var output = {}; (function() {(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.3/optimize for better performance and smaller assets.');


var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}



// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{tail: tail, nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\u000A    ',
		A2($elm$core$String$split, '\u000A', str));
};
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\u000A\u000A(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\u0027' + (f + '\u0027]'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\u000A\u000A',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\u000A\u000A';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\u000A\u000A    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\u000A\u000A' + msg));
			}
		}
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $author$project$PinMeTo$Ports$pinMeToLoggerLog = _Platform_outgoingPort(
	'pinMeToLoggerLog',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'context',
					$elm$json$Json$Encode$string($.context)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message)),
					_Utils_Tuple2(
					'metaData',
					$elm$core$Basics$identity($.metaData))
				]));
	});
var $author$project$PinMeTo$Logger$log = function (_v0) {
	var data = _v0.data;
	var message = _v0.message;
	var context = _v0.context;
	return $author$project$PinMeTo$Ports$pinMeToLoggerLog(
		{
			context: context,
			message: message,
			metaData: $elm$json$Json$Encode$string(data)
		});
};
var $elm$time$Time$Name = function (a) {
	return {$: 'Name', a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 'Offset', a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$RemoteData$Loading = {$: 'Loading'};
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$UpdateTime = function (a) {
	return {$: 'UpdateTime', a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$Flags = F3(
	function (siteName, isAdmin, translations) {
		return {isAdmin: isAdmin, siteName: siteName, translations: translations};
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $ChristophP$elm_i18next$I18Next$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(_Utils_Tuple0));
};
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $ChristophP$elm_i18next$I18Next$Branch = function (a) {
	return {$: 'Branch', a: a};
};
function $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $ChristophP$elm_i18next$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$ChristophP$elm_i18next$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder()));
				})
			]));
}
try {
	var $ChristophP$elm_i18next$I18Next$treeDecoder = $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder();
	$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder = function () {
		return $ChristophP$elm_i18next$I18Next$treeDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `I18Next` are causing infinite recursion:\n\n  ┌─────┐\n  │    treeDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $ChristophP$elm_i18next$I18Next$Translations = function (a) {
	return {$: 'Translations', a: a};
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $ChristophP$elm_i18next$I18Next$flattenTranslationsHelp = F3(
	function (initialValue, namespace, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 'Leaf') {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$ChristophP$elm_i18next$I18Next$flattenTranslationsHelp,
							acc,
							newNamespace(key),
							children);
					}
				}),
			initialValue,
			dict);
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslations = A2($ChristophP$elm_i18next$I18Next$flattenTranslationsHelp, $elm$core$Dict$empty, '');
var $ChristophP$elm_i18next$I18Next$translationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $ChristophP$elm_i18next$I18Next$flattenTranslations, $ChristophP$elm_i18next$I18Next$Translations),
	$elm$json$Json$Decode$dict($ChristophP$elm_i18next$I18Next$treeDecoder));
var $author$project$Common$Language$translationsDecoder = $ChristophP$elm_i18next$I18Next$translationsDecoder;
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['user', 'isAdmin']),
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['user', 'selectedSite', 'name']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Network$Conflicts$Trustpilot$Upload$Main$Flags))));
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Network$Conflicts$Trustpilot$Upload$Main$flagsDecoder, flags);
};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$FailedToDecodeFlags = {$: 'FailedToDecodeFlags'};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$init = function (flags) {
	var _v0 = $author$project$Network$Conflicts$Trustpilot$Upload$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var flags_ = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					isAdmin: flags_.isAdmin,
					siteName: flags_.siteName,
					timestamp: $elm$time$Time$millisToPosix(0),
					changeStats: $author$project$RemoteData$Loading,
					translations: flags_.translations,
					showAvailableInfo: false
				}),
			A2($elm$core$Task$perform, $author$project$Network$Conflicts$Trustpilot$Upload$Main$UpdateTime, $elm$time$Time$now));
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err($author$project$Network$Conflicts$Trustpilot$Upload$Main$FailedToDecodeFlags),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Network.Conflicts.Trustpilot.Upload.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$PinMeTo$Ui$TitleBar$iconView = function (config) {
	var className = config.hasLightBackground ? 'pmt-title-bar-light' : 'pmt-title-bar';
	var _v0 = config.iconHtml;
	if (_v0.$ === 'Just') {
		var iconHtml_ = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className + '__icon')
				]),
			_List_fromArray(
				[iconHtml_]));
	} else {
		var _v1 = config.faIconClass;
		if (_v1.$ === 'Just') {
			var faIconClass_ = _v1.a;
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(className + '__icon'),
						$elm$html$Html$Attributes$class(faIconClass_)
					]),
				_List_Nil);
		} else {
			return $elm$html$Html$text('');
		}
	}
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$PinMeTo$Ui$TitleBar$titleView = function (config) {
	var className = config.hasLightBackground ? 'pmt-title-bar-light' : 'pmt-title-bar';
	var _v0 = _Utils_Tuple2(config.titleHtml, config.label);
	if (_v0.a.$ === 'Just') {
		var titleHtml = _v0.a.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className + '__title'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'normal')
				]),
			_List_fromArray(
				[titleHtml]));
	} else {
		if (_v0.b.$ === 'Just') {
			var _v1 = _v0.a;
			var label = _v0.b.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class((className + '__title') + (className + '__title--with-label'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(className + '__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])),
						$elm$html$Html$text(' - '),
						$elm$html$Html$text(config.title)
					]));
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(className + '__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.title)
					]));
		}
	}
};
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $author$project$PinMeTo$Ui$TitleBar$asidesView = F2(
	function (config, className) {
		var forLightboxClass = config.forLightbox ? ' pmt-title-bar--close-margin' : '';
		return ($elm$core$List$length(config.asides) > 0) ? A2(
			$elm$html$Html$aside,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className + ('__asides' + forLightboxClass))
				]),
			config.asides) : $elm$html$Html$text('');
	});
var $author$project$PinMeTo$Ui$TitleBar$render = function (config) {
	var lighboxClass = (config.forLightbox && config.hasLightBackground) ? ' pmt-title-bar-light--lightbox' : (config.forLightbox ? ' pmt-title-bar--lightbox' : '');
	var className = config.hasLightBackground ? 'pmt-title-bar-light' : 'pmt-title-bar';
	return A3(
		$elm$html$Html$node,
		'pmt-title-bar',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						_Utils_ap(className, lighboxClass))
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$TitleBar$iconView(config),
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(className + '__heading')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$TitleBar$titleView(config)
							])),
						A2($author$project$PinMeTo$Ui$TitleBar$asidesView, config, className)
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$RemoveResponseBanner = {$: 'RemoveResponseBanner'};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$failBanner = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('status-bar__message')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('status-bar__dismiss'),
						$elm$html$Html$Events$onClick($author$project$Network$Conflicts$Trustpilot$Upload$Main$RemoveResponseBanner)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]))
			]));
};
var $author$project$PinMeTo$Ui$TitleBar$initConfig = {label: $elm$core$Maybe$Nothing, title: '', asides: _List_Nil, iconHtml: $elm$core$Maybe$Nothing, titleHtml: $elm$core$Maybe$Nothing, faIconClass: $elm$core$Maybe$Nothing, forLightbox: false, hasLightBackground: false};
var $author$project$PinMeTo$Ui$TitleBar$pmtTitleBar = function (title) {
	return _Utils_update(
		$author$project$PinMeTo$Ui$TitleBar$initConfig,
		{title: title});
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $ChristophP$elm_i18next$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$Translations$Listings$Tasks$here = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.here');
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $author$project$Translations$Listings$Tasks$changesAvailable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.changes_available');
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$PinMeTo$Ui$Spinner$spinner_ = function (withDelay) {
	return A3(
		$elm$html$Html$node,
		'pmt-spinner',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-spinner'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pmt-spinner--delayed', withDelay)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$svg,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$width('100px'),
								$elm$svg$Svg$Attributes$height('100px'),
								$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
								$elm$svg$Svg$Attributes$class('pmt-spinner__icon')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$use,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$xlinkHref('#pmt-icon__spinner')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay = $author$project$PinMeTo$Ui$Spinner$spinner_(true);
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$ShowAvailableInfo = {$: 'ShowAvailableInfo'};
var $author$project$Translations$Listings$Tasks$toUpdateOnTrustpilot = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.to_update_on_trustpilot');
};
var $ChristophP$elm_i18next$I18Next$Curly = {$: 'Curly'};
var $ChristophP$elm_i18next$I18Next$Text = function (a) {
	return {$: 'Text', a: a};
};
var $ChristophP$elm_i18next$I18Next$Converted = function (a) {
	return {$: 'Converted', a: a};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $ChristophP$elm_i18next$I18Next$Placeholder = function (a) {
	return {$: 'Placeholder', a: a};
};
var $ChristophP$elm_i18next$I18Next$Unconverted = function (a) {
	return {$: 'Unconverted', a: a};
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $ChristophP$elm_i18next$I18Next$delimsToTuple = function (delims) {
	switch (delims.$) {
		case 'Curly':
			return _Utils_Tuple2('{{', '}}');
		case 'Underscore':
			return _Utils_Tuple2('__', '__');
		default:
			var tuple = delims.a;
			return tuple;
	}
};
var $ChristophP$elm_i18next$I18Next$customReplace = F5(
	function (getTranslations, delims, lift, translationKey, replacements) {
		var _v0 = getTranslations(translationKey);
		if (_v0.$ === 'Just') {
			var rawString = _v0.a;
			var placeholderReplacers = A2(
				$elm$core$List$map,
				F2(
					function (_v5, translationElement) {
						var key = _v5.a;
						var value = _v5.b;
						return _Utils_eq(
							$ChristophP$elm_i18next$I18Next$Unconverted(
								$ChristophP$elm_i18next$I18Next$Placeholder(key)),
							translationElement) ? $ChristophP$elm_i18next$I18Next$Converted(value) : translationElement;
					}),
				replacements);
			var _v1 = $ChristophP$elm_i18next$I18Next$delimsToTuple(delims);
			var start = _v1.a;
			var end = _v1.b;
			var parseSinglePlaceholderKey = F2(
				function (key, translationElement) {
					if (translationElement.$ === 'Text') {
						var rawText = translationElement.a;
						return A2(
							$elm$core$List$intersperse,
							$ChristophP$elm_i18next$I18Next$Placeholder(key),
							A2(
								$elm$core$List$map,
								$ChristophP$elm_i18next$I18Next$Text,
								A2(
									$elm$core$String$split,
									_Utils_ap(
										start,
										_Utils_ap(key, end)),
									rawText)));
					} else {
						var name = translationElement.a;
						return _List_fromArray(
							[
								$ChristophP$elm_i18next$I18Next$Placeholder(name)
							]);
					}
				});
			var parsedTranslation = A3(
				$elm$core$List$foldl,
				F2(
					function (_v3, acc) {
						var key = _v3.a;
						return A2(
							$elm$core$List$concatMap,
							parseSinglePlaceholderKey(key),
							acc);
					}),
				_List_fromArray(
					[
						$ChristophP$elm_i18next$I18Next$Text(rawString)
					]),
				replacements);
			return A2(
				$elm$core$List$map,
				function (value) {
					if (value.$ === 'Converted') {
						var converted = value.a;
						return converted;
					} else {
						if (value.a.$ === 'Text') {
							var text = value.a.a;
							return lift(text);
						} else {
							var name = value.a.a;
							return lift(name);
						}
					}
				},
				function (list) {
					return A3($elm$core$List$foldr, $elm$core$List$map, list, placeholderReplacers);
				}(
					A2($elm$core$List$map, $ChristophP$elm_i18next$I18Next$Unconverted, parsedTranslation)));
		} else {
			return _List_fromArray(
				[
					lift(translationKey)
				]);
		}
	});
var $ChristophP$elm_i18next$I18Next$customTr = function (_v0) {
	var translations = _v0.a;
	return $ChristophP$elm_i18next$I18Next$customReplace(
		function (translationKey) {
			return A2($elm$core$Dict$get, translationKey, translations);
		});
};
var $author$project$Translations$Listings$Tasks$youHaveChangesCustom = F4(
	function (translations, nonPlaceholderLift, changeCount, locationCount) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'listings.tasks.you_have_changes',
			_List_fromArray(
				[
					_Utils_Tuple2('- changeCount', changeCount),
					_Utils_Tuple2('- locationCount', locationCount)
				]));
	});
var $author$project$Translations$Listings$Tasks$trustpilotInstructions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.trustpilot_instructions');
};
var $author$project$Translations$Listings$Tasks$uploadLocationsTrustpilot = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.upload_locations_trustpilot');
};
var $author$project$Translations$Listings$Tasks$uploadFileToTrustpilotCustom = F4(
	function (translations, nonPlaceholderLift, trustpilotUploadLink, trustpilotInstructionsLink) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'listings.tasks.upload_file_to_trustpilot',
			_List_fromArray(
				[
					_Utils_Tuple2('- trustpilotUploadLink', trustpilotUploadLink),
					_Utils_Tuple2('- trustpilotInstructionsLink', trustpilotInstructionsLink)
				]));
	});
var $author$project$Translations$Listings$Tasks$downloadApprovedChangesCustom = F3(
	function (translations, nonPlaceholderLift, approvedChangesLink) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'listings.tasks.download_approved_changes',
			_List_fromArray(
				[
					_Utils_Tuple2('- approvedChangesLink', approvedChangesLink)
				]));
	});
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$renderContent = function (model) {
	var timestamp = $elm$core$String$fromInt(
		$elm$time$Time$posixToMillis(model.timestamp));
	var url = 'api/' + (model.siteName + ('/trustpilot/conflict/solved/' + (timestamp + '/csv')));
	var _v0 = model.changeStats;
	switch (_v0.$) {
		case 'Suspended':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Error':
			return $elm$html$Html$text('');
		default:
			var stats = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-task__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Tasks$uploadLocationsTrustpilot(model.translations))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								A4(
									$author$project$Translations$Listings$Tasks$youHaveChangesCustom,
									model.translations,
									$elm$html$Html$text,
									A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(stats.uniqueChangesCount))
											])),
									A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(stats.locationsChangedCount))
											])))),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Tasks$toUpdateOnTrustpilot(model.translations))
									])),
								A2(
								$elm$html$Html$ol,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										A3(
											$author$project$Translations$Listings$Tasks$downloadApprovedChangesCustom,
											model.translations,
											$elm$html$Html$text,
											A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(url),
														$elm$html$Html$Events$onClick($author$project$Network$Conflicts$Trustpilot$Upload$Main$ShowAvailableInfo),
														$elm$html$Html$Attributes$target('blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$Tasks$here(model.translations))
													])))),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										A4(
											$author$project$Translations$Listings$Tasks$uploadFileToTrustpilotCustom,
											model.translations,
											$elm$html$Html$text,
											A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('https://businessapp.b2b.trustpilot.com/#/locations/summary'),
														$elm$html$Html$Attributes$target('blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$Tasks$here(model.translations))
													])),
											A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('https://support.trustpilot.com/hc/en-us/articles/360020581934-Set-up-Location-Reviews#add-multiple-locations-0'),
														$elm$html$Html$Attributes$target('blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$Tasks$trustpilotInstructions(model.translations))
													]))))
									])),
								model.showAvailableInfo ? A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('note')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' ' + $author$project$Translations$Listings$Tasks$changesAvailable(model.translations))
									])) : $elm$html$Html$text('')
							]))
					]));
	}
};
var $author$project$Translations$Listings$Tasks$uploadTrustpilotChanges = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.upload_trustpilot_changes');
};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$view = function (state) {
	if (state.$ === 'Ok') {
		var model = state.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$TitleBar$render(
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
								$author$project$Translations$Listings$Tasks$uploadTrustpilotChanges(model.translations))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list list--divided')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list__item')
										]),
									_List_fromArray(
										[
											function () {
											var _v1 = model.changeStats;
											if (_v1.$ === 'Error') {
												var e = _v1.a;
												return $author$project$Network$Conflicts$Trustpilot$Upload$Main$failBanner(e);
											} else {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-task')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-task__indicator')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$i,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('pmt-task__icon fa fa-plus')
																		]),
																	_List_Nil)
																])),
															$author$project$Network$Conflicts$Trustpilot$Upload$Main$renderContent(model)
														]));
											}
										}()
										]))
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$RemoteData$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$RemoteData$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$RemoteData$Suspended = {$: 'Suspended'};
var $author$project$PinMeTo$Logger$logHttpError = function (_v0) {
	var data = _v0.data;
	var message = _v0.message;
	var context = _v0.context;
	var metaData = function () {
		switch (data.$) {
			case 'BadUrl':
				var url = data.a;
				return 'BadUrl: ' + url;
			case 'Timeout':
				return 'Timeout';
			case 'NetworkError':
				return 'NetworkError';
			case 'BadStatus':
				var code = data.a;
				return 'BadStatus: ' + $elm$core$String$fromInt(code);
			default:
				var body = data.a;
				return 'BadBody: ' + body;
		}
	}();
	return $author$project$PinMeTo$Ports$pinMeToLoggerLog(
		{
			context: context,
			message: message,
			metaData: $elm$json$Json$Encode$string(metaData)
		});
};
var $elm$core$Maybe$isJust = function (maybe) {
	if (maybe.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 'BadUrl_', a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 'Sending', a: a};
};
var $elm$http$Http$Timeout_ = {$: 'Timeout_'};
var $elm$http$Http$Receiving = function (a) {
	return {$: 'Receiving', a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 'BadStatus_', a: a, b: b};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 'GoodStatus_', a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $elm$http$Http$Timeout = {$: 'Timeout'};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $elm$http$Http$NetworkError = {$: 'NetworkError'};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl = F2(
	function (method, url) {
		return {
			url: url,
			body: $elm$http$Http$emptyBody,
			expect: $elm$http$Http$expectString(
				function (_v0) {
					return _Utils_Tuple0;
				}),
			method: method,
			headers: _List_Nil,
			timeout: $elm$core$Maybe$Nothing,
			withCredentials: false
		};
	});
var $lukewestby$elm_http_builder$HttpBuilder$get = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('GET');
var $elm$http$Http$Request = function (a) {
	return {$: 'Request', a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {reqs: reqs, subs: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (cmd.$ === 'Cancel') {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 'Nothing') {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tracker;
							if (_v4.$ === 'Nothing') {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.subs)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 'Cancel', a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (cmd.$ === 'Cancel') {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					url: r.url,
					body: r.body,
					expect: A2(_Http_mapExpect, func, r.expect),
					method: r.method,
					headers: r.headers,
					timeout: r.timeout,
					tracker: r.tracker,
					allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 'MySub', a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{url: r.url, body: r.body, expect: r.expect, method: r.method, headers: r.headers, timeout: r.timeout, tracker: r.tracker, allowCookiesFromOtherDomains: false}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{url: r.url, body: r.body, expect: r.expect, method: r.method, headers: r.headers, timeout: r.timeout, tracker: r.tracker, allowCookiesFromOtherDomains: true}));
};
var $lukewestby$elm_http_builder$HttpBuilder$request = function (builder) {
	var req = builder.withCredentials ? $elm$http$Http$riskyRequest : $elm$http$Http$request;
	return req(
		{url: builder.url, body: builder.body, expect: builder.expect, method: builder.method, headers: builder.headers, timeout: builder.timeout, tracker: $elm$core$Maybe$Nothing});
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $lukewestby$elm_http_builder$HttpBuilder$withExpect = F2(
	function (expect, builder) {
		return {url: builder.url, body: builder.body, expect: expect, method: builder.method, headers: builder.headers, timeout: builder.timeout, withCredentials: builder.withCredentials};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$ChangeStats = F3(
	function (locationsChangedCount, uniqueChangesCount, totalChangesCount) {
		return {totalChangesCount: totalChangesCount, uniqueChangesCount: uniqueChangesCount, locationsChangedCount: locationsChangedCount};
	});
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$decodeStats = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalChangesCount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uniqueChangesCount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locationsChangedCount',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Network$Conflicts$Trustpilot$Upload$Main$ChangeStats))));
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$GetChangeStatsResponse = function (a) {
	return {$: 'GetChangeStatsResponse', a: a};
};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$getChangeStats = F2(
	function (site, timestamp) {
		var ts = $elm$core$String$fromInt(
			$elm$time$Time$posixToMillis(timestamp));
		var url = '/listings/api/' + (site + ('/trustpilot/conflict/solved/' + (ts + '/count')));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, $author$project$Network$Conflicts$Trustpilot$Upload$Main$GetChangeStatsResponse, $author$project$Network$Conflicts$Trustpilot$Upload$Main$decodeStats),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$PinMeTo$Common$Util$httpErrorToString = function (err) {
	switch (err.$) {
		case 'BadUrl':
			var s = err.a;
			return s;
		case 'Timeout':
			return 'Request timed out';
		case 'NetworkError':
			return 'Request failed';
		case 'BadStatus':
			var statusCode = err.a;
			return 'Request failed, server return status code ' + $elm$core$String$fromInt(statusCode);
		default:
			var body = err.a;
			return 'Bad body: ' + body;
	}
};
var $author$project$Util$httpErrorToString = $author$project$PinMeTo$Common$Util$httpErrorToString;
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$update = F2(
	function (msg, state) {
		if (state.$ === 'Ok') {
			var model = state.a;
			switch (msg.$) {
				case 'UpdateTime':
					var time = msg.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{timestamp: time})),
						A2($author$project$Network$Conflicts$Trustpilot$Upload$Main$getChangeStats, model.siteName, time));
				case 'ShowAvailableInfo':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{showAvailableInfo: true})),
						$elm$core$Platform$Cmd$none);
				case 'GetChangeStatsResponse':
					if (msg.a.$ === 'Ok') {
						var res = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										changeStats: $author$project$RemoteData$Loaded(res)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										changeStats: $author$project$RemoteData$Error(
											$author$project$Util$httpErrorToString(err))
									})),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Network.Conflicts.Trustpilot.Upload.Main', message: 'GetChangeStatsResponse failed'}));
					}
				case 'RemoveResponseBanner':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{changeStats: $author$project$RemoteData$Suspended})),
						$elm$core$Platform$Cmd$none);
				default:
					var flagsValue = msg.a;
					return $author$project$Network$Conflicts$Trustpilot$Upload$Main$init(flagsValue);
			}
		} else {
			return _Utils_Tuple2(
				$elm$core$Result$Err($author$project$Network$Conflicts$Trustpilot$Upload$Main$FailedToDecodeFlags),
				$author$project$PinMeTo$Logger$log(
					{data: 'Failed to decode flags', context: 'Network.Conflicts.Trustpilot.Upload.Main', message: 'Failed to decode flags'}));
		}
	});
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$core$String$slice = _String_slice;
var $elm$core$String$length = _String_length;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {host: host, path: path, port_: port_, query: query, fragment: fragment, protocol: protocol};
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$core$String$contains = _String_contains;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$browser$Browser$element = _Browser_element;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$passArgs_Network_Conflicts_Trustpilot_Upload_Main = _Platform_incomingPort('passArgs_Network_Conflicts_Trustpilot_Upload_Main', $elm$json$Json$Decode$value);
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Network$Conflicts$Trustpilot$Upload$Main$passArgs_Network_Conflicts_Trustpilot_Upload_Main($author$project$Network$Conflicts$Trustpilot$Upload$Main$HandleFlags)
			]));
};
var $author$project$Network$Conflicts$Trustpilot$Upload$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Network$Conflicts$Trustpilot$Upload$Main$init, view: $author$project$Network$Conflicts$Trustpilot$Upload$Main$view, update: $author$project$Network$Conflicts$Trustpilot$Upload$Main$update, subscriptions: $author$project$Network$Conflicts$Trustpilot$Upload$Main$subscriptions});
var $author$project$Location$DisplayLocationInfoTitleBar$Flags = F4(
	function (storeId, status, description, address) {
		return {status: status, address: address, storeId: storeId, description: description};
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Data$Address$Address = F6(
	function (street, zip, city, country, countryAlpha2Code, stateOrProvince) {
		return {zip: zip, city: city, street: street, country: country, stateOrProvince: stateOrProvince, countryAlpha2Code: countryAlpha2Code};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve = $elm$json$Json$Decode$andThen($elm$core$Basics$identity);
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (_v0.$ === 'Ok') {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (_v1.$ === 'Ok') {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Data$Address$WithState = function (a) {
	return {$: 'WithState', a: a};
};
var $author$project$Data$Address$WithProvince = function (a) {
	return {$: 'WithProvince', a: a};
};
var $author$project$Data$Address$addressDecoder = function () {
	var toDecoder = F8(
		function (street, zip, city, country, countryAlpha2Code, maybeState, maybeProvince, district) {
			var _v0 = _Utils_Tuple2(maybeState, maybeProvince);
			if (_v0.a.$ === 'Nothing') {
				if (_v0.b.$ === 'Just') {
					var _v2 = _v0.a;
					var province = _v0.b.a;
					return $elm$json$Json$Decode$succeed(
						A6(
							$author$project$Data$Address$Address,
							street,
							zip,
							city,
							country,
							countryAlpha2Code,
							$author$project$Data$Address$WithProvince(
								{district: district, province: province})));
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return $elm$json$Json$Decode$succeed(
						A6(
							$author$project$Data$Address$Address,
							street,
							zip,
							city,
							country,
							countryAlpha2Code,
							$author$project$Data$Address$WithState('')));
				}
			} else {
				if (_v0.b.$ === 'Nothing') {
					var state = _v0.a.a;
					var _v1 = _v0.b;
					return $elm$json$Json$Decode$succeed(
						A6(
							$author$project$Data$Address$Address,
							street,
							zip,
							city,
							country,
							countryAlpha2Code,
							$author$project$Data$Address$WithState(state)));
				} else {
					var state = _v0.a.a;
					var province = _v0.b.a;
					return ((state !== '') || (province === '')) ? $elm$json$Json$Decode$succeed(
						A6(
							$author$project$Data$Address$Address,
							street,
							zip,
							city,
							country,
							countryAlpha2Code,
							$author$project$Data$Address$WithState(state))) : $elm$json$Json$Decode$succeed(
						A6(
							$author$project$Data$Address$Address,
							street,
							zip,
							city,
							country,
							countryAlpha2Code,
							$author$project$Data$Address$WithProvince(
								{district: district, province: province})));
				}
			}
		});
	return $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'district',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'province',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'state',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'countryAlpha2Code',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'country',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'city',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'zip',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'street',
										$elm$json$Json$Decode$string,
										'',
										$elm$json$Json$Decode$succeed(toDecoder))))))))));
}();
var $author$project$Location$DisplayLocationInfoTitleBar$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'address',
	$author$project$Data$Address$addressDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'storeId',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Location$DisplayLocationInfoTitleBar$Flags)))));
var $author$project$Location$DisplayLocationInfoTitleBar$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Location$DisplayLocationInfoTitleBar$flagsDecoder, flagsValue);
};
var $author$project$Location$DisplayLocationInfoTitleBar$FailedToDecodeFlags = {$: 'FailedToDecodeFlags'};
var $author$project$Location$DisplayLocationInfoTitleBar$init = function (flagsValue) {
	var _v0 = $author$project$Location$DisplayLocationInfoTitleBar$decodeFlags(flagsValue);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{status: decoded.status, address: decoded.address, storeId: decoded.storeId, description: decoded.description}),
			$elm$core$Platform$Cmd$none);
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err($author$project$Location$DisplayLocationInfoTitleBar$FailedToDecodeFlags),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Location.DisplayLocationInfoTitleBar',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Location$DisplayLocationInfoTitleBar$view = function (state) {
	if (state.$ === 'Ok') {
		var model = state.a;
		var title = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-location-new-title-bar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.storeId)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.status)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.description)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.address.city)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.address.street)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.address.countryAlpha2Code)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-verify-location__header')
				]),
			_List_fromArray(
				[title]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-verify-location__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-location-new-title-bar')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('An error occurred')
						]))
				]));
	}
};
var $author$project$Location$DisplayLocationInfoTitleBar$update = F2(
	function (msg, _v0) {
		var flagsValue = msg.a;
		return $author$project$Location$DisplayLocationInfoTitleBar$init(flagsValue);
	});
var $author$project$Location$DisplayLocationInfoTitleBar$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Location$DisplayLocationInfoTitleBar$passArgs_Location_DisplayLocationInfoTitleBar = _Platform_incomingPort('passArgs_Location_DisplayLocationInfoTitleBar', $elm$json$Json$Decode$value);
var $author$project$Location$DisplayLocationInfoTitleBar$subscriptions = function (_v0) {
	return $author$project$Location$DisplayLocationInfoTitleBar$passArgs_Location_DisplayLocationInfoTitleBar($author$project$Location$DisplayLocationInfoTitleBar$HandleFlags);
};
var $author$project$Location$DisplayLocationInfoTitleBar$main = $elm$browser$Browser$element(
	{init: $author$project$Location$DisplayLocationInfoTitleBar$init, view: $author$project$Location$DisplayLocationInfoTitleBar$view, update: $author$project$Location$DisplayLocationInfoTitleBar$update, subscriptions: $author$project$Location$DisplayLocationInfoTitleBar$subscriptions});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$Flags = F2(
	function (listingsUrl, siteName) {
		return {siteName: siteName, listingsUrl: listingsUrl};
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['siteName']),
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['pmtEnv', 'urls', 'listings']),
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Tasks$Facebook$ReviewAndCreate$Model$Flags)));
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Facebook$ReviewAndCreate$Model$flagsDecoder, flags);
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$PinMeTo$Ui$Selector$All = {$: 'All'};
var $author$project$PinMeTo$Ui$Table$State = function (a) {
	return {$: 'State', a: a};
};
var $elm$core$Set$Set_elm_builtin = function (a) {
	return {$: 'Set_elm_builtin', a: a};
};
var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$PinMeTo$Ui$Table$initAll = F4(
	function (selected, deselected, limit, sort) {
		return $author$project$PinMeTo$Ui$Table$State(
			{
				sort: sort,
				limit: limit,
				selected: $elm$core$Set$fromList(selected),
				shiftHeld: false,
				deselected: $elm$core$Set$fromList(deselected),
				lastSelectedIndex: $elm$core$Maybe$Nothing
			});
	});
var $author$project$PinMeTo$Ui$Table$init = A4($author$project$PinMeTo$Ui$Table$initAll, _List_Nil, _List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$PinMeTo$Ui$Selector$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$Selector$Loading = {$: 'Loading'};
var $author$project$PinMeTo$Ui$Selector$ReceivedItems = function (a) {
	return {$: 'ReceivedItems', a: a};
};
var $author$project$PinMeTo$Ui$Selector$initWithSelected = F2(
	function (selected, getItems) {
		return _Utils_Tuple2(
			$author$project$PinMeTo$Ui$Selector$State(
				{
					items: $author$project$PinMeTo$Ui$Selector$Loading,
					uiTable: $author$project$PinMeTo$Ui$Table$init,
					selected: $elm$core$Set$fromList(selected),
					currentTab: $author$project$PinMeTo$Ui$Selector$All,
					deselected: $elm$core$Set$empty,
					searchQuery: ''
				}),
			getItems($author$project$PinMeTo$Ui$Selector$ReceivedItems));
	});
var $author$project$PinMeTo$Ui$Selector$init = $author$project$PinMeTo$Ui$Selector$initWithSelected(_List_Nil);
var $author$project$Data$SiteName$SiteName = function (a) {
	return {$: 'SiteName', a: a};
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$initialModel = {
	siteName: $author$project$Data$SiteName$SiteName(''),
	uiSelector: $elm$core$Maybe$Nothing,
	idsWithError: $elm$core$Dict$empty,
	resultBanner: $author$project$RemoteData$Loading
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$UiSelectorMsg = function (a) {
	return {$: 'UiSelectorMsg', a: a};
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$PinMeTo$Ui$Selector$ApiData = F2(
	function (data, unselectables) {
		return {data: data, unselectables: unselectables};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 'Empty':
					return list;
				case 'AddRight':
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0.a;
		var _v1 = parse(
			{col: 1, row: 1, src: src, indent: 1, offset: 0, context: _List_Nil});
		if (_v1.$ === 'Good') {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {col: col, row: row, problem: problem};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.row, p.col, p.problem);
};
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (_v0.$ === 'Ok') {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 'Bad', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 'Good', a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$parser$Parser$Advanced$Empty = {$: 'Empty'};
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {col: col, row: row, problem: problem, contextStack: contextStack};
	});
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 'AddRight', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.row, s.col, x, s.context));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return _Utils_eq(
				$elm$core$String$length(s.src),
				s.offset) ? A3($elm$parser$Parser$Advanced$Good, false, _Utils_Tuple0, s) : A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$ExpectingEnd = {$: 'ExpectingEnd'};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 'Append', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
		});
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0.a;
		var parseB = _v1.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v2 = parseA(s0);
				if (_v2.$ === 'Bad') {
					var p = _v2.a;
					var x = _v2.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v2.a;
					var a = _v2.b;
					var s1 = _v2.c;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3(
							$elm$parser$Parser$Advanced$Good,
							p1 || p2,
							A2(func, a, b),
							s2);
					}
				}
			});
	});
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 'Token', a: a, b: b};
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
			var newOffset = _v1.a;
			var newRow = _v1.b;
			var newCol = _v1.c;
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
				$elm$parser$Parser$Advanced$Good,
				progress,
				_Utils_Tuple0,
				{col: newCol, row: newRow, src: s.src, indent: s.indent, offset: newOffset, context: s.context});
		});
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 'ExpectingSymbol', a: a};
};
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parseA(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p1 = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					var _v2 = callback(a);
					var parseB = _v2.a;
					var _v3 = parseB(s1);
					if (_v3.$ === 'Bad') {
						var p2 = _v3.a;
						var x = _v3.b;
						return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
					} else {
						var p2 = _v3.a;
						var b = _v3.b;
						var s2 = _v3.c;
						return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
					}
				}
			});
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, false, a, s);
		});
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Good') {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						func(a),
						s1);
				} else {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				}
			});
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0.a;
			var _v1 = parse(s0);
			if (_v1.$ === 'Good') {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (step.$ === 'Loop') {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
			});
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 'Done', a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 'Loop', a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (step.$ === 'Loop') {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return $elm$parser$Parser$Advanced$Parser(
			function (s) {
				var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
				return _Utils_eq(newOffset, -1) ? A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: 1, row: s.row + 1, src: s.src, indent: s.indent, offset: s.offset + 1, context: s.context}) : A3(
					$elm$parser$Parser$Advanced$Good,
					true,
					_Utils_Tuple0,
					{col: s.col + 1, row: s.row, src: s.src, indent: s.indent, offset: newOffset, context: s.context}));
			});
	});
var $elm$parser$Parser$UnexpectedChar = {$: 'UnexpectedChar'};
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 'Problem', a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		});
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0.a;
		return $elm$parser$Parser$Advanced$Parser(
			function (s0) {
				var _v1 = parse(s0);
				if (_v1.$ === 'Bad') {
					var p = _v1.a;
					var x = _v1.b;
					return A2($elm$parser$Parser$Advanced$Bad, p, x);
				} else {
					var p = _v1.a;
					var a = _v1.b;
					var s1 = _v1.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p,
						A2(
							func,
							A3($elm$core$String$slice, s0.offset, s1.offset, s0.src),
							a),
						s1);
				}
			});
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (_v0.$ === 'Just') {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \u0022' + (str + '\u0022'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \u0022' + ($elm$core$String$fromInt(month) + '\u0022'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.offset, offset) < 0,
					_Utils_Tuple0,
					{col: col, row: row, src: s0.src, indent: s0.indent, offset: offset, context: s0.context});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.offset, s.row, s.col, s);
		});
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (_v0.$ === 'Just') {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \u0022' + (str + '\u0022'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 'Err') {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$LocationDetails$LocationContact = F3(
	function (email, phone, homepage) {
		return {email: email, phone: phone, homepage: homepage};
	});
var $author$project$Data$LocationDetails$contactDecoder = $elm$json$Json$Decode$maybe(
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'homepage',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'phone',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'email',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$Data$LocationDetails$LocationContact)))));
var $author$project$Data$LocationDetails$LocationDetails = function (id) {
	return function (name) {
		return function (locationType) {
			return function (storeId) {
				return function (address) {
					return function (permanentlyClosed) {
						return function (locationDescriptor) {
							return function (location) {
								return function (created) {
									return function (status) {
										return function (temporarilyClosedUntil) {
											return function (contact) {
												return function (fbStoreId) {
													return function (claimStatus) {
														return {id: id, name: name, status: status, address: address, contact: contact, created: created, storeId: storeId, location: location, fbStoreId: fbStoreId, claimStatus: claimStatus, locationType: locationType, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor, temporarilyClosedUntil: temporarilyClosedUntil};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Data$Coordinates$Coordinates = F2(
	function (lat, lon) {
		return {lat: lat, lon: lon};
	});
var $author$project$Data$Coordinates$coordinatesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lon',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lat',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Data$Coordinates$Coordinates)));
var $author$project$Data$Location$is = F2(
	function (a, b) {
		return _Utils_eq(a, b);
	});
var $elm_community$json_extra$Json$Decode$Extra$when = F3(
	function (checkDecoder, check, passDecoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (checkVal) {
				return check(checkVal) ? passDecoder : $elm$json$Json$Decode$fail('Check failed with input');
			},
			checkDecoder);
	});
var $author$project$Data$Location$Storefront = {$: 'Storefront'};
var $author$project$Data$Location$ServiceArea = {$: 'ServiceArea'};
var $author$project$Data$Location$StorefrontAndServiceArea = {$: 'StorefrontAndServiceArea'};
var $author$project$Data$Location$locationTypeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$elm$json$Json$Decode$string,
			$author$project$Data$Location$is('storefront'),
			$elm$json$Json$Decode$succeed($author$project$Data$Location$Storefront)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$elm$json$Json$Decode$string,
			$author$project$Data$Location$is('storefrontAndServiceArea'),
			$elm$json$Json$Decode$succeed($author$project$Data$Location$StorefrontAndServiceArea)),
			A3(
			$elm_community$json_extra$Json$Decode$Extra$when,
			$elm$json$Json$Decode$string,
			$author$project$Data$Location$is('serviceArea'),
			$elm$json$Json$Decode$succeed($author$project$Data$Location$ServiceArea))
		]));
var $elm$core$String$trim = _String_trim;
var $author$project$Data$LocationDetails$nonEmptyStringDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		var _v0 = $elm$core$String$trim(x);
		if (_v0 === '') {
			return $elm$json$Json$Decode$fail('Empty string');
		} else {
			var nonEmpty = _v0;
			return $elm$json$Json$Decode$succeed(nonEmpty);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$LocationDetails$locationDetailsDecoder = function () {
	var tempClosedDecoder = A2(
		$elm$json$Json$Decode$map,
		function (x) {
			return _Utils_eq(
				x,
				$elm$core$Maybe$Just('')) ? $elm$core$Maybe$Nothing : x;
		},
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'temporarilyClosedUntil', $elm$json$Json$Decode$string)));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (status) {
			return A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'claimStatus',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'fbStoreId',
					$elm$json$Json$Decode$maybe($author$project$Data$LocationDetails$nonEmptyStringDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'contact',
						$author$project$Data$LocationDetails$contactDecoder,
						$elm$core$Maybe$Just(
							{email: '', phone: '', homepage: ''}),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'temporarilyClosedUntil',
							$elm$json$Json$Decode$string,
							'',
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								status,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'created',
									$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
									$elm$time$Time$millisToPosix(0),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'location',
										$author$project$Data$Coordinates$coordinatesDecoder,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'locationDescriptor',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'permanentlyClosed',
												$elm$json$Json$Decode$bool,
												true,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'address',
													$author$project$Data$Address$addressDecoder,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'storeId',
														$elm$json$Json$Decode$string,
														'',
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'type',
															$author$project$Data$Location$locationTypeDecoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'_id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Data$LocationDetails$LocationDetails)))))))))))))));
		},
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (permanentlyClosed, temporarilyClosedUntil) {
					var _v0 = _Utils_Tuple2(permanentlyClosed, temporarilyClosedUntil);
					_v0$0:
					while (true) {
						if (_v0.b.$ === 'Nothing') {
							if ((_v0.a.$ === 'Just') && _v0.a.a) {
								break _v0$0;
							} else {
								var _v1 = _v0.b;
								return 'Open';
							}
						} else {
							if ((_v0.a.$ === 'Just') && _v0.a.a) {
								break _v0$0;
							} else {
								if (_v0.b.a === '') {
									return 'Open';
								} else {
									return 'Temporarily Closed';
								}
							}
						}
					}
					return 'Closed';
				}),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'permanentlyClosed', $elm$json$Json$Decode$bool)),
			tempClosedDecoder));
}();
var $author$project$Tasks$Facebook$ReviewAndCreate$Update$getLocationDetails = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var apiDataDecoder = A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'data',
				$elm$json$Json$Decode$list($author$project$Data$LocationDetails$locationDetailsDecoder),
				$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$Selector$ApiData)));
		var url = 'api/' + (siteName + '/facebook/claim/pendingconfirm');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, apiDataDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Update$handleFlags = function (decoded) {
	var _v0 = $author$project$PinMeTo$Ui$Selector$init(
		$author$project$Tasks$Facebook$ReviewAndCreate$Update$getLocationDetails(
			$author$project$Data$SiteName$SiteName(decoded.siteName)));
	var selectorState = _v0.a;
	var selectorCmd = _v0.b;
	var siteName = $author$project$Data$SiteName$SiteName(decoded.siteName);
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$Tasks$Facebook$ReviewAndCreate$Model$initialModel,
			{
				siteName: siteName,
				uiSelector: $elm$core$Maybe$Just(selectorState)
			}),
		A2($elm$core$Platform$Cmd$map, $author$project$Tasks$Facebook$ReviewAndCreate$Model$UiSelectorMsg, selectorCmd));
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Update$init = F2(
	function (onHandleFlags, flagsValue) {
		var _v0 = $author$project$Tasks$Facebook$ReviewAndCreate$Model$decodeFlags(flagsValue);
		if (_v0.$ === 'Ok') {
			var flags = _v0.a;
			return A2(
				$elm$core$Tuple$mapFirst,
				onHandleFlags,
				$author$project$Tasks$Facebook$ReviewAndCreate$Update$handleFlags(flags));
		} else {
			var e = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					$author$project$Tasks$Facebook$ReviewAndCreate$Model$initialModel,
					{
						resultBanner: $author$project$RemoteData$Error('Failed to decode flags')
					}),
				$author$project$PinMeTo$Logger$log(
					{
						data: $elm$json$Json$Decode$errorToString(e),
						context: 'Tasks.Facebook.ReviewAndCreate.Main.init',
						message: 'Failed to decode flags'
					}));
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$NoOp = {$: 'NoOp'};
var $author$project$PinMeTo$Ui$Lightbox$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Lightbox$Normal = {$: 'Normal'};
var $author$project$PinMeTo$Ui$Lightbox$view = function (_v0) {
	var content = _v0.content;
	var title = _v0.title;
	return $author$project$PinMeTo$Ui$Lightbox$View(
		{style: $author$project$PinMeTo$Ui$Lightbox$Normal, title: title, footer: $elm$core$Maybe$Nothing, header: $elm$core$Maybe$Nothing, content: content, onClose: $elm$core$Maybe$Nothing, minimize: $elm$core$Maybe$Nothing, className: $elm$core$Maybe$Nothing, fullHeight: false, withoutTitleBar: false, withLightLightbox: false});
};
var $author$project$PinMeTo$Ui$Selector$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Selector$view = function (config) {
	return $author$project$PinMeTo$Ui$Selector$View(
		{labels: config.labels, search: config.search, tagger: config.tagger, columns: _List_Nil, childRow: $elm$core$Maybe$Nothing, selected: _List_Nil, idToString: config.idToString, disabledItems: $elm$core$Maybe$Nothing});
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 'Nothing') {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$PinMeTo$Ui$TitleBar$withAsides = F2(
	function (asides, config) {
		return _Utils_update(
			config,
			{asides: asides});
	});
var $author$project$PinMeTo$Ui$TitleBar$forLightbox = function (config) {
	return _Utils_update(
		config,
		{forLightbox: true});
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$PinMeTo$Ui$Lightbox$onClickFinal = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$PinMeTo$Ui$TitleBar$withLightStyle = F2(
	function (lightStyle, config) {
		return _Utils_update(
			config,
			{hasLightBackground: lightStyle});
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute = $elm$html$Html$Attributes$attribute('data-test');
var $author$project$PinMeTo$Ui$Lightbox$render = function (_v0) {
	var config = _v0.a;
	var lightLightboxBg = config.withLightLightbox ? ' pmt-ui-lightbox__container--light-lightbox' : '';
	var titleBarAsides = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				function (onMinimize) {
					return A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-lightbox__minimize fa fa-dash'),
								$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-lightbox-minimize-button'),
								$author$project$PinMeTo$Ui$Lightbox$onClickFinal(onMinimize)
							]),
						_List_Nil);
				},
				config.minimize),
				A2(
				$elm$core$Maybe$map,
				function (onClose) {
					return A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-lightbox__close fa fa-xmark'),
								$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-lightbox-close-button'),
								$author$project$PinMeTo$Ui$Lightbox$onClickFinal(onClose)
							]),
						_List_Nil);
				},
				config.onClose)
			]));
	var withTitleBarAsides = $elm$core$List$isEmpty(titleBarAsides) ? $elm$core$Basics$identity : $author$project$PinMeTo$Ui$TitleBar$withAsides(titleBarAsides);
	var contentStyle = function () {
		var _v2 = config.style;
		switch (_v2.$) {
			case 'AlertStyle':
				return ' pmt-ui-lightbox__container--alert';
			case 'Medium':
				return ' pmt-ui-lightbox__container--medium';
			case 'Normal':
				return '';
			default:
				return ' pmt-ui-lightbox__container--wide';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-lightbox'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-ui-lightbox--full-height', config.fullHeight),
						_Utils_Tuple2(
						A2($elm$core$Maybe$withDefault, '', config.className),
						!_Utils_eq(config.className, $elm$core$Maybe$Nothing))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-lightbox__container' + (contentStyle + lightLightboxBg)),
						$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-lightbox-container')
					]),
				_List_fromArray(
					[
						config.withoutTitleBar ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-lightbox__close-container')
							]),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (onMinimize) {
										return A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-lightbox__minimize fa fa-dash'),
													$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-lightbox-minimize-button'),
													$author$project$PinMeTo$Ui$Lightbox$onClickFinal(onMinimize)
												]),
											_List_Nil);
									},
									config.minimize),
									A2(
									$elm$core$Maybe$map,
									function (onClose) {
										return A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-lightbox__close fa fa-xmark'),
													$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-lightbox-close-button'),
													$author$project$PinMeTo$Ui$Lightbox$onClickFinal(onClose)
												]),
											_List_Nil);
									},
									config.onClose)
								]))) : (config.withLightLightbox ? $author$project$PinMeTo$Ui$TitleBar$render(
						$author$project$PinMeTo$Ui$TitleBar$forLightbox(
							A2(
								$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
								true,
								withTitleBarAsides(
									$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(config.title))))) : $author$project$PinMeTo$Ui$TitleBar$render(
						withTitleBarAsides(
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(config.title)))),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (x) {
								return A2(
									$elm$html$Html$header,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-lightbox__header')
										]),
									_List_fromArray(
										[x]));
							},
							config.header)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-lightbox__content'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'pmt-ui-lightbox--rounded-bottom',
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											true,
											function (_v1) {
												return false;
											},
											config.footer))
									]))
							]),
						_List_fromArray(
							[config.content])),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (x) {
								return A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-lightbox__footer')
										]),
									_List_fromArray(
										[x]));
							},
							config.footer))
					])),
				A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-lightbox__overlay')
						]),
					_List_Nil),
				A2(
					$elm$core$Maybe$map,
					function (onClose) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-lightbox__overlay'),
									$author$project$PinMeTo$Ui$Lightbox$onClickFinal(onClose)
								]),
							_List_Nil);
					},
					config.onClose))
			]));
};
var $author$project$PinMeTo$Ui$StatusBar$Error = {$: 'Error'};
var $author$project$PinMeTo$Ui$StatusBar$Plain = function (a) {
	return {$: 'Plain', a: a};
};
var $author$project$PinMeTo$Ui$StatusBar$StatusBar = function (a) {
	return {$: 'StatusBar', a: a};
};
var $author$project$PinMeTo$Ui$StatusBar$DefaultPadding = {$: 'DefaultPadding'};
var $author$project$PinMeTo$Ui$StatusBar$error = function (message) {
	return $author$project$PinMeTo$Ui$StatusBar$StatusBar(
		{
			status: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$Error),
			content: $author$project$PinMeTo$Ui$StatusBar$Plain(message),
			padding: $author$project$PinMeTo$Ui$StatusBar$DefaultPadding
		});
};
var $author$project$PinMeTo$Ui$StatusBar$White = {$: 'White'};
var $author$project$PinMeTo$Ui$StatusBar$Notice = {$: 'Notice'};
var $author$project$PinMeTo$Ui$StatusBar$Success = {$: 'Success'};
var $author$project$PinMeTo$Ui$StatusBar$Warning = {$: 'Warning'};
var $author$project$PinMeTo$Ui$StatusBar$PaddingTop = {$: 'PaddingTop'};
var $author$project$PinMeTo$Ui$StatusBar$WithoutPadding = {$: 'WithoutPadding'};
var $author$project$PinMeTo$Ui$StatusBar$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-status-bar'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-ui-status-bar--notice',
						_Utils_eq(
							config.status,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$Notice))),
						_Utils_Tuple2(
						'pmt-ui-status-bar--success',
						_Utils_eq(
							config.status,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$Success))),
						_Utils_Tuple2(
						'pmt-ui-status-bar--warning',
						_Utils_eq(
							config.status,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$Warning))),
						_Utils_Tuple2(
						'pmt-ui-status-bar--error',
						_Utils_eq(
							config.status,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$Error))),
						_Utils_Tuple2(
						'pmt-ui-status-bar--white',
						_Utils_eq(
							config.status,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$White))),
						_Utils_Tuple2(
						'pmt-ui-status-bar__padding-top',
						_Utils_eq(config.padding, $author$project$PinMeTo$Ui$StatusBar$PaddingTop)),
						_Utils_Tuple2(
						'pmt-ui-status-bar__without-padding',
						_Utils_eq(config.padding, $author$project$PinMeTo$Ui$StatusBar$WithoutPadding)),
						_Utils_Tuple2(
						'pmt-ui-status-bar__default-padding',
						_Utils_eq(config.padding, $author$project$PinMeTo$Ui$StatusBar$DefaultPadding))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-status-bar__message')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = config.content;
						if (_v1.$ === 'Plain') {
							var message = _v1.a;
							return $elm$html$Html$text(message);
						} else {
							var html = _v1.a;
							return html;
						}
					}()
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$size(dict);
};
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$union, dict1, dict2));
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$filter = F2(
	function (isGood, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v1) {
						return isGood(key);
					}),
				dict));
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 'Nothing') {
		return false;
	} else {
		return true;
	}
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$PinMeTo$Ui$Form$Input$Search = {$: 'Search'};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$PinMeTo$Ui$Form$Input$hasError = function (errorMessage) {
	if (errorMessage.$ === 'Just') {
		if (errorMessage.a.$ === 'Error') {
			return true;
		} else {
			var _v1 = errorMessage.a;
			return false;
		}
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$FontAwesome$Solid$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faX = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-x');
var $author$project$FontAwesome$Solid$Icon$render = function (icon) {
	var classNames = function (_v0) {
		var val = _v0.a;
		return val;
	}(icon);
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(classNames)
			]),
		_List_Nil);
};
var $author$project$FontAwesome$Solid$faX = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faX);
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$FontAwesome$Solid$Icon$faCircleExclamation = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-circle-exclamation');
var $author$project$FontAwesome$Solid$faCircleExclamation = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircleExclamation);
var $author$project$PinMeTo$Ui$Form$Input$renderIcons = function (config) {
	var _v0 = config.value;
	var value = _v0.a;
	var clear = config.clearButtonEnabled && ((!config.disabled) && (!(!$elm$core$String$length(value))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-input__icons')
			]),
		_List_fromArray(
			[
				clear ? A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-input__icon pmt-ui-input__icon--clear'),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$tabindex(-1),
						$elm$html$Html$Events$onClick(
						config.onChange(''))
					]),
				_List_fromArray(
					[$author$project$FontAwesome$Solid$faX])) : $elm$html$Html$text(''),
				$author$project$PinMeTo$Ui$Form$Input$hasError(config.errorMessage) ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-input__icon pmt-ui-input__icon--error')
					]),
				_List_fromArray(
					[$author$project$FontAwesome$Solid$faCircleExclamation])) : $elm$html$Html$text('')
			]));
};
var $author$project$PinMeTo$Ui$Form$Input$addAttribute = F2(
	function (x, a) {
		return A2(
			$elm$core$Maybe$withDefault,
			a,
			A2(
				$elm$core$Maybe$map,
				function (attrib) {
					return A2($elm$core$List$cons, attrib, a);
				},
				x));
	});
var $author$project$PinMeTo$Ui$Form$Input$typeToAttribute = function (inputType) {
	switch (inputType.$) {
		case 'Text':
			return $elm$html$Html$Attributes$type_('text');
		case 'Email':
			return $elm$html$Html$Attributes$type_('email');
		case 'Search':
			return $elm$html$Html$Attributes$type_('search');
		case 'Password':
			return $elm$html$Html$Attributes$type_('password');
		default:
			return $elm$html$Html$Attributes$type_('number');
	}
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$PinMeTo$Ui$Form$Input$addSearchAttributes = function (a) {
	return _Utils_ap(
		a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$autofocus(true),
				$elm$html$Html$Attributes$autocomplete(false),
				A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off'),
				A2($elm$html$Html$Attributes$attribute, 'autocorrect', 'off'),
				A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'off'),
				A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false')
			]));
};
var $author$project$PinMeTo$Ui$DataTestAttribute$getAttributeString = function (_v0) {
	var testAttr = _v0.a;
	return testAttr;
};
var $author$project$PinMeTo$Ui$Form$Input$appendTestAttribute = F2(
	function (x, attributes) {
		return A2(
			$elm$core$List$cons,
			$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$getAttributeString, x))),
			attributes);
	});
var $author$project$PinMeTo$Ui$Form$Input$renderField = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-input__field'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-ui-input__field--disabled', config.disabled),
						_Utils_Tuple2(
						'pmt-ui-input__field--error',
						$author$project$PinMeTo$Ui$Form$Input$hasError(config.errorMessage)),
						_Utils_Tuple2('pmt-ui-input__field--error', config.inFocusError)
					])),
				$elm$html$Html$Attributes$tabindex(1)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				A2(
					$author$project$PinMeTo$Ui$Form$Input$addAttribute,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var id_ = _v4.a;
							return $elm$html$Html$Attributes$id(id_);
						},
						config.id),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$addAttribute,
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onBlur, config.onBlur),
						(_Utils_eq(config.type_, $author$project$PinMeTo$Ui$Form$Input$Search) ? $author$project$PinMeTo$Ui$Form$Input$addSearchAttributes : $elm$core$Basics$identity)(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$appendTestAttribute,
								config.dataTestAttribute,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Form$Input$typeToAttribute(config.type_),
											$elm$html$Html$Attributes$value(
											function (_v0) {
												var v = _v0.a;
												return v;
											}(config.value)),
											$elm$html$Html$Attributes$disabled(config.disabled),
											$elm$html$Html$Events$onInput(config.onChange),
											$elm$html$Html$Attributes$placeholder(
											A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												'',
												function (_v1) {
													var p = _v1.a;
													return p;
												},
												config.placeholder)),
											$elm$html$Html$Attributes$class('pmt-ui-input__input')
										]),
									function () {
										var _v2 = config.step;
										if (_v2.$ === 'Just') {
											switch (_v2.a.$) {
												case 'IntStep':
													var i = _v2.a.a;
													return _List_fromArray(
														[
															$elm$html$Html$Attributes$step(
															$elm$core$String$fromInt(i))
														]);
												case 'FloatStep':
													var f = _v2.a.a;
													return _List_fromArray(
														[
															$elm$html$Html$Attributes$step(
															$elm$core$String$fromFloat(f))
														]);
												default:
													var _v3 = _v2.a;
													return _List_fromArray(
														[
															$elm$html$Html$Attributes$step('any')
														]);
											}
										} else {
											return _List_Nil;
										}
									}()))))),
				_List_Nil),
				$author$project$PinMeTo$Ui$Form$Input$renderIcons(config)
			]));
};
var $author$project$PinMeTo$Ui$Form$Input$renderErrorMessage = function (errorMessage) {
	var getErrorMessage = function () {
		if (errorMessage.$ === 'Error') {
			var string = errorMessage.a;
			return string;
		} else {
			return '';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-input__message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(getErrorMessage)
			]));
};
var $author$project$PinMeTo$Ui$Form$Input$render = function (_v0) {
	var config = _v0.a;
	var _v1 = function () {
		var _v2 = config.label;
		if (_v2.$ === 'Just') {
			var label_ = _v2.a.a;
			return _Utils_Tuple2(
				$elm$html$Html$label,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-input__label')
						]),
					_List_fromArray(
						[
							label_,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-input__required')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									config.required ? ' *' : '')
								]))
						])));
		} else {
			return _Utils_Tuple2(
				$elm$html$Html$div,
				$elm$html$Html$text(''));
		}
	}();
	var tag = _v1.a;
	var label = _v1.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-input')
			]),
		_List_fromArray(
			[
				A2(
				tag,
				_List_Nil,
				_List_fromArray(
					[
						label,
						$author$project$PinMeTo$Ui$Form$Input$renderField(config),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Form$Input$renderErrorMessage, config.errorMessage))
					]))
			]));
};
var $author$project$PinMeTo$Ui$Form$Input$Input = function (a) {
	return {$: 'Input', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$Value = function (a) {
	return {$: 'Value', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$configWithType = F2(
	function (type_, _v0) {
		var onChange = _v0.onChange;
		var value = _v0.value;
		return {
			id: $elm$core$Maybe$Nothing,
			step: $elm$core$Maybe$Nothing,
			label: $elm$core$Maybe$Nothing,
			type_: type_,
			value: $author$project$PinMeTo$Ui$Form$Input$Value(value),
			onBlur: $elm$core$Maybe$Nothing,
			disabled: false,
			onChange: onChange,
			required: false,
			placeholder: $elm$core$Maybe$Nothing,
			errorMessage: $elm$core$Maybe$Nothing,
			inFocusError: false,
			dataTestAttribute: $elm$core$Maybe$Nothing,
			clearButtonEnabled: true
		};
	});
var $author$project$PinMeTo$Ui$Form$Input$search = function (config_) {
	return $author$project$PinMeTo$Ui$Form$Input$Input(
		A2($author$project$PinMeTo$Ui$Form$Input$configWithType, $author$project$PinMeTo$Ui$Form$Input$Search, config_));
};
var $author$project$PinMeTo$Ui$Selector$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$PinMeTo$Ui$Selector$Disabled = {$: 'Disabled'};
var $author$project$PinMeTo$Ui$Selector$Selected = {$: 'Selected'};
var $author$project$PinMeTo$Ui$Selector$SetActiveTab = function (a) {
	return {$: 'SetActiveTab', a: a};
};
var $author$project$PinMeTo$Ui$Selector$Unselectable = {$: 'Unselectable'};
var $author$project$PinMeTo$Ui$Selector$tabsView = F2(
	function (_v0, _v1) {
		var disableColumn = _v0.disableColumn;
		var disabledCount = _v0.disabledCount;
		var selectedCount = _v0.selectedCount;
		var unselectablesCount = _v0.unselectablesCount;
		var allCount = _v0.allCount;
		var currentTab = _v0.currentTab;
		var labels = _v1.labels;
		var addUnselectableColumn = function (x) {
			return (unselectablesCount > 0) ? A2(
				$elm$core$List$append,
				x,
				_List_fromArray(
					[
						{tab: $author$project$PinMeTo$Ui$Selector$Unselectable, count: unselectablesCount, label: 'Unselectable', isDisabled: false, totalCount: $elm$core$Maybe$Nothing}
					])) : x;
		};
		var addDisabledColumn = function (x) {
			return disableColumn ? A2(
				$elm$core$List$append,
				x,
				_List_fromArray(
					[
						{
						tab: $author$project$PinMeTo$Ui$Selector$Disabled,
						count: disabledCount,
						label: labels.invalidItems,
						isDisabled: !disabledCount,
						totalCount: $elm$core$Maybe$Just(allCount)
					}
					])) : x;
		};
		var doNothing = function (x) {
			return x;
		};
		var itemView = function (_v3) {
			var totalCount = _v3.totalCount;
			var isDisabled = _v3.isDisabled;
			var count = _v3.count;
			var tab = _v3.tab;
			var label = _v3.label;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
						$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--label'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pmt-ui-view-selector__item--active',
								_Utils_eq(tab, currentTab)),
								_Utils_Tuple2('pmt-ui-view-selector__item--enabled', !isDisabled)
							])),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(
						$author$project$PinMeTo$Ui$Selector$SetActiveTab(tab)),
						$elm$html$Html$Attributes$disabled(isDisabled)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						label + (' (' + ($elm$core$String$fromInt(count) + (function () {
							if (totalCount.$ === 'Just') {
								var c = totalCount.a;
								return '/' + $elm$core$String$fromInt(c);
							} else {
								return '';
							}
						}() + ')'))))
					]));
		};
		var baseCols = _List_fromArray(
			[
				{
				tab: $author$project$PinMeTo$Ui$Selector$All,
				count: allCount - disabledCount,
				label: labels.itemPlural,
				isDisabled: false,
				totalCount: disableColumn ? $elm$core$Maybe$Just(allCount) : $elm$core$Maybe$Nothing
			},
				{tab: $author$project$PinMeTo$Ui$Selector$Selected, count: selectedCount, label: labels.selectedItems, isDisabled: !selectedCount, totalCount: $elm$core$Maybe$Nothing}
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-view-selector pmt-ui-view-selector--labels')
				]),
			A2(
				$elm$core$List$map,
				itemView,
				addUnselectableColumn(
					addDisabledColumn(baseCols))));
	});
var $author$project$PinMeTo$Ui$Table$Asc = function (a) {
	return {$: 'Asc', a: a};
};
var $author$project$PinMeTo$Ui$Table$view = F2(
	function (tagger, items) {
		return {
			sort: $author$project$PinMeTo$Ui$Table$Asc(0),
			items: items,
			tagger: tagger,
			columns: $elm$core$Array$empty,
			noHover: false,
			rowIcon: $elm$core$Maybe$Nothing,
			rowLink: $elm$core$Maybe$Nothing,
			rowMore: $elm$core$Maybe$Nothing,
			fullWidth: false,
			rowAction: $elm$core$Maybe$Nothing,
			pagination: $elm$core$Maybe$Nothing,
			itemOptions: $elm$core$Maybe$Nothing,
			onRowSelect: $elm$core$Maybe$Nothing,
			onSelectAll: $elm$core$Maybe$Nothing,
			columnWidths: _List_Nil,
			headerSticky: false,
			itemsVisible: $elm$core$Maybe$Nothing,
			rowSelection: $elm$core$Maybe$Nothing,
			rowMoreIndent: 0,
			checkboxSticky: false,
			displayHeaders: true,
			sortingVisible: false,
			columnSelection: $elm$core$Maybe$Nothing,
			rowDeleteAction: $elm$core$Maybe$Nothing,
			scrollableTable: false,
			sortableColumns: _List_Nil,
			checkboxInactive: $elm$core$Maybe$Nothing,
			displayDeselected: false,
			rowLinkAttributes: $elm$core$Maybe$Nothing
		};
	});
var $author$project$PinMeTo$Ui$Table$when = F2(
	function (x, f) {
		return x ? f : $elm$core$Basics$identity;
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (_v0.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$caption = _VirtualDom_node('caption');
var $author$project$PinMeTo$Ui$Table$tags = {row: $elm$html$Html$tr, body: $elm$html$Html$tbody, cell: $elm$html$Html$td, head: $elm$html$Html$thead, root: $elm$html$Html$table, caption: $elm$html$Html$caption};
var $author$project$PinMeTo$Ui$Table$hasActions = function (config) {
	return !_Utils_eq(config.rowDeleteAction, $elm$core$Maybe$Nothing);
};
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (node.$ === 'SubTree') {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$PinMeTo$Ui$Table$getLimit = F2(
	function (model, config) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$List$length(config.items),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.limit;
					},
					config.pagination)),
			model.limit);
	});
var $author$project$PinMeTo$Ui$Table$Left = {$: 'Left'};
var $author$project$PinMeTo$Ui$Table$Index = {$: 'Index'};
var $author$project$PinMeTo$Ui$Table$Right = {$: 'Right'};
var $author$project$PinMeTo$Ui$Table$Select = F2(
	function (a, b) {
		return {$: 'Select', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Icon$renderSvg = function (svgId) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-icon pmt-icon--svg')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$svg,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$use,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$xlinkHref('#pmt-icon__' + svgId)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$PinMeTo$Ui$Icon$renderSvgWithColor = F2(
	function (_v0, svgId) {
		var iconColor = _v0.iconColor;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-icon pmt-icon--svg'),
					A2($elm$html$Html$Attributes$style, 'fill', 'var(' + (iconColor + ')'))
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$use,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$xlinkHref('#pmt-icon__' + svgId)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Icon$renderSvgWithScale = F2(
	function (svgId, scale) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-icon pmt-icon--svg'),
					A2($elm$html$Html$Attributes$style, 'transform', 'scale(' + (scale + ')')),
					A2($elm$html$Html$Attributes$style, 'transform-origin', 'center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$svg,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$use,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$xlinkHref('#pmt-icon__' + svgId)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Icon$render = function (icon) {
	switch (icon.$) {
		case 'PinMeToLogo':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('pmt-logo');
		case 'PinMeToLogoSolid':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('pmt-logo-solid');
		case 'AppIconListings':
			return A2(
				$author$project$PinMeTo$Ui$Icon$renderSvgWithColor,
				{iconColor: '--color-listings-app'},
				'app-listings');
		case 'AppIconReviews':
			return A2(
				$author$project$PinMeTo$Ui$Icon$renderSvgWithColor,
				{iconColor: '--color-conversations-app'},
				'app-reviews');
		case 'AppIconLocator':
			return A2(
				$author$project$PinMeTo$Ui$Icon$renderSvgWithColor,
				{iconColor: '--color-locator-app'},
				'app-locator');
		case 'AppIconLocalCampaigns':
			return A2(
				$author$project$PinMeTo$Ui$Icon$renderSvgWithColor,
				{iconColor: '--color-local-campaigns-app'},
				'app-local-campaigns');
		case 'AppIconConversations':
			return A2(
				$author$project$PinMeTo$Ui$Icon$renderSvgWithColor,
				{iconColor: '--color-conversations-app'},
				'app-conversations');
		case 'AppIconLocationPosts':
			return A2(
				$author$project$PinMeTo$Ui$Icon$renderSvgWithColor,
				{iconColor: '--color-posts-app'},
				'app-location-posts');
		case 'AppIconPlaces':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-places');
		case 'AppIconAiInsights':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-ai-insights');
		case 'AppIconListingsNoFill':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-listings');
		case 'AppIconReviewsNoFill':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-reviews');
		case 'AppIconConversationsNoFill':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-conversations');
		case 'AppIconLocationPostsNoFill':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-location-posts');
		case 'AppIconLocatorNoFill':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-locator');
		case 'AppIconLocalCampaignsNoFill':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-local-campaigns');
		case 'AppIconAccountSettings':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-access-manager');
		case 'AppIconAdmin':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-admin');
		case 'AppIconCS':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-cs');
		case 'AppIconUserSettings':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('app-user-settings');
		case 'IntercomLogo':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('intercom-logo');
		case 'NetworkHere':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('here-logo');
		case 'NetworkBing':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('bing-logo');
		case 'NetworkTomTom':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('tomtom-logo');
		case 'NetworkFactual':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('factual-logo');
		case 'NetworkTrustPilot':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('TrustPilot_Logo');
		case 'NetworkHuawei':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Huawei_App_Logo');
		case 'NetworkOneWay':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('one-way');
		case 'NetworkTwoWay':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('two-way');
		case 'NetworkOneWayWhite':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('one-way-white');
		case 'NetworkTwoWayWhite':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('two-way-white');
		case 'NetworkHitta':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('hitta-logo');
		case 'MediaCarousel':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('carousel_type');
		case 'MediaImage':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('image_media');
		case 'MediaLink':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('link_type');
		case 'MediaMultiMedia':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('multi_media');
		case 'MediaReel':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('reels_type');
		case 'MediaReelGrey':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('reels_type_grey');
		case 'MediaReelDarkgrey':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('reels_type_darkgrey');
		case 'MediaVideo':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('video_media');
		case 'RegularColorBing':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('bing');
		case 'RegularColorFacebook':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Facebook_Logo');
		case 'RegularColorLinkedIn':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('LinkedIn_Logo');
		case 'RegularColorGoogle':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_Logo');
		case 'RegularColorGMB':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_My_Business_Logo');
		case 'RegularColorGoogleSearch':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_Search_Logo');
		case 'RegularColorGoogleMaps':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_Maps_Logo');
		case 'RegularColorWaze':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Waze_Logo');
		case 'RegularColorInstagram':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Instagram_Logo');
		case 'RegularColorApple':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Apple_Logo');
		case 'RegularColorAppleOff':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Apple_logo_off');
		case 'RegularColorApplePending':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Apple_logo_pending');
		case 'RegularColorAppleSuccess':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Apple_logo_success');
		case 'RegularColorAppleFailed':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Apple_logo_error');
		case 'RegularColorAppleMaps':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Apple_Maps_Logo');
		case 'RegularColorFoursquare':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Foursquare_Logo');
		case 'RegularColorTomTom':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('TomTom_Logo');
		case 'RegularColorPTV':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('PTV_Logo');
		case 'RegularColorPTVOff':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('PTV_logo_off');
		case 'RegularColorPTVPending':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('PTV_logo_pending');
		case 'RegularColorPTVSuccess':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('PTV_logo_success');
		case 'RegularColorPTVFailed':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('PTV_logo_error');
		case 'RegularColorHere':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Here_Logo');
		case 'RegularColorYandex':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Yandex_Logo');
		case 'RegularColorWeChat':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('WeChat_Logo');
		case 'RegularColorBaidu':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Baidu_Logo');
		case 'RegularColorYelp':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Yelp_Logo');
		case 'RegularColorFactual':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Factual_Logo');
		case 'RegularColorTrustpilot':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('TrustPilot_Logo');
		case 'RegularColorHuawei':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Huawei_Logo');
		case 'RegularColorHitta':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Hitta_Logo');
		case 'RegularColorSeznam':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Seznam-logo');
		case 'RegularColorEcoMovement':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Ecomovement-logo');
		case 'RegularColorOverture':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Overture_logo');
		case 'User':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('user');
		case 'Location':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('location');
		case 'LocationGroupCustom':
			return A2($author$project$PinMeTo$Ui$Icon$renderSvgWithScale, 'location-group-custom', '1.5');
		case 'LocationGroupSmart':
			return A2($author$project$PinMeTo$Ui$Icon$renderSvgWithScale, 'location-group-smart', '1.5');
		case 'FacebookColor':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('FB_Colour');
		case 'FacebookOff':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Facebook_logo_off');
		case 'FacebookSuccess':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Facebook_logo_success');
		case 'FacebookPending':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Facebook_logo_pending');
		case 'FacebookFailed':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Facebook_logo_error');
		case 'GoogleColor':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_Colour');
		case 'GoogleOff':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_logo_off');
		case 'GoogleSuccess':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_logo_success');
		case 'GooglePending':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_logo_pending');
		case 'GoogleFailed':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_logo_error');
		case 'InstagramColor':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('IG_Colour');
		case 'InstagramOff':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Instagram_logo_off');
		case 'InstagramSuccess':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Instagram_logo_success');
		case 'InstagramPending':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('IG_logo_pending');
		case 'InstagramFailed':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Instagram_logo_error');
		case 'BingPending':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Bing_logo_pending');
		case 'BingOff':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Bing_logo_off');
		case 'BingSuccess':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Bing_logo_success');
		case 'BingFailed':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Bing_logo_error');
		case 'PostsGray':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('PostsGray');
		case 'ConversationsGray':
			return $author$project$PinMeTo$Ui$Icon$renderSvg('ConversationsGray');
		default:
			return $author$project$PinMeTo$Ui$Icon$renderSvg('Google_My_Business_Logo_Gray');
	}
};
var $author$project$PinMeTo$Ui$Table$Actions = {$: 'Actions'};
var $author$project$PinMeTo$Ui$Table$Compact = {$: 'Compact'};
var $author$project$PinMeTo$Ui$Table$Tooltip = {$: 'Tooltip'};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$PinMeTo$Ui$Table$Deselect = F2(
	function (a, b) {
		return {$: 'Deselect', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Table$Inactive = {$: 'Inactive'};
var $author$project$PinMeTo$Ui$Table$MaxWidth = {$: 'MaxWidth'};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$PinMeTo$Ui$Table$LineClamp3 = {$: 'LineClamp3'};
var $author$project$PinMeTo$Ui$Table$isSelected = F2(
	function (x, model) {
		return A2($elm$core$Set$member, x, model.selected);
	});
var $author$project$PinMeTo$Ui$Table$MultiSelect = F2(
	function (a, b) {
		return {$: 'MultiSelect', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Tooltip$tooltip_ = F5(
	function (classes, content, n, a, c) {
		var fc = A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-tooltip__tooltip')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-tooltip__content')
							]),
						_List_fromArray(
							[content]))
					])),
			c);
		var fa = A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$style, 'position', 'relative'),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(classes),
				a));
		return A2(n, fa, fc);
	});
var $author$project$PinMeTo$Ui$Tooltip$tooltipHtml = $author$project$PinMeTo$Ui$Tooltip$tooltip_('pmt-tooltip pmt-tooltip--top');
var $author$project$PinMeTo$Ui$Table$isDeselected = F2(
	function (x, model) {
		return A2($elm$core$Set$member, x, model.deselected);
	});
var $author$project$PinMeTo$Ui$Table$onClickFinal = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$PinMeTo$Ui$Table$MultiDeselect = F2(
	function (a, b) {
		return {$: 'MultiDeselect', a: a, b: b};
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{tail: jsArray, nodeList: nodeList, nodeListSize: nodeListSize});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$PinMeTo$Ui$Table$columnWidthStyles = F2(
	function (widths, index) {
		var widthsArray = $elm$core$Array$fromList(widths);
		var _v0 = A2($elm$core$Array$get, index, widthsArray);
		if ((_v0.$ === 'Just') && (_v0.a.$ === 'Just')) {
			var w = _v0.a.a;
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'min-width', w),
					A2($elm$html$Html$Attributes$style, 'max-width', w)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$PinMeTo$Ui$Table$classFromRowOption = function (option) {
	switch (option.$) {
		case 'Deleted':
			return 'pmt-ui-table__row--deleted';
		case 'Secret':
			return 'pmt-ui-table__row--secret';
		case 'Inactive':
			return 'pmt-ui-table__row--inactive';
		case 'Error':
			return 'pmt-ui-table__row--error';
		case 'ErrorHighlight':
			return 'pmt-ui-table__row--error-highlight';
		default:
			return 'pmt-ui-table__row--highlight';
	}
};
var $author$project$PinMeTo$Ui$Table$renderDeleteAction = F2(
	function (item, deleteAction) {
		return A2(
			$author$project$PinMeTo$Ui$Table$tags.cell,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-table__cell pmt-ui-table__actions')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-table__action'),
							$author$project$PinMeTo$Ui$Table$onClickFinal(
							deleteAction(item))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('✖')
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Table$renderItem = F5(
	function (model, config, sortedActiveItems, itemIndex, item) {
		var rowLinkAttributes = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return f(item);
				},
				config.rowLinkAttributes));
		var itemOptions = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					return A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						A2(
							$elm$core$List$filter,
							$elm$core$Tuple$second,
							x(item)));
				},
				config.itemOptions));
		var rowClasses = A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $author$project$PinMeTo$Ui$Table$classFromRowOption, itemOptions));
		var isInactive = function () {
			var _v14 = config.checkboxInactive;
			if (_v14.$ === 'Just') {
				var fn = _v14.a;
				return fn(item);
			} else {
				return A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Inactive, itemOptions);
			}
		}();
		var withMore = function (_v13) {
			var itemCount = _v13.a;
			var row = _v13.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[row]),
				A2(
					$elm$core$Maybe$map,
					function (f) {
						return A2(
							$elm$core$Maybe$withDefault,
							_List_fromArray(
								[row]),
							A2(
								$elm$core$Maybe$map,
								function (more) {
									return _List_fromArray(
										[
											row,
											(config.rowMoreIndent > 0) ? A2(
											$author$project$PinMeTo$Ui$Table$tags.row,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-table__row pmt-ui-table__row-more')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$PinMeTo$Ui$Table$tags.cell,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-ui-table__row-more-reason'),
															$elm$html$Html$Attributes$colspan(config.rowMoreIndent)
														]),
													_List_Nil),
													A2(
													$author$project$PinMeTo$Ui$Table$tags.cell,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-ui-table__row-more-reason'),
															$elm$html$Html$Attributes$colspan(itemCount - config.rowMoreIndent)
														]),
													_List_fromArray(
														[more]))
												])) : A2(
											$author$project$PinMeTo$Ui$Table$tags.row,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-table__row pmt-ui-table__row-more')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$PinMeTo$Ui$Table$tags.cell,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-ui-table__row-more-content'),
															$elm$html$Html$Attributes$colspan(itemCount)
														]),
													_List_fromArray(
														[more]))
												]))
										]);
								},
								f(item)));
					},
					config.rowMore));
		};
		var wrapper = function (cells) {
			var noSelection = config.noHover ? _Utils_Tuple2(
				$elm$core$List$length(cells),
				A2(
					$author$project$PinMeTo$Ui$Table$tags.row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-table__unselectables'),
							$elm$html$Html$Attributes$class(rowClasses)
						]),
					cells)) : _Utils_Tuple2(
				$elm$core$List$length(cells),
				A2(
					$author$project$PinMeTo$Ui$Table$tags.row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-table__row'),
							$elm$html$Html$Attributes$class(rowClasses),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-table__row--selectable',
									(!_Utils_eq(config.rowMore, $elm$core$Maybe$Nothing)) || (!_Utils_eq(config.rowAction, $elm$core$Maybe$Nothing)))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							A2($elm$html$Html$Attributes$style, '', ''),
							A2(
								$elm$core$Maybe$map,
								function (f) {
									return $elm$html$Html$Events$onClick(
										f(item));
								},
								config.rowAction))
						]),
					cells));
			var _v2 = config.columnSelection;
			if (_v2.$ === 'Just') {
				var column = _v2.a;
				var _v3 = _Utils_Tuple3(config.rowSelection, config.onRowSelect, config.rowLink);
				if (_v3.c.$ === 'Just') {
					var g = _v3.c.a;
					var itemId = column(item);
					var _v4 = (A2($author$project$PinMeTo$Ui$Table$isSelected, itemId, model) && model.shiftHeld) ? _Utils_Tuple2(
						true,
						A2(
							$author$project$PinMeTo$Ui$Table$MultiDeselect,
							A2($elm$core$List$map, column, sortedActiveItems),
							itemIndex)) : (A2($author$project$PinMeTo$Ui$Table$isSelected, itemId, model) ? _Utils_Tuple2(
						true,
						A2($author$project$PinMeTo$Ui$Table$Deselect, itemId, itemIndex)) : (model.shiftHeld ? _Utils_Tuple2(
						false,
						A2(
							$author$project$PinMeTo$Ui$Table$MultiSelect,
							A2($elm$core$List$map, column, sortedActiveItems),
							itemIndex)) : _Utils_Tuple2(
						false,
						A2($author$project$PinMeTo$Ui$Table$Select, itemId, itemIndex))));
					var selected = _v4.a;
					var msg = _v4.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$author$project$PinMeTo$Ui$Table$tags.row(
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-table__row pmt-ui-table__row--selectable'),
										$elm$html$Html$Attributes$class(rowClasses),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'pmt-ui-table__row--deselected',
												config.displayDeselected && A2($author$project$PinMeTo$Ui$Table$isDeselected, itemId, model))
											])),
										$elm$html$Html$Attributes$href(
										g(item))
									]),
								rowLinkAttributes)),
						function (x) {
							return _Utils_Tuple2(
								$elm$core$List$length(x),
								x);
						}(
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$PinMeTo$Ui$Table$tags.cell,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-table__cell pmt-ui-table__cell--compact'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-ui-table__cell__sticky', config.checkboxSticky)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-table__checkbox'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('pmt-ui-table__checkbox--selected', selected),
															_Utils_Tuple2('pmt-ui-table__checkbox--inactive', isInactive)
														])),
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Attributes$disabled(isInactive),
													$elm$html$Html$Events$onClick(
													config.tagger(msg))
												]),
											_List_Nil)
										])),
								cells)));
				} else {
					return noSelection;
				}
			} else {
				var _v5 = _Utils_Tuple3(config.rowSelection, config.onRowSelect, config.rowLink);
				if (_v5.a.$ === 'Just') {
					var f = _v5.a.a;
					var itemId = f(item);
					var _v6 = (A2($author$project$PinMeTo$Ui$Table$isSelected, itemId, model) && model.shiftHeld) ? _Utils_Tuple2(
						true,
						A2(
							$author$project$PinMeTo$Ui$Table$MultiDeselect,
							A2($elm$core$List$map, f, sortedActiveItems),
							itemIndex)) : (A2($author$project$PinMeTo$Ui$Table$isSelected, itemId, model) ? _Utils_Tuple2(
						true,
						A2($author$project$PinMeTo$Ui$Table$Deselect, itemId, itemIndex)) : (model.shiftHeld ? _Utils_Tuple2(
						false,
						A2(
							$author$project$PinMeTo$Ui$Table$MultiSelect,
							A2($elm$core$List$map, f, sortedActiveItems),
							itemIndex)) : _Utils_Tuple2(
						false,
						A2($author$project$PinMeTo$Ui$Table$Select, itemId, itemIndex))));
					var selected = _v6.a;
					var selectMsg = _v6.b;
					var _v7 = function () {
						var _v8 = config.rowAction;
						if (_v8.$ === 'Just') {
							var action = _v8.a;
							return _Utils_Tuple2(
								$elm$html$Html$Events$onClick(
									action(item)),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Table$onClickFinal(
										config.tagger(selectMsg))
									]));
						} else {
							return _Utils_Tuple2(
								$elm$html$Html$Events$onClick(
									config.tagger(selectMsg)),
								_List_Nil);
						}
					}();
					var rowOnClick = _v7.a;
					var checkboxAttrs = _v7.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						$author$project$PinMeTo$Ui$Table$tags.row(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-table__row pmt-ui-table__row--selectable'),
									$elm$html$Html$Attributes$class(rowClasses),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'pmt-ui-table__row--deselected',
											config.displayDeselected && A2($author$project$PinMeTo$Ui$Table$isDeselected, itemId, model))
										])),
									rowOnClick
								])),
						function (x) {
							return _Utils_Tuple2(
								$elm$core$List$length(x),
								x);
						}(
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$PinMeTo$Ui$Table$tags.cell,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-table__cell pmt-ui-table__cell--compact'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-ui-table__cell__sticky', config.checkboxSticky)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_Utils_ap(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-table__checkbox'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('pmt-ui-table__checkbox--selected', selected),
																_Utils_Tuple2('pmt-ui-table__checkbox--inactive', isInactive)
															])),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Attributes$disabled(isInactive)
													]),
												checkboxAttrs),
											_List_Nil)
										])),
								cells)));
				} else {
					if (_v5.b.$ === 'Just') {
						var _v9 = _v5.a;
						var _v10 = _v5.b.a;
						var selectF = _v10.a;
						var isSelectedF = _v10.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$author$project$PinMeTo$Ui$Table$tags.row(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-table__row pmt-ui-table__row--selectable'),
										$elm$html$Html$Attributes$class(rowClasses),
										$elm$html$Html$Events$onClick(
										selectF(item))
									])),
							function (x) {
								return _Utils_Tuple2(
									$elm$core$List$length(x),
									x);
							}(
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$PinMeTo$Ui$Table$tags.cell,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-table__cell pmt-ui-table__cell--compact'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('pmt-ui-table__cell__sticky', config.checkboxSticky)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-table__checkbox'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'pmt-ui-table__checkbox--selected',
																isSelectedF(item)),
																_Utils_Tuple2('pmt-ui-table__checkbox--inactive', isInactive)
															])),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Attributes$disabled(isInactive)
													]),
												_List_Nil)
											])),
									cells)));
					} else {
						if (_v5.c.$ === 'Just') {
							var _v11 = _v5.a;
							var _v12 = _v5.b;
							var f = _v5.c.a;
							return _Utils_Tuple2(
								$elm$core$List$length(cells),
								A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												f(item)),
												$elm$html$Html$Attributes$class('pmt-ui-table__row pmt-ui-table__row--link'),
												$elm$html$Html$Attributes$class(rowClasses)
											]),
										rowLinkAttributes),
									cells));
						} else {
							return noSelection;
						}
					}
				}
			}
		};
		var rowIcon = function (index) {
			return (!index) ? A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (x) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-table__cell-icon')
								]),
							_List_fromArray(
								[
									x(item)
								]));
					},
					config.rowIcon)) : $elm$html$Html$text('');
		};
		return withMore(
			wrapper(
				function (x) {
					return (!_Utils_eq(config.rowDeleteAction, $elm$core$Maybe$Nothing)) ? _Utils_ap(
						x,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									$author$project$PinMeTo$Ui$Table$renderDeleteAction(item),
									config.rowDeleteAction))
							])) : x;
				}(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, col) {
								var wrapIndexColumn = function (x) {
									return A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Index, col.options) ? A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-table__cell-index')
											]),
										_List_fromArray(
											[x])) : x;
								};
								var linkColumnClass = function () {
									var _v1 = _Utils_Tuple2(config.columnSelection, config.rowLink);
									if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
										return true;
									} else {
										return false;
									}
								}();
								var contentAttrs = A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('pmt-ui-table__cell--content'),
									A2($author$project$PinMeTo$Ui$Table$columnWidthStyles, config.columnWidths, index));
								var withTooltip = function (x) {
									return A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Tooltip, col.options) ? A2(
										$author$project$PinMeTo$Ui$Tooltip$tooltipHtml,
										col.renderer(item),
										x) : x;
								};
								var iconAside = A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										function (x) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-table__cell-icon pmt-ui-table__cell-icon--aside')
													]),
												_List_fromArray(
													[
														$author$project$PinMeTo$Ui$Icon$render(x)
													]));
										},
										col.icon));
								var withLink = function () {
									var _v0 = _Utils_Tuple2(config.columnSelection, config.rowLink);
									if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
										var g = _v0.b.a;
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													g(item)),
													$elm$html$Html$Attributes$class('pmt-ui-table__cell--a')
												]),
											_List_fromArray(
												[
													A3(
													withTooltip,
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															contentAttrs,
															_List_fromArray(
																[
																	rowIcon(index),
																	wrapIndexColumn(
																	col.renderer(item)),
																	iconAside
																]))
														]))
												]));
									} else {
										return A3(
											withTooltip,
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													contentAttrs,
													_List_fromArray(
														[
															rowIcon(index),
															wrapIndexColumn(
															col.renderer(item)),
															iconAside
														]))
												]));
									}
								}();
								return A2(
									$author$project$PinMeTo$Ui$Table$tags.cell,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-table__cell'),
											$elm$html$Html$Attributes$class(
											'pmt-ui-table__cell--index-' + $elm$core$String$fromInt(index)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'pmt-ui-table__cell--right',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Right, col.options)),
													_Utils_Tuple2(
													'pmt-ui-table__cell--left',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Left, col.options)),
													_Utils_Tuple2(
													'pmt-ui-table__cell--compact',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Compact, col.options)),
													_Utils_Tuple2(
													'pmt-ui-table__cell--index',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Index, col.options)),
													_Utils_Tuple2(
													'pmt-ui-table__cell--line-clamp-3',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$LineClamp3, col.options)),
													_Utils_Tuple2(
													'pmt-ui-table__cell--actions',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Actions, col.options)),
													_Utils_Tuple2(
													'pmt-ui-table__cell--max-width',
													A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$MaxWidth, col.options)),
													_Utils_Tuple2('pmt-ui-table__cell--with-link', linkColumnClass)
												]))
										]),
									_List_fromArray(
										[withLink]));
							}),
						$elm$core$Array$toList(config.columns)))));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$PinMeTo$Ui$Table$itemsSorted = F3(
	function (sort, sorters, items) {
		var getSorter = function (x) {
			return A2(
				$elm$core$Maybe$map,
				function (sorter_) {
					switch (sorter_.$) {
						case 'Standard':
							var srt = sorter_.a;
							return srt;
						case 'Custom':
							var srt = sorter_.a;
							return srt(sort);
						default:
							return F2(
								function (_v5, _v6) {
									return $elm$core$Basics$EQ;
								});
					}
				},
				A2($elm$core$Array$get, x, sorters));
		};
		var ordered = function (list_) {
			if (sort.$ === 'Asc') {
				return list_;
			} else {
				return $elm$core$List$reverse(list_);
			}
		};
		var sorter = function () {
			if (sort.$ === 'Asc') {
				var x = sort.a;
				return getSorter(x);
			} else {
				var x = sort.a;
				return getSorter(x);
			}
		}();
		return ordered(
			A2(
				$elm$core$List$sortWith,
				A2(
					$elm$core$Maybe$withDefault,
					F2(
						function (_v0, _v1) {
							return $elm$core$Basics$EQ;
						}),
					sorter),
				items));
	});
var $author$project$PinMeTo$Ui$Table$isItemInactive = F3(
	function (checkboxInactive, itemOptions, item) {
		if (checkboxInactive.$ === 'Just') {
			var fn = checkboxInactive.a;
			return fn(item);
		} else {
			return A2(
				$elm$core$List$member,
				$author$project$PinMeTo$Ui$Table$Inactive,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$List$map,
								$elm$core$Tuple$first,
								A2(
									$elm$core$List$filter,
									$elm$core$Tuple$second,
									x(item)));
						},
						itemOptions)));
		}
	});
var $author$project$PinMeTo$Ui$Table$renderItems = F3(
	function (sort, model, config) {
		var sortedItems = A3(
			$author$project$PinMeTo$Ui$Table$itemsSorted,
			sort,
			A2(
				$elm$core$Array$map,
				function ($) {
					return $.sorter;
				},
				config.columns),
			config.items);
		var sortedActiveItems = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				A2($author$project$PinMeTo$Ui$Table$isItemInactive, config.checkboxInactive, config.itemOptions)),
			sortedItems);
		return A2(
			$author$project$PinMeTo$Ui$Table$tags.body,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-table__tbody')
				]),
			$elm$core$List$concat(
				A2(
					$elm$core$List$indexedMap,
					A3($author$project$PinMeTo$Ui$Table$renderItem, model, config, sortedActiveItems),
					A3(
						$elm$core$Maybe$withDefault,
						$elm$core$Basics$identity,
						config.itemsVisible,
						A2(
							$elm$core$List$take,
							A2($author$project$PinMeTo$Ui$Table$getLimit, model, config),
							sortedItems)))));
	});
var $author$project$PinMeTo$Ui$Table$AddMore = function (a) {
	return {$: 'AddMore', a: a};
};
var $author$project$PinMeTo$Ui$Btn$pmtBtn_ = F4(
	function (classes, n, a, c) {
		var fc = _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn__label')
					]),
				c)
			]);
		var fa = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('pmt-btn ' + classes),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('button'),
				a));
		return A2(n, fa, fc);
	});
var $author$project$PinMeTo$Ui$Btn$pmtBtnSmall = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--link');
var $author$project$PinMeTo$Ui$Table$renderAddMore = F2(
	function (model, config) {
		var _v0 = _Utils_Tuple2(
			config.pagination,
			_Utils_cmp(
				A2($author$project$PinMeTo$Ui$Table$getLimit, model, config),
				$elm$core$List$length(config.items)) < 0);
		if ((_v0.a.$ === 'Just') && _v0.b) {
			var limit = _v0.a.a;
			return A2(
				$author$project$PinMeTo$Ui$Table$tags.caption,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-table__add-more')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								config.tagger(
									$author$project$PinMeTo$Ui$Table$AddMore(limit.limit))),
								$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-table-add-more')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									limit.viewMoreLabel,
									A2($author$project$PinMeTo$Ui$Table$getLimit, model, config),
									$elm$core$List$length(config.items)))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$PinMeTo$Ui$Table$Desc = function (a) {
	return {$: 'Desc', a: a};
};
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$intersect, dict1, dict2));
	});
var $author$project$PinMeTo$Ui$Table$ToggleSort = F2(
	function (a, b) {
		return {$: 'ToggleSort', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Metrics$ClickEvent = function (a) {
	return {$: 'ClickEvent', a: a};
};
var $author$project$PinMeTo$Ui$Metrics$clickEvent = function (x) {
	return $author$project$PinMeTo$Ui$Metrics$ClickEvent(x);
};
var $author$project$PinMeTo$Ui$Metrics$toAttribute = function (_v0) {
	var x = _v0.a;
	return A2($elm$html$Html$Attributes$attribute, 'data-pmt-event', x);
};
var $author$project$PinMeTo$Ui$Tooltip$tooltipBottom = function (content) {
	return A2(
		$author$project$PinMeTo$Ui$Tooltip$tooltip_,
		'pmt-tooltip pmt-tooltip--bottom',
		$elm$html$Html$text(content));
};
var $author$project$PinMeTo$Ui$Table$ToggleSelectAll = function (a) {
	return {$: 'ToggleSelectAll', a: a};
};
var $author$project$PinMeTo$Ui$Table$renderHeaders = F3(
	function (sort, model, config) {
		var emptyHeaderCell = _List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Ui$Table$tags.cell,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-table__cell ')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-table__header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]))
			]);
		var hasSubheaders = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.subheader;
				},
				$elm_community$maybe_extra$Maybe$Extra$isJust),
			$elm$core$Array$toList(config.columns));
		var itemsVisible = A3($elm$core$Maybe$withDefault, $elm$core$Basics$identity, config.itemsVisible, config.items);
		var isInactive = function (item) {
			var _v7 = config.checkboxInactive;
			if (_v7.$ === 'Just') {
				var fn = _v7.a;
				return fn(item);
			} else {
				return A2(
					$elm$core$List$member,
					$author$project$PinMeTo$Ui$Table$Inactive,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (x) {
								return A2(
									$elm$core$List$map,
									$elm$core$Tuple$first,
									A2(
										$elm$core$List$filter,
										$elm$core$Tuple$second,
										x(item)));
							},
							config.itemOptions)));
			}
		};
		var isEmpty = !$elm$core$List$length(itemsVisible);
		var withCheckbox = function (headers) {
			var checkboxHeader = function (f) {
				var itemIds = $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						f,
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeR, isInactive, $elm$core$Basics$not),
							itemsVisible)));
				var allSelected = function (selected) {
					return _Utils_eq(
						A2($elm$core$Set$intersect, itemIds, selected),
						itemIds);
				};
				var someSelected = ($elm$core$Set$size(
					A2($elm$core$Set$intersect, itemIds, model.selected)) > 0) && (!allSelected(model.selected));
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$PinMeTo$Ui$Table$tags.cell,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-table__cell'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('pmt-ui-table__cell__sticky', config.checkboxSticky)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-table__checkbox '),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'pmt-ui-table__checkbox--selected',
												(!isEmpty) && allSelected(model.selected)),
												_Utils_Tuple2('pmt-ui-table__checkbox--indeterminate', (!isEmpty) && someSelected)
											])),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$disabled(isEmpty),
										$elm$html$Html$Events$onClick(
										config.tagger(
											$author$project$PinMeTo$Ui$Table$ToggleSelectAll(
												A2(
													$elm$core$List$map,
													f,
													A2(
														$elm$core$List$filter,
														A2($elm$core$Basics$composeR, isInactive, $elm$core$Basics$not),
														itemsVisible)))))
									]),
								_List_Nil)
							])),
					headers);
			};
			var _v2 = config.columnSelection;
			if (_v2.$ === 'Just') {
				var f = _v2.a;
				return checkboxHeader(f);
			} else {
				var _v3 = _Utils_Tuple3(config.rowSelection, config.onSelectAll, config.onRowSelect);
				if (_v3.a.$ === 'Just') {
					var f = _v3.a.a;
					return checkboxHeader(f);
				} else {
					if (_v3.b.$ === 'Just') {
						var _v4 = _v3.b.a;
						var msg = _v4.a;
						var selected = _v4.b;
						var total = _v4.c;
						return A2(
							$elm$core$List$cons,
							A2(
								$author$project$PinMeTo$Ui$Table$tags.cell,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-table__cell'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('pmt-ui-table__cell__sticky', config.checkboxSticky)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-table__checkbox'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'pmt-ui-table__checkbox--selected',
														(_Utils_cmp(selected, total) > -1) && (total > 0)),
														_Utils_Tuple2(
														'pmt-ui-table__checkbox--indeterminate',
														(selected > 0) && ((_Utils_cmp(selected, total) < 0) && (total > 0)))
													])),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Events$onClick(msg)
											]),
										_List_Nil)
									])),
							headers);
					} else {
						if (_v3.c.$ === 'Just') {
							return A2(
								$elm$core$List$cons,
								A2(
									$author$project$PinMeTo$Ui$Table$tags.cell,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-table__cell'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-ui-table__cell__sticky', config.checkboxSticky)
												]))
										]),
									_List_Nil),
								headers);
						} else {
							var _v5 = _v3.a;
							var _v6 = _v3.b;
							return headers;
						}
					}
				}
			}
		};
		var header = F2(
			function (index, column) {
				var withHeaderTooltip = function (content) {
					var _v1 = column.headerTooltip;
					if (_v1.$ === 'Just') {
						var tooltip = _v1.a;
						return A4(
							$author$project$PinMeTo$Ui$Tooltip$tooltipBottom,
							tooltip,
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[content]));
					} else {
						return content;
					}
				};
				var addMetricEvent = function (attr) {
					var _v0 = column.metricsEvents;
					if (_v0.$ === 'Just') {
						var metricsEvents = _v0.a;
						return _Utils_eq(
							sort,
							$author$project$PinMeTo$Ui$Table$Asc(index)) ? A2(
							$elm$core$List$cons,
							$author$project$PinMeTo$Ui$Metrics$toAttribute(
								metricsEvents(
									$author$project$PinMeTo$Ui$Metrics$clickEvent('Sort Descending'))),
							attr) : A2(
							$elm$core$List$cons,
							$author$project$PinMeTo$Ui$Metrics$toAttribute(
								metricsEvents(
									$author$project$PinMeTo$Ui$Metrics$clickEvent('Sort Ascending'))),
							attr);
					} else {
						return attr;
					}
				};
				var applySorting = function (x) {
					return A2($elm$core$List$member, index, config.sortableColumns) ? A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onClick(
							config.tagger(
								A2($author$project$PinMeTo$Ui$Table$ToggleSort, sort, index))),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('pmt-ui-table__header--sortable', true),
										_Utils_Tuple2('pmt-ui-table__header--sortable-visible', config.sortingVisible)
									])),
							x)) : x;
				};
				return A2(
					$author$project$PinMeTo$Ui$Table$tags.cell,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-table__cell'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-table__cell--right',
									A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Right, column.options)),
									_Utils_Tuple2(
									'pmt-ui-table__cell--left',
									A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Left, column.options)),
									_Utils_Tuple2(
									'pmt-ui-table__cell--compact',
									A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Compact, column.options)),
									_Utils_Tuple2(
									'pmt-ui-table__cell--index',
									A2($elm$core$List$member, $author$project$PinMeTo$Ui$Table$Index, column.options))
								]))
						]),
					_List_fromArray(
						[
							withHeaderTooltip(
							A2(
								$elm$html$Html$button,
								addMetricEvent(
									applySorting(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-table__header'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'pmt-ui-table__header--asc',
														_Utils_eq(
															sort,
															$author$project$PinMeTo$Ui$Table$Asc(index))),
														_Utils_Tuple2(
														'pmt-ui-table__header--desc',
														_Utils_eq(
															sort,
															$author$project$PinMeTo$Ui$Table$Desc(index)))
													])),
												$elm$html$Html$Attributes$type_('button')
											]))),
								_List_fromArray(
									[
										$elm$html$Html$text(column.header)
									]))),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								function (x) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-table__subheader')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(x)
											]));
								},
								column.subheader))
						]));
			});
		return function (headers) {
			return A2(
				$author$project$PinMeTo$Ui$Table$tags.head,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-table__headers pmt-ui-table__thead'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pmt-ui-table__sticky', config.headerSticky),
								_Utils_Tuple2('pmt-ui-table__thead--with-subheaders', hasSubheaders)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Table$tags.row,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-table__controls')
							]),
						headers)
					]));
		}(
			function (headers) {
				return _Utils_eq(config.rowDeleteAction, $elm$core$Maybe$Nothing) ? headers : _Utils_ap(headers, emptyHeaderCell);
			}(
				withCheckbox(
					A2(
						$elm$core$List$indexedMap,
						header,
						$elm$core$Array$toList(config.columns)))));
	});
var $author$project$PinMeTo$Ui$Table$render = F2(
	function (_v0, config) {
		var model = _v0.a;
		var sort = A2($elm$core$Maybe$withDefault, config.sort, model.sort);
		var headers = config.displayHeaders ? A3($author$project$PinMeTo$Ui$Table$renderHeaders, sort, model, config) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-table'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-ui-table--with-actions',
							$author$project$PinMeTo$Ui$Table$hasActions(config)),
							_Utils_Tuple2('pmt-ui-table--full-width', config.fullWidth),
							_Utils_Tuple2('pmt-ui-table__fully-scrollable', config.scrollableTable)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$tags.root,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-table__table-container')
						]),
					_List_fromArray(
						[
							headers,
							A3($author$project$PinMeTo$Ui$Table$renderItems, sort, model, config),
							A2($author$project$PinMeTo$Ui$Table$renderAddMore, model, config)
						]))
				]));
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (value.$ === 'SubTree') {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$PinMeTo$Ui$Table$withColumn = F2(
	function (column, config) {
		var iconAside = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (x) {
					if (x.$ === 'IconAside') {
						var icon = x.a;
						return $elm$core$Maybe$Just(icon);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				column.options));
		return _Utils_update(
			config,
			{
				columns: A2(
					$elm$core$Array$push,
					_Utils_update(
						column,
						{icon: iconAside}),
					config.columns),
				sortableColumns: A2(
					$elm$core$List$cons,
					$elm$core$Array$length(config.columns),
					config.sortableColumns)
			});
	});
var $author$project$PinMeTo$Ui$Table$Standard = function (a) {
	return {$: 'Standard', a: a};
};
var $author$project$PinMeTo$Ui$Table$createColumn = F3(
	function (renderer, sorter, header) {
		return {
			icon: $elm$core$Maybe$Nothing,
			header: header,
			sorter: $author$project$PinMeTo$Ui$Table$Standard(sorter),
			options: _List_Nil,
			renderer: renderer,
			subheader: $elm$core$Maybe$Nothing,
			headerTooltip: $elm$core$Maybe$Nothing,
			metricsEvents: $elm$core$Maybe$Nothing
		};
	});
var $author$project$PinMeTo$Ui$Table$columnWithOptions = F2(
	function (options, column) {
		return _Utils_update(
			column,
			{options: options});
	});
var $author$project$PinMeTo$Ui$Table$addColumnWithOptions = F4(
	function (key, options, renderer, sorter) {
		return $author$project$PinMeTo$Ui$Table$withColumn(
			A2(
				$author$project$PinMeTo$Ui$Table$columnWithOptions,
				options,
				A3($author$project$PinMeTo$Ui$Table$createColumn, renderer, sorter, key)));
	});
var $author$project$PinMeTo$Ui$Table$addColumn = function (key) {
	return A2($author$project$PinMeTo$Ui$Table$addColumnWithOptions, key, _List_Nil);
};
var $author$project$PinMeTo$Ui$Table$withLimit = F2(
	function (pagination, config) {
		return _Utils_update(
			config,
			{
				pagination: $elm$core$Maybe$Just(pagination)
			});
	});
var $author$project$PinMeTo$Ui$Selector$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$PinMeTo$Ui$Selector$SelectItems = function (a) {
	return {$: 'SelectItems', a: a};
};
var $author$project$PinMeTo$Ui$Table$onRowSelect = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				onRowSelect: $elm$core$Maybe$Just(x)
			});
	});
var $author$project$PinMeTo$Ui$Table$onSelectAll = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				onSelectAll: $elm$core$Maybe$Just(x)
			});
	});
var $author$project$PinMeTo$Ui$Table$withNoHover = function (config) {
	return _Utils_update(
		config,
		{noHover: true});
};
var $author$project$PinMeTo$Ui$Table$withRowLink = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				rowLink: $elm$core$Maybe$Just(x)
			});
	});
var $author$project$PinMeTo$Ui$Table$withRowMore = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				rowMore: $elm$core$Maybe$Just(x)
			});
	});
var $author$project$PinMeTo$Ui$Selector$OnSelectItem = function (a) {
	return {$: 'OnSelectItem', a: a};
};
var $author$project$PinMeTo$Ui$Selector$DeselectItems = function (a) {
	return {$: 'DeselectItems', a: a};
};
var $author$project$PinMeTo$Ui$Table$withFullWidth = function (config) {
	return _Utils_update(
		config,
		{fullWidth: true});
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$PinMeTo$Ui$Table$comparingString = F3(
	function (f, x, y) {
		return A2(
			$elm$core$Basics$compare,
			$elm$core$String$toLower(
				f(x)),
			$elm$core$String$toLower(
				f(y)));
	});
var $author$project$PinMeTo$Ui$Table$withRowMoreIndent = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{rowMoreIndent: x});
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$PinMeTo$Ui$Table$comparingStringAndNumber = F4(
	function (n, f, x, y) {
		var pad = function (z) {
			return $elm$core$String$toLower(
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					z,
					function (_v0) {
						return A3(
							$elm$core$String$padLeft,
							n,
							_Utils_chr('0'),
							z);
					},
					$elm$core$String$toInt(z)));
		};
		return A2(
			$elm$core$Basics$compare,
			pad(
				f(x)),
			pad(
				f(y)));
	});
var $author$project$PinMeTo$Ui$Selector$itemsView = F5(
	function (_v0, uiTable, items, selected, tab) {
		var config = _v0.a;
		var isSelected = function (x) {
			return A2($elm$core$Set$member, x, selected);
		};
		var addColumns = function (tableView) {
			return A3(
				$elm$core$List$foldr,
				F2(
					function (column, t) {
						var renderItem = function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(
									column.toString(x)),
								A2(
									$elm$core$Maybe$map,
									function (toHtml) {
										return toHtml(x);
									},
									column.toHtml));
						};
						var cmp = function () {
							var _v5 = column.sort;
							if (_v5.$ === 'Standard') {
								return $author$project$PinMeTo$Ui$Table$comparingString;
							} else {
								return $author$project$PinMeTo$Ui$Table$comparingStringAndNumber(30);
							}
						}();
						return A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							column.key,
							renderItem,
							cmp(column.toString),
							t);
					}),
				tableView,
				config.columns);
		};
		if (tab.$ === 'Unselectable') {
			return A2(
				$author$project$PinMeTo$Ui$Table$render,
				uiTable,
				addColumns(
					$author$project$PinMeTo$Ui$Table$withNoHover(
						A2(
							$author$project$PinMeTo$Ui$Table$withLimit,
							{limit: 100, viewMoreLabel: config.labels.viewMore},
							A2(
								$author$project$PinMeTo$Ui$Table$withRowMore,
								function (x) {
									var _v2 = config.childRow;
									if (_v2.$ === 'Just') {
										var getChild = _v2.a;
										return A2(
											$elm$core$Maybe$map,
											$elm$html$Html$text,
											getChild(x));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								A2(
									$author$project$PinMeTo$Ui$Table$withRowMoreIndent,
									1,
									$author$project$PinMeTo$Ui$Table$withFullWidth(
										A2(
											$author$project$PinMeTo$Ui$Table$view,
											A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Selector$UiTableMsg, config.tagger),
											items))))))));
		} else {
			return A2(
				$author$project$PinMeTo$Ui$Table$render,
				uiTable,
				addColumns(
					A3(
						$author$project$PinMeTo$Ui$Table$when,
						function () {
							if (tab.$ === 'Disabled') {
								return false;
							} else {
								return true;
							}
						}(),
						function (c) {
							return A2(
								$author$project$PinMeTo$Ui$Table$onSelectAll,
								_Utils_Tuple3(
									_Utils_eq(
										$elm$core$Set$size(selected),
										$elm$core$List$length(items)) ? config.tagger(
										$author$project$PinMeTo$Ui$Selector$DeselectItems(
											$elm$core$Set$fromList(
												A2($elm$core$List$map, config.idToString, items)))) : config.tagger(
										$author$project$PinMeTo$Ui$Selector$SelectItems(
											$elm$core$Set$fromList(
												A2($elm$core$List$map, config.idToString, items)))),
									$elm$core$Set$size(selected),
									$elm$core$List$length(items)),
								A2(
									$author$project$PinMeTo$Ui$Table$onRowSelect,
									_Utils_Tuple2(
										A2(
											$elm$core$Basics$composeR,
											config.idToString,
											A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Selector$OnSelectItem, config.tagger)),
										A2($elm$core$Basics$composeR, config.idToString, isSelected)),
									c));
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withLimit,
							{limit: 100, viewMoreLabel: config.labels.viewMore},
							$author$project$PinMeTo$Ui$Table$withFullWidth(
								A2(
									$author$project$PinMeTo$Ui$Table$withRowLink,
									function (_v3) {
										return '';
									},
									A2(
										$author$project$PinMeTo$Ui$Table$view,
										A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Selector$UiTableMsg, config.tagger),
										items)))))));
		}
	});
var $author$project$PinMeTo$Ui$Form$Input$PlaceHolder = function (a) {
	return {$: 'PlaceHolder', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$withPlaceholder = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					placeholder: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Form$Input$PlaceHolder(x))
				}));
	});
var $author$project$PinMeTo$Ui$Selector$renderUnselectableCount = function (unselectablesCount) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-filter-controller__unselectable-count__with-padding')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('('),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-table__warning-color')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(unselectablesCount))
					])),
				$elm$html$Html$text(' Unselectable)')
			]));
};
var $author$project$PinMeTo$Ui$Selector$render_ = F3(
	function (_v0, _v1, allItems) {
		var model = _v0.a;
		var config = _v1.a;
		var _v2 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2(allItems.data, _List_Nil),
			function (x) {
				return _Utils_Tuple2(
					A2(
						$elm$core$List$filter,
						function (item) {
							return !x.disableBy(item);
						},
						allItems.data),
					A2($elm$core$List$filter, x.disableBy, allItems.data));
			},
			config.disabledItems);
		var items = _v2.a;
		var disabledItems = _v2.b;
		var searchView = function (count) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-selector__filters')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Form$Input$render(
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
							config.labels.searchItems,
							$author$project$PinMeTo$Ui$Form$Input$search(
								{value: model.searchQuery, onChange: $author$project$PinMeTo$Ui$Selector$OnSearch}))),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-selector__count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								config.labels.nItems(count))
							])),
						function () {
						var _v5 = model.currentTab;
						if (_v5.$ === 'All') {
							return (!(!$elm$core$List$length(allItems.unselectables))) ? $author$project$PinMeTo$Ui$Selector$renderUnselectableCount(
								$elm$core$List$length(allItems.unselectables)) : $elm$html$Html$text('');
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]));
		};
		var _v3 = function () {
			var _v4 = model.currentTab;
			switch (_v4.$) {
				case 'All':
					var items_ = A2(
						$elm$core$List$filter,
						config.search(model.searchQuery),
						items);
					return _Utils_Tuple3(
						items_,
						model.selected,
						$elm$core$Maybe$Just(
							searchView(
								$elm$core$List$length(items_))));
				case 'Selected':
					var included = $elm$core$Set$toList(
						A2($elm$core$Set$union, model.deselected, model.selected));
					var selected = A2(
						$elm$core$Set$filter,
						function (id) {
							return A2($elm$core$List$member, id, included);
						},
						model.selected);
					return _Utils_Tuple3(
						A2(
							$elm$core$List$filter,
							function (item) {
								return A2(
									$elm$core$List$member,
									config.idToString(item),
									included);
							},
							allItems.data),
						selected,
						$elm$core$Maybe$Nothing);
				case 'Disabled':
					return _Utils_Tuple3(
						disabledItems,
						model.selected,
						$elm$core$Maybe$Just(
							searchView(
								$elm$core$List$length(disabledItems))));
				default:
					var items_ = A2(
						$elm$core$List$filter,
						config.search(model.searchQuery),
						allItems.unselectables);
					return _Utils_Tuple3(
						allItems.unselectables,
						model.selected,
						$elm$core$Maybe$Just(
							searchView(
								$elm$core$List$length(items_))));
			}
		}();
		var filteredItems = _v3.a;
		var filteredSelected = _v3.b;
		var filtersView = _v3.c;
		var tabs = A2(
			$author$project$PinMeTo$Ui$Selector$tabsView,
			{
				allCount: $elm$core$List$length(allItems.data),
				currentTab: model.currentTab,
				disableColumn: $elm_community$maybe_extra$Maybe$Extra$isJust(config.disabledItems),
				disabledCount: $elm$core$List$length(disabledItems),
				selectedCount: $elm$core$Set$size(model.selected),
				unselectablesCount: $elm$core$List$length(allItems.unselectables)
			},
			config);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-selector__tabs')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$map, config.tagger, tabs)
						])),
					A2(
					$elm$html$Html$map,
					config.tagger,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						filtersView)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-selector__items')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$PinMeTo$Ui$Selector$itemsView,
							$author$project$PinMeTo$Ui$Selector$View(config),
							model.uiTable,
							filteredItems,
							filteredSelected,
							model.currentTab)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Selector$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var _v2 = model.items;
		switch (_v2.$) {
			case 'Loading':
				return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
			case 'Error':
				var _v3 = _v2.a;
				return $author$project$PinMeTo$Ui$StatusBar$render(
					$author$project$PinMeTo$Ui$StatusBar$error(config.labels.errorFetchingItems));
			default:
				var items = _v2.a;
				return A3(
					$author$project$PinMeTo$Ui$Selector$render_,
					$author$project$PinMeTo$Ui$Selector$State(model),
					$author$project$PinMeTo$Ui$Selector$View(config),
					items);
		}
	});
var $author$project$PinMeTo$Ui$Spinner$spinner = $author$project$PinMeTo$Ui$Spinner$spinner_(false);
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$PinMeTo$Common$StringNormalize$translate = function (input) {
	return A3($elm$core$String$replace, 'ß', 'ss', input);
};
var $elm$core$String$foldl = _String_foldl;
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_chr('A'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ⓐ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ａ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('À'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Á'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Â'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ầ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ấ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẫ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẩ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ã'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ā'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ă'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ằ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ắ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẵ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ẳ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ȧ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǡ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ä'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǟ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ả'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Å'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǻ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ǎ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ȁ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ȃ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ạ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ậ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ặ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ḁ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ą'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ⱥ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ɐ'),
		'A'),
		_Utils_Tuple2(
		_Utils_chr('Ꜳ'),
		'AA'),
		_Utils_Tuple2(
		_Utils_chr('Æ'),
		'AE'),
		_Utils_Tuple2(
		_Utils_chr('Ǽ'),
		'AE'),
		_Utils_Tuple2(
		_Utils_chr('Ǣ'),
		'AE'),
		_Utils_Tuple2(
		_Utils_chr('Ꜵ'),
		'AO'),
		_Utils_Tuple2(
		_Utils_chr('Ꜷ'),
		'AU'),
		_Utils_Tuple2(
		_Utils_chr('Ꜹ'),
		'AV'),
		_Utils_Tuple2(
		_Utils_chr('Ꜻ'),
		'AV'),
		_Utils_Tuple2(
		_Utils_chr('Ꜽ'),
		'AY'),
		_Utils_Tuple2(
		_Utils_chr('B'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ⓑ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ｂ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ḃ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ḅ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ḇ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ƀ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ƃ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('Ɓ'),
		'B'),
		_Utils_Tuple2(
		_Utils_chr('C'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ⓒ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ｃ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ć'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ĉ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ċ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Č'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ç'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ḉ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ƈ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ȼ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('Ꜿ'),
		'C'),
		_Utils_Tuple2(
		_Utils_chr('D'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ⓓ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ｄ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḋ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ď'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḍ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḑ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḓ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ḏ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Đ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ƌ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ɗ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ɖ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ꝺ'),
		'D'),
		_Utils_Tuple2(
		_Utils_chr('Ǳ'),
		'DZ'),
		_Utils_Tuple2(
		_Utils_chr('Ǆ'),
		'DZ'),
		_Utils_Tuple2(
		_Utils_chr('ǲ'),
		'Dz'),
		_Utils_Tuple2(
		_Utils_chr('ǅ'),
		'Dz'),
		_Utils_Tuple2(
		_Utils_chr('E'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ⓔ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ｅ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('È'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('É'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ê'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ề'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ế'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ễ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ể'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ẽ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ē'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḕ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḗ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ĕ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ė'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ë'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ẻ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ě'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ȅ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ȇ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ẹ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ệ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ȩ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḝ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ę'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḙ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ḛ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ɛ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('Ǝ'),
		'E'),
		_Utils_Tuple2(
		_Utils_chr('F'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ⓕ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ｆ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ḟ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ƒ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('Ꝼ'),
		'F'),
		_Utils_Tuple2(
		_Utils_chr('G'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ⓖ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ｇ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ǵ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ĝ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ḡ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ğ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ġ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ǧ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ģ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ǥ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ɠ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ꞡ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ᵹ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('Ꝿ'),
		'G'),
		_Utils_Tuple2(
		_Utils_chr('H'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ⓗ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ｈ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ĥ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḣ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḧ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ȟ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḥ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḩ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ḫ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ħ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ⱨ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ⱶ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('Ɥ'),
		'H'),
		_Utils_Tuple2(
		_Utils_chr('I'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ⓘ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ｉ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ì'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Í'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Î'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ĩ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ī'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ĭ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('İ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ï'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ḯ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ỉ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ǐ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ȉ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ȋ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ị'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Į'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ḭ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('Ɨ'),
		'I'),
		_Utils_Tuple2(
		_Utils_chr('J'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ⓙ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ｊ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ĵ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('Ɉ'),
		'J'),
		_Utils_Tuple2(
		_Utils_chr('K'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ⓚ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ｋ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ḱ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ǩ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ḳ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ķ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ḵ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ƙ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ⱪ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꝁ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꝃ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꝅ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('Ꞣ'),
		'K'),
		_Utils_Tuple2(
		_Utils_chr('L'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ⓛ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ｌ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ŀ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ĺ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ľ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḷ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḹ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ļ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḽ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ḻ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ł'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ƚ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ɫ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ⱡ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ꝉ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ꝇ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ꞁ'),
		'L'),
		_Utils_Tuple2(
		_Utils_chr('Ǉ'),
		'LJ'),
		_Utils_Tuple2(
		_Utils_chr('ǈ'),
		'Lj'),
		_Utils_Tuple2(
		_Utils_chr('M'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ⓜ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ｍ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ḿ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ṁ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ṃ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ɱ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('Ɯ'),
		'M'),
		_Utils_Tuple2(
		_Utils_chr('N'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ⓝ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ｎ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ǹ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ń'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ñ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṅ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ň'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṇ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ņ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṋ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ṉ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ƞ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ɲ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ꞑ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ꞥ'),
		'N'),
		_Utils_Tuple2(
		_Utils_chr('Ǌ'),
		'NJ'),
		_Utils_Tuple2(
		_Utils_chr('ǋ'),
		'Nj'),
		_Utils_Tuple2(
		_Utils_chr('O'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ⓞ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ｏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ò'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ó'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ô'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ồ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ố'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ỗ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ổ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Õ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṍ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȭ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ō'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṑ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ṓ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ŏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȯ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȱ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ö'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȫ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ỏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ő'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǒ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȍ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ȏ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ơ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ờ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ớ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ỡ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ở'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ợ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ọ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ộ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǫ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǭ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ø'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ǿ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ɔ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ɵ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ꝋ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ꝍ'),
		'O'),
		_Utils_Tuple2(
		_Utils_chr('Ƣ'),
		'OI'),
		_Utils_Tuple2(
		_Utils_chr('Ꝏ'),
		'OO'),
		_Utils_Tuple2(
		_Utils_chr('Ȣ'),
		'OU'),
		_Utils_Tuple2(
		_Utils_chr(''),
		'OE'),
		_Utils_Tuple2(
		_Utils_chr('Œ'),
		'OE'),
		_Utils_Tuple2(
		_Utils_chr(''),
		'oe'),
		_Utils_Tuple2(
		_Utils_chr('œ'),
		'oe'),
		_Utils_Tuple2(
		_Utils_chr('P'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ⓟ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ｐ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ṕ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ṗ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ƥ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ᵽ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ꝑ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ꝓ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Ꝕ'),
		'P'),
		_Utils_Tuple2(
		_Utils_chr('Q'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ⓠ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ｑ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ꝗ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ꝙ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('Ɋ'),
		'Q'),
		_Utils_Tuple2(
		_Utils_chr('R'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ⓡ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ｒ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ŕ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṙ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ř'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ȑ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ȓ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṛ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṝ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ŗ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ṟ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ɍ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ɽ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ꝛ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ꞧ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('Ꞃ'),
		'R'),
		_Utils_Tuple2(
		_Utils_chr('S'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ⓢ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ｓ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('ẞ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ś'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṥ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ŝ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṡ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Š'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṧ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṣ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ṩ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ș'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ş'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ȿ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ꞩ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('Ꞅ'),
		'S'),
		_Utils_Tuple2(
		_Utils_chr('T'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ⓣ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ｔ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṫ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ť'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṭ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ț'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ţ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṱ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ṯ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ŧ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ƭ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ʈ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ⱦ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ꞇ'),
		'T'),
		_Utils_Tuple2(
		_Utils_chr('Ꜩ'),
		'TZ'),
		_Utils_Tuple2(
		_Utils_chr('U'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ⓤ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ｕ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ù'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ú'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Û'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ũ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṹ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ū'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṻ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ŭ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ü'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǜ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǘ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǖ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǚ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ủ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ů'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ű'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ǔ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ȕ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ȗ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ư'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ừ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ứ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ữ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ử'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ự'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ụ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṳ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ų'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṷ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ṵ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('Ʉ'),
		'U'),
		_Utils_Tuple2(
		_Utils_chr('V'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ⓥ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ｖ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ṽ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ṿ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ʋ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ꝟ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ʌ'),
		'V'),
		_Utils_Tuple2(
		_Utils_chr('Ꝡ'),
		'VY'),
		_Utils_Tuple2(
		_Utils_chr('W'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ⓦ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ｗ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẁ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẃ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ŵ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẇ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẅ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ẉ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('Ⱳ'),
		'W'),
		_Utils_Tuple2(
		_Utils_chr('X'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ⓧ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ｘ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ẋ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Ẍ'),
		'X'),
		_Utils_Tuple2(
		_Utils_chr('Y'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ⓨ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ｙ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỳ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ý'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ŷ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỹ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ȳ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ẏ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ÿ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỷ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỵ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ƴ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ɏ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Ỿ'),
		'Y'),
		_Utils_Tuple2(
		_Utils_chr('Z'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ⓩ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ｚ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ź'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ẑ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ż'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ž'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ẓ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ẕ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ƶ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ȥ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ɀ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ⱬ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('Ꝣ'),
		'Z'),
		_Utils_Tuple2(
		_Utils_chr('a'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ⓐ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ａ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẚ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('à'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('á'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('â'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ầ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ấ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẫ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẩ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ã'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ā'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ă'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ằ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ắ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẵ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ẳ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ȧ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǡ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ä'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǟ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ả'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('å'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǻ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ǎ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ȁ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ȃ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ạ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ậ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ặ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ḁ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ą'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ⱥ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ɐ'),
		'a'),
		_Utils_Tuple2(
		_Utils_chr('ꜳ'),
		'aa'),
		_Utils_Tuple2(
		_Utils_chr('æ'),
		'ae'),
		_Utils_Tuple2(
		_Utils_chr('ǽ'),
		'ae'),
		_Utils_Tuple2(
		_Utils_chr('ǣ'),
		'ae'),
		_Utils_Tuple2(
		_Utils_chr('ꜵ'),
		'ao'),
		_Utils_Tuple2(
		_Utils_chr('ꜷ'),
		'au'),
		_Utils_Tuple2(
		_Utils_chr('ꜹ'),
		'av'),
		_Utils_Tuple2(
		_Utils_chr('ꜻ'),
		'av'),
		_Utils_Tuple2(
		_Utils_chr('ꜽ'),
		'ay'),
		_Utils_Tuple2(
		_Utils_chr('b'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ⓑ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ｂ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ḃ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ḅ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ḇ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ƀ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ƃ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('ɓ'),
		'b'),
		_Utils_Tuple2(
		_Utils_chr('c'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ⓒ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ｃ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ć'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ĉ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ċ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('č'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ç'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ḉ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ƈ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ȼ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ꜿ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('ↄ'),
		'c'),
		_Utils_Tuple2(
		_Utils_chr('d'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ⓓ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ｄ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḋ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ď'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḍ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḑ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḓ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ḏ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('đ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ƌ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ɖ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ɗ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ꝺ'),
		'd'),
		_Utils_Tuple2(
		_Utils_chr('ǳ'),
		'dz'),
		_Utils_Tuple2(
		_Utils_chr('ǆ'),
		'dz'),
		_Utils_Tuple2(
		_Utils_chr('e'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ⓔ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ｅ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('è'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('é'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ê'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ề'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ế'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ễ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ể'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ẽ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ē'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḕ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḗ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ĕ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ė'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ë'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ẻ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ě'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ȅ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ȇ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ẹ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ệ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ȩ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḝ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ę'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḙ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ḛ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ɇ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ɛ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('ǝ'),
		'e'),
		_Utils_Tuple2(
		_Utils_chr('f'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ⓕ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ｆ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ḟ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ƒ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('ꝼ'),
		'f'),
		_Utils_Tuple2(
		_Utils_chr('g'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ⓖ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ｇ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ǵ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ĝ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ḡ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ğ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ġ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ǧ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ģ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ǥ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ɠ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ꞡ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ᵹ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('ꝿ'),
		'g'),
		_Utils_Tuple2(
		_Utils_chr('h'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ⓗ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ｈ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ĥ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḣ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḧ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ȟ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḥ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḩ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ḫ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ẖ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ħ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ⱨ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ⱶ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ɥ'),
		'h'),
		_Utils_Tuple2(
		_Utils_chr('ƕ'),
		'hv'),
		_Utils_Tuple2(
		_Utils_chr('i'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ⓘ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ｉ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ì'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('í'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('î'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ĩ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ī'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ĭ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ï'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ḯ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ỉ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ǐ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ȉ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ȋ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ị'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('į'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ḭ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ɨ'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('ı'),
		'i'),
		_Utils_Tuple2(
		_Utils_chr('j'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ⓙ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ｊ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ĵ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ǰ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('ɉ'),
		'j'),
		_Utils_Tuple2(
		_Utils_chr('k'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ⓚ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ｋ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ḱ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ǩ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ḳ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ķ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ḵ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ƙ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ⱪ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꝁ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꝃ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꝅ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('ꞣ'),
		'k'),
		_Utils_Tuple2(
		_Utils_chr('l'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ⓛ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ｌ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ŀ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ĺ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ľ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḷ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḹ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ļ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḽ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ḻ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ſ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ł'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ƚ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ɫ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ⱡ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ꝉ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ꞁ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ꝇ'),
		'l'),
		_Utils_Tuple2(
		_Utils_chr('ǉ'),
		'lj'),
		_Utils_Tuple2(
		_Utils_chr('m'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ⓜ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ｍ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ḿ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ṁ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ṃ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ɱ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('ɯ'),
		'm'),
		_Utils_Tuple2(
		_Utils_chr('n'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ⓝ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ｎ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ǹ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ń'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ñ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṅ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ň'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṇ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ņ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṋ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ṉ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ƞ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ɲ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ŉ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ꞑ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ꞥ'),
		'n'),
		_Utils_Tuple2(
		_Utils_chr('ǌ'),
		'nj'),
		_Utils_Tuple2(
		_Utils_chr('o'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ⓞ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ｏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ò'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ó'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ô'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ồ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ố'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ỗ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ổ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('õ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṍ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȭ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ō'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṑ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ṓ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ŏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȯ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȱ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ö'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȫ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ỏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ő'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǒ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȍ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ȏ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ơ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ờ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ớ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ỡ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ở'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ợ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ọ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ộ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǫ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǭ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ø'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ǿ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ɔ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ꝋ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ꝍ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ɵ'),
		'o'),
		_Utils_Tuple2(
		_Utils_chr('ƣ'),
		'oi'),
		_Utils_Tuple2(
		_Utils_chr('ȣ'),
		'ou'),
		_Utils_Tuple2(
		_Utils_chr('ꝏ'),
		'oo'),
		_Utils_Tuple2(
		_Utils_chr('p'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ⓟ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ｐ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ṕ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ṗ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ƥ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ᵽ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ꝑ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ꝓ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('ꝕ'),
		'p'),
		_Utils_Tuple2(
		_Utils_chr('q'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ⓠ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ｑ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ɋ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ꝗ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('ꝙ'),
		'q'),
		_Utils_Tuple2(
		_Utils_chr('r'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ⓡ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ｒ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ŕ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṙ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ř'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ȑ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ȓ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṛ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṝ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ŗ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ṟ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ɍ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ɽ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ꝛ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ꞧ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('ꞃ'),
		'r'),
		_Utils_Tuple2(
		_Utils_chr('s'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ⓢ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ｓ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ß'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ś'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṥ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ŝ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṡ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('š'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṧ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṣ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ṩ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ș'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ş'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ȿ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ꞩ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ꞅ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('ẛ'),
		's'),
		_Utils_Tuple2(
		_Utils_chr('t'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ⓣ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ｔ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṫ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ẗ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ť'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṭ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ț'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ţ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṱ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ṯ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ŧ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ƭ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ʈ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ⱦ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ꞇ'),
		't'),
		_Utils_Tuple2(
		_Utils_chr('ꜩ'),
		'tz'),
		_Utils_Tuple2(
		_Utils_chr('u'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ⓤ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ｕ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ù'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ú'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('û'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ũ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṹ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ū'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṻ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ŭ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ü'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǜ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǘ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǖ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǚ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ủ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ů'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ű'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ǔ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ȕ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ȗ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ư'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ừ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ứ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ữ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ử'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ự'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ụ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṳ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ų'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṷ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ṵ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('ʉ'),
		'u'),
		_Utils_Tuple2(
		_Utils_chr('v'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ⓥ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ｖ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ṽ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ṿ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ʋ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ꝟ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ʌ'),
		'v'),
		_Utils_Tuple2(
		_Utils_chr('ꝡ'),
		'vy'),
		_Utils_Tuple2(
		_Utils_chr('w'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ⓦ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ｗ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẁ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẃ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ŵ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẇ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẅ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẘ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ẉ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('ⱳ'),
		'w'),
		_Utils_Tuple2(
		_Utils_chr('x'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ⓧ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ｘ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ẋ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('ẍ'),
		'x'),
		_Utils_Tuple2(
		_Utils_chr('y'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ⓨ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ｙ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỳ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ý'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ŷ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỹ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ȳ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ẏ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ÿ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỷ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ẙ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỵ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ƴ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ɏ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('ỿ'),
		'y'),
		_Utils_Tuple2(
		_Utils_chr('z'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ⓩ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ｚ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ź'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ẑ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ż'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ž'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ẓ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ẕ'),
		'z'),
		_Utils_Tuple2(
		_Utils_chr('ƶ'),
		'z')
	]);
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupTable = $elm$core$Dict$fromList($kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList);
var $kuon$elm_string_normalize$String$Normalize$removeDiacritics = function (str) {
	var replace = F2(
		function (c, result) {
			var _v0 = A2($elm$core$Dict$get, c, $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupTable);
			if (_v0.$ === 'Just') {
				var candidate = _v0.a;
				return _Utils_ap(result, candidate);
			} else {
				return _Utils_ap(
					result,
					$elm$core$String$fromChar(c));
			}
		});
	return A3($elm$core$String$foldl, replace, '', str);
};
var $author$project$PinMeTo$Common$StringNormalize$normalize = function (input) {
	return $kuon$elm_string_normalize$String$Normalize$removeDiacritics(
		$author$project$PinMeTo$Common$StringNormalize$translate(input));
};
var $author$project$PinMeTo$Common$StringNormalize$contains = F2(
	function (a, b) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(
				$author$project$PinMeTo$Common$StringNormalize$normalize(a)),
			$elm$core$String$toLower(
				$author$project$PinMeTo$Common$StringNormalize$normalize(b)));
	});
var $author$project$Data$LocationDetails$hasPhone = function (location) {
	var _v0 = location.contact;
	if (_v0.$ === 'Just') {
		var contact = _v0.a;
		return !$elm$core$String$isEmpty(contact.phone);
	} else {
		return false;
	}
};
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 'Text', a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {toAmPm: toAmPm, toMonthName: toMonthName, toWeekdayName: toWeekdayName, toOrdinalSuffix: toOrdinalSuffix, toMonthAbbreviation: toMonthAbbreviation, toWeekdayAbbreviation: toWeekdayAbbreviation};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.toAmPm(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var year = yearOfEra + (era * 400);
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		year: year + ((month <= 2) ? 1 : 0),
		month: month
	};
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).year;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Jan = {$: 'Jan'};
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[$elm$time$Time$Jan, $elm$time$Time$Feb, $elm$time$Time$Mar, $elm$time$Time$Apr, $elm$time$Time$May, $elm$time$Time$Jun, $elm$time$Time$Jul, $elm$time$Time$Aug, $elm$time$Time$Sep, $elm$time$Time$Oct, $elm$time$Time$Nov, $elm$time$Time$Dec]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, $elm$time$Time$Jan),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[$elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return $elm$time$Time$Thu;
			case 1:
				return $elm$time$Time$Fri;
			case 2:
				return $elm$time$Time$Sat;
			case 3:
				return $elm$time$Time$Sun;
			case 4:
				return $elm$time$Time$Mon;
			case 5:
				return $elm$time$Time$Tue;
			default:
				return $elm$time$Time$Wed;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, $elm$time$Time$Sun),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 'MonthNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthNameAbbreviated':
				return language.toMonthAbbreviation(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'MonthNameFull':
				return language.toMonthName(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'QuarterNumber':
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 'QuarterSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 'DayOfMonthNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfMonthSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfMonthFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfYearNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfYearSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfYearFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfWeekNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 'DayOfWeekSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 'DayOfWeekNameAbbreviated':
				return language.toWeekdayAbbreviation(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 'DayOfWeekNameFull':
				return language.toWeekdayName(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 'WeekOfYearNumber':
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 'WeekOfYearSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 'WeekOfYearFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 'YearNumberLastTwo':
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 'YearNumber':
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 'AmPmUppercase':
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 'AmPmLowercase':
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 'HourMilitaryNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 'HourMilitaryFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 'HourNumber':
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'HourFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'HourMilitaryFromOneNumber':
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'HourMilitaryFromOneFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'MinuteNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 'MinuteFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 'SecondNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 'SecondFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 'MillisecondNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 'MillisecondFixed':
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 'MonthFixed'};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 'YearNumber'};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 'DayOfMonthFixed'};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $author$project$Common$Date$dateShort = F2(
	function (zone, time) {
		return A3(
			$ryan_haskell$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$yearNumber,
					$ryan_haskell$date_format$DateFormat$text('-'),
					$ryan_haskell$date_format$DateFormat$monthFixed,
					$ryan_haskell$date_format$DateFormat$text('-'),
					$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
				]),
			zone,
			time);
	});
var $author$project$PinMeTo$Ui$Lightbox$withClose = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Lightbox$View(
			_Utils_update(
				config,
				{
					onClose: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$Selector$Standard = {$: 'Standard'};
var $author$project$PinMeTo$Ui$Selector$withColumn = F2(
	function (column, _v0) {
		var config = _v0.a;
		var column_ = {key: column.key, sort: $author$project$PinMeTo$Ui$Selector$Standard, toHtml: $elm$core$Maybe$Nothing, toString: column.toString};
		return $author$project$PinMeTo$Ui$Selector$View(
			_Utils_update(
				config,
				{
					columns: A2($elm$core$List$cons, column_, config.columns)
				}));
	});
var $author$project$PinMeTo$Ui$Lightbox$withFooter = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Lightbox$View(
			_Utils_update(
				config,
				{
					footer: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$Lightbox$withHeader = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Lightbox$View(
			_Utils_update(
				config,
				{
					header: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$Data$LocationDetails$hasValidFbId = function (location) {
	var fbStoreId = A2($elm$core$Maybe$withDefault, '', location.fbStoreId);
	return A2(
		$elm$core$String$all,
		function (c) {
			return $elm$core$Char$isAlphaNum(c) || _Utils_eq(
				c,
				_Utils_chr('-'));
		},
		fbStoreId) && ($elm$core$String$length(fbStoreId) > 0);
};
var $author$project$Data$LocationDetails$locationLink = F2(
	function (_v0, id) {
		var name = _v0.a;
		return '/listings/' + (name + ('/locations/' + id));
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$CloseLightBox = {$: 'CloseLightBox'};
var $author$project$Data$LocationDetails$phoneToString = function (location) {
	var _v0 = location.contact;
	if (_v0.$ === 'Just') {
		var c = _v0.a;
		return $elm$core$String$isEmpty(c.phone) ? '' : c.phone;
	} else {
		return '';
	}
};
var $author$project$PinMeTo$Ui$Lightbox$withFullHeight = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Lightbox$View(
		_Utils_update(
			config,
			{fullHeight: true}));
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$CreateLocations = function (a) {
	return {$: 'CreateLocations', a: a};
};
var $author$project$Labels$selectorEnglish = F2(
	function (item, itemPlural) {
		return {
			item: item,
			nItems: function (count) {
				return (count === 1) ? ($elm$core$String$fromInt(count) + (' ' + item)) : ($elm$core$String$fromInt(count) + (' ' + itemPlural));
			},
			viewMore: F2(
				function (count, total) {
					return 'View more (' + ($elm$core$String$fromInt(count) + (' of ' + ($elm$core$String$fromInt(total) + ')')));
				}),
			itemPlural: itemPlural,
			searchItems: 'Search ' + itemPlural,
			invalidItems: 'Invalid ' + itemPlural,
			unselectable: 'Unselectable',
			selectedItems: 'Selected ' + itemPlural,
			errorFetchingItems: 'Something went wrong'
		};
	});
var $author$project$Common$Util$stopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: false, stopPropagation: true}));
};
var $author$project$PinMeTo$Ui$Selector$withDisabledItems = F2(
	function (disabledItems, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Selector$View(
			_Utils_update(
				config,
				{
					disabledItems: $elm$core$Maybe$Just(disabledItems)
				}));
	});
var $author$project$PinMeTo$Ui$Btn$pmtBtn = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--default');
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === 'RBEmpty_elm_builtin') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$PinMeTo$Ui$Btn$pmtBtnSecondary = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--default pmt-btn--brand-2');
var $author$project$PinMeTo$Ui$Selector$renderCreateAction = F2(
	function (config, _v0) {
		var model = _v0.a;
		var createSelectedButton = A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					$elm$core$Set$isEmpty(model.selected)),
					$elm$html$Html$Events$onClick(
					config.onSelect(
						$elm$core$Set$toList(model.selected)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(config.labels.action)
				]));
		var cancelButton = A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtnSecondary,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(config.cancelMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(config.labels.cancel)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-btn-group')
				]),
			_List_fromArray(
				[cancelButton, createSelectedButton]));
	});
var $author$project$PinMeTo$Ui$Selector$withColumnRenderer = F2(
	function (column, _v0) {
		var config = _v0.a;
		var column_ = {
			key: column.key,
			sort: $author$project$PinMeTo$Ui$Selector$Standard,
			toHtml: $elm$core$Maybe$Just(column.toHtml),
			toString: column.toString
		};
		return $author$project$PinMeTo$Ui$Selector$View(
			_Utils_update(
				config,
				{
					columns: A2($elm$core$List$cons, column_, config.columns)
				}));
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$RemoveResponseBanner = {$: 'RemoveResponseBanner'};
var $author$project$Tasks$Facebook$ReviewAndCreate$View$view = function (model) {
	var _v0 = model.uiSelector;
	if (_v0.$ === 'Just') {
		var selector = _v0.a;
		var errorWrapper = function (message) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-table-list__cell-warning')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fa-solid fa-triangle-exclamation')
							]),
						_List_Nil),
						$elm$html$Html$text(''),
						$elm$html$Html$text(message)
					]));
		};
		var viewBanner = F2(
			function (cls, message) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('status-bar status-bar--symbol', true),
											_Utils_Tuple2(cls, true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-bar__message')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-bar__dismiss'),
											$elm$html$Html$Events$onClick($author$project$Tasks$Facebook$ReviewAndCreate$Model$RemoveResponseBanner)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						]));
			});
		var withLink = F3(
			function (id, item, err) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('util__color--error', err)
								])),
							$author$project$Common$Util$stopPropagation($author$project$Tasks$Facebook$ReviewAndCreate$Model$NoOp),
							$elm$html$Html$Attributes$href(
							A2($author$project$Data$LocationDetails$locationLink, model.siteName, id)),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('pmt-ui-table__row--link')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(item)
						]));
			});
		var locationList = A2(
			$author$project$PinMeTo$Ui$Selector$render,
			selector,
			A2(
				$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
				{
					key: 'Error',
					toHtml: function (location) {
						if (!$author$project$Data$LocationDetails$hasValidFbId(location)) {
							return errorWrapper('FB ID only accepts numbers, letters and dashes');
						} else {
							if (!$author$project$Data$LocationDetails$hasPhone(location)) {
								return errorWrapper('Missing Phone Number');
							} else {
								var _v4 = A2($elm$core$Dict$get, location.id, model.idsWithError);
								if (_v4.$ === 'Just') {
									var e = _v4.a;
									return errorWrapper(e);
								} else {
									return $elm$html$Html$text('');
								}
							}
						}
					},
					toString: function (_v5) {
						return '';
					}
				},
				A2(
					$author$project$PinMeTo$Ui$Selector$withColumn,
					{
						key: 'Claim Status',
						toString: function (location) {
							return location.claimStatus ? 'Claim issues' : '';
						}
					},
					A2(
						$author$project$PinMeTo$Ui$Selector$withColumn,
						{
							key: 'Country',
							toString: function (location) {
								return location.address.country;
							}
						},
						A2(
							$author$project$PinMeTo$Ui$Selector$withColumn,
							{
								key: 'City',
								toString: function (location) {
									return location.address.city;
								}
							},
							A2(
								$author$project$PinMeTo$Ui$Selector$withColumn,
								{
									key: 'Zip',
									toString: function (location) {
										return location.address.zip;
									}
								},
								A2(
									$author$project$PinMeTo$Ui$Selector$withColumn,
									{
										key: 'Street',
										toString: function (location) {
											return location.address.street;
										}
									},
									A2(
										$author$project$PinMeTo$Ui$Selector$withColumn,
										{
											key: 'Created date',
											toString: function (location) {
												return A2($author$project$Common$Date$dateShort, $elm$time$Time$utc, location.created);
											}
										},
										A2(
											$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
											{
												key: 'Location Descriptor',
												toHtml: function (location) {
													return A3(withLink, location.id, location.locationDescriptor, false);
												},
												toString: function ($) {
													return $.locationDescriptor;
												}
											},
											A2(
												$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
												{
													key: 'Phone',
													toHtml: function (location) {
														var phone = $author$project$Data$LocationDetails$phoneToString(location);
														return A3(
															withLink,
															location.id,
															$elm$core$String$isEmpty(phone) ? 'Add Number' : phone,
															$elm$core$String$isEmpty(phone));
													},
													toString: function (location) {
														return $author$project$Data$LocationDetails$phoneToString(location);
													}
												},
												A2(
													$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
													{
														key: 'FB ID',
														toHtml: function (location) {
															return A3(
																withLink,
																location.id,
																A2($elm$core$Maybe$withDefault, '', location.fbStoreId),
																!$author$project$Data$LocationDetails$hasValidFbId(location));
														},
														toString: function (location) {
															return A2($elm$core$Maybe$withDefault, '', location.fbStoreId);
														}
													},
													A2(
														$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
														{
															key: 'Store ID',
															toHtml: function (location) {
																return A3(withLink, location.id, location.storeId, false);
															},
															toString: function ($) {
																return $.storeId;
															}
														},
														A2(
															$author$project$PinMeTo$Ui$Selector$withDisabledItems,
															{
																disableBy: function (location) {
																	return (!$author$project$Data$LocationDetails$hasPhone(location)) || (!$author$project$Data$LocationDetails$hasValidFbId(location));
																}
															},
															$author$project$PinMeTo$Ui$Selector$view(
																{
																	labels: A2($author$project$Labels$selectorEnglish, 'Location', 'Locations'),
																	search: F2(
																		function (query, item) {
																			return A2(
																				$elm$core$List$any,
																				$author$project$PinMeTo$Common$StringNormalize$contains(query),
																				A2(
																					$elm$core$List$map,
																					$elm$core$String$toLower,
																					_List_fromArray(
																						[
																							item.storeId,
																							item.name,
																							item.locationDescriptor,
																							item.address.street,
																							item.address.city,
																							item.address.zip,
																							item.address.country,
																							A2($author$project$Common$Date$dateShort, $elm$time$Time$utc, item.created),
																							item.claimStatus ? 'Claim Issues' : ''
																						])));
																		}),
																	tagger: $author$project$Tasks$Facebook$ReviewAndCreate$Model$UiSelectorMsg,
																	idToString: function (item) {
																		return item.id;
																	}
																}))))))))))))));
		var banner = function () {
			var _v3 = model.resultBanner;
			switch (_v3.$) {
				case 'Loaded':
					return A2(viewBanner, 'status-bar--success', 'Created locations.');
				case 'Error':
					var errorMessage = _v3.a;
					return A2(viewBanner, 'status-bar--danger', errorMessage);
				default:
					return $elm$html$Html$text('');
			}
		}();
		return $author$project$PinMeTo$Ui$Lightbox$render(
			$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					function () {
						var _v2 = model.uiSelector;
						if (_v2.$ === 'Just') {
							var s = _v2.a;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$PinMeTo$Ui$Selector$renderCreateAction,
										{
											labels: {action: 'Create Selected', cancel: 'Cancel'},
											onSelect: function (selected) {
												return $author$project$Tasks$Facebook$ReviewAndCreate$Model$CreateLocations(selected);
											},
											cancelMsg: $author$project$Tasks$Facebook$ReviewAndCreate$Model$CloseLightBox
										},
										s)
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withClose,
						$author$project$Tasks$Facebook$ReviewAndCreate$Model$CloseLightBox,
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withHeader,
							banner,
							$author$project$PinMeTo$Ui$Lightbox$view(
								{
									title: 'Create locations on Facebook',
									content: function () {
										var _v1 = model.resultBanner;
										if (_v1.$ === 'Loading') {
											return $author$project$PinMeTo$Ui$Spinner$spinner;
										} else {
											return locationList;
										}
									}()
								}))))));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $lukewestby$elm_http_builder$HttpBuilder$post = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('POST');
var $author$project$PinMeTo$ExpectJson$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $author$project$PinMeTo$ExpectJson$Timeout = {$: 'Timeout'};
var $author$project$PinMeTo$ExpectJson$BadStatus = F3(
	function (a, b, c) {
		return {$: 'BadStatus', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$ExpectJson$ErrorMessage = function (a) {
	return {$: 'ErrorMessage', a: a};
};
var $author$project$PinMeTo$ExpectJson$NetworkError = {$: 'NetworkError'};
var $author$project$PinMeTo$ExpectJson$HttpErrorResult = F2(
	function (message, details) {
		return {details: details, message: message};
	});
var $author$project$PinMeTo$ExpectJson$ClientDecodeError = function (a) {
	return {$: 'ClientDecodeError', a: a};
};
var $author$project$PinMeTo$ExpectJson$handleResponse = F3(
	function (decode, jsonDecodeError, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					A2(
						$author$project$PinMeTo$ExpectJson$HttpErrorResult,
						$author$project$PinMeTo$ExpectJson$ErrorMessage('This is not the url you are looking for'),
						$author$project$PinMeTo$ExpectJson$BadUrl(url)));
			case 'Timeout_':
				return $elm$core$Result$Err(
					A2(
						$author$project$PinMeTo$ExpectJson$HttpErrorResult,
						$author$project$PinMeTo$ExpectJson$ErrorMessage('The server took too long time to respond, giving up.'),
						$author$project$PinMeTo$ExpectJson$Timeout));
			case 'NetworkError_':
				return $elm$core$Result$Err(
					A2(
						$author$project$PinMeTo$ExpectJson$HttpErrorResult,
						$author$project$PinMeTo$ExpectJson$ErrorMessage('There was a network error. I suggest you reload the page.'),
						$author$project$PinMeTo$ExpectJson$NetworkError));
			case 'BadStatus_':
				var metadata = response.a;
				var body = response.b;
				var obj = A2($elm$json$Json$Decode$decodeString, jsonDecodeError, body);
				return $elm$core$Result$Err(
					A2(
						$author$project$PinMeTo$ExpectJson$HttpErrorResult,
						$author$project$PinMeTo$ExpectJson$ErrorMessage(
							body + (' (' + ($elm$core$String$fromInt(metadata.statusCode) + ')'))),
						A3($author$project$PinMeTo$ExpectJson$BadStatus, metadata.statusCode, body, obj)));
			default:
				var body = response.b;
				var _v1 = decode(body);
				if (_v1.$ === 'Ok') {
					var value = _v1.a;
					return $elm$core$Result$Ok(value);
				} else {
					var err = _v1.a;
					return $elm$core$Result$Err(
						A2(
							$author$project$PinMeTo$ExpectJson$HttpErrorResult,
							$author$project$PinMeTo$ExpectJson$ErrorMessage('The shape of the data returned was unexpected. The developers have been notified of this.'),
							$author$project$PinMeTo$ExpectJson$ClientDecodeError(
								$elm$json$Json$Decode$errorToString(err))));
				}
		}
	});
var $author$project$PinMeTo$ExpectJson$expectJson = F3(
	function (toMsg, jsonDecoder, jsonDecodeError) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			A2(
				$author$project$PinMeTo$ExpectJson$handleResponse,
				function (s) {
					return A2($elm$json$Json$Decode$decodeString, jsonDecoder, s);
				},
				jsonDecodeError));
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $lukewestby$elm_http_builder$HttpBuilder$withBody = F2(
	function (body, builder) {
		return _Utils_update(
			builder,
			{body: body});
	});
var $lukewestby$elm_http_builder$HttpBuilder$withJsonBody = function (value) {
	return $lukewestby$elm_http_builder$HttpBuilder$withBody(
		$elm$http$Http$jsonBody(value));
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$CreateLocationsResponse = function (a) {
	return {$: 'CreateLocationsResponse', a: a};
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$LocationResult = F3(
	function (success, locationId, errorMessage) {
		return {success: success, locationId: locationId, errorMessage: errorMessage};
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$createLocationResultDecoder = function () {
	var locationResultDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['error', 'message']),
		$elm$json$Json$Decode$string,
		'An error occurred',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'success',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Tasks$Facebook$ReviewAndCreate$Model$LocationResult))));
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$values,
		$elm$json$Json$Decode$dict(locationResultDecoder));
}();
var $author$project$Tasks$Facebook$ReviewAndCreate$Commands$createLocations = F2(
	function (_v0, selectedPlaces) {
		var siteName = _v0.a;
		var selectedPlacesJson = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'places',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, selectedPlaces))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, $author$project$Tasks$Facebook$ReviewAndCreate$Model$CreateLocationsResponse, $author$project$Tasks$Facebook$ReviewAndCreate$Model$createLocationResultDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					selectedPlacesJson,
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/place/facebook')))));
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$SelectionChanged = function (a) {
	return {$: 'SelectionChanged', a: a};
};
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0.a;
		var dict2 = _v1.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$diff, dict1, dict2));
	});
var $author$project$PinMeTo$Ui$Selector$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$PinMeTo$Ui$Selector$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A2($elm$core$Dict$remove, key, dict));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$PinMeTo$Ui$Table$sliceItems = F3(
	function (start, end, items) {
		return _Utils_eq(end, start) ? A2(
			$elm$core$List$drop,
			start,
			A2($elm$core$List$take, start + 1, items)) : ((_Utils_cmp(end, start) > 0) ? A2(
			$elm$core$List$drop,
			start,
			A2($elm$core$List$take, end + 1, items)) : A2(
			$elm$core$List$drop,
			end,
			A2($elm$core$List$take, start + 1, items)));
	});
var $author$project$PinMeTo$Ui$Table$update = F2(
	function (msg, state) {
		var _v0 = state;
		var model = _v0.a;
		switch (msg.$) {
			case 'ToggleSort':
				var sort = msg.a;
				var index = msg.b;
				if (sort.$ === 'Asc') {
					var n = sort.a;
					return _Utils_eq(n, index) ? $author$project$PinMeTo$Ui$Table$State(
						_Utils_update(
							model,
							{
								sort: $elm$core$Maybe$Just(
									$author$project$PinMeTo$Ui$Table$Desc(n))
							})) : $author$project$PinMeTo$Ui$Table$State(
						_Utils_update(
							model,
							{
								sort: $elm$core$Maybe$Just(
									$author$project$PinMeTo$Ui$Table$Asc(index))
							}));
				} else {
					var n = sort.a;
					return _Utils_eq(n, index) ? $author$project$PinMeTo$Ui$Table$State(
						_Utils_update(
							model,
							{
								sort: $elm$core$Maybe$Just(
									$author$project$PinMeTo$Ui$Table$Asc(n))
							})) : $author$project$PinMeTo$Ui$Table$State(
						_Utils_update(
							model,
							{
								sort: $elm$core$Maybe$Just(
									$author$project$PinMeTo$Ui$Table$Asc(index))
							}));
				}
			case 'Select':
				var x = msg.a;
				var index = msg.b;
				var newModel = A2($elm$core$Set$member, x, model.deselected) ? $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{
							selected: A2($elm$core$Set$insert, x, model.selected),
							deselected: A2($elm$core$Set$remove, x, model.deselected),
							lastSelectedIndex: $elm$core$Maybe$Just(index)
						})) : $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{
							selected: A2($elm$core$Set$insert, x, model.selected),
							lastSelectedIndex: $elm$core$Maybe$Just(index)
						}));
				return newModel;
			case 'Deselect':
				var x = msg.a;
				var index = msg.b;
				return $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{
							selected: A2($elm$core$Set$remove, x, model.selected),
							deselected: A2($elm$core$Set$insert, x, model.deselected),
							lastSelectedIndex: $elm$core$Maybe$Just(index)
						}));
			case 'MultiSelect':
				var items = msg.a;
				var index = msg.b;
				var previouslyClickedItemIndex = A2($elm$core$Maybe$withDefault, index, model.lastSelectedIndex);
				var itemIdsDiff = $elm$core$Set$fromList(
					A3($author$project$PinMeTo$Ui$Table$sliceItems, index, previouslyClickedItemIndex, items));
				var deselected = A2($elm$core$Set$diff, model.deselected, itemIdsDiff);
				var selected = A2($elm$core$Set$union, model.selected, itemIdsDiff);
				return $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{
							selected: selected,
							deselected: deselected,
							lastSelectedIndex: $elm$core$Maybe$Just(index)
						}));
			case 'MultiDeselect':
				var items = msg.a;
				var index = msg.b;
				var previouslyClickedItemIndex = A2($elm$core$Maybe$withDefault, index, model.lastSelectedIndex);
				var itemIdsDiff = $elm$core$Set$fromList(
					A3($author$project$PinMeTo$Ui$Table$sliceItems, index, previouslyClickedItemIndex, items));
				var deselected = A2($elm$core$Set$union, model.deselected, itemIdsDiff);
				var selected = A2($elm$core$Set$diff, model.selected, itemIdsDiff);
				return $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{
							selected: selected,
							deselected: deselected,
							lastSelectedIndex: $elm$core$Maybe$Just(index)
						}));
			case 'AddMore':
				var limit = msg.a;
				var newLimit = A2(
					$elm$core$Maybe$withDefault,
					limit * 2,
					A2(
						$elm$core$Maybe$map,
						function (oldLimit) {
							return oldLimit + limit;
						},
						model.limit));
				return $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{
							limit: $elm$core$Maybe$Just(newLimit)
						}));
			case 'ToggleSelectAll':
				var ids = msg.a;
				var selected = A2(
					$elm$core$List$filter,
					function (x) {
						return A2($elm$core$Set$member, x, model.selected);
					},
					ids);
				var deselected = _Utils_eq(
					$elm$core$List$length(selected),
					$elm$core$List$length(ids)) ? model.selected : $elm$core$Set$empty;
				var newSelected = _Utils_eq(
					$elm$core$List$length(selected),
					$elm$core$List$length(ids)) ? A2(
					$elm$core$Set$diff,
					model.selected,
					$elm$core$Set$fromList(ids)) : A2(
					$elm$core$Set$union,
					model.selected,
					$elm$core$Set$fromList(ids));
				return $author$project$PinMeTo$Ui$Table$State(
					_Utils_update(
						model,
						{selected: newSelected, deselected: deselected}));
			case 'OnKeyDown':
				var key = msg.a;
				if (key.$ === 'Shift') {
					return $author$project$PinMeTo$Ui$Table$State(
						_Utils_update(
							model,
							{shiftHeld: true}));
				} else {
					return state;
				}
			default:
				var key = msg.a;
				if (key.$ === 'Shift') {
					return $author$project$PinMeTo$Ui$Table$State(
						_Utils_update(
							model,
							{shiftHeld: false}));
				} else {
					return state;
				}
		}
	});
var $author$project$PinMeTo$Ui$Selector$onChange = F2(
	function (options, _v0) {
		var model = _v0.a;
		var _v1 = options.onChange;
		if (_v1.$ === 'Just') {
			var onChange_ = _v1.a;
			return _Utils_Tuple2(
				$author$project$PinMeTo$Ui$Selector$State(model),
				A2(
					$elm$core$Task$perform,
					function (_v2) {
						return onChange_(
							$elm$core$Set$toList(model.selected));
					},
					$elm$core$Task$succeed(_Utils_Tuple0)));
		} else {
			return _Utils_Tuple2(
				$author$project$PinMeTo$Ui$Selector$State(model),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Ui$Selector$ErrorFetchingItems = {$: 'ErrorFetchingItems'};
var $author$project$PinMeTo$Ui$Selector$updateWithOptions = F3(
	function (options, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'OnSelectItem':
				var id = msg.a;
				return A2($elm$core$Set$member, id, model.selected) ? A2(
					$author$project$PinMeTo$Ui$Selector$onChange,
					options,
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{
								selected: A2($elm$core$Set$remove, id, model.selected),
								deselected: A2($elm$core$Set$insert, id, model.deselected)
							}))) : A2(
					$author$project$PinMeTo$Ui$Selector$onChange,
					options,
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{
								selected: A2($elm$core$Set$insert, id, model.selected)
							})));
			case 'SelectItems':
				var ids = msg.a;
				return A2(
					$author$project$PinMeTo$Ui$Selector$onChange,
					options,
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{
								selected: A2($elm$core$Set$union, ids, model.selected)
							})));
			case 'DeselectItems':
				var ids = msg.a;
				return A2(
					$author$project$PinMeTo$Ui$Selector$onChange,
					options,
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{
								selected: A2($elm$core$Set$diff, ids, model.selected),
								deselected: ids
							})));
			case 'ReceivedItems':
				if (msg.a.$ === 'Ok') {
					var items = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$Selector$State(
							_Utils_update(
								model,
								{
									items: $author$project$PinMeTo$Ui$Selector$Loaded(items)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$Selector$State(
							_Utils_update(
								model,
								{
									items: $author$project$PinMeTo$Ui$Selector$Error($author$project$PinMeTo$Ui$Selector$ErrorFetchingItems)
								})),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: error, context: 'PiMeTo.Ui.Selector', message: 'PiMeTo.Ui.Selector received bad data'}));
				}
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{
								uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
							})),
					$elm$core$Platform$Cmd$none);
			case 'SetActiveTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{currentTab: tab, deselected: $elm$core$Set$empty})),
					$elm$core$Platform$Cmd$none);
			default:
				var query = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Selector$State(
						_Utils_update(
							model,
							{searchQuery: query})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Update$removeResponseBanner = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{resultBanner: $author$project$RemoteData$Suspended}),
		$elm$core$Platform$Cmd$none);
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$PinMeTo$Common$Util$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time)));
	});
var $author$project$Util$delay = $author$project$PinMeTo$Common$Util$delay;
var $author$project$PinMeTo$Ui$Selector$getAllItems = function (state) {
	var s = state.a;
	var _v1 = s.items;
	if (_v1.$ === 'Loaded') {
		var items = _v1.a;
		return items.data;
	} else {
		return _List_Nil;
	}
};
var $author$project$PinMeTo$Ui$Selector$selectedItems = function (_v0) {
	var model = _v0.a;
	return $elm$core$Set$toList(model.selected);
};
var $author$project$PinMeTo$ExpectJson$getErrorMessage = function (_v0) {
	var message = _v0.message;
	var x = message.a;
	return x;
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Update$createLocationsResponse = F2(
	function (result_, model) {
		var _v0 = function () {
			var _v1 = model.uiSelector;
			if (_v1.$ === 'Just') {
				var sel = _v1.a;
				return A2(
					$author$project$PinMeTo$Ui$Selector$initWithSelected,
					$author$project$PinMeTo$Ui$Selector$selectedItems(sel),
					$author$project$Tasks$Facebook$ReviewAndCreate$Update$getLocationDetails(model.siteName));
			} else {
				return $author$project$PinMeTo$Ui$Selector$init(
					$author$project$Tasks$Facebook$ReviewAndCreate$Update$getLocationDetails(model.siteName));
			}
		}();
		var selectorState = _v0.a;
		var selectorCmd = _v0.b;
		var doCmd = A2($elm$core$Platform$Cmd$map, $author$project$Tasks$Facebook$ReviewAndCreate$Model$UiSelectorMsg, selectorCmd);
		if (result_.$ === 'Ok') {
			var result = result_.a;
			var newIdsWithError = $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (l) {
						return _Utils_Tuple2(l.locationId, l.errorMessage);
					},
					A2(
						$elm$core$List$filter,
						function (l) {
							return !l.success;
						},
						result)));
			var banner = function () {
				var _v3 = $elm$core$Dict$size(newIdsWithError);
				switch (_v3) {
					case 0:
						return $author$project$RemoteData$Loaded(_Utils_Tuple0);
					case 1:
						return $author$project$RemoteData$Error('An error occurred when trying to create one of the locations.');
					default:
						return $author$project$RemoteData$Error('An error occurred on multiple locations when trying to create them.');
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						uiSelector: $elm$core$Maybe$Just(selectorState),
						idsWithError: newIdsWithError,
						resultBanner: banner
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Util$delay, 5000, $author$project$Tasks$Facebook$ReviewAndCreate$Model$RemoveResponseBanner),
							doCmd
						])));
		} else {
			var e = result_.a;
			var selectedIds = function () {
				var _v5 = model.uiSelector;
				if (_v5.$ === 'Just') {
					var selector = _v5.a;
					return $author$project$PinMeTo$Ui$Selector$selectedItems(selector);
				} else {
					return _List_Nil;
				}
			}();
			var items = function () {
				var _v4 = model.uiSelector;
				if (_v4.$ === 'Just') {
					var s = _v4.a;
					return $author$project$PinMeTo$Ui$Selector$getAllItems(s);
				} else {
					return _List_Nil;
				}
			}();
			var newIdsWithError = $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (l) {
						return _Utils_Tuple2(l.id, 'Failed to create location');
					},
					A2(
						$elm$core$List$filter,
						function (l) {
							return A2($elm$core$List$member, l.id, selectedIds);
						},
						items)));
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						uiSelector: $elm$core$Maybe$Just(selectorState),
						idsWithError: newIdsWithError,
						resultBanner: $author$project$RemoteData$Error(
							$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
					}),
				doCmd);
		}
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Update$update = F3(
	function (closeLightBox, msg, model) {
		switch (msg.$) {
			case 'HandleFlags':
				var flagsValue = msg.a;
				return A2(
					$author$project$Tasks$Facebook$ReviewAndCreate$Update$init,
					function (x) {
						return _Utils_update(
							x,
							{resultBanner: $author$project$RemoteData$Suspended});
					},
					flagsValue);
			case 'RemoveResponseBanner':
				return $author$project$Tasks$Facebook$ReviewAndCreate$Update$removeResponseBanner(model);
			case 'CloseLightBox':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiSelector: $elm$core$Maybe$Nothing}),
					closeLightBox(_Utils_Tuple0));
			case 'CreateLocations':
				var selectedPlaces = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{idsWithError: $elm$core$Dict$empty, resultBanner: $author$project$RemoteData$Loading}),
					A2($author$project$Tasks$Facebook$ReviewAndCreate$Commands$createLocations, model.siteName, selectedPlaces));
			case 'CreateLocationsResponse':
				var result = msg.a;
				return A2($author$project$Tasks$Facebook$ReviewAndCreate$Update$createLocationsResponse, result, model);
			case 'UiSelectorMsg':
				var msg_ = msg.a;
				var _v1 = model.uiSelector;
				if (_v1.$ === 'Just') {
					var selector = _v1.a;
					var _v2 = A3(
						$author$project$PinMeTo$Ui$Selector$updateWithOptions,
						{
							onChange: $elm$core$Maybe$Just($author$project$Tasks$Facebook$ReviewAndCreate$Model$SelectionChanged)
						},
						msg_,
						selector);
					var state = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uiSelector: $elm$core$Maybe$Just(state)
							}),
						cmd);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'SelectionChanged':
				var _v3 = model.uiSelector;
				if (_v3.$ === 'Just') {
					var selector = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uiSelector: $elm$core$Maybe$Just(selector)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Model$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Tasks$Facebook$ReviewAndCreate$Main$in_Tasks_Facebook_ReviewAndCreate_Main_argsChanged = _Platform_incomingPort('in_Tasks_Facebook_ReviewAndCreate_Main_argsChanged', $elm$json$Json$Decode$value);
var $author$project$Tasks$Facebook$ReviewAndCreate$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Tasks$Facebook$ReviewAndCreate$Main$in_Tasks_Facebook_ReviewAndCreate_Main_argsChanged($author$project$Tasks$Facebook$ReviewAndCreate$Model$HandleFlags)
			]));
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Tasks$Facebook$ReviewAndCreate$Main$out_Tasks_Facebook_ReviewAndCreate_Main_close = _Platform_outgoingPort(
	'out_Tasks_Facebook_ReviewAndCreate_Main_close',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Tasks$Facebook$ReviewAndCreate$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Facebook$ReviewAndCreate$Update$init($elm$core$Basics$identity),
		view: $author$project$Tasks$Facebook$ReviewAndCreate$View$view,
		update: $author$project$Tasks$Facebook$ReviewAndCreate$Update$update($author$project$Tasks$Facebook$ReviewAndCreate$Main$out_Tasks_Facebook_ReviewAndCreate_Main_close),
		subscriptions: $author$project$Tasks$Facebook$ReviewAndCreate$Main$subscriptions
	});
var $author$project$Directories$Common$SiteName$SiteName = function (a) {
	return {$: 'SiteName', a: a};
};
var $author$project$Directories$NetworkListDetail$Command$Flags = F5(
	function (siteName, network, user, translations, language) {
		return {user: user, network: network, language: language, siteName: siteName, translations: translations};
	});
var $author$project$PinMeTo$Ui$I18n$Language$En = {$: 'En'};
var $author$project$PinMeTo$Ui$I18n$Language$De = {$: 'De'};
var $author$project$PinMeTo$Ui$I18n$Language$Es = {$: 'Es'};
var $author$project$PinMeTo$Ui$I18n$Language$Fi = {$: 'Fi'};
var $author$project$PinMeTo$Ui$I18n$Language$Fr = {$: 'Fr'};
var $author$project$PinMeTo$Ui$I18n$Language$Pl = {$: 'Pl'};
var $author$project$PinMeTo$Ui$I18n$Language$Pt = {$: 'Pt'};
var $author$project$PinMeTo$Ui$I18n$Language$Sv = {$: 'Sv'};
var $author$project$PinMeTo$Ui$I18n$Language$fromString = function (x) {
	switch (x) {
		case 'en':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$En);
		case 'fr':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$Fr);
		case 'de':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$De);
		case 'es':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$Es);
		case 'sv':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$Sv);
		case 'fi':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$Fi);
		case 'pl':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$Pl);
		case 'pt':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Language$Pt);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Ui$I18n$Language$decoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$author$project$PinMeTo$Ui$I18n$Language$fromString,
		$elm$core$Maybe$withDefault($author$project$PinMeTo$Ui$I18n$Language$En)),
	$elm$json$Json$Decode$string);
var $author$project$Data$User$User = F8(
	function (id, firstName, lastName, email, systemRoles, settings, localAccess, isDemo) {
		return {id: id, email: email, isDemo: isDemo, lastName: lastName, settings: settings, firstName: firstName, localAccess: localAccess, systemRoles: systemRoles};
	});
var $author$project$Data$User$UserId = function (a) {
	return {$: 'UserId', a: a};
};
var $author$project$PinMeTo$Common$Util$idDecoder = function (f) {
	return A2($elm$json$Json$Decode$map, f, $elm$json$Json$Decode$string);
};
var $author$project$Util$idDecoder = $author$project$PinMeTo$Common$Util$idDecoder;
var $author$project$Data$User$SystemRole = function (a) {
	return {$: 'SystemRole', a: a};
};
var $author$project$Data$User$ProfileImage = function (a) {
	return {$: 'ProfileImage', a: a};
};
var $author$project$Data$User$UserSettings = F3(
	function (locale, profileImage, locationListView) {
		return {locale: locale, profileImage: profileImage, locationListView: locationListView};
	});
var $author$project$Data$User$Permission = function (a) {
	return {$: 'Permission', a: a};
};
var $author$project$Data$User$LocalAccess = F2(
	function (roles, permissions) {
		return {roles: roles, permissions: permissions};
	});
var $elm_community$maybe_extra$Maybe$Extra$unpack = F3(
	function (_default, f, m) {
		if (m.$ === 'Nothing') {
			return _default(_Utils_Tuple0);
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Data$User$Owner = {$: 'Owner'};
var $author$project$Data$User$User_ = {$: 'User_'};
var $author$project$Data$User$Author = {$: 'Author'};
var $author$project$Data$User$Editor = {$: 'Editor'};
var $author$project$Data$User$Viewer = {$: 'Viewer'};
var $author$project$Data$User$Manager = {$: 'Manager'};
var $author$project$Data$User$PinMeTo = {$: 'PinMeTo'};
var $author$project$Data$User$Upsales = {$: 'Upsales'};
var $author$project$Data$User$ApiDeveloper = {$: 'ApiDeveloper'};
var $author$project$Data$User$CustomerSuccess = {$: 'CustomerSuccess'};
var $author$project$Data$User$PinMeToDeveloper = {$: 'PinMeToDeveloper'};
var $author$project$Data$User$stringToRoleMap = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('pinmeto', $author$project$Data$User$PinMeTo),
			_Utils_Tuple2('customersuccess', $author$project$Data$User$CustomerSuccess),
			_Utils_Tuple2('pinmetodeveloper', $author$project$Data$User$PinMeToDeveloper),
			_Utils_Tuple2('upsales', $author$project$Data$User$Upsales),
			_Utils_Tuple2('owner', $author$project$Data$User$Owner),
			_Utils_Tuple2('user', $author$project$Data$User$User_),
			_Utils_Tuple2('apideveloper', $author$project$Data$User$ApiDeveloper),
			_Utils_Tuple2('viewer', $author$project$Data$User$Viewer),
			_Utils_Tuple2('manager', $author$project$Data$User$Manager),
			_Utils_Tuple2('editor', $author$project$Data$User$Editor),
			_Utils_Tuple2('author', $author$project$Data$User$Author)
		]));
var $author$project$Data$User$roleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unpack,
			function (_v0) {
				return $elm$json$Json$Decode$fail('Unknown role \u0027' + (s + '\u0027.'));
			},
			function (x) {
				return $elm$json$Json$Decode$succeed(x);
			},
			A2($elm$core$Dict$get, s, $author$project$Data$User$stringToRoleMap));
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$User$localAccessDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'permissions',
	$elm$json$Json$Decode$list(
		$author$project$Util$idDecoder($author$project$Data$User$Permission)),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'roles',
		$elm$json$Json$Decode$list($author$project$Data$User$roleDecoder),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Data$User$LocalAccess)));
var $author$project$Data$User$userDecoder = function () {
	var settingsDecoder = function (profileImage) {
		var profileImage_ = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Maybe$Nothing,
			function (s) {
				return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Data$User$ProfileImage(s));
			},
			profileImage);
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'locationListView',
			$elm$json$Json$Decode$string,
			'list',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				profileImage_,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'locale',
					$elm$json$Json$Decode$string,
					'sv-SE',
					$elm$json$Json$Decode$succeed($author$project$Data$User$UserSettings))));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		function (profileImage) {
			return A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'isDemo',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'localAccess',
					$author$project$Data$User$localAccessDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'settings',
						settingsDecoder(profileImage),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'systemRoles',
							$elm$json$Json$Decode$list(
								$author$project$Util$idDecoder($author$project$Data$User$SystemRole)),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'lastName',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'firstName',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'_id',
											$author$project$Util$idDecoder($author$project$Data$User$UserId),
											$elm$json$Json$Decode$succeed($author$project$Data$User$User)))))))));
		},
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'profileImage', $elm$json$Json$Decode$string)));
}();
var $author$project$Directories$NetworkListDetail$Command$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$author$project$Data$User$userDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'network',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['user', 'selectedSite', 'name']),
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Directories$NetworkListDetail$Command$Flags))))));
var $author$project$Directories$NetworkListDetail$Command$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Directories$NetworkListDetail$Command$flagsDecoder, flags);
};
var $author$project$PinMeTo$Ui$Select$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$Select$init = $author$project$PinMeTo$Ui$Select$State(
	{isOpen: $elm$core$Maybe$Nothing, element: $elm$core$Maybe$Nothing, searchQuery: ''});
var $author$project$Data$User$emptyUser = {
	id: $author$project$Data$User$UserId(''),
	email: '',
	isDemo: false,
	lastName: '',
	settings: {locale: '', profileImage: $elm$core$Maybe$Nothing, locationListView: 'list'},
	firstName: '',
	localAccess: {roles: _List_Nil, permissions: _List_Nil},
	systemRoles: _List_Nil
};
var $ChristophP$elm_i18next$I18Next$initialTranslations = $ChristophP$elm_i18next$I18Next$Translations($elm$core$Dict$empty);
var $author$project$Common$Language$initialTranslationsFallback = $ChristophP$elm_i18next$I18Next$initialTranslations;
var $author$project$Directories$NetworkListDetail$Main$initialModel = {
	user: $author$project$Data$User$emptyUser,
	details: $author$project$RemoteData$Suspended,
	network: $elm$core$Maybe$Nothing,
	language: $author$project$PinMeTo$Ui$I18n$Language$En,
	selected: $elm$core$Maybe$Nothing,
	siteName: $author$project$Directories$Common$SiteName$SiteName(''),
	selectState: $author$project$PinMeTo$Ui$Select$init,
	translations: $author$project$Common$Language$initialTranslationsFallback
};
var $author$project$Directories$Common$Network$PTVNetwork = {$: 'PTVNetwork'};
var $author$project$Directories$Common$Network$BingNetwork = {$: 'BingNetwork'};
var $author$project$Directories$Common$Network$HereNetwork = {$: 'HereNetwork'};
var $author$project$Directories$Common$Network$WazeNetwork = {$: 'WazeNetwork'};
var $author$project$Directories$Common$Network$AppleNetwork = {$: 'AppleNetwork'};
var $author$project$Directories$Common$Network$BaiduNetwork = {$: 'BaiduNetwork'};
var $author$project$Directories$Common$Network$SeznamNetwork = {$: 'SeznamNetwork'};
var $author$project$Directories$Common$Network$TomTomNetwork = {$: 'TomTomNetwork'};
var $author$project$Directories$Common$Network$FactualNetwork = {$: 'FactualNetwork'};
var $author$project$Directories$Common$Network$FacebookNetwork = {$: 'FacebookNetwork'};
var $author$project$Directories$Common$Network$OvertureNetwork = {$: 'OvertureNetwork'};
var $author$project$Directories$Common$Network$InstagramNetwork = {$: 'InstagramNetwork'};
var $author$project$Directories$Common$Network$FoursquareNetwork = {$: 'FoursquareNetwork'};
var $author$project$Directories$Common$Network$GoogleMapsNetwork = {$: 'GoogleMapsNetwork'};
var $author$project$Directories$Common$Network$TrustpilotNetwork = {$: 'TrustpilotNetwork'};
var $author$project$Directories$Common$Network$EcoMovementNetwork = {$: 'EcoMovementNetwork'};
var $author$project$Directories$Common$Network$GoogleSearchNetwork = {$: 'GoogleSearchNetwork'};
var $author$project$Directories$Common$Network$GoogleMyBusinessNetwork = {$: 'GoogleMyBusinessNetwork'};
var $author$project$Directories$Common$Network$getNetworkName = function (name) {
	switch (name) {
		case 'apple':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$AppleNetwork);
		case 'baidu':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$BaiduNetwork);
		case 'bing':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$BingNetwork);
		case 'factual':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$FactualNetwork);
		case 'facebook':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$FacebookNetwork);
		case 'foursquare':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$FoursquareNetwork);
		case 'google':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$GoogleMyBusinessNetwork);
		case 'googlemaps':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$GoogleMapsNetwork);
		case 'googlesearch':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$GoogleSearchNetwork);
		case 'here':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$HereNetwork);
		case 'instagram':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$InstagramNetwork);
		case 'tomtom':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$TomTomNetwork);
		case 'trustpilot':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$TrustpilotNetwork);
		case 'waze':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$WazeNetwork);
		case 'seznam':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$SeznamNetwork);
		case 'ecoMovement':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$EcoMovementNetwork);
		case 'overture':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$OvertureNetwork);
		case 'ptv':
			return $elm$core$Maybe$Just($author$project$Directories$Common$Network$PTVNetwork);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Directories$NetworkListDetail$Model$NetworkConnection = F3(
	function (enabled, customerCanEnable, isConnected) {
		return {enabled: enabled, isConnected: isConnected, customerCanEnable: customerCanEnable};
	});
var $author$project$Directories$NetworkListDetail$Command$statusDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'isConnected',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'customerCanEnable',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enabled',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Directories$NetworkListDetail$Model$NetworkConnection))));
var $author$project$Directories$NetworkListDetail$Model$NetworkDetails = F6(
	function (totalLocations, publishedLocations, brandpages, isTwoWayConnection, parentUrl, status) {
		return {status: status, parentUrl: parentUrl, brandpages: brandpages, totalLocations: totalLocations, isTwoWayConnection: isTwoWayConnection, publishedLocations: publishedLocations};
	});
var $author$project$Directories$NetworkListDetail$Command$detailsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Directories$NetworkListDetail$Command$statusDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'parentUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'isTwoWayConnection',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'brandpages',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'publishedLocations',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'totalLocations',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Directories$NetworkListDetail$Model$NetworkDetails)))))));
var $author$project$PinMeTo$Ui$Icon$RegularColorGMB = {$: 'RegularColorGMB'};
var $author$project$PinMeTo$Ui$Icon$RegularColorPTV = {$: 'RegularColorPTV'};
var $author$project$PinMeTo$Ui$Icon$RegularColorBing = {$: 'RegularColorBing'};
var $author$project$PinMeTo$Ui$Icon$RegularColorHere = {$: 'RegularColorHere'};
var $author$project$PinMeTo$Ui$Icon$RegularColorWaze = {$: 'RegularColorWaze'};
var $author$project$PinMeTo$Ui$Icon$RegularColorApple = {$: 'RegularColorApple'};
var $author$project$PinMeTo$Ui$Icon$RegularColorBaidu = {$: 'RegularColorBaidu'};
var $author$project$PinMeTo$Ui$Icon$RegularColorSeznam = {$: 'RegularColorSeznam'};
var $author$project$PinMeTo$Ui$Icon$RegularColorTomTom = {$: 'RegularColorTomTom'};
var $author$project$PinMeTo$Ui$Icon$RegularColorFactual = {$: 'RegularColorFactual'};
var $author$project$PinMeTo$Ui$Icon$RegularColorFacebook = {$: 'RegularColorFacebook'};
var $author$project$PinMeTo$Ui$Icon$RegularColorOverture = {$: 'RegularColorOverture'};
var $author$project$PinMeTo$Ui$Icon$RegularColorInstagram = {$: 'RegularColorInstagram'};
var $author$project$PinMeTo$Ui$Icon$RegularColorFoursquare = {$: 'RegularColorFoursquare'};
var $author$project$PinMeTo$Ui$Icon$RegularColorGoogleMaps = {$: 'RegularColorGoogleMaps'};
var $author$project$PinMeTo$Ui$Icon$RegularColorTrustpilot = {$: 'RegularColorTrustpilot'};
var $author$project$PinMeTo$Ui$Icon$RegularColorEcoMovement = {$: 'RegularColorEcoMovement'};
var $author$project$PinMeTo$Ui$Icon$RegularColorGoogleSearch = {$: 'RegularColorGoogleSearch'};
var $author$project$Directories$Common$Network$networkFromName = function (name) {
	switch (name.$) {
		case 'AppleNetwork':
			return {
				key: 'apple',
				icon: $author$project$PinMeTo$Ui$Icon$RegularColorApple,
				name: 'Apple',
				networkLink: $elm$core$Maybe$Just(
					{link: 'https://businessconnect.apple.com/', name: 'Apple Business'})
			};
		case 'BaiduNetwork':
			return {key: 'baidu', icon: $author$project$PinMeTo$Ui$Icon$RegularColorBaidu, name: ' Baidu', networkLink: $elm$core$Maybe$Nothing};
		case 'BingNetwork':
			return {key: 'bing', icon: $author$project$PinMeTo$Ui$Icon$RegularColorBing, name: 'Bing', networkLink: $elm$core$Maybe$Nothing};
		case 'FactualNetwork':
			return {key: 'factual', icon: $author$project$PinMeTo$Ui$Icon$RegularColorFactual, name: 'Factual', networkLink: $elm$core$Maybe$Nothing};
		case 'FacebookNetwork':
			return {
				key: 'facebook',
				icon: $author$project$PinMeTo$Ui$Icon$RegularColorFacebook,
				name: 'Facebook',
				networkLink: $elm$core$Maybe$Just(
					{link: 'https://business.facebook.com/', name: 'Facebook Business Manager'})
			};
		case 'FoursquareNetwork':
			return {key: 'foursquare', icon: $author$project$PinMeTo$Ui$Icon$RegularColorFoursquare, name: 'Foursquare', networkLink: $elm$core$Maybe$Nothing};
		case 'GoogleMyBusinessNetwork':
			return {
				key: 'google',
				icon: $author$project$PinMeTo$Ui$Icon$RegularColorGMB,
				name: 'Google Business Profile',
				networkLink: $elm$core$Maybe$Just(
					{link: 'https://business.google.com/', name: 'Google Business Profile'})
			};
		case 'GoogleMapsNetwork':
			return {key: 'googlemaps', icon: $author$project$PinMeTo$Ui$Icon$RegularColorGoogleMaps, name: 'Google Maps', networkLink: $elm$core$Maybe$Nothing};
		case 'GoogleSearchNetwork':
			return {key: 'googlesearch', icon: $author$project$PinMeTo$Ui$Icon$RegularColorGoogleSearch, name: 'Google Search', networkLink: $elm$core$Maybe$Nothing};
		case 'HereNetwork':
			return {key: 'here', icon: $author$project$PinMeTo$Ui$Icon$RegularColorHere, name: 'Here', networkLink: $elm$core$Maybe$Nothing};
		case 'InstagramNetwork':
			return {key: 'instagram', icon: $author$project$PinMeTo$Ui$Icon$RegularColorInstagram, name: 'Instagram', networkLink: $elm$core$Maybe$Nothing};
		case 'OvertureNetwork':
			return {key: 'overture', icon: $author$project$PinMeTo$Ui$Icon$RegularColorOverture, name: 'Overture', networkLink: $elm$core$Maybe$Nothing};
		case 'TomTomNetwork':
			return {key: 'tomtom', icon: $author$project$PinMeTo$Ui$Icon$RegularColorTomTom, name: 'TomTom', networkLink: $elm$core$Maybe$Nothing};
		case 'TrustpilotNetwork':
			return {key: 'trustpilot', icon: $author$project$PinMeTo$Ui$Icon$RegularColorTrustpilot, name: 'Trustpilot', networkLink: $elm$core$Maybe$Nothing};
		case 'WazeNetwork':
			return {key: 'waze', icon: $author$project$PinMeTo$Ui$Icon$RegularColorWaze, name: 'Waze', networkLink: $elm$core$Maybe$Nothing};
		case 'SeznamNetwork':
			return {key: 'seznam', icon: $author$project$PinMeTo$Ui$Icon$RegularColorSeznam, name: 'Seznam', networkLink: $elm$core$Maybe$Nothing};
		case 'EcoMovementNetwork':
			return {key: 'ecoMovement', icon: $author$project$PinMeTo$Ui$Icon$RegularColorEcoMovement, name: 'Eco-Movement', networkLink: $elm$core$Maybe$Nothing};
		default:
			return {
				key: 'ptv',
				icon: $author$project$PinMeTo$Ui$Icon$RegularColorPTV,
				name: 'PTV',
				networkLink: $elm$core$Maybe$Just(
					{link: 'https://palvelutietovaranto.suomi.fi/', name: 'Palveluhallinta'})
			};
	}
};
var $author$project$Directories$Common$SiteName$siteNameToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Directories$NetworkListDetail$Model$GetNetworkDetails = function (a) {
	return {$: 'GetNetworkDetails', a: a};
};
var $author$project$Directories$NetworkListDetail$Command$getNetworkDetails = F2(
	function (siteName, networkName) {
		var siteName_ = $author$project$Directories$Common$SiteName$siteNameToString(siteName);
		var network = $author$project$Directories$Common$Network$networkFromName(networkName);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, $author$project$Directories$NetworkListDetail$Model$GetNetworkDetails, $author$project$Directories$NetworkListDetail$Command$detailsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName_ + ('/network/networkConnections/' + network.key)))));
	});
var $author$project$Directories$NetworkListDetail$Main$init = function (flags) {
	var _v0 = $author$project$Directories$NetworkListDetail$Command$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		var networkName = $author$project$Directories$Common$Network$getNetworkName(decoded.network);
		var siteName = $author$project$Directories$Common$SiteName$SiteName(decoded.siteName);
		if (networkName.$ === 'Just') {
			var x = networkName.a;
			return _Utils_Tuple2(
				_Utils_update(
					$author$project$Directories$NetworkListDetail$Main$initialModel,
					{
						user: decoded.user,
						network: $elm$core$Maybe$Just(x),
						language: decoded.language,
						siteName: siteName,
						translations: decoded.translations
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Directories$NetworkListDetail$Command$getNetworkDetails, siteName, x)
						])));
		} else {
			return _Utils_Tuple2($author$project$Directories$NetworkListDetail$Main$initialModel, $elm$core$Platform$Cmd$none);
		}
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$author$project$Directories$NetworkListDetail$Main$initialModel,
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Directories.NetworkListDetail.Main.Init',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Directories$NetworkListDetail$Main$errorView = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('There was an error loading the network details')
				]))
		]));
var $author$project$PinMeTo$Ui$Select$Uid = function (a) {
	return {$: 'Uid', a: a};
};
var $author$project$PinMeTo$Ui$Select$Default = function (a) {
	return {$: 'Default', a: a};
};
var $author$project$PinMeTo$Ui$Select$LegacyToggle = function (a) {
	return {$: 'LegacyToggle', a: a};
};
var $author$project$PinMeTo$Ui$Select$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$PinMeTo$Ui$Select$Normal = {$: 'Normal'};
var $author$project$PinMeTo$Ui$Select$defaultInset = {top: 75 + 3, left: 10, right: 10, bottom: 10};
var $author$project$PinMeTo$Ui$Select$configWithRenderer = F2(
	function (config, renderer) {
		return $author$project$PinMeTo$Ui$Select$Config(
			{uid: config.uid, inset: $author$project$PinMeTo$Ui$Select$defaultInset, items: config.items, footer: $elm$core$Maybe$Nothing, header: $elm$core$Maybe$Nothing, onOpen: $elm$core$Maybe$Nothing, search: $elm$core$Maybe$Nothing, styles: _List_Nil, tagger: config.tagger, toggle: config.toggle, disabled: false, renderer: renderer, toggleStyle: $author$project$PinMeTo$Ui$Select$Normal, withNoHeader: false, closeOnMouseOut: false, dataTestAttribute: $elm$core$Maybe$Nothing, maxDropdownHeight: $elm$core$Maybe$Nothing});
	});
var $author$project$PinMeTo$Ui$Select$view = function (config) {
	return A2(
		$author$project$PinMeTo$Ui$Select$configWithRenderer,
		{
			uid: $author$project$PinMeTo$Ui$Select$Uid(config.uid),
			items: config.items,
			tagger: config.tagger,
			toggle: $author$project$PinMeTo$Ui$Select$LegacyToggle(
				{label: config.label})
		},
		$author$project$PinMeTo$Ui$Select$Default(
			{render: config.itemRender, onChange: config.onChange}));
};
var $author$project$PinMeTo$Ui$Button$FA = function (a) {
	return {$: 'FA', a: a};
};
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$PinMeTo$Ui$Select$OnKey = function (a) {
	return {$: 'OnKey', a: a};
};
var $author$project$PinMeTo$Ui$Select$isOpen = F2(
	function (uid, model) {
		return _Utils_eq(
			model.isOpen,
			$elm$core$Maybe$Just(uid));
	});
var $author$project$PinMeTo$Ui$Button$Only = {$: 'Only'};
var $author$project$PinMeTo$Ui$Button$Ghost = function (a) {
	return {$: 'Ghost', a: a};
};
var $author$project$PinMeTo$Ui$Button$Large = {$: 'Large'};
var $author$project$PinMeTo$Ui$Button$Small = {$: 'Small'};
var $author$project$PinMeTo$Ui$Button$Medium = {$: 'Medium'};
var $author$project$PinMeTo$Ui$Button$GhostAI = {$: 'GhostAI'};
var $author$project$PinMeTo$Ui$Button$Primary = function (a) {
	return {$: 'Primary', a: a};
};
var $author$project$PinMeTo$Ui$Button$Disabled = {$: 'Disabled'};
var $author$project$PinMeTo$Ui$Button$Outlined = function (a) {
	return {$: 'Outlined', a: a};
};
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2($elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var $author$project$PinMeTo$Ui$Button$Secondary = function (a) {
	return {$: 'Secondary', a: a};
};
var $author$project$PinMeTo$Ui$Button$GhostLight = {$: 'GhostLight'};
var $author$project$PinMeTo$Ui$Button$OutlinedAI = {$: 'OutlinedAI'};
var $author$project$PinMeTo$Ui$Button$GhostDanger = {$: 'GhostDanger'};
var $author$project$PinMeTo$Ui$DataTestAttribute$toAttribute = function (_v0) {
	var a = _v0.a;
	return A2($elm$html$Html$Attributes$attribute, 'data-test', a);
};
var $author$project$PinMeTo$Ui$Button$GhostDefault = {$: 'GhostDefault'};
var $author$project$PinMeTo$Ui$Button$GhostNeutral = {$: 'GhostNeutral'};
var $author$project$PinMeTo$Ui$Button$OutlinedLight = {$: 'OutlinedLight'};
var $author$project$PinMeTo$Ui$Button$PrimaryDanger = {$: 'PrimaryDanger'};
var $author$project$PinMeTo$Ui$Button$After = {$: 'After'};
var $author$project$PinMeTo$Ui$Button$Before = {$: 'Before'};
var $author$project$FontAwesome$Solid = function (a) {
	return {$: 'Solid', a: a};
};
var $author$project$FontAwesome$solid = function (icon) {
	return $author$project$FontAwesome$Solid(icon);
};
var $author$project$FontAwesome$Brands = function (a) {
	return {$: 'Brands', a: a};
};
var $author$project$FontAwesome$brands = function (icon) {
	return $author$project$FontAwesome$Brands(icon);
};
var $author$project$FontAwesome$Thin$Icon$render = function (icon) {
	var classNames = function (_v0) {
		var val = _v0.a;
		return val;
	}(icon);
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(classNames)
			]),
		_List_Nil);
};
var $author$project$FontAwesome$Light$Icon$render = function (icon) {
	var classNames = function (_v0) {
		var val = _v0.a;
		return val;
	}(icon);
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(classNames)
			]),
		_List_Nil);
};
var $author$project$FontAwesome$Brands$Icon$render = function (icon) {
	var classNames = function (_v0) {
		var val = _v0.a;
		return val;
	}(icon);
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(classNames)
			]),
		_List_Nil);
};
var $author$project$FontAwesome$Duotone$Icon$render = function (icon) {
	var classNames = function (_v0) {
		var val = _v0.a;
		return val;
	}(icon);
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(classNames)
			]),
		_List_Nil);
};
var $author$project$FontAwesome$Regular$Icon$render = function (icon) {
	var classNames = function (_v0) {
		var val = _v0.a;
		return val;
	}(icon);
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(classNames)
			]),
		_List_Nil);
};
var $author$project$FontAwesome$render = function (icon) {
	switch (icon.$) {
		case 'Brands':
			var style = icon.a;
			return $author$project$FontAwesome$Brands$Icon$render(style);
		case 'Duotone':
			var style = icon.a;
			return $author$project$FontAwesome$Duotone$Icon$render(style);
		case 'Light':
			var style = icon.a;
			return $author$project$FontAwesome$Light$Icon$render(style);
		case 'Regular':
			var style = icon.a;
			return $author$project$FontAwesome$Regular$Icon$render(style);
		case 'Solid':
			var style = icon.a;
			return $author$project$FontAwesome$Solid$Icon$render(style);
		default:
			var style = icon.a;
			return $author$project$FontAwesome$Thin$Icon$render(style);
	}
};
var $author$project$FontAwesome$Regular = function (a) {
	return {$: 'Regular', a: a};
};
var $author$project$FontAwesome$regular = function (icon) {
	return $author$project$FontAwesome$Regular(icon);
};
var $author$project$PinMeTo$Ui$Button$renderIcon = function (iconType) {
	switch (iconType.$) {
		case 'FA':
			var icon = iconType.a;
			return $author$project$FontAwesome$render(icon);
		case 'FASolid':
			var icon = iconType.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$solid(icon));
		case 'FARegular':
			var icon = iconType.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$regular(icon));
		case 'FABrands':
			var icon = iconType.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$brands(icon));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$PinMeTo$Ui$Button$renderContent = F3(
	function (x, iconType, iconAlignment) {
		var iconClasses = $elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('pmt-ui-button__icon', true),
					_Utils_Tuple2(
					'pmt-ui-button__icon-before',
					_Utils_eq(iconAlignment, $author$project$PinMeTo$Ui$Button$Before)),
					_Utils_Tuple2(
					'pmt-ui-button__icon-after',
					_Utils_eq(iconAlignment, $author$project$PinMeTo$Ui$Button$After))
				]));
		var renderIconSpan = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					iconClasses,
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$renderIcon(iconType)
				]));
		var renderText = $elm$html$Html$text(x);
		var _v0 = _Utils_Tuple2(iconType, iconAlignment);
		_v0$0:
		while (true) {
			switch (_v0.b.$) {
				case 'Before':
					if (_v0.a.$ === 'NoIcon') {
						break _v0$0;
					} else {
						var _v2 = _v0.b;
						return _List_fromArray(
							[renderIconSpan, renderText]);
					}
				case 'After':
					if (_v0.a.$ === 'NoIcon') {
						break _v0$0;
					} else {
						var _v3 = _v0.b;
						return _List_fromArray(
							[renderText, renderIconSpan]);
					}
				default:
					if (_v0.a.$ === 'NoIcon') {
						break _v0$0;
					} else {
						var _v4 = _v0.b;
						return _List_fromArray(
							[
								$elm$html$Html$text(''),
								renderIconSpan
							]);
					}
			}
		}
		var _v1 = _v0.a;
		return _List_fromArray(
			[renderText]);
	});
var $author$project$PinMeTo$Ui$Button$OutlinedDanger = {$: 'OutlinedDanger'};
var $author$project$PinMeTo$Ui$Button$PrimaryDefault = {$: 'PrimaryDefault'};
var $author$project$PinMeTo$Ui$Button$OutlinedAgentAI = {$: 'OutlinedAgentAI'};
var $author$project$PinMeTo$Ui$Button$OutlinedDefault = {$: 'OutlinedDefault'};
var $author$project$PinMeTo$Ui$Button$OutlinedNeutral = {$: 'OutlinedNeutral'};
var $author$project$PinMeTo$Ui$Button$SecondaryDanger = {$: 'SecondaryDanger'};
var $author$project$PinMeTo$Ui$Button$SecondaryDefault = {$: 'SecondaryDefault'};
var $author$project$PinMeTo$Ui$Button$render = function (_v0) {
	var config = _v0.a;
	var addAriaLabelAttribute = function (attributes) {
		return _Utils_eq(config.iconAlignment, $author$project$PinMeTo$Ui$Button$Only) ? A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$attribute, 'aria-label', config.label),
			attributes) : attributes;
	};
	var targetToString = function (t) {
		switch (t.$) {
			case 'Self':
				return '_self';
			case 'Blank':
				return '_blank';
			case 'Parent':
				return '_parent';
			case 'Top':
				return '_top';
			default:
				var s = t.a;
				return s;
		}
	};
	var addAttribute = F2(
		function (maybeAttribute, attributes) {
			if (maybeAttribute.$ === 'Just') {
				var attribute = maybeAttribute.a;
				return A2($elm$core$List$cons, attribute, attributes);
			} else {
				return attributes;
			}
		});
	var addTracking = addAttribute(
		A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Metrics$toAttribute, config.metricsEvent));
	var content_ = A3($author$project$PinMeTo$Ui$Button$renderContent, config.label, config.icon, config.iconAlignment);
	var classes = _List_fromArray(
		[
			_Utils_Tuple2('pmt-ui-button', true),
			_Utils_Tuple2(
			'pmt-ui-button--small',
			_Utils_eq(config.size, $author$project$PinMeTo$Ui$Button$Small)),
			_Utils_Tuple2(
			'pmt-ui-button--medium',
			_Utils_eq(config.size, $author$project$PinMeTo$Ui$Button$Medium)),
			_Utils_Tuple2(
			'pmt-ui-button--large',
			_Utils_eq(config.size, $author$project$PinMeTo$Ui$Button$Large)),
			_Utils_Tuple2(
			'pmt-ui-button--primary',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Primary($author$project$PinMeTo$Ui$Button$PrimaryDefault))),
			_Utils_Tuple2(
			'pmt-ui-button--primary-danger',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Primary($author$project$PinMeTo$Ui$Button$PrimaryDanger))),
			_Utils_Tuple2(
			'pmt-ui-button--secondary',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Secondary($author$project$PinMeTo$Ui$Button$SecondaryDefault))),
			_Utils_Tuple2(
			'pmt-ui-button--secondary-danger',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Secondary($author$project$PinMeTo$Ui$Button$SecondaryDanger))),
			_Utils_Tuple2(
			'pmt-ui-button--ghost',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostDefault))),
			_Utils_Tuple2(
			'pmt-ui-button--ghost-danger',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostDanger))),
			_Utils_Tuple2(
			'pmt-ui-button--ghost-neutral',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostNeutral))),
			_Utils_Tuple2(
			'pmt-ui-button--ghost-ai',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostAI))),
			_Utils_Tuple2(
			'pmt-ui-button--ghost-light',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostLight))),
			_Utils_Tuple2(
			'pmt-ui-button--outlined',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedDefault))),
			_Utils_Tuple2(
			'pmt-ui-button--outlined-danger',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedDanger))),
			_Utils_Tuple2(
			'pmt-ui-button--outlined-neutral',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedNeutral))),
			_Utils_Tuple2(
			'pmt-ui-button--outlined-ai',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedAI))),
			_Utils_Tuple2(
			'pmt-ui-button--outlined-agent-ai',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedAgentAI))),
			_Utils_Tuple2(
			'pmt-ui-button--outlined-light',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedLight))),
			_Utils_Tuple2(
			'pmt-ui-button--ghost-light',
			_Utils_eq(
				config.style,
				$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostLight))),
			_Utils_Tuple2(
			'pmt-ui-button--disabled',
			_Utils_eq(config.state, $author$project$PinMeTo$Ui$Button$Disabled)),
			_Utils_Tuple2(
			'pmt-ui-button--icon-only',
			_Utils_eq(config.iconAlignment, $author$project$PinMeTo$Ui$Button$Only))
		]);
	var _v1 = _Utils_Tuple2(config.type_, config.state);
	if (_v1.a.$ === 'Just') {
		if (_v1.a.a.$ === 'Link') {
			switch (_v1.b.$) {
				case 'Hidden':
					var _v2 = _v1.b;
					return $elm$html$Html$text('');
				case 'Disabled':
					var _v3 = _v1.b;
					return A2(
						$elm$html$Html$button,
						A2(
							addAttribute,
							A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$toAttribute, config.dataTestAttribute),
							addAriaLabelAttribute(
								addTracking(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(classes),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$disabled(true)
										])))),
						content_);
				default:
					var x = _v1.a.a.a;
					var _v4 = _v1.b;
					return A2(
						$elm$html$Html$a,
						A2(
							addAttribute,
							A2($elm$core$Maybe$map, $elm$html$Html$Attributes$download, config.download),
							A2(
								addAttribute,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, targetToString, $elm$html$Html$Attributes$target),
									x.target),
								A2(
									addAttribute,
									A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$toAttribute, config.dataTestAttribute),
									addAriaLabelAttribute(
										addTracking(
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(classes),
													$elm$html$Html$Attributes$href(x.href)
												])))))),
						content_);
			}
		} else {
			if (_v1.b.$ === 'Hidden') {
				var _v5 = _v1.b;
				return $elm$html$Html$text('');
			} else {
				var x = _v1.a.a.a;
				return A2(
					$elm$html$Html$button,
					A2(
						addAttribute,
						A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$toAttribute, config.dataTestAttribute),
						addAriaLabelAttribute(
							addTracking(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(classes),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Events$onClick(x.onClick),
										$elm$html$Html$Attributes$disabled(
										_Utils_eq(config.state, $author$project$PinMeTo$Ui$Button$Disabled))
									])))),
					content_);
			}
		}
	} else {
		var _v6 = _v1.a;
		return $elm$html$Html$text('');
	}
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$PinMeTo$Ui$Select$selectId = function (_v0) {
	var uid = _v0.a;
	return 'pmt-ui-select-' + uid;
};
var $author$project$PinMeTo$Ui$Button$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$PinMeTo$Ui$Button$withSize = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{size: x}));
	});
var $author$project$PinMeTo$Ui$Select$NoOp = {$: 'NoOp'};
var $author$project$PinMeTo$Ui$Select$Escape = {$: 'Escape'};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$PinMeTo$Ui$Select$onKeyDown = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$elm$json$Json$Decode$map,
			function (x) {
				return {message: x, preventDefault: true, stopPropagation: true};
			},
			A2(
				$elm$json$Json$Decode$andThen,
				function (keyCode) {
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Decode$fail('Unused key'),
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Decode$succeed,
							A2(
								$elm$core$Dict$get,
								keyCode,
								$elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											27,
											msg($author$project$PinMeTo$Ui$Select$Escape)),
											_Utils_Tuple2(38, $author$project$PinMeTo$Ui$Select$NoOp),
											_Utils_Tuple2(40, $author$project$PinMeTo$Ui$Select$NoOp)
										])))));
				},
				$elm$html$Html$Events$keyCode)));
};
var $author$project$PinMeTo$Ui$Select$InputStyle = {$: 'InputStyle'};
var $author$project$PinMeTo$Ui$Select$ToggleOpen = F2(
	function (a, b) {
		return {$: 'ToggleOpen', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Button$NoIcon = {$: 'NoIcon'};
var $author$project$PinMeTo$Ui$Button$Enabled = {$: 'Enabled'};
var $author$project$PinMeTo$Ui$Button$create = function (_v0) {
	var style = _v0.style;
	var label = _v0.label;
	return $author$project$PinMeTo$Ui$Button$Config(
		{icon: $author$project$PinMeTo$Ui$Button$NoIcon, size: $author$project$PinMeTo$Ui$Button$Medium, label: label, state: $author$project$PinMeTo$Ui$Button$Enabled, style: style, type_: $elm$core$Maybe$Nothing, download: $elm$core$Maybe$Nothing, metricsEvent: $elm$core$Maybe$Nothing, iconAlignment: $author$project$PinMeTo$Ui$Button$Before, dataTestAttribute: $elm$core$Maybe$Nothing});
};
var $author$project$PinMeTo$Ui$Button$buttonGhost = function (label) {
	return $author$project$PinMeTo$Ui$Button$create(
		{
			label: label,
			style: $author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostDefault)
		});
};
var $author$project$PinMeTo$Ui$Button$Button = function (a) {
	return {$: 'Button', a: a};
};
var $author$project$PinMeTo$Ui$Button$withOnClick = F2(
	function (msg, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					type_: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Button$Button(
							{onClick: msg}))
				}));
	});
var $author$project$PinMeTo$Ui$Select$Close = {$: 'Close'};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$PinMeTo$Ui$Select$onClickFinal = F2(
	function (msg, stopPropagation) {
		return A2(
			$elm$html$Html$Events$custom,
			'click',
			$elm$json$Json$Decode$succeed(
				{message: msg, preventDefault: false, stopPropagation: stopPropagation}));
	});
var $author$project$PinMeTo$Ui$Select$listItem = F2(
	function (_v0, item) {
		var config = _v0.a;
		var _v1 = config.renderer;
		if (_v1.$ === 'Raw') {
			var x = _v1.a;
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-select__item pmt-ui-select__item--raw')
					]),
				_List_fromArray(
					[
						x.render(item)
					]));
		} else {
			var x = _v1.a;
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-select__item pmt-ui-select__item--with-button'),
						A2(
						$author$project$PinMeTo$Ui$Select$onClickFinal,
						config.tagger($author$project$PinMeTo$Ui$Select$Close),
						true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								x.onChange(item))
							]),
						_List_fromArray(
							[
								x.render(item)
							]))
					]));
		}
	});
var $author$project$PinMeTo$Ui$Select$itemList = F2(
	function (_v0, items) {
		var config = _v0.a;
		var _v1 = _Utils_Tuple2(
			$elm$core$List$length(items),
			config.search);
		if ((!_v1.a) && (_v1.b.$ === 'Just')) {
			var noResultsLabel = _v1.b.a.noResultsLabel;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-select__message')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(noResultsLabel)
					]));
		} else {
			return A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-select__list')
					]),
				A2(
					$elm$core$List$map,
					$author$project$PinMeTo$Ui$Select$listItem(
						$author$project$PinMeTo$Ui$Select$Config(config)),
					items));
		}
	});
var $author$project$PinMeTo$Ui$Select$dropdownId = function (_v0) {
	var uid = _v0.a;
	return 'pmt-ui-select-dropdown' + uid;
};
var $author$project$PinMeTo$Ui$Select$footerView = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-select__footer')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$PinMeTo$Ui$Select$headerView = function (content) {
	return A2(
		$elm$html$Html$header,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-select__header')
			]),
		_List_fromArray(
			[content]));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$PinMeTo$Ui$Select$itemsWithSearch = F3(
	function (searchQuery, items, _v0) {
		var sort = _v0.sort;
		var searchMap = _v0.searchMap;
		return A3(
			$elm$core$Basics$apR,
			A2(
				$elm$core$Maybe$map,
				function (compareWithQuery) {
					return $elm$core$List$sortWith(
						compareWithQuery(searchQuery));
				},
				sort),
			$elm$core$Maybe$withDefault($elm$core$Basics$identity),
			A2(
				$elm$core$List$filter,
				function (x) {
					return A2(
						$elm$core$String$contains,
						$elm$core$String$toLower(searchQuery),
						$elm$core$String$toLower(
							searchMap(x)));
				},
				items));
	});
var $author$project$PinMeTo$Ui$Select$Search = function (a) {
	return {$: 'Search', a: a};
};
var $author$project$PinMeTo$Ui$Select$searchInputId = function (_v0) {
	var uid = _v0.a;
	return 'pmt-ui-select-searchInput' + uid;
};
var $author$project$PinMeTo$Ui$Select$searchFieldView = F4(
	function (uid, searchQuery, tagger, searchOptions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-select__search')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('search'),
							A2($elm$html$Html$Attributes$attribute, 'data-lpignore', 'true'),
							$elm$html$Html$Attributes$id(
							$author$project$PinMeTo$Ui$Select$searchInputId(uid)),
							$elm$html$Html$Attributes$value(searchQuery),
							$elm$html$Html$Attributes$autocomplete(false),
							$elm$html$Html$Attributes$placeholder(searchOptions.placeholder),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Select$Search, tagger)),
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'keypress',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(
									tagger($author$project$PinMeTo$Ui$Select$NoOp),
									true)))
						]),
					_List_Nil)
				]));
	});
var $author$project$PinMeTo$Ui$Select$resizedAttributes = F2(
	function (elementFitToViewport, attributes) {
		if (elementFitToViewport.$ === 'Element') {
			if (elementFitToViewport.a.$ === 'Below') {
				var _v1 = elementFitToViewport.a;
				var element = elementFitToViewport.b;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'left',
						$elm$core$String$fromInt(element.x) + 'px'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromInt(element.y) + 'px'),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$style,
								'width',
								$elm$core$String$fromInt(element.width) + 'px'),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$Attributes$style,
									'max-height',
									$elm$core$String$fromInt(element.height) + 'px'),
								attributes))));
			} else {
				var _v2 = elementFitToViewport.a;
				var element = elementFitToViewport.b;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'left',
						$elm$core$String$fromInt(element.x) + 'px'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$style,
							'bottom',
							$elm$core$String$fromInt(element.y) + 'px'),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$style,
								'width',
								$elm$core$String$fromInt(element.width) + 'px'),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$Attributes$style,
									'max-height',
									$elm$core$String$fromInt(element.height) + 'px'),
								attributes))));
			}
		} else {
			return attributes;
		}
	});
var $author$project$PinMeTo$Ui$Select$dropdownView = F3(
	function (element, model, _v0) {
		var config = _v0.a;
		var visibilityAttributes = function (attributes) {
			if (element.$ === 'Opening') {
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'visibility', 'hidden'),
					attributes);
			} else {
				return attributes;
			}
		};
		var isAbove = function () {
			if ((element.$ === 'Element') && (element.a.$ === 'Above')) {
				var _v2 = element.a;
				return true;
			} else {
				return false;
			}
		}();
		var items = A2(
			$elm$core$Maybe$withDefault,
			config.items,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$PinMeTo$Ui$Select$itemsWithSearch, model.searchQuery, config.items),
				config.search));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-select__backdrop'),
						$elm$html$Html$Events$onMouseLeave(
						config.tagger($author$project$PinMeTo$Ui$Select$Close)),
						A2(
						$author$project$PinMeTo$Ui$Select$onClickFinal,
						config.tagger($author$project$PinMeTo$Ui$Select$Close),
						true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						A2(
							$author$project$PinMeTo$Ui$Select$resizedAttributes,
							element,
							visibilityAttributes(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(
										$author$project$PinMeTo$Ui$Select$dropdownId(config.uid)),
										$elm$html$Html$Attributes$class('pmt-ui-select__items'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('pmt-ui-select__items--above', isAbove)
											])),
										A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
										A2(
										$author$project$PinMeTo$Ui$Select$onClickFinal,
										config.tagger($author$project$PinMeTo$Ui$Select$NoOp),
										true)
									]))),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									A3($author$project$PinMeTo$Ui$Select$searchFieldView, config.uid, model.searchQuery, config.tagger),
									config.search)),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Select$headerView, config.header)),
								A2(
								$author$project$PinMeTo$Ui$Select$itemList,
								$author$project$PinMeTo$Ui$Select$Config(config),
								items),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Select$footerView, config.footer))
							]))
					]))
			]);
	});
var $author$project$PinMeTo$Ui$Button$buttonPrimary = function (label) {
	return $author$project$PinMeTo$Ui$Button$create(
		{
			label: label,
			style: $author$project$PinMeTo$Ui$Button$Primary($author$project$PinMeTo$Ui$Button$PrimaryDefault)
		});
};
var $author$project$PinMeTo$Ui$Button$withIconAfter = F2(
	function (icon_, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{icon: icon_, iconAlignment: $author$project$PinMeTo$Ui$Button$After}));
	});
var $author$project$PinMeTo$Ui$Button$buttonOutlined = function (label) {
	return $author$project$PinMeTo$Ui$Button$create(
		{
			label: label,
			style: $author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedDefault)
		});
};
var $author$project$PinMeTo$Ui$Button$disabledIfTrue = F2(
	function (isDisabled, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					state: isDisabled ? $author$project$PinMeTo$Ui$Button$Disabled : $author$project$PinMeTo$Ui$Button$Enabled
				}));
	});
var $author$project$PinMeTo$Ui$Button$withGhostStyle = F2(
	function (style, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					style: $author$project$PinMeTo$Ui$Button$Ghost(style)
				}));
	});
var $author$project$PinMeTo$Ui$Button$withIconBefore = F2(
	function (icon_, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{icon: icon_, iconAlignment: $author$project$PinMeTo$Ui$Button$Before}));
	});
var $author$project$PinMeTo$Ui$Button$buttonSecondary = function (label) {
	return $author$project$PinMeTo$Ui$Button$create(
		{
			label: label,
			style: $author$project$PinMeTo$Ui$Button$Secondary($author$project$PinMeTo$Ui$Button$SecondaryDefault)
		});
};
var $author$project$PinMeTo$Ui$Button$withPrimaryStyle = F2(
	function (style, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					style: $author$project$PinMeTo$Ui$Button$Primary(style)
				}));
	});
var $author$project$PinMeTo$Ui$Button$withOutlinedStyle = F2(
	function (style, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					style: $author$project$PinMeTo$Ui$Button$Outlined(style)
				}));
	});
var $author$project$PinMeTo$Ui$Button$withSecondaryStyle = F2(
	function (style, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					style: $author$project$PinMeTo$Ui$Button$Secondary(style)
				}));
	});
var $author$project$PinMeTo$Ui$Button$withDataTestAttribute = F2(
	function (dataTestAttribute, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					dataTestAttribute: $elm$core$Maybe$Just(dataTestAttribute)
				}));
	});
var $author$project$PinMeTo$Ui$Select$render_ = F3(
	function (_v0, _v1, toggle) {
		var model = _v0.a;
		var config = _v1.a;
		var buttonVariant = function () {
			var _v4 = toggle.style;
			if (_v4.$ === 'ButtonStyle') {
				var style = _v4.a;
				switch (style.$) {
					case 'Primary':
						var v = style.a;
						return function (label) {
							return A2(
								$author$project$PinMeTo$Ui$Button$withPrimaryStyle,
								v,
								$author$project$PinMeTo$Ui$Button$buttonPrimary(label));
						};
					case 'Secondary':
						var v = style.a;
						return function (label) {
							return A2(
								$author$project$PinMeTo$Ui$Button$withSecondaryStyle,
								v,
								$author$project$PinMeTo$Ui$Button$buttonSecondary(label));
						};
					case 'Ghost':
						var v = style.a;
						return function (label) {
							return A2(
								$author$project$PinMeTo$Ui$Button$withGhostStyle,
								v,
								$author$project$PinMeTo$Ui$Button$buttonGhost(label));
						};
					default:
						var v = style.a;
						return function (label) {
							return A2(
								$author$project$PinMeTo$Ui$Button$withOutlinedStyle,
								v,
								$author$project$PinMeTo$Ui$Button$buttonOutlined(label));
						};
				}
			} else {
				return function (label) {
					return A2(
						$author$project$PinMeTo$Ui$Button$withOutlinedStyle,
						$author$project$PinMeTo$Ui$Button$OutlinedNeutral,
						$author$project$PinMeTo$Ui$Button$buttonOutlined(label));
				};
			}
		}();
		var maybeElement = A2(
			$elm$core$Maybe$andThen,
			function (element) {
				return A2($author$project$PinMeTo$Ui$Select$isOpen, config.uid, model) ? $elm$core$Maybe$Just(element) : $elm$core$Maybe$Nothing;
			},
			model.element);
		var addAttribute = F2(
			function (maybeAttribute, attributes) {
				if (maybeAttribute.$ === 'Just') {
					var attribute = maybeAttribute.a;
					return A2($elm$core$List$cons, attribute, attributes);
				} else {
					return attributes;
				}
			});
		var dropdown_ = A2(
			$elm$core$Maybe$andThen,
			function (element) {
				return $elm$core$List$head(
					A3(
						$author$project$PinMeTo$Ui$Select$dropdownView,
						element,
						model,
						$author$project$PinMeTo$Ui$Select$Config(config)));
			},
			maybeElement);
		return A2(
			$elm$html$Html$div,
			A2(
				addAttribute,
				A2(
					$elm$core$Maybe$map,
					function (onOpen) {
						return $elm$html$Html$Events$onClick(
							onOpen(_Utils_Tuple0));
					},
					config.onOpen),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(
						$author$project$PinMeTo$Ui$Select$selectId(config.uid)),
						$elm$html$Html$Attributes$class('pmt-ui-select'),
						A2(
						$elm$html$Html$Attributes$map,
						config.tagger,
						$author$project$PinMeTo$Ui$Select$onKeyDown($author$project$PinMeTo$Ui$Select$OnKey)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pmt-ui-select--input-style',
								_Utils_eq(toggle.style, $author$project$PinMeTo$Ui$Select$InputStyle))
							]))
					])),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A3(
						$elm$core$Basics$apR,
						A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Button$withDataTestAttribute, config.dataTestAttribute),
						$elm$core$Maybe$withDefault($elm$core$Basics$identity),
						A3(
							$elm$core$Basics$apR,
							A2(
								$elm$core$Maybe$map,
								function (toggleIcon) {
									if (toggleIcon.$ === 'ToggleIconBefore') {
										var icon = toggleIcon.a;
										return $author$project$PinMeTo$Ui$Button$withIconBefore(
											$author$project$PinMeTo$Ui$Button$FA(icon));
									} else {
										var icon = toggleIcon.a;
										return $author$project$PinMeTo$Ui$Button$withIconAfter(
											$author$project$PinMeTo$Ui$Button$FA(icon));
									}
								},
								toggle.icon),
							$elm$core$Maybe$withDefault($elm$core$Basics$identity),
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								config.disabled,
								A2(
									$author$project$PinMeTo$Ui$Button$withSize,
									toggle.size,
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										config.tagger(
											A2($author$project$PinMeTo$Ui$Select$ToggleOpen, config.uid, config.inset)),
										buttonVariant(toggle.label))))))),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					dropdown_)
				]));
	});
var $author$project$PinMeTo$Ui$Btn$FA = function (a) {
	return {$: 'FA', a: a};
};
var $author$project$PinMeTo$Ui$Select$Wrapper = {$: 'Wrapper'};
var $author$project$FontAwesome$Solid$Icon$faPencil = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-pencil');
var $author$project$PinMeTo$Ui$Btn$pmtBtnCtaTypeIcon = function (x) {
	switch (x.$) {
		case 'ExternalLink':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-external-link-alt')
					]),
				_List_Nil);
		case 'NavigateBack':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-angle-left')
					]),
				_List_Nil);
		case 'Done':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-check')
					]),
				_List_Nil);
		case 'Inbox':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-inbox')
					]),
				_List_Nil);
		case 'Collapsed':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-caret-right')
					]),
				_List_Nil);
		case 'Expanded':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-caret-down')
					]),
				_List_Nil);
		case 'Delete':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-xmark-circle')
					]),
				_List_Nil);
		case 'Add':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-solid fa-circle-plus')
					]),
				_List_Nil);
		case 'Create':
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa-regular fa-plus')
					]),
				_List_Nil);
		case 'Edit':
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faPencil));
		case 'FA':
			var icon = x.a;
			return $author$project$FontAwesome$render(icon);
		case 'FASolid':
			var icon = x.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$solid(icon));
		case 'FARegular':
			var icon = x.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$regular(icon));
		case 'FABrands':
			var icon = x.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$brands(icon));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$PinMeTo$Ui$Btn$pmtBtnCta_ = F5(
	function (classes, t, n, a, c) {
		var fc = _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Btn$pmtBtnCtaTypeIcon(t)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn__label')
					]),
				c)
			]);
		var fa = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('pmt-btn ' + classes),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('button'),
				a));
		return A2(n, fa, fc);
	});
var $author$project$PinMeTo$Ui$Btn$pmtBtnCta = function (t) {
	return A2($author$project$PinMeTo$Ui$Btn$pmtBtnCta_, 'pmt-btn--default pmt-btn--with-icon', t);
};
var $author$project$PinMeTo$Ui$Select$WithOutIcon = {$: 'WithOutIcon'};
var $author$project$PinMeTo$Ui$Btn$pmtBtnPlain = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--plain');
var $author$project$PinMeTo$Ui$Select$FullWidthInput = {$: 'FullWidthInput'};
var $author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--plain pmt-btn--light');
var $author$project$PinMeTo$Ui$Select$renderLegacy = F3(
	function (_v0, _v1, toggle) {
		var model = _v0.a;
		var config = _v1.a;
		var withNoHeaderClass = config.withNoHeader ? A2($elm$html$Html$Attributes$style, 'color', '#424242') : A2($elm$html$Html$Attributes$style, '', '');
		var _v2 = function () {
			var _v3 = config.toggleStyle;
			switch (_v3.$) {
				case 'PlainLight':
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight($elm$html$Html$button),
						'');
				case 'Normal':
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$Btn$pmtBtnSmall($elm$html$Html$button),
						'');
				case 'Positive':
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$Btn$pmtBtn($elm$html$Html$button),
						'pmt-ui-select__toggle--cta');
				case 'Cta':
					var icon = _v3.a;
					return _Utils_Tuple2(
						A2(
							$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
							$author$project$PinMeTo$Ui$Btn$FA(icon),
							$elm$html$Html$button),
						'pmt-ui-select__toggle--cta');
				case 'FullWidthInput':
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$Btn$pmtBtnPlain($elm$html$Html$button),
						'');
				default:
					return _Utils_Tuple2($elm$html$Html$button, '');
			}
		}();
		var toggleButton = _v2.a;
		var toggleClass = _v2.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-select'),
					$elm$html$Html$Attributes$id(
					$author$project$PinMeTo$Ui$Select$selectId(config.uid)),
					A2(
					$elm$html$Html$Attributes$map,
					config.tagger,
					$author$project$PinMeTo$Ui$Select$onKeyDown($author$project$PinMeTo$Ui$Select$OnKey)),
					A2(
					$author$project$PinMeTo$Ui$Select$onClickFinal,
					config.tagger(
						A2($author$project$PinMeTo$Ui$Select$ToggleOpen, config.uid, config.inset)),
					false),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-ui-select--with-icon',
							!A2($elm$core$List$member, $author$project$PinMeTo$Ui$Select$WithOutIcon, config.styles)),
							_Utils_Tuple2(
							'pmt-ui-select--full-width-input',
							_Utils_eq(config.toggleStyle, $author$project$PinMeTo$Ui$Select$FullWidthInput)),
							_Utils_Tuple2(
							'pmt-ui-select--with-wrapper-toggle',
							_Utils_eq(config.toggleStyle, $author$project$PinMeTo$Ui$Select$Wrapper))
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					toggleButton,
					_Utils_ap(
						_List_fromArray(
							[
								withNoHeaderClass,
								$elm$html$Html$Attributes$class('pmt-ui-select__toggle'),
								$elm$html$Html$Attributes$class(toggleClass),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$disabled(config.disabled)
							]),
						_Utils_ap(
							function () {
								var _v4 = config.dataTestAttribute;
								if (_v4.$ === 'Just') {
									var a = _v4.a.a;
									return _List_fromArray(
										[
											$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute(a)
										]);
								} else {
									return _List_Nil;
								}
							}(),
							function () {
								var _v5 = config.onOpen;
								if (_v5.$ === 'Just') {
									var onOpen_ = _v5.a;
									return _List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											onOpen_(_Utils_Tuple0))
										]);
								} else {
									return _List_Nil;
								}
							}())),
					_List_fromArray(
						[toggle.label])),
				function () {
					var _v6 = A2(
						$elm$core$Maybe$andThen,
						function (element) {
							return A2($author$project$PinMeTo$Ui$Select$isOpen, config.uid, model) ? $elm$core$Maybe$Just(element) : $elm$core$Maybe$Nothing;
						},
						model.element);
					if (_v6.$ === 'Just') {
						var element = _v6.a;
						return A3(
							$author$project$PinMeTo$Ui$Select$dropdownView,
							element,
							model,
							$author$project$PinMeTo$Ui$Select$Config(config));
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$PinMeTo$Ui$Select$render = F2(
	function (state, _v0) {
		var config = _v0.a;
		var _v1 = config.toggle;
		if (_v1.$ === 'UiButtonToggle') {
			var toggle = _v1.a;
			return A3(
				$author$project$PinMeTo$Ui$Select$render_,
				state,
				$author$project$PinMeTo$Ui$Select$Config(config),
				toggle);
		} else {
			var toggle = _v1.a;
			return A3(
				$author$project$PinMeTo$Ui$Select$renderLegacy,
				state,
				$author$project$PinMeTo$Ui$Select$Config(config),
				toggle);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (item.$ === 'Just') {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Directories$NetworkListDetail$Model$EnableNetwork = {$: 'EnableNetwork'};
var $author$project$Directories$NetworkListDetail$Model$ConnectionPage = {$: 'ConnectionPage'};
var $author$project$Directories$NetworkListDetail$Model$DisableNetwork = {$: 'DisableNetwork'};
var $author$project$Directories$NetworkListDetail$Main$actions = F2(
	function (details, network) {
		var twoWayAction = (details.isTwoWayConnection && (!_Utils_eq(network, $author$project$Directories$Common$Network$BingNetwork))) ? $elm$core$Maybe$Just($author$project$Directories$NetworkListDetail$Model$ConnectionPage) : $elm$core$Maybe$Nothing;
		var statusAction = details.status.enabled ? $author$project$Directories$NetworkListDetail$Model$DisableNetwork : $author$project$Directories$NetworkListDetail$Model$EnableNetwork;
		return $elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					twoWayAction,
					$elm$core$Maybe$Just(statusAction)
				]));
	});
var $author$project$Data$User$hasRole = F2(
	function (user, role) {
		return A2($elm$core$List$member, role, user.localAccess.roles);
	});
var $author$project$Directories$NetworkListDetail$Model$Selected = function (a) {
	return {$: 'Selected', a: a};
};
var $author$project$Translations$Listings$Directories$settings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.settings');
};
var $author$project$Directories$NetworkListDetail$Model$SelectMsg = function (a) {
	return {$: 'SelectMsg', a: a};
};
var $author$project$Translations$Listings$Directories$enableNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.enable_network');
};
var $author$project$Translations$Listings$Directories$connectionPage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.connection_page');
};
var $author$project$Translations$Listings$Directories$disableNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.disable_network');
};
var $author$project$Directories$NetworkListDetail$Model$selectableToString = F2(
	function (translations, x) {
		switch (x.$) {
			case 'ConnectionPage':
				return $author$project$Translations$Listings$Directories$connectionPage(translations);
			case 'DisableNetwork':
				return $author$project$Translations$Listings$Directories$disableNetwork(translations);
			default:
				return $author$project$Translations$Listings$Directories$enableNetwork(translations);
		}
	});
var $author$project$Directories$NetworkListDetail$Main$select = F3(
	function (model, data, network) {
		var showSettingsMenuWith = function (items) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'min-width', '150px')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Select$render,
						model.selectState,
						$author$project$PinMeTo$Ui$Select$view(
							{
								uid: 'ui-select-right',
								items: items,
								label: $elm$html$Html$text(
									$author$project$Translations$Listings$Directories$settings(model.translations)),
								tagger: $author$project$Directories$NetworkListDetail$Model$SelectMsg,
								onChange: $author$project$Directories$NetworkListDetail$Model$Selected,
								itemRender: A2(
									$elm$core$Basics$composeL,
									$elm$html$Html$text,
									$author$project$Directories$NetworkListDetail$Model$selectableToString(model.translations))
							}))
					]));
		};
		var showNothing = $elm$html$Html$text('');
		return (A2($author$project$Data$User$hasRole, model.user, $author$project$Data$User$Owner) && (!$elm$core$String$length(data.parentUrl))) ? (data.status.customerCanEnable ? showSettingsMenuWith(
			A2($author$project$Directories$NetworkListDetail$Main$actions, data, network)) : showNothing) : showNothing;
	});
var $author$project$Directories$NetworkListDetail$Model$ShowParentUrl = function (a) {
	return {$: 'ShowParentUrl', a: a};
};
var $author$project$Directories$NetworkListDetail$Main$renderParentUrl = F2(
	function (urlString, tag) {
		return ($elm$core$String$length(urlString) > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directories-detail-url')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(urlString),
							$elm$html$Html$Events$onClick(
							$author$project$Directories$NetworkListDetail$Model$ShowParentUrl(urlString))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(tag)
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				]));
	});
var $author$project$Translations$Listings$Directories$helpCenterArticle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.help_center_article');
};
var $author$project$Translations$Listings$Directories$parentNetworkLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.parent_network_link');
};
var $author$project$Translations$Listings$Directories$gmbNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.gmb_network');
};
var $author$project$Translations$Listings$Directories$ptvNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.ptv_network');
};
var $author$project$Translations$Listings$Directories$hereNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.here_network');
};
var $author$project$Translations$Listings$Directories$wazeNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.waze_network');
};
var $author$project$Translations$Listings$Directories$appleNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.apple_network');
};
var $author$project$Translations$Listings$Directories$seznamNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.seznam_network');
};
var $author$project$Translations$Listings$Directories$tomtomNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.tomtom_network');
};
var $author$project$Translations$Listings$Directories$factualNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.factual_network');
};
var $author$project$Translations$Listings$Directories$facebookNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.facebook_network');
};
var $author$project$Translations$Listings$Directories$overtureNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.overture_network');
};
var $author$project$Translations$Listings$Directories$instagramNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.instagram_network');
};
var $author$project$Translations$Listings$Directories$foursquareNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.foursquare_network');
};
var $author$project$Translations$Listings$Directories$googleMapsNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.google_maps_network');
};
var $author$project$Translations$Listings$Directories$trustpilotNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.trustpilot_network');
};
var $author$project$Translations$Listings$Directories$ecoMovementNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.eco_movement_network');
};
var $author$project$Translations$Listings$Directories$googleSearchNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.google_search_network');
};
var $author$project$Translations$Listings$Directories$bingNetworkDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.bing_network_description');
};
var $author$project$Directories$NetworkListDetail$Main$networkDescription = F3(
	function (network, _v0, t) {
		switch (network.$) {
			case 'AppleNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$appleNetwork(t));
			case 'BingNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$bingNetworkDescription(t));
			case 'FacebookNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$facebookNetwork(t));
			case 'FactualNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$factualNetwork(t));
			case 'FoursquareNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$foursquareNetwork(t));
			case 'HereNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$hereNetwork(t));
			case 'InstagramNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$instagramNetwork(t));
			case 'GoogleMyBusinessNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$gmbNetwork(t));
			case 'GoogleMapsNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$googleMapsNetwork(t));
			case 'GoogleSearchNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$googleSearchNetwork(t));
			case 'TomTomNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$tomtomNetwork(t));
			case 'TrustpilotNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$trustpilotNetwork(t));
			case 'WazeNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$wazeNetwork(t));
			case 'SeznamNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$seznamNetwork(t));
			case 'EcoMovementNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$ecoMovementNetwork(t));
			case 'OvertureNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$overtureNetwork(t));
			case 'PTVNetwork':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Directories$ptvNetwork(t));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$Listings$Directories$networkInformation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.network_information');
};
var $author$project$Directories$NetworkListDetail$Main$helpCenterUrl = function (networkName) {
	switch (networkName.$) {
		case 'AppleNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-apple-18lfzfo/';
		case 'BaiduNetwork':
			return 'https://help.pinmeto.com/en/';
		case 'BingNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-bing-places-1h9klhh/';
		case 'FacebookNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-facebook-18w5r75/';
		case 'FactualNetwork':
			return 'https://training.pinmeto.com/business-directories-factual/';
		case 'FoursquareNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-foursquare-u1h62g/';
		case 'GoogleMyBusinessNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-google-business-profile-gbp-tly9l4/';
		case 'GoogleMapsNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-google-maps-1ufcsbi/';
		case 'GoogleSearchNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-google-search-h51464/';
		case 'HereNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-here-11d8fjr/';
		case 'InstagramNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-instagram-locations-1wg75ly/';
		case 'TomTomNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-tomtom-nnbt3o/';
		case 'TrustpilotNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-trustpilot-1b1nyhb/';
		case 'WazeNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-waze-1eiz4xc/';
		case 'SeznamNetwork':
			return 'https://help.pinmeto.com/en/article/business-directories-seznam-1ole1ju/';
		case 'EcoMovementNetwork':
			return '';
		case 'OvertureNetwork':
			return '';
		default:
			return '';
	}
};
var $author$project$Directories$NetworkListDetail$Main$renderHelpCenterUrl = F2(
	function (networkName, tag) {
		var url = $author$project$Directories$NetworkListDetail$Main$helpCenterUrl(networkName);
		return $elm$core$String$isEmpty(url) ? A2($elm$html$Html$span, _List_Nil, _List_Nil) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directories-detail-url')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(url),
							$elm$html$Html$Attributes$target('blank_')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(tag)
						]))
				]));
	});
var $author$project$Directories$NetworkListDetail$Main$body = F3(
	function (model, network, data) {
		var networkName = $author$project$Directories$Common$Network$getNetworkName(network.key);
		if (networkName.$ === 'Just') {
			var x = networkName.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('directories-detail-body-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('directories-detail-header')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Directories$networkInformation(model.translations))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('directories-detail-network-description')
									]),
								_List_fromArray(
									[
										A3($author$project$Directories$NetworkListDetail$Main$networkDescription, x, data, model.translations)
									])),
								A2(
								$author$project$Directories$NetworkListDetail$Main$renderParentUrl,
								data.parentUrl,
								$author$project$Translations$Listings$Directories$parentNetworkLink(model.translations)),
								A2(
								$author$project$Directories$NetworkListDetail$Main$renderHelpCenterUrl,
								x,
								$author$project$Translations$Listings$Directories$helpCenterArticle(model.translations))
							])),
						A3($author$project$Directories$NetworkListDetail$Main$select, model, data, x)
					]));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Directories$NetworkListDetail$Main$renderNetworkIcon = function (network) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('directories-detail-network-icon')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Icon$render(network.icon)
			]));
};
var $ChristophP$elm_i18next$I18Next$replacePlaceholders = F3(
	function (replacements, delims, str) {
		var _v0 = $ChristophP$elm_i18next$I18Next$delimsToTuple(delims);
		var start = _v0.a;
		var end = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(
						$elm$core$String$replace,
						_Utils_ap(
							start,
							_Utils_ap(key, end)),
						value,
						acc);
				}),
			str,
			replacements);
	});
var $ChristophP$elm_i18next$I18Next$trf = F4(
	function (translationsList, delims, key, replacements) {
		trf:
		while (true) {
			if (translationsList.b) {
				var translations = translationsList.a.a;
				var rest = translationsList.b;
				var _v1 = A2($elm$core$Dict$get, key, translations);
				if (_v1.$ === 'Just') {
					var str = _v1.a;
					return A3($ChristophP$elm_i18next$I18Next$replacePlaceholders, replacements, delims, str);
				} else {
					var $temp$translationsList = rest,
						$temp$delims = delims,
						$temp$key = key,
						$temp$replacements = replacements;
					translationsList = $temp$translationsList;
					delims = $temp$delims;
					key = $temp$key;
					replacements = $temp$replacements;
					continue trf;
				}
			} else {
				return key;
			}
		}
	});
var $author$project$PinMeTo$Ui$I18n$Language$pluralKey = F3(
	function (language, key, n) {
		var zeroAsMany = function () {
			switch (n) {
				case 0:
					return key;
				case 1:
					return key;
				default:
					return key + '_plural';
			}
		}();
		var _default = function () {
			if (n === 1) {
				return key;
			} else {
				return key + '_plural';
			}
		}();
		switch (language.$) {
			case 'En':
				return _default;
			case 'Fr':
				return zeroAsMany;
			case 'De':
				return _default;
			case 'Es':
				return _default;
			case 'Sv':
				return _default;
			case 'Fi':
				return _default;
			case 'Pl':
				var _v1 = _Utils_Tuple3(key + '_0', key + '_1', key + '_2');
				var key0 = _v1.a;
				var key1 = _v1.b;
				var key2 = _v1.c;
				var _v2 = _Utils_Tuple2(
					$elm$core$Basics$floor((n % 100) / 10),
					n % 10);
				var dozen = _v2.a;
				var one = _v2.b;
				var _v3 = _Utils_Tuple2(dozen, one);
				_v3$1:
				while (true) {
					_v3$5:
					while (true) {
						switch (_v3.b) {
							case 1:
								switch (_v3.a) {
									case 0:
										return key0;
									case 1:
										break _v3$1;
									default:
										break _v3$5;
								}
							case 2:
								if (_v3.a === 1) {
									break _v3$1;
								} else {
									return key1;
								}
							case 3:
								if (_v3.a === 1) {
									break _v3$1;
								} else {
									return key1;
								}
							case 4:
								if (_v3.a === 1) {
									break _v3$1;
								} else {
									return key1;
								}
							default:
								if (_v3.a === 1) {
									break _v3$1;
								} else {
									break _v3$5;
								}
						}
					}
					return key2;
				}
				return key2;
			default:
				return zeroAsMany;
		}
	});
var $author$project$Common$Language$i18n = F4(
	function (translations, language, key, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$trf,
			_List_fromArray(
				[translations]),
			$ChristophP$elm_i18next$I18Next$Curly,
			A3($author$project$PinMeTo$Ui$I18n$Language$pluralKey, language, key, count),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'count',
					$elm$core$String$fromInt(count))
				]));
	});
var $author$project$FontAwesome$Solid$Icon$faCircle = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-circle');
var $author$project$FontAwesome$Solid$faCircle = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircle);
var $author$project$Translations$Listings$Directories$connected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.connected');
};
var $author$project$Translations$Listings$Directories$notEnabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.not_enabled');
};
var $author$project$Translations$Listings$Directories$oneWayConnection = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.one_way_connection');
};
var $author$project$Translations$Listings$Directories$twoWayConnection = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.two_way_connection');
};
var $author$project$Directories$NetworkListDetail$Main$renderType = F2(
	function (model, data) {
		return data.isTwoWayConnection ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directory-details-connection-type')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Directories$twoWayConnection(model.translations))
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directory-details-connection-type')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Directories$oneWayConnection(model.translations))
				]));
	});
var $author$project$Translations$Listings$Directories$disconnected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.disconnected');
};
var $ChristophP$elm_i18next$I18Next$tr = F4(
	function (_v0, delims, key, replacements) {
		var translations = _v0.a;
		var _v1 = A2($elm$core$Dict$get, key, translations);
		if (_v1.$ === 'Just') {
			var str = _v1.a;
			return A3($ChristophP$elm_i18next$I18Next$replacePlaceholders, replacements, delims, str);
		} else {
			return key;
		}
	});
var $author$project$Translations$Listings$Directories$publishedLocations = F3(
	function (translations, published, total) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.directories.published_locations',
			_List_fromArray(
				[
					_Utils_Tuple2('published', published),
					_Utils_Tuple2('total', total)
				]));
	});
var $author$project$Translations$General$connectionTypeHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.connection_type_header');
};
var $author$project$Directories$NetworkListDetail$Main$renderNetworkDetails = F3(
	function (model, network, data) {
		var publishedLocations = $elm$core$String$fromInt(data.publishedLocations);
		var totalLocations = $elm$core$String$fromInt(data.totalLocations);
		var brandpages = $elm$core$String$fromInt(data.brandpages);
		var getText = A2($author$project$Common$Language$i18n, model.translations, model.language);
		var renderBrandpages = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					((network.key === 'facebook') || (network.key === 'trustpilot')) ? $elm$html$Html$text(
					brandpages + (' ' + A2(getText, 'general.brand_page', data.brandpages))) : $elm$html$Html$text('')
				]));
		var details = data.status;
		var statusLabel = (!details.enabled) ? $author$project$Translations$Listings$Directories$notEnabled(model.translations) : ((details.enabled && details.isConnected) ? $author$project$Translations$Listings$Directories$connected(model.translations) : $author$project$Translations$Listings$Directories$disconnected(model.translations));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directories-detail-item-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directories-detail-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('directory-detail-network-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(network.name)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('directories-status-active', details.enabled && details.isConnected),
													_Utils_Tuple2('directories-status-disconnected', details.enabled && (!details.isConnected)),
													_Utils_Tuple2('directories-status-not-enabled', !details.enabled)
												])),
											$elm$html$Html$Attributes$class('directories-status')
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Solid$faCircle])),
									$elm$html$Html$text(statusLabel)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directories-detail-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									publishedLocations + (' ' + A2(getText, 'general.location', data.publishedLocations)))
								])),
							renderBrandpages
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directories-detail-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$connectionTypeHeader(model.translations))
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Directories$NetworkListDetail$Main$renderType, model, data)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directories-detail-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Translations$Listings$Directories$publishedLocations, model.translations, publishedLocations, totalLocations))
								]))
						]))
				]));
	});
var $author$project$Directories$NetworkListDetail$Main$detailsBar = F3(
	function (model, network, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directories-detail-item-container')
						]),
					_List_fromArray(
						[
							$author$project$Directories$NetworkListDetail$Main$renderNetworkIcon(network),
							A3($author$project$Directories$NetworkListDetail$Main$renderNetworkDetails, model, network, data)
						]))
				]));
	});
var $author$project$Directories$NetworkListDetail$Main$contentView = F3(
	function (model, network, data) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Directories$NetworkListDetail$Main$detailsBar, model, network, data),
					A3($author$project$Directories$NetworkListDetail$Main$body, model, network, data)
				]));
	});
var $author$project$Directories$NetworkListDetail$Main$loadingView = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
var $author$project$Directories$NetworkListDetail$Main$handleNetworkLoaded = F2(
	function (model, networkName) {
		var _v0 = model.details;
		switch (_v0.$) {
			case 'Loaded':
				var networkDetails = _v0.a;
				return A3(
					$author$project$Directories$NetworkListDetail$Main$contentView,
					model,
					$author$project$Directories$Common$Network$networkFromName(networkName),
					networkDetails);
			case 'Loading':
				return $author$project$Directories$NetworkListDetail$Main$loadingView;
			case 'Suspended':
				return $author$project$Directories$NetworkListDetail$Main$loadingView;
			default:
				return $author$project$Directories$NetworkListDetail$Main$errorView;
		}
	});
var $author$project$Directories$NetworkListDetail$Main$render = function (model) {
	var _v0 = model.network;
	if (_v0.$ === 'Just') {
		var x = _v0.a;
		return A2($author$project$Directories$NetworkListDetail$Main$handleNetworkLoaded, model, x);
	} else {
		return $author$project$Directories$NetworkListDetail$Main$errorView;
	}
};
var $author$project$Directories$NetworkListDetail$Main$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section--solid')
					]),
				_List_fromArray(
					[
						$author$project$Directories$NetworkListDetail$Main$render(model)
					]))
			]));
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$PinMeTo$Ui$Select$Opening = {$: 'Opening'};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$PinMeTo$Ui$Select$fitToViewportWidth = F3(
	function (inset, buttonDom, dropdownDom) {
		var naturalWidth = $elm$core$Basics$ceiling(dropdownDom.element.width);
		var right = $elm$core$Basics$ceiling(buttonDom.viewport.width - buttonDom.element.x);
		var fitsRight = _Utils_cmp(naturalWidth, right - inset.right) < 1;
		var left = $elm$core$Basics$floor(buttonDom.element.x + buttonDom.element.width);
		var moreSpaceRight = _Utils_cmp(right - inset.right, left - inset.left) > -1;
		if (fitsRight || moreSpaceRight) {
			return {
				x: $elm$core$Basics$floor(buttonDom.element.x),
				width: A2(
					$elm$core$Basics$max,
					$elm$core$Basics$ceiling(buttonDom.element.width),
					A2($elm$core$Basics$min, right - inset.right, naturalWidth))
			};
		} else {
			var width = A2(
				$elm$core$Basics$max,
				$elm$core$Basics$ceiling(buttonDom.element.width),
				A2($elm$core$Basics$min, left - inset.left, naturalWidth));
			return {
				x: $elm$core$Basics$ceiling(buttonDom.element.x + buttonDom.element.width) - width,
				width: width
			};
		}
	});
var $author$project$PinMeTo$Ui$Select$Above = {$: 'Above'};
var $author$project$PinMeTo$Ui$Select$Below = {$: 'Below'};
var $author$project$PinMeTo$Ui$Select$Element = F2(
	function (a, b) {
		return {$: 'Element', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Select$fitToViewportHeight = F4(
	function (inset, buttonDom, dropdownDom, horizontal) {
		var naturalHeight = $elm$core$Basics$ceiling(dropdownDom.element.height) - 1;
		var bottom = $elm$core$Basics$ceiling((buttonDom.viewport.height - (buttonDom.element.y + buttonDom.element.height)) + buttonDom.viewport.y);
		var fitsDown = _Utils_cmp(naturalHeight, bottom - inset.bottom) < 1;
		var top = $elm$core$Basics$floor((buttonDom.element.y + buttonDom.element.height) - buttonDom.viewport.y);
		var moreSpaceDown = _Utils_cmp(bottom - inset.bottom, top - inset.top) > -1;
		return (fitsDown || moreSpaceDown) ? A2(
			$author$project$PinMeTo$Ui$Select$Element,
			$author$project$PinMeTo$Ui$Select$Below,
			{
				x: horizontal.x,
				y: top,
				width: horizontal.width,
				height: A2($elm$core$Basics$min, naturalHeight, bottom - inset.bottom)
			}) : A2(
			$author$project$PinMeTo$Ui$Select$Element,
			$author$project$PinMeTo$Ui$Select$Above,
			{
				x: horizontal.x,
				y: bottom,
				width: horizontal.width,
				height: A2($elm$core$Basics$min, naturalHeight, top - inset.top)
			});
	});
var $author$project$PinMeTo$Ui$Select$fitToViewport = F3(
	function (inset, buttonDom, dropdownDom) {
		return A4(
			$author$project$PinMeTo$Ui$Select$fitToViewportHeight,
			inset,
			buttonDom,
			dropdownDom,
			A3($author$project$PinMeTo$Ui$Select$fitToViewportWidth, inset, buttonDom, dropdownDom));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $author$project$PinMeTo$Ui$Select$focusSearchTask = function (uid) {
	return A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($author$project$PinMeTo$Ui$Select$NoOp),
		$elm$browser$Browser$Dom$focus(
			$author$project$PinMeTo$Ui$Select$searchInputId(uid)));
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (result.$ === 'Ok') {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$PinMeTo$Ui$Select$FitToViewport = F3(
	function (a, b, c) {
		return {$: 'FitToViewport', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Ui$Select$getDropdownElementTask = F2(
	function (uid, inset) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return {buttonDom: a, dropdownDom: b};
					}),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$map(
						A2($author$project$PinMeTo$Ui$Select$FitToViewport, uid, inset)),
					$elm$core$Result$withDefault($author$project$PinMeTo$Ui$Select$NoOp))),
			A2(
				$elm$core$Task$andThen,
				function (a) {
					return A2(
						$elm$core$Task$andThen,
						function (b) {
							return $elm$core$Task$succeed(
								_Utils_Tuple2(a, b));
						},
						$elm$browser$Browser$Dom$getElement(
							$author$project$PinMeTo$Ui$Select$dropdownId(uid)));
				},
				$elm$browser$Browser$Dom$getElement(
					$author$project$PinMeTo$Ui$Select$selectId(uid))));
	});
var $author$project$PinMeTo$Ui$Select$update = F3(
	function (tagger, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'ToggleOpen':
				var uid = msg.a;
				var inset = msg.b;
				return _Utils_Tuple2(
					A2($author$project$PinMeTo$Ui$Select$isOpen, uid, model) ? $author$project$PinMeTo$Ui$Select$State(
						_Utils_update(
							model,
							{isOpen: $elm$core$Maybe$Nothing, element: $elm$core$Maybe$Nothing})) : $author$project$PinMeTo$Ui$Select$State(
						_Utils_update(
							model,
							{
								isOpen: $elm$core$Maybe$Just(uid),
								element: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$Select$Opening)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						tagger,
						A2($author$project$PinMeTo$Ui$Select$getDropdownElementTask, uid, inset)));
			case 'Search':
				var x = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Select$State(
						_Utils_update(
							model,
							{searchQuery: x})),
					$elm$core$Platform$Cmd$none);
			case 'Close':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Select$State(
						_Utils_update(
							model,
							{isOpen: $elm$core$Maybe$Nothing, searchQuery: ''})),
					$elm$core$Platform$Cmd$none);
			case 'FitToViewport':
				var uid = msg.a;
				var inset = msg.b;
				var dropdownDom = msg.c.dropdownDom;
				var buttonDom = msg.c.buttonDom;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Select$State(
						_Utils_update(
							model,
							{
								element: $elm$core$Maybe$Just(
									A3($author$project$PinMeTo$Ui$Select$fitToViewport, inset, buttonDom, dropdownDom))
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						tagger,
						$author$project$PinMeTo$Ui$Select$focusSearchTask(uid)));
			case 'NoOp':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Select$State(model),
					$elm$core$Platform$Cmd$none);
			default:
				var _v2 = msg.a;
				return _Utils_Tuple2($author$project$PinMeTo$Ui$Select$init, $elm$core$Platform$Cmd$none);
		}
	});
var $lukewestby$elm_http_builder$HttpBuilder$put = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('PUT');
var $author$project$Directories$NetworkListDetail$Command$encodeConnection = function (connection) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(connection.enabled))
			]));
};
var $author$project$Directories$NetworkListDetail$Command$enableNetwork = F4(
	function (msg, connection, siteName, networkName) {
		var network = $author$project$Directories$Common$Network$networkFromName(networkName);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Directories$NetworkListDetail$Command$statusDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Directories$NetworkListDetail$Command$encodeConnection(connection),
					$lukewestby$elm_http_builder$HttpBuilder$put(
						'api/' + ($author$project$Directories$Common$SiteName$siteNameToString(siteName) + ('/network/networkConnections/' + network.key))))));
	});
var $author$project$Directories$NetworkListDetail$Model$NetworkStatusChanged = function (a) {
	return {$: 'NetworkStatusChanged', a: a};
};
var $author$project$Directories$NetworkListDetail$Main$toggleNetworkConnection = function (model) {
	var _v0 = model.details;
	if (_v0.$ === 'Loaded') {
		var x = _v0.a;
		return {enabled: !x.status.enabled, isConnected: x.status.isConnected, customerCanEnable: x.status.customerCanEnable};
	} else {
		return {enabled: false, isConnected: false, customerCanEnable: false};
	}
};
var $author$project$Directories$NetworkListDetail$Main$handleSelected = F2(
	function (model, selection) {
		switch (selection.$) {
			case 'ConnectionPage':
				return $elm$browser$Browser$Navigation$load(
					'/account-settings/' + ($author$project$Directories$Common$SiteName$siteNameToString(model.siteName) + '/connections'));
			case 'DisableNetwork':
				var connection = $author$project$Directories$NetworkListDetail$Main$toggleNetworkConnection(model);
				var _v1 = model.network;
				if (_v1.$ === 'Just') {
					var network = _v1.a;
					return A4($author$project$Directories$NetworkListDetail$Command$enableNetwork, $author$project$Directories$NetworkListDetail$Model$NetworkStatusChanged, connection, model.siteName, network);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			default:
				var connection = $author$project$Directories$NetworkListDetail$Main$toggleNetworkConnection(model);
				var _v2 = model.network;
				if (_v2.$ === 'Just') {
					var network = _v2.a;
					return A4($author$project$Directories$NetworkListDetail$Command$enableNetwork, $author$project$Directories$NetworkListDetail$Model$NetworkStatusChanged, connection, model.siteName, network);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
		}
	});
var $author$project$Directories$NetworkListDetail$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'HandleFlags':
				var flagsValue = msg.a;
				return $author$project$Directories$NetworkListDetail$Main$init(flagsValue);
			case 'GetNetworkDetails':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var networkDetails = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								details: $author$project$RemoteData$Loaded(networkDetails)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$author$project$Directories$NetworkListDetail$Main$initialModel,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Directories.NetworkListDetail.Main.Update.GetNetworkDetails', message: 'GetNetworkdetails Error'}));
				}
			case 'NetworkStatusChanged':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var _v3 = model.network;
					if (_v3.$ === 'Just') {
						var x = _v3.a;
						return _Utils_Tuple2(
							model,
							A2($author$project$Directories$NetworkListDetail$Command$getNetworkDetails, model.siteName, x));
					} else {
						return _Utils_Tuple2(
							$author$project$Directories$NetworkListDetail$Main$initialModel,
							$author$project$PinMeTo$Logger$log(
								{data: 'Invalid siteName', context: 'Directories.NetworkListDetail.Main.Update.NetworkStatusChanged', message: 'invalid siteName'}));
					}
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$author$project$Directories$NetworkListDetail$Main$initialModel,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Directories.NetworkListDetail.Main.Update.NetworkStatusChanged', message: 'Http error getting network status'}));
				}
			case 'ShowParentUrl':
				var urlString = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(urlString));
			case 'SelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{selectState: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Directories$NetworkListDetail$Model$SelectMsg, msg_, model.selectState));
			default:
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selected: $elm$core$Maybe$Just(x)
						}),
					A2($author$project$Directories$NetworkListDetail$Main$handleSelected, model, x));
		}
	});
var $author$project$Directories$NetworkListDetail$Model$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Directories$NetworkListDetail$Main$passArgs_Directories_NetworkListDetail_Main = _Platform_incomingPort('passArgs_Directories_NetworkListDetail_Main', $elm$json$Json$Decode$value);
var $author$project$Directories$NetworkListDetail$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Directories$NetworkListDetail$Main$passArgs_Directories_NetworkListDetail_Main($author$project$Directories$NetworkListDetail$Model$HandleFlags)
			]));
};
var $author$project$Directories$NetworkListDetail$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Directories$NetworkListDetail$Main$init, view: $author$project$Directories$NetworkListDetail$Main$view, update: $author$project$Directories$NetworkListDetail$Main$update, subscriptions: $author$project$Directories$NetworkListDetail$Main$subscriptions});
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$init = $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$State(
	{uiSelect: $author$project$PinMeTo$Ui$Select$init});
var $author$project$PinMeTo$Ui$FilterController$State = F2(
	function (a, b) {
		return {$: 'State', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$FilterController$Default = {$: 'Default'};
var $author$project$PinMeTo$Ui$FilterController$Loading = {$: 'Loading'};
var $author$project$PinMeTo$Ui$FilterController$Suspended = {$: 'Suspended'};
var $author$project$PinMeTo$Ui$FilterController$ReceivedPropertyDefinitions = function (a) {
	return {$: 'ReceivedPropertyDefinitions', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$init = F3(
	function (getPropertyDefinitions, initialQuery, initialFilterDefinition) {
		return _Utils_Tuple2(
			A2(
				$author$project$PinMeTo$Ui$FilterController$State,
				{propertyDefinitions: $author$project$PinMeTo$Ui$FilterController$Loading},
				{
					inputStyle: $author$project$PinMeTo$Ui$FilterController$Default,
					searchQuery: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, initialQuery),
					filterEditor: $author$project$PinMeTo$Ui$FilterController$Suspended,
					savedFilters: $author$project$PinMeTo$Ui$FilterController$Loading,
					searchOptions: $elm$core$Maybe$Nothing,
					selectedFilter: $elm$core$Maybe$Nothing,
					filterDefinition: initialFilterDefinition,
					propertyDefinitions: $elm$core$Dict$empty,
					searchOptionsToggled: false,
					uiSavedFiltersSelect: $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$init
				}),
			getPropertyDefinitions($author$project$PinMeTo$Ui$FilterController$ReceivedPropertyDefinitions));
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$SelectorBrandPage$init = $author$project$PinMeTo$Ui$SelectorBrandPage$State(
	{selector: $elm$core$Maybe$Nothing});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init = $author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(
	{selector: $elm$core$Maybe$Nothing});
var $author$project$PinMeTo$Ui$Filter$FilterForm$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterForm$init = $author$project$PinMeTo$Ui$Filter$FilterForm$State(
	{uiSelect: $author$project$PinMeTo$Ui$Select$init, brandPageSelector: $author$project$PinMeTo$Ui$SelectorBrandPage$init, locationSelectorWithFilters: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init});
var $author$project$PinMeTo$Global$FilterController$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Global$FilterController$UiFilterControllerMsg = function (a) {
	return {$: 'UiFilterControllerMsg', a: a};
};
var $lukewestby$elm_http_builder$HttpBuilder$withCredentials = function (builder) {
	return _Utils_update(
		builder,
		{withCredentials: true});
};
var $author$project$PinMeTo$Api$FilterApi$filterTypeToString = function (x) {
	switch (x.$) {
		case 'Location':
			return 'locationList';
		case 'Insights':
			return 'insights';
		case 'LocationPosts':
			return 'locationPostList';
		case 'Issues':
			return 'listenSavedIssueFilter';
		case 'ListenInsights':
			return 'listenInsightsFilter';
		case 'MediaReview':
			return 'mediaReview';
		case 'PostInsights':
			return 'postInsights';
		case 'AccessManagerUserList':
			return 'accessManagerUserList';
		default:
			return 'networkLog';
	}
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$enum = function (enumValues) {
	return $elm$json$Json$Decode$oneOf(
		A2(
			$elm$core$List$map,
			function (enumValue) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (s) {
						return _Utils_eq(s, enumValue) ? $elm$json$Json$Decode$succeed(s) : $elm$json$Json$Decode$fail('Unknown type \u0027' + (s + '\u0027'));
					},
					$elm$json$Json$Decode$string);
			},
			enumValues));
};
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$MultiProperty = function (a) {
	return {$: 'MultiProperty', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$SingleProperty = function (a) {
	return {$: 'SingleProperty', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$AnyTextProperty = function (a) {
	return {$: 'AnyTextProperty', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$Property = function (a) {
	return {$: 'Property', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$propertyDecoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Ui$Filter$DataTypes$Property, $elm$json$Json$Decode$string);
var $author$project$PinMeTo$Ui$Filter$DataTypes$MultiTextProperty = function (a) {
	return {$: 'MultiTextProperty', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$LocationSelectorProperty = function (a) {
	return {$: 'LocationSelectorProperty', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$BrandPageSelectorProperty = function (a) {
	return {$: 'BrandPageSelectorProperty', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$propertyDefinitionDecoder = function () {
	var keyLabelDecoder = function () {
		var intOrStringAsString = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
				]));
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			intOrStringAsString,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'key',
				intOrStringAsString,
				$elm$json$Json$Decode$succeed(
					F2(
						function (key, label) {
							return {key: key, label: label};
						}))));
	}();
	return A7(
		$elm$json$Json$Decode$map6,
		F6(
			function (property, displayName, sortOrder, type_, _default, values) {
				var def = {
					values: values,
					_default: _default,
					property: property,
					sortOrder: A2($elm$core$Maybe$withDefault, 9999, sortOrder),
					displayName: displayName
				};
				switch (type_) {
					case 'Single':
						return $author$project$PinMeTo$Ui$Filter$DataTypes$SingleProperty(def);
					case 'Multi':
						return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiProperty(def);
					case 'AnyText':
						return $author$project$PinMeTo$Ui$Filter$DataTypes$AnyTextProperty(def);
					case 'MultiText':
						return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiTextProperty(def);
					case 'LocationSelector':
						return $author$project$PinMeTo$Ui$Filter$DataTypes$LocationSelectorProperty(def);
					case 'BrandPageSelector':
						return $author$project$PinMeTo$Ui$Filter$DataTypes$BrandPageSelectorProperty(def);
					default:
						return $author$project$PinMeTo$Ui$Filter$DataTypes$SingleProperty(def);
				}
			}),
		A2($elm$json$Json$Decode$field, 'property', $author$project$PinMeTo$Ui$Filter$DataTypes$propertyDecoder),
		A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'sortOrder', $elm$json$Json$Decode$int)),
		A2(
			$elm$json$Json$Decode$field,
			'type',
			$author$project$PinMeTo$Ui$Filter$DataTypes$enum(
				_List_fromArray(
					['Single', 'Multi', 'AnyText', 'MultiText', 'LocationSelector', 'BrandPageSelector']))),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'default',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'values',
			$elm$json$Json$Decode$nullable(
				$elm$json$Json$Decode$list(keyLabelDecoder))));
}();
var $author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionDecoder = $elm$json$Json$Decode$list($author$project$PinMeTo$Ui$Filter$DataTypes$propertyDefinitionDecoder);
var $author$project$PinMeTo$Api$FilterApi$getPropertyDefinitions = F3(
	function (siteName, filterType, msg) {
		var url = function () {
			switch (filterType.$) {
				case 'Issues':
					return '/listen-and-respond/api/' + (siteName + ('/propertyDefinition/' + $author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType)));
				case 'ListenInsights':
					return '/listen-and-respond/api/' + (siteName + ('/propertyDefinition/' + $author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType)));
				case 'AccessManagerUserList':
					return '/account-settings/api/filter/' + (siteName + ('/propertyDefinition/' + $author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType)));
				default:
					return '/api/filter/' + (siteName + ('/propertyDefinition/' + $author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType)));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$PinMeTo$Global$FilterController$init = function (_v0) {
	var filterDefinition = _v0.filterDefinition;
	var query = _v0.query;
	var filterType = _v0.filterType;
	var siteName = _v0.siteName;
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$PinMeTo$Global$FilterController$UiFilterControllerMsg),
		A2(
			$elm$core$Tuple$mapFirst,
			function (x) {
				return $author$project$PinMeTo$Global$FilterController$State(
					{
						debounce: 0,
						siteName: siteName,
						filterType: filterType,
						searchQuery: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, query),
						uiFilterForm: $author$project$PinMeTo$Ui$Filter$FilterForm$init,
						filterDefinition: filterDefinition,
						uiFilterController: x
					});
			},
			A3(
				$author$project$PinMeTo$Ui$FilterController$init,
				A2($author$project$PinMeTo$Api$FilterApi$getPropertyDefinitions, siteName, filterType),
				query,
				filterDefinition)));
};
var $author$project$Filter$FilterController$UiFilteredListMsg = function (a) {
	return {$: 'UiFilteredListMsg', a: a};
};
var $author$project$Filter$FilterController$init = F4(
	function (siteName, query, filterType, filterDefinition) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Filter$FilterController$UiFilteredListMsg),
			A2(
				$elm$core$Tuple$mapFirst,
				function (x) {
					return {filterType: filterType, currentFilter: $elm$core$Maybe$Nothing, uiFilteredList: x};
				},
				$author$project$PinMeTo$Global$FilterController$init(
					{query: query, siteName: siteName, filterType: filterType, filterDefinition: filterDefinition})));
	});
var $author$project$Common$Filter$FilterControllerPort$Flags = F7(
	function (siteName, initialFilter, query, filterType, locale, translations, language) {
		return {query: query, locale: locale, language: language, siteName: siteName, filterType: filterType, translations: translations, initialFilter: initialFilter};
	});
var $author$project$PinMeTo$Ui$I18n$Locale$De = {$: 'De'};
var $author$project$PinMeTo$Ui$I18n$Locale$Es = {$: 'Es'};
var $author$project$PinMeTo$Ui$I18n$Locale$Fi = {$: 'Fi'};
var $author$project$PinMeTo$Ui$I18n$Locale$Fr = {$: 'Fr'};
var $author$project$PinMeTo$Ui$I18n$Locale$Pl = {$: 'Pl'};
var $author$project$PinMeTo$Ui$I18n$Locale$Pt = {$: 'Pt'};
var $author$project$PinMeTo$Ui$I18n$Locale$EnGb = {$: 'EnGb'};
var $author$project$PinMeTo$Ui$I18n$Locale$EnUs = {$: 'EnUs'};
var $author$project$PinMeTo$Ui$I18n$Locale$SvSe = {$: 'SvSe'};
var $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale = {$: 'BrowserLocale'};
var $author$project$PinMeTo$Ui$I18n$Locale$fromString = function (x) {
	switch (x) {
		case 'en-us':
			return $author$project$PinMeTo$Ui$I18n$Locale$EnUs;
		case 'en-gb':
			return $author$project$PinMeTo$Ui$I18n$Locale$EnGb;
		case 'fr':
			return $author$project$PinMeTo$Ui$I18n$Locale$Fr;
		case 'de':
			return $author$project$PinMeTo$Ui$I18n$Locale$De;
		case 'es':
			return $author$project$PinMeTo$Ui$I18n$Locale$Es;
		case 'sv-se':
			return $author$project$PinMeTo$Ui$I18n$Locale$SvSe;
		case 'fi':
			return $author$project$PinMeTo$Ui$I18n$Locale$Fi;
		case 'pl':
			return $author$project$PinMeTo$Ui$I18n$Locale$Pl;
		case 'pt-pt':
			return $author$project$PinMeTo$Ui$I18n$Locale$Pt;
		default:
			return $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale;
	}
};
var $author$project$PinMeTo$Ui$I18n$Locale$decoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Ui$I18n$Locale$fromString, $elm$json$Json$Decode$string);
var $author$project$PinMeTo$Api$FilterApi$Insights = {$: 'Insights'};
var $author$project$PinMeTo$Api$FilterApi$Location = {$: 'Location'};
var $author$project$Common$Filter$FilterControllerPort$filterTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'insights':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Api$FilterApi$Insights);
			case 'locations':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Api$FilterApi$Location);
			default:
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Api$FilterApi$Location);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinition = F3(
	function (id, name, filter) {
		return {id: id, name: name, filter: filter};
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue = function (a) {
	return {$: 'MultiValue', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue = function (a) {
	return {$: 'SingleValue', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter = F3(
	function (a, b, c) {
		return {$: 'PropertyFilter', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$filterDecoder = function (propertyDefinitions) {
	var valuesDecoder = A2(
		$elm$json$Json$Decode$map,
		A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue, $elm$core$Maybe$Just),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
	var valueDecoder = A2(
		$elm$json$Json$Decode$map,
		function (value) {
			return A2(
				$elm$core$Maybe$andThen,
				function (x) {
					return $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue(x));
				},
				value);
		},
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string));
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (_v0, value) {
				var property = _v0.a;
				var propertyDef = A2($elm$core$Dict$get, property, propertyDefinitions);
				var _v1 = _Utils_Tuple2(value, propertyDef);
				if (_v1.a.$ === 'Just') {
					if (_v1.b.$ === 'Just') {
						var v = _v1.a.a;
						var pd = _v1.b.a;
						return $elm$core$Maybe$Just(
							A3(
								$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
								$author$project$PinMeTo$Ui$Filter$DataTypes$Property(property),
								v,
								$elm$core$Maybe$Just(pd)));
					} else {
						var v = _v1.a.a;
						var _v2 = _v1.b;
						return $elm$core$Dict$isEmpty(propertyDefinitions) ? $elm$core$Maybe$Just(
							A3(
								$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
								$author$project$PinMeTo$Ui$Filter$DataTypes$Property(property),
								v,
								$elm$core$Maybe$Nothing)) : $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}),
		A2($elm$json$Json$Decode$field, 'property', $author$project$PinMeTo$Ui$Filter$DataTypes$propertyDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'value',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[valuesDecoder, valueDecoder]))));
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$dictFilterDecoder = function (propertyDefinitions) {
	return A2(
		$elm$json$Json$Decode$map,
		function (filters) {
			return $elm$core$Dict$fromList(
				$elm_community$maybe_extra$Maybe$Extra$values(
					A2(
						$elm$core$List$map,
						$elm$core$Maybe$map(
							function (_v0) {
								var name = _v0.a.a;
								var propertyValue = _v0.b;
								var propertyDefinition = _v0.c;
								return _Utils_Tuple2(
									name,
									A3(
										$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
										$author$project$PinMeTo$Ui$Filter$DataTypes$Property(name),
										propertyValue,
										propertyDefinition));
							}),
						filters)));
		},
		$elm$json$Json$Decode$list(
			$author$project$PinMeTo$Ui$Filter$DataTypes$filterDecoder(propertyDefinitions)));
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinitionId = function (a) {
	return {$: 'FilterDefinitionId', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder = function (propertyDefinitions) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'filterDefinition',
		$author$project$PinMeTo$Ui$Filter$DataTypes$dictFilterDecoder(propertyDefinitions),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'_id',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					$author$project$PinMeTo$Common$Util$idDecoder($author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinitionId)),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinition))));
};
var $author$project$Common$Filter$FilterControllerPort$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locale',
			$author$project$PinMeTo$Ui$I18n$Locale$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filterType',
				$author$project$Common$Filter$FilterControllerPort$filterTypeDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'query',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'initialFilter',
						$elm$json$Json$Decode$nullable(
							$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'siteName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Common$Filter$FilterControllerPort$Flags))))))));
var $author$project$Common$Filter$FilterControllerPort$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Common$Filter$FilterControllerPort$flagsDecoder, flagsValue);
};
var $author$project$Common$Filter$FilterControllerPort$FailedToDecodeFlags = {$: 'FailedToDecodeFlags'};
var $author$project$Common$Filter$FilterControllerPort$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Common$Filter$FilterControllerPort$init = function (flagsValue) {
	var _v0 = $author$project$Common$Filter$FilterControllerPort$decodeFlags(flagsValue);
	if (_v0.$ === 'Ok') {
		var flags = _v0.a;
		var _v1 = A4($author$project$Filter$FilterController$init, flags.siteName, flags.query, flags.filterType, flags.initialFilter);
		var filterControllerModel_ = _v1.a;
		var filterControllerCmd_ = _v1.b;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{locale: flags.locale, language: flags.language, siteName: flags.siteName, translations: flags.translations, filterController: filterControllerModel_}),
			A2($elm$core$Platform$Cmd$map, $author$project$Common$Filter$FilterControllerPort$FilterControllerMsg, filterControllerCmd_));
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err($author$project$Common$Filter$FilterControllerPort$FailedToDecodeFlags),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Common.Filter.FilterControllerPort',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$PinMeTo$Ui$FilterController$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$view = function (_v0) {
	var labels = _v0.labels;
	var locale = _v0.locale;
	var uid = _v0.uid;
	return $author$project$PinMeTo$Ui$FilterController$View(
		{uid: uid, labels: labels, locale: locale, allCount: $elm$core$Maybe$Nothing, rightNode: $elm$core$Maybe$Nothing, resultsCount: $elm$core$Maybe$Nothing, resultsCountNode: $elm$core$Maybe$Nothing, resultsCountLabel: $elm$core$Maybe$Nothing, resultsCountCutoff: $elm$core$Maybe$Nothing, unselectablesCount: $elm$core$Maybe$Nothing, withSearchOptionsOnly: false});
};
var $author$project$Translations$General$filter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.filter');
};
var $author$project$PinMeTo$Ui$FilterController$LoadedMsg = function (a) {
	return {$: 'LoadedMsg', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faXmark = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-xmark');
var $author$project$FontAwesome$Solid$faXmark = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faXmark);
var $author$project$PinMeTo$Ui$FilterController$ClearSearchOptions = {$: 'ClearSearchOptions'};
var $author$project$PinMeTo$Ui$Filter$DataTypes$toPropertyValueFromList = F2(
	function (propDef, values) {
		switch (propDef.$) {
			case 'SingleProperty':
				return $author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(values)));
			case 'MultiProperty':
				return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(values);
			case 'AnyTextProperty':
				return $author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(values)));
			case 'MultiTextProperty':
				return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(values);
			case 'LocationSelectorProperty':
				return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(values);
			default:
				return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(values);
		}
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions = function (propertyDefinitions) {
	var defaultFilter = F3(
		function (propertyDefinition, propertyName, meta) {
			return A2(
				$elm$core$Maybe$map,
				function (value) {
					return _Utils_Tuple2(
						propertyName,
						A3(
							$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
							meta.property,
							value,
							$elm$core$Maybe$Just(propertyDefinition)));
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$PinMeTo$Ui$Filter$DataTypes$toPropertyValueFromList(propertyDefinition),
					meta._default));
		});
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var propertyName = _v0.a;
				var propertyDefinition = _v0.b;
				switch (propertyDefinition.$) {
					case 'SingleProperty':
						var meta = propertyDefinition.a;
						return A3(defaultFilter, propertyDefinition, propertyName, meta);
					case 'MultiProperty':
						var meta = propertyDefinition.a;
						return A3(defaultFilter, propertyDefinition, propertyName, meta);
					case 'AnyTextProperty':
						var meta = propertyDefinition.a;
						return A3(defaultFilter, propertyDefinition, propertyName, meta);
					case 'MultiTextProperty':
						var meta = propertyDefinition.a;
						return A3(defaultFilter, propertyDefinition, propertyName, meta);
					case 'LocationSelectorProperty':
						var meta = propertyDefinition.a;
						return A3(defaultFilter, propertyDefinition, propertyName, meta);
					default:
						var meta = propertyDefinition.a;
						return A3(defaultFilter, propertyDefinition, propertyName, meta);
				}
			},
			$elm$core$Dict$toList(propertyDefinitions)));
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$getFilterFieldCount = F2(
	function (propertyDefinitions, filter) {
		var _default = $author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions(propertyDefinitions);
		return $elm$core$Dict$size(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (propertyName, value) {
						return A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								function (x) {
									return !_Utils_eq(x, value);
								},
								A2($elm$core$Dict$get, propertyName, _default)));
					}),
				filter));
	});
var $author$project$PinMeTo$Ui$FilterController$renderFilterCount = F2(
	function (propertyDefinitions, filterDefinition) {
		var count = A2($author$project$PinMeTo$Ui$Filter$DataTypes$getFilterFieldCount, propertyDefinitions, filterDefinition.filter);
		return (count > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-controller-filter-count')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-controller-filter-count__value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(count))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-controller-filter-count__button'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick($author$project$PinMeTo$Ui$FilterController$ClearSearchOptions)
						]),
					_List_fromArray(
						[$author$project$FontAwesome$Solid$faXmark]))
				])) : $elm$html$Html$text('');
	});
var $author$project$PinMeTo$Ui$FilterController$renderResultCount = function (config) {
	var _v0 = config.resultsCount;
	if (_v0.$ === 'Just') {
		var count = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-controller__matches')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = config.resultsCountCutoff;
					if (_v1.$ === 'Just') {
						var resultsCountCutoff = _v1.a;
						return ((!_Utils_eq(config.unselectablesCount, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
							config.unselectablesCount,
							$elm$core$Maybe$Just(0)))) ? $elm$html$Html$text(
							config.labels.numberOfItemsWithUnselectables(
								{
									totalCount: count,
									unselectableCount: A2($elm$core$Maybe$withDefault, 0, config.unselectablesCount)
								})) : ((_Utils_cmp(count, resultsCountCutoff) > -1) ? $elm$html$Html$text(
							config.labels.numberOfItemsLimited(
								$elm$core$String$fromInt(resultsCountCutoff - 1) + '+')) : $elm$html$Html$text(
							config.labels.numberOfItems(count)));
					} else {
						return ((!_Utils_eq(config.unselectablesCount, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
							config.unselectablesCount,
							$elm$core$Maybe$Just(0)))) ? $elm$html$Html$text(
							config.labels.numberOfItemsWithUnselectables(
								{
									totalCount: count,
									unselectableCount: A2($elm$core$Maybe$withDefault, 0, config.unselectablesCount)
								})) : $elm$html$Html$text(
							config.labels.numberOfItems(count));
					}
				}()
				]));
	} else {
		var _v2 = config.resultsCountNode;
		if (_v2.$ === 'Just') {
			var node = _v2.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-filter-controller__matches')
					]),
				_List_fromArray(
					[node]));
		} else {
			return $elm$html$Html$text('');
		}
	}
};
var $author$project$PinMeTo$Ui$FilterController$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$FontAwesome$Regular$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$FontAwesome$Regular$Icon$faBarsFilter = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-bars-filter');
var $author$project$FontAwesome$Regular$faBarsFilter = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faBarsFilter);
var $author$project$PinMeTo$Ui$Form$Input$withDisabled = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{disabled: x}));
	});
var $author$project$PinMeTo$Ui$FilterController$ToggleSearchOptions = {$: 'ToggleSearchOptions'};
var $author$project$PinMeTo$Ui$FilterController$renderSearchInput = F2(
	function (model, config) {
		var toggle = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$PinMeTo$Ui$FilterController$ToggleSearchOptions),
					$elm$html$Html$Attributes$class('pmt-ui-filter-controller__search-options-toggle'),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$disabled(
					_Utils_eq(model.searchOptions, $elm$core$Maybe$Nothing))
				]),
			_List_fromArray(
				[
					$author$project$FontAwesome$Regular$faBarsFilter,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-controller__filters__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.labels.addFilters)
						]))
				]));
		return config.withSearchOptionsOnly ? toggle : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-controller__search')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withDisabled,
						_Utils_eq(model.searchOptions, $elm$core$Maybe$Nothing),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
							config.labels.searchItemsPlaceholder,
							$author$project$PinMeTo$Ui$Form$Input$search(
								{value: model.searchQuery, onChange: $author$project$PinMeTo$Ui$FilterController$OnSearch})))),
					toggle
				]));
	});
var $author$project$PinMeTo$Ui$Form$Input$Text = {$: 'Text'};
var $author$project$PinMeTo$Ui$Form$Input$text = function (config_) {
	return $author$project$PinMeTo$Ui$Form$Input$Input(
		A2($author$project$PinMeTo$Ui$Form$Input$configWithType, $author$project$PinMeTo$Ui$Form$Input$Text, config_));
};
var $author$project$PinMeTo$Ui$FilterController$inputId = 'filter-search';
var $author$project$PinMeTo$Ui$FilterController$FocusError = {$: 'FocusError'};
var $author$project$PinMeTo$Ui$FilterController$FocusInput = {$: 'FocusInput'};
var $author$project$PinMeTo$Ui$Btn$pmtBtnNegative = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--default pmt-btn--brand-4');
var $author$project$PinMeTo$Ui$Form$Input$Id = function (a) {
	return {$: 'Id', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$withFocusError = F2(
	function (id, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					id: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Form$Input$Id(id)),
					inFocusError: true
				}));
	});
var $author$project$PinMeTo$Ui$FilterController$FilterEditorSave = function (a) {
	return {$: 'FilterEditorSave', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$FilterEditorClose = function (a) {
	return {$: 'FilterEditorClose', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$FilterEditorReset = function (a) {
	return {$: 'FilterEditorReset', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$FilterEditorDelete = function (a) {
	return {$: 'FilterEditorDelete', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$Saved = function (a) {
	return {$: 'Saved', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$UnSaved = function (a) {
	return {$: 'UnSaved', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$SearchOption = function (a) {
	return {$: 'SearchOption', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$fromFilterDefinition = function (x) {
	var _v0 = _Utils_Tuple3(x.id, x.name, x.filter);
	_v0$2:
	while (true) {
		if (_v0.a.$ === 'Just') {
			if (_v0.b.$ === 'Just') {
				var id = _v0.a.a.a;
				var name = _v0.b.a;
				var filter = _v0.c;
				return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$Saved(
					{id: id, name: name, filter: filter, changes: filter});
			} else {
				break _v0$2;
			}
		} else {
			if (_v0.b.$ === 'Just') {
				var _v1 = _v0.a;
				var name = _v0.b.a;
				var filter = _v0.c;
				return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$UnSaved(
					{name: name, filter: filter});
			} else {
				break _v0$2;
			}
		}
	}
	var filter = _v0.c;
	return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$SearchOption(filter);
};
var $author$project$PinMeTo$Ui$FilterController$FilterEditorOnNameChange = function (a) {
	return {$: 'FilterEditorOnNameChange', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$renderFilterEditor = F5(
	function (tagger, labels, model, savedFilters, filterForm) {
		var filterIsEmpty = function (filter) {
			return _Utils_eq(filter, $elm$core$Dict$empty);
		};
		var errorMessage = function (_v3) {
			var error = _v3.a;
			return A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$StatusBar$error, $author$project$PinMeTo$Ui$StatusBar$render),
				error);
		};
		var nameExists = function (name) {
			return A2(
				$elm$core$List$any,
				function (x) {
					return _Utils_eq(x.name, name);
				},
				savedFilters);
		};
		var _v0 = model.filterEditor;
		switch (_v0.$) {
			case 'Loaded':
				if (_v0.a.$ === 'NewFilter') {
					var _v1 = _v0.a;
					var error = _v1.a;
					var formData = _v1.b;
					var resetTo = {
						id: $elm$core$Maybe$Nothing,
						name: $elm$core$Maybe$Nothing,
						filter: $author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions(model.propertyDefinitions)
					};
					return $author$project$PinMeTo$Ui$Lightbox$render(
						A3(
							$elm$core$Basics$apR,
							A2(
								$elm$core$Maybe$map,
								$author$project$PinMeTo$Ui$Lightbox$withHeader,
								errorMessage(error)),
							$elm$core$Maybe$withDefault($elm$core$Basics$identity),
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withFooter,
								A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-btn-group')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$PinMeTo$Ui$Btn$pmtBtnPlain,
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														$author$project$PinMeTo$Ui$FilterController$FilterEditorReset(resetTo))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labels.clearAll)
													])),
												A3(
												$author$project$PinMeTo$Ui$Btn$pmtBtn,
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														(formData.name === '') ? $author$project$PinMeTo$Ui$FilterController$FocusInput : $author$project$PinMeTo$Ui$FilterController$FilterEditorSave(
															{
																id: $elm$core$Maybe$Nothing,
																name: $elm$core$Maybe$Just(formData.name),
																filter: formData.filter
															})),
														$elm$html$Html$Attributes$disabled(
														nameExists(formData.name) || filterIsEmpty(formData.filter))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labels.create)
													]))
											]))),
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									tagger(
										$author$project$PinMeTo$Ui$FilterController$LoadedMsg(
											$author$project$PinMeTo$Ui$FilterController$FilterEditorClose(resetTo))),
									$author$project$PinMeTo$Ui$Lightbox$view(
										{
											title: labels.addFilter,
											content: A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor__name')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor__name-label')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(labels.filterName)
																	])),
																$author$project$PinMeTo$Ui$Form$Input$render(
																(_Utils_eq(model.inputStyle, $author$project$PinMeTo$Ui$FilterController$FocusError) ? $author$project$PinMeTo$Ui$Form$Input$withFocusError($author$project$PinMeTo$Ui$FilterController$inputId) : $elm$core$Basics$identity)(
																	A2(
																		$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
																		labels.nameFilterPlaceholder,
																		$author$project$PinMeTo$Ui$Form$Input$text(
																			{
																				value: formData.name,
																				onChange: A2(
																					$elm$core$Basics$composeR,
																					$author$project$PinMeTo$Ui$FilterController$FilterEditorOnNameChange,
																					A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger))
																			}))))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor__filter-form')
															]),
														_List_fromArray(
															[
																A2(
																filterForm,
																'filterEditor',
																$author$project$PinMeTo$Ui$Filter$FilterFormFilter$fromFilterDefinition(
																	{
																		id: $elm$core$Maybe$Nothing,
																		name: $elm$core$Maybe$Just(formData.name),
																		filter: formData.filter
																	}))
															]))
													]))
										})))));
				} else {
					var _v2 = _v0.a;
					var error = _v2.a;
					var filterId = _v2.b;
					var original = _v2.c;
					var formData = _v2.d;
					var resetTo = {
						id: $elm$core$Maybe$Just(filterId),
						name: $elm$core$Maybe$Just(original.name),
						filter: original.filter
					};
					return $author$project$PinMeTo$Ui$Lightbox$render(
						A3(
							$elm$core$Basics$apR,
							A2(
								$elm$core$Maybe$map,
								$author$project$PinMeTo$Ui$Lightbox$withHeader,
								errorMessage(error)),
							$elm$core$Maybe$withDefault($elm$core$Basics$identity),
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withFooter,
								A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-btn-group')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$PinMeTo$Ui$Btn$pmtBtnNegative,
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														$author$project$PinMeTo$Ui$FilterController$FilterEditorDelete(filterId))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labels._delete)
													])),
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-btn-group__divider')
													]),
												_List_Nil),
												A3(
												$author$project$PinMeTo$Ui$Btn$pmtBtnPlain,
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														$author$project$PinMeTo$Ui$FilterController$FilterEditorReset(resetTo))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labels.reset)
													])),
												A3(
												$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														(formData.name === '') ? $author$project$PinMeTo$Ui$FilterController$FocusInput : $author$project$PinMeTo$Ui$FilterController$FilterEditorSave(
															{
																id: $elm$core$Maybe$Nothing,
																name: $elm$core$Maybe$Just(formData.name),
																filter: formData.filter
															})),
														$elm$html$Html$Attributes$disabled(
														nameExists(formData.name) || filterIsEmpty(formData.filter))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labels.saveAsNew)
													])),
												A3(
												$author$project$PinMeTo$Ui$Btn$pmtBtn,
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														(formData.name === '') ? $author$project$PinMeTo$Ui$FilterController$FocusInput : $author$project$PinMeTo$Ui$FilterController$FilterEditorSave(
															{
																id: $elm$core$Maybe$Just(filterId),
																name: $elm$core$Maybe$Just(formData.name),
																filter: formData.filter
															})),
														$elm$html$Html$Attributes$disabled(
														filterIsEmpty(formData.filter) || _Utils_eq(original, formData))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labels.save)
													]))
											]))),
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									tagger(
										$author$project$PinMeTo$Ui$FilterController$LoadedMsg(
											$author$project$PinMeTo$Ui$FilterController$FilterEditorClose(resetTo))),
									$author$project$PinMeTo$Ui$Lightbox$view(
										{
											title: labels.editFilter,
											content: A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor__name')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor__name-label')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(labels.filterName)
																	])),
																$author$project$PinMeTo$Ui$Form$Input$render(
																(_Utils_eq(model.inputStyle, $author$project$PinMeTo$Ui$FilterController$FocusError) ? $author$project$PinMeTo$Ui$Form$Input$withFocusError($author$project$PinMeTo$Ui$FilterController$inputId) : $elm$core$Basics$identity)(
																	A2(
																		$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
																		labels.nameFilterPlaceholder,
																		$author$project$PinMeTo$Ui$Form$Input$text(
																			{
																				value: formData.name,
																				onChange: A2(
																					$elm$core$Basics$composeR,
																					$author$project$PinMeTo$Ui$FilterController$FilterEditorOnNameChange,
																					A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger))
																			}))))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-filter-controller-editor__filter-form')
															]),
														_List_fromArray(
															[
																A2(
																filterForm,
																'filterEditor',
																$author$project$PinMeTo$Ui$Filter$FilterFormFilter$fromFilterDefinition(
																	{
																		id: $elm$core$Maybe$Just(filterId),
																		name: $elm$core$Maybe$Just(formData.name),
																		filter: formData.filter
																	}))
															]))
													]))
										})))));
				}
			case 'Error':
				var error = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$header,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$StatusBar$render(
									$author$project$PinMeTo$Ui$StatusBar$error(error))
								]))
						]));
			case 'Loading':
				return $elm$html$Html$text('');
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$view = function (config) {
	return $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Config(
		{uid: config.uid, onAdd: $elm$core$Maybe$Nothing, onEdit: $elm$core$Maybe$Nothing, filters: config.filters, loading: false, onReset: config.onReset, onSelect: config.onSelect, selected: config.selected});
};
var $author$project$PinMeTo$Ui$Btn$Add = {$: 'Add'};
var $author$project$PinMeTo$Ui$Select$Raw = function (a) {
	return {$: 'Raw', a: a};
};
var $author$project$PinMeTo$Ui$Select$raw = function (config) {
	return A2(
		$author$project$PinMeTo$Ui$Select$configWithRenderer,
		{
			uid: $author$project$PinMeTo$Ui$Select$Uid(config.uid),
			items: config.items,
			tagger: config.tagger,
			toggle: $author$project$PinMeTo$Ui$Select$LegacyToggle(
				{label: config.label})
		},
		$author$project$PinMeTo$Ui$Select$Raw(
			{render: config.itemRender}));
};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Filter = function (a) {
	return {$: 'Filter', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faCheck = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-check');
var $author$project$FontAwesome$Solid$faCheck = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCheck);
var $author$project$FontAwesome$Solid$faPencil = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faPencil);
var $author$project$PinMeTo$Ui$Select$isDisabled = F2(
	function (disabled, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Select$Config(
			_Utils_update(
				config,
				{disabled: disabled}));
	});
var $author$project$PinMeTo$Ui$Select$withFooter = F2(
	function (footer, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Select$Config(
			_Utils_update(
				config,
				{
					footer: $elm$core$Maybe$Just(footer)
				}));
	});
var $author$project$PinMeTo$Ui$Select$withSearch = F2(
	function (search, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Select$Config(
			_Utils_update(
				config,
				{
					search: $elm$core$Maybe$Just(
						{sort: $elm$core$Maybe$Nothing, searchMap: search.searchMap, placeholder: search.placeholder, noResultsLabel: search.noResultsLabel})
				}));
	});
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$DefaultFilter = {$: 'DefaultFilter'};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$render = F4(
	function (tagger, _v0, labels, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var addFilterFooter = function (onAddFilter) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select__add-filter')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
						$author$project$PinMeTo$Ui$Btn$Add,
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(onAddFilter),
								$elm$html$Html$Attributes$type_('button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labels.addFilter)
							]))
					]));
		};
		var renderSelect = function (item) {
			var render_ = function (_v5) {
				var onEditItem = _v5.onEditItem;
				var onClickItem = _v5.onClickItem;
				var label = _v5.label;
				var selected = _v5.selected;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select__item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select__item-select'),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Events$onClick(onClickItem)
								]),
							_List_fromArray(
								[
									selected ? A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select__item-selected-icon')
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Solid$faCheck])) : $elm$html$Html$text(''),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select__item-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]))
								])),
							function () {
							if (onEditItem.$ === 'Just') {
								var onEdit = onEditItem.a;
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select__item-edit-button'),
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick(onEdit)
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Solid$faPencil]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]));
			};
			if (item.$ === 'DefaultFilter') {
				return render_(
					{
						label: labels.allItems,
						selected: _Utils_eq(config.selected, $elm$core$Maybe$Nothing),
						onEditItem: $elm$core$Maybe$Nothing,
						onClickItem: config.onReset
					});
			} else {
				var x = item.a;
				return render_(
					{
						label: x.name,
						selected: _Utils_eq(
							config.selected,
							$elm$core$Maybe$Just(x)),
						onEditItem: A2(
							$elm$core$Maybe$map,
							function (onEdit) {
								return onEdit(x);
							},
							config.onEdit),
						onClickItem: config.onSelect(x)
					});
			}
		};
		var itemName = function (item) {
			if (item.$ === 'DefaultFilter') {
				return labels.allItems;
			} else {
				var x = item.a;
				return x.name;
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-saved-filters-select')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.uiSelect,
					A2(
						$author$project$PinMeTo$Ui$Select$isDisabled,
						config.loading,
						A3(
							$elm$core$Basics$apR,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, addFilterFooter, $author$project$PinMeTo$Ui$Select$withFooter),
								config.onAdd),
							$elm$core$Maybe$withDefault($elm$core$Basics$identity),
							A2(
								$author$project$PinMeTo$Ui$Select$withSearch,
								{searchMap: itemName, placeholder: labels.searchPlaceholder, noResultsLabel: labels.searchNoResults},
								$author$project$PinMeTo$Ui$Select$raw(
									{
										uid: 'pmt-ui-saved-filters-select__' + config.uid,
										items: A2(
											$elm$core$List$cons,
											$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$DefaultFilter,
											A2($elm$core$List$map, $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Filter, config.filters)),
										label: $elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												labels.allItems,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.name;
													},
													config.selected))),
										tagger: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$UiSelectMsg, tagger),
										itemRender: renderSelect
									})))))
				]));
	});
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$withLoading = F2(
	function (loading, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Config(
			_Utils_update(
				config,
				{loading: loading}));
	});
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$withAddFilter = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Config(
			_Utils_update(
				config,
				{
					onAdd: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$withEditFilter = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$Config(
			_Utils_update(
				config,
				{
					onEdit: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$FilterController$UiSavedFilterMsg = function (a) {
	return {$: 'UiSavedFilterMsg', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnAdd = {$: 'UiSavedFiltersSelectOnAdd'};
var $author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnEdit = function (a) {
	return {$: 'UiSavedFiltersSelectOnEdit', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnSelect = function (a) {
	return {$: 'UiSavedFiltersSelectOnSelect', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$savedFiltersSelect = F5(
	function (uid, model, savedFilters, loading, config) {
		return A4(
			$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$render,
			$author$project$PinMeTo$Ui$FilterController$UiSavedFilterMsg,
			model.uiSavedFiltersSelect,
			config.labels,
			((!loading) ? A2(
				$elm$core$Basics$composeR,
				$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$withEditFilter($author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnEdit),
				$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$withAddFilter($author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnAdd)) : $elm$core$Basics$identity)(
				A2(
					$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$withLoading,
					loading,
					$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$view(
						{
							uid: uid,
							filters: savedFilters,
							onReset: $author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnSelect($elm$core$Maybe$Nothing),
							onSelect: A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$PinMeTo$Ui$FilterController$UiSavedFiltersSelectOnSelect),
							selected: model.selectedFilter
						}))));
	});
var $author$project$PinMeTo$Ui$FilterController$renderSavedFilters = F3(
	function (uid, model, config) {
		var _v0 = model.savedFilters;
		switch (_v0.$) {
			case 'Error':
				return $elm$html$Html$text('');
			case 'Loaded':
				var savedFilters = _v0.a;
				return A5($author$project$PinMeTo$Ui$FilterController$savedFiltersSelect, uid, model, savedFilters, false, config);
			default:
				return A5($author$project$PinMeTo$Ui$FilterController$savedFiltersSelect, uid, model, _List_Nil, true, config);
		}
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$toFilterDefinition = function (filter) {
	switch (filter.$) {
		case 'Saved':
			var x = filter.a;
			return {
				id: $elm$core$Maybe$Nothing,
				name: $elm$core$Maybe$Just(x.name),
				filter: x.filter
			};
		case 'UnSaved':
			var x = filter.a;
			return {
				id: $elm$core$Maybe$Nothing,
				name: $elm$core$Maybe$Just(x.name),
				filter: x.filter
			};
		default:
			var x = filter.a;
			return {id: $elm$core$Maybe$Nothing, name: $elm$core$Maybe$Nothing, filter: x};
	}
};
var $author$project$PinMeTo$Ui$FilterController$renderSearchOptions = F3(
	function (model, uid, filterForm) {
		return model.searchOptionsToggled ? A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				filterForm(uid + '_searchOptions'),
				model.searchOptions)) : $elm$html$Html$text('');
	});
var $author$project$PinMeTo$Ui$FilterController$renderUnselectableCount = function (config) {
	return (!_Utils_eq(
		config.unselectablesCount,
		$elm$core$Maybe$Just(0))) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-filter-controller__unselectable-count')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('('),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-table__warning-color')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							A2($elm$core$Maybe$withDefault, 0, config.unselectablesCount)))
					])),
				$elm$html$Html$text(' Unselectable)')
			])) : $elm$html$Html$text('');
};
var $author$project$PinMeTo$Ui$FilterController$renderModel = F4(
	function (tagger, model, renderer, _v0) {
		var config = _v0.a;
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-controller')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-controller__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-filter-controller__filters'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('pmt-ui-filter-controller__filters--with-search', config.withSearchOptionsOnly)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger),
									A3($author$project$PinMeTo$Ui$FilterController$renderSavedFilters, config.uid, model, config)),
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger),
									A2($author$project$PinMeTo$Ui$FilterController$renderSearchInput, model, config)),
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$LoadedMsg, tagger),
									A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												$author$project$PinMeTo$Ui$Filter$FilterFormFilter$toFilterDefinition,
												$author$project$PinMeTo$Ui$FilterController$renderFilterCount(model.propertyDefinitions)),
											model.searchOptions))),
									$author$project$PinMeTo$Ui$FilterController$renderResultCount(config),
									(!_Utils_eq(config.unselectablesCount, $elm$core$Maybe$Nothing)) ? $author$project$PinMeTo$Ui$FilterController$renderUnselectableCount(config) : $elm$html$Html$text('')
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								function (x) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-filter-controller__right')
											]),
										_List_fromArray(
											[x]));
								},
								config.rightNode))
						])),
					A3(
					$author$project$PinMeTo$Ui$FilterController$renderSearchOptions,
					model,
					config.uid,
					A2(renderer, config.locale, model.propertyDefinitions)),
					function () {
					var _v1 = model.savedFilters;
					if (_v1.$ === 'Loaded') {
						var savedFilters = _v1.a;
						return A5(
							$author$project$PinMeTo$Ui$FilterController$renderFilterEditor,
							tagger,
							config.labels,
							model,
							savedFilters,
							A2(renderer, config.locale, model.propertyDefinitions));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$FilterController$render = F4(
	function (tagger, _v0, renderer, _v1) {
		var loading = _v0.a;
		var model = _v0.b;
		var config = _v1.a;
		var _v2 = loading.propertyDefinitions;
		switch (_v2.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Error':
				var error = _v2.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$header,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$StatusBar$render(
									$author$project$PinMeTo$Ui$StatusBar$error(error))
								]))
						]));
			default:
				return A4(
					$author$project$PinMeTo$Ui$FilterController$renderModel,
					tagger,
					model,
					renderer,
					$author$project$PinMeTo$Ui$FilterController$View(config));
		}
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$PinMeTo$Ui$SelectorBrandPage$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$SelectorBrandPage$view = function (config) {
	return $author$project$PinMeTo$Ui$SelectorBrandPage$View(
		{labels: config.labels, locale: config.locale, tagger: config.tagger, selected: $elm$core$Set$empty});
};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$emptyNeedsVerification = {alertText: '', locations: $elm$core$Dict$empty, columnTitle: '', alertButtonLabel: ''};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$view = function (config) {
	return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$View(
		{labels: config.labels, locale: config.locale, tagger: config.tagger, readOnly: false, selected: $elm$core$Set$empty, needsVerifications: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$emptyNeedsVerification});
};
var $author$project$PinMeTo$Ui$Date$Posix = F2(
	function (a, b) {
		return {$: 'Posix', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Date$Default = {$: 'Default'};
var $author$project$PinMeTo$Ui$Date$NoIcons = {$: 'NoIcons'};
var $author$project$PinMeTo$Ui$Date$defaultConfig = function (locale) {
	return {icons: $author$project$PinMeTo$Ui$Date$NoIcons, format: $elm$core$Maybe$Nothing, locale: locale, display: $author$project$PinMeTo$Ui$Date$Default};
};
var $author$project$PinMeTo$Ui$Date$posix = F2(
	function (locale, x) {
		return A2(
			$author$project$PinMeTo$Ui$Date$Posix,
			x,
			$author$project$PinMeTo$Ui$Date$defaultConfig(locale));
	});
var $author$project$PinMeTo$Ui$Selector$Action = function (a) {
	return {$: 'Action', a: a};
};
var $author$project$PinMeTo$Ui$Selector$action = F2(
	function (labels, config) {
		return $author$project$PinMeTo$Ui$Selector$Action(
			{count: config.count, labels: labels, showSelector: config.showSelector, clearSelection: config.clearSelection});
	});
var $author$project$PinMeTo$Ui$Date$getConfig = function (date) {
	if (date.$ === 'Posix') {
		var config = date.b;
		return config;
	} else {
		var config = date.b;
		return config;
	}
};
var $author$project$PinMeTo$Ui$Date$applyConfig = F2(
	function (config, attributes) {
		var _v0 = config.icons;
		if (_v0.$ === 'WithIcons') {
			return A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'fancy', 'true'),
				attributes);
		} else {
			return attributes;
		}
	});
var $author$project$PinMeTo$Ui$Date$diffAttribute = function (date) {
	var _v0 = $author$project$PinMeTo$Ui$Date$getConfig(date).display;
	if (_v0.$ === 'Diff') {
		return $elm$core$Maybe$Just(
			A2($elm$html$Html$Attributes$attribute, 'diff', 'true'));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Ui$Date$valueAttribute = function (date) {
	if (date.$ === 'Posix') {
		var x = date.a;
		return A2(
			$elm$html$Html$Attributes$attribute,
			'millis',
			$elm$core$String$fromInt(
				$elm$time$Time$posixToMillis(x)));
	} else {
		var x = date.a;
		return A2($elm$html$Html$Attributes$attribute, 'date-string', x);
	}
};
var $author$project$PinMeTo$Ui$Date$formatToString = function (format) {
	switch (format.$) {
		case 'FormatDate':
			return 'L';
		case 'FormatTime':
			return 'LT';
		case 'FormatDateShortMonth':
			return 'D MMM';
		case 'FormatLongIso':
			return 'YYYY-MM-DD hh:mm:ss.SSS';
		default:
			return 'MMMM YYYY';
	}
};
var $author$project$PinMeTo$Ui$Date$formatAttribute = function (date) {
	return A2(
		$elm$core$Maybe$map,
		function (x) {
			return A2(
				$elm$html$Html$Attributes$attribute,
				'format',
				$author$project$PinMeTo$Ui$Date$formatToString(x));
		},
		$author$project$PinMeTo$Ui$Date$getConfig(date).format);
};
var $author$project$PinMeTo$Ui$I18n$Locale$toString = function (locale) {
	switch (locale.$) {
		case 'BrowserLocale':
			return 'browser';
		case 'EnUs':
			return 'en-us';
		case 'EnGb':
			return 'en-gb';
		case 'Fr':
			return 'fr';
		case 'De':
			return 'de';
		case 'Es':
			return 'es';
		case 'SvSe':
			return 'sv-se';
		case 'Fi':
			return 'fi';
		case 'Pl':
			return 'pl';
		default:
			return 'pt-pt';
	}
};
var $author$project$PinMeTo$Ui$Date$localeAttribute = function (date) {
	var _v0 = $author$project$PinMeTo$Ui$Date$getConfig(date).locale;
	if (_v0.$ === 'BrowserLocale') {
		return $elm$core$Maybe$Nothing;
	} else {
		var locale = _v0;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$Attributes$attribute,
				'locale',
				$author$project$PinMeTo$Ui$I18n$Locale$toString(locale)));
	}
};
var $author$project$PinMeTo$Ui$I18n$Language$toString = function (x) {
	switch (x.$) {
		case 'En':
			return 'en';
		case 'Fr':
			return 'fr';
		case 'De':
			return 'de';
		case 'Es':
			return 'es';
		case 'Sv':
			return 'sv';
		case 'Fi':
			return 'fi';
		case 'Pl':
			return 'pl';
		default:
			return 'pt';
	}
};
var $author$project$PinMeTo$Ui$Date$timeAgoFormatToJsonString = function (x) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'future',
					$elm$json$Json$Encode$string(x.future)),
					_Utils_Tuple2(
					'past',
					$elm$json$Json$Encode$string(x.past)),
					_Utils_Tuple2(
					's',
					$elm$json$Json$Encode$string(x.recent)),
					_Utils_Tuple2(
					'ss',
					$elm$json$Json$Encode$string(x.recent)),
					_Utils_Tuple2(
					'm',
					$elm$json$Json$Encode$string(x.minute)),
					_Utils_Tuple2(
					'mm',
					$elm$json$Json$Encode$string(x.minutes)),
					_Utils_Tuple2(
					'h',
					$elm$json$Json$Encode$string(x.hour)),
					_Utils_Tuple2(
					'hh',
					$elm$json$Json$Encode$string(x.hours)),
					_Utils_Tuple2(
					'd',
					$elm$json$Json$Encode$string(x.day)),
					_Utils_Tuple2(
					'dd',
					$elm$json$Json$Encode$string(x.days)),
					_Utils_Tuple2(
					'M',
					$elm$json$Json$Encode$string(x.month)),
					_Utils_Tuple2(
					'MM',
					$elm$json$Json$Encode$string(x.months)),
					_Utils_Tuple2(
					'y',
					$elm$json$Json$Encode$string(x.year)),
					_Utils_Tuple2(
					'yy',
					$elm$json$Json$Encode$string(x.years))
				])));
};
var $author$project$PinMeTo$Ui$Date$timeAgoAttribute = function (date) {
	var _v0 = $author$project$PinMeTo$Ui$Date$getConfig(date).display;
	switch (_v0.$) {
		case 'TimeAgo':
			var language = _v0.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Attributes$attribute,
					'timeAgo',
					$author$project$PinMeTo$Ui$I18n$Language$toString(language)));
		case 'TimeAgoShort':
			var format = _v0.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Attributes$attribute,
					'timeAgoShort',
					$author$project$PinMeTo$Ui$Date$timeAgoFormatToJsonString(format)));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Ui$Date$disabledAttribute = function (date) {
	var _v0 = $author$project$PinMeTo$Ui$Date$getConfig(date).display;
	if (_v0.$ === 'Disabled') {
		return $elm$core$Maybe$Just(
			$elm$html$Html$Attributes$class('date-range-selector__disabled'));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Ui$Date$render = function (date) {
	var config = $author$project$PinMeTo$Ui$Date$getConfig(date);
	return A3(
		$elm$html$Html$node,
		'pmt-date',
		A2(
			$author$project$PinMeTo$Ui$Date$applyConfig,
			config,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Date$valueAttribute(date)),
						$author$project$PinMeTo$Ui$Date$formatAttribute(date),
						$author$project$PinMeTo$Ui$Date$localeAttribute(date),
						$author$project$PinMeTo$Ui$Date$diffAttribute(date),
						$author$project$PinMeTo$Ui$Date$timeAgoAttribute(date),
						$author$project$PinMeTo$Ui$Date$disabledAttribute(date)
					]))),
		_List_Nil);
};
var $author$project$PinMeTo$Ui$SelectorBrandPage$OnSelect = function (a) {
	return {$: 'OnSelect', a: a};
};
var $author$project$PinMeTo$Ui$Date$FormatDate = {$: 'FormatDate'};
var $author$project$PinMeTo$Ui$Date$String = F2(
	function (a, b) {
		return {$: 'String', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Date$withFormat = F2(
	function (format, date) {
		if (date.$ === 'Posix') {
			var x = date.a;
			var config = date.b;
			return A2(
				$author$project$PinMeTo$Ui$Date$Posix,
				x,
				_Utils_update(
					config,
					{
						format: $elm$core$Maybe$Just(format)
					}));
		} else {
			var x = date.a;
			var config = date.b;
			return A2(
				$author$project$PinMeTo$Ui$Date$String,
				x,
				_Utils_update(
					config,
					{
						format: $elm$core$Maybe$Just(format)
					}));
		}
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$ShowSelector = F2(
	function (a, b) {
		return {$: 'ShowSelector', a: a, b: b};
	});
var $author$project$FontAwesome$Regular$Icon$faPlus = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-plus');
var $author$project$PinMeTo$Ui$Button$FARegular = function (a) {
	return {$: 'FARegular', a: a};
};
var $author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute = function (a) {
	return {$: 'DataTestAttribute', a: a};
};
var $author$project$PinMeTo$Ui$Selector$renderAction = function (_v0) {
	var config = _v0.a;
	var clearSelection = (config.count > 0) ? $author$project$PinMeTo$Ui$Button$render(
		A2(
			$author$project$PinMeTo$Ui$Button$withDataTestAttribute,
			$author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute('pmt-ui-selector-action-clear'),
			A2(
				$author$project$PinMeTo$Ui$Button$withOnClick,
				config.clearSelection,
				A2(
					$author$project$PinMeTo$Ui$Button$withGhostStyle,
					$author$project$PinMeTo$Ui$Button$GhostNeutral,
					$author$project$PinMeTo$Ui$Button$buttonGhost(config.labels.clearSelection))))) : $elm$html$Html$text('');
	var label = (config.count > 0) ? (config.labels.selectItems + (' (' + ($elm$core$String$fromInt(config.count) + ')'))) : config.labels.selectItems;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-selector-action')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Button$render(
				A2(
					$author$project$PinMeTo$Ui$Button$withDataTestAttribute,
					$author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute('pmt-ui-selector-action-show'),
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						config.showSelector,
						A2(
							$author$project$PinMeTo$Ui$Button$withIconBefore,
							$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
							A2(
								$author$project$PinMeTo$Ui$Button$withSecondaryStyle,
								$author$project$PinMeTo$Ui$Button$SecondaryDefault,
								$author$project$PinMeTo$Ui$Button$buttonSecondary(label)))))),
				clearSelection
			]));
};
var $author$project$PinMeTo$Ui$Selector$withChildRow = F2(
	function (getChild, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Selector$View(
			_Utils_update(
				config,
				{
					childRow: $elm$core$Maybe$Just(getChild)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$UiSelectorMsg = function (a) {
	return {$: 'UiSelectorMsg', a: a};
};
var $author$project$PinMeTo$Ui$Selector$renderActions = F2(
	function (config, _v0) {
		var model = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-btn-group')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							config.onSelect(
								$elm$core$Set$toList(model.selected))),
							$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-selector-add-selection')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.label)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var labels = config.labels;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-selector-brand-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.tagger,
					$author$project$PinMeTo$Ui$Selector$renderAction(
						A2(
							$author$project$PinMeTo$Ui$Selector$action,
							{selectItems: labels.uiSelector.itemPlural, clearSelection: labels.clearSelection, itemsPluralized: labels.selectedItems},
							{
								count: $elm$core$Set$size(config.selected),
								showSelector: A2($author$project$PinMeTo$Ui$SelectorBrandPage$ShowSelector, config.selected, true),
								clearSelection: $author$project$PinMeTo$Ui$SelectorBrandPage$OnSelect($elm$core$Set$empty)
							}))),
					function () {
					var _v2 = model.selector;
					if (_v2.$ === 'Just') {
						var selector = _v2.a;
						return A2(
							$elm$html$Html$map,
							config.tagger,
							$author$project$PinMeTo$Ui$Lightbox$render(
								$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
									A2(
										$author$project$PinMeTo$Ui$Lightbox$withFooter,
										A2(
											$author$project$PinMeTo$Ui$Selector$renderActions,
											{
												label: labels.submit,
												onSelect: A2($elm$core$Basics$composeR, $elm$core$Set$fromList, $author$project$PinMeTo$Ui$SelectorBrandPage$OnSelect)
											},
											selector),
										A2(
											$author$project$PinMeTo$Ui$Lightbox$withClose,
											A2($author$project$PinMeTo$Ui$SelectorBrandPage$ShowSelector, config.selected, false),
											$author$project$PinMeTo$Ui$Lightbox$view(
												{
													title: labels.title,
													content: A2(
														$author$project$PinMeTo$Ui$Selector$render,
														selector,
														A2(
															$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
															{
																key: labels.columns.created,
																toHtml: A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.created;
																	},
																	A2(
																		$elm$core$Basics$composeR,
																		$author$project$PinMeTo$Ui$Date$posix(config.locale),
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$PinMeTo$Ui$Date$withFormat($author$project$PinMeTo$Ui$Date$FormatDate),
																			$author$project$PinMeTo$Ui$Date$render))),
																toString: A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.created;
																	},
																	A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt))
															},
															A2(
																$author$project$PinMeTo$Ui$Selector$withColumn,
																{
																	key: labels.columns.network,
																	toString: function ($) {
																		return $.network;
																	}
																},
																A2(
																	$author$project$PinMeTo$Ui$Selector$withColumn,
																	{
																		key: labels.columns.name,
																		toString: function ($) {
																			return $.name;
																		}
																	},
																	A2(
																		$author$project$PinMeTo$Ui$Selector$withChildRow,
																		function ($) {
																			return $.reason;
																		},
																		$author$project$PinMeTo$Ui$Selector$view(
																			{
																				labels: labels.uiSelector,
																				search: F2(
																					function (query, item) {
																						return A2(
																							$elm$core$List$any,
																							A2(
																								$elm$core$Basics$composeR,
																								$elm$core$String$toLower,
																								$author$project$PinMeTo$Common$StringNormalize$contains(query)),
																							_List_fromArray(
																								[item.name, item.network]));
																					}),
																				tagger: $author$project$PinMeTo$Ui$SelectorBrandPage$UiSelectorMsg,
																				idToString: function (item) {
																					return item.id;
																				}
																			}))))))
												}))))));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$Alert$Note = {$: 'Note'};
var $author$project$PinMeTo$Ui$Alert$Rich = function (a) {
	return {$: 'Rich', a: a};
};
var $author$project$PinMeTo$Ui$Alert$Alert = function (a) {
	return {$: 'Alert', a: a};
};
var $author$project$PinMeTo$Ui$Alert$Plain = function (a) {
	return {$: 'Plain', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faCircleInfo = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-circle-info');
var $author$project$FontAwesome$Solid$faCircleInfo = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircleInfo);
var $author$project$PinMeTo$Ui$Alert$defaultConfig = {
	icon: $author$project$FontAwesome$Solid$faCircleInfo,
	status: $author$project$PinMeTo$Ui$Alert$Note,
	content: $author$project$PinMeTo$Ui$Alert$Plain(''),
	withoutIcon: false
};
var $author$project$PinMeTo$Ui$Alert$rich = function (message) {
	return $author$project$PinMeTo$Ui$Alert$Alert(
		_Utils_update(
			$author$project$PinMeTo$Ui$Alert$defaultConfig,
			{
				status: $author$project$PinMeTo$Ui$Alert$Note,
				content: $author$project$PinMeTo$Ui$Alert$Rich(message)
			}));
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$view = function (config) {
	return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
		{labels: config.labels, locale: config.locale, search: config.search, tagger: config.tagger, columns: _List_Nil, childRow: $elm$core$Maybe$Nothing, readOnly: false, selected: _List_Nil, idToString: config.idToString, initialSort: $elm$core$Maybe$Nothing});
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$action = $author$project$PinMeTo$Ui$Selector$action;
var $author$project$PinMeTo$Ui$Alert$Tip = {$: 'Tip'};
var $author$project$PinMeTo$Ui$Alert$Error = {$: 'Error'};
var $author$project$PinMeTo$Ui$Alert$Success = {$: 'Success'};
var $author$project$PinMeTo$Ui$Alert$Warning = {$: 'Warning'};
var $author$project$PinMeTo$Ui$Alert$Disclaimer = {$: 'Disclaimer'};
var $author$project$PinMeTo$Ui$Alert$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-alert pmt-ui-font-note'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-ui-alert--note',
						_Utils_eq(config.status, $author$project$PinMeTo$Ui$Alert$Note)),
						_Utils_Tuple2(
						'pmt-ui-alert--success',
						_Utils_eq(config.status, $author$project$PinMeTo$Ui$Alert$Success)),
						_Utils_Tuple2(
						'pmt-ui-alert--warning',
						_Utils_eq(config.status, $author$project$PinMeTo$Ui$Alert$Warning)),
						_Utils_Tuple2(
						'pmt-ui-alert--error',
						_Utils_eq(config.status, $author$project$PinMeTo$Ui$Alert$Error)),
						_Utils_Tuple2(
						'pmt-ui-alert--disclaimer',
						_Utils_eq(config.status, $author$project$PinMeTo$Ui$Alert$Disclaimer)),
						_Utils_Tuple2('pmt-ui-alert--no-icon', config.withoutIcon),
						_Utils_Tuple2(
						'pmt-ui-alert--tip',
						_Utils_eq(config.status, $author$project$PinMeTo$Ui$Alert$Tip))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-alert__icon')
					]),
				_List_fromArray(
					[
						config.withoutIcon ? $elm$html$Html$text('') : config.icon
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-alert__message')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = config.content;
						if (_v1.$ === 'Plain') {
							var message = _v1.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-alert__message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]));
						} else {
							var html = _v1.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-alert__message')
									]),
								html);
						}
					}()
					]))
			]));
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$Loading = {$: 'Loading'};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$All = {$: 'All'};
var $author$project$PinMeTo$Ui$SelectorLocation$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocation$view = function (config) {
	return $author$project$PinMeTo$Ui$SelectorLocation$View(
		{labels: config.labels, locale: config.locale, tagger: config.tagger, selected: $elm$core$Set$empty});
};
var $author$project$PinMeTo$Ui$SelectorLocation$search = F2(
	function (query, item) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toLower,
				$author$project$PinMeTo$Common$StringNormalize$contains(query)),
			_List_fromArray(
				[item.name, item.storeId, item.locationDescriptor, item.address.city, item.address.street, item.address.country, item.address.zip]));
	});
var $author$project$PinMeTo$Ui$SelectorLocation$OnSelect = function (a) {
	return {$: 'OnSelect', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocation$ShowSelector = F2(
	function (a, b) {
		return {$: 'ShowSelector', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$SelectorLocation$UiSelectorMsg = function (a) {
	return {$: 'UiSelectorMsg', a: a};
};
var $author$project$PinMeTo$Ui$Selector$WithPadding = {$: 'WithPadding'};
var $author$project$PinMeTo$Ui$Selector$withColumnPaddedSort = F2(
	function (column, _v0) {
		var config = _v0.a;
		var column_ = {key: column.key, sort: $author$project$PinMeTo$Ui$Selector$WithPadding, toHtml: $elm$core$Maybe$Nothing, toString: column.toString};
		return $author$project$PinMeTo$Ui$Selector$View(
			_Utils_update(
				config,
				{
					columns: A2($elm$core$List$cons, column_, config.columns)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorLocation$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var labels = config.labels;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-selector-location')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.tagger,
					$author$project$PinMeTo$Ui$Selector$renderAction(
						A2(
							$author$project$PinMeTo$Ui$Selector$action,
							{selectItems: labels.uiSelector.itemPlural, clearSelection: labels.clearSelection, itemsPluralized: labels.selectedItems},
							{
								count: $elm$core$Set$size(config.selected),
								showSelector: A2($author$project$PinMeTo$Ui$SelectorLocation$ShowSelector, config.selected, true),
								clearSelection: $author$project$PinMeTo$Ui$SelectorLocation$OnSelect($elm$core$Set$empty)
							}))),
					function () {
					var _v2 = model.selector;
					if (_v2.$ === 'Just') {
						var selector = _v2.a;
						return A2(
							$elm$html$Html$map,
							config.tagger,
							$author$project$PinMeTo$Ui$Lightbox$render(
								$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
									A2(
										$author$project$PinMeTo$Ui$Lightbox$withFooter,
										A2(
											$author$project$PinMeTo$Ui$Selector$renderActions,
											{
												label: labels.submit,
												onSelect: A2($elm$core$Basics$composeR, $elm$core$Set$fromList, $author$project$PinMeTo$Ui$SelectorLocation$OnSelect)
											},
											selector),
										A2(
											$author$project$PinMeTo$Ui$Lightbox$withClose,
											A2($author$project$PinMeTo$Ui$SelectorLocation$ShowSelector, config.selected, false),
											$author$project$PinMeTo$Ui$Lightbox$view(
												{
													title: labels.title,
													content: A2(
														$author$project$PinMeTo$Ui$Selector$render,
														selector,
														A2(
															$author$project$PinMeTo$Ui$Selector$withColumnRenderer,
															{
																key: labels.columns.created,
																toHtml: A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.created;
																	},
																	A2(
																		$elm$core$Basics$composeR,
																		$author$project$PinMeTo$Ui$Date$posix(config.locale),
																		A2(
																			$elm$core$Basics$composeR,
																			$author$project$PinMeTo$Ui$Date$withFormat($author$project$PinMeTo$Ui$Date$FormatDate),
																			$author$project$PinMeTo$Ui$Date$render))),
																toString: A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.created;
																	},
																	A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt))
															},
															A2(
																$author$project$PinMeTo$Ui$Selector$withColumn,
																{
																	key: labels.columns.country,
																	toString: A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.address;
																		},
																		function ($) {
																			return $.country;
																		})
																},
																A2(
																	$author$project$PinMeTo$Ui$Selector$withColumn,
																	{
																		key: labels.columns.city,
																		toString: A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.address;
																			},
																			function ($) {
																				return $.city;
																			})
																	},
																	A2(
																		$author$project$PinMeTo$Ui$Selector$withColumnPaddedSort,
																		{
																			key: labels.columns.zip,
																			toString: A2(
																				$elm$core$Basics$composeR,
																				function ($) {
																					return $.address;
																				},
																				function ($) {
																					return $.zip;
																				})
																		},
																		A2(
																			$author$project$PinMeTo$Ui$Selector$withColumn,
																			{
																				key: labels.columns.street,
																				toString: A2(
																					$elm$core$Basics$composeR,
																					function ($) {
																						return $.address;
																					},
																					function ($) {
																						return $.street;
																					})
																			},
																			A2(
																				$author$project$PinMeTo$Ui$Selector$withColumn,
																				{
																					key: labels.columns.locationDescriptor,
																					toString: function ($) {
																						return $.locationDescriptor;
																					}
																				},
																				A2(
																					$author$project$PinMeTo$Ui$Selector$withColumn,
																					{
																						key: labels.columns.name,
																						toString: function ($) {
																							return $.name;
																						}
																					},
																					A2(
																						$author$project$PinMeTo$Ui$Selector$withColumnPaddedSort,
																						{
																							key: labels.columns.storeId,
																							toString: function ($) {
																								return $.storeId;
																							}
																						},
																						A2(
																							$author$project$PinMeTo$Ui$Selector$withChildRow,
																							function ($) {
																								return $.reason;
																							},
																							$author$project$PinMeTo$Ui$Selector$view(
																								{
																									labels: labels.uiSelector,
																									search: $author$project$PinMeTo$Ui$SelectorLocation$search,
																									tagger: $author$project$PinMeTo$Ui$SelectorLocation$UiSelectorMsg,
																									idToString: function (item) {
																										return item.id;
																									}
																								})))))))))))
												}))))));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate = F4(
	function (a, b, c, d) {
		return {$: 'OnUpdate', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty = function (propDef) {
	switch (propDef.$) {
		case 'SingleProperty':
			return $author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue('');
		case 'MultiProperty':
			return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(_List_Nil);
		case 'AnyTextProperty':
			return $author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue('');
		case 'MultiTextProperty':
			return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(_List_Nil);
		case 'LocationSelectorProperty':
			return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(_List_Nil);
		default:
			return $author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(_List_Nil);
	}
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$defaultFilterForProperty = function (propDef) {
	switch (propDef.$) {
		case 'SingleProperty':
			var meta = propDef.a;
			return A3(
				$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
				meta.property,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty(propDef),
				$elm$core$Maybe$Just(propDef));
		case 'MultiProperty':
			var meta = propDef.a;
			return A3(
				$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
				meta.property,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty(propDef),
				$elm$core$Maybe$Just(propDef));
		case 'AnyTextProperty':
			var meta = propDef.a;
			return A3(
				$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
				meta.property,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty(propDef),
				$elm$core$Maybe$Just(propDef));
		case 'MultiTextProperty':
			var meta = propDef.a;
			return A3(
				$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
				meta.property,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty(propDef),
				$elm$core$Maybe$Just(propDef));
		case 'LocationSelectorProperty':
			var meta = propDef.a;
			return A3(
				$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
				meta.property,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty(propDef),
				$elm$core$Maybe$Just(propDef));
		default:
			var meta = propDef.a;
			return A3(
				$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
				meta.property,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultValueForProperty(propDef),
				$elm$core$Maybe$Just(propDef));
	}
};
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$getFilter = F3(
	function (propertyDefinition, propertyName, filter) {
		var get = function (filter_) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultFilterForProperty(propertyDefinition),
				A2($elm$core$Dict$get, propertyName, filter_));
		};
		switch (filter.$) {
			case 'Saved':
				var x = filter.a;
				return get(x.filter);
			case 'UnSaved':
				var x = filter.a;
				return get(x.filter);
			default:
				var x = filter.a;
				return get(x);
		}
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocation$withSelected = F2(
	function (selected, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorLocation$View(
			_Utils_update(
				config,
				{
					selected: $elm$core$Set$fromList(selected)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$withSelected = F2(
	function (selected, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorBrandPage$View(
			_Utils_update(
				config,
				{
					selected: $elm$core$Set$fromList(selected)
				}));
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$textValueField = F6(
	function (_v0, property, propertyValue, meta, propertyDefinition, theFilter) {
		var onSelect = _v0.onSelect;
		var propertyValue_ = function () {
			if (propertyValue.$ === 'SingleValue') {
				var x = propertyValue.a;
				return x;
			} else {
				var xs = propertyValue.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(xs));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-form__anyText')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(meta.displayName)
						])),
					$author$project$PinMeTo$Ui$Form$Input$render(
					$author$project$PinMeTo$Ui$Form$Input$text(
						{
							value: propertyValue_,
							onChange: A2(
								$elm$core$Basics$composeR,
								$author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue,
								A3(onSelect, theFilter, property, propertyDefinition))
						}))
				]));
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyMeta = function (pd) {
	switch (pd.$) {
		case 'SingleProperty':
			var pm = pd.a;
			return pm;
		case 'MultiProperty':
			var pm = pd.a;
			return pm;
		case 'AnyTextProperty':
			var pm = pd.a;
			return pm;
		case 'MultiTextProperty':
			var pm = pd.a;
			return pm;
		case 'LocationSelectorProperty':
			var pm = pd.a;
			return pm;
		default:
			var pm = pd.a;
			return pm;
	}
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$multiValueField = F6(
	function (_v0, property, propertyValues, meta, propertyDefinition, theFilter) {
		var onSelect = _v0.onSelect;
		var renderFields = function (values) {
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var label = _v1.label;
					var key = _v1.key;
					var isChecked = A2($elm$core$List$member, key, propertyValues);
					return A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-checkbox')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$class('pmt-ui-filter-form__input '),
										$elm$html$Html$Attributes$id(key),
										$elm$html$Html$Attributes$value(key),
										$elm$html$Html$Attributes$checked(isChecked),
										$elm$html$Html$Events$onCheck(
										function (x) {
											return x ? A4(
												onSelect,
												theFilter,
												property,
												propertyDefinition,
												$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(
													A2($elm$core$List$cons, key, propertyValues))) : A4(
												onSelect,
												theFilter,
												property,
												propertyDefinition,
												$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(
													A2(
														$elm$core$List$filter,
														$elm$core$Basics$neq(key),
														propertyValues)));
										})
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-checkbox__label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]))
							]));
				},
				values);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-form__multi')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(meta.displayName)
						])),
				A2(
					$elm$core$Maybe$withDefault,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]),
					A2($elm$core$Maybe$map, renderFields, meta.values))));
	});
var $author$project$PinMeTo$Ui$Form$Radio$Radio = function (a) {
	return {$: 'Radio', a: a};
};
var $author$project$PinMeTo$Ui$Form$Radio$radio = function (_v0) {
	var onChange = _v0.onChange;
	var checked = _v0.checked;
	var label = _v0.label;
	return $author$project$PinMeTo$Ui$Form$Radio$Radio(
		{label: label, checked: checked, disabled: false, onChange: onChange});
};
var $author$project$PinMeTo$Ui$Form$Radio$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-radio'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-ui-radio--disabled', config.disabled),
						_Utils_Tuple2('pmt-ui-radio--checked', config.checked)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('radio'),
						$elm$html$Html$Attributes$disabled(config.disabled),
						$elm$html$Html$Attributes$checked(config.checked),
						$elm$html$Html$Events$onCheck(config.onChange)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-radio__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.label)
					]))
			]));
};
var $elm$core$String$reverse = _String_reverse;
var $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyName = function (_v0) {
	var property = _v0.a;
	return property;
};
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$singleValueField = F8(
	function (_v0, uiSelect, uid, property, propertyValue, meta, propertyDefinition, theFilter) {
		var onSelect = _v0.onSelect;
		var uiSelectTagger = _v0.uiSelectTagger;
		var propName = $elm$core$String$reverse(
			$author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyName(property));
		var options = A2($elm$core$Maybe$withDefault, _List_Nil, meta.values);
		var input_ = function (_v1) {
			var label = _v1.label;
			var key = _v1.key;
			return $author$project$PinMeTo$Ui$Form$Radio$render(
				$author$project$PinMeTo$Ui$Form$Radio$radio(
					{
						label: label,
						checked: _Utils_eq(key, propertyValue),
						onChange: $elm$core$Basics$always(
							A4(
								onSelect,
								theFilter,
								property,
								propertyDefinition,
								$author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue(key)))
					}));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-form__single')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(meta.displayName)
						])),
					($elm$core$List$length(options) <= 6) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__single--options')
						]),
					A2($elm$core$List$map, input_, options)) : A2(
					$author$project$PinMeTo$Ui$Select$render,
					uiSelect,
					$author$project$PinMeTo$Ui$Select$view(
						{
							uid: uid + ('-' + propName),
							items: A2(
								$elm$core$List$cons,
								{key: '', label: 'Select'},
								options),
							label: $elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'Select',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.label;
										},
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (x) {
													return _Utils_eq(x.key, propertyValue);
												},
												options))))),
							tagger: uiSelectTagger,
							onChange: function (x) {
								return A4(
									onSelect,
									theFilter,
									property,
									propertyDefinition,
									$author$project$PinMeTo$Ui$Filter$DataTypes$SingleValue(x.key));
							},
							itemRender: A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.label;
								},
								$elm$html$Html$text)
						}))
				]));
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$multiTextValueField = F9(
	function (_v0, uiSelect, uid, property, propertyValue, meta, propertyDefinition, theFilter, labels) {
		var uiSelectTagger = _v0.uiSelectTagger;
		var onSelect = _v0.onSelect;
		var selectedValues = function () {
			if (propertyValue.$ === 'SingleValue') {
				var x = propertyValue.a;
				return _List_fromArray(
					[x]);
			} else {
				var xs = propertyValue.a;
				return xs;
			}
		}();
		var listValues = function (values) {
			return ($elm$core$List$length(values) > 0) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-filter-form__multiText')
					]),
				A2(
					$elm$core$List$map,
					function (_v3) {
						var label = _v3.label;
						var key = _v3.key;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-filter-form__multiText--values')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-filter-form__multiText--value')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-filter-form__multiText--delete')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													A4(
														onSelect,
														theFilter,
														property,
														propertyDefinition,
														$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(
															A2(
																$elm$core$List$filter,
																$elm$core$Basics$neq(key),
																selectedValues))))
												]),
											_List_fromArray(
												[$author$project$FontAwesome$Solid$faXmark]))
										]))
								]));
					},
					values)) : $elm$html$Html$text('');
		};
		var isSelected = function (key) {
			return A2($elm$core$List$member, key, selectedValues);
		};
		var propName = $elm$core$String$reverse(
			$author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyName(property));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-form__ui-select')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(meta.displayName)
						])),
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					uiSelect,
					A2(
						$author$project$PinMeTo$Ui$Select$withSearch,
						{
							searchMap: function ($) {
								return $.label;
							},
							placeholder: labels.searchPlaceholder,
							noResultsLabel: labels.searchNoResults
						},
						$author$project$PinMeTo$Ui$Select$view(
							{
								uid: uid + ('-' + propName),
								items: A2(
									$elm$core$List$filter,
									function (_v1) {
										var key = _v1.key;
										return !isSelected(key);
									},
									A2($elm$core$Maybe$withDefault, _List_Nil, meta.values)),
								label: $elm$html$Html$text(
									labels.addSelection(meta.displayName)),
								tagger: uiSelectTagger,
								onChange: function (x) {
									return A4(
										onSelect,
										theFilter,
										property,
										propertyDefinition,
										$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(
											A2($elm$core$List$cons, x.key, selectedValues)));
								},
								itemRender: A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.label;
									},
									$elm$html$Html$text)
							}))),
					listValues(
					A2(
						$elm$core$List$filter,
						function (_v2) {
							var key = _v2.key;
							return isSelected(key);
						},
						A2($elm$core$Maybe$withDefault, _List_Nil, meta.values)))
				]));
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectorLocationMsg = F4(
	function (a, b, c, d) {
		return {$: 'UiSelectorLocationMsg', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectorBrandPageMsg = F4(
	function (a, b, c, d) {
		return {$: 'UiSelectorBrandPageMsg', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$render = F7(
	function (tagger, _v0, labels, locale, propertyDefinitions, uid, theFilter) {
		var model = _v0.a;
		var renderFilter = function (propertyDefinition) {
			var configErrorMessage = function (p) {
				return $elm$html$Html$text('Incorrectly configured property \u0027' + (p + '\u0027'));
			};
			var brandPageSelector = F2(
				function (property, selected) {
					return A2(
						$author$project$PinMeTo$Ui$SelectorBrandPage$render,
						model.brandPageSelector,
						A2(
							$author$project$PinMeTo$Ui$SelectorBrandPage$withSelected,
							selected,
							$author$project$PinMeTo$Ui$SelectorBrandPage$view(
								{
									labels: labels.brandPageSelector,
									locale: locale,
									tagger: A2(
										$elm$core$Basics$composeR,
										A3($author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectorBrandPageMsg, theFilter, property, propertyDefinition),
										tagger)
								})));
				});
			var locationSelector = F2(
				function (property, selected) {
					return A2(
						$author$project$PinMeTo$Ui$SelectorLocation$render,
						model.locationSelector,
						A2(
							$author$project$PinMeTo$Ui$SelectorLocation$withSelected,
							selected,
							$author$project$PinMeTo$Ui$SelectorLocation$view(
								{
									labels: labels.locationSelector,
									locale: locale,
									tagger: A2(
										$elm$core$Basics$composeR,
										A3($author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectorLocationMsg, theFilter, property, propertyDefinition),
										tagger)
								})));
				});
			var _v1 = $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyMeta(propertyDefinition).property;
			var propertyName = _v1.a;
			var currentFilter = A3($author$project$PinMeTo$Ui$Filter$FilterFormFilter$getFilter, propertyDefinition, propertyName, theFilter);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-filter-form__property')
					]),
				_List_fromArray(
					[
						function () {
						_v2$6:
						while (true) {
							if (currentFilter.c.$ === 'Just') {
								switch (currentFilter.c.a.$) {
									case 'SingleProperty':
										if (currentFilter.b.$ === 'SingleValue') {
											var p = currentFilter.a;
											var value = currentFilter.b.a;
											var meta = currentFilter.c.a.a;
											return A2(
												$elm$html$Html$map,
												tagger,
												A8(
													$author$project$PinMeTo$Ui$Filter$FilterFormBase$singleValueField,
													{onSelect: $author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate, uiSelectTagger: $author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectMsg},
													model.uiSelect,
													uid,
													p,
													value,
													meta,
													propertyDefinition,
													theFilter));
										} else {
											break _v2$6;
										}
									case 'MultiProperty':
										if (currentFilter.b.$ === 'MultiValue') {
											var p = currentFilter.a;
											var values = currentFilter.b.a;
											var meta = currentFilter.c.a.a;
											return A2(
												$elm$html$Html$map,
												tagger,
												A6(
													$author$project$PinMeTo$Ui$Filter$FilterFormBase$multiValueField,
													{onSelect: $author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate},
													p,
													values,
													meta,
													propertyDefinition,
													theFilter));
										} else {
											break _v2$6;
										}
									case 'AnyTextProperty':
										var p = currentFilter.a;
										var propertyValue = currentFilter.b;
										var meta = currentFilter.c.a.a;
										return A2(
											$elm$html$Html$map,
											tagger,
											A6(
												$author$project$PinMeTo$Ui$Filter$FilterFormBase$textValueField,
												{onSelect: $author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate},
												p,
												propertyValue,
												meta,
												propertyDefinition,
												theFilter));
									case 'MultiTextProperty':
										var p = currentFilter.a;
										var propertyValue = currentFilter.b;
										var meta = currentFilter.c.a.a;
										return A2(
											$elm$html$Html$map,
											tagger,
											A9(
												$author$project$PinMeTo$Ui$Filter$FilterFormBase$multiTextValueField,
												{onSelect: $author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate, uiSelectTagger: $author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectMsg},
												model.uiSelect,
												uid,
												p,
												propertyValue,
												meta,
												propertyDefinition,
												theFilter,
												labels.locationSelectorFilterController));
									case 'LocationSelectorProperty':
										if (currentFilter.b.$ === 'MultiValue') {
											var p = currentFilter.a.a;
											var values = currentFilter.b.a;
											var meta = currentFilter.c.a.a;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-filter-form__multi')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h2,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(meta.displayName)
															])),
														A2(locationSelector, meta.property, values)
													]));
										} else {
											break _v2$6;
										}
									default:
										if (currentFilter.b.$ === 'MultiValue') {
											var p = currentFilter.a.a;
											var values = currentFilter.b.a;
											var meta = currentFilter.c.a.a;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-filter-form__multi')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h2,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(meta.displayName)
															])),
														A2(brandPageSelector, meta.property, values)
													]));
										} else {
											break _v2$6;
										}
								}
							} else {
								break _v2$6;
							}
						}
						var p = currentFilter.a.a;
						return configErrorMessage(p);
					}()
					]));
		};
		var sortPropDef = function (xs) {
			return A2(
				$elm$core$List$sortBy,
				function (x) {
					return $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyMeta(x).sortOrder;
				},
				xs);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__properties')
						]),
					A2(
						$elm$core$List$map,
						renderFilter,
						sortPropDef(
							$elm$core$Dict$values(propertyDefinitions))))
				]));
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$Selected = {$: 'Selected'};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$SetActiveTab = function (a) {
	return {$: 'SetActiveTab', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$Unselectable = {$: 'Unselectable'};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$tabsView = F2(
	function (_v0, labels) {
		var unselectableCount = _v0.unselectableCount;
		var selectedCount = _v0.selectedCount;
		var allCount = _v0.allCount;
		var currentTab = _v0.currentTab;
		var itemView = function (_v1) {
			var isDisabled = _v1.isDisabled;
			var countColor = _v1.countColor;
			var count = _v1.count;
			var tab = _v1.tab;
			var label = _v1.label;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
						$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--label'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pmt-ui-view-selector__item--active',
								_Utils_eq(tab, currentTab)),
								_Utils_Tuple2('pmt-ui-view-selector__item--enabled', !isDisabled)
							])),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(
						$author$project$PinMeTo$Ui$SelectorWithFilterController$SetActiveTab(tab)),
						A2($elm$html$Html$Attributes$attribute, 'data-label', label),
						$elm$html$Html$Attributes$disabled(isDisabled)
					]),
				_List_fromArray(
					[
						countColor ? A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label + ' ('),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-table__warning-color')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(count))
									])),
								$elm$html$Html$text(')')
							])) : $elm$html$Html$text(
						label + (' (' + ($elm$core$String$fromInt(count) + ')')))
					]));
		};
		var baseCols = _List_fromArray(
			[
				{tab: $author$project$PinMeTo$Ui$SelectorWithFilterController$All, count: allCount, label: labels.itemPlural, countColor: false, isDisabled: false},
				{tab: $author$project$PinMeTo$Ui$SelectorWithFilterController$Selected, count: selectedCount, label: labels.selectedItems, countColor: false, isDisabled: !selectedCount}
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-view-selector pmt-ui-view-selector--labels')
				]),
			A2(
				$elm$core$List$map,
				itemView,
				(!(!unselectableCount)) ? A2(
					$elm$core$List$append,
					baseCols,
					_List_fromArray(
						[
							{tab: $author$project$PinMeTo$Ui$SelectorWithFilterController$Unselectable, count: unselectableCount, label: labels.unselectable, countColor: true, isDisabled: false}
						])) : baseCols));
	});
var $author$project$PinMeTo$Ui$Table$withSort = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{sort: x});
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$addColumns = F2(
	function (columns, tableView) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (column, t) {
					var renderItem = function (x) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(
								column.toString(x)),
							A2(
								$elm$core$Maybe$map,
								function (toHtml) {
									return toHtml(x);
								},
								column.toHtml));
					};
					var cmp = function () {
						var _v0 = column.sort;
						if (_v0.$ === 'Standard') {
							return $author$project$PinMeTo$Ui$Table$comparingString;
						} else {
							return $author$project$PinMeTo$Ui$Table$comparingStringAndNumber(30);
						}
					}();
					return A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						column.key,
						renderItem,
						cmp(column.toString),
						t);
				}),
			tableView,
			columns);
	});
var $author$project$PinMeTo$Ui$Table$withDeselected = function (config) {
	return _Utils_update(
		config,
		{displayDeselected: true});
};
var $author$project$PinMeTo$Ui$Table$withRowSelection = F2(
	function (f, config) {
		return _Utils_update(
			config,
			{
				rowSelection: $elm$core$Maybe$Just(f)
			});
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$itemsView = F9(
	function (tagger, currentTab, uiTable, idToString, columns, labels, childRow, items, initSort) {
		if (currentTab.$ === 'Unselectable') {
			return A2(
				$author$project$PinMeTo$Ui$Table$render,
				uiTable,
				A2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$addColumns,
					columns,
					$author$project$PinMeTo$Ui$Table$withNoHover(
						A2(
							$author$project$PinMeTo$Ui$Table$withLimit,
							{limit: 100, viewMoreLabel: labels.viewMore},
							A2(
								$author$project$PinMeTo$Ui$Table$withRowMore,
								function (x) {
									if (childRow.$ === 'Just') {
										var getChild = childRow.a;
										return A2(
											$elm$core$Maybe$map,
											$elm$html$Html$text,
											getChild(x));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								A2(
									$author$project$PinMeTo$Ui$Table$withRowMoreIndent,
									1,
									$author$project$PinMeTo$Ui$Table$withFullWidth(
										A2(
											$author$project$PinMeTo$Ui$Table$view,
											A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorWithFilterController$UiTableMsg, tagger),
											items))))))));
		} else {
			return A2(
				$author$project$PinMeTo$Ui$Table$render,
				uiTable,
				A2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$addColumns,
					columns,
					function () {
						if (initSort.$ === 'Just') {
							var sort = initSort.a;
							return $author$project$PinMeTo$Ui$Table$withSort(sort);
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						A2(
							$author$project$PinMeTo$Ui$Table$withRowSelection,
							idToString,
							A3(
								$author$project$PinMeTo$Ui$Table$when,
								_Utils_eq(currentTab, $author$project$PinMeTo$Ui$SelectorWithFilterController$Selected),
								$author$project$PinMeTo$Ui$Table$withDeselected,
								A2(
									$author$project$PinMeTo$Ui$Table$withLimit,
									{limit: 100, viewMoreLabel: labels.viewMore},
									$author$project$PinMeTo$Ui$Table$withFullWidth(
										A2(
											$author$project$PinMeTo$Ui$Table$view,
											A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorWithFilterController$UiTableMsg, tagger),
											items))))))));
		}
	});
var $author$project$PinMeTo$Ui$Table$selectedItems = function (_v0) {
	var model = _v0.a;
	return $elm$core$Set$toList(model.selected);
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterFormMsg = function (a) {
	return {$: 'UiFilterFormMsg', a: a};
};
var $author$project$PinMeTo$Ui$Table$deselectedItems = function (_v0) {
	var model = _v0.a;
	return $elm$core$Set$toList(model.deselected);
};
var $author$project$PinMeTo$Ui$FilterController$withResultsCount = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$FilterController$View(
			_Utils_update(
				config,
				{
					resultsCount: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$FilterController$withUnselectables = F2(
	function (_v0, _v1) {
		var allCount = _v0.a;
		var unselectablesCount = _v0.b;
		var config = _v1.a;
		return $author$project$PinMeTo$Ui$FilterController$View(
			_Utils_update(
				config,
				{
					allCount: $elm$core$Maybe$Just(allCount),
					unselectablesCount: $elm$core$Maybe$Just(unselectablesCount)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerMsg = function (a) {
	return {$: 'UiFilterControllerMsg', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$render_ = F4(
	function (_v0, _v1, _v2, items) {
		var isLoadingItems = _v0.isLoadingItems;
		var unselectableCount = _v0.unselectableCount;
		var allCount = _v0.allCount;
		var model = _v1.a;
		var config = _v2.a;
		var _v3 = function () {
			if (_Utils_eq(model.currentTab, $author$project$PinMeTo$Ui$SelectorWithFilterController$Selected)) {
				var included = _Utils_ap(
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable),
					$author$project$PinMeTo$Ui$Table$deselectedItems(model.uiTable));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$filter,
						function (item) {
							return A2(
								$elm$core$List$member,
								config.idToString(item),
								included);
						},
						items),
					$elm$core$Maybe$Nothing);
			} else {
				var items_ = A2(
					$elm$core$List$filter,
					config.search(model.searchQuery),
					items);
				return _Utils_Tuple2(
					items_,
					$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-selector__filter-controller')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$PinMeTo$Ui$FilterController$render,
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerMsg, config.tagger),
									model.uiFilterController,
									A3(
										$author$project$PinMeTo$Ui$Filter$FilterFormBase$render,
										A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterFormMsg, config.tagger),
										model.uiFilterForm,
										config.labels),
									(_Utils_eq(model.currentTab, $author$project$PinMeTo$Ui$SelectorWithFilterController$All) ? $author$project$PinMeTo$Ui$FilterController$withUnselectables(
										_Utils_Tuple2(allCount, unselectableCount)) : $elm$core$Basics$identity)(
										A2(
											$author$project$PinMeTo$Ui$FilterController$withResultsCount,
											$elm$core$List$length(items_),
											$author$project$PinMeTo$Ui$FilterController$view(
												{uid: 'pmt-ui-selector', labels: config.labels.locationSelectorFilterController, locale: config.locale}))))
								]))));
			}
		}();
		var filteredItems = _v3.a;
		var filtersView = _v3.b;
		var selectedCount = $elm$core$List$length(
			$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
		var tabs = A2(
			$author$project$PinMeTo$Ui$SelectorWithFilterController$tabsView,
			{allCount: allCount, currentTab: model.currentTab, selectedCount: selectedCount, unselectableCount: unselectableCount},
			config.labels.locationSelector.uiSelector);
		return config.readOnly ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-selector__items')
						]),
					_List_fromArray(
						[
							function () {
							var included = _Utils_ap(
								$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable),
								$author$project$PinMeTo$Ui$Table$deselectedItems(model.uiTable));
							return A2(
								$author$project$PinMeTo$Ui$Table$render,
								model.uiTable,
								A2(
									$author$project$PinMeTo$Ui$SelectorWithFilterController$addColumns,
									config.columns,
									A2(
										$author$project$PinMeTo$Ui$Table$withLimit,
										{limit: 100, viewMoreLabel: config.labels.locationSelector.uiSelector.viewMore},
										$author$project$PinMeTo$Ui$Table$withFullWidth(
											A2(
												$author$project$PinMeTo$Ui$Table$view,
												A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorWithFilterController$UiTableMsg, config.tagger),
												A2(
													$elm$core$List$filter,
													function (item) {
														return A2(
															$elm$core$List$member,
															config.idToString(item),
															included);
													},
													items))))));
						}()
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-selector__tabs')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$map, config.tagger, tabs)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					filtersView),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-selector__items')
						]),
					_List_fromArray(
						[
							isLoadingItems ? $author$project$PinMeTo$Ui$Spinner$spinner : A9($author$project$PinMeTo$Ui$SelectorWithFilterController$itemsView, config.tagger, model.currentTab, model.uiTable, config.idToString, config.columns, config.labels.locationSelector.uiSelector, config.childRow, filteredItems, config.initialSort)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var countItems = function (x) {
			if (x.$ === 'Loaded') {
				var xs = x.a;
				return $elm$core$List$length(xs);
			} else {
				return 0;
			}
		};
		var items = function () {
			var _v4 = model.currentTab;
			switch (_v4.$) {
				case 'All':
					return model.items;
				case 'Selected':
					return model.items;
				default:
					return model.unselectableItems;
			}
		}();
		var renderConfig = {
			allCount: countItems(model.items),
			isLoadingItems: _Utils_eq(items, $author$project$PinMeTo$Ui$SelectorWithFilterController$Loading),
			unselectableCount: countItems(model.unselectableItems)
		};
		switch (items.$) {
			case 'Loading':
				return model.firstLoadDone ? A4(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$render_,
					renderConfig,
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(model),
					$author$project$PinMeTo$Ui$SelectorWithFilterController$View(config),
					_List_Nil) : $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
			case 'Error':
				var _v3 = items.a;
				return $author$project$PinMeTo$Ui$StatusBar$render(
					$author$project$PinMeTo$Ui$StatusBar$error(config.labels.errorFetchingItems));
			default:
				var items_ = items.a;
				return A4(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$render_,
					renderConfig,
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(model),
					$author$project$PinMeTo$Ui$SelectorWithFilterController$View(config),
					items_);
		}
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$OnSelect = function (a) {
	return {$: 'OnSelect', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$UnSelect = function (a) {
	return {$: 'UnSelect', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$readOnly = F2(
	function (value, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
			_Utils_update(
				config,
				{readOnly: value}));
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$Standard = {$: 'Standard'};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$withColumn = F2(
	function (column, _v0) {
		var config = _v0.a;
		var column_ = {key: column.key, sort: $author$project$PinMeTo$Ui$SelectorWithFilterController$Standard, toHtml: $elm$core$Maybe$Nothing, toString: column.toString};
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
			_Utils_update(
				config,
				{
					columns: A2($elm$core$List$cons, column_, config.columns)
				}));
	});
var $author$project$FontAwesome$Regular$Icon$faCircleInfo = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-circle-info');
var $author$project$FontAwesome$Regular$faCircleInfo = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faCircleInfo);
var $author$project$FontAwesome$Solid$Icon$faCircleCheck = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-circle-check');
var $author$project$FontAwesome$Solid$faCircleCheck = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircleCheck);
var $author$project$FontAwesome$Solid$Icon$faCircleXmark = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-circle-xmark');
var $author$project$FontAwesome$Solid$faCircleXmark = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircleXmark);
var $author$project$FontAwesome$Regular$Icon$faLightbulbOn = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-lightbulb-on');
var $author$project$FontAwesome$Regular$faLightbulbOn = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faLightbulbOn);
var $author$project$FontAwesome$Solid$Icon$faTriangleExclamation = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-triangle-exclamation');
var $author$project$FontAwesome$Solid$faTriangleExclamation = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faTriangleExclamation);
var $author$project$PinMeTo$Ui$Alert$withStatus = F2(
	function (status, _v0) {
		var config = _v0.a;
		var icon = function () {
			switch (status.$) {
				case 'Note':
					return $author$project$FontAwesome$Solid$faCircleInfo;
				case 'Success':
					return $author$project$FontAwesome$Solid$faCircleCheck;
				case 'Warning':
					return $author$project$FontAwesome$Solid$faTriangleExclamation;
				case 'Error':
					return $author$project$FontAwesome$Solid$faCircleXmark;
				case 'Disclaimer':
					return $author$project$FontAwesome$Regular$faCircleInfo;
				default:
					return $author$project$FontAwesome$Regular$faLightbulbOn;
			}
		}();
		return $author$project$PinMeTo$Ui$Alert$Alert(
			_Utils_update(
				config,
				{icon: icon, status: status}));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$ShowSelector = F2(
	function (a, b) {
		return {$: 'ShowSelector', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$renderAction = $author$project$PinMeTo$Ui$Selector$renderAction;
var $author$project$PinMeTo$Ui$SelectorWithFilterController$withChildRow = F2(
	function (getChild, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
			_Utils_update(
				config,
				{
					childRow: $elm$core$Maybe$Just(getChild)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$UiSelectorMsg = function (a) {
	return {$: 'UiSelectorMsg', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$renderActions = F2(
	function (config, _v0) {
		var model = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-btn-group')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							config.onSelect(
								$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable))),
							$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-selector-add-selection')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.label)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Selector$ReadOnlyAction = function (a) {
	return {$: 'ReadOnlyAction', a: a};
};
var $author$project$PinMeTo$Ui$Selector$readOnlyAction = F2(
	function (labels, config) {
		return $author$project$PinMeTo$Ui$Selector$ReadOnlyAction(
			{count: config.count, labels: labels, showSelector: config.showSelector});
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$readOnlyAction = $author$project$PinMeTo$Ui$Selector$readOnlyAction;
var $author$project$PinMeTo$Ui$SelectorWithFilterController$getSelectedList = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable);
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$withInitialSort = F2(
	function (sort, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
			_Utils_update(
				config,
				{
					initialSort: $elm$core$Maybe$Just(sort)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$withColumnRenderer = F2(
	function (column, _v0) {
		var config = _v0.a;
		var column_ = {
			key: column.key,
			sort: $author$project$PinMeTo$Ui$SelectorWithFilterController$Standard,
			toHtml: $elm$core$Maybe$Just(column.toHtml),
			toString: column.toString
		};
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
			_Utils_update(
				config,
				{
					columns: A2($elm$core$List$cons, column_, config.columns)
				}));
	});
var $author$project$PinMeTo$Ui$Selector$renderReadOnlyAction = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-selector-action')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Button$render(
				A2(
					$author$project$PinMeTo$Ui$Button$withDataTestAttribute,
					$author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute('pmt-ui-selector-action-show'),
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						config.showSelector,
						A2(
							$author$project$PinMeTo$Ui$Button$withSecondaryStyle,
							$author$project$PinMeTo$Ui$Button$SecondaryDefault,
							$author$project$PinMeTo$Ui$Button$buttonSecondary(
								config.labels.itemsPluralized(config.count) + (' (' + ($elm$core$String$fromInt(config.count) + ')')))))))
			]));
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$renderReadOnlyAction = $author$project$PinMeTo$Ui$Selector$renderReadOnlyAction;
var $author$project$PinMeTo$Ui$SelectorWithFilterController$WithPadding = {$: 'WithPadding'};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$withColumnPaddedSort = F2(
	function (column, _v0) {
		var config = _v0.a;
		var column_ = {key: column.key, sort: $author$project$PinMeTo$Ui$SelectorWithFilterController$WithPadding, toHtml: $elm$core$Maybe$Nothing, toString: column.toString};
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$View(
			_Utils_update(
				config,
				{
					columns: A2($elm$core$List$cons, column_, config.columns)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$needsVerificationToHtml = F2(
	function (locations, itemId) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (x) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-selector-row-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-selector-row-container--warning-icon')
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Solid$faTriangleExclamation])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-selector-row-container--text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(x)
								]))
						]));
			},
			A2($elm$core$Dict$get, itemId, locations));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$needsVerificationToString = F2(
	function (locations, itemId) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, itemId, locations));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$needsVerificationGetUnSelectList = F2(
	function (locationsNeedsVerification, selectedLocations) {
		var selectedLocationsSet = $elm$core$Set$fromList(selectedLocations);
		return A2(
			$elm$core$Set$filter,
			function (location) {
				return A2($elm$core$Dict$member, location, locationsNeedsVerification);
			},
			selectedLocationsSet);
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var labels = config.labels;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-ui-selector-location')
				]),
			_List_fromArray(
				[
					(!config.readOnly) ? A2(
					$elm$html$Html$map,
					config.tagger,
					$author$project$PinMeTo$Ui$SelectorWithFilterController$renderAction(
						A2(
							$author$project$PinMeTo$Ui$SelectorWithFilterController$action,
							{selectItems: labels.locationSelector.uiSelector.itemPlural, clearSelection: labels.locationSelector.clearSelection, itemsPluralized: labels.locationSelector.selectedItems},
							{
								count: $elm$core$Set$size(config.selected),
								showSelector: A2($author$project$PinMeTo$Ui$SelectorLocationWithFilters$ShowSelector, config.selected, true),
								clearSelection: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$OnSelect($elm$core$Set$empty)
							}))) : A2(
					$elm$html$Html$map,
					config.tagger,
					$author$project$PinMeTo$Ui$SelectorWithFilterController$renderReadOnlyAction(
						A2(
							$author$project$PinMeTo$Ui$SelectorWithFilterController$readOnlyAction,
							{itemsPluralized: labels.locationSelector.selectedItems},
							{
								count: $elm$core$Set$size(config.selected),
								showSelector: A2($author$project$PinMeTo$Ui$SelectorLocationWithFilters$ShowSelector, config.selected, true)
							}))),
					function () {
					var _v2 = model.selector;
					if (_v2.$ === 'Just') {
						var selector = _v2.a;
						var _v3 = $elm$core$Dict$isEmpty(config.needsVerifications.locations) ? _Utils_Tuple2($elm$core$Basics$identity, $elm$core$Basics$identity) : _Utils_Tuple2(
							$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumnRenderer(
								{
									key: config.needsVerifications.columnTitle,
									toHtml: function (item) {
										return A2($author$project$PinMeTo$Ui$SelectorLocationWithFilters$needsVerificationToHtml, config.needsVerifications.locations, item.id);
									},
									toString: function (item) {
										return A2($author$project$PinMeTo$Ui$SelectorLocationWithFilters$needsVerificationToString, config.needsVerifications.locations, item.id);
									}
								}),
							$author$project$PinMeTo$Ui$SelectorWithFilterController$withInitialSort(
								$author$project$PinMeTo$Ui$Table$Desc(0)));
						var needsVerificationColumn = _v3.a;
						var initialSort = _v3.b;
						var selectedList = $author$project$PinMeTo$Ui$SelectorWithFilterController$getSelectedList(selector);
						var unselectList = A2($author$project$PinMeTo$Ui$SelectorLocationWithFilters$needsVerificationGetUnSelectList, config.needsVerifications.locations, selectedList);
						var unselectListLength = $elm$core$String$fromInt(
							$elm$core$Set$size(unselectList));
						var selectedListLength = $elm$core$String$fromInt(
							$elm$core$List$length(selectedList));
						var needsVerificationAlert = $elm$core$Set$isEmpty(unselectList) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-selector-footer-container')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Warning,
										$author$project$PinMeTo$Ui$Alert$rich(
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('location-selector-alert-content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('location-selector-alert-content__text')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(unselectListLength + ('/' + (selectedListLength + config.needsVerifications.alertText)))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('location-selector-alert-content--actions')
																]),
															_List_fromArray(
																[
																	$author$project$PinMeTo$Ui$Button$render(
																	A2(
																		$author$project$PinMeTo$Ui$Button$withSize,
																		$author$project$PinMeTo$Ui$Button$Small,
																		A2(
																			$author$project$PinMeTo$Ui$Button$withOnClick,
																			$author$project$PinMeTo$Ui$SelectorLocationWithFilters$UnSelect(unselectList),
																			A2(
																				$author$project$PinMeTo$Ui$Button$withGhostStyle,
																				$author$project$PinMeTo$Ui$Button$GhostDanger,
																				$author$project$PinMeTo$Ui$Button$buttonGhost(config.needsVerifications.alertButtonLabel + (' (' + (unselectListLength + ')')))))))
																]))
														]))
												]))))
								]));
						var content = A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-selector-with-filter-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$SelectorWithFilterController$render,
									selector,
									A2(
										$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumnRenderer,
										{
											key: labels.locationSelector.columns.created,
											toHtml: A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.created;
												},
												A2(
													$elm$core$Basics$composeR,
													$author$project$PinMeTo$Ui$Date$posix(config.locale),
													A2(
														$elm$core$Basics$composeR,
														$author$project$PinMeTo$Ui$Date$withFormat($author$project$PinMeTo$Ui$Date$FormatDate),
														$author$project$PinMeTo$Ui$Date$render))),
											toString: A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.created;
												},
												A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt))
										},
										A2(
											$author$project$PinMeTo$Ui$SelectorWithFilterController$readOnly,
											config.readOnly,
											A2(
												$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumn,
												{
													key: labels.locationSelector.columns.country,
													toString: A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.address;
														},
														function ($) {
															return $.country;
														})
												},
												A2(
													$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumn,
													{
														key: labels.locationSelector.columns.city,
														toString: A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.address;
															},
															function ($) {
																return $.city;
															})
													},
													A2(
														$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumnPaddedSort,
														{
															key: labels.locationSelector.columns.zip,
															toString: A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.address;
																},
																function ($) {
																	return $.zip;
																})
														},
														A2(
															$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumn,
															{
																key: labels.locationSelector.columns.street,
																toString: A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.address;
																	},
																	function ($) {
																		return $.street;
																	})
															},
															A2(
																$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumn,
																{
																	key: labels.locationSelector.columns.locationDescriptor,
																	toString: function ($) {
																		return $.locationDescriptor;
																	}
																},
																A2(
																	$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumn,
																	{
																		key: labels.locationSelector.columns.name,
																		toString: function ($) {
																			return $.name;
																		}
																	},
																	A2(
																		$author$project$PinMeTo$Ui$SelectorWithFilterController$withColumnPaddedSort,
																		{
																			key: labels.locationSelector.columns.storeId,
																			toString: function ($) {
																				return $.storeId;
																			}
																		},
																		needsVerificationColumn(
																			initialSort(
																				A2(
																					$author$project$PinMeTo$Ui$SelectorWithFilterController$withChildRow,
																					function ($) {
																						return $.reason;
																					},
																					$author$project$PinMeTo$Ui$SelectorWithFilterController$view(
																						{
																							labels: {locationSelector: labels.locationSelector, brandPageSelector: labels.brandPageSelector, errorFetchingItems: labels.locationSelector.uiSelector.errorFetchingItems, locationSelectorFilterController: labels.locationSelectorFilterController},
																							locale: config.locale,
																							search: $author$project$PinMeTo$Ui$SelectorLocation$search,
																							tagger: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$UiSelectorMsg,
																							idToString: function (item) {
																								return item.id;
																							}
																						}))))))))))))))
								]));
						return A2(
							$elm$html$Html$map,
							config.tagger,
							$author$project$PinMeTo$Ui$Lightbox$render(
								((!config.readOnly) ? $author$project$PinMeTo$Ui$Lightbox$withFooter(
									A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												needsVerificationAlert,
												A2(
												$author$project$PinMeTo$Ui$SelectorWithFilterController$renderActions,
												{
													label: labels.locationSelector.submit,
													onSelect: A2($elm$core$Basics$composeR, $elm$core$Set$fromList, $author$project$PinMeTo$Ui$SelectorLocationWithFilters$OnSelect)
												},
												selector)
											]))) : $elm$core$Basics$identity)(
									$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
										A2(
											$author$project$PinMeTo$Ui$Lightbox$withClose,
											A2($author$project$PinMeTo$Ui$SelectorLocationWithFilters$ShowSelector, config.selected, false),
											$author$project$PinMeTo$Ui$Lightbox$view(
												{title: labels.locationSelector.title, content: content}))))));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate = F4(
	function (a, b, c, d) {
		return {$: 'OnUpdate', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$withSelected = F2(
	function (selected, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$View(
			_Utils_update(
				config,
				{
					selected: $elm$core$Set$fromList(selected)
				}));
	});
var $author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectorBrandPageMsg = F4(
	function (a, b, c, d) {
		return {$: 'UiSelectorBrandPageMsg', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectorLocationWithFiltersMsg = F4(
	function (a, b, c, d) {
		return {$: 'UiSelectorLocationWithFiltersMsg', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Filter$FilterForm$render = F7(
	function (tagger, _v0, labels, locale, propertyDefinitions, uid, theFilter) {
		var model = _v0.a;
		var renderFilter = function (propertyDefinition) {
			var configErrorMessage = function (p) {
				return $elm$html$Html$text('Incorrectly configured property \u0027' + (p + '\u0027'));
			};
			var brandPageSelector = F2(
				function (property, selected) {
					return A2(
						$author$project$PinMeTo$Ui$SelectorBrandPage$render,
						model.brandPageSelector,
						A2(
							$author$project$PinMeTo$Ui$SelectorBrandPage$withSelected,
							selected,
							$author$project$PinMeTo$Ui$SelectorBrandPage$view(
								{
									labels: labels.brandPageSelector,
									locale: locale,
									tagger: A2(
										$elm$core$Basics$composeR,
										A3($author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectorBrandPageMsg, theFilter, property, propertyDefinition),
										tagger)
								})));
				});
			var locationSelector = F2(
				function (property, selected) {
					return A2(
						$author$project$PinMeTo$Ui$SelectorLocationWithFilters$render,
						model.locationSelectorWithFilters,
						A2(
							$author$project$PinMeTo$Ui$SelectorLocationWithFilters$withSelected,
							selected,
							$author$project$PinMeTo$Ui$SelectorLocationWithFilters$view(
								{
									labels: labels,
									locale: locale,
									tagger: A2(
										$elm$core$Basics$composeR,
										A3($author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectorLocationWithFiltersMsg, theFilter, property, propertyDefinition),
										tagger)
								})));
				});
			var _v1 = $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyMeta(propertyDefinition).property;
			var propertyName = _v1.a;
			var currentFilter = A3($author$project$PinMeTo$Ui$Filter$FilterFormFilter$getFilter, propertyDefinition, propertyName, theFilter);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-filter-form__property')
					]),
				_List_fromArray(
					[
						function () {
						var _v2 = _Utils_Tuple2(currentFilter, propertyDefinition);
						_v2$6:
						while (true) {
							switch (_v2.b.$) {
								case 'SingleProperty':
									if (_v2.a.b.$ === 'SingleValue') {
										var _v3 = _v2.a;
										var p = _v3.a;
										var value = _v3.b.a;
										var meta = _v2.b.a;
										return A2(
											$elm$html$Html$map,
											tagger,
											A8(
												$author$project$PinMeTo$Ui$Filter$FilterFormBase$singleValueField,
												{onSelect: $author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate, uiSelectTagger: $author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectMsg},
												model.uiSelect,
												uid,
												p,
												value,
												meta,
												propertyDefinition,
												theFilter));
									} else {
										break _v2$6;
									}
								case 'MultiProperty':
									if (_v2.a.b.$ === 'MultiValue') {
										var _v4 = _v2.a;
										var p = _v4.a;
										var values = _v4.b.a;
										var meta = _v2.b.a;
										return A2(
											$elm$html$Html$map,
											tagger,
											A6(
												$author$project$PinMeTo$Ui$Filter$FilterFormBase$multiValueField,
												{onSelect: $author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate},
												p,
												values,
												meta,
												propertyDefinition,
												theFilter));
									} else {
										break _v2$6;
									}
								case 'AnyTextProperty':
									var _v5 = _v2.a;
									var p = _v5.a;
									var propertyValue = _v5.b;
									var meta = _v2.b.a;
									return A2(
										$elm$html$Html$map,
										tagger,
										A6(
											$author$project$PinMeTo$Ui$Filter$FilterFormBase$textValueField,
											{onSelect: $author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate},
											p,
											propertyValue,
											meta,
											propertyDefinition,
											theFilter));
								case 'MultiTextProperty':
									var _v6 = _v2.a;
									var p = _v6.a;
									var propertyValue = _v6.b;
									var meta = _v2.b.a;
									return A2(
										$elm$html$Html$map,
										tagger,
										A9(
											$author$project$PinMeTo$Ui$Filter$FilterFormBase$multiTextValueField,
											{onSelect: $author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate, uiSelectTagger: $author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectMsg},
											model.uiSelect,
											uid,
											p,
											propertyValue,
											meta,
											propertyDefinition,
											theFilter,
											labels.locationSelectorFilterController));
								case 'LocationSelectorProperty':
									if (_v2.a.b.$ === 'MultiValue') {
										var _v7 = _v2.a;
										var values = _v7.b.a;
										var meta = _v2.b.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-filter-form__multi')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(meta.displayName)
														])),
													A2(locationSelector, meta.property, values)
												]));
									} else {
										break _v2$6;
									}
								default:
									if (_v2.a.b.$ === 'MultiValue') {
										var _v8 = _v2.a;
										var values = _v8.b.a;
										var meta = _v2.b.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-filter-form__multi')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-ui-filter-form__title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(meta.displayName)
														])),
													A2(brandPageSelector, meta.property, values)
												]));
									} else {
										break _v2$6;
									}
							}
						}
						var _v9 = _v2.a;
						var p = _v9.a.a;
						return configErrorMessage(p);
					}()
					]));
		};
		var sortPropDef = function (xs) {
			return A2(
				$elm$core$List$sortBy,
				function (x) {
					return $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyMeta(x).sortOrder;
				},
				xs);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-filter-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-filter-form__properties')
						]),
					A2(
						$elm$core$List$map,
						renderFilter,
						sortPropDef(
							$elm$core$Dict$values(propertyDefinitions))))
				]));
	});
var $author$project$PinMeTo$Global$FilterController$UiFilterFormMsg = function (a) {
	return {$: 'UiFilterFormMsg', a: a};
};
var $author$project$PinMeTo$Global$FilterController$render = F4(
	function (labels, tagger, _v0, view) {
		var model = _v0.a;
		return A4(
			$author$project$PinMeTo$Ui$FilterController$render,
			A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$UiFilterControllerMsg, tagger),
			model.uiFilterController,
			A3(
				$author$project$PinMeTo$Ui$Filter$FilterForm$render,
				A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$UiFilterFormMsg, tagger),
				model.uiFilterForm,
				labels),
			view);
	});
var $author$project$PinMeTo$Ui$FilterController$withSearchOptionsOnly = F2(
	function (label, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$FilterController$View(
			_Utils_update(
				config,
				{withSearchOptionsOnly: true}));
	});
var $author$project$Translations$General$save = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.save');
};
var $author$project$Translations$General$reset = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.reset');
};
var $author$project$Translations$General$create = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.create');
};
var $author$project$Translations$General$delete = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.delete');
};
var $author$project$Translations$General$clearAll = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.clear_all');
};
var $author$project$Translations$General$addFilter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.add_filter');
};
var $author$project$Translations$General$saveAsNew = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.save_as_new');
};
var $author$project$Translations$General$addFilters = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.add_filters');
};
var $author$project$Translations$General$editFilter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.edit_filter');
};
var $author$project$Translations$General$filterName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.filter_name');
};
var $author$project$Translations$General$addSelected = F2(
	function (translations, selection) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.add_selected',
			_List_fromArray(
				[
					_Utils_Tuple2('selection', selection)
				]));
	});
var $author$project$Translations$General$allLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.all_locations');
};
var $author$project$Translations$General$noFiltersFound = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_filters_found');
};
var $author$project$Translations$General$searchLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.search_locations');
};
var $author$project$Translations$General$searchNoResults = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.search_no_results');
};
var $author$project$Translations$General$searchPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.search_placeholder');
};
var $author$project$Translations$General$nameFilterPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.name_filter_placeholder');
};
var $author$project$Translations$General$unselectableLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.unselectable_locations');
};
var $author$project$Filter$FilterLabels$unselectableFilterLabel = F2(
	function (translations, language) {
		return function (_v0) {
			var unselectableCount = _v0.unselectableCount;
			var totalCount = _v0.totalCount;
			return (!(!unselectableCount)) ? ($elm$core$String$fromInt(totalCount) + (' / ' + ($elm$core$String$fromInt(unselectableCount + totalCount) + (' ' + A4($author$project$Common$Language$i18n, translations, language, 'general.location', totalCount))))) : _Utils_ap(
				$elm$core$String$fromInt(totalCount),
				$author$project$Translations$General$unselectableLocations(translations));
		};
	});
var $author$project$Filter$FilterLabels$locationsFilterControllerLabels = F2(
	function (translations, language) {
		return {
			save: $author$project$Translations$General$save(translations),
			reset: $author$project$Translations$General$reset(translations),
			create: $author$project$Translations$General$create(translations),
			_delete: $author$project$Translations$General$delete(translations),
			allItems: $author$project$Translations$General$allLocations(translations),
			clearAll: $author$project$Translations$General$clearAll(translations),
			addFilter: $author$project$Translations$General$addFilter(translations),
			saveAsNew: $author$project$Translations$General$saveAsNew(translations),
			addFilters: $author$project$Translations$General$addFilters(translations),
			editFilter: $author$project$Translations$General$editFilter(translations),
			filterName: $author$project$Translations$General$filterName(translations),
			addSelection: $author$project$Translations$General$addSelected(translations),
			numberOfItems: function (n) {
				return A4($author$project$Common$Language$i18n, translations, language, 'general.number_of_locations', n);
			},
			noFiltersFound: $author$project$Translations$General$noFiltersFound(translations),
			searchNoResults: $author$project$Translations$General$searchNoResults(translations),
			searchPlaceholder: $author$project$Translations$General$searchPlaceholder(translations),
			numberOfItemsLimited: function (_v0) {
				return '';
			},
			nameFilterPlaceholder: $author$project$Translations$General$nameFilterPlaceholder(translations),
			searchItemsPlaceholder: $author$project$Translations$General$searchLocations(translations),
			numberOfItemsWithUnselectables: A2($author$project$Filter$FilterLabels$unselectableFilterLabel, translations, language)
		};
	});
var $author$project$Translations$General$errorOccurred = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.error_occurred');
};
var $author$project$Translations$General$clear = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.clear');
};
var $author$project$Translations$General$location = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location');
};
var $author$project$Translations$General$viewMore = F3(
	function (translations, count, total) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.view_more',
			_List_fromArray(
				[
					_Utils_Tuple2(' count ', count),
					_Utils_Tuple2(' total ', total)
				]));
	});
var $author$project$Filter$FilterLabels$viewMore = F3(
	function (translations, count, total) {
		return A3(
			$author$project$Translations$General$viewMore,
			translations,
			$elm$core$String$fromInt(count),
			$elm$core$String$fromInt(total));
	});
var $author$project$Translations$General$locations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.locations');
};
var $author$project$Translations$General$locationZip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_zip');
};
var $author$project$Translations$General$addSelection = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.add_selection');
};
var $author$project$Translations$General$locationCity = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_city');
};
var $author$project$Translations$General$locationName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_name');
};
var $author$project$Translations$General$unselectable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.unselectable');
};
var $author$project$Translations$General$locationStreet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_street');
};
var $author$project$Translations$General$locationCountry = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_country');
};
var $author$project$Translations$General$locationCreated = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_created');
};
var $author$project$Translations$General$locationStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_store_id');
};
var $author$project$Translations$General$locationsInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.locations_invalid');
};
var $author$project$Translations$General$locationsSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.locations_selected');
};
var $author$project$Translations$General$locationDescriptor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_descriptor');
};
var $author$project$Translations$General$locationSelectTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_select_title');
};
var $author$project$Filter$FilterLabels$selectorLocationLabels = F2(
	function (translations, language) {
		return {
			title: $author$project$Translations$General$locationSelectTitle(translations),
			submit: $author$project$Translations$General$addSelection(translations),
			columns: {
				zip: $author$project$Translations$General$locationZip(translations),
				city: $author$project$Translations$General$locationCity(translations),
				name: $author$project$Translations$General$locationName(translations),
				street: $author$project$Translations$General$locationStreet(translations),
				country: $author$project$Translations$General$locationCountry(translations),
				created: $author$project$Translations$General$locationCreated(translations),
				storeId: $author$project$Translations$General$locationStoreId(translations),
				locationDescriptor: $author$project$Translations$General$locationDescriptor(translations)
			},
			uiSelector: {
				item: $author$project$Translations$General$location(translations),
				nItems: function (n) {
					return A4($author$project$Common$Language$i18n, translations, language, 'general.number_of_locations', n);
				},
				viewMore: $author$project$Filter$FilterLabels$viewMore(translations),
				itemPlural: $author$project$Translations$General$locations(translations),
				searchItems: $author$project$Translations$General$searchLocations(translations),
				invalidItems: $author$project$Translations$General$locationsInvalid(translations),
				unselectable: $author$project$Translations$General$unselectable(translations),
				selectedItems: $author$project$Translations$General$locationsSelected(translations),
				errorFetchingItems: $author$project$Translations$General$errorOccurred(translations)
			},
			selectedItems: function (n) {
				return A4($author$project$Common$Language$i18n, translations, language, 'general.location_selected', n);
			},
			clearSelection: $author$project$Translations$General$clear(translations)
		};
	});
var $author$project$Translations$General$name = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.name');
};
var $author$project$Translations$General$network = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.network');
};
var $author$project$Translations$General$brandPage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.brand_page');
};
var $author$project$Translations$General$brandPages = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.brand_pages');
};
var $author$project$Translations$General$brandPageSearch = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.brand_page_search');
};
var $author$project$Translations$General$brandPageInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.brand_page_invalid');
};
var $author$project$Translations$General$brandPagesSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.brand_pages_selected');
};
var $author$project$Translations$General$brandPageSelectTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.brand_page_select_title');
};
var $author$project$Filter$FilterLabels$selectorBrandPageLabels = F2(
	function (translations, language) {
		return {
			title: $author$project$Translations$General$brandPageSelectTitle(translations),
			submit: $author$project$Translations$General$addSelection(translations),
			columns: {
				name: $author$project$Translations$General$name(translations),
				created: $author$project$Translations$General$locationCreated(translations),
				network: $author$project$Translations$General$network(translations)
			},
			uiSelector: {
				item: $author$project$Translations$General$brandPage(translations),
				nItems: function (n) {
					return A4($author$project$Common$Language$i18n, translations, language, 'general.number_of_brand_pages', n);
				},
				viewMore: $author$project$Filter$FilterLabels$viewMore(translations),
				itemPlural: $author$project$Translations$General$brandPages(translations),
				searchItems: $author$project$Translations$General$brandPageSearch(translations),
				invalidItems: $author$project$Translations$General$brandPageInvalid(translations),
				unselectable: $author$project$Translations$General$unselectable(translations),
				selectedItems: $author$project$Translations$General$brandPagesSelected(translations),
				errorFetchingItems: $author$project$Translations$General$errorOccurred(translations)
			},
			selectedItems: function (n) {
				return A4($author$project$Common$Language$i18n, translations, language, 'general.brand_page_selected', n);
			},
			clearSelection: $author$project$Translations$General$clear(translations)
		};
	});
var $author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels = F3(
	function (translations, language, filterControllerLabels) {
		return {
			locationSelector: A2($author$project$Filter$FilterLabels$selectorLocationLabels, translations, language),
			brandPageSelector: A2($author$project$Filter$FilterLabels$selectorBrandPageLabels, translations, language),
			errorFetchingItems: $author$project$Translations$General$errorOccurred(translations),
			locationSelectorFilterController: filterControllerLabels
		};
	});
var $author$project$Filter$FilterController$viewInsights = F4(
	function (model, locale, translations, language) {
		var labels = A2($author$project$Filter$FilterLabels$locationsFilterControllerLabels, translations, language);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$PinMeTo$Global$FilterController$render,
					A3($author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels, translations, language, labels),
					$author$project$Filter$FilterController$UiFilteredListMsg,
					model.uiFilteredList,
					A2(
						$author$project$PinMeTo$Ui$FilterController$withSearchOptionsOnly,
						$author$project$Translations$General$filter(translations),
						$author$project$PinMeTo$Ui$FilterController$view(
							{uid: 'filter-controller-insights', labels: labels, locale: locale})))
				]));
	});
var $author$project$Common$Filter$FilterControllerPort$view = function (state) {
	if (state.$ === 'Ok') {
		var model = state.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Common$Filter$FilterControllerPort$FilterControllerMsg,
			A4($author$project$Filter$FilterController$viewInsights, model.filterController, model.locale, model.translations, model.language));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$PinMeTo$Api$SelectorApi$All = {$: 'All'};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$PinMeTo$Api$SelectorApi$Places = {$: 'Places'};
var $author$project$PinMeTo$Ui$Filter$DataTypes$ExistingFilter = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$existingFilterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$Filter$DataTypes$ExistingFilter)));
var $author$project$PinMeTo$Api$FilterApi$getFilters = F3(
	function (siteName, filterType, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$PinMeTo$Ui$Filter$DataTypes$existingFilterDecoder)),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(
						'/api/filter/' + (siteName + ('/' + $author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType)))))));
	});
var $author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilterDefinition = function (_v0) {
	var filter = _v0.filter;
	var name = _v0.name;
	var id = _v0.id;
	var encodePropertyValue = function (p) {
		if (p.$ === 'SingleValue') {
			var s = p.a;
			return $elm$json$Json$Encode$string(s);
		} else {
			var xs = p.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, xs);
		}
	};
	var encodeFilterProperties = function (x) {
		var propName = x.a.a;
		var value = x.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'property',
					$elm$json$Json$Encode$string(propName)),
					_Utils_Tuple2(
					'value',
					encodePropertyValue(value))
				]));
	};
	return $elm$json$Json$Encode$object(
		$elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var id_ = _v1.a;
						return _Utils_Tuple2(
							'_id',
							$elm$json$Json$Encode$string(id_));
					},
					id),
					A2(
					$elm$core$Maybe$map,
					function (n) {
						return _Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(n));
					},
					name),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'filterDefinition',
						A2(
							$elm$json$Json$Encode$list,
							encodeFilterProperties,
							$elm$core$Dict$values(filter))))
				])));
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilter = function (filterDef) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filter',
				$author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilterDefinition(filterDef))
			]));
};
var $author$project$PinMeTo$Api$FilterApi$saveFilter = F5(
	function (siteName, filterType, propDef, filter, msg) {
		var json = $author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilter(filter);
		var url = '/api/filter/' + (siteName + ('/' + $author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType)));
		var saveNew = $lukewestby$elm_http_builder$HttpBuilder$request(
			$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					A2(
						$elm$http$Http$expectJson,
						msg,
						$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder(propDef)),
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						json,
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
		var saveExisting = function (_v0) {
			var id = _v0.a;
			return $lukewestby$elm_http_builder$HttpBuilder$request(
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withExpect,
						A2(
							$elm$http$Http$expectJson,
							msg,
							$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder(propDef)),
						A2(
							$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
							json,
							$lukewestby$elm_http_builder$HttpBuilder$put(url + ('/' + id))))));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			saveNew,
			A2($elm$core$Maybe$map, saveExisting, filter.id));
	});
var $lukewestby$elm_http_builder$HttpBuilder$delete = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('DELETE');
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(_Utils_Tuple0);
			}));
};
var $author$project$PinMeTo$Api$FilterApi$deleteFilter = F3(
	function (siteName, _v0, msg) {
		var id = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					$elm$http$Http$expectWhatever(msg),
					$lukewestby$elm_http_builder$HttpBuilder$delete('/api/filter/' + (siteName + ('/' + id))))));
	});
var $author$project$PinMeTo$Api$FilterApi$getFilterById = F5(
	function (siteName, filterType, propDef, _v0, msg) {
		var filterId = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder(propDef)),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(
						'/api/filter/' + (siteName + ('/' + ($author$project$PinMeTo$Api$FilterApi$filterTypeToString(filterType) + ('/' + filterId))))))));
	});
var $author$project$PinMeTo$Api$FilterApi$api = F2(
	function (siteName, filterType) {
		return {
			getFilters: A2($author$project$PinMeTo$Api$FilterApi$getFilters, siteName, filterType),
			saveFilter: A2($author$project$PinMeTo$Api$FilterApi$saveFilter, siteName, filterType),
			deleteFilter: $author$project$PinMeTo$Api$FilterApi$deleteFilter(siteName),
			getFilterById: A2($author$project$PinMeTo$Api$FilterApi$getFilterById, siteName, filterType)
		};
	});
var $author$project$PinMeTo$Ui$FilterController$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$applyEvents = function (cmds) {
	return $elm$core$Platform$Cmd$batch(
		A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$core$Task$perform,
					function (_v0) {
						return x;
					},
					$elm$core$Task$succeed(_Utils_Tuple0));
			},
			cmds));
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$PinMeTo$Ui$Select$updateModel = F2(
	function (state, f) {
		var model = state.a;
		return $author$project$PinMeTo$Ui$Select$State(
			f(model));
	});
var $author$project$PinMeTo$Ui$Select$close = function (state) {
	return A2(
		$author$project$PinMeTo$Ui$Select$updateModel,
		state,
		function (model) {
			return _Utils_update(
				model,
				{isOpen: $elm$core$Maybe$Nothing});
		});
};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$close = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$State(
		_Utils_update(
			model,
			{
				uiSelect: $author$project$PinMeTo$Ui$Select$close(model.uiSelect)
			}));
};
var $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$update = F3(
	function (tagger, msg, _v0) {
		var model = _v0.a;
		var msg_ = msg.a;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(tagger),
			A2(
				$elm$core$Tuple$mapFirst,
				function (x) {
					return $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$State(
						_Utils_update(
							model,
							{uiSelect: x}));
				},
				A3($author$project$PinMeTo$Ui$Select$update, $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$UiSelectMsg, msg_, model.uiSelect)));
	});
var $author$project$PinMeTo$Ui$FilterController$NewFilter = F2(
	function (a, b) {
		return {$: 'NewFilter', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$FilterController$FocusResult = function (a) {
	return {$: 'FocusResult', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption = F2(
	function (propertyDefinitions, x) {
		return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$SearchOption(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions(propertyDefinitions),
				x));
	});
var $author$project$PinMeTo$Ui$FilterController$OnFilterSaved = function (a) {
	return {$: 'OnFilterSaved', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$remoteDataMap = F2(
	function (f, remoteData) {
		switch (remoteData.$) {
			case 'Suspended':
				return $author$project$PinMeTo$Ui$FilterController$Suspended;
			case 'Loading':
				return $author$project$PinMeTo$Ui$FilterController$Loading;
			case 'Loaded':
				var a = remoteData.a;
				return $author$project$PinMeTo$Ui$FilterController$Loaded(
					f(a));
			default:
				var error = remoteData.a;
				return $author$project$PinMeTo$Ui$FilterController$Error(error);
		}
	});
var $author$project$PinMeTo$Ui$FilterController$ExistingFilter = F4(
	function (a, b, c, d) {
		return {$: 'ExistingFilter', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$FilterController$FilterFormData = F2(
	function (name, filter) {
		return {name: name, filter: filter};
	});
var $author$project$PinMeTo$Ui$FilterController$OnFilterDeleted = function (a) {
	return {$: 'OnFilterDeleted', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$FilterEditorError = function (a) {
	return {$: 'FilterEditorError', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilter = F2(
	function (a, b) {
		return {$: 'ReceivedSavedFilter', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilters = function (a) {
	return {$: 'ReceivedSavedFilters', a: a};
};
var $author$project$PinMeTo$Ui$FilterController$filterEditorSetErrorMessage = F2(
	function (error, editor) {
		if (editor.$ === 'ExistingFilter') {
			var existing = editor.b;
			var original = editor.c;
			var filter = editor.d;
			return A4(
				$author$project$PinMeTo$Ui$FilterController$ExistingFilter,
				$author$project$PinMeTo$Ui$FilterController$FilterEditorError(
					$elm$core$Maybe$Just(error)),
				existing,
				original,
				filter);
		} else {
			var filter = editor.b;
			return A2(
				$author$project$PinMeTo$Ui$FilterController$NewFilter,
				$author$project$PinMeTo$Ui$FilterController$FilterEditorError(
					$elm$core$Maybe$Just(error)),
				filter);
		}
	});
var $author$project$PinMeTo$Ui$FilterController$updateModel = F4(
	function (propertyDefinitions, config, msg, model) {
		switch (msg.$) {
			case 'FilterEditorOnNameChange':
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							inputStyle: $elm$core$String$isEmpty(x) ? $author$project$PinMeTo$Ui$FilterController$FocusError : $author$project$PinMeTo$Ui$FilterController$Default,
							filterEditor: A2(
								$author$project$PinMeTo$Ui$FilterController$remoteDataMap,
								function (filterEditor) {
									if (filterEditor.$ === 'ExistingFilter') {
										var error = filterEditor.a;
										var existing = filterEditor.b;
										var original = filterEditor.c;
										var formData = filterEditor.d;
										return A4(
											$author$project$PinMeTo$Ui$FilterController$ExistingFilter,
											error,
											existing,
											original,
											_Utils_update(
												formData,
												{name: x}));
									} else {
										var error = filterEditor.a;
										var formData = filterEditor.b;
										return A2(
											$author$project$PinMeTo$Ui$FilterController$NewFilter,
											error,
											_Utils_update(
												formData,
												{name: x}));
									}
								},
								model.filterEditor)
						}),
					$elm$core$Platform$Cmd$none);
			case 'FilterEditorClose':
				var filterDefinition = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filterEditor: $author$project$PinMeTo$Ui$FilterController$Suspended}),
					$author$project$PinMeTo$Ui$FilterController$applyEvents(
						_List_fromArray(
							[
								config.events.onFilter(filterDefinition)
							])));
			case 'FilterEditorReset':
				var filterDefinition = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filterEditor: A2(
								$author$project$PinMeTo$Ui$FilterController$remoteDataMap,
								function (filterEditor) {
									if (filterEditor.$ === 'ExistingFilter') {
										var error = filterEditor.a;
										var existing = filterEditor.b;
										var original = filterEditor.c;
										return A4($author$project$PinMeTo$Ui$FilterController$ExistingFilter, error, existing, original, original);
									} else {
										var error = filterEditor.a;
										return A2(
											$author$project$PinMeTo$Ui$FilterController$NewFilter,
											error,
											A2($author$project$PinMeTo$Ui$FilterController$FilterFormData, '', $elm$core$Dict$empty));
									}
								},
								model.filterEditor)
						}),
					$author$project$PinMeTo$Ui$FilterController$applyEvents(
						_List_fromArray(
							[
								config.events.onFilter(filterDefinition)
							])));
			case 'FilterEditorSave':
				var filterDefinition = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						config.tagger,
						A3(
							config.api.saveFilter,
							propertyDefinitions,
							filterDefinition,
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$OnFilterSaved, $author$project$PinMeTo$Ui$FilterController$LoadedMsg))));
			case 'FilterEditorDelete':
				var filterDefinitionId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						config.tagger,
						A2(
							config.api.deleteFilter,
							filterDefinitionId,
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$OnFilterDeleted, $author$project$PinMeTo$Ui$FilterController$LoadedMsg))));
			case 'OnSearch':
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{searchQuery: x}),
					$author$project$PinMeTo$Ui$FilterController$applyEvents(
						_List_fromArray(
							[
								config.events.onSearch(x)
							])));
			case 'ToggleSearchOptions':
				var _v3 = model.searchOptions;
				if (_v3.$ === 'Nothing') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								searchOptions: $elm$core$Maybe$Just(
									A2($author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption, propertyDefinitions, $elm$core$Maybe$Nothing)),
								searchOptionsToggled: true
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{searchOptionsToggled: !model.searchOptionsToggled}),
						$elm$core$Platform$Cmd$none);
				}
			case 'ClearSearchOptions':
				var emptySearchOptions = A2($author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption, propertyDefinitions, $elm$core$Maybe$Nothing);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							searchOptions: $elm$core$Maybe$Just(emptySearchOptions)
						}),
					$author$project$PinMeTo$Ui$FilterController$applyEvents(
						_List_fromArray(
							[
								config.events.onFilter(
								$author$project$PinMeTo$Ui$Filter$FilterFormFilter$toFilterDefinition(emptySearchOptions))
							])));
			case 'UiSavedFilterMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(config.tagger),
					A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{uiSavedFiltersSelect: x});
						},
						A3(
							$author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$update,
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$UiSavedFilterMsg, $author$project$PinMeTo$Ui$FilterController$LoadedMsg),
							msg_,
							model.uiSavedFiltersSelect)));
			case 'UiSavedFiltersSelectOnSelect':
				var filter = msg.a;
				if (filter.$ === 'Just') {
					var existingFilter = filter.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								searchOptions: $elm$core$Maybe$Nothing,
								uiSavedFiltersSelect: $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$close(model.uiSavedFiltersSelect)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							config.tagger,
							A3(
								config.api.getFilterById,
								propertyDefinitions,
								$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinitionId(existingFilter.id),
								A2(
									$elm$core$Basics$composeR,
									$author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilter(
										$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinitionId(existingFilter.id)),
									$author$project$PinMeTo$Ui$FilterController$LoadedMsg))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								searchQuery: '',
								searchOptions: $elm$core$Maybe$Nothing,
								selectedFilter: $elm$core$Maybe$Nothing,
								uiSavedFiltersSelect: $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$close(model.uiSavedFiltersSelect)
							}),
						function () {
							var defaultFilter = A3(
								$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinition,
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Nothing,
								$author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions(propertyDefinitions));
							return $author$project$PinMeTo$Ui$FilterController$applyEvents(
								_List_fromArray(
									[
										config.events.onFilter(defaultFilter)
									]));
						}());
				}
			case 'UiSavedFiltersSelectOnEdit':
				var filter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filterEditor: $author$project$PinMeTo$Ui$FilterController$Loading,
							uiSavedFiltersSelect: $author$project$PinMeTo$Ui$Filter$SavedFiltersSelect$close(model.uiSavedFiltersSelect)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						config.tagger,
						A3(
							config.api.getFilterById,
							propertyDefinitions,
							$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinitionId(filter.id),
							A2(
								$elm$core$Basics$composeR,
								$author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilter(
									$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinitionId(filter.id)),
								$author$project$PinMeTo$Ui$FilterController$LoadedMsg))));
			case 'UiSavedFiltersSelectOnAdd':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							filterEditor: $author$project$PinMeTo$Ui$FilterController$Loaded(
								A2(
									$author$project$PinMeTo$Ui$FilterController$NewFilter,
									$author$project$PinMeTo$Ui$FilterController$FilterEditorError($elm$core$Maybe$Nothing),
									A2($author$project$PinMeTo$Ui$FilterController$FilterFormData, '', $elm$core$Dict$empty)))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnFilterSaved':
				if (msg.a.$ === 'Ok') {
					var saved = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								filterEditor: $author$project$PinMeTo$Ui$FilterController$Suspended,
								searchOptions: $elm$core$Maybe$Just(
									A2(
										$author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption,
										propertyDefinitions,
										$elm$core$Maybe$Just(saved.filter))),
								selectedFilter: A3(
									$elm$core$Maybe$map2,
									F2(
										function (_v5, name) {
											var id = _v5.a;
											return A2($author$project$PinMeTo$Ui$Filter$DataTypes$ExistingFilter, id, name);
										}),
									saved.id,
									saved.name)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							config.tagger,
							config.api.getFilters(
								A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilters, $author$project$PinMeTo$Ui$FilterController$LoadedMsg))));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								filterEditor: A2(
									$author$project$PinMeTo$Ui$FilterController$remoteDataMap,
									$author$project$PinMeTo$Ui$FilterController$filterEditorSetErrorMessage('Could not save filter. Error has been logged...'),
									model.filterEditor)
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$Common$Util$httpErrorToString(e),
								context: config.loggerContext + ':OnFilterSaved',
								message: 'Failed to handle saved result for msg OnFilterSaved'
							}));
				}
			case 'OnFilterDeleted':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{filterEditor: $author$project$PinMeTo$Ui$FilterController$Suspended, selectedFilter: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Platform$Cmd$map,
									config.tagger,
									config.api.getFilters(
										A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilters, $author$project$PinMeTo$Ui$FilterController$LoadedMsg))),
									function (defaultFilter) {
									return $author$project$PinMeTo$Ui$FilterController$applyEvents(
										_List_fromArray(
											[
												config.events.onFilter(defaultFilter)
											]));
								}(
									A3(
										$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinition,
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Nothing,
										$author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions(propertyDefinitions)))
								])));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								filterEditor: A2(
									$author$project$PinMeTo$Ui$FilterController$remoteDataMap,
									$author$project$PinMeTo$Ui$FilterController$filterEditorSetErrorMessage('Could not delete filter. Error has been logged...'),
									model.filterEditor)
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$Common$Util$httpErrorToString(e),
								context: config.loggerContext + ':OnFilterDeleted ',
								message: 'Failed to delete filter'
							}));
				}
			case 'ReceivedSavedFilter':
				if (msg.b.$ === 'Ok') {
					var filterId = msg.a;
					var filterDefinition = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								searchQuery: function () {
									var _v6 = model.filterEditor;
									if (_v6.$ === 'Loading') {
										return model.searchQuery;
									} else {
										return '';
									}
								}(),
								filterEditor: function () {
									var _v7 = model.filterEditor;
									if (_v7.$ === 'Loading') {
										return $author$project$PinMeTo$Ui$FilterController$Loaded(
											A4(
												$author$project$PinMeTo$Ui$FilterController$ExistingFilter,
												$author$project$PinMeTo$Ui$FilterController$FilterEditorError($elm$core$Maybe$Nothing),
												filterId,
												A2(
													$author$project$PinMeTo$Ui$FilterController$FilterFormData,
													A2($elm$core$Maybe$withDefault, '', filterDefinition.name),
													filterDefinition.filter),
												A2(
													$author$project$PinMeTo$Ui$FilterController$FilterFormData,
													A2($elm$core$Maybe$withDefault, '', filterDefinition.name),
													filterDefinition.filter)));
									} else {
										return model.filterEditor;
									}
								}(),
								searchOptions: $elm$core$Maybe$Just(
									A2(
										$author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption,
										propertyDefinitions,
										$elm$core$Maybe$Just(filterDefinition.filter))),
								selectedFilter: A3(
									$elm$core$Maybe$map2,
									F2(
										function (_v8, name) {
											var id = _v8.a;
											return A2($author$project$PinMeTo$Ui$Filter$DataTypes$ExistingFilter, id, name);
										}),
									filterDefinition.id,
									filterDefinition.name)
							}),
						$author$project$PinMeTo$Ui$FilterController$applyEvents(
							_List_fromArray(
								[
									config.events.onFilter(filterDefinition)
								])));
				} else {
					var filterId = msg.a.a;
					var e = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								filterEditor: function () {
									var _v9 = model.filterEditor;
									if (_v9.$ === 'Loading') {
										return $author$project$PinMeTo$Ui$FilterController$Error('Failed to get saved filter. Error has been logged.');
									} else {
										return model.filterEditor;
									}
								}(),
								searchOptions: function () {
									var _v10 = model.searchOptions;
									if (_v10.$ === 'Nothing') {
										return $elm$core$Maybe$Just(
											A2($author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption, propertyDefinitions, $elm$core$Maybe$Nothing));
									} else {
										return model.searchOptions;
									}
								}()
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$Common$Util$httpErrorToString(e),
								context: config.loggerContext + ':ReceivedSavedFilter: ',
								message: 'Failed to get saved filter with id: ' + filterId
							}));
				}
			case 'ReceivedSavedFilters':
				if (msg.a.$ === 'Ok') {
					var filters = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								savedFilters: $author$project$PinMeTo$Ui$FilterController$Loaded(filters)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								savedFilters: $author$project$PinMeTo$Ui$FilterController$Error('Could not load saved filters. Try again later.')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$Common$Util$httpErrorToString(e),
								context: config.loggerContext + ':ReceivedSavedFilters: ',
								message: 'Failed to get all saved filters'
							}));
				}
			case 'FocusInput':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{inputStyle: $author$project$PinMeTo$Ui$FilterController$FocusError}),
					A2(
						$elm$core$Platform$Cmd$map,
						config.tagger,
						A2(
							$elm$core$Task$attempt,
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$FocusResult, $author$project$PinMeTo$Ui$FilterController$LoadedMsg),
							$elm$browser$Browser$Dom$focus($author$project$PinMeTo$Ui$FilterController$inputId))));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Ui$FilterController$PropertyDefinitionsFailed = function (a) {
	return {$: 'PropertyDefinitionsFailed', a: a};
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict = function (propertyDefinitions) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (def) {
				var _v0 = $author$project$PinMeTo$Ui$Filter$DataTypes$getPropertyMeta(def).property;
				var p = _v0.a;
				return _Utils_Tuple2(p, def);
			},
			propertyDefinitions));
};
var $author$project$PinMeTo$Ui$FilterController$update = F3(
	function (config, msg, _v0) {
		var loading = _v0.a;
		var model = _v0.b;
		if (msg.$ === 'ReceivedPropertyDefinitions') {
			if (msg.a.$ === 'Ok') {
				var propertyDefinitions = msg.a.a;
				return _Utils_Tuple2(
					A2(
						$author$project$PinMeTo$Ui$FilterController$State,
						_Utils_update(
							loading,
							{
								propertyDefinitions: $author$project$PinMeTo$Ui$FilterController$Loaded(propertyDefinitions)
							}),
						{
							inputStyle: $author$project$PinMeTo$Ui$FilterController$Default,
							searchQuery: model.searchQuery,
							filterEditor: $author$project$PinMeTo$Ui$FilterController$Suspended,
							savedFilters: $author$project$PinMeTo$Ui$FilterController$Loading,
							searchOptions: $elm$core$Maybe$Just(
								A2(
									$author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption,
									$author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict(propertyDefinitions),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.filter;
										},
										model.filterDefinition))),
							selectedFilter: $elm$core$Maybe$Nothing,
							filterDefinition: model.filterDefinition,
							propertyDefinitions: $author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict(propertyDefinitions),
							searchOptionsToggled: false,
							uiSavedFiltersSelect: model.uiSavedFiltersSelect
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								function () {
								var getFilterById = function (filterId) {
									return A2(
										$elm$core$Platform$Cmd$map,
										config.tagger,
										A3(
											config.api.getFilterById,
											$author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict(propertyDefinitions),
											filterId,
											A2(
												$elm$core$Basics$composeR,
												$author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilter(filterId),
												$author$project$PinMeTo$Ui$FilterController$LoadedMsg)));
								};
								var defaultFilter = A2(
									$elm$core$Maybe$withDefault,
									A3(
										$author$project$PinMeTo$Ui$Filter$DataTypes$FilterDefinition,
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Nothing,
										$author$project$PinMeTo$Ui$Filter$DataTypes$defaultFiltersFromPropertyDefinitions(
											$author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict(propertyDefinitions))),
									model.filterDefinition);
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$PinMeTo$Ui$FilterController$applyEvents(
										_List_fromArray(
											[
												config.events.onFilter(defaultFilter)
											])),
									function (fd_) {
										return A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$PinMeTo$Ui$FilterController$applyEvents(
												_List_fromArray(
													[
														config.events.onFilter(fd_)
													])),
											getFilterById,
											fd_.id);
									},
									model.filterDefinition);
							}(),
								A2(
								$elm$core$Platform$Cmd$map,
								config.tagger,
								config.api.getFilters(
									A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$FilterController$ReceivedSavedFilters, $author$project$PinMeTo$Ui$FilterController$LoadedMsg)))
							])));
			} else {
				var httpError = msg.a.a;
				return _Utils_Tuple2(
					A2(
						$author$project$PinMeTo$Ui$FilterController$State,
						_Utils_update(
							loading,
							{
								propertyDefinitions: $author$project$PinMeTo$Ui$FilterController$Error('Could not load filters. Try again later.')
							}),
						model),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$PinMeTo$Logger$log(
								{
									data: $author$project$PinMeTo$Common$Util$httpErrorToString(httpError),
									context: config.loggerContext + ':ReceivedPropertyDefinitions',
									message: 'Failed to get propertyDefinitions'
								}),
								A2(
								$elm$core$Task$perform,
								config.onError,
								$elm$core$Task$succeed(
									$author$project$PinMeTo$Ui$FilterController$PropertyDefinitionsFailed(httpError)))
							])));
			}
		} else {
			var msg_ = msg.a;
			var _v2 = loading.propertyDefinitions;
			if (_v2.$ === 'Loaded') {
				var propertyDefinitions = _v2.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return A2($author$project$PinMeTo$Ui$FilterController$State, loading, x);
					},
					A4(
						$author$project$PinMeTo$Ui$FilterController$updateModel,
						$author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict(propertyDefinitions),
						{api: config.api, events: config.events, tagger: config.tagger, loggerContext: config.loggerContext},
						msg_,
						model));
			} else {
				return _Utils_Tuple2(
					A2($author$project$PinMeTo$Ui$FilterController$State, loading, model),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$PinMeTo$Ui$Selector$update = $author$project$PinMeTo$Ui$Selector$updateWithOptions(
	{onChange: $elm$core$Maybe$Nothing});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'ShowSelector':
				if (msg.b) {
					var selected = msg.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (uiSelector) {
							return $author$project$PinMeTo$Ui$SelectorBrandPage$State(
								_Utils_update(
									model,
									{
										selector: $elm$core$Maybe$Just(uiSelector)
									}));
						},
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorBrandPage$UiSelectorMsg, config.tagger)),
						A2(
							$author$project$PinMeTo$Ui$Selector$initWithSelected,
							$elm$core$Set$toList(selected),
							config.getAllItems));
				} else {
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$SelectorBrandPage$State(
							_Utils_update(
								model,
								{selector: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				}
			case 'UiSelectorMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						$author$project$PinMeTo$Ui$SelectorBrandPage$State(model),
						$elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (uiSelector) {
							return A2(
								$elm$core$Tuple$mapFirst,
								function (x) {
									return $author$project$PinMeTo$Ui$SelectorBrandPage$State(
										_Utils_update(
											model,
											{
												selector: $elm$core$Maybe$Just(x)
											}));
								},
								A2($author$project$PinMeTo$Ui$Selector$update, msg_, uiSelector));
						},
						model.selector));
			default:
				var selected = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorBrandPage$State(
						_Utils_update(
							model,
							{selector: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$perform,
						function (_v2) {
							return config.onChange(
								$elm$core$Set$toList(selected));
						},
						$elm$core$Task$succeed(_Utils_Tuple0)));
		}
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocation$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$SelectorLocation$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'ShowSelector':
				if (msg.b) {
					var selected = msg.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (uiSelector) {
							return $author$project$PinMeTo$Ui$SelectorLocation$State(
								_Utils_update(
									model,
									{
										selector: $elm$core$Maybe$Just(uiSelector)
									}));
						},
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorLocation$UiSelectorMsg, config.tagger)),
						A2(
							$author$project$PinMeTo$Ui$Selector$initWithSelected,
							$elm$core$Set$toList(selected),
							config.getAllItems));
				} else {
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$SelectorLocation$State(
							_Utils_update(
								model,
								{selector: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				}
			case 'UiSelectorMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						$author$project$PinMeTo$Ui$SelectorLocation$State(model),
						$elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (uiSelector) {
							return A2(
								$elm$core$Tuple$mapFirst,
								function (x) {
									return $author$project$PinMeTo$Ui$SelectorLocation$State(
										_Utils_update(
											model,
											{
												selector: $elm$core$Maybe$Just(x)
											}));
								},
								A2($author$project$PinMeTo$Ui$Selector$update, msg_, uiSelector));
						},
						model.selector));
			default:
				var selected = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorLocation$State(
						_Utils_update(
							model,
							{selector: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$perform,
						function (_v2) {
							return config.onChange(
								$elm$core$Set$toList(selected));
						},
						$elm$core$Task$succeed(_Utils_Tuple0)));
		}
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$updateFilter = F4(
	function (_v0, propertyDefinition, value, filter) {
		var propertyName = _v0.a;
		var value_ = function () {
			_v2$2:
			while (true) {
				if (value.$ === 'SingleValue') {
					if (value.a === '') {
						return $elm$core$Maybe$Nothing;
					} else {
						break _v2$2;
					}
				} else {
					if (!value.a.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						break _v2$2;
					}
				}
			}
			var nonEmptyValue = value;
			return $elm$core$Maybe$Just(
				A3(
					$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
					$author$project$PinMeTo$Ui$Filter$DataTypes$Property(propertyName),
					nonEmptyValue,
					$elm$core$Maybe$Just(propertyDefinition)));
		}();
		var update = A2(
			$elm$core$Dict$update,
			propertyName,
			$elm$core$Basics$always(value_));
		switch (filter.$) {
			case 'Saved':
				var x = filter.a;
				return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$Saved(
					_Utils_update(
						x,
						{
							filter: update(x.filter)
						}));
			case 'UnSaved':
				var x = filter.a;
				return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$UnSaved(
					_Utils_update(
						x,
						{
							filter: update(x.filter)
						}));
			default:
				var x = filter.a;
				return $author$project$PinMeTo$Ui$Filter$FilterFormFilter$SearchOption(
					update(x));
		}
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'OnUpdate':
				var currentFilter = msg.a;
				var property = msg.b;
				var propertyDefinition = msg.c;
				var value = msg.d;
				var filter = $author$project$PinMeTo$Ui$Filter$FilterFormFilter$toFilterDefinition(
					A4($author$project$PinMeTo$Ui$Filter$FilterFormFilter$updateFilter, property, propertyDefinition, value, currentFilter));
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Filter$FilterFormBase$State(model),
					A2(
						$elm$core$Task$perform,
						function (_v2) {
							return config.onFilter(filter);
						},
						$elm$core$Task$succeed(_Utils_Tuple0)));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(config.tagger),
					A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return $author$project$PinMeTo$Ui$Filter$FilterFormBase$State(
								_Utils_update(
									model,
									{uiSelect: x}));
						},
						A3($author$project$PinMeTo$Ui$Select$update, $author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectMsg, msg_, model.uiSelect)));
			case 'UiSelectorLocationMsg':
				var currentFilter = msg.a;
				var property = msg.b;
				var propertyDefinition = msg.c;
				var msg_ = msg.d;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (selector) {
						return $author$project$PinMeTo$Ui$Filter$FilterFormBase$State(
							_Utils_update(
								model,
								{locationSelector: selector}));
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorLocation$update,
						{
							tagger: A2(
								$elm$core$Basics$composeR,
								A3($author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectorLocationMsg, currentFilter, property, propertyDefinition),
								config.tagger),
							onChange: A2(
								$elm$core$Basics$composeR,
								$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue,
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate, currentFilter, property, propertyDefinition),
									config.tagger)),
							getAllItems: config.api.selectorGetLocations
						},
						msg_,
						model.locationSelector));
			default:
				var currentFilter = msg.a;
				var property = msg.b;
				var propertyDefinition = msg.c;
				var msg_ = msg.d;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (selector) {
						return $author$project$PinMeTo$Ui$Filter$FilterFormBase$State(
							_Utils_update(
								model,
								{brandPageSelector: selector}));
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorBrandPage$update,
						{
							tagger: A2(
								$elm$core$Basics$composeR,
								A3($author$project$PinMeTo$Ui$Filter$FilterFormBase$UiSelectorBrandPageMsg, currentFilter, property, propertyDefinition),
								config.tagger),
							onChange: A2(
								$elm$core$Basics$composeR,
								$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue,
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$PinMeTo$Ui$Filter$FilterFormBase$OnUpdate, currentFilter, property, propertyDefinition),
									config.tagger)),
							getAllItems: config.api.selectorGetBrandPages
						},
						msg_,
						model.brandPageSelector));
		}
	});
var $author$project$PinMeTo$Ui$FilterController$updateEditor = F2(
	function (filter, editor) {
		if (editor.$ === 'ExistingFilter') {
			var error = editor.a;
			var existing = editor.b;
			var original = editor.c;
			var formData = editor.d;
			return A4(
				$author$project$PinMeTo$Ui$FilterController$ExistingFilter,
				error,
				existing,
				original,
				_Utils_update(
					formData,
					{filter: filter}));
		} else {
			var error = editor.a;
			var formData = editor.b;
			return A2(
				$author$project$PinMeTo$Ui$FilterController$NewFilter,
				error,
				_Utils_update(
					formData,
					{filter: filter}));
		}
	});
var $author$project$PinMeTo$Ui$FilterController$modelWithFilter = F3(
	function (filterDefinition, propertyDefinitions, model) {
		var _v0 = _Utils_Tuple3(filterDefinition.id, filterDefinition.name, filterDefinition.filter);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Just') {
				if (_v0.b.$ === 'Just') {
					var filter = _v0.c;
					return _Utils_update(
						model,
						{
							filterEditor: A2(
								$author$project$PinMeTo$Ui$FilterController$remoteDataMap,
								$author$project$PinMeTo$Ui$FilterController$updateEditor(filter),
								model.filterEditor)
						});
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Just') {
					var _v1 = _v0.a;
					var filter = _v0.c;
					return _Utils_update(
						model,
						{
							filterEditor: A2(
								$author$project$PinMeTo$Ui$FilterController$remoteDataMap,
								$author$project$PinMeTo$Ui$FilterController$updateEditor(filter),
								model.filterEditor)
						});
				} else {
					break _v0$2;
				}
			}
		}
		var filter = _v0.c;
		return _Utils_update(
			model,
			{
				searchOptions: $elm$core$Maybe$Just(
					A2(
						$author$project$PinMeTo$Ui$Filter$FilterFormFilter$searchOption,
						propertyDefinitions,
						$elm$core$Maybe$Just(filter))),
				selectedFilter: $elm$core$Maybe$Nothing
			});
	});
var $author$project$PinMeTo$Ui$FilterController$setFilter = F2(
	function (filterDefinition, _v0) {
		var loading = _v0.a;
		var model = _v0.b;
		var _v1 = loading.propertyDefinitions;
		if (_v1.$ === 'Loaded') {
			var propertyDefinitions = _v1.a;
			return A2(
				$author$project$PinMeTo$Ui$FilterController$State,
				loading,
				A3(
					$author$project$PinMeTo$Ui$FilterController$modelWithFilter,
					filterDefinition,
					$author$project$PinMeTo$Ui$Filter$DataTypes$listPropertyDefinitionsToDict(propertyDefinitions),
					model));
		} else {
			return A2($author$project$PinMeTo$Ui$FilterController$State, loading, model);
		}
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$ReceivedItems = function (a) {
	return {$: 'ReceivedItems', a: a};
};
var $author$project$PinMeTo$Ui$Table$clearDeselected = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Ui$Table$State(
		_Utils_update(
			model,
			{deselected: $elm$core$Set$empty}));
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$ErrorFetchingItems = {$: 'ErrorFetchingItems'};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnError = function (a) {
	return {$: 'UiFilterControllerOnError', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnFilter = function (a) {
	return {$: 'UiFilterControllerOnFilter', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnSearch = function (a) {
	return {$: 'UiFilterControllerOnSearch', a: a};
};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$update = F3(
	function (api, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'UiFilterControllerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return $author$project$PinMeTo$Ui$SelectorWithFilterController$State(
							_Utils_update(
								model,
								{uiFilterController: x}));
					},
					A3(
						$author$project$PinMeTo$Ui$FilterController$update,
						{
							api: api.filterControllerApi,
							events: {onFilter: $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnFilter, onSearch: $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnSearch},
							tagger: $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerMsg,
							onError: $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnError,
							loggerContext: 'filter-controller-example'
						},
						msg_,
						model.uiFilterController));
			case 'UiFilterControllerOnError':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(model),
					$elm$core$Platform$Cmd$none);
			case 'UiFilterFormMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return $author$project$PinMeTo$Ui$SelectorWithFilterController$State(
							_Utils_update(
								model,
								{uiFilterForm: x}));
					},
					A3(
						$author$project$PinMeTo$Ui$Filter$FilterFormBase$update,
						{
							api: {selectorGetLocations: api.getLocations, selectorGetBrandPages: api.getBrandPages},
							tagger: $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterFormMsg,
							onFilter: $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerOnFilter
						},
						msg_,
						model.uiFilterForm));
			case 'UiFilterControllerOnFilter':
				var filter = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(
						_Utils_update(
							model,
							{
								items: $author$project$PinMeTo$Ui$SelectorWithFilterController$Loading,
								filterDefinition: $elm$core$Maybe$Just(filter),
								uiFilterController: A2($author$project$PinMeTo$Ui$FilterController$setFilter, filter, model.uiFilterController)
							})),
					A2(api.getItemsByFilter, filter, $author$project$PinMeTo$Ui$SelectorWithFilterController$ReceivedItems));
			case 'UiFilterControllerOnSearch':
				var query = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(
						_Utils_update(
							model,
							{searchQuery: query})),
					$elm$core$Platform$Cmd$none);
			case 'ReceivedItems':
				if (msg.a.$ === 'Ok') {
					var items = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$SelectorWithFilterController$State(
							_Utils_update(
								model,
								{
									items: $author$project$PinMeTo$Ui$SelectorWithFilterController$Loaded(items.data),
									firstLoadDone: true,
									unselectableItems: $author$project$PinMeTo$Ui$SelectorWithFilterController$Loaded(items.unselectables)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$SelectorWithFilterController$State(
							_Utils_update(
								model,
								{
									items: $author$project$PinMeTo$Ui$SelectorWithFilterController$Error($author$project$PinMeTo$Ui$SelectorWithFilterController$ErrorFetchingItems)
								})),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: error, context: 'PiMeTo.Ui.Selector', message: 'PiMeTo.Ui.Selector received bad data'}));
				}
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(
						_Utils_update(
							model,
							{
								uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				var tab = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$State(
						_Utils_update(
							model,
							{
								uiTable: $author$project$PinMeTo$Ui$Table$clearDeselected(model.uiTable),
								currentTab: tab
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Ui$Table$setSelected = F2(
	function (selected, _v0) {
		var model = _v0.a;
		return $author$project$PinMeTo$Ui$Table$State(
			_Utils_update(
				model,
				{
					selected: $elm$core$Set$fromList(selected)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorWithFilterController$setSelectedList = F2(
	function (selected, _v0) {
		var model = _v0.a;
		var uiTable = A2(
			$author$project$PinMeTo$Ui$Table$setSelected,
			selected,
			$author$project$PinMeTo$Ui$Table$clearDeselected(model.uiTable));
		return $author$project$PinMeTo$Ui$SelectorWithFilterController$State(
			_Utils_update(
				model,
				{
					uiTable: uiTable,
					selected: $elm$core$Set$fromList(selected)
				}));
	});
var $author$project$PinMeTo$Ui$SelectorLocation$init = $author$project$PinMeTo$Ui$SelectorLocation$State(
	{selector: $elm$core$Maybe$Nothing});
var $author$project$PinMeTo$Ui$Filter$FilterFormBase$init = $author$project$PinMeTo$Ui$Filter$FilterFormBase$State(
	{uiSelect: $author$project$PinMeTo$Ui$Select$init, locationSelector: $author$project$PinMeTo$Ui$SelectorLocation$init, brandPageSelector: $author$project$PinMeTo$Ui$SelectorBrandPage$init});
var $author$project$PinMeTo$Ui$Table$initWithSelected = function (selected) {
	return A4($author$project$PinMeTo$Ui$Table$initAll, selected, _List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$emptyFilterDefinition = {id: $elm$core$Maybe$Nothing, name: $elm$core$Maybe$Nothing, filter: $elm$core$Dict$empty};
var $author$project$PinMeTo$Ui$SelectorWithFilterController$initWithSelected = F2(
	function (api, selected) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (x) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$PinMeTo$Ui$SelectorWithFilterController$UiFilterControllerMsg, x),
							A2(api.getItemsByFilter, $author$project$PinMeTo$Ui$Filter$DataTypes$emptyFilterDefinition, $author$project$PinMeTo$Ui$SelectorWithFilterController$ReceivedItems)
						]));
			},
			A2(
				$elm$core$Tuple$mapFirst,
				function (uiFilterController) {
					return $author$project$PinMeTo$Ui$SelectorWithFilterController$State(
						{
							items: $author$project$PinMeTo$Ui$SelectorWithFilterController$Loading,
							uiTable: $author$project$PinMeTo$Ui$Table$initWithSelected(selected),
							selected: $elm$core$Set$fromList(selected),
							currentTab: $author$project$PinMeTo$Ui$SelectorWithFilterController$All,
							searchQuery: '',
							uiFilterForm: $author$project$PinMeTo$Ui$Filter$FilterFormBase$init,
							firstLoadDone: false,
							filterDefinition: $elm$core$Maybe$Nothing,
							unselectableItems: $author$project$PinMeTo$Ui$SelectorWithFilterController$Loading,
							uiFilterController: uiFilterController
						});
				},
				A3($author$project$PinMeTo$Ui$FilterController$init, api.getPropertyDefinitions, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		var updateSelectorWith = function (msg_) {
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(
					$author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(model),
					$elm$core$Platform$Cmd$none),
				A2(
					$elm$core$Maybe$map,
					function (uiSelector) {
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map(
								A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorLocationWithFilters$UiSelectorMsg, config.tagger)),
							A2(
								$elm$core$Tuple$mapFirst,
								function (x) {
									return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(
										_Utils_update(
											model,
											{
												selector: $elm$core$Maybe$Just(x)
											}));
								},
								A3($author$project$PinMeTo$Ui$SelectorWithFilterController$update, config.api, msg_, uiSelector)));
					},
					model.selector));
		};
		var performOnChange = function (selected) {
			return _Utils_Tuple2(
				$author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(
					_Utils_update(
						model,
						{selector: $elm$core$Maybe$Nothing})),
				A2(
					$elm$core$Task$perform,
					function (_v2) {
						return config.onChange(
							$elm$core$Set$toList(selected));
					},
					$elm$core$Task$succeed(_Utils_Tuple0)));
		};
		var updateSelector = F2(
			function (deSelecedList, selector) {
				var selected = $author$project$PinMeTo$Ui$SelectorWithFilterController$getSelectedList(selector);
				var newSelected = A2(
					$elm$core$List$filter,
					function (item) {
						return !A2($elm$core$Set$member, item, deSelecedList);
					},
					selected);
				return A2($author$project$PinMeTo$Ui$SelectorWithFilterController$setSelectedList, newSelected, selector);
			});
		var updateSelectedList = function (deSelecedList) {
			return _Utils_Tuple2(
				$author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(
					_Utils_update(
						model,
						{
							selector: A2(
								$elm$core$Maybe$map,
								updateSelector(deSelecedList),
								model.selector)
						})),
				$elm$core$Platform$Cmd$none);
		};
		var clearSelector = _Utils_Tuple2(
			$author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(
				_Utils_update(
					model,
					{selector: $elm$core$Maybe$Nothing})),
			$elm$core$Platform$Cmd$none);
		var setSelector = function (selected) {
			return A3(
				$elm$core$Tuple$mapBoth,
				function (uiSelector) {
					return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$State(
						_Utils_update(
							model,
							{
								selector: $elm$core$Maybe$Just(uiSelector)
							}));
				},
				$elm$core$Platform$Cmd$map(
					A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$SelectorLocationWithFilters$UiSelectorMsg, config.tagger)),
				A2(
					$author$project$PinMeTo$Ui$SelectorWithFilterController$initWithSelected,
					config.api,
					$elm$core$Set$toList(selected)));
		};
		switch (msg.$) {
			case 'ShowSelector':
				if (msg.b) {
					var selected = msg.a;
					return setSelector(selected);
				} else {
					return clearSelector;
				}
			case 'UiSelectorMsg':
				var msg_ = msg.a;
				return updateSelectorWith(msg_);
			case 'OnSelect':
				var selected = msg.a;
				return performOnChange(selected);
			default:
				var deSelecedList = msg.a;
				return updateSelectedList(deSelecedList);
		}
	});
var $author$project$PinMeTo$Ui$Filter$FilterFormFilter$isSearchOptions = function (filter) {
	switch (filter.$) {
		case 'Saved':
			return false;
		case 'UnSaved':
			return false;
		default:
			return true;
	}
};
var $author$project$PinMeTo$Ui$Filter$FilterForm$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'OnUpdate':
				var currentFilter = msg.a;
				var property = msg.b;
				var propertyDefinition = msg.c;
				var value = msg.d;
				var filter = A4($author$project$PinMeTo$Ui$Filter$FilterFormFilter$updateFilter, property, propertyDefinition, value, currentFilter);
				var onFilter = $author$project$PinMeTo$Ui$Filter$FilterFormFilter$isSearchOptions(filter) ? config.onSearchOptions(
					$author$project$PinMeTo$Ui$Filter$FilterFormFilter$toFilterDefinition(filter)) : config.onFilter(
					$author$project$PinMeTo$Ui$Filter$FilterFormFilter$toFilterDefinition(filter));
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Filter$FilterForm$State(model),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(onFilter),
						$elm$core$Task$succeed(_Utils_Tuple0)));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(config.tagger),
					A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return $author$project$PinMeTo$Ui$Filter$FilterForm$State(
								_Utils_update(
									model,
									{uiSelect: x}));
						},
						A3($author$project$PinMeTo$Ui$Select$update, $author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectMsg, msg_, model.uiSelect)));
			case 'UiSelectorBrandPageMsg':
				var currentFilter = msg.a;
				var property = msg.b;
				var propertyDefinition = msg.c;
				var msg_ = msg.d;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (selector) {
						return $author$project$PinMeTo$Ui$Filter$FilterForm$State(
							_Utils_update(
								model,
								{brandPageSelector: selector}));
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorBrandPage$update,
						{
							tagger: A2(
								$elm$core$Basics$composeR,
								A3($author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectorBrandPageMsg, currentFilter, property, propertyDefinition),
								config.tagger),
							onChange: A2(
								$elm$core$Basics$composeR,
								$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue,
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate, currentFilter, property, propertyDefinition),
									config.tagger)),
							getAllItems: config.api.selectorGetBrandPages
						},
						msg_,
						model.brandPageSelector));
			default:
				var currentFilter = msg.a;
				var property = msg.b;
				var propertyDefinition = msg.c;
				var msg_ = msg.d;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return $author$project$PinMeTo$Ui$Filter$FilterForm$State(
							_Utils_update(
								model,
								{locationSelectorWithFilters: x}));
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorLocationWithFilters$update,
						{
							api: config.api.selectorLocationsWithFilter,
							tagger: A2(
								$elm$core$Basics$composeR,
								A3($author$project$PinMeTo$Ui$Filter$FilterForm$UiSelectorLocationWithFiltersMsg, currentFilter, property, propertyDefinition),
								config.tagger),
							onChange: A2(
								$elm$core$Basics$composeR,
								$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue,
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$PinMeTo$Ui$Filter$FilterForm$OnUpdate, currentFilter, property, propertyDefinition),
									config.tagger))
						},
						msg_,
						model.locationSelectorWithFilters));
		}
	});
var $author$project$PinMeTo$Global$FilterController$OnFilter = F2(
	function (a, b) {
		return {$: 'OnFilter', a: a, b: b};
	});
var $author$project$PinMeTo$Global$FilterController$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$PinMeTo$Ui$SelectorBrandPage$BrandPage = F5(
	function (id, name, network, created, reason) {
		return {id: id, name: name, reason: reason, created: created, network: network};
	});
var $author$project$PinMeTo$Ui$SelectorBrandPage$reasonDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'reason',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$PinMeTo$Ui$SelectorBrandPage$brandpageDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$PinMeTo$Ui$SelectorBrandPage$BrandPage,
	A2($elm$json$Json$Decode$field, '_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'network', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'createdAt', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	$author$project$PinMeTo$Ui$SelectorBrandPage$reasonDecoder);
var $author$project$PinMeTo$Ui$SelectorBrandPage$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'unselectables',
	$elm$json$Json$Decode$list($author$project$PinMeTo$Ui$SelectorBrandPage$brandpageDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data',
		$elm$json$Json$Decode$list($author$project$PinMeTo$Ui$SelectorBrandPage$brandpageDecoder),
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$Selector$ApiData)));
var $author$project$PinMeTo$Api$SelectorApi$realmToString = function (x) {
	switch (x.$) {
		case 'Places':
			return 'places';
		case 'SocialMedia':
			return 'socialmedia';
		case 'Listen':
			return 'listenrespond';
		default:
			return 'accessManager';
	}
};
var $author$project$PinMeTo$Api$SelectorApi$networkToString = function (x) {
	switch (x.$) {
		case 'All':
			return '';
		case 'Google':
			return 'google';
		case 'Facebook':
			return 'facebook';
		case 'Instagram':
			return 'instagram';
		default:
			return 'linkedin';
	}
};
var $author$project$PinMeTo$Api$SelectorApi$getBrandPagesForTarget = F2(
	function (_v0, msg) {
		var network = _v0.network;
		var realm = _v0.realm;
		var siteName = _v0.siteName;
		var url = function () {
			if (realm.$ === 'SocialMedia') {
				return '/location-posts/api/' + (siteName + ('/selector/brandpages/' + $author$project$PinMeTo$Api$SelectorApi$networkToString(network)));
			} else {
				return '/api/' + (siteName + ('/' + ($author$project$PinMeTo$Api$SelectorApi$realmToString(realm) + ('/selector/brandPages/' + ($author$project$PinMeTo$Api$SelectorApi$networkToString(network) + '?v=2')))));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$PinMeTo$Ui$SelectorBrandPage$decoder),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$PinMeTo$Api$SelectorApi$getBrandPages = F2(
	function (_v0, msg) {
		var network = _v0.network;
		var realm = _v0.realm;
		var siteName = _v0.siteName;
		return A2(
			$author$project$PinMeTo$Api$SelectorApi$getBrandPagesForTarget,
			{realm: realm, target: $elm$core$Maybe$Nothing, network: network, siteName: siteName},
			msg);
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$PinMeTo$Ui$SelectorLocation$Location = F7(
	function (id, storeId, name, locationDescriptor, address, created, reason) {
		return {id: id, name: name, reason: reason, address: address, created: created, storeId: storeId, locationDescriptor: locationDescriptor};
	});
var $author$project$PinMeTo$Ui$SelectorLocation$reasonDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'reason',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$PinMeTo$Ui$SelectorLocation$Address = F4(
	function (country, city, zip, street) {
		return {zip: zip, city: city, street: street, country: country};
	});
var $author$project$PinMeTo$Ui$SelectorLocation$addressDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'street',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'zip',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'city',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'country',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$SelectorLocation$Address)))));
var $author$project$PinMeTo$Ui$SelectorLocation$locationDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$PinMeTo$Ui$SelectorLocation$Location,
	A2($elm$json$Json$Decode$field, '_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'storeId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'locationDescriptor', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'address', $author$project$PinMeTo$Ui$SelectorLocation$addressDecoder),
	A2($elm$json$Json$Decode$field, 'createdAt', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	$author$project$PinMeTo$Ui$SelectorLocation$reasonDecoder);
var $author$project$PinMeTo$Ui$SelectorLocation$apiDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'unselectables',
	$elm$json$Json$Decode$list($author$project$PinMeTo$Ui$SelectorLocation$locationDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data',
		$elm$json$Json$Decode$list($author$project$PinMeTo$Ui$SelectorLocation$locationDecoder),
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$Selector$ApiData)));
var $author$project$PinMeTo$Api$SelectorApi$getLocationsForTarget = F2(
	function (_v0, msg) {
		var target = _v0.target;
		var network = _v0.network;
		var realm = _v0.realm;
		var siteName = _v0.siteName;
		var url = function () {
			if (target.$ === 'Just') {
				var _v2 = target.a;
				return '/location-posts/api/' + (siteName + ('/' + ($author$project$PinMeTo$Api$SelectorApi$networkToString(network) + '/selector/locations/')));
			} else {
				return '/api/' + (siteName + ('/' + ($author$project$PinMeTo$Api$SelectorApi$realmToString(realm) + ('/selector/location-post/locations/' + ($author$project$PinMeTo$Api$SelectorApi$networkToString(network) + '?v=2')))));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$PinMeTo$Ui$SelectorLocation$apiDataDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$PinMeTo$Api$SelectorApi$getLocations = function (_v0) {
	var network = _v0.network;
	var realm = _v0.realm;
	var siteName = _v0.siteName;
	return $author$project$PinMeTo$Api$SelectorApi$getLocationsForTarget(
		{realm: realm, target: $elm$core$Maybe$Nothing, network: network, siteName: siteName});
};
var $author$project$PinMeTo$Api$SelectorApi$getLocationsWithFilterForTarget = F3(
	function (_v0, filter, msg) {
		var target = _v0.target;
		var network = _v0.network;
		var realm = _v0.realm;
		var siteName = _v0.siteName;
		var json = $author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilter(filter);
		var url = function () {
			if (target.$ === 'Just') {
				var _v2 = target.a;
				return '/location-posts/api/' + (siteName + ('/' + ($author$project$PinMeTo$Api$SelectorApi$networkToString(network) + '/selector/locations/')));
			} else {
				return '/api/' + (siteName + ('/' + ($author$project$PinMeTo$Api$SelectorApi$realmToString(realm) + ('/selector/location-post/locations/' + ($author$project$PinMeTo$Api$SelectorApi$networkToString(network) + '?v=2')))));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$PinMeTo$Ui$SelectorLocation$apiDataDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$PinMeTo$Api$SelectorApi$filteredLocationApi = function (config) {
	var network = config.network;
	var realm = config.realm;
	var siteName = config.siteName;
	return {
		getLocations: $author$project$PinMeTo$Api$SelectorApi$getLocations(config),
		getBrandPages: $author$project$PinMeTo$Api$SelectorApi$getBrandPages(config),
		getItemsByFilter: $author$project$PinMeTo$Api$SelectorApi$getLocationsWithFilterForTarget(
			{realm: realm, target: $elm$core$Maybe$Nothing, network: network, siteName: siteName}),
		filterControllerApi: A2($author$project$PinMeTo$Api$FilterApi$api, siteName, $author$project$PinMeTo$Api$FilterApi$Location),
		getPropertyDefinitions: A2($author$project$PinMeTo$Api$FilterApi$getPropertyDefinitions, siteName, $author$project$PinMeTo$Api$FilterApi$Location)
	};
};
var $author$project$PinMeTo$Global$FilterController$OnFilterWithDebounce = function (a) {
	return {$: 'OnFilterWithDebounce', a: a};
};
var $author$project$PinMeTo$Global$FilterController$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'UiFilterControllerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return $author$project$PinMeTo$Global$FilterController$State(
							_Utils_update(
								model,
								{uiFilterController: x}));
					},
					A3(
						$author$project$PinMeTo$Ui$FilterController$update,
						{
							api: A2($author$project$PinMeTo$Api$FilterApi$api, model.siteName, model.filterType),
							events: {
								onFilter: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$OnFilterWithDebounce, config.tagger),
								onSearch: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$OnSearch, config.tagger)
							},
							tagger: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$UiFilterControllerMsg, config.tagger),
							onError: config.onError,
							loggerContext: 'pinmeto-filter-controller'
						},
						msg_,
						model.uiFilterController));
			case 'UiFilterFormMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return $author$project$PinMeTo$Global$FilterController$State(
							_Utils_update(
								model,
								{uiFilterForm: x}));
					},
					A3(
						$author$project$PinMeTo$Ui$Filter$FilterForm$update,
						{
							api: {
								selectorGetBrandPages: $author$project$PinMeTo$Api$SelectorApi$getBrandPages(
									{realm: config.realm, network: config.brandPageSelectorNetwork, siteName: model.siteName}),
								selectorLocationsWithFilter: $author$project$PinMeTo$Api$SelectorApi$filteredLocationApi(
									{realm: config.realm, network: config.locationSelectorNetwork, siteName: model.siteName})
							},
							tagger: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$UiFilterFormMsg, config.tagger),
							onFilter: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$OnFilterWithDebounce, config.tagger),
							onSearchOptions: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$FilterController$OnFilterWithDebounce, config.tagger)
						},
						msg_,
						model.uiFilterForm));
			case 'OnFilter':
				var debounce = msg.a;
				var filter = msg.b;
				return _Utils_eq(debounce, model.debounce) ? _Utils_Tuple2(
					$author$project$PinMeTo$Global$FilterController$State(
						_Utils_update(
							model,
							{
								debounce: 0,
								filterDefinition: $elm$core$Maybe$Just(filter),
								uiFilterController: A2($author$project$PinMeTo$Ui$FilterController$setFilter, filter, model.uiFilterController)
							})),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							config.onFilter(filter)),
						$elm$core$Task$succeed(_Utils_Tuple0))) : _Utils_Tuple2(
					$author$project$PinMeTo$Global$FilterController$State(model),
					$elm$core$Platform$Cmd$none);
			case 'OnFilterWithDebounce':
				var filter = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$FilterController$State(
						_Utils_update(
							model,
							{
								debounce: model.debounce + 1,
								filterDefinition: $elm$core$Maybe$Just(filter),
								uiFilterController: A2($author$project$PinMeTo$Ui$FilterController$setFilter, filter, model.uiFilterController)
							})),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							config.tagger(
								A2($author$project$PinMeTo$Global$FilterController$OnFilter, model.debounce + 1, filter))),
						$elm$core$Process$sleep(500)));
			default:
				var x = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$FilterController$State(
						_Utils_update(
							model,
							{searchQuery: x})),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							config.onSearch(x)),
						$elm$core$Task$succeed(_Utils_Tuple0)));
		}
	});
var $author$project$Filter$FilterController$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Filter$FilterController$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Filter$FilterController$main_redirectToLoginPage = _Platform_outgoingPort(
	'main_redirectToLoginPage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Filter$FilterController$UiFilterControllerOnError = function (a) {
	return {$: 'UiFilterControllerOnError', a: a};
};
var $author$project$Filter$FilterController$updatedFilterWithExtraRequirements = function (filter_) {
	if (filter_.b.$ === 'MultiValue') {
		var prop = filter_.a.a;
		var values = filter_.b.a;
		var rest = filter_.c;
		return ((prop === 'address.country') && (A2($elm$core$List$member, 'Netherlands', values) && (!A2($elm$core$List$member, 'The Netherlands', values)))) ? A3(
			$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
			$author$project$PinMeTo$Ui$Filter$DataTypes$Property(prop),
			$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(
				A2($elm$core$List$cons, 'The Netherlands', values)),
			rest) : (((prop === 'address.country') && (A2($elm$core$List$member, 'The Netherlands', values) && (!A2($elm$core$List$member, 'Netherlands', values)))) ? A3(
			$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
			$author$project$PinMeTo$Ui$Filter$DataTypes$Property(prop),
			$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(
				A2($elm$core$List$cons, 'Netherlands', values)),
			rest) : A3(
			$author$project$PinMeTo$Ui$Filter$DataTypes$PropertyFilter,
			$author$project$PinMeTo$Ui$Filter$DataTypes$Property(prop),
			$author$project$PinMeTo$Ui$Filter$DataTypes$MultiValue(values),
			rest));
	} else {
		return filter_;
	}
};
var $author$project$Filter$FilterController$update = F5(
	function (tagger, msg, model, onFilter, onSearch) {
		switch (msg.$) {
			case 'UiFilteredListMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(tagger),
					A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{uiFilteredList: x});
						},
						A3(
							$author$project$PinMeTo$Global$FilterController$update,
							{realm: $author$project$PinMeTo$Api$SelectorApi$Places, tagger: $author$project$Filter$FilterController$UiFilteredListMsg, onError: $author$project$Filter$FilterController$UiFilterControllerOnError, onFilter: $author$project$Filter$FilterController$OnFilter, onSearch: $author$project$Filter$FilterController$OnSearch, loggerContext: 'Update', locationSelectorNetwork: $author$project$PinMeTo$Api$SelectorApi$All, brandPageSelectorNetwork: $author$project$PinMeTo$Api$SelectorApi$All},
							msg_,
							model.uiFilteredList)));
			case 'OnFilter':
				var filter = msg.a;
				var updatedFilter = _Utils_update(
					filter,
					{
						filter: A2(
							$elm$core$Dict$map,
							function (_v2) {
								return $author$project$Filter$FilterController$updatedFilterWithExtraRequirements;
							},
							filter.filter)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							currentFilter: $elm$core$Maybe$Just(updatedFilter)
						}),
					A2(
						$elm$core$Task$perform,
						function (_v1) {
							return onFilter(
								$author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilterDefinition(updatedFilter));
						},
						$elm$core$Task$succeed(_Utils_Tuple0)));
			case 'OnSearch':
				var searchQuery = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						function (_v3) {
							return onSearch(searchQuery);
						},
						$elm$core$Task$succeed(_Utils_Tuple0)));
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					model,
					function () {
						var err = error.a;
						if (err.$ === 'BadStatus') {
							var code = err.a;
							return (code === 401) ? $author$project$Filter$FilterController$main_redirectToLoginPage(_Utils_Tuple0) : $elm$core$Platform$Cmd$none;
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
		}
	});
var $author$project$Common$Filter$FilterControllerPort$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Common$Filter$FilterControllerPort$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Common$Filter$FilterControllerPort$out_Common_Filter_FilterControllerPort_onFilter = _Platform_outgoingPort('out_Common_Filter_FilterControllerPort_onFilter', $elm$core$Basics$identity);
var $author$project$Common$Filter$FilterControllerPort$updateModel = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'HandleFlags':
				var flagsValue = msg.a;
				return $author$project$Common$Filter$FilterControllerPort$init(flagsValue);
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (filterController) {
						return $elm$core$Result$Ok(
							_Utils_update(
								model,
								{filterController: filterController}));
					},
					A5($author$project$Filter$FilterController$update, $author$project$Common$Filter$FilterControllerPort$FilterControllerMsg, msg_, model.filterController, $author$project$Common$Filter$FilterControllerPort$OnFilter, $author$project$Common$Filter$FilterControllerPort$OnSearch));
			case 'OnFilter':
				var filterDefinition = msg.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(model),
					$author$project$Common$Filter$FilterControllerPort$out_Common_Filter_FilterControllerPort_onFilter(filterDefinition));
			case 'OnSearch':
				return _Utils_Tuple2(
					$elm$core$Result$Ok(model),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					var t = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{translations: t})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(model),
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'Common.Filter.FilterControllerPort',
								message: 'Failed to decode translations'
							}));
				}
		}
	});
var $author$project$Common$Filter$FilterControllerPort$update = F2(
	function (msg, state) {
		if (msg.$ === 'HandleFlags') {
			var flagsValue = msg.a;
			return $author$project$Common$Filter$FilterControllerPort$init(flagsValue);
		} else {
			if (state.$ === 'Ok') {
				var model = state.a;
				return A2($author$project$Common$Filter$FilterControllerPort$updateModel, msg, model);
			} else {
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Common$Filter$FilterControllerPort$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Common$Filter$FilterControllerPort$OnLanguageChanged = function (a) {
	return {$: 'OnLanguageChanged', a: a};
};
var $author$project$Common$Filter$FilterControllerPort$passArgs_Common_Filter_FilterControllerPort = _Platform_incomingPort('passArgs_Common_Filter_FilterControllerPort', $elm$json$Json$Decode$value);
var $author$project$Common$Filter$FilterControllerPort$in_Common_Filter_FilterControllerPort_languageChanged = _Platform_incomingPort('in_Common_Filter_FilterControllerPort_languageChanged', $elm$json$Json$Decode$value);
var $author$project$Common$Filter$FilterControllerPort$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$Filter$FilterControllerPort$passArgs_Common_Filter_FilterControllerPort($author$project$Common$Filter$FilterControllerPort$HandleFlags),
				$author$project$Common$Filter$FilterControllerPort$in_Common_Filter_FilterControllerPort_languageChanged(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Common$Language$translationsDecoder),
					$author$project$Common$Filter$FilterControllerPort$OnLanguageChanged))
			]));
};
var $author$project$Common$Filter$FilterControllerPort$main = $elm$browser$Browser$element(
	{init: $author$project$Common$Filter$FilterControllerPort$init, view: $author$project$Common$Filter$FilterControllerPort$view, update: $author$project$Common$Filter$FilterControllerPort$update, subscriptions: $author$project$Common$Filter$FilterControllerPort$subscriptions});
var $author$project$ApiDocumentation$ApiDocumentation$init = F2(
	function (_v0, flags) {
		return _Utils_Tuple2(
			{apiAppUrl: flags.apiAppUrl, apiDocUrlV3: flags.apiDocUrlV3, apiDocUrlV4: flags.apiDocUrlV4, apiIsEnabled: flags.apiEnabled, apiDocUrlMediaV1: flags.apiDocUrlMediaV1, apiDocUrlLocationsV4: flags.apiDocUrlLocationsV4},
			$elm$core$Platform$Cmd$none);
	});
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$PinMeToPage$ElementMsg = function (a) {
	return {$: 'ElementMsg', a: a};
};
var $author$project$PinMeToPage$Session = F9(
	function (siteName, user, locale, language, features, url, translations, analytics, products) {
		return {url: url, user: user, locale: locale, features: features, language: language, products: products, siteName: siteName, analytics: analytics, translations: translations};
	});
var $author$project$Data$Account$emptyFeatures = {allowPtvTwoWay: false, appleCustomName: false, allowMediaReview: false, googleCustomName: false, facebookCustomName: false, allowCustomStoreName: false};
var $author$project$PinMeToPage$Products = F2(
	function (listenAndRespond, socialMedia) {
		return {socialMedia: socialMedia, listenAndRespond: listenAndRespond};
	});
var $author$project$PinMeToPage$ProductDisabled = {$: 'ProductDisabled'};
var $author$project$PinMeToPage$SocialMedia = function (availability) {
	return {availability: availability};
};
var $author$project$PinMeToPage$ProductEnabled = {$: 'ProductEnabled'};
var $author$project$PinMeToPage$productAvailabilityDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (b) {
		return b ? $elm$json$Json$Decode$succeed($author$project$PinMeToPage$ProductEnabled) : $elm$json$Json$Decode$succeed($author$project$PinMeToPage$ProductDisabled);
	},
	$elm$json$Json$Decode$bool);
var $author$project$PinMeToPage$socialMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$author$project$PinMeToPage$productAvailabilityDecoder,
	$elm$json$Json$Decode$succeed($author$project$PinMeToPage$SocialMedia));
var $author$project$PinMeToPage$ListenAndRespond = function (availability) {
	return {availability: availability};
};
var $author$project$PinMeToPage$listenAndRespondDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$author$project$PinMeToPage$productAvailabilityDecoder,
	$elm$json$Json$Decode$succeed($author$project$PinMeToPage$ListenAndRespond));
var $author$project$PinMeToPage$decodeProducts = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'socialMedia',
	$author$project$PinMeToPage$socialMediaDecoder,
	{availability: $author$project$PinMeToPage$ProductDisabled},
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'listenAndRespond',
		$author$project$PinMeToPage$listenAndRespondDecoder,
		{availability: $author$project$PinMeToPage$ProductDisabled},
		$elm$json$Json$Decode$succeed($author$project$PinMeToPage$Products)));
var $author$project$PinMeToPage$Analytics = function (facebook) {
	return function (google) {
		return function (apple) {
			return function (baidu) {
				return function (here) {
					return function (bing) {
						return function (tomtom) {
							return function (seznam) {
								return function (ecoMovement) {
									return function (foursquare) {
										return function (trustpilot) {
											return function (instagram) {
												return function (overture) {
													return function (ptv) {
														return function (appleConnectionType) {
															return {ptv: ptv, bing: bing, here: here, apple: apple, baidu: baidu, google: google, seznam: seznam, tomtom: tomtom, facebook: facebook, overture: overture, instagram: instagram, foursquare: foursquare, trustpilot: trustpilot, ecoMovement: ecoMovement, appleConnectionType: appleConnectionType};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PinMeToPage$NotVisible = {$: 'NotVisible'};
var $author$project$PinMeToPage$CanEnable = {$: 'CanEnable'};
var $author$project$PinMeToPage$NetworkEnabled = {$: 'NetworkEnabled'};
var $author$project$PinMeToPage$decodeNetworkIntegration = A2(
	$elm$json$Json$Decode$andThen,
	function (enabled) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (canEnable) {
				var _v0 = _Utils_Tuple2(enabled, canEnable);
				if ((_v0.a.$ === 'Just') && _v0.a.a) {
					return $elm$json$Json$Decode$succeed($author$project$PinMeToPage$NetworkEnabled);
				} else {
					if ((_v0.b.$ === 'Just') && _v0.b.a) {
						return $elm$json$Json$Decode$succeed($author$project$PinMeToPage$CanEnable);
					} else {
						return $elm$json$Json$Decode$succeed($author$project$PinMeToPage$NotVisible);
					}
				}
			},
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'customerCanEnable', $elm$json$Json$Decode$bool)));
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'enabled', $elm$json$Json$Decode$bool)));
var $author$project$PinMeToPage$AppleOauth = {$: 'AppleOauth'};
var $author$project$PinMeToPage$AppleSystem = {$: 'AppleSystem'};
var $author$project$PinMeToPage$decodeAppleConnectionType = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		return (x === 'oauth') ? $author$project$PinMeToPage$AppleOauth : $author$project$PinMeToPage$AppleSystem;
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeToPage$decodeAnalytics = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['apple', 'connectionType']),
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$PinMeToPage$decodeAppleConnectionType),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['ptv']),
		$author$project$PinMeToPage$decodeNetworkIntegration,
		$author$project$PinMeToPage$NotVisible,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['overture']),
			$author$project$PinMeToPage$decodeNetworkIntegration,
			$author$project$PinMeToPage$NotVisible,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['instagram']),
				$author$project$PinMeToPage$decodeNetworkIntegration,
				$author$project$PinMeToPage$NotVisible,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['trustpilot']),
					$author$project$PinMeToPage$decodeNetworkIntegration,
					$author$project$PinMeToPage$NotVisible,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['factual']),
						$author$project$PinMeToPage$decodeNetworkIntegration,
						$author$project$PinMeToPage$NotVisible,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['ecoMovement']),
							$author$project$PinMeToPage$decodeNetworkIntegration,
							$author$project$PinMeToPage$NotVisible,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['seznam']),
								$author$project$PinMeToPage$decodeNetworkIntegration,
								$author$project$PinMeToPage$NotVisible,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['tomtom']),
									$author$project$PinMeToPage$decodeNetworkIntegration,
									$author$project$PinMeToPage$NotVisible,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
										_List_fromArray(
											['bing']),
										$author$project$PinMeToPage$decodeNetworkIntegration,
										$author$project$PinMeToPage$NotVisible,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
											_List_fromArray(
												['here']),
											$author$project$PinMeToPage$decodeNetworkIntegration,
											$author$project$PinMeToPage$NotVisible,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
												_List_fromArray(
													['baidu']),
												$author$project$PinMeToPage$decodeNetworkIntegration,
												$author$project$PinMeToPage$NotVisible,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
													_List_fromArray(
														['apple']),
													$author$project$PinMeToPage$decodeNetworkIntegration,
													$author$project$PinMeToPage$NotVisible,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
														_List_fromArray(
															['google']),
														$author$project$PinMeToPage$decodeNetworkIntegration,
														$author$project$PinMeToPage$NotVisible,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
															_List_fromArray(
																['facebook']),
															$author$project$PinMeToPage$decodeNetworkIntegration,
															$author$project$PinMeToPage$NotVisible,
															$elm$json$Json$Decode$succeed($author$project$PinMeToPage$Analytics))))))))))))))));
var $author$project$PinMeToPage$defaultProducts = {
	socialMedia: {availability: $author$project$PinMeToPage$ProductDisabled},
	listenAndRespond: {availability: $author$project$PinMeToPage$ProductDisabled}
};
var $author$project$PinMeToPage$defaultAnalytics = {ptv: $author$project$PinMeToPage$NotVisible, bing: $author$project$PinMeToPage$NotVisible, here: $author$project$PinMeToPage$NotVisible, apple: $author$project$PinMeToPage$NotVisible, baidu: $author$project$PinMeToPage$NotVisible, google: $author$project$PinMeToPage$NotVisible, seznam: $author$project$PinMeToPage$NotVisible, tomtom: $author$project$PinMeToPage$NotVisible, facebook: $author$project$PinMeToPage$NotVisible, overture: $author$project$PinMeToPage$NotVisible, instagram: $author$project$PinMeToPage$NotVisible, foursquare: $author$project$PinMeToPage$NotVisible, trustpilot: $author$project$PinMeToPage$NotVisible, ecoMovement: $author$project$PinMeToPage$NotVisible, appleConnectionType: $elm$core$Maybe$Nothing};
var $author$project$Data$Account$Features = F6(
	function (facebookCustomName, googleCustomName, allowCustomStoreName, appleCustomName, allowMediaReview, allowPtvTwoWay) {
		return {allowPtvTwoWay: allowPtvTwoWay, appleCustomName: appleCustomName, allowMediaReview: allowMediaReview, googleCustomName: googleCustomName, facebookCustomName: facebookCustomName, allowCustomStoreName: allowCustomStoreName};
	});
var $author$project$PinMeToPage$decodeFeatureFlags = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['allowPtvTwoWay', 'enabled']),
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['allowMediaReview', 'enabled']),
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['allowAppleCustomName', 'enabled']),
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['allowCustomStoreNames', 'enabled']),
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['allowGoogleCustomName', 'enabled']),
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['allowFacebookCustomName', 'enabled']),
						$elm$json$Json$Decode$bool,
						false,
						$elm$json$Json$Decode$succeed($author$project$Data$Account$Features)))))));
var $author$project$PinMeToPage$decodeFlags = $elm$json$Json$Decode$decodeValue(
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'products',
		$author$project$PinMeToPage$decodeProducts,
		$author$project$PinMeToPage$defaultProducts,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'analytics',
			$author$project$PinMeToPage$decodeAnalytics,
			$author$project$PinMeToPage$defaultAnalytics,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'translations',
				$ChristophP$elm_i18next$I18Next$translationsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['user', 'selectedSite', 'places', 'feature']),
						$author$project$PinMeToPage$decodeFeatureFlags,
						$author$project$Data$Account$emptyFeatures,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['user', 'settings', 'language']),
							$author$project$PinMeTo$Ui$I18n$Language$decoder,
							$author$project$PinMeTo$Ui$I18n$Language$En,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['user', 'settings', 'locale']),
								$author$project$PinMeTo$Ui$I18n$Locale$decoder,
								$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'user',
									$author$project$Data$User$userDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['user', 'selectedSite', 'name']),
										$author$project$Util$idDecoder($author$project$Data$SiteName$SiteName),
										$elm$json$Json$Decode$succeed($author$project$PinMeToPage$Session)))))))))));
var $author$project$PinMeToPage$ErrorDecodingFlags = {$: 'ErrorDecodingFlags'};
var $author$project$PinMeToPage$init = F3(
	function (moduleName, config, flagsValue) {
		var _v0 = $author$project$PinMeToPage$decodeFlags(flagsValue);
		if (_v0.$ === 'Ok') {
			var flags = _v0.a;
			var _v1 = A2($elm$json$Json$Decode$decodeValue, config.flagsDecoder, flagsValue);
			if (_v1.$ === 'Ok') {
				var elementFlags = _v1.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$PinMeToPage$ElementMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (elementModel) {
							return $elm$core$Result$Ok(
								{data: flags, element: elementModel});
						},
						A2(config.init, flags, elementFlags)));
			} else {
				var error = _v1.a;
				return _Utils_Tuple2(
					$elm$core$Result$Err($author$project$PinMeToPage$ErrorDecodingFlags),
					$author$project$PinMeTo$Logger$log(
						{
							data: $elm$json$Json$Decode$errorToString(error),
							context: moduleName,
							message: 'Failed to decode flags for ' + moduleName
						}));
			}
		} else {
			var error = _v0.a;
			return _Utils_Tuple2(
				$elm$core$Result$Err($author$project$PinMeToPage$ErrorDecodingFlags),
				$author$project$PinMeTo$Logger$log(
					{
						data: $elm$json$Json$Decode$errorToString(error),
						context: moduleName,
						message: 'Failed to decode flags for Session'
					}));
		}
	});
var $author$project$PinMeTo$Ui$Alert$plain = function (message) {
	return $author$project$PinMeTo$Ui$Alert$Alert(
		_Utils_update(
			$author$project$PinMeTo$Ui$Alert$defaultConfig,
			{
				status: $author$project$PinMeTo$Ui$Alert$Note,
				content: $author$project$PinMeTo$Ui$Alert$Plain(message)
			}));
};
var $author$project$PinMeToPage$view = F2(
	function (elementView, result) {
		if (result.$ === 'Ok') {
			var model = result.a;
			return A2(
				$elm$html$Html$map,
				$author$project$PinMeToPage$ElementMsg,
				A2(elementView, model.data, model.element));
		} else {
			if (result.a.$ === 'ElementIsDormant') {
				var _v1 = result.a;
				return $elm$html$Html$text('');
			} else {
				return $author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Error,
						$author$project$PinMeTo$Ui$Alert$plain('We seem to have released a broken page. Please contact support if problem remains.')));
			}
		}
	});
var $author$project$PinMeToPage$OnInit = function (a) {
	return {$: 'OnInit', a: a};
};
var $author$project$PinMeToPage$onInit = _Platform_incomingPort(
	'onInit',
	A2(
		$elm$json$Json$Decode$andThen,
		function (flags) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return $elm$json$Json$Decode$succeed(
						{name: name, flags: flags});
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'flags', $elm$json$Json$Decode$value)));
var $author$project$PinMeToPage$ElementIsDormant = {$: 'ElementIsDormant'};
var $author$project$PinMeToPage$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'OnInit':
				var flags = msg.a.flags;
				var name = msg.a.name;
				return A3(
					$author$project$PinMeToPage$init,
					name,
					{init: config.init, flagsDecoder: config.flagsDecoder},
					flags);
			case 'OnDestroy':
				return _Utils_Tuple2(
					$elm$core$Result$Err($author$project$PinMeToPage$ElementIsDormant),
					$elm$core$Platform$Cmd$none);
			case 'OnUrlChange':
				var urlString = msg.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Result$map,
						function (model_) {
							var session = model_.data;
							return _Utils_update(
								model_,
								{
									data: _Utils_update(
										session,
										{url: urlString})
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			default:
				var elementMsg = msg.a;
				if (model.$ === 'Ok') {
					var modelWithElement = model.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$PinMeToPage$ElementMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (x) {
								return $elm$core$Result$Ok(
									_Utils_update(
										modelWithElement,
										{element: x}));
							},
							A3(config.update, modelWithElement.data, elementMsg, modelWithElement.element)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$PinMeToPage$OnDestroy = function (a) {
	return {$: 'OnDestroy', a: a};
};
var $author$project$PinMeToPage$onDestroy = _Platform_incomingPort(
	'onDestroy',
	A2(
		$elm$json$Json$Decode$andThen,
		function (name) {
			return $elm$json$Json$Decode$succeed(
				{name: name});
		},
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)));
var $author$project$Common$PollPortModule$urlChange = _Platform_incomingPort('urlChange', $elm$json$Json$Decode$value);
var $author$project$PinMeToPage$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$PinMeToPage$decodeModuleName = $elm$json$Json$Decode$decodeValue(
	A2($elm$json$Json$Decode$field, 'moduleName', $elm$json$Json$Decode$string));
var $author$project$PinMeToPage$ErrorMissingModuleName = {$: 'ErrorMissingModuleName'};
var $author$project$PinMeToPage$page = function (config) {
	return $elm$browser$Browser$element(
		{
			init: function (flags) {
				var _v0 = $author$project$PinMeToPage$decodeModuleName(flags);
				if (_v0.$ === 'Ok') {
					var moduleName = _v0.a;
					return A3(
						$author$project$PinMeToPage$init,
						moduleName,
						{init: config.init, flagsDecoder: config.flagsDecoder},
						flags);
				} else {
					var error = _v0.a;
					return _Utils_Tuple2(
						$elm$core$Result$Err($author$project$PinMeToPage$ErrorMissingModuleName),
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'PinMeTo Page Program',
								message: 'Flags missing moduleName'
							}));
				}
			},
			view: $author$project$PinMeToPage$view(config.view),
			update: $author$project$PinMeToPage$update(
				{init: config.init, update: config.update, flagsDecoder: config.flagsDecoder}),
			subscriptions: function (result) {
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$PinMeToPage$onDestroy($author$project$PinMeToPage$OnDestroy),
							$author$project$PinMeToPage$onInit($author$project$PinMeToPage$OnInit),
							$author$project$Common$PollPortModule$urlChange(
							function (value) {
								var _v1 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
								if (_v1.$ === 'Ok') {
									var url = _v1.a;
									return $author$project$PinMeToPage$OnUrlChange(url);
								} else {
									return $author$project$PinMeToPage$OnUrlChange('');
								}
							}),
							function () {
							if (result.$ === 'Ok') {
								var data = result.a;
								return A2(
									$elm$core$Platform$Sub$map,
									$author$project$PinMeToPage$ElementMsg,
									config.subscriptions(data.element));
							} else {
								return $elm$core$Platform$Sub$none;
							}
						}()
						]));
			}
		});
};
var $author$project$Translations$Listings$ApiDocumentation$pageTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.page_title');
};
var $author$project$Translations$Listings$ApiDocumentation$helpTextMiddle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.help_text_middle');
};
var $author$project$Translations$Listings$ApiDocumentation$helpTextPrefix = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.help_text_prefix');
};
var $author$project$Translations$Listings$ApiDocumentation$helpTextApiDocs = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.help_text_api_docs');
};
var $author$project$Translations$Listings$ApiDocumentation$headerDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.header_description');
};
var $author$project$Translations$Listings$ApiDocumentation$helpTextHelpCenter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.help_text_help_center');
};
var $author$project$ApiDocumentation$ApiDocumentation$renderPageHeader = function (session) {
	var description = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-api-documentation__header-description-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-api-documentation__header-description__paragraph')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$ApiDocumentation$headerDescription(session.translations))
					])),
				A2(
				$elm$html$Html$strong,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-api-documentation__header-description__subparagraph')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$ApiDocumentation$helpTextPrefix(session.translations)),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('https://github.com/PinMeTo/documentation'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$ApiDocumentation$helpTextApiDocs(session.translations))
							])),
						$elm$html$Html$text(
						$author$project$Translations$Listings$ApiDocumentation$helpTextMiddle(session.translations)),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/introducing-the-pinmeto-api-kl3pwj/'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$ApiDocumentation$helpTextHelpCenter(session.translations))
							]))
					]))
			]));
	var title = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-api-documentation__header-title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Translations$Listings$ApiDocumentation$pageTitle(session.translations))
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-api-documentation__header-section')
			]),
		_List_fromArray(
			[title, description]));
};
var $author$project$ApiDocumentation$ApiDocumentation$UseCase = {$: 'UseCase'};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$ApiDocumentation$ApiDocumentation$renderSection = F2(
	function (sectionType, info) {
		var sectionConfig = function () {
			if (sectionType.$ === 'UseCase') {
				return {
					titleClass: 'pmt-api-documentation__use-case-section__title',
					contentClass: 'pmt-api-documentation__use-case-section__content',
					containerClass: 'pmt-api-documentation__use-case-section',
					imageAttributes: _List_fromArray(
						[
							$elm$html$Html$Attributes$width(300),
							$elm$html$Html$Attributes$height(200)
						])
				};
			} else {
				return {
					titleClass: 'pmt-api-documentation__additional-feature-section__title',
					contentClass: 'pmt-api-documentation__additional-feature-section__content',
					containerClass: 'pmt-api-documentation__additional-feature-section',
					imageAttributes: _List_fromArray(
						[
							$elm$html$Html$Attributes$width(198)
						])
				};
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(sectionConfig.containerClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$src(info.image),
						sectionConfig.imageAttributes),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(sectionConfig.contentClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(sectionConfig.titleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(info.title)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(info.description)
										]))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(info.href),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(info.linkText)
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$ApiDocumentation$useCaseInsightsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_insights_title');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseLocalTeamsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_local_teams_title');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseInsightsLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_insights_link_text');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseLocalTeamsLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_local_teams_link_text');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseInsightsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_insights_description');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseManageLocationsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_manage_locations_title');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseLocalTeamsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_local_teams_description');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseManageLocationsLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_manage_locations_link_text');
};
var $author$project$Translations$Listings$ApiDocumentation$useCaseManageLocationsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.use_case_manage_locations_description');
};
var $author$project$ApiDocumentation$ApiDocumentation$renderUseCasesSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-api-documentation__use-cases-section')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$ApiDocumentation$ApiDocumentation$renderSection,
					$author$project$ApiDocumentation$ApiDocumentation$UseCase,
					{
						href: model.apiDocUrlLocationsV4,
						image: 'img/api-docs/API_Landing_Manage_Locations.png',
						title: $author$project$Translations$Listings$ApiDocumentation$useCaseManageLocationsTitle(session.translations),
						linkText: $author$project$Translations$Listings$ApiDocumentation$useCaseManageLocationsLinkText(session.translations),
						description: $author$project$Translations$Listings$ApiDocumentation$useCaseManageLocationsDescription(session.translations)
					}),
					A2(
					$author$project$ApiDocumentation$ApiDocumentation$renderSection,
					$author$project$ApiDocumentation$ApiDocumentation$UseCase,
					{
						href: 'https://github.com/PinMeTo/documentation?tab=readme-ov-file#performance-1',
						image: 'img/api-docs/API_Landing_Insights.png',
						title: $author$project$Translations$Listings$ApiDocumentation$useCaseInsightsTitle(session.translations),
						linkText: $author$project$Translations$Listings$ApiDocumentation$useCaseInsightsLinkText(session.translations),
						description: $author$project$Translations$Listings$ApiDocumentation$useCaseInsightsDescription(session.translations)
					}),
					A2(
					$author$project$ApiDocumentation$ApiDocumentation$renderSection,
					$author$project$ApiDocumentation$ApiDocumentation$UseCase,
					{
						href: model.apiDocUrlLocationsV4,
						image: 'img/api-docs/API_Landing_Local_Teams.png',
						title: $author$project$Translations$Listings$ApiDocumentation$useCaseLocalTeamsTitle(session.translations),
						linkText: $author$project$Translations$Listings$ApiDocumentation$useCaseLocalTeamsLinkText(session.translations),
						description: $author$project$Translations$Listings$ApiDocumentation$useCaseLocalTeamsDescription(session.translations)
					})
				]));
	});
var $author$project$ApiDocumentation$ApiDocumentation$AdditionalFeature = {$: 'AdditionalFeature'};
var $author$project$Translations$Listings$ApiDocumentation$additionalFeaturesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.additional_features_title');
};
var $author$project$Translations$Listings$ApiDocumentation$featureTrackKeywordsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.feature_track_keywords_title');
};
var $author$project$Translations$Listings$ApiDocumentation$featureMediaManagementTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.feature_media_management_title');
};
var $author$project$Translations$Listings$ApiDocumentation$featureTrackKeywordsLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.feature_track_keywords_link_text');
};
var $author$project$Translations$Listings$ApiDocumentation$featureMediaManagementLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.feature_media_management_link_text');
};
var $author$project$Translations$Listings$ApiDocumentation$featureTrackKeywordsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.feature_track_keywords_description');
};
var $author$project$Translations$Listings$ApiDocumentation$featureMediaManagementDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_documentation.feature_media_management_description');
};
var $author$project$ApiDocumentation$ApiDocumentation$renderAdditionalFeaturesSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-api-documentation__additional-features-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ApiDocumentation$additionalFeaturesTitle(session.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$ApiDocumentation$ApiDocumentation$renderSection,
							$author$project$ApiDocumentation$ApiDocumentation$AdditionalFeature,
							{
								href: model.apiDocUrlMediaV1,
								image: 'img/api-docs/API_Landing_Manage_Images.png',
								title: $author$project$Translations$Listings$ApiDocumentation$featureMediaManagementTitle(session.translations),
								linkText: $author$project$Translations$Listings$ApiDocumentation$featureMediaManagementLinkText(session.translations),
								description: $author$project$Translations$Listings$ApiDocumentation$featureMediaManagementDescription(session.translations)
							}),
							A2(
							$author$project$ApiDocumentation$ApiDocumentation$renderSection,
							$author$project$ApiDocumentation$ApiDocumentation$AdditionalFeature,
							{
								href: model.apiDocUrlV3,
								image: 'img/api-docs/API_Landing_Track_Keywords.png',
								title: $author$project$Translations$Listings$ApiDocumentation$featureTrackKeywordsTitle(session.translations),
								linkText: $author$project$Translations$Listings$ApiDocumentation$featureTrackKeywordsLinkText(session.translations),
								description: $author$project$Translations$Listings$ApiDocumentation$featureTrackKeywordsDescription(session.translations)
							})
						]))
				]));
	});
var $author$project$ApiDocumentation$ApiDocumentation$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-api-documentation')
				]),
			_List_fromArray(
				[
					$author$project$ApiDocumentation$ApiDocumentation$renderPageHeader(session),
					A2($author$project$ApiDocumentation$ApiDocumentation$renderUseCasesSection, session, model),
					A2($author$project$ApiDocumentation$ApiDocumentation$renderAdditionalFeaturesSection, session, model)
				]));
	});
var $author$project$ApiDocumentation$ApiDocumentation$update = F3(
	function (_v0, _v1, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$ApiDocumentation$ApiDocumentation$Flags = F6(
	function (apiEnabled, apiDocUrlV3, apiDocUrlV4, apiDocUrlMediaV1, apiDocUrlLocationsV4, apiAppUrl) {
		return {apiAppUrl: apiAppUrl, apiEnabled: apiEnabled, apiDocUrlV3: apiDocUrlV3, apiDocUrlV4: apiDocUrlV4, apiDocUrlMediaV1: apiDocUrlMediaV1, apiDocUrlLocationsV4: apiDocUrlLocationsV4};
	});
var $author$project$ApiDocumentation$ApiDocumentation$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'apiAppUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apiDocUrlLocationsV4',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'apiDocUrlMediaV1',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'apiDocUrlV4',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'apiDocUrlV3',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'apiEnabled',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$ApiDocumentation$ApiDocumentation$Flags)))))));
var $author$project$ApiDocumentation$ApiDocumentation$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$ApiDocumentation$ApiDocumentation$init,
		view: $author$project$ApiDocumentation$ApiDocumentation$view,
		update: $author$project$ApiDocumentation$ApiDocumentation$update,
		flagsDecoder: $author$project$ApiDocumentation$ApiDocumentation$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$ApiPendingChanges$Dashboard$Model$Flags = F2(
	function (siteName, translations) {
		return {siteName: siteName, translations: translations};
	});
var $author$project$ApiPendingChanges$Dashboard$Model$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siteName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$ApiPendingChanges$Dashboard$Model$Flags)));
var $author$project$ApiPendingChanges$Dashboard$Model$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$ApiPendingChanges$Dashboard$Model$flagsDecoder, flagsValue);
};
var $author$project$ApiPendingChanges$Dashboard$Model$FailedToDecodeFlags = {$: 'FailedToDecodeFlags'};
var $author$project$ApiPendingChanges$Dashboard$Commands$Response = function (count) {
	return {count: count};
};
var $author$project$ApiPendingChanges$Dashboard$Commands$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$ApiPendingChanges$Dashboard$Commands$Response));
var $author$project$ApiPendingChanges$Dashboard$Commands$getNumberOfLocationsWithPendingChanges = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$ApiPendingChanges$Dashboard$Commands$decode),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/apipendingchanges/count')))));
	});
var $author$project$ApiPendingChanges$Dashboard$Model$NumberOfLocationsWithPendingChangesResponse = function (a) {
	return {$: 'NumberOfLocationsWithPendingChangesResponse', a: a};
};
var $author$project$ApiPendingChanges$Dashboard$Main$init = function (flags) {
	var _v0 = $author$project$ApiPendingChanges$Dashboard$Model$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var flags_ = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{siteName: flags_.siteName, translations: flags_.translations, numberOfPendingChanges: $elm$core$Maybe$Nothing}),
			A2($author$project$ApiPendingChanges$Dashboard$Commands$getNumberOfLocationsWithPendingChanges, flags_.siteName, $author$project$ApiPendingChanges$Dashboard$Model$NumberOfLocationsWithPendingChangesResponse));
	} else {
		return _Utils_Tuple2(
			$elm$core$Result$Err($author$project$ApiPendingChanges$Dashboard$Model$FailedToDecodeFlags),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Translations$Listings$ApiDifference$reviewLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.review_locations');
};
var $author$project$Translations$Listings$ApiDifference$reviewDifferences = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.review_differences');
};
var $author$project$Translations$Listings$ApiDifference$differencesTaskTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.differences_task_title');
};
var $author$project$Translations$Listings$ApiDifference$differencesTaskHelpText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.differences_task_help_text');
};
var $author$project$ApiPendingChanges$Dashboard$View$taskStatus = F3(
	function (url, numberOfLocations, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-task')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-task__indicator')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-task__icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-regular fa-map-location-dot')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-task__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-task__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$ApiDifference$differencesTaskTitle(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$ApiDifference$differencesTaskHelpText(translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-task__asides stats')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stats')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('stats__title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$ApiDifference$reviewLocations(translations))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-verify-location__status stats__value')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(numberOfLocations))
										]))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url),
									$elm$html$Html$Attributes$class('stats__cta pmt-btn--default pmt-btn')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$ApiDifference$reviewDifferences(translations))
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$ApiDifference$apiDifferencesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.api_differences_title');
};
var $author$project$ApiPendingChanges$Dashboard$View$view = function (state) {
	if (state.$ === 'Ok') {
		var model = state.a;
		var _v1 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$lt(0),
				model.numberOfPendingChanges),
			model.numberOfPendingChanges);
		if (((_v1.a.$ === 'Just') && _v1.a.a) && (_v1.b.$ === 'Just')) {
			var numberOfPendingChanges = _v1.b.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section pmt-verify-location')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-verify-location__header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$ApiDifference$apiDifferencesTitle(model.translations))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$ApiPendingChanges$Dashboard$View$taskStatus, '/listings/' + (model.siteName + '/apisettings/pendingchanges'), numberOfPendingChanges, model.translations)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$ApiPendingChanges$Dashboard$Main$update = F2(
	function (msg, state) {
		if (msg.$ === 'HandleFlags') {
			var flags = msg.a;
			return $author$project$ApiPendingChanges$Dashboard$Main$init(flags);
		} else {
			var result = msg.a;
			if (state.$ === 'Ok') {
				var model = state.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									numberOfPendingChanges: $elm$core$Maybe$Just(response.count)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						$elm$core$Result$Ok(model),
						$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$ApiPendingChanges$Dashboard$Model$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$ApiPendingChanges$Dashboard$Main$passArgs_ApiPendingChanges_Dashboard_Main = _Platform_incomingPort('passArgs_ApiPendingChanges_Dashboard_Main', $elm$json$Json$Decode$value);
var $author$project$ApiPendingChanges$Dashboard$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$ApiPendingChanges$Dashboard$Main$init,
		view: $author$project$ApiPendingChanges$Dashboard$View$view,
		update: $author$project$ApiPendingChanges$Dashboard$Main$update,
		subscriptions: function (_v0) {
			return $author$project$ApiPendingChanges$Dashboard$Main$passArgs_ApiPendingChanges_Dashboard_Main($author$project$ApiPendingChanges$Dashboard$Model$HandleFlags);
		}
	});
var $author$project$ApiPendingChanges$Resolver$Model$init = function (flags) {
	return {editor: $elm$core$Maybe$Nothing, editing: $elm$core$Maybe$Nothing, selected: $elm$core$Dict$empty, siteName: flags.siteName, locations: $author$project$RemoteData$Loading, displayName: flags.displayName, pressedKeys: _List_Nil, verifyLocationErrors: $elm$core$Dict$empty};
};
var $author$project$ApiPendingChanges$Resolver$Update$LocationsResponse = function (a) {
	return {$: 'LocationsResponse', a: a};
};
var $author$project$Data$ServiceArea$None = {$: 'None'};
var $author$project$ApiPendingChanges$Resolver$Commands$Location = function (id) {
	return function (locationDescriptor) {
		return function (storeId) {
			return function (address) {
				return function (originalAddress) {
					return function (coordinates) {
						return function (addressChanges) {
							return function (addressChangeState) {
								return function (coordinatesChange) {
									return function (coordinatesChangeState) {
										return function (name) {
											return function (locationType) {
												return function (serviceAreas) {
													return {id: id, name: name, address: address, storeId: storeId, coordinates: coordinates, locationType: locationType, serviceAreas: serviceAreas, addressChanges: addressChanges, originalAddress: originalAddress, coordinatesChange: coordinatesChange, addressChangeState: addressChangeState, locationDescriptor: locationDescriptor, coordinatesChangeState: coordinatesChangeState};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$ServiceArea$Text = function (a) {
	return {$: 'Text', a: a};
};
var $author$project$Data$ServiceArea$WithPlaceId = function (a) {
	return {$: 'WithPlaceId', a: a};
};
var $author$project$Data$ServiceArea$ServiceArea = F7(
	function (area, placeId, country, state, region, city, zip) {
		return {zip: zip, area: area, city: city, state: state, region: region, country: country, placeId: placeId};
	});
var $author$project$Data$ServiceArea$ServiceAreaMeta = F2(
	function (longName, shortName) {
		return {longName: longName, shortName: shortName};
	});
var $author$project$Data$ServiceArea$serviceAreaMetaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'shortName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'longName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$ServiceArea$ServiceAreaMeta)));
var $author$project$Data$ServiceArea$serviceAreaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'zip',
	$elm$json$Json$Decode$nullable($author$project$Data$ServiceArea$serviceAreaMetaDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'city',
		$elm$json$Json$Decode$maybe($author$project$Data$ServiceArea$serviceAreaMetaDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'region',
			$elm$json$Json$Decode$maybe($author$project$Data$ServiceArea$serviceAreaMetaDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'state',
				$elm$json$Json$Decode$maybe($author$project$Data$ServiceArea$serviceAreaMetaDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'country',
					$author$project$Data$ServiceArea$serviceAreaMetaDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'placeId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'area',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Data$ServiceArea$ServiceArea))))))));
var $author$project$Data$ServiceArea$decodeServiceAreaList = $elm$json$Json$Decode$list($author$project$Data$ServiceArea$serviceAreaDecoder);
var $author$project$Data$ServiceArea$decodeServiceAreas = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$ServiceArea$Text,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2($elm$json$Json$Decode$map, $author$project$Data$ServiceArea$WithPlaceId, $author$project$Data$ServiceArea$decodeServiceAreaList)
		]));
var $author$project$ApiPendingChanges$Resolver$Commands$locationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'serviceAreas',
	$author$project$Data$ServiceArea$decodeServiceAreas,
	$author$project$Data$ServiceArea$None,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'type',
		$author$project$Data$Location$locationTypeDecoder,
		$author$project$Data$Location$Storefront,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$elm$json$Json$Decode$string,
			'',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				{isResolved: false, isPublishing: false},
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'pendingLocation',
					$elm$json$Json$Decode$nullable($author$project$Data$Coordinates$coordinatesDecoder),
					$elm$core$Maybe$Nothing,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						{isResolved: false, isPublishing: false},
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pendingAddress',
							$author$project$Data$Address$addressDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'location',
								$author$project$Data$Coordinates$coordinatesDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'address',
									$author$project$Data$Address$addressDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'address',
										$author$project$Data$Address$addressDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'storeId',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'locationDescriptor',
												$elm$json$Json$Decode$string,
												'',
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'_id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$ApiPendingChanges$Resolver$Commands$Location))))))))))))));
var $author$project$ApiPendingChanges$Resolver$Commands$decodeLocations = $elm$json$Json$Decode$list($author$project$ApiPendingChanges$Resolver$Commands$locationDecoder);
var $author$project$ApiPendingChanges$Resolver$Commands$getPendingChanges = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$ApiPendingChanges$Resolver$Commands$decodeLocations),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/apipendingchanges')))));
	});
var $author$project$ApiPendingChanges$Resolver$Main$init = F2(
	function (_v0, flags) {
		return _Utils_Tuple2(
			$author$project$ApiPendingChanges$Resolver$Model$init(flags),
			A2($author$project$ApiPendingChanges$Resolver$Commands$getPendingChanges, flags.siteName, $author$project$ApiPendingChanges$Resolver$Update$LocationsResponse));
	});
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$PinMeTo$Ui$Pagination$renderInput = F4(
	function (page, totalPages, onInputChangeMsg, submitMsg) {
		var inputFieldAttr = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-pagination__input'),
				$elm$html$Html$Attributes$type_('number'),
				$elm$html$Html$Attributes$value(
				$elm$core$String$fromInt(page)),
				$elm$html$Html$Events$onInput(onInputChangeMsg),
				$elm$html$Html$Attributes$max(
				$elm$core$String$fromInt(totalPages)),
				$elm$html$Html$Attributes$min('1')
			]);
		var allowSubmit = (page > 0) || (_Utils_cmp(page, totalPages) > 0);
		return allowSubmit ? A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit(submitMsg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onBlur(submitMsg),
						inputFieldAttr),
					_List_Nil)
				])) : A2(
			$elm$html$Html$form,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$input, inputFieldAttr, _List_Nil)
				]));
	});
var $author$project$PinMeTo$Ui$Pagination$view = F7(
	function (index, value, totalPages, pageChange, onInputChangeMsg, submitMsg, labels) {
		var forward = (_Utils_cmp(index + 1, totalPages) < 0) ? A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					pageChange(index + 1)),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'pagination.arrowNext')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa-solid fa-angle-right')
						]),
					_List_Nil)
				])) : A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa-solid fa-angle-right')
						]),
					_List_Nil)
				]));
		var back = (index > 0) ? A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					pageChange(index - 1))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa-solid fa-angle-left')
						]),
					_List_Nil)
				])) : A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa-solid fa-angle-left')
						]),
					_List_Nil)
				]));
		var to = $elm$core$String$fromInt(totalPages);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-pagination')
				]),
			_List_fromArray(
				[
					back,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-pagination__label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A4($author$project$PinMeTo$Ui$Pagination$renderInput, value, totalPages, onInputChangeMsg, submitMsg),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-pagination__label__text-of')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' ' + labels.of_)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'data-test', 'pagination.totalPages'),
											$elm$html$Html$Attributes$class('pmt-pagination__label__total-pages')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(to)
										]))
								]))
						])),
					forward
				]));
	});
var $author$project$Common$PaginationSimple$pageCount = function (x) {
	return $elm$core$Dict$size(x.items);
};
var $author$project$Common$PaginationSimple$view = F5(
	function (pagination, pageChangeMsg, onInputChangeMsg, onSubmitMsg, labels) {
		return A7(
			$author$project$PinMeTo$Ui$Pagination$view,
			pagination.currentPage,
			pagination.value,
			$author$project$Common$PaginationSimple$pageCount(pagination),
			pageChangeMsg,
			onInputChangeMsg,
			onSubmitMsg,
			labels);
	});
var $author$project$Translations$Listings$ApiDifference$apiData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.api_data');
};
var $author$project$Translations$Listings$ApiDifference$reviewDoneText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.review_done_text');
};
var $author$project$Translations$Listings$ApiDifference$reviewDoneHelperTextUrl = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.review_done_helper_text_url');
};
var $author$project$ApiPendingChanges$Resolver$NoContent$view = F2(
	function (_v0, model) {
		var translations = _v0.translations;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-empty-state pmt-verify-location-done')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-verify-location-done__message')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa-regular fa-check-circle fa-5x'),
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ApiDifference$reviewDoneText(translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ApiDifference$reviewDoneHelperTextUrl(translations)),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/listings/' + (model.siteName + '/apisettings/changes'))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$ApiDifference$apiData(translations) + (' - ' + $author$project$Translations$Listings$ApiDifference$apiDifferencesTitle(translations)))
								]))
						]))
				]));
	});
var $author$project$ApiPendingChanges$Resolver$Data$Source$Api = {$: 'Api'};
var $author$project$PinMeTo$Ui$Layout$Grid$Flex = {$: 'Flex'};
var $author$project$PinMeTo$Ui$Layout$Grid$flex = $author$project$PinMeTo$Ui$Layout$Grid$Flex;
var $author$project$Conflicts$FieldEditor$FieldEditor$Local = {$: 'Local'};
var $author$project$Conflicts$FieldEditor$FieldEditor$view = function (_v0) {
	var data = _v0.data;
	var title = _v0.title;
	return {cta: $elm$core$Maybe$Nothing, data: data, title: title, fieldType: $author$project$Conflicts$FieldEditor$FieldEditor$Local, isWorking: false, isResolved: false, isSelected: false, isPublishing: false};
};
var $author$project$ApiPendingChanges$Resolver$Data$Source$Master = {$: 'Master'};
var $author$project$PinMeTo$Ui$Layout$Grid$render = F2(
	function (_v0, items) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-grid')
				]),
			A2(
				$elm$core$List$map,
				function (x) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-grid__item')
							]),
						_List_fromArray(
							[x]));
				},
				items));
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Conflicts$FieldEditor$FieldEditor$ctaView = function (x) {
	var attributes = A2(
		$elm_community$maybe_extra$Maybe$Extra$cons,
		A2(
			$elm$core$Maybe$map,
			$elm$html$Html$Attributes$attribute('data-test'),
			x.dataTestAttribute),
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(x.msg),
				$elm$html$Html$Attributes$disabled(x.disabled),
				$elm$html$Html$Attributes$class('pmt-field-editor__cta')
			]));
	return A3(
		$author$project$PinMeTo$Ui$Btn$pmtBtn,
		$elm$html$Html$button,
		attributes,
		_List_fromArray(
			[
				$elm$html$Html$text(x.title)
			]));
};
var $author$project$Conflicts$FieldEditor$FieldEditor$progressIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('100%'),
			$elm$svg$Svg$Attributes$height('100%'),
			$elm$svg$Svg$Attributes$viewBox('0 0 64 64')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$use,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$xlinkHref('#pmt-icon__progress')
				]),
			_List_Nil)
		]));
var $author$project$Conflicts$FieldEditor$FieldEditor$render = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-field-editor'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-field-editor--local',
						_Utils_eq(config.fieldType, $author$project$Conflicts$FieldEditor$FieldEditor$Local)),
						_Utils_Tuple2(
						'pmt-field-editor--network',
						!_Utils_eq(config.fieldType, $author$project$Conflicts$FieldEditor$FieldEditor$Local)),
						_Utils_Tuple2('pmt-field-editor--publishing-current', config.isPublishing),
						_Utils_Tuple2('pmt-field-editor--publishing-other', config.isWorking),
						_Utils_Tuple2('pmt-field-editor--selected', config.isSelected)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-field-editor__header')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = config.fieldType;
						if (_v0.$ === 'Local') {
							return A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-field-editor__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(config.title),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-field-editor__title-suffix')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('PinMeTo')
													]))
											]))
									]));
						} else {
							var url = _v0.a.url;
							var name = _v0.a.name;
							return A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-field-editor__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(config.title),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-field-editor__title-suffix')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$core$Maybe$withDefault,
														A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-field-editor__network-name')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(name)
																])),
														A2(
															$elm$core$Maybe$map,
															function (x) {
																return A2(
																	$elm$html$Html$a,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$href(x),
																			$elm$html$Html$Attributes$target('_blank'),
																			$elm$html$Html$Attributes$class('pmt-field-editor__network-name')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(name)
																		]));
															},
															url))
													]))
											]))
									]));
						}
					}()
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-field-editor__content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-field-editor__data')
							]),
						_List_fromArray(
							[config.data])),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-field-editor__progress')
							]),
						_List_fromArray(
							[$author$project$Conflicts$FieldEditor$FieldEditor$progressIcon]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-field-editor__footer')
					]),
				_List_fromArray(
					[
						(config.isPublishing || config.isWorking) ? A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-field-editor__status')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fa fa-cog fa-spin')
									]),
								_List_Nil),
								$elm$html$Html$text(' Publishing')
							])) : (config.isResolved ? A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-field-editor__status')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fa fa-check pmt-field-editor__resolved-icon')
									]),
								_List_Nil)
							])) : A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2($elm$core$Maybe$map, $author$project$Conflicts$FieldEditor$FieldEditor$ctaView, config.cta)))
					]))
			]));
};
var $author$project$Data$Location$Field$Address = {$: 'Address'};
var $author$project$Conflicts$FieldEditor$FieldEditor$withCta = F2(
	function (_v0, config) {
		var msg = _v0.msg;
		var title = _v0.title;
		return _Utils_update(
			config,
			{
				cta: $elm$core$Maybe$Just(
					{msg: msg, title: title, disabled: false, dataTestAttribute: $elm$core$Maybe$Nothing})
			});
	});
var $author$project$Translations$Listings$ApiDifference$useMaster = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.use_master');
};
var $author$project$Conflicts$FieldEditor$FieldEditor$isResolved = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{isResolved: x});
	});
var $author$project$ApiPendingChanges$Resolver$Model$isSelected = F4(
	function (field, locationId, source, selections) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					switch (field.$) {
						case 'Address':
							return _Utils_eq(
								x.address,
								$elm$core$Maybe$Just(source));
						case 'Location':
							return _Utils_eq(
								x.location,
								$elm$core$Maybe$Just(source));
						default:
							return false;
					}
				},
				A2($elm$core$Dict$get, locationId, selections)));
	});
var $author$project$Conflicts$FieldEditor$FieldEditor$isSelected = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{isSelected: x});
	});
var $author$project$Conflicts$FieldEditor$Data$Config = F2(
	function (data, onClick) {
		return {data: data, onClick: onClick};
	});
var $author$project$Conflicts$FieldEditor$Data$view = function (data) {
	return A2($author$project$Conflicts$FieldEditor$Data$Config, data, $elm$core$Maybe$Nothing);
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Conflicts$FieldEditor$Data$render = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-field-editor-data'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-field-editor-data--editable',
						!_Utils_eq(config.onClick, $elm$core$Maybe$Nothing))
					]))
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var approveDiff = _v0.a.approveDiff;
				var useThis = _v0.a.useThis;
				var value = _v0.a.value;
				var label = _v0.a.label;
				var hasApprovedDiff = _v0.a.hasApprovedDiff;
				var hasConflict = _v0.a.hasConflict;
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-field-editor-data__row'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-field-editor-data__row--with-conflict', hasConflict),
									_Utils_Tuple2('pmt-conflict-data__row--with-approved-diff', hasApprovedDiff),
									_Utils_Tuple2(
									'pmt-conflict-data__row--with-actions',
									(!_Utils_eq(useThis, $elm$core$Maybe$Nothing)) || (!_Utils_eq(approveDiff, $elm$core$Maybe$Nothing)))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$Attributes$class(''),
							A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, config.onClick))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-field-editor-data__field')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-field-editor-data__content pmt-field-editor-data__content--nowrap')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__actions')
								]),
							_List_fromArray(
								[
									function () {
									var _v1 = _Utils_Tuple2(approveDiff, hasConflict);
									if ((_v1.a.$ === 'Just') && _v1.b) {
										var opt = _v1.a.a;
										return A3(
											$author$project$PinMeTo$Ui$Btn$pmtBtn,
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(opt.label),
													$elm$html$Html$Events$onClick(opt.onClick)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa fa-check')
														]),
													_List_Nil)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									function () {
									var _v2 = _Utils_Tuple2(
										useThis,
										hasConflict && ($elm$core$String$trim(value) !== ''));
									if ((_v2.a.$ === 'Just') && _v2.b) {
										var opt = _v2.a.a;
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-btn--use-this'),
													$elm$html$Html$Events$onClick(
													opt.onClick(value))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(opt.label)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								]))
						]));
			},
			config.data));
};
var $author$project$Data$Address$getState = function (address) {
	var _v0 = address.stateOrProvince;
	if (_v0.$ === 'WithState') {
		var state = _v0.a;
		return state;
	} else {
		return '';
	}
};
var $author$project$Data$Address$hasState = function (address) {
	var _v0 = address.stateOrProvince;
	if (_v0.$ === 'WithState') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Conflicts$FieldEditor$Data$Row = function (a) {
	return {$: 'Row', a: a};
};
var $author$project$Conflicts$FieldEditor$Data$row = F2(
	function (label, value) {
		return $author$project$Conflicts$FieldEditor$Data$Row(
			{label: label, value: value, useThis: $elm$core$Maybe$Nothing, approveDiff: $elm$core$Maybe$Nothing, hasConflict: false, hasApprovedDiff: false});
	});
var $author$project$Conflicts$FieldEditor$Data$withConflict = F2(
	function (value, _v0) {
		var data = _v0.a;
		return $author$project$Conflicts$FieldEditor$Data$Row(
			_Utils_update(
				data,
				{hasConflict: value}));
	});
var $author$project$Conflicts$FieldEditor$Data$withOnUseThis = F3(
	function (msg, label, _v0) {
		var data = _v0.a;
		return $author$project$Conflicts$FieldEditor$Data$Row(
			_Utils_update(
				data,
				{
					useThis: $elm$core$Maybe$Just(
						{label: label, onClick: msg})
				}));
	});
var $author$project$Common$AddressEditor$buildField = F5(
	function (label, value, conflict, useThisLabel, onUseThis) {
		return function (data) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				data,
				function (onUseThis_) {
					return A3($author$project$Conflicts$FieldEditor$Data$withOnUseThis, onUseThis_, useThisLabel, data);
				},
				onUseThis);
		}(
			A2(
				$author$project$Conflicts$FieldEditor$Data$withConflict,
				conflict,
				A2($author$project$Conflicts$FieldEditor$Data$row, label, value)));
	});
var $author$project$Translations$Listings$Conflicts$approveDiff = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.approve_diff');
};
var $author$project$Data$Address$getDistrict = function (address) {
	var _v0 = address.stateOrProvince;
	if (_v0.$ === 'WithState') {
		return '';
	} else {
		var district = _v0.a.district;
		return district;
	}
};
var $author$project$Data$Address$getProvince = function (address) {
	var _v0 = address.stateOrProvince;
	if (_v0.$ === 'WithState') {
		return '';
	} else {
		var province = _v0.a.province;
		return province;
	}
};
var $author$project$Conflicts$FieldEditor$Data$withOnClick = F2(
	function (msg, config) {
		return _Utils_update(
			config,
			{
				onClick: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Translations$General$locationState = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_state');
};
var $author$project$Translations$General$resolverUseThis = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.resolver_use_this');
};
var $author$project$Translations$General$locationDistrict = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_district');
};
var $author$project$Translations$General$locationLatitude = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_latitude');
};
var $author$project$Translations$General$locationProvince = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_province');
};
var $author$project$Conflicts$FieldEditor$Data$withApprovedDiff = F2(
	function (value, _v0) {
		var data = _v0.a;
		return $author$project$Conflicts$FieldEditor$Data$Row(
			_Utils_update(
				data,
				{hasApprovedDiff: value}));
	});
var $author$project$Translations$General$locationLongitude = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_longitude');
};
var $author$project$Conflicts$FieldEditor$Data$withOnApproveDiff = F3(
	function (msg, label, _v0) {
		var data = _v0.a;
		return $author$project$Conflicts$FieldEditor$Data$Row(
			_Utils_update(
				data,
				{
					approveDiff: $elm$core$Maybe$Just(
						{label: label, onClick: msg})
				}));
	});
var $author$project$Common$AddressEditor$view = function (config) {
	return $author$project$Conflicts$FieldEditor$Data$render(
		function (data) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				data,
				function (msg) {
					return A2($author$project$Conflicts$FieldEditor$Data$withOnClick, msg, data);
				},
				config.onClick);
		}(
			$author$project$Conflicts$FieldEditor$Data$view(
				$elm_community$maybe_extra$Maybe$Extra$values(
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A5(
								$author$project$Common$AddressEditor$buildField,
								$author$project$Translations$General$locationStreet(config.translations),
								config.address.street,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									function ($) {
										return $.street;
									},
									config.addressConflicts),
								$author$project$Translations$General$resolverUseThis(config.translations),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.street;
										},
										$elm$core$Maybe$Just),
									config.onUseThisMsgs))),
							$elm$core$Maybe$Just(
							A5(
								$author$project$Common$AddressEditor$buildField,
								$author$project$Translations$General$locationZip(config.translations),
								config.address.zip,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									function ($) {
										return $.zip;
									},
									config.addressConflicts),
								$author$project$Translations$General$resolverUseThis(config.translations),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.zip;
										},
										$elm$core$Maybe$Just),
									config.onUseThisMsgs))),
							$elm$core$Maybe$Just(
							function (row) {
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									row,
									function (onApproveDiffMsgs) {
										return A3(
											$author$project$Conflicts$FieldEditor$Data$withOnApproveDiff,
											onApproveDiffMsgs.city,
											$author$project$Translations$Listings$Conflicts$approveDiff(config.translations),
											row);
									},
									config.onApproveDiffMsgs);
							}(
								function (row) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										row,
										function (approvedDiffs) {
											return A2($author$project$Conflicts$FieldEditor$Data$withApprovedDiff, approvedDiffs.city, row);
										},
										config.approvedDiffs);
								}(
									A5(
										$author$project$Common$AddressEditor$buildField,
										$author$project$Translations$General$locationCity(config.translations),
										config.address.city,
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											false,
											function ($) {
												return $.city;
											},
											config.addressConflicts),
										$author$project$Translations$General$resolverUseThis(config.translations),
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$elm$core$Maybe$Nothing,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.city;
												},
												$elm$core$Maybe$Just),
											config.onUseThisMsgs))))),
							$author$project$Data$Address$hasState(config.address) ? $elm$core$Maybe$Just(
							A5(
								$author$project$Common$AddressEditor$buildField,
								$author$project$Translations$General$locationState(config.translations),
								$author$project$Data$Address$getState(config.address),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									function ($) {
										return $.state;
									},
									config.addressConflicts),
								$author$project$Translations$General$resolverUseThis(config.translations),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.state;
										},
										$elm$core$Maybe$Just),
									config.onUseThisMsgs))) : $elm$core$Maybe$Nothing,
							$author$project$Data$Address$hasState(config.address) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							function (row) {
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									row,
									function (onApproveDiffMsgs) {
										return A3(
											$author$project$Conflicts$FieldEditor$Data$withOnApproveDiff,
											onApproveDiffMsgs.province,
											$author$project$Translations$Listings$Conflicts$approveDiff(config.translations),
											row);
									},
									config.onApproveDiffMsgs);
							}(
								function (row) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										row,
										function (approvedDiffs) {
											return A2($author$project$Conflicts$FieldEditor$Data$withApprovedDiff, approvedDiffs.province, row);
										},
										config.approvedDiffs);
								}(
									A5(
										$author$project$Common$AddressEditor$buildField,
										$author$project$Translations$General$locationProvince(config.translations),
										$author$project$Data$Address$getProvince(config.address),
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											false,
											function ($) {
												return $.province;
											},
											config.addressConflicts),
										$author$project$Translations$General$resolverUseThis(config.translations),
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$elm$core$Maybe$Nothing,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.province;
												},
												$elm$core$Maybe$Just),
											config.onUseThisMsgs))))),
							$author$project$Data$Address$hasState(config.address) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A5(
								$author$project$Common$AddressEditor$buildField,
								$author$project$Translations$General$locationDistrict(config.translations),
								$author$project$Data$Address$getDistrict(config.address),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									function ($) {
										return $.district;
									},
									config.addressConflicts),
								$author$project$Translations$General$resolverUseThis(config.translations),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.district;
										},
										$elm$core$Maybe$Just),
									config.onUseThisMsgs))),
							$elm$core$Maybe$Just(
							A5(
								$author$project$Common$AddressEditor$buildField,
								$author$project$Translations$General$locationCountry(config.translations),
								config.address.country,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									function ($) {
										return $.country;
									},
									config.addressConflicts),
								$author$project$Translations$General$resolverUseThis(config.translations),
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.country;
										},
										$elm$core$Maybe$Just),
									config.onUseThisMsgs))),
							A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Maybe$Nothing,
							function (coordinates) {
								return $elm$core$Maybe$Just(
									A5(
										$author$project$Common$AddressEditor$buildField,
										$author$project$Translations$General$locationLatitude(config.translations),
										$elm$core$String$fromFloat(coordinates.lat),
										_Utils_eq(
											config.coordinateConflict,
											$elm$core$Maybe$Just(true)),
										$author$project$Translations$General$resolverUseThis(config.translations),
										$elm$core$Maybe$Nothing));
							},
							config.coordinates),
							A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Maybe$Nothing,
							function (coordinates) {
								return $elm$core$Maybe$Just(
									A5(
										$author$project$Common$AddressEditor$buildField,
										$author$project$Translations$General$locationLongitude(config.translations),
										$elm$core$String$fromFloat(coordinates.lon),
										_Utils_eq(
											config.coordinateConflict,
											$elm$core$Maybe$Just(true)),
										$author$project$Translations$General$resolverUseThis(config.translations),
										$elm$core$Maybe$Nothing));
							},
							config.coordinates)
						])))));
};
var $author$project$Common$AddressEditor$Config = F9(
	function (address, translations, coordinates, addressConflicts, coordinateConflict, approvedDiffs, onUseThisMsgs, onApproveDiffMsgs, onClick) {
		return {address: address, onClick: onClick, coordinates: coordinates, translations: translations, approvedDiffs: approvedDiffs, onUseThisMsgs: onUseThisMsgs, addressConflicts: addressConflicts, onApproveDiffMsgs: onApproveDiffMsgs, coordinateConflict: coordinateConflict};
	});
var $author$project$Common$AddressEditor$withAddress = F2(
	function (address, translations) {
		return A9($author$project$Common$AddressEditor$Config, address, translations, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	});
var $author$project$Common$AddressEditor$withOnClick = F2(
	function (msg, config) {
		return _Utils_update(
			config,
			{
				onClick: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$ApiPendingChanges$Resolver$Update$EditMasterData = F2(
	function (a, b) {
		return {$: 'EditMasterData', a: a, b: b};
	});
var $author$project$ApiPendingChanges$Resolver$View$AddressView$masterData = F2(
	function (location, translations) {
		return $author$project$Common$AddressEditor$view(
			A2(
				$author$project$Common$AddressEditor$withOnClick,
				A2($author$project$ApiPendingChanges$Resolver$Update$EditMasterData, $author$project$Data$Location$Field$Address, location.id),
				A2($author$project$Common$AddressEditor$withAddress, location.address, translations)));
	});
var $author$project$ApiPendingChanges$Resolver$View$AddressView$hasApiChange = function (location) {
	return (location.addressChanges.street !== '') || ((location.addressChanges.zip !== '') || ((location.addressChanges.city !== '') || ((location.addressChanges.country !== '') || (($author$project$Data$Address$getState(location.addressChanges) !== '') || (($author$project$Data$Address$getProvince(location.addressChanges) !== '') || ($author$project$Data$Address$getDistrict(location.addressChanges) !== ''))))));
};
var $author$project$Conflicts$FieldEditor$FieldEditor$isPublishing = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{isPublishing: x});
	});
var $author$project$ApiPendingChanges$Resolver$Update$SelectApiData = F2(
	function (a, b) {
		return {$: 'SelectApiData', a: a, b: b};
	});
var $author$project$Data$Address$merge = F2(
	function (address1, address2) {
		var mergeValue = function (f) {
			return (f(address2) === '') ? f(address1) : f(address2);
		};
		return {
			zip: mergeValue(
				function ($) {
					return $.zip;
				}),
			city: mergeValue(
				function ($) {
					return $.city;
				}),
			street: mergeValue(
				function ($) {
					return $.street;
				}),
			country: mergeValue(
				function ($) {
					return $.country;
				}),
			stateOrProvince: $author$project$Data$Address$hasState(address1) ? $author$project$Data$Address$WithState(
				mergeValue($author$project$Data$Address$getState)) : $author$project$Data$Address$WithProvince(
				{
					district: mergeValue($author$project$Data$Address$getDistrict),
					province: mergeValue($author$project$Data$Address$getProvince)
				}),
			countryAlpha2Code: mergeValue(
				function ($) {
					return $.countryAlpha2Code;
				})
		};
	});
var $author$project$Common$AddressEditor$withAddressConflicts = F2(
	function (conflicts, config) {
		return _Utils_update(
			config,
			{
				addressConflicts: $elm$core$Maybe$Just(conflicts)
			});
	});
var $author$project$Common$AddressEditor$withCoordinateConflict = F2(
	function (conflict, config) {
		return _Utils_update(
			config,
			{
				coordinateConflict: $elm$core$Maybe$Just(conflict)
			});
	});
var $author$project$ApiPendingChanges$Resolver$View$AddressView$geoLookupData = F2(
	function (location, translations) {
		var conflict = function (f) {
			return f(location.addressChanges) !== '';
		};
		return $author$project$Common$AddressEditor$view(
			A2(
				$author$project$Common$AddressEditor$withCoordinateConflict,
				!_Utils_eq(location.coordinatesChange, $elm$core$Maybe$Nothing),
				A2(
					$author$project$Common$AddressEditor$withAddressConflicts,
					{
						zip: conflict(
							function ($) {
								return $.zip;
							}),
						city: conflict(
							function ($) {
								return $.city;
							}),
						state: conflict($author$project$Data$Address$getState),
						street: conflict(
							function ($) {
								return $.street;
							}),
						country: conflict(
							function ($) {
								return $.country;
							}),
						district: conflict($author$project$Data$Address$getDistrict),
						province: conflict($author$project$Data$Address$getProvince)
					},
					A2(
						$author$project$Common$AddressEditor$withAddress,
						A2($author$project$Data$Address$merge, location.address, location.addressChanges),
						translations))));
	});
var $author$project$Translations$Listings$ApiDifference$applyApiChange = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.apply_api_change');
};
var $author$project$Translations$General$locationAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_address');
};
var $author$project$Conflicts$FieldEditor$FieldEditor$Network = function (a) {
	return {$: 'Network', a: a};
};
var $author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				fieldType: $author$project$Conflicts$FieldEditor$FieldEditor$Network(
					{url: $elm$core$Maybe$Nothing, name: x})
			});
	});
var $author$project$ApiPendingChanges$Resolver$Update$SelectMasterData = F2(
	function (a, b) {
		return {$: 'SelectMasterData', a: a, b: b};
	});
var $author$project$ApiPendingChanges$Resolver$View$AddressView$view = F4(
	function (isEditing, selections, location, translations) {
		return $author$project$ApiPendingChanges$Resolver$View$AddressView$hasApiChange(location) ? A2(
			$author$project$PinMeTo$Ui$Layout$Grid$render,
			$author$project$PinMeTo$Ui$Layout$Grid$flex,
			_List_fromArray(
				[
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isPublishing,
						location.addressChangeState.isPublishing,
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
							location.addressChangeState.isResolved,
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
								isEditing || A4($author$project$ApiPendingChanges$Resolver$Model$isSelected, $author$project$Data$Location$Field$Address, location.id, $author$project$ApiPendingChanges$Resolver$Data$Source$Master, selections),
								A2(
									$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
									{
										msg: A2($author$project$ApiPendingChanges$Resolver$Update$SelectMasterData, $author$project$Data$Location$Field$Address, location.id),
										title: $author$project$Translations$Listings$ApiDifference$useMaster(translations)
									},
									$author$project$Conflicts$FieldEditor$FieldEditor$view(
										{
											data: A2($author$project$ApiPendingChanges$Resolver$View$AddressView$masterData, location, translations),
											title: $author$project$Translations$General$locationAddress(translations)
										})))))),
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isPublishing,
						location.addressChangeState.isPublishing,
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
							location.addressChangeState.isResolved,
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
								(!isEditing) && A4($author$project$ApiPendingChanges$Resolver$Model$isSelected, $author$project$Data$Location$Field$Address, location.id, $author$project$ApiPendingChanges$Resolver$Data$Source$Api, selections),
								A2(
									$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
									{
										msg: A2($author$project$ApiPendingChanges$Resolver$Update$SelectApiData, $author$project$Data$Location$Field$Address, location.id),
										title: $author$project$Translations$Listings$ApiDifference$applyApiChange(translations)
									},
									A2(
										$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName,
										$author$project$Translations$Listings$ApiDifference$apiData(translations),
										$author$project$Conflicts$FieldEditor$FieldEditor$view(
											{
												data: A2($author$project$ApiPendingChanges$Resolver$View$AddressView$geoLookupData, location, translations),
												title: $author$project$Translations$General$locationAddress(translations)
											})))))))
				])) : $elm$html$Html$text('');
	});
var $author$project$Data$Location$Field$Location = {$: 'Location'};
var $author$project$ApiPendingChanges$Resolver$View$LocationView$masterData = F2(
	function (location, translations) {
		return $author$project$Conflicts$FieldEditor$Data$render(
			A2(
				$author$project$Conflicts$FieldEditor$Data$withOnClick,
				A2($author$project$ApiPendingChanges$Resolver$Update$EditMasterData, $author$project$Data$Location$Field$Location, location.id),
				$author$project$Conflicts$FieldEditor$Data$view(
					_List_fromArray(
						[
							A2(
							$author$project$Conflicts$FieldEditor$Data$row,
							$author$project$Translations$General$locationLatitude(translations),
							$elm$core$String$fromFloat(location.coordinates.lat)),
							A2(
							$author$project$Conflicts$FieldEditor$Data$row,
							$author$project$Translations$General$locationLongitude(translations),
							$elm$core$String$fromFloat(location.coordinates.lon))
						]))));
	});
var $author$project$ApiPendingChanges$Resolver$View$LocationView$apiData = F2(
	function (location, translations) {
		var _v0 = location.coordinatesChange;
		if (_v0.$ === 'Just') {
			var change = _v0.a;
			return $author$project$Conflicts$FieldEditor$Data$render(
				$author$project$Conflicts$FieldEditor$Data$view(
					_List_fromArray(
						[
							A2(
							$author$project$Conflicts$FieldEditor$Data$withConflict,
							true,
							A2(
								$author$project$Conflicts$FieldEditor$Data$row,
								$author$project$Translations$General$locationLatitude(translations),
								$elm$core$String$fromFloat(change.lat))),
							A2(
							$author$project$Conflicts$FieldEditor$Data$withConflict,
							true,
							A2(
								$author$project$Conflicts$FieldEditor$Data$row,
								$author$project$Translations$General$locationLongitude(translations),
								$elm$core$String$fromFloat(change.lon)))
						])));
		} else {
			return A2($author$project$ApiPendingChanges$Resolver$View$LocationView$masterData, location, translations);
		}
	});
var $author$project$ApiPendingChanges$Resolver$View$LocationView$hasApiChange = function (location) {
	return !_Utils_eq(location.coordinatesChange, $elm$core$Maybe$Nothing);
};
var $author$project$ApiPendingChanges$Resolver$View$LocationView$view = F4(
	function (isEditing, selections, location, translations) {
		return $author$project$ApiPendingChanges$Resolver$View$LocationView$hasApiChange(location) ? A2(
			$author$project$PinMeTo$Ui$Layout$Grid$render,
			$author$project$PinMeTo$Ui$Layout$Grid$flex,
			_List_fromArray(
				[
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isPublishing,
						location.coordinatesChangeState.isPublishing,
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
							location.coordinatesChangeState.isResolved,
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
								isEditing || A4($author$project$ApiPendingChanges$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$ApiPendingChanges$Resolver$Data$Source$Master, selections),
								A2(
									$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
									{
										msg: A2($author$project$ApiPendingChanges$Resolver$Update$SelectMasterData, $author$project$Data$Location$Field$Location, location.id),
										title: $author$project$Translations$Listings$ApiDifference$useMaster(translations)
									},
									$author$project$Conflicts$FieldEditor$FieldEditor$view(
										{
											data: A2($author$project$ApiPendingChanges$Resolver$View$LocationView$masterData, location, translations),
											title: $author$project$Translations$General$location(translations)
										})))))),
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isPublishing,
						location.coordinatesChangeState.isPublishing,
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
							location.coordinatesChangeState.isResolved,
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
								(!isEditing) && A4($author$project$ApiPendingChanges$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$ApiPendingChanges$Resolver$Data$Source$Api, selections),
								A2(
									$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
									{
										msg: A2($author$project$ApiPendingChanges$Resolver$Update$SelectApiData, $author$project$Data$Location$Field$Location, location.id),
										title: $author$project$Translations$Listings$ApiDifference$applyApiChange(translations)
									},
									A2(
										$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName,
										$author$project$Translations$Listings$ApiDifference$apiData(translations),
										$author$project$Conflicts$FieldEditor$FieldEditor$view(
											{
												data: A2($author$project$ApiPendingChanges$Resolver$View$LocationView$apiData, location, translations),
												title: $author$project$Translations$General$location(translations)
											})))))))
				])) : $elm$html$Html$text('');
	});
var $author$project$ApiPendingChanges$Resolver$View$ConflictView$isEditing = F3(
	function (field, id, editing) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					return _Utils_eq(x.field, field) && _Utils_eq(x.locationId, id);
				},
				editing));
	});
var $author$project$ApiPendingChanges$Resolver$View$ConflictView$view = F4(
	function (editing, selections, location, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$ApiPendingChanges$Resolver$View$AddressView$view,
					A3($author$project$ApiPendingChanges$Resolver$View$ConflictView$isEditing, $author$project$Data$Location$Field$Address, location.id, editing),
					selections,
					location,
					translations),
					A4(
					$author$project$ApiPendingChanges$Resolver$View$LocationView$view,
					A3($author$project$ApiPendingChanges$Resolver$View$ConflictView$isEditing, $author$project$Data$Location$Field$Location, location.id, editing),
					selections,
					location,
					translations)
				]));
	});
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$ApiPendingChanges$Resolver$View$title = F6(
	function (siteName, id, name, locationDescriptor, storeId, translations) {
		var descriptor = (locationDescriptor !== '') ? A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('( ' + (locationDescriptor + ' )'))
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-api-changes-resolver__title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$locationStoreId(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/listings/' + (siteName + ('/locations/' + id)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(storeId)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$location(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/listings/' + (siteName + ('/locations/' + id)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										])),
									descriptor
								]))
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Map$Pin = function (a) {
	return {$: 'Pin', a: a};
};
var $author$project$PinMeTo$Ui$Map$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Map$Feature = function (a) {
	return {$: 'Feature', a: a};
};
var $author$project$PinMeTo$Ui$Map$ZoomAuto = {$: 'ZoomAuto'};
var $author$project$PinMeTo$Ui$Map$UnClustered = {$: 'UnClustered'};
var $author$project$PinMeTo$Ui$Map$view = function (pins) {
	return $author$project$PinMeTo$Ui$Map$View(
		{
			pins: function () {
				var ensureId = F2(
					function (index, x) {
						return _Utils_update(
							x,
							{
								id: (x.id === '') ? $elm$core$String$fromInt(index) : x.id
							});
					});
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, pin_) {
							if (pin_.$ === 'Pin') {
								var x = pin_.a;
								return $author$project$PinMeTo$Ui$Map$Pin(
									A2(ensureId, index, x));
							} else {
								var feature = pin_.a;
								return $author$project$PinMeTo$Ui$Map$Feature(
									_Utils_update(
										feature,
										{
											properties: A2(ensureId, index, feature.properties)
										}));
							}
						}),
					pins);
			}(),
			zoom: $author$project$PinMeTo$Ui$Map$ZoomAuto,
			mapType: $author$project$PinMeTo$Ui$Map$UnClustered,
			onChange: $elm$core$Maybe$Nothing,
			onPopulate: $elm$core$Maybe$Nothing,
			onPinSelect: $elm$core$Maybe$Nothing,
			customPopovers: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$filterMap,
					function (pin_) {
						if (pin_.$ === 'Pin') {
							var x = pin_.a;
							var _v2 = x.popover;
							if (_v2.$ === 'Just') {
								if (_v2.a.$ === 'CustomPinPopover') {
									var custom = _v2.a.a;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(x.id, custom));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					pins))
		});
};
var $author$project$Env$paths = {pmtUiPath: '/static/pmt-ui'};
var $author$project$PinMeToUiConstants$awsMaps = {apiKey: 'v1.public.eyJqdGkiOiI3YWVmM2NkYS1iZmE3LTQ1NGMtOWJhNC04ZTdkYzA4ZjM0N2QifZRZQXm_p617dstbIlbribGpQPfGr92QNxXHlY_DjTbqYpRvTGs-P4ihmnpBWNzLCRo7D6XCqVoK5stjbFa1ChyVEOtanYfMYvmk-S7t3izJqKA6tPu0zqDPkgdrj7qeZLMolx78LpmLrLKLDh-s-ffmmH0KpidiDsIFCLZXqwyfkOFER0IGDi3Ahrrv0NV2NjVupbgk5EyHYDshUonaZrfXDy9efFltZED8_LNAQP6Wnc4BC7D-qVYYRsI_gIYvlEiRISkgx5qVRx-dm8Qk-WFk2AFea9MtunkUXnVpHjBEak5Inf-2XVFC_xPCHzJ8bD7mTv3wxFWYSpUl8gdUTQk.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4'};
var $author$project$PinMeTo$Ui$Map$Coordinates = F2(
	function (lat, lon) {
		return {lat: lat, lon: lon};
	});
var $author$project$PinMeTo$Ui$Map$coordinatesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$PinMeTo$Ui$Map$Coordinates,
	A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float));
var $author$project$PinMeTo$Ui$Map$onChange = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A3(
			$elm$json$Json$Decode$map2,
			msg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail', 'id']),
				$elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail', 'coordinates']),
				$author$project$PinMeTo$Ui$Map$coordinatesDecoder)));
};
var $author$project$PinMeTo$Ui$Map$toFeature = function (pin_) {
	if (pin_.$ === 'Pin') {
		var config = pin_.a;
		var markerName = function () {
			var _v5 = config.marker;
			if (_v5.$ === 'Just') {
				var marker_ = _v5.a;
				switch (marker_.$) {
					case 'ApiMarker':
						return 'Gray_API.svg';
					case 'AppleMarker':
						return 'Gray_Apple.svg';
					case 'BingMarker':
						return 'Gray_Bing.svg';
					case 'FacebookMarker':
						return 'Gray_Facebook.svg';
					case 'FourSquareMarker':
						return 'Gray_FourSquare.svg';
					case 'GoogleMarker':
						return 'Gray_Google.svg';
					case 'TrustpilotMarker':
						return 'Gray_Trustpilot.svg';
					case 'WechatMarker':
						return 'Gray_Wechat.svg';
					default:
						return 'Blue_Check.svg';
				}
			} else {
				return 'Blue_MasterData.svg';
			}
		}();
		var _v1 = function () {
			var _v2 = config.popover;
			if (_v2.$ === 'Just') {
				var popover = _v2.a;
				if (popover.$ === 'DefaultPinPopover') {
					var x = popover.a;
					return {url: x.url, name: x.name};
				} else {
					var x = popover.a;
					return {url: '', name: ''};
				}
			} else {
				return {url: '', name: ''};
			}
		}();
		var url = _v1.url;
		var name = _v1.name;
		return {
			type_: 'Feature',
			geometry: {
				type_: 'Point',
				coordinates: function (_v4) {
					var lat = _v4.lat;
					var lon = _v4.lon;
					return _List_fromArray(
						[lon, lat]);
				}(config.coordinates)
			},
			properties: {id: config.id, url: url, name: name, site: '', type_: $elm$core$Maybe$Nothing, marker: $author$project$Env$paths.pmtUiPath + ('/svg/map-markers/' + markerName), country: '', draggable: config.draggable}
		};
	} else {
		var x = pin_.a;
		return x;
	}
};
var $author$project$PinMeTo$Ui$Map$onPinSelect = function (msg) {
	var decoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['detail', 'id']),
					$elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
	return A2(
		$elm$html$Html$Events$on,
		'pinselect',
		A2($elm$json$Json$Decode$map, msg, decoder));
};
var $author$project$PinMeTo$Ui$Map$addAttribute = F2(
	function (maybeAttribute, attributes) {
		if (maybeAttribute.$ === 'Just') {
			var attribute = maybeAttribute.a;
			return A2($elm$core$List$cons, attribute, attributes);
		} else {
			return attributes;
		}
	});
var $author$project$PinMeTo$Ui$Map$zoomToString = function (zoom) {
	if (zoom.$ === 'Zoom') {
		var x = zoom.a;
		return $elm$core$String$fromInt(x);
	} else {
		return '0';
	}
};
var $author$project$PinMeTo$Ui$Map$mapTypeToString = function (onPopulate) {
	if (onPopulate.$ === 'Clustered') {
		return 'clustered';
	} else {
		return 'unclustered';
	}
};
var $author$project$PinMeTo$Ui$Map$onPopulateToString = function (onPopulate) {
	return 'fit-bounds';
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$PinMeTo$Ui$WCMap$MapV2$encodeGeometry = function (geometry) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(geometry.type_)),
				_Utils_Tuple2(
				'coordinates',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, geometry.coordinates))
			]));
};
var $author$project$PinMeTo$Ui$WCMap$MapV2$encodeProperties = function (properties) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(properties.id)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(properties.name)),
				_Utils_Tuple2(
				'site',
				$elm$json$Json$Encode$string(properties.site)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', properties.type_))),
				_Utils_Tuple2(
				'country',
				$elm$json$Json$Encode$string(properties.country)),
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(properties.url)),
				_Utils_Tuple2(
				'marker',
				$elm$json$Json$Encode$string(properties.marker)),
				_Utils_Tuple2(
				'draggable',
				$elm$json$Json$Encode$bool(properties.draggable))
			]));
};
var $author$project$PinMeTo$Ui$WCMap$MapV2$encodeFeature = function (feature) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(feature.type_)),
				_Utils_Tuple2(
				'geometry',
				$author$project$PinMeTo$Ui$WCMap$MapV2$encodeGeometry(feature.geometry)),
				_Utils_Tuple2(
				'properties',
				$author$project$PinMeTo$Ui$WCMap$MapV2$encodeProperties(feature.properties))
			]));
};
var $author$project$PinMeTo$Ui$WCMap$MapV2$encodeFeatureCollection = function (collection) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(collection.type_)),
				_Utils_Tuple2(
				'features',
				A2($elm$json$Json$Encode$list, $author$project$PinMeTo$Ui$WCMap$MapV2$encodeFeature, collection.features))
			]));
};
var $author$project$PinMeTo$Ui$Map$render = function (_v0) {
	var config = _v0.a;
	var featureCollection = A2(
		$elm$json$Json$Encode$encode,
		0,
		$author$project$PinMeTo$Ui$WCMap$MapV2$encodeFeatureCollection(
			{
				type_: 'FeatureCollection',
				features: A2($elm$core$List$map, $author$project$PinMeTo$Ui$Map$toFeature, config.pins)
			}));
	return A3(
		$elm$html$Html$node,
		'pmt-map-v2',
		A2(
			$author$project$PinMeTo$Ui$Map$addAttribute,
			A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Map$onPinSelect, config.onPinSelect),
			A2(
				$author$project$PinMeTo$Ui$Map$addAttribute,
				A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Map$onChange, config.onChange),
				A2(
					$author$project$PinMeTo$Ui$Map$addAttribute,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$PinMeTo$Ui$Map$onPopulateToString,
							$elm$html$Html$Attributes$attribute('data-on-populate')),
						config.onPopulate),
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'mapname', 'admin-dashboard-map'),
							A2($elm$html$Html$Attributes$attribute, 'apikey', $author$project$PinMeToUiConstants$awsMaps.apiKey),
							A2($elm$html$Html$Attributes$attribute, 'featurecollection', featureCollection),
							A2(
							$elm$html$Html$Attributes$attribute,
							'zoom',
							$author$project$PinMeTo$Ui$Map$zoomToString(config.zoom)),
							A2(
							$elm$html$Html$Attributes$attribute,
							'type',
							$author$project$PinMeTo$Ui$Map$mapTypeToString(config.mapType)),
							A2($elm$html$Html$Attributes$attribute, 'data-marker', $author$project$Env$paths.pmtUiPath + '/svg/map-markers/Blue_MasterData.svg')
						])))),
		$elm$core$Dict$values(
			A2(
				$elm$core$Dict$map,
				F2(
					function (id, _v1) {
						var content = _v1.content;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'slot', 'popover-' + id)
								]),
							_List_fromArray(
								[content]));
					}),
				config.customPopovers)));
};
var $author$project$ApiPendingChanges$Resolver$Data$Source$toString = function (x) {
	if (x.$ === 'Master') {
		return 'master';
	} else {
		return 'api';
	}
};
var $author$project$PinMeTo$Ui$Map$Zoom = function (a) {
	return {$: 'Zoom', a: a};
};
var $author$project$PinMeTo$Ui$Map$withZoom = F2(
	function (zoom, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Map$View(
			_Utils_update(
				config,
				{
					zoom: $author$project$PinMeTo$Ui$Map$Zoom(zoom)
				}));
	});
var $author$project$PinMeTo$Ui$Map$ApiMarker = {$: 'ApiMarker'};
var $author$project$PinMeTo$Ui$Map$pinWithId = F2(
	function (id, coordinates) {
		return $author$project$PinMeTo$Ui$Map$Pin(
			{id: id, marker: $elm$core$Maybe$Nothing, popover: $elm$core$Maybe$Nothing, draggable: false, coordinates: coordinates});
	});
var $author$project$PinMeTo$Ui$Map$withPinMarker = F2(
	function (marker, pin_) {
		if (pin_.$ === 'Pin') {
			var config = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Pin(
				_Utils_update(
					config,
					{
						marker: $elm$core$Maybe$Just(marker)
					}));
		} else {
			var feature = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Feature(feature);
		}
	});
var $author$project$PinMeTo$Ui$Map$withOnPopulate = F2(
	function (onPopulate, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Map$View(
			_Utils_update(
				config,
				{
					onPopulate: $elm$core$Maybe$Just(onPopulate)
				}));
	});
var $author$project$PinMeTo$Ui$Map$BlueCheckMarker = {$: 'BlueCheckMarker'};
var $author$project$PinMeTo$Ui$Map$CustomPinPopover = function (a) {
	return {$: 'CustomPinPopover', a: a};
};
var $author$project$PinMeTo$Ui$Map$withCustomPopover = F2(
	function (content, pin_) {
		if (pin_.$ === 'Pin') {
			var config = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Pin(
				_Utils_update(
					config,
					{
						popover: $elm$core$Maybe$Just(
							$author$project$PinMeTo$Ui$Map$CustomPinPopover(
								{content: content}))
					}));
		} else {
			var feature = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Feature(feature);
		}
	});
var $author$project$ApiPendingChanges$Resolver$Update$OnMapMarkerUseThis = function (a) {
	return {$: 'OnMapMarkerUseThis', a: a};
};
var $author$project$PinMeTo$Ui$Map$FitBoundsOnPopulate = {$: 'FitBoundsOnPopulate'};
var $author$project$ApiPendingChanges$Resolver$View$mapView = F3(
	function (translations, selected, location) {
		return $author$project$PinMeTo$Ui$Map$render(
			A2(
				$author$project$PinMeTo$Ui$Map$withOnPopulate,
				$author$project$PinMeTo$Ui$Map$FitBoundsOnPopulate,
				A2(
					$author$project$PinMeTo$Ui$Map$withZoom,
					15,
					$author$project$PinMeTo$Ui$Map$view(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									(A4($author$project$ApiPendingChanges$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$ApiPendingChanges$Resolver$Data$Source$Master, selected) ? $author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$BlueCheckMarker) : $author$project$PinMeTo$Ui$Map$withCustomPopover(
										$author$project$PinMeTo$Ui$Button$render(
											A2(
												$author$project$PinMeTo$Ui$Button$withOnClick,
												$author$project$ApiPendingChanges$Resolver$Update$OnMapMarkerUseThis($author$project$ApiPendingChanges$Resolver$Data$Source$Master),
												$author$project$PinMeTo$Ui$Button$buttonPrimary(
													$author$project$Translations$General$resolverUseThis(translations))))))(
										A2(
											$author$project$PinMeTo$Ui$Map$pinWithId,
											$author$project$ApiPendingChanges$Resolver$Data$Source$toString($author$project$ApiPendingChanges$Resolver$Data$Source$Master),
											location.coordinates))),
									A2(
									$elm$core$Maybe$map,
									function (coordinatesChange) {
										return (A4($author$project$ApiPendingChanges$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$ApiPendingChanges$Resolver$Data$Source$Api, selected) ? $author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$BlueCheckMarker) : A2(
											$elm$core$Basics$composeR,
											$author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$ApiMarker),
											$author$project$PinMeTo$Ui$Map$withCustomPopover(
												$author$project$PinMeTo$Ui$Button$render(
													A2(
														$author$project$PinMeTo$Ui$Button$withOnClick,
														$author$project$ApiPendingChanges$Resolver$Update$OnMapMarkerUseThis($author$project$ApiPendingChanges$Resolver$Data$Source$Api),
														$author$project$PinMeTo$Ui$Button$buttonPrimary(
															$author$project$Translations$General$resolverUseThis(translations)))))))(
											A2(
												$author$project$PinMeTo$Ui$Map$pinWithId,
												$author$project$ApiPendingChanges$Resolver$Data$Source$toString($author$project$ApiPendingChanges$Resolver$Data$Source$Api),
												coordinatesChange));
									},
									location.coordinatesChange)
								]))))));
	});
var $author$project$ApiPendingChanges$Resolver$View$wrapper = function (html) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-api-changes-resolver container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section')
					]),
				html)
			]));
};
var $author$project$Translations$Listings$ApiDifference$pageError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.page_error');
};
var $author$project$Translations$Listings$ApiDifference$apiChanges = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.api_changes');
};
var $author$project$Translations$General$cancel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.cancel');
};
var $author$project$Translations$General$update = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.update');
};
var $author$project$Translations$General$confirm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.confirm');
};
var $author$project$Translations$General$schedule = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.schedule');
};
var $justinmimbs$date$Date$RD = function (a) {
	return {$: 'RD', a: a};
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
				$elm$core$Basics$clamp,
				1,
				A2($justinmimbs$date$Date$daysInMonth, y, m),
				d));
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$PinMeTo$Ui$Lightbox$withStyle = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Lightbox$View(
			_Utils_update(
				config,
				{style: x}));
	});
var $author$project$PinMeTo$Ui$Lightbox$AlertStyle = {$: 'AlertStyle'};
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$language_en = {
	monthName: $justinmimbs$date$Date$monthToName,
	weekdayName: $justinmimbs$date$Date$weekdayToName,
	dayWithSuffix: $justinmimbs$date$Date$withOrdinalSuffix,
	monthNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	weekdayNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 'Literal', a: a};
};
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			var _v0 = thunk(_Utils_Tuple0);
			var parse = _v0.a;
			return parse(s);
		});
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$parser$Parser$Advanced$getOffset = $elm$parser$Parser$Advanced$Parser(
	function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, s.offset, s);
	});
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 'Expecting', a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(_Utils_Tuple0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq(
									_Utils_chr('\'')))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq(
								_Utils_chr('\'')))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\u0027');
				},
				$elm$parser$Parser$token('\u0027\u0027')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq(
				_Utils_chr('\'')))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq(
						_Utils_chr('\''))),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (!_Utils_eq(
		_char,
		_Utils_chr('\''))) && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 'Literal') && _v0.b.b) && (_v0.b.a.$ === 'Literal')) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\u0027')),
	$elm$parser$Parser$token('\u0027\u0027'));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0.a;
	var y = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd));
	return {
		year: y,
		ordinalDay: rd - $justinmimbs$date$Date$daysBeforeYear(y)
	};
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Jan;
		case 2:
			return $elm$time$Time$Feb;
		case 3:
			return $elm$time$Time$Mar;
		case 4:
			return $elm$time$Time$Apr;
		case 5:
			return $elm$time$Time$May;
		case 6:
			return $elm$time$Time$Jun;
		case 7:
			return $elm$time$Time$Jul;
		case 8:
			return $elm$time$Time$Aug;
		case 9:
			return $elm$time$Time$Sep;
		case 10:
			return $elm$time$Time$Oct;
		case 11:
			return $elm$time$Time$Nov;
		default:
			return $elm$time$Time$Dec;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {day: d, year: y, month: m};
			}
		}
	});
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0.a;
	var date = $justinmimbs$date$Date$toOrdinalDate(
		$justinmimbs$date$Date$RD(rd));
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.year, $elm$time$Time$Jan, date.ordinalDay);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.day;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.month;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0.a;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return $elm$time$Time$Mon;
		case 2:
			return $elm$time$Time$Tue;
		case 3:
			return $elm$time$Time$Wed;
		case 4:
			return $elm$time$Time$Thu;
		case 5:
			return $elm$time$Time$Fri;
		case 6:
			return $elm$time$Time$Sat;
		default:
			return $elm$time$Time$Sun;
	}
};
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(jan4));
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0.a;
	var wdn = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$RD(rd));
	var wy = $justinmimbs$date$Date$year(
		$justinmimbs$date$Date$RD(rd + (4 - wdn)));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		weekday: $justinmimbs$date$Date$numberToWeekday(wdn),
		weekYear: wy,
		weekNumber: 1 + (((rd - week1Day1) / 7) | 0)
	};
};
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekYear;
	});
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ordinalDay;
	});
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekNumber;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				_Utils_chr('0'),
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char.valueOf()) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.monthNameShort(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.monthName(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.monthNameShort(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.dayWithSuffix(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							_Utils_chr('0'),
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.weekdayName(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.weekdayNameShort(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4(
							$justinmimbs$date$Date$formatField,
							language,
							_Utils_chr('E'),
							length,
							date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (token.$ === 'Field') {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Translations$Listings$LocationDetail$confirmUpdateMany = F2(
	function (translations, locationAmount) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.confirm_update_many',
			_List_fromArray(
				[
					_Utils_Tuple2('locationAmount', locationAmount)
				]));
	});
var $author$project$Translations$Listings$LocationDetail$confirmScheduleMany = F4(
	function (translations, fieldName, locationAmount, dateString) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.confirm_schedule_many',
			_List_fromArray(
				[
					_Utils_Tuple2('fieldName', fieldName),
					_Utils_Tuple2('locationAmount', locationAmount),
					_Utils_Tuple2('dateString', dateString)
				]));
	});
var $author$project$Translations$Listings$LocationDetail$confirmDeleteScheduleMany = F3(
	function (translations, locationAmount, dateString) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.confirm_delete_schedule_many',
			_List_fromArray(
				[
					_Utils_Tuple2('locationAmount', locationAmount),
					_Utils_Tuple2('dateString', dateString)
				]));
	});
var $author$project$Location$Details$Editor$Confirm$view = F3(
	function (session, config, confirm) {
		var _v0 = function () {
			switch (confirm.$) {
				case 'ConfirmedUpdateSelectedLocations':
					var locationsList = confirm.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Translations$Listings$LocationDetail$confirmUpdateMany,
							session.translations,
							$elm$core$String$fromInt(
								$elm$core$List$length(locationsList))),
						$author$project$Translations$General$update(session.translations),
						$author$project$PinMeTo$Ui$Btn$pmtBtn);
				case 'ConfirmedScheduleSelectedLocations':
					var locationsList = confirm.a;
					var date = confirm.b;
					var fieldName = confirm.c;
					return _Utils_Tuple3(
						A4(
							$author$project$Translations$Listings$LocationDetail$confirmScheduleMany,
							session.translations,
							fieldName,
							$elm$core$String$fromInt(
								$elm$core$List$length(locationsList)),
							$justinmimbs$date$Date$toIsoString(
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, date))),
						$author$project$Translations$General$schedule(session.translations),
						$author$project$PinMeTo$Ui$Btn$pmtBtn);
				default:
					var locationsList = confirm.a;
					var date = confirm.b;
					return _Utils_Tuple3(
						A3(
							$author$project$Translations$Listings$LocationDetail$confirmDeleteScheduleMany,
							session.translations,
							$elm$core$String$fromInt(
								$elm$core$List$length(locationsList)),
							$justinmimbs$date$Date$toIsoString(
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, date))),
						$author$project$Translations$General$delete(session.translations),
						$author$project$PinMeTo$Ui$Btn$pmtBtnNegative);
			}
		}();
		var translationMessage = _v0.a;
		var buttonLabel = _v0.b;
		var confirmButton = _v0.c;
		return $author$project$PinMeTo$Ui$Lightbox$render(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withFooter,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-btn-group')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(config.onCancel)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$cancel(session.translations))
								])),
							A3(
							confirmButton,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									config.onConfirm(confirm)),
									$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('pmt-listings-confirm-update')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonLabel)
								]))
						])),
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withStyle,
					$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
					$author$project$PinMeTo$Ui$Lightbox$view(
						{
							title: $author$project$Translations$General$confirm(session.translations),
							content: A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'padding', '1em 2em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(translationMessage)
									]))
						}))));
	});
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Location$Details$PopupContent$SpecialOpenHours$LDP = {$: 'LDP'};
var $author$project$PinMeTo$Ui$Layout$Flex$flex = {
	gap: $elm$core$Maybe$Nothing,
	wrap: $elm$core$Maybe$Nothing,
	align: $elm$core$Maybe$Nothing,
	margin: {top: $elm$core$Maybe$Nothing, left: $elm$core$Maybe$Nothing, right: $elm$core$Maybe$Nothing, bottom: $elm$core$Maybe$Nothing},
	justify: $elm$core$Maybe$Nothing,
	padding: {top: $elm$core$Maybe$Nothing, left: $elm$core$Maybe$Nothing, right: $elm$core$Maybe$Nothing, bottom: $elm$core$Maybe$Nothing},
	direction: $elm$core$Maybe$Nothing,
	attributes: _List_Nil
};
var $author$project$PinMeTo$Ui$PopOver$defaultViewportPadding = {top: 75 + 10, left: 10, right: 10, bottom: 10};
var $author$project$PinMeTo$Ui$PopOver$view = function (config) {
	return {uid: config.uid, link: $elm$core$Maybe$Nothing, inset: $author$project$PinMeTo$Ui$PopOver$defaultViewportPadding, tagger: config.tagger, content: config.content, preferredDirection: config.preferredDirection};
};
var $author$project$Location$Details$PopupContent$Wifi$Update = function (a) {
	return {$: 'Update', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$wifiSsid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.wifi_ssid');
};
var $author$project$PinMeTo$Ui$Form$Input$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$NoError = {$: 'NoError'};
var $author$project$PinMeTo$Ui$Form$Input$withError = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					errorMessage: $elm$core$Maybe$Just(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$PinMeTo$Ui$Form$Input$NoError,
							A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Form$Input$Error, x)))
				}));
	});
var $zwilias$elm_utf_tools$String$UTF16$length = $elm$core$String$length;
var $author$project$Location$Details$PopupContent$Wifi$wordCount = function (model) {
	var _v0 = model.wifi;
	var wifi = _v0.a;
	return $zwilias$elm_utf_tools$String$UTF16$length(wifi);
};
var $author$project$Location$Details$PopupContent$Wifi$countLimit = 31;
var $author$project$Translations$Listings$LocationDetail$PopUpContent$wifiNameInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.wifi_name_invalid');
};
var $author$project$Location$Details$PopupContent$Wifi$view = F2(
	function (translations, model) {
		var _v0 = (_Utils_cmp(
			$author$project$Location$Details$PopupContent$Wifi$wordCount(model),
			$author$project$Location$Details$PopupContent$Wifi$countLimit) < 1) ? _Utils_Tuple2('form__word-count form__word-count-align-old', $elm$core$Maybe$Nothing) : _Utils_Tuple2(
			'form__word-count form__word-count-align-old form__error',
			$elm$core$Maybe$Just(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$wifiNameInvalid(translations)));
		var wordCountClass = _v0.a;
		var error = _v0.b;
		var _v1 = model.wifi;
		var wifi = _v1.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withError,
								error,
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
									$author$project$Translations$Listings$LocationDetail$PopUpContent$wifiSsid(translations),
									$author$project$PinMeTo$Ui$Form$Input$text(
										{value: wifi, onChange: $author$project$Location$Details$PopupContent$Wifi$Update}))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(wordCountClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Location$Details$PopupContent$Wifi$wordCount(model)) + ('/' + $elm$core$String$fromInt($author$project$Location$Details$PopupContent$Wifi$countLimit)))
						]))
				]));
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Location$Details$PopupContent$Phone$pattern = '^\u005Cs*(?:\u005C+?(\u005Cd{2,4}))?[- (]*(\u005Cd{0,3})[- )]*(\u005Cd{0,3})[- )]*(\u005Cd{0,3})[- ]*(\u005Cd{0,4})(?: *x(\u005Cd+))?\u005Cs*$';
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{multiline: false, caseInsensitive: false},
		string);
};
var $author$project$Location$Details$PopupContent$Phone$maybeRegex = $elm$regex$Regex$fromString($author$project$Location$Details$PopupContent$Phone$pattern);
var $author$project$Location$Details$PopupContent$Phone$regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $author$project$Location$Details$PopupContent$Phone$maybeRegex);
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Location$Details$PopupContent$Phone$checkRegex = function (phone) {
	return A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$Phone$regex, phone) ? true : false;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$phoneInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.phone_invalid');
};
var $author$project$Location$Details$PopupContent$Phone$checkMinLength = function (input) {
	return (!$elm$core$String$length(input)) ? true : false;
};
var $author$project$Location$Details$PopupContent$Phone$validationErrors = F2(
	function (translations, model) {
		var list = _List_Nil;
		return ((!$author$project$Location$Details$PopupContent$Phone$checkMinLength(model.phoneNumberString)) && (!$author$project$Location$Details$PopupContent$Phone$checkRegex(model.phoneNumberString))) ? A2(
			$elm$core$List$cons,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$phoneInvalid(translations),
			list) : list;
	});
var $author$project$Location$Details$PopupContent$Phone$UpdatePhoneNumber = function (a) {
	return {$: 'UpdatePhoneNumber', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$phonePlaceholderText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.phone_placeholder_text');
};
var $author$project$Location$Details$PopupContent$Phone$view = F2(
	function (translations, model) {
		var validationErrors_ = A2($author$project$Location$Details$PopupContent$Phone$validationErrors, translations, model);
		var errorToShow = $elm$core$List$head(validationErrors_);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withError,
						errorToShow,
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
							$author$project$Translations$Listings$LocationDetail$PopUpContent$phonePlaceholderText(translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{value: model.phoneNumberString, onChange: $author$project$Location$Details$PopupContent$Phone$UpdatePhoneNumber}))))
				]));
	});
var $author$project$Data$Location$Active = {$: 'Active'};
var $author$project$PinMeTo$Ui$Form$Checkbox$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-checkbox'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-ui-checkbox--disabled', config.disabled)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$disabled(config.disabled),
						$elm$html$Html$Attributes$checked(config.checked),
						$elm$html$Html$Events$onCheck(config.onChange)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-checkbox__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.label)
					]))
			]));
};
var $author$project$Data$Location$Inactive = {$: 'Inactive'};
var $author$project$Location$Details$PopupContent$Active$OnChange = function (a) {
	return {$: 'OnChange', a: a};
};
var $author$project$PinMeTo$Ui$Form$Checkbox$Checkbox = function (a) {
	return {$: 'Checkbox', a: a};
};
var $author$project$PinMeTo$Ui$Form$Checkbox$checkbox = function (_v0) {
	var onChange = _v0.onChange;
	var checked = _v0.checked;
	var label = _v0.label;
	return $author$project$PinMeTo$Ui$Form$Checkbox$Checkbox(
		{label: label, checked: checked, disabled: false, onChange: onChange});
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$activeInputText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.active_input_text');
};
var $author$project$Location$Details$PopupContent$Active$view = F2(
	function (translations, model) {
		return $author$project$PinMeTo$Ui$Form$Checkbox$render(
			$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
				{
					label: $author$project$Translations$Listings$LocationDetail$PopUpContent$activeInputText(translations),
					checked: _Utils_eq(model.isActive, $author$project$Data$Location$Active),
					onChange: function (checked) {
						return checked ? $author$project$Location$Details$PopupContent$Active$OnChange($author$project$Data$Location$Active) : $author$project$Location$Details$PopupContent$Active$OnChange($author$project$Data$Location$Inactive);
					}
				}));
	});
var $author$project$PinMeTo$Ui$Chip$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Chip$view = function (label) {
	return $author$project$PinMeTo$Ui$Chip$View(
		{icon: $elm$core$Maybe$Nothing, color: $elm$core$Maybe$Nothing, label: label, action: $elm$core$Maybe$Nothing});
};
var $author$project$Listings$Ui$AutoComplete$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$Listings$Ui$AutoComplete$view = F2(
	function (tagger, nodeId) {
		return $author$project$Listings$Ui$AutoComplete$Config(
			{label: $elm$core$Maybe$Nothing, nodeId: nodeId, tagger: tagger, hasError: false, isReadOnly: false, isRequired: false, placeholder: $elm$core$Maybe$Nothing, doFindMatches: false, requiredLabel: $elm$core$Maybe$Nothing});
	});
var $author$project$Listings$Ui$AutoComplete$NodeId = function (a) {
	return {$: 'NodeId', a: a};
};
var $author$project$PinMeTo$Ui$Chip$Chevron = {$: 'Chevron'};
var $author$project$FontAwesome$Regular$Icon$faXmark = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-xmark');
var $author$project$FontAwesome$Regular$faXmark = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faXmark);
var $author$project$PinMeTo$Ui$Chip$NewColor = {$: 'NewColor'};
var $author$project$PinMeTo$Ui$Chip$AppPostsColor = {$: 'AppPostsColor'};
var $author$project$FontAwesome$Regular$Icon$faChevronDown = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-chevron-down');
var $author$project$FontAwesome$Regular$faChevronDown = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faChevronDown);
var $author$project$PinMeTo$Ui$Chip$AppPlacesColor = {$: 'AppPlacesColor'};
var $author$project$PinMeTo$Ui$Chip$AppListingsColor = {$: 'AppListingsColor'};
var $author$project$PinMeTo$Ui$Chip$MixedSentimentColor = {$: 'MixedSentimentColor'};
var $author$project$PinMeTo$Ui$Chip$AppConversationsColor = {$: 'AppConversationsColor'};
var $author$project$PinMeTo$Ui$Chip$NeutralSentimentColor = {$: 'NeutralSentimentColor'};
var $author$project$PinMeTo$Ui$Chip$NegativeSentimentColor = {$: 'NegativeSentimentColor'};
var $author$project$PinMeTo$Ui$Chip$PositiveSentimentColor = {$: 'PositiveSentimentColor'};
var $author$project$PinMeTo$Ui$Chip$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-chip'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-ui-chip--with-icon',
						!_Utils_eq(config.icon, $elm$core$Maybe$Nothing)),
						_Utils_Tuple2(
						'pmt-ui-chip--with-action',
						!_Utils_eq(config.action, $elm$core$Maybe$Nothing)),
						_Utils_Tuple2(
						'pmt-ui-chip--with-chevron',
						_Utils_eq(
							config.action,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$Chevron))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-positive-sentiment',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$PositiveSentimentColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-negative-sentiment',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$NegativeSentimentColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-neutral-sentiment',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$NeutralSentimentColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-mixed-sentiment',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$MixedSentimentColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-new',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$NewColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-listings',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$AppListingsColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-posts',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$AppPostsColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-conversations',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$AppConversationsColor))),
						_Utils_Tuple2(
						'pmt-ui-chip--color-places',
						_Utils_eq(
							config.color,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chip$AppPlacesColor)))
					]))
			]),
		_List_fromArray(
			[
				function () {
				var _v1 = config.icon;
				if (_v1.$ === 'Just') {
					var icon = _v1.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-chip__icon')
							]),
						_List_fromArray(
							[
								$author$project$FontAwesome$Light$Icon$render(icon)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-chip__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.label)
					])),
				function () {
				var _v2 = config.action;
				if (_v2.$ === 'Just') {
					if (_v2.a.$ === 'OnDelete') {
						var onDelete = _v2.a.a;
						return A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-chip__action'),
									$elm$html$Html$Events$onClick(onDelete)
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Regular$faXmark]));
					} else {
						var _v3 = _v2.a;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-chip__action')
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Regular$faChevronDown]));
					}
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Listings$Ui$AutoComplete$idString = function (_v0) {
	var s = _v0.a;
	return s;
};
var $author$project$Listings$Ui$AutoComplete$anchorName = function (nodeId) {
	return '--search-input-' + $author$project$Listings$Ui$AutoComplete$idString(nodeId);
};
var $author$project$Common$Form$unwrapFormState = function (formState) {
	if (formState.$ === 'Clean') {
		var val = formState.a;
		return val;
	} else {
		var val = formState.a;
		return val;
	}
};
var $author$project$Listings$Ui$AutoComplete$findMatches = function (model) {
	var unwrappedInput = $author$project$Common$Form$unwrapFormState(model.inputValue);
	if ($elm$core$String$length(unwrappedInput) > 0) {
		var find = function (_v0) {
			var value = _v0.a;
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(unwrappedInput),
				$elm$core$String$toLower(value));
		};
		var matches = A2($elm$core$List$filter, find, model.values);
		return $elm$core$Maybe$Just(matches);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Listings$Ui$AutoComplete$Enter = {$: 'Enter'};
var $author$project$Listings$Ui$AutoComplete$Leave = {$: 'Leave'};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$Listings$Ui$AutoComplete$Noop = {$: 'Noop'};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Listings$Ui$AutoComplete$Select = function (a) {
	return {$: 'Select', a: a};
};
var $author$project$Listings$Ui$AutoComplete$InputFocus = function (a) {
	return {$: 'InputFocus', a: a};
};
var $author$project$Listings$Ui$AutoComplete$SelectByIndex = F2(
	function (a, b) {
		return {$: 'SelectByIndex', a: a, b: b};
	});
var $author$project$Listings$Ui$AutoComplete$onKeyDown = F2(
	function (model, matches) {
		var selectByIndex = function (index) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Maybe$Nothing,
				function (m) {
					return $elm$core$List$head(
						A2($elm$core$List$drop, index, m));
				},
				matches);
		};
		var handleKeyDown = function (key) {
			switch (key) {
				case 13:
					return $elm$json$Json$Decode$succeed(
						$author$project$Listings$Ui$AutoComplete$Select(
							selectByIndex(
								A2($elm$core$Maybe$withDefault, 0, model.index))));
				case 27:
					return $elm$json$Json$Decode$succeed(
						$author$project$Listings$Ui$AutoComplete$InputFocus($author$project$Listings$Ui$AutoComplete$Leave));
				case 38:
					var index = A2($elm$core$Maybe$withDefault, -1, model.index);
					if (index > 0) {
						var newIndex = index - 1;
						return $elm$json$Json$Decode$succeed(
							A2(
								$author$project$Listings$Ui$AutoComplete$SelectByIndex,
								selectByIndex(newIndex),
								newIndex));
					} else {
						return $elm$json$Json$Decode$succeed($author$project$Listings$Ui$AutoComplete$Noop);
					}
				case 40:
					var nrOfMatches = $elm$core$List$length(
						A2($elm$core$Maybe$withDefault, _List_Nil, matches));
					var newIndex = A2($elm$core$Maybe$withDefault, -1, model.index) + 1;
					return (_Utils_cmp(newIndex, nrOfMatches) < 0) ? $elm$json$Json$Decode$succeed(
						A2(
							$author$project$Listings$Ui$AutoComplete$SelectByIndex,
							selectByIndex(newIndex),
							newIndex)) : $elm$json$Json$Decode$succeed($author$project$Listings$Ui$AutoComplete$Noop);
				case 9:
					var nrOfMatches = $elm$core$List$length(
						A2($elm$core$Maybe$withDefault, _List_Nil, matches));
					var newIndex = A2($elm$core$Maybe$withDefault, -1, model.index) + 1;
					return (_Utils_cmp(newIndex, nrOfMatches) < 0) ? $elm$json$Json$Decode$succeed(
						A2(
							$author$project$Listings$Ui$AutoComplete$SelectByIndex,
							selectByIndex(newIndex),
							newIndex)) : $elm$json$Json$Decode$fail('No more items to select');
				default:
					return $elm$json$Json$Decode$fail('unhandled key');
			}
		};
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			'keydown',
			A2(
				$elm$json$Json$Decode$map,
				function (x) {
					return A2($elm$core$Tuple$pair, x, true);
				},
				A2($elm$json$Json$Decode$andThen, handleKeyDown, $elm$html$Html$Events$keyCode)));
	});
var $author$project$Listings$Ui$AutoComplete$InputChange = function (a) {
	return {$: 'InputChange', a: a};
};
var $author$project$Listings$Ui$AutoComplete$Clear = {$: 'Clear'};
var $author$project$Listings$Ui$AutoComplete$renderIcons = F2(
	function (model, hasError) {
		var clear = !(!$elm$core$String$length(
			$author$project$Common$Form$unwrapFormState(model.inputValue)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-input__icons')
				]),
			_List_fromArray(
				[
					clear ? A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-input__icon pmt-ui-input__icon--clear'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Events$onClick($author$project$Listings$Ui$AutoComplete$Clear)
						]),
					_List_fromArray(
						[$author$project$FontAwesome$Solid$faX])) : $elm$html$Html$text(''),
					hasError ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-input__icon pmt-ui-input__icon--error')
						]),
					_List_fromArray(
						[$author$project$FontAwesome$Solid$faCircleExclamation])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Listings$Ui$AutoComplete$isUncleanRequiredAndUnfocused = F2(
	function (model, _v0) {
		var config = _v0.a;
		var _v1 = _Utils_Tuple2(
			_Utils_Tuple2(model.inputValue, model.selected),
			_Utils_Tuple2(config.isRequired, model.visible));
		if ((((_v1.a.a.$ === 'Edited') && (_v1.a.b.$ === 'Nothing')) && _v1.b.a) && (!_v1.b.b)) {
			var _v2 = _v1.a;
			var _v3 = _v2.b;
			var _v4 = _v1.b;
			return true;
		} else {
			return false;
		}
	});
var $author$project$Listings$Ui$AutoComplete$renderInput = F2(
	function (model, _v0) {
		var config = _v0.a;
		var hasError = config.hasError || A2(
			$author$project$Listings$Ui$AutoComplete$isUncleanRequiredAndUnfocused,
			model,
			$author$project$Listings$Ui$AutoComplete$Config(config));
		var matches = config.doFindMatches ? $author$project$Listings$Ui$AutoComplete$findMatches(model) : $elm$core$Maybe$Just(model.values);
		var select = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-input__field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-ui-input__field--error', hasError)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-input__input'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('error', hasError)
									])),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$id(
								$author$project$Listings$Ui$AutoComplete$idString(config.nodeId)),
								$elm$html$Html$Attributes$autocomplete(false),
								$elm$html$Html$Attributes$value(
								$author$project$Common$Form$unwrapFormState(model.inputValue)),
								$elm$html$Html$Events$onInput($author$project$Listings$Ui$AutoComplete$InputChange),
								$elm$html$Html$Events$onFocus(
								$author$project$Listings$Ui$AutoComplete$InputFocus($author$project$Listings$Ui$AutoComplete$Enter)),
								$elm$html$Html$Events$onBlur(
								$author$project$Listings$Ui$AutoComplete$InputFocus($author$project$Listings$Ui$AutoComplete$Leave)),
								A2($author$project$Listings$Ui$AutoComplete$onKeyDown, model, matches),
								$elm$html$Html$Attributes$readonly(config.isReadOnly)
							]),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (x) {
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder(x)
									]);
							},
							config.placeholder)),
					_List_Nil),
					A2($author$project$Listings$Ui$AutoComplete$renderIcons, model, hasError)
				]));
		return select;
	});
var $author$project$Listings$Ui$AutoComplete$Selectable = function (a) {
	return {$: 'Selectable', a: a};
};
var $author$project$Listings$Ui$AutoComplete$isSelected = F2(
	function (selected, value) {
		if (selected.$ === 'Just') {
			var s = selected.a;
			return _Utils_eq(s, value);
		} else {
			return false;
		}
	});
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Listings$Ui$AutoComplete$renderMatches = F3(
	function (nodeId, model, matches) {
		if (model.visible) {
			if (matches.$ === 'Just') {
				var matches_ = matches.a;
				return ($elm$core$List$length(matches_) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-listings-autocomplete--results-container'),
							A2(
							$elm$html$Html$Attributes$style,
							'position-anchor',
							$author$project$Listings$Ui$AutoComplete$anchorName(nodeId))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (_v1) {
									var match = _v1.a;
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'selected',
														A2(
															$author$project$Listings$Ui$AutoComplete$isSelected,
															model.selected,
															$author$project$Listings$Ui$AutoComplete$Selectable(match)))
													])),
												$elm$html$Html$Events$onMouseDown(
												$author$project$Listings$Ui$AutoComplete$Select(
													$elm$core$Maybe$Just(
														$author$project$Listings$Ui$AutoComplete$Selectable(match))))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(match)
											]));
								},
								matches_))
						])) : $elm$html$Html$text('');
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Listings$Ui$AutoComplete$renderErrorMessage = function (errorMessage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-input__message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(errorMessage)
			]));
};
var $author$project$Listings$Ui$AutoComplete$render = F2(
	function (model, _v0) {
		var config = _v0.a;
		var _v1 = function () {
			var _v2 = config.label;
			if (_v2.$ === 'Just') {
				var label_ = _v2.a;
				return _Utils_Tuple2(
					$elm$html$Html$label,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-input__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label_),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-input__required')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										config.isRequired ? ' *' : '')
									]))
							])));
			} else {
				return _Utils_Tuple2(
					$elm$html$Html$div,
					$elm$html$Html$text(''));
			}
		}();
		var tag = _v1.a;
		var label = _v1.b;
		var matches = config.doFindMatches ? $author$project$Listings$Ui$AutoComplete$findMatches(model) : $elm$core$Maybe$Just(model.values);
		return A2(
			$elm$html$Html$map,
			config.tagger,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-input pmt-listings-autocomplete'),
								A2(
								$elm$html$Html$Attributes$style,
								'anchor-name',
								$author$project$Listings$Ui$AutoComplete$anchorName(config.nodeId))
							]),
						_List_fromArray(
							[
								A2(
								tag,
								_List_Nil,
								_List_fromArray(
									[
										label,
										A2(
										$author$project$Listings$Ui$AutoComplete$renderInput,
										model,
										$author$project$Listings$Ui$AutoComplete$Config(config)),
										A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2(
											$elm$core$Maybe$andThen,
											function (l) {
												return A2(
													$author$project$Listings$Ui$AutoComplete$isUncleanRequiredAndUnfocused,
													model,
													$author$project$Listings$Ui$AutoComplete$Config(config)) ? $elm$core$Maybe$Just(
													$author$project$Listings$Ui$AutoComplete$renderErrorMessage(l)) : $elm$core$Maybe$Nothing;
											},
											config.requiredLabel)),
										A3($author$project$Listings$Ui$AutoComplete$renderMatches, config.nodeId, model, matches)
									]))
							]))
					])));
	});
var $author$project$Location$Details$PopupContent$Address$fieldLabel = F2(
	function (label, required) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__input-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-input__required')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							required ? ' *' : '')
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Chip$OnDelete = function (a) {
	return {$: 'OnDelete', a: a};
};
var $author$project$PinMeTo$Ui$Chip$withDelete = F2(
	function (onDelete, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Chip$View(
			_Utils_update(
				config,
				{
					action: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Chip$OnDelete(onDelete))
				}));
	});
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList = function (lst) {
	switch (lst.$) {
		case 'EmptyList':
			return _List_Nil;
		case 'AddableList':
			var xs = lst.a;
			return xs;
		case 'FullList':
			var xs = lst.a;
			return xs;
		default:
			return _List_Nil;
	}
};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$maxServiceArea = 20;
var $author$project$Listings$Ui$AutoComplete$withIsRequired = F2(
	function (isRequired, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{isRequired: isRequired}));
	});
var $author$project$Listings$Ui$AutoComplete$withPlaceholder = F2(
	function (label, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{
					placeholder: $elm$core$Maybe$Just(label)
				}));
	});
var $author$project$Common$ServiceAreaSelectorV2$Types$RemoveServiceArea = function (a) {
	return {$: 'RemoveServiceArea', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$Types$UiAutoCompleteMsg = function (a) {
	return {$: 'UiAutoCompleteMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$selectServiceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.select_service_areas');
};
var $author$project$Translations$Listings$LocationDetail$maxTwentyServiceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.max_twenty_service_areas');
};
var $author$project$Location$Details$PopupContent$Address$ServiceAreaSelectorMsg = function (a) {
	return {$: 'ServiceAreaSelectorMsg', a: a};
};
var $author$project$Translations$Listings$AddLocation$serviceAreasPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.service_areas_placeholder');
};
var $author$project$Location$Details$PopupContent$Address$serviceAreaView = F2(
	function (translations, model) {
		var selectedAreas = $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
			$author$project$Common$Form$unwrapFormState(model.serviceAreaSelector.selectedServiceAreas));
		var input_ = A2(
			$author$project$Listings$Ui$AutoComplete$render,
			model.serviceAreaSelector.uiAutoComplete,
			A2(
				$author$project$Listings$Ui$AutoComplete$withIsRequired,
				true,
				A2(
					$author$project$Listings$Ui$AutoComplete$withPlaceholder,
					$author$project$Translations$Listings$AddLocation$serviceAreasPlaceholder(translations),
					A2(
						$author$project$Listings$Ui$AutoComplete$view,
						A2($elm$core$Basics$composeL, $author$project$Location$Details$PopupContent$Address$ServiceAreaSelectorMsg, $author$project$Common$ServiceAreaSelectorV2$Types$UiAutoCompleteMsg),
						$author$project$Listings$Ui$AutoComplete$NodeId('address-service-area-selector')))));
		var chips = A2(
			$elm$core$List$map,
			function (area) {
				return $author$project$PinMeTo$Ui$Chip$render(
					A2(
						$author$project$PinMeTo$Ui$Chip$withDelete,
						$author$project$Location$Details$PopupContent$Address$ServiceAreaSelectorMsg(
							$author$project$Common$ServiceAreaSelectorV2$Types$RemoveServiceArea(area)),
						$author$project$PinMeTo$Ui$Chip$view(area.area)));
			},
			selectedAreas);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__input-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Location$Details$PopupContent$Address$fieldLabel,
					$author$project$Translations$Listings$LocationDetail$selectServiceAreas(translations),
					true),
					input_,
					(_Utils_cmp(
					$elm$core$List$length(selectedAreas),
					$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$maxServiceArea) > 0) ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__input-error')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$maxTwentyServiceAreas(translations))
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__selected-categories')
						]),
					chips)
				]));
	});
var $author$project$Location$Details$PopupContent$Address$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$Ui$PopOver$Open = F2(
	function (a, b) {
		return {$: 'Open', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$PopOver$targetId = function (uid) {
	return 'pmt-ui-popOver-target-' + uid;
};
var $author$project$PinMeTo$Ui$PopOver$Close = function (a) {
	return {$: 'Close', a: a};
};
var $author$project$PinMeTo$Ui$PopOver$cardId = function (uid) {
	return 'pmt-ui-popOver-' + uid;
};
var $author$project$PinMeTo$Ui$PopOver$resizedAttributes = F2(
	function (cardFitToViewport, attributes) {
		if (cardFitToViewport.$ === 'Opening') {
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromFloat(0) + 'px'),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'top',
						$elm$core$String$fromFloat(0) + 'px'),
					attributes));
		} else {
			if (cardFitToViewport.a.$ === 'Sheet') {
				var _v1 = cardFitToViewport.a;
				return A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('pmt-ui-popOver__card--sheet'),
					attributes);
			} else {
				var coordinates = cardFitToViewport.b;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'left',
						$elm$core$String$fromFloat(coordinates.x) + 'px'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat(coordinates.y) + 'px'),
						attributes));
			}
		}
	});
var $author$project$PinMeTo$Ui$PopOver$renderCard = F2(
	function (model, config) {
		var visibilityAttributes = F2(
			function (card, attributes) {
				if (card.$ === 'Opening') {
					return A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$style, 'visibility', 'hidden'),
						attributes);
				} else {
					return attributes;
				}
			});
		var link = function () {
			var _v1 = config.link;
			if (_v1.$ === 'Just') {
				var link_ = _v1.a;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-note'),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$href(link_.href)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(link_.text)
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var _v0 = model.card;
		if (_v0.$ === 'Just') {
			var card = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'inline-flex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-popOver__backdrop'),
								$elm$html$Html$Events$onClick(
								config.tagger(
									$author$project$PinMeTo$Ui$PopOver$Close(config.uid)))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						A2(
							$author$project$PinMeTo$Ui$PopOver$resizedAttributes,
							card,
							A2(
								visibilityAttributes,
								card,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(
										$author$project$PinMeTo$Ui$PopOver$cardId(config.uid)),
										$elm$html$Html$Attributes$class('pmt-ui-popOver__card')
									]))),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-popOver__card--close'),
										$elm$html$Html$Events$onClick(
										config.tagger(
											$author$project$PinMeTo$Ui$PopOver$Close(config.uid)))
									]),
								_List_fromArray(
									[$author$project$FontAwesome$Regular$faXmark])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-popOver__card--scroll')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-popOver__card--content pmt-ui-font-note')
											]),
										config.content),
										link
									]))
							]))
					]));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$FontAwesome$Regular$Icon$faCircleQuestion = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-circle-question');
var $author$project$FontAwesome$Regular$faCircleQuestion = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faCircleQuestion);
var $author$project$PinMeTo$Ui$PopOver$renderPlain = F2(
	function (_v0, config) {
		var model = _v0.a;
		var clickAttribute = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
				$elm$html$Html$Events$onClick(
				config.tagger(
					A2($author$project$PinMeTo$Ui$PopOver$Open, config.uid, config.preferredDirection))),
				$elm$html$Html$Attributes$id(
				$author$project$PinMeTo$Ui$PopOver$targetId(config.uid)),
				$elm$html$Html$Attributes$class('pmt-ui-popOver__target')
			]);
		var popOver = _Utils_eq(
			config.uid,
			A2($elm$core$Maybe$withDefault, '', model.openPopOver)) ? A2($author$project$PinMeTo$Ui$PopOver$renderCard, model, config) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					clickAttribute,
					_List_fromArray(
						[$author$project$FontAwesome$Regular$faCircleQuestion])),
					popOver
				]));
	});
var $author$project$Translations$General$locationType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_type');
};
var $author$project$Location$Details$PopupContent$Address$SelectBusinessType = function (a) {
	return {$: 'SelectBusinessType', a: a};
};
var $author$project$Translations$General$storefront = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.storefront');
};
var $author$project$Translations$General$serviceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.service_area');
};
var $author$project$Translations$General$storefrontAndServiceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.storefront_and_service_area');
};
var $author$project$Location$Details$PopupContent$Address$locationTypeToString = F2(
	function (locationType, translations) {
		switch (locationType.$) {
			case 'Storefront':
				return $author$project$Translations$General$storefront(translations);
			case 'StorefrontAndServiceArea':
				return $author$project$Translations$General$storefrontAndServiceArea(translations);
			default:
				return $author$project$Translations$General$serviceArea(translations);
		}
	});
var $author$project$PinMeTo$Ui$Select$withFullWidthInputToggle = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Select$Config(
		_Utils_update(
			config,
			{toggleStyle: $author$project$PinMeTo$Ui$Select$FullWidthInput}));
};
var $author$project$PinMeTo$Ui$PopOver$BottomRight = {$: 'BottomRight'};
var $author$project$Translations$Listings$AddLocation$popOverStorefront = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_storefront');
};
var $author$project$Translations$Listings$AddLocation$popOverServiceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_service_area');
};
var $author$project$Translations$Listings$AddLocation$popOverStorefrontBold = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_storefront_bold');
};
var $author$project$Location$Details$PopupContent$Address$BusinessTypePopOverMsg = function (a) {
	return {$: 'BusinessTypePopOverMsg', a: a};
};
var $author$project$Translations$Listings$AddLocation$popOverServiceAreaBold = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_service_area_bold');
};
var $author$project$Translations$Listings$AddLocation$popOverStorefrontAndServiceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_storefront_and_service_area');
};
var $author$project$Translations$Listings$AddLocation$popOverStorefrontAndServiceAreaBold = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_storefront_and_service_area_bold');
};
var $author$project$Location$Details$PopupContent$Address$businessTypePopOverConfig = F2(
	function (translations, isLockedToServiceArea) {
		var storeFrontAndServiceArea = _List_fromArray(
			[
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$AddLocation$popOverStorefrontBold(translations))
					])),
				$elm$html$Html$text(
				$author$project$Translations$Listings$AddLocation$popOverStorefront(translations)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$AddLocation$popOverStorefrontAndServiceAreaBold(translations))
					])),
				$elm$html$Html$text(
				$author$project$Translations$Listings$AddLocation$popOverStorefrontAndServiceArea(translations))
			]);
		var serviceAreaOnly = _List_fromArray(
			[
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$AddLocation$popOverServiceAreaBold(translations))
					])),
				$elm$html$Html$text(
				$author$project$Translations$Listings$AddLocation$popOverServiceArea(translations))
			]);
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: 'address-business-type-popover',
				tagger: $author$project$Location$Details$PopupContent$Address$BusinessTypePopOverMsg,
				content: isLockedToServiceArea ? serviceAreaOnly : storeFrontAndServiceArea,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $author$project$Location$Details$PopupContent$Address$businessTypeView = F2(
	function (translations, model) {
		var isLockedToServiceArea = _Utils_eq(model.locationType, $author$project$Data$Location$ServiceArea);
		var selectableTypes = isLockedToServiceArea ? _List_fromArray(
			[$author$project$Data$Location$ServiceArea]) : _List_fromArray(
			[$author$project$Data$Location$Storefront, $author$project$Data$Location$StorefrontAndServiceArea]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__input-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__input-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationType(translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.businessTypePopOver,
							A2($author$project$Location$Details$PopupContent$Address$businessTypePopOverConfig, translations, isLockedToServiceArea))
						])),
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.uiSelect,
					A2(
						$author$project$PinMeTo$Ui$Select$isDisabled,
						isLockedToServiceArea,
						$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
							$author$project$PinMeTo$Ui$Select$view(
								{
									uid: 'address_business_type',
									items: selectableTypes,
									label: $elm$html$Html$text(
										A2($author$project$Location$Details$PopupContent$Address$locationTypeToString, model.locationType, translations)),
									tagger: $author$project$Location$Details$PopupContent$Address$UiSelectMsg,
									onChange: $author$project$Location$Details$PopupContent$Address$SelectBusinessType,
									itemRender: function (locationType) {
										return $elm$html$Html$text(
											A2($author$project$Location$Details$PopupContent$Address$locationTypeToString, locationType, translations));
									}
								}))))
				]));
	});
var $author$project$Data$Address$Zip = function (a) {
	return {$: 'Zip', a: a};
};
var $author$project$Data$Address$City = function (a) {
	return {$: 'City', a: a};
};
var $author$project$Data$Address$Street = function (a) {
	return {$: 'Street', a: a};
};
var $author$project$Data$Address$District = function (a) {
	return {$: 'District', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$withRequired = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{required: x}));
	});
var $author$project$Location$Details$PopupContent$Address$textField = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lightbox__input-container')
			]),
		_List_fromArray(
			[
				A2($author$project$Location$Details$PopupContent$Address$fieldLabel, config.label, config.required),
				$author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withRequired,
					config.required,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						config.label,
						$author$project$PinMeTo$Ui$Form$Input$text(
							{value: config.value, onChange: config.onChange}))))
			]));
};
var $author$project$Data$Address$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$RemoteData$currentData = function (remoteData) {
	if (remoteData.$ === 'Loaded') {
		var data = remoteData.a;
		return $elm$core$Maybe$Just(data);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RemoteData$withDefault = F2(
	function (_default, remoteData) {
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			$author$project$RemoteData$currentData(remoteData));
	});
var $author$project$Location$Details$PopupContent$Address$findCountry = function (model) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (country) {
				return _Utils_eq(country.name, model.address.country);
			},
			A2($author$project$RemoteData$withDefault, _List_Nil, model.countries)));
};
var $author$project$Location$Details$PopupContent$Address$SelectRegion = function (a) {
	return {$: 'SelectRegion', a: a};
};
var $author$project$Location$Details$PopupContent$Address$regionRequired = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.requiresRegion;
			},
			$author$project$Location$Details$PopupContent$Address$findCountry(model)));
};
var $author$project$Location$Details$PopupContent$Address$ChangeAddressField = function (a) {
	return {$: 'ChangeAddressField', a: a};
};
var $author$project$Translations$General$locationStateRegion = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_state_region');
};
var $author$project$Translations$General$searchItemsPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.search_items_placeholder');
};
var $author$project$Location$Details$PopupContent$Address$regionView = F2(
	function (translations, model) {
		var _v0 = $author$project$Location$Details$PopupContent$Address$findCountry(model);
		if (_v0.$ === 'Just') {
			var country = _v0.a;
			return $elm$core$List$isEmpty(country.regions) ? $author$project$Location$Details$PopupContent$Address$textField(
				{
					label: $author$project$Translations$General$locationStateRegion(translations),
					value: $author$project$Data$Address$getState(model.address),
					onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$State, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
					required: $author$project$Location$Details$PopupContent$Address$regionRequired(model)
				}) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__input-container')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Location$Details$PopupContent$Address$fieldLabel,
						$author$project$Translations$General$locationStateRegion(translations),
						$author$project$Location$Details$PopupContent$Address$regionRequired(model)),
						A2(
						$author$project$PinMeTo$Ui$Select$render,
						model.uiSelect,
						$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
							A2(
								$author$project$PinMeTo$Ui$Select$withSearch,
								{
									searchMap: $elm$core$Basics$identity,
									placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
									noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
								},
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'address_region',
										items: country.regions,
										label: $elm$html$Html$text(
											$author$project$Data$Address$getState(model.address)),
										tagger: $author$project$Location$Details$PopupContent$Address$UiSelectMsg,
										onChange: $author$project$Location$Details$PopupContent$Address$SelectRegion,
										itemRender: $elm$html$Html$text
									}))))
					]));
		} else {
			return $author$project$Location$Details$PopupContent$Address$textField(
				{
					label: $author$project$Translations$General$locationStateRegion(translations),
					value: $author$project$Data$Address$getState(model.address),
					onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$State, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
					required: false
				});
		}
	});
var $author$project$Location$Details$PopupContent$Address$SelectCountry = function (a) {
	return {$: 'SelectCountry', a: a};
};
var $author$project$Location$Details$PopupContent$Address$countryView = F2(
	function (translations, model) {
		var label = (model.address.country === '') ? $elm$html$Html$text(
			$author$project$Translations$General$locationCountry(translations)) : $elm$html$Html$text(model.address.country);
		var control = A2(
			$author$project$PinMeTo$Ui$Select$render,
			model.uiSelect,
			$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
				A2(
					$author$project$PinMeTo$Ui$Select$withSearch,
					{
						searchMap: function ($) {
							return $.name;
						},
						placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
						noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
					},
					$author$project$PinMeTo$Ui$Select$view(
						{
							uid: 'address_country',
							items: function () {
								var _v0 = model.countries;
								if (_v0.$ === 'Loaded') {
									var countries = _v0.a;
									return countries;
								} else {
									return _List_Nil;
								}
							}(),
							label: label,
							tagger: $author$project$Location$Details$PopupContent$Address$UiSelectMsg,
							onChange: $author$project$Location$Details$PopupContent$Address$SelectCountry,
							itemRender: function (country) {
								return $elm$html$Html$text(country.name);
							}
						}))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__input-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Location$Details$PopupContent$Address$fieldLabel,
					$author$project$Translations$General$locationCountry(translations),
					true),
					control
				]));
	});
var $author$project$Location$Details$PopupContent$Address$zipRequired = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.requiresZip;
			},
			$author$project$Location$Details$PopupContent$Address$findCountry(model)));
};
var $author$project$Data$Address$Province = function (a) {
	return {$: 'Province', a: a};
};
var $author$project$Location$Details$PopupContent$Address$SelectProvince = function (a) {
	return {$: 'SelectProvince', a: a};
};
var $author$project$Location$Details$PopupContent$Address$provinceView = F2(
	function (translations, model) {
		var _v0 = $author$project$Location$Details$PopupContent$Address$findCountry(model);
		if (_v0.$ === 'Just') {
			var country = _v0.a;
			return $elm$core$List$isEmpty(country.regions) ? $author$project$Location$Details$PopupContent$Address$textField(
				{
					label: $author$project$Translations$General$locationProvince(translations),
					value: $author$project$Data$Address$getProvince(model.address),
					onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$Province, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
					required: false
				}) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__input-container')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Location$Details$PopupContent$Address$fieldLabel,
						$author$project$Translations$General$locationProvince(translations),
						false),
						A2(
						$author$project$PinMeTo$Ui$Select$render,
						model.uiSelect,
						$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
							A2(
								$author$project$PinMeTo$Ui$Select$withSearch,
								{
									searchMap: $elm$core$Basics$identity,
									placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
									noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
								},
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'address_province',
										items: country.regions,
										label: $elm$html$Html$text(
											$author$project$Data$Address$getProvince(model.address)),
										tagger: $author$project$Location$Details$PopupContent$Address$UiSelectMsg,
										onChange: $author$project$Location$Details$PopupContent$Address$SelectProvince,
										itemRender: $elm$html$Html$text
									}))))
					]));
		} else {
			return $author$project$Location$Details$PopupContent$Address$textField(
				{
					label: $author$project$Translations$General$locationProvince(translations),
					value: $author$project$Data$Address$getProvince(model.address),
					onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$Province, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
					required: false
				});
		}
	});
var $author$project$Translations$General$locationZipPostalCode = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_zip_postal_code');
};
var $author$project$Location$Details$PopupContent$Address$addressFieldsView = F2(
	function (translations, model) {
		return _List_fromArray(
			[
				$author$project$Location$Details$PopupContent$Address$textField(
				{
					label: $author$project$Translations$General$locationStreet(translations),
					value: model.address.street,
					onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$Street, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
					required: true
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__input-row')
					]),
				_List_fromArray(
					[
						$author$project$Location$Details$PopupContent$Address$textField(
						{
							label: $author$project$Translations$General$locationZipPostalCode(translations),
							value: model.address.zip,
							onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$Zip, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
							required: $author$project$Location$Details$PopupContent$Address$zipRequired(model)
						}),
						$author$project$Location$Details$PopupContent$Address$textField(
						{
							label: $author$project$Translations$General$locationCity(translations),
							value: model.address.city,
							onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$City, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
							required: true
						})
					])),
				$author$project$Data$Address$hasState(model.address) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__input-row')
					]),
				_List_fromArray(
					[
						A2($author$project$Location$Details$PopupContent$Address$countryView, translations, model),
						A2($author$project$Location$Details$PopupContent$Address$regionView, translations, model)
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Location$Details$PopupContent$Address$countryView, translations, model),
						A2($author$project$Location$Details$PopupContent$Address$provinceView, translations, model),
						$author$project$Location$Details$PopupContent$Address$textField(
						{
							label: $author$project$Translations$General$locationDistrict(translations),
							value: $author$project$Data$Address$getDistrict(model.address),
							onChange: A2($elm$core$Basics$composeR, $author$project$Data$Address$District, $author$project$Location$Details$PopupContent$Address$ChangeAddressField),
							required: false
						})
					]))
			]);
	});
var $author$project$Location$Details$PopupContent$Address$showAddressSection = function (model) {
	return !_Utils_eq(model.locationType, $author$project$Data$Location$ServiceArea);
};
var $author$project$Location$Details$PopupContent$Address$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__address-form')
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Location$Details$PopupContent$Address$businessTypeView, translations, model),
				_Utils_ap(
					$author$project$Location$Details$PopupContent$Address$showAddressSection(model) ? A2($author$project$Location$Details$PopupContent$Address$addressFieldsView, translations, model) : _List_Nil,
					(!_Utils_eq(model.locationType, $author$project$Data$Location$Storefront)) ? _List_fromArray(
						[
							A2($author$project$Location$Details$PopupContent$Address$serviceAreaView, translations, model)
						]) : _List_Nil)));
	});
var $author$project$Listings$Ui$Label$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$Listings$Ui$Label$Title = function (a) {
	return {$: 'Title', a: a};
};
var $author$project$Listings$Ui$Label$Description = function (a) {
	return {$: 'Description', a: a};
};
var $author$project$Listings$Ui$Label$label = function (config) {
	return $author$project$Listings$Ui$Label$Label(
		{
			title: $author$project$Listings$Ui$Label$Title(config.title),
			description: $author$project$Listings$Ui$Label$Description(config.description),
			translations: $elm$core$Maybe$Nothing,
			enableNewReleaseIndicator: false
		});
};
var $author$project$Translations$General$new = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.new');
};
var $author$project$Listings$Ui$Label$render = function (_v0) {
	var config = _v0.a;
	var _v1 = config.description;
	var description = _v1.a;
	var _v2 = config.title;
	var title = _v2.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-details-label')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-label__title-and-new-release-indicator-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details-label__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						function () {
						var _v3 = _Utils_Tuple2(config.enableNewReleaseIndicator, config.translations);
						if (_v3.a) {
							if (_v3.b.$ === 'Just') {
								var translations = _v3.b.a;
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('location-details-label__new-release-indicator')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$new(translations))
										]));
							} else {
								var _v4 = _v3.b;
								return $elm$html$Html$text('');
							}
						} else {
							if (_v3.b.$ === 'Just') {
								return $elm$html$Html$text('');
							} else {
								var _v5 = _v3.b;
								return $elm$html$Html$text('');
							}
						}
					}()
					])),
				($elm$core$String$length(description) > 0) ? A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-label__description')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
			]));
};
var $author$project$Location$Details$PopupContent$StoreId$checkMaxLength = function (input) {
	return ($elm$core$String$length(input) <= 40) ? true : false;
};
var $author$project$Location$Details$PopupContent$StoreId$checkMinLength = function (input) {
	return ($elm$core$String$length(input) > 0) ? true : false;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.store_id_invalid');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdRequired = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.store_id_required');
};
var $author$project$Location$Details$PopupContent$StoreId$validationErrors = F3(
	function (isFacebook, translations, model) {
		var list = _List_Nil;
		return ((!$author$project$Location$Details$PopupContent$StoreId$checkMinLength(model.textStoreId)) && (!isFacebook)) ? A2(
			$elm$core$List$cons,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdRequired(translations),
			list) : (((!$author$project$Location$Details$PopupContent$StoreId$checkMaxLength(model.textStoreId)) && (!isFacebook)) ? A2(
			$elm$core$List$cons,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdInvalid(translations),
			list) : list);
	});
var $author$project$Location$Details$PopupContent$StoreId$renderAlert = F3(
	function (isFacebook, translations, model) {
		var err = isFacebook ? A3($author$project$Location$Details$PopupContent$StoreId$validationErrors, isFacebook, translations, model) : A3($author$project$Location$Details$PopupContent$StoreId$validationErrors, isFacebook, translations, model);
		return ($elm$core$List$length(err) > 0) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Warning,
				$author$project$PinMeTo$Ui$Alert$plain(
					'Error: ' + A2($elm$core$String$join, ',', err)))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
	});
var $author$project$Location$Details$PopupContent$StoreId$OnChangeStoreId = function (a) {
	return {$: 'OnChangeStoreId', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdPlaceHolder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.store_id_place_holder');
};
var $author$project$Location$Details$PopupContent$StoreId$OnChangeFacebookStoreId = function (a) {
	return {$: 'OnChangeFacebookStoreId', a: a};
};
var $author$project$Translations$General$locationStoreIdFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_store_id_facebook');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$facebookStoreIdPlaceHolder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.facebook_store_id_place_holder');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$facebookStoreIdLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.facebook_store_id_light_box_description');
};
var $author$project$Location$Details$PopupContent$StoreId$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdPlaceHolder(translations),
						$author$project$PinMeTo$Ui$Form$Input$text(
							{value: model.textStoreId, onChange: $author$project$Location$Details$PopupContent$StoreId$OnChangeStoreId}))),
					A3($author$project$Location$Details$PopupContent$StoreId$renderAlert, false, translations, model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__sub-headline ')
						]),
					_List_Nil),
					$author$project$Listings$Ui$Label$render(
					$author$project$Listings$Ui$Label$label(
						{
							title: $author$project$Translations$General$locationStoreIdFacebook(translations),
							description: $author$project$Translations$Listings$LocationDetail$PopUpContent$facebookStoreIdLightBoxDescription(translations)
						})),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								$author$project$Translations$Listings$LocationDetail$PopUpContent$facebookStoreIdPlaceHolder(translations),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{value: model.textFacebookStoreId, onChange: $author$project$Location$Details$PopupContent$StoreId$OnChangeFacebookStoreId})))
						])),
					A3($author$project$Location$Details$PopupContent$StoreId$renderAlert, model.isFacebookConnected, translations, model)
				]));
	});
var $author$project$Data$Location$OpenHours$Always = {$: 'Always'};
var $author$project$Translations$General$fri = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.fri');
};
var $author$project$Translations$General$mon = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.mon');
};
var $author$project$Translations$General$sat = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.sat');
};
var $author$project$Translations$General$sun = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.sun');
};
var $author$project$Translations$General$thu = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.thu');
};
var $author$project$Translations$General$tue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.tue');
};
var $author$project$Translations$General$wed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.wed');
};
var $author$project$Data$Location$OpenHours$AlwaysOpen = {$: 'AlwaysOpen'};
var $author$project$PinMeTo$Ui$Form$Checkbox$withEnabled = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Checkbox$Checkbox(
			_Utils_update(
				config,
				{disabled: !x}));
	});
var $author$project$Location$Details$PopupContent$OpenHours$AddSpanToDay = F2(
	function (a, b) {
		return {$: 'AddSpanToDay', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Form$TimeInput$hasError = function (errorMessage) {
	if (errorMessage.$ === 'Error') {
		return true;
	} else {
		return false;
	}
};
var $author$project$PinMeTo$Ui$Form$TimeInput$timeToString = F2(
	function (format, _v0) {
		var hour = _v0.a;
		var minute = _v0.b;
		if (format.$ === 'Military') {
			return _Utils_ap(hour, minute);
		} else {
			return hour + (':' + minute);
		}
	});
var $author$project$PinMeTo$Ui$Form$TimeInput$Time = F2(
	function (a, b) {
		return {$: 'Time', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Form$TimeInput$fieldValueToTime = function (value) {
	var minute = A2($elm$core$String$right, 2, value);
	var hour = A2($elm$core$String$left, 2, value);
	return A2($author$project$PinMeTo$Ui$Form$TimeInput$Time, hour, minute);
};
var $author$project$PinMeTo$Ui$Form$TimeInput$timeToFieldValue = function (_v0) {
	var hour = _v0.a;
	var minute = _v0.b;
	return hour + (':' + minute);
};
var $author$project$PinMeTo$Ui$Form$TimeInput$renderField = function (config) {
	var correctValue = function (value) {
		return config.disabled ? '' : $author$project$PinMeTo$Ui$Form$TimeInput$timeToFieldValue(value);
	};
	var onChange = function (fieldValue) {
		return config.onChange(
			A2(
				$author$project$PinMeTo$Ui$Form$TimeInput$timeToString,
				config.format,
				$author$project$PinMeTo$Ui$Form$TimeInput$fieldValueToTime(fieldValue)));
	};
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('time'),
				$elm$html$Html$Attributes$disabled(config.disabled),
				$elm$html$Html$Attributes$readonly(config.readOnly),
				$elm$html$Html$Attributes$value(
				correctValue(config.time)),
				$elm$html$Html$Events$onInput(onChange),
				$elm$html$Html$Attributes$class('pmt-ui-time-input__field'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-ui-time-input__field--disabled', config.disabled),
						_Utils_Tuple2('pmt-ui-time-input__field--disabled', config.readOnly),
						_Utils_Tuple2(
						'pmt-ui-time-input__field--error',
						$author$project$PinMeTo$Ui$Form$TimeInput$hasError(config.error))
					]))
			]),
		_List_Nil);
};
var $author$project$PinMeTo$Ui$Form$TimeInput$renderErrorMessage = function (errorMessage) {
	var getErrorMessage = function () {
		if (errorMessage.$ === 'Error') {
			var string = errorMessage.a;
			return string;
		} else {
			return '';
		}
	}();
	return $author$project$PinMeTo$Ui$Form$TimeInput$hasError(errorMessage) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-time-input__error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(getErrorMessage)
			])) : $elm$html$Html$text('');
};
var $author$project$PinMeTo$Ui$Form$TimeInput$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-time-input')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-time-input__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', config.label))
					])),
				$author$project$PinMeTo$Ui$Form$TimeInput$renderField(config),
				$author$project$PinMeTo$Ui$Form$TimeInput$renderErrorMessage(config.error)
			]));
};
var $author$project$Translations$General$invalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.invalid');
};
var $author$project$PinMeTo$Ui$Form$TimeInput$Military = {$: 'Military'};
var $author$project$Location$Details$PopupContent$OpenHours$getRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[012][0-9][0-5][0-9]'));
var $author$project$PinMeTo$Ui$Form$TimeInput$NoError = {$: 'NoError'};
var $author$project$PinMeTo$Ui$Form$TimeInput$TimeInput = function (a) {
	return {$: 'TimeInput', a: a};
};
var $author$project$PinMeTo$Ui$Form$TimeInput$stringToTime = F2(
	function (format, value) {
		if (format.$ === 'Military') {
			return A2(
				$author$project$PinMeTo$Ui$Form$TimeInput$Time,
				A2($elm$core$String$left, 2, value),
				A2($elm$core$String$right, 2, value));
		} else {
			return A2(
				$author$project$PinMeTo$Ui$Form$TimeInput$Time,
				A2($elm$core$String$left, 2, value),
				A2($elm$core$String$right, 2, value));
		}
	});
var $author$project$PinMeTo$Ui$Form$TimeInput$timeInput = function (_v0) {
	var format = _v0.format;
	var onChange = _v0.onChange;
	var value = _v0.value;
	var time = A2($author$project$PinMeTo$Ui$Form$TimeInput$stringToTime, format, value);
	return $author$project$PinMeTo$Ui$Form$TimeInput$TimeInput(
		{time: time, error: $author$project$PinMeTo$Ui$Form$TimeInput$NoError, label: $elm$core$Maybe$Nothing, format: format, disabled: false, onChange: onChange, readOnly: false});
};
var $author$project$PinMeTo$Ui$Form$TimeInput$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$PinMeTo$Ui$Form$TimeInput$withError = F2(
	function (hasError_, _v0) {
		var config = _v0.a;
		var error = function () {
			if (hasError_.$ === 'Just') {
				var string = hasError_.a;
				return $author$project$PinMeTo$Ui$Form$TimeInput$Error(string);
			} else {
				return $author$project$PinMeTo$Ui$Form$TimeInput$NoError;
			}
		}();
		return $author$project$PinMeTo$Ui$Form$TimeInput$TimeInput(
			_Utils_update(
				config,
				{error: error}));
	});
var $author$project$PinMeTo$Ui$Form$TimeInput$withDisabled = F2(
	function (disabled, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$TimeInput$TimeInput(
			_Utils_update(
				config,
				{disabled: disabled}));
	});
var $author$project$Location$Details$PopupContent$OpenHours$UpdateHourSet = F5(
	function (a, b, c, d, e) {
		return {$: 'UpdateHourSet', a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Location$Details$PopupContent$OpenHours$mapClosingTime0000To2400 = F5(
	function (openOrClose, shortStringDay, spanIndex, state, fieldValue) {
		var newFieldValue = ((openOrClose === 'close') && (fieldValue === '0000')) ? '2400' : fieldValue;
		return A5($author$project$Location$Details$PopupContent$OpenHours$UpdateHourSet, openOrClose, shortStringDay, spanIndex, state, newFieldValue);
	});
var $author$project$Location$Details$PopupContent$OpenHours$mapClosingTime2400To0000 = function (textValue) {
	return (textValue === '2400') ? '0000' : textValue;
};
var $author$project$Location$Details$PopupContent$OpenHours$renderHourInput = F7(
	function (translations, textValue, openOrClose, shortStringDay, spanIndex, isDisabled, state) {
		var errorToShow = function () {
			switch (state.$) {
				case 'NotSpecified':
					return $elm$core$Maybe$Nothing;
				case 'Closed':
					return $elm$core$Maybe$Nothing;
				case 'AlwaysOpen':
					return $elm$core$Maybe$Nothing;
				default:
					return A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$OpenHours$getRegex, textValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Translations$General$invalid(translations));
			}
		}();
		return $author$project$PinMeTo$Ui$Form$TimeInput$render(
			A2(
				$author$project$PinMeTo$Ui$Form$TimeInput$withError,
				errorToShow,
				A2(
					$author$project$PinMeTo$Ui$Form$TimeInput$withDisabled,
					isDisabled,
					$author$project$PinMeTo$Ui$Form$TimeInput$timeInput(
						{
							value: $author$project$Location$Details$PopupContent$OpenHours$mapClosingTime2400To0000(textValue),
							format: $author$project$PinMeTo$Ui$Form$TimeInput$Military,
							onChange: A4($author$project$Location$Details$PopupContent$OpenHours$mapClosingTime0000To2400, openOrClose, shortStringDay, spanIndex, state)
						}))));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_add_span');
};
var $author$project$PinMeTo$Deprecated$FontAwesome$Delete = {$: 'Delete'};
var $author$project$PinMeTo$Deprecated$FontAwesome$wrap = function (c) {
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(c)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('')
			]));
};
var $author$project$PinMeTo$Deprecated$FontAwesome$render = function (icon) {
	switch (icon.$) {
		case 'Task':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-list-check');
		case 'Period':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-period');
		case 'BrandPage':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-globe');
		case 'Location':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-location-dot');
		case 'Film':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-film');
		case 'Connect':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-plug');
		case 'Import':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-arrow-right');
		case 'Export':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-arrow-left');
		case 'SpecialOpenHours':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-clock');
		case 'Insights':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-chart-line');
		case 'InsightsOverview':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-chart-bar');
		case 'InsightsRatings':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-star');
		case 'Google':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-google');
		case 'Facebook':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-square-facebook');
		case 'FacebookF':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-facebook-f');
		case 'Foursquare':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-foursquare');
		case 'Instagram':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-instagram');
		case 'Apple':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-apple');
		case 'System':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-hard-drive');
		case 'MediaLibrary':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-images');
		case 'Update':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-rotate-right');
		case 'Difference':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-not-equal');
		case 'Access':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-shield-halved');
		case 'Request':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-right-left');
		case 'Documentation':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-file-lines');
		case 'Security':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-address-card');
		case 'Support':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-circle-question');
		case 'SwitchProduct':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-grid-2');
		case 'SwitchAccount':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-building');
		case 'ToggleOn':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-toggle-on');
		case 'ToggleOff':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-toggle-off');
		case 'Notification':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-bell');
		case 'UserSettings':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-user');
		case 'Email':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-envelope');
		case 'Chat':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-comment-dots');
		case 'KeyboardShortcut':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-keyboard');
		case 'AccountSettings':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-user-gear');
		case 'LocationPostList':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-paper-plane');
		case 'Collapsed':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-angles-left');
		case 'Expanded':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-angles-right');
		case 'WorkerLog':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-clock-rotate-left');
		case 'Api':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-left-right');
		case 'ApiDiff':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-shuffle');
		case 'Search':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-magnifying-glass');
		case 'SearchOptions':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-sliders');
		case 'ExternalLink':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-up-right-from-square');
		case 'WorkInProgress':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-gear fa-spin');
		case 'Spinner':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-spinner');
		case 'Icons':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-icons');
		case 'Info':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-info');
		case 'Click':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-hand-pointer');
		case 'Chart':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-chart-bar');
		case 'Down':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-caret-down');
		case 'Country':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-flag');
		case 'Table':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-table');
		case 'Edit':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-pen-to-square');
		case 'EditAlt':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-pencil');
		case 'Map':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-map');
		case 'Home':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-house');
		case 'Bars':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-bars');
		case 'ElipsisVertical':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-ellipsis-vertical');
		case 'Channels':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-brands fa-mandalorian');
		case 'Inbox':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-inbox');
		case 'Filter':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-filter');
		case 'File':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-file-lines');
		case 'Language':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-language');
		case 'Desktop':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-desktop');
		case 'Lock':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-lock');
		case 'FileSignature':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-file-signature');
		case 'Logout':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-right-from-bracket');
		case 'Exclamation':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-triangle-exclamation');
		case 'Circle':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-circle');
		case 'Sitemap':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-sitemap');
		case 'OneWayNetwork':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-right-long');
		case 'TemporarilyClosed':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-calendar-xmark');
		case 'Video':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-circle-play');
		case 'VideoCamera':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-camera-movie');
		case 'Link':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-link');
		case 'Image':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-image');
		case 'Carousel':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-images');
		case 'AngleLeft':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-angle-left');
		case 'AngleRight':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-angle-right');
		case 'Clone':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-clone');
		case 'Targeting':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-bullseye');
		case 'Download':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-download');
		case 'Key':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-key');
		case 'View':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-eye');
		case 'Unschedule':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-calendar-minus');
		case 'Trash':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-trash-can');
		case 'Copy':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-copy');
		case 'Cog':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-gear');
		case 'InfoCircle':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-circle-info');
		case 'UserSecret':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-user-secret');
		case 'Delete':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-xmark');
		case 'Check':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-check');
		case 'Bookmark':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-bookmark');
		case 'Calendar':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-calendar-days');
		case 'Flag':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-flag');
		case 'FlagSolid':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-flag');
		case 'Create':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-circle-plus');
		case 'ListView':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-table-list');
		case 'CardView':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-table-cells-large');
		case 'CalendarMonthlyView':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-calendar-days');
		case 'CalendarWeeklyView':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-calendar-minus');
		case 'CompanyLogoFallback':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-building');
		case 'ArrowUp':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-arrow-up');
		case 'ArrowDown':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-arrow-down');
		case 'ArrowUpShortUp':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-arrow-up-short-wide');
		case 'ArrowUpShortDown':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-arrow-down-short-wide');
		case 'F_ck':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-hand-middle-finger');
		case 'SortUp':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-sort-up');
		case 'SortDown':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-sort-down');
		case 'ErrorCircle':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-circle-exclamation');
		case 'ClearX':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-x');
		case 'Verify':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-shield-alt');
		case 'CompassDrafting':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-compass-drafting');
		case 'Conflict':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-info-circle');
		case 'AttributeTrue':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-circle-check');
		case 'AttributeFalse':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-circle-xmark');
		case 'CodeBranch':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-code-branch');
		case 'InputText':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-input-text');
		case 'FilterCircleXmark':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-filter-circle-xmark');
		case 'ChartNetwork':
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-solid fa-chart-network');
		default:
			return $author$project$PinMeTo$Deprecated$FontAwesome$wrap('fa-regular fa-calendar-day');
	}
};
var $author$project$Location$Details$PopupContent$OpenHours$RemoveDaySpanByIndex = F2(
	function (a, b) {
		return {$: 'RemoveDaySpanByIndex', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$OpenHours$renderDeleteSpan = F2(
	function (spanIndex, day) {
		return (spanIndex > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-remove-span'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Location$Details$PopupContent$OpenHours$RemoveDaySpanByIndex, spanIndex, day))
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-remove-span')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(' ')
				]));
	});
var $author$project$Location$Details$PopupContent$OpenHours$OnDayClosedChange = F2(
	function (a, b) {
		return {$: 'OnDayClosedChange', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_day_closed');
};
var $author$project$Location$Details$PopupContent$OpenHours$NoOp = {$: 'NoOp'};
var $author$project$PinMeTo$Ui$Form$TimeInput$withReadOnly = F2(
	function (readOnly, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$TimeInput$TimeInput(
			_Utils_update(
				config,
				{readOnly: readOnly}));
	});
var $author$project$Location$Details$PopupContent$OpenHours$renderReadOnlyHourInput = function (textValue) {
	return $author$project$PinMeTo$Ui$Form$TimeInput$render(
		A2(
			$author$project$PinMeTo$Ui$Form$TimeInput$withReadOnly,
			true,
			$author$project$PinMeTo$Ui$Form$TimeInput$timeInput(
				{
					value: textValue,
					format: $author$project$PinMeTo$Ui$Form$TimeInput$Military,
					onChange: function (_v0) {
						return $author$project$Location$Details$PopupContent$OpenHours$NoOp;
					}
				})));
};
var $author$project$Location$Details$PopupContent$OpenHours$renderDayData = F4(
	function (translations, model, day, state) {
		var renderCloseDay = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
								{
									label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
									checked: true,
									onChange: $author$project$Location$Details$PopupContent$OpenHours$OnDayClosedChange(day)
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-input')
										]),
									_List_fromArray(
										[
											A7($author$project$Location$Details$PopupContent$OpenHours$renderHourInput, translations, '', 'open', day, 0, true, state)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-input')
										]),
									_List_fromArray(
										[
											A7($author$project$Location$Details$PopupContent$OpenHours$renderHourInput, translations, '', 'close', day, 0, true, state)
										]))
								])),
							A2($author$project$Location$Details$PopupContent$OpenHours$renderDeleteSpan, 0, day)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								A2($author$project$Location$Details$PopupContent$OpenHours$AddSpanToDay, day, state),
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostLight,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$disabledIfTrue,
											true,
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations)))))))
						]))
				]));
		switch (state.$) {
			case 'Open':
				var spanList = state.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Checkbox$render(
									$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
										{
											label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
											checked: false,
											onChange: $author$project$Location$Details$PopupContent$OpenHours$OnDayClosedChange(day)
										}))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, timeSpan) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('lightbox__open-hours-input')
																]),
															_List_fromArray(
																[
																	A7($author$project$Location$Details$PopupContent$OpenHours$renderHourInput, translations, timeSpan.open, 'open', day, index, false, state)
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('lightbox__open-hours-input')
																]),
															_List_fromArray(
																[
																	A7($author$project$Location$Details$PopupContent$OpenHours$renderHourInput, translations, timeSpan.close, 'close', day, index, false, state)
																]))
														])),
													A2($author$project$Location$Details$PopupContent$OpenHours$renderDeleteSpan, index, day)
												]));
									}),
								spanList)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										A2($author$project$Location$Details$PopupContent$OpenHours$AddSpanToDay, day, state),
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostLight,
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												A2(
													$author$project$PinMeTo$Ui$Button$disabledIfTrue,
													$elm$core$List$length(spanList) > 2,
													$author$project$PinMeTo$Ui$Button$buttonGhost(
														$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations)))))))
								]))
						]));
			case 'AlwaysOpen':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Checkbox$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Checkbox$withEnabled,
										false,
										$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
											{
												label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
												checked: false,
												onChange: $author$project$Location$Details$PopupContent$OpenHours$OnDayClosedChange(day)
											})))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-input')
												]),
											_List_fromArray(
												[
													$author$project$Location$Details$PopupContent$OpenHours$renderReadOnlyHourInput('0000')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-input')
												]),
											_List_fromArray(
												[
													$author$project$Location$Details$PopupContent$OpenHours$renderReadOnlyHourInput('0000')
												]))
										])),
									A2($author$project$Location$Details$PopupContent$OpenHours$renderDeleteSpan, 0, day)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										A2($author$project$Location$Details$PopupContent$OpenHours$AddSpanToDay, day, state),
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostLight,
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												A2(
													$author$project$PinMeTo$Ui$Button$disabledIfTrue,
													true,
													$author$project$PinMeTo$Ui$Button$buttonGhost(
														$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations)))))))
								]))
						]));
			case 'Closed':
				return renderCloseDay;
			default:
				return renderCloseDay;
		}
	});
var $author$project$Location$Details$PopupContent$OpenHours$renderWeek = F2(
	function (translations, model) {
		var dayContainer = F3(
			function (translatedDay, shortDay, state) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-days')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translatedDay)
								])),
							A4($author$project$Location$Details$PopupContent$OpenHours$renderDayData, translations, model, shortDay, state)
						]));
			});
		var openHours = model.openHours;
		if (openHours.$ === 'Always') {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						dayContainer,
						$author$project$Translations$General$mon(translations),
						'mon',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$tue(translations),
						'tue',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$wed(translations),
						'wed',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$thu(translations),
						'thu',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$fri(translations),
						'fri',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$sat(translations),
						'sat',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$sun(translations),
						'sun',
						$author$project$Data$Location$OpenHours$AlwaysOpen)
					]));
		} else {
			var days = openHours.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						dayContainer,
						$author$project$Translations$General$mon(translations),
						'mon',
						days.mon),
						A3(
						dayContainer,
						$author$project$Translations$General$tue(translations),
						'tue',
						days.tue),
						A3(
						dayContainer,
						$author$project$Translations$General$wed(translations),
						'wed',
						days.wed),
						A3(
						dayContainer,
						$author$project$Translations$General$thu(translations),
						'thu',
						days.thu),
						A3(
						dayContainer,
						$author$project$Translations$General$fri(translations),
						'fri',
						days.fri),
						A3(
						dayContainer,
						$author$project$Translations$General$sat(translations),
						'sat',
						days.sat),
						A3(
						dayContainer,
						$author$project$Translations$General$sun(translations),
						'sun',
						days.sun)
					]));
		}
	});
var $author$project$Location$Details$PopupContent$OpenHours$Fri = {$: 'Fri'};
var $author$project$Location$Details$PopupContent$OpenHours$Mon = {$: 'Mon'};
var $author$project$Location$Details$PopupContent$OpenHours$Sat = {$: 'Sat'};
var $author$project$Location$Details$PopupContent$OpenHours$Sun = {$: 'Sun'};
var $author$project$Location$Details$PopupContent$OpenHours$Thu = {$: 'Thu'};
var $author$project$Location$Details$PopupContent$OpenHours$Tue = {$: 'Tue'};
var $author$project$Location$Details$PopupContent$OpenHours$Wed = {$: 'Wed'};
var $author$project$Location$Details$PopupContent$OpenHours$timeOverlapping = F2(
	function (span1, span2) {
		var span2Close = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$elm$core$String$toInt(span2.close));
		return ((_Utils_cmp(span1.open, span2.close) < 1) && (_Utils_cmp(span1.open, span2.open) > -1)) || (((_Utils_cmp(span1.close, span2.close) < 0) && (_Utils_cmp(span1.close, span2.open) > -1)) || (((_Utils_cmp(span2.close, span1.close) < 1) && (span2Close > 1159)) || ((span1.open === '2400') || (span2.open === '2400'))));
	});
var $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay = function (spanList) {
	var tempList = A2(
		$elm$core$List$indexedMap,
		F2(
			function (outerIndex, outerSpan) {
				return A2(
					$elm$core$List$map,
					function (innerSpan) {
						return A2($author$project$Location$Details$PopupContent$OpenHours$timeOverlapping, outerSpan, innerSpan);
					},
					A2($elm$core$List$drop, outerIndex + 1, spanList));
			}),
		spanList);
	var resultList = $elm$core$List$concat(tempList);
	return A2($elm$core$List$member, true, resultList);
};
var $author$project$Location$Details$PopupContent$OpenHours$overlapValidationErrors = function (model) {
	var getSpanList = function (day) {
		if (day.$ === 'Open') {
			var spanList = day.a;
			return spanList;
		} else {
			return _List_Nil;
		}
	};
	var _v0 = model.openHours;
	if (_v0.$ === 'During') {
		var days = _v0.a;
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.day;
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.hasError;
				},
				_List_fromArray(
					[
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Mon,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.mon))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Tue,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.tue))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Wed,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.wed))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Thu,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.thu))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Fri,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.fri))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Sat,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.sat))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Sun,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.sun))
					}
					])));
	} else {
		return _List_Nil;
	}
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursOverlappingError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_overlapping_error');
};
var $author$project$Location$Details$PopupContent$OpenHours$renderAlert = F2(
	function (translations, model) {
		var errorDays = A2(
			$elm$core$List$map,
			function (day) {
				switch (day.$) {
					case 'Mon':
						return $author$project$Translations$General$mon(translations);
					case 'Tue':
						return $author$project$Translations$General$tue(translations);
					case 'Wed':
						return $author$project$Translations$General$wed(translations);
					case 'Thu':
						return $author$project$Translations$General$thu(translations);
					case 'Fri':
						return $author$project$Translations$General$fri(translations);
					case 'Sat':
						return $author$project$Translations$General$sat(translations);
					default:
						return $author$project$Translations$General$sun(translations);
				}
			},
			$author$project$Location$Details$PopupContent$OpenHours$overlapValidationErrors(model));
		return ($elm$core$List$length(errorDays) > 0) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Error,
				$author$project$PinMeTo$Ui$Alert$plain(
					_Utils_ap(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursOverlappingError(translations),
						A2($elm$core$String$join, ',', errorDays))))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
	});
var $author$project$Location$Details$PopupContent$OpenHours$OnAlwaysOpenChange = function (a) {
	return {$: 'OnAlwaysOpenChange', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAlwaysOpen = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_always_open');
};
var $author$project$Location$Details$PopupContent$OpenHours$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Location$Details$PopupContent$OpenHours$renderAlert, translations, model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__checkbox-header')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
								{
									label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAlwaysOpen(translations),
									checked: _Utils_eq(model.openHours, $author$project$Data$Location$OpenHours$Always),
									onChange: $author$project$Location$Details$PopupContent$OpenHours$OnAlwaysOpenChange
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__flex')
						]),
					_List_fromArray(
						[
							A2($author$project$Location$Details$PopupContent$OpenHours$renderWeek, translations, model)
						]))
				]));
	});
var $author$project$Translations$Listings$LocationDetail$primaryCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.primary_category');
};
var $author$project$Data$Network$Google = {$: 'Google'};
var $author$project$Translations$Listings$Conflicts$changingGoogleCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.changing_google_category');
};
var $author$project$Translations$Listings$Conflicts$changingGoogleCategoryLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.changing_google_category_link');
};
var $author$project$Location$Details$PopupContent$Categories$renderGoogleAlert = F2(
	function (translations, network) {
		return _Utils_eq(network, $author$project$Data$Network$Google) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Warning,
						$author$project$PinMeTo$Ui$Alert$rich(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Conflicts$changingGoogleCategory(translations) + ' '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://support.google.com/business/answer/7249669?hl=en#:~:text=Add%20or%20edit%20categories,Select%20Edit%20profile.&text=From%20the%20%E2%80%9CPrimary%20category%E2%80%9D%20box,shows%20up%2C%20select%20a%20category'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Conflicts$changingGoogleCategoryLink(translations))
										]))
								])))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.categories_error_suspended');
};
var $author$project$Data$Location$NetworkCategories$getName = function (x) {
	if (x.$ === 'CommonNetworkCategory') {
		var cat = x.a;
		return cat.name;
	} else {
		var cat = x.a;
		return cat.name;
	}
};
var $author$project$PinMeTo$Ui$Chip$withColor = F2(
	function (color, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Chip$View(
			_Utils_update(
				config,
				{
					color: $elm$core$Maybe$Just(color)
				}));
	});
var $author$project$Location$Details$PopupContent$Categories$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$renderSelectedCategories = F2(
	function (categories, model) {
		var _v0 = model.network;
		if (_v0.$ === 'Tomtom') {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__selected-categories')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, removableCategory) {
							var color = removableCategory.pendingRemoval ? $author$project$PinMeTo$Ui$Chip$NegativeSentimentColor : $author$project$PinMeTo$Ui$Chip$MixedSentimentColor;
							return $author$project$PinMeTo$Ui$Chip$render(
								A2(
									$author$project$PinMeTo$Ui$Chip$withColor,
									color,
									A2(
										$author$project$PinMeTo$Ui$Chip$withDelete,
										$author$project$Location$Details$PopupContent$Categories$RemoveAdditionalCategoryByIndex(index),
										$author$project$PinMeTo$Ui$Chip$view(
											$author$project$Data$Location$NetworkCategories$getName(removableCategory.category)))));
						}),
					categories));
		}
	});
var $author$project$Location$Details$PopupContent$Categories$CancelRemoval = {$: 'CancelRemoval'};
var $author$project$Location$Details$PopupContent$Categories$RemovePendingCategories = {$: 'RemovePendingCategories'};
var $author$project$Translations$Listings$LocationDetail$categoriesRemoveMessageGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_remove_message_google');
};
var $author$project$Translations$Listings$LocationDetail$categoriesRemoveMessageGeneral = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_remove_message_general');
};
var $author$project$Location$Details$PopupContent$Categories$renderConfirmRemovalBanner = F3(
	function (translations, categories, network) {
		var message = _Utils_eq(network, $author$project$Data$Network$Google) ? $author$project$Translations$Listings$LocationDetail$categoriesRemoveMessageGoogle(translations) : $author$project$Translations$Listings$LocationDetail$categoriesRemoveMessageGeneral(translations);
		var banner = A2(
			$elm$core$List$any,
			function (removableCategory) {
				return removableCategory.pendingRemoval;
			},
			categories) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Warning,
				$author$project$PinMeTo$Ui$Alert$rich(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__banner-confirm-removal-button-container')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withGhostStyle,
										$author$project$PinMeTo$Ui$Button$GhostNeutral,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$Location$Details$PopupContent$Categories$CancelRemoval,
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$General$cancel(translations))))),
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withGhostStyle,
										$author$project$PinMeTo$Ui$Button$GhostDanger,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$Location$Details$PopupContent$Categories$RemovePendingCategories,
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$General$delete(translations)))))
								]))
						])))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__banner-confirm-removal-container')
				]),
			_List_fromArray(
				[banner]));
	});
var $author$project$Location$Details$PopupContent$Categories$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$SelectPrimaryCategory = function (a) {
	return {$: 'SelectPrimaryCategory', a: a};
};
var $author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_categories_select_action');
};
var $author$project$Location$Details$PopupContent$Categories$renderPrimaryCategoriesDropdown = F4(
	function (translations, allCategories, selectedCategory, model) {
		var filteredCategories = function () {
			if (selectedCategory.$ === 'Just') {
				var cat = selectedCategory.a;
				return A2(
					$elm$core$List$filter,
					function (category_) {
						return !_Utils_eq(category_, cat);
					},
					allCategories);
			} else {
				return allCategories;
			}
		}();
		var categoryLabel = function () {
			if (selectedCategory.$ === 'Just') {
				var cat = selectedCategory.a;
				return $elm$html$Html$text(
					$author$project$Data$Location$NetworkCategories$getName(cat));
			} else {
				return $elm$html$Html$text(
					$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__dropdown-container lightbox__dropdown-container--small')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.uiSelect,
					$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
						A2(
							$author$project$PinMeTo$Ui$Select$withSearch,
							{
								searchMap: $author$project$Data$Location$NetworkCategories$getName,
								placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
								noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
							},
							$author$project$PinMeTo$Ui$Select$view(
								{
									uid: 'primary_category',
									items: filteredCategories,
									label: categoryLabel,
									tagger: $author$project$Location$Details$PopupContent$Categories$UiSelectMsg,
									onChange: $author$project$Location$Details$PopupContent$Categories$SelectPrimaryCategory,
									itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
								}))))
				]));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$additionalCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.additional_category');
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Location$Details$PopupContent$Categories$convertToCategories = function (categories) {
	return A2(
		$elm$core$List$map,
		function (removableCategory) {
			return removableCategory.category;
		},
		categories);
};
var $author$project$Location$Details$PopupContent$Categories$getSelectedCategories = F2(
	function (primaryCategory, additionalCategories) {
		var additionalCategories_ = $author$project$Location$Details$PopupContent$Categories$convertToCategories(additionalCategories);
		var primaryCategory_ = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (cat) {
				return $elm$core$List$singleton(cat);
			},
			primaryCategory);
		return A2($elm$core$List$append, additionalCategories_, primaryCategory_);
	});
var $author$project$Location$Details$PopupContent$Categories$SelectAdditionalCategory = function (a) {
	return {$: 'SelectAdditionalCategory', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$hasMaxNumberOfAdditionalCategories = F2(
	function (numSelected, nw) {
		if (nw.$ === 'Facebook') {
			return numSelected >= 2;
		} else {
			return false;
		}
	});
var $author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectActionFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_categories_select_action_facebook');
};
var $author$project$Location$Details$PopupContent$Categories$renderAdditionalCategoriesDropdown = F3(
	function (translations, categories, model) {
		var selectedCategories = A2($author$project$Location$Details$PopupContent$Categories$getSelectedCategories, model.primaryCategory, model.additionalCategories);
		var filteredCategories = A2(
			$elm$core$List$filter,
			function (cat) {
				return !A2($elm$core$List$member, cat, selectedCategories);
			},
			categories);
		var hasMaxAdditonal = A2(
			$author$project$Location$Details$PopupContent$Categories$hasMaxNumberOfAdditionalCategories,
			$elm$core$List$length(model.additionalCategories),
			model.network);
		var categoryString = function () {
			var _v0 = model.network;
			if (_v0.$ === 'Facebook') {
				return $author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectActionFacebook(translations);
			} else {
				return $author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__dropdown-container lightbox__dropdown-container--small')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.uiSelect,
					A2(
						$author$project$PinMeTo$Ui$Select$isDisabled,
						hasMaxAdditonal,
						$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
							A2(
								$author$project$PinMeTo$Ui$Select$withSearch,
								{
									searchMap: $author$project$Data$Location$NetworkCategories$getName,
									placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
									noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
								},
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'additional_category',
										items: filteredCategories,
										label: $elm$html$Html$text(categoryString),
										tagger: $author$project$Location$Details$PopupContent$Categories$UiSelectMsg,
										onChange: $author$project$Location$Details$PopupContent$Categories$SelectAdditionalCategory,
										itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
									})))))
				]));
	});
var $author$project$Location$Details$PopupContent$Categories$renderAdditionalCategoriesSection = F3(
	function (translations, model, categories) {
		var _v0 = model.network;
		if (_v0.$ === 'Tomtom') {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__input-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('lightbox__input-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$LocationDetail$PopUpContent$additionalCategory(translations))
							])),
						A3($author$project$Location$Details$PopupContent$Categories$renderAdditionalCategoriesDropdown, translations, categories, model)
					]));
		}
	});
var $author$project$Location$Details$PopupContent$Categories$view = F2(
	function (translations, model) {
		var lightboxContent = function () {
			var _v0 = model.allCategories;
			switch (_v0.$) {
				case 'Loaded':
					var categories = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__input-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('lightbox__input-label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$primaryCategory(translations))
											])),
										A4($author$project$Location$Details$PopupContent$Categories$renderPrimaryCategoriesDropdown, translations, categories, model.primaryCategory, model)
									])),
								A3($author$project$Location$Details$PopupContent$Categories$renderAdditionalCategoriesSection, translations, model, categories),
								A2($author$project$Location$Details$PopupContent$Categories$renderSelectedCategories, model.additionalCategories, model),
								A2($author$project$Location$Details$PopupContent$Categories$renderGoogleAlert, translations, model.network),
								A3($author$project$Location$Details$PopupContent$Categories$renderConfirmRemovalBanner, translations, model.additionalCategories, model.network)
							]));
				case 'Error':
					var e = _v0.a;
					var errorMessage = A2($elm$core$String$contains, 'message', e) ? A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'.',
						function (message) {
							return ': ' + message;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$drop,
								1,
								$elm$core$List$reverse(
									A2($elm$core$String$split, '\u0022', e))))) : (': ' + e);
					return $author$project$PinMeTo$Ui$Alert$render(
						A2(
							$author$project$PinMeTo$Ui$Alert$withStatus,
							$author$project$PinMeTo$Ui$Alert$Warning,
							$author$project$PinMeTo$Ui$Alert$plain(
								_Utils_ap(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(translations),
									errorMessage))));
				case 'Suspended':
					return $author$project$PinMeTo$Ui$Alert$render(
						A2(
							$author$project$PinMeTo$Ui$Alert$withStatus,
							$author$project$PinMeTo$Ui$Alert$Warning,
							$author$project$PinMeTo$Ui$Alert$plain(
								$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(translations))));
				default:
					return $author$project$PinMeTo$Ui$Spinner$spinner;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[lightboxContent]));
	});
var $author$project$PinMeTo$Ui$Layout$Flex$Row = {$: 'Row'};
var $author$project$PinMeTo$Ui$Layout$Flex$Column = {$: 'Column'};
var $author$project$PinMeTo$Ui$Date$string = F2(
	function (locale, x) {
		return A2(
			$author$project$PinMeTo$Ui$Date$String,
			x,
			$author$project$PinMeTo$Ui$Date$defaultConfig(locale));
	});
var $author$project$PinMeTo$Ui$Btn$FARegular = function (a) {
	return {$: 'FARegular', a: a};
};
var $author$project$FontAwesome$Regular$Icon$faCalendarDay = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-calendar-day');
var $author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall = function (t) {
	return A2($author$project$PinMeTo$Ui$Btn$pmtBtnCta_, 'pmt-btn--link pmt-btn--with-icon', t);
};
var $author$project$PinMeTo$Ui$DatePicker$renderToggle = F2(
	function (labelText, date) {
		if (date.$ === 'Just') {
			var x = date.a;
			return A3(
				$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
				$elm$html$Html$button,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Date$render(x)
					]));
		} else {
			return A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faCalendarDay),
				$elm$html$Html$button,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelText)
					]));
		}
	});
var $author$project$PinMeTo$Ui$Date$Disabled = {$: 'Disabled'};
var $author$project$PinMeTo$Ui$Date$withDisabled = function (date) {
	if (date.$ === 'Posix') {
		var x = date.a;
		var config = date.b;
		return A2(
			$author$project$PinMeTo$Ui$Date$Posix,
			x,
			_Utils_update(
				config,
				{display: $author$project$PinMeTo$Ui$Date$Disabled}));
	} else {
		var x = date.a;
		var config = date.b;
		return A2(
			$author$project$PinMeTo$Ui$Date$String,
			x,
			_Utils_update(
				config,
				{display: $author$project$PinMeTo$Ui$Date$Disabled}));
	}
};
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(_Utils_Tuple0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return _Utils_eq(
											c,
											_Utils_chr('-'));
									}),
									$elm$parser$Parser$succeed(_Utils_Tuple0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(_Utils_Tuple0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(_Utils_Tuple0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Advanced$commit = function (a) {
	return $elm$parser$Parser$Advanced$Parser(
		function (s) {
			return A3($elm$parser$Parser$Advanced$Good, true, a, s);
		});
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 'OrdinalDay', a: a};
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 'MonthAndDay', a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0.a;
	return $elm$parser$Parser$Advanced$Parser(
		function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 'Bad') {
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, false, x);
			} else {
				var a = _v1.b;
				var s1 = _v1.c;
				return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
			}
		});
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 'WeekAndWeekday', a: a, b: b};
	});
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (result.$ === 'Ok') {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$RD(
		$justinmimbs$date$Date$daysBeforeYear(y) + 1);
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn)) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				$justinmimbs$date$Date$daysBeforeYear(y) + od)) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$RD(
				($justinmimbs$date$Date$daysBeforeYear(y) + A2(
					$justinmimbs$date$Date$daysBeforeMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + d)) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 'MonthAndDay':
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 'WeekAndWeekday':
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.problem;
	if (problem.$ === 'Problem') {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq(
										_Utils_chr('T')))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($justinmimbs$date$Date$deadEndToString),
			$elm$core$String$join('; '))));
var $author$project$PinMeTo$Ui$DatePicker$valueAttribute = F4(
	function (attrib, value, f, attribs) {
		if (value.$ === 'Just') {
			var x = value.a;
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					attrib,
					f(x)),
				attribs);
		} else {
			return attribs;
		}
	});
var $author$project$PinMeTo$Ui$DatePicker$renderDatePicker = function (_v0) {
	var picker = _v0.a;
	return A3(
		$elm$html$Html$node,
		'pmt-date-picker',
		A4(
			$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
			'max-date',
			picker.config.maxDate,
			$justinmimbs$date$Date$toIsoString,
			A4(
				$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
				'min-date',
				picker.config.minDate,
				$justinmimbs$date$Date$toIsoString,
				A4(
					$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
					'max-millis',
					picker.config.max,
					A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt),
					A4(
						$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
						'min-millis',
						picker.config.min,
						A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt),
						A4(
							$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
							'date',
							picker.value,
							$justinmimbs$date$Date$toIsoString,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'date-changed',
									A2(
										$elm$json$Json$Decode$map,
										picker.onChange,
										A2(
											$elm$json$Json$Decode$andThen,
											function (x) {
												var _v1 = $justinmimbs$date$Date$fromIsoString(x);
												if (_v1.$ === 'Ok') {
													var date = _v1.a;
													return $elm$json$Json$Decode$succeed(date);
												} else {
													var error = _v1.a;
													return $elm$json$Json$Decode$fail(error);
												}
											},
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['detail', 'date']),
												$elm$json$Json$Decode$string)))),
									A2(
									$elm$html$Html$Attributes$attribute,
									'language',
									$author$project$PinMeTo$Ui$I18n$Language$toString(picker.config.language))
								])))))),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$never,
				A3(
					$elm$core$Basics$apR,
					picker.config.renderer,
					$elm$core$Maybe$withDefault(
						$author$project$PinMeTo$Ui$DatePicker$renderToggle(picker.config.selectDateLabel)),
					A2(
						$elm$core$Maybe$map,
						function (date) {
							return picker.config.disabled ? $author$project$PinMeTo$Ui$Date$withDisabled(
								A2(
									$author$project$PinMeTo$Ui$Date$withFormat,
									$author$project$PinMeTo$Ui$Date$FormatDate,
									A2(
										$author$project$PinMeTo$Ui$Date$string,
										picker.config.locale,
										$justinmimbs$date$Date$toIsoString(date)))) : A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatDate,
								A2(
									$author$project$PinMeTo$Ui$Date$string,
									picker.config.locale,
									$justinmimbs$date$Date$toIsoString(date)));
						},
						picker.value)))
			]));
};
var $author$project$PinMeTo$Ui$Date$WithIcons = {$: 'WithIcons'};
var $author$project$PinMeTo$Ui$Date$withIcons = function (date) {
	if (date.$ === 'Posix') {
		var x = date.a;
		var config = date.b;
		return A2(
			$author$project$PinMeTo$Ui$Date$Posix,
			x,
			_Utils_update(
				config,
				{icons: $author$project$PinMeTo$Ui$Date$WithIcons}));
	} else {
		var x = date.a;
		var config = date.b;
		return A2(
			$author$project$PinMeTo$Ui$Date$String,
			x,
			_Utils_update(
				config,
				{icons: $author$project$PinMeTo$Ui$Date$WithIcons}));
	}
};
var $author$project$PinMeTo$Ui$DatePicker$renderTimePicker = function (_v0) {
	var picker = _v0.a;
	return A3(
		$elm$html$Html$node,
		'pmt-date-picker',
		A4(
			$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
			'locale',
			$elm$core$Maybe$Just(picker.config.locale),
			$author$project$PinMeTo$Ui$I18n$Locale$toString,
			A4(
				$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
				'max-date',
				picker.config.maxDate,
				$justinmimbs$date$Date$toIsoString,
				A4(
					$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
					'min-date',
					picker.config.minDate,
					$justinmimbs$date$Date$toIsoString,
					A4(
						$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
						'max-millis',
						picker.config.max,
						A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt),
						A4(
							$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
							'min-millis',
							picker.config.min,
							A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt),
							A4(
								$author$project$PinMeTo$Ui$DatePicker$valueAttribute,
								'millis',
								picker.value,
								A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$core$String$fromInt),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$Events$on,
										'date-changed',
										A2(
											$elm$json$Json$Decode$map,
											picker.onChange,
											A2(
												$elm$json$Json$Decode$map,
												$elm$time$Time$millisToPosix,
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['detail', 'millis']),
													$elm$json$Json$Decode$int)))),
										A2($elm$html$Html$Attributes$attribute, 'enable-time', 'true'),
										A2(
										$elm$html$Html$Attributes$attribute,
										'language',
										$author$project$PinMeTo$Ui$I18n$Language$toString(picker.config.language))
									]))))))),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$never,
				A3(
					$elm$core$Basics$apR,
					picker.config.renderer,
					$elm$core$Maybe$withDefault(
						$author$project$PinMeTo$Ui$DatePicker$renderToggle(picker.config.selectDateLabel)),
					A2(
						$elm$core$Maybe$map,
						function (posix) {
							return $author$project$PinMeTo$Ui$Date$withIcons(
								A2($author$project$PinMeTo$Ui$Date$posix, picker.config.locale, posix));
						},
						picker.value)))
			]));
};
var $author$project$PinMeTo$Ui$DatePicker$render = function (config) {
	if (config.$ === 'Time') {
		var x = config.a;
		return $author$project$PinMeTo$Ui$DatePicker$renderTimePicker(x);
	} else {
		var x = config.a;
		return $author$project$PinMeTo$Ui$DatePicker$renderDatePicker(x);
	}
};
var $author$project$PinMeTo$Ui$Layout$Spacing$toClass = function (spacing) {
	switch (spacing.$) {
		case 'SpacingXXS':
			return 'xxs';
		case 'SpacingXS':
			return 'xs';
		case 'SpacingSM':
			return 'sm';
		case 'SpacingMD':
			return 'md';
		case 'SpacingLG':
			return 'lg';
		case 'SpacingXL':
			return 'xl';
		case 'SpacingXXL':
			return 'xxl';
		case 'SpacingXXXL':
			return 'xxxl';
		case 'Spacing4XL':
			return '4xl';
		default:
			return '5xl';
	}
};
var $author$project$PinMeTo$Ui$Layout$Spacing$gap = function (spacing) {
	return $elm$html$Html$Attributes$class(
		'pmt-gap-' + $author$project$PinMeTo$Ui$Layout$Spacing$toClass(spacing));
};
var $author$project$PinMeTo$Ui$Layout$Flex$wrap = function (isWrap) {
	return $elm$html$Html$Attributes$class(
		isWrap ? 'pmt-flex-wrap' : '');
};
var $author$project$PinMeTo$Ui$Layout$Flex$align = function (align_) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (align_.$) {
				case 'AlignStart':
					return 'pmt-align-start';
				case 'AlignCenter':
					return 'pmt-align-center';
				case 'AlignEnd':
					return 'pmt-align-end';
				case 'Stretch':
					return 'pmt-align-stretch';
				default:
					return 'pmt-align-baseline';
			}
		}());
};
var $author$project$PinMeTo$Ui$Layout$Spacing$spacingLayoutClasses = F2(
	function (property, layout) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (s) {
							return 'pmt-' + (property + ('-top-' + $author$project$PinMeTo$Ui$Layout$Spacing$toClass(s)));
						},
						layout.top),
						A2(
						$elm$core$Maybe$map,
						function (s) {
							return 'pmt-' + (property + ('-right-' + $author$project$PinMeTo$Ui$Layout$Spacing$toClass(s)));
						},
						layout.right),
						A2(
						$elm$core$Maybe$map,
						function (s) {
							return 'pmt-' + (property + ('-bottom-' + $author$project$PinMeTo$Ui$Layout$Spacing$toClass(s)));
						},
						layout.bottom),
						A2(
						$elm$core$Maybe$map,
						function (s) {
							return 'pmt-' + (property + ('-left-' + $author$project$PinMeTo$Ui$Layout$Spacing$toClass(s)));
						},
						layout.left)
					])));
	});
var $author$project$PinMeTo$Ui$Layout$Spacing$margin = function (layout) {
	return $elm$html$Html$Attributes$class(
		A2($author$project$PinMeTo$Ui$Layout$Spacing$spacingLayoutClasses, 'margin', layout));
};
var $author$project$PinMeTo$Ui$Layout$Flex$justify = function (justify_) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (justify_.$) {
				case 'Start':
					return 'pmt-justify-start';
				case 'Center':
					return 'pmt-justify-center';
				case 'End':
					return 'pmt-justify-end';
				case 'SpaceBetween':
					return 'pmt-justify-space-between';
				case 'SpaceAround':
					return 'pmt-justify-space-around';
				default:
					return 'pmt-justify-space-evenly';
			}
		}());
};
var $author$project$PinMeTo$Ui$Layout$Spacing$padding = function (layout) {
	return $elm$html$Html$Attributes$class(
		A2($author$project$PinMeTo$Ui$Layout$Spacing$spacingLayoutClasses, 'padding', layout));
};
var $author$project$PinMeTo$Ui$Layout$Flex$direction = function (direction_) {
	return $elm$html$Html$Attributes$class(
		function () {
			if (direction_.$ === 'Row') {
				return 'pmt-flex-row';
			} else {
				return 'pmt-flex-column';
			}
		}());
};
var $author$project$PinMeTo$Ui$Layout$Flex$optionalStyles = _List_fromArray(
	[
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.gap;
		},
		$elm$core$Maybe$map($author$project$PinMeTo$Ui$Layout$Spacing$gap)),
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.padding;
		},
		A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Layout$Spacing$padding, $elm$core$Maybe$Just)),
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.margin;
		},
		A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Layout$Spacing$margin, $elm$core$Maybe$Just)),
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.justify;
		},
		$elm$core$Maybe$map($author$project$PinMeTo$Ui$Layout$Flex$justify)),
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.align;
		},
		$elm$core$Maybe$map($author$project$PinMeTo$Ui$Layout$Flex$align)),
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.wrap;
		},
		$elm$core$Maybe$map($author$project$PinMeTo$Ui$Layout$Flex$wrap)),
		A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.direction;
		},
		$elm$core$Maybe$map($author$project$PinMeTo$Ui$Layout$Flex$direction))
	]);
var $author$project$PinMeTo$Ui$Layout$Flex$render = F2(
	function (children, config) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('pmt-flex'),
				_Utils_ap(
					A2(
						$elm$core$List$filterMap,
						function (f) {
							return f(config);
						},
						$author$project$PinMeTo$Ui$Layout$Flex$optionalStyles),
					config.attributes)),
			children);
	});
var $author$project$PinMeTo$Ui$Layout$Spacing$withGap = F2(
	function (spacing, config) {
		return _Utils_update(
			config,
			{
				gap: $elm$core$Maybe$Just(spacing)
			});
	});
var $author$project$PinMeTo$Ui$Layout$Flex$withWrap = function (config) {
	return _Utils_update(
		config,
		{
			wrap: $elm$core$Maybe$Just(true)
		});
};
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD = {$: 'SpacingMD'};
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM = {$: 'SpacingSM'};
var $author$project$PinMeTo$Ui$Layout$Flex$withAlign = F2(
	function (align_, config) {
		return _Utils_update(
			config,
			{
				align: $elm$core$Maybe$Just(align_)
			});
	});
var $author$project$PinMeTo$Ui$DatePicker$Date = function (a) {
	return {$: 'Date', a: a};
};
var $author$project$PinMeTo$Ui$DatePicker$DatePicker = function (a) {
	return {$: 'DatePicker', a: a};
};
var $author$project$PinMeTo$Ui$DatePicker$defaultConfig = F3(
	function (selectDateLabel, locale, language) {
		return {max: $elm$core$Maybe$Nothing, min: $elm$core$Maybe$Nothing, locale: locale, maxDate: $elm$core$Maybe$Nothing, minDate: $elm$core$Maybe$Nothing, disabled: false, language: language, renderer: $elm$core$Maybe$Nothing, selectDateLabel: selectDateLabel};
	});
var $author$project$PinMeTo$Ui$DatePicker$datePicker = function (_v0) {
	var selectDateLabel = _v0.selectDateLabel;
	var value = _v0.value;
	var language = _v0.language;
	var locale = _v0.locale;
	var onChange = _v0.onChange;
	return $author$project$PinMeTo$Ui$DatePicker$Date(
		$author$project$PinMeTo$Ui$DatePicker$DatePicker(
			{
				value: value,
				config: A3($author$project$PinMeTo$Ui$DatePicker$defaultConfig, selectDateLabel, locale, language),
				onChange: onChange
			}));
};
var $author$project$Translations$General$selectDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.select_date');
};
var $author$project$PinMeTo$Ui$Layout$Flex$AlignCenter = {$: 'AlignCenter'};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0.a;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		var millis = $elm$time$Time$posixToMillis(posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var millisecond = _v0.millisecond;
		var second = _v0.second;
		var minute = _v0.minute;
		var hour = _v0.hour;
		var day = _v0.day;
		var month = _v0.month;
		var year = _v0.year;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		{
			day: $justinmimbs$date$Date$day(date),
			hour: 0,
			year: $justinmimbs$date$Date$year(date),
			month: $justinmimbs$date$Date$month(date),
			minute: 0,
			second: 0,
			millisecond: 0
		});
};
var $author$project$PinMeTo$Ui$DatePicker$Time = function (a) {
	return {$: 'Time', a: a};
};
var $author$project$PinMeTo$Ui$DatePicker$TimePicker = function (a) {
	return {$: 'TimePicker', a: a};
};
var $author$project$PinMeTo$Ui$DatePicker$withMinTime = F2(
	function (posix, v) {
		if (v.$ === 'Time') {
			var x = v.a.a;
			var config = x.config;
			return $author$project$PinMeTo$Ui$DatePicker$Time(
				$author$project$PinMeTo$Ui$DatePicker$TimePicker(
					_Utils_update(
						x,
						{
							config: _Utils_update(
								config,
								{
									min: $elm$core$Maybe$Just(posix)
								})
						})));
		} else {
			var x = v.a.a;
			var config = x.config;
			return $author$project$PinMeTo$Ui$DatePicker$Date(
				$author$project$PinMeTo$Ui$DatePicker$DatePicker(
					_Utils_update(
						x,
						{
							config: _Utils_update(
								config,
								{
									min: $elm$core$Maybe$Just(posix)
								})
						})));
		}
	});
var $author$project$Location$Details$PopupContent$OpenStatus$SelectOption = function (a) {
	return {$: 'SelectOption', a: a};
};
var $author$project$PinMeTo$Ui$Layout$Flex$withDirection = F2(
	function (direction_, config) {
		return _Utils_update(
			config,
			{
				direction: $elm$core$Maybe$Just(direction_)
			});
	});
var $author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop = F2(
	function (spacing, config) {
		var margin_ = config.margin;
		return _Utils_update(
			config,
			{
				margin: _Utils_update(
					margin_,
					{
						top: $elm$core$Maybe$Just(spacing)
					})
			});
	});
var $author$project$Location$Details$PopupContent$OpenStatus$UpdateClosesOn = function (a) {
	return {$: 'UpdateClosesOn', a: a};
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$dayValue = ((24 * 60) * 60) * 1000;
var $author$project$Location$Details$PopupContent$TemporarilyClosed$addDaysToPosix = F2(
	function (numberOfDays, posixDate) {
		return $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(posixDate) + (numberOfDays * $author$project$Location$Details$PopupContent$TemporarilyClosed$dayValue));
	});
var $author$project$Location$Details$PopupContent$OpenStatus$DeleteScheduled = function (a) {
	return {$: 'DeleteScheduled', a: a};
};
var $author$project$Location$Details$PopupContent$OpenStatus$OpenForBusiness = {$: 'OpenForBusiness'};
var $author$project$Location$Details$PopupContent$OpenStatus$UpdateReopensOn = function (a) {
	return {$: 'UpdateReopensOn', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openForBusiness = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_for_business');
};
var $author$project$Location$Details$PopupContent$OpenStatus$UpdateClosedFrom = function (a) {
	return {$: 'UpdateClosedFrom', a: a};
};
var $author$project$Location$Details$PopupContent$OpenStatus$PermanentlyClosed = {$: 'PermanentlyClosed'};
var $author$project$Location$Details$PopupContent$OpenStatus$TemporarilyClosed = {$: 'TemporarilyClosed'};
var $author$project$Translations$General$locationTempClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_temp_closed');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosesOn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_closes_on');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusReopensOn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_reopens_on');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosedFrom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_closed_from');
};
var $author$project$Translations$General$locationPermanentlyClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_permanently_closed');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosureTooShort = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_closure_too_short');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusPermanentlyClosedWarning = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_permanently_closed_warning');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusScheduledToPermanentlyClose = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_scheduled_to_permanently_close');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusScheduledAsTemporarilyClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_scheduled_as_temporarily_closed');
};
var $author$project$Location$Details$PopupContent$OpenStatus$view = F2(
	function (translations, model) {
		var deleteScheduledButton = function (scheduleId) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('open-status__scheduled-delete'),
						$elm$html$Html$Events$onClick(
						$author$project$Location$Details$PopupContent$OpenStatus$DeleteScheduled(scheduleId))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('✕')
					]));
		};
		var scheduledDateHtml = function (posix) {
			return $author$project$PinMeTo$Ui$Date$render(
				A2(
					$author$project$PinMeTo$Ui$Date$withFormat,
					$author$project$PinMeTo$Ui$Date$FormatDate,
					A2($author$project$PinMeTo$Ui$Date$posix, model.locale, posix)));
		};
		var scheduledSection = F3(
			function (headerClass, headerLabel, rows) {
				return $elm$core$List$isEmpty(rows) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('open-status__scheduled')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('open-status__scheduled-header'),
									$elm$html$Html$Attributes$class(headerClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(headerLabel)
								])),
						rows));
			});
		var scheduledPermClosedSection = A3(
			scheduledSection,
			'open-status__scheduled-header--perm',
			$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusScheduledToPermanentlyClose(translations),
			A2(
				$elm$core$List$filterMap,
				function (scheduleUpdate) {
					var _v5 = scheduleUpdate.fieldAndData;
					if (_v5.$ === 'PermanentlyClosedField') {
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('open-status__scheduled-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosesOn(translations) + ':')
											])),
										scheduledDateHtml(scheduleUpdate.date),
										deleteScheduledButton(scheduleUpdate.scheduleId)
									])));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				model.scheduledUpdates));
		var scheduledTempClosedSection = A3(
			scheduledSection,
			'open-status__scheduled-header--temp',
			$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusScheduledAsTemporarilyClosed(translations),
			A2(
				$elm$core$List$filterMap,
				function (scheduleUpdate) {
					var _v3 = scheduleUpdate.fieldAndData;
					if ((_v3.$ === 'TemporarilyClosedField') && (_v3.a.$ === 'Until')) {
						var _v4 = _v3.a;
						var until = _v4.a;
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('open-status__scheduled-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosedFrom(translations) + ':')
											])),
										scheduledDateHtml(scheduleUpdate.date),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusReopensOn(translations) + ':')
											])),
										scheduledDateHtml(until),
										deleteScheduledButton(scheduleUpdate.scheduleId)
									])));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				model.scheduledUpdates));
		var todayPosix = model.now;
		var minReopensOnPosix = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			todayPosix,
			function (from) {
				return A2(
					$author$project$Location$Details$PopupContent$TemporarilyClosed$addDaysToPosix,
					7,
					$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(from));
			},
			model.selectedFromDate);
		return A2(
			$author$project$PinMeTo$Ui$Layout$Flex$render,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Radio$render(
					$author$project$PinMeTo$Ui$Form$Radio$radio(
						{
							label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openForBusiness(translations),
							checked: _Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$OpenForBusiness),
							onChange: function (_v0) {
								return $author$project$Location$Details$PopupContent$OpenStatus$SelectOption($author$project$Location$Details$PopupContent$OpenStatus$OpenForBusiness);
							}
						})),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Radio$render(
							$author$project$PinMeTo$Ui$Form$Radio$radio(
								{
									label: $author$project$Translations$General$locationTempClosed(translations),
									checked: _Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$TemporarilyClosed),
									onChange: function (_v1) {
										return $author$project$Location$Details$PopupContent$OpenStatus$SelectOption($author$project$Location$Details$PopupContent$OpenStatus$TemporarilyClosed);
									}
								})),
							_Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$TemporarilyClosed) ? A2(
							$author$project$PinMeTo$Ui$Layout$Flex$render,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosedFrom(translations) + ':')
										])),
									$author$project$PinMeTo$Ui$DatePicker$render(
									A2(
										$author$project$PinMeTo$Ui$DatePicker$withMinTime,
										todayPosix,
										$author$project$PinMeTo$Ui$DatePicker$datePicker(
											{
												value: model.selectedFromDate,
												locale: model.locale,
												language: model.language,
												onChange: $author$project$Location$Details$PopupContent$OpenStatus$UpdateClosedFrom,
												selectDateLabel: $author$project$Translations$General$selectDate(translations)
											}))),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusReopensOn(translations) + ':')
										])),
									$author$project$PinMeTo$Ui$DatePicker$render(
									A2(
										$author$project$PinMeTo$Ui$DatePicker$withMinTime,
										minReopensOnPosix,
										$author$project$PinMeTo$Ui$DatePicker$datePicker(
											{
												value: model.selectedUntilDate,
												locale: model.locale,
												language: model.language,
												onChange: $author$project$Location$Details$PopupContent$OpenStatus$UpdateReopensOn,
												selectDateLabel: $author$project$Translations$General$selectDate(translations)
											})))
								]),
							A2(
								$author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop,
								$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
								A2(
									$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
									$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
									$author$project$PinMeTo$Ui$Layout$Flex$withWrap(
										A2(
											$author$project$PinMeTo$Ui$Layout$Flex$withAlign,
											$author$project$PinMeTo$Ui$Layout$Flex$AlignCenter,
											A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)))))) : $elm$html$Html$text(''),
							_Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$TemporarilyClosed) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-top', '0.5rem')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Disclaimer,
										$author$project$PinMeTo$Ui$Alert$rich(
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosureTooShort(translations))
												]))))
								])) : $elm$html$Html$text(''),
							scheduledTempClosedSection
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Radio$render(
							$author$project$PinMeTo$Ui$Form$Radio$radio(
								{
									label: $author$project$Translations$General$locationPermanentlyClosed(translations),
									checked: _Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$PermanentlyClosed),
									onChange: function (_v2) {
										return $author$project$Location$Details$PopupContent$OpenStatus$SelectOption($author$project$Location$Details$PopupContent$OpenStatus$PermanentlyClosed);
									}
								})),
							_Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$PermanentlyClosed) ? A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Layout$Flex$render,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusClosesOn(translations) + ':')
												])),
											$author$project$PinMeTo$Ui$DatePicker$render(
											A2(
												$author$project$PinMeTo$Ui$DatePicker$withMinTime,
												todayPosix,
												$author$project$PinMeTo$Ui$DatePicker$datePicker(
													{
														value: model.selectedClosesOnDate,
														locale: model.locale,
														language: model.language,
														onChange: $author$project$Location$Details$PopupContent$OpenStatus$UpdateClosesOn,
														selectDateLabel: $author$project$Translations$General$selectDate(translations)
													})))
										]),
									A2(
										$author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop,
										$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
										A2(
											$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
											$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
											$author$project$PinMeTo$Ui$Layout$Flex$withWrap(
												A2(
													$author$project$PinMeTo$Ui$Layout$Flex$withAlign,
													$author$project$PinMeTo$Ui$Layout$Flex$AlignCenter,
													A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)))))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'margin-top', '0.5rem')
										]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Alert$render(
											A2(
												$author$project$PinMeTo$Ui$Alert$withStatus,
												$author$project$PinMeTo$Ui$Alert$Warning,
												$author$project$PinMeTo$Ui$Alert$rich(
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusPermanentlyClosedWarning(translations))
														]))))
										]))
								])) : $elm$html$Html$text(''),
							scheduledPermClosedSection
						]))
				]),
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD,
				A2(
					$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
					$author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD,
					A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex))));
	});
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$PinMeTo$Ui$TemplateTags$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$TemplateTags$Surrounding = {$: 'Surrounding'};
var $author$project$PinMeTo$Ui$TemplateTags$view = function (tags) {
	return $author$project$PinMeTo$Ui$TemplateTags$View(
		{tags: tags, targets: $author$project$PinMeTo$Ui$TemplateTags$Surrounding, onInserted: $elm$core$Maybe$Nothing, dataTestAttribute: $elm$core$Maybe$Nothing});
};
var $author$project$PinMeTo$Ui$Form$Input$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$withLabel = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					label: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Form$Input$Label(
							$elm$html$Html$text(x)))
				}));
	});
var $author$project$Location$Details$PopupContent$ActionLinks$UrlChanged = F2(
	function (a, b) {
		return {$: 'UrlChanged', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$shopOnline = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.place_action_types.shop_online');
};
var $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$appointment = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.place_action_types.appointment');
};
var $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$foodTakeout = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.place_action_types.food_takeout');
};
var $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$foodDelivery = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.place_action_types.food_delivery');
};
var $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$foodOrdering = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.place_action_types.food_ordering');
};
var $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$diningReservation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.place_action_types.dining_reservation');
};
var $author$project$Data$Location$ActionLinks$typeToLabel = F2(
	function (type_, translations) {
		switch (type_.$) {
			case 'ShopOnline':
				return $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$shopOnline(translations);
			case 'BookAppointment':
				return $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$appointment(translations);
			case 'ReserveTable':
				return $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$diningReservation(translations);
			case 'OrderFood':
				return $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$foodOrdering(translations);
			case 'OrderFoodTakeout':
				return $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$foodTakeout(translations);
			default:
				return $author$project$Translations$Listings$LocationDetail$PlaceActionTypes$foodDelivery(translations);
		}
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$homepageInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.homepage_invalid');
};
var $author$project$Location$Details$PopupContent$ActionLinks$errorToString = F2(
	function (translations, error) {
		return $author$project$Translations$Listings$LocationDetail$PopUpContent$homepageInvalid(translations);
	});
var $author$project$Location$Details$PopupContent$ActionLinks$renderRow = F2(
	function (translations, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-links__row')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withError,
						A2(
							$elm$core$Maybe$map,
							$author$project$Location$Details$PopupContent$ActionLinks$errorToString(translations),
							row.error),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
							'https://...',
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withLabel,
								A2($author$project$Data$Location$ActionLinks$typeToLabel, row.type_, translations),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{
										value: row.url,
										onChange: $author$project$Location$Details$PopupContent$ActionLinks$UrlChanged(row.type_)
									})))))
				]));
	});
var $author$project$PinMeTo$Ui$TemplateTags$Selector = function (a) {
	return {$: 'Selector', a: a};
};
var $author$project$PinMeTo$Ui$TemplateTags$withTargets = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$TemplateTags$View(
			_Utils_update(
				config,
				{
					targets: $author$project$PinMeTo$Ui$TemplateTags$Selector(x)
				}));
	});
var $author$project$PinMeTo$Ui$TemplateTags$Tag = function (a) {
	return {$: 'Tag', a: a};
};
var $author$project$PinMeTo$Ui$TemplateTags$tag = F2(
	function (label, value) {
		return $author$project$PinMeTo$Ui$TemplateTags$Tag(
			{label: label, value: value, description: $elm$core$Maybe$Nothing});
	});
var $author$project$PinMeTo$Ui$TemplateTags$withDescription = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$TemplateTags$Tag(
			_Utils_update(
				config,
				{
					description: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsNetworkLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_network_label');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsStoreIdLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_store_id_label');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsNetworkDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_network_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsStoreIdDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_store_id_description');
};
var $author$project$Location$Details$PopupContent$ActionLinks$templateTags = function (translations) {
	return _List_fromArray(
		[
			A2(
			$author$project$PinMeTo$Ui$TemplateTags$withDescription,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsNetworkDescription(translations),
			A2(
				$author$project$PinMeTo$Ui$TemplateTags$tag,
				$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsNetworkLabel(translations),
				'{{network}}')),
			A2(
			$author$project$PinMeTo$Ui$TemplateTags$withDescription,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsStoreIdDescription(translations),
			A2(
				$author$project$PinMeTo$Ui$TemplateTags$tag,
				$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsStoreIdLabel(translations),
				'{{storeid}}'))
		]);
};
var $author$project$Location$Details$PopupContent$ActionLinks$TemplateTagsMsg = function (a) {
	return {$: 'TemplateTagsMsg', a: a};
};
var $author$project$Data$Location$ActionLinks$OrderFood = {$: 'OrderFood'};
var $author$project$Data$Location$ActionLinks$ShopOnline = {$: 'ShopOnline'};
var $author$project$Data$Location$ActionLinks$ReserveTable = {$: 'ReserveTable'};
var $author$project$Data$Location$ActionLinks$BookAppointment = {$: 'BookAppointment'};
var $author$project$Data$Location$ActionLinks$OrderFoodTakeout = {$: 'OrderFoodTakeout'};
var $author$project$Data$Location$ActionLinks$OrderFoodDelivery = {$: 'OrderFoodDelivery'};
var $author$project$Location$Details$PopupContent$ActionLinks$allTypes = _List_fromArray(
	[$author$project$Data$Location$ActionLinks$ShopOnline, $author$project$Data$Location$ActionLinks$BookAppointment, $author$project$Data$Location$ActionLinks$ReserveTable, $author$project$Data$Location$ActionLinks$OrderFood, $author$project$Data$Location$ActionLinks$OrderFoodTakeout, $author$project$Data$Location$ActionLinks$OrderFoodDelivery]);
var $author$project$Location$Details$PopupContent$ActionLinks$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Location$Details$PopupContent$ActionLinks$PreferredChanged = function (a) {
	return {$: 'PreferredChanged', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPreferredAction = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_preferred_action');
};
var $author$project$Location$Details$PopupContent$ActionLinks$renderPreferred = F2(
	function (translations, model) {
		var itemLabel = function (maybeType) {
			if (maybeType.$ === 'Just') {
				var type_ = maybeType.a;
				return $elm$html$Html$text(
					A2($author$project$Data$Location$ActionLinks$typeToLabel, type_, translations));
			} else {
				return $elm$html$Html$text('-');
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-links-preferred')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-input__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPreferredAction(translations))
						])),
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.uiSelect,
					$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
						$author$project$PinMeTo$Ui$Select$view(
							{
								uid: 'action_links_preferred',
								items: A2(
									$elm$core$List$cons,
									$elm$core$Maybe$Nothing,
									A2($elm$core$List$map, $elm$core$Maybe$Just, $author$project$Location$Details$PopupContent$ActionLinks$allTypes)),
								label: itemLabel(model.preferred),
								tagger: $author$project$Location$Details$PopupContent$ActionLinks$UiSelectMsg,
								onChange: $author$project$Location$Details$PopupContent$ActionLinks$PreferredChanged,
								itemRender: itemLabel
							})))
				]));
	});
var $author$project$PinMeTo$Ui$TemplateTags$tagView = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$button,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('pmt-ui-template-tags__tag'),
					A2($elm$html$Html$Attributes$attribute, 'data-template-tag', config.value)
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$html$Html$Attributes$title, $elm$core$List$singleton),
					config.description))),
		_List_fromArray(
			[
				$elm$html$Html$text(config.label)
			]));
};
var $author$project$PinMeTo$Ui$TemplateTags$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$PinMeTo$Ui$TemplateTags$Plain = function (a) {
	return {$: 'Plain', a: a};
};
var $author$project$PinMeTo$Ui$TemplateTags$Replaced = F2(
	function (a, b) {
		return {$: 'Replaced', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$TemplateTags$sampleValue = function (key) {
	switch (key) {
		case 'storeId':
			return 'PL-014';
		case 'network':
			return 'google';
		case 'name':
			return 'PinMeTo';
		case 'city':
			return 'Malmö';
		default:
			return '{{' + (key + '}}');
	}
};
var $author$project$PinMeTo$Ui$TemplateTags$toReplacedParts = function (segment) {
	var _v0 = A2($elm$core$String$split, '}}', segment);
	if (_v0.b) {
		var key = _v0.a;
		var after = _v0.b;
		return _List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Ui$TemplateTags$Replaced,
				'{{' + (key + '}}'),
				$author$project$PinMeTo$Ui$TemplateTags$sampleValue(key)),
				$author$project$PinMeTo$Ui$TemplateTags$Plain(
				A2($elm$core$String$join, '}}', after))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$PinMeTo$Ui$TemplateTags$toExampleParts = function (x) {
	var _v0 = A2($elm$core$String$split, '{{', x);
	if (_v0.b) {
		var first = _v0.a;
		var rest = _v0.b;
		return A2(
			$elm$core$List$cons,
			$author$project$PinMeTo$Ui$TemplateTags$Plain(first),
			A2($elm$core$List$concatMap, $author$project$PinMeTo$Ui$TemplateTags$toReplacedParts, rest));
	} else {
		return _List_Nil;
	}
};
var $author$project$PinMeTo$Ui$TemplateTags$helpExample = function (example) {
	var partView = F2(
		function (pick, part) {
			if (part.$ === 'Plain') {
				var x = part.a;
				return $elm$html$Html$text(x);
			} else {
				var tagText = part.a;
				var value = part.b;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-highlight')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(pick, tagText, value))
						]));
			}
		});
	var parts = $author$project$PinMeTo$Ui$TemplateTags$toExampleParts(example);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-example')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$code,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-example-part')
					]),
				A2(
					$elm$core$List$map,
					partView($elm$core$Basics$always),
					parts)),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-arrow')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('→')
					])),
				A2(
				$elm$html$Html$code,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-example-part')
					]),
				A2(
					$elm$core$List$map,
					partView(
						F2(
							function (_v0, value) {
								return value;
							})),
					parts))
			]));
};
var $author$project$PinMeTo$Ui$TemplateTags$helpHeading = function (x) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-heading')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(x)
			]));
};
var $author$project$PinMeTo$Ui$TemplateTags$helpParagraph = function (x) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-template-tags__help-paragraph')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(x)
			]));
};
var $author$project$PinMeTo$Ui$TemplateTags$helpContent = function (labels) {
	return _List_fromArray(
		[
			$author$project$PinMeTo$Ui$TemplateTags$helpHeading(labels.helpTitle),
			$author$project$PinMeTo$Ui$TemplateTags$helpParagraph(labels.helpIntro),
			$author$project$PinMeTo$Ui$TemplateTags$helpHeading(labels.linksHeading),
			$author$project$PinMeTo$Ui$TemplateTags$helpParagraph(labels.linksDescription),
			$author$project$PinMeTo$Ui$TemplateTags$helpExample('example.com/{{storeId}}?utm_source={{network}}'),
			$author$project$PinMeTo$Ui$TemplateTags$helpHeading(labels.textHeading),
			$author$project$PinMeTo$Ui$TemplateTags$helpParagraph(labels.textDescription),
			$author$project$PinMeTo$Ui$TemplateTags$helpExample(labels.textExample)
		]);
};
var $author$project$PinMeTo$Ui$TemplateTags$headerView = function (_v0) {
	var state = _v0.state;
	var tagger = _v0.tagger;
	var labels = _v0.labels;
	var label = _v0.label;
	var uid = _v0.uid;
	var _v1 = state;
	var popOverState = _v1.a;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-template-tags__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-template-tags__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-template-tags__help')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							popOverState,
							$author$project$PinMeTo$Ui$PopOver$view(
								{
									uid: uid,
									tagger: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$TemplateTags$PopOverMsg, tagger),
									content: $author$project$PinMeTo$Ui$TemplateTags$helpContent(labels),
									preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
								}))
						]))
				]))
		]);
};
var $author$project$PinMeTo$Ui$TemplateTags$appendTargets = F2(
	function (targets, attributes) {
		switch (targets.$) {
			case 'Selector':
				var x = targets.a;
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'targets', x),
					attributes);
			case 'Ids':
				var ids = targets.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$attribute,
						'for',
						A2($elm$core$String$join, ' ', ids)),
					attributes);
			default:
				return attributes;
		}
	});
var $author$project$PinMeTo$Ui$TemplateTags$appendOnInserted = F2(
	function (onInserted, attributes) {
		return A2(
			$elm$core$Maybe$withDefault,
			attributes,
			A2(
				$elm$core$Maybe$map,
				function (msg) {
					return A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Events$on,
							'template-tag-inserted',
							A2(
								$elm$json$Json$Decode$map,
								msg,
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['detail', 'value']),
									$elm$json$Json$Decode$string))),
						attributes);
				},
				onInserted));
	});
var $author$project$PinMeTo$Ui$TemplateTags$appendDataTestAttribute = F2(
	function (x, attributes) {
		return A2(
			$elm$core$List$cons,
			$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$getAttributeString, x))),
			attributes);
	});
var $author$project$PinMeTo$Ui$TemplateTags$renderHelper = F2(
	function (header, _v0) {
		var config = _v0.a;
		return A3(
			$elm$html$Html$node,
			'pmt-template-tags',
			A2(
				$author$project$PinMeTo$Ui$TemplateTags$appendDataTestAttribute,
				config.dataTestAttribute,
				A2(
					$author$project$PinMeTo$Ui$TemplateTags$appendOnInserted,
					config.onInserted,
					A2(
						$author$project$PinMeTo$Ui$TemplateTags$appendTargets,
						config.targets,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-template-tags')
							])))),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$TemplateTags$headerView, header)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-template-tags__tags')
							]),
						A2($elm$core$List$map, $author$project$PinMeTo$Ui$TemplateTags$tagView, config.tags))
					])));
	});
var $author$project$PinMeTo$Ui$TemplateTags$renderWithHeader = F6(
	function (uid, label, labels, tagger, state, config) {
		return A2(
			$author$project$PinMeTo$Ui$TemplateTags$renderHelper,
			$elm$core$Maybe$Just(
				{uid: uid, label: label, state: state, labels: labels, tagger: tagger}),
			config);
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsHelpIntro = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_help_intro');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsHelpTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_help_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsTextExample = F3(
	function (translations, name, city) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.pop_up_content.action_links_template_tags_text_example',
			_List_fromArray(
				[
					_Utils_Tuple2('name', name),
					_Utils_Tuple2('city', city)
				]));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsTextHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_text_heading');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsLinksHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_links_heading');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsTextDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_text_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsLinksDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_links_description');
};
var $author$project$Location$Details$PopupContent$ActionLinks$templateTagsLabels = function (translations) {
	return {
		helpIntro: $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsHelpIntro(translations),
		helpTitle: $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsHelpTitle(translations),
		textExample: A3($author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsTextExample, translations, '{{name}}', '{{city}}'),
		textHeading: $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsTextHeading(translations),
		linksHeading: $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsLinksHeading(translations),
		textDescription: $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsTextDescription(translations),
		linksDescription: $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsLinksDescription(translations)
	};
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Location$Details$PopupContent$ActionLinks$appleBusinessHelpUrl = 'https://help.pinmeto.com/en/article/apple-business-rlxj1e/';
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksAppleBusinessLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_apple_business_link');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksAppleBusinessRequired = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_apple_business_required');
};
var $author$project$Location$Details$PopupContent$ActionLinks$appleBusinessBanner = F2(
	function (translations, model) {
		return model.showAppleBusinessBanner ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-links__banner')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Note,
						$author$project$PinMeTo$Ui$Alert$rich(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksAppleBusinessRequired(translations) + ' '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href($author$project$Location$Details$PopupContent$ActionLinks$appleBusinessHelpUrl),
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$rel('noopener noreferrer')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksAppleBusinessLink(translations))
										]))
								]))))
				])) : $elm$html$Html$text('');
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_template_tags_header');
};
var $author$project$Location$Details$PopupContent$ActionLinks$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-links')
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Location$Details$PopupContent$ActionLinks$appleBusinessBanner, translations, model),
				A2(
					$elm$core$List$cons,
					A2($author$project$Location$Details$PopupContent$ActionLinks$renderPreferred, translations, model),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$hr,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-links__divider')
								]),
							_List_Nil),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-links__template-tags')
									]),
								_List_fromArray(
									[
										A6(
										$author$project$PinMeTo$Ui$TemplateTags$renderWithHeader,
										'action-links-template-tags',
										$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksTemplateTagsHeader(translations),
										$author$project$Location$Details$PopupContent$ActionLinks$templateTagsLabels(translations),
										$author$project$Location$Details$PopupContent$ActionLinks$TemplateTagsMsg,
										model.templateTagsState,
										A2(
											$author$project$PinMeTo$Ui$TemplateTags$withTargets,
											'.action-links__row',
											$author$project$PinMeTo$Ui$TemplateTags$view(
												$author$project$Location$Details$PopupContent$ActionLinks$templateTags(translations))))
									])),
							A2(
								$elm$core$List$map,
								$author$project$Location$Details$PopupContent$ActionLinks$renderRow(translations),
								model.rows))))));
	});
var $author$project$Location$Details$PopupContent$OpeningDate$UpdateOpeningDate = function (a) {
	return {$: 'UpdateOpeningDate', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openingDateLightBoxNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.opening_date_light_box_note');
};
var $author$project$Location$Details$PopupContent$OpeningDate$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$DatePicker$render(
					$author$project$PinMeTo$Ui$DatePicker$datePicker(
						{
							value: model.selectedDate,
							locale: model.locale,
							language: model.language,
							onChange: $author$project$Location$Details$PopupContent$OpeningDate$UpdateOpeningDate,
							selectDateLabel: $author$project$Translations$General$selectDate(translations)
						})),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__more-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('opening-date__note-margin')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$openingDateLightBoxNote(translations))
								]))
						]))
				]));
	});
var $author$project$Location$Details$PopupContent$StorefrontName$checkMinLength = function (input) {
	return ($elm$core$String$length(
		$elm$core$String$trim(input)) >= 2) ? true : false;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_invalid');
};
var $author$project$Location$Details$PopupContent$StorefrontName$validationErrors = F2(
	function (translations, model) {
		var list = _List_Nil;
		return (!$author$project$Location$Details$PopupContent$StorefrontName$checkMinLength(model.storefrontNameString)) ? A2(
			$elm$core$List$cons,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontInvalid(translations),
			list) : list;
	});
var $author$project$Location$Details$PopupContent$StorefrontName$renderAlert = F2(
	function (translations, model) {
		var err = A2($author$project$Location$Details$PopupContent$StorefrontName$validationErrors, translations, model);
		return ($elm$core$List$length(err) > 0) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Warning,
				$author$project$PinMeTo$Ui$Alert$plain(
					'Error: ' + A2($elm$core$String$join, ',', err)))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
	});
var $author$project$Location$Details$PopupContent$StorefrontName$PtvCustomNameMsg = function (a) {
	return {$: 'PtvCustomNameMsg', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$AppleCustomNameMsg = function (a) {
	return {$: 'AppleCustomNameMsg', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$GoogleCustomNameMsg = function (a) {
	return {$: 'GoogleCustomNameMsg', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$UpdateStorefrontName = function (a) {
	return {$: 'UpdateStorefrontName', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$FacebookCustomNameMsg = function (a) {
	return {$: 'FacebookCustomNameMsg', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Location$Details$PopupContent$CustomNameOnNetwork$UpdateCustomName = function (a) {
	return {$: 'UpdateCustomName', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$renderCustomNameField = F6(
	function (labelText, tooltipText, uid, popOverState, tagger, cnModel) {
		var _v0 = function () {
			var _v1 = cnModel.customName;
			if (_v1.$ === 'ValidCustomNameOnNetwork') {
				var x = _v1.a;
				return _Utils_Tuple2(x, $elm$core$Maybe$Nothing);
			} else {
				var x = _v1.a;
				var errMsg = _v1.b.a;
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(x)) ? _Utils_Tuple2(x, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
					x,
					$elm$core$Maybe$Just(errMsg));
			}
		}();
		var customNameString = _v0.a;
		var maybeError = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-input__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							popOverState,
							$author$project$PinMeTo$Ui$PopOver$view(
								{
									uid: uid,
									tagger: $author$project$Location$Details$PopupContent$StorefrontName$PopOverMsg,
									content: _List_fromArray(
										[
											$elm$html$Html$text(tooltipText)
										]),
									preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
								}))
						])),
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withError,
						maybeError,
						$author$project$PinMeTo$Ui$Form$Input$text(
							{
								value: customNameString,
								onChange: A2($elm$core$Basics$composeR, $author$project$Location$Details$PopupContent$CustomNameOnNetwork$UpdateCustomName, tagger)
							})))
				]));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPlaceHolder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_place_holder');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPtvCustomNameLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_ptv_custom_name_label');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontAppleCustomNameLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_apple_custom_name_label');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPtvCustomNameTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_ptv_custom_name_tooltip');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontGoogleCustomNameLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_google_custom_name_label');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontAppleCustomNameTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_apple_custom_name_tooltip');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontFacebookCustomNameLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_facebook_custom_name_label');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontGoogleCustomNameTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_google_custom_name_tooltip');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontFacebookCustomNameTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_facebook_custom_name_tooltip');
};
var $author$project$Location$Details$PopupContent$StorefrontName$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withDisabled,
						!model.canEditName,
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPlaceHolder(translations),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{value: model.storefrontNameString, onChange: $author$project$Location$Details$PopupContent$StorefrontName$UpdateStorefrontName}))))),
					A2($author$project$Location$Details$PopupContent$StorefrontName$renderAlert, translations, model),
					model.networkEnabled.google ? A6(
					$author$project$Location$Details$PopupContent$StorefrontName$renderCustomNameField,
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontGoogleCustomNameLabel(translations),
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontGoogleCustomNameTooltip(translations),
					'storefront-google-custom-name-popover',
					model.popOverState,
					$author$project$Location$Details$PopupContent$StorefrontName$GoogleCustomNameMsg,
					model.googleCustomName) : $elm$html$Html$text(''),
					model.networkEnabled.facebook ? A6(
					$author$project$Location$Details$PopupContent$StorefrontName$renderCustomNameField,
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontFacebookCustomNameLabel(translations),
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontFacebookCustomNameTooltip(translations),
					'storefront-facebook-custom-name-popover',
					model.popOverState,
					$author$project$Location$Details$PopupContent$StorefrontName$FacebookCustomNameMsg,
					model.facebookCustomName) : $elm$html$Html$text(''),
					model.networkEnabled.apple ? A6(
					$author$project$Location$Details$PopupContent$StorefrontName$renderCustomNameField,
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontAppleCustomNameLabel(translations),
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontAppleCustomNameTooltip(translations),
					'storefront-apple-custom-name-popover',
					model.popOverState,
					$author$project$Location$Details$PopupContent$StorefrontName$AppleCustomNameMsg,
					model.appleCustomName) : $elm$html$Html$text(''),
					model.networkEnabled.ptv ? A6(
					$author$project$Location$Details$PopupContent$StorefrontName$renderCustomNameField,
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPtvCustomNameLabel(translations),
					$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPtvCustomNameTooltip(translations),
					'storefront-ptv-custom-name-popover',
					model.popOverState,
					$author$project$Location$Details$PopupContent$StorefrontName$PtvCustomNameMsg,
					model.ptvCustomName) : $elm$html$Html$text('')
				]));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$SetValue = F2(
	function (a, b) {
		return {$: 'SetValue', a: a, b: b};
	});
var $author$project$Translations$General$select = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.select');
};
var $author$project$Location$Details$PopupContent$SocialMessaging$SelectEnum = F2(
	function (a, b) {
		return {$: 'SelectEnum', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$UiSelectMsg = F2(
	function (a, b) {
		return {$: 'UiSelectMsg', a: a, b: b};
	});
var $author$project$FontAwesome$Solid$Icon$faChevronDown = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-chevron-down');
var $author$project$PinMeTo$Ui$Select$ButtonStyle = function (a) {
	return {$: 'ButtonStyle', a: a};
};
var $author$project$PinMeTo$Ui$Select$UiButtonToggle = function (a) {
	return {$: 'UiButtonToggle', a: a};
};
var $author$project$PinMeTo$Ui$Select$uiButtonToggle = function (label) {
	return $author$project$PinMeTo$Ui$Select$UiButtonToggle(
		{
			icon: $elm$core$Maybe$Nothing,
			size: $author$project$PinMeTo$Ui$Button$Medium,
			label: label,
			style: $author$project$PinMeTo$Ui$Select$ButtonStyle(
				$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedNeutral))
		});
};
var $author$project$PinMeTo$Ui$Select$viewWithToggle = F2(
	function (config, toggle) {
		return A2(
			$author$project$PinMeTo$Ui$Select$configWithRenderer,
			{
				uid: $author$project$PinMeTo$Ui$Select$Uid(config.uid),
				items: config.items,
				tagger: config.tagger,
				toggle: toggle
			},
			$author$project$PinMeTo$Ui$Select$Default(
				{render: config.itemRender, onChange: config.onChange}));
	});
var $author$project$PinMeTo$Ui$Select$ToggleIconAfter = function (a) {
	return {$: 'ToggleIconAfter', a: a};
};
var $author$project$PinMeTo$Ui$Select$uiButtonToggleWithIcon = F2(
	function (toggleIcon, toggle) {
		if (toggle.$ === 'LegacyToggle') {
			var config = toggle.a;
			return $author$project$PinMeTo$Ui$Select$LegacyToggle(config);
		} else {
			var config = toggle.a;
			return $author$project$PinMeTo$Ui$Select$UiButtonToggle(
				_Utils_update(
					config,
					{
						icon: $elm$core$Maybe$Just(toggleIcon)
					}));
		}
	});
var $author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter = F2(
	function (icon, toggle) {
		return A2(
			$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIcon,
			$author$project$PinMeTo$Ui$Select$ToggleIconAfter(icon),
			toggle);
	});
var $author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonSize = F2(
	function (buttonSize, toggle) {
		if (toggle.$ === 'LegacyToggle') {
			var config = toggle.a;
			return $author$project$PinMeTo$Ui$Select$LegacyToggle(config);
		} else {
			var config = toggle.a;
			return $author$project$PinMeTo$Ui$Select$UiButtonToggle(
				_Utils_update(
					config,
					{size: buttonSize}));
		}
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$viewEnumSelect = F2(
	function (translations, field) {
		var selectedLabel = function () {
			var _v0 = A2(
				$elm$core$List$filter,
				function (meta) {
					return _Utils_eq(meta.value, field.value);
				},
				field.attribute.valueMetaData);
			if (_v0.b) {
				var meta = _v0.a;
				return meta.displayName;
			} else {
				return $author$project$Translations$General$select(translations);
			}
		}();
		return A2(
			$author$project$PinMeTo$Ui$Select$render,
			field.selectState,
			A2(
				$author$project$PinMeTo$Ui$Select$viewWithToggle,
				{
					uid: 'social-messaging-' + field.attribute.attributeId,
					items: field.attribute.valueMetaData,
					tagger: $author$project$Location$Details$PopupContent$SocialMessaging$UiSelectMsg(field.attribute.attributeId),
					onChange: function (meta) {
						return A2($author$project$Location$Details$PopupContent$SocialMessaging$SelectEnum, field.attribute.attributeId, meta.value);
					},
					itemRender: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.displayName;
						},
						$elm$html$Html$text)
				},
				A2(
					$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonSize,
					$author$project$PinMeTo$Ui$Button$Small,
					A2(
						$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter,
						$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faChevronDown),
						$author$project$PinMeTo$Ui$Select$uiButtonToggle(selectedLabel)))));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$viewField = F3(
	function (translations, urlErrors, field) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('social-messaging__field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('social-messaging__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(field.attribute.displayName)
						])),
					function () {
					var _v0 = field.attribute.valueType;
					if (_v0 === 'ENUM') {
						return A2($author$project$Location$Details$PopupContent$SocialMessaging$viewEnumSelect, translations, field);
					} else {
						return $author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withError,
								A2($elm$core$Dict$get, field.attribute.attributeId, urlErrors),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{
										value: field.value,
										onChange: $author$project$Location$Details$PopupContent$SocialMessaging$SetValue(field.attribute.attributeId)
									})));
					}
				}()
				]));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$view = F3(
	function (translations, _v0, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('social-messaging')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Location$Details$PopupContent$SocialMessaging$viewField, translations, model.urlErrors),
				model.fields));
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$RemoveRow = function (a) {
	return {$: 'RemoveRow', a: a};
};
var $author$project$Common$Util$onClickFinal = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$Translations$General$no = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no');
};
var $author$project$Translations$General$yes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.yes');
};
var $author$project$PinMeTo$Ui$Button$FASolid = function (a) {
	return {$: 'FASolid', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$SetUrlValue = F2(
	function (a, b) {
		return {$: 'SetUrlValue', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$SetBoolValue = F2(
	function (a, b) {
		return {$: 'SetBoolValue', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$SetEnumValue = F2(
	function (a, b) {
		return {$: 'SetEnumValue', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$urlPlaceholder = function (attr) {
	var _v0 = attr.attributeId;
	switch (_v0) {
		case 'url_whatsapp':
			return 'https://wa.me/46123456789';
		case 'url_text_messaging':
			return 'sms:+46123456789';
		default:
			return 'https://';
	}
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectValueMsg = F2(
	function (a, b) {
		return {$: 'UiSelectValueMsg', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$ToggleRepeatedEnumSetValue = F2(
	function (a, b) {
		return {$: 'ToggleRepeatedEnumSetValue', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewValueWidget = F4(
	function (translations, urlErrors, row, attr) {
		var _v0 = attr.valueType;
		switch (_v0) {
			case 'BOOL':
				var isChecked = function () {
					var _v1 = row.value;
					if (_v1.$ === 'BoolValue') {
						var b = _v1.a;
						return b;
					} else {
						return false;
					}
				}();
				var btnText = isChecked ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations);
				var icon = isChecked ? $author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faCheck) : $author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faXmark);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-attributes__boolean-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(attr.displayName),
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								A2($author$project$Location$Details$PopupContent$GoogleAttributes$SetBoolValue, row.id, !isChecked),
								A2(
									$author$project$PinMeTo$Ui$Button$withSize,
									$author$project$PinMeTo$Ui$Button$Small,
									A2(
										$author$project$PinMeTo$Ui$Button$withIconAfter,
										icon,
										$author$project$PinMeTo$Ui$Button$buttonGhost(btnText)))))
						]));
			case 'ENUM':
				var selectedLabel = function () {
					var _v2 = row.value;
					if (_v2.$ === 'EnumValue') {
						var val = _v2.a;
						var _v3 = A2(
							$elm$core$List$filter,
							function (m) {
								return _Utils_eq(m.value, val);
							},
							attr.valueMetaData);
						if (_v3.b) {
							var meta = _v3.a;
							return meta.displayName;
						} else {
							return (val === '') ? $author$project$Translations$General$select(translations) : val;
						}
					} else {
						return $author$project$Translations$General$select(translations);
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-attributes__enum-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(attr.displayName),
							A2(
							$author$project$PinMeTo$Ui$Select$render,
							row.uiSelectValueState,
							A2(
								$author$project$PinMeTo$Ui$Select$viewWithToggle,
								{
									uid: 'google-attr-value-' + $elm$core$String$fromInt(row.id),
									items: attr.valueMetaData,
									tagger: $author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectValueMsg(row.id),
									onChange: function (meta) {
										return A2($author$project$Location$Details$PopupContent$GoogleAttributes$SetEnumValue, row.id, meta.value);
									},
									itemRender: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.displayName;
										},
										$elm$html$Html$text)
								},
								A2(
									$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonSize,
									$author$project$PinMeTo$Ui$Button$Small,
									A2(
										$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter,
										$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faChevronDown),
										$author$project$PinMeTo$Ui$Select$uiButtonToggle(selectedLabel)))))
						]));
			case 'URL':
				var error = A2($elm$core$Dict$get, attr.attributeId, urlErrors);
				var url = function () {
					var _v4 = row.value;
					if (_v4.$ === 'UrlValue') {
						var val = _v4.a;
						return val;
					} else {
						return '';
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-attributes__url-value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(attr.displayName),
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withError,
								error,
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
									$author$project$Location$Details$PopupContent$GoogleAttributes$urlPlaceholder(attr),
									$author$project$PinMeTo$Ui$Form$Input$text(
										{
											value: url,
											onChange: $author$project$Location$Details$PopupContent$GoogleAttributes$SetUrlValue(row.id)
										}))))
						]));
			case 'REPEATED_ENUM':
				var setValues = function () {
					var _v5 = row.value;
					if (_v5.$ === 'RepeatedEnumValue') {
						var re = _v5.a;
						return re.setValues;
					} else {
						return _List_Nil;
					}
				}();
				var selectedMeta = A2(
					$elm$core$List$filterMap,
					function (val) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (meta) {
									return _Utils_eq(meta.value, val);
								},
								attr.valueMetaData));
					},
					setValues);
				var filteredMetaData = A2(
					$elm$core$List$filter,
					function (meta) {
						return !A2($elm$core$List$member, meta.value, setValues);
					},
					attr.valueMetaData);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-attributes__repeated-enum-value')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Select$render,
							row.uiSelectValueState,
							A2(
								$author$project$PinMeTo$Ui$Select$viewWithToggle,
								{
									uid: 'google-attr-repeated-' + $elm$core$String$fromInt(row.id),
									items: filteredMetaData,
									tagger: $author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectValueMsg(row.id),
									onChange: function (meta) {
										return A2($author$project$Location$Details$PopupContent$GoogleAttributes$ToggleRepeatedEnumSetValue, row.id, meta.value);
									},
									itemRender: A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.displayName;
										},
										$elm$html$Html$text)
								},
								A2(
									$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonSize,
									$author$project$PinMeTo$Ui$Button$Small,
									A2(
										$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter,
										$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faChevronDown),
										$author$project$PinMeTo$Ui$Select$uiButtonToggle(attr.displayName))))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('google-attributes__repeated-enum-selected')
								]),
							A2(
								$elm$core$List$map,
								function (meta) {
									return $author$project$PinMeTo$Ui$Chip$render(
										A2(
											$author$project$PinMeTo$Ui$Chip$withDelete,
											A2($author$project$Location$Details$PopupContent$GoogleAttributes$ToggleRepeatedEnumSetValue, row.id, meta.value),
											$author$project$PinMeTo$Ui$Chip$view(meta.displayName)));
								},
								selectedMeta))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewRow = F3(
	function (translations, urlErrors, row) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-attributes__row')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = row.origin;
					if (_v0.$ === 'ManuallyAdded') {
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-xmark'),
									$elm$html$Html$Attributes$class('google-attributes__row--remove'),
									$author$project$Common$Util$onClickFinal(
									$author$project$Location$Details$PopupContent$GoogleAttributes$RemoveRow(row.id))
								]),
							_List_Nil);
					} else {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('google-attributes__row--remove-placeholder')
								]),
							_List_Nil);
					}
				}(),
					A4($author$project$Location$Details$PopupContent$GoogleAttributes$viewValueWidget, translations, urlErrors, row, row.selectedAttribute)
				]));
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$normalizeGroupName = function (name) {
	return A2($elm$core$String$startsWith, 'Place page', name) ? 'Place page' : name;
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$withinGroupSortKey = function (row) {
	return _Utils_Tuple2(
		(row.selectedAttribute.valueType === 'URL') ? 1 : 0,
		row.selectedAttribute.displayName);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$groupRows = function (rows) {
	var groupName = function (row) {
		return $author$project$Location$Details$PopupContent$GoogleAttributes$normalizeGroupName(row.selectedAttribute.groupDisplayName);
	};
	var groupNames = A2(
		$elm$core$List$sortBy,
		$elm$core$String$toLower,
		$elm_community$list_extra$List$Extra$unique(
			A2($elm$core$List$map, groupName, rows)));
	return A2(
		$elm$core$List$map,
		function (name) {
			return _Utils_Tuple2(
				name,
				A2(
					$elm$core$List$sortBy,
					$author$project$Location$Details$PopupContent$GoogleAttributes$withinGroupSortKey,
					A2(
						$elm$core$List$filter,
						function (r) {
							return _Utils_eq(
								groupName(r),
								name);
						},
						rows)));
		},
		groupNames);
};
var $author$project$Translations$General$add = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.add');
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectAddMsg = function (a) {
	return {$: 'UiSelectAddMsg', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewSelectItem = function (item) {
	if (item.$ === 'AttributeItem') {
		var attribute = item.a;
		return $elm$html$Html$text(attribute.displayName);
	} else {
		var name = item.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-attributes__select-group-header')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	}
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$NoOp = {$: 'NoOp'};
var $author$project$Location$Details$PopupContent$GoogleAttributes$AddAttribute = function (a) {
	return {$: 'AddAttribute', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$selectItemChosen = function (item) {
	if (item.$ === 'AttributeItem') {
		var attribute = item.a;
		return $author$project$Location$Details$PopupContent$GoogleAttributes$AddAttribute(attribute);
	} else {
		return $author$project$Location$Details$PopupContent$GoogleAttributes$NoOp;
	}
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$GroupHeader = function (a) {
	return {$: 'GroupHeader', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$AttributeItem = function (a) {
	return {$: 'AttributeItem', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$groupedSelectItems = function (attributes) {
	var groupName = function (attribute) {
		return $author$project$Location$Details$PopupContent$GoogleAttributes$normalizeGroupName(attribute.groupDisplayName);
	};
	var sorted = A2(
		$elm$core$List$sortBy,
		function (a) {
			return _Utils_Tuple2(
				$elm$core$String$toLower(
					groupName(a)),
				a.displayName);
		},
		attributes);
	var step = F2(
		function (attribute, _v0) {
			var lastGroup = _v0.a;
			var acc = _v0.b;
			return _Utils_eq(
				lastGroup,
				$elm$core$Maybe$Just(
					groupName(attribute))) ? _Utils_Tuple2(
				lastGroup,
				A2(
					$elm$core$List$cons,
					$author$project$Location$Details$PopupContent$GoogleAttributes$AttributeItem(attribute),
					acc)) : _Utils_Tuple2(
				$elm$core$Maybe$Just(
					groupName(attribute)),
				A2(
					$elm$core$List$cons,
					$author$project$Location$Details$PopupContent$GoogleAttributes$AttributeItem(attribute),
					A2(
						$elm$core$List$cons,
						$author$project$Location$Details$PopupContent$GoogleAttributes$GroupHeader(
							groupName(attribute)),
						acc)));
		});
	return $elm$core$List$reverse(
		A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			sorted).b);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$selectItemSearchText = function (item) {
	if (item.$ === 'AttributeItem') {
		var attribute = item.a;
		return attribute.displayName;
	} else {
		return '';
	}
};
var $author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonStyle = F2(
	function (buttonStyle, toggle) {
		if (toggle.$ === 'LegacyToggle') {
			var config = toggle.a;
			return $author$project$PinMeTo$Ui$Select$LegacyToggle(config);
		} else {
			var config = toggle.a;
			return $author$project$PinMeTo$Ui$Select$UiButtonToggle(
				_Utils_update(
					config,
					{
						style: $author$project$PinMeTo$Ui$Select$ButtonStyle(buttonStyle)
					}));
		}
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewLocations = F2(
	function (model, translations) {
		var selectedAttributeIds = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.selectedAttribute;
				},
				function ($) {
					return $.attributeId;
				}),
			model.rows);
		var filteredAttributes = $author$project$Location$Details$PopupContent$GoogleAttributes$groupedSelectItems(
			A2(
				$elm$core$List$filter,
				function (a) {
					return !A2($elm$core$List$member, a.attributeId, selectedAttributeIds);
				},
				model.availableAttributes));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.addSelectState,
					A2(
						$author$project$PinMeTo$Ui$Select$isDisabled,
						model.loading,
						A2(
							$author$project$PinMeTo$Ui$Select$withSearch,
							{
								searchMap: $author$project$Location$Details$PopupContent$GoogleAttributes$selectItemSearchText,
								placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
								noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
							},
							A2(
								$author$project$PinMeTo$Ui$Select$viewWithToggle,
								{uid: 'google-attr-add', items: filteredAttributes, tagger: $author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectAddMsg, onChange: $author$project$Location$Details$PopupContent$GoogleAttributes$selectItemChosen, itemRender: $author$project$Location$Details$PopupContent$GoogleAttributes$viewSelectItem},
								A2(
									$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonSize,
									$author$project$PinMeTo$Ui$Button$Small,
									A2(
										$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonStyle,
										$author$project$PinMeTo$Ui$Button$Primary($author$project$PinMeTo$Ui$Button$PrimaryDefault),
										A2(
											$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter,
											$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faChevronDown),
											$author$project$PinMeTo$Ui$Select$uiButtonToggle(
												$author$project$Translations$General$add(translations)))))))))
				]));
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewGroup = F2(
	function (rowView, _v0) {
		var groupName = _v0.a;
		var rows = _v0.b;
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('google-attributes__group-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(groupName)
					])),
			A2($elm$core$List$map, rowView, rows));
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewRowSection = F2(
	function (groups, rowView) {
		return $elm$core$List$isEmpty(groups) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-attributes__rows')
				]),
			A2(
				$elm$core$List$concatMap,
				$author$project$Location$Details$PopupContent$GoogleAttributes$viewGroup(rowView),
				groups));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleAttributesNotSupportedByAll = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_attributes_not_supported_by_all');
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewUnsupportedWarning = F2(
	function (translations, unsupportedRows) {
		return $elm$core$List$isEmpty(unsupportedRows) ? $elm$html$Html$text('') : $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Warning,
				$author$project$PinMeTo$Ui$Alert$rich(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$googleAttributesNotSupportedByAll(translations)),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (r) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(r.selectedAttribute.displayName)
											]));
								},
								unsupportedRows))
						]))));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleAttributesNoLocationsSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_attributes_no_locations_selected');
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$viewNoLocationsSelectedWarning = function (translations) {
	return $author$project$PinMeTo$Ui$Alert$render(
		A2(
			$author$project$PinMeTo$Ui$Alert$withStatus,
			$author$project$PinMeTo$Ui$Alert$Warning,
			$author$project$PinMeTo$Ui$Alert$plain(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$googleAttributesNoLocationsSelected(translations))));
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$view = F3(
	function (translations, hasSelectedLocations, model) {
		var availableAttributeIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.attributeId;
			},
			model.availableAttributes);
		var unsupportedRows = A2(
			$elm$core$List$filter,
			function (r) {
				return !A2($elm$core$List$member, r.selectedAttribute.attributeId, availableAttributeIds);
			},
			model.rows);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-attributes')
				]),
			_List_fromArray(
				[
					hasSelectedLocations ? A2($author$project$Location$Details$PopupContent$GoogleAttributes$viewLocations, model, translations) : $author$project$Location$Details$PopupContent$GoogleAttributes$viewNoLocationsSelectedWarning(translations),
					A2(
					$author$project$Location$Details$PopupContent$GoogleAttributes$viewRowSection,
					$author$project$Location$Details$PopupContent$GoogleAttributes$groupRows(model.rows),
					A2($author$project$Location$Details$PopupContent$GoogleAttributes$viewRow, translations, model.urlErrors)),
					A2($author$project$Location$Details$PopupContent$GoogleAttributes$viewUnsupportedWarning, translations, unsupportedRows)
				]));
	});
var $author$project$PinMeTo$Ui$Form$Textarea$onInput = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			msg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail', 'value']),
				$elm$json$Json$Decode$string)));
};
var $author$project$PinMeTo$Ui$Form$Textarea$hasError = function (errorMessage) {
	if (errorMessage.$ === 'Just') {
		if (errorMessage.a.$ === 'Error') {
			return true;
		} else {
			var _v1 = errorMessage.a;
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$PinMeTo$Ui$Form$Textarea$addAttrib = F3(
	function (key, x, attribs) {
		return A2(
			$elm$core$Maybe$withDefault,
			attribs,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, key, value),
						attribs);
				},
				x));
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$PinMeTo$Ui$Form$Textarea$encodePaste = function (_v0) {
	var index = _v0.a;
	var paste = _v0.b;
	var encodeSelection = F2(
		function (selection, attribs) {
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'selection',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'start',
								$elm$json$Json$Encode$int(selection.start)),
								_Utils_Tuple2(
								'end',
								$elm$json$Json$Encode$int(selection.end))
							]))),
				attribs);
		});
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			A3(
				$elm$core$Basics$apR,
				A2($elm$core$Maybe$map, encodeSelection, paste.selection),
				$elm$core$Maybe$withDefault($elm$core$Basics$identity),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'index',
						$elm$json$Json$Encode$int(index)),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(paste.value)),
						_Utils_Tuple2(
						'selectPastedText',
						$elm$json$Json$Encode$bool(paste.selectPastedText))
					]))));
};
var $author$project$PinMeTo$Ui$Form$Textarea$OnSelectionChange = function (a) {
	return {$: 'OnSelectionChange', a: a};
};
var $author$project$PinMeTo$Ui$Form$Textarea$Selection = F2(
	function (start, end) {
		return {end: end, start: start};
	});
var $author$project$PinMeTo$Ui$Form$Textarea$selectionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$PinMeTo$Ui$Form$Textarea$Selection,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['start']),
		$elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['end']),
		$elm$json$Json$Decode$int));
var $author$project$PinMeTo$Ui$Form$Textarea$onSelectionChange = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'selection-change',
		A2(
			$elm$json$Json$Decode$map,
			msg,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail', 'selection']),
				$author$project$PinMeTo$Ui$Form$Textarea$selectionDecoder)));
};
var $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelect = function (a) {
	return {$: 'AutocompleteSelect', a: a};
};
var $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteViewMsg = F2(
	function (a, b) {
		return {$: 'AutocompleteViewMsg', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Form$Textarea$autocompleteItemsView = F4(
	function (_v0, replacementSelectedIndex, caret, items) {
		var moreItemsLabel = _v0.a.moreItemsLabel;
		var maxItems = _v0.a.maxItems;
		var moreItems = $elm$core$List$length(items) - maxItems;
		var items_ = A2($elm$core$List$take, maxItems, items);
		var selected = A2(
			$elm$core$Basics$min,
			replacementSelectedIndex,
			$elm$core$List$length(items_) - 1);
		var itemView = function (_v1) {
			var index = _v1.a;
			var label = _v1.b.label;
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selected',
								_Utils_eq(index, selected))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								A2(
									$author$project$PinMeTo$Ui$Form$Textarea$AutocompleteViewMsg,
									items,
									$author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelect(index)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]));
		};
		return ($elm$core$List$length(items) > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$elm$core$String$fromFloat(caret.top) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromFloat(caret.left) + 'px'),
					$elm$html$Html$Attributes$class('pmt-ui-textarea__cursor-modal'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-ui-textarea__cursor-modal--up', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-textarea__cursor-modal-items')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								itemView,
								A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, items_))),
							(moreItems > 0) ? A2(
							$elm$html$Html$footer,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									moreItemsLabel(moreItems))
								])) : $elm$html$Html$text('')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$PinMeTo$Ui$Form$Textarea$OnAutocomplete = function (a) {
	return {$: 'OnAutocomplete', a: a};
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$PinMeTo$Ui$Form$Textarea$Caret = F2(
	function (top, left) {
		return {top: top, left: left};
	});
var $author$project$PinMeTo$Ui$Form$Textarea$caretDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$PinMeTo$Ui$Form$Textarea$Caret,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['top']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['left']),
		$elm$json$Json$Decode$float));
var $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteQuery = F3(
	function (a, b, c) {
		return {$: 'AutocompleteQuery', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Ui$Form$Textarea$autocompleteDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$PinMeTo$Ui$Form$Textarea$AutocompleteQuery,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail', 'query']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail', 'range']),
		$author$project$PinMeTo$Ui$Form$Textarea$selectionDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail', 'caret']),
		$author$project$PinMeTo$Ui$Form$Textarea$caretDecoder));
var $author$project$PinMeTo$Ui$Form$Textarea$onAutocomplete = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'pmt-autocomplete',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					function (x) {
						return msg(
							$elm$core$Maybe$Just(x));
					},
					$author$project$PinMeTo$Ui$Form$Textarea$autocompleteDecoder),
					$elm$json$Json$Decode$succeed(
					msg($elm$core$Maybe$Nothing))
				])));
};
var $author$project$PinMeTo$Ui$Form$Textarea$addAutocompleteAttribs = F3(
	function (tagger, autocomplete_, attribs) {
		return A2(
			$elm$core$Maybe$withDefault,
			attribs,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var trigger = _v0.a.trigger;
					return A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$attribute,
							'autocomplete-trigger',
							$elm$core$String$fromChar(trigger)),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$Attributes$map,
								tagger,
								$author$project$PinMeTo$Ui$Form$Textarea$onAutocomplete($author$project$PinMeTo$Ui$Form$Textarea$OnAutocomplete)),
							attribs));
				},
				autocomplete_));
	});
var $author$project$PinMeTo$Ui$Form$Textarea$autocompleteItemsByValue = F2(
	function (_v0, autocompleteValue) {
		var itemsFromString = _v0.a.itemsFromString;
		var toString = _v0.a.toString;
		return A2(
			$elm$core$List$map,
			toString,
			itemsFromString(autocompleteValue.value));
	});
var $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSubmit = {$: 'AutocompleteSubmit'};
var $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelectNext = {$: 'AutocompleteSelectNext'};
var $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelectPrevious = {$: 'AutocompleteSelectPrevious'};
var $author$project$PinMeTo$Ui$Form$Textarea$autocompleteKeyBoardEvents = function (items) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$elm$json$Json$Decode$map,
			function (x) {
				return {message: x, preventDefault: true, stopPropagation: true};
			},
			A2(
				$elm$json$Json$Decode$andThen,
				function (keyCode) {
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Decode$fail('Unused key'),
						A2(
							$elm$core$Maybe$map,
							function (x) {
								return $elm$json$Json$Decode$succeed(
									A2($author$project$PinMeTo$Ui$Form$Textarea$AutocompleteViewMsg, items, x));
							},
							A2(
								$elm$core$Dict$get,
								keyCode,
								$elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(13, $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSubmit),
											_Utils_Tuple2(38, $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelectPrevious),
											_Utils_Tuple2(40, $author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelectNext)
										])))));
				},
				$elm$html$Html$Events$keyCode)));
};
var $author$project$PinMeTo$Ui$Form$Textarea$addAutocompleteKeyEvent = F4(
	function (tagger, autocomplete_, autocompleteValue_, attribs) {
		return A2(
			$elm$core$Maybe$withDefault,
			attribs,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (autocomplete__, value) {
						var maxItems = autocomplete__.a.maxItems;
						var _v0 = A2($author$project$PinMeTo$Ui$Form$Textarea$autocompleteItemsByValue, autocomplete__, value);
						if (!_v0.b) {
							return attribs;
						} else {
							var items = _v0;
							return A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$Attributes$map,
									tagger,
									$author$project$PinMeTo$Ui$Form$Textarea$autocompleteKeyBoardEvents(
										A2($elm$core$List$take, maxItems, items))),
								attribs);
						}
					}),
				autocomplete_,
				autocompleteValue_));
	});
var $author$project$PinMeTo$Ui$Form$Textarea$appendDataTestAttribute = F2(
	function (x, attributes) {
		return A2(
			$elm$core$List$cons,
			$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$getAttributeString, x))),
			attributes);
	});
var $author$project$PinMeTo$Ui$Form$Textarea$render = F3(
	function (tagger, _v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-textarea'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-ui-textarea--error',
							$author$project$PinMeTo$Ui$Form$Textarea$hasError(config.errorMessage))
						]))
				]),
			_List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'pmt-textarea',
					A4(
						$author$project$PinMeTo$Ui$Form$Textarea$addAutocompleteKeyEvent,
						tagger,
						config.autocomplete,
						model.activeAutocompleteValue,
						A3(
							$author$project$PinMeTo$Ui$Form$Textarea$addAutocompleteAttribs,
							tagger,
							config.autocomplete,
							A3(
								$author$project$PinMeTo$Ui$Form$Textarea$addAttrib,
								'focus-counter',
								$elm$core$Maybe$Just(
									$elm$core$String$fromInt(model.focusCounter)),
								A3(
									$author$project$PinMeTo$Ui$Form$Textarea$addAttrib,
									'min-rows',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, config.minRows),
									A3(
										$author$project$PinMeTo$Ui$Form$Textarea$addAttrib,
										'autoresize',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, config.autoresize),
										A3(
											$author$project$PinMeTo$Ui$Form$Textarea$addAttrib,
											'paste',
											A2(
												$elm$core$Maybe$map,
												function (value) {
													return $author$project$PinMeTo$Ui$Form$Textarea$encodePaste(
														_Utils_Tuple2(
															$elm$core$List$length(model.paste),
															value));
												},
												$elm$core$List$head(model.paste)),
											A3(
												$author$project$PinMeTo$Ui$Form$Textarea$addAttrib,
												'placeholder',
												config.placeholder,
												A3(
													$author$project$PinMeTo$Ui$Form$Textarea$addAttrib,
													'disabled',
													config.disabled ? $elm$core$Maybe$Just('disabled') : $elm$core$Maybe$Nothing,
													A2(
														$author$project$PinMeTo$Ui$Form$Textarea$appendDataTestAttribute,
														config.dataTestAttribute,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$attribute, 'pmt-value', config.value),
																$author$project$PinMeTo$Ui$Form$Textarea$onInput(config.onChange),
																A2(
																$elm$html$Html$Attributes$map,
																tagger,
																$author$project$PinMeTo$Ui$Form$Textarea$onSelectionChange($author$project$PinMeTo$Ui$Form$Textarea$OnSelectionChange))
															])))))))))),
					_List_Nil),
					A2(
					$elm$html$Html$map,
					tagger,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A3(
							$elm$core$Maybe$map2,
							F2(
								function (autocomplete_, value) {
									var values = A2($author$project$PinMeTo$Ui$Form$Textarea$autocompleteItemsByValue, autocomplete_, value);
									return A4($author$project$PinMeTo$Ui$Form$Textarea$autocompleteItemsView, autocomplete_, model.replacementSelectedIndex, model.caret, values);
								}),
							config.autocomplete,
							model.activeAutocompleteValue))),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (message) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-textarea__error-message ')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function () {
											if (message.$ === 'Error') {
												var string = message.a;
												return string;
											} else {
												return '';
											}
										}())
									]));
						},
						config.errorMessage))
				]));
	});
var $author$project$PinMeTo$Ui$Form$Textarea$Textarea = function (a) {
	return {$: 'Textarea', a: a};
};
var $author$project$PinMeTo$Ui$Form$Textarea$textarea = function (_v0) {
	var onChange = _v0.onChange;
	var value = _v0.value;
	return $author$project$PinMeTo$Ui$Form$Textarea$Textarea(
		{paste: $elm$core$Maybe$Nothing, value: value, minRows: $elm$core$Maybe$Nothing, disabled: false, onChange: onChange, autoresize: $elm$core$Maybe$Nothing, placeholder: $elm$core$Maybe$Nothing, autocomplete: $elm$core$Maybe$Nothing, errorMessage: $elm$core$Maybe$Nothing, dataTestAttribute: $elm$core$Maybe$Nothing});
};
var $author$project$PinMeTo$Deprecated$FontAwesome$InfoCircle = {$: 'InfoCircle'};
var $author$project$Location$Details$PopupContent$ShortDescription$countLimit = 255;
var $author$project$Common$Validators$CsvInjection$invalidChars = _List_fromArray(
	[
		_Utils_chr('='),
		_Utils_chr('/'),
		_Utils_chr('|'),
		_Utils_chr('"'),
		_Utils_chr('@'),
		_Utils_chr('+'),
		_Utils_chr('-'),
		_Utils_chr('\t'),
		_Utils_chr('\r')
	]);
var $author$project$Common$Validators$CsvInjection$validChar = function (_char) {
	return !A2($elm$core$List$member, _char, $author$project$Common$Validators$CsvInjection$invalidChars);
};
var $author$project$Common$Validators$CsvInjection$separators = _List_fromArray(
	[
		_Utils_chr(','),
		_Utils_chr(';'),
		_Utils_chr('\''),
		_Utils_chr('"')
	]);
var $author$project$Common$Validators$CsvInjection$validRest = function (chars) {
	validRest:
	while (true) {
		if (chars.b && chars.b.b) {
			var first = chars.a;
			var _v1 = chars.b;
			var second = _v1.a;
			var rest = _v1.b;
			if (A2($elm$core$List$member, first, $author$project$Common$Validators$CsvInjection$separators) && (!$author$project$Common$Validators$CsvInjection$validChar(second))) {
				return false;
			} else {
				var $temp$chars = A2($elm$core$List$cons, second, rest);
				chars = $temp$chars;
				continue validRest;
			}
		} else {
			return true;
		}
	}
};
var $author$project$Common$Validators$CsvInjection$validFirst = function (chars) {
	if (chars.b) {
		var head = chars.a;
		return $author$project$Common$Validators$CsvInjection$validChar(head);
	} else {
		return true;
	}
};
var $author$project$Common$Validators$CsvInjection$isInputValid = function (input) {
	var chars = $elm$core$String$toList(input);
	return $author$project$Common$Validators$CsvInjection$validFirst(chars) && $author$project$Common$Validators$CsvInjection$validRest(chars);
};
var $author$project$Location$Details$PopupContent$ShortDescription$checkMaxLength = function (input) {
	return (_Utils_cmp(
		$zwilias$elm_utf_tools$String$UTF16$length(
			$elm$core$String$trim(input)),
		$author$project$Location$Details$PopupContent$ShortDescription$countLimit) < 1) ? true : false;
};
var $author$project$Translations$General$csvInjectionError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.csv_injection_error');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.short_description_invalid');
};
var $author$project$Location$Details$PopupContent$ShortDescription$validationErrors = F2(
	function (translations, model) {
		var list = _List_Nil;
		return (!$author$project$Location$Details$PopupContent$ShortDescription$checkMaxLength(model.shortDescriptionString)) ? A2(
			$elm$core$List$cons,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionInvalid(translations),
			list) : ((!$author$project$Common$Validators$CsvInjection$isInputValid(model.shortDescriptionString)) ? A2(
			$elm$core$List$cons,
			$author$project$Translations$General$csvInjectionError(translations),
			list) : list);
	});
var $author$project$Location$Details$PopupContent$ShortDescription$renderAlert = F2(
	function (translations, model) {
		var err = A2($author$project$Location$Details$PopupContent$ShortDescription$validationErrors, translations, model);
		return ($elm$core$List$length(err) > 0) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Warning,
				$author$project$PinMeTo$Ui$Alert$plain(
					'Error: ' + A2($elm$core$String$join, ',', err)))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
	});
var $author$project$PinMeTo$Ui$Form$Textarea$withMinRows = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Textarea$Textarea(
			_Utils_update(
				config,
				{
					minRows: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$Form$Textarea$withAutoresize = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Textarea$Textarea(
			_Utils_update(
				config,
				{
					autoresize: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$Location$Details$PopupContent$ShortDescription$UiTextareaMessage = function (a) {
	return {$: 'UiTextareaMessage', a: a};
};
var $author$project$Location$Details$PopupContent$ShortDescription$UpdateShortDescription = function (a) {
	return {$: 'UpdateShortDescription', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxHelpLine1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.short_description_light_box_help_line1');
};
var $author$project$Location$Details$PopupContent$ShortDescription$view = F2(
	function (translations, model) {
		var wordCount = $zwilias$elm_utf_tools$String$UTF16$length(model.shortDescriptionString);
		var wordCountClass = (_Utils_cmp(wordCount, $author$project$Location$Details$PopupContent$ShortDescription$countLimit) < 1) ? 'form__word-count form__word-count-align' : 'form__word-count form__word-count-align-error form__error';
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$PinMeTo$Ui$Form$Textarea$render,
					$author$project$Location$Details$PopupContent$ShortDescription$UiTextareaMessage,
					model.uiTextareaState,
					A2(
						$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
						5,
						A2(
							$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
							7,
							$author$project$PinMeTo$Ui$Form$Textarea$textarea(
								{value: model.shortDescriptionString, onChange: $author$project$Location$Details$PopupContent$ShortDescription$UpdateShortDescription})))),
					A2($author$project$Location$Details$PopupContent$ShortDescription$renderAlert, translations, model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(wordCountClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(wordCount) + ('/' + $elm$core$String$fromInt($author$project$Location$Details$PopupContent$ShortDescription$countLimit)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__more-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details__more-info__icon')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$InfoCircle)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxHelpLine1(translations) + '\u000A')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('{{name}} {{locationDescriptor}} {{phoneNumber}} {{street}} {{zip}} {{city}} {{homepage}} {{nameAndLocationDescriptor}}')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$Past = {$: 'Past'};
var $author$project$Translations$Listings$SpecialOpenHours$past = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.special_open_hours.past');
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$Warning = {$: 'Warning'};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming = {$: 'Upcoming'};
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0.a;
		var b = _v1.a;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$dayValue = ((24 * 60) * 60) * 1000;
var $author$project$Location$Details$PopupContent$SpecialOpenHours$yesterdayTimestamp = function (model) {
	return $elm$time$Time$posixToMillis(model.now) - $author$project$Location$Details$PopupContent$SpecialOpenHours$dayValue;
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$yesterday = function (model) {
	return A2(
		$justinmimbs$date$Date$fromPosix,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(
			$author$project$Location$Details$PopupContent$SpecialOpenHours$yesterdayTimestamp(model)));
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$isDateBeforeToday = F2(
	function (model, date) {
		return !_Utils_eq(
			A2(
				$justinmimbs$date$Date$compare,
				A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, date),
				$author$project$Location$Details$PopupContent$SpecialOpenHours$yesterday(model)),
			$elm$core$Basics$GT);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$todayDate = function (model) {
	return A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.now);
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$isDateFromTodayOnwards = F2(
	function (model, date) {
		return !_Utils_eq(
			A2(
				$justinmimbs$date$Date$compare,
				A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, date),
				$author$project$Location$Details$PopupContent$SpecialOpenHours$todayDate(model)),
			$elm$core$Basics$LT);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$tabList = F2(
	function (tab, model) {
		var filteringOption = _Utils_eq(tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming) ? $author$project$Location$Details$PopupContent$SpecialOpenHours$isDateFromTodayOnwards(model) : $author$project$Location$Details$PopupContent$SpecialOpenHours$isDateBeforeToday(model);
		return A2(
			$elm$core$List$filter,
			function (record) {
				return filteringOption(record.date);
			},
			model.specialOpenHoursList);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$ShowPast = function (a) {
	return {$: 'ShowPast', a: a};
};
var $author$project$FontAwesome$Regular$Icon$faTrashCan = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-trash-can');
var $author$project$Data$Location$SpecialOpenHours$Closed = {$: 'Closed'};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$Success = function (a) {
	return {$: 'Success', a: a};
};
var $author$project$Location$Details$PopupContent$OpenHours$SpecialOpenHours = {$: 'SpecialOpenHours'};
var $author$project$Location$Details$PopupContent$OpenHours$OpenHours = {$: 'OpenHours'};
var $author$project$Location$Details$PopupContent$OpenHours$containsInvalidTimes = F2(
	function (validationType, span) {
		if (A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$OpenHours$getRegex, span.open) && A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$OpenHours$getRegex, span.close)) {
			var _v0 = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_Utils_Tuple2(true, -1),
				function (number) {
					return _Utils_Tuple2(number > 2400, number);
				},
				$elm$core$String$toInt(span.close));
			var invalidNumberClose = _v0.a;
			var closeTime = _v0.b;
			var _v1 = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_Utils_Tuple2(true, -1),
				function (number) {
					return _Utils_Tuple2(number > 2400, number);
				},
				$elm$core$String$toInt(span.open));
			var invalidNumberOpen = _v1.a;
			var openTime = _v1.b;
			var identicalTime = _Utils_eq(closeTime, openTime) || ((openTime === 2400) && (!closeTime));
			var invalidCloseTime = !((_Utils_cmp(closeTime, openTime) > 0) || ((_Utils_cmp(closeTime, openTime) < 1) && (closeTime <= 1159)));
			var invalidAlwaysOpen = ((openTime === 2400) && (!closeTime)) || ((!openTime) && (!closeTime));
			return (_Utils_eq(validationType, $author$project$Location$Details$PopupContent$OpenHours$OpenHours) && (invalidNumberOpen || (invalidNumberClose || (invalidCloseTime || invalidAlwaysOpen)))) || (_Utils_eq(validationType, $author$project$Location$Details$PopupContent$OpenHours$SpecialOpenHours) && (invalidNumberOpen || (invalidNumberClose || (invalidCloseTime || identicalTime))));
		} else {
			return true;
		}
	});
var $author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay = F2(
	function (validationType, spanList) {
		var resultList = A2(
			$elm$core$List$map,
			function (span) {
				return ($elm$core$String$length(span.open) !== 4) || (($elm$core$String$length(span.close) !== 4) || A2($author$project$Location$Details$PopupContent$OpenHours$containsInvalidTimes, validationType, span));
			},
			spanList);
		return A2($elm$core$List$member, true, resultList);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans = function (spanList) {
	return $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(spanList) || A2($author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay, $author$project$Location$Details$PopupContent$OpenHours$SpecialOpenHours, spanList);
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$UpdateHourSet = F5(
	function (a, b, c, d, e) {
		return {$: 'UpdateHourSet', a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$mapClosingTime0000To2400 = F5(
	function (openOrClose, date, spanIndex, inTheList, fieldValue) {
		var newFieldValue = ((openOrClose === 'close') && (fieldValue === '0000')) ? '2400' : fieldValue;
		return A5($author$project$Location$Details$PopupContent$SpecialOpenHours$UpdateHourSet, openOrClose, date, spanIndex, inTheList, newFieldValue);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$mapClosingTime2400To0000 = function (textValue) {
	return (textValue === '2400') ? '0000' : textValue;
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$renderHourInput = F9(
	function (model, translations, textValue, openOrClose, date, spanIndex, isDisabled, inTheList, hasError) {
		var error = hasError ? $elm$core$Maybe$Just(
			$author$project$Translations$General$invalid(translations)) : $elm$core$Maybe$Nothing;
		return $author$project$PinMeTo$Ui$Form$TimeInput$render(
			A2(
				$author$project$PinMeTo$Ui$Form$TimeInput$withError,
				error,
				A2(
					$author$project$PinMeTo$Ui$Form$TimeInput$withDisabled,
					isDisabled || _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Past),
					$author$project$PinMeTo$Ui$Form$TimeInput$timeInput(
						{
							value: $author$project$Location$Details$PopupContent$SpecialOpenHours$mapClosingTime2400To0000(textValue),
							format: $author$project$PinMeTo$Ui$Form$TimeInput$Military,
							onChange: A4($author$project$Location$Details$PopupContent$SpecialOpenHours$mapClosingTime0000To2400, openOrClose, date, spanIndex, inTheList)
						}))));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$renderSpans = F7(
	function (model, translations, deactivateClass, status, date, inTheList, spans) {
		var errorInForm = $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans(spans);
		return _Utils_eq(status, $author$project$Data$Location$SpecialOpenHours$Closed) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__special-open-hours-spans-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(deactivateClass),
							$elm$html$Html$Attributes$class('lightbox__special-open-hours-day-span-container lightbox__special-open-hours-span-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__special-open-hours-input')
								]),
							_List_fromArray(
								[
									A9($author$project$Location$Details$PopupContent$SpecialOpenHours$renderHourInput, model, translations, '', 'open', date, 0, true, inTheList, errorInForm)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__special-open-hours-input')
								]),
							_List_fromArray(
								[
									A9($author$project$Location$Details$PopupContent$SpecialOpenHours$renderHourInput, model, translations, '', 'close', date, 0, true, inTheList, errorInForm)
								]))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__special-open-hours-spans-row')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, timeSpan) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(deactivateClass),
									$elm$html$Html$Attributes$class('lightbox__special-open-hours-day-span-container lightbox__special-open-hours-span-width')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(deactivateClass),
											$elm$html$Html$Attributes$class('lightbox__special-open-hours-inner-span-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__special-open-hours-input')
												]),
											_List_fromArray(
												[
													A9($author$project$Location$Details$PopupContent$SpecialOpenHours$renderHourInput, model, translations, timeSpan.open, 'open', date, index, false, inTheList, errorInForm)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__special-open-hours-input')
												]),
											_List_fromArray(
												[
													A9($author$project$Location$Details$PopupContent$SpecialOpenHours$renderHourInput, model, translations, timeSpan.close, 'close', date, index, false, inTheList, errorInForm)
												]))
										]))
								]));
					}),
				spans));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$isDateInList = F2(
	function (list, dateToFind) {
		var boolList = A2(
			$elm$core$List$map,
			function (element) {
				return _Utils_eq(
					A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, element.date),
					A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, dateToFind)) ? true : false;
			},
			list);
		return A2($elm$core$List$member, true, boolList);
	});
var $author$project$PinMeTo$Ui$DatePicker$withDisabled = function (v) {
	if (v.$ === 'Time') {
		var x = v.a.a;
		var config = x.config;
		return $author$project$PinMeTo$Ui$DatePicker$Time(
			$author$project$PinMeTo$Ui$DatePicker$TimePicker(
				_Utils_update(
					x,
					{
						config: _Utils_update(
							config,
							{disabled: true})
					})));
	} else {
		var x = v.a.a;
		var config = x.config;
		return $author$project$PinMeTo$Ui$DatePicker$Date(
			$author$project$PinMeTo$Ui$DatePicker$DatePicker(
				_Utils_update(
					x,
					{
						config: _Utils_update(
							config,
							{disabled: true})
					})));
	}
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$OnCreateRecord = {$: 'OnCreateRecord'};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$OnDateSelected = F3(
	function (a, b, c) {
		return {$: 'OnDateSelected', a: a, b: b, c: c};
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$OnDeleteRecord = function (a) {
	return {$: 'OnDeleteRecord', a: a};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$OnDayClosedChange = F3(
	function (a, b, c) {
		return {$: 'OnDayClosedChange', a: a, b: b, c: c};
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$OnDescriptionChange = F3(
	function (a, b, c) {
		return {$: 'OnDescriptionChange', a: a, b: b, c: c};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursCreate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.special_open_hours_create');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursDescriptionPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.special_open_hours_description_placeholder');
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$renderForm = F5(
	function (translations, model, inTheList, index, record) {
		var checkboxViewConfig = _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Past) ? false : true;
		var deactivateClass = _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Past) ? 'lightbox__deactive' : '';
		var dateViewConfig = _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Past) ? $author$project$PinMeTo$Ui$DatePicker$withDisabled : $author$project$PinMeTo$Ui$DatePicker$withMinTime(model.now);
		var dateClass = (inTheList && (_Utils_eq(
			model.highlightDate,
			$author$project$Location$Details$PopupContent$SpecialOpenHours$Success(index)) && _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming))) ? 'lightbox__mr-05 lightbox__special-open-hours-span-width lightbox__highlight-new-date lightbox__center_input' : 'lightbox__mr-05 lightbox__special-open-hours-span-width lightbox__center_input';
		var divClass = ((!inTheList) && ((!index) && _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming))) ? 'lightbox__open-hours-days lightbox__open-hours-days-soh lightbox__line' : 'lightbox__special-open-hours-days lightbox__mt-09';
		var spans = ($elm$core$List$length(record.spans) > 0) ? record.spans : _List_fromArray(
			[
				{open: '0800', close: '1700'}
			]);
		var date = ((!inTheList) && ((!index) && _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming))) ? model.selectedDate : $elm$core$Maybe$Just(
			A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, record.date));
		var day = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, record.date);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(divClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(dateClass),
							$elm$html$Html$Attributes$class(deactivateClass)
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$DatePicker$render(
							dateViewConfig(
								$author$project$PinMeTo$Ui$DatePicker$datePicker(
									{
										value: date,
										locale: model.locale,
										language: model.language,
										onChange: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$OnDateSelected, index, inTheList),
										selectDateLabel: $author$project$Translations$General$selectDate(translations)
									})))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__special-open-hours-checkbox-alignment'),
							$elm$html$Html$Attributes$class(deactivateClass)
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Checkbox$withEnabled,
								checkboxViewConfig,
								$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
									{
										label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
										checked: _Utils_eq(record.state, $author$project$Data$Location$SpecialOpenHours$Closed),
										onChange: function (isChecked) {
											return A3($author$project$Location$Details$PopupContent$SpecialOpenHours$OnDayClosedChange, inTheList, day, isChecked);
										}
									})))
						])),
					A7($author$project$Location$Details$PopupContent$SpecialOpenHours$renderSpans, model, translations, deactivateClass, record.state, day, inTheList, spans),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__special-open-hours-label-alignment'),
							$elm$html$Html$Attributes$class(deactivateClass)
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								$author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursDescriptionPlaceholder(translations),
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withDisabled,
									!checkboxViewConfig,
									$author$project$PinMeTo$Ui$Form$Input$text(
										{
											value: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, record.label),
											onChange: function (text) {
												return A3($author$project$Location$Details$PopupContent$SpecialOpenHours$OnDescriptionChange, day, inTheList, text);
											}
										}))))
						])),
					function () {
					if (_Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming)) {
						if (inTheList) {
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick(
												$author$project$Location$Details$PopupContent$SpecialOpenHours$OnDeleteRecord(index))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$delete(translations))
											]))
									]));
						} else {
							var disableButton = A2($author$project$Location$Details$PopupContent$SpecialOpenHours$isDateInList, model.specialOpenHoursList, model.currentRecord.date) || (_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing) || model.errorInForm);
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$PinMeTo$Ui$Btn$pmtBtn,
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Location$Details$PopupContent$SpecialOpenHours$OnCreateRecord),
												$elm$html$Html$Attributes$disabled(disableButton)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursCreate(translations))
											]))
									]));
						}
					} else {
						return A2($elm$html$Html$span, _List_Nil, _List_Nil);
					}
				}()
				]));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$renderList = F2(
	function (translations, model) {
		var isUpcoming = _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming) ? true : false;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, record) {
						return isUpcoming ? A5($author$project$Location$Details$PopupContent$SpecialOpenHours$renderForm, translations, model, true, index, record) : A5($author$project$Location$Details$PopupContent$SpecialOpenHours$renderForm, translations, model, false, index, record);
					}),
				A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model)));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$OnDeletePast = {$: 'OnDeletePast'};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursNoPastEntries = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.special_open_hours_no_past_entries');
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$pastView = F2(
	function (translations, model) {
		var _v0 = (!$elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (record) {
					return A2($author$project$Location$Details$PopupContent$SpecialOpenHours$isDateBeforeToday, model, record.date);
				},
				model.specialOpenHoursList))) ? _Utils_Tuple3(
			true,
			$elm$html$Html$Attributes$class('lightbox__special-open-hours-clear-button-disabled'),
			$elm$html$Html$Attributes$class('lightbox__special-open-hours-clear-button-disabled')) : _Utils_Tuple3(
			false,
			$elm$html$Html$Attributes$class('lightbox__special-open-hours-clear-button-icon-enabled'),
			$elm$html$Html$Attributes$class('lightbox__special-open-hours-clear-button-enabled'));
		var disableClearButton = _v0.a;
		var clearButtonIconClass = _v0.b;
		var clearButtonClass = _v0.c;
		var alert = ($elm$core$List$length(
			A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model)) <= 0) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Note,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursNoPastEntries(translations)))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__mt-1 lightbox__special-open-hours-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Location$Details$PopupContent$SpecialOpenHours$OnDeletePast),
									$elm$html$Html$Attributes$disabled(disableClearButton)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[clearButtonIconClass]),
									_List_fromArray(
										[
											$author$project$FontAwesome$render(
											$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faTrashCan))
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__special-open-hours-clear-button'),
											clearButtonClass
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$clearAll(translations))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__flex')
						]),
					_List_fromArray(
						[
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$renderList, translations, model)
						])),
					alert
				]));
	});
var $author$project$Translations$Listings$SpecialOpenHours$upcoming = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.special_open_hours.upcoming');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursOverlappingDay = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.special_open_hours_overlapping_day');
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$renderAlert = function (translations) {
	return $author$project$PinMeTo$Ui$Alert$render(
		A2(
			$author$project$PinMeTo$Ui$Alert$withStatus,
			$author$project$PinMeTo$Ui$Alert$Error,
			$author$project$PinMeTo$Ui$Alert$plain(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$specialOpenHoursOverlappingDay(translations))));
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$ShowUpcoming = function (a) {
	return {$: 'ShowUpcoming', a: a};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$upconmigView = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__mt-1 lightbox__special-open-hours-container')
				]),
			_List_fromArray(
				[
					A5($author$project$Location$Details$PopupContent$SpecialOpenHours$renderForm, translations, model, false, 0, model.currentRecord),
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__line')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__flex')
						]),
					_List_fromArray(
						[
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$renderList, translations, model)
						]))
				]));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$classSelection = F2(
	function (model, tab) {
		return _Utils_eq(tab, model.tab) ? 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header pmt-ui-view-selector__item--active pmt-ui-view-selector__item--enabled' : 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header';
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$view = F2(
	function (translations, model) {
		var posixDate = model.currentRecord;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$classSelection, model, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming)),
							$elm$html$Html$Events$onClick(
							$author$project$Location$Details$PopupContent$SpecialOpenHours$ShowUpcoming($author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$SpecialOpenHours$upcoming(translations))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$classSelection, model, $author$project$Location$Details$PopupContent$SpecialOpenHours$Past)),
							$elm$html$Html$Events$onClick(
							$author$project$Location$Details$PopupContent$SpecialOpenHours$ShowPast($author$project$Location$Details$PopupContent$SpecialOpenHours$Past))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$SpecialOpenHours$past(translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__special-open-hours-error-spacing')
						]),
					_List_fromArray(
						[
							(_Utils_eq(model.noticeWarning, $author$project$Location$Details$PopupContent$SpecialOpenHours$Warning) || (A2(
							$author$project$Location$Details$PopupContent$SpecialOpenHours$isDateInList,
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model),
							posixDate.date) && (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing)))) ? $author$project$Location$Details$PopupContent$SpecialOpenHours$renderAlert(translations) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
						])),
					_Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming) ? A2($author$project$Location$Details$PopupContent$SpecialOpenHours$upconmigView, translations, model) : A2($author$project$Location$Details$PopupContent$SpecialOpenHours$pastView, translations, model)
				]));
	});
var $author$project$Location$Details$PopupContent$PermanentlyClosed$UpdatePermanentlyClosed = function (a) {
	return {$: 'UpdatePermanentlyClosed', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedInputText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.permanently_closed_input_text');
};
var $author$project$Location$Details$PopupContent$PermanentlyClosed$view = F2(
	function (translations, model) {
		return $author$project$PinMeTo$Ui$Form$Checkbox$render(
			$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
				{
					label: $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedInputText(translations),
					checked: model.permanentlyClosedStatus,
					onChange: $author$project$Location$Details$PopupContent$PermanentlyClosed$UpdatePermanentlyClosed
				}));
	});
var $author$project$Location$Details$PopupContent$TemporarilyClosed$tomorrowTimestamp = function (model) {
	return $elm$time$Time$posixToMillis(model.now) + $author$project$Location$Details$PopupContent$TemporarilyClosed$dayValue;
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$tomorrowPosix = function (model) {
	return $elm$time$Time$millisToPosix(
		$author$project$Location$Details$PopupContent$TemporarilyClosed$tomorrowTimestamp(model));
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$UiTextareaMessage = function (a) {
	return {$: 'UiTextareaMessage', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedTo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_to');
};
var $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed = {$: 'NotTemporarilyClosed'};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedFrom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_from');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedFromDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_from_date');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedInputText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarilyClosedInputText');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedNoteLine1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_note_line1');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_until_date');
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedFrom = function (a) {
	return {$: 'UpdateTemporarilyClosedFrom', a: a};
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedUntil = function (a) {
	return {$: 'UpdateTemporarilyClosedUntil', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_until_header');
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedStatus = function (a) {
	return {$: 'UpdateTemporarilyClosedStatus', a: a};
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedMessage = function (a) {
	return {$: 'UpdateTemporarilyClosedMessage', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_until_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedMessageDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_message_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilDescriptionNotFrom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_until_description_not_from');
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$view = F2(
	function (translations, model) {
		var checkDisbaleStatusStyles = (!_Utils_eq(model.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed)) ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('temporarily-closed__details-section')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('temporarily-closed__deactive'),
				$elm$html$Html$Attributes$class('temporarily-closed__details-section')
			]);
		var _v0 = model.allowToSelectFrom ? _Utils_Tuple2(
			$elm$html$Html$Attributes$class('temporarily-closed__details-section'),
			$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilDescription(translations)) : _Utils_Tuple2(
			$elm$html$Html$Attributes$class('temporarily-closed__deactive'),
			$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilDescriptionNotFrom(translations));
		var fromDateClass = _v0.a;
		var descriptionText = _v0.b;
		var message = function () {
			var _v1 = model.temporarilyClosed;
			if (_v1.$ === 'Until') {
				var message_ = _v1.b;
				return message_;
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Checkbox$render(
					$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
						{
							label: $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedInputText(translations),
							checked: !_Utils_eq(model.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed),
							onChange: $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedStatus
						})),
					(!_Utils_eq(model.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed)) ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__sub-headline')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							$author$project$PinMeTo$Ui$Alert$rich(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedNoteLine1(translations))
									])))
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					checkDisbaleStatusStyles,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__sub-headline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilHeader(translations))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__sub-headline-description')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(descriptionText)
										]))
								])),
							model.allowToSelectFrom ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__mr-05')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedFrom(translations))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[fromDateClass]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$DatePicker$render(
											A2(
												$author$project$PinMeTo$Ui$DatePicker$withMinTime,
												model.now,
												$author$project$PinMeTo$Ui$DatePicker$datePicker(
													{
														value: model.selectedFromDate,
														locale: model.locale,
														language: model.language,
														onChange: $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedFrom,
														selectDateLabel: $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedFromDate(translations)
													})))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__ml-05 lightbox__mr-05')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedTo(translations))
										]))
								])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
							$author$project$PinMeTo$Ui$DatePicker$render(
							A2(
								$author$project$PinMeTo$Ui$DatePicker$withMinTime,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Location$Details$PopupContent$TemporarilyClosed$tomorrowPosix(model),
									function (date) {
										return A2(
											$author$project$Location$Details$PopupContent$TemporarilyClosed$addDaysToPosix,
											6,
											$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(date));
									},
									model.selectedFromDate),
								$author$project$PinMeTo$Ui$DatePicker$datePicker(
									{
										value: model.selectedUntilDate,
										locale: model.locale,
										language: model.language,
										onChange: $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedUntil,
										selectDateLabel: $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntilDate(translations)
									}))),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__mt-075 lightbox__sub-headline-description')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedMessageDescription(translations))
										]))
								])),
							A3(
							$author$project$PinMeTo$Ui$Form$Textarea$render,
							$author$project$Location$Details$PopupContent$TemporarilyClosed$UiTextareaMessage,
							model.uiTextareaState,
							A2(
								$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
								1,
								A2(
									$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
									7,
									$author$project$PinMeTo$Ui$Form$Textarea$textarea(
										{value: message, onChange: $author$project$Location$Details$PopupContent$TemporarilyClosed$UpdateTemporarilyClosedMessage}))))
						]))
				]));
	});
var $author$project$Translations$General$or = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.or');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Translations$General$priceOptional = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.price_optional');
};
var $author$project$Translations$General$selectService = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.select_service');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnCreateService = {$: 'OnCreateService'};
var $author$project$Data$Location$NetworkServiceItems$Freeform = function (a) {
	return {$: 'Freeform', a: a};
};
var $author$project$Data$Location$NetworkServiceItems$Structured = function (a) {
	return {$: 'Structured', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$validateService = function (model) {
	var _v0 = model.selectedServiceId;
	if (_v0.$ === 'Just') {
		var selectedServiceId = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Data$Location$NetworkServiceItems$Structured(
				{id: selectedServiceId, price: $elm$core$Maybe$Nothing, description: $elm$core$Maybe$Nothing}));
	} else {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				function (name) {
					return A2(
						$elm$core$Maybe$map,
						function (categoryId_) {
							return $author$project$Data$Location$NetworkServiceItems$Freeform(
								{
									label: {description: $elm$core$Maybe$Nothing, displayName: name},
									price: $elm$core$Maybe$Nothing,
									categoryId: categoryId_
								});
						},
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unpack,
							function (_v1) {
								return $elm$core$Maybe$Nothing;
							},
							function (category) {
								return $elm$core$Maybe$Just(category.id);
							},
							model.primaryCategory));
				},
				model.freeformServiceName));
	}
};
var $author$project$Common$Validators$ValidatedItem$ValidItem = function (a) {
	return {$: 'ValidItem', a: a};
};
var $author$project$Common$Validators$ValidatedItem$InvalidItem = F2(
	function (a, b) {
		return {$: 'InvalidItem', a: a, b: b};
	});
var $author$project$Common$Validators$ValidatedItem$map = F2(
	function (f, item) {
		if (item.$ === 'ValidItem') {
			var valid = item.a;
			return $author$project$Common$Validators$ValidatedItem$ValidItem(
				f(valid));
		} else {
			var e = item.a;
			var invalid = item.b;
			return A2(
				$author$project$Common$Validators$ValidatedItem$InvalidItem,
				e,
				f(invalid));
		}
	});
var $author$project$Common$Validators$ValidatedItem$unwrap = function (validatedItem) {
	if (validatedItem.$ === 'ValidItem') {
		var valid = validatedItem.a;
		return valid;
	} else {
		var invalid = validatedItem.b;
		return invalid;
	}
};
var $author$project$PinMeTo$Ui$Form$Textarea$disabled = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Textarea$Textarea(
			_Utils_update(
				config,
				{disabled: x}));
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getPrice = function (service) {
	if (service.$ === 'Structured') {
		var structuredService = service.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.amount;
				},
				structuredService.price));
	} else {
		var freeformService = service.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.amount;
				},
				freeformService.price));
	}
};
var $author$project$PinMeTo$Ui$Form$Textarea$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$PinMeTo$Ui$Form$Textarea$NoError = {$: 'NoError'};
var $author$project$PinMeTo$Ui$Form$Textarea$withError = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Textarea$Textarea(
			_Utils_update(
				config,
				{
					errorMessage: $elm$core$Maybe$Just(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$PinMeTo$Ui$Form$Textarea$NoError,
							A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Form$Textarea$Error, x)))
				}));
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$EditAmount = F2(
	function (a, b) {
		return {$: 'EditAmount', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$countLimit = 300;
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getCurrency = function (service) {
	if (service.$ === 'Structured') {
		var structuredService = service.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'EUR',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.currency;
				},
				structuredService.price));
	} else {
		var freeformService = service.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'EUR',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.currency;
				},
				freeformService.price));
	}
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$EditCurrency = F2(
	function (a, b) {
		return {$: 'EditCurrency', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getServiceId = function (service) {
	if (service.$ === 'Structured') {
		var structuredService = service.a;
		return structuredService.id;
	} else {
		var freeformService = service.a;
		return freeformService.label.displayName;
	}
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier = function (service) {
	if (service.$ === 'Structured') {
		var structuredService = service.a;
		return structuredService.id;
	} else {
		var freeformService = service.a;
		return freeformService.label.displayName;
	}
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getDescription = function (service) {
	if (service.$ === 'Structured') {
		var structuredService = service.a;
		return A2($elm$core$Maybe$withDefault, '', structuredService.description);
	} else {
		var freeformService = service.a;
		return A2($elm$core$Maybe$withDefault, '', freeformService.label.description);
	}
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$EditDescription = F2(
	function (a, b) {
		return {$: 'EditDescription', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnDeleteService = function (a) {
	return {$: 'OnDeleteService', a: a};
};
var $author$project$PinMeTo$Ui$Form$Textarea$withPlaceholder = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Textarea$Textarea(
			_Utils_update(
				config,
				{
					placeholder: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$UiTextareaMessage = function (a) {
	return {$: 'UiTextareaMessage', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditExistingService = F2(
	function (a, b) {
		return {$: 'OnEditExistingService', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$EditFreeformName = F2(
	function (a, b) {
		return {$: 'EditFreeformName', a: a, b: b};
	});
var $author$project$Translations$General$typeCustomService = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.type_custom_service');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$EditStructuredService = F2(
	function (a, b) {
		return {$: 'EditStructuredService', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$filterSelectedServices = F2(
	function (selectedServices, allGoogleServiceItems) {
		var isService = F2(
			function (serviceToFind, serviceToCheck) {
				if (serviceToCheck.$ === 'Structured') {
					var structuredService = serviceToCheck.a;
					return _Utils_eq(structuredService.id, serviceToFind.id);
				} else {
					return false;
				}
			});
		var listContainsService = function (service) {
			var isServiceToFind = isService(service);
			return A2(
				$elm$core$List$any,
				function (validatedService) {
					if (validatedService.$ === 'ValidItem') {
						var validService = validatedService.a;
						return isServiceToFind(validService);
					} else {
						var invalidService = validatedService.b;
						return isServiceToFind(invalidService);
					}
				},
				selectedServices);
		};
		return A2(
			$elm$core$List$filter,
			function (service) {
				return !listContainsService(service);
			},
			allGoogleServiceItems);
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $author$project$Data$Location$NetworkServiceItems$parseStructuredServiceId = function (serviceId) {
	var serviceId_ = A2(
		$elm$core$Maybe$withDefault,
		serviceId,
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, ':', serviceId))));
	var capitalize = function (str) {
		var _v0 = $elm$core$String$uncons(str);
		if (_v0.$ === 'Nothing') {
			return '';
		} else {
			var _v1 = _v0.a;
			var head = _v1.a;
			var tail = _v1.b;
			return A2(
				$elm$core$String$append,
				$elm$core$String$fromChar(
					$elm$core$Char$toUpper(head)),
				tail);
		}
	};
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			capitalize,
			A2($elm$core$String$split, '_', serviceId_)));
};
var $author$project$Data$NetworkData$GoogleServiceItems$googleServiceItemNameLookup = F2(
	function (services, id) {
		var filteredList = A2(
			$elm$core$List$filter,
			function (service) {
				return _Utils_eq(service.id, id);
			},
			services);
		var firstMatch = $elm$core$List$head(filteredList);
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Location$NetworkServiceItems$parseStructuredServiceId(id),
			function (service) {
				return service.name;
			},
			firstMatch);
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$renderServiceSelector = F4(
	function (translations, service, allGoogleServiceItems, model) {
		if (service.$ === 'Structured') {
			var structuredService = service.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__google-services-dropdown-container')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Select$render,
						model.uiSelect,
						A2(
							$author$project$PinMeTo$Ui$Select$isDisabled,
							!model.canModifyServiceList,
							$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
								A2(
									$author$project$PinMeTo$Ui$Select$withSearch,
									{
										searchMap: function ($) {
											return $.name;
										},
										placeholder: $author$project$Translations$General$searchPlaceholder(translations),
										noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
									},
									$author$project$PinMeTo$Ui$Select$view(
										{
											uid: 'google-services-select' + structuredService.id,
											items: A2($author$project$Location$Details$PopupContent$GoogleServiceItems$filterSelectedServices, model.selectedServices, allGoogleServiceItems),
											label: $elm$html$Html$text(
												A2($author$project$Data$NetworkData$GoogleServiceItems$googleServiceItemNameLookup, allGoogleServiceItems, structuredService.id)),
											tagger: $author$project$Location$Details$PopupContent$GoogleServiceItems$UiSelectMsg,
											onChange: function (newService) {
												return A2(
													$author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditExistingService,
													translations,
													A2(
														$author$project$Location$Details$PopupContent$GoogleServiceItems$EditStructuredService,
														$author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier(service),
														newService.id));
											},
											itemRender: A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.name;
												},
												$elm$html$Html$text)
										})))))
					]));
		} else {
			var freeformService = service.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('lightbox__google-services-freeform-container lightbox__google-services-hidden-icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Form$Input$render(
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withDisabled,
							_Utils_eq(model.primaryCategory, $elm$core$Maybe$Nothing) || (!model.canModifyServiceList),
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								$author$project$Translations$General$typeCustomService(translations),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{
										value: freeformService.label.displayName,
										onChange: function (newName) {
											return A2(
												$author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditExistingService,
												translations,
												A2(
													$author$project$Location$Details$PopupContent$GoogleServiceItems$EditFreeformName,
													$author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier(service),
													newName));
										}
									}))))
					]));
		}
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$pattern = '^(([0-9]*[.])?[0-9]*)$';
var $author$project$Location$Details$PopupContent$GoogleServiceItems$maybeRegex = $elm$regex$Regex$fromString($author$project$Location$Details$PopupContent$GoogleServiceItems$pattern);
var $author$project$Location$Details$PopupContent$GoogleServiceItems$regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $author$project$Location$Details$PopupContent$GoogleServiceItems$maybeRegex);
var $author$project$Location$Details$PopupContent$GoogleServiceItems$replaceInvalidCharacters = function (price) {
	var charList = $elm$core$String$toList(price);
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_char, acc) {
				return A2(
					$elm$regex$Regex$contains,
					$author$project$Location$Details$PopupContent$GoogleServiceItems$regex,
					_Utils_ap(_char, acc)) ? _Utils_ap(acc, _char) : (acc + '');
			}),
		'',
		A2($elm$core$List$map, $elm$core$String$fromChar, charList));
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$renderServiceRow = F5(
	function (translations, service, currencyCodes, allGoogleServiceItems, model) {
		var wordCount = $zwilias$elm_utf_tools$String$UTF16$length(
			$author$project$Location$Details$PopupContent$GoogleServiceItems$getDescription(
				$author$project$Common$Validators$ValidatedItem$unwrap(service)));
		var wordCountClass = (_Utils_cmp(wordCount, $author$project$Location$Details$PopupContent$GoogleServiceItems$countLimit) < 1) ? 'form__word-count form__word-count--small form__word-count-align' : 'form__word-count form__word-count--small form__error';
		var error = function () {
			if (service.$ === 'InvalidItem') {
				var err = service.a;
				return $elm$core$Maybe$Just(err);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__google-services-selection-row')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Location$Details$PopupContent$GoogleServiceItems$renderServiceSelector,
					translations,
					$author$project$Common$Validators$ValidatedItem$unwrap(service),
					allGoogleServiceItems,
					model),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__google-services-price-container lightbox__google-services-hidden-icon')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withDisabled,
								!model.canModifyServiceList,
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
									'0',
									$author$project$PinMeTo$Ui$Form$Input$text(
										{
											value: $author$project$Common$Validators$ValidatedItem$unwrap(
												A2($author$project$Common$Validators$ValidatedItem$map, $author$project$Location$Details$PopupContent$GoogleServiceItems$getPrice, service)),
											onChange: function (newPrice) {
												return A2(
													$author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditExistingService,
													translations,
													A2(
														$author$project$Location$Details$PopupContent$GoogleServiceItems$EditAmount,
														$author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier(
															$author$project$Common$Validators$ValidatedItem$unwrap(service)),
														$author$project$Location$Details$PopupContent$GoogleServiceItems$replaceInvalidCharacters(newPrice)));
											}
										}))))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__google-services-price-container')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Select$render,
							model.uiSelect,
							A2(
								$author$project$PinMeTo$Ui$Select$isDisabled,
								!model.canModifyServiceList,
								$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
									A2(
										$author$project$PinMeTo$Ui$Select$withSearch,
										{
											searchMap: $elm$core$Basics$identity,
											placeholder: $author$project$Translations$General$searchPlaceholder(translations),
											noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
										},
										$author$project$PinMeTo$Ui$Select$view(
											{
												uid: 'google-services-currency-select' + $author$project$Location$Details$PopupContent$GoogleServiceItems$getServiceId(
													$author$project$Common$Validators$ValidatedItem$unwrap(service)),
												items: currencyCodes,
												label: $elm$html$Html$text(
													$author$project$Location$Details$PopupContent$GoogleServiceItems$getCurrency(
														$author$project$Common$Validators$ValidatedItem$unwrap(service))),
												tagger: $author$project$Location$Details$PopupContent$GoogleServiceItems$UiSelectMsg,
												onChange: function (newCurrency) {
													return A2(
														$author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditExistingService,
														translations,
														A2(
															$author$project$Location$Details$PopupContent$GoogleServiceItems$EditCurrency,
															$author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier(
																$author$project$Common$Validators$ValidatedItem$unwrap(service)),
															newCurrency));
												},
												itemRender: $elm$html$Html$text
											})))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__google-services-description-container')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Form$Textarea$render,
							$author$project$Location$Details$PopupContent$GoogleServiceItems$UiTextareaMessage,
							model.uiTextareaState,
							A2(
								$author$project$PinMeTo$Ui$Form$Textarea$withError,
								error,
								A2(
									$author$project$PinMeTo$Ui$Form$Textarea$disabled,
									!model.canModifyServiceList,
									A2(
										$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
										2,
										A2(
											$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
											7,
											A2(
												$author$project$PinMeTo$Ui$Form$Textarea$withPlaceholder,
												'Tell customers about your service...',
												$author$project$PinMeTo$Ui$Form$Textarea$textarea(
													{
														value: $author$project$Location$Details$PopupContent$GoogleServiceItems$getDescription(
															$author$project$Common$Validators$ValidatedItem$unwrap(service)),
														onChange: function (newDescription) {
															return A2(
																$author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditExistingService,
																translations,
																A2(
																	$author$project$Location$Details$PopupContent$GoogleServiceItems$EditDescription,
																	$author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier(
																		$author$project$Common$Validators$ValidatedItem$unwrap(service)),
																	newDescription));
														}
													}))))))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(wordCountClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(wordCount) + ('/' + $elm$core$String$fromInt($author$project$Location$Details$PopupContent$GoogleServiceItems$countLimit)))
								]))
						])),
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa fa-xmark'),
							$author$project$Common$Util$onClickFinal(
							$author$project$Location$Details$PopupContent$GoogleServiceItems$OnDeleteService(
								$author$project$Location$Details$PopupContent$GoogleServiceItems$getIdentifier(
									$author$project$Common$Validators$ValidatedItem$unwrap(service))))
						]),
					_List_Nil)
				]));
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditFreeformName = function (a) {
	return {$: 'OnEditFreeformName', a: a};
};
var $author$project$Translations$General$descriptionOptional = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.description_optional');
};
var $author$project$Translations$General$locationNetworkServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_network_services');
};
var $author$project$Translations$General$googleCustomServiceAlert = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.google_custom_service_alert');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnSelectStructuredService = function (a) {
	return {$: 'OnSelectStructuredService', a: a};
};
var $author$project$Translations$Listings$ErrorMessages$locationNotEligibleForServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.location_not_eligible_for_services');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$renderServicesEditor = F4(
	function (translations, model, allGoogleServiceItems, currencyCodes) {
		var freeformAlert = model.showFreeFormAlert ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Note,
				$author$project$PinMeTo$Ui$Alert$rich(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$googleCustomServiceAlert(translations)),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/listings-google-services-ixhfeq/'),
									$elm$html$Html$Attributes$target('blank_')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Google Services')
								]))
						])))) : $elm$html$Html$text('');
		var dropdownLabel = function () {
			var _v0 = model.selectedServiceId;
			if (_v0.$ === 'Just') {
				var selectedServiceId = _v0.a;
				return A2($author$project$Data$NetworkData$GoogleServiceItems$googleServiceItemNameLookup, allGoogleServiceItems, selectedServiceId);
			} else {
				return $author$project$Translations$General$selectService(translations);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__google-services-editor-container')
						]),
					_List_fromArray(
						[
							(!model.canModifyServiceList) ? $author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Warning,
								$author$project$PinMeTo$Ui$Alert$rich(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$ErrorMessages$locationNotEligibleForServices(translations)),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/listings-google-services-ixhfeq/'),
													$elm$html$Html$Attributes$target('blank_')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Google Services')
												]))
										])))) : $elm$html$Html$text(''),
							freeformAlert,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__google-services-input-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__google-services-dropdown-container')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$PinMeTo$Ui$Select$render,
											model.uiSelect,
											A2(
												$author$project$PinMeTo$Ui$Select$isDisabled,
												!model.canModifyServiceList,
												$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
													A2(
														$author$project$PinMeTo$Ui$Select$withSearch,
														{
															searchMap: function ($) {
																return $.name;
															},
															placeholder: $author$project$Translations$General$searchPlaceholder(translations),
															noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
														},
														$author$project$PinMeTo$Ui$Select$view(
															{
																uid: 'google-services-select',
																items: A2($author$project$Location$Details$PopupContent$GoogleServiceItems$filterSelectedServices, model.selectedServices, allGoogleServiceItems),
																label: $elm$html$Html$text(dropdownLabel),
																tagger: $author$project$Location$Details$PopupContent$GoogleServiceItems$UiSelectMsg,
																onChange: $author$project$Location$Details$PopupContent$GoogleServiceItems$OnSelectStructuredService,
																itemRender: A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.name;
																	},
																	$elm$html$Html$text)
															})))))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$or(translations))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__google-services-freeform-container lightbox__google-services-hidden-icon')
										]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Form$Input$render(
											A2(
												$author$project$PinMeTo$Ui$Form$Input$withDisabled,
												_Utils_eq(model.primaryCategory, $elm$core$Maybe$Nothing) || (!model.canModifyServiceList),
												A2(
													$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
													$author$project$Translations$General$typeCustomService(translations),
													$author$project$PinMeTo$Ui$Form$Input$text(
														{
															value: A2($elm$core$Maybe$withDefault, '', model.freeformServiceName),
															onChange: $author$project$Location$Details$PopupContent$GoogleServiceItems$OnEditFreeformName
														}))))
										])),
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$disabledIfTrue,
										_Utils_eq(
											$author$project$Location$Details$PopupContent$GoogleServiceItems$validateService(model),
											$elm$core$Maybe$Nothing),
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$Location$Details$PopupContent$GoogleServiceItems$OnCreateService,
											$author$project$PinMeTo$Ui$Button$buttonSecondary(
												$author$project$Translations$General$create(translations)))))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__google-services-titles-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__google-services-dropdown-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$locationNetworkServices(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__google-services-price-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$priceOptional(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__google-services-description-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$descriptionOptional(translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__google-services-selection-container')
						]),
					A2(
						$elm$core$List$map,
						function (service) {
							return A5($author$project$Location$Details$PopupContent$GoogleServiceItems$renderServiceRow, translations, service, currencyCodes, allGoogleServiceItems, model);
						},
						model.selectedServices))
				]));
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$view = F2(
	function (translations, model) {
		var lightboxContent = function () {
			if (model.canModifyServiceList) {
				var _v0 = _Utils_Tuple2(model.allGoogleServiceItems, model.currencyCodes);
				_v0$1:
				while (true) {
					_v0$2:
					while (true) {
						_v0$4:
						while (true) {
							_v0$5:
							while (true) {
								switch (_v0.b.$) {
									case 'Loading':
										switch (_v0.a.$) {
											case 'Loading':
												break _v0$1;
											case 'Suspended':
												break _v0$2;
											default:
												break _v0$2;
										}
									case 'Loaded':
										switch (_v0.a.$) {
											case 'Loaded':
												var services = _v0.a.a;
												var currencyCodes = _v0.b.a;
												return A4($author$project$Location$Details$PopupContent$GoogleServiceItems$renderServicesEditor, translations, model, services, currencyCodes);
											case 'Loading':
												break _v0$1;
											case 'Error':
												var error = _v0.a.a;
												return $author$project$PinMeTo$Ui$Alert$render(
													A2(
														$author$project$PinMeTo$Ui$Alert$withStatus,
														$author$project$PinMeTo$Ui$Alert$Warning,
														$author$project$PinMeTo$Ui$Alert$plain(error)));
											default:
												break _v0$5;
										}
									case 'Error':
										switch (_v0.a.$) {
											case 'Loading':
												break _v0$1;
											case 'Suspended':
												break _v0$4;
											default:
												break _v0$4;
										}
									default:
										switch (_v0.a.$) {
											case 'Loading':
												break _v0$1;
											case 'Suspended':
												break _v0$5;
											default:
												var _v4 = _v0.b;
												return $author$project$PinMeTo$Ui$Alert$render(
													A2(
														$author$project$PinMeTo$Ui$Alert$withStatus,
														$author$project$PinMeTo$Ui$Alert$Warning,
														$author$project$PinMeTo$Ui$Alert$plain('Suspended')));
										}
								}
							}
							var _v3 = _v0.a;
							return $author$project$PinMeTo$Ui$Alert$render(
								A2(
									$author$project$PinMeTo$Ui$Alert$withStatus,
									$author$project$PinMeTo$Ui$Alert$Warning,
									$author$project$PinMeTo$Ui$Alert$plain('Suspended')));
						}
						var error = _v0.b.a;
						return $author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Warning,
								$author$project$PinMeTo$Ui$Alert$plain(error)));
					}
					var _v2 = _v0.b;
					return $author$project$PinMeTo$Ui$Spinner$spinner;
				}
				var _v1 = _v0.a;
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			} else {
				return A4($author$project$Location$Details$PopupContent$GoogleServiceItems$renderServicesEditor, translations, model, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[lightboxContent]));
	});
var $author$project$Location$Details$PopupContent$AlternativeSearchNames$OnChange = function (a) {
	return {$: 'OnChange', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$alternativeSearchNamesPlaceHolder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.alternative_search_names_place_holder');
};
var $author$project$Location$Details$PopupContent$AlternativeSearchNames$view = F2(
	function (translations, model) {
		return $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
				$author$project$Translations$Listings$LocationDetail$PopUpContent$alternativeSearchNamesPlaceHolder(translations),
				$author$project$PinMeTo$Ui$Form$Input$text(
					{value: model.inputText, onChange: $author$project$Location$Details$PopupContent$AlternativeSearchNames$OnChange})));
	});
var $author$project$PinMeTo$Ui$Lightbox$Medium = {$: 'Medium'};
var $author$project$Data$Location$Email = function (a) {
	return {$: 'Email', a: a};
};
var $author$project$Location$Details$PopupContent$Email$UpdateEmail = function (a) {
	return {$: 'UpdateEmail', a: a};
};
var $author$project$Data$Location$emailToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$emailPlaceholderText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.email_placeholder_text');
};
var $author$project$Location$Details$PopupContent$Email$render = F2(
	function (tagger, model) {
		var _v0 = function () {
			var _v1 = model.email;
			if (_v1.$ === 'InvalidEmail') {
				var email_ = _v1.a;
				var errorMessage = _v1.b.a;
				return _Utils_Tuple2(
					email_,
					$elm$core$Maybe$Just(errorMessage));
			} else {
				var email_ = _v1.a;
				return _Utils_Tuple2(email_, $elm$core$Maybe$Nothing);
			}
		}();
		var email = _v0.a;
		var error = _v0.b;
		var hasError = $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var html = A2(
			$elm$html$Html$map,
			tagger,
			$author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withError,
					error,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$emailPlaceholderText(model.translations),
						$author$project$PinMeTo$Ui$Form$Input$text(
							{
								value: $author$project$Data$Location$emailToString(email),
								onChange: A2($elm$core$Basics$composeR, $author$project$Data$Location$Email, $author$project$Location$Details$PopupContent$Email$UpdateEmail)
							})))));
		return _Utils_Tuple2(html, hasError);
	});
var $author$project$Location$Details$PopupContent$Homepage$Url = function (a) {
	return {$: 'Url', a: a};
};
var $author$project$Translations$General$note = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.note');
};
var $author$project$Location$Details$PopupContent$Homepage$Google = {$: 'Google'};
var $author$project$Data$Location$StoreId = function (a) {
	return {$: 'StoreId', a: a};
};
var $author$project$Location$Details$PopupContent$Homepage$Facebook = {$: 'Facebook'};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleUrl = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_url');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$facebookUrl = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.facebook_url');
};
var $author$project$PinMeTo$Deprecated$FontAwesome$ExternalLink = {$: 'ExternalLink'};
var $author$project$Location$Details$PopupContent$Homepage$UpdateHomepage = function (a) {
	return {$: 'UpdateHomepage', a: a};
};
var $author$project$Location$Details$PopupContent$Homepage$generateNetworkUrl = F3(
	function (network, _v0, _v1) {
		var homepage = _v0.a;
		var storeId = _v1.a;
		var replacedStoreId = (storeId === '') ? homepage : A3($elm$core$String$replace, '{{storeid}}', storeId, homepage);
		var getUrl = F2(
			function (networkName, medium) {
				return $author$project$Location$Details$PopupContent$Homepage$Url(
					A3(
						$elm$core$String$replace,
						'{{network}}',
						networkName,
						A3($elm$core$String$replace, '{{medium}}', medium, replacedStoreId)));
			});
		if (network.$ === 'Facebook') {
			return A2(getUrl, 'facebook', 'social');
		} else {
			return A2(getUrl, 'google', 'organic');
		}
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$homepagePlaceHolder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.homepage_place_holder');
};
var $author$project$Translations$Listings$LocationDetail$helpTextHomepageTags = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_homepage_tags');
};
var $author$project$Translations$Listings$LocationDetail$helpTextHomepageLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_homepage_label');
};
var $author$project$Translations$Listings$LocationDetail$helpTextHomepageMedium = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_homepage_medium');
};
var $author$project$Translations$Listings$LocationDetail$helpTextHomepageNetwork = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_homepage_network');
};
var $author$project$Translations$Listings$LocationDetail$helpTextHomepageStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_homepage_store_id');
};
var $author$project$Location$Details$PopupContent$Homepage$render = F2(
	function (tagger, model) {
		var _v0 = model.storeId;
		var storeId = _v0.a;
		var error = function () {
			var _v4 = model.homepage;
			if (_v4.$ === 'InvalidHomepage') {
				var err = _v4.b.a;
				return $elm$core$Maybe$Just(err);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var hasError = $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var url = function () {
			var _v3 = model.homepage;
			if (_v3.$ === 'ValidHomepage') {
				var homepage = _v3.a;
				return homepage;
			} else {
				var homepage = _v3.a;
				return homepage;
			}
		}();
		var _v1 = A3(
			$author$project$Location$Details$PopupContent$Homepage$generateNetworkUrl,
			$author$project$Location$Details$PopupContent$Homepage$Google,
			$author$project$Location$Details$PopupContent$Homepage$Url(url),
			$author$project$Data$Location$StoreId(storeId));
		var googleUrl = _v1.a;
		var _v2 = A3(
			$author$project$Location$Details$PopupContent$Homepage$generateNetworkUrl,
			$author$project$Location$Details$PopupContent$Homepage$Facebook,
			$author$project$Location$Details$PopupContent$Homepage$Url(url),
			$author$project$Data$Location$StoreId(storeId));
		var facebookUrl = _v2.a;
		var html = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					tagger,
					$author$project$PinMeTo$Ui$Form$Input$render(
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							error,
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								$author$project$Translations$Listings$LocationDetail$PopUpContent$homepagePlaceHolder(model.translations),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{value: url, onChange: $author$project$Location$Details$PopupContent$Homepage$UpdateHomepage}))))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__more-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details__more-info__icon')
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Solid$faCircleInfo])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$helpTextHomepageLabel(model.translations) + '\u000A')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('{{storeid}}')
												])),
											$elm$html$Html$text(
											' - ' + ($author$project$Translations$Listings$LocationDetail$helpTextHomepageStoreId(model.translations) + '\u000A'))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('{{network}}')
												])),
											$elm$html$Html$text(
											' - ' + ($author$project$Translations$Listings$LocationDetail$helpTextHomepageNetwork(model.translations) + '\u000A'))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('{{medium}}')
												])),
											$elm$html$Html$text(
											' - ' + ($author$project$Translations$Listings$LocationDetail$helpTextHomepageMedium(model.translations) + '\u000A'))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$General$note(model.translations) + ': ')
												])),
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$helpTextHomepageTags(model.translations) + '\u000A')
										]))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__subheader')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$facebookUrl(model.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__subheader__url')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details__subheader__url__icon')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$ExternalLink)
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(facebookUrl),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(facebookUrl)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__subheader')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$googleUrl(model.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__subheader__url')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details__subheader__url__icon')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$ExternalLink)
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(googleUrl),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(googleUrl)
								]))
						]))
				]));
		return _Utils_Tuple2(html, hasError);
	});
var $author$project$PinMeTo$Ui$Map$pin = function (coordinates) {
	return $author$project$PinMeTo$Ui$Map$Pin(
		{id: '', marker: $elm$core$Maybe$Nothing, popover: $elm$core$Maybe$Nothing, draggable: false, coordinates: coordinates});
};
var $author$project$Location$Details$PopupContent$Coordinates$Update = F2(
	function (a, b) {
		return {$: 'Update', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Map$withOnChange = F2(
	function (msg, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Map$View(
			_Utils_update(
				config,
				{
					onChange: $elm$core$Maybe$Just(msg)
				}));
	});
var $author$project$PinMeTo$Ui$Map$withPinDraggable = F2(
	function (draggable, pin_) {
		if (pin_.$ === 'Pin') {
			var config = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Pin(
				_Utils_update(
					config,
					{draggable: draggable}));
		} else {
			var feature = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Feature(feature);
		}
	});
var $author$project$Location$Details$PopupContent$Coordinates$UpdateLatFromInput = function (a) {
	return {$: 'UpdateLatFromInput', a: a};
};
var $author$project$Location$Details$PopupContent$Coordinates$UpdateLonFromInput = function (a) {
	return {$: 'UpdateLonFromInput', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLatDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_lat_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLatPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_lat_placeholder');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLonDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_lon_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLonPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_lon_placeholder');
};
var $author$project$Location$Details$PopupContent$Coordinates$render = F2(
	function (tagger, model) {
		var coordinates = function () {
			var _v3 = model.coordinates;
			if (_v3.$ === 'ValidCooridnates') {
				var coordinates_ = _v3.a;
				return coordinates_;
			} else {
				var coordinates_ = _v3.a;
				return coordinates_;
			}
		}();
		var error = function () {
			var _v2 = model.coordinates;
			if (_v2.$ === 'InvalidCooridnates') {
				var err = _v2.b.a;
				return err;
			} else {
				return {lat: $elm$core$Maybe$Nothing, lon: $elm$core$Maybe$Nothing};
			}
		}();
		var hasError = (!_Utils_eq(error.lat, $elm$core$Maybe$Nothing)) || (!_Utils_eq(error.lon, $elm$core$Maybe$Nothing));
		var markerLat = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			coordinates.lat,
			function (_v1) {
				return 0;
			},
			error.lat);
		var markerLon = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			coordinates.lon,
			function (_v0) {
				return 0;
			},
			error.lon);
		var html = A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'height', '400px')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Map$render(
								A2(
									$author$project$PinMeTo$Ui$Map$withOnChange,
									$author$project$Location$Details$PopupContent$Coordinates$Update,
									A2(
										$author$project$PinMeTo$Ui$Map$withZoom,
										15,
										$author$project$PinMeTo$Ui$Map$view(
											_List_fromArray(
												[
													A2(
													$author$project$PinMeTo$Ui$Map$withPinDraggable,
													true,
													$author$project$PinMeTo$Ui$Map$pin(
														{lat: markerLat, lon: markerLon}))
												])))))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__sub-headline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$locationLatitude(model.translations))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__sub-headline-description')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLatDescription(model.translations))
									])),
								$author$project$PinMeTo$Ui$Form$Input$render(
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withError,
									error.lat,
									A2(
										$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
										$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLatPlaceholder(model.translations),
										$author$project$PinMeTo$Ui$Form$Input$text(
											{value: model.coordinatesAsString.lat, onChange: $author$project$Location$Details$PopupContent$Coordinates$UpdateLatFromInput}))))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__sub-headline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$locationLongitude(model.translations))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__sub-headline-description')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLonDescription(model.translations))
									])),
								$author$project$PinMeTo$Ui$Form$Input$render(
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withError,
									error.lon,
									A2(
										$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
										$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLonPlaceholder(model.translations),
										$author$project$PinMeTo$Ui$Form$Input$text(
											{value: model.coordinatesAsString.lon, onChange: $author$project$Location$Details$PopupContent$Coordinates$UpdateLonFromInput}))))
							]))
					])));
		return _Utils_Tuple2(html, hasError);
	});
var $author$project$Location$Details$PopupContent$LongDescription$countLimit = 750;
var $author$project$Data$Location$LongDescription = function (a) {
	return {$: 'LongDescription', a: a};
};
var $author$project$Location$Details$PopupContent$LongDescription$UiTextareaMessage = function (a) {
	return {$: 'UiTextareaMessage', a: a};
};
var $author$project$Location$Details$PopupContent$LongDescription$UpdateLongDescription = function (a) {
	return {$: 'UpdateLongDescription', a: a};
};
var $author$project$Data$Location$longDescriptionToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionLightBoxHelp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.long_description_light_box_help');
};
var $author$project$Location$Details$PopupContent$LongDescription$render = F2(
	function (tagger, model) {
		var noChange = _Utils_eq(model.longDescription, model.initialLongDescription);
		var _v0 = function () {
			var _v1 = model.longDescription;
			if (_v1.$ === 'InvalidLongDescription') {
				var longDescription_ = _v1.a;
				var errorMessage = _v1.b.a;
				return _Utils_Tuple2(
					longDescription_,
					$elm$core$Maybe$Just(errorMessage));
			} else {
				var longDescription_ = _v1.a;
				return _Utils_Tuple2(longDescription_, $elm$core$Maybe$Nothing);
			}
		}();
		var longDescription = _v0.a;
		var error = _v0.b;
		var wordCount = $zwilias$elm_utf_tools$String$UTF16$length(
			$author$project$Data$Location$longDescriptionToString(longDescription));
		var wordCountClass = (_Utils_cmp(wordCount, $author$project$Location$Details$PopupContent$LongDescription$countLimit) < 1) ? 'form__word-count form__word-count-align-old' : 'form__word-count form__word-count-align-old form__error';
		var hasError = $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var html = A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$PinMeTo$Ui$Form$Textarea$render,
						$author$project$Location$Details$PopupContent$LongDescription$UiTextareaMessage,
						model.uiTextareaState,
						A2(
							$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
							5,
							A2(
								$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
								7,
								A2(
									$author$project$PinMeTo$Ui$Form$Textarea$withError,
									error,
									$author$project$PinMeTo$Ui$Form$Textarea$textarea(
										{
											value: $author$project$Data$Location$longDescriptionToString(longDescription),
											onChange: A2($elm$core$Basics$composeR, $author$project$Data$Location$LongDescription, $author$project$Location$Details$PopupContent$LongDescription$UpdateLongDescription)
										}))))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(wordCountClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(wordCount) + ('/' + $elm$core$String$fromInt($author$project$Location$Details$PopupContent$LongDescription$countLimit)))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details__more-info')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('location-details__more-info__icon')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$InfoCircle)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionLightBoxHelp(model.translations) + '\u000A')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('{{name}} {{locationDescriptor}} {{street}} {{zip}} {{city}} {{nameAndLocationDescriptor}}')
													]))
											]))
									]))
							]))
					])));
		return _Utils_Tuple2(html, hasError || noChange);
	});
var $author$project$Location$Details$PopupContent$LocationDescriptor$countLimit = 75;
var $author$project$Data$Location$LocationDescriptor = function (a) {
	return {$: 'LocationDescriptor', a: a};
};
var $author$project$Location$Details$PopupContent$LocationDescriptor$UpdateLocationDescriptor = function (a) {
	return {$: 'UpdateLocationDescriptor', a: a};
};
var $author$project$Data$Location$locationDescriptorToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorLightBoxHelp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.location_descriptor_light_box_help');
};
var $author$project$Location$Details$PopupContent$LocationDescriptor$render = F2(
	function (tagger, model) {
		var _v0 = function () {
			var _v1 = model.locationDescriptor;
			if (_v1.$ === 'InvalidLocationDescriptor') {
				var locationDescriptor_ = _v1.a;
				var errorMessage = _v1.b.a;
				return _Utils_Tuple2(
					locationDescriptor_,
					$elm$core$Maybe$Just(errorMessage));
			} else {
				var locationDescriptor_ = _v1.a;
				return _Utils_Tuple2(locationDescriptor_, $elm$core$Maybe$Nothing);
			}
		}();
		var locationDescriptor = _v0.a;
		var error = _v0.b;
		var wordCount = $zwilias$elm_utf_tools$String$UTF16$length(
			$author$project$Data$Location$locationDescriptorToString(locationDescriptor));
		var wordCountClass = (_Utils_cmp(wordCount, $author$project$Location$Details$PopupContent$LocationDescriptor$countLimit) < 1) ? 'form__word-count form__word-count-align-old' : 'form__word-count form__word-count-align-old form__error';
		var hasError = $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var html = A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Form$Input$render(
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							error,
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Data$Location$locationDescriptorToString(locationDescriptor),
									onChange: A2($elm$core$Basics$composeR, $author$project$Data$Location$LocationDescriptor, $author$project$Location$Details$PopupContent$LocationDescriptor$UpdateLocationDescriptor)
								}))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(wordCountClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(wordCount) + ('/' + $elm$core$String$fromInt($author$project$Location$Details$PopupContent$LocationDescriptor$countLimit)))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details__more-info')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('location-details__more-info__icon')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$InfoCircle)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorLightBoxHelp(model.translations))
											]))
									]))
							]))
					])));
		return _Utils_Tuple2(html, hasError);
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNamePtvPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_ptv_placeholder');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameApplePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_apple_placeholder');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameGooglePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_google_placeholder');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameFacebookPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_facebook_placeholder');
};
var $author$project$Location$Details$PopupContent$CustomNameOnNetwork$render = F2(
	function (tagger, model) {
		var placeHolder = function () {
			var _v2 = model.network;
			switch (_v2.$) {
				case 'Facebook':
					return $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$customNameFacebookPlaceholder(model.translations));
				case 'Google':
					return $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$customNameGooglePlaceholder(model.translations));
				case 'Apple':
					return $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$customNameApplePlaceholder(model.translations));
				case 'Ptv':
					return $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$customNamePtvPlaceholder(model.translations));
				case 'Here':
					return $elm$core$Maybe$Nothing;
				case 'Bing':
					return $elm$core$Maybe$Nothing;
				case 'Overture':
					return $elm$core$Maybe$Nothing;
				case 'Foursquare':
					return $elm$core$Maybe$Nothing;
				case 'Tomtom':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = function () {
			var _v1 = model.customName;
			if (_v1.$ === 'InValidCustomNameOnNetwork') {
				var customName_ = _v1.a;
				var errorMessage = _v1.b.a;
				return _Utils_Tuple2(
					customName_,
					$elm$core$Maybe$Just(errorMessage));
			} else {
				var customName_ = _v1.a;
				return _Utils_Tuple2(customName_, $elm$core$Maybe$Nothing);
			}
		}();
		var customName = _v0.a;
		var error = _v0.b;
		var hasError = $elm_community$maybe_extra$Maybe$Extra$isJust(error);
		var html = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					tagger,
					$author$project$PinMeTo$Ui$Form$Input$render(
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
							A2($elm$core$Maybe$withDefault, '', placeHolder),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{value: customName, onChange: $author$project$Location$Details$PopupContent$CustomNameOnNetwork$UpdateCustomName}))))
				]));
		return _Utils_Tuple2(html, hasError);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$SideBar = {$: 'SideBar'};
var $author$project$Location$Details$Editor$Model$WifiMsg = function (a) {
	return {$: 'WifiMsg', a: a};
};
var $author$project$Location$Details$PopupContent$ActionLinks$toSslUrl = function (url) {
	return A2($elm$core$String$startsWith, 'http', url) ? url : ('https://' + url);
};
var $author$project$Location$Details$PopupContent$ActionLinks$filledLinks = function (model) {
	return A2(
		$elm$core$List$map,
		function (row) {
			return {
				url: $author$project$Location$Details$PopupContent$ActionLinks$toSslUrl(row.url),
				type_: row.type_,
				primary: _Utils_eq(
					model.preferred,
					$elm$core$Maybe$Just(row.type_))
			};
		},
		A2(
			$elm$core$List$filter,
			function (row) {
				return row.url !== '';
			},
			model.rows));
};
var $author$project$Location$Details$PopupContent$ActionLinks$isEmpty = function (model) {
	return $elm$core$List$isEmpty(
		$author$project$Location$Details$PopupContent$ActionLinks$filledLinks(model));
};
var $author$project$Location$Details$PopupContent$SocialMessaging$isEmpty = function (model) {
	return !A2(
		$elm$core$List$any,
		function (field) {
			return $elm$core$String$trim(field.value) !== '';
		},
		model.fields);
};
var $author$project$Location$Details$PopupContent$Wifi$isValid = function (model) {
	return _Utils_cmp(
		$author$project$Location$Details$PopupContent$Wifi$wordCount(model),
		$author$project$Location$Details$PopupContent$Wifi$countLimit) < 1;
};
var $author$project$Location$Details$PopupContent$Email$isValid = function (model) {
	var _v0 = model.email;
	if (_v0.$ === 'InvalidEmail') {
		return false;
	} else {
		return true;
	}
};
var $author$project$Location$Details$PopupContent$Phone$isValid = F2(
	function (translations, model) {
		return $elm$core$List$isEmpty(
			A2($author$project$Location$Details$PopupContent$Phone$validationErrors, translations, model));
	});
var $author$project$Location$Details$PopupContent$Address$isValid = function (model) {
	var serviceAreaCount = $elm$core$List$length(
		$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
			$author$project$Common$Form$unwrapFormState(model.serviceAreaSelector.selectedServiceAreas)));
	var serviceAreaOk = _Utils_eq(model.locationType, $author$project$Data$Location$Storefront) || ((serviceAreaCount > 0) && (_Utils_cmp(serviceAreaCount, $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$maxServiceArea) < 1));
	var addressOk = (!$author$project$Location$Details$PopupContent$Address$showAddressSection(model)) || ((model.address.street !== '') && ((model.address.city !== '') && ((model.address.country !== '') && (((!$author$project$Location$Details$PopupContent$Address$zipRequired(model)) || (model.address.zip !== '')) && ((!$author$project$Location$Details$PopupContent$Address$regionRequired(model)) || ($author$project$Data$Address$getState(model.address) !== ''))))));
	return serviceAreaOk && addressOk;
};
var $author$project$Location$Details$PopupContent$StoreId$isValid = F2(
	function (translations, model) {
		return $elm$core$List$isEmpty(
			A3($author$project$Location$Details$PopupContent$StoreId$validationErrors, model.isFacebookConnected, translations, model)) && $elm$core$List$isEmpty(
			A3($author$project$Location$Details$PopupContent$StoreId$validationErrors, false, translations, model));
	});
var $author$project$Location$Details$PopupContent$Homepage$isValid = function (model) {
	var _v0 = model.homepage;
	if (_v0.$ === 'InvalidHomepage') {
		return false;
	} else {
		return true;
	}
};
var $author$project$Location$Details$PopupContent$OpenHours$validationErrors = function (model) {
	var getSpanList = function (day) {
		if (day.$ === 'Open') {
			var spanList = day.a;
			return spanList;
		} else {
			return _List_Nil;
		}
	};
	var _v0 = model.openHours;
	if (_v0.$ === 'During') {
		var days = _v0.a;
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.day;
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.hasError;
				},
				_List_fromArray(
					[
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Mon,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.mon)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.mon))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Tue,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.tue)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.tue))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Wed,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.wed)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.wed))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Thu,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.thu)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.thu))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Fri,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.fri)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.fri))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Sat,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.sat)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.sat))
					},
						{
						day: $author$project$Location$Details$PopupContent$OpenHours$Sun,
						hasError: $author$project$Location$Details$PopupContent$OpenHours$checkOverlappingPerDay(
							getSpanList(days.sun)) || A2(
							$author$project$Location$Details$PopupContent$OpenHours$checkValidHoursPerDay,
							$author$project$Location$Details$PopupContent$OpenHours$OpenHours,
							getSpanList(days.sun))
					}
					])));
	} else {
		return _List_Nil;
	}
};
var $author$project$Location$Details$PopupContent$OpenHours$isValid = function (model) {
	return $elm$core$List$isEmpty(
		$author$project$Location$Details$PopupContent$OpenHours$validationErrors(model));
};
var $justinmimbs$date$Date$Days = {$: 'Days'};
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(
		$justinmimbs$date$Date$RD(rd));
	var wholeMonths = (12 * (date.year - 1)) + ($justinmimbs$date$Date$monthToNumber(date.month) - 1);
	return wholeMonths + (date.day / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0.a;
		var rd2 = _v1.a;
		switch (unit.$) {
			case 'Years':
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 'Months':
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 'Weeks':
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$Location$Details$PopupContent$OpenStatus$isValid = function (model) {
	var _v0 = model.choice;
	switch (_v0.$) {
		case 'OpenForBusiness':
			return true;
		case 'TemporarilyClosed':
			var _v1 = _Utils_Tuple2(model.selectedFromDate, model.selectedUntilDate);
			if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
				var from = _v1.a.a;
				var until = _v1.b.a;
				return A3($justinmimbs$date$Date$diff, $justinmimbs$date$Date$Days, from, until) >= 7;
			} else {
				return false;
			}
		default:
			return !_Utils_eq(model.selectedClosesOnDate, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Location$Details$PopupContent$StorefrontName$isCustomNameOk = function (cnModel) {
	var _v0 = cnModel.customName;
	if (_v0.$ === 'ValidCustomNameOnNetwork') {
		return true;
	} else {
		var x = _v0.a;
		return $elm$core$String$isEmpty(
			$elm$core$String$trim(x));
	}
};
var $author$project$Location$Details$PopupContent$StorefrontName$isValid = F2(
	function (translations, model) {
		return $elm$core$List$isEmpty(
			A2($author$project$Location$Details$PopupContent$StorefrontName$validationErrors, translations, model)) && ($author$project$Location$Details$PopupContent$StorefrontName$isCustomNameOk(model.googleCustomName) && ($author$project$Location$Details$PopupContent$StorefrontName$isCustomNameOk(model.facebookCustomName) && ($author$project$Location$Details$PopupContent$StorefrontName$isCustomNameOk(model.appleCustomName) && $author$project$Location$Details$PopupContent$StorefrontName$isCustomNameOk(model.ptvCustomName))));
	});
var $author$project$Location$Details$PopupContent$LongDescription$isValid = function (model) {
	var _v0 = model.longDescription;
	if (_v0.$ === 'ValidLongDescription') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$isFieldValid = F2(
	function (urlErrors, field) {
		return _Utils_eq(
			A2($elm$core$Dict$get, field.attribute.attributeId, urlErrors),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$isValid = function (model) {
	return (!model.validatingUrls) && A2(
		$elm$core$List$all,
		$author$project$Location$Details$PopupContent$SocialMessaging$isFieldValid(model.urlErrors),
		model.fields);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$AlwaysShownPlaceholder = {$: 'AlwaysShownPlaceholder'};
var $author$project$Location$Details$PopupContent$GoogleAttributes$isRowValid = F2(
	function (urlErrors, row) {
		var _v0 = row.value;
		switch (_v0.$) {
			case 'EnumValue':
				var val = _v0.a;
				return _Utils_eq(row.origin, $author$project$Location$Details$PopupContent$GoogleAttributes$AlwaysShownPlaceholder) || (val !== '');
			case 'UrlValue':
				return _Utils_eq(
					A2($elm$core$Dict$get, row.selectedAttribute.attributeId, urlErrors),
					$elm$core$Maybe$Nothing);
			default:
				return true;
		}
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$isValid = function (model) {
	return (!model.validatingUrls) && A2(
		$elm$core$List$all,
		$author$project$Location$Details$PopupContent$GoogleAttributes$isRowValid(model.urlErrors),
		model.rows);
};
var $author$project$Location$Details$PopupContent$ShortDescription$isValid = F2(
	function (translations, model) {
		return $elm$core$List$isEmpty(
			A2($author$project$Location$Details$PopupContent$ShortDescription$validationErrors, translations, model));
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$isValid = function (model) {
	var upcomingList = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.date;
			},
			$author$project$Location$Details$PopupContent$SpecialOpenHours$isDateFromTodayOnwards(model)),
		model.specialOpenHoursList);
	var boolList = A2(
		$elm$core$List$map,
		function (record) {
			return $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans(record.spans);
		},
		upcomingList);
	return !A2($elm$core$List$member, true, boolList);
};
var $author$project$Common$Validators$ValidatedItem$isValid = function (item) {
	if (item.$ === 'ValidItem') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Validators$ValidatedItem$allValid = $elm$core$List$all($author$project$Common$Validators$ValidatedItem$isValid);
var $author$project$Location$Details$PopupContent$GoogleServiceItems$isValid = function (model) {
	return $author$project$Common$Validators$ValidatedItem$allValid(model.selectedServices);
};
var $author$project$Location$Details$Editor$Model$EmailMsg = function (a) {
	return {$: 'EmailMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$OnSubmit = {$: 'OnSubmit'};
var $author$project$Location$Details$Editor$Model$PhoneMsg = function (a) {
	return {$: 'PhoneMsg', a: a};
};
var $author$project$Translations$Listings$AddLocation$wifiName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.wifi_name');
};
var $author$project$PinMeTo$Ui$PopOver$withLink = F2(
	function (linkContent, config) {
		return _Utils_update(
			config,
			{
				link: $elm$core$Maybe$Just(linkContent)
			});
	});
var $author$project$Location$Details$Editor$Model$ActiveMsg = function (a) {
	return {$: 'ActiveMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$EditorMsg = function (a) {
	return {$: 'EditorMsg', a: a};
};
var $author$project$Translations$General$republish = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.republish');
};
var $author$project$PinMeTo$Ui$Lightbox$withoutTitleBar = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Lightbox$View(
		_Utils_update(
			config,
			{withoutTitleBar: true}));
};
var $author$project$Listings$Ui$Lightbox$addSubHeaderIfExist = F2(
	function (config, currentList) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			currentList,
			function (description) {
				return A2(
					$elm$core$List$append,
					currentList,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__headline-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]));
			},
			config.description);
	});
var $author$project$Listings$Ui$Lightbox$render = function (config) {
	var defaulUpdateButtonLabel = config.isRePublish ? $author$project$Translations$General$republish(config.translations) : $author$project$Translations$General$update(config.translations);
	var locationSelector = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$text(''),
		$elm$core$Basics$identity,
		config.locationSelector);
	var _v0 = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_Utils_Tuple3(
			$elm$html$Html$text(''),
			defaulUpdateButtonLabel,
			$author$project$PinMeTo$Ui$Btn$pmtBtn),
		function (schedulerObject) {
			return _Utils_Tuple3(
				schedulerObject.negativeButton ? $elm$html$Html$text('') : schedulerObject.view,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					defaulUpdateButtonLabel,
					function (customLabel) {
						return customLabel;
					},
					schedulerObject.customSubmitLabel),
				schedulerObject.negativeButton ? $author$project$PinMeTo$Ui$Btn$pmtBtnNegative : $author$project$PinMeTo$Ui$Btn$pmtBtn);
		},
		config.scheduler);
	var scheduler = _v0.a;
	var buttonLabel = _v0.b;
	var confirmButton = _v0.c;
	var updateDisabled = config.content.b;
	var popOver = function () {
		var _v1 = config.popOver;
		if (_v1.$ === 'Just') {
			var popOver_ = _v1.a;
			return A2($author$project$PinMeTo$Ui$PopOver$renderPlain, popOver_.state, popOver_.config);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var content = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lightbox__content')
			]),
		_List_fromArray(
			[config.content.a]));
	return $author$project$PinMeTo$Ui$Lightbox$render(
		$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				config.style,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withClose,
					config.onCloseMessage,
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withFooter,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__footer')
								]),
							_List_fromArray(
								[
									locationSelector,
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__footer-actions')
										]),
									_List_fromArray(
										[
											scheduler,
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-btn-group lightbox__footer-buttons')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtn,
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$disabled(config.disabledButtons),
															$elm$html$Html$Events$onClick(config.onCloseMessage),
															$elm$html$Html$Attributes$id('lightbox__btn-close')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$General$cancel(config.translations))
														])),
													A3(
													confirmButton,
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$disabled(updateDisabled || config.disabledButtons),
															$elm$html$Html$Events$onClick(config.updateMessage),
															$elm$html$Html$Attributes$id('lightbox__btn-update')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(buttonLabel)
														]))
												]))
										]))
								])),
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withHeader,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__header'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'lightbox__header--with-pop-over',
												!_Utils_eq(config.popOver, $elm$core$Maybe$Nothing))
											]))
									]),
								A2(
									$author$project$Listings$Ui$Lightbox$addSubHeaderIfExist,
									config,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__headline'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'lightbox__headline--with-pop-over',
															!_Utils_eq(config.popOver, $elm$core$Maybe$Nothing))
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(config.header),
													popOver
												]))
										]))),
							$author$project$PinMeTo$Ui$Lightbox$view(
								{title: config.title, content: content})))))));
};
var $author$project$Translations$General$saving = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.saving');
};
var $author$project$Listings$Ui$Lightbox$lightbox = function (config) {
	return {style: config.style, title: config.title, header: config.header, content: config.content, popOver: config.popOver, scheduler: $elm$core$Maybe$Nothing, description: config.description, isRePublish: config.isRePublish, translations: config.translations, updateMessage: config.updateMessage, onCloseMessage: config.onCloseMessage, disabledButtons: false, locationSelector: $elm$core$Maybe$Nothing};
};
var $author$project$Listings$Ui$Lightbox$withScheduler = F2(
	function (schedulerObject, config) {
		return _Utils_update(
			config,
			{scheduler: schedulerObject});
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleErrorText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.schedule_error_text');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$unselectLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.unselect_locations');
};
var $author$project$Translations$Listings$SpecialOpenHours$overlappingGeneral = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.special_open_hours.overlapping_general');
};
var $author$project$Translations$Listings$SpecialOpenHours$regularHoursMustSet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.special_open_hours.regular_hours_must_set');
};
var $author$project$Listings$Ui$Lightbox$withDisabledButtons = F2(
	function (buttonsAreDisabled, config) {
		return _Utils_update(
			config,
			{disabledButtons: buttonsAreDisabled});
	});
var $author$project$Translations$Listings$LocationDetail$storeIdRepeatedError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.store_id_repeated_error');
};
var $author$project$Listings$Ui$Lightbox$withLocationSelector = F2(
	function (locationSeletor, config) {
		return _Utils_update(
			config,
			{
				locationSelector: $elm$core$Maybe$Just(locationSeletor)
			});
	});
var $author$project$Translations$Listings$LocationDetail$storeIdFbRepeatedError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.store_id_fb_repeated_error');
};
var $author$project$Translations$Listings$SpecialOpenHours$overlappingNumberLocations = F2(
	function (translations, totalLocations) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.special_open_hours.overlapping_number_locations',
			_List_fromArray(
				[
					_Utils_Tuple2('totalLocations', totalLocations)
				]));
	});
var $author$project$Location$Details$Editor$View$lightBox2 = F4(
	function (session, details, config, content) {
		var withLocationSelector = config.showSavingProgress ? $elm$core$Basics$identity : A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2($elm$core$Maybe$map, $author$project$Listings$Ui$Lightbox$withLocationSelector, config.locationSelector));
		var maybePrependError = function (content_) {
			var divElement = F3(
				function (textMessage, contentElement, locationIds) {
					var divText = $elm$core$List$isEmpty(locationIds) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(textMessage)
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textMessage + ' ')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-action')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick(
												config.onUnselect(locationIds))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$unselectLocations(session.translations))
											]))
									]))
							]));
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__overlapping-special-open-hours')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Alert$render(
										A2(
											$author$project$PinMeTo$Ui$Alert$withStatus,
											$author$project$PinMeTo$Ui$Alert$Error,
											$author$project$PinMeTo$Ui$Alert$rich(
												_List_fromArray(
													[divText]))))
									])),
								contentElement
							]));
				});
			var _v0 = config.error;
			if (_v0.$ === 'Just') {
				if (_v0.a.$ === 'PartialUpdateFailed') {
					switch (_v0.a.a.$) {
						case 'StoreIdExists':
							var _v1 = _v0.a.a;
							return A3(
								divElement,
								$author$project$Translations$Listings$LocationDetail$storeIdRepeatedError(session.translations),
								content_,
								_List_Nil);
						case 'FacebookStoreIdExists':
							var _v2 = _v0.a.a;
							return A3(
								divElement,
								$author$project$Translations$Listings$LocationDetail$storeIdFbRepeatedError(session.translations),
								content_,
								_List_Nil);
						case 'SpecialOpenHoursOverlap':
							var locationIds = _v0.a.a.a;
							return $elm$core$List$isEmpty(locationIds) ? A3(
								divElement,
								$author$project$Translations$Listings$SpecialOpenHours$overlappingGeneral(session.translations),
								content_,
								_List_Nil) : A3(
								divElement,
								A2(
									$author$project$Translations$Listings$SpecialOpenHours$overlappingNumberLocations,
									session.translations,
									$elm$core$String$fromInt(
										$elm$core$List$length(locationIds))),
								content_,
								locationIds);
						case 'SpecialOpenHoursNoRegularHours':
							var _v3 = _v0.a.a;
							return A3(
								divElement,
								$author$project$Translations$Listings$SpecialOpenHours$regularHoursMustSet(session.translations),
								content_,
								_List_Nil);
						default:
							var errorMessage = _v0.a.a.a;
							return A3(divElement, errorMessage, content_, _List_Nil);
					}
				} else {
					var _v4 = _v0.a;
					return A3(
						divElement,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleErrorText(session.translations),
						content_,
						_List_Nil);
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							config.showSavingProgress ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar status-bar--status')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-gear fa-spin fa-fw')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$saving(session.translations))
										]))
								])) : content_
						]));
			}
		};
		return $author$project$Listings$Ui$Lightbox$render(
			A2(
				$author$project$Listings$Ui$Lightbox$withScheduler,
				config.scheduler,
				A2(
					$author$project$Listings$Ui$Lightbox$withDisabledButtons,
					config.showSavingProgress,
					withLocationSelector(
						$author$project$Listings$Ui$Lightbox$lightbox(
							{
								style: details.style,
								title: details.title,
								header: details.header,
								content: _Utils_Tuple2(
									maybePrependError(content),
									config.isDisabled),
								popOver: config.popOver,
								description: details.description,
								isRePublish: config.isRePublish,
								translations: session.translations,
								updateMessage: config.onSubmit,
								onCloseMessage: config.onCancel
							})))));
	});
var $author$project$Location$Details$Editor$Model$AddressMsg = function (a) {
	return {$: 'AddressMsg', a: a};
};
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingXXS = {$: 'SpacingXXS'};
var $author$project$Location$Details$Editor$Model$StoreIdMsg = function (a) {
	return {$: 'StoreIdMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$categories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.categories');
};
var $author$project$Location$Details$PopupContent$ActionLinks$isDisabled = function (model) {
	return A2(
		$elm$core$List$any,
		function (row) {
			return !_Utils_eq(row.error, $elm$core$Maybe$Nothing);
		},
		model.rows);
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$sourceCall = function (model) {
	return model.sourceCall;
};
var $author$project$Translations$Listings$LocationDetail$updateWifi = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.update_wifi');
};
var $author$project$Location$Details$Editor$Model$HomepageMsg = function (a) {
	return {$: 'HomepageMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$activeTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.active_title');
};
var $author$project$Location$Details$PopupContent$OpenStatus$isRePublish = function (model) {
	return _Utils_eq(model.choice, $author$project$Location$Details$PopupContent$OpenStatus$OpenForBusiness);
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Location$NetworkCategories$CommonNetworkCategory = function (a) {
	return {$: 'CommonNetworkCategory', a: a};
};
var $author$project$Data$Location$NetworkCategories$TomtomNetworkCategory = function (a) {
	return {$: 'TomtomNetworkCategory', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$extractCategoriesFromEditorGroup = function (editorGroup) {
	switch (editorGroup.$) {
		case 'GoogleCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.primary),
				A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.additional));
		case 'FacebookCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$Maybe$map,
					$author$project$Data$Location$NetworkCategories$CommonNetworkCategory,
					$elm$core$List$head(selected.subcategories)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.subcategories))));
		case 'AppleCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.primary),
				A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.additional));
		case 'BingCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$Maybe$map,
					$author$project$Data$Location$NetworkCategories$CommonNetworkCategory,
					A2(
						$elm$core$Maybe$andThen,
						function (id) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								function (cat) {
									return _Utils_eq(cat.id, id);
								},
								selected.categories);
						},
						selected.primaryCategoryId)),
				A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.categories));
		case 'FoursquareCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$Maybe$map,
					$author$project$Data$Location$NetworkCategories$CommonNetworkCategory,
					$elm$core$List$head(selected.categories)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.categories))));
		case 'OvertureCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.primary),
				A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.additional));
		case 'HereCategories':
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.primary),
				A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected.additional));
		default:
			var selected = editorGroup.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					$author$project$Data$Location$NetworkCategories$TomtomNetworkCategory(selected)),
				_List_Nil);
	}
};
var $author$project$Location$Details$PopupContent$Categories$isUnchanged = function (model) {
	var _v0 = model.initialCategories;
	if (_v0.$ === 'Nothing') {
		return _Utils_eq(model.primaryCategory, $elm$core$Maybe$Nothing) && $elm$core$List$isEmpty(model.additionalCategories);
	} else {
		var editorGroup = _v0.a;
		var _v1 = $author$project$Location$Details$PopupContent$Categories$extractCategoriesFromEditorGroup(editorGroup);
		var initialPrimary = _v1.a;
		var initialAdditional = _v1.b;
		return _Utils_eq(model.primaryCategory, initialPrimary) && _Utils_eq(
			$author$project$Location$Details$PopupContent$Categories$convertToCategories(model.additionalCategories),
			initialAdditional);
	}
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Data$Location$ActionLinks$actionLinkTypeToString = function (type_) {
	switch (type_.$) {
		case 'ShopOnline':
			return 'shop_online';
		case 'BookAppointment':
			return 'book_appointment';
		case 'ReserveTable':
			return 'reserve_table';
		case 'OrderFood':
			return 'order_food';
		case 'OrderFoodTakeout':
			return 'order_food_takeout';
		default:
			return 'order_food_delivery';
	}
};
var $author$project$Location$Details$PopupContent$ActionLinks$comparable = function (links) {
	return $elm$core$List$sort(
		A2(
			$elm$core$List$map,
			function (link) {
				return _Utils_Tuple3(
					$author$project$Data$Location$ActionLinks$actionLinkTypeToString(link.type_),
					link.url,
					link.primary ? '1' : '0');
			},
			links));
};
var $author$project$Location$Details$PopupContent$ActionLinks$isUnchanged = function (model) {
	return _Utils_eq(
		$author$project$Location$Details$PopupContent$ActionLinks$comparable(
			$author$project$Location$Details$PopupContent$ActionLinks$filledLinks(model)),
		$author$project$Location$Details$PopupContent$ActionLinks$comparable(model.initial));
};
var $author$project$Location$Details$PopupContent$SocialMessaging$isUnchanged = function (model) {
	return A2(
		$elm$core$List$all,
		function (field) {
			return _Utils_eq(
				field.value,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, field.attribute.attributeId, model.initial)));
		},
		model.fields);
};
var $author$project$Location$Details$Editor$Model$OpenHoursMsg = function (a) {
	return {$: 'OpenHoursMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$activeHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.active_header');
};
var $author$project$Data$Location$OpenHours$During = function (a) {
	return {$: 'During', a: a};
};
var $author$project$Data$Location$OpenHours$NotSpecified = {$: 'NotSpecified'};
var $author$project$Data$Location$OpenHours$notSpecified = $author$project$Data$Location$OpenHours$During(
	{fri: $author$project$Data$Location$OpenHours$NotSpecified, mon: $author$project$Data$Location$OpenHours$NotSpecified, sat: $author$project$Data$Location$OpenHours$NotSpecified, sun: $author$project$Data$Location$OpenHours$NotSpecified, thu: $author$project$Data$Location$OpenHours$NotSpecified, tue: $author$project$Data$Location$OpenHours$NotSpecified, wed: $author$project$Data$Location$OpenHours$NotSpecified});
var $author$project$Location$Details$Editor$Model$CategoriesMsg = function (a) {
	return {$: 'CategoriesMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$OpenStatusMsg = function (a) {
	return {$: 'OpenStatusMsg', a: a};
};
var $author$project$Translations$General$locationEmail = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_email');
};
var $author$project$Translations$General$locationPhone = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_phone');
};
var $justinmimbs$time_extra$Time$Extra$Day = {$: 'Day'};
var $justinmimbs$date$Date$Months = {$: 'Months'};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0.a;
		switch (unit.$) {
			case 'Years':
				return A3(
					$justinmimbs$date$Date$add,
					$justinmimbs$date$Date$Months,
					12 * n,
					$justinmimbs$date$Date$RD(rd));
			case 'Months':
				var date = $justinmimbs$date$Date$toCalendarDate(
					$justinmimbs$date$Date$RD(rd));
				var wholeMonths = ((12 * (date.year - 1)) + ($justinmimbs$date$Date$monthToNumber(date.month) - 1)) + n;
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				return $justinmimbs$date$Date$RD(
					($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
						$elm$core$Basics$min,
						date.day,
						A2($justinmimbs$date$Date$daysInMonth, y, m)));
			case 'Weeks':
				return $justinmimbs$date$Date$RD(rd + (7 * n));
			default:
				return $justinmimbs$date$Date$RD(rd + n);
		}
	});
var $justinmimbs$time_extra$Time$Extra$Month = {$: 'Month'};
var $justinmimbs$time_extra$Time$Extra$Millisecond = {$: 'Millisecond'};
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval.$) {
				case 'Millisecond':
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 'Second':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Millisecond,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Minute':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Millisecond,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Hour':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Millisecond,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Day':
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							$justinmimbs$date$Date$Days,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 'Month':
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							$justinmimbs$date$Date$Months,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 'Year':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Month,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Quarter':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Month,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 'Week':
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Day,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = $justinmimbs$time_extra$Time$Extra$Day,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$PinMeTo$Ui$DatePicker$withRenderer = F2(
	function (renderer, v) {
		if (v.$ === 'Time') {
			var x = v.a.a;
			var config = x.config;
			return $author$project$PinMeTo$Ui$DatePicker$Time(
				$author$project$PinMeTo$Ui$DatePicker$TimePicker(
					_Utils_update(
						x,
						{
							config: _Utils_update(
								config,
								{
									renderer: $elm$core$Maybe$Just(renderer)
								})
						})));
		} else {
			var x = v.a.a;
			var config = x.config;
			return $author$project$PinMeTo$Ui$DatePicker$Date(
				$author$project$PinMeTo$Ui$DatePicker$DatePicker(
					_Utils_update(
						x,
						{
							config: _Utils_update(
								config,
								{
									renderer: $elm$core$Maybe$Just(renderer)
								})
						})));
		}
	});
var $author$project$FontAwesome$Regular$Icon$faCalendar = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-calendar');
var $author$project$Location$Details$Scheduler$scheduleButton = function (label) {
	return A4(
		$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
		$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faCalendar),
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lightbox__scheduler-trigger')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.schedule_button_text');
};
var $author$project$Location$Details$Scheduler$view = function (config) {
	var label = function () {
		var _v2 = config.selectedDate;
		if (_v2.$ === 'Just') {
			var date = _v2.a;
			return $justinmimbs$date$Date$toIsoString(date);
		} else {
			return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(config.translations);
		}
	}();
	var clear = function () {
		var _v1 = config.selectedDate;
		if (_v1.$ === 'Just') {
			return $author$project$PinMeTo$Ui$Button$render(
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					config.onRemove,
					A2(
						$author$project$PinMeTo$Ui$Button$withGhostStyle,
						$author$project$PinMeTo$Ui$Button$GhostNeutral,
						$author$project$PinMeTo$Ui$Button$buttonGhost(
							$author$project$Translations$General$clear(config.translations)))));
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lightbox__scheduler')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$DatePicker$render(
				A2(
					$author$project$PinMeTo$Ui$DatePicker$withRenderer,
					function (_v0) {
						return $author$project$Location$Details$Scheduler$scheduleButton(label);
					},
					A2(
						$author$project$PinMeTo$Ui$DatePicker$withMinTime,
						A4($justinmimbs$time_extra$Time$Extra$add, $justinmimbs$time_extra$Time$Extra$Day, 1, $elm$time$Time$utc, config.now),
						$author$project$PinMeTo$Ui$DatePicker$datePicker(
							{value: config.selectedDate, locale: config.locale, language: config.language, onChange: config.onSelect, selectDateLabel: label})))),
				clear
			]));
};
var $author$project$Location$Details$Editor$Model$OnRemoveSchedulingDate = {$: 'OnRemoveSchedulingDate'};
var $author$project$Location$Details$Editor$Model$OnSelectSchedulingDate = function (a) {
	return {$: 'OnSelectSchedulingDate', a: a};
};
var $author$project$Location$Details$Editor$View$schedulerHtml = F2(
	function (session, model) {
		return $author$project$Location$Details$Scheduler$view(
			{now: model.now, locale: session.locale, language: session.language, onRemove: $author$project$Location$Details$Editor$Model$OnRemoveSchedulingDate, onSelect: $author$project$Location$Details$Editor$Model$OnSelectSchedulingDate, selectedDate: model.selectedDate, translations: session.translations});
	});
var $author$project$Location$Details$Editor$Model$ActionLinksMsg = function (a) {
	return {$: 'ActionLinksMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$CoordinatesMsg = function (a) {
	return {$: 'CoordinatesMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$OpeningDateMsg = function (a) {
	return {$: 'OpeningDateMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_title');
};
var $author$project$Translations$Listings$LocationDetail$sectionAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.section_address');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_status_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$wifiDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.wifi_description');
};
var $author$project$Data$ValidatedCoordinates$ValidCooridnates = function (a) {
	return {$: 'ValidCooridnates', a: a};
};
var $author$project$Data$Location$SpecialOpenHours$Open = function (a) {
	return {$: 'Open', a: a};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList = function (model) {
	return A2(
		$elm$core$List$map,
		function (record) {
			var state = function () {
				var _v0 = record.state;
				if (_v0.$ === 'Closed') {
					return $author$project$Data$Location$SpecialOpenHours$Closed;
				} else {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Data$Location$SpecialOpenHours$Closed,
						function (firstSpan) {
							return $author$project$Data$Location$SpecialOpenHours$Open(firstSpan);
						},
						$elm$core$List$head(record.spans));
				}
			}();
			var specialHours = {label: record.label, state: state, endDate: record.date, startDate: record.date};
			return specialHours;
		},
		model.specialOpenHoursList);
};
var $author$project$Translations$General$locationHomepage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_homepage');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_popover');
};
var $author$project$Location$Details$Editor$Model$StorefrontNameMsg = function (a) {
	return {$: 'StorefrontNameMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$activeDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.active_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.categories_popover');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_header');
};
var $author$project$Location$Details$PopupContent$OpeningDate$dateResultToPosix = function (result) {
	if (result.$ === 'Ok') {
		var posixTime = result.a;
		return $elm$core$Maybe$Just(posixTime);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Location$Details$PopupContent$OpeningDate$stringDateToPosix = function (stringDate) {
	var date = stringDate + 'T00:00:00.000Z';
	return (($elm$core$String$length(stringDate) === 10) && ($elm$core$List$length(
		A2($elm$core$String$split, '-', stringDate)) === 3)) ? $author$project$Location$Details$PopupContent$OpeningDate$dateResultToPosix(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(date)) : $elm$core$Maybe$Nothing;
};
var $author$project$Location$Details$Editor$Model$LongDescriptionMsg = function (a) {
	return {$: 'LongDescriptionMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$SocialMessagingMsg = function (a) {
	return {$: 'SocialMessagingMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNamePtvTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_ptv_title');
};
var $author$project$Translations$General$locationAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_attributes');
};
var $author$project$Translations$General$locationOpenStatus = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_open_status');
};
var $author$project$Location$Details$Editor$Model$GoogleAttributesMsg = function (a) {
	return {$: 'GoogleAttributesMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$ShortDescriptionMsg = function (a) {
	return {$: 'ShortDescriptionMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$SpecialOpenHoursMsg = function (a) {
	return {$: 'SpecialOpenHoursMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$bingCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.bing_categories_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNamePtvHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_ptv_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$emailLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.email_light_box_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_services_title');
};
var $author$project$Translations$Listings$LocationDetail$googleUrlAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.google_url_attributes');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$hereCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.here_categories_title');
};
var $author$project$Translations$General$locationActionLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_action_links');
};
var $author$project$Translations$General$locationOpeningDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_opening_date');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$phoneLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.phone_light_box_header');
};
var $author$project$Location$Details$Editor$Model$PermanentlyClosedMsg = function (a) {
	return {$: 'PermanentlyClosedMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$TemporarilyClosedMsg = function (a) {
	return {$: 'TemporarilyClosedMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$appleCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.apple_categories_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameAppleTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_apple_title');
};
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$readOnly = F2(
	function (value, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$View(
			_Utils_update(
				config,
				{readOnly: value}));
	});
var $author$project$PinMeTo$Ui$SelectorLocationWithFilters$withNeedsVerification = F2(
	function (needsVerification, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$View(
			_Utils_update(
				config,
				{needsVerifications: needsVerification}));
	});
var $author$project$Translations$General$destroy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.destroy');
};
var $author$project$Translations$General$allItems = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.all_items');
};
var $author$project$Translations$General$itemPlain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.item_plain');
};
var $author$project$Filter$FilterLabels$defaultFilterControllerLabels = F2(
	function (translations, language) {
		return {
			save: $author$project$Translations$General$save(translations),
			reset: $author$project$Translations$General$reset(translations),
			create: $author$project$Translations$General$create(translations),
			_delete: $author$project$Translations$General$destroy(translations),
			allItems: $author$project$Translations$General$allItems(translations),
			clearAll: $author$project$Translations$General$clearAll(translations),
			addFilter: $author$project$Translations$General$addFilter(translations),
			saveAsNew: $author$project$Translations$General$saveAsNew(translations),
			addFilters: $author$project$Translations$General$addFilters(translations),
			editFilter: $author$project$Translations$General$editFilter(translations),
			filterName: $author$project$Translations$General$filterName(translations),
			addSelection: function (_v0) {
				return $author$project$Translations$General$addSelection(translations);
			},
			numberOfItems: function (n) {
				return A4($author$project$Common$Language$i18n, translations, language, 'general.number_of_items', n);
			},
			noFiltersFound: $author$project$Translations$General$noFiltersFound(translations),
			searchNoResults: $author$project$Translations$General$searchNoResults(translations),
			searchPlaceholder: $author$project$Translations$General$searchPlaceholder(translations),
			numberOfItemsLimited: function (_v1) {
				return $author$project$Translations$General$itemPlain(translations);
			},
			nameFilterPlaceholder: $author$project$Translations$General$nameFilterPlaceholder(translations),
			searchItemsPlaceholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
			numberOfItemsWithUnselectables: function (_v2) {
				var totalCount = _v2.totalCount;
				return A4($author$project$Common$Language$i18n, translations, language, 'general.number_of_items', totalCount);
			}
		};
	});
var $author$project$Location$Details$Editor$Model$UiSelectorLocationWithFiltersMsg = function (a) {
	return {$: 'UiSelectorLocationWithFiltersMsg', a: a};
};
var $author$project$Location$Details$Editor$View$locationSelectorHtml = F2(
	function (session, model) {
		var readOnly = function () {
			var _v1 = model.content;
			if (_v1.$ === 'ScheduledUpdate') {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$SelectorLocationWithFilters$render,
					model.locationSelector,
					function () {
						var _v0 = model.locationsNeedsVerificationOnLocationSelector;
						if (_v0.$ === 'Just') {
							var identity = _v0.a;
							return $author$project$PinMeTo$Ui$SelectorLocationWithFilters$withNeedsVerification(identity);
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						A2(
							$author$project$PinMeTo$Ui$SelectorLocationWithFilters$withSelected,
							model.selectedLocations,
							A2(
								$author$project$PinMeTo$Ui$SelectorLocationWithFilters$readOnly,
								readOnly,
								$author$project$PinMeTo$Ui$SelectorLocationWithFilters$view(
									{
										labels: A3(
											$author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels,
											session.translations,
											session.language,
											A2($author$project$Filter$FilterLabels$defaultFilterControllerLabels, session.translations, session.language)),
										locale: session.locale,
										tagger: $author$project$Location$Details$Editor$Model$UiSelectorLocationWithFiltersMsg
									})))))
				]));
	});
var $author$project$Translations$General$locationSpecialHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_special_hours');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursPopoverLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_popover_link');
};
var $author$project$Translations$Listings$LocationDetail$updateGeoCoordinates = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.update_geo_coordinates');
};
var $author$project$Location$Details$Editor$Model$GoogleServiceItemsMsg = function (a) {
	return {$: 'GoogleServiceItemsMsg', a: a};
};
var $author$project$Location$Details$Editor$Model$LocationDescriptorMsg = function (a) {
	return {$: 'LocationDescriptorMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameAppleHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_apple_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameGoogleTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_google_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_categories_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_services_popover');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.long_description_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.store_id_light_box_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$tomtomCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.tomtom_categories_title');
};
var $author$project$Location$Details$PopupContent$Email$validatedEmailToEmail = function (validatedEmail) {
	if (validatedEmail.$ === 'ValidEmail') {
		var email = validatedEmail.a;
		return email;
	} else {
		var email = validatedEmail.a;
		return email;
	}
};
var $author$project$Location$Details$Editor$Model$CustomNameOnNetworkMsg = function (a) {
	return {$: 'CustomNameOnNetworkMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameGoogleHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_google_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$factualCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.factual_categories_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$homepageLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.homepage_light_box_header');
};
var $author$project$Translations$General$locationStorefrontName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_storefront_name');
};
var $author$project$Data$ValidatedLocationDescriptor$ValidLocationDescriptor = function (a) {
	return {$: 'ValidLocationDescriptor', a: a};
};
var $author$project$Data$Network$Disconnected = {$: 'Disconnected'};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$canModifyGoogleServices = function (maybeGoogle) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		true,
		function (google) {
			return _Utils_eq(google.idSetType, $author$project$Data$Network$Disconnected) || google.data.canModifyServiceList;
		},
		maybeGoogle);
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameFacebookTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_facebook_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$facebookCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.facebook_categories_title');
};
var $author$project$Translations$General$locationLongDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_long_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$overtureCategoriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.overture_categories_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.permanently_closed_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_header');
};
var $author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedToBool = function (temp) {
	if (temp.$ === 'Until') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$ValidatedCustomNameOnNetwork$ValidCustomNameOnNetwork = function (a) {
	return {$: 'ValidCustomNameOnNetwork', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameFacebookHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_name_facebook_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$emailLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.email_light_box_description');
};
var $author$project$Translations$General$locationShortDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_short_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$phoneLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.phone_light_box_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_light_box_header');
};
var $author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedToPosix = function (temp) {
	if (temp.$ === 'Until') {
		var until = temp.a;
		return $elm$core$Maybe$Just(until);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Location$Details$Editor$Model$AlternativeSearchNamesMsg = function (a) {
	return {$: 'AlternativeSearchNamesMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_services_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openingDateLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.opening_date_light_box_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverAddLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_popover_add_links');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverNetworks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_popover_networks');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.long_description_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.store_id_light_box_description');
};
var $author$project$Translations$Listings$LocationDetail$descriptionSpecialOpenHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_special_open_hours');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$googleAttributesDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.google_attributes_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$homepageLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.homepage_light_box_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.permanently_closed_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverPrimaryText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_popover_primary_text');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.storefront_light_box_description');
};
var $author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations = function (a) {
	return {$: 'OnUnselectConflictingLocations', a: a};
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverPrimaryTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.action_links_popover_primary_title');
};
var $author$project$Translations$Listings$LocationDetail$descriptionGoogleUrlAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_google_url_attributes');
};
var $author$project$Translations$General$locationAlternativeSearchNames = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_alternative_search_names');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openingDateLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.opening_date_light_box_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.short_description_light_box_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.location_descriptor_light_box_header');
};
var $author$project$Data$Location$temporarilyClosedMessageToString = function (message) {
	var _v0 = message;
	var message_ = _v0.a;
	return message_;
};
var $author$project$Data$Location$Homepage = function (a) {
	return {$: 'Homepage', a: a};
};
var $author$project$Location$Details$PopupContent$Homepage$validatedHomepageToMaybeHomepage = function (validatedHomepage) {
	var urlHomePage = function (homepage) {
		var sslHomepage = A2($elm$core$String$startsWith, 'http', homepage) ? homepage : ('https://' + homepage);
		return sslHomepage;
	};
	if (validatedHomepage.$ === 'ValidHomepage') {
		var homepage = validatedHomepage.a;
		return $author$project$Data$Location$Homepage(
			urlHomePage(homepage));
	} else {
		var homepage = validatedHomepage.a;
		return $author$project$Data$Location$Homepage(
			urlHomePage(homepage));
	}
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.short_description_light_box_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$alternativeSearchNamesLightBoxHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.alternative_search_names_light_box_header');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.location_descriptor_light_box_description');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$alternativeSearchNamesLightBoxDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.alternative_search_names_light_box_description');
};
var $author$project$Location$Details$PopupContent$LongDescription$validatedLongDescriptionToLongDescription = function (validatedLongDescription) {
	if (validatedLongDescription.$ === 'ValidLongDescription') {
		var longDesctiption = validatedLongDescription.a;
		return longDesctiption;
	} else {
		var longDesctiption = validatedLongDescription.a;
		return longDesctiption;
	}
};
var $author$project$Location$Details$Editor$View$editorView = F4(
	function (_v0, session, model, editor) {
		var withScheduling = _v0.withScheduling;
		var onCancel = _v0.onCancel;
		var tagger = _v0.tagger;
		var locationsSelected = $elm$core$List$length(model.selectedLocations) > 0;
		var locationsChanged = !_Utils_eq(
			_List_fromArray(
				[model.location.id]),
			model.selectedLocations);
		switch (editor.$) {
			case 'Active':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(model.location.isActive, editorModel.isActive);
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					!editorChanged,
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							return false;
						},
						model.bulkAction));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$activeTitle(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$activeHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$activeDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: false,
						onUnselect: function (_v2) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$ActiveMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$Active$view, session.translations, editorModel)));
			case 'Address':
				var editorModel = editor.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$General$locationAddress(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$sectionAddress(session.translations),
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: !$author$project$Location$Details$PopupContent$Address$isValid(editorModel),
						onUnselect: function (_v4) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$AddressMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$Address$view, session.translations, editorModel)));
			case 'AlternativeSearchNames':
				var editorModel = editor.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationAlternativeSearchNames(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$alternativeSearchNamesLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$alternativeSearchNamesLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: _Utils_eq(model.location.alternativeSearchNames, editorModel.alternativeSearchNames) || (!locationsSelected),
						onUnselect: function (_v5) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$AlternativeSearchNamesMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$AlternativeSearchNames$view, session.translations, editorModel)));
			case 'Categories':
				var network = editor.a;
				var editorModel = editor.b;
				var popOverConfig = $author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'edit-categories-popover',
						tagger: A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$UiPopOverMsg, tagger),
						content: _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesPopover(session.translations))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					});
				var popOver_ = {state: model.popOverState, config: popOverConfig};
				var config = function () {
					switch (network.$) {
						case 'Facebook':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$facebookCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Google':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$googleCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Bing':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$bingCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Apple':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$appleCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Foursquare':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$factualCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Overture':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$overtureCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Here':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$hereCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Tomtom':
							return $elm$core$Maybe$Just(
								{
									style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$tomtomCategoriesTitle(session.translations),
									header: $author$project$Translations$Listings$LocationDetail$PopUpContent$categories(session.translations),
									description: $elm$core$Maybe$Nothing
								});
						case 'Ptv':
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				}();
				if (config.$ === 'Just') {
					var cfg = config.a;
					return A4(
						$author$project$Location$Details$Editor$View$lightBox2,
						session,
						cfg,
						{
							error: model.error,
							popOver: $elm$core$Maybe$Just(popOver_),
							onCancel: onCancel,
							onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
							scheduler: $elm$core$Maybe$Nothing,
							isDisabled: !locationsSelected,
							onUnselect: function (_v7) {
								return tagger(
									$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
							},
							isRePublish: $author$project$Location$Details$PopupContent$Categories$isUnchanged(editorModel),
							locationSelector: $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
							showSavingProgress: model.showSavingProgress
						},
						A2(
							$elm$html$Html$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Location$Details$Editor$Model$CategoriesMsg,
								A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
							A2($author$project$Location$Details$PopupContent$Categories$view, session.translations, editorModel)));
				} else {
					return $elm$html$Html$text('Categories are not supported for this network.');
				}
			case 'GoogleServiceItems':
				var editorModel = editor.a;
				var lightboxDetails = {
					style: $author$project$PinMeTo$Ui$Lightbox$Medium,
					title: $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesTitle(session.translations),
					header: $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesTitle(session.translations),
					description: $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesDescription(session.translations))
				};
				var popOverConfig = $author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'edit-google-services-popover',
						tagger: A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$UiPopOverMsg, tagger),
						content: _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesPopover(session.translations)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/listings-google-services-ixhfeq/'),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Google Services')
									]))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					});
				var cannotModify = !$author$project$Location$Details$PopupContent$GoogleServiceItems$canModifyGoogleServices(model.location.google);
				var isInvalid = !$author$project$Location$Details$PopupContent$GoogleServiceItems$isValid(editorModel);
				var isDisabled = cannotModify || isInvalid;
				var popOver_ = {state: model.popOverState, config: popOverConfig};
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					lightboxDetails,
					{
						error: model.error,
						popOver: $elm$core$Maybe$Just(popOver_),
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: isDisabled,
						onUnselect: function (_v9) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$GoogleServiceItemsMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$GoogleServiceItems$view, session.translations, editorModel)));
			case 'GoogleAttributes':
				var editorModel = editor.a;
				var hasSelectedLocations = function () {
					var _v11 = model.bulkAction;
					if (_v11.$ === 'Just') {
						return !$elm$core$List$isEmpty(model.selectedLocations);
					} else {
						return true;
					}
				}();
				var hasNoAttributes = $elm$core$List$isEmpty(editorModel.rows);
				var isBulkAction = $elm_community$maybe_extra$Maybe$Extra$isJust(model.bulkAction);
				var isDisabled = (isBulkAction && hasNoAttributes) || ((!hasSelectedLocations) || (!$author$project$Location$Details$PopupContent$GoogleAttributes$isValid(editorModel)));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$General$locationAttributes(session.translations),
						header: $author$project$Translations$General$locationAttributes(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$googleAttributesDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: isDisabled,
						onUnselect: function (_v10) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$GoogleAttributesMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A3($author$project$Location$Details$PopupContent$GoogleAttributes$view, session.translations, hasSelectedLocations, editorModel)));
			case 'SocialMessaging':
				var editorModel = editor.a;
				var hasSelectedLocations = function () {
					var _v13 = model.bulkAction;
					if (_v13.$ === 'Just') {
						return !$elm$core$List$isEmpty(model.selectedLocations);
					} else {
						return true;
					}
				}();
				var isRepublish = (!$author$project$Location$Details$PopupContent$SocialMessaging$isEmpty(editorModel)) && $author$project$Location$Details$PopupContent$SocialMessaging$isUnchanged(editorModel);
				var isDisabled = (!hasSelectedLocations) || (!$author$project$Location$Details$PopupContent$SocialMessaging$isValid(editorModel));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$Listings$LocationDetail$googleUrlAttributes(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$googleUrlAttributes(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$descriptionGoogleUrlAttributes(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: isDisabled,
						onUnselect: function (_v12) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$SocialMessagingMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A3($author$project$Location$Details$PopupContent$SocialMessaging$view, session.translations, hasSelectedLocations, editorModel)));
			case 'ActionLinks':
				var editorModel = editor.a;
				var popOverConfig = $author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'edit-action-links-popover',
						tagger: A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$UiPopOverMsg, tagger),
						content: _List_fromArray(
							[
								A2(
								$author$project$PinMeTo$Ui$Layout$Flex$render,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverAddLinks(session.translations))
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverNetworks(session.translations))
											])),
										A2(
										$author$project$PinMeTo$Ui$Layout$Flex$render,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$b,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverPrimaryTitle(session.translations))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksPopoverPrimaryText(session.translations))
													]))
											]),
										A2(
											$author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop,
											$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
											A2(
												$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
												$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXXS,
												A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex))))
									]),
								A2(
									$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
									$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
									A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex)))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					});
				var isDisabled = $author$project$Location$Details$PopupContent$ActionLinks$isDisabled(editorModel);
				var popOver_ = {state: model.popOverState, config: popOverConfig};
				var isEmpty = $author$project$Location$Details$PopupContent$ActionLinks$isEmpty(editorModel);
				var config = {
					style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
					title: $author$project$Translations$General$locationActionLinks(session.translations),
					header: $author$project$Translations$General$locationActionLinks(session.translations),
					description: $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$actionLinksDescription(session.translations))
				};
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					config,
					{
						error: model.error,
						popOver: $elm$core$Maybe$Just(popOver_),
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: (isEmpty && $author$project$Location$Details$PopupContent$ActionLinks$isUnchanged(editorModel)) || ((!locationsSelected) || isDisabled),
						onUnselect: function (_v14) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: (!isEmpty) && $author$project$Location$Details$PopupContent$ActionLinks$isUnchanged(editorModel),
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$ActionLinksMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$ActionLinks$view, session.translations, editorModel)));
			case 'Coordinates':
				var editorModel = editor.a;
				var _v15 = A2($author$project$Location$Details$PopupContent$Coordinates$render, $elm$core$Basics$identity, editorModel);
				var view_ = _v15.a;
				var isDisabled = _v15.b;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$Listings$LocationDetail$updateGeoCoordinates(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: isDisabled,
						onUnselect: function (_v16) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: _Utils_eq(
							editorModel.coordinates,
							$author$project$Data$ValidatedCoordinates$ValidCooridnates(model.location.location)),
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$CoordinatesMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						view_));
			case 'CustomNameOnNetwork':
				var network = editor.a;
				var editorModel = editor.b;
				var _v17 = function () {
					switch (network.$) {
						case 'Facebook':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(
									{
										style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
										title: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameFacebookTitle(session.translations),
										header: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameFacebookHeader(session.translations),
										description: $elm$core$Maybe$Nothing
									}),
								model.location.networkNames.facebook);
						case 'Google':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(
									{
										style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
										title: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameGoogleTitle(session.translations),
										header: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameGoogleHeader(session.translations),
										description: $elm$core$Maybe$Nothing
									}),
								model.location.networkNames.google);
						case 'Apple':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(
									{
										style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
										title: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameAppleTitle(session.translations),
										header: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNameAppleHeader(session.translations),
										description: $elm$core$Maybe$Nothing
									}),
								$elm$core$Basics$identity(model.location.networkNames.apple));
						case 'Ptv':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(
									{
										style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
										title: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNamePtvTitle(session.translations),
										header: $author$project$Translations$Listings$LocationDetail$PopUpContent$customNamePtvHeader(session.translations),
										description: $elm$core$Maybe$Nothing
									}),
								$elm$core$Basics$identity(model.location.networkNames.ptv));
						case 'Here':
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						case 'Tomtom':
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						case 'Foursquare':
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						case 'Bing':
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						case 'Overture':
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				}();
				var details = _v17.a;
				var initialNetworkName = _v17.b;
				var _v19 = A2($author$project$Location$Details$PopupContent$CustomNameOnNetwork$render, $elm$core$Basics$identity, editorModel);
				var view_ = _v19.a;
				var isDisabled = _v19.b;
				if (details.$ === 'Just') {
					var d = details.a;
					return A4(
						$author$project$Location$Details$Editor$View$lightBox2,
						session,
						d,
						{
							error: model.error,
							popOver: $elm$core$Maybe$Nothing,
							onCancel: onCancel,
							onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
							scheduler: $elm$core$Maybe$Nothing,
							isDisabled: isDisabled,
							onUnselect: function (_v21) {
								return tagger(
									$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
							},
							isRePublish: _Utils_eq(
								editorModel.customName,
								$author$project$Data$ValidatedCustomNameOnNetwork$ValidCustomNameOnNetwork(
									A2($elm$core$Maybe$withDefault, '', initialNetworkName))),
							locationSelector: $elm$core$Maybe$Nothing,
							showSavingProgress: model.showSavingProgress
						},
						A2(
							$elm$html$Html$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Location$Details$Editor$Model$CustomNameOnNetworkMsg,
								A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
							view_));
				} else {
					return $elm$html$Html$text('Custom Name on this network is not supported.');
				}
			case 'Email':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(
					model.location.email,
					$author$project$Location$Details$PopupContent$Email$validatedEmailToEmail(editorModel.email));
				var _v22 = A2($author$project$Location$Details$PopupContent$Email$render, $elm$core$Basics$identity, editorModel);
				var view_ = _v22.a;
				var isDisabled = _v22.b;
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					!editorChanged,
					A2(
						$elm$core$Maybe$map,
						function (_v25) {
							return false;
						},
						model.bulkAction));
				var isEnabled = locationsSelected && ((!isDisabled) && $author$project$Location$Details$PopupContent$Email$isValid(editorModel));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationEmail(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$emailLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$emailLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v23) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						onUnselect: function (_v24) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$EmailMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						view_));
			case 'Homepage':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(
					model.location.homepage,
					$author$project$Location$Details$PopupContent$Homepage$validatedHomepageToMaybeHomepage(editorModel.homepage));
				var _v26 = A2($author$project$Location$Details$PopupContent$Homepage$render, $elm$core$Basics$identity, editorModel);
				var view_ = _v26.a;
				var isDisabled = _v26.b;
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					!editorChanged,
					A2(
						$elm$core$Maybe$map,
						function (_v29) {
							return false;
						},
						model.bulkAction));
				var isEnabled = locationsSelected && ((!isDisabled) && $author$project$Location$Details$PopupContent$Homepage$isValid(editorModel));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationHomepage(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$homepageLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$homepageLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v27) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						onUnselect: function (_v28) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$HomepageMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						view_));
			case 'OpenHours':
				var editorModel = editor.a;
				var openHoursNotSpecified = _Utils_eq(model.location.openHours, $author$project$Data$Location$OpenHours$notSpecified);
				var popOverConfig = A2(
					$author$project$PinMeTo$Ui$PopOver$withLink,
					{
						href: 'https://help.pinmeto.com/en/article/how-to-set-up-open-hours-and-special-open-hours-ff9vjp/',
						text: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursPopoverLink(session.translations)
					},
					$author$project$PinMeTo$Ui$PopOver$view(
						{
							uid: 'edit-open-hours-popover',
							tagger: A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$UiPopOverMsg, tagger),
							content: _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursPopover(session.translations))
								]),
							preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
						}));
				var editorChanged = !_Utils_eq(model.location.openHours, editorModel.openHours);
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					(!editorChanged) && (!openHoursNotSpecified),
					A2(
						$elm$core$Maybe$map,
						function (_v32) {
							return false;
						},
						model.bulkAction));
				var isEnabled = $author$project$Location$Details$PopupContent$OpenHours$isValid(editorModel) && locationsSelected;
				var popOver_ = {state: model.popOverState, config: popOverConfig};
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursTitle(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Just(popOver_),
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v30) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: (!isEnabled) || (!locationsSelected),
						onUnselect: function (_v31) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$Editor$Model$OpenHoursMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
								A2($author$project$Location$Details$PopupContent$OpenHours$view, session.translations, editorModel))
							])));
			case 'Wifi':
				var editorModel = editor.a;
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					_Utils_eq(model.location.wifiSsId, editorModel.wifi),
					A2(
						$elm$core$Maybe$map,
						function (_v34) {
							return false;
						},
						model.bulkAction));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$updateWifi(session.translations),
						header: $author$project$Translations$Listings$AddLocation$wifiName(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$wifiDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: (!locationsSelected) || (!$author$project$Location$Details$PopupContent$Wifi$isValid(editorModel)),
						onUnselect: function (_v33) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$WifiMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$Wifi$view, session.translations, editorModel)));
			case 'StoreId':
				var editorModel = editor.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationStoreId(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$storeIdLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: !A2($author$project$Location$Details$PopupContent$StoreId$isValid, session.translations, editorModel),
						onUnselect: function (_v35) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: _Utils_eq(model.location.storeId, editorModel.storeId) && _Utils_eq(model.location.fbStoreId, editorModel.facebookStoreId),
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$StoreIdMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$StoreId$view, session.translations, editorModel)));
			case 'StorefrontName':
				var editorModel = editor.a;
				var allowUpdateMultiple = A2($elm$core$List$member, $author$project$Data$User$CustomerSuccess, session.user.localAccess.roles) && (!session.user.isDemo);
				var locationSelector = allowUpdateMultiple ? $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$map,
						tagger,
						A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))) : $elm$core$Maybe$Nothing;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationStorefrontName(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: !A2($author$project$Location$Details$PopupContent$StorefrontName$isValid, session.translations, editorModel),
						onUnselect: function (_v36) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: true,
						locationSelector: locationSelector,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$StorefrontNameMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$StorefrontName$view, session.translations, editorModel)));
			case 'ShortDescription':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(model.location.about, editorModel.shortDescription);
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					!editorChanged,
					A2(
						$elm$core$Maybe$map,
						function (_v39) {
							return false;
						},
						model.bulkAction));
				var isValid = A2($author$project$Location$Details$PopupContent$ShortDescription$isValid, session.translations, editorModel);
				var isEnabled = isValid && locationsSelected;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationShortDescription(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v37) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						onUnselect: function (_v38) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$ShortDescriptionMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$ShortDescription$view, session.translations, editorModel)));
			case 'TemporarilyClosed':
				var editorModel = editor.a;
				var isDisabled = ((model.location.id !== '') && (_Utils_eq(editorModel.selectedUntilDate, $elm$core$Maybe$Nothing) && (!_Utils_eq(editorModel.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed)))) || ((model.location.id === '') && ((!_Utils_eq(editorModel.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed)) && _Utils_eq(editorModel.selectedUntilDate, $elm$core$Maybe$Nothing)));
				var _v40 = function () {
					var _v41 = editorModel.temporarilyClosed;
					if (_v41.$ === 'Until') {
						var until = _v41.a;
						var message_ = _v41.b;
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(until),
							message_);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
					}
				}();
				var maybePosix = _v40.a;
				var message = _v40.b;
				var schedulingSelected = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					function (date) {
						var isoStringToday = $justinmimbs$date$Date$toIsoString(
							A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.now));
						var isoTringDate = $justinmimbs$date$Date$toIsoString(date);
						return (!_Utils_eq(editorModel.selectedUntilDate, $elm$core$Maybe$Nothing)) && ((!_Utils_eq(isoTringDate, isoStringToday)) && (!_Utils_eq(
							$author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedToPosix(model.location.temporarilyClosedUntil),
							maybePosix)));
					},
					editorModel.selectedFromDate);
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					_Utils_eq(
						$author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedToPosix(model.location.temporarilyClosedUntil),
						maybePosix) && (_Utils_eq(
						$author$project$Data$Location$temporarilyClosedMessageToString(model.location.temporarilyClosedMessage),
						message) && _Utils_eq(
						$author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedToBool(model.location.temporarilyClosedUntil),
						!_Utils_eq(editorModel.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed))),
					A2(
						$elm$core$Maybe$map,
						function (_v43) {
							return false;
						},
						model.bulkAction));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationTempClosed(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2($elm$html$Html$span, _List_Nil, _List_Nil),
								negativeButton: false,
								customSubmitLabel: schedulingSelected ? $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations)) : $elm$core$Maybe$Nothing
							}) : $elm$core$Maybe$Nothing,
						isDisabled: $elm$core$List$isEmpty(model.selectedLocations) || (isDisabled && (!schedulingSelected)),
						onUnselect: function (_v42) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$TemporarilyClosedMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$TemporarilyClosed$view, session.translations, editorModel)));
			case 'OpenStatus':
				var editorModel = editor.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationOpenStatus(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$openStatusTitle(session.translations),
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: $elm$core$List$isEmpty(model.selectedLocations) || (!$author$project$Location$Details$PopupContent$OpenStatus$isValid(editorModel)),
						onUnselect: function (_v44) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: $author$project$Location$Details$PopupContent$OpenStatus$isRePublish(editorModel),
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$OpenStatusMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$OpenStatus$view, session.translations, editorModel)));
			case 'OpeningDate':
				var editorModel = editor.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationOpeningDate(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$openingDateLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$openingDateLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: false,
						onUnselect: function (_v45) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: _Utils_eq(
							$author$project$Location$Details$PopupContent$OpeningDate$stringDateToPosix(model.location.openingDate),
							editorModel.openingDate),
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$OpeningDateMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$OpeningDate$view, session.translations, editorModel)));
			case 'LongDescription':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(
					model.location.longDescription,
					$author$project$Location$Details$PopupContent$LongDescription$validatedLongDescriptionToLongDescription(editorModel.longDescription));
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					!editorChanged,
					A2(
						$elm$core$Maybe$map,
						function (_v49) {
							return false;
						},
						model.bulkAction));
				var _v46 = A2($author$project$Location$Details$PopupContent$LongDescription$render, $elm$core$Basics$identity, editorModel);
				var view_ = _v46.a;
				var isValid = $author$project$Location$Details$PopupContent$LongDescription$isValid(editorModel);
				var isEnabled = isValid && locationsSelected;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationLongDescription(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v47) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						onUnselect: function (_v48) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$LongDescriptionMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						view_));
			case 'Phone':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(model.location.phone, editorModel.phoneNumber);
				var phoneIsValid = A2($author$project$Location$Details$PopupContent$Phone$isValid, session.translations, editorModel);
				var isRepublish = A2(
					$elm$core$Maybe$withDefault,
					!editorChanged,
					A2(
						$elm$core$Maybe$map,
						function (_v52) {
							return false;
						},
						model.bulkAction));
				var isEnabled = locationsSelected && phoneIsValid;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationPhone(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$phoneLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$phoneLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v50) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						onUnselect: function (_v51) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: isRepublish,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$PhoneMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$Phone$view, session.translations, editorModel)));
			case 'PermanentlyClosed':
				var editorModel = editor.a;
				var editorChanged = !_Utils_eq(model.location.permanentlyClosed, editorModel.permanentlyClosedStatus);
				var isEnabled = locationsSelected;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationPermanentlyClosed(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v53) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: (!isEnabled) || (!locationsSelected),
						onUnselect: function (_v54) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: !editorChanged,
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$PermanentlyClosedMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$PermanentlyClosed$view, session.translations, editorModel)));
			case 'LocationDescriptor':
				var editorModel = editor.a;
				var _v55 = A2($author$project$Location$Details$PopupContent$LocationDescriptor$render, $elm$core$Basics$identity, editorModel);
				var view_ = _v55.a;
				var isDisabled = _v55.b;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationLongDescription(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: isDisabled,
						onUnselect: function (_v56) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: _Utils_eq(
							editorModel.locationDescriptor,
							$author$project$Data$ValidatedLocationDescriptor$ValidLocationDescriptor(model.location.locationDescriptor)),
						locationSelector: $elm$core$Maybe$Nothing,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$LocationDescriptorMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						view_));
			default:
				var editorModel = editor.a;
				var locationSelectorEnabled = $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$map,
						tagger,
						A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model)));
				var editorChanged = !_Utils_eq(
					A2(
						$elm$core$List$sortBy,
						function (record) {
							return $elm$time$Time$posixToMillis(record.startDate);
						},
						model.location.specialOpenHours),
					A2(
						$elm$core$List$sortBy,
						function (record) {
							return $elm$time$Time$posixToMillis(record.startDate);
						},
						$author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList(editorModel)));
				var isRepublish = _Utils_eq(
					$author$project$Location$Details$PopupContent$SpecialOpenHours$sourceCall(editorModel),
					$author$project$Location$Details$PopupContent$SpecialOpenHours$LDP) ? ((!editorChanged) && locationsSelected) : false;
				var isEnabled = locationsSelected && ($author$project$Location$Details$PopupContent$SpecialOpenHours$isValid(editorModel) && ((locationsChanged && (!_Utils_eq(
					$author$project$Location$Details$PopupContent$SpecialOpenHours$sourceCall(editorModel),
					$author$project$Location$Details$PopupContent$SpecialOpenHours$SideBar))) || editorChanged));
				var isDisabled = (!isEnabled) && (!isRepublish);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$General$locationSpecialHours(session.translations),
						header: $author$project$Translations$General$locationSpecialHours(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$descriptionSpecialOpenHours(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: isDisabled,
						onUnselect: function (ids) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(ids));
						},
						isRePublish: isRepublish,
						locationSelector: locationSelectorEnabled,
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$SpecialOpenHoursMsg,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, tagger)),
						A2($author$project$Location$Details$PopupContent$SpecialOpenHours$view, session.translations, editorModel)));
		}
	});
var $author$project$Location$Details$Editor$Model$ConfirmCancel = {$: 'ConfirmCancel'};
var $author$project$Location$Details$Editor$Model$ConfirmedUpdate = function (a) {
	return {$: 'ConfirmedUpdate', a: a};
};
var $author$project$Common$Util$boolToString = function (value) {
	return value ? 'True' : 'False';
};
var $author$project$Translations$General$serviceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.service_areas');
};
var $author$project$Data$Location$phoneToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.delete_schedule');
};
var $author$project$Location$Details$Editor$View$getDisplayNameFromProperty = F2(
	function (property, fieldName) {
		var propertyMeta = function () {
			switch (property.$) {
				case 'ListProperty':
					var propertyMeta_ = property.a;
					return propertyMeta_;
				case 'StringProperty':
					var propertyMeta_ = property.a;
					return propertyMeta_;
				case 'BooleanProperty':
					var propertyMeta_ = property.a;
					return propertyMeta_;
				case 'OpenHoursProperty':
					var propertyMeta_ = property.a;
					return propertyMeta_;
				case 'SpecialOpenHoursProperty':
					var propertyMeta_ = property.a;
					return propertyMeta_;
				default:
					var propertyMeta_ = property.a;
					return propertyMeta_;
			}
		}();
		var _v0 = propertyMeta.name;
		var propertyFieldName = _v0.a;
		return _Utils_eq(propertyFieldName, fieldName) ? $elm$core$Maybe$Just(propertyMeta.displayName) : $elm$core$Maybe$Nothing;
	});
var $author$project$Location$Details$Editor$View$getDisplayName = F2(
	function (fieldName, customDataDefinition) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			fieldName,
			function (customData) {
				var _v0 = customData;
				var definitions = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fieldName,
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function (item) {
								return $elm$core$Basics$identity(
									A2($author$project$Location$Details$Editor$View$getDisplayNameFromProperty, item, fieldName));
							},
							definitions)));
			},
			customDataDefinition);
	});
var $author$project$Data$Location$homepageToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Translations$General$closed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.closed');
};
var $author$project$Translations$General$abbrHour = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_hour');
};
var $author$project$Translations$Listings$LocationDetail$alwaysOpen = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.always_open');
};
var $author$project$Translations$Listings$LocationDetail$notSet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.not_set');
};
var $author$project$Listings$Ui$Row$emptyValue = function (translations) {
	return $author$project$Translations$Listings$LocationDetail$notSet(translations);
};
var $author$project$Listings$Ui$Row$emptyValueSpan = function (translations) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-details-row__value__not-set')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Listings$Ui$Row$emptyValue(translations))
			]));
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Listings$Ui$Row$timeFormat = function (time) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				A2($elm$core$String$left, 2, time),
				':',
				A2($elm$core$String$right, 2, time)
			]));
};
var $author$project$Listings$Ui$Row$displayTimeSpan = function (timeSpan) {
	return $author$project$Listings$Ui$Row$timeFormat(timeSpan.open) + (' - ' + $author$project$Listings$Ui$Row$timeFormat(timeSpan.close));
};
var $author$project$Listings$Ui$Row$renderOpenHoursView = F2(
	function (hour, translations) {
		var hourText = '24' + $author$project$Translations$General$abbrHour(translations);
		var displayDaySpan = function (day) {
			switch (day.$) {
				case 'Open':
					var span = day.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (s) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Listings$Ui$Row$displayTimeSpan(
												{open: s.open, close: s.close}))
										]));
							},
							span));
				case 'Closed':
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$closed(translations))
							]));
				case 'NotSpecified':
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Listings$Ui$Row$emptyValueSpan(translations)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(hourText)
							]));
			}
		};
		if (hour.$ === 'Always') {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$alwaysOpen(translations))
					]));
		} else {
			var sun = hour.a.sun;
			var sat = hour.a.sat;
			var fri = hour.a.fri;
			var thu = hour.a.thu;
			var wed = hour.a.wed;
			var tue = hour.a.tue;
			var mon = hour.a.mon;
			var weekObjects = _List_fromArray(
				[
					{
					key: $author$project$Translations$General$mon(translations),
					value: displayDaySpan(mon)
				},
					{
					key: $author$project$Translations$General$tue(translations),
					value: displayDaySpan(tue)
				},
					{
					key: $author$project$Translations$General$wed(translations),
					value: displayDaySpan(wed)
				},
					{
					key: $author$project$Translations$General$thu(translations),
					value: displayDaySpan(thu)
				},
					{
					key: $author$project$Translations$General$fri(translations),
					value: displayDaySpan(fri)
				},
					{
					key: $author$project$Translations$General$sat(translations),
					value: displayDaySpan(sat)
				},
					{
					key: $author$project$Translations$General$sun(translations),
					value: displayDaySpan(sun)
				}
				]);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (day) {
										return A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'vertical-align', 'top')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(day.key)
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('location-details-row__table--td-center'),
															A2($elm$html$Html$Attributes$style, 'width', '10em')
														]),
													_List_fromArray(
														[day.value]))
												]));
									},
									weekObjects))
							]))
					]));
		}
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customFieldTypeNotSupported = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_field_type_not_supported');
};
var $author$project$Listings$Ui$Row$displayLabel = function (hour) {
	return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, hour.label);
};
var $author$project$Listings$Ui$Row$displayDateSpan = function (hour) {
	return _Utils_eq(hour.startDate, hour.endDate) ? A2($author$project$Common$Date$dateShort, $elm$time$Time$utc, hour.startDate) : (A2($author$project$Common$Date$dateShort, $elm$time$Time$utc, hour.startDate) + (' - ' + A2($author$project$Common$Date$dateShort, $elm$time$Time$utc, hour.endDate)));
};
var $author$project$Listings$Ui$Row$renderSpecialOpenHoursTable = F2(
	function (upcomingDatesList, translations) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '44.5rem')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (hour) {
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('location-details-row__table--td-special-hour-date')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Listings$Ui$Row$displayDateSpan(hour))
											])),
										function () {
										var _v0 = hour.state;
										if (_v0.$ === 'Open') {
											var span = _v0.a;
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('location-details-row__table--td-special-hour-time')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Listings$Ui$Row$displayTimeSpan(
															{open: span.open, close: span.close}))
													]));
										} else {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('location-details-row__table--td-special-hour-time')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$General$closed(translations))
													]));
										}
									}(),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('location-details-row__table--td-special-hour-label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Listings$Ui$Row$displayLabel(hour))
											]))
									]));
						},
						upcomingDatesList))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$renderObjectView = F2(
	function (properties, translations) {
		var fromBooleanToString = function (boolValue) {
			return boolValue ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations);
		};
		var fromListToString = function (valuesList) {
			return $elm$core$List$isEmpty(valuesList) ? '-' : A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (text) {
						if (text.$ === 'StringProperty') {
							var _v8 = text.a;
							var str = _v8.a;
							return str;
						} else {
							return '-' + ($author$project$Translations$Listings$LocationDetail$PopUpContent$customFieldTypeNotSupported(translations) + '-');
						}
					},
					valuesList));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (value) {
					switch (value.$) {
						case 'ObjectProperty':
							var _v1 = value.a;
							var vals = _v1.a;
							return A2($author$project$Location$Details$PopupContent$CustomFieldObject$renderObjectView, vals, translations);
						case 'StringProperty':
							var _v2 = value.a;
							var val = _v2.a;
							var meta = _v2.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(meta.displayName + (': ' + val))
									]));
						case 'BooleanProperty':
							var _v3 = value.a;
							var val = _v3.a;
							var meta = _v3.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										meta.displayName + (': ' + fromBooleanToString(val)))
									]));
						case 'ListProperty':
							var _v4 = value.a;
							var valuesList = _v4.a;
							var meta = _v4.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										meta.displayName + (': ' + fromListToString(valuesList)))
									]));
						case 'OpenHoursProperty':
							var _v5 = value.a;
							var val = _v5.a;
							var meta = _v5.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(meta.displayName)
											])),
										A2($author$project$Listings$Ui$Row$renderOpenHoursView, val, translations)
									]));
						default:
							var _v6 = value.a;
							var val = _v6.a;
							var meta = _v6.b;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(meta.displayName)
											])),
										A2($author$project$Listings$Ui$Row$renderSpecialOpenHoursTable, val, translations)
									]));
					}
				},
				properties));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.permanently_closed_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$setToPermanentlyClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.set_to_permanently_closed');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_title');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$setToNotPermanentlyClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.set_to_not_permanently_closed');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntil = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.temporarily_closed_until');
};
var $author$project$Listings$Ui$Row$renderTemporarilyClosedView = F3(
	function (tempClosed, translations, locale) {
		if (tempClosed.$ === 'Until') {
			var until = tempClosed.a;
			var message = tempClosed.b;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedUntil(translations))
							])),
						$author$project$PinMeTo$Ui$Date$render(
						A2(
							$author$project$PinMeTo$Ui$Date$withFormat,
							$author$project$PinMeTo$Ui$Date$FormatDate,
							A2($author$project$PinMeTo$Ui$Date$posix, locale, until))),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								($elm$core$String$length(message) > 0) ? (' - ' + message) : '')
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$no(translations))
							])),
						A2($elm$html$Html$span, _List_Nil, _List_Nil)
					]));
		}
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduledReadOnlyDescriptionAuthor = F2(
	function (translations, author) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.pop_up_content.scheduled_read_only_description_author',
			_List_fromArray(
				[
					_Utils_Tuple2('author', author)
				]));
	});
var $author$project$Location$Details$Editor$View$scheduledUpdateView = F5(
	function (_v0, session, model, customDataDefinition, scheduledUpdate) {
		var onCancel = _v0.onCancel;
		var tagger = _v0.tagger;
		var renderSchedulingDetailsLabel = function () {
			var dateElement = $author$project$PinMeTo$Ui$Date$render(
				A2(
					$author$project$PinMeTo$Ui$Date$withFormat,
					$author$project$PinMeTo$Ui$Date$FormatDate,
					A2($author$project$PinMeTo$Ui$Date$posix, session.locale, scheduledUpdate.date)));
			var labelText = A2($author$project$Translations$Listings$LocationDetail$PopUpContent$scheduledReadOnlyDescriptionAuthor, session.translations, scheduledUpdate.userName);
			return A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelText),
						$elm$html$Html$text(' '),
						dateElement
					]));
		}();
		var _v1 = scheduledUpdate.fieldAndData;
		switch (_v1.$) {
			case 'AddressField':
				var data = _v1.a;
				var locationTypeLabel = function () {
					var _v4 = data.locationType;
					switch (_v4.$) {
						case 'Storefront':
							return $author$project$Translations$General$storefront(session.translations);
						case 'StorefrontAndServiceArea':
							return $author$project$Translations$General$storefrontAndServiceArea(session.translations);
						default:
							return $author$project$Translations$General$serviceArea(session.translations);
					}
				}();
				var serviceAreaLines = function () {
					var _v3 = data.serviceAreas;
					switch (_v3.$) {
						case 'WithPlaceId':
							var areas = _v3.a;
							return A2(
								$elm$core$List$map,
								function ($) {
									return $.area;
								},
								areas);
						case 'Text':
							var areas = _v3.a;
							return areas;
						default:
							return _List_Nil;
					}
				}();
				var addressLines = _Utils_ap(
					_List_fromArray(
						[
							$author$project$Translations$General$locationStreet(session.translations) + (': ' + data.address.street),
							$author$project$Translations$General$locationZipPostalCode(session.translations) + (': ' + data.address.zip),
							$author$project$Translations$General$locationCity(session.translations) + (': ' + data.address.city)
						]),
					_Utils_ap(
						$author$project$Data$Address$hasState(data.address) ? _List_fromArray(
							[
								$author$project$Translations$General$locationStateRegion(session.translations) + (': ' + $author$project$Data$Address$getState(data.address))
							]) : _List_fromArray(
							[
								$author$project$Translations$General$locationProvince(session.translations) + (': ' + $author$project$Data$Address$getProvince(data.address)),
								$author$project$Translations$General$locationDistrict(session.translations) + (': ' + $author$project$Data$Address$getDistrict(data.address))
							]),
						_List_fromArray(
							[
								$author$project$Translations$General$locationCountry(session.translations) + (': ' + data.address.country)
							])));
				var textLine = function (line) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(line)
							]));
				};
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationAddress(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$sectionAddress(session.translations),
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v2) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									textLine(
										$author$project$Translations$General$locationType(session.translations) + (': ' + locationTypeLabel)),
									_Utils_ap(
										A2($elm$core$List$map, textLine, addressLines),
										$elm$core$List$isEmpty(serviceAreaLines) ? _List_Nil : A2(
											$elm$core$List$cons,
											textLine(
												$author$project$Translations$General$serviceAreas(session.translations) + ':'),
											A2($elm$core$List$map, textLine, serviceAreaLines)))))
							])));
			case 'OpenHoursField':
				var openHours = _v1.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursTitle(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v5) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Listings$Ui$Row$renderOpenHoursView, openHours, session.translations)
									]))
							])));
			case 'TemporarilyClosedField':
				var temporarilyClosed = _v1.a;
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedTitle(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v6) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$LocationDetail$PopUpContent$temporarilyClosedTitle(session.translations) + ' '),
										A3($author$project$Listings$Ui$Row$renderTemporarilyClosedView, temporarilyClosed, session.translations, session.locale)
									]))
							])));
			case 'PermanentlyClosedField':
				var permanentlyClosed = _v1.a;
				var renderText = (permanentlyClosed ? $author$project$Translations$Listings$LocationDetail$PopUpContent$setToPermanentlyClosed : $author$project$Translations$Listings$LocationDetail$PopUpContent$setToNotPermanentlyClosed)(session.translations);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedTitle(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$permanentlyClosedDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v7) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(renderText)
									]))
							])));
			case 'PhoneField':
				var phone = _v1.a;
				var stringPhone = ($author$project$Data$Location$phoneToString(phone) === '') ? '-' : $author$project$Data$Location$phoneToString(phone);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationPhone(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$phoneLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$phoneLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v8) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$locationPhone(session.translations) + (': ' + stringPhone))
									]))
							])));
			case 'EmailField':
				var email = _v1.a;
				var stringEmail = ($author$project$Data$Location$emailToString(email) === '') ? '-' : $author$project$Data$Location$emailToString(email);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationEmail(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$emailLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$emailLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v9) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$locationEmail(session.translations) + (': ' + stringEmail))
									]))
							])));
			case 'HomepageField':
				var homepage = _v1.a;
				var stringHomepage = ($author$project$Data$Location$homepageToString(homepage) === '') ? '-' : $author$project$Data$Location$homepageToString(homepage);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationHomepage(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$homepageLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$homepageLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v10) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$locationHomepage(session.translations) + (': ' + stringHomepage))
									]))
							])));
			case 'LongDescriptionField':
				var longDescription = _v1.a;
				var _v11 = longDescription;
				var stringLongDescription = _v11.a;
				var data = A2(
					$elm$core$List$map,
					function (longDescription_) {
						return A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(longDescription_)
								]));
					},
					A2($elm$core$String$split, '\u000A', stringLongDescription));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationLongDescription(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v12) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$append,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$locationLongDescription(session.translations) + ':'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										]),
									data))
							])));
			case 'ShortDescriptionField':
				var shortDescription = _v1.a;
				var _v13 = shortDescription;
				var stringShortDescription = _v13.a;
				var data = A2(
					$elm$core$List$map,
					function (shortDescription_) {
						return A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(shortDescription_)
								]));
					},
					A2($elm$core$String$split, '\u000A', stringShortDescription));
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$General$locationShortDescription(session.translations),
						header: $author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxHeader(session.translations),
						description: $elm$core$Maybe$Just(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$shortDescriptionLightBoxDescription(session.translations))
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v14) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$append,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$locationShortDescription(session.translations) + ':'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										]),
									data))
							])));
			case 'CustomDataOpenHoursField':
				var customName = _v1.a;
				var openHours = _v1.b;
				var displayName = A2($author$project$Location$Details$Editor$View$getDisplayName, customName, customDataDefinition);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursTitle(session.translations),
						header: displayName,
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v15) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Listings$Ui$Row$renderOpenHoursView, openHours, session.translations)
									]))
							])));
			case 'CustomDataStringField':
				var customName = _v1.a;
				var string = _v1.b;
				var displayName = A2($author$project$Location$Details$Editor$View$getDisplayName, customName, customDataDefinition);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle, title: displayName, header: displayName, description: $elm$core$Maybe$Nothing},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v16) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(string)
									]))
							])));
			case 'CustomDataBoolField':
				var customName = _v1.a;
				var bool = _v1.b;
				var displayName = A2($author$project$Location$Details$Editor$View$getDisplayName, customName, customDataDefinition);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle, title: displayName, header: displayName, description: $elm$core$Maybe$Nothing},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v17) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Common$Util$boolToString(bool))
									]))
							])));
			case 'CustomDataListField':
				var customName = _v1.a;
				var list = _v1.b;
				var displayName = A2($author$project$Location$Details$Editor$View$getDisplayName, customName, customDataDefinition);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle, title: displayName, header: displayName, description: $elm$core$Maybe$Nothing},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v18) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$String$join, ', ', list))
									]))
							])));
			default:
				var customName = _v1.a;
				var customData = _v1.b;
				var _v19 = customData;
				var propertyList = _v19.a;
				var displayName = A2($author$project$Location$Details$Editor$View$getDisplayName, customName, customDataDefinition);
				return A4(
					$author$project$Location$Details$Editor$View$lightBox2,
					session,
					{style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle, title: displayName, header: displayName, description: $elm$core$Maybe$Nothing},
					{
						error: model.error,
						popOver: $elm$core$Maybe$Nothing,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$Editor$Model$OnSubmit),
						scheduler: $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$Editor$View$schedulerHtml, session, model)),
								negativeButton: true,
								customSubmitLabel: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$PopUpContent$deleteSchedule(session.translations))
							}),
						isDisabled: false,
						onUnselect: function (_v20) {
							return tagger(
								$author$project$Location$Details$Editor$Model$OnUnselectConflictingLocations(_List_Nil));
						},
						isRePublish: false,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$Editor$View$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								renderSchedulingDetailsLabel,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Location$Details$PopupContent$CustomFieldObject$renderObjectView, propertyList, session.translations)
									]))
							])));
		}
	});
var $author$project$Location$Details$Editor$View$view = F4(
	function (config, session, customDataDefinition, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = model.content;
					if (_v0.$ === 'Editor') {
						var editorState = _v0.a;
						return A4($author$project$Location$Details$Editor$View$editorView, config, session, model, editorState);
					} else {
						var scheduledUpdate = _v0.a;
						return A5($author$project$Location$Details$Editor$View$scheduledUpdateView, config, session, model, customDataDefinition, scheduledUpdate);
					}
				}(),
					A2(
					$elm$html$Html$map,
					config.tagger,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Location$Details$Editor$Confirm$view,
								session,
								{onCancel: $author$project$Location$Details$Editor$Model$ConfirmCancel, onConfirm: $author$project$Location$Details$Editor$Model$ConfirmedUpdate}),
							model.confirm)))
				]));
	});
var $author$project$Location$Details$Editor$view = F4(
	function (config, session, customDataDefinition, _v0) {
		var model = _v0.a;
		return A4($author$project$Location$Details$Editor$View$view, config, session, customDataDefinition, model);
	});
var $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorMsg = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorMsg', a: a, b: b};
	});
var $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorClose = {$: 'LocationDetailsEditorClose'};
var $author$project$ApiPendingChanges$Resolver$View$editorView = F3(
	function (session, locationId, _v0) {
		var editorState = _v0.b;
		return A4(
			$author$project$Location$Details$Editor$view,
			{
				tagger: $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorMsg(locationId),
				onCancel: $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorClose,
				onSubmit: $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorClose,
				withScheduling: false
			},
			session,
			$elm$core$Maybe$Nothing,
			editorState);
	});
var $author$project$Common$PaginationSimple$currentKey = function (pagination) {
	return A2($elm$core$Array$get, pagination.currentPage, pagination.keys);
};
var $author$project$Common$PaginationSimple$currentItem = function (pagination) {
	return A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($elm$core$Dict$get, id, pagination.items);
		},
		$author$project$Common$PaginationSimple$currentKey(pagination));
};
var $author$project$Translations$General$error = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.error');
};
var $author$project$ApiPendingChanges$Resolver$View$errorBanner = F2(
	function (userMessage, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar__message')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$error(translations) + ': ')
										])),
									$elm$html$Html$text(userMessage)
								]))
						]))
				]));
	});
var $author$project$ApiPendingChanges$Resolver$Update$OnPageChange = function (a) {
	return {$: 'OnPageChange', a: a};
};
var $author$project$Translations$General$ofPreposition = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.of_preposition');
};
var $author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml = function (titleHtml) {
	return _Utils_update(
		$author$project$PinMeTo$Ui$TitleBar$initConfig,
		{
			titleHtml: $elm$core$Maybe$Just(titleHtml)
		});
};
var $author$project$ApiPendingChanges$Resolver$Update$OnPageInputChange = function (a) {
	return {$: 'OnPageInputChange', a: a};
};
var $author$project$ApiPendingChanges$Resolver$Update$OnPageInputSubmit = {$: 'OnPageInputSubmit'};
var $author$project$Translations$Listings$Conflicts$clickingUseMasterdata = F2(
	function (translations, useMasterData) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.conflicts.clicking_use_masterdata',
			_List_fromArray(
				[
					_Utils_Tuple2('useMasterData', useMasterData)
				]));
	});
var $author$project$Translations$Listings$Conflicts$clickingApplyApiChange = F2(
	function (translations, applyApiChange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.conflicts.clicking_apply_api_change',
			_List_fromArray(
				[
					_Utils_Tuple2('applyApiChange', applyApiChange)
				]));
	});
var $author$project$ApiPendingChanges$Resolver$View$view = F2(
	function (session, model) {
		var _v0 = model.locations;
		switch (_v0.$) {
			case 'Loaded':
				var locations = _v0.a;
				var _v1 = $author$project$Common$PaginationSimple$currentItem(locations);
				if (_v1.$ === 'Just') {
					var location = _v1.a;
					var verifyLocationError = function () {
						var _v2 = A2($elm$core$Dict$get, location.id, model.verifyLocationErrors);
						if (_v2.$ === 'Nothing') {
							return $elm$html$Html$text('');
						} else {
							var userMessage = _v2.a.userMessage;
							return A2($author$project$ApiPendingChanges$Resolver$View$errorBanner, userMessage, session.translations);
						}
					}();
					return $author$project$ApiPendingChanges$Resolver$View$wrapper(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h1-page-title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$ApiDifference$apiChanges(session.translations))
									])),
								A2(
								$elm$html$Html$header,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('util__stick-to-header')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$TitleBar$render(
										A2(
											$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
											true,
											A2(
												$author$project$PinMeTo$Ui$TitleBar$withAsides,
												_List_fromArray(
													[
														A5(
														$author$project$Common$PaginationSimple$view,
														locations,
														$author$project$ApiPendingChanges$Resolver$Update$OnPageChange,
														$author$project$ApiPendingChanges$Resolver$Update$OnPageInputChange,
														$author$project$ApiPendingChanges$Resolver$Update$OnPageInputSubmit,
														{
															of_: $author$project$Translations$General$ofPreposition(session.translations)
														})
													]),
												$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(
													A6($author$project$ApiPendingChanges$Resolver$View$title, model.siteName, location.id, location.name, location.locationDescriptor, location.storeId, session.translations)))))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('util__inset')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-api-changes-resolver__content ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-api-changes-resolver__content--map')
													]),
												_List_fromArray(
													[
														A3($author$project$ApiPendingChanges$Resolver$View$mapView, session.translations, model.selected, location),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-api-changes-resolver__note')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('note')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$author$project$Translations$Listings$Conflicts$clickingUseMasterdata,
																			session.translations,
																			$author$project$Translations$Listings$ApiDifference$useMaster(session.translations))),
																		A2($elm$html$Html$br, _List_Nil, _List_Nil),
																		$elm$html$Html$text(
																		A2(
																			$author$project$Translations$Listings$Conflicts$clickingApplyApiChange,
																			session.translations,
																			$author$project$Translations$Listings$ApiDifference$applyApiChange(session.translations)))
																	]))
															]))
													])),
												verifyLocationError,
												A4($author$project$ApiPendingChanges$Resolver$View$ConflictView$view, model.editing, model.selected, location, session.translations)
											]))
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									A2($author$project$ApiPendingChanges$Resolver$View$editorView, session, location.id),
									model.editor))
							]));
				} else {
					return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
				}
			case 'Loading':
				return $author$project$ApiPendingChanges$Resolver$View$wrapper(
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Suspended':
				return $author$project$ApiPendingChanges$Resolver$View$wrapper(
					_List_fromArray(
						[
							A2($author$project$ApiPendingChanges$Resolver$NoContent$view, session, model)
						]));
			default:
				return $author$project$ApiPendingChanges$Resolver$View$wrapper(
					_List_fromArray(
						[
							A2(
							$author$project$ApiPendingChanges$Resolver$View$errorBanner,
							$author$project$Translations$Listings$ApiDifference$pageError(session.translations),
							session.translations)
						]));
		}
	});
var $author$project$RemoteData$map = F2(
	function (f, remoteData) {
		switch (remoteData.$) {
			case 'Loaded':
				var data = remoteData.a;
				return $author$project$RemoteData$Loaded(
					f(data));
			case 'Suspended':
				return $author$project$RemoteData$Suspended;
			case 'Loading':
				return $author$project$RemoteData$Loading;
			default:
				var x = remoteData.a;
				return $author$project$RemoteData$Error(x);
		}
	});
var $author$project$ApiPendingChanges$Resolver$Update$NoOp = {$: 'NoOp'};
var $author$project$Location$Details$Editor$Model$Wifi = function (a) {
	return {$: 'Wifi', a: a};
};
var $author$project$Location$Details$PopupContent$Wifi$init = function (wifi) {
	return {wifi: wifi};
};
var $author$project$Data$ValidatedEmail$pattern = '(?:[a-z0-9\u005Cu00C0-\u005Cu017F!#$%&\u0027*+\u005C/=?^_`{|}~-]+(?:\u005C.[a-z0-9\u005Cu00C0-\u005Cu017F!#$%&\u0027*+\u005C/=?^_`{|}~-]+)*|\u0022(?:[\u005Cx01-\u005Cx08\u005Cx0b\u005Cx0c\u005Cx0e-\u005Cx1f\u005Cx21\u005Cx23-\u005Cx5b\u005Cx5d-\u005Cx7f]|\u005C[\u005Cx01-\u005Cx09\u005Cx0b\u005Cx0c\u005Cx0e-\u005Cx7f])*\u0022)@(?:(?:[a-z0-9\u005Cu00C0-\u005Cu017F](?:[a-z0-9\u005Cu00C0-\u005Cu017F-]*[a-z0-9\u005Cu00C0-\u005Cu017F])?\u005C.)+[a-z0-9\u005Cu00C0-\u005Cu017F](?:[a-z0-9\u005Cu00C0-\u005Cu017F-]*[a-z0-9\u005Cu00C0-\u005Cu017F])?|\u005C[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\u005C.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9\u005Cu00C0-\u005Cu017F-]*[a-z0-9\u005Cu00C0-\u005Cu017F]:(?:[\u005Cx01-\u005Cx08\u005Cx0b\u005Cx0c\u005Cx0e-\u005Cx1f\u005Cx21-\u005Cx5a\u005Cx53-\u005Cx7f]|\u005C[\u005Cx01-\u005Cx09\u005Cx0b\u005Cx0c\u005Cx0e-\u005Cx7f])+)\u005C])';
var $author$project$Data$ValidatedEmail$maybeRegex = $elm$regex$Regex$fromString($author$project$Data$ValidatedEmail$pattern);
var $author$project$Data$ValidatedEmail$regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $author$project$Data$ValidatedEmail$maybeRegex);
var $author$project$Data$ValidatedEmail$ValidEmail = function (a) {
	return {$: 'ValidEmail', a: a};
};
var $author$project$Data$ValidatedEmail$InvalidEmail = F2(
	function (a, b) {
		return {$: 'InvalidEmail', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$emailInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.email_invalid');
};
var $author$project$Data$ValidatedEmail$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Data$ValidatedEmail$create = F2(
	function (translations, email) {
		return ((!$elm$core$String$length(email)) || ($author$project$Common$Validators$CsvInjection$isInputValid(email) && A2($elm$regex$Regex$contains, $author$project$Data$ValidatedEmail$regex, email))) ? $author$project$Data$ValidatedEmail$ValidEmail(
			$author$project$Data$Location$Email(email)) : A2(
			$author$project$Data$ValidatedEmail$InvalidEmail,
			$author$project$Data$Location$Email(email),
			$author$project$Data$ValidatedEmail$ValidationError(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$emailInvalid(translations)));
	});
var $author$project$Location$Details$PopupContent$Email$init = F2(
	function (translations, _v0) {
		var email = _v0.a;
		var validatedEmail = A2($author$project$Data$ValidatedEmail$create, translations, email);
		return {email: validatedEmail, translations: translations};
	});
var $author$project$Location$Details$PopupContent$Phone$init = function (phone) {
	return {
		phoneNumber: phone,
		phoneNumberString: $author$project$Data$Location$phoneToString(phone)
	};
};
var $author$project$Location$Details$PopupContent$Active$init = function (isActive) {
	return {isActive: isActive};
};
var $author$project$PinMeTo$Ui$PopOver$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$PopOver$init = $author$project$PinMeTo$Ui$PopOver$State(
	{card: $elm$core$Maybe$Nothing, openPopOver: $elm$core$Maybe$Nothing, currentPreferredDirection: $elm$core$Maybe$Nothing});
var $author$project$Common$Debouncer$maxId = 99999999999;
var $author$project$Common$Debouncer$init = F2(
	function (amountMs, initialContent) {
		return {content: initialContent, debounceId: -$author$project$Common$Debouncer$maxId, debounceAmountMs: amountMs};
	});
var $author$project$Common$Form$Clean = function (a) {
	return {$: 'Clean', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FullList = function (a) {
	return {$: 'FullList', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FetchFail = {$: 'FetchFail'};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$AddableList = function (a) {
	return {$: 'AddableList', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$addArea = F2(
	function (areaToAdd, list) {
		switch (list.$) {
			case 'EmptyList':
				return $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$AddableList(
					_List_fromArray(
						[areaToAdd]));
			case 'AddableList':
				var currentAreas = list.a;
				var lst = A2($elm$core$List$cons, areaToAdd, currentAreas);
				return (_Utils_cmp(
					$elm$core$List$length(lst),
					$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$maxServiceArea) > 0) ? $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FullList(currentAreas) : $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$AddableList(lst);
			case 'FullList':
				var currentAreas = list.a;
				return $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FullList(currentAreas);
			default:
				return $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FetchFail;
		}
	});
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$EmptyList = {$: 'EmptyList'};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$create = function (xs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (x, serviceAreaList) {
				return A2($author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$addArea, x, serviceAreaList);
			}),
		$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$EmptyList,
		xs);
};
var $author$project$Common$ServiceAreaSelectorV2$Update$init = function (session) {
	var uiModel = {
		index: $elm$core$Maybe$Nothing,
		values: _List_Nil,
		visible: true,
		selected: $elm$core$Maybe$Nothing,
		inputValue: $author$project$Common$Form$Clean(''),
		multiValues: true
	};
	return _Utils_Tuple2(
		{
			siteName: session.siteName,
			debouncer: A2($author$project$Common$Debouncer$init, 150, ''),
			sessionToken: $elm$core$Maybe$Nothing,
			translations: session.translations,
			uiAutoComplete: uiModel,
			selectedServiceAreas: $author$project$Common$Form$Clean(
				$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$create(_List_Nil)),
			availableServiceAreas: $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$EmptyList
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Location$Details$PopupContent$Address$GotCountryData = function (a) {
	return {$: 'GotCountryData', a: a};
};
var $author$project$Location$Details$PopupContent$Address$toCountries = function (data) {
	return A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.name;
		},
		A2(
			$elm$core$List$map,
			function (country) {
				return {
					name: country.countryName,
					alpha2: country.iso,
					regions: country.regions,
					requiresZip: !A2($elm$core$List$member, country.iso, data.countriesNotRequireZip),
					requiresRegion: A2($elm$core$List$member, country.iso, data.countriesRequiresRegion)
				};
			},
			data.countries));
};
var $author$project$Location$Details$PopupContent$Address$RawCountryData = F3(
	function (countriesRequiresRegion, countriesNotRequireZip, countries) {
		return {countries: countries, countriesNotRequireZip: countriesNotRequireZip, countriesRequiresRegion: countriesRequiresRegion};
	});
var $author$project$Location$Details$PopupContent$Address$RawCountry = F3(
	function (countryName, iso, regions) {
		return {iso: iso, regions: regions, countryName: countryName};
	});
var $author$project$Location$Details$PopupContent$Address$rawCountryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'regions',
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ISO',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'countryName',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Location$Details$PopupContent$Address$RawCountry))));
var $author$project$Location$Details$PopupContent$Address$countryDataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Location$Details$PopupContent$Address$toCountries,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'countries',
		$elm$json$Json$Decode$list($author$project$Location$Details$PopupContent$Address$rawCountryDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'countriesNotRequireZip',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'countriesRequiresRegion',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Location$Details$PopupContent$Address$RawCountryData)))));
var $author$project$Location$Details$PopupContent$Address$getCountryData = $lukewestby$elm_http_builder$HttpBuilder$request(
	A2(
		$lukewestby$elm_http_builder$HttpBuilder$withExpect,
		A2($elm$http$Http$expectJson, $author$project$Location$Details$PopupContent$Address$GotCountryData, $author$project$Location$Details$PopupContent$Address$countryDataDecoder),
		$lukewestby$elm_http_builder$HttpBuilder$get('/listings/api/countrydata/')));
var $author$project$Location$Details$PopupContent$Address$serviceAreasToList = function (serviceAreas) {
	switch (serviceAreas.$) {
		case 'WithPlaceId':
			var areas = serviceAreas.a;
			return areas;
		case 'Text':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Location$Details$PopupContent$Address$init = F3(
	function (translations, siteName, location) {
		var _v0 = $author$project$Common$ServiceAreaSelectorV2$Update$init(
			{siteName: siteName, translations: translations});
		var serviceAreaSelectorModel = _v0.a;
		var serviceAreaSelectorCmd = _v0.b;
		return _Utils_Tuple2(
			{
				address: location.address,
				uiSelect: $author$project$PinMeTo$Ui$Select$init,
				countries: $author$project$RemoteData$Loading,
				locationType: location.locationType,
				businessTypePopOver: $author$project$PinMeTo$Ui$PopOver$init,
				serviceAreaSelector: _Utils_update(
					serviceAreaSelectorModel,
					{
						selectedServiceAreas: $author$project$Common$Form$Clean(
							$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$create(
								$author$project$Location$Details$PopupContent$Address$serviceAreasToList(location.serviceAreas)))
					})
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Location$Details$PopupContent$Address$getCountryData,
						A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$PopupContent$Address$ServiceAreaSelectorMsg, serviceAreaSelectorCmd)
					])));
	});
var $author$project$Data$Location$storeIdToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Data$Location$facebookStoreIdToString = function (_v0) {
	var maybeString = _v0.a;
	return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, maybeString);
};
var $author$project$Location$Details$PopupContent$StoreId$init = F3(
	function (storeId, facebookStoreId, isFacebookConnected) {
		return {
			storeId: storeId,
			textStoreId: $author$project$Data$Location$storeIdToString(storeId),
			facebookStoreId: facebookStoreId,
			isFacebookConnected: isFacebookConnected,
			textFacebookStoreId: $author$project$Data$Location$facebookStoreIdToString(facebookStoreId)
		};
	});
var $author$project$Data$ValidatedHomepage$pattern = '^((https|http):\u005C/\u005C/)?([a-zA-Z0-9\u005Cu00C0-\u005Cu017F]+[a-zA-Z0-9\u005Cu00C0-\u005Cu017F\u005C.-]*[a-zA-Z0-9\u005Cu00C0-\u005Cu017F]+|[a-zA-Z0-9\u005Cu00C0-\u005Cu017F])\u005C.[a-zA-Z0-9]{2,}(((\u005C/|\u005C?|\u005C/\u005C?)[\u005Cs\u005CS]*[\u005Cw\u005CW]*[\u005Cd\u005CD]*)*)$';
var $author$project$Data$ValidatedHomepage$maybeRegex = $elm$regex$Regex$fromString($author$project$Data$ValidatedHomepage$pattern);
var $author$project$Data$ValidatedHomepage$regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $author$project$Data$ValidatedHomepage$maybeRegex);
var $author$project$Data$ValidatedHomepage$ValidHomepage = function (a) {
	return {$: 'ValidHomepage', a: a};
};
var $author$project$Data$ValidatedHomepage$InvalidHomepage = F2(
	function (a, b) {
		return {$: 'InvalidHomepage', a: a, b: b};
	});
var $author$project$Data$ValidatedHomepage$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Data$ValidatedHomepage$create = F2(
	function (translations, homepageParam) {
		var homepageInString = $elm$core$String$trim(homepageParam);
		return (!$elm$core$String$length(homepageInString)) ? $author$project$Data$ValidatedHomepage$ValidHomepage('') : ((A2($elm$regex$Regex$contains, $author$project$Data$ValidatedHomepage$regex, homepageInString) && $author$project$Common$Validators$CsvInjection$isInputValid(homepageInString)) ? $author$project$Data$ValidatedHomepage$ValidHomepage(homepageInString) : A2(
			$author$project$Data$ValidatedHomepage$InvalidHomepage,
			homepageInString,
			$author$project$Data$ValidatedHomepage$ValidationError(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$homepageInvalid(translations))));
	});
var $author$project$Location$Details$PopupContent$Homepage$init = F3(
	function (translations, storeId, _v0) {
		var homepage = _v0.a;
		var url = A2($author$project$Data$ValidatedHomepage$create, translations, homepage);
		return {storeId: storeId, homepage: url, translations: translations};
	});
var $author$project$Location$Details$PopupContent$OpenHours$init = function (openHours) {
	return _Utils_Tuple2(
		{error: $elm$core$Maybe$Nothing, openHours: openHours, bufferOpenHours: openHours, initialOpenHours: openHours},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Location$Details$PopupContent$Categories$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 'Header', a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $lukewestby$elm_http_builder$HttpBuilder$withHeader = F3(
	function (key, value, builder) {
		return _Utils_update(
			builder,
			{
				headers: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					builder.headers)
			});
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $author$project$Data$Location$NetworkCategories$Category = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$Data$Location$NetworkCategories$dataCategoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$Category)));
var $author$project$Data$Location$NetworkCategories$TomtomCategory = F3(
	function (featureTypeId, serviceSubCategoryId, name) {
		return {name: name, featureTypeId: featureTypeId, serviceSubCategoryId: serviceSubCategoryId};
	});
var $author$project$Data$Location$NetworkCategories$tomtomCategoryDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'name',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'serviceSubCategoryId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'featureTypeId',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$TomtomCategory))));
var $author$project$Data$Location$NetworkCategories$allCategoriesListDecoder = $elm$json$Json$Decode$list(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, $author$project$Data$Location$NetworkCategories$dataCategoryDecoder),
				A2($elm$json$Json$Decode$map, $author$project$Data$Location$NetworkCategories$TomtomNetworkCategory, $author$project$Data$Location$NetworkCategories$tomtomCategoryDecoder)
			])));
var $author$project$Location$Details$PopupContent$Categories$getAllBingCategories = F3(
	function (_v0, storeId, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allCategoriesListDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(
						'api/' + (accountName + ('/bing/categories/' + $elm$url$Url$percentEncode(
							$author$project$Data$Location$storeIdToString(storeId))))))));
	});
var $author$project$Data$Network$Here = {$: 'Here'};
var $author$project$Data$Network$toString = function (network) {
	switch (network.$) {
		case 'Facebook':
			return 'facebook';
		case 'Google':
			return 'google';
		case 'Bing':
			return 'bing';
		case 'Apple':
			return 'apple';
		case 'Foursquare':
			return 'factual';
		case 'Overture':
			return 'overture';
		case 'Here':
			return 'here';
		case 'Tomtom':
			return 'tomtom';
		case 'Ptv':
			return 'ptv';
		default:
			return 'instagram';
	}
};
var $author$project$Location$Details$PopupContent$Categories$getAllCategories = F4(
	function (network, _v0, decoderr, msg) {
		var accountName = _v0.a;
		var networkName = function () {
			if (network.$ === 'Foursquare') {
				return 'foursquare';
			} else {
				return $author$project$Data$Network$toString(network);
			}
		}();
		var url = 'api/' + (accountName + ('/' + (networkName + '/categories')));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, decoderr, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data',
	A2(
		$elm$json$Json$Decode$map,
		$elm_community$maybe_extra$Maybe$Extra$values,
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, $elm$core$Maybe$Just),
						$author$project$Data$Location$NetworkCategories$dataCategoryDecoder),
						A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$TomtomNetworkCategory, $elm$core$Maybe$Just),
						$author$project$Data$Location$NetworkCategories$tomtomCategoryDecoder),
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
					])))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Location$Details$PopupContent$Categories$getAllHereCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Here, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Data$Network$Apple = {$: 'Apple'};
var $author$project$Location$Details$PopupContent$Categories$getAllAppleCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Apple, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Location$Details$PopupContent$Categories$getAllGoogleCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Google, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Data$Network$Tomtom = {$: 'Tomtom'};
var $author$project$Location$Details$PopupContent$Categories$getAllTomtomCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Tomtom, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Data$Network$Facebook = {$: 'Facebook'};
var $author$project$Location$Details$PopupContent$Categories$getAllFacebookCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Facebook, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Data$Network$Overture = {$: 'Overture'};
var $author$project$Location$Details$PopupContent$Categories$getAllOvertureCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Overture, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Data$Network$Foursquare = {$: 'Foursquare'};
var $author$project$Location$Details$PopupContent$Categories$getAllFoursquareCategories = F2(
	function (accountName, msg) {
		return A4($author$project$Location$Details$PopupContent$Categories$getAllCategories, $author$project$Data$Network$Foursquare, accountName, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, msg);
	});
var $author$project$Location$Details$PopupContent$Categories$convertToRemovableCategories = function (categories) {
	return A2(
		$elm$core$List$map,
		function (cat) {
			return {category: cat, pendingRemoval: false};
		},
		categories);
};
var $author$project$Data$Location$NetworkCategories$bingCategoriesToCategoryGroup = function (bing) {
	var maybePrimary = A2(
		$elm$core$Maybe$andThen,
		function (id_) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return _Utils_eq(c.id, id_);
					},
					bing.categories));
		},
		bing.primaryCategoryId);
	var additional = function () {
		if (maybePrimary.$ === 'Just') {
			var primary = maybePrimary.a;
			return A2(
				$elm$core$List$filter,
				function (c) {
					return !_Utils_eq(c.id, primary.id);
				},
				bing.categories);
		} else {
			return bing.categories;
		}
	}();
	return {primary: maybePrimary, additional: additional};
};
var $author$project$Location$Details$PopupContent$Categories$init = F4(
	function (siteName, storeId, network, initialSelectedCategories) {
		var _v0 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			function (selected) {
				switch (selected.$) {
					case 'GoogleCategories':
						var selected_ = selected.a;
						return _Utils_Tuple2(
							A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.primary),
							A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.additional));
					case 'FacebookCategories':
						var selected_ = selected.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$Maybe$map,
								$author$project$Data$Location$NetworkCategories$CommonNetworkCategory,
								$elm$core$List$head(selected_.subcategories)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$elm$core$List$tail(
									A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.subcategories))));
					case 'BingCategories':
						var selected_ = selected.a;
						return function (x) {
							return _Utils_Tuple2(
								A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, x.primary),
								A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, x.additional));
						}(
							$author$project$Data$Location$NetworkCategories$bingCategoriesToCategoryGroup(selected_));
					case 'AppleCategories':
						var selected_ = selected.a;
						return _Utils_Tuple2(
							A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.primary),
							A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.additional));
					case 'FoursquareCategories':
						var selected_ = selected.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$Maybe$map,
								$author$project$Data$Location$NetworkCategories$CommonNetworkCategory,
								$elm$core$List$head(selected_.categories)),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$elm$core$List$tail(
									A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.categories))));
					case 'OvertureCategories':
						var selected_ = selected.a;
						return _Utils_Tuple2(
							A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.primary),
							A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.additional));
					case 'HereCategories':
						var selected_ = selected.a;
						return _Utils_Tuple2(
							A2($elm$core$Maybe$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.primary),
							A2($elm$core$List$map, $author$project$Data$Location$NetworkCategories$CommonNetworkCategory, selected_.additional));
					default:
						var selected_ = selected.a;
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								$author$project$Data$Location$NetworkCategories$TomtomNetworkCategory(selected_)),
							_List_Nil);
				}
			},
			initialSelectedCategories);
		var primary = _v0.a;
		var additionalCategories = _v0.b;
		var model = {
			network: network,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			allCategories: $author$project$RemoteData$Loading,
			primaryCategory: primary,
			initialCategories: initialSelectedCategories,
			additionalCategories: $author$project$Location$Details$PopupContent$Categories$convertToRemovableCategories(additionalCategories)
		};
		return _Utils_Tuple2(
			model,
			function () {
				switch (network.$) {
					case 'Apple':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllAppleCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Facebook':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllFacebookCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Google':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllGoogleCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Bing':
						return A3($author$project$Location$Details$PopupContent$Categories$getAllBingCategories, siteName, storeId, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Foursquare':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllFoursquareCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Overture':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllOvertureCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Here':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllHereCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Tomtom':
						return A2($author$project$Location$Details$PopupContent$Categories$getAllTomtomCategories, siteName, $author$project$Location$Details$PopupContent$Categories$GotAllCategories);
					case 'Ptv':
						return $elm$core$Platform$Cmd$none;
					default:
						return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$Location$Details$PopupContent$OpenStatus$init = F6(
	function (permanentlyClosed, temporarilyClosed, now, language, locale, scheduledUpdates) {
		var initialUntilDate = function () {
			if (temporarilyClosed.$ === 'Until') {
				var posix = temporarilyClosed.a;
				return $elm$core$Maybe$Just(
					A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, posix));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var initialFromDate = function () {
			if (temporarilyClosed.$ === 'Until') {
				return $elm$core$Maybe$Just(
					A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, now));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var initialChoice = function () {
			if (permanentlyClosed) {
				return $author$project$Location$Details$PopupContent$OpenStatus$PermanentlyClosed;
			} else {
				if (temporarilyClosed.$ === 'Until') {
					return $author$project$Location$Details$PopupContent$OpenStatus$TemporarilyClosed;
				} else {
					return $author$project$Location$Details$PopupContent$OpenStatus$OpenForBusiness;
				}
			}
		}();
		return {now: now, choice: initialChoice, locale: locale, language: language, scheduledUpdates: scheduledUpdates, selectedFromDate: initialFromDate, selectedUntilDate: initialUntilDate, selectedClosesOnDate: $elm$core$Maybe$Nothing};
	});
var $author$project$PinMeTo$Ui$TemplateTags$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$TemplateTags$init = $author$project$PinMeTo$Ui$TemplateTags$State($author$project$PinMeTo$Ui$PopOver$init);
var $author$project$Location$Details$PopupContent$ActionLinks$urlForType = F2(
	function (type_, links) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.url;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (link) {
							return _Utils_eq(link.type_, type_);
						},
						links))));
	});
var $author$project$Location$Details$PopupContent$ActionLinks$init = F4(
	function (_v0, _v1, appleConnectionType, initialActionLinks) {
		return _Utils_Tuple2(
			{
				rows: A2(
					$elm$core$List$map,
					function (type_) {
						return {
							url: A2($author$project$Location$Details$PopupContent$ActionLinks$urlForType, type_, initialActionLinks),
							error: $elm$core$Maybe$Nothing,
							type_: type_
						};
					},
					$author$project$Location$Details$PopupContent$ActionLinks$allTypes),
				initial: initialActionLinks,
				uiSelect: $author$project$PinMeTo$Ui$Select$init,
				preferred: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.type_;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function ($) {
								return $.primary;
							},
							initialActionLinks))),
				templateTagsState: $author$project$PinMeTo$Ui$TemplateTags$init,
				showAppleBusinessBanner: _Utils_eq(
					appleConnectionType,
					$elm$core$Maybe$Just($author$project$PinMeToPage$AppleSystem))
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Data$ValidatedCoordinates$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Data$ValidatedCoordinates$InvalidCooridnates = F2(
	function (a, b) {
		return {$: 'InvalidCooridnates', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLatLimitation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_lat_limitation');
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLonLimitation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.coordinates_lon_limitation');
};
var $author$project$Data$ValidatedCoordinates$create = F2(
	function (translations, cooridnates) {
		var errors = {
			lat: ((cooridnates.lat > 90) || (_Utils_cmp(cooridnates.lat, -90) < 0)) ? $elm$core$Maybe$Just(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLatLimitation(translations)) : $elm$core$Maybe$Nothing,
			lon: ((cooridnates.lon > 180) || (_Utils_cmp(cooridnates.lon, -180) < 0)) ? $elm$core$Maybe$Just(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$coordinatesLonLimitation(translations)) : $elm$core$Maybe$Nothing
		};
		return ((!_Utils_eq(errors.lat, $elm$core$Maybe$Nothing)) || (!_Utils_eq(errors.lon, $elm$core$Maybe$Nothing))) ? A2(
			$author$project$Data$ValidatedCoordinates$InvalidCooridnates,
			cooridnates,
			$author$project$Data$ValidatedCoordinates$ValidationError(errors)) : $author$project$Data$ValidatedCoordinates$ValidCooridnates(cooridnates);
	});
var $author$project$Location$Details$PopupContent$Coordinates$init = F2(
	function (translations, initialCoordinates) {
		var coordinatesAsString = {
			lat: $elm$core$String$fromFloat(initialCoordinates.lat),
			lon: $elm$core$String$fromFloat(initialCoordinates.lon)
		};
		var coordinates = A2($author$project$Data$ValidatedCoordinates$create, translations, initialCoordinates);
		return {coordinates: coordinates, translations: translations, initialCoordinates: coordinates, coordinatesAsString: coordinatesAsString};
	});
var $author$project$Location$Details$PopupContent$OpeningDate$init = F3(
	function (language, locale, initialDate) {
		var dateInPosix = $author$project$Location$Details$PopupContent$OpeningDate$stringDateToPosix(initialDate);
		var selectedDate = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Maybe$Nothing,
			function (posixDate) {
				return $elm$core$Maybe$Just(
					A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, posixDate));
			},
			dateInPosix);
		return {locale: locale, language: language, openingDate: dateInPosix, selectedDate: selectedDate};
	});
var $author$project$Data$Network$Ptv = {$: 'Ptv'};
var $author$project$Data$ValidatedCustomNameOnNetwork$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Data$ValidatedCustomNameOnNetwork$hasTrademarkSymbols = function (input) {
	return A2($elm$core$String$contains, '®', input) || (A2($elm$core$String$contains, '©', input) || A2($elm$core$String$contains, '™', input));
};
var $author$project$Data$ValidatedCustomNameOnNetwork$InValidCustomNameOnNetwork = F2(
	function (a, b) {
		return {$: 'InValidCustomNameOnNetwork', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$trademarkSymbolsNotAllowed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.trademark_symbols_not_allowed');
};
var $author$project$Data$ValidatedCustomNameOnNetwork$create = F2(
	function (translations, customName) {
		return $author$project$Data$ValidatedCustomNameOnNetwork$hasTrademarkSymbols(customName) ? A2(
			$author$project$Data$ValidatedCustomNameOnNetwork$InValidCustomNameOnNetwork,
			customName,
			$author$project$Data$ValidatedCustomNameOnNetwork$ValidationError(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$trademarkSymbolsNotAllowed(translations))) : ((($elm$core$String$length(
			$elm$core$String$trim(customName)) >= 2) && $author$project$Common$Validators$CsvInjection$isInputValid(customName)) ? $author$project$Data$ValidatedCustomNameOnNetwork$ValidCustomNameOnNetwork(customName) : A2(
			$author$project$Data$ValidatedCustomNameOnNetwork$InValidCustomNameOnNetwork,
			customName,
			$author$project$Data$ValidatedCustomNameOnNetwork$ValidationError(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontInvalid(translations))));
	});
var $author$project$Location$Details$PopupContent$CustomNameOnNetwork$init = F3(
	function (translations, customName, networkName) {
		var validatedCustomNameOnNetwork = A2($author$project$Data$ValidatedCustomNameOnNetwork$create, translations, customName);
		return {network: networkName, customName: validatedCustomNameOnNetwork, translations: translations};
	});
var $author$project$Data$Location$storefrontNameToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Location$Details$PopupContent$StorefrontName$init = F7(
	function (translations, storefrontName, googleName, facebookName, appleName, ptvName, config) {
		return {
			canEditName: config.canEditName,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			ptvCustomName: A3(
				$author$project$Location$Details$PopupContent$CustomNameOnNetwork$init,
				translations,
				A2($elm$core$Maybe$withDefault, '', ptvName),
				$author$project$Data$Network$Ptv),
			networkEnabled: config.networkEnabled,
			storefrontName: storefrontName,
			appleCustomName: A3(
				$author$project$Location$Details$PopupContent$CustomNameOnNetwork$init,
				translations,
				A2($elm$core$Maybe$withDefault, '', appleName),
				$author$project$Data$Network$Apple),
			googleCustomName: A3(
				$author$project$Location$Details$PopupContent$CustomNameOnNetwork$init,
				translations,
				A2($elm$core$Maybe$withDefault, '', googleName),
				$author$project$Data$Network$Google),
			facebookCustomName: A3(
				$author$project$Location$Details$PopupContent$CustomNameOnNetwork$init,
				translations,
				A2($elm$core$Maybe$withDefault, '', facebookName),
				$author$project$Data$Network$Facebook),
			storefrontNameString: $author$project$Data$Location$storefrontNameToString(storefrontName)
		};
	});
var $author$project$PinMeTo$Ui$Form$Textarea$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$Form$Textarea$init = $author$project$PinMeTo$Ui$Form$Textarea$State(
	{
		caret: A2($author$project$PinMeTo$Ui$Form$Textarea$Caret, 0, 0),
		paste: _List_Nil,
		selection: A2($author$project$PinMeTo$Ui$Form$Textarea$Selection, 0, 0),
		focusCounter: 0,
		activeAutocompleteValue: $elm$core$Maybe$Nothing,
		replacementSelectedIndex: 0
	});
var $author$project$Data$ValidatedLongDescription$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Data$ValidatedLongDescription$ValidLongDescription = function (a) {
	return {$: 'ValidLongDescription', a: a};
};
var $author$project$Data$ValidatedLongDescription$InvalidLongDescription = F2(
	function (a, b) {
		return {$: 'InvalidLongDescription', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.long_description_invalid');
};
var $author$project$Data$ValidatedLongDescription$create = F2(
	function (translations, longDescription) {
		return (($zwilias$elm_utf_tools$String$UTF16$length(longDescription) <= 750) && $author$project$Common$Validators$CsvInjection$isInputValid(longDescription)) ? $author$project$Data$ValidatedLongDescription$ValidLongDescription(
			$author$project$Data$Location$LongDescription(longDescription)) : A2(
			$author$project$Data$ValidatedLongDescription$InvalidLongDescription,
			$author$project$Data$Location$LongDescription(longDescription),
			$author$project$Data$ValidatedLongDescription$ValidationError(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$longDescriptionInvalid(translations)));
	});
var $author$project$Location$Details$PopupContent$LongDescription$init = F2(
	function (translations, _v0) {
		var longDescription = _v0.a;
		var validatedLongDescription = A2($author$project$Data$ValidatedLongDescription$create, translations, longDescription);
		return {translations: translations, longDescription: validatedLongDescription, uiTextareaState: $author$project$PinMeTo$Ui$Form$Textarea$init, initialLongDescription: validatedLongDescription};
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$isSocialGroup = function (attribute) {
	return A2($elm$core$String$contains, 'URL', attribute.groupDisplayName);
};
var $author$project$Location$Details$PopupContent$SocialMessaging$currentValueFor = F2(
	function (attributeId, currentValues) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return $elm$core$List$head(value.values);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (value) {
							return _Utils_eq(value.attributeId, attributeId);
						},
						currentValues))));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$buildFields = F2(
	function (attributes, currentValues) {
		return A2(
			$elm$core$List$map,
			function (attribute) {
				return {
					value: A2($author$project$Location$Details$PopupContent$SocialMessaging$currentValueFor, attribute.attributeId, currentValues),
					attribute: attribute,
					selectState: $author$project$PinMeTo$Ui$Select$init
				};
			},
			A2($elm$core$List$filter, $author$project$Location$Details$PopupContent$SocialMessaging$isSocialGroup, attributes));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$fieldValuesDict = function (fields) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple2(field.attribute.attributeId, field.value);
			},
			fields));
};
var $author$project$Location$Details$PopupContent$SocialMessaging$init = F2(
	function (attributes, currentValues) {
		var fields = A2($author$project$Location$Details$PopupContent$SocialMessaging$buildFields, attributes, currentValues);
		return {
			fields: fields,
			initial: $author$project$Location$Details$PopupContent$SocialMessaging$fieldValuesDict(fields),
			loading: $elm$core$List$isEmpty(attributes),
			urlErrors: $elm$core$Dict$empty,
			urlDebouncer: A2($author$project$Common$Debouncer$init, 400, _Utils_Tuple0),
			validatingUrls: false
		};
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$renumberRows = function (rows) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (idx, row) {
				return _Utils_update(
					row,
					{id: idx});
			}),
		rows);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$UrlValue = function (a) {
	return {$: 'UrlValue', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue = function (a) {
	return {$: 'BoolValue', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$EnumValue = function (a) {
	return {$: 'EnumValue', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue = function (a) {
	return {$: 'RepeatedEnumValue', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$defaultValueForType = function (valueType) {
	switch (valueType) {
		case 'BOOL':
			return $author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue(false);
		case 'ENUM':
			return $author$project$Location$Details$PopupContent$GoogleAttributes$EnumValue('');
		case 'URL':
			return $author$project$Location$Details$PopupContent$GoogleAttributes$UrlValue('');
		case 'REPEATED_ENUM':
			return $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
				{setValues: _List_Nil, unsetValues: _List_Nil});
		default:
			return $author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue(false);
	}
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$emptyRow = function (attribute) {
	return {
		id: 0,
		value: $author$project$Location$Details$PopupContent$GoogleAttributes$defaultValueForType(attribute.valueType),
		origin: $author$project$Location$Details$PopupContent$GoogleAttributes$AlwaysShownPlaceholder,
		selectedAttribute: attribute,
		uiSelectValueState: $author$project$PinMeTo$Ui$Select$init
	};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$alwaysDisplayAttributeIds = _List_fromArray(
	['preferred_messaging_service']);
var $author$project$Location$Details$PopupContent$GoogleAttributes$withAlwaysShownRows = F2(
	function (availableAttributes, rows) {
		var existingAttributeIds = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.selectedAttribute;
				},
				function ($) {
					return $.attributeId;
				}),
			rows);
		var placeholderRows = A2(
			$elm$core$List$map,
			$author$project$Location$Details$PopupContent$GoogleAttributes$emptyRow,
			A2(
				$elm$core$List$filter,
				function (a) {
					return A2($elm$core$List$member, a.attributeId, $author$project$Location$Details$PopupContent$GoogleAttributes$alwaysDisplayAttributeIds) && (!A2($elm$core$List$member, a.attributeId, existingAttributeIds));
				},
				availableAttributes));
		return _Utils_ap(rows, placeholderRows);
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$SavedValue = {$: 'SavedValue'};
var $author$project$Location$Details$PopupContent$GoogleAttributes$savedAttributeToValue = function (attr) {
	var _v0 = attr.valueType;
	switch (_v0) {
		case 'BOOL':
			var _v1 = attr.values;
			if (_v1.b && (_v1.a === 'true')) {
				return $author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue(true);
			} else {
				return $author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue(false);
			}
		case 'ENUM':
			var _v2 = attr.values;
			if (_v2.b) {
				var val = _v2.a;
				return $author$project$Location$Details$PopupContent$GoogleAttributes$EnumValue(val);
			} else {
				return $author$project$Location$Details$PopupContent$GoogleAttributes$EnumValue('');
			}
		case 'URL':
			return $author$project$Location$Details$PopupContent$GoogleAttributes$UrlValue(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(attr.values)));
		case 'REPEATED_ENUM':
			var _v3 = attr.repeatedEnumValue;
			if (_v3.$ === 'Just') {
				var re = _v3.a;
				return $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
					{setValues: re.setValues, unsetValues: re.unsetValues});
			} else {
				return $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
					{setValues: _List_Nil, unsetValues: _List_Nil});
			}
		default:
			return $author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue(false);
	}
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$initRowFromAttribute = F2(
	function (availableAttributes, savedAttr) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (a) {
				return _Utils_eq(a.attributeId, savedAttr.attributeId);
			},
			availableAttributes);
		if (_v0.b) {
			var googleAttr = _v0.a;
			return $elm$core$Maybe$Just(
				{
					id: 0,
					value: $author$project$Location$Details$PopupContent$GoogleAttributes$savedAttributeToValue(savedAttr),
					origin: $author$project$Location$Details$PopupContent$GoogleAttributes$SavedValue,
					selectedAttribute: googleAttr,
					uiSelectValueState: $author$project$PinMeTo$Ui$Select$init
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$buildInitialRows = F2(
	function (availableAttributes, currentValues) {
		return $author$project$Location$Details$PopupContent$GoogleAttributes$renumberRows(
			A2(
				$author$project$Location$Details$PopupContent$GoogleAttributes$withAlwaysShownRows,
				availableAttributes,
				A2(
					$elm$core$List$filterMap,
					$author$project$Location$Details$PopupContent$GoogleAttributes$initRowFromAttribute(availableAttributes),
					currentValues)));
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$init = F2(
	function (attributes, currentValues) {
		var initialRows = A2($author$project$Location$Details$PopupContent$GoogleAttributes$buildInitialRows, attributes, currentValues);
		return {
			rows: initialRows,
			nextId: $elm$core$List$length(initialRows),
			loading: $elm$core$List$isEmpty(attributes),
			urlErrors: $elm$core$Dict$empty,
			urlDebouncer: A2($author$project$Common$Debouncer$init, 400, _Utils_Tuple0),
			addSelectState: $author$project$PinMeTo$Ui$Select$init,
			validatingUrls: false,
			availableAttributes: attributes
		};
	});
var $author$project$Data$Location$shortDescriptionToString = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Location$Details$PopupContent$ShortDescription$init = function (shortDescription) {
	return {
		uiTextareaState: $author$project$PinMeTo$Ui$Form$Textarea$init,
		shortDescription: shortDescription,
		shortDescriptionString: $author$project$Data$Location$shortDescriptionToString(shortDescription)
	};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$None = {$: 'None'};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$init = F5(
	function (openHours, source, now, language, locale) {
		var initialRecord = {date: now, label: $elm$core$Maybe$Nothing, spans: _List_Nil, state: $author$project$Data$Location$SpecialOpenHours$Closed};
		var newList = A2(
			$elm$core$List$sortBy,
			function (record) {
				return $elm$time$Time$posixToMillis(record.date);
			},
			A2(
				$elm$core$List$map,
				function (hours) {
					var spans = function () {
						var _v0 = hours.state;
						if (_v0.$ === 'Closed') {
							return _List_Nil;
						} else {
							var span = _v0.a;
							return $elm$core$List$singleton(span);
						}
					}();
					return {date: hours.startDate, label: hours.label, spans: spans, state: hours.state};
				},
				openHours));
		var errorInForm = A2($author$project$Location$Details$PopupContent$SpecialOpenHours$isDateInList, newList, initialRecord.date);
		return _Utils_Tuple2(
			{now: now, tab: $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming, locale: locale, language: language, sourceCall: source, errorInForm: errorInForm, selectedDate: $elm$core$Maybe$Nothing, currentRecord: initialRecord, highlightDate: $author$project$Location$Details$PopupContent$SpecialOpenHours$None, noticeWarning: $author$project$Location$Details$PopupContent$SpecialOpenHours$None, specialOpenHoursList: newList},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Location$Details$PopupContent$PermanentlyClosed$init = function (initialStatus) {
	return {permanentlyClosedStatus: initialStatus};
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$init = F6(
	function (temporarilyClosed, now, language, locale, canSelectFrom, initialUntil) {
		var selectedUntilDate = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Maybe$Nothing,
			function (until) {
				return $elm$core$Maybe$Just(
					A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, until));
			},
			initialUntil);
		return {now: now, locale: locale, language: language, uiTextareaState: $author$project$PinMeTo$Ui$Form$Textarea$init, selectedFromDate: $elm$core$Maybe$Nothing, allowToSelectFrom: canSelectFrom, selectedUntilDate: selectedUntilDate, temporarilyClosed: temporarilyClosed};
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnCurrencyCodes = function (a) {
	return {$: 'OnCurrencyCodes', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getCurrencyCodes = function (msg) {
	var url = 'api/currencycodes';
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A3(
				$author$project$PinMeTo$ExpectJson$expectJson,
				msg,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$string),
			$lukewestby$elm_http_builder$HttpBuilder$get(url)));
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$OnGoogleServiceItemsData = function (a) {
	return {$: 'OnGoogleServiceItemsData', a: a};
};
var $author$project$Data$NetworkData$GoogleServiceItems$GoogleNetworkService = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$Data$NetworkData$GoogleServiceItems$googleServiceItemsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data',
	$elm$json$Json$Decode$list(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$GoogleServiceItems$GoogleNetworkService)))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Data$Location$NetworkCategories$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(x.id)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(x.name))
			]));
};
var $author$project$Data$NetworkData$GoogleServiceItems$encodeCategoriesForServiceItems = function (categories) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, categories))
			]));
};
var $author$project$Data$NetworkData$GoogleServiceItems$getGoogleSupportedServiceItems = F3(
	function (_v0, categories, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/google/supportedServiceItems');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$NetworkData$GoogleServiceItems$googleServiceItemsDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Data$NetworkData$GoogleServiceItems$encodeCategoriesForServiceItems(categories),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$init = F4(
	function (siteName, canModifyServiceList, initialServices, categoryGroup) {
		var locationCategories = function () {
			if (categoryGroup.$ === 'Just') {
				var categoryGroup_ = categoryGroup.a;
				return _Utils_ap(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[categoryGroup_.primary])),
					categoryGroup_.additional);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_Tuple2(
			{
				uiSelect: $author$project$PinMeTo$Ui$Select$init,
				currencyCodes: $author$project$RemoteData$Loading,
				initialServices: initialServices,
				primaryCategory: A3(
					$elm_community$maybe_extra$Maybe$Extra$unpack,
					function (_v0) {
						return $elm$core$Maybe$Nothing;
					},
					function ($) {
						return $.primary;
					},
					categoryGroup),
				uiTextareaState: $author$project$PinMeTo$Ui$Form$Textarea$init,
				selectedServices: A2($elm$core$List$map, $author$project$Common$Validators$ValidatedItem$ValidItem, initialServices),
				selectedServiceId: $elm$core$Maybe$Nothing,
				showFreeFormAlert: false,
				locationCategories: locationCategories,
				freeformServiceName: $elm$core$Maybe$Nothing,
				canModifyServiceList: canModifyServiceList,
				allGoogleServiceItems: $author$project$RemoteData$Loading
			},
			canModifyServiceList ? $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Data$NetworkData$GoogleServiceItems$getGoogleSupportedServiceItems, siteName, locationCategories, $author$project$Location$Details$PopupContent$GoogleServiceItems$OnGoogleServiceItemsData),
						$author$project$Location$Details$PopupContent$GoogleServiceItems$getCurrencyCodes($author$project$Location$Details$PopupContent$GoogleServiceItems$OnCurrencyCodes)
					])) : $elm$core$Platform$Cmd$none);
	});
var $author$project$Data$ValidatedLocationDescriptor$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Data$ValidatedLocationDescriptor$InvalidLocationDescriptor = F2(
	function (a, b) {
		return {$: 'InvalidLocationDescriptor', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.location_descriptor_invalid');
};
var $author$project$Data$ValidatedLocationDescriptor$create = F2(
	function (translations, locationDescriptor) {
		return (($zwilias$elm_utf_tools$String$UTF16$length(locationDescriptor) <= 75) && $author$project$Common$Validators$CsvInjection$isInputValid(locationDescriptor)) ? $author$project$Data$ValidatedLocationDescriptor$ValidLocationDescriptor(
			$author$project$Data$Location$LocationDescriptor(locationDescriptor)) : A2(
			$author$project$Data$ValidatedLocationDescriptor$InvalidLocationDescriptor,
			$author$project$Data$Location$LocationDescriptor(locationDescriptor),
			$author$project$Data$ValidatedLocationDescriptor$ValidationError(
				$author$project$Translations$Listings$LocationDetail$PopUpContent$locationDescriptorInvalid(translations)));
	});
var $author$project$Location$Details$PopupContent$LocationDescriptor$init = F2(
	function (translations, _v0) {
		var locationDescriptor = _v0.a;
		var validatedLocationDescriptor = A2($author$project$Data$ValidatedLocationDescriptor$create, translations, locationDescriptor);
		return {translations: translations, locationDescriptor: validatedLocationDescriptor};
	});
var $author$project$Data$Location$alternativeSearchNamesToString = function (_v0) {
	var names = _v0.a;
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filter,
			function (name) {
				return name !== '';
			},
			A2($elm$core$List$map, $elm$core$String$trim, names)));
};
var $author$project$Location$Details$PopupContent$AlternativeSearchNames$init = function (alternativeSearchNames) {
	return {
		inputText: $author$project$Data$Location$alternativeSearchNamesToString(alternativeSearchNames),
		alternativeSearchNames: alternativeSearchNames
	};
};
var $author$project$Location$Details$Editor$Model$Email = function (a) {
	return {$: 'Email', a: a};
};
var $author$project$Location$Details$Editor$Model$Phone = function (a) {
	return {$: 'Phone', a: a};
};
var $author$project$Data$NetworkData$TemporarilyClosed$Until = F2(
	function (a, b) {
		return {$: 'Until', a: a, b: b};
	});
var $author$project$Location$Details$Editor$Model$Active = function (a) {
	return {$: 'Active', a: a};
};
var $author$project$Location$Details$Editor$Model$Address = function (a) {
	return {$: 'Address', a: a};
};
var $author$project$Location$Details$Editor$Model$StoreId = function (a) {
	return {$: 'StoreId', a: a};
};
var $author$project$Location$Details$Editor$Model$Homepage = function (a) {
	return {$: 'Homepage', a: a};
};
var $author$project$Location$Details$Editor$Model$OpenHours = function (a) {
	return {$: 'OpenHours', a: a};
};
var $author$project$Location$Details$Editor$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Location$Details$Editor$Model$Editor = function (a) {
	return {$: 'Editor', a: a};
};
var $author$project$Location$Details$Editor$initModel = F5(
	function (selectedLocationsList, trackingInfo, now, location, editor) {
		var locationIds = (location.id === '') ? _List_Nil : _List_fromArray(
			[location.id]);
		var selectedLocations = function () {
			if (selectedLocationsList.$ === 'Just') {
				var x = selectedLocationsList.a;
				return $elm$core$List$isEmpty(x.locations) ? locationIds : x.locations;
			} else {
				return locationIds;
			}
		}();
		return $author$project$Location$Details$Editor$State(
			{
				now: now,
				error: $elm$core$Maybe$Nothing,
				confirm: $elm$core$Maybe$Nothing,
				content: $author$project$Location$Details$Editor$Model$Editor(editor),
				location: location,
				bulkAction: selectedLocationsList,
				popOverState: $author$project$PinMeTo$Ui$PopOver$init,
				selectedDate: $elm$core$Maybe$Nothing,
				trackingInfo: trackingInfo,
				locationSelector: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init,
				selectedLocations: selectedLocations,
				showSavingProgress: false,
				locationsNeedsVerificationOnLocationSelector: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Location$Details$Editor$Model$Categories = F2(
	function (a, b) {
		return {$: 'Categories', a: a, b: b};
	});
var $author$project$Location$Details$Editor$Model$OpenStatus = function (a) {
	return {$: 'OpenStatus', a: a};
};
var $author$project$Location$Details$Editor$Model$ActionLinks = function (a) {
	return {$: 'ActionLinks', a: a};
};
var $author$project$Location$Details$Editor$Model$Coordinates = function (a) {
	return {$: 'Coordinates', a: a};
};
var $author$project$Location$Details$Editor$Model$OpeningDate = function (a) {
	return {$: 'OpeningDate', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$BingCategories = function (a) {
	return {$: 'BingCategories', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$HereCategories = function (a) {
	return {$: 'HereCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$StorefrontName = function (a) {
	return {$: 'StorefrontName', a: a};
};
var $author$project$PlanHat$TrackingActions$keys = {
	tasks: {listingsTasksLinkToConversationsClicked: 'listingsTasksLinkToConversationsClicked'},
	insights: {
		listings: {
			bing: {actionsPopoverClicked: 'listingsInsightsBingActionsPopoverClicked', topListPopoverClicked: 'listingsInsightsBingTopListPopoverClicked', impressionsPopoverClicked: 'listingsInsightsBingImpressionsPopoverClicked'},
			apple: {viewsPopoverClicked: 'listingsInsightsAppleViewsPopoverClicked', actionsPopoverClicked: 'listingsInsightsAppleActionsPopoverClicked', topListPopoverClicked: 'listingsInsightsAppleTopListPopoverClicked', searchesPopoverClicked: 'listingsInsightsAppleSearchesPopoverClicked'},
			facebook: {likesPopoverClicked: 'listingsInsightsFacebookLikesPopoverClicked', reachPopoverClicked: 'listingsInsightsFacebookReachPopoverClicked', topListPopoverClicked: 'listingsInsightsFacebookTopListPopoverClicked', impressionsPopoverClicked: 'listingsInsightsFacebookImpressionsPopoverClicked'},
			overview: {actionsPopoverClicked: 'listingsActionsPopoverClicked', topListPopoverClicked: 'listingsTopListPopoverClicked', datePickerPopoverClicked: 'listingsDatePickerPopoverClicked', visibilityPopoverClicked: 'listingsUisibilityPopoverClicked', ratingTrendPopoverClicked: 'listingsRatingTrendPopoverClicked', responseRatePopoverClicked: 'listingsResponseRatePopoverClicked', localPageLikesPopoverClicked: 'listingsLocalPageLikesPopoverClicked'}
		},
		postsTopListDownloadCsv: 'Posts - download TopList csv',
		postsInsightsDownloadCsv: 'Posts - download insights csv',
		postsTopListDownloadXlsx: 'Posts - download TopList xlsx',
		postsInsightsDownloadXlsx: 'Posts - download insights xlsx',
		postsDetailTopListDownloadCsv: 'Posts - Detail download TopList csv',
		postsDetailTopListDownloadXlsx: 'Posts - Detail download TopList xlsx',
		postsInsightsLinkToConversationsClicked: 'postsInsightsLinkToConversationsClicked',
		listingsInsightsLinkToConversationsClicked: 'listingsInsightsLinkToConversationsClicked',
		postsInsightsLinkToConversationsClickedInstagram: 'postsInsightsLinkToConversationsClickedInstagram'
	},
	postsPQL: {locationList: 'Posts – PQL – Locations List click'},
	bulkUpdate: {emailUpdated: 'updateLocationListBulkActionEmail', dropDownOpened: 'openLocationListBulkAction', homepageUpdated: 'updateLocationListBulkActionHomepage', wifiNameUpdated: 'updateLocationListBulkActionWiFiName', openHoursUpdated: 'updateLocationListBulkActionOpenHours', phoneNumberUpdated: 'updateLocationListBulkActionPhoneNumber', appleCategoriesUpdated: 'updateLocationListBulkActionAppleCategories', longDescriptionUpdated: 'updateLocationListBulkActionLongDescription', googleAttributesUpdated: 'updateLocationListBulkActionGoogleAttributes', googleCategoriesUpdated: 'updateLocationListBulkActionGoogleCategories', shortDescriptionUpdated: 'updateLocationListBulkActionShortDescription', specialOpenHoursUpdated: 'updateLocationListBulkActionSpecialOpenHours', temporarilyClosedUpdated: 'updateLocationListBulkActionTemporarilyClosed', facebookCategoriesUpdated: 'updateLocationListBulkActionFacebookCategories'},
	networkPage: {needsActionLinkClicked: 'needsActionLinkClicked'},
	locationDetails: {
		media: {fileSizeTooLarge: 'ldpMediaFileSizeTooLarge', fileTypeNotSupported: 'ldpMediaFileTypeNotSupported', imageDimensionsTooSmall: 'ldpMediaImageDimensionsTooSmall'},
		clicksNotSetRow: 'ldpNotSetRowClicked'
	},
	dataCompleteness: {emailMissingFieldsDisplayed: 'displayEmailMissingFieldsDataCompletenessDashboard', homepageMissingFieldsDisplayed: 'displayHomepageMissingFieldsDataCompletenessDashboard', openHoursMissingFieldsDisplayed: 'displayOpenHoursMissingFieldsDataCompletenessDashboard', attributesMissingFieldsDisplayed: 'displayAttributesMissingFieldsDataCompletenessDashboard', actionLinksMissingFieldsDisplayed: 'displayActionLinksMissingFieldsDataCompletenessDashboard', phoneNumberMissingFieldsDisplayed: 'displayPhoneNumberMissingFieldsDataCompletenessDashboard', bingCategoriesMissingFieldsDisplayed: 'displayBingCategoriesMissingFieldsDataCompletenessDashboard', appleCategoriesMissingFieldsDisplayed: 'displayAppleCategoriesMissingFieldsDataCompletenessDashboard', longDescriptionMissingFieldsDisplayed: 'displayLongDescriptionMissingFieldsDataCompletenessDashboard', googleCategoriesMissingFieldsDisplayed: 'displayGoogleCategoriesMissingFieldsDataCompletenessDashboard', googleCoverImageMissingFieldsDisplayed: 'displayGoogleCoverImageMissingFieldsDataCompletenessDashboard', shortDescriptionMissingFieldsDisplayed: 'displayShortDescriptionMissingFieldsDataCompletenessDashboard', facebookCategoriesMissingFieldsDisplayed: 'displayFacebookCategoriesMissingFieldsDataCompletenessDashboard', facebookCoverImageMissingFieldsDisplayed: 'displayFacebookCoverImageMissingFieldsDataCompletenessDashboard', googleProfileImageMissingFieldsDisplayed: 'displayGoogleProfileImageMissingFieldsDataCompletenessDashboard', facebookProfileImageMissingFieldsDisplayed: 'displayFacebookProfileImageMissingFieldsDataCompletenessDashboard', googleLocationImagesMissingFieldsDisplayed: 'displayGoogleLocationImagesMissingFieldsDataCompletenessDashboard'},
	listingsDashboard: {goToRatings: 'listingsDashboardGoToRatings', goToNetworks: 'listingsDashboardGoToNetworks', goToConflicts: 'listingsDashboardGoToConflicts', goToLocations: 'listingsDashboardGoToLocations', tasksAPIMedia: 'listingsDashboardAPIMedia', tasksNewMedia: 'listingsDashboardNewMedia', goToDataCompleteness: 'listingsDashboardGoToDataCompleteness', linkInNetworksNumber: 'listingsDashboardNetworksNumber', tasksVerifyAddresses: 'listingsDashboardVerifyAddresses', linkInConflictsNumber: 'listingsDashboardConflictsNumber', linkInLocationsNumber: 'listingsDashboardLocationsNumber', tasksAPIAddressDifferences: 'listingsDashboardAPIAddressDifferences', tasksPtvListingsWithIssues: 'listingsDashboardPtvListingsWithIssues', tasksAppleListingsWithIssues: 'listingsDashboardAppleListingsWithIssues', tasksGoogleListingsWithIssues: 'listingsDashboardGoogleListingsWithIssues', tasksFacebookListingsWithIssues: 'listingsDashboardFacebookListingsWithIssues'}
};
var $author$project$PlanHat$PlanHat$out_PlanHat_sendPlanHatTracking = _Platform_outgoingPort(
	'out_PlanHat_sendPlanHatTracking',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'info',
					$elm$json$Json$Encode$string($.info)),
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string($.action))
				]));
	});
var $author$project$PlanHat$PlanHat$track = function (item) {
	return $author$project$PlanHat$PlanHat$out_PlanHat_sendPlanHatTracking(item);
};
var $author$project$Data$Location$wifiSsIdToString = function (_v0) {
	var string = _v0.a;
	return string;
};
var $author$project$Location$Details$Editor$isNotSetRowCmd = F3(
	function (editor, location, now) {
		var isEmpty = function () {
			switch (editor.$) {
				case 'ActiveEditor':
					return false;
				case 'AlternativeSearchNamesEditor':
					return false;
				case 'AddressEditor':
					return false;
				case 'CategoriesEditor':
					var network = editor.a;
					switch (network.$) {
						case 'Apple':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										true,
										function (_v2) {
											return false;
										},
										categories.primary);
								},
								location.networkCategories.apple);
						case 'Bing':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										true,
										function (_v3) {
											return false;
										},
										categories.primaryCategoryId);
								},
								location.networkCategories.bing);
						case 'Facebook':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return !$elm$core$List$length(categories.subcategories);
								},
								location.networkCategories.facebook);
						case 'Foursquare':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return !$elm$core$List$length(categories.categories);
								},
								location.networkCategories.foursquare);
						case 'Google':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										true,
										function (_v4) {
											return false;
										},
										categories.primary);
								},
								location.networkCategories.google);
						case 'Overture':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										true,
										function (_v5) {
											return false;
										},
										categories.primary);
								},
								location.networkCategories.overture);
						case 'Here':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (categories) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										true,
										function (_v6) {
											return false;
										},
										categories.primary);
								},
								location.networkCategories.here);
						case 'Tomtom':
							return _Utils_eq(location.networkCategories.tomtom, $elm$core$Maybe$Nothing);
						case 'Ptv':
							return true;
						default:
							return true;
					}
				case 'GoogleAttributesEditor':
					return !$elm$core$List$length(location.networkAttributes.google);
				case 'SocialMessagingEditor':
					return !$elm$core$List$length(location.networkAttributes.google);
				case 'ActionLinksEditor':
					return $elm$core$List$isEmpty(location.actionLinks);
				case 'CoordinatesEditor':
					return false;
				case 'CustomNameOnNetworkEditor':
					var network = editor.a;
					switch (network.$) {
						case 'Apple':
							return false;
						case 'Bing':
							return false;
						case 'Facebook':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (name) {
									return name === '';
								},
								location.networkNames.facebook);
						case 'Foursquare':
							return false;
						case 'Google':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (name) {
									return name === '';
								},
								location.networkNames.google);
						case 'Overture':
							return false;
						case 'Here':
							return false;
						case 'Tomtom':
							return false;
						case 'Ptv':
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								true,
								function (name) {
									return name === '';
								},
								location.networkNames.ptv);
						default:
							return false;
					}
				case 'EmailEditor':
					return $author$project$Data$Location$emailToString(location.email) === '';
				case 'ServiceItemsEditor':
					var network = editor.a;
					if (network.$ === 'Google') {
						return _Utils_eq(location.networkServiceItems.google, _List_Nil);
					} else {
						return false;
					}
				case 'HomepageEditor':
					return $author$project$Data$Location$homepageToString(location.homepage) === '';
				case 'OpenHoursEditor':
					return _Utils_eq(location.openHours, $author$project$Data$Location$OpenHours$notSpecified);
				case 'OpenStatusEditor':
					return false;
				case 'WifiEditor':
					return $author$project$Data$Location$wifiSsIdToString(location.wifiSsId) === '';
				case 'StoreIdEditor':
					return false;
				case 'StorefrontNameEditor':
					return $author$project$Data$Location$storefrontNameToString(location.storefrontName) === '';
				case 'TemporarilyClosedEditor':
					return false;
				case 'ShortDescriptionEditor':
					return $author$project$Data$Location$shortDescriptionToString(location.about) === '';
				case 'PhoneEditor':
					return $author$project$Data$Location$phoneToString(location.phone) === '';
				case 'PermanentlyClosedEditor':
					return false;
				case 'OpeningDateEditor':
					return location.openingDate === '';
				case 'LongDescriptionEditor':
					return $author$project$Data$Location$longDescriptionToString(location.longDescription) === '';
				case 'LocationDescriptorEditor':
					return $author$project$Data$Location$locationDescriptorToString(location.locationDescriptor) === '';
				default:
					var upcomingSpecialOpenHours = A2(
						$elm$core$List$filter,
						function (soh) {
							return _Utils_cmp(
								$elm$time$Time$posixToMillis(soh.startDate),
								$elm$time$Time$posixToMillis(now)) > 0;
						},
						location.specialOpenHours);
					return !$elm$core$List$length(upcomingSpecialOpenHours);
			}
		}();
		return isEmpty ? $author$project$PlanHat$PlanHat$track(
			{info: '', action: $author$project$PlanHat$TrackingActions$keys.locationDetails.clicksNotSetRow}) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Location$Details$PopupContent$Categories$AppleCategories = function (a) {
	return {$: 'AppleCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$LongDescription = function (a) {
	return {$: 'LongDescription', a: a};
};
var $author$project$Location$Details$Editor$Model$SocialMessaging = function (a) {
	return {$: 'SocialMessaging', a: a};
};
var $author$project$Location$Details$Editor$Model$GoogleAttributes = function (a) {
	return {$: 'GoogleAttributes', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$GoogleCategories = function (a) {
	return {$: 'GoogleCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$ShortDescription = function (a) {
	return {$: 'ShortDescription', a: a};
};
var $author$project$Location$Details$Editor$Model$SpecialOpenHours = function (a) {
	return {$: 'SpecialOpenHours', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$TomtomCategories = function (a) {
	return {$: 'TomtomCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$PermanentlyClosed = function (a) {
	return {$: 'PermanentlyClosed', a: a};
};
var $author$project$Location$Details$Editor$Model$TemporarilyClosed = function (a) {
	return {$: 'TemporarilyClosed', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$FacebookCategories = function (a) {
	return {$: 'FacebookCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$GoogleServiceItems = function (a) {
	return {$: 'GoogleServiceItems', a: a};
};
var $author$project$Location$Details$Editor$Model$LocationDescriptor = function (a) {
	return {$: 'LocationDescriptor', a: a};
};
var $author$project$Location$Details$PopupContent$Categories$OvertureCategories = function (a) {
	return {$: 'OvertureCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$CustomNameOnNetwork = F2(
	function (a, b) {
		return {$: 'CustomNameOnNetwork', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$Categories$FoursquareCategories = function (a) {
	return {$: 'FoursquareCategories', a: a};
};
var $author$project$Location$Details$Editor$Model$AlternativeSearchNames = function (a) {
	return {$: 'AlternativeSearchNames', a: a};
};
var $author$project$Location$Details$PopupContent$SocialMessaging$OnAvailableAttributesFetched = function (a) {
	return {$: 'OnAvailableAttributesFetched', a: a};
};
var $author$project$Data$NetworkData$GoogleAttributes$GoogleAttributes = function (attributes) {
	return {attributes: attributes};
};
var $author$project$Data$NetworkData$GoogleAttributes$GoogleAttribute = F5(
	function (attributeId, valueType, displayName, groupDisplayName, valueMetaData) {
		return {valueType: valueType, attributeId: attributeId, displayName: displayName, valueMetaData: valueMetaData, groupDisplayName: groupDisplayName};
	});
var $author$project$Data$NetworkData$GoogleAttributes$boolToString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Data$NetworkData$GoogleAttributes$GoogleAttributesValueMeta = F2(
	function (value, displayName) {
		return {value: value, displayName: displayName};
	});
var $author$project$Data$NetworkData$GoogleAttributes$googleAttributesValueMetaDecoder = function (valueType) {
	var decoders = _List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$map, $author$project$Data$NetworkData$GoogleAttributes$boolToString, $elm$json$Json$Decode$bool)
		]);
	return A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			var _v0 = _Utils_Tuple2(value, valueType);
			if ((_v0.a.$ === 'Nothing') && (_v0.b === 'BOOL')) {
				var _v1 = _v0.a;
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'displayName',
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						'false',
						$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$GoogleAttributes$GoogleAttributesValueMeta)));
			} else {
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'displayName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'value',
						$elm$json$Json$Decode$oneOf(decoders),
						$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$GoogleAttributes$GoogleAttributesValueMeta)));
			}
		},
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
};
var $author$project$Data$NetworkData$GoogleAttributes$googleAttributeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (valueType) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'valueMetadata',
			$elm$json$Json$Decode$list(
				$author$project$Data$NetworkData$GoogleAttributes$googleAttributesValueMetaDecoder(valueType)),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'groupDisplayName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'displayName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'valueType',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'attributeId',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$GoogleAttributes$GoogleAttribute))))));
	},
	A2($elm$json$Json$Decode$field, 'valueType', $elm$json$Json$Decode$string));
var $author$project$Data$NetworkData$GoogleAttributes$googleAttributesDecoder = function () {
	var listDecoder = A2(
		$elm$json$Json$Decode$map,
		function (xs) {
			return A2(
				$elm$core$List$sortBy,
				function (x) {
					return x.groupDisplayName + ('/' + x.displayName);
				},
				xs);
		},
		$elm$json$Json$Decode$list($author$project$Data$NetworkData$GoogleAttributes$googleAttributeDecoder));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'attributes',
		listDecoder,
		$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$GoogleAttributes$GoogleAttributes));
}();
var $author$project$Data$NetworkData$GoogleAttributes$getMultipleLocationsGoogleAttributes = F3(
	function (_v0, locationIds, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$NetworkData$GoogleAttributes$googleAttributesDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'locationIds',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locationIds))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/places/google/attributes')))));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$fetchAvailableAttributes = F2(
	function (siteName, locationIds) {
		return A3($author$project$Data$NetworkData$GoogleAttributes$getMultipleLocationsGoogleAttributes, siteName, locationIds, $author$project$Location$Details$PopupContent$SocialMessaging$OnAvailableAttributesFetched);
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$OnAvailableAttributesFetched = function (a) {
	return {$: 'OnAvailableAttributesFetched', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$fetchAvailableAttributes = F2(
	function (siteName, locationIds) {
		return A3($author$project$Data$NetworkData$GoogleAttributes$getMultipleLocationsGoogleAttributes, siteName, locationIds, $author$project$Location$Details$PopupContent$GoogleAttributes$OnAvailableAttributesFetched);
	});
var $author$project$Data$SiteName$toString = function (_v0) {
	var siteName = _v0.a;
	return siteName;
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$LocationHasServiceItems = F2(
	function (locationId, serviceItems) {
		return {locationId: locationId, serviceItems: serviceItems};
	});
var $author$project$Data$Location$NetworkServiceItems$Label = F2(
	function (displayName, description) {
		return {description: description, displayName: displayName};
	});
var $author$project$Data$Location$NetworkServiceItems$labelDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'description',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'displayName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkServiceItems$Label)));
var $author$project$Data$Location$NetworkServiceItems$Price = F2(
	function (amount, currency) {
		return {amount: amount, currency: currency};
	});
var $author$project$Data$Location$NetworkServiceItems$priceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currencyCode',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount',
		A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkServiceItems$Price)));
var $author$project$Data$Location$NetworkServiceItems$FreeformGoogleServiceItem = F3(
	function (price, categoryId, label) {
		return {label: label, price: price, categoryId: categoryId};
	});
var $author$project$Data$Location$NetworkServiceItems$freeformGoogleServiceItemsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['freeFormServiceItem', 'label']),
	$author$project$Data$Location$NetworkServiceItems$labelDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['freeFormServiceItem', 'category']),
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'price',
			$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkServiceItems$priceDecoder),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkServiceItems$FreeformGoogleServiceItem))));
var $author$project$Data$Location$NetworkServiceItems$StructuredGoogleServiceItem = F3(
	function (id, description, price) {
		return {id: id, price: price, description: description};
	});
var $author$project$Data$Location$NetworkServiceItems$structuredGoogleServiceItemsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'price',
	$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkServiceItems$priceDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['structuredServiceItem', 'description']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['structuredServiceItem', 'serviceTypeId']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkServiceItems$StructuredGoogleServiceItem))));
var $author$project$Data$Location$NetworkServiceItems$googleServiceItemsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (serviceType) {
		switch (serviceType) {
			case 'structured':
				return A2($elm$json$Json$Decode$map, $author$project$Data$Location$NetworkServiceItems$Structured, $author$project$Data$Location$NetworkServiceItems$structuredGoogleServiceItemsDecoder);
			case 'freeForm':
				return A2($elm$json$Json$Decode$map, $author$project$Data$Location$NetworkServiceItems$Freeform, $author$project$Data$Location$NetworkServiceItems$freeformGoogleServiceItemsDecoder);
			default:
				return $elm$json$Json$Decode$fail('Unknown service type \u0027' + (serviceType + '\u0027'));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Location$Details$PopupContent$GoogleServiceItems$locationHasServiceItemsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['networkServiceItems', 'google']),
	$elm$json$Json$Decode$list($author$project$Data$Location$NetworkServiceItems$googleServiceItemsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Location$Details$PopupContent$GoogleServiceItems$LocationHasServiceItems)));
var $author$project$Location$Details$PopupContent$GoogleServiceItems$getLocationsHasServiceItems = F2(
	function (siteName_, msg) {
		var requestBody = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field',
					$elm$json$Json$Encode$string('googleServiceItems'))
				]));
		var url = 'api/' + ($author$project$Data$SiteName$toString(siteName_) + '/places/locationsHasField');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$Location$Details$PopupContent$GoogleServiceItems$locationHasServiceItemsDecoder)),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					requestBody,
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Location$Details$Editor$Model$OnLocationNeedsVerificationResponse = function (a) {
	return {$: 'OnLocationNeedsVerificationResponse', a: a};
};
var $author$project$Location$Details$Editor$init = F7(
	function (categories, now, location, session, canSchedule, scheduleUpdates, editor) {
		var siteName = session.siteName;
		var _v0 = function () {
			switch (editor.$) {
				case 'ActiveEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$Active(
								$author$project$Location$Details$PopupContent$Active$init(location.isActive))),
						$elm$core$Platform$Cmd$none);
				case 'AlternativeSearchNamesEditor':
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$AlternativeSearchNames(
								$author$project$Location$Details$PopupContent$AlternativeSearchNames$init(location.alternativeSearchNames))),
						$elm$core$Platform$Cmd$none);
				case 'AddressEditor':
					return A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$Address,
							A4($author$project$Location$Details$Editor$initModel, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, now, location)),
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$AddressMsg, $author$project$Location$Details$Editor$Model$EditorMsg)),
						A3($author$project$Location$Details$PopupContent$Address$init, session.translations, siteName, location));
				case 'CategoriesEditor':
					var network = editor.a;
					var locations = editor.b;
					var tracking = editor.c;
					return A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$Categories(network),
							A4($author$project$Location$Details$Editor$initModel, locations, tracking, now, location)),
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$CategoriesMsg, $author$project$Location$Details$Editor$Model$EditorMsg)),
						A4(
							$author$project$Location$Details$PopupContent$Categories$init,
							siteName,
							location.storeId,
							network,
							function () {
								switch (network.$) {
									case 'Facebook':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$FacebookCategories, categories.facebook);
									case 'Google':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$GoogleCategories, categories.google);
									case 'Bing':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$BingCategories, categories.bing);
									case 'Apple':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$AppleCategories, categories.apple);
									case 'Foursquare':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$FoursquareCategories, categories.foursquare);
									case 'Overture':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$OvertureCategories, categories.overture);
									case 'Here':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$HereCategories, categories.here);
									case 'Tomtom':
										return A2($elm$core$Maybe$map, $author$project$Location$Details$PopupContent$Categories$TomtomCategories, categories.tomtom);
									case 'Ptv':
										return $elm$core$Maybe$Nothing;
									default:
										return $elm$core$Maybe$Nothing;
								}
							}()));
				case 'ServiceItemsEditor':
					var locations = editor.b;
					var tracking = editor.c;
					var fetchLocationsHasServiceItemsCmd = A2($author$project$Location$Details$PopupContent$GoogleServiceItems$getLocationsHasServiceItems, session.siteName, $author$project$Location$Details$Editor$Model$OnLocationNeedsVerificationResponse);
					var canModifyServiceList = $author$project$Location$Details$PopupContent$GoogleServiceItems$canModifyGoogleServices(location.google);
					var _v3 = A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$GoogleServiceItems,
							A4($author$project$Location$Details$Editor$initModel, locations, tracking, now, location)),
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$GoogleServiceItemsMsg, $author$project$Location$Details$Editor$Model$EditorMsg)),
						A4($author$project$Location$Details$PopupContent$GoogleServiceItems$init, siteName, canModifyServiceList, location.networkServiceItems.google, categories.google));
					var editorState_ = _v3.a;
					var editorCmd_ = _v3.b;
					return _Utils_Tuple2(
						editorState_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[editorCmd_, fetchLocationsHasServiceItemsCmd])));
				case 'GoogleAttributesEditor':
					var googleAttributes = editor.a;
					var locations = editor.b;
					var tracking = editor.c;
					var fetchCmd = function () {
						var _v4 = _Utils_Tuple2(
							$elm$core$List$isEmpty(googleAttributes),
							locations);
						if (_v4.a && (_v4.b.$ === 'Just')) {
							var bulkLocations = _v4.b.a;
							return $elm$core$List$isEmpty(bulkLocations.locations) ? $elm$core$Platform$Cmd$none : A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$GoogleAttributesMsg, $author$project$Location$Details$Editor$Model$EditorMsg),
								A2($author$project$Location$Details$PopupContent$GoogleAttributes$fetchAvailableAttributes, siteName, bulkLocations.locations));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$GoogleAttributes(
								A2($author$project$Location$Details$PopupContent$GoogleAttributes$init, googleAttributes, location.networkAttributes.google))),
						fetchCmd);
				case 'SocialMessagingEditor':
					var googleAttributes = editor.a;
					var locations = editor.b;
					var tracking = editor.c;
					var fetchCmd = function () {
						var _v5 = _Utils_Tuple2(
							$elm$core$List$isEmpty(googleAttributes),
							locations);
						if (_v5.a && (_v5.b.$ === 'Just')) {
							var bulkLocations = _v5.b.a;
							return $elm$core$List$isEmpty(bulkLocations.locations) ? $elm$core$Platform$Cmd$none : A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$SocialMessagingMsg, $author$project$Location$Details$Editor$Model$EditorMsg),
								A2($author$project$Location$Details$PopupContent$SocialMessaging$fetchAvailableAttributes, siteName, bulkLocations.locations));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$SocialMessaging(
								A2($author$project$Location$Details$PopupContent$SocialMessaging$init, googleAttributes, location.networkAttributes.google))),
						fetchCmd);
				case 'ActionLinksEditor':
					return A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$ActionLinks,
							A4($author$project$Location$Details$Editor$initModel, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, now, location)),
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$ActionLinksMsg, $author$project$Location$Details$Editor$Model$EditorMsg)),
						A4($author$project$Location$Details$PopupContent$ActionLinks$init, siteName, location.id, session.analytics.appleConnectionType, location.actionLinks));
				case 'CoordinatesEditor':
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$Coordinates(
								A2($author$project$Location$Details$PopupContent$Coordinates$init, session.translations, location.location))),
						$elm$core$Platform$Cmd$none);
				case 'CustomNameOnNetworkEditor':
					var network = editor.a;
					var customName = function () {
						switch (network.$) {
							case 'Facebook':
								return A2($elm$core$Maybe$withDefault, '', location.networkNames.facebook);
							case 'Google':
								return A2($elm$core$Maybe$withDefault, '', location.networkNames.google);
							case 'Bing':
								return '';
							case 'Apple':
								return A2($elm$core$Maybe$withDefault, '', location.networkNames.apple);
							case 'Foursquare':
								return '';
							case 'Overture':
								return '';
							case 'Here':
								return '';
							case 'Tomtom':
								return '';
							case 'Ptv':
								return A2($elm$core$Maybe$withDefault, '', location.networkNames.ptv);
							default:
								return '';
						}
					}();
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							A2(
								$author$project$Location$Details$Editor$Model$CustomNameOnNetwork,
								network,
								A3($author$project$Location$Details$PopupContent$CustomNameOnNetwork$init, session.translations, customName, network))),
						$elm$core$Platform$Cmd$none);
				case 'EmailEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$Email(
								A2($author$project$Location$Details$PopupContent$Email$init, session.translations, location.email))),
						$elm$core$Platform$Cmd$none);
				case 'HomepageEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$Homepage(
								A3($author$project$Location$Details$PopupContent$Homepage$init, session.translations, location.storeId, location.homepage))),
						$elm$core$Platform$Cmd$none);
				case 'OpenHoursEditor':
					var locations = editor.a;
					var tracking = editor.b;
					var openHours = function () {
						if (locations.$ === 'Just') {
							return $author$project$Data$Location$OpenHours$notSpecified;
						} else {
							return location.openHours;
						}
					}();
					return A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$OpenHours,
							A4($author$project$Location$Details$Editor$initModel, locations, tracking, now, location)),
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$OpenHoursMsg, $author$project$Location$Details$Editor$Model$EditorMsg)),
						$author$project$Location$Details$PopupContent$OpenHours$init(openHours));
				case 'WifiEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$Wifi(
								$author$project$Location$Details$PopupContent$Wifi$init(location.wifiSsId))),
						$elm$core$Platform$Cmd$none);
				case 'StoreIdEditor':
					var isFacebookConnected = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						false,
						function (facebook) {
							return _Utils_eq(facebook.idSetType, $author$project$Data$Network$Disconnected) ? false : true;
						},
						location.facebook);
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$StoreId(
								A3($author$project$Location$Details$PopupContent$StoreId$init, location.storeId, location.fbStoreId, isFacebookConnected))),
						$elm$core$Platform$Cmd$none);
				case 'TemporarilyClosedEditor':
					var locations = editor.a;
					var tracking = editor.b;
					var temporarilyClosed = function () {
						var _v8 = location.temporarilyClosedUntil;
						if (_v8.$ === 'Until') {
							var until = _v8.a;
							return A2(
								$author$project$Data$NetworkData$TemporarilyClosed$Until,
								until,
								$author$project$Data$Location$temporarilyClosedMessageToString(location.temporarilyClosedMessage));
						} else {
							return $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed;
						}
					}();
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$TemporarilyClosed(
								A6(
									$author$project$Location$Details$PopupContent$TemporarilyClosed$init,
									temporarilyClosed,
									now,
									session.language,
									session.locale,
									canSchedule,
									$author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedToPosix(location.temporarilyClosedUntil)))),
						$elm$core$Platform$Cmd$none);
				case 'StorefrontNameEditor':
					var locations = editor.a;
					var config = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$StorefrontName(
								A7($author$project$Location$Details$PopupContent$StorefrontName$init, session.translations, location.storefrontName, location.networkNames.google, location.networkNames.facebook, location.networkNames.apple, location.networkNames.ptv, config))),
						$elm$core$Platform$Cmd$none);
				case 'ShortDescriptionEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$ShortDescription(
								$author$project$Location$Details$PopupContent$ShortDescription$init(location.about))),
						$elm$core$Platform$Cmd$none);
				case 'PhoneEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$Phone(
								$author$project$Location$Details$PopupContent$Phone$init(location.phone))),
						$elm$core$Platform$Cmd$none);
				case 'OpenStatusEditor':
					var locations = editor.a;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$OpenStatus(
								A6($author$project$Location$Details$PopupContent$OpenStatus$init, location.permanentlyClosed, location.temporarilyClosedUntil, now, session.language, session.locale, scheduleUpdates))),
						$elm$core$Platform$Cmd$none);
				case 'PermanentlyClosedEditor':
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$PermanentlyClosed(
								$author$project$Location$Details$PopupContent$PermanentlyClosed$init(location.permanentlyClosed))),
						$elm$core$Platform$Cmd$none);
				case 'OpeningDateEditor':
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$OpeningDate(
								A3($author$project$Location$Details$PopupContent$OpeningDate$init, session.language, session.locale, location.openingDate))),
						$elm$core$Platform$Cmd$none);
				case 'LongDescriptionEditor':
					var locations = editor.a;
					var tracking = editor.b;
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							locations,
							tracking,
							now,
							location,
							$author$project$Location$Details$Editor$Model$LongDescription(
								A2($author$project$Location$Details$PopupContent$LongDescription$init, session.translations, location.longDescription))),
						$elm$core$Platform$Cmd$none);
				case 'LocationDescriptorEditor':
					return _Utils_Tuple2(
						A5(
							$author$project$Location$Details$Editor$initModel,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Nothing,
							now,
							location,
							$author$project$Location$Details$Editor$Model$LocationDescriptor(
								A2($author$project$Location$Details$PopupContent$LocationDescriptor$init, session.translations, location.locationDescriptor))),
						$elm$core$Platform$Cmd$none);
				default:
					var sourceCall = editor.a;
					var locations = editor.b;
					var tracking = editor.c;
					return A3(
						$elm$core$Tuple$mapBoth,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$Details$Editor$Model$SpecialOpenHours,
							A4($author$project$Location$Details$Editor$initModel, locations, tracking, now, location)),
						$elm$core$Platform$Cmd$map(
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$SpecialOpenHoursMsg, $author$project$Location$Details$Editor$Model$EditorMsg)),
						A5($author$project$Location$Details$PopupContent$SpecialOpenHours$init, location.specialOpenHours, sourceCall, now, session.language, session.locale));
			}
		}();
		var editorState = _v0.a;
		var editorCmd = _v0.b;
		return _Utils_Tuple2(
			editorState,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						editorCmd,
						A3($author$project$Location$Details$Editor$isNotSetRowCmd, editor, location, now)
					])));
	});
var $author$project$Common$PaginationSimple$empty = {keys: $elm$core$Array$empty, items: $elm$core$Dict$empty, value: 1, currentPage: 0};
var $author$project$Data$Location$Field$Wifi = {$: 'Wifi'};
var $author$project$Data$Location$Field$About = {$: 'About'};
var $author$project$Data$Location$Field$Email = {$: 'Email'};
var $author$project$Data$Location$Field$Hours = {$: 'Hours'};
var $author$project$Data$Location$Field$Phone = {$: 'Phone'};
var $author$project$Data$ValidatedEmail$encode = function (email) {
	if (email.$ === 'ValidEmail') {
		var x = email.a.a;
		return $elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'contact',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'email',
									$elm$json$Json$Encode$string(x))
								])))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$ValidatedHomepage$encode = function (validatedHomepage) {
	if (validatedHomepage.$ === 'ValidHomepage') {
		var homepage = validatedHomepage.a;
		return $elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'contact',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'homepage',
									$elm$json$Json$Encode$string(homepage))
								])))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$ValidatedCoordinates$encode = function (validatedCooridnates) {
	if (validatedCooridnates.$ === 'ValidCooridnates') {
		var cooridnates = validatedCooridnates.a;
		return $elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'lat',
									$elm$json$Json$Encode$float(cooridnates.lat)),
									_Utils_Tuple2(
									'lon',
									$elm$json$Json$Encode$float(cooridnates.lon))
								])))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$ValidatedLongDescription$encode = function (longDescription) {
	if (longDescription.$ === 'ValidLongDescription') {
		var x = longDescription.a.a;
		return $elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'longDescription',
						$elm$json$Json$Encode$string(x))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			_Utils_chr('0'),
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Data$Location$SpecialOpenHours$encode = function (openHours) {
	var state = function () {
		var _v0 = openHours.state;
		if (_v0.$ === 'Closed') {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'isClosed',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'openTime',
					$elm$json$Json$Encode$string('0000')),
					_Utils_Tuple2(
					'closeTime',
					$elm$json$Json$Encode$string('0000'))
				]);
		} else {
			var span = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'isClosed',
					$elm$json$Json$Encode$bool(false)),
					_Utils_Tuple2(
					'openTime',
					$elm$json$Json$Encode$string(span.open)),
					_Utils_Tuple2(
					'closeTime',
					$elm$json$Json$Encode$string(span.close))
				]);
		}
	}();
	var label = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		function (x) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'label',
					$elm$json$Json$Encode$string(x))
				]);
		},
		openHours.label);
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start',
					$elm$json$Json$Encode$string(
						A3(
							$elm$core$String$slice,
							0,
							10,
							$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(openHours.startDate)))),
					_Utils_Tuple2(
					'end',
					$elm$json$Json$Encode$string(
						A3(
							$elm$core$String$slice,
							0,
							10,
							$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(openHours.endDate))))
				]),
			_Utils_ap(label, state)));
};
var $author$project$Data$ValidatedLocationDescriptor$encode = function (locationDescriptor) {
	if (locationDescriptor.$ === 'ValidLocationDescriptor') {
		var x = locationDescriptor.a.a;
		return $elm$core$Maybe$Just(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'locationDescriptor',
						$elm$json$Json$Encode$string(x))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$ValidatedCustomNameOnNetwork$encode = F2(
	function (customName, network) {
		if (customName.$ === 'ValidCustomNameOnNetwork') {
			var x = customName.a;
			return $elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Network$toString(network),
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'custom',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(
														$elm$core$String$trim(x)))
												])))
									])))
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Location$Details$PopupContent$Phone$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'contact',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'phone',
							$elm$json$Json$Encode$string(model.phoneNumberString))
						])))
			]));
};
var $author$project$Location$Details$PopupContent$Active$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'isActive',
				function () {
					var _v0 = model.isActive;
					if (_v0.$ === 'Active') {
						return $elm$json$Json$Encode$bool(true);
					} else {
						return $elm$json$Json$Encode$bool(false);
					}
				}())
			]));
};
var $author$project$Data$Address$addressEncoder = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(address.street)),
				_Utils_Tuple2(
				'zip',
				$elm$json$Json$Encode$string(address.zip)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(address.city)),
				_Utils_Tuple2(
				'country',
				$elm$json$Json$Encode$string(address.country)),
				_Utils_Tuple2(
				'countryAlpha2Code',
				$elm$json$Json$Encode$string(address.countryAlpha2Code)),
				_Utils_Tuple2(
				'state',
				$author$project$Data$Address$hasState(address) ? $elm$json$Json$Encode$string(
					$author$project$Data$Address$getState(address)) : $elm$json$Json$Encode$null),
				_Utils_Tuple2(
				'province',
				$author$project$Data$Address$hasState(address) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(
					$author$project$Data$Address$getProvince(address))),
				_Utils_Tuple2(
				'district',
				$author$project$Data$Address$hasState(address) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(
					$author$project$Data$Address$getDistrict(address)))
			]));
};
var $author$project$Data$ServiceArea$serviceAreaMetaEncoder = function (meta) {
	if (meta.$ === 'Just') {
		var m = meta.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'longName',
					$elm$json$Json$Encode$string(m.longName)),
					_Utils_Tuple2(
					'shortName',
					$elm$json$Json$Encode$string(m.shortName))
				]));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Data$ServiceArea$serviceAreaEncoder = function (serviceArea) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'area',
				$elm$json$Json$Encode$string(serviceArea.area)),
				_Utils_Tuple2(
				'placeId',
				$elm$json$Json$Encode$string(serviceArea.placeId)),
				_Utils_Tuple2(
				'country',
				$author$project$Data$ServiceArea$serviceAreaMetaEncoder(
					$elm$core$Maybe$Just(serviceArea.country))),
				_Utils_Tuple2(
				'state',
				$author$project$Data$ServiceArea$serviceAreaMetaEncoder(serviceArea.state)),
				_Utils_Tuple2(
				'region',
				$author$project$Data$ServiceArea$serviceAreaMetaEncoder(serviceArea.region)),
				_Utils_Tuple2(
				'city',
				$author$project$Data$ServiceArea$serviceAreaMetaEncoder(serviceArea.city)),
				_Utils_Tuple2(
				'zip',
				$author$project$Data$ServiceArea$serviceAreaMetaEncoder(serviceArea.zip))
			]));
};
var $author$project$Data$ServiceArea$encodeServiceAreas = function (serviceAreas) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$ServiceArea$serviceAreaEncoder, serviceAreas);
};
var $author$project$Data$Location$locationTypeEncoder = function (locationType) {
	switch (locationType.$) {
		case 'Storefront':
			return $elm$json$Json$Encode$string('storefront');
		case 'ServiceArea':
			return $elm$json$Json$Encode$string('serviceArea');
		default:
			return $elm$json$Json$Encode$string('storefrontAndServiceArea');
	}
};
var $author$project$Location$Details$PopupContent$Address$encode = function (model) {
	var serviceAreasField = (!_Utils_eq(model.locationType, $author$project$Data$Location$Storefront)) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'serviceAreas',
			$author$project$Data$ServiceArea$encodeServiceAreas(
				$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
					$author$project$Common$Form$unwrapFormState(model.serviceAreaSelector.selectedServiceAreas))))
		]) : _List_Nil;
	var businessType = _List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$author$project$Data$Location$locationTypeEncoder(model.locationType))
		]);
	var addressField = $author$project$Location$Details$PopupContent$Address$showAddressSection(model) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'address',
			$author$project$Data$Address$addressEncoder(model.address))
		]) : _List_Nil;
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			businessType,
			_Utils_ap(addressField, serviceAreasField)));
};
var $author$project$Location$Details$PopupContent$StoreId$encode = function (model) {
	return ((!model.isFacebookConnected) && (!$elm$core$String$length(
		$author$project$Data$Location$facebookStoreIdToString(model.facebookStoreId)))) ? $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'storeId',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$storeIdToString(model.storeId)))
			])) : $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'storeId',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$storeIdToString(model.storeId))),
				_Utils_Tuple2(
				'fb',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'storeId',
							$elm$json$Json$Encode$string(
								$author$project$Data$Location$facebookStoreIdToString(model.facebookStoreId)))
						])))
			]));
};
var $author$project$Location$Details$PopupContent$OpenStatus$encode = F2(
	function (now, model) {
		var todayIso = $justinmimbs$date$Date$toIsoString(
			A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, now));
		var _v0 = model.choice;
		switch (_v0.$) {
			case 'OpenForBusiness':
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'isTempClosed',
							$elm$json$Json$Encode$bool(false)),
							_Utils_Tuple2(
							'temporarilyClosedMessage',
							$elm$json$Json$Encode$string('')),
							_Utils_Tuple2(
							'temporarilyClosedUntil',
							$elm$json$Json$Encode$string(todayIso)),
							_Utils_Tuple2(
							'permanentlyClosed',
							$elm$json$Json$Encode$bool(false))
						]));
			case 'TemporarilyClosed':
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'isTempClosed',
							$elm$json$Json$Encode$bool(true)),
							_Utils_Tuple2(
							'temporarilyClosedMessage',
							$elm$json$Json$Encode$string('')),
							_Utils_Tuple2(
							'temporarilyClosedUntil',
							$elm$json$Json$Encode$string(
								A2(
									$elm$core$Maybe$withDefault,
									todayIso,
									A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.selectedUntilDate)))),
							_Utils_Tuple2(
							'permanentlyClosed',
							$elm$json$Json$Encode$bool(false))
						]));
			default:
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'permanentlyClosed',
							$elm$json$Json$Encode$bool(true)),
							_Utils_Tuple2(
							'isTempClosed',
							$elm$json$Json$Encode$bool(false)),
							_Utils_Tuple2(
							'temporarilyClosedMessage',
							$elm$json$Json$Encode$string(''))
						]));
		}
	});
var $author$project$Data$Location$ActionLinks$encode = function (link) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$ActionLinks$actionLinkTypeToString(link.type_))),
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(link.url)),
				_Utils_Tuple2(
				'primary',
				$elm$json$Json$Encode$bool(link.primary))
			]));
};
var $author$project$Location$Details$PopupContent$ActionLinks$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'actionLinks',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Data$Location$ActionLinks$encode,
					$author$project$Location$Details$PopupContent$ActionLinks$filledLinks(model)))
			]));
};
var $author$project$Location$Details$PopupContent$OpeningDate$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'openingDate',
				$elm$json$Json$Encode$string(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (openingDate_) {
							return $justinmimbs$date$Date$toIsoString(
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, openingDate_));
						},
						model.openingDate)))
			]));
};
var $author$project$Location$Details$PopupContent$StorefrontName$encode = function (model) {
	var customNameField = function (cnModel) {
		var _v0 = cnModel.customName;
		if (_v0.$ === 'ValidCustomNameOnNetwork') {
			var x = _v0.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					$author$project$Data$Network$toString(cnModel.network),
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'custom',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'name',
											$elm$json$Json$Encode$string(
												$elm$core$String$trim(x)))
										])))
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var customFields = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				customNameField(model.googleCustomName),
				customNameField(model.facebookCustomName),
				customNameField(model.appleCustomName),
				customNameField(model.ptvCustomName)
			]));
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.storefrontNameString)),
			customFields));
};
var $author$project$Location$Details$PopupContent$ShortDescription$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'shortDescription',
				$elm$json$Json$Encode$string(model.shortDescriptionString))
			]));
};
var $author$project$Location$Details$PopupContent$PermanentlyClosed$encode = function (status) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'permanentlyClosed',
				$elm$json$Json$Encode$bool(status))
			]));
};
var $author$project$Location$Details$PopupContent$TemporarilyClosed$encode = function (model) {
	var _v0 = function () {
		var _v1 = model.temporarilyClosed;
		if (_v1.$ === 'Until') {
			var until = _v1.a;
			var message_ = _v1.b;
			return _Utils_Tuple2(until, message_);
		} else {
			return _Utils_Tuple2(model.now, '');
		}
	}();
	var maybePosix = _v0.a;
	var message = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'isTempClosed',
				$elm$json$Json$Encode$bool(
					!_Utils_eq(model.temporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed))),
				_Utils_Tuple2(
				'temporarilyClosedMessage',
				$elm$json$Json$Encode$string(message)),
				_Utils_Tuple2(
				'temporarilyClosedUntil',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(
						A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, maybePosix))))
			]));
};
var $author$project$Data$Location$alternativeSearchNamesToListOfStrings = function (_v0) {
	var names = _v0.a;
	return A2(
		$elm$core$List$filter,
		function (name) {
			return name !== '';
		},
		A2($elm$core$List$map, $elm$core$String$trim, names));
};
var $author$project$Location$Details$PopupContent$AlternativeSearchNames$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'alternativeNames',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					$author$project$Data$Location$alternativeSearchNamesToListOfStrings(model.alternativeSearchNames)))
			]));
};
var $author$project$PinMeTo$Ui$PopOver$Card = F2(
	function (a, b) {
		return {$: 'Card', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$PopOver$Opening = {$: 'Opening'};
var $author$project$PinMeTo$Ui$PopOver$Sheet = {$: 'Sheet'};
var $author$project$PinMeTo$Ui$PopOver$TopLeft = {$: 'TopLeft'};
var $author$project$PinMeTo$Ui$PopOver$TopRight = {$: 'TopRight'};
var $author$project$PinMeTo$Ui$PopOver$TopCenter = {$: 'TopCenter'};
var $author$project$PinMeTo$Ui$PopOver$BottomLeft = {$: 'BottomLeft'};
var $author$project$PinMeTo$Ui$PopOver$BottomCenter = {$: 'BottomCenter'};
var $author$project$PinMeTo$Ui$PopOver$getPriorityList = function (preferredDirection) {
	switch (preferredDirection.$) {
		case 'TopCenter':
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$TopCenter, $author$project$PinMeTo$Ui$PopOver$TopRight, $author$project$PinMeTo$Ui$PopOver$TopLeft, $author$project$PinMeTo$Ui$PopOver$BottomCenter, $author$project$PinMeTo$Ui$PopOver$BottomRight, $author$project$PinMeTo$Ui$PopOver$BottomLeft, $author$project$PinMeTo$Ui$PopOver$Sheet]);
		case 'TopRight':
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$TopRight, $author$project$PinMeTo$Ui$PopOver$BottomLeft, $author$project$PinMeTo$Ui$PopOver$TopLeft, $author$project$PinMeTo$Ui$PopOver$BottomRight, $author$project$PinMeTo$Ui$PopOver$TopCenter, $author$project$PinMeTo$Ui$PopOver$BottomCenter, $author$project$PinMeTo$Ui$PopOver$Sheet]);
		case 'TopLeft':
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$TopLeft, $author$project$PinMeTo$Ui$PopOver$BottomRight, $author$project$PinMeTo$Ui$PopOver$TopRight, $author$project$PinMeTo$Ui$PopOver$BottomLeft, $author$project$PinMeTo$Ui$PopOver$TopCenter, $author$project$PinMeTo$Ui$PopOver$BottomCenter, $author$project$PinMeTo$Ui$PopOver$Sheet]);
		case 'BottomCenter':
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$BottomCenter, $author$project$PinMeTo$Ui$PopOver$BottomRight, $author$project$PinMeTo$Ui$PopOver$BottomLeft, $author$project$PinMeTo$Ui$PopOver$TopCenter, $author$project$PinMeTo$Ui$PopOver$TopRight, $author$project$PinMeTo$Ui$PopOver$TopLeft, $author$project$PinMeTo$Ui$PopOver$Sheet]);
		case 'BottomRight':
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$BottomRight, $author$project$PinMeTo$Ui$PopOver$TopLeft, $author$project$PinMeTo$Ui$PopOver$BottomLeft, $author$project$PinMeTo$Ui$PopOver$TopRight, $author$project$PinMeTo$Ui$PopOver$BottomCenter, $author$project$PinMeTo$Ui$PopOver$TopCenter, $author$project$PinMeTo$Ui$PopOver$Sheet]);
		case 'BottomLeft':
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$BottomLeft, $author$project$PinMeTo$Ui$PopOver$TopRight, $author$project$PinMeTo$Ui$PopOver$BottomRight, $author$project$PinMeTo$Ui$PopOver$TopLeft, $author$project$PinMeTo$Ui$PopOver$BottomCenter, $author$project$PinMeTo$Ui$PopOver$TopCenter, $author$project$PinMeTo$Ui$PopOver$Sheet]);
		default:
			return _List_fromArray(
				[$author$project$PinMeTo$Ui$PopOver$Sheet]);
	}
};
var $author$project$PinMeTo$Ui$PopOver$fitsInViewport = F4(
	function (viewportWithInsets, target, card, direction) {
		switch (direction.$) {
			case 'TopRight':
				return (_Utils_cmp((target.x + target.width) + card.width, viewportWithInsets.width) < 1) && (_Utils_cmp(target.y - card.height, viewportWithInsets.y) > -1);
			case 'TopCenter':
				return (_Utils_cmp((target.x + (target.width / 2)) + (card.width / 2), viewportWithInsets.width) < 1) && ((_Utils_cmp((target.x - (target.width / 2)) - (card.width / 2), viewportWithInsets.x) > -1) && (_Utils_cmp(target.y - card.height, viewportWithInsets.y) > -1));
			case 'TopLeft':
				return (_Utils_cmp(target.x - card.width, viewportWithInsets.x) > -1) && (_Utils_cmp(target.y - card.height, viewportWithInsets.y) > -1);
			case 'BottomRight':
				return (_Utils_cmp((target.x + target.width) + card.width, viewportWithInsets.width) < 1) && (_Utils_cmp((target.y + target.height) + card.height, viewportWithInsets.y + viewportWithInsets.height) < 1);
			case 'BottomCenter':
				return (_Utils_cmp((target.x + (target.width / 2)) + (card.width / 2), viewportWithInsets.width) < 1) && ((_Utils_cmp((target.x - (target.width / 2)) - (card.width / 2), viewportWithInsets.x) > -1) && (_Utils_cmp((target.y + target.height) + card.height, viewportWithInsets.y + viewportWithInsets.height) < 1));
			case 'BottomLeft':
				return (_Utils_cmp(target.x - card.width, viewportWithInsets.x) > -1) && (_Utils_cmp((target.y + target.height) + card.height, viewportWithInsets.y + viewportWithInsets.height) < 1);
			default:
				return true;
		}
	});
var $author$project$PinMeTo$Ui$PopOver$getAllValidDirections = F3(
	function (viewport, target, card) {
		var coordinatesBottomCenter = {x: (target.x + (target.width / 2)) - (card.width / 2), y: (target.y + target.height) - viewport.scroll};
		var coordinatesBottomRight = {x: target.x + target.width, y: (target.y + target.height) - viewport.scroll};
		var coordinatesBottomLeft = {x: target.x - card.width, y: (target.y + target.height) - viewport.scroll};
		var coordinatesTopCenter = {x: (target.x + (target.width / 2)) - (card.width / 2), y: (target.y - card.height) - viewport.scroll};
		var coordinatesTopRight = {x: target.x + target.width, y: (target.y - card.height) - viewport.scroll};
		var coordinatesTopLeft = {x: target.x - card.width, y: (target.y - card.height) - viewport.scroll};
		return A2(
			$elm$core$List$filter,
			function (cardDirection) {
				return A4(
					$author$project$PinMeTo$Ui$PopOver$fitsInViewport,
					viewport,
					target,
					{width: card.width, height: card.height},
					cardDirection.a);
			},
			_List_fromArray(
				[
					_Utils_Tuple2($author$project$PinMeTo$Ui$PopOver$TopRight, coordinatesTopRight),
					_Utils_Tuple2($author$project$PinMeTo$Ui$PopOver$TopCenter, coordinatesTopCenter),
					_Utils_Tuple2($author$project$PinMeTo$Ui$PopOver$TopLeft, coordinatesTopLeft),
					_Utils_Tuple2($author$project$PinMeTo$Ui$PopOver$BottomRight, coordinatesBottomRight),
					_Utils_Tuple2($author$project$PinMeTo$Ui$PopOver$BottomCenter, coordinatesBottomCenter),
					_Utils_Tuple2($author$project$PinMeTo$Ui$PopOver$BottomLeft, coordinatesBottomLeft)
				]));
	});
var $author$project$PinMeTo$Ui$PopOver$getCardDirectionFromPriority = F2(
	function (validDirections, priorityList) {
		var filteredPrio = A2(
			$elm$core$List$filter,
			function (direction) {
				return A2($elm$core$List$member, direction, validDirections);
			},
			priorityList);
		return $elm$core$List$head(filteredPrio);
	});
var $author$project$PinMeTo$Ui$PopOver$fitToViewport = F4(
	function (preferredDirection, viewport, target, card) {
		var validDirectionsAndBoundingBoxes = A3($author$project$PinMeTo$Ui$PopOver$getAllValidDirections, viewport, target, card);
		var validCardDirections = A2($elm$core$List$map, $elm$core$Tuple$first, validDirectionsAndBoundingBoxes);
		var cardDirection = A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$PopOver$Sheet,
			A2(
				$author$project$PinMeTo$Ui$PopOver$getCardDirectionFromPriority,
				validCardDirections,
				$author$project$PinMeTo$Ui$PopOver$getPriorityList(preferredDirection)));
		var cardCoordinates = A2(
			$elm$core$Maybe$withDefault,
			{x: 0, y: 0},
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						function (tuple) {
							return _Utils_eq(tuple.a, cardDirection);
						},
						validDirectionsAndBoundingBoxes))));
		return _Utils_Tuple2(cardDirection, cardCoordinates);
	});
var $author$project$PinMeTo$Ui$PopOver$cardDimensions = function (cardDom) {
	return {width: cardDom.element.width, height: cardDom.element.height};
};
var $author$project$PinMeTo$Ui$PopOver$targetFromTargetDom = F2(
	function (targetDom, padding) {
		return {x: targetDom.element.x - padding, y: targetDom.element.y - padding, width: targetDom.element.width + (padding * 2), height: targetDom.element.height + (padding * 2)};
	});
var $author$project$PinMeTo$Ui$PopOver$defaultTargetPadding = 4;
var $author$project$PinMeTo$Ui$PopOver$viewportFromTargetDom = F2(
	function (targetDom, inset) {
		return {x: targetDom.viewport.x + inset.left, y: targetDom.viewport.y + inset.top, width: targetDom.viewport.width - (inset.left + inset.right), height: targetDom.viewport.height - (inset.top + inset.bottom), scroll: targetDom.viewport.y};
	});
var $author$project$PinMeTo$Ui$PopOver$NoOp = {$: 'NoOp'};
var $author$project$PinMeTo$Ui$PopOver$FitToViewport = F2(
	function (a, b) {
		return {$: 'FitToViewport', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$PopOver$getDropdownElementTask = F2(
	function (uid, preferredDirection) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return {cardDom: b, targetDom: a};
					}),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$map(
						$author$project$PinMeTo$Ui$PopOver$FitToViewport(preferredDirection)),
					$elm$core$Result$withDefault($author$project$PinMeTo$Ui$PopOver$NoOp))),
			A2(
				$elm$core$Task$andThen,
				function (a) {
					return A2(
						$elm$core$Task$andThen,
						function (b) {
							return $elm$core$Task$succeed(
								_Utils_Tuple2(a, b));
						},
						$elm$browser$Browser$Dom$getElement(
							$author$project$PinMeTo$Ui$PopOver$cardId(uid)));
				},
				$elm$browser$Browser$Dom$getElement(
					$author$project$PinMeTo$Ui$PopOver$targetId(uid))));
	});
var $author$project$PinMeTo$Ui$PopOver$updateWithCallbacks = F4(
	function (callbacks, tagger, msg, _v0) {
		var model = _v0.a;
		var onClose = function (uid) {
			var _v8 = callbacks.onClose;
			if (_v8.$ === 'Just') {
				var onClose_ = _v8.a;
				return A2(
					$elm$core$Task$perform,
					function (_v9) {
						return onClose_(uid);
					},
					$elm$core$Task$succeed(_Utils_Tuple0));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		};
		var onOpen = function (uid) {
			var _v6 = callbacks.onOpen;
			if (_v6.$ === 'Just') {
				var onOpen_ = _v6.a;
				return A2(
					$elm$core$Task$perform,
					function (_v7) {
						return onOpen_(uid);
					},
					$elm$core$Task$succeed(_Utils_Tuple0));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		};
		switch (msg.$) {
			case 'Open':
				var uid = msg.a;
				var preferredDirection = msg.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$PopOver$State(
						_Utils_update(
							model,
							{
								card: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$PopOver$Opening),
								openPopOver: $elm$core$Maybe$Just(uid),
								currentPreferredDirection: $elm$core$Maybe$Just(preferredDirection)
							})),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								tagger,
								A2($author$project$PinMeTo$Ui$PopOver$getDropdownElementTask, uid, preferredDirection)),
								onOpen(uid)
							])));
			case 'Close':
				var uid = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$PopOver$State(
						_Utils_update(
							model,
							{card: $elm$core$Maybe$Nothing, openPopOver: $elm$core$Maybe$Nothing, currentPreferredDirection: $elm$core$Maybe$Nothing})),
					onClose(uid));
			case 'FitToViewport':
				var preferredDirection = msg.a;
				var cardDom = msg.b.cardDom;
				var targetDom = msg.b.targetDom;
				var viewport = A2($author$project$PinMeTo$Ui$PopOver$viewportFromTargetDom, targetDom, $author$project$PinMeTo$Ui$PopOver$defaultViewportPadding);
				var target = A2($author$project$PinMeTo$Ui$PopOver$targetFromTargetDom, targetDom, $author$project$PinMeTo$Ui$PopOver$defaultTargetPadding);
				var card = $author$project$PinMeTo$Ui$PopOver$cardDimensions(cardDom);
				var _v2 = A4($author$project$PinMeTo$Ui$PopOver$fitToViewport, preferredDirection, viewport, target, card);
				var cardDirection = _v2.a;
				var cardCoordinates = _v2.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$PopOver$State(
						_Utils_update(
							model,
							{
								card: $elm$core$Maybe$Just(
									A2($author$project$PinMeTo$Ui$PopOver$Card, cardDirection, cardCoordinates))
							})),
					$elm$core$Platform$Cmd$none);
			case 'Resize':
				var uid = msg.a;
				var preferredDirection = msg.b;
				var shouldReconsiderSheet = function () {
					var _v3 = model.card;
					if (((_v3.$ === 'Just') && (_v3.a.$ === 'Card')) && (_v3.a.a.$ === 'Sheet')) {
						var _v4 = _v3.a;
						var _v5 = _v4.a;
						return true;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$PopOver$State(
						_Utils_update(
							model,
							{
								card: shouldReconsiderSheet ? $elm$core$Maybe$Just($author$project$PinMeTo$Ui$PopOver$Opening) : model.card
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						tagger,
						A2($author$project$PinMeTo$Ui$PopOver$getDropdownElementTask, uid, preferredDirection)));
			default:
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$PopOver$State(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Ui$PopOver$update = F3(
	function (tagger, msg, _v0) {
		var model = _v0.a;
		return A4(
			$author$project$PinMeTo$Ui$PopOver$updateWithCallbacks,
			{onOpen: $elm$core$Maybe$Nothing, onClose: $elm$core$Maybe$Nothing},
			tagger,
			msg,
			$author$project$PinMeTo$Ui$PopOver$State(model));
	});
var $author$project$Data$Location$WifiSsId = function (a) {
	return {$: 'WifiSsId', a: a};
};
var $author$project$Location$Details$PopupContent$Wifi$update = F2(
	function (msg, model) {
		var wifi = msg.a;
		return $author$project$Common$Validators$CsvInjection$isInputValid(wifi) ? _Utils_update(
			model,
			{
				wifi: $author$project$Data$Location$WifiSsId(wifi)
			}) : model;
	});
var $author$project$Location$Details$PopupContent$Email$update = F2(
	function (msg, model) {
		var value = msg.a.a;
		return _Utils_update(
			model,
			{
				email: A2($author$project$Data$ValidatedEmail$create, model.translations, value)
			});
	});
var $author$project$Data$Location$Phone = function (a) {
	return {$: 'Phone', a: a};
};
var $author$project$Location$Details$PopupContent$Phone$update = F2(
	function (msg, model) {
		var value = msg.a;
		return _Utils_update(
			model,
			{
				phoneNumber: $author$project$Data$Location$Phone(value),
				phoneNumberString: value
			});
	});
var $author$project$Location$Details$PopupContent$Active$update = F2(
	function (msg, model) {
		var isActive = msg.a;
		return _Utils_update(
			model,
			{isActive: isActive});
	});
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 'Seed', a: a, b: b};
	});
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$Generator = function (a) {
	return {$: 'Generator', a: a};
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return $elm$random$Random$Generator(
			function (seed0) {
				var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
				var lo = _v0.a;
				var hi = _v0.b;
				var range = (hi - lo) + 1;
				if (!((range - 1) & range)) {
					return _Utils_Tuple2(
						(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
						$elm$random$Random$next(seed0));
				} else {
					var threshhold = (((-range) >>> 0) % range) >>> 0;
					var accountForBias = function (seed) {
						accountForBias:
						while (true) {
							var seedN = $elm$random$Random$next(seed);
							var x = $elm$random$Random$peel(seed);
							if (_Utils_cmp(x, threshhold) < 0) {
								var $temp$seed = seedN;
								seed = $temp$seed;
								continue accountForBias;
							} else {
								return _Utils_Tuple2((x % range) + lo, seedN);
							}
						}
					};
					return accountForBias(seed0);
				}
			});
	});
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0.a;
		return $elm$random$Random$Generator(
			function (seed) {
				return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
			});
	});
var $author$project$Common$Form$Edited = function (a) {
	return {$: 'Edited', a: a};
};
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $author$project$Common$Debouncer$Timeout = function (a) {
	return {$: 'Timeout', a: a};
};
var $author$project$Common$Debouncer$update = F2(
	function (msg, model) {
		if (msg.$ === 'Trigger') {
			var newContent = msg.a;
			var newDebounceId = A2($elm$core$Basics$modBy, $author$project$Common$Debouncer$maxId, model.debounceId + 1);
			var cmd = A2(
				$elm$core$Task$perform,
				$elm$core$Basics$always(
					$author$project$Common$Debouncer$Timeout(newDebounceId)),
				$elm$core$Process$sleep(model.debounceAmountMs));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{content: newContent, debounceId: newDebounceId}),
				cmd,
				$elm$core$Maybe$Nothing);
		} else {
			var id = msg.a;
			return _Utils_eq(id, model.debounceId) ? _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$elm$core$Maybe$Just(model.content)) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Listings$Ui$AutoComplete$getSelectableValue = function (selectable) {
	if (selectable.$ === 'Just') {
		var s = selectable.a;
		var selectableValue = s.a;
		return selectableValue;
	} else {
		return '';
	}
};
var $author$project$Listings$Ui$AutoComplete$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'InputChange':
				var str = msg.a;
				return (!A2(
					$author$project$Listings$Ui$AutoComplete$isSelected,
					model.selected,
					$author$project$Listings$Ui$AutoComplete$Selectable(str))) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							index: $elm$core$Maybe$Nothing,
							visible: true,
							selected: $elm$core$Maybe$Nothing,
							inputValue: $author$project$Common$Form$Edited(str)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							inputValue: $author$project$Common$Form$Edited(str)
						}),
					$elm$core$Platform$Cmd$none);
			case 'Select':
				var selectable = msg.a;
				var newInputValue = model.multiValues ? '' : $author$project$Listings$Ui$AutoComplete$getSelectableValue(selectable);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							visible: false,
							selected: selectable,
							inputValue: $author$project$Common$Form$Edited(newInputValue)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectByIndex':
				var selectable = msg.a;
				var index = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							index: $elm$core$Maybe$Just(index),
							selected: selectable
						}),
					$elm$core$Platform$Cmd$none);
			case 'InputFocus':
				var focusType = msg.a;
				if (focusType.$ === 'Enter') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{visible: true}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{visible: false}),
						$elm$core$Platform$Cmd$none);
				}
			case 'Clear':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							inputValue: $author$project$Common$Form$Clean('')
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0.a;
		return $elm$random$Random$Generator(
			function (seed0) {
				var _v1 = genA(seed0);
				var a = _v1.a;
				var seed1 = _v1.b;
				return _Utils_Tuple2(
					func(a),
					seed1);
			});
	});
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0.a;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generate = function (a) {
	return {$: 'Generate', a: a};
};
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0.a;
		return $elm$random$Random$Generate(
			A2($elm$random$Random$map, func, generator));
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			$elm$random$Random$Generate(
				A2($elm$random$Random$map, tagger, generator)));
	});
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Common$ServiceAreaSelectorV2$Update$InputValue = function (a) {
	return {$: 'InputValue', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$Types$DebouncerMsg = function (a) {
	return {$: 'DebouncerMsg', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$Update$SessionToken = function (a) {
	return {$: 'SessionToken', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$Types$GenerateSeeds = F2(
	function (a, b) {
		return {$: 'GenerateSeeds', a: a, b: b};
	});
var $TSFoster$elm_uuid$UUID$UUID = F4(
	function (a, b, c, d) {
		return {$: 'UUID', a: a, b: b, c: c, d: d};
	});
var $TSFoster$elm_uuid$UUID$Seeds = F4(
	function (seed1, seed2, seed3, seed4) {
		return {seed1: seed1, seed2: seed2, seed3: seed3, seed4: seed4};
	});
var $TSFoster$elm_uuid$UUID$forceUnsigned = $elm$core$Bitwise$shiftRightZfBy(0);
var $TSFoster$elm_uuid$UUID$randomU32 = A2(
	$elm$random$Random$map,
	$TSFoster$elm_uuid$UUID$forceUnsigned,
	A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt));
var $elm$core$Bitwise$or = _Bitwise_or;
var $TSFoster$elm_uuid$UUID$toVersion = F2(
	function (v, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return A4(
			$TSFoster$elm_uuid$UUID$UUID,
			a,
			$TSFoster$elm_uuid$UUID$forceUnsigned((v << 12) | (4294905855 & b)),
			c,
			d);
	});
var $TSFoster$elm_uuid$UUID$toVariant1 = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return A4(
		$TSFoster$elm_uuid$UUID$UUID,
		a,
		b,
		$TSFoster$elm_uuid$UUID$forceUnsigned(2147483648 | (1073741823 & c)),
		d);
};
var $TSFoster$elm_uuid$UUID$step = function (s) {
	var _v0 = A2($elm$random$Random$step, $TSFoster$elm_uuid$UUID$randomU32, s.seed4);
	var int4 = _v0.a;
	var seed4 = _v0.b;
	var _v1 = A2($elm$random$Random$step, $TSFoster$elm_uuid$UUID$randomU32, s.seed3);
	var int3 = _v1.a;
	var seed3 = _v1.b;
	var _v2 = A2($elm$random$Random$step, $TSFoster$elm_uuid$UUID$randomU32, s.seed2);
	var int2 = _v2.a;
	var seed2 = _v2.b;
	var _v3 = A2($elm$random$Random$step, $TSFoster$elm_uuid$UUID$randomU32, s.seed1);
	var int1 = _v3.a;
	var seed1 = _v3.b;
	var uuid = $TSFoster$elm_uuid$UUID$toVariant1(
		A2(
			$TSFoster$elm_uuid$UUID$toVersion,
			4,
			A4($TSFoster$elm_uuid$UUID$UUID, int1, int2, int3, int4)));
	return _Utils_Tuple2(
		uuid,
		A4($TSFoster$elm_uuid$UUID$Seeds, seed1, seed2, seed3, seed4));
};
var $elm$core$String$fromList = _String_fromList;
var $TSFoster$elm_uuid$UUID$toHex = F2(
	function (acc, _int) {
		toHex:
		while (true) {
			if (!_int) {
				return $elm$core$String$fromList(acc);
			} else {
				var _char = function () {
					var _v0 = 15 & _int;
					switch (_v0) {
						case 0:
							return _Utils_chr('0');
						case 1:
							return _Utils_chr('1');
						case 2:
							return _Utils_chr('2');
						case 3:
							return _Utils_chr('3');
						case 4:
							return _Utils_chr('4');
						case 5:
							return _Utils_chr('5');
						case 6:
							return _Utils_chr('6');
						case 7:
							return _Utils_chr('7');
						case 8:
							return _Utils_chr('8');
						case 9:
							return _Utils_chr('9');
						case 10:
							return _Utils_chr('a');
						case 11:
							return _Utils_chr('b');
						case 12:
							return _Utils_chr('c');
						case 13:
							return _Utils_chr('d');
						case 14:
							return _Utils_chr('e');
						default:
							return _Utils_chr('f');
					}
				}();
				var $temp$acc = A2($elm$core$List$cons, _char, acc),
					$temp$int = _int >>> 4;
				acc = $temp$acc;
				_int = $temp$int;
				continue toHex;
			}
		}
	});
var $TSFoster$elm_uuid$UUID$toStringWith = F2(
	function (sep, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return _Utils_ap(
			A3(
				$elm$core$String$padLeft,
				8,
				_Utils_chr('0'),
				A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, a)),
			_Utils_ap(
				sep,
				_Utils_ap(
					A3(
						$elm$core$String$padLeft,
						4,
						_Utils_chr('0'),
						A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, b >>> 16)),
					_Utils_ap(
						sep,
						_Utils_ap(
							A3(
								$elm$core$String$padLeft,
								4,
								_Utils_chr('0'),
								A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & b)),
							_Utils_ap(
								sep,
								_Utils_ap(
									A3(
										$elm$core$String$padLeft,
										4,
										_Utils_chr('0'),
										A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, c >>> 16)),
									_Utils_ap(
										sep,
										_Utils_ap(
											A3(
												$elm$core$String$padLeft,
												4,
												_Utils_chr('0'),
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & c)),
											A3(
												$elm$core$String$padLeft,
												8,
												_Utils_chr('0'),
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, d)))))))))));
	});
var $TSFoster$elm_uuid$UUID$toString = $TSFoster$elm_uuid$UUID$toStringWith('-');
var $author$project$Common$ServiceAreaSelectorV2$Update$generateToken = F2(
	function (sessionToken, seeds) {
		var _v0 = function () {
			if ((((seeds.b && seeds.b.b) && seeds.b.b.b) && seeds.b.b.b.b) && (!seeds.b.b.b.b.b)) {
				var a = seeds.a;
				var _v4 = seeds.b;
				var b = _v4.a;
				var _v5 = _v4.b;
				var c = _v5.a;
				var _v6 = _v5.b;
				var d = _v6.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(a, b),
					_Utils_Tuple2(c, d));
			} else {
				return _Utils_Tuple2(
					_Utils_Tuple2(890453, 789045),
					_Utils_Tuple2(23678, 89657));
			}
		}();
		var _v1 = _v0.a;
		var s1 = _v1.a;
		var s2 = _v1.b;
		var _v2 = _v0.b;
		var s3 = _v2.a;
		var s4 = _v2.b;
		var _v7 = _Utils_Tuple2(
			$elm$random$Random$initialSeed(s3),
			$elm$random$Random$initialSeed(s4));
		var seed3 = _v7.a;
		var seed4 = _v7.b;
		var _v8 = _Utils_Tuple2(
			$elm$random$Random$initialSeed(s1),
			$elm$random$Random$initialSeed(s2));
		var seed1 = _v8.a;
		var seed2 = _v8.b;
		var generateUUIDv4 = $TSFoster$elm_uuid$UUID$toString(
			$TSFoster$elm_uuid$UUID$step(
				A4($TSFoster$elm_uuid$UUID$Seeds, seed1, seed2, seed3, seed4)).a);
		var newSessionToken = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, generateUUIDv4, $elm$core$Basics$identity, sessionToken);
		return newSessionToken;
	});
var $author$project$Common$ServiceAreaSelectorV2$Update$inputEncoder = F3(
	function (_v0, _v1, _v2) {
		var inputValue = _v0.a;
		var sessionToken = _v1.a;
		var siteName = _v2.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'input',
					$elm$json$Json$Encode$string(inputValue)),
					_Utils_Tuple2(
					'sessionToken',
					$elm$json$Json$Encode$string(sessionToken)),
					_Utils_Tuple2(
					'siteName',
					$elm$json$Json$Encode$string(siteName))
				]));
	});
var $author$project$Common$ServiceAreaSelectorV2$Types$HandleSearchResult = function (a) {
	return {$: 'HandleSearchResult', a: a};
};
var $author$project$Common$ServiceAreaSelectorV2$Types$SearchResult = function (serviceAreas) {
	return {serviceAreas: serviceAreas};
};
var $author$project$Data$ServiceArea$ServiceAreaSuggestion = F2(
	function (area, placeId) {
		return {area: area, placeId: placeId};
	});
var $author$project$Data$ServiceArea$serviceAreaSuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'placeId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'area',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$ServiceArea$ServiceAreaSuggestion)));
var $author$project$Common$ServiceAreaSelectorV2$Types$searchResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'serviceAreas',
	$elm$json$Json$Decode$list($author$project$Data$ServiceArea$serviceAreaSuggestionDecoder),
	$elm$json$Json$Decode$succeed($author$project$Common$ServiceAreaSelectorV2$Types$SearchResult));
var $author$project$Common$ServiceAreaSelectorV2$Update$searchServiceAreas = F3(
	function (inputValue, sessionToken, siteName) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, $author$project$Common$ServiceAreaSelectorV2$Types$HandleSearchResult, $author$project$Common$ServiceAreaSelectorV2$Types$searchResultDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A3($author$project$Common$ServiceAreaSelectorV2$Update$inputEncoder, inputValue, sessionToken, siteName),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/google/servicearea/lookup')))));
	});
var $author$project$Common$Debouncer$Trigger = function (a) {
	return {$: 'Trigger', a: a};
};
var $author$project$Common$Debouncer$trigger = function (value) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(
			$author$project$Common$Debouncer$Trigger(value)));
};
var $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getSuggestionList = function (lst) {
	switch (lst.$) {
		case 'EmptyList':
			return _List_Nil;
		case 'AddableList':
			var xs = lst.a;
			return xs;
		case 'FullList':
			var xs = lst.a;
			return xs;
		default:
			return _List_Nil;
	}
};
var $author$project$Common$ServiceAreaSelectorV2$Types$ResultWithOptions = F2(
	function (a, b) {
		return {$: 'ResultWithOptions', a: a, b: b};
	});
var $author$project$Common$ServiceAreaSelectorV2$Types$HandlePlaceDetailsResponse = function (a) {
	return {$: 'HandlePlaceDetailsResponse', a: a};
};
var $author$project$Data$ServiceArea$serviceAreaSuggestionEncoder = function (serviceArea) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'area',
				$elm$json$Json$Encode$string(serviceArea.area)),
				_Utils_Tuple2(
				'placeId',
				$elm$json$Json$Encode$string(serviceArea.placeId))
			]));
};
var $author$project$Common$ServiceAreaSelectorV2$Update$getMetaDataForServiceArea = F3(
	function (model, suggestion, autoCompleteMsg) {
		var sessionToken = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, model.sessionToken);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Common$ServiceAreaSelectorV2$Types$ResultWithOptions(autoCompleteMsg),
						$author$project$Common$ServiceAreaSelectorV2$Types$HandlePlaceDetailsResponse),
					$author$project$Data$ServiceArea$serviceAreaDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Data$ServiceArea$serviceAreaSuggestionEncoder(suggestion),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/google/servicearea/placeDetails/' + sessionToken)))));
	});
var $author$project$Common$ServiceAreaSelectorV2$Update$updateAutoComplete = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Noop':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'Select':
				var selectable = msg.a;
				var selectedAreaAsString = $author$project$Listings$Ui$AutoComplete$getSelectableValue(selectable);
				var selectedArea = A2(
					$elm$core$List$filter,
					function (area) {
						return _Utils_eq(area.area, selectedAreaAsString);
					},
					$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getSuggestionList(model.availableServiceAreas));
				var metaDataCmd = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Platform$Cmd$none,
					function (area) {
						return A3($author$project$Common$ServiceAreaSelectorV2$Update$getMetaDataForServiceArea, model, area, msg);
					},
					$elm$core$List$head(selectedArea));
				return _Utils_Tuple2(model, metaDataCmd);
			case 'InputChange':
				var inputValue = msg.a;
				var _v1 = A2($author$project$Listings$Ui$AutoComplete$update, msg, model.uiAutoComplete);
				var newModel = _v1.a;
				var autoCompleteCmd = _v1.b;
				var debouncerCmd = A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Common$ServiceAreaSelectorV2$Types$DebouncerMsg,
					$author$project$Common$Debouncer$trigger(inputValue));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiAutoComplete: newModel}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[debouncerCmd, autoCompleteCmd])));
			case 'SelectByIndex':
				var _v2 = A2($author$project$Listings$Ui$AutoComplete$update, msg, model.uiAutoComplete);
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiAutoComplete: newModel}),
					cmd);
			case 'InputFocus':
				if (msg.a.$ === 'Enter') {
					var _v3 = msg.a;
					var _v4 = A2($author$project$Listings$Ui$AutoComplete$update, msg, model.uiAutoComplete);
					var newModel = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uiAutoComplete: newModel}),
						cmd);
				} else {
					var _v5 = msg.a;
					var _v6 = A2($author$project$Listings$Ui$AutoComplete$update, msg, model.uiAutoComplete);
					var newModel = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uiAutoComplete: newModel}),
						cmd);
				}
			default:
				var _v7 = A2($author$project$Listings$Ui$AutoComplete$update, msg, model.uiAutoComplete);
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiAutoComplete: newModel}),
					cmd);
		}
	});
var $author$project$Common$ServiceAreaSelectorV2$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UiAutoCompleteMsg':
				var msg_ = msg.a;
				return A2($author$project$Common$ServiceAreaSelectorV2$Update$updateAutoComplete, msg_, model);
			case 'DebouncerMsg':
				var debouncerMsg = msg.a;
				var _v1 = A2($author$project$Common$Debouncer$update, debouncerMsg, model.debouncer);
				var newDebouncer = _v1.a;
				var debouncerCmd = _v1.b;
				var maybeInputValue = _v1.c;
				var searchCmd = function () {
					if (maybeInputValue.$ === 'Just') {
						var inputValue = maybeInputValue.a;
						return ($elm$core$String$length(inputValue) > 0) ? A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							A2(
								$elm$random$Random$generate,
								$author$project$Common$ServiceAreaSelectorV2$Types$GenerateSeeds(inputValue),
								A2(
									$elm$random$Random$list,
									4,
									A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt))),
							function (token) {
								return A3(
									$author$project$Common$ServiceAreaSelectorV2$Update$searchServiceAreas,
									$author$project$Common$ServiceAreaSelectorV2$Update$InputValue(inputValue),
									$author$project$Common$ServiceAreaSelectorV2$Update$SessionToken(token),
									model.siteName);
							},
							model.sessionToken) : $elm$core$Platform$Cmd$none;
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{debouncer: newDebouncer}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Common$ServiceAreaSelectorV2$Types$DebouncerMsg, debouncerCmd),
								searchCmd
							])));
			case 'HandleSearchResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var searchValue = result.a;
					var filteredList = A2(
						$elm_community$list_extra$List$Extra$filterNot,
						function (x) {
							return A2(
								$elm$core$List$any,
								function (y) {
									return _Utils_eq(y.placeId, x.placeId);
								},
								$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
									$author$project$Common$Form$unwrapFormState(model.selectedServiceAreas)));
						},
						searchValue.serviceAreas);
					var newAvailableList = $elm$core$List$isEmpty(filteredList) ? $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FetchFail : $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$AddableList(filteredList);
					var uiModel = model.uiAutoComplete;
					var newUiModel = _Utils_update(
						uiModel,
						{
							values: A2(
								$elm$core$List$map,
								function (x) {
									return $author$project$Listings$Ui$AutoComplete$Selectable(x.area);
								},
								filteredList)
						});
					var newModel = _Utils_update(
						model,
						{
							uiAutoComplete: newUiModel,
							selectedServiceAreas: $author$project$Common$Form$Clean(
								$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$AddableList(
									$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
										$author$project$Common$Form$unwrapFormState(model.selectedServiceAreas)))),
							availableServiceAreas: newAvailableList
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					var uiModel = model.uiAutoComplete;
					var newUiModel = _Utils_update(
						uiModel,
						{values: _List_Nil});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uiAutoComplete: newUiModel,
								selectedServiceAreas: $author$project$Common$Form$Clean($author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FetchFail),
								availableServiceAreas: $author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$FetchFail
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$Common$Util$httpErrorToString(err),
								context: 'Common.ServiceAreaSelectorV2',
								message: 'HandleSearchResult failed'
							}));
				}
			case 'HandlePlaceDetailsResponse':
				var _v4 = msg.a;
				var autoCompleteMsg = _v4.a;
				var result = _v4.b;
				if (result.$ === 'Ok') {
					var serviceArea = result.a;
					var updateSelectedAndSetAutoComplete = function (_v8) {
						var newSelected = A2(
							$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$addArea,
							serviceArea,
							$author$project$Common$Form$unwrapFormState(model.selectedServiceAreas));
						var _v7 = A2($author$project$Listings$Ui$AutoComplete$update, autoCompleteMsg, model.uiAutoComplete);
						var newModel = _v7.a;
						var cmd = _v7.b;
						var resetUiAutoCompleteValues = _Utils_update(
							newModel,
							{values: _List_Nil});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									sessionToken: $elm$core$Maybe$Nothing,
									uiAutoComplete: resetUiAutoCompleteValues,
									selectedServiceAreas: $author$project$Common$Form$Edited(newSelected)
								}),
							cmd);
					};
					var _v6 = $author$project$Common$Form$unwrapFormState(model.selectedServiceAreas);
					switch (_v6.$) {
						case 'EmptyList':
							return updateSelectedAndSetAutoComplete(_Utils_Tuple0);
						case 'AddableList':
							return updateSelectedAndSetAutoComplete(_Utils_Tuple0);
						case 'FullList':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{sessionToken: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{sessionToken: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none);
					}
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{sessionToken: $elm$core$Maybe$Nothing}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$Common$Util$httpErrorToString(err),
								context: 'Common.ServiceAreaSelectorV2',
								message: 'HandlePlaceDetails failed'
							}));
				}
			case 'RemoveServiceArea':
				var serviceArea = msg.a;
				var filteredList = A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (area) {
						return _Utils_eq(area.placeId, serviceArea.placeId);
					},
					$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
						$author$project$Common$Form$unwrapFormState(model.selectedServiceAreas)));
				var newModel = _Utils_update(
					model,
					{
						selectedServiceAreas: $author$project$Common$Form$Edited(
							$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$create(filteredList))
					});
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			default:
				var inputValue = msg.a;
				var seeds = msg.b;
				var newSessionToken = A2($author$project$Common$ServiceAreaSelectorV2$Update$generateToken, model.sessionToken, seeds);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionToken: $elm$core$Maybe$Just(newSessionToken)
						}),
					A3(
						$author$project$Common$ServiceAreaSelectorV2$Update$searchServiceAreas,
						$author$project$Common$ServiceAreaSelectorV2$Update$InputValue(inputValue),
						$author$project$Common$ServiceAreaSelectorV2$Update$SessionToken(newSessionToken),
						model.siteName));
		}
	});
var $author$project$Data$Address$updateField = F2(
	function (field, address) {
		switch (field.$) {
			case 'Street':
				var value = field.a;
				return _Utils_update(
					address,
					{street: value});
			case 'Zip':
				var value = field.a;
				return _Utils_update(
					address,
					{zip: value});
			case 'City':
				var value = field.a;
				return _Utils_update(
					address,
					{city: value});
			case 'State':
				var value = field.a;
				return _Utils_update(
					address,
					{
						stateOrProvince: $author$project$Data$Address$WithState(value)
					});
			case 'Country':
				var value = field.a;
				return _Utils_update(
					address,
					{country: value});
			case 'Province':
				var value = field.a;
				return _Utils_update(
					address,
					{
						stateOrProvince: $author$project$Data$Address$WithProvince(
							{
								district: $author$project$Data$Address$getDistrict(address),
								province: value
							})
					});
			default:
				var value = field.a;
				return _Utils_update(
					address,
					{
						stateOrProvince: $author$project$Data$Address$WithProvince(
							{
								district: value,
								province: $author$project$Data$Address$getProvince(address)
							})
					});
		}
	});
var $author$project$Location$Details$PopupContent$Address$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'ChangeAddressField':
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							address: A2($author$project$Data$Address$updateField, field, model.address)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectBusinessType':
				var locationType = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationType: locationType}),
					$elm$core$Platform$Cmd$none);
			case 'SelectCountry':
				var country = msg.a;
				var newStateOrProvince = (country.alpha2 === 'CN') ? $author$project$Data$Address$WithProvince(
					{district: '', province: ''}) : $author$project$Data$Address$WithState('');
				var address = model.address;
				var newAddress = _Utils_update(
					address,
					{country: country.name, stateOrProvince: newStateOrProvince, countryAlpha2Code: country.alpha2});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{address: newAddress}),
					$elm$core$Platform$Cmd$none);
			case 'SelectRegion':
				var region = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							address: A2(
								$author$project$Data$Address$updateField,
								$author$project$Data$Address$State(region),
								model.address)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectProvince':
				var province = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							address: A2(
								$author$project$Data$Address$updateField,
								$author$project$Data$Address$Province(province),
								model.address)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (state) {
						return _Utils_update(
							model,
							{uiSelect: state});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Location$Details$PopupContent$Address$UiSelectMsg, msg_, model.uiSelect));
			case 'ServiceAreaSelectorMsg':
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (state) {
						return _Utils_update(
							model,
							{serviceAreaSelector: state});
					},
					$elm$core$Platform$Cmd$map($author$project$Location$Details$PopupContent$Address$ServiceAreaSelectorMsg),
					A2($author$project$Common$ServiceAreaSelectorV2$Update$update, msg_, model.serviceAreaSelector));
			case 'GotCountryData':
				if (msg.a.$ === 'Ok') {
					var countries = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								countries: $author$project$RemoteData$Loaded(countries)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								countries: $author$project$RemoteData$Error(
									$author$project$PinMeTo$Common$Util$httpErrorToString(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var popMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (state) {
						return _Utils_update(
							model,
							{businessTypePopOver: state});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Location$Details$PopupContent$Address$BusinessTypePopOverMsg, popMsg, model.businessTypePopOver));
		}
	});
var $author$project$Location$Details$PopupContent$StoreId$pattern = '^[a-zA-Z0-9\u005C-]*$';
var $author$project$Location$Details$PopupContent$StoreId$maybeRegex = $elm$regex$Regex$fromString($author$project$Location$Details$PopupContent$StoreId$pattern);
var $author$project$Location$Details$PopupContent$StoreId$regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $author$project$Location$Details$PopupContent$StoreId$maybeRegex);
var $author$project$Data$Location$FacebookStoreId = function (a) {
	return {$: 'FacebookStoreId', a: a};
};
var $author$project$Location$Details$PopupContent$StoreId$update = F2(
	function (msg, model) {
		if (msg.$ === 'OnChangeStoreId') {
			var value = msg.a;
			return $author$project$Common$Validators$CsvInjection$isInputValid(value) ? _Utils_update(
				model,
				{
					storeId: $author$project$Data$Location$StoreId(value),
					textStoreId: value
				}) : model;
		} else {
			var value = msg.a;
			var newValue = (value === '') ? '' : ((A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$StoreId$regex, value) && $author$project$Common$Validators$CsvInjection$isInputValid(value)) ? value : model.textFacebookStoreId);
			return _Utils_update(
				model,
				{
					facebookStoreId: $author$project$Data$Location$FacebookStoreId(
						$elm$core$Maybe$Just(newValue)),
					textFacebookStoreId: newValue
				});
		}
	});
var $author$project$Location$Details$PopupContent$Homepage$update = F2(
	function (msg, model) {
		var url = msg.a;
		return _Utils_update(
			model,
			{
				homepage: A2($author$project$Data$ValidatedHomepage$create, model.translations, url)
			});
	});
var $author$project$Data$Location$OpenHours$Open = function (a) {
	return {$: 'Open', a: a};
};
var $author$project$Data$Location$OpenHours$Closed = {$: 'Closed'};
var $author$project$Location$Details$PopupContent$OpenHours$updateDaySameState = F3(
	function (openHours, stringShortDay, newState) {
		if (openHours.$ === 'During') {
			var days = openHours.a;
			switch (stringShortDay) {
				case 'mon':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{mon: newState}));
				case 'tue':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{tue: newState}));
				case 'wed':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{wed: newState}));
				case 'thu':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{thu: newState}));
				case 'fri':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{fri: newState}));
				case 'sat':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sat: newState}));
				case 'sun':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sun: newState}));
				default:
					return $author$project$Data$Location$OpenHours$During(days);
			}
		} else {
			return openHours;
		}
	});
var $author$project$Location$Details$PopupContent$OpenHours$updateDayDifferentState = F3(
	function (openHours, stringShortDay, newDaysState) {
		if (openHours.$ === 'During') {
			var days = openHours.a;
			switch (stringShortDay) {
				case 'mon':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{mon: newDaysState.mon}));
				case 'tue':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{tue: newDaysState.tue}));
				case 'wed':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{wed: newDaysState.wed}));
				case 'thu':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{thu: newDaysState.thu}));
				case 'fri':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{fri: newDaysState.fri}));
				case 'sat':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sat: newDaysState.sat}));
				case 'sun':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sun: newDaysState.sun}));
				default:
					return $author$project$Data$Location$OpenHours$During(days);
			}
		} else {
			return openHours;
		}
	});
var $author$project$Location$Details$PopupContent$OpenHours$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnAlwaysOpenChange':
				var checked = msg.a;
				var defaultOpenHours = $author$project$Data$Location$OpenHours$During(
					{
						fri: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						mon: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						sat: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						sun: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						thu: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						tue: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						wed: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								]))
					});
				var _v1 = checked ? _Utils_Tuple2($author$project$Data$Location$OpenHours$Always, model.openHours) : _Utils_Tuple2(
					_Utils_eq(model.bufferOpenHours, $author$project$Data$Location$OpenHours$Always) ? defaultOpenHours : model.bufferOpenHours,
					defaultOpenHours);
				var newHours = _v1.a;
				var newBufferOpenHours = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newHours, bufferOpenHours: newBufferOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'OnDayClosedChange':
				var stringDay = msg.a;
				var checked = msg.b;
				var newDayValue = function (currentState) {
					if (checked) {
						return $author$project$Data$Location$OpenHours$Closed;
					} else {
						switch (currentState.$) {
							case 'AlwaysOpen':
								return $author$project$Data$Location$OpenHours$AlwaysOpen;
							case 'Open':
								var spanList = currentState.a;
								return $author$project$Data$Location$OpenHours$Open(spanList);
							default:
								return $author$project$Data$Location$OpenHours$Open(
									_List_fromArray(
										[
											{open: '0800', close: '1700'}
										]));
						}
					}
				};
				var openHours_ = model.openHours;
				var newDays = function () {
					if (openHours_.$ === 'During') {
						var days = openHours_.a;
						switch (stringDay) {
							case 'mon':
								return _Utils_update(
									days,
									{
										mon: newDayValue(days.mon)
									});
							case 'tue':
								return _Utils_update(
									days,
									{
										tue: newDayValue(days.tue)
									});
							case 'wed':
								return _Utils_update(
									days,
									{
										wed: newDayValue(days.wed)
									});
							case 'thu':
								return _Utils_update(
									days,
									{
										thu: newDayValue(days.thu)
									});
							case 'fri':
								return _Utils_update(
									days,
									{
										fri: newDayValue(days.fri)
									});
							case 'sat':
								return _Utils_update(
									days,
									{
										sat: newDayValue(days.sat)
									});
							case 'sun':
								return _Utils_update(
									days,
									{
										sun: newDayValue(days.sun)
									});
							default:
								return days;
						}
					} else {
						return {fri: $author$project$Data$Location$OpenHours$Closed, mon: $author$project$Data$Location$OpenHours$Closed, sat: $author$project$Data$Location$OpenHours$Closed, sun: $author$project$Data$Location$OpenHours$Closed, thu: $author$project$Data$Location$OpenHours$Closed, tue: $author$project$Data$Location$OpenHours$Closed, wed: $author$project$Data$Location$OpenHours$Closed};
					}
				}();
				var newOpenHours = A3($author$project$Location$Details$PopupContent$OpenHours$updateDayDifferentState, model.openHours, stringDay, newDays);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'UpdateHourSet':
				var stringSpanType = msg.a;
				var shortDay = msg.b;
				var spanIndex = msg.c;
				var dayState = msg.d;
				var newText = msg.e;
				var validNumericValue = F2(
					function (fallback, value) {
						return ((value !== '') && (($elm$core$String$length(value) > 4) || _Utils_eq(
							$elm$core$String$toInt(value),
							$elm$core$Maybe$Nothing))) ? fallback : value;
					});
				var newSpanList = function () {
					if (dayState.$ === 'Open') {
						var spanList = dayState.a;
						return A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, span) {
									return _Utils_eq(index, spanIndex) ? ((stringSpanType === 'open') ? {
										open: A2(validNumericValue, span.open, newText),
										close: span.close
									} : {
										open: span.open,
										close: A2(validNumericValue, span.close, newText)
									}) : span;
								}),
							spanList);
					} else {
						return _List_fromArray(
							[
								{open: '0800', close: '1700'}
							]);
					}
				}();
				var newOpenHours = A3(
					$author$project$Location$Details$PopupContent$OpenHours$updateDaySameState,
					model.openHours,
					shortDay,
					$author$project$Data$Location$OpenHours$Open(newSpanList));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveDaySpanByIndex':
				var spanIndex = msg.a;
				var day = msg.b;
				var removeState = function (dayState) {
					if (dayState.$ === 'Open') {
						var spanList = dayState.a;
						return $author$project$Data$Location$OpenHours$Open(
							A2(
								$elm$core$List$append,
								A2($elm$core$List$take, spanIndex, spanList),
								A2($elm$core$List$drop, spanIndex + 1, spanList)));
					} else {
						return dayState;
					}
				};
				var newDays = function () {
					var _v6 = model.openHours;
					if (_v6.$ === 'During') {
						var days = _v6.a;
						switch (day) {
							case 'mon':
								return _Utils_update(
									days,
									{
										mon: removeState(days.mon)
									});
							case 'tue':
								return _Utils_update(
									days,
									{
										tue: removeState(days.tue)
									});
							case 'wed':
								return _Utils_update(
									days,
									{
										wed: removeState(days.wed)
									});
							case 'thu':
								return _Utils_update(
									days,
									{
										thu: removeState(days.thu)
									});
							case 'fri':
								return _Utils_update(
									days,
									{
										fri: removeState(days.fri)
									});
							case 'sat':
								return _Utils_update(
									days,
									{
										sat: removeState(days.sat)
									});
							case 'sun':
								return _Utils_update(
									days,
									{
										sun: removeState(days.sun)
									});
							default:
								return days;
						}
					} else {
						return {fri: $author$project$Data$Location$OpenHours$Closed, mon: $author$project$Data$Location$OpenHours$Closed, sat: $author$project$Data$Location$OpenHours$Closed, sun: $author$project$Data$Location$OpenHours$Closed, thu: $author$project$Data$Location$OpenHours$Closed, tue: $author$project$Data$Location$OpenHours$Closed, wed: $author$project$Data$Location$OpenHours$Closed};
					}
				}();
				var newOpenHours = A3($author$project$Location$Details$PopupContent$OpenHours$updateDayDifferentState, model.openHours, day, newDays);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'AddSpanToDay':
				var shortDay = msg.a;
				var dayState = msg.b;
				var newSpanList = function () {
					if (dayState.$ === 'Open') {
						var spanList = dayState.a;
						return ($elm$core$List$length(spanList) < 3) ? A2(
							$elm$core$List$append,
							spanList,
							$elm$core$List$singleton(
								{open: '0800', close: '1700'})) : spanList;
					} else {
						return _List_Nil;
					}
				}();
				var newOpenHours = A3(
					$author$project$Location$Details$PopupContent$OpenHours$updateDaySameState,
					model.openHours,
					shortDay,
					$author$project$Data$Location$OpenHours$Open(newSpanList));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Details$PopupContent$Categories$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Location$Details$PopupContent$Categories$UiSelectMsg, msg_, model.uiSelect));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								allCategories: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'SelectPrimaryCategory':
				var category = msg.a;
				var list = $author$project$Location$Details$PopupContent$Categories$convertToCategories(model.additionalCategories);
				return A2($elm$core$List$member, category, list) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							primaryCategory: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectAdditionalCategory':
				var category = msg.a;
				var selectedCategories = A2($author$project$Location$Details$PopupContent$Categories$getSelectedCategories, model.primaryCategory, model.additionalCategories);
				var hasMaxSelected = A2(
					$author$project$Location$Details$PopupContent$Categories$hasMaxNumberOfAdditionalCategories,
					$elm$core$List$length(model.additionalCategories),
					model.network);
				var newRemovable = (A2($elm$core$List$member, category, selectedCategories) || hasMaxSelected) ? model.additionalCategories : _Utils_ap(
					model.additionalCategories,
					_List_fromArray(
						[
							{category: category, pendingRemoval: false}
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{additionalCategories: newRemovable}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				var updatedList = A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, additionalCategory) {
							return _Utils_eq(i, index) ? {category: additionalCategory.category, pendingRemoval: true} : additionalCategory;
						}),
					model.additionalCategories);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{additionalCategories: updatedList}),
					$elm$core$Platform$Cmd$none);
			case 'RemovePendingCategories':
				var newList = A2(
					$elm$core$List$filter,
					function (removableCategory) {
						return !removableCategory.pendingRemoval;
					},
					model.additionalCategories);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{additionalCategories: newList}),
					$elm$core$Platform$Cmd$none);
			default:
				var newList = A2(
					$elm$core$List$map,
					function (removableCategory) {
						return _Utils_update(
							removableCategory,
							{pendingRemoval: false});
					},
					model.additionalCategories);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{additionalCategories: newList}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Details$PopupContent$OpenStatus$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'SelectOption':
				var choice = msg.a;
				return _Utils_update(
					model,
					{choice: choice});
			case 'UpdateClosedFrom':
				var date = msg.a;
				var currentUntilPosix = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, model.now, $author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix, model.selectedUntilDate);
				var minUntilPosix = A2(
					$author$project$Location$Details$PopupContent$TemporarilyClosed$addDaysToPosix,
					7,
					$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(date));
				var newUntil = (_Utils_cmp(
					$elm$time$Time$posixToMillis(currentUntilPosix),
					$elm$time$Time$posixToMillis(minUntilPosix)) > -1) ? model.selectedUntilDate : $elm$core$Maybe$Nothing;
				return _Utils_update(
					model,
					{
						selectedFromDate: $elm$core$Maybe$Just(date),
						selectedUntilDate: newUntil
					});
			case 'UpdateReopensOn':
				var date = msg.a;
				return _Utils_update(
					model,
					{
						selectedUntilDate: $elm$core$Maybe$Just(date)
					});
			case 'UpdateClosesOn':
				var date = msg.a;
				return _Utils_update(
					model,
					{
						selectedClosesOnDate: $elm$core$Maybe$Just(date)
					});
			default:
				return model;
		}
	});
var $author$project$PinMeTo$Ui$TemplateTags$update = F3(
	function (tagger, _v0, _v1) {
		var msg = _v0.a;
		var state = _v1.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$PinMeTo$Ui$TemplateTags$State,
			A3(
				$author$project$PinMeTo$Ui$PopOver$update,
				A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$TemplateTags$PopOverMsg, tagger),
				msg,
				state));
	});
var $author$project$Location$Details$PopupContent$ActionLinks$urlPattern = '^((https|http):\u005C/\u005C/)?([a-zA-Z0-9]+[a-zA-Z0-9\u005C.-]*[a-zA-Z0-9]+|[a-zA-Z0-9])\u005C.[a-zA-Z0-9]{2,}(((\u005C/|\u005C?|\u005C/\u005C?)[\u005Cs\u005CS]*[\u005Cw\u005CW]*[\u005Cd\u005CD]*)*)$';
var $author$project$Location$Details$PopupContent$ActionLinks$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString($author$project$Location$Details$PopupContent$ActionLinks$urlPattern));
var $author$project$Location$Details$PopupContent$ActionLinks$validUrl = function (url) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Location$Details$PopupContent$ActionLinks$urlRegex,
		$author$project$Location$Details$PopupContent$ActionLinks$toSslUrl(url));
};
var $author$project$Location$Details$PopupContent$ActionLinks$InvalidUrl = {$: 'InvalidUrl'};
var $author$project$Location$Details$PopupContent$ActionLinks$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UrlChanged':
				var type_ = msg.a;
				var url = msg.b;
				var error = ((url === '') || $author$project$Location$Details$PopupContent$ActionLinks$validUrl(url)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Location$Details$PopupContent$ActionLinks$InvalidUrl);
				var rows = A2(
					$elm$core$List$map,
					function (row) {
						return _Utils_eq(row.type_, type_) ? _Utils_update(
							row,
							{url: url, error: error}) : row;
					},
					model.rows);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rows: rows}),
					$elm$core$Platform$Cmd$none);
			case 'PreferredChanged':
				var preferred = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{preferred: preferred}),
					$elm$core$Platform$Cmd$none);
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (state) {
						return _Utils_update(
							model,
							{uiSelect: state});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Location$Details$PopupContent$ActionLinks$UiSelectMsg, msg_, model.uiSelect));
			case 'TemplateTagsMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (state) {
						return _Utils_update(
							model,
							{templateTagsState: state});
					},
					A3($author$project$PinMeTo$Ui$TemplateTags$update, $author$project$Location$Details$PopupContent$ActionLinks$TemplateTagsMsg, msg_, model.templateTagsState));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Details$PopupContent$Coordinates$pattern = '^([+-]?([0-9]*[.])?[0-9]*)$';
var $author$project$Location$Details$PopupContent$Coordinates$maybeRegex = $elm$regex$Regex$fromString($author$project$Location$Details$PopupContent$Coordinates$pattern);
var $author$project$Location$Details$PopupContent$Coordinates$regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $author$project$Location$Details$PopupContent$Coordinates$maybeRegex);
var $author$project$Location$Details$PopupContent$Coordinates$replaceInvalidCharacters = function (coordinate) {
	var charList = $elm$core$String$toList(coordinate);
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_char, acc) {
				return A2(
					$elm$regex$Regex$contains,
					$author$project$Location$Details$PopupContent$Coordinates$regex,
					_Utils_ap(_char, acc)) ? _Utils_ap(acc, _char) : (acc + '');
			}),
		'',
		A2($elm$core$List$map, $elm$core$String$fromChar, charList));
};
var $author$project$Location$Details$PopupContent$Coordinates$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateLatFromInput':
				var lat = msg.a;
				var coordinates = function () {
					var _v2 = model.coordinates;
					if (_v2.$ === 'ValidCooridnates') {
						var coordinates_ = _v2.a;
						return coordinates_;
					} else {
						var coordinates_ = _v2.a;
						return coordinates_;
					}
				}();
				var newLat = A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$Coordinates$regex, lat) ? lat : $author$project$Location$Details$PopupContent$Coordinates$replaceInvalidCharacters(lat);
				var floatLat = function () {
					var _v1 = $elm$core$String$toFloat(newLat);
					if (_v1.$ === 'Just') {
						var value = _v1.a;
						return value;
					} else {
						return coordinates.lat;
					}
				}();
				var newCoordinates = {lat: floatLat, lon: coordinates.lon};
				var coordinatesAsString = {lat: newLat, lon: model.coordinatesAsString.lon};
				return _Utils_update(
					model,
					{
						coordinates: A2($author$project$Data$ValidatedCoordinates$create, model.translations, newCoordinates),
						coordinatesAsString: coordinatesAsString
					});
			case 'UpdateLonFromInput':
				var lon = msg.a;
				var coordinates = function () {
					var _v4 = model.coordinates;
					if (_v4.$ === 'ValidCooridnates') {
						var coordinates_ = _v4.a;
						return coordinates_;
					} else {
						var coordinates_ = _v4.a;
						return coordinates_;
					}
				}();
				var newLon = A2($elm$regex$Regex$contains, $author$project$Location$Details$PopupContent$Coordinates$regex, lon) ? lon : $author$project$Location$Details$PopupContent$Coordinates$replaceInvalidCharacters(lon);
				var floatLon = function () {
					var _v3 = $elm$core$String$toFloat(newLon);
					if (_v3.$ === 'Just') {
						var value = _v3.a;
						return value;
					} else {
						return coordinates.lon;
					}
				}();
				var newCoordinates = {lat: coordinates.lat, lon: floatLon};
				var coordinatesAsString = {lat: model.coordinatesAsString.lat, lon: newLon};
				return _Utils_update(
					model,
					{
						coordinates: A2($author$project$Data$ValidatedCoordinates$create, model.translations, newCoordinates),
						coordinatesAsString: coordinatesAsString
					});
			default:
				var coordinates = msg.b;
				return _Utils_update(
					model,
					{
						coordinates: A2($author$project$Data$ValidatedCoordinates$create, model.translations, coordinates),
						coordinatesAsString: {
							lat: $elm$core$String$fromFloat(coordinates.lat),
							lon: $elm$core$String$fromFloat(coordinates.lon)
						}
					});
		}
	});
var $author$project$Location$Details$PopupContent$OpeningDate$dateToPosix = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		{
			day: $justinmimbs$date$Date$day(date),
			hour: 0,
			year: $justinmimbs$date$Date$year(date),
			month: $justinmimbs$date$Date$month(date),
			minute: 0,
			second: 0,
			millisecond: 0
		});
};
var $author$project$Location$Details$PopupContent$OpeningDate$update = F2(
	function (msg, model) {
		var date = msg.a;
		return _Utils_update(
			model,
			{
				openingDate: $elm$core$Maybe$Just(
					$author$project$Location$Details$PopupContent$OpeningDate$dateToPosix(date)),
				selectedDate: $elm$core$Maybe$Just(date)
			});
	});
var $author$project$Location$Details$PopupContent$CustomNameOnNetwork$update = F2(
	function (msg, model) {
		var customValue = msg.a;
		return _Utils_update(
			model,
			{
				customName: A2($author$project$Data$ValidatedCustomNameOnNetwork$create, model.translations, customValue)
			});
	});
var $author$project$Data$Location$StorefrontName = function (a) {
	return {$: 'StorefrontName', a: a};
};
var $author$project$Location$Details$PopupContent$StorefrontName$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateStorefrontName':
				var value = msg.a;
				return $author$project$Common$Validators$CsvInjection$isInputValid(value) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							storefrontName: $author$project$Data$Location$StorefrontName(value),
							storefrontNameString: value
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'GoogleCustomNameMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							googleCustomName: A2($author$project$Location$Details$PopupContent$CustomNameOnNetwork$update, msg_, model.googleCustomName)
						}),
					$elm$core$Platform$Cmd$none);
			case 'FacebookCustomNameMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							facebookCustomName: A2($author$project$Location$Details$PopupContent$CustomNameOnNetwork$update, msg_, model.facebookCustomName)
						}),
					$elm$core$Platform$Cmd$none);
			case 'AppleCustomNameMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							appleCustomName: A2($author$project$Location$Details$PopupContent$CustomNameOnNetwork$update, msg_, model.appleCustomName)
						}),
					$elm$core$Platform$Cmd$none);
			case 'PtvCustomNameMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ptvCustomName: A2($author$project$Location$Details$PopupContent$CustomNameOnNetwork$update, msg_, model.ptvCustomName)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var popMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (state) {
						return _Utils_update(
							model,
							{popOverState: state});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Location$Details$PopupContent$StorefrontName$PopOverMsg, popMsg, model.popOverState));
		}
	});
var $author$project$PinMeTo$Ui$Form$Textarea$update = F2(
	function (msg, _v0) {
		update:
		while (true) {
			var model = _v0.a;
			switch (msg.$) {
				case 'OnSelectionChange':
					var selection = msg.a;
					return $author$project$PinMeTo$Ui$Form$Textarea$State(
						_Utils_update(
							model,
							{selection: selection}));
				case 'OnAutocomplete':
					var x = msg.a;
					if (x.$ === 'Just') {
						var _v3 = x.a;
						var query = _v3.a;
						var range = _v3.b;
						var caret = _v3.c;
						return $author$project$PinMeTo$Ui$Form$Textarea$State(
							_Utils_update(
								model,
								{
									caret: caret,
									activeAutocompleteValue: $elm$core$Maybe$Just(
										{end: range.end, start: range.start, value: query})
								}));
					} else {
						return $author$project$PinMeTo$Ui$Form$Textarea$State(
							_Utils_update(
								model,
								{activeAutocompleteValue: $elm$core$Maybe$Nothing}));
					}
				default:
					var replacements = msg.a;
					var msg_ = msg.b;
					var replacementsCount = $elm$core$List$length(replacements);
					var currentIndex = A2(
						$elm$core$Basics$min,
						model.replacementSelectedIndex,
						$elm$core$List$length(replacements) - 1);
					switch (msg_.$) {
						case 'AutocompleteSubmit':
							var $temp$msg = A2(
								$author$project$PinMeTo$Ui$Form$Textarea$AutocompleteViewMsg,
								replacements,
								$author$project$PinMeTo$Ui$Form$Textarea$AutocompleteSelect(currentIndex)),
								$temp$_v0 = $author$project$PinMeTo$Ui$Form$Textarea$State(model);
							msg = $temp$msg;
							_v0 = $temp$_v0;
							continue update;
						case 'AutocompleteSelect':
							var index = msg_.a;
							var selectedIndex = A2(
								$elm$core$Basics$min,
								index,
								$elm$core$List$length(replacements) - 1);
							var replacementSelected = $elm$core$List$head(
								A2($elm$core$List$drop, selectedIndex, replacements));
							var paste = function (model_) {
								return A2(
									$elm$core$Maybe$withDefault,
									model_,
									A3(
										$elm$core$Maybe$map2,
										F2(
											function (autocompleteValue, replacement) {
												return _Utils_update(
													model_,
													{
														paste: A2(
															$elm$core$List$cons,
															{
																value: replacement.replacement,
																selection: $elm$core$Maybe$Just(
																	A2($author$project$PinMeTo$Ui$Form$Textarea$Selection, autocompleteValue.start, autocompleteValue.end)),
																selectPastedText: false
															},
															model_.paste)
													});
											}),
										model.activeAutocompleteValue,
										replacementSelected));
							};
							return $author$project$PinMeTo$Ui$Form$Textarea$State(
								paste(
									_Utils_update(
										model,
										{activeAutocompleteValue: $elm$core$Maybe$Nothing})));
						case 'AutocompleteSelectPrevious':
							return $author$project$PinMeTo$Ui$Form$Textarea$State(
								_Utils_update(
									model,
									{
										replacementSelectedIndex: A2($elm$core$Basics$max, 0, currentIndex - 1)
									}));
						default:
							return $author$project$PinMeTo$Ui$Form$Textarea$State(
								_Utils_update(
									model,
									{
										replacementSelectedIndex: A2($elm$core$Basics$min, replacementsCount - 1, currentIndex + 1)
									}));
					}
			}
		}
	});
var $author$project$Location$Details$PopupContent$LongDescription$update = F2(
	function (msg, model) {
		if (msg.$ === 'UpdateLongDescription') {
			var value = msg.a.a;
			return _Utils_update(
				model,
				{
					longDescription: A2($author$project$Data$ValidatedLongDescription$create, model.translations, value)
				});
		} else {
			var msg_ = msg.a;
			return _Utils_update(
				model,
				{
					uiTextareaState: A2($author$project$PinMeTo$Ui$Form$Textarea$update, msg_, model.uiTextareaState)
				});
		}
	});
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$Data$NetworkData$SocialUrlValidation$errorsDecoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string));
var $author$project$Data$NetworkData$SocialUrlValidation$encodeUrlAttribute = function (attribute) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'attributeId',
				$elm$json$Json$Encode$string(attribute.attributeId)),
				_Utils_Tuple2(
				'values',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					_List_fromArray(
						[attribute.value])))
			]));
};
var $author$project$Data$NetworkData$SocialUrlValidation$validateUrls = F3(
	function (_v0, attributes, tagger) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, tagger, $author$project$Data$NetworkData$SocialUrlValidation$errorsDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'attributes',
								A2($elm$json$Json$Encode$list, $author$project$Data$NetworkData$SocialUrlValidation$encodeUrlAttribute, attributes))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/google/attributes/validate')))));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$urlFieldValues = function (fields) {
	return A2(
		$elm$core$List$map,
		function (field) {
			return {value: field.value, attributeId: field.attribute.attributeId};
		},
		fields);
};
var $author$project$Location$Details$PopupContent$SocialMessaging$OnUrlsValidated = function (a) {
	return {$: 'OnUrlsValidated', a: a};
};
var $author$project$Location$Details$PopupContent$SocialMessaging$UrlDebouncerMsg = function (a) {
	return {$: 'UrlDebouncerMsg', a: a};
};
var $author$project$Location$Details$PopupContent$SocialMessaging$updateFieldValue = F3(
	function (attributeId, value, fields) {
		return A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_eq(field.attribute.attributeId, attributeId) ? _Utils_update(
					field,
					{value: value}) : field;
			},
			fields);
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$mergeFetchedAttributes = F2(
	function (attributes, existingFields) {
		return A2(
			$elm$core$List$map,
			function (attribute) {
				return {
					value: A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.value;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (field) {
										return _Utils_eq(field.attribute.attributeId, attribute.attributeId);
									},
									existingFields)))),
					attribute: attribute,
					selectState: $author$project$PinMeTo$Ui$Select$init
				};
			},
			A2($elm$core$List$filter, $author$project$Location$Details$PopupContent$SocialMessaging$isSocialGroup, attributes));
	});
var $author$project$Location$Details$PopupContent$SocialMessaging$update = F3(
	function (siteName, msg, model) {
		switch (msg.$) {
			case 'OnAvailableAttributesFetched':
				if (msg.a.$ === 'Ok') {
					var googleAttributes = msg.a.a;
					var fields = A2($author$project$Location$Details$PopupContent$SocialMessaging$mergeFetchedAttributes, googleAttributes.attributes, model.fields);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fields: fields,
								initial: A2(
									$elm$core$Dict$union,
									model.initial,
									$author$project$Location$Details$PopupContent$SocialMessaging$fieldValuesDict(fields)),
								loading: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{loading: false}),
						$elm$core$Platform$Cmd$none);
				}
			case 'SetValue':
				var attributeId = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fields: A3($author$project$Location$Details$PopupContent$SocialMessaging$updateFieldValue, attributeId, value, model.fields),
							validatingUrls: true
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Location$Details$PopupContent$SocialMessaging$UrlDebouncerMsg,
						$author$project$Common$Debouncer$trigger(_Utils_Tuple0)));
			case 'SelectEnum':
				var attributeId = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fields: A3($author$project$Location$Details$PopupContent$SocialMessaging$updateFieldValue, attributeId, value, model.fields)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UiSelectMsg':
				var attributeId = msg.a;
				var msg_ = msg.b;
				var updateField = function (field) {
					return _Utils_eq(field.attribute.attributeId, attributeId) ? A2(
						$elm$core$Tuple$mapFirst,
						function (state) {
							return _Utils_update(
								field,
								{selectState: state});
						},
						A3(
							$author$project$PinMeTo$Ui$Select$update,
							$author$project$Location$Details$PopupContent$SocialMessaging$UiSelectMsg(attributeId),
							msg_,
							field.selectState)) : _Utils_Tuple2(field, $elm$core$Platform$Cmd$none);
				};
				var _v1 = $elm$core$List$unzip(
					A2($elm$core$List$map, updateField, model.fields));
				var fields = _v1.a;
				var cmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fields: fields}),
					$elm$core$Platform$Cmd$batch(cmds));
			case 'UrlDebouncerMsg':
				var debouncerMsg = msg.a;
				var _v2 = A2($author$project$Common$Debouncer$update, debouncerMsg, model.urlDebouncer);
				var newDebouncer = _v2.a;
				var debouncerCmd = _v2.b;
				var timedOut = _v2.c;
				var validateCmd = function () {
					if (timedOut.$ === 'Just') {
						return A3(
							$author$project$Data$NetworkData$SocialUrlValidation$validateUrls,
							siteName,
							$author$project$Location$Details$PopupContent$SocialMessaging$urlFieldValues(model.fields),
							$author$project$Location$Details$PopupContent$SocialMessaging$OnUrlsValidated);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{urlDebouncer: newDebouncer}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$PopupContent$SocialMessaging$UrlDebouncerMsg, debouncerCmd),
								validateCmd
							])));
			default:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							urlErrors: A2($elm$core$Result$withDefault, model.urlErrors, result),
							validatingUrls: false
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$ManuallyAdded = {$: 'ManuallyAdded'};
var $author$project$Location$Details$PopupContent$GoogleAttributes$updateRowValue = F3(
	function (rowId, newValue, rows) {
		return A2(
			$elm$core$List$map,
			function (r) {
				return _Utils_eq(r.id, rowId) ? _Utils_update(
					r,
					{value: newValue}) : r;
			},
			rows);
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$OnUrlsValidated = function (a) {
	return {$: 'OnUrlsValidated', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$UrlDebouncerMsg = function (a) {
	return {$: 'UrlDebouncerMsg', a: a};
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$toggleRepeatedEnum = F4(
	function (rowId, val, isSet, row) {
		if (!_Utils_eq(row.id, rowId)) {
			return row;
		} else {
			var _v0 = row.value;
			if (_v0.$ === 'RepeatedEnumValue') {
				var repeatedEnum = _v0.a;
				var newValue = isSet ? (A2($elm$core$List$member, val, repeatedEnum.setValues) ? $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
					_Utils_update(
						repeatedEnum,
						{
							setValues: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(val),
								repeatedEnum.setValues)
						})) : $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
					{
						setValues: _Utils_ap(
							repeatedEnum.setValues,
							_List_fromArray(
								[val])),
						unsetValues: A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(val),
							repeatedEnum.unsetValues)
					})) : (A2($elm$core$List$member, val, repeatedEnum.unsetValues) ? $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
					_Utils_update(
						repeatedEnum,
						{
							unsetValues: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(val),
								repeatedEnum.unsetValues)
						})) : $author$project$Location$Details$PopupContent$GoogleAttributes$RepeatedEnumValue(
					{
						setValues: A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(val),
							repeatedEnum.setValues),
						unsetValues: _Utils_ap(
							repeatedEnum.unsetValues,
							_List_fromArray(
								[val]))
					}));
				return _Utils_update(
					row,
					{value: newValue});
			} else {
				return row;
			}
		}
	});
var $author$project$Location$Details$PopupContent$GoogleAttributes$urlAttributeValues = function (rows) {
	return A2(
		$elm$core$List$filterMap,
		function (row) {
			var _v0 = row.value;
			if (_v0.$ === 'UrlValue') {
				var val = _v0.a;
				return $elm$core$Maybe$Just(
					{value: val, attributeId: row.selectedAttribute.attributeId});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		rows);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$update = F3(
	function (siteName, msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnAvailableAttributesFetched':
				if (msg.a.$ === 'Ok') {
					var googleAttributes = msg.a.a;
					var stillAvailable = function (row) {
						return A2(
							$elm$core$List$any,
							function (a) {
								return _Utils_eq(a.attributeId, row.selectedAttribute.attributeId);
							},
							googleAttributes.attributes);
					};
					var rows = $author$project$Location$Details$PopupContent$GoogleAttributes$renumberRows(
						A2(
							$author$project$Location$Details$PopupContent$GoogleAttributes$withAlwaysShownRows,
							googleAttributes.attributes,
							A2($elm$core$List$filter, stillAvailable, model.rows)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								rows: rows,
								nextId: $elm$core$List$length(rows),
								loading: false,
								availableAttributes: googleAttributes.attributes
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{loading: false}),
						$elm$core$Platform$Cmd$none);
				}
			case 'AddAttribute':
				var attribute = msg.a;
				var newRow = {
					id: model.nextId,
					value: $author$project$Location$Details$PopupContent$GoogleAttributes$defaultValueForType(attribute.valueType),
					origin: $author$project$Location$Details$PopupContent$GoogleAttributes$ManuallyAdded,
					selectedAttribute: attribute,
					uiSelectValueState: $author$project$PinMeTo$Ui$Select$init
				};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: _Utils_ap(
								model.rows,
								_List_fromArray(
									[newRow])),
							nextId: model.nextId + 1
						}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveRow':
				var rowId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$filter,
								function (r) {
									return (!_Utils_eq(r.id, rowId)) || (!_Utils_eq(r.origin, $author$project$Location$Details$PopupContent$GoogleAttributes$ManuallyAdded));
								},
								model.rows)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SetBoolValue':
				var rowId = msg.a;
				var val = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A3(
								$author$project$Location$Details$PopupContent$GoogleAttributes$updateRowValue,
								rowId,
								$author$project$Location$Details$PopupContent$GoogleAttributes$BoolValue(val),
								model.rows)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SetEnumValue':
				var rowId = msg.a;
				var val = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A3(
								$author$project$Location$Details$PopupContent$GoogleAttributes$updateRowValue,
								rowId,
								$author$project$Location$Details$PopupContent$GoogleAttributes$EnumValue(val),
								model.rows)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SetUrlValue':
				var rowId = msg.a;
				var val = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A3(
								$author$project$Location$Details$PopupContent$GoogleAttributes$updateRowValue,
								rowId,
								$author$project$Location$Details$PopupContent$GoogleAttributes$UrlValue(val),
								model.rows),
							validatingUrls: true
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Location$Details$PopupContent$GoogleAttributes$UrlDebouncerMsg,
						$author$project$Common$Debouncer$trigger(_Utils_Tuple0)));
			case 'ToggleRepeatedEnumSetValue':
				var rowId = msg.a;
				var val = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$map,
								A3($author$project$Location$Details$PopupContent$GoogleAttributes$toggleRepeatedEnum, rowId, val, true),
								model.rows)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleRepeatedEnumUnsetValue':
				var rowId = msg.a;
				var val = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rows: A2(
								$elm$core$List$map,
								A3($author$project$Location$Details$PopupContent$GoogleAttributes$toggleRepeatedEnum, rowId, val, false),
								model.rows)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UiSelectAddMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (s) {
						return _Utils_update(
							model,
							{addSelectState: s});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectAddMsg, msg_, model.addSelectState));
			case 'UiSelectValueMsg':
				var rowId = msg.a;
				var msg_ = msg.b;
				var updateRow = function (row) {
					return _Utils_eq(row.id, rowId) ? A2(
						$elm$core$Tuple$mapFirst,
						function (s) {
							return _Utils_update(
								row,
								{uiSelectValueState: s});
						},
						A3(
							$author$project$PinMeTo$Ui$Select$update,
							$author$project$Location$Details$PopupContent$GoogleAttributes$UiSelectValueMsg(rowId),
							msg_,
							row.uiSelectValueState)) : _Utils_Tuple2(row, $elm$core$Platform$Cmd$none);
				};
				var _v1 = $elm$core$List$unzip(
					A2($elm$core$List$map, updateRow, model.rows));
				var updatedRows = _v1.a;
				var cmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{rows: updatedRows}),
					$elm$core$Platform$Cmd$batch(cmds));
			case 'UrlDebouncerMsg':
				var debouncerMsg = msg.a;
				var _v2 = A2($author$project$Common$Debouncer$update, debouncerMsg, model.urlDebouncer);
				var newDebouncer = _v2.a;
				var debouncerCmd = _v2.b;
				var timedOut = _v2.c;
				var validateCmd = function () {
					if (timedOut.$ === 'Just') {
						return A3(
							$author$project$Data$NetworkData$SocialUrlValidation$validateUrls,
							siteName,
							$author$project$Location$Details$PopupContent$GoogleAttributes$urlAttributeValues(model.rows),
							$author$project$Location$Details$PopupContent$GoogleAttributes$OnUrlsValidated);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{urlDebouncer: newDebouncer}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$PopupContent$GoogleAttributes$UrlDebouncerMsg, debouncerCmd),
								validateCmd
							])));
			default:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							urlErrors: A2($elm$core$Result$withDefault, model.urlErrors, result),
							validatingUrls: false
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Location$ShortDescription = function (a) {
	return {$: 'ShortDescription', a: a};
};
var $author$project$Location$Details$PopupContent$ShortDescription$update = F2(
	function (msg, model) {
		if (msg.$ === 'UpdateShortDescription') {
			var value = msg.a;
			return _Utils_update(
				model,
				{
					shortDescription: $author$project$Data$Location$ShortDescription(value),
					shortDescriptionString: value
				});
		} else {
			var msg_ = msg.a;
			return _Utils_update(
				model,
				{
					uiTextareaState: A2($author$project$PinMeTo$Ui$Form$Textarea$update, msg_, model.uiTextareaState)
				});
		}
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$EditSpan = F3(
	function (a, b, c) {
		return {$: 'EditSpan', a: a, b: b, c: c};
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$removeDuplicates = function (list) {
	if (!list.b) {
		return _List_Nil;
	} else {
		var head = list.a;
		var tail = list.b;
		var restWithoutDuplicates = $author$project$Location$Details$PopupContent$SpecialOpenHours$removeDuplicates(
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(head),
				tail));
		return A2($elm$core$List$cons, head, restWithoutDuplicates);
	}
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend = F2(
	function (model, listOrigin) {
		return _Utils_eq(model.tab, $author$project$Location$Details$PopupContent$SpecialOpenHours$Upcoming) ? $author$project$Location$Details$PopupContent$SpecialOpenHours$removeDuplicates(
			A3(
				$elm$core$List$foldr,
				$elm$core$List$cons,
				$elm$core$List$reverse(
					A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, $author$project$Location$Details$PopupContent$SpecialOpenHours$Past, model)),
				listOrigin)) : listOrigin;
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$SuccessTimeout = {$: 'SuccessTimeout'};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$WarningTimeout = {$: 'WarningTimeout'};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$NoticeDisappear = function (a) {
	return {$: 'NoticeDisappear', a: a};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimer = F2(
	function (time, notice) {
		switch (notice.$) {
			case 'Success':
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						$author$project$Location$Details$PopupContent$SpecialOpenHours$NoticeDisappear($author$project$Location$Details$PopupContent$SpecialOpenHours$SuccessTimeout)),
					$elm$core$Process$sleep(time));
			case 'Warning':
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						$author$project$Location$Details$PopupContent$SpecialOpenHours$NoticeDisappear($author$project$Location$Details$PopupContent$SpecialOpenHours$WarningTimeout)),
					$elm$core$Process$sleep(time));
			default:
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						$author$project$Location$Details$PopupContent$SpecialOpenHours$NoticeDisappear($author$project$Location$Details$PopupContent$SpecialOpenHours$None)),
					$elm$core$Process$sleep(time));
		}
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$ChangeClosed = function (a) {
	return {$: 'ChangeClosed', a: a};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$EditDescription = function (a) {
	return {$: 'EditDescription', a: a};
};
var $author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimeValue = 3500;
var $author$project$Location$Details$PopupContent$SpecialOpenHours$deleteDatesBeforeToday = F2(
	function (model, list) {
		return A2(
			$elm$core$List$filter,
			function (record) {
				return A2($author$project$Location$Details$PopupContent$SpecialOpenHours$isDateFromTodayOnwards, model, record.date);
			},
			list);
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$update = F2(
	function (msg, model) {
		var newRecordRemovingSpan = F2(
			function (index, record) {
				var newSpanList = A2(
					$elm$core$List$append,
					A2($elm$core$List$take, index, record.spans),
					A2($elm$core$List$drop, index + 1, record.spans));
				return _Utils_update(
					record,
					{spans: newSpanList});
			});
		var newRecordEditingSpan = F4(
			function (index, stringSpanType, newSpanText, record) {
				var validNumericValue = F2(
					function (fallback, value) {
						return ((value !== '') && (($elm$core$String$length(value) > 4) || _Utils_eq(
							$elm$core$String$toInt(value),
							$elm$core$Maybe$Nothing))) ? fallback : value;
					});
				var newSpanList = A2(
					$elm$core$List$indexedMap,
					F2(
						function (innerIndex, span) {
							return _Utils_eq(innerIndex, index) ? ((stringSpanType === 'open') ? {
								open: A2(validNumericValue, span.open, newSpanText),
								close: span.close
							} : {
								open: span.open,
								close: A2(validNumericValue, span.close, newSpanText)
							}) : span;
						}),
					record.spans);
				return _Utils_update(
					record,
					{spans: newSpanList});
			});
		var defaultSpan = {open: '0800', close: '1700'};
		var newRecordAddingSpan = function (record) {
			var newSpanList = ($elm$core$List$length(record.spans) < 2) ? A2(
				$elm$core$List$append,
				record.spans,
				$elm$core$List$singleton(defaultSpan)) : record.spans;
			return _Utils_update(
				record,
				{spans: newSpanList});
		};
		var newRecordChangingClosed = F2(
			function (isClosed, record) {
				var _v3 = isClosed ? _Utils_Tuple2($author$project$Data$Location$SpecialOpenHours$Closed, _List_Nil) : _Utils_Tuple2(
					$author$project$Data$Location$SpecialOpenHours$Open(defaultSpan),
					$elm$core$List$singleton(defaultSpan));
				var newState = _v3.a;
				var newSpanList = _v3.b;
				return _Utils_update(
					record,
					{spans: newSpanList, state: newState});
			});
		var generateNewList = F3(
			function (list, dateToChange, action) {
				return A2(
					$elm$core$List$map,
					function (record) {
						if (_Utils_eq(
							record.date,
							$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(dateToChange))) {
							switch (action.$) {
								case 'RemoveSpan':
									var spanIndex = action.a;
									return A2(newRecordRemovingSpan, spanIndex, record);
								case 'AddSpan':
									return newRecordAddingSpan(record);
								case 'EditDescription':
									var newDescription = action.a;
									return _Utils_update(
										record,
										{
											label: $elm$core$Maybe$Just(newDescription)
										});
								case 'ChangeClosed':
									var isClosedChecked = action.a;
									return A2(newRecordChangingClosed, isClosedChecked, record);
								default:
									var openOrCloseString = action.a;
									var spanIndex = action.b;
									var stringValue = action.c;
									return A4(newRecordEditingSpan, spanIndex, openOrCloseString, stringValue, record);
							}
						} else {
							return record;
						}
					},
					list);
			});
		switch (msg.$) {
			case 'OnDateSelected':
				var index = msg.a;
				var inTheList = msg.b;
				var newDate = msg.c;
				var posixDate = $author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(newDate);
				var triggerWarning = A2(
					$author$project$Location$Details$PopupContent$SpecialOpenHours$isDateInList,
					A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model),
					posixDate);
				var highlightDate = (!triggerWarning) ? $author$project$Location$Details$PopupContent$SpecialOpenHours$Success(index) : $author$project$Location$Details$PopupContent$SpecialOpenHours$None;
				var noticeWarning = triggerWarning ? $author$project$Location$Details$PopupContent$SpecialOpenHours$Warning : $author$project$Location$Details$PopupContent$SpecialOpenHours$None;
				var newModel = function () {
					if (inTheList) {
						var updatedList = A2(
							$elm$core$List$indexedMap,
							F2(
								function (innerIndex, record) {
									return _Utils_eq(innerIndex, index) ? (triggerWarning ? record : _Utils_update(
										record,
										{date: posixDate})) : record;
								}),
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model));
						return _Utils_update(
							model,
							{
								highlightDate: highlightDate,
								noticeWarning: noticeWarning,
								specialOpenHoursList: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend, model, updatedList)
							});
					} else {
						var oldRecord = model.currentRecord;
						var newRecord = _Utils_update(
							oldRecord,
							{date: posixDate});
						return _Utils_update(
							model,
							{
								errorInForm: $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans(newRecord.spans),
								selectedDate: $elm$core$Maybe$Just(newDate),
								currentRecord: newRecord
							});
					}
				}();
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimer, $author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimeValue, noticeWarning),
							A2($author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimer, $author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimeValue, highlightDate)
						]));
				return _Utils_Tuple2(newModel, cmd);
			case 'OnDayClosedChange':
				var inTheList = msg.a;
				var date = msg.b;
				var isChecked = msg.c;
				var newModel = function () {
					if (inTheList) {
						var updatedList = A3(
							generateNewList,
							model.specialOpenHoursList,
							date,
							$author$project$Location$Details$PopupContent$SpecialOpenHours$ChangeClosed(isChecked));
						return _Utils_update(
							model,
							{
								specialOpenHoursList: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend, model, updatedList)
							});
					} else {
						var newRecord = A2(newRecordChangingClosed, isChecked, model.currentRecord);
						return _Utils_update(
							model,
							{
								errorInForm: (!isChecked) && $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans(newRecord.spans),
								currentRecord: newRecord
							});
					}
				}();
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'UpdateHourSet':
				var stringSpanType = msg.a;
				var date = msg.b;
				var spanIndex = msg.c;
				var inTheList = msg.d;
				var newText = msg.e;
				var newModel = function () {
					if (inTheList) {
						var updatedList = A3(
							generateNewList,
							model.specialOpenHoursList,
							date,
							A3($author$project$Location$Details$PopupContent$SpecialOpenHours$EditSpan, stringSpanType, spanIndex, newText));
						return _Utils_update(
							model,
							{
								specialOpenHoursList: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend, model, updatedList)
							});
					} else {
						var newRecord = A4(newRecordEditingSpan, spanIndex, stringSpanType, newText, model.currentRecord);
						return _Utils_update(
							model,
							{
								errorInForm: $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans(newRecord.spans),
								currentRecord: newRecord
							});
					}
				}();
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'OnDescriptionChange':
				var date = msg.a;
				var inTheList = msg.b;
				var newDescription = msg.c;
				var newModel = function () {
					if (inTheList) {
						var updatedList = A3(
							generateNewList,
							model.specialOpenHoursList,
							date,
							$author$project$Location$Details$PopupContent$SpecialOpenHours$EditDescription(newDescription));
						return _Utils_update(
							model,
							{
								specialOpenHoursList: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend, model, updatedList)
							});
					} else {
						var oldRecord = model.currentRecord;
						return _Utils_update(
							model,
							{
								currentRecord: _Utils_update(
									oldRecord,
									{
										label: $elm$core$Maybe$Just(newDescription)
									})
							});
					}
				}();
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'OnCreateRecord':
				var oldRecord = model.currentRecord;
				var newRecord = _Utils_update(
					oldRecord,
					{
						date: A2($author$project$Location$Details$PopupContent$TemporarilyClosed$addDaysToPosix, 1, oldRecord.date),
						label: $elm$core$Maybe$Nothing
					});
				var newList = $author$project$Location$Details$PopupContent$SpecialOpenHours$errorInSpans(oldRecord.spans) ? model.specialOpenHoursList : _Utils_ap(
					A2($elm$core$List$take, 0, model.specialOpenHoursList),
					_Utils_ap(
						_List_fromArray(
							[oldRecord]),
						A2($elm$core$List$drop, 0, model.specialOpenHoursList)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedDate: $elm$core$Maybe$Just(
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, newRecord.date)),
							currentRecord: newRecord,
							highlightDate: $author$project$Location$Details$PopupContent$SpecialOpenHours$Success(0),
							specialOpenHoursList: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend, model, newList)
						}),
					A2($author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimer, $author$project$Location$Details$PopupContent$SpecialOpenHours$noticeTimeValue, model.highlightDate));
			case 'OnDeleteRecord':
				var index = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							specialOpenHoursList: A2(
								$author$project$Location$Details$PopupContent$SpecialOpenHours$listAppend,
								model,
								A2(
									$elm$core$List$append,
									A2(
										$elm$core$List$take,
										index,
										A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model)),
									A2(
										$elm$core$List$drop,
										index + 1,
										A2($author$project$Location$Details$PopupContent$SpecialOpenHours$tabList, model.tab, model))))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDeletePast':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							specialOpenHoursList: A2($author$project$Location$Details$PopupContent$SpecialOpenHours$deleteDatesBeforeToday, model, model.specialOpenHoursList)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ShowUpcoming':
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tab: tab}),
					$elm$core$Platform$Cmd$none);
			case 'ShowPast':
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tab: tab}),
					$elm$core$Platform$Cmd$none);
			default:
				var notice = msg.a;
				switch (notice.$) {
					case 'SuccessTimeout':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{noticeWarning: $author$project$Location$Details$PopupContent$SpecialOpenHours$None}),
							$elm$core$Platform$Cmd$none);
					case 'WarningTimeout':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{highlightDate: $author$project$Location$Details$PopupContent$SpecialOpenHours$None}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{highlightDate: $author$project$Location$Details$PopupContent$SpecialOpenHours$None, noticeWarning: $author$project$Location$Details$PopupContent$SpecialOpenHours$None}),
							$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Location$Details$PopupContent$PermanentlyClosed$update = F2(
	function (msg, model) {
		var status = msg.a;
		return _Utils_update(
			model,
			{permanentlyClosedStatus: status});
	});
var $author$project$Data$NetworkData$TemporarilyClosed$NotCompleted = F2(
	function (a, b) {
		return {$: 'NotCompleted', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$TemporarilyClosed$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateTemporarilyClosedStatus':
				var status = msg.a;
				return _Utils_update(
					model,
					{
						selectedFromDate: $elm$core$Maybe$Nothing,
						selectedUntilDate: $elm$core$Maybe$Nothing,
						temporarilyClosed: status ? A2($author$project$Data$NetworkData$TemporarilyClosed$NotCompleted, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed
					});
			case 'UpdateTemporarilyClosedFrom':
				var from = msg.a;
				var minUntilDate = A2(
					$author$project$Location$Details$PopupContent$TemporarilyClosed$addDaysToPosix,
					6,
					$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(from));
				var untilDate = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					model.now,
					function (date) {
						return $author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(date);
					},
					model.selectedUntilDate);
				var newUntilDate = (_Utils_cmp(
					$elm$time$Time$posixToMillis(minUntilDate),
					$elm$time$Time$posixToMillis(untilDate)) > 0) ? $elm$core$Maybe$Nothing : model.selectedUntilDate;
				return _Utils_update(
					model,
					{
						selectedFromDate: $elm$core$Maybe$Just(from),
						selectedUntilDate: newUntilDate
					});
			case 'UpdateTemporarilyClosedUntil':
				var until = msg.a;
				var message = function () {
					var _v1 = model.temporarilyClosed;
					if (_v1.$ === 'Until') {
						var message_ = _v1.b;
						return $elm$core$Maybe$Just(message_);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_update(
					model,
					{
						selectedUntilDate: $elm$core$Maybe$Just(until),
						temporarilyClosed: A2(
							$author$project$Data$NetworkData$TemporarilyClosed$Until,
							$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(until),
							A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, message))
					});
			case 'UpdateTemporarilyClosedMessage':
				var message = msg.a;
				var until = function () {
					var _v2 = model.temporarilyClosed;
					if (_v2.$ === 'Until') {
						var until_ = _v2.a;
						return $elm$core$Maybe$Just(until_);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_update(
					model,
					{
						temporarilyClosed: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							A2(
								$author$project$Data$NetworkData$TemporarilyClosed$NotCompleted,
								until,
								$elm$core$Maybe$Just(message)),
							function (until_) {
								return A2($author$project$Data$NetworkData$TemporarilyClosed$Until, until_, message);
							},
							until)
					});
			default:
				var msg_ = msg.a;
				return _Utils_update(
					model,
					{
						uiTextareaState: A2($author$project$PinMeTo$Ui$Form$Textarea$update, msg_, model.uiTextareaState)
					});
		}
	});
var $author$project$PinMeTo$ExpectJson$logError = F2(
	function (_v0, error) {
		var ctx = _v0.a;
		var errorMessage = function () {
			var _v2 = error.message;
			var x = _v2.a;
			return x;
		}();
		var _v1 = error.details;
		switch (_v1.$) {
			case 'ClientDecodeError':
				var x = _v1.a;
				return $author$project$PinMeTo$Logger$logHttpError(
					{
						data: $elm$http$Http$BadBody(x),
						context: ctx,
						message: errorMessage
					});
			case 'BadUrl':
				var x = _v1.a;
				return $author$project$PinMeTo$Logger$logHttpError(
					{
						data: $elm$http$Http$BadUrl(x),
						context: ctx,
						message: errorMessage
					});
			case 'Timeout':
				return $author$project$PinMeTo$Logger$logHttpError(
					{data: $elm$http$Http$Timeout, context: ctx, message: errorMessage});
			case 'NetworkError':
				return $author$project$PinMeTo$Logger$logHttpError(
					{data: $elm$http$Http$NetworkError, context: ctx, message: errorMessage});
			default:
				var code = _v1.a;
				var errMsg = _v1.b;
				return $author$project$PinMeTo$Logger$logHttpError(
					{
						data: $elm$http$Http$BadStatus(code),
						context: ctx,
						message: errMsg
					});
		}
	});
var $author$project$PinMeTo$ExpectJson$ErrorContext = function (a) {
	return {$: 'ErrorContext', a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (result.$ === 'Ok') {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Common$Validators$ValidatedItem$validate = F2(
	function (validators, item) {
		var validated = A3(
			$elm$core$List$foldl,
			$elm$core$Result$andThen,
			$elm$core$Result$Ok(item),
			validators);
		if (validated.$ === 'Ok') {
			return $author$project$Common$Validators$ValidatedItem$ValidItem(item);
		} else {
			var e = validated.a;
			return A2($author$project$Common$Validators$ValidatedItem$InvalidItem, e, item);
		}
	});
var $author$project$Common$Validators$ValidatedItem$noValidation = $author$project$Common$Validators$ValidatedItem$validate(_List_Nil);
var $author$project$Translations$Listings$ErrorMessages$descriptionTooLong = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.description_too_long');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionNotToLong = F2(
	function (errorMessage, service) {
		if (service.$ === 'Structured') {
			var structuredService = service.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Result$Ok(service),
				function (serviceDescription) {
					return (_Utils_cmp(
						$zwilias$elm_utf_tools$String$UTF16$length(serviceDescription),
						$author$project$Location$Details$PopupContent$GoogleServiceItems$countLimit) < 1) ? $elm$core$Result$Ok(service) : $elm$core$Result$Err(errorMessage);
				},
				structuredService.description);
		} else {
			var freeformService = service.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Result$Ok(service),
				function (serviceDescription) {
					return (_Utils_cmp(
						$zwilias$elm_utf_tools$String$UTF16$length(serviceDescription),
						$author$project$Location$Details$PopupContent$GoogleServiceItems$countLimit) < 1) ? $elm$core$Result$Ok(service) : $elm$core$Result$Err(errorMessage);
				},
				freeformService.label.description);
		}
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$matchDescriptionWithRegex = F3(
	function (regularExpression, errMsg, serviceItem) {
		var rx = $elm$regex$Regex$fromString(regularExpression);
		var isMatch = function (description) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (desc, r) {
						return A2($elm$regex$Regex$contains, r, desc);
					}),
				description,
				rx);
		};
		var valid = function (description) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Result$Ok(serviceItem),
				function (match) {
					return match ? $elm$core$Result$Err(errMsg) : $elm$core$Result$Ok(serviceItem);
				},
				isMatch(description));
		};
		if (serviceItem.$ === 'Structured') {
			var structured = serviceItem.a;
			return valid(structured.description);
		} else {
			var freeformItem = serviceItem.a;
			return valid(freeformItem.label.description);
		}
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionHasNoLeadingWhiteSpace = function (errorMessage) {
	return A2($author$project$Location$Details$PopupContent$GoogleServiceItems$matchDescriptionWithRegex, '^\u005Cs+', errorMessage);
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionHasNoTrailingWhiteSpace = function (errorMessage) {
	return A2($author$project$Location$Details$PopupContent$GoogleServiceItems$matchDescriptionWithRegex, '\u005Cs+$', errorMessage);
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionHasNoContigousWhiteSpace = function (errorMessage) {
	return A2($author$project$Location$Details$PopupContent$GoogleServiceItems$matchDescriptionWithRegex, '\u005Cs{2,}', errorMessage);
};
var $author$project$Translations$Listings$ErrorMessages$descriptionContainsLeadingWhitespace = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.description_contains_leading_whitespace');
};
var $author$project$Translations$Listings$ErrorMessages$descriptionContainsTrailingWhitespace = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.description_contains_trailing_whitespace');
};
var $author$project$Translations$Listings$ErrorMessages$descriptionContainsContiguousWhitespace = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.description_contains_contiguous_whitespace');
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$validateDescription = function (translations) {
	return _List_fromArray(
		[
			$author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionHasNoLeadingWhiteSpace(
			$author$project$Translations$Listings$ErrorMessages$descriptionContainsLeadingWhitespace(translations)),
			$author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionHasNoContigousWhiteSpace(
			$author$project$Translations$Listings$ErrorMessages$descriptionContainsContiguousWhitespace(translations)),
			$author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionHasNoTrailingWhiteSpace(
			$author$project$Translations$Listings$ErrorMessages$descriptionContainsTrailingWhitespace(translations)),
			$author$project$Location$Details$PopupContent$GoogleServiceItems$descriptionNotToLong(
			$author$project$Translations$Listings$ErrorMessages$descriptionTooLong(translations))
		]);
};
var $author$project$Location$Details$PopupContent$GoogleServiceItems$editSelectedService = F3(
	function (translations, action, services) {
		var updateStructuredService = function (structuredService) {
			switch (action.$) {
				case 'EditAmount':
					var amount_ = action.b;
					var newPrice = A3(
						$elm_community$maybe_extra$Maybe$Extra$unpack,
						function (_v8) {
							return {amount: amount_, currency: 'EUR'};
						},
						function (price_) {
							return _Utils_update(
								price_,
								{amount: amount_});
						},
						structuredService.price);
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Structured(
							_Utils_update(
								structuredService,
								{
									price: $elm$core$Maybe$Just(newPrice)
								})));
				case 'EditCurrency':
					var currency_ = action.b;
					var newPrice = A3(
						$elm_community$maybe_extra$Maybe$Extra$unpack,
						function (_v9) {
							return {amount: '', currency: currency_};
						},
						function (price_) {
							return _Utils_update(
								price_,
								{currency: currency_});
						},
						structuredService.price);
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Structured(
							_Utils_update(
								structuredService,
								{
									price: $elm$core$Maybe$Just(newPrice)
								})));
				case 'EditDescription':
					var description_ = action.b;
					var description = (description_ === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(description_);
					return A2(
						$author$project$Common$Validators$ValidatedItem$validate,
						$author$project$Location$Details$PopupContent$GoogleServiceItems$validateDescription(translations),
						$author$project$Data$Location$NetworkServiceItems$Structured(
							_Utils_update(
								structuredService,
								{description: description})));
				case 'EditStructuredService':
					var newId = action.b;
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Structured(
							_Utils_update(
								structuredService,
								{id: newId})));
				default:
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Structured(structuredService));
			}
		};
		var updateFreeformService = function (freeformService) {
			var oldLabel = freeformService.label;
			switch (action.$) {
				case 'EditAmount':
					var amount_ = action.b;
					var newPrice = A3(
						$elm_community$maybe_extra$Maybe$Extra$unpack,
						function (_v5) {
							return {amount: amount_, currency: 'EUR'};
						},
						function (price_) {
							return _Utils_update(
								price_,
								{amount: amount_});
						},
						freeformService.price);
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Freeform(
							_Utils_update(
								freeformService,
								{
									price: $elm$core$Maybe$Just(newPrice)
								})));
				case 'EditCurrency':
					var currency_ = action.b;
					var newPrice = A3(
						$elm_community$maybe_extra$Maybe$Extra$unpack,
						function (_v6) {
							return {amount: '', currency: currency_};
						},
						function (price_) {
							return _Utils_update(
								price_,
								{currency: currency_});
						},
						freeformService.price);
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Freeform(
							_Utils_update(
								freeformService,
								{
									price: $elm$core$Maybe$Just(newPrice)
								})));
				case 'EditDescription':
					var description_ = action.b;
					return A2(
						$author$project$Common$Validators$ValidatedItem$validate,
						$author$project$Location$Details$PopupContent$GoogleServiceItems$validateDescription(translations),
						$author$project$Data$Location$NetworkServiceItems$Freeform(
							_Utils_update(
								freeformService,
								{
									label: _Utils_update(
										oldLabel,
										{
											description: $elm$core$Maybe$Just(description_)
										})
								})));
				case 'EditFreeformName':
					var name = action.b;
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Freeform(
							_Utils_update(
								freeformService,
								{
									label: _Utils_update(
										oldLabel,
										{displayName: name})
								})));
				default:
					return $author$project$Common$Validators$ValidatedItem$noValidation(
						$author$project$Data$Location$NetworkServiceItems$Freeform(freeformService));
			}
		};
		var identifier = function () {
			switch (action.$) {
				case 'EditAmount':
					var id = action.a;
					return id;
				case 'EditCurrency':
					var id = action.a;
					return id;
				case 'EditDescription':
					var id = action.a;
					return id;
				case 'EditFreeformName':
					var id = action.a;
					return id;
				default:
					var id = action.a;
					return id;
			}
		}();
		return A2(
			$elm$core$List$map,
			function (validatedService) {
				if (validatedService.$ === 'ValidItem') {
					var service = validatedService.a;
					if (service.$ === 'Structured') {
						var structuredService = service.a;
						return _Utils_eq(structuredService.id, identifier) ? updateStructuredService(structuredService) : $author$project$Common$Validators$ValidatedItem$noValidation(
							$author$project$Data$Location$NetworkServiceItems$Structured(structuredService));
					} else {
						var freeformService = service.a;
						return _Utils_eq(freeformService.label.displayName, identifier) ? updateFreeformService(freeformService) : $author$project$Common$Validators$ValidatedItem$noValidation(
							$author$project$Data$Location$NetworkServiceItems$Freeform(freeformService));
					}
				} else {
					var service = validatedService.b;
					if (service.$ === 'Structured') {
						var structuredService = service.a;
						return _Utils_eq(structuredService.id, identifier) ? updateStructuredService(structuredService) : $author$project$Common$Validators$ValidatedItem$noValidation(
							$author$project$Data$Location$NetworkServiceItems$Structured(structuredService));
					} else {
						var freeformService = service.a;
						return _Utils_eq(freeformService.label.displayName, identifier) ? updateFreeformService(freeformService) : $author$project$Common$Validators$ValidatedItem$noValidation(
							$author$project$Data$Location$NetworkServiceItems$Freeform(freeformService));
					}
				}
			},
			services);
	});
var $author$project$Location$Details$PopupContent$GoogleServiceItems$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnGoogleServiceItemsData':
				if (msg.a.$ === 'Ok') {
					var services = msg.a.a;
					var sortedServices = A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.name;
						},
						services);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								allGoogleServiceItems: $author$project$RemoteData$Loaded(sortedServices)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								allGoogleServiceItems: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnGoogleServiceItemsData'),
							err));
				}
			case 'OnSelectStructuredService':
				var service = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedServiceId: $elm$core$Maybe$Just(service.id),
							freeformServiceName: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnEditFreeformName':
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedServiceId: $elm$core$Maybe$Nothing,
							freeformServiceName: $elm$core$Maybe$Just(name)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnCreateService':
				var newService = $author$project$Location$Details$PopupContent$GoogleServiceItems$validateService(model);
				var selectedServices = A3(
					$elm_community$maybe_extra$Maybe$Extra$unpack,
					function (_v2) {
						return model.selectedServices;
					},
					function (service) {
						return A2(
							$elm$core$List$cons,
							$author$project$Common$Validators$ValidatedItem$ValidItem(service),
							model.selectedServices);
					},
					newService);
				var isFreeformService = function () {
					if ((newService.$ === 'Just') && (newService.a.$ === 'Freeform')) {
						return true;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedServices: selectedServices, selectedServiceId: $elm$core$Maybe$Nothing, showFreeFormAlert: model.showFreeFormAlert || isFreeformService, freeformServiceName: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'OnDeleteService':
				var id = msg.a;
				var newSelectedServices = A2(
					$elm$core$List$filter,
					function (service) {
						if (service.$ === 'ValidItem') {
							var item = service.a;
							if (item.$ === 'Structured') {
								var structuredService = item.a;
								return !_Utils_eq(structuredService.id, id);
							} else {
								var freeformService = item.a;
								return !_Utils_eq(freeformService.label.displayName, id);
							}
						} else {
							var item = service.b;
							if (item.$ === 'Structured') {
								var structuredService = item.a;
								return !_Utils_eq(structuredService.id, id);
							} else {
								var freeformService = item.a;
								return !_Utils_eq(freeformService.label.displayName, id);
							}
						}
					},
					model.selectedServices);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedServices: newSelectedServices}),
					$elm$core$Platform$Cmd$none);
			case 'OnEditExistingService':
				var translations = msg.a;
				var action = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedServices: A3($author$project$Location$Details$PopupContent$GoogleServiceItems$editSelectedService, translations, action, model.selectedServices)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (state_) {
						return _Utils_update(
							model,
							{uiSelect: state_});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Location$Details$PopupContent$GoogleServiceItems$UiSelectMsg, msg_, model.uiSelect));
			case 'UiTextareaMessage':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTextareaState: A2($author$project$PinMeTo$Ui$Form$Textarea$update, msg_, model.uiTextareaState)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 'Ok') {
					var currencyCodes_ = msg.a.a;
					var sortedCurrencyCodes = $elm$core$List$sort(currencyCodes_);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								currencyCodes: $author$project$RemoteData$Loaded(sortedCurrencyCodes)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								currencyCodes: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Location$Details$PopupContent$LocationDescriptor$update = F2(
	function (msg, model) {
		var value = msg.a.a;
		return _Utils_update(
			model,
			{
				locationDescriptor: A2($author$project$Data$ValidatedLocationDescriptor$create, model.translations, value)
			});
	});
var $author$project$Data$Location$AlternativeSearchNames = function (a) {
	return {$: 'AlternativeSearchNames', a: a};
};
var $author$project$Data$Location$stringToAlternativeSearchNames = function (string) {
	return $author$project$Data$Location$AlternativeSearchNames(
		A2(
			$elm$core$List$filter,
			function (name) {
				return name !== '';
			},
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, ',', string))));
};
var $author$project$Location$Details$PopupContent$AlternativeSearchNames$update = F2(
	function (msg, model) {
		var value = msg.a;
		return _Utils_update(
			model,
			{
				inputText: value,
				alternativeSearchNames: $author$project$Data$Location$stringToAlternativeSearchNames(value)
			});
	});
var $author$project$Location$Details$Editor$Model$Unknown = function (a) {
	return {$: 'Unknown', a: a};
};
var $author$project$Data$Location$Field$Homepage = {$: 'Homepage'};
var $author$project$Location$Details$Editor$Model$OnUpdated = function (a) {
	return {$: 'OnUpdated', a: a};
};
var $author$project$Location$Details$PopupContent$OpenStatus$fieldName = function (model) {
	var _v0 = model.choice;
	if (_v0.$ === 'PermanentlyClosed') {
		return 'permanentlyClosed';
	} else {
		return 'temporarilyClosed';
	}
};
var $author$project$Location$Details$Editor$Model$OnScheduled = function (a) {
	return {$: 'OnScheduled', a: a};
};
var $author$project$Location$Details$Editor$Update$dateToPosix = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		{
			day: $justinmimbs$date$Date$day(date),
			hour: 0,
			year: $justinmimbs$date$Date$year(date),
			month: $justinmimbs$date$Date$month(date),
			minute: 0,
			second: 0,
			millisecond: 0
		});
};
var $author$project$Data$Location$Field$SpecialHours = {$: 'SpecialHours'};
var $author$project$Location$Details$Editor$Model$StoreIdExists = {$: 'StoreIdExists'};
var $author$project$Location$Details$PopupContent$OpenStatus$schedulingDate = function (model) {
	var _v0 = model.choice;
	switch (_v0.$) {
		case 'TemporarilyClosed':
			return model.selectedFromDate;
		case 'PermanentlyClosed':
			return model.selectedClosesOnDate;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Location$Field$LongDescription = {$: 'LongDescription'};
var $author$project$Location$Details$Editor$Model$OnDeleteSchedule = function (a) {
	return {$: 'OnDeleteSchedule', a: a};
};
var $author$project$Data$Location$NetworkAttributes$Attributes = {$: 'Attributes'};
var $author$project$Location$Details$PopupContent$SocialMessaging$encodeField = function (field) {
	return ($elm$core$String$trim(field.value) === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		{
			source: $author$project$Data$Location$NetworkAttributes$Attributes,
			values: _List_fromArray(
				[
					$elm$core$String$trim(field.value)
				]),
			valueType: field.attribute.valueType,
			attributeId: field.attribute.attributeId,
			repeatedEnumValue: $elm$core$Maybe$Nothing
		});
};
var $author$project$Location$Details$PopupContent$SocialMessaging$attributesToSave = function (model) {
	return A2($elm$core$List$filterMap, $author$project$Location$Details$PopupContent$SocialMessaging$encodeField, model.fields);
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$encodeRow = function (row) {
	var attr = row.selectedAttribute;
	var _v0 = row.value;
	switch (_v0.$) {
		case 'BoolValue':
			var b = _v0.a;
			return $elm$core$Maybe$Just(
				{
					source: $author$project$Data$Location$NetworkAttributes$Attributes,
					values: _List_fromArray(
						[
							b ? 'true' : 'false'
						]),
					valueType: attr.valueType,
					attributeId: attr.attributeId,
					repeatedEnumValue: $elm$core$Maybe$Nothing
				});
		case 'EnumValue':
			var val = _v0.a;
			return (val === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{
					source: $author$project$Data$Location$NetworkAttributes$Attributes,
					values: _List_fromArray(
						[val]),
					valueType: attr.valueType,
					attributeId: attr.attributeId,
					repeatedEnumValue: $elm$core$Maybe$Nothing
				});
		case 'UrlValue':
			var val = _v0.a;
			var trimmed = $elm$core$String$trim(val);
			return (trimmed === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{
					source: $author$project$Data$Location$NetworkAttributes$Attributes,
					values: _List_fromArray(
						[trimmed]),
					valueType: attr.valueType,
					attributeId: attr.attributeId,
					repeatedEnumValue: $elm$core$Maybe$Nothing
				});
		default:
			var re = _v0.a;
			return $elm$core$Maybe$Just(
				{
					source: $author$project$Data$Location$NetworkAttributes$Attributes,
					values: _List_Nil,
					valueType: attr.valueType,
					attributeId: attr.attributeId,
					repeatedEnumValue: $elm$core$Maybe$Just(re)
				});
	}
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$attributesToSave = function (model) {
	return A2($elm$core$List$filterMap, $author$project$Location$Details$PopupContent$GoogleAttributes$encodeRow, model.rows);
};
var $author$project$Location$Details$Editor$Model$OnSelectLocations = function (a) {
	return {$: 'OnSelectLocations', a: a};
};
var $author$project$Data$Location$Field$PermanentlyClosed = {$: 'PermanentlyClosed'};
var $author$project$Location$Details$Editor$Model$PartialUpdateFailed = function (a) {
	return {$: 'PartialUpdateFailed', a: a};
};
var $author$project$Location$Details$PopupContent$SocialMessaging$emptiedAttributeIds = function (model) {
	var wasSaved = function (field) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return $elm$core$String$trim(value) !== '';
				},
				A2($elm$core$Dict$get, field.attribute.attributeId, model.initial)));
	};
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.attribute;
			},
			function ($) {
				return $.attributeId;
			}),
		A2(
			$elm$core$List$filter,
			function (field) {
				return wasSaved(field) && _Utils_eq(
					$author$project$Location$Details$PopupContent$SocialMessaging$encodeField(field),
					$elm$core$Maybe$Nothing);
			},
			model.fields));
};
var $author$project$Location$Details$PopupContent$GoogleAttributes$emptiedAttributeIds = function (model) {
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.selectedAttribute;
			},
			function ($) {
				return $.attributeId;
			}),
		A2(
			$elm$core$List$filter,
			function (row) {
				return _Utils_eq(row.origin, $author$project$Location$Details$PopupContent$GoogleAttributes$SavedValue) && _Utils_eq(
					$author$project$Location$Details$PopupContent$GoogleAttributes$encodeRow(row),
					$elm$core$Maybe$Nothing);
			},
			model.rows));
};
var $author$project$Location$Details$Editor$Update$onLocationsSelected = F3(
	function (siteName, locationIds, content) {
		if (content.$ === 'Editor') {
			switch (content.a.$) {
				case 'GoogleAttributes':
					return $elm$core$List$isEmpty(locationIds) ? _Utils_Tuple2(content, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						content,
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$GoogleAttributesMsg, $author$project$Location$Details$Editor$Model$EditorMsg),
							A2($author$project$Location$Details$PopupContent$GoogleAttributes$fetchAvailableAttributes, siteName, locationIds)));
				case 'SocialMessaging':
					return $elm$core$List$isEmpty(locationIds) ? _Utils_Tuple2(content, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						content,
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$SocialMessagingMsg, $author$project$Location$Details$Editor$Model$EditorMsg),
							A2($author$project$Location$Details$PopupContent$SocialMessaging$fetchAvailableAttributes, siteName, locationIds)));
				default:
					return _Utils_Tuple2(content, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(content, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Details$Editor$Model$ScheduleUpdateFailed = {$: 'ScheduleUpdateFailed'};
var $author$project$Location$Details$Editor$Model$FacebookStoreIdExists = {$: 'FacebookStoreIdExists'};
var $author$project$Location$Details$Editor$Model$SpecialOpenHoursOverlap = function (a) {
	return {$: 'SpecialOpenHoursOverlap', a: a};
};
var $author$project$Data$Location$OpenHours$encodeSpan = function (span) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'open',
				$elm$json$Json$Encode$string(span.open)),
				_Utils_Tuple2(
				'close',
				$elm$json$Json$Encode$string(span.close))
			]));
};
var $author$project$Data$Location$OpenHours$encodeState = function (state) {
	switch (state.$) {
		case 'NotSpecified':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('Closed')),
						_Utils_Tuple2(
						'span',
						A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil))
					]));
		case 'Closed':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('Closed')),
						_Utils_Tuple2(
						'span',
						A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil))
					]));
		case 'AlwaysOpen':
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('AlwaysOpen')),
						_Utils_Tuple2(
						'span',
						A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil))
					]));
		default:
			var spans = state.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'state',
						$elm$json$Json$Encode$string('Open')),
						_Utils_Tuple2(
						'span',
						A2($elm$json$Json$Encode$list, $author$project$Data$Location$OpenHours$encodeSpan, spans))
					]));
	}
};
var $author$project$Data$Location$OpenHours$encodeDays = function (days) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mon',
				$author$project$Data$Location$OpenHours$encodeState(days.mon)),
				_Utils_Tuple2(
				'tue',
				$author$project$Data$Location$OpenHours$encodeState(days.tue)),
				_Utils_Tuple2(
				'wed',
				$author$project$Data$Location$OpenHours$encodeState(days.wed)),
				_Utils_Tuple2(
				'thu',
				$author$project$Data$Location$OpenHours$encodeState(days.thu)),
				_Utils_Tuple2(
				'fri',
				$author$project$Data$Location$OpenHours$encodeState(days.fri)),
				_Utils_Tuple2(
				'sat',
				$author$project$Data$Location$OpenHours$encodeState(days.sat)),
				_Utils_Tuple2(
				'sun',
				$author$project$Data$Location$OpenHours$encodeState(days.sun))
			]));
};
var $author$project$Data$Location$OpenHours$encode = function (openHours) {
	if (openHours.$ === 'Always') {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'isAlwaysOpen',
				$elm$json$Json$Encode$bool(true)),
				_Utils_Tuple2(
				'openHours',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mon',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen)),
							_Utils_Tuple2(
							'tue',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen)),
							_Utils_Tuple2(
							'wed',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen)),
							_Utils_Tuple2(
							'thu',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen)),
							_Utils_Tuple2(
							'fri',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen)),
							_Utils_Tuple2(
							'sat',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen)),
							_Utils_Tuple2(
							'sun',
							$author$project$Data$Location$OpenHours$encodeState($author$project$Data$Location$OpenHours$AlwaysOpen))
						])))
			]);
	} else {
		var days = openHours.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'isAlwaysOpen',
				$elm$json$Json$Encode$bool(false)),
				_Utils_Tuple2(
				'openHours',
				$author$project$Data$Location$OpenHours$encodeDays(days))
			]);
	}
};
var $author$project$Data$Location$NetworkAttributes$encodeRepeatedEnum = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'setValues',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, x.setValues)),
				_Utils_Tuple2(
				'unsetValues',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, x.unsetValues))
			]));
};
var $author$project$Data$Location$NetworkAttributes$encodeAttribute = function (x) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'attributeId',
					$elm$json$Json$Encode$string(x.attributeId)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(x.valueType)),
					_Utils_Tuple2(
					'values',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, x.values))
				]),
			function () {
				var _v0 = x.repeatedEnumValue;
				if (_v0.$ === 'Just') {
					var y = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'repeatedEnumValue',
							$author$project$Data$Location$NetworkAttributes$encodeRepeatedEnum(y))
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$Data$Location$NetworkAttributes$encode = function (attributes) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'google',
			A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkAttributes$encodeAttribute, attributes))
		]);
};
var $author$project$Data$Location$NetworkCategories$encodeCategoryGroup = function (x) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'additional',
				A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, x.additional)),
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						_Utils_Tuple2('primary', $elm$json$Json$Encode$null)
					]),
				A2(
					$elm$core$Maybe$map,
					function (p) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'primary',
								$author$project$Data$Location$NetworkCategories$encodeCategory(p))
							]);
					},
					x.primary))));
};
var $author$project$Data$Location$NetworkCategories$encodeBingCategories = function (x) {
	var primaryCategoryId = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, x.primaryCategoryId);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, x.categories)),
				_Utils_Tuple2(
				'primaryCategoryId',
				$elm$json$Json$Encode$string(primaryCategoryId))
			]));
};
var $author$project$Data$Location$NetworkCategories$encodeTomtomCategories = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'featureTypeId',
				$elm$json$Json$Encode$string(x.featureTypeId)),
				_Utils_Tuple2(
				'serviceSubCategoryId',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, x.serviceSubCategoryId)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(x.name))
			]));
};
var $author$project$Data$Location$NetworkCategories$encodeFacebookCategories = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subcategories',
				A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, x.subcategories))
			]));
};
var $author$project$Data$Location$NetworkCategories$encodeFoursquareCategories = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, x.categories))
			]));
};
var $author$project$Data$Location$NetworkCategories$encode = F2(
	function (categories, network) {
		var result = function () {
			switch (network.$) {
				case 'Google':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'google',
								$author$project$Data$Location$NetworkCategories$encodeCategoryGroup(x));
						},
						categories.google);
				case 'Facebook':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'facebook',
								$author$project$Data$Location$NetworkCategories$encodeFacebookCategories(x));
						},
						categories.facebook);
				case 'Bing':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'bing',
								$author$project$Data$Location$NetworkCategories$encodeBingCategories(x));
						},
						categories.bing);
				case 'Apple':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'apple',
								$author$project$Data$Location$NetworkCategories$encodeCategoryGroup(x));
						},
						categories.apple);
				case 'Foursquare':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'factual',
								$author$project$Data$Location$NetworkCategories$encodeFoursquareCategories(x));
						},
						categories.foursquare);
				case 'Overture':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'overture',
								$author$project$Data$Location$NetworkCategories$encodeCategoryGroup(x));
						},
						categories.overture);
				case 'Here':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'here',
								$author$project$Data$Location$NetworkCategories$encodeCategoryGroup(x));
						},
						categories.here);
				case 'Tomtom':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(
								'tomtom',
								$author$project$Data$Location$NetworkCategories$encodeTomtomCategories(x));
						},
						categories.tomtom);
				case 'Ptv':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return $elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[result]));
	});
var $author$project$Data$Location$NetworkServiceItems$priceEncoder = function (price) {
	if (price.$ === 'Just') {
		var price_ = price.a;
		var amount = $elm$core$String$toFloat(price_.amount);
		if (amount.$ === 'Just') {
			var amount_ = amount.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'amount',
						$elm$json$Json$Encode$float(amount_)),
						_Utils_Tuple2(
						'currencyCode',
						$elm$json$Json$Encode$string(price_.currency))
					]));
		} else {
			return $elm$json$Json$Encode$null;
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Data$Location$NetworkServiceItems$labelEncoder = function (label) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'displayName',
				$elm$json$Json$Encode$string(
					$elm$core$String$trim(label.displayName))),
			function () {
				var _v0 = label.description;
				if (_v0.$ === 'Just') {
					var description = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(
								$elm$core$String$trim(description)))
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$Data$Location$NetworkServiceItems$freeformGoogleServiceItemEncoder = function (service) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'category',
				$elm$json$Json$Encode$string(service.categoryId)),
				_Utils_Tuple2(
				'label',
				$author$project$Data$Location$NetworkServiceItems$labelEncoder(service.label))
			]));
};
var $author$project$Data$Location$NetworkServiceItems$structuredGoogleServiceItemEncoder = function (service) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'serviceTypeId',
				$elm$json$Json$Encode$string(service.id)),
			function () {
				var _v0 = service.description;
				if (_v0.$ === 'Just') {
					var description = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(
								$elm$core$String$trim(description)))
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$Data$Location$NetworkServiceItems$encodeGoogleServiceItem = function (service) {
	if (service.$ === 'Structured') {
		var structured = service.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('structured')),
					_Utils_Tuple2(
					'price',
					$author$project$Data$Location$NetworkServiceItems$priceEncoder(structured.price)),
					_Utils_Tuple2(
					'structuredServiceItem',
					$author$project$Data$Location$NetworkServiceItems$structuredGoogleServiceItemEncoder(structured))
				]));
	} else {
		var freeform = service.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'price',
					$author$project$Data$Location$NetworkServiceItems$priceEncoder(freeform.price)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('freeForm')),
					_Utils_Tuple2(
					'freeFormServiceItem',
					$author$project$Data$Location$NetworkServiceItems$freeformGoogleServiceItemEncoder(freeform))
				]));
	}
};
var $author$project$Data$Location$NetworkServiceItems$encode = function (selectedServices) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'google',
			A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkServiceItems$encodeGoogleServiceItem, selectedServices))
		]);
};
var $author$project$Data$Location$Field$appendNetwork = F2(
	function (network, x) {
		switch (network.$) {
			case 'Facebook':
				return x + 'Facebook';
			case 'Google':
				return x + 'Google';
			case 'Bing':
				return x + 'Bing';
			case 'Apple':
				return x + 'Apple';
			case 'Foursquare':
				return x + 'Foursquare';
			case 'Overture':
				return x + 'Overture';
			case 'Here':
				return x + 'Here';
			case 'Tomtom':
				return x + 'Tomtom';
			case 'Ptv':
				return x + 'Ptv';
			default:
				return x + 'Instagram';
		}
	});
var $author$project$Data$Location$Field$toString = function (field) {
	switch (field.$) {
		case 'Name':
			return 'name';
		case 'CustomName':
			var network = field.a;
			return A2($author$project$Data$Location$Field$appendNetwork, network, 'customName');
		case 'StoreId':
			return 'storeId';
		case 'LocationDescriptor':
			return 'locationDescriptor';
		case 'Location':
			return 'location';
		case 'About':
			return 'shortDescription';
		case 'LongDescription':
			return 'longDescription';
		case 'OpeningDate':
			return 'openingDate';
		case 'Hours':
			return 'hours';
		case 'SpecialHours':
			return 'specialHours';
		case 'PermanentlyClosed':
			return 'permanentlyClosed';
		case 'TemporarilyClosedUntil':
			return 'temporarilyClosedUntil';
		case 'Email':
			return 'email';
		case 'Homepage':
			return 'homepage';
		case 'Phone':
			return 'phone';
		case 'Address':
			return 'address';
		case 'CoverImage':
			var network = field.a;
			return A2($author$project$Data$Location$Field$appendNetwork, network, 'coverImage');
		case 'ProfileImage':
			var network = field.a;
			return A2($author$project$Data$Location$Field$appendNetwork, network, 'profileImage');
		case 'NetworkCategories':
			var network = field.a;
			return A2($author$project$Data$Location$Field$appendNetwork, network, 'networkCategories');
		case 'NetworkAttributes':
			var network = field.a;
			return A2($author$project$Data$Location$Field$appendNetwork, network, 'networkAttributes');
		case 'ServiceAreas':
			return 'serviceAreas';
		case 'Wifi':
			return 'wifiSsid';
		case 'Unhandled':
			var x = field.a;
			return x;
		case 'ActionLinks':
			return 'actionLinks';
		default:
			var network = field.a;
			return A2($author$project$Data$Location$Field$appendNetwork, network, 'networkServiceItems');
	}
};
var $author$project$Data$NetworkData$TemporarilyClosed$toString = function (x) {
	if (x.$ === 'Until') {
		var until = x.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$left,
				10,
				$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(until)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (mx.$ === 'Just') {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Media$encodeMedia = function (media) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(media.url)),
				_Utils_Tuple2(
				'previewUrl',
				$elm$json$Json$Encode$string(media.previewUrl))
			]));
};
var $author$project$Data$Location$networkImagesFromNetwork = function (network) {
	switch (network.$) {
		case 'Facebook':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.facebook;
				});
		case 'Google':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.google;
				});
		case 'Bing':
			return $elm$core$Maybe$Nothing;
		case 'Apple':
			return $elm$core$Maybe$Nothing;
		case 'Foursquare':
			return $elm$core$Maybe$Nothing;
		case 'Overture':
			return $elm$core$Maybe$Nothing;
		case 'Here':
			return $elm$core$Maybe$Nothing;
		case 'Tomtom':
			return $elm$core$Maybe$Nothing;
		case 'Ptv':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Location$handleImage = F4(
	function (image, getImage, location, network) {
		return A2(
			$elm$core$Maybe$map,
			function (x) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'networkMedia',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Data$Network$toString(network),
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												image,
												$author$project$Data$Media$encodeMedia(x))
											])))
								])))
					]);
			},
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					function (f) {
						return getImage(
							f(location.networkMedia));
					},
					$author$project$Data$Location$networkImagesFromNetwork(network))));
	});
var $author$project$Data$Location$encodeFieldInLocation = F2(
	function (field, location) {
		switch (field.$) {
			case 'Name':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(location.name))
						]));
			case 'CustomName':
				var network = field.a;
				var data = function () {
					switch (network.$) {
						case 'Facebook':
							return A2($elm$core$Maybe$withDefault, '', location.networkNames.facebook);
						case 'Google':
							return A2($elm$core$Maybe$withDefault, '', location.networkNames.google);
						case 'Bing':
							return '';
						case 'Apple':
							return A2($elm$core$Maybe$withDefault, '', location.networkNames.apple);
						case 'Foursquare':
							return '';
						case 'Overture':
							return '';
						case 'Here':
							return '';
						case 'Tomtom':
							return '';
						case 'Ptv':
							return A2($elm$core$Maybe$withDefault, '', location.networkNames.ptv);
						default:
							return '';
					}
				}();
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Network$toString(network),
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'custom',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(data))
												])))
									])))
						]));
			case 'StoreId':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(
								$author$project$Data$Location$storeIdToString(location.storeId)))
						]));
			case 'LocationDescriptor':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(
								$author$project$Data$Location$locationDescriptorToString(location.locationDescriptor)))
						]));
			case 'Location':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'lat',
										$elm$json$Json$Encode$float(location.location.lat)),
										_Utils_Tuple2(
										'lon',
										$elm$json$Json$Encode$float(location.location.lon))
									])))
						]));
			case 'About':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(
								$author$project$Data$Location$shortDescriptionToString(location.about)))
						]));
			case 'LongDescription':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(
								$author$project$Data$Location$longDescriptionToString(location.longDescription)))
						]));
			case 'Hours':
				return $elm$core$Maybe$Just(
					$author$project$Data$Location$OpenHours$encode(location.openHours));
			case 'OpeningDate':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(location.openingDate))
						]));
			case 'SpecialHours':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'specialOpenHours',
							A2(
								$elm$json$Json$Encode$list,
								$author$project$Data$Location$SpecialOpenHours$encode,
								A2(
									$elm$core$List$sortBy,
									function (record) {
										return $elm$time$Time$posixToMillis(record.startDate);
									},
									location.specialOpenHours)))
						]));
			case 'PermanentlyClosed':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$bool(location.permanentlyClosed))
						]));
			case 'TemporarilyClosedUntil':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Data$NetworkData$TemporarilyClosed$toString(location.temporarilyClosedUntil))))
						]));
			case 'Email':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'contact',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Data$Location$Field$toString(field),
										$elm$json$Json$Encode$string(
											$author$project$Data$Location$emailToString(location.email)))
									])))
						]));
			case 'Homepage':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'contact',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Data$Location$Field$toString(field),
										$elm$json$Json$Encode$string(
											$author$project$Data$Location$homepageToString(location.homepage)))
									])))
						]));
			case 'Phone':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'contact',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Data$Location$Field$toString(field),
										$elm$json$Json$Encode$string(
											$author$project$Data$Location$phoneToString(location.phone)))
									])))
						]));
			case 'Address':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$author$project$Data$Address$addressEncoder(location.address))
						]));
			case 'CoverImage':
				var network = field.a;
				return A4(
					$author$project$Data$Location$handleImage,
					'coverImage',
					function ($) {
						return $.coverImage;
					},
					location,
					network);
			case 'ProfileImage':
				var network = field.a;
				return A4(
					$author$project$Data$Location$handleImage,
					'profileImage',
					function ($) {
						return $.profileImage;
					},
					location,
					network);
			case 'NetworkCategories':
				var network = field.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'networkCategories',
							$elm$json$Json$Encode$object(
								A2($author$project$Data$Location$NetworkCategories$encode, location.networkCategories, network)))
						]));
			case 'NetworkAttributes':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'networkAttributes',
							$elm$json$Json$Encode$object(
								$author$project$Data$Location$NetworkAttributes$encode(location.networkAttributes.google)))
						]));
			case 'ActionLinks':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'actionLinks',
							A2($elm$json$Json$Encode$list, $author$project$Data$Location$ActionLinks$encode, location.actionLinks))
						]));
			case 'NetworkServiceItems':
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'networkServiceItems',
							$elm$json$Json$Encode$object(
								$author$project$Data$Location$NetworkServiceItems$encode(location.networkServiceItems.google)))
						]));
			case 'ServiceAreas':
				var encoder = function () {
					var _v2 = location.serviceAreas;
					if (_v2.$ === 'WithPlaceId') {
						var a = _v2.a;
						return $author$project$Data$ServiceArea$encodeServiceAreas(a);
					} else {
						return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil);
					}
				}();
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							encoder)
						]));
			case 'Wifi':
				var _v3 = location.wifiSsId;
				var wifi = _v3.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'wifiSsid',
							$elm$json$Json$Encode$string(wifi))
						]));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Location$fieldsInLocationEncoder = F2(
	function (fields, location) {
		return $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						function (field) {
							return A2($author$project$Data$Location$encodeFieldInLocation, field, location);
						},
						fields))));
	});
var $author$project$Data$Location$NetworkServiceItems$encodeGoogleServiceItems = function (selectedServices) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'networkServiceItems',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'google',
							A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkServiceItems$encodeGoogleServiceItem, selectedServices))
						])))
			]));
};
var $author$project$Translations$General$locationWifi = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_wifi');
};
var $author$project$Translations$General$locationActive = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_active');
};
var $author$project$Translations$General$locationOpenHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_open_hours');
};
var $author$project$Translations$General$locationCustomName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_custom_name');
};
var $author$project$Translations$General$locationGeoCoordinates = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_geo_coordinates');
};
var $author$project$Translations$General$locationNetworkCategories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_network_categories');
};
var $author$project$Location$Details$Editor$Model$editorStateToHumanReadable = F2(
	function (editorState, translations) {
		switch (editorState.$) {
			case 'Active':
				return $author$project$Translations$General$locationActive(translations);
			case 'Address':
				return $author$project$Translations$General$locationAddress(translations);
			case 'AlternativeSearchNames':
				return $author$project$Translations$General$locationAlternativeSearchNames(translations);
			case 'Categories':
				return $author$project$Translations$General$locationNetworkCategories(translations);
			case 'GoogleAttributes':
				return $author$project$Translations$General$locationAttributes(translations);
			case 'SocialMessaging':
				return $author$project$Translations$Listings$LocationDetail$googleUrlAttributes(translations);
			case 'GoogleServiceItems':
				return $author$project$Translations$General$locationNetworkServices(translations);
			case 'ActionLinks':
				return $author$project$Translations$General$locationActionLinks(translations);
			case 'Coordinates':
				return $author$project$Translations$General$locationGeoCoordinates(translations);
			case 'CustomNameOnNetwork':
				return $author$project$Translations$General$locationCustomName(translations);
			case 'Email':
				return $author$project$Translations$General$locationEmail(translations);
			case 'Homepage':
				return $author$project$Translations$General$locationHomepage(translations);
			case 'OpenHours':
				return $author$project$Translations$General$locationOpenHours(translations);
			case 'OpenStatus':
				return $author$project$Translations$General$locationOpenStatus(translations);
			case 'Wifi':
				return $author$project$Translations$General$locationWifi(translations);
			case 'StoreId':
				return $author$project$Translations$General$locationStoreId(translations);
			case 'StorefrontName':
				return $author$project$Translations$General$locationStorefrontName(translations);
			case 'TemporarilyClosed':
				return $author$project$Translations$General$locationTempClosed(translations);
			case 'ShortDescription':
				return $author$project$Translations$General$locationShortDescription(translations);
			case 'Phone':
				return $author$project$Translations$General$locationPhone(translations);
			case 'PermanentlyClosed':
				return $author$project$Translations$General$locationPermanentlyClosed(translations);
			case 'OpeningDate':
				return $author$project$Translations$General$locationOpeningDate(translations);
			case 'LongDescription':
				return $author$project$Translations$General$locationLongDescription(translations);
			case 'LocationDescriptor':
				return $author$project$Translations$General$locationDescriptor(translations);
			default:
				return $author$project$Translations$General$locationSpecialHours(translations);
		}
	});
var $author$project$Data$Location$NetworkCategories$toCommon = function (x) {
	if ((x.$ === 'Just') && (x.a.$ === 'CommonNetworkCategory')) {
		var cat = x.a.a;
		return $elm$core$Maybe$Just(cat);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Location$NetworkCategories$toTomtom = function (x) {
	if ((x.$ === 'Just') && (x.a.$ === 'TomtomNetworkCategory')) {
		var cat = x.a.a;
		return $elm$core$Maybe$Just(cat);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Location$Details$PopupContent$Categories$encodeWithNetworkCategories = function (model) {
	var additional = A2(
		$elm$core$List$filterMap,
		function (cat) {
			return $author$project$Data$Location$NetworkCategories$toCommon(
				$elm$core$Maybe$Just(cat));
		},
		$author$project$Location$Details$PopupContent$Categories$convertToCategories(model.additionalCategories));
	var primary = $author$project$Data$Location$NetworkCategories$toCommon(model.primaryCategory);
	var categoryGroup = {primary: primary, additional: additional};
	var networkCategories = function () {
		var _v0 = model.network;
		switch (_v0.$) {
			case 'Facebook':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Nothing,
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Just(
						{
							subcategories: A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								_List_Nil,
								function (p) {
									return A2($elm$core$List$cons, p, additional);
								},
								primary)
						}),
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Bing':
				return {
					bing: $elm$core$Maybe$Just(
						{
							categories: A2(
								$elm$core$List$append,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									_List_Nil,
									function (x) {
										return _List_fromArray(
											[x]);
									},
									primary),
								additional),
							primaryCategoryId: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.id;
								},
								primary)
						}),
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Nothing,
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Foursquare':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Nothing,
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Just(
						{
							categories: A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								additional,
								function (p) {
									return A2($elm$core$List$cons, p, additional);
								},
								primary)
						})
				};
			case 'Overture':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Nothing,
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Just(categoryGroup),
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Google':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Just(categoryGroup),
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Apple':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Just(categoryGroup),
					google: $elm$core$Maybe$Nothing,
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Here':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Just(categoryGroup),
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Nothing,
					tomtom: $elm$core$Maybe$Nothing,
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Tomtom':
				return {
					bing: $elm$core$Maybe$Nothing,
					here: $elm$core$Maybe$Nothing,
					apple: $elm$core$Maybe$Nothing,
					google: $elm$core$Maybe$Nothing,
					tomtom: $author$project$Data$Location$NetworkCategories$toTomtom(model.primaryCategory),
					facebook: $elm$core$Maybe$Nothing,
					overture: $elm$core$Maybe$Nothing,
					foursquare: $elm$core$Maybe$Nothing
				};
			case 'Ptv':
				return {bing: $elm$core$Maybe$Nothing, here: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, tomtom: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, overture: $elm$core$Maybe$Nothing, foursquare: $elm$core$Maybe$Nothing};
			default:
				return {bing: $elm$core$Maybe$Nothing, here: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, tomtom: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, overture: $elm$core$Maybe$Nothing, foursquare: $elm$core$Maybe$Nothing};
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'network',
				$elm$json$Json$Encode$string(
					$author$project$Data$Network$toString(model.network))),
				_Utils_Tuple2(
				'networkCategories',
				$elm$json$Json$Encode$object(
					A2($author$project$Data$Location$NetworkCategories$encode, networkCategories, model.network)))
			]));
};
var $author$project$Location$Details$Editor$Model$OnUpdatedLdpSpecialOpenHours = function (a) {
	return {$: 'OnUpdatedLdpSpecialOpenHours', a: a};
};
var $author$project$Location$Details$Editor$Model$SpecialOpenHoursNoRegularHours = {$: 'SpecialOpenHoursNoRegularHours'};
var $author$project$Location$Details$Editor$Confirm$ConfirmedUpdateSelectedLocations = function (a) {
	return {$: 'ConfirmedUpdateSelectedLocations', a: a};
};
var $author$project$Location$Details$Editor$Model$OnUpdatedSideBarSpecialOpenHours = function (a) {
	return {$: 'OnUpdatedSideBarSpecialOpenHours', a: a};
};
var $author$project$Location$Details$Editor$Confirm$ConfirmedScheduleSelectedLocations = F3(
	function (a, b, c) {
		return {$: 'ConfirmedScheduleSelectedLocations', a: a, b: b, c: c};
	});
var $author$project$Location$Details$Editor$Confirm$ConfirmedDeleteScheduleSelectedLocations = F2(
	function (a, b) {
		return {$: 'ConfirmedDeleteScheduleSelectedLocations', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationSelector$deselectLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_selector.deselect_locations');
};
var $author$project$PinMeToPage$translatePluralValue = F3(
	function (session, key, count) {
		return A4($author$project$Common$Language$i18n, session.translations, session.language, key, count);
	});
var $author$project$Location$Details$Editor$LocationSelector$LocationsNeedsVerification$createLocationsDict = F2(
	function (data, session) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (data_) {
					return _Utils_Tuple2(
						data_.locationId,
						A3(
							$author$project$PinMeToPage$translatePluralValue,
							session,
							'listings.location_selector.number_of_services',
							$elm$core$List$length(data_.serviceItems)));
				},
				data));
	});
var $author$project$Translations$Listings$LocationSelector$googleServicesVerificationAlert = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_selector.google_services_verification_alert');
};
var $author$project$Location$Details$Editor$LocationSelector$LocationsNeedsVerification$createNeedsVerification = F2(
	function (data, session) {
		var locationsDict = A2($author$project$Location$Details$Editor$LocationSelector$LocationsNeedsVerification$createLocationsDict, data, session);
		var needsVerification = {
			alertText: $author$project$Translations$Listings$LocationSelector$googleServicesVerificationAlert(session.translations),
			locations: locationsDict,
			columnTitle: $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesTitle(session.translations),
			alertButtonLabel: $author$project$Translations$Listings$LocationSelector$deselectLocations(session.translations)
		};
		return needsVerification;
	});
var $author$project$Location$Details$Editor$LocationSelector$LocationsNeedsVerification$locationsNeedsVerificationOnLocationSelector = F3(
	function (content, data, session) {
		if ((content.$ === 'Editor') && (content.a.$ === 'GoogleServiceItems')) {
			return $elm$core$Maybe$Just(
				A2($author$project$Location$Details$Editor$LocationSelector$LocationsNeedsVerification$createNeedsVerification, data, session));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Location$Details$Editor$Update$update = F4(
	function (config, session, msg, model) {
		var location = model.location;
		var getLocationsWithOverlappingSpecialOpenHours = function (errorMessage) {
			var errorsList = A2($elm$core$String$split, '|', errorMessage);
			var allIdsFromValidation = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (item) {
						return $elm$core$List$head(
							A2($elm$core$String$split, ':', item));
					},
					errorsList));
			var locationIds = $elm$core$Set$toList(
				$elm$core$Set$fromList(allIdsFromValidation));
			return locationIds;
		};
		switch (msg.$) {
			case 'UiSelectorLocationWithFiltersMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{locationSelector: x});
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorLocationWithFilters$update,
						{
							api: $author$project$PinMeTo$Api$SelectorApi$filteredLocationApi(
								{
									realm: $author$project$PinMeTo$Api$SelectorApi$Places,
									network: $author$project$PinMeTo$Api$SelectorApi$All,
									siteName: $author$project$Data$SiteName$toString(config.siteName)
								}),
							tagger: A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$UiSelectorLocationWithFiltersMsg, config.tagger),
							onChange: A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$OnSelectLocations, config.tagger)
						},
						msg_,
						model.locationSelector));
			case 'OnSelectLocations':
				var locationIds = msg.a;
				var _v1 = A3($author$project$Location$Details$Editor$Update$onLocationsSelected, config.siteName, locationIds, model.content);
				var updatedContent = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{content: updatedContent, selectedLocations: locationIds}),
					A2($elm$core$Platform$Cmd$map, config.tagger, cmd));
			case 'OnSelectSchedulingDate':
				var newDate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedDate: $elm$core$Maybe$Just(newDate)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnRemoveSchedulingDate':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedDate: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'ConfirmCancel':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{confirm: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmit':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							confirm: function () {
								var _v2 = model.content;
								if (_v2.$ === 'Editor') {
									switch (_v2.a.$) {
										case 'OpenStatus':
											var openStatusModel = _v2.a.a;
											var isoStringToday = $justinmimbs$date$Date$toIsoString(
												A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.now));
											var _v3 = A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												_Utils_Tuple2(isoStringToday, model.now),
												function (date) {
													return _Utils_Tuple2(
														$justinmimbs$date$Date$toIsoString(date),
														$author$project$Location$Details$Editor$Update$dateToPosix(date));
												},
												$author$project$Location$Details$PopupContent$OpenStatus$schedulingDate(openStatusModel));
											var isoStringDate = _v3.a;
											var posixDate = _v3.b;
											return (!_Utils_eq(isoStringDate, isoStringToday)) ? $elm$core$Maybe$Just(
												A3(
													$author$project$Location$Details$Editor$Confirm$ConfirmedScheduleSelectedLocations,
													model.selectedLocations,
													posixDate,
													A2(
														$author$project$Location$Details$Editor$Model$editorStateToHumanReadable,
														$author$project$Location$Details$Editor$Model$OpenStatus(openStatusModel),
														session.translations))) : $elm$core$Maybe$Just(
												$author$project$Location$Details$Editor$Confirm$ConfirmedUpdateSelectedLocations(model.selectedLocations));
										case 'TemporarilyClosed':
											var temporarilyClosedModel = _v2.a.a;
											var isoStringToday = $justinmimbs$date$Date$toIsoString(
												A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.now));
											var _v4 = A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												_Utils_Tuple2(isoStringToday, model.now),
												function (date) {
													return _Utils_Tuple2(
														$justinmimbs$date$Date$toIsoString(date),
														$author$project$Location$Details$Editor$Update$dateToPosix(date));
												},
												temporarilyClosedModel.selectedFromDate);
											var isoStringDate = _v4.a;
											var posixDate = _v4.b;
											return (!_Utils_eq(isoStringDate, isoStringToday)) ? $elm$core$Maybe$Just(
												A3(
													$author$project$Location$Details$Editor$Confirm$ConfirmedScheduleSelectedLocations,
													model.selectedLocations,
													posixDate,
													A2(
														$author$project$Location$Details$Editor$Model$editorStateToHumanReadable,
														$author$project$Location$Details$Editor$Model$TemporarilyClosed(temporarilyClosedModel),
														session.translations))) : $elm$core$Maybe$Just(
												$author$project$Location$Details$Editor$Confirm$ConfirmedUpdateSelectedLocations(model.selectedLocations));
										default:
											var state = _v2.a;
											if (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing)) {
												var posixDate = A3(
													$elm_community$maybe_extra$Maybe$Extra$unwrap,
													model.now,
													function (date) {
														return $author$project$Location$Details$Editor$Update$dateToPosix(date);
													},
													model.selectedDate);
												return $elm$core$Maybe$Just(
													A3(
														$author$project$Location$Details$Editor$Confirm$ConfirmedScheduleSelectedLocations,
														model.selectedLocations,
														posixDate,
														A2($author$project$Location$Details$Editor$Model$editorStateToHumanReadable, state, session.translations)));
											} else {
												return $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Confirm$ConfirmedUpdateSelectedLocations(model.selectedLocations));
											}
									}
								} else {
									var scheduledUpdate = _v2.a;
									return $elm$core$Maybe$Just(
										A2($author$project$Location$Details$Editor$Confirm$ConfirmedDeleteScheduleSelectedLocations, model.selectedLocations, scheduledUpdate.date));
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 'ConfirmedUpdate':
				switch (msg.a.$) {
					case 'ConfirmedScheduleSelectedLocations':
						var _v5 = msg.a;
						var locations = _v5.a;
						var scheduleDate = _v5.b;
						var wrapScheduling = F3(
							function (fieldName, stringDate, updateData) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'locations',
											A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
											_Utils_Tuple2('updateData', updateData),
											_Utils_Tuple2(
											'fieldToUpdate',
											$elm$json$Json$Encode$string(fieldName)),
											_Utils_Tuple2(
											'date',
											$elm$json$Json$Encode$string(stringDate))
										]));
							});
						var formatDate = function (posix) {
							return A2(
								$elm$core$String$left,
								10,
								$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix));
						};
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing}),
							function () {
								var _v6 = model.content;
								_v6$10:
								while (true) {
									if (_v6.$ === 'Editor') {
										switch (_v6.a.$) {
											case 'OpenHours':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'openHours',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$Hours]),
																_Utils_update(
																	location,
																	{openHours: editorModel.openHours})))));
											case 'OpenStatus':
												var editorModel = _v6.a.a;
												var newScheduleDate = A3(
													$elm_community$maybe_extra$Maybe$Extra$unwrap,
													model.now,
													$author$project$Location$Details$Editor$Update$dateToPosix,
													$author$project$Location$Details$PopupContent$OpenStatus$schedulingDate(editorModel));
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															$author$project$Location$Details$PopupContent$OpenStatus$fieldName(editorModel),
															formatDate(newScheduleDate),
															A2($author$project$Location$Details$PopupContent$OpenStatus$encode, model.now, editorModel))));
											case 'TemporarilyClosed':
												var editorModel = _v6.a.a;
												var newScheduleDate = A3(
													$elm_community$maybe_extra$Maybe$Extra$unwrap,
													model.now,
													function (date) {
														return $author$project$Location$Details$Editor$Update$dateToPosix(date);
													},
													editorModel.selectedFromDate);
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'temporarilyClosed',
															formatDate(newScheduleDate),
															$author$project$Location$Details$PopupContent$TemporarilyClosed$encode(editorModel))));
											case 'PermanentlyClosed':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'permanentlyClosed',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$PermanentlyClosed]),
																_Utils_update(
																	location,
																	{permanentlyClosed: editorModel.permanentlyClosedStatus})))));
											case 'Phone':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'contact.phone',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$Phone]),
																_Utils_update(
																	location,
																	{phone: editorModel.phoneNumber})))));
											case 'Address':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'address',
															formatDate(scheduleDate),
															$author$project$Location$Details$PopupContent$Address$encode(editorModel))));
											case 'Email':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'contact.email',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$Email]),
																_Utils_update(
																	location,
																	{
																		email: $author$project$Location$Details$PopupContent$Email$validatedEmailToEmail(editorModel.email)
																	})))));
											case 'Homepage':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'contact.homepage',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$Homepage]),
																_Utils_update(
																	location,
																	{
																		homepage: $author$project$Location$Details$PopupContent$Homepage$validatedHomepageToMaybeHomepage(editorModel.homepage)
																	})))));
											case 'LongDescription':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'longDescription',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$LongDescription]),
																_Utils_update(
																	location,
																	{
																		longDescription: $author$project$Location$Details$PopupContent$LongDescription$validatedLongDescriptionToLongDescription(editorModel.longDescription)
																	})))));
											case 'ShortDescription':
												var editorModel = _v6.a.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$Editor$Model$OnScheduled,
														A3(
															wrapScheduling,
															'shortDescription',
															formatDate(scheduleDate),
															A2(
																$author$project$Data$Location$fieldsInLocationEncoder,
																_List_fromArray(
																	[$author$project$Data$Location$Field$About]),
																_Utils_update(
																	location,
																	{about: editorModel.shortDescription})))));
											default:
												break _v6$10;
										}
									} else {
										break _v6$10;
									}
								}
								return $elm$core$Platform$Cmd$none;
							}());
					case 'ConfirmedDeleteScheduleSelectedLocations':
						var _v7 = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing}),
							function () {
								var _v8 = model.content;
								if (_v8.$ === 'ScheduledUpdate') {
									var scheduleId = _v8.a.scheduleId;
									return A2(
										$elm$core$Platform$Cmd$map,
										config.tagger,
										A2(config.deleteCommand, scheduleId, $author$project$Location$Details$Editor$Model$OnDeleteSchedule));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					default:
						var locations = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: true}),
							function () {
								var wrapSideBarSpecialOpenHours = function (specialOpenHours) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'locationIds',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
												_Utils_Tuple2(
												'specialOpenHours',
												A2(
													$elm$json$Json$Encode$list,
													$author$project$Data$Location$SpecialOpenHours$encode,
													A2(
														$elm$core$List$sortBy,
														function (record) {
															return $elm$time$Time$posixToMillis(record.startDate);
														},
														specialOpenHours)))
											]));
								};
								var wrap = function (updateData) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'locations',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
												_Utils_Tuple2('updateData', updateData)
											]));
								};
								var cmd = function () {
									var _v17 = model.trackingInfo;
									if (_v17.$ === 'Just') {
										var trackingInfo_ = _v17.a;
										return $author$project$PlanHat$PlanHat$track(trackingInfo_);
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								}();
								var _v9 = model.content;
								if (_v9.$ === 'ScheduledUpdate') {
									return $elm$core$Platform$Cmd$none;
								} else {
									var editor = _v9.a;
									switch (editor.$) {
										case 'Active':
											var editorModel = editor.a;
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																$author$project$Location$Details$PopupContent$Active$encode(editorModel)))),
														cmd
													]));
										case 'AlternativeSearchNames':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$AlternativeSearchNames$encode(editorModel))));
										case 'Address':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$Address$encode(editorModel))));
										case 'Categories':
											var editorModel = editor.b;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$Categories$encodeWithNetworkCategories(editorModel))));
										case 'GoogleServiceItems':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Data$Location$NetworkServiceItems$encodeGoogleServiceItems(
															A2($elm$core$List$map, $author$project$Common$Validators$ValidatedItem$unwrap, editorModel.selectedServices)))));
										case 'GoogleAttributes':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.saveGoogleAttributes,
													{
														attributes: $author$project$Location$Details$PopupContent$GoogleAttributes$attributesToSave(editorModel),
														locationIds: locations,
														emptiedAttributeIds: $author$project$Location$Details$PopupContent$GoogleAttributes$emptiedAttributeIds(editorModel)
													},
													$author$project$Location$Details$Editor$Model$OnUpdated));
										case 'SocialMessaging':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.saveGoogleSocialLinks,
													{
														attributes: $author$project$Location$Details$PopupContent$SocialMessaging$attributesToSave(editorModel),
														locationIds: locations,
														emptiedAttributeIds: $author$project$Location$Details$PopupContent$SocialMessaging$emptiedAttributeIds(editorModel)
													},
													$author$project$Location$Details$Editor$Model$OnUpdated));
										case 'ActionLinks':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$ActionLinks$encode(editorModel))));
										case 'Coordinates':
											var editorModel = editor.a;
											var _v11 = $author$project$Data$ValidatedCoordinates$encode(editorModel.coordinates);
											if (_v11.$ === 'Just') {
												var encoded = _v11.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.updateCommand,
														$author$project$Location$Details$Editor$Model$OnUpdated,
														wrap(encoded)));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										case 'CustomNameOnNetwork':
											var network = editor.a;
											var editorModel = editor.b;
											var _v12 = A2($author$project$Data$ValidatedCustomNameOnNetwork$encode, editorModel.customName, network);
											if (_v12.$ === 'Just') {
												var encoded = _v12.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.updateCommand,
														$author$project$Location$Details$Editor$Model$OnUpdated,
														wrap(encoded)));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										case 'Email':
											var editorModel = editor.a;
											var _v13 = $author$project$Data$ValidatedEmail$encode(editorModel.email);
											if (_v13.$ === 'Just') {
												var encoded = _v13.a;
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2(
															$elm$core$Platform$Cmd$map,
															config.tagger,
															A2(
																config.updateCommand,
																$author$project$Location$Details$Editor$Model$OnUpdated,
																wrap(encoded))),
															cmd
														]));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										case 'Homepage':
											var editorModel = editor.a;
											var _v14 = $author$project$Data$ValidatedHomepage$encode(editorModel.homepage);
											if (_v14.$ === 'Just') {
												var encoded = _v14.a;
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2(
															$elm$core$Platform$Cmd$map,
															config.tagger,
															A2(
																config.updateCommand,
																$author$project$Location$Details$Editor$Model$OnUpdated,
																wrap(encoded))),
															cmd
														]));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										case 'OpenHours':
											var editorModel = editor.a;
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																A2(
																	$author$project$Data$Location$fieldsInLocationEncoder,
																	_List_fromArray(
																		[$author$project$Data$Location$Field$Hours]),
																	_Utils_update(
																		location,
																		{openHours: editorModel.openHours}))))),
														cmd
													]));
										case 'Wifi':
											var editorModel = editor.a;
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																A2(
																	$author$project$Data$Location$fieldsInLocationEncoder,
																	_List_fromArray(
																		[$author$project$Data$Location$Field$Wifi]),
																	_Utils_update(
																		location,
																		{wifiSsId: editorModel.wifi}))))),
														cmd
													]));
										case 'StoreId':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$StoreId$encode(editorModel))));
										case 'StorefrontName':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$StorefrontName$encode(editorModel))));
										case 'OpenStatus':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														A2($author$project$Location$Details$PopupContent$OpenStatus$encode, model.now, editorModel))));
										case 'TemporarilyClosed':
											var editorModel = editor.a;
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																$author$project$Location$Details$PopupContent$TemporarilyClosed$encode(editorModel)))),
														cmd
													]));
										case 'ShortDescription':
											var editorModel = editor.a;
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																$author$project$Location$Details$PopupContent$ShortDescription$encode(editorModel)))),
														cmd
													]));
										case 'Phone':
											var editorModel = editor.a;
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																$author$project$Location$Details$PopupContent$Phone$encode(editorModel)))),
														cmd
													]));
										case 'PermanentlyClosed':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$PermanentlyClosed$encode(editorModel.permanentlyClosedStatus))));
										case 'OpeningDate':
											var editorModel = editor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$Editor$Model$OnUpdated,
													wrap(
														$author$project$Location$Details$PopupContent$OpeningDate$encode(editorModel))));
										case 'LongDescription':
											var editorModel = editor.a;
											var _v15 = $author$project$Data$ValidatedLongDescription$encode(editorModel.longDescription);
											if (_v15.$ === 'Just') {
												var encoded = _v15.a;
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2(
															$elm$core$Platform$Cmd$map,
															config.tagger,
															A2(
																config.updateCommand,
																$author$project$Location$Details$Editor$Model$OnUpdated,
																wrap(encoded))),
															cmd
														]));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										case 'LocationDescriptor':
											var editorModel = editor.a;
											var _v16 = $author$project$Data$ValidatedLocationDescriptor$encode(editorModel.locationDescriptor);
											if (_v16.$ === 'Just') {
												var encoded = _v16.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.updateCommand,
														$author$project$Location$Details$Editor$Model$OnUpdated,
														wrap(encoded)));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										default:
											var editorModel = editor.a;
											return _Utils_eq(editorModel.sourceCall, $author$project$Location$Details$PopupContent$SpecialOpenHours$SideBar) ? $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														$elm$core$Platform$Cmd$none,
														function (updateCommandSideBarSpecialOpenHours) {
															return A2(
																$elm$core$Platform$Cmd$map,
																config.tagger,
																A2(
																	updateCommandSideBarSpecialOpenHours,
																	$author$project$Location$Details$Editor$Model$OnUpdatedSideBarSpecialOpenHours,
																	wrapSideBarSpecialOpenHours(
																		$author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList(editorModel))));
														},
														config.updateCommandSideBarSpecialOpenHours),
														cmd
													])) : (_Utils_eq(editorModel.sourceCall, $author$project$Location$Details$PopupContent$SpecialOpenHours$LDP) ? $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														$elm$core$Platform$Cmd$none,
														function (updateCommandLdpSpecialOpenHours) {
															return A2(
																$elm$core$Platform$Cmd$map,
																config.tagger,
																A2(
																	updateCommandLdpSpecialOpenHours,
																	$author$project$Location$Details$Editor$Model$OnUpdatedLdpSpecialOpenHours,
																	wrapSideBarSpecialOpenHours(
																		$author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList(editorModel))));
														},
														config.updateCommandLdpSpecialOpenHours),
														cmd
													])) : $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Platform$Cmd$map,
														config.tagger,
														A2(
															config.updateCommand,
															$author$project$Location$Details$Editor$Model$OnUpdated,
															wrap(
																A2(
																	$author$project$Data$Location$fieldsInLocationEncoder,
																	_List_fromArray(
																		[$author$project$Data$Location$Field$SpecialHours]),
																	_Utils_update(
																		location,
																		{
																			specialOpenHours: $author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList(editorModel)
																		}))))),
														cmd
													])));
									}
								}
							}());
				}
			case 'OnUpdatedSideBarSpecialOpenHours':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var sideBarUpdate = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: false}),
						A2(
							$elm$core$Task$perform,
							config.onUpdatedSideBarSpecialOpenHours,
							$elm$core$Task$succeed(sideBarUpdate.storeIds)));
				} else {
					var error = result.a;
					var _v19 = model.content;
					if ((_v19.$ === 'Editor') && (_v19.a.$ === 'SpecialOpenHours')) {
						var errorMessage = $author$project$PinMeTo$ExpectJson$getErrorMessage(error);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									error: A2($elm$core$String$contains, 'regular open hours must be set', errorMessage) ? $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed($author$project$Location$Details$Editor$Model$SpecialOpenHoursNoRegularHours)) : (A2($elm$core$String$contains, 'overlap', errorMessage) ? $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
											$author$project$Location$Details$Editor$Model$SpecialOpenHoursOverlap(
												getLocationsWithOverlappingSpecialOpenHours(errorMessage)))) : $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
											$author$project$Location$Details$Editor$Model$Unknown(errorMessage)))),
									confirm: $elm$core$Maybe$Nothing,
									showSavingProgress: false
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
								error));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
											$author$project$Location$Details$Editor$Model$Unknown(
												$author$project$PinMeTo$ExpectJson$getErrorMessage(error)))),
									confirm: $elm$core$Maybe$Nothing,
									showSavingProgress: false
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
								error));
					}
				}
			case 'OnUpdatedLdpSpecialOpenHours':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var sideBarUpdate = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: false}),
						A2(
							$elm$core$Task$perform,
							config.onUpdatedLdpSpecialOpenHours,
							$elm$core$Task$succeed(sideBarUpdate.location)));
				} else {
					var error = result.a;
					var _v21 = model.content;
					if ((_v21.$ === 'Editor') && (_v21.a.$ === 'SpecialOpenHours')) {
						var errorMessage = $author$project$PinMeTo$ExpectJson$getErrorMessage(error);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									error: A2($elm$core$String$contains, 'regular open hours must be set', errorMessage) ? $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed($author$project$Location$Details$Editor$Model$SpecialOpenHoursNoRegularHours)) : (A2($elm$core$String$contains, 'overlap', errorMessage) ? $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
											$author$project$Location$Details$Editor$Model$SpecialOpenHoursOverlap(
												getLocationsWithOverlappingSpecialOpenHours(errorMessage)))) : $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
											$author$project$Location$Details$Editor$Model$Unknown(errorMessage)))),
									confirm: $elm$core$Maybe$Nothing,
									showSavingProgress: false
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
								error));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
											$author$project$Location$Details$Editor$Model$Unknown(
												$author$project$PinMeTo$ExpectJson$getErrorMessage(error)))),
									confirm: $elm$core$Maybe$Nothing,
									showSavingProgress: false
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
								error));
					}
				}
			case 'OnUpdated':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var partialUpdate = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: false}),
						A2(
							$elm$core$Task$perform,
							config.onUpdated,
							$elm$core$Task$succeed(partialUpdate.location)));
				} else {
					var error = result.a;
					var _v23 = model.content;
					_v23$2:
					while (true) {
						if (_v23.$ === 'Editor') {
							switch (_v23.a.$) {
								case 'StoreId':
									var errorMessage = $author$project$PinMeTo$ExpectJson$getErrorMessage(error);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												error: A2($elm$core$String$startsWith, 'You already have a location with store id', errorMessage) ? $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Model$PartialUpdateFailed($author$project$Location$Details$Editor$Model$StoreIdExists)) : (A2($elm$core$String$startsWith, 'You already have a facebook location with store id', errorMessage) ? $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Model$PartialUpdateFailed($author$project$Location$Details$Editor$Model$FacebookStoreIdExists)) : $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
														$author$project$Location$Details$Editor$Model$Unknown(errorMessage)))),
												confirm: $elm$core$Maybe$Nothing,
												showSavingProgress: false
											}),
										A2(
											$author$project$PinMeTo$ExpectJson$logError,
											$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
											error));
								case 'SpecialOpenHours':
									var errorMessage = $author$project$PinMeTo$ExpectJson$getErrorMessage(error);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												error: A2($elm$core$String$contains, 'regular open hours must be set', errorMessage) ? $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Model$PartialUpdateFailed($author$project$Location$Details$Editor$Model$SpecialOpenHoursNoRegularHours)) : (A2($elm$core$String$contains, 'overlap', errorMessage) ? $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
														$author$project$Location$Details$Editor$Model$SpecialOpenHoursOverlap(
															getLocationsWithOverlappingSpecialOpenHours(errorMessage)))) : $elm$core$Maybe$Just(
													$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
														$author$project$Location$Details$Editor$Model$Unknown(errorMessage)))),
												confirm: $elm$core$Maybe$Nothing,
												showSavingProgress: false
											}),
										A2(
											$author$project$PinMeTo$ExpectJson$logError,
											$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
											error));
								default:
									break _v23$2;
							}
						} else {
							break _v23$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									$author$project$Location$Details$Editor$Model$PartialUpdateFailed(
										$author$project$Location$Details$Editor$Model$Unknown(
											$author$project$PinMeTo$ExpectJson$getErrorMessage(error)))),
								confirm: $elm$core$Maybe$Nothing,
								showSavingProgress: false
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
							error));
				}
			case 'EditorMsg':
				var editorMsg = msg.a;
				var _v24 = model.content;
				if (_v24.$ === 'ScheduledUpdate') {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var editor = _v24.a;
					switch (editorMsg.$) {
						case 'ActiveMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Active') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$Active(
													A2($author$project$Location$Details$PopupContent$Active$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'AlternativeSearchNamesMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'AlternativeSearchNames') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$AlternativeSearchNames(
													A2($author$project$Location$Details$PopupContent$AlternativeSearchNames$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'AddressMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Address') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (m) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$Address(m))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$AddressMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$Address$update, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'CategoriesMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Categories') {
								var network = editor.a;
								var editorModel = editor.b;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (x) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													A2($author$project$Location$Details$Editor$Model$Categories, network, x))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$CategoriesMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$Categories$update, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'GoogleAttributesMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'GoogleAttributes') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (m) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$GoogleAttributes(m))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$GoogleAttributesMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A3($author$project$Location$Details$PopupContent$GoogleAttributes$update, config.siteName, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'SocialMessagingMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'SocialMessaging') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (m) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$SocialMessaging(m))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$SocialMessagingMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A3($author$project$Location$Details$PopupContent$SocialMessaging$update, config.siteName, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'GoogleServiceItemsMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'GoogleServiceItems') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (model_) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$GoogleServiceItems(model_))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$GoogleServiceItemsMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$GoogleServiceItems$update, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'ActionLinksMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'ActionLinks') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (x) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$ActionLinks(x))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$ActionLinksMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$ActionLinks$update, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'CoordinatesMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Coordinates') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$Coordinates(
													A2($author$project$Location$Details$PopupContent$Coordinates$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'CustomNameOnNetworkMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'CustomNameOnNetwork') {
								var network = editor.a;
								var editorModel = editor.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												A2(
													$author$project$Location$Details$Editor$Model$CustomNameOnNetwork,
													network,
													A2($author$project$Location$Details$PopupContent$CustomNameOnNetwork$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'EmailMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Email') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$Email(
													A2($author$project$Location$Details$PopupContent$Email$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'HomepageMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Homepage') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$Homepage(
													A2($author$project$Location$Details$PopupContent$Homepage$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'OpenHoursMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'OpenHours') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (x) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$OpenHours(x))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$OpenHoursMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$OpenHours$update, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'OpenStatusMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'OpenStatus') {
								var editorModel = editor.a;
								if (msg_.$ === 'DeleteScheduled') {
									var scheduleId = msg_.a;
									return _Utils_Tuple2(
										model,
										A2(
											$elm$core$Platform$Cmd$map,
											config.tagger,
											A2(config.deleteCommand, scheduleId, $author$project$Location$Details$Editor$Model$OnDeleteSchedule)));
								} else {
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$OpenStatus(
														A2($author$project$Location$Details$PopupContent$OpenStatus$update, msg_, editorModel)))
											}),
										$elm$core$Platform$Cmd$none);
								}
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'WifiMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Wifi') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$Wifi(
													A2($author$project$Location$Details$PopupContent$Wifi$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'StoreIdMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'StoreId') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$StoreId(
													A2($author$project$Location$Details$PopupContent$StoreId$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'StorefrontNameMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'StorefrontName') {
								var editorModel = editor.a;
								var _v44 = A2($author$project$Location$Details$PopupContent$StorefrontName$update, msg_, editorModel);
								var newEditorModel = _v44.a;
								var editorCmd = _v44.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$StorefrontName(newEditorModel))
										}),
									A2(
										$elm$core$Platform$Cmd$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$StorefrontNameMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger)),
										editorCmd));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'TemporarilyClosedMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'TemporarilyClosed') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$TemporarilyClosed(
													A2($author$project$Location$Details$PopupContent$TemporarilyClosed$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'ShortDescriptionMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'ShortDescription') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$ShortDescription(
													A2($author$project$Location$Details$PopupContent$ShortDescription$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'PhoneMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'Phone') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$Phone(
													A2($author$project$Location$Details$PopupContent$Phone$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'PermanentlyClosedMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'PermanentlyClosed') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$PermanentlyClosed(
													A2($author$project$Location$Details$PopupContent$PermanentlyClosed$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'OpeningDateMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'OpeningDate') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$OpeningDate(
													A2($author$project$Location$Details$PopupContent$OpeningDate$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'LongDescriptionMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'LongDescription') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$LongDescription(
													A2($author$project$Location$Details$PopupContent$LongDescription$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						case 'LocationDescriptorMsg':
							var msg_ = editorMsg.a;
							if (editor.$ === 'LocationDescriptor') {
								var editorModel = editor.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											content: $author$project$Location$Details$Editor$Model$Editor(
												$author$project$Location$Details$Editor$Model$LocationDescriptor(
													A2($author$project$Location$Details$PopupContent$LocationDescriptor$update, msg_, editorModel)))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						default:
							var msg_ = editorMsg.a;
							if (editor.$ === 'SpecialOpenHours') {
								var editorModel = editor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (x) {
										return _Utils_update(
											model,
											{
												content: $author$project$Location$Details$Editor$Model$Editor(
													$author$project$Location$Details$Editor$Model$SpecialOpenHours(x))
											});
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$Editor$Model$SpecialOpenHoursMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$EditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$SpecialOpenHours$update, msg_, editorModel));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
					}
				}
			case 'OnScheduled':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var data = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing}),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							function (onScheduled) {
								return A2(
									$elm$core$Task$perform,
									onScheduled,
									$elm$core$Task$succeed(data));
							},
							config.onScheduled));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just($author$project$Location$Details$Editor$Model$ScheduleUpdateFailed)
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
							error));
				}
			case 'OnDeleteSchedule':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var data = result.a;
					var _v55 = model.content;
					if ((_v55.$ === 'Editor') && (_v55.a.$ === 'OpenStatus')) {
						var editorModel = _v55.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Nothing,
									confirm: $elm$core$Maybe$Nothing,
									content: $author$project$Location$Details$Editor$Model$Editor(
										$author$project$Location$Details$Editor$Model$OpenStatus(
											_Utils_update(
												editorModel,
												{scheduledUpdates: data})))
								}),
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Platform$Cmd$none,
								function (onScheduleUpdatesRefreshed) {
									return A2(
										$elm$core$Task$perform,
										onScheduleUpdatesRefreshed,
										$elm$core$Task$succeed(data));
								},
								config.onScheduleUpdatesRefreshed));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing}),
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Platform$Cmd$none,
								function (onDeleteSchedule) {
									return A2(
										$elm$core$Task$perform,
										onDeleteSchedule,
										$elm$core$Task$succeed(data));
								},
								config.onDeleteSchedule));
					}
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just($author$project$Location$Details$Editor$Model$ScheduleUpdateFailed)
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
							error));
				}
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(config.tagger),
					A2(
						$elm$core$Tuple$mapFirst,
						function (updatedUiPopover) {
							return _Utils_update(
								model,
								{popOverState: updatedUiPopover});
						},
						A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Location$Details$Editor$Model$UiPopOverMsg, msg_, model.popOverState)));
			case 'OnUnselectConflictingLocations':
				var locationIds = msg.a;
				var newSelectedLocations = A2(
					$elm$core$List$filter,
					function (locationId) {
						return !A2($elm$core$List$member, locationId, locationIds);
					},
					model.selectedLocations);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, selectedLocations: newSelectedLocations}),
					$elm$core$Platform$Cmd$none);
			default:
				var locationsWithField = msg.a;
				if (locationsWithField.$ === 'Ok') {
					var data = locationsWithField.a;
					var locationsWithFieldWithoutCurrentLocation = A2(
						$elm$core$List$filter,
						function (locationWithField) {
							return !_Utils_eq(locationWithField.locationId, location.id);
						},
						data);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationsNeedsVerificationOnLocationSelector: A3($author$project$Location$Details$Editor$LocationSelector$LocationsNeedsVerification$locationsNeedsVerificationOnLocationSelector, model.content, locationsWithFieldWithoutCurrentLocation, session)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = locationsWithField.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{locationsNeedsVerificationOnLocationSelector: $elm$core$Maybe$Nothing}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Editor'),
							error));
				}
		}
	});
var $author$project$Location$Details$Editor$update = F4(
	function (config, session, msg, _v0) {
		var model = _v0.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Location$Details$Editor$State,
			A4($author$project$Location$Details$Editor$Update$update, config, session, msg, model));
	});
var $author$project$Common$PaginationSimple$changePage = F2(
	function (newPage, pagination) {
		return _Utils_update(
			pagination,
			{value: newPage + 1, currentPage: newPage});
	});
var $author$project$Common$PaginationSimple$updateItem = F3(
	function (id, f, pagination) {
		return _Utils_update(
			pagination,
			{
				items: A3(
					$elm$core$Dict$update,
					id,
					function (item) {
						return A2($elm$core$Maybe$map, f, item);
					},
					pagination.items)
			});
	});
var $author$project$Location$Details$Editor$AddressEditor = {$: 'AddressEditor'};
var $author$project$Common$PaginationSimple$Pagination = F4(
	function (currentPage, value, keys, items) {
		return {keys: keys, items: items, value: value, currentPage: currentPage};
	});
var $author$project$Common$PaginationSimple$initWithItems = F2(
	function (items, f) {
		return A4(
			$author$project$Common$PaginationSimple$Pagination,
			0,
			1,
			$elm$core$Array$fromList(
				A2($elm$core$List$map, f, items)),
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (x) {
						return _Utils_Tuple2(
							f(x),
							x);
					},
					items)));
	});
var $author$project$Common$PaginationSimple$setInputValue = F2(
	function (newPage, pagination) {
		return _Utils_update(
			pagination,
			{value: newPage});
	});
var $author$project$ApiPendingChanges$Resolver$Update$setPublishing = F2(
	function (x, field) {
		if (_Utils_eq(field, $author$project$Data$Location$Field$Address)) {
			var state_ = x.addressChangeState;
			var state = _Utils_update(
				state_,
				{isPublishing: true});
			return _Utils_update(
				x,
				{addressChangeState: state});
		} else {
			var state_ = x.coordinatesChangeState;
			var state = _Utils_update(
				state_,
				{isPublishing: true});
			return _Utils_update(
				x,
				{coordinatesChangeState: state});
		}
	});
var $ohanhi$keyboard$Keyboard$oneOf = F2(
	function (fns, key) {
		oneOf:
		while (true) {
			if (!fns.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var fn = fns.a;
				var rest = fns.b;
				var _v1 = fn(key);
				if (_v1.$ === 'Just') {
					var a = _v1.a;
					return $elm$core$Maybe$Just(a);
				} else {
					var $temp$fns = rest,
						$temp$key = key;
					fns = $temp$fns;
					key = $temp$key;
					continue oneOf;
				}
			}
		}
	});
var $ohanhi$keyboard$Keyboard$Attn = {$: 'Attn'};
var $ohanhi$keyboard$Keyboard$Find = {$: 'Find'};
var $ohanhi$keyboard$Keyboard$Help = {$: 'Help'};
var $ohanhi$keyboard$Keyboard$Play = {$: 'Play'};
var $ohanhi$keyboard$Keyboard$Again = {$: 'Again'};
var $ohanhi$keyboard$Keyboard$Pause = {$: 'Pause'};
var $ohanhi$keyboard$Keyboard$Props = {$: 'Props'};
var $ohanhi$keyboard$Keyboard$Cancel = {$: 'Cancel'};
var $ohanhi$keyboard$Keyboard$Escape = {$: 'Escape'};
var $ohanhi$keyboard$Keyboard$Finish = {$: 'Finish'};
var $ohanhi$keyboard$Keyboard$Select = {$: 'Select'};
var $ohanhi$keyboard$Keyboard$ZoomIn = {$: 'ZoomIn'};
var $ohanhi$keyboard$Keyboard$Execute = {$: 'Execute'};
var $ohanhi$keyboard$Keyboard$ZoomOut = {$: 'ZoomOut'};
var $ohanhi$keyboard$Keyboard$ContextMenu = {$: 'ContextMenu'};
var $ohanhi$keyboard$Keyboard$uiKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Again':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Again);
		case 'Attn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Attn);
		case 'Cancel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cancel);
		case 'ContextMenu':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ContextMenu);
		case 'Escape':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape);
		case 'Execute':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Execute);
		case 'Find':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Find);
		case 'Finish':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Finish);
		case 'Help':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Help);
		case 'Pause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Pause);
		case 'Play':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Play);
		case 'Props':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Props);
		case 'Select':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Select);
		case 'ZoomIn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomIn);
		case 'ZoomOut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomOut);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ChannelUp = {$: 'ChannelUp'};
var $ohanhi$keyboard$Keyboard$MediaPlay = {$: 'MediaPlay'};
var $ohanhi$keyboard$Keyboard$MediaStop = {$: 'MediaStop'};
var $ohanhi$keyboard$Keyboard$MediaPause = {$: 'MediaPause'};
var $ohanhi$keyboard$Keyboard$ChannelDown = {$: 'ChannelDown'};
var $ohanhi$keyboard$Keyboard$MediaRecord = {$: 'MediaRecord'};
var $ohanhi$keyboard$Keyboard$MediaRewind = {$: 'MediaRewind'};
var $ohanhi$keyboard$Keyboard$MediaPlayPause = {$: 'MediaPlayPause'};
var $ohanhi$keyboard$Keyboard$MediaTrackNext = {$: 'MediaTrackNext'};
var $ohanhi$keyboard$Keyboard$MediaFastForward = {$: 'MediaFastForward'};
var $ohanhi$keyboard$Keyboard$MediaTrackPrevious = {$: 'MediaTrackPrevious'};
var $ohanhi$keyboard$Keyboard$mediaKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'ChannelDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelDown);
		case 'ChannelUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelUp);
		case 'MediaFastForward':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaFastForward);
		case 'MediaPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPause);
		case 'MediaPlay':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlay);
		case 'MediaPlayPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlayPause);
		case 'MediaRecord':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRecord);
		case 'MediaRewind':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRewind);
		case 'MediaStop':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaStop);
		case 'MediaTrackNext':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackNext);
		case 'MediaTrackPrevious':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackPrevious);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Call = {$: 'Call'};
var $ohanhi$keyboard$Keyboard$Camera = {$: 'Camera'};
var $ohanhi$keyboard$Keyboard$GoBack = {$: 'GoBack'};
var $ohanhi$keyboard$Keyboard$GoHome = {$: 'GoHome'};
var $ohanhi$keyboard$Keyboard$EndCall = {$: 'EndCall'};
var $ohanhi$keyboard$Keyboard$AppSwitch = {$: 'AppSwitch'};
var $ohanhi$keyboard$Keyboard$VoiceDial = {$: 'VoiceDial'};
var $ohanhi$keyboard$Keyboard$MannerMode = {$: 'MannerMode'};
var $ohanhi$keyboard$Keyboard$CameraFocus = {$: 'CameraFocus'};
var $ohanhi$keyboard$Keyboard$HeadsetHook = {$: 'HeadsetHook'};
var $ohanhi$keyboard$Keyboard$Notification = {$: 'Notification'};
var $ohanhi$keyboard$Keyboard$LastNumberRedial = {$: 'LastNumberRedial'};
var $ohanhi$keyboard$Keyboard$phoneKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'AppSwitch':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AppSwitch);
		case 'Call':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Call);
		case 'Camera':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Camera);
		case 'CameraFocus':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CameraFocus);
		case 'EndCall':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EndCall);
		case 'GoBack':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoBack);
		case 'GoHome':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoHome);
		case 'HeadsetHook':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$HeadsetHook);
		case 'LastNumberRedial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$LastNumberRedial);
		case 'Notification':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Notification);
		case 'MannerMode':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MannerMode);
		case 'VoiceDial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$VoiceDial);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Cut = {$: 'Cut'};
var $ohanhi$keyboard$Keyboard$Copy = {$: 'Copy'};
var $ohanhi$keyboard$Keyboard$Redo = {$: 'Redo'};
var $ohanhi$keyboard$Keyboard$Undo = {$: 'Undo'};
var $ohanhi$keyboard$Keyboard$Clear = {$: 'Clear'};
var $ohanhi$keyboard$Keyboard$CrSel = {$: 'CrSel'};
var $ohanhi$keyboard$Keyboard$ExSel = {$: 'ExSel'};
var $ohanhi$keyboard$Keyboard$Paste = {$: 'Paste'};
var $ohanhi$keyboard$Keyboard$Delete = {$: 'Delete'};
var $ohanhi$keyboard$Keyboard$Insert = {$: 'Insert'};
var $ohanhi$keyboard$Keyboard$EraseEof = {$: 'EraseEof'};
var $ohanhi$keyboard$Keyboard$Backspace = {$: 'Backspace'};
var $ohanhi$keyboard$Keyboard$editingKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Backspace':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Backspace);
		case 'Clear':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Clear);
		case 'Copy':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Copy);
		case 'CrSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CrSel);
		case 'Cut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cut);
		case 'Delete':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Delete);
		case 'EraseEof':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EraseEof);
		case 'ExSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ExSel);
		case 'Insert':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Insert);
		case 'Paste':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Paste);
		case 'Redo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Redo);
		case 'Undo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Undo);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$F1 = {$: 'F1'};
var $ohanhi$keyboard$Keyboard$F2 = {$: 'F2'};
var $ohanhi$keyboard$Keyboard$F3 = {$: 'F3'};
var $ohanhi$keyboard$Keyboard$F4 = {$: 'F4'};
var $ohanhi$keyboard$Keyboard$F5 = {$: 'F5'};
var $ohanhi$keyboard$Keyboard$F6 = {$: 'F6'};
var $ohanhi$keyboard$Keyboard$F7 = {$: 'F7'};
var $ohanhi$keyboard$Keyboard$F8 = {$: 'F8'};
var $ohanhi$keyboard$Keyboard$F9 = {$: 'F9'};
var $ohanhi$keyboard$Keyboard$F10 = {$: 'F10'};
var $ohanhi$keyboard$Keyboard$F11 = {$: 'F11'};
var $ohanhi$keyboard$Keyboard$F12 = {$: 'F12'};
var $ohanhi$keyboard$Keyboard$F13 = {$: 'F13'};
var $ohanhi$keyboard$Keyboard$F14 = {$: 'F14'};
var $ohanhi$keyboard$Keyboard$F15 = {$: 'F15'};
var $ohanhi$keyboard$Keyboard$F16 = {$: 'F16'};
var $ohanhi$keyboard$Keyboard$F17 = {$: 'F17'};
var $ohanhi$keyboard$Keyboard$F18 = {$: 'F18'};
var $ohanhi$keyboard$Keyboard$F19 = {$: 'F19'};
var $ohanhi$keyboard$Keyboard$F20 = {$: 'F20'};
var $ohanhi$keyboard$Keyboard$functionKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'F1':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F1);
		case 'F2':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F2);
		case 'F3':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F3);
		case 'F4':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F4);
		case 'F5':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F5);
		case 'F6':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F6);
		case 'F7':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F7);
		case 'F8':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F8);
		case 'F9':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F9);
		case 'F10':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F10);
		case 'F11':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F11);
		case 'F12':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F12);
		case 'F13':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F13);
		case 'F14':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F14);
		case 'F15':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F15);
		case 'F16':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F16);
		case 'F17':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F17);
		case 'F18':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F18);
		case 'F19':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F19);
		case 'F20':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F20);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Fn = {$: 'Fn'};
var $ohanhi$keyboard$Keyboard$Alt = {$: 'Alt'};
var $ohanhi$keyboard$Keyboard$Meta = {$: 'Meta'};
var $ohanhi$keyboard$Keyboard$Hyper = {$: 'Hyper'};
var $ohanhi$keyboard$Keyboard$Shift = {$: 'Shift'};
var $ohanhi$keyboard$Keyboard$Super = {$: 'Super'};
var $ohanhi$keyboard$Keyboard$FnLock = {$: 'FnLock'};
var $ohanhi$keyboard$Keyboard$Symbol = {$: 'Symbol'};
var $ohanhi$keyboard$Keyboard$Control = {$: 'Control'};
var $ohanhi$keyboard$Keyboard$NumLock = {$: 'NumLock'};
var $ohanhi$keyboard$Keyboard$AltGraph = {$: 'AltGraph'};
var $ohanhi$keyboard$Keyboard$CapsLock = {$: 'CapsLock'};
var $ohanhi$keyboard$Keyboard$ScrollLock = {$: 'ScrollLock'};
var $ohanhi$keyboard$Keyboard$SymbolLock = {$: 'SymbolLock'};
var $ohanhi$keyboard$Keyboard$modifierKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Alt':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Alt);
		case 'AltGraph':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AltGraph);
		case 'CapsLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CapsLock);
		case 'Control':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Control);
		case 'Fn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Fn);
		case 'FnLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$FnLock);
		case 'Hyper':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Hyper);
		case 'Meta':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Meta);
		case 'NumLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$NumLock);
		case 'ScrollLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ScrollLock);
		case 'Shift':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Shift);
		case 'Super':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'OS':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'Symbol':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Symbol);
		case 'SymbolLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$SymbolLock);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$End = {$: 'End'};
var $ohanhi$keyboard$Keyboard$Home = {$: 'Home'};
var $ohanhi$keyboard$Keyboard$PageUp = {$: 'PageUp'};
var $ohanhi$keyboard$Keyboard$ArrowUp = {$: 'ArrowUp'};
var $ohanhi$keyboard$Keyboard$PageDown = {$: 'PageDown'};
var $ohanhi$keyboard$Keyboard$ArrowDown = {$: 'ArrowDown'};
var $ohanhi$keyboard$Keyboard$ArrowLeft = {$: 'ArrowLeft'};
var $ohanhi$keyboard$Keyboard$ArrowRight = {$: 'ArrowRight'};
var $ohanhi$keyboard$Keyboard$navigationKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'ArrowDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'ArrowLeft':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'ArrowRight':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'ArrowUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'Down':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'Left':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'Right':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'Up':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'End':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$End);
		case 'Home':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Home);
		case 'PageDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageDown);
		case 'PageUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageUp);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Tab = {$: 'Tab'};
var $ohanhi$keyboard$Keyboard$Enter = {$: 'Enter'};
var $ohanhi$keyboard$Keyboard$Spacebar = {$: 'Spacebar'};
var $ohanhi$keyboard$Keyboard$whitespaceKey = function (_v0) {
	var value = _v0.a;
	switch (value) {
		case 'Enter':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Enter);
		case 'Tab':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Tab);
		case 'Spacebar':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		case ' ':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$anyKeyWith = function (charParser) {
	return $ohanhi$keyboard$Keyboard$oneOf(
		_List_fromArray(
			[$ohanhi$keyboard$Keyboard$whitespaceKey, charParser, $ohanhi$keyboard$Keyboard$modifierKey, $ohanhi$keyboard$Keyboard$navigationKey, $ohanhi$keyboard$Keyboard$editingKey, $ohanhi$keyboard$Keyboard$functionKey, $ohanhi$keyboard$Keyboard$uiKey, $ohanhi$keyboard$Keyboard$phoneKey, $ohanhi$keyboard$Keyboard$mediaKey]));
};
var $ohanhi$keyboard$Keyboard$Character = function (a) {
	return {$: 'Character', a: a};
};
var $ohanhi$keyboard$Keyboard$characterKeyOriginal = function (_v0) {
	var value = _v0.a;
	return ($elm$core$String$length(value) === 1) ? $elm$core$Maybe$Just(
		$ohanhi$keyboard$Keyboard$Character(value)) : $elm$core$Maybe$Nothing;
};
var $ohanhi$keyboard$Keyboard$anyKeyOriginal = $ohanhi$keyboard$Keyboard$anyKeyWith($ohanhi$keyboard$Keyboard$characterKeyOriginal);
var $author$project$Data$Location$NetworkMedia = F2(
	function (facebook, google) {
		return {google: google, facebook: facebook};
	});
var $author$project$Data$Location$NewReviewUrl = function (a) {
	return {$: 'NewReviewUrl', a: a};
};
var $author$project$Data$Location$NetworkImages = F2(
	function (profileImage, coverImage) {
		return {coverImage: coverImage, profileImage: profileImage};
	});
var $author$project$Data$Location$TemporarilyClosedMessage = function (a) {
	return {$: 'TemporarilyClosedMessage', a: a};
};
var $author$project$ApiPendingChanges$Resolver$Commands$toLocationData = function (location) {
	return {
		id: location.id,
		ptv: $elm$core$Maybe$Nothing,
		bing: $elm$core$Maybe$Nothing,
		name: location.name,
		about: $author$project$Data$Location$ShortDescription(''),
		apple: $elm$core$Maybe$Nothing,
		email: $author$project$Data$Location$Email(''),
		phone: $author$project$Data$Location$Phone(''),
		google: $elm$core$Maybe$Nothing,
		address: location.address,
		storeId: $author$project$Data$Location$StoreId(location.storeId),
		facebook: $elm$core$Maybe$Nothing,
		homepage: $author$project$Data$Location$Homepage(''),
		isActive: $author$project$Data$Location$Active,
		location: location.coordinates,
		wifiSsId: $author$project$Data$Location$WifiSsId(''),
		fbStoreId: $author$project$Data$Location$FacebookStoreId($elm$core$Maybe$Nothing),
		openHours: $author$project$Data$Location$OpenHours$Always,
		customData: $elm$core$Maybe$Nothing,
		actionLinks: _List_Nil,
		openingDate: '',
		locationType: location.locationType,
		networkMedia: A2(
			$author$project$Data$Location$NetworkMedia,
			A2($author$project$Data$Location$NetworkImages, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			A2($author$project$Data$Location$NetworkImages, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
		networkNames: {ptv: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing},
		serviceAreas: location.serviceAreas,
		verification: $elm$core$Maybe$Nothing,
		storefrontName: $author$project$Data$Location$StorefrontName(''),
		longDescription: $author$project$Data$Location$LongDescription(''),
		specialOpenHours: _List_Nil,
		networkAttributes: {google: _List_Nil},
		networkCategories: {bing: $elm$core$Maybe$Nothing, here: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, tomtom: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, overture: $elm$core$Maybe$Nothing, foursquare: $elm$core$Maybe$Nothing},
		permanentlyClosed: false,
		locationDescriptor: $author$project$Data$Location$LocationDescriptor(location.locationDescriptor),
		networkServiceItems: {google: _List_Nil},
		newGoogleReviewLink: $author$project$Data$Location$NewReviewUrl(''),
		alternativeSearchNames: $author$project$Data$Location$AlternativeSearchNames(_List_Nil),
		temporarilyClosedUntil: $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
		temporarilyClosedMessage: $author$project$Data$Location$TemporarilyClosedMessage(''),
		hasTransitionedToNewPageExperience: true
	};
};
var $author$project$ApiPendingChanges$Resolver$Commands$resolveEncoder = function (source) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'source',
				$elm$json$Json$Encode$string(
					$author$project$ApiPendingChanges$Resolver$Data$Source$toString(source)))
			]));
};
var $author$project$ApiPendingChanges$Resolver$Commands$resolveLocationResultDecoder = $elm$json$Json$Decode$succeed(true);
var $author$project$ApiPendingChanges$Resolver$Commands$resolveLocation = F5(
	function (siteName, locationId, field, source, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$ApiPendingChanges$Resolver$Commands$resolveLocationResultDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$ApiPendingChanges$Resolver$Commands$resolveEncoder(source),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(
							'api/' + (siteName + ('/places/apipendingchanges/resolve/' + (locationId + ('/' + $author$project$Data$Location$Field$toString(field))))))))));
	});
var $author$project$Location$Details$Editor$CoordinatesEditor = {$: 'CoordinatesEditor'};
var $author$project$Translations$Listings$ApiDifference$resolverErrorText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.resolver_error_text');
};
var $author$project$ApiPendingChanges$Resolver$Update$MasterAddressSaved = F2(
	function (a, b) {
		return {$: 'MasterAddressSaved', a: a, b: b};
	});
var $author$project$ApiPendingChanges$Resolver$Model$VerifyLocationError = F2(
	function (userMessage, errorMessage) {
		return {userMessage: userMessage, errorMessage: errorMessage};
	});
var $author$project$ApiPendingChanges$Resolver$Commands$updateMasterAddress = F4(
	function (siteName, locationId, address, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectWhatever(msg),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'address',
								$author$project$Data$Address$addressEncoder(address))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + ('/places/' + (locationId + '/partialUpdate'))))))));
	});
var $ohanhi$keyboard$Keyboard$KeyUp = function (a) {
	return {$: 'KeyUp', a: a};
};
var $ohanhi$keyboard$Keyboard$insert = F3(
	function (keyParser, rawKey, list) {
		var _v0 = keyParser(rawKey);
		if (_v0.$ === 'Just') {
			var key = _v0.a;
			return A2(
				$elm$core$List$cons,
				key,
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(key),
					list));
		} else {
			return list;
		}
	});
var $ohanhi$keyboard$Keyboard$remove = F3(
	function (keyParser, rawKey, list) {
		var _v0 = keyParser(rawKey);
		if (_v0.$ === 'Just') {
			var key = _v0.a;
			return A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(key),
				list);
		} else {
			return list;
		}
	});
var $ohanhi$keyboard$Keyboard$KeyDown = function (a) {
	return {$: 'KeyDown', a: a};
};
var $ohanhi$keyboard$Keyboard$updateWithKeyChange = F3(
	function (keyParser, msg, state) {
		if (msg.$ === 'Down') {
			var key = msg.a;
			var nextState = A3($ohanhi$keyboard$Keyboard$insert, keyParser, key, state);
			var change = (!_Utils_eq(
				$elm$core$List$length(nextState),
				$elm$core$List$length(state))) ? A2(
				$elm$core$Maybe$map,
				$ohanhi$keyboard$Keyboard$KeyDown,
				keyParser(key)) : $elm$core$Maybe$Nothing;
			return _Utils_Tuple2(nextState, change);
		} else {
			var key = msg.a;
			var nextState = A3($ohanhi$keyboard$Keyboard$remove, keyParser, key, state);
			var change = (!_Utils_eq(
				$elm$core$List$length(nextState),
				$elm$core$List$length(state))) ? A2(
				$elm$core$Maybe$map,
				$ohanhi$keyboard$Keyboard$KeyUp,
				keyParser(key)) : $elm$core$Maybe$Nothing;
			return _Utils_Tuple2(nextState, change);
		}
	});
var $author$project$Data$Network$Bing = {$: 'Bing'};
var $author$project$Data$Location$NetworkAttributes$NetworkAttributes = function (google) {
	return {google: google};
};
var $author$project$Data$Location$NetworkAttributes$Attribute = F5(
	function (source, attributeId, valueType, values, repeatedEnumValue) {
		return {source: source, values: values, valueType: valueType, attributeId: attributeId, repeatedEnumValue: repeatedEnumValue};
	});
var $author$project$Data$Location$NetworkAttributes$RepeatedEnums = F2(
	function (setValues, unsetValues) {
		return {setValues: setValues, unsetValues: unsetValues};
	});
var $author$project$Data$Location$NetworkAttributes$enumDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unsetValues',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$sort,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setValues',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$sort,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkAttributes$RepeatedEnums)));
var $author$project$Data$Location$NetworkAttributes$GoogleUpdated = {$: 'GoogleUpdated'};
var $author$project$Data$Location$NetworkAttributes$nullableStringDecoder = A2(
	$elm$json$Json$Decode$map,
	function (xs) {
		return $elm_community$maybe_extra$Maybe$Extra$values(xs);
	},
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Data$Location$NetworkAttributes$attributeDecoder = function () {
	var gAttr = function (s) {
		var _v0 = $elm$core$String$toLower(s);
		switch (_v0) {
			case 'googleupdated':
				return $author$project$Data$Location$NetworkAttributes$GoogleUpdated;
			case 'attributes':
				return $author$project$Data$Location$NetworkAttributes$Attributes;
			default:
				return $author$project$Data$Location$NetworkAttributes$Attributes;
		}
	};
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'repeatedEnumValue',
		$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkAttributes$enumDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'values',
			$author$project$Data$Location$NetworkAttributes$nullableStringDecoder,
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'attributeId',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'source',
						A2($elm$json$Json$Decode$map, gAttr, $elm$json$Json$Decode$string),
						$author$project$Data$Location$NetworkAttributes$Attributes,
						$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkAttributes$Attribute))))));
}();
var $author$project$Data$Location$NetworkAttributes$attributeListDecoder = function () {
	var sortRepeatedEnums = function (attrib) {
		var _v0 = attrib.valueType;
		if (_v0 === 'REPEATED_ENUM') {
			var sorted = A2(
				$elm$core$Maybe$map,
				function (y) {
					return _Utils_update(
						y,
						{
							setValues: $elm$core$List$sort(y.setValues),
							unsetValues: $elm$core$List$sort(y.unsetValues)
						});
				},
				attrib.repeatedEnumValue);
			return _Utils_update(
				attrib,
				{repeatedEnumValue: sorted});
		} else {
			return attrib;
		}
	};
	var sortAttributes = $elm$core$List$sortBy(
		function (x) {
			return x.attributeId;
		});
	return A2(
		$elm$json$Json$Decode$map,
		sortAttributes,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map(sortRepeatedEnums),
			$elm$json$Json$Decode$list($author$project$Data$Location$NetworkAttributes$attributeDecoder)));
}();
var $author$project$Data$Location$NetworkAttributes$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'google',
	$author$project$Data$Location$NetworkAttributes$attributeListDecoder,
	$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkAttributes$NetworkAttributes));
var $author$project$Data$Location$NetworkCategories$NetworkCategories = F8(
	function (google, facebook, bing, apple, foursquare, overture, here, tomtom) {
		return {bing: bing, here: here, apple: apple, google: google, tomtom: tomtom, facebook: facebook, overture: overture, foursquare: foursquare};
	});
var $author$project$Data$Location$NetworkCategories$BingCategories = F2(
	function (primaryCategoryId, categories) {
		return {categories: categories, primaryCategoryId: primaryCategoryId};
	});
var $author$project$Data$Location$NetworkCategories$categoryDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'name',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$Category)));
var $author$project$Data$Location$NetworkCategories$bingCategoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'categories',
	$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'primaryCategoryId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$BingCategories)));
var $author$project$Data$Location$NetworkCategories$CategoryGroup = F2(
	function (primary, additional) {
		return {primary: primary, additional: additional};
	});
var $author$project$Data$Location$NetworkCategories$categoryGroupDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'additional',
			$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'primary',
				$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$CategoryGroup))),
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'additionalCategories',
			$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'primaryCategory',
				$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$CategoryGroup)))
		]));
var $author$project$Data$Location$NetworkCategories$FacebookCategories = function (subcategories) {
	return {subcategories: subcategories};
};
var $author$project$Data$Location$NetworkCategories$facebookCategoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'subcategories',
	$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
	$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$FacebookCategories));
var $author$project$Data$Location$NetworkCategories$FoursquareCategories = function (categories) {
	return {categories: categories};
};
var $author$project$Data$Location$NetworkCategories$foursquareCategoriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'categories',
	$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
	$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$FoursquareCategories));
var $author$project$Data$Location$NetworkCategories$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tomtom',
	$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$tomtomCategoryDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'here',
		$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryGroupDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'overture',
			$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryGroupDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'factual',
				$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$foursquareCategoriesDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'apple',
					$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryGroupDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'bing',
						$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$bingCategoryDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'facebook',
							$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$facebookCategoryDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'google',
								$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryGroupDecoder),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$NetworkCategories)))))))));
var $author$project$Data$Location$NetworkServiceItems$NetworkServiceItems = function (google) {
	return {google: google};
};
var $author$project$Data$Location$NetworkServiceItems$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'google',
	$elm$json$Json$Decode$list($author$project$Data$Location$NetworkServiceItems$googleServiceItemsDecoder),
	$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkServiceItems$NetworkServiceItems));
var $author$project$Data$NetworkData$TemporarilyClosed$Indefinitely = {$: 'Indefinitely'};
var $author$project$Data$NetworkData$TemporarilyClosed$fromBool = function (x) {
	return x ? $elm$json$Json$Decode$succeed($author$project$Data$NetworkData$TemporarilyClosed$Indefinitely) : $elm$json$Json$Decode$succeed($author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed);
};
var $author$project$Data$NetworkData$TemporarilyClosed$untilDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		var yearMonthDayInString = x + 'T00:00:00.000Z';
		var dateResultToPosix = function (result) {
			if (result.$ === 'Ok') {
				var posixTime = result.a;
				return $elm$core$Maybe$Just(posixTime);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var maybePosix = dateResultToPosix(
			$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(yearMonthDayInString));
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$json$Json$Decode$fail('Can not decode YearMonthDay from ' + x),
			function (posix) {
				return $elm$json$Json$Decode$succeed(posix);
			},
			maybePosix);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$NetworkData$TemporarilyClosed$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$andThen, $author$project$Data$NetworkData$TemporarilyClosed$fromBool, $elm$json$Json$Decode$bool),
			A2(
			$elm$json$Json$Decode$andThen,
			function (posixUntil) {
				return $elm$json$Json$Decode$succeed(
					A2($author$project$Data$NetworkData$TemporarilyClosed$Until, posixUntil, ''));
			},
			$author$project$Data$NetworkData$TemporarilyClosed$untilDecoder),
			$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed)
		]));
var $author$project$Data$Location$ActionLinks$ActionLink = F3(
	function (type_, url, primary) {
		return {url: url, type_: type_, primary: primary};
	});
var $author$project$Data$Location$ActionLinks$toMaybeActionLink = F3(
	function (maybeType, maybeUrl, primary) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (type_, url) {
					return A3($author$project$Data$Location$ActionLinks$ActionLink, type_, url, primary);
				}),
			maybeType,
			maybeUrl);
	});
var $author$project$Data$Location$ActionLinks$stringToActionLinkType = function (raw) {
	switch (raw) {
		case 'shop_online':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$ShopOnline);
		case 'book_appointment':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$BookAppointment);
		case 'reserve_table':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$ReserveTable);
		case 'order_food':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$OrderFood);
		case 'order_food_takeout':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$OrderFoodTakeout);
		case 'order_food_delivery':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$OrderFoodDelivery);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Location$ActionLinks$maybeDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'primary',
	$elm$json$Json$Decode$bool,
	false,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			A2($elm$json$Json$Decode$map, $author$project$Data$Location$ActionLinks$stringToActionLinkType, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Data$Location$ActionLinks$toMaybeActionLink))));
var $author$project$Data$Location$ActionLinks$listDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list($author$project$Data$Location$ActionLinks$maybeDecoder));
var $author$project$Data$Location$LocationData = function (id) {
	return function (name) {
		return function (networkNames) {
			return function (storeId) {
				return function (locationDescriptor) {
					return function (location) {
						return function (about) {
							return function (longDescription) {
								return function (email) {
									return function (homepage) {
										return function (phone) {
											return function (address) {
												return function (facebook) {
													return function (google) {
														return function (bing) {
															return function (apple) {
																return function (ptv) {
																	return function (networkMedia) {
																		return function (permanentlyClosed) {
																			return function (temporarilyClosedUntil) {
																				return function (temporarilyClosedMessage) {
																					return function (openHours) {
																						return function (openingDate) {
																							return function (specialOpenHours) {
																								return function (networkCategories) {
																									return function (networkServiceItems) {
																										return function (actionLinks) {
																											return function (networkAttributes) {
																												return function (locationType) {
																													return function (serviceAreas) {
																														return function (isActive) {
																															return function (verification) {
																																return function (hasTransitionedToNewPageExperience) {
																																	return function (newGoogleReviewLink) {
																																		return function (wifiSsId) {
																																			return function (alternativeSearchNames) {
																																				return function (customData) {
																																					return function (fbStoreId) {
																																						return function (storefrontName) {
																																							return {id: id, ptv: ptv, bing: bing, name: name, about: about, apple: apple, email: email, phone: phone, google: google, address: address, storeId: storeId, facebook: facebook, homepage: homepage, isActive: isActive, location: location, wifiSsId: wifiSsId, fbStoreId: fbStoreId, openHours: openHours, customData: customData, actionLinks: actionLinks, openingDate: openingDate, locationType: locationType, networkMedia: networkMedia, networkNames: networkNames, serviceAreas: serviceAreas, verification: verification, storefrontName: storefrontName, longDescription: longDescription, specialOpenHours: specialOpenHours, networkAttributes: networkAttributes, networkCategories: networkCategories, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor, networkServiceItems: networkServiceItems, newGoogleReviewLink: newGoogleReviewLink, alternativeSearchNames: alternativeSearchNames, temporarilyClosedUntil: temporarilyClosedUntil, temporarilyClosedMessage: temporarilyClosedMessage, hasTransitionedToNewPageExperience: hasTransitionedToNewPageExperience};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Location$OpenHours$Days = F7(
	function (mon, tue, wed, thu, fri, sat, sun) {
		return {fri: fri, mon: mon, sat: sat, sun: sun, thu: thu, tue: tue, wed: wed};
	});
var $author$project$Data$Location$OpenHours$Span = F2(
	function (open, close) {
		return {open: open, close: close};
	});
var $author$project$Data$Location$OpenHours$spanDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'close',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'open',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$Span)));
var $author$project$Data$Location$OpenHours$stateDecoder = function (state) {
	_v0$4:
	while (true) {
		if (state.$ === 'Just') {
			switch (state.a) {
				case 'NotSpecified':
					return $elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$NotSpecified);
				case 'Closed':
					return $elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$Closed);
				case 'Open':
					return A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$Location$OpenHours$Open,
						A2(
							$elm$json$Json$Decode$field,
							'span',
							$elm$json$Json$Decode$list($author$project$Data$Location$OpenHours$spanDecoder)));
				case 'AlwaysOpen':
					return $elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$AlwaysOpen);
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$NotSpecified);
};
var $author$project$Data$Location$OpenHours$dayDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Data$Location$OpenHours$stateDecoder,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string)));
var $author$project$Data$Location$OpenHours$daysDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sun',
	$author$project$Data$Location$OpenHours$dayDecoder,
	$author$project$Data$Location$OpenHours$NotSpecified,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sat',
		$author$project$Data$Location$OpenHours$dayDecoder,
		$author$project$Data$Location$OpenHours$NotSpecified,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'fri',
			$author$project$Data$Location$OpenHours$dayDecoder,
			$author$project$Data$Location$OpenHours$NotSpecified,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'thu',
				$author$project$Data$Location$OpenHours$dayDecoder,
				$author$project$Data$Location$OpenHours$NotSpecified,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'wed',
					$author$project$Data$Location$OpenHours$dayDecoder,
					$author$project$Data$Location$OpenHours$NotSpecified,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'tue',
						$author$project$Data$Location$OpenHours$dayDecoder,
						$author$project$Data$Location$OpenHours$NotSpecified,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'mon',
							$author$project$Data$Location$OpenHours$dayDecoder,
							$author$project$Data$Location$OpenHours$NotSpecified,
							$elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$Days))))))));
var $author$project$Data$Location$OpenHours$decoder = A2($elm$json$Json$Decode$map, $author$project$Data$Location$OpenHours$During, $author$project$Data$Location$OpenHours$daysDecoder);
var $author$project$Data$Location$OpenHours$openHoursDecoder = function (maybeAlwaysOpen) {
	var alwaysOpen = A2($elm$core$Maybe$withDefault, false, maybeAlwaysOpen);
	return alwaysOpen ? $elm$json$Json$Decode$succeed($author$project$Data$Location$OpenHours$Always) : A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$Data$Location$OpenHours$notSpecified),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'openHours', $author$project$Data$Location$OpenHours$decoder)));
};
var $author$project$Data$Location$SpecialOpenHours$OpenHours = F4(
	function (startDate, endDate, label, state) {
		return {label: label, state: state, endDate: endDate, startDate: startDate};
	});
var $author$project$Data$Location$SpecialOpenHours$Span = F2(
	function (open, close) {
		return {open: open, close: close};
	});
var $author$project$Data$Location$SpecialOpenHours$stateDecoder = function (isClosed) {
	return isClosed ? $elm$json$Json$Decode$succeed($author$project$Data$Location$SpecialOpenHours$Closed) : A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Location$SpecialOpenHours$Open,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'closeTime',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'openTime',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$Location$SpecialOpenHours$Span))));
};
var $author$project$Data$Location$SpecialOpenHours$openHoursDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Data$Location$SpecialOpenHours$stateDecoder,
			A2($elm$json$Json$Decode$field, 'isClosed', $elm$json$Json$Decode$bool))),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'label',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				$elm$json$Json$Decode$succeed($author$project$Data$Location$SpecialOpenHours$OpenHours)))));
var $author$project$Data$Location$CustomData$propName = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Data$Location$CustomData$CustomData = function (a) {
	return {$: 'CustomData', a: a};
};
var $author$project$Data$Location$CustomData$ObjectProperty = function (a) {
	return {$: 'ObjectProperty', a: a};
};
var $author$project$Data$Location$CustomData$StringProperty = function (a) {
	return {$: 'StringProperty', a: a};
};
var $author$project$Data$Location$CustomData$BooleanProperty = function (a) {
	return {$: 'BooleanProperty', a: a};
};
var $author$project$Data$Location$CustomData$ListProperty = function (a) {
	return {$: 'ListProperty', a: a};
};
var $author$project$Data$Location$CustomData$decodeListItems = F3(
	function (propMeta, listItemsDecoder, itemMapper) {
		return A2(
			$elm$json$Json$Decode$map,
			function (xs) {
				return function (x) {
					return _List_fromArray(
						[
							$author$project$Data$Location$CustomData$ListProperty(
							_Utils_Tuple2(x, propMeta))
						]);
				}(
					A2($elm$core$List$map, itemMapper, xs));
			},
			A2(
				$elm$json$Json$Decode$map,
				A2($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $elm$core$Basics$identity),
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$field,
						$author$project$Data$Location$CustomData$propName(propMeta.name),
						$elm$json$Json$Decode$list(listItemsDecoder)))));
	});
var $author$project$Data$Location$CustomData$OpenHoursProperty = function (a) {
	return {$: 'OpenHoursProperty', a: a};
};
var $author$project$Data$Location$CustomData$SpecialOpenHoursProperty = function (a) {
	return {$: 'SpecialOpenHoursProperty', a: a};
};
var $author$project$Data$Location$CustomData$customDataDecoder = function (_v0) {
	var definition = _v0.a;
	var handleMaybe = function (defaultVal) {
		return A2($elm_community$maybe_extra$Maybe$Extra$unwrap, defaultVal, $elm$core$Basics$identity);
	};
	var root = function (propDef) {
		var stringOrNumber = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$string,
					A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float)
				]));
		switch (propDef.$) {
			case 'StringProperty':
				var propMeta = propDef.a;
				return A2(
					$elm$json$Json$Decode$map,
					function (x) {
						return _List_fromArray(
							[
								$author$project$Data$Location$CustomData$StringProperty(
								_Utils_Tuple2(
									A2(handleMaybe, '', x),
									propMeta))
							]);
					},
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							$author$project$Data$Location$CustomData$propName(propMeta.name),
							stringOrNumber)));
			case 'BooleanProperty':
				var propMeta = propDef.a;
				return A2(
					$elm$json$Json$Decode$map,
					function (x) {
						return _List_fromArray(
							[
								$author$project$Data$Location$CustomData$BooleanProperty(
								_Utils_Tuple2(
									A2(handleMaybe, false, x),
									propMeta))
							]);
					},
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							$author$project$Data$Location$CustomData$propName(propMeta.name),
							$elm$json$Json$Decode$bool)));
			case 'OpenHoursProperty':
				var propMeta = propDef.a;
				return A2(
					$elm$json$Json$Decode$map,
					function (x) {
						var defaultopen = $author$project$Data$Location$OpenHours$During(
							{fri: $author$project$Data$Location$OpenHours$NotSpecified, mon: $author$project$Data$Location$OpenHours$NotSpecified, sat: $author$project$Data$Location$OpenHours$NotSpecified, sun: $author$project$Data$Location$OpenHours$NotSpecified, thu: $author$project$Data$Location$OpenHours$NotSpecified, tue: $author$project$Data$Location$OpenHours$NotSpecified, wed: $author$project$Data$Location$OpenHours$NotSpecified});
						return _List_fromArray(
							[
								$author$project$Data$Location$CustomData$OpenHoursProperty(
								_Utils_Tuple2(
									A2(handleMaybe, defaultopen, x),
									propMeta))
							]);
					},
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							$author$project$Data$Location$CustomData$propName(propMeta.name),
							$author$project$Data$Location$OpenHours$decoder)));
			case 'SpecialOpenHoursProperty':
				var propMeta = propDef.a;
				return A2(
					$elm$json$Json$Decode$map,
					function (x) {
						return _List_fromArray(
							[
								$author$project$Data$Location$CustomData$SpecialOpenHoursProperty(
								_Utils_Tuple2(
									A2(handleMaybe, _List_Nil, x),
									propMeta))
							]);
					},
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							$author$project$Data$Location$CustomData$propName(propMeta.name),
							$elm$json$Json$Decode$list($author$project$Data$Location$SpecialOpenHours$openHoursDecoder))));
			case 'ListProperty':
				var propMeta = propDef.a;
				var listItemsDef = propDef.b;
				var decodeListItems_ = $author$project$Data$Location$CustomData$decodeListItems(propMeta);
				switch (listItemsDef.$) {
					case 'StringProperty':
						var strPropMeta = listItemsDef.a;
						return A2(
							decodeListItems_,
							$elm$json$Json$Decode$string,
							function (x) {
								return $author$project$Data$Location$CustomData$StringProperty(
									_Utils_Tuple2(x, strPropMeta));
							});
					case 'ObjectProperty':
						var meta = listItemsDef.a;
						var customData = listItemsDef.b;
						return A2(
							decodeListItems_,
							$author$project$Data$Location$CustomData$customDataDecoder(customData),
							function (_v4) {
								var x = _v4.a;
								return $author$project$Data$Location$CustomData$ObjectProperty(
									_Utils_Tuple2(x, meta));
							});
					default:
						return $elm$json$Json$Decode$fail('Only strings and objects are supported in lists');
				}
			default:
				var propMeta = propDef.a;
				var customData = propDef.b;
				return A2(
					$elm$json$Json$Decode$map,
					function (x) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_fromArray(
								[
									$author$project$Data$Location$CustomData$ObjectProperty(
									_Utils_Tuple2(_List_Nil, propMeta))
								]),
							$elm$core$Basics$identity,
							x);
					},
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							$author$project$Data$Location$CustomData$propName(propMeta.name),
							A2(
								$elm$json$Json$Decode$map,
								function (_v5) {
									var xs = _v5.a;
									return _List_fromArray(
										[
											$author$project$Data$Location$CustomData$ObjectProperty(
											_Utils_Tuple2(xs, propMeta))
										]);
								},
								$author$project$Data$Location$CustomData$customDataDecoder(customData)))));
		}
	};
	var decodeProperties = function (xs) {
		return A2(
			$elm$core$List$map,
			function (propDef) {
				return root(propDef);
			},
			xs);
	};
	var decodedCustomData = A3(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (_v1, prop) {
							var cd = _v1.a;
							return $author$project$Data$Location$CustomData$CustomData(
								_Utils_ap(cd, prop));
						}),
					acc,
					x);
			}),
		$elm$json$Json$Decode$succeed(
			$author$project$Data$Location$CustomData$CustomData(_List_Nil)),
		decodeProperties(definition));
	return decodedCustomData;
};
var $author$project$Data$Location$Verified = {$: 'Verified'};
var $author$project$Data$Location$Unverified = {$: 'Unverified'};
var $author$project$Data$Location$Verification = F2(
	function (addressAndCoordinates, serviceAreas) {
		return {serviceAreas: serviceAreas, addressAndCoordinates: addressAndCoordinates};
	});
var $author$project$Data$Location$decodeVerification = function () {
	var decodeBool = A2(
		$elm$json$Json$Decode$andThen,
		function (bool) {
			return bool ? $elm$json$Json$Decode$succeed($author$project$Data$Location$Verified) : $elm$json$Json$Decode$succeed($author$project$Data$Location$Unverified);
		},
		$elm$json$Json$Decode$bool);
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['serviceAreas', 'status']),
		decodeBool,
		$author$project$Data$Location$Unverified,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['addressAndCoordinates', 'status']),
			decodeBool,
			$author$project$Data$Location$Unverified,
			$elm$json$Json$Decode$succeed($author$project$Data$Location$Verification)));
}();
var $author$project$Data$NetworkData$NetworkData = F4(
	function (data, validation, idSetType, supportedActionLinkTypes) {
		return {data: data, idSetType: idSetType, validation: validation, supportedActionLinkTypes: supportedActionLinkTypes};
	});
var $author$project$Data$Network$Approved = {$: 'Approved'};
var $author$project$Data$Network$UserAction = {$: 'UserAction'};
var $author$project$Data$NetworkData$idSetTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		switch (x) {
			case 'approved':
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$Approved);
			case 'userAction':
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$UserAction);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$Disconnected);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$NetworkData$Validation$Validation = F4(
	function (hasDataDiff, dataDiff, approvedDiffs, googleLatLonMarkedForPublication) {
		return {dataDiff: dataDiff, hasDataDiff: hasDataDiff, approvedDiffs: approvedDiffs, googleLatLonMarkedForPublication: googleLatLonMarkedForPublication};
	});
var $author$project$Data$NetworkData$Validation$noDiff = {work: $elm$core$Maybe$Nothing, hasDiff: false};
var $author$project$Data$NetworkData$Validation$DataDiff = function (name) {
	return function (customName) {
		return function (storeId) {
			return function (locationDescriptor) {
				return function (location) {
					return function (about) {
						return function (longDescription) {
							return function (hours) {
								return function (openingDate) {
									return function (specialOpenHours) {
										return function (permanentlyClosed) {
											return function (temporarilyClosedUntil) {
												return function (street) {
													return function (zip) {
														return function (city) {
															return function (province) {
																return function (district) {
																	return function (country) {
																		return function (phone) {
																			return function (email) {
																				return function (homepage) {
																					return function (coverImage) {
																						return function (profileImage) {
																							return function (networkCategories) {
																								return function (networkAttributes) {
																									return function (networkActionLinks) {
																										return function (networkServiceItems) {
																											return function (serviceAreas) {
																												return {zip: zip, city: city, name: name, about: about, email: email, hours: hours, phone: phone, street: street, country: country, storeId: storeId, district: district, homepage: homepage, location: location, province: province, coverImage: coverImage, customName: customName, openingDate: openingDate, profileImage: profileImage, serviceAreas: serviceAreas, longDescription: longDescription, specialOpenHours: specialOpenHours, networkAttributes: networkAttributes, networkCategories: networkCategories, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor, networkActionLinks: networkActionLinks, networkServiceItems: networkServiceItems, temporarilyClosedUntil: temporarilyClosedUntil};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$NetworkData$Validation$Diff = F2(
	function (hasDiff, work) {
		return {work: work, hasDiff: hasDiff};
	});
var $author$project$Data$Work$Work = F2(
	function (id, status) {
		return {id: id, status: status};
	});
var $author$project$Data$Work$Done = {$: 'Done'};
var $author$project$Data$Work$Failed = {$: 'Failed'};
var $author$project$Data$Work$InProgress = {$: 'InProgress'};
var $author$project$Data$Work$workStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		switch (val) {
			case 'inProgress':
				return $elm$json$Json$Decode$succeed($author$project$Data$Work$InProgress);
			case 'failed':
				return $elm$json$Json$Decode$succeed($author$project$Data$Work$Failed);
			case 'done':
				return $elm$json$Json$Decode$succeed($author$project$Data$Work$Done);
			default:
				return $elm$json$Json$Decode$fail('Could not decode WorkStatus from string \u0027' + (val + '\u0027'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Work$workDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Data$Work$workStatusDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Data$Work$Work)));
var $author$project$Data$NetworkData$Validation$diffDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'work',
	$elm$json$Json$Decode$maybe($author$project$Data$Work$workDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hasDiff',
		$elm$json$Json$Decode$bool,
		false,
		$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$Validation$Diff)));
var $author$project$Data$NetworkData$Validation$diffDecoderOrNoDiff = function (diff) {
	return diff ? $author$project$Data$NetworkData$Validation$diffDecoder : $elm$json$Json$Decode$succeed(
		{work: $elm$core$Maybe$Nothing, hasDiff: false});
};
var $author$project$Data$NetworkData$Validation$dataDiffDecoder = function (withCustomName) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'serviceAreas',
		$author$project$Data$NetworkData$Validation$diffDecoder,
		$author$project$Data$NetworkData$Validation$noDiff,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'networkServiceItems',
			$author$project$Data$NetworkData$Validation$diffDecoder,
			$author$project$Data$NetworkData$Validation$noDiff,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'networkActionLinks',
				$author$project$Data$NetworkData$Validation$diffDecoder,
				$author$project$Data$NetworkData$Validation$noDiff,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'networkAttributes',
					$author$project$Data$NetworkData$Validation$diffDecoder,
					$author$project$Data$NetworkData$Validation$noDiff,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'networkCategories',
						$author$project$Data$NetworkData$Validation$diffDecoder,
						$author$project$Data$NetworkData$Validation$noDiff,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'profileImage',
							$author$project$Data$NetworkData$Validation$diffDecoder,
							$author$project$Data$NetworkData$Validation$noDiff,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'coverImage',
								$author$project$Data$NetworkData$Validation$diffDecoder,
								$author$project$Data$NetworkData$Validation$noDiff,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'homepage',
									$author$project$Data$NetworkData$Validation$diffDecoder,
									$author$project$Data$NetworkData$Validation$noDiff,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'email',
										$author$project$Data$NetworkData$Validation$diffDecoder,
										$author$project$Data$NetworkData$Validation$noDiff,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'phoneNumber',
											$author$project$Data$NetworkData$Validation$diffDecoder,
											$author$project$Data$NetworkData$Validation$noDiff,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'country',
												$author$project$Data$NetworkData$Validation$diffDecoder,
												$author$project$Data$NetworkData$Validation$noDiff,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'district',
													$author$project$Data$NetworkData$Validation$diffDecoder,
													$author$project$Data$NetworkData$Validation$noDiff,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'province',
														$author$project$Data$NetworkData$Validation$diffDecoder,
														$author$project$Data$NetworkData$Validation$noDiff,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'city',
															$author$project$Data$NetworkData$Validation$diffDecoder,
															$author$project$Data$NetworkData$Validation$noDiff,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'zip',
																$author$project$Data$NetworkData$Validation$diffDecoder,
																$author$project$Data$NetworkData$Validation$noDiff,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'street',
																	$author$project$Data$NetworkData$Validation$diffDecoder,
																	$author$project$Data$NetworkData$Validation$noDiff,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'temporarilyClosedUntil',
																		$author$project$Data$NetworkData$Validation$diffDecoder,
																		$author$project$Data$NetworkData$Validation$noDiff,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'permanentlyClosed',
																			$author$project$Data$NetworkData$Validation$diffDecoder,
																			$author$project$Data$NetworkData$Validation$noDiff,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'specialOpenHours',
																				$author$project$Data$NetworkData$Validation$diffDecoder,
																				$author$project$Data$NetworkData$Validation$noDiff,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'openingDate',
																					$author$project$Data$NetworkData$Validation$diffDecoder,
																					$author$project$Data$NetworkData$Validation$noDiff,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'hours',
																						$author$project$Data$NetworkData$Validation$diffDecoder,
																						$author$project$Data$NetworkData$Validation$noDiff,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'longDescription',
																							$author$project$Data$NetworkData$Validation$diffDecoder,
																							$author$project$Data$NetworkData$Validation$noDiff,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'about',
																								$author$project$Data$NetworkData$Validation$diffDecoder,
																								$author$project$Data$NetworkData$Validation$noDiff,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'location',
																									$author$project$Data$NetworkData$Validation$diffDecoder,
																									$author$project$Data$NetworkData$Validation$noDiff,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'locationDescriptor',
																										$author$project$Data$NetworkData$Validation$diffDecoder,
																										$author$project$Data$NetworkData$Validation$noDiff,
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'storeId',
																											$author$project$Data$NetworkData$Validation$diffDecoder,
																											$author$project$Data$NetworkData$Validation$noDiff,
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'name',
																												$author$project$Data$NetworkData$Validation$diffDecoderOrNoDiff(withCustomName),
																												$author$project$Data$NetworkData$Validation$noDiff,
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'name',
																													$author$project$Data$NetworkData$Validation$diffDecoderOrNoDiff(!withCustomName),
																													$author$project$Data$NetworkData$Validation$noDiff,
																													$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$Validation$DataDiff)))))))))))))))))))))))))))));
};
var $author$project$Data$NetworkData$Validation$ApprovedDiffs = F2(
	function (city, province) {
		return {city: city, province: province};
	});
var $author$project$Data$NetworkData$Validation$approvedDiffsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'province',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'city',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$Validation$ApprovedDiffs)));
var $author$project$Data$NetworkData$Validation$defaultEmptyDataDiff = {zip: $author$project$Data$NetworkData$Validation$noDiff, city: $author$project$Data$NetworkData$Validation$noDiff, name: $author$project$Data$NetworkData$Validation$noDiff, about: $author$project$Data$NetworkData$Validation$noDiff, email: $author$project$Data$NetworkData$Validation$noDiff, hours: $author$project$Data$NetworkData$Validation$noDiff, phone: $author$project$Data$NetworkData$Validation$noDiff, street: $author$project$Data$NetworkData$Validation$noDiff, country: $author$project$Data$NetworkData$Validation$noDiff, storeId: $author$project$Data$NetworkData$Validation$noDiff, district: $author$project$Data$NetworkData$Validation$noDiff, homepage: $author$project$Data$NetworkData$Validation$noDiff, location: $author$project$Data$NetworkData$Validation$noDiff, province: $author$project$Data$NetworkData$Validation$noDiff, coverImage: $author$project$Data$NetworkData$Validation$noDiff, customName: $author$project$Data$NetworkData$Validation$noDiff, openingDate: $author$project$Data$NetworkData$Validation$noDiff, profileImage: $author$project$Data$NetworkData$Validation$noDiff, serviceAreas: $author$project$Data$NetworkData$Validation$noDiff, longDescription: $author$project$Data$NetworkData$Validation$noDiff, specialOpenHours: $author$project$Data$NetworkData$Validation$noDiff, networkAttributes: $author$project$Data$NetworkData$Validation$noDiff, networkCategories: $author$project$Data$NetworkData$Validation$noDiff, permanentlyClosed: $author$project$Data$NetworkData$Validation$noDiff, locationDescriptor: $author$project$Data$NetworkData$Validation$noDiff, networkActionLinks: $author$project$Data$NetworkData$Validation$noDiff, networkServiceItems: $author$project$Data$NetworkData$Validation$noDiff, temporarilyClosedUntil: $author$project$Data$NetworkData$Validation$noDiff};
var $author$project$Data$NetworkData$Validation$markedForPublicationDecoder = function (x) {
	if (x.$ === 'Just') {
		return $elm$json$Json$Decode$succeed(true);
	} else {
		return $elm$json$Json$Decode$succeed(false);
	}
};
var $author$project$Data$NetworkData$Validation$validationDecoder = function (withCustomName) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'markedForPublication',
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$NetworkData$Validation$markedForPublicationDecoder,
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))),
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'approvedDiffs',
			$author$project$Data$NetworkData$Validation$approvedDiffsDecoder,
			{city: $elm$core$Maybe$Nothing, province: $elm$core$Maybe$Nothing},
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$json$Json$Decode$field,
							'dataDiff',
							$author$project$Data$NetworkData$Validation$dataDiffDecoder(withCustomName)),
							$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$Validation$defaultEmptyDataDiff)
						])),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'hasDataDiff',
					$elm$json$Json$Decode$bool,
					false,
					$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$Validation$Validation)))));
};
var $author$project$Data$Network$LocationData$Ptv = {$: 'Ptv'};
var $author$project$Data$Network$LocationData$Bing = function (a) {
	return {$: 'Bing', a: a};
};
var $author$project$Data$Network$LocationData$Here = function (a) {
	return {$: 'Here', a: a};
};
var $author$project$Data$Network$LocationData$Apple = function (a) {
	return {$: 'Apple', a: a};
};
var $author$project$Data$Network$LocationData$Google = function (a) {
	return {$: 'Google', a: a};
};
var $author$project$Data$Network$LocationData$Tomtom = function (a) {
	return {$: 'Tomtom', a: a};
};
var $author$project$Data$Network$LocationData$Facebook = function (a) {
	return {$: 'Facebook', a: a};
};
var $author$project$Data$Network$LocationData$Overture = function (a) {
	return {$: 'Overture', a: a};
};
var $author$project$Data$Network$LocationData$Instagram = {$: 'Instagram'};
var $author$project$Data$Network$LocationData$Foursquare = function (a) {
	return {$: 'Foursquare', a: a};
};
var $author$project$Data$Address$emptyAddress = {
	zip: '',
	city: '',
	street: '',
	country: '',
	stateOrProvince: $author$project$Data$Address$WithState(''),
	countryAlpha2Code: ''
};
var $author$project$Data$Network$LocationData$NetworkLocationData = function (name) {
	return function (storeId) {
		return function (network) {
			return function (locationDescriptor) {
				return function (location) {
					return function (about) {
						return function (longDescription) {
							return function (emails) {
								return function (homepage) {
									return function (link) {
										return function (phone) {
											return function (address) {
												return function (profileImageUrl) {
													return function (coverImageUrl) {
														return function (permanentlyClosed) {
															return function (temporarilyClosedUntil) {
																return function (openHours) {
																	return function (openingDate) {
																		return function (specialOpenHours) {
																			return function (networkCategories) {
																				return function (attributes) {
																					return function (actionLinks) {
																						return function (serviceAreas) {
																							return function (languageCode) {
																								return function (canModifyServiceList) {
																									return function (serviceItems) {
																										return {link: link, name: name, about: about, phone: phone, emails: emails, address: address, network: network, storeId: storeId, homepage: homepage, location: location, openHours: openHours, attributes: attributes, actionLinks: actionLinks, openingDate: openingDate, languageCode: languageCode, serviceAreas: serviceAreas, serviceItems: serviceItems, coverImageUrl: coverImageUrl, longDescription: longDescription, profileImageUrl: profileImageUrl, specialOpenHours: specialOpenHours, networkCategories: networkCategories, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor, canModifyServiceList: canModifyServiceList, temporarilyClosedUntil: temporarilyClosedUntil};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Network$LocationData$networkDecoder = F5(
	function (network, categories, permanentlyClosed, temporarilyClosed, link) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'serviceItems',
			$elm$json$Json$Decode$list($author$project$Data$Location$NetworkServiceItems$googleServiceItemsDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['metadata', 'canModifyServiceList']),
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'languageCode',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'serviceAreas',
						$author$project$Data$ServiceArea$decodeServiceAreas,
						$author$project$Data$ServiceArea$None,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'actionLinks',
							$author$project$Data$Location$ActionLinks$listDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'attributes',
								$author$project$Data$Location$NetworkAttributes$attributeListDecoder,
								_List_Nil,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									categories,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'specialOpenHours',
										$elm$json$Json$Decode$list($author$project$Data$Location$SpecialOpenHours$openHoursDecoder),
										_List_Nil,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'openingDate',
											$elm$json$Json$Decode$string,
											'',
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												A2(
													$elm$json$Json$Decode$andThen,
													$author$project$Data$Location$OpenHours$openHoursDecoder,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'isAlwaysOpen',
														$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool),
														$elm$core$Maybe$Nothing,
														$elm$json$Json$Decode$succeed($elm$core$Basics$identity))),
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													temporarilyClosed,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														permanentlyClosed,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'coverPhoto',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'profilePhoto',
																$elm$json$Json$Decode$string,
																'',
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'address',
																	$author$project$Data$Address$addressDecoder,
																	$author$project$Data$Address$emptyAddress,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'phoneNumber',
																		$elm$json$Json$Decode$string,
																		'',
																		A2(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																			link,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'website',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'emails',
																					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																					_List_Nil,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'longDescription',
																						$elm$json$Json$Decode$string,
																						'',
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'about',
																							$elm$json$Json$Decode$string,
																							'',
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'location',
																								$elm$json$Json$Decode$maybe($author$project$Data$Coordinates$coordinatesDecoder),
																								$elm$core$Maybe$Nothing,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'locationDescriptor',
																									$elm$json$Json$Decode$string,
																									'',
																									A2(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																										network,
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'storeId',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'name',
																												$elm$json$Json$Decode$string,
																												'',
																												$elm$json$Json$Decode$succeed($author$project$Data$Network$LocationData$NetworkLocationData)))))))))))))))))))))))))));
	});
var $author$project$Data$Network$LocationData$TempNetworkData = F3(
	function (primary, id, name) {
		return {id: id, name: name, primary: primary};
	});
var $author$project$Data$Network$LocationData$tempNetworkDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'name',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'primary',
			$elm$json$Json$Decode$bool,
			false,
			$elm$json$Json$Decode$succeed($author$project$Data$Network$LocationData$TempNetworkData))));
var $author$project$Data$Network$LocationData$locationDataDecoder = function (network) {
	var permanentlyClosedDecoder = $elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'permanentlyClosed', $elm$json$Json$Decode$bool));
	var temporaryClosedDecoder = function () {
		var facebook = A2(
			$elm$json$Json$Decode$andThen,
			function (x) {
				return $author$project$Data$NetworkData$TemporarilyClosed$fromBool(x === 'temporarily_closed');
			},
			$elm$json$Json$Decode$string);
		var google = A2(
			$elm$json$Json$Decode$andThen,
			function (x) {
				return $author$project$Data$NetworkData$TemporarilyClosed$fromBool(x === 'CLOSED_TEMPORARILY');
			},
			$elm$json$Json$Decode$string);
		switch (network.$) {
			case 'Google':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['openInfo', 'status']),
					google,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Facebook':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporaryStatus',
					facebook,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Bing':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporarilyClosedUntil',
					$author$project$Data$NetworkData$TemporarilyClosed$decoder,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Apple':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporarilyClosedUntil',
					$author$project$Data$NetworkData$TemporarilyClosed$decoder,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Foursquare':
				return A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Overture':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporarilyClosedUntil',
					$author$project$Data$NetworkData$TemporarilyClosed$decoder,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Here':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporarilyClosedUntil',
					$author$project$Data$NetworkData$TemporarilyClosed$decoder,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Tomtom':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporarilyClosedUntil',
					$author$project$Data$NetworkData$TemporarilyClosed$decoder,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			case 'Ptv':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'temporarilyClosedUntil',
					$author$project$Data$NetworkData$TemporarilyClosed$decoder,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
			default:
				return A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
		}
	}();
	var categoryDecoder = function () {
		switch (network.$) {
			case 'Google':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (x) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Network$LocationData$Google(x));
					},
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'additionalCategories',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'primaryCategory',
							$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkCategories$CategoryGroup))));
			case 'Facebook':
				return A2(
					$elm$json$Json$Decode$andThen,
					A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Data$Network$LocationData$Facebook),
					A2(
						$elm$json$Json$Decode$field,
						'categories',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder)));
			case 'Bing':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (xs) {
						var map = function (x) {
							return {id: x.id, name: x.name};
						};
						var primary = A2(
							$elm$core$Maybe$map,
							map,
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (x) {
									return x.primary;
								},
								xs));
						var additional = A2(
							$elm$core$List$map,
							map,
							A2(
								$elm$core$List$filter,
								function (x) {
									return !x.primary;
								},
								xs));
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Network$LocationData$Bing(
								{primary: primary, additional: additional}));
					},
					A2(
						$elm$json$Json$Decode$field,
						'categories',
						$elm$json$Json$Decode$list($author$project$Data$Network$LocationData$tempNetworkDataDecoder)));
			case 'Apple':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (categories) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Network$LocationData$Apple(
								{
									primary: $elm$core$List$head(categories),
									additional: A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										$elm$core$List$tail(categories))
								}));
					},
					A2(
						$elm$json$Json$Decode$field,
						'categories',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder)));
			case 'Foursquare':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Network$LocationData$Foursquare,
					A2($elm$json$Json$Decode$field, 'categories', $author$project$Data$Location$NetworkCategories$foursquareCategoriesDecoder));
			case 'Overture':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (categories) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Network$LocationData$Overture(
								{
									primary: $elm$core$List$head(categories),
									additional: A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										$elm$core$List$tail(categories))
								}));
					},
					A2(
						$elm$json$Json$Decode$field,
						'categories',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder)));
			case 'Here':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (categories) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Network$LocationData$Here(
								{
									primary: $elm$core$List$head(categories),
									additional: A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										$elm$core$List$tail(categories))
								}));
					},
					A2(
						$elm$json$Json$Decode$field,
						'categories',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder)));
			case 'Tomtom':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Network$LocationData$Tomtom,
					A2($elm$json$Json$Decode$field, 'category', $author$project$Data$Location$NetworkCategories$tomtomCategoryDecoder));
			case 'Ptv':
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$LocationData$Ptv);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$LocationData$Instagram);
		}
	}();
	var mapLinkDecoder = function () {
		if (network.$ === 'Apple') {
			return A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'placeCardUrl',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
		} else {
			return A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'link',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
		}
	}();
	return A2(
		$elm$json$Json$Decode$andThen,
		function (category) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (permanentlyClosed) {
					var permanentlyClosed_ = A2($elm$core$Maybe$withDefault, false, permanentlyClosed);
					return A2(
						$elm$json$Json$Decode$andThen,
						function (temporarilyClosed) {
							return A2(
								$elm$json$Json$Decode$andThen,
								A4($author$project$Data$Network$LocationData$networkDecoder, network, category, permanentlyClosed_, temporarilyClosed),
								mapLinkDecoder);
						},
						temporaryClosedDecoder);
				},
				permanentlyClosedDecoder);
		},
		categoryDecoder);
};
var $author$project$Data$Location$ActionLinks$googleStringToActionLinkType = function (raw) {
	switch (raw) {
		case 'APPOINTMENT':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$BookAppointment);
		case 'DINING_RESERVATION':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$ReserveTable);
		case 'FOOD_ORDERING':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$OrderFood);
		case 'FOOD_DELIVERY':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$OrderFoodDelivery);
		case 'FOOD_TAKEOUT':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$OrderFoodTakeout);
		case 'SHOP_ONLINE':
			return $elm$core$Maybe$Just($author$project$Data$Location$ActionLinks$ShopOnline);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Location$ActionLinks$supportedTypesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$map, $author$project$Data$Location$ActionLinks$googleStringToActionLinkType, $elm$json$Json$Decode$string)));
var $author$project$Data$NetworkData$Validation$defaultEmptyValidation = {
	dataDiff: $author$project$Data$NetworkData$Validation$defaultEmptyDataDiff,
	hasDataDiff: false,
	approvedDiffs: {city: $elm$core$Maybe$Nothing, province: $elm$core$Maybe$Nothing},
	googleLatLonMarkedForPublication: false
};
var $author$project$Data$NetworkData$networkDataDecoder = F2(
	function (network, withCustomName) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (data) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
					function (data_) {
						return A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$Just,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['actionLinkEligibility', 'supportedTypes']),
								$author$project$Data$Location$ActionLinks$supportedTypesDecoder,
								_List_Nil,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'idSetType',
									$author$project$Data$NetworkData$idSetTypeDecoder,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'validation',
										$author$project$Data$NetworkData$Validation$validationDecoder(withCustomName),
										$author$project$Data$NetworkData$Validation$defaultEmptyValidation,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											data_,
											$elm$json$Json$Decode$succeed($author$project$Data$NetworkData$NetworkData))))));
					},
					data);
			},
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$author$project$Data$Network$LocationData$locationDataDecoder(network))));
	});
var $author$project$Data$Media$Media = F3(
	function (url, previewUrl, setType) {
		return {url: url, setType: setType, previewUrl: previewUrl};
	});
var $author$project$Data$Media$Global = {$: 'Global'};
var $author$project$Data$Media$Location = {$: 'Location'};
var $author$project$Data$Media$Regional = {$: 'Regional'};
var $author$project$Data$Media$setTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'global':
				return $elm$json$Json$Decode$succeed($author$project$Data$Media$Global);
			case 'location':
				return $elm$json$Json$Decode$succeed($author$project$Data$Media$Location);
			case 'regional':
				return $elm$json$Json$Decode$succeed($author$project$Data$Media$Regional);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown setType: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Media$mediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'setType',
	$author$project$Data$Media$setTypeDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'previewUrl',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'url',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Data$Media$Media))));
var $author$project$Data$Location$networkImagesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'coverImage',
	$elm$json$Json$Decode$maybe($author$project$Data$Media$mediaDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'profileImage',
		$elm$json$Json$Decode$maybe($author$project$Data$Media$mediaDecoder),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkImages)));
var $author$project$Data$Location$networkMediaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'google',
	$author$project$Data$Location$networkImagesDecoder,
	{coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing},
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'facebook',
		$author$project$Data$Location$networkImagesDecoder,
		{coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing},
		$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkMedia)));
var $author$project$Data$Location$NetworkNames = F4(
	function (facebook, google, apple, ptv) {
		return {ptv: ptv, apple: apple, google: google, facebook: facebook};
	});
var $author$project$Data$Location$networkNamesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['networkCustomName', 'ptv']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['networkCustomName', 'apple']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['google', 'custom', 'name']),
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['fb', 'custom', 'name']),
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Data$Location$NetworkNames)))));
var $author$project$Data$CustomDataDefinition$CustomDataDefinition = function (a) {
	return {$: 'CustomDataDefinition', a: a};
};
var $author$project$Data$Location$locationDecoder = F2(
	function (features, customDataDefinition) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$author$project$Util$idDecoder($author$project$Data$Location$StorefrontName),
			$author$project$Data$Location$StorefrontName(''),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['fb', 'storeId']),
				A2(
					$elm$json$Json$Decode$andThen,
					function (fbStoreId) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Location$FacebookStoreId(fbStoreId));
					},
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
				$author$project$Data$Location$FacebookStoreId($elm$core$Maybe$Nothing),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'customData',
					$elm$json$Json$Decode$nullable(
						$author$project$Data$Location$CustomData$customDataDecoder(
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$CustomDataDefinition$CustomDataDefinition(_List_Nil),
								$elm$core$Basics$identity,
								customDataDefinition))),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'alternativeNames',
						A2(
							$elm$json$Json$Decode$andThen,
							function (list) {
								return $elm$json$Json$Decode$succeed(
									$author$project$Data$Location$AlternativeSearchNames(list));
							},
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
						$author$project$Data$Location$AlternativeSearchNames(_List_Nil),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'wifiSsid',
							$author$project$Util$idDecoder($author$project$Data$Location$WifiSsId),
							$author$project$Data$Location$WifiSsId(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['google', 'data', 'newReviewUrl']),
								$author$project$Util$idDecoder($author$project$Data$Location$NewReviewUrl),
								$author$project$Data$Location$NewReviewUrl(''),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['fb', 'data', 'hasTransitionedToNewPageExperience']),
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'verification',
										$elm$json$Json$Decode$nullable($author$project$Data$Location$decodeVerification),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'isActive',
											A2(
												$elm$json$Json$Decode$andThen,
												function (bool) {
													return bool ? $elm$json$Json$Decode$succeed($author$project$Data$Location$Active) : $elm$json$Json$Decode$succeed($author$project$Data$Location$Inactive);
												},
												$elm$json$Json$Decode$bool),
											$author$project$Data$Location$Active,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'serviceAreas',
												$author$project$Data$ServiceArea$decodeServiceAreas,
												$author$project$Data$ServiceArea$None,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'type',
													$author$project$Data$Location$locationTypeDecoder,
													$author$project$Data$Location$Storefront,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'networkAttributes',
														$author$project$Data$Location$NetworkAttributes$decoder,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'actionLinks',
															$author$project$Data$Location$ActionLinks$listDecoder,
															_List_Nil,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'networkServiceItems',
																$author$project$Data$Location$NetworkServiceItems$decoder,
																{google: _List_Nil},
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'networkCategories',
																	$author$project$Data$Location$NetworkCategories$decoder,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'specialOpenHours',
																		$elm$json$Json$Decode$list($author$project$Data$Location$SpecialOpenHours$openHoursDecoder),
																		_List_Nil,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'openingDate',
																			$elm$json$Json$Decode$string,
																			'',
																			A2(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
																					A2(
																						$elm$json$Json$Decode$map,
																						$author$project$Data$Location$OpenHours$openHoursDecoder,
																						A2(
																							$elm$json$Json$Decode$field,
																							'isAlwaysOpen',
																							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)))),
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'temporarilyClosedMessage',
																					$author$project$Util$idDecoder($author$project$Data$Location$TemporarilyClosedMessage),
																					$author$project$Data$Location$TemporarilyClosedMessage(''),
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'temporarilyClosedUntil',
																						$author$project$Data$NetworkData$TemporarilyClosed$decoder,
																						$author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'permanentlyClosed',
																							$elm$json$Json$Decode$bool,
																							false,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'networkMedia',
																								$author$project$Data$Location$networkMediaDecoder,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'ptv',
																									A2($author$project$Data$NetworkData$networkDataDecoder, $author$project$Data$Network$Ptv, false),
																									$elm$core$Maybe$Nothing,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'apple',
																										A2($author$project$Data$NetworkData$networkDataDecoder, $author$project$Data$Network$Apple, false),
																										$elm$core$Maybe$Nothing,
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'bing',
																											A2($author$project$Data$NetworkData$networkDataDecoder, $author$project$Data$Network$Bing, false),
																											$elm$core$Maybe$Nothing,
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'google',
																												A2($author$project$Data$NetworkData$networkDataDecoder, $author$project$Data$Network$Google, features.googleCustomName),
																												$elm$core$Maybe$Nothing,
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'fb',
																													A2($author$project$Data$NetworkData$networkDataDecoder, $author$project$Data$Network$Facebook, features.facebookCustomName),
																													$elm$core$Maybe$Nothing,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'address',
																														$author$project$Data$Address$addressDecoder,
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																															_List_fromArray(
																																['contact', 'phone']),
																															$author$project$Util$idDecoder($author$project$Data$Location$Phone),
																															$author$project$Data$Location$Phone(''),
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																																_List_fromArray(
																																	['contact', 'homepage']),
																																$author$project$Util$idDecoder($author$project$Data$Location$Homepage),
																																$author$project$Data$Location$Homepage(''),
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																																	_List_fromArray(
																																		['contact', 'email']),
																																	$author$project$Util$idDecoder($author$project$Data$Location$Email),
																																	$author$project$Data$Location$Email(''),
																																	A4(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																		'longDescription',
																																		$author$project$Util$idDecoder($author$project$Data$Location$LongDescription),
																																		$author$project$Data$Location$LongDescription(''),
																																		A4(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																			'shortDescription',
																																			$author$project$Util$idDecoder($author$project$Data$Location$ShortDescription),
																																			$author$project$Data$Location$ShortDescription(''),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'location',
																																				$author$project$Data$Coordinates$coordinatesDecoder,
																																				A4(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																					'locationDescriptor',
																																					$author$project$Util$idDecoder($author$project$Data$Location$LocationDescriptor),
																																					$author$project$Data$Location$LocationDescriptor(''),
																																					A4(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																						'storeId',
																																						$author$project$Util$idDecoder($author$project$Data$Location$StoreId),
																																						$author$project$Data$Location$StoreId(''),
																																						A2(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																																							$author$project$Data$Location$networkNamesDecoder,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'name',
																																								$elm$json$Json$Decode$string,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'_id',
																																									$elm$json$Json$Decode$string,
																																									$elm$json$Json$Decode$succeed($author$project$Data$Location$LocationData))))))))))))))))))))))))))))))))))))))));
	});
var $author$project$Location$Details$Model$PartialUpdateResult = F4(
	function (success, locationId, location, workId) {
		return {workId: workId, success: success, location: location, locationId: locationId};
	});
var $author$project$Location$Details$Commands$partialUpdateResultDecoder = F2(
	function (features, customDataDefinition) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['data', 'workId']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['data', 'place']),
				A2($author$project$Data$Location$locationDecoder, features, customDataDefinition),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['data', 'place', '_id']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'success',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Location$Details$Model$PartialUpdateResult)))));
	});
var $author$project$Location$Details$Commands$sendToPartialUpdate_ = F6(
	function (_v0, locationId, features, customDataDefinition, msg, json) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$Location$Details$Commands$partialUpdateResultDecoder, features, customDataDefinition),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + ('/places/partialUpdateMultiple/?returnPlaceId=' + locationId))))));
	});
var $author$project$ApiPendingChanges$Resolver$Model$selectFieldInLocation = F4(
	function (field, locationId, source, model) {
		return _Utils_update(
			model,
			{
				selected: A3(
					$elm$core$Dict$update,
					locationId,
					function (x) {
						var _v0 = _Utils_Tuple2(
							field,
							A2(
								$elm$core$Maybe$withDefault,
								{address: $elm$core$Maybe$Nothing, location: $elm$core$Maybe$Nothing},
								x));
						switch (_v0.a.$) {
							case 'Address':
								var _v1 = _v0.a;
								var selections = _v0.b;
								return $elm$core$Maybe$Just(
									_Utils_update(
										selections,
										{
											address: $elm$core$Maybe$Just(source)
										}));
							case 'Location':
								var _v2 = _v0.a;
								var selections = _v0.b;
								return $elm$core$Maybe$Just(
									_Utils_update(
										selections,
										{
											location: $elm$core$Maybe$Just(source)
										}));
							default:
								return x;
						}
					},
					model.selected)
			});
	});
var $author$project$ApiPendingChanges$Resolver$Update$ResolveLocationResponse = F3(
	function (a, b, c) {
		return {$: 'ResolveLocationResponse', a: a, b: b, c: c};
	});
var $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorUpdated = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorUpdated', a: a, b: b};
	});
var $author$project$ApiPendingChanges$Resolver$Update$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 'SelectMasterData':
					var field = msg.a;
					var locationId = msg.b;
					var editedAddress = function () {
						if (field.$ === 'Address') {
							return A2(
								$elm$core$Maybe$andThen,
								function (location) {
									return (!_Utils_eq(location.address, location.originalAddress)) ? $elm$core$Maybe$Just(location.address) : $elm$core$Maybe$Nothing;
								},
								A2(
									$elm$core$Maybe$andThen,
									function (pagination) {
										return A2($elm$core$Dict$get, locationId, pagination.items);
									},
									$author$project$RemoteData$currentData(model.locations)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var cmd = function () {
						if (editedAddress.$ === 'Just') {
							var address = editedAddress.a;
							return A4(
								$author$project$ApiPendingChanges$Resolver$Commands$updateMasterAddress,
								model.siteName,
								locationId,
								address,
								$author$project$ApiPendingChanges$Resolver$Update$MasterAddressSaved(locationId));
						} else {
							return A5(
								$author$project$ApiPendingChanges$Resolver$Commands$resolveLocation,
								model.siteName,
								locationId,
								field,
								$author$project$ApiPendingChanges$Resolver$Data$Source$Master,
								A2($author$project$ApiPendingChanges$Resolver$Update$ResolveLocationResponse, locationId, field));
						}
					}();
					return _Utils_Tuple2(
						A4(
							$author$project$ApiPendingChanges$Resolver$Model$selectFieldInLocation,
							field,
							locationId,
							$author$project$ApiPendingChanges$Resolver$Data$Source$Master,
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (x) {
												return A2($author$project$ApiPendingChanges$Resolver$Update$setPublishing, x, field);
											}),
										model.locations)
								})),
						cmd);
				case 'SelectApiData':
					var field = msg.a;
					var locationId = msg.b;
					return _Utils_Tuple2(
						A4(
							$author$project$ApiPendingChanges$Resolver$Model$selectFieldInLocation,
							field,
							locationId,
							$author$project$ApiPendingChanges$Resolver$Data$Source$Api,
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (x) {
												return A2($author$project$ApiPendingChanges$Resolver$Update$setPublishing, x, field);
											}),
										model.locations)
								})),
						A5(
							$author$project$ApiPendingChanges$Resolver$Commands$resolveLocation,
							model.siteName,
							locationId,
							field,
							$author$project$ApiPendingChanges$Resolver$Data$Source$Api,
							A2($author$project$ApiPendingChanges$Resolver$Update$ResolveLocationResponse, locationId, field)));
				case 'ResolveLocationResponse':
					var locationId = msg.a;
					var field = msg.b;
					var response = msg.c;
					var clearData = function (x) {
						if (_Utils_eq(field, $author$project$Data$Location$Field$Address)) {
							var state_ = x.addressChangeState;
							var state = _Utils_update(
								state_,
								{isResolved: true, isPublishing: false});
							return _Utils_update(
								x,
								{addressChangeState: state});
						} else {
							var state_ = x.coordinatesChangeState;
							var state = _Utils_update(
								state_,
								{isResolved: true, isPublishing: false});
							return _Utils_update(
								x,
								{coordinatesChangeState: state});
						}
					};
					if (response.$ === 'Ok') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (x) {
												return clearData(x);
											}),
										model.locations)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = response.a;
						var serverErrorMsg = $author$project$Util$httpErrorToString(err);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									verifyLocationErrors: A3(
										$elm$core$Dict$insert,
										locationId,
										A2(
											$author$project$ApiPendingChanges$Resolver$Model$VerifyLocationError,
											$author$project$Translations$Listings$ApiDifference$resolverErrorText(session.translations),
											serverErrorMsg),
										model.verifyLocationErrors)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'ApiPendingChanges.Resolver.Update', message: 'Failed to handle result for msg ResolveLocationResponse'}));
					}
				case 'MasterAddressSaved':
					var locationId = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (location) {
												return _Utils_update(
													location,
													{originalAddress: location.address});
											}),
										model.locations)
								}),
							A5(
								$author$project$ApiPendingChanges$Resolver$Commands$resolveLocation,
								model.siteName,
								locationId,
								$author$project$Data$Location$Field$Address,
								$author$project$ApiPendingChanges$Resolver$Data$Source$Master,
								A2($author$project$ApiPendingChanges$Resolver$Update$ResolveLocationResponse, locationId, $author$project$Data$Location$Field$Address)));
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (location) {
												var state = location.addressChangeState;
												return _Utils_update(
													location,
													{
														addressChangeState: _Utils_update(
															state,
															{isPublishing: false})
													});
											}),
										model.locations)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'ApiPendingChanges.Resolver.Update', message: 'Failed to save and select the address in PinMeTo when resolving the difference'}));
					}
				case 'EditMasterData':
					var field = msg.a;
					var locationId = msg.b;
					var editorVariant = function () {
						switch (field.$) {
							case 'Location':
								return $elm$core$Maybe$Just($author$project$Location$Details$Editor$CoordinatesEditor);
							case 'Address':
								return $elm$core$Maybe$Just($author$project$Location$Details$Editor$AddressEditor);
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					var initEditor = F2(
						function (variant, location) {
							return A3(
								$elm$core$Tuple$mapBoth,
								function (editorModel) {
									return _Utils_update(
										model,
										{
											editor: $elm$core$Maybe$Just(
												_Utils_Tuple2(field, editorModel)),
											editing: $elm$core$Maybe$Just(
												{field: field, locationId: locationId})
										});
								},
								$elm$core$Platform$Cmd$map(
									$author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorMsg(location.id)),
								A7(
									$author$project$Location$Details$Editor$init,
									location.networkCategories,
									$elm$time$Time$millisToPosix(0),
									location,
									{
										locale: session.locale,
										language: session.language,
										siteName: $author$project$Data$SiteName$SiteName(model.siteName),
										analytics: session.analytics,
										translations: session.translations
									},
									false,
									_List_Nil,
									variant));
						});
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$andThen,
							function (variant) {
								return A2(
									$elm$core$Maybe$map,
									initEditor(variant),
									A2(
										$elm$core$Maybe$map,
										$author$project$ApiPendingChanges$Resolver$Commands$toLocationData,
										A2(
											$elm$core$Maybe$andThen,
											function (pagination) {
												return A2($elm$core$Dict$get, locationId, pagination.items);
											},
											$author$project$RemoteData$currentData(model.locations))));
							},
							editorVariant));
				case 'LocationsResponse':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var locations = result.a;
						return _Utils_Tuple2(
							($elm$core$List$length(locations) > 0) ? _Utils_update(
								model,
								{
									locations: $author$project$RemoteData$Loaded(
										A2(
											$author$project$Common$PaginationSimple$initWithItems,
											locations,
											function ($) {
												return $.id;
											}))
								}) : _Utils_update(
								model,
								{locations: $author$project$RemoteData$Suspended}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: $author$project$RemoteData$Error(
										$author$project$Util$httpErrorToString(err))
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'ApiPendingChanges.Resolver.Update', message: 'Failed to handle result for command LocationsResponse'}));
					}
				case 'OnPageInputSubmit':
					var locations = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$PaginationSimple$empty,
						$author$project$RemoteData$currentData(model.locations));
					var $temp$session = session,
						$temp$msg = $author$project$ApiPendingChanges$Resolver$Update$OnPageChange(locations.value - 1),
						$temp$model = model;
					session = $temp$session;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 'OnPageInputChange':
					var setInputValue = msg.a;
					var locations = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$PaginationSimple$empty,
						$author$project$RemoteData$currentData(model.locations));
					var newPagination = A2(
						$author$project$Common$PaginationSimple$setInputValue,
						A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(setInputValue)),
						locations);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: $author$project$RemoteData$Loaded(newPagination)
							}),
						$elm$core$Platform$Cmd$none);
				case 'OnPageChange':
					var inc = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						$author$project$RemoteData$currentData(
							A2(
								$author$project$RemoteData$map,
								function (_v7) {
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												locations: A2(
													$author$project$RemoteData$map,
													$author$project$Common$PaginationSimple$changePage(inc),
													model.locations)
											}),
										$elm$core$Platform$Cmd$none);
								},
								model.locations)));
				case 'OnMapMarkerUseThis':
					var source = msg.a;
					var select = function (locationId) {
						return A4($author$project$ApiPendingChanges$Resolver$Model$selectFieldInLocation, $author$project$Data$Location$Field$Location, locationId, source, model);
					};
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								select,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Common$PaginationSimple$currentKey,
									$author$project$RemoteData$currentData(model.locations)))),
						$elm$core$Platform$Cmd$none);
				case 'KeyboardMsg':
					var keyMsg = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (_v8) {
								var _v9 = A3($ohanhi$keyboard$Keyboard$updateWithKeyChange, $ohanhi$keyboard$Keyboard$anyKeyOriginal, keyMsg, model.pressedKeys);
								var pressedKeys = _v9.a;
								var maybeKeyChange = _v9.b;
								var newModel = _Utils_update(
									model,
									{pressedKeys: pressedKeys});
								var editing = A2(
									$elm$core$List$any,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											!_Utils_eq(model.editing, $elm$core$Maybe$Nothing),
											!_Utils_eq(model.editor, $elm$core$Maybe$Nothing)
										]));
								if (!editing) {
									var locations = A2(
										$elm$core$Maybe$withDefault,
										$author$project$Common$PaginationSimple$empty,
										$author$project$RemoteData$currentData(model.locations));
									_v10$2:
									while (true) {
										if ((maybeKeyChange.$ === 'Just') && (maybeKeyChange.a.$ === 'KeyUp')) {
											switch (maybeKeyChange.a.a.$) {
												case 'ArrowRight':
													var _v11 = maybeKeyChange.a.a;
													return A3(
														$author$project$ApiPendingChanges$Resolver$Update$update,
														session,
														$author$project$ApiPendingChanges$Resolver$Update$OnPageChange(locations.currentPage + 1),
														newModel);
												case 'ArrowLeft':
													var _v12 = maybeKeyChange.a.a;
													return A3(
														$author$project$ApiPendingChanges$Resolver$Update$update,
														session,
														$author$project$ApiPendingChanges$Resolver$Update$OnPageChange(locations.currentPage - 1),
														newModel);
												default:
													break _v10$2;
											}
										} else {
											break _v10$2;
										}
									}
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
								} else {
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
								}
							},
							$author$project$RemoteData$currentData(model.locations)));
				case 'LocationDetailsEditorMsg':
					var locationId = msg.a;
					var msg_ = msg.b;
					var _v13 = model.editor;
					if (_v13.$ === 'Just') {
						var _v14 = _v13.a;
						var field = _v14.a;
						var editor = _v14.b;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (editor_) {
								return _Utils_update(
									model,
									{
										editor: $elm$core$Maybe$Just(
											_Utils_Tuple2(field, editor_))
									});
							},
							A4(
								$author$project$Location$Details$Editor$update,
								{
									tagger: $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorMsg(locationId),
									siteName: $author$project$Data$SiteName$SiteName(model.siteName),
									onUpdated: $author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorUpdated(field),
									onScheduled: $elm$core$Maybe$Nothing,
									deleteCommand: F2(
										function (_v15, _v16) {
											return $elm$core$Platform$Cmd$none;
										}),
									updateCommand: A4(
										$author$project$Location$Details$Commands$sendToPartialUpdate_,
										$author$project$Data$SiteName$SiteName(model.siteName),
										locationId,
										$author$project$Data$Account$emptyFeatures,
										$elm$core$Maybe$Nothing),
									scheduleCommand: F2(
										function (_v17, _v18) {
											return $elm$core$Platform$Cmd$none;
										}),
									onDeleteSchedule: $elm$core$Maybe$Nothing,
									saveGoogleAttributes: F2(
										function (_v19, _v20) {
											return $elm$core$Platform$Cmd$none;
										}),
									saveGoogleSocialLinks: F2(
										function (_v21, _v22) {
											return $elm$core$Platform$Cmd$none;
										}),
									onScheduleUpdatesRefreshed: $elm$core$Maybe$Nothing,
									onUpdatedLdpSpecialOpenHours: function (_v23) {
										return $author$project$ApiPendingChanges$Resolver$Update$NoOp;
									},
									onUpdatedSideBarSpecialOpenHours: function (_v24) {
										return $author$project$ApiPendingChanges$Resolver$Update$NoOp;
									},
									updateCommandLdpSpecialOpenHours: $elm$core$Maybe$Nothing,
									updateCommandSideBarSpecialOpenHours: $elm$core$Maybe$Nothing
								},
								{language: session.language, translations: session.translations},
								msg_,
								editor));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'LocationDetailsEditorClose':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editor: $elm$core$Maybe$Nothing, editing: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'LocationDetailsEditorUpdated':
					var field = msg.a;
					var locationData = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editor: $elm$core$Maybe$Nothing,
								locations: A2(
									$author$project$RemoteData$map,
									A2(
										$author$project$Common$PaginationSimple$updateItem,
										locationData.id,
										function (location) {
											switch (field.$) {
												case 'Location':
													return _Utils_update(
														location,
														{coordinates: locationData.location});
												case 'Address':
													return _Utils_update(
														location,
														{address: locationData.address, locationType: locationData.locationType, serviceAreas: locationData.serviceAreas, originalAddress: locationData.address});
												default:
													return location;
											}
										}),
									model.locations)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$ApiPendingChanges$Resolver$Model$Flags = F3(
	function (siteName, displayName, translations) {
		return {siteName: siteName, displayName: displayName, translations: translations};
	});
var $author$project$ApiPendingChanges$Resolver$Update$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'displayName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'siteName',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$ApiPendingChanges$Resolver$Model$Flags))));
var $author$project$ApiPendingChanges$Resolver$Update$KeyboardMsg = function (a) {
	return {$: 'KeyboardMsg', a: a};
};
var $ohanhi$keyboard$Keyboard$Up = function (a) {
	return {$: 'Up', a: a};
};
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 'MySub', a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {pids: pids, subs: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {key: key, event: event};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (node.$ === 'Document') {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (node.$ === 'Document') {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.pids,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var event = _v0.event;
		var key = _v0.key;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.subs);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$Document = {$: 'Document'};
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'keyup');
var $ohanhi$keyboard$Keyboard$RawKey = function (a) {
	return {$: 'RawKey', a: a};
};
var $ohanhi$keyboard$Keyboard$eventKeyDecoder = A2(
	$elm$json$Json$Decode$field,
	'key',
	A2($elm$json$Json$Decode$map, $ohanhi$keyboard$Keyboard$RawKey, $elm$json$Json$Decode$string));
var $ohanhi$keyboard$Keyboard$ups = function (toMsg) {
	return $elm$browser$Browser$Events$onKeyUp(
		A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
};
var $ohanhi$keyboard$Keyboard$Down = function (a) {
	return {$: 'Down', a: a};
};
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'keydown');
var $ohanhi$keyboard$Keyboard$downs = function (toMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2($elm$json$Json$Decode$map, toMsg, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
};
var $ohanhi$keyboard$Keyboard$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$ohanhi$keyboard$Keyboard$downs($ohanhi$keyboard$Keyboard$Down),
			$ohanhi$keyboard$Keyboard$ups($ohanhi$keyboard$Keyboard$Up)
		]));
var $author$project$PinMeTo$Ui$PopOver$Resize = F2(
	function (a, b) {
		return {$: 'Resize', a: a, b: b};
	});
var $elm$browser$Browser$Events$Window = {$: 'Window'};
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		$elm$browser$Browser$Events$Window,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$PinMeTo$Ui$PopOver$subscriptions = F2(
	function (_v0, tagger) {
		var model = _v0.a;
		var preferredDirection = A2($elm$core$Maybe$withDefault, $author$project$PinMeTo$Ui$PopOver$Sheet, model.currentPreferredDirection);
		var uid = A2($elm$core$Maybe$withDefault, '', model.openPopOver);
		return (!_Utils_eq(model.openPopOver, $elm$core$Maybe$Nothing)) ? $elm$browser$Browser$Events$onResize(
			F2(
				function (_v1, _v2) {
					return tagger(
						A2($author$project$PinMeTo$Ui$PopOver$Resize, uid, preferredDirection));
				})) : $elm$core$Platform$Sub$none;
	});
var $author$project$Location$Details$PopupContent$Address$subscriptions = function (model) {
	return A2($author$project$PinMeTo$Ui$PopOver$subscriptions, model.businessTypePopOver, $author$project$Location$Details$PopupContent$Address$BusinessTypePopOverMsg);
};
var $author$project$Location$Details$PopupContent$StorefrontName$subscriptions = function (model) {
	return A2($author$project$PinMeTo$Ui$PopOver$subscriptions, model.popOverState, $author$project$Location$Details$PopupContent$StorefrontName$PopOverMsg);
};
var $author$project$Location$Details$Editor$subscriptions = function (_v0) {
	var model = _v0.a;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$PinMeTo$Ui$PopOver$subscriptions, model.popOverState, $author$project$Location$Details$Editor$Model$UiPopOverMsg),
				function () {
				var _v1 = model.content;
				_v1$2:
				while (true) {
					if (_v1.$ === 'Editor') {
						switch (_v1.a.$) {
							case 'StorefrontName':
								var sfModel = _v1.a.a;
								return A2(
									$elm$core$Platform$Sub$map,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$StorefrontNameMsg, $author$project$Location$Details$Editor$Model$EditorMsg),
									$author$project$Location$Details$PopupContent$StorefrontName$subscriptions(sfModel));
							case 'Address':
								var addressModel = _v1.a.a;
								return A2(
									$elm$core$Platform$Sub$map,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$Editor$Model$AddressMsg, $author$project$Location$Details$Editor$Model$EditorMsg),
									$author$project$Location$Details$PopupContent$Address$subscriptions(addressModel));
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return $elm$core$Platform$Sub$none;
			}()
			]));
};
var $author$project$ApiPendingChanges$Resolver$Main$editorSubscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (_v0, location) {
					var editorState = _v0.b;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$ApiPendingChanges$Resolver$Update$LocationDetailsEditorMsg(location.id),
						$author$project$Location$Details$Editor$subscriptions(editorState));
				}),
			model.editor,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Common$PaginationSimple$currentItem,
				$author$project$RemoteData$currentData(model.locations))));
};
var $author$project$ApiPendingChanges$Resolver$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$ApiPendingChanges$Resolver$Update$KeyboardMsg, $ohanhi$keyboard$Keyboard$subscriptions),
				$author$project$ApiPendingChanges$Resolver$Main$editorSubscriptions(model)
			]));
};
var $author$project$ApiPendingChanges$Resolver$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$ApiPendingChanges$Resolver$Main$init, view: $author$project$ApiPendingChanges$Resolver$View$view, update: $author$project$ApiPendingChanges$Resolver$Update$update, flagsDecoder: $author$project$ApiPendingChanges$Resolver$Update$flagsDecoder, subscriptions: $author$project$ApiPendingChanges$Resolver$Main$subscriptions});
var $author$project$VerifyLocations$Dashboard$Model$init = {siteName: '', translations: $author$project$Common$Language$initialTranslationsFallback, numberOfLocations: $elm$core$Maybe$Nothing};
var $author$project$VerifyLocations$Dashboard$Model$Flags = F2(
	function (siteName, translations) {
		return {siteName: siteName, translations: translations};
	});
var $author$project$VerifyLocations$Dashboard$Update$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siteName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Dashboard$Model$Flags)));
var $author$project$VerifyLocations$Dashboard$Update$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$VerifyLocations$Dashboard$Update$flagsDecoder, flagsValue);
};
var $author$project$VerifyLocations$Dashboard$Commands$Response = function (count) {
	return {count: count};
};
var $author$project$VerifyLocations$Dashboard$Commands$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Dashboard$Commands$Response));
var $author$project$VerifyLocations$Dashboard$Commands$getNumberOfLocationsToVerify = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$VerifyLocations$Dashboard$Commands$decode),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/unverified/count')))));
	});
var $author$project$VerifyLocations$Dashboard$Update$NumberOfLocationsToVerifyResponse = function (a) {
	return {$: 'NumberOfLocationsToVerifyResponse', a: a};
};
var $author$project$VerifyLocations$Dashboard$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'NumberOfLocationsToVerifyResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocations: $elm$core$Maybe$Just(response.count)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'VerifyLocations.Dashboard.Update', message: 'Failed to get number of locations to verify'}));
				}
			case 'HandleFlags':
				var flagsValue = msg.a;
				var _v2 = $author$project$VerifyLocations$Dashboard$Update$decodeFlags(flagsValue);
				if (_v2.$ === 'Ok') {
					var flags = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{siteName: flags.siteName, translations: flags.translations}),
						A2($author$project$VerifyLocations$Dashboard$Commands$getNumberOfLocationsToVerify, flags.siteName, $author$project$VerifyLocations$Dashboard$Update$NumberOfLocationsToVerifyResponse));
				} else {
					var err = _v2.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'VerifyLocations.Dashboard.Update',
								message: 'Failed to decode flags'
							}));
				}
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					var t = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{translations: t}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'VerifyLocations.Dashboard.Update',
								message: 'Failed to decode translations'
							}));
				}
		}
	});
var $author$project$VerifyLocations$Dashboard$Update$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$VerifyLocations$Dashboard$Main$init = function (flags) {
	return A2(
		$author$project$VerifyLocations$Dashboard$Update$update,
		$author$project$VerifyLocations$Dashboard$Update$HandleFlags(flags),
		$author$project$VerifyLocations$Dashboard$Model$init);
};
var $author$project$Translations$Listings$VerifyLocations$verifyLocationsBtn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.verify_locations_btn');
};
var $author$project$Translations$Listings$VerifyLocations$manualVerificationText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.manual_verification_text');
};
var $author$project$Translations$Listings$VerifyLocations$manualVerificationHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.manual_verification_header');
};
var $author$project$VerifyLocations$Dashboard$View$taskStatus = F2(
	function (model, numberOfLocations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-task')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-task__indicator')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-task__icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-regular fa-magnifying-glass-location')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-task__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-task__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$VerifyLocations$manualVerificationHeader(model.translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$VerifyLocations$manualVerificationText(model.translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-task__asides stats')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stats')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('stats__title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Locations to verify')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-verify-location__status stats__value')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(numberOfLocations))
										]))
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/listings/' + (model.siteName + '/locations/verify')),
									$elm$html$Html$Attributes$class('stats__cta pmt-btn--default pmt-btn')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$VerifyLocations$verifyLocationsBtn(model.translations))
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$VerifyLocations$addressVerification = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.address_verification');
};
var $author$project$VerifyLocations$Dashboard$View$view = function (model) {
	var _v0 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$lt(0),
			model.numberOfLocations),
		model.numberOfLocations);
	if (((_v0.a.$ === 'Just') && _v0.a.a) && (_v0.b.$ === 'Just')) {
		var numberOfLocations = _v0.b.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section pmt-verify-location')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-verify-location__header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$VerifyLocations$addressVerification(model.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$VerifyLocations$Dashboard$View$taskStatus, model, numberOfLocations)
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$VerifyLocations$Dashboard$Update$OnLanguageChanged = function (a) {
	return {$: 'OnLanguageChanged', a: a};
};
var $author$project$VerifyLocations$Dashboard$Main$passArgs_VerifyLocations_Dashboard_Main = _Platform_incomingPort('passArgs_VerifyLocations_Dashboard_Main', $elm$json$Json$Decode$value);
var $author$project$VerifyLocations$Dashboard$Main$in_VerifyLocations_Dashboard_languageChanged = _Platform_incomingPort('in_VerifyLocations_Dashboard_languageChanged', $elm$json$Json$Decode$value);
var $author$project$VerifyLocations$Dashboard$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$VerifyLocations$Dashboard$Main$passArgs_VerifyLocations_Dashboard_Main($author$project$VerifyLocations$Dashboard$Update$HandleFlags),
				$author$project$VerifyLocations$Dashboard$Main$in_VerifyLocations_Dashboard_languageChanged(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Common$Language$translationsDecoder),
					$author$project$VerifyLocations$Dashboard$Update$OnLanguageChanged))
			]));
};
var $author$project$VerifyLocations$Dashboard$Main$main = $elm$browser$Browser$element(
	{init: $author$project$VerifyLocations$Dashboard$Main$init, view: $author$project$VerifyLocations$Dashboard$View$view, update: $author$project$VerifyLocations$Dashboard$Update$update, subscriptions: $author$project$VerifyLocations$Dashboard$Main$subscriptions});
var $author$project$PinMeTo$Ui$AdvancedTooltip$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$init = $author$project$PinMeTo$Ui$AdvancedTooltip$State(
	{card: $elm$core$Maybe$Nothing, isHovered: $elm$core$Maybe$Nothing, toBeClosed: $elm$core$Set$empty, toBeOpened: $elm$core$Set$empty, openTooltip: $elm$core$Maybe$Nothing, currentPreferredDirection: $elm$core$Maybe$Nothing});
var $author$project$Location$LocationInfoPane$Model$OnLifeTimeRating = function (a) {
	return {$: 'OnLifeTimeRating', a: a};
};
var $author$project$Insights$Rating$Model$DetailedRatingStats = F7(
	function (oneStar, twoStar, threeStar, fourStar, fiveStar, answeredCount, unAnsweredCount) {
		return {oneStar: oneStar, twoStar: twoStar, fiveStar: fiveStar, fourStar: fourStar, threeStar: threeStar, answeredCount: answeredCount, unAnsweredCount: unAnsweredCount};
	});
var $author$project$Insights$Rating$Decoders$detailedRatingStatsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unAnswered',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'answered',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fiveStar',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fourStar',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'threeStar',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'twoStar',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'oneStar',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Insights$Rating$Model$DetailedRatingStats))))))));
var $author$project$Location$LocationInfoPane$Commands$getLifetimeRating = F4(
	function (requestUrl, siteName, locationId, msg) {
		var url = requestUrl + (siteName + ('/rating/locations/' + (locationId + '/metrics/detailedRatings')));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Insights$Rating$Decoders$detailedRatingStatsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Location$LocationInfoPane$Commands$getDataCompleteness = F2(
	function (model, msg) {
		var dataCompletenessDecoder = A2(
			$elm$json$Json$Decode$andThen,
			function (values) {
				if (values.b) {
					var first = values.a;
					return $elm$json$Json$Decode$succeed(first);
				} else {
					return $elm$json$Json$Decode$fail('Expected at least one object in the array');
				}
			},
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$field, 'completeness', $elm$json$Json$Decode$float)));
		var body = function () {
			var locationIds = _List_fromArray(
				[model.location.id]);
			var filter = $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'filterDefinition',
						A2(
							$elm$json$Json$Encode$list,
							function (_v0) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'property',
											$elm$json$Json$Encode$string('locations')),
											_Utils_Tuple2(
											'value',
											A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locationIds))
										]));
							},
							locationIds))
					]));
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('filter', filter)
					]));
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, dataCompletenessDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(
							'api/' + ($author$project$Data$SiteName$toString(model.siteName) + '/dataCompleteness'))))));
	});
var $author$project$Location$LocationInfoPane$Model$OnDataCompletenessResult = function (a) {
	return {$: 'OnDataCompletenessResult', a: a};
};
var $author$project$Location$LocationInfoPane$App$loadCmds = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2($author$project$Location$LocationInfoPane$Commands$getDataCompleteness, model, $author$project$Location$LocationInfoPane$Model$OnDataCompletenessResult),
				A4(
				$author$project$Location$LocationInfoPane$Commands$getLifetimeRating,
				model.requestUrl,
				$author$project$Data$SiteName$toString(model.siteName),
				model.location.id,
				$author$project$Location$LocationInfoPane$Model$OnLifeTimeRating)
			]));
};
var $author$project$Location$LocationInfoPane$Model$DetailsPage = {$: 'DetailsPage'};
var $author$project$Location$LocationInfoPane$Types$Navigation$GeneralData = {$: 'GeneralData'};
var $author$project$Location$LocationInfoPane$Ports$out_Location_LocationInfoPane_Main_OnSidePanelMounted = _Platform_outgoingPort('out_Location_LocationInfoPane_Main_OnSidePanelMounted', $elm$json$Json$Encode$string);
var $author$project$Location$LocationInfoPane$App$init = F2(
	function (_v0, arg) {
		var model = {
			page: $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Model$DetailsPage),
			today: arg.today,
			location: arg.location,
			siteName: $author$project$Data$SiteName$SiteName(arg.siteName),
			requestUrl: arg.requestUrl,
			copiedValue: $elm$core$Maybe$Nothing,
			mapPopupOpen: false,
			siteNetworks: arg.siteNetworks,
			tooltipState: $author$project$PinMeTo$Ui$AdvancedTooltip$init,
			currentNavItem: $author$project$Location$LocationInfoPane$Types$Navigation$GeneralData,
			lifetimeRatings: $author$project$RemoteData$Loading,
			dataCompleteness: $author$project$RemoteData$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Location$LocationInfoPane$App$loadCmds(model),
						$author$project$Location$LocationInfoPane$Ports$out_Location_LocationInfoPane_Main_OnSidePanelMounted('')
					])));
	});
var $author$project$Location$LocationInfoPane$Main$init = F2(
	function (session, flags) {
		return A2(
			$author$project$Location$LocationInfoPane$App$init,
			session,
			{today: flags.today, location: flags.location, siteName: flags.siteName, requestUrl: flags.requestUrl, siteNetworks: flags.siteNetworks});
	});
var $author$project$Location$LocationInfoPane$View$Map$mapElement = function (model) {
	return $author$project$PinMeTo$Ui$Map$render(
		A2(
			$author$project$PinMeTo$Ui$Map$withOnPopulate,
			$author$project$PinMeTo$Ui$Map$FitBoundsOnPopulate,
			A2(
				$author$project$PinMeTo$Ui$Map$withZoom,
				15,
				$author$project$PinMeTo$Ui$Map$view(
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Map$pin(model.location.coordinates)
						])))));
};
var $author$project$Location$LocationInfoPane$Model$OpenMapPopup = {$: 'OpenMapPopup'};
var $author$project$Location$LocationInfoPane$View$Map$render = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-info-pane__map--container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-info-pane__map--shadow')
					]),
				_List_fromArray(
					[
						$author$project$Location$LocationInfoPane$View$Map$mapElement(model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-info-pane__map--clickable-overlay'),
						$elm$html$Html$Events$onClick($author$project$Location$LocationInfoPane$Model$OpenMapPopup)
					]),
				_List_Nil)
			]));
};
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingLG = {$: 'SpacingLG'};
var $author$project$PinMeTo$Ui$Layout$Flex$withJustify = F2(
	function (justify_, config) {
		return _Utils_update(
			config,
			{
				justify: $elm$core$Maybe$Just(justify_)
			});
	});
var $author$project$PinMeTo$Ui$Layout$Flex$SpaceBetween = {$: 'SpaceBetween'};
var $author$project$PinMeTo$Ui$Layout$Spacing$withPaddingBottom = F2(
	function (spacing, config) {
		var padding_ = config.padding;
		return _Utils_update(
			config,
			{
				padding: _Utils_update(
					padding_,
					{
						bottom: $elm$core$Maybe$Just(spacing)
					})
			});
	});
var $author$project$Translations$General$copy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.copy');
};
var $author$project$Translations$General$copied = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.copied');
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$defaultOpenDelay = 500;
var $author$project$PinMeTo$Ui$AdvancedTooltip$defaultCloseDelay = 100;
var $author$project$PinMeTo$Ui$AdvancedTooltip$defaultViewportPadding = {top: 75 + 10, left: 10, right: 10, bottom: 10};
var $author$project$PinMeTo$Ui$AdvancedTooltip$view = function (config) {
	return {uid: config.uid, inset: $author$project$PinMeTo$Ui$AdvancedTooltip$defaultViewportPadding, tagger: config.tagger, content: config.content, openDelay: $author$project$PinMeTo$Ui$AdvancedTooltip$defaultOpenDelay, closeDelay: $author$project$PinMeTo$Ui$AdvancedTooltip$defaultCloseDelay, preferredDirection: config.preferredDirection};
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$Scroll = {$: 'Scroll'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$targetId = function (uid) {
	return 'pmt-ui-tooltip-target-' + uid;
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$cardId = function (uid) {
	return 'pmt-ui-tooltip-' + uid;
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$getCardArrow = function (card) {
	if (card.$ === 'Opening') {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var direction = card.a;
		var boundingBox = card.b;
		switch (direction.$) {
			case 'TopCenter':
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-tooltip__arrow pmt-ui-tooltip__arrow--bottom'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat((boundingBox.x + (boundingBox.width / 2)) - 6) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat(boundingBox.y + boundingBox.height) + 'px')
						]),
					_List_Nil);
			case 'BottomCenter':
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-tooltip__arrow pmt-ui-tooltip__arrow--top'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat((boundingBox.x + (boundingBox.width / 2)) - 6) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat(boundingBox.y - 12) + 'px')
						]),
					_List_Nil);
			case 'RightCenter':
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-tooltip__arrow pmt-ui-tooltip__arrow--left'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat(boundingBox.x - 12) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat((boundingBox.y + (boundingBox.height / 2)) - 6) + 'px')
						]),
					_List_Nil);
			case 'LeftCenter':
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-tooltip__arrow pmt-ui-tooltip__arrow--right'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat(boundingBox.x + boundingBox.width) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat((boundingBox.y + (boundingBox.height / 2)) - 6) + 'px')
						]),
					_List_Nil);
			case 'TopRight':
				return $elm$html$Html$text('');
			case 'TopLeft':
				return $elm$html$Html$text('');
			case 'BottomRight':
				return $elm$html$Html$text('');
			default:
				return $elm$html$Html$text('');
		}
	}
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$resizedAttributes = F2(
	function (cardFitToViewport, attributes) {
		if (cardFitToViewport.$ === 'Opening') {
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromFloat(0) + 'px'),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'top',
						$elm$core$String$fromFloat(0) + 'px'),
					attributes));
		} else {
			var boundingBox = cardFitToViewport.b;
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromFloat(boundingBox.x) + 'px'),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'top',
						$elm$core$String$fromFloat(boundingBox.y) + 'px'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$style,
							'max-height',
							$elm$core$String$fromFloat(boundingBox.height) + 'px'),
						A2(
							$elm$core$List$cons,
							(boundingBox.width > 400) ? A2($elm$html$Html$Attributes$style, 'max-width', '40rem') : A2(
								$elm$html$Html$Attributes$style,
								'max-width',
								$elm$core$String$fromFloat(boundingBox.width) + 'px'),
							attributes))));
		}
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$renderTooltip = F2(
	function (model, config) {
		var visibilityAttributes = F2(
			function (card, attributes) {
				if (card.$ === 'Opening') {
					return A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$style, 'visibility', 'hidden'),
						attributes);
				} else {
					return attributes;
				}
			});
		var _v0 = model.card;
		if (_v0.$ === 'Just') {
			var card = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-tooltip__arrow-and-tooltip-container')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$AdvancedTooltip$getCardArrow(card),
						A2(
						$elm$html$Html$div,
						A2(
							$author$project$PinMeTo$Ui$AdvancedTooltip$resizedAttributes,
							card,
							A2(
								visibilityAttributes,
								card,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(
										$author$project$PinMeTo$Ui$AdvancedTooltip$cardId(config.uid)),
										$elm$html$Html$Attributes$class('pmt-ui-font-caption pmt-ui-tooltip__tooltip')
									]))),
						config.content)
					]));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$MouseLeftTarget = F2(
	function (a, b) {
		return {$: 'MouseLeftTarget', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$MouseEnteredTarget = F3(
	function (a, b, c) {
		return {$: 'MouseEnteredTarget', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$render = F5(
	function (_v0, config, wrapHtml, attributes, htmlContent) {
		var model = _v0.a;
		var clickAttribute = $elm$core$List$concat(
			_List_fromArray(
				[
					attributes,
					_List_fromArray(
					[
						$elm$html$Html$Events$onMouseLeave(
						config.tagger(
							A2($author$project$PinMeTo$Ui$AdvancedTooltip$MouseLeftTarget, config.closeDelay, config.uid))),
						$elm$html$Html$Events$onMouseEnter(
						config.tagger(
							A3($author$project$PinMeTo$Ui$AdvancedTooltip$MouseEnteredTarget, config.openDelay, config.uid, config.preferredDirection))),
						A2(
						$elm$html$Html$Events$on,
						'wheel',
						A2(
							$elm$json$Json$Decode$map,
							config.tagger,
							$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$AdvancedTooltip$Scroll))),
						$elm$html$Html$Attributes$id(
						$author$project$PinMeTo$Ui$AdvancedTooltip$targetId(config.uid))
					])
				]));
		var tooltip = _Utils_eq(
			config.uid,
			A2($elm$core$Maybe$withDefault, '', model.openTooltip)) ? A2($author$project$PinMeTo$Ui$AdvancedTooltip$renderTooltip, model, config) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(wrapHtml, clickAttribute, htmlContent),
					tooltip
				]));
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter = {$: 'TopCenter'};
var $author$project$Location$LocationInfoPane$View$CopyWrapper$openDelayMs = 150;
var $author$project$Location$LocationInfoPane$View$CopyWrapper$closeDelayMs = 100;
var $author$project$PinMeTo$Ui$AdvancedTooltip$withOpenDelay = F2(
	function (delay, config) {
		return _Utils_update(
			config,
			{openDelay: delay});
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$withCloseDelay = F2(
	function (delay, config) {
		return _Utils_update(
			config,
			{closeDelay: delay});
	});
var $author$project$Location$LocationInfoPane$View$CopyWrapper$confirmationCloseDelayMs = 1500;
var $author$project$Location$LocationInfoPane$View$CopyWrapper$render = F2(
	function (config, content) {
		var label = config.copied ? config.confirmationLabel : config.copyLabel;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane-copy-wrapper__container')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$PinMeTo$Ui$AdvancedTooltip$render,
					config.tooltipState,
					A2(
						$author$project$PinMeTo$Ui$AdvancedTooltip$withCloseDelay,
						config.copied ? $author$project$Location$LocationInfoPane$View$CopyWrapper$confirmationCloseDelayMs : $author$project$Location$LocationInfoPane$View$CopyWrapper$closeDelayMs,
						A2(
							$author$project$PinMeTo$Ui$AdvancedTooltip$withOpenDelay,
							$author$project$Location$LocationInfoPane$View$CopyWrapper$openDelayMs,
							$author$project$PinMeTo$Ui$AdvancedTooltip$view(
								{
									uid: 'location-info-pane-copy-' + config.uid,
									tagger: config.tooltipTagger,
									content: _List_fromArray(
										[
											$elm$html$Html$text(label)
										]),
									preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
								}))),
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('location-info-pane-copy-wrapper__button'),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', config.copyLabel),
							$elm$html$Html$Events$onClick(
							config.onCopy(config.value))
						]),
					content)
				]));
	});
var $author$project$Location$LocationInfoPane$Model$TooltipMsg = function (a) {
	return {$: 'TooltipMsg', a: a};
};
var $author$project$Location$LocationInfoPane$Model$CopyToClipboard = function (a) {
	return {$: 'CopyToClipboard', a: a};
};
var $author$project$Location$LocationInfoPane$View$Header$renderLocationName = F2(
	function (_v0, model) {
		var translations = _v0.translations;
		return A2(
			$author$project$Location$LocationInfoPane$View$CopyWrapper$render,
			{
				uid: 'location-name',
				value: model.location.name,
				copied: _Utils_eq(
					model.copiedValue,
					$elm$core$Maybe$Just(model.location.name)),
				onCopy: $author$project$Location$LocationInfoPane$Model$CopyToClipboard,
				copyLabel: $author$project$Translations$General$copy(translations),
				tooltipState: model.tooltipState,
				tooltipTagger: $author$project$Location$LocationInfoPane$Model$TooltipMsg,
				confirmationLabel: $author$project$Translations$General$copied(translations)
			},
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane-header__storefront-name pmt-ui-font-note-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(model.location.name)
						]))
				]));
	});
var $author$project$Translations$General$open = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.open');
};
var $author$project$Translations$General$disabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.disabled');
};
var $author$project$Location$LocationInfoPane$View$Header$renderLocationStatus = F3(
	function (translations, today, location) {
		var todayDate = $justinmimbs$date$Date$toIsoString(today);
		var _v0 = (!location.isActive) ? _Utils_Tuple2(
			$author$project$Translations$General$disabled(translations),
			'location-info-pane-header__status-pill--disabled') : (location.permanentlyClosed ? _Utils_Tuple2(
			$author$project$Translations$General$closed(translations),
			'location-info-pane-header__status-pill--closed') : ((_Utils_cmp(location.temporarilyClosedUntil, todayDate) > -1) ? _Utils_Tuple2(
			$author$project$Translations$General$locationTempClosed(translations),
			'location-info-pane-header__status-pill--temporarily-closed') : _Utils_Tuple2(
			$author$project$Translations$General$open(translations),
			'location-info-pane-header__status-pill--open')));
		var label = _v0.a;
		var statusClass = _v0.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane-header__status-pill ' + statusClass)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Location$LocationInfoPane$View$Header$render = F2(
	function (session, model) {
		return A2(
			$author$project$PinMeTo$Ui$Layout$Flex$render,
			_List_fromArray(
				[
					A3($author$project$Location$LocationInfoPane$View$Header$renderLocationStatus, session.translations, model.today, model.location),
					A2($author$project$Location$LocationInfoPane$View$Header$renderLocationName, session, model)
				]),
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withPaddingBottom,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingLG,
				A2(
					$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
					$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
					A2(
						$author$project$PinMeTo$Ui$Layout$Flex$withJustify,
						$author$project$PinMeTo$Ui$Layout$Flex$SpaceBetween,
						A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)))));
	});
var $author$project$Location$LocationInfoPane$View$Address$render = F2(
	function (_v0, model) {
		var translations = _v0.translations;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane-address__container pmt-ui-font-caption')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane-address__key')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationStreet(translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.location.address.street)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane-address__key')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationZip(translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.location.address.zip)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane-address__key')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationCity(translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.location.address.city)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane-address__key')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationCountry(translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(model.location.address.country)
						]))
				]));
	});
var $author$project$Location$LocationInfoPane$View$StoreId$render = F2(
	function (_v0, model) {
		var translations = _v0.translations;
		return A2(
			$author$project$Location$LocationInfoPane$View$CopyWrapper$render,
			{
				uid: 'store-id',
				value: model.location.storeId,
				copied: _Utils_eq(
					model.copiedValue,
					$elm$core$Maybe$Just(model.location.storeId)),
				onCopy: $author$project$Location$LocationInfoPane$Model$CopyToClipboard,
				copyLabel: $author$project$Translations$General$copy(translations),
				tooltipState: model.tooltipState,
				tooltipTagger: $author$project$Location$LocationInfoPane$Model$TooltipMsg,
				confirmationLabel: $author$project$Translations$General$copied(translations)
			},
			_List_fromArray(
				[
					$elm$html$Html$text(model.location.storeId)
				]));
	});
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsBing = {$: 'InsightsBing'};
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsApple = {$: 'InsightsApple'};
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsGoogle = {$: 'InsightsGoogle'};
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsRating = {$: 'InsightsRating'};
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsFacebook = {$: 'InsightsFacebook'};
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsKeywords = {$: 'InsightsKeywords'};
var $author$project$Location$LocationInfoPane$Types$Navigation$InsightsOverview = {$: 'InsightsOverview'};
var $author$project$Location$LocationInfoPane$View$Navigation$insightsItems = _List_fromArray(
	[
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsOverview,
		shouldRender: function (_v0) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsRating,
		shouldRender: function (model) {
			return model.siteNetworks.google;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsKeywords,
		shouldRender: function (model) {
			return model.siteNetworks.google;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsGoogle,
		shouldRender: function (model) {
			return model.siteNetworks.google;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsApple,
		shouldRender: function (model) {
			return model.siteNetworks.apple;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsFacebook,
		shouldRender: function (model) {
			return model.siteNetworks.facebook;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$InsightsBing,
		shouldRender: function (_v1) {
			return true;
		}
	}
	]);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Translations$Listings$LocationDetail$customFields = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.custom_fields');
};
var $author$project$Translations$Listings$LocationDetail$sectionImages = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.section_images');
};
var $author$project$Translations$Listings$LocationDetail$sectionCategories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.section_categories');
};
var $author$project$Translations$Listings$LocationDetail$sectionGeneralData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.section_general_data');
};
var $author$project$Translations$General$locationHoursAndStatus = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_hours_and_status');
};
var $author$project$Translations$Listings$LocationDetail$sectionContactAndLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.section_contact_and_links');
};
var $author$project$Translations$Listings$LocationDetail$sectionAttributesAndServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.section_attributes_and_services');
};
var $author$project$Location$LocationInfoPane$View$Navigation$navItemToLabel = F2(
	function (_v0, navItem) {
		var translations = _v0.translations;
		switch (navItem.$) {
			case 'GeneralData':
				return $author$project$Translations$Listings$LocationDetail$sectionGeneralData(translations);
			case 'Address':
				return $author$project$Translations$Listings$LocationDetail$sectionAddress(translations);
			case 'ContactInformation':
				return $author$project$Translations$Listings$LocationDetail$sectionContactAndLinks(translations);
			case 'AttributesAndServices':
				return $author$project$Translations$Listings$LocationDetail$sectionAttributesAndServices(translations);
			case 'Images':
				return $author$project$Translations$Listings$LocationDetail$sectionImages(translations);
			case 'Categories':
				return $author$project$Translations$Listings$LocationDetail$sectionCategories(translations);
			case 'OpenHours':
				return $author$project$Translations$General$locationHoursAndStatus(translations);
			default:
				return $author$project$Translations$Listings$LocationDetail$customFields(translations);
		}
	});
var $author$project$Location$LocationInfoPane$Model$OnNavigationClicked = function (a) {
	return {$: 'OnNavigationClicked', a: a};
};
var $author$project$Location$LocationInfoPane$View$Navigation$renderNavItem = F3(
	function (session, model, navItem) {
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane-navigation__item pmt-ui-font-note'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'location-info-pane-navigation__active',
							_Utils_eq(model.currentNavItem, navItem))
						]))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'navItem_' + A2($author$project$Location$LocationInfoPane$View$Navigation$navItemToLabel, session, navItem),
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Location$LocationInfoPane$Model$OnNavigationClicked(navItem))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Location$LocationInfoPane$View$Navigation$navItemToLabel, session, navItem))
							])))
				]));
	});
var $author$project$FontAwesome$Light$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$FontAwesome$Light$Icon$faStar = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-star');
var $author$project$FontAwesome$Light$faStar = $author$project$FontAwesome$Light$Icon$render($author$project$FontAwesome$Light$Icon$faStar);
var $author$project$FontAwesome$Brands$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$FontAwesome$Brands$Icon$faApple = $author$project$FontAwesome$Brands$Icon$Icon('fa-brands fa-apple');
var $author$project$FontAwesome$Brands$faApple = $author$project$FontAwesome$Brands$Icon$render($author$project$FontAwesome$Brands$Icon$faApple);
var $author$project$FontAwesome$Brands$Icon$faGoogle = $author$project$FontAwesome$Brands$Icon$Icon('fa-brands fa-google');
var $author$project$FontAwesome$Brands$faGoogle = $author$project$FontAwesome$Brands$Icon$render($author$project$FontAwesome$Brands$Icon$faGoogle);
var $author$project$PinMeTo$Ui$Icon$NetworkBing = {$: 'NetworkBing'};
var $author$project$FontAwesome$Light$Icon$faChartLine = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-chart-line');
var $author$project$FontAwesome$Light$faChartLine = $author$project$FontAwesome$Light$Icon$render($author$project$FontAwesome$Light$Icon$faChartLine);
var $author$project$FontAwesome$Brands$Icon$faFacebookF = $author$project$FontAwesome$Brands$Icon$Icon('fa-brands fa-facebook-f');
var $author$project$FontAwesome$Brands$faFacebookF = $author$project$FontAwesome$Brands$Icon$render($author$project$FontAwesome$Brands$Icon$faFacebookF);
var $author$project$FontAwesome$Light$Icon$faInputText = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-input-text');
var $author$project$FontAwesome$Light$faInputText = $author$project$FontAwesome$Light$Icon$render($author$project$FontAwesome$Light$Icon$faInputText);
var $author$project$Location$LocationInfoPane$View$Navigation$pageItemToIcon = function (pageItem) {
	switch (pageItem.$) {
		case 'InsightsOverview':
			return $author$project$FontAwesome$Light$faChartLine;
		case 'InsightsRating':
			return $author$project$FontAwesome$Light$faStar;
		case 'InsightsKeywords':
			return $author$project$FontAwesome$Light$faInputText;
		case 'InsightsGoogle':
			return $author$project$FontAwesome$Brands$faGoogle;
		case 'InsightsFacebook':
			return $author$project$FontAwesome$Brands$faFacebookF;
		case 'InsightsBing':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$NetworkBing);
		default:
			return $author$project$FontAwesome$Brands$faApple;
	}
};
var $author$project$Translations$General$Insights$bing = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.bing');
};
var $author$project$Translations$General$Insights$apple = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.apple');
};
var $author$project$Translations$General$Insights$google = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.google');
};
var $author$project$Translations$General$Insights$facebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.facebook');
};
var $author$project$Translations$General$Insights$overview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.overview');
};
var $author$project$Translations$General$Insights$ratingTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.rating_title');
};
var $author$project$Translations$General$Insights$keywordsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.keywords_title');
};
var $author$project$Location$LocationInfoPane$View$Navigation$pageItemToLabel = F2(
	function (_v0, pageItem) {
		var translations = _v0.translations;
		switch (pageItem.$) {
			case 'InsightsOverview':
				return $author$project$Translations$General$Insights$overview(translations);
			case 'InsightsRating':
				return $author$project$Translations$General$Insights$ratingTitle(translations);
			case 'InsightsFacebook':
				return $author$project$Translations$General$Insights$facebook(translations);
			case 'InsightsBing':
				return $author$project$Translations$General$Insights$bing(translations);
			case 'InsightsApple':
				return $author$project$Translations$General$Insights$apple(translations);
			case 'InsightsGoogle':
				return $author$project$Translations$General$Insights$google(translations);
			default:
				return $author$project$Translations$General$Insights$keywordsTitle(translations);
		}
	});
var $author$project$Location$LocationInfoPane$View$Navigation$pageItemToRedirect = F2(
	function (model, pageItem) {
		switch (pageItem.$) {
			case 'InsightsOverview':
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/overview')));
			case 'InsightsRating':
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/rating')));
			case 'InsightsFacebook':
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/facebook')));
			case 'InsightsBing':
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/bing')));
			case 'InsightsApple':
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/apple')));
			case 'InsightsGoogle':
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/google')));
			default:
				return '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/keywords')));
		}
	});
var $author$project$Location$LocationInfoPane$View$Navigation$renderPageItem = F3(
	function (session, model, pageItem) {
		var isCurrentPage = function () {
			var _v0 = model.page;
			if ((_v0.$ === 'Just') && (_v0.a.$ === 'InsightPage')) {
				var p = _v0.a.a;
				return _Utils_eq(p, pageItem);
			} else {
				return false;
			}
		}();
		var getLabel = $author$project$Location$LocationInfoPane$View$Navigation$pageItemToLabel(session);
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane-navigation__item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('location-info-pane-navigation__active', isCurrentPage)
						]))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pageItem_' + getLabel(pageItem),
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								A2($author$project$Location$LocationInfoPane$View$Navigation$pageItemToRedirect, model, pageItem))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('location-info-pane-navigation__item-with-icon')
									]),
								_List_fromArray(
									[
										$author$project$Location$LocationInfoPane$View$Navigation$pageItemToIcon(pageItem),
										$elm$html$Html$text(
										getLabel(pageItem))
									]))
							])))
				]));
	});
var $author$project$Location$LocationInfoPane$Types$Navigation$Images = {$: 'Images'};
var $author$project$Location$LocationInfoPane$Types$Navigation$Address = {$: 'Address'};
var $author$project$Location$LocationInfoPane$Types$Navigation$OpenHours = {$: 'OpenHours'};
var $author$project$Location$LocationInfoPane$Types$Navigation$Categories = {$: 'Categories'};
var $author$project$Location$LocationInfoPane$Types$Navigation$CustomFields = {$: 'CustomFields'};
var $author$project$Location$LocationInfoPane$Types$Navigation$ContactInformation = {$: 'ContactInformation'};
var $author$project$Location$LocationInfoPane$Types$Navigation$AttributesAndServices = {$: 'AttributesAndServices'};
var $author$project$Location$LocationInfoPane$View$Navigation$detailsNavItems = _List_fromArray(
	[
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$GeneralData,
		shouldRender: function (_v0) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$Address,
		shouldRender: function (_v1) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$OpenHours,
		shouldRender: function (_v2) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$ContactInformation,
		shouldRender: function (_v3) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$AttributesAndServices,
		shouldRender: function (_v4) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$Images,
		shouldRender: function (_v5) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$Categories,
		shouldRender: function (_v6) {
			return true;
		}
	},
		{
		item: $author$project$Location$LocationInfoPane$Types$Navigation$CustomFields,
		shouldRender: function (_v7) {
			return true;
		}
	}
	]);
var $author$project$Location$LocationInfoPane$View$Navigation$renderItemsForPage = F3(
	function (session, model, page) {
		var renderFilter = $elm$core$List$filterMap(
			function (_v1) {
				var shouldRender = _v1.shouldRender;
				var item = _v1.item;
				return shouldRender(model) ? $elm$core$Maybe$Just(item) : $elm$core$Maybe$Nothing;
			});
		var items = function () {
			switch (page.$) {
				case 'DetailsPage':
					return A2(
						$elm$core$List$map,
						A2($author$project$Location$LocationInfoPane$View$Navigation$renderNavItem, session, model),
						renderFilter($author$project$Location$LocationInfoPane$View$Navigation$detailsNavItems));
				case 'InsightPage':
					return A2(
						$elm$core$List$map,
						A2($author$project$Location$LocationInfoPane$View$Navigation$renderPageItem, session, model),
						renderFilter($author$project$Location$LocationInfoPane$View$Navigation$insightsItems));
				default:
					return _List_Nil;
			}
		}();
		return items;
	});
var $author$project$Location$LocationInfoPane$View$Navigation$render = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane-navigation__container pmt-ui-font-note')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Location$LocationInfoPane$View$Navigation$renderItemsForPage, session, model),
					model.page)));
	});
var $author$project$PinMeTo$Ui$Layout$Flex$Start = {$: 'Start'};
var $author$project$PinMeTo$Ui$Layout$Spacing$withPaddingTop = F2(
	function (spacing, config) {
		var padding_ = config.padding;
		return _Utils_update(
			config,
			{
				padding: _Utils_update(
					padding_,
					{
						top: $elm$core$Maybe$Just(spacing)
					})
			});
	});
var $author$project$PinMeTo$Ui$Badge$TopRight = {$: 'TopRight'};
var $author$project$PinMeTo$Ui$Badge$Neutral = {$: 'Neutral'};
var $author$project$PinMeTo$Ui$Badge$Success = {$: 'Success'};
var $author$project$PinMeTo$Ui$Badge$Warning = {$: 'Warning'};
var $author$project$Location$LocationInfoPane$View$NetworkIcons$getColor = function (idSetType) {
	switch (idSetType.$) {
		case 'Approved':
			return $author$project$PinMeTo$Ui$Badge$Success;
		case 'UserAction':
			return $author$project$PinMeTo$Ui$Badge$Neutral;
		default:
			return $author$project$PinMeTo$Ui$Badge$Warning;
	}
};
var $author$project$Location$LocationInfoPane$View$NetworkIcons$renderIcon = F3(
	function (link, isInternalLink, icon) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-info-pane__icon--container'),
						$elm$html$Html$Attributes$href(link)
					]),
				isInternalLink ? _List_Nil : _List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$rel('noopener noreferrer')
					])),
			_List_fromArray(
				[icon]));
	});
var $author$project$PinMeTo$Ui$Badge$NoIcon = {$: 'NoIcon'};
var $author$project$PinMeTo$Ui$Badge$FASolid = function (a) {
	return {$: 'FASolid', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faClock = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-clock');
var $author$project$Location$LocationInfoPane$View$NetworkIcons$getBadgeIcon = function (idSetType) {
	switch (idSetType.$) {
		case 'Approved':
			return $author$project$PinMeTo$Ui$Badge$NoIcon;
		case 'UserAction':
			return $author$project$PinMeTo$Ui$Badge$FASolid($author$project$FontAwesome$Solid$Icon$faClock);
		default:
			return $author$project$PinMeTo$Ui$Badge$FASolid($author$project$FontAwesome$Solid$Icon$faCircleExclamation);
	}
};
var $author$project$PinMeTo$Ui$Badge$renderBadge = function (badgeType) {
	switch (badgeType.$) {
		case 'FA':
			var icon = badgeType.a;
			return $author$project$FontAwesome$render(icon);
		case 'FASolid':
			var icon = badgeType.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$solid(icon));
		case 'FARegular':
			var icon = badgeType.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$regular(icon));
		case 'FABrands':
			var icon = badgeType.a;
			return $author$project$FontAwesome$render(
				$author$project$FontAwesome$brands(icon));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$PinMeTo$Ui$Badge$renderWithBadge = F4(
	function (element, position, badgePosition, badgeColor) {
		var positionStr = function () {
			switch (position.$) {
				case 'TopLeft':
					return 'top-left';
				case 'TopRight':
					return 'top-right';
				case 'BottomLeft':
					return 'bottom-left';
				default:
					return 'bottom-right';
			}
		}();
		var colorStr = function () {
			switch (badgeColor.$) {
				case 'Error':
					return 'error';
				case 'Success':
					return 'success';
				case 'Warning':
					return 'warning';
				case 'Info':
					return 'info';
				default:
					return 'neutral';
			}
		}();
		var badgeClasses = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				['badge', 'badge--' + positionStr, 'badge--' + colorStr]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('badge-wrapper')
				]),
			_List_fromArray(
				[
					element,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(badgeClasses)
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Badge$renderBadge(badgePosition)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Icon$NetworkTwoWay = {$: 'NetworkTwoWay'};
var $author$project$PinMeTo$Ui$Icon$RegularColorGoogle = {$: 'RegularColorGoogle'};
var $author$project$Location$LocationInfoPane$View$NetworkIcons$renderNetworkIcon = function (network) {
	var icon = function () {
		switch (network.$) {
			case 'Apple':
				return $author$project$PinMeTo$Ui$Icon$RegularColorApple;
			case 'Bing':
				return $author$project$PinMeTo$Ui$Icon$RegularColorBing;
			case 'Facebook':
				return $author$project$PinMeTo$Ui$Icon$RegularColorFacebook;
			case 'Google':
				return $author$project$PinMeTo$Ui$Icon$RegularColorGoogle;
			case 'Ptv':
				return $author$project$PinMeTo$Ui$Icon$RegularColorPTV;
			default:
				return $author$project$PinMeTo$Ui$Icon$NetworkTwoWay;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Icon$render(icon)
			]));
};
var $author$project$Location$LocationInfoPane$View$NetworkIcons$getNetworkIcon = F5(
	function (network, idSetType, siteName, locationId, link) {
		var networksPageLink = '/listings/' + (siteName + ('/locations/' + (locationId + '/network-status')));
		var userActionBadge = A4(
			$author$project$PinMeTo$Ui$Badge$renderWithBadge,
			$author$project$Location$LocationInfoPane$View$NetworkIcons$renderNetworkIcon(network),
			$author$project$PinMeTo$Ui$Badge$TopRight,
			$author$project$Location$LocationInfoPane$View$NetworkIcons$getBadgeIcon($author$project$Data$Network$UserAction),
			$author$project$Location$LocationInfoPane$View$NetworkIcons$getColor($author$project$Data$Network$UserAction));
		var badge = A4(
			$author$project$PinMeTo$Ui$Badge$renderWithBadge,
			$author$project$Location$LocationInfoPane$View$NetworkIcons$renderNetworkIcon(network),
			$author$project$PinMeTo$Ui$Badge$TopRight,
			$author$project$Location$LocationInfoPane$View$NetworkIcons$getBadgeIcon(idSetType),
			$author$project$Location$LocationInfoPane$View$NetworkIcons$getColor(idSetType));
		switch (idSetType.$) {
			case 'Approved':
				return (link === '') ? (_Utils_eq(network, $author$project$Data$Network$Bing) ? A3($author$project$Location$LocationInfoPane$View$NetworkIcons$renderIcon, networksPageLink, true, userActionBadge) : A3($author$project$Location$LocationInfoPane$View$NetworkIcons$renderIcon, networksPageLink, true, badge)) : A3($author$project$Location$LocationInfoPane$View$NetworkIcons$renderIcon, link, false, badge);
			case 'UserAction':
				return A3($author$project$Location$LocationInfoPane$View$NetworkIcons$renderIcon, networksPageLink, true, badge);
			default:
				return (link === '') ? $elm$html$Html$text('') : A3($author$project$Location$LocationInfoPane$View$NetworkIcons$renderIcon, networksPageLink, true, badge);
		}
	});
var $author$project$Location$LocationInfoPane$View$NetworkIcons$getMapNetworkButton = F4(
	function (network, networkData, site, locationId) {
		return A5($author$project$Location$LocationInfoPane$View$NetworkIcons$getNetworkIcon, network, networkData.idSetType, site, locationId, networkData.link);
	});
var $author$project$Location$LocationInfoPane$View$NetworkIcons$render = function (model) {
	var site = $author$project$Data$SiteName$toString(model.siteName);
	return A2(
		$author$project$PinMeTo$Ui$Layout$Flex$render,
		_List_fromArray(
			[
				A4($author$project$Location$LocationInfoPane$View$NetworkIcons$getMapNetworkButton, $author$project$Data$Network$Google, model.location.google, site, model.location.id),
				A4($author$project$Location$LocationInfoPane$View$NetworkIcons$getMapNetworkButton, $author$project$Data$Network$Apple, model.location.apple, site, model.location.id),
				A4($author$project$Location$LocationInfoPane$View$NetworkIcons$getMapNetworkButton, $author$project$Data$Network$Bing, model.location.bing, site, model.location.id),
				A4($author$project$Location$LocationInfoPane$View$NetworkIcons$getMapNetworkButton, $author$project$Data$Network$Facebook, model.location.facebook, site, model.location.id),
				A4($author$project$Location$LocationInfoPane$View$NetworkIcons$getMapNetworkButton, $author$project$Data$Network$Ptv, model.location.ptv, site, model.location.id)
			]),
		A2(
			$author$project$PinMeTo$Ui$Layout$Spacing$withPaddingBottom,
			$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withPaddingTop,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
				A2(
					$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
					$author$project$PinMeTo$Ui$Layout$Spacing$SpacingLG,
					A2(
						$author$project$PinMeTo$Ui$Layout$Flex$withJustify,
						$author$project$PinMeTo$Ui$Layout$Flex$Start,
						A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex))))));
};
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (!_Utils_eq(
					c,
					_Utils_chr('0'))) && (!_Utils_eq(
					c,
					_Utils_chr('.')));
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3(
				$elm$core$String$padRight,
				e + 1,
				_Utils_chr('0'),
				total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (_Utils_eq(
		head,
		_Utils_chr('9'))) {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 'Nothing') {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				_Utils_chr('0'),
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var signed = fl < 0;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					_Utils_chr('0'),
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3(
					$elm$core$String$padRight,
					s,
					_Utils_chr('0'),
					after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 'Nothing') {
				return false;
			} else {
				if ('5' === _v0.a.a.valueOf()) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$PinMeTo$Ui$Layout$Flex$AlignEnd = {$: 'AlignEnd'};
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingXS = {$: 'SpacingXS'};
var $author$project$Location$LocationInfoPane$View$Reviews$reviewCount = function (stats) {
	return stats.answeredCount + stats.unAnsweredCount;
};
var $author$project$Location$LocationInfoPane$View$Reviews$reviewAverage = function (stats) {
	var totalScore = $elm$core$List$sum(
		_List_fromArray(
			[stats.oneStar, stats.twoStar * 2, stats.threeStar * 3, stats.fourStar * 4, stats.fiveStar * 5]));
	var count = $author$project$Location$LocationInfoPane$View$Reviews$reviewCount(stats);
	return ((!count) || (!totalScore)) ? 0 : (totalScore / count);
};
var $author$project$PinMeTo$Ui$Insights$Rating$pct = function (rating) {
	return $elm$core$String$fromFloat((rating / 5) * 100) + '%';
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$PinMeTo$Ui$Insights$Rating$renderStartRating = F3(
	function (toString, rating, asides) {
		return A3(
			$elm$html$Html$node,
			'pmt-rating',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-rating')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-rating__value')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-rating__value-numeric')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											toString(rating))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-rating__value-stars')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-rating__stars-bg')
												]),
											A2(
												$elm$core$List$repeat,
												5,
												A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa-solid fa-star')
														]),
													_List_Nil))),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													$author$project$PinMeTo$Ui$Insights$Rating$pct(rating)),
													$elm$html$Html$Attributes$class('pmt-rating__stars-fg')
												]),
											A2(
												$elm$core$List$repeat,
												5,
												A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa-solid fa-star')
														]),
													_List_Nil)))
										]))
								]))
						])),
					function () {
					if (asides.$ === 'Just') {
						var asides_ = asides.a;
						return A2(
							$elm$html$Html$aside,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-rating__aside')
								]),
							_List_fromArray(
								[asides_]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage = F2(
	function (toString, rating) {
		return A3($author$project$PinMeTo$Ui$Insights$Rating$renderStartRating, toString, rating, $elm$core$Maybe$Nothing);
	});
var $author$project$Location$LocationInfoPane$View$Reviews$renderRating = F3(
	function (session, model, stats) {
		var reviewsLink = '/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.location.id + '/insights/rating')));
		return A2(
			$author$project$PinMeTo$Ui$Layout$Flex$render,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-note')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage,
							$myrho$elm_round$Round$round(2),
							$author$project$Location$LocationInfoPane$View$Reviews$reviewAverage(stats))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane__rating-block--reviews-count'),
							$elm$html$Html$Attributes$href(reviewsLink)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3(
								$author$project$PinMeToPage$translatePluralValue,
								session,
								'general.number_of_reviews',
								$author$project$Location$LocationInfoPane$View$Reviews$reviewCount(stats)))
						]))
				]),
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXS,
				A2(
					$author$project$PinMeTo$Ui$Layout$Flex$withAlign,
					$author$project$PinMeTo$Ui$Layout$Flex$AlignEnd,
					A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex))));
	});
var $author$project$Translations$General$Insights$failedToLoadReviews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.failed_to_load_reviews');
};
var $author$project$Location$LocationInfoPane$View$Reviews$renderRatingLoading = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('location-info-pane__rating-block')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage,
			$myrho$elm_round$Round$round(1),
			0)
		]));
var $author$project$Location$LocationInfoPane$View$Reviews$renderRatingBlock = F2(
	function (session, model) {
		var _v0 = model.lifetimeRatings;
		switch (_v0.$) {
			case 'Loading':
				return $author$project$Location$LocationInfoPane$View$Reviews$renderRatingLoading;
			case 'Suspended':
				return $author$project$Location$LocationInfoPane$View$Reviews$renderRatingLoading;
			case 'Error':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane__rating-block')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$Insights$failedToLoadReviews(session.translations))
						]));
			default:
				var stats = _v0.a;
				return A3($author$project$Location$LocationInfoPane$View$Reviews$renderRating, session, model, stats);
		}
	});
var $author$project$Location$LocationInfoPane$View$Reviews$render = F2(
	function (session, model) {
		return A2($author$project$Location$LocationInfoPane$View$Reviews$renderRatingBlock, session, model);
	});
var $author$project$PinMeTo$Ui$ProgressBar$ProgressBar = function (a) {
	return {$: 'ProgressBar', a: a};
};
var $author$project$PinMeTo$Ui$ProgressBar$view = function (percentage) {
	return $author$project$PinMeTo$Ui$ProgressBar$ProgressBar(
		{style: $elm$core$Maybe$Nothing, isActive: true, withLabel: true, percentage: percentage, manualColor: $elm$core$Maybe$Nothing});
};
var $author$project$Translations$Listings$DataCompleteness$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.data-completeness.title');
};
var $author$project$PinMeTo$Ui$ProgressBar$Mixed = {$: 'Mixed'};
var $author$project$PinMeTo$Ui$ProgressBar$Negative = {$: 'Negative'};
var $author$project$PinMeTo$Ui$ProgressBar$Positive = {$: 'Positive'};
var $author$project$PinMeTo$Ui$ProgressBar$ReviewSlim = {$: 'ReviewSlim'};
var $author$project$PinMeTo$Ui$ProgressBar$ReviewThick = {$: 'ReviewThick'};
var $author$project$PinMeTo$Ui$ProgressBar$SlimUnbound = {$: 'SlimUnbound'};
var $author$project$PinMeTo$Ui$ProgressBar$ConversationsThick = {$: 'ConversationsThick'};
var $author$project$PinMeTo$Ui$ProgressBar$render = function (_v0) {
	var config = _v0.a;
	var stringPercentage = $elm$core$String$fromInt(
		$elm$core$Basics$round(config.percentage));
	var cssClass = function () {
		var _v1 = config.manualColor;
		if (_v1.$ === 'Just') {
			switch (_v1.a.$) {
				case 'Negative':
					var _v2 = _v1.a;
					return 'ui-progress-bar__attention-filling';
				case 'Mixed':
					var _v3 = _v1.a;
					return 'ui-progress-bar__warning-filling';
				default:
					var _v4 = _v1.a;
					return 'ui-progress-bar__success-filling';
			}
		} else {
			return config.isActive ? ((config.percentage < 25) ? 'ui-progress-bar__attention-filling' : ((config.percentage < 75) ? 'ui-progress-bar__warning-filling' : 'ui-progress-bar__success-filling')) : 'ui-progress-bar__inactive-filling';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ui-progress-bar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('ui-progress-bar__bar', true),
								_Utils_Tuple2(
								'ui-progress-bar__bar-review-thick',
								_Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ReviewThick))),
								_Utils_Tuple2(
								'ui-progress-bar__bar-review-slim',
								_Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ReviewSlim))),
								_Utils_Tuple2(
								'ui-progress-bar__bar-conversations-thick',
								_Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ConversationsThick))),
								_Utils_Tuple2(
								'ui-progress-bar__bar-slim-unbound',
								_Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$SlimUnbound))),
								_Utils_Tuple2(
								'ui-progress-bar__attention-background',
								_Utils_eq(
									config.manualColor,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$Negative)) && _Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ConversationsThick))),
								_Utils_Tuple2(
								'ui-progress-bar__warning-background',
								_Utils_eq(
									config.manualColor,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$Mixed)) && _Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ConversationsThick))),
								_Utils_Tuple2(
								'ui-progress-bar__success-background',
								_Utils_eq(
									config.manualColor,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$Positive)) && _Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ConversationsThick)))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(cssClass),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('ui-progress-bar__filling', true),
										_Utils_Tuple2(
										'ui-progress-bar__filling-review-thick',
										_Utils_eq(
											config.style,
											$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ReviewThick))),
										_Utils_Tuple2(
										'ui-progress-bar__filling-review-slim',
										_Utils_eq(
											config.style,
											$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ReviewSlim))),
										_Utils_Tuple2(
										'ui-progress-bar__filling-conversations-thick',
										_Utils_eq(
											config.style,
											$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ConversationsThick)))
									])),
								A2($elm$html$Html$Attributes$style, 'width', stringPercentage + '%')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' ')
							]))
					])),
				config.withLabel ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-progress-bar__label'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('ui-progress-bar__label', true),
								_Utils_Tuple2(
								'ui-progress-bar__label-review-thick',
								_Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ReviewThick))),
								_Utils_Tuple2(
								'ui-progress-bar__label-review-slim',
								_Utils_eq(
									config.style,
									$elm$core$Maybe$Just($author$project$PinMeTo$Ui$ProgressBar$ReviewSlim)))
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stringPercentage + '%')
					])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
			]));
};
var $author$project$PinMeTo$Ui$ProgressBar$withStyle = F2(
	function (style, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ProgressBar$ProgressBar(
			_Utils_update(
				config,
				{
					style: $elm$core$Maybe$Just(style)
				}));
	});
var $author$project$PinMeTo$Ui$Layout$Flex$AlignStart = {$: 'AlignStart'};
var $author$project$Location$LocationInfoPane$View$DataCompleteness$render = F2(
	function (_v0, model) {
		var translations = _v0.translations;
		var score = function () {
			var _v1 = model.dataCompleteness;
			if (_v1.$ === 'Loaded') {
				var s = _v1.a;
				return A3($elm$core$Basics$clamp, 0, 100, s);
			} else {
				return 0;
			}
		}();
		return A2(
			$author$project$PinMeTo$Ui$Layout$Flex$render,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-caption')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$DataCompleteness$title(translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane__data-completeness--progress-bar')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$ProgressBar$render(
							A2(
								$author$project$PinMeTo$Ui$ProgressBar$withStyle,
								$author$project$PinMeTo$Ui$ProgressBar$SlimUnbound,
								$author$project$PinMeTo$Ui$ProgressBar$view(score)))
						]))
				]),
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXS,
				A2(
					$author$project$PinMeTo$Ui$Layout$Flex$withAlign,
					$author$project$PinMeTo$Ui$Layout$Flex$AlignStart,
					A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex))));
	});
var $author$project$Location$LocationInfoPane$View$dataCompletenessAndReviews = F2(
	function (session, model) {
		return A2(
			$author$project$PinMeTo$Ui$Layout$Flex$render,
			_List_fromArray(
				[
					A2($author$project$Location$LocationInfoPane$View$DataCompleteness$render, session, model),
					A2($author$project$Location$LocationInfoPane$View$Reviews$render, session, model)
				]),
			A2(
				$author$project$PinMeTo$Ui$Layout$Flex$withJustify,
				$author$project$PinMeTo$Ui$Layout$Flex$SpaceBetween,
				A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)));
	});
var $author$project$Location$LocationInfoPane$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-info-pane__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-info-pane__scroll')
						]),
					_List_fromArray(
						[
							A2($author$project$Location$LocationInfoPane$View$Header$render, session, model),
							function () {
							var _v0 = model.location.locationType;
							if (_v0.$ === 'ServiceArea') {
								return $author$project$Location$LocationInfoPane$View$NetworkIcons$render(model);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Location$LocationInfoPane$View$Map$render(model),
											$author$project$Location$LocationInfoPane$View$NetworkIcons$render(model)
										]));
							}
						}(),
							A2($author$project$Location$LocationInfoPane$View$dataCompletenessAndReviews, session, model),
							A2($author$project$Location$LocationInfoPane$View$StoreId$render, session, model),
							(!_Utils_eq(model.location.locationType, $author$project$Data$Location$ServiceArea)) ? A2($author$project$Location$LocationInfoPane$View$Address$render, session, model) : $elm$html$Html$text(''),
							A2($author$project$Location$LocationInfoPane$View$Navigation$render, session, model)
						]))
				]));
	});
var $author$project$Location$LocationInfoPane$App$view = F2(
	function (session, model) {
		return A2($author$project$Location$LocationInfoPane$View$view, session, model);
	});
var $author$project$Util$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$Card = F2(
	function (a, b) {
		return {$: 'Card', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$Open = F2(
	function (a, b) {
		return {$: 'Open', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$Close = function (a) {
	return {$: 'Close', a: a};
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$Opening = {$: 'Opening'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$BottomCenter = {$: 'BottomCenter'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$directionToId = function (direction) {
	switch (direction.$) {
		case 'TopRight':
			return 'top-right';
		case 'TopCenter':
			return 'top-center';
		case 'TopLeft':
			return 'top-left';
		case 'BottomRight':
			return 'bottom-right';
		case 'BottomCenter':
			return 'bottom-center';
		case 'BottomLeft':
			return 'bottom-left';
		case 'RightCenter':
			return 'right-center';
		default:
			return 'left-center';
	}
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$TopLeft = {$: 'TopLeft'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$TopRight = {$: 'TopRight'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$BottomLeft = {$: 'BottomLeft'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$LeftCenter = {$: 'LeftCenter'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$BottomRight = {$: 'BottomRight'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$RightCenter = {$: 'RightCenter'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$calculateScore = F3(
	function (direction, originalCard, newCard) {
		var originalArea = originalCard.width * originalCard.height;
		var newArea = newCard.width * newCard.height;
		var calculateDirectionScore = function (dir) {
			return (_Utils_eq(dir, direction) && (originalArea > 0)) ? (newArea / originalArea) : 0;
		};
		return A3(
			$elm$core$List$foldl,
			F2(
				function (dir, acc) {
					return A2(
						$elm$core$Basics$max,
						acc,
						calculateDirectionScore(dir));
				}),
			0,
			_List_fromArray(
				[$author$project$PinMeTo$Ui$AdvancedTooltip$TopRight, $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter, $author$project$PinMeTo$Ui$AdvancedTooltip$TopLeft, $author$project$PinMeTo$Ui$AdvancedTooltip$BottomRight, $author$project$PinMeTo$Ui$AdvancedTooltip$BottomCenter, $author$project$PinMeTo$Ui$AdvancedTooltip$BottomLeft, $author$project$PinMeTo$Ui$AdvancedTooltip$RightCenter, $author$project$PinMeTo$Ui$AdvancedTooltip$LeftCenter]));
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$directionFromId = function (directionId) {
	switch (directionId) {
		case 'top-right':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$TopRight;
		case 'top-center':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter;
		case 'top-left':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$TopLeft;
		case 'bottom-right':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$BottomRight;
		case 'bottom-center':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$BottomCenter;
		case 'bottom-left':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$BottomLeft;
		case 'right-center':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$RightCenter;
		case 'left-center':
			return $author$project$PinMeTo$Ui$AdvancedTooltip$LeftCenter;
		default:
			return $author$project$PinMeTo$Ui$AdvancedTooltip$BottomCenter;
	}
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$scoresAllNearEqual = function (scores) {
	var firstScore = $elm$core$List$head(scores);
	if (firstScore.$ === 'Just') {
		var score = firstScore.a;
		return A2(
			$elm$core$List$all,
			function (s) {
				return $elm$core$Basics$abs(score - s) < 0.1;
			},
			scores);
	} else {
		return false;
	}
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$preferredDirectionIsTopScore = F2(
	function (preferredDirectionScore, scores) {
		if (scores.b) {
			var topScore = scores.a;
			return _Utils_eq(topScore, preferredDirectionScore);
		} else {
			return false;
		}
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$getBestFittingTooltip = F3(
	function (preferredDirection, originalCard, boundingBoxes) {
		var emptyBoundingBox = {x: 0, y: 0, width: 0, height: 0};
		var boundingBoxMap = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v4) {
					var direction = _v4.a;
					var boundingBox = _v4.b;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$AdvancedTooltip$directionToId(direction),
						boundingBox);
				},
				boundingBoxes));
		var scoresMap = A2(
			$elm$core$Dict$map,
			F2(
				function (directionId, boundingBox) {
					return A3(
						$author$project$PinMeTo$Ui$AdvancedTooltip$calculateScore,
						$author$project$PinMeTo$Ui$AdvancedTooltip$directionFromId(directionId),
						originalCard,
						boundingBox);
				}),
			boundingBoxMap);
		var scoresList = $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$second,
				$elm$core$Dict$toList(scoresMap)));
		var preferredDirectionScore = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Dict$get,
				$author$project$PinMeTo$Ui$AdvancedTooltip$directionToId(preferredDirection),
				scoresMap));
		var preferredDirectionIsValid = $author$project$PinMeTo$Ui$AdvancedTooltip$scoresAllNearEqual(
			A2($elm$core$List$map, $elm$core$Tuple$second, scoresList)) || A2(
			$author$project$PinMeTo$Ui$AdvancedTooltip$preferredDirectionIsTopScore,
			preferredDirectionScore,
			A2($elm$core$List$map, $elm$core$Tuple$second, scoresList));
		var _v0 = function () {
			if (preferredDirectionIsValid) {
				return _Utils_Tuple2(
					preferredDirection,
					A2(
						$elm$core$Maybe$withDefault,
						emptyBoundingBox,
						A2(
							$elm$core$Dict$get,
							$author$project$PinMeTo$Ui$AdvancedTooltip$directionToId(preferredDirection),
							boundingBoxMap)));
			} else {
				if (scoresList.b) {
					var _v2 = scoresList.a;
					var direction = _v2.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$AdvancedTooltip$directionFromId(direction),
						A2(
							$elm$core$Maybe$withDefault,
							emptyBoundingBox,
							A2($elm$core$Dict$get, direction, boundingBoxMap)));
				} else {
					return _Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$BottomCenter, emptyBoundingBox);
				}
			}
		}();
		var selectedTooltipDirection = _v0.a;
		var selectedTooltipBoundingBox = _v0.b;
		var padAdjustedBoundingBox = function () {
			switch (selectedTooltipDirection.$) {
				case 'TopLeft':
					return _Utils_update(
						selectedTooltipBoundingBox,
						{x: selectedTooltipBoundingBox.x + 8, y: selectedTooltipBoundingBox.y + 8});
				case 'TopRight':
					return _Utils_update(
						selectedTooltipBoundingBox,
						{x: selectedTooltipBoundingBox.x - 8, y: selectedTooltipBoundingBox.y + 8});
				case 'BottomLeft':
					return _Utils_update(
						selectedTooltipBoundingBox,
						{x: selectedTooltipBoundingBox.x + 8, y: selectedTooltipBoundingBox.y - 8});
				case 'BottomRight':
					return _Utils_update(
						selectedTooltipBoundingBox,
						{x: selectedTooltipBoundingBox.x - 8, y: selectedTooltipBoundingBox.y - 8});
				default:
					return selectedTooltipBoundingBox;
			}
		}();
		return _Utils_Tuple2(selectedTooltipDirection, padAdjustedBoundingBox);
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$leftCardWidthAndX = F3(
	function (viewport, target, card) {
		return {
			x: A2($elm$core$Basics$max, target.x - card.width, viewport.x),
			width: A2($elm$core$Basics$min, target.x - viewport.x, card.width)
		};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$topCardHeightAndY = F3(
	function (viewport, target, card) {
		return {
			y: A2($elm$core$Basics$max, target.y - card.height, viewport.y),
			height: A2($elm$core$Basics$min, target.y - viewport.y, card.height)
		};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$rightCardWidthAndX = F3(
	function (viewport, target, card) {
		return {
			x: target.x + target.width,
			width: A2($elm$core$Basics$min, ((viewport.width + viewport.x) - target.x) - target.width, card.width)
		};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$bottomCardHeightAndY = F3(
	function (viewport, target, card) {
		return {
			y: target.y + target.height,
			height: A2($elm$core$Basics$min, ((viewport.height + viewport.y) - target.y) - target.height, card.height)
		};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$verticalCenterCardHeightAndY = F3(
	function (viewport, target, card) {
		var spaceToBottom = (viewport.height + viewport.y) - (target.y + (target.height / 2));
		var spaceToTop = (target.y - viewport.y) + (target.height / 2);
		var height = 2 * A2(
			$elm$core$Basics$min,
			card.height / 2,
			A2($elm$core$Basics$min, spaceToTop, spaceToBottom));
		return {
			y: A2($elm$core$Basics$max, (target.y + (target.height / 2)) - (height / 2), viewport.y),
			height: height
		};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$horizontalCenterCardWidthAndX = F3(
	function (viewport, target, card) {
		var spaceToRight = (viewport.width + viewport.x) - (target.x + (target.width / 2));
		var spaceToLeft = (target.x - viewport.x) + (target.width / 2);
		var width = 2 * A2(
			$elm$core$Basics$min,
			card.width / 2,
			A2($elm$core$Basics$min, spaceToLeft, spaceToRight));
		return {
			x: A2($elm$core$Basics$max, (target.x + (target.width / 2)) - (width / 2), viewport.x),
			width: width
		};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$getAllPossibleTooltips = F3(
	function (viewport, target, card) {
		var horizontalCenterCard = A3($author$project$PinMeTo$Ui$AdvancedTooltip$horizontalCenterCardWidthAndX, viewport, target, card);
		var verticalCenterCard = A3($author$project$PinMeTo$Ui$AdvancedTooltip$verticalCenterCardHeightAndY, viewport, target, card);
		var bottomCard = A3($author$project$PinMeTo$Ui$AdvancedTooltip$bottomCardHeightAndY, viewport, target, card);
		var boundingBoxBottomCenter = {x: horizontalCenterCard.x, y: bottomCard.y, width: horizontalCenterCard.width, height: bottomCard.height};
		var rightCard = A3($author$project$PinMeTo$Ui$AdvancedTooltip$rightCardWidthAndX, viewport, target, card);
		var boundingBoxBottomRight = {x: rightCard.x, y: bottomCard.y, width: rightCard.width, height: bottomCard.height};
		var boundingBoxRightCenter = {x: rightCard.x, y: verticalCenterCard.y, width: rightCard.width, height: verticalCenterCard.height};
		var leftCard = A3($author$project$PinMeTo$Ui$AdvancedTooltip$leftCardWidthAndX, viewport, target, card);
		var boundingBoxBottomLeft = {x: leftCard.x, y: bottomCard.y, width: leftCard.width, height: bottomCard.height};
		var boundingBoxLeftCenter = {x: leftCard.x, y: verticalCenterCard.y, width: leftCard.width, height: verticalCenterCard.height};
		var topCard = A3($author$project$PinMeTo$Ui$AdvancedTooltip$topCardHeightAndY, viewport, target, card);
		var boundingBoxTopLeft = {x: leftCard.x, y: topCard.y, width: leftCard.width, height: topCard.height};
		var boundingBoxTopRight = {x: rightCard.x, y: topCard.y, width: rightCard.width, height: topCard.height};
		var boundingBoxTopCenter = {x: horizontalCenterCard.x, y: topCard.y, width: horizontalCenterCard.width, height: topCard.height};
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$TopRight, boundingBoxTopRight),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter, boundingBoxTopCenter),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$TopLeft, boundingBoxTopLeft),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$BottomRight, boundingBoxBottomRight),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$BottomCenter, boundingBoxBottomCenter),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$BottomLeft, boundingBoxBottomLeft),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$RightCenter, boundingBoxRightCenter),
				_Utils_Tuple2($author$project$PinMeTo$Ui$AdvancedTooltip$LeftCenter, boundingBoxLeftCenter)
			]);
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$fitToViewport = F4(
	function (preferredDirection, viewport, target, card) {
		var possibleTooltips = A3($author$project$PinMeTo$Ui$AdvancedTooltip$getAllPossibleTooltips, viewport, target, card);
		var _v0 = A3($author$project$PinMeTo$Ui$AdvancedTooltip$getBestFittingTooltip, preferredDirection, card, possibleTooltips);
		var tooltipDirection = _v0.a;
		var tooltipBoundingBox = _v0.b;
		return _Utils_Tuple2(tooltipDirection, tooltipBoundingBox);
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$cardDimensions = function (cardDom) {
	return {width: cardDom.element.width, height: cardDom.element.height};
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$targetFromTargetDom = F2(
	function (targetDom, padding) {
		return {x: (targetDom.element.x - padding) - targetDom.viewport.x, y: (targetDom.element.y - padding) - targetDom.viewport.y, width: targetDom.element.width + (padding * 2), height: targetDom.element.height + (padding * 2)};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$defaultTargetPadding = 8;
var $author$project$PinMeTo$Ui$AdvancedTooltip$viewportFromTargetDom = F2(
	function (targetDom, inset) {
		return {x: inset.left, y: inset.top, width: targetDom.viewport.width - (inset.left + inset.right), height: targetDom.viewport.height - (inset.top + inset.bottom), scrollY: targetDom.viewport.y};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$NoOp = {$: 'NoOp'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$FitToViewport = F2(
	function (a, b) {
		return {$: 'FitToViewport', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$getDropdownElementTask = F2(
	function (uid, preferredDirection) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map(
					function (_v0) {
						var a = _v0.a;
						var b = _v0.b;
						return {cardDom: b, targetDom: a};
					}),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$map(
						$author$project$PinMeTo$Ui$AdvancedTooltip$FitToViewport(preferredDirection)),
					$elm$core$Result$withDefault($author$project$PinMeTo$Ui$AdvancedTooltip$NoOp))),
			A2(
				$elm$core$Task$andThen,
				function (a) {
					return A2(
						$elm$core$Task$andThen,
						function (b) {
							return $elm$core$Task$succeed(
								_Utils_Tuple2(a, b));
						},
						$elm$browser$Browser$Dom$getElement(
							$author$project$PinMeTo$Ui$AdvancedTooltip$cardId(uid)));
				},
				$elm$browser$Browser$Dom$getElement(
					$author$project$PinMeTo$Ui$AdvancedTooltip$targetId(uid))));
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$updateWithCallbacks = F4(
	function (callbacks, tagger, msg, _v0) {
		var model = _v0.a;
		var onClose = function (uid) {
			var _v10 = callbacks.onClose;
			if (_v10.$ === 'Just') {
				var onClose_ = _v10.a;
				return A2(
					$elm$core$Task$perform,
					function (_v11) {
						return onClose_(uid);
					},
					$elm$core$Task$succeed(_Utils_Tuple0));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		};
		var onOpen = function (uid) {
			var _v8 = callbacks.onOpen;
			if (_v8.$ === 'Just') {
				var onOpen_ = _v8.a;
				return A2(
					$elm$core$Task$perform,
					function (_v9) {
						return onOpen_(uid);
					},
					$elm$core$Task$succeed(_Utils_Tuple0));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		};
		switch (msg.$) {
			case 'Open':
				var uid = msg.a;
				var preferredDirection = msg.b;
				var isStillHovered = _Utils_eq(
					model.isHovered,
					$elm$core$Maybe$Just(uid));
				var _v2 = (A2($elm$core$Set$member, uid, model.toBeOpened) && isStillHovered) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							card: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$AdvancedTooltip$Opening),
							toBeOpened: A2($elm$core$Set$remove, uid, model.toBeOpened),
							openTooltip: $elm$core$Maybe$Just(uid),
							currentPreferredDirection: $elm$core$Maybe$Just(preferredDirection)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								tagger,
								A2($author$project$PinMeTo$Ui$AdvancedTooltip$getDropdownElementTask, uid, preferredDirection)),
								onOpen(uid)
							]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(newModel),
					cmd);
			case 'Close':
				var uid = msg.a;
				var isNotHoveringAnything = _Utils_eq(model.isHovered, $elm$core$Maybe$Nothing);
				var _v3 = (A2($elm$core$Set$member, uid, model.toBeClosed) && isNotHoveringAnything) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							card: $elm$core$Maybe$Nothing,
							toBeClosed: A2($elm$core$Set$remove, uid, model.toBeClosed),
							openTooltip: $elm$core$Maybe$Nothing,
							currentPreferredDirection: $elm$core$Maybe$Nothing
						}),
					onClose(uid)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(newModel),
					cmd);
			case 'FitToViewport':
				var preferredDirection = msg.a;
				var cardDom = msg.b.cardDom;
				var targetDom = msg.b.targetDom;
				var viewport = A2($author$project$PinMeTo$Ui$AdvancedTooltip$viewportFromTargetDom, targetDom, $author$project$PinMeTo$Ui$AdvancedTooltip$defaultViewportPadding);
				var target = A2($author$project$PinMeTo$Ui$AdvancedTooltip$targetFromTargetDom, targetDom, $author$project$PinMeTo$Ui$AdvancedTooltip$defaultTargetPadding);
				var card = $author$project$PinMeTo$Ui$AdvancedTooltip$cardDimensions(cardDom);
				var _v4 = A4($author$project$PinMeTo$Ui$AdvancedTooltip$fitToViewport, preferredDirection, viewport, target, card);
				var cardDirection = _v4.a;
				var cardCoordinates = _v4.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(
						_Utils_update(
							model,
							{
								card: $elm$core$Maybe$Just(
									A2($author$project$PinMeTo$Ui$AdvancedTooltip$Card, cardDirection, cardCoordinates))
							})),
					$elm$core$Platform$Cmd$none);
			case 'MouseEnteredTarget':
				var delayInMillis = msg.a;
				var uid = msg.b;
				var direction = msg.c;
				var newToBeClosed = A2($elm$core$Set$remove, uid, model.toBeClosed);
				var anyCardIsOpen = !_Utils_eq(model.openTooltip, $elm$core$Maybe$Nothing);
				var cardIsOpen = _Utils_eq(
					model.openTooltip,
					$elm$core$Maybe$Just(uid));
				var _v5 = cardIsOpen ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							isHovered: $elm$core$Maybe$Just(uid),
							toBeClosed: newToBeClosed,
							toBeOpened: A2($elm$core$Set$remove, uid, model.toBeOpened)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							isHovered: $elm$core$Maybe$Just(uid),
							toBeClosed: newToBeClosed,
							toBeOpened: A2($elm$core$Set$insert, uid, model.toBeOpened)
						}),
					anyCardIsOpen ? A2(
						$author$project$PinMeTo$Common$Util$delay,
						0,
						tagger(
							A2($author$project$PinMeTo$Ui$AdvancedTooltip$Open, uid, direction))) : A2(
						$author$project$PinMeTo$Common$Util$delay,
						delayInMillis,
						tagger(
							A2($author$project$PinMeTo$Ui$AdvancedTooltip$Open, uid, direction))));
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(newModel),
					cmd);
			case 'MouseLeftTarget':
				var delayInMillis = msg.a;
				var uid = msg.b;
				var newToBeOpened = A2($elm$core$Set$remove, uid, model.toBeOpened);
				var cardIsOpen = _Utils_eq(
					model.openTooltip,
					$elm$core$Maybe$Just(uid));
				var _v6 = cardIsOpen ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							isHovered: $elm$core$Maybe$Nothing,
							toBeClosed: A2($elm$core$Set$insert, uid, model.toBeClosed),
							toBeOpened: newToBeOpened
						}),
					A2(
						$author$project$PinMeTo$Common$Util$delay,
						delayInMillis,
						tagger(
							$author$project$PinMeTo$Ui$AdvancedTooltip$Close(uid)))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							isHovered: $elm$core$Maybe$Nothing,
							toBeClosed: A2($elm$core$Set$insert, uid, model.toBeClosed),
							toBeOpened: newToBeOpened
						}),
					$elm$core$Platform$Cmd$none);
				var newModel = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(newModel),
					cmd);
			case 'Refresh':
				var _v7 = _Utils_Tuple2(model.openTooltip, model.currentPreferredDirection);
				if ((_v7.a.$ === 'Just') && (_v7.b.$ === 'Just')) {
					var uid = _v7.a.a;
					var preferredDirection = _v7.b.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$AdvancedTooltip$State(
							_Utils_update(
								model,
								{
									card: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$AdvancedTooltip$Opening)
								})),
						A2(
							$elm$core$Platform$Cmd$map,
							tagger,
							A2($author$project$PinMeTo$Ui$AdvancedTooltip$getDropdownElementTask, uid, preferredDirection)));
				} else {
					return _Utils_Tuple2(
						$author$project$PinMeTo$Ui$AdvancedTooltip$State(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'Scroll':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(
						_Utils_update(
							model,
							{toBeOpened: $elm$core$Set$empty, openTooltip: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$AdvancedTooltip$State(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Ui$AdvancedTooltip$update = F3(
	function (tagger, msg, _v0) {
		var model = _v0.a;
		return A4(
			$author$project$PinMeTo$Ui$AdvancedTooltip$updateWithCallbacks,
			{onOpen: $elm$core$Maybe$Nothing, onClose: $elm$core$Maybe$Nothing},
			tagger,
			msg,
			$author$project$PinMeTo$Ui$AdvancedTooltip$State(model));
	});
var $author$project$Location$LocationInfoPane$Model$MediaPage = {$: 'MediaPage'};
var $author$project$PinMeTo$Ports$pmtUiCopyTextToClipboard = _Platform_outgoingPort('pmtUiCopyTextToClipboard', $elm$json$Json$Encode$string);
var $author$project$PinMeTo$Common$Clipboard$writeText = function (text) {
	return $author$project$PinMeTo$Ports$pmtUiCopyTextToClipboard(text);
};
var $author$project$Location$LocationInfoPane$Model$InsightPage = function (a) {
	return {$: 'InsightPage', a: a};
};
var $author$project$Location$LocationInfoPane$Types$Navigation$navItemToId = function (navItem) {
	switch (navItem.$) {
		case 'GeneralData':
			return 'general-data';
		case 'Address':
			return 'address';
		case 'ContactInformation':
			return 'contact-information';
		case 'AttributesAndServices':
			return 'attributes-and-services';
		case 'Images':
			return 'images';
		case 'Categories':
			return 'categories';
		case 'OpenHours':
			return 'open-hours';
		default:
			return 'custom-fields';
	}
};
var $author$project$Location$LocationInfoPane$Model$ConflictsPage = {$: 'ConflictsPage'};
var $author$project$Location$LocationInfoPane$Types$Navigation$navItemFromId = function (id) {
	switch (id) {
		case 'general-data':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$GeneralData);
		case 'address':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$Address);
		case 'contact-information':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$ContactInformation);
		case 'attributes-and-services':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$AttributesAndServices);
		case 'images':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$Images);
		case 'categories':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$Categories);
		case 'open-hours':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$OpenHours);
		case 'custom-fields':
			return $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Types$Navigation$CustomFields);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Ui$AdvancedTooltip$Refresh = {$: 'Refresh'};
var $author$project$PinMeTo$Ui$AdvancedTooltip$refresh = $author$project$PinMeTo$Ui$AdvancedTooltip$Refresh;
var $author$project$Location$LocationInfoPane$App$refreshTooltip = function (model) {
	return A3($author$project$PinMeTo$Ui$AdvancedTooltip$update, $author$project$Location$LocationInfoPane$Model$TooltipMsg, $author$project$PinMeTo$Ui$AdvancedTooltip$refresh, model.tooltipState);
};
var $author$project$Location$LocationInfoPane$Model$ClearCopiedValue = function (a) {
	return {$: 'ClearCopiedValue', a: a};
};
var $author$project$Location$LocationInfoPane$Model$NetworkStatusPage = {$: 'NetworkStatusPage'};
var $author$project$Location$LocationInfoPane$App$copiedConfirmationMs = 1500;
var $author$project$Location$LocationInfoPane$Ports$out_Location_LocationInfoPane_Main_SendScrollToSection = _Platform_outgoingPort('out_Location_LocationInfoPane_Main_SendScrollToSection', $elm$json$Json$Encode$string);
var $author$project$Location$LocationInfoPane$App$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 'OnDataCompletenessResult':
				if (msg.a.$ === 'Err') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dataCompleteness: $author$project$RemoteData$Error('failed to load data completeness')
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var r = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dataCompleteness: $author$project$RemoteData$Loaded(r)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnLifeTimeRating':
				if (msg.a.$ === 'Ok') {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lifetimeRatings: $author$project$RemoteData$Loaded(data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNavigationClicked':
				var navItem = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{currentNavItem: navItem}),
					$author$project$Location$LocationInfoPane$Ports$out_Location_LocationInfoPane_Main_SendScrollToSection(
						$author$project$Location$LocationInfoPane$Types$Navigation$navItemToId(navItem)));
			case 'OnScrolledToSection':
				var sectionId = msg.a;
				var _v2 = $author$project$Location$LocationInfoPane$Types$Navigation$navItemFromId(sectionId);
				if (_v2.$ === 'Just') {
					var navItem = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{currentNavItem: navItem}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'CopyToClipboard':
				var value = msg.a;
				var _v3 = $author$project$Location$LocationInfoPane$App$refreshTooltip(model);
				var tooltipState = _v3.a;
				var tooltipCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							copiedValue: $elm$core$Maybe$Just(value),
							tooltipState: tooltipState
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$PinMeTo$Common$Clipboard$writeText(value),
								A2(
								$elm$core$Task$perform,
								function (_v4) {
									return $author$project$Location$LocationInfoPane$Model$ClearCopiedValue(value);
								},
								$elm$core$Process$sleep($author$project$Location$LocationInfoPane$App$copiedConfirmationMs)),
								tooltipCmd
							])));
			case 'ClearCopiedValue':
				var value = msg.a;
				if (_Utils_eq(
					model.copiedValue,
					$elm$core$Maybe$Just(value))) {
					var _v5 = $author$project$Location$LocationInfoPane$App$refreshTooltip(model);
					var tooltipState = _v5.a;
					var tooltipCmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{copiedValue: $elm$core$Maybe$Nothing, tooltipState: tooltipState}),
						tooltipCmd);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'TooltipMsg':
				var tooltipMsg = msg.a;
				var _v6 = A3($author$project$PinMeTo$Ui$AdvancedTooltip$update, $author$project$Location$LocationInfoPane$Model$TooltipMsg, tooltipMsg, model.tooltipState);
				var tooltipState = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tooltipState: tooltipState}),
					cmd);
			case 'OpenMapPopup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapPopupOpen: true}),
					$elm$core$Platform$Cmd$none);
			case 'CloseMapPopup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mapPopupOpen: false}),
					$elm$core$Platform$Cmd$none);
			default:
				var path = msg.a;
				var matchesPage = A2($author$project$Util$flip, $elm$core$String$contains, path);
				var page = matchesPage('/insights') ? (matchesPage('/overview') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsOverview)) : (matchesPage('rating') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsRating)) : (matchesPage('keywords') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsKeywords)) : (matchesPage('apple') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsApple)) : (matchesPage('google') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsGoogle)) : (matchesPage('facebook') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsFacebook)) : (matchesPage('bing') ? $elm$core$Maybe$Just(
					$author$project$Location$LocationInfoPane$Model$InsightPage($author$project$Location$LocationInfoPane$Types$Navigation$InsightsBing)) : $elm$core$Maybe$Nothing))))))) : (matchesPage('/conflicts') ? $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Model$ConflictsPage) : (matchesPage('/media') ? $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Model$MediaPage) : (matchesPage('/details') ? $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Model$DetailsPage) : (matchesPage('/network-status') ? $elm$core$Maybe$Just($author$project$Location$LocationInfoPane$Model$NetworkStatusPage) : $elm$core$Maybe$Nothing))));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{page: page}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$LocationInfoPane$Model$Flags = F5(
	function (location, siteNetworks, today, siteName, requestUrl) {
		return {today: today, location: location, siteName: siteName, requestUrl: requestUrl, siteNetworks: siteNetworks};
	});
var $author$project$Location$LocationInfoPane$Decoders$dateDecoder = A2(
	$elm$json$Json$Decode$map,
	$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder);
var $author$project$Location$LocationInfoPane$Model$Location = function (storeId) {
	return function (name) {
		return function (shortDescription) {
			return function (longDescription) {
				return function (locationType) {
					return function (isActive) {
						return function (permanentlyClosed) {
							return function (temporarilyClosedUntil) {
								return function (contact) {
									return function (address) {
										return function (coordinates) {
											return function (id) {
												return function (networkCategories) {
													return function (siteCategories) {
														return function (networkAttributes) {
															return function (actionLinks) {
																return function (brandMedia) {
																	return function (openHours) {
																		return function (apple) {
																			return function (facebook) {
																				return function (google) {
																					return function (bing) {
																						return function (ptv) {
																							return {id: id, ptv: ptv, bing: bing, name: name, apple: apple, google: google, address: address, contact: contact, storeId: storeId, facebook: facebook, isActive: isActive, openHours: openHours, brandMedia: brandMedia, actionLinks: actionLinks, coordinates: coordinates, locationType: locationType, siteCategories: siteCategories, longDescription: longDescription, shortDescription: shortDescription, networkAttributes: networkAttributes, networkCategories: networkCategories, permanentlyClosed: permanentlyClosed, temporarilyClosedUntil: temporarilyClosedUntil};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Locations$List$Model$LocationContact = F3(
	function (email, phone, homepage) {
		return {email: email, phone: phone, homepage: homepage};
	});
var $author$project$Locations$List$Model$contactDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'homepage',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'phone',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Locations$List$Model$LocationContact))));
var $author$project$Location$LocationInfoPane$Model$NetworkData = F4(
	function (idSetType, link, coverImageUrl, profileImageUrl) {
		return {link: link, idSetType: idSetType, coverImageUrl: coverImageUrl, profileImageUrl: profileImageUrl};
	});
var $author$project$Location$LocationInfoPane$Decoders$idSetTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'approved':
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$Approved);
			case 'pendingClaim':
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$UserAction);
			case 'userAction':
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$UserAction);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Data$Network$Disconnected);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Location$LocationInfoPane$Decoders$bingDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['data', 'profilePhoto']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['data', 'coverPhoto']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['businessStatus', 'PublishLink']),
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'idSetType',
				$author$project$Location$LocationInfoPane$Decoders$idSetTypeDecoder,
				$author$project$Data$Network$Disconnected,
				$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$NetworkData)))));
var $author$project$Location$LocationInfoPane$Decoders$appleDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['data', 'profilePhoto']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['data', 'coverPhoto']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['data', 'placeCardUrl']),
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'idSetType',
				$author$project$Location$LocationInfoPane$Decoders$idSetTypeDecoder,
				$author$project$Data$Network$Disconnected,
				$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$NetworkData)))));
var $author$project$Location$LocationInfoPane$Decoders$networkDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['data', 'profilePhoto']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['data', 'coverPhoto']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['data', 'link']),
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'idSetType',
				$author$project$Location$LocationInfoPane$Decoders$idSetTypeDecoder,
				$author$project$Data$Network$Disconnected,
				$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$NetworkData)))));
var $author$project$Location$LocationInfoPane$Model$BrandMedia = F2(
	function (coverImageUrl, profileImageUrl) {
		return {coverImageUrl: coverImageUrl, profileImageUrl: profileImageUrl};
	});
var $author$project$Location$LocationInfoPane$Decoders$brandMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['profileImage', 'url']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['coverImage', 'url']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$BrandMedia)));
var $author$project$Location$LocationInfoPane$Model$LocationBrandMedia = F2(
	function (google, facebook) {
		return {google: google, facebook: facebook};
	});
var $author$project$Location$LocationInfoPane$Decoders$locationBrandMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'facebook',
	$elm$json$Json$Decode$maybe($author$project$Location$LocationInfoPane$Decoders$brandMediaDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'google',
		$elm$json$Json$Decode$maybe($author$project$Location$LocationInfoPane$Decoders$brandMediaDecoder),
		$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$LocationBrandMedia)));
var $author$project$Location$LocationInfoPane$Decoders$locationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ptv',
	$author$project$Location$LocationInfoPane$Decoders$networkDataDecoder,
	{link: '', idSetType: $author$project$Data$Network$Disconnected, coverImageUrl: $elm$core$Maybe$Nothing, profileImageUrl: $elm$core$Maybe$Nothing},
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'bing',
		$author$project$Location$LocationInfoPane$Decoders$bingDataDecoder,
		{link: '', idSetType: $author$project$Data$Network$Disconnected, coverImageUrl: $elm$core$Maybe$Nothing, profileImageUrl: $elm$core$Maybe$Nothing},
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'google',
			$author$project$Location$LocationInfoPane$Decoders$networkDataDecoder,
			{link: '', idSetType: $author$project$Data$Network$Disconnected, coverImageUrl: $elm$core$Maybe$Nothing, profileImageUrl: $elm$core$Maybe$Nothing},
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'facebook',
				$author$project$Location$LocationInfoPane$Decoders$networkDataDecoder,
				{link: '', idSetType: $author$project$Data$Network$Disconnected, coverImageUrl: $elm$core$Maybe$Nothing, profileImageUrl: $elm$core$Maybe$Nothing},
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'apple',
					$author$project$Location$LocationInfoPane$Decoders$appleDataDecoder,
					{link: '', idSetType: $author$project$Data$Network$Disconnected, coverImageUrl: $elm$core$Maybe$Nothing, profileImageUrl: $elm$core$Maybe$Nothing},
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Data$Location$OpenHours$openHoursDecoder,
								A2(
									$elm$json$Json$Decode$field,
									'isAlwaysOpen',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'brandMedia',
							$elm$json$Json$Decode$maybe($author$project$Location$LocationInfoPane$Decoders$locationBrandMediaDecoder),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'actionLinks',
								$author$project$Data$Location$ActionLinks$listDecoder,
								_List_Nil,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'networkAttributes',
									$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkAttributes$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'siteCategories',
										$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'networkCategories',
											$author$project$Data$Location$NetworkCategories$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'coordinates',
													$author$project$Data$Coordinates$coordinatesDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'address',
														$author$project$Data$Address$addressDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'contact',
															$author$project$Locations$List$Model$contactDecoder,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'temporarilyClosedUntil',
																$elm$json$Json$Decode$string,
																'',
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'permanentlyClosed',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'isActive',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'type',
																			$author$project$Data$Location$locationTypeDecoder,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'longDescription',
																				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'shortDescription',
																					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'name',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'storeId',
																							$elm$json$Json$Decode$string,
																							$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$Location))))))))))))))))))))))));
var $author$project$Location$LocationInfoPane$Types$NetworkStatus$NetworkStatus = F9(
	function (google, facebook, apple, bing, factual, overture, here, tomtom, ptv) {
		return {ptv: ptv, bing: bing, here: here, apple: apple, google: google, tomtom: tomtom, factual: factual, facebook: facebook, overture: overture};
	});
var $author$project$Location$LocationInfoPane$Decoders$siteNetworkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ptv',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tomtom',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'here',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'overture',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'factual',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'bing',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'apple',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'facebook',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'google',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Types$NetworkStatus$NetworkStatus))))))))));
var $author$project$Location$LocationInfoPane$Decoders$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requestUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siteName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'today',
			$author$project$Location$LocationInfoPane$Decoders$dateDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteNetworks',
				$author$project$Location$LocationInfoPane$Decoders$siteNetworkDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'location',
					$author$project$Location$LocationInfoPane$Decoders$locationDecoder,
					$elm$json$Json$Decode$succeed($author$project$Location$LocationInfoPane$Model$Flags))))));
var $author$project$Location$LocationInfoPane$Model$OnScrolledToSection = function (a) {
	return {$: 'OnScrolledToSection', a: a};
};
var $author$project$Location$LocationInfoPane$Model$HandleLocationChanged = function (a) {
	return {$: 'HandleLocationChanged', a: a};
};
var $author$project$Location$LocationInfoPane$Ports$in_Location_LocationInfoPane_Main_OnLocationChanged = _Platform_incomingPort('in_Location_LocationInfoPane_Main_OnLocationChanged', $elm$json$Json$Decode$string);
var $author$project$Location$LocationInfoPane$Ports$in_Location_LocationInfoPane_Main_OnScrolledToSection = _Platform_incomingPort('in_Location_LocationInfoPane_Main_OnScrolledToSection', $elm$json$Json$Decode$string);
var $author$project$Location$LocationInfoPane$App$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Location$LocationInfoPane$Ports$in_Location_LocationInfoPane_Main_OnLocationChanged($author$project$Location$LocationInfoPane$Model$HandleLocationChanged),
				$author$project$Location$LocationInfoPane$Ports$in_Location_LocationInfoPane_Main_OnScrolledToSection($author$project$Location$LocationInfoPane$Model$OnScrolledToSection)
			]));
};
var $author$project$Location$LocationInfoPane$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Location$LocationInfoPane$Main$init, view: $author$project$Location$LocationInfoPane$App$view, update: $author$project$Location$LocationInfoPane$App$update, flagsDecoder: $author$project$Location$LocationInfoPane$Decoders$flagsDecoder, subscriptions: $author$project$Location$LocationInfoPane$App$subscriptions});
var $author$project$Location$Edit$OpeningDate$Main$Flags = F4(
	function (openingDate, translations, language, locale) {
		return {locale: locale, language: language, openingDate: openingDate, translations: translations};
	});
var $author$project$Location$Edit$OpeningDate$Main$localeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(
			$author$project$PinMeTo$Ui$I18n$Locale$fromString(str));
	},
	$elm$json$Json$Decode$string);
var $author$project$Location$Edit$OpeningDate$Main$languageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $author$project$PinMeTo$Ui$I18n$Language$fromString(str);
		if (_v0.$ === 'Just') {
			var language = _v0.a;
			return $elm$json$Json$Decode$succeed(language);
		} else {
			return $elm$json$Json$Decode$fail('Invalid Language');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Location$Edit$OpeningDate$Main$openingDateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(str);
		if (_v0.$ === 'Ok') {
			var date = _v0.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Location$Edit$OpeningDate$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'locale',
	$author$project$Location$Edit$OpeningDate$Main$localeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$Location$Edit$OpeningDate$Main$languageDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'translations',
			$author$project$Common$Language$translationsDecoder,
			$author$project$Common$Language$initialTranslationsFallback,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'openingDate',
				$elm$json$Json$Decode$maybe($author$project$Location$Edit$OpeningDate$Main$openingDateDecoder),
				$elm$json$Json$Decode$succeed($author$project$Location$Edit$OpeningDate$Main$Flags)))));
var $author$project$Location$Edit$OpeningDate$Main$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Location$Edit$OpeningDate$Main$flagsDecoder, flagsValue);
};
var $author$project$Location$Edit$OpeningDate$Main$FailedToDecodeFlags = {$: 'FailedToDecodeFlags'};
var $author$project$Location$Edit$OpeningDate$Main$init = function (flagsValue) {
	var _v0 = $author$project$Location$Edit$OpeningDate$Main$decodeFlags(flagsValue);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{locale: decoded.locale, language: decoded.language, initialDate: decoded.openingDate, openingDate: decoded.openingDate, translations: decoded.translations, showErrorSaving: false, showSavingProgress: false}),
			$elm$core$Platform$Cmd$none);
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err($author$project$Location$Edit$OpeningDate$Main$FailedToDecodeFlags),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Location.Edit.OpeningDate.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Location$Edit$OpeningDate$Main$Save = {$: 'Save'};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$Location$Edit$OpeningDate$Main$Cancel = {$: 'Cancel'};
var $author$project$Location$Edit$OpeningDate$Main$ClearDate = {$: 'ClearDate'};
var $author$project$Location$Edit$OpeningDate$Main$DatePicked = function (a) {
	return {$: 'DatePicked', a: a};
};
var $author$project$Translations$Listings$LocationDetail$firstOpened = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.first_opened');
};
var $author$project$Translations$General$updateError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.update_error');
};
var $author$project$Translations$Listings$LocationDetail$customersNotice = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.customers_notice');
};
var $author$project$Translations$Listings$LocationDetail$updateOpeningDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.update_opening_date');
};
var $author$project$Location$Edit$OpeningDate$Main$view = function (state) {
	if (state.$ === 'Ok') {
		var model = state.a;
		var clearBtnDisabled = function () {
			var _v6 = model.openingDate;
			if (_v6.$ === 'Just') {
				return false;
			} else {
				return true;
			}
		}();
		var isSameDate = function () {
			var _v1 = _Utils_Tuple2(model.openingDate, model.initialDate);
			if (_v1.a.$ === 'Just') {
				if (_v1.b.$ === 'Just') {
					var openingDate = _v1.a.a;
					var initialDate = _v1.b.a;
					return _Utils_eq(openingDate, initialDate);
				} else {
					var _v2 = _v1.b;
					return false;
				}
			} else {
				if (_v1.b.$ === 'Just') {
					var _v3 = _v1.a;
					return false;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return true;
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title-bar')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title-bar__icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-pen-to-square')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title-bar__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$LocationDetail$updateOpeningDate(model.translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form card')
						]),
					_List_fromArray(
						[
							(!model.showSavingProgress) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card__content')
								]),
							_List_fromArray(
								[
									model.showErrorSaving ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-bar status-bar--danger')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$General$updateError(model.translations))
												]))
										])) : A2($elm$html$Html$div, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$form,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$name('place_form')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-opening-date pmt-opening-date__container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$General$locationOpeningDate(model.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('first-instructions')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$LocationDetail$firstOpened(model.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('second-instructions')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$LocationDetail$customersNotice(model.translations))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('date-input'),
															$elm$html$Html$Attributes$tabindex(0)
														]),
													_List_fromArray(
														[
															$author$project$PinMeTo$Ui$DatePicker$render(
															$author$project$PinMeTo$Ui$DatePicker$datePicker(
																{
																	value: model.openingDate,
																	locale: model.locale,
																	language: model.language,
																	onChange: $author$project$Location$Edit$OpeningDate$Main$DatePicked,
																	selectDateLabel: $author$project$Translations$General$selectDate(model.translations)
																})),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-btn--default pmt-btn clear-date'),
																	$elm$html$Html$Attributes$type_('button'),
																	$elm$html$Html$Attributes$disabled(clearBtnDisabled),
																	$elm$html$Html$Events$onClick($author$project$Location$Edit$OpeningDate$Main$ClearDate)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$General$clear(model.translations))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('util__inset')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-btn-group pmt-btn-group--basis-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-btn--default pmt-btn--brand-2 pmt-btn'),
																	$elm$html$Html$Attributes$type_('button'),
																	$elm$html$Html$Events$onClick($author$project$Location$Edit$OpeningDate$Main$Cancel)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$General$cancel(model.translations))
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-btn--default pmt-btn'),
																	$elm$html$Html$Attributes$type_('button'),
																	$elm$html$Html$Attributes$disabled(isSameDate),
																	$elm$html$Html$Events$onClick($author$project$Location$Edit$OpeningDate$Main$Save)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$General$update(model.translations))
																]))
														]))
												]))
										]))
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card__content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-bar status-bar--status')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa fa-gear fa-spin fa-fw')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$General$saving(model.translations))
												]))
										]))
								]))
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title-bar')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title-bar__icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-pen-to-square')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title-bar__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update Opening Date')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card__content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('status-bar__message')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('An error occurred')
												]))
										]))
								]))
						]))
				]));
	}
};
var $author$project$Location$Edit$OpeningDate$Main$decodeBool = function (bool) {
	return A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$bool, bool);
};
var $author$project$Location$Edit$OpeningDate$Main$initialDateEncoder = function (date) {
	if (date.$ === 'Just') {
		var d = date.a;
		return $elm$json$Json$Encode$string(
			$justinmimbs$date$Date$toIsoString(d));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Location$Edit$OpeningDate$Main$openingDateEncoder = function (date) {
	return $elm$json$Json$Encode$string(
		$justinmimbs$date$Date$toIsoString(date));
};
var $author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Save = _Platform_outgoingPort('out_Location_Edit_OpeningDate_Main_Save', $elm$core$Basics$identity);
var $author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Cancel = _Platform_outgoingPort('out_Location_Edit_OpeningDate_Main_Cancel', $elm$core$Basics$identity);
var $author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Date_Selected = _Platform_outgoingPort('out_Location_Edit_OpeningDate_Main_Date_Selected', $elm$core$Basics$identity);
var $author$project$Location$Edit$OpeningDate$Main$update = F2(
	function (msg, state) {
		if (state.$ === 'Ok') {
			var model = state.a;
			switch (msg.$) {
				case 'DatePicked':
					var date = msg.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									openingDate: $elm$core$Maybe$Just(date)
								})),
						$author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Date_Selected(
							$author$project$Location$Edit$OpeningDate$Main$openingDateEncoder(date)));
				case 'HandleFlags':
					var flagsValue = msg.a;
					return $author$project$Location$Edit$OpeningDate$Main$init(flagsValue);
				case 'Cancel':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{openingDate: model.initialDate})),
						$author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Cancel(
							$author$project$Location$Edit$OpeningDate$Main$initialDateEncoder(model.initialDate)));
				case 'ClearDate':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{openingDate: $elm$core$Maybe$Nothing})),
						$author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Date_Selected(
							$elm$json$Json$Encode$string('')));
				case 'Save':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{initialDate: model.openingDate})),
						$author$project$Location$Edit$OpeningDate$Main$out_Location_Edit_OpeningDate_Main_Save(
							$elm$json$Json$Encode$bool(true)));
				case 'ShowSavingProgress':
					var jsonBool = msg.a;
					var _v2 = $author$project$Location$Edit$OpeningDate$Main$decodeBool(jsonBool);
					if (_v2.$ === 'Ok') {
						var bool = _v2.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{showSavingProgress: bool})),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = _v2.a;
						return _Utils_Tuple2(
							$elm$core$Result$Err($author$project$Location$Edit$OpeningDate$Main$FailedToDecodeFlags),
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(err),
									context: 'Location.Edit.OpeningDate.Main',
									message: 'Failed to decode show saving progress bool'
								}));
					}
				default:
					var jsonBool = msg.a;
					var _v3 = $author$project$Location$Edit$OpeningDate$Main$decodeBool(jsonBool);
					if (_v3.$ === 'Ok') {
						var bool = _v3.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{showErrorSaving: bool})),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = _v3.a;
						return _Utils_Tuple2(
							$elm$core$Result$Err($author$project$Location$Edit$OpeningDate$Main$FailedToDecodeFlags),
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(err),
									context: 'Location.Edit.OpeningDate.Main',
									message: 'Failed to decode show error saving bool'
								}));
					}
			}
		} else {
			return _Utils_Tuple2(
				$elm$core$Result$Err($author$project$Location$Edit$OpeningDate$Main$FailedToDecodeFlags),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Edit$OpeningDate$Main$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Location$Edit$OpeningDate$Main$ShowErrorSaving = function (a) {
	return {$: 'ShowErrorSaving', a: a};
};
var $author$project$Location$Edit$OpeningDate$Main$ShowSavingProgress = function (a) {
	return {$: 'ShowSavingProgress', a: a};
};
var $author$project$Location$Edit$OpeningDate$Main$passArgs_Location_Edit_OpeningDate_Main = _Platform_incomingPort('passArgs_Location_Edit_OpeningDate_Main', $elm$json$Json$Decode$value);
var $author$project$Location$Edit$OpeningDate$Main$in_Location_Edit_OpeningDate_Main_Show_Error_Saving = _Platform_incomingPort('in_Location_Edit_OpeningDate_Main_Show_Error_Saving', $elm$json$Json$Decode$value);
var $author$project$Location$Edit$OpeningDate$Main$in_Location_Edit_OpeningDate_Main_Show_Saving_Progress = _Platform_incomingPort('in_Location_Edit_OpeningDate_Main_Show_Saving_Progress', $elm$json$Json$Decode$value);
var $author$project$Location$Edit$OpeningDate$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Location$Edit$OpeningDate$Main$passArgs_Location_Edit_OpeningDate_Main($author$project$Location$Edit$OpeningDate$Main$HandleFlags),
				$author$project$Location$Edit$OpeningDate$Main$in_Location_Edit_OpeningDate_Main_Show_Saving_Progress($author$project$Location$Edit$OpeningDate$Main$ShowSavingProgress),
				$author$project$Location$Edit$OpeningDate$Main$in_Location_Edit_OpeningDate_Main_Show_Error_Saving($author$project$Location$Edit$OpeningDate$Main$ShowErrorSaving)
			]));
};
var $author$project$Location$Edit$OpeningDate$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Location$Edit$OpeningDate$Main$init, view: $author$project$Location$Edit$OpeningDate$Main$view, update: $author$project$Location$Edit$OpeningDate$Main$update, subscriptions: $author$project$Location$Edit$OpeningDate$Main$subscriptions});
var $author$project$VerifyLocations$Resolver$Model$Deactive = {$: 'Deactive'};
var $author$project$VerifyLocations$Resolver$Model$init = {editor: $elm$core$Maybe$Nothing, editing: $elm$core$Maybe$Nothing, selected: $elm$core$Dict$empty, siteName: '', locations: $author$project$RemoteData$Loading, userRoles: _List_Nil, geoLookups: $elm$core$Dict$empty, allVerified: false, displayName: '', pressedKeys: _List_Nil, searchError: $elm$core$Maybe$Nothing, suggestions: _List_Nil, searchString: '', sessionToken: $elm$core$Maybe$Nothing, tooltipState: $author$project$PinMeTo$Ui$AdvancedTooltip$init, translations: $author$project$Common$Language$initialTranslationsFallback, activeServiceArea: $author$project$VerifyLocations$Resolver$Model$Deactive, verifyLocationErrors: $elm$core$Dict$empty};
var $author$project$VerifyLocations$Resolver$Data$Source$Geo = {$: 'Geo'};
var $author$project$VerifyLocations$Resolver$Update$NoOp = {$: 'NoOp'};
var $author$project$VerifyLocations$Resolver$Commands$None = {$: 'None'};
var $author$project$VerifyLocations$Resolver$Data$Source$Master = {$: 'Master'};
var $author$project$VerifyLocations$Resolver$Update$FocusOn = function (a) {
	return {$: 'FocusOn', a: a};
};
var $elm$core$Result$toMaybe = function (result) {
	if (result.$ === 'Ok') {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$VerifyLocations$Resolver$Commands$AddedArea = {$: 'AddedArea'};
var $author$project$VerifyLocations$Resolver$Model$addAreaId = 'added-area';
var $author$project$VerifyLocations$Resolver$Update$TooltipMsg = function (a) {
	return {$: 'TooltipMsg', a: a};
};
var $author$project$VerifyLocations$Resolver$Model$ActiveAdded = {$: 'ActiveAdded'};
var $author$project$VerifyLocations$Resolver$Model$Flags = F4(
	function (siteName, displayName, translations, roles) {
		return {roles: roles, siteName: siteName, displayName: displayName, translations: translations};
	});
var $author$project$VerifyLocations$Resolver$Update$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'userRoles',
	$elm$json$Json$Decode$list($author$project$Data$User$roleDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'displayName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteName',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Model$Flags)))));
var $author$project$VerifyLocations$Resolver$Update$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$VerifyLocations$Resolver$Update$flagsDecoder, flagsValue);
};
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Common$PaginationSimple$removeItems = F2(
	function (idsToRemove, pagination) {
		var preservedKey = $author$project$Common$PaginationSimple$currentKey(pagination);
		var newItems = A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v2) {
					return !A2($elm$core$Set$member, k, idsToRemove);
				}),
			pagination.items);
		var newKeys = $elm$core$Array$fromList(
			A2(
				$elm$core$List$filter,
				function (k) {
					return !A2($elm$core$Set$member, k, idsToRemove);
				},
				$elm$core$Array$toList(pagination.keys)));
		var lastIndex = A2(
			$elm$core$Basics$max,
			0,
			$elm$core$Array$length(newKeys) - 1);
		var newCurrentPage = function () {
			if (preservedKey.$ === 'Just') {
				var id = preservedKey.a;
				return A2(
					$elm$core$Maybe$withDefault,
					A2($elm$core$Basics$min, pagination.currentPage, lastIndex),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v1) {
									var k = _v1.b;
									return _Utils_eq(k, id);
								},
								$elm$core$Array$toIndexedList(newKeys)))));
			} else {
				return A2($elm$core$Basics$min, pagination.currentPage, lastIndex);
			}
		}();
		return {keys: newKeys, items: newItems, value: newCurrentPage + 1, currentPage: newCurrentPage};
	});
var $author$project$VerifyLocations$Resolver$Commands$ExistingArea = function (a) {
	return {$: 'ExistingArea', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$OnPageChange = function (a) {
	return {$: 'OnPageChange', a: a};
};
var $author$project$VerifyLocations$Resolver$Commands$ServiceAreas = function (a) {
	return {$: 'ServiceAreas', a: a};
};
var $author$project$VerifyLocations$Resolver$Commands$coordinatesEncoder = function (coordinate) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lat',
				$elm$json$Json$Encode$float(coordinate.lat)),
				_Utils_Tuple2(
				'lon',
				$elm$json$Json$Encode$float(coordinate.lon))
			]));
};
var $author$project$VerifyLocations$Resolver$Commands$encoder = F3(
	function (stringAddress, address, coordinates) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$author$project$Data$Address$addressEncoder(address)),
					_Utils_Tuple2(
					'stringAddress',
					$elm$json$Json$Encode$string(stringAddress)),
					_Utils_Tuple2(
					'coordinates',
					$author$project$VerifyLocations$Resolver$Commands$coordinatesEncoder(coordinates))
				]));
	});
var $author$project$VerifyLocations$Resolver$Commands$GeoLookup = F3(
	function (coordinates, address, conflicts) {
		return {address: address, conflicts: conflicts, coordinates: coordinates};
	});
var $author$project$VerifyLocations$Resolver$Data$Conflicts$Conflicts = F2(
	function (address, location) {
		return {address: address, location: location};
	});
var $author$project$Common$AddressEditor$AddressConflicts = F7(
	function (street, zip, city, state, country, province, district) {
		return {zip: zip, city: city, state: state, street: street, country: country, district: district, province: province};
	});
var $author$project$VerifyLocations$Resolver$Data$Conflicts$addressDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'district',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'province',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'country',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'city',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'zip',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'street',
							$elm$json$Json$Decode$bool,
							$elm$json$Json$Decode$succeed($author$project$Common$AddressEditor$AddressConflicts))))))));
var $author$project$VerifyLocations$Resolver$Data$Conflicts$conflictsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$VerifyLocations$Resolver$Data$Conflicts$addressDecoder,
		$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Data$Conflicts$Conflicts)));
var $author$project$VerifyLocations$Resolver$Commands$geoLookupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'conflicts',
	$author$project$VerifyLocations$Resolver$Data$Conflicts$conflictsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$elm$core$Result$Err,
					A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)),
					A2(
					$elm$json$Json$Decode$map,
					$elm$core$Result$Ok,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Address$addressDecoder))
				])),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'coordinates',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Result$Err,
						A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)),
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Result$Ok,
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Coordinates$coordinatesDecoder))
					])),
			$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Commands$GeoLookup))));
var $author$project$VerifyLocations$Resolver$Commands$getGeoLookup = F3(
	function (location, siteName, msg) {
		var stringAddress = location.address.street + (',' + (location.address.zip + (',' + (location.address.city + (',' + location.address.country)))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$VerifyLocations$Resolver$Commands$geoLookupDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A3($author$project$VerifyLocations$Resolver$Commands$encoder, stringAddress, location.address, location.coordinates),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/google/geo/lookup'))))));
	});
var $author$project$VerifyLocations$Resolver$Update$GenerateSeeds = F2(
	function (a, b) {
		return {$: 'GenerateSeeds', a: a, b: b};
	});
var $author$project$Common$ServiceAreaSelector$Update$generateToken = F2(
	function (sessionToken, seeds) {
		var _v0 = function () {
			if ((((seeds.b && seeds.b.b) && seeds.b.b.b) && seeds.b.b.b.b) && (!seeds.b.b.b.b.b)) {
				var a = seeds.a;
				var _v4 = seeds.b;
				var b = _v4.a;
				var _v5 = _v4.b;
				var c = _v5.a;
				var _v6 = _v5.b;
				var d = _v6.a;
				return _Utils_Tuple2(
					_Utils_Tuple2(a, b),
					_Utils_Tuple2(c, d));
			} else {
				return _Utils_Tuple2(
					_Utils_Tuple2(890453, 789045),
					_Utils_Tuple2(23678, 89657));
			}
		}();
		var _v1 = _v0.a;
		var s1 = _v1.a;
		var s2 = _v1.b;
		var _v2 = _v0.b;
		var s3 = _v2.a;
		var s4 = _v2.b;
		var _v7 = _Utils_Tuple2(
			$elm$random$Random$initialSeed(s3),
			$elm$random$Random$initialSeed(s4));
		var seed3 = _v7.a;
		var seed4 = _v7.b;
		var _v8 = _Utils_Tuple2(
			$elm$random$Random$initialSeed(s1),
			$elm$random$Random$initialSeed(s2));
		var seed1 = _v8.a;
		var seed2 = _v8.b;
		var generateUUIDv4 = $TSFoster$elm_uuid$UUID$toString(
			$TSFoster$elm_uuid$UUID$step(
				A4($TSFoster$elm_uuid$UUID$Seeds, seed1, seed2, seed3, seed4)).a);
		var newSessionToken = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, generateUUIDv4, $elm$core$Basics$identity, sessionToken);
		return newSessionToken;
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$VerifyLocations$Resolver$Model$ActiveExisting = function (a) {
	return {$: 'ActiveExisting', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$SetAllVerified = function (a) {
	return {$: 'SetAllVerified', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$ActivateServiceArea = function (a) {
	return {$: 'ActivateServiceArea', a: a};
};
var $author$project$VerifyLocations$Resolver$Commands$mapVerificationToBool = F2(
	function (mapper, ver) {
		if (ver.$ === 'AddedArea') {
			return false;
		} else {
			var sa = ver.a;
			return mapper(sa);
		}
	});
var $author$project$VerifyLocations$Resolver$Update$DeactivateServiceAreas = {$: 'DeactivateServiceAreas'};
var $author$project$VerifyLocations$Resolver$Update$getActivateMsg = function (model) {
	var serviceAreas = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		function ($) {
			return $.serviceAreas;
		},
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Common$PaginationSimple$currentItem,
			$author$project$RemoteData$currentData(model.locations)));
	var nextActiveAreaCommand = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$author$project$VerifyLocations$Resolver$Update$DeactivateServiceAreas,
		$author$project$VerifyLocations$Resolver$Update$ActivateServiceArea,
		A2(
			$elm_community$list_extra$List$Extra$find,
			$author$project$VerifyLocations$Resolver$Commands$mapVerificationToBool(
				function ($) {
					return $.verified;
				}),
			A2(
				$elm$core$List$filter,
				function (area) {
					var _v0 = _Utils_Tuple2(area, model.activeServiceArea);
					if ((_v0.a.$ === 'ExistingArea') && (_v0.b.$ === 'ActiveExisting')) {
						var a = _v0.a.a;
						var sa = _v0.b.a;
						return !_Utils_eq(a.serviceArea.placeId, sa.placeId);
					} else {
						return false;
					}
				},
				serviceAreas)));
	return _Utils_Tuple2(
		nextActiveAreaCommand,
		$elm$core$List$length(serviceAreas));
};
var $author$project$VerifyLocations$Resolver$Commands$setNeedsReview = F4(
	function (siteName, locationId, needsReview, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'needsReview', $elm$json$Json$Decode$bool),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(locationId)),
								_Utils_Tuple2(
								'needsReview',
								$elm$json$Json$Encode$bool(needsReview))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/places/verify/needs-review'))))));
	});
var $author$project$VerifyLocations$Resolver$Commands$verifyLocationEncoder = F4(
	function (id, address, coordinates, isVerified) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'address',
					$author$project$Data$Address$addressEncoder(address)),
					_Utils_Tuple2(
					'location',
					$author$project$VerifyLocations$Resolver$Commands$coordinatesEncoder(coordinates)),
					_Utils_Tuple2(
					'isVerified',
					$elm$json$Json$Encode$bool(isVerified))
				]));
	});
var $author$project$VerifyLocations$Resolver$Commands$VerifyLocationData = F3(
	function (id, address, location) {
		return {id: id, address: address, location: location};
	});
var $author$project$VerifyLocations$Resolver$Commands$verifyLocationResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$author$project$Data$Coordinates$coordinatesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$Data$Address$addressDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Commands$VerifyLocationData))));
var $author$project$VerifyLocations$Resolver$Commands$verifyLocation = F4(
	function (siteName, isVerified, _v0, msg) {
		var location = _v0.location;
		var address = _v0.address;
		var id = _v0.id;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$VerifyLocations$Resolver$Commands$verifyLocationResultDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A4($author$project$VerifyLocations$Resolver$Commands$verifyLocationEncoder, id, address, location, isVerified),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/places/verify'))))));
	});
var $author$project$Data$ServiceArea$splitSuggestion = function (serviceArea) {
	var tailItem = $elm$core$String$trim(
		$elm$core$String$concat(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(
					A2($elm$core$String$split, ',', serviceArea.area)))));
	var headItem = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, ',', serviceArea.area)));
	return _Utils_Tuple2(headItem, tailItem);
};
var $author$project$VerifyLocations$Resolver$Commands$ServiceAreaError = {$: 'ServiceAreaError'};
var $author$project$VerifyLocations$Resolver$Update$GeoLookupResponse = F2(
	function (a, b) {
		return {$: 'GeoLookupResponse', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Model$selectFieldInLocation = F4(
	function (field, locationId, source, model) {
		return _Utils_update(
			model,
			{
				selected: A3(
					$elm$core$Dict$update,
					locationId,
					function (x) {
						var _v0 = _Utils_Tuple2(
							field,
							A2(
								$elm$core$Maybe$withDefault,
								{address: $elm$core$Maybe$Nothing, location: $elm$core$Maybe$Nothing},
								x));
						switch (_v0.a.$) {
							case 'Address':
								var _v1 = _v0.a;
								var selections = _v0.b;
								return $elm$core$Maybe$Just(
									_Utils_update(
										selections,
										{
											address: $elm$core$Maybe$Just(source)
										}));
							case 'Location':
								var _v2 = _v0.a;
								var selections = _v0.b;
								return $elm$core$Maybe$Just(
									_Utils_update(
										selections,
										{
											location: $elm$core$Maybe$Just(source)
										}));
							default:
								return x;
						}
					},
					model.selected)
			});
	});
var $author$project$VerifyLocations$Resolver$Update$setupCurrentPage = function (model) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Common$PaginationSimple$currentItem,
		$author$project$RemoteData$currentData(model.locations));
	if (_v0.$ === 'Just') {
		var location = _v0.a;
		var _v1 = $author$project$VerifyLocations$Resolver$Update$getActivateMsg(model);
		var nextActiveAreaCommand = _v1.a;
		var preSelectMasterModel = A4(
			$author$project$VerifyLocations$Resolver$Model$selectFieldInLocation,
			$author$project$Data$Location$Field$Location,
			location.id,
			$author$project$VerifyLocations$Resolver$Data$Source$Master,
			A4($author$project$VerifyLocations$Resolver$Model$selectFieldInLocation, $author$project$Data$Location$Field$Address, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Master, model));
		return _Utils_Tuple2(
			_Utils_update(
				preSelectMasterModel,
				{
					geoLookups: A3($elm$core$Dict$insert, location.id, $author$project$RemoteData$Loading, model.geoLookups)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$VerifyLocations$Resolver$Commands$getGeoLookup,
						location,
						model.siteName,
						$author$project$VerifyLocations$Resolver$Update$GeoLookupResponse(location.id)),
						A2(
						$elm$core$Task$perform,
						function (_v2) {
							return nextActiveAreaCommand;
						},
						$elm$core$Task$succeed(_Utils_Tuple0))
					])));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$VerifyLocations$Resolver$Update$LocationsResponse = function (a) {
	return {$: 'LocationsResponse', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$UpdateSuggestions = function (a) {
	return {$: 'UpdateSuggestions', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$HandleSearchResult = function (a) {
	return {$: 'HandleSearchResult', a: a};
};
var $author$project$VerifyLocations$Resolver$Commands$inputEncoder = F3(
	function (inputValue, sessionToken, siteName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'input',
					$elm$json$Json$Encode$string(inputValue)),
					_Utils_Tuple2(
					'sessionToken',
					$elm$json$Json$Encode$string(sessionToken)),
					_Utils_Tuple2(
					'siteName',
					$elm$json$Json$Encode$string(siteName))
				]));
	});
var $author$project$Common$ServiceAreaSelector$Types$SearchResult = function (serviceAreas) {
	return {serviceAreas: serviceAreas};
};
var $author$project$Common$ServiceAreaSelector$Types$searchResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'serviceAreas',
	$elm$json$Json$Decode$list($author$project$Data$ServiceArea$serviceAreaSuggestionDecoder),
	$elm$json$Json$Decode$succeed($author$project$Common$ServiceAreaSelector$Types$SearchResult));
var $author$project$VerifyLocations$Resolver$Commands$searchServiceAreas = F4(
	function (inputValue, sessionToken, siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Common$ServiceAreaSelector$Types$searchResultDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A3($author$project$VerifyLocations$Resolver$Commands$inputEncoder, inputValue, sessionToken, siteName),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/google/servicearea/lookup')))));
	});
var $author$project$VerifyLocations$Resolver$Commands$verifyServiceAreasEncoder = F2(
	function (id, serviceAreas) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'serviceAreas',
					$author$project$Data$ServiceArea$encodeServiceAreas(serviceAreas))
				]));
	});
var $author$project$VerifyLocations$Resolver$Commands$decodeListServiceAreaObject = function (bool) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (serviceAreas) {
			var serviceAreaObjects = A2(
				$elm$core$List$map,
				function (serviceArea) {
					var serviceAreaObject = $author$project$VerifyLocations$Resolver$Commands$ExistingArea(
						{verified: bool, serviceArea: serviceArea});
					return serviceAreaObject;
				},
				serviceAreas);
			return $elm$json$Json$Decode$succeed(serviceAreaObjects);
		},
		$author$project$Data$ServiceArea$decodeServiceAreaList);
};
var $author$project$VerifyLocations$Resolver$Commands$verifyServiceAreas = F4(
	function (siteName, locationId, serviceAreas, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$VerifyLocations$Resolver$Commands$decodeListServiceAreaObject(true),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A2($author$project$VerifyLocations$Resolver$Commands$verifyServiceAreasEncoder, locationId, serviceAreas),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/places/verify/serviceareas'))))));
	});
var $author$project$VerifyLocations$Resolver$Update$NeedsReviewResponse = F2(
	function (a, b) {
		return {$: 'NeedsReviewResponse', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Model$VerifyLocationError = F2(
	function (userMessage, errorMessage) {
		return {userMessage: userMessage, errorMessage: errorMessage};
	});
var $author$project$VerifyLocations$Resolver$Commands$decodeCount = A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int);
var $author$project$VerifyLocations$Resolver$Commands$decodeAllVerified = A2(
	$elm$json$Json$Decode$andThen,
	function (_int) {
		return (!_int) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$succeed(false);
	},
	$author$project$VerifyLocations$Resolver$Commands$decodeCount);
var $author$project$VerifyLocations$Resolver$Commands$allLocationsVerified = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$VerifyLocations$Resolver$Commands$decodeAllVerified, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/unverified/count')))));
	});
var $author$project$Location$Details$ScheduleUpdate$ScheduleUpdate = F6(
	function (scheduleId, locations, fieldAndData, date, createdAt, userName) {
		return {date: date, userName: userName, createdAt: createdAt, locations: locations, scheduleId: scheduleId, fieldAndData: fieldAndData};
	});
var $author$project$Location$Details$ScheduleUpdate$EmailField = function (a) {
	return {$: 'EmailField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$PhoneField = function (a) {
	return {$: 'PhoneField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$AddressField = function (a) {
	return {$: 'AddressField', a: a};
};
var $author$project$Data$CustomDataDefinition$PropertyName = function (a) {
	return {$: 'PropertyName', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$HomepageField = function (a) {
	return {$: 'HomepageField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$OpenHoursField = function (a) {
	return {$: 'OpenHoursField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$CustomDataBoolField = F2(
	function (a, b) {
		return {$: 'CustomDataBoolField', a: a, b: b};
	});
var $author$project$Location$Details$ScheduleUpdate$CustomDataListField = F2(
	function (a, b) {
		return {$: 'CustomDataListField', a: a, b: b};
	});
var $author$project$Location$Details$ScheduleUpdate$LongDescriptionField = function (a) {
	return {$: 'LongDescriptionField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$CustomDataObjectField = F2(
	function (a, b) {
		return {$: 'CustomDataObjectField', a: a, b: b};
	});
var $author$project$Location$Details$ScheduleUpdate$CustomDataStringField = F2(
	function (a, b) {
		return {$: 'CustomDataStringField', a: a, b: b};
	});
var $author$project$Location$Details$ScheduleUpdate$ShortDescriptionField = function (a) {
	return {$: 'ShortDescriptionField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$PermanentlyClosedField = function (a) {
	return {$: 'PermanentlyClosedField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$TemporarilyClosedField = function (a) {
	return {$: 'TemporarilyClosedField', a: a};
};
var $author$project$Location$Details$ScheduleUpdate$CustomDataOpenHoursField = F2(
	function (a, b) {
		return {$: 'CustomDataOpenHoursField', a: a, b: b};
	});
var $author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedDecoder = function (isTempClosed) {
	return (!isTempClosed) ? $elm$json$Json$Decode$succeed($author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed) : A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed),
		$elm$json$Json$Decode$maybe(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Data$NetworkData$TemporarilyClosed$Until,
				A2($elm$json$Json$Decode$field, 'temporarilyClosedUntil', $author$project$Data$NetworkData$TemporarilyClosed$untilDecoder),
				A2($elm$json$Json$Decode$field, 'temporarilyClosedMessage', $elm$json$Json$Decode$string))));
};
var $author$project$Location$Details$Commands$fieldAndDataDecoder = F2(
	function (customDataDefinition, field) {
		var fieldWithoutCustomFieldPointer = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			$elm$core$Basics$identity,
			$elm$core$List$head(
				A2($elm$core$String$split, '#', field)));
		var customFieldPointer = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			$elm$core$Basics$identity,
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$String$split, '#', field))));
		switch (fieldWithoutCustomFieldPointer) {
			case 'openHours':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (isAlwaysOpen) {
						return A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'data',
							$author$project$Data$Location$OpenHours$openHoursDecoder(isAlwaysOpen),
							$elm$json$Json$Decode$succeed($author$project$Location$Details$ScheduleUpdate$OpenHoursField));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'isAlwaysOpen']),
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)));
			case 'temporarilyClosed':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (isTempClosed) {
						return A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'data',
							$author$project$Data$NetworkData$TemporarilyClosed$temporarilyClosedDecoder(isTempClosed),
							$elm$json$Json$Decode$succeed($author$project$Location$Details$ScheduleUpdate$TemporarilyClosedField));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'isTempClosed']),
						$elm$json$Json$Decode$bool));
			case 'permanentlyClosed':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (permanentlyClosed) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Location$Details$ScheduleUpdate$PermanentlyClosedField(permanentlyClosed));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'permanentlyClosed']),
						$elm$json$Json$Decode$bool));
			case 'address':
				return A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['data', 'serviceAreas']),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Data$ServiceArea$decodeServiceAreas),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['data', 'type']),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Data$Location$locationTypeDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['data', 'address']),
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Data$Address$addressDecoder),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed(
								F3(
									function (maybeAddress, maybeLocationType, maybeServiceAreas) {
										return $author$project$Location$Details$ScheduleUpdate$AddressField(
											{
												address: A2($elm$core$Maybe$withDefault, $author$project$Data$Address$emptyAddress, maybeAddress),
												locationType: A2($elm$core$Maybe$withDefault, $author$project$Data$Location$Storefront, maybeLocationType),
												serviceAreas: A2($elm$core$Maybe$withDefault, $author$project$Data$ServiceArea$None, maybeServiceAreas)
											});
									})))));
			case 'contact.phone':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (phone) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Location$Details$ScheduleUpdate$PhoneField(
								$author$project$Data$Location$Phone(phone)));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'contact', 'phone']),
						$elm$json$Json$Decode$string));
			case 'contact.homepage':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (homepage) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Location$Details$ScheduleUpdate$HomepageField(
								$author$project$Data$Location$Homepage(homepage)));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'contact', 'homepage']),
						$elm$json$Json$Decode$string));
			case 'contact.email':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (email) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Location$Details$ScheduleUpdate$EmailField(
								$author$project$Data$Location$Email(email)));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'contact', 'email']),
						$elm$json$Json$Decode$string));
			case 'longDescription':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (longDescription) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Location$Details$ScheduleUpdate$LongDescriptionField(
								$author$project$Data$Location$LongDescription(longDescription)));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'longDescription']),
						$elm$json$Json$Decode$string));
			case 'shortDescription':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (shortDescription) {
						return $elm$json$Json$Decode$succeed(
							$author$project$Location$Details$ScheduleUpdate$ShortDescriptionField(
								$author$project$Data$Location$ShortDescription(shortDescription)));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'shortDescription']),
						$elm$json$Json$Decode$string));
			case 'customData.openHours':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (openHours) {
						return $elm$json$Json$Decode$succeed(
							A2($author$project$Location$Details$ScheduleUpdate$CustomDataOpenHoursField, customFieldPointer, openHours));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customData', customFieldPointer]),
						$author$project$Data$Location$OpenHours$decoder));
			case 'customData.string':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (string) {
						return $elm$json$Json$Decode$succeed(
							A2($author$project$Location$Details$ScheduleUpdate$CustomDataStringField, customFieldPointer, string));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customData', customFieldPointer]),
						$elm$json$Json$Decode$string));
			case 'customData.bool':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (bool) {
						return $elm$json$Json$Decode$succeed(
							A2($author$project$Location$Details$ScheduleUpdate$CustomDataBoolField, customFieldPointer, bool));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customData', customFieldPointer]),
						$elm$json$Json$Decode$bool));
			case 'customData.list':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (listOfString) {
						return $elm$json$Json$Decode$succeed(
							A2($author$project$Location$Details$ScheduleUpdate$CustomDataListField, customFieldPointer, listOfString));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customData', customFieldPointer]),
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
			case 'customData.object':
				return A2(
					$elm$json$Json$Decode$andThen,
					function (customData) {
						var mapObjectPropToListOfProps = function (prop) {
							if (prop.$ === 'ObjectProperty') {
								var _v3 = prop.a;
								var objectListProperty = _v3.a;
								var metaDefinition = _v3.b;
								return _Utils_eq(
									metaDefinition.name,
									$author$project$Data$CustomDataDefinition$PropertyName(customFieldPointer)) ? $elm$core$Maybe$Just(objectListProperty) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						};
						var _v1 = customData;
						var propertyList = _v1.a;
						var objectPropsList = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$elm$core$List$head(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									A2($elm$core$List$map, mapObjectPropToListOfProps, propertyList))));
						return $elm$json$Json$Decode$succeed(
							A2(
								$author$project$Location$Details$ScheduleUpdate$CustomDataObjectField,
								customFieldPointer,
								$author$project$Data$Location$CustomData$CustomData(objectPropsList)));
					},
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'customData']),
						$author$project$Data$Location$CustomData$customDataDecoder(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Data$CustomDataDefinition$CustomDataDefinition(_List_Nil),
								customDataDefinition))));
			default:
				return $elm$json$Json$Decode$fail('Unknown field ' + field);
		}
	});
var $author$project$Location$Details$ScheduleUpdate$ScheduleUpdateLocation = F2(
	function (locationId, status) {
		return {status: status, locationId: locationId};
	});
var $author$project$Location$Details$ScheduleUpdate$Error = {$: 'Error'};
var $author$project$Location$Details$ScheduleUpdate$Ignored = {$: 'Ignored'};
var $author$project$Location$Details$ScheduleUpdate$Pending = {$: 'Pending'};
var $author$project$Location$Details$ScheduleUpdate$Working = {$: 'Working'};
var $author$project$Location$Details$ScheduleUpdate$Published = {$: 'Published'};
var $author$project$Location$Details$ScheduleUpdate$stringToScheduleUpdateLocationStatus = function (status) {
	switch (status) {
		case 'Published':
			return $author$project$Location$Details$ScheduleUpdate$Published;
		case 'Working':
			return $author$project$Location$Details$ScheduleUpdate$Working;
		case 'Pending':
			return $author$project$Location$Details$ScheduleUpdate$Pending;
		case 'Ignored':
			return $author$project$Location$Details$ScheduleUpdate$Ignored;
		default:
			return $author$project$Location$Details$ScheduleUpdate$Error;
	}
};
var $author$project$Location$Details$Commands$scheduleUpdateLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	A2($elm$json$Json$Decode$map, $author$project$Location$Details$ScheduleUpdate$stringToScheduleUpdateLocationStatus, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Location$Details$ScheduleUpdate$ScheduleUpdateLocation)));
var $author$project$Location$Details$Commands$scheduleUpdateDecoder = function (customDataDefinition) {
	var dateDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (date) {
			var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(date + 'T00:00:00.000Z');
			if (_v0.$ === 'Ok') {
				var posix = _v0.a;
				return $elm$json$Json$Decode$succeed(posix);
			} else {
				return $elm$json$Json$Decode$fail('Failed to decode date' + date);
			}
		},
		$elm$json$Json$Decode$string);
	return A2(
		$elm$json$Json$Decode$andThen,
		function (fieldAndData) {
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['user', 'name']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'date',
						dateDecoder,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							fieldAndData,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'locations',
								$elm$json$Json$Decode$list($author$project$Location$Details$Commands$scheduleUpdateLocationDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'_id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Location$Details$ScheduleUpdate$ScheduleUpdate)))))));
		},
		A2(
			$elm$json$Json$Decode$andThen,
			$author$project$Location$Details$Commands$fieldAndDataDecoder(customDataDefinition),
			A2($elm$json$Json$Decode$field, 'fieldToUpdate', $elm$json$Json$Decode$string)));
};
var $author$project$Location$Details$Commands$scheduleUpdatesDecoder = function (customDataDefinition) {
	return A2(
		$elm$json$Json$Decode$field,
		'data',
		$elm$json$Json$Decode$list(
			$author$project$Location$Details$Commands$scheduleUpdateDecoder(customDataDefinition)));
};
var $author$project$Location$Details$Commands$deleteScheduleUpdate = F4(
	function (_v0, locationId, scheduleId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Location$Details$Commands$scheduleUpdatesDecoder($elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$delete('api/' + (siteName + ('/places/schedule/' + (scheduleId + ('?returnPlaceId=' + locationId))))))));
	});
var $author$project$Location$Details$Commands$sendToScheduleUpdate_ = F5(
	function (_v0, customDataDefinition, locationId, msg, json) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Location$Details$Commands$scheduleUpdatesDecoder(customDataDefinition),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + ('/places/schedule?returnPlaceId=' + locationId))))));
	});
var $author$project$VerifyLocations$Resolver$Update$VerifyLocationResponse = F4(
	function (a, b, c, d) {
		return {$: 'VerifyLocationResponse', a: a, b: b, c: c, d: d};
	});
var $author$project$VerifyLocations$Resolver$Commands$ResultWithLocationId = F2(
	function (a, b) {
		return {$: 'ResultWithLocationId', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Commands$getMetaDataServiceArea = F4(
	function (suggestion, sessionToken, locationId, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					A2(
						$elm$core$Basics$composeR,
						$author$project$VerifyLocations$Resolver$Commands$ResultWithLocationId(locationId),
						msg),
					$author$project$Data$ServiceArea$serviceAreaDecoder,
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Data$ServiceArea$serviceAreaSuggestionEncoder(suggestion),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/google/servicearea/placeDetails/' + sessionToken)))));
	});
var $author$project$VerifyLocations$Resolver$Commands$Address = {$: 'Address'};
var $author$project$VerifyLocations$Resolver$Commands$Location = function (id) {
	return function (locationDescriptor) {
		return function (storeId) {
			return function (address) {
				return function (coordinates) {
					return function (verified) {
						return function (googleCustomName) {
							return function (facebookCustomName) {
								return function (serviceAreas) {
									return function (verificationState) {
										return function (serviceAreaError) {
											return function (storefrontName) {
												return function (locationType) {
													return function (needsReview) {
														return {id: id, address: address, storeId: storeId, verified: verified, coordinates: coordinates, needsReview: needsReview, locationType: locationType, serviceAreas: serviceAreas, storefrontName: storefrontName, googleCustomName: googleCustomName, serviceAreaError: serviceAreaError, verificationState: verificationState, facebookCustomName: facebookCustomName, locationDescriptor: locationDescriptor};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$VerifyLocations$Resolver$Commands$getAddressStatus = F2(
	function (statusMaybe, needsStorefront) {
		return (!needsStorefront) ? true : A2($elm$core$Maybe$withDefault, false, statusMaybe);
	});
var $author$project$VerifyLocations$Resolver$Commands$getServiceAreaStatus = F2(
	function (statusMaybe, needsServiceArea) {
		return (!needsServiceArea) ? true : A2($elm$core$Maybe$withDefault, false, statusMaybe);
	});
var $author$project$VerifyLocations$Resolver$Commands$getLocationRequirements = function (locationType) {
	switch (locationType.$) {
		case 'Storefront':
			return {needsStorefront: true, needsServiceArea: false};
		case 'ServiceArea':
			return {needsStorefront: false, needsServiceArea: true};
		default:
			return {needsStorefront: true, needsServiceArea: true};
	}
};
var $author$project$VerifyLocations$Resolver$Commands$VerificationStatus = F2(
	function (serviceAreaStatus, addressAndCoordinatesStatus) {
		return {serviceAreaStatus: serviceAreaStatus, addressAndCoordinatesStatus: addressAndCoordinatesStatus};
	});
var $author$project$VerifyLocations$Resolver$Commands$decodeVerificationStatus = A3(
	$elm$json$Json$Decode$map2,
	$author$project$VerifyLocations$Resolver$Commands$VerificationStatus,
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'serviceAreas',
			A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$bool))),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'addressAndCoordinates',
			A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$bool))));
var $author$project$VerifyLocations$Resolver$Commands$AddressAndServiceAreas = {$: 'AddressAndServiceAreas'};
var $author$project$VerifyLocations$Resolver$Commands$determineVerificationState = F2(
	function (serviceAreaStatus, addressStatus) {
		var _v0 = _Utils_Tuple2(serviceAreaStatus, addressStatus);
		if (!_v0.a) {
			if (!_v0.b) {
				return $elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Commands$AddressAndServiceAreas);
			} else {
				return $elm$json$Json$Decode$succeed(
					$author$project$VerifyLocations$Resolver$Commands$ServiceAreas(false));
			}
		} else {
			if (!_v0.b) {
				return $elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Commands$Address);
			} else {
				return $elm$json$Json$Decode$fail('All fields have already been verified on this location.');
			}
		}
	});
var $author$project$VerifyLocations$Resolver$Commands$decodeVerification = function (locationType) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (verificationStatus) {
			var locationRequirements = $author$project$VerifyLocations$Resolver$Commands$getLocationRequirements(locationType);
			var serviceAreaStatus = A2($author$project$VerifyLocations$Resolver$Commands$getServiceAreaStatus, verificationStatus.serviceAreaStatus, locationRequirements.needsServiceArea);
			var addressStatus = A2($author$project$VerifyLocations$Resolver$Commands$getAddressStatus, verificationStatus.addressAndCoordinatesStatus, locationRequirements.needsStorefront);
			return A2($author$project$VerifyLocations$Resolver$Commands$determineVerificationState, serviceAreaStatus, addressStatus);
		},
		$author$project$VerifyLocations$Resolver$Commands$decodeVerificationStatus);
};
var $author$project$VerifyLocations$Resolver$Commands$locationDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (locationType) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['verification', 'needsReview']),
			$elm$json$Json$Decode$bool,
			false,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				locationType,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$string,
					'',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						$author$project$VerifyLocations$Resolver$Commands$None,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'verification',
							$author$project$VerifyLocations$Resolver$Commands$decodeVerification(locationType),
							function () {
								switch (locationType.$) {
									case 'Storefront':
										return $author$project$VerifyLocations$Resolver$Commands$Address;
									case 'ServiceArea':
										return $author$project$VerifyLocations$Resolver$Commands$ServiceAreas(false);
									default:
										return $author$project$VerifyLocations$Resolver$Commands$AddressAndServiceAreas;
								}
							}(),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'serviceAreas',
								$author$project$VerifyLocations$Resolver$Commands$decodeListServiceAreaObject(false),
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['facebook', 'custom', 'name']),
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$null('')
											])),
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
										_List_fromArray(
											['google', 'custom', 'name']),
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$null('')
												])),
										'',
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											false,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'location',
												$author$project$Data$Coordinates$coordinatesDecoder,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'address',
													$author$project$Data$Address$addressDecoder,
													$author$project$Data$Address$emptyAddress,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'storeId',
														$elm$json$Json$Decode$string,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'locationDescriptor',
															$elm$json$Json$Decode$string,
															'',
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'_id',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$VerifyLocations$Resolver$Commands$Location)))))))))))))));
	},
	A2($elm$json$Json$Decode$field, 'type', $author$project$Data$Location$locationTypeDecoder));
var $author$project$VerifyLocations$Resolver$Commands$decodeLocations = $elm$json$Json$Decode$list($author$project$VerifyLocations$Resolver$Commands$locationDecoder);
var $author$project$VerifyLocations$Resolver$Commands$getUnverifiedLocations = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$VerifyLocations$Resolver$Commands$decodeLocations),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/unverified')))));
	});
var $author$project$Data$ServiceArea$serviceAreaToSuggestion = function (_v0) {
	var area = _v0.area;
	var placeId = _v0.placeId;
	return {area: area, placeId: placeId};
};
var $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorMsg = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorMsg', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Update$RefreshLocationsResponse = function (a) {
	return {$: 'RefreshLocationsResponse', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$defaultVerificationState = function (locationType) {
	switch (locationType.$) {
		case 'Storefront':
			return $author$project$VerifyLocations$Resolver$Commands$Address;
		case 'ServiceArea':
			return $author$project$VerifyLocations$Resolver$Commands$ServiceAreas(false);
		default:
			return $author$project$VerifyLocations$Resolver$Commands$AddressAndServiceAreas;
	}
};
var $author$project$VerifyLocations$Resolver$Update$HandlePlaceDetailsResponse = function (a) {
	return {$: 'HandlePlaceDetailsResponse', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$LdpSpecialOpenHoursUpdated = F2(
	function (a, b) {
		return {$: 'LdpSpecialOpenHoursUpdated', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Update$VerifyServiceAreasResponse = F2(
	function (a, b) {
		return {$: 'VerifyServiceAreasResponse', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorUpdated = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorUpdated', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Update$serviceAreasFromLocationData = F2(
	function (previousAreas, serviceAreas) {
		var previousVerifiedByPlaceId = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filterMap,
				function (area) {
					if (area.$ === 'ExistingArea') {
						var verified = area.a.verified;
						var serviceArea = area.a.serviceArea;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(serviceArea.placeId, verified));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				previousAreas));
		var preservedAddedAreas = A2(
			$elm$core$List$filter,
			function (area) {
				return _Utils_eq(area, $author$project$VerifyLocations$Resolver$Commands$AddedArea);
			},
			previousAreas);
		var newExistingAreas = function () {
			if (serviceAreas.$ === 'WithPlaceId') {
				var areas = serviceAreas.a;
				return A2(
					$elm$core$List$map,
					function (area) {
						return $author$project$VerifyLocations$Resolver$Commands$ExistingArea(
							{
								verified: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Dict$get, area.placeId, previousVerifiedByPlaceId)),
								serviceArea: area
							});
					},
					areas);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_ap(newExistingAreas, preservedAddedAreas);
	});
var $author$project$VerifyLocations$Resolver$Update$SideBarSpecialOpenHoursUpdated = function (a) {
	return {$: 'SideBarSpecialOpenHoursUpdated', a: a};
};
var $author$project$Location$Details$Model$LdpSpecialOpenHoursUpdateResult = F3(
	function (success, locationId, location) {
		return {success: success, location: location, locationId: locationId};
	});
var $author$project$Location$Details$Commands$ldpSpecialOpenHoursUpdateResultDecoder = F2(
	function (features, customDataDefinition) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['data', 'place']),
			A2($author$project$Data$Location$locationDecoder, features, customDataDefinition),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['data', 'place', '_id']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'success',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Location$Details$Model$LdpSpecialOpenHoursUpdateResult))));
	});
var $author$project$Location$Details$Commands$sendToOverwriteSpecialOpenHours = F6(
	function (_v0, locationId, features, customDataDefinition, msg, json) {
		var siteName = _v0.a;
		var locationIdUrl = (locationId !== '') ? ('?returnPlaceId=' + locationId) : locationId;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$Location$Details$Commands$ldpSpecialOpenHoursUpdateResultDecoder, features, customDataDefinition),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + ('/places/overwriteSpecialOpenHours/' + locationIdUrl))))));
	});
var $author$project$VerifyLocations$Resolver$Update$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 'SelectMasterData':
					var field = msg.a;
					var locationId = msg.b;
					return _Utils_Tuple2(
						A4($author$project$VerifyLocations$Resolver$Model$selectFieldInLocation, field, locationId, $author$project$VerifyLocations$Resolver$Data$Source$Master, model),
						$elm$core$Platform$Cmd$none);
				case 'SelectGeoLookupData':
					var field = msg.a;
					var locationId = msg.b;
					return _Utils_Tuple2(
						A4($author$project$VerifyLocations$Resolver$Model$selectFieldInLocation, field, locationId, $author$project$VerifyLocations$Resolver$Data$Source$Geo, model),
						$elm$core$Platform$Cmd$none);
				case 'UseThisGeoLookupData':
					var data = msg.a;
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						function (location) {
							var newLocation = _Utils_update(
								location,
								{
									address: A2($author$project$Data$Address$updateField, data, location.address)
								});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										locations: A2(
											$author$project$RemoteData$map,
											A2(
												$author$project$Common$PaginationSimple$updateItem,
												location.id,
												function (_v1) {
													return newLocation;
												}),
											model.locations)
									}),
								A3(
									$author$project$VerifyLocations$Resolver$Commands$getGeoLookup,
									newLocation,
									model.siteName,
									$author$project$VerifyLocations$Resolver$Update$GeoLookupResponse(location.id)));
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Common$PaginationSimple$currentItem,
							$author$project$RemoteData$currentData(model.locations)));
				case 'LocationsResponse':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var locations = result.a;
						return ($elm$core$List$length(locations) > 0) ? $author$project$VerifyLocations$Resolver$Update$setupCurrentPage(
							_Utils_update(
								model,
								{
									locations: $author$project$RemoteData$Loaded(
										A2(
											$author$project$Common$PaginationSimple$initWithItems,
											locations,
											function ($) {
												return $.id;
											}))
								})) : _Utils_Tuple2(
							_Utils_update(
								model,
								{locations: $author$project$RemoteData$Suspended}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: $author$project$RemoteData$Error(
										$author$project$Util$httpErrorToString(err))
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 'RefreshLocationsResponse':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var freshLocations = result.a;
						var _v4 = $author$project$RemoteData$currentData(model.locations);
						if (_v4.$ === 'Just') {
							var pagination = _v4.a;
							var freshById = $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (loc) {
										return _Utils_Tuple2(loc.id, loc);
									},
									freshLocations));
							var syncedPagination = _Utils_update(
								pagination,
								{
									items: A2(
										$elm$core$Dict$map,
										F2(
											function (id, loc) {
												var _v5 = A2($elm$core$Dict$get, id, freshById);
												if (_v5.$ === 'Just') {
													var fresh = _v5.a;
													return _Utils_update(
														loc,
														{needsReview: fresh.needsReview});
												} else {
													return loc;
												}
											}),
										pagination.items)
								});
							var freshIds = $elm$core$Set$fromList(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.id;
									},
									freshLocations));
							var idsToRemove = $elm$core$Set$fromList(
								$elm$core$Dict$keys(
									A2(
										$elm$core$Dict$filter,
										F2(
											function (id, loc) {
												return (!loc.verified) && (!A2($elm$core$Set$member, id, freshIds));
											}),
										pagination.items)));
							if ($elm$core$Set$isEmpty(idsToRemove)) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											locations: $author$project$RemoteData$Loaded(syncedPagination)
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								var newLocations = A2($author$project$Common$PaginationSimple$removeItems, idsToRemove, syncedPagination);
								var previousKey = $author$project$Common$PaginationSimple$currentKey(syncedPagination);
								var newModel = _Utils_update(
									model,
									{
										locations: $author$project$RemoteData$Loaded(newLocations)
									});
								return $elm$core$Dict$isEmpty(newLocations.items) ? _Utils_Tuple2(
									_Utils_update(
										model,
										{locations: $author$project$RemoteData$Loading}),
									A2($author$project$VerifyLocations$Resolver$Commands$getUnverifiedLocations, model.siteName, $author$project$VerifyLocations$Resolver$Update$LocationsResponse)) : ((!_Utils_eq(
									previousKey,
									$author$project$Common$PaginationSimple$currentKey(newLocations))) ? $author$project$VerifyLocations$Resolver$Update$setupCurrentPage(newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none));
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'GeoLookupResponse':
					var locationId = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						var geoData = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									geoLookups: A3(
										$elm$core$Dict$insert,
										locationId,
										$author$project$RemoteData$Loaded(geoData),
										model.geoLookups)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									geoLookups: A3(
										$elm$core$Dict$insert,
										locationId,
										$author$project$RemoteData$Error(
											$author$project$Util$httpErrorToString(err)),
										model.geoLookups)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnPageInputSubmit':
					var locations = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$PaginationSimple$empty,
						$author$project$RemoteData$currentData(model.locations));
					var $temp$msg = $author$project$VerifyLocations$Resolver$Update$OnPageChange(locations.value - 1),
						$temp$model = model;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 'OnPageInputChange':
					var setInputValue = msg.a;
					var locations = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$PaginationSimple$empty,
						$author$project$RemoteData$currentData(model.locations));
					var newPagination = A2(
						$author$project$Common$PaginationSimple$setInputValue,
						A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(setInputValue)),
						locations);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: $author$project$RemoteData$Loaded(newPagination)
							}),
						$elm$core$Platform$Cmd$none);
				case 'OnPageChange':
					var inc = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						$author$project$RemoteData$currentData(
							A2(
								$author$project$RemoteData$map,
								function (_v7) {
									var _v8 = $author$project$VerifyLocations$Resolver$Update$setupCurrentPage(
										_Utils_update(
											model,
											{
												locations: A2(
													$author$project$RemoteData$map,
													$author$project$Common$PaginationSimple$changePage(inc),
													model.locations)
											}));
									var newModel = _v8.a;
									var cmd = _v8.b;
									return _Utils_Tuple2(
										newModel,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													cmd,
													A2($author$project$VerifyLocations$Resolver$Commands$getUnverifiedLocations, newModel.siteName, $author$project$VerifyLocations$Resolver$Update$RefreshLocationsResponse)
												])));
								},
								model.locations)));
				case 'OnMapMarkerUseThis':
					var source = msg.a;
					var select = function (locationId) {
						return A4($author$project$VerifyLocations$Resolver$Model$selectFieldInLocation, $author$project$Data$Location$Field$Location, locationId, source, model);
					};
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								select,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Common$PaginationSimple$currentKey,
									$author$project$RemoteData$currentData(model.locations)))),
						$elm$core$Platform$Cmd$none);
				case 'OnMapMarkerMoved':
					var coordinates = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (loc) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											locations: A2(
												$author$project$RemoteData$map,
												A2(
													$author$project$Common$PaginationSimple$updateItem,
													loc.id,
													function (x) {
														return _Utils_update(
															x,
															{coordinates: coordinates});
													}),
												model.locations)
										}),
									A3(
										$author$project$VerifyLocations$Resolver$Commands$getGeoLookup,
										loc,
										model.siteName,
										$author$project$VerifyLocations$Resolver$Update$GeoLookupResponse(loc.id)));
							},
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Common$PaginationSimple$currentItem,
								$author$project$RemoteData$currentData(model.locations))));
				case 'GenerateSeeds':
					var inputValue = msg.a;
					var seeds = msg.b;
					var newSessionToken = A2($author$project$Common$ServiceAreaSelector$Update$generateToken, model.sessionToken, seeds);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionToken: $elm$core$Maybe$Just(newSessionToken)
							}),
						A4($author$project$VerifyLocations$Resolver$Commands$searchServiceAreas, inputValue, newSessionToken, model.siteName, $author$project$VerifyLocations$Resolver$Update$HandleSearchResult));
				case 'UpdateSuggestions':
					var inputValue = msg.a;
					var searchCmd = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2(
							$elm$random$Random$generate,
							$author$project$VerifyLocations$Resolver$Update$GenerateSeeds(inputValue),
							A2(
								$elm$random$Random$list,
								4,
								A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt))),
						function (token) {
							return A4($author$project$VerifyLocations$Resolver$Commands$searchServiceAreas, inputValue, token, model.siteName, $author$project$VerifyLocations$Resolver$Update$HandleSearchResult);
						},
						model.sessionToken);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{searchString: inputValue}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									searchCmd,
									A2(
									$elm$core$Task$attempt,
									function (_v9) {
										return $author$project$VerifyLocations$Resolver$Update$NoOp;
									},
									$elm$browser$Browser$Dom$focus('suggestions'))
								])));
				case 'FocusOn':
					var id = msg.a;
					var scrollTask = A2(
						$elm$core$Task$andThen,
						function (outcome) {
							if (((outcome.b && outcome.b.b) && outcome.b.b.b) && (!outcome.b.b.b.b)) {
								var elY = outcome.a;
								var _v12 = outcome.b;
								var viewportY = _v12.a;
								var _v13 = _v12.b;
								var viewportScrollTop = _v13.a;
								return A2(
									$elm$core$Task$onError,
									function (_v14) {
										return $elm$core$Task$succeed(_Utils_Tuple0);
									},
									A3($elm$browser$Browser$Dom$setViewportOf, 'service-area-scroll', 0, viewportScrollTop + (elY - viewportY)));
							} else {
								return $elm$core$Task$succeed(_Utils_Tuple0);
							}
						},
						$elm$core$Task$sequence(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$map,
									function (x) {
										return x.element.y;
									},
									$elm$browser$Browser$Dom$getElement(id)),
									A2(
									$elm$core$Task$map,
									function (x) {
										return x.element.y;
									},
									$elm$browser$Browser$Dom$getElement('service-area-scroll')),
									A2(
									$elm$core$Task$map,
									function (x) {
										return x.viewport.y;
									},
									$elm$browser$Browser$Dom$getViewportOf('service-area-scroll'))
								])));
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							function (_v10) {
								return $author$project$VerifyLocations$Resolver$Update$NoOp;
							},
							scrollTask));
				case 'NoOp':
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 'ActivateServiceArea':
					var serviceAreaObject = msg.a;
					var _v15 = function () {
						if (serviceAreaObject.$ === 'ExistingArea') {
							var a = serviceAreaObject.a;
							var _v17 = $author$project$Data$ServiceArea$splitSuggestion(
								$author$project$Data$ServiceArea$serviceAreaToSuggestion(a.serviceArea));
							var areaFirstPart = _v17.a;
							return _Utils_Tuple3(
								$author$project$VerifyLocations$Resolver$Model$ActiveExisting(a.serviceArea),
								areaFirstPart,
								a.serviceArea.placeId);
						} else {
							return _Utils_Tuple3($author$project$VerifyLocations$Resolver$Model$ActiveAdded, '', $author$project$VerifyLocations$Resolver$Model$addAreaId);
						}
					}();
					var saToActivate = _v15.a;
					var area = _v15.b;
					var placeId = _v15.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{activeServiceArea: saToActivate}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$perform,
									function (_v18) {
										return $author$project$VerifyLocations$Resolver$Update$UpdateSuggestions(area);
									},
									$elm$core$Task$succeed(_Utils_Tuple0)),
									A2(
									$elm$core$Task$perform,
									function (_v19) {
										return $author$project$VerifyLocations$Resolver$Update$FocusOn(placeId);
									},
									$elm$core$Task$succeed(_Utils_Tuple0))
								])));
				case 'DeactivateServiceAreas':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{suggestions: _List_Nil, searchString: '', activeServiceArea: $author$project$VerifyLocations$Resolver$Model$Deactive}),
						$elm$core$Platform$Cmd$none);
				case 'VerifyServiceAreas':
					var locationId = msg.a;
					var serviceAreas = msg.b;
					var sa = A2(
						$elm$core$List$filterMap,
						function (a) {
							if (a.$ === 'ExistingArea') {
								var serviceArea = a.a.serviceArea;
								return $elm$core$Maybe$Just(serviceArea);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						serviceAreas);
					var verify = A4(
						$author$project$VerifyLocations$Resolver$Commands$verifyServiceAreas,
						model.siteName,
						locationId,
						sa,
						$author$project$VerifyLocations$Resolver$Update$VerifyServiceAreasResponse(locationId));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								verifyLocationErrors: A2($elm$core$Dict$remove, locationId, model.verifyLocationErrors)
							}),
						verify);
				case 'VerifyLocation':
					var location = msg.a;
					var isVerified = function () {
						var _v33 = location.verificationState;
						if (_v33.$ === 'Address') {
							return true;
						} else {
							return false;
						}
					}();
					var geoData = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
						A2(
							$elm$core$Maybe$map,
							function (x) {
								return _Utils_Tuple2(
									$elm$core$Result$toMaybe(x.address),
									$elm$core$Result$toMaybe(x.coordinates));
							},
							A2(
								$elm$core$Maybe$andThen,
								$author$project$RemoteData$currentData,
								A2($elm$core$Dict$get, location.id, model.geoLookups))));
					var verify = A2($author$project$VerifyLocations$Resolver$Commands$verifyLocation, model.siteName, isVerified);
					var createCmd = F2(
						function (addressSource, locationSource) {
							var _v21 = _Utils_Tuple3(addressSource, locationSource, geoData);
							_v21$4:
							while (true) {
								if (_v21.a.$ === 'Master') {
									if (_v21.b.$ === 'Master') {
										var _v22 = _v21.a;
										var _v23 = _v21.b;
										return A2(
											verify,
											A3($author$project$VerifyLocations$Resolver$Commands$VerifyLocationData, location.id, location.address, location.coordinates),
											A3($author$project$VerifyLocations$Resolver$Update$VerifyLocationResponse, location.id, location.verificationState, location.locationType));
									} else {
										if (_v21.c.b.$ === 'Just') {
											var _v24 = _v21.a;
											var _v25 = _v21.b;
											var _v26 = _v21.c;
											var geoCoordinates = _v26.b.a;
											return A2(
												verify,
												A3($author$project$VerifyLocations$Resolver$Commands$VerifyLocationData, location.id, location.address, geoCoordinates),
												A3($author$project$VerifyLocations$Resolver$Update$VerifyLocationResponse, location.id, location.verificationState, location.locationType));
										} else {
											break _v21$4;
										}
									}
								} else {
									if (_v21.b.$ === 'Master') {
										if (_v21.c.a.$ === 'Just') {
											var _v27 = _v21.a;
											var _v28 = _v21.b;
											var _v29 = _v21.c;
											var geoAddress = _v29.a.a;
											return A2(
												verify,
												A3($author$project$VerifyLocations$Resolver$Commands$VerifyLocationData, location.id, geoAddress, location.coordinates),
												A3($author$project$VerifyLocations$Resolver$Update$VerifyLocationResponse, location.id, location.verificationState, location.locationType));
										} else {
											break _v21$4;
										}
									} else {
										if ((_v21.c.a.$ === 'Just') && (_v21.c.b.$ === 'Just')) {
											var _v30 = _v21.a;
											var _v31 = _v21.b;
											var _v32 = _v21.c;
											var geoAddress = _v32.a.a;
											var geoCoordinates = _v32.b.a;
											return A2(
												verify,
												A3($author$project$VerifyLocations$Resolver$Commands$VerifyLocationData, location.id, geoAddress, geoCoordinates),
												A3($author$project$VerifyLocations$Resolver$Update$VerifyLocationResponse, location.id, location.verificationState, location.locationType));
										} else {
											break _v21$4;
										}
									}
								}
							}
							return $elm$core$Platform$Cmd$none;
						});
					return A2(
						$elm$core$Tuple$pair,
						_Utils_update(
							model,
							{
								verifyLocationErrors: A2($elm$core$Dict$remove, location.id, model.verifyLocationErrors)
							}),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$andThen,
								function (selection) {
									return A3($elm$core$Maybe$map2, createCmd, selection.address, selection.location);
								},
								A2($elm$core$Dict$get, location.id, model.selected))));
				case 'RemoveServiceArea':
					var locationId = msg.a;
					var serviceArea = msg.b;
					var _v34 = $author$project$VerifyLocations$Resolver$Update$getActivateMsg(model);
					var nextActiveAreaCommand = _v34.a;
					var serviceAreaLength = _v34.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: A2(
									$author$project$RemoteData$map,
									A2(
										$author$project$Common$PaginationSimple$updateItem,
										locationId,
										function (x) {
											var newServiceAreas = A2(
												$elm$core$List$filter,
												function (area) {
													return !_Utils_eq(area, serviceArea);
												},
												x.serviceAreas);
											return (serviceAreaLength === 1) ? _Utils_update(
												x,
												{serviceAreas: x.serviceAreas, serviceAreaError: $author$project$VerifyLocations$Resolver$Commands$ServiceAreaError}) : _Utils_update(
												x,
												{serviceAreas: newServiceAreas, serviceAreaError: $author$project$VerifyLocations$Resolver$Commands$None});
										}),
									model.locations)
							}),
						A2(
							$elm$core$Task$perform,
							function (_v35) {
								return (serviceAreaLength !== 1) ? nextActiveAreaCommand : $author$project$VerifyLocations$Resolver$Update$NoOp;
							},
							$elm$core$Task$succeed(_Utils_Tuple0)));
				case 'AddServiceArea':
					var locationId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: A2(
									$author$project$RemoteData$map,
									A2(
										$author$project$Common$PaginationSimple$updateItem,
										locationId,
										function (x) {
											var newServiceAreas = _Utils_ap(
												x.serviceAreas,
												_List_fromArray(
													[$author$project$VerifyLocations$Resolver$Commands$AddedArea]));
											return _Utils_update(
												x,
												{serviceAreas: newServiceAreas, serviceAreaError: $author$project$VerifyLocations$Resolver$Commands$None});
										}),
									model.locations)
							}),
						A2(
							$elm$core$Task$perform,
							function (_v36) {
								return $author$project$VerifyLocations$Resolver$Update$ActivateServiceArea($author$project$VerifyLocations$Resolver$Commands$AddedArea);
							},
							$elm$core$Task$succeed(_Utils_Tuple0)));
				case 'ConfirmAllServiceAreas':
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: A2(
									$author$project$RemoteData$map,
									A2(
										$author$project$Common$PaginationSimple$updateItem,
										id,
										function (x) {
											var newServiceArea = A2(
												$elm$core$List$map,
												function (area) {
													if (area.$ === 'ExistingArea') {
														var sa = area.a;
														return $author$project$VerifyLocations$Resolver$Commands$ExistingArea(
															_Utils_update(
																sa,
																{verified: true}));
													} else {
														return area;
													}
												},
												x.serviceAreas);
											return _Utils_update(
												x,
												{serviceAreas: newServiceArea, serviceAreaError: $author$project$VerifyLocations$Resolver$Commands$None});
										}),
									model.locations)
							}),
						A2(
							$elm$core$Task$perform,
							function (_v38) {
								return $author$project$VerifyLocations$Resolver$Update$DeactivateServiceAreas;
							},
							$elm$core$Task$succeed(_Utils_Tuple0)));
				case 'ConfirmServiceArea':
					var id = msg.a;
					var suggestion = msg.b;
					var sessionToken = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, model.sessionToken);
					return _Utils_Tuple2(
						model,
						A4($author$project$VerifyLocations$Resolver$Commands$getMetaDataServiceArea, suggestion, sessionToken, id, $author$project$VerifyLocations$Resolver$Update$HandlePlaceDetailsResponse));
				case 'HandleSearchResult':
					var response = msg.a;
					if (response.$ === 'Ok') {
						var searchResult = response.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{suggestions: searchResult.serviceAreas}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = response.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									searchError: $elm$core$Maybe$Just(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
								}),
							$author$project$PinMeTo$Logger$log(
								{
									data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
									context: 'VerifyLocations.Resolver.Update',
									message: 'HandleSearchResult failed'
								}));
					}
				case 'HandlePlaceDetailsResponse':
					var _v40 = msg.a;
					var id = _v40.a;
					var result = _v40.b;
					if (result.$ === 'Ok') {
						var serviceArea = result.a;
						var _v42 = $author$project$VerifyLocations$Resolver$Update$getActivateMsg(model);
						var nextActiveAreaCommand = _v42.a;
						var newLocations = A2(
							$author$project$RemoteData$map,
							A2(
								$author$project$Common$PaginationSimple$updateItem,
								id,
								function (x) {
									var newServiceAreas = A2(
										$elm$core$List$map,
										function (area) {
											var updatedArea = $author$project$VerifyLocations$Resolver$Commands$ExistingArea(
												{verified: true, serviceArea: serviceArea});
											var _v44 = _Utils_Tuple2(area, model.activeServiceArea);
											_v44$2:
											while (true) {
												if (_v44.a.$ === 'ExistingArea') {
													if (_v44.b.$ === 'ActiveExisting') {
														var sa = _v44.a.a;
														var activeSa = _v44.b.a;
														return _Utils_eq(sa.serviceArea.placeId, activeSa.placeId) ? updatedArea : area;
													} else {
														break _v44$2;
													}
												} else {
													if (_v44.b.$ === 'ActiveAdded') {
														var _v45 = _v44.a;
														var _v46 = _v44.b;
														return updatedArea;
													} else {
														break _v44$2;
													}
												}
											}
											return area;
										},
										x.serviceAreas);
									return _Utils_update(
										x,
										{serviceAreas: newServiceAreas, serviceAreaError: $author$project$VerifyLocations$Resolver$Commands$None});
								}),
							model.locations);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: newLocations,
									searchString: A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'',
										$elm$core$Basics$identity,
										$elm$core$List$head(
											A2($elm$core$String$split, ',', serviceArea.area))),
									sessionToken: $elm$core$Maybe$Nothing
								}),
							A2(
								$elm$core$Task$perform,
								function (_v43) {
									return nextActiveAreaCommand;
								},
								$elm$core$Task$succeed(_Utils_Tuple0)));
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									searchError: $elm$core$Maybe$Just(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
								}),
							$author$project$PinMeTo$Logger$log(
								{
									data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
									context: 'VerifyLocations.Resolver.Update',
									message: 'HandlePlaceDetailsResponse failed'
								}));
					}
				case 'SetAllVerified':
					var response = msg.a;
					if (response.$ === 'Ok') {
						var allVerified = response.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{allVerified: allVerified}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = response.a;
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$log(
								{
									data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
									context: 'VerifyLocations.Resolver.Update',
									message: 'SetAllVerified failed'
								}));
					}
				case 'VerifyServiceAreasResponse':
					var locationId = msg.a;
					var response = msg.b;
					if (response.$ === 'Ok') {
						var serviceAreas = response.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (x) {
												return _Utils_update(
													x,
													{verified: true, serviceAreas: serviceAreas, serviceAreaError: $author$project$VerifyLocations$Resolver$Commands$None});
											}),
										model.locations)
								}),
							A2($author$project$VerifyLocations$Resolver$Commands$allLocationsVerified, model.siteName, $author$project$VerifyLocations$Resolver$Update$SetAllVerified));
					} else {
						var err = response.a;
						var serverErrorMsg = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									verifyLocationErrors: A3(
										$elm$core$Dict$insert,
										locationId,
										A2($author$project$VerifyLocations$Resolver$Model$VerifyLocationError, '', serverErrorMsg),
										model.verifyLocationErrors)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 'VerifyLocationResponse':
					var locationId = msg.a;
					var verificationState = msg.b;
					var locationType = msg.c;
					var response = msg.d;
					var handlePaginationQueueItem = F3(
						function (id, address, location) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										locations: A2(
											$author$project$RemoteData$map,
											A2(
												$author$project$Common$PaginationSimple$updateItem,
												id,
												function (x) {
													return _Utils_update(
														x,
														{
															address: address,
															coordinates: location,
															verificationState: $author$project$VerifyLocations$Resolver$Commands$ServiceAreas(true)
														});
												}),
											model.locations)
									}),
								$elm$core$Platform$Cmd$none);
						});
					if (response.$ === 'Ok') {
						var location = response.a.location;
						var address = response.a.address;
						var id = response.a.id;
						var _v50 = _Utils_Tuple2(verificationState, locationType);
						_v50$4:
						while (true) {
							switch (_v50.a.$) {
								case 'AddressAndServiceAreas':
									switch (_v50.b.$) {
										case 'ServiceArea':
											var _v51 = _v50.a;
											var _v52 = _v50.b;
											return A3(handlePaginationQueueItem, id, address, location);
										case 'StorefrontAndServiceArea':
											var _v53 = _v50.a;
											var _v54 = _v50.b;
											return A3(handlePaginationQueueItem, id, address, location);
										default:
											break _v50$4;
									}
								case 'Address':
									switch (_v50.b.$) {
										case 'ServiceArea':
											var _v55 = _v50.a;
											var _v56 = _v50.b;
											return A3(handlePaginationQueueItem, id, address, location);
										case 'StorefrontAndServiceArea':
											var _v57 = _v50.a;
											var _v58 = _v50.b;
											return A3(handlePaginationQueueItem, id, address, location);
										default:
											break _v50$4;
									}
								default:
									break _v50$4;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											id,
											function (x) {
												return _Utils_update(
													x,
													{address: address, verified: true, coordinates: location});
											}),
										model.locations)
								}),
							A2($author$project$VerifyLocations$Resolver$Commands$allLocationsVerified, model.siteName, $author$project$VerifyLocations$Resolver$Update$SetAllVerified));
					} else {
						var err = response.a;
						var serverErrorMsg = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									verifyLocationErrors: A3(
										$elm$core$Dict$insert,
										locationId,
										A2($author$project$VerifyLocations$Resolver$Model$VerifyLocationError, '', serverErrorMsg),
										model.verifyLocationErrors)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 'HandleFlags':
					var flagsValue = msg.a;
					var _v59 = $author$project$VerifyLocations$Resolver$Update$decodeFlags(flagsValue);
					if (_v59.$ === 'Ok') {
						var flags = _v59.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{siteName: flags.siteName, userRoles: flags.roles, displayName: flags.displayName, translations: flags.translations}),
							A2($author$project$VerifyLocations$Resolver$Commands$getUnverifiedLocations, flags.siteName, $author$project$VerifyLocations$Resolver$Update$LocationsResponse));
					} else {
						var err = _v59.a;
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(err),
									context: 'VerifyLocations.Resolver.Update',
									message: 'Failed to decode flags'
								}));
					}
				case 'OnLanguageChanged':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var t = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{translations: t}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(err),
									context: 'VerifyLocations.Resolver.Update',
									message: 'Failed to decode translations'
								}));
					}
				case 'KeyboardMsg':
					var keyMsg = msg.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (_v61) {
								var _v62 = A3($ohanhi$keyboard$Keyboard$updateWithKeyChange, $ohanhi$keyboard$Keyboard$anyKeyOriginal, keyMsg, model.pressedKeys);
								var pressedKeys = _v62.a;
								var maybeKeyChange = _v62.b;
								var newModel = _Utils_update(
									model,
									{pressedKeys: pressedKeys});
								if (_Utils_eq(model.editing, $elm$core$Maybe$Nothing)) {
									var locations = A2(
										$elm$core$Maybe$withDefault,
										$author$project$Common$PaginationSimple$empty,
										$author$project$RemoteData$currentData(model.locations));
									_v63$2:
									while (true) {
										if ((maybeKeyChange.$ === 'Just') && (maybeKeyChange.a.$ === 'KeyUp')) {
											switch (maybeKeyChange.a.a.$) {
												case 'ArrowRight':
													var _v64 = maybeKeyChange.a.a;
													var count = $elm$core$Array$length(locations.keys);
													return _Utils_eq(locations.currentPage + 1, count) ? _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none) : A2(
														$author$project$VerifyLocations$Resolver$Update$update,
														$author$project$VerifyLocations$Resolver$Update$OnPageChange(locations.currentPage + 1),
														newModel);
												case 'ArrowLeft':
													var _v65 = maybeKeyChange.a.a;
													return (!locations.currentPage) ? _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none) : A2(
														$author$project$VerifyLocations$Resolver$Update$update,
														$author$project$VerifyLocations$Resolver$Update$OnPageChange(locations.currentPage - 1),
														newModel);
												default:
													break _v63$2;
											}
										} else {
											break _v63$2;
										}
									}
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
								} else {
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
								}
							},
							$author$project$RemoteData$currentData(model.locations)));
				case 'LocationDetailsEditorOpen':
					var field = msg.a;
					var editor = msg.b;
					var location = msg.c;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (editorModel) {
							return _Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(
										_Utils_Tuple2(field, editorModel))
								});
						},
						$elm$core$Platform$Cmd$map(
							$author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorMsg(location.id)),
						A7(
							$author$project$Location$Details$Editor$init,
							location.networkCategories,
							$elm$time$Time$millisToPosix(0),
							location,
							{
								locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
								language: $author$project$PinMeTo$Ui$I18n$Language$En,
								siteName: $author$project$Data$SiteName$SiteName(model.siteName),
								analytics: $author$project$PinMeToPage$defaultAnalytics,
								translations: model.translations
							},
							false,
							_List_Nil,
							editor));
				case 'LocationDetailsEditorClose':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editor: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'LocationDetailsEditorMsg':
					var locationId = msg.a;
					var msg_ = msg.b;
					var _v66 = model.editor;
					if (_v66.$ === 'Just') {
						var _v67 = _v66.a;
						var field = _v67.a;
						var editor = _v67.b;
						var updateCommandLdpSpecialOpenHours = A4(
							$author$project$Location$Details$Commands$sendToOverwriteSpecialOpenHours,
							$author$project$Data$SiteName$SiteName(model.siteName),
							locationId,
							{allowPtvTwoWay: false, appleCustomName: false, allowMediaReview: false, googleCustomName: false, facebookCustomName: false, allowCustomStoreName: false},
							$elm$core$Maybe$Nothing);
						var _v68 = A4(
							$author$project$Location$Details$Editor$update,
							{
								tagger: $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorMsg(locationId),
								siteName: $author$project$Data$SiteName$SiteName(model.siteName),
								onUpdated: $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorUpdated(field),
								onScheduled: $elm$core$Maybe$Nothing,
								deleteCommand: A2(
									$author$project$Location$Details$Commands$deleteScheduleUpdate,
									$author$project$Data$SiteName$SiteName(model.siteName),
									locationId),
								updateCommand: A4(
									$author$project$Location$Details$Commands$sendToPartialUpdate_,
									$author$project$Data$SiteName$SiteName(model.siteName),
									locationId,
									$author$project$Data$Account$emptyFeatures,
									$elm$core$Maybe$Nothing),
								scheduleCommand: A3(
									$author$project$Location$Details$Commands$sendToScheduleUpdate_,
									$author$project$Data$SiteName$SiteName(model.siteName),
									$elm$core$Maybe$Nothing,
									locationId),
								onDeleteSchedule: $elm$core$Maybe$Nothing,
								saveGoogleAttributes: F2(
									function (_v69, _v70) {
										return $elm$core$Platform$Cmd$none;
									}),
								saveGoogleSocialLinks: F2(
									function (_v71, _v72) {
										return $elm$core$Platform$Cmd$none;
									}),
								onScheduleUpdatesRefreshed: $elm$core$Maybe$Nothing,
								onUpdatedLdpSpecialOpenHours: $author$project$VerifyLocations$Resolver$Update$LdpSpecialOpenHoursUpdated(field),
								onUpdatedSideBarSpecialOpenHours: $author$project$VerifyLocations$Resolver$Update$SideBarSpecialOpenHoursUpdated,
								updateCommandLdpSpecialOpenHours: $elm$core$Maybe$Just(updateCommandLdpSpecialOpenHours),
								updateCommandSideBarSpecialOpenHours: $elm$core$Maybe$Nothing
							},
							{language: $author$project$PinMeTo$Ui$I18n$Language$En, translations: model.translations},
							msg_,
							editor);
						var state = _v68.a;
						var cmd = _v68.b;
						var _v73 = editor;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(
										_Utils_Tuple2(field, state))
								}),
							cmd);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'SideBarSpecialOpenHoursUpdated':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editor: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'LdpSpecialOpenHoursUpdated':
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 'LocationDetailsEditorUpdated':
					var field = msg.a;
					var newLocationData = msg.b;
					var currentLocationItem = A2(
						$elm$core$Maybe$andThen,
						$author$project$Common$PaginationSimple$currentItem,
						$author$project$RemoteData$currentData(model.locations));
					if (currentLocationItem.$ === 'Just') {
						var locationItem = currentLocationItem.a;
						var updatedLocation = function () {
							if (field.$ === 'Address') {
								var typeChanged = !_Utils_eq(newLocationData.locationType, locationItem.locationType);
								return _Utils_update(
									locationItem,
									{
										address: newLocationData.address,
										locationType: newLocationData.locationType,
										serviceAreas: A2($author$project$VerifyLocations$Resolver$Update$serviceAreasFromLocationData, locationItem.serviceAreas, newLocationData.serviceAreas),
										verificationState: typeChanged ? $author$project$VerifyLocations$Resolver$Update$defaultVerificationState(newLocationData.locationType) : locationItem.verificationState
									});
							} else {
								return _Utils_update(
									locationItem,
									{coordinates: newLocationData.location});
							}
						}();
						return _Utils_Tuple2(
							A4(
								$author$project$VerifyLocations$Resolver$Model$selectFieldInLocation,
								field,
								newLocationData.id,
								$author$project$VerifyLocations$Resolver$Data$Source$Master,
								_Utils_update(
									model,
									{
										editor: $elm$core$Maybe$Nothing,
										editing: $elm$core$Maybe$Nothing,
										locations: A2(
											$author$project$RemoteData$map,
											A2(
												$author$project$Common$PaginationSimple$updateItem,
												newLocationData.id,
												$elm$core$Basics$always(updatedLocation)),
											model.locations)
									})),
							A3(
								$author$project$VerifyLocations$Resolver$Commands$getGeoLookup,
								updatedLocation,
								model.siteName,
								$author$project$VerifyLocations$Resolver$Update$GeoLookupResponse(newLocationData.id)));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'ToggleNeedsReview':
					var locationId = msg.a;
					var needsReview = msg.b;
					return _Utils_Tuple2(
						model,
						A4(
							$author$project$VerifyLocations$Resolver$Commands$setNeedsReview,
							model.siteName,
							locationId,
							needsReview,
							$author$project$VerifyLocations$Resolver$Update$NeedsReviewResponse(locationId)));
				case 'NeedsReviewResponse':
					var locationId = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						var needsReview = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locations: A2(
										$author$project$RemoteData$map,
										A2(
											$author$project$Common$PaginationSimple$updateItem,
											locationId,
											function (x) {
												return _Utils_update(
													x,
													{needsReview: needsReview});
											}),
										model.locations)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$log(
								{
									data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
									context: 'VerifyLocations.Resolver.Update',
									message: 'Failed to request or decode needsReview response'
								}));
					}
				default:
					var tooltipMsg = msg.a;
					var _v77 = A3($author$project$PinMeTo$Ui$AdvancedTooltip$update, $author$project$VerifyLocations$Resolver$Update$TooltipMsg, tooltipMsg, model.tooltipState);
					var newTooltipState = _v77.a;
					var cmd = _v77.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{tooltipState: newTooltipState}),
						cmd);
			}
		}
	});
var $author$project$VerifyLocations$Resolver$Update$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$VerifyLocations$Resolver$Main$init = function (flags) {
	return A2(
		$author$project$VerifyLocations$Resolver$Update$update,
		$author$project$VerifyLocations$Resolver$Update$HandleFlags(flags),
		$author$project$VerifyLocations$Resolver$Model$init);
};
var $author$project$Translations$Listings$VerifyLocations$verificationDone = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.verification_done');
};
var $author$project$VerifyLocations$Resolver$NoContent$view = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-empty-state pmt-verify-location-done')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-verify-location-done__message')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fa-regular fa-check-circle fa-5x'),
								A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$VerifyLocations$verificationDone(translations))
					]))
			]));
};
var $author$project$PinMeTo$Ui$Btn$FASolid = function (a) {
	return {$: 'FASolid', a: a};
};
var $author$project$PinMeTo$Ui$Form$Input$withFocus = F2(
	function (id, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					id: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Form$Input$Id(id))
				}));
	});
var $author$project$Translations$Listings$VerifyLocations$suggestions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.suggestions');
};
var $author$project$Translations$Listings$VerifyLocations$importedData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.imported_data');
};
var $author$project$Translations$Listings$VerifyLocations$twoHoursAway = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.two_hours_away');
};
var $author$project$VerifyLocations$Resolver$Update$AddServiceArea = function (a) {
	return {$: 'AddServiceArea', a: a};
};
var $author$project$Translations$Listings$VerifyLocations$addServiceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.add_service_area');
};
var $author$project$FontAwesome$Solid$Icon$faShieldHalved = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-shield-halved');
var $author$project$VerifyLocations$Resolver$View$ServiceAreaView$suggestionView = function (suggestion) {
	var _v0 = $author$project$Data$ServiceArea$splitSuggestion(suggestion);
	var firstItem = _v0.a;
	var tailItems = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verify-service-areas__details verify-service-areas__details--bold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(firstItem)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verify-service-areas__details')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(tailItems)
					]))
			]));
};
var $author$project$Translations$Listings$VerifyLocations$selectSuggested = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.select_suggested');
};
var $author$project$Translations$Listings$LocationDetail$serviceAreaError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.service_area_error');
};
var $author$project$Translations$Listings$VerifyLocations$serviceAreaSearch = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.service_area_search');
};
var $author$project$VerifyLocations$Resolver$Update$ConfirmServiceArea = F2(
	function (a, b) {
		return {$: 'ConfirmServiceArea', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Update$VerifyServiceAreas = F2(
	function (a, b) {
		return {$: 'VerifyServiceAreas', a: a, b: b};
	});
var $author$project$Translations$Listings$VerifyLocations$verifyServiceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.verify_service_areas');
};
var $author$project$Translations$Listings$VerifyLocations$confirmServiceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.confirm_service_areas');
};
var $author$project$VerifyLocations$Resolver$Update$RemoveServiceArea = F2(
	function (a, b) {
		return {$: 'RemoveServiceArea', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$View$ServiceAreaView$renderServiceAreaRows = F3(
	function (model, locationId, serviceAreas) {
		var activeAreaPlaceId = function () {
			var _v3 = model.activeServiceArea;
			if (_v3.$ === 'ActiveExisting') {
				var placeId = _v3.a.placeId;
				return placeId;
			} else {
				return $author$project$VerifyLocations$Resolver$Model$addAreaId;
			}
		}();
		return A2(
			$elm$core$List$map,
			function (area) {
				var checkMark = function () {
					var exclamation = A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verify-service-areas__exclamation-icon fa-solid fa-circle-exclamation')
							]),
						_List_Nil);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('verify-service-areas__icon-container')
							]),
						_List_fromArray(
							[
								function () {
								if (area.$ === 'ExistingArea') {
									var verified = area.a.verified;
									return verified ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('verify-service-areas__check-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('verify-service-areas__check-icon fa-solid fa-check')
													]),
												_List_Nil)
											])) : exclamation;
								} else {
									return exclamation;
								}
							}()
							]));
				}();
				var renderRow = F3(
					function (placeId, verified, msg_) {
						var verfiedBool = A2($elm$core$Maybe$withDefault, false, verified);
						var pId = A2($elm$core$Maybe$withDefault, $author$project$VerifyLocations$Resolver$Model$addAreaId, placeId);
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verify-service-areas__row'),
									$elm$html$Html$Attributes$id(pId),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'verify-service-areas__row--selected',
											_Utils_eq(activeAreaPlaceId, pId)),
											_Utils_Tuple2('verify-service-areas__row--no-hover', verfiedBool)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verify-service-areas__service-area'),
											$elm$html$Html$Events$onClick(
											verfiedBool ? $author$project$VerifyLocations$Resolver$Update$NoOp : $author$project$VerifyLocations$Resolver$Update$ActivateServiceArea(area))
										]),
									_List_fromArray(
										[
											checkMark,
											function () {
											if (area.$ === 'ExistingArea') {
												var sa = area.a;
												return $author$project$VerifyLocations$Resolver$View$ServiceAreaView$suggestionView(
													$author$project$Data$ServiceArea$serviceAreaToSuggestion(sa.serviceArea));
											} else {
												return $elm$html$Html$text('');
											}
										}()
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verify-service-areas__delete-row'),
											$elm$html$Html$Events$onClick(msg_)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__delete-row--icon fa-solid fa-xmark')
												]),
											_List_Nil)
										]))
								]));
					});
				if (area.$ === 'ExistingArea') {
					var sa = area.a;
					return A3(
						renderRow,
						$elm$core$Maybe$Just(sa.serviceArea.placeId),
						$elm$core$Maybe$Just(sa.verified),
						A2(
							$author$project$VerifyLocations$Resolver$Update$RemoveServiceArea,
							locationId,
							$author$project$VerifyLocations$Resolver$Commands$ExistingArea(sa)));
				} else {
					return A3(
						renderRow,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Nothing,
						A2($author$project$VerifyLocations$Resolver$Update$RemoveServiceArea, locationId, $author$project$VerifyLocations$Resolver$Commands$AddedArea));
				}
			},
			serviceAreas);
	});
var $author$project$Translations$Listings$VerifyLocations$searchForServiceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.search_for_service_areas');
};
var $author$project$VerifyLocations$Resolver$Update$ConfirmAllServiceAreas = function (a) {
	return {$: 'ConfirmAllServiceAreas', a: a};
};
var $author$project$VerifyLocations$Resolver$View$ServiceAreaView$view = F3(
	function (model, locationId, serviceAreas) {
		var locationVerified = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			false,
			function (location) {
				return location.verified;
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Common$PaginationSimple$currentItem,
				$author$project$RemoteData$currentData(model.locations)));
		var locationError = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$VerifyLocations$Resolver$Commands$None,
			function ($) {
				return $.serviceAreaError;
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Common$PaginationSimple$currentItem,
				$author$project$RemoteData$currentData(model.locations)));
		var anyAreaIsNew = A2(
			$elm$core$List$any,
			function (area) {
				return _Utils_eq(area, $author$project$VerifyLocations$Resolver$Commands$AddedArea);
			},
			serviceAreas);
		var allVerified = A2(
			$elm$core$List$all,
			$author$project$VerifyLocations$Resolver$Commands$mapVerificationToBool(
				function ($) {
					return $.verified;
				}),
			serviceAreas);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('verify-service-areas')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verify-service-areas__container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('verify-service-areas__wrapper verify-service-areas__wrapper--left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verify-service-areas__title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$VerifyLocations$importedData(model.translations))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verify-service-areas__column-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__column verify-service-areas__column--left')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$General$serviceAreas(model.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__column verify-service-areas__column--right')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('verify-service-areas__select'),
															$elm$html$Html$Attributes$id('service-area-scroll')
														]),
													A3($author$project$VerifyLocations$Resolver$View$ServiceAreaView$renderServiceAreaRows, model, locationId, serviceAreas)),
													A4(
													$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
													$author$project$PinMeTo$Ui$Btn$Add,
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('verify-service-areas__add'),
															$elm$html$Html$Events$onClick(
															$author$project$VerifyLocations$Resolver$Update$AddServiceArea(locationId)),
															$elm$html$Html$Attributes$disabled(anyAreaIsNew || locationVerified)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$VerifyLocations$addServiceArea(model.translations))
														]))
												]))
										])),
									function () {
									if (locationError.$ === 'ServiceAreaError') {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__error-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$LocationDetail$serviceAreaError(model.translations))
														]))
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verify-service-areas__confirm')
										]),
									_List_fromArray(
										[
											locationVerified ? A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa-regular fa-check-circle fa-5x')
												]),
											_List_Nil) : A3(
											$author$project$PinMeTo$Ui$Btn$pmtBtn,
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__confirm--button'),
													$elm$html$Html$Attributes$disabled(allVerified || anyAreaIsNew),
													$elm$html$Html$Events$onClick(
													$author$project$VerifyLocations$Resolver$Update$ConfirmAllServiceAreas(locationId))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$VerifyLocations$confirmServiceAreas(model.translations))
												]))
										]))
								])),
							function () {
							if (locationVerified) {
								return $elm$html$Html$text('');
							} else {
								var serviceAreaActive = function () {
									var _v3 = model.activeServiceArea;
									if (_v3.$ === 'Deactive') {
										return false;
									} else {
										return true;
									}
								}();
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('verify-service-areas__wrapper verify-service-areas__wrapper--right')
										]),
									_List_fromArray(
										[
											function () {
											var _v1 = model.searchError;
											if (_v1.$ === 'Just') {
												var err = _v1.a;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('status-bar__message')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(err)
																]))
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}(),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$VerifyLocations$selectSuggested(model.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__input')
												]),
											_List_fromArray(
												[
													$author$project$PinMeTo$Ui$Form$Input$render(
													A2(
														$author$project$PinMeTo$Ui$Form$Input$withFocus,
														'suggestions',
														(serviceAreaActive ? $author$project$PinMeTo$Ui$Form$Input$withPlaceholder(
															$author$project$Translations$Listings$VerifyLocations$searchForServiceAreas(model.translations)) : $elm$core$Basics$identity)(
															A2(
																$author$project$PinMeTo$Ui$Form$Input$withDisabled,
																!serviceAreaActive,
																A2(
																	$author$project$PinMeTo$Ui$Form$Input$withLabel,
																	$author$project$Translations$Listings$VerifyLocations$serviceAreaSearch(model.translations),
																	$author$project$PinMeTo$Ui$Form$Input$text(
																		{value: model.searchString, onChange: $author$project$VerifyLocations$Resolver$Update$UpdateSuggestions}))))))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('verify-service-areas__column-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('verify-service-areas__column verify-service-areas__column--left verify-service-areas__column--background-light-blue')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$VerifyLocations$suggestions(model.translations))
														])),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('verify-service-areas__column verify-service-areas__column--right verify-service-areas__column--background-white')
														]),
													A2(
														$elm$core$List$map,
														function (suggestion) {
															return A2(
																$elm$html$Html$li,
																_List_fromArray(
																	[
																		A2(
																		$elm$core$List$any,
																		function (area) {
																			return A2(
																				$author$project$VerifyLocations$Resolver$Commands$mapVerificationToBool,
																				function (_v2) {
																					var serviceArea = _v2.serviceArea;
																					return _Utils_eq(serviceArea.placeId, suggestion.placeId);
																				},
																				area);
																		},
																		serviceAreas) ? $elm$html$Html$Attributes$class('verify-service-areas__disabled') : $elm$html$Html$Events$onClick(
																		A2($author$project$VerifyLocations$Resolver$Update$ConfirmServiceArea, locationId, suggestion)),
																		$elm$html$Html$Attributes$class('verify-service-areas__row')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('verify-service-areas__service-area')
																			]),
																		_List_fromArray(
																			[
																				$author$project$VerifyLocations$Resolver$View$ServiceAreaView$suggestionView(suggestion)
																			]))
																	]));
														},
														model.suggestions))
												]))
										]));
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('verify-service-areas__verify')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
							$author$project$PinMeTo$Ui$Btn$FASolid($author$project$FontAwesome$Solid$Icon$faShieldHalved),
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2($author$project$VerifyLocations$Resolver$Update$VerifyServiceAreas, locationId, serviceAreas)),
									$elm$html$Html$Attributes$disabled((!allVerified) || locationVerified)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$VerifyLocations$verifyServiceAreas(model.translations))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('note verify-service-areas__note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$VerifyLocations$twoHoursAway(model.translations))
						]))
				]));
	});
var $author$project$VerifyLocations$Resolver$View$locationDescriptorOrCustomName = F2(
	function (locationDescriptor, storefrontName) {
		var selectString = (locationDescriptor !== '') ? locationDescriptor : ((storefrontName !== '') ? storefrontName : '');
		var displayString = (selectString !== '') ? (' ( ' + (selectString + ' )')) : '';
		return displayString;
	});
var $author$project$VerifyLocations$Resolver$View$title = F4(
	function (siteName, displayName, translations, location) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-verify-location-resolver__title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$locationStoreId(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/listings/' + (siteName + ('/locations/' + location.id)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(location.storeId)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$location(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/listings/' + (siteName + ('/locations/' + location.id)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(displayName)
										])),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$VerifyLocations$Resolver$View$locationDescriptorOrCustomName, location.locationDescriptor, location.storefrontName))
										]))
								]))
						]))
				]));
	});
var $author$project$VerifyLocations$Resolver$View$wrapper = function (html) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-verify-location-resolver container')
			]),
		html);
};
var $author$project$VerifyLocations$Resolver$View$errorBanner = F2(
	function (userMessage, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset util__background--white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar__message')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$error(translations) + ': ')
										])),
									$elm$html$Html$text(userMessage)
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$VerifyLocations$errorLoading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.error_loading');
};
var $author$project$Translations$Listings$VerifyLocations$verifyLocation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.verify_location');
};
var $author$project$VerifyLocations$Resolver$Update$OnPageInputChange = function (a) {
	return {$: 'OnPageInputChange', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$OnPageInputSubmit = {$: 'OnPageInputSubmit'};
var $author$project$FontAwesome$Regular$Icon$faFlag = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-flag');
var $author$project$Translations$Listings$VerifyLocations$needsReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.needs_review');
};
var $author$project$PinMeTo$Ui$Button$withIconOnly = F2(
	function (icon_, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{icon: icon_, iconAlignment: $author$project$PinMeTo$Ui$Button$Only}));
	});
var $author$project$Translations$Listings$VerifyLocations$flagForReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.flag_for_review');
};
var $author$project$VerifyLocations$Resolver$Update$ToggleNeedsReview = F2(
	function (a, b) {
		return {$: 'ToggleNeedsReview', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$View$needsReviewButton = F2(
	function (model, location) {
		var tooltipConfig = location.needsReview ? $author$project$PinMeTo$Ui$AdvancedTooltip$view(
			{
				uid: 'needs-review-' + location.id,
				tagger: $author$project$VerifyLocations$Resolver$Update$TooltipMsg,
				content: _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$VerifyLocations$needsReview(model.translations))
					]),
				preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
			}) : $author$project$PinMeTo$Ui$AdvancedTooltip$view(
			{
				uid: 'needs-review-' + location.id,
				tagger: $author$project$VerifyLocations$Resolver$Update$TooltipMsg,
				content: _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$VerifyLocations$flagForReview(model.translations))
					]),
				preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
			});
		var flagButton = location.needsReview ? $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withOnClick,
				A2($author$project$VerifyLocations$Resolver$Update$ToggleNeedsReview, location.id, false),
				A2(
					$author$project$PinMeTo$Ui$Button$withIconOnly,
					$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faFlag),
					A2(
						$author$project$PinMeTo$Ui$Button$withPrimaryStyle,
						$author$project$PinMeTo$Ui$Button$PrimaryDanger,
						$author$project$PinMeTo$Ui$Button$buttonPrimary(''))))) : $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withOnClick,
				A2($author$project$VerifyLocations$Resolver$Update$ToggleNeedsReview, location.id, true),
				A2(
					$author$project$PinMeTo$Ui$Button$withIconOnly,
					$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faFlag),
					A2(
						$author$project$PinMeTo$Ui$Button$withGhostStyle,
						$author$project$PinMeTo$Ui$Button$GhostDanger,
						$author$project$PinMeTo$Ui$Button$buttonGhost('')))));
		return A5(
			$author$project$PinMeTo$Ui$AdvancedTooltip$render,
			model.tooltipState,
			tooltipConfig,
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[flagButton]));
	});
var $author$project$VerifyLocations$Resolver$View$getVerifyLocationError = F2(
	function (model, location) {
		var _v0 = A2($elm$core$Dict$get, location.id, model.verifyLocationErrors);
		if (_v0.$ === 'Nothing') {
			return $elm$html$Html$text('');
		} else {
			var errorMessage = _v0.a.errorMessage;
			var userMessage = _v0.a.userMessage;
			return A2($author$project$VerifyLocations$Resolver$View$errorBanner, userMessage + (' ' + errorMessage), model.translations);
		}
	});
var $author$project$VerifyLocations$Resolver$Model$isSelected = F4(
	function (field, locationId, source, selections) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					switch (field.$) {
						case 'Address':
							return _Utils_eq(
								x.address,
								$elm$core$Maybe$Just(source));
						case 'Location':
							return _Utils_eq(
								x.location,
								$elm$core$Maybe$Just(source));
						default:
							return false;
					}
				},
				A2($elm$core$Dict$get, locationId, selections)));
	});
var $author$project$VerifyLocations$Resolver$Commands$toLocationData = function (location) {
	var existingServiceAreas = A2(
		$elm$core$List$filterMap,
		function (area) {
			if (area.$ === 'ExistingArea') {
				var serviceArea = area.a.serviceArea;
				return $elm$core$Maybe$Just(serviceArea);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		location.serviceAreas);
	return {
		id: location.id,
		ptv: $elm$core$Maybe$Nothing,
		bing: $elm$core$Maybe$Nothing,
		name: '',
		about: $author$project$Data$Location$ShortDescription(''),
		apple: $elm$core$Maybe$Nothing,
		email: $author$project$Data$Location$Email(''),
		phone: $author$project$Data$Location$Phone(''),
		google: $elm$core$Maybe$Nothing,
		address: location.address,
		storeId: $author$project$Data$Location$StoreId(location.storeId),
		facebook: $elm$core$Maybe$Nothing,
		homepage: $author$project$Data$Location$Homepage(''),
		isActive: $author$project$Data$Location$Active,
		location: location.coordinates,
		wifiSsId: $author$project$Data$Location$WifiSsId(''),
		fbStoreId: $author$project$Data$Location$FacebookStoreId(
			$elm$core$Maybe$Just('')),
		openHours: $author$project$Data$Location$OpenHours$Always,
		customData: $elm$core$Maybe$Nothing,
		actionLinks: _List_Nil,
		openingDate: '',
		locationType: location.locationType,
		networkMedia: {
			google: {coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing},
			facebook: {coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing}
		},
		networkNames: {ptv: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing},
		serviceAreas: $elm$core$List$isEmpty(existingServiceAreas) ? $author$project$Data$ServiceArea$None : $author$project$Data$ServiceArea$WithPlaceId(existingServiceAreas),
		verification: $elm$core$Maybe$Just(
			{serviceAreas: $author$project$Data$Location$Unverified, addressAndCoordinates: $author$project$Data$Location$Unverified}),
		storefrontName: $author$project$Data$Location$StorefrontName(''),
		longDescription: $author$project$Data$Location$LongDescription(''),
		specialOpenHours: _List_Nil,
		networkAttributes: {google: _List_Nil},
		networkCategories: {bing: $elm$core$Maybe$Nothing, here: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, tomtom: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, overture: $elm$core$Maybe$Nothing, foursquare: $elm$core$Maybe$Nothing},
		permanentlyClosed: false,
		locationDescriptor: $author$project$Data$Location$LocationDescriptor(location.locationDescriptor),
		networkServiceItems: {google: _List_Nil},
		newGoogleReviewLink: $author$project$Data$Location$NewReviewUrl(''),
		alternativeSearchNames: $author$project$Data$Location$AlternativeSearchNames(_List_Nil),
		temporarilyClosedUntil: $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
		temporarilyClosedMessage: $author$project$Data$Location$TemporarilyClosedMessage(''),
		hasTransitionedToNewPageExperience: false
	};
};
var $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorOpen = F3(
	function (a, b, c) {
		return {$: 'LocationDetailsEditorOpen', a: a, b: b, c: c};
	});
var $author$project$VerifyLocations$Resolver$View$AddressView$masterData = F2(
	function (location, translations) {
		return $author$project$Common$AddressEditor$view(
			A2(
				$author$project$Common$AddressEditor$withOnClick,
				A3(
					$author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorOpen,
					$author$project$Data$Location$Field$Address,
					$author$project$Location$Details$Editor$AddressEditor,
					$author$project$VerifyLocations$Resolver$Commands$toLocationData(location)),
				A2($author$project$Common$AddressEditor$withAddress, location.address, translations)));
	});
var $author$project$Data$Address$Country = function (a) {
	return {$: 'Country', a: a};
};
var $author$project$Translations$Listings$VerifyLocations$errorGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.error_google');
};
var $author$project$Common$AddressEditor$withOnUseThisMsgs = F2(
	function (onUseThisMsgs, config) {
		return _Utils_update(
			config,
			{
				onUseThisMsgs: $elm$core$Maybe$Just(onUseThisMsgs)
			});
	});
var $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData = function (a) {
	return {$: 'UseThisGeoLookupData', a: a};
};
var $author$project$VerifyLocations$Resolver$View$AddressView$geoLookupData = F2(
	function (geoLookup, translations) {
		switch (geoLookup.$) {
			case 'Loaded':
				var lookup = geoLookup.a;
				var _v1 = lookup.address;
				if (_v1.$ === 'Ok') {
					var address = _v1.a;
					return $author$project$Common$AddressEditor$view(
						A2(
							$author$project$Common$AddressEditor$withOnUseThisMsgs,
							{
								zip: A2($elm$core$Basics$composeR, $author$project$Data$Address$Zip, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData),
								city: A2($elm$core$Basics$composeR, $author$project$Data$Address$City, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData),
								state: A2($elm$core$Basics$composeR, $author$project$Data$Address$State, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData),
								street: A2($elm$core$Basics$composeR, $author$project$Data$Address$Street, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData),
								country: A2($elm$core$Basics$composeR, $author$project$Data$Address$Country, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData),
								district: A2($elm$core$Basics$composeR, $author$project$Data$Address$District, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData),
								province: A2($elm$core$Basics$composeR, $author$project$Data$Address$Province, $author$project$VerifyLocations$Resolver$Update$UseThisGeoLookupData)
							},
							A2(
								$author$project$Common$AddressEditor$withAddressConflicts,
								lookup.conflicts.address,
								A2($author$project$Common$AddressEditor$withAddress, address, translations))));
				} else {
					var err = _v1.a;
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(err)
							]));
				}
			case 'Error':
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$VerifyLocations$errorGoogle(translations))
						]));
			case 'Suspended':
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			default:
				return $author$project$PinMeTo$Ui$Spinner$spinner;
		}
	});
var $author$project$Conflicts$FieldEditor$FieldEditor$withCtaDisabled = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				cta: A2(
					$elm$core$Maybe$map,
					function (cta_) {
						return _Utils_update(
							cta_,
							{disabled: x});
					},
					config.cta)
			});
	});
var $author$project$VerifyLocations$Resolver$Update$SelectMasterData = F2(
	function (a, b) {
		return {$: 'SelectMasterData', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$Update$SelectGeoLookupData = F2(
	function (a, b) {
		return {$: 'SelectGeoLookupData', a: a, b: b};
	});
var $author$project$VerifyLocations$Resolver$View$AddressView$view = F5(
	function (isEditing, selections, location, geoLookup, translations) {
		return A2(
			$author$project$PinMeTo$Ui$Layout$Grid$render,
			$author$project$PinMeTo$Ui$Layout$Grid$flex,
			_List_fromArray(
				[
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
						location.verified,
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
							isEditing || A4($author$project$VerifyLocations$Resolver$Model$isSelected, $author$project$Data$Location$Field$Address, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Master, selections),
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
								{
									msg: A2($author$project$VerifyLocations$Resolver$Update$SelectMasterData, $author$project$Data$Location$Field$Address, location.id),
									title: $author$project$Translations$General$resolverUseThis(translations)
								},
								$author$project$Conflicts$FieldEditor$FieldEditor$view(
									{
										data: A2($author$project$VerifyLocations$Resolver$View$AddressView$masterData, location, translations),
										title: $author$project$Translations$General$locationAddress(translations)
									}))))),
					(!location.verified) ? $author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
						(!isEditing) && A4($author$project$VerifyLocations$Resolver$Model$isSelected, $author$project$Data$Location$Field$Address, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Geo, selections),
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$withCtaDisabled,
							_Utils_eq(
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$Result$toMaybe,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.address;
										},
										$author$project$RemoteData$currentData(geoLookup))),
								$elm$core$Maybe$Nothing),
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
								{
									msg: A2($author$project$VerifyLocations$Resolver$Update$SelectGeoLookupData, $author$project$Data$Location$Field$Address, location.id),
									title: $author$project$Translations$General$resolverUseThis(translations)
								},
								A2(
									$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName,
									'Google',
									$author$project$Conflicts$FieldEditor$FieldEditor$view(
										{
											data: A2($author$project$VerifyLocations$Resolver$View$AddressView$geoLookupData, geoLookup, translations),
											title: $author$project$Translations$General$locationAddress(translations)
										})))))) : $elm$html$Html$text('')
				]));
	});
var $author$project$VerifyLocations$Resolver$View$LocationView$masterData = F2(
	function (location, translations) {
		return $author$project$Conflicts$FieldEditor$Data$render(
			A2(
				$author$project$Conflicts$FieldEditor$Data$withOnClick,
				A3(
					$author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorOpen,
					$author$project$Data$Location$Field$Location,
					$author$project$Location$Details$Editor$CoordinatesEditor,
					$author$project$VerifyLocations$Resolver$Commands$toLocationData(location)),
				$author$project$Conflicts$FieldEditor$Data$view(
					_List_fromArray(
						[
							A2(
							$author$project$Conflicts$FieldEditor$Data$row,
							$author$project$Translations$General$locationLatitude(translations),
							$elm$core$String$fromFloat(location.coordinates.lat)),
							A2(
							$author$project$Conflicts$FieldEditor$Data$row,
							$author$project$Translations$General$locationLongitude(translations),
							$elm$core$String$fromFloat(location.coordinates.lon))
						]))));
	});
var $author$project$Translations$Listings$Conflicts$distance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.distance');
};
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $elm$core$Basics$atan2 = _Basics_atan2;
var $elm$core$Basics$pi = _Basics_pi;
var $author$project$Common$Math$toRadians = function (value) {
	return (value * $elm$core$Basics$pi) / 180;
};
var $author$project$Common$Math$calculateDistance = F4(
	function (lat1, lon1, lat2, lon2) {
		var dLon = $author$project$Common$Math$toRadians(lon2 - lon1);
		var dLat = $author$project$Common$Math$toRadians(lat2 - lat1);
		var r = 6371;
		var a = ($elm$core$Basics$sin(dLat / 2) * $elm$core$Basics$sin(dLat / 2)) + ((($elm$core$Basics$cos(
			$author$project$Common$Math$toRadians(lat1)) * $elm$core$Basics$cos(
			$author$project$Common$Math$toRadians(lat2))) * $elm$core$Basics$sin(dLon / 2)) * $elm$core$Basics$sin(dLon / 2));
		var sqa = $elm$core$Basics$sqrt(a);
		var sqma = $elm$core$Basics$sqrt(1 - a);
		var c = 2 * A2($elm$core$Basics$atan2, sqa, sqma);
		var d = r * c;
		return $elm$core$String$fromInt(
			$elm$core$Basics$round(d * 1000));
	});
var $author$project$VerifyLocations$Resolver$View$LocationView$geoLookupData = F3(
	function (geoLookup, translations, masterLocation) {
		switch (geoLookup.$) {
			case 'Loaded':
				var lookup = geoLookup.a;
				var _v1 = lookup.coordinates;
				if (_v1.$ === 'Ok') {
					var coordinates = _v1.a;
					return $author$project$Conflicts$FieldEditor$Data$render(
						$author$project$Conflicts$FieldEditor$Data$view(
							_List_fromArray(
								[
									A2(
									$author$project$Conflicts$FieldEditor$Data$withConflict,
									lookup.conflicts.location,
									A2(
										$author$project$Conflicts$FieldEditor$Data$row,
										$author$project$Translations$General$locationLatitude(translations),
										$elm$core$String$fromFloat(coordinates.lat))),
									A2(
									$author$project$Conflicts$FieldEditor$Data$withConflict,
									lookup.conflicts.location,
									A2(
										$author$project$Conflicts$FieldEditor$Data$row,
										$author$project$Translations$General$locationLongitude(translations),
										$elm$core$String$fromFloat(coordinates.lon))),
									A2(
									$author$project$Conflicts$FieldEditor$Data$row,
									$author$project$Translations$Listings$Conflicts$distance(translations),
									A4($author$project$Common$Math$calculateDistance, coordinates.lat, coordinates.lon, masterLocation.coordinates.lat, masterLocation.coordinates.lon) + ' m')
								])));
				} else {
					var err = _v1.a;
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(err)
							]));
				}
			case 'Error':
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$VerifyLocations$errorGoogle(translations))
						]));
			case 'Suspended':
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			default:
				return $author$project$PinMeTo$Ui$Spinner$spinner;
		}
	});
var $author$project$VerifyLocations$Resolver$View$LocationView$view = F5(
	function (isEditing, selections, location, geoLookup, translations) {
		return A2(
			$author$project$PinMeTo$Ui$Layout$Grid$render,
			$author$project$PinMeTo$Ui$Layout$Grid$flex,
			_List_fromArray(
				[
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
						location.verified,
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
							isEditing || A4($author$project$VerifyLocations$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Master, selections),
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
								{
									msg: A2($author$project$VerifyLocations$Resolver$Update$SelectMasterData, $author$project$Data$Location$Field$Location, location.id),
									title: $author$project$Translations$General$resolverUseThis(translations)
								},
								$author$project$Conflicts$FieldEditor$FieldEditor$view(
									{
										data: A2($author$project$VerifyLocations$Resolver$View$LocationView$masterData, location, translations),
										title: $author$project$Translations$General$location(translations)
									}))))),
					(!location.verified) ? $author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
						(!isEditing) && A4($author$project$VerifyLocations$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Geo, selections),
						A2(
							$author$project$Conflicts$FieldEditor$FieldEditor$withCtaDisabled,
							_Utils_eq(
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$Result$toMaybe,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.coordinates;
										},
										$author$project$RemoteData$currentData(geoLookup))),
								$elm$core$Maybe$Nothing),
							A2(
								$author$project$Conflicts$FieldEditor$FieldEditor$withCta,
								{
									msg: A2($author$project$VerifyLocations$Resolver$Update$SelectGeoLookupData, $author$project$Data$Location$Field$Location, location.id),
									title: $author$project$Translations$General$resolverUseThis(translations)
								},
								A2(
									$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName,
									'Google',
									$author$project$Conflicts$FieldEditor$FieldEditor$view(
										{
											data: A3($author$project$VerifyLocations$Resolver$View$LocationView$geoLookupData, geoLookup, translations, location),
											title: $author$project$Translations$General$location(translations)
										})))))) : $elm$html$Html$text('')
				]));
	});
var $author$project$VerifyLocations$Resolver$View$ConflictView$isEditing = F3(
	function (field, id, editing) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					return _Utils_eq(x.field, field) && _Utils_eq(x.locationId, id);
				},
				editing));
	});
var $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorClose = {$: 'LocationDetailsEditorClose'};
var $author$project$VerifyLocations$Resolver$View$ConflictView$editorView = F3(
	function (editorState, location, translations) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var editor = _v0.b;
					return A4(
						$author$project$Location$Details$Editor$view,
						{
							tagger: $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorMsg(location.id),
							onCancel: $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorClose,
							onSubmit: $author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorClose,
							withScheduling: false
						},
						{user: $author$project$Data$User$emptyUser, locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, language: $author$project$PinMeTo$Ui$I18n$Language$En, translations: translations},
						$elm$core$Maybe$Nothing,
						editor);
				},
				editorState));
	});
var $author$project$VerifyLocations$Resolver$Update$VerifyLocation = function (a) {
	return {$: 'VerifyLocation', a: a};
};
var $author$project$Translations$Listings$VerifyLocations$verifyAddressBtn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.verify_address_btn');
};
var $author$project$VerifyLocations$Resolver$Model$isSelectionComplete = F2(
	function (locationId, selections) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (x) {
					return (!_Utils_eq(x.address, $elm$core$Maybe$Nothing)) && (!_Utils_eq(x.location, $elm$core$Maybe$Nothing));
				},
				A2($elm$core$Dict$get, locationId, selections)));
	});
var $author$project$VerifyLocations$Resolver$View$ConflictView$view = F3(
	function (model, location, geoLookup) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$VerifyLocations$Resolver$View$AddressView$view,
					A3($author$project$VerifyLocations$Resolver$View$ConflictView$isEditing, $author$project$Data$Location$Field$Address, location.id, model.editing),
					model.selected,
					location,
					geoLookup,
					model.translations),
					A5(
					$author$project$VerifyLocations$Resolver$View$LocationView$view,
					A3($author$project$VerifyLocations$Resolver$View$ConflictView$isEditing, $author$project$Data$Location$Field$Location, location.id, model.editing),
					model.selected,
					location,
					geoLookup,
					model.translations),
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(
							(!A2($author$project$VerifyLocations$Resolver$Model$isSelectionComplete, location.id, model.selected)) || location.verified),
							$elm$html$Html$Events$onClick(
							$author$project$VerifyLocations$Resolver$Update$VerifyLocation(location)),
							$elm$html$Html$Attributes$class('pmt-verify-location__publish-button')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa-solid fa-shield-alt space-right'),
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
								]),
							_List_Nil),
							$elm$html$Html$text(
							$author$project$Translations$Listings$VerifyLocations$verifyAddressBtn(model.translations))
						])),
					A3($author$project$VerifyLocations$Resolver$View$ConflictView$editorView, model.editor, location, model.translations)
				]));
	});
var $author$project$VerifyLocations$Resolver$Data$Source$toString = function (x) {
	if (x.$ === 'Master') {
		return 'master';
	} else {
		return 'geo';
	}
};
var $author$project$PinMeTo$Ui$Map$GoogleMarker = {$: 'GoogleMarker'};
var $author$project$VerifyLocations$Resolver$Model$getGeoLookup = F2(
	function (locationId, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$RemoteData$Suspended,
			A2($elm$core$Dict$get, locationId, model.geoLookups));
	});
var $author$project$PinMeTo$Ui$Btn$ExternalLink = {$: 'ExternalLink'};
var $author$project$Translations$Listings$VerifyLocations$viewExternal = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.view_external');
};
var $author$project$VerifyLocations$Resolver$View$externalMapLink = F3(
	function (coordinates, geoLookup, translations) {
		var link = function (label) {
			if (geoLookup.$ === 'Just') {
				var geoLookupCoordinates = geoLookup.a;
				var url = A2(
					$elm$core$String$join,
					'',
					_List_fromArray(
						[
							'https://www.google.com/maps/dir/?api=1&origin=',
							$elm$core$String$fromFloat(coordinates.lat),
							',',
							$elm$core$String$fromFloat(coordinates.lon),
							'&destination=',
							$elm$core$String$fromFloat(geoLookupCoordinates.lat),
							',',
							$elm$core$String$fromFloat(geoLookupCoordinates.lon)
						]));
				return A4(
					$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
					$author$project$PinMeTo$Ui$Btn$ExternalLink,
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$href(url)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			} else {
				return A4(
					$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
					$author$project$PinMeTo$Ui$Btn$ExternalLink,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			}
		};
		return link(
			$author$project$Translations$Listings$VerifyLocations$viewExternal(translations));
	});
var $author$project$VerifyLocations$Resolver$Update$OnMapMarkerMoved = function (a) {
	return {$: 'OnMapMarkerMoved', a: a};
};
var $author$project$Translations$Listings$VerifyLocations$helpTextMasterTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.help_text_master_two');
};
var $author$project$VerifyLocations$Resolver$Update$OnMapMarkerUseThis = function (a) {
	return {$: 'OnMapMarkerUseThis', a: a};
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$VerifyLocations$Resolver$View$getMapUrl = F3(
	function (mapView, coordinates, geoLookup) {
		var locationLatLong = $elm$core$String$fromFloat(coordinates.lat) + (',' + $elm$core$String$fromFloat(coordinates.lon));
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(mapView, geoLookup);
			if (_v1.a.$ === 'Directions') {
				if (_v1.b.$ === 'Just') {
					var _v2 = _v1.a;
					var lookup = _v1.b.a;
					return _Utils_Tuple2(
						'directions',
						'&origin=' + (locationLatLong + ('&destination=' + ($elm$core$String$fromFloat(lookup.lat) + (',' + $elm$core$String$fromFloat(lookup.lon))))));
				} else {
					var _v3 = _v1.a;
					var _v4 = _v1.b;
					return _Utils_Tuple2('place', '&q=' + locationLatLong);
				}
			} else {
				var _v5 = _v1.a;
				return _Utils_Tuple2('streetview', '&location=' + locationLatLong);
			}
		}();
		var mapType = _v0.a;
		var params = _v0.b;
		var apiKey = 'AIzaSyBAXYzMFWwyVutxO7zgbRDz5t6ogW2Lx8w';
		var url = 'https://www.google.com/maps/embed/v1/' + (mapType + ('?key=' + (apiKey + params)));
		return url;
	});
var $author$project$VerifyLocations$Resolver$Model$StreetView = {$: 'StreetView'};
var $author$project$VerifyLocations$Resolver$View$externalStreetViewMap = function (coordinates) {
	var url = A3($author$project$VerifyLocations$Resolver$View$getMapUrl, $author$project$VerifyLocations$Resolver$Model$StreetView, coordinates, $elm$core$Maybe$Nothing);
	return A2(
		$elm$html$Html$iframe,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(url),
				$elm$html$Html$Attributes$class('pmt-verify-location-resolver__content--address-map__street-view'),
				A2($elm$html$Html$Attributes$attribute, 'referrerpolicy', 'origin')
			]),
		_List_Nil);
};
var $author$project$Translations$Listings$VerifyLocations$viewExternalStreetView = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.verify_locations.view_external_street_view');
};
var $author$project$VerifyLocations$Resolver$View$externalStreetViewMapLink = F2(
	function (coordinates, translations) {
		var link = function (label) {
			var url = A2(
				$elm$core$String$join,
				'',
				_List_fromArray(
					[
						'https://www.google.com/maps?q=&layer=c&cbll=',
						$elm$core$String$fromFloat(coordinates.lat),
						',',
						$elm$core$String$fromFloat(coordinates.lon)
					]));
			return A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
				$author$project$PinMeTo$Ui$Btn$ExternalLink,
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$href(url)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]));
		};
		return link(
			$author$project$Translations$Listings$VerifyLocations$viewExternalStreetView(translations));
	});
var $author$project$VerifyLocations$Resolver$View$renderStorefrontLocation = F2(
	function (model, location) {
		var showCSView = A2($elm$core$List$member, $author$project$Data$User$CustomerSuccess, model.userRoles);
		var links = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'marginTop', '0.5rem'),
					A2($elm$html$Html$Attributes$style, 'marginBottom', '3rem')
				]),
			_List_fromArray(
				[
					A2($author$project$VerifyLocations$Resolver$View$externalStreetViewMapLink, location.coordinates, model.translations),
					A3(
					$author$project$VerifyLocations$Resolver$View$externalMapLink,
					location.coordinates,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$Result$toMaybe,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.coordinates;
							},
							$author$project$RemoteData$currentData(
								A2($author$project$VerifyLocations$Resolver$Model$getGeoLookup, location.id, model)))),
					model.translations)
				]));
		var userView = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					links,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-verify-location-resolver__note')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$VerifyLocations$helpTextMasterTwo(model.translations))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-verify-location-resolver__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-verify-location-resolver__content--address-map')
								]),
							_List_fromArray(
								[
									function () {
									var maybeGeoLookup = A2($elm$core$Dict$get, location.id, model.geoLookups);
									if (maybeGeoLookup.$ === 'Just') {
										var geoLookup = maybeGeoLookup.a;
										return $author$project$PinMeTo$Ui$Map$render(
											A2(
												$author$project$PinMeTo$Ui$Map$withOnChange,
												function (_v1) {
													return $author$project$VerifyLocations$Resolver$Update$OnMapMarkerMoved;
												},
												A2(
													$author$project$PinMeTo$Ui$Map$withZoom,
													15,
													$author$project$PinMeTo$Ui$Map$view(
														A2(
															$elm$core$List$filterMap,
															$elm$core$Basics$identity,
															_List_fromArray(
																[
																	A2(
																	$elm$core$Maybe$map,
																	function (geoLookupCoordinates) {
																		return (A4($author$project$VerifyLocations$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Geo, model.selected) ? $author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$BlueCheckMarker) : A2(
																			$elm$core$Basics$composeR,
																			$author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$GoogleMarker),
																			$author$project$PinMeTo$Ui$Map$withCustomPopover(
																				$author$project$PinMeTo$Ui$Button$render(
																					A2(
																						$author$project$PinMeTo$Ui$Button$withOnClick,
																						$author$project$VerifyLocations$Resolver$Update$OnMapMarkerUseThis($author$project$VerifyLocations$Resolver$Data$Source$Geo),
																						$author$project$PinMeTo$Ui$Button$buttonPrimary(
																							$author$project$Translations$General$resolverUseThis(model.translations)))))))(
																			A2(
																				$author$project$PinMeTo$Ui$Map$pinWithId,
																				$author$project$VerifyLocations$Resolver$Data$Source$toString($author$project$VerifyLocations$Resolver$Data$Source$Geo),
																				geoLookupCoordinates));
																	},
																	A2(
																		$elm$core$Maybe$andThen,
																		$elm$core$Result$toMaybe,
																		$author$project$RemoteData$currentData(
																			A2(
																				$author$project$RemoteData$map,
																				function ($) {
																					return $.coordinates;
																				},
																				geoLookup)))),
																	$elm$core$Maybe$Just(
																	(A4($author$project$VerifyLocations$Resolver$Model$isSelected, $author$project$Data$Location$Field$Location, location.id, $author$project$VerifyLocations$Resolver$Data$Source$Master, model.selected) ? $author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$BlueCheckMarker) : $author$project$PinMeTo$Ui$Map$withCustomPopover(
																		$author$project$PinMeTo$Ui$Button$render(
																			A2(
																				$author$project$PinMeTo$Ui$Button$withOnClick,
																				$author$project$VerifyLocations$Resolver$Update$OnMapMarkerUseThis($author$project$VerifyLocations$Resolver$Data$Source$Master),
																				$author$project$PinMeTo$Ui$Button$buttonPrimary(
																					$author$project$Translations$General$resolverUseThis(model.translations))))))(
																		A2(
																			$author$project$PinMeTo$Ui$Map$withPinDraggable,
																			true,
																			A2(
																				$author$project$PinMeTo$Ui$Map$pinWithId,
																				$author$project$VerifyLocations$Resolver$Data$Source$toString($author$project$VerifyLocations$Resolver$Data$Source$Master),
																				location.coordinates))))
																]))))));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									showCSView ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-verify-location-resolver__cs-maps')
										]),
									_List_fromArray(
										[
											$author$project$VerifyLocations$Resolver$View$externalStreetViewMap(location.coordinates)
										])) : userView
								])),
							A2($author$project$VerifyLocations$Resolver$View$getVerifyLocationError, model, location),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-verify-location-resolver__conflicts')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$VerifyLocations$Resolver$View$ConflictView$view,
									model,
									location,
									A2($author$project$VerifyLocations$Resolver$Model$getGeoLookup, location.id, model))
								]))
						])),
					showCSView ? links : A2($elm$html$Html$span, _List_Nil, _List_Nil)
				]));
	});
var $author$project$VerifyLocations$Resolver$View$view = function (model) {
	if (model.allVerified) {
		return $author$project$VerifyLocations$Resolver$View$wrapper(
			_List_fromArray(
				[
					$author$project$VerifyLocations$Resolver$NoContent$view(model.translations)
				]));
	} else {
		var _v0 = model.locations;
		switch (_v0.$) {
			case 'Loaded':
				var locations = _v0.a;
				var _v1 = $author$project$Common$PaginationSimple$currentItem(locations);
				if (_v1.$ === 'Just') {
					var location = _v1.a;
					var serviceAreaVerificationView = A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$VerifyLocations$Resolver$View$getVerifyLocationError, model, location),
								A3($author$project$VerifyLocations$Resolver$View$ServiceAreaView$view, model, location.id, location.serviceAreas)
							]));
					return $author$project$VerifyLocations$Resolver$View$wrapper(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h1-page-title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$VerifyLocations$verifyLocation(model.translations))
									])),
								A2(
								$elm$html$Html$header,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('util__stick-to-header')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$TitleBar$render(
										A2(
											$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
											true,
											A2(
												$author$project$PinMeTo$Ui$TitleBar$withAsides,
												A2(
													$elm$core$List$filterMap,
													$elm$core$Basics$identity,
													_List_fromArray(
														[
															A2($elm$core$List$member, $author$project$Data$User$CustomerSuccess, model.userRoles) ? $elm$core$Maybe$Just(
															A2($author$project$VerifyLocations$Resolver$View$needsReviewButton, model, location)) : $elm$core$Maybe$Nothing,
															$elm$core$Maybe$Just(
															A5(
																$author$project$Common$PaginationSimple$view,
																locations,
																$author$project$VerifyLocations$Resolver$Update$OnPageChange,
																$author$project$VerifyLocations$Resolver$Update$OnPageInputChange,
																$author$project$VerifyLocations$Resolver$Update$OnPageInputSubmit,
																{
																	of_: $author$project$Translations$General$ofPreposition(model.translations)
																}))
														])),
												$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(
													A4($author$project$VerifyLocations$Resolver$View$title, model.siteName, model.displayName, model.translations, location)))))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v2 = _Utils_Tuple2(location.verificationState, location.locationType);
										_v2$2:
										while (true) {
											if (_v2.a.$ === 'ServiceAreas') {
												switch (_v2.b.$) {
													case 'ServiceArea':
														var _v3 = _v2.b;
														return serviceAreaVerificationView;
													case 'StorefrontAndServiceArea':
														var _v4 = _v2.b;
														return serviceAreaVerificationView;
													default:
														break _v2$2;
												}
											} else {
												break _v2$2;
											}
										}
										return A2($author$project$VerifyLocations$Resolver$View$renderStorefrontLocation, model, location);
									}(),
										function () {
										var secondStepForPaginationDotView = A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('custom-radio__container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa-regular fa-circle background--dark-gray')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa-solid fa-circle background--dark-gray')
														]),
													_List_Nil)
												]));
										var firstStepForPaginationDotView = A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('custom-radio__container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa-solid fa-circle background--dark-gray')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa-regular fa-circle background--dark-gray')
														]),
													_List_Nil)
												]));
										var _v5 = _Utils_Tuple2(location.verificationState, location.locationType);
										_v5$4:
										while (true) {
											switch (_v5.a.$) {
												case 'ServiceAreas':
													if (!_v5.a.a) {
														switch (_v5.b.$) {
															case 'ServiceArea':
																var _v6 = _v5.b;
																return secondStepForPaginationDotView;
															case 'StorefrontAndServiceArea':
																var _v7 = _v5.b;
																return secondStepForPaginationDotView;
															default:
																break _v5$4;
														}
													} else {
														break _v5$4;
													}
												case 'AddressAndServiceAreas':
													switch (_v5.b.$) {
														case 'ServiceArea':
															var _v8 = _v5.a;
															var _v9 = _v5.b;
															return firstStepForPaginationDotView;
														case 'StorefrontAndServiceArea':
															var _v10 = _v5.a;
															var _v11 = _v5.b;
															return firstStepForPaginationDotView;
														default:
															break _v5$4;
													}
												default:
													break _v5$4;
											}
										}
										return A2($elm$html$Html$div, _List_Nil, _List_Nil);
									}()
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							]));
				} else {
					return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
				}
			case 'Loading':
				return $author$project$VerifyLocations$Resolver$View$wrapper(
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Suspended':
				return $author$project$VerifyLocations$Resolver$View$wrapper(
					_List_fromArray(
						[
							$author$project$VerifyLocations$Resolver$NoContent$view(model.translations)
						]));
			default:
				var err = _v0.a;
				var _v12 = $author$project$PinMeTo$Logger$log(
					{data: err, context: 'VerifyLocations.Resolver.View', message: 'View render failed with error'});
				return $author$project$VerifyLocations$Resolver$View$wrapper(
					_List_fromArray(
						[
							A2(
							$author$project$VerifyLocations$Resolver$View$errorBanner,
							$author$project$Translations$Listings$VerifyLocations$errorLoading(model.translations),
							model.translations)
						]));
		}
	}
};
var $author$project$VerifyLocations$Resolver$Update$KeyboardMsg = function (a) {
	return {$: 'KeyboardMsg', a: a};
};
var $author$project$VerifyLocations$Resolver$Update$OnLanguageChanged = function (a) {
	return {$: 'OnLanguageChanged', a: a};
};
var $author$project$VerifyLocations$Resolver$Main$editorSubscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (_v0, location) {
					var editorState = _v0.b;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$VerifyLocations$Resolver$Update$LocationDetailsEditorMsg(location.id),
						$author$project$Location$Details$Editor$subscriptions(editorState));
				}),
			model.editor,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Common$PaginationSimple$currentItem,
				$author$project$RemoteData$currentData(model.locations))));
};
var $author$project$VerifyLocations$Resolver$Main$passArgs_VerifyLocations_Resolver_Main = _Platform_incomingPort('passArgs_VerifyLocations_Resolver_Main', $elm$json$Json$Decode$value);
var $author$project$VerifyLocations$Resolver$Main$in_VerifyLocations_Resolver_languageChanged = _Platform_incomingPort('in_VerifyLocations_Resolver_languageChanged', $elm$json$Json$Decode$value);
var $author$project$VerifyLocations$Resolver$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$VerifyLocations$Resolver$Main$passArgs_VerifyLocations_Resolver_Main($author$project$VerifyLocations$Resolver$Update$HandleFlags),
				$author$project$VerifyLocations$Resolver$Main$in_VerifyLocations_Resolver_languageChanged(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Common$Language$translationsDecoder),
					$author$project$VerifyLocations$Resolver$Update$OnLanguageChanged)),
				A2($elm$core$Platform$Sub$map, $author$project$VerifyLocations$Resolver$Update$KeyboardMsg, $ohanhi$keyboard$Keyboard$subscriptions),
				$author$project$VerifyLocations$Resolver$Main$editorSubscriptions(model)
			]));
};
var $author$project$VerifyLocations$Resolver$Main$main = $elm$browser$Browser$element(
	{init: $author$project$VerifyLocations$Resolver$Main$init, view: $author$project$VerifyLocations$Resolver$View$view, update: $author$project$VerifyLocations$Resolver$Update$update, subscriptions: $author$project$VerifyLocations$Resolver$Main$subscriptions});
var $author$project$Location$Bing$Categories$Model$StoreId = function (a) {
	return {$: 'StoreId', a: a};
};
var $author$project$Location$Bing$Categories$Model$init = {
	site: {
		name: $author$project$Data$SiteName$SiteName(''),
		displayName: ''
	},
	error: $elm$core$Maybe$Nothing,
	storeId: $author$project$Location$Bing$Categories$Model$StoreId(''),
	categories: $author$project$RemoteData$Suspended,
	translations: $author$project$Common$Language$initialTranslationsFallback,
	selectBoxState: $author$project$PinMeTo$Ui$Select$init,
	selectedCategories: {categories: _List_Nil, primaryCategoryId: $elm$core$Maybe$Nothing}
};
var $author$project$Common$Bing$SelectCategoryMsg$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Location$Bing$Categories$Model$Flags = F4(
	function (site, storeId, selectedCategories, translations) {
		return {site: site, storeId: storeId, translations: translations, selectedCategories: selectedCategories};
	});
var $author$project$Location$Bing$Categories$Model$Site = F2(
	function (name, displayName) {
		return {name: name, displayName: displayName};
	});
var $author$project$Location$Bing$Categories$Model$siteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'displayName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$author$project$Util$idDecoder($author$project$Data$SiteName$SiteName),
		$elm$json$Json$Decode$succeed($author$project$Location$Bing$Categories$Model$Site)));
var $author$project$Common$Bing$Data$Categories$Category = F2(
	function (id, name) {
		return {id: id, name: name};
	});
var $author$project$Common$Bing$Data$Categories$categoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Common$Bing$Data$Categories$Category)));
var $author$project$Common$Bing$Data$Categories$SelectedCategories = F2(
	function (categories, primaryCategoryId) {
		return {categories: categories, primaryCategoryId: primaryCategoryId};
	});
var $author$project$Common$Bing$Data$Categories$selectedCategoriesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'primaryCategoryId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'categories',
		$elm$json$Json$Decode$list($author$project$Common$Bing$Data$Categories$categoryDecoder),
		$elm$json$Json$Decode$succeed($author$project$Common$Bing$Data$Categories$SelectedCategories)));
var $author$project$Location$Bing$Categories$Model$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'categories',
		$author$project$Common$Bing$Data$Categories$selectedCategoriesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'storeId',
			A2($elm$json$Json$Decode$map, $author$project$Location$Bing$Categories$Model$StoreId, $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'site',
				$author$project$Location$Bing$Categories$Model$siteDecoder,
				$elm$json$Json$Decode$succeed($author$project$Location$Bing$Categories$Model$Flags)))));
var $author$project$Location$Bing$Categories$Model$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Location$Bing$Categories$Model$flagsDecoder, flags);
};
var $author$project$Translations$Listings$LocationDetail$errorLoading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.error_loading');
};
var $author$project$Location$Bing$Categories$Msg$GetCategories = function (a) {
	return {$: 'GetCategories', a: a};
};
var $author$project$Common$Bing$Data$Categories$allCategoriesDecoder = $elm$json$Json$Decode$list($author$project$Common$Bing$Data$Categories$categoryDecoder);
var $author$project$Location$Bing$Categories$Update$getCategories = F2(
	function (_v0, _v1) {
		var siteName = _v0.a;
		var storeId = _v1.a;
		var url = 'api/' + (siteName + ('/bing/categories/' + storeId));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, $author$project$Location$Bing$Categories$Msg$GetCategories, $author$project$Common$Bing$Data$Categories$allCategoriesDecoder),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Location$Bing$Categories$Msg$CategoriesViewMsg = function (a) {
	return {$: 'CategoriesViewMsg', a: a};
};
var $author$project$Common$HandleResult$httpErrorUserMessage = function (e) {
	switch (e.$) {
		case 'BadUrl':
			return 'Something went wrong. Please contact support.';
		case 'Timeout':
			return 'Could not connect to server. Please try again.';
		case 'NetworkError':
			return 'Could not connect to server. Please try again.';
		case 'BadStatus':
			var code = e.a;
			return 'Error code: ' + $elm$core$String$fromInt(code);
		default:
			var body = e.a;
			return body;
	}
};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (maybe.$ === 'Just') {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Location$Bing$Categories$Update$out_Location_Bing_Categories_Main_categoriesChanged = _Platform_outgoingPort(
	'out_Location_Bing_Categories_Main_categoriesChanged',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'categories',
					$elm$json$Json$Encode$list(
						function ($) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string($.id)),
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string($.name))
									]));
						})($.categories)),
					_Utils_Tuple2(
					'primaryCategoryId',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.primaryCategoryId))
				]));
	});
var $author$project$Location$Bing$Categories$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'HandleFlags':
				var flagsValue = msg.a;
				var _v1 = $author$project$Location$Bing$Categories$Model$decodeFlags(flagsValue);
				if (_v1.$ === 'Ok') {
					var flags = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{site: flags.site, error: $elm$core$Maybe$Nothing, storeId: flags.storeId, translations: flags.translations, selectedCategories: flags.selectedCategories}),
						A2($author$project$Location$Bing$Categories$Update$getCategories, flags.site.name, flags.storeId));
				} else {
					var err = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$LocationDetail$errorLoading(model.translations))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'Location.Bing.Categories.Update',
								message: 'Failed to decode flags'
							}));
				}
			case 'OnLanguageChanged':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var t = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{translations: t}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$author$project$Location$Bing$Categories$Model$init,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'Location.Bing.Update',
								message: 'Failed to decode translations'
							}));
				}
			case 'GetCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								categories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var errMsg = $author$project$Common$HandleResult$httpErrorUserMessage(err);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								categories: $author$project$RemoteData$Error(errMsg)
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Location.Bing.Categories.Update', message: 'Failed to handle result of msg GetCategories'}));
				}
			default:
				var msg_ = msg.a;
				var doUpdate = function (selected) {
					return $author$project$Location$Bing$Categories$Update$out_Location_Bing_Categories_Main_categoriesChanged(selected);
				};
				switch (msg_.$) {
					case 'UiSelectMsg':
						var msg__ = msg_.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							function (x) {
								return _Utils_update(
									model,
									{selectBoxState: x});
							},
							A3(
								$author$project$PinMeTo$Ui$Select$update,
								A2($elm$core$Basics$composeR, $author$project$Common$Bing$SelectCategoryMsg$UiSelectMsg, $author$project$Location$Bing$Categories$Msg$CategoriesViewMsg),
								msg__,
								model.selectBoxState));
					case 'SelectCategory':
						var category = msg_.a;
						var selected = _Utils_ap(
							model.selectedCategories.categories,
							_List_fromArray(
								[category]));
						var sc = model.selectedCategories;
						var sc_ = _Utils_update(
							sc,
							{categories: selected});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{selectedCategories: sc_}),
							doUpdate(sc_));
					case 'SetCategories':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'RemoveCategory':
						var id = msg_.a;
						var filtered = A2(
							$elm$core$List$filter,
							function (x) {
								return !_Utils_eq(x.id, id);
							},
							model.selectedCategories.categories);
						var sc = model.selectedCategories;
						var primary = _Utils_eq(
							sc.primaryCategoryId,
							$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : sc.primaryCategoryId;
						var sc_ = _Utils_update(
							sc,
							{categories: filtered, primaryCategoryId: primary});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{selectedCategories: sc_}),
							doUpdate(sc_));
					default:
						var id = msg_.a;
						var sc = model.selectedCategories;
						var sc_ = _Utils_update(
							sc,
							{
								primaryCategoryId: $elm$core$Maybe$Just(id)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{selectedCategories: sc_}),
							doUpdate(sc_));
				}
		}
	});
var $author$project$Location$Bing$Categories$Msg$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Location$Bing$Categories$Main$init = function (flags) {
	return A2(
		$author$project$Location$Bing$Categories$Update$update,
		$author$project$Location$Bing$Categories$Msg$HandleFlags(flags),
		$author$project$Location$Bing$Categories$Model$init);
};
var $author$project$Translations$Listings$LocationDetail$addCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.add_category');
};
var $author$project$Translations$General$remove = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.remove');
};
var $author$project$Translations$Listings$LocationDetail$makePrimary = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.make_primary');
};
var $author$project$Common$Bing$SelectCategoryMsg$RemoveCategory = function (a) {
	return {$: 'RemoveCategory', a: a};
};
var $author$project$Common$Bing$SelectCategoryMsg$MakeCategoryPrimary = function (a) {
	return {$: 'MakeCategoryPrimary', a: a};
};
var $author$project$Common$Bing$CategoriesView$categoryRow = F3(
	function (primaryId, x, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-actions')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-actions__target')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(x.name)
						])),
					A2(
					$elm$html$Html$aside,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-actions__items')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnPlain,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(
									_Utils_eq(
										primaryId,
										$elm$core$Maybe$Just(x.id))),
									$elm$html$Html$Events$onClick(
									$author$project$Common$Bing$SelectCategoryMsg$MakeCategoryPrimary(x.id)),
									$elm$html$Html$Attributes$title(
									$author$project$Translations$Listings$LocationDetail$makePrimary(translations))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-solid fa-star'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'util__color--primary',
													_Utils_eq(
														primaryId,
														$elm$core$Maybe$Just(x.id)))
												]))
										]),
									_List_Nil)
								])),
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnPlain,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Common$Bing$SelectCategoryMsg$RemoveCategory(x.id)),
									$elm$html$Html$Attributes$title(
									$author$project$Translations$General$remove(translations))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-solid fa-trash')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Common$Bing$SelectCategoryMsg$SetCategories = {$: 'SetCategories'};
var $author$project$Common$Bing$SelectCategoryMsg$SelectCategory = function (a) {
	return {$: 'SelectCategory', a: a};
};
var $author$project$Translations$Listings$LocationDetail$helpTextSelectionRequired = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.help_text_selection_required');
};
var $author$project$Common$Bing$CategoriesView$renderCategories = F2(
	function (model, _v0) {
		var showSaveButton = _v0.showSaveButton;
		var msg = _v0.msg;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-category-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__spacing-bottom-2')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Select$render,
							model.selectBoxState,
							A2(
								$author$project$PinMeTo$Ui$Select$withSearch,
								{
									searchMap: function ($) {
										return $.name;
									},
									placeholder: $author$project$Translations$General$searchItemsPlaceholder(model.translations),
									noResultsLabel: $author$project$Translations$General$searchNoResults(model.translations)
								},
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'bing-category-select',
										items: A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											$author$project$RemoteData$currentData(model.categories)),
										label: $elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$addCategory(model.translations)),
										tagger: A2($elm$core$Basics$composeR, $author$project$Common$Bing$SelectCategoryMsg$UiSelectMsg, msg),
										onChange: function (category) {
											return msg(
												$author$project$Common$Bing$SelectCategoryMsg$SelectCategory(category));
										},
										itemRender: A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.name;
											},
											$elm$html$Html$text)
									})))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__spacing-bottom-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							msg,
							A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list list--divided')
									]),
								A2(
									$elm$core$List$map,
									function (x) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list__item')
												]),
											_List_fromArray(
												[x]));
									},
									A2(
										$elm$core$List$map,
										function (category) {
											return A3($author$project$Common$Bing$CategoriesView$categoryRow, model.selectedCategories.primaryCategoryId, category, model.translations);
										},
										A2(
											$elm$core$List$sortBy,
											function ($) {
												return $.name;
											},
											model.selectedCategories.categories)))))
						])),
					function () {
					if (showSaveButton) {
						var _v1 = model.selectedCategories.primaryCategoryId;
						if (_v1.$ === 'Just') {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick(
												msg($author$project$Common$Bing$SelectCategoryMsg$SetCategories)),
												$elm$html$Html$Attributes$class('pmt-btn pmt-btn--default')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$save(model.translations))
											]))
									]));
						} else {
							return ($elm$core$List$length(model.selectedCategories.categories) > 0) ? A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'color', 'red'),
												A2($elm$html$Html$Attributes$style, 'fontSize', '0.8em'),
												A2($elm$html$Html$Attributes$style, 'float', 'right')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$LocationDetail$helpTextSelectionRequired(model.translations))
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$disabled(true),
												$elm$html$Html$Events$onClick(
												msg($author$project$Common$Bing$SelectCategoryMsg$SetCategories)),
												$elm$html$Html$Attributes$class('pmt-btn pmt-btn--default')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$save(model.translations))
											]))
									])) : $elm$html$Html$text('');
						}
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Location$Bing$Categories$View$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('util__inset')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.error;
				if (_v0.$ === 'Just') {
					var message = _v0.a;
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('status-bar status-bar--danger')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$error(model.translations) + ': ')
									])),
								$elm$html$Html$text(message)
							]));
				} else {
					return A2(
						$author$project$Common$Bing$CategoriesView$renderCategories,
						model,
						{msg: $author$project$Location$Bing$Categories$Msg$CategoriesViewMsg, showSaveButton: false});
				}
			}()
			]));
};
var $author$project$Location$Bing$Categories$Msg$OnLanguageChanged = function (a) {
	return {$: 'OnLanguageChanged', a: a};
};
var $author$project$Location$Bing$Categories$Main$passArgs_Location_Bing_Categories_Main = _Platform_incomingPort('passArgs_Location_Bing_Categories_Main', $elm$json$Json$Decode$value);
var $author$project$Location$Bing$Categories$Main$in_Location_Bing_Categories_Main_languageChanged = _Platform_incomingPort('in_Location_Bing_Categories_Main_languageChanged', $elm$json$Json$Decode$value);
var $author$project$Location$Bing$Categories$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Location$Bing$Categories$Main$passArgs_Location_Bing_Categories_Main($author$project$Location$Bing$Categories$Msg$HandleFlags),
				$author$project$Location$Bing$Categories$Main$in_Location_Bing_Categories_Main_languageChanged(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Common$Language$translationsDecoder),
					$author$project$Location$Bing$Categories$Msg$OnLanguageChanged))
			]));
};
var $author$project$Location$Bing$Categories$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Location$Bing$Categories$Main$init, view: $author$project$Location$Bing$Categories$View$view, update: $author$project$Location$Bing$Categories$Update$update, subscriptions: $author$project$Location$Bing$Categories$Main$subscriptions});
var $author$project$LocalCampaignLandingPage$Main$init = F2(
	function (_v0, flags) {
		return _Utils_Tuple2(
			{listings: flags.listings, confirmationPopup: false},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Translations$LocatorLandingPage$chat = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.chat');
};
var $author$project$Translations$LocatorLandingPage$gotIt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.got_it');
};
var $author$project$FontAwesome$Thin$Icon$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$FontAwesome$Thin$Icon$faLink = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-link');
var $author$project$FontAwesome$Thin$faLink = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faLink);
var $author$project$Translations$LocatorLandingPage$bookDemo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.book_demo');
};
var $author$project$Translations$LocatorLandingPage$contactMe = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.contact_me');
};
var $author$project$Translations$LocalCampaignLandingPage$mainTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.main_title');
};
var $author$project$LocalCampaignLandingPage$Main$CloseAlertBox = function (a) {
	return {$: 'CloseAlertBox', a: a};
};
var $author$project$PinMeTo$Ui$Lightbox$withLightLightbox = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Lightbox$View(
		_Utils_update(
			config,
			{withLightLightbox: true}));
};
var $author$project$LocalCampaignLandingPage$Main$showAlert = F3(
	function (body, footer, action) {
		return $author$project$PinMeTo$Ui$Lightbox$render(
			$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
				$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withStyle,
						$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withClose,
							$author$project$LocalCampaignLandingPage$Main$CloseAlertBox(action),
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withFooter,
								footer,
								$author$project$PinMeTo$Ui$Lightbox$view(
									{
										title: '',
										content: A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[body]))
									})))))));
	});
var $author$project$Translations$LocalCampaignLandingPage$subtitle1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.subtitle1');
};
var $author$project$Translations$LocatorLandingPage$trustedBy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.trusted_by');
};
var $author$project$LocalCampaignLandingPage$Main$ChatWithUs = {$: 'ChatWithUs'};
var $author$project$Translations$LocalCampaignLandingPage$brand0Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand0_title');
};
var $author$project$Translations$LocalCampaignLandingPage$brand1Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand1_title');
};
var $author$project$Translations$LocalCampaignLandingPage$brand2Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand2_title');
};
var $author$project$Translations$LocalCampaignLandingPage$brand3Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand3_title');
};
var $author$project$Translations$LocalCampaignLandingPage$intro1Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro1_title');
};
var $author$project$Translations$LocalCampaignLandingPage$intro2Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro2_title');
};
var $author$project$Translations$LocalCampaignLandingPage$intro3Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro3_title');
};
var $author$project$Translations$LocalCampaignLandingPage$intro4Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro4_title');
};
var $author$project$Translations$LocatorLandingPage$letsConnect = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.lets_connect');
};
var $author$project$PinMeTo$Ui$Btn$pmtBtnMuted = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--cta-muted');
var $author$project$Translations$LocalCampaignLandingPage$bookDemoNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.book_demo_note');
};
var $author$project$FontAwesome$Thin$Icon$faBadgeCheck = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-badge-check');
var $author$project$FontAwesome$Thin$faBadgeCheck = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faBadgeCheck);
var $author$project$FontAwesome$Thin$Icon$faPaperPlane = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-paper-plane');
var $author$project$FontAwesome$Thin$faPaperPlane = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faPaperPlane);
var $author$project$Translations$LocalCampaignLandingPage$turnDataInto = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.turn_data_into');
};
var $author$project$LocalCampaignLandingPage$Main$InterestPopup = {$: 'InterestPopup'};
var $author$project$Translations$LocalCampaignLandingPage$brand1Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand1_content');
};
var $author$project$Translations$LocalCampaignLandingPage$brand2Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand2_content');
};
var $author$project$Translations$LocalCampaignLandingPage$brand3Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.brand3_content');
};
var $author$project$Translations$LocatorLandingPage$contactMeNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.contact_me_note');
};
var $author$project$Translations$LocatorLandingPage$haveQuestions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.have_questions');
};
var $author$project$Translations$LocalCampaignLandingPage$intro1Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro1_content');
};
var $author$project$Translations$LocalCampaignLandingPage$intro2Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro2_content');
};
var $author$project$Translations$LocalCampaignLandingPage$intro3Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro3_content');
};
var $author$project$Translations$LocalCampaignLandingPage$intro4Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'local_campaign_landing_page.intro4_content');
};
var $author$project$Translations$LocatorLandingPage$notInterested = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.not_interested');
};
var $author$project$FontAwesome$Thin$Icon$faArrowsRotate = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-arrows-rotate');
var $author$project$FontAwesome$Thin$faArrowsRotate = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faArrowsRotate);
var $author$project$LocalCampaignLandingPage$Main$ClickedBookMeeting = {$: 'ClickedBookMeeting'};
var $author$project$LocalCampaignLandingPage$Main$NotInterestedClicked = {$: 'NotInterestedClicked'};
var $author$project$LocalCampaignLandingPage$Main$view = F2(
	function (session, model) {
		var translation = F2(
			function (key, replacements) {
				return A5($ChristophP$elm_i18next$I18Next$customTr, session.translations, $ChristophP$elm_i18next$I18Next$Curly, $elm$html$Html$text, key, replacements);
			});
		var confirmationBody = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__confirmation-popup')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__confirmation-popup-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$LocatorLandingPage$letsConnect(session.translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__confirmation-popup-content'),
							A2($elm$html$Html$Attributes$style, 'padding-bottom', '1.6rem')
						]),
					A2(
						translation,
						'locator_landing_page.reach',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(session.user.email)
										])))
							])))
				]));
		var confirmationPopup = model.confirmationPopup ? A3(
			$author$project$LocalCampaignLandingPage$Main$showAlert,
			confirmationBody,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn-group')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$PinMeTo$Ui$Btn$pmtBtn,
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$LocalCampaignLandingPage$Main$CloseAlertBox(''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$LocatorLandingPage$gotIt(session.translations))
							]))
					])),
			'Local Campaigns - Landing page - Contact me clicked') : $elm$html$Html$text('');
		var ctaButtons = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-center flex-basis flex-wrap')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__interest-button'),
									$elm$html$Html$Events$onClick($author$project$LocalCampaignLandingPage$Main$InterestPopup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$contactMe(session.translations))
								])),
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnMuted,
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-page__interest-button'),
									$elm$html$Html$Events$onClick($author$project$LocalCampaignLandingPage$Main$ClickedBookMeeting),
									$elm$html$Html$Attributes$href('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3FB8sI5Epv0PQIWzf4qL_hIeBpV4hkHcnwEh8jfo9gjvM8ZCKowb55j71ncAevtfmEhhL2bGTk'),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$id('book-a-meeting')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$bookDemo(session.translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__cta-note-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__cta-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$contactMeNote(session.translations))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__cta-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocalCampaignLandingPage$bookDemoNote(session.translations))
								]))
						]))
				]));
		var chatButton = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__chat')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$LocatorLandingPage$haveQuestions(session.translations))
						])),
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$LocalCampaignLandingPage$Main$ChatWithUs)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$LocatorLandingPage$chat(session.translations))
						]))
				]));
		var mainImage = A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('img/local-campaign-landing-page/promo.png'),
					$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__main-image')
				]),
			_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__content-header')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocalCampaignLandingPage$mainTitle(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__content-subtitle')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocalCampaignLandingPage$subtitle1(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__content-buttons')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtn,
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__interest-button'),
															$elm$html$Html$Events$onClick($author$project$LocalCampaignLandingPage$Main$InterestPopup)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$contactMe(session.translations))
														])),
													A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtnMuted,
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-locator-landing-page__interest-button'),
															$elm$html$Html$Events$onClick($author$project$LocalCampaignLandingPage$Main$ClickedBookMeeting),
															$elm$html$Html$Attributes$href('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3FB8sI5Epv0PQIWzf4qL_hIeBpV4hkHcnwEh8jfo9gjvM8ZCKowb55j71ncAevtfmEhhL2bGTk'),
															$elm$html$Html$Attributes$target('_blank'),
															$elm$html$Html$Attributes$id('book-a-meeting')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$bookDemo(session.translations))
														])),
													$author$project$PinMeTo$Ui$Button$render(
													A2(
														$author$project$PinMeTo$Ui$Button$withOnClick,
														$author$project$LocalCampaignLandingPage$Main$NotInterestedClicked,
														$author$project$PinMeTo$Ui$Button$buttonGhost(
															$author$project$Translations$LocatorLandingPage$notInterested(session.translations))))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__cta-note')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocatorLandingPage$contactMeNote(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__cta-note')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocalCampaignLandingPage$bookDemoNote(session.translations))
												]))
										])),
									mainImage
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__gray-container pmt-local-campaign-landing-page__introduction-container'),
									A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-item pmt-local-campaign-landing-page__introduction-item--divider')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center pmt-local-campaign-landing-page__introduction-icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faLink]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro1Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro1Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-item pmt-local-campaign-landing-page__introduction-item--divider')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center pmt-local-campaign-landing-page__introduction-icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faPaperPlane]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro2Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro2Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-item pmt-local-campaign-landing-page__introduction-item--divider')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center pmt-local-campaign-landing-page__introduction-icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faBadgeCheck]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro3Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro3Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center pmt-local-campaign-landing-page__introduction-icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__introduction-icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faArrowsRotate]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro4Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$intro4Content(session.translations))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__middle-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__promo-wrapper')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__promo')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('img/local-campaign-landing-page/promo-2.png')
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__product-title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocalCampaignLandingPage$brand0Title(session.translations))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__card-item')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h1,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$LocalCampaignLandingPage$brand1Title(session.translations))
																])),
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$LocalCampaignLandingPage$brand1Content(session.translations))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__card-item')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h1,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$LocalCampaignLandingPage$brand2Title(session.translations))
																])),
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$LocalCampaignLandingPage$brand2Content(session.translations))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__card-item')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h1,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$LocalCampaignLandingPage$brand3Title(session.translations))
																])),
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$LocalCampaignLandingPage$brand3Content(session.translations))
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__dot-separator')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$span, _List_Nil, _List_Nil),
							A2($elm$html$Html$span, _List_Nil, _List_Nil),
							A2($elm$html$Html$span, _List_Nil, _List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-center pmt-local-campaign-landing-page__product-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocalCampaignLandingPage$turnDataInto(session.translations))
								])),
							ctaButtons
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__gray-container'),
									A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
								]),
							_List_fromArray(
								[chatButton]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__footer'),
									A2($elm$html$Html$Attributes$style, 'padding-bottom', '0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__content-note')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$LocatorLandingPage$trustedBy(session.translations))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-local-campaign-landing-page__footer pmt-local-campaign-landing-page__footer-brands')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/boots.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/hm.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/7eleven.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/starbucks.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/coop.svg'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil)
										]))
								]))
						])),
					confirmationPopup
				]));
	});
var $author$project$LocalCampaignLandingPage$Main$SlackResponse = function (a) {
	return {$: 'SlackResponse', a: a};
};
var $author$project$LocalCampaignLandingPage$Requests$errorBodyDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['error', 'message']),
	$elm$json$Json$Decode$string);
var $author$project$LocalCampaignLandingPage$Requests$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 'BadUrl_':
						var url = response.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadUrl(url));
					case 'Timeout_':
						return $elm$core$Result$Err($elm$http$Http$Timeout);
					case 'NetworkError_':
						return $elm$core$Result$Err($elm$http$Http$NetworkError);
					case 'BadStatus_':
						var metadata = response.a;
						var body = response.b;
						var message = A2(
							$elm$core$Result$withDefault,
							body,
							A2($elm$json$Json$Decode$decodeString, $author$project$LocalCampaignLandingPage$Requests$errorBodyDecoder, body));
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(
								'Error ' + ($elm$core$String$fromInt(metadata.statusCode) + (': ' + message))));
					default:
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (_v1.$ === 'Ok') {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err)));
						}
				}
			});
	});
var $author$project$LocalCampaignLandingPage$Requests$slackChannelEncoder = function (channel) {
	return $elm$json$Json$Encode$int(4);
};
var $author$project$LocalCampaignLandingPage$Requests$slackMessageEncoder = function (message) {
	return $elm$json$Json$Encode$int(4);
};
var $author$project$LocalCampaignLandingPage$Requests$sendSlackMessage = F4(
	function (channel, messageTemplate, siteName, msg) {
		var encoder = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'channel',
					$author$project$LocalCampaignLandingPage$Requests$slackChannelEncoder(channel)),
					_Utils_Tuple2(
					'messageTemplate',
					$author$project$LocalCampaignLandingPage$Requests$slackMessageEncoder(messageTemplate))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$author$project$LocalCampaignLandingPage$Requests$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(true)),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					encoder,
					$lukewestby$elm_http_builder$HttpBuilder$post('/api/' + (siteName + '/notify')))));
	});
var $author$project$LocalCampaignLandingPage$Requests$LocalCampaignLead = {$: 'LocalCampaignLead'};
var $author$project$LocalCampaignLandingPage$Main$NotInterestedPending = function (a) {
	return {$: 'NotInterestedPending', a: a};
};
var $author$project$LocalCampaignLandingPage$Requests$addIgnoredProductUpgrade = F2(
	function (siteName, msg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'siteName',
					$elm$json$Json$Encode$string(siteName)),
					_Utils_Tuple2(
					'product',
					$elm$json$Json$Encode$string('Local Campaigns'))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$author$project$LocalCampaignLandingPage$Requests$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(true)),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$post('/location-posts/api/user/ignoredProductUpgrades'))));
	});
var $author$project$LocalCampaignLandingPage$Requests$LocalCampaignProductLeads = {$: 'LocalCampaignProductLeads'};
var $author$project$LocalCampaignLandingPage$Main$out_LocalCampaignLandingPage_Main_ToggleChat = _Platform_outgoingPort(
	'out_LocalCampaignLandingPage_Main_ToggleChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$LocalCampaignLandingPage$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'InterestPopup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmationPopup: true}),
					A4(
						$author$project$LocalCampaignLandingPage$Requests$sendSlackMessage,
						$author$project$LocalCampaignLandingPage$Requests$LocalCampaignProductLeads,
						$author$project$LocalCampaignLandingPage$Requests$LocalCampaignLead,
						$author$project$Data$SiteName$toString(session.siteName),
						$author$project$LocalCampaignLandingPage$Main$SlackResponse));
			case 'CloseAlertBox':
				var action = msg.a;
				return (action === '') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmationPopup: false}),
					$elm$browser$Browser$Navigation$load(model.listings)) : _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmationPopup: false}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$PlanHat$PlanHat$track(
								{info: '', action: action}),
								$elm$browser$Browser$Navigation$load(model.listings)
							])));
			case 'ClickedBookMeeting':
				return _Utils_Tuple2(
					model,
					$author$project$PlanHat$PlanHat$track(
						{info: '', action: 'Local Campaigns - Landing page - Book a demo clicked'}));
			case 'SlackResponse':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'ChatWithUs':
				return _Utils_Tuple2(
					model,
					$author$project$LocalCampaignLandingPage$Main$out_LocalCampaignLandingPage_Main_ToggleChat(_Utils_Tuple0));
			case 'NotInterestedClicked':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$LocalCampaignLandingPage$Requests$addIgnoredProductUpgrade,
								$author$project$Data$SiteName$toString(session.siteName),
								$author$project$LocalCampaignLandingPage$Main$NotInterestedPending),
								$author$project$PlanHat$PlanHat$track(
								{info: '', action: 'Local Campaigns - Landing page - Not interested clicked'})
							])));
			default:
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(model.listings));
		}
	});
var $author$project$LocalCampaignLandingPage$Main$Flags = function (listings) {
	return {listings: listings};
};
var $author$project$LocalCampaignLandingPage$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'listings',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$LocalCampaignLandingPage$Main$Flags));
var $author$project$LocalCampaignLandingPage$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$LocalCampaignLandingPage$Main$init,
		view: $author$project$LocalCampaignLandingPage$Main$view,
		update: $author$project$LocalCampaignLandingPage$Main$update,
		flagsDecoder: $author$project$LocalCampaignLandingPage$Main$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Common$Image$Types$Cover = {$: 'Cover'};
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$init = function (siteName) {
	return {variant: $author$project$Common$Image$Types$Cover, siteName: siteName, showLightBox: false, uiTableState: $author$project$PinMeTo$Ui$Table$init, locationContent: $author$project$RemoteData$Loading};
};
var $author$project$BrandManagement$Facebook$Types$FacebookBrandPage = F9(
	function (name, id, enabled, media, brandPageId, brandPageUrl, isWebhookSubscribed, hasDataDiff, connected) {
		return {id: id, name: name, media: media, enabled: enabled, connected: connected, brandPageId: brandPageId, hasDataDiff: hasDataDiff, brandPageUrl: brandPageUrl, isWebhookSubscribed: isWebhookSubscribed};
	});
var $author$project$BrandManagement$Facebook$Types$FacebookMedia = F2(
	function (url, previewUrl) {
		return {url: url, previewUrl: previewUrl};
	});
var $author$project$BrandManagement$Facebook$Decoders$facebookMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'previewUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$Types$FacebookMedia)));
var $author$project$BrandManagement$Facebook$Types$FacebookBrandPageMedia = F2(
	function (profileImage, coverImage) {
		return {coverImage: coverImage, profileImage: profileImage};
	});
var $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coverImage',
	$elm$json$Json$Decode$maybe($author$project$BrandManagement$Facebook$Decoders$facebookMediaDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profileImage',
		$elm$json$Json$Decode$maybe($author$project$BrandManagement$Facebook$Decoders$facebookMediaDecoder),
		$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$Types$FacebookBrandPageMedia)));
var $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['connectedStatus', 'connected']),
	$elm$json$Json$Decode$bool,
	true,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['validation', 'hasDataDiff']),
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['data', 'isWebhookSubscribed']),
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['data', 'link']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pageId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'media',
						$author$project$BrandManagement$Facebook$Decoders$facebookBrandPageMediaDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'enabled',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'_id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$Types$FacebookBrandPage))))))))));
var $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageListDecoder = A2(
	$elm$json$Json$Decode$field,
	'data',
	$elm$json$Json$Decode$list($author$project$BrandManagement$Facebook$Decoders$facebookBrandPageDecoder));
var $author$project$BrandManagement$Facebook$Commands$getFacebookBrandPages = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/network/facebook/brandpages');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageListDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Facebook$Model$OnFacebookBrandPagesReceived = function (a) {
	return {$: 'OnFacebookBrandPagesReceived', a: a};
};
var $author$project$BrandManagement$Facebook$Types$FacebookBrandPageSummary = F2(
	function (brandPageId, totalLocations) {
		return {brandPageId: brandPageId, totalLocations: totalLocations};
	});
var $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageSummaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalLocations',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'brandPageId',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$Types$FacebookBrandPageSummary)));
var $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageSummaryListDecoder = $elm$json$Json$Decode$list($author$project$BrandManagement$Facebook$Decoders$facebookBrandPageSummaryDecoder);
var $author$project$BrandManagement$Facebook$Commands$getFacebookBrandPagesSummary = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/network/facebook/brandpages/locations/summary');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageSummaryListDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Facebook$Model$OnFacebookBrandPagesSummaryReceived = function (a) {
	return {$: 'OnFacebookBrandPagesSummaryReceived', a: a};
};
var $author$project$BrandManagement$Facebook$Main$init = F2(
	function (session, _v0) {
		var initialModel = {
			brandPages: $author$project$RemoteData$Loading,
			selectedPage: $elm$core$Maybe$Nothing,
			brandMediaStates: $elm$core$Dict$empty,
			brandPageSummaries: $author$project$RemoteData$Loading,
			resetMediaLightbox: $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$init(session.siteName),
			brandCoverImageInfo: $elm$core$Dict$empty,
			brandPageSearchTerm: '',
			brandProfileImageInfo: $elm$core$Dict$empty
		};
		return _Utils_Tuple2(
			initialModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$BrandManagement$Facebook$Commands$getFacebookBrandPagesSummary, session.siteName, $author$project$BrandManagement$Facebook$Model$OnFacebookBrandPagesSummaryReceived),
						A2($author$project$BrandManagement$Facebook$Commands$getFacebookBrandPages, session.siteName, $author$project$BrandManagement$Facebook$Model$OnFacebookBrandPagesReceived)
					])));
	});
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$NoOp = {$: 'NoOp'};
var $author$project$Translations$Listings$BrandPages$edit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.edit');
};
var $author$project$Translations$Listings$BrandPages$crop = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.crop');
};
var $author$project$Translations$Listings$BrandPages$cancel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.cancel');
};
var $author$project$Common$Image$Editor$OnCancel = {$: 'OnCancel'};
var $author$project$Translations$Listings$BrandPages$browse = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.browse');
};
var $author$project$Common$Image$Types$Profile = {$: 'Profile'};
var $author$project$Common$Image$Cropper$OneToOne = {$: 'OneToOne'};
var $author$project$Common$Image$Cropper$SixteenToNine = {$: 'SixteenToNine'};
var $author$project$Common$Image$Cropper$TwentyFourToNine = {$: 'TwentyFourToNine'};
var $author$project$Common$Image$Cropper$EightTwentyToThreeTwelve = {$: 'EightTwentyToThreeTwelve'};
var $author$project$Common$Image$Validation$rulesFor = F2(
	function (network, mediaType) {
		var _v0 = _Utils_Tuple2(network, mediaType);
		if (_v0.a.$ === 'Google') {
			if (_v0.b.$ === 'Profile') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return {
					maxBytes: $elm$core$Maybe$Nothing,
					maxWidth: $elm$core$Maybe$Just(500),
					minBytes: $elm$core$Maybe$Just(10240),
					minWidth: 250,
					fileTypes: _List_fromArray(
						['jpg', 'jpeg', 'png']),
					maxHeight: $elm$core$Maybe$Just(500),
					minHeight: 250,
					aspectRatios: _List_fromArray(
						[$author$project$Common$Image$Cropper$OneToOne]),
					mustBeSquare: true
				};
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return {
					maxBytes: $elm$core$Maybe$Nothing,
					maxWidth: $elm$core$Maybe$Just(2120),
					minBytes: $elm$core$Maybe$Just(10240),
					minWidth: 480,
					fileTypes: _List_fromArray(
						['jpg', 'jpeg', 'png']),
					maxHeight: $elm$core$Maybe$Just(1192),
					minHeight: 270,
					aspectRatios: _List_fromArray(
						[$author$project$Common$Image$Cropper$SixteenToNine]),
					mustBeSquare: false
				};
			}
		} else {
			if (_v0.b.$ === 'Profile') {
				var _v5 = _v0.a;
				var _v6 = _v0.b;
				return {
					maxBytes: $elm$core$Maybe$Just((1024 * 1024) * 4),
					maxWidth: $elm$core$Maybe$Just(1000),
					minBytes: $elm$core$Maybe$Nothing,
					minWidth: 400,
					fileTypes: _List_fromArray(
						['jpg', 'jpeg', 'png']),
					maxHeight: $elm$core$Maybe$Just(1000),
					minHeight: 400,
					aspectRatios: _List_fromArray(
						[$author$project$Common$Image$Cropper$OneToOne]),
					mustBeSquare: true
				};
			} else {
				var _v7 = _v0.a;
				var _v8 = _v0.b;
				return {
					maxBytes: $elm$core$Maybe$Just((1024 * 1024) * 4),
					maxWidth: $elm$core$Maybe$Nothing,
					minBytes: $elm$core$Maybe$Nothing,
					minWidth: 400,
					fileTypes: _List_fromArray(
						['jpg', 'jpeg', 'png']),
					maxHeight: $elm$core$Maybe$Nothing,
					minHeight: 150,
					aspectRatios: _List_fromArray(
						[$author$project$Common$Image$Cropper$TwentyFourToNine, $author$project$Common$Image$Cropper$EightTwentyToThreeTwelve, $author$project$Common$Image$Cropper$SixteenToNine]),
					mustBeSquare: false
				};
			}
		}
	});
var $author$project$Translations$General$imagePlain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.image_plain');
};
var $author$project$Common$Image$Editor$ratioLabel = function (ratio) {
	switch (ratio.$) {
		case 'TwentyFourToNine':
			return '24:9';
		case 'EightTwentyToThreeTwelve':
			return '2.63:1';
		case 'SixteenToNine':
			return '16:9';
		default:
			return '1:1';
	}
};
var $author$project$Common$Image$Validation$minDimensions = F3(
	function (network, mediaType, aspectRatio) {
		var _v0 = _Utils_Tuple3(network, mediaType, aspectRatio);
		_v0$2:
		while (true) {
			if ((_v0.a.$ === 'Facebook') && (_v0.b.$ === 'Cover')) {
				switch (_v0.c.$) {
					case 'EightTwentyToThreeTwelve':
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var _v3 = _v0.c;
						return _Utils_Tuple2(820, 312);
					case 'SixteenToNine':
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						var _v6 = _v0.c;
						return _Utils_Tuple2(640, 360);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		var rules = A2($author$project$Common$Image$Validation$rulesFor, network, mediaType);
		return _Utils_Tuple2(rules.minWidth, rules.minHeight);
	});
var $author$project$Common$Image$Editor$requirements = F2(
	function (translations, state) {
		var _v0 = A3($author$project$Common$Image$Validation$minDimensions, state.network, state.mediaType, state.selectedAspectRatio);
		var minWidth = _v0.a;
		var minHeight = _v0.b;
		var imageLabel = $author$project$Translations$General$imagePlain(translations);
		var translated = F2(
			function (key, replacements) {
				return A5(
					$ChristophP$elm_i18next$I18Next$customTr,
					translations,
					$ChristophP$elm_i18next$I18Next$Curly,
					$elm$html$Html$text,
					'general.media_upload.' + key,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'mediaTypeCapital',
							$elm$html$Html$text(imageLabel)),
						replacements));
			});
		var dimensions = F2(
			function (width, height) {
				return $elm$core$String$fromInt(width) + ('x' + $elm$core$String$fromInt(height));
			});
		var rules = A2($author$project$Common$Image$Validation$rulesFor, state.network, state.mediaType);
		var fileTypes = A2(
			$elm$core$String$join,
			' ' + (A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.media_upload.or') + ' '),
			A2(
				$elm$core$List$map,
				$elm$core$String$toUpper,
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq('jpeg'),
					rules.fileTypes)));
		var bold = function (value) {
			return A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(value)
					]));
		};
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$elm$html$Html$li(_List_Nil),
				$elm_community$maybe_extra$Maybe$Extra$values(
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							A2(
								translated,
								'file_type_image',
								_List_fromArray(
									[
										_Utils_Tuple2(
										'- fileTypeImage',
										bold(fileTypes))
									]))),
							((minWidth > 0) && (minHeight > 0)) ? $elm$core$Maybe$Just(
							_Utils_ap(
								A2(translated, 'media_size', _List_Nil),
								_List_fromArray(
									[
										bold(
										A2(dimensions, minWidth, minHeight))
									]))) : $elm$core$Maybe$Nothing,
							A3(
							$elm$core$Maybe$map2,
							F2(
								function (width, height) {
									return _Utils_ap(
										A2(translated, 'media_size_max', _List_Nil),
										_List_fromArray(
											[
												bold(
												A2(dimensions, width, height))
											]));
								}),
							rules.maxWidth,
							rules.maxHeight),
							$elm$core$Maybe$Just(
							_Utils_ap(
								A2(translated, 'aspect_ratio', _List_Nil),
								_List_fromArray(
									[
										bold(
										$author$project$Common$Image$Editor$ratioLabel(state.selectedAspectRatio))
									]))),
							_Utils_eq(state.mediaType, $author$project$Common$Image$Types$Profile) ? A2(
							$elm$core$Maybe$map,
							function (bytes) {
								return A2(
									translated,
									'file_size_min',
									_List_fromArray(
										[
											_Utils_Tuple2(
											'- minFileSizeFormatted',
											bold(
												$elm$core$String$fromInt((bytes / 1024) | 0) + ' KB'))
										]));
							},
							rules.minBytes) : $elm$core$Maybe$Nothing
						]))));
	});
var $author$project$Common$Image$Editor$OnDropZoneMsg = function (a) {
	return {$: 'OnDropZoneMsg', a: a};
};
var $author$project$Listings$Ui$DropZone$Pick = {$: 'Pick'};
var $author$project$Listings$Ui$DropZone$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Listings$Ui$DropZone$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Listings$Ui$DropZone$hijack, decoder));
	});
var $author$project$Listings$Ui$DropZone$DragEnter = {$: 'DragEnter'};
var $author$project$Listings$Ui$DropZone$DragLeave = {$: 'DragLeave'};
var $elm$file$File$decoder = _File_decoder;
var $author$project$Listings$Ui$DropZone$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Listings$Ui$DropZone$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$Listings$Ui$DropZone$GotFiles, $elm$file$File$decoder));
var $author$project$Listings$Ui$DropZone$viewWithNotes = F3(
	function (config, notes, model) {
		return A2(
			$elm$html$Html$map,
			config.tagger,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('listings-drop-zone'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('listings-drop-zone--hover', model.hover)
							])),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragenter',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragEnter)),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragover',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragEnter)),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragleave',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragLeave)),
						A2($author$project$Listings$Ui$DropZone$hijackOn, 'drop', $author$project$Listings$Ui$DropZone$dropDecoder)
					]),
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								$author$project$Listings$Ui$DropZone$Pick,
								$author$project$PinMeTo$Ui$Button$buttonSecondary(config.buttonLabel))),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(config.dropZoneLabel)
								]))
						]),
					notes)));
	});
var $author$project$Translations$Listings$BrandPages$uploadingImages = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.brand_pages.uploading_images',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $author$project$Translations$Listings$BrandPages$uploadingImagesPlural = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.brand_pages.uploading_images_plural',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $author$project$Translations$Listings$BrandPages$orDragFilesHereToUpload = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.or_drag_files_here_to_upload');
};
var $author$project$Common$Image$Editor$dropZone = F2(
	function (translations, state) {
		var numberOfFilesBeingUploaded = $elm$core$List$length(state.imageNamesBeingUploaded);
		var label = function () {
			if (numberOfFilesBeingUploaded > 0) {
				var uploadingLabel = (numberOfFilesBeingUploaded === 1) ? $author$project$Translations$Listings$BrandPages$uploadingImages : $author$project$Translations$Listings$BrandPages$uploadingImagesPlural;
				return A2(
					uploadingLabel,
					translations,
					$elm$core$String$fromInt(numberOfFilesBeingUploaded));
			} else {
				return $author$project$Translations$Listings$BrandPages$orDragFilesHereToUpload(translations);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-drop-zone-container')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Listings$Ui$DropZone$viewWithNotes,
					{
						tagger: $author$project$Common$Image$Editor$OnDropZoneMsg,
						buttonLabel: $author$project$Translations$Listings$BrandPages$browse(translations),
						dropZoneLabel: label
					},
					_List_fromArray(
						[
							A2($author$project$Common$Image$Editor$requirements, translations, state)
						]),
					state.dropzoneState)
				]));
	});
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Common$Image$Editor$NoOp = {$: 'NoOp'};
var $author$project$Common$Validators$ValidatedItem$unpack = F3(
	function (ifInvalid, ifValid, item) {
		if (item.$ === 'ValidItem') {
			var a = item.a;
			return ifValid(a);
		} else {
			return ifInvalid(_Utils_Tuple0);
		}
	});
var $author$project$Translations$Listings$BrandPages$fileSizeToSmall = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.file_size_to_small');
};
var $author$project$Translations$Listings$BrandPages$invalidFileType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.invalid_file_type');
};
var $author$project$Translations$Listings$BrandPages$invalidDimensions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.invalid_dimensions');
};
var $author$project$Translations$Listings$BrandPages$invalidAspectRatio = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.invalid_aspect_ratio');
};
var $author$project$Translations$Listings$BrandPages$fileDimensionsToLarge = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.file_dimensions_to_large');
};
var $author$project$Translations$Listings$BrandPages$fileDimensionsToSmall = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.file_dimensions_to_small');
};
var $author$project$Common$Image$Validation$errorToString = F2(
	function (translations, err) {
		switch (err.$) {
			case 'FileDimensionsTooSmall':
				return $author$project$Translations$Listings$BrandPages$fileDimensionsToSmall(translations);
			case 'FileDimensionsTooLarge':
				return $author$project$Translations$Listings$BrandPages$fileDimensionsToLarge(translations);
			case 'FileSizeTooSmall':
				return $author$project$Translations$Listings$BrandPages$fileSizeToSmall(translations);
			case 'FileSizeTooLarge':
				return $author$project$Translations$Listings$BrandPages$invalidDimensions(translations);
			case 'InvalidFileType':
				return $author$project$Translations$Listings$BrandPages$invalidFileType(translations);
			default:
				return $author$project$Translations$Listings$BrandPages$invalidAspectRatio(translations);
		}
	});
var $author$project$Common$Image$Editor$OnMediaChecked = F2(
	function (a, b) {
		return {$: 'OnMediaChecked', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Form$Radio$withIsDisabled = F2(
	function (isDisabled, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Radio$Radio(
			_Utils_update(
				config,
				{disabled: isDisabled}));
	});
var $author$project$Translations$Listings$BrandPages$uploadedByAndAt = F3(
	function (translations, date, name) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.brand_pages.uploadedByAndAt',
			_List_fromArray(
				[
					_Utils_Tuple2('date', date),
					_Utils_Tuple2('name', name)
				]));
	});
var $author$project$Common$Image$Validation$isSelectableImage = function (validatedItem) {
	if (validatedItem.$ === 'ValidItem') {
		return true;
	} else {
		switch (validatedItem.a.$) {
			case 'FileDimensionsTooLarge':
				var _v1 = validatedItem.a;
				return true;
			case 'InvalidAspectRatio':
				var _v2 = validatedItem.a;
				return true;
			default:
				return false;
		}
	}
};
var $author$project$Common$Image$Editor$fileItem = F3(
	function (translations, isSelected, validatedItem) {
		var selectable = $author$project$Common$Image$Validation$isSelectableImage(validatedItem);
		var errorText = function () {
			if (validatedItem.$ === 'InvalidItem') {
				var err = validatedItem.a;
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							selectable ? 'pmt-brand-management__file-uploader-item__warning-text' : 'pmt-brand-management__file-uploader-item__error-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Common$Image$Validation$errorToString, translations, err))
						]));
			} else {
				return A2($elm$html$Html$p, _List_Nil, _List_Nil);
			}
		}();
		var overlay = A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-item__disabled-overlay'),
				selectable ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'none')
					]) : _List_Nil),
			_List_Nil);
		var item = $author$project$Common$Validators$ValidatedItem$unwrap(validatedItem);
		var liAttributes = selectable ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-item'),
				$elm$html$Html$Events$onClick(
				A2($author$project$Common$Image$Editor$OnMediaChecked, item, true))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-item'),
				$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-item__disabled')
			]);
		var renderItem = A2(
			$elm$html$Html$li,
			liAttributes,
			_List_fromArray(
				[
					overlay,
					$author$project$PinMeTo$Ui$Form$Radio$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Radio$withIsDisabled,
						!selectable,
						$author$project$PinMeTo$Ui$Form$Radio$radio(
							{
								label: '',
								checked: isSelected,
								onChange: A3(
									$author$project$Common$Validators$ValidatedItem$unpack,
									$elm$core$Basics$always(
										function (_v0) {
											return $author$project$Common$Image$Editor$NoOp;
										}),
									$author$project$Common$Image$Editor$OnMediaChecked,
									validatedItem)
							}))),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(item.previewUrl)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-item__title')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'pmt-brand-management__file-uploader-item__text-disabled',
													!$author$project$Common$Validators$ValidatedItem$isValid(validatedItem))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(item.name)
										])),
									errorText,
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__container__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(item.metaData.width) + (' x ' + ($elm$core$String$fromInt(item.metaData.height) + ' px')))
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-item__upload-info'),
									$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__container__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$author$project$Translations$Listings$BrandPages$uploadedByAndAt,
										translations,
										A2($justinmimbs$date$Date$format, 'dd-MM-YYYY', item.createdAt),
										item.uploadedBy.name))
								]))
						]))
				]));
		return renderItem;
	});
var $author$project$Translations$Listings$BrandPages$failedToLoadMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.failed_to_load_media');
};
var $author$project$Common$Image$Editor$fileList = F2(
	function (translations, state) {
		var selectedId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Common$Validators$ValidatedItem$unwrap,
					function ($) {
						return $.id;
					}),
				state.selectedMedia));
		var toFileItem = function (validatedItem) {
			var id = $author$project$Common$Validators$ValidatedItem$unwrap(validatedItem).id;
			return _Utils_Tuple2(
				id,
				A4(
					$elm$html$Html$Lazy$lazy3,
					$author$project$Common$Image$Editor$fileItem,
					translations,
					_Utils_eq(id, selectedId),
					validatedItem));
		};
		var _v0 = state.mediaList;
		switch (_v0.$) {
			case 'Loading':
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			case 'Loaded':
				var loadedMedia = _v0.a;
				return A2(
					$elm$html$Html$Keyed$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-list')
						]),
					A2($elm$core$List$map, toFileItem, loadedMedia));
			default:
				return $elm$html$Html$text(
					$author$project$Translations$Listings$BrandPages$failedToLoadMedia(translations));
		}
	});
var $author$project$Common$Image$Editor$OnConfirm = {$: 'OnConfirm'};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 'Nothing') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Image$Editor$OpenCropper = {$: 'OpenCropper'};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$FontAwesome$Solid$Icon$faDesktop = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-desktop');
var $author$project$Translations$Listings$MediaUpload$optimizeFor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_upload.optimize_for');
};
var $author$project$Translations$Listings$MediaUpload$optimizeForBoth = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_upload.optimize_for_both');
};
var $author$project$Translations$Listings$MediaUpload$optimizeForMobile = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_upload.optimize_for_mobile');
};
var $author$project$Translations$Listings$MediaUpload$optimizeForDesktop = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_upload.optimize_for_desktop');
};
var $author$project$Common$Image$Editor$OnAspectRatioChanged = function (a) {
	return {$: 'OnAspectRatioChanged', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faMobileScreenButton = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-mobile-screen-button');
var $author$project$FontAwesome$Solid$Icon$faTabletScreenButton = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-tablet-screen-button');
var $author$project$Common$Image$Editor$optimizeFor = F2(
	function (translations, state) {
		var nameAndIcon = function (ratio) {
			switch (ratio.$) {
				case 'TwentyFourToNine':
					return _Utils_Tuple2(
						$author$project$Translations$Listings$MediaUpload$optimizeForBoth(translations),
						$elm$core$Maybe$Just($author$project$FontAwesome$Solid$Icon$faTabletScreenButton));
				case 'EightTwentyToThreeTwelve':
					return _Utils_Tuple2(
						$author$project$Translations$Listings$MediaUpload$optimizeForDesktop(translations),
						$elm$core$Maybe$Just($author$project$FontAwesome$Solid$Icon$faDesktop));
				case 'SixteenToNine':
					return _Utils_Tuple2(
						$author$project$Translations$Listings$MediaUpload$optimizeForMobile(translations),
						$elm$core$Maybe$Just($author$project$FontAwesome$Solid$Icon$faMobileScreenButton));
				default:
					return _Utils_Tuple2(
						$author$project$Common$Image$Editor$ratioLabel(ratio),
						$elm$core$Maybe$Nothing);
			}
		};
		var ratios = A2($author$project$Common$Image$Validation$rulesFor, state.network, state.mediaType).aspectRatios;
		var option = function (ratio) {
			var isChecked = _Utils_eq(state.selectedAspectRatio, ratio);
			var _v0 = nameAndIcon(ratio);
			var name = _v0.a;
			var icon = _v0.b;
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-radio'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pmt-ui-radio--checked', isChecked)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$checked(isChecked),
								$elm$html$Html$Events$onCheck(
								function (_v1) {
									return $author$project$Common$Image$Editor$OnAspectRatioChanged(ratio);
								})
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-radio__label')
							]),
						_Utils_ap(
							$elm_community$maybe_extra$Maybe$Extra$toList(
								A2($elm$core$Maybe$map, $author$project$FontAwesome$Solid$Icon$render, icon)),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								])))
					]));
		};
		return ($elm$core$List$length(ratios) > 1) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$MediaUpload$optimizeFor(translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-optimize')
						]),
					A2($elm$core$List$map, option, ratios))
				])) : $elm$html$Html$text('');
	});
var $author$project$Common$Image$Editor$OnMediaSearch = function (a) {
	return {$: 'OnMediaSearch', a: a};
};
var $author$project$Translations$Listings$BrandPages$searchMediaLibraryPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.search_media_library_placeholder');
};
var $author$project$Common$Image$Editor$pickerLightbox = F3(
	function (translations, viewConfig, state) {
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-container')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Image$Editor$optimizeFor, translations, state),
					A2($author$project$Common$Image$Editor$dropZone, translations, state),
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$BrandPages$searchMediaLibraryPlaceholder(translations),
						$author$project$PinMeTo$Ui$Form$Input$search(
							{value: state.searchTerm, onChange: $author$project$Common$Image$Editor$OnMediaSearch}))),
					A2($author$project$Common$Image$Editor$fileList, translations, state)
				]));
		var header = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(viewConfig.title)
						]))
				]));
		var footer = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-footer')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Common$Image$Editor$OnCancel,
						A2(
							$author$project$PinMeTo$Ui$Button$withGhostStyle,
							$author$project$PinMeTo$Ui$Button$GhostNeutral,
							$author$project$PinMeTo$Ui$Button$buttonGhost(
								$author$project$Translations$Listings$BrandPages$cancel(translations))))),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$disabledIfTrue,
						$elm_community$maybe_extra$Maybe$Extra$isNothing(state.selectedMedia),
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Common$Image$Editor$OpenCropper,
							$author$project$PinMeTo$Ui$Button$buttonSecondary(
								$author$project$Translations$Listings$BrandPages$crop(translations))))),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$disabledIfTrue,
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$not,
								A2($elm$core$Maybe$map, $author$project$Common$Validators$ValidatedItem$isValid, state.selectedMedia))),
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Common$Image$Editor$OnConfirm,
							$author$project$PinMeTo$Ui$Button$buttonPrimary(viewConfig.confirmLabel))))
				]));
		return $author$project$PinMeTo$Ui$Lightbox$render(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$Medium,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					footer,
					$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
						$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withHeader,
								header,
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$Common$Image$Editor$OnCancel,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{title: '', content: content}))))))));
	});
var $author$project$Translations$Listings$BrandPages$back = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.back');
};
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$Move = {$: 'Move'};
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$Move = {$: 'Move'};
var $author$project$PinMeTo$Ui$ImageCropper$Image$Cover = {$: 'Cover'};
var $author$project$PinMeTo$Ui$ImageCropper$Image$Image = function (a) {
	return {$: 'Image', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$Image$init = function (_v0) {
	var src = _v0.src;
	return $author$project$PinMeTo$Ui$ImageCropper$Image$Image(
		{alt: '', src: src, hidden: false, movable: false, scalable: false, skewable: false, rotatable: false, translatable: false, boundToSelection: false, initialCenterSize: $author$project$PinMeTo$Ui$ImageCropper$Image$Cover});
};
var $author$project$PinMeTo$Ui$ImageCropper$Canvas$Canvas = function (a) {
	return {$: 'Canvas', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$Canvas$init = $author$project$PinMeTo$Ui$ImageCropper$Canvas$Canvas(
	{hidden: false, disabled: false, scaleStep: 0.1, background: false});
var $author$project$PinMeTo$Ui$ImageCropper$CrossHair$CrossHair = function (a) {
	return {$: 'CrossHair', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$CrossHair$init = $author$project$PinMeTo$Ui$ImageCropper$CrossHair$CrossHair(
	{hidden: true, centered: true});
var $author$project$PinMeTo$Ui$ImageCropper$Selection$Free = {$: 'Free'};
var $author$project$PinMeTo$Ui$ImageCropper$Selection$Selection = function (a) {
	return {$: 'Selection', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$Selection$init = function (_v0) {
	var initialCoverage = _v0.initialCoverage;
	var initialAspectRatio = _v0.initialAspectRatio;
	var height = _v0.height;
	var width = _v0.width;
	return $author$project$PinMeTo$Ui$ImageCropper$Selection$Selection(
		{x: 0, y: 0, width: width, height: height, hidden: false, dynamic: false, movable: false, precise: false, keyboard: false, multiple: false, outlined: false, resizable: false, aspectRatio: $author$project$PinMeTo$Ui$ImageCropper$Selection$Free, initialCoverage: initialCoverage, initialAspectRatio: initialAspectRatio});
};
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$None = {$: 'None'};
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$CropperHandle = function (a) {
	return {$: 'CropperHandle', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$init = $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$CropperHandle(
	{plain: false, action: $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$None, hidden: false});
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$None = {$: 'None'};
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$SelectionHandle = function (a) {
	return {$: 'SelectionHandle', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$init = $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$SelectionHandle(
	{action: $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$None, hidden: false, resizers: _List_Nil});
var $author$project$PinMeTo$Ui$ImageCropper$Grid$Grid = function (a) {
	return {$: 'Grid', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$Grid$init = $author$project$PinMeTo$Ui$ImageCropper$Grid$Grid(
	{rows: 0, hidden: false, columns: 0, covered: false, bordered: false});
var $author$project$PinMeTo$Ui$ImageCropper$Shade$Shade = function (a) {
	return {$: 'Shade', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$Shade$init = $author$project$PinMeTo$Ui$ImageCropper$Shade$Shade(
	{hidden: false});
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper = function (a) {
	return {$: 'Cropper', a: a};
};
var $author$project$PinMeTo$Ui$ImageCropper$Selection$OneToOne = {$: 'OneToOne'};
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$view = function (_v0) {
	var uid = _v0.uid;
	return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
		{
			uid: uid,
			gridConfig: $author$project$PinMeTo$Ui$ImageCropper$Grid$init,
			imageConfig: $author$project$PinMeTo$Ui$ImageCropper$Image$init(
				{src: ''}),
			shadeConfig: $author$project$PinMeTo$Ui$ImageCropper$Shade$init,
			canvasConfig: $author$project$PinMeTo$Ui$ImageCropper$Canvas$init,
			handleConfig: $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$init,
			crossHairConfig: $author$project$PinMeTo$Ui$ImageCropper$CrossHair$init,
			selectionConfig: $author$project$PinMeTo$Ui$ImageCropper$Selection$init(
				{width: 0, height: 0, initialCoverage: 0.5, initialAspectRatio: $author$project$PinMeTo$Ui$ImageCropper$Selection$OneToOne}),
			selectionHandleConfig: $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$init
		});
};
var $author$project$PinMeTo$Ui$ImageCropper$Selection$Custom = F2(
	function (a, b) {
		return {$: 'Custom', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$ImageCropper$Grid$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'bordered',
				$elm$json$Json$Encode$bool(config.bordered)),
				_Utils_Tuple2(
				'covered',
				$elm$json$Json$Encode$bool(config.covered)),
				_Utils_Tuple2(
				'columns',
				$elm$json$Json$Encode$int(config.columns)),
				_Utils_Tuple2(
				'rows',
				$elm$json$Json$Encode$int(config.rows)),
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$Image$encode = function (_v0) {
	var config = _v0.a;
	var centerSizeToString = function (cs) {
		if (cs.$ === 'Contain') {
			return 'contain';
		} else {
			return 'cover';
		}
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden)),
				_Utils_Tuple2(
				'rotatable',
				$elm$json$Json$Encode$bool(config.rotatable)),
				_Utils_Tuple2(
				'scalable',
				$elm$json$Json$Encode$bool(config.scalable)),
				_Utils_Tuple2(
				'skewable',
				$elm$json$Json$Encode$bool(config.skewable)),
				_Utils_Tuple2(
				'translatable',
				$elm$json$Json$Encode$bool(config.translatable)),
				_Utils_Tuple2(
				'initialCenterSize',
				$elm$json$Json$Encode$string(
					centerSizeToString(config.initialCenterSize))),
				_Utils_Tuple2(
				'src',
				$elm$json$Json$Encode$string(config.src)),
				_Utils_Tuple2(
				'alt',
				$elm$json$Json$Encode$string(config.alt)),
				_Utils_Tuple2(
				'bound',
				$elm$json$Json$Encode$bool(config.boundToSelection))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$Shade$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$Canvas$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden)),
				_Utils_Tuple2(
				'background',
				$elm$json$Json$Encode$bool(config.background)),
				_Utils_Tuple2(
				'disabled',
				$elm$json$Json$Encode$bool(config.disabled)),
				_Utils_Tuple2(
				'scaleStep',
				$elm$json$Json$Encode$float(config.scaleStep))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$CrossHair$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden)),
				_Utils_Tuple2(
				'centered',
				$elm$json$Json$Encode$bool(config.centered))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$Selection$aspectRatioToFloat = function (ar) {
	switch (ar.$) {
		case 'Free':
			return 0 / 0;
		case 'OneToOne':
			return 1;
		case 'FourToThree':
			return 4 / 3;
		case 'ThreeToFour':
			return 3 / 4;
		case 'SixteenToNine':
			return 16 / 9;
		case 'NineToSixteen':
			return 9 / 16;
		case 'TwentyFourToNine':
			return 24 / 9;
		default:
			var width = ar.a;
			var height = ar.b;
			return width / height;
	}
};
var $author$project$PinMeTo$Ui$ImageCropper$Selection$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden)),
				_Utils_Tuple2(
				'x',
				$elm$json$Json$Encode$int(config.x)),
				_Utils_Tuple2(
				'y',
				$elm$json$Json$Encode$int(config.y)),
				_Utils_Tuple2(
				'width',
				$elm$json$Json$Encode$int(config.width)),
				_Utils_Tuple2(
				'height',
				$elm$json$Json$Encode$int(config.height)),
				_Utils_Tuple2(
				'initialCoverage',
				$elm$json$Json$Encode$float(config.initialCoverage)),
				_Utils_Tuple2(
				'aspectRatio',
				$elm$json$Json$Encode$float(
					$author$project$PinMeTo$Ui$ImageCropper$Selection$aspectRatioToFloat(config.aspectRatio))),
				_Utils_Tuple2(
				'initialAspectRatio',
				$elm$json$Json$Encode$float(
					$author$project$PinMeTo$Ui$ImageCropper$Selection$aspectRatioToFloat(config.initialAspectRatio))),
				_Utils_Tuple2(
				'dynamic',
				$elm$json$Json$Encode$bool(config.dynamic)),
				_Utils_Tuple2(
				'multiple',
				$elm$json$Json$Encode$bool(config.multiple)),
				_Utils_Tuple2(
				'keyboard',
				$elm$json$Json$Encode$bool(config.keyboard)),
				_Utils_Tuple2(
				'outlined',
				$elm$json$Json$Encode$bool(config.outlined)),
				_Utils_Tuple2(
				'movable',
				$elm$json$Json$Encode$bool(config.movable)),
				_Utils_Tuple2(
				'resizable',
				$elm$json$Json$Encode$bool(config.resizable)),
				_Utils_Tuple2(
				'precise',
				$elm$json$Json$Encode$bool(config.precise))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$cropperHandleActionToString = function (action) {
	switch (action.$) {
		case 'Move':
			return 'move';
		case 'Select':
			return 'select';
		default:
			return 'none';
	}
};
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden)),
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string(
					$author$project$PinMeTo$Ui$ImageCropper$CropperHandle$cropperHandleActionToString(config.action))),
				_Utils_Tuple2(
				'plain',
				$elm$json$Json$Encode$bool(config.plain))
			]));
};
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$selectionHandleActionToString = function (action) {
	switch (action.$) {
		case 'Move':
			return 'move';
		case 'Select':
			return 'select';
		default:
			return 'none';
	}
};
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$encode = function (_v0) {
	var config = _v0.a;
	var encodeResizer = function (_v2) {
		var variant = _v2.a.variant;
		var variantString = function () {
			switch (variant.$) {
				case 'North':
					return 'n-resize';
				case 'East':
					return 'e-resize';
				case 'South':
					return 's-resize';
				case 'West':
					return 'w-resize';
				case 'NorthEast':
					return 'ne-resize';
				case 'NorthWest':
					return 'nw-resize';
				case 'SouthEast':
					return 'se-resize';
				default:
					return 'sw-resize';
			}
		}();
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'variant',
					$elm$json$Json$Encode$string(variantString))
				]));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'hidden',
				$elm$json$Json$Encode$bool(config.hidden)),
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string(
					$author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$selectionHandleActionToString(config.action))),
				_Utils_Tuple2(
				'resizers',
				A2($elm$json$Json$Encode$list, encodeResizer, config.resizers))
			]));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$render = function (_v0) {
	var crossHairConfig = _v0.a.crossHairConfig;
	var selectionConfig = _v0.a.selectionConfig;
	var handleConfig = _v0.a.handleConfig;
	var gridConfig = _v0.a.gridConfig;
	var selectionHandleConfig = _v0.a.selectionHandleConfig;
	var shadeConfig = _v0.a.shadeConfig;
	var imageConfig = _v0.a.imageConfig;
	var canvasConfig = _v0.a.canvasConfig;
	var uid = _v0.a.uid;
	var selectionHandle = $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$encode(selectionHandleConfig);
	var cropperHandle = $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$encode(handleConfig);
	var selection = $author$project$PinMeTo$Ui$ImageCropper$Selection$encode(selectionConfig);
	var crossHair = $author$project$PinMeTo$Ui$ImageCropper$CrossHair$encode(crossHairConfig);
	var canvas = $author$project$PinMeTo$Ui$ImageCropper$Canvas$encode(canvasConfig);
	var shade = $author$project$PinMeTo$Ui$ImageCropper$Shade$encode(shadeConfig);
	var image = $author$project$PinMeTo$Ui$ImageCropper$Image$encode(imageConfig);
	var grid = $author$project$PinMeTo$Ui$ImageCropper$Grid$encode(gridConfig);
	return A3(
		$elm$html$Html$node,
		'pmt-image-cropper',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$property, 'canvas', canvas),
				A2($elm$html$Html$Attributes$property, 'image', image),
				A2($elm$html$Html$Attributes$property, 'shade', shade),
				A2($elm$html$Html$Attributes$property, 'grid', grid),
				A2($elm$html$Html$Attributes$property, 'cropperHandle', cropperHandle),
				A2($elm$html$Html$Attributes$property, 'selectionHandle', selectionHandle),
				A2($elm$html$Html$Attributes$property, 'selection', selection),
				A2($elm$html$Html$Attributes$property, 'crossHair', crossHair),
				$elm$html$Html$Attributes$id(uid)
			]),
		_List_Nil);
};
var $author$project$PinMeTo$Ui$ImageCropper$Image$Contain = {$: 'Contain'};
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$withImage = F2(
	function (imageConfig, _v0) {
		var cropperConfig = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
			_Utils_update(
				cropperConfig,
				{imageConfig: imageConfig}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$withPlain = F2(
	function (isPlain, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$CropperHandle(
			_Utils_update(
				config,
				{plain: isPlain}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$withAction = F2(
	function (action, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$CropperHandle(
			_Utils_update(
				config,
				{action: action}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$withAction = F2(
	function (action, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$SelectionHandle(
			_Utils_update(
				config,
				{action: action}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$withCanvas = F2(
	function (canvasConfig, _v0) {
		var cropperConfig = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
			_Utils_update(
				cropperConfig,
				{canvasConfig: canvasConfig}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$withHandle = F2(
	function (handleConfig, _v0) {
		var cropperConfig = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
			_Utils_update(
				cropperConfig,
				{handleConfig: handleConfig}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$CrossHair$withHidden = F2(
	function (isHidden, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$CrossHair$CrossHair(
			_Utils_update(
				config,
				{hidden: isHidden}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Image$withMovable = F2(
	function (isMovable, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Image$Image(
			_Utils_update(
				config,
				{movable: isMovable}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Selection$withOutline = F2(
	function (isOutlined, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Selection$Selection(
			_Utils_update(
				config,
				{outlined: isOutlined}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$CrossHair$withCentered = F2(
	function (isCentered, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$CrossHair$CrossHair(
			_Utils_update(
				config,
				{centered: isCentered}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Image$withScalable = F2(
	function (isScalable, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Image$Image(
			_Utils_update(
				config,
				{scalable: isScalable}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Selection$SixteenToNine = {$: 'SixteenToNine'};
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$withCrossHair = F2(
	function (crossHairConfig, _v0) {
		var cropperConfig = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
			_Utils_update(
				cropperConfig,
				{crossHairConfig: crossHairConfig}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Canvas$withScaleStep = F2(
	function (scaleStep, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Canvas$Canvas(
			_Utils_update(
				config,
				{scaleStep: scaleStep}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$withSelection = F2(
	function (selectionConfig, _v0) {
		var cropperConfig = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
			_Utils_update(
				cropperConfig,
				{selectionConfig: selectionConfig}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Canvas$withBackground = F2(
	function (background, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Canvas$Canvas(
			_Utils_update(
				config,
				{background: background}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Canvas$withIsDisabled = F2(
	function (isDisabled, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Canvas$Canvas(
			_Utils_update(
				config,
				{disabled: isDisabled}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Selection$TwentyFourToNine = {$: 'TwentyFourToNine'};
var $author$project$PinMeTo$Ui$ImageCropper$Image$withTranslatable = F2(
	function (isTranslatable, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Image$Image(
			_Utils_update(
				config,
				{translatable: isTranslatable}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Cropper$withSelectionHandle = F2(
	function (selectionHandleConfig, _v0) {
		var cropperConfig = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$Cropper(
			_Utils_update(
				cropperConfig,
				{selectionHandleConfig: selectionHandleConfig}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Image$withBoundToSelection = F2(
	function (isBound, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Image$Image(
			_Utils_update(
				config,
				{boundToSelection: isBound}));
	});
var $author$project$PinMeTo$Ui$ImageCropper$Image$withInitialCenterSize = F2(
	function (size, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ImageCropper$Image$Image(
			_Utils_update(
				config,
				{initialCenterSize: size}));
	});
var $author$project$Common$Image$Cropper$view = F2(
	function (uid, _v0) {
		var aspectRatio = _v0.aspectRatio;
		var imageSrc = _v0.imageSrc;
		return $author$project$PinMeTo$Ui$ImageCropper$Cropper$render(
			A2(
				$author$project$PinMeTo$Ui$ImageCropper$Cropper$withSelectionHandle,
				A2($author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$withAction, $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$Move, $author$project$PinMeTo$Ui$ImageCropper$SelectionHandle$init),
				A2(
					$author$project$PinMeTo$Ui$ImageCropper$Cropper$withSelection,
					A2(
						$author$project$PinMeTo$Ui$ImageCropper$Selection$withOutline,
						true,
						$author$project$PinMeTo$Ui$ImageCropper$Selection$init(
							{
								width: 0,
								height: 0,
								initialCoverage: 0.9,
								initialAspectRatio: function () {
									switch (aspectRatio.$) {
										case 'TwentyFourToNine':
											return $author$project$PinMeTo$Ui$ImageCropper$Selection$TwentyFourToNine;
										case 'EightTwentyToThreeTwelve':
											return A2($author$project$PinMeTo$Ui$ImageCropper$Selection$Custom, 820, 312);
										case 'OneToOne':
											return $author$project$PinMeTo$Ui$ImageCropper$Selection$OneToOne;
										default:
											return $author$project$PinMeTo$Ui$ImageCropper$Selection$SixteenToNine;
									}
								}()
							})),
					A2(
						$author$project$PinMeTo$Ui$ImageCropper$Cropper$withHandle,
						A2(
							$author$project$PinMeTo$Ui$ImageCropper$CropperHandle$withPlain,
							true,
							A2($author$project$PinMeTo$Ui$ImageCropper$CropperHandle$withAction, $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$Move, $author$project$PinMeTo$Ui$ImageCropper$CropperHandle$init)),
						A2(
							$author$project$PinMeTo$Ui$ImageCropper$Cropper$withCrossHair,
							A2(
								$author$project$PinMeTo$Ui$ImageCropper$CrossHair$withCentered,
								true,
								A2($author$project$PinMeTo$Ui$ImageCropper$CrossHair$withHidden, false, $author$project$PinMeTo$Ui$ImageCropper$CrossHair$init)),
							A2(
								$author$project$PinMeTo$Ui$ImageCropper$Cropper$withCanvas,
								A2(
									$author$project$PinMeTo$Ui$ImageCropper$Canvas$withScaleStep,
									0.01,
									A2(
										$author$project$PinMeTo$Ui$ImageCropper$Canvas$withIsDisabled,
										false,
										A2($author$project$PinMeTo$Ui$ImageCropper$Canvas$withBackground, true, $author$project$PinMeTo$Ui$ImageCropper$Canvas$init))),
								A2(
									$author$project$PinMeTo$Ui$ImageCropper$Cropper$withImage,
									A2(
										$author$project$PinMeTo$Ui$ImageCropper$Image$withInitialCenterSize,
										$author$project$PinMeTo$Ui$ImageCropper$Image$Contain,
										A2(
											$author$project$PinMeTo$Ui$ImageCropper$Image$withBoundToSelection,
											false,
											A2(
												$author$project$PinMeTo$Ui$ImageCropper$Image$withScalable,
												true,
												A2(
													$author$project$PinMeTo$Ui$ImageCropper$Image$withTranslatable,
													true,
													A2(
														$author$project$PinMeTo$Ui$ImageCropper$Image$withMovable,
														true,
														$author$project$PinMeTo$Ui$ImageCropper$Image$init(
															{src: imageSrc})))))),
									$author$project$PinMeTo$Ui$ImageCropper$Cropper$view(
										{uid: uid}))))))));
	});
var $author$project$Common$Image$Editor$CropImage = {$: 'CropImage'};
var $author$project$Translations$Listings$BrandPages$cropAndSave = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.crop_and_save');
};
var $author$project$Common$Image$Editor$CloseCropper = {$: 'CloseCropper'};
var $author$project$Common$Image$Editor$ResetCropper = {$: 'ResetCropper'};
var $author$project$Translations$Listings$BrandPages$scrollToZoom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.scroll_to_zoom');
};
var $author$project$FontAwesome$Regular$Icon$faArrowRotateLeft = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-arrow-rotate-left');
var $author$project$Translations$Listings$BrandPages$savingYourNewImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.saving_your_new_image');
};
var $author$project$Common$Image$Editor$cropperLightbox = F3(
	function (translations, viewConfig, state) {
		var resetButton = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withIconBefore,
						$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faArrowRotateLeft),
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Common$Image$Editor$ResetCropper,
							$author$project$PinMeTo$Ui$Button$buttonGhost(
								$author$project$Translations$General$reset(translations)))))
				]));
		var selected = A2($elm$core$Maybe$map, $author$project$Common$Validators$ValidatedItem$unwrap, state.selectedMedia);
		var cropper = state.cropperRefreshing ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__image-cropper__cropper')
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__image-cropper__cropper')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Image$Cropper$view,
					state.cropperId,
					{
						width: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.metaData;
									},
									function ($) {
										return $.width;
									}),
								selected)),
						height: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.metaData;
									},
									function ($) {
										return $.height;
									}),
								selected)),
						imageSrc: A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.url;
								},
								selected)),
						aspectRatio: state.selectedAspectRatio
					})
				]));
		var content = state.savingCroppedImage ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__image-cropper__saving-image-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Spinner$spinner,
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$savingYourNewImage(translations))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__image-cropper__container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Note,
						$author$project$PinMeTo$Ui$Alert$plain(
							$author$project$Translations$Listings$BrandPages$scrollToZoom(translations)))),
					cropper,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-brand-management__image-cropper__radio-buttons')
						]),
					_List_fromArray(
						[resetButton]))
				]));
		var header = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(viewConfig.cropTitle)
						]))
				]));
		var footer = state.savingCroppedImage ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__file-uploader-footer')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withGhostStyle,
						$author$project$PinMeTo$Ui$Button$GhostNeutral,
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Common$Image$Editor$CloseCropper,
							$author$project$PinMeTo$Ui$Button$buttonGhost(
								$author$project$Translations$Listings$BrandPages$back(translations))))),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Common$Image$Editor$CropImage,
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$Listings$BrandPages$cropAndSave(translations))))
				]));
		return $author$project$PinMeTo$Ui$Lightbox$render(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$Medium,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					footer,
					$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
						$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withHeader,
								header,
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$Common$Image$Editor$CloseCropper,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{title: '', content: content}))))))));
	});
var $author$project$Common$Image$Editor$view = F3(
	function (translations, viewConfig, state) {
		var _v0 = state.step;
		if (_v0.$ === 'PickingMedia') {
			return A3($author$project$Common$Image$Editor$pickerLightbox, translations, viewConfig, state);
		} else {
			return A3($author$project$Common$Image$Editor$cropperLightbox, translations, viewConfig, state);
		}
	});
var $author$project$PinMeTo$Ui$Skeleton$view = function (_v0) {
	var isLoading = _v0.isLoading;
	var children = _v0.children;
	var attributes = _v0.attributes;
	var shimmer = _v0.shimmer;
	var shimmerClasses = function () {
		switch (shimmer.$) {
			case 'Pulse':
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-skeleton'),
						$elm$html$Html$Attributes$class('pmt-ui-skeleton--loading-pulse-shimmer')
					]);
			case 'Gradient':
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-skeleton'),
						$elm$html$Html$Attributes$class('pmt-ui-skeleton--loading-gradient-shimmer')
					]);
			default:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-skeleton'),
						$elm$html$Html$Attributes$class('pmt-ui-skeleton--loading-no-shimmer')
					]);
		}
	}();
	var attrs = _Utils_ap(shimmerClasses, attributes);
	return (!isLoading) ? A2($elm$html$Html$div, _List_Nil, children) : A2($elm$html$Html$div, attrs, children);
};
var $author$project$PinMeTo$Ui$Button$Blank = {$: 'Blank'};
var $author$project$Translations$Listings$BrandPages$publish = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.publish');
};
var $author$project$PinMeTo$Ui$Skeleton$Gradient = {$: 'Gradient'};
var $author$project$FontAwesome$Regular$Icon$faPencil = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-pencil');
var $author$project$PinMeTo$Ui$Button$Link = function (a) {
	return {$: 'Link', a: a};
};
var $author$project$PinMeTo$Ui$Button$withHref = F2(
	function (href, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					type_: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Button$Link(
							{href: href, target: $elm$core$Maybe$Nothing}))
				}));
	});
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$EditorMsg = function (a) {
	return {$: 'EditorMsg', a: a};
};
var $author$project$PinMeTo$Ui$Button$withTarget = F2(
	function (target, _v0) {
		var config = _v0.a;
		var _v1 = config.type_;
		if ((_v1.$ === 'Just') && (_v1.a.$ === 'Link')) {
			var href = _v1.a.a.href;
			return $author$project$PinMeTo$Ui$Button$Config(
				_Utils_update(
					config,
					{
						type_: $elm$core$Maybe$Just(
							$author$project$PinMeTo$Ui$Button$Link(
								{
									href: href,
									target: $elm$core$Maybe$Just(target)
								}))
					}));
		} else {
			return $author$project$PinMeTo$Ui$Button$Config(config);
		}
	});
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnCoverClick = {$: 'OnCoverClick'};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnCoverLoaded = {$: 'OnCoverLoaded'};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnProfileClick = {$: 'OnProfileClick'};
var $author$project$Translations$Listings$BrandPages$cropCoverImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.crop_cover_image');
};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnProfileLoaded = {$: 'OnProfileLoaded'};
var $author$project$Translations$Listings$BrandPages$brandPageLinkButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.brand_page_link_button');
};
var $author$project$Translations$Listings$BrandPages$addCoverImageForFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.add_cover_image_for_facebook');
};
var $author$project$Translations$Listings$BrandPages$cropProfileImageFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.crop_profile_image_facebook');
};
var $author$project$FontAwesome$Regular$Icon$faArrowUpRightFromSquare = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-arrow-up-right-from-square');
var $author$project$Translations$Listings$BrandPages$addProfileImageForFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.add_profile_image_for_facebook');
};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$view = F3(
	function (user, translations, _v0) {
		var coverLoaded = _v0.coverLoaded;
		var profileLoaded = _v0.profileLoaded;
		var editor = _v0.editor;
		var brandPage = _v0.brandPage;
		var getMediaPreviewWithDefault = function (maybeMedia) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.previewUrl;
					},
					maybeMedia));
		};
		var brandPageUrl = $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withIconAfter,
				$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faArrowUpRightFromSquare),
				A2(
					$author$project$PinMeTo$Ui$Button$withTarget,
					$author$project$PinMeTo$Ui$Button$Blank,
					A2(
						$author$project$PinMeTo$Ui$Button$withHref,
						brandPage.brandPageUrl,
						A2(
							$author$project$PinMeTo$Ui$Button$withSize,
							$author$project$PinMeTo$Ui$Button$Small,
							$author$project$PinMeTo$Ui$Button$buttonGhost(
								$author$project$Translations$Listings$BrandPages$brandPageLinkButton(translations)))))));
		var userIsOwner = A2($author$project$Data$User$hasRole, user, $author$project$Data$User$Owner);
		var skeletonImg = F3(
			function (img, attributes, isLoading) {
				return $author$project$PinMeTo$Ui$Skeleton$view(
					{
						shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
						children: _List_fromArray(
							[img]),
						isLoading: isLoading,
						attributes: attributes
					});
			});
		var profileImage = function () {
			var profileImageClass = userIsOwner ? 'pmt-brand-management__brand-media-info__profile__facebook' : 'pmt-brand-management__brand-media-info__profile__not-owner';
			var profileImageAttributes = _List_fromArray(
				[
					$elm$html$Html$Attributes$src(
					getMediaPreviewWithDefault(brandPage.media.profileImage)),
					$elm$html$Html$Attributes$class(profileImageClass),
					A2(
					$elm$html$Html$Events$on,
					'load',
					$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnProfileLoaded))
				]);
			var profileOverlay = userIsOwner ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__profile__overlay')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__edit-container')
							]),
						_List_fromArray(
							[
								$author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faPencil)
							]))
					])) : $elm$html$Html$text('');
			var msg = userIsOwner ? $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnProfileClick : $author$project$BrandManagement$Facebook$View$BrandMediaInfo$NoOp;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__profile-container'),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						A3(
						skeletonImg,
						A2($elm$html$Html$img, profileImageAttributes, _List_Nil),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(profileImageClass)
							]),
						!profileLoaded),
						profileOverlay
					]));
		}();
		var imageEditor = function () {
			if (editor.$ === 'Just') {
				var _v2 = editor.a;
				var mediaType = _v2.a;
				var state = _v2.b;
				return A2(
					$elm$html$Html$map,
					$author$project$BrandManagement$Facebook$View$BrandMediaInfo$EditorMsg,
					A3(
						$author$project$Common$Image$Editor$view,
						translations,
						{
							title: function () {
								if (mediaType.$ === 'Profile') {
									return $author$project$Translations$Listings$BrandPages$addProfileImageForFacebook(translations);
								} else {
									return $author$project$Translations$Listings$BrandPages$addCoverImageForFacebook(translations);
								}
							}(),
							cropTitle: function () {
								if (mediaType.$ === 'Profile') {
									return $author$project$Translations$Listings$BrandPages$cropProfileImageFacebook(translations);
								} else {
									return $author$project$Translations$Listings$BrandPages$cropCoverImage(translations);
								}
							}(),
							confirmLabel: $author$project$Translations$Listings$BrandPages$publish(translations)
						},
						state));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var coverImage = function () {
			var editOverLay = userIsOwner ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__cover__overlay')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__edit-container')
							]),
						_List_fromArray(
							[
								$author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faPencil),
								$elm$html$Html$text(
								$author$project$Translations$Listings$BrandPages$edit(translations))
							]))
					])) : $elm$html$Html$text('');
			var coverClass = userIsOwner ? 'pmt-brand-management__brand-media-info__cover' : 'pmt-brand-management__brand-media-info__cover-not-owner';
			var msg = userIsOwner ? $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnCoverClick : $author$project$BrandManagement$Facebook$View$BrandMediaInfo$NoOp;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__cover-container'),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						A3(
						skeletonImg,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									getMediaPreviewWithDefault(brandPage.media.coverImage)),
									$elm$html$Html$Attributes$class(coverClass),
									A2(
									$elm$html$Html$Events$on,
									'load',
									$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnCoverLoaded))
								]),
							_List_Nil),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(coverClass)
							]),
						!coverLoaded),
						editOverLay
					]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__container')
				]),
			_List_fromArray(
				[
					coverImage,
					profileImage,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__brand-page-info')
						]),
					_List_fromArray(
						[
							brandPageUrl,
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__container__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($elm$core$String$replace, 'https://', '', brandPage.brandPageUrl))
								]))
						])),
					imageEditor
				]));
	});
var $author$project$RemoteData$unpack = F3(
	function (_default, f, m) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unpack,
			_default,
			f,
			$author$project$RemoteData$currentData(m));
	});
var $author$project$Translations$Listings$BrandPages$webhook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.webhook');
};
var $author$project$Translations$Listings$BrandPages$confirmed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.confirmed');
};
var $author$project$Translations$Listings$BrandPages$locations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.locations');
};
var $author$project$Translations$Listings$BrandPages$unconfirmed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.unconfirmed');
};
var $author$project$BrandManagement$Facebook$Model$BrandMediaInfoMsg = F2(
	function (a, b) {
		return {$: 'BrandMediaInfoMsg', a: a, b: b};
	});
var $author$project$Translations$Listings$BrandPages$customCoverImages = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.custom_cover_images');
};
var $author$project$Translations$Listings$Tasks$brandPageConflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.brand_page_conflicts');
};
var $author$project$Translations$Listings$BrandPages$customProfileImagesFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.custom_profile_images_facebook');
};
var $author$project$BrandManagement$Facebook$Model$DisplayCoverImageResetLightBox = function (a) {
	return {$: 'DisplayCoverImageResetLightBox', a: a};
};
var $author$project$BrandManagement$Facebook$Model$DisplayProfileImageResetLightBox = function (a) {
	return {$: 'DisplayProfileImageResetLightBox', a: a};
};
var $author$project$BrandManagement$Facebook$View$BrandListView$brandCard = F5(
	function (_v0, page, _v1, summary, infoModel) {
		var user = _v0.user;
		var translations = _v0.translations;
		var siteName = _v0.siteName;
		var profileStatus = _v1.profileStatus;
		var coverStatus = _v1.coverStatus;
		var brandCardImageInfo = function () {
			var getLocationNumberForStatus = function (status) {
				return A2(
					$author$project$RemoteData$map,
					function (s) {
						return A2($elm$core$Maybe$withDefault, 0, s.location);
					},
					status);
			};
			var getLocationStatusNumberString = function (statusList) {
				return A3(
					$author$project$RemoteData$unpack,
					$elm$core$Basics$always('(...)'),
					function (num) {
						return '(' + ($elm$core$String$fromInt(num) + ')');
					},
					getLocationNumberForStatus(statusList));
			};
			var profileImageNumber = getLocationStatusNumberString(profileStatus);
			var coverImageNumber = getLocationStatusNumberString(coverStatus);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-media-information')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-media-information-row')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$disabledIfTrue,
									A2(
										$author$project$RemoteData$withDefault,
										true,
										A2(
											$author$project$RemoteData$map,
											$elm$core$Basics$eq(0),
											getLocationNumberForStatus(profileStatus))),
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$BrandManagement$Facebook$Model$DisplayProfileImageResetLightBox(page.id),
											A2(
												$author$project$PinMeTo$Ui$Button$withGhostStyle,
												$author$project$PinMeTo$Ui$Button$GhostNeutral,
												$author$project$PinMeTo$Ui$Button$buttonGhost(
													$author$project$Translations$Listings$BrandPages$customProfileImagesFacebook(translations) + (' ' + profileImageNumber)))))))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-media-information-row')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$disabledIfTrue,
									A2(
										$author$project$RemoteData$withDefault,
										true,
										A2(
											$author$project$RemoteData$map,
											$elm$core$Basics$eq(0),
											getLocationNumberForStatus(coverStatus))),
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$BrandManagement$Facebook$Model$DisplayCoverImageResetLightBox(page.id),
											A2(
												$author$project$PinMeTo$Ui$Button$withGhostStyle,
												$author$project$PinMeTo$Ui$Button$GhostNeutral,
												$author$project$PinMeTo$Ui$Button$buttonGhost(
													$author$project$Translations$Listings$BrandPages$customCoverImages(translations) + (' ' + coverImageNumber)))))))
							]))
					]));
		}();
		var hideExtraInfo = user.isDemo || A3(
			$elm$core$Basics$composeR,
			A2($author$project$Util$flip, $author$project$Data$User$hasRole, $author$project$Data$User$CustomerSuccess),
			$elm$core$Basics$not,
			user);
		var conflictInfo = function () {
			var redirectUrl = '/listings/' + ($author$project$Data$SiteName$toString(siteName) + '/conflicts/facebook/brandpage');
			return (A2($author$project$Data$User$hasRole, user, $author$project$Data$User$Owner) && page.hasDataDiff) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__conflict-button-container')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$withTarget,
							$author$project$PinMeTo$Ui$Button$Blank,
							A2(
								$author$project$PinMeTo$Ui$Button$withHref,
								redirectUrl,
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostDanger,
									$author$project$PinMeTo$Ui$Button$buttonGhost(
										$author$project$Translations$Listings$Tasks$brandPageConflicts(translations))))))
					])) : $elm$html$Html$text('');
		}();
		var attributes = hideExtraInfo ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-brand-management__webhook-info pmt-brand-management__webhook-info--stacked'),
				A2($elm$html$Html$Attributes$style, 'display', 'none')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-brand-management__webhook-info pmt-brand-management__webhook-info--stacked')
			]);
		var mediaInfo = A2(
			$elm$html$Html$map,
			$author$project$BrandManagement$Facebook$Model$BrandMediaInfoMsg(infoModel.brandPage.brandPageId),
			A3($author$project$BrandManagement$Facebook$View$BrandMediaInfo$view, user, translations, infoModel));
		var infoRow = F2(
			function (label, value) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label + ': ')
								])),
							$elm$html$Html$text(value)
						]));
			});
		var webhookAndBrandPageInfo = A2(
			$elm$html$Html$div,
			attributes,
			_List_fromArray(
				[
					A2(
					infoRow,
					$author$project$Translations$Listings$BrandPages$webhook(translations),
					page.isWebhookSubscribed ? $author$project$Translations$Listings$BrandPages$confirmed(translations) : $author$project$Translations$Listings$BrandPages$unconfirmed(translations)),
					A2(
					infoRow,
					'Brandpage status',
					page.connected ? $author$project$Translations$Listings$Directories$connected(translations) : $author$project$Translations$Listings$Directories$disconnected(translations))
				]));
		var brandCardTitle = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(page.name)
								])),
							webhookAndBrandPageInfo
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(summary.totalLocations) + (' ' + $author$project$Translations$Listings$BrandPages$locations(translations)))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__brand_card')
				]),
			_List_fromArray(
				[
					mediaInfo,
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[brandCardTitle, brandCardImageInfo, conflictInfo]))
				]));
	});
var $author$project$BrandManagement$Facebook$View$BrandListView$renderList = F6(
	function (session, summaryLookup, _v0, mediaInfoModelLookup, brandPages, searchTerm) {
		var profileStatusLookup = _v0.profileStatusLookup;
		var coverStatusLookup = _v0.coverStatusLookup;
		var renderBrandCard = function (page) {
			var profileStatus = A2(
				$elm$core$Maybe$withDefault,
				$author$project$RemoteData$Loading,
				A2($elm$core$Dict$get, page.brandPageId, profileStatusLookup));
			var coverStatus = A2(
				$elm$core$Maybe$withDefault,
				$author$project$RemoteData$Loading,
				A2($elm$core$Dict$get, page.brandPageId, coverStatusLookup));
			var card = A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A3(
					$elm$core$Maybe$map2,
					A3(
						$author$project$BrandManagement$Facebook$View$BrandListView$brandCard,
						session,
						page,
						{coverStatus: coverStatus, profileStatus: profileStatus}),
					A2($elm$core$Dict$get, page.brandPageId, summaryLookup),
					A2($elm$core$Dict$get, page.brandPageId, mediaInfoModelLookup)));
			return card;
		};
		var renderPage = function (brandPage) {
			return A2(
				$elm$html$Html$Lazy$lazy,
				function (bp) {
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-container')
							]),
						_List_fromArray(
							[
								renderBrandCard(bp)
							]));
				},
				brandPage);
		};
		return A2(
			$elm$html$Html$Keyed$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__facebook-brand_list')
				]),
			A2(
				$elm$core$List$map,
				function (page) {
					return _Utils_Tuple2(
						page.id,
						renderPage(page));
				},
				A2(
					$elm$core$List$filter,
					function (page) {
						return A2(
							$elm$core$String$contains,
							$elm$core$String$toLower(searchTerm),
							$elm$core$String$toLower(page.name));
					},
					brandPages)));
	});
var $author$project$Translations$Listings$BrandPages$failedToLoad = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.failed_to_load');
};
var $author$project$Translations$Listings$BrandPages$searchBrands = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.search_brands');
};
var $author$project$BrandManagement$Facebook$Model$OnBrandPageSearch = function (a) {
	return {$: 'OnBrandPageSearch', a: a};
};
var $author$project$BrandManagement$Facebook$View$BrandListView$view = F2(
	function (session, _v0) {
		var brandPageSearchTerm = _v0.brandPageSearchTerm;
		var brandMediaStates = _v0.brandMediaStates;
		var brandProfileImageInfo = _v0.brandProfileImageInfo;
		var brandCoverImageInfo = _v0.brandCoverImageInfo;
		var brandPages = _v0.brandPages;
		var brandPageSummaries = _v0.brandPageSummaries;
		var mediaStatuses = {coverStatusLookup: brandCoverImageInfo, profileStatusLookup: brandProfileImageInfo};
		var searchBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__search-bar-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$BrandPages$searchBrands(session.translations),
						$author$project$PinMeTo$Ui$Form$Input$search(
							{value: brandPageSearchTerm, onChange: $author$project$BrandManagement$Facebook$Model$OnBrandPageSearch})))
				]));
		var _v1 = _Utils_Tuple2(brandPageSummaries, brandPages);
		_v1$2:
		while (true) {
			_v1$3:
			while (true) {
				switch (_v1.a.$) {
					case 'Loaded':
						switch (_v1.b.$) {
							case 'Loaded':
								var summaries = _v1.a.a;
								var pages = _v1.b.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											searchBar,
											A6($author$project$BrandManagement$Facebook$View$BrandListView$renderList, session, summaries, mediaStatuses, brandMediaStates, pages, brandPageSearchTerm)
										]));
							case 'Error':
								break _v1$2;
							default:
								break _v1$3;
						}
					case 'Error':
						return $elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$failedToLoad(session.translations));
					default:
						if (_v1.b.$ === 'Error') {
							break _v1$2;
						} else {
							break _v1$3;
						}
				}
			}
			return $author$project$PinMeTo$Ui$Spinner$spinner;
		}
		return $elm$html$Html$text(
			$author$project$Translations$Listings$BrandPages$failedToLoad(session.translations));
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$Close = {$: 'Close'};
var $author$project$RemoteData$unwrap = F3(
	function (_default, f, m) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_default,
			f,
			$author$project$RemoteData$currentData(m));
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$ResetMedia = {$: 'ResetMedia'};
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$BrandPages$imageColumn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.image_column');
};
var $author$project$PinMeTo$Ui$Table$withColumns = F2(
	function (columns, config) {
		return A3($elm$core$List$foldl, $author$project$PinMeTo$Ui$Table$withColumn, config, columns);
	});
var $author$project$Translations$Listings$BrandPages$resetToBrand = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.reset_to_brand');
};
var $author$project$Translations$Listings$BrandPages$storeIdColumn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.store_id_column');
};
var $author$project$PinMeTo$Ui$Table$comparingMaybe = F3(
	function (f, a, b) {
		var _v0 = _Utils_Tuple2(
			f(a),
			f(b));
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm$core$Basics$EQ;
			} else {
				var _v4 = _v0.a;
				return $elm$core$Basics$LT;
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v3 = _v0.b;
				return $elm$core$Basics$GT;
			} else {
				var aOk = _v0.a.a;
				var bOk = _v0.b.a;
				return A2($elm$core$Basics$compare, aOk, bOk);
			}
		}
	});
var $author$project$Translations$Listings$BrandPages$descriptorColumn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.descriptor_column');
};
var $author$project$Translations$Listings$BrandPages$lightBoxSubHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.light_box_sub_heading');
};
var $author$project$Translations$Listings$BrandPages$lightBoxHeadingCover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.light_box_heading_cover');
};
var $author$project$Translations$Listings$BrandPages$lightBoxHeadingProfileFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.light_box_heading_profile_facebook');
};
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$view = F2(
	function (translations, model) {
		if (model.showLightBox) {
			var subTitleText = $author$project$Translations$Listings$BrandPages$lightBoxSubHeading(translations);
			var numSelected = $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Util$flip,
						$elm$core$List$member,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.locationId;
							},
							A2($author$project$RemoteData$withDefault, _List_Nil, model.locationContent))),
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTableState)));
			var selectedNumberString = (!(!numSelected)) ? (' (' + ($elm$core$String$fromInt(numSelected) + ')')) : '';
			var loadedBody = function (customMedia) {
				return A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTableState,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowSelection,
						function ($) {
							return $.locationId;
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withColumns,
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Table$columnWithOptions,
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Table$Compact]),
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										function (media) {
											return A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-image-preview'),
														$elm$html$Html$Attributes$src(media.previewUrl)
													]),
												_List_Nil);
										},
										$author$project$PinMeTo$Ui$Table$comparingString(
											function ($) {
												return $.previewUrl;
											}),
										$author$project$Translations$Listings$BrandPages$imageColumn(translations))),
									A2(
									$author$project$PinMeTo$Ui$Table$columnWithOptions,
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Table$Compact]),
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										function (media) {
											return $elm$html$Html$text(media.storeId);
										},
										$author$project$PinMeTo$Ui$Table$comparingString(
											function ($) {
												return $.storeId;
											}),
										$author$project$Translations$Listings$BrandPages$storeIdColumn(translations))),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (media) {
										return $elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, '', media.descriptor));
									},
									$author$project$PinMeTo$Ui$Table$comparingMaybe(
										function ($) {
											return $.descriptor;
										}),
									$author$project$Translations$Listings$BrandPages$descriptorColumn(translations))
								]),
							$author$project$PinMeTo$Ui$Table$withFullWidth(
								A2($author$project$PinMeTo$Ui$Table$view, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$UiTableMsg, customMedia)))));
			};
			var titleText = function () {
				var _v1 = model.variant;
				if (_v1.$ === 'Cover') {
					return $author$project$Translations$Listings$BrandPages$lightBoxHeadingCover(translations);
				} else {
					return $author$project$Translations$Listings$BrandPages$lightBoxHeadingProfileFacebook(translations);
				}
			}();
			var footer = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-footer')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$Close,
							A2(
								$author$project$PinMeTo$Ui$Button$withSize,
								$author$project$PinMeTo$Ui$Button$Large,
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostNeutral,
									$author$project$PinMeTo$Ui$Button$buttonGhost(
										$author$project$Translations$General$cancel(translations)))))),
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$disabledIfTrue,
							!numSelected,
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								A3(
									$author$project$RemoteData$unwrap,
									true,
									$elm$core$Basics$always(false),
									model.locationContent),
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$ResetMedia,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Large,
										$author$project$PinMeTo$Ui$Button$buttonPrimary(
											_Utils_ap(
												$author$project$Translations$Listings$BrandPages$resetToBrand(translations),
												selectedNumberString)))))))
					]));
			var title = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-title')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(titleText)
							])),
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(subTitleText)
							]))
					]));
			var content = function () {
				var body = function () {
					var _v0 = model.locationContent;
					switch (_v0.$) {
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinner;
						case 'Loaded':
							var t = _v0.a;
							return loadedBody(t);
						default:
							return $elm$html$Html$text(
								$author$project$Translations$Listings$BrandPages$failedToLoad(translations));
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-container')
						]),
					_List_fromArray(
						[
							title,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-table-container')
								]),
							_List_fromArray(
								[body]))
						]));
			}();
			return $author$project$PinMeTo$Ui$Lightbox$render(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					footer,
					$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withStyle,
							$author$project$PinMeTo$Ui$Lightbox$Medium,
							$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$Close,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{title: '', content: content})))))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$Listings$BrandPages$brandManagement = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.brand_management');
};
var $author$project$Translations$Listings$BrandPages$facebookBrandPages = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.facebook_brand_pages');
};
var $author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg = function (a) {
	return {$: 'CustomMediaResetLightBoxMsg', a: a};
};
var $author$project$BrandManagement$Facebook$View$view = F2(
	function (session, model) {
		var brandList = A2($author$project$BrandManagement$Facebook$View$BrandListView$view, session, model);
		var title = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__page-title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$brandManagement(session.translations))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$facebookBrandPages(session.translations))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__page-container')
				]),
			_List_fromArray(
				[
					title,
					brandList,
					A2(
					$elm$html$Html$map,
					$author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg,
					A2($author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$view, session.translations, model.resetMediaLightbox))
				]));
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$Open = {$: 'Open'};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$init = F2(
	function (brandPage, siteName) {
		return {editor: $elm$core$Maybe$Nothing, siteName: siteName, brandPage: brandPage, coverLoaded: false, profileLoaded: false};
	});
var $elm$file$File$name = _File_name;
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		var _v0 = A2($elm$core$Maybe$map, f, m);
		if ((_v0.$ === 'Just') && _v0.a) {
			return m;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $author$project$Listings$Ui$DropZone$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'Pick':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						config.tagger,
						A2($elm$file$File$Select$files, config.mimes, $author$project$Listings$Ui$DropZone$GotFiles)));
			case 'DragEnter':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hover: true}),
					$elm$core$Platform$Cmd$none);
			case 'DragLeave':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hover: false}),
					$elm$core$Platform$Cmd$none);
			default:
				var file = msg.a;
				var files = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hover: false}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$identity,
						$elm$core$Task$succeed(
							A2(config.onGotFiles, file, files))));
		}
	});
var $author$project$Common$Image$Editor$Cropping = {$: 'Cropping'};
var $author$project$Common$Image$Editor$logError = F2(
	function (message, error) {
		return $author$project$PinMeTo$Logger$log(
			{
				data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
				context: 'Common.Image.Editor',
				message: message
			});
	});
var $author$project$Common$Image$Editor$Cancelled = {$: 'Cancelled'};
var $author$project$Common$Image$Editor$Confirmed = function (a) {
	return {$: 'Confirmed', a: a};
};
var $author$project$Common$Image$Validation$InvalidAspectRatio = {$: 'InvalidAspectRatio'};
var $author$project$Common$Image$Validation$squareValidator = F2(
	function (mustBeSquare, m) {
		return ((!mustBeSquare) || _Utils_eq(m.metaData.width, m.metaData.height)) ? $elm$core$Result$Ok(m) : $elm$core$Result$Err($author$project$Common$Image$Validation$InvalidAspectRatio);
	});
var $author$project$Common$Image$Validation$InvalidFileType = {$: 'InvalidFileType'};
var $author$project$Common$Image$Validation$fileTypeValidator = F2(
	function (fileTypes, m) {
		return A2($elm$core$List$member, m.fileType, fileTypes) ? $elm$core$Result$Ok(m) : $elm$core$Result$Err($author$project$Common$Image$Validation$InvalidFileType);
	});
var $author$project$Common$Image$Validation$FileSizeTooLarge = {$: 'FileSizeTooLarge'};
var $author$project$Common$Image$Validation$maxBytesValidator = F2(
	function (limit, m) {
		if (limit.$ === 'Just') {
			var maxBytes = limit.a;
			return (_Utils_cmp(m.size, maxBytes) < 1) ? $elm$core$Result$Ok(m) : $elm$core$Result$Err($author$project$Common$Image$Validation$FileSizeTooLarge);
		} else {
			return $elm$core$Result$Ok(m);
		}
	});
var $author$project$Common$Image$Validation$FileSizeTooSmall = {$: 'FileSizeTooSmall'};
var $author$project$Common$Image$Validation$minBytesValidator = F2(
	function (limit, m) {
		if (limit.$ === 'Just') {
			var minBytes = limit.a;
			return (_Utils_cmp(m.size, minBytes) > -1) ? $elm$core$Result$Ok(m) : $elm$core$Result$Err($author$project$Common$Image$Validation$FileSizeTooSmall);
		} else {
			return $elm$core$Result$Ok(m);
		}
	});
var $author$project$Common$Image$Validation$FileDimensionsTooLarge = {$: 'FileDimensionsTooLarge'};
var $author$project$Common$Image$Validation$maxDimensionsValidator = F3(
	function (maxWidth, maxHeight, m) {
		var withinLimit = F2(
			function (limit, value) {
				return A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						function (l) {
							return _Utils_cmp(value, l) < 1;
						},
						limit));
			});
		return (A2(withinLimit, maxWidth, m.metaData.width) && A2(withinLimit, maxHeight, m.metaData.height)) ? $elm$core$Result$Ok(m) : $elm$core$Result$Err($author$project$Common$Image$Validation$FileDimensionsTooLarge);
	});
var $author$project$Common$Image$Validation$FileDimensionsTooSmall = {$: 'FileDimensionsTooSmall'};
var $author$project$Common$Image$Validation$minDimensionsValidator = F3(
	function (minWidth, minHeight, m) {
		return ((_Utils_cmp(m.metaData.width, minWidth) > -1) && (_Utils_cmp(m.metaData.height, minHeight) > -1)) ? $elm$core$Result$Ok(m) : $elm$core$Result$Err($author$project$Common$Image$Validation$FileDimensionsTooSmall);
	});
var $author$project$Common$Image$Validation$validatorsFor = F3(
	function (network, mediaType, aspectRatio) {
		var _v0 = A3($author$project$Common$Image$Validation$minDimensions, network, mediaType, aspectRatio);
		var minWidth = _v0.a;
		var minHeight = _v0.b;
		var rules = A2($author$project$Common$Image$Validation$rulesFor, network, mediaType);
		return _List_fromArray(
			[
				$author$project$Common$Image$Validation$minBytesValidator(rules.minBytes),
				$author$project$Common$Image$Validation$maxBytesValidator(rules.maxBytes),
				A2($author$project$Common$Image$Validation$minDimensionsValidator, minWidth, minHeight),
				A2($author$project$Common$Image$Validation$maxDimensionsValidator, rules.maxWidth, rules.maxHeight),
				$author$project$Common$Image$Validation$squareValidator(rules.mustBeSquare),
				$author$project$Common$Image$Validation$fileTypeValidator(rules.fileTypes)
			]);
	});
var $author$project$Common$Image$Editor$validators = function (state) {
	return A3($author$project$Common$Image$Validation$validatorsFor, state.network, state.mediaType, state.selectedAspectRatio);
};
var $elm_community$list_extra$List$Extra$init = function (items) {
	if (!items.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var nonEmptyList = items;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$List$reverse,
			$elm$core$List$tail(
				$elm$core$List$reverse(nonEmptyList)));
	}
};
var $author$project$Common$Image$Editor$fileSuffix = function (state) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$join(''),
			A2(
				$elm$core$Maybe$andThen,
				function (parts) {
					return ($elm$core$List$length(parts) > 1) ? $elm_community$list_extra$List$Extra$init(parts) : $elm$core$Maybe$Just(parts);
				},
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split('.'),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Common$Validators$ValidatedItem$unwrap,
							function ($) {
								return $.name;
							}),
						state.selectedMedia)))));
};
var $author$project$Common$Image$Validation$maxDimensions = F2(
	function (network, mediaType) {
		var rules = A2($author$project$Common$Image$Validation$rulesFor, network, mediaType);
		return A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, rules.maxWidth, rules.maxHeight);
	});
var $author$project$Common$Image$Editor$cropRequest = function (state) {
	var maxDimensions = function () {
		var _v0 = A2($author$project$Common$Image$Validation$maxDimensions, state.network, state.mediaType);
		if (_v0.$ === 'Just') {
			var _v1 = _v0.a;
			var width = _v1.a;
			var height = _v1.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'maxWidth',
					$elm$json$Json$Encode$int(width)),
					_Utils_Tuple2(
					'maxHeight',
					$elm$json$Json$Encode$int(height))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cropperId',
					$elm$json$Json$Encode$string(state.cropperId)),
					_Utils_Tuple2(
					'fileSuffix',
					$elm$json$Json$Encode$string(
						$author$project$Common$Image$Editor$fileSuffix(state)))
				]),
			maxDimensions));
};
var $author$project$Common$Image$Types$Media = function (id) {
	return function (name) {
		return function (previewUrl) {
			return function (url) {
				return function (fileType) {
					return function (size) {
						return function (siteName) {
							return function (metaData) {
								return function (uploadedBy) {
									return function (createdAt) {
										return {id: id, url: url, name: name, size: size, fileType: fileType, metaData: metaData, siteName: siteName, createdAt: createdAt, previewUrl: previewUrl, uploadedBy: uploadedBy};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Common$Image$Types$MediaMetaData = F2(
	function (width, height) {
		return {width: width, height: height};
	});
var $author$project$Common$Image$Types$MediaUploadInfo = F3(
	function (userId, name, email) {
		return {name: name, email: email, userId: userId};
	});
var $author$project$Common$Image$Decoders$mediaDecoder = function () {
	var mediaUploadInfoDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'userId',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Common$Image$Types$MediaUploadInfo))));
	var mediaMetaDataDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'height',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'width',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Common$Image$Types$MediaMetaData)));
	var decodeCreatedAt = A2(
		$elm$json$Json$Decode$andThen,
		function (x) {
			var parts = A2($elm$core$String$split, 'T', x);
			var first = $elm$core$List$head(parts);
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Invalid date'),
				A2(
					$elm$core$Maybe$map,
					$elm$json$Json$Decode$succeed,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$Result$toMaybe,
						A2($elm$core$Maybe$map, $justinmimbs$date$Date$fromIsoString, first))));
		},
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createdAt',
		decodeCreatedAt,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'uploadedBy',
			mediaUploadInfoDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'metaData',
				mediaMetaDataDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'siteName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'size',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'fileType',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'url',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'previewUrl',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'_id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Common$Image$Types$Media)))))))))));
}();
var $author$project$Common$Image$Decoders$mediaListDecoder = A2(
	$elm$json$Json$Decode$field,
	'data',
	$elm$json$Json$Decode$list($author$project$Common$Image$Decoders$mediaDecoder));
var $author$project$Common$Image$Commands$searchMedia = F3(
	function (_v0, searchTerm, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + ('/media/image?search=' + (searchTerm + '&skip=0')));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Common$Image$Decoders$mediaListDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Common$Image$Commands$uploadMedia = F3(
	function (_v0, msg, file) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Common$Image$Decoders$mediaDecoder),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$multipartBody(
						_List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('/listings/api/' + (siteName + '/media')))));
	});
var $author$project$Common$Image$Editor$PickingMedia = {$: 'PickingMedia'};
var $author$project$Common$Image$Editor$OnDebouncerMsg = function (a) {
	return {$: 'OnDebouncerMsg', a: a};
};
var $author$project$Common$Image$Editor$RestoreCropper = {$: 'RestoreCropper'};
var $author$project$Common$Image$Editor$OnFilesSelected = F2(
	function (a, b) {
		return {$: 'OnFilesSelected', a: a, b: b};
	});
var $author$project$Common$Image$Editor$OnMediaReceived = function (a) {
	return {$: 'OnMediaReceived', a: a};
};
var $author$project$Common$Image$Editor$OnMediaUploaded = function (a) {
	return {$: 'OnMediaUploaded', a: a};
};
var $author$project$Common$Image$Editor$update = F3(
	function (config, msg, state) {
		var stay = function (_v6) {
			var newState = _v6.a;
			var cmd = _v6.b;
			return _Utils_Tuple3(newState, cmd, $elm$core$Maybe$Nothing);
		};
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 'OnCancel':
				return _Utils_Tuple3(
					state,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just($author$project$Common$Image$Editor$Cancelled));
			case 'OnConfirm':
				var _v1 = state.selectedMedia;
				if ((_v1.$ === 'Just') && (_v1.a.$ === 'ValidItem')) {
					var media = _v1.a.a;
					return _Utils_Tuple3(
						state,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Common$Image$Editor$Confirmed(media)));
				} else {
					return _Utils_Tuple3(state, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 'RestoreCropper':
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{cropperRefreshing: false}),
						$elm$core$Platform$Cmd$none));
			case 'ResetCropper':
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{cropperRefreshing: true}),
						A2(
							$elm$core$Task$perform,
							function (_v2) {
								return $author$project$Common$Image$Editor$RestoreCropper;
							},
							$elm$core$Process$sleep(0))));
			case 'ImageDecodeFailed':
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{savingCroppedImage: false}),
						$author$project$PinMeTo$Logger$log(
							{data: '', context: 'Common.Image.Editor', message: 'Failed to decode cropped image'})));
			case 'OpenCropper':
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{step: $author$project$Common$Image$Editor$Cropping}),
						$elm$core$Platform$Cmd$none));
			case 'CloseCropper':
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{step: $author$project$Common$Image$Editor$PickingMedia, savingCroppedImage: false}),
						$elm$core$Platform$Cmd$none));
			case 'OnAspectRatioChanged':
				var ratio = msg.a;
				var newState = _Utils_update(
					state,
					{selectedAspectRatio: ratio});
				var revalidate = A2(
					$elm$core$Basics$composeR,
					$author$project$Common$Validators$ValidatedItem$unwrap,
					$author$project$Common$Validators$ValidatedItem$validate(
						$author$project$Common$Image$Editor$validators(newState)));
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							newState,
							{
								mediaList: A2(
									$author$project$RemoteData$map,
									$elm$core$List$map(revalidate),
									state.mediaList),
								selectedMedia: A2(
									$elm_community$maybe_extra$Maybe$Extra$filter,
									$author$project$Common$Image$Validation$isSelectableImage,
									A2($elm$core$Maybe$map, revalidate, state.selectedMedia))
							}),
						$elm$core$Platform$Cmd$none));
			case 'CropImage':
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{savingCroppedImage: true}),
						config.cropImage(
							$author$project$Common$Image$Editor$cropRequest(state))));
			case 'OnImageCaptured':
				var file = msg.a;
				return stay(
					_Utils_Tuple2(
						state,
						A3($author$project$Common$Image$Commands$uploadMedia, state.siteName, $author$project$Common$Image$Editor$OnMediaUploaded, file)));
			case 'OnDebouncerMsg':
				var debouncerMsg = msg.a;
				var _v3 = A2($author$project$Common$Debouncer$update, debouncerMsg, state.debouncer);
				var newDebouncerState = _v3.a;
				var newDebouncerMsg = _v3.b;
				var maybeSearchTerm = _v3.c;
				var searchCmd = function () {
					if (maybeSearchTerm.$ === 'Just') {
						var term = maybeSearchTerm.a;
						return A3($author$project$Common$Image$Commands$searchMedia, state.siteName, term, $author$project$Common$Image$Editor$OnMediaReceived);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{debouncer: newDebouncerState}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Common$Image$Editor$OnDebouncerMsg, newDebouncerMsg),
									searchCmd
								]))));
			case 'OnMediaReceived':
				if (msg.a.$ === 'Ok') {
					var media = msg.a.a;
					return stay(
						_Utils_Tuple2(
							_Utils_update(
								state,
								{
									mediaList: $author$project$RemoteData$Loaded(
										A2(
											$elm$core$List$map,
											$author$project$Common$Validators$ValidatedItem$validate(
												$author$project$Common$Image$Editor$validators(state)),
											media))
								}),
							$elm$core$Platform$Cmd$none));
				} else {
					var error = msg.a.a;
					return stay(
						_Utils_Tuple2(
							_Utils_update(
								state,
								{
									mediaList: $author$project$RemoteData$Error('failed to fetch media')
								}),
							A2($author$project$Common$Image$Editor$logError, 'Failed to fetch media', error)));
				}
			case 'OnMediaSearch':
				var term = msg.a;
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{searchTerm: term}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Common$Image$Editor$OnDebouncerMsg,
							$author$project$Common$Debouncer$trigger(term))));
			case 'OnMediaChecked':
				var item = msg.a;
				var checked = msg.b;
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{
								selectedMedia: checked ? $elm$core$Maybe$Just(
									A2(
										$author$project$Common$Validators$ValidatedItem$validate,
										$author$project$Common$Image$Editor$validators(state),
										item)) : $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none));
			case 'OnFilesSelected':
				var file = msg.a;
				var files = msg.b;
				var allFiles = A2($elm$core$List$cons, file, files);
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{
								imageNamesBeingUploaded: _Utils_ap(
									A2($elm$core$List$map, $elm$file$File$name, allFiles),
									state.imageNamesBeingUploaded)
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								A2($author$project$Common$Image$Commands$uploadMedia, state.siteName, $author$project$Common$Image$Editor$OnMediaUploaded),
								allFiles))));
			case 'OnDropZoneMsg':
				var dzMsg = msg.a;
				var _v5 = A3(
					$author$project$Listings$Ui$DropZone$update,
					{
						mimes: _List_fromArray(
							['image/png', 'image/jpeg', 'image/jpg']),
						tagger: $author$project$Common$Image$Editor$OnDropZoneMsg,
						onGotFiles: $author$project$Common$Image$Editor$OnFilesSelected
					},
					dzMsg,
					state.dropzoneState);
				var newState = _v5.a;
				var next = _v5.b;
				return stay(
					_Utils_Tuple2(
						_Utils_update(
							state,
							{dropzoneState: newState}),
						next));
			default:
				if (msg.a.$ === 'Ok') {
					var media = msg.a.a;
					return stay(
						_Utils_Tuple2(
							_Utils_update(
								state,
								{
									step: $author$project$Common$Image$Editor$PickingMedia,
									selectedMedia: A2(
										$elm_community$maybe_extra$Maybe$Extra$filter,
										$author$project$Common$Image$Validation$isSelectableImage,
										$elm$core$Maybe$Just(
											A2(
												$author$project$Common$Validators$ValidatedItem$validate,
												$author$project$Common$Image$Editor$validators(state),
												media))),
									savingCroppedImage: false,
									imageNamesBeingUploaded: A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq(media.name),
										state.imageNamesBeingUploaded)
								}),
							A3($author$project$Common$Image$Commands$searchMedia, state.siteName, state.searchTerm, $author$project$Common$Image$Editor$OnMediaReceived)));
				} else {
					var error = msg.a.a;
					return stay(
						_Utils_Tuple2(
							_Utils_update(
								state,
								{savingCroppedImage: false}),
							A2($author$project$Common$Image$Editor$logError, 'Failed to upload media', error)));
				}
		}
	});
var $author$project$Listings$Ui$DropZone$init = {hover: false};
var $author$project$Common$Image$Editor$defaultAspectRatio = F2(
	function (network, mediaType) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Image$Cropper$OneToOne,
			$elm$core$List$head(
				A2($author$project$Common$Image$Validation$rulesFor, network, mediaType).aspectRatios));
	});
var $author$project$Common$Image$Editor$init = F4(
	function (network, mediaType, siteName, cropperId) {
		return _Utils_Tuple2(
			{
				step: $author$project$Common$Image$Editor$PickingMedia,
				network: network,
				siteName: siteName,
				cropperId: cropperId,
				debouncer: A2($author$project$Common$Debouncer$init, 150.0, ''),
				mediaList: $author$project$RemoteData$Loading,
				mediaType: mediaType,
				searchTerm: '',
				dropzoneState: $author$project$Listings$Ui$DropZone$init,
				selectedMedia: $elm$core$Maybe$Nothing,
				cropperRefreshing: false,
				savingCroppedImage: false,
				selectedAspectRatio: A2($author$project$Common$Image$Editor$defaultAspectRatio, network, mediaType),
				imageNamesBeingUploaded: _List_Nil
			},
			A3($author$project$Common$Image$Commands$searchMedia, siteName, '', $author$project$Common$Image$Editor$OnMediaReceived));
	});
var $author$project$Common$Image$Validation$Facebook = {$: 'Facebook'};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$openEditor = F2(
	function (mediaType, model) {
		var _v0 = A4($author$project$Common$Image$Editor$init, $author$project$Common$Image$Validation$Facebook, mediaType, model.siteName, 'the-facebook-cropper');
		var state = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					editor: $elm$core$Maybe$Just(
						_Utils_Tuple2(mediaType, state))
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$BrandManagement$Facebook$View$BrandMediaInfo$EditorMsg, cmd));
	});
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnMediaPublished = function (a) {
	return {$: 'OnMediaPublished', a: a};
};
var $lukewestby$elm_http_builder$HttpBuilder$patch = $lukewestby$elm_http_builder$HttpBuilder$requestWithMethodAndUrl('PATCH');
var $author$project$BrandManagement$Facebook$Types$UpdatedBrandPage = F2(
	function (id, pageId) {
		return {id: id, pageId: pageId};
	});
var $author$project$BrandManagement$Facebook$Decoders$updatedBrandPageResponseDecoder = function () {
	var updatedBrandPageDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pageId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$Types$UpdatedBrandPage)));
	return A2($elm$json$Json$Decode$field, 'data', updatedBrandPageDecoder);
}();
var $author$project$BrandManagement$Facebook$Commands$setRegionalFacebookMedia = F5(
	function (_v0, mediaType, brandPageId, media, msg) {
		var siteName = _v0.a;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'media',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								_Utils_eq(mediaType, $author$project$Common$Image$Types$Cover) ? 'coverImage' : 'profileImage',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'mediaRef',
											$elm$json$Json$Encode$string(media.id)),
											_Utils_Tuple2(
											'previewUrl',
											$elm$json$Json$Encode$string(media.previewUrl)),
											_Utils_Tuple2(
											'setType',
											$elm$json$Json$Encode$string('regional')),
											_Utils_Tuple2(
											'url',
											$elm$json$Json$Encode$string(media.url))
										])))
							])))
				]));
		var url = 'api/' + (siteName + ('/network/facebook/brandpages/' + brandPageId));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$BrandManagement$Facebook$Decoders$updatedBrandPageResponseDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						body,
						$lukewestby$elm_http_builder$HttpBuilder$patch(url)))));
	});
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$out_BrandManagement_Facebook_Main_CropImage = _Platform_outgoingPort('out_BrandManagement_Facebook_Main_CropImage', $elm$core$Basics$identity);
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnProfileLoaded':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{profileLoaded: true}),
					$elm$core$Platform$Cmd$none);
			case 'OnCoverLoaded':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{coverLoaded: true}),
					$elm$core$Platform$Cmd$none);
			case 'OnProfileClick':
				return A2($author$project$BrandManagement$Facebook$View$BrandMediaInfo$openEditor, $author$project$Common$Image$Types$Profile, model);
			case 'OnCoverClick':
				return A2($author$project$BrandManagement$Facebook$View$BrandMediaInfo$openEditor, $author$project$Common$Image$Types$Cover, model);
			case 'EditorMsg':
				var editorMsg = msg.a;
				var _v1 = model.editor;
				if (_v1.$ === 'Just') {
					var _v2 = _v1.a;
					var mediaType = _v2.a;
					var state = _v2.b;
					var _v3 = A3(
						$author$project$Common$Image$Editor$update,
						{cropImage: $author$project$BrandManagement$Facebook$View$BrandMediaInfo$out_BrandManagement_Facebook_Main_CropImage},
						editorMsg,
						state);
					var newState = _v3.a;
					var cmd = _v3.b;
					var event = _v3.c;
					var editorCmd = A2($elm$core$Platform$Cmd$map, $author$project$BrandManagement$Facebook$View$BrandMediaInfo$EditorMsg, cmd);
					if (event.$ === 'Nothing') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(
										_Utils_Tuple2(mediaType, newState))
								}),
							editorCmd);
					} else {
						if (event.a.$ === 'Cancelled') {
							var _v5 = event.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{editor: $elm$core$Maybe$Nothing}),
								editorCmd);
						} else {
							var media = event.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{editor: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											editorCmd,
											A5($author$project$BrandManagement$Facebook$Commands$setRegionalFacebookMedia, model.siteName, mediaType, model.brandPage.id, media, $author$project$BrandManagement$Facebook$View$BrandMediaInfo$OnMediaPublished)
										])));
						}
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
								context: 'BrandManagement.Facebook.BrandMediaInfo',
								message: 'Failed to publish media'
							}));
				}
		}
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnLocationMediaReset = function (a) {
	return {$: 'OnLocationMediaReset', a: a};
};
var $author$project$BrandManagement$Facebook$Types$FacebookCustomLocationMedia = F6(
	function (locationId, name, storeId, url, previewUrl, descriptor) {
		return {url: url, name: name, storeId: storeId, descriptor: descriptor, locationId: locationId, previewUrl: previewUrl};
	});
var $author$project$BrandManagement$Facebook$Decoders$facebookCustomMediaDecoder = function (mediaType) {
	var key = function () {
		if (mediaType.$ === 'Cover') {
			return 'coverImage';
		} else {
			return 'profileImage';
		}
	}();
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'locationDescriptor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['networkMedia', 'facebook', key, 'previewUrl']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['networkMedia', 'facebook', key, 'url']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'storeId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$BrandManagement$Facebook$Types$FacebookCustomLocationMedia)))))));
};
var $author$project$BrandManagement$Facebook$Decoders$facebookCustomerMediaListDecoder = function (mediaType) {
	return $elm$json$Json$Decode$list(
		$author$project$BrandManagement$Facebook$Decoders$facebookCustomMediaDecoder(mediaType));
};
var $author$project$BrandManagement$Facebook$Commands$getCustomFacebookMediaForPageId = F4(
	function (mediaType, _v0, pageId, msg) {
		var siteName = _v0.a;
		var url = function () {
			if (mediaType.$ === 'Cover') {
				return 'api/' + (siteName + ('/media/cover/facebook/status/' + pageId));
			} else {
				return 'api/' + (siteName + ('/media/profile/facebook/status/' + pageId));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$BrandManagement$Facebook$Decoders$facebookCustomerMediaListDecoder(mediaType),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnCustomLocationCoverInfoReceived = function (a) {
	return {$: 'OnCustomLocationCoverInfoReceived', a: a};
};
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnCustomLocationProfileInfoReceived = function (a) {
	return {$: 'OnCustomLocationProfileInfoReceived', a: a};
};
var $author$project$BrandManagement$Facebook$Commands$putFacebookRegionalImageForLocationId = F4(
	function (mediaType, _v0, msg, locationId) {
		var siteName = _v0.a;
		var url = function () {
			if (mediaType.$ === 'Cover') {
				return 'api/' + (siteName + ('/place/' + (locationId + '/image/facebook/coverImage/regional')));
			} else {
				return 'api/' + (siteName + ('/place/' + (locationId + '/image/facebook/profileImage/regional')));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(locationId),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$put(url))));
	});
var $author$project$BrandManagement$Facebook$Commands$putFacebookRegionalCoverImageForLocationId = $author$project$BrandManagement$Facebook$Commands$putFacebookRegionalImageForLocationId($author$project$Common$Image$Types$Cover);
var $author$project$BrandManagement$Facebook$Commands$putFacebookRegionalProfileImageForLocationId = $author$project$BrandManagement$Facebook$Commands$putFacebookRegionalImageForLocationId($author$project$Common$Image$Types$Profile);
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Open':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showLightBox: true, uiTableState: $author$project$PinMeTo$Ui$Table$init}),
					$elm$core$Platform$Cmd$none);
			case 'Close':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showLightBox: false, locationContent: $author$project$RemoteData$Loading}),
					$elm$core$Platform$Cmd$none);
			case 'FetchProfileForPageId':
				var siteName = msg.a;
				var pageId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{variant: $author$project$Common$Image$Types$Profile}),
					A4($author$project$BrandManagement$Facebook$Commands$getCustomFacebookMediaForPageId, $author$project$Common$Image$Types$Profile, siteName, pageId, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnCustomLocationProfileInfoReceived));
			case 'FetchCoverForPageId':
				var siteName = msg.a;
				var pageId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{variant: $author$project$Common$Image$Types$Cover}),
					A4($author$project$BrandManagement$Facebook$Commands$getCustomFacebookMediaForPageId, $author$project$Common$Image$Types$Cover, siteName, pageId, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnCustomLocationCoverInfoReceived));
			case 'OnCustomLocationProfileInfoReceived':
				if (msg.a.$ === 'Ok') {
					var customInfo = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Loaded(customInfo)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Facebook.CustomMediaResetLightBox',
							message: 'Failed to fetch custom location profile info '
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Error('Failed to load profile info for locations')
							}),
						cmd);
				}
			case 'OnCustomLocationCoverInfoReceived':
				if (msg.a.$ === 'Ok') {
					var customInfo = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Loaded(customInfo)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Facebook.CustomMediaResetLightBox',
							message: 'Failed to fetch custom location cover info '
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Error('Failed to load cover info for locations')
							}),
						cmd);
				}
			case 'ResetMedia':
				var fn = function () {
					var _v1 = model.variant;
					if (_v1.$ === 'Cover') {
						return A2($author$project$BrandManagement$Facebook$Commands$putFacebookRegionalCoverImageForLocationId, model.siteName, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnLocationMediaReset);
					} else {
						return A2($author$project$BrandManagement$Facebook$Commands$putFacebookRegionalProfileImageForLocationId, model.siteName, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$OnLocationMediaReset);
					}
				}();
				var cmds = A2(
					$elm$core$List$map,
					fn,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTableState));
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(cmds));
			case 'UiTableMsg':
				var tableMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTableState: A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.uiTableState)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 'Ok') {
					var locationId = msg.a.a;
					var newListState = A3(
						$author$project$Util$flip,
						$author$project$PinMeTo$Ui$Table$setSelected,
						model.uiTableState,
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(locationId),
							$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTableState)));
					var newItems = A2(
						$author$project$RemoteData$map,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.locationId;
								},
								$elm$core$Basics$neq(locationId))),
						model.locationContent);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uiTableState: newListState, locationContent: newItems}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Facebook.CustomMediaResetLightBox',
							message: 'Failed to reseet location media'
						});
					return _Utils_Tuple2(model, cmd);
				}
		}
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$FetchCoverForPageId = F2(
	function (a, b) {
		return {$: 'FetchCoverForPageId', a: a, b: b};
	});
var $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$FetchProfileForPageId = F2(
	function (a, b) {
		return {$: 'FetchProfileForPageId', a: a, b: b};
	});
var $author$project$BrandManagement$Facebook$Commands$fetchFacebookBrandpage = F3(
	function (_v0, brandPageId, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + ('/network/facebook/brandpages/' + brandPageId));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'data', $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageDecoder),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Facebook$Model$OnCoverImageInfoReceived = function (a) {
	return {$: 'OnCoverImageInfoReceived', a: a};
};
var $author$project$BrandManagement$Facebook$Model$OnProfileImageInfoReceived = function (a) {
	return {$: 'OnProfileImageInfoReceived', a: a};
};
var $author$project$BrandManagement$Facebook$Model$OnFacebookBrandPageRefetched = function (a) {
	return {$: 'OnFacebookBrandPageRefetched', a: a};
};
var $author$project$BrandManagement$Facebook$Decoders$findCountDecoder = function (countType) {
	var targetedCountDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (idString) {
			return _Utils_eq(idString, countType) ? A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int)) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		},
		A2($elm$json$Json$Decode$field, '_id', $elm$json$Json$Decode$string));
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$head,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2(
				$elm$json$Json$Decode$field,
				'locations',
				$elm$json$Json$Decode$list(targetedCountDecoder))));
};
var $author$project$BrandManagement$Facebook$Types$FacebookBrandPageMediaStatus = F3(
	function (brandPageId, regional, location) {
		return {location: location, regional: regional, brandPageId: brandPageId};
	});
var $author$project$BrandManagement$Facebook$Decoders$facebookBrandPageMediaStatusDecoder = function (brandPageId) {
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$BrandManagement$Facebook$Types$FacebookBrandPageMediaStatus,
		$elm$json$Json$Decode$succeed(brandPageId),
		$author$project$BrandManagement$Facebook$Decoders$findCountDecoder('regional'),
		$author$project$BrandManagement$Facebook$Decoders$findCountDecoder('location'));
};
var $author$project$BrandManagement$Facebook$Commands$getFacebookBrandMediaStatus = F4(
	function (mediaType, _v0, _v1, msg) {
		var siteName = _v0.a;
		var id = _v1.id;
		var brandPageId = _v1.brandPageId;
		var url = function () {
			if (mediaType.$ === 'Cover') {
				return 'api/' + (siteName + ('/media/cover/facebook/status/connection/' + id));
			} else {
				return 'api/' + (siteName + ('/media/profile/facebook/status/connection/' + id));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$BrandManagement$Facebook$Decoders$facebookBrandPageMediaStatusDecoder(brandPageId),
					$elm$json$Json$Decode$succeed(brandPageId)),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Facebook$Commands$getFacebookBrandCoverImageStatus = $author$project$BrandManagement$Facebook$Commands$getFacebookBrandMediaStatus($author$project$Common$Image$Types$Cover);
var $author$project$BrandManagement$Facebook$Commands$getFacebookBrandProfileImageStatus = $author$project$BrandManagement$Facebook$Commands$getFacebookBrandMediaStatus($author$project$Common$Image$Types$Profile);
var $author$project$BrandManagement$Facebook$Main$update = F3(
	function (session, msg, model) {
		var extractBrandPageIdFromError = function (_v12) {
			var id = _v12.a;
			return id;
		};
		var getSelectedPageFromPageId = function (pageId) {
			return A2(
				$author$project$RemoteData$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$RemoteData$map,
					function (pages) {
						return A2(
							$elm$core$Maybe$map,
							function (bpId) {
								return {pageId: pageId, brandPageId: bpId};
							},
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.brandPageId;
								},
								A2(
									$elm_community$list_extra$List$Extra$find,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.id;
										},
										$elm$core$Basics$eq(pageId)),
									pages)));
					},
					model.brandPages));
		};
		switch (msg.$) {
			case 'OnFacebookBrandPagesSummaryReceived':
				if (msg.a.$ === 'Ok') {
					var summaryList = msg.a.a;
					var dict = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (summary) {
								return _Utils_Tuple2(summary.brandPageId, summary);
							},
							summaryList));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								brandPageSummaries: $author$project$RemoteData$Loaded(dict)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Facebook.Main',
							message: 'Failed to fetch facebook brand page'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								brandPageSummaries: $author$project$RemoteData$Error('Failed to fetch summaries')
							}),
						cmd);
				}
			case 'OnFacebookBrandPagesReceived':
				if (msg.a.$ === 'Ok') {
					var brandPageList = msg.a.a;
					var initialImageDict = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (page) {
								return _Utils_Tuple2(page.brandPageId, $author$project$RemoteData$Loading);
							},
							brandPageList));
					var getMediaInfoCmds = function () {
						var profileImageCmds = A2(
							$elm$core$List$map,
							function (page) {
								return A3(
									$author$project$BrandManagement$Facebook$Commands$getFacebookBrandProfileImageStatus,
									session.siteName,
									{id: page.id, brandPageId: page.brandPageId},
									$author$project$BrandManagement$Facebook$Model$OnProfileImageInfoReceived);
							},
							brandPageList);
						var coverImageCmds = A2(
							$elm$core$List$map,
							function (page) {
								return A3(
									$author$project$BrandManagement$Facebook$Commands$getFacebookBrandCoverImageStatus,
									session.siteName,
									{id: page.id, brandPageId: page.brandPageId},
									$author$project$BrandManagement$Facebook$Model$OnCoverImageInfoReceived);
							},
							brandPageList);
						return A2($elm$core$List$append, coverImageCmds, profileImageCmds);
					}();
					var initialStates = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (page) {
								return _Utils_Tuple2(
									page.brandPageId,
									A2($author$project$BrandManagement$Facebook$View$BrandMediaInfo$init, page, session.siteName));
							},
							brandPageList));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								brandPages: $author$project$RemoteData$Loaded(brandPageList),
								brandMediaStates: initialStates,
								brandCoverImageInfo: initialImageDict,
								brandProfileImageInfo: initialImageDict
							}),
						$elm$core$Platform$Cmd$batch(getMediaInfoCmds));
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Facebook.Main',
							message: 'Failed to fetch facebook brand pages'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								brandPages: $author$project$RemoteData$Error('Failed to fetch brand pages')
							}),
						cmd);
				}
			case 'OnCoverImageInfoReceived':
				if (msg.a.$ === 'Ok') {
					var coverImageInfo = msg.a.a;
					var updatedDict = A3(
						$elm$core$Dict$insert,
						coverImageInfo.brandPageId,
						$author$project$RemoteData$Loaded(coverImageInfo),
						model.brandCoverImageInfo);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandCoverImageInfo: updatedDict}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var brandPageId = extractBrandPageIdFromError(err.message);
					var updatedDict = A3(
						$elm$core$Dict$insert,
						brandPageId,
						$author$project$RemoteData$Error(brandPageId),
						model.brandCoverImageInfo);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandCoverImageInfo: updatedDict}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnProfileImageInfoReceived':
				if (msg.a.$ === 'Ok') {
					var profileImageInfo = msg.a.a;
					var updatedDict = A3(
						$elm$core$Dict$insert,
						profileImageInfo.brandPageId,
						$author$project$RemoteData$Loaded(profileImageInfo),
						model.brandProfileImageInfo);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandProfileImageInfo: updatedDict}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var brandPageId = extractBrandPageIdFromError(err.message);
					var updatedDict = A3(
						$elm$core$Dict$insert,
						brandPageId,
						$author$project$RemoteData$Error(brandPageId),
						model.brandProfileImageInfo);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandProfileImageInfo: updatedDict}),
						$elm$core$Platform$Cmd$none);
				}
			case 'CustomMediaResetLightBoxMsg':
				var lightBoxMsg = msg.a;
				var _v1 = function () {
					var _v2 = _Utils_Tuple2(lightBoxMsg, model.selectedPage);
					if ((_v2.a.$ === 'Close') && (_v2.b.$ === 'Just')) {
						var _v3 = _v2.a;
						var pageId = _v2.b.a.pageId;
						var brandPageId = _v2.b.a.brandPageId;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$BrandManagement$Facebook$Commands$getFacebookBrandCoverImageStatus,
										session.siteName,
										{id: pageId, brandPageId: brandPageId},
										$author$project$BrandManagement$Facebook$Model$OnCoverImageInfoReceived),
										A3(
										$author$project$BrandManagement$Facebook$Commands$getFacebookBrandProfileImageStatus,
										session.siteName,
										{id: pageId, brandPageId: brandPageId},
										$author$project$BrandManagement$Facebook$Model$OnProfileImageInfoReceived)
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v1.a;
				var refreshCommand = _v1.b;
				var _v4 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg),
					A2($author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$update, lightBoxMsg, model.resetMediaLightbox));
				var newLightboxState = _v4.a;
				var newLightboxMsg = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{resetMediaLightbox: newLightboxState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[newLightboxMsg, refreshCommand])));
			case 'DisplayProfileImageResetLightBox':
				var pageId = msg.a;
				var _v5 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg),
					A2($author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$update, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$Open, model.resetMediaLightbox));
				var newLightboxState = _v5.a;
				var firstMessage = _v5.b;
				var _v6 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg),
					A2(
						$author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$update,
						A2($author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$FetchProfileForPageId, session.siteName, pageId),
						newLightboxState));
				var lastState = _v6.a;
				var secondMessage = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedPage: getSelectedPageFromPageId(pageId),
							resetMediaLightbox: lastState
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[firstMessage, secondMessage])));
			case 'DisplayCoverImageResetLightBox':
				var pageId = msg.a;
				var _v7 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg),
					A2($author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$update, $author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$Open, model.resetMediaLightbox));
				var newLightboxState = _v7.a;
				var firstMessage = _v7.b;
				var _v8 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Facebook$Model$CustomMediaResetLightBoxMsg),
					A2(
						$author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$update,
						A2($author$project$BrandManagement$Facebook$View$CustomMediaResetLightBox$FetchCoverForPageId, session.siteName, pageId),
						newLightboxState));
				var lastState = _v8.a;
				var secondMessage = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedPage: getSelectedPageFromPageId(pageId),
							resetMediaLightbox: lastState
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[firstMessage, secondMessage])));
			case 'OnFacebookBrandPageRefetched':
				if (msg.a.$ === 'Ok') {
					var refreshedPage = msg.a.a;
					var newMediaStates = A2(
						$elm$core$Maybe$withDefault,
						model.brandMediaStates,
						A2(
							$elm$core$Maybe$map,
							function (stateToUpdate) {
								return A3($elm$core$Dict$insert, refreshedPage.brandPageId, stateToUpdate, model.brandMediaStates);
							},
							A2(
								$elm$core$Maybe$map,
								function (state) {
									return _Utils_update(
										state,
										{brandPage: refreshedPage});
								},
								A2($elm$core$Dict$get, refreshedPage.brandPageId, model.brandMediaStates))));
					var brandPages = A2(
						$author$project$RemoteData$map,
						$elm$core$List$map(
							function (currentPage) {
								return _Utils_eq(currentPage.id, refreshedPage.id) ? refreshedPage : currentPage;
							}),
						model.brandPages);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandPages: brandPages, brandMediaStates: newMediaStates}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Facebook.Main',
							message: 'Failed to refetch facebook brand page'
						});
					return _Utils_Tuple2(model, cmd);
				}
			case 'BrandMediaInfoMsg':
				var pageId = msg.a;
				var mediaInfoMsg = msg.b;
				var selectedState = A2($elm$core$Dict$get, pageId, model.brandMediaStates);
				var _v9 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (_v10) {
							var state = _v10.a;
							var cmd = _v10.b;
							var selectedPage = {pageId: state.brandPage.id, brandPageId: state.brandPage.brandPageId};
							var updatedDict = A3($elm$core$Dict$insert, pageId, state, model.brandMediaStates);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										selectedPage: $elm$core$Maybe$Just(selectedPage),
										brandMediaStates: updatedDict
									}),
								cmd);
						},
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$mapSecond(
								$elm$core$Platform$Cmd$map(
									$author$project$BrandManagement$Facebook$Model$BrandMediaInfoMsg(pageId))),
							A2(
								$elm$core$Maybe$map,
								$author$project$BrandManagement$Facebook$View$BrandMediaInfo$update(mediaInfoMsg),
								selectedState))));
				var newModel = _v9.a;
				var nextMsg = _v9.b;
				var extraMsg = function () {
					if ((mediaInfoMsg.$ === 'OnMediaPublished') && (mediaInfoMsg.a.$ === 'Ok')) {
						var pageToRefetch = mediaInfoMsg.a.a;
						return A3($author$project$BrandManagement$Facebook$Commands$fetchFacebookBrandpage, session.siteName, pageToRefetch.id, $author$project$BrandManagement$Facebook$Model$OnFacebookBrandPageRefetched);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[nextMsg, extraMsg])));
			default:
				var searchTerm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{brandPageSearchTerm: searchTerm}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Common$Image$Editor$OnImageCaptured = function (a) {
	return {$: 'OnImageCaptured', a: a};
};
var $author$project$Common$Image$Editor$ImageDecodeFailed = {$: 'ImageDecodeFailed'};
var $author$project$Common$Image$Editor$subscriptions = function (onImageCaptured) {
	return onImageCaptured(
		function (value) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$file$File$decoder, value);
			if (_v0.$ === 'Ok') {
				var f = _v0.a;
				return $author$project$Common$Image$Editor$OnImageCaptured(f);
			} else {
				return $author$project$Common$Image$Editor$ImageDecodeFailed;
			}
		});
};
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$onImageCaptured_Facebook = _Platform_incomingPort('onImageCaptured_Facebook', $elm$json$Json$Decode$value);
var $author$project$BrandManagement$Facebook$View$BrandMediaInfo$subscriptions = function (model) {
	var _v0 = model.editor;
	if (_v0.$ === 'Just') {
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$BrandManagement$Facebook$View$BrandMediaInfo$EditorMsg,
			$author$project$Common$Image$Editor$subscriptions($author$project$BrandManagement$Facebook$View$BrandMediaInfo$onImageCaptured_Facebook));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$BrandManagement$Facebook$Main$subscriptions = function (model) {
	var relevantState = A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($elm$core$Dict$get, id, model.brandMediaStates);
		},
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.brandPageId;
			},
			model.selectedPage));
	if (relevantState.$ === 'Just') {
		var state = relevantState.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$BrandManagement$Facebook$Model$BrandMediaInfoMsg(state.brandPage.brandPageId),
			$author$project$BrandManagement$Facebook$View$BrandMediaInfo$subscriptions(state));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$BrandManagement$Facebook$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$BrandManagement$Facebook$Main$init,
		view: $author$project$BrandManagement$Facebook$View$view,
		update: $author$project$BrandManagement$Facebook$Main$update,
		flagsDecoder: $elm$json$Json$Decode$succeed(_Utils_Tuple0),
		subscriptions: $author$project$BrandManagement$Facebook$Main$subscriptions
	});
var $author$project$Locations$MediaApproval$Model$MultiLocationItems = F2(
	function (count, items) {
		return {count: count, items: items};
	});
var $author$project$Locations$MediaApproval$Model$Google = {$: 'Google'};
var $author$project$Locations$MediaApproval$Model$Facebook = {$: 'Facebook'};
var $author$project$Locations$MediaApproval$Model$decodeNetwork = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'GOOGLE':
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$Google);
			case 'FACEBOOK':
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$Facebook);
			default:
				return $elm$json$Json$Decode$fail('Invalid network type');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Locations$MediaApproval$Model$Resolution = F2(
	function (width, height) {
		return {width: width, height: height};
	});
var $author$project$Locations$MediaApproval$Model$decodeResolution = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'height',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'width',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$Resolution)));
var $author$project$Locations$MediaApproval$Model$MultiLocationItem = F7(
	function (imageId, network, name, url, previewUrl, numberOfLocations, resolution) {
		return {url: url, name: name, imageId: imageId, network: network, previewUrl: previewUrl, resolution: resolution, numberOfLocations: numberOfLocations};
	});
var $author$project$Locations$MediaApproval$Model$decodeMultiLocationItem = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'metaData',
	$elm$json$Json$Decode$nullable($author$project$Locations$MediaApproval$Model$decodeResolution),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'numberOfLocations',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'previewUrl',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'network',
						$author$project$Locations$MediaApproval$Model$decodeNetwork,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'imageId',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$MultiLocationItem))))))));
var $author$project$Locations$MediaApproval$Model$decodeMultiLocationItems = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'items',
	$elm$json$Json$Decode$list($author$project$Locations$MediaApproval$Model$decodeMultiLocationItem),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$MultiLocationItems)));
var $author$project$Locations$MediaApproval$Commands$getCoverItems = F3(
	function (_v0, cursor, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaApproval$Model$decodeMultiLocationItems),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					'api/' + (siteName + ('/media/approval/cover?offset=' + ($elm$core$String$fromInt(cursor.offset) + ('&pageSize=' + $elm$core$String$fromInt(cursor.pageSize))))))));
	});
var $author$project$Locations$MediaApproval$Commands$getProfileItems = F3(
	function (_v0, cursor, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaApproval$Model$decodeMultiLocationItems),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					'api/' + (siteName + ('/media/approval/profile?offset=' + ($elm$core$String$fromInt(cursor.offset) + ('&pageSize=' + $elm$core$String$fromInt(cursor.pageSize))))))));
	});
var $author$project$Locations$MediaApproval$Model$SingleLocationItems = F2(
	function (count, items) {
		return {count: count, items: items};
	});
var $author$project$Locations$MediaApproval$Model$SingleLocationItem = F6(
	function (url, previewUrl, storeId, name, network, resolution) {
		return {url: url, name: name, network: network, storeId: storeId, previewUrl: previewUrl, resolution: resolution};
	});
var $author$project$Locations$MediaApproval$Model$decodeSingleLocationItem = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'metaData',
	$elm$json$Json$Decode$nullable($author$project$Locations$MediaApproval$Model$decodeResolution),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'network',
		$author$project$Locations$MediaApproval$Model$decodeNetwork,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'storeId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'previewUrl',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'url',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$SingleLocationItem)))))));
var $author$project$Locations$MediaApproval$Model$decodeSingleLocationItems = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'items',
	$elm$json$Json$Decode$list($author$project$Locations$MediaApproval$Model$decodeSingleLocationItem),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$SingleLocationItems)));
var $author$project$Locations$MediaApproval$Commands$getLocationItems = F3(
	function (_v0, cursor, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaApproval$Model$decodeSingleLocationItems),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					'api/' + (siteName + ('/media/approval/location?offset=' + ($elm$core$String$fromInt(cursor.offset) + ('&pageSize=' + $elm$core$String$fromInt(cursor.pageSize))))))));
	});
var $author$project$Locations$MediaApproval$Model$OnReceivedCoverItems = function (a) {
	return {$: 'OnReceivedCoverItems', a: a};
};
var $author$project$Locations$MediaApproval$Model$OnReceivedProfileItems = function (a) {
	return {$: 'OnReceivedProfileItems', a: a};
};
var $author$project$Locations$MediaApproval$Model$OnReceivedLocationItems = function (a) {
	return {$: 'OnReceivedLocationItems', a: a};
};
var $author$project$Locations$MediaApproval$Main$init = F2(
	function (session, _v0) {
		var blankModel = {
			toasts: _List_Nil,
			coverItems: {count: 0, items: _List_Nil},
			coverCursor: {offset: 0, pageSize: 4},
			isProcessing: true,
			profileItems: {count: 0, items: _List_Nil},
			locationItems: {count: 0, items: _List_Nil},
			profileCursor: {offset: 0, pageSize: 8},
			imageInfoModal: $elm$core$Maybe$Nothing,
			locationCursor: {offset: 0, pageSize: 24},
			coverShowMoreDisabled: false,
			profileShowMoreDisabled: false,
			locationShowMoreDisabled: false
		};
		return _Utils_Tuple2(
			blankModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Locations$MediaApproval$Commands$getProfileItems, session.siteName, blankModel.profileCursor, $author$project$Locations$MediaApproval$Model$OnReceivedProfileItems),
						A3($author$project$Locations$MediaApproval$Commands$getCoverItems, session.siteName, blankModel.coverCursor, $author$project$Locations$MediaApproval$Model$OnReceivedCoverItems),
						A3($author$project$Locations$MediaApproval$Commands$getLocationItems, session.siteName, blankModel.locationCursor, $author$project$Locations$MediaApproval$Model$OnReceivedLocationItems)
					])));
	});
var $author$project$Listings$Ui$InsightsHeader$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$Listings$Ui$InsightsHeader$view = function (config) {
	return $author$project$Listings$Ui$InsightsHeader$View(
		{icon: $elm$core$Maybe$Nothing, note: $elm$core$Maybe$Nothing, title: config.title, asides: $elm$core$Maybe$Nothing, filter: $elm$core$Maybe$Nothing, number: $elm$core$Maybe$Nothing, popOver: $elm$core$Maybe$Nothing, iconTitle: $elm$core$Maybe$Nothing, isLoading: false, starRating: $elm$core$Maybe$Nothing, lifetimeNumber: $elm$core$Maybe$Nothing});
};
var $author$project$Listings$Ui$InsightsHeader$skellify = F2(
	function (isLoading, child) {
		return $author$project$PinMeTo$Ui$Skeleton$view(
			{
				shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
				children: _List_fromArray(
					[child]),
				isLoading: isLoading,
				attributes: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'border-radius', '0.6rem')
					])
			});
	});
var $author$project$Listings$Ui$InsightsHeader$formatLifetimeText = F2(
	function (label, value) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-insights-header__lifetime-number')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('('),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-insights-header__lifetime-number--value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						])),
					$elm$html$Html$text(' '),
					$elm$html$Html$text(label),
					$elm$html$Html$text(')')
				]));
	});
var $author$project$Listings$Ui$InsightsHeader$renderLifetimeNumber = function (number) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ui-insights-header__lifetime-number')
			]),
		_List_fromArray(
			[
				A2($author$project$Listings$Ui$InsightsHeader$formatLifetimeText, number.lifetimeLabel, number.value)
			]));
};
var $author$project$Listings$Ui$InsightsHeader$render = function (_v0) {
	var config = _v0.a;
	var headerIcon = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$text(''),
		function (icon) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-insights-header__header__icon')
					]),
				_List_fromArray(
					[
						$author$project$FontAwesome$render(icon)
					]));
		},
		config.iconTitle);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ui-insights-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-insights-header__header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ui-insights-header__header__title')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										headerIcon,
										$elm$html$Html$text(config.title)
									]))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						config.filter),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var view_ = _v1.a;
								var state = _v1.b;
								return A2($author$project$PinMeTo$Ui$PopOver$renderPlain, state, view_);
							},
							config.popOver)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						config.asides)
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (number) {
						return A2(
							$author$project$Listings$Ui$InsightsHeader$skellify,
							config.isLoading,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ui-insights-header__number')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(number),
										A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2($elm$core$Maybe$map, $author$project$Listings$Ui$InsightsHeader$renderLifetimeNumber, config.lifetimeNumber))
									])));
					},
					config.number)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (starRating) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-insights-header__star-rating')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Listings$Ui$InsightsHeader$skellify,
									config.isLoading,
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ui-insights-header__star-rating__value')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												starRating.toString(starRating.rating))
											]))),
									A2(
									$author$project$Listings$Ui$InsightsHeader$skellify,
									config.isLoading,
									A2(
										$author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage,
										function (_v2) {
											return '';
										},
										starRating.rating)),
									A2(
									$author$project$Listings$Ui$InsightsHeader$skellify,
									config.isLoading,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2($elm$core$Maybe$map, $author$project$Listings$Ui$InsightsHeader$renderLifetimeNumber, config.lifetimeNumber)))
								]));
					},
					config.starRating)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (icon) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-insights-header__number')
										]),
									_List_fromArray(
										[
											$author$project$FontAwesome$render(icon)
										]))
								]));
					},
					config.icon)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (note) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-insights-header__note')
								]),
							_List_fromArray(
								[note]));
					},
					config.note))
			]));
};
var $author$project$Listings$Ui$InsightsHeader$withNote = F2(
	function (note, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					note: $elm$core$Maybe$Just(note)
				}));
	});
var $author$project$FontAwesome$Regular$Icon$faX = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-x');
var $author$project$FontAwesome$Regular$faX = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faX);
var $author$project$PinMeTo$Ui$Toast$Error = {$: 'Error'};
var $author$project$PinMeTo$Ui$Toast$Success = {$: 'Success'};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$PinMeTo$Ui$Toast$FaIcon = function (a) {
	return {$: 'FaIcon', a: a};
};
var $author$project$FontAwesome$Regular$Icon$faInfo = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-info');
var $author$project$FontAwesome$Regular$Icon$faCircleCheck = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-circle-check');
var $author$project$FontAwesome$Regular$Icon$faCircleXmark = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-circle-xmark');
var $author$project$PinMeTo$Ui$Toast$defaultIcon = function (toastType) {
	switch (toastType.$) {
		case 'Success':
			return $author$project$PinMeTo$Ui$Toast$FaIcon(
				$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faCircleCheck));
		case 'Error':
			return $author$project$PinMeTo$Ui$Toast$FaIcon(
				$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faCircleXmark));
		default:
			return $author$project$PinMeTo$Ui$Toast$FaIcon(
				$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faInfo));
	}
};
var $author$project$PinMeTo$Ui$Toast$defaultDuration = 5;
var $author$project$PinMeTo$Ui$Toast$render = F2(
	function (a, _v0) {
		var type_ = _v0.a;
		var config = _v0.b;
		var animationDurationParsed = function (val) {
			return val + 's';
		}(
			$elm$core$String$fromInt(
				A2($elm$core$Maybe$withDefault, $author$project$PinMeTo$Ui$Toast$defaultDuration, config.duration)));
		var defaultIconClass = _Utils_eq(type_, $author$project$PinMeTo$Ui$Toast$Success) ? 'ui-toast__icon--success' : (_Utils_eq(type_, $author$project$PinMeTo$Ui$Toast$Error) ? 'ui-toast__icon--failure' : 'ui-toast__icon');
		var animationStyle = config.infinite ? A2($elm$html$Html$Attributes$style, 'animation-name', 'none') : A2($elm$html$Html$Attributes$style, 'animation-delay', animationDurationParsed);
		var iconClass = A2($elm$core$Maybe$withDefault, defaultIconClass, config.iconClass);
		var icon = A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$Toast$defaultIcon(type_),
			config.icon);
		var _v1 = function () {
			if (icon.$ === 'FaIcon') {
				var faIcon = icon.a;
				return _Utils_Tuple2(
					$author$project$FontAwesome$render(faIcon),
					'ui-toast__icon--fa');
			} else {
				var uiIcon = icon.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Ui$Icon$render(uiIcon),
					'');
			}
		}();
		var renderedIcon = _v1.a;
		var faClass = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-toast'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'ui-toast--success',
							_Utils_eq(type_, $author$project$PinMeTo$Ui$Toast$Success)),
							_Utils_Tuple2(
							'',
							_Utils_eq(type_, $author$project$PinMeTo$Ui$Toast$Error))
						])),
					animationStyle
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-toast__icon'),
							$elm$html$Html$Attributes$class(iconClass),
							$elm$html$Html$Attributes$class(faClass)
						]),
					_List_fromArray(
						[renderedIcon])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-toast__body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									config.title(a))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									config.body(a))
								]))
						])),
					A2(
					$elm$html$Html$aside,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-toast__actions'),
							$elm$html$Html$Events$onClick(config.onClose)
						]),
					_List_fromArray(
						[$author$project$FontAwesome$Regular$faX]))
				]));
	});
var $author$project$PinMeTo$Ui$Toast$Toast = F2(
	function (a, b) {
		return {$: 'Toast', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Toast$failure = function (config) {
	var config_ = {body: config.body, icon: $elm$core$Maybe$Nothing, title: config.title, onClose: config.onClose, duration: $elm$core$Maybe$Nothing, infinite: false, iconClass: $elm$core$Maybe$Nothing};
	return A2($author$project$PinMeTo$Ui$Toast$Toast, $author$project$PinMeTo$Ui$Toast$Error, config_);
};
var $author$project$PinMeTo$Ui$Toast$success = function (config) {
	var config_ = {body: config.body, icon: $elm$core$Maybe$Nothing, title: config.title, onClose: config.onClose, duration: $elm$core$Maybe$Nothing, infinite: false, iconClass: $elm$core$Maybe$Nothing};
	return A2($author$project$PinMeTo$Ui$Toast$Toast, $author$project$PinMeTo$Ui$Toast$Success, config_);
};
var $author$project$PinMeTo$Ui$Toast$withIcon = F2(
	function (icon, _v0) {
		var type_ = _v0.a;
		var config = _v0.b;
		return A2(
			$author$project$PinMeTo$Ui$Toast$Toast,
			type_,
			_Utils_update(
				config,
				{
					icon: $elm$core$Maybe$Just(icon)
				}));
	});
var $author$project$PinMeTo$Ui$Toast$withDuration = F2(
	function (duration, _v0) {
		var type_ = _v0.a;
		var config = _v0.b;
		return A2(
			$author$project$PinMeTo$Ui$Toast$Toast,
			type_,
			_Utils_update(
				config,
				{
					duration: $elm$core$Maybe$Just(duration)
				}));
	});
var $author$project$Locations$MediaApproval$Model$ClickedDismissToast = {$: 'ClickedDismissToast'};
var $author$project$Locations$MediaApproval$View$renderToast = function (toast) {
	var specs = function (config) {
		return {
			body: function (_v1) {
				return config.body;
			},
			title: function (_v2) {
				return config.title;
			},
			onClose: $author$project$Locations$MediaApproval$Model$ClickedDismissToast
		};
	};
	switch (toast.$) {
		case 'ToastApproved':
			var icon = toast.a;
			var config = toast.b;
			return A2(
				$author$project$PinMeTo$Ui$Toast$render,
				_Utils_Tuple0,
				A2(
					$author$project$PinMeTo$Ui$Toast$withDuration,
					10,
					A2(
						$author$project$PinMeTo$Ui$Toast$withIcon,
						icon,
						$author$project$PinMeTo$Ui$Toast$success(
							specs(config)))));
		case 'ToastRejected':
			var icon = toast.a;
			var config = toast.b;
			return A2(
				$author$project$PinMeTo$Ui$Toast$render,
				_Utils_Tuple0,
				A2(
					$author$project$PinMeTo$Ui$Toast$withDuration,
					10,
					A2(
						$author$project$PinMeTo$Ui$Toast$withIcon,
						icon,
						$author$project$PinMeTo$Ui$Toast$failure(
							specs(config)))));
		default:
			var icon = toast.a;
			var config = toast.b;
			return A2(
				$author$project$PinMeTo$Ui$Toast$render,
				_Utils_Tuple0,
				A2(
					$author$project$PinMeTo$Ui$Toast$withDuration,
					10,
					A2(
						$author$project$PinMeTo$Ui$Toast$withIcon,
						icon,
						$author$project$PinMeTo$Ui$Toast$failure(
							specs(config)))));
	}
};
var $author$project$Translations$Listings$ListingMedia$approveMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.approve_media');
};
var $author$project$Translations$Listings$ListingMedia$networkTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.network_title');
};
var $author$project$Translations$Listings$ListingMedia$fileNameTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.file_name_title');
};
var $author$project$Translations$Listings$ListingMedia$locationsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.locations_title');
};
var $author$project$Locations$MediaApproval$Model$OnPreviewClosed = {$: 'OnPreviewClosed'};
var $author$project$Locations$MediaApproval$Model$networkToString = function (network) {
	if (network.$ === 'Google') {
		return 'GOOGLE';
	} else {
		return 'FACEBOOK';
	}
};
var $author$project$Translations$Listings$ListingMedia$resolutionTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.resolution_title');
};
var $author$project$Locations$MediaApproval$InfoModal$View$view = F2(
	function (translations, imageInfo) {
		var values = function () {
			var valueEntry = function (value) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]));
			};
			var titleCase = function (s) {
				var lowerCaseTail = A3(
					$elm$core$String$slice,
					1,
					$elm$core$String$length(s),
					$elm$core$String$toLower(s));
				var first = A2(
					$elm$core$Maybe$map,
					$elm$core$String$toUpper,
					$elm$core$List$head(
						A2($elm$core$String$split, '', s)));
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return _Utils_ap(f, lowerCaseTail);
						},
						first));
			};
			var resString = A2(
				$elm$core$Maybe$withDefault,
				'-',
				A2(
					$elm$core$Maybe$map,
					function (info) {
						return $elm$core$String$fromInt(info.width) + (' x ' + $elm$core$String$fromInt(info.height));
					},
					imageInfo.resolution));
			return A2(
				$elm$core$List$map,
				valueEntry,
				_List_fromArray(
					[
						imageInfo.name,
						resString,
						titleCase(
						$author$project$Locations$MediaApproval$Model$networkToString(imageInfo.network)),
						$elm$core$String$fromInt(imageInfo.numLocations)
					]));
		}();
		var titles = function () {
			var titleEntry = function (title) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]));
			};
			return A2(
				$elm$core$List$map,
				function (title) {
					return titleEntry(
						title(translations));
				},
				_List_fromArray(
					[$author$project$Translations$Listings$ListingMedia$fileNameTitle, $author$project$Translations$Listings$ListingMedia$resolutionTitle, $author$project$Translations$Listings$ListingMedia$networkTitle, $author$project$Translations$Listings$ListingMedia$locationsTitle]));
		}();
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-info-preview__content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-info-preview__image'),
							$elm$html$Html$Attributes$src(imageInfo.url)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-info-preview__info__container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-info-preview__info__title-col')
								]),
							titles),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-info-preview__info__value-col')
								]),
							values)
						]))
				]));
		return $author$project$PinMeTo$Ui$Lightbox$render(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$Medium,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withClose,
					$author$project$Locations$MediaApproval$Model$OnPreviewClosed,
					$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
						$author$project$PinMeTo$Ui$Lightbox$view(
							{title: '', content: content})))));
	});
var $author$project$Locations$MediaApproval$Model$Cover = {$: 'Cover'};
var $author$project$Translations$Listings$ListingMedia$cover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.cover');
};
var $author$project$Translations$General$reject = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.reject');
};
var $author$project$Locations$MediaApproval$Model$Profile = {$: 'Profile'};
var $author$project$Translations$General$approve = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.approve');
};
var $author$project$Translations$Listings$ListingMedia$showMore = F3(
	function (translations, count, total) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.listing_media.show_more',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count),
					_Utils_Tuple2('total', total)
				]));
	});
var $author$project$Translations$Listings$ListingMedia$goToTasks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.go_to_tasks');
};
var $author$project$Translations$Listings$ListingMedia$noApprovals = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.no_approvals');
};
var $author$project$Locations$MediaApproval$Model$kindToString = function (kind) {
	switch (kind.$) {
		case 'Location':
			return 'Location';
		case 'Cover':
			return 'Cover';
		default:
			return 'Profile';
	}
};
var $author$project$Locations$MediaApproval$Model$ClickedReject = {$: 'ClickedReject'};
var $author$project$Translations$Listings$ListingMedia$locationMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.location_media');
};
var $author$project$Locations$MediaApproval$Model$ClickedApprove = {$: 'ClickedApprove'};
var $author$project$Translations$Listings$ListingMedia$logoProfileMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.logo_profile_media');
};
var $author$project$Locations$MediaApproval$Model$ClickedShowMoreCovers = {$: 'ClickedShowMoreCovers'};
var $author$project$Locations$MediaApproval$Model$ClickedShowMoreProfiles = {$: 'ClickedShowMoreProfiles'};
var $author$project$Locations$MediaApproval$Model$ClickedShowMoreLocations = {$: 'ClickedShowMoreLocations'};
var $author$project$Locations$MediaApproval$Model$OnMultiLocationImagePreviewClicked = function (a) {
	return {$: 'OnMultiLocationImagePreviewClicked', a: a};
};
var $author$project$Locations$MediaApproval$Model$OnSingleLocationImagePreviewClicked = function (a) {
	return {$: 'OnSingleLocationImagePreviewClicked', a: a};
};
var $author$project$Locations$MediaApproval$View$renderContent = F2(
	function (session, model) {
		var renderMultiLocationItems = F2(
			function (kind, items) {
				return A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											'media-approval__img media-approval__img--' + $elm$core$String$toLower(
												$author$project$Locations$MediaApproval$Model$kindToString(kind))),
											$elm$html$Html$Attributes$src(item.previewUrl),
											$elm$html$Html$Events$onClick(
											$author$project$Locations$MediaApproval$Model$OnMultiLocationImagePreviewClicked(item))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('media-approval__img__network')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$toLower(
												$author$project$Locations$MediaApproval$Model$networkToString(item.network)))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$PinMeToPage$translatePluralValue, session, 'general.number_of_locations', item.numberOfLocations))
										]))
								]));
					},
					items);
			});
		var renderShowMoreButton = F4(
			function (totalCount, itemsCount, isDisabled, cmd) {
				return (_Utils_cmp(totalCount, itemsCount) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-approval__show-more')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								isDisabled,
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									cmd,
									A2(
										$author$project$PinMeTo$Ui$Button$withGhostStyle,
										$author$project$PinMeTo$Ui$Button$GhostDefault,
										$author$project$PinMeTo$Ui$Button$buttonGhost(
											A3(
												$author$project$Translations$Listings$ListingMedia$showMore,
												session.translations,
												$elm$core$String$fromInt(itemsCount),
												$elm$core$String$fromInt(totalCount)))))))
						])) : $elm$html$Html$text('');
			});
		var approveRejectButtons = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('media-approval__buttons')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Locations$MediaApproval$Model$ClickedReject,
						A2(
							$author$project$PinMeTo$Ui$Button$withSecondaryStyle,
							$author$project$PinMeTo$Ui$Button$SecondaryDanger,
							$author$project$PinMeTo$Ui$Button$buttonSecondary(
								$author$project$Translations$General$reject(session.translations))))),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Locations$MediaApproval$Model$ClickedApprove,
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$General$approve(session.translations))))
				]));
		var renderSkeletonCard = F3(
			function (content, isLoading, shimmer) {
				var config = {
					shimmer: shimmer,
					children: _List_fromArray(
						[content]),
					isLoading: isLoading,
					attributes: _List_Nil
				};
				return $author$project$PinMeTo$Ui$Skeleton$view(config);
			});
		var renderSectionTitle = F2(
			function (title, count) {
				return A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-body-1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									' (' + ($elm$core$String$fromInt(count) + ')'))
								]))
						]));
			});
		var renderLocationItems = function () {
			var totalCount = model.locationItems.count;
			var itemsCount = $elm$core$List$length(model.locationItems.items);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('media-approval__section media-approval__section__last')
					]),
				_List_fromArray(
					[
						A2(
						renderSectionTitle,
						$author$project$Translations$Listings$ListingMedia$locationMedia(session.translations),
						model.locationItems.count),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('media-approval__items')
							]),
						A2(
							$elm$core$List$map,
							function (item) {
								return A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$Locations$MediaApproval$Model$OnSingleLocationImagePreviewClicked(item)),
													$elm$html$Html$Attributes$class('media-approval__img'),
													$elm$html$Html$Attributes$src(item.previewUrl)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(item.storeId)
												]))
										]));
							},
							model.locationItems.items)),
						A4(renderShowMoreButton, totalCount, itemsCount, model.locationShowMoreDisabled, $author$project$Locations$MediaApproval$Model$ClickedShowMoreLocations)
					]));
		}();
		var renderProfileItems = function () {
			var totalCount = model.profileItems.count;
			var itemsCount = $elm$core$List$length(model.profileItems.items);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('media-approval__section')
					]),
				_List_fromArray(
					[
						A2(
						renderSectionTitle,
						$author$project$Translations$Listings$ListingMedia$logoProfileMedia(session.translations),
						model.profileItems.count),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('media-approval__items')
							]),
						A2(renderMultiLocationItems, $author$project$Locations$MediaApproval$Model$Profile, model.profileItems.items)),
						A4(renderShowMoreButton, totalCount, itemsCount, model.profileShowMoreDisabled, $author$project$Locations$MediaApproval$Model$ClickedShowMoreProfiles)
					]));
		}();
		var renderCoverItems = function () {
			var totalCount = model.coverItems.count;
			var itemsCount = $elm$core$List$length(model.coverItems.items);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('media-approval__section')
					]),
				_List_fromArray(
					[
						A2(
						renderSectionTitle,
						$author$project$Translations$Listings$ListingMedia$cover(session.translations),
						model.coverItems.count),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('media-approval__items')
							]),
						A2(renderMultiLocationItems, $author$project$Locations$MediaApproval$Model$Cover, model.coverItems.items)),
						A4(renderShowMoreButton, totalCount, itemsCount, model.coverShowMoreDisabled, $author$project$Locations$MediaApproval$Model$ClickedShowMoreCovers)
					]));
		}();
		var cardRenderer = function (elements) {
			return A2(renderSkeletonCard, elements, model.isProcessing);
		};
		var preview = A3(
			$elm_community$maybe_extra$Maybe$Extra$unpack,
			function (_v0) {
				return $elm$html$Html$text('');
			},
			$author$project$Locations$MediaApproval$InfoModal$View$view(session.translations),
			model.imageInfoModal);
		var noData = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('no-approvals')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ListingMedia$noApprovals(session.translations) + ' '),
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withHref,
								'/listings/' + ($author$project$Data$SiteName$toString(session.siteName) + '/tasks'),
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostDefault,
									$author$project$PinMeTo$Ui$Button$buttonGhost(
										$author$project$Translations$Listings$ListingMedia$goToTasks(session.translations)))))
						]))
				]));
		return (((model.profileItems.count + model.coverItems.count) + model.locationItems.count) > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('media-approval__content')
				]),
			_List_fromArray(
				[
					A2(cardRenderer, approveRejectButtons, $author$project$PinMeTo$Ui$Skeleton$Gradient),
					renderProfileItems,
					renderCoverItems,
					renderLocationItems,
					preview
				])) : A2(cardRenderer, noData, $author$project$PinMeTo$Ui$Skeleton$Gradient);
	});
var $author$project$Translations$Listings$ListingMedia$approveMediaDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.approve_media_description');
};
var $author$project$Locations$MediaApproval$View$view = F2(
	function (session, model) {
		var header = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-card__header')
				]),
			_List_fromArray(
				[
					$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNote,
						$elm$html$Html$text(
							$author$project$Translations$Listings$ListingMedia$approveMediaDescription(session.translations)),
						$author$project$Listings$Ui$InsightsHeader$view(
							{
								title: $author$project$Translations$Listings$ListingMedia$approveMedia(session.translations)
							})))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					header,
					A2($author$project$Locations$MediaApproval$View$renderContent, session, model),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Locations$MediaApproval$View$renderToast,
						$elm$core$List$reverse(model.toasts)))
				]));
	});
var $author$project$Translations$Listings$ListingMedia$error = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.error');
};
var $author$project$FontAwesome$Regular$Icon$faImages = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-images');
var $author$project$Locations$MediaApproval$Model$Response = function (message) {
	return {message: message};
};
var $author$project$Locations$MediaApproval$Model$decodeResponse = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'message',
	$elm$json$Json$Decode$string,
	'',
	$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$Response));
var $author$project$Locations$MediaApproval$Commands$rejectAll = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaApproval$Model$decodeResponse),
				$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/media/approval/reject/all'))));
	});
var $author$project$Locations$MediaApproval$Model$ToastError = F2(
	function (a, b) {
		return {$: 'ToastError', a: a, b: b};
	});
var $author$project$Locations$MediaApproval$Commands$approveAll = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaApproval$Model$decodeResponse),
				$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/media/approval/approve/all'))));
	});
var $author$project$Translations$Listings$ListingMedia$errorMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.error_message');
};
var $author$project$FontAwesome$Regular$Icon$faImageSlash = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-image-slash');
var $author$project$Locations$MediaApproval$Model$ToastApproved = F2(
	function (a, b) {
		return {$: 'ToastApproved', a: a, b: b};
	});
var $author$project$Locations$MediaApproval$Model$ToastRejected = F2(
	function (a, b) {
		return {$: 'ToastRejected', a: a, b: b};
	});
var $author$project$Translations$Listings$ListingMedia$mediaApproved = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.media_approved');
};
var $author$project$Translations$Listings$ListingMedia$mediaRejected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.listing_media.media_rejected');
};
var $author$project$Locations$MediaApproval$Model$OnReceivedRejectResponse = function (a) {
	return {$: 'OnReceivedRejectResponse', a: a};
};
var $author$project$Locations$MediaApproval$Model$OnReceivedApproveResponse = function (a) {
	return {$: 'OnReceivedApproveResponse', a: a};
};
var $author$project$Locations$MediaApproval$Main$update = F3(
	function (session, msg, model) {
		var errorToast = function (body) {
			return A2(
				$author$project$Locations$MediaApproval$Model$ToastError,
				$author$project$PinMeTo$Ui$Toast$FaIcon(
					$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faTriangleExclamation)),
				{
					body: body,
					title: $author$project$Translations$Listings$ListingMedia$error(session.translations)
				});
		};
		switch (msg.$) {
			case 'OnReceivedProfileItems':
				if (msg.a.$ === 'Ok') {
					var receivedItems = msg.a.a;
					var newProfileItems = {
						count: receivedItems.count,
						items: $elm$core$List$concat(
							_List_fromArray(
								[model.profileItems.items, receivedItems.items]))
					};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								isProcessing: false,
								profileItems: newProfileItems,
								profileCursor: {
									offset: model.profileCursor.offset + $elm$core$List$length(receivedItems.items),
									pageSize: model.profileCursor.pageSize
								},
								profileShowMoreDisabled: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isProcessing: false}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnReceivedCoverItems':
				if (msg.a.$ === 'Ok') {
					var receivedItems = msg.a.a;
					var newCoverItems = {
						count: receivedItems.count,
						items: $elm$core$List$concat(
							_List_fromArray(
								[model.coverItems.items, receivedItems.items]))
					};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								coverItems: newCoverItems,
								coverCursor: {
									offset: model.coverCursor.offset + $elm$core$List$length(receivedItems.items),
									pageSize: model.coverCursor.pageSize
								},
								isProcessing: false,
								coverShowMoreDisabled: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isProcessing: false}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnReceivedLocationItems':
				if (msg.a.$ === 'Ok') {
					var receivedItems = msg.a.a;
					var newLocationItems = {
						count: receivedItems.count,
						items: $elm$core$List$concat(
							_List_fromArray(
								[model.locationItems.items, receivedItems.items]))
					};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								isProcessing: false,
								locationItems: newLocationItems,
								locationCursor: {
									offset: model.locationCursor.offset + $elm$core$List$length(receivedItems.items),
									pageSize: model.locationCursor.pageSize
								},
								locationShowMoreDisabled: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isProcessing: false}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnReceivedApproveResponse':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									A2(
										$author$project$Locations$MediaApproval$Model$ToastApproved,
										$author$project$PinMeTo$Ui$Toast$FaIcon(
											$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faImages)),
										{
											body: A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.listing_media.media_approved_body', (model.profileItems.count + model.coverItems.count) + model.locationItems.count),
											title: $author$project$Translations$Listings$ListingMedia$mediaApproved(session.translations)
										}),
									model.toasts),
								coverItems: {count: 0, items: _List_Nil},
								coverCursor: {offset: 0, pageSize: 4},
								isProcessing: false,
								profileItems: {count: 0, items: _List_Nil},
								locationItems: {count: 0, items: _List_Nil},
								profileCursor: {offset: 0, pageSize: 8},
								locationCursor: {offset: 0, pageSize: 24}
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									errorToast(
										$author$project$Translations$Listings$ListingMedia$errorMessage(session.translations)),
									model.toasts),
								isProcessing: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnReceivedRejectResponse':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									A2(
										$author$project$Locations$MediaApproval$Model$ToastRejected,
										$author$project$PinMeTo$Ui$Toast$FaIcon(
											$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faImageSlash)),
										{
											body: A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.listing_media.media_rejected_body', (model.profileItems.count + model.coverItems.count) + model.locationItems.count),
											title: $author$project$Translations$Listings$ListingMedia$mediaRejected(session.translations)
										}),
									model.toasts),
								coverItems: {count: 0, items: _List_Nil},
								coverCursor: {offset: 0, pageSize: 4},
								isProcessing: false,
								profileItems: {count: 0, items: _List_Nil},
								locationItems: {count: 0, items: _List_Nil},
								profileCursor: {offset: 0, pageSize: 8},
								locationCursor: {offset: 0, pageSize: 24}
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									errorToast(
										$author$project$Translations$Listings$ListingMedia$errorMessage(session.translations)),
									model.toasts),
								isProcessing: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'ClickedApprove':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isProcessing: true}),
					A2($author$project$Locations$MediaApproval$Commands$approveAll, session.siteName, $author$project$Locations$MediaApproval$Model$OnReceivedApproveResponse));
			case 'ClickedReject':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isProcessing: true}),
					A2($author$project$Locations$MediaApproval$Commands$rejectAll, session.siteName, $author$project$Locations$MediaApproval$Model$OnReceivedRejectResponse));
			case 'ClickedShowMoreProfiles':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{profileShowMoreDisabled: true}),
					A3($author$project$Locations$MediaApproval$Commands$getProfileItems, session.siteName, model.profileCursor, $author$project$Locations$MediaApproval$Model$OnReceivedProfileItems));
			case 'ClickedShowMoreCovers':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{coverShowMoreDisabled: true}),
					A3($author$project$Locations$MediaApproval$Commands$getCoverItems, session.siteName, model.coverCursor, $author$project$Locations$MediaApproval$Model$OnReceivedCoverItems));
			case 'ClickedShowMoreLocations':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationShowMoreDisabled: true}),
					A3($author$project$Locations$MediaApproval$Commands$getLocationItems, session.siteName, model.locationCursor, $author$project$Locations$MediaApproval$Model$OnReceivedLocationItems));
			case 'ClickedDismissToast':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							toasts: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$elm$core$List$tail(model.toasts))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnSingleLocationImagePreviewClicked':
				var image = msg.a;
				var info = {url: image.url, name: image.name, network: image.network, resolution: image.resolution, numLocations: 1};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							imageInfoModal: $elm$core$Maybe$Just(info)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnMultiLocationImagePreviewClicked':
				var image = msg.a;
				var info = {url: image.url, name: image.name, network: image.network, resolution: image.resolution, numLocations: image.numberOfLocations};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							imageInfoModal: $elm$core$Maybe$Just(info)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{imageInfoModal: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm_community$json_extra$Json$Decode$Extra$url = A2(
	$elm$json$Json$Decode$andThen,
	function (urlString) {
		var _v0 = $elm$url$Url$fromString(urlString);
		if (_v0.$ === 'Just') {
			var actualUrl = _v0.a;
			return $elm$json$Json$Decode$succeed(actualUrl);
		} else {
			return $elm$json$Json$Decode$fail('Expecting a  URL');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Locations$MediaApproval$Model$Flags = function (currentUrl) {
	return {currentUrl: currentUrl};
};
var $author$project$Locations$MediaApproval$Model$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currentUrl',
	$elm_community$json_extra$Json$Decode$Extra$url,
	$elm$json$Json$Decode$succeed($author$project$Locations$MediaApproval$Model$Flags));
var $author$project$Locations$MediaApproval$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Locations$MediaApproval$Main$init,
		view: $author$project$Locations$MediaApproval$View$view,
		update: $author$project$Locations$MediaApproval$Main$update,
		flagsDecoder: $author$project$Locations$MediaApproval$Model$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Directories$NetworkList$Model$Flags = F5(
	function (siteName, translations, isDev, bulkVerifiedEligible, hasAppleOAuth) {
		return {isDev: isDev, siteName: siteName, translations: translations, hasAppleOAuth: hasAppleOAuth, bulkVerifiedEligible: bulkVerifiedEligible};
	});
var $author$project$Directories$NetworkList$Command$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'appleOAuth',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bulkVerifiedEligible',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			A2(
				$elm$json$Json$Decode$andThen,
				function (u) {
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Data$User$hasRole, u, $author$project$Data$User$PinMeToDeveloper));
				},
				$author$project$Data$User$userDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'translations',
				$author$project$Common$Language$translationsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['user', 'selectedSite', 'name']),
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Directories$NetworkList$Model$Flags))))));
var $author$project$Directories$NetworkList$Command$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Directories$NetworkList$Command$flagsDecoder, flags);
};
var $author$project$Directories$NetworkList$Main$initialModel = {
	isDev: false,
	uiTable: $author$project$PinMeTo$Ui$Table$init,
	siteName: $author$project$Directories$Common$SiteName$SiteName(''),
	dataStatus: $author$project$RemoteData$Loading,
	networkData: _List_Nil,
	translations: $author$project$Common$Language$initialTranslationsFallback,
	hasAppleOAuth: false,
	bulkVerifiedEligible: false
};
var $author$project$Directories$NetworkList$Model$GetNetworkStatus = function (a) {
	return {$: 'GetNetworkStatus', a: a};
};
var $author$project$Directories$NetworkList$Model$NetworkStatus = F7(
	function (networkKey, enabled, customerCanEnable, isConnected, isTwoWayConnection, rank, networkDetails) {
		return {rank: rank, enabled: enabled, networkKey: networkKey, isConnected: isConnected, networkDetails: networkDetails, customerCanEnable: customerCanEnable, isTwoWayConnection: isTwoWayConnection};
	});
var $author$project$Directories$NetworkList$Model$NetworkLocations = F5(
	function (locations, totalLocations, brandpages, needsActionLocationList, filterKey) {
		return {filterKey: filterKey, locations: locations, brandpages: brandpages, totalLocations: totalLocations, needsActionLocationList: needsActionLocationList};
	});
var $author$project$Directories$NetworkList$Command$networkDetailsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'filterKey',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'needsActionLocationList',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'brandpages',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'totalLocations',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locations',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Directories$NetworkList$Model$NetworkLocations))))));
var $author$project$Directories$NetworkList$Command$networkStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'networkDetails',
	$author$project$Directories$NetworkList$Command$networkDetailsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rank',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'isTwoWayConnection',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'isConnected',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'customerCanEnable',
					$elm$json$Json$Decode$bool,
					false,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'networkKey',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Directories$NetworkList$Model$NetworkStatus))))))));
var $author$project$Directories$NetworkList$Command$statusListDecoder = $elm$json$Json$Decode$list($author$project$Directories$NetworkList$Command$networkStatusDecoder);
var $author$project$Directories$NetworkList$Command$getNetworkData = function (siteName) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($elm$http$Http$expectJson, $author$project$Directories$NetworkList$Model$GetNetworkStatus, $author$project$Directories$NetworkList$Command$statusListDecoder),
			$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/network/networkConnections'))));
};
var $author$project$Directories$NetworkList$Main$init = function (flags) {
	var _v0 = $author$project$Directories$NetworkList$Command$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Directories$NetworkList$Main$initialModel,
				{
					isDev: decoded.isDev,
					siteName: $author$project$Directories$Common$SiteName$SiteName(decoded.siteName),
					translations: decoded.translations,
					hasAppleOAuth: decoded.hasAppleOAuth,
					bulkVerifiedEligible: decoded.bulkVerifiedEligible
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Directories$NetworkList$Command$getNetworkData(decoded.siteName)
					])));
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$author$project$Directories$NetworkList$Main$initialModel,
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Directories.NetworkList.Main.init',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$PinMeTo$Ui$Status$Red = {$: 'Red'};
var $author$project$PinMeTo$Ui$Status$Gray = {$: 'Gray'};
var $author$project$PinMeTo$Ui$Status$Green = {$: 'Green'};
var $author$project$PinMeTo$Ui$Status$toString = function (status) {
	switch (status.$) {
		case 'Gray':
			return 'gray';
		case 'Orange':
			return 'orange';
		case 'Blue':
			return 'blue';
		case 'Green':
			return 'green';
		case 'Black':
			return 'black';
		default:
			return 'red';
	}
};
var $author$project$PinMeTo$Ui$Status$render_ = F3(
	function (right, status, label) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-ui-status--right', right)
						])),
					$elm$html$Html$Attributes$class(
					'pmt-ui-status pmt-ui-status--' + $author$project$PinMeTo$Ui$Status$toString(status))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$PinMeTo$Ui$Status$render = F2(
	function (status, label) {
		return A3($author$project$PinMeTo$Ui$Status$render_, false, status, label);
	});
var $author$project$Translations$General$status = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.status');
};
var $author$project$Directories$NetworkList$Main$wrapper = function (html) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('util__background--white')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-table')
							]),
						html)
					]))
			]));
};
var $author$project$PinMeTo$Ui$Table$comparing = F3(
	function (f, x, y) {
		return A2(
			$elm$core$Basics$compare,
			f(x),
			f(y));
	});
var $author$project$Directories$NetworkList$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Directories$NetworkList$Main$errorBanner = function (userMessage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('util__inset')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('status-bar__message')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Error: ')
									])),
								$elm$html$Html$text(userMessage)
							]))
					]))
			]));
};
var $author$project$Translations$General$errorUnexpected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.error_unexpected');
};
var $author$project$PinMeTo$Ui$Table$columnOfCompactType = function (column) {
	return _Utils_update(
		column,
		{
			options: _List_fromArray(
				[$author$project$PinMeTo$Ui$Table$Compact])
		});
};
var $author$project$PinMeTo$Ui$Table$addCompactColumn = F3(
	function (key, renderer, sorter) {
		return $author$project$PinMeTo$Ui$Table$withColumn(
			$author$project$PinMeTo$Ui$Table$columnOfCompactType(
				A3($author$project$PinMeTo$Ui$Table$createColumn, renderer, sorter, key)));
	});
var $author$project$Translations$Listings$Directories$bulkVerifiedText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.bulk_verified_text');
};
var $author$project$Directories$NetworkList$Main$renderIconAndName = F2(
	function (icon, name) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directories-name')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Icon$render(icon)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directories-name-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$Directories$NetworkList$Model$Connected = {$: 'Connected'};
var $author$project$Directories$NetworkList$Model$NotEnabled = {$: 'NotEnabled'};
var $author$project$Directories$NetworkList$Model$Disconnected = {$: 'Disconnected'};
var $author$project$Directories$NetworkList$Main$getConnectionStatus = function (status) {
	return (status.enabled && status.isConnected) ? $author$project$Directories$NetworkList$Model$Connected : ((status.enabled && (!status.isConnected)) ? $author$project$Directories$NetworkList$Model$Disconnected : $author$project$Directories$NetworkList$Model$NotEnabled);
};
var $author$project$Translations$Listings$Directories$bulkVerifiedLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.bulk_verified_link_text');
};
var $author$project$Directories$NetworkList$Main$getConnectedLocations = function (status) {
	return (status.enabled && status.isConnected) ? ($elm$core$String$fromInt(status.networkDetails.locations) + (' / ' + $elm$core$String$fromInt(status.networkDetails.totalLocations))) : '-';
};
var $author$project$Translations$Listings$Directories$appleHelpCenterArticle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.apple_help_center_article');
};
var $author$project$Directories$NetworkList$Model$RunNeedsActionPlanHatEvent = {$: 'RunNeedsActionPlanHatEvent'};
var $author$project$Directories$NetworkList$Main$getUnverifiedLocations = function (_v0) {
	var status = _v0.a;
	var siteName = _v0.b;
	var unverifiedLocations = $elm$core$List$length(status.networkDetails.needsActionLocationList);
	var getLocationIds = A2(
		$elm$core$String$join,
		',',
		A2(
			$elm$core$List$map,
			function (x) {
				return '\u0022' + (x + '\u0022');
			},
			status.networkDetails.needsActionLocationList));
	var unshortenedFilter = '%7B\u0022filterDefinition\u0022:%5B%7B\u0022property\u0022:\u0022locations\u0022,\u0022value\u0022:%5B' + (getLocationIds + ('%5D%7D%5D%7D' + '&openFilterOnLoad=true'));
	var generateFilterUrl = $elm$html$Html$Attributes$href(
		A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					'',
					$author$project$Directories$Common$SiteName$siteNameToString(siteName),
					'/locations',
					'?filter=',
					A2($elm$core$Maybe$withDefault, unshortenedFilter, status.networkDetails.filterKey)
				])));
	return (status.enabled && (status.isConnected && (unverifiedLocations > 0))) ? A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-button pmt-ui-button--medium pmt-ui-button--secondary-danger'),
				$elm$html$Html$Attributes$target('_blank'),
				generateFilterUrl,
				$elm$html$Html$Events$onClick($author$project$Directories$NetworkList$Model$RunNeedsActionPlanHatEvent)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(unverifiedLocations))
			])) : A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('-')
			]));
};
var $author$project$Translations$Listings$Directories$manageNetworkLinkHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.manage_network_link_header');
};
var $author$project$Translations$Listings$Directories$publishedLocationsHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.published_locations_header');
};
var $author$project$Translations$Listings$Directories$unverifiedLocationsHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.directories.unverified_locations_header');
};
var $author$project$Directories$NetworkList$Main$view = function (model) {
	var statusToString = function (s) {
		switch (s.$) {
			case 'Connected':
				return $author$project$Translations$Listings$Directories$connected(model.translations);
			case 'Disconnected':
				return $author$project$Translations$Listings$Directories$disconnected(model.translations);
			default:
				return $author$project$Translations$Listings$Directories$notEnabled(model.translations);
		}
	};
	var linkAvailable = function (x) {
		var _v3 = x.network.networkLink;
		if (_v3.$ === 'Just') {
			var networkLink = _v3.a;
			var externalLink = function () {
				if ((x.network.key === 'apple') && (!model.hasAppleOAuth)) {
					var helpCenterLink = {
						link: 'https://help.pinmeto.com/en/article/setting-up-your-apple-business-connect-account-b1rdhn/',
						name: $author$project$Translations$Listings$Directories$appleHelpCenterArticle(model.translations)
					};
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__weight-medium'),
								$elm$html$Html$Attributes$href(helpCenterLink.link),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('lightbox__mr-05')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(helpCenterLink.name)
									])),
								A2(
								$elm$html$Html$a,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$ExternalLink)
									]))
							]));
				} else {
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-btn pmt-btn--cta-muted'),
								$elm$html$Html$Attributes$href(networkLink.link),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(networkLink.name)
							]));
				}
			}();
			return externalLink;
		} else {
			return A2($elm$html$Html$a, _List_Nil, _List_Nil);
		}
	};
	var statusLabel = function (status_) {
		switch (status_.$) {
			case 'Connected':
				return A2(
					$author$project$PinMeTo$Ui$Status$render,
					$author$project$PinMeTo$Ui$Status$Green,
					statusToString(status_));
			case 'Disconnected':
				return A2(
					$author$project$PinMeTo$Ui$Status$render,
					$author$project$PinMeTo$Ui$Status$Red,
					statusToString(status_));
			default:
				return A2(
					$author$project$PinMeTo$Ui$Status$render,
					$author$project$PinMeTo$Ui$Status$Gray,
					statusToString(status_));
		}
	};
	var linkName = function (x) {
		var _v1 = x.network.networkLink;
		if (_v1.$ === 'Just') {
			var networkLink = _v1.a;
			return networkLink.name;
		} else {
			return '';
		}
	};
	var _v0 = model.dataStatus;
	switch (_v0.$) {
		case 'Loaded':
			var networkDataCustomerCanEnable = A2(
				$elm$core$List$filter,
				function (networkData) {
					return networkData.status.customerCanEnable || networkData.status.enabled;
				},
				model.networkData);
			return $author$project$Directories$NetworkList$Main$wrapper(
				_List_fromArray(
					[
						model.bulkVerifiedEligible ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Alert$render(
								A2(
									$author$project$PinMeTo$Ui$Alert$withStatus,
									$author$project$PinMeTo$Ui$Alert$Warning,
									$author$project$PinMeTo$Ui$Alert$rich(
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Directories$bulkVerifiedText(model.translations) + ' '),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/updates-to-google-verification-15qzobj/'),
														A2($elm$html$Html$Attributes$attribute, 'download', ''),
														$elm$html$Html$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$Directories$bulkVerifiedLinkText(model.translations))
													]))
											]))))
							])) : $elm$html$Html$text(''),
						A2(
						$author$project$PinMeTo$Ui$Table$render,
						model.uiTable,
						A2(
							$author$project$PinMeTo$Ui$Table$withSort,
							$author$project$PinMeTo$Ui$Table$Asc(1),
							A5(
								$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
								$author$project$Translations$Listings$Directories$manageNetworkLinkHeader(model.translations),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Table$Left, $author$project$PinMeTo$Ui$Table$Compact]),
								function (x) {
									return linkAvailable(x);
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (x) {
										return linkName(x);
									}),
								A5(
									$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
									$author$project$Translations$Listings$Directories$unverifiedLocationsHeader(model.translations),
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
									function (x) {
										return $author$project$Directories$NetworkList$Main$getUnverifiedLocations(
											_Utils_Tuple2(x.status, model.siteName));
									},
									$author$project$PinMeTo$Ui$Table$comparing(
										function (x) {
											return x.status.networkDetails.locations;
										}),
									A5(
										$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
										$author$project$Translations$Listings$Directories$publishedLocationsHeader(model.translations),
										_List_fromArray(
											[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
										function (x) {
											return $elm$html$Html$text(
												$author$project$Directories$NetworkList$Main$getConnectedLocations(x.status));
										},
										$author$project$PinMeTo$Ui$Table$comparing(
											function (x) {
												return x.status.networkDetails.locations;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addCompactColumn,
											$author$project$Translations$General$status(model.translations),
											function (x) {
												return statusLabel(
													$author$project$Directories$NetworkList$Main$getConnectionStatus(x.status));
											},
											$author$project$PinMeTo$Ui$Table$comparing(
												A2(
													$elm$core$Basics$composeR,
													function (x) {
														return statusToString(
															$author$project$Directories$NetworkList$Main$getConnectionStatus(x.status));
													},
													$elm$core$String$toLower)),
											A4(
												$author$project$PinMeTo$Ui$Table$addCompactColumn,
												$author$project$Translations$General$name(model.translations),
												function (x) {
													return A2($author$project$Directories$NetworkList$Main$renderIconAndName, x.network.icon, x.network.name);
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													A2(
														$elm$core$Basics$composeR,
														function (x) {
															return x.network.name;
														},
														$elm$core$String$toLower)),
												A2(
													$author$project$PinMeTo$Ui$Table$withRowLink,
													function (x) {
														return '/listings/' + ($author$project$Directories$Common$SiteName$siteNameToString(model.siteName) + ('/directories/' + x.network.key));
													},
													A2($author$project$PinMeTo$Ui$Table$view, $author$project$Directories$NetworkList$Model$UiTableMsg, networkDataCustomerCanEnable)))))))))
					]));
		case 'Loading':
			return $author$project$Directories$NetworkList$Main$wrapper(
				_List_fromArray(
					[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
		case 'Suspended':
			return $author$project$Directories$NetworkList$Main$wrapper(
				_List_fromArray(
					[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
		default:
			return $author$project$Directories$NetworkList$Main$wrapper(
				_List_fromArray(
					[
						$author$project$Directories$NetworkList$Main$errorBanner(
						$author$project$Translations$General$errorUnexpected(model.translations))
					]));
	}
};
var $author$project$Directories$NetworkList$Main$maybeNetworkName = function (status) {
	var name = $author$project$Directories$Common$Network$getNetworkName(status.networkKey);
	return name;
};
var $author$project$Directories$NetworkList$Main$maybeData = function (status) {
	var maybeName = $author$project$Directories$NetworkList$Main$maybeNetworkName(status);
	return A2(
		$elm$core$Maybe$map,
		function (x) {
			return {
				status: status,
				network: $author$project$Directories$Common$Network$networkFromName(x)
			};
		},
		maybeName);
};
var $author$project$Directories$NetworkList$Main$mapToNetworkData = F2(
	function (statuses, isDev) {
		var shouldShow = function (networkData) {
			return networkData.status.customerCanEnable || (networkData.status.enabled || isDev);
		};
		return A2(
			$elm$core$List$filter,
			shouldShow,
			A2($elm$core$List$filterMap, $author$project$Directories$NetworkList$Main$maybeData, statuses));
	});
var $author$project$Directories$NetworkList$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'GetNetworkStatus':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var statuses = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dataStatus: $author$project$RemoteData$Loaded(statuses),
								networkData: A2($author$project$Directories$NetworkList$Main$mapToNetworkData, statuses, model.isDev)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dataStatus: $author$project$RemoteData$Error('Could not get network status')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Directories.NetworkList.Main.Update.GetNetworkStatus', message: 'Error on GetNetworkStatus'}));
				}
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$PlanHat$PlanHat$track(
						{info: '', action: $author$project$PlanHat$TrackingActions$keys.networkPage.needsActionLinkClicked}));
		}
	});
var $author$project$Directories$NetworkList$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Directories$NetworkList$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Directories$NetworkList$Main$init, view: $author$project$Directories$NetworkList$Main$view, update: $author$project$Directories$NetworkList$Main$update, subscriptions: $author$project$Directories$NetworkList$Main$subscriptions});
var $author$project$Tasks$Trustpilot$Claim$Model$Flags = function (site) {
	return {site: site};
};
var $author$project$Tasks$Trustpilot$Claim$Model$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['user', 'selectedSite', 'name']),
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Tasks$Trustpilot$Claim$Model$Flags));
var $author$project$Tasks$Trustpilot$Claim$Model$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Trustpilot$Claim$Model$flagsDecoder, flags);
};
var $author$project$Tasks$Trustpilot$Claim$Model$LocationData = function (locationName) {
	return function (storeId) {
		return function (streetAddress) {
			return function (streetAddress2) {
				return function (zipCode) {
					return function (city) {
						return function (state) {
							return function (province) {
								return function (country) {
									return function (countryCode) {
										return function (phoneNumber) {
											return function (website) {
												return {city: city, state: state, country: country, storeId: storeId, website: website, zipCode: zipCode, province: province, countryCode: countryCode, phoneNumber: phoneNumber, locationName: locationName, streetAddress: streetAddress, streetAddress2: streetAddress2};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Tasks$Trustpilot$Claim$Commands$decodeLocationData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['contact', 'homepage']),
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['contact', 'phone']),
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['address', 'countryAlpha2Code']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['address', 'country']),
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['address', 'province']),
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['address', 'state']),
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['address', 'city']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['address', 'zip']),
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['address', 'street2']),
									$elm$json$Json$Decode$string,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['address', 'street']),
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'storeId',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'name',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Tasks$Trustpilot$Claim$Model$LocationData)))))))))))));
var $author$project$Tasks$Trustpilot$Claim$Commands$decodeLocations = $elm$json$Json$Decode$list($author$project$Tasks$Trustpilot$Claim$Commands$decodeLocationData);
var $author$project$Tasks$Trustpilot$Claim$Commands$GotLocationsResponse = function (a) {
	return {$: 'GotLocationsResponse', a: a};
};
var $author$project$Tasks$Trustpilot$Claim$Commands$getLocations = function (site) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($elm$http$Http$expectJson, $author$project$Tasks$Trustpilot$Claim$Commands$GotLocationsResponse, $author$project$Tasks$Trustpilot$Claim$Commands$decodeLocations),
			$lukewestby$elm_http_builder$HttpBuilder$get('/listings/api/' + (site + '/trustpilot/claim/getMatchedLocations'))));
};
var $author$project$Tasks$Trustpilot$Claim$Main$initialModel = {site: '', locations: $author$project$RemoteData$Suspended};
var $author$project$Tasks$Trustpilot$Claim$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Trustpilot$Claim$Model$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Tasks$Trustpilot$Claim$Main$initialModel,
				{site: decoded.site}),
			$author$project$Tasks$Trustpilot$Claim$Commands$getLocations(decoded.site));
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$author$project$Tasks$Trustpilot$Claim$Main$initialModel,
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Tasks.Trustpilot.Claim.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Trustpilot$Claim$Commands$ExportTemplate = {$: 'ExportTemplate'};
var $author$project$Tasks$Trustpilot$Claim$Main$renderContent = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-task__content')
			]),
		function () {
			var _v0 = model.locations;
			if (_v0.$ === 'Error') {
				var e = _v0.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(e)
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-task__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create new locations on Trustpilot')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Download the locations file to upload locations to Trustpilot.')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$PinMeTo$Ui$Btn$pmtBtn,
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Tasks$Trustpilot$Claim$Commands$ExportTemplate)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Download file (.csv)')
									]))
							]))
					]);
			}
		}());
};
var $author$project$Tasks$Trustpilot$Claim$Main$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$TitleBar$render(
						$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar('Claim Trustpilot Locations')),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list list--divided')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__indicator')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$i,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-task__icon fa fa-plus')
															]),
														_List_Nil)
													])),
												$author$project$Tasks$Trustpilot$Claim$Main$renderContent(model)
											]))
									]))
							]))
					]))
			]));
};
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Tasks$Trustpilot$Claim$Commands$locationInfoToString = function (locations) {
	var encode = function (x) {
		return A2($elm$core$String$contains, ',', x) ? ('\u0022' + (x + '\u0022')) : x;
	};
	var adminArea = function (x) {
		return (x.country === 'China') ? encode(x.province) : encode(x.state);
	};
	var location = function (l) {
		return encode(l.locationName) + (',' + (encode(l.storeId) + (',' + (encode(l.streetAddress) + (',' + (encode(l.streetAddress2) + (',' + (encode(l.zipCode) + (',' + (encode(l.city) + (',' + (adminArea(l) + (',' + (encode(l.countryCode) + (',' + (encode(l.phoneNumber) + (',' + (encode(l.website) + '\u000A'))))))))))))))))));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			function (l) {
				return location(l);
			},
			locations));
};
var $author$project$Tasks$Trustpilot$Claim$Main$update = F2(
	function (msg, model) {
		if (msg.$ === 'ExportTemplate') {
			var getLocationList = function () {
				var _v1 = model.locations;
				if (_v1.$ === 'Loaded') {
					var x = _v1.a;
					return x;
				} else {
					return _List_Nil;
				}
			}();
			var listToCsv = $author$project$Tasks$Trustpilot$Claim$Commands$locationInfoToString(getLocationList);
			var csvTemplate = ($elm$core$List$length(getLocationList) > 0) ? listToCsv : 'Location name,ID,Street address,Street address 2,ZIP code,City,State/Province/Region, Country code,Phone number,Website';
			var getTemplate = A3($elm$file$File$Download$string, 'Trustpilot Locations.csv', 'text/csv', csvTemplate);
			return _Utils_Tuple2(model, getTemplate);
		} else {
			if (msg.a.$ === 'Ok') {
				var x = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							locations: $author$project$RemoteData$Loaded(x)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var err = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							locations: $author$project$RemoteData$Error(
								$author$project$Util$httpErrorToString(err))
						}),
					$author$project$PinMeTo$Logger$logHttpError(
						{data: err, context: 'Tasks.Trustpilot.Claim.Main', message: 'GotLocationsResponse failed'}));
			}
		}
	});
var $author$project$Tasks$Trustpilot$Claim$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Trustpilot$Claim$Main$init,
		view: $author$project$Tasks$Trustpilot$Claim$Main$view,
		update: $author$project$Tasks$Trustpilot$Claim$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Foursquare$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Foursquare$Claim$Commands$getAllFoursquareCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/foursquare/categories')))));
	});
var $author$project$Tasks$Foursquare$Claim$Main$init = F2(
	function (session, flags) {
		return _Utils_Tuple2(
			{uiTable: $author$project$PinMeTo$Ui$Table$init, uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, allCategories: $author$project$RemoteData$Loading, primaryCategory: flags.categories.primaryCategory, categoriesNotification: $elm$core$Maybe$Nothing, additionalCategoriesList: flags.categories.additionalCategories},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Foursquare$Claim$Commands$getAllFoursquareCategories, session.siteName, $author$project$Tasks$Foursquare$Claim$Model$GotAllCategories)
					])));
	});
var $author$project$Tasks$Foursquare$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Translations$Listings$Claim$claimFoursquareLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_foursquare_locations');
};
var $author$project$Tasks$Foursquare$Claim$View$renderHeader = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorFoursquare)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimFoursquareLocations(translations))
					]))
			]));
};
var $author$project$Tasks$Foursquare$Claim$View$renderInnerContainer = F2(
	function (session, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Tasks$Foursquare$Claim$View$renderHeader(session.translations)
					]),
				_List_Nil));
	});
var $author$project$Translations$Listings$Claim$categories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.categories');
};
var $author$project$Tasks$Foursquare$Claim$Sections$Shared$renderAlert = function (notification) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$text(''),
		function (_v0) {
			var message = _v0.message;
			var state = _v0.state;
			return $author$project$PinMeTo$Ui$Alert$render(
				function () {
					switch (state.$) {
						case 'Success':
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
						case 'Failed':
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
						default:
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
					}
				}()(
					$author$project$PinMeTo$Ui$Alert$plain(message)));
		},
		notification);
};
var $author$project$Tasks$Shared$Components$Header$renderHeader = F2(
	function (header, additionalElement) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__headline')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline ')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(header)
							]))
					]),
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (html) {
						return _List_fromArray(
							[html]);
					},
					additionalElement)));
	});
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Translations$General$publish = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.publish');
};
var $author$project$Tasks$Foursquare$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Foursquare$Claim$Update$areCategoriesSelected = function (model) {
	var areAllAdditionalCategoriesSelected = A2($elm$core$List$all, $elm_community$maybe_extra$Maybe$Extra$isJust, model.additionalCategoriesList);
	var isPrimaryCategorySelected = $elm_community$maybe_extra$Maybe$Extra$isJust(model.primaryCategory);
	return isPrimaryCategorySelected && areAllAdditionalCategoriesSelected;
};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Foursquare$Claim$Update$areCategoriesSelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Foursquare$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Tasks$Foursquare$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$additionalCategory = F2(
	function (translations, number) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.additional_category',
			_List_fromArray(
				[
					_Utils_Tuple2('- number', number)
				]));
	});
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Foursquare$Claim$Model$SelectedPrimaryCategory = function (a) {
	return {$: 'SelectedPrimaryCategory', a: a};
};
var $author$project$Tasks$Foursquare$Claim$Model$SelectedAdditionalCategory = F2(
	function (a, b) {
		return {$: 'SelectedAdditionalCategory', a: a, b: b};
	});
var $author$project$Tasks$Foursquare$Claim$Model$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderCategorySelector = F6(
	function (uid, translations, model, categories, category, index) {
		var isPrimary = uid === 'ui-select-primary';
		var title = isPrimary ? $author$project$Translations$Listings$LocationDetail$primaryCategory(translations) : A2(
			$author$project$Translations$Listings$LocationDetail$additionalCategory,
			translations,
			$elm$core$String$fromInt(index + 1));
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid + ('-' + $elm$core$String$fromInt(index)),
													items: A2($author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Foursquare$Claim$Model$UiSelectMsg,
													onChange: function (category_) {
														return isPrimary ? $author$project$Tasks$Foursquare$Claim$Model$SelectedPrimaryCategory(category_) : A2($author$project$Tasks$Foursquare$Claim$Model$SelectedAdditionalCategory, category_, index);
													},
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								])),
							isPrimary ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__remove-additional'),
									$elm$html$Html$Events$onClick(
									$author$project$Tasks$Foursquare$Claim$Model$RemoveAdditionalCategoryByIndex(index))
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
								]))
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted = function (t) {
	return A2($author$project$PinMeTo$Ui$Btn$pmtBtnCta_, 'pmt-btn--cta-muted pmt-btn--with-icon', t);
};
var $author$project$Tasks$Foursquare$Claim$Model$AddAdditionalCategory = {$: 'AddAdditionalCategory'};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderAddCategoryButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__publish-button')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Tasks$Foursquare$Claim$Model$AddAdditionalCategory)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$addCategory(translations))
					]))
			]));
};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderAdditionalCategories = F3(
	function (translations, model, categories) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return A6($author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-additional', translations, model, categories, item, index);
					}),
				model.additionalCategoriesList));
	});
var $author$project$Data$Location$NetworkCategories$getId = function (x) {
	if (x.$ === 'CommonNetworkCategory') {
		var cat = x.a;
		return cat.id;
	} else {
		var cat = x.a;
		return A2($elm$core$Maybe$withDefault, cat.featureTypeId, cat.serviceSubCategoryId);
	}
};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$getCategoryId = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	function (category_) {
		return $author$project$Data$Location$NetworkCategories$getId(category_);
	});
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$getSelectedCategoryIds = function (model) {
	return A2(
		$elm$core$List$append,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (category) {
				return _List_fromArray(
					[
						$author$project$Data$Location$NetworkCategories$getId(category)
					]);
			},
			model.primaryCategory),
		A2(
			$elm$core$List$filter,
			function (category) {
				return category !== '';
			},
			A2($elm$core$List$map, $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$getCategoryId, model.additionalCategoriesList)));
};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$getAllNotSelectedCategories = function (model) {
	var _v0 = model.allCategories;
	if (_v0.$ === 'Loaded') {
		var categories = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (category) {
				return !A2(
					$elm$core$List$member,
					$author$project$Data$Location$NetworkCategories$getId(category),
					$author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$getSelectedCategoryIds(model));
			},
			categories);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = $author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$sortCategories(
			$author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$getAllNotSelectedCategories(model));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Tasks$Shared$Components$Header$renderHeader,
							$author$project$Translations$Listings$Claim$categories(translations),
							$elm$core$Maybe$Nothing),
							$author$project$Tasks$Foursquare$Claim$Sections$Shared$renderAlert(model.categoriesNotification),
							A6($author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-primary', translations, model, sortedCategories, model.primaryCategory, 0),
							A3($author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderAdditionalCategories, translations, model, sortedCategories),
							$author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderAddCategoryButton(translations),
							A2($author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
						]))
				]));
	});
var $author$project$Tasks$Foursquare$Claim$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Foursquare$Claim$View$renderInnerContainer, session, model),
						$author$project$Tasks$Foursquare$Claim$View$lineSeparator,
						A2($author$project$Tasks$Foursquare$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Foursquare$Claim$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Tasks$Foursquare$Claim$Commands$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getId(x))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getName(x)))
			]));
};
var $author$project$Tasks$Foursquare$Claim$Commands$encodeCategories = function (model) {
	var categories = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[model.primaryCategory]),
			model.additionalCategoriesList));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $author$project$Tasks$Foursquare$Claim$Commands$encodeCategory, categories))
			]));
};
var $author$project$Tasks$Foursquare$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var sitename = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Foursquare$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (sitename + '/foursquare/categories')))));
	});
var $author$project$Tasks$Foursquare$Claim$Update$emptyNotification = function (model) {
	return _Utils_update(
		model,
		{categoriesNotification: $elm$core$Maybe$Nothing});
};
var $author$project$Tasks$Foursquare$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Foursquare$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Foursquare$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				categoriesNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$Foursquare$Claim$Update$handleCategoriesError = F3(
	function (session, err, model) {
		var updatedModel = A3(
			$author$project$Tasks$Foursquare$Claim$Update$updateNotification,
			$author$project$Tasks$Foursquare$Claim$Model$Failed,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(session.translations),
			model);
		return _Utils_Tuple2(
			_Utils_update(
				updatedModel,
				{
					allCategories: $author$project$RemoteData$Error(
						$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
				}),
			$author$project$PinMeTo$Logger$log(
				{
					data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
					context: 'Tasks.Foursquare.Claim.Update.GotAllCategories',
					message: 'Failed to decode response GotAllCategories'
				}));
	});
var $author$project$Tasks$Foursquare$Claim$Model$Success = {$: 'Success'};
var $author$project$Translations$Listings$LocationDetail$saveCategories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.save_categories');
};
var $author$project$Translations$Listings$LocationDetail$saveCategoriesFailed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.save_categories_failed');
};
var $author$project$Tasks$Foursquare$Claim$Update$handleSaveCategoriesResultOk = F3(
	function (session, success, model) {
		var _v0 = success ? _Utils_Tuple2(
			$author$project$Tasks$Foursquare$Claim$Model$Success,
			$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
			$author$project$Tasks$Foursquare$Claim$Model$Failed,
			$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
		var notificationState = _v0.a;
		var notificationMessage = _v0.b;
		return _Utils_Tuple2(
			A3($author$project$Tasks$Foursquare$Claim$Update$updateNotification, notificationState, notificationMessage, model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Foursquare$Claim$Update$handleSaveCategoriesResultErr = F2(
	function (err, model) {
		var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
		return _Utils_Tuple2(
			A3($author$project$Tasks$Foursquare$Claim$Update$updateNotification, $author$project$Tasks$Foursquare$Claim$Model$Failed, message, model),
			$author$project$PinMeTo$Logger$log(
				{data: message, context: 'Tasks.Foursquare.Claim.Update.SaveCategoriesResult', message: 'Failed to decode response SaveCategoriesResult'}));
	});
var $author$project$Tasks$Foursquare$Claim$Update$handleSelectedPrimaryCategory = F3(
	function (model, modelClearedNotifications, category) {
		return A2(
			$elm$core$List$member,
			$elm$core$Maybe$Just(category),
			model.additionalCategoriesList) ? _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			_Utils_update(
				modelClearedNotifications,
				{
					primaryCategory: $elm$core$Maybe$Just(category)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Foursquare$Claim$Update$handleSelectedAdditionalCategory = F4(
	function (model, modelClearedNotifications, category, index) {
		var primaryCategory = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (cat) {
				return $elm$core$List$singleton(
					$elm$core$Maybe$Just(cat));
			},
			model.primaryCategory);
		var newAdditional = A2(
			$elm$core$List$member,
			$elm$core$Maybe$Just(category),
			A2($elm$core$List$append, model.additionalCategoriesList, primaryCategory)) ? model.additionalCategoriesList : A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$append,
				A2($elm$core$List$take, index, model.additionalCategoriesList),
				$elm$core$List$singleton(
					$elm$core$Maybe$Just(category))),
			A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
		return _Utils_Tuple2(
			_Utils_update(
				modelClearedNotifications,
				{additionalCategoriesList: newAdditional}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Foursquare$Claim$Update$handleRemoveRemoveAdditionalCategory = F3(
	function (model, modelClearedNotifications, index) {
		var newAdditional = A2(
			$elm$core$List$append,
			A2($elm$core$List$take, index, model.additionalCategoriesList),
			A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
		return _Utils_Tuple2(
			_Utils_update(
				modelClearedNotifications,
				{additionalCategoriesList: newAdditional}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Foursquare$Claim$Update$update = F3(
	function (session, msg, model) {
		var modelClearedNotifications = $author$project$Tasks$Foursquare$Claim$Update$emptyNotification(model);
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Foursquare$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Foursquare$Claim$Model$UiPopOverMsg, msg_, model.uiPopover));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							modelClearedNotifications,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return A3($author$project$Tasks$Foursquare$Claim$Update$handleCategoriesError, session, err, model);
				}
			case 'SelectedPrimaryCategory':
				var category = msg.a;
				return A3($author$project$Tasks$Foursquare$Claim$Update$handleSelectedPrimaryCategory, model, modelClearedNotifications, category);
			case 'AddAdditionalCategory':
				var newSelection = A2(
					$elm$core$List$append,
					model.additionalCategoriesList,
					$elm$core$List$singleton($elm$core$Maybe$Nothing));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newSelection}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedAdditionalCategory':
				var category = msg.a;
				var index = msg.b;
				return A4($author$project$Tasks$Foursquare$Claim$Update$handleSelectedAdditionalCategory, model, modelClearedNotifications, category, index);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				return A3($author$project$Tasks$Foursquare$Claim$Update$handleRemoveRemoveAdditionalCategory, model, modelClearedNotifications, index);
			case 'SaveCategories':
				return $author$project$Tasks$Foursquare$Claim$Update$areCategoriesSelected(model) ? _Utils_Tuple2(
					modelClearedNotifications,
					A3($author$project$Tasks$Foursquare$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Foursquare$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					return A3($author$project$Tasks$Foursquare$Claim$Update$handleSaveCategoriesResultOk, session, success, model);
				} else {
					var err = msg.a.a;
					return A2($author$project$Tasks$Foursquare$Claim$Update$handleSaveCategoriesResultErr, err, model);
				}
			default:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Foursquare$Claim$Model$Flags = function (categories) {
	return {categories: categories};
};
var $author$project$Tasks$Foursquare$Claim$Commands$defaultCategoriesValue = {primaryCategory: $elm$core$Maybe$Nothing, additionalCategories: _List_Nil};
var $author$project$Tasks$Foursquare$Claim$Commands$flagsCategoriesDecoder = function () {
	var decodeCategories = $elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder);
	var decodeCategoriesAsCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodeCategories);
	return A2(
		$elm$json$Json$Decode$map,
		function (categories) {
			return {
				primaryCategory: $elm$core$List$head(categories),
				additionalCategories: A2(
					$elm$core$List$map,
					$elm$core$Maybe$Just,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$elm$core$List$tail(categories)))
			};
		},
		decodeCategoriesAsCommon);
}();
var $author$project$Tasks$Foursquare$Claim$Commands$flagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Tasks$Foursquare$Claim$Model$Flags,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$Tasks$Foursquare$Claim$Commands$defaultCategoriesValue),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'categories', $author$project$Tasks$Foursquare$Claim$Commands$flagsCategoriesDecoder))));
var $author$project$Tasks$Foursquare$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$Foursquare$Claim$Main$init,
		view: function (session) {
			return $author$project$Tasks$Foursquare$Claim$View$view(session);
		},
		update: $author$project$Tasks$Foursquare$Claim$Update$update,
		flagsDecoder: $author$project$Tasks$Foursquare$Claim$Commands$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Locations$BookingLinks$Main$Blank = {$: 'Blank'};
var $author$project$Locations$BookingLinks$Main$init = {choice: $author$project$Locations$BookingLinks$Main$Blank, report: $author$project$RemoteData$Suspended, dropZone: $author$project$Listings$Ui$DropZone$init};
var $author$project$Translations$Listings$GoogleActionsCenter$intro = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.google_actions_center.intro');
};
var $author$project$Translations$Listings$GoogleActionsCenter$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.google_actions_center.title');
};
var $author$project$Locations$BookingLinks$Main$viewIntro = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$GoogleActionsCenter$title(translations))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$GoogleActionsCenter$intro(translations))
					]))
			]));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Translations$Listings$GoogleActionsCenter$reportTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.google_actions_center.report_title');
};
var $author$project$Locations$BookingLinks$Main$viewReport = F2(
	function (translations, report) {
		switch (report.$) {
			case 'Loaded':
				var value = report.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$GoogleActionsCenter$reportTitle(translations))
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$readonly(true),
									$elm$html$Html$Attributes$rows(30),
									$elm$html$Html$Attributes$class('booking-links-report')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$json$Json$Encode$encode, 2, value))
								]))
						]));
			case 'Error':
				var message = report.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$GoogleActionsCenter$reportTitle(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form__error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$Listings$Spreadsheet$stepTwoTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.step_two_title');
};
var $author$project$Locations$BookingLinks$Main$DropZoneMsg = function (a) {
	return {$: 'DropZoneMsg', a: a};
};
var $author$project$Translations$Listings$Spreadsheet$uploadButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.upload_button');
};
var $author$project$Translations$Listings$Spreadsheet$uploadPrefix = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.upload_prefix');
};
var $author$project$Translations$Listings$GoogleActionsCenter$uploadSuffix = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.google_actions_center.upload_suffix');
};
var $author$project$Locations$BookingLinks$Main$viewDropZone = F2(
	function (translations, dropZone) {
		return A2(
			$elm$html$Html$map,
			$author$project$Locations$BookingLinks$Main$DropZoneMsg,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('listings-drop-zone'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('listings-drop-zone--hover', dropZone.hover)
							])),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragenter',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragEnter)),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragover',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragEnter)),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragleave',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragLeave)),
						A2($author$project$Listings$Ui$DropZone$hijackOn, 'drop', $author$project$Listings$Ui$DropZone$dropDecoder)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Spreadsheet$uploadPrefix(translations)),
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$Listings$Ui$DropZone$Pick,
									$author$project$PinMeTo$Ui$Button$buttonSecondary(
										$author$project$Translations$Listings$Spreadsheet$uploadButton(translations)))),
								$elm$html$Html$text(
								$author$project$Translations$Listings$GoogleActionsCenter$uploadSuffix(translations))
							]))
					])));
	});
var $author$project$Locations$BookingLinks$Main$viewUpload = F3(
	function (translations, dropZone, report) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$stepTwoTitle(translations))
						])),
					function () {
					if (report.$ === 'Loading') {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spreadsheet-loading')
								]),
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]));
					} else {
						return A2($author$project$Locations$BookingLinks$Main$viewDropZone, translations, dropZone);
					}
				}()
				]));
	});
var $author$project$Locations$BookingLinks$Main$Prefilled = {$: 'Prefilled'};
var $author$project$Locations$BookingLinks$Main$ChooseTemplate = function (a) {
	return {$: 'ChooseTemplate', a: a};
};
var $author$project$Locations$BookingLinks$Main$viewChoice = F3(
	function (label, option, chosen) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Radio$render(
					$author$project$PinMeTo$Ui$Form$Radio$radio(
						{
							label: label,
							checked: _Utils_eq(option, chosen),
							onChange: function (_v0) {
								return $author$project$Locations$BookingLinks$Main$ChooseTemplate(option);
							}
						}))
				]));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 'QueryParameter', a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Locations$BookingLinks$Main$templateQuery = function (choice) {
	if (choice.$ === 'Blank') {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'prefill', 'true')
			]);
	}
};
var $author$project$Locations$BookingLinks$Main$templateUrl = F3(
	function (site, format, choice) {
		return A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				['listings', 'api', site, 'import', 'bookingLinks', 'template', format]),
			$author$project$Locations$BookingLinks$Main$templateQuery(choice));
	});
var $author$project$Locations$BookingLinks$Main$downloadLink = F3(
	function (label, url, filename) {
		return A3(
			$elm$html$Html$node,
			'pmt-download-with-filter-button',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'url', url),
					A2($elm$html$Html$Attributes$attribute, 'label', label),
					A2($elm$html$Html$Attributes$attribute, 'filename', filename)
				]),
			_List_Nil);
	});
var $author$project$Translations$Listings$Spreadsheet$stepOneTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.step_one_title');
};
var $author$project$Translations$Listings$Spreadsheet$blankTemplateLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.blank_template_label');
};
var $author$project$Translations$Listings$Import$downloadTemplateCsv = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.import.download_template_csv');
};
var $author$project$Translations$Listings$Import$downloadTemplateXlsx = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.import.download_template_xlsx');
};
var $author$project$Translations$Listings$GoogleActionsCenter$prefilledTemplateLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.google_actions_center.prefilled_template_label');
};
var $author$project$Locations$BookingLinks$Main$viewDownloadTemplate = F3(
	function (translations, site, choice) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$stepOneTitle(translations))
						])),
					A3(
					$author$project$Locations$BookingLinks$Main$viewChoice,
					$author$project$Translations$Listings$Spreadsheet$blankTemplateLabel(translations),
					$author$project$Locations$BookingLinks$Main$Blank,
					choice),
					A3(
					$author$project$Locations$BookingLinks$Main$viewChoice,
					$author$project$Translations$Listings$GoogleActionsCenter$prefilledTemplateLabel(translations),
					$author$project$Locations$BookingLinks$Main$Prefilled,
					choice),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Locations$BookingLinks$Main$downloadLink,
							$author$project$Translations$Listings$Import$downloadTemplateCsv(translations),
							A3($author$project$Locations$BookingLinks$Main$templateUrl, site, 'csv', choice),
							'booking-links-template.csv'),
							A3(
							$author$project$Locations$BookingLinks$Main$downloadLink,
							$author$project$Translations$Listings$Import$downloadTemplateXlsx(translations),
							A3($author$project$Locations$BookingLinks$Main$templateUrl, site, 'xlsx', choice),
							'booking-links-template.xlsx')
						]))
				]));
	});
var $author$project$Locations$BookingLinks$Main$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spreadsheet-import')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section section--solid')
						]),
					_List_fromArray(
						[
							$author$project$Locations$BookingLinks$Main$viewIntro(session.translations),
							A3(
							$author$project$Locations$BookingLinks$Main$viewDownloadTemplate,
							session.translations,
							$author$project$Data$SiteName$toString(session.siteName),
							model.choice),
							A3($author$project$Locations$BookingLinks$Main$viewUpload, session.translations, model.dropZone, model.report),
							A2($author$project$Locations$BookingLinks$Main$viewReport, session.translations, model.report)
						]))
				]));
	});
var $author$project$Locations$BookingLinks$Main$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Locations$BookingLinks$Commands$validate = F3(
	function (site, file, toMsg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, toMsg, $elm$json$Json$Decode$value, $elm$json$Json$Decode$value),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$multipartBody(
						_List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (site + '/import/bookingLinks/validate')))));
	});
var $author$project$Locations$BookingLinks$Main$GotReport = function (a) {
	return {$: 'GotReport', a: a};
};
var $author$project$Locations$BookingLinks$Main$acceptedMimes = _List_fromArray(
	['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']);
var $author$project$Locations$BookingLinks$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'ChooseTemplate':
				var choice = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{choice: choice}),
					$elm$core$Platform$Cmd$none);
			case 'DropZoneMsg':
				var dropZoneMsg = msg.a;
				var _v1 = A3(
					$author$project$Listings$Ui$DropZone$update,
					{mimes: $author$project$Locations$BookingLinks$Main$acceptedMimes, tagger: $author$project$Locations$BookingLinks$Main$DropZoneMsg, onGotFiles: $author$project$Locations$BookingLinks$Main$GotFiles},
					dropZoneMsg,
					model.dropZone);
				var dropZone = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dropZone: dropZone}),
					cmd);
			case 'GotFiles':
				var file = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{report: $author$project$RemoteData$Loading}),
					A3(
						$author$project$Locations$BookingLinks$Commands$validate,
						$author$project$Data$SiteName$toString(session.siteName),
						file,
						$author$project$Locations$BookingLinks$Main$GotReport));
			default:
				if (msg.a.$ === 'Ok') {
					var report = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								report: $author$project$RemoteData$Loaded(report)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					var _v2 = error.details;
					if ((_v2.$ === 'BadStatus') && (_v2.c.$ === 'Ok')) {
						var body = _v2.c.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									report: $author$project$RemoteData$Loaded(body)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									report: $author$project$RemoteData$Error(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
		}
	});
var $author$project$Locations$BookingLinks$Main$main = $author$project$PinMeToPage$page(
	{
		init: F2(
			function (_v0, _v1) {
				return _Utils_Tuple2($author$project$Locations$BookingLinks$Main$init, $elm$core$Platform$Cmd$none);
			}),
		view: $author$project$Locations$BookingLinks$Main$view,
		update: $author$project$Locations$BookingLinks$Main$update,
		flagsDecoder: $elm$json$Json$Decode$succeed(_Utils_Tuple0),
		subscriptions: function (_v2) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Common$NoPermissionLightbox$Flags = F8(
	function (accountSettings, listen, social, switchAccounts, accountAccess, sitesCount, logout, translations) {
		return {listen: listen, logout: logout, social: social, sitesCount: sitesCount, translations: translations, accountAccess: accountAccess, switchAccounts: switchAccounts, accountSettings: accountSettings};
	});
var $author$project$Common$NoPermissionLightbox$AccountAccess = F4(
	function (hasPlaces, hasListenRespond, hasSocialMedia, hasAccountAccess) {
		return {hasPlaces: hasPlaces, hasSocialMedia: hasSocialMedia, hasAccountAccess: hasAccountAccess, hasListenRespond: hasListenRespond};
	});
var $author$project$Common$NoPermissionLightbox$flagsDecoder = function () {
	var access = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hasAccountAccess',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hasSocialMedia',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hasListenRespond',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'hasPlaces',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Common$NoPermissionLightbox$AccountAccess)))));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'logout',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sitesCount',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'accountAccess',
					access,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'switchAccounts',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'social',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'listen',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'accountSettings',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Common$NoPermissionLightbox$Flags)))))))));
}();
var $author$project$Common$NoPermissionLightbox$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Common$NoPermissionLightbox$flagsDecoder, flags);
};
var $author$project$Common$NoPermissionLightbox$update = F2(
	function (msg, model) {
		if (msg.$ === 'Noop') {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var flags = msg.a;
			var _v1 = $author$project$Common$NoPermissionLightbox$decodeFlags(flags);
			if (_v1.$ === 'Ok') {
				var flags_ = _v1.a;
				var accountAccess = flags_.accountAccess;
				var links = {listen: flags_.listen, logout: flags_.logout, social: flags_.social, switchAccounts: flags_.switchAccounts, accountSettings: flags_.accountSettings};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{links: links, sitesCount: flags_.sitesCount, translations: flags_.translations, accountAccess: accountAccess}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Common$NoPermissionLightbox$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Common$NoPermissionLightbox$init = function (flags) {
	return A2(
		$author$project$Common$NoPermissionLightbox$update,
		$author$project$Common$NoPermissionLightbox$HandleFlags(flags),
		{
			links: {listen: '', logout: '', social: '', switchAccounts: '', accountSettings: ''},
			sitesCount: 0,
			translations: $ChristophP$elm_i18next$I18Next$initialTranslations,
			accountAccess: {hasPlaces: false, hasSocialMedia: false, hasAccountAccess: false, hasListenRespond: false}
		});
};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Translations$General$NoPermissionPopup$or = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.or');
};
var $author$project$Translations$General$NoPermissionPopup$posts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.posts');
};
var $author$project$Translations$General$TopNavigation$logout = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.logout');
};
var $author$project$Translations$General$NoPermissionPopup$conversations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.conversations');
};
var $author$project$Translations$General$NoPermissionPopup$switchAccount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.switch_account');
};
var $author$project$Translations$General$NoPermissionPopup$accountSettings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.account_settings');
};
var $author$project$Common$NoPermissionLightbox$buttons = function (model) {
	return $elm_community$maybe_extra$Maybe$Extra$values(
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(model.links.logout)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$TopNavigation$logout(model.translations))
								]))
						]))),
				(model.sitesCount !== 1) ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(model.links.switchAccounts)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$NoPermissionPopup$switchAccount(model.translations))
								]))
						]))) : $elm$core$Maybe$Nothing,
				model.accountAccess.hasAccountAccess ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(model.links.accountSettings)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$NoPermissionPopup$accountSettings(model.translations))
								]))
						]))) : $elm$core$Maybe$Nothing,
				model.accountAccess.hasListenRespond ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(model.links.listen)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$NoPermissionPopup$conversations(model.translations))
								]))
						]))) : $elm$core$Maybe$Nothing,
				model.accountAccess.hasSocialMedia ? $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(model.links.social)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$NoPermissionPopup$posts(model.translations))
								]))
						]))) : $elm$core$Maybe$Nothing
			]));
};
var $author$project$Translations$General$NoPermissionPopup$ifElseFails = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.if_else_fails');
};
var $author$project$Translations$General$NoPermissionPopup$tryNavigating = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.try_navigating');
};
var $author$project$Translations$General$NoPermissionPopup$attentionTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.attention_title');
};
var $author$project$Translations$General$NoPermissionPopup$contactSupport = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.contact_support');
};
var $author$project$Translations$General$NoPermissionPopup$accessToMoreAccounts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.access_to_more_accounts');
};
var $author$project$Translations$General$NoPermissionPopup$listingsNotActivated = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.listings_not_activated');
};
var $author$project$Translations$General$NoPermissionPopup$maybeYouWereLookingFor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.maybe_you_were_looking_for');
};
var $author$project$Translations$General$NoPermissionPopup$loginWithDifferentAccount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.no_permission_popup.login_with_different_account');
};
var $author$project$Common$NoPermissionLightbox$view = function (model) {
	return $author$project$PinMeTo$Ui$Lightbox$render(
		A2(
			$author$project$PinMeTo$Ui$Lightbox$withFooter,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn-group')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-btn-group__divider')
							]),
						_List_Nil),
					$author$project$Common$NoPermissionLightbox$buttons(model))),
			$author$project$PinMeTo$Ui$Lightbox$view(
				{
					title: $author$project$Translations$General$NoPermissionPopup$attentionTitle(model.translations),
					content: A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h5,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$NoPermissionPopup$listingsNotActivated(model.translations))
									])),
								model.accountAccess.hasAccountAccess ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$tryNavigating(model.translations))
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(model.links.accountSettings)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$accountSettings(model.translations))
											]))
									])) : $elm$html$Html$text(''),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$maybeYouWereLookingFor(model.translations))
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(model.links.social)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$posts(model.translations))
											])),
										$elm$html$Html$text(' or '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(model.links.listen)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$conversations(model.translations))
											]))
									])),
								(model.sitesCount !== 1) ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$NoPermissionPopup$accessToMoreAccounts(model.translations)),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(model.links.switchAccounts)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$switchAccount(model.translations))
											])),
										$elm$html$Html$text(
										$author$project$Translations$General$NoPermissionPopup$or(model.translations)),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(model.links.logout)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$TopNavigation$logout(model.translations))
											])),
										$elm$html$Html$text(
										$author$project$Translations$General$NoPermissionPopup$loginWithDifferentAccount(model.translations))
									])) : $elm$html$Html$text(''),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$NoPermissionPopup$ifElseFails(model.translations)),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('mailto:support@pinmeto.com')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$NoPermissionPopup$contactSupport(model.translations))
											]))
									]))
							]))
				})));
};
var $author$project$Common$NoPermissionLightbox$main = $elm$browser$Browser$element(
	{
		init: $author$project$Common$NoPermissionLightbox$init,
		view: $author$project$Common$NoPermissionLightbox$view,
		update: $author$project$Common$NoPermissionLightbox$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$init = function (siteName) {
	return {variant: $author$project$Common$Image$Types$Cover, siteName: siteName, showLightBox: false, uiTableState: $author$project$PinMeTo$Ui$Table$init, locationContent: $author$project$RemoteData$Loading};
};
var $author$project$Data$Network$GoogleBusinessAccountId$NoAccount = {$: 'NoAccount'};
var $author$project$BrandManagement$Google$Types$GoogleBusinessAccount = F7(
	function (name, id, googleAccountId, enabled, locationCount, media, isWebhookSubscribed) {
		return {id: id, name: name, media: media, enabled: enabled, locationCount: locationCount, googleAccountId: googleAccountId, isWebhookSubscribed: isWebhookSubscribed};
	});
var $author$project$Data$Network$GoogleBusinessAccountId$AccountId = function (a) {
	return {$: 'AccountId', a: a};
};
var $author$project$Data$Network$GoogleBusinessAccountId$googleBusinessAccountIdDecoder = function () {
	var accountIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Network$GoogleBusinessAccountId$AccountId, $elm$json$Json$Decode$string);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				accountIdDecoder,
				$elm$json$Json$Decode$succeed($author$project$Data$Network$GoogleBusinessAccountId$NoAccount)
			]));
}();
var $author$project$BrandManagement$Google$Types$GoogleMedia = F2(
	function (url, previewUrl) {
		return {url: url, previewUrl: previewUrl};
	});
var $author$project$BrandManagement$Google$Decoders$googleMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'previewUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$Types$GoogleMedia)));
var $author$project$BrandManagement$Google$Types$GoogleBusinessAccountMedia = F2(
	function (profileImage, coverImage) {
		return {coverImage: coverImage, profileImage: profileImage};
	});
var $author$project$BrandManagement$Google$Decoders$googleBusinessAccountMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coverImage',
	$elm$json$Json$Decode$maybe($author$project$BrandManagement$Google$Decoders$googleMediaDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profileImage',
		$elm$json$Json$Decode$maybe($author$project$BrandManagement$Google$Decoders$googleMediaDecoder),
		$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$Types$GoogleBusinessAccountMedia)));
var $author$project$BrandManagement$Google$Decoders$googleBusinessAccountDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isWebhookSubscribed',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'media',
		$author$project$BrandManagement$Google$Decoders$googleBusinessAccountMediaDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locationCount',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enabled',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'googleAccountId',
					$author$project$Data$Network$GoogleBusinessAccountId$googleBusinessAccountIdDecoder,
					$author$project$Data$Network$GoogleBusinessAccountId$NoAccount,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'_id',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['account', 'accountName']),
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$Types$GoogleBusinessAccount))))))));
var $author$project$BrandManagement$Google$Decoders$googleBusinessAccountListDecoder = $elm$json$Json$Decode$list($author$project$BrandManagement$Google$Decoders$googleBusinessAccountDecoder);
var $author$project$BrandManagement$Google$Commands$getGoogleBusinessAccounts = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/network/google/businessaccounts');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$BrandManagement$Google$Decoders$googleBusinessAccountListDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Google$Model$OnGoogleBusinessAccountsReceived = function (a) {
	return {$: 'OnGoogleBusinessAccountsReceived', a: a};
};
var $author$project$BrandManagement$Google$Main$init = F2(
	function (session, _v0) {
		var initialModel = {
			selectedPage: $elm$core$Maybe$Nothing,
			brandMediaStates: $elm$core$Dict$empty,
			businessAccounts: $author$project$RemoteData$Loading,
			resetMediaLightbox: $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$init(session.siteName),
			brandCoverImageInfo: $elm$core$Dict$empty,
			brandProfileImageInfo: $elm$core$Dict$empty,
			locationGroupSearchTerm: ''
		};
		return _Utils_Tuple2(
			initialModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$BrandManagement$Google$Commands$getGoogleBusinessAccounts, session.siteName, $author$project$BrandManagement$Google$Model$OnGoogleBusinessAccountsReceived)
					])));
	});
var $author$project$BrandManagement$Google$View$BrandMediaInfo$NoOp = {$: 'NoOp'};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$EditorMsg = function (a) {
	return {$: 'EditorMsg', a: a};
};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$OnCoverClick = {$: 'OnCoverClick'};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$OnCoverLoaded = {$: 'OnCoverLoaded'};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$OnProfileClick = {$: 'OnProfileClick'};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$OnProfileLoaded = {$: 'OnProfileLoaded'};
var $author$project$Translations$Listings$BrandPages$cropLogoImageGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.crop_logo_image_google');
};
var $author$project$Translations$Listings$BrandPages$addLogoImageForGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.add_logo_image_for_google');
};
var $author$project$Translations$Listings$BrandPages$addCoverImageForGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.add_cover_image_for_google');
};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$view = F3(
	function (user, translations, _v0) {
		var editor = _v0.editor;
		var businessAccount = _v0.businessAccount;
		var coverLoaded = _v0.coverLoaded;
		var profileLoaded = _v0.profileLoaded;
		var getMediaPreviewWithDefault = function (maybeMedia) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.previewUrl;
					},
					maybeMedia));
		};
		var userIsOwner = A2($author$project$Data$User$hasRole, user, $author$project$Data$User$Owner);
		var skeletonImg = F3(
			function (img, attributes, isLoading) {
				return $author$project$PinMeTo$Ui$Skeleton$view(
					{
						shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
						children: _List_fromArray(
							[img]),
						isLoading: isLoading,
						attributes: attributes
					});
			});
		var profileImage = function () {
			var profileImageClass = userIsOwner ? 'pmt-brand-management__brand-media-info__profile__google' : 'pmt-brand-management__brand-media-info__profile__not-owner';
			var profileImageAttributes = _List_fromArray(
				[
					$elm$html$Html$Attributes$src(
					getMediaPreviewWithDefault(businessAccount.media.profileImage)),
					$elm$html$Html$Attributes$class(profileImageClass),
					A2(
					$elm$html$Html$Events$on,
					'load',
					$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$View$BrandMediaInfo$OnProfileLoaded))
				]);
			var profileOverlay = userIsOwner ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__profile__overlay')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__edit-container')
							]),
						_List_fromArray(
							[
								$author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faPencil)
							]))
					])) : $elm$html$Html$text('');
			var msg = userIsOwner ? $author$project$BrandManagement$Google$View$BrandMediaInfo$OnProfileClick : $author$project$BrandManagement$Google$View$BrandMediaInfo$NoOp;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__profile-container'),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						A3(
						skeletonImg,
						A2($elm$html$Html$img, profileImageAttributes, _List_Nil),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(profileImageClass)
							]),
						!profileLoaded),
						profileOverlay
					]));
		}();
		var imageEditor = function () {
			if (editor.$ === 'Just') {
				var _v2 = editor.a;
				var mediaType = _v2.a;
				var state = _v2.b;
				return A2(
					$elm$html$Html$map,
					$author$project$BrandManagement$Google$View$BrandMediaInfo$EditorMsg,
					A3(
						$author$project$Common$Image$Editor$view,
						translations,
						{
							title: function () {
								if (mediaType.$ === 'Profile') {
									return $author$project$Translations$Listings$BrandPages$addLogoImageForGoogle(translations);
								} else {
									return $author$project$Translations$Listings$BrandPages$addCoverImageForGoogle(translations);
								}
							}(),
							cropTitle: function () {
								if (mediaType.$ === 'Profile') {
									return $author$project$Translations$Listings$BrandPages$cropLogoImageGoogle(translations);
								} else {
									return $author$project$Translations$Listings$BrandPages$cropCoverImage(translations);
								}
							}(),
							confirmLabel: $author$project$Translations$Listings$BrandPages$publish(translations)
						},
						state));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var coverImage = function () {
			var editOverLay = userIsOwner ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__cover__overlay')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__edit-container')
							]),
						_List_fromArray(
							[
								$author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faPencil),
								$elm$html$Html$text(
								$author$project$Translations$Listings$BrandPages$edit(translations))
							]))
					])) : $elm$html$Html$text('');
			var coverClass = userIsOwner ? 'pmt-brand-management__brand-media-info__cover' : 'pmt-brand-management__brand-media-info__cover-not-owner';
			var msg = userIsOwner ? $author$project$BrandManagement$Google$View$BrandMediaInfo$OnCoverClick : $author$project$BrandManagement$Google$View$BrandMediaInfo$NoOp;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__cover-container'),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						A3(
						skeletonImg,
						A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									getMediaPreviewWithDefault(businessAccount.media.coverImage)),
									$elm$html$Html$Attributes$class(coverClass),
									A2(
									$elm$html$Html$Events$on,
									'load',
									$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$View$BrandMediaInfo$OnCoverLoaded))
								]),
							_List_Nil),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(coverClass)
							]),
						!coverLoaded),
						editOverLay
					]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__brand-media-info__container')
				]),
			_List_fromArray(
				[coverImage, profileImage, imageEditor]));
	});
var $author$project$BrandManagement$Google$Model$BrandMediaInfoMsg = F2(
	function (a, b) {
		return {$: 'BrandMediaInfoMsg', a: a, b: b};
	});
var $author$project$Translations$Listings$BrandPages$customLogoImagesGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.custom_logo_images_google');
};
var $author$project$BrandManagement$Google$Model$DisplayCoverImageResetLightBox = function (a) {
	return {$: 'DisplayCoverImageResetLightBox', a: a};
};
var $author$project$BrandManagement$Google$Model$DisplayProfileImageResetLightBox = function (a) {
	return {$: 'DisplayProfileImageResetLightBox', a: a};
};
var $author$project$BrandManagement$Google$View$BrandListView$brandCard = F5(
	function (translations, user, account, _v0, model) {
		var profileStatus = _v0.profileStatus;
		var coverStatus = _v0.coverStatus;
		var brandCardImageInfo = function () {
			var getLocationNumberForStatus = function (statusList) {
				return A2($author$project$RemoteData$map, $elm$core$List$length, statusList);
			};
			var getLocationStatusNumberString = function (statusList) {
				return A3(
					$author$project$RemoteData$unpack,
					$elm$core$Basics$always('(...)'),
					function (num) {
						return '(' + ($elm$core$String$fromInt(num) + ')');
					},
					getLocationNumberForStatus(statusList));
			};
			var profileImageNumber = getLocationStatusNumberString(profileStatus);
			var coverImageNumber = getLocationStatusNumberString(coverStatus);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-media-information')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-media-information-row')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$disabledIfTrue,
									A2(
										$author$project$RemoteData$withDefault,
										true,
										A2(
											$author$project$RemoteData$map,
											$elm$core$Basics$eq(0),
											getLocationNumberForStatus(profileStatus))),
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$BrandManagement$Google$Model$DisplayProfileImageResetLightBox(account.id),
											A2(
												$author$project$PinMeTo$Ui$Button$withGhostStyle,
												$author$project$PinMeTo$Ui$Button$GhostNeutral,
												$author$project$PinMeTo$Ui$Button$buttonGhost(
													$author$project$Translations$Listings$BrandPages$customLogoImagesGoogle(translations) + (' ' + profileImageNumber)))))))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-media-information-row')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$disabledIfTrue,
									A2(
										$author$project$RemoteData$withDefault,
										true,
										A2(
											$author$project$RemoteData$map,
											$elm$core$Basics$eq(0),
											getLocationNumberForStatus(coverStatus))),
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											$author$project$BrandManagement$Google$Model$DisplayCoverImageResetLightBox(account.id),
											A2(
												$author$project$PinMeTo$Ui$Button$withGhostStyle,
												$author$project$PinMeTo$Ui$Button$GhostNeutral,
												$author$project$PinMeTo$Ui$Button$buttonGhost(
													$author$project$Translations$Listings$BrandPages$customCoverImages(translations) + (' ' + coverImageNumber)))))))
							]))
					]));
		}();
		var hideWebhookStatus = user.isDemo || A3(
			$elm$core$Basics$composeR,
			A2($author$project$Util$flip, $author$project$Data$User$hasRole, $author$project$Data$User$CustomerSuccess),
			$elm$core$Basics$not,
			user);
		var attributes = hideWebhookStatus ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-brand-management__webhook-info'),
				A2($elm$html$Html$Attributes$style, 'display', 'none')
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-brand-management__webhook-info')
			]);
		var webhookInfo = A2(
			$elm$html$Html$div,
			attributes,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$webhook(translations) + ': ')
						])),
					$elm$html$Html$text(
					account.isWebhookSubscribed ? $author$project$Translations$Listings$BrandPages$confirmed(translations) : $author$project$Translations$Listings$BrandPages$unconfirmed(translations))
				]));
		var brandCardTitle = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(account.name)
								])),
							webhookInfo
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(account.locationCount) + (' ' + $author$project$Translations$Listings$BrandPages$locations(translations)))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__brand_card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$BrandManagement$Google$Model$BrandMediaInfoMsg(model.businessAccount.id),
					A3($author$project$BrandManagement$Google$View$BrandMediaInfo$view, user, translations, model)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[brandCardTitle, brandCardImageInfo]))
				]));
	});
var $author$project$BrandManagement$Google$View$BrandListView$renderList = F2(
	function (_v0, _v1) {
		var user = _v0.user;
		var translations = _v0.translations;
		var locationGroupSearchTerm = _v1.locationGroupSearchTerm;
		var brandMediaStates = _v1.brandMediaStates;
		var businessAccounts = _v1.businessAccounts;
		var brandProfileImageInfo = _v1.brandProfileImageInfo;
		var brandCoverImageInfo = _v1.brandCoverImageInfo;
		var renderBrandCard = function (account) {
			var profileStatus = A2(
				$elm$core$Maybe$withDefault,
				$author$project$RemoteData$Loading,
				A2($elm$core$Dict$get, account.id, brandProfileImageInfo));
			var coverStatus = A2(
				$elm$core$Maybe$withDefault,
				$author$project$RemoteData$Loading,
				A2($elm$core$Dict$get, account.id, brandCoverImageInfo));
			var mediaState = A2($elm$core$Dict$get, account.id, brandMediaStates);
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					A4(
						$author$project$BrandManagement$Google$View$BrandListView$brandCard,
						translations,
						user,
						account,
						{coverStatus: coverStatus, profileStatus: profileStatus}),
					mediaState));
		};
		var renderPage = function (account) {
			return A2(
				$elm$html$Html$Lazy$lazy,
				function (acc) {
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-brand-management__brand-card-container')
							]),
						_List_fromArray(
							[
								renderBrandCard(acc)
							]));
				},
				account);
		};
		return A2(
			$elm$html$Html$Keyed$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__google-brand_list')
				]),
			A2(
				$author$project$RemoteData$withDefault,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'__default-id',
						$elm$html$Html$text(''))
					]),
				A2(
					$author$project$RemoteData$map,
					$elm$core$List$map(
						function (acc) {
							return _Utils_Tuple2(
								acc.id,
								renderPage(acc));
						}),
					A2(
						$author$project$RemoteData$map,
						$elm$core$List$filter(
							function (acc) {
								return A2(
									$elm$core$String$contains,
									$elm$core$String$toLower(locationGroupSearchTerm),
									$elm$core$String$toLower(acc.name));
							}),
						businessAccounts))));
	});
var $author$project$Translations$Listings$BrandPages$searchLocationGroups = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.search_location_groups');
};
var $author$project$BrandManagement$Google$Model$OnLocationGroupSearch = function (a) {
	return {$: 'OnLocationGroupSearch', a: a};
};
var $author$project$BrandManagement$Google$View$BrandListView$view = F2(
	function (session, model) {
		var searchBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__search-bar-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Input$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$BrandPages$searchLocationGroups(session.translations),
						$author$project$PinMeTo$Ui$Form$Input$search(
							{value: model.locationGroupSearchTerm, onChange: $author$project$BrandManagement$Google$Model$OnLocationGroupSearch})))
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					searchBar,
					A2($author$project$BrandManagement$Google$View$BrandListView$renderList, session, model)
				]));
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$Close = {$: 'Close'};
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$ResetMedia = {$: 'ResetMedia'};
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$BrandPages$lightBoxHeadingLogoGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.light_box_heading_logo_google');
};
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$view = F2(
	function (translations, model) {
		if (model.showLightBox) {
			var subTitleText = $author$project$Translations$Listings$BrandPages$lightBoxSubHeading(translations);
			var numSelected = $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Util$flip,
						$elm$core$List$member,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.locationId;
							},
							A2($author$project$RemoteData$withDefault, _List_Nil, model.locationContent))),
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTableState)));
			var selectedNumberString = (!(!numSelected)) ? (' (' + ($elm$core$String$fromInt(numSelected) + ')')) : '';
			var loadedBody = function (customMedia) {
				return A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTableState,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowSelection,
						function ($) {
							return $.locationId;
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withColumns,
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Table$columnWithOptions,
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Table$Compact]),
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										function (media) {
											return A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-image-preview'),
														$elm$html$Html$Attributes$src(media.previewUrl)
													]),
												_List_Nil);
										},
										$author$project$PinMeTo$Ui$Table$comparingString(
											function ($) {
												return $.previewUrl;
											}),
										$author$project$Translations$Listings$BrandPages$imageColumn(translations))),
									A2(
									$author$project$PinMeTo$Ui$Table$columnWithOptions,
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Table$Compact]),
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										function (media) {
											return $elm$html$Html$text(media.storeId);
										},
										$author$project$PinMeTo$Ui$Table$comparingString(
											function ($) {
												return $.storeId;
											}),
										$author$project$Translations$Listings$BrandPages$storeIdColumn(translations))),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (media) {
										return $elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, '', media.descriptor));
									},
									$author$project$PinMeTo$Ui$Table$comparingMaybe(
										function ($) {
											return $.descriptor;
										}),
									$author$project$Translations$Listings$BrandPages$descriptorColumn(translations))
								]),
							$author$project$PinMeTo$Ui$Table$withFullWidth(
								A2($author$project$PinMeTo$Ui$Table$view, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$UiTableMsg, customMedia)))));
			};
			var titleText = function () {
				var _v1 = model.variant;
				if (_v1.$ === 'Cover') {
					return $author$project$Translations$Listings$BrandPages$lightBoxHeadingCover(translations);
				} else {
					return $author$project$Translations$Listings$BrandPages$lightBoxHeadingLogoGoogle(translations);
				}
			}();
			var footer = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-footer')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$BrandManagement$Google$View$CustomMediaResetLightBox$Close,
							A2(
								$author$project$PinMeTo$Ui$Button$withSize,
								$author$project$PinMeTo$Ui$Button$Large,
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostNeutral,
									$author$project$PinMeTo$Ui$Button$buttonGhost(
										$author$project$Translations$General$cancel(translations)))))),
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$disabledIfTrue,
							!numSelected,
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								A3(
									$author$project$RemoteData$unwrap,
									true,
									$elm$core$Basics$always(false),
									model.locationContent),
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$BrandManagement$Google$View$CustomMediaResetLightBox$ResetMedia,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Large,
										$author$project$PinMeTo$Ui$Button$buttonPrimary(
											_Utils_ap(
												$author$project$Translations$Listings$BrandPages$resetToBrand(translations),
												selectedNumberString)))))))
					]));
			var title = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-title')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(titleText)
							])),
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(subTitleText)
							]))
					]));
			var content = function () {
				var body = function () {
					var _v0 = model.locationContent;
					switch (_v0.$) {
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinner;
						case 'Loaded':
							var t = _v0.a;
							return loadedBody(t);
						default:
							return $elm$html$Html$text(
								$author$project$Translations$Listings$BrandPages$failedToLoad(translations));
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-container')
						]),
					_List_fromArray(
						[
							title,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-brand-management__reset-media-lightbox-table-container')
								]),
							_List_fromArray(
								[body]))
						]));
			}();
			return $author$project$PinMeTo$Ui$Lightbox$render(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					footer,
					$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withStyle,
							$author$project$PinMeTo$Ui$Lightbox$Medium,
							$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$BrandManagement$Google$View$CustomMediaResetLightBox$Close,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{title: '', content: content})))))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$Listings$BrandPages$googleLocationGroups = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.brand_pages.google_location_groups');
};
var $author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg = function (a) {
	return {$: 'CustomMediaResetLightBoxMsg', a: a};
};
var $author$project$BrandManagement$Google$View$view = F2(
	function (session, model) {
		var title = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__page-title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$brandManagement(session.translations))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$BrandPages$googleLocationGroups(session.translations))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-brand-management__page-container')
				]),
			_List_fromArray(
				[
					title,
					A2($author$project$BrandManagement$Google$View$BrandListView$view, session, model),
					A2(
					$elm$html$Html$map,
					$author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg,
					A2($author$project$BrandManagement$Google$View$CustomMediaResetLightBox$view, session.translations, model.resetMediaLightbox))
				]));
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$Open = {$: 'Open'};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$init = F2(
	function (businessAccount, siteName) {
		return {editor: $elm$core$Maybe$Nothing, siteName: siteName, coverLoaded: false, profileLoaded: false, businessAccount: businessAccount};
	});
var $author$project$Common$Image$Validation$Google = {$: 'Google'};
var $author$project$BrandManagement$Google$View$BrandMediaInfo$openEditor = F2(
	function (mediaType, model) {
		var _v0 = A4($author$project$Common$Image$Editor$init, $author$project$Common$Image$Validation$Google, mediaType, model.siteName, 'the-google-cropper');
		var state = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					editor: $elm$core$Maybe$Just(
						_Utils_Tuple2(mediaType, state))
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$BrandManagement$Google$View$BrandMediaInfo$EditorMsg, cmd));
	});
var $author$project$BrandManagement$Google$View$BrandMediaInfo$OnMediaPublished = function (a) {
	return {$: 'OnMediaPublished', a: a};
};
var $author$project$BrandManagement$Google$Commands$setRegionalGoogleMedia = F5(
	function (_v0, mediaType, brandPageId, media, msg) {
		var siteName = _v0.a;
		var mediaPath = function () {
			if (mediaType.$ === 'Profile') {
				return 'profileimage/';
			} else {
				return 'coverimage/';
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mediaId',
					$elm$json$Json$Encode$string(media.id))
				]));
		var url = 'api/' + (siteName + ('/google/media/' + (mediaPath + brandPageId)));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(brandPageId),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						body,
						$lukewestby$elm_http_builder$HttpBuilder$put(url)))));
	});
var $author$project$BrandManagement$Google$View$BrandMediaInfo$out_BrandManagement_Google_Main_CropImage = _Platform_outgoingPort('out_BrandManagement_Google_Main_CropImage', $elm$core$Basics$identity);
var $author$project$BrandManagement$Google$View$BrandMediaInfo$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnProfileLoaded':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{profileLoaded: true}),
					$elm$core$Platform$Cmd$none);
			case 'OnCoverLoaded':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{coverLoaded: true}),
					$elm$core$Platform$Cmd$none);
			case 'OnProfileClick':
				return A2($author$project$BrandManagement$Google$View$BrandMediaInfo$openEditor, $author$project$Common$Image$Types$Profile, model);
			case 'OnCoverClick':
				return A2($author$project$BrandManagement$Google$View$BrandMediaInfo$openEditor, $author$project$Common$Image$Types$Cover, model);
			case 'EditorMsg':
				var editorMsg = msg.a;
				var _v1 = model.editor;
				if (_v1.$ === 'Just') {
					var _v2 = _v1.a;
					var mediaType = _v2.a;
					var state = _v2.b;
					var _v3 = A3(
						$author$project$Common$Image$Editor$update,
						{cropImage: $author$project$BrandManagement$Google$View$BrandMediaInfo$out_BrandManagement_Google_Main_CropImage},
						editorMsg,
						state);
					var newState = _v3.a;
					var cmd = _v3.b;
					var event = _v3.c;
					var editorCmd = A2($elm$core$Platform$Cmd$map, $author$project$BrandManagement$Google$View$BrandMediaInfo$EditorMsg, cmd);
					if (event.$ === 'Nothing') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(
										_Utils_Tuple2(mediaType, newState))
								}),
							editorCmd);
					} else {
						if (event.a.$ === 'Cancelled') {
							var _v5 = event.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{editor: $elm$core$Maybe$Nothing}),
								editorCmd);
						} else {
							var media = event.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{editor: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											editorCmd,
											A5($author$project$BrandManagement$Google$Commands$setRegionalGoogleMedia, model.siteName, mediaType, model.businessAccount.id, media, $author$project$BrandManagement$Google$View$BrandMediaInfo$OnMediaPublished)
										])));
						}
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
								context: 'BrandManagement.Google.View.BrandMediaInfo',
								message: 'Failed to publish media'
							}));
				}
		}
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnLocationMediaReset = function (a) {
	return {$: 'OnLocationMediaReset', a: a};
};
var $author$project$BrandManagement$Google$Types$GoogleCustomLocationMedia = F7(
	function (locationId, accountId, name, storeId, url, previewUrl, descriptor) {
		return {url: url, name: name, storeId: storeId, accountId: accountId, descriptor: descriptor, locationId: locationId, previewUrl: previewUrl};
	});
var $author$project$BrandManagement$Google$Decoders$googleCustomLocationMediaDecoder = F2(
	function (mediaType, accountId) {
		var key = function () {
			if (mediaType.$ === 'Cover') {
				return 'coverImage';
			} else {
				return 'profileImage';
			}
		}();
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'locationDescriptor',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['networkMedia', 'google', key, 'previewUrl']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['networkMedia', 'google', key, 'url']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'storeId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'',
								$elm$json$Json$Decode$string,
								accountId,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'_id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$Types$GoogleCustomLocationMedia))))))));
	});
var $author$project$BrandManagement$Google$Decoders$googleCustomLocationMediaListDecoder = F2(
	function (mediaType, accountId) {
		return $elm$json$Json$Decode$list(
			A2($author$project$BrandManagement$Google$Decoders$googleCustomLocationMediaDecoder, mediaType, accountId));
	});
var $author$project$BrandManagement$Google$Commands$getCustomGoogleMediaForPageId = F4(
	function (mediaType, _v0, pageId, msg) {
		var siteName = _v0.a;
		var url = function () {
			if (mediaType.$ === 'Cover') {
				return 'api/' + (siteName + ('/media/cover/google/status/' + pageId));
			} else {
				return 'api/' + (siteName + ('/media/profile/google/status/' + pageId));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$BrandManagement$Google$Decoders$googleCustomLocationMediaListDecoder, mediaType, pageId),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnCustomLocationCoverInfoReceived = function (a) {
	return {$: 'OnCustomLocationCoverInfoReceived', a: a};
};
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnCustomLocationProfileInfoReceived = function (a) {
	return {$: 'OnCustomLocationProfileInfoReceived', a: a};
};
var $author$project$BrandManagement$Google$Commands$putGoogleRegionalImageForLocationId = F4(
	function (mediaType, _v0, msg, locationId) {
		var siteName = _v0.a;
		var url = function () {
			if (mediaType.$ === 'Cover') {
				return 'api/' + (siteName + ('/place/' + (locationId + '/image/google/coverImage/regional')));
			} else {
				return 'api/' + (siteName + ('/place/' + (locationId + '/image/google/profileImage/regional')));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(locationId),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$put(url))));
	});
var $author$project$BrandManagement$Google$Commands$putGoogleRegionalCoverImageForLocationId = $author$project$BrandManagement$Google$Commands$putGoogleRegionalImageForLocationId($author$project$Common$Image$Types$Cover);
var $author$project$BrandManagement$Google$Commands$putGoogleRegionalProfileImageForLocationId = $author$project$BrandManagement$Google$Commands$putGoogleRegionalImageForLocationId($author$project$Common$Image$Types$Profile);
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'Open':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showLightBox: true, uiTableState: $author$project$PinMeTo$Ui$Table$init}),
					$elm$core$Platform$Cmd$none);
			case 'Close':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showLightBox: false}),
					$elm$core$Platform$Cmd$none);
			case 'FetchProfileForPageId':
				var siteName = msg.a;
				var pageId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{variant: $author$project$Common$Image$Types$Profile}),
					A4($author$project$BrandManagement$Google$Commands$getCustomGoogleMediaForPageId, $author$project$Common$Image$Types$Profile, siteName, pageId, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnCustomLocationProfileInfoReceived));
			case 'FetchCoverForPageId':
				var siteName = msg.a;
				var pageId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{variant: $author$project$Common$Image$Types$Cover}),
					A4($author$project$BrandManagement$Google$Commands$getCustomGoogleMediaForPageId, $author$project$Common$Image$Types$Cover, siteName, pageId, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnCustomLocationCoverInfoReceived));
			case 'OnCustomLocationProfileInfoReceived':
				if (msg.a.$ === 'Ok') {
					var customInfo = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Loaded(customInfo)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.View.CustomMediaResetLightBox',
							message: 'Failed to fetch profile media'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Error('Failed to load profile info for locations')
							}),
						cmd);
				}
			case 'OnCustomLocationCoverInfoReceived':
				if (msg.a.$ === 'Ok') {
					var customInfo = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Loaded(customInfo)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.View.CustomMediaResetLightBox',
							message: 'Failed to fetch cover media'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationContent: $author$project$RemoteData$Error('Failed to load cover info for locations')
							}),
						cmd);
				}
			case 'ResetMedia':
				var fn = function () {
					var _v1 = model.variant;
					if (_v1.$ === 'Cover') {
						return A2($author$project$BrandManagement$Google$Commands$putGoogleRegionalCoverImageForLocationId, model.siteName, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnLocationMediaReset);
					} else {
						return A2($author$project$BrandManagement$Google$Commands$putGoogleRegionalProfileImageForLocationId, model.siteName, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$OnLocationMediaReset);
					}
				}();
				var cmds = A2(
					$elm$core$List$map,
					fn,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTableState));
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(cmds));
			case 'UiTableMsg':
				var tableMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTableState: A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.uiTableState)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 'Ok') {
					var locationId = msg.a.a;
					var newListState = A3(
						$author$project$Util$flip,
						$author$project$PinMeTo$Ui$Table$setSelected,
						model.uiTableState,
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(locationId),
							$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTableState)));
					var newItems = A2(
						$author$project$RemoteData$map,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.locationId;
								},
								$elm$core$Basics$neq(locationId))),
						model.locationContent);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{uiTableState: newListState, locationContent: newItems}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.View.CustomMediaResetLightBox',
							message: 'Failed to reset media'
						});
					return _Utils_Tuple2(model, cmd);
				}
		}
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$FetchCoverForPageId = F2(
	function (a, b) {
		return {$: 'FetchCoverForPageId', a: a, b: b};
	});
var $author$project$BrandManagement$Google$Types$PartialGoogleBusinessAccount = F6(
	function (name, id, googleAccountId, enabled, media, isWebhookSubscribed) {
		return {id: id, name: name, media: media, enabled: enabled, googleAccountId: googleAccountId, isWebhookSubscribed: isWebhookSubscribed};
	});
var $author$project$BrandManagement$Google$Decoders$partialGoogleBusinessAccountDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isWebhookSubscribed',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'media',
		$author$project$BrandManagement$Google$Decoders$googleBusinessAccountMediaDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enabled',
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'googleAccountId',
				$author$project$Data$Network$GoogleBusinessAccountId$googleBusinessAccountIdDecoder,
				$author$project$Data$Network$GoogleBusinessAccountId$NoAccount,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'_id',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['account', 'accountName']),
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$BrandManagement$Google$Types$PartialGoogleBusinessAccount)))))));
var $author$project$BrandManagement$Google$Commands$fetchGoogleBrandPage = F3(
	function (_v0, accountId, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + ('/network/google/businessaccounts/' + accountId));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$BrandManagement$Google$Decoders$partialGoogleBusinessAccountDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$FetchProfileForPageId = F2(
	function (a, b) {
		return {$: 'FetchProfileForPageId', a: a, b: b};
	});
var $author$project$BrandManagement$Google$Model$OnCoverImageInfoReceived = F2(
	function (a, b) {
		return {$: 'OnCoverImageInfoReceived', a: a, b: b};
	});
var $author$project$BrandManagement$Google$Model$OnProfileImageInfoReceived = F2(
	function (a, b) {
		return {$: 'OnProfileImageInfoReceived', a: a, b: b};
	});
var $author$project$BrandManagement$Google$Model$OnGoogleBusinessAccountRefetched = function (a) {
	return {$: 'OnGoogleBusinessAccountRefetched', a: a};
};
var $author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountLocationsWithCustomMedia = F4(
	function (mediaType, _v0, _v1, msg) {
		var siteName = _v0.a;
		var accountId = _v1.accountId;
		var url = function () {
			if (mediaType.$ === 'Cover') {
				return 'api/' + (siteName + ('/media/cover/google/status/' + accountId));
			} else {
				return 'api/' + (siteName + ('/media/profile/google/status/' + accountId));
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$BrandManagement$Google$Decoders$googleCustomLocationMediaListDecoder, mediaType, accountId),
					$elm$json$Json$Decode$succeed(accountId)),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountCoverImageStatus = $author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountLocationsWithCustomMedia($author$project$Common$Image$Types$Cover);
var $author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountProfileImageStatus = $author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountLocationsWithCustomMedia($author$project$Common$Image$Types$Profile);
var $author$project$BrandManagement$Google$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnGoogleBusinessAccountsReceived':
				if (msg.a.$ === 'Ok') {
					var businessAccounts = msg.a.a;
					var initialStateDict = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (account) {
								return _Utils_Tuple2(
									account.id,
									A2($author$project$BrandManagement$Google$View$BrandMediaInfo$init, account, session.siteName));
							},
							businessAccounts));
					var initialImageDict = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (page) {
								return _Utils_Tuple2(page.id, $author$project$RemoteData$Loading);
							},
							businessAccounts));
					var getMediaInfoCmds = function () {
						var profileImageCmds = A2(
							$elm$core$List$map,
							function (page) {
								return A3(
									$author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountProfileImageStatus,
									session.siteName,
									{accountId: page.id},
									$author$project$BrandManagement$Google$Model$OnProfileImageInfoReceived(page.id));
							},
							businessAccounts);
						var coverImageCmds = A2(
							$elm$core$List$map,
							function (page) {
								return A3(
									$author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountCoverImageStatus,
									session.siteName,
									{accountId: page.id},
									$author$project$BrandManagement$Google$Model$OnCoverImageInfoReceived(page.id));
							},
							businessAccounts);
						return A2($elm$core$List$append, coverImageCmds, profileImageCmds);
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								brandMediaStates: initialStateDict,
								businessAccounts: $author$project$RemoteData$Loaded(businessAccounts),
								brandCoverImageInfo: initialImageDict,
								brandProfileImageInfo: initialImageDict
							}),
						$elm$core$Platform$Cmd$batch(getMediaInfoCmds));
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.Main',
							message: 'Failed to fetch google business accounts'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessAccounts: $author$project$RemoteData$Error('Failed to fetch business accounts')
							}),
						cmd);
				}
			case 'OnCoverImageInfoReceived':
				if (msg.b.$ === 'Ok') {
					var accountId = msg.a;
					var coverImageInfo = msg.b.a;
					var updatedDict = A3(
						$elm$core$Dict$insert,
						accountId,
						$author$project$RemoteData$Loaded(coverImageInfo),
						model.brandCoverImageInfo);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandCoverImageInfo: updatedDict}),
						$elm$core$Platform$Cmd$none);
				} else {
					var accountId = msg.a;
					var e = msg.b.a;
					var updatedDict = A3(
						$elm$core$Dict$insert,
						accountId,
						$author$project$RemoteData$Error(accountId),
						model.brandCoverImageInfo);
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.Main',
							message: 'Failed to fetch cover image info'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandCoverImageInfo: updatedDict}),
						cmd);
				}
			case 'OnProfileImageInfoReceived':
				if (msg.b.$ === 'Ok') {
					var accountId = msg.a;
					var profileImageInfo = msg.b.a;
					var updatedDict = A3(
						$elm$core$Dict$insert,
						accountId,
						$author$project$RemoteData$Loaded(profileImageInfo),
						model.brandProfileImageInfo);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandProfileImageInfo: updatedDict}),
						$elm$core$Platform$Cmd$none);
				} else {
					var accountId = msg.a;
					var e = msg.b.a;
					var updatedDict = A3(
						$elm$core$Dict$insert,
						accountId,
						$author$project$RemoteData$Error(accountId),
						model.brandProfileImageInfo);
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.Main',
							message: 'Failed to fetch profile image info'
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandProfileImageInfo: updatedDict}),
						cmd);
				}
			case 'CustomMediaResetLightBoxMsg':
				var lightBoxMsg = msg.a;
				var _v1 = function () {
					var _v2 = _Utils_Tuple2(lightBoxMsg, model.selectedPage);
					if ((_v2.a.$ === 'Close') && (_v2.b.$ === 'Just')) {
						var _v3 = _v2.a;
						var accountId = _v2.b.a;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountCoverImageStatus,
										session.siteName,
										{accountId: accountId},
										$author$project$BrandManagement$Google$Model$OnCoverImageInfoReceived(accountId)),
										A3(
										$author$project$BrandManagement$Google$Commands$getGoogleBusinessAccountProfileImageStatus,
										session.siteName,
										{accountId: accountId},
										$author$project$BrandManagement$Google$Model$OnProfileImageInfoReceived(accountId))
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v1.a;
				var refreshCommand = _v1.b;
				var _v4 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg),
					A2($author$project$BrandManagement$Google$View$CustomMediaResetLightBox$update, lightBoxMsg, model.resetMediaLightbox));
				var newLightboxState = _v4.a;
				var newLightboxMsg = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{resetMediaLightbox: newLightboxState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[newLightboxMsg, refreshCommand])));
			case 'DisplayProfileImageResetLightBox':
				var pageId = msg.a;
				var _v5 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg),
					A2($author$project$BrandManagement$Google$View$CustomMediaResetLightBox$update, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$Open, model.resetMediaLightbox));
				var newLightboxState = _v5.a;
				var firstMessage = _v5.b;
				var _v6 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg),
					A2(
						$author$project$BrandManagement$Google$View$CustomMediaResetLightBox$update,
						A2($author$project$BrandManagement$Google$View$CustomMediaResetLightBox$FetchProfileForPageId, session.siteName, pageId),
						newLightboxState));
				var lastState = _v6.a;
				var secondMessage = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedPage: $elm$core$Maybe$Just(pageId),
							resetMediaLightbox: lastState
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[firstMessage, secondMessage])));
			case 'DisplayCoverImageResetLightBox':
				var pageId = msg.a;
				var _v7 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg),
					A2($author$project$BrandManagement$Google$View$CustomMediaResetLightBox$update, $author$project$BrandManagement$Google$View$CustomMediaResetLightBox$Open, model.resetMediaLightbox));
				var newLightboxState = _v7.a;
				var firstMessage = _v7.b;
				var _v8 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$BrandManagement$Google$Model$CustomMediaResetLightBoxMsg),
					A2(
						$author$project$BrandManagement$Google$View$CustomMediaResetLightBox$update,
						A2($author$project$BrandManagement$Google$View$CustomMediaResetLightBox$FetchCoverForPageId, session.siteName, pageId),
						newLightboxState));
				var lastState = _v8.a;
				var secondMessage = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedPage: $elm$core$Maybe$Just(pageId),
							resetMediaLightbox: lastState
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[firstMessage, secondMessage])));
			case 'BrandMediaInfoMsg':
				var pageId = msg.a;
				var mediaInfoMsg = msg.b;
				var _v9 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (_v10) {
							var state = _v10.a;
							var cmd = _v10.b;
							var updatedDict = A3($elm$core$Dict$insert, pageId, state, model.brandMediaStates);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										selectedPage: $elm$core$Maybe$Just(pageId),
										brandMediaStates: updatedDict
									}),
								cmd);
						},
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$mapSecond(
								$elm$core$Platform$Cmd$map(
									$author$project$BrandManagement$Google$Model$BrandMediaInfoMsg(pageId))),
							A2(
								$elm$core$Maybe$map,
								$author$project$BrandManagement$Google$View$BrandMediaInfo$update(mediaInfoMsg),
								A2($elm$core$Dict$get, pageId, model.brandMediaStates)))));
				var newModel = _v9.a;
				var nextMsg = _v9.b;
				var extraMsg = function () {
					if ((mediaInfoMsg.$ === 'OnMediaPublished') && (mediaInfoMsg.a.$ === 'Ok')) {
						var pageToRefetch = mediaInfoMsg.a.a;
						return A3($author$project$BrandManagement$Google$Commands$fetchGoogleBrandPage, session.siteName, pageToRefetch, $author$project$BrandManagement$Google$Model$OnGoogleBusinessAccountRefetched);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[nextMsg, extraMsg])));
			case 'OnGoogleBusinessAccountRefetched':
				if (msg.a.$ === 'Ok') {
					var refreshedPage = msg.a.a;
					var businessAccounts = A2(
						$author$project$RemoteData$map,
						$elm$core$List$map(
							function (currentPage) {
								return _Utils_eq(currentPage.id, refreshedPage.id) ? _Utils_update(
									currentPage,
									{media: refreshedPage.media}) : currentPage;
							}),
						model.businessAccounts);
					var newMediaStates = A2(
						$elm$core$Maybe$withDefault,
						model.brandMediaStates,
						A2(
							$elm$core$Maybe$map,
							function (stateToUpdate) {
								return A3($elm$core$Dict$insert, refreshedPage.id, stateToUpdate, model.brandMediaStates);
							},
							A2(
								$elm$core$Maybe$map,
								function (state) {
									var updatedAccount = {id: state.businessAccount.id, name: state.businessAccount.name, media: refreshedPage.media, enabled: state.businessAccount.enabled, locationCount: state.businessAccount.locationCount, googleAccountId: state.businessAccount.googleAccountId, isWebhookSubscribed: state.businessAccount.isWebhookSubscribed};
									return _Utils_update(
										state,
										{businessAccount: updatedAccount});
								},
								A2($elm$core$Dict$get, refreshedPage.id, model.brandMediaStates))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{brandMediaStates: newMediaStates, businessAccounts: businessAccounts}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$log(
						{
							data: $author$project$PinMeTo$ExpectJson$getErrorMessage(e),
							context: 'BrandManagement.Google.Main',
							message: 'Failed to refetch Google business account'
						});
					return _Utils_Tuple2(model, cmd);
				}
			default:
				var newSearchTerm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationGroupSearchTerm: newSearchTerm}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$BrandManagement$Google$View$BrandMediaInfo$onImageCaptured_Google = _Platform_incomingPort('onImageCaptured_Google', $elm$json$Json$Decode$value);
var $author$project$BrandManagement$Google$View$BrandMediaInfo$subscriptions = function (model) {
	var _v0 = model.editor;
	if (_v0.$ === 'Just') {
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$BrandManagement$Google$View$BrandMediaInfo$EditorMsg,
			$author$project$Common$Image$Editor$subscriptions($author$project$BrandManagement$Google$View$BrandMediaInfo$onImageCaptured_Google));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$BrandManagement$Google$Main$subscriptions = function (model) {
	var selectedPageId = A2($elm$core$Maybe$withDefault, '', model.selectedPage);
	var relevantState = A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return A2($elm$core$Dict$get, id, model.brandMediaStates);
		},
		model.selectedPage);
	if (relevantState.$ === 'Just') {
		var state = relevantState.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$BrandManagement$Google$Model$BrandMediaInfoMsg(selectedPageId),
			$author$project$BrandManagement$Google$View$BrandMediaInfo$subscriptions(state));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$BrandManagement$Google$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$BrandManagement$Google$Main$init,
		view: $author$project$BrandManagement$Google$View$view,
		update: $author$project$BrandManagement$Google$Main$update,
		flagsDecoder: $elm$json$Json$Decode$succeed(_Utils_Tuple0),
		subscriptions: $author$project$BrandManagement$Google$Main$subscriptions
	});
var $author$project$Locations$Spreadsheet$Main$init = F2(
	function (_v0, _v1) {
		return _Utils_Tuple2(
			{dropZone: $author$project$Listings$Ui$DropZone$init, validation: $author$project$RemoteData$Suspended, editedTable: $author$project$PinMeTo$Ui$Table$init, errorsTable: $author$project$PinMeTo$Ui$Table$init, confirmation: $author$project$RemoteData$Suspended, createdTable: $author$project$PinMeTo$Ui$Table$init, unchangedTable: $author$project$PinMeTo$Ui$Table$init, collapsedSections: $elm$core$Set$empty},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$FontAwesome$Light = function (a) {
	return {$: 'Light', a: a};
};
var $author$project$FontAwesome$light = function (icon) {
	return $author$project$FontAwesome$Light(icon);
};
var $author$project$FontAwesome$Light$Icon$faPencil = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-pencil');
var $author$project$Locations$Spreadsheet$Model$EditedTable = {$: 'EditedTable'};
var $author$project$Locations$Spreadsheet$Model$TableMsg = F2(
	function (a, b) {
		return {$: 'TableMsg', a: a, b: b};
	});
var $author$project$Locations$Spreadsheet$View$Review$columns = _List_fromArray(
	[
		_Utils_Tuple2('Store ID', 'storeId'),
		_Utils_Tuple2('Facebook Store ID', 'fb - storeId'),
		_Utils_Tuple2('Storefront Name', 'name'),
		_Utils_Tuple2('Active', 'isActive'),
		_Utils_Tuple2('Custom Facebook Name', 'fb - custom - name'),
		_Utils_Tuple2('Custom Google Name', 'google - custom - name'),
		_Utils_Tuple2('Location Descriptor', 'locationDescriptor'),
		_Utils_Tuple2('Short Description', 'shortDescription'),
		_Utils_Tuple2('Long Description', 'longDescription'),
		_Utils_Tuple2('Street', 'address - street'),
		_Utils_Tuple2('City', 'address - city'),
		_Utils_Tuple2('State', 'address - state'),
		_Utils_Tuple2('Postal Code', 'address - zip'),
		_Utils_Tuple2('Country', 'address - country'),
		_Utils_Tuple2('Latitude', 'location - lat'),
		_Utils_Tuple2('Longitude', 'location - lon'),
		_Utils_Tuple2('Phone', 'contact - phone'),
		_Utils_Tuple2('Email', 'contact - email'),
		_Utils_Tuple2('Webpage', 'contact - homepage'),
		_Utils_Tuple2('Monday Hours', 'openHours - mon'),
		_Utils_Tuple2('Tuesday Hours', 'openHours - tue'),
		_Utils_Tuple2('Wednesday Hours', 'openHours - wed'),
		_Utils_Tuple2('Thursday Hours', 'openHours - thu'),
		_Utils_Tuple2('Friday Hours', 'openHours - fri'),
		_Utils_Tuple2('Saturday Hours', 'openHours - sat'),
		_Utils_Tuple2('Sunday Hours', 'openHours - sun'),
		_Utils_Tuple2('Always Open', 'isAlwaysOpen'),
		_Utils_Tuple2('Temporarily Closed Until', 'temporarilyClosedUntil'),
		_Utils_Tuple2('Permanently Closed', 'permanentlyClosed'),
		_Utils_Tuple2('Opening Date', 'openingDate'),
		_Utils_Tuple2('WiFi SSID', 'wifiSsid'),
		_Utils_Tuple2('Service Area', 'serviceAreas'),
		_Utils_Tuple2('Facebook Link', 'fb - data - link'),
		_Utils_Tuple2('Bing Maps', 'bing - businessStatus - PublishLink'),
		_Utils_Tuple2('Apple Maps', 'apple - data - placeCardUrl'),
		_Utils_Tuple2('Google Maps', 'google - data - link'),
		_Utils_Tuple2('Google Review Link', 'google - data - newReviewUrl')
	]);
var $author$project$Locations$Spreadsheet$View$Review$hasValues = function (change) {
	return !($elm$core$String$isEmpty(change.from) && $elm$core$String$isEmpty(change.to));
};
var $author$project$Locations$Spreadsheet$View$Review$fieldValue = F2(
	function (key, item) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, key, item.fields));
	});
var $author$project$Locations$Spreadsheet$View$Review$highlighted = function (content) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('spreadsheet-cell--changed')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $author$project$Locations$Spreadsheet$View$Review$viewChangeLine = function (change) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Locations$Spreadsheet$View$Review$highlighted('From: ' + (change.from + (' → To: ' + change.to)))
			]));
};
var $author$project$Locations$Spreadsheet$View$Review$isInternalId = function (field) {
	return A2(
		$elm$core$List$member,
		'_id',
		A2($elm$core$String$split, ' - ', field));
};
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Locations$Spreadsheet$View$Review$isHiddenServiceAreaField = function (field) {
	return A2($elm$core$String$startsWith, 'serviceAreas - ', field) && (!A2($elm$core$String$endsWith, ' - area', field));
};
var $author$project$Locations$Spreadsheet$View$Review$matchingChanges = F2(
	function (key, item) {
		return A2(
			$elm$core$List$filter,
			function (change) {
				return !$author$project$Locations$Spreadsheet$View$Review$isHiddenServiceAreaField(change.field);
			},
			A2(
				$elm$core$List$filter,
				function (change) {
					return !$author$project$Locations$Spreadsheet$View$Review$isInternalId(change.field);
				},
				A2(
					$elm$core$List$filter,
					function (change) {
						return _Utils_eq(change.field, key) || A2($elm$core$String$startsWith, key + ' - ', change.field);
					},
					item.changes)));
	});
var $author$project$Locations$Spreadsheet$View$Review$viewCell = F2(
	function (key, item) {
		var matches = A2($author$project$Locations$Spreadsheet$View$Review$matchingChanges, key, item);
		var valued = A2($elm$core$List$filter, $author$project$Locations$Spreadsheet$View$Review$hasValues, matches);
		return $elm$core$List$isEmpty(matches) ? $elm$html$Html$text(
			A2($author$project$Locations$Spreadsheet$View$Review$fieldValue, key, item)) : ($elm$core$List$isEmpty(valued) ? $author$project$Locations$Spreadsheet$View$Review$highlighted(
			A2($author$project$Locations$Spreadsheet$View$Review$fieldValue, key, item)) : A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Locations$Spreadsheet$View$Review$viewChangeLine, valued)));
	});
var $author$project$Locations$Spreadsheet$View$Review$cellOptions = _List_fromArray(
	[$author$project$PinMeTo$Ui$Table$MaxWidth, $author$project$PinMeTo$Ui$Table$Tooltip]);
var $author$project$Locations$Spreadsheet$View$Review$customDataPrefix = 'customData - ';
var $author$project$Locations$Spreadsheet$View$Review$customDataColumns = function (items) {
	return A2(
		$elm$core$List$map,
		function (key) {
			return _Utils_Tuple2(
				'Custom Data ' + A2(
					$elm$core$String$dropLeft,
					$elm$core$String$length($author$project$Locations$Spreadsheet$View$Review$customDataPrefix),
					key),
				key);
		},
		$elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$filter,
					$elm$core$String$startsWith($author$project$Locations$Spreadsheet$View$Review$customDataPrefix),
					A2(
						$elm$core$List$concatMap,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fields;
							},
							$elm$core$Dict$keys),
						items)))));
};
var $author$project$Locations$Spreadsheet$View$Review$withBaseColumns = F2(
	function (items, config) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, acc) {
					var header = _v0.a;
					var key = _v0.b;
					return A5(
						$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
						header,
						$author$project$Locations$Spreadsheet$View$Review$cellOptions,
						$author$project$Locations$Spreadsheet$View$Review$viewCell(key),
						$author$project$PinMeTo$Ui$Table$comparingString(
							$author$project$Locations$Spreadsheet$View$Review$fieldValue(key)),
						acc);
				}),
			config,
			_Utils_ap(
				$author$project$Locations$Spreadsheet$View$Review$columns,
				$author$project$Locations$Spreadsheet$View$Review$customDataColumns(items)));
	});
var $author$project$Locations$Spreadsheet$Model$tableIdKey = function (tableId) {
	switch (tableId.$) {
		case 'CreatedTable':
			return 'created';
		case 'EditedTable':
			return 'edited';
		case 'UnchangedTable':
			return 'unchanged';
		default:
			return 'errors';
	}
};
var $author$project$FontAwesome$Light$Icon$faChevronUp = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-chevron-up');
var $author$project$Locations$Spreadsheet$Model$ToggleSection = function (a) {
	return {$: 'ToggleSection', a: a};
};
var $author$project$FontAwesome$Light$Icon$faChevronDown = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-chevron-down');
var $author$project$Locations$Spreadsheet$View$Review$sectionHeader = F6(
	function (tableId, isCollapsed, icon, iconClass, title, count) {
		return A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spreadsheet-section__header'),
					$elm$html$Html$Events$onClick(
					$author$project$Locations$Spreadsheet$Model$ToggleSection(tableId))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(iconClass)
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(icon)
						])),
					$elm$html$Html$text(
					title + (' (' + ($elm$core$String$fromInt(count) + ')'))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('spreadsheet-section__chevron')
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(
							$author$project$FontAwesome$light(
								isCollapsed ? $author$project$FontAwesome$Light$Icon$faChevronDown : $author$project$FontAwesome$Light$Icon$faChevronUp))
						]))
				]));
	});
var $author$project$Locations$Spreadsheet$View$Review$viewSectionContainer = F7(
	function (tableId, collapsed, icon, iconClass, title, items, table) {
		if ($elm$core$List$isEmpty(items)) {
			return $elm$html$Html$text('');
		} else {
			var isCollapsed = A2(
				$elm$core$Set$member,
				$author$project$Locations$Spreadsheet$Model$tableIdKey(tableId),
				collapsed);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section section--solid')
					]),
				_List_fromArray(
					[
						A6(
						$author$project$Locations$Spreadsheet$View$Review$sectionHeader,
						tableId,
						isCollapsed,
						icon,
						iconClass,
						title,
						$elm$core$List$length(items)),
						isCollapsed ? $elm$html$Html$text('') : table
					]));
		}
	});
var $author$project$Locations$Spreadsheet$View$Review$viewSection = F7(
	function (collapsed, tableId, state, icon, iconClass, title, items) {
		return A7(
			$author$project$Locations$Spreadsheet$View$Review$viewSectionContainer,
			tableId,
			collapsed,
			icon,
			iconClass,
			title,
			items,
			A2(
				$author$project$PinMeTo$Ui$Table$render,
				state,
				A2(
					$author$project$Locations$Spreadsheet$View$Review$withBaseColumns,
					items,
					A2(
						$author$project$PinMeTo$Ui$Table$view,
						$author$project$Locations$Spreadsheet$Model$TableMsg(tableId),
						items))));
	});
var $author$project$Locations$Spreadsheet$Model$CreatedTable = {$: 'CreatedTable'};
var $author$project$FontAwesome$Light$Icon$faCirclePlus = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-circle-plus');
var $author$project$Translations$Listings$Spreadsheet$reviewEdited = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.review_edited');
};
var $author$project$Locations$Spreadsheet$Model$Approve = {$: 'Approve'};
var $author$project$Translations$Listings$Spreadsheet$approve = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.approve');
};
var $author$project$Locations$Spreadsheet$View$Review$approveButton = F3(
	function (translations, model, result) {
		var loading = function () {
			var _v0 = model.confirmation;
			if (_v0.$ === 'Loading') {
				return true;
			} else {
				return false;
			}
		}();
		var count = $elm$core$List$length(result.newObjects) + $elm$core$List$length(result.withChanges);
		return (!count) ? $elm$html$Html$text('') : $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				loading,
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Locations$Spreadsheet$Model$Approve,
					$author$project$PinMeTo$Ui$Button$buttonPrimary(
						$author$project$Translations$Listings$Spreadsheet$approve(translations) + (' (' + ($elm$core$String$fromInt(count) + ')'))))));
	});
var $author$project$FontAwesome$Light$Icon$faCircleMinus = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-circle-minus');
var $author$project$Translations$Listings$Spreadsheet$reviewCreated = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.review_created');
};
var $author$project$Locations$Spreadsheet$Model$UnchangedTable = {$: 'UnchangedTable'};
var $author$project$Translations$Listings$Spreadsheet$reviewUnchanged = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.review_unchanged');
};
var $author$project$Locations$Spreadsheet$View$Review$stripRowPrefix = function (message) {
	var _v0 = A2($elm$core$String$split, ': ', message);
	if (_v0.b) {
		var prefix = _v0.a;
		var rest = _v0.b;
		return (A2($elm$core$String$startsWith, 'Row ', prefix) && (!$elm$core$List$isEmpty(rest))) ? A2($elm$core$String$join, ': ', rest) : message;
	} else {
		return message;
	}
};
var $author$project$Locations$Spreadsheet$View$Review$joinErrors = function (item) {
	return A2(
		$elm$core$String$join,
		'; ',
		A2($elm$core$List$map, $author$project$Locations$Spreadsheet$View$Review$stripRowPrefix, item.errors));
};
var $author$project$Locations$Spreadsheet$Model$ErrorsTable = {$: 'ErrorsTable'};
var $author$project$Translations$Listings$Spreadsheet$reviewErrors = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.review_errors');
};
var $author$project$FontAwesome$Light$Icon$faCircleXmark = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-circle-xmark');
var $author$project$Locations$Spreadsheet$View$Review$viewErrorCell = function (item) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('spreadsheet-cell--error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Locations$Spreadsheet$View$Review$joinErrors(item))
			]));
};
var $author$project$Locations$Spreadsheet$View$Review$errorCellOptions = _List_fromArray(
	[$author$project$PinMeTo$Ui$Table$Tooltip]);
var $author$project$Translations$Listings$Spreadsheet$reviewErrorColumn = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.review_error_column');
};
var $author$project$Translations$Listings$Spreadsheet$downloadErrors = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.download_errors');
};
var $author$project$FontAwesome$Light$Icon$faFileArrowDown = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-file-arrow-down');
var $author$project$Locations$Spreadsheet$Model$DownloadErrorsCsv = {$: 'DownloadErrorsCsv'};
var $author$project$Locations$Spreadsheet$View$Review$downloadErrorsButton = F2(
	function (translations, errors) {
		return $elm$core$List$isEmpty(errors) ? $elm$html$Html$text('') : $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withOnClick,
				$author$project$Locations$Spreadsheet$Model$DownloadErrorsCsv,
				A2(
					$author$project$PinMeTo$Ui$Button$withIconBefore,
					$author$project$PinMeTo$Ui$Button$FA(
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faFileArrowDown)),
					A2(
						$author$project$PinMeTo$Ui$Button$withOutlinedStyle,
						$author$project$PinMeTo$Ui$Button$OutlinedNeutral,
						$author$project$PinMeTo$Ui$Button$buttonOutlined(
							$author$project$Translations$Listings$Spreadsheet$downloadErrors(translations) + (' (' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ')')))))));
	});
var $author$project$Locations$Spreadsheet$View$Review$viewErrorsSection = F4(
	function (translations, collapsed, state, items) {
		return A7(
			$author$project$Locations$Spreadsheet$View$Review$viewSectionContainer,
			$author$project$Locations$Spreadsheet$Model$ErrorsTable,
			collapsed,
			$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCircleXmark),
			'spreadsheet-icon--error',
			$author$project$Translations$Listings$Spreadsheet$reviewErrors(translations),
			items,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spreadsheet-section__actions')
							]),
						_List_fromArray(
							[
								A2($author$project$Locations$Spreadsheet$View$Review$downloadErrorsButton, translations, items)
							])),
						A2(
						$author$project$PinMeTo$Ui$Table$render,
						state,
						A2(
							$author$project$Locations$Spreadsheet$View$Review$withBaseColumns,
							items,
							A5(
								$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
								$author$project$Translations$Listings$Spreadsheet$reviewErrorColumn(translations),
								$author$project$Locations$Spreadsheet$View$Review$errorCellOptions,
								$author$project$Locations$Spreadsheet$View$Review$viewErrorCell,
								$author$project$PinMeTo$Ui$Table$comparingString($author$project$Locations$Spreadsheet$View$Review$joinErrors),
								A2(
									$author$project$PinMeTo$Ui$Table$view,
									$author$project$Locations$Spreadsheet$Model$TableMsg($author$project$Locations$Spreadsheet$Model$ErrorsTable),
									items))))
					])));
	});
var $author$project$FontAwesome$Light$Icon$faArrowLeft = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-arrow-left');
var $author$project$Locations$Spreadsheet$Model$BackToUpload = {$: 'BackToUpload'};
var $author$project$Translations$Listings$Spreadsheet$returnToImport = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.return_to_import');
};
var $author$project$Locations$Spreadsheet$View$Review$returnToImportButton = function (translations) {
	return $author$project$PinMeTo$Ui$Button$render(
		A2(
			$author$project$PinMeTo$Ui$Button$withOnClick,
			$author$project$Locations$Spreadsheet$Model$BackToUpload,
			A2(
				$author$project$PinMeTo$Ui$Button$withIconBefore,
				$author$project$PinMeTo$Ui$Button$FA(
					$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faArrowLeft)),
				$author$project$PinMeTo$Ui$Button$buttonGhost(
					$author$project$Translations$Listings$Spreadsheet$returnToImport(translations)))));
};
var $author$project$Translations$Listings$Spreadsheet$sentForImport = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.sent_for_import');
};
var $author$project$Locations$Spreadsheet$View$Review$viewConfirmationBanner = F2(
	function (translations, confirmation) {
		switch (confirmation.$) {
			case 'Loaded':
				return $author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Success,
						$author$project$PinMeTo$Ui$Alert$plain(
							$author$project$Translations$Listings$Spreadsheet$sentForImport(translations))));
			case 'Error':
				var message = confirmation.a;
				return $author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Error,
						$author$project$PinMeTo$Ui$Alert$plain(message)));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Locations$Spreadsheet$View$Review$view = F3(
	function (translations, model, result) {
		var _v0 = model.confirmation;
		if (_v0.$ === 'Loaded') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('spreadsheet-review__success')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Locations$Spreadsheet$View$Review$returnToImportButton(translations)
							])),
						A2($author$project$Locations$Spreadsheet$View$Review$viewConfirmationBanner, translations, model.confirmation),
						A4($author$project$Locations$Spreadsheet$View$Review$viewErrorsSection, translations, model.collapsedSections, model.errorsTable, result.withValidationError)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Locations$Spreadsheet$View$Review$viewConfirmationBanner, translations, model.confirmation),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spreadsheet-review__back')
							]),
						_List_fromArray(
							[
								$author$project$Locations$Spreadsheet$View$Review$returnToImportButton(translations)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spreadsheet-review__actions')
							]),
						_List_fromArray(
							[
								A3($author$project$Locations$Spreadsheet$View$Review$approveButton, translations, model, result),
								A2($author$project$Locations$Spreadsheet$View$Review$downloadErrorsButton, translations, result.withValidationError)
							])),
						A7(
						$author$project$Locations$Spreadsheet$View$Review$viewSection,
						model.collapsedSections,
						$author$project$Locations$Spreadsheet$Model$CreatedTable,
						model.createdTable,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCirclePlus),
						'spreadsheet-icon--created',
						$author$project$Translations$Listings$Spreadsheet$reviewCreated(translations),
						result.newObjects),
						A7(
						$author$project$Locations$Spreadsheet$View$Review$viewSection,
						model.collapsedSections,
						$author$project$Locations$Spreadsheet$Model$EditedTable,
						model.editedTable,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faPencil),
						'spreadsheet-icon--edited',
						$author$project$Translations$Listings$Spreadsheet$reviewEdited(translations),
						result.withChanges),
						A7(
						$author$project$Locations$Spreadsheet$View$Review$viewSection,
						model.collapsedSections,
						$author$project$Locations$Spreadsheet$Model$UnchangedTable,
						model.unchangedTable,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCircleMinus),
						'spreadsheet-icon--unchanged',
						$author$project$Translations$Listings$Spreadsheet$reviewUnchanged(translations),
						result.withNoChanges),
						A4($author$project$Locations$Spreadsheet$View$Review$viewErrorsSection, translations, model.collapsedSections, model.errorsTable, result.withValidationError)
					]));
		}
	});
var $author$project$Translations$Listings$Spreadsheet$intro = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.intro');
};
var $author$project$Translations$Listings$Spreadsheet$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.title');
};
var $author$project$Translations$Listings$Spreadsheet$introLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.intro_link');
};
var $author$project$Locations$Spreadsheet$View$LocationsBulk$documentationHelpUrl = 'https://help.pinmeto.com/en/article/listings-mtaskv/#1-section-3-location-information';
var $author$project$Locations$Spreadsheet$View$LocationsBulk$viewIntro = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Spreadsheet$title(translations))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Spreadsheet$intro(translations) + ' '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href($author$project$Locations$Spreadsheet$View$LocationsBulk$documentationHelpUrl),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Spreadsheet$introLink(translations))
							]))
					]))
			]));
};
var $author$project$Translations$Listings$Spreadsheet$stepThreeTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.step_three_title');
};
var $author$project$Locations$Spreadsheet$View$LocationsBulk$verificationHelpUrl = 'https://help.pinmeto.com/en/article/listings-mtaskv/#6-verify-an-added-location';
var $author$project$Translations$Listings$Spreadsheet$verificationNoteLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.verification_note_link');
};
var $author$project$Translations$Listings$Spreadsheet$verificationNoteAfter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.verification_note_after');
};
var $author$project$Translations$Listings$Spreadsheet$verificationNoteBefore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.verification_note_before');
};
var $author$project$Locations$Spreadsheet$View$LocationsBulk$viewReview = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Spreadsheet$stepThreeTitle(translations))
					])),
				$author$project$PinMeTo$Ui$Alert$render(
				$author$project$PinMeTo$Ui$Alert$rich(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$verificationNoteBefore(translations) + ' '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href($author$project$Locations$Spreadsheet$View$LocationsBulk$verificationHelpUrl),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Spreadsheet$verificationNoteLink(translations))
								])),
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$verificationNoteAfter(translations))
						])))
			]));
};
var $author$project$Translations$Listings$Spreadsheet$deleteNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.delete_note');
};
var $author$project$Locations$Spreadsheet$Model$DropZoneMsg = function (a) {
	return {$: 'DropZoneMsg', a: a};
};
var $author$project$Translations$Listings$Spreadsheet$uploadSuffix = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.upload_suffix');
};
var $author$project$Locations$Spreadsheet$View$LocationsBulk$viewDropZone = F2(
	function (translations, dropZone) {
		return A2(
			$elm$html$Html$map,
			$author$project$Locations$Spreadsheet$Model$DropZoneMsg,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('listings-drop-zone'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('listings-drop-zone--hover', dropZone.hover)
							])),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragenter',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragEnter)),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragover',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragEnter)),
						A2(
						$author$project$Listings$Ui$DropZone$hijackOn,
						'dragleave',
						$elm$json$Json$Decode$succeed($author$project$Listings$Ui$DropZone$DragLeave)),
						A2($author$project$Listings$Ui$DropZone$hijackOn, 'drop', $author$project$Listings$Ui$DropZone$dropDecoder)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Spreadsheet$uploadPrefix(translations)),
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$Listings$Ui$DropZone$Pick,
									$author$project$PinMeTo$Ui$Button$buttonSecondary(
										$author$project$Translations$Listings$Spreadsheet$uploadButton(translations)))),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Spreadsheet$uploadSuffix(translations))
							]))
					])));
	});
var $author$project$Locations$Spreadsheet$View$LocationsBulk$viewUploadFile = F3(
	function (translations, dropZone, validation) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$stepTwoTitle(translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('spreadsheet-upload-note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$deleteNote(translations))
						])),
					function () {
					if (validation.$ === 'Loading') {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spreadsheet-loading')
								]),
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]));
					} else {
						return A2($author$project$Locations$Spreadsheet$View$LocationsBulk$viewDropZone, translations, dropZone);
					}
				}()
				]));
	});
var $author$project$Locations$Spreadsheet$Commands$exportUrl = F2(
	function (site, format) {
		return 'listings/api/' + (site + ('/export/locations/' + format));
	});
var $author$project$Locations$Spreadsheet$Commands$templateUrl = F2(
	function (site, format) {
		return 'listings/api/' + (site + ('/import/template/' + format));
	});
var $author$project$Locations$Spreadsheet$View$LocationsBulk$downloadLink = F3(
	function (label, url, filename) {
		return A3(
			$elm$html$Html$node,
			'pmt-download-with-filter-button',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'url', url),
					A2($elm$html$Html$Attributes$attribute, 'label', label),
					A2($elm$html$Html$Attributes$attribute, 'filename', filename)
				]),
			_List_Nil);
	});
var $author$project$Translations$Listings$Spreadsheet$downloadLocationsCsv = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.download_locations_csv');
};
var $author$project$Translations$Listings$Spreadsheet$downloadLocationsXlsx = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.download_locations_xlsx');
};
var $author$project$Translations$Listings$Spreadsheet$existingLocationsLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.existing_locations_label');
};
var $author$project$Translations$Listings$Spreadsheet$blankTemplateDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.blank_template_description');
};
var $author$project$Translations$Listings$Spreadsheet$existingLocationsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.spreadsheet.existing_locations_description');
};
var $author$project$Locations$Spreadsheet$View$LocationsBulk$viewDownloadTemplate = F2(
	function (site, translations) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Spreadsheet$stepOneTitle(translations))
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Spreadsheet$blankTemplateLabel(translations))
										])),
									$elm$html$Html$text(
									$author$project$Translations$Listings$Spreadsheet$blankTemplateDescription(translations)),
									A3(
									$author$project$Locations$Spreadsheet$View$LocationsBulk$downloadLink,
									$author$project$Translations$Listings$Import$downloadTemplateCsv(translations),
									A2($author$project$Locations$Spreadsheet$Commands$templateUrl, site, 'csv'),
									'import-template.csv'),
									A3(
									$author$project$Locations$Spreadsheet$View$LocationsBulk$downloadLink,
									$author$project$Translations$Listings$Import$downloadTemplateXlsx(translations),
									A2($author$project$Locations$Spreadsheet$Commands$templateUrl, site, 'xlsx'),
									'import-template.xlsx')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Spreadsheet$existingLocationsLabel(translations))
										])),
									$elm$html$Html$text(
									$author$project$Translations$Listings$Spreadsheet$existingLocationsDescription(translations)),
									A3(
									$author$project$Locations$Spreadsheet$View$LocationsBulk$downloadLink,
									$author$project$Translations$Listings$Spreadsheet$downloadLocationsCsv(translations),
									A2($author$project$Locations$Spreadsheet$Commands$exportUrl, site, 'csv'),
									'locations.csv'),
									A3(
									$author$project$Locations$Spreadsheet$View$LocationsBulk$downloadLink,
									$author$project$Translations$Listings$Spreadsheet$downloadLocationsXlsx(translations),
									A2($author$project$Locations$Spreadsheet$Commands$exportUrl, site, 'xlsx'),
									'locations.xlsx')
								]))
						]))
				]));
	});
var $author$project$Locations$Spreadsheet$View$LocationsBulk$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section section--solid')
				]),
			_List_fromArray(
				[
					$author$project$Locations$Spreadsheet$View$LocationsBulk$viewIntro(session.translations),
					A2(
					$author$project$Locations$Spreadsheet$View$LocationsBulk$viewDownloadTemplate,
					$author$project$Data$SiteName$toString(session.siteName),
					session.translations),
					A3($author$project$Locations$Spreadsheet$View$LocationsBulk$viewUploadFile, session.translations, model.dropZone, model.validation),
					$author$project$Locations$Spreadsheet$View$LocationsBulk$viewReview(session.translations)
				]));
	});
var $author$project$Locations$Spreadsheet$View$viewValidationStatus = F2(
	function (_v0, validation) {
		switch (validation.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Loading':
				return $elm$html$Html$text('');
			case 'Loaded':
				return $elm$html$Html$text('');
			default:
				var message = validation.a;
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Error: ' + message)
						]));
		}
	});
var $author$project$Locations$Spreadsheet$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spreadsheet-import')
				]),
			function () {
				var _v0 = model.validation;
				if (_v0.$ === 'Loaded') {
					var result = _v0.a;
					return _List_fromArray(
						[
							A3($author$project$Locations$Spreadsheet$View$Review$view, session.translations, model, result)
						]);
				} else {
					return _List_fromArray(
						[
							A2($author$project$Locations$Spreadsheet$View$LocationsBulk$view, session, model),
							A2($author$project$Locations$Spreadsheet$View$viewValidationStatus, session.translations, model.validation)
						]);
				}
			}());
	});
var $author$project$Locations$Spreadsheet$Commands$confirmBody = function (result) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'newObjects',
				A2(
					$elm$json$Json$Encode$list,
					function ($) {
						return $.raw;
					},
					result.newObjects)),
				_Utils_Tuple2(
				'withChanges',
				A2(
					$elm$json$Json$Encode$list,
					function ($) {
						return $.raw;
					},
					result.withChanges)),
				_Utils_Tuple2(
				'withNoChanges',
				A2(
					$elm$json$Json$Encode$list,
					function ($) {
						return $.raw;
					},
					result.withNoChanges))
			]));
};
var $author$project$Locations$Spreadsheet$Model$ConfirmFailure = function (a) {
	return {$: 'ConfirmFailure', a: a};
};
var $author$project$Locations$Spreadsheet$Model$ConfirmSuccess = {$: 'ConfirmSuccess'};
var $author$project$Locations$Spreadsheet$Commands$confirmResponseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (ok) {
		return ok ? $elm$json$Json$Decode$succeed($author$project$Locations$Spreadsheet$Model$ConfirmSuccess) : A2(
			$elm$json$Json$Decode$map,
			$author$project$Locations$Spreadsheet$Model$ConfirmFailure,
			A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
	},
	A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool));
var $author$project$Locations$Spreadsheet$Commands$confirm = F3(
	function (site, result, toMsg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, toMsg, $author$project$Locations$Spreadsheet$Commands$confirmResponseDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$jsonBody(
						$author$project$Locations$Spreadsheet$Commands$confirmBody(result)),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (site + '/import/confirm')))));
	});
var $author$project$Locations$Spreadsheet$Model$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Locations$Spreadsheet$Model$Failure = function (a) {
	return {$: 'Failure', a: a};
};
var $author$project$Locations$Spreadsheet$Model$Success = function (a) {
	return {$: 'Success', a: a};
};
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Locations$Spreadsheet$Model$Item = F5(
	function (fields, changes, errors, raw, originalFieldsRows) {
		return {raw: raw, errors: errors, fields: fields, changes: changes, originalFieldsRows: originalFieldsRows};
	});
var $author$project$Locations$Spreadsheet$Model$Change = F3(
	function (field, from, to) {
		return {to: to, from: from, field: field};
	});
var $author$project$Locations$Spreadsheet$Commands$pathElement = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)
		]));
var $author$project$Locations$Spreadsheet$Commands$pathDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$String$join(' - '),
	$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$pathElement));
var $author$project$Locations$Spreadsheet$Commands$boolToString = function (value) {
	return value ? 'true' : 'false';
};
var $author$project$Locations$Spreadsheet$Commands$valueToString = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $author$project$Locations$Spreadsheet$Commands$boolToString, $elm$json$Json$Decode$bool),
			$elm$json$Json$Decode$null(''),
			A2(
			$elm$json$Json$Decode$map,
			$elm$json$Json$Encode$encode(0),
			$elm$json$Json$Decode$value)
		]));
var $author$project$Locations$Spreadsheet$Commands$changeDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Locations$Spreadsheet$Model$Change,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'path', $author$project$Locations$Spreadsheet$Commands$pathDecoder),
				$elm$json$Json$Decode$succeed('')
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'lhs', $author$project$Locations$Spreadsheet$Commands$valueToString),
				$elm$json$Json$Decode$succeed('')
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'rhs', $author$project$Locations$Spreadsheet$Commands$valueToString),
				$elm$json$Json$Decode$succeed('')
			])));
var $author$project$Locations$Spreadsheet$Commands$errorsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$valueToString),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map($elm$core$Tuple$second),
			$elm$json$Json$Decode$keyValuePairs($author$project$Locations$Spreadsheet$Commands$valueToString))
		]));
var $author$project$Locations$Spreadsheet$Commands$joinKey = F2(
	function (key, subKey) {
		return (subKey === '') ? key : (key + (' - ' + subKey));
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Locations$Spreadsheet$Commands$singleValueDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $author$project$Locations$Spreadsheet$Commands$boolToString, $elm$json$Json$Decode$bool)
		]));
function $author$project$Locations$Spreadsheet$Commands$cyclic$flattenFieldsDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				function (pairs) {
					return $elm$core$Dict$fromList(
						A2(
							$elm$core$List$concatMap,
							function (_v1) {
								var key = _v1.a;
								var subFields = _v1.b;
								return A2(
									$elm$core$List$map,
									function (_v2) {
										var subKey = _v2.a;
										var value = _v2.b;
										return _Utils_Tuple2(
											A2($author$project$Locations$Spreadsheet$Commands$joinKey, key, subKey),
											value);
									},
									$elm$core$Dict$toList(subFields));
							},
							pairs));
				},
				$elm$json$Json$Decode$keyValuePairs(
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $author$project$Locations$Spreadsheet$Commands$cyclic$flattenFieldsDecoder();
						}))),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$singleton(''),
				$author$project$Locations$Spreadsheet$Commands$singleValueDecoder),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			]));
}
try {
	var $author$project$Locations$Spreadsheet$Commands$flattenFieldsDecoder = $author$project$Locations$Spreadsheet$Commands$cyclic$flattenFieldsDecoder();
	$author$project$Locations$Spreadsheet$Commands$cyclic$flattenFieldsDecoder = function () {
		return $author$project$Locations$Spreadsheet$Commands$flattenFieldsDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `Locations.Spreadsheet.Commands` are causing infinite recursion:\n\n  ┌─────┐\n  │    flattenFieldsDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $author$project$Locations$Spreadsheet$Commands$stringOrNumber = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float)
		]));
var $author$project$Locations$Spreadsheet$Commands$spanDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (open, close) {
			return open + ('-' + close);
		}),
	A2($elm$json$Json$Decode$field, 'open', $author$project$Locations$Spreadsheet$Commands$stringOrNumber),
	A2($elm$json$Json$Decode$field, 'close', $author$project$Locations$Spreadsheet$Commands$stringOrNumber));
var $author$project$Locations$Spreadsheet$Commands$dayHoursEntry = function (day) {
	return A2(
		$elm$json$Json$Decode$map,
		function (maybeSpans) {
			return _Utils_Tuple2(
				'openHours - ' + day,
				A2(
					$elm$core$String$join,
					';',
					A2($elm$core$Maybe$withDefault, _List_Nil, maybeSpans)));
		},
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['openHours', day, 'span']),
				$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$spanDecoder))));
};
var $author$project$Locations$Spreadsheet$Commands$hoursDecoder = A3(
	$elm$core$List$foldr,
	F2(
		function (day, acc) {
			return A3(
				$elm$json$Json$Decode$map2,
				$elm$core$List$cons,
				$author$project$Locations$Spreadsheet$Commands$dayHoursEntry(day),
				acc);
		}),
	$elm$json$Json$Decode$succeed(_List_Nil),
	_List_fromArray(
		['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']));
var $author$project$Locations$Spreadsheet$Commands$serviceAreaName = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(''),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'area', $elm$json$Json$Decode$string)));
var $author$project$Locations$Spreadsheet$Commands$serviceAreasDecoder = A2(
	$elm$json$Json$Decode$map,
	function (maybeAreas) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'serviceAreas',
				A2(
					$elm$core$String$join,
					'; ',
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
						A2($elm$core$Maybe$withDefault, _List_Nil, maybeAreas))))
			]);
	},
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'serviceAreas',
			$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$serviceAreaName))));
var $author$project$Locations$Spreadsheet$Commands$structuredFieldsDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (hours, areas) {
			return $elm$core$Dict$fromList(
				_Utils_ap(hours, areas));
		}),
	$author$project$Locations$Spreadsheet$Commands$hoursDecoder,
	$author$project$Locations$Spreadsheet$Commands$serviceAreasDecoder);
var $author$project$Locations$Spreadsheet$Commands$fieldsDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Dict$union, $author$project$Locations$Spreadsheet$Commands$structuredFieldsDecoder, $author$project$Locations$Spreadsheet$Commands$flattenFieldsDecoder);
var $author$project$Locations$Spreadsheet$Commands$itemDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Locations$Spreadsheet$Model$Item,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'importPlace', $author$project$Locations$Spreadsheet$Commands$fieldsDecoder),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'diff',
				$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$changeDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'errors', $author$project$Locations$Spreadsheet$Commands$errorsDecoder),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])),
	$elm$json$Json$Decode$value,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'originalPlaces',
				$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$flattenFieldsDecoder)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			])));
var $author$project$Locations$Spreadsheet$Model$ValidationResult = F4(
	function (newObjects, withChanges, withNoChanges, withValidationError) {
		return {newObjects: newObjects, withChanges: withChanges, withNoChanges: withNoChanges, withValidationError: withValidationError};
	});
var $author$project$Locations$Spreadsheet$Commands$validationResultDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Locations$Spreadsheet$Model$ValidationResult,
	A2(
		$elm$json$Json$Decode$field,
		'newObjects',
		$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$itemDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'withChanges',
		$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$itemDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'withNoChanges',
		$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$itemDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'withValidationError',
		$elm$json$Json$Decode$list($author$project$Locations$Spreadsheet$Commands$itemDecoder)));
var $author$project$Locations$Spreadsheet$Commands$validateResponseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (ok) {
		return ok ? A2(
			$elm$json$Json$Decode$map,
			$author$project$Locations$Spreadsheet$Model$Success,
			A2($elm$json$Json$Decode$field, 'data', $author$project$Locations$Spreadsheet$Commands$validationResultDecoder)) : A2(
			$elm$json$Json$Decode$map,
			$author$project$Locations$Spreadsheet$Model$Failure,
			A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
	},
	A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool));
var $author$project$Locations$Spreadsheet$Commands$validate = F3(
	function (site, file, toMsg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, toMsg, $author$project$Locations$Spreadsheet$Commands$validateResponseDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$multipartBody(
						_List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (site + '/import/validate-new')))));
	});
var $elm$core$String$any = _String_any;
var $author$project$Locations$Spreadsheet$Csv$isSpecial = function (c) {
	return _Utils_eq(
		c,
		_Utils_chr(';')) || (_Utils_eq(
		c,
		_Utils_chr('"')) || (_Utils_eq(
		c,
		_Utils_chr('\n')) || _Utils_eq(
		c,
		_Utils_chr('\r'))));
};
var $elm$core$String$trimLeft = _String_trimLeft;
var $author$project$Locations$Spreadsheet$Csv$startsWithAny = F2(
	function (chars, value) {
		var _v0 = $elm$core$String$uncons(value);
		if (_v0.$ === 'Just') {
			var _v1 = _v0.a;
			var first = _v1.a;
			return A2($elm$core$List$member, first, chars);
		} else {
			return false;
		}
	});
var $author$project$Locations$Spreadsheet$Csv$isNumberBodyChar = function (c) {
	return $elm$core$Char$isDigit(c) || A2(
		$elm$core$List$member,
		c,
		_List_fromArray(
			[
				_Utils_chr(' '),
				_Utils_chr('\t'),
				_Utils_chr('\n'),
				_Utils_chr('\r'),
				_Utils_chr('('),
				_Utils_chr(')'),
				_Utils_chr('.'),
				_Utils_chr('-')
			]));
};
var $author$project$Locations$Spreadsheet$Csv$isSignedNumber = function (value) {
	var body = function () {
		var _v2 = $elm$core$String$uncons(value);
		if (_v2.$ === 'Just') {
			var _v3 = _v2.a;
			var first = _v3.a;
			var rest = _v3.b;
			return (_Utils_eq(
				first,
				_Utils_chr('+')) || _Utils_eq(
				first,
				_Utils_chr('-'))) ? rest : value;
		} else {
			return value;
		}
	}();
	var _v0 = $elm$core$String$uncons(body);
	if (_v0.$ === 'Just') {
		var _v1 = _v0.a;
		var first = _v1.a;
		var rest = _v1.b;
		return $elm$core$Char$isDigit(first) && A2($elm$core$String$all, $author$project$Locations$Spreadsheet$Csv$isNumberBodyChar, rest);
	} else {
		return false;
	}
};
var $author$project$Locations$Spreadsheet$Csv$isFormulaRisky = function (value) {
	var trimmed = $elm$core$String$trimLeft(value);
	return A2(
		$author$project$Locations$Spreadsheet$Csv$startsWithAny,
		_List_fromArray(
			[
				_Utils_chr('\t'),
				_Utils_chr('\r')
			]),
		value) || ((!$author$project$Locations$Spreadsheet$Csv$isSignedNumber(trimmed)) && A2(
		$author$project$Locations$Spreadsheet$Csv$startsWithAny,
		_List_fromArray(
			[
				_Utils_chr('='),
				_Utils_chr('@'),
				_Utils_chr('+'),
				_Utils_chr('-')
			]),
		trimmed));
};
var $author$project$Locations$Spreadsheet$Csv$escape = function (value) {
	var guarded = $author$project$Locations$Spreadsheet$Csv$isFormulaRisky(value) ? ('\u0027' + value) : value;
	return A2($elm$core$String$any, $author$project$Locations$Spreadsheet$Csv$isSpecial, guarded) ? ('\u0022' + (A3($elm$core$String$replace, '\u0022', '\u0022\u0022', guarded) + '\u0022')) : guarded;
};
var $author$project$Locations$Spreadsheet$Csv$toLine = function (cells) {
	return A2(
		$elm$core$String$join,
		';',
		A2($elm$core$List$map, $author$project$Locations$Spreadsheet$Csv$escape, cells));
};
var $author$project$Locations$Spreadsheet$Csv$encode = F2(
	function (headers, rows) {
		return A2(
			$elm$core$String$join,
			'\u000A',
			A2(
				$elm$core$List$map,
				$author$project$Locations$Spreadsheet$Csv$toLine,
				A2($elm$core$List$cons, headers, rows)));
	});
var $author$project$Locations$Spreadsheet$View$Review$originalFieldValue = F2(
	function (key, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, key, fields));
	});
var $author$project$Locations$Spreadsheet$View$Review$errorsCsv = function (items) {
	var dataColumns = _Utils_ap(
		$author$project$Locations$Spreadsheet$View$Review$columns,
		$author$project$Locations$Spreadsheet$View$Review$customDataColumns(items));
	var headerRow = A2(
		$elm$core$List$cons,
		'Error',
		A2($elm$core$List$map, $elm$core$Tuple$first, dataColumns));
	var rowFor = F2(
		function (item, fields) {
			return A2(
				$elm$core$List$cons,
				$author$project$Locations$Spreadsheet$View$Review$joinErrors(item),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.b;
						return A2($author$project$Locations$Spreadsheet$View$Review$originalFieldValue, key, fields);
					},
					dataColumns));
		});
	var itemRows = function (item) {
		var _v0 = item.originalFieldsRows;
		if (!_v0.b) {
			return _List_fromArray(
				[
					A2(rowFor, item, $elm$core$Dict$empty)
				]);
		} else {
			var rows = _v0;
			return A2(
				$elm$core$List$map,
				rowFor(item),
				rows);
		}
	};
	return A2(
		$author$project$Locations$Spreadsheet$Csv$encode,
		headerRow,
		A2($elm$core$List$concatMap, itemRows, items));
};
var $author$project$Locations$Spreadsheet$Model$GotConfirm = function (a) {
	return {$: 'GotConfirm', a: a};
};
var $author$project$Locations$Spreadsheet$Main$errorItems = function (model) {
	var _v0 = model.validation;
	if (_v0.$ === 'Loaded') {
		var result = _v0.a;
		return result.withValidationError;
	} else {
		return _List_Nil;
	}
};
var $author$project$Locations$Spreadsheet$Commands$downloadCsv = F2(
	function (fileName, content) {
		return A3($elm$file$File$Download$string, fileName, 'text/csv;charset=utf-8', content);
	});
var $author$project$Locations$Spreadsheet$Main$updateTable = F3(
	function (tableId, transform, model) {
		switch (tableId.$) {
			case 'CreatedTable':
				return _Utils_update(
					model,
					{
						createdTable: transform(model.createdTable)
					});
			case 'EditedTable':
				return _Utils_update(
					model,
					{
						editedTable: transform(model.editedTable)
					});
			case 'UnchangedTable':
				return _Utils_update(
					model,
					{
						unchangedTable: transform(model.unchangedTable)
					});
			default:
				return _Utils_update(
					model,
					{
						errorsTable: transform(model.errorsTable)
					});
		}
	});
var $author$project$Locations$Spreadsheet$Main$toggleMember = F2(
	function (key, set) {
		return A2($elm$core$Set$member, key, set) ? A2($elm$core$Set$remove, key, set) : A2($elm$core$Set$insert, key, set);
	});
var $author$project$Locations$Spreadsheet$Model$GotValidation = function (a) {
	return {$: 'GotValidation', a: a};
};
var $author$project$Locations$Spreadsheet$Main$acceptedMimes = _List_fromArray(
	['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']);
var $author$project$Locations$Spreadsheet$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'DropZoneMsg':
				var dropZoneMsg = msg.a;
				var _v1 = A3(
					$author$project$Listings$Ui$DropZone$update,
					{mimes: $author$project$Locations$Spreadsheet$Main$acceptedMimes, tagger: $author$project$Locations$Spreadsheet$Model$DropZoneMsg, onGotFiles: $author$project$Locations$Spreadsheet$Model$GotFiles},
					dropZoneMsg,
					model.dropZone);
				var newDropZone = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dropZone: newDropZone}),
					cmd);
			case 'GotFiles':
				var file = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{validation: $author$project$RemoteData$Loading}),
					A3(
						$author$project$Locations$Spreadsheet$Commands$validate,
						$author$project$Data$SiteName$toString(session.siteName),
						file,
						$author$project$Locations$Spreadsheet$Model$GotValidation));
			case 'GotValidation':
				if (msg.a.$ === 'Ok') {
					if (msg.a.a.$ === 'Success') {
						var result = msg.a.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									validation: $author$project$RemoteData$Loaded(result)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var message = msg.a.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									validation: $author$project$RemoteData$Error(message)
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								validation: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'TableMsg':
				var tableId = msg.a;
				var subMsg = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Locations$Spreadsheet$Main$updateTable,
						tableId,
						$author$project$PinMeTo$Ui$Table$update(subMsg),
						model),
					$elm$core$Platform$Cmd$none);
			case 'ToggleSection':
				var tableId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							collapsedSections: A2(
								$author$project$Locations$Spreadsheet$Main$toggleMember,
								$author$project$Locations$Spreadsheet$Model$tableIdKey(tableId),
								model.collapsedSections)
						}),
					$elm$core$Platform$Cmd$none);
			case 'DownloadErrorsCsv':
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Locations$Spreadsheet$Commands$downloadCsv,
						'error-locations.csv',
						$author$project$Locations$Spreadsheet$View$Review$errorsCsv(
							$author$project$Locations$Spreadsheet$Main$errorItems(model))));
			case 'BackToUpload':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{validation: $author$project$RemoteData$Suspended, confirmation: $author$project$RemoteData$Suspended}),
					$elm$core$Platform$Cmd$none);
			case 'Approve':
				var _v2 = model.validation;
				if (_v2.$ === 'Loaded') {
					var result = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{confirmation: $author$project$RemoteData$Loading}),
						A3(
							$author$project$Locations$Spreadsheet$Commands$confirm,
							$author$project$Data$SiteName$toString(session.siteName),
							result,
							$author$project$Locations$Spreadsheet$Model$GotConfirm));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.a.$ === 'Ok') {
					if (msg.a.a.$ === 'ConfirmSuccess') {
						var _v3 = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									confirmation: $author$project$RemoteData$Loaded(_Utils_Tuple0)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var message = msg.a.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									confirmation: $author$project$RemoteData$Error(message)
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								confirmation: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$PinMeTo$Ui$Table$OnKeyUp = function (a) {
	return {$: 'OnKeyUp', a: a};
};
var $author$project$PinMeTo$Ui$Table$OnKeyDown = function (a) {
	return {$: 'OnKeyDown', a: a};
};
var $author$project$PinMeTo$Ui$Table$Other = function (a) {
	return {$: 'Other', a: a};
};
var $author$project$PinMeTo$Ui$Table$Shift = {$: 'Shift'};
var $author$project$PinMeTo$Ui$Table$toKey = function (string) {
	var _v0 = $elm$core$String$uncons(string);
	if ((_v0.$ === 'Just') && (_v0.a.b === '')) {
		var _v1 = _v0.a;
		var _char = _v1.a;
		return $author$project$PinMeTo$Ui$Table$Other(
			$elm$core$String$fromChar(_char));
	} else {
		return (string === 'Shift') ? $author$project$PinMeTo$Ui$Table$Shift : $author$project$PinMeTo$Ui$Table$Other(string);
	}
};
var $author$project$PinMeTo$Ui$Table$keyDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$PinMeTo$Ui$Table$toKey,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $author$project$PinMeTo$Ui$Table$subscriptions = F2(
	function (tagger, _v0) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$elm$browser$Browser$Events$onKeyDown(
					A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Table$OnKeyDown, tagger),
						$author$project$PinMeTo$Ui$Table$keyDecoder)),
					$elm$browser$Browser$Events$onKeyUp(
					A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Table$OnKeyUp, tagger),
						$author$project$PinMeTo$Ui$Table$keyDecoder))
				]));
	});
var $author$project$Locations$Spreadsheet$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Ui$Table$subscriptions,
				$author$project$Locations$Spreadsheet$Model$TableMsg($author$project$Locations$Spreadsheet$Model$CreatedTable),
				model.createdTable),
				A2(
				$author$project$PinMeTo$Ui$Table$subscriptions,
				$author$project$Locations$Spreadsheet$Model$TableMsg($author$project$Locations$Spreadsheet$Model$EditedTable),
				model.editedTable),
				A2(
				$author$project$PinMeTo$Ui$Table$subscriptions,
				$author$project$Locations$Spreadsheet$Model$TableMsg($author$project$Locations$Spreadsheet$Model$UnchangedTable),
				model.unchangedTable),
				A2(
				$author$project$PinMeTo$Ui$Table$subscriptions,
				$author$project$Locations$Spreadsheet$Model$TableMsg($author$project$Locations$Spreadsheet$Model$ErrorsTable),
				model.errorsTable)
			]));
};
var $author$project$Locations$Spreadsheet$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Locations$Spreadsheet$Main$init,
		view: $author$project$Locations$Spreadsheet$View$view,
		update: $author$project$Locations$Spreadsheet$Main$update,
		flagsDecoder: $elm$json$Json$Decode$succeed(_Utils_Tuple0),
		subscriptions: $author$project$Locations$Spreadsheet$Main$subscriptions
	});
var $author$project$PinMeTo$Api$FilterApi$MediaReview = {$: 'MediaReview'};
var $author$project$Command$SiteProfileImage$Src = function (a) {
	return {$: 'Src', a: a};
};
var $author$project$Locations$MediaReview$Model$Descending = {$: 'Descending'};
var $author$project$Locations$MediaReview$Model$defaultPagination = {page: 0, pageSize: 24, sortOrder: $author$project$Locations$MediaReview$Model$Descending};
var $author$project$Locations$MediaReview$Model$initialModel = {
	count: $author$project$RemoteData$Loading,
	media: $author$project$RemoteData$Loading,
	toasts: _List_Nil,
	addMedia: $elm$core$Maybe$Nothing,
	locationId: $elm$core$Maybe$Nothing,
	pagination: $author$project$Locations$MediaReview$Model$defaultPagination,
	currentFilter: $elm$core$Maybe$Nothing,
	deletingMedia: false,
	mediaToDelete: $elm$core$Maybe$Nothing,
	locationEnabled: $elm$core$Maybe$Just(false),
	filterController: $elm$core$Maybe$Nothing,
	detailedMediaToShow: $elm$core$Maybe$Nothing,
	siteProfileImageUrl: $author$project$Command$SiteProfileImage$Src('')
};
var $author$project$Locations$MediaReview$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Locations$MediaReview$Model$MediaAssetResponse = F2(
	function (count, assets) {
		return {count: count, assets: assets};
	});
var $author$project$Locations$MediaReview$Model$DEFAULT = {$: 'DEFAULT'};
var $author$project$Locations$MediaReview$Model$emptyDimensions = {width: 0, height: 0};
var $author$project$Locations$MediaReview$Model$NetworkMediaAsset = F9(
	function (id, assetType, url, previewUrl, publishedAt, createdAt, status, uploadedBy, dimensions) {
		return {id: id, url: url, status: status, assetType: assetType, createdAt: createdAt, dimensions: dimensions, previewUrl: previewUrl, uploadedBy: uploadedBy, publishedAt: publishedAt};
	});
var $author$project$Locations$MediaReview$Model$Dimensions = F2(
	function (height, width) {
		return {width: width, height: height};
	});
var $author$project$Locations$MediaReview$Model$dimensionsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'width',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'height',
		$elm$json$Json$Decode$int,
		0,
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$Dimensions)));
var $author$project$Data$Network$Media$OWNER = {$: 'OWNER'};
var $author$project$Data$Network$Media$CUSTOMER = function (a) {
	return {$: 'CUSTOMER', a: a};
};
var $author$project$Data$Network$Media$Attribution = F2(
	function (profileName, takedownUrl) {
		return {profileName: profileName, takedownUrl: takedownUrl};
	});
var $author$project$Locations$MediaReview$Model$attributionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'takedownUrl',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'profileName',
		$elm$json$Json$Decode$string,
		'Anonymous',
		$elm$json$Json$Decode$succeed($author$project$Data$Network$Media$Attribution)));
var $author$project$Locations$MediaReview$Model$uploadedByTypeDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		decoder,
		A2(
			$elm$json$Json$Decode$andThen,
			function (uploadedBy) {
				switch (uploadedBy) {
					case 'OWNER':
						return $elm$json$Json$Decode$succeed($author$project$Data$Network$Media$OWNER);
					case 'CUSTOMER':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Data$Network$Media$CUSTOMER,
							A2($elm$json$Json$Decode$field, 'attribution', $author$project$Locations$MediaReview$Model$attributionDecoder));
					default:
						return $elm$json$Json$Decode$fail('Could not decode UploadedBy from string \u0027' + (uploadedBy + '\u0027'));
				}
			},
			A2($elm$json$Json$Decode$field, 'uploadedByType', $elm$json$Json$Decode$string)));
};
var $author$project$Locations$MediaReview$Model$PHOTO = {$: 'PHOTO'};
var $author$project$Locations$MediaReview$Model$VIDEO = {$: 'VIDEO'};
var $author$project$Locations$MediaReview$Model$networkMediaAssetTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		switch (val) {
			case 'PHOTO':
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$PHOTO);
			case 'VIDEO':
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$VIDEO);
			default:
				return $elm$json$Json$Decode$fail('Could not decode NetworkMediaAssetType from string \u0027' + (val + '\u0027'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Locations$MediaReview$Model$FLAGGED = {$: 'FLAGGED'};
var $author$project$Locations$MediaReview$Model$REMOVED = {$: 'REMOVED'};
var $author$project$Locations$MediaReview$Model$networkMediaAssetStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		switch (val) {
			case 'FLAGGED':
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$FLAGGED);
			case 'REMOVED':
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$REMOVED);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$DEFAULT);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Locations$MediaReview$Model$networkMediaAssetDecoder = $author$project$Locations$MediaReview$Model$uploadedByTypeDecoder(
	function (uploadedByType) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'dimensions',
			$author$project$Locations$MediaReview$Model$dimensionsDecoder,
			$author$project$Locations$MediaReview$Model$emptyDimensions,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				uploadedByType,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'status',
					$author$project$Locations$MediaReview$Model$networkMediaAssetStatusDecoder,
					$author$project$Locations$MediaReview$Model$DEFAULT,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'publishedAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'previewUrl',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'url',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'assetType',
										$author$project$Locations$MediaReview$Model$networkMediaAssetTypeDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$NetworkMediaAsset))))))))));
	});
var $author$project$Locations$MediaReview$Commands$mediaAssetResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'media',
	$elm$json$Json$Decode$list($author$project$Locations$MediaReview$Model$networkMediaAssetDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$MediaAssetResponse)));
var $author$project$Locations$MediaReview$Model$sortOrderToString = function (sortOrder) {
	if (sortOrder.$ === 'Ascending') {
		return 'asc';
	} else {
		return 'desc';
	}
};
var $author$project$Locations$MediaReview$Commands$paginationEncoder = function (pagination) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'currentPage',
				$elm$json$Json$Encode$int(pagination.page)),
				_Utils_Tuple2(
				'pageSize',
				$elm$json$Json$Encode$int(pagination.pageSize)),
				_Utils_Tuple2(
				'sortOrder',
				$elm$json$Json$Encode$string(
					$author$project$Locations$MediaReview$Model$sortOrderToString(pagination.sortOrder)))
			]));
};
var $author$project$Locations$MediaReview$Commands$networkMediaAssetsBodyEncoder = function (body) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pagination',
				$author$project$Locations$MediaReview$Commands$paginationEncoder(body.pagination)),
				_Utils_Tuple2(
				'filter',
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$json$Json$Encode$null,
					function (f) {
						return f;
					},
					body.filter))
			]));
};
var $author$project$Locations$MediaReview$Commands$getNetworkMediaAssets = F5(
	function (filter, pagination, _v0, locationId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaReview$Commands$mediaAssetResponseDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Locations$MediaReview$Commands$networkMediaAssetsBodyEncoder(
						{filter: filter, pagination: pagination}),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								'api/' + (siteName + '/network-media-assets'),
								function (locationId_) {
									return 'api/' + (siteName + ('/' + (locationId_ + '/network-media-assets')));
								},
								locationId))))));
	});
var $author$project$Locations$MediaReview$Model$NetworkMediaAssetResponse = function (a) {
	return {$: 'NetworkMediaAssetResponse', a: a};
};
var $author$project$Locations$MediaReview$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			flags.query,
			$author$project$PinMeTo$Api$FilterApi$MediaReview,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var cmd = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2($elm$core$Platform$Cmd$map, $author$project$Locations$MediaReview$Model$FilterControllerMsg, filterControllerCmd_),
			function (locationId) {
				return A5(
					$author$project$Locations$MediaReview$Commands$getNetworkMediaAssets,
					$elm$core$Maybe$Nothing,
					$author$project$Locations$MediaReview$Model$defaultPagination,
					session.siteName,
					$elm$core$Maybe$Just(locationId),
					$author$project$Locations$MediaReview$Model$NetworkMediaAssetResponse);
			},
			flags.locationId);
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Locations$MediaReview$Model$initialModel,
				{
					media: $author$project$RemoteData$Loading,
					locationId: flags.locationId,
					locationEnabled: flags.locationEnabled,
					filterController: $elm$core$Maybe$Just(filterControllerModel_)
				}),
			cmd);
	});
var $author$project$Listings$Ui$DropZone$view = F2(
	function (config, model) {
		return A3($author$project$Listings$Ui$DropZone$viewWithNotes, config, _List_Nil, model);
	});
var $author$project$Locations$MediaReview$AddMedia$Close = {$: 'Close'};
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Translations$Listings$AddImage$browse = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_image.browse');
};
var $author$project$Translations$Listings$AddImage$cancel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_image.cancel');
};
var $elm$html$Html$Attributes$poster = $elm$html$Html$Attributes$stringProperty('poster');
var $author$project$Translations$Listings$AddImage$publish = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.add_image.publish',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $author$project$Translations$Listings$MediaReview$dropZone = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.drop_zone');
};
var $author$project$Locations$MediaReview$AddMedia$DropZoneMsg = function (a) {
	return {$: 'DropZoneMsg', a: a};
};
var $author$project$Locations$MediaReview$AddMedia$RemoveAsset = function (a) {
	return {$: 'RemoveAsset', a: a};
};
var $author$project$Translations$Listings$MediaReview$uploadMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.upload_media');
};
var $author$project$Locations$MediaReview$AddMedia$ClickPublish = {$: 'ClickPublish'};
var $author$project$Locations$MediaReview$AddAssets$uploadedAssets = function (assets) {
	return A2(
		$elm$core$List$filterMap,
		function (asset) {
			if (asset.$ === 'Uploaded') {
				var remote = asset.a;
				return $elm$core$Maybe$Just(remote);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		assets);
};
var $author$project$Locations$MediaReview$AddAssets$countUploaded = function (assets) {
	return $elm$core$List$length(
		$author$project$Locations$MediaReview$AddAssets$uploadedAssets(assets));
};
var $author$project$Locations$MediaReview$AddMedia$formatDuration = function (seconds) {
	var totalSeconds = A2(
		$elm$core$Basics$max,
		0,
		$elm$core$Basics$round(seconds));
	var remainingSeconds = A2($elm$core$Basics$modBy, 60, totalSeconds);
	var minutes = (totalSeconds / 60) | 0;
	var pad = function (n) {
		return (n < 10) ? ('0' + $elm$core$String$fromInt(n)) : $elm$core$String$fromInt(n);
	};
	return pad(minutes) + (':' + pad(remainingSeconds));
};
var $author$project$Locations$MediaReview$AddMedia$mediaMetaLabel = function (mediaAsset) {
	var durationPart = function () {
		var _v1 = _Utils_Tuple2(mediaAsset.kind, mediaAsset.metaData.duration);
		if ((_v1.a.$ === 'VideoKind') && (_v1.b.$ === 'Just')) {
			var _v2 = _v1.a;
			var d = _v1.b.a;
			return $author$project$Locations$MediaReview$AddMedia$formatDuration(d);
		} else {
			return '';
		}
	}();
	var resolution = $elm$core$String$fromInt(mediaAsset.metaData.width) + (' x ' + $elm$core$String$fromInt(mediaAsset.metaData.height));
	var _v0 = mediaAsset.kind;
	if (_v0.$ === 'ImageKind') {
		return resolution + ' px';
	} else {
		return $elm$core$String$isEmpty(durationPart) ? (resolution + ' px') : durationPart;
	}
};
var $author$project$Locations$MediaReview$MediaToast$renderToast = F2(
	function (onDismiss, toast) {
		return A2(
			$author$project$PinMeTo$Ui$Toast$render,
			_Utils_Tuple0,
			A2(
				$author$project$PinMeTo$Ui$Toast$withDuration,
				10,
				A2(
					$author$project$PinMeTo$Ui$Toast$withIcon,
					toast.icon,
					$author$project$PinMeTo$Ui$Toast$failure(
						{
							body: function (_v0) {
								return toast.body;
							},
							title: function (_v1) {
								return toast.title;
							},
							onClose: onDismiss(toast)
						}))));
	});
var $author$project$Locations$MediaReview$AddAssets$viewAssetPanel = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('add-assets')
			]),
		A2(
			$elm$core$List$cons,
			config.dropZone,
			_Utils_ap(
				config.belowDropZone,
				_List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-assets__assets-container')
							]),
						config.rows),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Locations$MediaReview$MediaToast$renderToast(config.onDismissToast),
							config.toasts))
					]))));
};
var $author$project$Locations$MediaReview$AddAssets$skellifyPreview = function (child) {
	return $author$project$PinMeTo$Ui$Skeleton$view(
		{
			shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
			children: _List_fromArray(
				[child]),
			isLoading: true,
			attributes: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('add-assets__image')
				])
		});
};
var $author$project$Locations$MediaReview$AddMedia$ClickDismissToast = function (a) {
	return {$: 'ClickDismissToast', a: a};
};
var $author$project$Locations$MediaReview$AddMedia$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Translations$Listings$MediaReview$mediaGuidelines = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.media_guidelines');
};
var $author$project$Translations$Listings$MediaReview$photoSize = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.photo_size');
};
var $author$project$Translations$Listings$MediaReview$photoFormat = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.photo_format');
};
var $author$project$Translations$Listings$MediaReview$photoGuidelines = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.photo_guidelines');
};
var $author$project$Translations$Listings$MediaReview$videoGuidelines = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.video_guidelines');
};
var $author$project$Locations$MediaReview$AddMedia$guidelineSection = F2(
	function (title, items) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('add-assets__guidelines-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-assets__guidelines-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-assets__guidelines-list')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(item)
									]));
						},
						items))
				]));
	});
var $author$project$Translations$Listings$MediaReview$photoMinResolution = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.photo_min_resolution');
};
var $author$project$Translations$Listings$MediaReview$videoDurationGuideline = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.video_duration_guideline');
};
var $author$project$Translations$Listings$MediaReview$videoFileSizeGuideline = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.video_file_size_guideline');
};
var $author$project$Translations$Listings$MediaReview$videoResolutionGuideline = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.video_resolution_guideline');
};
var $author$project$Locations$MediaReview$AddMedia$guidelinesContent = function (translations) {
	return _List_fromArray(
		[
			A2(
			$author$project$Locations$MediaReview$AddMedia$guidelineSection,
			$author$project$Translations$Listings$MediaReview$photoGuidelines(translations),
			_List_fromArray(
				[
					$author$project$Translations$Listings$MediaReview$photoFormat(translations),
					$author$project$Translations$Listings$MediaReview$photoSize(translations),
					$author$project$Translations$Listings$MediaReview$photoMinResolution(translations)
				])),
			A2(
			$author$project$Locations$MediaReview$AddMedia$guidelineSection,
			$author$project$Translations$Listings$MediaReview$videoGuidelines(translations),
			_List_fromArray(
				[
					$author$project$Translations$Listings$MediaReview$videoDurationGuideline(translations),
					$author$project$Translations$Listings$MediaReview$videoFileSizeGuideline(translations),
					$author$project$Translations$Listings$MediaReview$videoResolutionGuideline(translations)
				]))
		]);
};
var $author$project$Locations$MediaReview$AddMedia$guidelinesPopOverUid = 'media-upload-guidelines';
var $author$project$Translations$Listings$MediaReview$mediaGuidelinesLearnMore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.media_guidelines_learn_more');
};
var $author$project$Locations$MediaReview$AddMedia$videoRequirementsHelpUrl = 'https://support.google.com/business/answer/6103862';
var $author$project$Locations$MediaReview$AddMedia$viewMediaGuidelines = F2(
	function (session, model) {
		var translations = session.translations;
		var config = A2(
			$author$project$PinMeTo$Ui$PopOver$withLink,
			{
				href: $author$project$Locations$MediaReview$AddMedia$videoRequirementsHelpUrl,
				text: $author$project$Translations$Listings$MediaReview$mediaGuidelinesLearnMore(translations)
			},
			$author$project$PinMeTo$Ui$PopOver$view(
				{
					uid: $author$project$Locations$MediaReview$AddMedia$guidelinesPopOverUid,
					tagger: $author$project$Locations$MediaReview$AddMedia$PopOverMsg,
					content: $author$project$Locations$MediaReview$AddMedia$guidelinesContent(translations),
					preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
				}));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('add-assets__guidelines'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'media-upload-guidelines')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-assets__guidelines-label'),
							$elm$html$Html$Events$onClick(
							$author$project$Locations$MediaReview$AddMedia$PopOverMsg(
								A2($author$project$PinMeTo$Ui$PopOver$Open, $author$project$Locations$MediaReview$AddMedia$guidelinesPopOverUid, $author$project$PinMeTo$Ui$PopOver$BottomRight)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$MediaReview$mediaGuidelines(translations))
						])),
					A2($author$project$PinMeTo$Ui$PopOver$renderPlain, model.popOverState, config)
				]));
	});
var $author$project$Locations$MediaReview$AddAssets$viewUploaderLightbox = function (config) {
	return $author$project$PinMeTo$Ui$Lightbox$render(
		A2(
			$author$project$PinMeTo$Ui$Lightbox$withClose,
			config.onClose,
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
				$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withFooter,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('add-assets__button-container')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										config.onCancel,
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostNeutral,
											$author$project$PinMeTo$Ui$Button$buttonGhost(config.cancelLabel)))),
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$disabledIfTrue,
										!config.canPublish,
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											config.onPublish,
											$author$project$PinMeTo$Ui$Button$buttonPrimary(config.publishLabel))))
								])),
						$author$project$PinMeTo$Ui$Lightbox$view(
							{title: config.title, content: config.content}))))));
};
var $author$project$Locations$MediaReview$AddMedia$view = F3(
	function (session, model, tagger) {
		var uploadableCount = $author$project$Locations$MediaReview$AddAssets$countUploaded(model.selectedFiles);
		var renderLoading = function (file) {
			return _Utils_Tuple2(
				$elm$file$File$name(file),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-assets__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('add-assets__asset')
								]),
							_List_fromArray(
								[
									$author$project$Locations$MediaReview$AddAssets$skellifyPreview(
									A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(''),
												$elm$html$Html$Attributes$class('add-assets__image')
											]),
										_List_Nil)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('add-assets__asset-info')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('add-assets__asset-title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$file$File$name(file))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('add-assets__asset-metadata--hidden')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('…')
												]))
										]))
								]))
						])));
		};
		var renderDropbox = A2(
			$author$project$Listings$Ui$DropZone$view,
			{
				tagger: $author$project$Locations$MediaReview$AddMedia$DropZoneMsg,
				buttonLabel: $author$project$Translations$Listings$AddImage$browse(session.translations),
				dropZoneLabel: $author$project$Translations$Listings$MediaReview$dropZone(session.translations)
			},
			model.dropZone);
		var renderLoaded = function (mediaAsset) {
			return _Utils_Tuple2(
				mediaAsset.id,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-assets__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('add-assets__asset')
								]),
							_Utils_ap(
								function () {
									var _v1 = mediaAsset.kind;
									if (_v1.$ === 'ImageKind') {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(mediaAsset.previewUrl),
														$elm$html$Html$Attributes$class('add-assets__image')
													]),
												_List_Nil)
											]);
									} else {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$video,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(mediaAsset.url),
														$elm$html$Html$Attributes$poster(mediaAsset.previewUrl),
														$elm$html$Html$Attributes$class('add-assets__image'),
														$elm$html$Html$Attributes$controls(true),
														A2($elm$html$Html$Attributes$attribute, 'preload', 'metadata')
													]),
												_List_Nil)
											]);
									}
								}(),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('add-assets__asset-info')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('add-assets__asset-title')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(mediaAsset.name)
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('add-assets__asset-metadata')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Locations$MediaReview$AddMedia$mediaMetaLabel(mediaAsset))
															]))
													]))
											]))
									]))),
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('far fa-trash'),
									$author$project$Common$Util$onClickFinal(
									$author$project$Locations$MediaReview$AddMedia$RemoveAsset(mediaAsset))
								]),
							_List_Nil)
						])));
		};
		var renderRow = function (asset) {
			if (asset.$ === 'Local') {
				var file = asset.a;
				return renderLoading(file);
			} else {
				var mediaAsset = asset.a;
				return renderLoaded(mediaAsset);
			}
		};
		return A2(
			$elm$html$Html$map,
			tagger,
			$author$project$Locations$MediaReview$AddAssets$viewUploaderLightbox(
				{
					title: $author$project$Translations$Listings$MediaReview$uploadMedia(session.translations),
					content: $author$project$Locations$MediaReview$AddAssets$viewAssetPanel(
						{
							rows: A2($elm$core$List$map, renderRow, model.selectedFiles),
							toasts: model.toasts,
							dropZone: renderDropbox,
							belowDropZone: _List_fromArray(
								[
									A2($author$project$Locations$MediaReview$AddMedia$viewMediaGuidelines, session, model)
								]),
							onDismissToast: $author$project$Locations$MediaReview$AddMedia$ClickDismissToast
						}),
					onClose: $author$project$Locations$MediaReview$AddMedia$Close,
					onCancel: $author$project$Locations$MediaReview$AddMedia$Close,
					onPublish: $author$project$Locations$MediaReview$AddMedia$ClickPublish,
					canPublish: $elm$core$List$isEmpty(model.publishing) && ((!$elm$core$List$isEmpty(model.selectedFiles)) && (uploadableCount > 0)),
					cancelLabel: $author$project$Translations$Listings$AddImage$cancel(session.translations),
					publishLabel: A2(
						$author$project$Translations$Listings$AddImage$publish,
						session.translations,
						$elm$core$String$fromInt(uploadableCount))
				}));
	});
var $author$project$Translations$Listings$MediaReview$media = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.media');
};
var $author$project$Translations$Listings$MediaReview$report = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.report');
};
var $author$project$Translations$Listings$MediaReview$noMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.noMedia');
};
var $author$project$Listings$Ui$MediaCard$Media = F8(
	function (id, url, previewUrl, published, mediaType, status, uploadedBy, dimensions) {
		return {id: id, url: url, status: status, mediaType: mediaType, published: published, dimensions: dimensions, previewUrl: previewUrl, uploadedBy: uploadedBy};
	});
var $author$project$Listings$Ui$MediaCard$MediaId = function (a) {
	return {$: 'MediaId', a: a};
};
var $author$project$Listings$Ui$MediaCard$DEFAULT = {$: 'DEFAULT'};
var $author$project$Listings$Ui$MediaCard$FLAGGED = {$: 'FLAGGED'};
var $author$project$Listings$Ui$MediaCard$REMOVED = {$: 'REMOVED'};
var $author$project$Locations$MediaReview$Main$mapStatus = function (status) {
	switch (status.$) {
		case 'REMOVED':
			return $author$project$Listings$Ui$MediaCard$REMOVED;
		case 'FLAGGED':
			return $author$project$Listings$Ui$MediaCard$FLAGGED;
		default:
			return $author$project$Listings$Ui$MediaCard$DEFAULT;
	}
};
var $author$project$Listings$Ui$MediaCard$PHOTO = {$: 'PHOTO'};
var $author$project$Listings$Ui$MediaCard$VIDEO = {$: 'VIDEO'};
var $author$project$Locations$MediaReview$Main$mapAssetType = function (assetType) {
	if (assetType.$ === 'VIDEO') {
		return $author$project$Listings$Ui$MediaCard$VIDEO;
	} else {
		return $author$project$Listings$Ui$MediaCard$PHOTO;
	}
};
var $author$project$Locations$MediaReview$Main$toUiMediaList = function (media) {
	var dateToShow = F2(
		function (publishedAt, createdAt) {
			return _Utils_eq(
				publishedAt,
				$elm$time$Time$millisToPosix(0)) ? createdAt : publishedAt;
		});
	return A2(
		$elm$core$List$map,
		function (x) {
			return A8(
				$author$project$Listings$Ui$MediaCard$Media,
				$author$project$Listings$Ui$MediaCard$MediaId(x.id),
				x.url,
				x.previewUrl,
				A2(dateToShow, x.publishedAt, x.createdAt),
				$author$project$Locations$MediaReview$Main$mapAssetType(x.assetType),
				$author$project$Locations$MediaReview$Main$mapStatus(x.status),
				x.uploadedBy,
				{width: x.dimensions.width, height: x.dimensions.height});
		},
		media);
};
var $author$project$Locations$MediaReview$Model$LoadMore = {$: 'LoadMore'};
var $author$project$Labels$viewMore = F3(
	function (translations, count, total) {
		return A3(
			$author$project$Translations$General$viewMore,
			translations,
			$elm$core$String$fromInt(count),
			$elm$core$String$fromInt(total));
	});
var $author$project$Locations$MediaReview$Main$renderLoadMore = F3(
	function (session, totalCount, currentLoaded) {
		var disabled_ = _Utils_cmp(currentLoaded, totalCount) > -1;
		var currentLoadedCount = disabled_ ? totalCount : currentLoaded;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-table__add-more')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Locations$MediaReview$Model$LoadMore),
							$elm$html$Html$Attributes$disabled(disabled_)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Labels$viewMore, session.translations, currentLoadedCount, totalCount))
						]))
				]));
	});
var $author$project$Listings$Ui$MediaCard$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$Listings$Ui$MediaCard$view = function (config) {
	return $author$project$Listings$Ui$MediaCard$View(
		{locale: config.locale, onFlag: config.onFlag, onDelete: config.onDelete, onReport: config.onReport, onMediaClick: config.onMediaClick});
};
var $author$project$FontAwesome$Solid$Icon$faFlag = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-flag');
var $author$project$FontAwesome$Solid$faFlag = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faFlag);
var $author$project$FontAwesome$Regular$faFlag = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faFlag);
var $author$project$Listings$Ui$MediaCard$renderFlag = F2(
	function (media, config) {
		var _v0 = media.uploadedBy;
		if (_v0.$ === 'OWNER') {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-media-card__flag')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = media.status;
						switch (_v1.$) {
							case 'FLAGGED':
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-media-card__actions--flag ui-media-card__actions--flag-flagged'),
											$elm$html$Html$Events$onClick(
											config.onFlag(media))
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Solid$faFlag]));
							case 'DEFAULT':
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-media-card__actions--flag'),
											$elm$html$Html$Events$onClick(
											config.onFlag(media))
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Regular$faFlag]));
							default:
								return $elm$html$Html$text('');
						}
					}()
					]));
		}
	});
var $author$project$FontAwesome$Solid$Icon$faUsers = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-users');
var $author$project$FontAwesome$Solid$faUsers = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faUsers);
var $author$project$FontAwesome$Solid$Icon$faUserTie = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-user-tie');
var $author$project$FontAwesome$Solid$faUserTie = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faUserTie);
var $author$project$FontAwesome$Solid$Icon$faTrashCan = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-trash-can');
var $author$project$FontAwesome$Solid$faTrashCan = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faTrashCan);
var $author$project$Listings$Ui$MediaCard$renderImageAction = F6(
	function (deleteAction, reportOnNetwork, media, uploadedBy, config, report) {
		if (uploadedBy.$ === 'OWNER') {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-media-card__actions--delete'),
						$elm$html$Html$Events$onClick(
						config.onDelete(media))
					]),
				_List_fromArray(
					[deleteAction]));
		} else {
			var attribution = uploadedBy.a;
			return (attribution.takedownUrl !== '') ? A2(
				reportOnNetwork,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-media-card__actions--report'),
						$elm$html$Html$Attributes$href(attribution.takedownUrl),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Events$onClick(
						config.onReport(media))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(report)
					])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
		}
	});
var $author$project$Listings$Ui$MediaCard$renderActions = F4(
	function (media, uploadedBy, config, report) {
		var createdBy = function () {
			if (uploadedBy.$ === 'OWNER') {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-media-card__customer-owner-logo')
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Solid$faUserTie])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-media-card__customer-owner-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Owner')
								]))
						]));
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-media-card__customer-owner-logo')
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Solid$faUsers])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-media-card__customer-owner-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Customer')
								]))
						]));
			}
		}();
		return _List_fromArray(
			[
				createdBy,
				A6($author$project$Listings$Ui$MediaCard$renderImageAction, $author$project$FontAwesome$Solid$faTrashCan, $elm$html$Html$a, media, uploadedBy, config, report)
			]);
	});
var $author$project$Listings$Ui$MediaCard$formatResolution = function (_v0) {
	var height = _v0.height;
	var width = _v0.width;
	return ((width > 0) && (height > 0)) ? ($elm$core$String$fromInt(width) + (' x ' + ($elm$core$String$fromInt(height) + ' px'))) : '';
};
var $author$project$Listings$Ui$MediaCard$updateThumbnailUrlResolution = F2(
	function (thumbnailUrl, newWidth) {
		var thumbnailSplitUrl = A2($elm$core$String$split, '=s', thumbnailUrl);
		var thumbnailSplitUrlValid = $elm$core$List$length(thumbnailSplitUrl) > 1;
		var getListHead = function (list) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(list));
		};
		var thumbnailResolution = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$elm$core$String$toInt(
				getListHead(
					$elm$core$List$reverse(thumbnailSplitUrl))));
		return ((!_Utils_eq(thumbnailResolution, newWidth)) && thumbnailSplitUrlValid) ? (getListHead(thumbnailSplitUrl) + ('=s' + $elm$core$String$fromInt(newWidth))) : thumbnailUrl;
	});
var $author$project$Listings$Ui$MediaCard$render = F3(
	function (media, report, _v0) {
		var config = _v0.a;
		var thumbnailWidth = 700;
		var metadataLabel = $author$project$Listings$Ui$MediaCard$formatResolution(media.dimensions);
		var previewUrl = _Utils_eq(media.mediaType, $author$project$Listings$Ui$MediaCard$VIDEO) ? A2($author$project$Listings$Ui$MediaCard$updateThumbnailUrlResolution, media.previewUrl, thumbnailWidth) : media.url;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('ui-media-card', true),
							_Utils_Tuple2(
							'ui-media-card__flagged',
							_Utils_eq(media.status, $author$project$Listings$Ui$MediaCard$FLAGGED)),
							_Utils_Tuple2(
							'ui-media-card__removed',
							_Utils_eq(media.status, $author$project$Listings$Ui$MediaCard$REMOVED))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-media-card__actions')
						]),
					A4($author$project$Listings$Ui$MediaCard$renderActions, media, media.uploadedBy, config, report)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-media-card__thumbnail')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Listings$Ui$MediaCard$renderFlag, media, config)
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(previewUrl),
									$elm$html$Html$Events$onClick(
									config.onMediaClick(media))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-media-card__footer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-media-card__footer-date')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Date$render(
									A2(
										$author$project$PinMeTo$Ui$Date$withFormat,
										$author$project$PinMeTo$Ui$Date$FormatDate,
										A2($author$project$PinMeTo$Ui$Date$posix, config.locale, media.published)))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-media-card__footer-metadata')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(metadataLabel)
								]))
						]))
				]));
	});
var $author$project$Locations$MediaReview$Model$OnMediaFlag = function (a) {
	return {$: 'OnMediaFlag', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaClick = function (a) {
	return {$: 'OnMediaClick', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaDelete = function (a) {
	return {$: 'OnMediaDelete', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaReport = function (a) {
	return {$: 'OnMediaReport', a: a};
};
var $author$project$Locations$MediaReview$Main$uiMediaCardConfig = function (locale) {
	return {locale: locale, onFlag: $author$project$Locations$MediaReview$Model$OnMediaFlag, onDelete: $author$project$Locations$MediaReview$Model$OnMediaDelete, onReport: $author$project$Locations$MediaReview$Model$OnMediaReport, onMediaClick: $author$project$Locations$MediaReview$Model$OnMediaClick};
};
var $author$project$Locations$MediaReview$Main$renderMedia = F3(
	function (locale, reportLabel, image) {
		var uiMediaCardConfig_ = $author$project$Locations$MediaReview$Main$uiMediaCardConfig(locale);
		return A3(
			$author$project$Listings$Ui$MediaCard$render,
			image,
			reportLabel,
			$author$project$Listings$Ui$MediaCard$view(uiMediaCardConfig_));
	});
var $author$project$Locations$MediaReview$Main$renderMediaGrid = F3(
	function (session, reportLabel, imageCards) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-layout-grid')
				]),
			A2(
				$elm$core$List$map,
				function (media) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-layout-grid__item')
							]),
						_List_fromArray(
							[
								A3($author$project$Locations$MediaReview$Main$renderMedia, session.locale, reportLabel, media)
							]));
				},
				imageCards));
	});
var $author$project$Locations$MediaReview$Main$gridView = F4(
	function (session, media, count, reportLabel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-network-media-assets--grid')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Locations$MediaReview$Main$renderMediaGrid,
					session,
					reportLabel,
					$author$project$Locations$MediaReview$Main$toUiMediaList(media)),
					A3(
					$author$project$Locations$MediaReview$Main$renderLoadMore,
					session,
					count,
					$elm$core$List$length(media))
				]));
	});
var $author$project$PinMeTo$Ui$Toast$Neutral = {$: 'Neutral'};
var $author$project$PinMeTo$Ui$Toast$neutral = function (config) {
	var config_ = {body: config.body, icon: $elm$core$Maybe$Nothing, title: config.title, onClose: config.onClose, duration: $elm$core$Maybe$Nothing, infinite: false, iconClass: $elm$core$Maybe$Nothing};
	return A2($author$project$PinMeTo$Ui$Toast$Toast, $author$project$PinMeTo$Ui$Toast$Neutral, config_);
};
var $author$project$Translations$General$success = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.success');
};
var $author$project$FontAwesome$Regular$Icon$faSpinner = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-spinner');
var $author$project$Translations$General$uploading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.uploading');
};
var $author$project$PinMeTo$Ui$Toast$withInfinite = function (_v0) {
	var type_ = _v0.a;
	var config = _v0.b;
	return A2(
		$author$project$PinMeTo$Ui$Toast$Toast,
		type_,
		_Utils_update(
			config,
			{infinite: true}));
};
var $author$project$Translations$Listings$MediaReview$uploadingToNetwork = F2(
	function (translations, network) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.media_review.uploading_to_network',
			_List_fromArray(
				[
					_Utils_Tuple2('network', network)
				]));
	});
var $author$project$Locations$MediaReview$Main$getCurrentNetworkName = 'Google';
var $author$project$Locations$MediaReview$Model$UserClickedDismissToast = {$: 'UserClickedDismissToast'};
var $author$project$Translations$Listings$MediaReview$successfulUploadToNetwork = F2(
	function (translations, network) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.media_review.successful_upload_to_network',
			_List_fromArray(
				[
					_Utils_Tuple2('network', network)
				]));
	});
var $author$project$Locations$MediaReview$Main$toastView = F2(
	function (session, toast) {
		if (toast.$ === 'ToastPassed') {
			var state = toast.a;
			if (state.$ === 'ToastSuccess') {
				return A2(
					$author$project$PinMeTo$Ui$Toast$render,
					_Utils_Tuple0,
					$author$project$PinMeTo$Ui$Toast$success(
						{
							body: function (_v2) {
								return A2($author$project$Translations$Listings$MediaReview$successfulUploadToNetwork, session.translations, $author$project$Locations$MediaReview$Main$getCurrentNetworkName);
							},
							title: function (_v3) {
								return $author$project$Translations$General$success(session.translations);
							},
							onClose: $author$project$Locations$MediaReview$Model$UserClickedDismissToast
						}));
			} else {
				return A2(
					$author$project$PinMeTo$Ui$Toast$render,
					_Utils_Tuple0,
					A2(
						$author$project$PinMeTo$Ui$Toast$withIcon,
						$author$project$PinMeTo$Ui$Toast$FaIcon(
							$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faSpinner)),
						$author$project$PinMeTo$Ui$Toast$neutral(
							{
								body: function (_v4) {
									return A2($author$project$Translations$Listings$MediaReview$uploadingToNetwork, session.translations, $author$project$Locations$MediaReview$Main$getCurrentNetworkName);
								},
								title: function (_v5) {
									return $author$project$Translations$General$uploading(session.translations);
								},
								onClose: $author$project$Locations$MediaReview$Model$UserClickedDismissToast
							})));
			}
		} else {
			var toastMsg = toast.a;
			return A2(
				$author$project$PinMeTo$Ui$Toast$render,
				_Utils_Tuple0,
				$author$project$PinMeTo$Ui$Toast$withInfinite(
					$author$project$PinMeTo$Ui$Toast$failure(
						{
							body: function (_v6) {
								return toastMsg;
							},
							title: function (_v7) {
								return $author$project$Translations$General$error(session.translations);
							},
							onClose: $author$project$Locations$MediaReview$Model$UserClickedDismissToast
						})));
		}
	});
var $author$project$Locations$MediaReview$Model$Ascending = {$: 'Ascending'};
var $author$project$Translations$Listings$MediaReview$sortAscending = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.sort_ascending');
};
var $author$project$PinMeTo$Deprecated$FontAwesome$ArrowUpShortUp = {$: 'ArrowUpShortUp'};
var $author$project$Translations$Listings$MediaReview$sortDescending = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.sort_descending');
};
var $author$project$Locations$MediaReview$Model$ChangeSortOrder = function (a) {
	return {$: 'ChangeSortOrder', a: a};
};
var $author$project$PinMeTo$Deprecated$FontAwesome$ArrowUpShortDown = {$: 'ArrowUpShortDown'};
var $author$project$Locations$MediaReview$Main$sortAction = F2(
	function (session, sortOrder) {
		if (sortOrder.$ === 'Ascending') {
			return A3(
				$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-network-media-assets--sort-action-light'),
						$elm$html$Html$Attributes$title(
						$author$project$Translations$Listings$MediaReview$sortDescending(session.translations)),
						$elm$html$Html$Events$onClick(
						$author$project$Locations$MediaReview$Model$ChangeSortOrder($author$project$Locations$MediaReview$Model$Descending))
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$ArrowUpShortUp)
					]));
		} else {
			return A3(
				$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-network-media-assets--sort-action-light'),
						$elm$html$Html$Attributes$title(
						$author$project$Translations$Listings$MediaReview$sortAscending(session.translations)),
						$elm$html$Html$Events$onClick(
						$author$project$Locations$MediaReview$Model$ChangeSortOrder($author$project$Locations$MediaReview$Model$Ascending))
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$ArrowUpShortDown)
					]));
		}
	});
var $author$project$Locations$MediaReview$Model$AddMediaMsg = function (a) {
	return {$: 'AddMediaMsg', a: a};
};
var $author$project$Translations$Listings$MediaReview$deleteMedia = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.delete_media');
};
var $author$project$Locations$MediaReview$Model$RemoveResponseBanner = {$: 'RemoveResponseBanner'};
var $author$project$Locations$MediaReview$Main$errorBanner = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('status-bar__message')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('status-bar__dismiss'),
						$elm$html$Html$Events$onClick($author$project$Locations$MediaReview$Model$RemoveResponseBanner)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]))
			]));
};
var $author$project$Locations$MediaReview$Model$AddMediaClicked = {$: 'AddMediaClicked'};
var $author$project$Locations$MediaReview$Model$OnCloseLightBox = {$: 'OnCloseLightBox'};
var $author$project$Filter$FilterController$viewMediaAssets = F6(
	function (tagger, model, itemCount, locale, translations, language) {
		var labels = A2($author$project$Filter$FilterLabels$defaultFilterControllerLabels, translations, language);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$PinMeTo$Global$FilterController$render,
					A3($author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels, translations, language, labels),
					A2($elm$core$Basics$composeR, $author$project$Filter$FilterController$UiFilteredListMsg, tagger),
					model.uiFilteredList,
					A2(
						$author$project$PinMeTo$Ui$FilterController$withResultsCount,
						itemCount,
						A2(
							$author$project$PinMeTo$Ui$FilterController$withSearchOptionsOnly,
							$author$project$Translations$General$filter(translations),
							$author$project$PinMeTo$Ui$FilterController$view(
								{uid: 'filter-controller-media-assets', labels: labels, locale: locale}))))
				]));
	});
var $author$project$Translations$Listings$MediaReview$cantUndo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.cant_undo');
};
var $author$project$Translations$Listings$MediaReview$confirmRemove = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.confirm_remove');
};
var $author$project$Locations$MediaReview$Model$ConfirmMediaDelete = function (a) {
	return {$: 'ConfirmMediaDelete', a: a};
};
var $author$project$Locations$MediaReview$Model$OnCloseDeleteMediaAlert = {$: 'OnCloseDeleteMediaAlert'};
var $author$project$Locations$MediaReview$Main$renderDeleteMediaAlert = F3(
	function (session, model, media) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset util__background--white')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$MediaReview$confirmRemove(session.translations) + ' ')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$MediaReview$cantUndo(session.translations) + '.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-btn-group pmt-btn-group--basis-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-btn-group__divider')
								]),
							_List_Nil),
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnSecondary,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Locations$MediaReview$Model$OnCloseDeleteMediaAlert),
									$elm$html$Html$Attributes$type_('reset')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$cancel(session.translations))
								])),
							model.deletingMedia ? A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnNegative,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-network-media-assets__spinner-btn'),
									$elm$html$Html$Attributes$disabled(true)
								]),
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner])) : A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnNegative,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Locations$MediaReview$Model$ConfirmMediaDelete(media))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$delete(session.translations))
								]))
						]))
				]));
	});
var $author$project$Translations$General$date = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.date');
};
var $author$project$Translations$Listings$MediaReview$owner = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.owner');
};
var $author$project$Translations$Listings$MediaReview$photo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.photo');
};
var $author$project$Translations$Listings$MediaReview$video = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.video');
};
var $author$project$Translations$Listings$MediaReview$action = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.action');
};
var $author$project$Translations$Listings$MediaReview$mediaType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.media_type');
};
var $author$project$Translations$Listings$MediaReview$resolution = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.resolution');
};
var $author$project$Translations$Listings$MediaReview$publishedBy = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.published_by');
};
var $author$project$Listings$Ui$MediaCard$MediaDetails = F8(
	function (id, url, published, mediaType, status, dimensions, location, uploadedBy) {
		return {id: id, url: url, status: status, location: location, mediaType: mediaType, published: published, dimensions: dimensions, uploadedBy: uploadedBy};
	});
var $author$project$Locations$MediaReview$Main$mapLocationInfo = function (loc) {
	return {id: loc.id, address: loc.address, storeId: loc.storeId};
};
var $author$project$Translations$Listings$MediaReview$publishedByUser = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.published_by_user');
};
var $elm$html$Html$source = _VirtualDom_node('source');
var $elm$html$Html$Attributes$autoplay = $elm$html$Html$Attributes$boolProperty('autoplay');
var $author$project$Listings$Ui$MediaCard$mediaTypeString = F2(
	function (mediaType, labels) {
		if (mediaType.$ === 'VIDEO') {
			return labels.video;
		} else {
			return labels.photo;
		}
	});
var $author$project$Listings$Ui$MediaCard$renderDetailedView = F4(
	function (media, siteName, _v0, labels) {
		var config = _v0.a;
		var attributionDetails = function () {
			var _v4 = media.uploadedBy;
			if (_v4.$ === 'OWNER') {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labels.publishedBy),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-media-card__customer-owner-logo ui-media-card__customer-owner-logo-popup')
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Solid$faUserTie]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labels.owner)
								]))
						]));
			} else {
				var attribution = _v4.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labels.publishedBy),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-media-card__customer-owner-logo ui-media-card__customer-owner-logo-popup')
										]),
									_List_fromArray(
										[$author$project$FontAwesome$Solid$faUsers]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(attribution.profileName)
								]))
						]));
			}
		}();
		var mediaResoltuion = ((!media.dimensions.width) || (!media.dimensions.height)) ? A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(labels.resolution)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(media.dimensions.width) + (' x ' + $elm$core$String$fromInt(media.dimensions.height)))
						]))
				]));
		var brandLogo = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-media-card__google-media-icon')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorGoogle)
						]))
				]));
		var storeAndLocationRows = function () {
			var _v2 = media.location;
			if (_v2.$ === 'Just') {
				var loc = _v2.a;
				var locationUrl = '/listings/' + (siteName + ('/locations/' + (loc.id + '/details')));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ui-media-card__icon-and-store-div')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ui-media-card__margin-right-auto')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(labels.storeId)
									])),
								brandLogo
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(locationUrl)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Data$Location$storeIdToString(loc.storeId))
									]))
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(labels.location)
							])),
						function () {
						var _v3 = loc.address;
						if (_v3.$ === 'Just') {
							var addr = _v3.a;
							return A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(locationUrl)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(addr.street + (', ' + addr.city))
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(labels.location)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ui-media-card__location-unavailable')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labels.locationUnavailable)
							]))
					]);
			}
		}();
		var actionRow = A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A6(
					$author$project$Listings$Ui$MediaCard$renderImageAction,
					A3(
						$author$project$PinMeTo$Ui$Btn$pmtBtnNegative,
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								config.onDelete(media))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labels._delete)
							])),
					$author$project$PinMeTo$Ui$Btn$pmtBtn($elm$html$Html$a),
					media,
					media.uploadedBy,
					config,
					labels.report)
				]));
		var preview = function () {
			var _v1 = media.mediaType;
			if (_v1.$ === 'VIDEO') {
				return A2(
					$elm$html$Html$video,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$autoplay(false),
							$elm$html$Html$Attributes$class('ui-media-card__video')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$source,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(media.url)
								]),
							_List_Nil)
						]));
			} else {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(media.url)
						]),
					_List_Nil);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-media-card__detailed-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-media-card__detailed-view--media-preview')
						]),
					_List_fromArray(
						[preview])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-media-card__detailed-view--details')
						]),
					_Utils_ap(
						storeAndLocationRows,
						_List_fromArray(
							[
								A2($elm$html$Html$h4, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[attributionDetails])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(labels.date)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Date$render(
										A2($author$project$PinMeTo$Ui$Date$posix, config.locale, media.published))
									])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(labels.mediaType)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Listings$Ui$MediaCard$mediaTypeString, media.mediaType, labels))
									])),
								mediaResoltuion,
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(labels.action)
									])),
								actionRow
							])))
				]));
	});
var $author$project$Translations$Listings$MediaReview$locationUnavailable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.location_unavailable');
};
var $author$project$Locations$MediaReview$Model$OnMediaDetailsFlag = function (a) {
	return {$: 'OnMediaDetailsFlag', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaDetailsClick = function (a) {
	return {$: 'OnMediaDetailsClick', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaDetailsDelete = function (a) {
	return {$: 'OnMediaDetailsDelete', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaDetailsReport = function (a) {
	return {$: 'OnMediaDetailsReport', a: a};
};
var $author$project$Locations$MediaReview$Main$uiMediaDetailsConfig = function (locale) {
	return {locale: locale, onFlag: $author$project$Locations$MediaReview$Model$OnMediaDetailsFlag, onDelete: $author$project$Locations$MediaReview$Model$OnMediaDetailsDelete, onReport: $author$project$Locations$MediaReview$Model$OnMediaDetailsReport, onMediaClick: $author$project$Locations$MediaReview$Model$OnMediaDetailsClick};
};
var $author$project$Locations$MediaReview$Main$renderDetailedMediaView = F4(
	function (_v0, locale, mediaDetails, translations) {
		var siteName = _v0.a;
		var mediaCardLabels = {
			date: $author$project$Translations$General$date(translations),
			owner: $author$project$Translations$Listings$MediaReview$owner(translations),
			photo: $author$project$Translations$Listings$MediaReview$photo(translations),
			video: $author$project$Translations$Listings$MediaReview$video(translations),
			action: $author$project$Translations$Listings$MediaReview$action(translations),
			_delete: $author$project$Translations$General$delete(translations),
			report: $author$project$Translations$Listings$MediaReview$report(translations),
			storeId: $author$project$Translations$General$locationStoreId(translations),
			location: $author$project$Translations$General$location(translations),
			mediaType: $author$project$Translations$Listings$MediaReview$mediaType(translations),
			resolution: $author$project$Translations$Listings$MediaReview$resolution(translations),
			publishedBy: $author$project$Translations$Listings$MediaReview$publishedBy(translations),
			publishedByUser: $author$project$Translations$Listings$MediaReview$publishedByUser(translations),
			locationUnavailable: $author$project$Translations$Listings$MediaReview$locationUnavailable(translations)
		};
		var details = A8(
			$author$project$Listings$Ui$MediaCard$MediaDetails,
			$author$project$Listings$Ui$MediaCard$MediaId(mediaDetails.id),
			mediaDetails.url,
			mediaDetails.publishedAt,
			$author$project$Locations$MediaReview$Main$mapAssetType(mediaDetails.assetType),
			$author$project$Locations$MediaReview$Main$mapStatus(mediaDetails.status),
			mediaDetails.dimensions,
			A2($elm$core$Maybe$map, $author$project$Locations$MediaReview$Main$mapLocationInfo, mediaDetails.location),
			mediaDetails.uploadedBy);
		return A4(
			$author$project$Listings$Ui$MediaCard$renderDetailedView,
			details,
			siteName,
			$author$project$Listings$Ui$MediaCard$view(
				$author$project$Locations$MediaReview$Main$uiMediaDetailsConfig(locale)),
			mediaCardLabels);
	});
var $author$project$Locations$MediaReview$Main$view = F2(
	function (session, model) {
		var detailedViewLightbox = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (details) {
				return $author$project$PinMeTo$Ui$Lightbox$render(
					$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
						$author$project$PinMeTo$Ui$Lightbox$withFullHeight(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withClose,
								$author$project$Locations$MediaReview$Model$OnCloseLightBox,
								$author$project$PinMeTo$Ui$Lightbox$view(
									{
										title: $author$project$Translations$Listings$MediaReview$media(session.translations),
										content: A4($author$project$Locations$MediaReview$Main$renderDetailedMediaView, session.siteName, session.locale, details, session.translations)
									})))));
			},
			model.detailedMediaToShow);
		var deleteMediaAlert = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (media_) {
				return $author$project$PinMeTo$Ui$Lightbox$render(
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withStyle,
						$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withClose,
							$author$project$Locations$MediaReview$Model$OnCloseLightBox,
							$author$project$PinMeTo$Ui$Lightbox$view(
								{
									title: $author$project$Translations$Listings$MediaReview$deleteMedia(session.translations),
									content: A3($author$project$Locations$MediaReview$Main$renderDeleteMediaAlert, session, model, media_)
								}))));
			},
			model.mediaToDelete);
		var locationEnabled = A2($elm$core$Maybe$withDefault, true, model.locationEnabled);
		var titleBarUploadBtn = locationEnabled ? A4(
			$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
			$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Locations$MediaReview$Model$AddMediaClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$MediaReview$uploadMedia(session.translations))
				])) : $elm$html$Html$text('');
		var titleBar = function () {
			var _v7 = model.locationId;
			if (_v7.$ === 'Nothing') {
				return $author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
						true,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withAsides,
							_List_fromArray(
								[
									A2($author$project$Locations$MediaReview$Main$sortAction, session, model.pagination.sortOrder)
								]),
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
								$author$project$Translations$Listings$MediaReview$media(session.translations)))));
			} else {
				return $author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
						true,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withAsides,
							_List_fromArray(
								[
									A2($author$project$Locations$MediaReview$Main$sortAction, session, model.pagination.sortOrder)
								]),
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-network-media-assets--upload-actions')
										]),
									_List_fromArray(
										[titleBarUploadBtn]))))));
			}
		}();
		var noMedia = function () {
			var _v6 = _Utils_Tuple2(model.media, model.count);
			if ((_v6.a.$ === 'Loaded') && (_v6.b.$ === 'Loaded')) {
				var count_ = _v6.b.a;
				return (!count_) ? $author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Note,
						$author$project$PinMeTo$Ui$Alert$plain(
							$author$project$Translations$Listings$MediaReview$noMedia(session.translations)))) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
			} else {
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			}
		}();
		var modal = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (addMedia) {
				return A3($author$project$Locations$MediaReview$AddMedia$view, session, addMedia, $author$project$Locations$MediaReview$Model$AddMediaMsg);
			},
			model.addMedia);
		var media = function () {
			var _v1 = _Utils_Tuple2(model.media, model.count);
			_v1$2:
			while (true) {
				_v1$3:
				while (true) {
					_v1$4:
					while (true) {
						_v1$5:
						while (true) {
							switch (_v1.a.$) {
								case 'Loaded':
									switch (_v1.b.$) {
										case 'Loaded':
											var media_ = _v1.a.a;
											var count_ = _v1.b.a;
											return A4(
												$author$project$Locations$MediaReview$Main$gridView,
												session,
												media_,
												count_,
												$author$project$Translations$Listings$MediaReview$report(session.translations));
										case 'Error':
											break _v1$2;
										case 'Loading':
											break _v1$3;
										default:
											var _v5 = _v1.b;
											return $elm$html$Html$text('');
									}
								case 'Error':
									var e = _v1.a.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-network-media-assets')
											]),
										_List_fromArray(
											[
												$author$project$Locations$MediaReview$Main$errorBanner(e)
											]));
								case 'Loading':
									switch (_v1.b.$) {
										case 'Error':
											break _v1$2;
										case 'Loading':
											break _v1$3;
										case 'Suspended':
											break _v1$4;
										default:
											break _v1$4;
									}
								default:
									switch (_v1.b.$) {
										case 'Error':
											break _v1$2;
										case 'Loading':
											break _v1$3;
										case 'Suspended':
											break _v1$5;
										default:
											break _v1$5;
									}
							}
						}
						var _v4 = _v1.a;
						return $elm$html$Html$text('');
					}
					var _v3 = _v1.a;
					return $author$project$PinMeTo$Ui$Spinner$spinner;
				}
				var _v2 = _v1.b;
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			}
			var e = _v1.b.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-network-media-assets')
					]),
				_List_fromArray(
					[
						$author$project$Locations$MediaReview$Main$errorBanner(e)
					]));
		}();
		var count = function () {
			var _v0 = model.count;
			if (_v0.$ === 'Loaded') {
				var count_ = _v0.a;
				return count_;
			} else {
				return 0;
			}
		}();
		var filter = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (model_) {
				return A6($author$project$Filter$FilterController$viewMediaAssets, $author$project$Locations$MediaReview$Model$FilterControllerMsg, model_, count, session.locale, session.translations, session.language);
			},
			model.filterController);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-network-media-assets', true),
							_Utils_Tuple2(
							'pmt-network-media-assets__container',
							_Utils_eq(model.locationId, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-network-media-assets--filter')
						]),
					_List_fromArray(
						[filter])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[modal])),
					titleBar,
					noMedia,
					media,
					detailedViewLightbox,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-network-media-assets--alert-box')
						]),
					_List_fromArray(
						[deleteMediaAlert])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Locations$MediaReview$Main$toastView(session),
						$elm$core$List$reverse(model.toasts)))
				]));
	});
var $author$project$Locations$MediaReview$AddMedia$init = function (locationId) {
	return _Utils_Tuple2(
		{toasts: _List_Nil, dropZone: $author$project$Listings$Ui$DropZone$init, locationId: locationId, publishing: _List_Nil, popOverState: $author$project$PinMeTo$Ui$PopOver$init, selectedFiles: _List_Nil},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Locations$MediaReview$AddAssets$Local = function (a) {
	return {$: 'Local', a: a};
};
var $author$project$Locations$MediaReview$AddMedia$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Locations$MediaReview$AddAssets$Uploaded = function (a) {
	return {$: 'Uploaded', a: a};
};
var $author$project$Locations$MediaReview$MediaToast$dismissToast = F2(
	function (toast, toasts) {
		return A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(toast),
			toasts);
	});
var $author$project$Locations$MediaReview$AddMedia$dropZoneMimes = _List_fromArray(
	['image/*', 'video/*']);
var $author$project$Translations$Listings$AddImage$failedToUpload = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_image.failed_to_upload');
};
var $elm$file$File$mime = _File_mime;
var $author$project$Locations$MediaReview$AddMedia$ImageKind = {$: 'ImageKind'};
var $author$project$Locations$MediaReview$AddMedia$VideoKind = {$: 'VideoKind'};
var $author$project$Locations$MediaReview$AddMedia$fileKind = function (file) {
	return A2(
		$elm$core$String$startsWith,
		'image/',
		$elm$file$File$mime(file)) ? $elm$core$Maybe$Just($author$project$Locations$MediaReview$AddMedia$ImageKind) : (A2(
		$elm$core$String$startsWith,
		'video/',
		$elm$file$File$mime(file)) ? $elm$core$Maybe$Just($author$project$Locations$MediaReview$AddMedia$VideoKind) : $elm$core$Maybe$Nothing);
};
var $author$project$Locations$MediaReview$AddMedia$OnUploadedFile = F2(
	function (a, b) {
		return {$: 'OnUploadedFile', a: a, b: b};
	});
var $author$project$Locations$MediaReview$AddMedia$MediaAsset = F6(
	function (id, name, url, previewUrl, metaData, kind) {
		return {id: id, url: url, kind: kind, name: name, metaData: metaData, previewUrl: previewUrl};
	});
var $author$project$Locations$MediaReview$AddMedia$MetaData = F3(
	function (width, height, duration) {
		return {width: width, height: height, duration: duration};
	});
var $author$project$Locations$MediaReview$AddMedia$decodeMetaData = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'duration',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'height',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'width',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$AddMedia$MetaData))));
var $author$project$Locations$MediaReview$AddMedia$decodeImageAsset = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metaData',
	$author$project$Locations$MediaReview$AddMedia$decodeMetaData,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'previewUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'_id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed(
					F4(
						function (id, name, previewUrl, metaData) {
							return A6($author$project$Locations$MediaReview$AddMedia$MediaAsset, id, name, previewUrl, previewUrl, metaData, $author$project$Locations$MediaReview$AddMedia$ImageKind);
						}))))));
var $author$project$Locations$MediaReview$AddMedia$decodeVideoAsset = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metaData',
	$author$project$Locations$MediaReview$AddMedia$decodeMetaData,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'previewUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'_id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed(
						F5(
							function (id, name, url, previewUrl, metaData) {
								return A6($author$project$Locations$MediaReview$AddMedia$MediaAsset, id, name, url, previewUrl, metaData, $author$project$Locations$MediaReview$AddMedia$VideoKind);
							})))))));
var $author$project$Locations$MediaReview$AddAssets$mediaUploadResponseDecoder = function (dataDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (success) {
			return success ? A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Ok,
				A2($elm$json$Json$Decode$field, 'data', dataDecoder)) : A2(
				$elm$json$Json$Decode$map,
				$elm$core$Result$Err,
				A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool));
};
var $author$project$Locations$MediaReview$AddAssets$decodeMediaUploadResponse = F2(
	function (dataDecoder, body) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeString,
			$author$project$Locations$MediaReview$AddAssets$mediaUploadResponseDecoder(dataDecoder),
			body);
		if (_v0.$ === 'Ok') {
			var result = _v0.a;
			return result;
		} else {
			var decodeErr = _v0.a;
			return $elm$core$Result$Err(
				'Unexpected response: ' + $elm$json$Json$Decode$errorToString(decodeErr));
		}
	});
var $author$project$Locations$MediaReview$AddAssets$expectMediaUpload = F2(
	function (toMsg, dataDecoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 'GoodStatus_':
						var body = response.b;
						return A2($author$project$Locations$MediaReview$AddAssets$decodeMediaUploadResponse, dataDecoder, body);
					case 'BadUrl_':
						return $elm$core$Result$Err('Invalid URL');
					case 'Timeout_':
						return $elm$core$Result$Err('Request timed out');
					case 'NetworkError_':
						return $elm$core$Result$Err('Network error');
					default:
						var metadata = response.a;
						return $elm$core$Result$Err(
							'Upload failed (' + ($elm$core$String$fromInt(metadata.statusCode) + ')'));
				}
			});
	});
var $author$project$Locations$MediaReview$AddAssets$uploadToMediaLibrary = F3(
	function (config, _v0, file) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($author$project$Locations$MediaReview$AddAssets$expectMediaUpload, config.onResult, config.decoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$multipartBody(
						_List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('/listings/api/' + (siteName + '/media/media-review')))));
	});
var $author$project$Locations$MediaReview$AddMedia$uploadFile = F2(
	function (siteName, file) {
		var _v0 = $author$project$Locations$MediaReview$AddMedia$fileKind(file);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Platform$Cmd$none;
		} else {
			var kind = _v0.a;
			return A3(
				$author$project$Locations$MediaReview$AddAssets$uploadToMediaLibrary,
				{
					decoder: function () {
						if (kind.$ === 'ImageKind') {
							return $author$project$Locations$MediaReview$AddMedia$decodeImageAsset;
						} else {
							return $author$project$Locations$MediaReview$AddMedia$decodeVideoAsset;
						}
					}(),
					onResult: $author$project$Locations$MediaReview$AddMedia$OnUploadedFile(
						$elm$file$File$name(file))
				},
				siteName,
				file);
		}
	});
var $author$project$Locations$MediaReview$AddAssets$InvalidFileType = function (a) {
	return {$: 'InvalidFileType', a: a};
};
var $elm$file$File$size = _File_size;
var $author$project$Locations$MediaReview$AddAssets$ValidFile = function (a) {
	return {$: 'ValidFile', a: a};
};
var $author$project$Locations$MediaReview$AddAssets$InvalidFileSize = function (a) {
	return {$: 'InvalidFileSize', a: a};
};
var $author$project$Locations$MediaReview$AddAssets$validateMimeAndSize = F2(
	function (config, file) {
		return (!A2(
			$elm$core$String$startsWith,
			config.mimePrefix,
			$elm$file$File$mime(file))) ? $author$project$Locations$MediaReview$AddAssets$InvalidFileType(file) : ((_Utils_cmp(
			$elm$file$File$size(file),
			config.maxFileSize) > 0) ? $author$project$Locations$MediaReview$AddAssets$InvalidFileSize(file) : $author$project$Locations$MediaReview$AddAssets$ValidFile(file));
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Locations$MediaReview$AddMedia$imageMaxFileSizeBytes = A2($elm$core$Basics$pow, 10, 7);
var $author$project$Locations$MediaReview$AddMedia$videoMaxFileSizeBytes = (75 * 1024) * 1024;
var $author$project$Locations$MediaReview$AddMedia$classifyFile = function (file) {
	var _v0 = $author$project$Locations$MediaReview$AddMedia$fileKind(file);
	if (_v0.$ === 'Just') {
		if (_v0.a.$ === 'ImageKind') {
			var _v1 = _v0.a;
			return A2(
				$author$project$Locations$MediaReview$AddAssets$validateMimeAndSize,
				{mimePrefix: 'image/', maxFileSize: $author$project$Locations$MediaReview$AddMedia$imageMaxFileSizeBytes},
				file);
		} else {
			var _v2 = _v0.a;
			return A2(
				$author$project$Locations$MediaReview$AddAssets$validateMimeAndSize,
				{mimePrefix: 'video/', maxFileSize: $author$project$Locations$MediaReview$AddMedia$videoMaxFileSizeBytes},
				file);
		}
	} else {
		return $author$project$Locations$MediaReview$AddAssets$InvalidFileType(file);
	}
};
var $author$project$Locations$MediaReview$AddAssets$maxNumberOfFiles = 10;
var $author$project$Locations$MediaReview$AddAssets$trackInvalidFile = function (validated) {
	switch (validated.$) {
		case 'ValidFile':
			return $elm$core$Platform$Cmd$none;
		case 'InvalidFileType':
			return $author$project$PlanHat$PlanHat$track(
				{info: '', action: $author$project$PlanHat$TrackingActions$keys.locationDetails.media.fileTypeNotSupported});
		default:
			return $author$project$PlanHat$PlanHat$track(
				{info: '', action: $author$project$PlanHat$TrackingActions$keys.locationDetails.media.fileSizeTooLarge});
	}
};
var $author$project$Locations$MediaReview$MediaToast$create = F2(
	function (icon, _v0) {
		var body = _v0.body;
		var title = _v0.title;
		return {body: body, icon: icon, title: title};
	});
var $author$project$Translations$Listings$AddImage$tooManyFilesBody = F2(
	function (translations, max) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.add_image.too_many_files_body',
			_List_fromArray(
				[
					_Utils_Tuple2('max', max)
				]));
	});
var $author$project$Translations$Listings$AddImage$tooManyFilesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_image.too_many_files_title');
};
var $author$project$Locations$MediaReview$AddMedia$tooManyFilesToast = function (session) {
	return A2(
		$author$project$Locations$MediaReview$MediaToast$create,
		$author$project$PinMeTo$Ui$Toast$FaIcon(
			$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faTriangleExclamation)),
		{
			body: A2(
				$author$project$Translations$Listings$AddImage$tooManyFilesBody,
				session.translations,
				$elm$core$String$fromInt($author$project$Locations$MediaReview$AddAssets$maxNumberOfFiles)),
			title: $author$project$Translations$Listings$AddImage$tooManyFilesTitle(session.translations)
		});
};
var $author$project$Translations$Listings$AddImage$invalidFileSize = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_image.invalid_fileSize');
};
var $author$project$Translations$Listings$MediaReview$imageMaxFileSize = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.image_max_file_size');
};
var $author$project$Translations$Listings$MediaReview$videoMaxFileSize = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.video_max_file_size');
};
var $author$project$FontAwesome$Solid$Icon$faFileCircleXmark = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-file-circle-xmark');
var $author$project$Locations$MediaReview$AddMedia$invalidFileSizeToast = F2(
	function (session, file) {
		return A2(
			$author$project$Locations$MediaReview$MediaToast$create,
			$author$project$PinMeTo$Ui$Toast$FaIcon(
				$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faFileCircleXmark)),
			{
				body: function () {
					var _v0 = $author$project$Locations$MediaReview$AddMedia$fileKind(file);
					if (_v0.$ === 'Just') {
						if (_v0.a.$ === 'ImageKind') {
							var _v1 = _v0.a;
							return $author$project$Translations$Listings$MediaReview$imageMaxFileSize(session.translations);
						} else {
							var _v2 = _v0.a;
							return $author$project$Translations$Listings$MediaReview$videoMaxFileSize(session.translations);
						}
					} else {
						return $author$project$Translations$Listings$AddImage$invalidFileSize(session.translations);
					}
				}(),
				title: $elm$file$File$name(file)
			});
	});
var $author$project$Translations$Listings$AddImage$invalidFileType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_image.invalid_file_type');
};
var $author$project$Locations$MediaReview$AddMedia$invalidFileTypeToast = F2(
	function (session, file) {
		return A2(
			$author$project$Locations$MediaReview$MediaToast$create,
			$author$project$PinMeTo$Ui$Toast$FaIcon(
				$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faFileCircleXmark)),
			{
				body: $author$project$Translations$Listings$AddImage$invalidFileType(session.translations),
				title: $elm$file$File$name(file)
			});
	});
var $author$project$Locations$MediaReview$AddMedia$handleGotFiles = F4(
	function (session, model, file, files) {
		var allFiles = A2($elm$core$List$cons, file, files);
		var classified = A2(
			$elm$core$List$map,
			$author$project$Locations$MediaReview$AddMedia$classifyFile,
			A2(
				$elm$core$List$take,
				$author$project$Locations$MediaReview$AddAssets$maxNumberOfFiles - $elm$core$List$length(model.selectedFiles),
				allFiles));
		var validFiles = A2(
			$elm$core$List$filterMap,
			function (validated) {
				if (validated.$ === 'ValidFile') {
					var f = validated.a;
					return $elm$core$Maybe$Just(f);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			classified);
		var planhatTrackCmds = A2($elm$core$List$map, $author$project$Locations$MediaReview$AddAssets$trackInvalidFile, classified);
		var validationToasts = A2(
			$elm$core$List$filterMap,
			function (validated) {
				switch (validated.$) {
					case 'InvalidFileType':
						var invalidFile = validated.a;
						return $elm$core$Maybe$Just(
							A2($author$project$Locations$MediaReview$AddMedia$invalidFileTypeToast, session, invalidFile));
					case 'InvalidFileSize':
						var invalidFile = validated.a;
						return $elm$core$Maybe$Just(
							A2($author$project$Locations$MediaReview$AddMedia$invalidFileSizeToast, session, invalidFile));
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			classified);
		var totalFileCount = $elm$core$List$length(allFiles) + $elm$core$List$length(model.selectedFiles);
		var tooManyFilesToasts = (_Utils_cmp(totalFileCount, $author$project$Locations$MediaReview$AddAssets$maxNumberOfFiles) > 0) ? _List_fromArray(
			[
				$author$project$Locations$MediaReview$AddMedia$tooManyFilesToast(session)
			]) : _List_Nil;
		var toasts = $elm$core$List$concat(
			_List_fromArray(
				[validationToasts, tooManyFilesToasts, model.toasts]));
		return {
			cmd: $elm$core$Platform$Cmd$batch(
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Locations$MediaReview$AddMedia$uploadFile(session.siteName),
							validFiles),
							planhatTrackCmds
						]))),
			toasts: toasts,
			validFiles: validFiles
		};
	});
var $author$project$Locations$MediaReview$AddAssets$handlePublishOk = F4(
	function (config, published, publishing, selectedFiles) {
		var remainingPublishing = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(published),
			publishing);
		var remainingSelected = A2(
			$elm$core$List$filterMap,
			function (asset) {
				if (asset.$ === 'Local') {
					return $elm$core$Maybe$Just(asset);
				} else {
					var remote = asset.a;
					return _Utils_eq(
						config.getId(remote),
						config.getPublishedId(published)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(asset);
				}
			},
			selectedFiles);
		return {
			publishing: remainingPublishing,
			shouldClose: $elm$core$List$isEmpty(remainingSelected),
			selectedFiles: remainingSelected
		};
	});
var $author$project$Locations$MediaReview$MediaToast$errorIcon = $author$project$PinMeTo$Ui$Toast$FaIcon(
	$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faTriangleExclamation));
var $author$project$Locations$MediaReview$MediaToast$prependError = F3(
	function (title, body, toasts) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Locations$MediaReview$MediaToast$create,
				$author$project$Locations$MediaReview$MediaToast$errorIcon,
				{body: body, title: title}),
			toasts);
	});
var $author$project$Locations$MediaReview$AddAssets$handleUploadErr = function (config) {
	return _Utils_Tuple2(
		A3($author$project$Locations$MediaReview$MediaToast$prependError, config.toastTitle, config.err, config.currentToasts),
		$author$project$PinMeTo$Logger$log(
			{data: config.err, context: config.context, message: 'Failed to upload media to library'}));
};
var $author$project$Locations$MediaReview$AddAssets$assetId = F2(
	function (config, asset) {
		if (asset.$ === 'Uploaded') {
			var remote = asset.a;
			return config.getId(remote);
		} else {
			return '';
		}
	});
var $author$project$Locations$MediaReview$AddAssets$isLocal = function (asset) {
	if (asset.$ === 'Local') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Locations$MediaReview$AddAssets$isRemovable = function (asset) {
	return !$author$project$Locations$MediaReview$AddAssets$isLocal(asset);
};
var $author$project$Locations$MediaReview$AddAssets$removeAssetById = F3(
	function (config, id, assets) {
		return A2(
			$elm$core$List$filter,
			function (asset) {
				return ($author$project$Locations$MediaReview$AddAssets$isRemovable(asset) && (!_Utils_eq(
					A2($author$project$Locations$MediaReview$AddAssets$assetId, config, asset),
					id))) || (!$author$project$Locations$MediaReview$AddAssets$isRemovable(asset));
			},
			assets);
	});
var $author$project$Locations$MediaReview$AddAssets$handlePublishErr = function (config) {
	return _Utils_Tuple3(
		A3(
			$author$project$Locations$MediaReview$MediaToast$prependError,
			config.toastTitle,
			$author$project$Common$HandleResult$httpErrorUserMessage(config.err),
			config.currentToasts),
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(config.published),
			config.publishing),
		$author$project$PinMeTo$Logger$logHttpError(
			{data: config.err, context: config.context, message: config.logMessage}));
};
var $author$project$Locations$MediaReview$AddMedia$OnPublish = F2(
	function (a, b) {
		return {$: 'OnPublish', a: a, b: b};
	});
var $author$project$Locations$MediaReview$AddAssets$publishToGoogleMedia = F3(
	function (config, _v0, locationId) {
		var siteName = _v0.a;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mediaId',
					$elm$json$Json$Encode$string(config.mediaId)),
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string('additional')),
					_Utils_Tuple2(
					'mediaFormat',
					$elm$json$Json$Encode$string(config.mediaFormat))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectWhatever(config.onResult),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$jsonBody(body),
					$lukewestby$elm_http_builder$HttpBuilder$put('/listings/api/' + (siteName + ('/google/media/' + locationId))))));
	});
var $author$project$Locations$MediaReview$AddMedia$publishToNetwork = F3(
	function (siteName, locationId, mediaAsset) {
		return A3(
			$author$project$Locations$MediaReview$AddAssets$publishToGoogleMedia,
			{
				mediaId: mediaAsset.id,
				onResult: $author$project$Locations$MediaReview$AddMedia$OnPublish(mediaAsset),
				mediaFormat: function () {
					var _v0 = mediaAsset.kind;
					if (_v0.$ === 'ImageKind') {
						return 'photo';
					} else {
						return 'video';
					}
				}()
			},
			siteName,
			locationId);
	});
var $author$project$Locations$MediaReview$AddMedia$translateUploadError = F2(
	function (translations, err) {
		return A2($ChristophP$elm_i18next$I18Next$t, translations, err);
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var tail = $elm$core$List$tail(
				A2($elm$core$List$drop, index, l));
			var head = A2($elm$core$List$take, index, l);
			if (tail.$ === 'Nothing') {
				return l;
			} else {
				var t = tail.a;
				return A2($elm$core$List$append, head, t);
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Locations$MediaReview$AddAssets$isLocalNamed = F2(
	function (name, asset) {
		if (asset.$ === 'Local') {
			var file = asset.a;
			return _Utils_eq(
				$elm$file$File$name(file),
				name);
		} else {
			return false;
		}
	});
var $author$project$Locations$MediaReview$AddAssets$removeFirstLocalByName = F2(
	function (name, assets) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$findIndex,
			$author$project$Locations$MediaReview$AddAssets$isLocalNamed(name),
			assets);
		if (_v0.$ === 'Just') {
			var index = _v0.a;
			return A2($elm_community$list_extra$List$Extra$removeAt, index, assets);
		} else {
			return assets;
		}
	});
var $author$project$Locations$MediaReview$AddAssets$replaceFirstLocalByName = F4(
	function (localName, toAsset, remote, assets) {
		if (!assets.b) {
			return _List_Nil;
		} else {
			var asset = assets.a;
			var rest = assets.b;
			if (asset.$ === 'Local') {
				var file = asset.a;
				return _Utils_eq(
					$elm$file$File$name(file),
					localName) ? A2(
					$elm$core$List$cons,
					toAsset(remote),
					rest) : A2(
					$elm$core$List$cons,
					asset,
					A4($author$project$Locations$MediaReview$AddAssets$replaceFirstLocalByName, localName, toAsset, remote, rest));
			} else {
				return A2(
					$elm$core$List$cons,
					asset,
					A4($author$project$Locations$MediaReview$AddAssets$replaceFirstLocalByName, localName, toAsset, remote, rest));
			}
		}
	});
var $author$project$Locations$MediaReview$AddMedia$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'GotFiles':
				var file = msg.a;
				var files = msg.b;
				var intake = A4($author$project$Locations$MediaReview$AddMedia$handleGotFiles, session, model, file, files);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							toasts: intake.toasts,
							selectedFiles: _Utils_ap(
								A2($elm$core$List$map, $author$project$Locations$MediaReview$AddAssets$Local, intake.validFiles),
								model.selectedFiles)
						}),
					intake.cmd);
			case 'Close':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnUploadedFile':
				if (msg.b.$ === 'Ok') {
					var fileName = msg.a;
					var mediaAsset = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								selectedFiles: A4($author$project$Locations$MediaReview$AddAssets$replaceFirstLocalByName, fileName, $author$project$Locations$MediaReview$AddAssets$Uploaded, mediaAsset, model.selectedFiles)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var fileName = msg.a;
					var err = msg.b.a;
					var _v1 = $author$project$Locations$MediaReview$AddAssets$handleUploadErr(
						{
							err: A2($author$project$Locations$MediaReview$AddMedia$translateUploadError, session.translations, err),
							context: 'Locations.MediaReview.AddMedia',
							toastTitle: fileName,
							currentToasts: model.toasts
						});
					var toasts = _v1.a;
					var cmd = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: toasts,
								selectedFiles: A2($author$project$Locations$MediaReview$AddAssets$removeFirstLocalByName, fileName, model.selectedFiles)
							}),
						cmd);
				}
			case 'ClickPublish':
				return $elm$core$List$isEmpty(model.publishing) ? function (uploadedAssets) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{publishing: uploadedAssets}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								A2($author$project$Locations$MediaReview$AddMedia$publishToNetwork, session.siteName, model.locationId),
								uploadedAssets)));
				}(
					$author$project$Locations$MediaReview$AddAssets$uploadedAssets(model.selectedFiles)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnPublish':
				if (msg.b.$ === 'Ok') {
					var mediaAsset = msg.a;
					var result = A4(
						$author$project$Locations$MediaReview$AddAssets$handlePublishOk,
						{
							getId: function ($) {
								return $.id;
							},
							getPublishedId: function ($) {
								return $.id;
							}
						},
						mediaAsset,
						model.publishing,
						model.selectedFiles);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{publishing: result.publishing, selectedFiles: result.selectedFiles}),
						result.shouldClose ? A2(
							$elm$core$Task$perform,
							$elm$core$Basics$identity,
							$elm$core$Task$succeed($author$project$Locations$MediaReview$AddMedia$Close)) : $elm$core$Platform$Cmd$none);
				} else {
					var mediaAsset = msg.a;
					var err = msg.b.a;
					var _v2 = $author$project$Locations$MediaReview$AddAssets$handlePublishErr(
						{
							err: err,
							context: 'Locations.MediaReview.AddMedia',
							published: mediaAsset,
							logMessage: 'Failed to publish media to network',
							publishing: model.publishing,
							toastTitle: $author$project$Translations$Listings$AddImage$failedToUpload(session.translations),
							currentToasts: model.toasts
						});
					var toasts = _v2.a;
					var publishing = _v2.b;
					var cmd = _v2.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{toasts: toasts, publishing: publishing}),
						cmd);
				}
			case 'RemoveAsset':
				var mediaAsset = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedFiles: A3(
								$author$project$Locations$MediaReview$AddAssets$removeAssetById,
								{
									getId: function ($) {
										return $.id;
									}
								},
								mediaAsset.id,
								model.selectedFiles)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ClickDismissToast':
				var toast = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							toasts: A2($author$project$Locations$MediaReview$MediaToast$dismissToast, toast, model.toasts)
						}),
					$elm$core$Platform$Cmd$none);
			case 'PopOverMsg':
				var popOverMsg = msg.a;
				var _v3 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Locations$MediaReview$AddMedia$PopOverMsg, popOverMsg, model.popOverState);
				var popOverState = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: popOverState}),
					cmd);
			default:
				var dropZoneMsg = msg.a;
				var _v4 = A3(
					$author$project$Listings$Ui$DropZone$update,
					{mimes: $author$project$Locations$MediaReview$AddMedia$dropZoneMimes, tagger: $author$project$Locations$MediaReview$AddMedia$DropZoneMsg, onGotFiles: $author$project$Locations$MediaReview$AddMedia$GotFiles},
					dropZoneMsg,
					model.dropZone);
				var newDropZone = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dropZone: newDropZone}),
					cmd);
		}
	});
var $author$project$Locations$MediaReview$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Locations$MediaReview$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Locations$MediaReview$Model$ADDITIONAL = {$: 'ADDITIONAL'};
var $author$project$Locations$MediaReview$Main$mapToMedia = function (x) {
	return {id: x.id, url: x.url, status: x.status, mediaType: x.mediaType, published: x.published, dimensions: x.dimensions, previewUrl: x.url, uploadedBy: x.uploadedBy};
};
var $author$project$Locations$MediaReview$Model$ToastFailed = function (a) {
	return {$: 'ToastFailed', a: a};
};
var $author$project$Locations$MediaReview$Model$ToastPassed = function (a) {
	return {$: 'ToastPassed', a: a};
};
var $author$project$Locations$MediaReview$Model$ToastPending = {$: 'ToastPending'};
var $author$project$Locations$MediaReview$Model$ToastSuccess = {$: 'ToastSuccess'};
var $author$project$Listings$Ui$MediaCard$mediaIdToString = function (_v0) {
	var id = _v0.a;
	return id;
};
var $author$project$Locations$MediaReview$Model$ReloadNetworkMedia = {$: 'ReloadNetworkMedia'};
var $author$project$Locations$MediaReview$Model$OnMediaFlagResponse = function (a) {
	return {$: 'OnMediaFlagResponse', a: a};
};
var $author$project$Locations$MediaReview$Commands$networkMediaCategoryEncoder = function (mediaCategory) {
	var category = function () {
		switch (mediaCategory.$) {
			case 'COVER':
				return 'cover';
			case 'PROFILE':
				return 'profile';
			default:
				return 'additional';
		}
	}();
	return $elm$json$Json$Encode$string(category);
};
var $author$project$Locations$MediaReview$Commands$networkMediaAssetTypeEncoder = function (networkMediaAssetType) {
	var mediaAssetType = function () {
		if (networkMediaAssetType.$ === 'PHOTO') {
			return 'photo';
		} else {
			return 'video';
		}
	}();
	return $elm$json$Json$Encode$string(mediaAssetType);
};
var $author$project$Locations$MediaReview$Commands$mediaUploadBodyEncoder = function (body) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mediaId',
				$elm$json$Json$Encode$string(body.mediaId)),
				_Utils_Tuple2(
				'category',
				$author$project$Locations$MediaReview$Commands$networkMediaCategoryEncoder(body.category)),
				_Utils_Tuple2(
				'mediaFormat',
				$author$project$Locations$MediaReview$Commands$networkMediaAssetTypeEncoder(body.mediaFormat))
			]));
};
var $author$project$Locations$MediaReview$Model$MediaUploadResponse = function (success) {
	return {success: success};
};
var $author$project$Locations$MediaReview$Model$mediaUploadSuccessResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'success',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$MediaUploadResponse));
var $author$project$Locations$MediaReview$Commands$uploadLocationMedia = F6(
	function (_v0, locationId, _v1, mediaType, mediaCategory, msg) {
		var siteName = _v0.a;
		var mediaId = _v1.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Locations$MediaReview$Model$mediaUploadSuccessResponseDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Locations$MediaReview$Commands$mediaUploadBodyEncoder(
						{mediaId: mediaId, category: mediaCategory, mediaFormat: mediaType}),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + ('/google/media/' + locationId)))))));
	});
var $author$project$Locations$MediaReview$Model$LocationInfo = F3(
	function (id, storeId, address) {
		return {id: id, address: address, storeId: storeId};
	});
var $author$project$Locations$MediaReview$Model$Address = F2(
	function (street, city) {
		return {city: city, street: street};
	});
var $author$project$Locations$MediaReview$Model$addressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'city',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'street',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$Address)));
var $author$project$Locations$MediaReview$Model$locationInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'address',
	$elm$json$Json$Decode$nullable($author$project$Locations$MediaReview$Model$addressDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'storeId',
		A2($elm$json$Json$Decode$map, $author$project$Data$Location$StoreId, $elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$LocationInfo))));
var $author$project$Locations$MediaReview$Model$NetworkMediaAssetDetails = F9(
	function (id, assetType, url, publishedAt, createdAt, dimensions, status, location, uploadedBy) {
		return {id: id, url: url, status: status, location: location, assetType: assetType, createdAt: createdAt, dimensions: dimensions, uploadedBy: uploadedBy, publishedAt: publishedAt};
	});
var $author$project$Locations$MediaReview$Model$networkMediaAssetDetailsDecoder = $author$project$Locations$MediaReview$Model$uploadedByTypeDecoder(
	function (uploadedByType) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			uploadedByType,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$elm$json$Json$Decode$nullable($author$project$Locations$MediaReview$Model$locationInfoDecoder),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'status',
					$author$project$Locations$MediaReview$Model$networkMediaAssetStatusDecoder,
					$author$project$Locations$MediaReview$Model$DEFAULT,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'dimensions',
						$author$project$Locations$MediaReview$Model$dimensionsDecoder,
						$author$project$Locations$MediaReview$Model$emptyDimensions,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'publishedAt',
								$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'url',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'assetType',
										$author$project$Locations$MediaReview$Model$networkMediaAssetTypeDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$NetworkMediaAssetDetails))))))))));
	});
var $author$project$Locations$MediaReview$Commands$getMediaAssetDetails = F3(
	function (_v0, _v1, msg) {
		var id = _v0.a;
		var siteName = _v1.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$MediaReview$Model$networkMediaAssetDetailsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/network-media-assets/details/' + id)))));
	});
var $author$project$Locations$MediaReview$Model$OnMediaDeleteResponse = function (a) {
	return {$: 'OnMediaDeleteResponse', a: a};
};
var $author$project$Locations$MediaReview$Model$OnMediaUploadResponse = function (a) {
	return {$: 'OnMediaUploadResponse', a: a};
};
var $author$project$Locations$MediaReview$Commands$statusDecoder = function (status) {
	var isFlagged = function () {
		switch (status.$) {
			case 'FLAGGED':
				return true;
			case 'DEFAULT':
				return false;
			default:
				return false;
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'flagged',
				$elm$json$Json$Encode$bool(isFlagged))
			]));
};
var $author$project$Locations$MediaReview$Commands$flagNetworkMediaAsset = F4(
	function (_v0, status, _v1, msg) {
		var id = _v0.a;
		var siteName = _v1.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					$elm$http$Http$expectString(msg),
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						$author$project$Locations$MediaReview$Commands$statusDecoder(status),
						$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + ('/network-media-assets/flag/' + id)))))));
	});
var $author$project$Locations$MediaReview$Commands$deleteNetworkMediaAsset = F3(
	function (_v0, _v1, msg) {
		var id = _v0.a;
		var siteName = _v1.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					$elm$http$Http$expectString(msg),
					$lukewestby$elm_http_builder$HttpBuilder$delete('api/' + (siteName + ('/network-media-assets/' + id))))));
	});
var $author$project$Translations$Listings$MediaReview$failedToLoadMediaDetails = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.media_review.failed_to_load_media_details');
};
var $author$project$Locations$MediaReview$Model$NetworkMediaAssetDetailsResponse = function (a) {
	return {$: 'NetworkMediaAssetDetailsResponse', a: a};
};
var $author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_onFilter = _Platform_outgoingPort('out_Locations_MediaReview_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackDeleteMedia = _Platform_outgoingPort('out_Locations_MediaReview_Main_TrackDeleteMedia', $elm$json$Json$Encode$string);
var $author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackMediaUploaded = _Platform_outgoingPort(
	'out_Locations_MediaReview_Main_TrackMediaUploaded',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackReportOnNetwork = _Platform_outgoingPort('out_Locations_MediaReview_Main_TrackReportOnNetwork', $elm$json$Json$Encode$string);
var $author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackOpenDetailedView = _Platform_outgoingPort('out_Locations_MediaReview_Main_TrackOpenDetailedView', $elm$json$Json$Encode$string);
var $author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackUploadMediaClicked = _Platform_outgoingPort(
	'out_Locations_MediaReview_Main_TrackUploadMediaClicked',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Locations$MediaReview$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'NetworkMediaAssetResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					var _v1 = model.media;
					if (_v1.$ === 'Loaded') {
						var media = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									count: $author$project$RemoteData$Loaded(x.count),
									media: $author$project$RemoteData$Loaded(
										_Utils_ap(media, x.assets))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									count: $author$project$RemoteData$Loaded(x.count),
									media: $author$project$RemoteData$Loaded(x.assets)
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					var errMsg = $author$project$Common$HandleResult$httpErrorUserMessage(err);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								media: $author$project$RemoteData$Error(errMsg)
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.MediaReview.Main', message: 'Failed to get network media'}));
				}
			case 'NetworkMediaAssetDetailsResponse':
				if (msg.a.$ === 'Ok') {
					var mediaDetails = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detailedMediaToShow: $elm$core$Maybe$Just(mediaDetails)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									$author$project$Locations$MediaReview$Model$ToastFailed(
										$author$project$Translations$Listings$MediaReview$failedToLoadMediaDetails(session.translations)),
									model.toasts)
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.MediaReview.Main', message: 'Failed to get network media details'}));
				}
			case 'SiteProfileImageResponse':
				if (msg.a.$ === 'Ok') {
					var imageUrl = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{siteProfileImageUrl: imageUrl}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.MediaReview.Main', message: 'Failed to get site profile image'}));
				}
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (model_) {
						var _v2 = A5($author$project$Filter$FilterController$update, $author$project$Locations$MediaReview$Model$FilterControllerMsg, msg_, model_, $author$project$Locations$MediaReview$Model$OnFilter, $author$project$Locations$MediaReview$Model$OnSearch);
						var filterControllerModel_ = _v2.a;
						var filterControllerCmd_ = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									filterController: $elm$core$Maybe$Just(filterControllerModel_)
								}),
							filterControllerCmd_);
					},
					model.filterController);
			case 'OnFilter':
				var filterDefinition = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							media: $author$project$RemoteData$Loading,
							pagination: $author$project$Locations$MediaReview$Model$defaultPagination,
							currentFilter: $elm$core$Maybe$Just(filterDefinition)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A5(
								$author$project$Locations$MediaReview$Commands$getNetworkMediaAssets,
								$elm$core$Maybe$Just(filterDefinition),
								$author$project$Locations$MediaReview$Model$defaultPagination,
								session.siteName,
								model.locationId,
								$author$project$Locations$MediaReview$Model$NetworkMediaAssetResponse),
								$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_onFilter(filterDefinition)
							])));
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnMediaClick':
				var media = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Locations$MediaReview$Commands$getMediaAssetDetails, media.id, session.siteName, $author$project$Locations$MediaReview$Model$NetworkMediaAssetDetailsResponse),
								$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackOpenDetailedView(
								$author$project$Listings$Ui$MediaCard$mediaIdToString(media.id))
							])));
			case 'OnMediaDelete':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mediaToDelete: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnMediaDeleteResponse':
				if (msg.a.$ === 'Ok') {
					var id = msg.a.a;
					var _v3 = model.media;
					if (_v3.$ === 'Loaded') {
						var media = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									count: A2(
										$author$project$RemoteData$map,
										function (x) {
											return x - 1;
										},
										model.count),
									media: $author$project$RemoteData$Loaded(
										A2(
											$elm$core$List$filter,
											function (x) {
												return !_Utils_eq(x.id, id);
											},
											media)),
									deletingMedia: false,
									mediaToDelete: $elm$core$Maybe$Nothing,
									detailedMediaToShow: $elm$core$Maybe$Nothing
								}),
							$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackDeleteMedia(id));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								media: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(err))
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.MediaReview.Main', message: 'Failed to delete media asset'}));
				}
			case 'OnMediaFlag':
				var media = msg.a;
				return _Utils_Tuple2(
					model,
					A4($author$project$Locations$MediaReview$Commands$flagNetworkMediaAsset, media.id, media.status, session.siteName, $author$project$Locations$MediaReview$Model$OnMediaFlagResponse));
			case 'OnMediaFlagResponse':
				if (msg.a.$ === 'Ok') {
					var id = msg.a.a;
					var _v4 = model.media;
					if (_v4.$ === 'Loaded') {
						var media = _v4.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									media: $author$project$RemoteData$Loaded(
										A2(
											$elm$core$List$map,
											function (x) {
												return _Utils_eq(x.id, id) ? _Utils_update(
													x,
													{
														status: _Utils_eq(x.status, $author$project$Locations$MediaReview$Model$FLAGGED) ? $author$project$Locations$MediaReview$Model$DEFAULT : $author$project$Locations$MediaReview$Model$FLAGGED
													}) : x;
											},
											media))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								media: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(err))
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.MediaReview.Main', message: 'Failed to flag media asset'}));
				}
			case 'OnMediaReport':
				var media = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackReportOnNetwork(
						$author$project$Listings$Ui$MediaCard$mediaIdToString(media.id)));
			case 'OnCloseLightBox':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mediaToDelete: $elm$core$Maybe$Nothing, detailedMediaToShow: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'OnCloseDeleteMediaAlert':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mediaToDelete: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'ConfirmMediaDelete':
				var media = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{deletingMedia: true}),
					A3($author$project$Locations$MediaReview$Commands$deleteNetworkMediaAsset, media.id, session.siteName, $author$project$Locations$MediaReview$Model$OnMediaDeleteResponse));
			case 'LoadMore':
				var pagination = model.pagination;
				var newPagination = _Utils_update(
					pagination,
					{page: pagination.page + 1});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pagination: newPagination}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A5($author$project$Locations$MediaReview$Commands$getNetworkMediaAssets, model.currentFilter, newPagination, session.siteName, model.locationId, $author$project$Locations$MediaReview$Model$NetworkMediaAssetResponse)
							])));
			case 'RemoveResponseBanner':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{count: $author$project$RemoteData$Suspended, media: $author$project$RemoteData$Suspended}),
					$elm$core$Platform$Cmd$none);
			case 'OnMediaDetailsClick':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnMediaDetailsDelete':
				var mediaDetails = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mediaToDelete: $elm$core$Maybe$Just(
								$author$project$Locations$MediaReview$Main$mapToMedia(mediaDetails))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnMediaDetailsFlag':
				var media = msg.a;
				return _Utils_Tuple2(
					model,
					A4($author$project$Locations$MediaReview$Commands$flagNetworkMediaAsset, media.id, media.status, session.siteName, $author$project$Locations$MediaReview$Model$OnMediaFlagResponse));
			case 'OnMediaDetailsReport':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'ChangeSortOrder':
				var sortOrder = msg.a;
				var pagination = model.pagination;
				var newPagination = _Utils_update(
					pagination,
					{page: 0, sortOrder: sortOrder});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{media: $author$project$RemoteData$Loading, pagination: newPagination}),
					A5($author$project$Locations$MediaReview$Commands$getNetworkMediaAssets, model.currentFilter, newPagination, session.siteName, model.locationId, $author$project$Locations$MediaReview$Model$NetworkMediaAssetResponse));
			case 'AddMediaClicked':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							addMedia: A2(
								$elm$core$Maybe$map,
								function (locationId) {
									return $author$project$Locations$MediaReview$AddMedia$init(locationId).a;
								},
								model.locationId)
						}),
					$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackUploadMediaClicked(_Utils_Tuple0));
			case 'AddMediaMsg':
				var msg_ = msg.a;
				if (msg_.$ === 'Close') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{addMedia: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$Task$perform,
							function (_v6) {
								return $author$project$Locations$MediaReview$Model$ReloadNetworkMedia;
							},
							$elm$core$Process$sleep(3000)));
				} else {
					var _v7 = model.addMedia;
					if (_v7.$ === 'Just') {
						var addMedia = _v7.a;
						var _v8 = A3($author$project$Locations$MediaReview$AddMedia$update, session, msg_, addMedia);
						var newAddMediaModel = _v8.a;
						var addMediaCmd = _v8.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									addMedia: $elm$core$Maybe$Just(newAddMediaModel)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Locations$MediaReview$Model$AddMediaMsg, addMediaCmd));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 'OnMediaUploadPopUpResponse':
				if (msg.a.$ === 'Ok') {
					var mediaResponse = msg.a.a;
					var uploadMediaCmd = function (locationId) {
						return A6($author$project$Locations$MediaReview$Commands$uploadLocationMedia, session.siteName, locationId, mediaResponse.mediaId, $author$project$Locations$MediaReview$Model$PHOTO, $author$project$Locations$MediaReview$Model$ADDITIONAL, $author$project$Locations$MediaReview$Model$OnMediaUploadResponse);
					};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									$author$project$Locations$MediaReview$Model$ToastPassed($author$project$Locations$MediaReview$Model$ToastPending),
									model.toasts)
							}),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							function (locationId) {
								return uploadMediaCmd(locationId);
							},
							model.locationId));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								toasts: A2(
									$elm$core$List$cons,
									$author$project$Locations$MediaReview$Model$ToastFailed(
										$author$project$Translations$General$errorOccurred(session.translations)),
									model.toasts)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnMediaUploadResponse':
				if (msg.a.$ === 'Ok') {
					var cleanedPopUpModel = model;
					return _Utils_Tuple2(
						_Utils_update(
							cleanedPopUpModel,
							{
								toasts: _List_fromArray(
									[
										$author$project$Locations$MediaReview$Model$ToastPassed($author$project$Locations$MediaReview$Model$ToastSuccess)
									])
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackMediaUploaded(_Utils_Tuple0),
									A2(
									$elm$core$Task$perform,
									function (_v9) {
										return $author$project$Locations$MediaReview$Model$ReloadNetworkMedia;
									},
									$elm$core$Process$sleep(5000))
								])));
				} else {
					var err = msg.a.a;
					var cleanedPopUpModel = model;
					return _Utils_Tuple2(
						_Utils_update(
							cleanedPopUpModel,
							{
								toasts: _List_fromArray(
									[
										$author$project$Locations$MediaReview$Model$ToastFailed(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
									])
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Locations$MediaReview$Main$out_Locations_MediaReview_Main_TrackMediaUploaded(_Utils_Tuple0),
									A2(
									$author$project$PinMeTo$ExpectJson$logError,
									$author$project$PinMeTo$ExpectJson$ErrorContext('Locations.MediaReview.Main'),
									err)
								])));
				}
			case 'ReloadNetworkMedia':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{count: $author$project$RemoteData$Loading, media: $author$project$RemoteData$Loading}),
					A5($author$project$Locations$MediaReview$Commands$getNetworkMediaAssets, model.currentFilter, model.pagination, session.siteName, model.locationId, $author$project$Locations$MediaReview$Model$NetworkMediaAssetResponse));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							toasts: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$elm$core$List$tail(model.toasts))
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Locations$MediaReview$Main$Flags = F5(
	function (filter, initialFilter, query, locationId, locationEnabled) {
		return {query: query, filter: filter, locationId: locationId, initialFilter: initialFilter, locationEnabled: locationEnabled};
	});
var $author$project$Locations$MediaReview$Main$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'locationEnabled',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'locationId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'query',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'initialFilter',
				$elm$json$Json$Decode$nullable(
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'filter',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$value),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Main$Flags))))));
var $author$project$Locations$MediaReview$AddMedia$subscriptions = function (model) {
	return A2($author$project$PinMeTo$Ui$PopOver$subscriptions, model.popOverState, $author$project$Locations$MediaReview$AddMedia$PopOverMsg);
};
var $author$project$Locations$MediaReview$Model$OnMediaUploadPopUpResponse = function (a) {
	return {$: 'OnMediaUploadPopUpResponse', a: a};
};
var $author$project$Locations$MediaReview$Model$MediaUploadPopUpResponse = F2(
	function (mediaId, locationId) {
		return {mediaId: mediaId, locationId: locationId};
	});
var $author$project$Locations$MediaReview$Model$mediaUploadPopUpResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'locationId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mediaId',
		A2($elm$json$Json$Decode$map, $author$project$Listings$Ui$MediaCard$MediaId, $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Locations$MediaReview$Model$MediaUploadPopUpResponse)));
var $author$project$Locations$MediaReview$Main$in_Locations_MediaReview_Main_angularPopupUpdated = _Platform_incomingPort('in_Locations_MediaReview_Main_angularPopupUpdated', $elm$json$Json$Decode$value);
var $author$project$Locations$MediaReview$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Locations$MediaReview$Main$in_Locations_MediaReview_Main_angularPopupUpdated(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Locations$MediaReview$Model$mediaUploadPopUpResponseDecoder),
					$author$project$Locations$MediaReview$Model$OnMediaUploadPopUpResponse)),
				function () {
				var _v0 = model.addMedia;
				if (_v0.$ === 'Just') {
					var addMedia = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Locations$MediaReview$Model$AddMediaMsg,
						$author$project$Locations$MediaReview$AddMedia$subscriptions(addMedia));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Locations$MediaReview$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Locations$MediaReview$Main$init, view: $author$project$Locations$MediaReview$Main$view, update: $author$project$Locations$MediaReview$Main$update, flagsDecoder: $author$project$Locations$MediaReview$Main$flagsDecoder, subscriptions: $author$project$Locations$MediaReview$Main$subscriptions});
var $author$project$Listings$Ui$OpenHours$init = function (openHours) {
	return _Utils_Tuple2(
		{error: $elm$core$Maybe$Nothing, openHours: openHours, bufferOpenHours: openHours, initialOpenHours: openHours},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Locations$AddLocation$Model$Storefront = {$: 'Storefront'};
var $author$project$Locations$AddLocation$Model$OpenHoursMsg = function (a) {
	return {$: 'OpenHoursMsg', a: a};
};
var $author$project$Listings$Ui$AutoComplete$defaultModel = {
	index: $elm$core$Maybe$Nothing,
	values: _List_Nil,
	visible: false,
	selected: $elm$core$Maybe$Nothing,
	inputValue: $author$project$Common$Form$Clean(''),
	multiValues: false
};
var $author$project$Locations$AddLocation$Model$CountryName = function (name) {
	return {name: name};
};
var $author$project$Locations$AddLocation$Commands$decodeCountryName = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$CountryName));
var $author$project$Locations$AddLocation$Commands$decodeCountryNames = $elm$json$Json$Decode$list($author$project$Locations$AddLocation$Commands$decodeCountryName);
var $author$project$Locations$AddLocation$Commands$getCountries = function (msg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($elm$http$Http$expectJson, msg, $author$project$Locations$AddLocation$Commands$decodeCountryNames),
			$lukewestby$elm_http_builder$HttpBuilder$get('/listings/api/countries/')));
};
var $author$project$Translations$General$fieldIsRequired = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.field_is_required');
};
var $author$project$Locations$AddLocation$Main$required = function (input) {
	return (!$elm$core$String$length(input)) ? $elm$core$Result$Err($author$project$Translations$General$fieldIsRequired) : $elm$core$Result$Ok(input);
};
var $author$project$Locations$AddLocation$Main$zipValidators = function (req) {
	if (req.$ === 'ZipRequired') {
		return _List_fromArray(
			[$author$project$Locations$AddLocation$Main$required]);
	} else {
		return _List_fromArray(
			[
				function (input) {
				return $elm$core$Result$Ok(input);
			}
			]);
	}
};
var $author$project$Locations$AddLocation$Model$ZipNotRequired = {$: 'ZipNotRequired'};
var $author$project$Locations$AddLocation$Main$cityValidators = _List_fromArray(
	[$author$project$Locations$AddLocation$Main$required]);
var $author$project$Locations$AddLocation$Model$RawCountry = function (name) {
	return function (countryName) {
		return function (alternateCountryNames) {
			return function (countryShortCode) {
				return function (iso) {
					return function (iso3) {
						return function (postalCodeFormat) {
							return function (postalCodeRegex) {
								return function (countryCallingCodes) {
									return function (languages) {
										return function (regions) {
											return {iso: iso, iso3: iso3, name: name, regions: regions, languages: languages, countryName: countryName, postalCodeRegex: postalCodeRegex, countryShortCode: countryShortCode, postalCodeFormat: postalCodeFormat, countryCallingCodes: countryCallingCodes, alternateCountryNames: alternateCountryNames};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Locations$AddLocation$Model$Region = F3(
	function (name, alternateNames, localizedNames) {
		return {name: name, alternateNames: alternateNames, localizedNames: localizedNames};
	});
var $author$project$Locations$AddLocation$Model$LocalizedName = F2(
	function (isoLanguage, name) {
		return {name: name, isoLanguage: isoLanguage};
	});
var $author$project$Locations$AddLocation$Commands$decodeLocalizedName = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isoLanguage',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$LocalizedName)));
var $author$project$Locations$AddLocation$Commands$decodeRegion = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'localizedNames',
	$elm$json$Json$Decode$list($author$project$Locations$AddLocation$Commands$decodeLocalizedName),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'alternateNames',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$Region))));
var $author$project$Locations$AddLocation$Commands$decodeCountry = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'regions',
	$elm$json$Json$Decode$list($author$project$Locations$AddLocation$Commands$decodeRegion),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'languages',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'countryCallingCodes',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'postalCodeRegex',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'postalCodeFormat',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'ISO3',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ISO',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'countryShortCode',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'alternateCountryNames',
									$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'countryName',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$RawCountry))))))))))));
var $author$project$Locations$AddLocation$Model$RawCountryData = F3(
	function (countriesRequiresRegion, countries, countriesNotRequireZip) {
		return {countries: countries, countriesNotRequireZip: countriesNotRequireZip, countriesRequiresRegion: countriesRequiresRegion};
	});
var $author$project$Locations$AddLocation$Commands$decodeCountryData = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'countriesNotRequireZip',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'countries',
		$elm$json$Json$Decode$list($author$project$Locations$AddLocation$Commands$decodeCountry),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'countriesRequiresRegion',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$RawCountryData))));
var $author$project$Locations$AddLocation$Commands$getCountryData = function (msg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($elm$http$Http$expectJson, msg, $author$project$Locations$AddLocation$Commands$decodeCountryData),
			$lukewestby$elm_http_builder$HttpBuilder$get('/listings/api/countrydata/')));
};
var $author$project$Locations$AddLocation$Model$CountriesLoaded = function (a) {
	return {$: 'CountriesLoaded', a: a};
};
var $author$project$Locations$AddLocation$Model$RegionRequired = {$: 'RegionRequired'};
var $author$project$Locations$AddLocation$Main$regionValidators = function (req) {
	return _List_fromArray(
		[
			function (model) {
			return (_Utils_eq(req, $author$project$Locations$AddLocation$Model$RegionRequired) && $elm_community$maybe_extra$Maybe$Extra$isNothing(model.selected)) ? $elm$core$Result$Err($author$project$Translations$General$fieldIsRequired) : $elm$core$Result$Ok(model);
		}
		]);
};
var $author$project$Locations$AddLocation$Main$streetValidators = _List_fromArray(
	[$author$project$Locations$AddLocation$Main$required]);
var $author$project$Locations$AddLocation$Model$CountryDataLoaded = function (a) {
	return {$: 'CountryDataLoaded', a: a};
};
var $author$project$Locations$AddLocation$Model$RegionNotRequired = {$: 'RegionNotRequired'};
var $author$project$Locations$AddLocation$Main$countryValidators = _List_fromArray(
	[
		function (model) {
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(model.selected) ? $elm$core$Result$Err($author$project$Translations$General$fieldIsRequired) : $elm$core$Result$Ok(model);
	}
	]);
var $author$project$Translations$Listings$AddLocation$maximumLength = F2(
	function (translations, maxLength) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.add_location.maximum_length',
			_List_fromArray(
				[
					_Utils_Tuple2('maxLength', maxLength)
				]));
	});
var $author$project$Locations$AddLocation$Main$maxLength = F2(
	function (max, input) {
		return (_Utils_cmp(
			$elm$core$String$length(input),
			max) > 0) ? $elm$core$Result$Err(
			A2(
				$author$project$Util$flip,
				$author$project$Translations$Listings$AddLocation$maximumLength,
				$elm$core$String$fromInt(max))) : $elm$core$Result$Ok(input);
	});
var $author$project$Translations$Listings$AddLocation$safeInput = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.safe_input');
};
var $author$project$Locations$AddLocation$Main$csvInjectionSafe = function (input) {
	return $author$project$Common$Validators$CsvInjection$isInputValid(input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err($author$project$Translations$Listings$AddLocation$safeInput);
};
var $author$project$Locations$AddLocation$Main$storeIdValidators = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$required,
		$author$project$Locations$AddLocation$Main$csvInjectionSafe,
		$author$project$Locations$AddLocation$Main$maxLength(40)
	]);
var $author$project$Translations$Listings$AddLocation$coordinateNeedsToBeMost = F2(
	function (translations, maximum) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.add_location.coordinate_needs_to_be_most',
			_List_fromArray(
				[
					_Utils_Tuple2('maximum', maximum)
				]));
	});
var $author$project$Translations$Listings$AddLocation$coordinateNeedsToBeLeast = F2(
	function (translations, minimum) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.add_location.coordinate_needs_to_be_least',
			_List_fromArray(
				[
					_Utils_Tuple2('minimum', minimum)
				]));
	});
var $author$project$Locations$AddLocation$Main$validCoordinate = F3(
	function (min, max, input) {
		return (_Utils_cmp(input, min) < 0) ? $elm$core$Result$Err(
			A2(
				$author$project$Util$flip,
				$author$project$Translations$Listings$AddLocation$coordinateNeedsToBeLeast,
				$elm$core$String$fromFloat(min))) : ((_Utils_cmp(input, max) > 0) ? $elm$core$Result$Err(
			A2(
				$author$project$Util$flip,
				$author$project$Translations$Listings$AddLocation$coordinateNeedsToBeMost,
				$elm$core$String$fromFloat(max))) : $elm$core$Result$Ok(input));
	});
var $author$project$Translations$Listings$AddLocation$invalidCoordinate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.invalid_coordinate');
};
var $author$project$Locations$AddLocation$Main$validCoordinateString = F3(
	function (min, max, input) {
		var _v0 = $elm$core$String$toFloat(input);
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A2(
				$elm$core$Result$map,
				$elm$core$String$fromFloat,
				A3($author$project$Locations$AddLocation$Main$validCoordinate, min, max, value));
		} else {
			return $elm$core$Result$Err($author$project$Translations$Listings$AddLocation$invalidCoordinate);
		}
	});
var $author$project$Locations$AddLocation$Main$latitudeValidators = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$required,
		A2($author$project$Locations$AddLocation$Main$validCoordinateString, -90, 90)
	]);
var $author$project$Locations$AddLocation$Main$longitudeValidators = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$required,
		A2($author$project$Locations$AddLocation$Main$validCoordinateString, -180, 180)
	]);
var $author$project$Locations$AddLocation$Model$ServiceAreaSelectorMsg = function (a) {
	return {$: 'ServiceAreaSelectorMsg', a: a};
};
var $author$project$Locations$AddLocation$Main$storefrontNameValidators = _List_fromArray(
	[$author$project$Locations$AddLocation$Main$required, $author$project$Locations$AddLocation$Main$csvInjectionSafe]);
var $author$project$Locations$AddLocation$Main$initialModel = F3(
	function (session, chainName, displayName) {
		var _v0 = $author$project$Common$ServiceAreaSelectorV2$Update$init(session);
		var serviceAreaSelectorModel = _v0.a;
		var serviceAreaSelectorCmd = _v0.b;
		var initialOpenHours = $author$project$Data$Location$OpenHours$During(
			{fri: $author$project$Data$Location$OpenHours$NotSpecified, mon: $author$project$Data$Location$OpenHours$NotSpecified, sat: $author$project$Data$Location$OpenHours$NotSpecified, sun: $author$project$Data$Location$OpenHours$NotSpecified, thu: $author$project$Data$Location$OpenHours$NotSpecified, tue: $author$project$Data$Location$OpenHours$NotSpecified, wed: $author$project$Data$Location$OpenHours$NotSpecified});
		var _v1 = $author$project$Listings$Ui$OpenHours$init(initialOpenHours);
		var openHoursModel = _v1.a;
		var openHoursCmd = _v1.b;
		var nameToDisplay = $elm$core$String$isEmpty(chainName) ? displayName : chainName;
		return _Utils_Tuple2(
			{
				zip: $author$project$Common$Form$Clean(
					A2(
						$author$project$Common$Validators$ValidatedItem$validate,
						$author$project$Locations$AddLocation$Main$zipValidators($author$project$Locations$AddLocation$Model$ZipNotRequired),
						'')),
				city: $author$project$Common$Form$Clean(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$cityValidators, '')),
				email: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				phone: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				region: A2(
					$author$project$Common$Validators$ValidatedItem$validate,
					$author$project$Locations$AddLocation$Main$regionValidators($author$project$Locations$AddLocation$Model$RegionNotRequired),
					$author$project$Listings$Ui$AutoComplete$defaultModel),
				street: $author$project$Common$Form$Clean(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$streetValidators, '')),
				country: A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$countryValidators, $author$project$Listings$Ui$AutoComplete$defaultModel),
				storeId: $author$project$Common$Form$Clean(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$storeIdValidators, '')),
				homepage: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				latitude: $author$project$Common$Form$Clean(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$latitudeValidators, '')),
				wifiSsid: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				chainName: chainName,
				longitude: $author$project$Common$Form$Clean(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$longitudeValidators, '')),
				openHours: openHoursModel,
				countryData: $elm$core$Dict$empty,
				displayName: displayName,
				emailBlurred: false,
				errorMessage: $elm$core$Maybe$Nothing,
				locationType: $author$project$Locations$AddLocation$Model$Storefront,
				phoneBlurred: false,
				ptvCustomName: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				regionOptions: $elm$core$Dict$empty,
				geocodingError: $elm$core$Maybe$Nothing,
				storefrontName: $author$project$Common$Form$Clean(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$storefrontNameValidators, nameToDisplay)),
				successMessage: $elm$core$Maybe$Nothing,
				uiPopOverState: $author$project$PinMeTo$Ui$PopOver$init,
				appleCustomName: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				homepageBlurred: false,
				longDescription: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				googleCustomName: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				shortDescription: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				storeOpeningDate: $elm$core$Maybe$Nothing,
				facebookCustomName: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				serviceAreaSelector: serviceAreaSelectorModel,
				longDescriptionState: $author$project$PinMeTo$Ui$Form$Textarea$init,
				canGeocodeFromAddress: false,
				isGeocodingInProgress: false,
				shortDescriptionState: $author$project$PinMeTo$Ui$Form$Textarea$init,
				storeLocationDescriptor: $author$project$Common$Validators$ValidatedItem$ValidItem(''),
				uiConfirmationModalShown: false,
				longDescriptionCharOverLimit: false,
				shortDescriptionCharOverLimit: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Locations$AddLocation$Commands$getCountryData($author$project$Locations$AddLocation$Model$CountryDataLoaded),
								$author$project$Locations$AddLocation$Commands$getCountries($author$project$Locations$AddLocation$Model$CountriesLoaded)
							])),
						A2($elm$core$Platform$Cmd$map, $author$project$Locations$AddLocation$Model$OpenHoursMsg, openHoursCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Locations$AddLocation$Model$ServiceAreaSelectorMsg, serviceAreaSelectorCmd)
					])));
	});
var $author$project$Locations$AddLocation$Main$init = F2(
	function (session, flags) {
		return A3($author$project$Locations$AddLocation$Main$initialModel, session, flags.chainName, flags.displayName);
	});
var $author$project$Translations$Listings$AddLocation$city = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.city');
};
var $author$project$PinMeTo$Ui$Form$Input$Number = {$: 'Number'};
var $author$project$PinMeTo$Ui$Form$Input$number = function (config_) {
	return $author$project$PinMeTo$Ui$Form$Input$Input(
		A2($author$project$PinMeTo$Ui$Form$Input$configWithType, $author$project$PinMeTo$Ui$Form$Input$Number, config_));
};
var $author$project$Translations$Listings$AddLocation$region = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.region');
};
var $author$project$Translations$Listings$AddLocation$street = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.street');
};
var $author$project$Common$Form$unwrap = A2($elm$core$Basics$composeR, $author$project$Common$Form$unwrapFormState, $author$project$Common$Validators$ValidatedItem$unwrap);
var $author$project$Translations$Listings$AddLocation$country = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.country');
};
var $author$project$Translations$Listings$AddLocation$zipCode = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.zip_code');
};
var $author$project$Translations$Listings$AddLocation$latitude = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.latitude');
};
var $author$project$PinMeTo$Ui$Form$Input$withStep = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					step: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$PinMeTo$Ui$Form$Input$FloatStep = function (a) {
	return {$: 'FloatStep', a: a};
};
var $author$project$Translations$Listings$AddLocation$geocoding = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.geocoding');
};
var $author$project$Translations$Listings$AddLocation$longitude = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.longitude');
};
var $author$project$Listings$Ui$AutoComplete$withLabel = F2(
	function (label, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{
					label: $elm$core$Maybe$Just(label)
				}));
	});
var $author$project$Locations$AddLocation$Model$ZipChanged = function (a) {
	return {$: 'ZipChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$CityChanged = function (a) {
	return {$: 'CityChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$MapPinMoved = F2(
	function (a, b) {
		return {$: 'MapPinMoved', a: a, b: b};
	});
var $author$project$Translations$Listings$AddLocation$couldNotFind = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.could_not_find');
};
var $author$project$Locations$AddLocation$Model$RegionChanged = function (a) {
	return {$: 'RegionChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$StreetChanged = function (a) {
	return {$: 'StreetChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$CountryChanged = function (a) {
	return {$: 'CountryChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$getCountryName = function (model) {
	return $author$project$Common$Form$unwrapFormState(
		$author$project$Common$Validators$ValidatedItem$unwrap(model.country).inputValue);
};
var $author$project$Translations$Listings$AddLocation$getFromAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.get_from_address');
};
var $author$project$Locations$AddLocation$Model$LatInputChanged = function (a) {
	return {$: 'LatInputChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$LonInputChanged = function (a) {
	return {$: 'LonInputChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$cityPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.city_placeholder');
};
var $author$project$Common$Validators$ValidatedItem$unwrapError = function (item) {
	if (item.$ === 'ValidItem') {
		return $elm$core$Maybe$Nothing;
	} else {
		var err = item.a;
		return $elm$core$Maybe$Just(err);
	}
};
var $author$project$Common$Form$unwrapFormError = function (field) {
	if (field.$ === 'Clean') {
		return $elm$core$Maybe$Nothing;
	} else {
		var value = field.a;
		return $author$project$Common$Validators$ValidatedItem$unwrapError(value);
	}
};
var $author$project$Listings$Ui$AutoComplete$withFindMatches = F2(
	function (doFindMatches, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{doFindMatches: doFindMatches}));
	});
var $author$project$Locations$AddLocation$View$applyTranslations = F2(
	function (translations, translatedString) {
		return translatedString(translations);
	});
var $author$project$Translations$Listings$AddLocation$regionPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.region_placeholder');
};
var $author$project$Locations$AddLocation$Model$regionRequirement = F2(
	function (countryName, countryData) {
		var maybeCountry = A2($elm$core$Dict$get, countryName, countryData);
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Locations$AddLocation$Model$RegionNotRequired,
			A2(
				$elm$core$Maybe$andThen,
				function (c) {
					return c.requiresRegions ? $elm$core$Maybe$Just($author$project$Locations$AddLocation$Model$RegionRequired) : $elm$core$Maybe$Nothing;
				},
				maybeCountry));
	});
var $author$project$Translations$Listings$AddLocation$storefrontAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.storefront_address');
};
var $author$project$Translations$Listings$AddLocation$streetPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.street_placeholder');
};
var $author$project$Listings$Ui$AutoComplete$withRequiredLabel = F2(
	function (label, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{
					requiredLabel: $elm$core$Maybe$Just(label)
				}));
	});
var $author$project$Translations$Listings$AddLocation$countryPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.country_placeholder');
};
var $author$project$Translations$Listings$AddLocation$zipCodePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.zip_code_placeholder');
};
var $author$project$Locations$AddLocation$Model$GetFromAddressClicked = {$: 'GetFromAddressClicked'};
var $author$project$PinMeTo$Ui$Form$Input$withClearButtonDisabled = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Form$Input$Input(
		_Utils_update(
			config,
			{clearButtonEnabled: false}));
};
var $author$project$Locations$AddLocation$Model$StorefrontAndServiceArea = {$: 'StorefrontAndServiceArea'};
var $author$project$Locations$AddLocation$View$address = F2(
	function (session, model) {
		var getFromAddressButton = $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				(!model.canGeocodeFromAddress) || model.isGeocodingInProgress,
				A2(
					$author$project$PinMeTo$Ui$Button$withSecondaryStyle,
					$author$project$PinMeTo$Ui$Button$SecondaryDefault,
					A2(
						$author$project$PinMeTo$Ui$Button$withSize,
						$author$project$PinMeTo$Ui$Button$Medium,
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Locations$AddLocation$Model$GetFromAddressClicked,
							$author$project$PinMeTo$Ui$Button$buttonSecondary(
								model.isGeocodingInProgress ? $author$project$Translations$Listings$AddLocation$geocoding(session.translations) : $author$project$Translations$Listings$AddLocation$getFromAddress(session.translations)))))));
		var translateError = $elm$core$Maybe$map(
			$author$project$Locations$AddLocation$View$applyTranslations(session.translations));
		var unwrappedLon = $author$project$Common$Form$unwrap(model.longitude);
		var unwrappedLat = $author$project$Common$Form$unwrap(model.latitude);
		var countryInput = A2(
			$author$project$Listings$Ui$AutoComplete$render,
			$author$project$Common$Validators$ValidatedItem$unwrap(model.country),
			A2(
				$author$project$Listings$Ui$AutoComplete$withPlaceholder,
				$author$project$Translations$Listings$AddLocation$countryPlaceholder(session.translations),
				A2(
					$author$project$Listings$Ui$AutoComplete$withLabel,
					$author$project$Translations$Listings$AddLocation$country(session.translations),
					A2(
						$author$project$Listings$Ui$AutoComplete$withRequiredLabel,
						$author$project$Translations$General$fieldIsRequired(session.translations),
						A2(
							$author$project$Listings$Ui$AutoComplete$withIsRequired,
							true,
							A2(
								$author$project$Listings$Ui$AutoComplete$withFindMatches,
								true,
								A2(
									$author$project$Listings$Ui$AutoComplete$view,
									$author$project$Locations$AddLocation$Model$CountryChanged,
									$author$project$Listings$Ui$AutoComplete$NodeId('country'))))))));
		var streetInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withError,
				translateError(
					$author$project$Common$Form$unwrapFormError(model.street)),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withRequired,
					true,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$AddLocation$streetPlaceholder(session.translations),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$street(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Form$unwrap(model.street),
									onChange: $author$project$Locations$AddLocation$Model$StreetChanged
								}))))));
		var regionInput = A2(
			$author$project$Listings$Ui$AutoComplete$render,
			$author$project$Common$Validators$ValidatedItem$unwrap(model.region),
			A2(
				$author$project$Listings$Ui$AutoComplete$withPlaceholder,
				$author$project$Translations$Listings$AddLocation$regionPlaceholder(session.translations),
				A2(
					$author$project$Listings$Ui$AutoComplete$withIsRequired,
					_Utils_eq(
						A2(
							$author$project$Locations$AddLocation$Model$regionRequirement,
							$author$project$Locations$AddLocation$Model$getCountryName(model),
							model.countryData),
						$author$project$Locations$AddLocation$Model$RegionRequired),
					A2(
						$author$project$Listings$Ui$AutoComplete$withLabel,
						$author$project$Translations$Listings$AddLocation$region(session.translations),
						A2(
							$author$project$Listings$Ui$AutoComplete$withRequiredLabel,
							$author$project$Translations$General$fieldIsRequired(session.translations),
							A2(
								$author$project$Listings$Ui$AutoComplete$withIsRequired,
								true,
								A2(
									$author$project$Listings$Ui$AutoComplete$withFindMatches,
									true,
									A2(
										$author$project$Listings$Ui$AutoComplete$view,
										$author$project$Locations$AddLocation$Model$RegionChanged,
										$author$project$Listings$Ui$AutoComplete$NodeId('region')))))))));
		var cityInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withError,
				translateError(
					$author$project$Common$Form$unwrapFormError(model.city)),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withRequired,
					true,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$AddLocation$cityPlaceholder(session.translations),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$city(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Form$unwrap(model.city),
									onChange: $author$project$Locations$AddLocation$Model$CityChanged
								}))))));
		var zipInput = function () {
			var countryName = $author$project$Locations$AddLocation$Model$getCountryName(model);
			var requiresZip = function () {
				var _v1 = A2($elm$core$Dict$get, countryName, model.countryData);
				if (_v1.$ === 'Just') {
					var country = _v1.a;
					return country.requiresZip;
				} else {
					return true;
				}
			}();
			return $author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withError,
					translateError(
						$author$project$Common$Form$unwrapFormError(model.zip)),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withRequired,
						requiresZip,
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
							$author$project$Translations$Listings$AddLocation$zipCodePlaceholder(session.translations),
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withLabel,
								$author$project$Translations$Listings$AddLocation$zipCode(session.translations),
								$author$project$PinMeTo$Ui$Form$Input$text(
									{
										value: $author$project$Common$Form$unwrap(model.zip),
										onChange: $author$project$Locations$AddLocation$Model$ZipChanged
									}))))));
		}();
		var lonInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withError,
				translateError(
					$author$project$Common$Form$unwrapFormError(model.longitude)),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withStep,
					$author$project$PinMeTo$Ui$Form$Input$FloatStep(0.000001),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withRequired,
						true,
						$author$project$PinMeTo$Ui$Form$Input$withClearButtonDisabled(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withLabel,
								$author$project$Translations$Listings$AddLocation$longitude(session.translations),
								$author$project$PinMeTo$Ui$Form$Input$number(
									{value: unwrappedLon, onChange: $author$project$Locations$AddLocation$Model$LonInputChanged})))))));
		var latInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withError,
				translateError(
					$author$project$Common$Form$unwrapFormError(model.latitude)),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withStep,
					$author$project$PinMeTo$Ui$Form$Input$FloatStep(0.000001),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withRequired,
						true,
						$author$project$PinMeTo$Ui$Form$Input$withClearButtonDisabled(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withLabel,
								$author$project$Translations$Listings$AddLocation$latitude(session.translations),
								$author$project$PinMeTo$Ui$Form$Input$number(
									{value: unwrappedLat, onChange: $author$project$Locations$AddLocation$Model$LatInputChanged})))))));
		var map = $author$project$PinMeTo$Ui$Map$render(
			A2(
				$author$project$PinMeTo$Ui$Map$withOnChange,
				$author$project$Locations$AddLocation$Model$MapPinMoved,
				A2(
					$author$project$PinMeTo$Ui$Map$withZoom,
					19,
					$author$project$PinMeTo$Ui$Map$view(
						_List_fromArray(
							[
								A2(
								$author$project$PinMeTo$Ui$Map$withPinDraggable,
								true,
								$author$project$PinMeTo$Ui$Map$pin(
									{
										lat: A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toFloat(unwrappedLat)),
										lon: A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toFloat(unwrappedLon))
									}))
							])))));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-add-location__section--hidden',
							!(_Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$StorefrontAndServiceArea) || _Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$Storefront)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-subheading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$storefrontAddress(session.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[streetInput]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[countryInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[regionInput]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[cityInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[zipInput]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[latInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[lonInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__get-from-address-button-container')
								]),
							_List_fromArray(
								[getFromAddressButton]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__map-container')
						]),
					_List_fromArray(
						[map])),
					function () {
					var _v0 = model.geocodingError;
					if (_v0.$ === 'Just') {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form__error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$AddLocation$couldNotFind(session.translations))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Translations$Listings$AddLocation$discard = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.discard');
};
var $author$project$Translations$Listings$AddLocation$createLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.create_locations');
};
var $author$project$Locations$AddLocation$Model$ClearFormClicked = {$: 'ClearFormClicked'};
var $author$project$Listings$Ui$OpenHours$isAlwaysOpen = function (model) {
	var _v0 = model.openHours;
	if (_v0.$ === 'Always') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Listings$Ui$OpenHours$Fri = {$: 'Fri'};
var $author$project$Listings$Ui$OpenHours$Mon = {$: 'Mon'};
var $author$project$Listings$Ui$OpenHours$Sat = {$: 'Sat'};
var $author$project$Listings$Ui$OpenHours$Sun = {$: 'Sun'};
var $author$project$Listings$Ui$OpenHours$Thu = {$: 'Thu'};
var $author$project$Listings$Ui$OpenHours$Tue = {$: 'Tue'};
var $author$project$Listings$Ui$OpenHours$Wed = {$: 'Wed'};
var $author$project$Listings$Ui$OpenHours$timeOverlapping = F2(
	function (span1, span2) {
		var span2Close = A2(
			$elm$core$Maybe$withDefault,
			-1,
			$elm$core$String$toInt(span2.close));
		return ((_Utils_cmp(span1.open, span2.close) < 1) && (_Utils_cmp(span1.open, span2.open) > -1)) || (((_Utils_cmp(span1.close, span2.close) < 0) && (_Utils_cmp(span1.close, span2.open) > -1)) || (((_Utils_cmp(span2.close, span1.close) < 1) && (span2Close > 1159)) || ((span1.open === '2400') || (span2.open === '2400'))));
	});
var $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay = function (spanList) {
	var tempList = A2(
		$elm$core$List$indexedMap,
		F2(
			function (outerIndex, outerSpan) {
				return A2(
					$elm$core$List$map,
					function (innerSpan) {
						return A2($author$project$Listings$Ui$OpenHours$timeOverlapping, outerSpan, innerSpan);
					},
					A2($elm$core$List$drop, outerIndex + 1, spanList));
			}),
		spanList);
	var resultList = $elm$core$List$concat(tempList);
	return A2($elm$core$List$member, true, resultList);
};
var $author$project$Listings$Ui$OpenHours$overlapValidationErrors = function (model) {
	var getSpanList = function (day) {
		if (day.$ === 'Open') {
			var spanList = day.a;
			return spanList;
		} else {
			return _List_Nil;
		}
	};
	var _v0 = model.openHours;
	if (_v0.$ === 'During') {
		var days = _v0.a;
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.day;
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.hasError;
				},
				_List_fromArray(
					[
						{
						day: $author$project$Listings$Ui$OpenHours$Mon,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.mon))
					},
						{
						day: $author$project$Listings$Ui$OpenHours$Tue,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.tue))
					},
						{
						day: $author$project$Listings$Ui$OpenHours$Wed,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.wed))
					},
						{
						day: $author$project$Listings$Ui$OpenHours$Thu,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.thu))
					},
						{
						day: $author$project$Listings$Ui$OpenHours$Fri,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.fri))
					},
						{
						day: $author$project$Listings$Ui$OpenHours$Sat,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.sat))
					},
						{
						day: $author$project$Listings$Ui$OpenHours$Sun,
						hasError: $author$project$Listings$Ui$OpenHours$checkOverlappingPerDay(
							getSpanList(days.sun))
					}
					])));
	} else {
		return _List_Nil;
	}
};
var $author$project$Listings$Ui$OpenHours$getDaysWithErrors = F2(
	function (translations, model) {
		var errorDays = A2(
			$elm$core$List$map,
			function (day) {
				switch (day.$) {
					case 'Mon':
						return $author$project$Translations$General$mon(translations);
					case 'Tue':
						return $author$project$Translations$General$tue(translations);
					case 'Wed':
						return $author$project$Translations$General$wed(translations);
					case 'Thu':
						return $author$project$Translations$General$thu(translations);
					case 'Fri':
						return $author$project$Translations$General$fri(translations);
					case 'Sat':
						return $author$project$Translations$General$sat(translations);
					default:
						return $author$project$Translations$General$sun(translations);
				}
			},
			$author$project$Listings$Ui$OpenHours$overlapValidationErrors(model));
		return errorDays;
	});
var $author$project$Listings$Ui$OpenHours$validateOpenHours = F2(
	function (translations, model) {
		var errorDays = A2($author$project$Listings$Ui$OpenHours$getDaysWithErrors, translations, model);
		return $elm$core$List$isEmpty(errorDays);
	});
var $author$project$Locations$AddLocation$Commands$validateOpenHours = F2(
	function (translations, model) {
		if ($author$project$Listings$Ui$OpenHours$isAlwaysOpen(model)) {
			return true;
		} else {
			var validOpenHours = A2($author$project$Listings$Ui$OpenHours$validateOpenHours, translations, model);
			return validOpenHours ? true : false;
		}
	});
var $author$project$Locations$AddLocation$Model$CreateLocationClicked = {$: 'CreateLocationClicked'};
var $author$project$Locations$AddLocation$View$buttons = F2(
	function (session, model) {
		var storefrontValidatedAutoCompleteFields = _List_fromArray(
			[model.region, model.country]);
		var storefrontValidatedValidatedItems = _List_fromArray(
			[model.phone, model.email, model.homepage, model.shortDescription, model.longDescription]);
		var storefrontValidatedFormFields = _List_fromArray(
			[model.storeId, model.storefrontName, model.street, model.zip, model.city, model.latitude, model.longitude]);
		var serviceAreaValidatedFields = _List_fromArray(
			[model.longDescription, model.shortDescription]);
		var hasSelectedServiceAreas = !$elm$core$List$isEmpty(
			$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
				$author$project$Common$Form$unwrapFormState(model.serviceAreaSelector.selectedServiceAreas)));
		var hasValidOpenHours = A2($author$project$Locations$AddLocation$Commands$validateOpenHours, session.translations, model.openHours);
		var formFieldValid = function (formState) {
			if (formState.$ === 'Clean') {
				var validated = formState.a;
				return $author$project$Common$Validators$ValidatedItem$isValid(validated);
			} else {
				var validated = formState.a;
				return $author$project$Common$Validators$ValidatedItem$isValid(validated);
			}
		};
		var validStoreFront = A2($elm$core$List$all, formFieldValid, storefrontValidatedFormFields) && ($author$project$Common$Validators$ValidatedItem$allValid(storefrontValidatedValidatedItems) && $author$project$Common$Validators$ValidatedItem$allValid(storefrontValidatedAutoCompleteFields));
		var errorDisplay = function () {
			var _v1 = model.errorMessage;
			if (_v1.$ === 'Just') {
				var errorMessage = _v1.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__errorDisplay')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Error,
								$author$project$PinMeTo$Ui$Alert$plain(errorMessage)))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var cancelButton = $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withGhostStyle,
				$author$project$PinMeTo$Ui$Button$GhostDefault,
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Locations$AddLocation$Model$ClearFormClicked,
					$author$project$PinMeTo$Ui$Button$buttonGhost(
						$author$project$Translations$Listings$AddLocation$discard(session.translations)))));
		var allValid = function () {
			var _v0 = model.locationType;
			switch (_v0.$) {
				case 'Storefront':
					return validStoreFront && hasValidOpenHours;
				case 'StorefrontAndServiceArea':
					return validStoreFront && ($author$project$Common$Validators$ValidatedItem$allValid(serviceAreaValidatedFields) && (hasSelectedServiceAreas && hasValidOpenHours));
				default:
					return $author$project$Common$Validators$ValidatedItem$allValid(serviceAreaValidatedFields) && (hasSelectedServiceAreas && hasValidOpenHours);
			}
		}();
		var createLocationsButton = $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				!allValid,
				A2(
					$author$project$PinMeTo$Ui$Button$withPrimaryStyle,
					$author$project$PinMeTo$Ui$Button$PrimaryDefault,
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Locations$AddLocation$Model$CreateLocationClicked,
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$Listings$AddLocation$createLocations(session.translations))))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					errorDisplay,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[createLocationsButton, cancelButton]))
				]));
	});
var $author$project$Translations$Listings$AddLocation$wifiLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.wifi_label');
};
var $author$project$Translations$Listings$AddLocation$wifiTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.wifi_title');
};
var $author$project$Locations$AddLocation$Model$WifiSsidChanged = function (a) {
	return {$: 'WifiSsidChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$wifiPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.wifi_placeholder');
};
var $author$project$Locations$AddLocation$View$wifiSsid = F2(
	function (session, model) {
		var translateError = $elm$core$Maybe$map(
			$author$project$Locations$AddLocation$View$applyTranslations(session.translations));
		var wifiSsidInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
				$author$project$Translations$Listings$AddLocation$wifiPlaceholder(session.translations),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withLabel,
					$author$project$Translations$Listings$AddLocation$wifiLabel(session.translations),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withError,
						translateError(
							$author$project$Common$Validators$ValidatedItem$unwrapError(model.wifiSsid)),
						$author$project$PinMeTo$Ui$Form$Input$text(
							{
								value: $author$project$Common$Validators$ValidatedItem$unwrap(model.wifiSsid),
								onChange: $author$project$Locations$AddLocation$Model$WifiSsidChanged
							})))));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$wifiTitle(session.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[wifiSsidInput]))
						]))
				]));
	});
var $author$project$Listings$Ui$OpenHours$ResetDay = function (a) {
	return {$: 'ResetDay', a: a};
};
var $author$project$Listings$Ui$OpenHours$AddSpanToDay = F2(
	function (a, b) {
		return {$: 'AddSpanToDay', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursReset = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_reset');
};
var $author$project$Listings$Ui$OpenHours$getRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[012][0-9][0-5][0-9]'));
var $author$project$Listings$Ui$OpenHours$UpdateHourSet = F5(
	function (a, b, c, d, e) {
		return {$: 'UpdateHourSet', a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Listings$Ui$OpenHours$mapClosingTime0000To2400 = F5(
	function (openOrClose, shortStringDay, spanIndex, state, fieldValue) {
		var newFieldValue = ((openOrClose === 'close') && (fieldValue === '0000')) ? '2400' : fieldValue;
		return A5($author$project$Listings$Ui$OpenHours$UpdateHourSet, openOrClose, shortStringDay, spanIndex, state, newFieldValue);
	});
var $author$project$Listings$Ui$OpenHours$mapClosingTime2400To0000 = function (textValue) {
	return (textValue === '2400') ? '0000' : textValue;
};
var $author$project$Listings$Ui$OpenHours$renderHourInput = F7(
	function (translations, textValue, openOrClose, shortStringDay, spanIndex, isDisabled, state) {
		var errorToShow = function () {
			switch (state.$) {
				case 'NotSpecified':
					return $elm$core$Maybe$Nothing;
				case 'Closed':
					return $elm$core$Maybe$Nothing;
				case 'AlwaysOpen':
					return $elm$core$Maybe$Nothing;
				default:
					return A2($elm$regex$Regex$contains, $author$project$Listings$Ui$OpenHours$getRegex, textValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Translations$General$invalid(translations));
			}
		}();
		return $author$project$PinMeTo$Ui$Form$TimeInput$render(
			A2(
				$author$project$PinMeTo$Ui$Form$TimeInput$withError,
				errorToShow,
				A2(
					$author$project$PinMeTo$Ui$Form$TimeInput$withDisabled,
					isDisabled,
					$author$project$PinMeTo$Ui$Form$TimeInput$timeInput(
						{
							value: $author$project$Listings$Ui$OpenHours$mapClosingTime2400To0000(textValue),
							format: $author$project$PinMeTo$Ui$Form$TimeInput$Military,
							onChange: A4($author$project$Listings$Ui$OpenHours$mapClosingTime0000To2400, openOrClose, shortStringDay, spanIndex, state)
						}))));
	});
var $author$project$Listings$Ui$OpenHours$RemoveDaySpanByIndex = F2(
	function (a, b) {
		return {$: 'RemoveDaySpanByIndex', a: a, b: b};
	});
var $author$project$Listings$Ui$OpenHours$renderDeleteSpan = F2(
	function (spanIndex, day) {
		return (spanIndex > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-remove-span'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Listings$Ui$OpenHours$RemoveDaySpanByIndex, spanIndex, day))
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-remove-span')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(' ')
				]));
	});
var $author$project$Listings$Ui$OpenHours$OnDayClosedChange = F2(
	function (a, b) {
		return {$: 'OnDayClosedChange', a: a, b: b};
	});
var $author$project$Listings$Ui$OpenHours$NoOp = {$: 'NoOp'};
var $author$project$Listings$Ui$OpenHours$renderReadOnlyHourInput = function (textValue) {
	return $author$project$PinMeTo$Ui$Form$TimeInput$render(
		A2(
			$author$project$PinMeTo$Ui$Form$TimeInput$withReadOnly,
			true,
			$author$project$PinMeTo$Ui$Form$TimeInput$timeInput(
				{
					value: textValue,
					format: $author$project$PinMeTo$Ui$Form$TimeInput$Military,
					onChange: function (_v0) {
						return $author$project$Listings$Ui$OpenHours$NoOp;
					}
				})));
};
var $author$project$Listings$Ui$OpenHours$renderDayData = F4(
	function (translations, model, day, state) {
		var renderNotSpecified = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
								{
									label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
									checked: false,
									onChange: $author$project$Listings$Ui$OpenHours$OnDayClosedChange(day)
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-input')
												]),
											_List_fromArray(
												[
													A7($author$project$Listings$Ui$OpenHours$renderHourInput, translations, '', 'open', day, 0, false, state)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-input')
												]),
											_List_fromArray(
												[
													A7($author$project$Listings$Ui$OpenHours$renderHourInput, translations, '', 'close', day, 0, false, state)
												]))
										])),
									A2($author$project$Listings$Ui$OpenHours$renderDeleteSpan, 0, day)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								A2($author$project$Listings$Ui$OpenHours$AddSpanToDay, day, state),
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostLight,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$disabledIfTrue,
											false,
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations)))))))
						]))
				]));
		var renderCloseDay = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
								{
									label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
									checked: true,
									onChange: $author$project$Listings$Ui$OpenHours$OnDayClosedChange(day)
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-input')
										]),
									_List_fromArray(
										[
											A7($author$project$Listings$Ui$OpenHours$renderHourInput, translations, '', 'open', day, 0, true, state)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-input')
										]),
									_List_fromArray(
										[
											A7($author$project$Listings$Ui$OpenHours$renderHourInput, translations, '', 'close', day, 0, true, state)
										]))
								])),
							A2($author$project$Listings$Ui$OpenHours$renderDeleteSpan, 0, day)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								A2($author$project$Listings$Ui$OpenHours$AddSpanToDay, day, state),
								A2(
									$author$project$PinMeTo$Ui$Button$withGhostStyle,
									$author$project$PinMeTo$Ui$Button$GhostLight,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$disabledIfTrue,
											true,
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations)))))))
						]))
				]));
		switch (state.$) {
			case 'Open':
				var spanList = state.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Checkbox$render(
									$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
										{
											label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
											checked: false,
											onChange: $author$project$Listings$Ui$OpenHours$OnDayClosedChange(day)
										}))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, timeSpan) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('lightbox__open-hours-input')
																]),
															_List_fromArray(
																[
																	A7($author$project$Listings$Ui$OpenHours$renderHourInput, translations, timeSpan.open, 'open', day, index, false, state)
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('lightbox__open-hours-input')
																]),
															_List_fromArray(
																[
																	A7($author$project$Listings$Ui$OpenHours$renderHourInput, translations, timeSpan.close, 'close', day, index, false, state)
																]))
														])),
													A2($author$project$Listings$Ui$OpenHours$renderDeleteSpan, index, day)
												]));
									}),
								spanList)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										A2($author$project$Listings$Ui$OpenHours$AddSpanToDay, day, state),
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostLight,
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												A2(
													$author$project$PinMeTo$Ui$Button$disabledIfTrue,
													$elm$core$List$length(spanList) > 2,
													$author$project$PinMeTo$Ui$Button$buttonGhost(
														$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations))))))),
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										$author$project$Listings$Ui$OpenHours$ResetDay(day),
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostLight,
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												$author$project$PinMeTo$Ui$Button$buttonGhost(
													$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursReset(translations))))))
								]))
						]));
			case 'AlwaysOpen':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-closed')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Checkbox$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Checkbox$withEnabled,
										false,
										$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
											{
												label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations),
												checked: false,
												onChange: $author$project$Listings$Ui$OpenHours$OnDayClosedChange(day)
											})))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-span-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lightbox__open-hours-inner-span-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-input')
												]),
											_List_fromArray(
												[
													$author$project$Listings$Ui$OpenHours$renderReadOnlyHourInput('0000')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__open-hours-input')
												]),
											_List_fromArray(
												[
													$author$project$Listings$Ui$OpenHours$renderReadOnlyHourInput('0000')
												]))
										])),
									A2($author$project$Listings$Ui$OpenHours$renderDeleteSpan, 0, day)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										A2($author$project$Listings$Ui$OpenHours$AddSpanToDay, day, state),
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostLight,
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												A2(
													$author$project$PinMeTo$Ui$Button$disabledIfTrue,
													true,
													$author$project$PinMeTo$Ui$Button$buttonGhost(
														$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAddSpan(translations)))))))
								]))
						]));
			case 'Closed':
				return renderCloseDay;
			default:
				return renderNotSpecified;
		}
	});
var $author$project$Listings$Ui$OpenHours$renderWeek = F2(
	function (translations, model) {
		var dayContainer = F3(
			function (translatedDay, shortDay, state) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-days')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__open-hours-day-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translatedDay)
								])),
							A4($author$project$Listings$Ui$OpenHours$renderDayData, translations, model, shortDay, state)
						]));
			});
		var openHours = model.openHours;
		if (openHours.$ === 'Always') {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						dayContainer,
						$author$project$Translations$General$mon(translations),
						'mon',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$tue(translations),
						'tue',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$wed(translations),
						'wed',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$thu(translations),
						'thu',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$fri(translations),
						'fri',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$sat(translations),
						'sat',
						$author$project$Data$Location$OpenHours$AlwaysOpen),
						A3(
						dayContainer,
						$author$project$Translations$General$sun(translations),
						'sun',
						$author$project$Data$Location$OpenHours$AlwaysOpen)
					]));
		} else {
			var days = openHours.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						dayContainer,
						$author$project$Translations$General$mon(translations),
						'mon',
						days.mon),
						A3(
						dayContainer,
						$author$project$Translations$General$tue(translations),
						'tue',
						days.tue),
						A3(
						dayContainer,
						$author$project$Translations$General$wed(translations),
						'wed',
						days.wed),
						A3(
						dayContainer,
						$author$project$Translations$General$thu(translations),
						'thu',
						days.thu),
						A3(
						dayContainer,
						$author$project$Translations$General$fri(translations),
						'fri',
						days.fri),
						A3(
						dayContainer,
						$author$project$Translations$General$sat(translations),
						'sat',
						days.sat),
						A3(
						dayContainer,
						$author$project$Translations$General$sun(translations),
						'sun',
						days.sun)
					]));
		}
	});
var $author$project$Listings$Ui$OpenHours$renderAlert = F2(
	function (translations, model) {
		var errorDays = A2($author$project$Listings$Ui$OpenHours$getDaysWithErrors, translations, model);
		return ($elm$core$List$length(errorDays) > 0) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Error,
				$author$project$PinMeTo$Ui$Alert$plain(
					_Utils_ap(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursOverlappingError(translations),
						A2($elm$core$String$join, ',', errorDays))))) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
	});
var $author$project$Listings$Ui$OpenHours$OnAlwaysOpenChange = function (a) {
	return {$: 'OnAlwaysOpenChange', a: a};
};
var $author$project$Listings$Ui$OpenHours$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Listings$Ui$OpenHours$renderAlert, translations, model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__checkbox-header')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
								{
									label: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAlwaysOpen(translations),
									checked: _Utils_eq(model.openHours, $author$project$Data$Location$OpenHours$Always),
									onChange: $author$project$Listings$Ui$OpenHours$OnAlwaysOpenChange
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__flex')
						]),
					_List_fromArray(
						[
							A2($author$project$Listings$Ui$OpenHours$renderWeek, translations, model)
						]))
				]));
	});
var $author$project$Translations$Listings$AddLocation$openHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.open_hours');
};
var $author$project$Locations$AddLocation$View$openHours = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$openHours(session.translations))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Locations$AddLocation$Model$OpenHoursMsg,
					A2($author$project$Listings$Ui$OpenHours$view, session.translations, model.openHours))
				]));
	});
var $author$project$PinMeTo$Ui$DatePickerV2$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$DatePickerV2$Normal = {$: 'Normal'};
var $author$project$PinMeTo$Ui$DatePickerV2$DateSelector = {$: 'DateSelector'};
var $author$project$PinMeTo$Ui$DatePickerV2$view = function (_v0) {
	var label = _v0.label;
	var value = _v0.value;
	var language = _v0.language;
	var locale = _v0.locale;
	var onChange = _v0.onChange;
	return $author$project$PinMeTo$Ui$DatePickerV2$View(
		{max: $elm$core$Maybe$Nothing, min: $elm$core$Maybe$Nothing, label: label, type_: $author$project$PinMeTo$Ui$DatePickerV2$DateSelector, value: value, inline: false, locale: locale, language: language, onChange: onChange, renderer: $elm$core$Maybe$Nothing, toggleStyle: $author$project$PinMeTo$Ui$DatePickerV2$Normal});
};
var $author$project$PinMeTo$Ui$DatePickerV2$DateChanged = function (a) {
	return {$: 'DateChanged', a: a};
};
var $author$project$PinMeTo$Ui$DatePickerV2$valueAttribute = F4(
	function (attrib, value, f, attribs) {
		if (value.$ === 'Just') {
			var x = value.a;
			return A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$Attributes$attribute,
					attrib,
					f(x)),
				attribs);
		} else {
			return attribs;
		}
	});
var $author$project$PinMeTo$Ui$DatePickerV2$DateRangeChanged = function (a) {
	return {$: 'DateRangeChanged', a: a};
};
var $author$project$PinMeTo$Ui$DatePickerV2$languageToLocale = function (language) {
	switch (language.$) {
		case 'En':
			return $author$project$PinMeTo$Ui$I18n$Locale$EnUs;
		case 'Fr':
			return $author$project$PinMeTo$Ui$I18n$Locale$Fr;
		case 'De':
			return $author$project$PinMeTo$Ui$I18n$Locale$De;
		case 'Es':
			return $author$project$PinMeTo$Ui$I18n$Locale$Es;
		case 'Sv':
			return $author$project$PinMeTo$Ui$I18n$Locale$SvSe;
		case 'Fi':
			return $author$project$PinMeTo$Ui$I18n$Locale$Fi;
		case 'Pl':
			return $author$project$PinMeTo$Ui$I18n$Locale$Pl;
		default:
			return $author$project$PinMeTo$Ui$I18n$Locale$Pt;
	}
};
var $author$project$PinMeTo$Ui$DatePickerV2$MonthRangeChanged = function (a) {
	return {$: 'MonthRangeChanged', a: a};
};
var $author$project$PinMeTo$Ui$DatePickerV2$stringToDateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(x);
		if (_v0.$ === 'Ok') {
			var date = _v0.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			return $elm$json$Json$Decode$fail('Invalid date');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Ui$Date$FormatFullMonthAndYear = {$: 'FormatFullMonthAndYear'};
var $author$project$PinMeTo$Ui$DatePickerV2$render = function (_v0) {
	var config = _v0.a;
	var typeAttribute = function () {
		var _v4 = config.type_;
		switch (_v4.$) {
			case 'DateSelector':
				return 'date-selector';
			case 'MonthRange':
				return 'month-range';
			default:
				return 'date-range';
		}
	}();
	var toggleButton = function () {
		var _v3 = config.toggleStyle;
		switch (_v3.$) {
			case 'PlainLight':
				return $author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight($elm$html$Html$button);
			case 'SelectDate':
				return A2(
					$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
					$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faCalendarDay),
					$elm$html$Html$button);
			default:
				return $author$project$PinMeTo$Ui$Btn$pmtBtnSmall($elm$html$Html$button);
		}
	}();
	return A3(
		$elm$html$Html$node,
		'pmt-date-picker-v2',
		A4(
			$author$project$PinMeTo$Ui$DatePickerV2$valueAttribute,
			'min',
			config.min,
			function (min_) {
				return $justinmimbs$date$Date$toIsoString(min_);
			},
			A4(
				$author$project$PinMeTo$Ui$DatePickerV2$valueAttribute,
				'max',
				config.max,
				function (max_) {
					return $justinmimbs$date$Date$toIsoString(max_);
				},
				A4(
					$author$project$PinMeTo$Ui$DatePickerV2$valueAttribute,
					'selected-dates',
					config.value,
					function (value) {
						switch (value.$) {
							case 'DateChanged':
								var date = value.a;
								return $justinmimbs$date$Date$toIsoString(date);
							case 'MonthRangeChanged':
								var range = value.a;
								return $justinmimbs$date$Date$toIsoString(range.from) + (',' + $justinmimbs$date$Date$toIsoString(range.to));
							default:
								var range = value.a;
								return $justinmimbs$date$Date$toIsoString(range.from) + (',' + $justinmimbs$date$Date$toIsoString(range.to));
						}
					},
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'type', typeAttribute),
							A2(
							$elm$html$Html$Attributes$attribute,
							'locale',
							$author$project$PinMeTo$Ui$I18n$Locale$toString(config.locale)),
							A2(
							$elm$html$Html$Attributes$attribute,
							'language',
							$author$project$PinMeTo$Ui$I18n$Language$toString(config.language)),
							A2(
							$elm$html$Html$Attributes$property,
							'inline',
							$elm$json$Json$Encode$bool(config.inline)),
							A2(
							$elm$html$Html$Events$on,
							'on-month-range-changed',
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (from, to) {
										return config.onChange(
											$author$project$PinMeTo$Ui$DatePickerV2$MonthRangeChanged(
												{to: to, from: from}));
									}),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['detail', 'from']),
									$author$project$PinMeTo$Ui$DatePickerV2$stringToDateDecoder),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['detail', 'to']),
									$author$project$PinMeTo$Ui$DatePickerV2$stringToDateDecoder))),
							A2(
							$elm$html$Html$Events$on,
							'on-date-changed',
							A2(
								$elm$json$Json$Decode$map,
								config.onChange,
								A2(
									$elm$json$Json$Decode$andThen,
									function (x) {
										return $elm$json$Json$Decode$succeed(
											$author$project$PinMeTo$Ui$DatePickerV2$DateChanged(x));
									},
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['detail', 'date']),
										$author$project$PinMeTo$Ui$DatePickerV2$stringToDateDecoder)))),
							A2(
							$elm$html$Html$Events$on,
							'on-date-range-changed',
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (from, to) {
										return config.onChange(
											$author$project$PinMeTo$Ui$DatePickerV2$DateRangeChanged(
												{to: to, from: from}));
									}),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['detail', 'from']),
									$author$project$PinMeTo$Ui$DatePickerV2$stringToDateDecoder),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['detail', 'to']),
									$author$project$PinMeTo$Ui$DatePickerV2$stringToDateDecoder)))
						])))),
		config.inline ? _List_Nil : _List_fromArray(
			[
				A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				A2(
					toggleButton,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(config.label)
						])),
				function (value) {
					switch (value.$) {
						case 'DateChanged':
							var date = value.a;
							var formattedDate = A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatDate,
								A2(
									$author$project$PinMeTo$Ui$Date$string,
									config.locale,
									$justinmimbs$date$Date$toIsoString(date)));
							return A2(
								toggleButton,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										$author$project$PinMeTo$Ui$Date$render(formattedDate))
									]));
						case 'MonthRangeChanged':
							var range = value.a;
							var formattedFrom = A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatFullMonthAndYear,
								A2(
									$author$project$PinMeTo$Ui$Date$string,
									$author$project$PinMeTo$Ui$DatePickerV2$languageToLocale(config.language),
									$justinmimbs$date$Date$toIsoString(range.from)));
							var fromattedTo = A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatFullMonthAndYear,
								A2(
									$author$project$PinMeTo$Ui$Date$string,
									$author$project$PinMeTo$Ui$DatePickerV2$languageToLocale(config.language),
									$justinmimbs$date$Date$toIsoString(range.to)));
							var formattedDate = _Utils_eq(formattedFrom, fromattedTo) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$PinMeTo$Ui$Date$render(formattedFrom))
								]) : _List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$PinMeTo$Ui$Date$render(formattedFrom)),
									$elm$html$Html$text(' - '),
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$PinMeTo$Ui$Date$render(fromattedTo))
								]);
							return A2(
								toggleButton,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'min-width', '130px')
									]),
								formattedDate);
						default:
							var range = value.a;
							var formattedFrom = A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatDate,
								A2(
									$author$project$PinMeTo$Ui$Date$string,
									config.locale,
									$justinmimbs$date$Date$toIsoString(range.from)));
							var fromattedTo = A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatDate,
								A2(
									$author$project$PinMeTo$Ui$Date$string,
									config.locale,
									$justinmimbs$date$Date$toIsoString(range.to)));
							var formattedDate = _Utils_eq(formattedFrom, fromattedTo) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$PinMeTo$Ui$Date$render(formattedFrom))
								]) : _List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$PinMeTo$Ui$Date$render(formattedFrom)),
									$elm$html$Html$text(' - '),
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$PinMeTo$Ui$Date$render(fromattedTo))
								]);
							return A2(toggleButton, _List_Nil, formattedDate);
					}
				},
				config.value)
			]));
};
var $author$project$Translations$Listings$AddLocation$storeId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.store_id');
};
var $author$project$PinMeTo$Ui$DatePickerV2$withType = F2(
	function (type_, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$DatePickerV2$View(
			_Utils_update(
				config,
				{type_: type_}));
	});
var $author$project$Translations$Listings$AddLocation$selectDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.select_date');
};
var $author$project$Translations$Listings$AddLocation$openingDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.opening_date');
};
var $author$project$Locations$AddLocation$Model$StoreIdChanged = function (a) {
	return {$: 'StoreIdChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$storefrontName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.storefront_name');
};
var $author$project$Translations$Listings$AddLocation$basicInformation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.basic_information');
};
var $author$project$Translations$Listings$AddLocation$locationDescriptor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.location_descriptor');
};
var $author$project$Translations$Listings$AddLocation$storeIdPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.store_id_placeholder');
};
var $author$project$Locations$AddLocation$Model$StorefrontNameChanged = function (a) {
	return {$: 'StorefrontNameChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$StoreOpeningDateChanged = function (a) {
	return {$: 'StoreOpeningDateChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$locationDescriptorPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.location_descriptor_placeholder');
};
var $author$project$Locations$AddLocation$Model$StoreLocationDescriptorChanged = function (a) {
	return {$: 'StoreLocationDescriptorChanged', a: a};
};
var $author$project$Locations$AddLocation$View$storeInfo = F2(
	function (session, model) {
		var storeLocationDescriptorInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withError,
				A2(
					$elm$core$Maybe$map,
					$author$project$Locations$AddLocation$View$applyTranslations(session.translations),
					$author$project$Common$Validators$ValidatedItem$unwrapError(model.storeLocationDescriptor)),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
					$author$project$Translations$Listings$AddLocation$locationDescriptorPlaceholder(session.translations),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withLabel,
						$author$project$Translations$Listings$AddLocation$locationDescriptor(session.translations),
						$author$project$PinMeTo$Ui$Form$Input$text(
							{
								value: $author$project$Common$Validators$ValidatedItem$unwrap(model.storeLocationDescriptor),
								onChange: $author$project$Locations$AddLocation$Model$StoreLocationDescriptorChanged
							})))));
		var openingDateButton = $author$project$PinMeTo$Ui$DatePickerV2$render(
			A2(
				$author$project$PinMeTo$Ui$DatePickerV2$withType,
				$author$project$PinMeTo$Ui$DatePickerV2$DateSelector,
				$author$project$PinMeTo$Ui$DatePickerV2$view(
					{
						label: $author$project$Translations$Listings$AddLocation$selectDate(session.translations),
						value: A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DatePickerV2$DateChanged, model.storeOpeningDate),
						locale: $author$project$PinMeTo$Ui$I18n$Locale$EnUs,
						language: $author$project$PinMeTo$Ui$I18n$Language$En,
						onChange: $author$project$Locations$AddLocation$Model$StoreOpeningDateChanged
					})));
		var translateError = $elm$core$Maybe$map(
			$author$project$Locations$AddLocation$View$applyTranslations(session.translations));
		var storeFrontNameInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withDisabled,
				!session.features.allowCustomStoreName,
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withError,
					translateError(
						$author$project$Common$Form$unwrapFormError(model.storefrontName)),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withRequired,
						true,
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$storefrontName(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Form$unwrap(model.storefrontName),
									onChange: $author$project$Locations$AddLocation$Model$StorefrontNameChanged
								}))))));
		var storeIdInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withError,
				A2(
					$elm$core$Maybe$map,
					$author$project$Locations$AddLocation$View$applyTranslations(session.translations),
					$author$project$Common$Form$unwrapFormError(model.storeId)),
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
					$author$project$Translations$Listings$AddLocation$storeIdPlaceholder(session.translations),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withRequired,
						true,
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$storeId(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Form$unwrap(model.storeId),
									onChange: $author$project$Locations$AddLocation$Model$StoreIdChanged
								}))))));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$basicInformation(session.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[storeFrontNameInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[storeIdInput]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[storeLocationDescriptorInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__opening-date')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$AddLocation$openingDate(session.translations))
										])),
									openingDateButton
								]))
						]))
				]));
	});
var $author$project$Locations$AddLocation$View$groupsOfTwo = function (l) {
	var inner = F2(
		function (curr, list) {
			inner:
			while (true) {
				var _v0 = _Utils_Tuple2(curr, list);
				if (_v0.a.a.$ === 'Just') {
					if (_v0.a.b.$ === 'Just') {
						var _v8 = _v0.a;
						var a = _v8.a.a;
						var b = _v8.b.a;
						var rest = _v0.b;
						return A2(
							$elm$core$List$cons,
							_List_fromArray(
								[a, b]),
							A2(
								inner,
								_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
								rest));
					} else {
						if (_v0.b.b) {
							var _v9 = _v0.a;
							var a = _v9.a.a;
							var _v10 = _v9.b;
							var _v11 = _v0.b;
							var x = _v11.a;
							var rest = _v11.b;
							var $temp$curr = _Utils_Tuple2(
								$elm$core$Maybe$Just(a),
								$elm$core$Maybe$Just(x)),
								$temp$list = rest;
							curr = $temp$curr;
							list = $temp$list;
							continue inner;
						} else {
							var _v12 = _v0.a;
							var a = _v12.a.a;
							var _v13 = _v12.b;
							return _List_fromArray(
								[
									_List_fromArray(
									[a])
								]);
						}
					}
				} else {
					if (_v0.a.b.$ === 'Nothing') {
						if (!_v0.b.b) {
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							return _List_Nil;
						} else {
							var _v4 = _v0.a;
							var _v5 = _v4.a;
							var _v6 = _v4.b;
							var _v7 = _v0.b;
							var x = _v7.a;
							var rest = _v7.b;
							var $temp$curr = _Utils_Tuple2(
								$elm$core$Maybe$Just(x),
								$elm$core$Maybe$Nothing),
								$temp$list = rest;
							curr = $temp$curr;
							list = $temp$list;
							continue inner;
						}
					} else {
						var _v14 = _v0.a;
						var _v15 = _v14.a;
						return _List_Nil;
					}
				}
			}
		});
	return A2(
		inner,
		_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		l);
};
var $author$project$Translations$Listings$AddLocation$customNameFor = F2(
	function (translations, network) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.add_location.custom_name_for',
			_List_fromArray(
				[
					_Utils_Tuple2('- network', network)
				]));
	});
var $author$project$Translations$Listings$AddLocation$customNetworkNames = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.custom_network_names');
};
var $author$project$Locations$AddLocation$Model$PtvCustomNameChanged = function (a) {
	return {$: 'PtvCustomNameChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$AppleCustomNameChanged = function (a) {
	return {$: 'AppleCustomNameChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$GoogleCustomNameChanged = function (a) {
	return {$: 'GoogleCustomNameChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$FacebookCustomNameChanged = function (a) {
	return {$: 'FacebookCustomNameChanged', a: a};
};
var $author$project$Locations$AddLocation$View$customNames = F2(
	function (session, model) {
		var anyNetworkEnabledWithCustomNameEnabled = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(true),
			_List_fromArray(
				[session.features.googleCustomName, session.features.facebookCustomName, session.features.appleCustomName]));
		var translateError = $elm$core$Maybe$map(
			$author$project$Locations$AddLocation$View$applyTranslations(session.translations));
		var ptvCustomNameInput = _Utils_Tuple2(
			session.features.allowPtvTwoWay,
			$author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
					A2($author$project$Translations$Listings$AddLocation$customNameFor, session.translations, 'PTV'),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withLabel,
						'PTV',
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							translateError(
								$author$project$Common$Validators$ValidatedItem$unwrapError(model.ptvCustomName)),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.ptvCustomName),
									onChange: $author$project$Locations$AddLocation$Model$PtvCustomNameChanged
								}))))));
		var appleCustomNameInput = _Utils_Tuple2(
			session.features.appleCustomName,
			$author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
					A2($author$project$Translations$Listings$AddLocation$customNameFor, session.translations, 'Apple'),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withLabel,
						'Apple',
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							translateError(
								$author$project$Common$Validators$ValidatedItem$unwrapError(model.appleCustomName)),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.appleCustomName),
									onChange: $author$project$Locations$AddLocation$Model$AppleCustomNameChanged
								}))))));
		var googleCustomNameInput = _Utils_Tuple2(
			session.features.googleCustomName,
			$author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
					A2($author$project$Translations$Listings$AddLocation$customNameFor, session.translations, 'Google'),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withLabel,
						'Google',
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							translateError(
								$author$project$Common$Validators$ValidatedItem$unwrapError(model.googleCustomName)),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.googleCustomName),
									onChange: $author$project$Locations$AddLocation$Model$GoogleCustomNameChanged
								}))))));
		var facebookCustomNameInput = _Utils_Tuple2(
			session.features.facebookCustomName,
			$author$project$PinMeTo$Ui$Form$Input$render(
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
					A2($author$project$Translations$Listings$AddLocation$customNameFor, session.translations, 'Facebook'),
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withLabel,
						'Facebook',
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withError,
							translateError(
								$author$project$Common$Validators$ValidatedItem$unwrapError(model.facebookCustomName)),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.facebookCustomName),
									onChange: $author$project$Locations$AddLocation$Model$FacebookCustomNameChanged
								}))))));
		var renderInput = function (input) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-add-location__cell')
					]),
				_List_fromArray(
					[input]));
		};
		var enabledInputs = A2(
			$elm$core$List$map,
			function (groups) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					groups);
			},
			$author$project$Locations$AddLocation$View$groupsOfTwo(
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, renderInput),
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(true)),
						_List_fromArray(
							[googleCustomNameInput, facebookCustomNameInput, appleCustomNameInput, ptvCustomNameInput])))));
		return anyNetworkEnabledWithCustomNameEnabled ? A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$customNetworkNames(session.translations))
						])),
				enabledInputs)) : $elm$html$Html$text('');
	});
var $author$project$Translations$Listings$AddLocation$newLocation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.new_location');
};
var $author$project$Listings$Ui$AutoComplete$withError = F2(
	function (showError, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{hasError: showError}));
	});
var $author$project$Common$ServiceAreaSelectorV2$View$errWrapper = function (msg) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-input__message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(msg)
			]));
};
var $author$project$Listings$Ui$AutoComplete$withReadOnly = F2(
	function (readOnly, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$AutoComplete$Config(
			_Utils_update(
				config,
				{isReadOnly: readOnly}));
	});
var $author$project$Translations$Listings$LocationDetail$couldNotGetSuggestions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.could_not_get_suggestions');
};
var $author$project$Common$ServiceAreaSelectorV2$View$getErrorAndErrorView = function (model) {
	var _v0 = _Utils_Tuple2(model.selectedServiceAreas, model.availableServiceAreas);
	_v0$0:
	while (true) {
		if (_v0.a.$ === 'Edited') {
			switch (_v0.a.a.$) {
				case 'EmptyList':
					if (_v0.b.$ === 'FetchFail') {
						break _v0$0;
					} else {
						var _v2 = _v0.a.a;
						return _Utils_Tuple2(
							true,
							$author$project$Common$ServiceAreaSelectorV2$View$errWrapper(
								$author$project$Translations$Listings$LocationDetail$serviceAreaError(model.translations)));
					}
				case 'AddableList':
					if (_v0.b.$ === 'FetchFail') {
						break _v0$0;
					} else {
						return _Utils_Tuple2(
							false,
							$elm$html$Html$text(''));
					}
				case 'FullList':
					if (_v0.b.$ === 'FetchFail') {
						break _v0$0;
					} else {
						return _Utils_Tuple2(
							true,
							$author$project$Common$ServiceAreaSelectorV2$View$errWrapper(
								$author$project$Translations$Listings$LocationDetail$maxTwentyServiceAreas(model.translations)));
					}
				default:
					if (_v0.b.$ === 'FetchFail') {
						break _v0$0;
					} else {
						var _v3 = _v0.a.a;
						return _Utils_Tuple2(
							true,
							$author$project$Common$ServiceAreaSelectorV2$View$errWrapper(
								$author$project$Translations$Listings$LocationDetail$couldNotGetSuggestions(model.translations)));
					}
			}
		} else {
			if (_v0.b.$ === 'FetchFail') {
				break _v0$0;
			} else {
				return _Utils_Tuple2(
					false,
					$elm$html$Html$text(''));
			}
		}
	}
	var _v1 = _v0.b;
	return _Utils_Tuple2(
		true,
		$author$project$Common$ServiceAreaSelectorV2$View$errWrapper(
			$author$project$Translations$Listings$LocationDetail$couldNotGetSuggestions(model.translations)));
};
var $author$project$Common$ServiceAreaSelectorV2$View$view = function (model) {
	var renderServiceAreas = $elm$core$List$map(
		function (serviceArea) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-add-location__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-add-location__cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('service-area-item__text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(serviceArea.area)
									]))
							])),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fa-regular fa-xmark'),
								$author$project$Common$Util$onClickFinal(
								$author$project$Common$ServiceAreaSelectorV2$Types$RemoveServiceArea(serviceArea))
							]),
						_List_Nil)
					]));
		});
	var _v0 = $author$project$Common$ServiceAreaSelectorV2$View$getErrorAndErrorView(model);
	var showValidationError = _v0.a;
	var renderError_ = _v0.b;
	var disableSelectorInteractionOnFullList = (showValidationError && _Utils_eq(
		renderError_,
		$author$project$Common$ServiceAreaSelectorV2$View$errWrapper(
			$author$project$Translations$Listings$LocationDetail$maxTwentyServiceAreas(model.translations)))) ? true : false;
	var serviceAreaInput = A2(
		$author$project$Listings$Ui$AutoComplete$render,
		model.uiAutoComplete,
		A2(
			$author$project$Listings$Ui$AutoComplete$withIsRequired,
			true,
			A2(
				$author$project$Listings$Ui$AutoComplete$withReadOnly,
				disableSelectorInteractionOnFullList,
				A2(
					$author$project$Listings$Ui$AutoComplete$withPlaceholder,
					$author$project$Translations$Listings$AddLocation$serviceAreasPlaceholder(model.translations),
					A2(
						$author$project$Listings$Ui$AutoComplete$withError,
						showValidationError,
						A2(
							$author$project$Listings$Ui$AutoComplete$withLabel,
							$author$project$Translations$Listings$LocationDetail$selectServiceAreas(model.translations),
							A2(
								$author$project$Listings$Ui$AutoComplete$view,
								$author$project$Common$ServiceAreaSelectorV2$Types$UiAutoCompleteMsg,
								$author$project$Listings$Ui$AutoComplete$NodeId('service-area-selector'))))))));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-add-location__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-add-location__cell')
							]),
						_List_fromArray(
							[serviceAreaInput]))
					])),
				showValidationError ? renderError_ : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('service-areas-container')
					]),
				function () {
					var _v1 = $author$project$Common$Form$unwrapFormState(model.selectedServiceAreas);
					switch (_v1.$) {
						case 'EmptyList':
							return _List_Nil;
						case 'AddableList':
							var xs = _v1.a;
							return renderServiceAreas(xs);
						case 'FullList':
							var xs = _v1.a;
							return renderServiceAreas(xs);
						default:
							return _List_Nil;
					}
				}())
			]));
};
var $author$project$Translations$Listings$AddLocation$readMore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.read_more');
};
var $author$project$Locations$AddLocation$Model$ServiceArea = {$: 'ServiceArea'};
var $author$project$Translations$Listings$AddLocation$serviceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.service_area');
};
var $author$project$Translations$Listings$AddLocation$serviceAreaBingDisclaimer = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.service_area_bing_disclaimer');
};
var $author$project$Translations$Listings$AddLocation$serviceAreaQualityDisclaimer = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.service_area_quality_disclaimer');
};
var $author$project$Locations$AddLocation$View$serviceArea = F2(
	function (session, model) {
		var helpCenterArticleLink = 'https://help.pinmeto.com/en/article/creating-and-editing-service-area-business-locations-1yxkoq7/ ';
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-add-location__section--hidden',
							!(_Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$StorefrontAndServiceArea) || _Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$ServiceArea)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-subheading'),
							$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$serviceArea(session.translations))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Locations$AddLocation$Model$ServiceAreaSelectorMsg,
					$author$project$Common$ServiceAreaSelectorV2$View$view(model.serviceAreaSelector)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__service-areas-info-container')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Note,
								$author$project$PinMeTo$Ui$Alert$plain(
									$author$project$Translations$Listings$AddLocation$serviceAreaQualityDisclaimer(session.translations)))),
							_Utils_eq(session.analytics.bing, $author$project$PinMeToPage$NetworkEnabled) ? $author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Note,
								$author$project$PinMeTo$Ui$Alert$rich(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$AddLocation$serviceAreaBingDisclaimer(session.translations)),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(helpCenterArticleLink),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													' ' + $author$project$Translations$Listings$AddLocation$readMore(session.translations))
												]))
										])))) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Translations$Listings$AddLocation$descriptions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.descriptions');
};
var $author$project$Translations$Listings$AddLocation$longDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.long_description');
};
var $author$project$Translations$Listings$AddLocation$shortDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.short_description');
};
var $author$project$Locations$AddLocation$Model$LongDescriptionMsg = function (a) {
	return {$: 'LongDescriptionMsg', a: a};
};
var $author$project$Locations$AddLocation$Model$ShortDescriptionMsg = function (a) {
	return {$: 'ShortDescriptionMsg', a: a};
};
var $author$project$Locations$AddLocation$Model$LongDescriptionChanged = function (a) {
	return {$: 'LongDescriptionChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$ShortDescriptionChanged = function (a) {
	return {$: 'ShortDescriptionChanged', a: a};
};
var $author$project$Locations$AddLocation$View$descriptions = F2(
	function (session, model) {
		var shortDescCharCounter = $author$project$Common$Validators$ValidatedItem$unwrap(model.shortDescription);
		var longDescCharCounter = $author$project$Common$Validators$ValidatedItem$unwrap(model.longDescription);
		var translateError = $elm$core$Maybe$map(
			$author$project$Locations$AddLocation$View$applyTranslations(session.translations));
		var shortDescriptionInput = A3(
			$author$project$PinMeTo$Ui$Form$Textarea$render,
			$author$project$Locations$AddLocation$Model$ShortDescriptionMsg,
			model.shortDescriptionState,
			A2(
				$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
				3,
				A2(
					$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
					7,
					A2(
						$author$project$PinMeTo$Ui$Form$Textarea$withError,
						translateError(
							$author$project$Common$Validators$ValidatedItem$unwrapError(model.shortDescription)),
						$author$project$PinMeTo$Ui$Form$Textarea$textarea(
							{
								value: $author$project$Common$Validators$ValidatedItem$unwrap(model.shortDescription),
								onChange: $author$project$Locations$AddLocation$Model$ShortDescriptionChanged
							})))));
		var longDescriptionTextArea = A3(
			$author$project$PinMeTo$Ui$Form$Textarea$render,
			$author$project$Locations$AddLocation$Model$LongDescriptionMsg,
			model.longDescriptionState,
			A2(
				$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
				5,
				A2(
					$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
					7,
					A2(
						$author$project$PinMeTo$Ui$Form$Textarea$withError,
						translateError(
							$author$project$Common$Validators$ValidatedItem$unwrapError(model.longDescription)),
						$author$project$PinMeTo$Ui$Form$Textarea$textarea(
							{
								value: $author$project$Common$Validators$ValidatedItem$unwrap(model.longDescription),
								onChange: $author$project$Locations$AddLocation$Model$LongDescriptionChanged
							})))));
		var counterText = F2(
			function (current, max_) {
				return $elm$core$String$fromInt(current) + ('/' + $elm$core$String$fromInt(max_));
			});
		var shortLen = $elm$core$String$length(shortDescCharCounter);
		var longLen = $elm$core$String$length(longDescCharCounter);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$descriptions(session.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row--full-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$AddLocation$shortDescription(session.translations))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__field')
								]),
							_List_fromArray(
								[
									shortDescriptionInput,
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-add-location__char-counter'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-add-location__charcount--over', model.shortDescriptionCharOverLimit)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(counterText, shortLen, 255))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row--full-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$AddLocation$longDescription(session.translations))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__field')
								]),
							_List_fromArray(
								[
									longDescriptionTextArea,
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-add-location__char-counter'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-add-location__charcount--over', model.longDescriptionCharOverLimit)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(counterText, longLen, 750))
										]))
								]))
						]))
				]));
	});
var $author$project$Locations$AddLocation$Model$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Translations$Listings$AddLocation$storefront = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.storefront');
};
var $author$project$Translations$Listings$AddLocation$popOverLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.pop_over_link');
};
var $author$project$Locations$AddLocation$Model$LocationTypeChanged = function (a) {
	return {$: 'LocationTypeChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$addressAndServiceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.address_and_service_area');
};
var $author$project$Translations$Listings$AddLocation$storefrontAndServiceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.storefront_and_service_area');
};
var $author$project$Locations$AddLocation$View$locationType = F2(
	function (session, model) {
		var storefrontAndServiceAreaRadioButton = $author$project$PinMeTo$Ui$Form$Radio$render(
			$author$project$PinMeTo$Ui$Form$Radio$radio(
				{
					label: $author$project$Translations$Listings$AddLocation$storefrontAndServiceArea(session.translations),
					checked: _Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$StorefrontAndServiceArea),
					onChange: function (_v2) {
						return $author$project$Locations$AddLocation$Model$LocationTypeChanged($author$project$Locations$AddLocation$Model$StorefrontAndServiceArea);
					}
				}));
		var serviceAreaRadioButton = $author$project$PinMeTo$Ui$Form$Radio$render(
			$author$project$PinMeTo$Ui$Form$Radio$radio(
				{
					label: $author$project$Translations$Listings$AddLocation$serviceArea(session.translations),
					checked: _Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$ServiceArea),
					onChange: function (_v1) {
						return $author$project$Locations$AddLocation$Model$LocationTypeChanged($author$project$Locations$AddLocation$Model$ServiceArea);
					}
				}));
		var storeFrontRadioButton = $author$project$PinMeTo$Ui$Form$Radio$render(
			$author$project$PinMeTo$Ui$Form$Radio$radio(
				{
					label: $author$project$Translations$Listings$AddLocation$storefront(session.translations),
					checked: _Utils_eq(model.locationType, $author$project$Locations$AddLocation$Model$Storefront),
					onChange: function (_v0) {
						return $author$project$Locations$AddLocation$Model$LocationTypeChanged($author$project$Locations$AddLocation$Model$Storefront);
					}
				}));
		var locationPopOver = A2(
			$author$project$PinMeTo$Ui$PopOver$renderPlain,
			model.uiPopOverState,
			A2(
				$author$project$PinMeTo$Ui$PopOver$withLink,
				{
					href: 'https://help.pinmeto.com/en/article/adding-locations-to-listings-rz5yg5/#2-1-add-single-locations',
					text: $author$project$Translations$Listings$AddLocation$popOverLink(session.translations)
				},
				$author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'location-type-help',
						tagger: $author$project$Locations$AddLocation$Model$PopOverMsg,
						content: _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-add-location__text')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$AddLocation$popOverStorefrontBold(session.translations))
													])),
												$elm$html$Html$text(
												$author$project$Translations$Listings$AddLocation$popOverStorefront(session.translations))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-add-location__text')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$AddLocation$popOverServiceAreaBold(session.translations))
											])),
										$elm$html$Html$text(
										$author$project$Translations$Listings$AddLocation$popOverServiceArea(session.translations))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-add-location__text')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$AddLocation$popOverStorefrontAndServiceAreaBold(session.translations))
											])),
										$elm$html$Html$text(
										$author$project$Translations$Listings$AddLocation$popOverStorefrontAndServiceArea(session.translations))
									]))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					})));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$addressAndServiceArea(session.translations)),
							locationPopOver
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[storeFrontRadioButton, serviceAreaRadioButton, storefrontAndServiceAreaRadioButton]))
				]));
	});
var $author$project$Translations$Listings$AddLocation$homepage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.homepage');
};
var $author$project$PinMeTo$Ui$Form$Input$withOnBlur = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Form$Input$Input(
			_Utils_update(
				config,
				{
					onBlur: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$Translations$Listings$AddLocation$phoneNumber = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.phone_number');
};
var $author$project$Locations$AddLocation$Model$EmailBlurred = {$: 'EmailBlurred'};
var $author$project$Locations$AddLocation$Model$EmailChanged = function (a) {
	return {$: 'EmailChanged', a: a};
};
var $author$project$Locations$AddLocation$Model$PhoneBlurred = {$: 'PhoneBlurred'};
var $author$project$Locations$AddLocation$Model$PhoneChanged = function (a) {
	return {$: 'PhoneChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$emailAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.email_address');
};
var $author$project$Locations$AddLocation$Model$HomepageBlurred = {$: 'HomepageBlurred'};
var $author$project$Locations$AddLocation$Model$HomepageChanged = function (a) {
	return {$: 'HomepageChanged', a: a};
};
var $author$project$Translations$Listings$AddLocation$contactInformation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.contact_information');
};
var $author$project$Translations$Listings$AddLocation$homepagePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.homepage_placeholder');
};
var $author$project$Translations$Listings$AddLocation$phoneInfoDisclaimer = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.phone_info_disclaimer');
};
var $author$project$Translations$Listings$AddLocation$phoneNumberPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.phone_number_placeholder');
};
var $author$project$Translations$Listings$AddLocation$emailAddressPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.email_address_placeholder');
};
var $author$project$Locations$AddLocation$View$contactInformation = F2(
	function (session, model) {
		var translateError = $elm$core$Maybe$map(
			$author$project$Locations$AddLocation$View$applyTranslations(session.translations));
		var homepageInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withOnBlur,
				$author$project$Locations$AddLocation$Model$HomepageBlurred,
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withError,
					model.homepageBlurred ? translateError(
						$author$project$Common$Validators$ValidatedItem$unwrapError(model.homepage)) : $elm$core$Maybe$Nothing,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$AddLocation$homepagePlaceholder(session.translations),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$homepage(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.homepage),
									onChange: $author$project$Locations$AddLocation$Model$HomepageChanged
								}))))));
		var phoneInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withOnBlur,
				$author$project$Locations$AddLocation$Model$PhoneBlurred,
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withError,
					model.phoneBlurred ? translateError(
						$author$project$Common$Validators$ValidatedItem$unwrapError(model.phone)) : $elm$core$Maybe$Nothing,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$AddLocation$phoneNumberPlaceholder(session.translations),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$phoneNumber(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.phone),
									onChange: $author$project$Locations$AddLocation$Model$PhoneChanged
								}))))));
		var emailInput = $author$project$PinMeTo$Ui$Form$Input$render(
			A2(
				$author$project$PinMeTo$Ui$Form$Input$withOnBlur,
				$author$project$Locations$AddLocation$Model$EmailBlurred,
				A2(
					$author$project$PinMeTo$Ui$Form$Input$withError,
					model.emailBlurred ? translateError(
						$author$project$Common$Validators$ValidatedItem$unwrapError(model.email)) : $elm$core$Maybe$Nothing,
					A2(
						$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
						$author$project$Translations$Listings$AddLocation$emailAddressPlaceholder(session.translations),
						A2(
							$author$project$PinMeTo$Ui$Form$Input$withLabel,
							$author$project$Translations$Listings$AddLocation$emailAddress(session.translations),
							$author$project$PinMeTo$Ui$Form$Input$text(
								{
									value: $author$project$Common$Validators$ValidatedItem$unwrap(model.email),
									onChange: $author$project$Locations$AddLocation$Model$EmailChanged
								}))))));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__section-heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$contactInformation(session.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[homepageInput])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[phoneInput]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-add-location__cell')
								]),
							_List_fromArray(
								[emailInput]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__phone-info-disclaimer')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Note,
								$author$project$PinMeTo$Ui$Alert$plain(
									$author$project$Translations$Listings$AddLocation$phoneInfoDisclaimer(session.translations))))
						]))
				]));
	});
var $author$project$Locations$AddLocation$View$view = F2(
	function (session, model) {
		var successMessageDisplay = function () {
			var _v0 = model.successMessage;
			if (_v0.$ === 'Just') {
				var successMessage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-add-location__success-message')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Success,
								$author$project$PinMeTo$Ui$Alert$plain(successMessage)))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-add-location')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$AddLocation$newLocation(session.translations))
						])),
					successMessageDisplay,
					A2($author$project$Locations$AddLocation$View$storeInfo, session, model),
					A2($author$project$Locations$AddLocation$View$customNames, session, model),
					A2($author$project$Locations$AddLocation$View$locationType, session, model),
					A2($author$project$Locations$AddLocation$View$address, session, model),
					A2($author$project$Locations$AddLocation$View$serviceArea, session, model),
					A2($author$project$Locations$AddLocation$View$openHours, session, model),
					A2($author$project$Locations$AddLocation$View$contactInformation, session, model),
					A2($author$project$Locations$AddLocation$View$descriptions, session, model),
					A2($author$project$Locations$AddLocation$View$wifiSsid, session, model),
					A2($author$project$Locations$AddLocation$View$buttons, session, model)
				]));
	});
var $author$project$Locations$AddLocation$Model$NoOp = {$: 'NoOp'};
var $author$project$Listings$Ui$OpenHours$updateDaySameState = F3(
	function (openHours, day, newState) {
		if (openHours.$ === 'During') {
			var days = openHours.a;
			switch (day) {
				case 'mon':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{mon: newState}));
				case 'tue':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{tue: newState}));
				case 'wed':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{wed: newState}));
				case 'thu':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{thu: newState}));
				case 'fri':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{fri: newState}));
				case 'sat':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sat: newState}));
				case 'sun':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sun: newState}));
				default:
					return $author$project$Data$Location$OpenHours$During(days);
			}
		} else {
			return openHours;
		}
	});
var $author$project$Listings$Ui$OpenHours$updateDayDifferentState = F3(
	function (openHours, day, newDaysState) {
		if (openHours.$ === 'During') {
			var days = openHours.a;
			switch (day) {
				case 'mon':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{mon: newDaysState.mon}));
				case 'tue':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{tue: newDaysState.tue}));
				case 'wed':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{wed: newDaysState.wed}));
				case 'thu':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{thu: newDaysState.thu}));
				case 'fri':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{fri: newDaysState.fri}));
				case 'sat':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sat: newDaysState.sat}));
				case 'sun':
					return $author$project$Data$Location$OpenHours$During(
						_Utils_update(
							days,
							{sun: newDaysState.sun}));
				default:
					return $author$project$Data$Location$OpenHours$During(days);
			}
		} else {
			return openHours;
		}
	});
var $author$project$Listings$Ui$OpenHours$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnAlwaysOpenChange':
				var checked = msg.a;
				var defaultOpenHours = $author$project$Data$Location$OpenHours$During(
					{
						fri: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						mon: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						sat: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						sun: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						thu: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						tue: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								])),
						wed: $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0800', close: '1700'}
								]))
					});
				var _v1 = checked ? _Utils_Tuple2($author$project$Data$Location$OpenHours$Always, model.openHours) : _Utils_Tuple2(
					_Utils_eq(model.bufferOpenHours, $author$project$Data$Location$OpenHours$Always) ? defaultOpenHours : model.bufferOpenHours,
					defaultOpenHours);
				var newHours = _v1.a;
				var newBufferOpenHours = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newHours, bufferOpenHours: newBufferOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'OnDayClosedChange':
				var day = msg.a;
				var checked = msg.b;
				var defaultOpenState = $author$project$Data$Location$OpenHours$Open(
					_List_fromArray(
						[
							{open: '0800', close: '1700'}
						]));
				var defaultDays = {fri: defaultOpenState, mon: defaultOpenState, sat: defaultOpenState, sun: defaultOpenState, thu: defaultOpenState, tue: defaultOpenState, wed: defaultOpenState};
				var currentDays = function () {
					var _v8 = model.openHours;
					if (_v8.$ === 'During') {
						var ds = _v8.a;
						return ds;
					} else {
						return defaultDays;
					}
				}();
				var bufferDays = function () {
					var _v7 = model.bufferOpenHours;
					if (_v7.$ === 'During') {
						var ds = _v7.a;
						return ds;
					} else {
						return defaultDays;
					}
				}();
				var newDaysForOpenHours = function () {
					if (checked) {
						switch (day) {
							case 'mon':
								return _Utils_update(
									currentDays,
									{mon: $author$project$Data$Location$OpenHours$Closed});
							case 'tue':
								return _Utils_update(
									currentDays,
									{tue: $author$project$Data$Location$OpenHours$Closed});
							case 'wed':
								return _Utils_update(
									currentDays,
									{wed: $author$project$Data$Location$OpenHours$Closed});
							case 'thu':
								return _Utils_update(
									currentDays,
									{thu: $author$project$Data$Location$OpenHours$Closed});
							case 'fri':
								return _Utils_update(
									currentDays,
									{fri: $author$project$Data$Location$OpenHours$Closed});
							case 'sat':
								return _Utils_update(
									currentDays,
									{sat: $author$project$Data$Location$OpenHours$Closed});
							case 'sun':
								return _Utils_update(
									currentDays,
									{sun: $author$project$Data$Location$OpenHours$Closed});
							default:
								return currentDays;
						}
					} else {
						var restored = function () {
							switch (day) {
								case 'mon':
									return bufferDays.mon;
								case 'tue':
									return bufferDays.tue;
								case 'wed':
									return bufferDays.wed;
								case 'thu':
									return bufferDays.thu;
								case 'fri':
									return bufferDays.fri;
								case 'sat':
									return bufferDays.sat;
								case 'sun':
									return bufferDays.sun;
								default:
									return defaultOpenState;
							}
						}();
						switch (day) {
							case 'mon':
								return _Utils_update(
									currentDays,
									{mon: restored});
							case 'tue':
								return _Utils_update(
									currentDays,
									{tue: restored});
							case 'wed':
								return _Utils_update(
									currentDays,
									{wed: restored});
							case 'thu':
								return _Utils_update(
									currentDays,
									{thu: restored});
							case 'fri':
								return _Utils_update(
									currentDays,
									{fri: restored});
							case 'sat':
								return _Utils_update(
									currentDays,
									{sat: restored});
							case 'sun':
								return _Utils_update(
									currentDays,
									{sun: restored});
							default:
								return currentDays;
						}
					}
				}();
				var prevState = function () {
					switch (day) {
						case 'mon':
							return currentDays.mon;
						case 'tue':
							return currentDays.tue;
						case 'wed':
							return currentDays.wed;
						case 'thu':
							return currentDays.thu;
						case 'fri':
							return currentDays.fri;
						case 'sat':
							return currentDays.sat;
						case 'sun':
							return currentDays.sun;
						default:
							return defaultOpenState;
					}
				}();
				var newDaysForBuffer = function () {
					if (checked) {
						switch (day) {
							case 'mon':
								return _Utils_update(
									bufferDays,
									{mon: prevState});
							case 'tue':
								return _Utils_update(
									bufferDays,
									{tue: prevState});
							case 'wed':
								return _Utils_update(
									bufferDays,
									{wed: prevState});
							case 'thu':
								return _Utils_update(
									bufferDays,
									{thu: prevState});
							case 'fri':
								return _Utils_update(
									bufferDays,
									{fri: prevState});
							case 'sat':
								return _Utils_update(
									bufferDays,
									{sat: prevState});
							case 'sun':
								return _Utils_update(
									bufferDays,
									{sun: prevState});
							default:
								return bufferDays;
						}
					} else {
						return bufferDays;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							openHours: $author$project$Data$Location$OpenHours$During(newDaysForOpenHours),
							bufferOpenHours: $author$project$Data$Location$OpenHours$During(newDaysForBuffer)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UpdateHourSet':
				var stringSpanType = msg.a;
				var day = msg.b;
				var spanIndex = msg.c;
				var dayState = msg.d;
				var newText = msg.e;
				var validNumericValue = F2(
					function (fallback, value) {
						return ((value !== '') && (($elm$core$String$length(value) > 4) || _Utils_eq(
							$elm$core$String$toInt(value),
							$elm$core$Maybe$Nothing))) ? fallback : value;
					});
				var newSpanList = function () {
					if (dayState.$ === 'Open') {
						var spanList = dayState.a;
						return A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, span) {
									return _Utils_eq(index, spanIndex) ? ((stringSpanType === 'open') ? {
										open: A2(validNumericValue, span.open, newText),
										close: span.close
									} : {
										open: span.open,
										close: A2(validNumericValue, span.close, newText)
									}) : span;
								}),
							spanList);
					} else {
						return (stringSpanType === 'open') ? _List_fromArray(
							[
								{open: newText, close: ''}
							]) : _List_fromArray(
							[
								{open: '', close: newText}
							]);
					}
				}();
				var newOpenHours = A3(
					$author$project$Listings$Ui$OpenHours$updateDaySameState,
					model.openHours,
					day,
					$author$project$Data$Location$OpenHours$Open(newSpanList));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveDaySpanByIndex':
				var spanIndex = msg.a;
				var day = msg.b;
				var removeState = function (dayState) {
					if (dayState.$ === 'Open') {
						var spanList = dayState.a;
						return $author$project$Data$Location$OpenHours$Open(
							A2(
								$elm$core$List$append,
								A2($elm$core$List$take, spanIndex, spanList),
								A2($elm$core$List$drop, spanIndex + 1, spanList)));
					} else {
						return dayState;
					}
				};
				var newDays = function () {
					var _v10 = model.openHours;
					if (_v10.$ === 'During') {
						var days = _v10.a;
						switch (day) {
							case 'mon':
								return _Utils_update(
									days,
									{
										mon: removeState(days.mon)
									});
							case 'tue':
								return _Utils_update(
									days,
									{
										tue: removeState(days.tue)
									});
							case 'wed':
								return _Utils_update(
									days,
									{
										wed: removeState(days.wed)
									});
							case 'thu':
								return _Utils_update(
									days,
									{
										thu: removeState(days.thu)
									});
							case 'fri':
								return _Utils_update(
									days,
									{
										fri: removeState(days.fri)
									});
							case 'sat':
								return _Utils_update(
									days,
									{
										sat: removeState(days.sat)
									});
							case 'sun':
								return _Utils_update(
									days,
									{
										sun: removeState(days.sun)
									});
							default:
								return days;
						}
					} else {
						return {fri: $author$project$Data$Location$OpenHours$Closed, mon: $author$project$Data$Location$OpenHours$Closed, sat: $author$project$Data$Location$OpenHours$Closed, sun: $author$project$Data$Location$OpenHours$Closed, thu: $author$project$Data$Location$OpenHours$Closed, tue: $author$project$Data$Location$OpenHours$Closed, wed: $author$project$Data$Location$OpenHours$Closed};
					}
				}();
				var newOpenHours = A3($author$project$Listings$Ui$OpenHours$updateDayDifferentState, model.openHours, day, newDays);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'AddSpanToDay':
				var day = msg.a;
				var dayState = msg.b;
				var defaultSpan = {open: '0800', close: '1700'};
				var newSpanList = function () {
					switch (dayState.$) {
						case 'Open':
							var spanList = dayState.a;
							return ($elm$core$List$length(spanList) < 3) ? _Utils_ap(
								spanList,
								_List_fromArray(
									[defaultSpan])) : spanList;
						case 'Closed':
							return _List_fromArray(
								[defaultSpan]);
						case 'NotSpecified':
							return _List_fromArray(
								[defaultSpan]);
						default:
							return _List_fromArray(
								[defaultSpan]);
					}
				}();
				var newOpenHours = A3(
					$author$project$Listings$Ui$OpenHours$updateDaySameState,
					model.openHours,
					day,
					$author$project$Data$Location$OpenHours$Open(newSpanList));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours}),
					$elm$core$Platform$Cmd$none);
			case 'ResetDay':
				var day = msg.a;
				var newBufferOpenHours = A3($author$project$Listings$Ui$OpenHours$updateDaySameState, model.bufferOpenHours, day, $author$project$Data$Location$OpenHours$NotSpecified);
				var newOpenHours = A3($author$project$Listings$Ui$OpenHours$updateDaySameState, model.openHours, day, $author$project$Data$Location$OpenHours$NotSpecified);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHours, bufferOpenHours: newBufferOpenHours}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Locations$AddLocation$Model$Country = function (name) {
	return function (countryName) {
		return function (alternateCountryNames) {
			return function (countryShortCode) {
				return function (iso) {
					return function (iso3) {
						return function (postalCodeFormat) {
							return function (postalCodeRegex) {
								return function (countryCallingCodes) {
									return function (languages) {
										return function (regions) {
											return function (requiresRegions) {
												return function (requiresZip) {
													return {iso: iso, iso3: iso3, name: name, regions: regions, languages: languages, countryName: countryName, requiresZip: requiresZip, postalCodeRegex: postalCodeRegex, requiresRegions: requiresRegions, countryShortCode: countryShortCode, postalCodeFormat: postalCodeFormat, countryCallingCodes: countryCallingCodes, alternateCountryNames: alternateCountryNames};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Locations$AddLocation$Model$StoreId = {$: 'StoreId'};
var $author$project$Translations$Listings$ErrorMessages$unexpected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.unexpected');
};
var $myrho$elm_round$Round$funNum = F3(
	function (fun, s, fl) {
		return A2(
			$elm$core$Maybe$withDefault,
			0 / 0,
			$elm$core$String$toFloat(
				A2(fun, s, fl)));
	});
var $myrho$elm_round$Round$roundCom = $myrho$elm_round$Round$roundFun(
	F2(
		function (_v0, _int) {
			return 53 <= $elm$core$Char$toCode(
				A2(
					$elm$core$Maybe$withDefault,
					_Utils_chr('0'),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						$elm$core$String$uncons(_int))));
		}));
var $myrho$elm_round$Round$roundNumCom = $myrho$elm_round$Round$funNum($myrho$elm_round$Round$roundCom);
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Translations$Listings$AddLocation$failGeocoding = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.fail_geocoding');
};
var $author$project$Translations$Listings$AddLocation$storeIdUnique = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.store_id_unique');
};
var $author$project$Locations$AddLocation$Model$UnknownError = {$: 'UnknownError'};
var $author$project$Locations$AddLocation$Commands$dateToString = function (date) {
	return $justinmimbs$date$Date$toIsoString(date);
};
var $author$project$Locations$AddLocation$Commands$addressEncoder = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(address.street)),
				_Utils_Tuple2(
				'zip',
				$elm$json$Json$Encode$string(address.zip)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(address.city)),
				_Utils_Tuple2(
				'countryAlpha2Code',
				$elm$json$Json$Encode$string(address.countryAlpha2Code)),
				_Utils_Tuple2(
				'country',
				$elm$json$Json$Encode$string(address.country)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(address.state))
			]));
};
var $author$project$Locations$AddLocation$Commands$contactEncoder = function (contact) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(contact.email)),
				_Utils_Tuple2(
				'homepage',
				$elm$json$Json$Encode$string(contact.homepage)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(contact.phone))
			]));
};
var $author$project$Listings$Ui$OpenHours$encodeSpan = function (span) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'open',
				$elm$json$Json$Encode$string(span.open)),
				_Utils_Tuple2(
				'close',
				$elm$json$Json$Encode$string(span.close))
			]));
};
var $author$project$Listings$Ui$OpenHours$encodeDay = function (state) {
	var stateString = function () {
		switch (state.$) {
			case 'Open':
				return 'Open';
			case 'Closed':
				return 'Closed';
			case 'AlwaysOpen':
				return 'AlwaysOpen';
			default:
				return 'NotSpecified';
		}
	}();
	var spans = function () {
		if (state.$ === 'Open') {
			var spanList = state.a;
			return A2($elm$json$Json$Encode$list, $author$project$Listings$Ui$OpenHours$encodeSpan, spanList);
		} else {
			return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil);
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(stateString)),
				_Utils_Tuple2('span', spans)
			]));
};
var $author$project$Listings$Ui$OpenHours$encodeOpenHours = function (openHours) {
	if (openHours.$ === 'Always') {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mon',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen)),
					_Utils_Tuple2(
					'tue',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen)),
					_Utils_Tuple2(
					'wed',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen)),
					_Utils_Tuple2(
					'thu',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen)),
					_Utils_Tuple2(
					'fri',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen)),
					_Utils_Tuple2(
					'sat',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen)),
					_Utils_Tuple2(
					'sun',
					$author$project$Listings$Ui$OpenHours$encodeDay($author$project$Data$Location$OpenHours$AlwaysOpen))
				]));
	} else {
		var days = openHours.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mon',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.mon)),
					_Utils_Tuple2(
					'tue',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.tue)),
					_Utils_Tuple2(
					'wed',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.wed)),
					_Utils_Tuple2(
					'thu',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.thu)),
					_Utils_Tuple2(
					'fri',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.fri)),
					_Utils_Tuple2(
					'sat',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.sat)),
					_Utils_Tuple2(
					'sun',
					$author$project$Listings$Ui$OpenHours$encodeDay(days.sun))
				]));
	}
};
var $author$project$Locations$AddLocation$Commands$coordinatesEncoder = function (coordinates) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'lat',
				$elm$json$Json$Encode$float(coordinates.lat)),
				_Utils_Tuple2(
				'lon',
				$elm$json$Json$Encode$float(coordinates.lon))
			]));
};
var $author$project$Locations$AddLocation$Commands$encodeVerificationStatus = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'status',
			$elm$json$Json$Encode$bool(true))
		]));
var $author$project$Locations$AddLocation$Commands$encodeVerification = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2('addressAndCoordinates', $author$project$Locations$AddLocation$Commands$encodeVerificationStatus),
			_Utils_Tuple2('serviceAreas', $author$project$Locations$AddLocation$Commands$encodeVerificationStatus)
		]));
var $author$project$Locations$AddLocation$Commands$locationEncoder = function (model) {
	var serviceAreasField = _Utils_Tuple2(
		'serviceAreas',
		$author$project$Data$ServiceArea$encodeServiceAreas(
			$author$project$Common$ServiceAreaSelectorV2$ServiceAreaList$getAreaList(
				$author$project$Common$Form$unwrapFormState(model.serviceAreaSelector.selectedServiceAreas))));
	var coordinatesField = _Utils_Tuple2(
		'location',
		$author$project$Locations$AddLocation$Commands$coordinatesEncoder(
			{
				lat: A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(
						$author$project$Common$Form$unwrap(model.latitude))),
				lon: A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(
						$author$project$Common$Form$unwrap(model.longitude)))
			}));
	var addressField = _Utils_Tuple2(
		'address',
		$author$project$Locations$AddLocation$Commands$addressEncoder(
			{
				zip: $author$project$Common$Form$unwrap(model.zip),
				city: $author$project$Common$Form$unwrap(model.city),
				state: A3(
					$elm$core$Basics$composeR,
					$author$project$Common$Validators$ValidatedItem$unwrap,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.inputValue;
						},
						$author$project$Common$Form$unwrapFormState),
					model.region),
				street: $author$project$Common$Form$unwrap(model.street),
				country: A3(
					$elm$core$Basics$composeR,
					$author$project$Common$Validators$ValidatedItem$unwrap,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.inputValue;
						},
						$author$project$Common$Form$unwrapFormState),
					model.country),
				countryAlpha2Code: ''
			}));
	var conditionalFields = function () {
		var _v2 = model.locationType;
		switch (_v2.$) {
			case 'Storefront':
				return _List_fromArray(
					[addressField, coordinatesField]);
			case 'ServiceArea':
				return _List_fromArray(
					[serviceAreasField]);
			default:
				return _List_fromArray(
					[addressField, coordinatesField, serviceAreasField]);
		}
	}();
	var baseFields = _List_fromArray(
		[
			_Utils_Tuple2(
			'type',
			$elm$json$Json$Encode$string(
				function () {
					var _v0 = model.locationType;
					switch (_v0.$) {
						case 'Storefront':
							return 'storefront';
						case 'ServiceArea':
							return 'serviceArea';
						default:
							return 'storefrontAndServiceArea';
					}
				}())),
			_Utils_Tuple2(
			'storeId',
			$elm$json$Json$Encode$string(
				$author$project$Common$Form$unwrap(model.storeId))),
			_Utils_Tuple2(
			'locationDescriptor',
			$elm$json$Json$Encode$string(
				$author$project$Common$Validators$ValidatedItem$unwrap(model.storeLocationDescriptor))),
			_Utils_Tuple2(
			'google',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'custom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(
										$author$project$Common$Validators$ValidatedItem$unwrap(model.googleCustomName)))
								])))
					]))),
			_Utils_Tuple2(
			'facebook',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'custom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(
										$author$project$Common$Validators$ValidatedItem$unwrap(model.facebookCustomName)))
								])))
					]))),
			_Utils_Tuple2(
			'apple',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'custom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(
										$author$project$Common$Validators$ValidatedItem$unwrap(model.appleCustomName)))
								])))
					]))),
			_Utils_Tuple2(
			'ptv',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'custom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(
										$author$project$Common$Validators$ValidatedItem$unwrap(model.ptvCustomName)))
								])))
					]))),
			_Utils_Tuple2(
			'contact',
			$author$project$Locations$AddLocation$Commands$contactEncoder(
				{
					email: $author$project$Common$Validators$ValidatedItem$unwrap(model.email),
					phone: $author$project$Common$Validators$ValidatedItem$unwrap(model.phone),
					homepage: $author$project$Common$Validators$ValidatedItem$unwrap(model.homepage)
				})),
			_Utils_Tuple2(
			'longDescription',
			$elm$json$Json$Encode$string(
				$author$project$Common$Validators$ValidatedItem$unwrap(model.longDescription))),
			_Utils_Tuple2(
			'shortDescription',
			$elm$json$Json$Encode$string(
				$author$project$Common$Validators$ValidatedItem$unwrap(model.shortDescription))),
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(
				$author$project$Common$Form$unwrap(model.storefrontName))),
			_Utils_Tuple2(
			'wifiSsid',
			$elm$json$Json$Encode$string(
				$author$project$Common$Validators$ValidatedItem$unwrap(model.wifiSsid))),
			_Utils_Tuple2(
			'openingDate',
			function () {
				var _v1 = model.storeOpeningDate;
				if (_v1.$ === 'Just') {
					var date = _v1.a;
					return $elm$json$Json$Encode$string(
						$author$project$Locations$AddLocation$Commands$dateToString(date));
				} else {
					return $elm$json$Json$Encode$string('');
				}
			}()),
			_Utils_Tuple2(
			'isAlwaysOpen',
			$elm$json$Json$Encode$bool(
				$author$project$Listings$Ui$OpenHours$isAlwaysOpen(model.openHours))),
			_Utils_Tuple2('verification', $author$project$Locations$AddLocation$Commands$encodeVerification),
			_Utils_Tuple2(
			'openHours',
			$author$project$Listings$Ui$OpenHours$encodeOpenHours(model.openHours.openHours))
		]);
	return $elm$json$Json$Encode$object(
		_Utils_ap(baseFields, conditionalFields));
};
var $author$project$Locations$AddLocation$Model$FieldError = F2(
	function (details, message) {
		return {details: details, message: message};
	});
var $author$project$Locations$AddLocation$Model$UnknownKey = {$: 'UnknownKey'};
var $author$project$Locations$AddLocation$Model$FieldErrors = function (a) {
	return {$: 'FieldErrors', a: a};
};
var $author$project$Locations$AddLocation$Model$ValidationError = function (a) {
	return {$: 'ValidationError', a: a};
};
var $author$project$Locations$AddLocation$Model$FieldErrorDetail = function (key) {
	return {key: key};
};
var $author$project$Locations$AddLocation$Commands$decodeValidationError = function () {
	var decodeFieldErrorDetail = A2(
		$elm$json$Json$Decode$map,
		$author$project$Locations$AddLocation$Model$FieldErrorDetail,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	var decodeFieldError = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'details',
			decodeFieldErrorDetail,
			$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$FieldError)));
	var fieldErrorKeyDecoder = A2(
		$elm$json$Json$Decode$field,
		'errors',
		$elm$json$Json$Decode$list(decodeFieldError));
	var fieldErrorDecoder = A2($elm$json$Json$Decode$map, $author$project$Locations$AddLocation$Model$FieldErrors, fieldErrorKeyDecoder);
	var errorKey = A2(
		$elm$json$Json$Decode$map,
		function (s) {
			if (s === 'storeId') {
				return $author$project$Locations$AddLocation$Model$StoreId;
			} else {
				return $author$project$Locations$AddLocation$Model$UnknownKey;
			}
		},
		$elm$json$Json$Decode$string);
	var errorKeyDecoder = A2(
		$elm$json$Json$Decode$field,
		'errors',
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$field,
				'details',
				A2($elm$json$Json$Decode$field, 'key', errorKey))));
	var validationKeyErrorDecoder = A2($elm$json$Json$Decode$map, $author$project$Locations$AddLocation$Model$ValidationError, errorKeyDecoder);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				fieldErrorDecoder,
				validationKeyErrorDecoder,
				$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$UnknownError)
			]));
}();
var $author$project$Locations$AddLocation$Model$CreateLocationResponse = function (message) {
	return {message: message};
};
var $author$project$Locations$AddLocation$Commands$createLocation = F3(
	function (siteName, model, msg) {
		var _v0 = siteName;
		var sitenameName = _v0.a;
		var successDecoder = A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'message',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$CreateLocationResponse));
		var responseDecoder = function (response) {
			switch (response.$) {
				case 'BadUrl_':
					return $elm$core$Result$Err($author$project$Locations$AddLocation$Model$UnknownError);
				case 'Timeout_':
					return $elm$core$Result$Err($author$project$Locations$AddLocation$Model$UnknownError);
				case 'NetworkError_':
					return $elm$core$Result$Err($author$project$Locations$AddLocation$Model$UnknownError);
				case 'BadStatus_':
					var body = response.b;
					var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Locations$AddLocation$Commands$decodeValidationError, body);
					if (_v2.$ === 'Ok') {
						var error = _v2.a;
						return $elm$core$Result$Err(error);
					} else {
						return $elm$core$Result$Err($author$project$Locations$AddLocation$Model$UnknownError);
					}
				default:
					var body = response.b;
					var _v3 = A2($elm$json$Json$Decode$decodeString, successDecoder, body);
					if (_v3.$ === 'Ok') {
						var value = _v3.a;
						return $elm$core$Result$Ok(value);
					} else {
						return $elm$core$Result$Err($author$project$Locations$AddLocation$Model$UnknownError);
					}
			}
		};
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectStringResponse, msg, responseDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Locations$AddLocation$Commands$locationEncoder(model),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (sitenameName + '/place')))));
	});
var $author$project$Translations$Listings$AddLocation$successMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.success_message');
};
var $author$project$Locations$AddLocation$Model$ZipRequired = {$: 'ZipRequired'};
var $author$project$Locations$AddLocation$Model$zipRequirement = F2(
	function (countryName, countryData) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Locations$AddLocation$Model$ZipNotRequired,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return c.requiresZip ? $author$project$Locations$AddLocation$Model$ZipRequired : $author$project$Locations$AddLocation$Model$ZipNotRequired;
				},
				A2($elm$core$Dict$get, countryName, countryData)));
	});
var $author$project$Translations$Listings$AddLocation$invalidEmail = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.invalid_email');
};
var $author$project$Locations$AddLocation$Main$emailValidators = _List_fromArray(
	[
		function (input) {
		var atSymbol = '@';
		var domain = '([^@\u005Cs]+\u005C.)+';
		var local = '^[^@\u005Cs]+';
		var tld = '[^@\u005Cs]{2,}$';
		var allowedInput = _Utils_ap(
			local,
			_Utils_ap(
				atSymbol,
				_Utils_ap(domain, tld)));
		return (!$elm$core$String$length(input)) ? $elm$core$Result$Ok('') : (A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString(allowedInput)),
			input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err($author$project$Translations$Listings$AddLocation$invalidEmail));
	}
	]);
var $author$project$Translations$Listings$AddLocation$invalidPhone = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.invalid_phone');
};
var $author$project$Locations$AddLocation$Main$phoneValidators = _List_fromArray(
	[
		function (input) {
		var allowedInput = '^(?:\u005C+[0-9]+|[0-9]+)$';
		return (!$elm$core$String$length(input)) ? $elm$core$Result$Ok('') : (A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString(allowedInput)),
			input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err($author$project$Translations$Listings$AddLocation$invalidPhone));
	}
	]);
var $author$project$Locations$AddLocation$Commands$GeoLookupAddress = F4(
	function (street, zip, city, countryAlpha2Code) {
		return {zip: zip, city: city, street: street, countryAlpha2Code: countryAlpha2Code};
	});
var $author$project$Locations$AddLocation$Model$OnGeocodeResponse = function (a) {
	return {$: 'OnGeocodeResponse', a: a};
};
var $author$project$Locations$AddLocation$Main$wifiSsidValidator = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$maxLength(32)
	]);
var $author$project$Locations$AddLocation$Commands$geoLookupAddressEncoder = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'address',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'street',
							$elm$json$Json$Encode$string(address.street)),
							_Utils_Tuple2(
							'zip',
							$elm$json$Json$Encode$string(address.zip)),
							_Utils_Tuple2(
							'city',
							$elm$json$Json$Encode$string(address.city)),
							_Utils_Tuple2(
							'countryAlpha2Code',
							$elm$json$Json$Encode$string(address.countryAlpha2Code))
						])))
			]));
};
var $author$project$Locations$AddLocation$Model$GeoLookupResponse = function (coordinates) {
	return {coordinates: coordinates};
};
var $author$project$Locations$AddLocation$Model$Coordinates = F2(
	function (lat, lon) {
		return {lat: lat, lon: lon};
	});
var $author$project$Locations$AddLocation$Commands$coordinatesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lon',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lat',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$Coordinates)));
var $author$project$Locations$AddLocation$Commands$geoLookupResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coordinates',
	$author$project$Locations$AddLocation$Commands$coordinatesDecoder,
	$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Model$GeoLookupResponse));
var $author$project$Locations$AddLocation$Commands$geocodeFromAddress = F3(
	function (siteName, address, msg) {
		var _v0 = siteName;
		var sitenameName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$AddLocation$Commands$geoLookupResponseDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Locations$AddLocation$Commands$geoLookupAddressEncoder(address),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (sitenameName + '/google/geo/forward-lookup')))));
	});
var $author$project$Translations$Listings$AddLocation$invalidHomepage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.add_location.invalid_homepage');
};
var $author$project$Locations$AddLocation$Main$homepageValidators = _List_fromArray(
	[
		function (input) {
		var allowedInput = '^((https|http):\u005C/\u005C/)?([a-zA-Z0-9\u005Cu00C0-\u005Cu017F]+[a-zA-Z0-9\u005Cu00C0-\u005Cu017F\u005C.-]*[a-zA-Z0-9\u005Cu00C0-\u005Cu017F]+|[a-zA-Z0-9\u005Cu00C0-\u005Cu017F])\u005C.[a-zA-Z0-9]{2,}(((\u005C/|\u005C?|\u005C/\u005C?)[\u005Cs\u005CS]*[\u005Cw\u005CW]*[\u005Cd\u005CD]*)*)$';
		return (!$elm$core$String$length(input)) ? $elm$core$Result$Ok('') : (A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString(allowedInput)),
			input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err($author$project$Translations$Listings$AddLocation$invalidHomepage));
	}
	]);
var $author$project$Locations$AddLocation$Main$customNameValidator = _List_fromArray(
	[$author$project$Locations$AddLocation$Main$csvInjectionSafe]);
var $author$project$Locations$AddLocation$Model$OnCreateLocationResponse = function (a) {
	return {$: 'OnCreateLocationResponse', a: a};
};
var $author$project$Locations$AddLocation$Main$longDescriptionValidators = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$maxLength(750),
		$author$project$Locations$AddLocation$Main$csvInjectionSafe
	]);
var $author$project$Locations$AddLocation$Main$canGeocodeFromAddressCheck = function (model) {
	return $author$project$Common$Validators$ValidatedItem$allValid(
		_List_fromArray(
			[
				A2(
				$author$project$Common$Validators$ValidatedItem$validate,
				_List_fromArray(
					[$author$project$Locations$AddLocation$Main$required]),
				$author$project$Common$Form$unwrap(model.street)),
				A2(
				$author$project$Common$Validators$ValidatedItem$validate,
				_List_fromArray(
					[$author$project$Locations$AddLocation$Main$required]),
				$author$project$Common$Form$unwrap(model.city)),
				A2(
				$author$project$Common$Validators$ValidatedItem$validate,
				_List_fromArray(
					[$author$project$Locations$AddLocation$Main$required]),
				$author$project$Common$Form$unwrapFormState(
					$author$project$Common$Validators$ValidatedItem$unwrap(model.country).inputValue))
			]));
};
var $author$project$Locations$AddLocation$Main$shortDescriptionValidators = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$maxLength(255),
		$author$project$Locations$AddLocation$Main$csvInjectionSafe
	]);
var $author$project$Locations$AddLocation$Main$storeLocationDescriptorValidators = _List_fromArray(
	[
		$author$project$Locations$AddLocation$Main$maxLength(75),
		$author$project$Locations$AddLocation$Main$csvInjectionSafe
	]);
var $author$project$Locations$AddLocation$Main$out_Locations_AddLocation_Main_PreventOutNavigation = _Platform_outgoingPort('out_Locations_AddLocation_Main_PreventOutNavigation', $elm$json$Json$Encode$bool);
var $author$project$Locations$AddLocation$Main$update = F3(
	function (session, msg, model) {
		var dirtyForm = function (cmd) {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$Locations$AddLocation$Main$out_Locations_AddLocation_Main_PreventOutNavigation(true)
					]));
		};
		switch (msg.$) {
			case 'OnDisableSubscriptions':
				return _Utils_Tuple2(
					model,
					$author$project$Locations$AddLocation$Main$out_Locations_AddLocation_Main_PreventOutNavigation(false));
			case 'StorefrontNameChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$storefrontNameValidators, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							errorMessage: $elm$core$Maybe$Nothing,
							storefrontName: $author$project$Common$Form$Edited(validatedItem),
							successMessage: $elm$core$Maybe$Nothing
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'StoreIdChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$storeIdValidators, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							storeId: $author$project$Common$Form$Edited(validatedItem),
							errorMessage: $elm$core$Maybe$Nothing,
							successMessage: $elm$core$Maybe$Nothing
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'StoreLocationDescriptorChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$storeLocationDescriptorValidators, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{storeLocationDescriptor: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'StoreOpeningDateChanged':
				var d = msg.a;
				var newDate = function () {
					if (d.$ === 'DateChanged') {
						var date = d.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{storeOpeningDate: newDate}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'GoogleCustomNameChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$customNameValidator, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{googleCustomName: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'FacebookCustomNameChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$customNameValidator, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{facebookCustomName: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'AppleCustomNameChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$customNameValidator, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{appleCustomName: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'PtvCustomNameChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$customNameValidator, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ptvCustomName: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'LocationTypeChanged':
				var t = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationType: t}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'ServiceAreaSelectorMsg':
				var msg_ = msg.a;
				var _v2 = A2($author$project$Common$ServiceAreaSelectorV2$Update$update, msg_, model.serviceAreaSelector);
				var newServiceAreaSelector = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{serviceAreaSelector: newServiceAreaSelector}),
					dirtyForm(
						A2($elm$core$Platform$Cmd$map, $author$project$Locations$AddLocation$Model$ServiceAreaSelectorMsg, cmd)));
			case 'MapPinMoved':
				var c = msg.b;
				var newLongitude = $author$project$Common$Form$Clean(
					A2(
						$author$project$Common$Validators$ValidatedItem$map,
						$elm$core$String$fromFloat,
						A2(
							$author$project$Common$Validators$ValidatedItem$validate,
							_List_fromArray(
								[
									A2($author$project$Locations$AddLocation$Main$validCoordinate, -180, 180)
								]),
							c.lon)));
				var newLatitude = $author$project$Common$Form$Clean(
					A2(
						$author$project$Common$Validators$ValidatedItem$map,
						$elm$core$String$fromFloat,
						A2(
							$author$project$Common$Validators$ValidatedItem$validate,
							_List_fromArray(
								[
									A2($author$project$Locations$AddLocation$Main$validCoordinate, -90, 90)
								]),
							c.lat)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{latitude: newLatitude, longitude: newLongitude}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'LatInputChanged':
				var lat = msg.a;
				var newLatitude = $author$project$Common$Form$Edited(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$latitudeValidators, lat));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{latitude: newLatitude}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'LonInputChanged':
				var lon = msg.a;
				var newLongitude = $author$project$Common$Form$Edited(
					A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$longitudeValidators, lon));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{longitude: newLongitude}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'StreetChanged':
				var s = msg.a;
				var newModel = _Utils_update(
					model,
					{
						street: $author$project$Common$Form$Edited(
							A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$streetValidators, s))
					});
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{
							canGeocodeFromAddress: $author$project$Locations$AddLocation$Main$canGeocodeFromAddressCheck(newModel)
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'ZipChanged':
				var s = msg.a;
				var countryName = $author$project$Locations$AddLocation$Model$getCountryName(model);
				var zipReq = A2($author$project$Locations$AddLocation$Model$zipRequirement, countryName, model.countryData);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							zip: $author$project$Common$Form$Edited(
								A2(
									$author$project$Common$Validators$ValidatedItem$validate,
									$author$project$Locations$AddLocation$Main$zipValidators(zipReq),
									s))
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'CityChanged':
				var s = msg.a;
				var newModel = _Utils_update(
					model,
					{
						city: $author$project$Common$Form$Edited(
							A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$cityValidators, s))
					});
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{
							canGeocodeFromAddress: $author$project$Locations$AddLocation$Main$canGeocodeFromAddressCheck(newModel)
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'GetCountryData':
				return _Utils_Tuple2(
					model,
					$author$project$Locations$AddLocation$Commands$getCountryData($author$project$Locations$AddLocation$Model$CountryDataLoaded));
			case 'CountryDataLoaded':
				if (msg.a.$ === 'Ok') {
					var countryData = msg.a.a;
					var toDecoratedCountry = F3(
						function (country, requiresRegions, requiresZip) {
							return $author$project$Locations$AddLocation$Model$Country(country.name)(country.countryName)(country.alternateCountryNames)(country.countryShortCode)(country.iso)(country.iso3)(country.postalCodeFormat)(country.postalCodeRegex)(country.countryCallingCodes)(country.languages)(country.regions)(requiresRegions)(requiresZip);
						});
					var newCountryData = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (c) {
								return _Utils_Tuple2(
									c.countryName,
									A3(
										toDecoratedCountry,
										c,
										A2($elm$core$List$member, c.iso, countryData.countriesRequiresRegion),
										!A2($elm$core$List$member, c.iso, countryData.countriesNotRequireZip)));
							},
							countryData.countries));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{countryData: newCountryData}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'RegionChanged':
				var msg_ = msg.a;
				var _v3 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Common$Validators$ValidatedItem$validate(
						$author$project$Locations$AddLocation$Main$regionValidators(
							A2(
								$author$project$Locations$AddLocation$Model$regionRequirement,
								$author$project$Locations$AddLocation$Model$getCountryName(model),
								model.countryData))),
					A2(
						$author$project$Listings$Ui$AutoComplete$update,
						msg_,
						$author$project$Common$Validators$ValidatedItem$unwrap(model.region)));
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{region: newModel}),
					cmd);
			case 'CountriesLoaded':
				if (msg.a.$ === 'Ok') {
					var result = msg.a.a;
					var countryOptions = A2(
						$elm$core$List$map,
						function (countryName) {
							return $author$project$Listings$Ui$AutoComplete$Selectable(countryName.name);
						},
						result);
					var updatedCountryModel = A2(
						$author$project$Common$Validators$ValidatedItem$validate,
						$author$project$Locations$AddLocation$Main$countryValidators,
						function (country) {
							return _Utils_update(
								country,
								{values: countryOptions});
						}(
							$author$project$Common$Validators$ValidatedItem$unwrap(model.country)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{country: updatedCountryModel}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'CountryChanged':
				var msg_ = msg.a;
				var newCountryName = $author$project$Locations$AddLocation$Model$getCountryName(model);
				var newZipRequirement = A2($author$project$Locations$AddLocation$Model$zipRequirement, newCountryName, model.countryData);
				var regionsForCountry = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$andThen,
						function (c) {
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$List$map,
									function (r) {
										return r.name;
									},
									c.regions));
						},
						A2($elm$core$Dict$get, newCountryName, model.countryData)));
				var newRegion = A2(
					$author$project$Common$Validators$ValidatedItem$validate,
					$author$project$Locations$AddLocation$Main$regionValidators(
						A2($author$project$Locations$AddLocation$Model$regionRequirement, newCountryName, model.countryData)),
					_Utils_update(
						$author$project$Listings$Ui$AutoComplete$defaultModel,
						{
							values: A2($elm$core$List$map, $author$project$Listings$Ui$AutoComplete$Selectable, regionsForCountry)
						}));
				var newZip = A2(
					$author$project$Common$Validators$ValidatedItem$validate,
					$author$project$Locations$AddLocation$Main$zipValidators(newZipRequirement),
					$author$project$Common$Form$unwrap(model.zip));
				var _v4 = A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Common$Validators$ValidatedItem$validate($author$project$Locations$AddLocation$Main$countryValidators),
					A2(
						$author$project$Listings$Ui$AutoComplete$update,
						msg_,
						$author$project$Common$Validators$ValidatedItem$unwrap(model.country)));
				var newCountry = _v4.a;
				var cmd = _v4.b;
				var updatedModel = _Utils_update(
					model,
					{
						zip: $author$project$Common$Form$Edited(newZip),
						region: newRegion,
						country: newCountry
					});
				return _Utils_Tuple2(
					_Utils_update(
						updatedModel,
						{
							canGeocodeFromAddress: $author$project$Locations$AddLocation$Main$canGeocodeFromAddressCheck(updatedModel)
						}),
					dirtyForm(cmd));
			case 'WifiSsidChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$wifiSsidValidator, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{wifiSsid: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'HomepageChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$homepageValidators, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{homepage: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'HomepageBlurred':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{homepageBlurred: true}),
					$elm$core$Platform$Cmd$none);
			case 'PhoneChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$phoneValidators, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{phone: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'PhoneBlurred':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{phoneBlurred: true}),
					$elm$core$Platform$Cmd$none);
			case 'EmailChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$emailValidators, s);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{email: validatedItem}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'EmailBlurred':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{emailBlurred: true}),
					$elm$core$Platform$Cmd$none);
			case 'ShortDescriptionChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$shortDescriptionValidators, s);
				var overLimit = $elm$core$String$length(s) > 255;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{shortDescription: validatedItem, shortDescriptionCharOverLimit: overLimit}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'LongDescriptionChanged':
				var s = msg.a;
				var validatedItem = A2($author$project$Common$Validators$ValidatedItem$validate, $author$project$Locations$AddLocation$Main$longDescriptionValidators, s);
				var overLimit = $elm$core$String$length(s) > 750;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{longDescription: validatedItem, longDescriptionCharOverLimit: overLimit}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'OpenHoursMsg':
				var openHourMsg = msg.a;
				var _v5 = A2($author$project$Listings$Ui$OpenHours$update, openHourMsg, model.openHours);
				var newOpenHoursModel = _v5.a;
				var newOpenHoursCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHours: newOpenHoursModel}),
					dirtyForm(
						A2($elm$core$Platform$Cmd$map, $author$project$Locations$AddLocation$Model$OpenHoursMsg, newOpenHoursCmd)));
			case 'CreateLocationClicked':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{errorMessage: $elm$core$Maybe$Nothing, successMessage: $elm$core$Maybe$Nothing}),
					A3($author$project$Locations$AddLocation$Commands$createLocation, session.siteName, model, $author$project$Locations$AddLocation$Model$OnCreateLocationResponse));
			case 'ClearFormClicked':
				var _v6 = A3($author$project$Locations$AddLocation$Main$initialModel, session, model.chainName, model.displayName);
				var clearedModel = _v6.a;
				var cmd = _v6.b;
				var finalModel = _Utils_update(
					clearedModel,
					{countryData: model.countryData});
				return _Utils_Tuple2(finalModel, cmd);
			case 'OnCreateLocationResponse':
				if (msg.a.$ === 'Ok') {
					var response = msg.a.a;
					var _v7 = response.message;
					if (_v7.$ === 'Just') {
						var message = _v7.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errorMessage: $elm$core$Maybe$Just(message),
									successMessage: $elm$core$Maybe$Nothing
								}),
							dirtyForm($elm$core$Platform$Cmd$none));
					} else {
						var _v8 = A3($author$project$Locations$AddLocation$Main$initialModel, session, model.chainName, model.displayName);
						var clearedModel = _v8.a;
						var cmd = _v8.b;
						var finalModel = _Utils_update(
							clearedModel,
							{
								countryData: model.countryData,
								successMessage: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$AddLocation$successMessage(session.translations))
							});
						return _Utils_Tuple2(
							finalModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A2(
										$elm$core$Task$perform,
										function (_v9) {
											return $author$project$Locations$AddLocation$Model$NoOp;
										},
										A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
										$author$project$Locations$AddLocation$Main$out_Locations_AddLocation_Main_PreventOutNavigation(false)
									])));
					}
				} else {
					var httpError = msg.a.a;
					var errorMessage = function () {
						switch (httpError.$) {
							case 'UnknownError':
								return $elm$core$Maybe$Just(
									$author$project$Translations$Listings$ErrorMessages$unexpected(session.translations));
							case 'FieldErrors':
								var errorKeys = httpError.a;
								return $elm$core$Maybe$Just(
									A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.message;
											},
											errorKeys)));
							default:
								var errorKeys = httpError.a;
								return A2(
									$elm$core$List$any,
									$elm$core$Basics$eq($author$project$Locations$AddLocation$Model$StoreId),
									errorKeys) ? $elm$core$Maybe$Just(
									$author$project$Translations$Listings$AddLocation$storeIdUnique(session.translations)) : $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{errorMessage: errorMessage, successMessage: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				}
			case 'GetFromAddressClicked':
				var countryName = $author$project$Locations$AddLocation$Model$getCountryName(model);
				var maybeCountryIso = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.iso;
					},
					A2($elm$core$Dict$get, countryName, model.countryData));
				var address = A4(
					$author$project$Locations$AddLocation$Commands$GeoLookupAddress,
					$author$project$Common$Form$unwrap(model.street),
					$author$project$Common$Form$unwrap(model.zip),
					$author$project$Common$Form$unwrap(model.city),
					A2($elm$core$Maybe$withDefault, '', maybeCountryIso));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{geocodingError: $elm$core$Maybe$Nothing, canGeocodeFromAddress: false, isGeocodingInProgress: true}),
					A3($author$project$Locations$AddLocation$Commands$geocodeFromAddress, session.siteName, address, $author$project$Locations$AddLocation$Model$OnGeocodeResponse));
			case 'OnGeocodeResponse':
				if (msg.a.$ === 'Ok') {
					var response = msg.a.a;
					var newLon = A2($myrho$elm_round$Round$roundNumCom, 6, response.coordinates.lon);
					var newLongitude = $author$project$Common$Form$Clean(
						A2(
							$author$project$Common$Validators$ValidatedItem$map,
							$elm$core$String$fromFloat,
							A2(
								$author$project$Common$Validators$ValidatedItem$validate,
								_List_fromArray(
									[
										A2($author$project$Locations$AddLocation$Main$validCoordinate, -180, 180)
									]),
								newLon)));
					var newLat = A2($myrho$elm_round$Round$roundNumCom, 6, response.coordinates.lat);
					var newLatitude = $author$project$Common$Form$Clean(
						A2(
							$author$project$Common$Validators$ValidatedItem$map,
							$elm$core$String$fromFloat,
							A2(
								$author$project$Common$Validators$ValidatedItem$validate,
								_List_fromArray(
									[
										A2($author$project$Locations$AddLocation$Main$validCoordinate, -90, 90)
									]),
								newLat)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{latitude: newLatitude, longitude: newLongitude, geocodingError: $elm$core$Maybe$Nothing, canGeocodeFromAddress: true, isGeocodingInProgress: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								geocodingError: $elm$core$Maybe$Just(
									$author$project$Translations$Listings$AddLocation$couldNotFind(session.translations)),
								canGeocodeFromAddress: $author$project$Locations$AddLocation$Main$canGeocodeFromAddressCheck(model),
								isGeocodingInProgress: false
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{
								data: err,
								context: 'Locations.AddLocation.Main.OnGeocodeResponse',
								message: $author$project$Translations$Listings$AddLocation$failGeocoding(session.translations)
							}));
				}
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'LongDescriptionMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							longDescriptionState: A2($author$project$PinMeTo$Ui$Form$Textarea$update, msg_, model.longDescriptionState)
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			case 'ShortDescriptionMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							shortDescriptionState: A2($author$project$PinMeTo$Ui$Form$Textarea$update, msg_, model.shortDescriptionState)
						}),
					dirtyForm($elm$core$Platform$Cmd$none));
			default:
				var msg_ = msg.a;
				var _v11 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Locations$AddLocation$Model$PopOverMsg, msg_, model.uiPopOverState);
				var newState = _v11.a;
				var cmd = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiPopOverState: newState}),
					cmd);
		}
	});
var $author$project$Locations$AddLocation$Main$Flags = F2(
	function (displayName, chainName) {
		return {chainName: chainName, displayName: displayName};
	});
var $author$project$Locations$AddLocation$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'chainName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'displayName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Locations$AddLocation$Main$Flags)));
var $author$project$Common$PollPortModule$disableSubscriptions = _Platform_incomingPort(
	'disableSubscriptions',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$Locations$AddLocation$Model$OnDisableSubscriptions = {$: 'OnDisableSubscriptions'};
var $author$project$Locations$AddLocation$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Locations$AddLocation$Main$init,
		view: $author$project$Locations$AddLocation$View$view,
		update: $author$project$Locations$AddLocation$Main$update,
		flagsDecoder: $author$project$Locations$AddLocation$Main$flagsDecoder,
		subscriptions: function (_v0) {
			return $author$project$Common$PollPortModule$disableSubscriptions(
				function (_v1) {
					return $author$project$Locations$AddLocation$Model$OnDisableSubscriptions;
				});
		}
	});
var $author$project$ApiPendingChanges$Log$Model$init = {uiTable: $author$project$PinMeTo$Ui$Table$init, showMore: $elm$core$Maybe$Nothing, siteName: '', locations: $author$project$RemoteData$Loading, translations: $author$project$Common$Language$initialTranslationsFallback};
var $author$project$ApiPendingChanges$Log$Model$Flags = F2(
	function (siteName, translations) {
		return {siteName: siteName, translations: translations};
	});
var $author$project$ApiPendingChanges$Log$Update$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['user', 'selectedSite', 'name']),
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$ApiPendingChanges$Log$Model$Flags)));
var $author$project$ApiPendingChanges$Log$Update$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$ApiPendingChanges$Log$Update$flagsDecoder, flagsValue);
};
var $author$project$ApiPendingChanges$Log$Commands$Location = F8(
	function (id, locationDescriptor, storeId, address, coordinates, addressChanges, coordinatesChange, lastChange) {
		return {id: id, address: address, storeId: storeId, lastChange: lastChange, coordinates: coordinates, addressChanges: addressChanges, coordinatesChange: coordinatesChange, locationDescriptor: locationDescriptor};
	});
var $author$project$ApiPendingChanges$Log$Commands$locationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'lastPendingChange',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pendingLocation',
		$elm$json$Json$Decode$nullable($author$project$Data$Coordinates$coordinatesDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pendingAddress',
			$author$project$Data$Address$addressDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$author$project$Data$Coordinates$coordinatesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address',
					$author$project$Data$Address$addressDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'storeId',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'locationDescriptor',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'_id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$ApiPendingChanges$Log$Commands$Location)))))))));
var $author$project$ApiPendingChanges$Log$Commands$decodeLocations = $elm$json$Json$Decode$list($author$project$ApiPendingChanges$Log$Commands$locationDecoder);
var $author$project$ApiPendingChanges$Log$Commands$getIgnoredApiChanges = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$ApiPendingChanges$Log$Commands$decodeLocations),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/apipendingchanges/listignored')))));
	});
var $author$project$ApiPendingChanges$Log$Commands$revertResultDecoder = $elm$json$Json$Decode$succeed(true);
var $author$project$ApiPendingChanges$Log$Commands$revertIgnoredApiChange = F3(
	function (siteName, locationId, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$ApiPendingChanges$Log$Commands$revertResultDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + ('/places/apipendingchanges/removeignored/' + locationId))))));
	});
var $author$project$ApiPendingChanges$Log$Update$IgnoredLocationsResponse = function (a) {
	return {$: 'IgnoredLocationsResponse', a: a};
};
var $author$project$ApiPendingChanges$Log$Update$RevertIgnoredApiChangeResponse = F2(
	function (a, b) {
		return {$: 'RevertIgnoredApiChangeResponse', a: a, b: b};
	});
var $author$project$ApiPendingChanges$Log$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'IgnoredLocationsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var locations = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: $author$project$RemoteData$Loaded(locations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'ApiPendingChanges.Log.Update', message: 'Failed to decode response IgnoredLocationsResponse'}));
				}
			case 'HandleFlags':
				var flagsValue = msg.a;
				var _v2 = $author$project$ApiPendingChanges$Log$Update$decodeFlags(flagsValue);
				if (_v2.$ === 'Ok') {
					var flags = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{siteName: flags.siteName, translations: flags.translations}),
						A2($author$project$ApiPendingChanges$Log$Commands$getIgnoredApiChanges, flags.siteName, $author$project$ApiPendingChanges$Log$Update$IgnoredLocationsResponse));
				} else {
					var err = _v2.a;
					return _Utils_Tuple2(
						$author$project$ApiPendingChanges$Log$Model$init,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'ApiPendingChanges.Log.Update',
								message: 'Failed to decode flags'
							}));
				}
			case 'OnLanguageChanged':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var t = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{translations: t}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$author$project$ApiPendingChanges$Log$Model$init,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'ApiPendingChanges.Log.Update',
								message: 'Failed to decode translations'
							}));
				}
			case 'RemovedIgnored':
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$ApiPendingChanges$Log$Commands$revertIgnoredApiChange,
						model.siteName,
						id,
						$author$project$ApiPendingChanges$Log$Update$RevertIgnoredApiChangeResponse(id)));
			case 'RevertIgnoredApiChangeResponse':
				var locationId = msg.a;
				var response = msg.b;
				if (response.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locations: A2(
									$author$project$RemoteData$map,
									$elm$core$List$filter(
										function (x) {
											return !_Utils_eq(x.id, locationId);
										}),
									model.locations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = response.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'ApiPendingChanges.Log.Update', message: 'Failed to decode response RevertIgnoredApiChangeResponse'}));
				}
			case 'ShowMore':
				var x = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showMore: x}),
					$elm$core$Platform$Cmd$none);
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var resetModel = msg.a;
				return _Utils_Tuple2(resetModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ApiPendingChanges$Log$Update$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$ApiPendingChanges$Log$Main$init = function (flags) {
	return A2(
		$author$project$ApiPendingChanges$Log$Update$update,
		$author$project$ApiPendingChanges$Log$Update$HandleFlags(flags),
		$author$project$ApiPendingChanges$Log$Model$init);
};
var $author$project$PinMeTo$Ui$EmptyState$view = F2(
	function (message, iconSrc) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-empty-state')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state__icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									_Utils_ap($author$project$Env$paths.pmtUiPath, iconSrc))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state__message')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	});
var $author$project$PinMeTo$Ui$EmptyState$iconSvg = function (icon) {
	switch (icon.$) {
		case 'Done':
			return '/svg/empty-states/Empty_states_Done.svg';
		case 'Comments':
			return '/svg/empty-states/Empty_states_Comments.svg';
		case 'Connect':
			return '/svg/empty-states/Empty_states_Connect.svg';
		case 'Insights':
			return '/svg/empty-states/Empty_states_Insights.svg';
		case 'Location':
			return '/svg/empty-states/Empty_states_Location.svg';
		default:
			return '/svg/empty-states/Empty_states_Posts.svg';
	}
};
var $author$project$PinMeTo$Ui$EmptyState$Location = {$: 'Location'};
var $author$project$PinMeTo$Ui$EmptyState$location = function (message) {
	return A2(
		$author$project$PinMeTo$Ui$EmptyState$view,
		message,
		$author$project$PinMeTo$Ui$EmptyState$iconSvg($author$project$PinMeTo$Ui$EmptyState$Location));
};
var $author$project$Translations$Listings$ApiDifference$noDifference = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.no_difference');
};
var $author$project$Translations$Listings$ApiDifference$action = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.action');
};
var $author$project$ApiPendingChanges$Log$Update$ShowMore = function (a) {
	return {$: 'ShowMore', a: a};
};
var $author$project$ApiPendingChanges$Log$Update$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$ApiDifference$reviewDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.review_date');
};
var $author$project$Common$AddressEditor$withCoordinates = F2(
	function (coordinates, config) {
		return _Utils_update(
			config,
			{
				coordinates: $elm$core$Maybe$Just(coordinates)
			});
	});
var $author$project$ApiPendingChanges$Log$View$changesView = F2(
	function (location, model) {
		var conflict = function (f) {
			return f(location.addressChanges) !== '';
		};
		return A2(
			$author$project$PinMeTo$Ui$Layout$Grid$render,
			$author$project$PinMeTo$Ui$Layout$Grid$flex,
			_List_fromArray(
				[
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					$author$project$Conflicts$FieldEditor$FieldEditor$view(
						{
							data: $author$project$Common$AddressEditor$view(
								A2(
									$author$project$Common$AddressEditor$withCoordinates,
									location.coordinates,
									A2($author$project$Common$AddressEditor$withAddress, location.address, model.translations))),
							title: $author$project$Translations$General$locationAddress(model.translations)
						})),
					$author$project$Conflicts$FieldEditor$FieldEditor$render(
					A2(
						$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName,
						$author$project$Translations$Listings$ApiDifference$apiData(model.translations),
						$author$project$Conflicts$FieldEditor$FieldEditor$view(
							{
								data: $author$project$Common$AddressEditor$view(
									A2(
										$author$project$Common$AddressEditor$withCoordinates,
										{
											lat: A2(
												$elm$core$Maybe$withDefault,
												location.coordinates.lat,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.lat;
													},
													location.coordinatesChange)),
											lon: A2(
												$elm$core$Maybe$withDefault,
												location.coordinates.lon,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.lon;
													},
													location.coordinatesChange))
										},
										A2(
											$author$project$Common$AddressEditor$withCoordinateConflict,
											!_Utils_eq(location.coordinatesChange, $elm$core$Maybe$Nothing),
											A2(
												$author$project$Common$AddressEditor$withAddressConflicts,
												{
													zip: conflict(
														function ($) {
															return $.zip;
														}),
													city: conflict(
														function ($) {
															return $.city;
														}),
													state: conflict($author$project$Data$Address$getState),
													street: conflict(
														function ($) {
															return $.street;
														}),
													country: conflict(
														function ($) {
															return $.country;
														}),
													district: conflict($author$project$Data$Address$getDistrict),
													province: conflict($author$project$Data$Address$getProvince)
												},
												A2(
													$author$project$Common$AddressEditor$withAddress,
													A2($author$project$Data$Address$merge, location.address, location.addressChanges),
													model.translations))))),
								title: $author$project$Translations$General$locationAddress(model.translations)
							})))
				]));
	});
var $author$project$Translations$Listings$ApiDifference$reviewAgain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.review_again');
};
var $author$project$PinMeTo$Ui$Table$withRowAction = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				rowAction: $elm$core$Maybe$Just(x)
			});
	});
var $author$project$ApiPendingChanges$Log$Update$RemovedIgnored = function (a) {
	return {$: 'RemovedIgnored', a: a};
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_title');
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterHelpText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_help_text');
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextTip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_help_text_tip');
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_help_text_link');
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextItem1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_help_text_item_1');
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextItem2 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_help_text_item_2');
};
var $author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextInstruction = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.pmt_master_help_text_instruction');
};
var $author$project$ApiPendingChanges$Log$View$locationsView = F2(
	function (model, locations) {
		var rowDeleteButton = function (x) {
			return A3(
				$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Common$Util$onClickFinal(
						$author$project$ApiPendingChanges$Log$Update$RemovedIgnored(x.id))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$ApiDifference$reviewAgain(model.translations))
					]));
		};
		var rowAction = function (x) {
			return _Utils_eq(
				model.showMore,
				$elm$core$Maybe$Just(x.id)) ? $author$project$ApiPendingChanges$Log$Update$ShowMore($elm$core$Maybe$Nothing) : $author$project$ApiPendingChanges$Log$Update$ShowMore(
				$elm$core$Maybe$Just(x.id));
		};
		var rowMore = function (x) {
			return _Utils_eq(
				model.showMore,
				$elm$core$Maybe$Just(x.id)) ? $elm$core$Maybe$Just(
				A2($author$project$ApiPendingChanges$Log$View$changesView, x, model)) : $elm$core$Maybe$Nothing;
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin', '0em 2em 0em 2em')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__background--white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('util__inset')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$ApiDifference$pmtMasterHelpText(model.translations))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextInstruction(model.translations)),
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'padding-left', '2em')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextItem1(model.translations))
														])),
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextItem2(model.translations))
														]))
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextTip(model.translations))
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('/listings/' + (model.siteName + '/apisettings/pendingchanges'))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$ApiDifference$pmtMasterHelpTextLink(model.translations))
												]))
										]))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$TitleBar$render(
									A2(
										$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
										true,
										A2(
											$author$project$PinMeTo$Ui$TitleBar$withAsides,
											_List_fromArray(
												[
													A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtnPlainLight,
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href('api/' + (model.siteName + '/places/apipendingchanges/export')),
															A2($elm$html$Html$Attributes$attribute, 'download', ''),
															$elm$html$Html$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('fa fa-download')
																]),
															_List_Nil)
														]))
												]),
											$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
												$author$project$Translations$Listings$ApiDifference$pmtMasterTitle(model.translations))))),
									A2(
									$author$project$PinMeTo$Ui$Table$render,
									model.uiTable,
									A5(
										$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
										$author$project$Translations$Listings$ApiDifference$action(model.translations),
										_List_fromArray(
											[$author$project$PinMeTo$Ui$Table$Right]),
										rowDeleteButton,
										function (_v0) {
											return function (_v1) {
												return $elm$core$Basics$LT;
											};
										},
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$Listings$ApiDifference$reviewDate(model.translations),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.lastChange;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.lastChange;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationDescriptor(model.translations),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.locationDescriptor;
													},
													$elm$html$Html$text),
												$author$project$PinMeTo$Ui$Table$comparing(
													function ($) {
														return $.locationDescriptor;
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addColumn,
													$author$project$Translations$General$locationStoreId(model.translations),
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.storeId;
														},
														$elm$html$Html$text),
													$author$project$PinMeTo$Ui$Table$comparing(
														function ($) {
															return $.storeId;
														}),
													A2(
														$author$project$PinMeTo$Ui$Table$withRowMore,
														rowMore,
														A2(
															$author$project$PinMeTo$Ui$Table$withRowAction,
															rowAction,
															A2($author$project$PinMeTo$Ui$Table$view, $author$project$ApiPendingChanges$Log$Update$UiTableMsg, locations))))))))
								]))
						]))
				]));
	});
var $author$project$ApiPendingChanges$Log$View$view = function (model) {
	var _v0 = model.locations;
	switch (_v0.$) {
		case 'Loaded':
			var locations = _v0.a;
			return ($elm$core$List$length(locations) > 0) ? A2($author$project$ApiPendingChanges$Log$View$locationsView, model, locations) : $author$project$PinMeTo$Ui$EmptyState$location(
				$author$project$Translations$Listings$ApiDifference$noDifference(model.translations));
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Suspended':
			return $elm$html$Html$text('');
		default:
			return $elm$html$Html$text(
				$author$project$Translations$Listings$ApiDifference$resolverErrorText(model.translations));
	}
};
var $author$project$ApiPendingChanges$Log$Update$ResetState = function (a) {
	return {$: 'ResetState', a: a};
};
var $author$project$ApiPendingChanges$Log$Main$passArgs_ApiPendingChanges_Log_Main = _Platform_incomingPort('passArgs_ApiPendingChanges_Log_Main', $elm$json$Json$Decode$value);
var $author$project$ApiPendingChanges$Log$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$ApiPendingChanges$Log$Main$passArgs_ApiPendingChanges_Log_Main($author$project$ApiPendingChanges$Log$Update$HandleFlags),
				$author$project$Common$PollPortModule$disableSubscriptions(
				function (_v1) {
					return $author$project$ApiPendingChanges$Log$Update$ResetState($author$project$ApiPendingChanges$Log$Model$init);
				})
			]));
};
var $author$project$ApiPendingChanges$Log$Main$main = $elm$browser$Browser$element(
	{init: $author$project$ApiPendingChanges$Log$Main$init, view: $author$project$ApiPendingChanges$Log$View$view, update: $author$project$ApiPendingChanges$Log$Update$update, subscriptions: $author$project$ApiPendingChanges$Log$Main$subscriptions});
var $author$project$Tasks$Overture$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Overture$Claim$Commands$getAllOvertureCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/overture/categories')))));
	});
var $author$project$Tasks$Overture$Claim$Main$init = F2(
	function (session, flags) {
		return _Utils_Tuple2(
			{uiTable: $author$project$PinMeTo$Ui$Table$init, uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, allCategories: $author$project$RemoteData$Loading, primaryCategory: flags.categories.primaryCategory, categoriesNotification: $elm$core$Maybe$Nothing, additionalCategoriesList: flags.categories.additionalCategories},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Overture$Claim$Commands$getAllOvertureCategories, session.siteName, $author$project$Tasks$Overture$Claim$Model$GotAllCategories)
					])));
	});
var $author$project$Tasks$Overture$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Translations$Listings$Claim$claimOvertureLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_overture_locations');
};
var $author$project$Tasks$Overture$Claim$View$renderHeader = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorOverture)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimOvertureLocations(translations))
					]))
			]));
};
var $author$project$Tasks$Overture$Claim$View$renderInnerContainer = F2(
	function (session, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Tasks$Overture$Claim$View$renderHeader(session.translations)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Overture$Claim$Sections$Shared$renderAlert = function (notification) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$text(''),
		function (_v0) {
			var message = _v0.message;
			var state = _v0.state;
			return $author$project$PinMeTo$Ui$Alert$render(
				function () {
					switch (state.$) {
						case 'Success':
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
						case 'Failed':
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
						default:
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
					}
				}()(
					$author$project$PinMeTo$Ui$Alert$plain(message)));
		},
		notification);
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Tasks$Overture$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Overture$Claim$Update$areCategoriesSelected = function (model) {
	var areAllAdditionalCategoriesSelected = A2($elm$core$List$all, $elm_community$maybe_extra$Maybe$Extra$isJust, model.additionalCategoriesList);
	var isPrimaryCategorySelected = $elm_community$maybe_extra$Maybe$Extra$isJust(model.primaryCategory);
	return isPrimaryCategorySelected && areAllAdditionalCategoriesSelected;
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Overture$Claim$Update$areCategoriesSelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Overture$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Tasks$Overture$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Overture$Claim$Model$SelectedPrimaryCategory = function (a) {
	return {$: 'SelectedPrimaryCategory', a: a};
};
var $author$project$Tasks$Overture$Claim$Model$SelectedAdditionalCategory = F2(
	function (a, b) {
		return {$: 'SelectedAdditionalCategory', a: a, b: b};
	});
var $author$project$Tasks$Overture$Claim$Model$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderCategorySelector = F6(
	function (uid, translations, model, categories, category, index) {
		var isPrimary = uid === 'ui-select-primary';
		var title = isPrimary ? $author$project$Translations$Listings$LocationDetail$primaryCategory(translations) : A2(
			$author$project$Translations$Listings$LocationDetail$additionalCategory,
			translations,
			$elm$core$String$fromInt(index + 1));
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid + ('-' + $elm$core$String$fromInt(index)),
													items: A2($author$project$Tasks$Overture$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Overture$Claim$Model$UiSelectMsg,
													onChange: function (category_) {
														return isPrimary ? $author$project$Tasks$Overture$Claim$Model$SelectedPrimaryCategory(category_) : A2($author$project$Tasks$Overture$Claim$Model$SelectedAdditionalCategory, category_, index);
													},
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								])),
							isPrimary ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__remove-additional'),
									$elm$html$Html$Events$onClick(
									$author$project$Tasks$Overture$Claim$Model$RemoveAdditionalCategoryByIndex(index))
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
								]))
						]))
				]));
	});
var $author$project$Tasks$Overture$Claim$Model$AddAdditionalCategory = {$: 'AddAdditionalCategory'};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderAddCategoryButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__publish-button')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Tasks$Overture$Claim$Model$AddAdditionalCategory)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$addCategory(translations))
					]))
			]));
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderAdditionalCategories = F3(
	function (translations, model, categories) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return A6($author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-additional', translations, model, categories, item, index);
					}),
				model.additionalCategoriesList));
	});
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$getCategoryId = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	function (category_) {
		return $author$project$Data$Location$NetworkCategories$getId(category_);
	});
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$getSelectedCategoryIds = function (model) {
	return A2(
		$elm$core$List$append,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (category) {
				return _List_fromArray(
					[
						$author$project$Data$Location$NetworkCategories$getId(category)
					]);
			},
			model.primaryCategory),
		A2(
			$elm$core$List$filter,
			function (category) {
				return category !== '';
			},
			A2($elm$core$List$map, $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$getCategoryId, model.additionalCategoriesList)));
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$getAllNotSelectedCategories = function (model) {
	var _v0 = model.allCategories;
	if (_v0.$ === 'Loaded') {
		var categories = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (category) {
				return !A2(
					$elm$core$List$member,
					$author$project$Data$Location$NetworkCategories$getId(category),
					$author$project$Tasks$Overture$Claim$Sections$CategoriesSection$getSelectedCategoryIds(model));
			},
			categories);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = $author$project$Tasks$Overture$Claim$Sections$CategoriesSection$sortCategories(
			$author$project$Tasks$Overture$Claim$Sections$CategoriesSection$getAllNotSelectedCategories(model));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Tasks$Shared$Components$Header$renderHeader,
							$author$project$Translations$Listings$Claim$categories(translations),
							$elm$core$Maybe$Nothing),
							$author$project$Tasks$Overture$Claim$Sections$Shared$renderAlert(model.categoriesNotification),
							A6($author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-primary', translations, model, sortedCategories, model.primaryCategory, 0),
							A3($author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderAdditionalCategories, translations, model, sortedCategories),
							$author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderAddCategoryButton(translations),
							A2($author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
						]))
				]));
	});
var $author$project$Tasks$Overture$Claim$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Overture$Claim$View$renderInnerContainer, session, model),
						$author$project$Tasks$Overture$Claim$View$lineSeparator,
						A2($author$project$Tasks$Overture$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Overture$Claim$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Tasks$Overture$Claim$Commands$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getId(x))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getName(x)))
			]));
};
var $author$project$Tasks$Overture$Claim$Commands$encodePrimaryCategory = function (primaryCategory) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (p) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'primaryCategory',
						$author$project$Tasks$Overture$Claim$Commands$encodeCategory(p))
					]);
			},
			primaryCategory));
};
var $author$project$Tasks$Overture$Claim$Commands$encodeAdditionalCategories = function (additionalCategories) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'additionalCategories',
			A2($elm$json$Json$Encode$list, $author$project$Tasks$Overture$Claim$Commands$encodeCategory, additionalCategories))
		]);
};
var $author$project$Tasks$Overture$Claim$Commands$encodeCategories = function (model) {
	var additionalCategories = A2($elm$core$List$filterMap, $elm$core$Basics$identity, model.additionalCategoriesList);
	var primaryCategory = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just, model.primaryCategory);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				$elm$json$Json$Encode$object(
					_Utils_ap(
						$author$project$Tasks$Overture$Claim$Commands$encodeAdditionalCategories(additionalCategories),
						$author$project$Tasks$Overture$Claim$Commands$encodePrimaryCategory(primaryCategory))))
			]));
};
var $author$project$Tasks$Overture$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var sitename = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Overture$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (sitename + '/overture/categories')))));
	});
var $author$project$Tasks$Overture$Claim$Update$emptyNotification = function (model) {
	return _Utils_update(
		model,
		{categoriesNotification: $elm$core$Maybe$Nothing});
};
var $author$project$Tasks$Overture$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Overture$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Overture$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				categoriesNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$Overture$Claim$Update$handleCategoriesError = F3(
	function (session, err, model) {
		var updatedModel = A3(
			$author$project$Tasks$Overture$Claim$Update$updateNotification,
			$author$project$Tasks$Overture$Claim$Model$Failed,
			$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(session.translations),
			model);
		return _Utils_Tuple2(
			_Utils_update(
				updatedModel,
				{
					allCategories: $author$project$RemoteData$Error(
						$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
				}),
			$author$project$PinMeTo$Logger$log(
				{
					data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
					context: 'Tasks.Overture.Claim.Update.GotAllCategories',
					message: 'Failed to decode response GotAllCategories'
				}));
	});
var $author$project$Tasks$Overture$Claim$Model$Success = {$: 'Success'};
var $author$project$Tasks$Overture$Claim$Update$handleSaveCategoriesResultOk = F3(
	function (session, success, model) {
		var _v0 = success ? _Utils_Tuple2(
			$author$project$Tasks$Overture$Claim$Model$Success,
			$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
			$author$project$Tasks$Overture$Claim$Model$Failed,
			$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
		var notificationState = _v0.a;
		var notificationMessage = _v0.b;
		return _Utils_Tuple2(
			A3($author$project$Tasks$Overture$Claim$Update$updateNotification, notificationState, notificationMessage, model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Overture$Claim$Update$handleSaveCategoriesResultErr = F2(
	function (err, model) {
		var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
		return _Utils_Tuple2(
			A3($author$project$Tasks$Overture$Claim$Update$updateNotification, $author$project$Tasks$Overture$Claim$Model$Failed, message, model),
			$author$project$PinMeTo$Logger$log(
				{data: message, context: 'Tasks.Overture.Claim.Update.SaveCategoriesResult', message: 'Failed to decode response SaveCategoriesResult'}));
	});
var $author$project$Tasks$Overture$Claim$Update$handleSelectedAdditionalCategory = F4(
	function (model, modelClearedNotifications, category, index) {
		var primaryCategory = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (cat) {
				return $elm$core$List$singleton(
					$elm$core$Maybe$Just(cat));
			},
			model.primaryCategory);
		var newAdditional = A2(
			$elm$core$List$member,
			$elm$core$Maybe$Just(category),
			A2($elm$core$List$append, model.additionalCategoriesList, primaryCategory)) ? model.additionalCategoriesList : A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$append,
				A2($elm$core$List$take, index, model.additionalCategoriesList),
				$elm$core$List$singleton(
					$elm$core$Maybe$Just(category))),
			A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
		return _Utils_Tuple2(
			_Utils_update(
				modelClearedNotifications,
				{additionalCategoriesList: newAdditional}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Overture$Claim$Update$handleRemoveRemoveAdditionalCategory = F3(
	function (model, modelClearedNotifications, index) {
		var newAdditional = A2(
			$elm$core$List$append,
			A2($elm$core$List$take, index, model.additionalCategoriesList),
			A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
		return _Utils_Tuple2(
			_Utils_update(
				modelClearedNotifications,
				{additionalCategoriesList: newAdditional}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Overture$Claim$Update$update = F3(
	function (session, msg, model) {
		var modelClearedNotifications = $author$project$Tasks$Overture$Claim$Update$emptyNotification(model);
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Overture$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Overture$Claim$Model$UiPopOverMsg, msg_, model.uiPopover));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							modelClearedNotifications,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return A3($author$project$Tasks$Overture$Claim$Update$handleCategoriesError, session, err, model);
				}
			case 'SelectedPrimaryCategory':
				var category = msg.a;
				return A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					model.additionalCategoriesList) ? _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{
							primaryCategory: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'AddAdditionalCategory':
				var newSelection = A2(
					$elm$core$List$append,
					model.additionalCategoriesList,
					$elm$core$List$singleton($elm$core$Maybe$Nothing));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newSelection}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedAdditionalCategory':
				var category = msg.a;
				var index = msg.b;
				return A4($author$project$Tasks$Overture$Claim$Update$handleSelectedAdditionalCategory, model, modelClearedNotifications, category, index);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				return A3($author$project$Tasks$Overture$Claim$Update$handleRemoveRemoveAdditionalCategory, model, modelClearedNotifications, index);
			case 'SaveCategories':
				return $author$project$Tasks$Overture$Claim$Update$areCategoriesSelected(model) ? _Utils_Tuple2(
					modelClearedNotifications,
					A3($author$project$Tasks$Overture$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Overture$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					return A3($author$project$Tasks$Overture$Claim$Update$handleSaveCategoriesResultOk, session, success, model);
				} else {
					var err = msg.a.a;
					return A2($author$project$Tasks$Overture$Claim$Update$handleSaveCategoriesResultErr, err, model);
				}
			default:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Overture$Claim$Model$Flags = function (categories) {
	return {categories: categories};
};
var $author$project$Tasks$Overture$Claim$Commands$defaultCategoriesValue = {primaryCategory: $elm$core$Maybe$Nothing, additionalCategories: _List_Nil};
var $author$project$Tasks$Overture$Claim$Commands$flagsCategoriesDecoder = function () {
	var decodeAdditional = A2(
		$elm$json$Json$Decode$field,
		'additionalCategories',
		$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodeAdditionalCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodeAdditional);
	var decodePrimary = A2(
		$elm$json$Json$Decode$field,
		'primaryCategory',
		$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodePrimaryCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodePrimary);
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (primary, additional) {
				return {
					primaryCategory: primary,
					additionalCategories: A2($elm$core$List$map, $elm$core$Maybe$Just, additional)
				};
			}),
		decodePrimaryCommon,
		decodeAdditionalCommon);
}();
var $author$project$Tasks$Overture$Claim$Commands$flagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Tasks$Overture$Claim$Model$Flags,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$Tasks$Overture$Claim$Commands$defaultCategoriesValue),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'categories', $author$project$Tasks$Overture$Claim$Commands$flagsCategoriesDecoder))));
var $author$project$Tasks$Overture$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$Overture$Claim$Main$init,
		view: function (session) {
			return $author$project$Tasks$Overture$Claim$View$view(session);
		},
		update: $author$project$Tasks$Overture$Claim$Update$update,
		flagsDecoder: $author$project$Tasks$Overture$Claim$Commands$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $rl_king$elm_scroll_to$ScrollTo$Settings = F2(
	function (strength, dampness) {
		return {dampness: dampness, strength: strength};
	});
var $rl_king$elm_scroll_to$ScrollTo$State = function (a) {
	return {$: 'State', a: a};
};
var $tad_lispy$springs$Spring$Spring = function (a) {
	return {$: 'Spring', a: a};
};
var $tad_lispy$springs$Spring$create = function (_v0) {
	var dampness = _v0.dampness;
	var strength = _v0.strength;
	return $tad_lispy$springs$Spring$Spring(
		{
			value: 0,
			target: 0,
			dampness: A2($elm$core$Basics$pow, dampness, 2),
			strength: strength,
			velocity: 0
		});
};
var $rl_king$elm_scroll_to$ScrollTo$Springs = F2(
	function (x, y) {
		return {x: x, y: y};
	});
var $rl_king$elm_scroll_to$ScrollTo$initWithSettings = function (settings) {
	return $rl_king$elm_scroll_to$ScrollTo$State(
		A2(
			$rl_king$elm_scroll_to$ScrollTo$Springs,
			$tad_lispy$springs$Spring$create(settings),
			$tad_lispy$springs$Spring$create(settings)));
};
var $rl_king$elm_scroll_to$ScrollTo$init = $rl_king$elm_scroll_to$ScrollTo$initWithSettings(
	A2($rl_king$elm_scroll_to$ScrollTo$Settings, 100, 4.5));
var $author$project$Translations$Listings$Tour$GoogleServicesTour$next = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.google_services_tour.next');
};
var $author$project$Translations$Listings$Tour$GoogleServicesTour$skip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.google_services_tour.skip');
};
var $author$project$PinMeTo$Common$Tour$Tour$Right = {$: 'Right'};
var $author$project$Translations$Listings$Tour$GoogleServicesTour$tourTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.google_services_tour.tour_title');
};
var $author$project$Translations$Listings$Tour$GoogleServicesTour$getStarted = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.google_services_tour.get_started');
};
var $author$project$PinMeTo$Common$Tour$Tour$BottomStart = {$: 'BottomStart'};
var $author$project$Translations$Listings$Tour$GoogleServicesTour$servicesDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.google_services_tour.services_description');
};
var $author$project$Translations$Listings$Tour$GoogleServicesTour$showcaseYourServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.google_services_tour.showcase_your_services');
};
var $author$project$Location$Details$App$tour = function (translations) {
	return {
		id: 'google_services',
		steps: _List_fromArray(
			[
				{
				arrow: false,
				title: $author$project$Translations$Listings$Tour$GoogleServicesTour$tourTitle(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Just('img/tour/services_tour_step_1.gif'),
				placement: $author$project$PinMeTo$Common$Tour$Tour$BottomStart,
				description: $author$project$Translations$Listings$Tour$GoogleServicesTour$showcaseYourServices(translations),
				targetElementQuery: '#view-scroll-container > div > div > div > div > a.pmt-location-top-info__nav-link.pmt-location-top-info__nav-link--active'
			},
				{
				arrow: true,
				title: $author$project$Translations$Listings$Tour$GoogleServicesTour$tourTitle(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$Right,
				description: $author$project$Translations$Listings$Tour$GoogleServicesTour$servicesDescription(translations),
				targetElementQuery: '.location-details-label:has(.location-details-label__new-release-indicator)'
			}
			]),
		endDate: '2025-03-15',
		startDate: '2024-11-19',
		useModalOverlay: false,
		confirmButtonUrl: $elm$core$Maybe$Nothing,
		requiresTourSeen: $elm$core$Maybe$Nothing,
		showStepProgress: true,
		confirmButtonLabel: $author$project$Translations$Listings$Tour$GoogleServicesTour$getStarted(translations),
		requiresTourNotSeen: $elm$core$Maybe$Nothing
	};
};
var $author$project$PinMeTo$Ports$pmtUiIntro = _Platform_outgoingPort('pmtUiIntro', $elm$core$Basics$identity);
var $author$project$PinMeTo$Common$Tour$Tour$placementEncoder = function (placement) {
	switch (placement.$) {
		case 'Top':
			return $elm$json$Json$Encode$string('top');
		case 'Bottom':
			return $elm$json$Json$Encode$string('bottom');
		case 'Left':
			return $elm$json$Json$Encode$string('left');
		case 'Right':
			return $elm$json$Json$Encode$string('right');
		case 'TopStart':
			return $elm$json$Json$Encode$string('top-start');
		case 'TopEnd':
			return $elm$json$Json$Encode$string('top-end');
		case 'BottomStart':
			return $elm$json$Json$Encode$string('bottom-start');
		case 'BottomEnd':
			return $elm$json$Json$Encode$string('bottom-end');
		case 'LeftStart':
			return $elm$json$Json$Encode$string('left-start');
		case 'LeftEnd':
			return $elm$json$Json$Encode$string('left-end');
		case 'RightStart':
			return $elm$json$Json$Encode$string('right-start');
		default:
			return $elm$json$Json$Encode$string('right-end');
	}
};
var $author$project$PinMeTo$Common$Tour$Tour$stepEncoder = function (step) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(step.title)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(step.description)),
				_Utils_Tuple2(
				'mediaUrl',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, step.mediaUrl))),
				_Utils_Tuple2(
				'targetElementQuery',
				$elm$json$Json$Encode$string(step.targetElementQuery)),
				_Utils_Tuple2(
				'placement',
				$author$project$PinMeTo$Common$Tour$Tour$placementEncoder(step.placement)),
				_Utils_Tuple2(
				'arrow',
				$elm$json$Json$Encode$bool(step.arrow)),
				_Utils_Tuple2(
				'classes',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, step.classes))
			]));
};
var $author$project$PinMeTo$Common$Tour$Tour$labelEncoder = function (labels) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nextButton',
				$elm$json$Json$Encode$string(labels.nextButton)),
				_Utils_Tuple2(
				'skipButton',
				$elm$json$Json$Encode$string(labels.skipButton))
			]));
};
var $author$project$PinMeTo$Common$Tour$Tour$tourEncoder = F2(
	function (labels, tour) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tour',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(tour.id)),
								_Utils_Tuple2(
								'steps',
								A2($elm$json$Json$Encode$list, $author$project$PinMeTo$Common$Tour$Tour$stepEncoder, tour.steps)),
								_Utils_Tuple2(
								'confirmButtonLabel',
								$elm$json$Json$Encode$string(tour.confirmButtonLabel)),
								_Utils_Tuple2(
								'confirmButtonUrl',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, tour.confirmButtonUrl))),
								_Utils_Tuple2(
								'startDate',
								$elm$json$Json$Encode$string(tour.startDate)),
								_Utils_Tuple2(
								'endDate',
								$elm$json$Json$Encode$string(tour.endDate)),
								_Utils_Tuple2(
								'showStepProgress',
								$elm$json$Json$Encode$bool(tour.showStepProgress)),
								_Utils_Tuple2(
								'useModalOverlay',
								$elm$json$Json$Encode$bool(tour.useModalOverlay)),
								_Utils_Tuple2(
								'requiresTourSeen',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, tour.requiresTourSeen))),
								_Utils_Tuple2(
								'requiresTourNotSeen',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, tour.requiresTourNotSeen)))
							]))),
					_Utils_Tuple2(
					'labels',
					$author$project$PinMeTo$Common$Tour$Tour$labelEncoder(labels))
				]));
	});
var $author$project$PinMeTo$Common$Tour$Tour$startTour = F2(
	function (labels, tour) {
		return $author$project$PinMeTo$Ports$pmtUiIntro(
			A2($author$project$PinMeTo$Common$Tour$Tour$tourEncoder, labels, tour));
	});
var $author$project$Location$Details$App$OnLocationProperties = function (a) {
	return {$: 'OnLocationProperties', a: a};
};
var $author$project$Location$Details$Model$LocationProperties = function (unreviewedMediaCount) {
	return {unreviewedMediaCount: unreviewedMediaCount};
};
var $author$project$Location$Details$Commands$locationPropertiesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unreviewedMediaCount',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Location$Details$Model$LocationProperties));
var $author$project$Location$Details$Commands$getLocationProperties = F3(
	function (_v0, locationId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Location$Details$Commands$locationPropertiesDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/place/' + (locationId + '/properties')))))));
	});
var $author$project$Location$Details$App$OnGoogleAttributesData = function (a) {
	return {$: 'OnGoogleAttributesData', a: a};
};
var $author$project$Location$Details$Commands$getLocationGoogleAttributes = F3(
	function (_v0, locationId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$NetworkData$GoogleAttributes$googleAttributesDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/place/' + (locationId + '/google/attributes')))))));
	});
var $author$project$Location$Details$App$init = F2(
	function (session, flags) {
		return _Utils_Tuple2(
			{today: flags.today, storeId: $elm$core$Maybe$Nothing, features: session.features, location: $author$project$RemoteData$Loading, scrollTo: $rl_king$elm_scroll_to$ScrollTo$init, locationId: flags.locationId, siteCategories: flags.siteCategories, scheduleUpdates: $author$project$RemoteData$Loading, googleAttributes: $author$project$RemoteData$Loading, locationDetailPage: $elm$core$Maybe$Nothing, locationProperties: $author$project$RemoteData$Loading, customDataDefinition: $author$project$RemoteData$Loading, allGoogleServiceItems: $author$project$RemoteData$Loading, locationDataWithConflictStatus: $author$project$RemoteData$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Location$Details$Commands$getLocationGoogleAttributes, session.siteName, flags.locationId, $author$project$Location$Details$App$OnGoogleAttributesData),
						A3($author$project$Location$Details$Commands$getLocationProperties, session.siteName, flags.locationId, $author$project$Location$Details$App$OnLocationProperties),
						A2(
						$author$project$PinMeTo$Common$Tour$Tour$startTour,
						{
							nextButton: $author$project$Translations$Listings$Tour$GoogleServicesTour$next(session.translations),
							skipButton: $author$project$Translations$Listings$Tour$GoogleServicesTour$skip(session.translations)
						},
						$author$project$Location$Details$App$tour(session.translations))
					])));
	});
var $author$project$Location$DetailsPage$Main$DetailsMsg = function (a) {
	return {$: 'DetailsMsg', a: a};
};
var $author$project$Location$DetailsPage$Main$SidePaneMsg = function (a) {
	return {$: 'SidePaneMsg', a: a};
};
var $author$project$Location$DetailsPage$Main$isDetailsRoute = function (path) {
	return A2($elm$core$String$contains, '/details', path);
};
var $author$project$Location$DetailsPage$Main$init = F2(
	function (session, flags) {
		var _v0 = A2($author$project$Location$LocationInfoPane$App$init, session, flags.sidePane);
		var sidePane = _v0.a;
		var sCmd = _v0.b;
		var _v1 = A2($author$project$Location$Details$App$init, session, flags.details);
		var details = _v1.a;
		var dCmd = _v1.b;
		return _Utils_Tuple2(
			{
				details: details,
				sidePane: sidePane,
				siteContext: {brandMedia: flags.sidePane.location.brandMedia, siteCategories: flags.sidePane.location.siteCategories},
				onDetailsRoute: $author$project$Location$DetailsPage$Main$isDetailsRoute(flags.initialPath)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Location$DetailsPage$Main$DetailsMsg, dCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Location$DetailsPage$Main$SidePaneMsg, sCmd)
					])));
	});
var $author$project$Translations$General$next = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.next');
};
var $author$project$Location$ImageEditor$EditorMsg = function (a) {
	return {$: 'EditorMsg', a: a};
};
var $author$project$Location$ImageEditor$OnConfirmSave = {$: 'OnConfirmSave'};
var $author$project$Location$ImageEditor$OnCancelConfirm = {$: 'OnCancelConfirm'};
var $author$project$Location$ImageEditor$OnSave = {$: 'OnSave'};
var $author$project$Location$ImageEditor$OnClose = {$: 'OnClose'};
var $author$project$Location$ImageEditor$LocationSelectorMsg = function (a) {
	return {$: 'LocationSelectorMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$imageEditorSelectLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.image_editor_select_locations');
};
var $author$project$Location$ImageEditor$locationsLightbox = F3(
	function (session, title, state) {
		var translations = session.translations;
		var locationSelector = A2(
			$author$project$PinMeTo$Ui$SelectorLocationWithFilters$render,
			state.locationSelector,
			A2(
				$author$project$PinMeTo$Ui$SelectorLocationWithFilters$withSelected,
				state.selectedLocations,
				$author$project$PinMeTo$Ui$SelectorLocationWithFilters$view(
					{
						labels: A3(
							$author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels,
							translations,
							session.language,
							A2($author$project$Filter$FilterLabels$defaultFilterControllerLabels, translations, session.language)),
						locale: session.locale,
						tagger: $author$project$Location$ImageEditor$LocationSelectorMsg
					})));
		var content = function () {
			if (state.saving) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--status')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-gear fa-spin fa-fw')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$saving(translations))
								]))
						]));
			} else {
				var _v0 = state.error;
				if (_v0.$ === 'Just') {
					var error = _v0.a;
					return $author$project$PinMeTo$Ui$Alert$render(
						A2(
							$author$project$PinMeTo$Ui$Alert$withStatus,
							$author$project$PinMeTo$Ui$Alert$Error,
							$author$project$PinMeTo$Ui$Alert$plain(error)));
				} else {
					return $elm$html$Html$text('');
				}
			}
		}();
		return $author$project$Listings$Ui$Lightbox$render(
			A2(
				$author$project$Listings$Ui$Lightbox$withDisabledButtons,
				state.saving,
				(state.saving ? $elm$core$Basics$identity : $author$project$Listings$Ui$Lightbox$withLocationSelector(locationSelector))(
					$author$project$Listings$Ui$Lightbox$lightbox(
						{
							style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
							title: title,
							header: title,
							content: _Utils_Tuple2(
								content,
								$elm$core$List$isEmpty(state.selectedLocations)),
							popOver: $elm$core$Maybe$Nothing,
							description: $elm$core$Maybe$Just(
								$author$project$Translations$Listings$LocationDetail$imageEditorSelectLocations(translations)),
							isRePublish: false,
							translations: translations,
							updateMessage: $author$project$Location$ImageEditor$OnSave,
							onCloseMessage: $author$project$Location$ImageEditor$OnClose
						}))));
	});
var $author$project$Location$ImageEditor$view = F2(
	function (session, _v0) {
		var state = _v0.a;
		var translations = session.translations;
		var cropTitle = function () {
			var _v4 = state.target;
			switch (_v4.$) {
				case 'GoogleLogo':
					return $author$project$Translations$Listings$BrandPages$cropLogoImageGoogle(translations);
				case 'FacebookProfile':
					return $author$project$Translations$Listings$BrandPages$cropProfileImageFacebook(translations);
				default:
					return $author$project$Translations$Listings$BrandPages$cropCoverImage(translations);
			}
		}();
		var title = function () {
			var _v3 = state.target;
			switch (_v3.$) {
				case 'GoogleLogo':
					return $author$project$Translations$Listings$BrandPages$addLogoImageForGoogle(translations);
				case 'GoogleCover':
					return $author$project$Translations$Listings$BrandPages$addCoverImageForGoogle(translations);
				case 'FacebookProfile':
					return $author$project$Translations$Listings$BrandPages$addProfileImageForFacebook(translations);
				default:
					return $author$project$Translations$Listings$BrandPages$addCoverImageForFacebook(translations);
			}
		}();
		var _v1 = state.stage;
		if (_v1.$ === 'PickingImage') {
			return A2(
				$elm$html$Html$map,
				$author$project$Location$ImageEditor$EditorMsg,
				A3(
					$author$project$Common$Image$Editor$view,
					translations,
					{
						title: title,
						cropTitle: cropTitle,
						confirmLabel: $author$project$Translations$General$next(translations)
					},
					state.editor));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Location$ImageEditor$locationsLightbox, session, title, state),
						state.confirming ? A3(
						$author$project$Location$Details$Editor$Confirm$view,
						session,
						{
							onCancel: $author$project$Location$ImageEditor$OnCancelConfirm,
							onConfirm: function (_v2) {
								return $author$project$Location$ImageEditor$OnConfirmSave;
							}
						},
						$author$project$Location$Details$Editor$Confirm$ConfirmedUpdateSelectedLocations(state.selectedLocations)) : $elm$html$Html$text('')
					]));
		}
	});
var $author$project$Location$Details$CustomFieldEditor$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$ConfirmCancel = {$: 'ConfirmCancel'};
var $author$project$Location$Details$CustomFieldEditor$ConfirmedUpdate = function (a) {
	return {$: 'ConfirmedUpdate', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$OnSubmit = {$: 'OnSubmit'};
var $author$project$Location$Details$CustomFieldEditor$lightBox2 = F4(
	function (session, details, config, content) {
		var withLocationSelector = config.showSavingProgress ? $elm$core$Basics$identity : A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2($elm$core$Maybe$map, $author$project$Listings$Ui$Lightbox$withLocationSelector, config.locationSelector));
		var maybePrependError = function (content_) {
			var divElement = F2(
				function (text, contentElement) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Alert$render(
								A2(
									$author$project$PinMeTo$Ui$Alert$withStatus,
									$author$project$PinMeTo$Ui$Alert$Error,
									$author$project$PinMeTo$Ui$Alert$plain(text))),
								contentElement
							]));
				});
			var _v0 = config.error;
			if (_v0.$ === 'Just') {
				if (_v0.a.$ === 'PartialUpdateFailed') {
					var errorMessage = _v0.a.a.a;
					return A2(divElement, errorMessage, content_);
				} else {
					var _v1 = _v0.a;
					return A2(
						divElement,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleErrorText(session.translations),
						content_);
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							config.showSavingProgress ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar status-bar--status')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-gear fa-spin fa-fw')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$saving(session.translations))
										]))
								])) : content_
						]));
			}
		};
		return $author$project$Listings$Ui$Lightbox$render(
			A2(
				$author$project$Listings$Ui$Lightbox$withScheduler,
				config.scheduler,
				A2(
					$author$project$Listings$Ui$Lightbox$withDisabledButtons,
					config.showSavingProgress,
					withLocationSelector(
						$author$project$Listings$Ui$Lightbox$lightbox(
							{
								style: details.style,
								title: details.title,
								header: details.header,
								content: _Utils_Tuple2(
									maybePrependError(content),
									config.isDisabled),
								popOver: $elm$core$Maybe$Nothing,
								description: details.description,
								isRePublish: false,
								translations: session.translations,
								updateMessage: config.onSubmit,
								onCloseMessage: config.onCancel
							})))));
	});
var $author$project$Location$Details$CustomFieldEditor$UiSelectorLocationWithFiltersMsg = function (a) {
	return {$: 'UiSelectorLocationWithFiltersMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$locationSelectorHtml = F2(
	function (session, model) {
		var readOnly = function () {
			var _v0 = model.content;
			if (_v0.$ === 'ScheduledUpdate') {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$SelectorLocationWithFilters$render,
					model.locationSelector,
					A2(
						$author$project$PinMeTo$Ui$SelectorLocationWithFilters$withSelected,
						model.selectedLocations,
						A2(
							$author$project$PinMeTo$Ui$SelectorLocationWithFilters$readOnly,
							readOnly,
							$author$project$PinMeTo$Ui$SelectorLocationWithFilters$view(
								{
									labels: A3(
										$author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels,
										session.translations,
										session.language,
										A2($author$project$Filter$FilterLabels$defaultFilterControllerLabels, session.translations, session.language)),
									locale: session.locale,
									tagger: $author$project$Location$Details$CustomFieldEditor$UiSelectorLocationWithFiltersMsg
								}))))
				]));
	});
var $author$project$Location$Details$CustomFieldEditor$scheduledUpdateView = F4(
	function (_v0, session, _v1, scheduledUpdate) {
		var withScheduling = _v0.withScheduling;
		var onCancel = _v0.onCancel;
		var tagger = _v0.tagger;
		var model = _v1.a;
		var renderSchedulingDetailsLabel = function () {
			var dateElement = $author$project$PinMeTo$Ui$Date$render(
				A2(
					$author$project$PinMeTo$Ui$Date$withFormat,
					$author$project$PinMeTo$Ui$Date$FormatDate,
					A2($author$project$PinMeTo$Ui$Date$posix, session.locale, scheduledUpdate.date)));
			var labelText = A2($author$project$Translations$Listings$LocationDetail$PopUpContent$scheduledReadOnlyDescriptionAuthor, session.translations, scheduledUpdate.userName);
			return A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelText),
						$elm$html$Html$text(' '),
						dateElement
					]));
		}();
		var _v2 = scheduledUpdate.fieldAndData;
		if (_v2.$ === 'OpenHoursField') {
			var openHours = _v2.a;
			return A4(
				$author$project$Location$Details$CustomFieldEditor$lightBox2,
				session,
				{
					style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
					title: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursTitle(session.translations),
					header: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursHeader(session.translations),
					description: $elm$core$Maybe$Just(
						$author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDescription(session.translations))
				},
				{
					error: model.error,
					onCancel: onCancel,
					onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
					scheduler: $elm$core$Maybe$Nothing,
					isDisabled: false,
					locationSelector: $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$map,
							tagger,
							A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
					showSavingProgress: model.showSavingProgress
				},
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							renderSchedulingDetailsLabel,
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Listings$Ui$Row$renderOpenHoursView, openHours, session.translations)
								]))
						])));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$OnAddItem = {$: 'OnAddItem'};
var $author$project$Location$Details$PopupContent$CustomFieldList$OnChangeText = function (a) {
	return {$: 'OnChangeText', a: a};
};
var $author$project$Location$Details$PopupContent$CustomFieldList$renderForm = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__custom-field-list-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__custom-field-list-input')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							$author$project$PinMeTo$Ui$Form$Input$text(
								{value: model.currentText, onChange: $author$project$Location$Details$PopupContent$CustomFieldList$OnChangeText}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Location$Details$PopupContent$CustomFieldList$OnAddItem),
									$elm$html$Html$Attributes$disabled(
									$elm$core$String$isEmpty(model.currentText))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$add(translations))
								]))
						]))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$OnDeleteItem = function (a) {
	return {$: 'OnDeleteItem', a: a};
};
var $author$project$Location$Details$PopupContent$CustomFieldList$renderRow = F3(
	function (translations, index, textValue) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__custom-field-list-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__custom-field-list-input')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(textValue)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__open-hours-day-add-span')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Location$Details$PopupContent$CustomFieldList$OnDeleteItem(index))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$delete(translations))
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customFieldEmptyList = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_field_empty_list');
};
var $author$project$Location$Details$PopupContent$CustomFieldList$renderList = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__custom-fields-container')
				]),
			$elm$core$List$isEmpty(model.list) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$PopUpContent$customFieldEmptyList(translations))
						]))
				]) : A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, value) {
						return A3($author$project$Location$Details$PopupContent$CustomFieldList$renderRow, translations, index, value);
					}),
				model.list));
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Location$Details$PopupContent$CustomFieldList$renderForm, translations, model),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2($author$project$Location$Details$PopupContent$CustomFieldList$renderList, translations, model)
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$CustomFieldListMsg = F2(
	function (a, b) {
		return {$: 'CustomFieldListMsg', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$renderList = F4(
	function (dictElement, translations, label, index) {
		var initialModel = function () {
			if (dictElement.$ === 'ListAttribute') {
				var customModel = dictElement.b;
				return $elm$core$Maybe$Just(customModel);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			function (innerModel) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Listings$Ui$Label$render(
							$author$project$Listings$Ui$Label$label(
								{title: label, description: ''})),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Location$Details$PopupContent$CustomFieldObject$CustomFieldListMsg(index),
									A2($author$project$Location$Details$PopupContent$CustomFieldList$view, translations, innerModel))
								]))
						]));
			},
			initialModel);
	});
var $author$project$Location$Details$PopupContent$CustomFieldString$UpdateValue = function (a) {
	return {$: 'UpdateValue', a: a};
};
var $author$project$Location$Details$PopupContent$CustomFieldString$view = function (model) {
	return $author$project$PinMeTo$Ui$Form$Input$render(
		A2(
			$author$project$PinMeTo$Ui$Form$Input$withError,
			model.isValid ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Invalid value'),
			$author$project$PinMeTo$Ui$Form$Input$text(
				{value: model.value, onChange: $author$project$Location$Details$PopupContent$CustomFieldString$UpdateValue})));
};
var $author$project$Location$Details$PopupContent$CustomFieldObject$CustomFieldStringMsg = F2(
	function (a, b) {
		return {$: 'CustomFieldStringMsg', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$renderString = F3(
	function (dictElement, label, index) {
		var initialModel = function () {
			if (dictElement.$ === 'StringAttribute') {
				var customModel = dictElement.b;
				return $elm$core$Maybe$Just(customModel);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			function (innerModel) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Listings$Ui$Label$render(
							$author$project$Listings$Ui$Label$label(
								{title: label, description: ''})),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Location$Details$PopupContent$CustomFieldObject$CustomFieldStringMsg(index),
									$author$project$Location$Details$PopupContent$CustomFieldString$view(innerModel))
								]))
						]));
			},
			initialModel);
	});
var $author$project$Location$Details$PopupContent$CustomFieldBoolean$UpdateValue = function (a) {
	return {$: 'UpdateValue', a: a};
};
var $author$project$Location$Details$PopupContent$CustomFieldBoolean$view = F2(
	function (customFieldDisplayName, model) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__custom-field-checkbox-label')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Checkbox$render(
					$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
						{label: customFieldDisplayName, checked: model.value, onChange: $author$project$Location$Details$PopupContent$CustomFieldBoolean$UpdateValue}))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$CustomFieldBooleanMsg = F2(
	function (a, b) {
		return {$: 'CustomFieldBooleanMsg', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$renderBoolean = F3(
	function (dictElement, label, index) {
		var initialModel = function () {
			if (dictElement.$ === 'BooleanAttribute') {
				var customModel = dictElement.b;
				return $elm$core$Maybe$Just(customModel);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			function (innerModel) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Listings$Ui$Label$render(
							$author$project$Listings$Ui$Label$label(
								{title: label, description: ''})),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Location$Details$PopupContent$CustomFieldObject$CustomFieldBooleanMsg(index),
									A2($author$project$Location$Details$PopupContent$CustomFieldBoolean$view, label, innerModel))
								]))
						]));
			},
			initialModel);
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$customFieldOnlyApi = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.custom_field_only_api');
};
var $author$project$Location$Details$PopupContent$CustomFieldObject$renderUnsupportedField = F3(
	function (translations, label, value) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Listings$Ui$Label$render(
					$author$project$Listings$Ui$Label$label(
						{
							title: label,
							description: $author$project$Translations$Listings$LocationDetail$PopUpContent$customFieldOnlyApi(translations)
						})),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__custom-field-read-only')
						]),
					_List_fromArray(
						[value]))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$renderRow = F3(
	function (translations, index, propertyModel) {
		var renderProperty = function (property) {
			switch (property.$) {
				case 'StringProperty':
					var _v2 = property.a;
					var meta = _v2.b;
					return A3($author$project$Location$Details$PopupContent$CustomFieldObject$renderString, propertyModel, meta.displayName, index);
				case 'BooleanProperty':
					var _v3 = property.a;
					var meta = _v3.b;
					return A3($author$project$Location$Details$PopupContent$CustomFieldObject$renderBoolean, propertyModel, meta.displayName, index);
				case 'ListProperty':
					var _v4 = property.a;
					var meta = _v4.b;
					return A4($author$project$Location$Details$PopupContent$CustomFieldObject$renderList, propertyModel, translations, meta.displayName, index);
				case 'ObjectProperty':
					var _v5 = property.a;
					var value = _v5.a;
					var meta = _v5.b;
					return A3(
						$author$project$Location$Details$PopupContent$CustomFieldObject$renderUnsupportedField,
						translations,
						meta.displayName,
						A2($author$project$Location$Details$PopupContent$CustomFieldObject$renderObjectView, value, translations));
				case 'OpenHoursProperty':
					var _v6 = property.a;
					var value = _v6.a;
					var meta = _v6.b;
					return A3(
						$author$project$Location$Details$PopupContent$CustomFieldObject$renderUnsupportedField,
						translations,
						meta.displayName,
						A2($author$project$Listings$Ui$Row$renderOpenHoursView, value, translations));
				default:
					var _v7 = property.a;
					var value = _v7.a;
					var meta = _v7.b;
					return A3(
						$author$project$Location$Details$PopupContent$CustomFieldObject$renderUnsupportedField,
						translations,
						meta.displayName,
						A2($author$project$Listings$Ui$Row$renderSpecialOpenHoursTable, value, translations));
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__custom-field-object-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__custom-field-list-input')
						]),
					_List_fromArray(
						[
							function () {
							switch (propertyModel.$) {
								case 'StringAttribute':
									var prop = propertyModel.a;
									return renderProperty(prop);
								case 'BooleanAttribute':
									var prop = propertyModel.a;
									return renderProperty(prop);
								case 'ListAttribute':
									var prop = propertyModel.a;
									return renderProperty(prop);
								case 'ObjectAttribute':
									var prop = propertyModel.a;
									return renderProperty(prop);
								case 'OpenHoursAttribute':
									var prop = propertyModel.a;
									return renderProperty(prop);
								default:
									var prop = propertyModel.a;
									return renderProperty(prop);
							}
						}()
						]))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$view = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__custom-field-object-container ')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var key = _v0.a;
					var value = _v0.b;
					return A3($author$project$Location$Details$PopupContent$CustomFieldObject$renderRow, translations, key, value);
				},
				$elm$core$Dict$toList(model.attributes)));
	});
var $author$project$Location$Details$PopupContent$CustomFieldString$isValid = function (model) {
	return model.isValid;
};
var $author$project$Translations$Listings$LocationDetail$customField = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.custom_field');
};
var $author$project$Location$Details$CustomFieldEditor$OnRemoveSchedulingDate = {$: 'OnRemoveSchedulingDate'};
var $author$project$Location$Details$CustomFieldEditor$OnSelectSchedulingDate = function (a) {
	return {$: 'OnSelectSchedulingDate', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$schedulerHtml = F2(
	function (session, model) {
		return $author$project$Location$Details$Scheduler$view(
			{now: model.now, locale: session.locale, language: session.language, onRemove: $author$project$Location$Details$CustomFieldEditor$OnRemoveSchedulingDate, onSelect: $author$project$Location$Details$CustomFieldEditor$OnSelectSchedulingDate, selectedDate: model.selectedDate, translations: session.translations});
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$getPropertyList = function (model) {
	return A2(
		$elm$core$List$map,
		function (stringValue) {
			return $author$project$Data$Location$CustomData$StringProperty(
				_Utils_Tuple2(
					stringValue,
					{
						name: $author$project$Data$CustomDataDefinition$PropertyName('_'),
						rules: _List_Nil,
						displayName: '_'
					}));
		},
		model.list);
};
var $author$project$Location$Details$PopupContent$CustomFieldObject$getPropertyList = function (propertyModel) {
	var getProperty = function (propertyModel_) {
		switch (propertyModel_.$) {
			case 'StringAttribute':
				var property = propertyModel_.a;
				return property;
			case 'BooleanAttribute':
				var property = propertyModel_.a;
				return property;
			case 'ListAttribute':
				var property = propertyModel_.a;
				return property;
			case 'ObjectAttribute':
				var property = propertyModel_.a;
				return property;
			case 'OpenHoursAttribute':
				var property = propertyModel_.a;
				return property;
			default:
				var property = propertyModel_.a;
				return property;
		}
	};
	return A2($elm$core$List$map, getProperty, propertyModel);
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldListMsg = function (a) {
	return {$: 'CustomFieldListMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg = function (a) {
	return {$: 'CustomFieldEditorMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldObjectMsg = function (a) {
	return {$: 'CustomFieldObjectMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldStringMsg = function (a) {
	return {$: 'CustomFieldStringMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldBooleanMsg = function (a) {
	return {$: 'CustomFieldBooleanMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHoursMsg = function (a) {
	return {$: 'CustomFieldOpenHoursMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHoursMsg = function (a) {
	return {$: 'CustomFieldSpecialOpenHoursMsg', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$customFieldEditorView = F4(
	function (_v0, session, _v1, customFieldEditor) {
		var withScheduling = _v0.withScheduling;
		var onCancel = _v0.onCancel;
		var tagger = _v0.tagger;
		var model = _v1.a;
		var locationsSelected = $elm$core$List$length(model.selectedLocations) > 0;
		var locationsChanged = !_Utils_eq(
			_List_fromArray(
				[model.locationId]),
			model.selectedLocations);
		switch (customFieldEditor.$) {
			case 'CustomFieldOpenHours':
				var customFieldEditorModel = customFieldEditor.a;
				var customFieldEditorChanged = function () {
					var _v4 = model.currentProperty;
					if (_v4.$ === 'OpenHoursProperty') {
						var _v5 = _v4.a;
						var initialOpenHours = _v5.a;
						return !_Utils_eq(initialOpenHours, customFieldEditorModel.openHours);
					} else {
						return false;
					}
				}();
				var isEnabled = locationsSelected && ($author$project$Location$Details$PopupContent$OpenHours$isValid(customFieldEditorModel) && (customFieldEditorChanged || (locationsChanged || (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing)))));
				return A4(
					$author$project$Location$Details$CustomFieldEditor$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursTitle(session.translations),
						header: model.currentConfig.meta.displayName,
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$CustomFieldEditor$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v3) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHoursMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, tagger)),
								A2($author$project$Location$Details$PopupContent$OpenHours$view, session.translations, customFieldEditorModel))
							])));
			case 'CustomFieldSpecialOpenHours':
				var customFieldEditorModel = customFieldEditor.a;
				var specialOpenHours = $author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList(customFieldEditorModel);
				var customFieldEditorChanged = function () {
					var _v6 = model.currentProperty;
					if (_v6.$ === 'SpecialOpenHoursProperty') {
						var _v7 = _v6.a;
						var initialSpecialOpenHours = _v7.a;
						return !_Utils_eq(initialSpecialOpenHours, specialOpenHours);
					} else {
						return false;
					}
				}();
				var isEnabled = $author$project$Location$Details$PopupContent$SpecialOpenHours$isValid(customFieldEditorModel) && customFieldEditorChanged;
				return A4(
					$author$project$Location$Details$CustomFieldEditor$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$Medium,
						title: $author$project$Translations$General$locationSpecialHours(session.translations),
						header: model.currentConfig.meta.displayName,
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
						scheduler: $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHoursMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, tagger)),
								A2($author$project$Location$Details$PopupContent$SpecialOpenHours$view, session.translations, customFieldEditorModel))
							])));
			case 'CustomFieldBoolean':
				var customFieldEditorModel = customFieldEditor.a;
				var customFieldEditorChanged = function () {
					var _v9 = model.currentProperty;
					if (_v9.$ === 'BooleanProperty') {
						var _v10 = _v9.a;
						var initialValue = _v10.a;
						return !_Utils_eq(initialValue, customFieldEditorModel.value);
					} else {
						return false;
					}
				}();
				var isEnabled = locationsSelected && (customFieldEditorChanged || (locationsChanged || (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing))));
				return A4(
					$author$project$Location$Details$CustomFieldEditor$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$customField(session.translations),
						header: '',
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$CustomFieldEditor$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v8) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$CustomFieldEditor$CustomFieldBooleanMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, tagger)),
								A2($author$project$Location$Details$PopupContent$CustomFieldBoolean$view, model.currentConfig.meta.displayName, customFieldEditorModel))
							])));
			case 'CustomFieldString':
				var customFieldEditorModel = customFieldEditor.a;
				var customFieldEditorChanged = function () {
					var _v12 = model.currentProperty;
					if (_v12.$ === 'StringProperty') {
						var _v13 = _v12.a;
						var initialValue = _v13.a;
						return !_Utils_eq(initialValue, customFieldEditorModel.value);
					} else {
						return false;
					}
				}();
				var isEnabled = locationsSelected && ($author$project$Location$Details$PopupContent$CustomFieldString$isValid(customFieldEditorModel) && (customFieldEditorChanged || (locationsChanged || (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing)))));
				return A4(
					$author$project$Location$Details$CustomFieldEditor$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$customField(session.translations),
						header: model.currentConfig.meta.displayName,
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$CustomFieldEditor$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v11) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$CustomFieldEditor$CustomFieldStringMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, tagger)),
								$author$project$Location$Details$PopupContent$CustomFieldString$view(customFieldEditorModel))
							])));
			case 'CustomFieldList':
				var customFieldEditorModel = customFieldEditor.a;
				var customFieldEditorChanged = function () {
					var _v15 = model.currentProperty;
					if (_v15.$ === 'ListProperty') {
						var _v16 = _v15.a;
						var initialValue = _v16.a;
						return !_Utils_eq(
							initialValue,
							$author$project$Location$Details$PopupContent$CustomFieldList$getPropertyList(customFieldEditorModel));
					} else {
						return false;
					}
				}();
				var isEnabled = locationsSelected && (customFieldEditorChanged || (locationsChanged || (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing))));
				return A4(
					$author$project$Location$Details$CustomFieldEditor$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$customField(session.translations),
						header: model.currentConfig.meta.displayName,
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$CustomFieldEditor$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v14) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$CustomFieldEditor$CustomFieldListMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, tagger)),
								A2($author$project$Location$Details$PopupContent$CustomFieldList$view, session.translations, customFieldEditorModel))
							])));
			default:
				var customFieldEditorModel = customFieldEditor.a;
				var customFieldEditorChanged = function () {
					var _v18 = model.currentProperty;
					if (_v18.$ === 'ObjectProperty') {
						var _v19 = _v18.a;
						var initialValue = _v19.a;
						return !_Utils_eq(
							initialValue,
							$author$project$Location$Details$PopupContent$CustomFieldObject$getPropertyList(
								$elm$core$Dict$values(customFieldEditorModel.attributes)));
					} else {
						return false;
					}
				}();
				var isEnabled = locationsSelected && (customFieldEditorChanged || (locationsChanged || (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing))));
				return A4(
					$author$project$Location$Details$CustomFieldEditor$lightBox2,
					session,
					{
						style: $author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						title: $author$project$Translations$Listings$LocationDetail$customField(session.translations),
						header: model.currentConfig.meta.displayName,
						description: $elm$core$Maybe$Nothing
					},
					{
						error: model.error,
						onCancel: onCancel,
						onSubmit: tagger($author$project$Location$Details$CustomFieldEditor$OnSubmit),
						scheduler: withScheduling ? $elm$core$Maybe$Just(
							{
								view: A2(
									$elm$html$Html$map,
									tagger,
									A2($author$project$Location$Details$CustomFieldEditor$schedulerHtml, session, model)),
								negativeButton: false,
								customSubmitLabel: A2(
									$elm$core$Maybe$map,
									function (_v17) {
										return $author$project$Translations$Listings$LocationDetail$PopUpContent$scheduleButtonText(session.translations);
									},
									model.selectedDate)
							}) : $elm$core$Maybe$Nothing,
						isDisabled: !isEnabled,
						locationSelector: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$Location$Details$CustomFieldEditor$locationSelectorHtml, session, model))),
						showSavingProgress: model.showSavingProgress
					},
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Location$Details$CustomFieldEditor$CustomFieldObjectMsg,
									A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, tagger)),
								A2($author$project$Location$Details$PopupContent$CustomFieldObject$view, session.translations, customFieldEditorModel))
							])));
		}
	});
var $author$project$Location$Details$CustomFieldEditor$view = F3(
	function (config, session, _v0) {
		var model = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v1 = model.content;
					if (_v1.$ === 'CustomFieldEditor') {
						var customFieldEditorState = _v1.a;
						return A4(
							$author$project$Location$Details$CustomFieldEditor$customFieldEditorView,
							config,
							session,
							$author$project$Location$Details$CustomFieldEditor$State(model),
							customFieldEditorState);
					} else {
						var scheduledUpdate = _v1.a;
						return A4(
							$author$project$Location$Details$CustomFieldEditor$scheduledUpdateView,
							config,
							session,
							$author$project$Location$Details$CustomFieldEditor$State(model),
							scheduledUpdate);
					}
				}(),
					A2(
					$elm$html$Html$map,
					config.tagger,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Location$Details$Editor$Confirm$view,
								session,
								{onCancel: $author$project$Location$Details$CustomFieldEditor$ConfirmCancel, onConfirm: $author$project$Location$Details$CustomFieldEditor$ConfirmedUpdate}),
							model.confirm)))
				]));
	});
var $author$project$Location$Details$DevNetworkActions$Model$Close = {$: 'Close'};
var $author$project$Location$Details$DevNetworkActions$Model$Queued = {$: 'Queued'};
var $author$project$Location$Details$DevNetworkActions$Model$Submit = {$: 'Submit'};
var $author$project$Location$Details$DevNetworkActions$View$statusBox = F2(
	function (modifier, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dev-network-actions__status'),
					$elm$html$Html$Attributes$class('dev-network-actions__status--' + modifier)
				]),
			content);
	});
var $author$project$Location$Details$DevNetworkActions$View$statusText = function (message) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dev-network-actions__status-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(message)
			]));
};
var $author$project$Location$Details$DevNetworkActions$View$tracerLink = function (url) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(url),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$class('dev-network-actions__honeycomb-link')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('View in Honeycomb')
			]));
};
var $author$project$Location$Details$DevNetworkActions$Api$baseUrl = function (_v0) {
	var locationId = _v0.locationId;
	var siteName = _v0.siteName;
	var site = $author$project$Data$SiteName$toString(siteName);
	return 'api/' + (site + ('/place/' + (locationId + '/dev-network-actions')));
};
var $author$project$Location$Details$DevNetworkActions$Model$actionToApi = function (action) {
	switch (action.$) {
		case 'GetPlaceInfo':
			return 'getPlaceInfo';
		case 'GetMediaAssets':
			return 'getMediaAssets';
		default:
			return 'getReviewStats';
	}
};
var $author$project$Location$Details$DevNetworkActions$Model$networkToApi = function (network) {
	switch (network.$) {
		case 'Google':
			return 'google';
		case 'Facebook':
			return 'facebook';
		case 'Bing':
			return 'bing';
		default:
			return 'apple';
	}
};
var $author$project$Location$Details$DevNetworkActions$Api$queryString = F2(
	function (network, action) {
		return '?network=' + ($author$project$Location$Details$DevNetworkActions$Model$networkToApi(network) + ('&action=' + $author$project$Location$Details$DevNetworkActions$Model$actionToApi(action)));
	});
var $author$project$Location$Details$DevNetworkActions$Api$tracerUrl = F3(
	function (context, network, action) {
		return $author$project$Location$Details$DevNetworkActions$Api$baseUrl(context) + ('/tracer' + A2($author$project$Location$Details$DevNetworkActions$Api$queryString, network, action));
	});
var $author$project$Location$Details$DevNetworkActions$View$honeycombLink = F2(
	function (context, selected) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (_v0) {
				var network = _v0.a;
				var action = _v0.b;
				return $author$project$Location$Details$DevNetworkActions$View$tracerLink(
					A3($author$project$Location$Details$DevNetworkActions$Api$tracerUrl, context, network, action));
			},
			selected);
	});
var $author$project$Location$Details$DevNetworkActions$View$successMessage = function (selected) {
	var _v0 = A2($elm$core$Maybe$map, $elm$core$Tuple$second, selected);
	if (_v0.$ === 'Just') {
		switch (_v0.a.$) {
			case 'GetPlaceInfo':
				var _v1 = _v0.a;
				return 'Done. The location details were synced from Google.';
			case 'GetMediaAssets':
				var _v2 = _v0.a;
				return 'Done. Photos and videos were synced from Google.';
			default:
				var _v3 = _v0.a;
				return 'Done. Reviews and replies were synced from Google.';
		}
	} else {
		return 'Done.';
	}
};
var $author$project$Location$Details$DevNetworkActions$Api$networkTracerUrl = F2(
	function (context, network) {
		return $author$project$Location$Details$DevNetworkActions$Api$baseUrl(context) + ('/tracer?network=' + $author$project$Location$Details$DevNetworkActions$Model$networkToApi(network));
	});
var $author$project$Location$Details$DevNetworkActions$View$statusView = F4(
	function (context, selectedNetwork, selected, status) {
		switch (status.$) {
			case 'Suspended':
				return A2(
					$author$project$Location$Details$DevNetworkActions$View$statusBox,
					'info',
					_List_fromArray(
						[
							$author$project$Location$Details$DevNetworkActions$View$statusText('This is experimental. If it is useful to you, send the developers feedback or a quick thumbs-up, and tell us which actions you would like to see here.'),
							A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$html$Html$text(''),
							function (network) {
								return $author$project$Location$Details$DevNetworkActions$View$tracerLink(
									A2($author$project$Location$Details$DevNetworkActions$Api$networkTracerUrl, context, network));
							},
							selectedNetwork)
						]));
			case 'Loading':
				return A2(
					$author$project$Location$Details$DevNetworkActions$View$statusBox,
					'pending',
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dev-network-actions__spinner')
								]),
							_List_Nil),
							$author$project$Location$Details$DevNetworkActions$View$statusText('Queueing...')
						]));
			case 'Loaded':
				switch (status.a.$) {
					case 'Queued':
						var _v1 = status.a;
						return A2(
							$author$project$Location$Details$DevNetworkActions$View$statusBox,
							'pending',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dev-network-actions__spinner')
										]),
									_List_Nil),
									$author$project$Location$Details$DevNetworkActions$View$statusText('Queued. Waiting for the work to finish...')
								]));
					case 'Succeeded':
						var _v2 = status.a;
						return A2(
							$author$project$Location$Details$DevNetworkActions$View$statusBox,
							'success',
							_List_fromArray(
								[
									$author$project$Location$Details$DevNetworkActions$View$statusText(
									$author$project$Location$Details$DevNetworkActions$View$successMessage(selected)),
									A2($author$project$Location$Details$DevNetworkActions$View$honeycombLink, context, selected)
								]));
					case 'TimedOut':
						var _v3 = status.a;
						return A2(
							$author$project$Location$Details$DevNetworkActions$View$statusBox,
							'warning',
							_List_fromArray(
								[
									$author$project$Location$Details$DevNetworkActions$View$statusText('The work was not done within 3 minutes and is no longer being checked. Check the trace in Honeycomb manually.'),
									A2($author$project$Location$Details$DevNetworkActions$View$honeycombLink, context, selected)
								]));
					default:
						var error = status.a.a;
						return A2(
							$author$project$Location$Details$DevNetworkActions$View$statusBox,
							'error',
							_List_fromArray(
								[
									$author$project$Location$Details$DevNetworkActions$View$statusText('The work failed: ' + error),
									A2($author$project$Location$Details$DevNetworkActions$View$honeycombLink, context, selected)
								]));
				}
			default:
				var message = status.a;
				return A2(
					$author$project$Location$Details$DevNetworkActions$View$statusBox,
					'error',
					_List_fromArray(
						[
							$author$project$Location$Details$DevNetworkActions$View$statusText(message)
						]));
		}
	});
var $author$project$Location$Details$DevNetworkActions$View$sectionView = F2(
	function (title, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dev-network-actions__section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dev-network-actions__section-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					content
				]));
	});
var $author$project$PinMeTo$Ui$Lightbox$withClassName = F2(
	function (className, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Lightbox$View(
			_Utils_update(
				config,
				{
					className: $elm$core$Maybe$Just(className)
				}));
	});
var $author$project$Location$Details$DevNetworkActions$Model$GetPlaceInfo = {$: 'GetPlaceInfo'};
var $author$project$Location$Details$DevNetworkActions$Model$GetMediaAssets = {$: 'GetMediaAssets'};
var $author$project$Location$Details$DevNetworkActions$Model$GetReviewStats = {$: 'GetReviewStats'};
var $author$project$Location$Details$DevNetworkActions$Model$actionsFor = function (network) {
	switch (network.$) {
		case 'Google':
			return _List_fromArray(
				[$author$project$Location$Details$DevNetworkActions$Model$GetPlaceInfo, $author$project$Location$Details$DevNetworkActions$Model$GetMediaAssets, $author$project$Location$Details$DevNetworkActions$Model$GetReviewStats]);
		case 'Facebook':
			return _List_Nil;
		case 'Bing':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Location$Details$DevNetworkActions$View$actionLabel = function (action) {
	switch (action.$) {
		case 'GetPlaceInfo':
			return 'Get place info';
		case 'GetMediaAssets':
			return 'Get media assets';
		default:
			return 'Get review stats';
	}
};
var $author$project$Location$Details$DevNetworkActions$Model$SelectAction = function (a) {
	return {$: 'SelectAction', a: a};
};
var $author$project$Location$Details$DevNetworkActions$Model$Google = {$: 'Google'};
var $author$project$Location$Details$DevNetworkActions$Model$isActionEnabled = F2(
	function (network, action) {
		return _Utils_eq(network, $author$project$Location$Details$DevNetworkActions$Model$Google) && A2(
			$elm$core$List$member,
			action,
			_List_fromArray(
				[$author$project$Location$Details$DevNetworkActions$Model$GetPlaceInfo, $author$project$Location$Details$DevNetworkActions$Model$GetMediaAssets, $author$project$Location$Details$DevNetworkActions$Model$GetReviewStats]));
	});
var $author$project$Location$Details$DevNetworkActions$View$actionDescription = function (action) {
	switch (action.$) {
		case 'GetPlaceInfo':
			return 'Sync location details with Google';
		case 'GetMediaAssets':
			return 'Sync photos and videos, including cover and profile photo, from Google';
		default:
			return 'Sync reviews and replies from Google used for review stats';
	}
};
var $author$project$Location$Details$DevNetworkActions$View$actionSelector = F2(
	function (network, selectedAction) {
		var _v0 = $author$project$Location$Details$DevNetworkActions$Model$actionsFor(network);
		if (!_v0.b) {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dev-network-actions__hint')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No actions available for this network yet.')
					]));
		} else {
			var actions = _v0;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dev-network-actions__actions')
					]),
				A2(
					$elm$core$List$map,
					function (action) {
						var enabled = A2($author$project$Location$Details$DevNetworkActions$Model$isActionEnabled, network, action);
						return A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dev-network-actions__action'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'dev-network-actions__action--selected',
											_Utils_eq(
												selectedAction,
												$elm$core$Maybe$Just(action))),
											_Utils_Tuple2('dev-network-actions__action--disabled', !enabled)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('radio'),
											$elm$html$Html$Attributes$name('dev-network-action'),
											$elm$html$Html$Attributes$checked(
											_Utils_eq(
												selectedAction,
												$elm$core$Maybe$Just(action))),
											$elm$html$Html$Attributes$disabled(!enabled),
											$elm$html$Html$Events$onClick(
											$author$project$Location$Details$DevNetworkActions$Model$SelectAction(action))
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dev-network-actions__action-text')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('dev-network-actions__action-title')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Location$Details$DevNetworkActions$View$actionLabel(action))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('dev-network-actions__action-description')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Location$Details$DevNetworkActions$View$actionDescription(action))
												]))
										]))
								]));
					},
					actions));
		}
	});
var $author$project$Location$Details$DevNetworkActions$Model$Bing = {$: 'Bing'};
var $author$project$Location$Details$DevNetworkActions$Model$Apple = {$: 'Apple'};
var $author$project$Location$Details$DevNetworkActions$Model$Facebook = {$: 'Facebook'};
var $author$project$Location$Details$DevNetworkActions$View$networkIcon = function (network) {
	return $author$project$PinMeTo$Ui$Icon$render(
		function () {
			switch (network.$) {
				case 'Google':
					return $author$project$PinMeTo$Ui$Icon$RegularColorGoogle;
				case 'Facebook':
					return $author$project$PinMeTo$Ui$Icon$RegularColorFacebook;
				case 'Bing':
					return $author$project$PinMeTo$Ui$Icon$RegularColorBing;
				default:
					return $author$project$PinMeTo$Ui$Icon$RegularColorApple;
			}
		}());
};
var $author$project$Location$Details$DevNetworkActions$Model$networkLabel = function (network) {
	switch (network.$) {
		case 'Google':
			return 'Google';
		case 'Facebook':
			return 'Facebook';
		case 'Bing':
			return 'Bing';
		default:
			return 'Apple';
	}
};
var $author$project$Location$Details$DevNetworkActions$Model$SelectNetwork = function (a) {
	return {$: 'SelectNetwork', a: a};
};
var $author$project$Location$Details$DevNetworkActions$Model$isNetworkEnabled = function (network) {
	return A2(
		$elm$core$List$any,
		$author$project$Location$Details$DevNetworkActions$Model$isActionEnabled(network),
		$author$project$Location$Details$DevNetworkActions$Model$actionsFor(network));
};
var $author$project$Location$Details$DevNetworkActions$View$networkSelector = function (selected) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dev-network-actions__networks')
			]),
		A2(
			$elm$core$List$map,
			function (network) {
				var isSelected = _Utils_eq(
					selected,
					$elm$core$Maybe$Just(network));
				var enabled = $author$project$Location$Details$DevNetworkActions$Model$isNetworkEnabled(network);
				return A2(
					$elm$html$Html$button,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('dev-network-actions__network'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('dev-network-actions__network--selected', isSelected)
									])),
								$elm$html$Html$Attributes$disabled(!enabled),
								A2(
								$elm$html$Html$Attributes$attribute,
								'aria-pressed',
								isSelected ? 'true' : 'false'),
								$elm$html$Html$Events$onClick(
								$author$project$Location$Details$DevNetworkActions$Model$SelectNetwork(network))
							]),
						enabled ? _List_Nil : _List_fromArray(
							[
								$elm$html$Html$Attributes$title('Coming soon')
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dev-network-actions__network-icon')
								]),
							_List_fromArray(
								[
									$author$project$Location$Details$DevNetworkActions$View$networkIcon(network)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Location$Details$DevNetworkActions$Model$networkLabel(network))
								]))
						]));
			},
			_List_fromArray(
				[$author$project$Location$Details$DevNetworkActions$Model$Google, $author$project$Location$Details$DevNetworkActions$Model$Facebook, $author$project$Location$Details$DevNetworkActions$Model$Bing, $author$project$Location$Details$DevNetworkActions$Model$Apple])));
};
var $author$project$Location$Details$DevNetworkActions$Model$selectedSupported = function (model) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (network, action) {
				return _Utils_Tuple2(network, action);
			}),
		model.selectedNetwork,
		model.selectedAction);
};
var $author$project$Location$Details$DevNetworkActions$View$view = F2(
	function (context, model) {
		if (model.isOpen) {
			var selected = $author$project$Location$Details$DevNetworkActions$Model$selectedSupported(model);
			var isBusy = _Utils_eq(model.status, $author$project$RemoteData$Loading) || _Utils_eq(
				model.status,
				$author$project$RemoteData$Loaded($author$project$Location$Details$DevNetworkActions$Model$Queued));
			return $author$project$PinMeTo$Ui$Lightbox$render(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withClose,
					$author$project$Location$Details$DevNetworkActions$Model$Close,
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withClassName,
						'dev-network-actions-lightbox',
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withFooter,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dev-network-actions__footer')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$PinMeTo$Ui$Btn$pmtBtn,
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Location$Details$DevNetworkActions$Model$Submit),
												$elm$html$Html$Attributes$disabled(
												isBusy || _Utils_eq(selected, $elm$core$Maybe$Nothing))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Run')
											]))
									])),
							$author$project$PinMeTo$Ui$Lightbox$view(
								{
									title: 'Dev network actions',
									content: A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dev-network-actions')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('dev-network-actions__intro')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Run a network task for this location right away instead of waiting for the scheduled sync.')
													])),
												A2(
												$author$project$Location$Details$DevNetworkActions$View$sectionView,
												'Network',
												$author$project$Location$Details$DevNetworkActions$View$networkSelector(model.selectedNetwork)),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('dev-network-actions__actions-section')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Location$Details$DevNetworkActions$View$sectionView,
														'Action',
														A3(
															$elm_community$maybe_extra$Maybe$Extra$unwrap,
															A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('dev-network-actions__hint')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Select a network to see its actions.')
																	])),
															function (network) {
																return A2($author$project$Location$Details$DevNetworkActions$View$actionSelector, network, model.selectedAction);
															},
															model.selectedNetwork))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('dev-network-actions__status-slot')
													]),
												_List_fromArray(
													[
														A4($author$project$Location$Details$DevNetworkActions$View$statusView, context, model.selectedNetwork, selected, model.status)
													]))
											]))
								})))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Location$Details$DevNetworkActions$view = $author$project$Location$Details$DevNetworkActions$View$view;
var $author$project$Location$Details$View$viewId = 'ldp_main_view_id';
var $author$project$Location$Details$Model$EditorMsg = function (a) {
	return {$: 'EditorMsg', a: a};
};
var $author$project$Location$Details$Model$EditorClose = {$: 'EditorClose'};
var $author$project$Location$Details$Model$ImageEditorMsg = function (a) {
	return {$: 'ImageEditorMsg', a: a};
};
var $author$project$Translations$General$auditHistory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.audit_history');
};
var $author$project$Location$Details$View$historyLink = F2(
	function (model, translations) {
		return A2(
			$elm$html$Html$section,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-btn-group lightbox__history-btn-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-btn'),
									$elm$html$Html$Attributes$class('pmt-btn-small'),
									$elm$html$Html$Attributes$class('pmt-btn--link'),
									$elm$html$Html$Attributes$href(
									'/listings/' + ($author$project$Data$SiteName$toString(model.siteName) + ('/locations/' + (model.locationId + '/audit'))))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-solid fa-code-branch'),
											$elm$html$Html$Attributes$class('history-link-icon ')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$auditHistory(translations))
										]))
								]))
						]))
				]));
	});
var $author$project$Listings$Ui$Row$Row = function (a) {
	return {$: 'Row', a: a};
};
var $author$project$Listings$Ui$Row$NoConflict = {$: 'NoConflict'};
var $author$project$Listings$Ui$Row$row = function (config) {
	return $author$project$Listings$Ui$Row$Row(
		{icon: $elm$core$Maybe$Nothing, label: config.label, status: $author$project$Listings$Ui$Row$NoConflict, copyMsg: $elm$core$Maybe$Nothing, fieldType: config.fieldType, fullWidth: $elm$core$Maybe$Nothing, openQRCodeMsg: $elm$core$Maybe$Nothing, onOpenLightBox: $elm$core$Maybe$Nothing, scheduleUpdates: $elm$core$Maybe$Nothing, dataTestAttribute: $elm$core$Maybe$Nothing});
};
var $author$project$PinMeTo$Ui$Card$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Card$Large = {$: 'Large'};
var $author$project$PinMeTo$Ui$Card$Loaded = {$: 'Loaded'};
var $author$project$PinMeTo$Ui$Card$view = function (content) {
	return $author$project$PinMeTo$Ui$Card$View(
		{size: $author$project$PinMeTo$Ui$Card$Large, header: $elm$core$Maybe$Nothing, status: $author$project$PinMeTo$Ui$Card$Loaded, content: content, separator: true, backgroundColor: $elm$core$Maybe$Nothing});
};
var $author$project$Translations$Listings$OpenHours$notSet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.open_hours.not_set');
};
var $author$project$Translations$Listings$LocationDetail$fetchError = F2(
	function (translations, field) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.fetch_error',
			_List_fromArray(
				[
					_Utils_Tuple2(' field ', field)
				]));
	});
var $author$project$Listings$Ui$Row$renderFromDate = F3(
	function (stringDate, locale, translations) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(stringDate);
		if (_v0.$ === 'Ok') {
			var date = _v0.a;
			return $author$project$PinMeTo$Ui$Date$render(
				A2(
					$author$project$PinMeTo$Ui$Date$withFormat,
					$author$project$PinMeTo$Ui$Date$FormatDate,
					A2(
						$author$project$PinMeTo$Ui$Date$posix,
						locale,
						$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(date))));
		} else {
			return $author$project$Listings$Ui$Row$emptyValueSpan(translations);
		}
	});
var $author$project$Data$Location$SpecialOpenHours$isBeforeTime = F2(
	function (now, startDate) {
		return (_Utils_eq(
			A2($elm$time$Time$toDay, $elm$time$Time$utc, startDate),
			A2($elm$time$Time$toDay, $elm$time$Time$utc, now)) && (_Utils_eq(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, startDate),
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, now)) && _Utils_eq(
			A2($elm$time$Time$toYear, $elm$time$Time$utc, startDate),
			A2($elm$time$Time$toYear, $elm$time$Time$utc, now)))) ? false : (_Utils_cmp(
			$elm$time$Time$posixToMillis(startDate),
			$elm$time$Time$posixToMillis(now)) < 0);
	});
var $author$project$Data$Location$SpecialOpenHours$withoutExpired = F2(
	function (openHours, now) {
		return A2(
			$elm$core$List$filter,
			function (x) {
				return !A2($author$project$Data$Location$SpecialOpenHours$isBeforeTime, now, x.startDate);
			},
			openHours);
	});
var $author$project$Translations$Listings$LocationDetail$categoryPrimary = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.category_primary');
};
var $author$project$Listings$Ui$Row$textWithEmptyState = F2(
	function (translations, text) {
		return ($elm$core$String$length(text) > 0) ? text : $author$project$Listings$Ui$Row$emptyValue(translations);
	});
var $author$project$Listings$Ui$Row$renderParagraph = F2(
	function (translations, paragraph) {
		return ($elm$core$String$length(paragraph) > 0) ? A2(
			$elm$core$List$map,
			function (paragraph_) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value__text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(paragraph_)
						]));
			},
			A2(
				$elm$core$String$split,
				'\u000A',
				A2($author$project$Listings$Ui$Row$textWithEmptyState, translations, paragraph))) : _List_fromArray(
			[
				$author$project$Listings$Ui$Row$emptyValueSpan(translations)
			]);
	});
var $author$project$Translations$Listings$LocationDetail$categoryAdditional = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.category_additional');
};
var $author$project$Translations$Listings$LocationDetail$qrCode = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.qr_code');
};
var $author$project$FontAwesome$Regular$Icon$faClone = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-clone');
var $author$project$Translations$Listings$LocationDetail$copyLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.copy_link');
};
var $author$project$FontAwesome$Solid$Icon$faQrcode = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-qrcode');
var $author$project$Listings$Ui$Row$possibleOnClick = function (config) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$Attributes$class(''),
		function (msg) {
			return $elm$html$Html$Events$onClick(msg);
		},
		config.onOpenLightBox);
};
var $author$project$Listings$Ui$Row$hoverOnClickable = function (config) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$Attributes$class(''),
		function (_v0) {
			return $elm$html$Html$Attributes$class('location-details-group__clickable-element');
		},
		config.onOpenLightBox);
};
var $author$project$Listings$Ui$Row$possibleDataTestAttribute = function (config) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		A2($elm$html$Html$Attributes$attribute, 'data-test', ''),
		function (value) {
			return A2($elm$html$Html$Attributes$attribute, 'data-test', value);
		},
		config.dataTestAttribute);
};
var $author$project$Listings$Ui$Row$renderNewReviewLink = F3(
	function (link, translations, config) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(link),
						$elm$html$Html$Attributes$id('copy'),
						$elm$html$Html$Attributes$class('location-details-row__review_link'),
						$author$project$Listings$Ui$Row$possibleOnClick(config),
						$author$project$Listings$Ui$Row$hoverOnClickable(config),
						$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(link)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__review_actions')
					]),
				_List_fromArray(
					[
						A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2($elm$html$Html$span, _List_Nil, _List_Nil),
						function (msg) {
							return $author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									msg,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$withIconBefore,
											$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faClone),
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$Listings$LocationDetail$copyLink(translations))))));
						},
						config.copyMsg),
						A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2($elm$html$Html$span, _List_Nil, _List_Nil),
						function (msg) {
							return $author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									msg,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										A2(
											$author$project$PinMeTo$Ui$Button$withIconBefore,
											$author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faQrcode),
											$author$project$PinMeTo$Ui$Button$buttonGhost(
												$author$project$Translations$Listings$LocationDetail$qrCode(translations))))));
						},
						config.openQRCodeMsg)
					]))
			]);
	});
var $author$project$Listings$Ui$Row$renderCustomNameRows = function (customNames) {
	return A2(
		$elm$core$List$map,
		function (customName) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__custom-names-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details-row__custom-names-label pmt-ui-font-caption')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(customName.label)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details-row__custom-names-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(customName.value)
							]))
					]));
		},
		customNames);
};
var $author$project$Listings$Ui$Row$renderActionLinksRows = F2(
	function (actionLinks, translations) {
		return A2(
			$elm$core$List$map,
			function (actionLink) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__action-links-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__action-links-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Data$Location$ActionLinks$typeToLabel, actionLink.type_, translations))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__action-links-type location-details-row__action-links-url')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(actionLink.url)
								]))
						]));
			},
			actionLinks);
	});
var $author$project$PinMeTo$Deprecated$FontAwesome$Check = {$: 'Check'};
var $author$project$PinMeTo$Deprecated$FontAwesome$AttributeTrue = {$: 'AttributeTrue'};
var $author$project$PinMeTo$Deprecated$FontAwesome$AttributeFalse = {$: 'AttributeFalse'};
var $author$project$Listings$Ui$Row$googleBooleanToHtml = function (attribute) {
	return A2(
		$elm$html$Html$td,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$PinMeTo$Deprecated$FontAwesome$render(
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$PinMeTo$Deprecated$FontAwesome$AttributeFalse,
					function (b) {
						return (b === 'true') ? $author$project$PinMeTo$Deprecated$FontAwesome$AttributeTrue : $author$project$PinMeTo$Deprecated$FontAwesome$AttributeFalse;
					},
					$elm$core$List$head(attribute.values)))
			]));
};
var $author$project$Listings$Ui$Row$renderGoogleAttributesRows = F2(
	function (attributes, translations) {
		return A2(
			$elm$core$List$map,
			function (attribute) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__attribute-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(attribute.name)
								])),
							function () {
							var _v0 = attribute.type_;
							switch (_v0) {
								case 'BOOL':
									return $author$project$Listings$Ui$Row$googleBooleanToHtml(attribute);
								case 'REPEATED_ENUM':
									return A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('location-details-row__enum')
													]),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														function (v) {
															return A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('location-details-row__pill location-details-row__pill--true')
																	]),
																_List_fromArray(
																	[
																		$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Check),
																		A2(
																		$elm$html$Html$span,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(v)
																			]))
																	]));
														},
														attribute.values),
													A2(
														$elm$core$List$map,
														function (v) {
															return A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('location-details-row__pill location-details-row__pill--false')
																	]),
																_List_fromArray(
																	[
																		$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete),
																		A2(
																		$elm$html$Html$span,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(v)
																			]))
																	]));
														},
														attribute.unsetValue)))
											]));
								case 'ENUM':
									return A2(
										$elm$html$Html$td,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (v) {
												return A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('location-details-row__pill location-details-row__pill--true')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(v)
														]));
											},
											attribute.values));
								default:
									return A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												$author$project$Listings$Ui$Row$emptyValueSpan(translations),
												function (value) {
													return $elm$html$Html$text(value);
												},
												$elm$core$List$head(attribute.values))
											]));
							}
						}()
						]));
			},
			attributes);
	});
var $author$project$Listings$Ui$Row$renderLatitudeAndLongitude = F2(
	function (coordinates, translations) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__coordinates_lat')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$General$locationLatitude(translations) + ': '),
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(coordinates.lat))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__coordinates_long')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$General$locationLongitude(translations) + ': '),
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(coordinates.lon))
							]))
					]))
			]);
	});
var $author$project$Listings$Ui$Row$getHtml = F4(
	function (fieldType, translations, locale, config) {
		var fullWidthClass = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$Attributes$class('location-details-row__inner-value'),
			function (_v2) {
				return $elm$html$Html$Attributes$class('location-details-row__value__max_content');
			},
			config.fullWidth);
		var getAttributesTable = function (attributeList) {
			return $elm$core$List$isEmpty(attributeList) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__value'),
						fullWidthClass,
						$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
					]),
				_List_fromArray(
					[
						$author$project$Listings$Ui$Row$emptyValueSpan(translations)
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__value'),
						fullWidthClass,
						$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_Nil,
						A2($author$project$Listings$Ui$Row$renderGoogleAttributesRows, attributeList, translations))
					]));
		};
		switch (fieldType.$) {
			case 'Paragraph':
				var paragraph = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					A2($author$project$Listings$Ui$Row$renderParagraph, translations, paragraph));
			case 'MultiParagraph':
				var paragraphList = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					A2(
						$elm$core$List$map,
						function (paragraph) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('location-details-row__value__text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Listings$Ui$Row$textWithEmptyState, translations, paragraph))
									]));
						},
						paragraphList));
			case 'ObjectParagraph':
				var _v1 = fieldType.a;
				var displayName = _v1.a;
				var fieldTypeList = _v1.b;
				var nestedObjectClass = ($elm$core$String$length(displayName) > 0) ? 'location-details-row__indented ' : 'location-details-row__inner-value';
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value')
						]),
					A2(
						$elm$core$List$map,
						function (field) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(nestedObjectClass),
										$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(displayName),
										A4($author$project$Listings$Ui$Row$getHtml, field, translations, locale, config)
									]));
						},
						fieldTypeList));
			case 'ObjectInnerParagraph':
				var paragraph = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					A2($author$project$Listings$Ui$Row$renderParagraph, translations, paragraph));
			case 'ObjectInnerOpenHours':
				var label = fieldType.a;
				var openHours = fieldType.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label + ': ')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__value location-details-row__table')
								]),
							_List_fromArray(
								[
									A2($author$project$Listings$Ui$Row$renderOpenHoursView, openHours, translations)
								]))
						]));
			case 'ObjectInnerSpecialOpenHours':
				var label = fieldType.a;
				var hours = fieldType.b;
				var today = fieldType.c;
				var withoutExpiredHours = A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, hours, today);
				return ($elm$core$List$length(withoutExpiredHours) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label + ': ')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__value location-details-row__table')
								]),
							_List_fromArray(
								[
									A2($author$project$Listings$Ui$Row$renderSpecialOpenHoursTable, withoutExpiredHours, translations)
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label + ': ')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__value__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$OpenHours$notSet(translations))
								]))
						]));
			case 'Coordinates':
				var coordinates = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__coordinates'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					A2($author$project$Listings$Ui$Row$renderLatitudeAndLongitude, coordinates, translations));
			case 'ProfileImage':
				var link = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__profile_image'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(link)
								]),
							_List_Nil)
						]));
			case 'CoverImage':
				var link = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__cover_image'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(link)
								]),
							_List_Nil)
						]));
			case 'CategoryPrimaryAdditional':
				var additional = fieldType.a.additional;
				var primary = fieldType.a.primary;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__categories'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__categories-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('location-details-row__categories-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$categoryPrimary(translations))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('location-details-row__categories-value')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(primary)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__categories-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('location-details-row__categories-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$LocationDetail$categoryAdditional(translations))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('location-details-row__categories-value')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(additional)
										]))
								]))
						]));
			case 'NewReviewLink':
				var link = fieldType.a.a;
				return ($elm$core$String$length(link) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass
						]),
					A3($author$project$Listings$Ui$Row$renderNewReviewLink, link, translations, config)) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass
						]),
					_List_fromArray(
						[
							$author$project$Listings$Ui$Row$emptyValueSpan(translations)
						]));
			case 'GoogleAttributes':
				var attributes = fieldType.a;
				var noUrlAttributes = A2(
					$elm$core$List$filter,
					function (attribute) {
						return attribute.type_ !== 'URL';
					},
					attributes);
				return getAttributesTable(noUrlAttributes);
			case 'GoogleUrlAttributes':
				var attributes = fieldType.a;
				var urlAttributes = A2(
					$elm$core$List$filter,
					function (attribute) {
						return attribute.type_ === 'URL';
					},
					attributes);
				return $elm$core$List$isEmpty(urlAttributes) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass
						]),
					_List_fromArray(
						[
							$author$project$Listings$Ui$Row$emptyValueSpan(translations)
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__action-links-table'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					A2(
						$elm$core$List$map,
						function (attribute) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('location-details-row__action-links-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('location-details-row__action-links-header')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(attribute.name)
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('location-details-row__action-links-type location-details-row__action-links-url')
											]),
										_List_fromArray(
											[
												A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												$author$project$Listings$Ui$Row$emptyValueSpan(translations),
												function (value) {
													return $elm$html$Html$text(value);
												},
												$elm$core$List$head(attribute.values))
											]))
									]));
						},
						urlAttributes));
			case 'SpecialOpenHours':
				var hours = fieldType.a;
				var today = fieldType.b;
				var withoutExpiredHours = A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, hours, today);
				return ($elm$core$List$length(withoutExpiredHours) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__table'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2($author$project$Listings$Ui$Row$renderSpecialOpenHoursTable, withoutExpiredHours, translations)
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__value__text')
								]),
							_List_fromArray(
								[
									$author$project$Listings$Ui$Row$emptyValueSpan(translations)
								]))
						]));
			case 'OpenHours':
				var hour = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__table'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A2($author$project$Listings$Ui$Row$renderOpenHoursView, hour, translations)
						]));
			case 'TemporarilyClosed':
				var tempClosed = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A3($author$project$Listings$Ui$Row$renderTemporarilyClosedView, tempClosed, translations, locale)
						]));
			case 'DateFromString':
				var stringDate = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_List_fromArray(
						[
							A3($author$project$Listings$Ui$Row$renderFromDate, stringDate, locale, translations)
						]));
			case 'ActionLinks':
				var actionLinks = fieldType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__action-links-table'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					A2($author$project$Listings$Ui$Row$renderActionLinksRows, actionLinks, translations));
			case 'StorefrontNames':
				var storefrontName = fieldType.a;
				var customNames = fieldType.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value'),
							fullWidthClass,
							$author$project$Listings$Ui$Row$possibleDataTestAttribute(config)
						]),
					_Utils_ap(
						A2($author$project$Listings$Ui$Row$renderParagraph, translations, storefrontName),
						$elm$core$List$isEmpty(customNames) ? _List_Nil : _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('location-details-row__custom-names-table')
									]),
								$author$project$Listings$Ui$Row$renderCustomNameRows(customNames))
							])));
			default:
				var field = fieldType.a;
				return $author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Error,
						$author$project$PinMeTo$Ui$Alert$plain(
							A2($author$project$Translations$Listings$LocationDetail$fetchError, translations, field))));
		}
	});
var $author$project$PinMeTo$Deprecated$FontAwesome$Conflict = {$: 'Conflict'};
var $author$project$PinMeTo$Deprecated$FontAwesome$WorkInProgress = {$: 'WorkInProgress'};
var $author$project$Listings$Ui$Row$render = F3(
	function (_v0, translations, locale) {
		var config = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group__row location-details-row'),
					$author$project$Listings$Ui$Row$possibleOnClick(config),
					$author$project$Listings$Ui$Row$hoverOnClickable(config)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__label-conflicts-container')
								]),
							_List_fromArray(
								[
									function () {
									var _v1 = config.icon;
									if (_v1.$ === 'Nothing') {
										return $elm$html$Html$text('');
									} else {
										var icon = _v1.a.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('location-details-row__icon'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'location-details-row__icon--conflict',
															_Utils_eq(icon, $author$project$PinMeTo$Deprecated$FontAwesome$Conflict)),
															_Utils_Tuple2(
															'location-details-row__icon--work',
															_Utils_eq(icon, $author$project$PinMeTo$Deprecated$FontAwesome$WorkInProgress))
														]))
												]),
											_List_fromArray(
												[
													$author$project$PinMeTo$Deprecated$FontAwesome$render(icon)
												]));
									}
								}(),
									$author$project$Listings$Ui$Label$render(config.label)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									config.scheduleUpdates)
								]))
						])),
					A4($author$project$Listings$Ui$Row$getHtml, config.fieldType, translations, locale, config)
				]));
	});
var $author$project$PinMeTo$Ui$Card$Error = {$: 'Error'};
var $author$project$PinMeTo$Ui$Card$Medium = {$: 'Medium'};
var $author$project$PinMeTo$Ui$Card$Loading = {$: 'Loading'};
var $author$project$PinMeTo$Ui$Card$render = function (_v0) {
	var config = _v0.a;
	var attributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('pmt-ui-card'),
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pmt-ui-card--is-loading',
					_Utils_eq(config.status, $author$project$PinMeTo$Ui$Card$Loading)),
					_Utils_Tuple2(
					'pmt-ui-card--is-error',
					_Utils_eq(config.status, $author$project$PinMeTo$Ui$Card$Error)),
					_Utils_Tuple2(
					'pmt-ui-card--is-medium',
					_Utils_eq(config.size, $author$project$PinMeTo$Ui$Card$Medium))
				]))
		]);
	return A2(
		$elm$html$Html$div,
		function () {
			var _v1 = config.backgroundColor;
			if (_v1.$ === 'Just') {
				var color = _v1.a;
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'background-color', color),
					attributes);
			} else {
				return attributes;
			}
		}(),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (header) {
						var borderClass = $elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-ui-card__header__without-border', !config.separator)
								]));
						return A2(
							$elm$html$Html$header,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-card__header'),
									borderClass
								]),
							_List_fromArray(
								[header]));
					},
					config.header)),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-card__content')
					]),
				_List_fromArray(
					[config.content]))
			]));
};
var $author$project$Listings$Ui$Row$CoverImage = function (a) {
	return {$: 'CoverImage', a: a};
};
var $author$project$Location$ImageEditor$GoogleLogo = {$: 'GoogleLogo'};
var $author$project$Listings$Ui$Row$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$Listings$Ui$Row$withStatus = F2(
	function (status, _v0) {
		var config = _v0.a;
		var icon = function () {
			switch (status.$) {
				case 'Conflict':
					return $elm$core$Maybe$Nothing;
				case 'Work':
					return $elm$core$Maybe$Just(
						$author$project$Listings$Ui$Row$Icon($author$project$PinMeTo$Deprecated$FontAwesome$WorkInProgress));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{icon: icon, status: status}));
	});
var $author$project$Location$ImageEditor$GoogleCover = {$: 'GoogleCover'};
var $author$project$Listings$Ui$Row$ProfileImage = function (a) {
	return {$: 'ProfileImage', a: a};
};
var $author$project$Location$ImageEditor$FacebookCover = {$: 'FacebookCover'};
var $author$project$Location$ImageEditor$FacebookProfile = {$: 'FacebookProfile'};
var $author$project$Location$Details$Model$ImageEditorOpen = function (a) {
	return {$: 'ImageEditorOpen', a: a};
};
var $author$project$Listings$Ui$Row$withOpenLightBox = F3(
	function (active, msg, _v0) {
		var config = _v0.a;
		return _Utils_eq(active, $author$project$Data$Location$Active) ? $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{
					onOpenLightBox: $elm$core$Maybe$Just(msg)
				})) : $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{onOpenLightBox: $elm$core$Maybe$Nothing}));
	});
var $author$project$Translations$General$locationLogoImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_logo_image');
};
var $author$project$Translations$General$locationCoverImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_cover_image');
};
var $author$project$Translations$General$locationProfileImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_profile_image');
};
var $author$project$Listings$Ui$Row$withDataTestAttribute = F2(
	function (idValue, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{
					dataTestAttribute: $elm$core$Maybe$Just(idValue)
				}));
	});
var $author$project$Location$Details$View$imagesSection = F2(
	function (session, locationData) {
		var _v0 = locationData.facebookProfileImage;
		var facebookProfileImage = _v0.a;
		var facebookProfileImageConflicts = _v0.b;
		var _v1 = locationData.googleProfileImage;
		var googleProfileImage = _v1.a;
		var googleProfileImageConflicts = _v1.b;
		var _v2 = locationData.facebookCoverImage;
		var facebookCoverImage = _v2.a;
		var facebookCoverImageConflicts = _v2.b;
		var _v3 = locationData.googleCoverImage;
		var googleCoverImage = _v3.a;
		var googleCoverImageConflicts = _v3.b;
		var facebookEnabled = _Utils_eq(session.analytics.facebook, $author$project$PinMeToPage$NetworkEnabled);
		var googleEnabled = _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled);
		var translations = session.translations;
		var withNetwork = F2(
			function (title, network) {
				return title + (' (' + (network + ')'));
			});
		var googleLogoRow = A2(
			$author$project$Listings$Ui$Row$withDataTestAttribute,
			'googleSection.locationProfileImage',
			A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$ImageEditorOpen($author$project$Location$ImageEditor$GoogleLogo),
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					googleProfileImageConflicts,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: A2(
										withNetwork,
										$author$project$Translations$General$locationLogoImage(translations),
										$author$project$Translations$General$Insights$google(translations)),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$ProfileImage(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function (media) {
										return media.previewUrl;
									},
									googleProfileImage))
						}))));
		var googleCoverRow = A2(
			$author$project$Listings$Ui$Row$withDataTestAttribute,
			'googleSection.locationCoverImage',
			A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$ImageEditorOpen($author$project$Location$ImageEditor$GoogleCover),
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					googleCoverImageConflicts,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: A2(
										withNetwork,
										$author$project$Translations$General$locationCoverImage(translations),
										$author$project$Translations$General$Insights$google(translations)),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$CoverImage(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function (media) {
										return media.previewUrl;
									},
									googleCoverImage))
						}))));
		var facebookCoverRow = A2(
			$author$project$Listings$Ui$Row$withDataTestAttribute,
			'facebookSection.locationCoverImage',
			A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$ImageEditorOpen($author$project$Location$ImageEditor$FacebookCover),
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					facebookCoverImageConflicts,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: A2(
										withNetwork,
										$author$project$Translations$General$locationCoverImage(translations),
										$author$project$Translations$General$Insights$facebook(translations)),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$CoverImage(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function (media) {
										return media.previewUrl;
									},
									facebookCoverImage))
						}))));
		var facebookProfileRow = A2(
			$author$project$Listings$Ui$Row$withDataTestAttribute,
			'facebookSection.locationProfileImage',
			A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$ImageEditorOpen($author$project$Location$ImageEditor$FacebookProfile),
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					facebookProfileImageConflicts,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: A2(
										withNetwork,
										$author$project$Translations$General$locationProfileImage(translations),
										$author$project$Translations$General$Insights$facebook(translations)),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$ProfileImage(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function (media) {
										return media.previewUrl;
									},
									facebookProfileImage))
						}))));
		var locale = session.locale;
		var rows = _Utils_ap(
			googleEnabled ? _List_fromArray(
				[googleLogoRow, googleCoverRow]) : _List_Nil,
			facebookEnabled ? _List_fromArray(
				[facebookProfileRow, facebookCoverRow]) : _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$sectionImages(translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Listings$Ui$Row$render, row, translations, locale)
											]));
								},
								rows))))
				]));
	});
var $author$project$Listings$Ui$Row$OpenHours = function (a) {
	return {$: 'OpenHours', a: a};
};
var $author$project$Location$Details$Model$EditorOpen = function (a) {
	return {$: 'EditorOpen', a: a};
};
var $author$project$Location$Details$Editor$OpenStatusEditor = function (a) {
	return {$: 'OpenStatusEditor', a: a};
};
var $author$project$Location$Details$View$StatusOpen = {$: 'StatusOpen'};
var $author$project$Location$Details$View$StatusDisabled = {$: 'StatusDisabled'};
var $author$project$Location$Details$View$StatusPermanentlyClosed = {$: 'StatusPermanentlyClosed'};
var $author$project$Location$Details$View$StatusTemporarilyClosed = {$: 'StatusTemporarilyClosed'};
var $author$project$Location$Details$View$isCurrentlyTemporarilyClosed = F2(
	function (tempClosed, today) {
		switch (tempClosed.$) {
			case 'Until':
				var until = tempClosed.a;
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(until),
					$elm$time$Time$posixToMillis(today)) > -1;
			case 'Indefinitely':
				return true;
			default:
				return false;
		}
	});
var $author$project$Location$Details$View$currentOpenStatus = F4(
	function (isActive, permanentlyClosed, tempClosed, today) {
		return (!_Utils_eq(isActive, $author$project$Data$Location$Active)) ? $author$project$Location$Details$View$StatusDisabled : (permanentlyClosed ? $author$project$Location$Details$View$StatusPermanentlyClosed : (A2($author$project$Location$Details$View$isCurrentlyTemporarilyClosed, tempClosed, today) ? $author$project$Location$Details$View$StatusTemporarilyClosed : $author$project$Location$Details$View$StatusOpen));
	});
var $author$project$Location$Details$View$scheduleDateHtml = F2(
	function (locale, posix) {
		return $author$project$PinMeTo$Ui$Date$render(
			A2(
				$author$project$PinMeTo$Ui$Date$withFormat,
				$author$project$PinMeTo$Ui$Date$FormatDate,
				A2($author$project$PinMeTo$Ui$Date$posix, locale, posix)));
	});
var $author$project$Location$Details$View$scheduledClosureRow = F2(
	function (label, dateContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-open-status__scheduled')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-open-status__scheduled-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-open-status__scheduled-date')
						]),
					dateContent)
				]));
	});
var $author$project$Location$Details$View$scheduledClosureRows = F3(
	function (locale, translations, scheduleUpdates) {
		var sortedByDate = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			scheduleUpdates);
		var permanentlyClosedRows = A2(
			$elm$core$List$filterMap,
			function (scheduleUpdate) {
				var _v2 = scheduleUpdate.fieldAndData;
				if (_v2.$ === 'PermanentlyClosedField') {
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Location$Details$View$scheduledClosureRow,
							$author$project$Translations$General$locationPermanentlyClosed(translations),
							_List_fromArray(
								[
									A2($author$project$Location$Details$View$scheduleDateHtml, locale, scheduleUpdate.date)
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			sortedByDate);
		var temporarilyClosedRows = A2(
			$elm$core$List$filterMap,
			function (scheduleUpdate) {
				var _v0 = scheduleUpdate.fieldAndData;
				if ((_v0.$ === 'TemporarilyClosedField') && (_v0.a.$ === 'Until')) {
					var _v1 = _v0.a;
					var until = _v1.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Location$Details$View$scheduledClosureRow,
							$author$project$Translations$General$locationTempClosed(translations),
							_List_fromArray(
								[
									A2($author$project$Location$Details$View$scheduleDateHtml, locale, scheduleUpdate.date),
									$elm$html$Html$text(' - '),
									A2($author$project$Location$Details$View$scheduleDateHtml, locale, until)
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			sortedByDate);
		return _Utils_ap(temporarilyClosedRows, permanentlyClosedRows);
	});
var $author$project$Translations$General$locationOpenStatusDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_open_status_description');
};
var $author$project$Location$Details$View$openStatusRow = F7(
	function (isActive, permanentlyClosed, tempClosed, scheduleUpdates, today, locale, translations) {
		var _v0 = function () {
			var _v1 = A4($author$project$Location$Details$View$currentOpenStatus, isActive, permanentlyClosed, tempClosed, today);
			switch (_v1.$) {
				case 'StatusDisabled':
					return _Utils_Tuple2(
						$author$project$Translations$General$disabled(translations),
						'location-details-open-status--disabled');
				case 'StatusPermanentlyClosed':
					return _Utils_Tuple2(
						$author$project$Translations$General$closed(translations),
						'location-details-open-status--permanently-closed');
				case 'StatusTemporarilyClosed':
					return _Utils_Tuple2(
						$author$project$Translations$General$locationTempClosed(translations),
						'location-details-open-status--temporarily-closed');
				default:
					return _Utils_Tuple2(
						$author$project$Translations$General$open(translations),
						'location-details-open-status--open');
			}
		}();
		var label = _v0.a;
		var colorClass = _v0.b;
		var clickAttrs = _Utils_eq(isActive, $author$project$Data$Location$Active) ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-details-group__clickable-element'),
				$elm$html$Html$Events$onClick(
				$author$project$Location$Details$Model$EditorOpen(
					$author$project$Location$Details$Editor$OpenStatusEditor($elm$core$Maybe$Nothing)))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('location-details-group__row location-details-row'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'openHoursSection.locationOpenStatus'),
					clickAttrs)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__label-conflicts-container')
								]),
							_List_fromArray(
								[
									$author$project$Listings$Ui$Label$render(
									$author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationOpenStatus(translations),
											description: $author$project$Translations$General$locationOpenStatusDescription(translations)
										}))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-open-status__list')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-open-status ' + colorClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
						A3($author$project$Location$Details$View$scheduledClosureRows, locale, translations, scheduleUpdates)))
				]));
	});
var $author$project$Location$Details$Editor$OpenHoursEditor = F2(
	function (a, b) {
		return {$: 'OpenHoursEditor', a: a, b: b};
	});
var $author$project$Listings$Ui$Row$SpecialOpenHours = F2(
	function (a, b) {
		return {$: 'SpecialOpenHours', a: a, b: b};
	});
var $author$project$Location$Details$Model$ScheduleUpdateEditorOpen = function (a) {
	return {$: 'ScheduleUpdateEditorOpen', a: a};
};
var $author$project$Location$Details$View$renderSchedulingChip = F2(
	function (scheduleUpdate, date) {
		return A4(
			$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
			$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faCalendarDay),
			$elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Common$Util$onClickFinal(
					$author$project$Location$Details$Model$ScheduleUpdateEditorOpen(scheduleUpdate))
				]),
			_List_fromArray(
				[date]));
	});
var $author$project$Location$Details$View$scheduleUpdatesView = F2(
	function (locale, scheduleUpdates) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (scheduleUpdate) {
					var date = A2($author$project$Location$Details$View$scheduleDateHtml, locale, scheduleUpdate.date);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details-label__schedule-updates__margin'),
								$elm$html$Html$Attributes$class('location-details-label__schedule-updates__rounded-button')
							]),
						_List_fromArray(
							[
								A2($author$project$Location$Details$View$renderSchedulingChip, scheduleUpdate, date)
							]));
				},
				scheduleUpdates));
	});
var $author$project$Listings$Ui$Row$withScheduleUpdates = F2(
	function (scheduleUpdates, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{
					scheduleUpdates: $elm$core$Maybe$Just(scheduleUpdates)
				}));
	});
var $author$project$Translations$Listings$LocationDetail$descriptionOpenHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_open_hours');
};
var $author$project$Translations$General$locationRegularHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_regular_hours');
};
var $author$project$Location$Details$Editor$SpecialOpenHoursEditor = F3(
	function (a, b, c) {
		return {$: 'SpecialOpenHoursEditor', a: a, b: b, c: c};
	});
var $author$project$Location$Details$View$openHoursSection = F6(
	function (_v0, locationData, scheduleUpdates, today, locale, translations) {
		var _v1 = locationData.permanentlyClosed;
		var permanentlyClosed = _v1.a;
		var permanentlyClosedConflict = _v1.b;
		var _v2 = locationData.specialOpenHours;
		var specialOpenHours = _v2.a;
		var specialOpenHoursConflict = _v2.b;
		var openHoursScheduleUpdates = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			A2(
				$elm$core$List$filter,
				function (scheduleUpdate) {
					var _v7 = scheduleUpdate.fieldAndData;
					if (_v7.$ === 'OpenHoursField') {
						return true;
					} else {
						return false;
					}
				},
				scheduleUpdates));
		var _v3 = locationData.temporarilyClosedUntil;
		var tempClosed = _v3.a;
		var tempClosedConflict = _v3.b;
		var _v4 = locationData.openHours;
		var openHours = _v4.a;
		var openHoursConflict = _v4.b;
		var tempClosedMessage = function () {
			var _v6 = locationData.temporarilyClosedMessage;
			var temporarilyClosedMessage = _v6.a;
			return $author$project$Data$Location$temporarilyClosedMessageToString(temporarilyClosedMessage);
		}();
		var temporarilyClosed = function () {
			if (tempClosed.$ === 'Until') {
				var posix = tempClosed.a;
				return A2($author$project$Data$NetworkData$TemporarilyClosed$Until, posix, tempClosedMessage);
			} else {
				return tempClosed;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationHoursAndStatus(translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A7($author$project$Location$Details$View$openStatusRow, locationData.isActive, permanentlyClosed, tempClosed, scheduleUpdates, today, locale, translations)
										])),
								A2(
									$elm$core$List$map,
									function (row) {
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A3($author$project$Listings$Ui$Row$render, row, translations, locale)
												]));
									},
									_List_fromArray(
										[
											A2(
											$author$project$Listings$Ui$Row$withScheduleUpdates,
											A2($author$project$Location$Details$View$scheduleUpdatesView, locale, openHoursScheduleUpdates),
											A2(
												$author$project$Listings$Ui$Row$withDataTestAttribute,
												'openHoursSection.locationOpenHours',
												A3(
													$author$project$Listings$Ui$Row$withOpenLightBox,
													locationData.isActive,
													$author$project$Location$Details$Model$EditorOpen(
														A2($author$project$Location$Details$Editor$OpenHoursEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
													A2(
														$author$project$Listings$Ui$Row$withStatus,
														openHoursConflict,
														$author$project$Listings$Ui$Row$row(
															{
																label: $author$project$Listings$Ui$Label$label(
																	{
																		title: $author$project$Translations$General$locationRegularHours(translations),
																		description: $author$project$Translations$Listings$LocationDetail$descriptionOpenHours(translations)
																	}),
																fieldType: $author$project$Listings$Ui$Row$OpenHours(openHours)
															}))))),
											A2(
											$author$project$Listings$Ui$Row$withDataTestAttribute,
											'openHoursSection.locationSpecialHours',
											A3(
												$author$project$Listings$Ui$Row$withOpenLightBox,
												locationData.isActive,
												$author$project$Location$Details$Model$EditorOpen(
													A3($author$project$Location$Details$Editor$SpecialOpenHoursEditor, $author$project$Location$Details$PopupContent$SpecialOpenHours$LDP, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
												A2(
													$author$project$Listings$Ui$Row$withStatus,
													specialOpenHoursConflict,
													$author$project$Listings$Ui$Row$row(
														{
															label: $author$project$Listings$Ui$Label$label(
																{
																	title: $author$project$Translations$General$locationSpecialHours(translations),
																	description: $author$project$Translations$Listings$LocationDetail$descriptionSpecialOpenHours(translations)
																}),
															fieldType: A2($author$project$Listings$Ui$Row$SpecialOpenHours, specialOpenHours, today)
														}))))
										]))))))
				]));
	});
var $author$project$Translations$General$Insights$here = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.here');
};
var $author$project$Translations$General$Insights$tomtom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.tomtom');
};
var $author$project$Translations$General$Insights$overture = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.overture');
};
var $author$project$Translations$General$Insights$foursquare = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.foursquare');
};
var $author$project$Location$Details$Editor$CategoriesEditor = F3(
	function (a, b, c) {
		return {$: 'CategoriesEditor', a: a, b: b, c: c};
	});
var $author$project$Listings$Ui$Row$CategoryPrimaryAdditional = function (a) {
	return {$: 'CategoryPrimaryAdditional', a: a};
};
var $author$project$Location$Details$View$getLocationCategoriesWithSiteFallback = F2(
	function (locationCategories, siteCategories) {
		if (!locationCategories.b) {
			return siteCategories;
		} else {
			if ((locationCategories.a === '') && (!locationCategories.b.b)) {
				return siteCategories;
			} else {
				return locationCategories;
			}
		}
	});
var $author$project$Location$Details$View$categoriesSection = F3(
	function (session, locationData, siteCategories) {
		var _v0 = locationData.foursquareNetworkCategories;
		var foursquareNetworkCategories = _v0.a;
		var foursquareNetworkCategoriesConflicts = _v0.b;
		var _v1 = locationData.overtureNetworkCategories;
		var overtureNetworkCategories = _v1.a;
		var overtureNetworkCategoriesConflicts = _v1.b;
		var _v2 = locationData.facebookNetworkCategories;
		var facebookNetworkCategories = _v2.a;
		var facebookNetworkCategoriesConflicts = _v2.b;
		var _v3 = locationData.googleNetworkCategories;
		var googleNetworkCategories = _v3.a;
		var googleNetworkCategoriesConflicts = _v3.b;
		var _v4 = locationData.appleNetworkCategories;
		var appleNetworkCategories = _v4.a;
		var appleNetworkCategoriesConflicts = _v4.b;
		var _v5 = locationData.hereNetworkCategories;
		var hereNetworkCategories = _v5.a;
		var hereNetworkCategoriesConflicts = _v5.b;
		var _v6 = locationData.bingNetworkCategories;
		var bingNetworkCategories = _v6.a;
		var bingNetworkCategoriesConflicts = _v6.b;
		var splitPrimaryAdditional = function (maybeCategories) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				{primary: '', additional: _List_Nil},
				function (categories) {
					return {
						primary: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							'',
							function ($) {
								return $.name;
							},
							categories.primary),
						additional: A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							categories.additional)
					};
				},
				maybeCategories);
		};
		var _v7 = locationData.tomtomNetworkCategory;
		var tomtomCategory = _v7.a;
		var withSiteFallback = F2(
			function (location, site) {
				return (($elm$core$String$trim(location.primary) === '') && $elm$core$List$isEmpty(
					A2(
						$elm$core$List$filter,
						function (name) {
							return $elm$core$String$trim(name) !== '';
						},
						location.additional))) ? site : location;
			});
		var overtureCategories = A2(
			withSiteFallback,
			splitPrimaryAdditional(overtureNetworkCategories),
			splitPrimaryAdditional(siteCategories.overture));
		var googleCategories = A2(
			withSiteFallback,
			splitPrimaryAdditional(googleNetworkCategories),
			splitPrimaryAdditional(siteCategories.google));
		var appleCategories = A2(
			withSiteFallback,
			splitPrimaryAdditional(appleNetworkCategories),
			splitPrimaryAdditional(siteCategories.apple));
		var tomtomCategoryName = (A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function ($) {
				return $.name;
			},
			tomtomCategory) === '') ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function ($) {
				return $.name;
			},
			siteCategories.tomtom) : A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function ($) {
				return $.name;
			},
			tomtomCategory);
		var hereCategories = A2(
			withSiteFallback,
			splitPrimaryAdditional(hereNetworkCategories),
			splitPrimaryAdditional(siteCategories.here));
		var translations = session.translations;
		var fromNameList = function (names) {
			return {
				primary: A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(names)),
				additional: A2($elm$core$List$drop, 1, names)
			};
		};
		var bingCategories = fromNameList(
			A2(
				$author$project$Location$Details$View$getLocationCategoriesWithSiteFallback,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (bing) {
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							bing.categories);
					},
					bingNetworkCategories),
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (bing) {
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							bing.categories);
					},
					siteCategories.bing)));
		var tomtomCategories = fromNameList(
			(tomtomCategoryName === '') ? _List_Nil : _List_fromArray(
				[tomtomCategoryName]));
		var facebookCategories = fromNameList(
			A2(
				$author$project$Location$Details$View$getLocationCategoriesWithSiteFallback,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (categories) {
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							categories.subcategories);
					},
					facebookNetworkCategories),
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (categories) {
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							categories.subcategories);
					},
					siteCategories.facebook)));
		var foursquareCategories = fromNameList(
			A2(
				$author$project$Location$Details$View$getLocationCategoriesWithSiteFallback,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (foursquare) {
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							foursquare.categories);
					},
					foursquareNetworkCategories),
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (foursquare) {
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							foursquare.categories);
					},
					siteCategories.foursquare)));
		var emptyDash = function (string) {
			return ($elm$core$String$trim(string) === '') ? '-' : string;
		};
		var toField = function (categories) {
			return {
				primary: emptyDash(categories.primary),
				additional: emptyDash(
					A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$filter,
							function (name) {
								return $elm$core$String$trim(name) !== '';
							},
							categories.additional)))
			};
		};
		var categoryRow = F6(
			function (enabled, title, dataTest, status, categories, network) {
				return enabled ? _List_fromArray(
					[
						A3(
						$author$project$Listings$Ui$Row$withOpenLightBox,
						locationData.isActive,
						$author$project$Location$Details$Model$EditorOpen(
							A3($author$project$Location$Details$Editor$CategoriesEditor, network, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
						A2(
							$author$project$Listings$Ui$Row$withDataTestAttribute,
							dataTest,
							A2(
								$author$project$Listings$Ui$Row$withStatus,
								status,
								$author$project$Listings$Ui$Row$row(
									{
										label: $author$project$Listings$Ui$Label$label(
											{title: title, description: ''}),
										fieldType: $author$project$Listings$Ui$Row$CategoryPrimaryAdditional(
											toField(categories))
									}))))
					]) : _List_Nil;
			});
		var locale = session.locale;
		var rows = _Utils_ap(
			A6(
				categoryRow,
				_Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled),
				$author$project$Translations$General$Insights$google(translations),
				'googleSection.categoriesGoogle',
				googleNetworkCategoriesConflicts,
				googleCategories,
				$author$project$Data$Network$Google),
			_Utils_ap(
				A6(
					categoryRow,
					_Utils_eq(session.analytics.facebook, $author$project$PinMeToPage$NetworkEnabled),
					$author$project$Translations$General$Insights$facebook(translations),
					'facebookSection.categoriesFacebook',
					facebookNetworkCategoriesConflicts,
					facebookCategories,
					$author$project$Data$Network$Facebook),
				_Utils_ap(
					A6(
						categoryRow,
						_Utils_eq(session.analytics.apple, $author$project$PinMeToPage$NetworkEnabled),
						$author$project$Translations$General$Insights$apple(translations),
						'appleSection.categoriesApple',
						appleNetworkCategoriesConflicts,
						appleCategories,
						$author$project$Data$Network$Apple),
					_Utils_ap(
						A6(
							categoryRow,
							_Utils_eq(session.analytics.bing, $author$project$PinMeToPage$NetworkEnabled),
							$author$project$Translations$General$Insights$bing(translations),
							'bingSection.categoriesBing',
							bingNetworkCategoriesConflicts,
							bingCategories,
							$author$project$Data$Network$Bing),
						_Utils_ap(
							A6(
								categoryRow,
								_Utils_eq(session.analytics.foursquare, $author$project$PinMeToPage$NetworkEnabled),
								$author$project$Translations$General$Insights$foursquare(translations),
								'foursquareSection.categoriesFoursquare',
								foursquareNetworkCategoriesConflicts,
								foursquareCategories,
								$author$project$Data$Network$Foursquare),
							_Utils_ap(
								A6(
									categoryRow,
									_Utils_eq(session.analytics.overture, $author$project$PinMeToPage$NetworkEnabled),
									$author$project$Translations$General$Insights$overture(translations),
									'overtureSection.categoriesOverture',
									overtureNetworkCategoriesConflicts,
									overtureCategories,
									$author$project$Data$Network$Overture),
								_Utils_ap(
									A6(
										categoryRow,
										_Utils_eq(session.analytics.here, $author$project$PinMeToPage$NetworkEnabled),
										$author$project$Translations$General$Insights$here(translations),
										'hereSection.categoriesHere',
										hereNetworkCategoriesConflicts,
										hereCategories,
										$author$project$Data$Network$Here),
									A6(
										categoryRow,
										_Utils_eq(session.analytics.tomtom, $author$project$PinMeToPage$NetworkEnabled),
										$author$project$Translations$General$Insights$tomtom(translations),
										'tomtomSection.categoriesTomtom',
										$author$project$Listings$Ui$Row$NoConflict,
										tomtomCategories,
										$author$project$Data$Network$Tomtom))))))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$sectionCategories(translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Listings$Ui$Row$render, row, translations, locale)
											]));
								},
								rows))))
				]));
	});
var $author$project$Listings$Ui$Row$Paragraph = function (a) {
	return {$: 'Paragraph', a: a};
};
var $author$project$Location$Details$Editor$StoreIdEditor = {$: 'StoreIdEditor'};
var $author$project$Listings$Ui$Row$DateFromString = function (a) {
	return {$: 'DateFromString', a: a};
};
var $author$project$Listings$Ui$Row$StorefrontNames = F2(
	function (a, b) {
		return {$: 'StorefrontNames', a: a, b: b};
	});
var $author$project$Location$Details$Editor$OpeningDateEditor = {$: 'OpeningDateEditor'};
var $author$project$Translations$Listings$LocationDetail$descriptionStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_store_id');
};
var $author$project$Location$Details$Editor$StorefrontNameEditor = F2(
	function (a, b) {
		return {$: 'StorefrontNameEditor', a: a, b: b};
	});
var $author$project$Locations$List$Model$locationTypeToString = F2(
	function (locationType, translations) {
		switch (locationType.$) {
			case 'Storefront':
				return $author$project$Translations$General$storefront(translations);
			case 'StorefrontAndServiceArea':
				return $author$project$Translations$General$storefrontAndServiceArea(translations);
			default:
				return $author$project$Translations$General$serviceArea(translations);
		}
	});
var $author$project$Location$Details$Editor$LongDescriptionEditor = F2(
	function (a, b) {
		return {$: 'LongDescriptionEditor', a: a, b: b};
	});
var $author$project$Location$Details$Editor$ShortDescriptionEditor = F2(
	function (a, b) {
		return {$: 'ShortDescriptionEditor', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$descriptionOpeningDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_opening_date');
};
var $author$project$Translations$Listings$LocationDetail$descriptionLocationType = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_location_type');
};
var $author$project$Location$Details$Editor$LocationDescriptorEditor = {$: 'LocationDescriptorEditor'};
var $author$project$Translations$Listings$LocationDetail$descriptionStorefrontName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_storefront_name');
};
var $author$project$Translations$Listings$LocationDetail$descriptionLocationDescriptor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_location_descriptor');
};
var $author$project$Location$Details$View$generalDataSection = F5(
	function (session, locationData, features, showCSView, scheduleUpdates) {
		var shortDescriptionScheduleUpdates = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			A2(
				$elm$core$List$filter,
				function (scheduleUpdate) {
					var _v15 = scheduleUpdate.fieldAndData;
					if (_v15.$ === 'ShortDescriptionField') {
						return true;
					} else {
						return false;
					}
				},
				scheduleUpdates));
		var longDescriptionScheduleUpdates = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			A2(
				$elm$core$List$filter,
				function (scheduleUpdate) {
					var _v14 = scheduleUpdate.fieldAndData;
					if (_v14.$ === 'LongDescriptionField') {
						return true;
					} else {
						return false;
					}
				},
				scheduleUpdates));
		var _v0 = locationData.about;
		var shortDescription = _v0.a;
		var shortDescriptionConflict = _v0.b;
		var _v1 = locationData.longDescription;
		var longDescription = _v1.a;
		var longDescriptionConflict = _v1.b;
		var customNameNetworkEnabled = {
			ptv: _Utils_eq(session.analytics.ptv, $author$project$PinMeToPage$NetworkEnabled),
			apple: _Utils_eq(session.analytics.apple, $author$project$PinMeToPage$NetworkEnabled) && features.appleCustomName,
			google: _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled) && features.googleCustomName,
			facebook: _Utils_eq(session.analytics.facebook, $author$project$PinMeToPage$NetworkEnabled) && features.facebookCustomName
		};
		var _v2 = locationData.openingDate;
		var openingDate = _v2.a;
		var openingDateConflict = _v2.b;
		var _v3 = locationData.facebookCustomName;
		var facebookCustomName = _v3.a;
		var _v4 = locationData.locationDescriptor;
		var descriptor = _v4.a;
		var descriptorConflict = _v4.b;
		var hasCustomNameNetwork = A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			_List_fromArray(
				[customNameNetworkEnabled.google, customNameNetworkEnabled.facebook, customNameNetworkEnabled.apple, customNameNetworkEnabled.ptv]));
		var statusToEditStoreName = function () {
			var _v13 = locationData.isActive;
			if (_v13.$ === 'Active') {
				return (features.allowCustomStoreName || (showCSView || hasCustomNameNetwork)) ? $author$project$Data$Location$Active : $author$project$Data$Location$Inactive;
			} else {
				return $author$project$Data$Location$Inactive;
			}
		}();
		var _v5 = locationData.googleCustomName;
		var googleCustomName = _v5.a;
		var _v6 = locationData.storeId;
		var storeId = _v6.a;
		var storeIdConflict = _v6.b;
		var _v7 = locationData.appleCustomName;
		var appleCustomName = _v7.a;
		var _v8 = locationData.ptvCustomName;
		var ptvCustomName = _v8.a;
		var _v9 = locationData.locationType;
		var type_ = _v9.a;
		var typeConflict = _v9.b;
		var _v10 = locationData.name;
		var name = _v10.a;
		var nameConflict = _v10.b;
		var customNamesForView = A2(
			$elm$core$List$filterMap,
			function (network) {
				var _v12 = _Utils_Tuple2(network.enabled, network.customName);
				if (_v12.a && (_v12.b.$ === 'Just')) {
					var customName = _v12.b.a;
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(customName)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						{label: network.label, value: customName});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			_List_fromArray(
				[
					{
					label: $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontGoogleCustomNameLabel(session.translations),
					enabled: customNameNetworkEnabled.google,
					customName: googleCustomName
				},
					{
					label: $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontFacebookCustomNameLabel(session.translations),
					enabled: customNameNetworkEnabled.facebook,
					customName: facebookCustomName
				},
					{
					label: $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontAppleCustomNameLabel(session.translations),
					enabled: customNameNetworkEnabled.apple,
					customName: appleCustomName
				},
					{
					label: $author$project$Translations$Listings$LocationDetail$PopUpContent$storefrontPtvCustomNameLabel(session.translations),
					enabled: customNameNetworkEnabled.ptv,
					customName: ptvCustomName
				}
				]));
		var _v11 = locationData.facebookId;
		var locale = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
			$elm$core$Basics$identity,
			$elm$core$Maybe$Just(session.locale));
		var rows = _List_fromArray(
			[
				function (uiRowMsg) {
				return (A2($elm$core$List$member, $author$project$Data$User$CustomerSuccess, session.user.localAccess.roles) && (!session.user.isDemo)) ? A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$StoreIdEditor),
					uiRowMsg) : uiRowMsg;
			}(
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'generalDataSection.locationStoreId',
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						storeIdConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$General$locationStoreId(session.translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionStoreId(session.translations)
									}),
								fieldType: $author$project$Listings$Ui$Row$Paragraph(storeId)
							})))),
				A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$OpeningDateEditor),
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'generalDataSection.locationOpeningDate',
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						openingDateConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$General$locationOpeningDate(session.translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionOpeningDate(session.translations)
									}),
								fieldType: $author$project$Listings$Ui$Row$DateFromString(openingDate)
							})))),
				A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				statusToEditStoreName,
				$author$project$Location$Details$Model$EditorOpen(
					A2(
						$author$project$Location$Details$Editor$StorefrontNameEditor,
						$elm$core$Maybe$Nothing,
						{canEditName: features.allowCustomStoreName || showCSView, networkEnabled: customNameNetworkEnabled})),
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'generalDataSection.locationStorefrontName',
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						nameConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$General$locationStorefrontName(session.translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionStorefrontName(session.translations)
									}),
								fieldType: A2($author$project$Listings$Ui$Row$StorefrontNames, name, customNamesForView)
							})))),
				A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$LocationDescriptorEditor),
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'generalDataSection.locationDescriptor',
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						descriptorConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$General$locationDescriptor(session.translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionLocationDescriptor(session.translations)
									}),
								fieldType: $author$project$Listings$Ui$Row$Paragraph(descriptor)
							})))),
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'generalDataSection.locationType',
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$AddressEditor),
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						typeConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$General$locationType(session.translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionLocationType(session.translations)
									}),
								fieldType: $author$project$Listings$Ui$Row$Paragraph(
									A2($author$project$Locations$List$Model$locationTypeToString, type_, session.translations))
							})))),
				A2(
				$author$project$Listings$Ui$Row$withScheduleUpdates,
				A2($author$project$Location$Details$View$scheduleUpdatesView, session.locale, shortDescriptionScheduleUpdates),
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'generalDataSection.locationShortDescription',
					A3(
						$author$project$Listings$Ui$Row$withOpenLightBox,
						locationData.isActive,
						$author$project$Location$Details$Model$EditorOpen(
							A2($author$project$Location$Details$Editor$ShortDescriptionEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
						A2(
							$author$project$Listings$Ui$Row$withStatus,
							shortDescriptionConflict,
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationShortDescription(session.translations),
											description: ''
										}),
									fieldType: $author$project$Listings$Ui$Row$Paragraph(shortDescription)
								}))))),
				A2(
				$author$project$Listings$Ui$Row$withScheduleUpdates,
				A2($author$project$Location$Details$View$scheduleUpdatesView, session.locale, longDescriptionScheduleUpdates),
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen(
						A2($author$project$Location$Details$Editor$LongDescriptionEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
					A2(
						$author$project$Listings$Ui$Row$withDataTestAttribute,
						'generalDataSection.locationLongDescription',
						A2(
							$author$project$Listings$Ui$Row$withStatus,
							longDescriptionConflict,
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationLongDescription(session.translations),
											description: ''
										}),
									fieldType: $author$project$Listings$Ui$Row$Paragraph(
										($elm$core$String$length(longDescription) > 250) ? (A2($elm$core$String$left, 250, longDescription) + '...') : longDescription)
								})))))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$sectionGeneralData(session.translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Listings$Ui$Row$render, row, session.translations, locale)
											]));
								},
								rows))))
				]));
	});
var $author$project$Listings$Ui$Group$Group = function (a) {
	return {$: 'Group', a: a};
};
var $author$project$Listings$Ui$Group$Title = function (a) {
	return {$: 'Title', a: a};
};
var $author$project$Listings$Ui$Group$group = function (config) {
	return $author$project$Listings$Ui$Group$Group(
		{
			rows: config.rows,
			title: $author$project$Listings$Ui$Group$Title(config.title)
		});
};
var $author$project$Listings$Ui$Group$render = F3(
	function (_v0, translations, maybeLocale) {
		var config = _v0.a;
		var _v1 = config.title;
		var title = _v1.a;
		var locale = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, $elm$core$Basics$identity, maybeLocale);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__rows')
						]),
					A2(
						$elm$core$List$map,
						function (row) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A3($author$project$Listings$Ui$Row$render, row, translations, locale)
									]));
						},
						config.rows))
				]));
	});
var $author$project$Data$CustomDataDefinition$ObjectProperty = F2(
	function (a, b) {
		return {$: 'ObjectProperty', a: a, b: b};
	});
var $author$project$Location$Details$CustomFieldEditor$CustomListEditor = F2(
	function (a, b) {
		return {$: 'CustomListEditor', a: a, b: b};
	});
var $author$project$Location$Details$CustomFieldEditor$CustomObjectEditor = F3(
	function (a, b, c) {
		return {$: 'CustomObjectEditor', a: a, b: b, c: c};
	});
var $author$project$Location$Details$CustomFieldEditor$CustomStringEditor = F2(
	function (a, b) {
		return {$: 'CustomStringEditor', a: a, b: b};
	});
var $author$project$Location$Details$CustomFieldEditor$CustomBooleanEditor = F2(
	function (a, b) {
		return {$: 'CustomBooleanEditor', a: a, b: b};
	});
var $author$project$Location$Details$Model$CustomFieldEditorOpen = F2(
	function (a, b) {
		return {$: 'CustomFieldEditorOpen', a: a, b: b};
	});
var $author$project$Location$Details$CustomFieldEditor$CustomOpenHoursEditor = F2(
	function (a, b) {
		return {$: 'CustomOpenHoursEditor', a: a, b: b};
	});
var $author$project$Location$Details$CustomFieldEditor$CustomSpecialOpenHoursEditor = F2(
	function (a, b) {
		return {$: 'CustomSpecialOpenHoursEditor', a: a, b: b};
	});
var $author$project$Location$Details$View$getCustomDataRow = F6(
	function (locationData, _v0, fieldTypeValue, customDataProperty, objectPropertyDefinition, locale) {
		var type_ = _v0.a;
		var meta = _v0.b;
		var scheduleUpdates = _v0.c;
		var createRowWithUnsetData = function () {
			var elmPopUpRowUnsetData = F2(
				function (editor, dataProperty) {
					return A2(
						$author$project$Listings$Ui$Row$withScheduleUpdates,
						A2($author$project$Location$Details$View$scheduleUpdatesView, locale, scheduleUpdates),
						A3(
							$author$project$Listings$Ui$Row$withOpenLightBox,
							locationData.isActive,
							A2($author$project$Location$Details$Model$CustomFieldEditorOpen, editor, dataProperty),
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{title: meta.displayName, description: ''}),
									fieldType: fieldTypeValue
								})));
				});
			var emptyOpenHours = $author$project$Data$Location$OpenHours$During(
				{fri: $author$project$Data$Location$OpenHours$NotSpecified, mon: $author$project$Data$Location$OpenHours$NotSpecified, sat: $author$project$Data$Location$OpenHours$NotSpecified, sun: $author$project$Data$Location$OpenHours$NotSpecified, thu: $author$project$Data$Location$OpenHours$NotSpecified, tue: $author$project$Data$Location$OpenHours$NotSpecified, wed: $author$project$Data$Location$OpenHours$NotSpecified});
			var getConfig = function (customDataMeta) {
				return {meta: customDataMeta, type_: type_};
			};
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				A2(
					elmPopUpRowUnsetData,
					A2(
						$author$project$Location$Details$CustomFieldEditor$CustomStringEditor,
						'',
						getConfig(meta)),
					$author$project$Data$Location$CustomData$StringProperty(
						_Utils_Tuple2(
							'',
							{
								name: $author$project$Data$CustomDataDefinition$PropertyName('_'),
								rules: _List_Nil,
								displayName: '_'
							}))),
				function (propertyDefinition) {
					switch (propertyDefinition.$) {
						case 'OpenHoursProperty':
							var meta_ = propertyDefinition.a;
							return A2(
								elmPopUpRowUnsetData,
								A2(
									$author$project$Location$Details$CustomFieldEditor$CustomOpenHoursEditor,
									emptyOpenHours,
									getConfig(meta_)),
								$author$project$Data$Location$CustomData$OpenHoursProperty(
									_Utils_Tuple2(emptyOpenHours, meta_)));
						case 'SpecialOpenHoursProperty':
							var meta_ = propertyDefinition.a;
							return A2(
								elmPopUpRowUnsetData,
								A2(
									$author$project$Location$Details$CustomFieldEditor$CustomSpecialOpenHoursEditor,
									_List_Nil,
									getConfig(meta_)),
								$author$project$Data$Location$CustomData$SpecialOpenHoursProperty(
									_Utils_Tuple2(_List_Nil, meta_)));
						case 'BooleanProperty':
							var meta_ = propertyDefinition.a;
							return A2(
								elmPopUpRowUnsetData,
								A2(
									$author$project$Location$Details$CustomFieldEditor$CustomBooleanEditor,
									false,
									getConfig(meta_)),
								$author$project$Data$Location$CustomData$BooleanProperty(
									_Utils_Tuple2(false, meta_)));
						case 'StringProperty':
							var meta_ = propertyDefinition.a;
							return A2(
								elmPopUpRowUnsetData,
								A2(
									$author$project$Location$Details$CustomFieldEditor$CustomStringEditor,
									'',
									getConfig(meta_)),
								$author$project$Data$Location$CustomData$StringProperty(
									_Utils_Tuple2('', meta_)));
						case 'ListProperty':
							var meta_ = propertyDefinition.a;
							return A2(
								elmPopUpRowUnsetData,
								A2(
									$author$project$Location$Details$CustomFieldEditor$CustomListEditor,
									_List_Nil,
									getConfig(meta_)),
								$author$project$Data$Location$CustomData$ListProperty(
									_Utils_Tuple2(_List_Nil, meta_)));
						default:
							var meta_ = propertyDefinition.a;
							var customDataDefinition_ = propertyDefinition.b;
							var prop = A2($author$project$Data$CustomDataDefinition$ObjectProperty, meta_, customDataDefinition_);
							return A2(
								elmPopUpRowUnsetData,
								A3(
									$author$project$Location$Details$CustomFieldEditor$CustomObjectEditor,
									_List_Nil,
									getConfig(meta_),
									prop),
								$author$project$Data$Location$CustomData$ObjectProperty(
									_Utils_Tuple2(_List_Nil, meta_)));
					}
				},
				objectPropertyDefinition);
		}();
		var createRowWithData = function (dataProperty) {
			var elmPopUpRow = function (editor) {
				return A2(
					$author$project$Listings$Ui$Row$withScheduleUpdates,
					A2($author$project$Location$Details$View$scheduleUpdatesView, locale, scheduleUpdates),
					A3(
						$author$project$Listings$Ui$Row$withOpenLightBox,
						locationData.isActive,
						A2($author$project$Location$Details$Model$CustomFieldEditorOpen, editor, dataProperty),
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: meta.displayName, description: ''}),
								fieldType: fieldTypeValue
							})));
			};
			switch (dataProperty.$) {
				case 'OpenHoursProperty':
					var _v2 = dataProperty.a;
					var openHours = _v2.a;
					return elmPopUpRow(
						A2(
							$author$project$Location$Details$CustomFieldEditor$CustomOpenHoursEditor,
							openHours,
							{meta: meta, type_: type_}));
				case 'SpecialOpenHoursProperty':
					var _v3 = dataProperty.a;
					var specialOpenHours = _v3.a;
					return elmPopUpRow(
						A2(
							$author$project$Location$Details$CustomFieldEditor$CustomSpecialOpenHoursEditor,
							specialOpenHours,
							{meta: meta, type_: type_}));
				case 'BooleanProperty':
					var _v4 = dataProperty.a;
					var value = _v4.a;
					return elmPopUpRow(
						A2(
							$author$project$Location$Details$CustomFieldEditor$CustomBooleanEditor,
							value,
							{meta: meta, type_: type_}));
				case 'StringProperty':
					var _v5 = dataProperty.a;
					var value = _v5.a;
					return elmPopUpRow(
						A2(
							$author$project$Location$Details$CustomFieldEditor$CustomStringEditor,
							value,
							{meta: meta, type_: type_}));
				case 'ListProperty':
					var _v6 = dataProperty.a;
					var value = _v6.a;
					return elmPopUpRow(
						A2(
							$author$project$Location$Details$CustomFieldEditor$CustomListEditor,
							value,
							{meta: meta, type_: type_}));
				default:
					var _v7 = dataProperty.a;
					var value = _v7.a;
					var meta_ = _v7.b;
					var customDataObjectProperty = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2(
							$author$project$Data$CustomDataDefinition$ObjectProperty,
							meta_,
							$author$project$Data$CustomDataDefinition$CustomDataDefinition(_List_Nil)),
						$elm$core$Basics$identity,
						objectPropertyDefinition);
					return elmPopUpRow(
						A3(
							$author$project$Location$Details$CustomFieldEditor$CustomObjectEditor,
							value,
							{meta: meta, type_: type_},
							customDataObjectProperty));
			}
		};
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			createRowWithUnsetData,
			function (dataProperty) {
				return createRowWithData(dataProperty);
			},
			customDataProperty);
	});
var $author$project$Location$Details$View$getStringFromBool = F2(
	function (boolValue, translations) {
		return boolValue ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations);
	});
var $author$project$Listings$Ui$Row$ObjectParagraph = function (a) {
	return {$: 'ObjectParagraph', a: a};
};
var $author$project$Listings$Ui$Row$ObjectInnerOpenHours = F2(
	function (a, b) {
		return {$: 'ObjectInnerOpenHours', a: a, b: b};
	});
var $author$project$Listings$Ui$Row$ObjectInnerParagraph = function (a) {
	return {$: 'ObjectInnerParagraph', a: a};
};
var $author$project$Listings$Ui$Row$ObjectInnerSpecialOpenHours = F3(
	function (a, b, c) {
		return {$: 'ObjectInnerSpecialOpenHours', a: a, b: b, c: c};
	});
var $author$project$Location$Details$View$objectPropertyToFieldType = F4(
	function (fieldDisplayName, properties, translations, today) {
		return $author$project$Listings$Ui$Row$ObjectParagraph(
			_Utils_Tuple2(
				fieldDisplayName,
				A2(
					$elm$core$List$map,
					function (value) {
						switch (value.$) {
							case 'ObjectProperty':
								var _v1 = value.a;
								var vals = _v1.a;
								var meta = _v1.b;
								return A4($author$project$Location$Details$View$objectPropertyToFieldType, meta.displayName, vals, translations, today);
							case 'StringProperty':
								var _v2 = value.a;
								var val = _v2.a;
								var meta = _v2.b;
								return $author$project$Listings$Ui$Row$ObjectInnerParagraph(meta.displayName + (': ' + val));
							case 'BooleanProperty':
								var _v3 = value.a;
								var val = _v3.a;
								var meta = _v3.b;
								return $author$project$Listings$Ui$Row$ObjectInnerParagraph(
									meta.displayName + (': ' + A2($author$project$Location$Details$View$getStringFromBool, val, translations)));
							case 'ListProperty':
								var _v4 = value.a;
								var valuesList = _v4.a;
								var meta = _v4.b;
								return $author$project$Listings$Ui$Row$ObjectInnerParagraph(
									meta.displayName + (': ' + ($elm$core$List$isEmpty(valuesList) ? '' : A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function (text) {
												if (text.$ === 'StringProperty') {
													var _v6 = text.a;
													var str = _v6.a;
													return str;
												} else {
													return '';
												}
											},
											valuesList)))));
							case 'OpenHoursProperty':
								var _v7 = value.a;
								var val = _v7.a;
								var meta = _v7.b;
								return A2($author$project$Listings$Ui$Row$ObjectInnerOpenHours, meta.displayName, val);
							default:
								var _v8 = value.a;
								var val = _v8.a;
								var meta = _v8.b;
								return A3($author$project$Listings$Ui$Row$ObjectInnerSpecialOpenHours, meta.displayName, val, today);
						}
					},
					properties)));
	});
var $author$project$Location$Details$View$listPropertyToFieldType = F3(
	function (properties, translations, today) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Listings$Ui$Row$Paragraph(''),
			function (property) {
				switch (property.$) {
					case 'StringProperty':
						var _v1 = property.a;
						return $author$project$Listings$Ui$Row$Paragraph(
							A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									function (value) {
										if (value.$ === 'StringProperty') {
											var _v3 = value.a;
											var str = _v3.a;
											return str;
										} else {
											return '';
										}
									},
									properties)));
					case 'BooleanProperty':
						var _v4 = property.a;
						var value = _v4.a;
						return $author$project$Listings$Ui$Row$Paragraph(
							A2($author$project$Location$Details$View$getStringFromBool, value, translations));
					case 'ObjectProperty':
						var _v5 = property.a;
						var value = _v5.a;
						return A4($author$project$Location$Details$View$objectPropertyToFieldType, '', value, translations, today);
					default:
						return $author$project$Listings$Ui$Row$Paragraph('');
				}
			},
			$elm$core$List$head(properties));
	});
var $author$project$Location$Details$View$customFieldsSection = F7(
	function (locationData, maybeCustomData, _v0, today, scheduleUpdates, translations, locale) {
		var properties = _v0.a;
		return ($elm$core$List$length(properties) > 0) ? A2(
			$author$project$Listings$Ui$Group$render(
				$author$project$Listings$Ui$Group$group(
					{
						rows: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							A2(
								$elm$core$List$map,
								function (row) {
									switch (row.$) {
										case 'BooleanProperty':
											var meta = row.a;
											var _v2 = meta.name;
											var customName = _v2.a;
											var fieldScheduleUpdates = A2(
												$elm$core$List$sortBy,
												function (scheduleUpdate) {
													return $elm$time$Time$posixToMillis(scheduleUpdate.date);
												},
												A2(
													$elm$core$List$filter,
													function (scheduleUpdate) {
														var _v3 = scheduleUpdate.fieldAndData;
														if (_v3.$ === 'CustomDataBoolField') {
															var customName_ = _v3.a;
															return _Utils_eq(customName, customName_);
														} else {
															return false;
														}
													},
													scheduleUpdates));
											return A6(
												$author$project$Location$Details$View$getCustomDataRow,
												locationData,
												_Utils_Tuple3('boolean', meta, fieldScheduleUpdates),
												$author$project$Listings$Ui$Row$Paragraph(''),
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(row),
												locale);
										case 'StringProperty':
											var meta = row.a;
											var _v4 = meta.name;
											var customName = _v4.a;
											var fieldScheduleUpdates = A2(
												$elm$core$List$sortBy,
												function (scheduleUpdate) {
													return $elm$time$Time$posixToMillis(scheduleUpdate.date);
												},
												A2(
													$elm$core$List$filter,
													function (scheduleUpdate) {
														var _v5 = scheduleUpdate.fieldAndData;
														if (_v5.$ === 'CustomDataStringField') {
															var customName_ = _v5.a;
															return _Utils_eq(customName, customName_);
														} else {
															return false;
														}
													},
													scheduleUpdates));
											return A6(
												$author$project$Location$Details$View$getCustomDataRow,
												locationData,
												_Utils_Tuple3('string', meta, fieldScheduleUpdates),
												$author$project$Listings$Ui$Row$Paragraph(''),
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(row),
												locale);
										case 'ListProperty':
											var meta = row.a;
											var _v6 = meta.name;
											var customName = _v6.a;
											var fieldScheduleUpdates = A2(
												$elm$core$List$sortBy,
												function (scheduleUpdate) {
													return $elm$time$Time$posixToMillis(scheduleUpdate.date);
												},
												A2(
													$elm$core$List$filter,
													function (scheduleUpdate) {
														var _v7 = scheduleUpdate.fieldAndData;
														if (_v7.$ === 'CustomDataListField') {
															var customName_ = _v7.a;
															return _Utils_eq(customName, customName_);
														} else {
															return false;
														}
													},
													scheduleUpdates));
											return A6(
												$author$project$Location$Details$View$getCustomDataRow,
												locationData,
												_Utils_Tuple3('list', meta, fieldScheduleUpdates),
												$author$project$Listings$Ui$Row$Paragraph(''),
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(row),
												locale);
										case 'ObjectProperty':
											var meta = row.a;
											var _v8 = meta.name;
											var customName = _v8.a;
											var fieldScheduleUpdates = A2(
												$elm$core$List$sortBy,
												function (scheduleUpdate) {
													return $elm$time$Time$posixToMillis(scheduleUpdate.date);
												},
												A2(
													$elm$core$List$filter,
													function (scheduleUpdate) {
														var _v9 = scheduleUpdate.fieldAndData;
														if (_v9.$ === 'CustomDataObjectField') {
															var customName_ = _v9.a;
															return _Utils_eq(customName, customName_);
														} else {
															return false;
														}
													},
													scheduleUpdates));
											return A6(
												$author$project$Location$Details$View$getCustomDataRow,
												locationData,
												_Utils_Tuple3('object', meta, fieldScheduleUpdates),
												$author$project$Listings$Ui$Row$Paragraph(''),
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(row),
												locale);
										case 'SpecialOpenHoursProperty':
											var meta = row.a;
											return A6(
												$author$project$Location$Details$View$getCustomDataRow,
												locationData,
												_Utils_Tuple3('specialHours', meta, _List_Nil),
												A2($author$project$Listings$Ui$Row$SpecialOpenHours, _List_Nil, today),
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(row),
												locale);
										default:
											var meta = row.a;
											var _v10 = meta.name;
											var customName = _v10.a;
											var fieldScheduleUpdates = A2(
												$elm$core$List$sortBy,
												function (scheduleUpdate) {
													return $elm$time$Time$posixToMillis(scheduleUpdate.date);
												},
												A2(
													$elm$core$List$filter,
													function (scheduleUpdate) {
														var _v11 = scheduleUpdate.fieldAndData;
														if (_v11.$ === 'CustomDataOpenHoursField') {
															var customName_ = _v11.a;
															return _Utils_eq(customName, customName_);
														} else {
															return false;
														}
													},
													scheduleUpdates));
											return A6(
												$author$project$Location$Details$View$getCustomDataRow,
												locationData,
												_Utils_Tuple3('hours', meta, fieldScheduleUpdates),
												$author$project$Listings$Ui$Row$OpenHours(
													$author$project$Data$Location$OpenHours$During(
														{fri: $author$project$Data$Location$OpenHours$NotSpecified, mon: $author$project$Data$Location$OpenHours$NotSpecified, sat: $author$project$Data$Location$OpenHours$NotSpecified, sun: $author$project$Data$Location$OpenHours$NotSpecified, thu: $author$project$Data$Location$OpenHours$NotSpecified, tue: $author$project$Data$Location$OpenHours$NotSpecified, wed: $author$project$Data$Location$OpenHours$NotSpecified})),
												$elm$core$Maybe$Nothing,
												$elm$core$Maybe$Just(row),
												locale);
									}
								},
								properties),
							function (_v12) {
								var customData = _v12.a;
								var getCustomDataDefinition = function (objectMeta) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										A2(
											$author$project$Data$CustomDataDefinition$ObjectProperty,
											objectMeta,
											$author$project$Data$CustomDataDefinition$CustomDataDefinition(_List_Nil)),
										$elm$core$Basics$identity,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (propertyDefinition) {
													if (propertyDefinition.$ === 'ObjectProperty') {
														var innerMeta = propertyDefinition.a;
														return _Utils_eq(innerMeta.name, objectMeta.name) ? true : false;
													} else {
														return false;
													}
												},
												properties)));
								};
								return A2(
									$elm$core$List$map,
									function (row) {
										switch (row.$) {
											case 'BooleanProperty':
												var _v14 = row.a;
												var value = _v14.a;
												var meta = _v14.b;
												var _v15 = meta.name;
												var customName = _v15.a;
												var fieldScheduleUpdates = A2(
													$elm$core$List$sortBy,
													function (scheduleUpdate) {
														return $elm$time$Time$posixToMillis(scheduleUpdate.date);
													},
													A2(
														$elm$core$List$filter,
														function (scheduleUpdate) {
															var _v16 = scheduleUpdate.fieldAndData;
															if (_v16.$ === 'CustomDataBoolField') {
																var customName_ = _v16.a;
																return _Utils_eq(customName, customName_);
															} else {
																return false;
															}
														},
														scheduleUpdates));
												return A6(
													$author$project$Location$Details$View$getCustomDataRow,
													locationData,
													_Utils_Tuple3('boolean', meta, fieldScheduleUpdates),
													$author$project$Listings$Ui$Row$Paragraph(
														A2($author$project$Location$Details$View$getStringFromBool, value, translations)),
													$elm$core$Maybe$Just(row),
													$elm$core$Maybe$Nothing,
													locale);
											case 'StringProperty':
												var _v17 = row.a;
												var value = _v17.a;
												var meta = _v17.b;
												var _v18 = meta.name;
												var customName = _v18.a;
												var fieldScheduleUpdates = A2(
													$elm$core$List$sortBy,
													function (scheduleUpdate) {
														return $elm$time$Time$posixToMillis(scheduleUpdate.date);
													},
													A2(
														$elm$core$List$filter,
														function (scheduleUpdate) {
															var _v19 = scheduleUpdate.fieldAndData;
															if (_v19.$ === 'CustomDataStringField') {
																var customName_ = _v19.a;
																return _Utils_eq(customName, customName_);
															} else {
																return false;
															}
														},
														scheduleUpdates));
												return A6(
													$author$project$Location$Details$View$getCustomDataRow,
													locationData,
													_Utils_Tuple3('string', meta, fieldScheduleUpdates),
													$author$project$Listings$Ui$Row$Paragraph(value),
													$elm$core$Maybe$Just(row),
													$elm$core$Maybe$Nothing,
													locale);
											case 'ListProperty':
												var _v20 = row.a;
												var values = _v20.a;
												var meta = _v20.b;
												var _v21 = meta.name;
												var customName = _v21.a;
												var fieldScheduleUpdates = A2(
													$elm$core$List$sortBy,
													function (scheduleUpdate) {
														return $elm$time$Time$posixToMillis(scheduleUpdate.date);
													},
													A2(
														$elm$core$List$filter,
														function (scheduleUpdate) {
															var _v22 = scheduleUpdate.fieldAndData;
															if (_v22.$ === 'CustomDataListField') {
																var customName_ = _v22.a;
																return _Utils_eq(customName, customName_);
															} else {
																return false;
															}
														},
														scheduleUpdates));
												return A6(
													$author$project$Location$Details$View$getCustomDataRow,
													locationData,
													_Utils_Tuple3('list', meta, fieldScheduleUpdates),
													A3($author$project$Location$Details$View$listPropertyToFieldType, values, translations, today),
													$elm$core$Maybe$Just(row),
													$elm$core$Maybe$Nothing,
													locale);
											case 'SpecialOpenHoursProperty':
												var _v23 = row.a;
												var specialOpenHours = _v23.a;
												var meta = _v23.b;
												return A6(
													$author$project$Location$Details$View$getCustomDataRow,
													locationData,
													_Utils_Tuple3('specialHours', meta, _List_Nil),
													A2($author$project$Listings$Ui$Row$SpecialOpenHours, specialOpenHours, today),
													$elm$core$Maybe$Just(row),
													$elm$core$Maybe$Nothing,
													locale);
											case 'OpenHoursProperty':
												var _v24 = row.a;
												var openHours = _v24.a;
												var meta = _v24.b;
												var _v25 = meta.name;
												var customName = _v25.a;
												var fieldScheduleUpdates = A2(
													$elm$core$List$sortBy,
													function (scheduleUpdate) {
														return $elm$time$Time$posixToMillis(scheduleUpdate.date);
													},
													A2(
														$elm$core$List$filter,
														function (scheduleUpdate) {
															var _v26 = scheduleUpdate.fieldAndData;
															if (_v26.$ === 'CustomDataOpenHoursField') {
																var customName_ = _v26.a;
																return _Utils_eq(customName, customName_);
															} else {
																return false;
															}
														},
														scheduleUpdates));
												return A6(
													$author$project$Location$Details$View$getCustomDataRow,
													locationData,
													_Utils_Tuple3('hours', meta, fieldScheduleUpdates),
													$author$project$Listings$Ui$Row$OpenHours(openHours),
													$elm$core$Maybe$Just(row),
													$elm$core$Maybe$Nothing,
													locale);
											default:
												var _v27 = row.a;
												var values = _v27.a;
												var meta = _v27.b;
												var currentObject = getCustomDataDefinition(meta);
												var _v28 = meta.name;
												var customName = _v28.a;
												var fieldScheduleUpdates = A2(
													$elm$core$List$sortBy,
													function (scheduleUpdate) {
														return $elm$time$Time$posixToMillis(scheduleUpdate.date);
													},
													A2(
														$elm$core$List$filter,
														function (scheduleUpdate) {
															var _v29 = scheduleUpdate.fieldAndData;
															if (_v29.$ === 'CustomDataObjectField') {
																var customName_ = _v29.a;
																return _Utils_eq(customName, customName_);
															} else {
																return false;
															}
														},
														scheduleUpdates));
												return A6(
													$author$project$Location$Details$View$getCustomDataRow,
													locationData,
													_Utils_Tuple3('object', meta, fieldScheduleUpdates),
													A4($author$project$Location$Details$View$objectPropertyToFieldType, '', values, translations, today),
													$elm$core$Maybe$Just(row),
													$elm$core$Maybe$Just(currentObject),
													locale);
										}
									},
									customData);
							},
							maybeCustomData),
						title: $author$project$Translations$Listings$LocationDetail$customFields(translations)
					})),
			translations,
			$elm$core$Maybe$Just(locale)) : $elm$html$Html$text('');
	});
var $author$project$Translations$Listings$LocationDetail$plusAmount = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.location_detail.plus_amount',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $author$project$Listings$Ui$Row$MultiParagraph = function (a) {
	return {$: 'MultiParagraph', a: a};
};
var $author$project$Translations$Listings$LocationDetail$descriptionServiceAreas = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_service_areas');
};
var $author$project$Location$Details$View$serviceAreasSection = F3(
	function (locationData, translations, locale) {
		var _v0 = locationData.serviceAreas;
		var sa = _v0.a;
		var serviceAreasConflict = _v0.b;
		var serviceAreaToString = function (serviceArea) {
			switch (serviceArea.$) {
				case 'WithPlaceId':
					var serviceAreas = serviceArea.a;
					var longName = function (area) {
						return area.longName;
					};
					var unwrapServiceArea = F2(
						function (area, str) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								str,
								function (x) {
									return (str === '') ? longName(x) : (str + (', ' + longName(x)));
								},
								area);
						});
					var unwrappedServiceAreas = A2(
						$elm$core$List$map,
						function (area) {
							return A2(
								unwrapServiceArea,
								$elm$core$Maybe$Just(area.country),
								A2(
									unwrapServiceArea,
									area.state,
									A2(
										unwrapServiceArea,
										area.region,
										A2(
											unwrapServiceArea,
											area.city,
											A2(unwrapServiceArea, area.zip, '')))));
						},
						A2($elm$core$List$take, 5, serviceAreas));
					var serviceAreaStringList = ($elm$core$List$length(serviceAreas) > 5) ? A2(
						$elm$core$List$append,
						unwrappedServiceAreas,
						_List_fromArray(
							[
								A2(
								$author$project$Translations$Listings$LocationDetail$plusAmount,
								translations,
								$elm$core$String$fromInt(
									$elm$core$List$length(serviceAreas) - 5))
							])) : unwrappedServiceAreas;
					return serviceAreaStringList;
				case 'Text':
					var list = serviceArea.a;
					return list;
				default:
					return _List_fromArray(
						['']);
			}
		};
		return A2(
			$author$project$Listings$Ui$Group$render(
				$author$project$Listings$Ui$Group$group(
					{
						rows: _List_fromArray(
							[
								A2(
								$author$project$Listings$Ui$Row$withDataTestAttribute,
								'serviceAreasSection.serviceArea',
								A3(
									$author$project$Listings$Ui$Row$withOpenLightBox,
									locationData.isActive,
									$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$AddressEditor),
									A2(
										$author$project$Listings$Ui$Row$withStatus,
										serviceAreasConflict,
										$author$project$Listings$Ui$Row$row(
											{
												label: $author$project$Listings$Ui$Label$label(
													{
														title: $author$project$Translations$General$serviceArea(translations),
														description: $author$project$Translations$Listings$LocationDetail$descriptionServiceAreas(translations)
													}),
												fieldType: $author$project$Listings$Ui$Row$MultiParagraph(
													serviceAreaToString(sa))
											}))))
							]),
						title: $author$project$Translations$General$serviceAreas(translations)
					})),
			translations,
			locale);
	});
var $author$project$Listings$Ui$Row$withCopy = F2(
	function (msg, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{
					copyMsg: $elm$core$Maybe$Just(msg)
				}));
	});
var $author$project$Listings$Ui$Row$ActionLinks = function (a) {
	return {$: 'ActionLinks', a: a};
};
var $author$project$Location$Details$Editor$EmailEditor = F2(
	function (a, b) {
		return {$: 'EmailEditor', a: a, b: b};
	});
var $author$project$Location$Details$Editor$PhoneEditor = F2(
	function (a, b) {
		return {$: 'PhoneEditor', a: a, b: b};
	});
var $author$project$Location$Details$Model$CopyToBuffer = function (a) {
	return {$: 'CopyToBuffer', a: a};
};
var $author$project$Listings$Ui$Row$FailedToFetch = function (a) {
	return {$: 'FailedToFetch', a: a};
};
var $author$project$Listings$Ui$Row$NewReviewLink = function (a) {
	return {$: 'NewReviewLink', a: a};
};
var $author$project$Location$Details$View$getAttributes = F2(
	function (attributes, googleAttributes) {
		var rawAttributes = A2(
			$elm$core$List$map,
			function (attribute) {
				var element = A2(
					$elm_community$list_extra$List$Extra$find,
					function (a) {
						return _Utils_eq(a.attributeId, attribute.attributeId);
					},
					googleAttributes.attributes);
				var getString = function (func) {
					return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', func, element);
				};
				var getValueDisplayNames = function (values) {
					return A2(
						$elm$core$List$map,
						function (value) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								'',
								function (item) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										'',
										function (attribute_) {
											return attribute_.displayName;
										},
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (googleValue) {
												return _Utils_eq(googleValue.value, value);
											},
											item.valueMetaData));
								},
								element);
						},
						values);
				};
				var _v0 = attribute.valueType;
				switch (_v0) {
					case 'ENUM':
						return {
							name: getString(
								function (x) {
									return x.displayName;
								}),
							type_: getString(
								function (x) {
									return x.valueType;
								}),
							values: getValueDisplayNames(attribute.values),
							unsetValue: _List_Nil
						};
					case 'REPEATED_ENUM':
						return {
							name: getString(
								function (x) {
									return x.displayName;
								}),
							type_: getString(
								function (x) {
									return x.valueType;
								}),
							values: A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								_List_Nil,
								function (x) {
									return getValueDisplayNames(x.setValues);
								},
								attribute.repeatedEnumValue),
							unsetValue: A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								_List_Nil,
								function (x) {
									return getValueDisplayNames(x.unsetValues);
								},
								attribute.repeatedEnumValue)
						};
					default:
						return {
							name: getString(
								function (x) {
									return x.displayName;
								}),
							type_: getString(
								function (x) {
									return x.valueType;
								}),
							values: attribute.values,
							unsetValue: _List_Nil
						};
				}
			},
			attributes);
		return A2(
			$elm$core$List$filter,
			function (attribute) {
				return attribute.name !== '';
			},
			rawAttributes);
	});
var $author$project$Location$Details$Editor$HomepageEditor = F2(
	function (a, b) {
		return {$: 'HomepageEditor', a: a, b: b};
	});
var $author$project$Location$Details$Model$OpenGoogleQRCode = {$: 'OpenGoogleQRCode'};
var $author$project$Translations$Listings$LocationDetail$googleReviewLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.google_review_link');
};
var $author$project$Location$Details$Editor$ActionLinksEditor = {$: 'ActionLinksEditor'};
var $author$project$Listings$Ui$Row$withOpenQRCodeMsg = F2(
	function (msg, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$Row$Row(
			_Utils_update(
				config,
				{
					openQRCodeMsg: $elm$core$Maybe$Just(msg)
				}));
	});
var $author$project$Listings$Ui$Row$GoogleUrlAttributes = function (a) {
	return {$: 'GoogleUrlAttributes', a: a};
};
var $author$project$Translations$Listings$LocationDetail$descriptionHomepage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_homepage');
};
var $author$project$Location$Details$Editor$SocialMessagingEditor = F3(
	function (a, b, c) {
		return {$: 'SocialMessagingEditor', a: a, b: b, c: c};
	});
var $author$project$Translations$Listings$LocationDetail$fetchGoogleAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.fetch_google_attributes');
};
var $author$project$Translations$Listings$LocationDetail$googleReviewLinkDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.google_review_link_description');
};
var $author$project$Translations$Listings$LocationDetail$descriptionGoogleActionLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_google_action_links');
};
var $author$project$Location$Details$View$contactAndLinksSection = F6(
	function (locationData, scheduleUpdates, googleEnabled, googleAttributes, translations, locale) {
		var _v0 = locationData.googleNetworkActionLinks;
		var networkActionLinks = _v0.a;
		var networkActionLinksConflicts = _v0.b;
		var _v1 = locationData.networkAttributes;
		var networkAttributes = _v1.a;
		var networkAttributesConflicts = _v1.b;
		var homepageScheduleUpdates = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			A2(
				$elm$core$List$filter,
				function (scheduleUpdate) {
					var _v11 = scheduleUpdate.fieldAndData;
					if (_v11.$ === 'HomepageField') {
						return true;
					} else {
						return false;
					}
				},
				scheduleUpdates));
		var _v2 = locationData.newGoogleReviewLink;
		var newGoogleReviewLink = _v2.a;
		var phoneScheduleUpdates = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			A2(
				$elm$core$List$filter,
				function (scheduleUpdate) {
					var _v10 = scheduleUpdate.fieldAndData;
					if (_v10.$ === 'PhoneField') {
						return true;
					} else {
						return false;
					}
				},
				scheduleUpdates));
		var emailScheduleUpdates = A2(
			$elm$core$List$sortBy,
			function (scheduleUpdate) {
				return $elm$time$Time$posixToMillis(scheduleUpdate.date);
			},
			A2(
				$elm$core$List$filter,
				function (scheduleUpdate) {
					var _v9 = scheduleUpdate.fieldAndData;
					if (_v9.$ === 'EmailField') {
						return true;
					} else {
						return false;
					}
				},
				scheduleUpdates));
		var _v3 = locationData.homepage;
		var homepage = _v3.a;
		var homepageConflict = _v3.b;
		var actionLinksFieldType = (!$elm$core$List$length(networkActionLinks)) ? $author$project$Listings$Ui$Row$Paragraph('') : $author$project$Listings$Ui$Row$ActionLinks(networkActionLinks);
		var socialAndMessagingFieldType = function () {
			var _v8 = A2(
				$author$project$RemoteData$map,
				$author$project$Location$Details$View$getAttributes(networkAttributes.google),
				googleAttributes);
			switch (_v8.$) {
				case 'Loaded':
					var attributesList = _v8.a;
					return $author$project$Listings$Ui$Row$GoogleUrlAttributes(attributesList);
				case 'Error':
					return $author$project$Listings$Ui$Row$FailedToFetch(
						$author$project$Translations$Listings$LocationDetail$fetchGoogleAttributes(translations));
				default:
					return $author$project$Listings$Ui$Row$Paragraph('');
			}
		}();
		var _v4 = locationData.phone;
		var phone = _v4.a;
		var phoneConflict = _v4.b;
		var _v5 = locationData.email;
		var email = _v5.a;
		var emailConflict = _v5.b;
		var actionLinksRows = _List_fromArray(
			[
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'googleSection.locationActionLinks',
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$ActionLinksEditor),
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						networkActionLinksConflicts,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$General$locationActionLinks(translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionGoogleActionLinks(translations)
									}),
								fieldType: actionLinksFieldType
							}))))
			]);
		var googleLinkRows = _List_fromArray(
			[
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'googleSection.locationUrlAttributes',
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					function () {
						var _v7 = $author$project$RemoteData$currentData(googleAttributes);
						if (_v7.$ === 'Just') {
							var ga = _v7.a;
							return $author$project$Location$Details$Model$EditorOpen(
								A3($author$project$Location$Details$Editor$SocialMessagingEditor, ga.attributes, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
						} else {
							return $author$project$Location$Details$Model$EditorOpen(
								A3($author$project$Location$Details$Editor$SocialMessagingEditor, _List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
						}
					}(),
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						networkAttributesConflicts,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$Listings$LocationDetail$googleUrlAttributes(translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionGoogleUrlAttributes(translations)
									}),
								fieldType: socialAndMessagingFieldType
							})))),
				A2(
				$author$project$Listings$Ui$Row$withOpenQRCodeMsg,
				$author$project$Location$Details$Model$OpenGoogleQRCode,
				A2(
					$author$project$Listings$Ui$Row$withCopy,
					$author$project$Location$Details$Model$CopyToBuffer(newGoogleReviewLink),
					A2(
						$author$project$Listings$Ui$Row$withDataTestAttribute,
						'googleSection.googleReviewLink',
						A2(
							$author$project$Listings$Ui$Row$withStatus,
							$author$project$Listings$Ui$Row$NoConflict,
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$Listings$LocationDetail$googleReviewLink(translations),
											description: $author$project$Translations$Listings$LocationDetail$googleReviewLinkDescription(translations)
										}),
									fieldType: $author$project$Listings$Ui$Row$NewReviewLink(locationData.newGoogleReviewLink)
								})))))
			]);
		var contactRows = _List_fromArray(
			[
				A2(
				$author$project$Listings$Ui$Row$withScheduleUpdates,
				A2($author$project$Location$Details$View$scheduleUpdatesView, locale, phoneScheduleUpdates),
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen(
						A2($author$project$Location$Details$Editor$PhoneEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
					A2(
						$author$project$Listings$Ui$Row$withDataTestAttribute,
						'contactInformationSection.locationPhone',
						A2(
							$author$project$Listings$Ui$Row$withStatus,
							phoneConflict,
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationPhone(translations),
											description: ''
										}),
									fieldType: $author$project$Listings$Ui$Row$Paragraph(phone)
								}))))),
				A2(
				$author$project$Listings$Ui$Row$withScheduleUpdates,
				A2($author$project$Location$Details$View$scheduleUpdatesView, locale, emailScheduleUpdates),
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen(
						A2($author$project$Location$Details$Editor$EmailEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
					A2(
						$author$project$Listings$Ui$Row$withDataTestAttribute,
						'contactInformationSection.locationEmail',
						A2(
							$author$project$Listings$Ui$Row$withStatus,
							emailConflict,
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationEmail(translations),
											description: ''
										}),
									fieldType: $author$project$Listings$Ui$Row$Paragraph(email)
								}))))),
				A2(
				$author$project$Listings$Ui$Row$withScheduleUpdates,
				A2($author$project$Location$Details$View$scheduleUpdatesView, locale, homepageScheduleUpdates),
				A3(
					$author$project$Listings$Ui$Row$withOpenLightBox,
					locationData.isActive,
					$author$project$Location$Details$Model$EditorOpen(
						A2($author$project$Location$Details$Editor$HomepageEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
					A2(
						$author$project$Listings$Ui$Row$withDataTestAttribute,
						'contactInformationSection.locationHomepage',
						A2(
							$author$project$Listings$Ui$Row$withStatus,
							homepageConflict,
							$author$project$Listings$Ui$Row$row(
								{
									label: $author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationHomepage(translations),
											description: $author$project$Translations$Listings$LocationDetail$descriptionHomepage(translations)
										}),
									fieldType: $author$project$Listings$Ui$Row$Paragraph(homepage)
								})))))
			]);
		var rows = _Utils_ap(
			contactRows,
			_Utils_ap(
				actionLinksRows,
				googleEnabled ? googleLinkRows : _List_Nil));
		var _v6 = locationData.storeId;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$sectionContactAndLinks(translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Listings$Ui$Row$render, row, translations, locale)
											]));
								},
								rows))))
				]));
	});
var $author$project$Translations$Listings$LocationDetail$active = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.active');
};
var $author$project$Location$Details$DevNetworkActions$Model$Open = {$: 'Open'};
var $author$project$FontAwesome$Solid$Icon$faUserSecret = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-user-secret');
var $author$project$Location$Details$DevNetworkActions$View$openButton = A4(
	$author$project$PinMeTo$Ui$Btn$pmtBtnCtaSmall,
	$author$project$PinMeTo$Ui$Btn$FASolid($author$project$FontAwesome$Solid$Icon$faUserSecret),
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Events$onClick($author$project$Location$Details$DevNetworkActions$Model$Open)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Network actions')
		]));
var $author$project$Location$Details$DevNetworkActions$openButton = $author$project$Location$Details$DevNetworkActions$View$openButton;
var $author$project$Location$Details$Editor$ActiveEditor = F2(
	function (a, b) {
		return {$: 'ActiveEditor', a: a, b: b};
	});
var $author$project$Translations$Listings$LocationDetail$alternativeName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.alternative_name');
};
var $author$project$Translations$Listings$LocationDetail$customerSuccess = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.customer_success');
};
var $author$project$Translations$Listings$LocationDetail$initialLanguage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.initial_language');
};
var $author$project$PinMeTo$Ui$I18n$Language$toHumanReadable = function (x) {
	switch (x.$) {
		case 'En':
			return 'English (Default)';
		case 'Fr':
			return 'Français';
		case 'De':
			return 'Deutsch';
		case 'Es':
			return 'Español';
		case 'Sv':
			return 'Svenska';
		case 'Fi':
			return 'Suomi';
		case 'Pl':
			return 'Polski';
		default:
			return 'Português';
	}
};
var $author$project$Location$Details$Model$DevNetworkActionsMsg = function (a) {
	return {$: 'DevNetworkActionsMsg', a: a};
};
var $author$project$Translations$Listings$LocationDetail$initialLanguageDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.initial_language_description');
};
var $author$project$Data$Location$verificationToString = function (verificationStatus) {
	return _Utils_eq(verificationStatus, $author$project$Data$Location$Verified) ? 'Verified' : 'Unverified';
};
var $author$project$Data$Location$addressVerificationToString = function (maybeVerification) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'Unverified',
		function (verification) {
			return $author$project$Data$Location$verificationToString(verification.addressAndCoordinates);
		},
		maybeVerification);
};
var $author$project$Location$Details$Editor$AlternativeSearchNamesEditor = {$: 'AlternativeSearchNamesEditor'};
var $author$project$Data$Location$serviceAreaVerificationToString = function (maybeVerification) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'Unverified',
		function (verification) {
			return $author$project$Data$Location$verificationToString(verification.serviceAreas);
		},
		maybeVerification);
};
var $author$project$Translations$Listings$LocationDetail$transitionedToNewPageExperience = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.transitioned_to_new_page_experience');
};
var $author$project$Translations$Listings$LocationDetail$descriptionAlternativeSearchNames = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_alternative_search_names');
};
var $author$project$Location$Details$View$customerSuccessSection = F3(
	function (locationData, translations, maybeLocale) {
		var locale = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, $elm$core$Basics$identity, maybeLocale);
		var names = locationData.alternativeSearchNames;
		var rows = _List_fromArray(
			[
				A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				$author$project$Data$Location$Active,
				$author$project$Location$Details$Model$EditorOpen(
					A2($author$project$Location$Details$Editor$ActiveEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'customerSuccessSection.active',
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$Listings$LocationDetail$active(translations),
										description: ''
									}),
								fieldType: $author$project$Listings$Ui$Row$Paragraph(
									_Utils_eq(locationData.isActive, $author$project$Data$Location$Active) ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations))
							})))),
				A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$AlternativeSearchNamesEditor),
				A2(
					$author$project$Listings$Ui$Row$withDataTestAttribute,
					'customerSuccessSection.alternativeSearchNames',
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{
										title: $author$project$Translations$Listings$LocationDetail$alternativeName(translations),
										description: $author$project$Translations$Listings$LocationDetail$descriptionAlternativeSearchNames(translations)
									}),
								fieldType: $author$project$Listings$Ui$Row$Paragraph(
									$author$project$Data$Location$alternativeSearchNamesToString(names))
							})))),
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'customerSuccessSection.addressVerified',
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					$author$project$Listings$Ui$Row$NoConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$Listings$LocationDetail$sectionAddress(translations),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$Paragraph(
								$author$project$Data$Location$addressVerificationToString(locationData.verification))
						}))),
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'customerSuccessSection.serviceAreasVerified',
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					$author$project$Listings$Ui$Row$NoConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$General$serviceArea(translations),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$Paragraph(
								$author$project$Data$Location$serviceAreaVerificationToString(locationData.verification))
						}))),
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'customerSuccessSection.transitionedToNewPageExperience',
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					$author$project$Listings$Ui$Row$NoConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$Listings$LocationDetail$transitionedToNewPageExperience(translations),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$Paragraph(
								locationData.hasTransitionedToNewPageExperience ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations))
						}))),
				A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'customerSuccessSection.initialLanguage',
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					$author$project$Listings$Ui$Row$NoConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$Listings$LocationDetail$initialLanguage(translations),
									description: $author$project$Translations$Listings$LocationDetail$initialLanguageDescription(translations)
								}),
							fieldType: $author$project$Listings$Ui$Row$Paragraph(
								function () {
									var _v0 = locationData.googleIdSetType;
									if (_v0.$ === 'Just') {
										var googleIdSetType = _v0.a;
										return A2(
											$elm$core$Maybe$withDefault,
											A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, googleIdSetType.languageCode),
											A2(
												$elm$core$Maybe$map,
												$author$project$PinMeTo$Ui$I18n$Language$toHumanReadable,
												A2($elm$core$Maybe$andThen, $author$project$PinMeTo$Ui$I18n$Language$fromString, googleIdSetType.languageCode)));
									} else {
										return '';
									}
								}())
						})))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-group__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$LocationDetail$customerSuccess(translations))
								])),
							A2($elm$html$Html$map, $author$project$Location$Details$Model$DevNetworkActionsMsg, $author$project$Location$Details$DevNetworkActions$openButton)
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Listings$Ui$Row$render, row, translations, locale)
											]));
								},
								rows))))
				]));
	});
var $author$project$Listings$Ui$Row$Work = {$: 'Work'};
var $author$project$Listings$Ui$Row$Conflict = {$: 'Conflict'};
var $author$project$Listings$Ui$Row$Coordinates = function (a) {
	return {$: 'Coordinates', a: a};
};
var $author$project$Translations$Listings$LocationDetail$descriptionAddress = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_address');
};
var $author$project$Location$Details$View$locationAddressSection = F3(
	function (locationData, translations, locale) {
		var _v0 = locationData.location;
		var geoCoordinates = _v0.a;
		var geoCoordinatesConflict = _v0.b;
		var _v1 = locationData.serviceAreas;
		var sa = _v1.a;
		var serviceAreasConflict = _v1.b;
		var serviceAreaToString = function (serviceArea) {
			switch (serviceArea.$) {
				case 'WithPlaceId':
					var serviceAreas = serviceArea.a;
					var longName = function (area) {
						return area.longName;
					};
					var unwrapServiceArea = F2(
						function (area, str) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								str,
								function (x) {
									return (str === '') ? longName(x) : (str + (', ' + longName(x)));
								},
								area);
						});
					var unwrappedServiceAreas = A2(
						$elm$core$List$map,
						function (area) {
							return A2(
								unwrapServiceArea,
								$elm$core$Maybe$Just(area.country),
								A2(
									unwrapServiceArea,
									area.state,
									A2(
										unwrapServiceArea,
										area.region,
										A2(
											unwrapServiceArea,
											area.city,
											A2(unwrapServiceArea, area.zip, '')))));
						},
						A2($elm$core$List$take, 5, serviceAreas));
					var serviceAreaStringList = ($elm$core$List$length(serviceAreas) > 5) ? A2(
						$elm$core$List$append,
						unwrappedServiceAreas,
						_List_fromArray(
							[
								A2(
								$author$project$Translations$Listings$LocationDetail$plusAmount,
								translations,
								$elm$core$String$fromInt(
									$elm$core$List$length(serviceAreas) - 5))
							])) : unwrappedServiceAreas;
					return serviceAreaStringList;
				case 'Text':
					var list = serviceArea.a;
					return list;
				default:
					return _List_fromArray(
						['']);
			}
		};
		var _v2 = locationData.province;
		var province = _v2.a;
		var provinceConflict = _v2.b;
		var _v3 = locationData.district;
		var district = _v3.a;
		var districtConflict = _v3.b;
		var _v4 = locationData.country;
		var country = _v4.a;
		var countryConflict = _v4.b;
		var addressClickAttrs = _Utils_eq(locationData.isActive, $author$project$Data$Location$Active) ? _List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-details-group__clickable-element'),
				$elm$html$Html$Events$onClick(
				$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$AddressEditor))
			]) : _List_Nil;
		var _v5 = locationData.street;
		var street = _v5.a;
		var streetConflict = _v5.b;
		var addressFieldLine = F3(
			function (dataTestAttribute, label, value) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__address-line'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', dataTestAttribute)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__address-line-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__address-line-value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]))
						]));
			});
		var _v6 = locationData.state;
		var state = _v6.a;
		var stateConflict = _v6.b;
		var _v7 = locationData.locationType;
		var locationType = _v7.a;
		var _v8 = locationData.city;
		var city = _v8.a;
		var cityConflict = _v8.b;
		var resolvedLocale = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, $elm$core$Basics$identity, locale);
		var _v9 = locationData.zip;
		var zip = _v9.a;
		var zipConflict = _v9.b;
		var combinedStatus = A3(
			$elm$core$List$foldl,
			F2(
				function (status, acc) {
					var _v14 = _Utils_Tuple2(status, acc);
					_v14$1:
					while (true) {
						_v14$2:
						while (true) {
							switch (_v14.a.$) {
								case 'Work':
									var _v15 = _v14.a;
									return $author$project$Listings$Ui$Row$Work;
								case 'Conflict':
									switch (_v14.b.$) {
										case 'Work':
											break _v14$1;
										case 'Conflict':
											break _v14$2;
										default:
											break _v14$2;
									}
								default:
									switch (_v14.b.$) {
										case 'Work':
											break _v14$1;
										case 'Conflict':
											var _v18 = _v14.b;
											return $author$project$Listings$Ui$Row$Conflict;
										default:
											return $author$project$Listings$Ui$Row$NoConflict;
									}
							}
						}
						var _v17 = _v14.a;
						return $author$project$Listings$Ui$Row$Conflict;
					}
					var _v16 = _v14.b;
					return $author$project$Listings$Ui$Row$Work;
				}),
			$author$project$Listings$Ui$Row$NoConflict,
			_List_fromArray(
				[streetConflict, zipConflict, cityConflict, countryConflict, stateConflict, provinceConflict, districtConflict, serviceAreasConflict]));
		var addressStatusIcon = function () {
			if (combinedStatus.$ === 'Work') {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__icon location-details-row__icon--work')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$WorkInProgress)
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var mapPinRow = A3(
			$author$project$Listings$Ui$Row$withOpenLightBox,
			$author$project$Data$Location$Active,
			$author$project$Location$Details$Model$EditorOpen($author$project$Location$Details$Editor$CoordinatesEditor),
			A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'locationAddressSection.locationGeoCoordinates',
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					geoCoordinatesConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$General$locationGeoCoordinates(translations),
									description: ''
								}),
							fieldType: $author$project$Listings$Ui$Row$Coordinates(
								{lat: geoCoordinates.lat, lon: geoCoordinates.lon})
						}))));
		var stateOrProvinceLines = _Utils_ap(
			function () {
				if (state.$ === 'Just') {
					var s = state.a;
					return _List_fromArray(
						[
							A3(
							addressFieldLine,
							'locationAddressSection.locationState',
							$author$project$Translations$General$locationStateRegion(translations),
							s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					if (province.$ === 'Just') {
						var p = province.a;
						return _List_fromArray(
							[
								A3(
								addressFieldLine,
								'locationAddressSection.locationProvince',
								$author$project$Translations$General$locationProvince(translations),
								p)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				function () {
					if (district.$ === 'Just') {
						var d = district.a;
						return _List_fromArray(
							[
								A3(
								addressFieldLine,
								'locationAddressSection.locationDistrict',
								$author$project$Translations$General$locationDistrict(translations),
								d)
							]);
					} else {
						return _List_Nil;
					}
				}()));
		var addressLines = _Utils_ap(
			_List_fromArray(
				[
					A3(
					addressFieldLine,
					'locationAddressSection.locationStreet',
					$author$project$Translations$General$locationStreet(translations),
					street),
					A3(
					addressFieldLine,
					'locationAddressSection.locationZip',
					$author$project$Translations$General$locationZip(translations),
					zip),
					A3(
					addressFieldLine,
					'locationAddressSection.locationCity',
					$author$project$Translations$General$locationCity(translations),
					city)
				]),
			_Utils_ap(
				stateOrProvinceLines,
				_List_fromArray(
					[
						A3(
						addressFieldLine,
						'locationAddressSection.locationCountry',
						$author$project$Translations$General$locationCountry(translations),
						country)
					])));
		var serviceAreaLines = (!_Utils_eq(locationType, $author$project$Data$Location$Storefront)) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('location-details-row__address-line location-details-row__address-line--group'),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'locationAddressSection.serviceArea')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details-row__address-line-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$serviceAreas(translations))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('location-details-row__address-line-value')
							]),
						A2(
							$elm$core$List$map,
							function (s) {
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('location-details-row__value__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(s)
										]));
							},
							serviceAreaToString(sa)))
					]))
			]) : _List_Nil;
		var addressGroupRow = A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('location-details-group__row location-details-row'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'locationAddressSection.address'),
					addressClickAttrs)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('location-details-row__label-conflicts-container')
								]),
							_List_fromArray(
								[
									addressStatusIcon,
									$author$project$Listings$Ui$Label$render(
									$author$project$Listings$Ui$Label$label(
										{
											title: $author$project$Translations$General$locationAddress(translations),
											description: $author$project$Translations$Listings$LocationDetail$descriptionAddress(translations)
										}))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-row__value location-details-row__address-group')
						]),
					_Utils_ap(addressLines, serviceAreaLines))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$locationAddress(translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Listings$Ui$Row$render, mapPinRow, translations, resolvedLocale)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[addressGroupRow]))
								]))))
				]));
	});
var $author$project$Location$Details$Editor$WifiEditor = F2(
	function (a, b) {
		return {$: 'WifiEditor', a: a, b: b};
	});
var $author$project$Listings$Ui$Row$GoogleAttributes = function (a) {
	return {$: 'GoogleAttributes', a: a};
};
var $author$project$Location$Details$Editor$ServiceItemsEditor = F3(
	function (a, b, c) {
		return {$: 'ServiceItemsEditor', a: a, b: b, c: c};
	});
var $author$project$Translations$Listings$LocationDetail$descriptionWifiSsid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_wifi_ssid');
};
var $author$project$Translations$Listings$LocationDetail$fetchGoogleServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.fetch_google_services');
};
var $author$project$Location$Details$Editor$GoogleAttributesEditor = F3(
	function (a, b, c) {
		return {$: 'GoogleAttributesEditor', a: a, b: b, c: c};
	});
var $author$project$Translations$Listings$LocationDetail$descriptionGoogleServices = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_google_services');
};
var $author$project$Translations$Listings$LocationDetail$descriptionGoogleAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.description_google_attributes');
};
var $author$project$Location$Details$View$attributesAndServicesSection = F6(
	function (locationData, googleEnabled, googleAttributes, allGoogleServiceItems, translations, locale) {
		var _v0 = locationData.googleServiceItems;
		var googleServiceItems = _v0.a;
		var googleServiceItemsConflicts = _v0.b;
		var _v1 = locationData.networkAttributes;
		var networkAttributes = _v1.a;
		var networkAttributesConflicts = _v1.b;
		var _v2 = locationData.wifiSsId;
		var wifiSsId = _v2.a;
		var wifiSsIdConflict = _v2.b;
		var googleServiceNames = function () {
			if (allGoogleServiceItems.$ === 'Loaded') {
				var supportedServiceItems = allGoogleServiceItems.a;
				return A2(
					$elm$core$List$map,
					function (service) {
						if (service.$ === 'Structured') {
							var structuredService = service.a;
							return A2($author$project$Data$NetworkData$GoogleServiceItems$googleServiceItemNameLookup, supportedServiceItems, structuredService.id);
						} else {
							var freeformService = service.a;
							return freeformService.label.displayName;
						}
					},
					googleServiceItems);
			} else {
				return A2(
					$elm$core$List$map,
					function (service) {
						if (service.$ === 'Structured') {
							var structuredService = service.a;
							return $author$project$Data$Location$NetworkServiceItems$parseStructuredServiceId(structuredService.id);
						} else {
							var freeformService = service.a;
							return freeformService.label.displayName;
						}
					},
					googleServiceItems);
			}
		}();
		var servicesFieldType = function () {
			if (allGoogleServiceItems.$ === 'Error') {
				return $author$project$Listings$Ui$Row$FailedToFetch(
					$author$project$Translations$Listings$LocationDetail$fetchGoogleServices(translations));
			} else {
				return $author$project$Listings$Ui$Row$Paragraph(
					A2($elm$core$String$join, ', ', googleServiceNames));
			}
		}();
		var attributesFieldType = function () {
			var _v4 = A2(
				$author$project$RemoteData$map,
				$author$project$Location$Details$View$getAttributes(networkAttributes.google),
				googleAttributes);
			switch (_v4.$) {
				case 'Loaded':
					var attributesList = _v4.a;
					return $author$project$Listings$Ui$Row$GoogleAttributes(attributesList);
				case 'Error':
					return $author$project$Listings$Ui$Row$FailedToFetch(
						$author$project$Translations$Listings$LocationDetail$fetchGoogleAttributes(translations));
				default:
					return $author$project$Listings$Ui$Row$Paragraph('');
			}
		}();
		var googleAttributesRow = A2(
			$author$project$Listings$Ui$Row$withDataTestAttribute,
			'googleSection.locationAttributes',
			A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				function () {
					var _v3 = $author$project$RemoteData$currentData(googleAttributes);
					if (_v3.$ === 'Just') {
						var ga = _v3.a;
						return $author$project$Location$Details$Model$EditorOpen(
							A3($author$project$Location$Details$Editor$GoogleAttributesEditor, ga.attributes, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
					} else {
						return $author$project$Location$Details$Model$EditorOpen(
							A3($author$project$Location$Details$Editor$GoogleAttributesEditor, _List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
					}
				}(),
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					networkAttributesConflicts,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$General$locationAttributes(translations),
									description: $author$project$Translations$Listings$LocationDetail$descriptionGoogleAttributes(translations)
								}),
							fieldType: attributesFieldType
						}))));
		var servicesRow = A3(
			$author$project$Listings$Ui$Row$withOpenLightBox,
			locationData.isActive,
			$author$project$Location$Details$Model$EditorOpen(
				A3($author$project$Location$Details$Editor$ServiceItemsEditor, $author$project$Data$Network$Google, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
			A2(
				$author$project$Listings$Ui$Row$withDataTestAttribute,
				'googleSection.services',
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					googleServiceItemsConflicts,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$Listings$LocationDetail$PopUpContent$googleServicesTitle(translations),
									description: $author$project$Translations$Listings$LocationDetail$descriptionGoogleServices(translations)
								}),
							fieldType: servicesFieldType
						}))));
		var wifiRow = A2(
			$author$project$Listings$Ui$Row$withDataTestAttribute,
			'attributesAndServicesSection.locationWifi',
			A3(
				$author$project$Listings$Ui$Row$withOpenLightBox,
				locationData.isActive,
				$author$project$Location$Details$Model$EditorOpen(
					A2($author$project$Location$Details$Editor$WifiEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)),
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					wifiSsIdConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{
									title: $author$project$Translations$General$locationWifi(translations),
									description: $author$project$Translations$Listings$LocationDetail$descriptionWifiSsid(translations)
								}),
							fieldType: $author$project$Listings$Ui$Row$Paragraph(wifiSsId)
						}))));
		var rows = A2(
			$elm$core$List$cons,
			wifiRow,
			googleEnabled ? _List_fromArray(
				[servicesRow, googleAttributesRow]) : _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h6,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details-group__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$sectionAttributesAndServices(translations))
						])),
					$author$project$PinMeTo$Ui$Card$render(
					$author$project$PinMeTo$Ui$Card$view(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (row) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Listings$Ui$Row$render, row, translations, locale)
											]));
								},
								rows))))
				]));
	});
var $author$project$Location$Details$View$locationDetailsTab = F3(
	function (session, locationData, model) {
		var spaces = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				]));
		var isCS = A2($author$project$Data$User$hasRole, session.user, $author$project$Data$User$CustomerSuccess);
		var showCSView = isCS && (!session.user.isDemo);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					showCSView ? A3($author$project$Location$Details$View$customerSuccessSection, locationData, session.translations, $elm$core$Maybe$Nothing) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('general-data')
						]),
					_List_Nil),
					A5($author$project$Location$Details$View$generalDataSection, session, locationData, model.features, showCSView, model.scheduleUpdates),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('address')
						]),
					_List_Nil),
					_Utils_eq(
					function (_v0) {
						var type_ = _v0.a;
						return type_;
					}(locationData.locationType),
					$author$project$Data$Location$ServiceArea) ? A3($author$project$Location$Details$View$serviceAreasSection, locationData, session.translations, $elm$core$Maybe$Nothing) : $elm$html$Html$text(''),
					(!_Utils_eq(
					function (_v1) {
						var type_ = _v1.a;
						return type_;
					}(locationData.locationType),
					$author$project$Data$Location$ServiceArea)) ? A3($author$project$Location$Details$View$locationAddressSection, locationData, session.translations, $elm$core$Maybe$Nothing) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('open-hours')
						]),
					_List_Nil),
					A6($author$project$Location$Details$View$openHoursSection, model, locationData, model.scheduleUpdates, model.today, session.locale, session.translations),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('contact-information')
						]),
					_List_Nil),
					A6(
					$author$project$Location$Details$View$contactAndLinksSection,
					locationData,
					model.scheduleUpdates,
					_Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled),
					model.googleAttributes,
					session.translations,
					session.locale),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('attributes-and-services')
						]),
					_List_Nil),
					A6(
					$author$project$Location$Details$View$attributesAndServicesSection,
					locationData,
					_Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled),
					model.googleAttributes,
					model.allGoogleServiceItems,
					session.translations,
					session.locale),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('images')
						]),
					_List_Nil),
					A2($author$project$Location$Details$View$imagesSection, session, locationData),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('categories')
						]),
					_List_Nil),
					A3($author$project$Location$Details$View$categoriesSection, session, locationData, model.siteCategories),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('location-details__anchor'),
							$elm$html$Html$Attributes$id('custom-fields')
						]),
					_List_Nil),
					A7($author$project$Location$Details$View$customFieldsSection, locationData, locationData.customData, model.customDataDefinition, model.today, model.scheduleUpdates, session.translations, session.locale),
					A2($author$project$Location$Details$View$historyLink, model, session.translations),
					spaces
				]));
	});
var $author$project$Location$Details$Model$CustomFieldEditorMsg = function (a) {
	return {$: 'CustomFieldEditorMsg', a: a};
};
var $author$project$Location$Details$Model$CustomFieldEditorClose = {$: 'CustomFieldEditorClose'};
var $author$project$Location$Details$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('location-details'),
					$elm$html$Html$Attributes$id($author$project$Location$Details$View$viewId)
				]),
			_List_fromArray(
				[
					A3($author$project$Location$Details$View$locationDetailsTab, session, model.locationDataWithConflictStatus, model),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						A3(
							$author$project$Location$Details$Editor$view,
							{tagger: $author$project$Location$Details$Model$EditorMsg, onCancel: $author$project$Location$Details$Model$EditorClose, onSubmit: $author$project$Location$Details$Model$EditorClose, withScheduling: true},
							session,
							$elm$core$Maybe$Just(model.customDataDefinition)),
						model.editor)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						A2(
							$author$project$Location$Details$CustomFieldEditor$view,
							{tagger: $author$project$Location$Details$Model$CustomFieldEditorMsg, onCancel: $author$project$Location$Details$Model$CustomFieldEditorClose, withScheduling: true},
							session),
						model.customFieldEditor)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Location$ImageEditor$view(session),
							$elm$html$Html$map($author$project$Location$Details$Model$ImageEditorMsg)),
						model.imageEditor)),
					A2(
					$elm$html$Html$map,
					$author$project$Location$Details$Model$DevNetworkActionsMsg,
					A2(
						$author$project$Location$Details$DevNetworkActions$view,
						{siteName: model.siteName, locationId: model.locationId},
						model.devNetworkActions))
				]));
	});
var $author$project$Location$Details$App$LocationDetailsPageMsg = function (a) {
	return {$: 'LocationDetailsPageMsg', a: a};
};
var $author$project$Location$Details$App$view = F2(
	function (session, model) {
		var renderSpinner = _Utils_eq(model.location, $author$project$RemoteData$Loading) ? $elm$core$Maybe$withDefault($author$project$PinMeTo$Ui$Spinner$spinnerWithDelay) : $elm$core$Maybe$withDefault(
			$elm$html$Html$text(''));
		return A2(
			$elm$html$Html$map,
			$author$project$Location$Details$App$LocationDetailsPageMsg,
			renderSpinner(
				A2(
					$elm$core$Maybe$map,
					$author$project$Location$Details$View$view(session),
					model.locationDetailPage)));
	});
var $author$project$PinMeTo$Ui$Lightbox$Wide = {$: 'Wide'};
var $author$project$Location$LocationInfoPane$View$Map$popupMap = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-info-pane__map--popup')
			]),
		_List_fromArray(
			[
				$author$project$Location$LocationInfoPane$View$Map$mapElement(model)
			]));
};
var $author$project$Location$LocationInfoPane$Model$CloseMapPopup = {$: 'CloseMapPopup'};
var $author$project$Location$LocationInfoPane$View$mapPopupView = function (model) {
	return model.mapPopupOpen ? $author$project$PinMeTo$Ui$Lightbox$render(
		A2(
			$author$project$PinMeTo$Ui$Lightbox$withClassName,
			'location-info-pane__map-lightbox',
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withClose,
				$author$project$Location$LocationInfoPane$Model$CloseMapPopup,
				$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withStyle,
						$author$project$PinMeTo$Ui$Lightbox$Wide,
						$author$project$PinMeTo$Ui$Lightbox$view(
							{
								title: '',
								content: $author$project$Location$LocationInfoPane$View$Map$popupMap(model)
							})))))) : $elm$html$Html$text('');
};
var $author$project$Location$LocationInfoPane$App$mapPopupView = function (model) {
	return $author$project$Location$LocationInfoPane$View$mapPopupView(model);
};
var $author$project$Location$DetailsPage$Main$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-location-ldp')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-location-ldp__main')
						]),
					_List_fromArray(
						[
							model.onDetailsRoute ? A2(
							$elm$html$Html$map,
							$author$project$Location$DetailsPage$Main$DetailsMsg,
							A2($author$project$Location$Details$App$view, session, model.details)) : $elm$html$Html$text('')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-location-ldp__side')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Location$DetailsPage$Main$SidePaneMsg,
							A2($author$project$Location$LocationInfoPane$App$view, session, model.sidePane))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Location$DetailsPage$Main$SidePaneMsg,
					$author$project$Location$LocationInfoPane$App$mapPopupView(model.sidePane))
				]));
	});
var $rl_king$elm_scroll_to$ScrollTo$NoOp = {$: 'NoOp'};
var $tad_lispy$springs$Spring$value = function (_v0) {
	var _this = _v0.a;
	return _this.value;
};
var $tad_lispy$springs$Spring$jumpTo = F2(
	function (newValue, _v0) {
		var _this = _v0.a;
		return $tad_lispy$springs$Spring$Spring(
			_Utils_update(
				_this,
				{value: newValue, velocity: 0.0}));
	});
var $tad_lispy$springs$Spring$target = function (_v0) {
	var _this = _v0.a;
	return _this.target;
};
var $tad_lispy$springs$Spring$atRest = function (_v0) {
	var _this = _v0.a;
	return _Utils_eq(_this.value, _this.target) && (_this.velocity === 0.0);
};
var $tad_lispy$springs$Spring$animate = F2(
	function (delta, spring) {
		var _this = spring.a;
		if ($tad_lispy$springs$Spring$atRest(spring)) {
			return spring;
		} else {
			if (($elm$core$Basics$abs(_this.value - _this.target) < 0.05) && ($elm$core$Basics$abs(_this.velocity) < 0.05)) {
				return A2($tad_lispy$springs$Spring$jumpTo, _this.target, spring);
			} else {
				var stretch = _this.target - _this.value;
				var damping = _this.velocity * _this.dampness;
				var force = stretch * _this.strength;
				var time = A2($elm$core$Basics$min, delta, 32) / 1000;
				var acceleration = time * (force - damping);
				var velocity = _this.velocity + acceleration;
				var newValue = _this.value + (velocity * time);
				return $tad_lispy$springs$Spring$Spring(
					_Utils_update(
						_this,
						{value: newValue, velocity: velocity}));
			}
		}
	});
var $tad_lispy$springs$Spring$setTarget = F2(
	function (newTarget, _v0) {
		var spring = _v0.a;
		return $tad_lispy$springs$Spring$Spring(
			_Utils_update(
				spring,
				{target: newTarget}));
	});
var $rl_king$elm_scroll_to$ScrollTo$isScrolling = function (_v0) {
	var springs = _v0.a;
	return !($tad_lispy$springs$Spring$atRest(springs.x) && $tad_lispy$springs$Spring$atRest(springs.y));
};
var $rl_king$elm_scroll_to$ScrollTo$update = F2(
	function (msg, state) {
		var springs = state.a;
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 'Tick':
				var delta = msg.a;
				var check = F3(
					function (current, next_, target) {
						return !$elm$core$Basics$round((current - target) + (next_ - target));
					});
				var next = A2(
					$rl_king$elm_scroll_to$ScrollTo$Springs,
					A2($tad_lispy$springs$Spring$animate, delta, springs.x),
					A2($tad_lispy$springs$Spring$animate, delta, springs.y));
				return (A3(
					check,
					$tad_lispy$springs$Spring$value(springs.x),
					$tad_lispy$springs$Spring$value(next.x),
					$tad_lispy$springs$Spring$target(next.x)) && A3(
					check,
					$tad_lispy$springs$Spring$value(springs.y),
					$tad_lispy$springs$Spring$value(next.y),
					$tad_lispy$springs$Spring$target(next.y))) ? _Utils_Tuple2(
					$rl_king$elm_scroll_to$ScrollTo$State(
						A2(
							$rl_king$elm_scroll_to$ScrollTo$Springs,
							A2(
								$tad_lispy$springs$Spring$jumpTo,
								$tad_lispy$springs$Spring$target(springs.x),
								springs.x),
							A2(
								$tad_lispy$springs$Spring$jumpTo,
								$tad_lispy$springs$Spring$target(springs.y),
								springs.y))),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$rl_king$elm_scroll_to$ScrollTo$State(next),
					A2(
						$elm$core$Task$perform,
						function (_v1) {
							return $rl_king$elm_scroll_to$ScrollTo$NoOp;
						},
						A2(
							$elm$browser$Browser$Dom$setViewport,
							$tad_lispy$springs$Spring$value(next.x),
							$tad_lispy$springs$Spring$value(next.y))));
			default:
				if (msg.a.$ === 'Ok') {
					var to = msg.a.a.to;
					var from = msg.a.a.from;
					var setCurrent = $rl_king$elm_scroll_to$ScrollTo$isScrolling(state) ? $tad_lispy$springs$Spring$setTarget : $tad_lispy$springs$Spring$jumpTo;
					return _Utils_Tuple2(
						$rl_king$elm_scroll_to$ScrollTo$State(
							A2(
								$rl_king$elm_scroll_to$ScrollTo$Springs,
								A2(
									$tad_lispy$springs$Spring$setTarget,
									to.x,
									A2(setCurrent, from.x, springs.x)),
								A2(
									$tad_lispy$springs$Spring$setTarget,
									to.y,
									A2(setCurrent, from.y, springs.y)))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Location$ImageEditor$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Location$ImageEditor$PickingImage = {$: 'PickingImage'};
var $author$project$Location$ImageEditor$networkAndMediaType = function (target) {
	switch (target.$) {
		case 'GoogleLogo':
			return _Utils_Tuple2($author$project$Common$Image$Validation$Google, $author$project$Common$Image$Types$Profile);
		case 'GoogleCover':
			return _Utils_Tuple2($author$project$Common$Image$Validation$Google, $author$project$Common$Image$Types$Cover);
		case 'FacebookProfile':
			return _Utils_Tuple2($author$project$Common$Image$Validation$Facebook, $author$project$Common$Image$Types$Profile);
		default:
			return _Utils_Tuple2($author$project$Common$Image$Validation$Facebook, $author$project$Common$Image$Types$Cover);
	}
};
var $author$project$Location$ImageEditor$init = F3(
	function (target, siteName, locationId) {
		var _v0 = $author$project$Location$ImageEditor$networkAndMediaType(target);
		var network = _v0.a;
		var mediaType = _v0.b;
		var _v1 = A4($author$project$Common$Image$Editor$init, network, mediaType, siteName, 'location-image-editor-cropper');
		var editor = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			$author$project$Location$ImageEditor$State(
				{
					error: $elm$core$Maybe$Nothing,
					stage: $author$project$Location$ImageEditor$PickingImage,
					editor: editor,
					saving: false,
					target: target,
					siteName: siteName,
					confirming: false,
					locationId: locationId,
					locationSelector: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init,
					selectedLocations: _List_fromArray(
						[locationId])
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Location$ImageEditor$EditorMsg, cmd));
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$getStringList = function (initialList) {
	return A2(
		$elm$core$List$map,
		function (item) {
			if (item.$ === 'StringProperty') {
				var _v1 = item.a;
				var value = _v1.a;
				return value;
			} else {
				return '-';
			}
		},
		initialList);
};
var $author$project$Location$Details$PopupContent$CustomFieldList$init = function (initialList) {
	return {
		list: $author$project$Location$Details$PopupContent$CustomFieldList$getStringList(initialList),
		currentText: ''
	};
};
var $author$project$Data$CustomDataDefinition$validationRuleToString = function (_v0) {
	var str = _v0.a;
	return str;
};
var $author$project$Location$Details$PopupContent$CustomFieldString$validateInput = F2(
	function (rules, input) {
		var valid = _Utils_eq(rules, _List_Nil) ? true : (!A2(
			$elm$core$List$member,
			false,
			A2(
				$elm$core$List$map,
				function (rule) {
					return A2(
						$elm$regex$Regex$contains,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$regex$Regex$never,
							$elm$regex$Regex$fromString(
								$author$project$Data$CustomDataDefinition$validationRuleToString(rule))),
						input);
				},
				rules)));
		return valid;
	});
var $author$project$Location$Details$PopupContent$CustomFieldString$init = F2(
	function (initialStatus, initialRules) {
		return {
			rules: initialRules,
			value: initialStatus,
			isValid: A2($author$project$Location$Details$PopupContent$CustomFieldString$validateInput, initialRules, initialStatus)
		};
	});
var $author$project$Location$Details$PopupContent$CustomFieldBoolean$init = function (initialStatus) {
	return {value: initialStatus};
};
var $author$project$Location$Details$PopupContent$CustomFieldObject$ListAttribute = F2(
	function (a, b) {
		return {$: 'ListAttribute', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$ObjectAttribute = F2(
	function (a, b) {
		return {$: 'ObjectAttribute', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$StringAttribute = F2(
	function (a, b) {
		return {$: 'StringAttribute', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$BooleanAttribute = F2(
	function (a, b) {
		return {$: 'BooleanAttribute', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$OpenHoursAttribute = F2(
	function (a, b) {
		return {$: 'OpenHoursAttribute', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$SpecialOpenHoursAttribute = F2(
	function (a, b) {
		return {$: 'SpecialOpenHoursAttribute', a: a, b: b};
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$init = F2(
	function (initialList, property) {
		var propertyDefinitionList = function () {
			if (property.$ === 'ObjectProperty') {
				var customDataDefinition = property.b;
				var _v10 = customDataDefinition;
				var objectAttributes = _v10.a;
				return objectAttributes;
			} else {
				return _List_Nil;
			}
		}();
		var attributesList = ($elm$core$List$length(initialList) > 0) ? initialList : A2(
			$elm$core$List$map,
			function (attributeProperty) {
				switch (attributeProperty.$) {
					case 'StringProperty':
						var meta = attributeProperty.a;
						return $author$project$Data$Location$CustomData$StringProperty(
							_Utils_Tuple2('', meta));
					case 'BooleanProperty':
						var meta = attributeProperty.a;
						return $author$project$Data$Location$CustomData$BooleanProperty(
							_Utils_Tuple2(false, meta));
					case 'ListProperty':
						var meta = attributeProperty.a;
						return $author$project$Data$Location$CustomData$ListProperty(
							_Utils_Tuple2(_List_Nil, meta));
					case 'OpenHoursProperty':
						var meta = attributeProperty.a;
						var notSpecifiedOpenHours = $author$project$Data$Location$OpenHours$During(
							{fri: $author$project$Data$Location$OpenHours$NotSpecified, mon: $author$project$Data$Location$OpenHours$NotSpecified, sat: $author$project$Data$Location$OpenHours$NotSpecified, sun: $author$project$Data$Location$OpenHours$NotSpecified, thu: $author$project$Data$Location$OpenHours$NotSpecified, tue: $author$project$Data$Location$OpenHours$NotSpecified, wed: $author$project$Data$Location$OpenHours$NotSpecified});
						return $author$project$Data$Location$CustomData$OpenHoursProperty(
							_Utils_Tuple2(notSpecifiedOpenHours, meta));
					case 'SpecialOpenHoursProperty':
						var meta = attributeProperty.a;
						return $author$project$Data$Location$CustomData$SpecialOpenHoursProperty(
							_Utils_Tuple2(_List_Nil, meta));
					default:
						var meta = attributeProperty.a;
						return $author$project$Data$Location$CustomData$ObjectProperty(
							_Utils_Tuple2(_List_Nil, meta));
				}
			},
			propertyDefinitionList);
		var propertiesList = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, setProperty) {
					switch (setProperty.$) {
						case 'StringProperty':
							var _v1 = setProperty.a;
							var value = _v1.a;
							var meta = _v1.b;
							return _Utils_Tuple2(
								index,
								A2(
									$author$project$Location$Details$PopupContent$CustomFieldObject$StringAttribute,
									setProperty,
									A2($author$project$Location$Details$PopupContent$CustomFieldString$init, value, meta.rules)));
						case 'BooleanProperty':
							var _v2 = setProperty.a;
							var value = _v2.a;
							return _Utils_Tuple2(
								index,
								A2(
									$author$project$Location$Details$PopupContent$CustomFieldObject$BooleanAttribute,
									setProperty,
									$author$project$Location$Details$PopupContent$CustomFieldBoolean$init(value)));
						case 'ListProperty':
							var _v3 = setProperty.a;
							var value = _v3.a;
							return _Utils_Tuple2(
								index,
								A2(
									$author$project$Location$Details$PopupContent$CustomFieldObject$ListAttribute,
									setProperty,
									$author$project$Location$Details$PopupContent$CustomFieldList$init(value)));
						case 'OpenHoursProperty':
							var _v4 = setProperty.a;
							var value = _v4.a;
							var _v5 = $author$project$Location$Details$PopupContent$OpenHours$init(value);
							var openHoursModel = _v5.a;
							return _Utils_Tuple2(
								index,
								A2($author$project$Location$Details$PopupContent$CustomFieldObject$OpenHoursAttribute, setProperty, openHoursModel));
						case 'SpecialOpenHoursProperty':
							var _v6 = setProperty.a;
							var meta = _v6.b;
							return _Utils_Tuple2(
								index,
								A2(
									$author$project$Location$Details$PopupContent$CustomFieldObject$SpecialOpenHoursAttribute,
									setProperty,
									A2($author$project$Location$Details$PopupContent$CustomFieldString$init, '-', meta.rules)));
						default:
							var _v7 = setProperty.a;
							var meta = _v7.b;
							return _Utils_Tuple2(
								index,
								A2(
									$author$project$Location$Details$PopupContent$CustomFieldObject$ObjectAttribute,
									setProperty,
									A2($author$project$Location$Details$PopupContent$CustomFieldString$init, '-', meta.rules)));
					}
				}),
			attributesList);
		return {
			attributes: $elm$core$Dict$fromList(propertiesList)
		};
	});
var $author$project$Location$Details$PopupContent$SpecialOpenHours$Other = {$: 'Other'};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor = function (a) {
	return {$: 'CustomFieldEditor', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$initModel = F5(
	function (customFieldConfig, valueProperty, now, id, customFieldEditor) {
		var selectedLocations = (id === '') ? _List_Nil : _List_fromArray(
			[id]);
		return $author$project$Location$Details$CustomFieldEditor$State(
			{
				now: now,
				error: $elm$core$Maybe$Nothing,
				confirm: $elm$core$Maybe$Nothing,
				content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(customFieldEditor),
				locationId: id,
				selectedDate: $elm$core$Maybe$Nothing,
				currentConfig: customFieldConfig,
				currentProperty: valueProperty,
				locationSelector: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init,
				selectedLocations: selectedLocations,
				showSavingProgress: false
			});
	});
var $author$project$Location$Details$CustomFieldEditor$isNotSetRowCmd = F2(
	function (customFieldEditor, now) {
		var isEmpty = function () {
			switch (customFieldEditor.$) {
				case 'CustomOpenHoursEditor':
					var openHours = customFieldEditor.a;
					return _Utils_eq(openHours, $author$project$Data$Location$OpenHours$notSpecified);
				case 'CustomSpecialOpenHoursEditor':
					var specialOpenHours = customFieldEditor.a;
					var upcomingSpecialOpenHours = A2(
						$elm$core$List$filter,
						function (soh) {
							return _Utils_cmp(
								$elm$time$Time$posixToMillis(soh.startDate),
								$elm$time$Time$posixToMillis(now)) > 0;
						},
						specialOpenHours);
					return !$elm$core$List$length(upcomingSpecialOpenHours);
				case 'CustomBooleanEditor':
					return false;
				case 'CustomStringEditor':
					var value = customFieldEditor.a;
					return value === '';
				case 'CustomListEditor':
					var list = customFieldEditor.a;
					return !$elm$core$List$length(list);
				default:
					return false;
			}
		}();
		return isEmpty ? $author$project$PlanHat$PlanHat$track(
			{info: '', action: $author$project$PlanHat$TrackingActions$keys.locationDetails.clicksNotSetRow}) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Location$Details$CustomFieldEditor$CustomFieldList = function (a) {
	return {$: 'CustomFieldList', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldObject = function (a) {
	return {$: 'CustomFieldObject', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldString = function (a) {
	return {$: 'CustomFieldString', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldBoolean = function (a) {
	return {$: 'CustomFieldBoolean', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHours = function (a) {
	return {$: 'CustomFieldOpenHours', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHours = function (a) {
	return {$: 'CustomFieldSpecialOpenHours', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$init = F5(
	function (valueProperty, now, id, customFieldEditor, session) {
		var _v0 = function () {
			switch (customFieldEditor.$) {
				case 'CustomOpenHoursEditor':
					var openHours = customFieldEditor.a;
					var customFieldConfig = customFieldEditor.b;
					var _v2 = $author$project$Location$Details$PopupContent$OpenHours$init(openHours);
					var popupModel = _v2.a;
					var popupMsg = _v2.b;
					var editorState = $author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHours(popupModel);
					return _Utils_Tuple2(
						A5($author$project$Location$Details$CustomFieldEditor$initModel, customFieldConfig, valueProperty, now, id, editorState),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHoursMsg, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg),
							popupMsg));
				case 'CustomSpecialOpenHoursEditor':
					var openHours = customFieldEditor.a;
					var customFieldConfig = customFieldEditor.b;
					var _v3 = A5($author$project$Location$Details$PopupContent$SpecialOpenHours$init, openHours, $author$project$Location$Details$PopupContent$SpecialOpenHours$Other, now, session.language, session.locale);
					var popupModel = _v3.a;
					var popupMsg = _v3.b;
					var editorState = $author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHours(popupModel);
					return _Utils_Tuple2(
						A5($author$project$Location$Details$CustomFieldEditor$initModel, customFieldConfig, valueProperty, now, id, editorState),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHoursMsg, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg),
							popupMsg));
				case 'CustomBooleanEditor':
					var value = customFieldEditor.a;
					var customFieldConfig = customFieldEditor.b;
					var editorState = $author$project$Location$Details$CustomFieldEditor$CustomFieldBoolean(
						$author$project$Location$Details$PopupContent$CustomFieldBoolean$init(value));
					return _Utils_Tuple2(
						A5($author$project$Location$Details$CustomFieldEditor$initModel, customFieldConfig, valueProperty, now, id, editorState),
						$elm$core$Platform$Cmd$none);
				case 'CustomStringEditor':
					var value = customFieldEditor.a;
					var customFieldConfig = customFieldEditor.b;
					var rules = customFieldConfig.meta.rules;
					var editorState = $author$project$Location$Details$CustomFieldEditor$CustomFieldString(
						A2($author$project$Location$Details$PopupContent$CustomFieldString$init, value, rules));
					return _Utils_Tuple2(
						A5($author$project$Location$Details$CustomFieldEditor$initModel, customFieldConfig, valueProperty, now, id, editorState),
						$elm$core$Platform$Cmd$none);
				case 'CustomListEditor':
					var list = customFieldEditor.a;
					var customFieldConfig = customFieldEditor.b;
					var editorState = $author$project$Location$Details$CustomFieldEditor$CustomFieldList(
						$author$project$Location$Details$PopupContent$CustomFieldList$init(list));
					return _Utils_Tuple2(
						A5($author$project$Location$Details$CustomFieldEditor$initModel, customFieldConfig, valueProperty, now, id, editorState),
						$elm$core$Platform$Cmd$none);
				default:
					var value = customFieldEditor.a;
					var customFieldConfig = customFieldEditor.b;
					var customDataDefinition = customFieldEditor.c;
					var editorState = $author$project$Location$Details$CustomFieldEditor$CustomFieldObject(
						A2($author$project$Location$Details$PopupContent$CustomFieldObject$init, value, customDataDefinition));
					return _Utils_Tuple2(
						A5($author$project$Location$Details$CustomFieldEditor$initModel, customFieldConfig, valueProperty, now, id, editorState),
						$elm$core$Platform$Cmd$none);
			}
		}();
		var customDataEditorState = _v0.a;
		var customDataEditorCmd = _v0.b;
		return _Utils_Tuple2(
			customDataEditorState,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						customDataEditorCmd,
						A2($author$project$Location$Details$CustomFieldEditor$isNotSetRowCmd, customFieldEditor, now)
					])));
	});
var $author$project$Location$ImageEditor$Closed = {$: 'Closed'};
var $author$project$Location$ImageEditor$encodeUpdate = F3(
	function (target, locations, media) {
		var _v0 = function () {
			switch (target.$) {
				case 'GoogleLogo':
					return _Utils_Tuple2('google', 'profileImage');
				case 'GoogleCover':
					return _Utils_Tuple2('google', 'coverImage');
				case 'FacebookProfile':
					return _Utils_Tuple2('facebook', 'profileImage');
				default:
					return _Utils_Tuple2('facebook', 'coverImage');
			}
		}();
		var networkKey = _v0.a;
		var fieldKey = _v0.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'locations',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
					_Utils_Tuple2(
					'updateData',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'networkMedia',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											networkKey,
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														fieldKey,
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'mediaRef',
																	$elm$json$Json$Encode$string(media.id)),
																	_Utils_Tuple2(
																	'url',
																	$elm$json$Json$Encode$string(media.url)),
																	_Utils_Tuple2(
																	'previewUrl',
																	$elm$json$Json$Encode$string(media.previewUrl)),
																	_Utils_Tuple2(
																	'setType',
																	$elm$json$Json$Encode$string('location'))
																])))
													])))
										])))
							])))
				]));
	});
var $author$project$Location$ImageEditor$SaveRequested = function (a) {
	return {$: 'SaveRequested', a: a};
};
var $author$project$Location$ImageEditor$ChoosingLocations = function (a) {
	return {$: 'ChoosingLocations', a: a};
};
var $author$project$Location$ImageEditor$OnLocationsSelected = function (a) {
	return {$: 'OnLocationsSelected', a: a};
};
var $author$project$Location$ImageEditor$update = F3(
	function (config, msg, _v0) {
		var state = _v0.a;
		switch (msg.$) {
			case 'EditorMsg':
				var editorMsg = msg.a;
				var _v2 = A3($author$project$Common$Image$Editor$update, config, editorMsg, state.editor);
				var editor = _v2.a;
				var cmd = _v2.b;
				var event = _v2.c;
				var newState = function () {
					if ((event.$ === 'Just') && (event.a.$ === 'Confirmed')) {
						var media = event.a.a;
						return _Utils_update(
							state,
							{
								stage: $author$project$Location$ImageEditor$ChoosingLocations(media),
								editor: editor
							});
					} else {
						return _Utils_update(
							state,
							{editor: editor});
					}
				}();
				return _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(newState),
					A2($elm$core$Platform$Cmd$map, $author$project$Location$ImageEditor$EditorMsg, cmd),
					function () {
						if ((event.$ === 'Just') && (event.a.$ === 'Cancelled')) {
							var _v4 = event.a;
							return $elm$core$Maybe$Just($author$project$Location$ImageEditor$Closed);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}());
			case 'LocationSelectorMsg':
				var selectorMsg = msg.a;
				var _v6 = A3(
					$author$project$PinMeTo$Ui$SelectorLocationWithFilters$update,
					{
						api: $author$project$PinMeTo$Api$SelectorApi$filteredLocationApi(
							{
								realm: $author$project$PinMeTo$Api$SelectorApi$Places,
								network: $author$project$PinMeTo$Api$SelectorApi$All,
								siteName: $author$project$Data$SiteName$toString(state.siteName)
							}),
						tagger: $author$project$Location$ImageEditor$LocationSelectorMsg,
						onChange: $author$project$Location$ImageEditor$OnLocationsSelected
					},
					selectorMsg,
					state.locationSelector);
				var locationSelector = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(
						_Utils_update(
							state,
							{locationSelector: locationSelector})),
					cmd,
					$elm$core$Maybe$Nothing);
			case 'OnLocationsSelected':
				var locationIds = msg.a;
				return _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(
						_Utils_update(
							state,
							{selectedLocations: locationIds})),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 'OnSave':
				return (state.saving || $elm$core$List$isEmpty(state.selectedLocations)) ? _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(state),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(
						_Utils_update(
							state,
							{confirming: true})),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 'OnCancelConfirm':
				return _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(
						_Utils_update(
							state,
							{confirming: false})),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 'OnConfirmSave':
				var _v7 = _Utils_Tuple3(state.stage, state.saving, state.selectedLocations);
				if (((_v7.a.$ === 'ChoosingLocations') && (!_v7.b)) && _v7.c.b) {
					var media = _v7.a.a;
					var _v8 = _v7.c;
					return _Utils_Tuple3(
						$author$project$Location$ImageEditor$State(
							_Utils_update(
								state,
								{confirming: false})),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Location$ImageEditor$SaveRequested(
								{
									body: A3($author$project$Location$ImageEditor$encodeUpdate, state.target, state.selectedLocations, media),
									locations: state.selectedLocations
								})));
				} else {
					return _Utils_Tuple3(
						$author$project$Location$ImageEditor$State(state),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				}
			default:
				return state.saving ? _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(state),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					$author$project$Location$ImageEditor$State(state),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just($author$project$Location$ImageEditor$Closed));
		}
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$encode = F2(
	function (customFieldKey, list) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					customFieldKey,
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, list))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$encodeObject = function (list) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (attribute) {
				var getAttributeKey = function (metaValue) {
					var _v8 = metaValue.name;
					var val = _v8.a;
					return val;
				};
				switch (attribute.$) {
					case 'StringProperty':
						var _v1 = attribute.a;
						var value = _v1.a;
						var meta = _v1.b;
						return _Utils_Tuple2(
							getAttributeKey(meta),
							$elm$json$Json$Encode$string(value));
					case 'BooleanProperty':
						var _v2 = attribute.a;
						var value = _v2.a;
						var meta = _v2.b;
						return _Utils_Tuple2(
							getAttributeKey(meta),
							$elm$json$Json$Encode$bool(value));
					case 'ListProperty':
						var _v3 = attribute.a;
						var value = _v3.a;
						var meta = _v3.b;
						return _Utils_Tuple2(
							getAttributeKey(meta),
							A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								$author$project$Location$Details$PopupContent$CustomFieldList$getStringList(value)));
					case 'ObjectProperty':
						var _v4 = attribute.a;
						var meta = _v4.b;
						return _Utils_Tuple2(
							getAttributeKey(meta),
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										getAttributeKey(meta),
										$author$project$Location$Details$PopupContent$CustomFieldObject$encodeObject(list))
									])));
					case 'OpenHoursProperty':
						var _v5 = attribute.a;
						var value = _v5.a;
						var meta = _v5.b;
						var open24h = $author$project$Data$Location$OpenHours$Open(
							_List_fromArray(
								[
									{open: '0000', close: '2400'}
								]));
						var days = function () {
							if (value.$ === 'Always') {
								return {fri: open24h, mon: open24h, sat: open24h, sun: open24h, thu: open24h, tue: open24h, wed: open24h};
							} else {
								var someDays = value.a;
								return someDays;
							}
						}();
						return _Utils_Tuple2(
							getAttributeKey(meta),
							$author$project$Data$Location$OpenHours$encodeDays(days));
					default:
						var _v7 = attribute.a;
						var meta = _v7.b;
						return _Utils_Tuple2(
							getAttributeKey(meta),
							$elm$json$Json$Encode$null);
				}
			},
			list));
};
var $author$project$Location$Details$PopupContent$CustomFieldObject$encode = F2(
	function (customFieldKey, model) {
		var getPropertyMeta = function (prop) {
			switch (prop.$) {
				case 'StringProperty':
					var _v3 = prop.a;
					var propMeta = _v3.b;
					return propMeta;
				case 'BooleanProperty':
					var _v4 = prop.a;
					var propMeta = _v4.b;
					return propMeta;
				case 'ListProperty':
					var _v5 = prop.a;
					var propMeta = _v5.b;
					return propMeta;
				case 'OpenHoursProperty':
					var _v6 = prop.a;
					var propMeta = _v6.b;
					return propMeta;
				case 'SpecialOpenHoursProperty':
					var _v7 = prop.a;
					var propMeta = _v7.b;
					return propMeta;
				default:
					var _v8 = prop.a;
					var propMeta = _v8.b;
					return propMeta;
			}
		};
		var list = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var element = _v0.b;
					switch (element.$) {
						case 'StringAttribute':
							var prop = element.a;
							var fieldModel = element.b;
							return $elm$core$Maybe$Just(
								$author$project$Data$Location$CustomData$StringProperty(
									_Utils_Tuple2(
										fieldModel.value,
										getPropertyMeta(prop))));
						case 'BooleanAttribute':
							var prop = element.a;
							var fieldModel = element.b;
							return $elm$core$Maybe$Just(
								$author$project$Data$Location$CustomData$BooleanProperty(
									_Utils_Tuple2(
										fieldModel.value,
										getPropertyMeta(prop))));
						case 'ListAttribute':
							var prop = element.a;
							var fieldModel = element.b;
							return $elm$core$Maybe$Just(
								$author$project$Data$Location$CustomData$ListProperty(
									_Utils_Tuple2(
										$author$project$Location$Details$PopupContent$CustomFieldList$getPropertyList(fieldModel),
										getPropertyMeta(prop))));
						default:
							return $elm$core$Maybe$Nothing;
					}
				},
				$elm$core$Dict$toList(model.attributes)));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					customFieldKey,
					$author$project$Location$Details$PopupContent$CustomFieldObject$encodeObject(list))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldString$encode = F2(
	function (customFieldKey, value) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					customFieldKey,
					$elm$json$Json$Encode$string(value))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldBoolean$encode = F2(
	function (customFieldKey, status) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					customFieldKey,
					$elm$json$Json$Encode$bool(status))
				]));
	});
var $author$project$Location$Details$PopupContent$CustomFieldList$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnAddItem':
				return _Utils_update(
					model,
					{
						list: A2(
							$elm$core$List$append,
							model.list,
							$elm$core$List$singleton(model.currentText)),
						currentText: ''
					});
			case 'OnDeleteItem':
				var index = msg.a;
				return _Utils_update(
					model,
					{
						list: A2(
							$elm$core$List$append,
							A2($elm$core$List$take, index, model.list),
							A2($elm$core$List$drop, index + 1, model.list))
					});
			default:
				var newText = msg.a;
				return _Utils_update(
					model,
					{currentText: newText});
		}
	});
var $author$project$Location$Details$PopupContent$CustomFieldString$update = F2(
	function (msg, model) {
		var newText = msg.a;
		var valid = A2($author$project$Location$Details$PopupContent$CustomFieldString$validateInput, model.rules, newText);
		return _Utils_update(
			model,
			{value: newText, isValid: valid});
	});
var $author$project$Location$Details$PopupContent$CustomFieldBoolean$update = F2(
	function (msg, model) {
		var status = msg.a;
		return _Utils_update(
			model,
			{value: status});
	});
var $author$project$Location$Details$PopupContent$CustomFieldObject$update = F2(
	function (msg, model) {
		var getUpdatedModel = F2(
			function (itemIndex, getUpdatedFunction) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					model,
					function (_v7) {
						return _Utils_update(
							model,
							{
								attributes: A3($elm$core$Dict$update, itemIndex, getUpdatedFunction, model.attributes)
							});
					},
					A2($elm$core$Dict$get, itemIndex, model.attributes));
			});
		switch (msg.$) {
			case 'CustomFieldStringMsg':
				var itemIndex = msg.a;
				var msg_ = msg.b;
				var getUpdatedAttribute = function (attribute) {
					if ((attribute.$ === 'Just') && (attribute.a.$ === 'StringAttribute')) {
						var _v2 = attribute.a;
						var prop = _v2.a;
						var attributeModel = _v2.b;
						var updatedAttributeModel = A2($author$project$Location$Details$PopupContent$CustomFieldString$update, msg_, attributeModel);
						return $elm$core$Maybe$Just(
							A2($author$project$Location$Details$PopupContent$CustomFieldObject$StringAttribute, prop, updatedAttributeModel));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				};
				return A2(getUpdatedModel, itemIndex, getUpdatedAttribute);
			case 'CustomFieldBooleanMsg':
				var itemIndex = msg.a;
				var msg_ = msg.b;
				var getUpdatedAttribute = function (attribute) {
					if ((attribute.$ === 'Just') && (attribute.a.$ === 'BooleanAttribute')) {
						var _v4 = attribute.a;
						var prop = _v4.a;
						var attributeModel = _v4.b;
						var updatedAttributeModel = A2($author$project$Location$Details$PopupContent$CustomFieldBoolean$update, msg_, attributeModel);
						return $elm$core$Maybe$Just(
							A2($author$project$Location$Details$PopupContent$CustomFieldObject$BooleanAttribute, prop, updatedAttributeModel));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				};
				return A2(getUpdatedModel, itemIndex, getUpdatedAttribute);
			default:
				var itemIndex = msg.a;
				var msg_ = msg.b;
				var getUpdatedAttribute = function (attribute) {
					if ((attribute.$ === 'Just') && (attribute.a.$ === 'ListAttribute')) {
						var _v6 = attribute.a;
						var prop = _v6.a;
						var attributeModel = _v6.b;
						var updatedAttributeModel = A2($author$project$Location$Details$PopupContent$CustomFieldList$update, msg_, attributeModel);
						return $elm$core$Maybe$Just(
							A2($author$project$Location$Details$PopupContent$CustomFieldObject$ListAttribute, prop, updatedAttributeModel));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				};
				return A2(getUpdatedModel, itemIndex, getUpdatedAttribute);
		}
	});
var $author$project$Location$Details$CustomFieldEditor$Unknown = function (a) {
	return {$: 'Unknown', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$OnUpdated = function (a) {
	return {$: 'OnUpdated', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$OnScheduled = function (a) {
	return {$: 'OnScheduled', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$dateToPosix = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		{
			day: $justinmimbs$date$Date$day(date),
			hour: 0,
			year: $justinmimbs$date$Date$year(date),
			month: $justinmimbs$date$Date$month(date),
			minute: 0,
			second: 0,
			millisecond: 0
		});
};
var $author$project$Location$Details$CustomFieldEditor$OnDeleteSchedule = function (a) {
	return {$: 'OnDeleteSchedule', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$OnSelectLocations = function (a) {
	return {$: 'OnSelectLocations', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$PartialUpdateFailed = function (a) {
	return {$: 'PartialUpdateFailed', a: a};
};
var $author$project$Location$Details$CustomFieldEditor$ScheduleUpdateFailed = {$: 'ScheduleUpdateFailed'};
var $author$project$Location$Details$CustomFieldEditor$customFieldEditorStateToHumanReadable = F2(
	function (customFieldEditorState, translations) {
		switch (customFieldEditorState.$) {
			case 'CustomFieldOpenHours':
				return $author$project$Translations$General$locationOpenHours(translations);
			case 'CustomFieldSpecialOpenHours':
				return $author$project$Translations$General$locationSpecialHours(translations);
			case 'CustomFieldBoolean':
				return $author$project$Translations$Listings$LocationDetail$customField(translations);
			case 'CustomFieldString':
				return $author$project$Translations$Listings$LocationDetail$customField(translations);
			case 'CustomFieldList':
				return $author$project$Translations$Listings$LocationDetail$customField(translations);
			default:
				return $author$project$Translations$Listings$LocationDetail$customField(translations);
		}
	});
var $author$project$Location$Details$CustomFieldEditor$update = F4(
	function (config, session, msg, _v0) {
		var model = _v0.a;
		var locationId = model.locationId;
		switch (msg.$) {
			case 'UiSelectorLocationWithFiltersMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return $author$project$Location$Details$CustomFieldEditor$State(
							_Utils_update(
								model,
								{locationSelector: x}));
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorLocationWithFilters$update,
						{
							api: $author$project$PinMeTo$Api$SelectorApi$filteredLocationApi(
								{
									realm: $author$project$PinMeTo$Api$SelectorApi$Places,
									network: $author$project$PinMeTo$Api$SelectorApi$All,
									siteName: function (_v2) {
										var siteName = _v2.a;
										return siteName;
									}(config.siteName)
								}),
							tagger: A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$UiSelectorLocationWithFiltersMsg, config.tagger),
							onChange: A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$OnSelectLocations, config.tagger)
						},
						msg_,
						model.locationSelector));
			case 'OnSelectLocations':
				var locationIds = msg.a;
				return _Utils_Tuple2(
					$author$project$Location$Details$CustomFieldEditor$State(
						_Utils_update(
							model,
							{selectedLocations: locationIds})),
					$elm$core$Platform$Cmd$none);
			case 'OnSelectSchedulingDate':
				var newDate = msg.a;
				return _Utils_Tuple2(
					$author$project$Location$Details$CustomFieldEditor$State(
						_Utils_update(
							model,
							{
								selectedDate: $elm$core$Maybe$Just(newDate)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnRemoveSchedulingDate':
				return _Utils_Tuple2(
					$author$project$Location$Details$CustomFieldEditor$State(
						_Utils_update(
							model,
							{selectedDate: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'ConfirmCancel':
				return _Utils_Tuple2(
					$author$project$Location$Details$CustomFieldEditor$State(
						_Utils_update(
							model,
							{confirm: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmit':
				return _Utils_Tuple2(
					$author$project$Location$Details$CustomFieldEditor$State(
						_Utils_update(
							model,
							{
								confirm: function () {
									var _v3 = model.content;
									if (_v3.$ === 'CustomFieldEditor') {
										var state = _v3.a;
										if (!_Utils_eq(model.selectedDate, $elm$core$Maybe$Nothing)) {
											var posixDate = A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												model.now,
												function (date) {
													return $author$project$Location$Details$CustomFieldEditor$dateToPosix(date);
												},
												model.selectedDate);
											return $elm$core$Maybe$Just(
												A3(
													$author$project$Location$Details$Editor$Confirm$ConfirmedScheduleSelectedLocations,
													model.selectedLocations,
													posixDate,
													A2($author$project$Location$Details$CustomFieldEditor$customFieldEditorStateToHumanReadable, state, session.translations)));
										} else {
											return $elm$core$Maybe$Just(
												$author$project$Location$Details$Editor$Confirm$ConfirmedUpdateSelectedLocations(model.selectedLocations));
										}
									} else {
										var scheduledUpdate = _v3.a;
										return $elm$core$Maybe$Just(
											A2($author$project$Location$Details$Editor$Confirm$ConfirmedDeleteScheduleSelectedLocations, model.selectedLocations, scheduledUpdate.date));
									}
								}()
							})),
					$elm$core$Platform$Cmd$none);
			case 'ConfirmedUpdate':
				switch (msg.a.$) {
					case 'ConfirmedScheduleSelectedLocations':
						var _v4 = msg.a;
						var locations = _v4.a;
						var scheduleDate = _v4.b;
						var wrapScheduling = F3(
							function (fieldName, stringDate, updateData) {
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'locations',
											A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
											_Utils_Tuple2('updateData', updateData),
											_Utils_Tuple2(
											'fieldToUpdate',
											$elm$json$Json$Encode$string(fieldName)),
											_Utils_Tuple2(
											'date',
											$elm$json$Json$Encode$string(stringDate))
										]));
							});
						var formatDate = function (posix) {
							return A2(
								$elm$core$String$left,
								10,
								$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(posix));
						};
						return _Utils_Tuple2(
							$author$project$Location$Details$CustomFieldEditor$State(
								_Utils_update(
									model,
									{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: true})),
							function () {
								var _v5 = model.content;
								_v5$5:
								while (true) {
									if (_v5.$ === 'CustomFieldEditor') {
										switch (_v5.a.$) {
											case 'CustomFieldOpenHours':
												var customFieldEditorModel = _v5.a.a;
												var _v6 = model.currentConfig.meta.name;
												var customName = _v6.a;
												var open24h = $author$project$Data$Location$OpenHours$Open(
													_List_fromArray(
														[
															{open: '0000', close: '2400'}
														]));
												var days = function () {
													var _v7 = customFieldEditorModel.openHours;
													if (_v7.$ === 'Always') {
														return {fri: open24h, mon: open24h, sat: open24h, sun: open24h, thu: open24h, tue: open24h, wed: open24h};
													} else {
														var duringDays = _v7.a;
														return duringDays;
													}
												}();
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$CustomFieldEditor$OnScheduled,
														A3(
															wrapScheduling,
															'customData.openHours#' + customName,
															formatDate(scheduleDate),
															$elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'customData',
																		$elm$json$Json$Encode$object(
																			_List_fromArray(
																				[
																					_Utils_Tuple2(
																					customName,
																					$author$project$Data$Location$OpenHours$encodeDays(days))
																				])))
																	])))));
											case 'CustomFieldString':
												var customFieldEditorModel = _v5.a.a;
												var _v8 = model.currentConfig.meta.name;
												var customName = _v8.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$CustomFieldEditor$OnScheduled,
														A3(
															wrapScheduling,
															'customData.string#' + customName,
															formatDate(scheduleDate),
															$elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'customData',
																		$elm$json$Json$Encode$object(
																			_List_fromArray(
																				[
																					_Utils_Tuple2(
																					customName,
																					$elm$json$Json$Encode$string(customFieldEditorModel.value))
																				])))
																	])))));
											case 'CustomFieldBoolean':
												var customFieldEditorModel = _v5.a.a;
												var _v9 = model.currentConfig.meta.name;
												var customName = _v9.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$CustomFieldEditor$OnScheduled,
														A3(
															wrapScheduling,
															'customData.bool#' + customName,
															formatDate(scheduleDate),
															$elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'customData',
																		$elm$json$Json$Encode$object(
																			_List_fromArray(
																				[
																					_Utils_Tuple2(
																					customName,
																					$elm$json$Json$Encode$bool(customFieldEditorModel.value))
																				])))
																	])))));
											case 'CustomFieldList':
												var customFieldEditorModel = _v5.a.a;
												var _v10 = model.currentConfig.meta.name;
												var customName = _v10.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$CustomFieldEditor$OnScheduled,
														A3(
															wrapScheduling,
															'customData.list#' + customName,
															formatDate(scheduleDate),
															$elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'customData',
																		$elm$json$Json$Encode$object(
																			_List_fromArray(
																				[
																					_Utils_Tuple2(
																					customName,
																					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, customFieldEditorModel.list))
																				])))
																	])))));
											case 'CustomFieldObject':
												var customFieldEditorModel = _v5.a.a;
												var _v11 = model.currentConfig.meta.name;
												var customName = _v11.a;
												return A2(
													$elm$core$Platform$Cmd$map,
													config.tagger,
													A2(
														config.scheduleCommand,
														$author$project$Location$Details$CustomFieldEditor$OnScheduled,
														A3(
															wrapScheduling,
															'customData.object#' + customName,
															formatDate(scheduleDate),
															$elm$json$Json$Encode$object(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		'customData',
																		A2($author$project$Location$Details$PopupContent$CustomFieldObject$encode, customName, customFieldEditorModel))
																	])))));
											default:
												break _v5$5;
										}
									} else {
										break _v5$5;
									}
								}
								return $elm$core$Platform$Cmd$none;
							}());
					case 'ConfirmedDeleteScheduleSelectedLocations':
						var _v12 = msg.a;
						return _Utils_Tuple2(
							$author$project$Location$Details$CustomFieldEditor$State(
								_Utils_update(
									model,
									{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing})),
							function () {
								var _v13 = model.content;
								if (_v13.$ === 'ScheduledUpdate') {
									var scheduleId = _v13.a.scheduleId;
									return A2(
										$elm$core$Platform$Cmd$map,
										config.tagger,
										A2(config.deleteCommand, scheduleId, $author$project$Location$Details$CustomFieldEditor$OnDeleteSchedule));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					default:
						var locations = msg.a.a;
						return _Utils_Tuple2(
							$author$project$Location$Details$CustomFieldEditor$State(
								_Utils_update(
									model,
									{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: true})),
							function () {
								var wrap = function (updateData) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'locations',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
												_Utils_Tuple2('updateData', updateData)
											]));
								};
								var _v14 = model.content;
								if (_v14.$ === 'ScheduledUpdate') {
									return $elm$core$Platform$Cmd$none;
								} else {
									var customFieldEditor = _v14.a;
									var customName = function (_v17) {
										var name = _v17.a;
										return name;
									}(model.currentConfig.meta.name);
									switch (customFieldEditor.$) {
										case 'CustomFieldOpenHours':
											var customFieldEditorModel = customFieldEditor.a;
											var open24h = $author$project$Data$Location$OpenHours$Open(
												_List_fromArray(
													[
														{open: '0000', close: '2400'}
													]));
											var days = function () {
												var _v16 = customFieldEditorModel.openHours;
												if (_v16.$ === 'Always') {
													return {fri: open24h, mon: open24h, sat: open24h, sun: open24h, thu: open24h, tue: open24h, wed: open24h};
												} else {
													var duringDays = _v16.a;
													return duringDays;
												}
											}();
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$CustomFieldEditor$OnUpdated,
													wrap(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'customData',
																	$elm$json$Json$Encode$object(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				customName,
																				$author$project$Data$Location$OpenHours$encodeDays(days))
																			])))
																])))));
										case 'CustomFieldSpecialOpenHours':
											var customFieldEditorModel = customFieldEditor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$CustomFieldEditor$OnUpdated,
													wrap(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'customData',
																	$elm$json$Json$Encode$object(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				customName,
																				A2(
																					$elm$json$Json$Encode$list,
																					$author$project$Data$Location$SpecialOpenHours$encode,
																					A2(
																						$elm$core$List$sortBy,
																						function (record) {
																							return $elm$time$Time$posixToMillis(record.startDate);
																						},
																						$author$project$Location$Details$PopupContent$SpecialOpenHours$currentHoursList(customFieldEditorModel))))
																			])))
																])))));
										case 'CustomFieldBoolean':
											var customFieldEditorModel = customFieldEditor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$CustomFieldEditor$OnUpdated,
													wrap(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'customData',
																	A2($author$project$Location$Details$PopupContent$CustomFieldBoolean$encode, customName, customFieldEditorModel.value))
																])))));
										case 'CustomFieldString':
											var customFieldEditorModel = customFieldEditor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$CustomFieldEditor$OnUpdated,
													wrap(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'customData',
																	A2($author$project$Location$Details$PopupContent$CustomFieldString$encode, customName, customFieldEditorModel.value))
																])))));
										case 'CustomFieldList':
											var customFieldEditorModel = customFieldEditor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$CustomFieldEditor$OnUpdated,
													wrap(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'customData',
																	A2($author$project$Location$Details$PopupContent$CustomFieldList$encode, customName, customFieldEditorModel.list))
																])))));
										default:
											var customFieldEditorModel = customFieldEditor.a;
											return A2(
												$elm$core$Platform$Cmd$map,
												config.tagger,
												A2(
													config.updateCommand,
													$author$project$Location$Details$CustomFieldEditor$OnUpdated,
													wrap(
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'customData',
																	A2($author$project$Location$Details$PopupContent$CustomFieldObject$encode, customName, customFieldEditorModel))
																])))));
									}
								}
							}());
				}
			case 'OnUpdated':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var partialUpdate = result.a;
					return _Utils_Tuple2(
						$author$project$Location$Details$CustomFieldEditor$State(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: false})),
						A2(
							$elm$core$Task$perform,
							config.onUpdated,
							$elm$core$Task$succeed(partialUpdate.location)));
				} else {
					var error = result.a;
					var _v19 = model.content;
					if (_v19.$ === 'CustomFieldEditor') {
						return _Utils_Tuple2(
							$author$project$Location$Details$CustomFieldEditor$State(
								_Utils_update(
									model,
									{
										error: $elm$core$Maybe$Just(
											$author$project$Location$Details$CustomFieldEditor$PartialUpdateFailed(
												$author$project$Location$Details$CustomFieldEditor$Unknown(
													$author$project$PinMeTo$ExpectJson$getErrorMessage(error)))),
										confirm: $elm$core$Maybe$Nothing,
										showSavingProgress: false
									})),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.CustomFieldEditor'),
								error));
					} else {
						return _Utils_Tuple2(
							$author$project$Location$Details$CustomFieldEditor$State(
								_Utils_update(
									model,
									{
										error: $elm$core$Maybe$Just(
											$author$project$Location$Details$CustomFieldEditor$PartialUpdateFailed(
												$author$project$Location$Details$CustomFieldEditor$Unknown(
													$author$project$PinMeTo$ExpectJson$getErrorMessage(error)))),
										confirm: $elm$core$Maybe$Nothing,
										showSavingProgress: false
									})),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.CustomFieldEditor'),
								error));
					}
				}
			case 'CustomFieldEditorMsg':
				var customFieldEditorMsg = msg.a;
				var _v20 = model.content;
				if (_v20.$ === 'ScheduledUpdate') {
					return _Utils_Tuple2(
						$author$project$Location$Details$CustomFieldEditor$State(model),
						$elm$core$Platform$Cmd$none);
				} else {
					var customFieldEditor = _v20.a;
					switch (customFieldEditorMsg.$) {
						case 'CustomFieldOpenHoursMsg':
							var msg_ = customFieldEditorMsg.a;
							if (customFieldEditor.$ === 'CustomFieldOpenHours') {
								var customFieldEditorModel = customFieldEditor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (x) {
										return $author$project$Location$Details$CustomFieldEditor$State(
											_Utils_update(
												model,
												{
													content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(
														$author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHours(x))
												}));
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$CustomFieldEditor$CustomFieldOpenHoursMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$OpenHours$update, msg_, customFieldEditorModel));
							} else {
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(model),
									$elm$core$Platform$Cmd$none);
							}
						case 'CustomFieldSpecialOpenHoursMsg':
							var msg_ = customFieldEditorMsg.a;
							if (customFieldEditor.$ === 'CustomFieldSpecialOpenHours') {
								var customFieldEditorModel = customFieldEditor.a;
								return A3(
									$elm$core$Tuple$mapBoth,
									function (x) {
										return $author$project$Location$Details$CustomFieldEditor$State(
											_Utils_update(
												model,
												{
													content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(
														$author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHours(x))
												}));
									},
									$elm$core$Platform$Cmd$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Location$Details$CustomFieldEditor$CustomFieldSpecialOpenHoursMsg,
											A2($elm$core$Basics$composeR, $author$project$Location$Details$CustomFieldEditor$CustomFieldEditorMsg, config.tagger))),
									A2($author$project$Location$Details$PopupContent$SpecialOpenHours$update, msg_, customFieldEditorModel));
							} else {
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(model),
									$elm$core$Platform$Cmd$none);
							}
						case 'CustomFieldBooleanMsg':
							var msg_ = customFieldEditorMsg.a;
							if (customFieldEditor.$ === 'CustomFieldBoolean') {
								var customFieldEditorModel = customFieldEditor.a;
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(
										_Utils_update(
											model,
											{
												content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(
													$author$project$Location$Details$CustomFieldEditor$CustomFieldBoolean(
														A2($author$project$Location$Details$PopupContent$CustomFieldBoolean$update, msg_, customFieldEditorModel)))
											})),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(model),
									$elm$core$Platform$Cmd$none);
							}
						case 'CustomFieldStringMsg':
							var msg_ = customFieldEditorMsg.a;
							if (customFieldEditor.$ === 'CustomFieldString') {
								var customFieldEditorModel = customFieldEditor.a;
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(
										_Utils_update(
											model,
											{
												content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(
													$author$project$Location$Details$CustomFieldEditor$CustomFieldString(
														A2($author$project$Location$Details$PopupContent$CustomFieldString$update, msg_, customFieldEditorModel)))
											})),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(model),
									$elm$core$Platform$Cmd$none);
							}
						case 'CustomFieldListMsg':
							var msg_ = customFieldEditorMsg.a;
							if (customFieldEditor.$ === 'CustomFieldList') {
								var customFieldEditorModel = customFieldEditor.a;
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(
										_Utils_update(
											model,
											{
												content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(
													$author$project$Location$Details$CustomFieldEditor$CustomFieldList(
														A2($author$project$Location$Details$PopupContent$CustomFieldList$update, msg_, customFieldEditorModel)))
											})),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(model),
									$elm$core$Platform$Cmd$none);
							}
						default:
							var msg_ = customFieldEditorMsg.a;
							if (customFieldEditor.$ === 'CustomFieldObject') {
								var customFieldEditorModel = customFieldEditor.a;
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(
										_Utils_update(
											model,
											{
												content: $author$project$Location$Details$CustomFieldEditor$CustomFieldEditor(
													$author$project$Location$Details$CustomFieldEditor$CustomFieldObject(
														A2($author$project$Location$Details$PopupContent$CustomFieldObject$update, msg_, customFieldEditorModel)))
											})),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(
									$author$project$Location$Details$CustomFieldEditor$State(model),
									$elm$core$Platform$Cmd$none);
							}
					}
				}
			case 'OnScheduled':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var data = result.a;
					return _Utils_Tuple2(
						$author$project$Location$Details$CustomFieldEditor$State(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing, showSavingProgress: false})),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							function (onScheduled) {
								return A2(
									$elm$core$Task$perform,
									onScheduled,
									$elm$core$Task$succeed(data));
							},
							config.onScheduled));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$author$project$Location$Details$CustomFieldEditor$State(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just($author$project$Location$Details$CustomFieldEditor$ScheduleUpdateFailed)
								})),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.CustomFieldEditor'),
							error));
				}
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					var data = result.a;
					return _Utils_Tuple2(
						$author$project$Location$Details$CustomFieldEditor$State(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, confirm: $elm$core$Maybe$Nothing})),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							function (onDeleteSchedule) {
								return A2(
									$elm$core$Task$perform,
									onDeleteSchedule,
									$elm$core$Task$succeed(data));
							},
							config.onDeleteSchedule));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$author$project$Location$Details$CustomFieldEditor$State(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just($author$project$Location$Details$CustomFieldEditor$ScheduleUpdateFailed)
								})),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.CustomFieldEditor'),
							error));
				}
		}
	});
var $author$project$Location$Details$DevNetworkActions$Model$defaultAction = function (network) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		$author$project$Location$Details$DevNetworkActions$Model$isActionEnabled(network),
		$author$project$Location$Details$DevNetworkActions$Model$actionsFor(network));
};
var $author$project$Location$Details$DevNetworkActions$Model$init = {
	isOpen: false,
	status: $author$project$RemoteData$Suspended,
	selectedAction: $author$project$Location$Details$DevNetworkActions$Model$defaultAction($author$project$Location$Details$DevNetworkActions$Model$Google),
	selectedNetwork: $elm$core$Maybe$Just($author$project$Location$Details$DevNetworkActions$Model$Google)
};
var $author$project$Location$Details$DevNetworkActions$Model$Failed = function (a) {
	return {$: 'Failed', a: a};
};
var $author$project$Location$Details$DevNetworkActions$Model$TimedOut = {$: 'TimedOut'};
var $author$project$Location$Details$DevNetworkActions$Model$Succeeded = {$: 'Succeeded'};
var $author$project$Location$Details$DevNetworkActions$Api$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		switch (status) {
			case 'queued':
				return $elm$json$Json$Decode$succeed($author$project$Location$Details$DevNetworkActions$Model$Queued);
			case 'succeeded':
				return $elm$json$Json$Decode$succeed($author$project$Location$Details$DevNetworkActions$Model$Succeeded);
			case 'timedOut':
				return $elm$json$Json$Decode$succeed($author$project$Location$Details$DevNetworkActions$Model$TimedOut);
			case 'failed':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Location$Details$DevNetworkActions$Model$Failed,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed('Unknown error')
							])));
			default:
				var other = status;
				return $elm$json$Json$Decode$fail('Unknown status: ' + other);
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $author$project$Location$Details$DevNetworkActions$Model$StatusResponse = function (a) {
	return {$: 'StatusResponse', a: a};
};
var $author$project$Location$Details$DevNetworkActions$Api$getStatus = F3(
	function (context, network, action) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, $author$project$Location$Details$DevNetworkActions$Model$StatusResponse, $author$project$Location$Details$DevNetworkActions$Api$statusDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(
						$author$project$Location$Details$DevNetworkActions$Api$baseUrl(context) + ('/status' + A2($author$project$Location$Details$DevNetworkActions$Api$queryString, network, action))))));
	});
var $author$project$Location$Details$DevNetworkActions$Model$PollTick = {$: 'PollTick'};
var $author$project$Location$Details$DevNetworkActions$Update$pollIntervalMs = 2000;
var $author$project$Location$Details$DevNetworkActions$Update$schedulePoll = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Location$Details$DevNetworkActions$Model$PollTick;
	},
	$elm$core$Process$sleep($author$project$Location$Details$DevNetworkActions$Update$pollIntervalMs));
var $author$project$Location$Details$DevNetworkActions$Model$Triggered = function (a) {
	return {$: 'Triggered', a: a};
};
var $author$project$Location$Details$DevNetworkActions$Api$triggerAction = F3(
	function (context, network, action) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					$author$project$Location$Details$DevNetworkActions$Model$Triggered,
					$elm$json$Json$Decode$succeed(_Utils_Tuple0),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'network',
								$elm$json$Json$Encode$string(
									$author$project$Location$Details$DevNetworkActions$Model$networkToApi(network))),
								_Utils_Tuple2(
								'action',
								$elm$json$Json$Encode$string(
									$author$project$Location$Details$DevNetworkActions$Model$actionToApi(action)))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(
							$author$project$Location$Details$DevNetworkActions$Api$baseUrl(context))))));
	});
var $author$project$Location$Details$DevNetworkActions$Update$update = F3(
	function (context, msg, model) {
		switch (msg.$) {
			case 'Open':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isOpen: true}),
					$elm$core$Platform$Cmd$none);
			case 'Close':
				return _Utils_Tuple2($author$project$Location$Details$DevNetworkActions$Model$init, $elm$core$Platform$Cmd$none);
			case 'SelectNetwork':
				var network = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedAction: $author$project$Location$Details$DevNetworkActions$Model$defaultAction(network),
							selectedNetwork: $elm$core$Maybe$Just(network)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectAction':
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedAction: $elm$core$Maybe$Just(action)
						}),
					$elm$core$Platform$Cmd$none);
			case 'Submit':
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (_v1) {
						var network = _v1.a;
						var action = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{status: $author$project$RemoteData$Loading}),
							A3($author$project$Location$Details$DevNetworkActions$Api$triggerAction, context, network, action));
					},
					$author$project$Location$Details$DevNetworkActions$Model$selectedSupported(model));
			case 'Triggered':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								status: $author$project$RemoteData$Loaded($author$project$Location$Details$DevNetworkActions$Model$Queued)
							}),
						$author$project$Location$Details$DevNetworkActions$Update$schedulePoll);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								status: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'PollTick':
				var _v2 = _Utils_Tuple2(
					model.status,
					$author$project$Location$Details$DevNetworkActions$Model$selectedSupported(model));
				if (((_v2.a.$ === 'Loaded') && (_v2.a.a.$ === 'Queued')) && (_v2.b.$ === 'Just')) {
					var _v3 = _v2.a.a;
					var _v4 = _v2.b.a;
					var network = _v4.a;
					var action = _v4.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Location$Details$DevNetworkActions$Api$getStatus, context, network, action));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.a.$ === 'Ok') {
					if (msg.a.a.$ === 'Queued') {
						var _v5 = msg.a.a;
						return _Utils_Tuple2(model, $author$project$Location$Details$DevNetworkActions$Update$schedulePoll);
					} else {
						var finished = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									status: $author$project$RemoteData$Loaded(finished)
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								status: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Location$Details$DevNetworkActions$update = $author$project$Location$Details$DevNetworkActions$Update$update;
var $author$project$Location$ImageEditor$withError = F2(
	function (error, _v0) {
		var state = _v0.a;
		return $author$project$Location$ImageEditor$State(
			_Utils_update(
				state,
				{
					error: $elm$core$Maybe$Just(error),
					saving: false,
					confirming: false
				}));
	});
var $author$project$Location$ImageEditor$withSaving = function (_v0) {
	var state = _v0.a;
	return $author$project$Location$ImageEditor$State(
		_Utils_update(
			state,
			{error: $elm$core$Maybe$Nothing, saving: true}));
};
var $author$project$Location$Details$Model$EditorUpdated = function (a) {
	return {$: 'EditorUpdated', a: a};
};
var $author$project$Location$Details$Model$DeleteSchedule = function (a) {
	return {$: 'DeleteSchedule', a: a};
};
var $author$project$Location$Details$Model$ImageEditorSaved = function (a) {
	return {$: 'ImageEditorSaved', a: a};
};
var $author$project$Location$Details$Model$OnConflictStatus = function (a) {
	return {$: 'OnConflictStatus', a: a};
};
var $author$project$Location$Details$Model$SchedulerUpdated = function (a) {
	return {$: 'SchedulerUpdated', a: a};
};
var $author$project$Location$Details$Model$Zip = F2(
	function (a, b) {
		return {$: 'Zip', a: a, b: b};
	});
var $author$project$Location$Details$Model$City = F2(
	function (a, b) {
		return {$: 'City', a: a, b: b};
	});
var $author$project$Location$Details$Model$Link = function (a) {
	return {$: 'Link', a: a};
};
var $author$project$Location$Details$Model$Name = F2(
	function (a, b) {
		return {$: 'Name', a: a, b: b};
	});
var $author$project$Location$Details$Model$Type = F2(
	function (a, b) {
		return {$: 'Type', a: a, b: b};
	});
var $author$project$Location$Details$Model$Email = F2(
	function (a, b) {
		return {$: 'Email', a: a, b: b};
	});
var $author$project$Location$Details$Model$Phone = F2(
	function (a, b) {
		return {$: 'Phone', a: a, b: b};
	});
var $author$project$Location$Details$Model$Street = F2(
	function (a, b) {
		return {$: 'Street', a: a, b: b};
	});
var $author$project$Location$Details$Model$Country = F2(
	function (a, b) {
		return {$: 'Country', a: a, b: b};
	});
var $author$project$Location$Details$Model$StoreId = F2(
	function (a, b) {
		return {$: 'StoreId', a: a, b: b};
	});
var $author$project$Location$Details$Model$District = F2(
	function (a, b) {
		return {$: 'District', a: a, b: b};
	});
var $author$project$Location$Details$Model$Homepage = F2(
	function (a, b) {
		return {$: 'Homepage', a: a, b: b};
	});
var $author$project$Location$Details$Model$Province = F2(
	function (a, b) {
		return {$: 'Province', a: a, b: b};
	});
var $author$project$Location$Details$Model$WifiSsId = F2(
	function (a, b) {
		return {$: 'WifiSsId', a: a, b: b};
	});
var $author$project$Location$Details$Model$OpenHours = F2(
	function (a, b) {
		return {$: 'OpenHours', a: a, b: b};
	});
var $author$project$Location$Details$Model$FacebookId = F2(
	function (a, b) {
		return {$: 'FacebookId', a: a, b: b};
	});
var $author$project$Location$Details$Model$Coordinates = F2(
	function (a, b) {
		return {$: 'Coordinates', a: a, b: b};
	});
var $author$project$Location$Details$Model$OpeningDate = F2(
	function (a, b) {
		return {$: 'OpeningDate', a: a, b: b};
	});
var $author$project$Location$Details$Model$AddressState = F2(
	function (a, b) {
		return {$: 'AddressState', a: a, b: b};
	});
var $author$project$Location$Details$Model$ServiceAreas = F2(
	function (a, b) {
		return {$: 'ServiceAreas', a: a, b: b};
	});
var $author$project$Location$Details$Model$PtvCustomName = F2(
	function (a, b) {
		return {$: 'PtvCustomName', a: a, b: b};
	});
var $author$project$Location$Details$Model$AppleCustomName = F2(
	function (a, b) {
		return {$: 'AppleCustomName', a: a, b: b};
	});
var $author$project$Location$Details$Model$LongDescription = F2(
	function (a, b) {
		return {$: 'LongDescription', a: a, b: b};
	});
var $author$project$Location$Details$Model$GoogleCoverImage = F2(
	function (a, b) {
		return {$: 'GoogleCoverImage', a: a, b: b};
	});
var $author$project$Location$Details$Model$GoogleCustomName = F2(
	function (a, b) {
		return {$: 'GoogleCustomName', a: a, b: b};
	});
var $author$project$Location$Details$Model$ShortDescription = F2(
	function (a, b) {
		return {$: 'ShortDescription', a: a, b: b};
	});
var $author$project$Location$Details$Model$SpecialOpenHours = F2(
	function (a, b) {
		return {$: 'SpecialOpenHours', a: a, b: b};
	});
var $author$project$Location$Details$Model$NetworkAttributes = F2(
	function (a, b) {
		return {$: 'NetworkAttributes', a: a, b: b};
	});
var $author$project$Location$Details$Model$PermanentlyClosed = F2(
	function (a, b) {
		return {$: 'PermanentlyClosed', a: a, b: b};
	});
var $author$project$Location$Details$Model$TemporarilyClosed = F2(
	function (a, b) {
		return {$: 'TemporarilyClosed', a: a, b: b};
	});
var $author$project$Location$Details$Model$FacebookCoverImage = F2(
	function (a, b) {
		return {$: 'FacebookCoverImage', a: a, b: b};
	});
var $author$project$Location$Details$Model$FacebookCustomName = F2(
	function (a, b) {
		return {$: 'FacebookCustomName', a: a, b: b};
	});
var $author$project$Location$Details$Model$GoogleProfileImage = F2(
	function (a, b) {
		return {$: 'GoogleProfileImage', a: a, b: b};
	});
var $author$project$Location$Details$Model$GoogleServiceItems = F2(
	function (a, b) {
		return {$: 'GoogleServiceItems', a: a, b: b};
	});
var $author$project$Location$Details$Model$LocationDescriptor = F2(
	function (a, b) {
		return {$: 'LocationDescriptor', a: a, b: b};
	});
var $author$project$Location$Details$Commands$fieldStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (work) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$json$Json$Decode$succeed($author$project$Listings$Ui$Row$NoConflict),
			function (work_) {
				return work_ ? $elm$json$Json$Decode$succeed($author$project$Listings$Ui$Row$Work) : A2(
					$elm$json$Json$Decode$andThen,
					function (diff) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$json$Json$Decode$succeed($author$project$Listings$Ui$Row$NoConflict),
							function (diff_) {
								return diff_ ? $elm$json$Json$Decode$succeed($author$project$Listings$Ui$Row$Conflict) : $elm$json$Json$Decode$succeed($author$project$Listings$Ui$Row$NoConflict);
							},
							diff);
					},
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'hasDiff', $elm$json$Json$Decode$bool)));
			},
			work);
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'work', $elm$json$Json$Decode$bool)));
var $author$project$Location$Details$Model$FacebookProfileImage = F2(
	function (a, b) {
		return {$: 'FacebookProfileImage', a: a, b: b};
	});
var $author$project$Location$Details$Model$BingNetworkCategories = F2(
	function (a, b) {
		return {$: 'BingNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$HereNetworkCategories = F2(
	function (a, b) {
		return {$: 'HereNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$TomtomNetworkCategory = F2(
	function (a, b) {
		return {$: 'TomtomNetworkCategory', a: a, b: b};
	});
var $author$project$Location$Details$Model$AppleNetworkCategories = F2(
	function (a, b) {
		return {$: 'AppleNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$GoogleNetworkCategories = F2(
	function (a, b) {
		return {$: 'GoogleNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$GoogleNetworkActionLinks = F2(
	function (a, b) {
		return {$: 'GoogleNetworkActionLinks', a: a, b: b};
	});
var $author$project$Location$Details$Model$TemporarilyClosedMessage = F2(
	function (a, b) {
		return {$: 'TemporarilyClosedMessage', a: a, b: b};
	});
var $author$project$Location$Details$Model$FacebookNetworkCategories = F2(
	function (a, b) {
		return {$: 'FacebookNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$OvertureNetworkCategories = F2(
	function (a, b) {
		return {$: 'OvertureNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$FoursquareNetworkCategories = F2(
	function (a, b) {
		return {$: 'FoursquareNetworkCategories', a: a, b: b};
	});
var $author$project$Location$Details$Model$LocationDataWithConflictStatus = function (id) {
	return function (isActive) {
		return function (alternativeSearchNames) {
			return function (verification) {
				return function (hasTransitionedToNewPageExperience) {
					return function (storeId) {
						return function (name) {
							return function (locationType) {
								return function (locationDescriptor) {
									return function (about) {
										return function (longDescription) {
											return function (openingDate) {
												return function (wifiSsId) {
													return function (location) {
														return function (street) {
															return function (zip) {
																return function (city) {
																	return function (state) {
																		return function (province) {
																			return function (district) {
																				return function (country) {
																					return function (serviceAreas) {
																						return function (phone) {
																							return function (homepage) {
																								return function (email) {
																									return function (openHours) {
																										return function (specialOpenHours) {
																											return function (temporarilyClosedUntil) {
																												return function (temporarilyClosedMessage) {
																													return function (permanentlyClosed) {
																														return function (googleCustomName) {
																															return function (googleProfileImage) {
																																return function (googleCoverImage) {
																																	return function (newGoogleReviewLink) {
																																		return function (networkAttributes) {
																																			return function (googleNetworkCategories) {
																																				return function (googleNetworkActionLinks) {
																																					return function (googleServiceItems) {
																																						return function (facebookCustomName) {
																																							return function (facebookProfileImage) {
																																								return function (facebookCoverImage) {
																																									return function (facebookNetworkCategories) {
																																										return function (facebookId) {
																																											return function (appleNetworkCategories) {
																																												return function (appleCustomName) {
																																													return function (ptvCustomName) {
																																														return function (bingNetworkCategories) {
																																															return function (foursquareNetworkCategories) {
																																																return function (googleIdSetType) {
																																																	return function (facebookIdSetType) {
																																																		return function (bingIdSetType) {
																																																			return function (appleIdSetType) {
																																																				return function (ptvIdSetType) {
																																																					return function (customData) {
																																																						return function (overtureNetworkCategories) {
																																																							return function (hereNetworkCategories) {
																																																								return function (tomtomNetworkCategory) {
																																																									return {id: id, zip: zip, city: city, name: name, about: about, email: email, phone: phone, state: state, street: street, country: country, storeId: storeId, district: district, homepage: homepage, isActive: isActive, location: location, province: province, wifiSsId: wifiSsId, openHours: openHours, customData: customData, facebookId: facebookId, openingDate: openingDate, locationType: locationType, ptvIdSetType: ptvIdSetType, serviceAreas: serviceAreas, verification: verification, bingIdSetType: bingIdSetType, ptvCustomName: ptvCustomName, appleIdSetType: appleIdSetType, appleCustomName: appleCustomName, googleIdSetType: googleIdSetType, longDescription: longDescription, googleCoverImage: googleCoverImage, googleCustomName: googleCustomName, specialOpenHours: specialOpenHours, facebookIdSetType: facebookIdSetType, networkAttributes: networkAttributes, permanentlyClosed: permanentlyClosed, facebookCoverImage: facebookCoverImage, facebookCustomName: facebookCustomName, googleProfileImage: googleProfileImage, googleServiceItems: googleServiceItems, locationDescriptor: locationDescriptor, newGoogleReviewLink: newGoogleReviewLink, facebookProfileImage: facebookProfileImage, bingNetworkCategories: bingNetworkCategories, hereNetworkCategories: hereNetworkCategories, tomtomNetworkCategory: tomtomNetworkCategory, alternativeSearchNames: alternativeSearchNames, appleNetworkCategories: appleNetworkCategories, temporarilyClosedUntil: temporarilyClosedUntil, googleNetworkCategories: googleNetworkCategories, googleNetworkActionLinks: googleNetworkActionLinks, temporarilyClosedMessage: temporarilyClosedMessage, facebookNetworkCategories: facebookNetworkCategories, overtureNetworkCategories: overtureNetworkCategories, foursquareNetworkCategories: foursquareNetworkCategories, hasTransitionedToNewPageExperience: hasTransitionedToNewPageExperience};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Location$Details$Commands$conflictsDecoder = function (locationData) {
	var maybeCategoryGroup = locationData.networkCategories.bing;
	var succeedWithStatus = F2(
		function (type_, value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (status) {
					return $elm$json$Json$Decode$succeed(
						A2(type_, value, status));
				},
				$author$project$Location$Details$Commands$fieldStatusDecoder);
		});
	var hasBingCategories = function (locationData_) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Maybe$Nothing,
			function (bingNode) {
				if ($elm$core$List$length(bingNode.categories) > 0) {
					return $elm$core$Maybe$Just(
						{
							categories: bingNode.categories,
							primaryCategoryId: A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								($elm$core$List$length(bingNode.categories) > 0) ? A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Just(''),
									function (head) {
										return $elm$core$Maybe$Just(head.id);
									},
									$elm$core$List$head(bingNode.categories)) : $elm$core$Maybe$Nothing,
								function (primary) {
									return $elm$core$Maybe$Just(primary);
								},
								bingNode.primaryCategoryId)
						});
				} else {
					var defaultBingCategories = A2(
						$elm$core$Maybe$andThen,
						function (bingData) {
							var _v5 = bingData.data.networkCategories;
							if (_v5.$ === 'Bing') {
								var value = _v5.a;
								var bing = $elm$core$Maybe$Just(
									{
										categories: value.additional,
										primaryCategoryId: A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											($elm$core$List$length(value.additional) > 0) ? A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												$elm$core$Maybe$Just(''),
												function (head) {
													return $elm$core$Maybe$Just(head.id);
												},
												$elm$core$List$head(value.additional)) : $elm$core$Maybe$Nothing,
											function (primary) {
												return $elm$core$Maybe$Just(primary.id);
											},
											value.primary)
									});
								return bing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						locationData_.bing);
					return defaultBingCategories;
				}
			},
			locationData_.networkCategories.bing);
	};
	var shortNetworkData = function (data) {
		return $elm$core$Maybe$Just(
			{
				idSetType: $elm$core$Maybe$Just(data.idSetType),
				networkLink: $author$project$Location$Details$Model$Link(data.data.link),
				languageCode: data.data.languageCode
			});
	};
	var _v0 = function () {
		var _v1 = locationData.address.stateOrProvince;
		if (_v1.$ === 'WithProvince') {
			var p = _v1.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(p.province),
				$elm$core$Maybe$Just(p.district));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		}
	}();
	var province = _v0.a;
	var district = _v0.b;
	var state = function () {
		var _v4 = locationData.address.stateOrProvince;
		if (_v4.$ === 'WithState') {
			var s = _v4.a;
			return $elm$core$Maybe$Just(s);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		A2($author$project$Location$Details$Model$TomtomNetworkCategory, locationData.networkCategories.tomtom, $author$project$Listings$Ui$Row$NoConflict),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			A2($author$project$Location$Details$Model$HereNetworkCategories, locationData.networkCategories.here, $author$project$Listings$Ui$Row$NoConflict),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				A2($author$project$Location$Details$Model$OvertureNetworkCategories, locationData.networkCategories.overture, $author$project$Listings$Ui$Row$NoConflict),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					locationData.customData,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Maybe$Nothing,
							function (data) {
								return shortNetworkData(data);
							},
							locationData.ptv),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Maybe$Nothing,
								function (data) {
									return shortNetworkData(data);
								},
								locationData.apple),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Maybe$Nothing,
									function (data) {
										return shortNetworkData(data);
									},
									locationData.bing),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$elm$core$Maybe$Nothing,
										function (data) {
											return shortNetworkData(data);
										},
										locationData.facebook),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$elm$core$Maybe$Nothing,
											function (data) {
												return shortNetworkData(data);
											},
											locationData.google),
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											A2($author$project$Location$Details$Model$FoursquareNetworkCategories, locationData.networkCategories.foursquare, $author$project$Listings$Ui$Row$NoConflict),
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'bingNetworkCategories',
												A2(
													succeedWithStatus,
													$author$project$Location$Details$Model$BingNetworkCategories,
													hasBingCategories(locationData)),
												A2($author$project$Location$Details$Model$BingNetworkCategories, maybeCategoryGroup, $author$project$Listings$Ui$Row$NoConflict),
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													A2($author$project$Location$Details$Model$PtvCustomName, locationData.networkNames.ptv, $author$project$Listings$Ui$Row$NoConflict),
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														A2($author$project$Location$Details$Model$AppleCustomName, locationData.networkNames.apple, $author$project$Listings$Ui$Row$NoConflict),
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'appleNetworkCategories',
															A2(succeedWithStatus, $author$project$Location$Details$Model$AppleNetworkCategories, locationData.networkCategories.apple),
															A2($author$project$Location$Details$Model$AppleNetworkCategories, locationData.networkCategories.apple, $author$project$Listings$Ui$Row$NoConflict),
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																A2(
																	$author$project$Location$Details$Model$FacebookId,
																	function (_v3) {
																		var fbStoreId = _v3.a;
																		return fbStoreId;
																	}(locationData.fbStoreId),
																	$author$project$Listings$Ui$Row$NoConflict),
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'fbNetworkCategories',
																	A2(succeedWithStatus, $author$project$Location$Details$Model$FacebookNetworkCategories, locationData.networkCategories.facebook),
																	A2($author$project$Location$Details$Model$FacebookNetworkCategories, $elm$core$Maybe$Nothing, $author$project$Listings$Ui$Row$NoConflict),
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'fbCoverImage',
																		A2(succeedWithStatus, $author$project$Location$Details$Model$FacebookCoverImage, locationData.networkMedia.facebook.coverImage),
																		A2($author$project$Location$Details$Model$FacebookCoverImage, locationData.networkMedia.facebook.coverImage, $author$project$Listings$Ui$Row$NoConflict),
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'fbProfileImage',
																			A2(succeedWithStatus, $author$project$Location$Details$Model$FacebookProfileImage, locationData.networkMedia.facebook.profileImage),
																			A2($author$project$Location$Details$Model$FacebookProfileImage, locationData.networkMedia.facebook.profileImage, $author$project$Listings$Ui$Row$NoConflict),
																			A2(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																				A2($author$project$Location$Details$Model$FacebookCustomName, locationData.networkNames.facebook, $author$project$Listings$Ui$Row$NoConflict),
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'networkServiceItems',
																					A2(succeedWithStatus, $author$project$Location$Details$Model$GoogleServiceItems, locationData.networkServiceItems.google),
																					A2($author$project$Location$Details$Model$GoogleServiceItems, locationData.networkServiceItems.google, $author$project$Listings$Ui$Row$NoConflict),
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'googleNetworkActionLinks',
																						A2(succeedWithStatus, $author$project$Location$Details$Model$GoogleNetworkActionLinks, locationData.actionLinks),
																						A2($author$project$Location$Details$Model$GoogleNetworkActionLinks, locationData.actionLinks, $author$project$Listings$Ui$Row$NoConflict),
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'googleNetworkCategories',
																							A2(succeedWithStatus, $author$project$Location$Details$Model$GoogleNetworkCategories, locationData.networkCategories.google),
																							A2($author$project$Location$Details$Model$GoogleNetworkCategories, $elm$core$Maybe$Nothing, $author$project$Listings$Ui$Row$NoConflict),
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'networkAttributes',
																								A2(succeedWithStatus, $author$project$Location$Details$Model$NetworkAttributes, locationData.networkAttributes),
																								A2($author$project$Location$Details$Model$NetworkAttributes, locationData.networkAttributes, $author$project$Listings$Ui$Row$NoConflict),
																								A2(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																									locationData.newGoogleReviewLink,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'googleCoverImage',
																										A2(succeedWithStatus, $author$project$Location$Details$Model$GoogleCoverImage, locationData.networkMedia.google.coverImage),
																										A2($author$project$Location$Details$Model$GoogleCoverImage, locationData.networkMedia.google.coverImage, $author$project$Listings$Ui$Row$NoConflict),
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'googleProfileImage',
																											A2(succeedWithStatus, $author$project$Location$Details$Model$GoogleProfileImage, locationData.networkMedia.google.profileImage),
																											A2($author$project$Location$Details$Model$GoogleProfileImage, locationData.networkMedia.google.profileImage, $author$project$Listings$Ui$Row$NoConflict),
																											A2(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																												A2($author$project$Location$Details$Model$GoogleCustomName, locationData.networkNames.google, $author$project$Listings$Ui$Row$NoConflict),
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'permanentlyClosed',
																													A2(succeedWithStatus, $author$project$Location$Details$Model$PermanentlyClosed, locationData.permanentlyClosed),
																													A2($author$project$Location$Details$Model$PermanentlyClosed, locationData.permanentlyClosed, $author$project$Listings$Ui$Row$NoConflict),
																													A2(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																														A2($author$project$Location$Details$Model$TemporarilyClosedMessage, locationData.temporarilyClosedMessage, $author$project$Listings$Ui$Row$NoConflict),
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'temporarilyClosedUntil',
																															A2(succeedWithStatus, $author$project$Location$Details$Model$TemporarilyClosed, locationData.temporarilyClosedUntil),
																															A2($author$project$Location$Details$Model$TemporarilyClosed, $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed, $author$project$Listings$Ui$Row$NoConflict),
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'specialOpenHours',
																																A2(succeedWithStatus, $author$project$Location$Details$Model$SpecialOpenHours, locationData.specialOpenHours),
																																A2($author$project$Location$Details$Model$SpecialOpenHours, locationData.specialOpenHours, $author$project$Listings$Ui$Row$NoConflict),
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'hours',
																																	A2(succeedWithStatus, $author$project$Location$Details$Model$OpenHours, locationData.openHours),
																																	A2($author$project$Location$Details$Model$OpenHours, locationData.openHours, $author$project$Listings$Ui$Row$NoConflict),
																																	A4(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																		'email',
																																		A2(
																																			succeedWithStatus,
																																			$author$project$Location$Details$Model$Email,
																																			$author$project$Data$Location$emailToString(locationData.email)),
																																		A2(
																																			$author$project$Location$Details$Model$Email,
																																			$author$project$Data$Location$emailToString(locationData.email),
																																			$author$project$Listings$Ui$Row$NoConflict),
																																		A4(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																			'homepage',
																																			A2(
																																				succeedWithStatus,
																																				$author$project$Location$Details$Model$Homepage,
																																				$author$project$Data$Location$homepageToString(locationData.homepage)),
																																			A2(
																																				$author$project$Location$Details$Model$Homepage,
																																				$author$project$Data$Location$homepageToString(locationData.homepage),
																																				$author$project$Listings$Ui$Row$NoConflict),
																																			A4(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																				'phoneNumber',
																																				A2(
																																					succeedWithStatus,
																																					$author$project$Location$Details$Model$Phone,
																																					$author$project$Data$Location$phoneToString(locationData.phone)),
																																				A2(
																																					$author$project$Location$Details$Model$Phone,
																																					$author$project$Data$Location$phoneToString(locationData.phone),
																																					$author$project$Listings$Ui$Row$NoConflict),
																																				A4(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																					'serviceAreas',
																																					A2(succeedWithStatus, $author$project$Location$Details$Model$ServiceAreas, locationData.serviceAreas),
																																					A2($author$project$Location$Details$Model$ServiceAreas, $author$project$Data$ServiceArea$None, $author$project$Listings$Ui$Row$NoConflict),
																																					A4(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																						'country',
																																						A2(succeedWithStatus, $author$project$Location$Details$Model$Country, locationData.address.country),
																																						A2($author$project$Location$Details$Model$Country, locationData.address.country, $author$project$Listings$Ui$Row$NoConflict),
																																						A4(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																							'district',
																																							A2(succeedWithStatus, $author$project$Location$Details$Model$District, district),
																																							A2($author$project$Location$Details$Model$District, district, $author$project$Listings$Ui$Row$NoConflict),
																																							A4(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																								'province',
																																								A2(succeedWithStatus, $author$project$Location$Details$Model$Province, province),
																																								A2($author$project$Location$Details$Model$Province, province, $author$project$Listings$Ui$Row$NoConflict),
																																								A4(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																									'province',
																																									A2(succeedWithStatus, $author$project$Location$Details$Model$AddressState, state),
																																									A2($author$project$Location$Details$Model$AddressState, state, $author$project$Listings$Ui$Row$NoConflict),
																																									A4(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																										'city',
																																										A2(succeedWithStatus, $author$project$Location$Details$Model$City, locationData.address.city),
																																										A2($author$project$Location$Details$Model$City, locationData.address.city, $author$project$Listings$Ui$Row$NoConflict),
																																										A4(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																											'zip',
																																											A2(succeedWithStatus, $author$project$Location$Details$Model$Zip, locationData.address.zip),
																																											A2($author$project$Location$Details$Model$Zip, locationData.address.zip, $author$project$Listings$Ui$Row$NoConflict),
																																											A4(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																												'street',
																																												A2(succeedWithStatus, $author$project$Location$Details$Model$Street, locationData.address.street),
																																												A2($author$project$Location$Details$Model$Street, locationData.address.street, $author$project$Listings$Ui$Row$NoConflict),
																																												A4(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																													'location',
																																													A2(succeedWithStatus, $author$project$Location$Details$Model$Coordinates, locationData.location),
																																													A2($author$project$Location$Details$Model$Coordinates, locationData.location, $author$project$Listings$Ui$Row$NoConflict),
																																													A2(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																														A2(
																																															$author$project$Location$Details$Model$WifiSsId,
																																															function (_v2) {
																																																var wifiSsId = _v2.a;
																																																return wifiSsId;
																																															}(locationData.wifiSsId),
																																															$author$project$Listings$Ui$Row$NoConflict),
																																														A4(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																															'openingDate',
																																															A2(succeedWithStatus, $author$project$Location$Details$Model$OpeningDate, locationData.openingDate),
																																															A2($author$project$Location$Details$Model$OpeningDate, locationData.openingDate, $author$project$Listings$Ui$Row$NoConflict),
																																															A4(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																'longDescription',
																																																A2(
																																																	succeedWithStatus,
																																																	$author$project$Location$Details$Model$LongDescription,
																																																	$author$project$Data$Location$longDescriptionToString(locationData.longDescription)),
																																																A2(
																																																	$author$project$Location$Details$Model$LongDescription,
																																																	$author$project$Data$Location$longDescriptionToString(locationData.longDescription),
																																																	$author$project$Listings$Ui$Row$NoConflict),
																																																A4(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																	'about',
																																																	A2(
																																																		succeedWithStatus,
																																																		$author$project$Location$Details$Model$ShortDescription,
																																																		$author$project$Data$Location$shortDescriptionToString(locationData.about)),
																																																	A2(
																																																		$author$project$Location$Details$Model$ShortDescription,
																																																		$author$project$Data$Location$shortDescriptionToString(locationData.about),
																																																		$author$project$Listings$Ui$Row$NoConflict),
																																																	A4(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																		'locationDescriptor',
																																																		A2(
																																																			succeedWithStatus,
																																																			$author$project$Location$Details$Model$LocationDescriptor,
																																																			$author$project$Data$Location$locationDescriptorToString(locationData.locationDescriptor)),
																																																		A2(
																																																			$author$project$Location$Details$Model$LocationDescriptor,
																																																			$author$project$Data$Location$locationDescriptorToString(locationData.locationDescriptor),
																																																			$author$project$Listings$Ui$Row$NoConflict),
																																																		A2(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																																			A2($author$project$Location$Details$Model$Type, locationData.locationType, $author$project$Listings$Ui$Row$NoConflict),
																																																			A4(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																				'name',
																																																				A2(succeedWithStatus, $author$project$Location$Details$Model$Name, locationData.name),
																																																				A2($author$project$Location$Details$Model$Name, locationData.name, $author$project$Listings$Ui$Row$NoConflict),
																																																				A4(
																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																					'storeId',
																																																					A2(
																																																						succeedWithStatus,
																																																						$author$project$Location$Details$Model$StoreId,
																																																						$author$project$Data$Location$storeIdToString(locationData.storeId)),
																																																					A2(
																																																						$author$project$Location$Details$Model$StoreId,
																																																						$author$project$Data$Location$storeIdToString(locationData.storeId),
																																																						$author$project$Listings$Ui$Row$NoConflict),
																																																					A2(
																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																																						locationData.hasTransitionedToNewPageExperience,
																																																						A2(
																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																																							locationData.verification,
																																																							A2(
																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																																								locationData.alternativeSearchNames,
																																																								A2(
																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																																									locationData.isActive,
																																																									A2(
																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																																																										locationData.id,
																																																										$elm$json$Json$Decode$succeed($author$project$Location$Details$Model$LocationDataWithConflictStatus))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
};
var $author$project$Location$Details$Commands$getConflictStatus = F4(
	function (_v0, locationId, locationData, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Location$Details$Commands$conflictsDecoder(locationData),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/conflictsstatus/location/' + locationId))))));
	});
var $author$project$Translations$Listings$LocationDetail$imageEditorSaveFailed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.image_editor_save_failed');
};
var $author$project$Location$Details$Editor$Model$ScheduledUpdate = function (a) {
	return {$: 'ScheduledUpdate', a: a};
};
var $author$project$Location$Details$Editor$initWithScheduleUpdate = F3(
	function (now, location, scheduleUpdate) {
		var selectedLocations = (location.id === '') ? _List_Nil : A2(
			$elm$core$List$map,
			function ($) {
				return $.locationId;
			},
			scheduleUpdate.locations);
		return _Utils_Tuple2(
			$author$project$Location$Details$Editor$State(
				{
					now: now,
					error: $elm$core$Maybe$Nothing,
					confirm: $elm$core$Maybe$Nothing,
					content: $author$project$Location$Details$Editor$Model$ScheduledUpdate(scheduleUpdate),
					location: location,
					bulkAction: $elm$core$Maybe$Nothing,
					popOverState: $author$project$PinMeTo$Ui$PopOver$init,
					selectedDate: $elm$core$Maybe$Nothing,
					trackingInfo: $elm$core$Maybe$Nothing,
					locationSelector: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init,
					selectedLocations: selectedLocations,
					showSavingProgress: false,
					locationsNeedsVerificationOnLocationSelector: $elm$core$Maybe$Nothing
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Location$Details$Model$CustomFieldEditorUpdated = function (a) {
	return {$: 'CustomFieldEditorUpdated', a: a};
};
var $author$project$Location$Details$Model$ScheduleUpdatesRefreshed = function (a) {
	return {$: 'ScheduleUpdatesRefreshed', a: a};
};
var $author$project$Location$Details$Model$LdpSpecialOpenHoursUpdated = function (a) {
	return {$: 'LdpSpecialOpenHoursUpdated', a: a};
};
var $author$project$Location$Details$Model$SideBarSpecialOpenHoursUpdated = function (a) {
	return {$: 'SideBarSpecialOpenHoursUpdated', a: a};
};
var $author$project$Location$Details$Ports$out_Location_Details_Main_AddWork = _Platform_outgoingPort(
	'out_Location_Details_Main_AddWork',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Location$Details$Ports$out_Location_Details_Main_CropImage = _Platform_outgoingPort('out_Location_Details_Main_CropImage', $elm$core$Basics$identity);
var $author$project$Data$GoogleAttributes$Api$siteUrl = function (siteName) {
	return 'api/' + $author$project$Data$SiteName$toString(siteName);
};
var $author$project$Data$GoogleAttributes$Api$locationUrl = F2(
	function (siteName, locationId) {
		return $author$project$Data$GoogleAttributes$Api$siteUrl(siteName) + ('/place/' + locationId);
	});
var $author$project$Data$GoogleAttributes$Api$encodeAttributes = function (attributes) {
	return _Utils_Tuple2(
		'attributes',
		A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkAttributes$encodeAttribute, attributes));
};
var $author$project$Data$GoogleAttributes$Api$encodeEmptiedAttributeIds = function (emptiedAttributeIds) {
	return _Utils_Tuple2(
		'emptiedAttributeIds',
		A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, emptiedAttributeIds));
};
var $author$project$Data$GoogleAttributes$Api$setEditedAttributesOnLocation = F4(
	function (siteName, locationId, editor, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								$author$project$Data$GoogleAttributes$Api$encodeAttributes(editor.attributes),
								$author$project$Data$GoogleAttributes$Api$encodeEmptiedAttributeIds(editor.emptiedAttributeIds)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$put(
						A2($author$project$Data$GoogleAttributes$Api$locationUrl, siteName, locationId) + '/google/attributes'))));
	});
var $author$project$Data$GoogleAttributes$Api$encodeLocationIds = function (locationIds) {
	return _Utils_Tuple2(
		'locationIds',
		A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locationIds));
};
var $author$project$Data$GoogleAttributes$Api$withReturnPlaceId = F2(
	function (returnPlaceId, url) {
		if (returnPlaceId.$ === 'Just') {
			var placeId = returnPlaceId.a;
			return url + ('?returnPlaceId=' + placeId);
		} else {
			return url;
		}
	});
var $author$project$Data$GoogleAttributes$Api$addEditedAttributesToSelectedLocations = F4(
	function (siteName, returnPlaceId, editor, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								$author$project$Data$GoogleAttributes$Api$encodeLocationIds(editor.locationIds),
								$author$project$Data$GoogleAttributes$Api$encodeAttributes(editor.attributes),
								$author$project$Data$GoogleAttributes$Api$encodeEmptiedAttributeIds(editor.emptiedAttributeIds)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$put(
						A2(
							$author$project$Data$GoogleAttributes$Api$withReturnPlaceId,
							returnPlaceId,
							$author$project$Data$GoogleAttributes$Api$siteUrl(siteName) + '/places/google/attributes/addEdited')))));
	});
var $author$project$Location$Details$Commands$saveGoogleAttributesFromLocationDetails = F6(
	function (siteName, locationId, features, customDataDefinition, editor, msg) {
		var expect = A3(
			$author$project$PinMeTo$ExpectJson$expectJson,
			msg,
			A2($author$project$Location$Details$Commands$partialUpdateResultDecoder, features, customDataDefinition),
			$elm$json$Json$Decode$string);
		return _Utils_eq(
			editor.locationIds,
			_List_fromArray(
				[locationId])) ? A4($author$project$Data$GoogleAttributes$Api$setEditedAttributesOnLocation, siteName, locationId, editor, expect) : A4(
			$author$project$Data$GoogleAttributes$Api$addEditedAttributesToSelectedLocations,
			siteName,
			$elm$core$Maybe$Just(locationId),
			editor,
			expect);
	});
var $author$project$Location$Details$Update$out_Location_Details_Main_UpdateTitleBar = _Platform_outgoingPort(
	'out_Location_Details_Main_UpdateTitleBar',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string($.status)),
					_Utils_Tuple2(
					'address',
					$elm$core$Basics$identity($.address)),
					_Utils_Tuple2(
					'storeId',
					$elm$json$Json$Encode$string($.storeId)),
					_Utils_Tuple2(
					'isActive',
					$elm$json$Json$Encode$bool($.isActive)),
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string($.description))
				]));
	});
var $author$project$Data$GoogleAttributes$Api$setSocialLinksOnLocation = F4(
	function (siteName, locationId, editor, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								$author$project$Data$GoogleAttributes$Api$encodeAttributes(editor.attributes),
								$author$project$Data$GoogleAttributes$Api$encodeEmptiedAttributeIds(editor.emptiedAttributeIds)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$put(
						A2($author$project$Data$GoogleAttributes$Api$locationUrl, siteName, locationId) + '/google/socialLinks'))));
	});
var $author$project$Location$Details$Commands$saveGoogleSocialLinksFromLocationDetails = F6(
	function (siteName, locationId, features, customDataDefinition, editor, msg) {
		var expect = A3(
			$author$project$PinMeTo$ExpectJson$expectJson,
			msg,
			A2($author$project$Location$Details$Commands$partialUpdateResultDecoder, features, customDataDefinition),
			$elm$json$Json$Decode$string);
		return _Utils_eq(
			editor.locationIds,
			_List_fromArray(
				[locationId])) ? A4($author$project$Data$GoogleAttributes$Api$setSocialLinksOnLocation, siteName, locationId, editor, expect) : A4(
			$author$project$Data$GoogleAttributes$Api$addEditedAttributesToSelectedLocations,
			siteName,
			$elm$core$Maybe$Just(locationId),
			editor,
			expect);
	});
var $author$project$Location$Details$Update$out_Location_Details_Main_CopyToClipboard = _Platform_outgoingPort('out_Location_Details_Main_CopyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Location$Details$Update$out_Location_Details_Main_OpenGoogleQRCode = _Platform_outgoingPort(
	'out_Location_Details_Main_OpenGoogleQRCode',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Location$Details$Update$update = F3(
	function (session, msg, model) {
		var onEditorUpdated = F3(
			function (location, editor_, customFieldEditor_) {
				var _v14 = location.locationDescriptor;
				var locationDescriptor = _v14.a;
				var isTemporarilyClosed = function () {
					var _v18 = location.temporarilyClosedUntil;
					if (_v18.$ === 'Until') {
						var until = _v18.a;
						return (_Utils_cmp(
							$justinmimbs$date$Date$toIsoString(
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, until)),
							$justinmimbs$date$Date$toIsoString(
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, until))) > -1) ? true : false;
					} else {
						return false;
					}
				}();
				var _v15 = location.storeId;
				var storeId = _v15.a;
				var _v16 = function () {
					var _v17 = location.address.stateOrProvince;
					if (_v17.$ === 'WithState') {
						var state_ = _v17.a;
						return _Utils_Tuple3('', '', state_);
					} else {
						var data = _v17.a;
						return _Utils_Tuple3(data.province, data.district, '');
					}
				}();
				var province = _v16.a;
				var district = _v16.b;
				var state = _v16.c;
				var status = _Utils_eq(location.isActive, $author$project$Data$Location$Inactive) ? $author$project$Translations$General$disabled(session.translations) : (location.permanentlyClosed ? $author$project$Translations$General$closed(session.translations) : (isTemporarilyClosed ? $author$project$Translations$General$locationTempClosed(session.translations) : $author$project$Translations$General$open(session.translations)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: editor_, location: location, customFieldEditor: customFieldEditor_}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A4($author$project$Location$Details$Commands$getConflictStatus, model.siteName, model.locationId, location, $author$project$Location$Details$Model$OnConflictStatus),
								$author$project$Location$Details$Update$out_Location_Details_Main_UpdateTitleBar(
								{
									status: status,
									address: $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'street',
												$elm$json$Json$Encode$string(location.address.street)),
												_Utils_Tuple2(
												'zip',
												$elm$json$Json$Encode$string(location.address.zip)),
												_Utils_Tuple2(
												'city',
												$elm$json$Json$Encode$string(location.address.city)),
												_Utils_Tuple2(
												'country',
												$elm$json$Json$Encode$string(location.address.country)),
												_Utils_Tuple2(
												'countryAlpha2Code',
												$elm$json$Json$Encode$string(location.address.countryAlpha2Code)),
												_Utils_Tuple2(
												'state',
												$elm$json$Json$Encode$string(state)),
												_Utils_Tuple2(
												'province',
												$elm$json$Json$Encode$string(province)),
												_Utils_Tuple2(
												'district',
												$elm$json$Json$Encode$string(district))
											])),
									storeId: storeId,
									isActive: !_Utils_eq(
										status,
										$author$project$Translations$General$disabled(session.translations)),
									description: locationDescriptor
								})
							])));
			});
		switch (msg.$) {
			case 'DevNetworkActionsMsg':
				var subMsg = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (devNetworkActions) {
						return _Utils_update(
							model,
							{devNetworkActions: devNetworkActions});
					},
					$elm$core$Platform$Cmd$map($author$project$Location$Details$Model$DevNetworkActionsMsg),
					A3(
						$author$project$Location$Details$DevNetworkActions$update,
						{siteName: model.siteName, locationId: model.locationId},
						subMsg,
						model.devNetworkActions));
			case 'EditorOpen':
				var editor = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (editorModel) {
						return _Utils_update(
							model,
							{
								editor: $elm$core$Maybe$Just(editorModel)
							});
					},
					$elm$core$Platform$Cmd$map($author$project$Location$Details$Model$EditorMsg),
					A7(
						$author$project$Location$Details$Editor$init,
						{bing: model.location.networkCategories.bing, here: model.location.networkCategories.here, apple: model.location.networkCategories.apple, google: model.location.networkCategories.google, tomtom: model.location.networkCategories.tomtom, facebook: model.location.networkCategories.facebook, overture: model.location.networkCategories.overture, foursquare: model.location.networkCategories.foursquare},
						model.today,
						model.location,
						session,
						true,
						model.scheduleUpdates,
						editor));
			case 'CustomFieldEditorOpen':
				var editor = msg.a;
				var property = msg.b;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (editorModel) {
						return _Utils_update(
							model,
							{
								customFieldEditor: $elm$core$Maybe$Just(editorModel)
							});
					},
					$elm$core$Platform$Cmd$map($author$project$Location$Details$Model$CustomFieldEditorMsg),
					A5($author$project$Location$Details$CustomFieldEditor$init, property, model.today, model.location.id, editor, session));
			case 'ScheduleUpdateEditorOpen':
				var scheduleUpdate = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (editorModel) {
						return _Utils_update(
							model,
							{
								editor: $elm$core$Maybe$Just(editorModel)
							});
					},
					$elm$core$Platform$Cmd$map($author$project$Location$Details$Model$EditorMsg),
					A3($author$project$Location$Details$Editor$initWithScheduleUpdate, model.today, model.location, scheduleUpdate));
			case 'EditorClose':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'SideBarSpecialOpenHoursUpdated':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'LdpSpecialOpenHoursUpdated':
				var location = msg.a;
				return A3(onEditorUpdated, location, $elm$core$Maybe$Nothing, model.customFieldEditor);
			case 'EditorUpdated':
				var location = msg.a;
				return A3(onEditorUpdated, location, $elm$core$Maybe$Nothing, model.customFieldEditor);
			case 'EditorMsg':
				var msg_ = msg.a;
				var _v1 = model.editor;
				if (_v1.$ === 'Just') {
					var editor = _v1.a;
					var updateCommandLdpSpecialOpenHours = A4(
						$author$project$Location$Details$Commands$sendToOverwriteSpecialOpenHours,
						model.siteName,
						model.locationId,
						model.features,
						$elm$core$Maybe$Just(model.customDataDefinition));
					var _v2 = editor;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(x)
								});
						},
						A4(
							$author$project$Location$Details$Editor$update,
							{
								tagger: $author$project$Location$Details$Model$EditorMsg,
								siteName: model.siteName,
								onUpdated: $author$project$Location$Details$Model$EditorUpdated,
								onScheduled: $elm$core$Maybe$Just($author$project$Location$Details$Model$SchedulerUpdated),
								deleteCommand: A2($author$project$Location$Details$Commands$deleteScheduleUpdate, model.siteName, model.locationId),
								updateCommand: A4(
									$author$project$Location$Details$Commands$sendToPartialUpdate_,
									model.siteName,
									model.locationId,
									model.features,
									$elm$core$Maybe$Just(model.customDataDefinition)),
								scheduleCommand: A3(
									$author$project$Location$Details$Commands$sendToScheduleUpdate_,
									model.siteName,
									$elm$core$Maybe$Just(model.customDataDefinition),
									model.locationId),
								onDeleteSchedule: $elm$core$Maybe$Just($author$project$Location$Details$Model$DeleteSchedule),
								saveGoogleAttributes: A4(
									$author$project$Location$Details$Commands$saveGoogleAttributesFromLocationDetails,
									model.siteName,
									model.locationId,
									model.features,
									$elm$core$Maybe$Just(model.customDataDefinition)),
								saveGoogleSocialLinks: A4(
									$author$project$Location$Details$Commands$saveGoogleSocialLinksFromLocationDetails,
									model.siteName,
									model.locationId,
									model.features,
									$elm$core$Maybe$Just(model.customDataDefinition)),
								onScheduleUpdatesRefreshed: $elm$core$Maybe$Just($author$project$Location$Details$Model$ScheduleUpdatesRefreshed),
								onUpdatedLdpSpecialOpenHours: $author$project$Location$Details$Model$LdpSpecialOpenHoursUpdated,
								onUpdatedSideBarSpecialOpenHours: $author$project$Location$Details$Model$SideBarSpecialOpenHoursUpdated,
								updateCommandLdpSpecialOpenHours: $elm$core$Maybe$Just(updateCommandLdpSpecialOpenHours),
								updateCommandSideBarSpecialOpenHours: $elm$core$Maybe$Nothing
							},
							session,
							msg_,
							editor));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'CustomFieldEditorMsg':
				var msg_ = msg.a;
				var _v3 = model.customFieldEditor;
				if (_v3.$ === 'Just') {
					var editor = _v3.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									customFieldEditor: $elm$core$Maybe$Just(x)
								});
						},
						A4(
							$author$project$Location$Details$CustomFieldEditor$update,
							{
								tagger: $author$project$Location$Details$Model$CustomFieldEditorMsg,
								siteName: model.siteName,
								onUpdated: $author$project$Location$Details$Model$CustomFieldEditorUpdated,
								onScheduled: $elm$core$Maybe$Just($author$project$Location$Details$Model$SchedulerUpdated),
								deleteCommand: A2($author$project$Location$Details$Commands$deleteScheduleUpdate, model.siteName, model.locationId),
								updateCommand: A4(
									$author$project$Location$Details$Commands$sendToPartialUpdate_,
									model.siteName,
									model.locationId,
									model.features,
									$elm$core$Maybe$Just(model.customDataDefinition)),
								scheduleCommand: A3(
									$author$project$Location$Details$Commands$sendToScheduleUpdate_,
									model.siteName,
									$elm$core$Maybe$Just(model.customDataDefinition),
									model.locationId),
								onDeleteSchedule: $elm$core$Maybe$Just($author$project$Location$Details$Model$DeleteSchedule)
							},
							session,
							msg_,
							editor));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'CustomFieldEditorClose':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{customFieldEditor: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'CustomFieldEditorUpdated':
				var location = msg.a;
				return A3(onEditorUpdated, location, model.editor, $elm$core$Maybe$Nothing);
			case 'CopyToBuffer':
				var value = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Location$Details$Update$out_Location_Details_Main_CopyToClipboard(value));
			case 'OpenGoogleQRCode':
				var _v4 = model.siteName;
				var siteName = _v4.a;
				return _Utils_Tuple2(
					model,
					$author$project$Location$Details$Update$out_Location_Details_Main_OpenGoogleQRCode(
						_Utils_Tuple2(siteName, model.locationId)));
			case 'OnLocationData':
				if (msg.a.$ === 'Ok') {
					var locationData = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{storeId: locationData.storeId}),
						A4($author$project$Location$Details$Commands$getConflictStatus, model.siteName, model.locationId, locationData, $author$project$Location$Details$Model$OnConflictStatus));
				} else {
					var err = msg.a.a;
					var _v5 = err.message;
					var message = _v5.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Location.Details.Main', message: 'OnLocationData Failure'}));
				}
			case 'OnConflictStatus':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var locationDataWithConflictStatus = response.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{locationDataWithConflictStatus: locationDataWithConflictStatus}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = response.a;
					var _v7 = err.message;
					var message = _v7.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Location.Details.Main', message: 'OnConflictStatus Failure'}));
				}
			case 'ImageEditorOpen':
				var target = msg.a;
				var _v8 = A3($author$project$Location$ImageEditor$init, target, model.siteName, model.locationId);
				var imageEditor = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							imageEditor: $elm$core$Maybe$Just(imageEditor)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$Model$ImageEditorMsg, cmd));
			case 'ImageEditorMsg':
				var msg_ = msg.a;
				var _v9 = model.imageEditor;
				if (_v9.$ === 'Just') {
					var imageEditor = _v9.a;
					var _v10 = A3(
						$author$project$Location$ImageEditor$update,
						{cropImage: $author$project$Location$Details$Ports$out_Location_Details_Main_CropImage},
						msg_,
						imageEditor);
					var newImageEditor = _v10.a;
					var cmd = _v10.b;
					var event = _v10.c;
					if (event.$ === 'Nothing') {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									imageEditor: $elm$core$Maybe$Just(newImageEditor)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$Model$ImageEditorMsg, cmd));
					} else {
						if (event.a.$ === 'Closed') {
							var _v12 = event.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{imageEditor: $elm$core$Maybe$Nothing}),
								A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$Model$ImageEditorMsg, cmd));
						} else {
							var body = event.a.a.body;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										imageEditor: $elm$core$Maybe$Just(
											$author$project$Location$ImageEditor$withSaving(newImageEditor))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$Model$ImageEditorMsg, cmd),
											A6(
											$author$project$Location$Details$Commands$sendToPartialUpdate_,
											model.siteName,
											model.locationId,
											model.features,
											$elm$core$Maybe$Just(model.customDataDefinition),
											$author$project$Location$Details$Model$ImageEditorSaved,
											body)
										])));
						}
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ImageEditorSaved':
				if (msg.a.$ === 'Ok') {
					var result = msg.a.a;
					var _v13 = A3(onEditorUpdated, result.location, model.editor, model.customFieldEditor);
					var newModel = _v13.a;
					var cmd = _v13.b;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{imageEditor: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									$author$project$Location$Details$Ports$out_Location_Details_Main_AddWork(_Utils_Tuple0)
								])));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								imageEditor: A2(
									$elm$core$Maybe$map,
									$author$project$Location$ImageEditor$withError(
										$author$project$Translations$Listings$LocationDetail$imageEditorSaveFailed(session.translations)),
									model.imageEditor)
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Update.ImageEditorSaved'),
							err));
				}
			case 'OnMapDragend':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'SchedulerUpdated':
				var scheduleUpdates = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing, scheduleUpdates: scheduleUpdates, customFieldEditor: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'DeleteSchedule':
				var scheduleUpdates = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing, scheduleUpdates: scheduleUpdates}),
					$elm$core$Platform$Cmd$none);
			default:
				var scheduleUpdates = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{scheduleUpdates: scheduleUpdates}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $rl_king$elm_scroll_to$ScrollTo$SetTarget = function (a) {
	return {$: 'SetTarget', a: a};
};
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $rl_king$elm_scroll_to$ScrollTo$scrollToCustom = F2(
	function (f, id) {
		return A2(
			$elm$core$Task$attempt,
			$rl_king$elm_scroll_to$ScrollTo$SetTarget,
			A3(
				$elm$core$Task$map2,
				f,
				$elm$browser$Browser$Dom$getViewport,
				$elm$browser$Browser$Dom$getElement(id)));
	});
var $rl_king$elm_scroll_to$ScrollTo$scrollTo = function (id) {
	var f = F2(
		function (_v0, _v1) {
			var scene = _v0.scene;
			var viewport = _v0.viewport;
			var element = _v1.element;
			return {
				to: {
					x: viewport.x,
					y: A2($elm$core$Basics$min, element.y, scene.height - viewport.height)
				},
				from: {x: viewport.x, y: viewport.y}
			};
		});
	return A2($rl_king$elm_scroll_to$ScrollTo$scrollToCustom, f, id);
};
var $author$project$Data$Location$SpecialOpenHours$withSorted = function (openHours) {
	return A2(
		$elm$core$List$sortWith,
		F2(
			function (a, b) {
				var dateCompare = A2(
					$elm$core$Basics$compare,
					$elm$time$Time$posixToMillis(a.endDate),
					$elm$time$Time$posixToMillis(b.endDate));
				var spanB = function () {
					var _v1 = b.state;
					if (_v1.$ === 'Open') {
						var span = _v1.a;
						return span;
					} else {
						return {open: '0000', close: '0000'};
					}
				}();
				var spanA = function () {
					var _v0 = a.state;
					if (_v0.$ === 'Open') {
						var span = _v0.a;
						return span;
					} else {
						return {open: '0000', close: '0000'};
					}
				}();
				var timeCompare = A2($elm$core$Basics$compare, spanA.open, spanB.open);
				return _Utils_eq(dateCompare, $elm$core$Basics$EQ) ? timeCompare : dateCompare;
			}),
		openHours);
};
var $author$project$Location$Details$App$ScrollToMsg = function (a) {
	return {$: 'ScrollToMsg', a: a};
};
var $author$project$Location$Details$App$OnLocationData = function (a) {
	return {$: 'OnLocationData', a: a};
};
var $author$project$Location$Details$Commands$getLocationData = F5(
	function (_v0, locationId, features, customDataDefinition, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$Data$Location$locationDecoder, features, customDataDefinition),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/place/' + locationId))))));
	});
var $author$project$Location$Details$App$OnConflictStatus = function (a) {
	return {$: 'OnConflictStatus', a: a};
};
var $author$project$Location$Details$App$OnScheduleUpdates = function (a) {
	return {$: 'OnScheduleUpdates', a: a};
};
var $author$project$Location$Details$Commands$getScheduleUpdates = F4(
	function (_v0, locationId, maybeCustomDataDefinition, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Location$Details$Commands$scheduleUpdatesDecoder(maybeCustomDataDefinition),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/places/schedule?returnPlaceId=' + locationId))))));
	});
var $author$project$Location$Details$App$OnCustomDataDefinition = function (a) {
	return {$: 'OnCustomDataDefinition', a: a};
};
var $author$project$Data$CustomDataDefinition$ListProperty = F2(
	function (a, b) {
		return {$: 'ListProperty', a: a, b: b};
	});
var $author$project$Data$CustomDataDefinition$StringProperty = function (a) {
	return {$: 'StringProperty', a: a};
};
var $author$project$Data$CustomDataDefinition$BooleanProperty = function (a) {
	return {$: 'BooleanProperty', a: a};
};
var $author$project$Data$CustomDataDefinition$OpenHoursProperty = function (a) {
	return {$: 'OpenHoursProperty', a: a};
};
var $author$project$Data$CustomDataDefinition$ValidationRule = function (a) {
	return {$: 'ValidationRule', a: a};
};
var $author$project$Data$CustomDataDefinition$decodePropertyMeta = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (type_, property, displayName, rules) {
			return _Utils_Tuple2(
				type_,
				{name: property, rules: rules, displayName: displayName});
		}),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'property',
		$author$project$Util$idDecoder($author$project$Data$CustomDataDefinition$PropertyName)),
	A2($elm$json$Json$Decode$field, 'displayName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'rules',
		$elm$json$Json$Decode$list(
			$author$project$Util$idDecoder($author$project$Data$CustomDataDefinition$ValidationRule))));
var $author$project$Data$CustomDataDefinition$SpecialOpenHoursProperty = function (a) {
	return {$: 'SpecialOpenHoursProperty', a: a};
};
function $author$project$Data$CustomDataDefinition$cyclic$decodeProperty() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var type_ = _v0.a;
			var propMeta = _v0.b;
			switch (type_) {
				case 'string':
					return $elm$json$Json$Decode$succeed(
						$author$project$Data$CustomDataDefinition$StringProperty(propMeta));
				case 'boolean':
					return $elm$json$Json$Decode$succeed(
						$author$project$Data$CustomDataDefinition$BooleanProperty(propMeta));
				case 'hours':
					return $elm$json$Json$Decode$succeed(
						$author$project$Data$CustomDataDefinition$OpenHoursProperty(propMeta));
				case 'specialHours':
					return $elm$json$Json$Decode$succeed(
						$author$project$Data$CustomDataDefinition$SpecialOpenHoursProperty(propMeta));
				case 'list':
					return A2(
						$elm$json$Json$Decode$map,
						function (objDefs) {
							return A2(
								$author$project$Data$CustomDataDefinition$ListProperty,
								propMeta,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Data$CustomDataDefinition$StringProperty(
										{
											name: $author$project$Data$CustomDataDefinition$PropertyName('_'),
											rules: _List_Nil,
											displayName: '_'
										}),
									$elm$core$Basics$identity,
									$elm$core$List$head(objDefs)));
						},
						A2(
							$elm$json$Json$Decode$field,
							'objectDef',
							$elm$json$Json$Decode$list(
								$author$project$Data$CustomDataDefinition$cyclic$decodeProperty())));
				case 'object':
					return A2(
						$elm$json$Json$Decode$map,
						function (objDef) {
							return A2(
								$author$project$Data$CustomDataDefinition$ObjectProperty,
								propMeta,
								$author$project$Data$CustomDataDefinition$CustomDataDefinition(objDef));
						},
						A2(
							$elm$json$Json$Decode$field,
							'objectDef',
							$elm$json$Json$Decode$list(
								$author$project$Data$CustomDataDefinition$cyclic$decodeProperty())));
				default:
					return $elm$json$Json$Decode$fail('Unknown type \u0027' + (type_ + '\u0027'));
			}
		},
		$author$project$Data$CustomDataDefinition$decodePropertyMeta);
}
try {
	var $author$project$Data$CustomDataDefinition$decodeProperty = $author$project$Data$CustomDataDefinition$cyclic$decodeProperty();
	$author$project$Data$CustomDataDefinition$cyclic$decodeProperty = function () {
		return $author$project$Data$CustomDataDefinition$decodeProperty;
	};
} catch ($) {
	throw 'Some top-level definitions from `Data.CustomDataDefinition` are causing infinite recursion:\n\n  ┌─────┐\n  │    decodeProperty\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $author$project$Data$CustomDataDefinition$decodeCustomDataDefinition = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'customDataSchema',
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$CustomDataDefinition$CustomDataDefinition,
		$elm$json$Json$Decode$list($author$project$Data$CustomDataDefinition$decodeProperty)),
	$author$project$Data$CustomDataDefinition$CustomDataDefinition(_List_Nil),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Location$Details$Commands$getCustomDataDefinition = F3(
	function (_v0, locationId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$CustomDataDefinition$decodeCustomDataDefinition, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/place/' + (locationId + '/customData')))))));
	});
var $author$project$Location$Details$DevNetworkActions$init = $author$project$Location$Details$DevNetworkActions$Model$init;
var $author$project$Location$Details$Model$init = function (data) {
	return {today: data.today, editor: data.editor, storeId: data.storeId, features: data.features, location: data.location, siteName: data.session.siteName, locationId: data.locationId, imageEditor: data.imageEditor, siteCategories: data.siteCategories, scheduleUpdates: data.scheduleUpdates, googleAttributes: data.googleAttributes, customFieldEditor: $elm$core$Maybe$Nothing, devNetworkActions: $author$project$Location$Details$DevNetworkActions$init, customDataDefinition: data.customDataDefinition, allGoogleServiceItems: data.allGoogleServiceItems, locationDataWithConflictStatus: data.locationDataWithConflictStatus};
};
var $elm$core$Maybe$map5 = F6(
	function (func, ma, mb, mc, md, me) {
		if (ma.$ === 'Nothing') {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 'Nothing') {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 'Nothing') {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						if (me.$ === 'Nothing') {
							return $elm$core$Maybe$Nothing;
						} else {
							var e = me.a;
							return $elm$core$Maybe$Just(
								A5(func, a, b, c, d, e));
						}
					}
				}
			}
		}
	});
var $author$project$Location$Details$App$initLocationDetailsPage = F2(
	function (session, model) {
		return A2(
			$elm$core$Maybe$map,
			function (detailsModel) {
				var _v0 = model.locationDetailPage;
				if (_v0.$ === 'Just') {
					var page = _v0.a;
					return $author$project$Location$Details$Model$init(
						_Utils_update(
							detailsModel,
							{editor: page.editor, imageEditor: page.imageEditor}));
				} else {
					return $author$project$Location$Details$Model$init(detailsModel);
				}
			},
			A6(
				$elm$core$Maybe$map5,
				F5(
					function (storeId, customDataDefinition, location, locationData, scheduleUpdates) {
						return {today: model.today, editor: $elm$core$Maybe$Nothing, session: session, storeId: storeId, features: model.features, location: location, locationId: model.locationId, imageEditor: $elm$core$Maybe$Nothing, siteCategories: model.siteCategories, scheduleUpdates: scheduleUpdates, googleAttributes: model.googleAttributes, customDataDefinition: customDataDefinition, allGoogleServiceItems: model.allGoogleServiceItems, locationDataWithConflictStatus: locationData};
					}),
				model.storeId,
				$author$project$RemoteData$currentData(model.customDataDefinition),
				$author$project$RemoteData$currentData(model.location),
				$author$project$RemoteData$currentData(model.locationDataWithConflictStatus),
				$author$project$RemoteData$currentData(model.scheduleUpdates)));
	});
var $author$project$Location$Details$App$OnGoogleServiceItemsData = function (a) {
	return {$: 'OnGoogleServiceItemsData', a: a};
};
var $author$project$Location$Details$Ports$out_Location_Details_Main_UpdateTitleBarAngular = _Platform_outgoingPort(
	'out_Location_Details_Main_UpdateTitleBarAngular',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string($.status)),
					_Utils_Tuple2(
					'address',
					$elm$core$Basics$identity($.address)),
					_Utils_Tuple2(
					'storeId',
					$elm$json$Json$Encode$string($.storeId)),
					_Utils_Tuple2(
					'isActive',
					$elm$json$Json$Encode$bool($.isActive)),
					_Utils_Tuple2(
					'description',
					$elm$json$Json$Encode$string($.description))
				]));
	});
var $author$project$Location$Details$App$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'OnGoogleAttributesData':
				if (msg.a.$ === 'Ok') {
					var googleAttributes = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							googleAttributes: $author$project$RemoteData$Loaded(googleAttributes)
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								locationDetailPage: A2($author$project$Location$Details$App$initLocationDetailsPage, session, newModel)
							}),
						A3($author$project$Location$Details$Commands$getCustomDataDefinition, session.siteName, model.locationId, $author$project$Location$Details$App$OnCustomDataDefinition));
				} else {
					var error = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							googleAttributes: $author$project$RemoteData$Error(
								$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								locationDetailPage: A2($author$project$Location$Details$App$initLocationDetailsPage, session, newModel)
							}),
						A3($author$project$Location$Details$Commands$getCustomDataDefinition, session.siteName, model.locationId, $author$project$Location$Details$App$OnCustomDataDefinition));
				}
			case 'OnCustomDataDefinition':
				if (msg.a.$ === 'Ok') {
					var customDataDefinition = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								customDataDefinition: $author$project$RemoteData$Loaded(customDataDefinition)
							}),
						A5(
							$author$project$Location$Details$Commands$getLocationData,
							session.siteName,
							model.locationId,
							model.features,
							$elm$core$Maybe$Just(customDataDefinition),
							$author$project$Location$Details$App$OnLocationData));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								customDataDefinition: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnCustomDataDefinition'),
							error));
				}
			case 'OnLocationProperties':
				if (msg.a.$ === 'Ok') {
					var locationProperties = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationProperties: $author$project$RemoteData$Loaded(locationProperties)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationProperties: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnLocationProperties'),
							error));
				}
			case 'OnGoogleServiceItemsData':
				if (msg.a.$ === 'Ok') {
					var services = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							allGoogleServiceItems: $author$project$RemoteData$Loaded(services)
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								locationDetailPage: A2($author$project$Location$Details$App$initLocationDetailsPage, session, newModel)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								allGoogleServiceItems: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnGoogleServiceItemsData'),
							err));
				}
			case 'OnLocationData':
				if (msg.a.$ === 'Ok') {
					var locationData = msg.a.a;
					var sortedSpecialOpenHours = $author$project$Data$Location$SpecialOpenHours$withSorted(locationData.specialOpenHours);
					var _v1 = locationData.locationDescriptor;
					var locationDescriptor = _v1.a;
					var isTemporarilyClosed = function () {
						var _v5 = locationData.temporarilyClosedUntil;
						if (_v5.$ === 'Until') {
							var until = _v5.a;
							return _Utils_cmp(
								$justinmimbs$date$Date$toIsoString(
									A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, until)),
								$justinmimbs$date$Date$toIsoString(
									A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.today))) > -1;
						} else {
							return false;
						}
					}();
					var allCategories = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (categoryGroup) {
								return _Utils_ap(
									categoryGroup.additional,
									A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										_List_Nil,
										function (primaryCategory) {
											return _List_fromArray(
												[primaryCategory]);
										},
										categoryGroup.primary));
							},
							locationData.networkCategories.google));
					var _v2 = locationData.storeId;
					var storeId = _v2.a;
					var _v3 = function () {
						var _v4 = locationData.address.stateOrProvince;
						if (_v4.$ === 'WithState') {
							var state_ = _v4.a;
							return _Utils_Tuple3('', '', state_);
						} else {
							var data = _v4.a;
							return _Utils_Tuple3(data.province, data.district, '');
						}
					}();
					var province = _v3.a;
					var district = _v3.b;
					var state = _v3.c;
					var status = _Utils_eq(locationData.isActive, $author$project$Data$Location$Inactive) ? $author$project$Translations$General$disabled(session.translations) : (locationData.permanentlyClosed ? $author$project$Translations$General$closed(session.translations) : (isTemporarilyClosed ? $author$project$Translations$General$locationTempClosed(session.translations) : $author$project$Translations$General$open(session.translations)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								storeId: $elm$core$Maybe$Just(locationData.storeId),
								location: $author$project$RemoteData$Loaded(
									_Utils_update(
										locationData,
										{specialOpenHours: sortedSpecialOpenHours}))
							}),
						$elm$core$Platform$Cmd$batch(
							_Utils_ap(
								_List_fromArray(
									[
										A4($author$project$Location$Details$Commands$getConflictStatus, session.siteName, model.locationId, locationData, $author$project$Location$Details$App$OnConflictStatus),
										$author$project$Location$Details$Ports$out_Location_Details_Main_UpdateTitleBarAngular(
										{
											status: status,
											address: $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'street',
														$elm$json$Json$Encode$string(locationData.address.street)),
														_Utils_Tuple2(
														'zip',
														$elm$json$Json$Encode$string(locationData.address.zip)),
														_Utils_Tuple2(
														'city',
														$elm$json$Json$Encode$string(locationData.address.city)),
														_Utils_Tuple2(
														'country',
														$elm$json$Json$Encode$string(locationData.address.country)),
														_Utils_Tuple2(
														'countryAlpha2Code',
														$elm$json$Json$Encode$string(locationData.address.countryAlpha2Code)),
														_Utils_Tuple2(
														'state',
														$elm$json$Json$Encode$string(state)),
														_Utils_Tuple2(
														'province',
														$elm$json$Json$Encode$string(province)),
														_Utils_Tuple2(
														'district',
														$elm$json$Json$Encode$string(district))
													])),
											storeId: storeId,
											isActive: !_Utils_eq(
												status,
												$author$project$Translations$General$disabled(session.translations)),
											description: locationDescriptor
										})
									]),
								($elm$core$List$length(locationData.networkServiceItems.google) > 0) ? _List_fromArray(
									[
										A3($author$project$Data$NetworkData$GoogleServiceItems$getGoogleSupportedServiceItems, session.siteName, allCategories, $author$project$Location$Details$App$OnGoogleServiceItemsData)
									]) : _List_Nil)));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								location: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error)),
								customDataDefinition: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnLocationData'),
							error));
				}
			case 'OnConflictStatus':
				if (msg.a.$ === 'Ok') {
					var locationData = msg.a.a;
					var _v6 = locationData.specialOpenHours;
					var specialOpenHours = _v6.a;
					var specialOpenHoursConflict = _v6.b;
					var customDataDefinition = function () {
						var _v7 = model.customDataDefinition;
						if (_v7.$ === 'Loaded') {
							var data = _v7.a;
							return $elm$core$Maybe$Just(data);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var sortedSpecialOpenHours = $author$project$Data$Location$SpecialOpenHours$withSorted(specialOpenHours);
					var remoteData = $author$project$RemoteData$Loaded(
						_Utils_update(
							locationData,
							{
								specialOpenHours: A2($author$project$Location$Details$Model$SpecialOpenHours, sortedSpecialOpenHours, specialOpenHoursConflict)
							}));
					var newModelRemoteData = _Utils_update(
						model,
						{locationDataWithConflictStatus: remoteData});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationDetailPage: A2($author$project$Location$Details$App$initLocationDetailsPage, session, newModelRemoteData),
								locationDataWithConflictStatus: remoteData
							}),
						A4($author$project$Location$Details$Commands$getScheduleUpdates, session.siteName, model.locationId, customDataDefinition, $author$project$Location$Details$App$OnScheduleUpdates));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationDataWithConflictStatus: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnConflictStatus'),
							error));
				}
			case 'LocationDetailsPageMsg':
				var msg_ = msg.a;
				var _v8 = model.locationDetailPage;
				if (_v8.$ === 'Just') {
					var locationDetailPage = _v8.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (page) {
							return _Utils_update(
								model,
								{
									locationDetailPage: $elm$core$Maybe$Just(page)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Location$Details$App$LocationDetailsPageMsg),
						A3($author$project$Location$Details$Update$update, session, msg_, locationDetailPage));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnWorkSucceeded':
				var locationIds = msg.a.locationIds;
				return _Utils_Tuple2(
					model,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unpack,
						function (_v9) {
							return false;
						},
						function (detailPage) {
							return A2($elm$core$List$member, detailPage.locationId, locationIds);
						},
						model.locationDetailPage) ? A5(
						$author$project$Location$Details$Commands$getLocationData,
						session.siteName,
						model.locationId,
						model.features,
						$author$project$RemoteData$currentData(model.customDataDefinition),
						$author$project$Location$Details$App$OnLocationData) : $elm$core$Platform$Cmd$none);
			case 'OnWorkFailed':
				var locationIds = msg.a.locationIds;
				return _Utils_Tuple2(
					model,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unpack,
						function (_v10) {
							return false;
						},
						function (detailPage) {
							return A2($elm$core$List$member, detailPage.locationId, locationIds);
						},
						model.locationDetailPage) ? A5(
						$author$project$Location$Details$Commands$getLocationData,
						session.siteName,
						model.locationId,
						model.features,
						$author$project$RemoteData$currentData(model.customDataDefinition),
						$author$project$Location$Details$App$OnLocationData) : $elm$core$Platform$Cmd$none);
			case 'OnScheduleUpdates':
				if (msg.a.$ === 'Ok') {
					var scheduleUpdates = msg.a.a;
					var remoteData = $author$project$RemoteData$Loaded(scheduleUpdates);
					var newModelRemoteData = _Utils_update(
						model,
						{scheduleUpdates: remoteData});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								scheduleUpdates: remoteData,
								locationDetailPage: A2($author$project$Location$Details$App$initLocationDetailsPage, session, newModelRemoteData)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								scheduleUpdates: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Location.Details.Main.OnScheduleUpdates'),
							error));
				}
			case 'EditorMsg':
				var msg_ = msg.a;
				var _v11 = model.locationDetailPage;
				if (_v11.$ === 'Just') {
					var locationDetailPage = _v11.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (page) {
							return _Utils_update(
								model,
								{
									locationDetailPage: $elm$core$Maybe$Just(page)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Location$Details$App$LocationDetailsPageMsg),
						A3(
							$author$project$Location$Details$Update$update,
							session,
							$author$project$Location$Details$Model$EditorMsg(msg_),
							locationDetailPage));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnScrollToSection':
				var sectionId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Location$Details$App$ScrollToMsg,
						$rl_king$elm_scroll_to$ScrollTo$scrollTo(sectionId)));
			default:
				var msg_ = msg.a;
				var _v12 = A2($rl_king$elm_scroll_to$ScrollTo$update, msg_, model.scrollTo);
				var scrollToModel = _v12.a;
				var scrollToCmds = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{scrollTo: scrollToModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Location$Details$App$ScrollToMsg, scrollToCmds));
		}
	});
var $author$project$Location$LocationInfoPane$App$setLocation = F2(
	function (location, model) {
		var newModel = _Utils_update(
			model,
			{location: location});
		return _Utils_Tuple2(
			newModel,
			$author$project$Location$LocationInfoPane$App$loadCmds(newModel));
	});
var $author$project$Location$DetailsPage$SidePaneProjection$emptyToNothing = function (s) {
	return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$Location$DetailsPage$SidePaneProjection$isActiveToBool = function (isActive) {
	if (isActive.$ === 'Active') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneNetworkData = function (maybeNetworkData) {
	if (maybeNetworkData.$ === 'Nothing') {
		return {link: '', idSetType: $author$project$Data$Network$Disconnected, coverImageUrl: $elm$core$Maybe$Nothing, profileImageUrl: $elm$core$Maybe$Nothing};
	} else {
		var nd = maybeNetworkData.a;
		return {
			link: nd.data.link,
			idSetType: nd.idSetType,
			coverImageUrl: $author$project$Location$DetailsPage$SidePaneProjection$emptyToNothing(nd.data.coverImageUrl),
			profileImageUrl: $author$project$Location$DetailsPage$SidePaneProjection$emptyToNothing(nd.data.profileImageUrl)
		};
	}
};
var $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneLocation = F2(
	function (context, data) {
		return {
			id: data.id,
			ptv: $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneNetworkData(data.ptv),
			bing: $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneNetworkData(data.bing),
			name: data.name,
			apple: $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneNetworkData(data.apple),
			google: $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneNetworkData(data.google),
			address: data.address,
			contact: {
				email: $author$project$Data$Location$emailToString(data.email),
				phone: $author$project$Data$Location$phoneToString(data.phone),
				homepage: $author$project$Data$Location$homepageToString(data.homepage)
			},
			storeId: $author$project$Data$Location$storeIdToString(data.storeId),
			facebook: $author$project$Location$DetailsPage$SidePaneProjection$toSidePaneNetworkData(data.facebook),
			isActive: $author$project$Location$DetailsPage$SidePaneProjection$isActiveToBool(data.isActive),
			openHours: data.openHours,
			brandMedia: context.brandMedia,
			actionLinks: data.actionLinks,
			coordinates: data.location,
			locationType: data.locationType,
			siteCategories: context.siteCategories,
			longDescription: $author$project$Location$DetailsPage$SidePaneProjection$emptyToNothing(
				$author$project$Data$Location$longDescriptionToString(data.longDescription)),
			shortDescription: $author$project$Location$DetailsPage$SidePaneProjection$emptyToNothing(
				$author$project$Data$Location$shortDescriptionToString(data.about)),
			networkAttributes: $elm$core$Maybe$Just(data.networkAttributes),
			networkCategories: data.networkCategories,
			permanentlyClosed: data.permanentlyClosed,
			temporarilyClosedUntil: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Data$NetworkData$TemporarilyClosed$toString(data.temporarilyClosedUntil))
		};
	});
var $author$project$Location$DetailsPage$Bridge$syncSidePane = F4(
	function (siteContext, before, after, sidePane) {
		if (after.$ === 'Just') {
			var data = after.a;
			return (!_Utils_eq(before, after)) ? A2(
				$author$project$Location$LocationInfoPane$App$setLocation,
				A2($author$project$Location$DetailsPage$SidePaneProjection$toSidePaneLocation, siteContext, data),
				sidePane) : _Utils_Tuple2(sidePane, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(sidePane, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$Details$App$displayedLocation = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.location;
		},
		model.locationDetailPage);
};
var $author$project$Location$DetailsPage$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'DetailsMsg':
				var dMsg = msg.a;
				var _v1 = A3($author$project$Location$Details$App$update, session, dMsg, model.details);
				var details = _v1.a;
				var dCmd = _v1.b;
				var _v2 = A4(
					$author$project$Location$DetailsPage$Bridge$syncSidePane,
					model.siteContext,
					$author$project$Location$Details$App$displayedLocation(model.details),
					$author$project$Location$Details$App$displayedLocation(details),
					model.sidePane);
				var sidePane = _v2.a;
				var sCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{details: details, sidePane: sidePane}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Location$DetailsPage$Main$DetailsMsg, dCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Location$DetailsPage$Main$SidePaneMsg, sCmd)
							])));
			case 'SidePaneMsg':
				var sMsg = msg.a;
				var _v3 = A3($author$project$Location$LocationInfoPane$App$update, session, sMsg, model.sidePane);
				var sidePane = _v3.a;
				var sCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sidePane: sidePane}),
					A2($elm$core$Platform$Cmd$map, $author$project$Location$DetailsPage$Main$SidePaneMsg, sCmd));
			default:
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							onDetailsRoute: $author$project$Location$DetailsPage$Main$isDetailsRoute(url)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Location$DetailsPage$Main$Flags = F3(
	function (details, sidePane, initialPath) {
		return {details: details, sidePane: sidePane, initialPath: initialPath};
	});
var $author$project$Location$Details$App$Flags = F3(
	function (today, locationId, siteCategories) {
		return {today: today, locationId: locationId, siteCategories: siteCategories};
	});
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (_v0.$ === 'Ok') {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Location$Details$App$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'categories',
	$author$project$Data$Location$NetworkCategories$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locationId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'today',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			$elm$json$Json$Decode$succeed($author$project$Location$Details$App$Flags))));
var $author$project$Location$DetailsPage$Main$flagsDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Location$DetailsPage$Main$Flags,
	$author$project$Location$Details$App$flagsDecoder,
	$author$project$Location$LocationInfoPane$Decoders$flagsDecoder,
	A2($elm$json$Json$Decode$field, 'initialPath', $elm$json$Json$Decode$string));
var $author$project$Location$DetailsPage$Main$UrlChanged = function (a) {
	return {$: 'UrlChanged', a: a};
};
var $author$project$Location$Details$App$EditorMsg = function (a) {
	return {$: 'EditorMsg', a: a};
};
var $author$project$Location$Details$App$OnWorkFailed = function (a) {
	return {$: 'OnWorkFailed', a: a};
};
var $rl_king$elm_scroll_to$ScrollTo$Tick = function (a) {
	return {$: 'Tick', a: a};
};
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 'Delta', a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {subs: subs, oldTime: oldTime, request: request};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(_Utils_Tuple0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(_Utils_Tuple0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var oldTime = _v0.oldTime;
		var request = _v0.request;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 'Nothing') {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var oldTime = _v0.oldTime;
		var subs = _v0.subs;
		var send = function (sub) {
			if (sub.$ === 'Time') {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 'Time', a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (sub.$ === 'Time') {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $rl_king$elm_scroll_to$ScrollTo$subscriptions = function (state) {
	return $rl_king$elm_scroll_to$ScrollTo$isScrolling(state) ? $elm$browser$Browser$Events$onAnimationFrameDelta($rl_king$elm_scroll_to$ScrollTo$Tick) : $elm$core$Platform$Sub$none;
};
var $author$project$Location$ImageEditor$subscriptions = function (onImageCaptured) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Location$ImageEditor$EditorMsg,
		$author$project$Common$Image$Editor$subscriptions(onImageCaptured));
};
var $author$project$Location$Details$App$OnWorkSucceeded = function (a) {
	return {$: 'OnWorkSucceeded', a: a};
};
var $author$project$Location$Details$App$OnScrollToSection = function (a) {
	return {$: 'OnScrollToSection', a: a};
};
var $author$project$Location$Details$Ports$in_Location_Details_Main_workFailed = _Platform_incomingPort(
	'in_Location_Details_Main_workFailed',
	A2(
		$elm$json$Json$Decode$andThen,
		function (locationIds) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (workId) {
					return $elm$json$Json$Decode$succeed(
						{workId: workId, locationIds: locationIds});
				},
				A2($elm$json$Json$Decode$field, 'workId', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'locationIds',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Location$Details$Ports$in_Location_Details_Main_workSucceeded = _Platform_incomingPort(
	'in_Location_Details_Main_workSucceeded',
	A2(
		$elm$json$Json$Decode$andThen,
		function (locationIds) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (workId) {
					return $elm$json$Json$Decode$succeed(
						{workId: workId, locationIds: locationIds});
				},
				A2($elm$json$Json$Decode$field, 'workId', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'locationIds',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Location$Details$Ports$in_Location_Details_Main_onImageCaptured = _Platform_incomingPort('in_Location_Details_Main_onImageCaptured', $elm$json$Json$Decode$value);
var $author$project$Location$Details$Ports$in_Location_Details_Main_scrollToSection = _Platform_incomingPort('in_Location_Details_Main_scrollToSection', $elm$json$Json$Decode$string);
var $author$project$Location$Details$App$subscriptions = function (model) {
	var imageEditorSubscriptions = A2(
		$elm$core$Platform$Sub$map,
		A2($elm$core$Basics$composeR, $author$project$Location$Details$Model$ImageEditorMsg, $author$project$Location$Details$App$LocationDetailsPageMsg),
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					return $author$project$Location$ImageEditor$subscriptions($author$project$Location$Details$Ports$in_Location_Details_Main_onImageCaptured);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (page) {
						return page.imageEditor;
					},
					model.locationDetailPage))));
	var editorSubscriptions = A2(
		$elm$core$Platform$Sub$map,
		$author$project$Location$Details$App$EditorMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2(
				$elm$core$Maybe$map,
				$author$project$Location$Details$Editor$subscriptions,
				A2(
					$elm$core$Maybe$andThen,
					function (page) {
						return page.editor;
					},
					model.locationDetailPage))));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				editorSubscriptions,
				imageEditorSubscriptions,
				$author$project$Location$Details$Ports$in_Location_Details_Main_workSucceeded($author$project$Location$Details$App$OnWorkSucceeded),
				$author$project$Location$Details$Ports$in_Location_Details_Main_workFailed($author$project$Location$Details$App$OnWorkFailed),
				$author$project$Location$Details$Ports$in_Location_Details_Main_scrollToSection($author$project$Location$Details$App$OnScrollToSection),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Location$Details$App$ScrollToMsg,
				$rl_king$elm_scroll_to$ScrollTo$subscriptions(model.scrollTo))
			]));
};
var $author$project$Location$DetailsPage$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Location$DetailsPage$Main$DetailsMsg,
				$author$project$Location$Details$App$subscriptions(model.details)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Location$DetailsPage$Main$SidePaneMsg,
				$author$project$Location$LocationInfoPane$App$subscriptions(model.sidePane)),
				$author$project$Common$PollPortModule$urlChange(
				function (value) {
					return $author$project$Location$DetailsPage$Main$UrlChanged(
						A2(
							$elm$core$Result$withDefault,
							'',
							A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value)));
				})
			]));
};
var $author$project$Location$DetailsPage$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Location$DetailsPage$Main$init, view: $author$project$Location$DetailsPage$Main$view, update: $author$project$Location$DetailsPage$Main$update, flagsDecoder: $author$project$Location$DetailsPage$Main$flagsDecoder, subscriptions: $author$project$Location$DetailsPage$Main$subscriptions});
var $author$project$Tasks$Tomtom$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Tomtom$Claim$Commands$getAllTomtomCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/tomtom/categories')))));
	});
var $author$project$Tasks$Tomtom$Claim$Main$init = F2(
	function (session, flags) {
		return _Utils_Tuple2(
			{uiTable: $author$project$PinMeTo$Ui$Table$init, category: flags.category, uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, allCategories: $author$project$RemoteData$Loading, categoriesNotification: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Tomtom$Claim$Commands$getAllTomtomCategories, session.siteName, $author$project$Tasks$Tomtom$Claim$Model$GotAllCategories)
					])));
	});
var $author$project$Tasks$Tomtom$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Translations$Listings$Claim$claimTomtomLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_tomtom_locations');
};
var $author$project$Tasks$Tomtom$Claim$View$renderHeader = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorTomTom)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimTomtomLocations(translations))
					]))
			]));
};
var $author$project$Tasks$Tomtom$Claim$View$renderInnerContainer = F2(
	function (session, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Tasks$Tomtom$Claim$View$renderHeader(session.translations)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Tomtom$Claim$Sections$Shared$renderAlert = function (notification) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$html$Html$text(''),
		function (_v0) {
			var message = _v0.message;
			var state = _v0.state;
			return $author$project$PinMeTo$Ui$Alert$render(
				function () {
					switch (state.$) {
						case 'Success':
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
						case 'Failed':
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
						default:
							return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
					}
				}()(
					$author$project$PinMeTo$Ui$Alert$plain(message)));
		},
		notification);
};
var $author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Tasks$Tomtom$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Tomtom$Claim$Update$isCategorySelected = function (model) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(model.category);
};
var $author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Tomtom$Claim$Update$isCategorySelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Tomtom$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Tasks$Tomtom$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Tasks$Tomtom$Claim$Model$SelectedCategory = function (a) {
	return {$: 'SelectedCategory', a: a};
};
var $author$project$Translations$Listings$LocationDetail$categoriesTomtom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_tomtom');
};
var $author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$renderCategorySelector = F5(
	function (uid, translations, model, categories, category) {
		var title = $author$project$Translations$Listings$LocationDetail$categoriesTomtom(translations);
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid,
													items: A2($author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Tomtom$Claim$Model$UiSelectMsg,
													onChange: $author$project$Tasks$Tomtom$Claim$Model$SelectedCategory,
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								]))
						]))
				]));
	});
var $author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = function () {
			var _v0 = model.allCategories;
			if (_v0.$ === 'Loaded') {
				var categories = _v0.a;
				return $author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$sortCategories(categories);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Tasks$Shared$Components$Header$renderHeader,
							$author$project$Translations$Listings$Claim$categories(translations),
							$elm$core$Maybe$Nothing),
							$author$project$Tasks$Tomtom$Claim$Sections$Shared$renderAlert(model.categoriesNotification),
							A5($author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-category', translations, model, sortedCategories, model.category),
							A2($author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
						]))
				]));
	});
var $author$project$Tasks$Tomtom$Claim$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Tomtom$Claim$View$renderInnerContainer, session, model),
						$author$project$Tasks$Tomtom$Claim$View$lineSeparator,
						A2($author$project$Tasks$Tomtom$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Tomtom$Claim$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Tasks$Tomtom$Claim$Commands$encodeCategory = function (networkCategory) {
	var _v0 = $author$project$Data$Location$NetworkCategories$toTomtom(
		$elm$core$Maybe$Just(networkCategory));
	if (_v0.$ === 'Just') {
		var tomtomCat = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'featureTypeId',
					$elm$json$Json$Encode$string(tomtomCat.featureTypeId)),
					_Utils_Tuple2(
					'serviceSubCategoryId',
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, tomtomCat.serviceSubCategoryId)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(tomtomCat.name))
				]));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Tasks$Tomtom$Claim$Commands$encodeCategories = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Encode$null,
		A2($elm$core$Maybe$map, $author$project$Tasks$Tomtom$Claim$Commands$encodeCategory, model.category));
};
var $author$project$Tasks$Tomtom$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var sitename = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Tomtom$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (sitename + '/tomtom/categories')))));
	});
var $author$project$Tasks$Tomtom$Claim$Update$emptyNotification = function (model) {
	return _Utils_update(
		model,
		{categoriesNotification: $elm$core$Maybe$Nothing});
};
var $author$project$Tasks$Tomtom$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Tomtom$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Tomtom$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				categoriesNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$Tomtom$Claim$Update$handleCategoriesError = F3(
	function (_v0, err, model) {
		var updatedModel = A3(
			$author$project$Tasks$Tomtom$Claim$Update$updateNotification,
			$author$project$Tasks$Tomtom$Claim$Model$Failed,
			$author$project$PinMeTo$ExpectJson$getErrorMessage(err),
			model);
		return _Utils_Tuple2(
			_Utils_update(
				updatedModel,
				{
					allCategories: $author$project$RemoteData$Error(
						$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
				}),
			$author$project$PinMeTo$Logger$log(
				{
					data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
					context: 'Tasks.Tomtom.Claim.Update.GotAllCategories',
					message: 'Failed to decode response GotAllCategories'
				}));
	});
var $author$project$Tasks$Tomtom$Claim$Model$Success = {$: 'Success'};
var $author$project$Tasks$Tomtom$Claim$Update$handleSaveCategoriesResultOk = F3(
	function (session, success, model) {
		var _v0 = success ? _Utils_Tuple2(
			$author$project$Tasks$Tomtom$Claim$Model$Success,
			$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
			$author$project$Tasks$Tomtom$Claim$Model$Failed,
			$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
		var notificationState = _v0.a;
		var notificationMessage = _v0.b;
		return _Utils_Tuple2(
			A3($author$project$Tasks$Tomtom$Claim$Update$updateNotification, notificationState, notificationMessage, model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Tasks$Tomtom$Claim$Update$handleSaveCategoriesResultErr = F2(
	function (err, model) {
		var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
		return _Utils_Tuple2(
			A3($author$project$Tasks$Tomtom$Claim$Update$updateNotification, $author$project$Tasks$Tomtom$Claim$Model$Failed, message, model),
			$author$project$PinMeTo$Logger$log(
				{data: message, context: 'Tasks.Tomtom.Claim.Update.SaveCategoriesResult', message: 'Failed to decode response SaveCategoriesResult'}));
	});
var $author$project$Tasks$Tomtom$Claim$Update$update = F3(
	function (session, msg, model) {
		var modelClearedNotifications = $author$project$Tasks$Tomtom$Claim$Update$emptyNotification(model);
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Tomtom$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Tomtom$Claim$Model$UiPopOverMsg, msg_, model.uiPopover));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							modelClearedNotifications,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return A3($author$project$Tasks$Tomtom$Claim$Update$handleCategoriesError, session, err, model);
				}
			case 'SelectedCategory':
				var category = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{
							category: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SaveCategories':
				return $author$project$Tasks$Tomtom$Claim$Update$isCategorySelected(model) ? _Utils_Tuple2(
					modelClearedNotifications,
					A3($author$project$Tasks$Tomtom$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Tomtom$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					return A3($author$project$Tasks$Tomtom$Claim$Update$handleSaveCategoriesResultOk, session, success, model);
				} else {
					var err = msg.a.a;
					return A2($author$project$Tasks$Tomtom$Claim$Update$handleSaveCategoriesResultErr, err, model);
				}
			default:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Tomtom$Claim$Model$Flags = function (category) {
	return {category: category};
};
var $author$project$Tasks$Tomtom$Claim$Commands$flagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Tasks$Tomtom$Claim$Model$Flags,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$map($author$project$Data$Location$NetworkCategories$TomtomNetworkCategory),
		A2(
			$elm$json$Json$Decode$field,
			'category',
			$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$tomtomCategoryDecoder))));
var $author$project$Tasks$Tomtom$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$Tomtom$Claim$Main$init,
		view: function (session) {
			return $author$project$Tasks$Tomtom$Claim$View$view(session);
		},
		update: $author$project$Tasks$Tomtom$Claim$Update$update,
		flagsDecoder: $author$project$Tasks$Tomtom$Claim$Commands$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Google$Claim$Model$Idle = {$: 'Idle'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$GotLinkedChain = function (a) {
	return {$: 'GotLinkedChain', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$chainBaseUrl = function (siteName) {
	return 'api/' + (siteName + '/google/claim/chains');
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkedChain = F2(
	function (id, names) {
		return {id: id, names: names};
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LocalizedText = F2(
	function (displayName, languageCode) {
		return {displayName: displayName, languageCode: languageCode};
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$localizedTextDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'languageCode',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'displayName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LocalizedText)));
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$serverErrorMessageDecoder = A2(
	$elm$json$Json$Decode$field,
	'error',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('Unknown error')
			])));
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$linkedChainDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$andThen, $elm$json$Json$Decode$fail, $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$serverErrorMessageDecoder),
			A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (id, names) {
					return $elm$core$Maybe$Just(
						A2($author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkedChain, id, names));
				}),
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$field,
				'names',
				$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$localizedTextDecoder))),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$getLinkedChain = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$linkedChainDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$chainBaseUrl(siteName)))));
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation = {$: 'NoChainOperation'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Main$init = function (session) {
	return _Utils_Tuple2(
		$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
			{linkedChain: $author$project$RemoteData$Loading, expandedChain: $elm$core$Maybe$Nothing, chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation, chainSearchTerm: '', chainSearchResults: $author$project$RemoteData$Suspended}),
		A2($author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$getLinkedChain, session.siteName, $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$GotLinkedChain));
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$GotSuggestedMatches = function (a) {
	return {$: 'GotSuggestedMatches', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$emptyPmtData = {name: '', address: $author$project$Data$Address$emptyAddress, storeId: '', category: ''};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$SuggestedMatch = F6(
	function (id, locationId, googleId, data, pmtData, distanceInMeters) {
		return {id: id, data: data, pmtData: pmtData, googleId: googleId, locationId: locationId, distanceInMeters: distanceInMeters};
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$PmtData = F4(
	function (name, storeId, address, category) {
		return {name: name, address: address, storeId: storeId, category: category};
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$pmtDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'category',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'address',
		$author$project$Data$Address$addressDecoder,
		$author$project$Data$Address$emptyAddress,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'storeId',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'name',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$PmtData)))));
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$emptyGoogleData = {link: '', name: '', address: $author$project$Data$Address$emptyAddress, storeId: '', category: ''};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$GoogleData = F5(
	function (name, storeId, address, link, category) {
		return {link: link, name: name, address: address, storeId: storeId, category: category};
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$googleDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['primaryCategory', 'name']),
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'link',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'address',
			$author$project$Data$Address$addressDecoder,
			$author$project$Data$Address$emptyAddress,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'storeId',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$string,
					'',
					$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$GoogleData))))));
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$suggestedMatchDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'distanceInMeters',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pmtData',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$emptyPmtData),
			$elm$json$Json$Decode$nullable($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$pmtDataDecoder)),
		$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$emptyPmtData,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'data',
			$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$googleDataDecoder,
			$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$emptyGoogleData,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'googleId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$SuggestedMatch)))))));
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$suggestedMatchesResponseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'data',
	$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$suggestedMatchDecoder),
	_List_Nil,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Commands$getSuggestedMatches = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$suggestedMatchesResponseDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/google/claim/suggestedMatches')))));
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Main$init = function (session) {
	return _Utils_Tuple2(
		$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
			{uiPopOver: $author$project$PinMeTo$Ui$PopOver$init, confirming: false, confirmError: $elm$core$Maybe$Nothing, selectedMatches: $elm$core$Set$empty, suggestedMatches: $author$project$RemoteData$Loading}),
		A2($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Commands$getSuggestedMatches, session.siteName, $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$GotSuggestedMatches));
};
var $author$project$Tasks$Google$Claim$Model$NotConnecting = {$: 'NotConnecting'};
var $author$project$Tasks$Google$Claim$Model$ChainSectionMsg = function (a) {
	return {$: 'ChainSectionMsg', a: a};
};
var $author$project$Tasks$Google$Claim$Model$GotPmtLocations = function (a) {
	return {$: 'GotPmtLocations', a: a};
};
var $author$project$Tasks$Google$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Google$Claim$Model$GotBusinessAccounts = function (a) {
	return {$: 'GotBusinessAccounts', a: a};
};
var $author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg = function (a) {
	return {$: 'SuggestedMatchesMsg', a: a};
};
var $author$project$Tasks$Google$Claim$View$scaledVerificationUsers = $elm$core$Set$fromList(
	_List_fromArray(
		['lasse.poulsen@pinmeto.com', 'oliver.deaquino@pinmeto.com', 'andrew.rix@pinmeto.com', 'josefine.sahlin@pinmeto.com', 'sandra.bazior@pinmeto.com', 'maria.gronqvist@pinmeto.com']));
var $author$project$Tasks$Google$Claim$View$shouldSeeVerification = function (user) {
	return A2($elm$core$Set$member, user.email, $author$project$Tasks$Google$Claim$View$scaledVerificationUsers);
};
var $author$project$Tasks$Google$Claim$Model$GotNotMatchedLocations = function (a) {
	return {$: 'GotNotMatchedLocations', a: a};
};
var $author$project$Tasks$Google$Claim$Model$GotUnverifiedLocations = function (a) {
	return {$: 'GotUnverifiedLocations', a: a};
};
var $author$project$Tasks$Google$Claim$Commands$getAllGoogleCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/google/categories');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Tables$OpenStatus$Unknown = {$: 'Unknown'};
var $author$project$Tasks$Google$Claim$Model$NoDuplicate = {$: 'NoDuplicate'};
var $author$project$Tasks$Google$Claim$Model$GoogleMatches = function (source) {
	return function (storeId) {
		return function (openStatus) {
			return function (name) {
				return function (address) {
					return function (hasVoiceOfMerchant) {
						return function (requestClaimUrl) {
							return function (duplicateLocation) {
								return function (mapsUri) {
									return function (googleBusinessId) {
										return function (location) {
											return {name: name, source: source, address: address, mapsUri: mapsUri, storeId: storeId, location: location, openStatus: openStatus, requestClaimUrl: requestClaimUrl, googleBusinessId: googleBusinessId, duplicateLocation: duplicateLocation, hasVoiceOfMerchant: hasVoiceOfMerchant};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Tasks$Google$Claim$Tables$OpenStatus$Open = {$: 'Open'};
var $author$project$Tasks$Google$Claim$Tables$OpenStatus$PermanentlyClosed = {$: 'PermanentlyClosed'};
var $author$project$Tasks$Google$Claim$Tables$OpenStatus$TemporarilyClosed = {$: 'TemporarilyClosed'};
var $author$project$Tasks$Google$Claim$Decoders$openStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		switch (status) {
			case 'open':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Tables$OpenStatus$Open);
			case 'temporarilyClosed':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Tables$OpenStatus$TemporarilyClosed);
			case 'permanentlyClosed':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Tables$OpenStatus$PermanentlyClosed);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Tables$OpenStatus$Unknown);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Tasks$Google$Claim$Model$ExternalDuplicate = function (a) {
	return {$: 'ExternalDuplicate', a: a};
};
var $author$project$Tasks$Google$Claim$Model$InternalDuplicate = function (a) {
	return {$: 'InternalDuplicate', a: a};
};
var $author$project$Tasks$Google$Claim$Decoders$googleDuplicateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (maybeLocation) {
		if (maybeLocation.$ === 'Nothing') {
			return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$NoDuplicate);
		} else {
			var loc = maybeLocation.a;
			return A2(
				$elm$json$Json$Decode$map,
				function (isInternal) {
					return isInternal ? $author$project$Tasks$Google$Claim$Model$InternalDuplicate(loc) : $author$project$Tasks$Google$Claim$Model$ExternalDuplicate(loc);
				},
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'duplicateInternal', $elm$json$Json$Decode$bool),
							$elm$json$Json$Decode$succeed(false)
						])));
		}
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'duplicateLocation', $elm$json$Json$Decode$string)));
var $author$project$Tasks$Google$Claim$Model$OwnedBusinessProfile = {$: 'OwnedBusinessProfile'};
var $author$project$Tasks$Google$Claim$Model$UnownedBusinessProfile = {$: 'UnownedBusinessProfile'};
var $author$project$Tasks$Google$Claim$Decoders$googleMatchSourceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (source) {
		switch (source) {
			case 'ownedBusinessProfile':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$OwnedBusinessProfile);
			case 'unownedBusinessProfile':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$UnownedBusinessProfile);
			default:
				return $elm$json$Json$Decode$fail('Unknown source: ' + source);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Tasks$Google$Claim$Decoders$googleMatchesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['location', 'location']),
	$elm$json$Json$Decode$nullable($author$project$Data$Coordinates$coordinatesDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['location', 'link']),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['location', 'metadata']),
				$author$project$Tasks$Google$Claim$Decoders$googleDuplicateDecoder,
				$author$project$Tasks$Google$Claim$Model$NoDuplicate,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'requestClaimUrl',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['location', 'metadata', 'hasVoiceOfMerchant']),
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['location', 'address']),
							$author$project$Data$Address$addressDecoder,
							$author$project$Data$Address$emptyAddress,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['location', 'name']),
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['location', 'openStatus']),
									$author$project$Tasks$Google$Claim$Decoders$openStatusDecoder,
									$author$project$Tasks$Google$Claim$Tables$OpenStatus$Unknown,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
										_List_fromArray(
											['location', 'storeId']),
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'source',
											$author$project$Tasks$Google$Claim$Decoders$googleMatchSourceDecoder,
											$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$GoogleMatches))))))))))));
var $author$project$Tasks$Google$Claim$Commands$getNotMatchedLocations = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/claim/notMatchedGbpLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$googleMatchesDecoder)),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Model$GotLocationFinderStatus = function (a) {
	return {$: 'GotLocationFinderStatus', a: a};
};
var $author$project$Tasks$Google$Claim$Model$LocationFinderStatusResult = F3(
	function (status, timestamp, progress) {
		return {status: status, progress: progress, timestamp: timestamp};
	});
var $author$project$Tasks$Google$Claim$Model$Running = {$: 'Running'};
var $author$project$Tasks$Google$Claim$Model$FinderError = function (a) {
	return {$: 'FinderError', a: a};
};
var $author$project$Tasks$Google$Claim$Decoders$locationFinderStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'queued':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$Running);
			case 'running':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$Running);
			case 'error':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Tasks$Google$Claim$Model$FinderError,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed('')
							])));
			default:
				return $elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$Idle);
		}
	},
	A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string));
var $author$project$Tasks$Google$Claim$Model$LocationFinderProgress = F3(
	function (current, total, accountName) {
		return {total: total, current: current, accountName: accountName};
	});
var $author$project$Tasks$Google$Claim$Decoders$locationFinderProgressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accountName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$LocationFinderProgress))));
var $author$project$Tasks$Google$Claim$Decoders$locationFinderTimestampDecoder = A2(
	$elm$json$Json$Decode$map,
	function (timestamp) {
		return $elm$core$String$isEmpty(timestamp) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(timestamp);
	},
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'timestamp', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])));
var $author$project$Tasks$Google$Claim$Decoders$locationFinderStatusDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Tasks$Google$Claim$Model$LocationFinderStatusResult,
	$author$project$Tasks$Google$Claim$Decoders$locationFinderStateDecoder,
	$author$project$Tasks$Google$Claim$Decoders$locationFinderTimestampDecoder,
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'progress', $author$project$Tasks$Google$Claim$Decoders$locationFinderProgressDecoder)));
var $author$project$Tasks$Google$Claim$Commands$getLocationFinderStatus = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/locationfinderstatus');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Decoders$locationFinderStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Model$GotCreateLocationsStatus = function (a) {
	return {$: 'GotCreateLocationsStatus', a: a};
};
var $author$project$Tasks$Google$Claim$Model$Queued = {$: 'Queued'};
var $author$project$Tasks$Google$Claim$Model$Created = {$: 'Created'};
var $author$project$Tasks$Google$Claim$Model$Creating = {$: 'Creating'};
var $author$project$Tasks$Google$Claim$Model$CreateFailed = function (a) {
	return {$: 'CreateFailed', a: a};
};
var $author$project$Tasks$Google$Claim$Model$createStateFromString = F2(
	function (state, message) {
		switch (state) {
			case 'queued':
				return $author$project$Tasks$Google$Claim$Model$Queued;
			case 'creating':
				return $author$project$Tasks$Google$Claim$Model$Creating;
			case 'created':
				return $author$project$Tasks$Google$Claim$Model$Created;
			case 'failed':
				return $author$project$Tasks$Google$Claim$Model$CreateFailed(message);
			default:
				return $author$project$Tasks$Google$Claim$Model$Queued;
		}
	});
var $author$project$Tasks$Google$Claim$Decoders$createStateDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Tasks$Google$Claim$Model$createStateFromString,
	A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'errorMessage', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])));
var $author$project$Tasks$Google$Claim$Decoders$createStatesDecoder = $elm$json$Json$Decode$dict($author$project$Tasks$Google$Claim$Decoders$createStateDecoder);
var $author$project$Tasks$Google$Claim$Decoders$createLocationsStatusDecoder = A2($elm$json$Json$Decode$field, 'states', $author$project$Tasks$Google$Claim$Decoders$createStatesDecoder);
var $author$project$Tasks$Google$Claim$Commands$getCreateLocationsStatus = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/claim/createLocationsStatus');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Decoders$createLocationsStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Model$PmtLocation = F7(
	function (id, name, storeId, address, location, openStatus, createdAt) {
		return {id: id, name: name, address: address, storeId: storeId, location: location, createdAt: createdAt, openStatus: openStatus};
	});
var $author$project$Tasks$Google$Claim$Decoders$pmtLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'createdAt',
	A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'openStatus',
		$author$project$Tasks$Google$Claim$Decoders$openStatusDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'location',
			$author$project$Data$Coordinates$coordinatesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'address',
				$author$project$Data$Address$addressDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'storeId',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$PmtLocation))))))));
var $author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/claim/unclaimedPmtLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$pmtLocationDecoder)),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Commands$getBusinessAccountsForSite = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/claim/businessAccounts');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$BrandManagement$Google$Decoders$partialGoogleBusinessAccountDecoder)),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Model$UnverifiedLocation = F5(
	function (id, name, storeId, address, googleId) {
		return {id: id, name: name, address: address, storeId: storeId, googleId: googleId};
	});
var $author$project$Tasks$Google$Claim$Decoders$unverifiedLocationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['google', 'id']),
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$Data$Address$addressDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'storeId',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'_id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$UnverifiedLocation))))));
var $author$project$Tasks$Google$Claim$Commands$getUnverifiedGoogleLocations = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/claim/unverifiedGoogleLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$unverifiedLocationDecoder)),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Main$init = F2(
	function (session, flags) {
		var _v0 = $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Main$init(session);
		var suggestedMatchesState = _v0.a;
		var suggestedMatchesCmd = _v0.b;
		var _v1 = $author$project$Tasks$Google$Claim$Sections$ChainSection$Main$init(session);
		var chainSectionState = _v1.a;
		var chainSectionCmd = _v1.b;
		var isDev = A2($author$project$Data$User$hasRole, session.user, $author$project$Data$User$PinMeToDeveloper);
		return _Utils_Tuple2(
			{
				isDev: isDev,
				creating: false,
				uiSelect: $author$project$PinMeTo$Ui$Select$init,
				uiPopOver: $author$project$PinMeTo$Ui$PopOver$init,
				uiTooltip: $author$project$PinMeTo$Ui$AdvancedTooltip$init,
				connecting: $author$project$Tasks$Google$Claim$Model$NotConnecting,
				uiGbpTable: $author$project$PinMeTo$Ui$Table$init,
				expandedRow: $elm$core$Maybe$Nothing,
				columnWidths: _List_Nil,
				createStates: $elm$core$Dict$empty,
				innerMatches: $author$project$RemoteData$Suspended,
				pmtLocations: $author$project$RemoteData$Loading,
				uiInnerTable: $author$project$PinMeTo$Ui$Table$init,
				uiOuterTable: $author$project$PinMeTo$Ui$Table$init,
				verifyStates: $elm$core$Dict$empty,
				allCategories: $author$project$RemoteData$Loading,
				lastImportStats: $elm$core$Maybe$Nothing,
				primaryCategory: flags.categories.primaryCategory,
				businessAccounts: $author$project$RemoteData$Loading,
				chainSectionState: chainSectionState,
				createNotification: $elm$core$Maybe$Nothing,
				notMatchedLocations: $author$project$RemoteData$Loading,
				uiVerificationTable: $author$project$PinMeTo$Ui$Table$init,
				unverifiedLocations: $author$project$Tasks$Google$Claim$View$shouldSeeVerification(session.user) ? $author$project$RemoteData$Loading : $author$project$RemoteData$Suspended,
				locationFinderStatus: $author$project$Tasks$Google$Claim$Model$Idle,
				locationFinderLastRun: $elm$core$Maybe$Nothing,
				suggestedMatchesState: suggestedMatchesState,
				categoriesNotification: $elm$core$Maybe$Nothing,
				locationFinderProgress: $elm$core$Maybe$Nothing,
				selectedBusinessAccount: $elm$core$Maybe$Nothing,
				additionalCategoriesList: flags.categories.additionalCategories
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations),
						A2($author$project$Tasks$Google$Claim$Commands$getNotMatchedLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotNotMatchedLocations),
						A2($author$project$Tasks$Google$Claim$Commands$getBusinessAccountsForSite, session.siteName, $author$project$Tasks$Google$Claim$Model$GotBusinessAccounts),
						A2($author$project$Tasks$Google$Claim$Commands$getLocationFinderStatus, session.siteName, $author$project$Tasks$Google$Claim$Model$GotLocationFinderStatus),
						A2($author$project$Tasks$Google$Claim$Commands$getCreateLocationsStatus, session.siteName, $author$project$Tasks$Google$Claim$Model$GotCreateLocationsStatus),
						A2($author$project$Tasks$Google$Claim$Commands$getAllGoogleCategories, session.siteName, $author$project$Tasks$Google$Claim$Model$GotAllCategories),
						A2($elm$core$Platform$Cmd$map, $author$project$Tasks$Google$Claim$Model$ChainSectionMsg, chainSectionCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg, suggestedMatchesCmd),
						$author$project$Tasks$Google$Claim$View$shouldSeeVerification(session.user) ? A2($author$project$Tasks$Google$Claim$Commands$getUnverifiedGoogleLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotUnverifiedLocations) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingXL = {$: 'SpacingXL'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$rowLayout = A2(
	$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
	$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXL,
	A2(
		$author$project$PinMeTo$Ui$Layout$Flex$withAlign,
		$author$project$PinMeTo$Ui$Layout$Flex$AlignCenter,
		A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)));
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$SearchChains = {$: 'SearchChains'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$ChainSearchTermChanged = function (a) {
	return {$: 'ChainSearchTermChanged', a: a};
};
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionSearch = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_search');
};
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionSearchBrandsPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_search_brands_placeholder');
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderSearchForm = F2(
	function (translations, _v0) {
		var model = _v0.a;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chain-section__search-form'),
					$elm$html$Html$Events$onSubmit($author$project$Tasks$Google$Claim$Sections$ChainSection$Model$SearchChains)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Layout$Flex$render,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								$author$project$Translations$Listings$Claim$googleMatchesChainSectionSearchBrandsPlaceholder(translations),
								$author$project$PinMeTo$Ui$Form$Input$search(
									{value: model.chainSearchTerm, onChange: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$ChainSearchTermChanged}))),
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								$elm$core$String$isEmpty(
									$elm$core$String$trim(model.chainSearchTerm)),
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$SearchChains,
									$author$project$PinMeTo$Ui$Button$buttonSecondary(
										$author$project$Translations$Listings$Claim$googleMatchesChainSectionSearch(translations)))))
						]),
					$author$project$Tasks$Google$Claim$Sections$ChainSection$View$rowLayout)
				]));
	});
var $author$project$PinMeTo$Ui$SkeletonV2$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$PinMeTo$Ui$SkeletonV2$wrap = F2(
	function (content, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SkeletonV2$Config(
			_Utils_update(
				config,
				{
					content: $elm$core$Maybe$Just(content)
				}));
	});
var $author$project$PinMeTo$Ui$SkeletonV2$renderTextSkeleton = function (config) {
	if (!config.loading) {
		var _v0 = config.content;
		if (_v0.$ === 'Just') {
			var content = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[content]));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	} else {
		var shimmerClass = function () {
			var _v1 = config.shimmer;
			switch (_v1.$) {
				case 'Pulse':
					return 'pmt-ui-skeleton-v2--pulse';
				case 'Gradient':
					return 'pmt-ui-skeleton-v2--gradient';
				default:
					return 'pmt-ui-skeleton-v2--none';
			}
		}();
		var line = function (index) {
			var widthPercent = _Utils_eq(index, config.noOfLines - 1) ? '80%' : '100%';
			var marginBottom = _Utils_eq(index, config.noOfLines - 1) ? '0' : ($elm$core$String$fromInt(config.spacing) + 'px');
			return A3(
				$elm$html$Html$node,
				'span',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-skeleton-v2'),
						$elm$html$Html$Attributes$class(shimmerClass),
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', marginBottom)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', widthPercent),
								A2($elm$html$Html$Attributes$style, 'height', '1.2em'),
								A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
							]),
						_List_Nil)
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				line,
				A2($elm$core$List$range, 0, config.noOfLines - 1)));
	}
};
var $author$project$PinMeTo$Ui$SkeletonV2$renderRegularSkeleton = function (config) {
	var _v0 = config.content;
	if (_v0.$ === 'Nothing') {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var content = _v0.a;
		if (!config.loading) {
			return content;
		} else {
			var shimmerClass = function () {
				var _v1 = config.shimmer;
				switch (_v1.$) {
					case 'Pulse':
						return 'pmt-ui-skeleton-v2--pulse';
					case 'Gradient':
						return 'pmt-ui-skeleton-v2--gradient';
					default:
						return 'pmt-ui-skeleton-v2--none';
				}
			}();
			return A3(
				$elm$html$Html$node,
				'span',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-skeleton-v2'),
						$elm$html$Html$Attributes$class(shimmerClass)
					]),
				_List_fromArray(
					[content]));
		}
	}
};
var $author$project$PinMeTo$Ui$SkeletonV2$render = function (_v0) {
	var config = _v0.a;
	return config.isTextMode ? $author$project$PinMeTo$Ui$SkeletonV2$renderTextSkeleton(config) : $author$project$PinMeTo$Ui$SkeletonV2$renderRegularSkeleton(config);
};
var $author$project$PinMeTo$Ui$SkeletonV2$Gradient = {$: 'Gradient'};
var $author$project$PinMeTo$Ui$SkeletonV2$skeleton = $author$project$PinMeTo$Ui$SkeletonV2$Config(
	{content: $elm$core$Maybe$Nothing, loading: false, shimmer: $author$project$PinMeTo$Ui$SkeletonV2$Gradient, spacing: 8, noOfLines: 3, isTextMode: false});
var $author$project$PinMeTo$Ui$SkeletonV2$isLoading = F2(
	function (loading, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SkeletonV2$Config(
			_Utils_update(
				config,
				{loading: loading}));
	});
var $author$project$PinMeTo$Ui$SkeletonV2$withVariant = F2(
	function (variant, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$SkeletonV2$Config(
			_Utils_update(
				config,
				{shimmer: variant}));
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$UnlinkChain = {$: 'UnlinkChain'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderUnlinkButton = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Ui$Button$render(
		A2(
			$author$project$PinMeTo$Ui$Button$disabledIfTrue,
			!_Utils_eq(model.chainOperation, $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation),
			A2(
				$author$project$PinMeTo$Ui$Button$withOnClick,
				$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$UnlinkChain,
				A2(
					$author$project$PinMeTo$Ui$Button$withIconOnly,
					$author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faXmark),
					A2(
						$author$project$PinMeTo$Ui$Button$withGhostStyle,
						$author$project$PinMeTo$Ui$Button$GhostNeutral,
						$author$project$PinMeTo$Ui$Button$buttonGhost(''))))));
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoOp = {$: 'NoOp'};
var $elm$html$Html$sup = _VirtualDom_node('sup');
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLocalizedNames = function (names) {
	return A2(
		$author$project$PinMeTo$Ui$Layout$Flex$render,
		A2(
			$elm$core$List$map,
			function (name) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name.displayName),
							$elm$core$String$isEmpty(name.languageCode) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$sup,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chain-section__language-code')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(' + (name.languageCode + ')'))
								]))
						]));
			},
			names),
		A2(
			$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
			$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
			$author$project$PinMeTo$Ui$Layout$Flex$withWrap($author$project$PinMeTo$Ui$Layout$Flex$flex)));
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLinkedChainCard = function (linked) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chain-section__card chain-section--max-width')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Ui$Layout$Flex$render,
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Form$Radio$render(
						$author$project$PinMeTo$Ui$Form$Radio$radio(
							{
								label: '',
								checked: true,
								onChange: function (_v0) {
									return $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoOp;
								}
							})),
						$author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLocalizedNames(linked.names)
					]),
				A2(
					$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
					$author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD,
					A2($author$project$PinMeTo$Ui$Layout$Flex$withAlign, $author$project$PinMeTo$Ui$Layout$Flex$AlignCenter, $author$project$PinMeTo$Ui$Layout$Flex$flex)))
			]));
};
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionFailedToLoadLinked = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_failed_to_load_linked');
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLinkedChain = F2(
	function (translations, _v0) {
		var model = _v0.a;
		var _v1 = model.linkedChain;
		_v1$3:
		while (true) {
			switch (_v1.$) {
				case 'Loading':
					return $author$project$PinMeTo$Ui$SkeletonV2$render(
						A2(
							$author$project$PinMeTo$Ui$SkeletonV2$isLoading,
							true,
							A2(
								$author$project$PinMeTo$Ui$SkeletonV2$wrap,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('chain-section__linked-placeholder')
										]),
									_List_Nil),
								A2($author$project$PinMeTo$Ui$SkeletonV2$withVariant, $author$project$PinMeTo$Ui$SkeletonV2$Gradient, $author$project$PinMeTo$Ui$SkeletonV2$skeleton))));
				case 'Loaded':
					if (_v1.a.$ === 'Just') {
						var linked = _v1.a.a;
						return A2(
							$author$project$PinMeTo$Ui$Layout$Flex$render,
							_List_fromArray(
								[
									$author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLinkedChainCard(linked),
									$author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderUnlinkButton(
									$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(model))
								]),
							$author$project$Tasks$Google$Claim$Sections$ChainSection$View$rowLayout);
					} else {
						break _v1$3;
					}
				case 'Error':
					return $author$project$PinMeTo$Ui$Alert$render(
						A2(
							$author$project$PinMeTo$Ui$Alert$withStatus,
							$author$project$PinMeTo$Ui$Alert$Error,
							$author$project$PinMeTo$Ui$Alert$plain(
								$author$project$Translations$Listings$Claim$googleMatchesChainSectionFailedToLoadLinked(translations))));
				default:
					break _v1$3;
			}
		}
		return $elm$html$Html$text('');
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$resultStack = A2(
	$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
	$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
	A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex));
var $author$project$PinMeTo$Ui$Layout$Shared$withAttributes = F2(
	function (attrs, config) {
		return _Utils_update(
			config,
			{
				attributes: _Utils_ap(config.attributes, attrs)
			});
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkChain = function (a) {
	return {$: 'LinkChain', a: a};
};
var $author$project$FontAwesome$Solid$Icon$faChevronUp = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-chevron-up');
var $author$project$PinMeTo$Ui$Layout$Spacing$SpacingXXXL = {$: 'SpacingXXXL'};
var $author$project$PinMeTo$Ui$Layout$Spacing$withPaddingLeft = F2(
	function (spacing, config) {
		var padding_ = config.padding;
		return _Utils_update(
			config,
			{
				padding: _Utils_update(
					padding_,
					{
						left: $elm$core$Maybe$Just(spacing)
					})
			});
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderWebsites = function (websites) {
	return $elm$core$List$isEmpty(websites) ? $elm$html$Html$text('') : A2(
		$author$project$PinMeTo$Ui$Layout$Flex$render,
		A2(
			$elm$core$List$map,
			function (uri) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(uri),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(uri)
						]));
			},
			websites),
		A2(
			$author$project$PinMeTo$Ui$Layout$Spacing$withPaddingLeft,
			$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXXXL,
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withPaddingBottom,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
				A2(
					$author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop,
					$author$project$PinMeTo$Ui$Layout$Spacing$SpacingSM,
					A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex)))));
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$ToggleExpandedChain = function (a) {
	return {$: 'ToggleExpandedChain', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderResultCard = F2(
	function (_v0, chain) {
		var model = _v0.a;
		var hasWebsites = !$elm$core$List$isEmpty(chain.websites);
		var isExpanded = _Utils_eq(
			model.expandedChain,
			$elm$core$Maybe$Just(chain.name));
		var chevronIcon = isExpanded ? $author$project$FontAwesome$Solid$Icon$faChevronUp : $author$project$FontAwesome$Solid$Icon$faChevronDown;
		var isLinked = function () {
			var _v2 = model.linkedChain;
			if ((_v2.$ === 'Loaded') && (_v2.a.$ === 'Just')) {
				var linked = _v2.a.a;
				return _Utils_eq(linked.id, chain.name);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chain-section__card chain-section--max-width')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Layout$Flex$render,
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Layout$Flex$render,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Radio$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Radio$withIsDisabled,
										!_Utils_eq(model.chainOperation, $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation),
										$author$project$PinMeTo$Ui$Form$Radio$radio(
											{
												label: '',
												checked: isLinked,
												onChange: function (_v1) {
													return $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkChain(chain);
												}
											}))),
									$author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLocalizedNames(chain.chainNames)
								]),
							A2($author$project$PinMeTo$Ui$Layout$Spacing$withGap, $author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD, $author$project$PinMeTo$Ui$Layout$Flex$flex)),
							hasWebsites ? $author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$ToggleExpandedChain(chain.name),
								A2(
									$author$project$PinMeTo$Ui$Button$withIconOnly,
									$author$project$PinMeTo$Ui$Button$FASolid(chevronIcon),
									A2(
										$author$project$PinMeTo$Ui$Button$withGhostStyle,
										$author$project$PinMeTo$Ui$Button$GhostNeutral,
										$author$project$PinMeTo$Ui$Button$buttonGhost(''))))) : $elm$html$Html$text('')
						]),
					A2(
						$author$project$PinMeTo$Ui$Layout$Flex$withJustify,
						$author$project$PinMeTo$Ui$Layout$Flex$SpaceBetween,
						A2($author$project$PinMeTo$Ui$Layout$Flex$withAlign, $author$project$PinMeTo$Ui$Layout$Flex$AlignCenter, $author$project$PinMeTo$Ui$Layout$Flex$flex))),
					isExpanded ? $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderWebsites(chain.websites) : $elm$html$Html$text('')
				]));
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderResultSkeleton = $author$project$PinMeTo$Ui$SkeletonV2$render(
	A2(
		$author$project$PinMeTo$Ui$SkeletonV2$isLoading,
		true,
		A2(
			$author$project$PinMeTo$Ui$SkeletonV2$wrap,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chain-section__result-placeholder')
					]),
				_List_Nil),
			A2($author$project$PinMeTo$Ui$SkeletonV2$withVariant, $author$project$PinMeTo$Ui$SkeletonV2$Gradient, $author$project$PinMeTo$Ui$SkeletonV2$skeleton))));
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionFailedToSearch = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_failed_to_search');
};
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionNoResultsFound = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_no_results_found');
};
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionNoResultsExplanation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_no_results_explanation');
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderSearchResults = F2(
	function (translations, _v0) {
		var model = _v0.a;
		var _v1 = model.chainSearchResults;
		switch (_v1.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Loading':
				return A2(
					$author$project$PinMeTo$Ui$Layout$Flex$render,
					A2($elm$core$List$repeat, 3, $author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderResultSkeleton),
					$author$project$Tasks$Google$Claim$Sections$ChainSection$View$resultStack);
			case 'Loaded':
				if (!_v1.a.b) {
					return A2(
						$author$project$PinMeTo$Ui$Layout$Flex$render,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('chain-section__no-results-title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Claim$googleMatchesChainSectionNoResultsFound(translations))
									])),
								$author$project$PinMeTo$Ui$Alert$render(
								$author$project$PinMeTo$Ui$Alert$plain(
									$author$project$Translations$Listings$Claim$googleMatchesChainSectionNoResultsExplanation(translations)))
							]),
						A2(
							$author$project$PinMeTo$Ui$Layout$Shared$withAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chain-section--max-width')
								]),
							A2(
								$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
								$author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD,
								A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex))));
				} else {
					var chains = _v1.a;
					return A2(
						$author$project$PinMeTo$Ui$Layout$Flex$render,
						A2(
							$elm$core$List$map,
							function (chain) {
								return A2(
									$author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderResultCard,
									$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(model),
									chain);
							},
							chains),
						A2(
							$author$project$PinMeTo$Ui$Layout$Shared$withAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chain-section--max-width')
								]),
							$author$project$Tasks$Google$Claim$Sections$ChainSection$View$resultStack));
				}
			default:
				return $author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Error,
						$author$project$PinMeTo$Ui$Alert$plain(
							$author$project$Translations$Listings$Claim$googleMatchesChainSectionFailedToSearch(translations))));
		}
	});
var $author$project$Translations$Listings$Claim$googleMatchesChainSectionLinkBrand = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_chain_section_link_brand');
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$View$view = F2(
	function (session, state) {
		var translations = session.translations;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chain-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__section-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Claim$googleMatchesChainSectionLinkBrand(translations))
								]))
						])),
					A2(
					$author$project$PinMeTo$Ui$Layout$Flex$render,
					_List_fromArray(
						[
							A2($author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderSearchForm, translations, state),
							A2($author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderLinkedChain, translations, state),
							A2($author$project$Tasks$Google$Claim$Sections$ChainSection$View$renderSearchResults, translations, state)
						]),
					A2(
						$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
						$author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD,
						A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex)))
				]));
	});
var $author$project$Translations$Listings$Claim$googleMatchesGbp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_gbp');
};
var $author$project$Tasks$Google$Claim$View$renderHeader = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorGoogleSearch)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$googleMatchesGbp(session.translations))
					]))
			]));
};
var $author$project$Tasks$Google$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$PinMeTo$Ui$Date$FormatTime = {$: 'FormatTime'};
var $author$project$Translations$Listings$Claim$syncLocationsGroupsSynced = F3(
	function (translations, current, total) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.claim.sync_locations_groups_synced',
			_List_fromArray(
				[
					_Utils_Tuple2('- current', current),
					_Utils_Tuple2('- total', total)
				]));
	});
var $author$project$Translations$Listings$Claim$syncLocationsSyncTimeNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_sync_time_note');
};
var $author$project$PinMeTo$Ui$ProgressBar$withLabel = F2(
	function (hasLabel, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ProgressBar$ProgressBar(
			_Utils_update(
				config,
				{withLabel: hasLabel}));
	});
var $author$project$Tasks$Google$Claim$View$renderLocationFinderProgress = function (progress) {
	var percentage = function () {
		if (progress.$ === 'Just') {
			var total = progress.a.total;
			var current = progress.a.current;
			return (total > 0) ? ((current / total) * 100) : 0;
		} else {
			return 0;
		}
	}();
	return $author$project$PinMeTo$Ui$ProgressBar$render(
		A2(
			$author$project$PinMeTo$Ui$ProgressBar$withLabel,
			false,
			$author$project$PinMeTo$Ui$ProgressBar$view(percentage)));
};
var $author$project$Translations$Listings$Claim$syncLocationsInProgressActions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_in_progress_actions');
};
var $author$project$Translations$Listings$Claim$syncLocationsRunningSinceCustom = F3(
	function (translations, nonPlaceholderLift, time) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'listings.claim.sync_locations_running_since',
			_List_fromArray(
				[
					_Utils_Tuple2('- time', time)
				]));
	});
var $author$project$Tasks$Google$Claim$View$renderSyncProgress = F2(
	function (session, model) {
		var startedAtTime = function () {
			var _v1 = model.locationFinderLastRun;
			if (_v1.$ === 'Just') {
				var lastRun_ = _v1.a;
				return $author$project$PinMeTo$Ui$Date$render(
					A2(
						$author$project$PinMeTo$Ui$Date$withFormat,
						$author$project$PinMeTo$Ui$Date$FormatTime,
						A2($author$project$PinMeTo$Ui$Date$string, session.locale, lastRun_)));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var current = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.current;
				},
				model.locationFinderProgress));
		var total = function () {
			var _v0 = model.locationFinderProgress;
			if (_v0.$ === 'Just') {
				var progress = _v0.a;
				return progress.total;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$length,
						$author$project$RemoteData$currentData(model.businessAccounts)));
			}
		}();
		var groupsSynced = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-progress__groups')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$author$project$Translations$Listings$Claim$syncLocationsGroupsSynced,
						session.translations,
						$elm$core$String$fromInt(current),
						$elm$core$String$fromInt(total)))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-progress')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__sync-progress__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$strong,
									_List_Nil,
									A3($author$project$Translations$Listings$Claim$syncLocationsRunningSinceCustom, session.translations, $elm$html$Html$text, startedAtTime)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' ' + $author$project$Translations$Listings$Claim$syncLocationsSyncTimeNote(session.translations))
									]))),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Claim$syncLocationsInProgressActions(session.translations))
								])),
							$author$project$Tasks$Google$Claim$View$renderLocationFinderProgress(model.locationFinderProgress),
							groupsSynced
						]))
				]));
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Translations$Listings$Claim$suggestedMatches = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.suggested_matches');
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderConfirmError = function (maybeError) {
	if (maybeError.$ === 'Just') {
		var message = maybeError.a;
		return _List_fromArray(
			[
				$author$project$PinMeTo$Ui$Alert$render(
				A2(
					$author$project$PinMeTo$Ui$Alert$withStatus,
					$author$project$PinMeTo$Ui$Alert$Error,
					$author$project$PinMeTo$Ui$Alert$plain(message)))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_note');
};
var $author$project$Translations$Listings$Claim$ignoreMatches = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.ignore_matches');
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ConfirmSuggestedMatches = function (a) {
	return {$: 'ConfirmSuggestedMatches', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderIgnoreMatchesButton = F3(
	function (translations, model, matches) {
		var isDisabled = model.confirming || $elm$core$List$isEmpty(matches);
		var body = {
			rejectedMatchIds: A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				matches),
			confirmedMatchIds: _List_Nil
		};
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				isDisabled,
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ConfirmSuggestedMatches(body),
					A2(
						$author$project$PinMeTo$Ui$Button$withGhostStyle,
						$author$project$PinMeTo$Ui$Button$GhostNeutral,
						$author$project$PinMeTo$Ui$Button$buttonGhost(
							$author$project$Translations$Listings$Claim$ignoreMatches(translations))))));
	});
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesNoMatches = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_no_matches');
};
var $author$project$PinMeTo$Ui$Btn$NoIcon = {$: 'NoIcon'};
var $author$project$Translations$General$confirmSimple = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.confirm_simple');
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$partitionSelections = F2(
	function (model, matches) {
		var _v0 = A2(
			$elm$core$List$partition,
			function (match) {
				return A2($elm$core$Set$member, match.id, model.selectedMatches);
			},
			matches);
		var confirmed = _v0.a;
		var rejected = _v0.b;
		return {
			rejectedMatchIds: A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				rejected),
			confirmedMatchIds: A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				confirmed)
		};
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderConfirmMatchesButton = F3(
	function (translations, model, matches) {
		var body = A2($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$partitionSelections, model, matches);
		var confirmedCount = $elm$core$List$length(body.confirmedMatchIds);
		var isDisabled = model.confirming || (!confirmedCount);
		var buttonLabel = $author$project$Translations$General$confirmSimple(translations) + (' (' + ($elm$core$String$fromInt(confirmedCount) + ')'));
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
					$author$project$PinMeTo$Ui$Btn$NoIcon,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ConfirmSuggestedMatches(body)),
							$elm$html$Html$Attributes$disabled(isDisabled)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(buttonLabel)
						]))
				]));
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ToggleSuggestedMatch = function (a) {
	return {$: 'ToggleSuggestedMatch', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$formatDistance = function (maybeMeters) {
	if (maybeMeters.$ === 'Nothing') {
		return '-';
	} else {
		var meters = maybeMeters.a;
		return (meters < 1000) ? ($elm$core$String$fromInt(
			$elm$core$Basics$round(meters)) + ' m') : ($elm$core$String$fromFloat(
			$elm$core$Basics$round(meters / 100) / 10) + ' km');
	}
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderGoogleLocation = function (match) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-suggested-matches__location-icon')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorGMB)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.storeId)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$formatDistance(match.distanceInMeters))
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-suggested-matches__location-text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.name)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.address.street)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.address.zip)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.address.city)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.address.countryAlpha2Code)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(match.data.category)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$core$String$isEmpty(match.data.link) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(match.data.link),
							$elm$html$Html$Attributes$target('blank_')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Google Maps')
						]))
				]))
		]);
};
var $author$project$PinMeTo$Ui$Icon$PinMeToLogo = {$: 'PinMeToLogo'};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderPinMeToLocation = F2(
	function (_v0, match) {
		var siteName = _v0.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('google-suggested-matches__location-icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$PinMeToLogo)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.storeId)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('-')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('google-suggested-matches__location-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.name)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.address.street)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.address.zip)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.address.city)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.address.countryAlpha2Code)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match.pmtData.category)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/listings/' + (siteName + ('/locations/' + (match.locationId + '/details')))),
								$elm$html$Html$Attributes$target('blank_')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('LDP')
							]))
					]))
			]);
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderSuggestedMatch = F3(
	function (session, model, match) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-suggested-matches__match-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Checkbox$render(
					$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
						{
							label: '',
							checked: A2($elm$core$Set$member, match.id, model.selectedMatches),
							onChange: function (_v0) {
								return $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ToggleSuggestedMatch(match.id);
							}
						})),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-suggested-matches__locations-container')
						]),
					_Utils_ap(
						A2($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderPinMeToLocation, session.siteName, match),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('google-suggested-matches__divider')
									]),
								_List_Nil),
							$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderGoogleLocation(match))))
				]));
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderSuggestedMatchesTable = F3(
	function (session, model, matches) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-suggested-matches__container')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderSuggestedMatch, session, model),
				matches));
	});
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_popover_note');
};
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverConfirm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_popover_confirm');
};
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverStoreIds = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_popover_store_ids');
};
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverIgnoreAll = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_popover_ignore_all');
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$view = F2(
	function (session, _v0) {
		var model = _v0.a;
		return A2(
			$author$project$PinMeTo$Ui$Layout$Flex$render,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('google-matches__section-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Claim$suggestedMatches(session.translations))
										])),
									A2(
									$author$project$PinMeTo$Ui$PopOver$renderPlain,
									model.uiPopOver,
									$author$project$PinMeTo$Ui$PopOver$view(
										{
											uid: 'suggested-matches-popover',
											tagger: $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$UiPopOverMsg,
											content: _List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverStoreIds(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverConfirm(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverIgnoreAll(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Claim$Google$suggestedMatchesPopoverNote(session.translations))
														]))
												]),
											preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
										}))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Claim$Google$suggestedMatchesNote(session.translations))
								]))
						])),
				function () {
					var _v1 = model.suggestedMatches;
					switch (_v1.$) {
						case 'Loading':
							return _List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]);
						case 'Loaded':
							var matches = _v1.a;
							return _Utils_ap(
								$elm$core$List$isEmpty(matches) ? _List_fromArray(
									[
										$author$project$PinMeTo$Ui$Alert$render(
										$author$project$PinMeTo$Ui$Alert$plain(
											$author$project$Translations$Listings$Claim$Google$suggestedMatchesNoMatches(session.translations)))
									]) : _List_fromArray(
									[
										A3($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderSuggestedMatchesTable, session, model, matches)
									]),
								_Utils_ap(
									$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderConfirmError(model.confirmError),
									_List_fromArray(
										[
											A2(
											$author$project$PinMeTo$Ui$Layout$Flex$render,
											_List_fromArray(
												[
													A3($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderConfirmMatchesButton, session.translations, model, matches),
													A3($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$renderIgnoreMatchesButton, session.translations, model, matches)
												]),
											A2(
												$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
												$author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD,
												A2(
													$author$project$PinMeTo$Ui$Layout$Flex$withAlign,
													$author$project$PinMeTo$Ui$Layout$Flex$AlignCenter,
													A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex))))
										])));
						case 'Error':
							var message = _v1.a;
							return _List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Error,
										$author$project$PinMeTo$Ui$Alert$plain(message)))
								]);
						default:
							return _List_Nil;
					}
				}()),
			A2(
				$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
				$author$project$PinMeTo$Ui$Layout$Spacing$SpacingLG,
				A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Column, $author$project$PinMeTo$Ui$Layout$Flex$flex)));
	});
var $author$project$Tasks$Google$Claim$Model$GbpTab = {$: 'GbpTab'};
var $author$project$Tasks$Google$Claim$Model$PmtTab = {$: 'PmtTab'};
var $author$project$PinMeTo$Ui$ViewSelector$UiIcon = function (a) {
	return {$: 'UiIcon', a: a};
};
var $author$project$PinMeTo$Ui$ViewSelector$Icons = {$: 'Icons'};
var $author$project$PinMeTo$Ui$ViewSelector$Labels = {$: 'Labels'};
var $author$project$PinMeTo$Ui$ViewSelector$Filters = {$: 'Filters'};
var $author$project$PinMeTo$Ui$ViewSelector$buildUrl = F3(
	function (viewParam, queryKey, url) {
		var extractParam = function (x) {
			var _v0 = A2($elm$core$String$split, '=', x);
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				var key = _v0.a;
				var _v1 = _v0.b;
				var value = _v1.a;
				return _Utils_eq(key, queryKey) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, key, value));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var params = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split('&'),
					$elm$core$List$filterMap(extractParam)),
				url.query));
		var newParams = A2(
			$elm$core$String$dropLeft,
			1,
			$elm$url$Url$Builder$toQuery(
				A2(
					$elm$core$Maybe$withDefault,
					params,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$List$cons,
								A2($elm$url$Url$Builder$string, queryKey, x),
								params);
						},
						viewParam))));
		return _Utils_update(
			url,
			{
				query: $elm$core$Maybe$Just(newParams)
			});
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 'Nothing') {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 'Nothing') {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.protocol;
		if (_v0.$ === 'Http') {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.fragment,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.query,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.port_,
					_Utils_ap(http, url.host)),
				url.path)));
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {frag: frag, value: value, params: params, visited: visited, unvisited: unvisited};
	});
var $elm$url$Url$Parser$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$s = function (str) {
	return $elm$url$Url$Parser$Parser(
		function (_v0) {
			var value = _v0.value;
			var frag = _v0.frag;
			var params = _v0.params;
			var unvisited = _v0.unvisited;
			var visited = _v0.visited;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				return _Utils_eq(next, str) ? _List_fromArray(
					[
						A5(
						$elm$url$Url$Parser$State,
						A2($elm$core$List$cons, next, visited),
						rest,
						params,
						frag,
						value)
					]) : _List_Nil;
			}
		});
};
var $elm$url$Url$Parser$top = $elm$url$Url$Parser$Parser(
	function (state) {
		return _List_fromArray(
			[state]);
	});
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 'Nothing') {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 'Nothing') {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 'Nothing') {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.unvisited;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.value);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.value);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0.a;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.path),
					$elm$url$Url$Parser$prepareQuery(url.query),
					url.fragment,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0.a;
		var parseAfter = _v1.a;
		return $elm$url$Url$Parser$Parser(
			function (state) {
				return A2(
					$elm$core$List$concatMap,
					parseAfter,
					parseBefore(state));
			});
	});
var $elm$url$Url$Parser$Internal$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return $elm$url$Url$Parser$Internal$Parser(
			function (dict) {
				return func(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, key, dict)));
			});
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0.a;
	return $elm$url$Url$Parser$Parser(
		function (_v1) {
			var value = _v1.value;
			var frag = _v1.frag;
			var params = _v1.params;
			var unvisited = _v1.unvisited;
			var visited = _v1.visited;
			return _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					visited,
					unvisited,
					params,
					frag,
					value(
						queryParser(params)))
				]);
		});
};
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $author$project$PinMeTo$Ui$ViewSelector$currentView = F2(
	function (queryKey, url) {
		var withBase = function (parser) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (x, a) {
						return A2($elm$url$Url$Parser$slash, x, a);
					}),
				parser,
				A2(
					$elm$core$List$map,
					$elm$url$Url$Parser$s,
					$elm$core$List$reverse(
						A2(
							$elm$core$List$filter,
							$elm$core$Basics$neq(''),
							A2($elm$core$String$split, '/', url.path)))));
		};
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$url$Url$Parser$parse,
				withBase(
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$top,
						$elm$url$Url$Parser$Query$string(queryKey))),
				url));
	});
var $author$project$PinMeTo$Ui$ViewSelector$getItemView = function (item) {
	switch (item.$) {
		case 'Label':
			var view = item.a.view;
			return view;
		case 'Icon':
			var view = item.a.view;
			return view;
		case 'Filter':
			var view = item.a.view;
			return view;
		case 'Count':
			var view = item.a.view;
			return view;
		case 'NewReleaseLabel':
			var view = item.a.view;
			return view;
		default:
			var view = item.a.view;
			return view;
	}
};
var $author$project$PinMeTo$Ui$ViewSelector$itemView = F2(
	function (_v0, item) {
		var viewToString = _v0.viewToString;
		var viewFromString = _v0.viewFromString;
		var defaultView = _v0.defaultView;
		var queryKey = _v0.queryKey;
		var url = _v0.url;
		var attrString = function (maybeAttr) {
			if (maybeAttr.$ === 'Just') {
				var x = maybeAttr.a;
				return $author$project$PinMeTo$Ui$DataTestAttribute$getAttributeString(x);
			} else {
				return '';
			}
		};
		var activeView = A2(
			$elm$core$Maybe$withDefault,
			defaultView,
			A2(
				$elm$core$Maybe$andThen,
				viewFromString,
				A2($author$project$PinMeTo$Ui$ViewSelector$currentView, queryKey, url)));
		var itemView_ = $author$project$PinMeTo$Ui$ViewSelector$getItemView(item);
		var testAttr = function (value) {
			return $author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute(value);
		};
		var rootTag = function (disabled) {
			return disabled ? $elm$html$Html$span : $elm$html$Html$a;
		};
		var itemUrl = A3(
			$author$project$PinMeTo$Ui$ViewSelector$buildUrl,
			$elm$core$Maybe$Just(
				viewToString(itemView_)),
			queryKey,
			url);
		switch (item.$) {
			case 'Label':
				var dataTestAttribute = item.a.dataTestAttribute;
				var disabled = item.a.disabled;
				var label = item.a.label;
				return A3(
					rootTag,
					disabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--label'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector__item--active',
									_Utils_eq(activeView, itemView_)),
									_Utils_Tuple2('pmt-ui-view-selector__item--enabled', !disabled)
								])),
							testAttr(
							attrString(dataTestAttribute)),
							$elm$html$Html$Attributes$href(
							$elm$url$Url$toString(itemUrl))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			case 'Icon':
				var dataTestAttribute = item.a.dataTestAttribute;
				var disabled = item.a.disabled;
				var icon = item.a.icon;
				return A3(
					rootTag,
					disabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--icon'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector__item--active',
									_Utils_eq(activeView, itemView_)),
									_Utils_Tuple2('pmt-ui-view-selector__item--enabled', !disabled)
								])),
							testAttr(
							attrString(dataTestAttribute)),
							$elm$html$Html$Attributes$href(
							$elm$url$Url$toString(itemUrl))
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(icon)
						]));
			case 'Filter':
				var dataTestAttribute = item.a.dataTestAttribute;
				var disabled = item.a.disabled;
				var count = item.a.count;
				var icon = item.a.icon;
				var label = item.a.label;
				return A3(
					rootTag,
					(count <= 0) || disabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__filter'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector__filter--active',
									_Utils_eq(activeView, itemView_)),
									_Utils_Tuple2('pmt-ui-view-selector__filter--enabled', (count > 0) && (!disabled))
								])),
							testAttr(
							attrString(dataTestAttribute)),
							$elm$html$Html$Attributes$href(
							$elm$url$Url$toString(itemUrl))
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(icon),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-view-selector__filter-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(count))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-view-selector__filter-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						]));
			case 'Count':
				var dataTestAttribute = item.a.dataTestAttribute;
				var disabled = item.a.disabled;
				var count = item.a.count;
				var label = item.a.label;
				return A3(
					rootTag,
					(count <= 0) || disabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__filter'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector__filter--active',
									_Utils_eq(activeView, itemView_)),
									_Utils_Tuple2('pmt-ui-view-selector__filter--enabled', (count > 0) && (!disabled))
								])),
							testAttr(
							attrString(dataTestAttribute)),
							$elm$html$Html$Attributes$href(
							$elm$url$Url$toString(itemUrl))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-view-selector__filter-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-view-selector__item-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(count))
								]))
						]));
			case 'NewReleaseLabel':
				var dataTestAttribute = item.a.dataTestAttribute;
				var disabled = item.a.disabled;
				var label = item.a.label;
				return A3(
					rootTag,
					disabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--label'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector__item--active',
									_Utils_eq(activeView, itemView_)),
									_Utils_Tuple2('pmt-ui-view-selector__item--enabled', !disabled)
								])),
							testAttr(
							attrString(dataTestAttribute)),
							$elm$html$Html$Attributes$href(
							$elm$url$Url$toString(itemUrl))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-view-selector__new-release-tab')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New')
								]))
						]));
			default:
				var dataTestAttribute = item.a.dataTestAttribute;
				var disabled = item.a.disabled;
				var label = item.a.label;
				var icon = item.a.icon;
				return A3(
					rootTag,
					disabled,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--label'),
							$elm$html$Html$Attributes$class('pmt-ui-view-selector__item--icon-label'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector__item--active',
									_Utils_eq(activeView, itemView_)),
									_Utils_Tuple2('pmt-ui-view-selector__item--enabled', !disabled)
								])),
							testAttr(
							attrString(dataTestAttribute)),
							$elm$html$Html$Attributes$href(
							$elm$url$Url$toString(itemUrl))
						]),
					_List_fromArray(
						[
							function () {
							if (icon.$ === 'FontAwesomeIcon') {
								var fa = icon.a;
								return $author$project$FontAwesome$render(fa);
							} else {
								var ui = icon.a;
								return $author$project$PinMeTo$Ui$Icon$render(ui);
							}
						}(),
							$elm$html$Html$text(label)
						]));
		}
	});
var $author$project$PinMeTo$Ui$ViewSelector$getLayout = function (items) {
	var _v0 = $elm$core$List$head(items);
	_v0$3:
	while (true) {
		if (_v0.$ === 'Just') {
			switch (_v0.a.$) {
				case 'Icon':
					return $author$project$PinMeTo$Ui$ViewSelector$Icons;
				case 'Filter':
					return $author$project$PinMeTo$Ui$ViewSelector$Filters;
				case 'Count':
					return $author$project$PinMeTo$Ui$ViewSelector$Filters;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $author$project$PinMeTo$Ui$ViewSelector$Labels;
};
var $author$project$PinMeTo$Ui$ViewSelector$render = F2(
	function (renderer, _v0) {
		var items = _v0.a;
		var x = _v0.b;
		var layout = $author$project$PinMeTo$Ui$ViewSelector$getLayout(items);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-view-selector'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-ui-view-selector--labels',
									_Utils_eq(layout, $author$project$PinMeTo$Ui$ViewSelector$Labels)),
									_Utils_Tuple2(
									'pmt-ui-view-selector--icons',
									_Utils_eq(layout, $author$project$PinMeTo$Ui$ViewSelector$Icons)),
									_Utils_Tuple2(
									'pmt-ui-view-selector--filters',
									_Utils_eq(layout, $author$project$PinMeTo$Ui$ViewSelector$Filters))
								]))
						]),
					A2(
						$elm$core$List$map,
						$author$project$PinMeTo$Ui$ViewSelector$itemView(x),
						items)),
					renderer(
					A2(
						$elm$core$Maybe$withDefault,
						x.defaultView,
						A2(
							$elm$core$Maybe$andThen,
							x.viewFromString,
							A2($author$project$PinMeTo$Ui$ViewSelector$currentView, x.queryKey, x.url))))
				]));
	});
var $author$project$Tasks$Google$Claim$View$parseUrl = function (urlString) {
	return A2(
		$elm$core$Maybe$withDefault,
		{host: 'localhost', path: '/', port_: $elm$core$Maybe$Nothing, query: $elm$core$Maybe$Nothing, fragment: $elm$core$Maybe$Nothing, protocol: $elm$url$Url$Http},
		$elm$url$Url$fromString(urlString));
};
var $author$project$Tasks$Google$Claim$Model$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Tasks$Google$Claim$View$countLabel = function (remoteData) {
	if (remoteData.$ === 'Loaded') {
		var items = remoteData.a;
		return $elm$core$String$fromInt(
			$elm$core$List$length(items));
	} else {
		return '...';
	}
};
var $author$project$Tasks$Google$Claim$View$renderAlert = function (notification) {
	if (notification.$ === 'Just') {
		var message = notification.a;
		return $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Tasks$Google$Claim$View$tabToString = function (tab) {
	if (tab.$ === 'PmtTab') {
		return 'pmt';
	} else {
		return 'gbp';
	}
};
var $author$project$Translations$General$link = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.link');
};
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId = function (id) {
	return A2(
		$elm$core$Maybe$withDefault,
		id,
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '/', id))));
};
var $author$project$Tasks$Google$Claim$Model$GbpTableMsg = function (a) {
	return {$: 'GbpTableMsg', a: a};
};
var $author$project$Translations$Listings$Claim$Google$gbpStoreCode = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.gbp_store_code');
};
var $author$project$Tasks$Google$Claim$Model$TooltipMsg = function (a) {
	return {$: 'TooltipMsg', a: a};
};
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip = F3(
	function (state, uid, value) {
		return A5(
			$author$project$PinMeTo$Ui$AdvancedTooltip$render,
			state,
			$author$project$PinMeTo$Ui$AdvancedTooltip$view(
				{
					uid: 'inner-table-tooltip-' + uid,
					tagger: $author$project$Tasks$Google$Claim$Model$TooltipMsg,
					content: _List_fromArray(
						[
							$elm$html$Html$text(value)
						]),
					preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
				}),
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$PinMeTo$Ui$Table$ErrorHighlight = {$: 'ErrorHighlight'};
var $author$project$Data$Network$GoogleBusinessAccountId$toString = function (accountId) {
	if (accountId.$ === 'NoAccount') {
		return '';
	} else {
		var id = accountId.a;
		return id;
	}
};
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpAccountId = function (id) {
	return A2(
		$elm$core$Maybe$withDefault,
		id,
		$elm$core$List$head(
			A2(
				$elm$core$List$drop,
				1,
				A2($elm$core$String$split, '/', id))));
};
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$gbpAccountName = F2(
	function (accounts, id) {
		var gbpId = $author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpAccountId(id);
		return A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.name;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (a) {
							return _Utils_eq(
								$author$project$Data$Network$GoogleBusinessAccountId$toString(a.googleAccountId),
								gbpId);
						},
						accounts))));
	});
var $author$project$Translations$General$locationStatus = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_status');
};
var $author$project$PinMeTo$Ui$Table$withRowOptions = F2(
	function (itemOptions, config) {
		return _Utils_update(
			config,
			{
				itemOptions: $elm$core$Maybe$Just(itemOptions)
			});
	});
var $author$project$PinMeTo$Ui$Layout$Spacing$withMarginBottom = F2(
	function (spacing, config) {
		var margin_ = config.margin;
		return _Utils_update(
			config,
			{
				margin: _Utils_update(
					margin_,
					{
						bottom: $elm$core$Maybe$Just(spacing)
					})
			});
	});
var $author$project$Translations$General$importButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.import_button');
};
var $author$project$Tasks$Google$Claim$Model$ImportGbpLocations = {$: 'ImportGbpLocations'};
var $author$project$Tasks$Google$Claim$Tables$GbpTable$renderImportButton = F2(
	function (translations, model) {
		var selectedCount = $elm$core$List$length(
			$author$project$PinMeTo$Ui$Table$selectedItems(model.uiGbpTable));
		var label = $author$project$Translations$General$importButton(translations) + (' (' + ($elm$core$String$fromInt(selectedCount) + ')'));
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				!selectedCount,
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Tasks$Google$Claim$Model$ImportGbpLocations,
					$author$project$PinMeTo$Ui$Button$buttonPrimary(label))));
	});
var $author$project$PinMeTo$Ui$Table$withScrollableTable = function (config) {
	return _Utils_update(
		config,
		{scrollableTable: true});
};
var $author$project$Translations$General$locationVerified = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_verified');
};
var $author$project$Translations$Listings$Claim$googleMatchesLocationUnverified = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_location_unverified');
};
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$googleLocationStatus = F2(
	function (translations, m) {
		var _v0 = m.duplicateLocation;
		switch (_v0.$) {
			case 'InternalDuplicate':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__status--duplicate')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Int. Dup.')
						]));
			case 'ExternalDuplicate':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__status--duplicate')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Ext. Dup.')
						]));
			default:
				return m.hasVoiceOfMerchant ? $elm$html$Html$text(
					$author$project$Translations$General$locationVerified(translations)) : $elm$html$Html$text(
					$author$project$Translations$Listings$Claim$googleMatchesLocationUnverified(translations));
		}
	});
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$googleStatusToString = function (m) {
	var _v0 = m.duplicateLocation;
	switch (_v0.$) {
		case 'InternalDuplicate':
			return 'Int. Dup.';
		case 'ExternalDuplicate':
			return 'Ext. Dup.';
		default:
			return m.hasVoiceOfMerchant ? 'Verified' : '-';
	}
};
var $author$project$Tasks$Google$Claim$Tables$GbpTable$failedImportGoogleIds = function (stats) {
	if (stats.$ === 'Just') {
		var s = stats.a;
		return $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.googleId;
				},
				s.errors));
	} else {
		return $elm$core$Set$empty;
	}
};
var $author$project$Translations$Listings$Claim$googleMatchesLocality = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_locality');
};
var $author$project$Translations$Listings$Claim$googleMatchesPostcode = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_postcode');
};
var $author$project$Tasks$Google$Claim$Tables$GbpTable$importErrorByGoogleId = function (stats) {
	if (stats.$ === 'Just') {
		var s = stats.a;
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (e) {
					return _Utils_Tuple2(e.googleId, e.error);
				},
				s.errors));
	} else {
		return $elm$core$Dict$empty;
	}
};
var $author$project$PinMeTo$Ui$Table$withStickyRowSelection = F2(
	function (f, config) {
		return _Utils_update(
			config,
			{checkboxSticky: f});
	});
var $author$project$PinMeTo$Ui$Icon$GMBGray = {$: 'GMBGray'};
var $author$project$Tasks$Google$Claim$Tables$TableHelpers$googleMatchSourceToIcon = function (source) {
	if (source.$ === 'OwnedBusinessProfile') {
		return $author$project$PinMeTo$Ui$Icon$RegularColorGMB;
	} else {
		return $author$project$PinMeTo$Ui$Icon$GMBGray;
	}
};
var $author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToClass = function (openStatus) {
	switch (openStatus.$) {
		case 'Open':
			return 'google-matches__status--open';
		case 'TemporarilyClosed':
			return 'google-matches__status--temp-closed';
		case 'PermanentlyClosed':
			return 'google-matches__status--closed';
		default:
			return '';
	}
};
var $author$project$Translations$Listings$Claim$googleMatchesImportFailed = F3(
	function (translations, failed, total) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.claim.google_matches_import_failed',
			_List_fromArray(
				[
					_Utils_Tuple2('failed', failed),
					_Utils_Tuple2('total', total)
				]));
	});
var $author$project$Translations$Listings$Claim$googleMatchesImportSuccess = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_import_success');
};
var $author$project$Tasks$Google$Claim$Tables$GbpTable$renderImportResultAlert = F2(
	function (translations, stats) {
		if (stats.$ === 'Just') {
			var s = stats.a;
			return $elm$core$List$isEmpty(s.errors) ? $author$project$PinMeTo$Ui$Alert$render(
				A2(
					$author$project$PinMeTo$Ui$Alert$withStatus,
					$author$project$PinMeTo$Ui$Alert$Success,
					$author$project$PinMeTo$Ui$Alert$plain(
						$author$project$Translations$Listings$Claim$googleMatchesImportSuccess(translations)))) : $author$project$PinMeTo$Ui$Alert$render(
				A2(
					$author$project$PinMeTo$Ui$Alert$withStatus,
					$author$project$PinMeTo$Ui$Alert$Error,
					$author$project$PinMeTo$Ui$Alert$plain(
						A3(
							$author$project$Translations$Listings$Claim$googleMatchesImportFailed,
							translations,
							$elm$core$String$fromInt(
								$elm$core$List$length(s.errors)),
							$elm$core$String$fromInt(s.total)))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$Listings$Claim$googleMatchesImportError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_import_error');
};
var $author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString = function (openStatus) {
	switch (openStatus.$) {
		case 'Open':
			return 'Open';
		case 'TemporarilyClosed':
			return 'Temp Cl.';
		case 'PermanentlyClosed':
			return 'Perm Cl.';
		default:
			return '-';
	}
};
var $author$project$Translations$Listings$Claim$googleMatchesGbpAccountName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_gbp_account_name');
};
var $author$project$Translations$Listings$Claim$googleMatchesLoadingMatches = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_loading_matches');
};
var $author$project$Translations$Listings$Claim$googleMatchesGoogleBusinessProfileId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_google_business_profile_id');
};
var $author$project$Tasks$Google$Claim$Tables$GbpTable$gbpTableView = F2(
	function (translations, model) {
		var _v0 = model.notMatchedLocations;
		switch (_v0.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Claim$googleMatchesLoadingMatches(translations))
						]));
			case 'Error':
				var err = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(err)
						]));
			default:
				var matches = _v0.a;
				var failedIds = $author$project$Tasks$Google$Claim$Tables$GbpTable$failedImportGoogleIds(model.lastImportStats);
				var errorById = $author$project$Tasks$Google$Claim$Tables$GbpTable$importErrorByGoogleId(model.lastImportStats);
				var accounts = function () {
					var _v5 = model.businessAccounts;
					if (_v5.$ === 'Loaded') {
						var a = _v5.a;
						return a;
					} else {
						return _List_Nil;
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Layout$Flex$render,
							_List_fromArray(
								[
									A2($author$project$Tasks$Google$Claim$Tables$GbpTable$renderImportButton, translations, model)
								]),
							A2(
								$author$project$PinMeTo$Ui$Layout$Spacing$withMarginBottom,
								$author$project$PinMeTo$Ui$Layout$Spacing$SpacingLG,
								A2(
									$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
									$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXL,
									A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Layout$Spacing$margin(
									{
										top: $elm$core$Maybe$Nothing,
										left: $elm$core$Maybe$Nothing,
										right: $elm$core$Maybe$Nothing,
										bottom: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD)
									})
								]),
							_List_fromArray(
								[
									A2($author$project$Tasks$Google$Claim$Tables$GbpTable$renderImportResultAlert, translations, model.lastImportStats)
								])),
							A2(
							$author$project$PinMeTo$Ui$Table$render,
							model.uiGbpTable,
							$author$project$PinMeTo$Ui$Table$withScrollableTable(
								A2(
									$author$project$PinMeTo$Ui$Table$withSort,
									$author$project$PinMeTo$Ui$Table$Desc(3),
									A2(
										$author$project$PinMeTo$Ui$Table$withRowMoreIndent,
										0,
										A2(
											$author$project$PinMeTo$Ui$Table$withLimit,
											{
												limit: 10,
												viewMoreLabel: F2(
													function (shown, total) {
														return 'Show more (' + ($elm$core$String$fromInt(shown) + ('/' + ($elm$core$String$fromInt(total) + ')')));
													})
											},
											A2(
												$author$project$PinMeTo$Ui$Table$withColumns,
												_List_fromArray(
													[
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return $author$project$PinMeTo$Ui$Icon$render(
																$author$project$Tasks$Google$Claim$Tables$TableHelpers$googleMatchSourceToIcon(m.source));
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function (_v1) {
																return '';
															}),
														''),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class(
																		$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToClass(m.openStatus))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(m.openStatus))
																	]));
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function (m) {
																return $author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(m.openStatus);
															}),
														$author$project$Translations$General$open(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														$author$project$Tasks$Google$Claim$Tables$TableHelpers$googleLocationStatus(translations),
														$author$project$PinMeTo$Ui$Table$comparingString($author$project$Tasks$Google$Claim$Tables$TableHelpers$googleStatusToString),
														$author$project$Translations$General$locationStatus(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3(
																$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
																model.uiTooltip,
																m.googleBusinessId + '-storeId',
																A2($elm$core$Maybe$withDefault, '-', m.storeId));
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function (m) {
																return A2($elm$core$Maybe$withDefault, '-', m.storeId);
															}),
														$author$project$Translations$Listings$Claim$Google$gbpStoreCode(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-name', m.name);
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function ($) {
																return $.name;
															}),
														$author$project$Translations$General$locationName(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-street', m.address.street);
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.address;
																},
																function ($) {
																	return $.street;
																})),
														$author$project$Translations$General$locationAddress(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-zip', m.address.zip);
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.address;
																},
																function ($) {
																	return $.zip;
																})),
														$author$project$Translations$Listings$Claim$googleMatchesPostcode(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-city', m.address.city);
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.address;
																},
																function ($) {
																	return $.city;
																})),
														$author$project$Translations$Listings$Claim$googleMatchesLocality(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-country', m.address.countryAlpha2Code);
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.address;
																},
																function ($) {
																	return $.countryAlpha2Code;
																})),
														$author$project$Translations$General$locationCountry(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															var _v2 = m.mapsUri;
															if (_v2.$ === 'Just') {
																var uri = _v2.a;
																return A2(
																	$elm$html$Html$a,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$href(uri),
																			$elm$html$Html$Attributes$target('_blank')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('GBP')
																		]));
															} else {
																return $elm$html$Html$text('-');
															}
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function (_v3) {
																return '';
															}),
														$author$project$Translations$General$link(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3(
																$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
																model.uiTooltip,
																m.googleBusinessId + '-gbpId',
																$author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId(m.googleBusinessId));
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function (m) {
																return $author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId(m.googleBusinessId);
															}),
														$author$project$Translations$Listings$Claim$googleMatchesGoogleBusinessProfileId(translations)),
														A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														function (m) {
															return A3(
																$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
																model.uiTooltip,
																m.googleBusinessId + '-gbpAccountName',
																A2($author$project$Tasks$Google$Claim$Tables$TableHelpers$gbpAccountName, accounts, m.googleBusinessId));
														},
														$author$project$PinMeTo$Ui$Table$comparingString(
															function (m) {
																return A2($author$project$Tasks$Google$Claim$Tables$TableHelpers$gbpAccountName, accounts, m.googleBusinessId);
															}),
														$author$project$Translations$Listings$Claim$googleMatchesGbpAccountName(translations)),
														A2(
														$author$project$PinMeTo$Ui$Table$columnWithOptions,
														_List_fromArray(
															[$author$project$PinMeTo$Ui$Table$MaxWidth]),
														A3(
															$author$project$PinMeTo$Ui$Table$createColumn,
															function (m) {
																var _v4 = A2($elm$core$Dict$get, m.googleBusinessId, errorById);
																if (_v4.$ === 'Just') {
																	var err = _v4.a;
																	return A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('google-matches__status--duplicate')
																			]),
																		_List_fromArray(
																			[
																				A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-importError', err)
																			]));
																} else {
																	return $elm$html$Html$text('-');
																}
															},
															$author$project$PinMeTo$Ui$Table$comparingString(
																function (m) {
																	return A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2($elm$core$Dict$get, m.googleBusinessId, errorById));
																}),
															$author$project$Translations$Listings$Claim$googleMatchesImportError(translations)))
													]),
												A2(
													$author$project$PinMeTo$Ui$Table$withRowOptions,
													function (m) {
														return _List_fromArray(
															[
																_Utils_Tuple2(
																$author$project$PinMeTo$Ui$Table$ErrorHighlight,
																A2($elm$core$Set$member, m.googleBusinessId, failedIds))
															]);
													},
													A2(
														$author$project$PinMeTo$Ui$Table$withStickyRowSelection,
														true,
														A2(
															$author$project$PinMeTo$Ui$Table$withRowSelection,
															function ($) {
																return $.googleBusinessId;
															},
															A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Google$Claim$Model$GbpTableMsg, matches))))))))))
						]));
		}
	});
var $author$project$PinMeTo$Ui$ViewSelector$ViewSelector = F2(
	function (a, b) {
		return {$: 'ViewSelector', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$ViewSelector$viewSelector = F2(
	function (_v0, items) {
		var viewToString = _v0.viewToString;
		var viewFromString = _v0.viewFromString;
		var defaultView = _v0.defaultView;
		var queryKey = _v0.queryKey;
		var url = _v0.url;
		return A2(
			$author$project$PinMeTo$Ui$ViewSelector$ViewSelector,
			items,
			{url: url, queryKey: queryKey, defaultView: defaultView, viewToString: viewToString, viewFromString: viewFromString});
	});
var $author$project$PinMeTo$Ui$ViewSelector$IconLabel = function (a) {
	return {$: 'IconLabel', a: a};
};
var $author$project$PinMeTo$Ui$ViewSelector$iconLabelItem = F3(
	function (icon, label, view_) {
		return $author$project$PinMeTo$Ui$ViewSelector$IconLabel(
			{icon: icon, view: view_, label: label, disabled: false, dataTestAttribute: $elm$core$Maybe$Nothing});
	});
var $author$project$Tasks$Google$Claim$View$tabFromString = function (str) {
	switch (str) {
		case 'pmt':
			return $elm$core$Maybe$Just($author$project$Tasks$Google$Claim$Model$PmtTab);
		case 'gbp':
			return $elm$core$Maybe$Just($author$project$Tasks$Google$Claim$Model$GbpTab);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Ui$Table$Ch = {$: 'Ch'};
var $author$project$Tasks$Google$Claim$Tables$InnerTable$getDistance = F2(
	function (locationCoordinates, googleCoords) {
		var _v0 = _Utils_Tuple2(locationCoordinates, googleCoords);
		if (_v0.a.$ === 'Nothing') {
			if (_v0.b.$ === 'Nothing') {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return '-';
			} else {
				var _v4 = _v0.a;
				return '-';
			}
		} else {
			if (_v0.b.$ === 'Nothing') {
				var _v3 = _v0.b;
				return '-';
			} else {
				var locationCoordinates_ = _v0.a.a;
				var googleCoords_ = _v0.b.a;
				return A4($author$project$Common$Math$calculateDistance, locationCoordinates_.lat, locationCoordinates_.lon, googleCoords_.lat, googleCoords_.lon);
			}
		}
	});
var $author$project$Translations$Listings$Claim$connect = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.connect');
};
var $author$project$Translations$Listings$Claim$Google$claimNow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.claim_now');
};
var $author$project$Translations$Listings$Claim$Google$requestAccess = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.request_access');
};
var $author$project$Translations$Listings$Claim$Google$copyAndClaimNow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.copy_and_claim_now');
};
var $author$project$Tasks$Google$Claim$Model$SelectedClaimMatch = F2(
	function (a, b) {
		return {$: 'SelectedClaimMatch', a: a, b: b};
	});
var $author$project$Translations$Listings$Claim$Google$copyAndRequestAccess = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.copy_and_request_access');
};
var $author$project$Tasks$Google$Claim$Model$ConnectGoogleLocation = F2(
	function (a, b) {
		return {$: 'ConnectGoogleLocation', a: a, b: b};
	});
var $author$project$Tasks$Google$Claim$Tables$InnerTable$generateGoogleClaimUrl = function (googleAccountId) {
	var pinmetoBusinessProfileManagerOrganizationId = '105412081284569621690';
	var gmbsrc = 'ww-ww-z-z-al-gmb-s-z-l~mbi-d';
	return 'https://business.google.com/create?oi=' + (pinmetoBusinessProfileManagerOrganizationId + ('&pma=' + ($author$project$Data$Network$GoogleBusinessAccountId$toString(googleAccountId) + ('&gmbsrc=' + gmbsrc))));
};
var $author$project$Translations$Listings$Claim$Google$selectBusinessAccountToClaim = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.select_business_account_to_claim');
};
var $author$project$Tasks$Google$Claim$Tables$InnerTable$actionButton = F4(
	function (indexByGoogleId, model, translations, match) {
		var isConnecting = function (googleId) {
			var _v2 = model.connecting;
			if (_v2.$ === 'ConnectingLocations') {
				var locationId = _v2.a;
				var googleId_ = _v2.b;
				return _Utils_eq(googleId, googleId_) && _Utils_eq(
					model.expandedRow,
					$elm$core$Maybe$Just(locationId));
			} else {
				return false;
			}
		};
		var itemIndex = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Dict$get, match.googleBusinessId, indexByGoogleId));
		var _v0 = match.source;
		if (_v0.$ === 'OwnedBusinessProfile') {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$withSize,
							$author$project$PinMeTo$Ui$Button$Small,
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								isConnecting(match.googleBusinessId),
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									A2($author$project$Tasks$Google$Claim$Model$ConnectGoogleLocation, match, itemIndex),
									$author$project$PinMeTo$Ui$Button$buttonPrimary(
										isConnecting(match.googleBusinessId) ? ($author$project$Translations$Listings$Claim$connect(translations) + '...') : $author$project$Translations$Listings$Claim$connect(translations))))))
					]));
		} else {
			var enabledTooltipText = $elm$core$String$isEmpty(match.requestClaimUrl) ? $author$project$Translations$Listings$Claim$Google$copyAndClaimNow(translations) : $author$project$Translations$Listings$Claim$Google$copyAndRequestAccess(translations);
			var tooltipWrap = F3(
				function (uid, tooltipText, child) {
					return A5(
						$author$project$PinMeTo$Ui$AdvancedTooltip$render,
						model.uiTooltip,
						$author$project$PinMeTo$Ui$AdvancedTooltip$view(
							{
								uid: 'inner-table-tooltip-' + (uid + match.googleBusinessId),
								tagger: $author$project$Tasks$Google$Claim$Model$TooltipMsg,
								content: _List_fromArray(
									[
										$elm$html$Html$text(tooltipText)
									]),
								preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
							}),
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[child]));
				});
			var label = $elm$core$String$isEmpty(match.requestClaimUrl) ? $author$project$Translations$Listings$Claim$Google$claimNow(translations) : $author$project$Translations$Listings$Claim$Google$requestAccess(translations);
			var _v1 = model.selectedBusinessAccount;
			if (_v1.$ === 'Nothing') {
				return A3(
					tooltipWrap,
					'claim-disabled-',
					$author$project$Translations$Listings$Claim$Google$selectBusinessAccountToClaim(translations),
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])));
			} else {
				var account = _v1.a;
				var claimUrl = $author$project$Tasks$Google$Claim$Tables$InnerTable$generateGoogleClaimUrl(account.googleAccountId);
				return A3(
					tooltipWrap,
					'claim-enabled-',
					enabledTooltipText,
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(claimUrl),
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Events$onClick(
								A2($author$project$Tasks$Google$Claim$Model$SelectedClaimMatch, match, itemIndex))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							])));
			}
		}
	});
var $author$project$Tasks$Google$Claim$Model$InnerTableMsg = function (a) {
	return {$: 'InnerTableMsg', a: a};
};
var $author$project$PinMeTo$Ui$Table$withColumnWidths = F3(
	function (unit, widths, config) {
		var unitStr = function () {
			if (unit.$ === 'Px') {
				return 'px';
			} else {
				return 'ch';
			}
		}();
		return _Utils_update(
			config,
			{
				columnWidths: A2(
					$elm$core$List$map,
					$elm$core$Maybe$map(
						function (w) {
							return _Utils_ap(
								$elm$core$String$fromInt(w),
								unitStr);
						}),
					widths)
			});
	});
var $author$project$Tasks$Google$Claim$Tables$InnerTable$getDistanceNumber = function (distance) {
	return A2(
		$elm$core$Maybe$withDefault,
		2147483647,
		$elm$core$String$toInt(distance));
};
var $author$project$Tasks$Google$Claim$Tables$InnerTable$getLocationStatus = F2(
	function (translations, match) {
		return _Utils_eq(match.source, $author$project$Tasks$Google$Claim$Model$UnownedBusinessProfile) ? $elm$html$Html$text('-') : A2($author$project$Tasks$Google$Claim$Tables$TableHelpers$googleLocationStatus, translations, match);
	});
var $author$project$Translations$Listings$Claim$googleMatchesDistance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_distance');
};
var $author$project$Translations$Listings$Claim$googleMatchesMapsLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_maps_link');
};
var $author$project$Tasks$Google$Claim$Tables$InnerTable$googleMatchSourceToString = function (source) {
	if (source.$ === 'OwnedBusinessProfile') {
		return 'Owned Business Profile';
	} else {
		return 'Unowned Business Profile';
	}
};
var $author$project$Tasks$Google$Claim$Tables$InnerTable$generateGoogleBusinessProfileUrl = function (match) {
	var storeId = A2($elm$core$Maybe$withDefault, '', match.storeId);
	var query = $elm$url$Url$percentEncode(storeId + (' ' + match.name));
	return 'https://business.google.com/locations/search?q=' + query;
};
var $author$project$Tasks$Google$Claim$Tables$InnerTable$innerTableView = F3(
	function (translations, model, _v0) {
		var locationCoordinates = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.location;
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						function (loc) {
							return _Utils_eq(
								$elm$core$Maybe$Just(loc.id),
								model.expandedRow);
						}),
					$elm$core$List$head),
				$author$project$RemoteData$currentData(model.pmtLocations)));
		var getLink = function (match) {
			var _v6 = match.source;
			if (_v6.$ === 'OwnedBusinessProfile') {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Tasks$Google$Claim$Tables$InnerTable$generateGoogleBusinessProfileUrl(match)),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('GBP')
						]));
			} else {
				var _v7 = match.mapsUri;
				if (_v7.$ === 'Nothing') {
					return $elm$html$Html$text('-');
				} else {
					var uri = _v7.a;
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(uri),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$googleMatchesMapsLink(translations))
							]));
				}
			}
		};
		var _v1 = model.innerMatches;
		switch (_v1.$) {
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Claim$googleMatchesLoadingMatches(translations))
						]));
			case 'Error':
				var err = _v1.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(err)
						]));
			case 'Loaded':
				var externalMatches = _v1.a;
				var internalMatches = function () {
					var _v5 = model.notMatchedLocations;
					if (_v5.$ === 'Loaded') {
						var locations = _v5.a;
						return locations;
					} else {
						return _List_Nil;
					}
				}();
				var allMatches = _Utils_ap(internalMatches, externalMatches);
				var indexByGoogleId = $elm$core$Dict$fromList(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, m) {
								return _Utils_Tuple2(m.googleBusinessId, i);
							}),
						A2(
							$elm$core$List$sortBy,
							function (m) {
								return $author$project$Tasks$Google$Claim$Tables$InnerTable$getDistanceNumber(
									A2($author$project$Tasks$Google$Claim$Tables$InnerTable$getDistance, locationCoordinates, m.location));
							},
							allMatches)));
				var accounts = function () {
					var _v4 = model.businessAccounts;
					if (_v4.$ === 'Loaded') {
						var a = _v4.a;
						return a;
					} else {
						return _List_Nil;
					}
				}();
				return A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiInnerTable,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowMoreIndent,
						0,
						A2(
							$author$project$PinMeTo$Ui$Table$withLimit,
							{
								limit: 5,
								viewMoreLabel: F2(
									function (shown, total) {
										return 'Show more (' + ($elm$core$String$fromInt(shown) + ('/' + ($elm$core$String$fromInt(total) + ')')));
									})
							},
							A2(
								$author$project$PinMeTo$Ui$Table$withSort,
								$author$project$PinMeTo$Ui$Table$Asc(2),
								A2(
									$author$project$PinMeTo$Ui$Table$withColumns,
									_List_fromArray(
										[
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return $author$project$PinMeTo$Ui$Icon$render(
													$author$project$Tasks$Google$Claim$Tables$TableHelpers$googleMatchSourceToIcon(m.source));
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return $author$project$Tasks$Google$Claim$Tables$InnerTable$googleMatchSourceToString(m.source);
												}),
											''),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											A3($author$project$Tasks$Google$Claim$Tables$InnerTable$actionButton, indexByGoogleId, model, translations),
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (_v2) {
													return '';
												}),
											''),
											A2(
											$author$project$PinMeTo$Ui$Table$columnWithOptions,
											_List_fromArray(
												[$author$project$PinMeTo$Ui$Table$Right]),
											A3(
												$author$project$PinMeTo$Ui$Table$createColumn,
												function (m) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('google-matches__distance')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($author$project$Tasks$Google$Claim$Tables$InnerTable$getDistance, locationCoordinates, m.location))
															]));
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													function (m) {
														return A3(
															$elm$core$Basics$composeR,
															$author$project$Tasks$Google$Claim$Tables$InnerTable$getDistance(locationCoordinates),
															$author$project$Tasks$Google$Claim$Tables$InnerTable$getDistanceNumber,
															m.location);
													}),
												$author$project$Translations$Listings$Claim$googleMatchesDistance(translations))),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(
															$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToClass(m.openStatus))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(m.openStatus))
														]));
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return $author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(m.openStatus);
												}),
											$author$project$Translations$General$open(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											$author$project$Tasks$Google$Claim$Tables$InnerTable$getLocationStatus(translations),
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return $author$project$Tasks$Google$Claim$Tables$TableHelpers$googleStatusToString(m);
												}),
											$author$project$Translations$General$locationStatus(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-name', m.name);
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function ($) {
													return $.name;
												}),
											$author$project$Translations$General$locationName(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-street', m.address.street);
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return m.address.street;
												}),
											$author$project$Translations$General$locationAddress(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-zip', m.address.zip);
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return m.address.zip;
												}),
											$author$project$Translations$Listings$Claim$googleMatchesPostcode(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-city', m.address.city);
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return m.address.city;
												}),
											$author$project$Translations$Listings$Claim$googleMatchesLocality(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, m.googleBusinessId + '-country', m.address.countryAlpha2Code);
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return m.address.countryAlpha2Code;
												}),
											$author$project$Translations$General$locationCountry(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											getLink,
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (_v3) {
													return '';
												}),
											$author$project$Translations$General$link(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3(
													$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
													model.uiTooltip,
													m.googleBusinessId + '-storeId',
													A2($elm$core$Maybe$withDefault, '-', m.storeId));
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return A2($elm$core$Maybe$withDefault, '-', m.storeId);
												}),
											$author$project$Translations$Listings$Claim$Google$gbpStoreCode(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3(
													$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
													model.uiTooltip,
													m.googleBusinessId + '-gbpId',
													$author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId(m.googleBusinessId));
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return $author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId(m.googleBusinessId);
												}),
											$author$project$Translations$Listings$Claim$googleMatchesGoogleBusinessProfileId(translations)),
											A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											function (m) {
												return A3(
													$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
													model.uiTooltip,
													m.googleBusinessId + '-gbpAccountName',
													A2($author$project$Tasks$Google$Claim$Tables$TableHelpers$gbpAccountName, accounts, m.googleBusinessId));
											},
											$author$project$PinMeTo$Ui$Table$comparingString(
												function (m) {
													return A2($author$project$Tasks$Google$Claim$Tables$TableHelpers$gbpAccountName, accounts, m.googleBusinessId);
												}),
											$author$project$Translations$Listings$Claim$googleMatchesGbpAccountName(translations))
										]),
									A3(
										$author$project$PinMeTo$Ui$Table$withColumnWidths,
										$author$project$PinMeTo$Ui$Table$Ch,
										model.columnWidths,
										A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Google$Claim$Model$InnerTableMsg, allMatches)))))));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$PinMeTo$Ui$Table$Highlight = {$: 'Highlight'};
var $author$project$Tasks$Google$Claim$Model$ToggleRow = function (a) {
	return {$: 'ToggleRow', a: a};
};
var $author$project$Translations$Listings$Claim$Google$pmtStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.pmt_store_id');
};
var $author$project$Tasks$Google$Claim$Model$NoOp = {$: 'NoOp'};
var $author$project$FontAwesome$Regular$Icon$faCopy = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-copy');
var $author$project$Tasks$Google$Claim$Model$CopyStoreId = function (a) {
	return {$: 'CopyStoreId', a: a};
};
var $author$project$Translations$Listings$Claim$Google$copyStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.copy_store_id');
};
var $author$project$Tasks$Google$Claim$Tables$OuterTable$storeIdCell = F3(
	function (translations, model, loc) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-matches__store-id')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__store-id-value')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$PinMeTo$Ui$AdvancedTooltip$render,
							model.uiTooltip,
							$author$project$PinMeTo$Ui$AdvancedTooltip$view(
								{
									uid: 'outer-table-tooltip-' + (loc.id + '-storeId-icon'),
									tagger: $author$project$Tasks$Google$Claim$Model$TooltipMsg,
									content: _List_fromArray(
										[
											$elm$html$Html$text(loc.storeId)
										]),
									preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
								}),
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('google-matches__store-id-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(loc.storeId)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__store-id-copy'),
							$author$project$Common$Util$stopPropagation($author$project$Tasks$Google$Claim$Model$NoOp)
						]),
					_List_fromArray(
						[
							A5(
							$author$project$PinMeTo$Ui$AdvancedTooltip$render,
							model.uiTooltip,
							$author$project$PinMeTo$Ui$AdvancedTooltip$view(
								{
									uid: 'outer-table-tooltip-' + (loc.id + '-storeId-copy'),
									tagger: $author$project$Tasks$Google$Claim$Model$TooltipMsg,
									content: _List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Claim$Google$copyStoreId(translations))
										]),
									preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
								}),
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										$author$project$Tasks$Google$Claim$Model$CopyStoreId(loc.storeId),
										A2(
											$author$project$PinMeTo$Ui$Button$withIconOnly,
											$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faCopy),
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												A2(
													$author$project$PinMeTo$Ui$Button$withGhostStyle,
													$author$project$PinMeTo$Ui$Button$GhostNeutral,
													$author$project$PinMeTo$Ui$Button$buttonGhost(''))))))
								]))
						]))
				]));
	});
var $author$project$Tasks$Google$Claim$Tables$OuterTable$columnWidths = function (model) {
	return model.columnWidths;
};
var $author$project$Tasks$Google$Claim$Model$OuterTableMsg = function (a) {
	return {$: 'OuterTableMsg', a: a};
};
var $author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip = F3(
	function (state, uid, value) {
		return A5(
			$author$project$PinMeTo$Ui$AdvancedTooltip$render,
			state,
			$author$project$PinMeTo$Ui$AdvancedTooltip$view(
				{
					uid: 'outer-table-tooltip-' + uid,
					tagger: $author$project$Tasks$Google$Claim$Model$TooltipMsg,
					content: _List_fromArray(
						[
							$elm$html$Html$text(value)
						]),
					preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
				}),
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Translations$Listings$Claim$googleMatchesAllLocationsMatched = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_all_locations_matched');
};
var $author$project$Tasks$Google$Claim$Tables$OuterTable$emptyStateView = function (session) {
	return $author$project$PinMeTo$Ui$Alert$render(
		A2(
			$author$project$PinMeTo$Ui$Alert$withStatus,
			$author$project$PinMeTo$Ui$Alert$Success,
			$author$project$PinMeTo$Ui$Alert$plain(
				$author$project$Translations$Listings$Claim$googleMatchesAllLocationsMatched(session.translations))));
};
var $author$project$Translations$Listings$Claim$Google$creatingLocation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.creating_location');
};
var $elm$core$String$lines = _String_lines;
var $author$project$Tasks$Google$Claim$Tables$OuterTable$errorLines = function (value) {
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$trim,
			function (line) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__error-tooltip-line')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(line)
						]));
			}),
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$trim,
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
			$elm$core$String$lines(value)));
};
var $author$project$Tasks$Google$Claim$Tables$OuterTable$wrapErrorInTooltip = F3(
	function (state, uid, value) {
		return A5(
			$author$project$PinMeTo$Ui$AdvancedTooltip$render,
			state,
			$author$project$PinMeTo$Ui$AdvancedTooltip$view(
				{
					uid: 'outer-table-tooltip-' + uid,
					tagger: $author$project$Tasks$Google$Claim$Model$TooltipMsg,
					content: _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('google-matches__error-tooltip-content')
								]),
							$author$project$Tasks$Google$Claim$Tables$OuterTable$errorLines(value))
						]),
					preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
				}),
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Tasks$Google$Claim$Tables$OuterTable$createStateCell = F3(
	function (translations, model, loc) {
		var _v0 = A2($elm$core$Dict$get, loc.id, model.createStates);
		if (_v0.$ === 'Just') {
			switch (_v0.a.$) {
				case 'Queued':
					var _v1 = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__status--pending')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$Google$creatingLocation(translations))
							]));
				case 'Creating':
					var _v2 = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__status--pending')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$Google$creatingLocation(translations))
							]));
				case 'Created':
					var _v3 = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__status--success')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$locationCreated(translations))
							]));
				default:
					var err = _v0.a.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__status--duplicate')
							]),
						_List_fromArray(
							[
								A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapErrorInTooltip, model.uiTooltip, loc.id + '-createError', err)
							]));
			}
		} else {
			return $elm$html$Html$text('-');
		}
	});
var $author$project$Tasks$Google$Claim$Tables$OuterTable$createStateSortKey = F2(
	function (model, loc) {
		var _v0 = A2($elm$core$Dict$get, loc.id, model.createStates);
		if (_v0.$ === 'Just') {
			switch (_v0.a.$) {
				case 'Creating':
					var _v1 = _v0.a;
					return '1';
				case 'Queued':
					var _v2 = _v0.a;
					return '2';
				case 'CreateFailed':
					return '3';
				default:
					var _v3 = _v0.a;
					return '4';
			}
		} else {
			return '5';
		}
	});
var $author$project$Translations$Listings$Claim$googleMatchesFailedToLoad = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_failed_to_load');
};
var $author$project$Tasks$Google$Claim$Tables$OuterTable$outerTableView = F3(
	function (session, model, innerView) {
		var translations = session.translations;
		var _v0 = model.pmtLocations;
		switch (_v0.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Loading':
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			case 'Error':
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Claim$googleMatchesFailedToLoad(translations));
			default:
				var locations = _v0.a;
				var visibleLocations = A2(
					$elm$core$List$filter,
					function (loc) {
						return !_Utils_eq(
							A2($elm$core$Dict$get, loc.id, model.createStates),
							$elm$core$Maybe$Just($author$project$Tasks$Google$Claim$Model$Created));
					},
					locations);
				return $elm$core$List$isEmpty(visibleLocations) ? $author$project$Tasks$Google$Claim$Tables$OuterTable$emptyStateView(session) : A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiOuterTable,
					$author$project$PinMeTo$Ui$Table$withScrollableTable(
						A2(
							$author$project$PinMeTo$Ui$Table$withStickyRowSelection,
							true,
							A2(
								$author$project$PinMeTo$Ui$Table$withRowSelection,
								function ($) {
									return $.id;
								},
								A2(
									$author$project$PinMeTo$Ui$Table$withRowMoreIndent,
									0,
									A2(
										$author$project$PinMeTo$Ui$Table$withRowMore,
										function (loc) {
											return _Utils_eq(
												model.expandedRow,
												$elm$core$Maybe$Just(loc.id)) ? $elm$core$Maybe$Just(
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('google-matches__row-more-inner')
														]),
													_List_fromArray(
														[
															innerView(loc.id)
														]))) : $elm$core$Maybe$Nothing;
										},
										A2(
											$author$project$PinMeTo$Ui$Table$withRowOptions,
											function (loc) {
												return _List_fromArray(
													[
														_Utils_Tuple2(
														$author$project$PinMeTo$Ui$Table$Highlight,
														_Utils_eq(
															model.expandedRow,
															$elm$core$Maybe$Just(loc.id)))
													]);
											},
											A2(
												$author$project$PinMeTo$Ui$Table$withRowAction,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.id;
													},
													$author$project$Tasks$Google$Claim$Model$ToggleRow),
												A2(
													$author$project$PinMeTo$Ui$Table$withSort,
													$author$project$PinMeTo$Ui$Table$Asc(1),
													A2(
														$author$project$PinMeTo$Ui$Table$withColumns,
														_List_fromArray(
															[
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (_v1) {
																	return A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('google-matches__pmt-logo')
																			]),
																		_List_fromArray(
																			[
																				$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$PinMeToLogo)
																			]));
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function ($) {
																		return $.storeId;
																	}),
																''),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																A2($author$project$Tasks$Google$Claim$Tables$OuterTable$storeIdCell, translations, model),
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function ($) {
																		return $.storeId;
																	}),
																$author$project$Translations$Listings$Claim$Google$pmtStoreId(translations)),
																A2(
																$author$project$PinMeTo$Ui$Table$columnWithOptions,
																_List_fromArray(
																	[$author$project$PinMeTo$Ui$Table$Right]),
																A3(
																	$author$project$PinMeTo$Ui$Table$createColumn,
																	function (_v2) {
																		return $elm$html$Html$text('-');
																	},
																	$author$project$PinMeTo$Ui$Table$comparingString(
																		function (_v3) {
																			return '-';
																		}),
																	$author$project$Translations$Listings$Claim$googleMatchesDistance(translations))),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(
																				$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToClass(loc.openStatus))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(loc.openStatus))
																			]));
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function (loc) {
																		return $author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(loc.openStatus);
																	}),
																$author$project$Translations$General$open(translations)),
																A2(
																$author$project$PinMeTo$Ui$Table$columnWithOptions,
																_List_fromArray(
																	[$author$project$PinMeTo$Ui$Table$MaxWidth]),
																A3(
																	$author$project$PinMeTo$Ui$Table$createColumn,
																	A2($author$project$Tasks$Google$Claim$Tables$OuterTable$createStateCell, translations, model),
																	$author$project$PinMeTo$Ui$Table$comparingString(
																		$author$project$Tasks$Google$Claim$Tables$OuterTable$createStateSortKey(model)),
																	$author$project$Translations$General$locationStatus(translations))),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip, model.uiTooltip, loc.id + '-name', loc.name);
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function ($) {
																		return $.name;
																	}),
																$author$project$Translations$General$locationName(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip, model.uiTooltip, loc.id + '-street', loc.address.street);
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.address;
																		},
																		function ($) {
																			return $.street;
																		})),
																$author$project$Translations$General$locationStreet(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip, model.uiTooltip, loc.id + '-zip', loc.address.zip);
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.address;
																		},
																		function ($) {
																			return $.zip;
																		})),
																$author$project$Translations$Listings$Claim$googleMatchesPostcode(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip, model.uiTooltip, loc.id + '-city', loc.address.city);
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.address;
																		},
																		function ($) {
																			return $.city;
																		})),
																$author$project$Translations$General$locationCity(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip, model.uiTooltip, loc.id + '-country', loc.address.countryAlpha2Code);
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.address;
																		},
																		function ($) {
																			return $.countryAlpha2Code;
																		})),
																$author$project$Translations$General$locationCountry(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A2(
																		$elm$html$Html$a,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$href(
																				'/listings/' + ($author$project$Data$SiteName$toString(session.siteName) + ('/locations/' + loc.id))),
																				$elm$html$Html$Attributes$target('_blank')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('LDP')
																			]));
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function (_v4) {
																		return '';
																	}),
																$author$project$Translations$General$link(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return A3($author$project$Tasks$Google$Claim$Tables$OuterTable$wrapInTooltip, model.uiTooltip, loc.id + '-storeId', loc.storeId);
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function ($) {
																		return $.storeId;
																	}),
																$author$project$Translations$Listings$Claim$Google$pmtStoreId(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (loc) {
																	return $author$project$PinMeTo$Ui$Date$render(
																		A2($author$project$PinMeTo$Ui$Date$posix, session.locale, loc.createdAt));
																},
																$author$project$PinMeTo$Ui$Table$comparing(
																	function (loc) {
																		return $elm$time$Time$posixToMillis(loc.createdAt);
																	}),
																$author$project$Translations$General$locationCreated(translations)),
																A3(
																$author$project$PinMeTo$Ui$Table$createColumn,
																function (_v5) {
																	return $elm$html$Html$text('-');
																},
																$author$project$PinMeTo$Ui$Table$comparingString(
																	function (_v6) {
																		return '';
																	}),
																'')
															]),
														A3(
															$author$project$PinMeTo$Ui$Table$withColumnWidths,
															$author$project$PinMeTo$Ui$Table$Ch,
															$author$project$Tasks$Google$Claim$Tables$OuterTable$columnWidths(model),
															A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Google$Claim$Model$OuterTableMsg, visibleLocations))))))))))));
		}
	});
var $author$project$Translations$Listings$Claim$connectAndCreate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.connect_and_create');
};
var $author$project$Translations$Listings$Claim$pinmetoLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.pinmeto_locations');
};
var $author$project$Tasks$Google$Claim$Model$CreateLocations = {$: 'CreateLocations'};
var $author$project$Tasks$Google$Claim$View$renderCreateButton = F2(
	function (session, model) {
		var selectedCount = $elm$core$List$length(
			$author$project$PinMeTo$Ui$Table$selectedItems(model.uiOuterTable));
		var label = $author$project$Translations$General$create(session.translations) + (' (' + ($elm$core$String$fromInt(selectedCount) + ')'));
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				(!selectedCount) || (model.creating || _Utils_eq(model.selectedBusinessAccount, $elm$core$Maybe$Nothing)),
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Tasks$Google$Claim$Model$CreateLocations,
					$author$project$PinMeTo$Ui$Button$buttonPrimary(label))));
	});
var $author$project$Translations$Listings$Claim$googleMatchesExportTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_export_title');
};
var $author$project$Translations$Listings$Claim$googleMatchesExportGbpXlsx = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google_matches_export_gbp_xlsx');
};
var $author$project$Tasks$Google$Claim$View$renderExportSection = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$googleMatchesExportTitle(session.translations))
					])),
				A2(
				$author$project$PinMeTo$Ui$Layout$Flex$render,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								'api/' + ($author$project$Data$SiteName$toString(session.siteName) + '/google/claim/gbpLocations/export')),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$googleMatchesExportGbpXlsx(session.translations))
							]))
					]),
				A2($author$project$PinMeTo$Ui$Layout$Spacing$withMarginTop, $author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD, $author$project$PinMeTo$Ui$Layout$Flex$flex))
			]));
};
var $author$project$Tasks$Google$Claim$Model$SelectMsg = function (a) {
	return {$: 'SelectMsg', a: a};
};
var $author$project$Translations$Listings$Claim$Google$selectBusinessAccount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.select_business_account');
};
var $author$project$Tasks$Google$Claim$Model$BusinessAccountSelected = function (a) {
	return {$: 'BusinessAccountSelected', a: a};
};
var $author$project$Translations$Listings$Claim$Google$errorLoadingBusinessAccounts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.error_loading_business_accounts');
};
var $author$project$Tasks$Google$Claim$View$renderBusinessAccountSelect = F2(
	function (session, model) {
		var dropdownSelector = function (businessAccounts) {
			return A2(
				$author$project$PinMeTo$Ui$Select$render,
				model.uiSelect,
				A2(
					$author$project$PinMeTo$Ui$Select$withSearch,
					{
						searchMap: function ($) {
							return $.name;
						},
						placeholder: $author$project$Translations$General$searchPlaceholder(session.translations),
						noResultsLabel: $author$project$Translations$General$searchNoResults(session.translations)
					},
					A2(
						$author$project$PinMeTo$Ui$Select$viewWithToggle,
						{
							uid: 'ui-select-google-business-account',
							items: businessAccounts,
							tagger: $author$project$Tasks$Google$Claim$Model$SelectMsg,
							onChange: $author$project$Tasks$Google$Claim$Model$BusinessAccountSelected,
							itemRender: A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.name;
								},
								$elm$html$Html$text)
						},
						A2(
							$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter,
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faChevronDown),
							A2(
								$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonStyle,
								$author$project$PinMeTo$Ui$Button$Secondary($author$project$PinMeTo$Ui$Button$SecondaryDefault),
								$author$project$PinMeTo$Ui$Select$uiButtonToggle(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Translations$Listings$Claim$Google$selectBusinessAccount(session.translations),
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.name;
											},
											model.selectedBusinessAccount))))))));
		};
		var _v0 = model.businessAccounts;
		switch (_v0.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Loading':
				return $author$project$PinMeTo$Ui$SkeletonV2$render(
					A2(
						$author$project$PinMeTo$Ui$SkeletonV2$isLoading,
						true,
						A2(
							$author$project$PinMeTo$Ui$SkeletonV2$wrap,
							dropdownSelector(_List_Nil),
							A2($author$project$PinMeTo$Ui$SkeletonV2$withVariant, $author$project$PinMeTo$Ui$SkeletonV2$Gradient, $author$project$PinMeTo$Ui$SkeletonV2$skeleton))));
			case 'Loaded':
				var businessAccounts = _v0.a;
				return dropdownSelector(businessAccounts);
			default:
				return $elm$html$Html$text(
					$author$project$Translations$Listings$Claim$Google$errorLoadingBusinessAccounts(session.translations));
		}
	});
var $author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverFooter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.connect_and_create_popover_footer');
};
var $author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverClaimBody = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.connect_and_create_popover_claim_body');
};
var $author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverClaimTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.connect_and_create_popover_claim_title');
};
var $author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverGoogleGroupBody = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.connect_and_create_popover_google_group_body');
};
var $author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverGoogleGroupTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.connect_and_create_popover_google_group_title');
};
var $author$project$Tasks$Google$Claim$View$renderMatchSections = F2(
	function (session, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg,
				A2($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$View$view, session, model.suggestedMatchesState)),
				$author$project$Tasks$Google$Claim$View$lineSeparator,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('google-matches__section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$connectAndCreate(session.translations))
							])),
						A2(
						$author$project$PinMeTo$Ui$PopOver$renderPlain,
						model.uiPopOver,
						$author$project$PinMeTo$Ui$PopOver$view(
							{
								uid: 'connect-and-create-popover',
								tagger: $author$project$Tasks$Google$Claim$Model$PopOverMsg,
								content: _List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverGoogleGroupTitle(session.translations))
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverGoogleGroupBody(session.translations))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverClaimTitle(session.translations))
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverClaimBody(session.translations))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Claim$Google$connectAndCreatePopoverFooter(session.translations))
											]))
									]),
								preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
							}))
					])),
				A2(
				$author$project$PinMeTo$Ui$ViewSelector$render,
				function (tab) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__tab-content')
							]),
						_List_fromArray(
							[
								function () {
								if (tab.$ === 'GbpTab') {
									return A2($author$project$Tasks$Google$Claim$Tables$GbpTable$gbpTableView, session.translations, model);
								} else {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$PinMeTo$Ui$Layout$Flex$render,
												_List_fromArray(
													[
														A2($author$project$Tasks$Google$Claim$View$renderCreateButton, session, model),
														A2($author$project$Tasks$Google$Claim$View$renderBusinessAccountSelect, session, model)
													]),
												A2(
													$author$project$PinMeTo$Ui$Layout$Spacing$withMarginBottom,
													$author$project$PinMeTo$Ui$Layout$Spacing$SpacingLG,
													A2(
														$author$project$PinMeTo$Ui$Layout$Spacing$withGap,
														$author$project$PinMeTo$Ui$Layout$Spacing$SpacingXL,
														A2($author$project$PinMeTo$Ui$Layout$Flex$withDirection, $author$project$PinMeTo$Ui$Layout$Flex$Row, $author$project$PinMeTo$Ui$Layout$Flex$flex)))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$PinMeTo$Ui$Layout$Spacing$margin(
														{
															top: $elm$core$Maybe$Nothing,
															left: $elm$core$Maybe$Nothing,
															right: $elm$core$Maybe$Nothing,
															bottom: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$Layout$Spacing$SpacingMD)
														})
													]),
												_List_fromArray(
													[
														$author$project$Tasks$Google$Claim$View$renderAlert(model.createNotification)
													])),
												A3(
												$author$project$Tasks$Google$Claim$Tables$OuterTable$outerTableView,
												session,
												model,
												A2($author$project$Tasks$Google$Claim$Tables$InnerTable$innerTableView, session.translations, model))
											]));
								}
							}()
							]));
				},
				A2(
					$author$project$PinMeTo$Ui$ViewSelector$viewSelector,
					{
						url: $author$project$Tasks$Google$Claim$View$parseUrl(session.url),
						queryKey: 'tab',
						defaultView: $author$project$Tasks$Google$Claim$Model$PmtTab,
						viewToString: $author$project$Tasks$Google$Claim$View$tabToString,
						viewFromString: $author$project$Tasks$Google$Claim$View$tabFromString
					},
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$ViewSelector$iconLabelItem,
							$author$project$PinMeTo$Ui$ViewSelector$UiIcon($author$project$PinMeTo$Ui$Icon$PinMeToLogo),
							$author$project$Translations$Listings$Claim$pinmetoLocations(session.translations) + (' (' + ($author$project$Tasks$Google$Claim$View$countLabel(model.pmtLocations) + ')')),
							$author$project$Tasks$Google$Claim$Model$PmtTab),
							A3(
							$author$project$PinMeTo$Ui$ViewSelector$iconLabelItem,
							$author$project$PinMeTo$Ui$ViewSelector$UiIcon($author$project$PinMeTo$Ui$Icon$RegularColorGMB),
							$author$project$Translations$Listings$Claim$googleMatchesGbp(session.translations) + (' (' + ($author$project$Tasks$Google$Claim$View$countLabel(model.notMatchedLocations) + ')')),
							$author$project$Tasks$Google$Claim$Model$GbpTab)
						]))),
				$author$project$Tasks$Google$Claim$View$lineSeparator,
				$author$project$Tasks$Google$Claim$View$renderExportSection(session)
			]);
	});
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderAlert = function (notification) {
	if (notification.$ === 'Just') {
		var message = notification.a.message;
		var state = notification.a.state;
		return $author$project$PinMeTo$Ui$Alert$render(
			function () {
				switch (state.$) {
					case 'Success':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
					case 'Failed':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
					default:
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
				}
			}()(
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Tasks$Google$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Google$Claim$Update$areCategoriesSelected = function (model) {
	var areAllAdditionalCategoriesSelected = A2($elm$core$List$all, $elm_community$maybe_extra$Maybe$Extra$isJust, model.additionalCategoriesList);
	var isPrimaryCategorySelected = $elm_community$maybe_extra$Maybe$Extra$isJust(model.primaryCategory);
	return isPrimaryCategorySelected && areAllAdditionalCategoriesSelected;
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Google$Claim$Update$areCategoriesSelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Google$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Translations$Listings$LocationDetail$additionalCategories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.additional_categories');
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Google$Claim$Model$SelectedPrimaryCategory = function (a) {
	return {$: 'SelectedPrimaryCategory', a: a};
};
var $author$project$Tasks$Google$Claim$Model$SelectedAdditionalCategory = F2(
	function (a, b) {
		return {$: 'SelectedAdditionalCategory', a: a, b: b};
	});
var $author$project$Tasks$Google$Claim$Model$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderCategorySelector = F6(
	function (uid, translations, model, categories, category, index) {
		var isPrimary = uid === 'ui-select-primary';
		var title = isPrimary ? $author$project$Translations$Listings$LocationDetail$primaryCategory(translations) : A2(
			$author$project$Translations$Listings$LocationDetail$additionalCategory,
			translations,
			$elm$core$String$fromInt(index + 1));
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					isPrimary ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid + ('-' + $elm$core$String$fromInt(index)),
													items: A2($author$project$Tasks$Google$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Google$Claim$Model$SelectMsg,
													onChange: function (category_) {
														return isPrimary ? $author$project$Tasks$Google$Claim$Model$SelectedPrimaryCategory(category_) : A2($author$project$Tasks$Google$Claim$Model$SelectedAdditionalCategory, category_, index);
													},
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								])),
							isPrimary ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__remove-additional'),
									$elm$html$Html$Events$onClick(
									$author$project$Tasks$Google$Claim$Model$RemoveAdditionalCategoryByIndex(index))
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
								]))
						]))
				]));
	});
var $author$project$Tasks$Google$Claim$Model$AddAdditionalCategory = {$: 'AddAdditionalCategory'};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderAddCategoryButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__publish-button')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Tasks$Google$Claim$Model$AddAdditionalCategory)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$addCategory(translations))
					]))
			]));
};
var $author$project$Translations$Listings$Claim$categoriesPublishWarning = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.categories_publish_warning');
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderAdditionalCategories = F3(
	function (translations, model, categories) {
		return $elm$core$List$isEmpty(model.additionalCategoriesList) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return A6($author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-additional', translations, model, categories, item, index);
					}),
				model.additionalCategoriesList));
	});
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$getCategoryId = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	function (category_) {
		return $author$project$Data$Location$NetworkCategories$getId(category_);
	});
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$getSelectedCategoryIds = function (model) {
	return A2(
		$elm$core$List$append,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (category) {
				return _List_fromArray(
					[
						$author$project$Data$Location$NetworkCategories$getId(category)
					]);
			},
			model.primaryCategory),
		A2(
			$elm$core$List$filter,
			function (category) {
				return category !== '';
			},
			A2($elm$core$List$map, $author$project$Tasks$Google$Claim$Sections$CategoriesSection$getCategoryId, model.additionalCategoriesList)));
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$getAllNotSelectedCategories = function (model) {
	var _v0 = model.allCategories;
	if (_v0.$ === 'Loaded') {
		var categories = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (category) {
				return !A2(
					$elm$core$List$member,
					$author$project$Data$Location$NetworkCategories$getId(category),
					$author$project$Tasks$Google$Claim$Sections$CategoriesSection$getSelectedCategoryIds(model));
			},
			categories);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = $author$project$Tasks$Google$Claim$Sections$CategoriesSection$sortCategories(
			$author$project$Tasks$Google$Claim$Sections$CategoriesSection$getAllNotSelectedCategories(model));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('google-matches__section-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Claim$categories(translations))
								]))
						])),
					$author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderAlert(model.categoriesNotification),
					A6($author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-primary', translations, model, sortedCategories, model.primaryCategory, 0),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$LocationDetail$additionalCategories(translations))
						])),
					A3($author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderAdditionalCategories, translations, model, sortedCategories),
					$author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderAddCategoryButton(translations),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__render-distance')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Note,
								$author$project$PinMeTo$Ui$Alert$plain(
									$author$project$Translations$Listings$Claim$categoriesPublishWarning(translations))))
						])),
					A2($author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
				]));
	});
var $author$project$Translations$Listings$Claim$syncLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations');
};
var $author$project$FontAwesome$Solid$Icon$faArrowsRotate = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-arrows-rotate');
var $author$project$Tasks$Google$Claim$Model$RunLocationFinder = {$: 'RunLocationFinder'};
var $author$project$Translations$Listings$Claim$syncLocationsError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_error');
};
var $author$project$Tasks$Google$Claim$View$renderLocationFinderError = F2(
	function (translations, status) {
		if (status.$ === 'FinderError') {
			var err = status.a;
			return $author$project$PinMeTo$Ui$Alert$render(
				A2(
					$author$project$PinMeTo$Ui$Alert$withStatus,
					$author$project$PinMeTo$Ui$Alert$Error,
					$author$project$PinMeTo$Ui$Alert$plain(
						$author$project$Translations$Listings$Claim$syncLocationsError(translations) + (': ' + err))));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$Listings$Claim$syncLocationsLastRun = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_last_run');
};
var $author$project$Translations$Listings$Claim$syncLocationsErroredAt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_errored_at');
};
var $author$project$Translations$Listings$Claim$syncLocationsStartedAt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_started_at');
};
var $author$project$Tasks$Google$Claim$View$timestampLabel = F2(
	function (translations, status) {
		switch (status.$) {
			case 'Running':
				return $author$project$Translations$Listings$Claim$syncLocationsStartedAt(translations);
			case 'FinderError':
				return $author$project$Translations$Listings$Claim$syncLocationsErroredAt(translations);
			default:
				return $author$project$Translations$Listings$Claim$syncLocationsLastRun(translations);
		}
	});
var $author$project$Translations$Listings$Claim$syncLocationsAt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_at');
};
var $author$project$Translations$Listings$Claim$syncLocationsNeverRun = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_never_run');
};
var $author$project$Tasks$Google$Claim$View$renderLocationFinderLastRun = F3(
	function (session, status, lastRun) {
		var dateAndTime = function () {
			if (lastRun.$ === 'Nothing') {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$syncLocationsNeverRun(session.translations))
							]))
					]);
			} else {
				var lastRun_ = lastRun.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Date$render(
										A2(
											$author$project$PinMeTo$Ui$Date$withFormat,
											$author$project$PinMeTo$Ui$Date$FormatDate,
											A2($author$project$PinMeTo$Ui$Date$string, session.locale, lastRun_)))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' ' + ($author$project$Translations$Listings$Claim$syncLocationsAt(session.translations) + ' '))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Date$render(
										A2(
											$author$project$PinMeTo$Ui$Date$withFormat,
											$author$project$PinMeTo$Ui$Date$FormatTime,
											A2($author$project$PinMeTo$Ui$Date$string, session.locale, lastRun_)))
									]))
							]))
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations__container')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__sync-locations__last-sync'),
							$elm$html$Html$Attributes$class('pmt-ui-font-caption')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Tasks$Google$Claim$View$timestampLabel, session.translations, status))
						])),
				dateAndTime));
	});
var $author$project$Tasks$Google$Claim$View$renderLocationFinderSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations_section')
				]),
			_List_fromArray(
				[
					A3($author$project$Tasks$Google$Claim$View$renderLocationFinderLastRun, session, model.locationFinderStatus, model.locationFinderLastRun),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$disabledIfTrue,
						_Utils_eq(model.locationFinderStatus, $author$project$Tasks$Google$Claim$Model$Running),
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Tasks$Google$Claim$Model$RunLocationFinder,
							A2(
								$author$project$PinMeTo$Ui$Button$withIconBefore,
								$author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faArrowsRotate),
								$author$project$PinMeTo$Ui$Button$buttonPrimary(
									$author$project$Translations$Listings$Claim$syncLocations(session.translations)))))),
					A2($author$project$Tasks$Google$Claim$View$renderLocationFinderError, session.translations, model.locationFinderStatus)
				]));
	});
var $author$project$Tasks$Google$Claim$Model$Verifying = {$: 'Verifying'};
var $author$project$Tasks$Google$Claim$Model$VerifyGoogleLocation = function (a) {
	return {$: 'VerifyGoogleLocation', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$VerificationSection$verifyButtonCell = F2(
	function (model, location) {
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				_Utils_eq(
					A2($elm$core$Dict$get, location.id, model.verifyStates),
					$elm$core$Maybe$Just($author$project$Tasks$Google$Claim$Model$Verifying)),
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Tasks$Google$Claim$Model$VerifyGoogleLocation(location.id),
					$author$project$PinMeTo$Ui$Button$buttonSecondary('Verify'))));
	});
var $author$project$Tasks$Google$Claim$Sections$VerificationSection$verifyStatusCell = F2(
	function (model, location) {
		var _v0 = A2($elm$core$Dict$get, location.id, model.verifyStates);
		if (_v0.$ === 'Nothing') {
			return $elm$html$Html$text('-');
		} else {
			switch (_v0.a.$) {
				case 'Verifying':
					var _v1 = _v0.a;
					return $elm$html$Html$text('Verifying...');
				case 'Verified':
					var status = _v0.a.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__status--success')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(status)
							]));
				default:
					var message = _v0.a.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('google-matches__status--duplicate')
							]),
						_List_fromArray(
							[
								A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, location.id + '-verifyError', message)
							]));
			}
		}
	});
var $author$project$Tasks$Google$Claim$Sections$VerificationSection$verifyStatusSortKey = F2(
	function (model, location) {
		var _v0 = A2($elm$core$Dict$get, location.id, model.verifyStates);
		if (_v0.$ === 'Nothing') {
			return '';
		} else {
			switch (_v0.a.$) {
				case 'Verifying':
					var _v1 = _v0.a;
					return 'Verifying';
				case 'Verified':
					var status = _v0.a.a;
					return status;
				default:
					var message = _v0.a.a;
					return message;
			}
		}
	});
var $author$project$Tasks$Google$Claim$Model$VerificationTableMsg = function (a) {
	return {$: 'VerificationTableMsg', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$VerificationSection$renderTable = F3(
	function (translations, model, locations) {
		return A2(
			$author$project$PinMeTo$Ui$Table$render,
			model.uiVerificationTable,
			$author$project$PinMeTo$Ui$Table$withScrollableTable(
				A2(
					$author$project$PinMeTo$Ui$Table$withSort,
					$author$project$PinMeTo$Ui$Table$Asc(2),
					A2(
						$author$project$PinMeTo$Ui$Table$withLimit,
						{
							limit: 10,
							viewMoreLabel: F2(
								function (shown, total) {
									return 'Show more (' + ($elm$core$String$fromInt(shown) + ('/' + ($elm$core$String$fromInt(total) + ')')));
								})
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withColumns,
							_List_fromArray(
								[
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									$author$project$Tasks$Google$Claim$Sections$VerificationSection$verifyButtonCell(model),
									$author$project$PinMeTo$Ui$Table$comparingString(
										function (_v0) {
											return '';
										}),
									''),
									A2(
									$author$project$PinMeTo$Ui$Table$columnWithOptions,
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Table$MaxWidth]),
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										$author$project$Tasks$Google$Claim$Sections$VerificationSection$verifyStatusCell(model),
										$author$project$PinMeTo$Ui$Table$comparingString(
											$author$project$Tasks$Google$Claim$Sections$VerificationSection$verifyStatusSortKey(model)),
										'Verification')),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, loc.id + '-verify-storeId', loc.storeId);
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										function ($) {
											return $.storeId;
										}),
									$author$project$Translations$Listings$Claim$Google$pmtStoreId(translations)),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, loc.id + '-verify-name', loc.name);
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										function ($) {
											return $.name;
										}),
									$author$project$Translations$General$locationName(translations)),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, loc.id + '-verify-street', loc.address.street);
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.street;
											})),
									$author$project$Translations$General$locationStreet(translations)),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, loc.id + '-verify-zip', loc.address.zip);
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.zip;
											})),
									$author$project$Translations$Listings$Claim$googleMatchesPostcode(translations)),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, loc.id + '-verify-city', loc.address.city);
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.city;
											})),
									$author$project$Translations$General$locationCity(translations)),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										return A3($author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip, model.uiTooltip, loc.id + '-verify-country', loc.address.countryAlpha2Code);
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.countryAlpha2Code;
											})),
									$author$project$Translations$General$locationCountry(translations)),
									A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									function (loc) {
										var _v1 = loc.googleId;
										if (_v1.$ === 'Just') {
											var googleId = _v1.a;
											return A3(
												$author$project$Tasks$Google$Claim$Tables$TableHelpers$wrapInTooltip,
												model.uiTooltip,
												loc.id + '-verify-gbpId',
												$author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId(googleId));
										} else {
											return $elm$html$Html$text('-');
										}
									},
									$author$project$PinMeTo$Ui$Table$comparingString(
										function (loc) {
											return A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId, loc.googleId));
										}),
									$author$project$Translations$Listings$Claim$googleMatchesGoogleBusinessProfileId(translations))
								]),
							A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Google$Claim$Model$VerificationTableMsg, locations))))));
	});
var $author$project$Tasks$Google$Claim$Sections$VerificationSection$renderVerificationSection = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-sub-headline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Google verification (dev)')
						])),
					function () {
					var _v0 = model.unverifiedLocations;
					switch (_v0.$) {
						case 'Suspended':
							return $elm$html$Html$text('');
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Claim$googleMatchesLoadingMatches(translations))
									]));
						case 'Error':
							var err = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						default:
							if (!_v0.a.b) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('No unverified locations')
										]));
							} else {
								var locations = _v0.a;
								return A3($author$project$Tasks$Google$Claim$Sections$VerificationSection$renderTable, translations, model, locations);
							}
					}
				}()
				]));
	});
var $author$project$Tasks$Google$Claim$View$renderDevVerificationSection = F2(
	function (session, model) {
		return $author$project$Tasks$Google$Claim$View$shouldSeeVerification(session.user) ? _List_fromArray(
			[
				$author$project$Tasks$Google$Claim$View$lineSeparator,
				A2($author$project$Tasks$Google$Claim$Sections$VerificationSection$renderVerificationSection, session.translations, model)
			]) : _List_Nil;
	});
var $author$project$Tasks$Google$Claim$View$view = F2(
	function (session, model) {
		var running = _Utils_eq(model.locationFinderStatus, $author$project$Tasks$Google$Claim$Model$Running);
		var syncProgress = running ? _List_fromArray(
			[
				A2($author$project$Tasks$Google$Claim$View$renderSyncProgress, session, model)
			]) : _List_Nil;
		var matchSections = running ? _List_Nil : A2($author$project$Tasks$Google$Claim$View$renderMatchSections, session, model);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('google-matches container network-claim-page__page-margin')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
							]),
						_List_fromArray(
							[
								$author$project$Tasks$Google$Claim$View$renderHeader(session),
								A2($author$project$Tasks$Google$Claim$View$renderLocationFinderSection, session, model)
							])),
						$author$project$Tasks$Google$Claim$View$lineSeparator
					]),
				_Utils_ap(
					syncProgress,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Tasks$Google$Claim$Model$ChainSectionMsg,
								A2($author$project$Tasks$Google$Claim$Sections$ChainSection$View$view, session, model.chainSectionState)),
								$author$project$Tasks$Google$Claim$View$lineSeparator,
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Tasks$Google$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model),
										$author$project$Tasks$Google$Claim$View$lineSeparator
									]))
							]),
						_Utils_ap(
							matchSections,
							A2($author$project$Tasks$Google$Claim$View$renderDevVerificationSection, session, model))))));
	});
var $author$project$Tasks$Google$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkingChain = {$: 'LinkingChain'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$Chain = F3(
	function (name, chainNames, websites) {
		return {name: name, websites: websites, chainNames: chainNames};
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$chainDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'websites',
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'uri', $elm$json$Json$Decode$string)),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'chainNames',
		$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$localizedTextDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Sections$ChainSection$Model$Chain))));
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$chainsResponseDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$andThen, $elm$json$Json$Decode$fail, $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$serverErrorMessageDecoder),
			A2(
			$elm$json$Json$Decode$field,
			'chains',
			$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$chainDecoder)),
			$elm$json$Json$Decode$succeed(_List_Nil)
		]));
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$searchChains = F3(
	function (_v0, searchTerm, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$chainsResponseDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$chainBaseUrl(siteName) + ('/search/' + $elm$url$Url$percentEncode(searchTerm))))));
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$UnlinkingChain = {$: 'UnlinkingChain'};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$setLinkedChain = F3(
	function (_v0, chain, msg) {
		var siteName = _v0.a;
		var encodeLocalizedText = function (lt) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'displayName',
						$elm$json$Json$Encode$string(lt.displayName)),
						_Utils_Tuple2(
						'languageCode',
						$elm$json$Json$Encode$string(lt.languageCode))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(chain.name)),
					_Utils_Tuple2(
					'chainNames',
					A2($elm$json$Json$Encode$list, encodeLocalizedText, chain.chainNames))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Sections$ChainSection$Decoders$linkedChainDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$post(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$chainBaseUrl(siteName)))));
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$removeLinkedChain = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(_Utils_Tuple0),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$delete(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$chainBaseUrl(siteName)))));
	});
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkedChainResponse = function (a) {
	return {$: 'LinkedChainResponse', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$GotChainSearchResults = function (a) {
	return {$: 'GotChainSearchResults', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$UnlinkedChainResponse = function (a) {
	return {$: 'UnlinkedChainResponse', a: a};
};
var $author$project$Tasks$Google$Claim$Sections$ChainSection$Update$update = F3(
	function (session, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(model),
					$elm$core$Platform$Cmd$none);
			case 'ChainSearchTermChanged':
				var term = msg.a;
				return _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
						_Utils_update(
							model,
							{chainSearchTerm: term})),
					$elm$core$Platform$Cmd$none);
			case 'SearchChains':
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(model.chainSearchTerm)) ? _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(model),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
						_Utils_update(
							model,
							{chainSearchResults: $author$project$RemoteData$Loading})),
					A3($author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$searchChains, session.siteName, model.chainSearchTerm, $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$GotChainSearchResults));
			case 'GotChainSearchResults':
				if (msg.a.$ === 'Ok') {
					var chains = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{
									chainSearchResults: $author$project$RemoteData$Loaded(chains)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{
									chainSearchResults: $author$project$RemoteData$Error(
										$author$project$Translations$Listings$Claim$googleMatchesChainSectionFailedToSearch(session.translations))
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Sections.ChainSection.Update.GotChainSearchResults',
								message: 'Failed to search chains'
							}));
				}
			case 'ToggleExpandedChain':
				var chainId = msg.a;
				return _Utils_eq(
					model.expandedChain,
					$elm$core$Maybe$Just(chainId)) ? _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
						_Utils_update(
							model,
							{expandedChain: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
						_Utils_update(
							model,
							{
								expandedChain: $elm$core$Maybe$Just(chainId)
							})),
					$elm$core$Platform$Cmd$none);
			case 'GotLinkedChain':
				if (msg.a.$ === 'Ok') {
					var linkedChain = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{
									linkedChain: $author$project$RemoteData$Loaded(linkedChain)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{
									linkedChain: $author$project$RemoteData$Error(
										$author$project$Translations$Listings$Claim$googleMatchesChainSectionFailedToLoadLinked(session.translations))
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Sections.ChainSection.Update.GotLinkedChain',
								message: 'Failed to load linked chain'
							}));
				}
			case 'LinkChain':
				var chain = msg.a;
				return _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
						_Utils_update(
							model,
							{chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkingChain})),
					A3($author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$setLinkedChain, session.siteName, chain, $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$LinkedChainResponse));
			case 'LinkedChainResponse':
				if (msg.a.$ === 'Ok') {
					var linkedChain = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{
									linkedChain: $author$project$RemoteData$Loaded(linkedChain),
									chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation,
									chainSearchResults: $author$project$RemoteData$Suspended
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Sections.ChainSection.Update.LinkedChainResponse',
								message: 'Failed to link chain'
							}));
				}
			case 'UnlinkChain':
				return _Utils_Tuple2(
					$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
						_Utils_update(
							model,
							{chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$UnlinkingChain})),
					A2($author$project$Tasks$Google$Claim$Sections$ChainSection$Commands$removeLinkedChain, session.siteName, $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$UnlinkedChainResponse));
			default:
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{
									linkedChain: $author$project$RemoteData$Loaded($elm$core$Maybe$Nothing),
									chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Sections$ChainSection$Model$State(
							_Utils_update(
								model,
								{chainOperation: $author$project$Tasks$Google$Claim$Sections$ChainSection$Model$NoChainOperation})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Sections.ChainSection.Update.UnlinkedChainResponse',
								message: 'Failed to unlink chain'
							}));
				}
		}
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg = {$: 'NoOutMsg'};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$selectAllIds = function (matches) {
	return $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.id;
			},
			matches));
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$RefreshLocations = {$: 'RefreshLocations'};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Commands$confirmSuggestedMatches = F3(
	function (_v0, _v1, msg) {
		var siteName = _v0.a;
		var rejectedMatchIds = _v1.rejectedMatchIds;
		var confirmedMatchIds = _v1.confirmedMatchIds;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Decoders$suggestedMatchesResponseDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'confirmedMatchIds',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, confirmedMatchIds)),
								_Utils_Tuple2(
								'rejectedMatchIds',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, rejectedMatchIds))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/google/claim/confirmMatches')))));
	});
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ConfirmedSuggestedMatches = function (a) {
	return {$: 'ConfirmedSuggestedMatches', a: a};
};
var $author$project$Translations$Listings$Claim$Google$suggestedMatchesConfirmFailed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.google.suggested_matches_confirm_failed');
};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$update = F3(
	function (session, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple3(
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(model),
					$elm$core$Platform$Cmd$none,
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
			case 'GotSuggestedMatches':
				if (msg.a.$ === 'Ok') {
					var suggestedMatches = msg.a.a;
					return _Utils_Tuple3(
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
							_Utils_update(
								model,
								{
									selectedMatches: $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$selectAllIds(suggestedMatches),
									suggestedMatches: $author$project$RemoteData$Loaded(suggestedMatches)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
							_Utils_update(
								model,
								{
									suggestedMatches: $author$project$RemoteData$Error('Failed to load suggested matches')
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.Sections.SuggestedMatches.Update.GotSuggestedMatches',
								message: 'Failed to load suggested matches'
							}),
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
				}
			case 'ToggleSuggestedMatch':
				var matchId = msg.a;
				var newSelected = A2($elm$core$Set$member, matchId, model.selectedMatches) ? A2($elm$core$Set$remove, matchId, model.selectedMatches) : A2($elm$core$Set$insert, matchId, model.selectedMatches);
				return _Utils_Tuple3(
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
						_Utils_update(
							model,
							{selectedMatches: newSelected})),
					$elm$core$Platform$Cmd$none,
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
			case 'ConfirmSuggestedMatches':
				var body = msg.a;
				return _Utils_Tuple3(
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
						_Utils_update(
							model,
							{confirming: true, confirmError: $elm$core$Maybe$Nothing})),
					A3($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Commands$confirmSuggestedMatches, session.siteName, body, $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$ConfirmedSuggestedMatches),
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
			case 'ConfirmedSuggestedMatches':
				if (msg.a.$ === 'Ok') {
					var remaining = msg.a.a;
					return _Utils_Tuple3(
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
							_Utils_update(
								model,
								{
									confirming: false,
									confirmError: $elm$core$Maybe$Nothing,
									selectedMatches: $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$selectAllIds(remaining),
									suggestedMatches: $author$project$RemoteData$Loaded(remaining)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$RefreshLocations);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
							_Utils_update(
								model,
								{
									confirming: false,
									confirmError: $elm$core$Maybe$Just(
										$author$project$Translations$Listings$Claim$Google$suggestedMatchesConfirmFailed(session.translations))
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.Sections.SuggestedMatches.Update.ConfirmedSuggestedMatches',
								message: 'Failed to confirm suggested matches'
							}),
						$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
				}
			default:
				var popOverMsg = msg.a;
				var _v2 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$UiPopOverMsg, popOverMsg, model.uiPopOver);
				var newPopOver = _v2.a;
				var popOverCmd = _v2.b;
				return _Utils_Tuple3(
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$State(
						_Utils_update(
							model,
							{uiPopOver: newPopOver})),
					popOverCmd,
					$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$NoOutMsg);
		}
	});
var $author$project$Tasks$Google$Claim$Model$Success = {$: 'Success'};
var $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$refresh = function (siteName) {
	return A2($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Commands$getSuggestedMatches, siteName, $author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Model$GotSuggestedMatches);
};
var $author$project$Tasks$Google$Claim$Model$Verified = function (a) {
	return {$: 'Verified', a: a};
};
var $author$project$Tasks$Google$Claim$Model$VerifyFailed = function (a) {
	return {$: 'VerifyFailed', a: a};
};
var $author$project$PinMeTo$Ui$Table$clearSelected = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Ui$Table$State(
		_Utils_update(
			model,
			{selected: $elm$core$Set$empty, deselected: $elm$core$Set$empty}));
};
var $author$project$Tasks$Google$Claim$Commands$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getId(x))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getName(x)))
			]));
};
var $author$project$Tasks$Google$Claim$Commands$encodePrimaryCategory = function (primaryCategory) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (primary) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'primaryCategory',
						$author$project$Tasks$Google$Claim$Commands$encodeCategory(primary))
					]);
			},
			primaryCategory));
};
var $author$project$Tasks$Google$Claim$Commands$encodeCategories = function (model) {
	var additionalCategories = A2($elm$core$List$filterMap, $elm$core$Basics$identity, model.additionalCategoriesList);
	var primaryCategory = model.primaryCategory;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'additionalCategories',
							A2($elm$json$Json$Encode$list, $author$project$Tasks$Google$Claim$Commands$encodeCategory, additionalCategories)),
						$author$project$Tasks$Google$Claim$Commands$encodePrimaryCategory(primaryCategory))))
			]));
};
var $author$project$Tasks$Google$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/google/categories');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Google$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Google$Claim$Model$CreatedLocations = function (a) {
	return {$: 'CreatedLocations', a: a};
};
var $author$project$Tasks$Google$Claim$Model$GotGoogleMatches = F2(
	function (a, b) {
		return {$: 'GotGoogleMatches', a: a, b: b};
	});
var $author$project$Tasks$Google$Claim$Commands$getGoogleMatches = F3(
	function (_v0, locationId, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + ('/google/claim/googleMatches/' + locationId));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$googleMatchesDecoder)),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Claim$Model$RanLocationFinder = function (a) {
	return {$: 'RanLocationFinder', a: a};
};
var $author$project$Tasks$Google$Claim$Update$emptyNotification = function (model) {
	return _Utils_update(
		model,
		{categoriesNotification: $elm$core$Maybe$Nothing});
};
var $author$project$Tasks$Google$Claim$Commands$runLocationFinder = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/locationsfind');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(_Utils_Tuple0),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$post(url)));
	});
var $author$project$Tasks$Google$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				categoriesNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$Google$Claim$Model$ConnectingLocations = F2(
	function (a, b) {
		return {$: 'ConnectingLocations', a: a, b: b};
	});
var $author$project$Tasks$Google$Claim$Model$CreateLocationsResult = F2(
	function (data, states) {
		return {data: data, states: states};
	});
var $author$project$Tasks$Google$Claim$Decoders$createLocationsResultDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'states',
	$author$project$Tasks$Google$Claim$Decoders$createStatesDecoder,
	$elm$core$Dict$empty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'data',
		$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$pmtLocationDecoder),
		$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$CreateLocationsResult)));
var $author$project$Tasks$Google$Claim$Commands$postCreateLocations = F4(
	function (_v0, googleBusinessAccountId, locationIds, msg) {
		var siteName = _v0.a;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'googleBusinessAccountId',
					$elm$json$Json$Encode$string(googleBusinessAccountId)),
					_Utils_Tuple2(
					'locationIds',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locationIds))
				]));
		var url = 'api/' + (siteName + '/google/claim/createLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Decoders$createLocationsResultDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Google$Claim$Model$ImportedGbpLocations = function (a) {
	return {$: 'ImportedGbpLocations', a: a};
};
var $author$project$Tasks$Google$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Google$Claim$Commands$postConnectLocations = F3(
	function (_v0, body, msg) {
		var siteName = _v0.a;
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'locationId',
					$elm$json$Json$Encode$string(body.locationId)),
					_Utils_Tuple2(
					'googleId',
					$elm$json$Json$Encode$string(body.googleId)),
					_Utils_Tuple2(
					'listIndex',
					$elm$json$Json$Encode$int(body.listIndex)),
					_Utils_Tuple2(
					'googleAddress',
					$author$project$Data$Address$addressEncoder(body.googleAddress)),
					_Utils_Tuple2(
					'pmtAddress',
					$author$project$Data$Address$addressEncoder(body.pmtAddress))
				]));
		var url = 'api/' + (siteName + '/google/claim/connectLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$googleMatchesDecoder)),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body_,
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth = function (charCount) {
	return charCount + 1;
};
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent = F2(
	function (maxChars, content) {
		return A2($elm$core$Basics$min, maxChars, content);
	});
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$headerPadding = 2;
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxHeaderLength = function (headers) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				function (h) {
					return $elm$core$String$length(h) + $author$project$Tasks$Google$Claim$Tables$ColumnWidths$headerPadding;
				},
				headers)));
};
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxStringLength = F2(
	function (f, items) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$maximum(
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, f, $elm$core$String$length),
					items)));
	});
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$storeIdCopyButtonWidth = 4;
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$computeColumnWidths = F4(
	function (translations, pmtLocations, googleMatches, accounts) {
		var withHeader = F2(
			function (headers, contentWidth) {
				return A2(
					$elm$core$Basics$max,
					contentWidth,
					$author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxHeaderLength(headers));
			});
		var openWidth = function () {
			var googleMatchesLength = A2(
				$elm$core$Maybe$withDefault,
				1,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$map,
						function (m) {
							return $elm$core$String$length(
								$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(m.openStatus)) + 1;
						},
						googleMatches)));
			var pmtLocationsLength = A2(
				$elm$core$Maybe$withDefault,
				1,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$map,
						function (loc) {
							return $elm$core$String$length(
								$author$project$Tasks$Google$Claim$Tables$OpenStatus$googleOpenStatusToString(loc.openStatus)) + 1;
						},
						pmtLocations)));
			return A2($elm$core$Basics$max, pmtLocationsLength, googleMatchesLength);
		}();
		var maxAcross = F2(
			function (pmtF, googleF) {
				return A2(
					$elm$core$Basics$max,
					A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxStringLength, pmtF, pmtLocations),
					A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxStringLength, googleF, googleMatches));
			});
		return _List_fromArray(
			[
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$Listings$Claim$Google$pmtStoreId(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							12,
							A2(
								$author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxStringLength,
								function ($) {
									return $.storeId;
								},
								pmtLocations))) + $author$project$Tasks$Google$Claim$Tables$ColumnWidths$storeIdCopyButtonWidth)),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$Listings$Claim$googleMatchesDistance(translations)
							]),
						0))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$open(translations)
							]),
						openWidth))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$locationStatus(translations)
							]),
						0))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$locationName(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							20,
							A2(
								maxAcross,
								function ($) {
									return $.name;
								},
								function ($) {
									return $.name;
								}))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$locationStreet(translations),
								$author$project$Translations$General$locationAddress(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							20,
							A2(
								maxAcross,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.street;
									}),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.street;
									})))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$Listings$Claim$googleMatchesPostcode(translations)
							]),
						A2(
							maxAcross,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.zip;
								}),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.zip;
								}))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$locationCity(translations),
								$author$project$Translations$Listings$Claim$googleMatchesLocality(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							12,
							A2(
								maxAcross,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.city;
									}),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.city;
									})))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$locationCountry(translations)
							]),
						A2(
							maxAcross,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.countryAlpha2Code;
								}),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.countryAlpha2Code;
								}))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$link(translations)
							]),
						0))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$Listings$Claim$Google$gbpStoreCode(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							12,
							A2(
								maxAcross,
								function ($) {
									return $.storeId;
								},
								function (m) {
									return A2($elm$core$Maybe$withDefault, '', m.storeId);
								}))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$General$locationCreated(translations),
								$author$project$Translations$Listings$Claim$googleMatchesGoogleBusinessProfileId(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							15,
							A2(
								$author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxStringLength,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.googleBusinessId;
									},
									$author$project$Tasks$Google$Claim$Tables$TableHelpers$trimGbpId),
								googleMatches))))),
				$elm$core$Maybe$Just(
				$author$project$Tasks$Google$Claim$Tables$ColumnWidths$toChWidth(
					A2(
						withHeader,
						_List_fromArray(
							[
								$author$project$Translations$Listings$Claim$googleMatchesGbpAccountName(translations)
							]),
						A2(
							$author$project$Tasks$Google$Claim$Tables$ColumnWidths$capContent,
							20,
							A2(
								$author$project$Tasks$Google$Claim$Tables$ColumnWidths$maxStringLength,
								function (m) {
									return A2($author$project$Tasks$Google$Claim$Tables$TableHelpers$gbpAccountName, accounts, m.googleBusinessId);
								},
								googleMatches)))))
			]);
	});
var $author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths = F2(
	function (translations, model) {
		var unownedGoogleMatches = function () {
			var _v3 = model.innerMatches;
			if (_v3.$ === 'Loaded') {
				var matches = _v3.a;
				return matches;
			} else {
				return _List_Nil;
			}
		}();
		var notMatchedLocations = function () {
			var _v2 = model.notMatchedLocations;
			if (_v2.$ === 'Loaded') {
				var matches = _v2.a;
				return matches;
			} else {
				return _List_Nil;
			}
		}();
		var businessAccounts = function () {
			var _v1 = model.businessAccounts;
			if (_v1.$ === 'Loaded') {
				var accounts = _v1.a;
				return accounts;
			} else {
				return _List_Nil;
			}
		}();
		var pmtLocations = function () {
			var _v0 = model.pmtLocations;
			if (_v0.$ === 'Loaded') {
				var locations = _v0.a;
				return locations;
			} else {
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Tasks$Google$Claim$Tables$ColumnWidths$computeColumnWidths,
			translations,
			pmtLocations,
			$elm$core$List$concat(
				_List_fromArray(
					[notMatchedLocations, unownedGoogleMatches])),
			businessAccounts);
	});
var $author$project$Tasks$Google$Claim$Model$VerifiedGoogleLocation = F2(
	function (a, b) {
		return {$: 'VerifiedGoogleLocation', a: a, b: b};
	});
var $author$project$Tasks$Google$Claim$Model$ImportResult = F2(
	function (notMatchedLocations, importStats) {
		return {importStats: importStats, notMatchedLocations: notMatchedLocations};
	});
var $author$project$Tasks$Google$Claim$Model$ImportStats = F2(
	function (total, errors) {
		return {total: total, errors: errors};
	});
var $author$project$Tasks$Google$Claim$Model$ImportError = F2(
	function (googleId, error) {
		return {error: error, googleId: googleId};
	});
var $author$project$Tasks$Google$Claim$Decoders$importErrorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'googleId',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$ImportError)));
var $author$project$Tasks$Google$Claim$Decoders$importStatsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'errors',
	$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$importErrorDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$ImportStats)));
var $author$project$Tasks$Google$Claim$Decoders$importResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'importStats',
	$author$project$Tasks$Google$Claim$Decoders$importStatsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'notMatchedLocations',
		$elm$json$Json$Decode$list($author$project$Tasks$Google$Claim$Decoders$googleMatchesDecoder),
		$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$ImportResult)));
var $author$project$Tasks$Google$Claim$Commands$postImportGbpLocations = F3(
	function (_v0, googleBusinessIds, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/google/claim/importNotMatchedGbpLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Decoders$importResultDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'googleIds',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, googleBusinessIds))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Google$Claim$Model$ConnectedGoogleLocation = function (a) {
	return {$: 'ConnectedGoogleLocation', a: a};
};
var $author$project$Tasks$Google$Claim$Model$VerifyResult = F2(
	function (status, message) {
		return {status: status, message: message};
	});
var $author$project$Tasks$Google$Claim$Decoders$verifyResultDecoder = A2(
	$elm$json$Json$Decode$field,
	'data',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'message',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'status',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Claim$Model$VerifyResult))));
var $author$project$Tasks$Google$Claim$Commands$postVerifyGoogleLocation = F3(
	function (_v0, locationId, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + ('/google/claim/verify?locationId=' + $elm$url$Url$percentEncode(locationId)));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Claim$Decoders$verifyResultDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Google$Claim$Model$TrackedSelectedClaimMatch = function (a) {
	return {$: 'TrackedSelectedClaimMatch', a: a};
};
var $author$project$Tasks$Google$Claim$Decoders$createLocationEventDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (locationId, state) {
				return {state: state, locationId: locationId};
			}),
		A2($elm$json$Json$Decode$field, 'locationId', $elm$json$Json$Decode$string),
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Tasks$Google$Claim$Model$createStateFromString,
			A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'networkErrorMessage', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed('')
					])))));
var $author$project$Tasks$Google$Claim$Model$ProgressEvent = function (a) {
	return {$: 'ProgressEvent', a: a};
};
var $author$project$Tasks$Google$Claim$Model$CompletedEvent = function (a) {
	return {$: 'CompletedEvent', a: a};
};
var $author$project$Tasks$Google$Claim$Decoders$locationFinderEventDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (eventType) {
		switch (eventType) {
			case 'progress':
				return A2($elm$json$Json$Decode$map, $author$project$Tasks$Google$Claim$Model$ProgressEvent, $author$project$Tasks$Google$Claim$Decoders$locationFinderProgressDecoder);
			case 'completed':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Tasks$Google$Claim$Model$CompletedEvent,
					A2($elm$json$Json$Decode$field, 'status', $author$project$Tasks$Google$Claim$Decoders$locationFinderStatusDecoder));
			default:
				return $elm$json$Json$Decode$fail('Unknown location finder event: ' + eventType);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Tasks$Google$Claim$Update$getPmtAddressForExpandedRow = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Data$Address$emptyAddress,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.address;
			},
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						function (loc) {
							return _Utils_eq(
								$elm$core$Maybe$Just(loc.id),
								model.expandedRow);
						}),
					$elm$core$List$head),
				$author$project$RemoteData$currentData(model.pmtLocations))));
};
var $author$project$Tasks$Google$Claim$Commands$postTrackSelectedClaimMatch = F3(
	function (_v0, body, msg) {
		var siteName = _v0.a;
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'locationId',
					$elm$json$Json$Encode$string(body.locationId)),
					_Utils_Tuple2(
					'googleSearchId',
					$elm$json$Json$Encode$string(body.googleSearchId)),
					_Utils_Tuple2(
					'listIndex',
					$elm$json$Json$Encode$int(body.listIndex)),
					_Utils_Tuple2(
					'googleAddress',
					$author$project$Data$Address$addressEncoder(body.googleAddress)),
					_Utils_Tuple2(
					'pmtAddress',
					$author$project$Data$Address$addressEncoder(body.pmtAddress))
				]));
		var url = 'api/' + (siteName + '/google/claim/trackSelectedMatch');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(_Utils_Tuple0),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body_,
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Google$Claim$Update$update = F3(
	function (session, msg, model) {
		var modelClearedNotification = $author$project$Tasks$Google$Claim$Update$emptyNotification(model);
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OuterTableMsg':
				var tableMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiOuterTable: A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.uiOuterTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'InnerTableMsg':
				var tableMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiInnerTable: A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.uiInnerTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleRow':
				var rowId = msg.a;
				return _Utils_eq(
					model.expandedRow,
					$elm$core$Maybe$Just(rowId)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{expandedRow: $elm$core$Maybe$Nothing, innerMatches: $author$project$RemoteData$Suspended}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							expandedRow: $elm$core$Maybe$Just(rowId),
							innerMatches: $author$project$RemoteData$Loading
						}),
					A3(
						$author$project$Tasks$Google$Claim$Commands$getGoogleMatches,
						session.siteName,
						rowId,
						$author$project$Tasks$Google$Claim$Model$GotGoogleMatches(rowId)));
			case 'GotPmtLocations':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					var withRecomputedColumnWidths = function (model_) {
						return _Utils_update(
							model_,
							{
								columnWidths: A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths, session.translations, model_)
							});
					};
					var expandedRowStillPresent = function () {
						var _v2 = model.expandedRow;
						if (_v2.$ === 'Just') {
							var expandedId = _v2.a;
							return A2(
								$elm$core$List$any,
								function (location) {
									return _Utils_eq(location.id, expandedId);
								},
								locations);
						} else {
							return false;
						}
					}();
					var locationIds = $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.id;
							},
							locations));
					var prunedCreateStates = A2(
						$elm$core$Dict$filter,
						F2(
							function (id, _v1) {
								return A2($elm$core$Set$member, id, locationIds);
							}),
						model.createStates);
					if (expandedRowStillPresent) {
						var newModel = withRecomputedColumnWidths(
							_Utils_update(
								model,
								{
									createStates: prunedCreateStates,
									pmtLocations: $author$project$RemoteData$Loaded(locations)
								}));
						return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					} else {
						var newModel = withRecomputedColumnWidths(
							_Utils_update(
								model,
								{
									expandedRow: $elm$core$Maybe$Nothing,
									createStates: prunedCreateStates,
									innerMatches: $author$project$RemoteData$Suspended,
									pmtLocations: $author$project$RemoteData$Loaded(locations)
								}));
						return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pmtLocations: $author$project$RemoteData$Error('Failed to load PMT locations')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.GotPmtLocations',
								message: 'Failed to load PMT locations'
							}));
				}
			case 'GotNotMatchedLocations':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							notMatchedLocations: $author$project$RemoteData$Loaded(locations)
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								columnWidths: A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths, session.translations, newModel)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								notMatchedLocations: $author$project$RemoteData$Error('Failed to load not matched locations')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.GotNotMatchedLocations',
								message: 'Failed to load not matched locations'
							}));
				}
			case 'GotGoogleMatches':
				if (msg.b.$ === 'Ok') {
					var rowId = msg.a;
					var matches = msg.b.a;
					if (_Utils_eq(
						model.expandedRow,
						$elm$core$Maybe$Just(rowId))) {
						var newModel = _Utils_update(
							model,
							{
								innerMatches: $author$project$RemoteData$Loaded(matches)
							});
						return _Utils_Tuple2(
							_Utils_update(
								newModel,
								{
									columnWidths: A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths, session.translations, newModel)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var rowId = msg.a;
					var error = msg.b.a;
					return _Utils_eq(
						model.expandedRow,
						$elm$core$Maybe$Just(rowId)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								innerMatches: $author$project$RemoteData$Error('Failed to load matches')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.GotGoogleMatches',
								message: 'Failed to load Google matches'
							})) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ConnectGoogleLocation':
				var googleMatchData = msg.a;
				var listIndex = msg.b;
				var locationId = model.expandedRow;
				var googleId = googleMatchData.googleBusinessId;
				var connectingState = function () {
					if (locationId.$ === 'Just') {
						var locId = locationId.a;
						return A2($author$project$Tasks$Google$Claim$Model$ConnectingLocations, locId, googleId);
					} else {
						return $author$project$Tasks$Google$Claim$Model$NotConnecting;
					}
				}();
				var cmd = function () {
					if (locationId.$ === 'Just') {
						var locId = locationId.a;
						return A3(
							$author$project$Tasks$Google$Claim$Commands$postConnectLocations,
							session.siteName,
							{
								googleId: googleId,
								listIndex: listIndex,
								locationId: locId,
								pmtAddress: $author$project$Tasks$Google$Claim$Update$getPmtAddressForExpandedRow(model),
								googleAddress: googleMatchData.address
							},
							$author$project$Tasks$Google$Claim$Model$ConnectedGoogleLocation);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{connecting: connectingState}),
					cmd);
			case 'ConnectedGoogleLocation':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							connecting: $author$project$Tasks$Google$Claim$Model$NotConnecting,
							notMatchedLocations: $author$project$RemoteData$Loaded(locations)
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								columnWidths: A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths, session.translations, newModel)
							}),
						A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{connecting: $author$project$Tasks$Google$Claim$Model$NotConnecting}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.ConnectedGoogleLocation',
								message: 'Failed to connect Google location'
							}));
				}
			case 'TooltipMsg':
				var tooltipMsg = msg.a;
				var _v5 = A3($author$project$PinMeTo$Ui$AdvancedTooltip$update, $author$project$Tasks$Google$Claim$Model$TooltipMsg, tooltipMsg, model.uiTooltip);
				var uiTooltip = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiTooltip: uiTooltip}),
					cmd);
			case 'SelectedClaimMatch':
				var googleMatchData = msg.a;
				var listIndex = msg.b;
				var nameAndAddressCombined = A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
						_List_fromArray(
							[googleMatchData.name, googleMatchData.address.street, googleMatchData.address.zip, googleMatchData.address.city, googleMatchData.address.country])));
				var trackCmd = function () {
					var _v6 = model.expandedRow;
					if (_v6.$ === 'Just') {
						var locationId = _v6.a;
						return A3(
							$author$project$Tasks$Google$Claim$Commands$postTrackSelectedClaimMatch,
							session.siteName,
							{
								listIndex: listIndex,
								locationId: locationId,
								pmtAddress: $author$project$Tasks$Google$Claim$Update$getPmtAddressForExpandedRow(model),
								googleAddress: googleMatchData.address,
								googleSearchId: googleMatchData.googleBusinessId
							},
							$author$project$Tasks$Google$Claim$Model$TrackedSelectedClaimMatch);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$PinMeTo$Common$Clipboard$writeText(nameAndAddressCombined),
								trackCmd
							])));
			case 'TrackedSelectedClaimMatch':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.TrackedSelectedClaimMatch',
								message: 'Failed to track selected claim match'
							}));
				}
			case 'SelectMsg':
				var selectMsg = msg.a;
				var _v7 = A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Google$Claim$Model$SelectMsg, selectMsg, model.uiSelect);
				var uiSelect = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiSelect: uiSelect}),
					cmd);
			case 'BusinessAccountSelected':
				var businessAccount = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectedBusinessAccount: $elm$core$Maybe$Just(businessAccount)
						}),
					$elm$core$Platform$Cmd$none);
			case 'GotBusinessAccounts':
				if (msg.a.$ === 'Ok') {
					var businessAccounts = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessAccounts: $author$project$RemoteData$Loaded(businessAccounts),
								selectedBusinessAccount: $elm$core$List$head(businessAccounts)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessAccounts: $author$project$RemoteData$Error('Failed to load business accounts')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.GotBusinessAccounts',
								message: 'Failed to load business accounts'
							}));
				}
			case 'GotLocationFinderStatus':
				if (msg.a.$ === 'Ok') {
					var result = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{locationFinderStatus: result.status, locationFinderLastRun: result.timestamp, locationFinderProgress: result.progress}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationFinderStatus: $author$project$Tasks$Google$Claim$Model$FinderError(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.GotLocationFinderStatus',
								message: 'Failed to load location finder status'
							}));
				}
			case 'GotLocationFinderEvent':
				var value = msg.a;
				var _v8 = A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Google$Claim$Decoders$locationFinderEventDecoder, value);
				if (_v8.$ === 'Ok') {
					if (_v8.a.$ === 'ProgressEvent') {
						var progress = _v8.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									locationFinderStatus: $author$project$Tasks$Google$Claim$Model$Running,
									locationFinderProgress: $elm$core$Maybe$Just(progress)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var result = _v8.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{locationFinderStatus: result.status, locationFinderLastRun: result.timestamp, locationFinderProgress: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations),
										A2($author$project$Tasks$Google$Claim$Commands$getNotMatchedLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotNotMatchedLocations),
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg,
										$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$refresh(session.siteName))
									])));
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'RunLocationFinder':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pmtLocations: $author$project$RemoteData$Loading, notMatchedLocations: $author$project$RemoteData$Loading, locationFinderStatus: $author$project$Tasks$Google$Claim$Model$Running, locationFinderProgress: $elm$core$Maybe$Nothing}),
					A2($author$project$Tasks$Google$Claim$Commands$runLocationFinder, session.siteName, $author$project$Tasks$Google$Claim$Model$RanLocationFinder));
			case 'RanLocationFinder':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{locationFinderStatus: $author$project$Tasks$Google$Claim$Model$Running}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Tasks$Google$Claim$Commands$getLocationFinderStatus, session.siteName, $author$project$Tasks$Google$Claim$Model$GotLocationFinderStatus),
									A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations),
									A2($author$project$Tasks$Google$Claim$Commands$getNotMatchedLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotNotMatchedLocations),
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg,
									$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$refresh(session.siteName))
								])));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationFinderStatus: $author$project$Tasks$Google$Claim$Model$FinderError(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Tasks$Google$Claim$Commands$getLocationFinderStatus, session.siteName, $author$project$Tasks$Google$Claim$Model$GotLocationFinderStatus),
									A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations),
									A2($author$project$Tasks$Google$Claim$Commands$getNotMatchedLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotNotMatchedLocations),
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg,
									$author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$refresh(session.siteName)),
									$author$project$PinMeTo$Logger$log(
									{
										data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
										context: 'Tasks.Google.Claim.GoogleMatches.Update.RanLocationFinder',
										message: 'Failed to run location finder'
									})
								])));
				}
			case 'CreateLocations':
				var selectedIds = $author$project$PinMeTo$Ui$Table$selectedItems(model.uiOuterTable);
				var _v9 = model.selectedBusinessAccount;
				if (_v9.$ === 'Just') {
					var account = _v9.a;
					return $elm$core$List$isEmpty(selectedIds) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{creating: true, createNotification: $elm$core$Maybe$Nothing}),
						A4($author$project$Tasks$Google$Claim$Commands$postCreateLocations, session.siteName, account.id, selectedIds, $author$project$Tasks$Google$Claim$Model$CreatedLocations));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'CreatedLocations':
				if (msg.a.$ === 'Ok') {
					var result = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							creating: false,
							createStates: A2($elm$core$Dict$union, result.states, model.createStates),
							pmtLocations: $author$project$RemoteData$Loaded(result.data),
							uiOuterTable: $author$project$PinMeTo$Ui$Table$clearSelected(model.uiOuterTable)
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								columnWidths: A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths, session.translations, newModel)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{creating: false}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.CreatedLocations',
								message: 'Failed to create locations'
							}));
				}
			case 'GotCreateLocationEvent':
				var value = msg.a;
				var _v10 = A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Google$Claim$Decoders$createLocationEventDecoder, value);
				if (_v10.$ === 'Ok') {
					var events = _v10.a;
					var newCreateStates = A3(
						$elm$core$List$foldl,
						F2(
							function (event, acc) {
								return A3($elm$core$Dict$insert, event.locationId, event.state, acc);
							}),
						model.createStates,
						events);
					var stillInFlight = A2(
						$elm$core$List$any,
						function (state) {
							return _Utils_eq(state, $author$project$Tasks$Google$Claim$Model$Queued) || _Utils_eq(state, $author$project$Tasks$Google$Claim$Model$Creating);
						},
						$elm$core$Dict$values(newCreateStates));
					var refetch = stillInFlight ? $elm$core$Platform$Cmd$none : A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{createStates: newCreateStates}),
						refetch);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'GotCreateLocationsStatus':
				if (msg.a.$ === 'Ok') {
					var states = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{createStates: states}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.Update.GotCreateLocationsStatus',
								message: 'Failed to fetch create locations status'
							}));
				}
			case 'ChainSectionMsg':
				var chainMsg = msg.a;
				var _v11 = A3($author$project$Tasks$Google$Claim$Sections$ChainSection$Update$update, session, chainMsg, model.chainSectionState);
				var chainSectionState = _v11.a;
				var chainSectionMsg = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{chainSectionState: chainSectionState}),
					A2($elm$core$Platform$Cmd$map, $author$project$Tasks$Google$Claim$Model$ChainSectionMsg, chainSectionMsg));
			case 'SuggestedMatchesMsg':
				var suggestedMatchesMsg = msg.a;
				var _v12 = A3($author$project$Tasks$Google$Claim$Sections$SuggestedMatches$Update$update, session, suggestedMatchesMsg, model.suggestedMatchesState);
				var suggestedMatchesState = _v12.a;
				var suggestedMatchesCmd = _v12.b;
				var outMsg = _v12.c;
				var extraCmds = function () {
					if (outMsg.$ === 'RefreshLocations') {
						return _List_fromArray(
							[
								A2($author$project$Tasks$Google$Claim$Commands$getNotMatchedLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotNotMatchedLocations),
								A2($author$project$Tasks$Google$Claim$Commands$getNotClaimedPmtLocations, session.siteName, $author$project$Tasks$Google$Claim$Model$GotPmtLocations)
							]);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{suggestedMatchesState: suggestedMatchesState}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Tasks$Google$Claim$Model$SuggestedMatchesMsg, suggestedMatchesCmd),
							extraCmds)));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							modelClearedNotification,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var updatedModel = A3(
						$author$project$Tasks$Google$Claim$Update$updateNotification,
						$author$project$Tasks$Google$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(session.translations),
						model);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								allCategories: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Google.Claim.GoogleMatches.Update.GotAllCategories',
								message: 'Failed to load Google categories'
							}));
				}
			case 'SelectedPrimaryCategory':
				var category = msg.a;
				return A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					model.additionalCategoriesList) ? _Utils_Tuple2(modelClearedNotification, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						modelClearedNotification,
						{
							primaryCategory: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'AddAdditionalCategory':
				var newSelection = A2(
					$elm$core$List$append,
					model.additionalCategoriesList,
					$elm$core$List$singleton($elm$core$Maybe$Nothing));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotification,
						{additionalCategoriesList: newSelection}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedAdditionalCategory':
				var category = msg.a;
				var index = msg.b;
				var primaryCategory = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (cat) {
						return $elm$core$List$singleton(
							$elm$core$Maybe$Just(cat));
					},
					model.primaryCategory);
				var newAdditional = A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					A2($elm$core$List$append, model.additionalCategoriesList, primaryCategory)) ? model.additionalCategoriesList : A2(
					$elm$core$List$append,
					A2(
						$elm$core$List$append,
						A2($elm$core$List$take, index, model.additionalCategoriesList),
						$elm$core$List$singleton(
							$elm$core$Maybe$Just(category))),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotification,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				var newAdditional = A2(
					$elm$core$List$append,
					A2($elm$core$List$take, index, model.additionalCategoriesList),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotification,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'SaveCategories':
				return $author$project$Tasks$Google$Claim$Update$areCategoriesSelected(model) ? _Utils_Tuple2(
					modelClearedNotification,
					A3($author$project$Tasks$Google$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Google$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(modelClearedNotification, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					var _v14 = success ? _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Model$Success,
						$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
						$author$project$Tasks$Google$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
					var state = _v14.a;
					var message = _v14.b;
					return _Utils_Tuple2(
						A3($author$project$Tasks$Google$Claim$Update$updateNotification, state, message, model),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					return _Utils_Tuple2(
						A3($author$project$Tasks$Google$Claim$Update$updateNotification, $author$project$Tasks$Google$Claim$Model$Failed, message, model),
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Tasks.Google.Claim.GoogleMatches.Update.SaveCategoriesResult', message: 'Failed to save categories'}));
				}
			case 'GbpTableMsg':
				var tableMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiGbpTable: A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.uiGbpTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ImportGbpLocations':
				var selectedIds = $author$project$PinMeTo$Ui$Table$selectedItems(model.uiGbpTable);
				return $elm$core$List$isEmpty(selectedIds) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{lastImportStats: $elm$core$Maybe$Nothing}),
					A3($author$project$Tasks$Google$Claim$Commands$postImportGbpLocations, session.siteName, selectedIds, $author$project$Tasks$Google$Claim$Model$ImportedGbpLocations));
			case 'ImportedGbpLocations':
				if (msg.a.$ === 'Ok') {
					var result = msg.a.a;
					var remainingIds = $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.googleBusinessId;
							},
							result.notMatchedLocations));
					var prunedSelection = A2(
						$elm$core$List$filter,
						function (id) {
							return A2($elm$core$Set$member, id, remainingIds);
						},
						$author$project$PinMeTo$Ui$Table$selectedItems(model.uiGbpTable));
					var newModel = _Utils_update(
						model,
						{
							uiGbpTable: A2($author$project$PinMeTo$Ui$Table$setSelected, prunedSelection, model.uiGbpTable),
							lastImportStats: $elm$core$Maybe$Just(result.importStats),
							notMatchedLocations: $author$project$RemoteData$Loaded(result.notMatchedLocations)
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								columnWidths: A2($author$project$Tasks$Google$Claim$Tables$ColumnWidths$recomputeColumnWidths, session.translations, newModel)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.Update.ImportedGbpLocations',
								message: 'Failed to import GBP locations'
							}));
				}
			case 'PopOverMsg':
				var popOverMsg = msg.a;
				var _v15 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Google$Claim$Model$PopOverMsg, popOverMsg, model.uiPopOver);
				var newPopOverState = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiPopOver: newPopOverState}),
					cmd);
			case 'CopyStoreId':
				var storeId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$PinMeTo$Common$Clipboard$writeText(storeId));
			case 'VerificationTableMsg':
				var tableMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiVerificationTable: A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.uiVerificationTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'GotUnverifiedLocations':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								unverifiedLocations: $author$project$RemoteData$Loaded(locations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								unverifiedLocations: $author$project$RemoteData$Error('Failed to load unverified locations')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Tasks.Google.Claim.Update.GotUnverifiedLocations',
								message: 'Failed to load unverified locations'
							}));
				}
			case 'VerifyGoogleLocation':
				var locationId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							verifyStates: A3($elm$core$Dict$insert, locationId, $author$project$Tasks$Google$Claim$Model$Verifying, model.verifyStates)
						}),
					A3(
						$author$project$Tasks$Google$Claim$Commands$postVerifyGoogleLocation,
						session.siteName,
						locationId,
						$author$project$Tasks$Google$Claim$Model$VerifiedGoogleLocation(locationId)));
			default:
				if (msg.b.$ === 'Ok') {
					var locationId = msg.a;
					var result = msg.b.a;
					var status = A2($elm$core$Maybe$withDefault, 'SUBMITTED', result.status);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								verifyStates: A3(
									$elm$core$Dict$insert,
									locationId,
									$author$project$Tasks$Google$Claim$Model$Verified(status),
									model.verifyStates)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var locationId = msg.a;
					var error = msg.b.a;
					var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(error);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								verifyStates: A3(
									$elm$core$Dict$insert,
									locationId,
									$author$project$Tasks$Google$Claim$Model$VerifyFailed(message),
									model.verifyStates)
							}),
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Tasks.Google.Claim.Update.VerifiedGoogleLocation', message: 'Failed to verify Google location'}));
				}
		}
	});
var $author$project$Tasks$Google$Claim$Commands$flagsCategoriesDecoder = function () {
	var decodeAdditional = A2(
		$elm$json$Json$Decode$field,
		'additionalCategories',
		$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodeAdditionalCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodeAdditional);
	var decodePrimary = $elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'primaryCategory', $author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodePrimaryCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodePrimary);
	return A2(
		$elm$json$Json$Decode$field,
		'categories',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (primary, additional) {
					return {
						primaryCategory: primary,
						additionalCategories: A2($elm$core$List$map, $elm$core$Maybe$Just, additional)
					};
				}),
			decodePrimaryCommon,
			decodeAdditionalCommon));
}();
var $author$project$Tasks$Google$Claim$Commands$flagsDecoder = A2(
	$elm$json$Json$Decode$map,
	function (categories) {
		return {categories: categories};
	},
	$author$project$Tasks$Google$Claim$Commands$flagsCategoriesDecoder);
var $author$project$Tasks$Google$Claim$Model$GotCreateLocationEvent = function (a) {
	return {$: 'GotCreateLocationEvent', a: a};
};
var $author$project$Tasks$Google$Claim$Model$GotLocationFinderEvent = function (a) {
	return {$: 'GotLocationFinderEvent', a: a};
};
var $author$project$Tasks$Google$Claim$Main$in_Tasks_Google_Claim_Main_networkStatus = _Platform_incomingPort('in_Tasks_Google_Claim_Main_networkStatus', $elm$json$Json$Decode$value);
var $author$project$Tasks$Google$Claim$Main$in_Tasks_Google_Claim_Main_locationFinderEvent = _Platform_incomingPort('in_Tasks_Google_Claim_Main_locationFinderEvent', $elm$json$Json$Decode$value);
var $author$project$Tasks$Google$Claim$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Tasks$Google$Claim$Model$OuterTableMsg, model.uiOuterTable),
				A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Tasks$Google$Claim$Model$InnerTableMsg, model.uiInnerTable),
				A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Tasks$Google$Claim$Model$GbpTableMsg, model.uiGbpTable),
				A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Tasks$Google$Claim$Model$VerificationTableMsg, model.uiVerificationTable),
				$author$project$Tasks$Google$Claim$Main$in_Tasks_Google_Claim_Main_locationFinderEvent($author$project$Tasks$Google$Claim$Model$GotLocationFinderEvent),
				$author$project$Tasks$Google$Claim$Main$in_Tasks_Google_Claim_Main_networkStatus($author$project$Tasks$Google$Claim$Model$GotCreateLocationEvent)
			]));
};
var $author$project$Tasks$Google$Claim$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Tasks$Google$Claim$Main$init, view: $author$project$Tasks$Google$Claim$View$view, update: $author$project$Tasks$Google$Claim$Update$update, flagsDecoder: $author$project$Tasks$Google$Claim$Commands$flagsDecoder, subscriptions: $author$project$Tasks$Google$Claim$Main$subscriptions});
var $elm$time$Time$here = _Time_here(_Utils_Tuple0);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $author$project$Navigation$Sidebar$Main$GetToday = function (a) {
	return {$: 'GetToday', a: a};
};
var $author$project$PinMeTo$Permissions$Owner = {$: 'Owner'};
var $author$project$PinMeTo$Permissions$PinMeTo = {$: 'PinMeTo'};
var $author$project$PinMeTo$Permissions$Upsales = {$: 'Upsales'};
var $pzp1997$assoc_list$AssocList$D = function (a) {
	return {$: 'D', a: a};
};
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0.a;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = $pzp1997$assoc_list$AssocList$D(rest);
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$member = F2(
	function (targetKey, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (_v0.$ === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var $Gizra$elm_all_set$EverySet$member = F2(
	function (k, _v0) {
		var d = _v0.a;
		return A2($pzp1997$assoc_list$AssocList$member, k, d);
	});
var $author$project$PinMeTo$Permissions$hasRole = F2(
	function (_v0, role) {
		var model = _v0.a;
		return A2($Gizra$elm_all_set$EverySet$member, role, model.roles);
	});
var $author$project$PinMeTo$Permissions$CustomerSuccess = {$: 'CustomerSuccess'};
var $author$project$PinMeTo$Permissions$PinMeToDeveloper = {$: 'PinMeToDeveloper'};
var $author$project$Navigation$Sidebar$Main$userIsOwner = function (permissions) {
	return A2(
		$elm$core$List$any,
		function (role) {
			return A2($author$project$PinMeTo$Permissions$hasRole, permissions, role);
		},
		_List_fromArray(
			[$author$project$PinMeTo$Permissions$PinMeToDeveloper, $author$project$PinMeTo$Permissions$Owner, $author$project$PinMeTo$Permissions$PinMeTo, $author$project$PinMeTo$Permissions$CustomerSuccess, $author$project$PinMeTo$Permissions$Upsales]));
};
var $author$project$Navigation$Sidebar$Main$Model = function (unreviewedMediaCount) {
	return function (siteName) {
		return function (siteDisplayName) {
			return function (url) {
				return function (collapsed) {
					return function (workInProgress) {
						return function (permissions) {
							return function (mobile) {
								return function (enabledInsights) {
									return function (translations) {
										return function (today) {
											return function (apiEnabled) {
												return function (mediaReviewEnabled) {
													return function (bulkVerifiedEligible) {
														return function (isDemoMode) {
															return function (enabledNetworks) {
																return function (appleOauthEnabled) {
																	return function (numberOfConflicts) {
																		return function (facebookBrandPageConflicts) {
																			return function (conflictsDebouncer) {
																				return function (isLabelsFeatureFlaggedUser) {
																					return {url: url, today: today, mobile: mobile, siteName: siteName, collapsed: collapsed, apiEnabled: apiEnabled, isDemoMode: isDemoMode, permissions: permissions, translations: translations, workInProgress: workInProgress, enabledInsights: enabledInsights, enabledNetworks: enabledNetworks, siteDisplayName: siteDisplayName, appleOauthEnabled: appleOauthEnabled, numberOfConflicts: numberOfConflicts, conflictsDebouncer: conflictsDebouncer, mediaReviewEnabled: mediaReviewEnabled, bulkVerifiedEligible: bulkVerifiedEligible, unreviewedMediaCount: unreviewedMediaCount, facebookBrandPageConflicts: facebookBrandPageConflicts, isLabelsFeatureFlaggedUser: isLabelsFeatureFlaggedUser};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Navigation$Sidebar$Main$urlDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Invalid URL: ' + x),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$elm$url$Url$fromString(x)));
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Permissions$Permissions = function (a) {
	return {$: 'Permissions', a: a};
};
var $author$project$PinMeTo$Permissions$Model = F4(
	function (roles, groups, permissions, locations) {
		return {roles: roles, groups: groups, locations: locations, permissions: permissions};
	});
var $pzp1997$assoc_list$AssocList$empty = $pzp1997$assoc_list$AssocList$D(_List_Nil);
var $Gizra$elm_all_set$EverySet$EverySet = function (a) {
	return {$: 'EverySet', a: a};
};
var $Gizra$elm_all_set$EverySet$empty = $Gizra$elm_all_set$EverySet$EverySet($pzp1997$assoc_list$AssocList$empty);
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var key = _v1.a;
					return !_Utils_eq(key, targetKey);
				},
				alist));
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0.a;
		return $pzp1997$assoc_list$AssocList$D(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(key, value),
				alteredAlist));
	});
var $Gizra$elm_all_set$EverySet$insert = F2(
	function (k, _v0) {
		var d = _v0.a;
		return $Gizra$elm_all_set$EverySet$EverySet(
			A3($pzp1997$assoc_list$AssocList$insert, k, _Utils_Tuple0, d));
	});
var $Gizra$elm_all_set$EverySet$fromList = function (xs) {
	return A3($elm$core$List$foldl, $Gizra$elm_all_set$EverySet$insert, $Gizra$elm_all_set$EverySet$empty, xs);
};
var $author$project$PinMeTo$Permissions$requiredSet = F2(
	function (x, typeDecoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			x,
			A2(
				$elm$json$Json$Decode$map,
				function (xs) {
					return $Gizra$elm_all_set$EverySet$fromList(xs);
				},
				$elm$json$Json$Decode$list(typeDecoder)));
	});
var $author$project$PinMeTo$Permissions$User = {$: 'User'};
var $author$project$PinMeTo$Permissions$Author = {$: 'Author'};
var $author$project$PinMeTo$Permissions$Editor = {$: 'Editor'};
var $author$project$PinMeTo$Permissions$Viewer = {$: 'Viewer'};
var $author$project$PinMeTo$Permissions$Manager = {$: 'Manager'};
var $author$project$PinMeTo$Permissions$Publisher = {$: 'Publisher'};
var $author$project$PinMeTo$Permissions$ApiDeveloper = {$: 'ApiDeveloper'};
var $author$project$PinMeTo$Permissions$roleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		switch (x) {
			case 'pinmeto':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$PinMeTo);
			case 'customersuccess':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$CustomerSuccess);
			case 'pinmetodeveloper':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$PinMeToDeveloper);
			case 'upsales':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Upsales);
			case 'owner':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Owner);
			case 'user':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$User);
			case 'apideveloper':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$ApiDeveloper);
			case 'viewer':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Viewer);
			case 'publisher':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Publisher);
			case 'manager':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Manager);
			case 'editor':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Editor);
			case 'author':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Author);
			default:
				return $elm$json$Json$Decode$fail('Unknown role: ' + x);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Permissions$CustomGroup = F3(
	function (a, b, c) {
		return {$: 'CustomGroup', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Permissions$LocationGroup = F3(
	function (a, b, c) {
		return {$: 'LocationGroup', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Permissions$SmartGroupAll = F3(
	function (a, b, c) {
		return {$: 'SmartGroupAll', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Permissions$GroupData = F4(
	function (name, type_, smartType, smartTypeValue) {
		return {name: name, type_: type_, smartType: smartType, smartTypeValue: smartTypeValue};
	});
var $author$project$PinMeTo$Permissions$GroupName = function (a) {
	return {$: 'GroupName', a: a};
};
var $author$project$PinMeTo$Permissions$groupNameDecoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Permissions$GroupName, $elm$json$Json$Decode$string);
var $author$project$PinMeTo$Permissions$groupDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'smartTypeValue',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'smartType',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$author$project$PinMeTo$Permissions$groupNameDecoder,
				$elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$GroupData)))));
var $author$project$PinMeTo$Permissions$SmartGroupCountry = F3(
	function (a, b, c) {
		return {$: 'SmartGroupCountry', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Permissions$Permission = function (a) {
	return {$: 'Permission', a: a};
};
var $author$project$PinMeTo$Permissions$permissionDecoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Permissions$Permission, $elm$json$Json$Decode$string);
var $author$project$PinMeTo$Permissions$groupDecoder = function () {
	var decodeType = function (groupData) {
		var decode_ = function (constructor) {
			return A3(
				$author$project$PinMeTo$Permissions$requiredSet,
				'permissions',
				$author$project$PinMeTo$Permissions$permissionDecoder,
				A3(
					$author$project$PinMeTo$Permissions$requiredSet,
					'roles',
					$author$project$PinMeTo$Permissions$roleDecoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						groupData,
						$elm$json$Json$Decode$succeed(constructor))));
		};
		var _v0 = _Utils_Tuple2(groupData.type_, groupData.smartType);
		switch (_v0.a) {
			case 'smart':
				switch (_v0.b) {
					case 'all':
						return decode_($author$project$PinMeTo$Permissions$SmartGroupAll);
					case 'country':
						return decode_($author$project$PinMeTo$Permissions$SmartGroupCountry);
					default:
						return $elm$json$Json$Decode$fail('Unknown location group type: ' + (groupData.type_ + (' / ' + groupData.smartType)));
				}
			case 'custom':
				return decode_($author$project$PinMeTo$Permissions$CustomGroup);
			case 'location':
				return decode_($author$project$PinMeTo$Permissions$LocationGroup);
			default:
				var x = _v0;
				return $elm$json$Json$Decode$fail('Unknown location group type: ' + groupData.type_);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decodeType, $author$project$PinMeTo$Permissions$groupDataDecoder);
}();
var $author$project$PinMeTo$Permissions$Location = F4(
	function (id, permissions, roles, groups) {
		return {id: id, roles: roles, groups: groups, permissions: permissions};
	});
var $author$project$PinMeTo$Permissions$LocationId = function (a) {
	return {$: 'LocationId', a: a};
};
var $author$project$PinMeTo$Permissions$locationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'groups',
	$elm$json$Json$Decode$list($author$project$PinMeTo$Permissions$groupDataDecoder),
	A3(
		$author$project$PinMeTo$Permissions$requiredSet,
		'roles',
		$author$project$PinMeTo$Permissions$roleDecoder,
		A3(
			$author$project$PinMeTo$Permissions$requiredSet,
			'permissions',
			$author$project$PinMeTo$Permissions$permissionDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Permissions$LocationId, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Location)))));
var $author$project$PinMeTo$Permissions$modelDecoder = function () {
	var locationDictDecoder = A2(
		$elm$json$Json$Decode$map,
		function (xs) {
			return $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (x) {
						var _v0 = x.id;
						var id = _v0.a;
						return _Utils_Tuple2(id, x);
					},
					xs));
		},
		$elm$json$Json$Decode$list($author$project$PinMeTo$Permissions$locationDecoder));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locations',
		locationDictDecoder,
		A3(
			$author$project$PinMeTo$Permissions$requiredSet,
			'permissions',
			$author$project$PinMeTo$Permissions$permissionDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'groups',
				$elm$json$Json$Decode$list($author$project$PinMeTo$Permissions$groupDecoder),
				A3(
					$author$project$PinMeTo$Permissions$requiredSet,
					'roles',
					$author$project$PinMeTo$Permissions$roleDecoder,
					$elm$json$Json$Decode$succeed($author$project$PinMeTo$Permissions$Model)))));
}();
var $author$project$PinMeTo$Permissions$permissionsDecoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Permissions$Permissions, $author$project$PinMeTo$Permissions$modelDecoder);
var $author$project$Navigation$Sidebar$Main$EnabledNetworks = function (google) {
	return function (facebook) {
		return function (bing) {
			return function (apple) {
				return function (here) {
					return function (tomtom) {
						return function (baidu) {
							return function (factual) {
								return function (trustpilot) {
									return function (overture) {
										return function (ptv) {
											return {ptv: ptv, bing: bing, here: here, apple: apple, baidu: baidu, google: google, tomtom: tomtom, factual: factual, facebook: facebook, overture: overture, trustpilot: trustpilot};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Navigation$Sidebar$Main$enabledNetworksDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ptv',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'overture',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'trustpilot',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'factual',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'baidu',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tomtom',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'here',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'apple',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'bing',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'facebook',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'google',
											$elm$json$Json$Decode$bool,
											$elm$json$Json$Decode$succeed($author$project$Navigation$Sidebar$Main$EnabledNetworks))))))))))));
var $author$project$Navigation$Sidebar$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isLabelsFeatureFlaggedUser',
	$elm$json$Json$Decode$bool,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		A2($author$project$Common$Debouncer$init, 2000, _Utils_Tuple0),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$author$project$RemoteData$Loading,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$author$project$RemoteData$Loading,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'appleOauthEnabled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabledNetworks',
						$author$project$Navigation$Sidebar$Main$enabledNetworksDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'isDemoMode',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'bulkVerifiedEligible',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'mediaReviewEnabled',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'apiEnabled',
										$elm$json$Json$Decode$bool,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											A3($justinmimbs$date$Date$fromCalendarDate, 2021, $elm$time$Time$Jun, 1),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'translations',
												$author$project$Common$Language$translationsDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'enabledInsights',
													$author$project$Navigation$Sidebar$Main$enabledNetworksDecoder,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														true,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'permissions',
															$author$project$PinMeTo$Permissions$permissionsDecoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'workInProgressCount',
																$elm$json$Json$Decode$int,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'collapsed',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'currentUrl',
																		$author$project$Navigation$Sidebar$Main$urlDecoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'siteDisplayName',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'siteName',
																				$elm$json$Json$Decode$string,
																				A2(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																					$author$project$RemoteData$Loading,
																					$elm$json$Json$Decode$succeed($author$project$Navigation$Sidebar$Main$Model))))))))))))))))))))));
var $author$project$Navigation$Sidebar$Main$OnWindowWidth = function (a) {
	return {$: 'OnWindowWidth', a: a};
};
var $author$project$Navigation$Sidebar$Main$OnNumberOfConflicts = function (a) {
	return {$: 'OnNumberOfConflicts', a: a};
};
var $author$project$DashboardV2$Decoders$decodeNumberOfConflicts = A2($elm$json$Json$Decode$field, 'totalConflicts', $elm$json$Json$Decode$int);
var $author$project$Navigation$Sidebar$Main$getNumberOfConflicts = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$DashboardV2$Decoders$decodeNumberOfConflicts, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/conflicts/total'))));
	});
var $author$project$Navigation$Sidebar$Main$OnFacebookBrandPageConflicts = function (a) {
	return {$: 'OnFacebookBrandPageConflicts', a: a};
};
var $author$project$Navigation$Sidebar$Main$getFacebookBrandPageConflicts = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/facebook/conflict/brandpage/status'))));
	});
var $author$project$Navigation$Sidebar$Main$getAllConflicts = F2(
	function (isOwner, _v0) {
		var siteName = _v0.a;
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$author$project$Navigation$Sidebar$Main$getNumberOfConflicts,
					$author$project$Data$SiteName$SiteName(siteName),
					$author$project$Navigation$Sidebar$Main$OnNumberOfConflicts),
					isOwner ? A2(
					$author$project$Navigation$Sidebar$Main$getFacebookBrandPageConflicts,
					$author$project$Data$SiteName$SiteName(siteName),
					$author$project$Navigation$Sidebar$Main$OnFacebookBrandPageConflicts) : $elm$core$Platform$Cmd$none
				]));
	});
var $author$project$Navigation$Sidebar$Main$OnUnreviewedMediaCount = function (a) {
	return {$: 'OnUnreviewedMediaCount', a: a};
};
var $author$project$Navigation$Sidebar$Main$getUnreviewedMediaCount = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'unreviewedMediaCount', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/network-media-assets/unreviewed-count'))));
	});
var $author$project$Navigation$Sidebar$Main$init = function (flagsValue) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Navigation$Sidebar$Main$flagsDecoder, flagsValue);
	if (_v0.$ === 'Ok') {
		var flags = _v0.a;
		var isOwner = $author$project$Navigation$Sidebar$Main$userIsOwner(flags.permissions);
		var newFlags = isOwner ? flags : function (f) {
			return _Utils_update(
				f,
				{
					facebookBrandPageConflicts: $author$project$RemoteData$Loaded(0)
				});
		}(flags);
		return _Utils_Tuple2(
			$elm$core$Result$Ok(newFlags),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						function (viewPort) {
							return $author$project$Navigation$Sidebar$Main$OnWindowWidth(
								$elm$core$Basics$round(viewPort.viewport.width));
						},
						$elm$browser$Browser$Dom$getViewport),
						A2($elm$core$Task$perform, $author$project$Navigation$Sidebar$Main$GetToday, $justinmimbs$date$Date$today),
						A2(
						$author$project$Navigation$Sidebar$Main$getAllConflicts,
						$author$project$Navigation$Sidebar$Main$userIsOwner(flags.permissions),
						$author$project$Data$SiteName$SiteName(flags.siteName)),
						A2(
						$author$project$Navigation$Sidebar$Main$getUnreviewedMediaCount,
						$author$project$Data$SiteName$SiteName(flags.siteName),
						$author$project$Navigation$Sidebar$Main$OnUnreviewedMediaCount)
					])));
	} else {
		var error = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err('Can not display navigation. Error was logged.'),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(error),
					context: 'Navigation.Sidebar.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$PinMeTo$Global$Sidebar$View = F2(
	function (a, b) {
		return {$: 'View', a: a, b: b};
	});
var $author$project$PinMeTo$Global$Sidebar$view = function (config) {
	return A2(
		$author$project$PinMeTo$Global$Sidebar$View,
		config,
		{maybeNavigationMap: $elm$core$Maybe$Nothing});
};
var $author$project$PinMeTo$Ui$Navigation$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Navigation$Link = F4(
	function (a, b, c, d) {
		return {$: 'Link', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Navigation$Path = function (a) {
	return {$: 'Path', a: a};
};
var $author$project$PinMeTo$Ui$Navigation$pathToAbsolute = F2(
	function (basePath, _v0) {
		var path = _v0.a.a;
		var label = _v0.b;
		var options = _v0.c;
		var children = _v0.d;
		return A2($elm$core$String$startsWith, 'https', path) ? A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			$author$project$PinMeTo$Ui$Navigation$Path(path),
			label,
			options,
			A2(
				$elm$core$List$map,
				$author$project$PinMeTo$Ui$Navigation$pathToAbsolute(basePath),
				children)) : (A2($elm$core$String$startsWith, '/', path) ? A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			$author$project$PinMeTo$Ui$Navigation$Path(path),
			label,
			options,
			A2(
				$elm$core$List$map,
				$author$project$PinMeTo$Ui$Navigation$pathToAbsolute(basePath),
				children)) : A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			$author$project$PinMeTo$Ui$Navigation$Path(
				_Utils_ap(basePath, path)),
			label,
			options,
			A2(
				$elm$core$List$map,
				$author$project$PinMeTo$Ui$Navigation$pathToAbsolute(basePath),
				children)));
	});
var $author$project$PinMeTo$Ui$Navigation$view = F2(
	function (_v0, items) {
		var compact = _v0.compact;
		var currentUrl = _v0.currentUrl;
		var basePath = _v0.basePath;
		return $author$project$PinMeTo$Ui$Navigation$View(
			{
				items: A2(
					$elm$core$List$map,
					$author$project$PinMeTo$Ui$Navigation$pathToAbsolute(basePath),
					items),
				style: $elm$core$Maybe$Nothing,
				compact: compact,
				currentUrl: currentUrl
			});
	});
var $author$project$PinMeTo$Ui$Navigation$Blank = {$: 'Blank'};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $author$project$PinMeTo$Ui$Navigation$Util$stripQuery = function (path) {
	return A2(
		$elm$core$Maybe$withDefault,
		path,
		$elm$core$List$head(
			A2($elm$core$String$split, '?', path)));
};
var $author$project$PinMeTo$Ui$Navigation$Util$normalizePath = function (path) {
	return A2($elm$core$String$endsWith, '/', path) ? $author$project$PinMeTo$Ui$Navigation$Util$stripQuery(path) : ($author$project$PinMeTo$Ui$Navigation$Util$stripQuery(path) + '/');
};
var $author$project$PinMeTo$Ui$Navigation$Util$isDescendant = F2(
	function (currentUrl, path) {
		return A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$String$startsWith,
					$author$project$PinMeTo$Ui$Navigation$Util$normalizePath(path),
					$author$project$PinMeTo$Ui$Navigation$Util$normalizePath(currentUrl.path))
				]));
	});
var $author$project$PinMeTo$Ui$Navigation$Util$distance = F2(
	function (currentUrl, path) {
		var current = A2(
			$elm$core$String$split,
			'/',
			A2(
				$elm$core$String$dropRight,
				1,
				A2(
					$elm$core$String$dropLeft,
					1,
					$author$project$PinMeTo$Ui$Navigation$Util$normalizePath(currentUrl.path))));
		var x = A2(
			$elm$core$String$split,
			'/',
			A2(
				$elm$core$String$dropRight,
				1,
				A2(
					$elm$core$String$dropLeft,
					1,
					$author$project$PinMeTo$Ui$Navigation$Util$normalizePath(path))));
		return A2($author$project$PinMeTo$Ui$Navigation$Util$isDescendant, currentUrl, path) ? ($elm$core$List$length(current) - $elm$core$List$length(x)) : 0;
	});
var $author$project$PinMeTo$Ui$Navigation$Util$isCurrent = F2(
	function (currentUrl, path) {
		return _Utils_eq(
			$author$project$PinMeTo$Ui$Navigation$Util$normalizePath(path),
			$author$project$PinMeTo$Ui$Navigation$Util$normalizePath(currentUrl.path));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(
	function (fma, mb) {
		if (mb.$ === 'Nothing') {
			return fma(_Utils_Tuple0);
		} else {
			return mb;
		}
	});
var $author$project$PinMeTo$Ui$Navigation$renderIcon = function (icon) {
	if (icon.$ === 'FontAwesome') {
		var x = icon.a;
		return $author$project$FontAwesome$render(x);
	} else {
		var x = icon.a;
		return $author$project$PinMeTo$Ui$Icon$render(x);
	}
};
var $author$project$PinMeTo$Ui$Navigation$roundCount = function (count) {
	return (count < 1000) ? $elm$core$String$fromInt(count) : (((count >= 1000) && (count < 1000000)) ? ($elm$core$String$fromInt((count / 1000) | 0) + 'k') : ($elm$core$String$fromInt((count / 1000000) | 0) + 'm'));
};
var $author$project$FontAwesome$Solid$Icon$faCaretDown = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-caret-down');
var $author$project$FontAwesome$Solid$faCaretDown = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCaretDown);
var $author$project$PinMeTo$Ui$Navigation$activeFilter = function (items) {
	return A2(
		$elm$core$List$filter,
		function (_v0) {
			var options = _v0.c;
			return options.active;
		},
		items);
};
var $author$project$FontAwesome$Solid$Icon$faCaretRight = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-caret-right');
var $author$project$FontAwesome$Solid$faCaretRight = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCaretRight);
var $author$project$FontAwesome$Regular$Icon$faLinkHorizontal = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-link-horizontal');
var $author$project$FontAwesome$Regular$faLinkHorizontal = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faLinkHorizontal);
var $author$project$PinMeTo$Ui$Navigation$UnreadCountIndicator = function (a) {
	return {$: 'UnreadCountIndicator', a: a};
};
var $author$project$PinMeTo$Ui$Navigation$renderItem = F3(
	function (compact, currentUrl, _v0) {
		var path = _v0.a.a;
		var label = _v0.b;
		var options = _v0.c;
		var children = _v0.d;
		var hasCurrentInChildren = A2(
			$elm$core$List$any,
			function (_v19) {
				var childPath = _v19.a.a;
				return A2($author$project$PinMeTo$Ui$Navigation$Util$isCurrent, currentUrl, childPath);
			},
			children);
		var isCurrentParent = hasCurrentInChildren || A2($author$project$PinMeTo$Ui$Navigation$Util$isDescendant, currentUrl, path);
		var newIndicatorFromChildren = (!isCurrentParent) ? $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v18) {
					var indicators = _v18.c.indicators;
					return indicators._new;
				},
				children)) : $elm$core$Maybe$Nothing;
		var warningIndicatorFromChildren = (!isCurrentParent) ? $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v17) {
					var indicators = _v17.c.indicators;
					return indicators.warning;
				},
				children)) : $elm$core$Maybe$Nothing;
		var unreadCountIndicatorFromChildren = (!isCurrentParent) ? function (sum) {
			return (sum > 0) ? $elm$core$Maybe$Just(
				$author$project$PinMeTo$Ui$Navigation$UnreadCountIndicator(sum)) : $elm$core$Maybe$Nothing;
		}(
			$elm$core$List$sum(
				A2(
					$elm$core$List$filterMap,
					function (_v15) {
						var indicators = _v15.c.indicators;
						return A2(
							$elm$core$Maybe$map,
							function (_v16) {
								var count = _v16.a;
								return count;
							},
							indicators.unreadCount);
					},
					children))) : $elm$core$Maybe$Nothing;
		var childDistance = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (_v14) {
					var childPath = _v14.a.a;
					return A2($author$project$PinMeTo$Ui$Navigation$Util$distance, currentUrl, childPath);
				},
				children));
		var addAttribute = F2(
			function (maybeAttribute, attributes) {
				if (maybeAttribute.$ === 'Just') {
					var attribute = maybeAttribute.a;
					return A2($elm$core$List$cons, attribute, attributes);
				} else {
					return attributes;
				}
			});
		var applyTarget = function (attributes) {
			var _v11 = options.target;
			if (_v11.$ === 'Just') {
				var _v12 = _v11.a;
				return A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$target('_blank'),
					attributes);
			} else {
				return attributes;
			}
		};
		var withTitle = function (attributes) {
			return compact ? A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$title(label),
				attributes) : attributes;
		};
		var labelView = (!compact) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-navigation-item__label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : $elm$html$Html$text('');
		var isCurrent = A2($author$project$PinMeTo$Ui$Navigation$Util$isCurrent, currentUrl, path);
		var isExpanded = A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					isCurrent,
					hasCurrentInChildren,
					A2($author$project$PinMeTo$Ui$Navigation$Util$isDescendant, currentUrl, path)
				]));
		var isParent = $elm$core$List$length(children) > 0;
		var distance = A2($author$project$PinMeTo$Ui$Navigation$Util$distance, currentUrl, path);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-ui-navigation__item', true),
							_Utils_Tuple2('pmt-ui-navigation__item--current', isCurrent),
							_Utils_Tuple2('pmt-ui-navigation__item--current-last', (!hasCurrentInChildren) && ((distance > 0) && (!childDistance))),
							_Utils_Tuple2('pmt-ui-navigation__item--current-parent', hasCurrentInChildren),
							_Utils_Tuple2(
							'pmt-ui-navigation__item--current-path',
							A2($author$project$PinMeTo$Ui$Navigation$Util$isDescendant, currentUrl, path)),
							_Utils_Tuple2('pmt-ui-navigation__item--expanded', isExpanded)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					withTitle(
						applyTarget(
							A2(
								addAttribute,
								A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, options.onClick),
								A2(
									addAttribute,
									A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$DataTestAttribute$toAttribute, options.dataTestAttribute),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-navigation-item'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-ui-navigation-item--current', isCurrent),
													_Utils_Tuple2('pmt-ui-navigation-item--compact', compact)
												])),
											$elm$html$Html$Attributes$href(path)
										]))))),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-navigation-item__icon pmt-ui-navigation-icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Navigation$renderIcon, options.icon)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-navigation-icon__indicators')
										]),
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$map,
												function (_v2) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-navigation-icon__indicator pmt-ui-navigation-icon__indicator--new')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('New')
															]));
												},
												A2(
													$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
													function (_v1) {
														return newIndicatorFromChildren;
													},
													options.indicators._new)),
												A2(
												$elm$core$Maybe$map,
												function (_v4) {
													var count = _v4.a;
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-navigation-icon__indicator pmt-ui-navigation-icon__indicator--unread-count')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$PinMeTo$Ui$Navigation$roundCount(count))
															]));
												},
												A2(
													$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
													function (_v3) {
														return unreadCountIndicatorFromChildren;
													},
													options.indicators.unreadCount)),
												A2(
												$elm$core$Maybe$map,
												function (_v6) {
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pmt-ui-navigation-icon__indicator pmt-ui-navigation-icon__indicator--warning')
															]),
														_List_fromArray(
															[$author$project$FontAwesome$Solid$faCircleExclamation]));
												},
												A2(
													$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
													function (_v5) {
														return warningIndicatorFromChildren;
													},
													options.indicators.warning))
											])))
								])),
							labelView,
							function () {
							var _v7 = options.indicators.contentCount;
							if (_v7.$ === 'Just') {
								var count = _v7.a.a;
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-ui-navigation-item__content-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$PinMeTo$Ui$Navigation$roundCount(count))
										]));
							} else {
								return (options.accumulateChildIndicatorContentCounts && (!isCurrentParent)) ? A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										function (count) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-ui-navigation-item__content-count')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$PinMeTo$Ui$Navigation$roundCount(count))
													]));
										},
										function (sum) {
											return (sum > 0) ? $elm$core$Maybe$Just(sum) : $elm$core$Maybe$Nothing;
										}(
											$elm$core$List$sum(
												A2(
													$elm$core$List$filterMap,
													function (_v8) {
														var indicators = _v8.c.indicators;
														return A2(
															$elm$core$Maybe$map,
															function (_v9) {
																var count = _v9.a;
																return count;
															},
															indicators.contentCount);
													},
													children))))) : $elm$html$Html$text('');
							}
						}(),
							isParent ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-navigation-item__caret')
								]),
							_List_fromArray(
								[
									(hasCurrentInChildren || A2($author$project$PinMeTo$Ui$Navigation$Util$isDescendant, currentUrl, path)) ? $author$project$FontAwesome$Solid$faCaretDown : $author$project$FontAwesome$Solid$faCaretRight
								])) : (_Utils_eq(
							options.target,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Navigation$Blank)) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-navigation-item__caret pmt-ui-navigation-item__caret--small')
								]),
							_List_fromArray(
								[$author$project$FontAwesome$Regular$faLinkHorizontal])) : $elm$html$Html$text(''))
						])),
					function () {
					if (!children.b) {
						return $elm$html$Html$text('');
					} else {
						var children_ = children;
						return A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-navigation')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$PinMeTo$Ui$Navigation$renderItem, compact, currentUrl),
								$author$project$PinMeTo$Ui$Navigation$activeFilter(children_)));
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$Navigation$ConversationsStyle = {$: 'ConversationsStyle'};
var $author$project$PinMeTo$Ui$Navigation$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-ui-navigation'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-ui-navigation--compact', config.compact),
						_Utils_Tuple2(
						'pmt-ui-navigation--conversations',
						_Utils_eq(
							config.style,
							$elm$core$Maybe$Just($author$project$PinMeTo$Ui$Navigation$ConversationsStyle)))
					]))
			]),
		A2(
			$elm$core$List$map,
			A2($author$project$PinMeTo$Ui$Navigation$renderItem, config.compact, config.currentUrl),
			$author$project$PinMeTo$Ui$Navigation$activeFilter(config.items)));
};
var $author$project$FontAwesome$Solid$Icon$faAngleLeft = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-angle-left');
var $author$project$FontAwesome$Solid$faAngleLeft = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faAngleLeft);
var $author$project$FontAwesome$Solid$Icon$faAngleRight = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-angle-right');
var $author$project$FontAwesome$Solid$faAngleRight = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faAngleRight);
var $author$project$PinMeTo$Global$Sidebar$toggleView = function (config) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				config.onToggle(!config.compact)),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-global-sidebar__toggler', true),
						_Utils_Tuple2('pmt-global-sidebar__toggler--compact', config.compact)
					]))
			]),
		_List_fromArray(
			[
				config.compact ? $author$project$FontAwesome$Solid$faAngleRight : $author$project$FontAwesome$Solid$faAngleLeft
			]));
};
var $author$project$PinMeTo$Global$Sidebar$productViewWithClickEvent = F3(
	function (maybeMetricsEvent, compact, product) {
		var withMetricsEvent = function (attribs) {
			if (maybeMetricsEvent.$ === 'Just') {
				var metricsEvent = maybeMetricsEvent.a;
				return A2(
					$elm$core$List$cons,
					$author$project$PinMeTo$Ui$Metrics$toAttribute(metricsEvent),
					attribs);
			} else {
				return attribs;
			}
		};
		return A2(
			$elm$html$Html$a,
			withMetricsEvent(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(product.path),
						$elm$html$Html$Attributes$class('pmt-global-sidebar-product'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pmt-global-sidebar-product--compact', compact)
							]))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-sidebar-product__icon')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Icon$render(product.icon)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-sidebar-product__info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-global-sidebar-product__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(product.title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-global-sidebar-product__site-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(product.siteName)
								]))
						]))
				]));
	});
var $author$project$PinMeTo$Global$Sidebar$productView = F2(
	function (compact, product) {
		return A3($author$project$PinMeTo$Global$Sidebar$productViewWithClickEvent, $elm$core$Maybe$Nothing, compact, product);
	});
var $author$project$FontAwesome$Solid$Icon$faBars = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-bars');
var $author$project$FontAwesome$Solid$faBars = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faBars);
var $author$project$PinMeTo$Global$Sidebar$mobileToggleView = function (config) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				config.onToggle(!config.compact)),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-global-sidebar__toggler-mobile', true),
						_Utils_Tuple2('pmt-global-sidebar__toggler-mobile--visible', config.compact)
					]))
			]),
		_List_fromArray(
			[$author$project$FontAwesome$Solid$faBars]));
};
var $author$project$PinMeTo$Global$Sidebar$workInProgressView = function (count) {
	var render_ = function (x) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-sidebar__work-in-progress pmt-ui-navigation')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-navigation-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-navigation-item__icon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-solid fa-gear fa-spin')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-navigation-item__label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(x)
								]))
						]))
				]));
	};
	switch (count) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			return render_('1 job in progress');
		default:
			var n = count;
			return render_(
				$elm$core$String$fromInt(n) + ' jobs in queue');
	}
};
var $author$project$PinMeTo$Global$Sidebar$render = function (_v0) {
	var config = _v0.a;
	var options = _v0.b;
	var compactNotMobile = config.compact && (!config.mobile);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-global-sidebar'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-global-sidebar--compact', compactNotMobile),
						_Utils_Tuple2('pmt-global-sidebar--mobile-compact', config.mobile && config.compact),
						_Utils_Tuple2('pmt-global-sidebar--mobile', config.mobile)
					]))
			]),
		_List_fromArray(
			[
				(config.mobile && (!config.compact)) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-sidebar__overlay'),
						$elm$html$Html$Events$onClick(
						config.onToggle(true))
					]),
				_List_Nil) : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-sidebar__content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$header,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-global-sidebar__header')
							]),
						_List_fromArray(
							[
								A2($author$project$PinMeTo$Global$Sidebar$productView, compactNotMobile, config.product)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-global-sidebar__navigation')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Navigation$render(
								function (navigation) {
									return A2(
										$elm$core$Maybe$withDefault,
										navigation,
										A2(
											$elm$core$Maybe$map,
											function (f) {
												return f(navigation);
											},
											options.maybeNavigationMap));
								}(
									A2(
										$author$project$PinMeTo$Ui$Navigation$view,
										{compact: compactNotMobile, basePath: config.basePath, currentUrl: config.url},
										config.navigation)))
							])),
						$author$project$PinMeTo$Global$Sidebar$workInProgressView(config.workInProgress),
						$author$project$PinMeTo$Global$Sidebar$toggleView(config)
					])),
				config.mobile ? $author$project$PinMeTo$Global$Sidebar$mobileToggleView(config) : $elm$html$Html$text('')
			]));
};
var $author$project$PinMeTo$Ui$Navigation$Indicators = F4(
	function (_new, warning, unreadCount, contentCount) {
		return {_new: _new, warning: warning, unreadCount: unreadCount, contentCount: contentCount};
	});
var $author$project$PinMeTo$Ui$Navigation$link = F2(
	function (label, path) {
		return A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			$author$project$PinMeTo$Ui$Navigation$Path(path),
			label,
			{
				icon: $elm$core$Maybe$Nothing,
				active: true,
				target: $elm$core$Maybe$Nothing,
				onClick: $elm$core$Maybe$Nothing,
				indicators: A4($author$project$PinMeTo$Ui$Navigation$Indicators, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				dataTestAttribute: $elm$core$Maybe$Nothing,
				accumulateChildIndicatorContentCounts: true
			},
			_List_Nil);
	});
var $author$project$Translations$Listings$Conflicts$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.title');
};
var $author$project$Translations$Listings$Navigation$rating = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.rating');
};
var $author$project$Translations$General$SharedNavigation$system = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.shared_navigation.system');
};
var $author$project$FontAwesome$Light$Icon$faClock = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-clock');
var $author$project$FontAwesome$Light$Icon$faGlobe = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-globe');
var $author$project$FontAwesome$Light$Icon$faImage = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-image');
var $author$project$PinMeTo$Ui$Navigation$activeIf = F2(
	function (active, _v0) {
		var url = _v0.a;
		var label = _v0.b;
		var options = _v0.c;
		var children = _v0.d;
		return A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			url,
			label,
			_Utils_update(
				options,
				{active: active}),
			children);
	});
var $author$project$PinMeTo$Ui$Navigation$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $author$project$PinMeTo$Ui$Navigation$withIcon = F2(
	function (icon, item) {
		var url = item.a;
		var label = item.b;
		var options = item.c;
		var children = item.d;
		return A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			url,
			label,
			_Utils_update(
				options,
				{
					icon: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Navigation$Custom(icon))
				}),
			children);
	});
var $author$project$Translations$Listings$Navigation$Dashboard$dashboard = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.dashboard.dashboard');
};
var $author$project$FontAwesome$Light$Icon$faSitemap = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-sitemap');
var $author$project$FontAwesome$Brands$Icon$faFacebook = $author$project$FontAwesome$Brands$Icon$Icon('fa-brands fa-facebook');
var $author$project$Translations$Listings$Navigation$directories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.directories');
};
var $author$project$FontAwesome$Light$Icon$faHardDrive = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-hard-drive');
var $author$project$FontAwesome$Light$Icon$faListCheck = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-list-check');
var $author$project$Translations$Listings$Navigation$mediaReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.media_review');
};
var $author$project$Translations$Listings$Navigation$bookingLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.booking_links');
};
var $author$project$FontAwesome$Light$Icon$faArrowRight = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-arrow-right');
var $author$project$Translations$General$mediaLibrary = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.media_library');
};
var $author$project$PinMeTo$Ui$Navigation$withChildren = F2(
	function (children, item) {
		var url = item.a;
		var label = item.b;
		var options = item.c;
		return A4($author$project$PinMeTo$Ui$Navigation$Link, url, label, options, children);
	});
var $author$project$FontAwesome$Light$Icon$faFolderImage = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-folder-image');
var $author$project$FontAwesome$Light$Icon$faLocationDot = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-location-dot');
var $author$project$PinMeTo$Permissions$hasPermission = F2(
	function (_v0, p) {
		var model = _v0.a;
		return A2($Gizra$elm_all_set$EverySet$member, p, model.permissions);
	});
var $author$project$Translations$General$Insights$insightsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.insights_title');
};
var $author$project$FontAwesome$Light$Icon$faBarsProgress = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-bars-progress');
var $author$project$FontAwesome$Light$Icon$faChartNetwork = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-chart-network');
var $author$project$FontAwesome$Light$Icon$faChartTreeMap = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-chart-tree-map');
var $author$project$Translations$General$WorkerLog$workerLogTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.worker_log_title');
};
var $author$project$Translations$Listings$Navigation$brandManagement = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.brand_management');
};
var $author$project$Translations$Listings$Navigation$tasks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.tasks');
};
var $author$project$Translations$Listings$Navigation$claimPage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.claim_page');
};
var $author$project$PinMeTo$Ui$Icon$NetworkHere = {$: 'NetworkHere'};
var $author$project$FontAwesome$Light$Icon$faShieldCheck = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-shield-check');
var $author$project$PinMeTo$Ui$Icon$NetworkTrustPilot = {$: 'NetworkTrustPilot'};
var $author$project$PinMeTo$Ui$Navigation$FontAwesome = function (a) {
	return {$: 'FontAwesome', a: a};
};
var $author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon = F2(
	function (icon, item) {
		var url = item.a;
		var label = item.b;
		var options = item.c;
		var children = item.d;
		return A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			url,
			label,
			_Utils_update(
				options,
				{
					icon: $elm$core$Maybe$Just(
						$author$project$PinMeTo$Ui$Navigation$FontAwesome(icon))
				}),
			children);
	});
var $author$project$Navigation$Sidebar$Main$claimNavigation = F2(
	function (model, path) {
		var navVisible = A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$CustomerSuccess) && (!model.isDemoMode);
		var uiNavItem = function (_v0) {
			var name = _v0.b;
			var path_ = _v0.c;
			return A2(
				$author$project$PinMeTo$Ui$Navigation$link,
				name,
				path(path_));
		};
		var rootIcon = $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faShieldCheck);
		var networks = {
			ptv: _Utils_Tuple3(model.enabledNetworks.ptv, 'PTV', 'claim/ptv'),
			bing: _Utils_Tuple3(model.enabledNetworks.bing, 'Bing', 'claim/bing'),
			here: _Utils_Tuple3(model.enabledNetworks.here, 'Here', 'claim/here'),
			apple: _Utils_Tuple3(model.enabledNetworks.apple, 'Apple', 'claim/apple'),
			baidu: _Utils_Tuple3(model.enabledNetworks.baidu, 'Baidu', 'claim/baidu'),
			google: _Utils_Tuple3(model.enabledNetworks.google, 'Google', 'claim/google'),
			tomtom: _Utils_Tuple3(model.enabledNetworks.tomtom, 'TomTom', 'claim/tomtom'),
			factual: _Utils_Tuple3(model.enabledNetworks.factual, 'Foursquare', 'claim/foursquare'),
			facebook: _Utils_Tuple3(model.enabledNetworks.facebook, 'Facebook', 'claim/facebook'),
			overture: _Utils_Tuple3(model.enabledNetworks.overture, 'Overture', 'claim/overture'),
			trustpilot: _Utils_Tuple3(model.enabledNetworks.trustpilot, 'TrustPilot', 'claim/trustpilot')
		};
		return navVisible ? _List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Ui$Navigation$withChildren,
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faListCheck),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$Listings$Navigation$tasks(model.translations),
							path('claim/tasks'))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faGoogle),
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.google,
							uiNavItem(networks.google))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faFacebookF),
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.facebook,
							uiNavItem(networks.facebook))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faApple),
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.apple,
							uiNavItem(networks.apple))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$NetworkBing,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.bing,
							uiNavItem(networks.bing))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$NetworkHere,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.here,
							uiNavItem(networks.here))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$RegularColorTomTom,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.tomtom,
							uiNavItem(networks.tomtom))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$RegularColorBaidu,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.baidu,
							uiNavItem(networks.baidu))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$NetworkTrustPilot,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.trustpilot,
							uiNavItem(networks.trustpilot))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$RegularColorOverture,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.overture,
							uiNavItem(networks.overture))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$RegularColorPTV,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.ptv,
							uiNavItem(networks.ptv))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$withIcon,
						$author$project$PinMeTo$Ui$Icon$RegularColorFoursquare,
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.factual,
							uiNavItem(networks.factual)))
					]),
				A2(
					$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
					rootIcon,
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						$author$project$Translations$Listings$Navigation$claimPage(model.translations),
						path('claim/tasks'))))
			]) : _List_Nil;
	});
var $author$project$FontAwesome$Light$Icon$faCalendarCheck = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-calendar-check');
var $author$project$Translations$Listings$ApiDifference$rejectedChanges = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.api_difference.rejected_changes');
};
var $author$project$FontAwesome$Light$Icon$faTags = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-tags');
var $author$project$Navigation$Sidebar$Main$labelsDevNavLink = F2(
	function (model, path) {
		return (model.isLabelsFeatureFlaggedUser && (!model.isDemoMode)) ? _List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
				$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faTags),
				A2(
					$author$project$PinMeTo$Ui$Navigation$link,
					'Labels (dev)',
					path('locations/labels')))
			]) : _List_Nil;
	});
var $author$project$FontAwesome$Light$Icon$faClockRotateLeft = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-clock-rotate-left');
var $author$project$FontAwesome$Light$Icon$faFileSpreadsheet = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-file-spreadsheet');
var $author$project$Translations$General$spreadsheetButton = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.spreadsheet_button');
};
var $author$project$FontAwesome$Light$Icon$faFilterCircleXmark = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-filter-circle-xmark');
var $author$project$PinMeTo$Ui$Navigation$WarningIndicator = {$: 'WarningIndicator'};
var $author$project$PinMeTo$Ui$Navigation$withWarningIndicator = function (_v0) {
	var url = _v0.a;
	var label = _v0.b;
	var options = _v0.c;
	var children = _v0.d;
	return A4(
		$author$project$PinMeTo$Ui$Navigation$Link,
		url,
		label,
		_Utils_update(
			options,
			{
				indicators: function (x) {
					return _Utils_update(
						x,
						{
							warning: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$Navigation$WarningIndicator)
						});
				}(options.indicators)
			}),
		children);
};
var $author$project$PinMeTo$Ui$Navigation$withUnreadCountIndicator = F2(
	function (count, _v0) {
		var url = _v0.a;
		var label = _v0.b;
		var options = _v0.c;
		var children = _v0.d;
		return A4(
			$author$project$PinMeTo$Ui$Navigation$Link,
			url,
			label,
			_Utils_update(
				options,
				{
					indicators: function (x) {
						return _Utils_update(
							x,
							{
								unreadCount: $elm$core$Maybe$Just(
									$author$project$PinMeTo$Ui$Navigation$UnreadCountIndicator(count))
							});
					}(options.indicators)
				}),
			children);
	});
var $author$project$Navigation$Sidebar$Main$navigation = function (model) {
	var ifBulkVerifiedEligible = function (eligible) {
		return eligible ? $author$project$PinMeTo$Ui$Navigation$withWarningIndicator : $elm$core$Basics$identity;
	};
	var ifMediaCountNotZero = function (mediaCount) {
		if (mediaCount.$ === 'Loaded') {
			var count = mediaCount.a;
			return (count > 0) ? $author$project$PinMeTo$Ui$Navigation$withUnreadCountIndicator(count) : $elm$core$Basics$identity;
		} else {
			return $elm$core$Basics$identity;
		}
	};
	var ifPermission = function (permission) {
		return $author$project$PinMeTo$Ui$Navigation$activeIf(
			A2($author$project$PinMeTo$Permissions$hasPermission, model.permissions, permission));
	};
	var path = function (x) {
		return model.siteName + ('/' + x);
	};
	var brandManagementDefaultPath = function () {
		var _v2 = _Utils_Tuple2(model.enabledNetworks.google, model.enabledNetworks.facebook);
		if (_v2.b) {
			return path('brandmanagement/facebook');
		} else {
			if (_v2.a) {
				return path('brandmanagement/google');
			} else {
				return path('brandmanagement/google');
			}
		}
	}();
	return _Utils_ap(
		_List_fromArray(
			[
				A2(
				ifPermission,
				$author$project$PinMeTo$Permissions$Permission('task.view'),
				A2(
					$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
					$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faChartTreeMap),
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						$author$project$Translations$Listings$Navigation$Dashboard$dashboard(model.translations),
						path('dashboard')))),
				function (nav) {
				if (A2(
					$author$project$PinMeTo$Permissions$hasPermission,
					model.permissions,
					$author$project$PinMeTo$Permissions$Permission('location.edit'))) {
					return A2(
						$author$project$PinMeTo$Ui$Navigation$withChildren,
						_Utils_ap(
							_List_fromArray(
								[
									function () {
									var _v0 = _Utils_Tuple2(model.numberOfConflicts, model.facebookBrandPageConflicts);
									if ((_v0.a.$ === 'Loaded') && (_v0.b.$ === 'Loaded')) {
										var numConflicts = _v0.a.a;
										var numBrandPageConflicts = _v0.b.a;
										var totalConflicts = numConflicts + numBrandPageConflicts;
										return (totalConflicts > 0) ? $author$project$PinMeTo$Ui$Navigation$withUnreadCountIndicator(totalConflicts) : $elm$core$Basics$identity;
									} else {
										return $elm$core$Basics$identity;
									}
								}()(
									A2(
										ifPermission,
										$author$project$PinMeTo$Permissions$Permission('task.conflict.manage'),
										A2(
											$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
											$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faListCheck),
											A2(
												$author$project$PinMeTo$Ui$Navigation$link,
												$author$project$Translations$Listings$Conflicts$title(model.translations),
												path('conflicts'))))),
									A2(
									$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
									$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faBarsProgress),
									A2(
										$author$project$PinMeTo$Ui$Navigation$link,
										$author$project$Translations$Listings$DataCompleteness$title(model.translations),
										path('dataCompleteness'))),
									A2(
									$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
									$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faArrowRight),
									A2(
										$author$project$PinMeTo$Ui$Navigation$link,
										$author$project$Translations$General$importButton(model.translations),
										path('locations/import'))),
									A2(
									$author$project$PinMeTo$Ui$Navigation$activeIf,
									A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$PinMeToDeveloper) && (!model.isDemoMode),
									A2(
										$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
										$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faFileSpreadsheet),
										A2(
											$author$project$PinMeTo$Ui$Navigation$link,
											$author$project$Translations$General$spreadsheetButton(model.translations),
											path('locations/spreadsheet')))),
									A2(
									$author$project$PinMeTo$Ui$Navigation$activeIf,
									A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$PinMeToDeveloper) && (!model.isDemoMode),
									A2(
										$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
										$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCalendarCheck),
										A2(
											$author$project$PinMeTo$Ui$Navigation$link,
											$author$project$Translations$Listings$Navigation$bookingLinks(model.translations),
											path('locations/bookingLinks')))),
									A2(
									$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
									$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faClock),
									A2(
										$author$project$PinMeTo$Ui$Navigation$link,
										$author$project$Translations$General$locationSpecialHours(model.translations),
										path('locations/specialhours')))
								]),
							A2($author$project$Navigation$Sidebar$Main$labelsDevNavLink, model, path)),
						nav);
				} else {
					var _v1 = A2($author$project$Navigation$Sidebar$Main$labelsDevNavLink, model, path);
					if (!_v1.b) {
						return nav;
					} else {
						var labels = _v1;
						return A2($author$project$PinMeTo$Ui$Navigation$withChildren, labels, nav);
					}
				}
			}(
				A2(
					ifPermission,
					$author$project$PinMeTo$Permissions$Permission('location.view'),
					A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faLocationDot),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$General$locations(model.translations),
							path('locations'))))),
				A2(
				ifBulkVerifiedEligible,
				model.bulkVerifiedEligible,
				A2(
					ifPermission,
					$author$project$PinMeTo$Permissions$Permission('location.view'),
					A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faSitemap),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$Listings$Navigation$directories(model.translations),
							path('directories'))))),
				A2(
				$author$project$PinMeTo$Ui$Navigation$withChildren,
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Navigation$activeIf,
						model.enabledNetworks.facebook,
						A2(
							$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faFacebook),
							A2(
								$author$project$PinMeTo$Ui$Navigation$link,
								'Facebook',
								path('brandmanagement/facebook')))),
						A2(
						$author$project$PinMeTo$Ui$Navigation$activeIf,
						model.enabledNetworks.google,
						A2(
							$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faGoogle),
							A2(
								$author$project$PinMeTo$Ui$Navigation$link,
								'Google',
								path('brandmanagement/google'))))
					]),
				A2(
					ifPermission,
					$author$project$PinMeTo$Permissions$Permission('location.view'),
					A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faGlobe),
						A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledNetworks.google || model.enabledNetworks.facebook,
							A2(
								$author$project$PinMeTo$Ui$Navigation$link,
								$author$project$Translations$Listings$Navigation$brandManagement(model.translations),
								brandManagementDefaultPath))))),
				A2(
				ifPermission,
				$author$project$PinMeTo$Permissions$Permission('location.view'),
				A2(
					$author$project$PinMeTo$Ui$Navigation$withChildren,
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faStar),
							A2(
								$author$project$PinMeTo$Ui$Navigation$link,
								$author$project$Translations$Listings$Navigation$rating(model.translations),
								path('insights/rating'))),
							A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledInsights.google,
							A2(
								$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
								$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faInputText),
								A2(
									$author$project$PinMeTo$Ui$Navigation$link,
									'Keywords',
									path('insights/keywords')))),
							A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledInsights.google,
							A2(
								$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
								$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faGoogle),
								A2(
									$author$project$PinMeTo$Ui$Navigation$link,
									'Google',
									path('insights/google')))),
							A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledInsights.apple,
							A2(
								$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
								$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faApple),
								A2(
									$author$project$PinMeTo$Ui$Navigation$link,
									'Apple',
									path('insights/apple')))),
							A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledInsights.facebook,
							A2(
								$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
								$author$project$FontAwesome$brands($author$project$FontAwesome$Brands$Icon$faFacebookF),
								A2(
									$author$project$PinMeTo$Ui$Navigation$link,
									'Facebook',
									path('insights/facebook')))),
							A2(
							$author$project$PinMeTo$Ui$Navigation$activeIf,
							model.enabledInsights.bing,
							A2(
								$author$project$PinMeTo$Ui$Navigation$withIcon,
								$author$project$PinMeTo$Ui$Icon$NetworkBing,
								A2(
									$author$project$PinMeTo$Ui$Navigation$link,
									'Bing',
									path('insights/bing')))),
							A2(
							$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faHardDrive),
							A2(
								$author$project$PinMeTo$Ui$Navigation$link,
								$author$project$Translations$General$SharedNavigation$system(model.translations),
								path('insights/system')))
						]),
					A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faChartLine),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$General$Insights$insightsTitle(model.translations),
							path('insights/overview'))))),
				A2(
				ifMediaCountNotZero,
				model.unreviewedMediaCount,
				A2(
					$author$project$PinMeTo$Ui$Navigation$activeIf,
					model.mediaReviewEnabled,
					A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faImage),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$Listings$Navigation$mediaReview(model.translations),
							path('mediareview'))))),
				A2(
				ifPermission,
				$author$project$PinMeTo$Permissions$Permission('media.view'),
				A2(
					$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
					$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faFolderImage),
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						$author$project$Translations$General$mediaLibrary(model.translations),
						path('assets')))),
				A2(
				$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
				$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faClockRotateLeft),
				A2(
					$author$project$PinMeTo$Ui$Navigation$link,
					$author$project$Translations$General$WorkerLog$workerLogTitle(model.translations),
					path('workerLog/items'))),
				(A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$Owner) && model.apiEnabled) ? A2(
				$author$project$PinMeTo$Ui$Navigation$withChildren,
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faFilterCircleXmark),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$Listings$ApiDifference$rejectedChanges(model.translations),
							path('apisettings/changes')))
					]),
				A2(
					$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
					$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faChartNetwork),
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						$author$project$Translations$Listings$ApiDifference$apiData(model.translations),
						path('apisettings/documentation')))) : A2(
				ifPermission,
				$author$project$PinMeTo$Permissions$Permission('location.view'),
				A2(
					$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
					$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faChartNetwork),
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						$author$project$Translations$Listings$ApiDifference$apiData(model.translations),
						path('apisettings/documentation'))))
			]),
		A2($author$project$Navigation$Sidebar$Main$claimNavigation, model, path));
};
var $author$project$PinMeTo$Ui$Icon$AppIconListings = {$: 'AppIconListings'};
var $author$project$Navigation$Sidebar$Main$SidebarSetCompact = function (a) {
	return {$: 'SidebarSetCompact', a: a};
};
var $author$project$Navigation$Sidebar$Main$view_ = function (model) {
	return $author$project$PinMeTo$Global$Sidebar$render(
		$author$project$PinMeTo$Global$Sidebar$view(
			{
				url: model.url,
				mobile: model.mobile,
				compact: model.collapsed,
				product: {icon: $author$project$PinMeTo$Ui$Icon$AppIconListings, path: '/listings/' + model.siteName, title: 'Listings', siteName: model.siteDisplayName},
				basePath: '/listings/',
				onToggle: $author$project$Navigation$Sidebar$Main$SidebarSetCompact,
				navigation: $author$project$Navigation$Sidebar$Main$navigation(model),
				workInProgress: model.workInProgress
			}));
};
var $author$project$Navigation$Sidebar$Main$view = function (state) {
	if (state.$ === 'Ok') {
		var model = state.a;
		return $author$project$Navigation$Sidebar$Main$view_(model);
	} else {
		var error = state.a;
		return $elm$html$Html$text(error);
	}
};
var $author$project$Navigation$Sidebar$Main$OnDebouncerMsg = function (a) {
	return {$: 'OnDebouncerMsg', a: a};
};
var $author$project$Navigation$Sidebar$Main$out_Navigation_Sidebar_Main_sidebarCollapsed = _Platform_outgoingPort(
	'out_Navigation_Sidebar_Main_sidebarCollapsed',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collapsed',
					$elm$json$Json$Encode$bool($.collapsed))
				]));
	});
var $author$project$Navigation$Sidebar$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnLanguageChanged':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var t = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{translations: t})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Err('Can not display navigation. Error was logged.'),
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'Navigation.Sidebar.Main',
								message: 'Failed to decode translations'
							}));
				}
			case 'SidebarSetCompact':
				var x = msg.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{collapsed: x})),
					$author$project$Navigation$Sidebar$Main$out_Navigation_Sidebar_Main_sidebarCollapsed(
						{collapsed: x}));
			case 'OnUrlChange':
				var x = msg.a;
				var resetMediaCount = function (url) {
					var pageName = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$elm$core$Basics$identity,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$String$split, '/', url))));
					return (!(pageName === 'mediareview')) ? model.unreviewedMediaCount : $author$project$RemoteData$Loaded(0);
				};
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Result$Err('Invalid URL'),
						A2(
							$elm$core$Maybe$map,
							function (url) {
								return $elm$core$Result$Ok(
									_Utils_update(
										model,
										{
											url: url,
											unreviewedMediaCount: resetMediaCount(url.path)
										}));
							},
							$elm$url$Url$fromString(x))),
					$elm$core$Platform$Cmd$none);
			case 'OnWorkInProgress':
				var count = msg.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{workInProgress: count})),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Navigation$Sidebar$Main$OnDebouncerMsg,
						$author$project$Common$Debouncer$trigger(_Utils_Tuple0)));
			case 'OnWindowWidth':
				var width = msg.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{mobile: width < 640})),
					$elm$core$Platform$Cmd$none);
			case 'GetToday':
				var date = msg.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{today: date})),
					$elm$core$Platform$Cmd$none);
			case 'OnNumberOfConflicts':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var count = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									numberOfConflicts: $author$project$RemoteData$Loaded(count)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									numberOfConflicts: $author$project$RemoteData$Error(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Navigation.Sidebar.Main',
								message: 'Failed to get number of conflicts'
							}));
				}
			case 'OnFacebookBrandPageConflicts':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var count = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									facebookBrandPageConflicts: $author$project$RemoteData$Loaded(count)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									facebookBrandPageConflicts: $author$project$RemoteData$Error(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Navigation.Sidebar.Main',
								message: 'Failed to get number of facebook brand page conflicts'
							}));
				}
			case 'OnUnreviewedMediaCount':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var count = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									unreviewedMediaCount: $author$project$RemoteData$Loaded(count)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									unreviewedMediaCount: $author$project$RemoteData$Error(
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
								})),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Navigation.Sidebar.Main',
								message: 'Failed to get number of unreviewed media'
							}));
				}
			default:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Common$Debouncer$update, subMsg, model.conflictsDebouncer);
				var newDebouncerState = _v5.a;
				var newDebouncerCmd = _v5.b;
				var maybeResult = _v5.c;
				var fetchConflictsCmd = function () {
					if (maybeResult.$ === 'Just') {
						return A2(
							$author$project$Navigation$Sidebar$Main$getAllConflicts,
							$author$project$Navigation$Sidebar$Main$userIsOwner(model.permissions),
							$author$project$Data$SiteName$SiteName(model.siteName));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{conflictsDebouncer: newDebouncerState})),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Navigation$Sidebar$Main$OnDebouncerMsg, newDebouncerCmd),
								fetchConflictsCmd
							])));
		}
	});
var $author$project$Navigation$Sidebar$Main$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Navigation$Sidebar$Main$OnWorkInProgress = function (a) {
	return {$: 'OnWorkInProgress', a: a};
};
var $author$project$Navigation$Sidebar$Main$OnLanguageChanged = function (a) {
	return {$: 'OnLanguageChanged', a: a};
};
var $author$project$Navigation$Sidebar$Main$in_Navigation_Sidebar_Main_urlChange = _Platform_incomingPort('in_Navigation_Sidebar_Main_urlChange', $elm$json$Json$Decode$string);
var $author$project$Navigation$Sidebar$Main$in_Navigation_Sidebar_Main_languageChanged = _Platform_incomingPort('in_Navigation_Sidebar_Main_languageChanged', $elm$json$Json$Decode$value);
var $author$project$Navigation$Sidebar$Main$in_Navigation_Sidebar_Main_workInProgressCount = _Platform_incomingPort('in_Navigation_Sidebar_Main_workInProgressCount', $elm$json$Json$Decode$int);
var $author$project$Navigation$Sidebar$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Navigation$Sidebar$Main$init,
		view: $author$project$Navigation$Sidebar$Main$view,
		update: F2(
			function (msg, state) {
				if (state.$ === 'Ok') {
					var model = state.a;
					return A2($author$project$Navigation$Sidebar$Main$update, msg, model);
				} else {
					return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
				}
			}),
		subscriptions: $elm$core$Basics$always(
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onResize(
						F2(
							function (w, _v1) {
								return $author$project$Navigation$Sidebar$Main$OnWindowWidth(w);
							})),
						$author$project$Navigation$Sidebar$Main$in_Navigation_Sidebar_Main_urlChange($author$project$Navigation$Sidebar$Main$OnUrlChange),
						$author$project$Navigation$Sidebar$Main$in_Navigation_Sidebar_Main_workInProgressCount($author$project$Navigation$Sidebar$Main$OnWorkInProgress),
						$author$project$Navigation$Sidebar$Main$in_Navigation_Sidebar_Main_languageChanged(
						A2(
							$elm$core$Basics$composeR,
							$elm$json$Json$Decode$decodeValue($author$project$Common$Language$translationsDecoder),
							$author$project$Navigation$Sidebar$Main$OnLanguageChanged))
					])))
	});
var $author$project$LocatorLandingPage$Main$init = F2(
	function (_v0, flags) {
		return _Utils_Tuple2(
			{listings: flags.listings, confirmationPopup: false},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$FontAwesome$Thin$Icon$faBrowser = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-browser');
var $author$project$FontAwesome$Thin$faBrowser = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faBrowser);
var $author$project$FontAwesome$Thin$Icon$faPalette = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-palette');
var $author$project$FontAwesome$Thin$faPalette = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faPalette);
var $author$project$Translations$LocatorLandingPage$mainTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.main_title');
};
var $author$project$LocatorLandingPage$Main$CloseAlertBox = function (a) {
	return {$: 'CloseAlertBox', a: a};
};
var $author$project$LocatorLandingPage$Main$showAlert = F3(
	function (body, footer, action) {
		return $author$project$PinMeTo$Ui$Lightbox$render(
			$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
				$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withStyle,
						$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withClose,
							$author$project$LocatorLandingPage$Main$CloseAlertBox(action),
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withFooter,
								footer,
								$author$project$PinMeTo$Ui$Lightbox$view(
									{
										title: '',
										content: A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[body]))
									})))))));
	});
var $author$project$Translations$LocatorLandingPage$subtitle1 = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.subtitle1');
};
var $author$project$LocatorLandingPage$Main$ChatWithUs = {$: 'ChatWithUs'};
var $author$project$Translations$LocatorLandingPage$brand0Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.brand0_title');
};
var $author$project$Translations$LocatorLandingPage$brand1Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.brand1_title');
};
var $author$project$Translations$LocatorLandingPage$brand2Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.brand2_title');
};
var $author$project$Translations$LocatorLandingPage$intro1Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro1_title');
};
var $author$project$Translations$LocatorLandingPage$intro2Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro2_title');
};
var $author$project$Translations$LocatorLandingPage$intro3Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro3_title');
};
var $author$project$Translations$LocatorLandingPage$intro4Title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro4_title');
};
var $author$project$Translations$LocatorLandingPage$bookDemoNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.book_demo_note');
};
var $author$project$LocatorLandingPage$Main$InterestPopup = {$: 'InterestPopup'};
var $author$project$Translations$LocatorLandingPage$brand1Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.brand1_content');
};
var $author$project$Translations$LocatorLandingPage$brand2Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.brand2_content');
};
var $author$project$Translations$LocatorLandingPage$intro1Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro1_content');
};
var $author$project$Translations$LocatorLandingPage$intro2Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro2_content');
};
var $author$project$Translations$LocatorLandingPage$intro3Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro3_content');
};
var $author$project$Translations$LocatorLandingPage$intro4Content = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.intro4_content');
};
var $author$project$LocatorLandingPage$Main$ClickedBookMeeting = {$: 'ClickedBookMeeting'};
var $author$project$LocatorLandingPage$Main$NotInterestedClicked = {$: 'NotInterestedClicked'};
var $author$project$FontAwesome$Thin$Icon$faMagnifyingGlassLocation = $author$project$FontAwesome$Thin$Icon$Icon('fa-thin fa-magnifying-glass-location');
var $author$project$FontAwesome$Thin$faMagnifyingGlassLocation = $author$project$FontAwesome$Thin$Icon$render($author$project$FontAwesome$Thin$Icon$faMagnifyingGlassLocation);
var $author$project$Translations$LocatorLandingPage$turnDataIntoTrustedSource = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'locator_landing_page.turn_data_into_trusted_source');
};
var $author$project$LocatorLandingPage$Main$view = F2(
	function (session, model) {
		var translation = F2(
			function (key, replacements) {
				return A5($ChristophP$elm_i18next$I18Next$customTr, session.translations, $ChristophP$elm_i18next$I18Next$Curly, $elm$html$Html$text, key, replacements);
			});
		var confirmationBody = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-locator-landing-page__confirmation-popup')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-locator-landing-page__confirmation-popup--title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$LocatorLandingPage$letsConnect(session.translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-locator-landing-page__confirmation-popup--content'),
							A2($elm$html$Html$Attributes$style, 'padding-bottom', '1.6rem')
						]),
					A2(
						translation,
						'locator_landing_page.reach',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(session.user.email)
										])))
							])))
				]));
		var confirmationPopup = model.confirmationPopup ? A3(
			$author$project$LocatorLandingPage$Main$showAlert,
			confirmationBody,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn-group')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$PinMeTo$Ui$Btn$pmtBtn,
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$LocatorLandingPage$Main$CloseAlertBox(''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$LocatorLandingPage$gotIt(session.translations))
							]))
					])),
			'Locator - Landing page - Contact me clicked') : $elm$html$Html$text('');
		var ctaButtons = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-center flex-basis flex-wrap')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-page__interest-button'),
									$elm$html$Html$Events$onClick($author$project$LocatorLandingPage$Main$InterestPopup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$contactMe(session.translations))
								])),
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnMuted,
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-page__interest-button'),
									$elm$html$Html$Events$onClick($author$project$LocatorLandingPage$Main$ClickedBookMeeting),
									$elm$html$Html$Attributes$href('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3FB8sI5Epv0PQIWzf4qL_hIeBpV4hkHcnwEh8jfo9gjvM8ZCKowb55j71ncAevtfmEhhL2bGTk'),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$id('book-a-meeting')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$bookDemo(session.translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('locator-ctas-note-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('locator-ctas-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$contactMeNote(session.translations))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('locator-ctas-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$LocatorLandingPage$bookDemoNote(session.translations))
								]))
						]))
				]));
		var chatButton = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chat')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$LocatorLandingPage$haveQuestions(session.translations))
						])),
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$LocatorLandingPage$Main$ChatWithUs)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$LocatorLandingPage$chat(session.translations))
						]))
				]));
		var mainImage = A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('img/locator-landing-page/promo.png'),
					$elm$html$Html$Attributes$class('main-image')
				]),
			_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-locator-landing-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-page__container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-locator-landing-page__content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-locator-landing-page__content--header')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocatorLandingPage$mainTitle(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-locator-landing-page__content--subtitle')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocatorLandingPage$subtitle1(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-locator-landing-page__content--buttons')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtn,
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-locator-landing-page__interest-button'),
															$elm$html$Html$Events$onClick($author$project$LocatorLandingPage$Main$InterestPopup)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$contactMe(session.translations))
														])),
													A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtnMuted,
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-locator-landing-page__interest-button'),
															$elm$html$Html$Events$onClick($author$project$LocatorLandingPage$Main$ClickedBookMeeting),
															$elm$html$Html$Attributes$href('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3FB8sI5Epv0PQIWzf4qL_hIeBpV4hkHcnwEh8jfo9gjvM8ZCKowb55j71ncAevtfmEhhL2bGTk'),
															$elm$html$Html$Attributes$target('_blank'),
															$elm$html$Html$Attributes$id('book-a-meeting')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$bookDemo(session.translations))
														])),
													$author$project$PinMeTo$Ui$Button$render(
													A2(
														$author$project$PinMeTo$Ui$Button$withOnClick,
														$author$project$LocatorLandingPage$Main$NotInterestedClicked,
														$author$project$PinMeTo$Ui$Button$buttonGhost(
															$author$project$Translations$LocatorLandingPage$notInterested(session.translations))))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('locator-lp-cta-note')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocatorLandingPage$contactMeNote(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('locator-lp-cta-note')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$LocatorLandingPage$bookDemoNote(session.translations))
												]))
										])),
									mainImage
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-gray-container introduction-container'),
									A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('locator-lp-introduction')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content divider')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faBrowser]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro1Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro1Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content divider')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faPalette]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro2Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro2Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content divider')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faArrowsRotate]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro3Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro3Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center icon')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('icon-wrapper')
																]),
															_List_fromArray(
																[$author$project$FontAwesome$Thin$faMagnifyingGlassLocation]))
														])),
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro4Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$intro4Content(session.translations))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-page__middle-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex-center locator-lp-product-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$LocatorLandingPage$brand0Title(session.translations))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dot-separator')
										]),
									_List_fromArray(
										[
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('locator-lp-card')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('box')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$brand1Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$brand1Content(session.translations))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('box')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex-center')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$brand2Title(session.translations))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$LocatorLandingPage$brand2Content(session.translations))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('locator-gif')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/locator.gif')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dot-separator')
										]),
									_List_fromArray(
										[
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil)
										])),
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex-center locator-lp-product-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$LocatorLandingPage$turnDataIntoTrustedSource(session.translations))
										])),
									ctaButtons
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-locator-landing-gray-container'),
									A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
								]),
							_List_fromArray(
								[chatButton]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('app__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-landing-page-footer pmt-locator-landing-page_container'),
									A2($elm$html$Html$Attributes$style, 'padding-bottom', '0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-locator-landing-page__content--note')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$LocatorLandingPage$trustedBy(session.translations))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-landing-page-footer pmt-landing-page-footer__brands')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/boots.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/hm.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/7eleven.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/starbucks.png'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('img/locator-landing-page/coop.svg'),
													$elm$html$Html$Attributes$width(40)
												]),
											_List_Nil)
										]))
								]))
						])),
					confirmationPopup
				]));
	});
var $author$project$LocatorLandingPage$Requests$LocatorLead = {$: 'LocatorLead'};
var $author$project$LocatorLandingPage$Main$SlackResponse = function (a) {
	return {$: 'SlackResponse', a: a};
};
var $author$project$LocatorLandingPage$Requests$errorBodyDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['error', 'message']),
	$elm$json$Json$Decode$string);
var $author$project$LocatorLandingPage$Requests$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 'BadUrl_':
						var url = response.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadUrl(url));
					case 'Timeout_':
						return $elm$core$Result$Err($elm$http$Http$Timeout);
					case 'NetworkError_':
						return $elm$core$Result$Err($elm$http$Http$NetworkError);
					case 'BadStatus_':
						var metadata = response.a;
						var body = response.b;
						var message = A2(
							$elm$core$Result$withDefault,
							body,
							A2($elm$json$Json$Decode$decodeString, $author$project$LocatorLandingPage$Requests$errorBodyDecoder, body));
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(
								'Error ' + ($elm$core$String$fromInt(metadata.statusCode) + (': ' + message))));
					default:
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (_v1.$ === 'Ok') {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err)));
						}
				}
			});
	});
var $author$project$LocatorLandingPage$Requests$slackChannelEncoder = function (channel) {
	return $elm$json$Json$Encode$int(3);
};
var $author$project$LocatorLandingPage$Requests$slackMessageEncoder = function (message) {
	return $elm$json$Json$Encode$int(3);
};
var $author$project$LocatorLandingPage$Requests$sendSlackMessage = F4(
	function (channel, messageTemplate, siteName, msg) {
		var encoder = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'channel',
					$author$project$LocatorLandingPage$Requests$slackChannelEncoder(channel)),
					_Utils_Tuple2(
					'messageTemplate',
					$author$project$LocatorLandingPage$Requests$slackMessageEncoder(messageTemplate))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$author$project$LocatorLandingPage$Requests$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(true)),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					encoder,
					$lukewestby$elm_http_builder$HttpBuilder$post('/api/' + (siteName + '/notify')))));
	});
var $author$project$LocatorLandingPage$Requests$LocatorProductLeads = {$: 'LocatorProductLeads'};
var $author$project$LocatorLandingPage$Main$NotInterestedPending = function (a) {
	return {$: 'NotInterestedPending', a: a};
};
var $author$project$LocatorLandingPage$Requests$addIgnoredProductUpgrade = F2(
	function (siteName, msg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'siteName',
					$elm$json$Json$Encode$string(siteName)),
					_Utils_Tuple2(
					'product',
					$elm$json$Json$Encode$string('Locator & Local Pages'))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$author$project$LocatorLandingPage$Requests$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(true)),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$post('/location-posts/api/user/ignoredProductUpgrades'))));
	});
var $author$project$LocatorLandingPage$Main$out_LocatorLandingPage_Main_ToggleChat = _Platform_outgoingPort(
	'out_LocatorLandingPage_Main_ToggleChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$LocatorLandingPage$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'Noop':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'InterestPopup':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmationPopup: true}),
					A4(
						$author$project$LocatorLandingPage$Requests$sendSlackMessage,
						$author$project$LocatorLandingPage$Requests$LocatorProductLeads,
						$author$project$LocatorLandingPage$Requests$LocatorLead,
						$author$project$Data$SiteName$toString(session.siteName),
						$author$project$LocatorLandingPage$Main$SlackResponse));
			case 'CloseAlertBox':
				var action = msg.a;
				return (action === '') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmationPopup: false}),
					$elm$browser$Browser$Navigation$load(model.listings)) : _Utils_Tuple2(
					_Utils_update(
						model,
						{confirmationPopup: false}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$PlanHat$PlanHat$track(
								{info: '', action: action}),
								$elm$browser$Browser$Navigation$load(model.listings)
							])));
			case 'ClickedBookMeeting':
				return _Utils_Tuple2(
					model,
					$author$project$PlanHat$PlanHat$track(
						{info: '', action: 'Locator - Landing page - Book a demo clicked'}));
			case 'SlackResponse':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'ChatWithUs':
				return _Utils_Tuple2(
					model,
					$author$project$LocatorLandingPage$Main$out_LocatorLandingPage_Main_ToggleChat(_Utils_Tuple0));
			case 'NotInterestedClicked':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$LocatorLandingPage$Requests$addIgnoredProductUpgrade,
								$author$project$Data$SiteName$toString(session.siteName),
								$author$project$LocatorLandingPage$Main$NotInterestedPending),
								$author$project$PlanHat$PlanHat$track(
								{info: '', action: 'Locator - Landing page - Not interested clicked'})
							])));
			default:
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(model.listings));
		}
	});
var $author$project$LocatorLandingPage$Main$Flags = function (listings) {
	return {listings: listings};
};
var $author$project$LocatorLandingPage$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'listings',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$LocatorLandingPage$Main$Flags));
var $author$project$LocatorLandingPage$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$LocatorLandingPage$Main$init,
		view: $author$project$LocatorLandingPage$Main$view,
		update: $author$project$LocatorLandingPage$Main$update,
		flagsDecoder: $author$project$LocatorLandingPage$Main$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$DataCompletenessV2$Dashboard$Model$init = {popOverState: $author$project$PinMeTo$Ui$PopOver$init, dataCompletenessStatus: $author$project$RemoteData$Suspended};
var $author$project$DataCompletenessV2$Commands$DataCompletenessStatus = function (locationsCount) {
	return function (enabledNetworks) {
		return function (totalFields) {
			return function (totalFieldsMissing) {
				return function (phone) {
					return function (openHours) {
						return function (email) {
							return function (homepage) {
								return function (longDescription) {
									return function (shortDescription) {
										return function (googleAttributes) {
											return function (actionLinks) {
												return function (googleCoverImage) {
													return function (googleProfileImage) {
														return function (googleLocationImages) {
															return function (facebookCoverImage) {
																return function (facebookProfileImage) {
																	return function (googleCategories) {
																		return function (facebookCategories) {
																			return function (bingCategories) {
																				return function (appleCategories) {
																					return {email: email, phone: phone, homepage: homepage, openHours: openHours, actionLinks: actionLinks, totalFields: totalFields, bingCategories: bingCategories, locationsCount: locationsCount, appleCategories: appleCategories, enabledNetworks: enabledNetworks, longDescription: longDescription, googleAttributes: googleAttributes, googleCategories: googleCategories, googleCoverImage: googleCoverImage, shortDescription: shortDescription, facebookCategories: facebookCategories, facebookCoverImage: facebookCoverImage, googleProfileImage: googleProfileImage, totalFieldsMissing: totalFieldsMissing, facebookProfileImage: facebookProfileImage, googleLocationImages: googleLocationImages};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$DataCompletenessV2$Commands$missingDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['missingFields', 'networkCategoriesApple']),
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['missingFields', 'networkCategoriesBing']),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['missingFields', 'networkCategoriesFacebook']),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['missingFields', 'networkCategoriesGoogle']),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['missingFields', 'facebookProfileImage']),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['missingFields', 'facebookCoverImage']),
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['missingFields', 'googleLocationImages']),
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['missingFields', 'googleProfileImage']),
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['missingFields', 'googleCoverImage']),
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['missingFields', 'actionLinks']),
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['missingFields', 'googleAttributes']),
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
												_List_fromArray(
													['missingFields', 'shortDescription']),
												$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
													_List_fromArray(
														['missingFields', 'longDescription']),
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
														_List_fromArray(
															['missingFields', 'homepage']),
														$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
															_List_fromArray(
																['missingFields', 'email']),
															$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																_List_fromArray(
																	['missingFields', 'openHours']),
																$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																	_List_fromArray(
																		['missingFields', 'phone']),
																	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'totalFieldsMissing',
																		$elm$json$Json$Decode$int,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'totalFields',
																			$elm$json$Json$Decode$int,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'enabledNetworks',
																				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'locationsCount',
																					$elm$json$Json$Decode$int,
																					$elm$json$Json$Decode$succeed($author$project$DataCompletenessV2$Commands$DataCompletenessStatus))))))))))))))))))))));
var $author$project$DataCompletenessV2$Commands$getMissingDataStatus = F2(
	function (account, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$DataCompletenessV2$Commands$missingDataDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					'api/' + ($author$project$Data$SiteName$toString(account.name) + '/dataCompleteness/missingData'))));
	});
var $author$project$DataCompletenessV2$Dashboard$Update$OnDataCompletenessStatus = function (a) {
	return {$: 'OnDataCompletenessStatus', a: a};
};
var $author$project$DataCompletenessV2$Dashboard$init = function (account) {
	return _Utils_Tuple2(
		$author$project$DataCompletenessV2$Dashboard$Model$init,
		A2($author$project$DataCompletenessV2$Commands$getMissingDataStatus, account, $author$project$DataCompletenessV2$Dashboard$Update$OnDataCompletenessStatus));
};
var $author$project$DataCompletenessV2$Main$DataCompletenessMsg = function (a) {
	return {$: 'DataCompletenessMsg', a: a};
};
var $author$project$DataCompletenessV2$Main$init = F2(
	function (_v0, flags) {
		var _v1 = $author$project$DataCompletenessV2$Dashboard$init(flags.account);
		var dataCompletenessCmd = _v1.b;
		var dataCompleteness = $author$project$DataCompletenessV2$Dashboard$Model$init;
		return _Utils_Tuple2(
			{account: flags.account, dataCompleteness: dataCompleteness},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$DataCompletenessV2$Main$DataCompletenessMsg, dataCompletenessCmd)
					])));
	});
var $author$project$DataCompletenessV2$Dashboard$Update$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$PinMeTo$Ui$Card$withHeader = F2(
	function (header, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Card$View(
			_Utils_update(
				config,
				{
					header: $elm$core$Maybe$Just(header)
				}));
	});
var $author$project$Listings$Ui$InsightsHeader$withPopOver = F2(
	function (popOver, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					popOver: $elm$core$Maybe$Just(popOver)
				}));
	});
var $author$project$PinMeTo$Ui$Card$withSeparator = F2(
	function (hasSeparator, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Card$View(
			_Utils_update(
				config,
				{separator: hasSeparator}));
	});
var $author$project$Translations$Listings$Tasks$whatIsDataCompleteness = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.what_is_data_completeness');
};
var $author$project$Translations$Listings$Dashboard$dataCompletenessPopoverContent = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.data_completeness_popover_content');
};
var $author$project$Translations$Listings$Dashboard$dataCompletenessPagePopoverContent = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.data_completeness_page_popover_content');
};
var $author$project$DataCompletenessV2$Dashboard$View$renderCard = F5(
	function (model, translations, title, isOnTheDashboard, content) {
		var dataCompletenessInfoBox = function () {
			var translationToShow = isOnTheDashboard ? $author$project$Translations$Listings$Dashboard$dataCompletenessPopoverContent(translations) : $author$project$Translations$Listings$Dashboard$dataCompletenessPagePopoverContent(translations);
			return A2(
				$author$project$PinMeTo$Ui$PopOver$withLink,
				{
					href: 'https://help.pinmeto.com/en/article/listings-what-is-data-completeness-1so1qxe/?bust=1717579743144',
					text: $author$project$Translations$Listings$Tasks$whatIsDataCompleteness(translations)
				},
				$author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'data-completeness-info-box',
						tagger: $author$project$DataCompletenessV2$Dashboard$Update$PopOverMsg,
						content: _List_fromArray(
							[
								$elm$html$Html$text(translationToShow)
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					}));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__insights__item'),
					$elm$html$Html$Attributes$class('pmt-dashboard__insights-card')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Card$render(
					A2(
						$author$project$PinMeTo$Ui$Card$withSeparator,
						false,
						A2(
							$author$project$PinMeTo$Ui$Card$withHeader,
							$author$project$Listings$Ui$InsightsHeader$render(
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(dataCompletenessInfoBox, model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{title: title}))),
							$author$project$PinMeTo$Ui$Card$view(content))))
				]));
	});
var $author$project$PinMeTo$Ui$Chart$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$Chart$Numeric = {$: 'Numeric'};
var $author$project$PinMeTo$Ui$Chart$view = function (config) {
	return $author$project$PinMeTo$Ui$Chart$View(
		{chart: config.chart, legend: $elm$core$Maybe$Nothing, locale: $author$project$PinMeTo$Ui$I18n$Locale$EnUs, offsetsX: false, granularity: $elm$core$Maybe$Nothing, valueFormat: $author$project$PinMeTo$Ui$Chart$Numeric, withGradient: true, withoutXAxis: false, withoutYAxis: false, withStackingX: false, withStackingY: false});
};
var $author$project$PinMeTo$Ui$Chart$Gauge = function (a) {
	return {$: 'Gauge', a: a};
};
var $author$project$PinMeTo$Ui$Chart$Legend$encode = function (_v0) {
	var config = _v0.a;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'total',
				$elm$json$Json$Encode$bool(config.total)),
				_Utils_Tuple2(
				'position',
				function () {
					var _v1 = config.position;
					switch (_v1.$) {
						case 'PositionTop':
							return $elm$json$Json$Encode$string('top');
						case 'PositionRight':
							return $elm$json$Json$Encode$string('right');
						default:
							return $elm$json$Json$Encode$string('bottom');
					}
				}())
			]));
};
var $author$project$PinMeTo$Ui$Chart$encodeBoolean = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$PinMeTo$Ui$Chart$chartTypeToString = function (chartType) {
	switch (chartType.$) {
		case 'Line':
			return 'line';
		case 'Bar':
			return 'bar';
		case 'Doughnut':
			return 'doughnut';
		case 'Gauge':
			return 'gauge';
		case 'Pie':
			return 'pie';
		case 'Mixed':
			return 'mixed';
		default:
			return 'area';
	}
};
var $author$project$PinMeTo$Ui$Chart$granularityToString = function (granularity) {
	switch (granularity.$) {
		case 'Day':
			return 'day';
		case 'Week':
			return 'week';
		default:
			return 'month';
	}
};
var $author$project$PinMeTo$Ui$Chart$valueFormatToString = function (valueFormat) {
	switch (valueFormat.$) {
		case 'Numeric':
			return 'numeric';
		case 'Duration':
			return 'duration';
		default:
			return 'percent';
	}
};
var $author$project$PinMeTo$Ui$Chart$encodeData = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(data.key)),
				_Utils_Tuple2(
				'value',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, data.value))
			]));
};
var $author$project$PinMeTo$Ui$Chart$encodeDataItemSeries = function (dataItem) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(dataItem.title)),
				_Utils_Tuple2(
				'color',
				$elm$json$Json$Encode$string(dataItem.color)),
				_Utils_Tuple2(
				'data',
				A2($elm$json$Json$Encode$list, $author$project$PinMeTo$Ui$Chart$encodeData, dataItem.data))
			]));
};
var $author$project$PinMeTo$Ui$Chart$mixableChartTypeToString = function (chartType) {
	switch (chartType.$) {
		case 'MixLine':
			return 'line';
		case 'MixBar':
			return 'bar';
		default:
			return 'area';
	}
};
var $author$project$PinMeTo$Ui$Chart$encodeDataItemsMixed = F2(
	function (chartTypes, dataSeries) {
		var encoder = $elm$json$Json$Encode$list($author$project$PinMeTo$Ui$Chart$encodeDataItemSeries);
		var mapTuple = A2($elm$core$Tuple$mapBoth, $author$project$PinMeTo$Ui$Chart$mixableChartTypeToString, encoder);
		var zipped = A2(
			$elm$core$List$map,
			mapTuple,
			A3($elm$core$List$map2, $elm$core$Tuple$pair, chartTypes, dataSeries));
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(zipped));
	});
var $author$project$PinMeTo$Ui$Chart$encodeDataItemsSeries = function (items) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		A2($elm$json$Json$Encode$list, $author$project$PinMeTo$Ui$Chart$encodeDataItemSeries, items));
};
var $author$project$PinMeTo$Ui$Chart$encodeDataItemSingleValue = function (dataItem) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(dataItem.title)),
				_Utils_Tuple2(
				'color',
				$elm$json$Json$Encode$string(dataItem.color)),
				_Utils_Tuple2(
				'data',
				$elm$json$Json$Encode$int(dataItem.data))
			]));
};
var $author$project$PinMeTo$Ui$Chart$encodeDataItemsSingleValue = function (items) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		A2($elm$json$Json$Encode$list, $author$project$PinMeTo$Ui$Chart$encodeDataItemSingleValue, items));
};
var $author$project$PinMeTo$Ui$Chart$render = function (_v0) {
	var config = _v0.a;
	var datasets = function () {
		var _v1 = config.chart;
		switch (_v1.$) {
			case 'Line':
				var data = _v1.a;
				return $author$project$PinMeTo$Ui$Chart$encodeDataItemsSeries(data);
			case 'Area':
				var data = _v1.a;
				return $author$project$PinMeTo$Ui$Chart$encodeDataItemsSeries(data);
			case 'Bar':
				var data = _v1.a;
				return $author$project$PinMeTo$Ui$Chart$encodeDataItemsSeries(data);
			case 'Doughnut':
				var data = _v1.a;
				return $author$project$PinMeTo$Ui$Chart$encodeDataItemsSingleValue(data);
			case 'Gauge':
				var data = _v1.a;
				return A2(
					$elm$json$Json$Encode$encode,
					0,
					$author$project$PinMeTo$Ui$Chart$encodeDataItemSingleValue(data));
			case 'Pie':
				var data = _v1.a;
				return $author$project$PinMeTo$Ui$Chart$encodeDataItemsSingleValue(data);
			default:
				var typeList = _v1.a;
				var dataLists = _v1.b;
				return A2($author$project$PinMeTo$Ui$Chart$encodeDataItemsMixed, typeList, dataLists);
		}
	}();
	return A3(
		$elm$html$Html$node,
		'pmt-charts-v2',
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'type',
				$author$project$PinMeTo$Ui$Chart$chartTypeToString(config.chart)),
				A2($elm$html$Html$Attributes$attribute, 'add-data', datasets),
				A2(
				$elm$html$Html$Attributes$attribute,
				'without-y-axis',
				$author$project$PinMeTo$Ui$Chart$encodeBoolean(config.withoutYAxis)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'without-x-axis',
				$author$project$PinMeTo$Ui$Chart$encodeBoolean(config.withoutXAxis)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'locale',
				$author$project$PinMeTo$Ui$I18n$Locale$toString(config.locale)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'with-stacking-x',
				$author$project$PinMeTo$Ui$Chart$encodeBoolean(config.withStackingX)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'with-stacking-y',
				$author$project$PinMeTo$Ui$Chart$encodeBoolean(config.withStackingY)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'offsets-x',
				$author$project$PinMeTo$Ui$Chart$encodeBoolean(config.offsetsX)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'value-format',
				$author$project$PinMeTo$Ui$Chart$valueFormatToString(config.valueFormat)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'legend',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$PinMeTo$Ui$Chart$Legend$encode,
							$elm$json$Json$Encode$encode(0)),
						config.legend))),
				A2(
				$elm$html$Html$Attributes$attribute,
				'with-gradient',
				$author$project$PinMeTo$Ui$Chart$encodeBoolean(config.withGradient)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'granularity',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Chart$granularityToString, config.granularity)))
			]),
		_List_Nil);
};
var $author$project$DataCompletenessV2$Dashboard$View$renderDonutChart = function (model) {
	var dataCompletenessPercentage = function () {
		var missingFields = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.totalFieldsMissing;
				},
				$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
		var totalFields = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.totalFields;
				},
				$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
		if ((!missingFields) && (!totalFields)) {
			return 0;
		} else {
			var percentageValue = (missingFields / totalFields) * 100;
			return $elm$core$Basics$floor(100 - percentageValue);
		}
	}();
	var color = (dataCompletenessPercentage < 25) ? '#DB0037' : ((dataCompletenessPercentage < 75) ? '#FFA54D' : '#33CD32');
	var dataItem = {data: dataCompletenessPercentage, color: color, title: 'Completeness'};
	return $author$project$PinMeTo$Ui$Chart$render(
		$author$project$PinMeTo$Ui$Chart$view(
			{
				chart: $author$project$PinMeTo$Ui$Chart$Gauge(dataItem)
			}));
};
var $author$project$DataCompletenessV2$Dashboard$Update$LinkClicked = function (a) {
	return {$: 'LinkClicked', a: a};
};
var $author$project$DataCompletenessV2$Dashboard$View$renderField = F6(
	function (model, siteName, fieldLink, fieldTranslation, isDisconnected, trackingKey) {
		var missingFieldPercentage = function (x) {
			var missingFields = $elm$core$List$length(x);
			var locationCount = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.locationsCount;
					},
					$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
			var percentageValue = (missingFields / locationCount) * 100;
			return ((!missingFields) && (!locationCount)) ? 0 : $elm$core$Basics$floor(100 - percentageValue);
		};
		var missingFieldLink = function (fieldName) {
			return $elm$html$Html$Attributes$href(
				A2(
					$elm$core$String$join,
					'',
					_List_fromArray(
						[
							'/listings/',
							$author$project$Data$SiteName$toString(siteName),
							'/locations',
							'?filter=%7B%22filterDefinition%22:%5B%7B%22property%22:%22missingData%22,%22value%22:%5B%22' + (fieldName + ('\u0022%5D%7D' + (',%7B\u0022property\u0022:\u0022status\u0022,\u0022value\u0022:%5B\u0022temp_closed\u0022,\u0022open\u0022%5D%7D%5D%7D' + '&openFilterOnLoad=true')))
						])));
		};
		var missingFieldData = function (fieldName) {
			switch (fieldName) {
				case 'contact.phone':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.phone;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'openHours':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.openHours;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'contact.email':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.email;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'contact.homepage':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.homepage;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'longDescription':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.longDescription;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'shortDescription':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.shortDescription;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'actionLinks':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.actionLinks;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkAttributes.google':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.googleAttributes;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkMedia.google.coverImage':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.googleCoverImage;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkMedia.google.profileImage':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.googleProfileImage;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkMedia.google.locationImages':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.googleLocationImages;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkMedia.facebook.coverImage':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.facebookCoverImage;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkMedia.facebook.profileImage':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.facebookProfileImage;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkCategories.google':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.googleCategories;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkCategories.facebook':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.facebookCategories;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkCategories.bing':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.bingCategories;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				case 'networkCategories.apple':
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.appleCategories;
							},
							$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
				default:
					return _List_Nil;
			}
		};
		var percentage = missingFieldPercentage(
			missingFieldData(fieldLink));
		return (!isDisconnected) ? _Utils_Tuple2(
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-dashboard__data-completeness-fields'),
						missingFieldLink(fieldLink),
						$elm$html$Html$Events$onClick(
						$author$project$DataCompletenessV2$Dashboard$Update$LinkClicked(trackingKey))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(fieldTranslation)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$ProgressBar$render(
								A2(
									$author$project$PinMeTo$Ui$ProgressBar$withStyle,
									$author$project$PinMeTo$Ui$ProgressBar$ReviewSlim,
									$author$project$PinMeTo$Ui$ProgressBar$view(percentage)))
							]))
					])),
			percentage) : _Utils_Tuple2(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-dashboard__empty-fields')
					]),
				_List_Nil),
			percentage);
	});
var $author$project$Translations$Listings$LocationDetail$categoriesBing = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_bing');
};
var $author$project$Translations$General$locationImages = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_images');
};
var $author$project$Translations$Listings$LocationDetail$categoriesApple = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_apple');
};
var $author$project$Translations$Listings$LocationDetail$categoriesGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_google');
};
var $author$project$DataCompletenessV2$Dashboard$View$EmailMissingField = {$: 'EmailMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$PhoneMissingField = {$: 'PhoneMissingField'};
var $author$project$Translations$Listings$LocationDetail$categoriesFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.categories_facebook');
};
var $author$project$DataCompletenessV2$Dashboard$View$HomepageMissingField = {$: 'HomepageMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$OpenHoursMissingField = {$: 'OpenHoursMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$AttributesMissingField = {$: 'AttributesMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$ActionLinksMissingField = {$: 'ActionLinksMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$BingCategoriesMissingField = {$: 'BingCategoriesMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$AppleCategoriesMissingField = {$: 'AppleCategoriesMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$LongDescriptionMissingField = {$: 'LongDescriptionMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$GoogleCategoriesMissingField = {$: 'GoogleCategoriesMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$GoogleCoverImageMissingField = {$: 'GoogleCoverImageMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$ShortDescriptionMissingField = {$: 'ShortDescriptionMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$FacebookCategoriesMissingField = {$: 'FacebookCategoriesMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$FacebookCoverImageMissingField = {$: 'FacebookCoverImageMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$GoogleProfileImageMissingField = {$: 'GoogleProfileImageMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$FacebookProfileImageMissingField = {$: 'FacebookProfileImageMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$GoogleLocationImagesMissingField = {$: 'GoogleLocationImagesMissingField'};
var $author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey = function (dataCompletenessField) {
	switch (dataCompletenessField.$) {
		case 'PhoneMissingField':
			return {info: 'Opened location list with phone number missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.phoneNumberMissingFieldsDisplayed};
		case 'OpenHoursMissingField':
			return {info: 'Opened location list with Open Hours missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.openHoursMissingFieldsDisplayed};
		case 'EmailMissingField':
			return {info: 'Opened location list with Email missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.emailMissingFieldsDisplayed};
		case 'HomepageMissingField':
			return {info: 'Opened location list with Homepage missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.homepageMissingFieldsDisplayed};
		case 'LongDescriptionMissingField':
			return {info: 'Opened location list with Long Description missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.longDescriptionMissingFieldsDisplayed};
		case 'ShortDescriptionMissingField':
			return {info: 'Opened location list with Short Description missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.shortDescriptionMissingFieldsDisplayed};
		case 'AttributesMissingField':
			return {info: 'Opened location list with Attributes missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.attributesMissingFieldsDisplayed};
		case 'ActionLinksMissingField':
			return {info: 'Opened location list with Action Links missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.actionLinksMissingFieldsDisplayed};
		case 'FacebookProfileImageMissingField':
			return {info: 'Opened location list with Facebook Profile Image missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.facebookProfileImageMissingFieldsDisplayed};
		case 'FacebookCoverImageMissingField':
			return {info: 'Opened location list with Facebook Cover Image missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.facebookCoverImageMissingFieldsDisplayed};
		case 'GoogleProfileImageMissingField':
			return {info: 'Opened location list with Google Profile Image missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.googleProfileImageMissingFieldsDisplayed};
		case 'GoogleCoverImageMissingField':
			return {info: 'Opened location list with Google Cover Image missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.googleCoverImageMissingFieldsDisplayed};
		case 'GoogleCategoriesMissingField':
			return {info: 'Opened location list with Google Categories missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.googleCategoriesMissingFieldsDisplayed};
		case 'GoogleLocationImagesMissingField':
			return {info: 'Opened location list with Google Location Images missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.googleLocationImagesMissingFieldsDisplayed};
		case 'FacebookCategoriesMissingField':
			return {info: 'Opened location list with Facebook Categories missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.facebookCategoriesMissingFieldsDisplayed};
		case 'BingCategoriesMissingField':
			return {info: 'Opened location list with Bing Categories missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.bingCategoriesMissingFieldsDisplayed};
		default:
			return {info: 'Opened location list with Apple Categories missing fields filter', action: $author$project$PlanHat$TrackingActions$keys.dataCompleteness.appleCategoriesMissingFieldsDisplayed};
	}
};
var $author$project$DataCompletenessV2$Dashboard$View$renderFieldsList = F4(
	function (maxItems, model, account, translations) {
		var renderMissingDataField = A2($author$project$DataCompletenessV2$Dashboard$View$renderField, model, account.name);
		var listOfEnabledNetworks = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.enabledNetworks;
				},
				$author$project$RemoteData$currentData(model.dataCompletenessStatus)));
		var isGoogleDisconnected = !A2($elm$core$List$member, 'google', listOfEnabledNetworks);
		var isAppleDisconnected = !A2($elm$core$List$member, 'apple', listOfEnabledNetworks);
		var isBingDisconnected = !A2($elm$core$List$member, 'bing', listOfEnabledNetworks);
		var showLocationMedia = account.features.allowMediaReview;
		var isFbDisconnected = !A2($elm$core$List$member, 'facebook', listOfEnabledNetworks);
		var orderedMissingDataFields = function () {
			var conditionalFields = showLocationMedia ? _List_fromArray(
				[
					A4(
					renderMissingDataField,
					'networkMedia.google.locationImages',
					$author$project$Translations$General$locationImages(translations),
					isGoogleDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$GoogleLocationImagesMissingField))
				]) : _List_Nil;
			var commonFields = _List_fromArray(
				[
					A4(
					renderMissingDataField,
					'openHours',
					$author$project$Translations$General$locationOpenHours(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$OpenHoursMissingField)),
					A4(
					renderMissingDataField,
					'longDescription',
					$author$project$Translations$General$locationLongDescription(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$LongDescriptionMissingField)),
					A4(
					renderMissingDataField,
					'shortDescription',
					$author$project$Translations$General$locationShortDescription(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$ShortDescriptionMissingField)),
					A4(
					renderMissingDataField,
					'contact.homepage',
					$author$project$Translations$General$locationHomepage(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$HomepageMissingField)),
					A4(
					renderMissingDataField,
					'contact.email',
					$author$project$Translations$General$locationEmail(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$EmailMissingField)),
					A4(
					renderMissingDataField,
					'contact.phone',
					$author$project$Translations$General$locationPhone(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$PhoneMissingField)),
					A4(
					renderMissingDataField,
					'actionLinks',
					$author$project$Translations$General$locationActionLinks(translations),
					false,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$ActionLinksMissingField)),
					A4(
					renderMissingDataField,
					'networkAttributes.google',
					$author$project$Translations$General$locationAttributes(translations),
					isGoogleDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$AttributesMissingField)),
					A4(
					renderMissingDataField,
					'networkMedia.google.coverImage',
					$author$project$Translations$General$Insights$google(translations) + (' ' + $author$project$Translations$General$locationCoverImage(translations)),
					isGoogleDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$GoogleCoverImageMissingField)),
					A4(
					renderMissingDataField,
					'networkMedia.google.profileImage',
					$author$project$Translations$General$Insights$google(translations) + (' ' + $author$project$Translations$General$locationLogoImage(translations)),
					isGoogleDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$GoogleProfileImageMissingField)),
					A4(
					renderMissingDataField,
					'networkMedia.facebook.coverImage',
					$author$project$Translations$General$Insights$facebook(translations) + (' ' + $author$project$Translations$General$locationCoverImage(translations)),
					isFbDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$FacebookCoverImageMissingField)),
					A4(
					renderMissingDataField,
					'networkMedia.facebook.profileImage',
					$author$project$Translations$General$Insights$facebook(translations) + (' ' + $author$project$Translations$General$locationProfileImage(translations)),
					isFbDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$FacebookProfileImageMissingField)),
					A4(
					renderMissingDataField,
					'networkCategories.google',
					$author$project$Translations$Listings$LocationDetail$categoriesGoogle(translations),
					isGoogleDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$GoogleCategoriesMissingField)),
					A4(
					renderMissingDataField,
					'networkCategories.facebook',
					$author$project$Translations$Listings$LocationDetail$categoriesFacebook(translations),
					isFbDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$FacebookCategoriesMissingField)),
					A4(
					renderMissingDataField,
					'networkCategories.bing',
					$author$project$Translations$Listings$LocationDetail$categoriesBing(translations),
					isBingDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$BingCategoriesMissingField)),
					A4(
					renderMissingDataField,
					'networkCategories.apple',
					$author$project$Translations$Listings$LocationDetail$categoriesApple(translations),
					isAppleDisconnected,
					$author$project$DataCompletenessV2$Dashboard$View$dataCompletenessFieldToTrackingKey($author$project$DataCompletenessV2$Dashboard$View$AppleCategoriesMissingField))
				]);
			var list = A2($elm$core$List$append, commonFields, conditionalFields);
			return A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$take,
					A2($elm$core$Maybe$withDefault, 30, maxItems),
					A2($elm$core$List$sortBy, $elm$core$Tuple$second, list)));
		}();
		return orderedMissingDataFields;
	});
var $author$project$DataCompletenessV2$Dashboard$View$fullView = F3(
	function (account, model, translations) {
		var content = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__data-completeness__row-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-dashboard__data-completeness__column-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-dashboard__gauge'),
											$elm$html$Html$Attributes$class('pmt-dashboard__gauge-full')
										]),
									_List_fromArray(
										[
											$author$project$DataCompletenessV2$Dashboard$View$renderDonutChart(model)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-dashboard__data-completeness__column-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-summary pmt-dashboard__data-completeness__page-list')
						]),
					A4($author$project$DataCompletenessV2$Dashboard$View$renderFieldsList, $elm$core$Maybe$Nothing, model, account, translations))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__data-completeness')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$DataCompletenessV2$Dashboard$View$renderCard,
					model,
					translations,
					$author$project$Translations$Listings$DataCompleteness$title(translations),
					false,
					content)
				]));
	});
var $author$project$DataCompletenessV2$Main$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$DataCompletenessV2$Main$DataCompletenessMsg,
					A3($author$project$DataCompletenessV2$Dashboard$View$fullView, model.account, model.dataCompleteness, session.translations))
				]));
	});
var $author$project$DataCompletenessV2$Dashboard$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnDataCompletenessStatus':
				if (msg.a.$ === 'Ok') {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dataCompletenessStatus: $author$project$RemoteData$Loaded(data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var errMsg = $author$project$Util$httpErrorToString(err);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dataCompletenessStatus: $author$project$RemoteData$Error(errMsg)
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'DataCompletenessV2.Dashboard.Update', message: 'Failed to decode response OnDataCompletenessStatus'}));
				}
			case 'LinkClicked':
				var trackingInfo = msg.a;
				var cmd = $author$project$PlanHat$PlanHat$track(trackingInfo);
				return _Utils_Tuple2(model, cmd);
			default:
				var msg_ = msg.a;
				var _v1 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$DataCompletenessV2$Dashboard$Update$PopOverMsg, msg_, model.popOverState);
				var popOverState = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: popOverState}),
					cmd);
		}
	});
var $author$project$DataCompletenessV2$Main$update = F3(
	function (_v0, msg, model) {
		var dataCompletenessMsg = msg.a;
		var _v2 = A2($author$project$DataCompletenessV2$Dashboard$Update$update, dataCompletenessMsg, model.dataCompleteness);
		var updatedDataCompleteness = _v2.a;
		var dataCompletenessCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dataCompleteness: updatedDataCompleteness}),
			A2($elm$core$Platform$Cmd$map, $author$project$DataCompletenessV2$Main$DataCompletenessMsg, dataCompletenessCmd));
	});
var $author$project$DataCompletenessV2$Main$Flags = F2(
	function (siteName, account) {
		return {account: account, siteName: siteName};
	});
var $author$project$Data$SiteName$decode = $author$project$PinMeTo$Common$Util$idDecoder($author$project$Data$SiteName$SiteName);
var $author$project$Data$Account$Account = F4(
	function (name, displayName, networks, features) {
		return {name: name, features: features, networks: networks, displayName: displayName};
	});
var $author$project$Data$Account$featuresDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'allowPtvTwoWay',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'allowMediaReview',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'allowAppleCustomName',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'allowCustomStoreNames',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'allowGoogleCustomName',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'allowFacebookCustomName',
						$elm$json$Json$Decode$bool,
						false,
						$elm$json$Json$Decode$succeed($author$project$Data$Account$Features)))))));
var $author$project$Data$Network$Instagram = {$: 'Instagram'};
var $author$project$Data$Network$fromString = function (x) {
	switch (x) {
		case 'facebook':
			return $elm$core$Maybe$Just($author$project$Data$Network$Facebook);
		case 'google':
			return $elm$core$Maybe$Just($author$project$Data$Network$Google);
		case 'bing':
			return $elm$core$Maybe$Just($author$project$Data$Network$Bing);
		case 'apple':
			return $elm$core$Maybe$Just($author$project$Data$Network$Apple);
		case 'factual':
			return $elm$core$Maybe$Just($author$project$Data$Network$Foursquare);
		case 'foursquare':
			return $elm$core$Maybe$Just($author$project$Data$Network$Foursquare);
		case 'overture':
			return $elm$core$Maybe$Just($author$project$Data$Network$Overture);
		case 'here':
			return $elm$core$Maybe$Just($author$project$Data$Network$Here);
		case 'tomtom':
			return $elm$core$Maybe$Just($author$project$Data$Network$Tomtom);
		case 'ptv':
			return $elm$core$Maybe$Just($author$project$Data$Network$Ptv);
		case 'instagram':
			return $elm$core$Maybe$Just($author$project$Data$Network$Instagram);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Network$networkDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Network$fromString, $elm$json$Json$Decode$string);
var $author$project$Data$Network$networkListDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list($author$project$Data$Network$networkDecoder));
var $author$project$Data$Account$accountDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'features',
	$author$project$Data$Account$featuresDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'networks',
		$author$project$Data$Network$networkListDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'displayName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$author$project$Data$SiteName$decode,
				$elm$json$Json$Decode$succeed($author$project$Data$Account$Account)))));
var $author$project$DataCompletenessV2$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account',
	$author$project$Data$Account$accountDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siteName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$DataCompletenessV2$Main$Flags)));
var $author$project$DataCompletenessV2$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$DataCompletenessV2$Main$init,
		view: $author$project$DataCompletenessV2$Main$view,
		update: $author$project$DataCompletenessV2$Main$update,
		flagsDecoder: $author$project$DataCompletenessV2$Main$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$PinMeTo$Deprecated$Lightbox$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Deprecated$Lightbox$Closed = {$: 'Closed'};
var $author$project$PinMeTo$Deprecated$Lightbox$Normal = {$: 'Normal'};
var $author$project$PinMeTo$Deprecated$Lightbox$init = $author$project$PinMeTo$Deprecated$Lightbox$State(
	{openState: $author$project$PinMeTo$Deprecated$Lightbox$Closed, lightBoxStyle: $author$project$PinMeTo$Deprecated$Lightbox$Normal});
var $author$project$PinMeTo$Deprecated$Lightbox$Open = {$: 'Open'};
var $author$project$PinMeTo$Deprecated$Lightbox$open = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Deprecated$Lightbox$State(
		_Utils_update(
			model,
			{openState: $author$project$PinMeTo$Deprecated$Lightbox$Open}));
};
var $author$project$Common$Pagination$Pagination = F4(
	function (currentPage, value, items, data) {
		return {data: data, items: items, value: value, currentPage: currentPage};
	});
var $author$project$Common$Pagination$initWithItems = function (items) {
	return A4($author$project$Common$Pagination$Pagination, 0, 1, items, $elm$core$Dict$empty);
};
var $author$project$Common$Pagination$empty = $author$project$Common$Pagination$initWithItems($elm$core$Array$empty);
var $author$project$Conflicts$Resolver$ConflictStates$empty = $elm$core$Dict$empty;
var $author$project$Conflicts$Resolver$Model$init = F4(
	function (account, fields, editableFields, translations) {
		return {
			meta: {
				googleAttributes: {attributes: _List_Nil},
				googleSupportedServiceItems: _List_Nil
			},
			time: $elm$time$Time$millisToPosix(0),
			config: {
				timeZone: $elm$time$Time$utc,
				locationUrl: function (x) {
					return '/listings/' + ($author$project$Data$SiteName$toString(account.name) + ('/locations/' + x));
				},
				editableFields: editableFields
			},
			editor: $elm$core$Maybe$Nothing,
			fields: fields,
			account: account,
			alertBox: $elm$core$Maybe$Nothing,
			summaries: $elm$core$Maybe$Nothing,
			pagination: $author$project$Common$Pagination$empty,
			uiLightbox: $author$project$PinMeTo$Deprecated$Lightbox$open($author$project$PinMeTo$Deprecated$Lightbox$init),
			imageEditor: $elm$core$Maybe$Nothing,
			pressedKeys: _List_Nil,
			errorMessage: $elm$core$Maybe$Nothing,
			translations: translations,
			selectedPinId: $elm$core$Maybe$Nothing,
			conflictStates: $author$project$Conflicts$Resolver$ConflictStates$empty,
			listingsManagerPoliciesEnabled: $author$project$RemoteData$Loading
		};
	});
var $author$project$Common$Pagination$Left = {$: 'Left'};
var $author$project$Common$Pagination$Right = {$: 'Right'};
var $author$project$Conflicts$Resolver$ConflictStates$reset = F3(
	function (field, locationId, states) {
		return A2(
			$elm$core$Dict$remove,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
	});
var $author$project$Conflicts$Resolver$Types$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$PinMeTo$Deprecated$Lightbox$update = F2(
	function (msg, _v0) {
		var model = _v0.a;
		if (msg.$ === 'ToogleOpenState') {
			var newState = function () {
				var _v2 = model.openState;
				if (_v2.$ === 'Open') {
					return $author$project$PinMeTo$Deprecated$Lightbox$Closed;
				} else {
					return $author$project$PinMeTo$Deprecated$Lightbox$Open;
				}
			}();
			return _Utils_Tuple2(
				$author$project$PinMeTo$Deprecated$Lightbox$State(
					_Utils_update(
						model,
						{openState: newState})),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				$author$project$PinMeTo$Deprecated$Lightbox$State(
					_Utils_update(
						model,
						{openState: $author$project$PinMeTo$Deprecated$Lightbox$Closed})),
				$elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$Task$fail = _Scheduler_fail;
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 'Save', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {current: current, history: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {zoneRules: zoneRules, standardOffset: standardOffset};
	});
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {day: day, time: time, year: year, clock: clock, month: month};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = {$: 'Universal'};
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.history);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.current, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m.$) {
			case 'Jan':
				return 0;
			case 'Feb':
				return 31;
			case 'Mar':
				return 59 + leapDays;
			case 'Apr':
				return 90 + leapDays;
			case 'May':
				return 120 + leapDays;
			case 'Jun':
				return 151 + leapDays;
			case 'Jul':
				return 181 + leapDays;
			case 'Aug':
				return 212 + leapDays;
			case 'Sep':
				return 243 + leapDays;
			case 'Oct':
				return 273 + leapDays;
			case 'Nov':
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var save = _v0.save;
		var standard = _v0.standard;
		switch (clock.$) {
			case 'Universal':
				return 0;
			case 'Standard':
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var time = _v0.time;
	var day = _v0.day;
	var month = _v0.month;
	var year = _v0.year;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.clock, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var initialOffset = {save: 0, standard: standardOffset};
		var initialChange = {
			start: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start),
			offset: standardOffset
		};
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.start;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								save: rule.save,
								clock: rule.clock,
								start: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.day;
										switch (_v2.$) {
											case 'Day':
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, day);
											case 'Next':
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, after));
											case 'Prev':
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.month, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.month));
										}
									}()) + rule.time
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.from, year) < 1) && (_Utils_cmp(year, rule.to) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.year - 1, until.year));
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {save: transition.save, standard: standardOffset};
					if (_Utils_cmp(
						transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, previousOffset),
						initialChange.start) < 1) {
						var updatedInitialChange = {start: initialChange.start, offset: standardOffset + transition.save};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								start: transition.start + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.clock, currentOffset),
								offset: standardOffset + transition.save
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var zoneRules = _v0.zoneRules;
		var standardOffset = _v0.standardOffset;
		if (zoneRules.$ === 'Save') {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						start: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start),
						offset: standardOffset + save
					}
					]),
				{save: save, standard: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.start <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.offset, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.history;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.current;
			}
		}();
		var initialOffset = {
			save: function () {
				var _v4 = initialState.zoneRules;
				if (_v4.$ === 'Save') {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			standard: initialState.standardOffset
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.offset;
			},
			initialOffset.standard + initialOffset.save,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Universal),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Universal),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.standard + initialOffset.save, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aden = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 'Rules', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = {$: 'Standard'};
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = {$: 'WallClock'};
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 'Last', a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {to: to, day: day, from: from, save: save, time: time, clock: clock, month: month};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		300,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 'Day', a: a};
};
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$May, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 'Next', a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 'Prev', a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, $elm$time$Time$Fri, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Thu, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2015,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Aug, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 27, 1, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Aug, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$May, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$May, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 15, 720, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__lome = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$asia__brunei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuwait = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__muscat = $justinmimbs$timezone_data$TimeZone$asia__dubai;
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__kiev = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__oslo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Feb, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Jan, 2, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mahe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__accra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Thu, 1),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Thu),
		1440,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Mar, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__dakar = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bahrain = $justinmimbs$timezone_data$TimeZone$asia__qatar;
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$May, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		150,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		150,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Aug, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Aug, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$May, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 26, 30, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 15, 30, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Mar, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Apr, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 1),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Mar, 31, 1380, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Sep, 26, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vaduz = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$indian__cocos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 1),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sat),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Dec, 29, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 21),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 18),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 12),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wake = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__asmara = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__bamako = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__bangui = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__banjul = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__douala = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__harare = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__kigali = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__luanda = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lusaka = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__malabo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maseru = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__niamey = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$america__curacao = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__aruba = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		$elm$time$Time$Feb,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Feb, 3, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Mon),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Fri, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 9, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jun, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 30, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Oct, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 8, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Sep, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__istanbul = $justinmimbs$timezone_data$TimeZone$europe__istanbul;
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__jersey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1982,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Sep, 26, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Mar, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 12),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__monaco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Nov, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__skopje = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zagreb = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__comoro = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$pacific__chuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1991,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Feb, 10, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__conakry = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__kampala = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__mbabane = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Fri),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$May, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Oct, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Nov, 10, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Oct, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Aug, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Feb, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayman = $justinmimbs$timezone_data$TimeZone$america__panama;
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jul, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Apr, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Oct, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Sep, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Dec, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Dec, 2, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Bahamas = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__nassau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bahamas)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Sep, 8, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, $elm$time$Time$Oct, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Aug, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$May, 4, 1410, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Dec, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vientiane = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__nicosia = $justinmimbs$timezone_data$TimeZone$asia__nicosia;
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Sep, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vatican = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Sep, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Mar, 29, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mayotte = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__reunion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 2),
		240,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Mar, 14, 180, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__majuro = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__midway = $justinmimbs$timezone_data$TimeZone$pacific__pago_pago;
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Dec,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__saipan = $justinmimbs$timezone_data$TimeZone$pacific__guam;
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wallis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__blantyre = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__djibouti = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Apr, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__freetown = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__gaborone = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 15, 720, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kinshasa = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jan, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Mar, 8, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Jan, 1, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jan, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$america__port_of_spain = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__antigua = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Dec, 9, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$May, 1, 150, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__creston = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Apr, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__godthab = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__grenada = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Jun,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Mon, 23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Feb, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__marigot = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__nipigon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1950,
		1973,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tortola = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__phnom_penh = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Sep, 27, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Mar, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__busingen = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$May, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$europe__guernsey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__sarajevo = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__uzhgorod = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		165,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Dec, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Mar, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Oct, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pohnpei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bujumbura = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__mogadishu = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$america__anguilla = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Apr, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
};
var $justinmimbs$timezone_data$TimeZone$america__atikokan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__dominica = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Sep, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Nov, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Mar, 11, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_kitts = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_lucia = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 5, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Feb, 21, 1020, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Mar, 11, 240, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 10, 1200, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Feb, 21, 1200, $justinmimbs$timezone_data$TimeZone$Specification$Universal))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__syowa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Universal,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, $elm$time$Time$Feb, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Jun, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$May, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Jul, 24, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Apr, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Sep, 25, 60, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 9),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		$elm$time$Time$Sep,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Sep, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Sep, 5, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__currie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ljubljana = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__mariehamn = $justinmimbs$timezone_data$TimeZone$europe__helsinki;
var $justinmimbs$timezone_data$TimeZone$europe__podgorica = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__stockholm = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__christmas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__kerguelen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__funafuti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Mar, 16, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Oct, 28, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__libreville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lubumbashi = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__nouakchott = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__porto_novo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Nov, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Sep, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Sep, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, $elm$time$Time$Oct, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Sep, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, $elm$time$Time$Apr, 5, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Sep, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Sep, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Nov, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Apr, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_thomas = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 18, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Mar, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__bratislava = $justinmimbs$timezone_data$TimeZone$europe__prague;
var $justinmimbs$timezone_data$TimeZone$europe__copenhagen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__luxembourg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__san_marino = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jul, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$May, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Mar, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Oct, 27, 180, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, $elm$time$Time$Mar, 30, 60, $justinmimbs$timezone_data$TimeZone$Specification$Universal)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Mar, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zaporozhye = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__enderbury = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Dec, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, $elm$time$Time$Aug, 20, 1440, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Nov,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, $elm$time$Time$Nov, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		180,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$africa__addis_ababa = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__brazzaville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__ouagadougou = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		$elm$time$Time$Jun,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Jan,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sat, 15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Mar, 11, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__guadeloupe = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__kralendijk = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Sep, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Nov, 1, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, $elm$time$Time$Jan, 20, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Jun,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Jul,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		$elm$time$Time$Dec,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Mar, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Dec, 22, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__montserrat = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jun, 24, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, $elm$time$Time$Nov, 10, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_vincent = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo = $justinmimbs$timezone_data$TimeZone$pacific__auckland;
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Dec, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 19, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__st_helena = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$europe__isle_of_man = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, $elm$time$Time$Mar, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, $elm$time$Time$Mar, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$Standard))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, $elm$time$Time$Oct, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, $elm$time$Time$Dec, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, $elm$time$Time$Mar, 8, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Sep, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, $elm$time$Time$Feb, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__pangnirtung = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, $elm$time$Time$Sep, 12, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rainy_river = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		$elm$time$Time$Sep,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$May,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Aug,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Mon, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$america__thunder_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yellowknife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen = $justinmimbs$timezone_data$TimeZone$europe__oslo;
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, $elm$time$Time$Nov, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, $elm$time$Time$Jul, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 15),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		$elm$time$Time$Aug,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		$elm$time$Time$Mar,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$indian__antananarivo = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$america__blanc_sablon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Aug, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, $elm$time$Time$Dec, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, $elm$time$Time$Apr, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, $elm$time$Time$Mar, 29, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Apr, 4, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, $elm$time$Time$Dec, 28, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 31, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Nov, 5, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, $elm$time$Time$Apr, 1, 180, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__lower_princes = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		$elm$time$Time$Feb,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		$elm$time$Time$Jan,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Dec, 3, 60, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_barthelemy = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, $elm$time$Time$Apr, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Apr, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		$elm$time$Time$May,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		$elm$time$Time$Apr,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		60,
		$justinmimbs$timezone_data$TimeZone$Specification$Standard,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		$elm$time$Time$Apr,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		$elm$time$Time$Oct,
		$justinmimbs$timezone_data$TimeZone$Specification$Last($elm$time$Time$Sun),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		$elm$time$Time$Nov,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 1),
		120,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 28, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 17, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 6, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Mar, 11, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 4, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 23, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Sep, 26, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 13, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 30, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$May, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$May, 7, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jul, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		$elm$time$Time$Mar,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		$elm$time$Time$Oct,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, $elm$time$Time$Sun, 8),
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$WallClock,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Mar, 14, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, $elm$time$Time$Oct, 15, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$May, 31, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jul, 25, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Jan, 21, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, $elm$time$Time$Oct, 11, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, $elm$time$Time$Oct, 30, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Apr, 2, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, $elm$time$Time$Nov, 4, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, $elm$time$Time$Oct, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Jan, 6, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, $elm$time$Time$Oct, 27, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Oct, 29, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, $elm$time$Time$Nov, 7, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, $elm$time$Time$Oct, 25, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, $elm$time$Time$Jan, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, $elm$time$Time$Oct, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, $elm$time$Time$Mar, 3, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 1, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, $elm$time$Time$Jun, 20, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, $elm$time$Time$Oct, 18, 0, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, $elm$time$Time$Oct, 26, 120, $justinmimbs$timezone_data$TimeZone$Specification$WallClock))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Accra', $justinmimbs$timezone_data$TimeZone$africa__accra),
			_Utils_Tuple2('Africa/Addis_Ababa', $justinmimbs$timezone_data$TimeZone$africa__addis_ababa),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Asmara', $justinmimbs$timezone_data$TimeZone$africa__asmara),
			_Utils_Tuple2('Africa/Bamako', $justinmimbs$timezone_data$TimeZone$africa__bamako),
			_Utils_Tuple2('Africa/Bangui', $justinmimbs$timezone_data$TimeZone$africa__bangui),
			_Utils_Tuple2('Africa/Banjul', $justinmimbs$timezone_data$TimeZone$africa__banjul),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Blantyre', $justinmimbs$timezone_data$TimeZone$africa__blantyre),
			_Utils_Tuple2('Africa/Brazzaville', $justinmimbs$timezone_data$TimeZone$africa__brazzaville),
			_Utils_Tuple2('Africa/Bujumbura', $justinmimbs$timezone_data$TimeZone$africa__bujumbura),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/Conakry', $justinmimbs$timezone_data$TimeZone$africa__conakry),
			_Utils_Tuple2('Africa/Dakar', $justinmimbs$timezone_data$TimeZone$africa__dakar),
			_Utils_Tuple2('Africa/Dar_es_Salaam', $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam),
			_Utils_Tuple2('Africa/Djibouti', $justinmimbs$timezone_data$TimeZone$africa__djibouti),
			_Utils_Tuple2('Africa/Douala', $justinmimbs$timezone_data$TimeZone$africa__douala),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Freetown', $justinmimbs$timezone_data$TimeZone$africa__freetown),
			_Utils_Tuple2('Africa/Gaborone', $justinmimbs$timezone_data$TimeZone$africa__gaborone),
			_Utils_Tuple2('Africa/Harare', $justinmimbs$timezone_data$TimeZone$africa__harare),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Kampala', $justinmimbs$timezone_data$TimeZone$africa__kampala),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Kigali', $justinmimbs$timezone_data$TimeZone$africa__kigali),
			_Utils_Tuple2('Africa/Kinshasa', $justinmimbs$timezone_data$TimeZone$africa__kinshasa),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Libreville', $justinmimbs$timezone_data$TimeZone$africa__libreville),
			_Utils_Tuple2('Africa/Lome', $justinmimbs$timezone_data$TimeZone$africa__lome),
			_Utils_Tuple2('Africa/Luanda', $justinmimbs$timezone_data$TimeZone$africa__luanda),
			_Utils_Tuple2('Africa/Lubumbashi', $justinmimbs$timezone_data$TimeZone$africa__lubumbashi),
			_Utils_Tuple2('Africa/Lusaka', $justinmimbs$timezone_data$TimeZone$africa__lusaka),
			_Utils_Tuple2('Africa/Malabo', $justinmimbs$timezone_data$TimeZone$africa__malabo),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Maseru', $justinmimbs$timezone_data$TimeZone$africa__maseru),
			_Utils_Tuple2('Africa/Mbabane', $justinmimbs$timezone_data$TimeZone$africa__mbabane),
			_Utils_Tuple2('Africa/Mogadishu', $justinmimbs$timezone_data$TimeZone$africa__mogadishu),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Niamey', $justinmimbs$timezone_data$TimeZone$africa__niamey),
			_Utils_Tuple2('Africa/Nouakchott', $justinmimbs$timezone_data$TimeZone$africa__nouakchott),
			_Utils_Tuple2('Africa/Ouagadougou', $justinmimbs$timezone_data$TimeZone$africa__ouagadougou),
			_Utils_Tuple2('Africa/Porto-Novo', $justinmimbs$timezone_data$TimeZone$africa__porto_novo),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Anguilla', $justinmimbs$timezone_data$TimeZone$america__anguilla),
			_Utils_Tuple2('America/Antigua', $justinmimbs$timezone_data$TimeZone$america__antigua),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Aruba', $justinmimbs$timezone_data$TimeZone$america__aruba),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Atikokan', $justinmimbs$timezone_data$TimeZone$america__atikokan),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Blanc-Sablon', $justinmimbs$timezone_data$TimeZone$america__blanc_sablon),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Cayman', $justinmimbs$timezone_data$TimeZone$america__cayman),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Creston', $justinmimbs$timezone_data$TimeZone$america__creston),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Curacao', $justinmimbs$timezone_data$TimeZone$america__curacao),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Dominica', $justinmimbs$timezone_data$TimeZone$america__dominica),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Godthab', $justinmimbs$timezone_data$TimeZone$america__godthab),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Grenada', $justinmimbs$timezone_data$TimeZone$america__grenada),
			_Utils_Tuple2('America/Guadeloupe', $justinmimbs$timezone_data$TimeZone$america__guadeloupe),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/Kralendijk', $justinmimbs$timezone_data$TimeZone$america__kralendijk),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Lower_Princes', $justinmimbs$timezone_data$TimeZone$america__lower_princes),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Marigot', $justinmimbs$timezone_data$TimeZone$america__marigot),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/Montserrat', $justinmimbs$timezone_data$TimeZone$america__montserrat),
			_Utils_Tuple2('America/Nassau', $justinmimbs$timezone_data$TimeZone$america__nassau),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nipigon', $justinmimbs$timezone_data$TimeZone$america__nipigon),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Pangnirtung', $justinmimbs$timezone_data$TimeZone$america__pangnirtung),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Port_of_Spain', $justinmimbs$timezone_data$TimeZone$america__port_of_spain),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rainy_River', $justinmimbs$timezone_data$TimeZone$america__rainy_river),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Barthelemy', $justinmimbs$timezone_data$TimeZone$america__st_barthelemy),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/St_Kitts', $justinmimbs$timezone_data$TimeZone$america__st_kitts),
			_Utils_Tuple2('America/St_Lucia', $justinmimbs$timezone_data$TimeZone$america__st_lucia),
			_Utils_Tuple2('America/St_Thomas', $justinmimbs$timezone_data$TimeZone$america__st_thomas),
			_Utils_Tuple2('America/St_Vincent', $justinmimbs$timezone_data$TimeZone$america__st_vincent),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Thunder_Bay', $justinmimbs$timezone_data$TimeZone$america__thunder_bay),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Tortola', $justinmimbs$timezone_data$TimeZone$america__tortola),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('America/Yellowknife', $justinmimbs$timezone_data$TimeZone$america__yellowknife),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/DumontDUrville', $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/McMurdo', $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Syowa', $justinmimbs$timezone_data$TimeZone$antarctica__syowa),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Arctic/Longyearbyen', $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen),
			_Utils_Tuple2('Asia/Aden', $justinmimbs$timezone_data$TimeZone$asia__aden),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Bahrain', $justinmimbs$timezone_data$TimeZone$asia__bahrain),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Brunei', $justinmimbs$timezone_data$TimeZone$asia__brunei),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Choibalsan', $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Istanbul', $justinmimbs$timezone_data$TimeZone$asia__istanbul),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuala_Lumpur', $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Kuwait', $justinmimbs$timezone_data$TimeZone$asia__kuwait),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Muscat', $justinmimbs$timezone_data$TimeZone$asia__muscat),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Phnom_Penh', $justinmimbs$timezone_data$TimeZone$asia__phnom_penh),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vientiane', $justinmimbs$timezone_data$TimeZone$asia__vientiane),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/Reykjavik', $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/St_Helena', $justinmimbs$timezone_data$TimeZone$atlantic__st_helena),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Currie', $justinmimbs$timezone_data$TimeZone$australia__currie),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Amsterdam', $justinmimbs$timezone_data$TimeZone$europe__amsterdam),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Bratislava', $justinmimbs$timezone_data$TimeZone$europe__bratislava),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Busingen', $justinmimbs$timezone_data$TimeZone$europe__busingen),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Copenhagen', $justinmimbs$timezone_data$TimeZone$europe__copenhagen),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Guernsey', $justinmimbs$timezone_data$TimeZone$europe__guernsey),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Isle_of_Man', $justinmimbs$timezone_data$TimeZone$europe__isle_of_man),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Jersey', $justinmimbs$timezone_data$TimeZone$europe__jersey),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kiev', $justinmimbs$timezone_data$TimeZone$europe__kiev),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/Ljubljana', $justinmimbs$timezone_data$TimeZone$europe__ljubljana),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Luxembourg', $justinmimbs$timezone_data$TimeZone$europe__luxembourg),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Mariehamn', $justinmimbs$timezone_data$TimeZone$europe__mariehamn),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Monaco', $justinmimbs$timezone_data$TimeZone$europe__monaco),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Nicosia', $justinmimbs$timezone_data$TimeZone$europe__nicosia),
			_Utils_Tuple2('Europe/Oslo', $justinmimbs$timezone_data$TimeZone$europe__oslo),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Podgorica', $justinmimbs$timezone_data$TimeZone$europe__podgorica),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/San_Marino', $justinmimbs$timezone_data$TimeZone$europe__san_marino),
			_Utils_Tuple2('Europe/Sarajevo', $justinmimbs$timezone_data$TimeZone$europe__sarajevo),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Skopje', $justinmimbs$timezone_data$TimeZone$europe__skopje),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Stockholm', $justinmimbs$timezone_data$TimeZone$europe__stockholm),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Uzhgorod', $justinmimbs$timezone_data$TimeZone$europe__uzhgorod),
			_Utils_Tuple2('Europe/Vaduz', $justinmimbs$timezone_data$TimeZone$europe__vaduz),
			_Utils_Tuple2('Europe/Vatican', $justinmimbs$timezone_data$TimeZone$europe__vatican),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zagreb', $justinmimbs$timezone_data$TimeZone$europe__zagreb),
			_Utils_Tuple2('Europe/Zaporozhye', $justinmimbs$timezone_data$TimeZone$europe__zaporozhye),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Antananarivo', $justinmimbs$timezone_data$TimeZone$indian__antananarivo),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Christmas', $justinmimbs$timezone_data$TimeZone$indian__christmas),
			_Utils_Tuple2('Indian/Cocos', $justinmimbs$timezone_data$TimeZone$indian__cocos),
			_Utils_Tuple2('Indian/Comoro', $justinmimbs$timezone_data$TimeZone$indian__comoro),
			_Utils_Tuple2('Indian/Kerguelen', $justinmimbs$timezone_data$TimeZone$indian__kerguelen),
			_Utils_Tuple2('Indian/Mahe', $justinmimbs$timezone_data$TimeZone$indian__mahe),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Indian/Mayotte', $justinmimbs$timezone_data$TimeZone$indian__mayotte),
			_Utils_Tuple2('Indian/Reunion', $justinmimbs$timezone_data$TimeZone$indian__reunion),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Chuuk', $justinmimbs$timezone_data$TimeZone$pacific__chuuk),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Enderbury', $justinmimbs$timezone_data$TimeZone$pacific__enderbury),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Funafuti', $justinmimbs$timezone_data$TimeZone$pacific__funafuti),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Majuro', $justinmimbs$timezone_data$TimeZone$pacific__majuro),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Midway', $justinmimbs$timezone_data$TimeZone$pacific__midway),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Pohnpei', $justinmimbs$timezone_data$TimeZone$pacific__pohnpei),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Saipan', $justinmimbs$timezone_data$TimeZone$pacific__saipan),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu),
			_Utils_Tuple2('Pacific/Wake', $justinmimbs$timezone_data$TimeZone$pacific__wake),
			_Utils_Tuple2('Pacific/Wallis', $justinmimbs$timezone_data$TimeZone$pacific__wallis)
		]));
var $justinmimbs$timezone_data$TimeZone$NoZoneName = {$: 'NoZoneName'};
var $elm$time$Time$getZoneName = _Time_getZoneName(_Utils_Tuple0);
var $justinmimbs$timezone_data$TimeZone$NoDataForZoneName = function (a) {
	return {$: 'NoDataForZoneName', a: a};
};
var $justinmimbs$timezone_data$TimeZone$getZone = A2(
	$elm$core$Task$andThen,
	function (nameOrOffset) {
		if (nameOrOffset.$ === 'Name') {
			var zoneName = nameOrOffset.a;
			var _v1 = A2($elm$core$Dict$get, zoneName, $justinmimbs$timezone_data$TimeZone$zones);
			if (_v1.$ === 'Just') {
				var zone = _v1.a;
				return $elm$core$Task$succeed(
					_Utils_Tuple2(
						zoneName,
						zone(_Utils_Tuple0)));
			} else {
				return $elm$core$Task$fail(
					$justinmimbs$timezone_data$TimeZone$NoDataForZoneName(zoneName));
			}
		} else {
			return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoZoneName);
		}
	},
	$elm$time$Time$getZoneName);
var $author$project$Conflicts$Resolver$ConflictStates$ResolvedLocal = function (a) {
	return {$: 'ResolvedLocal', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$resolve = F3(
	function (field, location, states) {
		return A3(
			$elm$core$Dict$insert,
			_Utils_Tuple2(
				location.id,
				$author$project$Data$Location$Field$toString(field)),
			{
				error: $elm$core$Maybe$Nothing,
				state: $author$project$Conflicts$Resolver$ConflictStates$ResolvedLocal(location),
				selected: $elm$core$Maybe$Nothing
			},
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$deSelect = F3(
	function (field, locationId, states) {
		return A3(
			$elm$core$Dict$update,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			function (x) {
				return A2(
					$elm$core$Maybe$map,
					function (x_) {
						return _Utils_update(
							x_,
							{selected: $elm$core$Maybe$Nothing});
					},
					x);
			},
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$WithError = {$: 'WithError'};
var $author$project$Conflicts$Resolver$ConflictStates$ConflictErrorWithDetails = function (a) {
	return {$: 'ConflictErrorWithDetails', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$failWork = F2(
	function (workErrors, states) {
		var addErrorForMatchingWorkId = F2(
			function (v, failedWorkId) {
				return _Utils_eq(failedWorkId, workErrors.id) ? {
					error: $elm$core$Maybe$Just(
						$author$project$Conflicts$Resolver$ConflictStates$ConflictErrorWithDetails(workErrors)),
					state: $author$project$Conflicts$Resolver$ConflictStates$WithError,
					selected: $elm$core$Maybe$Nothing
				} : v;
			});
		return A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, v) {
					var _v1 = v.state;
					switch (_v1.$) {
						case 'WorkingLocal':
							var workId = _v1.b;
							return A2(addErrorForMatchingWorkId, v, workId);
						case 'WorkingNetwork':
							var workId = _v1.c;
							return A2(addErrorForMatchingWorkId, v, workId);
						default:
							return v;
					}
				}),
			states);
	});
var $author$project$Common$Pagination$itemAt = F2(
	function (x, pagination) {
		return A2($elm$core$Array$get, x, pagination.items);
	});
var $author$project$Common$Pagination$pageSize = 20;
var $author$project$Common$Pagination$itemsInRange = F3(
	function (from, to, items) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				function (x) {
					return A2($elm$core$Array$get, x, items);
				},
				A2(
					$elm$core$List$range,
					A2($elm$core$Basics$min, from, to),
					A2($elm$core$Basics$max, from, to))));
	});
var $author$project$Common$Pagination$needsToLoad = F2(
	function (direction, pagination) {
		var itemsToLoad = function () {
			if (direction.$ === 'Right') {
				return $author$project$Common$Pagination$pageSize - 1;
			} else {
				return -($author$project$Common$Pagination$pageSize - 1);
			}
		}();
		var findMissing = function (keys) {
			findMissing:
			while (true) {
				if (keys.b) {
					var x = keys.a;
					var xs = keys.b;
					var _v1 = A2($author$project$Common$Pagination$itemAt, x, pagination);
					if (_v1.$ === 'Just') {
						var y = _v1.a;
						var _v2 = A2($elm$core$Dict$get, y, pagination.data);
						if (_v2.$ === 'Just') {
							var z = _v2.a;
							switch (z.$) {
								case 'Loaded':
									var $temp$keys = xs;
									keys = $temp$keys;
									continue findMissing;
								case 'Loading':
									var $temp$keys = xs;
									keys = $temp$keys;
									continue findMissing;
								default:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(x, y));
							}
						} else {
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(x, y));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		var indexes = function () {
			if (direction.$ === 'Right') {
				return A2($elm$core$List$range, pagination.currentPage, pagination.currentPage + (($author$project$Common$Pagination$pageSize / 2) | 0));
			} else {
				return $elm$core$List$reverse(
					A2($elm$core$List$range, pagination.currentPage - (($author$project$Common$Pagination$pageSize / 2) | 0), pagination.currentPage));
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (_v4) {
				var index = _v4.a;
				var item = _v4.b;
				return _Utils_Tuple3(
					index,
					item,
					A3($author$project$Common$Pagination$itemsInRange, index, index + itemsToLoad, pagination.items));
			},
			findMissing(indexes));
	});
var $author$project$Common$Pagination$load = F2(
	function (direction, pagination) {
		var remoteDataLoading = function (x) {
			if (x.$ === 'Just') {
				var remoteData = x.a;
				switch (remoteData.$) {
					case 'Suspended':
						return $elm$core$Maybe$Just($author$project$RemoteData$Loading);
					case 'Error':
						return $elm$core$Maybe$Just($author$project$RemoteData$Loading);
					default:
						return $elm$core$Maybe$Just(remoteData);
				}
			} else {
				return $elm$core$Maybe$Just($author$project$RemoteData$Loading);
			}
		};
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var item = _v0.b;
				var items = _v0.c;
				return _Utils_Tuple2(
					_Utils_update(
						pagination,
						{
							data: A3(
								$elm$core$List$foldl,
								F2(
									function (x, a) {
										return A3($elm$core$Dict$update, x, remoteDataLoading, a);
									}),
								pagination.data,
								items)
						}),
					item);
			},
			A2($author$project$Common$Pagination$needsToLoad, direction, pagination));
	});
var $author$project$Conflicts$Resolver$Types$OnLocations = function (a) {
	return {$: 'OnLocations', a: a};
};
var $author$project$Conflicts$Commands$locationsWithConflictsDecoder = function (features) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['places']),
		$elm$json$Json$Decode$list(
			A2($author$project$Data$Location$locationDecoder, features, $elm$core$Maybe$Nothing)));
};
var $author$project$Conflicts$Commands$toUniqueDataDiffValidationFieldString = function (fields) {
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function (field) {
					switch (field.$) {
						case 'Name':
							return 'name';
						case 'CustomName':
							return 'name';
						case 'OpeningDate':
							return 'openingDate';
						case 'StoreId':
							return 'storeId';
						case 'LocationDescriptor':
							return 'locationDescriptor';
						case 'Location':
							return 'location';
						case 'About':
							return 'about';
						case 'LongDescription':
							return 'longDescription';
						case 'Hours':
							return 'hours';
						case 'SpecialHours':
							return 'specialOpenHours';
						case 'PermanentlyClosed':
							return 'permanentlyClosed';
						case 'TemporarilyClosedUntil':
							return 'temporarilyClosedUntil';
						case 'Email':
							return 'email';
						case 'Homepage':
							return 'homepage';
						case 'Phone':
							return 'phoneNumber';
						case 'Address':
							return 'address';
						case 'CoverImage':
							return 'images';
						case 'ProfileImage':
							return 'images';
						case 'NetworkCategories':
							return 'networkCategories';
						case 'NetworkAttributes':
							return 'networkAttributes';
						case 'ActionLinks':
							return 'networkActionLinks';
						case 'NetworkServiceItems':
							return 'networkServiceItems';
						case 'ServiceAreas':
							return 'serviceAreas';
						case 'Wifi':
							return 'wifiSsid';
						default:
							var s = field.a;
							return s;
					}
				},
				fields)));
};
var $author$project$Conflicts$Commands$getLocations = F6(
	function (account, fields, page, limit, forward, msg) {
		var forwardQuery = forward ? '' : '&reverse=true';
		var limitQuery = '&limit=' + $elm$core$String$fromInt(limit);
		var route = $elm$core$List$isEmpty(fields) ? ('/conflicts/location/' + page) : ('/conflicts?fields=' + (A2(
			$elm$core$String$join,
			',',
			$author$project$Conflicts$Commands$toUniqueDataDiffValidationFieldString(fields)) + ('&page=' + (page + (forwardQuery + limitQuery)))));
		var url = 'api/' + ($author$project$Data$SiteName$toString(account.name) + route);
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Conflicts$Commands$locationsWithConflictsDecoder(account.features),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Conflicts$Resolver$Update$paginate = F5(
	function (account, maybeLocationId, fields, direction, pagination) {
		if (maybeLocationId.$ === 'Just') {
			var locationId = maybeLocationId.a;
			return _Utils_Tuple2(
				pagination,
				A6(
					$author$project$Conflicts$Commands$getLocations,
					account,
					_List_Nil,
					locationId,
					0,
					_Utils_eq(direction, $author$project$Common$Pagination$Right),
					$author$project$Conflicts$Resolver$Types$OnLocations));
		} else {
			var _v1 = A2($author$project$Common$Pagination$load, direction, pagination);
			if (_v1.$ === 'Just') {
				var _v2 = _v1.a;
				var newPagination = _v2.a;
				var page = _v2.b;
				return _Utils_Tuple2(
					newPagination,
					A6(
						$author$project$Conflicts$Commands$getLocations,
						account,
						fields,
						page,
						$author$project$Common$Pagination$pageSize,
						_Utils_eq(direction, $author$project$Common$Pagination$Right),
						$author$project$Conflicts$Resolver$Types$OnLocations));
			} else {
				return _Utils_Tuple2(pagination, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Data$Work$WorkError = F4(
	function (reason, network, properties, details) {
		return {reason: reason, details: details, network: network, properties: properties};
	});
var $author$project$Conflicts$Resolver$ConflictStates$EditingLocal = function (a) {
	return {$: 'EditingLocal', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$isEditingLocal = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			if (_v1.$ === 'EditingLocal') {
				var data = _v1.a;
				return _Utils_eq(data.id, locationId);
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$editLocal = F3(
	function (field, location, states) {
		return A3($author$project$Conflicts$Resolver$ConflictStates$isEditingLocal, field, location.id, states) ? A2(
			$elm$core$Dict$remove,
			_Utils_Tuple2(
				location.id,
				$author$project$Data$Location$Field$toString(field)),
			states) : A3(
			$elm$core$Dict$insert,
			_Utils_Tuple2(
				location.id,
				$author$project$Data$Location$Field$toString(field)),
			{
				error: $elm$core$Maybe$Nothing,
				state: $author$project$Conflicts$Resolver$ConflictStates$EditingLocal(location),
				selected: $elm$core$Maybe$Nothing
			},
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$isEditing = $author$project$Conflicts$Resolver$ConflictStates$isEditingLocal;
var $author$project$Common$Pagination$pageCount = function (x) {
	return $elm$core$Array$length(x.items);
};
var $author$project$Conflicts$Resolver$ConflictStates$SavingLocal = {$: 'SavingLocal'};
var $author$project$Conflicts$Resolver$ConflictStates$saveLocal = F3(
	function (field, locationId, states) {
		return A3(
			$elm$core$Dict$insert,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			{error: $elm$core$Maybe$Nothing, state: $author$project$Conflicts$Resolver$ConflictStates$SavingLocal, selected: $elm$core$Maybe$Nothing},
			states);
	});
var $author$project$Conflicts$Resolver$Types$OnSaveLocal = F3(
	function (a, b, c) {
		return {$: 'OnSaveLocal', a: a, b: b, c: c};
	});
var $author$project$Conflicts$Resolver$ConflictStates$editedLocation = F3(
	function (field, location, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				location.id,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			if (_v1.$ === 'EditingLocal') {
				var edited = _v1.a;
				return edited;
			} else {
				return location;
			}
		} else {
			return location;
		}
	});
var $author$project$Conflicts$Commands$PartialUpdateResult = F5(
	function (success, locationId, location, workId, fields) {
		return {fields: fields, workId: workId, success: success, location: location, locationId: locationId};
	});
var $author$project$Conflicts$Commands$partialUpdateResultDecoder = F2(
	function (features, fields) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			fields,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['data', 'workId']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['data', 'place']),
					A2($author$project$Data$Location$locationDecoder, features, $elm$core$Maybe$Nothing),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['data', 'place', '_id']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'success',
							$elm$json$Json$Decode$bool,
							$elm$json$Json$Decode$succeed($author$project$Conflicts$Commands$PartialUpdateResult))))));
	});
var $author$project$Conflicts$Commands$updateFieldsInLocation = F4(
	function (account, fields, location, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$Conflicts$Commands$partialUpdateResultDecoder, account.features, fields),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A2($author$project$Data$Location$fieldsInLocationEncoder, fields, location),
					$lukewestby$elm_http_builder$HttpBuilder$post(
						'api/' + ($author$project$Data$SiteName$toString(account.name) + ('/conflicts/resolve/' + (location.id + '/pinmeto')))))));
	});
var $author$project$Data$GoogleAttributes$Api$keepOurAttributesAsTheTruth = F3(
	function (siteName, locationId, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				$lukewestby$elm_http_builder$HttpBuilder$post(
					A2($author$project$Data$GoogleAttributes$Api$locationUrl, siteName, locationId) + '/google/attributes/keepOurs')));
	});
var $author$project$Conflicts$Commands$keepOurGoogleAttributesAsTheTruth = F4(
	function (account, field, locationId, msg) {
		return A3(
			$author$project$Data$GoogleAttributes$Api$keepOurAttributesAsTheTruth,
			account.name,
			locationId,
			A3(
				$author$project$PinMeTo$ExpectJson$expectJson,
				msg,
				A2(
					$author$project$Conflicts$Commands$partialUpdateResultDecoder,
					account.features,
					_List_fromArray(
						[field])),
				$elm$json$Json$Decode$string));
	});
var $author$project$Conflicts$Resolver$Update$saveLocal = F3(
	function (field, location, model) {
		var publishLocation = function (model_) {
			var location_ = A3($author$project$Conflicts$Resolver$ConflictStates$editedLocation, field, location, model_.conflictStates);
			return _Utils_update(
				location_,
				{
					specialOpenHours: A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, location_.specialOpenHours, model_.time)
				});
		};
		var updatedModel = _Utils_update(
			model,
			{
				selectedPinId: _Utils_eq(field, $author$project$Data$Location$Field$Location) ? $elm$core$Maybe$Just('pinmeto') : model.selectedPinId,
				conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$saveLocal, field, location.id, model.conflictStates)
			});
		return _Utils_Tuple2(
			updatedModel,
			function () {
				if (field.$ === 'NetworkAttributes') {
					return A4(
						$author$project$Conflicts$Commands$keepOurGoogleAttributesAsTheTruth,
						updatedModel.account,
						field,
						location.id,
						A2($author$project$Conflicts$Resolver$Types$OnSaveLocal, field, location.id));
				} else {
					return A4(
						$author$project$Conflicts$Commands$updateFieldsInLocation,
						updatedModel.account,
						_List_fromArray(
							[field]),
						publishLocation(updatedModel),
						function (x) {
							return A3($author$project$Conflicts$Resolver$Types$OnSaveLocal, field, location.id, x);
						});
				}
			}());
	});
var $author$project$Translations$Listings$Conflicts$workError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.work_error');
};
var $author$project$Conflicts$Resolver$ConflictStates$setState = F2(
	function (state, conflict) {
		if (conflict.$ === 'Just') {
			var conflict_ = conflict.a;
			return $elm$core$Maybe$Just(
				_Utils_update(
					conflict_,
					{state: state, selected: $elm$core$Maybe$Nothing}));
		} else {
			return $elm$core$Maybe$Just(
				{error: $elm$core$Maybe$Nothing, state: state, selected: $elm$core$Maybe$Nothing});
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$WorkingLocal = F2(
	function (a, b) {
		return {$: 'WorkingLocal', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$ConflictStates$workLocal = F4(
	function (workId, field, location, states) {
		return A3(
			$elm$core$Dict$update,
			_Utils_Tuple2(
				location.id,
				$author$project$Data$Location$Field$toString(field)),
			function (x) {
				return A2(
					$author$project$Conflicts$Resolver$ConflictStates$setState,
					A2($author$project$Conflicts$Resolver$ConflictStates$WorkingLocal, location, workId),
					x);
			},
			states);
	});
var $author$project$Conflicts$Resolver$Types$OnTimeZone = function (a) {
	return {$: 'OnTimeZone', a: a};
};
var $author$project$Data$Work$WorkErrors = F2(
	function (id, errors) {
		return {id: id, errors: errors};
	});
var $author$project$Common$Pagination$changePage = F2(
	function (newPage, pagination) {
		return _Utils_update(
			pagination,
			{value: newPage + 1, currentPage: newPage});
	});
var $author$project$Data$Location$Field$Name = {$: 'Name'};
var $author$project$Data$Location$Field$StoreId = {$: 'StoreId'};
var $author$project$Data$Location$Field$Unhandled = function (a) {
	return {$: 'Unhandled', a: a};
};
var $author$project$Data$Location$Field$CoverImage = function (a) {
	return {$: 'CoverImage', a: a};
};
var $author$project$Data$Location$Field$CustomName = function (a) {
	return {$: 'CustomName', a: a};
};
var $author$project$Data$Location$Field$ActionLinks = {$: 'ActionLinks'};
var $author$project$Data$Location$Field$OpeningDate = {$: 'OpeningDate'};
var $author$project$Data$Location$Field$ProfileImage = function (a) {
	return {$: 'ProfileImage', a: a};
};
var $author$project$Data$Location$Field$ServiceAreas = {$: 'ServiceAreas'};
var $author$project$Data$Location$Field$NetworkAttributes = function (a) {
	return {$: 'NetworkAttributes', a: a};
};
var $author$project$Data$Location$Field$NetworkCategories = function (a) {
	return {$: 'NetworkCategories', a: a};
};
var $author$project$Data$Location$Field$LocationDescriptor = {$: 'LocationDescriptor'};
var $author$project$Data$Location$Field$NetworkServiceItems = function (a) {
	return {$: 'NetworkServiceItems', a: a};
};
var $author$project$Data$Location$Field$TemporarilyClosedUntil = {$: 'TemporarilyClosedUntil'};
var $author$project$Data$Location$Field$fromString = function (s) {
	switch (s) {
		case 'name':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Name);
		case 'customNameFacebook':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$CustomName($author$project$Data$Network$Facebook));
		case 'customNameGoogle':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$CustomName($author$project$Data$Network$Google));
		case 'storeId':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$StoreId);
		case 'locationDescriptor':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$LocationDescriptor);
		case 'location':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Location);
		case 'shortDescription':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$About);
		case 'longDescription':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$LongDescription);
		case 'hours':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Hours);
		case 'openingDate':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$OpeningDate);
		case 'specialHours':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$SpecialHours);
		case 'permanentlyClosed':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$PermanentlyClosed);
		case 'temporarilyClosedUntil':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$TemporarilyClosedUntil);
		case 'email':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Email);
		case 'homepage':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Homepage);
		case 'phone':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Phone);
		case 'address':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$Address);
		case 'coverImageFacebook':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$CoverImage($author$project$Data$Network$Facebook));
		case 'profileImageFacebook':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$ProfileImage($author$project$Data$Network$Facebook));
		case 'coverImageGoogle':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$CoverImage($author$project$Data$Network$Google));
		case 'profileImageGoogle':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$ProfileImage($author$project$Data$Network$Google));
		case 'networkCategoriesGoogle':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Google));
		case 'networkCategoriesFacebook':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Facebook));
		case 'networkCategoriesBing':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Bing));
		case 'networkCategoriesApple':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Apple));
		case 'networkAttributesGoogle':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$NetworkAttributes($author$project$Data$Network$Google));
		case 'actionLinks':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$ActionLinks);
		case 'serviceAreas':
			return $elm$core$Maybe$Just($author$project$Data$Location$Field$ServiceAreas);
		case 'networkServiceItemsGoogle':
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$NetworkServiceItems($author$project$Data$Network$Google));
		default:
			var x = s;
			return $elm$core$Maybe$Just(
				$author$project$Data$Location$Field$Unhandled(x));
	}
};
var $author$project$Common$Pagination$insertData = F2(
	function (data, pagination) {
		var setDataLoaded = F2(
			function (_v0, data_) {
				var id = _v0.a;
				var x = _v0.b;
				return A3(
					$elm$core$Dict$insert,
					id,
					$author$project$RemoteData$Loaded(x),
					data_);
			});
		return _Utils_update(
			pagination,
			{
				data: A3(
					$elm$core$List$foldl,
					F2(
						function (x, a) {
							return A2(setDataLoaded, x, a);
						}),
					pagination.data,
					data)
			});
	});
var $author$project$Conflicts$Resolver$Types$OnSummaries = F2(
	function (a, b) {
		return {$: 'OnSummaries', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$Types$SaveNetwork = F3(
	function (a, b, c) {
		return {$: 'SaveNetwork', a: a, b: b, c: c};
	});
var $author$project$Data$Network$allNetworks = _List_fromArray(
	[$author$project$Data$Network$Facebook, $author$project$Data$Network$Google, $author$project$Data$Network$Bing, $author$project$Data$Network$Apple, $author$project$Data$Network$Foursquare, $author$project$Data$Network$Overture, $author$project$Data$Network$Here, $author$project$Data$Network$Tomtom, $author$project$Data$Network$Ptv, $author$project$Data$Network$Instagram]);
var $author$project$Common$Pagination$currentItem = function (pagination) {
	return A2($elm$core$Array$get, pagination.currentPage, pagination.items);
};
var $author$project$Common$Pagination$remoteDataWithId = F2(
	function (id, pagination) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$RemoteData$Suspended,
			A2($elm$core$Dict$get, id, pagination.data));
	});
var $author$project$Common$Pagination$currentData = function (pagination) {
	return A2(
		$elm$core$Maybe$andThen,
		function (x) {
			return $author$project$RemoteData$currentData(
				A2($author$project$Common$Pagination$remoteDataWithId, x, pagination));
		},
		$author$project$Common$Pagination$currentItem(pagination));
};
var $author$project$Conflicts$Resolver$Flags$Flags = F6(
	function (account, editableFields, fields, locationId, translations, conflictResolverType) {
		return {fields: fields, account: account, locationId: locationId, translations: translations, editableFields: editableFields, conflictResolverType: conflictResolverType};
	});
var $author$project$Conflicts$Resolver$Flags$Account = {$: 'Account'};
var $author$project$Conflicts$Resolver$Flags$Location = {$: 'Location'};
var $author$project$Conflicts$Resolver$Flags$fieldDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Location$Field$fromString, $elm$json$Json$Decode$string);
var $author$project$Conflicts$Resolver$Flags$fieldListDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list($author$project$Conflicts$Resolver$Flags$fieldDecoder));
var $author$project$Conflicts$Resolver$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isAccountConflictsResolver',
	A2(
		$elm$json$Json$Decode$andThen,
		function (isAccountConflictsResolver) {
			return isAccountConflictsResolver ? $elm$json$Json$Decode$succeed($author$project$Conflicts$Resolver$Flags$Account) : $elm$json$Json$Decode$succeed($author$project$Conflicts$Resolver$Flags$Location);
		},
		$elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locationId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fields',
				$author$project$Conflicts$Resolver$Flags$fieldListDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'editableFields',
					$author$project$Conflicts$Resolver$Flags$fieldListDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'account',
						$author$project$Data$Account$accountDecoder,
						$elm$json$Json$Decode$succeed($author$project$Conflicts$Resolver$Flags$Flags)))))));
var $author$project$Conflicts$Resolver$Flags$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Conflicts$Resolver$Flags$flagsDecoder, flags);
};
var $author$project$Conflicts$Resolver$ConflictStates$getConflictWorkId = function (conflict) {
	var _v0 = conflict.state;
	switch (_v0.$) {
		case 'WorkingLocal':
			var workId = _v0.b;
			return $elm$core$Maybe$Just(workId);
		case 'WorkingNetwork':
			var workId = _v0.c;
			return $elm$core$Maybe$Just(workId);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Conflicts$Resolver$ConflictStates$getByWorkId = F2(
	function (workId, states) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v1) {
					var _v2 = _v1.a;
					var locationId = _v2.a;
					var field = _v2.b;
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return _Utils_Tuple2(x, locationId);
						},
						$author$project$Data$Location$Field$fromString(field));
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (_v0, conflict) {
								return A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function (x) {
											return _Utils_eq(x, workId);
										},
										$author$project$Conflicts$Resolver$ConflictStates$getConflictWorkId(conflict)));
							}),
						states))));
	});
var $author$project$Conflicts$Commands$getLocation = F4(
	function (account, fields, placeId, msg) {
		var url = 'api/' + ($author$project$Data$SiteName$toString(account.name) + ('/conflicts/location/' + (placeId + ('?fields=' + A2(
			$elm$core$String$join,
			',',
			$author$project$Conflicts$Commands$toUniqueDataDiffValidationFieldString(fields))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$Conflicts$Commands$locationsWithConflictsDecoder(account.features)),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Conflicts$Resolver$ConflictStates$ResolvedNetwork = F2(
	function (a, b) {
		return {$: 'ResolvedNetwork', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$ConflictStates$resolveWork = F2(
	function (resolvedWorkId, states) {
		return A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, v) {
					var _v1 = v.state;
					switch (_v1.$) {
						case 'WorkingLocal':
							var location = _v1.a;
							var workId = _v1.b;
							return _Utils_eq(workId, resolvedWorkId) ? {
								error: $elm$core$Maybe$Nothing,
								state: $author$project$Conflicts$Resolver$ConflictStates$ResolvedLocal(location),
								selected: $elm$core$Maybe$Nothing
							} : v;
						case 'WorkingNetwork':
							var network = _v1.a;
							var location = _v1.b;
							var workId = _v1.c;
							return _Utils_eq(workId, resolvedWorkId) ? {
								error: $elm$core$Maybe$Nothing,
								state: A2($author$project$Conflicts$Resolver$ConflictStates$ResolvedNetwork, network, location),
								selected: $elm$core$Maybe$Nothing
							} : v;
						default:
							return v;
					}
				}),
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$SavingNetwork = function (a) {
	return {$: 'SavingNetwork', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$saveNetwork = F4(
	function (network, field, locationId, states) {
		return A3(
			$elm$core$Dict$insert,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			{
				error: $elm$core$Maybe$Nothing,
				state: $author$project$Conflicts$Resolver$ConflictStates$SavingNetwork(network),
				selected: $elm$core$Maybe$Nothing
			},
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$Local = {$: 'Local'};
var $author$project$Conflicts$Resolver$ConflictStates$Default = {$: 'Default'};
var $author$project$Conflicts$Resolver$ConflictStates$selectLocal = F3(
	function (field, locationId, states) {
		return A2(
			$elm$core$Dict$member,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states) ? A3(
			$elm$core$Dict$update,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			function (x) {
				return A2(
					$elm$core$Maybe$map,
					function (x_) {
						return _Utils_update(
							x_,
							{
								selected: $elm$core$Maybe$Just($author$project$Conflicts$Resolver$ConflictStates$Local)
							});
					},
					x);
			},
			states) : A3(
			$elm$core$Dict$insert,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			{
				error: $elm$core$Maybe$Nothing,
				state: $author$project$Conflicts$Resolver$ConflictStates$Default,
				selected: $elm$core$Maybe$Just($author$project$Conflicts$Resolver$ConflictStates$Local)
			},
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$WorkingNetwork = F3(
	function (a, b, c) {
		return {$: 'WorkingNetwork', a: a, b: b, c: c};
	});
var $author$project$Conflicts$Resolver$ConflictStates$workNetwork = F5(
	function (workId, network, field, location, states) {
		return A3(
			$elm$core$Dict$update,
			_Utils_Tuple2(
				location.id,
				$author$project$Data$Location$Field$toString(field)),
			function (x) {
				return A2(
					$author$project$Conflicts$Resolver$ConflictStates$setState,
					A3($author$project$Conflicts$Resolver$ConflictStates$WorkingNetwork, network, location, workId),
					x);
			},
			states);
	});
var $author$project$Conflicts$Resolver$Types$OnPageChange = function (a) {
	return {$: 'OnPageChange', a: a};
};
var $author$project$Common$Pagination$insertLoaded = F3(
	function (k, v, pagination) {
		return _Utils_update(
			pagination,
			{
				data: A3(
					$elm$core$Dict$insert,
					k,
					$author$project$RemoteData$Loaded(v),
					pagination.data)
			});
	});
var $author$project$Common$Pagination$updateLoaded = F3(
	function (k, alter, pagination) {
		var updateRemoteData = F2(
			function (alter_, x) {
				if (x.$ === 'Loaded') {
					var x_ = x.a;
					return $author$project$RemoteData$Loaded(
						alter_(x_));
				} else {
					return x;
				}
			});
		return _Utils_update(
			pagination,
			{
				data: A3(
					$elm$core$Dict$update,
					k,
					function (x) {
						return A2(
							$elm$core$Maybe$map,
							updateRemoteData(alter),
							x);
					},
					pagination.data)
			});
	});
var $author$project$Conflicts$Resolver$Types$OnApproveDiff = F4(
	function (a, b, c, d) {
		return {$: 'OnApproveDiff', a: a, b: b, c: c, d: d};
	});
var $author$project$Conflicts$Resolver$Types$OnSaveNetwork = F4(
	function (a, b, c, d) {
		return {$: 'OnSaveNetwork', a: a, b: b, c: c, d: d};
	});
var $author$project$Conflicts$Resolver$ConflictStates$ConflictError = function (a) {
	return {$: 'ConflictError', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$failWithError = F4(
	function (error, field, locationId, states) {
		return A3(
			$elm$core$Dict$update,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			function (_v0) {
				return $elm$core$Maybe$Just(
					{
						error: $elm$core$Maybe$Just(
							$author$project$Conflicts$Resolver$ConflictStates$ConflictError(error)),
						state: $author$project$Conflicts$Resolver$ConflictStates$WithError,
						selected: $elm$core$Maybe$Nothing
					});
			},
			states);
	});
var $author$project$Conflicts$Resolver$ConflictStates$Network = function (a) {
	return {$: 'Network', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$selectNetwork = F4(
	function (network, field, locationId, states) {
		return A2(
			$elm$core$Dict$member,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states) ? A3(
			$elm$core$Dict$update,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			function (x) {
				return A2(
					$elm$core$Maybe$map,
					function (x_) {
						return _Utils_update(
							x_,
							{
								selected: $elm$core$Maybe$Just(
									$author$project$Conflicts$Resolver$ConflictStates$Network(network))
							});
					},
					x);
			},
			states) : A3(
			$elm$core$Dict$insert,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			{
				error: $elm$core$Maybe$Nothing,
				state: $author$project$Conflicts$Resolver$ConflictStates$Default,
				selected: $elm$core$Maybe$Just(
					$author$project$Conflicts$Resolver$ConflictStates$Network(network))
			},
			states);
	});
var $author$project$Common$Pagination$setInputValue = F2(
	function (newPage, pagination) {
		return _Utils_update(
			pagination,
			{value: newPage});
	});
var $author$project$Conflicts$Resolver$Types$ImageEditorMsg = function (a) {
	return {$: 'ImageEditorMsg', a: a};
};
var $author$project$Conflicts$Resolver$Types$ImageEditorSaved = F2(
	function (a, b) {
		return {$: 'ImageEditorSaved', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$Types$WorkErrorDetails = F2(
	function (a, b) {
		return {$: 'WorkErrorDetails', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$Model$PrimaryCategories = function (a) {
	return {$: 'PrimaryCategories', a: a};
};
var $author$project$Conflicts$Resolver$Update$imageEditorTarget = function (field) {
	_v0$4:
	while (true) {
		switch (field.$) {
			case 'ProfileImage':
				switch (field.a.$) {
					case 'Google':
						var _v1 = field.a;
						return $elm$core$Maybe$Just($author$project$Location$ImageEditor$GoogleLogo);
					case 'Facebook':
						var _v3 = field.a;
						return $elm$core$Maybe$Just($author$project$Location$ImageEditor$FacebookProfile);
					default:
						break _v0$4;
				}
			case 'CoverImage':
				switch (field.a.$) {
					case 'Google':
						var _v2 = field.a;
						return $elm$core$Maybe$Just($author$project$Location$ImageEditor$GoogleCover);
					case 'Facebook':
						var _v4 = field.a;
						return $elm$core$Maybe$Just($author$project$Location$ImageEditor$FacebookCover);
					default:
						break _v0$4;
				}
			default:
				break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Conflicts$Resolver$Update$listAllCategories = function (networkCategories) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_List_Nil,
		function (categoryGroup) {
			return _Utils_ap(
				categoryGroup.additional,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (primaryCategory) {
						return _List_fromArray(
							[primaryCategory]);
					},
					categoryGroup.primary));
		},
		networkCategories);
};
var $author$project$Data$Location$updateCoverImageInNetwork = F3(
	function (network, x, y) {
		var updateCoverImage = F2(
			function (a, b) {
				return _Utils_update(
					a,
					{coverImage: b.coverImage});
			});
		switch (network.$) {
			case 'Facebook':
				return _Utils_update(
					x,
					{
						facebook: A2(updateCoverImage, x.facebook, y.facebook)
					});
			case 'Google':
				return _Utils_update(
					x,
					{
						google: A2(updateCoverImage, x.google, y.google)
					});
			case 'Bing':
				return x;
			case 'Apple':
				return x;
			case 'Foursquare':
				return x;
			case 'Overture':
				return x;
			case 'Here':
				return x;
			case 'Tomtom':
				return x;
			case 'Ptv':
				return x;
			default:
				return x;
		}
	});
var $author$project$Data$Location$updateProfileImageInNetwork = F3(
	function (network, x, y) {
		var updateProfileImage = F2(
			function (a, b) {
				return _Utils_update(
					a,
					{profileImage: b.profileImage});
			});
		switch (network.$) {
			case 'Facebook':
				return _Utils_update(
					x,
					{
						facebook: A2(updateProfileImage, x.facebook, y.facebook)
					});
			case 'Google':
				return _Utils_update(
					x,
					{
						google: A2(updateProfileImage, x.google, y.google)
					});
			case 'Bing':
				return x;
			case 'Apple':
				return x;
			case 'Foursquare':
				return x;
			case 'Overture':
				return x;
			case 'Here':
				return x;
			case 'Tomtom':
				return x;
			case 'Ptv':
				return x;
			default:
				return x;
		}
	});
var $author$project$Data$Location$updateDataInField = F3(
	function (field, oldLocation, newLocation) {
		switch (field.$) {
			case 'Name':
				return _Utils_update(
					oldLocation,
					{name: newLocation.name});
			case 'CustomName':
				var network = field.a;
				var updated = function () {
					switch (network.$) {
						case 'Facebook':
							return function (networkNames) {
								return _Utils_update(
									networkNames,
									{facebook: newLocation.networkNames.facebook});
							}(oldLocation.networkNames);
						case 'Google':
							return function (networkNames) {
								return _Utils_update(
									networkNames,
									{google: newLocation.networkNames.google});
							}(oldLocation.networkNames);
						case 'Bing':
							return oldLocation.networkNames;
						case 'Apple':
							return function (networkNames) {
								return _Utils_update(
									networkNames,
									{apple: newLocation.networkNames.apple});
							}(oldLocation.networkNames);
						case 'Foursquare':
							return oldLocation.networkNames;
						case 'Overture':
							return oldLocation.networkNames;
						case 'Here':
							return oldLocation.networkNames;
						case 'Tomtom':
							return oldLocation.networkNames;
						case 'Ptv':
							return function (networkNames) {
								return _Utils_update(
									networkNames,
									{ptv: newLocation.networkNames.ptv});
							}(oldLocation.networkNames);
						default:
							return oldLocation.networkNames;
					}
				}();
				return _Utils_update(
					oldLocation,
					{networkNames: updated});
			case 'StoreId':
				return _Utils_update(
					oldLocation,
					{storeId: newLocation.storeId});
			case 'LocationDescriptor':
				return _Utils_update(
					oldLocation,
					{locationDescriptor: newLocation.locationDescriptor});
			case 'Location':
				return _Utils_update(
					oldLocation,
					{location: newLocation.location});
			case 'About':
				return _Utils_update(
					oldLocation,
					{about: newLocation.about});
			case 'LongDescription':
				return _Utils_update(
					oldLocation,
					{longDescription: newLocation.longDescription});
			case 'Hours':
				return _Utils_update(
					oldLocation,
					{openHours: newLocation.openHours});
			case 'OpeningDate':
				return _Utils_update(
					oldLocation,
					{openingDate: newLocation.openingDate});
			case 'SpecialHours':
				return _Utils_update(
					oldLocation,
					{specialOpenHours: newLocation.specialOpenHours});
			case 'PermanentlyClosed':
				return _Utils_update(
					oldLocation,
					{permanentlyClosed: newLocation.permanentlyClosed});
			case 'TemporarilyClosedUntil':
				return _Utils_update(
					oldLocation,
					{temporarilyClosedUntil: newLocation.temporarilyClosedUntil});
			case 'Email':
				return _Utils_update(
					oldLocation,
					{email: newLocation.email});
			case 'Homepage':
				return _Utils_update(
					oldLocation,
					{homepage: newLocation.homepage});
			case 'Phone':
				return _Utils_update(
					oldLocation,
					{phone: newLocation.phone});
			case 'Address':
				return _Utils_update(
					oldLocation,
					{address: newLocation.address});
			case 'CoverImage':
				var network = field.a;
				return _Utils_update(
					oldLocation,
					{
						networkMedia: A3($author$project$Data$Location$updateCoverImageInNetwork, network, oldLocation.networkMedia, newLocation.networkMedia)
					});
			case 'ProfileImage':
				var network = field.a;
				return _Utils_update(
					oldLocation,
					{
						networkMedia: A3($author$project$Data$Location$updateProfileImageInNetwork, network, oldLocation.networkMedia, newLocation.networkMedia)
					});
			case 'NetworkCategories':
				return _Utils_update(
					oldLocation,
					{networkCategories: newLocation.networkCategories});
			case 'NetworkAttributes':
				return _Utils_update(
					oldLocation,
					{networkAttributes: newLocation.networkAttributes});
			case 'ActionLinks':
				return _Utils_update(
					oldLocation,
					{actionLinks: newLocation.actionLinks});
			case 'NetworkServiceItems':
				return _Utils_update(
					oldLocation,
					{networkServiceItems: newLocation.networkServiceItems});
			case 'ServiceAreas':
				return _Utils_update(
					oldLocation,
					{serviceAreas: newLocation.serviceAreas});
			case 'Wifi':
				return _Utils_update(
					oldLocation,
					{wifiSsId: newLocation.wifiSsId});
			default:
				return oldLocation;
		}
	});
var $author$project$Conflicts$Resolver$Types$OnUpdatedLocations = F3(
	function (a, b, c) {
		return {$: 'OnUpdatedLocations', a: a, b: b, c: c};
	});
var $author$project$Data$Location$fieldsInLocationWithIdEncoder = F2(
	function (fields, location) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'_id',
					$elm$json$Json$Encode$string(location.id)),
				$elm$core$List$concat(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function (field) {
								return A2($author$project$Data$Location$encodeFieldInLocation, field, location);
							},
							fields)))));
	});
var $author$project$Conflicts$Resolver$ExternalCommand$editCommandEncoder = function (editCommand) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'field',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$Field$toString(editCommand.field))),
				_Utils_Tuple2(
				'location',
				A2(
					$author$project$Data$Location$fieldsInLocationWithIdEncoder,
					_List_fromArray(
						[editCommand.field]),
					editCommand.location))
			]));
};
var $author$project$Translations$Listings$Conflicts$couldNotApproveDiff = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.could_not_approve_diff');
};
var $author$project$Data$Work$ErrorDetail = F3(
	function (message, field, value) {
		return {field: field, value: value, message: message};
	});
var $author$project$Data$Work$errorDetailDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'value',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'field',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'message',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Work$ErrorDetail))));
var $author$project$Data$Work$workErrorDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'details',
	$elm$json$Json$Decode$list($author$project$Data$Work$errorDetailDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'properties',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'network',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'reason',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$Data$Work$WorkError)))));
var $author$project$Data$Work$workErrorsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (success) {
		return success ? A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'errors',
			$elm$json$Json$Decode$list($author$project$Data$Work$workErrorDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Data$Work$WorkErrors))) : A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$fail,
			A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
	},
	A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool));
var $author$project$Conflicts$Commands$getWorkErrorDetails = F3(
	function (_v0, workId, msg) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + ('/workErrors/' + workId));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Data$Work$workErrorsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Data$NetworkData$Validation$fieldDiff = F3(
	function (f, field, diff) {
		switch (field.$) {
			case 'Name':
				return f(diff.name);
			case 'CustomName':
				return f(diff.customName);
			case 'StoreId':
				return f(diff.storeId);
			case 'LocationDescriptor':
				return f(diff.locationDescriptor);
			case 'Location':
				return f(diff.location);
			case 'About':
				return f(diff.about);
			case 'LongDescription':
				return f(diff.longDescription);
			case 'Hours':
				return f(diff.hours);
			case 'OpeningDate':
				return f(diff.openingDate);
			case 'SpecialHours':
				return f(diff.specialOpenHours);
			case 'PermanentlyClosed':
				return f(diff.permanentlyClosed);
			case 'TemporarilyClosedUntil':
				return f(diff.temporarilyClosedUntil);
			case 'Email':
				return f(diff.email);
			case 'Homepage':
				return f(diff.homepage);
			case 'Phone':
				return f(diff.phone);
			case 'Address':
				return f(diff.street) || (f(diff.zip) || (f(diff.city) || (f(diff.country) || (f(diff.province) || f(diff.district)))));
			case 'CoverImage':
				return f(diff.coverImage);
			case 'ProfileImage':
				return f(diff.profileImage);
			case 'NetworkCategories':
				return f(diff.networkCategories);
			case 'NetworkAttributes':
				return f(diff.networkAttributes);
			case 'ActionLinks':
				return f(diff.networkActionLinks);
			case 'NetworkServiceItems':
				return f(diff.networkServiceItems);
			case 'ServiceAreas':
				return f(diff.serviceAreas);
			case 'Wifi':
				return false;
			default:
				return false;
		}
	});
var $author$project$Data$NetworkData$Validation$hasDiff = $author$project$Data$NetworkData$Validation$fieldDiff(
	function ($) {
		return $.hasDiff;
	});
var $author$project$Data$Location$Field$isFieldInNetwork = F2(
	function (field, network) {
		switch (field.$) {
			case 'ProfileImage':
				var x = field.a;
				return _Utils_eq(x, network);
			case 'CoverImage':
				var x = field.a;
				return _Utils_eq(x, network);
			case 'CustomName':
				var x = field.a;
				return _Utils_eq(x, network);
			case 'NetworkCategories':
				var x = field.a;
				return _Utils_eq(x, network);
			default:
				return true;
		}
	});
var $author$project$Data$Location$hasDiff = F3(
	function (field, network, networkData) {
		return A2($author$project$Data$Location$Field$isFieldInNetwork, field, network) ? A2($author$project$Data$NetworkData$Validation$hasDiff, field, networkData.validation.dataDiff) : false;
	});
var $author$project$Data$Location$hasConflictInFieldsInNetwork = F3(
	function (fields, location, networkName) {
		var findDiffInFields = function (locationData) {
			return A2(
				$elm$core$List$any,
				function (x) {
					return A3($author$project$Data$Location$hasDiff, x, networkName, locationData);
				},
				A2(
					$elm$core$List$filter,
					function (x) {
						return _Utils_eq(x, $author$project$Data$Location$Field$Location) ? (!locationData.validation.googleLatLonMarkedForPublication) : true;
					},
					fields));
		};
		var networkHasDiff = function (network) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				false,
				function (x) {
					return _Utils_eq(x.idSetType, $author$project$Data$Network$Disconnected) ? false : findDiffInFields(x);
				},
				network);
		};
		switch (networkName.$) {
			case 'Facebook':
				return networkHasDiff(location.facebook);
			case 'Google':
				return networkHasDiff(location.google);
			case 'Bing':
				return networkHasDiff(location.bing);
			case 'Apple':
				return networkHasDiff(location.apple);
			case 'Foursquare':
				return false;
			case 'Overture':
				return false;
			case 'Here':
				return false;
			case 'Tomtom':
				return false;
			case 'Ptv':
				return networkHasDiff(location.ptv);
			default:
				return false;
		}
	});
var $author$project$Data$Location$hasConflictInFields = F2(
	function (fields, location) {
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				A2($author$project$Data$Location$hasConflictInFieldsInNetwork, fields, location),
				$author$project$Data$Network$allNetworks));
	});
var $author$project$Data$Location$updateMediaForField = F3(
	function (field, media, location) {
		var updateProfileImage = function (x) {
			return _Utils_update(
				x,
				{
					profileImage: $elm$core$Maybe$Just(media)
				});
		};
		var updateNetworkMedia = F3(
			function (network, f, x) {
				switch (network.$) {
					case 'Facebook':
						return _Utils_update(
							x,
							{
								facebook: f(location.networkMedia.facebook)
							});
					case 'Google':
						return _Utils_update(
							x,
							{
								google: f(location.networkMedia.google)
							});
					case 'Bing':
						return x;
					case 'Apple':
						return x;
					case 'Foursquare':
						return x;
					case 'Overture':
						return x;
					case 'Here':
						return x;
					case 'Tomtom':
						return x;
					case 'Ptv':
						return x;
					default:
						return x;
				}
			});
		var updateCoverImage = function (x) {
			return _Utils_update(
				x,
				{
					coverImage: $elm$core$Maybe$Just(media)
				});
		};
		var update = function (x) {
			switch (field.$) {
				case 'ProfileImage':
					var network = field.a;
					return A3(updateNetworkMedia, network, updateProfileImage, x);
				case 'CoverImage':
					var network = field.a;
					return A3(updateNetworkMedia, network, updateCoverImage, x);
				default:
					return x;
			}
		};
		return _Utils_update(
			location,
			{
				networkMedia: update(location.networkMedia)
			});
	});
var $author$project$Conflicts$Resolver$Update$editorUpdatedDecoder = function (features) {
	var fieldDecoder = A2(
		$elm$json$Json$Decode$map,
		function (x) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unpack,
				function (_v0) {
					return $author$project$Data$Location$Field$Unhandled(x);
				},
				function (z) {
					return z;
				},
				$author$project$Data$Location$Field$fromString(x));
		},
		$elm$json$Json$Decode$string);
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (field, location) {
				return {field: field, location: location};
			}),
		A2($elm$json$Json$Decode$field, 'field', fieldDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'location',
			A2($author$project$Data$Location$locationDecoder, features, $elm$core$Maybe$Nothing)));
};
var $author$project$Data$Location$networkDataFromNetwork = F2(
	function (location, network) {
		switch (network.$) {
			case 'Facebook':
				return location.facebook;
			case 'Google':
				return location.google;
			case 'Bing':
				return location.bing;
			case 'Apple':
				return location.apple;
			case 'Foursquare':
				return $elm$core$Maybe$Nothing;
			case 'Overture':
				return $elm$core$Maybe$Nothing;
			case 'Here':
				return $elm$core$Maybe$Nothing;
			case 'Tomtom':
				return $elm$core$Maybe$Nothing;
			case 'Ptv':
				return location.ptv;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Conflicts$Commands$ApproveDiffResult = F3(
	function (success, data, field) {
		return {data: data, field: field, success: success};
	});
var $author$project$Conflicts$Commands$approveDiffResultDecoder = F2(
	function (features, field) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			field,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['data', 'place']),
				A2($author$project$Data$Location$locationDecoder, features, $elm$core$Maybe$Nothing),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'success',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Conflicts$Commands$ApproveDiffResult))));
	});
var $author$project$Conflicts$Commands$approveDiffInLocation = F6(
	function (account, field, location, network, prop, msg) {
		var _v0 = A2($author$project$Data$Location$networkDataFromNetwork, location, network);
		if (_v0.$ === 'Just') {
			var networkData = _v0.a;
			switch (prop) {
				case 'city':
					var encoded = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'approvedDiff',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'city',
											$elm$json$Json$Encode$string(networkData.data.address.city))
										])))
							]));
					var url = A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'api',
								$author$project$Data$SiteName$toString(account.name),
								'place',
								location.id,
								$author$project$Data$Network$toString(network),
								'conflict/approveDiff'
							]));
					return $lukewestby$elm_http_builder$HttpBuilder$request(
						A2(
							$lukewestby$elm_http_builder$HttpBuilder$withExpect,
							A2(
								$elm$http$Http$expectJson,
								msg,
								A2($author$project$Conflicts$Commands$approveDiffResultDecoder, account.features, field)),
							A2(
								$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
								encoded,
								$lukewestby$elm_http_builder$HttpBuilder$put(url))));
				case 'province':
					var encoded = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'approvedDiff',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'province',
											$elm$json$Json$Encode$string(
												$author$project$Data$Address$getProvince(networkData.data.address)))
										])))
							]));
					var url = A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'api',
								$author$project$Data$SiteName$toString(account.name),
								'place',
								location.id,
								$author$project$Data$Network$toString(network),
								'conflict/approveDiff'
							]));
					return $lukewestby$elm_http_builder$HttpBuilder$request(
						A2(
							$lukewestby$elm_http_builder$HttpBuilder$withExpect,
							A2(
								$elm$http$Http$expectJson,
								msg,
								A2($author$project$Conflicts$Commands$approveDiffResultDecoder, account.features, field)),
							A2(
								$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
								encoded,
								$lukewestby$elm_http_builder$HttpBuilder$put(url))));
				default:
					return $elm$core$Platform$Cmd$none;
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Translations$Listings$Conflicts$errorLoadingConflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.error_loading_conflicts');
};
var $author$project$Conflicts$Resolver$Types$OnSaveMediaFromNetwork = F4(
	function (a, b, c, d) {
		return {$: 'OnSaveMediaFromNetwork', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $author$project$Common$Pagination$initWithItemsAndCurrent = F2(
	function (items, current) {
		var _v0 = A3(
			$elm$core$Array$foldl,
			F2(
				function (x, _v1) {
					var acc = _v1.a;
					var index = _v1.b;
					return _Utils_eq(x, current) ? _Utils_Tuple2(index, index + 1) : _Utils_Tuple2(acc, index + 1);
				}),
			_Utils_Tuple2(0, 0),
			items);
		var page = _v0.a;
		return A4($author$project$Common$Pagination$Pagination, page, page + 1, items, $elm$core$Dict$empty);
	});
var $author$project$Conflicts$Resolver$Types$LocationDetailsEditorMsg = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorMsg', a: a, b: b};
	});
var $author$project$Conflicts$Commands$MediaUpdateResult = F2(
	function (media, location) {
		return {media: media, location: location};
	});
var $author$project$Conflicts$Commands$mediaResultDecoder = function (location) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		location,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['media']),
			$author$project$Data$Media$mediaDecoder,
			$elm$json$Json$Decode$succeed($author$project$Conflicts$Commands$MediaUpdateResult)));
};
var $author$project$Conflicts$Commands$useCoverImageFromNetwork = F4(
	function (_v0, network, location, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$Conflicts$Commands$mediaResultDecoder(location)),
				$lukewestby$elm_http_builder$HttpBuilder$post(
					'api/' + (siteName + ('/media/' + (location.id + ('/coverPhoto/' + ($author$project$Data$Network$toString(network) + '/usenetwork'))))))));
	});
var $author$project$Data$Location$Summary = F6(
	function (id, locationType, name, storeId, locationDescriptor, address) {
		return {id: id, name: name, address: address, storeId: storeId, locationType: locationType, locationDescriptor: locationDescriptor};
	});
var $author$project$Data$Location$summaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'address',
	$author$project$Data$Address$addressDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'locationDescriptor',
		$author$project$Util$idDecoder($author$project$Data$Location$LocationDescriptor),
		$author$project$Data$Location$LocationDescriptor(''),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'storeId',
			$author$project$Util$idDecoder($author$project$Data$Location$StoreId),
			$author$project$Data$Location$StoreId(''),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$author$project$Data$Location$locationTypeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'_id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Location$Summary)))))));
var $author$project$Conflicts$Commands$getSummariesWithConflictsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['places']),
	$elm$json$Json$Decode$list($author$project$Data$Location$summaryDecoder));
var $author$project$Conflicts$Commands$getSummariesWithConflicts = F3(
	function (account, fields, msg) {
		var url = 'api/' + ($author$project$Data$SiteName$toString(account.name) + ('/conflicts/summaries?fields=' + A2(
			$elm$core$String$join,
			',',
			$author$project$Conflicts$Commands$toUniqueDataDiffValidationFieldString(fields))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Conflicts$Commands$getSummariesWithConflictsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Conflicts$Resolver$Types$LdpSpecialOpenHoursUpdated = F2(
	function (a, b) {
		return {$: 'LdpSpecialOpenHoursUpdated', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$Types$OnLocationGoogleAttributes = function (a) {
	return {$: 'OnLocationGoogleAttributes', a: a};
};
var $author$project$Conflicts$Commands$useProfileImageFromNetwork = F4(
	function (_v0, network, location, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$Conflicts$Commands$mediaResultDecoder(location)),
				$lukewestby$elm_http_builder$HttpBuilder$post(
					'api/' + (siteName + ('/media/' + (location.id + ('/profilePhoto/' + ($author$project$Data$Network$toString(network) + '/usenetwork'))))))));
	});
var $author$project$Data$NetworkData$Validation$workInField = F2(
	function (field, diff) {
		switch (field.$) {
			case 'Name':
				return diff.name.work;
			case 'CustomName':
				return diff.customName.work;
			case 'StoreId':
				return diff.storeId.work;
			case 'LocationDescriptor':
				return diff.locationDescriptor.work;
			case 'Location':
				return diff.location.work;
			case 'About':
				return diff.about.work;
			case 'LongDescription':
				return diff.longDescription.work;
			case 'Hours':
				return diff.hours.work;
			case 'OpeningDate':
				return diff.openingDate.work;
			case 'SpecialHours':
				return diff.specialOpenHours.work;
			case 'PermanentlyClosed':
				return diff.permanentlyClosed.work;
			case 'TemporarilyClosedUntil':
				return diff.temporarilyClosedUntil.work;
			case 'Email':
				return diff.email.work;
			case 'Homepage':
				return diff.homepage.work;
			case 'Phone':
				return diff.phone.work;
			case 'Address':
				return $elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[diff.street.work, diff.zip.work, diff.city.work, diff.country.work, diff.province.work, diff.district.work])));
			case 'CoverImage':
				return diff.coverImage.work;
			case 'ProfileImage':
				return diff.profileImage.work;
			case 'NetworkCategories':
				return diff.networkCategories.work;
			case 'NetworkAttributes':
				return diff.networkAttributes.work;
			case 'ActionLinks':
				return diff.networkActionLinks.work;
			case 'NetworkServiceItems':
				return diff.networkServiceItems.work;
			case 'ServiceAreas':
				return diff.serviceAreas.work;
			case 'Wifi':
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Location$workInField = F2(
	function (field, location) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					$author$project$Data$NetworkData$Validation$workInField(field),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function (x) {
								return A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.validation;
										},
										function ($) {
											return $.dataDiff;
										}),
									x);
							},
							A2(
								$elm$core$List$map,
								$author$project$Data$Location$networkDataFromNetwork(location),
								$author$project$Data$Network$allNetworks))))));
	});
var $author$project$Data$NetworkData$Validation$workIsInProgress = function (work) {
	if (work.$ === 'Just') {
		var x = work.a;
		return _Utils_eq(x.status, $author$project$Data$Work$InProgress);
	} else {
		return false;
	}
};
var $author$project$Conflicts$Resolver$Model$conflictsStatesFromLocation = F3(
	function (fields, location, states) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, states_) {
					var _v0 = A2($author$project$Data$Location$workInField, x, location);
					if (_v0.$ === 'Just') {
						var work = _v0.a;
						return $author$project$Data$NetworkData$Validation$workIsInProgress(
							$elm$core$Maybe$Just(work)) ? A4($author$project$Conflicts$Resolver$ConflictStates$workLocal, work.id, x, location, states_) : states_;
					} else {
						return states_;
					}
				}),
			states,
			fields);
	});
var $author$project$Data$NetworkData$GoogleAttributes$getLocationGoogleAttributes = F3(
	function (_v0, locationId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Data$NetworkData$GoogleAttributes$googleAttributesDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + ('/place/' + (locationId + '/google/attributes'))))));
	});
var $author$project$Conflicts$Resolver$Types$LocationDetailsEditorUpdated = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorUpdated', a: a, b: b};
	});
var $author$project$Conflicts$Resolver$Types$OnLocationGoogleServiceItems = function (a) {
	return {$: 'OnLocationGoogleServiceItems', a: a};
};
var $author$project$Conflicts$Resolver$Types$SideBarSpecialOpenHoursUpdated = function (a) {
	return {$: 'SideBarSpecialOpenHoursUpdated', a: a};
};
var $author$project$Conflicts$Commands$getLocationSummaryWithConflicts = F4(
	function (account, placeId, fields, msg) {
		var url = 'api/' + ($author$project$Data$SiteName$toString(account.name) + ('/conflicts/summaries/location/' + (placeId + ('?fields=' + A2(
			$elm$core$String$join,
			',',
			$author$project$Conflicts$Commands$toUniqueDataDiffValidationFieldString(fields))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Conflicts$Commands$getSummariesWithConflictsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Conflicts$Resolver$Types$OnListingsManagerPoliciesEnabled = function (a) {
	return {$: 'OnListingsManagerPoliciesEnabled', a: a};
};
var $author$project$Data$GoogleAttributes$Api$setAllAttributesFromGoogle = F3(
	function (siteName, locationId, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				$lukewestby$elm_http_builder$HttpBuilder$post(
					A2($author$project$Data$GoogleAttributes$Api$locationUrl, siteName, locationId) + '/google/attributes/setAllFromGoogle')));
	});
var $author$project$Conflicts$Commands$setAllGoogleAttributesFromGoogle = F4(
	function (account, field, locationId, msg) {
		return A3(
			$author$project$Data$GoogleAttributes$Api$setAllAttributesFromGoogle,
			account.name,
			locationId,
			A3(
				$author$project$PinMeTo$ExpectJson$expectJson,
				msg,
				A2(
					$author$project$Conflicts$Commands$partialUpdateResultDecoder,
					account.features,
					_List_fromArray(
						[field])),
				$elm$json$Json$Decode$string));
	});
var $author$project$Conflicts$Commands$hasEnabledPolicyDecoder = A2(
	$elm$json$Json$Decode$map,
	function (status) {
		return _Utils_eq(
			status,
			$elm$core$Maybe$Just('active'));
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string)));
var $author$project$Conflicts$Commands$getListingsManagerPoliciesEnabled = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Conflicts$Commands$hasEnabledPolicyDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('/ai/api/' + (siteName + '/conflicts/policies'))));
	});
var $author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_cropImage = _Platform_outgoingPort('out_Conflicts_Resolver_Main_cropImage', $elm$core$Basics$identity);
var $author$project$Common$List$find = $elm_community$list_extra$List$Extra$find;
var $author$project$Data$Location$SpecialOpenHours$findByDate = F2(
	function (now, openHours) {
		return A2(
			$author$project$Common$List$find,
			function (x) {
				return _Utils_eq(x.startDate, now);
			},
			openHours);
	});
var $author$project$Data$Location$SpecialOpenHours$withExpired = F2(
	function (openHours, now) {
		return A2(
			$elm$core$List$filter,
			function (x) {
				return A2($author$project$Data$Location$SpecialOpenHours$isBeforeTime, now, x.startDate);
			},
			openHours);
	});
var $author$project$Data$Location$addressEncoder = F2(
	function (field, locationData) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Data$Location$Field$toString(field),
				$author$project$Data$Address$addressEncoder(locationData.address))
			]);
	});
var $author$project$Data$Location$locationDataFromNetwork = F2(
	function (location, network) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.data;
			},
			A2($author$project$Data$Location$networkDataFromNetwork, location, network));
	});
var $author$project$Data$Location$encodeAttributesFieldInLocationFromNetwork = function (attributes) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'networkAttributes',
			$elm$json$Json$Encode$object(
				$author$project$Data$Location$NetworkAttributes$encode(attributes)))
		]);
};
var $author$project$Data$Location$encodeActionLinksFieldInLocationFromNetwork = function (actionLinks) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'actionLinks',
			A2($elm$json$Json$Encode$list, $author$project$Data$Location$ActionLinks$encode, actionLinks))
		]);
};
var $author$project$Data$Location$encodeNetworkCateogriesFieldInLocationFromNetwork = function (categories) {
	var fieldName = function () {
		switch (categories.$) {
			case 'Google':
				return 'google';
			case 'Facebook':
				return 'facebook';
			case 'Bing':
				return 'bing';
			case 'Apple':
				return 'apple';
			case 'Foursquare':
				return 'foursquare';
			case 'Overture':
				return 'overture';
			case 'Here':
				return 'here';
			case 'Tomtom':
				return 'tomtom';
			case 'Ptv':
				return 'ptv';
			default:
				return 'instagram';
		}
	}();
	switch (categories.$) {
		case 'Facebook':
			var fbCat = categories.a;
			var obj = _List_fromArray(
				[
					_Utils_Tuple2(
					'subcategories',
					A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, fbCat))
				]);
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$elm$json$Json$Encode$object(obj))
							])))
				]);
		case 'Google':
			var googleCat = categories.a;
			var obj = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'additional',
					A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, googleCat.additional)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'primary',
									$author$project$Data$Location$NetworkCategories$encodeCategory(x))
								]);
						},
						googleCat.primary)));
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$elm$json$Json$Encode$object(obj))
							])))
				]);
		case 'Bing':
			var categoryGroup = categories.a;
			var obj = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'additional',
					A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, categoryGroup.additional)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'primary',
									$author$project$Data$Location$NetworkCategories$encodeCategory(x))
								]);
						},
						categoryGroup.primary)));
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$elm$json$Json$Encode$object(obj))
							])))
				]);
		case 'Apple':
			var appleCat = categories.a;
			var obj = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'additional',
					A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, appleCat.additional)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'primary',
									$author$project$Data$Location$NetworkCategories$encodeCategory(x))
								]);
						},
						appleCat.primary)));
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$elm$json$Json$Encode$object(obj))
							])))
				]);
		case 'Foursquare':
			var foursquareCat = categories.a;
			var obj = $author$project$Data$Location$NetworkCategories$encodeFoursquareCategories(foursquareCat);
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(fieldName, obj)
							])))
				]);
		case 'Overture':
			var overtureCat = categories.a;
			var obj = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'additional',
					A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, overtureCat.additional)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'primary',
									$author$project$Data$Location$NetworkCategories$encodeCategory(x))
								]);
						},
						overtureCat.primary)));
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$elm$json$Json$Encode$object(obj))
							])))
				]);
		case 'Here':
			var hereCat = categories.a;
			var obj = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'additional',
					A2($elm$json$Json$Encode$list, $author$project$Data$Location$NetworkCategories$encodeCategory, hereCat.additional)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'primary',
									$author$project$Data$Location$NetworkCategories$encodeCategory(x))
								]);
						},
						hereCat.primary)));
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$elm$json$Json$Encode$object(obj))
							])))
				]);
		case 'Tomtom':
			var tomtomCat = categories.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'networkCategories',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								fieldName,
								$author$project$Data$Location$NetworkCategories$encodeTomtomCategories(tomtomCat))
							])))
				]);
		case 'Ptv':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Data$Location$encodeNetworkServiceItemsFieldInLocationFromNetwork = function (serviceItems) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'networkServiceItems',
			$elm$json$Json$Encode$object(
				$author$project$Data$Location$NetworkServiceItems$encode(serviceItems)))
		]);
};
var $author$project$Data$Location$encodeFieldInLocationFromNetwork = F3(
	function (field, location, network) {
		var _v0 = A2($author$project$Data$Location$locationDataFromNetwork, location, network);
		if (_v0.$ === 'Just') {
			var networkLocationData = _v0.a;
			switch (field.$) {
				case 'Name':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(networkLocationData.name))
						]);
				case 'CustomName':
					var network_ = field.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Network$toString(network_),
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'custom',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(networkLocationData.name))
												])))
									])))
						]);
				case 'StoreId':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(networkLocationData.storeId))
						]);
				case 'LocationDescriptor':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(networkLocationData.locationDescriptor))
						]);
				case 'Location':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'lat',
										$elm$json$Json$Encode$float(
											A2(
												$elm$core$Maybe$withDefault,
												0,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.lat;
													},
													networkLocationData.location)))),
										_Utils_Tuple2(
										'lon',
										$elm$json$Json$Encode$float(
											A2(
												$elm$core$Maybe$withDefault,
												0,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.lon;
													},
													networkLocationData.location))))
									])))
						]);
				case 'About':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(networkLocationData.about))
						]);
				case 'LongDescription':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(networkLocationData.longDescription))
						]);
				case 'Hours':
					return $author$project$Data$Location$OpenHours$encode(networkLocationData.openHours);
				case 'OpeningDate':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(networkLocationData.openingDate))
						]);
				case 'SpecialHours':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'specialOpenHours',
							A2($elm$json$Json$Encode$list, $author$project$Data$Location$SpecialOpenHours$encode, networkLocationData.specialOpenHours))
						]);
				case 'PermanentlyClosed':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$bool(networkLocationData.permanentlyClosed))
						]);
				case 'TemporarilyClosedUntil':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Data$NetworkData$TemporarilyClosed$toString(networkLocationData.temporarilyClosedUntil))))
						]);
				case 'Email':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'contact',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Data$Location$Field$toString(field),
										$elm$json$Json$Encode$string(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$elm$core$List$head(networkLocationData.emails))))
									])))
						]);
				case 'Homepage':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'contact',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Data$Location$Field$toString(field),
										$elm$json$Json$Encode$string(networkLocationData.homepage))
									])))
						]);
				case 'Phone':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'contact',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										$author$project$Data$Location$Field$toString(field),
										$elm$json$Json$Encode$string(networkLocationData.phone))
									])))
						]);
				case 'Address':
					return A2($author$project$Data$Location$addressEncoder, field, networkLocationData);
				case 'CoverImage':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string('locationData.coverImage'))
						]);
				case 'ProfileImage':
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string('locationData.profileImage'))
						]);
				case 'NetworkCategories':
					return $author$project$Data$Location$encodeNetworkCateogriesFieldInLocationFromNetwork(networkLocationData.networkCategories);
				case 'NetworkAttributes':
					return $author$project$Data$Location$encodeAttributesFieldInLocationFromNetwork(networkLocationData.attributes);
				case 'ActionLinks':
					return $author$project$Data$Location$encodeActionLinksFieldInLocationFromNetwork(networkLocationData.actionLinks);
				case 'NetworkServiceItems':
					return $author$project$Data$Location$encodeNetworkServiceItemsFieldInLocationFromNetwork(networkLocationData.serviceItems);
				case 'ServiceAreas':
					var encoder = function () {
						var _v2 = networkLocationData.serviceAreas;
						if (_v2.$ === 'WithPlaceId') {
							var a = _v2.a;
							return $author$project$Data$ServiceArea$encodeServiceAreas(a);
						} else {
							return $elm$json$Json$Encode$null;
						}
					}();
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							encoder)
						]);
				case 'Wifi':
					var _v3 = location.wifiSsId;
					var wifi = _v3.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Data$Location$Field$toString(field),
							$elm$json$Json$Encode$string(wifi))
						]);
				default:
					return _List_Nil;
			}
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Data$Location$Field$toString(field),
					$elm$json$Json$Encode$string(''))
				]);
		}
	});
var $author$project$Data$Location$fieldsInLocationFromNetworkEncoder = F3(
	function (fields, location, network) {
		return $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (field) {
						return A3($author$project$Data$Location$encodeFieldInLocationFromNetwork, field, location, network);
					},
					fields)));
	});
var $author$project$Conflicts$Commands$updateFieldsInLocationFromNetworkData = F6(
	function (account, fields, location, network, msg, now) {
		var mergeSpecialOpenHours = F2(
			function (network_, location_) {
				var networkSpecialOpenHours = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.data;
							},
							function ($) {
								return $.specialOpenHours;
							}),
						A2($author$project$Data$Location$networkDataFromNetwork, location_, network_)));
				var updateSpecialOpenHours = F2(
					function (data, x) {
						return _Utils_update(
							data,
							{specialOpenHours: x});
					});
				var existingLabel = function (date) {
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2($elm$core$Maybe$withDefault, '', x.label);
						},
						A2($author$project$Data$Location$SpecialOpenHours$findByDate, date, location.specialOpenHours));
				};
				var expiredLocal = A2($author$project$Data$Location$SpecialOpenHours$withExpired, location_.specialOpenHours, now);
				var merged = _Utils_ap(
					expiredLocal,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_update(
								x,
								{
									label: existingLabel(x.startDate)
								});
						},
						A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, networkSpecialOpenHours, now)));
				return _Utils_update(
					location,
					{
						apple: A2(
							$elm$core$Maybe$map,
							function (x) {
								return _Utils_update(
									x,
									{
										data: A2(updateSpecialOpenHours, x.data, merged)
									});
							},
							location.apple),
						google: A2(
							$elm$core$Maybe$map,
							function (x) {
								return _Utils_update(
									x,
									{
										data: A2(updateSpecialOpenHours, x.data, merged)
									});
							},
							location.google),
						facebook: A2(
							$elm$core$Maybe$map,
							function (x) {
								return _Utils_update(
									x,
									{
										data: A2(updateSpecialOpenHours, x.data, merged)
									});
							},
							location.facebook)
					});
			});
		var prepareData = function (location_) {
			return A2($elm$core$List$member, $author$project$Data$Location$Field$SpecialHours, fields) ? A2(mergeSpecialOpenHours, network, location_) : location;
		};
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$Conflicts$Commands$partialUpdateResultDecoder, account.features, fields),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A3(
						$author$project$Data$Location$fieldsInLocationFromNetworkEncoder,
						fields,
						prepareData(location),
						network),
					$lukewestby$elm_http_builder$HttpBuilder$post(
						'api/' + ($author$project$Data$SiteName$toString(account.name) + ('/conflicts/resolve/' + (location.id + ('/' + $author$project$Data$Network$toString(network)))))))));
	});
var $author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_editCommand = _Platform_outgoingPort('out_Conflicts_Resolver_Main_editCommand', $elm$core$Basics$identity);
var $author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_setCurrentIdCommand = _Platform_outgoingPort('out_Conflicts_Resolver_Main_setCurrentIdCommand', $elm$json$Json$Encode$string);
var $author$project$Conflicts$Resolver$Update$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var getSupportedFields = F2(
				function (location, allConflictsResolved) {
					var serviceItemsCmd = ((A2(
						$elm$core$List$member,
						$author$project$Data$Location$Field$NetworkServiceItems($author$project$Data$Network$Google),
						model.fields) || $elm$core$List$isEmpty(model.fields)) && (!allConflictsResolved)) ? A3(
						$author$project$Data$NetworkData$GoogleServiceItems$getGoogleSupportedServiceItems,
						model.account.name,
						$author$project$Conflicts$Resolver$Update$listAllCategories(location.networkCategories.google),
						$author$project$Conflicts$Resolver$Types$OnLocationGoogleServiceItems) : $elm$core$Platform$Cmd$none;
					var attributeCmd = ((A2(
						$elm$core$List$member,
						$author$project$Data$Location$Field$NetworkAttributes($author$project$Data$Network$Google),
						model.fields) || $elm$core$List$isEmpty(model.fields)) && (!allConflictsResolved)) ? A3($author$project$Data$NetworkData$GoogleAttributes$getLocationGoogleAttributes, model.account.name, location.id, $author$project$Conflicts$Resolver$Types$OnLocationGoogleAttributes) : $elm$core$Platform$Cmd$none;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[attributeCmd, serviceItemsCmd]));
				});
			switch (msg.$) {
				case 'OnTimeZone':
					var zone = msg.a;
					var originalConfig = model.config;
					var configWithTimeZone = _Utils_update(
						originalConfig,
						{timeZone: zone});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{config: configWithTimeZone}),
						$elm$core$Platform$Cmd$none);
				case 'KeyboardMsg':
					var keyMsg = msg.a;
					var _v1 = A3($ohanhi$keyboard$Keyboard$updateWithKeyChange, $ohanhi$keyboard$Keyboard$anyKeyOriginal, keyMsg, model.pressedKeys);
					var pressedKeys = _v1.a;
					var maybeKeyChange = _v1.b;
					var isEditing = function (locationId) {
						return A2(
							$elm$core$List$any,
							$elm$core$Basics$identity,
							A2(
								$elm$core$List$map,
								function (x) {
									return A3($author$project$Conflicts$Resolver$ConflictStates$isEditing, x, locationId, model.conflictStates);
								},
								model.fields));
					};
					var isEditingCurrent = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							isEditing,
							$author$project$Common$Pagination$currentItem(model.pagination)));
					var newModel = _Utils_update(
						model,
						{pressedKeys: pressedKeys});
					var maxPage = $author$project$Common$Pagination$pageCount(model.pagination);
					var _v2 = _Utils_Tuple2(isEditingCurrent, maybeKeyChange);
					_v2$2:
					while (true) {
						if (((!_v2.a) && (_v2.b.$ === 'Just')) && (_v2.b.a.$ === 'KeyDown')) {
							switch (_v2.b.a.a.$) {
								case 'ArrowRight':
									var _v3 = _v2.b.a.a;
									if (_Utils_cmp(model.pagination.currentPage + 1, maxPage) < 0) {
										var $temp$msg = $author$project$Conflicts$Resolver$Types$OnPageChange(model.pagination.currentPage + 1),
											$temp$model = model;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									} else {
										return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
									}
								case 'ArrowLeft':
									var _v4 = _v2.b.a.a;
									if (model.pagination.currentPage > 0) {
										var $temp$msg = $author$project$Conflicts$Resolver$Types$OnPageChange(model.pagination.currentPage - 1),
											$temp$model = model;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									} else {
										return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
									}
								default:
									break _v2$2;
							}
						} else {
							break _v2$2;
						}
					}
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				case 'HandleFlags':
					var flagsValue = msg.a;
					var getTimeZone = A2(
						$elm$core$Task$onError,
						$elm$core$Basics$always(
							$elm$core$Task$succeed($elm$time$Time$utc)),
						A2($elm$core$Task$map, $elm$core$Tuple$second, $justinmimbs$timezone_data$TimeZone$getZone));
					var _v5 = $author$project$Conflicts$Resolver$Flags$decodeFlags(flagsValue);
					if (_v5.$ === 'Ok') {
						var flags = _v5.a;
						return _Utils_Tuple2(
							A4($author$project$Conflicts$Resolver$Model$init, flags.account, flags.fields, flags.editableFields, flags.translations),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Task$perform, $author$project$Conflicts$Resolver$Types$OnTime, $elm$time$Time$now),
										A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										A3(
											$author$project$Conflicts$Commands$getSummariesWithConflicts,
											flags.account,
											flags.fields,
											$author$project$Conflicts$Resolver$Types$OnSummaries(flags.locationId)),
										function (locationId) {
											var _v6 = flags.conflictResolverType;
											if (_v6.$ === 'Location') {
												return A4(
													$author$project$Conflicts$Commands$getLocationSummaryWithConflicts,
													flags.account,
													locationId,
													flags.fields,
													$author$project$Conflicts$Resolver$Types$OnSummaries(flags.locationId));
											} else {
												return A3(
													$author$project$Conflicts$Commands$getSummariesWithConflicts,
													flags.account,
													flags.fields,
													$author$project$Conflicts$Resolver$Types$OnSummaries(flags.locationId));
											}
										},
										flags.locationId),
										A2($elm$core$Task$perform, $author$project$Conflicts$Resolver$Types$OnTimeZone, getTimeZone),
										A2($author$project$Conflicts$Commands$getListingsManagerPoliciesEnabled, flags.account.name, $author$project$Conflicts$Resolver$Types$OnListingsManagerPoliciesEnabled)
									])));
					} else {
						var err = _v5.a;
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(err),
									context: 'Conflicts.Resolver.Update',
									message: 'Failed to decode flags for msg HandleFlags'
								}));
					}
				case 'UpdateLocation':
					var flags = msg.a;
					var summaries = msg.b;
					var pagination = msg.c;
					var newModel = A4($author$project$Conflicts$Resolver$Model$init, flags.account, flags.fields, flags.editableFields, flags.translations);
					var conflictModel = _Utils_update(
						newModel,
						{summaries: summaries, pagination: pagination, listingsManagerPoliciesEnabled: model.listingsManagerPoliciesEnabled});
					return _Utils_Tuple2(
						conflictModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_setCurrentIdCommand,
										$author$project$Common$Pagination$currentItem(pagination)))
								])));
				case 'EditorClosed':
					var data = msg.a;
					var dataDecoder = A3(
						$elm$json$Json$Decode$map2,
						F2(
							function (field, locationId) {
								return _Utils_Tuple2(
									$author$project$Data$Location$Field$fromString(field),
									locationId);
							}),
						A2($elm$json$Json$Decode$field, 'field', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'locationId', $elm$json$Json$Decode$string));
					var _v7 = A2($elm$json$Json$Decode$decodeValue, dataDecoder, data);
					if (_v7.$ === 'Ok') {
						if (_v7.a.a.$ === 'Just') {
							var _v8 = _v7.a;
							var field = _v8.a.a;
							var locationId = _v8.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$reset, field, locationId, model.conflictStates)
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v9 = _v7.a;
							var _v10 = _v9.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										errorMessage: $elm$core$Maybe$Just('There was no field')
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						var e = _v7.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errorMessage: $elm$core$Maybe$Just(
										$elm$json$Json$Decode$errorToString(e))
								}),
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(e),
									context: 'Conflicts.Resolver.Update',
									message: 'EditorClosed failed'
								}));
					}
				case 'EditorUpdated':
					var json = msg.a;
					var _v11 = A2(
						$elm$json$Json$Decode$decodeValue,
						$author$project$Conflicts$Resolver$Update$editorUpdatedDecoder(model.account.features),
						json);
					if (_v11.$ === 'Ok') {
						var location = _v11.a.location;
						var field = _v11.a.field;
						var _v12 = A3(
							$author$project$Conflicts$Resolver$Update$saveLocal,
							field,
							location,
							function (m) {
								return _Utils_update(
									m,
									{
										pagination: A3(
											$author$project$Common$Pagination$updateLoaded,
											location.id,
											function (x) {
												return A3($author$project$Data$Location$updateDataInField, field, x, location);
											},
											m.pagination)
									});
							}(model));
						var updatedModel = _v12.a;
						var cmd = _v12.b;
						return _Utils_Tuple2(
							_Utils_update(
								updatedModel,
								{
									pagination: A3(
										$author$project$Common$Pagination$updateLoaded,
										location.id,
										function (x) {
											return A3($author$project$Data$Location$updateDataInField, field, x, location);
										},
										updatedModel.pagination)
								}),
							cmd);
					} else {
						var e = _v11.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errorMessage: $elm$core$Maybe$Just(
										$elm$json$Json$Decode$errorToString(e))
								}),
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(e),
									context: 'Conflicts.Resolver.Update',
									message: 'EditorUpdated failed'
								}));
					}
				case 'WorkSucceeded':
					var workId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								conflictStates: A2($author$project$Conflicts$Resolver$ConflictStates$resolveWork, workId, model.conflictStates)
							}),
						$elm$core$Platform$Cmd$none);
				case 'WorkFailed':
					var workId = msg.a;
					return _Utils_Tuple2(
						model,
						A3(
							$author$project$Conflicts$Commands$getWorkErrorDetails,
							model.account.name,
							workId,
							$author$project$Conflicts$Resolver$Types$WorkErrorDetails(workId)));
				case 'OnUpdatedLocations':
					if (msg.c.$ === 'Ok') {
						var workId = msg.a;
						var workErrors = msg.b;
						var locations = msg.c.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
							function (location) {
								var currentLocation = $author$project$Common$Pagination$currentData(model.pagination);
								var fields = A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									_List_Nil,
									function (_v14) {
										var field = _v14.a;
										return _List_fromArray(
											[field]);
									},
									A2($author$project$Conflicts$Resolver$ConflictStates$getByWorkId, workId, model.conflictStates));
								var networksWithConflicts = A2(
									$elm$core$List$filter,
									A2($author$project$Data$Location$hasConflictInFieldsInNetwork, fields, location),
									$author$project$Data$Network$allNetworks);
								var allConflictsResolved = !$elm$core$List$length(
									A2(
										$elm$core$List$filter,
										function (network) {
											return A3($author$project$Data$Location$hasConflictInFieldsInNetwork, fields, location, network);
										},
										networksWithConflicts));
								var pageData = function () {
									var newLoc = allConflictsResolved ? A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										location,
										function (oldLocation) {
											return A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												location,
												function (_v13) {
													var field = _v13.a;
													return A3($author$project$Data$Location$updateDataInField, field, oldLocation, location);
												},
												A2($author$project$Conflicts$Resolver$ConflictStates$getByWorkId, workId, model.conflictStates));
										},
										currentLocation) : location;
									return _List_fromArray(
										[
											_Utils_Tuple2(location.id, newLoc)
										]);
								}();
								var insert = A2($author$project$Common$Pagination$insertData, pageData, model.pagination);
								var workAction = allConflictsResolved ? A2($author$project$Conflicts$Resolver$ConflictStates$resolveWork, workId, model.conflictStates) : A2($author$project$Conflicts$Resolver$ConflictStates$failWork, workErrors, model.conflictStates);
								var newConflictModel = _Utils_update(
									model,
									{pagination: insert, conflictStates: workAction});
								return _Utils_Tuple2(
									newConflictModel,
									A2(getSupportedFields, location, allConflictsResolved));
							},
							$elm$core$List$head(locations));
					} else {
						var err = msg.c.a;
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'OnUpdatedLocations failed'}));
					}
				case 'WorkErrorDetails':
					if (msg.b.$ === 'Ok') {
						var workId = msg.a;
						var workErrors = msg.b.a;
						var cmd_ = A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Platform$Cmd$none,
							function (_v15) {
								var locationId = _v15.b;
								return A4(
									$author$project$Conflicts$Commands$getLocation,
									model.account,
									model.fields,
									locationId,
									A2($author$project$Conflicts$Resolver$Types$OnUpdatedLocations, workId, workErrors));
							},
							A2($author$project$Conflicts$Resolver$ConflictStates$getByWorkId, workId, model.conflictStates));
						return _Utils_Tuple2(model, cmd_);
					} else {
						var workId = msg.a;
						var err = msg.b.a;
						var error = A2(
							$author$project$Data$Work$WorkErrors,
							workId,
							_List_fromArray(
								[
									A4(
									$author$project$Data$Work$WorkError,
									$author$project$Translations$Listings$Conflicts$workError(model.translations),
									$elm$core$Maybe$Nothing,
									_List_Nil,
									_List_Nil)
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A2($author$project$Conflicts$Resolver$ConflictStates$failWork, error, model.conflictStates)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'WorkErrorDetails failed'}));
					}
				case 'SetDataInFieldSelected':
					var x = msg.a;
					var _v16 = $author$project$Data$Location$Field$fromString(x.field);
					if (_v16.$ === 'Just') {
						var field = _v16.a;
						if (!x.selected) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$deSelect, field, x.locationId, model.conflictStates)
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v17 = $author$project$Data$Network$fromString(x.network);
							if (_v17.$ === 'Just') {
								var network = _v17.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											conflictStates: A4($author$project$Conflicts$Resolver$ConflictStates$selectNetwork, network, field, x.locationId, model.conflictStates)
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$selectLocal, field, x.locationId, model.conflictStates)
										}),
									$elm$core$Platform$Cmd$none);
							}
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'SaveDataInField':
					var x = msg.a;
					var _v18 = _Utils_Tuple2(
						$author$project$Data$Location$Field$fromString(x.field),
						$author$project$Common$Pagination$currentData(model.pagination));
					if ((_v18.a.$ === 'Just') && (_v18.b.$ === 'Just')) {
						var field = _v18.a.a;
						var location = _v18.b.a;
						var _v19 = $author$project$Data$Network$fromString(x.network);
						if (_v19.$ === 'Just') {
							var network = _v19.a;
							var $temp$msg = A3($author$project$Conflicts$Resolver$Types$SaveNetwork, network, field, location),
								$temp$model = model;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							return A3($author$project$Conflicts$Resolver$Update$saveLocal, field, location, model);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'UpdateDataInField':
					var x = msg.a;
					var _v20 = _Utils_Tuple2(
						A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Coordinates$coordinatesDecoder, x.data),
						$author$project$Data$Location$Field$fromString(x.field));
					if (_v20.a.$ === 'Ok') {
						if (_v20.b.$ === 'Just') {
							var lonLat = _v20.a.a;
							var field = _v20.b.a;
							return _Utils_eq(field, $author$project$Data$Location$Field$Location) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										pagination: A3(
											$author$project$Common$Pagination$updateLoaded,
											x.locationId,
											function (x_) {
												return _Utils_update(
													x_,
													{location: lonLat});
											},
											model.pagination)
									}),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						var e = _v20.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errorMessage: $elm$core$Maybe$Just(
										$elm$json$Json$Decode$errorToString(e))
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnSummaries':
					var locationId = msg.a;
					var result = msg.b;
					var pagination = function (data) {
						if (locationId.$ === 'Just') {
							var locationId_ = locationId.a;
							return A5(
								$author$project$Conflicts$Resolver$Update$paginate,
								model.account,
								$elm$core$List$isEmpty(model.fields) ? $elm$core$Maybe$Just(locationId_) : $elm$core$Maybe$Nothing,
								model.fields,
								$author$project$Common$Pagination$Right,
								A2(
									$author$project$Common$Pagination$initWithItemsAndCurrent,
									$elm$core$Array$fromList(
										A2(
											$elm$core$List$map,
											function (x) {
												return x.id;
											},
											data)),
									locationId_));
						} else {
							return A5(
								$author$project$Conflicts$Resolver$Update$paginate,
								model.account,
								$elm$core$Maybe$Nothing,
								model.fields,
								$author$project$Common$Pagination$Right,
								$author$project$Common$Pagination$initWithItems(
									$elm$core$Array$fromList(
										A2(
											$elm$core$List$map,
											function (x) {
												return x.id;
											},
											data))));
						}
					};
					var onError = function (err) {
						return _Utils_Tuple2(
							model,
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'Failed to handle result for msg OnSummaries'}));
					};
					var comp = F2(
						function (a, b) {
							var _v22 = A2(
								$elm$core$Basics$compare,
								$elm$core$String$toUpper(b.id),
								$elm$core$String$toUpper(a.id));
							switch (_v22.$) {
								case 'LT':
									return $elm$core$Basics$GT;
								case 'EQ':
									return $elm$core$Basics$EQ;
								default:
									return $elm$core$Basics$LT;
							}
						});
					var onSuccess = function (data) {
						var list = A2($elm$core$List$sortWith, comp, data);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									summaries: $elm$core$Maybe$Just(
										$elm$core$Array$fromList(list)),
									pagination: pagination(list).a,
									conflictStates: $author$project$Conflicts$Resolver$ConflictStates$empty
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_setCurrentIdCommand(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Common$Pagination$currentItem(
												pagination(list).a))),
										pagination(list).b
									])));
					};
					if (result.$ === 'Ok') {
						var data = result.a;
						return onSuccess(data);
					} else {
						var e = result.a;
						return onError(e);
					}
				case 'OnLocations':
					if (msg.a.$ === 'Ok') {
						var data = msg.a.a;
						var pagination = A2(
							$author$project$Common$Pagination$insertData,
							A2(
								$elm$core$List$map,
								function (x) {
									return _Utils_Tuple2(x.id, x);
								},
								data),
							model.pagination);
						var location = $author$project$Common$Pagination$currentData(pagination);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									pagination: pagination,
									conflictStates: A3(
										$elm$core$List$foldl,
										F2(
											function (x, a) {
												return A3($author$project$Conflicts$Resolver$Model$conflictsStatesFromLocation, model.fields, x, a);
											}),
										model.conflictStates,
										data)
								}),
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Platform$Cmd$none,
								function (location_) {
									return A2(getSupportedFields, location_, false);
								},
								location));
					} else {
						var err = msg.a.a;
						var errMsg = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									errorMessage: $elm$core$Maybe$Just(
										_Utils_ap(
											$author$project$Translations$Listings$Conflicts$errorLoadingConflicts(model.translations),
											errMsg))
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Conflicts.Resolver.Update'),
								err));
					}
				case 'OnTime':
					var t = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{time: t}),
						$elm$core$Platform$Cmd$none);
				case 'OnPageInputSubmit':
					var $temp$msg = $author$project$Conflicts$Resolver$Types$OnPageChange(model.pagination.value - 1),
						$temp$model = model;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 'OnPageInputChange':
					var newPage = msg.a;
					var newPagination = A2(
						$author$project$Common$Pagination$setInputValue,
						A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(newPage)),
						model.pagination);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{pagination: newPagination, selectedPinId: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'OnPageChange':
					var newPage = msg.a;
					return function (pagination) {
						var newPagination = A5(
							$author$project$Conflicts$Resolver$Update$paginate,
							model.account,
							$elm$core$Maybe$Nothing,
							model.fields,
							(newPage > 0) ? $author$project$Common$Pagination$Right : $author$project$Common$Pagination$Left,
							pagination);
						var location = $author$project$Common$Pagination$currentData(pagination);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{pagination: newPagination.a, selectedPinId: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Task$perform, $author$project$Conflicts$Resolver$Types$OnTime, $elm$time$Time$now),
										A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_setCurrentIdCommand,
											$author$project$Common$Pagination$currentItem(pagination))),
										newPagination.b,
										A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$elm$core$Platform$Cmd$none,
										function (location_) {
											return A2(getSupportedFields, location_, false);
										},
										location)
									])));
					}(
						A2($author$project$Common$Pagination$changePage, newPage, model.pagination));
				case 'EditLocal':
					var field = msg.a;
					var location = msg.b;
					var _v24 = $author$project$Conflicts$Resolver$Update$imageEditorTarget(field);
					if (_v24.$ === 'Just') {
						var target = _v24.a;
						var _v25 = A3($author$project$Location$ImageEditor$init, target, model.account.name, location.id);
						var imageEditor = _v25.a;
						var cmd = _v25.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									imageEditor: $elm$core$Maybe$Just(
										{field: field, editor: imageEditor, locationId: location.id}),
									conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$editLocal, field, location, model.conflictStates)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Conflicts$Resolver$Types$ImageEditorMsg, cmd));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$editLocal, field, location, model.conflictStates)
								}),
							$author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_editCommand(
								$author$project$Conflicts$Resolver$ExternalCommand$editCommandEncoder(
									{field: field, location: location})));
					}
				case 'ImageEditorMsg':
					var msg_ = msg.a;
					var _v26 = model.imageEditor;
					if (_v26.$ === 'Just') {
						var open = _v26.a;
						var _v27 = A3(
							$author$project$Location$ImageEditor$update,
							{cropImage: $author$project$Conflicts$Resolver$Update$out_Conflicts_Resolver_Main_cropImage},
							msg_,
							open.editor);
						var editor = _v27.a;
						var cmd = _v27.b;
						var event = _v27.c;
						if (event.$ === 'Nothing') {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										imageEditor: $elm$core$Maybe$Just(
											_Utils_update(
												open,
												{editor: editor}))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Conflicts$Resolver$Types$ImageEditorMsg, cmd));
						} else {
							if (event.a.$ === 'Closed') {
								var _v29 = event.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											imageEditor: $elm$core$Maybe$Nothing,
											conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$reset, open.field, open.locationId, model.conflictStates)
										}),
									A2($elm$core$Platform$Cmd$map, $author$project$Conflicts$Resolver$Types$ImageEditorMsg, cmd));
							} else {
								var body = event.a.a.body;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											imageEditor: $elm$core$Maybe$Just(
												_Utils_update(
													open,
													{
														editor: $author$project$Location$ImageEditor$withSaving(editor)
													}))
										}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Conflicts$Resolver$Types$ImageEditorMsg, cmd),
												A6(
												$author$project$Location$Details$Commands$sendToPartialUpdate_,
												model.account.name,
												open.locationId,
												$author$project$Data$Account$emptyFeatures,
												$elm$core$Maybe$Nothing,
												$author$project$Conflicts$Resolver$Types$ImageEditorSaved(open.field),
												body)
											])));
							}
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'ImageEditorSaved':
					if (msg.b.$ === 'Ok') {
						var field = msg.a;
						var result = msg.b.a;
						var $temp$msg = A2($author$project$Conflicts$Resolver$Types$LocationDetailsEditorUpdated, field, result.location),
							$temp$model = _Utils_update(
							model,
							{imageEditor: $elm$core$Maybe$Nothing});
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var err = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									imageEditor: A2(
										$elm$core$Maybe$map,
										function (open) {
											return _Utils_update(
												open,
												{
													editor: A2(
														$author$project$Location$ImageEditor$withError,
														$author$project$Translations$Listings$LocationDetail$imageEditorSaveFailed(model.translations),
														open.editor)
												});
										},
										model.imageEditor)
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Conflicts.Resolver.Update.ImageEditorSaved'),
								err));
					}
				case 'LocationDetailsEditorOpen':
					var field = msg.a;
					var editor = msg.b;
					var location = msg.c;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (editorModel) {
							return _Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(
										_Utils_Tuple2(field, editorModel))
								});
						},
						$elm$core$Platform$Cmd$map(
							$author$project$Conflicts$Resolver$Types$LocationDetailsEditorMsg(location.id)),
						A7(
							$author$project$Location$Details$Editor$init,
							location.networkCategories,
							model.time,
							location,
							{locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, language: $author$project$PinMeTo$Ui$I18n$Language$En, siteName: model.account.name, analytics: $author$project$PinMeToPage$defaultAnalytics, translations: model.translations},
							false,
							_List_Nil,
							editor));
				case 'LocationDetailsEditorClose':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editor: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'SideBarSpecialOpenHoursUpdated':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{editor: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'LdpSpecialOpenHoursUpdated':
					var field = msg.a;
					var location = msg.b;
					var _v30 = A3(
						$author$project$Conflicts$Resolver$Update$saveLocal,
						field,
						location,
						function (m) {
							return _Utils_update(
								m,
								{
									pagination: A3(
										$author$project$Common$Pagination$updateLoaded,
										location.id,
										function (x) {
											return A3($author$project$Data$Location$updateDataInField, field, x, location);
										},
										m.pagination)
								});
						}(model));
					var updatedModel = _v30.a;
					var cmd = _v30.b;
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								editor: $elm$core$Maybe$Nothing,
								pagination: A3(
									$author$project$Common$Pagination$updateLoaded,
									location.id,
									function (x) {
										return A3($author$project$Data$Location$updateDataInField, field, x, location);
									},
									updatedModel.pagination)
							}),
						cmd);
				case 'LocationDetailsEditorUpdated':
					var field = msg.a;
					var location = msg.b;
					var _v31 = A3(
						$author$project$Conflicts$Resolver$Update$saveLocal,
						field,
						location,
						function (m) {
							return _Utils_update(
								m,
								{
									pagination: A3(
										$author$project$Common$Pagination$updateLoaded,
										location.id,
										function (x) {
											return A3($author$project$Data$Location$updateDataInField, field, x, location);
										},
										m.pagination)
								});
						}(model));
					var updatedModel = _v31.a;
					var cmd = _v31.b;
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								editor: $elm$core$Maybe$Nothing,
								pagination: A3(
									$author$project$Common$Pagination$updateLoaded,
									location.id,
									function (x) {
										return A3($author$project$Data$Location$updateDataInField, field, x, location);
									},
									updatedModel.pagination)
							}),
						cmd);
				case 'LocationDetailsEditorMsg':
					var locationId = msg.a;
					var msg_ = msg.b;
					var _v32 = model.editor;
					if (_v32.$ === 'Just') {
						var _v33 = _v32.a;
						var field = _v33.a;
						var editor = _v33.b;
						var updateCommandLdpSpecialOpenHours = A4(
							$author$project$Location$Details$Commands$sendToOverwriteSpecialOpenHours,
							model.account.name,
							locationId,
							{allowPtvTwoWay: false, appleCustomName: false, allowMediaReview: false, googleCustomName: false, facebookCustomName: false, allowCustomStoreName: false},
							$elm$core$Maybe$Nothing);
						var _v34 = A4(
							$author$project$Location$Details$Editor$update,
							{
								tagger: $author$project$Conflicts$Resolver$Types$LocationDetailsEditorMsg(locationId),
								siteName: model.account.name,
								onUpdated: $author$project$Conflicts$Resolver$Types$LocationDetailsEditorUpdated(field),
								onScheduled: $elm$core$Maybe$Nothing,
								deleteCommand: A2($author$project$Location$Details$Commands$deleteScheduleUpdate, model.account.name, locationId),
								updateCommand: A4($author$project$Location$Details$Commands$sendToPartialUpdate_, model.account.name, locationId, $author$project$Data$Account$emptyFeatures, $elm$core$Maybe$Nothing),
								scheduleCommand: A3($author$project$Location$Details$Commands$sendToScheduleUpdate_, model.account.name, $elm$core$Maybe$Nothing, locationId),
								onDeleteSchedule: $elm$core$Maybe$Nothing,
								saveGoogleAttributes: A4($author$project$Location$Details$Commands$saveGoogleAttributesFromLocationDetails, model.account.name, locationId, $author$project$Data$Account$emptyFeatures, $elm$core$Maybe$Nothing),
								saveGoogleSocialLinks: A4($author$project$Location$Details$Commands$saveGoogleSocialLinksFromLocationDetails, model.account.name, locationId, $author$project$Data$Account$emptyFeatures, $elm$core$Maybe$Nothing),
								onScheduleUpdatesRefreshed: $elm$core$Maybe$Nothing,
								onUpdatedLdpSpecialOpenHours: $author$project$Conflicts$Resolver$Types$LdpSpecialOpenHoursUpdated(field),
								onUpdatedSideBarSpecialOpenHours: $author$project$Conflicts$Resolver$Types$SideBarSpecialOpenHoursUpdated,
								updateCommandLdpSpecialOpenHours: $elm$core$Maybe$Just(updateCommandLdpSpecialOpenHours),
								updateCommandSideBarSpecialOpenHours: $elm$core$Maybe$Nothing
							},
							{language: $author$project$PinMeTo$Ui$I18n$Language$En, translations: model.translations},
							msg_,
							editor);
						var state = _v34.a;
						var cmd = _v34.b;
						var _v35 = editor;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									editor: $elm$core$Maybe$Just(
										_Utils_Tuple2(field, state))
								}),
							cmd);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'SaveLocal':
					var field = msg.a;
					var location = msg.b;
					return A3($author$project$Conflicts$Resolver$Update$saveLocal, field, location, model);
				case 'SaveNetwork':
					var network = msg.a;
					var field = msg.b;
					var location = msg.c;
					var publishLocation = _Utils_update(
						location,
						{
							specialOpenHours: A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, location.specialOpenHours, model.time)
						});
					var newModel = _Utils_update(
						model,
						{
							alertBox: $elm$core$Maybe$Nothing,
							selectedPinId: _Utils_eq(field, $author$project$Data$Location$Field$Location) ? $elm$core$Maybe$Just(
								$author$project$Data$Network$toString(network)) : model.selectedPinId,
							conflictStates: A4($author$project$Conflicts$Resolver$ConflictStates$saveNetwork, network, field, location.id, model.conflictStates)
						});
					switch (field.$) {
						case 'ProfileImage':
							return _Utils_Tuple2(
								newModel,
								A4(
									$author$project$Conflicts$Commands$useProfileImageFromNetwork,
									model.account.name,
									network,
									location,
									A3($author$project$Conflicts$Resolver$Types$OnSaveMediaFromNetwork, network, field, location.id)));
						case 'CoverImage':
							return _Utils_Tuple2(
								newModel,
								A4(
									$author$project$Conflicts$Commands$useCoverImageFromNetwork,
									model.account.name,
									network,
									location,
									A3($author$project$Conflicts$Resolver$Types$OnSaveMediaFromNetwork, network, field, location.id)));
						case 'NetworkAttributes':
							return _Utils_Tuple2(
								newModel,
								A4(
									$author$project$Conflicts$Commands$setAllGoogleAttributesFromGoogle,
									model.account,
									field,
									location.id,
									A3($author$project$Conflicts$Resolver$Types$OnSaveNetwork, network, field, location.id)));
						default:
							return _Utils_Tuple2(
								newModel,
								A6(
									$author$project$Conflicts$Commands$updateFieldsInLocationFromNetworkData,
									model.account,
									_List_fromArray(
										[field]),
									publishLocation,
									network,
									A3($author$project$Conflicts$Resolver$Types$OnSaveNetwork, network, field, location.id),
									model.time));
					}
				case 'OnSaveLocal':
					var field = msg.a;
					var locationId = msg.b;
					var result = msg.c;
					var onSuccess = function (data) {
						var location = data.location;
						var newLocation = _Utils_update(
							location,
							{
								specialOpenHours: A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, location.specialOpenHours, model.time)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4($author$project$Conflicts$Resolver$ConflictStates$workLocal, data.workId, field, newLocation, model.conflictStates)
								}),
							$elm$core$Platform$Cmd$none);
					};
					var onError = function (err) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4(
										$author$project$Conflicts$Resolver$ConflictStates$failWithError,
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err),
										field,
										locationId,
										model.conflictStates)
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Conflicts.Resolver.Update'),
								err));
					};
					if (result.$ === 'Ok') {
						var data = result.a;
						return onSuccess(data);
					} else {
						var e = result.a;
						return onError(e);
					}
				case 'OnSaveNetwork':
					var network = msg.a;
					var field = msg.b;
					var locationId = msg.c;
					var result = msg.d;
					var onSuccess = function (data) {
						var location = data.location;
						var newLocation = _Utils_update(
							location,
							{
								specialOpenHours: A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, location.specialOpenHours, model.time)
							});
						var p = A3(
							$author$project$Common$Pagination$updateLoaded,
							newLocation.id,
							function (x) {
								return A3($author$project$Data$Location$updateDataInField, field, x, newLocation);
							},
							model.pagination);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									pagination: p,
									conflictStates: A5($author$project$Conflicts$Resolver$ConflictStates$workNetwork, data.workId, network, field, newLocation, model.conflictStates)
								}),
							$elm$core$Platform$Cmd$none);
					};
					var onError = function (err) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4(
										$author$project$Conflicts$Resolver$ConflictStates$failWithError,
										$author$project$PinMeTo$ExpectJson$getErrorMessage(err),
										field,
										locationId,
										model.conflictStates)
								}),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Conflicts.Resolver.Update'),
								err));
					};
					if (result.$ === 'Ok') {
						var data = result.a;
						return onSuccess(data);
					} else {
						var e = result.a;
						return onError(e);
					}
				case 'OnSaveMediaFromNetwork':
					var field = msg.b;
					var locationId = msg.c;
					var result = msg.d;
					var onSuccess = function (data) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									pagination: A3(
										$author$project$Common$Pagination$updateLoaded,
										data.location.id,
										function (location) {
											return A3($author$project$Data$Location$updateMediaForField, field, data.media, location);
										},
										model.pagination),
									conflictStates: A3(
										$author$project$Conflicts$Resolver$ConflictStates$resolve,
										field,
										A3($author$project$Data$Location$updateMediaForField, field, data.media, data.location),
										model.conflictStates)
								}),
							$elm$core$Platform$Cmd$none);
					};
					var onError = function (err) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4(
										$author$project$Conflicts$Resolver$ConflictStates$failWithError,
										$author$project$Common$HandleResult$httpErrorUserMessage(err),
										field,
										locationId,
										model.conflictStates)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'OnSaveMediaFromNetwork failed'}));
					};
					if (result.$ === 'Ok') {
						var data = result.a;
						return onSuccess(data);
					} else {
						var e = result.a;
						return onError(e);
					}
				case 'ApproveDiff':
					var network = msg.a;
					var field = msg.b;
					var location = msg.c;
					var prop = msg.d;
					switch (prop) {
						case 'city':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										conflictStates: A4($author$project$Conflicts$Resolver$ConflictStates$saveNetwork, network, field, location.id, model.conflictStates)
									}),
								A6(
									$author$project$Conflicts$Commands$approveDiffInLocation,
									model.account,
									field,
									location,
									network,
									'city',
									A3($author$project$Conflicts$Resolver$Types$OnApproveDiff, network, field, location.id)));
						case 'province':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										conflictStates: A4($author$project$Conflicts$Resolver$ConflictStates$saveNetwork, network, field, location.id, model.conflictStates)
									}),
								A6(
									$author$project$Conflicts$Commands$approveDiffInLocation,
									model.account,
									field,
									location,
									network,
									'province',
									A3($author$project$Conflicts$Resolver$Types$OnApproveDiff, network, field, location.id)));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnApproveDiff':
					if (msg.d.$ === 'Ok') {
						var field = msg.b;
						var locationId = msg.c;
						var result = msg.d.a;
						return A2(
							$author$project$Data$Location$hasConflictInFields,
							_List_fromArray(
								[field]),
							result.data) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									pagination: A3($author$project$Common$Pagination$insertLoaded, result.data.id, result.data, model.pagination),
									conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$reset, field, locationId, model.conflictStates)
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A3($author$project$Conflicts$Resolver$ConflictStates$resolve, field, result.data, model.conflictStates)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var field = msg.b;
						var locationId = msg.c;
						var err = msg.d.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4(
										$author$project$Conflicts$Resolver$ConflictStates$failWithError,
										$author$project$Translations$Listings$Conflicts$couldNotApproveDiff(model.translations),
										field,
										locationId,
										model.conflictStates)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'OnApproveDiff failed'}));
					}
				case 'ResetState':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{summaries: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'ConfirmSaveNetwork':
					var msg_ = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								alertBox: $elm$core$Maybe$Just(
									$author$project$Conflicts$Resolver$Model$PrimaryCategories(msg_)),
								uiLightbox: $author$project$PinMeTo$Deprecated$Lightbox$open(model.uiLightbox)
							}),
						$elm$core$Platform$Cmd$none);
				case 'CloseConfirm':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{alertBox: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 'OnLocationGoogleAttributes':
					var result = msg.a;
					var onSuccess = function (data) {
						var meta = model.meta;
						var newMeta = _Utils_update(
							meta,
							{googleAttributes: data});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{meta: newMeta}),
							$elm$core$Platform$Cmd$none);
					};
					var onError = function (err) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4(
										$author$project$Conflicts$Resolver$ConflictStates$failWithError,
										$author$project$Common$HandleResult$httpErrorUserMessage(err),
										$author$project$Data$Location$Field$NetworkAttributes($author$project$Data$Network$Google),
										'',
										model.conflictStates)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'OnLocationGoogleAttributes failed'}));
					};
					if (result.$ === 'Ok') {
						var data = result.a;
						return onSuccess(data);
					} else {
						var e = result.a;
						return onError(e);
					}
				case 'OnLocationGoogleServiceItems':
					var result = msg.a;
					var onSuccess = function (data) {
						var meta = model.meta;
						var newMeta = _Utils_update(
							meta,
							{googleSupportedServiceItems: data});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{meta: newMeta}),
							$elm$core$Platform$Cmd$none);
					};
					var onError = function (err) {
						var error = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStates: A4(
										$author$project$Conflicts$Resolver$ConflictStates$failWithError,
										error,
										$author$project$Data$Location$Field$NetworkServiceItems($author$project$Data$Network$Google),
										'',
										model.conflictStates)
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{
									data: $elm$http$Http$BadBody(error),
									context: 'Conflicts.Resolver.Update',
									message: 'OnLocationGoogleServiceItems failed'
								}));
					};
					if (result.$ === 'Ok') {
						var data = result.a;
						return onSuccess(data);
					} else {
						var error = result.a;
						return onError(error);
					}
				case 'OnListingsManagerPoliciesEnabled':
					if (msg.a.$ === 'Ok') {
						var hasEnabledPolicy = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									listingsManagerPoliciesEnabled: $author$project$RemoteData$Loaded(hasEnabledPolicy)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									listingsManagerPoliciesEnabled: $author$project$RemoteData$Error(
										$author$project$Common$HandleResult$httpErrorUserMessage(err))
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: err, context: 'Conflicts.Resolver.Update', message: 'Failed to handle result for msg OnListingsManagerPoliciesEnabled'}));
					}
				case 'UiLightboxMsg':
					var msg_ = msg.a;
					var _v43 = A2($author$project$PinMeTo$Deprecated$Lightbox$update, msg_, model.uiLightbox);
					var newModel = _v43.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{alertBox: $elm$core$Maybe$Nothing, uiLightbox: newModel}),
						$elm$core$Platform$Cmd$none);
				case 'PinSelected':
					var pinId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{selectedPinId: pinId}),
						$elm$core$Platform$Cmd$none);
				default:
					var coordinates = msg.a;
					var updatedPagination = A2(
						$elm$core$Maybe$withDefault,
						model.pagination,
						A2(
							$elm$core$Maybe$map,
							function (locationId) {
								return A3(
									$author$project$Common$Pagination$updateLoaded,
									locationId,
									function (location) {
										return _Utils_update(
											location,
											{location: coordinates});
									},
									model.pagination);
							},
							$author$project$Common$Pagination$currentItem(model.pagination)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{pagination: updatedPagination}),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Conflicts$Resolver$Types$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Conflicts$Resolver$Main$init = function (flagsValue) {
	var _v0 = $author$project$Conflicts$Resolver$Flags$decodeFlags(flagsValue);
	if (_v0.$ === 'Ok') {
		var flags = _v0.a;
		return A2(
			$author$project$Conflicts$Resolver$Update$update,
			$author$project$Conflicts$Resolver$Types$HandleFlags(flagsValue),
			A4($author$project$Conflicts$Resolver$Model$init, flags.account, flags.fields, flags.editableFields, flags.translations));
	} else {
		var err = _v0.a;
		var m = {
			name: $author$project$Data$SiteName$SiteName(''),
			features: $author$project$Data$Account$emptyFeatures,
			networks: _List_Nil,
			displayName: ''
		};
		return _Utils_Tuple2(
			A4($author$project$Conflicts$Resolver$Model$init, m, _List_Nil, _List_Nil, $author$project$Common$Language$initialTranslationsFallback),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Conflicts.Resolver.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Translations$General$ok = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.ok');
};
var $author$project$Common$Pagination$view = F5(
	function (pagination, pageChangeMsg, onInputChangeMsg, onSubmitMsg, labels) {
		return A7(
			$author$project$PinMeTo$Ui$Pagination$view,
			pagination.currentPage,
			pagination.value,
			$elm$core$Array$length(pagination.items),
			pageChangeMsg,
			onInputChangeMsg,
			onSubmitMsg,
			labels);
	});
var $author$project$PinMeTo$Deprecated$Lightbox$view = function (config) {
	return config;
};
var $author$project$PinMeTo$Deprecated$Lightbox$Close = {$: 'Close'};
var $author$project$PinMeTo$Deprecated$Lightbox$onClickFinal = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{message: msg, preventDefault: true, stopPropagation: true}));
};
var $author$project$PinMeTo$Deprecated$Lightbox$render = F2(
	function (_v0, config) {
		var model = _v0.a;
		var contentStyle = function () {
			var _v2 = model.lightBoxStyle;
			switch (_v2.$) {
				case 'AlertStyle':
					return ' pmt-deprecated-lightbox__container--alert';
				case 'Normal':
					return '';
				default:
					return ' pmt-deprecated-lightbox__container--wide';
			}
		}();
		var _v1 = model.openState;
		if (_v1.$ === 'Open') {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-deprecated-lightbox')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-deprecated-lightbox__container' + contentStyle)
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$TitleBar$render(
								A2(
									$author$project$PinMeTo$Ui$TitleBar$withAsides,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-deprecated-lightbox__close fa fa-xmark'),
													$author$project$PinMeTo$Deprecated$Lightbox$onClickFinal(
													config.tagger($author$project$PinMeTo$Deprecated$Lightbox$Close))
												]),
											_List_Nil)
										]),
									$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(config.title))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-deprecated-lightbox__content')
									]),
								_List_fromArray(
									[config.content]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-deprecated-lightbox__overlay'),
								$author$project$PinMeTo$Deprecated$Lightbox$onClickFinal(
								config.tagger($author$project$PinMeTo$Deprecated$Lightbox$Close))
							]),
						_List_Nil)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$General$loading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.loading');
};
var $author$project$PinMeTo$Deprecated$Lightbox$AlertStyle = {$: 'AlertStyle'};
var $author$project$PinMeTo$Deprecated$Lightbox$alertStyle = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Deprecated$Lightbox$State(
		_Utils_update(
			model,
			{lightBoxStyle: $author$project$PinMeTo$Deprecated$Lightbox$AlertStyle}));
};
var $author$project$Translations$Listings$Conflicts$noLocation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.no_location');
};
var $author$project$Translations$Listings$ErrorMessages$staleData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.stale_data');
};
var $author$project$Translations$Listings$ErrorMessages$pinDropRequired = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.pin_drop_required');
};
var $author$project$Translations$Listings$ErrorMessages$sohWithoutOhSet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.soh_without_oh_set');
};
var $author$project$Translations$Listings$ErrorMessages$tooFastFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.too_fast_facebook');
};
var $author$project$Translations$Listings$ErrorMessages$invalidAttribute = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.invalid_attribute');
};
var $author$project$Translations$Listings$ErrorMessages$facebookUrlInvalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.facebook_url_invalid');
};
var $author$project$Translations$Listings$ErrorMessages$unsupportedCountry = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.unsupported_country');
};
var $author$project$Translations$Listings$ErrorMessages$facebookPermissions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.facebook_permissions');
};
var $author$project$Translations$Listings$ErrorMessages$locationNotVerified = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.location_not_verified');
};
var $author$project$Translations$Listings$ErrorMessages$phoneNumberNotValid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.phone_number_not_valid');
};
var $author$project$Translations$Listings$ErrorMessages$missingAddressFields = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.missing_address_fields');
};
var $author$project$Translations$Listings$ErrorMessages$invalidSocialMediaUrl = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.invalid_social_media_url');
};
var $author$project$Translations$Listings$ErrorMessages$noAccessTokenFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.no_access_token_facebook');
};
var $author$project$Translations$Listings$ErrorMessages$descriptionContainsUrl = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.description_contains_url');
};
var $author$project$Translations$Listings$ErrorMessages$locationEntityNotFound = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.location_entity_not_found');
};
var $author$project$Translations$Listings$ErrorMessages$shortDescriptionTooLong = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.short_description_too_long');
};
var $author$project$Translations$Listings$ErrorMessages$sohWithoutOhSetLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.soh_without_oh_set_link_text');
};
var $author$project$Translations$Listings$ErrorMessages$invalidAttributeLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.invalid_attribute_link_text');
};
var $author$project$Translations$Listings$ErrorMessages$phoneNumberEditsNotAllowed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.phone_number_edits_not_allowed');
};
var $author$project$Translations$Listings$ErrorMessages$specialOpenHoursCountLimit = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.special_open_hours_count_limit');
};
var $author$project$Translations$Listings$ErrorMessages$geoCoordinatesNotConsistent = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.geo_coordinates_not_consistent');
};
var $author$project$Translations$Listings$ErrorMessages$closedLocationNotToBeUpdated = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.closed_location_not_to_be_updated');
};
var $author$project$Translations$Listings$ErrorMessages$missingAddressFieldsLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.missing_address_fields_link_text');
};
var $author$project$Translations$Listings$ErrorMessages$descriptionContainsUrlLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.description_contains_url_link_text');
};
var $author$project$Translations$Listings$ErrorMessages$shortDescriptionTooLongLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.short_description_too_long_link_text');
};
var $author$project$Translations$Listings$ErrorMessages$twoFactorAuthenticationFacebook = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.two_factor_authentication_facebook');
};
var $author$project$Translations$Listings$ErrorMessages$locationNotEligibleForActionLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.location_not_eligible_for_action_links');
};
var $author$project$Translations$Listings$ErrorMessages$specialOpenHoursCountLimitLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.special_open_hours_count_limit_link_text');
};
var $author$project$Translations$Listings$ErrorMessages$fullThoroughfareUnsupportedCharacters = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.full_thoroughfare_unsupported_characters');
};
var $author$project$Translations$Listings$ErrorMessages$shortDescriptionUnsupportedCharacters = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.short_description_unsupported_characters');
};
var $author$project$Translations$Listings$ErrorMessages$twoFactorAuthenticationFacebookLinkText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.error_messages.two_factor_authentication_facebook_link_text');
};
var $author$project$Common$ErrorMessages$getError = F3(
	function (originalText, locationUrl, translations) {
		return A2($elm$core$String$contains, 'INVALID_LOCATION_CATEGORY', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$locationNotEligibleForActionLinks(translations))
				])) : (A2($elm$core$String$contains, 'A `CLOSED` location should not be updated if still `CLOSED`', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$closedLocationNotToBeUpdated(translations))
				])) : (A2($elm$core$String$contains, 'PIN_DROP_REQUIRED', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$pinDropRequired(translations))
				])) : (A2($elm$core$String$contains, 'check the accuracy of this address', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$pinDropRequired(translations))
				])) : (A2($elm$core$String$contains, 'PROFILE_DESCRIPTION_CONTAINS_URL', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$descriptionContainsUrl(translations)),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$descriptionContainsUrlLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'SPECIAL_HOURS_SET_WITHOUT_REGULAR_HOURS', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$sohWithoutOhSet(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$sohWithoutOhSetLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'shortDescription cannot be longer than 255 characters', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$shortDescriptionTooLong(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$shortDescriptionTooLongLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'Invalid attribute_id provided', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$invalidAttribute(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$invalidAttributeLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'is not a supported country', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unsupportedCountry(translations) + ' '),
					A2(
					$elm$html$Html$i,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(originalText)
						]))
				])) : (A2($elm$core$String$contains, 'STALE_DATA', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$staleData(translations))
				])) : (A2($elm$core$String$contains, 'FacebookData - No accessToken', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$noAccessTokenFacebook(translations))
				])) : (A2($elm$core$String$contains, 'INVALID_ATTRIBUTE_NAME', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$invalidAttribute(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$invalidAttributeLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'page business requires Two Factor Authentication', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$twoFactorAuthenticationFacebook(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://www.facebook.com/business/help/280940009201586?id=199156230960298')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$twoFactorAuthenticationFacebookLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'The operation was aborted', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, 'THROTTLED', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, 'Facebook\u0027s systems determined that you were going too fast', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$tooFastFacebook(translations))
				])) : (A2($elm$core$String$contains, 'ignore_coordinate_warnings', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$pinDropRequired(translations))
				])) : (A2($elm$core$String$contains, '(#100) Invalid parameter', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, 'INVALID_ADDRESS', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$pinDropRequired(translations))
				])) : (A2($elm$core$String$contains, 'MISSING_ADDRESS_COMPONENTS', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$pinDropRequired(translations))
				])) : (A2($elm$core$String$contains, 'INVALID_SOCIAL_MEDIA_PROFILE_URL', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$invalidSocialMediaUrl(translations))
				])) : (A2($elm$core$String$contains, 'UNVERIFIED_LOCATION', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$locationNotVerified(translations))
				])) : (A2($elm$core$String$contains, 'INVALID_PHONE_NUMBER', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$phoneNumberNotValid(translations))
				])) : (A2($elm$core$String$contains, 'You have entered an invalid phone number', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$phoneNumberNotValid(translations))
				])) : (A2($elm$core$String$contains, 'Contact support team', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, '\u0027subLocality\u0027 must be present', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$missingAddressFields(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$missingAddressFieldsLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, '(#371) This Facebook web address is invalid or unavailable', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$facebookUrlInvalid(translations))
				])) : (A2($elm$core$String$contains, 'Internal error encountered', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, 'Requested entity was not found', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$locationEntityNotFound(translations))
				])) : (A2($elm$core$String$contains, 'Cant find country \u0027undefined\u0027', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$missingAddressFields(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$missingAddressFieldsLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'Your Page\u0027s latitude/longitude coordinates aren\u0027t consistent with the city that it\u0027s in', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$geoCoordinatesNotConsistent(translations))
				])) : (A2($elm$core$String$contains, '\u0027subAdministrativeArea\u0027 must be present', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$missingAddressFields(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$missingAddressFieldsLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'LAT_LNG_TOO_FAR_FROM_ADDRESSS', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$pinDropRequired(translations))
				])) : (A2($elm$core$String$contains, 'PHONE_NUMBER_EDITS_NOT_ALLOWED', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$phoneNumberEditsNotAllowed(translations))
				])) : (A2($elm$core$String$contains, 'Count of items in \u0027specialHours\u0027 must be 50 or less', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$specialOpenHoursCountLimit(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$specialOpenHoursCountLimitLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'api.bingplaces.com', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, 'Internal error encountered', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, '\u0027subAdministrativeArea\u0027 must not be empty string', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$missingAddressFields(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$missingAddressFieldsLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, '\u0027fullThoroughfare\u0027 has unsupported character', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$fullThoroughfareUnsupportedCharacters(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$missingAddressFieldsLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, '\u0027text\u0027 has unsupported character', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$shortDescriptionUnsupportedCharacters(translations) + ' '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(locationUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$ErrorMessages$shortDescriptionTooLongLinkText(translations))
						]))
				])) : (A2($elm$core$String$contains, 'No matching document found for id', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$unexpected(translations))
				])) : (A2($elm$core$String$contains, '(#200) Permissions error', originalText) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$ErrorMessages$facebookPermissions(translations))
				])) : A2(
			$elm$html$Html$span,
			_List_Nil,
			A2(
				$elm$core$List$intersperse,
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
					$elm$core$List$map,
					$elm$html$Html$text,
					A2($elm$core$String$split, '\u000A', originalText)))))))))))))))))))))))))))))))))))))))))))));
	});
var $author$project$Conflicts$Resolver$View$errorBanner = F3(
	function (errorMessage, locationUrl, translations) {
		return $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Error,
				$author$project$PinMeTo$Ui$Alert$rich(
					_List_fromArray(
						[
							A3($author$project$Common$ErrorMessages$getError, errorMessage, locationUrl, translations)
						]))));
	});
var $author$project$FontAwesome$Regular$Icon$faArrowLeft = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-arrow-left');
var $author$project$Conflicts$Resolver$View$titleToHtml = F3(
	function (url, summary, translations) {
		var locationDescriptor = ($author$project$Data$Location$locationDescriptorToString(summary.locationDescriptor) === '') ? '' : (' ( ' + ($author$project$Data$Location$locationDescriptorToString(summary.locationDescriptor) + ' )'));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-resolver__title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$locationStoreId(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(url)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'data-test', 'titleBar.storeId')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Data$Location$storeIdToString(summary.storeId))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$location(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(url)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'data-test', 'titleBar.locationName')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(summary.name)
												]))
										])),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'data-test', 'titleBar.locationDescriptor')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(locationDescriptor)
												]))
										]))
								]))
						])),
					_Utils_eq(summary.locationType, $author$project$Data$Location$ServiceArea) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h6,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$locationAddress(translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$attribute, 'data-test', 'titleBar.address')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(summary.address.street + ', '),
											$elm$html$Html$text(summary.address.zip + (' ' + (summary.address.city + ', '))),
											$elm$html$Html$text(summary.address.country)
										]))
								]))
						]))
				]));
	});
var $author$project$Conflicts$Resolver$Types$CloseConfirm = {$: 'CloseConfirm'};
var $author$project$Conflicts$Resolver$Types$UiLightboxMsg = function (a) {
	return {$: 'UiLightboxMsg', a: a};
};
var $author$project$Translations$Listings$Conflicts$backToConflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.back_to_conflicts');
};
var $author$project$Translations$Listings$Conflicts$changingCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.changing_category');
};
var $author$project$Conflicts$Resolver$Types$OnPageInputChange = function (a) {
	return {$: 'OnPageInputChange', a: a};
};
var $author$project$Conflicts$Resolver$Types$OnPageInputSubmit = {$: 'OnPageInputSubmit'};
var $author$project$Conflicts$Resolver$View$FieldData$address = F2(
	function (location, translations) {
		return $author$project$Common$AddressEditor$view(
			A2($author$project$Common$AddressEditor$withAddress, location.address, translations));
	});
var $author$project$Conflicts$Resolver$View$FieldData$hasConflict = F2(
	function (field, location) {
		var hasConflictInNetwork = function (maybeNetwork) {
			if (maybeNetwork.$ === 'Just') {
				var network = maybeNetwork.a;
				return field(network.validation.dataDiff).hasDiff;
			} else {
				return false;
			}
		};
		return hasConflictInNetwork(location.facebook) || (hasConflictInNetwork(location.google) || (hasConflictInNetwork(location.bing) || hasConflictInNetwork(location.apple)));
	});
var $author$project$Conflicts$Resolver$View$FieldData$conflictData = F3(
	function (title, isConflict, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-field-editor-data__row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict ', isConflict)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
						]),
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$html$Html$text(''),
								function (title_) {
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(title_)
											]));
								},
								title)
							]),
						A2(
							$elm$core$List$map,
							function (paragraph_) {
								return A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-data__content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(paragraph_)
										]));
							},
							A2($elm$core$String$split, '\u000A', data))))
				]));
	});
var $author$project$Conflicts$Resolver$View$FieldData$nameField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.name;
				},
				location),
			location.name)
		]);
};
var $author$project$Conflicts$Resolver$View$FieldData$wifiField = function (location) {
	var _v0 = location.wifiSsId;
	var wifi = _v0.a;
	return _List_fromArray(
		[
			A3($author$project$Conflicts$Resolver$View$FieldData$conflictData, $elm$core$Maybe$Nothing, false, wifi)
		]);
};
var $author$project$Data$Location$replaceTemplateTags = F2(
	function (location, stringToReplace) {
		var tags = _List_fromArray(
			[
				_Utils_Tuple2('{{name}}', location.name),
				_Utils_Tuple2(
				'{{locationDescriptor}}',
				$author$project$Data$Location$locationDescriptorToString(location.locationDescriptor)),
				_Utils_Tuple2('{{street}}', location.address.street),
				_Utils_Tuple2('{{zip}}', location.address.zip),
				_Utils_Tuple2('{{city}}', location.address.city),
				_Utils_Tuple2(
				'{{nameAndLocationDescriptor}}',
				location.name + (' ' + $author$project$Data$Location$locationDescriptorToString(location.locationDescriptor)))
			]);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, acc) {
					var tag = _v0.a;
					var value = _v0.b;
					return A3($elm$core$String$replace, tag, value, acc);
				}),
			stringToReplace,
			tags);
	});
var $author$project$Conflicts$Resolver$View$FieldData$aboutField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.about;
				},
				location),
			A2(
				$author$project$Data$Location$replaceTemplateTags,
				location,
				$author$project$Data$Location$shortDescriptionToString(location.about)))
		]);
};
var $author$project$Conflicts$Resolver$View$FieldData$emailField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.email;
				},
				location),
			$author$project$Data$Location$emailToString(location.email))
		]);
};
var $author$project$Translations$General$abbrFri = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_fri');
};
var $author$project$Translations$General$abbrMon = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_mon');
};
var $author$project$Translations$General$abbrSat = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_sat');
};
var $author$project$Translations$General$abbrSun = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_sun');
};
var $author$project$Translations$General$abbrThu = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_thu');
};
var $author$project$Translations$General$abbrTue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_tue');
};
var $author$project$Translations$General$abbrWed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbr_wed');
};
var $author$project$Translations$Listings$OpenHours$alwaysOpen = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.open_hours.always_open');
};
var $author$project$Conflicts$Resolver$View$OpenHours$view = F3(
	function (openHours, compareWith, translations) {
		var alwaysOpenIsConflict = function (compareWith_) {
			return A2(
				$elm$core$List$any,
				function (x) {
					return !_Utils_eq(x, $author$project$Data$Location$OpenHours$Always);
				},
				compareWith_);
		};
		var dayIsConflict = F3(
			function (f, compare, compareWith_) {
				return A2(
					$elm$core$List$any,
					function (x) {
						if (x.$ === 'Always') {
							return true;
						} else {
							var days = x.a;
							return !_Utils_eq(
								f(days),
								f(compare));
						}
					},
					compareWith_);
			});
		var timeFormat = function (time) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						A2($elm$core$String$left, 2, time),
						':',
						A2($elm$core$String$right, 2, time)
					]));
		};
		var spanDisplay = function (timeSpan) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								timeFormat(timeSpan.open)),
								$elm$html$Html$text('–'),
								$elm$html$Html$text(
								timeFormat(timeSpan.close))
							]))
					]));
		};
		var openHoursDisplay = function (state) {
			switch (state.$) {
				case 'NotSpecified':
					return A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$OpenHours$notSet(translations))
							]));
				case 'Closed':
					return A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$closed(translations))
							]));
				case 'AlwaysOpen':
					return A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$OpenHours$alwaysOpen(translations))
							]));
				default:
					var spans = state.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$map, spanDisplay, spans));
			}
		};
		var openHoursDay = F3(
			function (title, hasConflict, state) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-conflict-data__row--with-conflict', hasConflict)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-conflict-data__field--day pmt-editor-row__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
								]),
							_List_fromArray(
								[
									openHoursDisplay(state)
								]))
						]));
			});
		if (openHours.$ === 'Always') {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'pmt-conflict-data__row--with-conflict',
									alwaysOpenIsConflict(compareWith))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$OpenHours$alwaysOpen(translations))
								]))
						]))
				]);
		} else {
			var days = openHours.a;
			return _List_fromArray(
				[
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrMon(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.mon;
						},
						days,
						compareWith),
					days.mon),
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrTue(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.tue;
						},
						days,
						compareWith),
					days.tue),
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrWed(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.wed;
						},
						days,
						compareWith),
					days.wed),
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrThu(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.thu;
						},
						days,
						compareWith),
					days.thu),
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrFri(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.fri;
						},
						days,
						compareWith),
					days.fri),
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrSat(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.sat;
						},
						days,
						compareWith),
					days.sat),
					A3(
					openHoursDay,
					$author$project$Translations$General$abbrSun(translations),
					A3(
						dayIsConflict,
						function ($) {
							return $.sun;
						},
						days,
						compareWith),
					days.sun)
				]);
		}
	});
var $author$project$Conflicts$Resolver$View$FieldData$hoursField = F2(
	function (location, translations) {
		var networkOpenHours = A2(
			$elm$core$List$map,
			function (x) {
				return x.data.openHours;
			},
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[location.google, location.facebook, location.apple])));
		return A3($author$project$Conflicts$Resolver$View$OpenHours$view, location.openHours, networkOpenHours, translations);
	});
var $author$project$Conflicts$Resolver$View$FieldData$phoneField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.phone;
				},
				location),
			$author$project$Data$Location$phoneToString(location.phone))
		]);
};
var $author$project$Conflicts$Resolver$View$FieldData$storeIdField = function (location) {
	var _v0 = location.storeId;
	var storeId = _v0.a;
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.name;
				},
				location),
			storeId)
		]);
};
var $author$project$Conflicts$Resolver$View$FieldData$homePageField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.homepage;
				},
				location),
			$author$project$Data$Location$homepageToString(location.homepage))
		]);
};
var $author$project$Conflicts$Resolver$Types$LocationDetailsEditorOpen = F3(
	function (a, b, c) {
		return {$: 'LocationDetailsEditorOpen', a: a, b: b, c: c};
	});
var $author$project$Conflicts$Resolver$View$FieldData$locationField = F3(
	function (editable, location, translations) {
		var clickAction = editable ? $author$project$Conflicts$FieldEditor$Data$withOnClick(
			A3($author$project$Conflicts$Resolver$Types$LocationDetailsEditorOpen, $author$project$Data$Location$Field$Location, $author$project$Location$Details$Editor$CoordinatesEditor, location)) : $elm$core$Basics$identity;
		return _List_fromArray(
			[
				$author$project$Conflicts$FieldEditor$Data$render(
				clickAction(
					$author$project$Conflicts$FieldEditor$Data$view(
						_List_fromArray(
							[
								A2(
								$author$project$Conflicts$FieldEditor$Data$row,
								$author$project$Translations$General$locationLatitude(translations),
								$elm$core$String$fromFloat(location.location.lat)),
								A2(
								$author$project$Conflicts$FieldEditor$Data$row,
								$author$project$Translations$General$locationLongitude(translations),
								$elm$core$String$fromFloat(location.location.lon))
							]))))
			]);
	});
var $author$project$Conflicts$Resolver$View$FieldData$imageUrlForNetwork = F3(
	function (imageField, networkField, location) {
		return $elm_community$maybe_extra$Maybe$Extra$join(
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					function (nwf) {
						return A2(
							$elm$core$Maybe$map,
							function (media) {
								return ($elm$core$String$trim(media.url) !== '') ? $elm$core$Maybe$Just(
									_Utils_Tuple2(media.url, media.setType)) : $elm$core$Maybe$Nothing;
							},
							imageField(
								nwf(location.networkMedia)));
					},
					networkField)));
	});
var $author$project$Conflicts$Resolver$View$FieldData$imageWithPlaceholder = function (imageUrlAndSetType) {
	if (imageUrlAndSetType.$ === 'Just') {
		var _v1 = imageUrlAndSetType.a;
		var url = _v1.a;
		var setType = _v1.b;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-data__image')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(url)
							]),
						_List_Nil)
					])),
				function () {
				if (setType.$ === 'Regional') {
					return $elm$html$Html$text('');
				} else {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('note')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('This image differs from the image on its brand page')
							]));
				}
			}()
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-data__image')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__image-placeholder')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fa-solid fa-unlink')
									]),
								_List_Nil)
							]))
					]))
			]);
	}
};
var $author$project$Conflicts$Resolver$View$FieldData$coverImageField = F2(
	function (network, location) {
		return $author$project$Conflicts$Resolver$View$FieldData$imageWithPlaceholder(
			A3(
				$author$project$Conflicts$Resolver$View$FieldData$imageUrlForNetwork,
				function ($) {
					return $.coverImage;
				},
				$author$project$Data$Location$networkImagesFromNetwork(network),
				location));
	});
var $author$project$Conflicts$Resolver$View$FieldData$customNameField = F2(
	function (network, location) {
		var data = function () {
			switch (network.$) {
				case 'Facebook':
					return A2($elm$core$Maybe$withDefault, '', location.networkNames.facebook);
				case 'Google':
					return A2($elm$core$Maybe$withDefault, '', location.networkNames.google);
				case 'Bing':
					return '';
				case 'Apple':
					return '';
				case 'Foursquare':
					return '';
				case 'Overture':
					return '';
				case 'Here':
					return '';
				case 'Tomtom':
					return '';
				case 'Ptv':
					return A2($elm$core$Maybe$withDefault, '', location.networkNames.ptv);
				default:
					return '';
			}
		}();
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$FieldData$conflictData,
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
					function ($) {
						return $.customName;
					},
					location),
				data)
			]);
	});
var $author$project$Conflicts$Resolver$View$FieldData$emptyActionLinksRow = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('')
				]))
		]));
var $author$project$Conflicts$Resolver$View$FieldData$actionLinksConflictData = F2(
	function (actionLink, translations) {
		var translatedType = A2($author$project$Data$Location$ActionLinks$typeToLabel, actionLink.type_, translations);
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translatedType)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(actionLink.url)
						]))
				]));
	});
var $author$project$Conflicts$Resolver$View$FieldData$actionLinksField = F2(
	function (location, translations) {
		var _v0 = location.actionLinks;
		if (!_v0.b) {
			return _List_fromArray(
				[$author$project$Conflicts$Resolver$View$FieldData$emptyActionLinksRow]);
		} else {
			var links = _v0;
			return A2(
				$elm$core$List$map,
				function (x) {
					return A2($author$project$Conflicts$Resolver$View$FieldData$actionLinksConflictData, x, translations);
				},
				links);
		}
	});
var $author$project$Conflicts$Resolver$View$FieldData$openingDateField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.openingDate;
				},
				location),
			location.openingDate)
		]);
};
var $author$project$Conflicts$Resolver$View$FieldData$renderRepeat = F2(
	function (metaAttribute, a) {
		var getAttributeName = function (metaId) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				metaId,
				function (attribute_) {
					var _v1 = A2(
						$elm_community$list_extra$List$Extra$find,
						function (x) {
							return _Utils_eq(x.value, metaId);
						},
						attribute_.valueMetaData);
					if (_v1.$ === 'Just') {
						var attr = _v1.a;
						return attr.displayName;
					} else {
						return metaId;
					}
				},
				metaAttribute);
		};
		var attributeRemoved = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			true,
			function (_v0) {
				return false;
			},
			metaAttribute);
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (enums) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-check')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-editor-row__removed', attributeRemoved)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												', ',
												A2($elm$core$List$map, getAttributeName, enums.setValues)))
										]))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-xmark')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-editor-row__removed', attributeRemoved)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												', ',
												A2($elm$core$List$map, getAttributeName, enums.unsetValues)))
										]))
								]))
						]));
			},
			a.repeatedEnumValue);
	});
var $author$project$Conflicts$Resolver$View$FieldData$attributeConflictData = F2(
	function (attribute, meta) {
		var getAttributeValue = function (attr) {
			var _v8 = $elm$core$List$head(attr.values);
			if (_v8.$ === 'Just') {
				var value = _v8.a;
				switch (value) {
					case 'true':
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-check')
								]),
							_List_Nil);
					case 'false':
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-xmark')
								]),
							_List_Nil);
					default:
						return $elm$html$Html$text(value);
				}
			} else {
				return $elm$html$Html$text('');
			}
		};
		var metaAttribute = A2(
			$elm_community$list_extra$List$Extra$find,
			function (x) {
				return _Utils_eq(x.attributeId, attribute.attributeId);
			},
			meta.googleAttributes.attributes);
		var removedAttribute = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			true,
			function (_v7) {
				return false;
			},
			metaAttribute);
		var additional = function (attr) {
			var _v6 = attr.valueType;
			if (_v6 === 'REPEATED_ENUM') {
				return A2($author$project$Conflicts$Resolver$View$FieldData$renderRepeat, metaAttribute, attr);
			} else {
				return $elm$html$Html$text('');
			}
		};
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(attribute.left, attribute.right);
			if (_v1.a.$ === 'Nothing') {
				if (_v1.b.$ === 'Nothing') {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return _Utils_Tuple3(
						false,
						$elm$html$Html$text(' -'),
						$elm$html$Html$text(''));
				} else {
					var _v5 = _v1.a;
					return _Utils_Tuple3(
						false,
						$elm$html$Html$text('Not set'),
						$elm$html$Html$text(''));
				}
			} else {
				if (_v1.b.$ === 'Nothing') {
					var x = _v1.a.a;
					var _v4 = _v1.b;
					return _Utils_Tuple3(
						true,
						getAttributeValue(x),
						additional(x));
				} else {
					var x = _v1.a.a;
					return _Utils_Tuple3(
						true,
						getAttributeValue(x),
						additional(x));
				}
			}
		}();
		var hasAttribute = _v0.a;
		var attributeValue = _v0.b;
		var additionalValue = _v0.c;
		var name = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			attribute.attributeId,
			function ($) {
				return $.displayName;
			},
			metaAttribute);
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict', false)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-conflict-data__field', true),
									_Utils_Tuple2('pmt-editor-row__title', true),
									_Utils_Tuple2('pmt-editor-row__removed', removedAttribute)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-conflict-data__content', true),
									_Utils_Tuple2('pmt-editor-row__data', true),
									_Utils_Tuple2('pmt-conflict-data__content--missing', !hasAttribute),
									_Utils_Tuple2('pmt-editor-row__removed', removedAttribute)
								]))
						]),
					_List_fromArray(
						[attributeValue, additionalValue]))
				]));
	});
var $author$project$Data$Location$NetworkAttributes$mapToAttributeCompare = F2(
	function (lefts, rights) {
		var find = F2(
			function (attrId, xs) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					function (x) {
						return _Utils_eq(x.attributeId, attrId);
					},
					xs);
			});
		var all = $elm$core$Set$toList(
			$elm$core$Set$fromList(
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.attributeId;
						},
						lefts),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.attributeId;
						},
						rights))));
		var res = A2(
			$elm$core$List$map,
			function (attrId) {
				return {
					left: A2(find, attrId, lefts),
					right: A2(find, attrId, rights),
					attributeId: attrId
				};
			},
			all);
		return res;
	});
var $author$project$Conflicts$Resolver$View$FieldData$networkAttributes = F3(
	function (network, location, meta) {
		if (network.$ === 'Google') {
			if ($elm$core$List$isEmpty(location.networkAttributes.google)) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('')
									]))
							]))
					]);
			} else {
				var networkData = A2($author$project$Data$Location$networkDataFromNetwork, location, network);
				var attributesCompared = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (nd) {
						return A2($author$project$Data$Location$NetworkAttributes$mapToAttributeCompare, location.networkAttributes.google, nd.data.attributes);
					},
					networkData);
				return A2(
					$elm$core$List$map,
					function (x) {
						return A2($author$project$Conflicts$Resolver$View$FieldData$attributeConflictData, x, meta);
					},
					attributesCompared);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Conflicts$Resolver$View$FieldData$profileImageField = F2(
	function (network, location) {
		return $author$project$Conflicts$Resolver$View$FieldData$imageWithPlaceholder(
			A3(
				$author$project$Conflicts$Resolver$View$FieldData$imageUrlForNetwork,
				function ($) {
					return $.profileImage;
				},
				$author$project$Data$Location$networkImagesFromNetwork(network),
				location));
	});
var $author$project$Conflicts$Resolver$View$FieldData$serviceAreasField = function (location) {
	var renderer = function (t) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-conflict-data__row--with-conflict',
							A2(
								$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
								function ($) {
									return $.serviceAreas;
								},
								location))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(t)
						]))
				]));
	};
	var _v0 = location.serviceAreas;
	switch (_v0.$) {
		case 'WithPlaceId':
			var sa = _v0.a;
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var area = _v1.area;
					return renderer(area);
				},
				sa);
		case 'Text':
			var sa = _v0.a;
			return A2($elm$core$List$map, renderer, sa);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$text('')
				]);
	}
};
var $author$project$Conflicts$Resolver$View$SpecialOpenHours$view = F4(
	function (timeZone, pickItem, matchedOpenHours, translations) {
		var timeFormat = function (time) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						A2($elm$core$String$left, 2, time),
						':',
						A2($elm$core$String$right, 2, time)
					]));
		};
		var spanDisplay = function (timeSpan) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								timeFormat(timeSpan.open)),
								$elm$html$Html$text('–'),
								$elm$html$Html$text(
								timeFormat(timeSpan.close))
							]))
					]));
		};
		var openHoursDisplay = function (state) {
			if (state.$ === 'Closed') {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$closed(translations))
						]));
			} else {
				var x = state.a;
				return spanDisplay(x);
			}
		};
		var isConflict = function (m) {
			var _v1 = m.match;
			if (_v1.$ === 'Equal') {
				return false;
			} else {
				return true;
			}
		};
		var row = function (x) {
			var item = pickItem(x);
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pmt-conflict-data__row--with-conflict',
								isConflict(x))
							])),
						$elm$html$Html$Attributes$title(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.label;
								},
								item)))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-conflict-data__field--date pmt-editor-row__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Common$Date$dateShort, timeZone, x.date))
							])),
						function () {
						if (item.$ === 'Just') {
							var openHours = item.a;
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
									]),
								_List_fromArray(
									[
										openHoursDisplay(openHours.state)
									]));
						} else {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$OpenHours$notSet(translations))
									]));
						}
					}()
					]));
		};
		return ($elm$core$List$length(matchedOpenHours) > 0) ? A2($elm$core$List$map, row, matchedOpenHours) : _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pmt-conflict-data__row--with-conflict', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$OpenHours$notSet(translations))
							]))
					]))
			]);
	});
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$Equal = {$: 'Equal'};
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$NoMatch = {$: 'NoMatch'};
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$doMatch = F4(
	function (list1, list2, compare, result) {
		var innerMatch = F3(
			function (xs, ys, acc) {
				innerMatch:
				while (true) {
					var _v0 = acc;
					var xsNotMatched = _v0.a;
					var matches = _v0.b;
					if (!xs.b) {
						return _Utils_Tuple3(xsNotMatched, ys, matches);
					} else {
						var x = xs.a;
						var xsTail = xs.b;
						var match_ = A2(
							$elm_community$list_extra$List$Extra$find,
							compare(x),
							ys);
						var remainingYs = function () {
							if (match_.$ === 'Nothing') {
								return ys;
							} else {
								var m = match_.a;
								return A2(
									$elm$core$List$filter,
									function (y) {
										return !_Utils_eq(y, m);
									},
									ys);
							}
						}();
						if (match_.$ === 'Nothing') {
							var $temp$xs = xsTail,
								$temp$ys = remainingYs,
								$temp$acc = _Utils_Tuple2(
								A2($elm$core$List$cons, x, xsNotMatched),
								matches);
							xs = $temp$xs;
							ys = $temp$ys;
							acc = $temp$acc;
							continue innerMatch;
						} else {
							var m = match_.a;
							var $temp$xs = xsTail,
								$temp$ys = remainingYs,
								$temp$acc = _Utils_Tuple2(
								xsNotMatched,
								A2(
									$elm$core$List$cons,
									{
										date: x.startDate,
										left: $elm$core$Maybe$Just(x),
										match: result,
										right: $elm$core$Maybe$Just(m)
									},
									matches));
							xs = $temp$xs;
							ys = $temp$ys;
							acc = $temp$acc;
							continue innerMatch;
						}
					}
				}
			});
		return A3(
			innerMatch,
			list1,
			list2,
			_Utils_Tuple2(_List_Nil, _List_Nil));
	});
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$NotEqual = {$: 'NotEqual'};
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$hasSameDate = F2(
	function (x, y) {
		return _Utils_eq(
			$elm$time$Time$posixToMillis(x.startDate),
			$elm$time$Time$posixToMillis(y.startDate));
	});
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$partialMatch = $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$hasSameDate;
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$toSortString = function (x) {
	var time = $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(x.date);
	var toStr = F2(
		function (s_, x_) {
			if (x_.$ === 'Nothing') {
				return s_;
			} else {
				var a = x_.a;
				return _Utils_ap(
					time,
					function () {
						var _v1 = a.state;
						if (_v1.$ === 'Closed') {
							return '_closed';
						} else {
							var s = _v1.a;
							return '_open_' + (s.open + ('_' + s.close));
						}
					}());
			}
		});
	var right = A2(toStr, '<no right>', x.right);
	var left = A2(toStr, '<no left>', x.left);
	return time + (left + (' - ' + right));
};
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$normalizeCloseTime = function (time) {
	return A2(
		$elm$core$List$member,
		time,
		_List_fromArray(
			['0000', '00:00', '2400', '24:00', '2359', '23:59'])) ? '2400' : time;
};
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$hasSameState = F2(
	function (x, y) {
		var _v0 = _Utils_Tuple2(x.state, y.state);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 'Closed') {
				if (_v0.b.$ === 'Closed') {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return true;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 'Open') {
					var a = _v0.a.a;
					var b = _v0.b.a;
					return _Utils_eq(a.open, b.open) && _Utils_eq(
						$author$project$Conflicts$Resolver$SpecialOpenHoursMatch$normalizeCloseTime(a.close),
						$author$project$Conflicts$Resolver$SpecialOpenHoursMatch$normalizeCloseTime(b.close));
				} else {
					break _v0$2;
				}
			}
		}
		return false;
	});
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$completeMatch = F2(
	function (x, y) {
		return A2($author$project$Conflicts$Resolver$SpecialOpenHoursMatch$hasSameDate, x, y) && A2($author$project$Conflicts$Resolver$SpecialOpenHoursMatch$hasSameState, x, y);
	});
var $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$match = F2(
	function (left, right) {
		var _v0 = A4($author$project$Conflicts$Resolver$SpecialOpenHoursMatch$doMatch, left, right, $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$completeMatch, $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$Equal);
		var leftNotMatched1 = _v0.a;
		var rightNotMatched1 = _v0.b;
		var completeMatches = _v0.c;
		var _v1 = A4($author$project$Conflicts$Resolver$SpecialOpenHoursMatch$doMatch, leftNotMatched1, rightNotMatched1, $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$partialMatch, $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$NotEqual);
		var leftNotMatched = _v1.a;
		var rightNotMatched = _v1.b;
		var partialMatches = _v1.c;
		var rightNoMatches = A2(
			$elm$core$List$map,
			function (x) {
				return {
					date: x.startDate,
					left: $elm$core$Maybe$Nothing,
					match: $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$NoMatch,
					right: $elm$core$Maybe$Just(x)
				};
			},
			rightNotMatched);
		var leftNoMatches = A2(
			$elm$core$List$map,
			function (x) {
				return {
					date: x.startDate,
					left: $elm$core$Maybe$Just(x),
					match: $author$project$Conflicts$Resolver$SpecialOpenHoursMatch$NoMatch,
					right: $elm$core$Maybe$Nothing
				};
			},
			leftNotMatched);
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$map,
					function (x) {
						return _Utils_Tuple2(
							$author$project$Conflicts$Resolver$SpecialOpenHoursMatch$toSortString(x),
							x);
					},
					$elm$core$List$concat(
						_List_fromArray(
							[completeMatches, partialMatches, leftNoMatches, rightNoMatches])))));
	});
var $author$project$Conflicts$Resolver$View$FieldData$specialHoursField = F5(
	function (now, timeZone, location, conflictingNetworks, translations) {
		var networkSpecialOpenHours = A3(
			$elm$core$List$foldl,
			$elm$core$Basics$append,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (network) {
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								function ($) {
									return $.specialOpenHours;
								},
								function ($) {
									return $.data;
								}),
							A2($author$project$Data$Location$networkDataFromNetwork, location, network)));
				},
				conflictingNetworks));
		var matches = A2(
			$author$project$Conflicts$Resolver$SpecialOpenHoursMatch$match,
			A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, location.specialOpenHours, now),
			A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, networkSpecialOpenHours, now));
		return A4(
			$author$project$Conflicts$Resolver$View$SpecialOpenHours$view,
			timeZone,
			function ($) {
				return $.left;
			},
			matches,
			translations);
	});
var $author$project$Conflicts$Resolver$View$FieldData$longDescriptionField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.longDescription;
				},
				location),
			A2(
				$author$project$Data$Location$replaceTemplateTags,
				location,
				$author$project$Data$Location$longDescriptionToString(location.longDescription)))
		]);
};
var $author$project$Translations$General$primary = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.primary');
};
var $author$project$Conflicts$Resolver$View$FieldData$networkCategoriesField = F3(
	function (network, location, translations) {
		var primaryTemp = function () {
			switch (network.$) {
				case 'Google':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return y.name;
									},
									x.primary));
						},
						location.networkCategories.google);
				case 'Facebook':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return y.name;
									},
									$elm$core$List$head(x.subcategories)));
						},
						location.networkCategories.facebook);
				case 'Bing':
					return A2(
						$elm$core$Maybe$andThen,
						function (categories) {
							return A2(
								$elm$core$Maybe$andThen,
								function (categoryId) {
									return A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.name;
										},
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (y) {
													return _Utils_eq(y.id, categoryId);
												},
												categories.categories)));
								},
								categories.primaryCategoryId);
						},
						location.networkCategories.bing);
				case 'Apple':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return y.name;
									},
									x.primary));
						},
						location.networkCategories.apple);
				case 'Foursquare':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return y.name;
									},
									$elm$core$List$head(x.categories)));
						},
						location.networkCategories.foursquare);
				case 'Overture':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return y.name;
									},
									x.primary));
						},
						location.networkCategories.overture);
				case 'Here':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return y.name;
									},
									x.primary));
						},
						location.networkCategories.here);
				case 'Tomtom':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return x.name;
						},
						location.networkCategories.tomtom);
				case 'Ptv':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var additionalTemp = function () {
			switch (network.$) {
				case 'Google':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return x.additional;
						},
						location.networkCategories.google);
				case 'Facebook':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$elm$core$List$tail(x.subcategories));
						},
						location.networkCategories.facebook);
				case 'Bing':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$List$filter,
								function (y) {
									return !_Utils_eq(
										y.name,
										A2($elm$core$Maybe$withDefault, '', primaryTemp));
								},
								x.categories);
						},
						location.networkCategories.bing);
				case 'Apple':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return x.additional;
						},
						location.networkCategories.apple);
				case 'Foursquare':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$elm$core$List$tail(x.categories));
						},
						location.networkCategories.foursquare);
				case 'Overture':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return x.additional;
						},
						location.networkCategories.overture);
				case 'Here':
					return A2(
						$elm$core$Maybe$map,
						function (x) {
							return x.additional;
						},
						location.networkCategories.here);
				case 'Tomtom':
					return $elm$core$Maybe$Nothing;
				case 'Ptv':
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var additional = A2(
			$elm$core$List$map,
			function (x) {
				return A3(
					$author$project$Conflicts$Resolver$View$FieldData$conflictData,
					$elm$core$Maybe$Nothing,
					A2(
						$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
						function ($) {
							return $.networkCategories;
						},
						location),
					x);
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.name;
				},
				A2($elm$core$Maybe$withDefault, _List_Nil, additionalTemp)));
		var primary = function (x) {
			return A3(
				$author$project$Conflicts$Resolver$View$FieldData$conflictData,
				$elm$core$Maybe$Just(
					$author$project$Translations$General$primary(translations) + ':'),
				A2(
					$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
					function ($) {
						return $.networkCategories;
					},
					location),
				x);
		}(
			A2($elm$core$Maybe$withDefault, '', primaryTemp));
		return A2($elm$core$List$cons, primary, additional);
	});
var $author$project$Conflicts$Resolver$View$FieldData$permanentlyClosedField = F2(
	function (location, translations) {
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$FieldData$conflictData,
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
					function ($) {
						return $.permanentlyClosed;
					},
					location),
				location.permanentlyClosed ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations))
			]);
	});
var $author$project$Data$NetworkData$TemporarilyClosed$toHumanReadable = F2(
	function (x, translations) {
		switch (x.$) {
			case 'NotTemporarilyClosed':
				return $author$project$Translations$General$no(translations);
			case 'NotCompleted':
				return $author$project$Translations$General$no(translations);
			case 'Until':
				var until = x.a;
				return A2(
					$elm$core$String$left,
					10,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(until));
			default:
				return $author$project$Translations$General$yes(translations);
		}
	});
var $author$project$Conflicts$Resolver$View$FieldData$temporarilyClosedField = F2(
	function (location, translations) {
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$FieldData$conflictData,
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
					function ($) {
						return $.temporarilyClosedUntil;
					},
					location),
				A2($author$project$Data$NetworkData$TemporarilyClosed$toHumanReadable, location.temporarilyClosedUntil, translations))
			]);
	});
var $author$project$Conflicts$Resolver$View$FieldData$locationDescriptorField = function (location) {
	return _List_fromArray(
		[
			A3(
			$author$project$Conflicts$Resolver$View$FieldData$conflictData,
			$elm$core$Maybe$Nothing,
			A2(
				$author$project$Conflicts$Resolver$View$FieldData$hasConflict,
				function ($) {
					return $.locationDescriptor;
				},
				location),
			$author$project$Data$Location$locationDescriptorToString(location.locationDescriptor))
		]);
};
var $author$project$Conflicts$Resolver$View$FieldData$networkServiceItemRow = F2(
	function (googleSupportedServiceItems, serviceItem) {
		var formatDescription = function (description) {
			return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '-', $elm$core$Basics$identity, description);
		};
		var formatPrice = function (price) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'-',
				function (price_) {
					return price_.amount + (' ' + price_.currency);
				},
				price);
		};
		var renderRow = F3(
			function (title, price, description) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
							$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title'),
									$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
									$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__price')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(price)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
									$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]));
			});
		if (serviceItem.$ === 'Structured') {
			var serviceItem_ = serviceItem.a;
			var formattedDescription = formatDescription(serviceItem_.description);
			var formattedPrice = formatPrice(serviceItem_.price);
			var displayName = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Data$Location$NetworkServiceItems$parseStructuredServiceId(serviceItem_.id),
				A2($elm$core$Dict$get, serviceItem_.id, googleSupportedServiceItems));
			return A3(renderRow, displayName, formattedPrice, formattedDescription);
		} else {
			var serviceItem_ = serviceItem.a;
			var formattedDescription = formatDescription(serviceItem_.label.description);
			var formattedPrice = formatPrice(serviceItem_.price);
			return A3(renderRow, serviceItem_.label.displayName, formattedPrice, formattedDescription);
		}
	});
var $author$project$Conflicts$Resolver$View$FieldData$networkServiceItemsField = F2(
	function (meta, locationData) {
		var googleSupportedServiceItems = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (supportedServiceItem) {
					return _Utils_Tuple2(supportedServiceItem.id, supportedServiceItem.name);
				},
				meta.googleSupportedServiceItems));
		return $elm$core$List$isEmpty(locationData.networkServiceItems.google) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
						$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]))
			]) : A2(
			$elm$core$List$map,
			$author$project$Conflicts$Resolver$View$FieldData$networkServiceItemRow(googleSupportedServiceItems),
			locationData.networkServiceItems.google);
	});
var $author$project$Translations$General$locationUnhandledProperty = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_unhandled_property');
};
var $author$project$Conflicts$Resolver$View$FieldData$view = F8(
	function (timeZone, editable, meta, location, field, translations, now, conflictingNetworks) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data pmt-conflict-data--local'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data--editable', editable),
							_Utils_Tuple2('pmt-field-editor-data pmt-field-editor-data--editable', editable)
						]))
				]),
			function () {
				switch (field.$) {
					case 'Name':
						return $author$project$Conflicts$Resolver$View$FieldData$nameField(location);
					case 'OpeningDate':
						return $author$project$Conflicts$Resolver$View$FieldData$openingDateField(location);
					case 'CustomName':
						var network = field.a;
						return A2($author$project$Conflicts$Resolver$View$FieldData$customNameField, network, location);
					case 'StoreId':
						return $author$project$Conflicts$Resolver$View$FieldData$storeIdField(location);
					case 'LocationDescriptor':
						return $author$project$Conflicts$Resolver$View$FieldData$locationDescriptorField(location);
					case 'Location':
						return A3($author$project$Conflicts$Resolver$View$FieldData$locationField, editable, location, translations);
					case 'About':
						return $author$project$Conflicts$Resolver$View$FieldData$aboutField(location);
					case 'LongDescription':
						return $author$project$Conflicts$Resolver$View$FieldData$longDescriptionField(location);
					case 'Hours':
						return A2($author$project$Conflicts$Resolver$View$FieldData$hoursField, location, translations);
					case 'SpecialHours':
						return A5($author$project$Conflicts$Resolver$View$FieldData$specialHoursField, now, timeZone, location, conflictingNetworks, translations);
					case 'PermanentlyClosed':
						return A2($author$project$Conflicts$Resolver$View$FieldData$permanentlyClosedField, location, translations);
					case 'TemporarilyClosedUntil':
						return A2($author$project$Conflicts$Resolver$View$FieldData$temporarilyClosedField, location, translations);
					case 'Email':
						return $author$project$Conflicts$Resolver$View$FieldData$emailField(location);
					case 'Homepage':
						return $author$project$Conflicts$Resolver$View$FieldData$homePageField(location);
					case 'Phone':
						return $author$project$Conflicts$Resolver$View$FieldData$phoneField(location);
					case 'Address':
						return _List_fromArray(
							[
								A2($author$project$Conflicts$Resolver$View$FieldData$address, location, translations)
							]);
					case 'CoverImage':
						var network = field.a;
						return A2($author$project$Conflicts$Resolver$View$FieldData$coverImageField, network, location);
					case 'ProfileImage':
						var network = field.a;
						return A2($author$project$Conflicts$Resolver$View$FieldData$profileImageField, network, location);
					case 'NetworkCategories':
						var network = field.a;
						return A3($author$project$Conflicts$Resolver$View$FieldData$networkCategoriesField, network, location, translations);
					case 'NetworkAttributes':
						var network = field.a;
						return A3($author$project$Conflicts$Resolver$View$FieldData$networkAttributes, network, location, meta);
					case 'ActionLinks':
						return A2($author$project$Conflicts$Resolver$View$FieldData$actionLinksField, location, translations);
					case 'NetworkServiceItems':
						return A2($author$project$Conflicts$Resolver$View$FieldData$networkServiceItemsField, meta, location);
					case 'ServiceAreas':
						return $author$project$Conflicts$Resolver$View$FieldData$serviceAreasField(location);
					case 'Wifi':
						return $author$project$Conflicts$Resolver$View$FieldData$wifiField(location);
					default:
						var s = field.a;
						return _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$locationUnhandledProperty(translations) + (' \u0027' + (s + '\u0027')))
							]);
				}
			}());
	});
var $jinjor$elm_diff$Diff$snake = F5(
	function (getA, getB, nextX, nextY, path) {
		snake:
		while (true) {
			var _v0 = _Utils_Tuple2(
				getA(nextX),
				getB(nextY));
			_v0$2:
			while (true) {
				if (_v0.a.$ === 'Just') {
					if (_v0.b.$ === 'Just') {
						var a = _v0.a.a;
						var b = _v0.b.a;
						if (_Utils_eq(a, b)) {
							var $temp$getA = getA,
								$temp$getB = getB,
								$temp$nextX = nextX + 1,
								$temp$nextY = nextY + 1,
								$temp$path = A2(
								$elm$core$List$cons,
								_Utils_Tuple2(nextX, nextY),
								path);
							getA = $temp$getA;
							getB = $temp$getB;
							nextX = $temp$nextX;
							nextY = $temp$nextY;
							path = $temp$path;
							continue snake;
						} else {
							return _Utils_Tuple2(path, false);
						}
					} else {
						break _v0$2;
					}
				} else {
					if (_v0.b.$ === 'Nothing') {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return _Utils_Tuple2(path, true);
					} else {
						break _v0$2;
					}
				}
			}
			return _Utils_Tuple2(path, false);
		}
	});
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (_v0.$ === 'SubTree') {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $jinjor$elm_diff$Diff$Found = function (a) {
	return {$: 'Found', a: a};
};
var $jinjor$elm_diff$Diff$Continue = function (a) {
	return {$: 'Continue', a: a};
};
var $jinjor$elm_diff$Diff$step = F4(
	function (snake_, offset, k, v) {
		var fromLeft = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Array$get, (k - 1) + offset, v));
		var fromTop = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Array$get, (k + 1) + offset, v));
		var _v0 = function () {
			var _v2 = _Utils_Tuple2(fromLeft, fromTop);
			if (!_v2.a.b) {
				if (!_v2.b.b) {
					return _Utils_Tuple2(
						_List_Nil,
						_Utils_Tuple2(0, 0));
				} else {
					var _v3 = _v2.b;
					var _v4 = _v3.a;
					var topX = _v4.a;
					var topY = _v4.b;
					return _Utils_Tuple2(
						fromTop,
						_Utils_Tuple2(topX + 1, topY));
				}
			} else {
				if (!_v2.b.b) {
					var _v5 = _v2.a;
					var _v6 = _v5.a;
					var leftX = _v6.a;
					var leftY = _v6.b;
					return _Utils_Tuple2(
						fromLeft,
						_Utils_Tuple2(leftX, leftY + 1));
				} else {
					var _v7 = _v2.a;
					var _v8 = _v7.a;
					var leftX = _v8.a;
					var leftY = _v8.b;
					var _v9 = _v2.b;
					var _v10 = _v9.a;
					var topX = _v10.a;
					var topY = _v10.b;
					return (_Utils_cmp(leftY + 1, topY) > -1) ? _Utils_Tuple2(
						fromLeft,
						_Utils_Tuple2(leftX, leftY + 1)) : _Utils_Tuple2(
						fromTop,
						_Utils_Tuple2(topX + 1, topY));
				}
			}
		}();
		var path = _v0.a;
		var _v1 = _v0.b;
		var x = _v1.a;
		var y = _v1.b;
		var _v11 = A3(
			snake_,
			x + 1,
			y + 1,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(x, y),
				path));
		var newPath = _v11.a;
		var goal = _v11.b;
		return goal ? $jinjor$elm_diff$Diff$Found(newPath) : $jinjor$elm_diff$Diff$Continue(
			A3($elm$core$Array$set, k + offset, newPath, v));
	});
var $jinjor$elm_diff$Diff$onpLoopK = F4(
	function (snake_, offset, ks, v) {
		onpLoopK:
		while (true) {
			if (!ks.b) {
				return $jinjor$elm_diff$Diff$Continue(v);
			} else {
				var k = ks.a;
				var ks_ = ks.b;
				var _v1 = A4($jinjor$elm_diff$Diff$step, snake_, offset, k, v);
				if (_v1.$ === 'Found') {
					var path = _v1.a;
					return $jinjor$elm_diff$Diff$Found(path);
				} else {
					var v_ = _v1.a;
					var $temp$snake_ = snake_,
						$temp$offset = offset,
						$temp$ks = ks_,
						$temp$v = v_;
					snake_ = $temp$snake_;
					offset = $temp$offset;
					ks = $temp$ks;
					v = $temp$v;
					continue onpLoopK;
				}
			}
		}
	});
var $jinjor$elm_diff$Diff$onpLoopP = F5(
	function (snake_, delta, offset, p, v) {
		onpLoopP:
		while (true) {
			var ks = (delta > 0) ? _Utils_ap(
				$elm$core$List$reverse(
					A2($elm$core$List$range, delta + 1, delta + p)),
				A2($elm$core$List$range, -p, delta)) : _Utils_ap(
				$elm$core$List$reverse(
					A2($elm$core$List$range, delta + 1, p)),
				A2($elm$core$List$range, (-p) + delta, delta));
			var _v0 = A4($jinjor$elm_diff$Diff$onpLoopK, snake_, offset, ks, v);
			if (_v0.$ === 'Found') {
				var path = _v0.a;
				return path;
			} else {
				var v_ = _v0.a;
				var $temp$snake_ = snake_,
					$temp$delta = delta,
					$temp$offset = offset,
					$temp$p = p + 1,
					$temp$v = v_;
				snake_ = $temp$snake_;
				delta = $temp$delta;
				offset = $temp$offset;
				p = $temp$p;
				v = $temp$v;
				continue onpLoopP;
			}
		}
	});
var $jinjor$elm_diff$Diff$onp = F4(
	function (getA, getB, m, n) {
		var delta = n - m;
		var v = A2(
			$elm$core$Array$initialize,
			(m + n) + 1,
			$elm$core$Basics$always(_List_Nil));
		return A5(
			$jinjor$elm_diff$Diff$onpLoopP,
			A2($jinjor$elm_diff$Diff$snake, getA, getB),
			delta,
			m,
			0,
			v);
	});
var $jinjor$elm_diff$Diff$Added = function (a) {
	return {$: 'Added', a: a};
};
var $jinjor$elm_diff$Diff$Removed = function (a) {
	return {$: 'Removed', a: a};
};
var $jinjor$elm_diff$Diff$NoChange = function (a) {
	return {$: 'NoChange', a: a};
};
var $jinjor$elm_diff$Diff$CannotGetA = function (a) {
	return {$: 'CannotGetA', a: a};
};
var $jinjor$elm_diff$Diff$CannotGetB = function (a) {
	return {$: 'CannotGetB', a: a};
};
var $jinjor$elm_diff$Diff$UnexpectedPath = F2(
	function (a, b) {
		return {$: 'UnexpectedPath', a: a, b: b};
	});
var $jinjor$elm_diff$Diff$makeChangesHelp = F5(
	function (changes, getA, getB, _v0, path) {
		makeChangesHelp:
		while (true) {
			var x = _v0.a;
			var y = _v0.b;
			if (!path.b) {
				return $elm$core$Result$Ok(changes);
			} else {
				var _v2 = path.a;
				var prevX = _v2.a;
				var prevY = _v2.b;
				var tail = path.b;
				var change = function () {
					if (_Utils_eq(x - 1, prevX) && _Utils_eq(y - 1, prevY)) {
						var _v4 = getA(x);
						if (_v4.$ === 'Just') {
							var a = _v4.a;
							return $elm$core$Result$Ok(
								$jinjor$elm_diff$Diff$NoChange(a));
						} else {
							return $elm$core$Result$Err(
								$jinjor$elm_diff$Diff$CannotGetA(x));
						}
					} else {
						if (_Utils_eq(x, prevX)) {
							var _v5 = getB(y);
							if (_v5.$ === 'Just') {
								var b = _v5.a;
								return $elm$core$Result$Ok(
									$jinjor$elm_diff$Diff$Added(b));
							} else {
								return $elm$core$Result$Err(
									$jinjor$elm_diff$Diff$CannotGetB(y));
							}
						} else {
							if (_Utils_eq(y, prevY)) {
								var _v6 = getA(x);
								if (_v6.$ === 'Just') {
									var a = _v6.a;
									return $elm$core$Result$Ok(
										$jinjor$elm_diff$Diff$Removed(a));
								} else {
									return $elm$core$Result$Err(
										$jinjor$elm_diff$Diff$CannotGetA(x));
								}
							} else {
								return $elm$core$Result$Err(
									A2(
										$jinjor$elm_diff$Diff$UnexpectedPath,
										_Utils_Tuple2(x, y),
										path));
							}
						}
					}
				}();
				if (change.$ === 'Ok') {
					var c = change.a;
					var $temp$changes = A2($elm$core$List$cons, c, changes),
						$temp$getA = getA,
						$temp$getB = getB,
						$temp$_v0 = _Utils_Tuple2(prevX, prevY),
						$temp$path = tail;
					changes = $temp$changes;
					getA = $temp$getA;
					getB = $temp$getB;
					_v0 = $temp$_v0;
					path = $temp$path;
					continue makeChangesHelp;
				} else {
					var e = change.a;
					return $elm$core$Result$Err(e);
				}
			}
		}
	});
var $jinjor$elm_diff$Diff$makeChanges = F3(
	function (getA, getB, path) {
		if (!path.b) {
			return $elm$core$Result$Ok(_List_Nil);
		} else {
			var latest = path.a;
			var tail = path.b;
			return A5($jinjor$elm_diff$Diff$makeChangesHelp, _List_Nil, getA, getB, latest, tail);
		}
	});
var $jinjor$elm_diff$Diff$testDiff = F2(
	function (a, b) {
		var arrB = $elm$core$Array$fromList(b);
		var getB = function (y) {
			return A2($elm$core$Array$get, y - 1, arrB);
		};
		var arrA = $elm$core$Array$fromList(a);
		var getA = function (x) {
			return A2($elm$core$Array$get, x - 1, arrA);
		};
		var n = $elm$core$Array$length(arrB);
		var m = $elm$core$Array$length(arrA);
		var path = A4($jinjor$elm_diff$Diff$onp, getA, getB, m, n);
		return A3($jinjor$elm_diff$Diff$makeChanges, getA, getB, path);
	});
var $jinjor$elm_diff$Diff$diff = F2(
	function (a, b) {
		var _v0 = A2($jinjor$elm_diff$Diff$testDiff, a, b);
		if (_v0.$ === 'Ok') {
			var changes = _v0.a;
			return changes;
		} else {
			return _List_Nil;
		}
	});
var $jinjor$elm_diff$Diff$diffLines = F2(
	function (a, b) {
		return A2(
			$jinjor$elm_diff$Diff$diff,
			$elm$core$String$lines(a),
			$elm$core$String$lines(b));
	});
var $author$project$PinMeTo$Global$StringComparison$renderChangeAsSentence = function (change) {
	switch (change.$) {
		case 'Added':
			var value = change.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-string-comparison__highlight-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value + ' ')
					]));
		case 'Removed':
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-string-comparison__highlight-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]));
		default:
			var value = change.a;
			return $elm$html$Html$text(value + ' ');
	}
};
var $author$project$PinMeTo$Global$StringComparison$splitStringIntoSentences = function (str) {
	return A2(
		$elm$core$List$concatMap,
		function (sentence) {
			return A2($elm$core$String$split, '? ', sentence);
		},
		A2(
			$elm$core$List$concatMap,
			function (sentence) {
				return A2($elm$core$String$split, '! ', sentence);
			},
			A2($elm$core$String$split, '. ', str)));
};
var $author$project$PinMeTo$Global$StringComparison$convertSentenceStringToSpaceSeparatedLines = function (str) {
	return A2(
		$elm$core$String$join,
		'\u000A',
		A2($elm$core$String$split, ' ', str));
};
var $author$project$PinMeTo$Global$StringComparison$renderSentenceDifference = F2(
	function (originalStringValue, stringValueToCompareTo) {
		var sentencesListToCompareTo = A2(
			$elm$core$List$map,
			$author$project$PinMeTo$Global$StringComparison$convertSentenceStringToSpaceSeparatedLines,
			$author$project$PinMeTo$Global$StringComparison$splitStringIntoSentences(stringValueToCompareTo));
		var originalSentencesList = A2(
			$elm$core$List$map,
			$author$project$PinMeTo$Global$StringComparison$convertSentenceStringToSpaceSeparatedLines,
			$author$project$PinMeTo$Global$StringComparison$splitStringIntoSentences(originalStringValue));
		var changes = A2(
			$elm$core$List$concatMap,
			function (originalSentence) {
				return A2(
					$elm$core$List$concatMap,
					function (sentenceToCompareTo) {
						return A2($jinjor$elm_diff$Diff$diffLines, sentenceToCompareTo, originalSentence);
					},
					sentencesListToCompareTo);
			},
			originalSentencesList);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$map, $author$project$PinMeTo$Global$StringComparison$renderChangeAsSentence, changes));
	});
var $author$project$PinMeTo$Global$StringComparison$renderSentenceComparison = F2(
	function (originalStringValue, stringValueToCompareTo) {
		return A2(
			$author$project$PinMeTo$Global$StringComparison$renderSentenceDifference,
			$author$project$PinMeTo$Global$StringComparison$convertSentenceStringToSpaceSeparatedLines(originalStringValue),
			$author$project$PinMeTo$Global$StringComparison$convertSentenceStringToSpaceSeparatedLines(stringValueToCompareTo));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$conflictDataRow = F3(
	function (title, isConflict, content) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict', isConflict)
						]))
				]),
			_List_fromArray(
				[
					function () {
					if (title.$ === 'Just') {
						var title_ = title.a;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title_)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison = F3(
	function (title, isConflict, comparisonData) {
		return A3($author$project$Conflicts$Resolver$View$NetworkData$conflictDataRow, title, isConflict, comparisonData);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$nameField = F2(
	function (networkData, locationData) {
		var platformNameValue = locationData.name;
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.name.hasDiff,
				A2($author$project$PinMeTo$Global$StringComparison$renderSentenceComparison, networkData.data.name, platformNameValue))
			]);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$aboutField = F2(
	function (networkData, locationData) {
		var platformShortDescriptionValue = A2(
			$author$project$Data$Location$replaceTemplateTags,
			locationData,
			$author$project$Data$Location$shortDescriptionToString(locationData.about));
		return A2(
			$elm$core$List$map,
			function (paragraph_) {
				return A3(
					$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
					$elm$core$Maybe$Nothing,
					networkData.validation.dataDiff.about.hasDiff,
					A2($author$project$PinMeTo$Global$StringComparison$renderSentenceComparison, paragraph_, platformShortDescriptionValue));
			},
			A2($elm$core$String$split, '\u000A', networkData.data.about));
	});
var $author$project$PinMeTo$Global$StringComparison$renderChangeAsCharacter = function (change) {
	switch (change.$) {
		case 'Added':
			var value = change.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-string-comparison__highlight-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value)
					]));
		case 'Removed':
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-string-comparison__highlight-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]));
		default:
			var value = change.a;
			return $elm$html$Html$text(value);
	}
};
var $author$project$PinMeTo$Global$StringComparison$convertCharacterStringToLineSeparatedString = function (str) {
	return A2(
		$elm$core$String$join,
		'\u000A',
		A2(
			$elm$core$List$map,
			$elm$core$String$fromChar,
			$elm$core$String$toList(str)));
};
var $author$project$PinMeTo$Global$StringComparison$renderCharacterDifference = F2(
	function (originalStringValue, stringValueToCompareTo) {
		var changes = A2(
			$jinjor$elm_diff$Diff$diffLines,
			$author$project$PinMeTo$Global$StringComparison$convertCharacterStringToLineSeparatedString(stringValueToCompareTo),
			$author$project$PinMeTo$Global$StringComparison$convertCharacterStringToLineSeparatedString(originalStringValue));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$map, $author$project$PinMeTo$Global$StringComparison$renderChangeAsCharacter, changes));
	});
var $author$project$PinMeTo$Global$StringComparison$renderCharacterComparison = F2(
	function (originalStringValue, stringValueToCompareTo) {
		return A2($author$project$PinMeTo$Global$StringComparison$renderCharacterDifference, originalStringValue, stringValueToCompareTo);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$emailField = F2(
	function (networkData, locationData) {
		var platformEmailValue = $author$project$Data$Location$emailToString(locationData.email);
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.email.hasDiff,
				A2(
					$author$project$PinMeTo$Global$StringComparison$renderCharacterComparison,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(networkData.data.emails)),
					platformEmailValue))
			]);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$hoursField = F3(
	function (networkData, locationData, translations) {
		return A3(
			$author$project$Conflicts$Resolver$View$OpenHours$view,
			networkData.data.openHours,
			_List_fromArray(
				[locationData.openHours]),
			translations);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$phoneField = F2(
	function (networkData, locationData) {
		var platformPhoneValue = $author$project$Data$Location$phoneToString(locationData.phone);
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.phone.hasDiff,
				A2($author$project$PinMeTo$Global$StringComparison$renderCharacterComparison, networkData.data.phone, platformPhoneValue))
			]);
	});
var $author$project$Common$AddressEditor$withApprovedDiff = F2(
	function (approvedDiffs, config) {
		return _Utils_update(
			config,
			{
				approvedDiffs: $elm$core$Maybe$Just(approvedDiffs)
			});
	});
var $author$project$Common$AddressEditor$withOnApproveDiffMsgs = F2(
	function (onApproveDiffMsgs, config) {
		return _Utils_update(
			config,
			{
				onApproveDiffMsgs: $elm$core$Maybe$Just(onApproveDiffMsgs)
			});
	});
var $author$project$Data$Network$canApproveDiffForCityOrProvince = function (network) {
	return A2(
		$elm$core$List$member,
		network,
		_List_fromArray(
			[$author$project$Data$Network$Facebook, $author$project$Data$Network$Google, $author$project$Data$Network$Bing, $author$project$Data$Network$Ptv]));
};
var $author$project$Conflicts$Resolver$View$NetworkData$addressField = F4(
	function (network, networkData, approveDiff, translations) {
		return $author$project$Common$AddressEditor$view(
			function (config_) {
				return $author$project$Data$Network$canApproveDiffForCityOrProvince(network) ? A2(
					$author$project$Common$AddressEditor$withOnApproveDiffMsgs,
					{
						city: approveDiff('city'),
						province: approveDiff('province')
					},
					config_) : config_;
			}(
				A2(
					$author$project$Common$AddressEditor$withApprovedDiff,
					{
						city: !_Utils_eq(networkData.validation.approvedDiffs.city, $elm$core$Maybe$Nothing),
						province: !_Utils_eq(networkData.validation.approvedDiffs.province, $elm$core$Maybe$Nothing)
					},
					A2(
						$author$project$Common$AddressEditor$withAddressConflicts,
						{zip: networkData.validation.dataDiff.zip.hasDiff, city: networkData.validation.dataDiff.city.hasDiff, state: false, street: networkData.validation.dataDiff.street.hasDiff, country: networkData.validation.dataDiff.country.hasDiff, district: networkData.validation.dataDiff.district.hasDiff, province: networkData.validation.dataDiff.province.hasDiff},
						A2($author$project$Common$AddressEditor$withAddress, networkData.data.address, translations)))));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$storeIdField = F2(
	function (networkData, locationData) {
		var platformStoreIdValue = $author$project$Data$Location$storeIdToString(locationData.storeId);
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.storeId.hasDiff,
				A2($author$project$PinMeTo$Global$StringComparison$renderSentenceComparison, networkData.data.storeId, platformStoreIdValue))
			]);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$homepageField = F2(
	function (networkData, locationData) {
		var platformHomepageValue = $author$project$Data$Location$homepageToString(locationData.homepage);
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.homepage.hasDiff,
				A2($author$project$PinMeTo$Global$StringComparison$renderCharacterComparison, networkData.data.homepage, platformHomepageValue))
			]);
	});
var $author$project$Translations$Listings$Conflicts$noLocationFound = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.no_location_found');
};
var $author$project$Conflicts$FieldEditor$Data$RowWithComparison = function (a) {
	return {$: 'RowWithComparison', a: a};
};
var $author$project$Conflicts$FieldEditor$Data$rowWithComparison = F3(
	function (label, value, comparisonData) {
		return $author$project$Conflicts$FieldEditor$Data$RowWithComparison(
			{label: label, value: value, useThis: $elm$core$Maybe$Nothing, approveDiff: $elm$core$Maybe$Nothing, hasConflict: false, comparisonData: comparisonData, hasApprovedDiff: false});
	});
var $author$project$Conflicts$FieldEditor$Data$ConfigWithComparison = F2(
	function (data, onClick) {
		return {data: data, onClick: onClick};
	});
var $author$project$Conflicts$FieldEditor$Data$viewWithComparison = function (data) {
	return A2($author$project$Conflicts$FieldEditor$Data$ConfigWithComparison, data, $elm$core$Maybe$Nothing);
};
var $author$project$Conflicts$FieldEditor$Data$renderWithComparison = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-field-editor-data'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-field-editor-data--editable',
						!_Utils_eq(config.onClick, $elm$core$Maybe$Nothing))
					]))
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var approveDiff = _v0.a.approveDiff;
				var useThis = _v0.a.useThis;
				var comparisonData = _v0.a.comparisonData;
				var value = _v0.a.value;
				var label = _v0.a.label;
				var hasApprovedDiff = _v0.a.hasApprovedDiff;
				var hasConflict = _v0.a.hasConflict;
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-field-editor-data__row'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-field-editor-data__row--with-conflict', hasConflict),
									_Utils_Tuple2('pmt-conflict-data__row--with-approved-diff', hasApprovedDiff),
									_Utils_Tuple2(
									'pmt-conflict-data__row--with-actions',
									(!_Utils_eq(useThis, $elm$core$Maybe$Nothing)) || (!_Utils_eq(approveDiff, $elm$core$Maybe$Nothing)))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$Attributes$class(''),
							A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, config.onClick))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-field-editor-data__field')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-field-editor-data__content pmt-field-editor-data__content--nowrap')
								]),
							_List_fromArray(
								[comparisonData])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__actions')
								]),
							_List_fromArray(
								[
									function () {
									var _v1 = _Utils_Tuple2(approveDiff, hasConflict);
									if ((_v1.a.$ === 'Just') && _v1.b) {
										var opt = _v1.a.a;
										return A3(
											$author$project$PinMeTo$Ui$Btn$pmtBtn,
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(opt.label),
													$elm$html$Html$Events$onClick(opt.onClick)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa fa-check')
														]),
													_List_Nil)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									function () {
									var _v2 = _Utils_Tuple2(
										useThis,
										hasConflict && ($elm$core$String$trim(value) !== ''));
									if ((_v2.a.$ === 'Just') && _v2.b) {
										var opt = _v2.a.a;
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-btn--use-this'),
													$elm$html$Html$Events$onClick(
													opt.onClick(value))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(opt.label)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								]))
						]));
			},
			config.data));
};
var $author$project$Conflicts$FieldEditor$Data$withConflictComparison = F2(
	function (value, _v0) {
		var data = _v0.a;
		return $author$project$Conflicts$FieldEditor$Data$RowWithComparison(
			_Utils_update(
				data,
				{hasConflict: value}));
	});
var $author$project$PinMeTo$Global$StringComparison$renderStrictCharacterComparison = F2(
	function (originalStringValue, stringValueToCompareTo) {
		var compareCharOneByOne = F2(
			function (c1, c2) {
				return _Utils_eq(c1, c2) ? $jinjor$elm_diff$Diff$NoChange(
					$elm$core$String$fromChar(c1)) : $jinjor$elm_diff$Diff$Added(
					$elm$core$String$fromChar(c1));
			});
		var changes = A3(
			$elm$core$List$map2,
			compareCharOneByOne,
			$elm$core$String$toList(originalStringValue),
			$elm$core$String$toList(stringValueToCompareTo));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$map, $author$project$PinMeTo$Global$StringComparison$renderChangeAsCharacter, changes));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$locationField = F3(
	function (networkData, locationData, translations) {
		var _v0 = networkData.data.location;
		if (_v0.$ === 'Just') {
			var networkLocationData = _v0.a;
			var platformLonValue = $elm$core$String$fromFloat(locationData.location.lon);
			var platformLatValue = $elm$core$String$fromFloat(locationData.location.lat);
			var distanceValue = A4($author$project$Common$Math$calculateDistance, locationData.location.lat, locationData.location.lon, networkLocationData.lat, networkLocationData.lon) + ' m';
			return _List_fromArray(
				[
					$author$project$Conflicts$FieldEditor$Data$renderWithComparison(
					$author$project$Conflicts$FieldEditor$Data$viewWithComparison(
						_List_fromArray(
							[
								A2(
								$author$project$Conflicts$FieldEditor$Data$withConflictComparison,
								networkData.validation.dataDiff.location.hasDiff,
								A3(
									$author$project$Conflicts$FieldEditor$Data$rowWithComparison,
									$author$project$Translations$General$locationLatitude(translations),
									$elm$core$String$fromFloat(networkLocationData.lat),
									A2(
										$author$project$PinMeTo$Global$StringComparison$renderStrictCharacterComparison,
										$elm$core$String$fromFloat(networkLocationData.lat),
										platformLatValue))),
								A2(
								$author$project$Conflicts$FieldEditor$Data$withConflictComparison,
								networkData.validation.dataDiff.location.hasDiff,
								A3(
									$author$project$Conflicts$FieldEditor$Data$rowWithComparison,
									$author$project$Translations$General$locationLongitude(translations),
									$elm$core$String$fromFloat(networkLocationData.lon),
									A2(
										$author$project$PinMeTo$Global$StringComparison$renderStrictCharacterComparison,
										$elm$core$String$fromFloat(networkLocationData.lon),
										platformLonValue))),
								A3(
								$author$project$Conflicts$FieldEditor$Data$rowWithComparison,
								$author$project$Translations$Listings$Conflicts$distance(translations),
								distanceValue,
								$elm$html$Html$text(distanceValue))
							])))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$noLocationFound(translations))
						]))
				]);
		}
	});
var $author$project$Conflicts$Resolver$View$NetworkData$imageWithPlaceholder = function (imageUrl) {
	return ($elm$core$String$trim(imageUrl) !== '') ? _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__image')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(imageUrl)
						]),
					_List_Nil)
				]))
		]) : _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__image')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__image-placeholder')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa-solid fa-unlink')
								]),
							_List_Nil)
						]))
				]))
		]);
};
var $author$project$Conflicts$Resolver$View$NetworkData$coverImageField = function (networkData) {
	return $author$project$Conflicts$Resolver$View$NetworkData$imageWithPlaceholder(networkData.data.coverImageUrl);
};
var $author$project$Conflicts$Resolver$View$NetworkData$conflictData = F3(
	function (title, isConflict, data) {
		return A3(
			$author$project$Conflicts$Resolver$View$NetworkData$conflictDataRow,
			title,
			isConflict,
			$elm$html$Html$text(data));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$customNameField = function (networkData) {
	return _List_fromArray(
		[
			A3($author$project$Conflicts$Resolver$View$NetworkData$conflictData, $elm$core$Maybe$Nothing, networkData.validation.dataDiff.customName.hasDiff, networkData.data.name)
		]);
};
var $author$project$Conflicts$Resolver$View$NetworkData$actionLinksConflictData = F3(
	function (actionLink, locationData, translations) {
		var translatedType = A2($author$project$Data$Location$ActionLinks$typeToLabel, actionLink.type_, translations);
		var locActionLinks = A2(
			$elm_community$list_extra$List$Extra$find,
			function (x) {
				return _Utils_eq(x.type_, actionLink.type_);
			},
			locationData.actionLinks);
		var platformActionLinkValue = function () {
			if (locActionLinks.$ === 'Just') {
				var link = locActionLinks.a;
				return link.url;
			} else {
				return '';
			}
		}();
		var hasConflict = function () {
			if (locActionLinks.$ === 'Just') {
				var link = locActionLinks.a;
				return !_Utils_eq(link.url, actionLink.url);
			} else {
				return true;
			}
		}();
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict', hasConflict)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translatedType)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
						]),
					_List_fromArray(
						[
							A2($author$project$PinMeTo$Global$StringComparison$renderCharacterComparison, actionLink.url, platformActionLinkValue)
						]))
				]));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$actionLinksField = F3(
	function (networkData, locationData, translations) {
		var _v0 = networkData.data.actionLinks;
		if (!_v0.b) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]);
		} else {
			var links = _v0;
			return A2(
				$elm$core$List$map,
				function (x) {
					return A3($author$project$Conflicts$Resolver$View$NetworkData$actionLinksConflictData, x, locationData, translations);
				},
				links);
		}
	});
var $author$project$Conflicts$Resolver$View$NetworkData$openingDateField = function (networkData) {
	return _List_fromArray(
		[
			A3($author$project$Conflicts$Resolver$View$NetworkData$conflictData, $elm$core$Maybe$Nothing, networkData.validation.dataDiff.openingDate.hasDiff, networkData.data.openingDate)
		]);
};
var $author$project$Translations$Listings$Conflicts$notSet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.not_set');
};
var $author$project$Translations$Listings$Conflicts$removed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.removed');
};
var $author$project$Conflicts$Resolver$View$NetworkData$renderRepeat = F2(
	function (metaAttribute, a) {
		var getAttributeName = function (metaId) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				metaId,
				function (attribute_) {
					var _v1 = A2(
						$elm_community$list_extra$List$Extra$find,
						function (x) {
							return _Utils_eq(x.value, metaId);
						},
						attribute_.valueMetaData);
					if (_v1.$ === 'Just') {
						var attr = _v1.a;
						return attr.displayName;
					} else {
						return metaId;
					}
				},
				metaAttribute);
		};
		var attributeRemoved = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			true,
			function (_v0) {
				return false;
			},
			metaAttribute);
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (enums) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-check')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-editor-row__removed', attributeRemoved)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												', ',
												A2($elm$core$List$map, getAttributeName, enums.setValues)))
										]))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-xmark')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('pmt-editor-row__removed', attributeRemoved)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$String$join,
												', ',
												A2($elm$core$List$map, getAttributeName, enums.unsetValues)))
										]))
								]))
						]));
			},
			a.repeatedEnumValue);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$attributeConflictData = F4(
	function (translations, attribute, meta, locationData) {
		var getAttributeValue = function (attr) {
			var _v17 = $elm$core$List$head(attr.values);
			if (_v17.$ === 'Just') {
				var value = _v17.a;
				switch (value) {
					case 'true':
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-check')
								]),
							_List_Nil);
					case 'false':
						return A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-xmark')
								]),
							_List_Nil);
					default:
						return $elm$html$Html$text(value);
				}
			} else {
				return $elm$html$Html$text('');
			}
		};
		var metaAttribute = A2(
			$elm_community$list_extra$List$Extra$find,
			function (x) {
				return _Utils_eq(x.attributeId, attribute.attributeId);
			},
			meta.googleAttributes.attributes);
		var removedAttribute = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			true,
			function (_v16) {
				return false;
			},
			metaAttribute);
		var additional = function (attr) {
			var _v15 = attr.valueType;
			if (_v15 === 'REPEATED_ENUM') {
				return A2($author$project$Conflicts$Resolver$View$NetworkData$renderRepeat, metaAttribute, attr);
			} else {
				return $elm$html$Html$text('');
			}
		};
		var _v0 = function () {
			var _v1 = _Utils_Tuple3(attribute.left, attribute.right, removedAttribute);
			if (_v1.a.$ === 'Nothing') {
				if (_v1.b.$ === 'Nothing') {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return _Utils_Tuple3(
						false,
						$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$removed(translations)),
						$elm$html$Html$text(''));
				} else {
					var _v6 = _v1.a;
					var y = _v1.b.a;
					return _Utils_Tuple3(
						false,
						getAttributeValue(y),
						additional(y));
				}
			} else {
				if (_v1.b.$ === 'Nothing') {
					if (!_v1.c) {
						var _v4 = _v1.b;
						return _Utils_Tuple3(
							false,
							$elm$html$Html$text(
								$author$project$Translations$Listings$Conflicts$notSet(translations)),
							$elm$html$Html$text(''));
					} else {
						var _v5 = _v1.b;
						return _Utils_Tuple3(
							false,
							$elm$html$Html$text(
								$author$project$Translations$Listings$Conflicts$removed(translations)),
							$elm$html$Html$text(''));
					}
				} else {
					var y = _v1.b.a;
					return _Utils_Tuple3(
						true,
						getAttributeValue(y),
						additional(y));
				}
			}
		}();
		var hasAttribute = _v0.a;
		var attributeValue = _v0.b;
		var additionalValue = _v0.c;
		var hasConflict = function () {
			var locAttr = A2(
				$elm_community$list_extra$List$Extra$find,
				function (x) {
					return _Utils_eq(x.attributeId, attribute.attributeId);
				},
				locationData.networkAttributes.google);
			var _v8 = _Utils_Tuple2(hasAttribute, locAttr);
			_v8$0:
			while (true) {
				if (_v8.b.$ === 'Just') {
					if (!_v8.a) {
						break _v8$0;
					} else {
						var attr__ = _v8.b.a;
						var _v9 = attr__.valueType;
						if (_v9 === 'REPEATED_ENUM') {
							var _v10 = attr__.repeatedEnumValue;
							if (_v10.$ === 'Just') {
								var enums = _v10.a;
								var _v11 = attr__.repeatedEnumValue;
								if (_v11.$ === 'Just') {
									var aEnums = _v11.a;
									return (!_Utils_eq(enums.setValues, aEnums.setValues)) || (!_Utils_eq(enums.unsetValues, aEnums.unsetValues));
								} else {
									return true;
								}
							} else {
								return true;
							}
						} else {
							var _v12 = $elm$core$List$head(attr__.values);
							if (_v12.$ === 'Just') {
								var value = _v12.a;
								var _v13 = $elm$core$List$head(attr__.values);
								if (_v13.$ === 'Just') {
									var aValue = _v13.a;
									return !_Utils_eq(value, aValue);
								} else {
									return true;
								}
							} else {
								return true;
							}
						}
					}
				} else {
					if (!_v8.a) {
						break _v8$0;
					} else {
						var _v14 = _v8.b;
						return true;
					}
				}
			}
			return true;
		}();
		var name = function () {
			if (metaAttribute.$ === 'Just') {
				var attribute_ = metaAttribute.a;
				return attribute_.displayName;
			} else {
				return attribute.attributeId;
			}
		}();
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict', hasConflict)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-editor-row__removed', removedAttribute)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-conflict-data__content', true),
									_Utils_Tuple2('pmt-editor-row__data', true),
									_Utils_Tuple2('pmt-conflict-data__content--missing', !hasAttribute)
								]))
						]),
					_List_fromArray(
						[attributeValue, additionalValue]))
				]));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$networkAttributes = F4(
	function (translations, networkData, meta, locationData) {
		var attributesCompared = A2($author$project$Data$Location$NetworkAttributes$mapToAttributeCompare, locationData.networkAttributes.google, networkData.data.attributes);
		return A2(
			$elm$core$List$map,
			function (x) {
				return A4($author$project$Conflicts$Resolver$View$NetworkData$attributeConflictData, translations, x, meta, locationData);
			},
			attributesCompared);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$profileImageField = function (networkData) {
	return $author$project$Conflicts$Resolver$View$NetworkData$imageWithPlaceholder(networkData.data.profileImageUrl);
};
var $author$project$Conflicts$Resolver$View$NetworkData$serviceAreasField = function (networkData) {
	var renderer = function (t) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-conflict-data__row--with-conflict', networkData.validation.dataDiff.serviceAreas.hasDiff)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(t)
						]))
				]));
	};
	var _v0 = networkData.data.serviceAreas;
	switch (_v0.$) {
		case 'WithPlaceId':
			var sa = _v0.a;
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var area = _v1.area;
					return renderer(area);
				},
				sa);
		case 'Text':
			var sa = _v0.a;
			return A2($elm$core$List$map, renderer, sa);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$text('')
				]);
	}
};
var $author$project$Conflicts$Resolver$View$NetworkData$specialHoursField = F5(
	function (now, timeZone, networkData, locationData, translations) {
		var matches = A2(
			$author$project$Conflicts$Resolver$SpecialOpenHoursMatch$match,
			A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, locationData.specialOpenHours, now),
			A2($author$project$Data$Location$SpecialOpenHours$withoutExpired, networkData.data.specialOpenHours, now));
		return A4(
			$author$project$Conflicts$Resolver$View$SpecialOpenHours$view,
			timeZone,
			function ($) {
				return $.right;
			},
			matches,
			translations);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$networkServiceItemRow = F3(
	function (googleSupportedServiceItems, locationServices, serviceItem) {
		var getLocationServiceItem = function (id) {
			return A2($elm$core$Dict$get, id, locationServices);
		};
		var formatDescription = function (description) {
			return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '-', $elm$core$Basics$identity, description);
		};
		var hasDifference = F2(
			function (serviceItem_, locationServiceItem) {
				var _v1 = _Utils_Tuple2(serviceItem_, locationServiceItem);
				_v1$2:
				while (true) {
					if (_v1.a.$ === 'Structured') {
						if ((_v1.b.$ === 'Just') && (_v1.b.a.$ === 'Structured')) {
							var s = _v1.a.a;
							var l = _v1.b.a.a;
							return (!_Utils_eq(s.price, l.price)) || (!_Utils_eq(s.description, l.description));
						} else {
							break _v1$2;
						}
					} else {
						if ((_v1.b.$ === 'Just') && (_v1.b.a.$ === 'Freeform')) {
							var s = _v1.a.a;
							var l = _v1.b.a.a;
							return (!_Utils_eq(s.price, l.price)) || (!_Utils_eq(s.label.description, l.label.description));
						} else {
							break _v1$2;
						}
					}
				}
				return true;
			});
		var formatPrice = function (price) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'-',
				function (price_) {
					return price_.amount + (' ' + price_.currency);
				},
				price);
		};
		var renderRow = F4(
			function (title, price, description, hasDiff) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-data__row pmt-editor-row'),
							$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__container'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-conflict-data__row--with-conflict', hasDiff)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__field pmt-editor-row__title'),
									$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
									$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__price')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(price)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-data__content pmt-editor-row__data'),
									$elm$html$Html$Attributes$class('pmt-conflict-data--service-items__description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]));
			});
		var renderServiceItem = F4(
			function (displayName, price, description, hasDiff) {
				return A4(
					renderRow,
					displayName,
					formatPrice(price),
					formatDescription(description),
					hasDiff);
			});
		if (serviceItem.$ === 'Structured') {
			var serviceItem_ = serviceItem.a;
			var locationServiceItem = getLocationServiceItem(serviceItem_.id);
			var displayName = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Data$Location$NetworkServiceItems$parseStructuredServiceId(serviceItem_.id),
				A2($elm$core$Dict$get, serviceItem_.id, googleSupportedServiceItems));
			var hasDiff = A2(
				hasDifference,
				$author$project$Data$Location$NetworkServiceItems$Structured(serviceItem_),
				locationServiceItem);
			return A4(renderServiceItem, displayName, serviceItem_.price, serviceItem_.description, hasDiff);
		} else {
			var serviceItem_ = serviceItem.a;
			var locationServiceItem = getLocationServiceItem(serviceItem_.label.displayName);
			var hasDiff = A2(
				hasDifference,
				$author$project$Data$Location$NetworkServiceItems$Freeform(serviceItem_),
				locationServiceItem);
			return A4(renderServiceItem, serviceItem_.label.displayName, serviceItem_.price, serviceItem_.label.description, hasDiff);
		}
	});
var $author$project$Conflicts$Resolver$View$NetworkData$networkServiceItems = F3(
	function (meta, networkData, locationData) {
		var googleSupportedServiceItems = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (supportedServiceItem) {
					return _Utils_Tuple2(supportedServiceItem.id, supportedServiceItem.name);
				},
				meta.googleSupportedServiceItems));
		var locationServices = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (x) {
					if (x.$ === 'Structured') {
						var serviceItem = x.a;
						return _Utils_Tuple2(serviceItem.id, x);
					} else {
						var serviceItem = x.a;
						return _Utils_Tuple2(serviceItem.label.displayName, x);
					}
				},
				locationData.networkServiceItems.google));
		return A2(
			$elm$core$List$map,
			A2($author$project$Conflicts$Resolver$View$NetworkData$networkServiceItemRow, googleSupportedServiceItems, locationServices),
			networkData.data.serviceItems);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$longDescriptionField = F2(
	function (networkData, locationData) {
		var platformLongDescriptionValue = A2(
			$author$project$Data$Location$replaceTemplateTags,
			locationData,
			$author$project$Data$Location$longDescriptionToString(locationData.longDescription));
		return A2(
			$elm$core$List$map,
			function (paragraph_) {
				return A3(
					$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
					$elm$core$Maybe$Nothing,
					networkData.validation.dataDiff.longDescription.hasDiff,
					A2($author$project$PinMeTo$Global$StringComparison$renderSentenceComparison, paragraph_, platformLongDescriptionValue));
			},
			A2($elm$core$String$split, '\u000A', networkData.data.longDescription));
	});
var $author$project$Translations$General$locationUnhandledField = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_unhandled_field');
};
var $author$project$Translations$General$additional = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.additional');
};
var $author$project$Conflicts$Resolver$View$NetworkData$networkCategoriesField = F2(
	function (networkData, translations) {
		var name = function () {
			var _v1 = networkData.data.networkCategories;
			switch (_v1.$) {
				case 'Google':
					var g = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							g.primary));
				case 'Facebook':
					var fb = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							$elm$core$List$head(fb)));
				case 'Bing':
					var bing = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							bing.primary));
				case 'Apple':
					var a = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							a.primary));
				case 'Foursquare':
					var a = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							$elm$core$List$head(a.categories)));
				case 'Overture':
					var o = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							o.primary));
				case 'Here':
					var h = _v1.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.name;
							},
							h.primary));
				case 'Tomtom':
					var t = _v1.a;
					return t.name;
				case 'Ptv':
					return '';
				default:
					return '';
			}
		}();
		var primaryName = name;
		var primary = A3(
			$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
			$elm$core$Maybe$Just(
				$author$project$Translations$General$primary(translations)),
			networkData.validation.dataDiff.networkCategories.hasDiff,
			primaryName);
		var additional = function () {
			var _v0 = networkData.data.networkCategories;
			switch (_v0.$) {
				case 'Google':
					var g = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3(
								$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
								$elm$core$Maybe$Just(
									$author$project$Translations$General$additional(translations)),
								networkData.validation.dataDiff.networkCategories.hasDiff,
								x);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.id;
								},
								g.additional)));
				case 'Facebook':
					var fb = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3($author$project$Conflicts$Resolver$View$NetworkData$conflictData, $elm$core$Maybe$Nothing, networkData.validation.dataDiff.networkCategories.hasDiff, x);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.id;
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$elm$core$List$tail(fb)))));
				case 'Bing':
					var bing = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3(
								$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
								$elm$core$Maybe$Just(
									$author$project$Translations$General$additional(translations)),
								networkData.validation.dataDiff.networkCategories.hasDiff,
								x);
						},
						A2(
							$elm$core$List$filter,
							function (y) {
								return !_Utils_eq(y, primaryName);
							},
							A2(
								$elm$core$List$map,
								function ($) {
									return $.name;
								},
								bing.additional)));
				case 'Apple':
					var a = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3(
								$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
								$elm$core$Maybe$Just(
									$author$project$Translations$General$additional(translations)),
								networkData.validation.dataDiff.networkCategories.hasDiff,
								x);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.id;
								},
								a.additional)));
				case 'Foursquare':
					var a = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3(
								$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
								$elm$core$Maybe$Just(
									$author$project$Translations$General$additional(translations)),
								networkData.validation.dataDiff.networkCategories.hasDiff,
								x);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.id;
								},
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$elm$core$List$tail(a.categories)))));
				case 'Overture':
					var a = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3(
								$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
								$elm$core$Maybe$Just(
									$author$project$Translations$General$additional(translations)),
								networkData.validation.dataDiff.networkCategories.hasDiff,
								x);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.id;
								},
								a.additional)));
				case 'Here':
					var a = _v0.a;
					return A2(
						$elm$core$List$map,
						function (x) {
							return A3(
								$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
								$elm$core$Maybe$Just(
									$author$project$Translations$General$additional(translations)),
								networkData.validation.dataDiff.networkCategories.hasDiff,
								x);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.id;
								},
								a.additional)));
				case 'Tomtom':
					return _List_Nil;
				case 'Ptv':
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}();
		var spacer = $elm$core$List$isEmpty(additional) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\u00A0')
				]));
		return A2(
			$elm$core$List$cons,
			primary,
			A2($elm$core$List$cons, spacer, additional));
	});
var $author$project$Conflicts$Resolver$View$NetworkData$permanentlyClosedField = F2(
	function (networkData, translations) {
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.permanentlyClosed.hasDiff,
				networkData.data.permanentlyClosed ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations))
			]);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$temporarilyClosedField = F2(
	function (networkData, translations) {
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictData,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.temporarilyClosedUntil.hasDiff,
				A2($author$project$Data$NetworkData$TemporarilyClosed$toHumanReadable, networkData.data.temporarilyClosedUntil, translations))
			]);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$locationDescriptorField = F2(
	function (networkData, locationData) {
		var platformLocationDescriptorValue = $author$project$Data$Location$locationDescriptorToString(locationData.locationDescriptor);
		return _List_fromArray(
			[
				A3(
				$author$project$Conflicts$Resolver$View$NetworkData$conflictDataWithComparison,
				$elm$core$Maybe$Nothing,
				networkData.validation.dataDiff.locationDescriptor.hasDiff,
				A2($author$project$PinMeTo$Global$StringComparison$renderSentenceComparison, networkData.data.locationDescriptor, platformLocationDescriptorValue))
			]);
	});
var $author$project$Conflicts$Resolver$View$NetworkData$view = F9(
	function (timeZone, meta, network, approveDiff, locationData, networkData, field, translations, now) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-data pmt-conflict-data--network-data')
				]),
			function () {
				switch (field.$) {
					case 'Name':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$nameField, networkData, locationData);
					case 'OpeningDate':
						return $author$project$Conflicts$Resolver$View$NetworkData$openingDateField(networkData);
					case 'CustomName':
						return $author$project$Conflicts$Resolver$View$NetworkData$customNameField(networkData);
					case 'StoreId':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$storeIdField, networkData, locationData);
					case 'LocationDescriptor':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$locationDescriptorField, networkData, locationData);
					case 'Location':
						return A3($author$project$Conflicts$Resolver$View$NetworkData$locationField, networkData, locationData, translations);
					case 'About':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$aboutField, networkData, locationData);
					case 'LongDescription':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$longDescriptionField, networkData, locationData);
					case 'Hours':
						return A3($author$project$Conflicts$Resolver$View$NetworkData$hoursField, networkData, locationData, translations);
					case 'SpecialHours':
						return A5($author$project$Conflicts$Resolver$View$NetworkData$specialHoursField, now, timeZone, networkData, locationData, translations);
					case 'PermanentlyClosed':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$permanentlyClosedField, networkData, translations);
					case 'TemporarilyClosedUntil':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$temporarilyClosedField, networkData, translations);
					case 'Email':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$emailField, networkData, locationData);
					case 'Homepage':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$homepageField, networkData, locationData);
					case 'Phone':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$phoneField, networkData, locationData);
					case 'Address':
						return _List_fromArray(
							[
								A4($author$project$Conflicts$Resolver$View$NetworkData$addressField, network, networkData, approveDiff, translations)
							]);
					case 'CoverImage':
						return $author$project$Conflicts$Resolver$View$NetworkData$coverImageField(networkData);
					case 'ProfileImage':
						return $author$project$Conflicts$Resolver$View$NetworkData$profileImageField(networkData);
					case 'NetworkCategories':
						return A2($author$project$Conflicts$Resolver$View$NetworkData$networkCategoriesField, networkData, translations);
					case 'NetworkAttributes':
						return A4($author$project$Conflicts$Resolver$View$NetworkData$networkAttributes, translations, networkData, meta, locationData);
					case 'ActionLinks':
						return A3($author$project$Conflicts$Resolver$View$NetworkData$actionLinksField, networkData, locationData, translations);
					case 'NetworkServiceItems':
						return A3($author$project$Conflicts$Resolver$View$NetworkData$networkServiceItems, meta, networkData, locationData);
					case 'ServiceAreas':
						return $author$project$Conflicts$Resolver$View$NetworkData$serviceAreasField(networkData);
					case 'Wifi':
						return _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$locationUnhandledField(translations) + ' \u0027Wifi\u0027')
							]);
					default:
						var s = field.a;
						return _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$locationUnhandledField(translations) + (' \u0027' + (s + '\u0027')))
							]);
				}
			}());
	});
var $author$project$Conflicts$FieldEditor$FieldEditor$when = F2(
	function (x, f) {
		return x ? f : $elm$core$Basics$identity;
	});
var $author$project$Translations$General$upload = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.upload');
};
var $author$project$Conflicts$Resolver$ConflictStates$isSaving = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			switch (_v1.$) {
				case 'SavingLocal':
					return true;
				case 'SavingNetwork':
					return true;
				default:
					return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$Types$SaveLocal = F2(
	function (a, b) {
		return {$: 'SaveLocal', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$Map$BingMarker = {$: 'BingMarker'};
var $author$project$PinMeTo$Ui$Map$AppleMarker = {$: 'AppleMarker'};
var $author$project$Conflicts$Resolver$Types$PinSelected = function (a) {
	return {$: 'PinSelected', a: a};
};
var $author$project$PinMeTo$Ui$Map$FacebookMarker = {$: 'FacebookMarker'};
var $author$project$PinMeTo$Ui$Map$withOnPinSelect = F2(
	function (msg, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Map$View(
			_Utils_update(
				config,
				{
					onPinSelect: $elm$core$Maybe$Just(msg)
				}));
	});
var $author$project$Conflicts$Resolver$Types$OnChangeMasterData = function (a) {
	return {$: 'OnChangeMasterData', a: a};
};
var $author$project$Conflicts$Resolver$View$FieldConflicts$pmtUiMap = F4(
	function (selectedPinId, location, isResolved, translations) {
		var getNetworkCoordinates = function (maybeNetworkData) {
			return A2(
				$elm$core$Maybe$andThen,
				function (networkData) {
					return networkData.data.location;
				},
				maybeNetworkData);
		};
		var getNetworkMarker = function (network) {
			switch (network.$) {
				case 'Facebook':
					return $author$project$PinMeTo$Ui$Map$FacebookMarker;
				case 'Google':
					return $author$project$PinMeTo$Ui$Map$GoogleMarker;
				case 'Bing':
					return $author$project$PinMeTo$Ui$Map$BingMarker;
				case 'Apple':
					return $author$project$PinMeTo$Ui$Map$AppleMarker;
				default:
					return $author$project$PinMeTo$Ui$Map$ApiMarker;
			}
		};
		var markerActivate = F4(
			function (popupLabel, saveMsg, maybeMarker, isSelected) {
				return isSelected ? A2(
					$elm$core$Basics$composeR,
					$author$project$PinMeTo$Ui$Map$withPinMarker($author$project$PinMeTo$Ui$Map$BlueCheckMarker),
					$author$project$PinMeTo$Ui$Map$withCustomPopover(
						$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								saveMsg,
								$author$project$PinMeTo$Ui$Button$buttonPrimary(popupLabel))))) : A2(
					$elm$core$Basics$composeR,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Basics$identity,
						A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Map$withPinMarker, maybeMarker)),
					$author$project$PinMeTo$Ui$Map$withCustomPopover(
						$elm$html$Html$text('')));
			});
		var getNetworkData = function (network) {
			switch (network.$) {
				case 'Facebook':
					return location.facebook;
				case 'Google':
					return location.google;
				case 'Bing':
					return location.bing;
				case 'Apple':
					return location.apple;
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var getNetworkInfo = function (network) {
			return {
				marker: getNetworkMarker(network),
				network: network,
				networkData: getNetworkData(network),
				networkName: $author$project$Data$Network$toString(network)
			};
		};
		var allNetworksInfo = A2(
			$elm$core$List$map,
			getNetworkInfo,
			_List_fromArray(
				[$author$project$Data$Network$Facebook, $author$project$Data$Network$Google, $author$project$Data$Network$Bing, $author$project$Data$Network$Apple]));
		var isSelectedPin = function (pinId) {
			return _Utils_eq(
				selectedPinId,
				$elm$core$Maybe$Just(pinId));
		};
		var createPinFromCoords = F4(
			function (coords, networkName, marker, network) {
				return A5(
					markerActivate,
					$author$project$Translations$General$resolverUseThis(translations),
					A3($author$project$Conflicts$Resolver$Types$SaveNetwork, network, $author$project$Data$Location$Field$Location, location),
					$elm$core$Maybe$Just(marker),
					isSelectedPin(networkName),
					A2($author$project$PinMeTo$Ui$Map$pinWithId, networkName, coords));
			});
		var createNetworkPin = function (_v1) {
			var network = _v1.network;
			var networkName = _v1.networkName;
			var marker = _v1.marker;
			var networkData = _v1.networkData;
			var maybeCoords = getNetworkCoordinates(networkData);
			var hasConflict = A3(
				$author$project$Data$Location$hasConflictInFieldsInNetwork,
				_List_fromArray(
					[$author$project$Data$Location$Field$Location]),
				location,
				network);
			return hasConflict ? A2(
				$elm$core$Maybe$map,
				function (coords) {
					return A4(createPinFromCoords, coords, networkName, marker, network);
				},
				maybeCoords) : $elm$core$Maybe$Nothing;
		};
		var networkPins = isResolved ? _List_Nil : A2($elm$core$List$map, createNetworkPin, allNetworksInfo);
		var mainPin = $elm$core$Maybe$Just(
			A5(
				markerActivate,
				$author$project$Translations$General$resolverUseThis(translations),
				A2($author$project$Conflicts$Resolver$Types$SaveLocal, $author$project$Data$Location$Field$Location, location),
				isResolved ? $elm$core$Maybe$Just($author$project$PinMeTo$Ui$Map$BlueCheckMarker) : $elm$core$Maybe$Nothing,
				isSelectedPin('pinmeto'),
				A2(
					$author$project$PinMeTo$Ui$Map$withPinDraggable,
					!isResolved,
					A2(
						$author$project$PinMeTo$Ui$Map$pinWithId,
						'pinmeto',
						{lat: location.location.lat, lon: location.location.lon}))));
		var allPins = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			$elm$core$List$reverse(
				A2($elm$core$List$cons, mainPin, networkPins)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-resolver__leaflet-map')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Map$render(
					A2(
						$author$project$PinMeTo$Ui$Map$withOnChange,
						F2(
							function (_v0, x) {
								return $author$project$Conflicts$Resolver$Types$OnChangeMasterData(x);
							}),
						A2(
							$author$project$PinMeTo$Ui$Map$withOnPinSelect,
							function (maybePinId) {
								return $author$project$Conflicts$Resolver$Types$PinSelected(maybePinId);
							},
							A2(
								$author$project$PinMeTo$Ui$Map$withOnPopulate,
								$author$project$PinMeTo$Ui$Map$FitBoundsOnPopulate,
								$author$project$PinMeTo$Ui$Map$view(allPins)))))
				]));
	});
var $author$project$Conflicts$Resolver$Types$EditLocal = F2(
	function (a, b) {
		return {$: 'EditLocal', a: a, b: b};
	});
var $author$project$Data$Location$Field$allFields = _List_fromArray(
	[
		$author$project$Data$Location$Field$Name,
		$author$project$Data$Location$Field$CustomName($author$project$Data$Network$Google),
		$author$project$Data$Location$Field$CustomName($author$project$Data$Network$Facebook),
		$author$project$Data$Location$Field$StoreId,
		$author$project$Data$Location$Field$LocationDescriptor,
		$author$project$Data$Location$Field$Location,
		$author$project$Data$Location$Field$About,
		$author$project$Data$Location$Field$LongDescription,
		$author$project$Data$Location$Field$Hours,
		$author$project$Data$Location$Field$OpeningDate,
		$author$project$Data$Location$Field$SpecialHours,
		$author$project$Data$Location$Field$PermanentlyClosed,
		$author$project$Data$Location$Field$TemporarilyClosedUntil,
		$author$project$Data$Location$Field$Email,
		$author$project$Data$Location$Field$Homepage,
		$author$project$Data$Location$Field$Phone,
		$author$project$Data$Location$Field$Address,
		$author$project$Data$Location$Field$CoverImage($author$project$Data$Network$Google),
		$author$project$Data$Location$Field$CoverImage($author$project$Data$Network$Facebook),
		$author$project$Data$Location$Field$ProfileImage($author$project$Data$Network$Google),
		$author$project$Data$Location$Field$ProfileImage($author$project$Data$Network$Facebook),
		$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Google),
		$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Facebook),
		$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Bing),
		$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Apple),
		$author$project$Data$Location$Field$NetworkAttributes($author$project$Data$Network$Google),
		$author$project$Data$Location$Field$ActionLinks,
		$author$project$Data$Location$Field$ServiceAreas,
		$author$project$Data$Location$Field$Wifi,
		$author$project$Data$Location$Field$NetworkServiceItems($author$project$Data$Network$Google)
	]);
var $author$project$Conflicts$FieldEditor$FieldEditor$isWorking = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{isWorking: x});
	});
var $author$project$Conflicts$Resolver$ConflictStates$isWorking = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			switch (_v1.$) {
				case 'WorkingLocal':
					return true;
				case 'WorkingNetwork':
					return true;
				default:
					return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$FieldEditor$FieldEditor$withAlert = F2(
	function (note, config) {
		return _Utils_update(
			config,
			{
				data: A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							config.data,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-field-editor__alert')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Warning,
										$author$project$PinMeTo$Ui$Alert$rich(
											_List_fromArray(
												[
													$elm$html$Html$text(note)
												]))))
								]))
						]))
			});
	});
var $author$project$Conflicts$Resolver$ConflictStates$isResolved = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			switch (_v1.$) {
				case 'ResolvedLocal':
					return true;
				case 'ResolvedNetwork':
					return true;
				default:
					return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$Types$ApproveDiff = F4(
	function (a, b, c, d) {
		return {$: 'ApproveDiff', a: a, b: b, c: c, d: d};
	});
var $author$project$Conflicts$Resolver$ConflictStates$errorMessage = F3(
	function (field, locationId, states) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Maybe$Nothing,
			function (conflict) {
				return conflict.error;
			},
			A2(
				$elm$core$Dict$get,
				_Utils_Tuple2(
					locationId,
					$author$project$Data$Location$Field$toString(field)),
				states));
	});
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Util$capitalize = function (str) {
	var _v0 = $elm$core$String$uncons(str);
	if (_v0.$ === 'Nothing') {
		return '';
	} else {
		var _v1 = _v0.a;
		var head = _v1.a;
		var tail = _v1.b;
		return A2(
			$elm$core$String$append,
			$elm$core$String$fromChar(
				$elm$core$Char$toUpper(head)),
			tail);
	}
};
var $author$project$Conflicts$Resolver$View$FieldConflicts$errorMessages = F3(
	function (conflictError, locationUrl, translations) {
		var networkLabel = function (error) {
			var _v2 = error.network;
			if (_v2.$ === 'Just') {
				var network = _v2.a;
				return $author$project$Util$capitalize(network);
			} else {
				return '';
			}
		};
		var errorDetails = function (error) {
			return ($elm$core$List$length(error.details) > 0) ? A2(
				$elm$html$Html$dl,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('status-bar__content util__inset')
					]),
				A2(
					$elm$core$List$map,
					function (detail) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$dt,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(detail.message)
										])),
									A2(
									$elm$html$Html$dd,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(detail.field + ': ')
												])),
											function () {
											var _v1 = detail.value;
											if (_v1.$ === 'Just') {
												var fieldValue = _v1.a;
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(fieldValue)
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}()
										]))
								]));
					},
					error.details)) : $elm$html$Html$text('');
		};
		var errorSpan = F2(
			function (networkName, errorText) {
				var errorElement = A3($author$project$Common$ErrorMessages$getError, errorText, locationUrl, translations);
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar__message')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(networkName + ': ')
								])),
							errorElement
						]));
			});
		if (conflictError.$ === 'ConflictError') {
			var errorMessage = conflictError.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-resolver__error-container')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Alert$render(
						A2(
							$author$project$PinMeTo$Ui$Alert$withStatus,
							$author$project$PinMeTo$Ui$Alert$Error,
							$author$project$PinMeTo$Ui$Alert$plain(errorMessage)))
					]));
		} else {
			var details = conflictError.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-conflict-resolver__error-container')
					]),
				A2(
					$elm$core$List$map,
					function (error) {
						return $author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Error,
								$author$project$PinMeTo$Ui$Alert$rich(
									_List_fromArray(
										[
											A2(
											errorSpan,
											networkLabel(error),
											error.reason),
											errorDetails(error)
										]))));
					},
					details.errors));
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$isSavingLocal = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			if (_v1.$ === 'SavingLocal') {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$isWorkingLocal = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			if (_v1.$ === 'WorkingLocal') {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$FieldEditor$FieldEditor$withNetworkUrl = F2(
	function (x, config) {
		return _Utils_update(
			config,
			{
				fieldType: function () {
					var _v0 = config.fieldType;
					if (_v0.$ === 'Local') {
						return $author$project$Conflicts$FieldEditor$FieldEditor$Local;
					} else {
						var network = _v0.a;
						return $author$project$Conflicts$FieldEditor$FieldEditor$Network(
							_Utils_update(
								network,
								{
									url: $elm$core$Maybe$Just(x)
								}));
					}
				}()
			});
	});
var $author$project$Conflicts$Resolver$ConflictStates$isSavingNetwork = F4(
	function (network, field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			if (_v1.$ === 'SavingNetwork') {
				var selectNetwork_ = _v1.a;
				return _Utils_eq(selectNetwork_, network);
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$isSelectedLocal = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			return _Utils_eq(
				conflict.selected,
				$elm$core$Maybe$Just($author$project$Conflicts$Resolver$ConflictStates$Local));
		} else {
			return false;
		}
	});
var $author$project$Data$Network$toHumanReadable = function (network) {
	if (network.$ === 'Ptv') {
		return 'PTV';
	} else {
		return $author$project$Data$Network$toString(network);
	}
};
var $author$project$Translations$Listings$Tasks$fieldUnhandled = F2(
	function (translations, field) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.tasks.field_unhandled',
			_List_fromArray(
				[
					_Utils_Tuple2('field', field)
				]));
	});
var $author$project$Translations$Listings$Tasks$locationLatLong = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.location_lat_long');
};
var $author$project$Translations$General$locationServiceItems = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_service_items');
};
var $author$project$Data$Location$Field$toHumanReadable = F2(
	function (field, translations) {
		switch (field.$) {
			case 'Name':
				return $author$project$Translations$General$locationStorefrontName(translations);
			case 'CustomName':
				return $author$project$Translations$General$locationCustomName(translations);
			case 'StoreId':
				return $author$project$Translations$General$locationStoreId(translations);
			case 'LocationDescriptor':
				return $author$project$Translations$General$locationDescriptor(translations);
			case 'Location':
				return $author$project$Translations$Listings$Tasks$locationLatLong(translations);
			case 'About':
				return $author$project$Translations$General$locationShortDescription(translations);
			case 'LongDescription':
				return $author$project$Translations$General$locationLongDescription(translations);
			case 'Hours':
				return $author$project$Translations$General$locationOpenHours(translations);
			case 'OpeningDate':
				return $author$project$Translations$General$locationOpeningDate(translations);
			case 'SpecialHours':
				return $author$project$Translations$General$locationSpecialHours(translations);
			case 'PermanentlyClosed':
				return $author$project$Translations$General$locationPermanentlyClosed(translations);
			case 'TemporarilyClosedUntil':
				return $author$project$Translations$General$locationTempClosed(translations);
			case 'Email':
				return $author$project$Translations$General$locationEmail(translations);
			case 'Homepage':
				return $author$project$Translations$General$locationHomepage(translations);
			case 'Phone':
				return $author$project$Translations$General$locationPhone(translations);
			case 'Address':
				return $author$project$Translations$General$locationAddress(translations);
			case 'CoverImage':
				return $author$project$Translations$General$locationCoverImage(translations);
			case 'ProfileImage':
				return $author$project$Translations$General$locationProfileImage(translations);
			case 'NetworkCategories':
				return $author$project$Translations$General$locationNetworkCategories(translations);
			case 'NetworkAttributes':
				return $author$project$Translations$General$locationAttributes(translations);
			case 'ActionLinks':
				return $author$project$Translations$General$locationActionLinks(translations);
			case 'ServiceAreas':
				return $author$project$Translations$General$serviceAreas(translations);
			case 'Wifi':
				return $author$project$Translations$General$locationWifi(translations);
			case 'Unhandled':
				var x = field.a;
				return A2($author$project$Translations$Listings$Tasks$fieldUnhandled, translations, x);
			default:
				return $author$project$Translations$General$locationServiceItems(translations);
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$isWorkingNetwork = F4(
	function (network, field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			if (_v1.$ === 'WorkingNetwork') {
				var selectNetwork_ = _v1.a;
				return _Utils_eq(selectNetwork_, network);
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$ConflictStates$isSelectedNetwork = F4(
	function (network, field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.selected;
			if ((_v1.$ === 'Just') && (_v1.a.$ === 'Network')) {
				var selectedNetwork = _v1.a.a;
				return _Utils_eq(network, selectedNetwork);
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Conflicts$Resolver$Types$ConfirmSaveNetwork = function (a) {
	return {$: 'ConfirmSaveNetwork', a: a};
};
var $author$project$Conflicts$Resolver$ConflictStates$isResolvedWithLocation = F3(
	function (field, locationId, states) {
		var _v0 = A2(
			$elm$core$Dict$get,
			_Utils_Tuple2(
				locationId,
				$author$project$Data$Location$Field$toString(field)),
			states);
		if (_v0.$ === 'Just') {
			var conflict = _v0.a;
			var _v1 = conflict.state;
			switch (_v1.$) {
				case 'ResolvedLocal':
					var location = _v1.a;
					return $elm$core$Maybe$Just(location);
				case 'ResolvedNetwork':
					var location = _v1.b;
					return $elm$core$Maybe$Just(location);
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Location$Details$Editor$PermanentlyClosedEditor = {$: 'PermanentlyClosedEditor'};
var $author$project$Location$Details$Editor$TemporarilyClosedEditor = F2(
	function (a, b) {
		return {$: 'TemporarilyClosedEditor', a: a, b: b};
	});
var $author$project$Translations$Listings$Conflicts$facebookCustomNameIssue = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.facebook_custom_name_issue');
};
var $author$project$Conflicts$FieldEditor$FieldEditor$withCtaDataTestAttribute = F2(
	function (attributeValue, config) {
		return _Utils_update(
			config,
			{
				cta: A2(
					$elm$core$Maybe$map,
					function (cta_) {
						return _Utils_update(
							cta_,
							{
								dataTestAttribute: $elm$core$Maybe$Just(attributeValue)
							});
					},
					config.cta)
			});
	});
var $author$project$Location$Details$Editor$CustomNameOnNetworkEditor = function (a) {
	return {$: 'CustomNameOnNetworkEditor', a: a};
};
var $author$project$Data$Location$Field$toHumanReadableWithNetwork = F2(
	function (field, translations) {
		var withNetwork = function (network) {
			return A2(
				$author$project$Data$Location$Field$appendNetwork,
				network,
				A2($author$project$Data$Location$Field$toHumanReadable, field, translations) + ' ');
		};
		switch (field.$) {
			case 'CustomName':
				var network = field.a;
				return withNetwork(network);
			case 'CoverImage':
				var network = field.a;
				return withNetwork(network);
			case 'ProfileImage':
				var network = field.a;
				return withNetwork(network);
			case 'NetworkCategories':
				var network = field.a;
				return withNetwork(network);
			default:
				return A2($author$project$Data$Location$Field$toHumanReadable, field, translations);
		}
	});
var $author$project$Translations$Listings$Conflicts$storeFrontWithServiceAreaConflict = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.store_front_with_service_area_conflict');
};
var $author$project$Conflicts$Resolver$View$FieldConflicts$view = function (isCtaDisabled) {
	return function (disabledField) {
		return function (alertMessage) {
			return function (selectedPinId) {
				return function (config) {
					return function (meta) {
						return function (networks) {
							return function (conflictStates) {
								return function (location) {
									return function (translations) {
										return function (now) {
											return function (siteNameParam) {
												return function (field) {
													if (A2(
														$author$project$Data$Location$hasConflictInFields,
														_List_fromArray(
															[field]),
														location)) {
														var hasStorefrontLocationServiceAreasConflict = (_Utils_eq(field, $author$project$Data$Location$Field$ServiceAreas) && _Utils_eq(location.locationType, $author$project$Data$Location$Storefront)) ? true : false;
														var networksWithFieldConflict = A2(
															$elm$core$List$filter,
															function (network) {
																return A2($author$project$Data$Location$Field$isFieldInNetwork, field, network) && A3(
																	$author$project$Data$Location$hasConflictInFieldsInNetwork,
																	_List_fromArray(
																		[field]),
																	location,
																	network);
															},
															networks);
														var specificFieldNote = function () {
															switch (field.$) {
																case 'NetworkCategories':
																	var network = field.a;
																	return _Utils_eq(network, $author$project$Data$Network$Google) ? A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$style, 'marginBottom', '1rem')
																			]),
																		_List_fromArray(
																			[
																				$author$project$PinMeTo$Ui$Alert$render(
																				A2(
																					$author$project$PinMeTo$Ui$Alert$withStatus,
																					$author$project$PinMeTo$Ui$Alert$Warning,
																					$author$project$PinMeTo$Ui$Alert$rich(
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Translations$Listings$Conflicts$changingGoogleCategory(translations) + ' '),
																								A2(
																								$elm$html$Html$a,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$href('https://support.google.com/business/answer/7249669?hl=en#:~:text=Add%20or%20edit%20categories,Select%20Edit%20profile.&text=From%20the%20%E2%80%9CPrimary%20category%E2%80%9D%20box,shows%20up%2C%20select%20a%20category'),
																										$elm$html$Html$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(
																										$author$project$Translations$Listings$Conflicts$changingGoogleCategoryLink(translations))
																									]))
																							]))))
																			])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
																case 'CustomName':
																	var network = field.a;
																	return _Utils_eq(network, $author$project$Data$Network$Facebook) ? A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				A2($elm$html$Html$Attributes$style, 'marginBottom', '1rem')
																			]),
																		_List_fromArray(
																			[
																				$author$project$PinMeTo$Ui$Alert$render(
																				A2(
																					$author$project$PinMeTo$Ui$Alert$withStatus,
																					$author$project$PinMeTo$Ui$Alert$Warning,
																					$author$project$PinMeTo$Ui$Alert$rich(
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Translations$Listings$Conflicts$facebookCustomNameIssue(translations))
																							]))))
																			])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
																default:
																	return A2($elm$html$Html$span, _List_Nil, _List_Nil);
															}
														}();
														var isFieldEditable = function (editableField) {
															var editableFields = $elm$core$List$isEmpty(config.editableFields) ? $author$project$Data$Location$Field$allFields : config.editableFields;
															return A2($elm$core$List$member, editableField, editableFields);
														};
														var fieldNetworkData = F2(
															function (network, networkData) {
																var fieldDataRender = A9(
																	$author$project$Conflicts$Resolver$View$NetworkData$view,
																	config.timeZone,
																	meta,
																	network,
																	A3($author$project$Conflicts$Resolver$Types$ApproveDiff, network, field, location),
																	location,
																	networkData,
																	field,
																	translations,
																	now);
																var canUseThis = function () {
																	var _v8 = _Utils_Tuple2(field, network);
																	switch (_v8.a.$) {
																		case 'Name':
																			var _v9 = _v8.a;
																			return isFieldEditable(field);
																		case 'StoreId':
																			var _v10 = _v8.a;
																			return false;
																		case 'TemporarilyClosedUntil':
																			var _v11 = _v8.a;
																			return A2(
																				$elm$core$List$member,
																				network,
																				_List_fromArray(
																					[$author$project$Data$Network$Bing, $author$project$Data$Network$Apple]));
																		case 'ServiceAreas':
																			if (_v8.b.$ === 'Google') {
																				var _v12 = _v8.a;
																				var _v13 = _v8.b;
																				return !_Utils_eq(location.locationType, $author$project$Data$Location$Storefront);
																			} else {
																				var _v14 = _v8.a;
																				return false;
																			}
																		default:
																			return true;
																	}
																}();
																var conf = {
																	isSaving: A3($author$project$Conflicts$Resolver$ConflictStates$isSaving, field, location.id, conflictStates) || A3($author$project$Conflicts$Resolver$ConflictStates$isWorking, field, location.id, conflictStates),
																	isResolved: A3($author$project$Conflicts$Resolver$ConflictStates$isResolved, field, location.id, conflictStates),
																	isSelected: _Utils_eq(field, $author$project$Data$Location$Field$Location) ? _Utils_eq(
																		selectedPinId,
																		$elm$core$Maybe$Just(
																			$author$project$Data$Network$toString(network))) : A4($author$project$Conflicts$Resolver$ConflictStates$isSelectedNetwork, network, field, location.id, conflictStates),
																	isPublishing: A4($author$project$Conflicts$Resolver$ConflictStates$isSavingNetwork, network, field, location.id, conflictStates) || A4($author$project$Conflicts$Resolver$ConflictStates$isWorkingNetwork, network, field, location.id, conflictStates)
																};
																var msg = function () {
																	if (_Utils_eq(
																		field,
																		$author$project$Data$Location$Field$NetworkCategories(network)) && _Utils_eq(network, $author$project$Data$Network$Google)) {
																		var primaryNetworkCategoryId = function () {
																			var _v7 = networkData.data.networkCategories;
																			if (_v7.$ === 'Google') {
																				var categories_ = _v7.a;
																				return A2(
																					$elm$core$Maybe$map,
																					function (primaryCategories_) {
																						return primaryCategories_.id;
																					},
																					categories_.primary);
																			} else {
																				return $elm$core$Maybe$Nothing;
																			}
																		}();
																		var primaryCategoryId = A2(
																			$elm$core$Maybe$map,
																			function ($) {
																				return $.id;
																			},
																			$elm_community$maybe_extra$Maybe$Extra$join(
																				A2(
																					$elm$core$Maybe$map,
																					function (cats) {
																						return cats.primary;
																					},
																					location.networkCategories.google)));
																		return _Utils_eq(primaryNetworkCategoryId, primaryCategoryId) ? A3($author$project$Conflicts$Resolver$Types$SaveNetwork, network, field, location) : $author$project$Conflicts$Resolver$Types$ConfirmSaveNetwork(
																			A3($author$project$Conflicts$Resolver$Types$SaveNetwork, network, field, location));
																	} else {
																		return A3($author$project$Conflicts$Resolver$Types$SaveNetwork, network, field, location);
																	}
																}();
																return $author$project$Conflicts$FieldEditor$FieldEditor$render(
																	A2(
																		$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
																		conf.isResolved,
																		A2(
																			$author$project$Conflicts$FieldEditor$FieldEditor$isWorking,
																			conf.isSaving && (!conf.isPublishing),
																			A2(
																				$author$project$Conflicts$FieldEditor$FieldEditor$isPublishing,
																				conf.isPublishing,
																				A2(
																					$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
																					conf.isSelected,
																					A2(
																						$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkUrl,
																						networkData.data.link,
																						A2(
																							$author$project$Conflicts$FieldEditor$FieldEditor$withNetworkName,
																							$author$project$Data$Network$toHumanReadable(network),
																							A3(
																								$author$project$Conflicts$FieldEditor$FieldEditor$when,
																								canUseThis,
																								$author$project$Conflicts$FieldEditor$FieldEditor$withCtaDataTestAttribute(
																									'cta.useThis.' + $author$project$Data$Network$toString(network)),
																								A3(
																									$author$project$Conflicts$FieldEditor$FieldEditor$when,
																									canUseThis,
																									$author$project$Conflicts$FieldEditor$FieldEditor$withCta(
																										{
																											msg: msg,
																											title: $author$project$Translations$General$resolverUseThis(translations)
																										}),
																									$author$project$Conflicts$FieldEditor$FieldEditor$view(
																										{
																											data: fieldDataRender,
																											title: A2($author$project$Data$Location$Field$toHumanReadable, field, translations)
																										}))))))))));
															});
														var fieldLocal = function () {
															var canUseThisForThisValue = function () {
																switch (field.$) {
																	case 'ProfileImage':
																		var network = field.a;
																		var previewUrl = A3(
																			$elm_community$maybe_extra$Maybe$Extra$unwrap,
																			'',
																			function (i) {
																				return i.previewUrl;
																			},
																			$elm_community$maybe_extra$Maybe$Extra$join(
																				A2(
																					$elm$core$Maybe$map,
																					function (x) {
																						return x.profileImage;
																					},
																					A2(
																						$elm$core$Maybe$map,
																						function (f) {
																							return f(location.networkMedia);
																						},
																						$author$project$Data$Location$networkImagesFromNetwork(network)))));
																		return (previewUrl === '') ? false : true;
																	case 'CoverImage':
																		var network = field.a;
																		var previewUrl = A3(
																			$elm_community$maybe_extra$Maybe$Extra$unwrap,
																			'',
																			function (i) {
																				return i.previewUrl;
																			},
																			$elm_community$maybe_extra$Maybe$Extra$join(
																				A2(
																					$elm$core$Maybe$map,
																					function (x) {
																						return x.coverImage;
																					},
																					A2(
																						$elm$core$Maybe$map,
																						function (f) {
																							return f(location.networkMedia);
																						},
																						$author$project$Data$Location$networkImagesFromNetwork(network)))));
																		return (previewUrl === '') ? false : true;
																	case 'CustomName':
																		var network = field.a;
																		return _Utils_eq(network, $author$project$Data$Network$Facebook) ? false : true;
																	default:
																		return true;
																}
															}();
															var editableFields = $elm$core$List$isEmpty(config.editableFields) ? $author$project$Data$Location$Field$allFields : config.editableFields;
															var imageCta = function (x) {
																if (x.$ === 'Just') {
																	return {
																		msg: A2($author$project$Conflicts$Resolver$Types$SaveLocal, field, location),
																		title: $author$project$Translations$General$resolverUseThis(translations)
																	};
																} else {
																	return {
																		msg: A2($author$project$Conflicts$Resolver$Types$EditLocal, field, location),
																		title: $author$project$Translations$General$upload(translations)
																	};
																}
															};
															var conf = {
																canEdit: A2($elm$core$List$member, field, editableFields),
																isSaving: A3($author$project$Conflicts$Resolver$ConflictStates$isSaving, field, location.id, conflictStates) || A3($author$project$Conflicts$Resolver$ConflictStates$isWorking, field, location.id, conflictStates),
																isEditing: A3($author$project$Conflicts$Resolver$ConflictStates$isEditing, field, location.id, conflictStates),
																isResolved: A3($author$project$Conflicts$Resolver$ConflictStates$isResolved, field, location.id, conflictStates),
																isSelected: _Utils_eq(field, $author$project$Data$Location$Field$Location) ? _Utils_eq(
																	selectedPinId,
																	$elm$core$Maybe$Just('pinmeto')) : A3($author$project$Conflicts$Resolver$ConflictStates$isSelectedLocal, field, location.id, conflictStates),
																isPublishing: A3($author$project$Conflicts$Resolver$ConflictStates$isSavingLocal, field, location.id, conflictStates) || A3($author$project$Conflicts$Resolver$ConflictStates$isWorkingLocal, field, location.id, conflictStates)
															};
															var editLocalOnClick = (conf.canEdit && ((!conf.isPublishing) && (!conf.isResolved))) ? $elm$html$Html$Events$onClick(
																A2($author$project$Conflicts$Resolver$Types$EditLocal, field, location)) : $elm$html$Html$Attributes$class('');
															var locationDetailEditor = F2(
																function (fieldToRender, editor) {
																	var editable = conf.canEdit && ((!conf.isPublishing) && (!conf.isResolved));
																	return A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				editable ? $elm$html$Html$Events$onClick(
																				A3($author$project$Conflicts$Resolver$Types$LocationDetailsEditorOpen, fieldToRender, editor, location)) : $elm$html$Html$Attributes$class('pmt-conflict-data pmt-conflict-data--local')
																			]),
																		_List_fromArray(
																			[
																				A8($author$project$Conflicts$Resolver$View$FieldData$view, config.timeZone, editable, meta, location, field, translations, now, networksWithFieldConflict)
																			]));
																});
															var fieldDataRender = function () {
																var editor = locationDetailEditor(field);
																_v3$21:
																while (true) {
																	switch (field.$) {
																		case 'Name':
																			return editor(
																				A2(
																					$author$project$Location$Details$Editor$StorefrontNameEditor,
																					$elm$core$Maybe$Nothing,
																					{
																						canEditName: true,
																						networkEnabled: {ptv: false, apple: false, google: false, facebook: false}
																					}));
																		case 'CustomName':
																			var network = field.a;
																			return editor(
																				$author$project$Location$Details$Editor$CustomNameOnNetworkEditor(network));
																		case 'StoreId':
																			return editor($author$project$Location$Details$Editor$StoreIdEditor);
																		case 'Location':
																			return editor($author$project$Location$Details$Editor$CoordinatesEditor);
																		case 'Hours':
																			return editor(
																				A2($author$project$Location$Details$Editor$OpenHoursEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'Email':
																			return editor(
																				A2($author$project$Location$Details$Editor$EmailEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'Homepage':
																			return editor(
																				A2($author$project$Location$Details$Editor$HomepageEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'NetworkCategories':
																			var network = field.a;
																			return editor(
																				A3($author$project$Location$Details$Editor$CategoriesEditor, network, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'Wifi':
																			return editor(
																				A2($author$project$Location$Details$Editor$WifiEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'About':
																			return editor(
																				A2($author$project$Location$Details$Editor$ShortDescriptionEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'LongDescription':
																			return editor(
																				A2($author$project$Location$Details$Editor$LongDescriptionEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'OpeningDate':
																			return editor($author$project$Location$Details$Editor$OpeningDateEditor);
																		case 'Phone':
																			return editor(
																				A2($author$project$Location$Details$Editor$PhoneEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'TemporarilyClosedUntil':
																			return editor(
																				A2($author$project$Location$Details$Editor$TemporarilyClosedEditor, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'PermanentlyClosed':
																			return editor($author$project$Location$Details$Editor$PermanentlyClosedEditor);
																		case 'LocationDescriptor':
																			return editor($author$project$Location$Details$Editor$LocationDescriptorEditor);
																		case 'SpecialHours':
																			return editor(
																				A3($author$project$Location$Details$Editor$SpecialOpenHoursEditor, $author$project$Location$Details$PopupContent$SpecialOpenHours$Other, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		case 'Address':
																			return editor($author$project$Location$Details$Editor$AddressEditor);
																		case 'NetworkAttributes':
																			if (field.a.$ === 'Google') {
																				var _v4 = field.a;
																				return editor(
																					A3($author$project$Location$Details$Editor$GoogleAttributesEditor, meta.googleAttributes.attributes, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																			} else {
																				break _v3$21;
																			}
																		case 'ActionLinks':
																			return editor($author$project$Location$Details$Editor$ActionLinksEditor);
																		case 'NetworkServiceItems':
																			var network = field.a;
																			return editor(
																				A3($author$project$Location$Details$Editor$ServiceItemsEditor, network, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
																		default:
																			break _v3$21;
																	}
																}
																return A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[editLocalOnClick]),
																	_List_fromArray(
																		[
																			A8($author$project$Conflicts$Resolver$View$FieldData$view, config.timeZone, conf.canEdit && ((!conf.isPublishing) && (!conf.isResolved)), meta, location, field, translations, now, networksWithFieldConflict)
																		]));
															}();
															var cta = function () {
																switch (field.$) {
																	case 'ProfileImage':
																		var network = field.a;
																		return imageCta(
																			A2(
																				$elm$core$Maybe$map,
																				function (x) {
																					return x.profileImage;
																				},
																				A2(
																					$elm$core$Maybe$map,
																					function (f) {
																						return f(location.networkMedia);
																					},
																					$author$project$Data$Location$networkImagesFromNetwork(network))));
																	case 'CoverImage':
																		var network = field.a;
																		return imageCta(
																			A2(
																				$elm$core$Maybe$map,
																				function (x) {
																					return x.coverImage;
																				},
																				A2(
																					$elm$core$Maybe$map,
																					function (f) {
																						return f(location.networkMedia);
																					},
																					$author$project$Data$Location$networkImagesFromNetwork(network))));
																	default:
																		return {
																			msg: A2($author$project$Conflicts$Resolver$Types$SaveLocal, field, location),
																			title: $author$project$Translations$General$resolverUseThis(translations)
																		};
																}
															}();
															return $author$project$Conflicts$FieldEditor$FieldEditor$render(
																A2(
																	$author$project$Conflicts$FieldEditor$FieldEditor$isResolved,
																	conf.isResolved,
																	A2(
																		$author$project$Conflicts$FieldEditor$FieldEditor$isWorking,
																		conf.isSaving && (!conf.isPublishing),
																		A2(
																			$author$project$Conflicts$FieldEditor$FieldEditor$isPublishing,
																			conf.isPublishing,
																			A2(
																				$author$project$Conflicts$FieldEditor$FieldEditor$isSelected,
																				conf.isSelected || conf.isEditing,
																				A2(
																					$author$project$Conflicts$FieldEditor$FieldEditor$withCtaDataTestAttribute,
																					'cta.useThis.Masterdata',
																					(((alertMessage !== '') && _Utils_eq(field, disabledField)) ? $author$project$Conflicts$FieldEditor$FieldEditor$withAlert(alertMessage) : $elm$core$Basics$identity)(
																						A2(
																							$author$project$Conflicts$FieldEditor$FieldEditor$withCtaDisabled,
																							isCtaDisabled && _Utils_eq(field, disabledField),
																							A3(
																								$author$project$Conflicts$FieldEditor$FieldEditor$when,
																								canUseThisForThisValue,
																								$author$project$Conflicts$FieldEditor$FieldEditor$withCta(cta),
																								$author$project$Conflicts$FieldEditor$FieldEditor$view(
																									{
																										data: fieldDataRender,
																										title: A2($author$project$Data$Location$Field$toHumanReadableWithNetwork, field, translations)
																									}))))))))));
														}();
														var notes = hasStorefrontLocationServiceAreasConflict ? A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('note')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Translations$Listings$Conflicts$storeFrontWithServiceAreaConflict(translations))
																])) : $elm$html$Html$text('');
														return A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-conflict-resolver__field pmt-conflict-resolver__img'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2(
																			'pmt-conflict-resolver__field--resolved',
																			A3($author$project$Conflicts$Resolver$ConflictStates$isResolved, field, location.id, conflictStates))
																		]))
																]),
															_List_fromArray(
																[
																	specificFieldNote,
																	notes,
																	function () {
																	var _v0 = A3($author$project$Conflicts$Resolver$ConflictStates$errorMessage, field, location.id, conflictStates);
																	if (_v0.$ === 'Just') {
																		var error = _v0.a;
																		var locationUrl = '/listings/' + ($author$project$Data$SiteName$toString(siteNameParam) + ('/locations/' + location.id));
																		return A3($author$project$Conflicts$Resolver$View$FieldConflicts$errorMessages, error, locationUrl, translations);
																	} else {
																		return $elm$html$Html$text('');
																	}
																}(),
																	_Utils_eq(field, $author$project$Data$Location$Field$Location) ? A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			A2($elm$html$Html$Attributes$style, 'margin', '1rem')
																		]),
																	_List_fromArray(
																		[
																			A4(
																			$author$project$Conflicts$Resolver$View$FieldConflicts$pmtUiMap,
																			selectedPinId,
																			A2(
																				$elm$core$Maybe$withDefault,
																				location,
																				A3($author$project$Conflicts$Resolver$ConflictStates$isResolvedWithLocation, field, location.id, conflictStates)),
																			A3($author$project$Conflicts$Resolver$ConflictStates$isResolved, field, location.id, conflictStates),
																			translations)
																		])) : $elm$html$Html$text(''),
																	A2(
																	$author$project$PinMeTo$Ui$Layout$Grid$render,
																	$author$project$PinMeTo$Ui$Layout$Grid$flex,
																	A2(
																		$elm$core$List$filterMap,
																		$elm$core$Basics$identity,
																		A2(
																			$elm$core$List$cons,
																			$elm$core$Maybe$Just(fieldLocal),
																			A2(
																				$elm$core$List$map,
																				function (_v1) {
																					var network = _v1.a;
																					var data = _v1.b;
																					return A2(
																						$elm$core$Maybe$map,
																						fieldNetworkData(network),
																						data);
																				},
																				A2(
																					$elm$core$List$map,
																					function (network) {
																						return _Utils_Tuple2(
																							network,
																							A2($author$project$Data$Location$networkDataFromNetwork, location, network));
																					},
																					networksWithFieldConflict)))))
																]));
													} else {
														return $elm$html$Html$text('');
													}
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Translations$Listings$Conflicts$couldNotFetch = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.could_not_fetch');
};
var $author$project$Translations$Listings$Conflicts$noConflictsToHandle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.no_conflicts_to_handle');
};
var $author$project$Translations$Listings$Conflicts$neitherOptionCorrect = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.neither_option_correct');
};
var $author$project$Conflicts$Resolver$Types$LocationDetailsEditorClose = {$: 'LocationDetailsEditorClose'};
var $author$project$Translations$Listings$Conflicts$facebookGeoCoordinateConflictMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.facebook_geo_coordinate_conflict_message');
};
var $author$project$Conflicts$Resolver$View$locationConflicts = F3(
	function (config, model, location) {
		var selectedPinId = model.selectedPinId;
		var account = model.account;
		var translations = model.translations;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section section--solid')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('util__inset')
								]),
							_List_fromArray(
								[
									function () {
									switch (location.$) {
										case 'Loaded':
											var data = location.a;
											var hasFacebookGeoDiff = A3(
												$author$project$Data$Location$hasConflictInFieldsInNetwork,
												_List_fromArray(
													[$author$project$Data$Location$Field$Location]),
												data,
												$author$project$Data$Network$Facebook);
											var hasOtherGeoDiffs = A2(
												$elm$core$List$member,
												true,
												A2(
													$elm$core$List$map,
													function (network) {
														return (!_Utils_eq(network, $author$project$Data$Network$Facebook)) && A3(
															$author$project$Data$Location$hasConflictInFieldsInNetwork,
															_List_fromArray(
																[$author$project$Data$Location$Field$Location]),
															data,
															network);
													},
													account.networks));
											var isDisabledGeoDiff = hasFacebookGeoDiff && (!hasOtherGeoDiffs);
											var fields = $elm$core$List$isEmpty(model.fields) ? $author$project$Data$Location$Field$allFields : model.fields;
											var hasConflicts = A2($author$project$Data$Location$hasConflictInFields, fields, data) || A2(
												$elm$core$List$member,
												true,
												A2(
													$elm$core$List$map,
													function (network) {
														return A3($author$project$Data$Location$hasConflictInFieldsInNetwork, fields, data, network);
													},
													account.networks));
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														A2(
															$elm$core$List$map,
															$author$project$Conflicts$Resolver$View$FieldConflicts$view(isDisabledGeoDiff)($author$project$Data$Location$Field$Location)(
																hasFacebookGeoDiff ? $author$project$Translations$Listings$Conflicts$facebookGeoCoordinateConflictMessage(translations) : '')(selectedPinId)(config)(model.meta)(account.networks)(model.conflictStates)(data)(translations)(model.time)(model.account.name),
															fields)),
														A2(
														$elm$core$Maybe$withDefault,
														$elm$html$Html$text(''),
														A2(
															$elm$core$Maybe$map,
															function (_v1) {
																var editor = _v1.b;
																return A4(
																	$author$project$Location$Details$Editor$view,
																	{
																		tagger: $author$project$Conflicts$Resolver$Types$LocationDetailsEditorMsg(data.id),
																		onCancel: $author$project$Conflicts$Resolver$Types$LocationDetailsEditorClose,
																		onSubmit: $author$project$Conflicts$Resolver$Types$LocationDetailsEditorClose,
																		withScheduling: false
																	},
																	{user: $author$project$Data$User$emptyUser, locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, language: $author$project$PinMeTo$Ui$I18n$Language$En, translations: translations},
																	$elm$core$Maybe$Nothing,
																	editor);
															},
															model.editor)),
														A2(
														$elm$core$Maybe$withDefault,
														$elm$html$Html$text(''),
														A2(
															$elm$core$Maybe$map,
															function (open) {
																return A2(
																	$elm$html$Html$map,
																	$author$project$Conflicts$Resolver$Types$ImageEditorMsg,
																	A2(
																		$author$project$Location$ImageEditor$view,
																		{locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, language: $author$project$PinMeTo$Ui$I18n$Language$En, translations: translations},
																		open.editor));
															},
															model.imageEditor)),
														hasConflicts ? A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('note')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Translations$Listings$Conflicts$neitherOptionCorrect(translations))
															])) : $elm$html$Html$text(
														$author$project$Translations$Listings$Conflicts$noConflictsToHandle(translations))
													]));
										case 'Loading':
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('spinner')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$i,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('spinner__symbol')
															]),
														_List_Nil)
													]));
										case 'Error':
											return $author$project$PinMeTo$Ui$Alert$render(
												A2(
													$author$project$PinMeTo$Ui$Alert$withStatus,
													$author$project$PinMeTo$Ui$Alert$Error,
													$author$project$PinMeTo$Ui$Alert$plain(
														$author$project$Translations$Listings$Conflicts$couldNotFetch(translations))));
										default:
											return $elm$html$Html$text(
												$author$project$Translations$Listings$Conflicts$noConflictsToHandle(translations));
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$Conflicts$locationConflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.location_conflicts');
};
var $author$project$Translations$Listings$Conflicts$changePrimaryCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.change_primary_category');
};
var $author$project$Conflicts$ListingsManagerSetup$helpUrl = 'https://help.pinmeto.com/en/article/places-ai-1br05c0/#2-listings-manager';
var $author$project$Common$Metrics$prefix = F2(
	function (feature, event) {
		return 'Listings - ' + (feature + (' - ' + event));
	});
var $author$project$Common$Metrics$clickEvent = F2(
	function (feature, event) {
		return $author$project$PinMeTo$Ui$Metrics$clickEvent(
			A2($author$project$Common$Metrics$prefix, feature, event));
	});
var $author$project$Conflicts$ListingsManagerSetup$originToFeature = function (origin) {
	switch (origin.$) {
		case 'Dashboard':
			return 'Dashboard';
		case 'Conflicts':
			return 'Conflicts';
		default:
			return 'Location Conflicts';
	}
};
var $author$project$PinMeTo$Ui$Button$withMetricsEvent = F2(
	function (event, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Button$Config(
			_Utils_update(
				config,
				{
					metricsEvent: $elm$core$Maybe$Just(event)
				}));
	});
var $author$project$Translations$Listings$Tasks$listingsManagerSetupCta = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.listings_manager_setup_cta');
};
var $author$project$Conflicts$ListingsManagerSetup$setupCta = F3(
	function (origin, _v0, translations) {
		var siteName = _v0.a;
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withMetricsEvent,
				A2(
					$author$project$Common$Metrics$clickEvent,
					$author$project$Conflicts$ListingsManagerSetup$originToFeature(origin),
					'Listings Manager setup'),
				A2(
					$author$project$PinMeTo$Ui$Button$withSize,
					$author$project$PinMeTo$Ui$Button$Small,
					A2(
						$author$project$PinMeTo$Ui$Button$withHref,
						'/overview/portfolio/' + (siteName + '/listings-manager'),
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$Listings$Tasks$listingsManagerSetupCta(translations))))));
	});
var $author$project$Translations$General$TopNavigation$ProductInfo$learnMore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.learn_more');
};
var $author$project$Translations$Listings$Tasks$listingsManagerSetupBody = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.listings_manager_setup_body');
};
var $author$project$Translations$Listings$Tasks$listingsManagerSetupTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.listings_manager_setup_title');
};
var $author$project$Conflicts$ListingsManagerSetup$setup = F4(
	function (origin, isStandalone, siteName, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-listings-manager-setup', true),
							_Utils_Tuple2('pmt-listings-manager-setup--standalone', isStandalone)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-listings-manager-setup__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Tasks$listingsManagerSetupTitle(translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-listings-manager-setup__body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Tasks$listingsManagerSetupBody(translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-listings-manager-setup__actions')
						]),
					_List_fromArray(
						[
							A3($author$project$Conflicts$ListingsManagerSetup$setupCta, origin, siteName, translations),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-listings-manager-setup__learn-more'),
									$elm$html$Html$Attributes$href($author$project$Conflicts$ListingsManagerSetup$helpUrl),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$rel('noopener noreferrer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$TopNavigation$ProductInfo$learnMore(translations))
								]))
						]))
				]));
	});
var $author$project$Conflicts$ListingsManagerSetup$isHidden = function (policiesEnabled) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		$author$project$RemoteData$currentData(policiesEnabled));
};
var $author$project$Conflicts$ListingsManagerSetup$LocationConflicts = {$: 'LocationConflicts'};
var $author$project$Conflicts$ListingsManagerSetup$inset = F3(
	function (siteName, policiesEnabled, translations) {
		return $author$project$Conflicts$ListingsManagerSetup$isHidden(policiesEnabled) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset pmt-listings-manager-setup-wrapper')
				]),
			_List_fromArray(
				[
					A4($author$project$Conflicts$ListingsManagerSetup$setup, $author$project$Conflicts$ListingsManagerSetup$LocationConflicts, true, siteName, translations)
				]));
	});
var $author$project$Conflicts$Resolver$View$locationConflictsView = function (model) {
	var wrapper = F2(
		function (locationUrl, content) {
			var lightboxContent = function (msg_) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '2em')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Conflicts$changingCategory(model.translations))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '2em'),
									A2($elm$html$Html$Attributes$style, 'float', 'right')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$PinMeTo$Ui$Btn$pmtBtn,
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('siteBtn siteSync-Btn'),
											A2($elm$html$Html$Attributes$style, 'marginRight', '1em'),
											$elm$html$Html$Events$onClick(msg_)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$ok(model.translations))
										])),
									A3(
									$author$project$PinMeTo$Ui$Btn$pmtBtn,
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('siteBtn siteSync-Btn'),
											$elm$html$Html$Events$onClick($author$project$Conflicts$Resolver$Types$CloseConfirm)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$cancel(model.translations))
										]))
								]))
						]));
			};
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_fromArray(
						[
							A3($author$project$Conflicts$ListingsManagerSetup$inset, model.account.name, model.listingsManagerPoliciesEnabled, model.translations),
							content,
							function () {
							var _v2 = model.alertBox;
							if (_v2.$ === 'Just') {
								var msg_ = _v2.a.a;
								return A2(
									$author$project$PinMeTo$Deprecated$Lightbox$render,
									$author$project$PinMeTo$Deprecated$Lightbox$alertStyle(model.uiLightbox),
									$author$project$PinMeTo$Deprecated$Lightbox$view(
										{
											title: $author$project$Translations$Listings$Conflicts$changePrimaryCategory(model.translations),
											tagger: $author$project$Conflicts$Resolver$Types$UiLightboxMsg,
											content: lightboxContent(msg_)
										}));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]),
					function (errorMessage) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h1-page-title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Conflicts$locationConflicts(model.translations))
									])),
								A3($author$project$Conflicts$Resolver$View$errorBanner, errorMessage, locationUrl, model.translations)
							]);
					},
					model.errorMessage));
		});
	var _v0 = model.summaries;
	if (_v0.$ === 'Just') {
		var summaries = _v0.a;
		var _v1 = A2($elm$core$Array$get, model.pagination.currentPage, summaries);
		if (_v1.$ === 'Just') {
			var summary = _v1.a;
			var url = '/listings/' + ($author$project$Data$SiteName$toString(model.account.name) + ('/locations/' + summary.id));
			return A2(
				wrapper,
				url,
				A3(
					$author$project$Conflicts$Resolver$View$locationConflicts,
					model.config,
					model,
					A2($author$project$Common$Pagination$remoteDataWithId, summary.id, model.pagination)));
		} else {
			return A2(
				wrapper,
				'',
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$noConflictsToHandle(model.translations))
						])));
		}
	} else {
		return A2(
			wrapper,
			'',
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('spinner')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spinner__symbol')
							]),
						_List_Nil)
					])));
	}
};
var $author$project$Conflicts$Resolver$View$view = function (model) {
	if ($elm$core$List$isEmpty(model.fields)) {
		return $author$project$Conflicts$Resolver$View$locationConflictsView(model);
	} else {
		var wrapper = F4(
			function (textIfNoSummary, summary, withPagination, content) {
				var lightboxContent = function (msg_) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'padding', '2em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Conflicts$changingCategory(model.translations))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'padding', '2em'),
										A2($elm$html$Html$Attributes$style, 'float', 'right')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$PinMeTo$Ui$Btn$pmtBtn,
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$class('siteBtn siteSync-Btn'),
												A2($elm$html$Html$Attributes$style, 'marginRight', '1em'),
												$elm$html$Html$Events$onClick(msg_)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$ok(model.translations))
											])),
										A3(
										$author$project$PinMeTo$Ui$Btn$pmtBtn,
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Attributes$class('siteBtn siteSync-Btn'),
												$elm$html$Html$Events$onClick($author$project$Conflicts$Resolver$Types$CloseConfirm)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$cancel(model.translations))
											]))
									]))
							]));
				};
				var _v2 = function () {
					if (summary.$ === 'Just') {
						var sum = summary.a;
						var url = model.config.locationUrl(sum.id);
						return _Utils_Tuple2(
							A3($author$project$Conflicts$Resolver$View$titleToHtml, url, sum, model.translations),
							url);
					} else {
						return _Utils_Tuple2(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h6,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(textIfNoSummary)
											]))
									])),
							'');
					}
				}();
				var title = _v2.a;
				var locationUrl = _v2.b;
				var goToConflicts = $author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withIconBefore,
						$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faArrowLeft),
						A2(
							$author$project$PinMeTo$Ui$Button$withHref,
							'/listings/' + ($author$project$Data$SiteName$toString(model.account.name) + '/conflicts'),
							$author$project$PinMeTo$Ui$Button$buttonGhost(
								$author$project$Translations$Listings$Conflicts$backToConflicts(model.translations)))));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section pmt-conflict-resolver')
						]),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('h1-page-title')
									]),
								_List_fromArray(
									[goToConflicts])),
								A2(
								$elm$html$Html$header,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('util__stick-to-header')
									]),
								_List_fromArray(
									[
										withPagination ? $author$project$PinMeTo$Ui$TitleBar$render(
										A2(
											$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
											true,
											A2(
												$author$project$PinMeTo$Ui$TitleBar$withAsides,
												_List_fromArray(
													[
														A5(
														$author$project$Common$Pagination$view,
														model.pagination,
														$author$project$Conflicts$Resolver$Types$OnPageChange,
														$author$project$Conflicts$Resolver$Types$OnPageInputChange,
														$author$project$Conflicts$Resolver$Types$OnPageInputSubmit,
														{
															of_: $author$project$Translations$General$ofPreposition(model.translations)
														})
													]),
												$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(title)))) : $author$project$PinMeTo$Ui$TitleBar$render(
										$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(title))
									])),
								content,
								function () {
								var _v4 = model.alertBox;
								if (_v4.$ === 'Just') {
									var msg_ = _v4.a.a;
									return A2(
										$author$project$PinMeTo$Deprecated$Lightbox$render,
										$author$project$PinMeTo$Deprecated$Lightbox$alertStyle(model.uiLightbox),
										$author$project$PinMeTo$Deprecated$Lightbox$view(
											{
												title: $author$project$Translations$Listings$Conflicts$changePrimaryCategory(model.translations),
												tagger: $author$project$Conflicts$Resolver$Types$UiLightboxMsg,
												content: lightboxContent(msg_)
											}));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							]),
						function (errorMessage) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('h1-page-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Conflicts$locationConflicts(model.translations))
										])),
									A3($author$project$Conflicts$Resolver$View$errorBanner, errorMessage, locationUrl, model.translations)
								]);
						},
						model.errorMessage));
			});
		var _v0 = model.summaries;
		if (_v0.$ === 'Just') {
			var summaries = _v0.a;
			var _v1 = A2($elm$core$Array$get, model.pagination.currentPage, summaries);
			if (_v1.$ === 'Just') {
				var summary = _v1.a;
				return A4(
					wrapper,
					'',
					$elm$core$Maybe$Just(summary),
					true,
					A3(
						$author$project$Conflicts$Resolver$View$locationConflicts,
						model.config,
						model,
						A2($author$project$Common$Pagination$remoteDataWithId, summary.id, model.pagination)));
			} else {
				return A4(
					wrapper,
					$author$project$Translations$Listings$Conflicts$noLocation(model.translations),
					$elm$core$Maybe$Nothing,
					false,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Conflicts$noConflictsToHandle(model.translations))
							])));
			}
		} else {
			return A4(
				wrapper,
				$author$project$Translations$General$loading(model.translations) + '...',
				$elm$core$Maybe$Nothing,
				false,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('spinner')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spinner__symbol')
								]),
							_List_Nil)
						])));
		}
	}
};
var $author$project$Conflicts$Resolver$Types$ResetState = function (a) {
	return {$: 'ResetState', a: a};
};
var $author$project$Conflicts$Resolver$Types$WorkFailed = function (a) {
	return {$: 'WorkFailed', a: a};
};
var $author$project$Conflicts$Resolver$Types$KeyboardMsg = function (a) {
	return {$: 'KeyboardMsg', a: a};
};
var $author$project$Conflicts$Resolver$Types$EditorClosed = function (a) {
	return {$: 'EditorClosed', a: a};
};
var $author$project$Conflicts$Resolver$Types$EditorUpdated = function (a) {
	return {$: 'EditorUpdated', a: a};
};
var $author$project$Conflicts$Resolver$Types$WorkSucceeded = function (a) {
	return {$: 'WorkSucceeded', a: a};
};
var $author$project$Conflicts$Resolver$Types$SaveDataInField = function (a) {
	return {$: 'SaveDataInField', a: a};
};
var $author$project$Conflicts$Resolver$Types$UpdateDataInField = function (a) {
	return {$: 'UpdateDataInField', a: a};
};
var $author$project$Conflicts$Resolver$Types$SetDataInFieldSelected = function (a) {
	return {$: 'SetDataInFieldSelected', a: a};
};
var $author$project$Conflicts$Resolver$Main$passArgs_Conflicts_Resolver_Main = _Platform_incomingPort('passArgs_Conflicts_Resolver_Main', $elm$json$Json$Decode$value);
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_workFailed = _Platform_incomingPort('in_Conflicts_Resolver_Main_workFailed', $elm$json$Json$Decode$string);
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_editorClosed = _Platform_incomingPort('in_Conflicts_Resolver_Main_editorClosed', $elm$json$Json$Decode$value);
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_editorUpdated = _Platform_incomingPort('in_Conflicts_Resolver_Main_editorUpdated', $elm$json$Json$Decode$value);
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_workSucceeded = _Platform_incomingPort('in_Conflicts_Resolver_Main_workSucceeded', $elm$json$Json$Decode$string);
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_onImageCaptured = _Platform_incomingPort('in_Conflicts_Resolver_Main_onImageCaptured', $elm$json$Json$Decode$value);
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_saveDataInField = _Platform_incomingPort(
	'in_Conflicts_Resolver_Main_saveDataInField',
	A2(
		$elm$json$Json$Decode$andThen,
		function (locationId) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (network) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (field) {
							return $elm$json$Json$Decode$succeed(
								{field: field, network: network, locationId: locationId});
						},
						A2($elm$json$Json$Decode$field, 'field', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'network', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'locationId', $elm$json$Json$Decode$string)));
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_updateDataInField = _Platform_incomingPort(
	'in_Conflicts_Resolver_Main_updateDataInField',
	A2(
		$elm$json$Json$Decode$andThen,
		function (locationId) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (field) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (data) {
							return $elm$json$Json$Decode$succeed(
								{data: data, field: field, locationId: locationId});
						},
						A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'field', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'locationId', $elm$json$Json$Decode$string)));
var $author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_setDataInFieldSelected = _Platform_incomingPort(
	'in_Conflicts_Resolver_Main_setDataInFieldSelected',
	A2(
		$elm$json$Json$Decode$andThen,
		function (locationId) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (selected) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (network) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (field) {
									return $elm$json$Json$Decode$succeed(
										{field: field, network: network, selected: selected, locationId: locationId});
								},
								A2($elm$json$Json$Decode$field, 'field', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'network', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'selected', $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$field, 'locationId', $elm$json$Json$Decode$string)));
var $author$project$Conflicts$Resolver$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Conflicts$Resolver$Main$passArgs_Conflicts_Resolver_Main($author$project$Conflicts$Resolver$Types$HandleFlags),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_editorClosed($author$project$Conflicts$Resolver$Types$EditorClosed),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_editorUpdated($author$project$Conflicts$Resolver$Types$EditorUpdated),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_workSucceeded($author$project$Conflicts$Resolver$Types$WorkSucceeded),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_workFailed($author$project$Conflicts$Resolver$Types$WorkFailed),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_setDataInFieldSelected($author$project$Conflicts$Resolver$Types$SetDataInFieldSelected),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_saveDataInField($author$project$Conflicts$Resolver$Types$SaveDataInField),
				$author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_updateDataInField($author$project$Conflicts$Resolver$Types$UpdateDataInField),
				A2($elm$core$Platform$Sub$map, $author$project$Conflicts$Resolver$Types$KeyboardMsg, $ohanhi$keyboard$Keyboard$subscriptions),
				$author$project$Common$PollPortModule$disableSubscriptions($author$project$Conflicts$Resolver$Types$ResetState),
				function () {
				var _v0 = model.imageEditor;
				if (_v0.$ === 'Just') {
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Conflicts$Resolver$Types$ImageEditorMsg,
						$author$project$Location$ImageEditor$subscriptions($author$project$Conflicts$Resolver$Main$in_Conflicts_Resolver_Main_onImageCaptured));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Conflicts$Resolver$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Conflicts$Resolver$Main$init, view: $author$project$Conflicts$Resolver$View$view, update: $author$project$Conflicts$Resolver$Update$update, subscriptions: $author$project$Conflicts$Resolver$Main$subscriptions});
var $author$project$Tasks$Apple$Claim$Model$Idle = {$: 'Idle'};
var $author$project$Insights$Apple$Model$OAUTH = {$: 'OAUTH'};
var $author$project$Tasks$Apple$Claim$Model$Available = {$: 'Available'};
var $author$project$Tasks$Apple$Claim$Model$GetBusinesses = function (a) {
	return {$: 'GetBusinesses', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$GotSyncStatus = function (a) {
	return {$: 'GotSyncStatus', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$Business = F4(
	function (companyId, name, countryCodes, businessId) {
		return {name: name, companyId: companyId, businessId: businessId, countryCodes: countryCodes};
	});
var $author$project$Tasks$Apple$Claim$Commands$businessDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'businessId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'countryCodes',
		A2(
			$elm$json$Json$Decode$andThen,
			function (countryCodes) {
				if (!countryCodes.b) {
					return $elm$json$Json$Decode$fail('No country codes found');
				} else {
					return $elm$json$Json$Decode$succeed(countryCodes);
				}
			},
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'companyId',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Tasks$Apple$Claim$Model$Business)))));
var $author$project$Tasks$Apple$Claim$Commands$getBusinesses = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/businesses');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$businessDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Claim$Model$SyncStatusResult = F3(
	function (running, startedAt, itemCount) {
		return {running: running, itemCount: itemCount, startedAt: startedAt};
	});
var $author$project$Tasks$Apple$Claim$Commands$syncStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'itemCount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'startedAt',
		$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'running',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Tasks$Apple$Claim$Model$SyncStatusResult))));
var $author$project$Tasks$Apple$Claim$Commands$getSyncStatus = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/syncStatus');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Apple$Claim$Commands$syncStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Apple$Claim$Commands$getAllAppleCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/categories');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated = function (a) {
	return {$: 'GetLocationsToBeCreated', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$ReadyToCreate = {$: 'ReadyToCreate'};
var $author$project$Tasks$Apple$Claim$Model$FailedToCreate = function (a) {
	return {$: 'FailedToCreate', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$LocationData = F9(
	function (id, storeId, name, address, location, locationDescriptor, locationType, isActive, permanentlyClosed) {
		return {id: id, name: name, address: address, storeId: storeId, isActive: isActive, location: location, locationType: locationType, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor};
	});
var $author$project$Tasks$Apple$Claim$Commands$locationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'permanentlyClosed',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isActive',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Data$Location$locationTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'locationDescriptor',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'location',
					$author$project$Data$Coordinates$coordinatesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'address',
						$author$project$Data$Address$addressDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'storeId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'_id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Tasks$Apple$Claim$Model$LocationData))))))))));
var $author$project$Tasks$Apple$Claim$Model$LocationToCreate = F5(
	function (location, errors, lastClaimAttempt, selectedBusiness, state) {
		return {state: state, errors: errors, location: location, lastClaimAttempt: lastClaimAttempt, selectedBusiness: selectedBusiness};
	});
var $author$project$Tasks$Apple$Claim$Commands$locationToCreateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (maybeErrors) {
		var errors = A2($elm$core$Maybe$withDefault, _List_Nil, maybeErrors);
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$elm$core$List$isEmpty(errors) ? $author$project$Tasks$Apple$Claim$Model$ReadyToCreate : $author$project$Tasks$Apple$Claim$Model$FailedToCreate(
				A2($elm$core$String$join, ', ', errors)),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'lastClaimAttempt',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						maybeErrors,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'location',
							$author$project$Tasks$Apple$Claim$Commands$locationDecoder,
							$elm$json$Json$Decode$succeed($author$project$Tasks$Apple$Claim$Model$LocationToCreate))))));
	},
	A2(
		$elm$json$Json$Decode$field,
		'errors',
		$elm$json$Json$Decode$nullable(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Tasks$Apple$Claim$Commands$getLocationsToBeCreated = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/locationsToCreate');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$locationToCreateDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations = function (a) {
	return {$: 'GetAppleNotMatchedLocations', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$AppleNotMatchedLocationData = F6(
	function (id, storeId, name, address, location, link) {
		return {id: id, link: link, name: name, address: address, storeId: storeId, location: location};
	});
var $author$project$Tasks$Apple$Claim$Commands$appleNotMatchedlocationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'placeCardUrl',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'location',
		$author$project$Data$Coordinates$coordinatesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$author$project$Data$Address$addressDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'storeCode',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Tasks$Apple$Claim$Model$AppleNotMatchedLocationData)))))));
var $author$project$Tasks$Apple$Claim$Commands$getAppleNotMatchedLocations = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/notMatchedLocationsFromApple');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$appleNotMatchedlocationDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Claim$Commands$getNonOauthLocationsToBeCreated = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/nonOauthLocationsToCreate');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$locationToCreateDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Claim$Main$init = F2(
	function (session, flags) {
		var getLocationsToCreateCmd = _Utils_eq(flags.appleConnectionType, $author$project$Insights$Apple$Model$OAUTH) ? A2($author$project$Tasks$Apple$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated) : A2($author$project$Tasks$Apple$Claim$Commands$getNonOauthLocationsToBeCreated, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated);
		var getSyncStatusCmd = _Utils_eq(flags.appleConnectionType, $author$project$Insights$Apple$Model$OAUTH) ? A2($author$project$Tasks$Apple$Claim$Commands$getSyncStatus, session.siteName, $author$project$Tasks$Apple$Claim$Model$GotSyncStatus) : $elm$core$Platform$Cmd$none;
		var isDev = A2($author$project$Data$User$hasRole, session.user, $author$project$Data$User$PinMeToDeveloper);
		return _Utils_Tuple2(
			{isDev: isDev, filter: '', syncNow: $elm$core$Maybe$Nothing, uiTable: $author$project$PinMeTo$Ui$Table$init, uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, businesses: $author$project$RemoteData$Loading, syncStatus: $author$project$Tasks$Apple$Claim$Model$Idle, allCategories: $author$project$RemoteData$Loading, syncStartedAt: $elm$core$Maybe$Nothing, primaryCategory: flags.categories.primaryCategory, suggestedMatches: $elm$core$Set$empty, createLocationsTab: $author$project$Tasks$Apple$Claim$Model$Available, appleConnectionType: flags.appleConnectionType, selectedPMTLocation: $elm$core$Maybe$Nothing, locationsToBeCreated: $author$project$RemoteData$Loading, syncLocationsLastRun: flags.syncLocationsLastRun, matchLocationPMTTable: $author$project$PinMeTo$Ui$Table$init, categoriesNotification: $elm$core$Maybe$Nothing, syncEstimatedItemCount: 0, selectedNetworkLocation: $elm$core$Maybe$Nothing, additionalCategoriesList: flags.categories.additionalCategories, appleNotMatchedLocations: $author$project$RemoteData$Loading, matchLocationNetworkTable: $author$project$PinMeTo$Ui$Table$init, createLocationsNotification: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Apple$Claim$Commands$getAllAppleCategories, session.siteName, $author$project$Tasks$Apple$Claim$Model$GotAllCategories),
						getLocationsToCreateCmd,
						getSyncStatusCmd,
						A2($author$project$Tasks$Apple$Claim$Commands$getBusinesses, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetBusinesses),
						A2($author$project$Tasks$Apple$Claim$Commands$getAppleNotMatchedLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations)
					])));
	});
var $author$project$Tasks$Apple$Claim$Model$Running = {$: 'Running'};
var $author$project$Tasks$Apple$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Tasks$Apple$Claim$View$assumedMsPerLocation = 150;
var $author$project$Tasks$Apple$Claim$View$estimatedSyncPercentage = function (model) {
	var _v0 = _Utils_Tuple2(model.syncStartedAt, model.syncNow);
	if ((_v0.a.$ === 'Just') && (_v0.b.$ === 'Just')) {
		var startedAt = _v0.a.a;
		var now = _v0.b.a;
		var estimatedMs = A2($elm$core$Basics$max, 1, model.syncEstimatedItemCount) * $author$project$Tasks$Apple$Claim$View$assumedMsPerLocation;
		var elapsedMs = $elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(startedAt);
		return (99 * elapsedMs) / (elapsedMs + estimatedMs);
	} else {
		return 0;
	}
};
var $author$project$Translations$Listings$Claim$syncLocationsSyncTimeNoteApple = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.sync_locations_sync_time_note_apple');
};
var $author$project$Tasks$Apple$Claim$View$renderSyncProgress = F2(
	function (session, model) {
		var startedAtTime = function () {
			var _v0 = model.syncStartedAt;
			if (_v0.$ === 'Just') {
				var time = _v0.a;
				return $author$project$PinMeTo$Ui$Date$render(
					A2(
						$author$project$PinMeTo$Ui$Date$withFormat,
						$author$project$PinMeTo$Ui$Date$FormatTime,
						A2($author$project$PinMeTo$Ui$Date$posix, session.locale, time)));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-progress')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__sync-progress__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$strong,
									_List_Nil,
									A3($author$project$Translations$Listings$Claim$syncLocationsRunningSinceCustom, session.translations, $elm$html$Html$text, startedAtTime)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' ' + $author$project$Translations$Listings$Claim$syncLocationsSyncTimeNoteApple(session.translations))
									]))),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Claim$syncLocationsInProgressActions(session.translations))
								])),
							$author$project$PinMeTo$Ui$ProgressBar$render(
							A2(
								$author$project$PinMeTo$Ui$ProgressBar$withLabel,
								true,
								$author$project$PinMeTo$Ui$ProgressBar$view(
									$author$project$Tasks$Apple$Claim$View$estimatedSyncPercentage(model))))
						]))
				]));
	});
var $author$project$Tasks$Apple$Claim$View$isBusinessesListEmpty = function (businesses) {
	if (businesses.$ === 'Loaded') {
		var businesses_ = businesses.a;
		return $elm$core$List$isEmpty(businesses_);
	} else {
		return false;
	}
};
var $author$project$Translations$General$connections = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.connections');
};
var $author$project$Translations$General$TopNavigation$accountSettings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.account_settings');
};
var $author$project$Translations$Listings$Claim$appleBrandsNotSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.apple_brands_not_selected');
};
var $author$project$Tasks$Apple$Claim$View$businessSelectionAlert = F2(
	function (translations, session) {
		var _v0 = session.siteName;
		var siteName = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Warning,
						$author$project$PinMeTo$Ui$Alert$rich(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Claim$appleBrandsNotSelected(translations)),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/account-settings/' + (siteName + '/connections/connect/apple'))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$TopNavigation$accountSettings(translations) + (' > ' + $author$project$Translations$General$connections(translations)))
										]))
								]))))
				]));
	});
var $author$project$Translations$Listings$Claim$remaining = F2(
	function (translations, locationsCount) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.claim.remaining',
			_List_fromArray(
				[
					_Utils_Tuple2('locationsCount', locationsCount)
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$Shared$renderAlert = function (notification) {
	if (notification.$ === 'Just') {
		var message = notification.a.message;
		var state = notification.a.state;
		return $author$project$PinMeTo$Ui$Alert$render(
			function () {
				switch (state.$) {
					case 'Success':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
					case 'Failed':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
					default:
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
				}
			}()(
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Tasks$Apple$Claim$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Translations$Listings$Claim$connectLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.connect_locations');
};
var $author$project$Translations$Listings$Claim$matchLocationsExplanation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.match_locations_explanation');
};
var $author$project$Translations$Listings$Claim$appleLocationsNotMatchingStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.apple_locations_not_matching_store_id');
};
var $author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderHeader_ = F2(
	function (uiPopoverState, translations) {
		var popOverConfig = {
			uid: 'match-locations-popover',
			tagger: $author$project$Tasks$Apple$Claim$Model$UiPopOverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$appleLocationsNotMatchingStoreId(translations)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$matchLocationsExplanation(translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$connectLocations(translations),
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Translations$Listings$Claim$appleLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.apple_locations');
};
var $author$project$Translations$Listings$Claim$placeCardLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.place_card_link');
};
var $author$project$Translations$Listings$Claim$distance = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.distance');
};
var $author$project$Translations$Listings$Claim$descriptor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.descriptor');
};
var $author$project$Tasks$Apple$Claim$Model$ConnectLocations = F2(
	function (a, b) {
		return {$: 'ConnectLocations', a: a, b: b};
	});
var $author$project$Tasks$Apple$Claim$Model$MatchLocationPMTTable = function (a) {
	return {$: 'MatchLocationPMTTable', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderPMTTable = F5(
	function (translations, model, locationsToBeCreated, selectedLocationAppleId, selectedLocationCoordinates) {
		var locationsToBeCreatedSortedByDistance = A2(
			$elm$core$List$take,
			10,
			A2(
				$elm$core$List$sortBy,
				function (l) {
					return l.distance;
				},
				A2(
					$elm$core$List$map,
					function (locationToBeCreated) {
						var distance = A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							0,
							$elm$core$Basics$identity,
							$elm$core$String$toInt(
								A4($author$project$Common$Math$calculateDistance, selectedLocationCoordinates.lat, selectedLocationCoordinates.lon, locationToBeCreated.location.location.lat, locationToBeCreated.location.location.lon)));
						return {distance: distance, location: locationToBeCreated.location};
					},
					locationsToBeCreated)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__match_location_container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.matchLocationPMTTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						'',
						function (location) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-btn pmt-btn--cta-muted network-claim-page__connect_button_small'),
												$elm$html$Html$Events$onClick(
												A2($author$project$Tasks$Apple$Claim$Model$ConnectLocations, location.location.id, selectedLocationAppleId))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Claim$connect(translations))
											]))
									]));
						},
						$author$project$PinMeTo$Ui$Table$comparing(
							function (_v0) {
								return 1;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							$author$project$Translations$General$locationCity(translations),
							function (location) {
								return $elm$html$Html$text(location.location.address.city);
							},
							$author$project$PinMeTo$Ui$Table$comparing(
								function (l) {
									return l.location.address.city;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$General$locationZip(translations),
								function (location) {
									return $elm$html$Html$text(location.location.address.zip);
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (l) {
										return l.location.address.zip;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									$author$project$Translations$General$locationStreet(translations),
									function (location) {
										return $elm$html$Html$text(location.location.address.street);
									},
									$author$project$PinMeTo$Ui$Table$comparing(
										function (l) {
											return l.location.address.street;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addColumn,
										$author$project$Translations$Listings$Claim$descriptor(translations),
										function (location) {
											return $elm$html$Html$text(location.location.locationDescriptor);
										},
										$author$project$PinMeTo$Ui$Table$comparing(
											function (l) {
												return l.location.locationDescriptor;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$locationName(translations),
											function (location) {
												return $elm$html$Html$text(location.location.name);
											},
											$author$project$PinMeTo$Ui$Table$comparing(
												function (l) {
													return l.location.name;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationStoreId(translations),
												function (location) {
													return $elm$html$Html$text(location.location.storeId);
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													function (l) {
														return l.location.storeId;
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addColumn,
													$author$project$Translations$Listings$Claim$distance(translations),
													function (location) {
														return $elm$html$Html$text(
															$elm$core$String$fromInt(location.distance));
													},
													$author$project$PinMeTo$Ui$Table$comparing(
														function (l) {
															return l.distance;
														}),
													A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Apple$Claim$Model$MatchLocationPMTTable, locationsToBeCreatedSortedByDistance))))))))))
				]));
	});
var $author$project$NetworkLogs$CardView$renderGeneralPmtCard = F3(
	function (heading, subheading, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-log-card-view__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__logo-box__logo-icon__general')
										]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$PinMeToLogo)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__left')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(heading)
												]))
										])),
									(subheading !== '') ? A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__center pmt-ui-font-caption')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(subheading)
										])) : $elm$html$Html$text(subheading)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__icon')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__text')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-log-card-view__content-box')
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Tasks$Apple$Claim$Model$MatchLocationNetworkTable = function (a) {
	return {$: 'MatchLocationNetworkTable', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$OnMatchLocationNetworkDataSelect = function (a) {
	return {$: 'OnMatchLocationNetworkDataSelect', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderNetworkTable = F3(
	function (translations, model, notMatchedLocations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__match_location_container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.matchLocationNetworkTable,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowMore,
						function (location) {
							if (_Utils_eq(
								model.selectedNetworkLocation,
								$elm$core$Maybe$Just(location.id))) {
								var locationsToBeCreated = function () {
									var _v0 = model.locationsToBeCreated;
									if (_v0.$ === 'Loaded') {
										var locations = _v0.a;
										return locations;
									} else {
										return _List_Nil;
									}
								}();
								var subheading = A2(
									$author$project$Translations$Listings$Claim$remaining,
									translations,
									$elm$core$String$fromInt(
										$elm$core$List$length(locationsToBeCreated)));
								var heading = $author$project$Translations$Listings$Claim$pinmetoLocations(translations);
								return $elm$core$Maybe$Just(
									A3(
										$author$project$NetworkLogs$CardView$renderGeneralPmtCard,
										heading,
										subheading,
										A5($author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderPMTTable, translations, model, locationsToBeCreated, location.id, location.location)));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withRowAction,
							function (location) {
								return $author$project$Tasks$Apple$Claim$Model$OnMatchLocationNetworkDataSelect(location.id);
							},
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$Listings$Claim$placeCardLink(translations),
								function (location) {
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(location.link),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(location.link)
											]));
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (l) {
										return l.link;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									$author$project$Translations$General$locationCity(translations),
									function (location) {
										return $elm$html$Html$text(location.address.city);
									},
									$author$project$PinMeTo$Ui$Table$comparing(
										function (l) {
											return l.address.city;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addColumn,
										$author$project$Translations$General$locationZip(translations),
										function (location) {
											return $elm$html$Html$text(location.address.zip);
										},
										$author$project$PinMeTo$Ui$Table$comparing(
											function (l) {
												return l.address.zip;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$locationStreet(translations),
											function (location) {
												return $elm$html$Html$text(location.address.street);
											},
											$author$project$PinMeTo$Ui$Table$comparing(
												function (l) {
													return l.address.street;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationName(translations),
												function (location) {
													return $elm$html$Html$text(location.name);
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													function (l) {
														return l.name;
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addColumn,
													$author$project$Translations$General$locationStoreId(translations),
													function (location) {
														return $elm$html$Html$text(location.storeId);
													},
													$author$project$PinMeTo$Ui$Table$comparing(
														function (l) {
															return l.storeId;
														}),
													A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Apple$Claim$Model$MatchLocationNetworkTable, notMatchedLocations))))))))))
				]));
	});
var $author$project$Translations$Listings$Claim$noAvailableLocationsToConnect = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.no_available_locations_to_connect');
};
var $author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderMatchTables = F3(
	function (translations, model, notMatchedLocations) {
		return $elm$core$List$isEmpty(notMatchedLocations) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$Claim$noAvailableLocationsToConnect(translations)))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__match_location_table_container')
				]),
			_List_fromArray(
				[
					A3($author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderNetworkTable, translations, model, notMatchedLocations)
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderMatchLocationsSection = F2(
	function (translations, model) {
		var notMatchedLocations = function () {
			var _v0 = model.appleNotMatchedLocations;
			if (_v0.$ === 'Loaded') {
				var locations = _v0.a;
				return locations;
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								A2($author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderHeader_, model.uiPopover, translations)
							]),
						(_Utils_eq(model.appleNotMatchedLocations, $author$project$RemoteData$Loading) || _Utils_eq(model.locationsToBeCreated, $author$project$RemoteData$Loading)) ? _List_fromArray(
							[$author$project$PinMeTo$Ui$Spinner$spinner]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('network-claim-page__sub_content-margin')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorApple),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-font-note network-claim-page__sub_content-note')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Claim$appleLocations(translations))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-font-caption network-claim-page__sub_content-caption')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Translations$Listings$Claim$remaining,
													translations,
													$elm$core$String$fromInt(
														$elm$core$List$length(notMatchedLocations))))
											]))
									])),
								$author$project$Tasks$Apple$Claim$Sections$Shared$renderAlert(model.categoriesNotification),
								A3($author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderMatchTables, translations, model, notMatchedLocations)
							])))
				]));
	});
var $author$project$Tasks$Apple$Claim$Model$Created = {$: 'Created'};
var $author$project$Tasks$Apple$Claim$Model$Invalid = {$: 'Invalid'};
var $author$project$Translations$Listings$Claim$invalid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.invalid');
};
var $author$project$Translations$Listings$Claim$available = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.available');
};
var $author$project$Translations$Listings$Claim$createLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.create_locations');
};
var $author$project$Translations$Listings$Claim$createLocationsExplanation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.create_locations_explanation');
};
var $author$project$Translations$Listings$Claim$locationsFailedToCreateOnApple = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.locations_failed_to_create_on_apple');
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderHeader_ = F2(
	function (uiPopoverState, session) {
		var popOverConfig = {
			uid: 'create-locations-popover',
			tagger: $author$project$Tasks$Apple$Claim$Model$UiPopOverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$locationsFailedToCreateOnApple(session.translations)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$createLocationsExplanation(session.translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$createLocations(session.translations),
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$classSelection = F2(
	function (model, tab) {
		return _Utils_eq(tab, model.createLocationsTab) ? 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header pmt-ui-view-selector__item--active pmt-ui-view-selector__item--enabled' : 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header';
	});
var $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError = function (location) {
	return !$elm$core$List$isEmpty(
		A2($elm$core$Maybe$withDefault, _List_Nil, location.errors));
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinesses = function (businesses) {
	if (businesses.$ === 'Loaded') {
		var businesses_ = businesses.a;
		return businesses_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Data$Location$Filter$isMatch = F2(
	function (searchFilter, item) {
		var lowerFilter = $elm$core$String$toLower(searchFilter);
		return A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(item.address.street)) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(item.address.zip)) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(item.address.city)) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(
				$author$project$Data$Address$getState(item.address))) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(item.address.country)) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(
				$author$project$Data$Address$getProvince(item.address))) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(
				$author$project$Data$Address$getDistrict(item.address))) || (A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(item.name)) || A2(
			$elm$core$String$contains,
			lowerFilter,
			$elm$core$String$toLower(item.storeId)))))))));
	});
var $author$project$Tasks$Apple$Claim$Model$filter = F2(
	function (searchQuery, locations) {
		var lowercasedSearchQuery = $elm$core$String$toLower(searchQuery);
		return (searchQuery === '') ? locations : A2(
			$elm$core$List$filter,
			function (locationToCreate) {
				return A2($author$project$Data$Location$Filter$isMatch, lowercasedSearchQuery, locationToCreate.location);
			},
			locations);
	});
var $author$project$Tasks$Apple$Claim$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessName = function (business) {
	if (business.$ === 'Just') {
		var business_ = business.a;
		return business_.name;
	} else {
		return '';
	}
};
var $author$project$Translations$Listings$Claim$selectBusiness = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.select_business');
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderBusinessName = F2(
	function (translations, business) {
		if (business.$ === 'Nothing') {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__business-name')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$selectBusiness(translations))
					]));
		} else {
			var business_ = business.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(business_.name),
						$elm$html$Html$text(' - '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-claim-page__business-name-absent')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$String$join, ', ', business_.countryCodes))
							]))
					]));
		}
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderErrorMessage = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__error-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getLastClaimAttempt = function (lastClaimAttempt) {
	if (lastClaimAttempt.$ === 'Just') {
		var lastClaimAttempt_ = lastClaimAttempt.a;
		return lastClaimAttempt_;
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getFirstErrorMessage = function (errors) {
	if (errors.$ === 'Just') {
		if (errors.a.b) {
			var _v1 = errors.a;
			var error = _v1.a;
			return error;
		} else {
			return '';
		}
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$hasNetworkClaimError = function (location) {
	var _v0 = location.state;
	if (_v0.$ === 'FailedToCreate') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getNetworkErrorMessage = function (state) {
	if (state.$ === 'FailedToCreate') {
		var error = state.a;
		return error;
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationTypeToPlainString = function (locationTypeToTurn) {
	switch (locationTypeToTurn.$) {
		case 'Storefront':
			return 'Storefront';
		case 'StorefrontAndServiceArea':
			return 'Storefront and Service Area';
		default:
			return 'Service Area';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderNetwrokErrorMessage = function (state) {
	return ($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getNetworkErrorMessage(state) !== '') ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__error-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getNetworkErrorMessage(state))
			])) : $elm$html$Html$text('');
};
var $author$project$PinMeTo$Ui$Table$withColumnSelectionAndLink = F3(
	function (f, g, config) {
		return _Utils_update(
			config,
			{
				rowLink: $elm$core$Maybe$Just(g),
				columnSelection: $elm$core$Maybe$Just(f)
			});
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationListTable = F4(
	function (translations, site, model, filteredLocations) {
		var createLocationTabAddColumn = function () {
			var _v0 = model.createLocationsTab;
			if (_v0.$ === 'Available') {
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					'Business to connect',
					function (location) {
						return A2($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderBusinessName, translations, location.selectedBusiness);
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (l) {
							return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessName(l.selectedBusiness);
						}));
			} else {
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					'Error',
					function (location) {
						return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderErrorMessage(
							$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getFirstErrorMessage(location.errors));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (l) {
							return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getFirstErrorMessage(l.errors);
						}));
			}
		}();
		var locationsMatchingFilter = A2($author$project$Tasks$Apple$Claim$Model$filter, model.filter, filteredLocations);
		var anyLocationHasNetworkClaimError = A2($elm$core$List$any, $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$hasNetworkClaimError, locationsMatchingFilter);
		var showLocationStatus = function (location) {
			return location.isActive ? (location.permanentlyClosed ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__error-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Closed')
					])) : A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Open')
					]))) : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__error-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Disabled')
					]));
		};
		var siteName_ = $author$project$Data$SiteName$toString(site);
		return A2(
			$author$project$PinMeTo$Ui$Table$render,
			model.uiTable,
			A3(
				$author$project$PinMeTo$Ui$Table$withColumnSelectionAndLink,
				function (x) {
					return x.location.id;
				},
				function (location) {
					return '/listings/' + (siteName_ + ('/locations/' + location.location.id));
				},
				A4(
					$author$project$PinMeTo$Ui$Table$addColumn,
					'Type',
					function (location) {
						return $elm$html$Html$text(
							$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationTypeToPlainString(location.location.locationType));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (l) {
							return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationTypeToPlainString(l.location.locationType);
						}),
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						'City',
						function (location) {
							return $elm$html$Html$text(location.location.address.city);
						},
						$author$project$PinMeTo$Ui$Table$comparing(
							function (l) {
								return l.location.address.city;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							'Zip',
							function (location) {
								return $elm$html$Html$text(location.location.address.zip);
							},
							$author$project$PinMeTo$Ui$Table$comparing(
								function (l) {
									return l.location.address.zip;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								'Street',
								function (location) {
									return $elm$html$Html$text(location.location.address.street);
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (l) {
										return l.location.address.street;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									'Location Descriptor',
									function (location) {
										return $elm$html$Html$text(location.location.locationDescriptor);
									},
									$author$project$PinMeTo$Ui$Table$comparing(
										function (l) {
											return l.location.locationDescriptor;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addColumn,
										'Name',
										function (location) {
											return $elm$html$Html$text(location.location.name);
										},
										$author$project$PinMeTo$Ui$Table$comparing(
											function (l) {
												return l.location.name;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											'Status',
											function (location) {
												return showLocationStatus(location.location);
											},
											$author$project$PinMeTo$Ui$Table$comparing(
												function (l) {
													return l.location.locationDescriptor;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												'Last claim attempt',
												function (location) {
													return $elm$html$Html$text(
														$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getLastClaimAttempt(location.lastClaimAttempt));
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													function (l) {
														return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getLastClaimAttempt(l.lastClaimAttempt);
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addColumn,
													'Country',
													function (location) {
														return $elm$html$Html$text(location.location.address.country);
													},
													$author$project$PinMeTo$Ui$Table$comparing(
														function (l) {
															return l.location.address.country;
														}),
													(anyLocationHasNetworkClaimError ? A3(
														$author$project$PinMeTo$Ui$Table$addColumn,
														'Error',
														function (location) {
															return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderNetwrokErrorMessage(location.state);
														},
														$author$project$PinMeTo$Ui$Table$comparing(
															function (l) {
																return $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getNetworkErrorMessage(l.state);
															})) : $elm$core$Basics$identity)(
														createLocationTabAddColumn(
															A4(
																$author$project$PinMeTo$Ui$Table$addColumn,
																'StoreId',
																function (location) {
																	return $elm$html$Html$text(location.location.storeId);
																},
																$author$project$PinMeTo$Ui$Table$comparing(
																	function (l) {
																		return l.location.storeId;
																	}),
																A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Apple$Claim$Model$UiTableMsg, locationsMatchingFilter)))))))))))))));
	});
var $author$project$Tasks$Apple$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$SelectedBusiness = F2(
	function (a, b) {
		return {$: 'SelectedBusiness', a: a, b: b};
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessCountryCodes = function (business) {
	if (business.$ === 'Just') {
		var business_ = business.a;
		return A2($elm$core$String$join, ', ', business_.countryCodes);
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$businessOptionLabel = function (business) {
	return business.name + (' - ' + $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessCountryCodes(
		$elm$core$Maybe$Just(business)));
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsCount = function (list) {
	return '(' + ($elm$core$String$fromInt(
		$elm$core$List$length(list)) + ')');
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList = function (locations) {
	if (locations.$ === 'Loaded') {
		var locations_ = locations.a;
		return locations_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderBusinessSelector = F3(
	function (translations, model, allBusinesses) {
		var selectedLocationIds = $author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable);
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2($elm$core$List$member, location.location.id, selectedLocationIds);
			},
			$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
		var selectedLocationsCountryCodes = $elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$map,
					function (location) {
						return location.location.address.countryAlpha2Code;
					},
					selectedLocations)));
		var selectableBusinesses = function () {
			var _v0 = $elm$core$List$length(selectedLocationsCountryCodes);
			switch (_v0) {
				case 0:
					return allBusinesses;
				case 1:
					var selectedCountryCode = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(selectedLocationsCountryCodes));
					return A2(
						$elm$core$List$filter,
						function (business) {
							return A2($elm$core$List$member, selectedCountryCode, business.countryCodes);
						},
						allBusinesses);
				default:
					return _List_Nil;
			}
		}();
		var selectedBusinessesNamesForLocations = $elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$map,
					function (business) {
						return ($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessName(business) !== '') ? ($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessName(business) + (' - ' + $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinessCountryCodes(business))) : '';
					},
					A2(
						$elm$core$List$map,
						function (location) {
							return location.selectedBusiness;
						},
						selectedLocations))));
		var selectedBusinessLabel = ($elm$core$List$length(selectedBusinessesNamesForLocations) === 1) ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Maybe$Nothing,
			function (name) {
				return (name === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(name);
			},
			$elm$core$List$head(selectedBusinessesNamesForLocations)) : $elm$core$Maybe$Nothing;
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$Claim$selectBusiness(translations),
			$elm$core$Basics$identity,
			selectedBusinessLabel) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsCount(selectedLocations));
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Apple$Claim$Model$Available) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__dropdown-container')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Select$render,
							model.uiSelect,
							A2(
								$author$project$PinMeTo$Ui$Select$withSearch,
								{
									searchMap: $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$businessOptionLabel,
									placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
									noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
								},
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'business-selector',
										items: selectableBusinesses,
										label: $elm$html$Html$text(label),
										tagger: $author$project$Tasks$Apple$Claim$Model$UiSelectMsg,
										onChange: function (business_) {
											return A2($author$project$Tasks$Apple$Claim$Model$SelectedBusiness, business_, selectedLocations);
										},
										itemRender: A2($elm$core$Basics$composeR, $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$businessOptionLabel, $elm$html$Html$text)
									})))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Apple$Claim$Model$FilterLocationsToCreate = function (a) {
	return {$: 'FilterLocationsToCreate', a: a};
};
var $author$project$Translations$Listings$Claim$noAvailableLocationsToCreate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.no_available_locations_to_create');
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsList = F5(
	function (translations, siteName, model, filteredLocations, button) {
		var bussinessesList = $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$getBusinesses(model.businesses);
		var renderLocationListTable = ($elm$core$List$isEmpty(bussinessesList) || $elm$core$List$isEmpty(filteredLocations)) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$Claim$noAvailableLocationsToCreate(translations)))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__list-container')
				]),
			_List_fromArray(
				[
					A4($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationListTable, translations, siteName, model, filteredLocations)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__business-selection-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__business-selection-filter-row')
						]),
					_List_fromArray(
						[
							A3($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderBusinessSelector, translations, model, bussinessesList),
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								'Search Locations',
								$author$project$PinMeTo$Ui$Form$Input$search(
									{value: model.filter, onChange: $author$project$Tasks$Apple$Claim$Model$FilterLocationsToCreate})))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__business-selection-container__button')
						]),
					_List_fromArray(
						[button])),
					renderLocationListTable
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderInvalidTab = F4(
	function (translations, siteName, model, filteredLocations) {
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Apple$Claim$Model$Invalid) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A5(
					$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsList,
					translations,
					siteName,
					model,
					filteredLocations,
					A2($elm$html$Html$span, _List_Nil, _List_Nil))
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderAlertSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__render-distance')
			]),
		_List_fromArray(
			[
				$author$project$Tasks$Apple$Claim$Sections$Shared$renderAlert(model.createLocationsNotification)
			]));
};
var $author$project$Tasks$Apple$Claim$Model$CreateLocations = {$: 'CreateLocations'};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderAvailableTab = F4(
	function (translations, siteName, model, filteredLocations) {
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
			},
			$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
		var allSelectedLocationsHaveBusiness = A2(
			$elm$core$List$all,
			function (location) {
				return $elm_community$maybe_extra$Maybe$Extra$isJust(location.selectedBusiness);
			},
			selectedLocations);
		var isCreateButtonDisabled = $elm$core$List$isEmpty(selectedLocations) || (!allSelectedLocationsHaveBusiness);
		var createButton = A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(isCreateButtonDisabled),
					$elm$html$Html$Events$onClick($author$project$Tasks$Apple$Claim$Model$CreateLocations)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$create(translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsCount(selectedLocations)))
				]));
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Apple$Claim$Model$Available) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsList, translations, siteName, model, filteredLocations, createButton),
					createButton
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Apple$Claim$Model$SwitchCreateLocationsTab = function (a) {
	return {$: 'SwitchCreateLocationsTab', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderCreateLocationsSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__content-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderHeader_, model.uiPopover, session),
						$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderAlertSection(model)
					]),
				function () {
					var _v0 = model.locationsToBeCreated;
					switch (_v0.$) {
						case 'Loading':
							return _List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]);
						case 'Loaded':
							var allLocations = _v0.a;
							var notCreatedLocations = A2(
								$elm$core$List$filter,
								function (location) {
									return !_Utils_eq(location.state, $author$project$Tasks$Apple$Claim$Model$Created);
								},
								allLocations);
							var locationsWithoutErrors = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeR, $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError, $elm$core$Basics$not),
								notCreatedLocations);
							var locationsWithErrors = A2($elm$core$List$filter, $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError, notCreatedLocations);
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('network-claim-page__create-location-tabs')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													A2($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$classSelection, model, $author$project$Tasks$Apple$Claim$Model$Available)),
													$elm$html$Html$Events$onClick(
													$author$project$Tasks$Apple$Claim$Model$SwitchCreateLocationsTab($author$project$Tasks$Apple$Claim$Model$Available))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$Claim$available(session.translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsCount(locationsWithoutErrors)))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													A2($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$classSelection, model, $author$project$Tasks$Apple$Claim$Model$Invalid)),
													$elm$html$Html$Events$onClick(
													$author$project$Tasks$Apple$Claim$Model$SwitchCreateLocationsTab($author$project$Tasks$Apple$Claim$Model$Invalid))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$Claim$invalid(session.translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderLocationsCount(locationsWithErrors)))
												]))
										])),
									A4($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderAvailableTab, session.translations, session.siteName, model, locationsWithoutErrors),
									A4($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderInvalidTab, session.translations, session.siteName, model, locationsWithErrors)
								]);
						case 'Error':
							var error = _v0.a;
							return _List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Error,
										$author$project$PinMeTo$Ui$Alert$plain(error)))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
					}
				}()));
	});
var $author$project$Translations$Listings$Claim$suggestedMatchesExplanation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.suggested_matches_explanation');
};
var $author$project$Translations$Listings$Claim$appleLocationsMatchedByStoreId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.apple_locations_matched_by_store_id');
};
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderHeader_ = F2(
	function (uiPopoverState, translations) {
		var popOverConfig = {
			uid: 'suggested-matches-popover',
			tagger: $author$project$Tasks$Apple$Claim$Model$UiPopOverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$appleLocationsMatchedByStoreId(translations)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$suggestedMatchesExplanation(translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$suggestedMatches(translations),
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Translations$Listings$Claim$matchesOnStoreId = F2(
	function (translations, locationsCount) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.claim.matches_on_store_id',
			_List_fromArray(
				[
					_Utils_Tuple2('locationsCount', locationsCount)
				]));
	});
var $author$project$Translations$Listings$Claim$suggestedMatchesNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.suggested_matches_note');
};
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$matchSimilarLocations = F2(
	function (notMatchedLocations, locationsToBeCreated) {
		return A2(
			$elm$core$List$filterMap,
			function (notMatchedLocation) {
				return A2(
					$elm$core$Maybe$map,
					function (locationToBeCreated) {
						return _Utils_Tuple2(notMatchedLocation, locationToBeCreated);
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (location) {
								return _Utils_eq(location.location.storeId, notMatchedLocation.storeId);
							},
							locationsToBeCreated)));
			},
			notMatchedLocations);
	});
var $author$project$Tasks$Apple$Claim$Model$ConfirmSuggestedMatches = function (a) {
	return {$: 'ConfirmSuggestedMatches', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$filterMatchesOnAppleIds = F2(
	function (appleIds, matches) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var appleLocation = _v0.a;
				var pinMeToLocation = _v0.b;
				return A2($elm$core$Set$member, appleLocation.id, appleIds) ? $elm$core$Maybe$Just(
					{appleId: appleLocation.id, locationId: pinMeToLocation.location.id}) : $elm$core$Maybe$Nothing;
			},
			matches);
	});
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderConfirmMatchesButton = F3(
	function (translations, suggestedMatches, matches) {
		var matchesToConfirm = A2($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$filterMatchesOnAppleIds, suggestedMatches, matches);
		return A4(
			$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
			$author$project$PinMeTo$Ui$Btn$NoIcon,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Tasks$Apple$Claim$Model$ConfirmSuggestedMatches(matchesToConfirm)),
					$elm$html$Html$Attributes$disabled(
					$elm$core$List$isEmpty(matchesToConfirm))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$confirmSimple(translations) + (' (' + ($elm$core$String$fromInt(
						$elm$core$List$length(matchesToConfirm)) + ')')))
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderAppleLocation = function (location) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__location-icon')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorApple)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.storeId)
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__location-text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(location.name)
				])),
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.address.street)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.address.zip)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.address.city)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(location.link),
							$elm$html$Html$Attributes$target('blank_')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Apple Maps')
						]))
				]))
		]);
};
var $author$project$Tasks$Apple$Claim$Model$ToggleSuggestedMatch = function (a) {
	return {$: 'ToggleSuggestedMatch', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderPinMeToLocation = function (location) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__location-icon')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$PinMeToLogo)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.location.storeId)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.location.name)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.location.locationDescriptor)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.location.address.street)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.location.address.zip)
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(location.location.address.city)
				])),
			A2($elm$html$Html$span, _List_Nil, _List_Nil)
		]);
};
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderSuggestedMatch = F4(
	function (model, _v0, appleLocation, pinMeToLocation) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__match-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Form$Checkbox$render(
					$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
						{
							label: '',
							checked: A2($elm$core$Set$member, appleLocation.id, model.suggestedMatches),
							onChange: function (_v1) {
								return $author$project$Tasks$Apple$Claim$Model$ToggleSuggestedMatch(appleLocation.id);
							}
						})),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__locations-container')
						]),
					_Utils_ap(
						$author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderAppleLocation(appleLocation),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__divider')
									]),
								_List_Nil),
							$author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderPinMeToLocation(pinMeToLocation))))
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderSuggestedMatchesTable = F3(
	function (model, translations, matches) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page--suggested-matches__container')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var appleNotMatchedLocation = _v0.a;
					var locationToCreate = _v0.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A4($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderSuggestedMatch, model, translations, appleNotMatchedLocation, locationToCreate)
							]));
				},
				matches));
	});
var $author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderSuggestedMatchesSection = F2(
	function (translations, model) {
		var notMatchedLocationsWithStoreId = function () {
			var _v1 = model.appleNotMatchedLocations;
			if (_v1.$ === 'Loaded') {
				var locations = _v1.a;
				return A2(
					$elm$core$List$filter,
					function (location) {
						return location.storeId !== '';
					},
					locations);
			} else {
				return _List_Nil;
			}
		}();
		var locationsToBeCreated = function () {
			var _v0 = model.locationsToBeCreated;
			if (_v0.$ === 'Loaded') {
				var locations = _v0.a;
				return locations;
			} else {
				return _List_Nil;
			}
		}();
		var matches = A2($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$matchSimilarLocations, notMatchedLocationsWithStoreId, locationsToBeCreated);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								A2($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderHeader_, model.uiPopover, translations)
							]),
						(_Utils_eq(model.appleNotMatchedLocations, $author$project$RemoteData$Loading) || _Utils_eq(model.locationsToBeCreated, $author$project$RemoteData$Loading)) ? _List_fromArray(
							[$author$project$PinMeTo$Ui$Spinner$spinner]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-font-note network-claim-page__sub_content-note')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Translations$Listings$Claim$matchesOnStoreId,
													translations,
													$elm$core$String$fromInt(
														$elm$core$List$length(matches))))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Alert$render(
										A2(
											$author$project$PinMeTo$Ui$Alert$withStatus,
											$author$project$PinMeTo$Ui$Alert$Note,
											$author$project$PinMeTo$Ui$Alert$plain(
												$author$project$Translations$Listings$Claim$suggestedMatchesNote(translations))))
									])),
								A3($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderSuggestedMatchesTable, model, translations, matches),
								A3($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderConfirmMatchesButton, translations, model.suggestedMatches, matches),
								$author$project$Tasks$Apple$Claim$Sections$Shared$renderAlert(model.categoriesNotification)
							])))
				]));
	});
var $author$project$Tasks$Apple$Claim$View$renderOauthSections = F2(
	function (session, model) {
		var businessesListIsEmpty = $author$project$Tasks$Apple$Claim$View$isBusinessesListEmpty(model.businesses);
		var businessSelectionAlert_ = businessesListIsEmpty ? A2($author$project$Tasks$Apple$Claim$View$businessSelectionAlert, session.translations, session) : $elm$html$Html$text('');
		return _List_fromArray(
			[
				businessSelectionAlert_,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('network-claim-page__disabled', businessesListIsEmpty)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-claim-page__section-break')
							]),
						_List_fromArray(
							[$author$project$Tasks$Apple$Claim$View$lineSeparator])),
						A2($author$project$Tasks$Apple$Claim$Sections$SuggestedMatchesSection$renderSuggestedMatchesSection, session.translations, model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-claim-page__section-break')
							]),
						_List_fromArray(
							[$author$project$Tasks$Apple$Claim$View$lineSeparator])),
						A2($author$project$Tasks$Apple$Claim$Sections$MatchLocationsSection$renderMatchLocationsSection, session.translations, model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-claim-page__section-break')
							]),
						_List_fromArray(
							[$author$project$Tasks$Apple$Claim$View$lineSeparator])),
						A2($author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$renderCreateLocationsSection, session, model),
						A2($elm$html$Html$br, _List_Nil, _List_Nil)
					]))
			]);
	});
var $author$project$Translations$Listings$Claim$claimAppleLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_apple_locations');
};
var $author$project$Tasks$Apple$Claim$View$renderHeader = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorApple)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimAppleLocations(translations))
					]))
			]));
};
var $author$project$Tasks$Apple$Claim$Model$SyncLocations = {$: 'SyncLocations'};
var $author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderLastDate = F2(
	function (session, lastRun) {
		var dateAndTime = function () {
			if (lastRun.$ === 'Nothing') {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$syncLocationsNeverRun(session.translations))
							]))
					]);
			} else {
				var lastRun_ = lastRun.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Date$render(
										A2(
											$author$project$PinMeTo$Ui$Date$withFormat,
											$author$project$PinMeTo$Ui$Date$FormatDate,
											A2($author$project$PinMeTo$Ui$Date$string, session.locale, lastRun_)))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' ' + ($author$project$Translations$Listings$Claim$syncLocationsAt(session.translations) + ' '))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Date$render(
										A2(
											$author$project$PinMeTo$Ui$Date$withFormat,
											$author$project$PinMeTo$Ui$Date$FormatTime,
											A2($author$project$PinMeTo$Ui$Date$string, session.locale, lastRun_)))
									]))
							]))
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations__container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-claim-page__sync-locations__last-sync'),
								$elm$html$Html$Attributes$class('pmt-ui-font-caption')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$syncLocationsLastRun(session.translations))
							]))
					]),
				dateAndTime));
	});
var $author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderSyncError = function (status) {
	if (status.$ === 'SyncError') {
		var err = status.a;
		return $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Error,
				$author$project$PinMeTo$Ui$Alert$plain(err)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$isButtonDisabled = function (model) {
	return (_Utils_eq(model.locationsToBeCreated, $author$project$RemoteData$Loading) || _Utils_eq(model.syncStatus, $author$project$Tasks$Apple$Claim$Model$Running)) ? true : false;
};
var $author$project$Tasks$Apple$Claim$Model$RepublishLocations = {$: 'RepublishLocations'};
var $author$project$Translations$Listings$Claim$republishLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.republish_locations');
};
var $author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderRepublishLocations = F2(
	function (translations, model) {
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				$author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$isButtonDisabled(model),
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Tasks$Apple$Claim$Model$RepublishLocations,
					A2(
						$author$project$PinMeTo$Ui$Button$withIconBefore,
						$author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faArrowsRotate),
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$Listings$Claim$republishLocations(translations))))));
	});
var $author$project$Tasks$Apple$Claim$Model$ResetSyncLock = {$: 'ResetSyncLock'};
var $author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderResetSyncLockButton = function (model) {
	return model.isDev ? $author$project$PinMeTo$Ui$Button$render(
		A2(
			$author$project$PinMeTo$Ui$Button$withOnClick,
			$author$project$Tasks$Apple$Claim$Model$ResetSyncLock,
			A2(
				$author$project$PinMeTo$Ui$Button$withSecondaryStyle,
				$author$project$PinMeTo$Ui$Button$SecondaryDanger,
				$author$project$PinMeTo$Ui$Button$buttonSecondary('Reset lock (dev)')))) : $elm$html$Html$text('');
};
var $author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderSyncLocationsSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations_section')
				]),
			_List_fromArray(
				[
					A2($author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderLastDate, session, model.syncLocationsLastRun),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$disabledIfTrue,
						$author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$isButtonDisabled(model),
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Tasks$Apple$Claim$Model$SyncLocations,
							A2(
								$author$project$PinMeTo$Ui$Button$withIconBefore,
								$author$project$PinMeTo$Ui$Button$FASolid($author$project$FontAwesome$Solid$Icon$faArrowsRotate),
								$author$project$PinMeTo$Ui$Button$buttonPrimary(
									$author$project$Translations$Listings$Claim$syncLocations(session.translations)))))),
					A2($author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderRepublishLocations, session.translations, model),
					$author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderResetSyncLockButton(model),
					$author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderSyncError(model.syncStatus)
				]));
	});
var $author$project$Tasks$Apple$Claim$View$renderInnerContainer = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Tasks$Apple$Claim$View$renderHeader(session.translations)
					]),
				_Utils_eq(model.appleConnectionType, $author$project$Insights$Apple$Model$OAUTH) ? _List_fromArray(
					[
						A2($author$project$Tasks$Apple$Claim$Sections$SyncLocationsSection$renderSyncLocationsSection, session, model)
					]) : _List_Nil));
	});
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Tasks$Apple$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Apple$Claim$Update$areCategoriesSelected = function (model) {
	var areAllAdditionalCategoriesSelected = A2($elm$core$List$all, $elm_community$maybe_extra$Maybe$Extra$isJust, model.additionalCategoriesList);
	var isPrimaryCategorySelected = $elm_community$maybe_extra$Maybe$Extra$isJust(model.primaryCategory);
	return isPrimaryCategorySelected && areAllAdditionalCategoriesSelected;
};
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Apple$Claim$Update$areCategoriesSelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Apple$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Apple$Claim$Model$SelectedPrimaryCategory = function (a) {
	return {$: 'SelectedPrimaryCategory', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$SelectedAdditionalCategory = F2(
	function (a, b) {
		return {$: 'SelectedAdditionalCategory', a: a, b: b};
	});
var $author$project$Tasks$Apple$Claim$Model$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderCategorySelector = F6(
	function (uid, translations, model, categories, category, index) {
		var isPrimary = uid === 'ui-select-primary';
		var title = isPrimary ? $author$project$Translations$Listings$LocationDetail$primaryCategory(translations) : A2(
			$author$project$Translations$Listings$LocationDetail$additionalCategory,
			translations,
			$elm$core$String$fromInt(index + 1));
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid + ('-' + $elm$core$String$fromInt(index)),
													items: A2($author$project$Tasks$Apple$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Apple$Claim$Model$UiSelectMsg,
													onChange: function (category_) {
														return isPrimary ? $author$project$Tasks$Apple$Claim$Model$SelectedPrimaryCategory(category_) : A2($author$project$Tasks$Apple$Claim$Model$SelectedAdditionalCategory, category_, index);
													},
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								])),
							isPrimary ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__remove-additional'),
									$elm$html$Html$Events$onClick(
									$author$project$Tasks$Apple$Claim$Model$RemoveAdditionalCategoryByIndex(index))
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
								]))
						]))
				]));
	});
var $author$project$Tasks$Apple$Claim$Model$AddAdditionalCategory = {$: 'AddAdditionalCategory'};
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderAddCategoryButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__publish-button')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Tasks$Apple$Claim$Model$AddAdditionalCategory)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$addCategory(translations))
					]))
			]));
};
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderAdditionalCategories = F3(
	function (translations, model, categories) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return A6($author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-additional', translations, model, categories, item, index);
					}),
				model.additionalCategoriesList));
	});
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$getCategoryId = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	function (category_) {
		return $author$project$Data$Location$NetworkCategories$getId(category_);
	});
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$getSelectedCategoryIds = function (model) {
	return A2(
		$elm$core$List$append,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (category) {
				return _List_fromArray(
					[
						$author$project$Data$Location$NetworkCategories$getId(category)
					]);
			},
			model.primaryCategory),
		A2(
			$elm$core$List$filter,
			function (category) {
				return category !== '';
			},
			A2($elm$core$List$map, $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$getCategoryId, model.additionalCategoriesList)));
};
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$getAllNotSelectedCategories = function (model) {
	var _v0 = model.allCategories;
	if (_v0.$ === 'Loaded') {
		var categories = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (category) {
				return !A2(
					$elm$core$List$member,
					$author$project$Data$Location$NetworkCategories$getId(category),
					$author$project$Tasks$Apple$Claim$Sections$CategoriesSection$getSelectedCategoryIds(model));
			},
			categories);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = $author$project$Tasks$Apple$Claim$Sections$CategoriesSection$sortCategories(
			$author$project$Tasks$Apple$Claim$Sections$CategoriesSection$getAllNotSelectedCategories(model));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Tasks$Shared$Components$Header$renderHeader,
							$author$project$Translations$Listings$Claim$categories(translations),
							$elm$core$Maybe$Nothing),
							$author$project$Tasks$Apple$Claim$Sections$Shared$renderAlert(model.categoriesNotification),
							A6($author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-primary', translations, model, sortedCategories, model.primaryCategory, 0),
							A3($author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderAdditionalCategories, translations, model, sortedCategories),
							$author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderAddCategoryButton(translations),
							A2($author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
						]))
				]));
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderHeader_ = F2(
	function (uiPopoverState, session) {
		var popOverConfig = {
			uid: 'create-locations-popover',
			tagger: $author$project$Tasks$Apple$Claim$Model$UiPopOverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$locationsFailedToCreateOnApple(session.translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$createLocations(session.translations),
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getClassesForTab = F2(
	function (model, tab) {
		return _Utils_eq(tab, model.createLocationsTab) ? 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header pmt-ui-view-selector__item--active pmt-ui-view-selector__item--enabled' : 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header';
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getLastClaimAttempt = function (lastClaimAttempt) {
	if (lastClaimAttempt.$ === 'Just') {
		var lastClaimAttempt_ = lastClaimAttempt.a;
		return lastClaimAttempt_;
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$hasNetworkClaimError = function (location) {
	var _v0 = location.state;
	if (_v0.$ === 'FailedToCreate') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getNetworkErrorMessage = function (state) {
	if (state.$ === 'FailedToCreate') {
		var error = state.a;
		return error;
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$locationTypeToPlainString = function (locationTypeToTurn) {
	switch (locationTypeToTurn.$) {
		case 'Storefront':
			return 'Storefront';
		case 'StorefrontAndServiceArea':
			return 'Storefront and Service Area';
		default:
			return 'Service Area';
	}
};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderNetwrokErrorMessage = function (state) {
	return ($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getNetworkErrorMessage(state) !== '') ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__error-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getNetworkErrorMessage(state))
			])) : $elm$html$Html$text('');
};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$locationListTable = F4(
	function (_v0, site, model, filteredLocations) {
		var locationsMatchingFilter = A2($author$project$Tasks$Apple$Claim$Model$filter, model.filter, filteredLocations);
		var anyLocationHasNetworkClaimError = A2($elm$core$List$any, $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$hasNetworkClaimError, locationsMatchingFilter);
		var showLocationStatus = function (location) {
			return location.isActive ? (location.permanentlyClosed ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__error-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Closed')
					])) : A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Open')
					]))) : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__error-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Disabled')
					]));
		};
		var siteName_ = $author$project$Data$SiteName$toString(site);
		return A2(
			$author$project$PinMeTo$Ui$Table$render,
			model.uiTable,
			A3(
				$author$project$PinMeTo$Ui$Table$withColumnSelectionAndLink,
				function (x) {
					return x.location.id;
				},
				function (location) {
					return '/listings/' + (siteName_ + ('/locations/' + location.location.id));
				},
				A4(
					$author$project$PinMeTo$Ui$Table$addColumn,
					'Type',
					function (location) {
						return $elm$html$Html$text(
							$author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$locationTypeToPlainString(location.location.locationType));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (l) {
							return $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$locationTypeToPlainString(l.location.locationType);
						}),
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						'City',
						function (location) {
							return $elm$html$Html$text(location.location.address.city);
						},
						$author$project$PinMeTo$Ui$Table$comparing(
							function (l) {
								return l.location.address.city;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							'Zip',
							function (location) {
								return $elm$html$Html$text(location.location.address.zip);
							},
							$author$project$PinMeTo$Ui$Table$comparing(
								function (l) {
									return l.location.address.zip;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								'Street',
								function (location) {
									return $elm$html$Html$text(location.location.address.street);
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (l) {
										return l.location.address.street;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									'Location Descriptor',
									function (location) {
										return $elm$html$Html$text(location.location.locationDescriptor);
									},
									$author$project$PinMeTo$Ui$Table$comparing(
										function (l) {
											return l.location.locationDescriptor;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addColumn,
										'Name',
										function (location) {
											return $elm$html$Html$text(location.location.name);
										},
										$author$project$PinMeTo$Ui$Table$comparing(
											function (l) {
												return l.location.name;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											'Status',
											function (location) {
												return showLocationStatus(location.location);
											},
											$author$project$PinMeTo$Ui$Table$comparing(
												function (l) {
													return l.location.locationDescriptor;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												'Last claim attempt',
												function (location) {
													return $elm$html$Html$text(
														$author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getLastClaimAttempt(location.lastClaimAttempt));
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													function (l) {
														return $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getLastClaimAttempt(l.lastClaimAttempt);
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addColumn,
													'Country',
													function (location) {
														return $elm$html$Html$text(location.location.address.country);
													},
													$author$project$PinMeTo$Ui$Table$comparing(
														function (l) {
															return l.location.address.country;
														}),
													(anyLocationHasNetworkClaimError ? A3(
														$author$project$PinMeTo$Ui$Table$addColumn,
														'Error',
														function (location) {
															return $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderNetwrokErrorMessage(location.state);
														},
														$author$project$PinMeTo$Ui$Table$comparing(
															function (l) {
																return $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getNetworkErrorMessage(l.state);
															})) : $elm$core$Basics$identity)(
														A4(
															$author$project$PinMeTo$Ui$Table$addColumn,
															'StoreId',
															function (location) {
																return $elm$html$Html$text(location.location.storeId);
															},
															$author$project$PinMeTo$Ui$Table$comparing(
																function (l) {
																	return l.location.storeId;
																}),
															A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Apple$Claim$Model$UiTableMsg, locationsMatchingFilter))))))))))))));
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsList = F4(
	function (translations, siteName, model, filteredLocations) {
		var renderLocationListTable = $elm$core$List$isEmpty(filteredLocations) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$Claim$noAvailableLocationsToCreate(translations)))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__list-container')
				]),
			_List_fromArray(
				[
					A4($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$locationListTable, translations, siteName, model, filteredLocations)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__business-selection-container')
				]),
			_List_fromArray(
				[renderLocationListTable]));
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderInvalidTab = F4(
	function (translations, siteName, model, filteredLocations) {
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Apple$Claim$Model$Invalid) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsList, translations, siteName, model, filteredLocations)
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderAlertSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__render-distance')
			]),
		_List_fromArray(
			[
				$author$project$Tasks$Apple$Claim$Sections$Shared$renderAlert(model.createLocationsNotification)
			]));
};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsCount = function (list) {
	return '(' + ($elm$core$String$fromInt(
		$elm$core$List$length(list)) + ')');
};
var $author$project$Tasks$Apple$Claim$Model$CreateNonOauthLocations = {$: 'CreateNonOauthLocations'};
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderAvailableTab = F4(
	function (translations, siteName, model, filteredLocations) {
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
			},
			filteredLocations);
		var isCreateButtonDisabled = $elm$core$List$isEmpty(selectedLocations);
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Apple$Claim$Model$Available) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__business-selection-container__button')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(isCreateButtonDisabled),
									$elm$html$Html$Events$onClick($author$project$Tasks$Apple$Claim$Model$CreateNonOauthLocations)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$create(translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsCount(selectedLocations)))
								]))
						])),
					A4($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsList, translations, siteName, model, filteredLocations),
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(isCreateButtonDisabled),
							$elm$html$Html$Events$onClick($author$project$Tasks$Apple$Claim$Model$CreateNonOauthLocations)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$create(translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsCount(selectedLocations)))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderCreateNonOauthLocationsSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__content-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderHeader_, model.uiPopover, session),
						$author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderAlertSection(model)
					]),
				function () {
					var _v0 = model.locationsToBeCreated;
					switch (_v0.$) {
						case 'Loading':
							return _List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]);
						case 'Loaded':
							var allLocations = _v0.a;
							var notCreatedLocations = A2(
								$elm$core$List$filter,
								function (location) {
									return !_Utils_eq(location.state, $author$project$Tasks$Apple$Claim$Model$Created);
								},
								allLocations);
							var locationsWithoutErrors = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeR, $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError, $elm$core$Basics$not),
								notCreatedLocations);
							var locationsWithErrors = A2($elm$core$List$filter, $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError, notCreatedLocations);
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('network-claim-page__create-location-tabs')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													A2($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getClassesForTab, model, $author$project$Tasks$Apple$Claim$Model$Available)),
													$elm$html$Html$Events$onClick(
													$author$project$Tasks$Apple$Claim$Model$SwitchCreateLocationsTab($author$project$Tasks$Apple$Claim$Model$Available))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$Claim$available(session.translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsCount(locationsWithoutErrors)))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													A2($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$getClassesForTab, model, $author$project$Tasks$Apple$Claim$Model$Invalid)),
													$elm$html$Html$Events$onClick(
													$author$project$Tasks$Apple$Claim$Model$SwitchCreateLocationsTab($author$project$Tasks$Apple$Claim$Model$Invalid))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$Claim$invalid(session.translations) + (' ' + $author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderLocationsCount(locationsWithErrors)))
												]))
										])),
									A4($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderAvailableTab, session.translations, session.siteName, model, locationsWithoutErrors),
									A4($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderInvalidTab, session.translations, session.siteName, model, locationsWithErrors)
								]);
						case 'Error':
							var error = _v0.a;
							return _List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Error,
										$author$project$PinMeTo$Ui$Alert$plain(error)))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
					}
				}()));
	});
var $author$project$Tasks$Apple$Claim$View$renderNonOauthSections = F2(
	function (session, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__section-break')
					]),
				_List_fromArray(
					[$author$project$Tasks$Apple$Claim$View$lineSeparator])),
				A2($author$project$Tasks$Apple$Claim$Sections$CreateNonOauthLocationsSection$renderCreateNonOauthLocationsSection, session, model)
			]);
	});
var $author$project$Tasks$Apple$Claim$View$view = F2(
	function (session, model) {
		var isSyncing = _Utils_eq(model.syncStatus, $author$project$Tasks$Apple$Claim$Model$Running);
		var syncProgress = isSyncing ? _List_fromArray(
			[
				A2($author$project$Tasks$Apple$Claim$View$renderSyncProgress, session, model)
			]) : _List_Nil;
		var claimSections = isSyncing ? _List_Nil : (_Utils_eq(model.appleConnectionType, $author$project$Insights$Apple$Model$OAUTH) ? A2($author$project$Tasks$Apple$Claim$View$renderOauthSections, session, model) : A2($author$project$Tasks$Apple$Claim$View$renderNonOauthSections, session, model));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Tasks$Apple$Claim$View$renderInnerContainer, session, model),
						$author$project$Tasks$Apple$Claim$View$lineSeparator
					]),
				_Utils_ap(
					syncProgress,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('network-claim-page__disabled', isSyncing)
											]))
									]),
								_List_fromArray(
									[
										A2($author$project$Tasks$Apple$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model)
									]))
							]),
						claimSections))));
	});
var $author$project$Tasks$Apple$Claim$Model$Info = {$: 'Info'};
var $author$project$Tasks$Apple$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Apple$Claim$Model$Success = {$: 'Success'};
var $author$project$Tasks$Apple$Claim$Model$SyncError = function (a) {
	return {$: 'SyncError', a: a};
};
var $author$project$RequestError$RequestError = F3(
	function (errorId, errorMessage, details) {
		return {details: details, errorId: errorId, errorMessage: errorMessage};
	});
var $author$project$RequestError$decode = function (detailsDecoder) {
	var requestErrorDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['error', 'details']),
		$elm$json$Json$Decode$maybe(detailsDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['error', 'message']),
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'errorId',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$RequestError$RequestError))));
	var stringError = A2(
		$elm$json$Json$Decode$map,
		function (s) {
			return {details: $elm$core$Maybe$Nothing, errorId: $elm$core$Maybe$Nothing, errorMessage: s};
		},
		$elm$json$Json$Decode$string);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[requestErrorDecoder, stringError]));
};
var $author$project$Tasks$Apple$Claim$Commands$resetSyncLock = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/resetSyncLock');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed('Sync lock reset'),
					$author$project$RequestError$decode(
						$elm$json$Json$Decode$succeed(_Utils_Tuple0))),
				$lukewestby$elm_http_builder$HttpBuilder$post(url)));
	});
var $author$project$Tasks$Apple$Claim$Commands$syncLocations = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/syncLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'itemCount', $elm$json$Json$Decode$int),
					$author$project$RequestError$decode(
						$elm$json$Json$Decode$succeed(_Utils_Tuple0))),
				$lukewestby$elm_http_builder$HttpBuilder$post(url)));
	});
var $author$project$Tasks$Apple$Claim$Commands$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getId(x))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getName(x)))
			]));
};
var $author$project$Tasks$Apple$Claim$Commands$encodePrimaryCategory = function (primaryCategory) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (p) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'primaryCategory',
						$author$project$Tasks$Apple$Claim$Commands$encodeCategory(p))
					]);
			},
			primaryCategory));
};
var $author$project$Tasks$Apple$Claim$Commands$encodeCategories = function (model) {
	var additionalCategories = A2($elm$core$List$filterMap, $elm$core$Basics$identity, model.additionalCategoriesList);
	var primaryCategory = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just, model.primaryCategory);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'additionalCategories',
							A2($elm$json$Json$Encode$list, $author$project$Tasks$Apple$Claim$Commands$encodeCategory, additionalCategories)),
						$author$project$Tasks$Apple$Claim$Commands$encodePrimaryCategory(primaryCategory))))
			]));
};
var $author$project$Tasks$Apple$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/categories');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Apple$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Apple$Claim$Commands$locationToCreateEncoder = function (location) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'locationId',
				$elm$json$Json$Encode$string(location.location.id)),
				_Utils_Tuple2(
				'businessId',
				$elm$json$Json$Encode$string(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (selectedBusiness) {
							return selectedBusiness.businessId;
						},
						location.selectedBusiness))),
				_Utils_Tuple2(
				'companyId',
				$elm$json$Json$Encode$string(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (selectedBusiness) {
							return selectedBusiness.companyId;
						},
						location.selectedBusiness))),
				_Utils_Tuple2(
				'storeId',
				$elm$json$Json$Encode$string(location.location.storeId))
			]));
};
var $author$project$Tasks$Apple$Claim$Commands$createLocationsEncoder = function (locations) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'locationsToCreate',
				A2($elm$json$Json$Encode$list, $author$project$Tasks$Apple$Claim$Commands$locationToCreateEncoder, locations))
			]));
};
var $author$project$Tasks$Apple$Claim$Commands$createLocations = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
			},
			$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
		var allHaveBusinessSelected = A2(
			$elm$core$List$all,
			function (location) {
				return $elm_community$maybe_extra$Maybe$Extra$isJust(location.selectedBusiness);
			},
			selectedLocations);
		var allHaveNoErrors = A2(
			$elm$core$List$all,
			A2($elm$core$Basics$composeR, $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError, $elm$core$Basics$not),
			selectedLocations);
		var url = 'api/' + (accountName + '/apple/claim/locationsToCreate');
		return (allHaveBusinessSelected && allHaveNoErrors) ? $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$locationToCreateDecoder),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Apple$Claim$Commands$createLocationsEncoder(selectedLocations),
					$lukewestby$elm_http_builder$HttpBuilder$post(url)))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$RequestError$getErrorMessage = function (err) {
	var _v0 = err.details;
	if (_v0.$ === 'BadStatus') {
		var result = _v0.c;
		if (result.$ === 'Ok') {
			var r = result.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				r.errorMessage,
				function (id) {
					return r.errorMessage + (' (code: ' + (id + ')'));
				},
				r.errorId);
		} else {
			var e = result.a;
			return $elm$json$Json$Decode$errorToString(e);
		}
	} else {
		return $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
	}
};
var $author$project$Tasks$Apple$Claim$Model$GotSyncStartTime = function (a) {
	return {$: 'GotSyncStartTime', a: a};
};
var $author$project$Tasks$Apple$Claim$Commands$encodeConnectLocation = function (_v0) {
	var appleId = _v0.appleId;
	var locationId = _v0.locationId;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'locationId',
				$elm$json$Json$Encode$string(locationId)),
				_Utils_Tuple2(
				'appleId',
				$elm$json$Json$Encode$string(appleId))
			]));
};
var $author$project$Tasks$Apple$Claim$Commands$connectLocations = F3(
	function (_v0, matches, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/connectLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$appleNotMatchedlocationDecoder),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'data',
								A2($elm$json$Json$Encode$list, $author$project$Tasks$Apple$Claim$Commands$encodeConnectLocation, matches))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Apple$Claim$Model$SendResetSyncLock = function (a) {
	return {$: 'SendResetSyncLock', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$SendSyncLocations = function (a) {
	return {$: 'SendSyncLocations', a: a};
};
var $author$project$Tasks$Apple$Claim$Update$emptyNotification = function (model) {
	return _Utils_update(
		model,
		{categoriesNotification: $elm$core$Maybe$Nothing});
};
var $author$project$Translations$Listings$LocationDetail$PopUpContent$failedGettingData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.failed_getting_data');
};
var $author$project$Tasks$Apple$Claim$Commands$republishLocations = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/apple/claim/republishLocations');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'itemCount', $elm$json$Json$Decode$int),
					$author$project$RequestError$decode(
						$elm$json$Json$Decode$succeed(_Utils_Tuple0))),
				$lukewestby$elm_http_builder$HttpBuilder$post(url)));
	});
var $author$project$Tasks$Apple$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				categoriesNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$Apple$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$SendRepublishLocations = function (a) {
	return {$: 'SendRepublishLocations', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$CreateLocationsResponse = function (a) {
	return {$: 'CreateLocationsResponse', a: a};
};
var $author$project$Tasks$Apple$Claim$Commands$createNonOauthLocations = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
			},
			$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
		var allHaveNoErrors = A2(
			$elm$core$List$all,
			A2($elm$core$Basics$composeR, $author$project$Tasks$Apple$Claim$Sections$Shared$locationHasError, $elm$core$Basics$not),
			selectedLocations);
		var url = 'api/' + (accountName + '/apple/claim/nonOauthLocationsToCreate');
		return allHaveNoErrors ? $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Apple$Claim$Commands$locationToCreateDecoder),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Apple$Claim$Commands$createLocationsEncoder(selectedLocations),
					$lukewestby$elm_http_builder$HttpBuilder$post(url)))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Tasks$Apple$Claim$Model$Creating = {$: 'Creating'};
var $author$project$Tasks$Apple$Claim$Model$locationStateFromString = F2(
	function (state, message) {
		switch (state) {
			case 'readyToCreate':
				return $author$project$Tasks$Apple$Claim$Model$ReadyToCreate;
			case 'creating':
				return $author$project$Tasks$Apple$Claim$Model$Creating;
			case 'created':
				return $author$project$Tasks$Apple$Claim$Model$Created;
			case 'failedToCreate':
				return $author$project$Tasks$Apple$Claim$Model$FailedToCreate(message);
			default:
				return $author$project$Tasks$Apple$Claim$Model$ReadyToCreate;
		}
	});
var $author$project$Translations$Listings$Claim$createLocationRequestNotification = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.create_location_request_notification');
};
var $author$project$Tasks$Apple$Claim$Update$createLocationNetwrokResponseDecoder = $elm$json$Json$Decode$decodeValue(
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (locationId, networkErrorMessage, state) {
					return {state: state, locationId: locationId, networkErrorMessage: networkErrorMessage};
				}),
			A2($elm$json$Json$Decode$field, 'locationId', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'networkErrorMessage', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'state', $elm$json$Json$Decode$string))));
var $author$project$Tasks$Apple$Claim$Update$update = F3(
	function (session, msg, model) {
		var modelClearedNotifications = $author$project$Tasks$Apple$Claim$Update$emptyNotification(model);
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Apple$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Apple$Claim$Model$UiPopOverMsg, msg_, model.uiPopover));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							modelClearedNotifications,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var updatedModel = A3(
						$author$project$Tasks$Apple$Claim$Update$updateNotification,
						$author$project$Tasks$Apple$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(session.translations),
						model);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								allCategories: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.GotAllCategories',
								message: 'Failed to decode response GotAllCategories'
							}));
				}
			case 'GotSyncStatus':
				if (msg.a.$ === 'Ok') {
					var result = msg.a.a;
					return result.running ? _Utils_Tuple2(
						_Utils_update(
							model,
							{syncStatus: $author$project$Tasks$Apple$Claim$Model$Running, syncStartedAt: result.startedAt, syncEstimatedItemCount: result.itemCount}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.GotSyncStatus',
								message: 'Failed to load sync status'
							}));
				}
			case 'SelectedPrimaryCategory':
				var category = msg.a;
				return A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					model.additionalCategoriesList) ? _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{
							primaryCategory: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'AddAdditionalCategory':
				var newSelection = A2(
					$elm$core$List$append,
					model.additionalCategoriesList,
					$elm$core$List$singleton($elm$core$Maybe$Nothing));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newSelection}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedAdditionalCategory':
				var category = msg.a;
				var index = msg.b;
				var primaryCategory = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (cat) {
						return $elm$core$List$singleton(
							$elm$core$Maybe$Just(cat));
					},
					model.primaryCategory);
				var newAdditional = A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					A2($elm$core$List$append, model.additionalCategoriesList, primaryCategory)) ? model.additionalCategoriesList : A2(
					$elm$core$List$append,
					A2(
						$elm$core$List$append,
						A2($elm$core$List$take, index, model.additionalCategoriesList),
						$elm$core$List$singleton(
							$elm$core$Maybe$Just(category))),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				var newAdditional = A2(
					$elm$core$List$append,
					A2($elm$core$List$take, index, model.additionalCategoriesList),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'SaveCategories':
				return $author$project$Tasks$Apple$Claim$Update$areCategoriesSelected(model) ? _Utils_Tuple2(
					modelClearedNotifications,
					A3($author$project$Tasks$Apple$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Apple$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					var _v1 = success ? _Utils_Tuple2(
						$author$project$Tasks$Apple$Claim$Model$Success,
						$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
						$author$project$Tasks$Apple$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
					var notificationState = _v1.a;
					var notificationMessage = _v1.b;
					return _Utils_Tuple2(
						A3($author$project$Tasks$Apple$Claim$Update$updateNotification, notificationState, notificationMessage, model),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					return _Utils_Tuple2(
						A3($author$project$Tasks$Apple$Claim$Update$updateNotification, $author$project$Tasks$Apple$Claim$Model$Failed, message, model),
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Tasks.Apple.Claim.Update.SaveCategoriesResult', message: 'Failed to decode response SaveCategoriesResult'}));
				}
			case 'GetLocationsToBeCreated':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationsToBeCreated: $author$project$RemoteData$Loaded(locations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationsToBeCreated: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.GetLocationsToBeCreated',
								message: 'Failed to decode response GetLocationsToBeCreated'
							}));
				}
			case 'FilterLocationsToCreate':
				var locationFilter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: locationFilter}),
					$elm$core$Platform$Cmd$none);
			case 'CreateLocations':
				var notificationAlert = $elm$core$Maybe$Just(
					{
						state: $author$project$Tasks$Apple$Claim$Model$Info,
						message: $author$project$Translations$Listings$Claim$createLocationRequestNotification(session.translations)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{createLocationsNotification: notificationAlert}),
					A3($author$project$Tasks$Apple$Claim$Commands$createLocations, session.siteName, model, $author$project$Tasks$Apple$Claim$Model$CreateLocationsResponse));
			case 'CreateLocationsResponse':
				if (msg.a.$ === 'Ok') {
					var selectedLocations = A2(
						$elm$core$List$filter,
						function (location) {
							return A2(
								$elm$core$List$member,
								location.location.id,
								$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
						},
						$author$project$Tasks$Apple$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
					var updatedLocationsData = function () {
						var _v2 = model.locationsToBeCreated;
						if (_v2.$ === 'Loaded') {
							var locationsData = _v2.a;
							return $author$project$RemoteData$Loaded(
								A2(
									$elm$core$List$map,
									function (location) {
										return A2(
											$elm$core$List$member,
											location.location.id,
											A2(
												$elm$core$List$map,
												function (selectedLocation) {
													return selectedLocation.location.id;
												},
												selectedLocations)) ? _Utils_update(
											location,
											{selectedBusiness: $elm$core$Maybe$Nothing}) : location;
									},
									locationsData));
						} else {
							return model.locationsToBeCreated;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{locationsToBeCreated: updatedLocationsData}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var notificationAlert = $elm$core$Maybe$Just(
						{
							state: $author$project$Tasks$Apple$Claim$Model$Failed,
							message: $author$project$PinMeTo$ExpectJson$getErrorMessage(err)
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{createLocationsNotification: notificationAlert}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.CreateLocationsResponse',
								message: 'Failed to decode response CreateLocationsResponse'
							}));
				}
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'MatchLocationNetworkTable':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							matchLocationNetworkTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.matchLocationNetworkTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'MatchLocationPMTTable':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							matchLocationPMTTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.matchLocationPMTTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnMatchLocationNetworkDataSelect':
				var id = msg.a;
				var newSelectedNetworkLocation = _Utils_eq(
					model.selectedNetworkLocation,
					$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedNetworkLocation: newSelectedNetworkLocation}),
					$elm$core$Platform$Cmd$none);
			case 'SwitchCreateLocationsTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: '', createLocationsTab: tab}),
					$elm$core$Platform$Cmd$none);
			case 'GetBusinesses':
				if (msg.a.$ === 'Ok') {
					var businesses = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businesses: $author$project$RemoteData$Loaded(businesses)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businesses: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err)),
								createLocationsNotification: $elm$core$Maybe$Just(
									{
										state: $author$project$Tasks$Apple$Claim$Model$Failed,
										message: $author$project$Translations$Listings$LocationDetail$PopUpContent$failedGettingData(session.translations)
									})
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.GetBusinesses',
								message: 'Failed to decode response GetBusinesses'
							}));
				}
			case 'SelectedBusiness':
				var business = msg.a;
				var selectedLocations = msg.b;
				var selectedLocaionIds = A2(
					$elm$core$List$map,
					function (location) {
						return location.location.id;
					},
					selectedLocations);
				var updatedLocationsData = function () {
					var _v3 = model.locationsToBeCreated;
					if (_v3.$ === 'Loaded') {
						var locationsData = _v3.a;
						return $author$project$RemoteData$Loaded(
							A2(
								$elm$core$List$map,
								function (location) {
									return A2($elm$core$List$member, location.location.id, selectedLocaionIds) ? _Utils_update(
										location,
										{
											selectedBusiness: $elm$core$Maybe$Just(business)
										}) : location;
								},
								locationsData));
					} else {
						return model.locationsToBeCreated;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationsToBeCreated: updatedLocationsData}),
					$elm$core$Platform$Cmd$none);
			case 'HandleCreateLocationsNetworkResponse':
				var value = msg.a;
				var updateLocation = F2(
					function (location, networkResponse) {
						var _v6 = $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (x) {
									return _Utils_eq(x.locationId, location.location.id);
								},
								networkResponse));
						if (_v6.$ === 'Just') {
							var networkErrorMessage = _v6.a.networkErrorMessage;
							var state = _v6.a.state;
							return _Utils_update(
								location,
								{
									state: A2($author$project$Tasks$Apple$Claim$Model$locationStateFromString, state, networkErrorMessage)
								});
						} else {
							return location;
						}
					});
				var updateLocationsData = function (networkResponse) {
					var _v5 = model.locationsToBeCreated;
					if (_v5.$ === 'Loaded') {
						var locationsData = _v5.a;
						return $author$project$RemoteData$Loaded(
							A2(
								$elm$core$List$map,
								function (location) {
									return A2(updateLocation, location, networkResponse);
								},
								locationsData));
					} else {
						return model.locationsToBeCreated;
					}
				};
				var _v4 = $author$project$Tasks$Apple$Claim$Update$createLocationNetwrokResponseDecoder(value);
				if (_v4.$ === 'Ok') {
					var networkResponse = _v4.a;
					var updatedLocationsData = updateLocationsData(networkResponse);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{locationsToBeCreated: updatedLocationsData}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'SyncLocations':
				var newModel = _Utils_update(
					model,
					{syncStatus: $author$project$Tasks$Apple$Claim$Model$Running, locationsToBeCreated: $author$project$RemoteData$Loading, appleNotMatchedLocations: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$Apple$Claim$Commands$syncLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$SendSyncLocations),
								A2($elm$core$Task$perform, $author$project$Tasks$Apple$Claim$Model$GotSyncStartTime, $elm$time$Time$now)
							])));
			case 'GotSyncStartTime':
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							syncStartedAt: $elm$core$Maybe$Just(time)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SyncProgressTick':
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							syncNow: $elm$core$Maybe$Just(time)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SendSyncLocations':
				if (msg.a.$ === 'Ok') {
					var itemCount = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{syncEstimatedItemCount: itemCount}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								syncStatus: $author$project$Tasks$Apple$Claim$Model$SyncError(
									$author$project$RequestError$getErrorMessage(err)),
								syncStartedAt: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Tasks$Apple$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated),
									A2($author$project$Tasks$Apple$Claim$Commands$getAppleNotMatchedLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations)
								])));
				}
			case 'SocketSyncLocations':
				var lastRun = msg.a;
				var newModel = _Utils_update(
					model,
					{
						syncStatus: $author$project$Tasks$Apple$Claim$Model$Idle,
						syncStartedAt: $elm$core$Maybe$Nothing,
						locationsToBeCreated: $author$project$RemoteData$Loading,
						syncLocationsLastRun: $elm$core$Maybe$Just(lastRun),
						appleNotMatchedLocations: $author$project$RemoteData$Loading
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$Apple$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated),
								A2($author$project$Tasks$Apple$Claim$Commands$getAppleNotMatchedLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations),
								A2($author$project$Tasks$Apple$Claim$Commands$getBusinesses, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetBusinesses)
							])));
			case 'RepublishLocations':
				var newModel = _Utils_update(
					model,
					{syncStatus: $author$project$Tasks$Apple$Claim$Model$Running, locationsToBeCreated: $author$project$RemoteData$Loading, appleNotMatchedLocations: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$Apple$Claim$Commands$republishLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$SendRepublishLocations),
								A2($elm$core$Task$perform, $author$project$Tasks$Apple$Claim$Model$GotSyncStartTime, $elm$time$Time$now)
							])));
			case 'SendRepublishLocations':
				if (msg.a.$ === 'Ok') {
					var itemCount = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{syncEstimatedItemCount: itemCount}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								syncStatus: $author$project$Tasks$Apple$Claim$Model$SyncError(
									$author$project$RequestError$getErrorMessage(err)),
								syncStartedAt: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Tasks$Apple$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated),
									A2($author$project$Tasks$Apple$Claim$Commands$getAppleNotMatchedLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations)
								])));
				}
			case 'SocketRepublishLocations':
				var lastRun = msg.a;
				var newModel = _Utils_update(
					model,
					{
						syncStatus: $author$project$Tasks$Apple$Claim$Model$Idle,
						syncStartedAt: $elm$core$Maybe$Nothing,
						locationsToBeCreated: $author$project$RemoteData$Loading,
						syncLocationsLastRun: $elm$core$Maybe$Just(lastRun),
						appleNotMatchedLocations: $author$project$RemoteData$Loading
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$Apple$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetLocationsToBeCreated),
								A2($author$project$Tasks$Apple$Claim$Commands$getAppleNotMatchedLocations, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations),
								A2($author$project$Tasks$Apple$Claim$Commands$getBusinesses, session.siteName, $author$project$Tasks$Apple$Claim$Model$GetBusinesses)
							])));
			case 'ResetSyncLock':
				return _Utils_Tuple2(
					model,
					A2($author$project$Tasks$Apple$Claim$Commands$resetSyncLock, session.siteName, $author$project$Tasks$Apple$Claim$Model$SendResetSyncLock));
			case 'SendResetSyncLock':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{syncStatus: $author$project$Tasks$Apple$Claim$Model$Idle, syncStartedAt: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$RequestError$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.SendResetSyncLock',
								message: 'Failed to reset sync lock'
							}));
				}
			case 'ConnectLocations':
				var pinmetoId = msg.a;
				var appleId = msg.b;
				var appleNotMatchedLocations = function () {
					var _v8 = model.appleNotMatchedLocations;
					if (_v8.$ === 'Loaded') {
						var locationsData = _v8.a;
						return $author$project$RemoteData$Loaded(
							A2(
								$elm$core$List$filter,
								function (location) {
									return !_Utils_eq(location.id, appleId);
								},
								locationsData));
					} else {
						return model.appleNotMatchedLocations;
					}
				}();
				var locationsToBeCreated = function () {
					var _v7 = model.locationsToBeCreated;
					if (_v7.$ === 'Loaded') {
						var locationsData = _v7.a;
						return $author$project$RemoteData$Loaded(
							A2(
								$elm$core$List$filter,
								function (location) {
									return !_Utils_eq(location.location.id, pinmetoId);
								},
								locationsData));
					} else {
						return model.locationsToBeCreated;
					}
				}();
				var newModel = _Utils_update(
					model,
					{locationsToBeCreated: locationsToBeCreated, appleNotMatchedLocations: appleNotMatchedLocations});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Tasks$Apple$Claim$Commands$connectLocations,
								session.siteName,
								_List_fromArray(
									[
										{appleId: appleId, locationId: pinmetoId}
									]),
								$author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations)
							])));
			case 'GetAppleNotMatchedLocations':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								suggestedMatches: $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function (loc) {
											return loc.id;
										},
										locations)),
								appleNotMatchedLocations: $author$project$RemoteData$Loaded(locations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appleNotMatchedLocations: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Apple.Claim.Update.GetAppleNotMatchedLocations',
								message: 'Failed to decode response GetAppleNotMatchedLocations'
							}));
				}
			case 'ToggleSuggestedMatch':
				var locationMatch = msg.a;
				var newSuggestedMatches = A2($elm$core$Set$member, locationMatch, model.suggestedMatches) ? A2($elm$core$Set$remove, locationMatch, model.suggestedMatches) : A2($elm$core$Set$insert, locationMatch, model.suggestedMatches);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{suggestedMatches: newSuggestedMatches}),
					$elm$core$Platform$Cmd$none);
			case 'ConfirmSuggestedMatches':
				var matches = msg.a;
				var appleNotMatchedLocations = function () {
					var _v10 = model.appleNotMatchedLocations;
					if (_v10.$ === 'Loaded') {
						var locationsData = _v10.a;
						return $author$project$RemoteData$Loaded(
							A2(
								$elm$core$List$filter,
								function (location) {
									return !A2(
										$elm$core$List$member,
										location.id,
										A2(
											$elm$core$List$map,
											function (match) {
												return match.appleId;
											},
											matches));
								},
								locationsData));
					} else {
						return model.appleNotMatchedLocations;
					}
				}();
				var locationsToBeCreated = function () {
					var _v9 = model.locationsToBeCreated;
					if (_v9.$ === 'Loaded') {
						var locationsData = _v9.a;
						return $author$project$RemoteData$Loaded(
							A2(
								$elm$core$List$filter,
								function (location) {
									return !A2(
										$elm$core$List$member,
										location.location.id,
										A2(
											$elm$core$List$map,
											function (match) {
												return match.locationId;
											},
											matches));
								},
								locationsData));
					} else {
						return model.locationsToBeCreated;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationsToBeCreated: locationsToBeCreated, appleNotMatchedLocations: appleNotMatchedLocations}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Tasks$Apple$Claim$Commands$connectLocations, session.siteName, matches, $author$project$Tasks$Apple$Claim$Model$GetAppleNotMatchedLocations)
							])));
			default:
				var notificationAlert = $elm$core$Maybe$Just(
					{
						state: $author$project$Tasks$Apple$Claim$Model$Info,
						message: $author$project$Translations$Listings$Claim$createLocationRequestNotification(session.translations)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{createLocationsNotification: notificationAlert}),
					A3($author$project$Tasks$Apple$Claim$Commands$createNonOauthLocations, session.siteName, model, $author$project$Tasks$Apple$Claim$Model$CreateLocationsResponse));
		}
	});
var $author$project$Insights$Apple$Model$SYSTEM = {$: 'SYSTEM'};
var $author$project$Tasks$Apple$Claim$Commands$isDevDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$eq('dev'),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['pmtEnv', 'env']),
				$elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed(false)
		]));
var $author$project$Tasks$Apple$Claim$Commands$flagsCategoriesDecoder = function () {
	var decodeAdditional = A2(
		$elm$json$Json$Decode$field,
		'additionalCategories',
		$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodeAdditionalCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodeAdditional);
	var decodePrimary = $elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'primaryCategory', $author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodePrimaryCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodePrimary);
	return A2(
		$elm$json$Json$Decode$field,
		'categories',
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (primary, additional) {
					return {
						primaryCategory: primary,
						additionalCategories: A2($elm$core$List$map, $elm$core$Maybe$Just, additional)
					};
				}),
			decodePrimaryCommon,
			decodeAdditionalCommon));
}();
var $author$project$Tasks$Apple$Claim$Commands$flagsDecoder = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (categories, lastRun, appleConnectionType, isDev) {
			return {isDev: isDev, categories: categories, appleConnectionType: appleConnectionType, syncLocationsLastRun: lastRun};
		}),
	$author$project$Tasks$Apple$Claim$Commands$flagsCategoriesDecoder,
	A2(
		$elm$json$Json$Decode$field,
		'lastRun',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'appleConnectionType',
		A2(
			$elm$json$Json$Decode$andThen,
			function (x) {
				switch (x) {
					case 'oauth':
						return $elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$OAUTH);
					case 'system':
						return $elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$SYSTEM);
					default:
						return $elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$SYSTEM);
				}
			},
			$elm$json$Json$Decode$string)),
	$author$project$Tasks$Apple$Claim$Commands$isDevDecoder);
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 'Every', a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {taggers: taggers, processes: processes};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 'Nothing') {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.processes;
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(_Utils_Tuple0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.taggers);
		if (_v0.$ === 'Nothing') {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Tasks$Apple$Claim$Model$SyncProgressTick = function (a) {
	return {$: 'SyncProgressTick', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$SocketSyncLocations = function (a) {
	return {$: 'SocketSyncLocations', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$SocketRepublishLocations = function (a) {
	return {$: 'SocketRepublishLocations', a: a};
};
var $author$project$Tasks$Apple$Claim$Model$HandleCreateLocationsNetworkResponse = function (a) {
	return {$: 'HandleCreateLocationsNetworkResponse', a: a};
};
var $author$project$Tasks$Apple$Claim$Main$in_Tasks_Apple_Claim_Main_networkStatus = _Platform_incomingPort('in_Tasks_Apple_Claim_Main_networkStatus', $elm$json$Json$Decode$value);
var $author$project$Tasks$Apple$Claim$Main$in_Tasks_Apple_Claim_Main_syncLocations = _Platform_incomingPort('in_Tasks_Apple_Claim_Main_syncLocations', $elm$json$Json$Decode$string);
var $author$project$Tasks$Apple$Claim$Main$in_Tasks_Apple_Claim_Main_republishLocations = _Platform_incomingPort('in_Tasks_Apple_Claim_Main_republishLocations', $elm$json$Json$Decode$string);
var $author$project$Tasks$Apple$Claim$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Tasks$Apple$Claim$Main$in_Tasks_Apple_Claim_Main_networkStatus($author$project$Tasks$Apple$Claim$Model$HandleCreateLocationsNetworkResponse),
				$author$project$Tasks$Apple$Claim$Main$in_Tasks_Apple_Claim_Main_syncLocations($author$project$Tasks$Apple$Claim$Model$SocketSyncLocations),
				$author$project$Tasks$Apple$Claim$Main$in_Tasks_Apple_Claim_Main_republishLocations($author$project$Tasks$Apple$Claim$Model$SocketRepublishLocations),
				A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Tasks$Apple$Claim$Model$UiTableMsg, model.uiTable),
				_Utils_eq(model.syncStatus, $author$project$Tasks$Apple$Claim$Model$Running) ? A2($elm$time$Time$every, 1000, $author$project$Tasks$Apple$Claim$Model$SyncProgressTick) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Tasks$Apple$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$Apple$Claim$Main$init,
		view: function (session) {
			return $author$project$Tasks$Apple$Claim$View$view(session);
		},
		update: $author$project$Tasks$Apple$Claim$Update$update,
		flagsDecoder: $author$project$Tasks$Apple$Claim$Commands$flagsDecoder,
		subscriptions: $author$project$Tasks$Apple$Claim$Main$subscriptions
	});
var $author$project$Listings$Ui$Feedback$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Listings$Ui$Feedback$InactiveModal = {$: 'InactiveModal'};
var $author$project$Listings$Ui$Feedback$init = $author$project$Listings$Ui$Feedback$State(
	{modal: $author$project$Listings$Ui$Feedback$InactiveModal, uiTextarea: $author$project$PinMeTo$Ui$Form$Textarea$init});
var $author$project$Listings$Ui$PresetDateRangePicker$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$init = function (date) {
	return _Utils_Tuple2(
		$author$project$Listings$Ui$PresetDateRangePicker$State(
			{date: date, uiSelect: $author$project$PinMeTo$Ui$Select$init}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Tours$InsightsRedesign$endDate = '2025-07-09';
var $author$project$Translations$General$skip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.skip');
};
var $author$project$Labels$tourLabels = function (translations) {
	return {
		nextButton: $author$project$Translations$General$next(translations),
		skipButton: $author$project$Translations$General$skip(translations)
	};
};
var $author$project$PinMeTo$Ports$pmtUiTourSetSeenCookie = _Platform_outgoingPort(
	'pmtUiTourSetSeenCookie',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tourId',
					$elm$json$Json$Encode$string($.tourId)),
					_Utils_Tuple2(
					'endDate',
					$elm$json$Json$Encode$string($.endDate))
				]));
	});
var $author$project$PinMeTo$Common$Tour$Tour$markCompleted = F2(
	function (tourId, tourEndDate) {
		return $author$project$PinMeTo$Ports$pmtUiTourSetSeenCookie(
			{tourId: tourId, endDate: tourEndDate});
	});
var $author$project$Tours$InsightsRedesign$breadCrumbTourId = 'insights-redesign-breadcrumb';
var $author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack = F2(
	function (date, days) {
		return {
			to: date,
			from: A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Days, -(days - 1), date)
		};
	});
var $author$project$Insights$Overview$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Insights$Overview$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Tours$InsightsRedesign$startDate = '2024-10-21';
var $author$project$PinMeTo$Common$Tour$Tour$RightStart = {$: 'RightStart'};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewConfirm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.overview_confirm');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewTitleStepOne = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.overview_title_step_one');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewTitleStepTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.overview_title_step_two');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewDescriptionStepOne = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.overview_description_step_one');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewDescriptionStepTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.overview_description_step_two');
};
var $author$project$Tours$InsightsRedesign$insightsRedesignTourOverview = F2(
	function (translations, _v0) {
		var siteName = _v0.a;
		return {
			id: 'insights-redesign-overview',
			steps: _List_fromArray(
				[
					{
					arrow: true,
					title: $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewTitleStepOne(translations),
					classes: _List_fromArray(
						['']),
					mediaUrl: $elm$core$Maybe$Nothing,
					placement: $author$project$PinMeTo$Common$Tour$Tour$RightStart,
					description: $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewDescriptionStepOne(translations),
					targetElementQuery: '.pmt-ui-navigation-item--current.pmt-ui-navigation-item--parent'
				},
					{
					arrow: true,
					title: $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewTitleStepTwo(translations),
					classes: _List_fromArray(
						['']),
					mediaUrl: $elm$core$Maybe$Just('img/tour/insights_redesign_overview_step_2.gif'),
					placement: $author$project$PinMeTo$Common$Tour$Tour$RightStart,
					description: $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewDescriptionStepTwo(translations),
					targetElementQuery: '.pmt-ui-navigation-item--current.pmt-ui-navigation-item--parent'
				}
				]),
			endDate: $author$project$Tours$InsightsRedesign$endDate,
			startDate: $author$project$Tours$InsightsRedesign$startDate,
			useModalOverlay: false,
			confirmButtonUrl: $elm$core$Maybe$Just('/listings/' + (siteName + '/insights/rating')),
			requiresTourSeen: $elm$core$Maybe$Nothing,
			showStepProgress: true,
			confirmButtonLabel: $author$project$Translations$Listings$Tour$InsightsRedesignTour$overviewConfirm(translations),
			requiresTourNotSeen: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Insights$Overview$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var tourCmds = (!session.user.isDemo) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$PinMeTo$Common$Tour$Tour$markCompleted, $author$project$Tours$InsightsRedesign$breadCrumbTourId, $author$project$Tours$InsightsRedesign$endDate),
					A2(
					$author$project$PinMeTo$Common$Tour$Tour$startTour,
					$author$project$Labels$tourLabels(session.translations),
					A2($author$project$Tours$InsightsRedesign$insightsRedesignTourOverview, session.translations, session.siteName))
				])) : $elm$core$Platform$Cmd$none;
		var timezone = A2($elm$time$Time$customZone, flags.timezoneOffset, _List_Nil);
		var defaultFromDate = A3(
			$justinmimbs$date$Date$add,
			$justinmimbs$date$Date$Days,
			-28,
			A2($justinmimbs$date$Date$fromPosix, timezone, flags.today));
		var today = A2($justinmimbs$date$Date$fromPosix, timezone, flags.today);
		var dateRange = A2(
			$elm$core$Maybe$withDefault,
			{to: today, from: defaultFromDate},
			flags.dateRange);
		var validRanges = _List_fromArray(
			[
				A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack, today, 30),
				A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack, today, 90),
				A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack, today, 180),
				A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack, today, 365)
			]);
		var isValidDateRange = function (range) {
			return A2(
				$elm$core$List$any,
				$elm$core$Basics$eq(range),
				validRanges);
		};
		var selectedRange = isValidDateRange(dateRange) ? dateRange : A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack, today, 30);
		var presetDateRangePicker = $author$project$Listings$Ui$PresetDateRangePicker$init(today);
		var model = {
			range: selectedRange,
			today: flags.today,
			baseUrl: flags.url,
			topList: $author$project$RemoteData$Loading,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			timezone: timezone,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			locationId: flags.locationId,
			uiFeedback: $author$project$Listings$Ui$Feedback$init,
			insightsUrl: flags.insightsUrl,
			ratingStats: $author$project$RemoteData$Loading,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			actionMetrics: $author$project$RemoteData$Loading,
			initialFilter: flags.initialFilter,
			totalPageLikes: $author$project$RemoteData$Loading,
			filterController: $elm$core$Maybe$Just(filterControllerModel_),
			filterDefinition: $elm$core$Maybe$Nothing,
			visibilityMetrics: $author$project$RemoteData$Loading,
			topListAmountToShow: 5,
			comparativePageLikes: $author$project$RemoteData$Loading,
			presetDatePickerState: presetDateRangePicker.a,
			comparativeRatingStats: $author$project$RemoteData$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Overview$Model$FilterControllerMsg, filterControllerCmd_),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Overview$Model$DateRangePickerMsg, presetDateRangePicker.b),
						tourCmds
					])));
	});
var $author$project$RemoteData$map2 = F3(
	function (f, ra, rb) {
		switch (ra.$) {
			case 'Suspended':
				return $author$project$RemoteData$Suspended;
			case 'Loading':
				return $author$project$RemoteData$Loading;
			case 'Error':
				var a = ra.a;
				return $author$project$RemoteData$Error(a);
			default:
				var a = ra.a;
				switch (rb.$) {
					case 'Loaded':
						var b = rb.a;
						return $author$project$RemoteData$Loaded(
							A2(f, a, b));
					case 'Suspended':
						return $author$project$RemoteData$Suspended;
					case 'Loading':
						return $author$project$RemoteData$Loading;
					default:
						var b = rb.a;
						return $author$project$RemoteData$Error(b);
				}
		}
	});
var $author$project$Listings$Ui$PresetDateRangePicker$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$DaysBack = function (a) {
	return {$: 'DaysBack', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$defaultRanges = _List_fromArray(
	[
		$author$project$Listings$Ui$PresetDateRangePicker$DaysBack(30),
		$author$project$Listings$Ui$PresetDateRangePicker$DaysBack(90),
		$author$project$Listings$Ui$PresetDateRangePicker$DaysBack(180),
		$author$project$Listings$Ui$PresetDateRangePicker$DaysBack(365)
	]);
var $author$project$Listings$Ui$PresetDateRangePicker$view = function (config) {
	return $author$project$Listings$Ui$PresetDateRangePicker$View(
		{uid: config.uid, range: config.range, labels: config.labels, locale: config.locale, ranges: _List_Nil, tagger: config.tagger, language: config.language, defaultRanges: $author$project$Listings$Ui$PresetDateRangePicker$defaultRanges});
};
var $author$project$Insights$Overview$Model$getToDateLabel = function (model) {
	return $justinmimbs$date$Date$toIsoString(model.range.to);
};
var $author$project$PinMeTo$Ui$Trend$None = {$: 'None'};
var $author$project$Listings$Ui$Feedback$Id = function (a) {
	return {$: 'Id', a: a};
};
var $author$project$Listings$Ui$Feedback$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$Listings$Ui$Feedback$view = function (config) {
	return $author$project$Listings$Ui$Feedback$View(
		{
			id: $author$project$Listings$Ui$Feedback$Id(config.id),
			labels: config.labels,
			tagger: config.tagger,
			thumbsUpEvent: config.thumbsUpEvent,
			thumbsDownEvent: config.thumbsDownEvent
		});
};
var $author$project$Listings$Ui$Feedback$Negative = {$: 'Negative'};
var $author$project$Listings$Ui$Feedback$Positive = {$: 'Positive'};
var $author$project$Listings$Ui$Feedback$Form = F2(
	function (a, b) {
		return {$: 'Form', a: a, b: b};
	});
var $author$project$Listings$Ui$Feedback$OnChangeText = F3(
	function (a, b, c) {
		return {$: 'OnChangeText', a: a, b: b, c: c};
	});
var $author$project$Listings$Ui$Feedback$UiTextareaMsg = function (a) {
	return {$: 'UiTextareaMsg', a: a};
};
var $author$project$Listings$Ui$Feedback$formView = F4(
	function (labels, id, _v0, _v1) {
		var opinion = _v0.a;
		var textValue = _v0.b;
		var model = _v1.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-feedback__modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(labels.title)
						])),
					A3(
					$author$project$PinMeTo$Ui$Form$Textarea$render,
					$author$project$Listings$Ui$Feedback$UiTextareaMsg,
					model.uiTextarea,
					A2(
						$author$project$PinMeTo$Ui$Form$Textarea$withMinRows,
						3,
						A2(
							$author$project$PinMeTo$Ui$Form$Textarea$withAutoresize,
							5,
							A2(
								$author$project$PinMeTo$Ui$Form$Textarea$withPlaceholder,
								labels.placeholder,
								$author$project$PinMeTo$Ui$Form$Textarea$textarea(
									{
										value: textValue,
										onChange: A2(
											$author$project$Listings$Ui$Feedback$OnChangeText,
											id,
											A2($author$project$Listings$Ui$Feedback$Form, opinion, textValue))
									})))))
				]));
	});
var $author$project$Listings$Ui$Feedback$ModalClose = {$: 'ModalClose'};
var $author$project$Listings$Ui$Feedback$OnSubmit = F2(
	function (a, b) {
		return {$: 'OnSubmit', a: a, b: b};
	});
var $author$project$Listings$Ui$Feedback$actionsView = F3(
	function (labels, id, form) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-feedback__modal-footer')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Listings$Ui$Feedback$ModalClose,
						$author$project$PinMeTo$Ui$Button$buttonGhost(labels.cancel))),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						A2($author$project$Listings$Ui$Feedback$OnSubmit, id, form),
						$author$project$PinMeTo$Ui$Button$buttonPrimary(labels.submit)))
				]));
	});
var $author$project$Listings$Ui$Feedback$modalView = F2(
	function (config, model) {
		var _v0 = model.modal;
		switch (_v0.$) {
			case 'FormModal':
				var id = _v0.a;
				var _v1 = _v0.b;
				var opinion = _v1.a;
				var textValue = _v1.b;
				return _Utils_eq(id, config.id) ? $author$project$PinMeTo$Ui$Lightbox$render(
					$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withFooter,
							A3(
								$author$project$Listings$Ui$Feedback$actionsView,
								{cancel: config.labels.cancel, submit: config.labels.submit},
								id,
								A2($author$project$Listings$Ui$Feedback$Form, opinion, textValue)),
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withClose,
								$author$project$Listings$Ui$Feedback$ModalClose,
								$author$project$PinMeTo$Ui$Lightbox$view(
									{
										title: '',
										content: A4(
											$author$project$Listings$Ui$Feedback$formView,
											{title: config.labels.negativeFeedbackTitle, placeholder: config.labels.negativeFeedbackPlaceholder},
											id,
											A2($author$project$Listings$Ui$Feedback$Form, opinion, textValue),
											$author$project$Listings$Ui$Feedback$State(model))
									}))))) : $elm$html$Html$text('');
			case 'SendingModal':
				return $author$project$PinMeTo$Ui$Lightbox$render(
					$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
						$author$project$PinMeTo$Ui$Lightbox$view(
							{
								title: '',
								content: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-feedback__modal')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h1,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(config.labels.submitting)
												])),
											$author$project$PinMeTo$Ui$Spinner$spinner
										]))
							})));
			case 'ConfirmationModal':
				if (_v0.b.$ === 'Ok') {
					return $author$project$PinMeTo$Ui$Lightbox$render(
						$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withFooter,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-feedback__modal-footer')
										]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Button$render(
											A2(
												$author$project$PinMeTo$Ui$Button$withOnClick,
												$author$project$Listings$Ui$Feedback$ModalClose,
												$author$project$PinMeTo$Ui$Button$buttonPrimary(config.labels.close)))
										])),
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$Listings$Ui$Feedback$ModalClose,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{
											title: '',
											content: A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('ui-feedback__modal')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h1,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(config.labels.confirmationTitle)
															]))
													]))
										})))));
				} else {
					var id = _v0.a;
					var _v2 = _v0.b.a;
					var opinion = _v2.a;
					var data = _v2.b;
					return $author$project$PinMeTo$Ui$Lightbox$render(
						$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withFooter,
								A3(
									$author$project$Listings$Ui$Feedback$actionsView,
									{cancel: config.labels.cancel, submit: config.labels.submitAgain},
									id,
									A2($author$project$Listings$Ui$Feedback$Form, opinion, data)),
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$Listings$Ui$Feedback$ModalClose,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{
											title: '',
											content: function () {
												if (opinion.$ === 'Positive') {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('ui-feedback__modal')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h1,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(config.labels.generalError)
																	]))
															]));
												} else {
													return A4(
														$author$project$Listings$Ui$Feedback$formView,
														{title: config.labels.generalError, placeholder: ''},
														id,
														A2($author$project$Listings$Ui$Feedback$Form, opinion, data),
														$author$project$Listings$Ui$Feedback$State(model));
												}
											}()
										})))));
				}
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$FontAwesome$Light$Icon$faThumbsUp = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-thumbs-up');
var $author$project$FontAwesome$Solid$Icon$faThumbsUp = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-thumbs-up');
var $author$project$FontAwesome$Light$Icon$faThumbsDown = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-thumbs-down');
var $author$project$FontAwesome$Solid$Icon$faThumbsDown = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-thumbs-down');
var $author$project$Listings$Ui$Feedback$OnSubmitOpinion = F2(
	function (a, b) {
		return {$: 'OnSubmitOpinion', a: a, b: b};
	});
var $author$project$Listings$Ui$Feedback$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		var activeModalId = function () {
			var _v5 = model.modal;
			switch (_v5.$) {
				case 'FormModal':
					var id = _v5.a;
					return $elm$core$Maybe$Just(id);
				case 'ConfirmationModal':
					var id = _v5.a;
					return $elm$core$Maybe$Just(id);
				case 'SendingModal':
					var id = _v5.a;
					return $elm$core$Maybe$Just(id);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var activeOpinion = function () {
			if (_Utils_eq(
				activeModalId,
				$elm$core$Maybe$Just(config.id))) {
				var _v2 = model.modal;
				switch (_v2.$) {
					case 'FormModal':
						var _v3 = _v2.b;
						var opinion = _v3.a;
						return $elm$core$Maybe$Just(opinion);
					case 'ConfirmationModal':
						if (_v2.b.$ === 'Ok') {
							var opinion = _v2.b.a.opinion;
							return $elm$core$Maybe$Just(opinion);
						} else {
							var _v4 = _v2.b.a;
							var opinion = _v4.a;
							return $elm$core$Maybe$Just(opinion);
						}
					case 'SendingModal':
						var opinion = _v2.b;
						return $elm$core$Maybe$Just(opinion);
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var voteButton = F5(
			function (opinion, solidIcon, lightIcon, clickEvent, onClickMsg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ui-feedback__action-button'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'ui-feedback__action-button--active',
									_Utils_eq(
										activeOpinion,
										$elm$core$Maybe$Just(opinion))),
									_Utils_Tuple2(
									'ui-feedback__action-button--positive',
									_Utils_eq(opinion, $author$project$Listings$Ui$Feedback$Positive)),
									_Utils_Tuple2(
									'ui-feedback__action-button--negative',
									_Utils_eq(opinion, $author$project$Listings$Ui$Feedback$Negative))
								])),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(onClickMsg),
							$author$project$PinMeTo$Ui$Metrics$toAttribute(clickEvent)
						]),
					_List_fromArray(
						[
							_Utils_eq(
							activeOpinion,
							$elm$core$Maybe$Just(opinion)) ? $author$project$FontAwesome$Solid$Icon$render(solidIcon) : $author$project$FontAwesome$Light$Icon$render(lightIcon)
						]));
			});
		return A2(
			$elm$html$Html$map,
			config.tagger,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ui-feedback')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ui-feedback__actions')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ui-feedback__label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(config.labels.label)
									])),
								A4(
								$author$project$PinMeTo$Ui$Tooltip$tooltipBottom,
								config.labels.positiveTooltip,
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										A5(
										voteButton,
										$author$project$Listings$Ui$Feedback$Positive,
										$author$project$FontAwesome$Solid$Icon$faThumbsUp,
										$author$project$FontAwesome$Light$Icon$faThumbsUp,
										config.thumbsUpEvent,
										A2($author$project$Listings$Ui$Feedback$OnSubmitOpinion, config.id, $author$project$Listings$Ui$Feedback$Positive))
									])),
								A4(
								$author$project$PinMeTo$Ui$Tooltip$tooltipBottom,
								config.labels.negativeTooltip,
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										A5(
										voteButton,
										$author$project$Listings$Ui$Feedback$Negative,
										$author$project$FontAwesome$Solid$Icon$faThumbsDown,
										$author$project$FontAwesome$Light$Icon$faThumbsDown,
										config.thumbsDownEvent,
										A2($author$project$Listings$Ui$Feedback$OnSubmitOpinion, config.id, $author$project$Listings$Ui$Feedback$Negative))
									]))
							])),
						_Utils_eq(
						activeModalId,
						$elm$core$Maybe$Just(config.id)) ? A2($author$project$Listings$Ui$Feedback$modalView, config, model) : $elm$html$Html$text('')
					])));
	});
var $author$project$Insights$Overview$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Translations$Listings$Insights$feedbackNegativeLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.feedback_negative_label');
};
var $author$project$Translations$Listings$Insights$feedbackPositiveLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.feedback_positive_label');
};
var $author$project$Insights$Overview$View$Charts$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: '',
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Overview$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Listings$Ui$InsightsHeader$withAsides = F2(
	function (asides, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					asides: $elm$core$Maybe$Just(asides)
				}));
	});
var $author$project$PinMeTo$Ui$Trend$View = F4(
	function (a, b, c, d) {
		return {$: 'View', a: a, b: b, c: c, d: d};
	});
var $author$project$PinMeTo$Ui$Trend$Neutral = {$: 'Neutral'};
var $author$project$PinMeTo$Ui$Trend$epsilon = A2($elm$core$Basics$pow, 2, -52);
var $author$project$PinMeTo$Ui$Trend$Negative = {$: 'Negative'};
var $author$project$PinMeTo$Ui$Trend$Positive = {$: 'Positive'};
var $author$project$PinMeTo$Ui$Trend$OneDecimal = {$: 'OneDecimal'};
var $author$project$PinMeTo$Ui$Trend$view = function (value) {
	return (_Utils_cmp(
		$elm$core$Basics$abs(value),
		$author$project$PinMeTo$Ui$Trend$epsilon) < 1) ? A4($author$project$PinMeTo$Ui$Trend$View, $author$project$PinMeTo$Ui$Trend$Neutral, $author$project$PinMeTo$Ui$Trend$None, $author$project$PinMeTo$Ui$Trend$OneDecimal, value) : ((value > 0) ? A4($author$project$PinMeTo$Ui$Trend$View, $author$project$PinMeTo$Ui$Trend$Positive, $author$project$PinMeTo$Ui$Trend$None, $author$project$PinMeTo$Ui$Trend$OneDecimal, value) : A4($author$project$PinMeTo$Ui$Trend$View, $author$project$PinMeTo$Ui$Trend$Negative, $author$project$PinMeTo$Ui$Trend$None, $author$project$PinMeTo$Ui$Trend$OneDecimal, value));
};
var $author$project$PinMeTo$Ui$Trend$withUnit = F2(
	function (u, _v0) {
		var sign = _v0.a;
		var decimals = _v0.c;
		var value = _v0.d;
		return A4($author$project$PinMeTo$Ui$Trend$View, sign, u, decimals, value);
	});
var $author$project$PinMeTo$Ui$Trend$emDash = '—';
var $author$project$PinMeTo$Ui$Trend$renderMissingTrend = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('pmt-ui-trend'),
			$elm$html$Html$Attributes$class('pmt-ui-trend--disabled')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-trend__value')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$PinMeTo$Ui$Trend$emDash)
						]))
				]))
		]));
var $author$project$PinMeTo$Ui$Trend$withNumberOfDecimals = F2(
	function (n, _v0) {
		var sign = _v0.a;
		var unit = _v0.b;
		var value = _v0.d;
		return A4($author$project$PinMeTo$Ui$Trend$View, sign, unit, n, value);
	});
var $author$project$PinMeTo$Ui$Trend$renderSign = function (sign) {
	var signString = function () {
		switch (sign.$) {
			case 'Positive':
				return '+';
			case 'Negative':
				return '-';
			default:
				return '';
		}
	}();
	var rendered = function () {
		if (sign.$ === 'Neutral') {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(signString)
					]));
		}
	}();
	return rendered;
};
var $author$project$PinMeTo$Ui$Trend$unitToString = function (unit) {
	if (unit.$ === 'Percentage') {
		return '%';
	} else {
		return '';
	}
};
var $author$project$PinMeTo$Ui$Trend$abbreviateValue = F2(
	function (labels, value) {
		var oneThousand = A2($elm$core$Basics$pow, 10, 3);
		var oneMillion = A2($elm$core$Basics$pow, 10, 6);
		var oneBillion = A2($elm$core$Basics$pow, 10, 9);
		return (_Utils_cmp(
			$elm$core$Basics$abs(value),
			oneBillion) > -1) ? _Utils_Tuple2(value / oneBillion, labels.billions) : ((_Utils_cmp(
			$elm$core$Basics$abs(value),
			oneMillion) > -1) ? _Utils_Tuple2(value / oneMillion, labels.millions) : ((_Utils_cmp(
			$elm$core$Basics$abs(value),
			oneThousand) > -1) ? _Utils_Tuple2(value / oneThousand, labels.thousands) : _Utils_Tuple2(value, '')));
	});
var $author$project$PinMeTo$Ui$Trend$numDecimalsToInt = function (n) {
	switch (n.$) {
		case 'ZeroDecimals':
			return 0;
		case 'OneDecimal':
			return 1;
		default:
			return 2;
	}
};
var $author$project$PinMeTo$Ui$Trend$renderAbsoluteValue = F3(
	function (sign, numDecimals, value) {
		var num = $author$project$PinMeTo$Ui$Trend$numDecimalsToInt(numDecimals);
		return _Utils_eq(sign, $author$project$PinMeTo$Ui$Trend$Neutral) ? ((num > 0) ? A2($myrho$elm_round$Round$round, num, 0) : '0') : A2(
			$myrho$elm_round$Round$round,
			num,
			$elm$core$Basics$abs(value));
	});
var $author$project$PinMeTo$Ui$Trend$render = F2(
	function (labels, _v0) {
		var sign = _v0.a;
		var unit = _v0.b;
		var decimals = _v0.c;
		var value = _v0.d;
		var _v1 = A2($author$project$PinMeTo$Ui$Trend$abbreviateValue, labels, value);
		var adjustedValue = _v1.a;
		var abbrevation = _v1.b;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-trend'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'pmt-ui-trend--positive',
							_Utils_eq(sign, $author$project$PinMeTo$Ui$Trend$Positive)),
							_Utils_Tuple2(
							'pmt-ui-trend--negative',
							_Utils_eq(sign, $author$project$PinMeTo$Ui$Trend$Negative))
						]))
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Trend$renderSign(sign),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(
								A3($author$project$PinMeTo$Ui$Trend$renderAbsoluteValue, sign, decimals, adjustedValue),
								_Utils_ap(
									abbrevation,
									$author$project$PinMeTo$Ui$Trend$unitToString(unit))))
						]))
				]));
	});
var $author$project$Translations$General$Abbreviations$billions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbreviations.billions');
};
var $author$project$Translations$General$Abbreviations$millions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbreviations.millions');
};
var $author$project$Translations$General$Abbreviations$thousands = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.abbreviations.thousands');
};
var $author$project$Insights$Overview$View$MetricSection$renderTrendWithLabels = function (translations) {
	return $author$project$PinMeTo$Ui$Trend$render(
		{
			billions: $author$project$Translations$General$Abbreviations$billions(translations),
			millions: $author$project$Translations$General$Abbreviations$millions(translations),
			thousands: $author$project$Translations$General$Abbreviations$thousands(translations)
		});
};
var $author$project$Insights$Overview$View$MetricSection$renderTrend = F4(
	function (translations, numDec, unit, trend) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$Trend$renderMissingTrend,
			A2(
				$elm$core$Maybe$map,
				function (t) {
					return A2(
						$author$project$Insights$Overview$View$MetricSection$renderTrendWithLabels,
						translations,
						A2(
							$author$project$PinMeTo$Ui$Trend$withUnit,
							unit,
							A2(
								$author$project$PinMeTo$Ui$Trend$withNumberOfDecimals,
								numDec,
								$author$project$PinMeTo$Ui$Trend$view(t))));
				},
				trend));
	});
var $author$project$PinMeTo$Ui$Trend$ZeroDecimals = {$: 'ZeroDecimals'};
var $author$project$Insights$Overview$View$MetricSection$emptyCard = F4(
	function (session, model, title, map) {
		var emptyContent = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__fixed-height-footer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('-')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('-')
						]))
				]));
		var card = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Card$render(
					map(
						A2(
							$author$project$PinMeTo$Ui$Card$withHeader,
							$author$project$Listings$Ui$InsightsHeader$render(
								A2(
									$author$project$Listings$Ui$InsightsHeader$withAsides,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Insights$Overview$View$MetricSection$renderTrend,
												session.translations,
												$author$project$PinMeTo$Ui$Trend$ZeroDecimals,
												$author$project$PinMeTo$Ui$Trend$None,
												$elm$core$Maybe$Just(1337)),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
													]),
												_List_fromArray(
													[
														A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, '', model.uiFeedback)
													]))
											])),
									$author$project$Listings$Ui$InsightsHeader$view(
										{title: title}))),
							$author$project$PinMeTo$Ui$Card$view(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__fixed-height-footer')
										]),
									_List_fromArray(
										[emptyContent]))))))
				]));
		var config = {
			shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
			children: _List_fromArray(
				[card]),
			isLoading: true,
			attributes: _List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
				])
		};
		return $author$project$PinMeTo$Ui$Skeleton$view(config);
	});
var $author$project$Common$Math$formatNumber = function (n) {
	if (_Utils_cmp(
		n,
		A2($elm$core$Basics$pow, 10, 9)) > 0) {
		var value = n / A2($elm$core$Basics$pow, 10, 9);
		var rounded = A2($myrho$elm_round$Round$round, 1, value);
		return rounded + 'B';
	} else {
		if (_Utils_cmp(
			n,
			A2($elm$core$Basics$pow, 10, 6)) > 0) {
			var value = n / A2($elm$core$Basics$pow, 10, 6);
			var rounded = A2($myrho$elm_round$Round$round, 1, value);
			return rounded + 'M';
		} else {
			if (_Utils_cmp(
				n,
				A2($elm$core$Basics$pow, 10, 3)) > 0) {
				var value = n / A2($elm$core$Basics$pow, 10, 3);
				var rounded = A2($myrho$elm_round$Round$round, 1, value);
				return rounded + 'K';
			} else {
				return $elm$core$String$fromInt(n);
			}
		}
	}
};
var $author$project$Insights$Overview$Model$OnPopOver = F2(
	function (a, b) {
		return {$: 'OnPopOver', a: a, b: b};
	});
var $author$project$Translations$Listings$Insights$overviewToplistPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_toplist_popover');
};
var $author$project$Translations$Listings$Insights$overviewDatePickerPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_date_picker_popover');
};
var $author$project$Translations$Listings$Insights$overviewNewActionsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_new_actions_popover');
};
var $author$project$Translations$Listings$Insights$overviewRatingTrendPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_rating_trend_popover');
};
var $author$project$Translations$Listings$Insights$overviewResponseRatePopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_response_rate_popover');
};
var $author$project$Translations$Listings$Insights$overviewNewVisibilityPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_new_visibility_popover');
};
var $author$project$Translations$Listings$Insights$overviewLocalPageLikesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_local_page_likes_popover');
};
var $author$project$Insights$Overview$View$Charts$popOverConfig = F2(
	function (popOverConfigType, translations) {
		var _v0 = function () {
			switch (popOverConfigType.$) {
				case 'Visibility':
					return _Utils_Tuple2(
						'overview-visibility-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewNewVisibilityPopover(translations))
							]));
				case 'Actions':
					return _Utils_Tuple2(
						'overview-actions-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewNewActionsPopover(translations))
							]));
				case 'TopList':
					return _Utils_Tuple2(
						'overview-toplist-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewToplistPopover(translations))
							]));
				case 'RatingTrend':
					return _Utils_Tuple2(
						'overview-ratings-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewRatingTrendPopover(translations))
							]));
				case 'ResponseRate':
					return _Utils_Tuple2(
						'overview-response-rate-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewResponseRatePopover(translations))
							]));
				case 'LocalPageLikes':
					return _Utils_Tuple2(
						'overview-local-page-likes-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewLocalPageLikesPopover(translations))
							]));
				default:
					return _Utils_Tuple2(
						'overview-date-picker-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewDatePickerPopover(translations))
							]));
			}
		}();
		var uid = _v0.a;
		var content = _v0.b;
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: uid,
				tagger: $author$project$Insights$Overview$Model$OnPopOver(popOverConfigType),
				content: content,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $author$project$Insights$Overview$Model$LocalPageLikes = {$: 'LocalPageLikes'};
var $author$project$PinMeTo$Ui$Card$withLoadingStatus = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Card$View(
		_Utils_update(
			config,
			{status: $author$project$PinMeTo$Ui$Card$Loading}));
};
var $author$project$Translations$Listings$Insights$overviewPageLikesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_page_likes_title');
};
var $author$project$Translations$Listings$Insights$overviewPageLikesDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.overview_page_likes_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$PinMeTo$Ui$Trend$TwoDecimals = {$: 'TwoDecimals'};
var $author$project$Translations$Listings$Insights$overviewDateRange = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_date_range');
};
var $author$project$Translations$Listings$Insights$overviewNoDataFound = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_no_data_found');
};
var $author$project$FontAwesome$Light$Icon$faMagnifyingGlassWaveform = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-magnifying-glass-waveform');
var $author$project$Insights$Overview$View$MetricSection$renderHighlightCardNoDataState = F4(
	function (session, model, popOverConfigType, title) {
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--empty-state-icon')
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faMagnifyingGlassWaveform))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Insights$overviewNoDataFound(session.translations)),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									' ' + $author$project$Translations$Listings$Insights$overviewDateRange(session.translations))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Card$render(
					A2(
						$author$project$PinMeTo$Ui$Card$withHeader,
						$author$project$Listings$Ui$InsightsHeader$render(
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
										]),
									_List_fromArray(
										[
											A4($author$project$Insights$Overview$View$MetricSection$renderTrend, session.translations, $author$project$PinMeTo$Ui$Trend$TwoDecimals, $author$project$PinMeTo$Ui$Trend$None, $elm$core$Maybe$Nothing)
										])),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(
										A2($author$project$Insights$Overview$View$Charts$popOverConfig, popOverConfigType, session.translations),
										model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{title: title})))),
						$author$project$PinMeTo$Ui$Card$view(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__fixed-height-footer')
									]),
								_List_fromArray(
									[content])))))
				]));
	});
var $author$project$Translations$Listings$Insights$or = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.or');
};
var $author$project$FontAwesome$Light$Icon$faCloudXmark = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-cloud-xmark');
var $author$project$Translations$Listings$Insights$overviewNetworkNotEnabledNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_network_not_enabled_note');
};
var $author$project$Insights$Overview$View$MetricSection$renderHighlightCardNotConnectedState = F4(
	function (session, model, popOverConfigType, title) {
		var siteName = $author$project$Data$SiteName$toString(session.siteName);
		var directoriesLink = '/listings/' + (siteName + '/directories');
		var popOverConfigTypeToConnectNote = function (popOverConfigType_) {
			switch (popOverConfigType_.$) {
				case 'LocalPageLikes':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewNetworkNotEnabledNote(session.translations)),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(directoriesLink)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Facebook')
											]))
									]))
							]));
				case 'ResponseRate':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewNetworkNotEnabledNote(session.translations)),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(directoriesLink)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Google ')
											]))
									])),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$or(session.translations)),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(directoriesLink)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Trustpilot')
											]))
									]))
							]));
				case 'RatingTrend':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$overviewNetworkNotEnabledNote(session.translations)),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(directoriesLink)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Google ')
											]))
									])),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$or(session.translations)),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(directoriesLink)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Trustpilot')
											]))
									]))
							]));
				default:
					return $elm$html$Html$text('');
			}
		};
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--empty-state-icon')
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCloudXmark))
						])),
					popOverConfigTypeToConnectNote(popOverConfigType)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Card$render(
					A2(
						$author$project$PinMeTo$Ui$Card$withHeader,
						$author$project$Listings$Ui$InsightsHeader$render(
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'visibility', 'hidden')
										]),
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Trend$renderMissingTrend])),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(
										A2($author$project$Insights$Overview$View$Charts$popOverConfig, popOverConfigType, session.translations),
										model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{title: title})))),
						$author$project$PinMeTo$Ui$Card$view(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__fixed-height-footer')
									]),
								_List_fromArray(
									[content])))))
				]));
	});
var $author$project$Insights$Overview$View$MetricSection$renderPageLikes = F4(
	function (session, model, totalPageLikes, comparativePageLikes) {
		var shouldShowConnectCard = !_Utils_eq(session.analytics.facebook, $author$project$PinMeToPage$NetworkEnabled);
		var shouldHideCard = _Utils_eq(session.analytics.facebook, $author$project$PinMeToPage$NotVisible);
		if (shouldHideCard) {
			return $elm$html$Html$text('');
		} else {
			if (shouldShowConnectCard) {
				return A4(
					$author$project$Insights$Overview$View$MetricSection$renderHighlightCardNotConnectedState,
					session,
					model,
					$author$project$Insights$Overview$Model$LocalPageLikes,
					$author$project$Translations$Listings$Insights$overviewPageLikesTitle(session.translations));
			} else {
				switch (totalPageLikes.$) {
					case 'Loaded':
						if (totalPageLikes.a.$ === 'Just') {
							var totalPageLikes_ = totalPageLikes.a.a;
							var pageLikesNote = A2($author$project$Translations$Listings$Insights$overviewPageLikesDescription, session.translations, totalPageLikes_.key);
							var pageLikesContent = A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__fixed-height-footer')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--value')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Common$Math$formatNumber(totalPageLikes_.value))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(pageLikesNote)
											]))
									]));
							var trend = function () {
								if (comparativePageLikes.$ === 'Loaded') {
									var comparativePageLikes_ = comparativePageLikes.a;
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$toFloat,
										A3(
											$elm$core$Maybe$map2,
											F2(
												function (a, b) {
													return a.value - b.value;
												}),
											$elm$core$Maybe$Just(totalPageLikes_),
											comparativePageLikes_));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}();
							var asides = A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
									]),
								_List_fromArray(
									[
										A4($author$project$Insights$Overview$View$MetricSection$renderTrend, session.translations, $author$project$PinMeTo$Ui$Trend$ZeroDecimals, $author$project$PinMeTo$Ui$Trend$None, trend),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
											]),
										_List_fromArray(
											[
												A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, 'overview-insights-page-likes', model.uiFeedback)
											]))
									]));
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Card$render(
										A2(
											$author$project$PinMeTo$Ui$Card$withHeader,
											$author$project$Listings$Ui$InsightsHeader$render(
												A2(
													$author$project$Listings$Ui$InsightsHeader$withAsides,
													asides,
													A2(
														$author$project$Listings$Ui$InsightsHeader$withPopOver,
														_Utils_Tuple2(
															A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$LocalPageLikes, session.translations),
															model.popOverState),
														$author$project$Listings$Ui$InsightsHeader$view(
															{
																title: $author$project$Translations$Listings$Insights$overviewPageLikesTitle(session.translations)
															})))),
											$author$project$PinMeTo$Ui$Card$view(pageLikesContent)))
									]));
						} else {
							var _v2 = totalPageLikes.a;
							return A4(
								$author$project$Insights$Overview$View$MetricSection$renderHighlightCardNoDataState,
								session,
								model,
								$author$project$Insights$Overview$Model$LocalPageLikes,
								$author$project$Translations$Listings$Insights$overviewPageLikesTitle(session.translations));
						}
					case 'Loading':
						return A4($author$project$Insights$Overview$View$MetricSection$emptyCard, session, model, 'Local Page Likes', $author$project$PinMeTo$Ui$Card$withLoadingStatus);
					case 'Suspended':
						return A4($author$project$Insights$Overview$View$MetricSection$emptyCard, session, model, 'Local Page Likes', $author$project$PinMeTo$Ui$Card$withLoadingStatus);
					default:
						var e = totalPageLikes.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(e)
								]));
				}
			}
		}
	});
var $author$project$Insights$Overview$Model$RatingTrend = {$: 'RatingTrend'};
var $author$project$Translations$General$Insights$ratingTrend = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.rating_trend');
};
var $author$project$Translations$Listings$Insights$overviewRatingDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.overview_rating_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Overview$View$MetricSection$renderRatingStats = F4(
	function (session, model, ratingStats, comparativeStats) {
		var shouldShowConnectCard = (!_Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled)) && (!_Utils_eq(session.analytics.trustpilot, $author$project$PinMeToPage$NetworkEnabled));
		var shouldHideCard = _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NotVisible) && _Utils_eq(session.analytics.trustpilot, $author$project$PinMeToPage$NotVisible);
		if (shouldHideCard) {
			return $elm$html$Html$text('');
		} else {
			if (shouldShowConnectCard) {
				return A4(
					$author$project$Insights$Overview$View$MetricSection$renderHighlightCardNotConnectedState,
					session,
					model,
					$author$project$Insights$Overview$Model$RatingTrend,
					$author$project$Translations$General$Insights$ratingTrend(session.translations));
			} else {
				switch (ratingStats.$) {
					case 'Loaded':
						var ratingStats_ = ratingStats.a;
						var shouldShowEmptyState = _Utils_eq(ratingStats_.answeredCount, $elm$core$Maybe$Nothing) && _Utils_eq(ratingStats_.unansweredCount, $elm$core$Maybe$Nothing);
						if (shouldShowEmptyState) {
							return A4(
								$author$project$Insights$Overview$View$MetricSection$renderHighlightCardNoDataState,
								session,
								model,
								$author$project$Insights$Overview$Model$RatingTrend,
								$author$project$Translations$General$Insights$ratingTrend(session.translations));
						} else {
							var dateRange = model.range;
							var ratingNote = A2(
								$author$project$Translations$Listings$Insights$overviewRatingDescription,
								session.translations,
								$justinmimbs$date$Date$toIsoString(dateRange.to));
							var uiRating = A2(
								$author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage,
								function (_v2) {
									return '';
								},
								A2($elm$core$Maybe$withDefault, 0.0, ratingStats_.averageRating));
							var ratingContent = A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__fixed-height-footer')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--star-rating')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-insights__highlight--value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$myrho$elm_round$Round$round,
															2,
															A2($elm$core$Maybe$withDefault, 0.0, ratingStats_.averageRating)))
													])),
												uiRating
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(ratingNote)
											]))
									]));
							var trend = function () {
								if (comparativeStats.$ === 'Loaded') {
									var comparativeStats_ = comparativeStats.a;
									return A3($elm$core$Maybe$map2, $elm$core$Basics$sub, ratingStats_.averageRating, comparativeStats_.averageRating);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}();
							var asides = A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
									]),
								_List_fromArray(
									[
										A4($author$project$Insights$Overview$View$MetricSection$renderTrend, session.translations, $author$project$PinMeTo$Ui$Trend$TwoDecimals, $author$project$PinMeTo$Ui$Trend$None, trend),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
											]),
										_List_fromArray(
											[
												A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, 'overview-insights-rating-stats', model.uiFeedback)
											]))
									]));
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Card$render(
										A2(
											$author$project$PinMeTo$Ui$Card$withHeader,
											$author$project$Listings$Ui$InsightsHeader$render(
												A2(
													$author$project$Listings$Ui$InsightsHeader$withPopOver,
													_Utils_Tuple2(
														A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$RatingTrend, session.translations),
														model.popOverState),
													A2(
														$author$project$Listings$Ui$InsightsHeader$withAsides,
														asides,
														$author$project$Listings$Ui$InsightsHeader$view(
															{
																title: $author$project$Translations$General$Insights$ratingTrend(session.translations)
															})))),
											$author$project$PinMeTo$Ui$Card$view(ratingContent)))
									]));
						}
					case 'Loading':
						return A4($author$project$Insights$Overview$View$MetricSection$emptyCard, session, model, 'Rating Trend', $author$project$PinMeTo$Ui$Card$withLoadingStatus);
					case 'Suspended':
						return A4($author$project$Insights$Overview$View$MetricSection$emptyCard, session, model, 'Rating Trend', $author$project$PinMeTo$Ui$Card$withLoadingStatus);
					default:
						var e = ratingStats.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(e)
								]));
				}
			}
		}
	});
var $author$project$PinMeTo$Ui$Trend$Percentage = {$: 'Percentage'};
var $author$project$Insights$Overview$Model$ResponseRate = {$: 'ResponseRate'};
var $author$project$Translations$Listings$Insights$responseRate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.response_rate');
};
var $author$project$Translations$Listings$Insights$overviewResponseRateDescription = F4(
	function (translations, responseCount, reviewCount, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.overview_response_rate_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' responseCount ', responseCount),
					_Utils_Tuple2(' reviewCount ', reviewCount),
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Overview$View$MetricSection$renderResponseRate = F5(
	function (session, model, ratingStats, comparativeRatingStats, toDate) {
		var shouldShowConnectCard = !_Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled);
		var calculateResponseRate = F2(
			function (answered, total) {
				return (answered / ((!total) ? 1 : total)) * 100;
			});
		var ratingStatsToResponseRate = function (stats) {
			return A3(
				$elm$core$Maybe$map2,
				calculateResponseRate,
				stats.answeredCount,
				A3($elm$core$Maybe$map2, $elm$core$Basics$add, stats.answeredCount, stats.unansweredCount));
		};
		var shouldHideCard = _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NotVisible);
		if (shouldHideCard) {
			return $elm$html$Html$text('');
		} else {
			if (shouldShowConnectCard) {
				return A4(
					$author$project$Insights$Overview$View$MetricSection$renderHighlightCardNotConnectedState,
					session,
					model,
					$author$project$Insights$Overview$Model$ResponseRate,
					$author$project$Translations$Listings$Insights$responseRate(session.translations));
			} else {
				switch (ratingStats.$) {
					case 'Loaded':
						var ratingStats_ = ratingStats.a;
						var shouldShowEmptyState = _Utils_eq(ratingStats_.answeredCount, $elm$core$Maybe$Nothing) && _Utils_eq(ratingStats_.unansweredCount, $elm$core$Maybe$Nothing);
						if (shouldShowEmptyState) {
							return A4(
								$author$project$Insights$Overview$View$MetricSection$renderHighlightCardNoDataState,
								session,
								model,
								$author$project$Insights$Overview$Model$ResponseRate,
								$author$project$Translations$Listings$Insights$responseRate(session.translations));
						} else {
							var answeredCount = A2($elm$core$Maybe$withDefault, 0, ratingStats_.answeredCount);
							var totalReviews = A2(
								$elm$core$Maybe$withDefault,
								0,
								A3($elm$core$Maybe$map2, $elm$core$Basics$add, ratingStats_.answeredCount, ratingStats_.unansweredCount));
							var responseRateNote = A4(
								$author$project$Translations$Listings$Insights$overviewResponseRateDescription,
								session.translations,
								$author$project$Common$Math$formatNumber(answeredCount),
								$author$project$Common$Math$formatNumber(totalReviews),
								toDate);
							var responseRateString = (!totalReviews) ? ' - ' : function (n) {
								return n + ' %';
							}(
								A2(
									$myrho$elm_round$Round$round,
									1,
									A2(calculateResponseRate, answeredCount, totalReviews)));
							var responseRateContent = A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--value')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(responseRateString)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(responseRateNote)
											]))
									]));
							var trend = function () {
								if (comparativeRatingStats.$ === 'Loaded') {
									var comparativeRatingStats_ = comparativeRatingStats.a;
									return A3(
										$elm$core$Maybe$map2,
										$elm$core$Basics$sub,
										ratingStatsToResponseRate(ratingStats_),
										ratingStatsToResponseRate(comparativeRatingStats_));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}();
							var asides = A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
									]),
								_List_fromArray(
									[
										A4($author$project$Insights$Overview$View$MetricSection$renderTrend, session.translations, $author$project$PinMeTo$Ui$Trend$OneDecimal, $author$project$PinMeTo$Ui$Trend$Percentage, trend),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
											]),
										_List_fromArray(
											[
												A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, 'overview-insights-response-rate', model.uiFeedback)
											]))
									]));
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Card$render(
										A2(
											$author$project$PinMeTo$Ui$Card$withHeader,
											$author$project$Listings$Ui$InsightsHeader$render(
												A2(
													$author$project$Listings$Ui$InsightsHeader$withAsides,
													asides,
													A2(
														$author$project$Listings$Ui$InsightsHeader$withPopOver,
														_Utils_Tuple2(
															A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$ResponseRate, session.translations),
															model.popOverState),
														$author$project$Listings$Ui$InsightsHeader$view(
															{
																title: $author$project$Translations$Listings$Insights$responseRate(session.translations)
															})))),
											$author$project$PinMeTo$Ui$Card$view(responseRateContent)))
									]));
						}
					case 'Loading':
						return A4($author$project$Insights$Overview$View$MetricSection$emptyCard, session, model, 'Response Rate', $author$project$PinMeTo$Ui$Card$withLoadingStatus);
					case 'Suspended':
						return A4($author$project$Insights$Overview$View$MetricSection$emptyCard, session, model, 'Response Rate', $author$project$PinMeTo$Ui$Card$withLoadingStatus);
					default:
						var e = ratingStats.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(e)
								]));
				}
			}
		}
	});
var $author$project$Insights$Overview$View$MetricSection$renderHighlights = F3(
	function (session, model, toDateLabel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--container')
				]),
			_List_fromArray(
				[
					A4($author$project$Insights$Overview$View$MetricSection$renderRatingStats, session, model, model.ratingStats, model.comparativeRatingStats),
					A5($author$project$Insights$Overview$View$MetricSection$renderResponseRate, session, model, model.ratingStats, model.comparativeRatingStats, toDateLabel),
					A4($author$project$Insights$Overview$View$MetricSection$renderPageLikes, session, model, model.totalPageLikes, model.comparativePageLikes)
				]));
	});
var $author$project$Insights$Overview$Model$Actions = {$: 'Actions'};
var $author$project$Insights$Overview$View$Charts$titleToInt = function (title) {
	switch (title) {
		case 'Google':
			return 0;
		case 'Facebook':
			return 1;
		case 'Apple':
			return 2;
		case 'Bing':
			return 3;
		default:
			return 1000;
	}
};
var $author$project$Listings$Ui$InsightsHeader$withNumber = F2(
	function (number, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					number: $elm$core$Maybe$Just(number)
				}));
	});
var $author$project$Insights$Utils$metricTotal = function (metricData) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return acc + A2($elm$core$Maybe$withDefault, 0, x.value);
			}),
		0,
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.data;
			},
			metricData));
};
var $author$project$Translations$Listings$Insights$actionsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.actions_title');
};
var $author$project$PinMeTo$Ui$Chart$Area = function (a) {
	return {$: 'Area', a: a};
};
var $author$project$PinMeTo$Ui$Chart$Legend$Legend = function (a) {
	return {$: 'Legend', a: a};
};
var $author$project$PinMeTo$Ui$Chart$Legend$withTotal = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$Legend$Legend(
		_Utils_update(
			config,
			{total: true}));
};
var $author$project$PinMeTo$Ui$Chart$Legend$PositionTop = {$: 'PositionTop'};
var $author$project$PinMeTo$Ui$Chart$Legend$legend = $author$project$PinMeTo$Ui$Chart$Legend$Legend(
	{total: false, position: $author$project$PinMeTo$Ui$Chart$Legend$PositionTop});
var $author$project$PinMeTo$Ui$Chart$withLegend = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$View(
		_Utils_update(
			config,
			{
				legend: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$Chart$Legend$legend)
			}));
};
var $author$project$PinMeTo$Ui$Chart$withLocale = F2(
	function (locale, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Chart$View(
			_Utils_update(
				config,
				{locale: locale}));
	});
var $author$project$PinMeTo$Ui$Chart$withLegendConfig = F2(
	function (f, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Chart$View(
			_Utils_update(
				config,
				{
					legend: $elm$core$Maybe$Just(
						f($author$project$PinMeTo$Ui$Chart$Legend$legend))
				}));
	});
var $author$project$Insights$Utils$renderAreaChart = F3(
	function (session, withLegendTotal, datasets) {
		return $author$project$PinMeTo$Ui$Chart$render(
			A2(
				$author$project$PinMeTo$Ui$Chart$withLocale,
				session.locale,
				(withLegendTotal ? $author$project$PinMeTo$Ui$Chart$withLegendConfig($author$project$PinMeTo$Ui$Chart$Legend$withTotal) : $author$project$PinMeTo$Ui$Chart$withLegend)(
					$author$project$PinMeTo$Ui$Chart$view(
						{
							chart: $author$project$PinMeTo$Ui$Chart$Area(datasets)
						}))));
	});
var $author$project$Insights$Overview$View$Charts$renderLoadingChart = function (content) {
	var config = {
		shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
		children: _List_fromArray(
			[content]),
		isLoading: true,
		attributes: _List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-insights__chartCard--container')
			])
	};
	return $author$project$PinMeTo$Ui$Skeleton$view(config);
};
var $author$project$Insights$Overview$View$Charts$areaChartTitleAndColor = F2(
	function (translations, metricData) {
		if (_Utils_eq(metricData.metrics, _List_Nil)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = metricData.networkName;
			switch (_v0) {
				case 'google':
					return $elm$core$Maybe$Just(
						{
							data: metricData.metrics,
							color: '#3399FF',
							title: $author$project$Translations$General$Insights$google(translations)
						});
				case 'facebook':
					return $elm$core$Maybe$Just(
						{
							data: metricData.metrics,
							color: '#61D173',
							title: $author$project$Translations$General$Insights$facebook(translations)
						});
				case 'apple':
					return $elm$core$Maybe$Just(
						{
							data: metricData.metrics,
							color: '#9933FF',
							title: $author$project$Translations$General$Insights$apple(translations)
						});
				case 'bing':
					return $elm$core$Maybe$Just(
						{
							data: metricData.metrics,
							color: '#FDB268',
							title: $author$project$Translations$General$Insights$bing(translations)
						});
				default:
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $justinmimbs$date$Date$Day = {$: 'Day'};
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return $justinmimbs$date$Date$RD(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1);
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd.$) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date.a;
		switch (interval.$) {
			case 'Year':
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 'Quarter':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 'Month':
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 'Week':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Monday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Mon, date));
			case 'Tuesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Tue, date));
			case 'Wednesday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Wed, date));
			case 'Thursday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Thu, date));
			case 'Friday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Fri, date));
			case 'Saturday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sat, date));
			case 'Sunday':
				return $justinmimbs$date$Date$RD(
					rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, $elm$time$Time$Sun, date));
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Weeks = {$: 'Weeks'};
var $justinmimbs$date$Date$Years = {$: 'Years'};
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval.$) {
		case 'Year':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Years);
		case 'Quarter':
			return _Utils_Tuple2(3, $justinmimbs$date$Date$Months);
		case 'Month':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Months);
		case 'Day':
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Days);
		default:
			var week = interval;
			return _Utils_Tuple2(1, $justinmimbs$date$Date$Weeks);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3(
					$justinmimbs$date$Date$add,
					unit,
					step,
					$justinmimbs$date$Date$RD(current));
				var next = _v0.a;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2(
					$elm$core$List$cons,
					$justinmimbs$date$Date$RD(current),
					revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0.a;
		var until = _v1.a;
		var _v2 = A2(
			$justinmimbs$date$Date$ceiling,
			interval,
			$justinmimbs$date$Date$RD(start));
		var first = _v2.a;
		var _v3 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v3.a;
		var unit = _v3.b;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $author$project$Insights$Utils$dateRangeToDateList = function (dateRange) {
	return A4(
		$justinmimbs$date$Date$range,
		$justinmimbs$date$Date$Day,
		1,
		dateRange.from,
		A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Days, 1, dateRange.to));
};
var $author$project$Insights$Utils$padDataItemSeries = F2(
	function (dateRange, dataSeries) {
		var dateRangeKeys = A2(
			$elm$core$List$map,
			$justinmimbs$date$Date$toIsoString,
			$author$project$Insights$Utils$dateRangeToDateList(dateRange));
		var dataMap = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (x) {
					return _Utils_Tuple2(x.key, x.value);
				},
				dataSeries.data));
		var padData = {
			data: A2(
				$elm$core$List$map,
				function (key) {
					return {
						key: key,
						value: A2($elm$core$Dict$get, key, dataMap)
					};
				},
				dateRangeKeys),
			color: dataSeries.color,
			title: dataSeries.title
		};
		return padData;
	});
var $author$project$Insights$Utils$padListOfDataItemSeries = F2(
	function (dateRange, dataSeries) {
		return A2(
			$elm$core$List$map,
			$author$project$Insights$Utils$padDataItemSeries(dateRange),
			dataSeries);
	});
var $author$project$Translations$Listings$Insights$overviewActionsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_actions_description');
};
var $author$project$Insights$Overview$View$Charts$renderActionChart = F2(
	function (session, model) {
		var actionData = function (insights) {
			return A2(
				$author$project$Insights$Utils$padListOfDataItemSeries,
				model.range,
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.title;
						},
						$author$project$Insights$Overview$View$Charts$titleToInt),
					A2(
						$elm$core$List$filterMap,
						$author$project$Insights$Overview$View$Charts$areaChartTitleAndColor(session.translations),
						insights)));
		};
		var emptyCard = function (map) {
			var card = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__chartCard--container')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Card$render(
						map(
							A2(
								$author$project$PinMeTo$Ui$Card$withHeader,
								$author$project$Listings$Ui$InsightsHeader$render(
									A2(
										$author$project$Listings$Ui$InsightsHeader$withNumber,
										'0',
										A2(
											$author$project$Listings$Ui$InsightsHeader$withAsides,
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
													]),
												_List_fromArray(
													[
														A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, '', model.uiFeedback)
													])),
											A2(
												$author$project$Listings$Ui$InsightsHeader$withPopOver,
												_Utils_Tuple2(
													A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$Actions, session.translations),
													model.popOverState),
												A2(
													$author$project$Listings$Ui$InsightsHeader$withNote,
													$elm$html$Html$text('-'),
													$author$project$Listings$Ui$InsightsHeader$view(
														{title: 'label'})))))),
								$author$project$PinMeTo$Ui$Card$view(
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__chart')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('-')
											]))))))
					]));
			return $author$project$Insights$Overview$View$Charts$renderLoadingChart(card);
		};
		var _v0 = model.actionMetrics;
		switch (_v0.$) {
			case 'Loaded':
				var insights = _v0.a;
				var actionChart = A3(
					$author$project$Insights$Utils$renderAreaChart,
					session,
					true,
					actionData(insights));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__chartCard--container')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Card$render(
							A2(
								$author$project$PinMeTo$Ui$Card$withHeader,
								$author$project$Listings$Ui$InsightsHeader$render(
									A2(
										$author$project$Listings$Ui$InsightsHeader$withNumber,
										$author$project$Common$Math$formatNumber(
											$author$project$Insights$Utils$metricTotal(
												actionData(insights))),
										A2(
											$author$project$Listings$Ui$InsightsHeader$withAsides,
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
													]),
												_List_fromArray(
													[
														A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, 'overview-insights-actions', model.uiFeedback)
													])),
											A2(
												$author$project$Listings$Ui$InsightsHeader$withPopOver,
												_Utils_Tuple2(
													A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$Actions, session.translations),
													model.popOverState),
												A2(
													$author$project$Listings$Ui$InsightsHeader$withNote,
													$elm$html$Html$text(
														$author$project$Translations$Listings$Insights$overviewActionsDescription(session.translations)),
													$author$project$Listings$Ui$InsightsHeader$view(
														{
															title: $author$project$Translations$Listings$Insights$actionsTitle(session.translations)
														})))))),
								$author$project$PinMeTo$Ui$Card$view(
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__chart')
											]),
										_List_fromArray(
											[actionChart])))))
						]));
			case 'Loading':
				return emptyCard($author$project$PinMeTo$Ui$Card$withLoadingStatus);
			case 'Suspended':
				return emptyCard($author$project$PinMeTo$Ui$Card$withLoadingStatus);
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Insights$Overview$Model$Visibility = {$: 'Visibility'};
var $author$project$Translations$Listings$Insights$visibility = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.visibility');
};
var $author$project$Translations$Listings$Insights$overviewVisibilityDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.overview_visibility_description');
};
var $author$project$Insights$Overview$View$Charts$renderVisibilityChart = F2(
	function (session, model) {
		var visibilityData = function (insights) {
			return A2(
				$author$project$Insights$Utils$padListOfDataItemSeries,
				model.range,
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.title;
						},
						$author$project$Insights$Overview$View$Charts$titleToInt),
					A2(
						$elm$core$List$filterMap,
						$author$project$Insights$Overview$View$Charts$areaChartTitleAndColor(session.translations),
						insights)));
		};
		var emptyCard = function (map) {
			var card = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__chartCard--container')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Card$render(
						map(
							A2(
								$author$project$PinMeTo$Ui$Card$withHeader,
								$author$project$Listings$Ui$InsightsHeader$render(
									A2(
										$author$project$Listings$Ui$InsightsHeader$withNumber,
										'0',
										A2(
											$author$project$Listings$Ui$InsightsHeader$withAsides,
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
													]),
												_List_fromArray(
													[
														A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, '', model.uiFeedback)
													])),
											A2(
												$author$project$Listings$Ui$InsightsHeader$withPopOver,
												_Utils_Tuple2(
													A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$Visibility, session.translations),
													model.popOverState),
												A2(
													$author$project$Listings$Ui$InsightsHeader$withNote,
													$elm$html$Html$text('-'),
													$author$project$Listings$Ui$InsightsHeader$view(
														{title: 'label'})))))),
								$author$project$PinMeTo$Ui$Card$view(
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__chart')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('-')
											]))))))
					]));
			return $author$project$Insights$Overview$View$Charts$renderLoadingChart(card);
		};
		var _v0 = model.visibilityMetrics;
		switch (_v0.$) {
			case 'Loaded':
				var insights = _v0.a;
				var visibilityChart = A3(
					$author$project$Insights$Utils$renderAreaChart,
					session,
					true,
					visibilityData(insights));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__chartCard--container')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Card$render(
							A2(
								$author$project$PinMeTo$Ui$Card$withHeader,
								$author$project$Listings$Ui$InsightsHeader$render(
									A2(
										$author$project$Listings$Ui$InsightsHeader$withNumber,
										$author$project$Common$Math$formatNumber(
											$author$project$Insights$Utils$metricTotal(
												visibilityData(insights))),
										A2(
											$author$project$Listings$Ui$InsightsHeader$withAsides,
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
													]),
												_List_fromArray(
													[
														A3($author$project$Insights$Overview$View$Charts$uiFeedback, session.translations, 'overview-insights-visibility', model.uiFeedback)
													])),
											A2(
												$author$project$Listings$Ui$InsightsHeader$withPopOver,
												_Utils_Tuple2(
													A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$Visibility, session.translations),
													model.popOverState),
												A2(
													$author$project$Listings$Ui$InsightsHeader$withNote,
													$elm$html$Html$text(
														$author$project$Translations$Listings$Insights$overviewVisibilityDescription(session.translations)),
													$author$project$Listings$Ui$InsightsHeader$view(
														{
															title: $author$project$Translations$Listings$Insights$visibility(session.translations)
														})))))),
								$author$project$PinMeTo$Ui$Card$view(
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__chart')
											]),
										_List_fromArray(
											[visibilityChart])))))
						]));
			case 'Loading':
				return emptyCard($author$project$PinMeTo$Ui$Card$withLoadingStatus);
			case 'Suspended':
				return emptyCard($author$project$PinMeTo$Ui$Card$withLoadingStatus);
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Insights$Overview$View$MetricSection$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Insights$Overview$View$MetricSection$renderHighlights,
					session,
					model,
					$author$project$Insights$Overview$Model$getToDateLabel(model)),
					A2($author$project$Insights$Overview$View$Charts$renderVisibilityChart, session, model),
					A2($author$project$Insights$Overview$View$Charts$renderActionChart, session, model)
				]));
	});
var $author$project$Translations$General$Insights$noData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.no_data');
};
var $author$project$Insights$Overview$Model$TopList = {$: 'TopList'};
var $author$project$PinMeTo$Ui$EmptyState$Insights = {$: 'Insights'};
var $author$project$PinMeTo$Ui$EmptyState$insights = function (message) {
	return A2(
		$author$project$PinMeTo$Ui$EmptyState$view,
		message,
		$author$project$PinMeTo$Ui$EmptyState$iconSvg($author$project$PinMeTo$Ui$EmptyState$Insights));
};
var $author$project$Insights$Overview$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$Ui$Tooltip$tooltipLeft = function (content) {
	return A2(
		$author$project$PinMeTo$Ui$Tooltip$tooltip_,
		'pmt-tooltip pmt-tooltip--left',
		$elm$html$Html$text(content));
};
var $author$project$Insights$Overview$Model$getDateLabel = function (model) {
	var toString = $justinmimbs$date$Date$toIsoString;
	var from = toString(model.range.from);
	var to = toString(model.range.to);
	return from + (' - ' + to);
};
var $author$project$Translations$General$topLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_locations');
};
var $author$project$PinMeTo$Ui$Filter$DataTypes$filterToQueryString = function (_v0) {
	var filter = _v0.filter;
	if ($elm$core$Dict$isEmpty(filter)) {
		return '';
	} else {
		var valueToString = function (filterValue) {
			if (filterValue.b.$ === 'SingleValue') {
				var x = filterValue.b.a;
				return $elm$url$Url$percentEncode(x);
			} else {
				var ls = filterValue.b.a;
				return '[' + (A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $elm$url$Url$percentEncode, ls)) + ']');
			}
		};
		return '?listFilter=' + A2(
			$elm$core$String$join,
			';',
			A2(
				$elm$core$List$map,
				function (_v1) {
					var k = _v1.a;
					var v = _v1.b;
					return k + ('=' + valueToString(v));
				},
				$elm$core$Dict$toList(filter)));
	}
};
var $author$project$PinMeTo$Ui$FilterController$filterToQueryString = function (filter) {
	return $author$project$PinMeTo$Ui$Filter$DataTypes$filterToQueryString(filter);
};
var $author$project$Filter$FilterController$getCurrentFilterAsQueryString = function (model) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (filter) {
			return $author$project$PinMeTo$Ui$FilterController$filterToQueryString(filter);
		},
		model.currentFilter);
};
var $author$project$Insights$Overview$Model$filterQueryString = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var filterQuery = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (filterController) {
				return '&' + A2(
					$elm$core$String$dropLeft,
					1,
					$author$project$Filter$FilterController$getCurrentFilterAsQueryString(filterController));
			},
			model.filterController);
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var dateRange = model.range;
		var query = '?from=' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('&to=' + ($justinmimbs$date$Date$toIsoString(dateRange.to) + filterQuery)));
		return requestUrl + (siteName + ('/overview/metrics' + (endpoint + (fileTypeStr + query))));
	});
var $author$project$PinMeTo$Ui$Table$getSort = function (_v0) {
	var model = _v0.a;
	return model.sort;
};
var $author$project$Translations$Listings$Insights$rating = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating');
};
var $author$project$Translations$Listings$Insights$actions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.actions');
};
var $author$project$Translations$General$Insights$pageLikes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.page_likes');
};
var $author$project$Insights$Overview$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$PinMeTo$Ui$Table$withStickyHeader = function (config) {
	return _Utils_update(
		config,
		{headerSticky: true});
};
var $author$project$Translations$Listings$Insights$reviewCountHeading = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.review_count_heading');
};
var $author$project$Insights$Overview$View$TopListSection$renderTopList = F4(
	function (session, model, topList, sortedBy) {
		var googleOrTrustPilotAreConnected = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($author$project$PinMeToPage$NetworkEnabled),
			_List_fromArray(
				[session.analytics.google, session.analytics.trustpilot]));
		var includeResponseRateColoumn = googleOrTrustPilotAreConnected;
		var includeReviewCountColoumn = googleOrTrustPilotAreConnected;
		var missingValuePlaceHolder = '-';
		var includePageLikesColoumn = _Utils_eq(session.analytics.facebook, $author$project$PinMeToPage$NetworkEnabled);
		var calculateResponseRate = F2(
			function (answered, unanswered) {
				var denom = ((unanswered + answered) > 0) ? (unanswered + answered) : 1;
				return answered / denom;
			});
		var includeRatingColumn = A2(
			$elm$core$List$any,
			function (item) {
				return $elm_community$maybe_extra$Maybe$Extra$isJust(item.averageRating);
			},
			topList) && googleOrTrustPilotAreConnected;
		var compactRightContent = _List_fromArray(
			[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]);
		var formatResponseRate = F2(
			function (a, b) {
				return A3(
					$author$project$Util$flip,
					$elm$core$Basics$append,
					'%',
					A2(
						$myrho$elm_round$Round$round,
						1,
						100 * A2(calculateResponseRate, a, b)));
			});
		var getResponseRate = function (location) {
			return A3($elm$core$Maybe$map2, calculateResponseRate, location.answeredCount, location.unAnsweredCount);
		};
		var site = $author$project$Data$SiteName$toString(session.siteName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-apple-insights-top-list')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						$author$project$Translations$General$locationCountry(session.translations),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.address;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.country;
								},
								$elm$html$Html$text)),
						$author$project$PinMeTo$Ui$Table$comparing(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.country;
								})),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							$author$project$Translations$General$locationCity(session.translations),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.city;
									},
									$elm$html$Html$text)),
							$author$project$PinMeTo$Ui$Table$comparing(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.city;
									})),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$General$locationZip(session.translations),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.zip;
										},
										$elm$html$Html$text)),
								$author$project$PinMeTo$Ui$Table$comparing(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.address;
										},
										function ($) {
											return $.zip;
										})),
								A4(
									$author$project$PinMeTo$Ui$Table$addCompactColumn,
									$author$project$Translations$General$locationStreet(session.translations),
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.address;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.street;
											},
											$elm$html$Html$text)),
									$author$project$PinMeTo$Ui$Table$comparing(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.street;
											})),
									A4(
										$author$project$PinMeTo$Ui$Table$addCompactColumn,
										$author$project$Translations$General$locationDescriptor(session.translations),
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.locationDescriptor;
											},
											$elm$html$Html$text),
										$author$project$PinMeTo$Ui$Table$comparing(
											function ($) {
												return $.locationDescriptor;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$name(session.translations),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.name;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.name;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationStoreId(session.translations),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.storeId;
													},
													$elm$html$Html$text),
												A2(
													$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
													30,
													function ($) {
														return $.storeId;
													}),
												A5(
													$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
													$author$project$Translations$Listings$Insights$actions(session.translations),
													compactRightContent,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.actions;
														},
														A2(
															$elm$core$Basics$composeR,
															A2(
																$elm_community$maybe_extra$Maybe$Extra$unpack,
																function (_v4) {
																	return missingValuePlaceHolder;
																},
																$author$project$Common$Math$formatNumber),
															$elm$html$Html$text)),
													$author$project$PinMeTo$Ui$Table$comparingMaybe(
														function ($) {
															return $.actions;
														}),
													A5(
														$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
														$author$project$Translations$Listings$Insights$visibility(session.translations),
														compactRightContent,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.visibility;
															},
															A2(
																$elm$core$Basics$composeR,
																A2(
																	$elm_community$maybe_extra$Maybe$Extra$unpack,
																	function (_v3) {
																		return missingValuePlaceHolder;
																	},
																	$author$project$Common$Math$formatNumber),
																$elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparingMaybe(
															function ($) {
																return $.visibility;
															}),
														(includePageLikesColoumn ? A4(
															$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
															$author$project$Translations$General$Insights$pageLikes(session.translations),
															compactRightContent,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.pageLikes;
																},
																A2(
																	$elm$core$Basics$composeR,
																	$elm$core$Maybe$map($elm$core$String$fromInt),
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$core$Maybe$withDefault('-'),
																		$elm$html$Html$text))),
															$author$project$PinMeTo$Ui$Table$comparingMaybe(
																function ($) {
																	return $.pageLikes;
																})) : $elm$core$Basics$identity)(
															(includeReviewCountColoumn ? A4(
																$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
																$author$project$Translations$Listings$Insights$reviewCountHeading(session.translations),
																compactRightContent,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.reviewCount;
																	},
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$core$Maybe$map($elm$core$String$fromInt),
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$Maybe$withDefault(missingValuePlaceHolder),
																			$elm$html$Html$text))),
																$author$project$PinMeTo$Ui$Table$comparingMaybe(
																	function ($) {
																		return $.reviewCount;
																	})) : $elm$core$Basics$identity)(
																(includeResponseRateColoumn ? A4(
																	$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
																	$author$project$Translations$Listings$Insights$responseRate(session.translations),
																	compactRightContent,
																	A2(
																		$elm$core$Basics$composeR,
																		function (item) {
																			return A3($elm$core$Maybe$map2, formatResponseRate, item.answeredCount, item.unAnsweredCount);
																		},
																		A2(
																			$elm$core$Basics$composeR,
																			$elm$core$Maybe$withDefault(missingValuePlaceHolder),
																			$elm$html$Html$text)),
																	$author$project$PinMeTo$Ui$Table$comparingMaybe(getResponseRate)) : $elm$core$Basics$identity)(
																	(includeRatingColumn ? A4(
																		$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
																		$author$project$Translations$Listings$Insights$rating(session.translations),
																		compactRightContent,
																		A2(
																			$elm$core$Basics$composeR,
																			function ($) {
																				return $.averageRating;
																			},
																			A2(
																				$elm$core$Basics$composeR,
																				A2(
																					$elm_community$maybe_extra$Maybe$Extra$unpack,
																					function (_v2) {
																						return missingValuePlaceHolder;
																					},
																					$myrho$elm_round$Round$round(1)),
																				$elm$html$Html$text)),
																		$author$project$PinMeTo$Ui$Table$comparingMaybe(
																			function ($) {
																				return $.averageRating;
																			})) : $elm$core$Basics$identity)(
																		A2(
																			$author$project$PinMeTo$Ui$Table$withRowLink,
																			function (location) {
																				return '/listings/' + (site + ('/locations/' + (location.locationId + '/details')));
																			},
																			A2(
																				$author$project$PinMeTo$Ui$Table$withLimit,
																				{
																					limit: model.topListAmountToShow,
																					viewMoreLabel: F2(
																						function (_v0, _v1) {
																							return 'Show more';
																						})
																				},
																				$author$project$PinMeTo$Ui$Table$withScrollableTable(
																					$author$project$PinMeTo$Ui$Table$withStickyHeader(
																						A2(
																							$author$project$PinMeTo$Ui$Table$withSort,
																							sortedBy,
																							A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Overview$Model$UiTableMsg, topList))))))))))))))))))))
				]));
	});
var $author$project$Insights$Overview$View$TopListSection$renderViewSelector = F2(
	function (session, model) {
		var topListMetricsData = function () {
			var _v0 = model.topList;
			if (_v0.$ === 'Loaded') {
				var topListData = _v0.a;
				return topListData;
			} else {
				return _List_Nil;
			}
		}();
		var sortedBy = A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$Table$Desc(0),
			$author$project$PinMeTo$Ui$Table$getSort(model.uiTable));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Insights$Overview$View$TopListSection$renderTopList, session, model, topListMetricsData, sortedBy)
				]));
	});
var $author$project$Insights$Overview$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Translations$General$downloadCsvSpreadsheet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.download_csv_spreadsheet');
};
var $author$project$Translations$General$downloadXlsxSpreadsheet = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.download_xlsx_spreadsheet');
};
var $author$project$Translations$General$topLocationsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.top_locations_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Translations$Listings$Insights$downloadTopLocationsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_top_locations_title');
};
var $author$project$Translations$Listings$Insights$downloadDetailedDataTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_detailed_data_tooltip');
};
var $author$project$PinMeTo$Ui$Select$ToggleIconBefore = function (a) {
	return {$: 'ToggleIconBefore', a: a};
};
var $author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconBefore = F2(
	function (icon, toggle) {
		return A2(
			$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIcon,
			$author$project$PinMeTo$Ui$Select$ToggleIconBefore(icon),
			toggle);
	});
var $author$project$Insights$Utils$renderInsightsDownloadButton = F2(
	function (_v0, selectState) {
		var isDisabled = _v0.isDisabled;
		var fileName = _v0.fileName;
		var items = _v0.items;
		var onChange = _v0.onChange;
		var tagger = _v0.tagger;
		var title = _v0.title;
		var uid = _v0.uid;
		var config = {
			uid: uid,
			items: items,
			tagger: tagger,
			onChange: onChange,
			itemRender: function (item) {
				return A3(
					$elm$html$Html$node,
					'pmt-download-with-filter-button',
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'url', item.url),
							A2($elm$html$Html$Attributes$attribute, 'label', item.label),
							A2($elm$html$Html$Attributes$attribute, 'filename', fileName)
						]),
					_List_Nil);
			}
		};
		var icon = $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faFileArrowDown);
		return A2(
			$author$project$PinMeTo$Ui$Select$render,
			selectState,
			A2(
				$author$project$PinMeTo$Ui$Select$isDisabled,
				isDisabled,
				A2(
					$author$project$PinMeTo$Ui$Select$viewWithToggle,
					config,
					A2(
						$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconBefore,
						icon,
						A2(
							$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonStyle,
							$author$project$PinMeTo$Ui$Button$Ghost($author$project$PinMeTo$Ui$Button$GhostDefault),
							$author$project$PinMeTo$Ui$Select$uiButtonToggle(title))))));
	});
var $author$project$Insights$Overview$View$TopListSection$view = F2(
	function (session, model) {
		var titleWithPopOver = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$topLocations(session.translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.popOverState,
							A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$TopList, session.translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$General$topLocationsDescription,
								session.translations,
								$author$project$Insights$Overview$Model$getDateLabel(model)))
						]))
				]));
		var dateRange = model.range;
		var downloadButton = _List_fromArray(
			[
				A2(
				$author$project$Insights$Utils$renderInsightsDownloadButton,
				{
					uid: 'ui-select-download-toplist-overview',
					items: _List_fromArray(
						[
							{
							url: A4($author$project$Insights$Overview$Model$filterQueryString, model, session.siteName, 'csv', '/topList/download/'),
							label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
						},
							{
							url: A4($author$project$Insights$Overview$Model$filterQueryString, model, session.siteName, 'xlsx', '/topList/download/'),
							label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
						}
						]),
					title: $author$project$Translations$Listings$Insights$downloadTopLocationsTitle(session.translations),
					tagger: $author$project$Insights$Overview$Model$UiSelectMsg,
					fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Overview-top-list_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
					onChange: $author$project$Insights$Overview$Model$OnDownloadLabelClicked,
					isDisabled: !_Utils_eq(
						A2(
							$author$project$RemoteData$map,
							function (data) {
								return $elm$core$List$isEmpty(data);
							},
							model.topList),
						$author$project$RemoteData$Loaded(false))
				},
				model.uiSelect)
			]);
		var asides = _List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
				$author$project$Translations$Listings$Insights$downloadDetailedDataTooltip(session.translations),
				$elm$html$Html$b,
				_List_Nil,
				downloadButton)
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(titleWithPopOver)))),
					function () {
					var _v0 = model.topList;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Loaded':
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Insights$Overview$View$TopListSection$renderViewSelector, session, model)
									]));
						default:
							var e = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
					}
				}()
				]));
	});
var $author$project$FontAwesome$Light$Icon$faCalendar = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-calendar');
var $author$project$FontAwesome$Light$faCalendar = $author$project$FontAwesome$Light$Icon$render($author$project$FontAwesome$Light$Icon$faCalendar);
var $author$project$Listings$Ui$PresetDateRangePicker$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$presetToRange = F2(
	function (date, preset) {
		switch (preset.$) {
			case 'DaysBack':
				var days = preset.a;
				return {
					to: date,
					from: A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Days, -(days - 1), date)
				};
			case 'MonthsBack':
				var months = preset.a;
				return {
					to: date,
					from: A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Months, -months, date)
				};
			default:
				var range = preset.c;
				return range;
		}
	});
var $author$project$Listings$Ui$PresetDateRangePicker$presetToString = F2(
	function (labels, preset) {
		switch (preset.$) {
			case 'DaysBack':
				var days = preset.a;
				return labels.daysBack(days);
			case 'MonthsBack':
				var months = preset.a;
				return labels.monthsBack(months);
			default:
				var label = preset.a.a;
				return label;
		}
	});
var $author$project$Listings$Ui$PresetDateRangePicker$OnPresetSelected = function (a) {
	return {$: 'OnPresetSelected', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$renderPresets = F3(
	function (config, model, presets) {
		var isCurrent = function (preset) {
			return _Utils_eq(
				A2($author$project$Listings$Ui$PresetDateRangePicker$presetToRange, model.date, preset),
				config.range);
		};
		return A2(
			$elm$core$List$map,
			function (preset) {
				return $author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Listings$Ui$PresetDateRangePicker$OnPresetSelected(preset),
						A2(
							$author$project$PinMeTo$Ui$Button$withGhostStyle,
							$author$project$PinMeTo$Ui$Button$GhostNeutral,
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								isCurrent(preset),
								A2(
									$author$project$PinMeTo$Ui$Button$withSize,
									$author$project$PinMeTo$Ui$Button$Small,
									$author$project$PinMeTo$Ui$Button$buttonGhost(
										A2($author$project$Listings$Ui$PresetDateRangePicker$presetToString, config.labels, preset)))))));
			},
			presets);
	});
var $author$project$Listings$Ui$PresetDateRangePicker$renderDropdown = F2(
	function (_v0, model) {
		var config = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('listings-ui-date-range-picker__dropdown')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('listings-ui-date-range-picker__presets')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (x) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[x]));
								},
								A3($author$project$Listings$Ui$PresetDateRangePicker$renderPresets, config, model, $author$project$Listings$Ui$PresetDateRangePicker$defaultRanges))),
							function () {
							var _v1 = config.ranges;
							if (!_v1.b) {
								return $elm$html$Html$text('');
							} else {
								var ranges = _v1;
								return A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (x) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[x]));
										},
										A3($author$project$Listings$Ui$PresetDateRangePicker$renderPresets, config, model, ranges)));
							}
						}()
						]))
				]));
	});
var $author$project$PinMeTo$Ui$Select$withWrapperToggle = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Select$Config(
		_Utils_update(
			config,
			{
				styles: A2($elm$core$List$cons, $author$project$PinMeTo$Ui$Select$WithOutIcon, config.styles),
				toggleStyle: $author$project$PinMeTo$Ui$Select$Wrapper
			}));
};
var $author$project$Listings$Ui$PresetDateRangePicker$rangeFromMonthsBack = F2(
	function (date, months) {
		return {
			to: date,
			from: A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Months, -months, date)
		};
	});
var $author$project$Listings$Ui$PresetDateRangePicker$rangeToPreset = F3(
	function (config, date, dateRange) {
		var presetIsEqualToRange = F2(
			function (range, preset) {
				switch (preset.$) {
					case 'Labeled':
						var range_ = preset.c;
						return _Utils_eq(range_, range);
					case 'MonthsBack':
						var months = preset.a;
						return _Utils_eq(
							range,
							A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromMonthsBack, date, months));
					default:
						var days = preset.a;
						return _Utils_eq(
							range,
							A2($author$project$Listings$Ui$PresetDateRangePicker$rangeFromDaysBack, date, days));
				}
			});
		var allRanges = _Utils_ap(config.defaultRanges, config.ranges);
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$find,
			presetIsEqualToRange(dateRange),
			allRanges);
		if (_v0.$ === 'Just') {
			var preset = _v0.a;
			return preset;
		} else {
			return $author$project$Listings$Ui$PresetDateRangePicker$DaysBack(
				A3($justinmimbs$date$Date$diff, $justinmimbs$date$Date$Days, dateRange.from, date) + 1);
		}
	});
var $author$project$Listings$Ui$PresetDateRangePicker$renderDateRangeToggle = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('listings-ui-date-range-picker-toggle')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('listings-ui-date-range-picker-toggle__part listings-ui-date-range-picker-toggle__preset')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Listings$Ui$PresetDateRangePicker$presetToString,
								config.labels,
								A3($author$project$Listings$Ui$PresetDateRangePicker$rangeToPreset, config, model.date, config.range))),
							$author$project$FontAwesome$Regular$faChevronDown
						]))
				]));
	});
var $author$project$Listings$Ui$PresetDateRangePicker$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('listings-ui-date-range-picker')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.tagger,
					A2(
						$author$project$PinMeTo$Ui$Select$render,
						model.uiSelect,
						$author$project$PinMeTo$Ui$Select$withWrapperToggle(
							$author$project$PinMeTo$Ui$Select$raw(
								{
									uid: 'date-range-picker-' + config.uid,
									items: _List_fromArray(
										[_Utils_Tuple0]),
									label: A2($author$project$Listings$Ui$PresetDateRangePicker$renderDateRangeToggle, config, model),
									tagger: $author$project$Listings$Ui$PresetDateRangePicker$UiSelectMsg,
									itemRender: function (_v2) {
										return A2(
											$author$project$Listings$Ui$PresetDateRangePicker$renderDropdown,
											$author$project$Listings$Ui$PresetDateRangePicker$View(config),
											model);
									}
								})))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('listings-ui-date-range-picker-toggle__part listings-ui-date-range-picker-toggle__dates')
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$Light$faCalendar,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('listings-ui-date-range-picker-toggle__date-range')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Date$render(
									A2(
										$author$project$PinMeTo$Ui$Date$withFormat,
										$author$project$PinMeTo$Ui$Date$FormatDate,
										A2(
											$author$project$PinMeTo$Ui$Date$string,
											config.locale,
											$justinmimbs$date$Date$toIsoString(config.range.from)))),
									$elm$html$Html$text('–'),
									$author$project$PinMeTo$Ui$Date$render(
									A2(
										$author$project$PinMeTo$Ui$Date$withFormat,
										$author$project$PinMeTo$Ui$Date$FormatDate,
										A2(
											$author$project$PinMeTo$Ui$Date$string,
											config.locale,
											$justinmimbs$date$Date$toIsoString(config.range.to))))
								]))
						]))
				]));
	});
var $author$project$Translations$Listings$PresetDateRangePicker$lastXDays = F2(
	function (translations, days) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.preset_date_range_picker.last_x_days',
			_List_fromArray(
				[
					_Utils_Tuple2('days', days)
				]));
	});
var $author$project$Insights$Overview$Model$DatePicker = {$: 'DatePicker'};
var $author$project$Listings$Ui$PresetDateRangePicker$withRanges = F2(
	function (ranges, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$PresetDateRangePicker$View(
			_Utils_update(
				config,
				{ranges: ranges}));
	});
var $author$project$Translations$Listings$Insights$yearToDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.year_to_date');
};
var $author$project$Translations$Listings$PresetDateRangePicker$lastXMonths = F2(
	function (translations, months) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.preset_date_range_picker.last_x_months',
			_List_fromArray(
				[
					_Utils_Tuple2('months', months)
				]));
	});
var $author$project$Listings$Ui$PresetDateRangePicker$Labeled = F3(
	function (a, b, c) {
		return {$: 'Labeled', a: a, b: b, c: c};
	});
var $author$project$Listings$Ui$PresetDateRangePicker$MetricsEvent = function (a) {
	return {$: 'MetricsEvent', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$DateRangeLabel = function (a) {
	return {$: 'DateRangeLabel', a: a};
};
var $author$project$Listings$Ui$PresetDateRangePicker$presetCustom = F3(
	function (label, metricsEvent, range) {
		return A3(
			$author$project$Listings$Ui$PresetDateRangePicker$Labeled,
			$author$project$Listings$Ui$PresetDateRangePicker$DateRangeLabel(label),
			$author$project$Listings$Ui$PresetDateRangePicker$MetricsEvent(metricsEvent),
			range);
	});
var $author$project$Translations$Listings$Insights$downloadMetricsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_metrics_title');
};
var $author$project$Translations$Listings$Insights$downloadSummaryTooltip = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_summary_tooltip');
};
var $author$project$Insights$Overview$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$html$Html$text(''),
				function (controller) {
					return A2(
						$elm$html$Html$map,
						$author$project$Insights$Overview$Model$FilterControllerMsg,
						A4($author$project$Filter$FilterController$viewInsights, controller, session.locale, session.translations, session.language));
				},
				model.filterController),
			function (_v0) {
				return $elm$html$Html$text('');
			},
			model.locationId);
		var shouldShowTopList = $elm_community$maybe_extra$Maybe$Extra$isNothing(model.locationId);
		var dateRangePicker = {
			uid: 'overview-date-range-picker',
			range: model.range,
			labels: {
				daysBack: function (days) {
					return A2(
						$author$project$Translations$Listings$PresetDateRangePicker$lastXDays,
						session.translations,
						$elm$core$String$fromInt(days));
				},
				monthsBack: function (months) {
					return A2(
						$author$project$Translations$Listings$PresetDateRangePicker$lastXMonths,
						session.translations,
						$elm$core$String$fromInt(months));
				}
			},
			locale: session.locale,
			tagger: $author$project$Insights$Overview$Model$DateRangePickerMsg,
			language: session.language
		};
		var dateRange = model.range;
		var downloadButtonConfig = {
			uid: 'ui-select-download-overview-metric',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Overview$Model$filterQueryString, model, session.siteName, 'csv', '/download/'),
					label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
				},
					{
					url: A4($author$project$Insights$Overview$Model$filterQueryString, model, session.siteName, 'xlsx', '/download/'),
					label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
			tagger: $author$project$Insights$Overview$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Overview-Insights_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Overview$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A3(
					$author$project$RemoteData$map2,
					F2(
						function (data1, data2) {
							return A2(
								$elm$core$List$all,
								function (data) {
									return $elm$core$List$isEmpty(data.metrics);
								},
								data1) && A2(
								$elm$core$List$all,
								function (data) {
									return $elm$core$List$isEmpty(data.metrics);
								},
								data2);
						}),
					model.visibilityMetrics,
					model.actionMetrics),
				$author$project$RemoteData$Loaded(false))
		};
		var downloadButton = A4(
			$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
			$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
			$elm$html$Html$b,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadButtonConfig, model.uiSelect)
				]));
		var today = A2($justinmimbs$date$Date$fromPosix, model.timezone, model.today);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					filterControllerHandler,
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
						true,
						$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
							$author$project$Translations$General$Insights$overview(session.translations)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Listings$Ui$PresetDateRangePicker$render,
									model.presetDatePickerState,
									A2(
										$author$project$Listings$Ui$PresetDateRangePicker$withRanges,
										_List_fromArray(
											[
												A3(
												$author$project$Listings$Ui$PresetDateRangePicker$presetCustom,
												$author$project$Translations$Listings$Insights$yearToDate(session.translations),
												'year-to-date',
												{
													to: today,
													from: A3(
														$justinmimbs$date$Date$fromCalendarDate,
														$justinmimbs$date$Date$year(today),
														$elm$time$Time$Jan,
														1)
												})
											]),
										$author$project$Listings$Ui$PresetDateRangePicker$view(dateRangePicker))),
									A2(
									$author$project$PinMeTo$Ui$PopOver$renderPlain,
									model.popOverState,
									A2($author$project$Insights$Overview$View$Charts$popOverConfig, $author$project$Insights$Overview$Model$DatePicker, session.translations))
								])),
							downloadButton
						])),
					A2($author$project$Insights$Overview$View$MetricSection$view, session, model),
					shouldShowTopList ? A2($author$project$Insights$Overview$View$TopListSection$view, session, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$PinMeTo$Ports$pmtUiMetricsSendEvent = _Platform_outgoingPort(
	'pmtUiMetricsSendEvent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'event',
					$elm$json$Json$Encode$string($.event)),
					_Utils_Tuple2(
					'weight',
					$elm$json$Json$Encode$int($.weight))
				]));
	});
var $author$project$PinMeTo$Ui$Metrics$sendEvent = function (event) {
	return $author$project$PinMeTo$Ports$pmtUiMetricsSendEvent(
		{event: event, weight: 1});
};
var $author$project$Listings$Ui$PresetDateRangePicker$update_ = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					$elm$core$Platform$Cmd$map(config.tagger),
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Listings$Ui$PresetDateRangePicker$UiSelectMsg, msg_, model.uiSelect));
			case 'OnSelectorOpened':
				return _Utils_Tuple2(
					model,
					$author$project$PinMeTo$Ui$Metrics$sendEvent(
						config.metricsPrefix('Range Selector Opened')));
			case 'OnPresetSelected':
				var preset = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiSelect: $author$project$PinMeTo$Ui$Select$close(model.uiSelect)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								config.onChange,
								$elm$core$Task$succeed(
									A2($author$project$Listings$Ui$PresetDateRangePicker$presetToRange, model.date, preset))),
								$author$project$PinMeTo$Ui$Metrics$sendEvent(
								_Utils_ap(
									config.metricsPrefix('Selected Date Range '),
									function () {
										switch (preset.$) {
											case 'DaysBack':
												var days = preset.a;
												return 'Last ' + ($elm$core$String$fromInt(days) + ' days');
											case 'MonthsBack':
												var months = preset.a;
												return 'Last ' + ($elm$core$String$fromInt(months) + ' months');
											default:
												var metricsEvent = preset.b.a;
												return metricsEvent;
										}
									}()))
							])));
			default:
				switch (msg.b.$) {
					case 'DateRangeChanged':
						var current = msg.a;
						var range = msg.b.a;
						return (!_Utils_eq(range, current)) ? _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$perform,
										config.onChange,
										$elm$core$Task$succeed(range)),
										$author$project$PinMeTo$Ui$Metrics$sendEvent(
										config.metricsPrefix('Selected Custom Date Range'))
									]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'DateChanged':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Listings$Ui$PresetDateRangePicker$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Listings$Ui$PresetDateRangePicker$State,
			A3($author$project$Listings$Ui$PresetDateRangePicker$update_, config, msg, model));
	});
var $author$project$Insights$Overview$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Overview$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Utils$encodeDateRange = function (range) {
	var asTupleList = _List_fromArray(
		[
			_Utils_Tuple2(
			'from',
			$elm$json$Json$Encode$string(
				$justinmimbs$date$Date$toIsoString(range.from))),
			_Utils_Tuple2(
			'to',
			$elm$json$Json$Encode$string(
				$justinmimbs$date$Date$toIsoString(range.to)))
		]);
	return $elm$json$Json$Encode$object(asTupleList);
};
var $author$project$Insights$Overview$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$Overview$Commands$urlAppend = $author$project$Util$flip($elm$core$Basics$append);
var $author$project$Insights$Overview$Model$RatingStats = F3(
	function (averageRating, answeredCount, unansweredCount) {
		return {answeredCount: answeredCount, averageRating: averageRating, unansweredCount: unansweredCount};
	});
var $author$project$Insights$Overview$Decoders$ratingStatsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'unansweredCount',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'answeredCount',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'averageRating',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Insights$Overview$Model$RatingStats))));
var $author$project$Insights$Overview$Commands$getRatingStats = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var dateRange = model.range;
		var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			'?to=' + to,
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'/rating',
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (locationId) {
							return '/' + locationId;
						},
						model.locationId),
					A2(
						$author$project$Insights$Overview$Commands$urlAppend,
						'/overview',
						A2(
							$author$project$Insights$Overview$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Overview$Decoders$ratingStatsDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Commands$getQueryParams = function (model) {
	var dateRange = model.range;
	var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
	var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
	return '?from=' + (from + ('&to=' + to));
};
var $author$project$Insights$Overview$Model$NetworkMetrics = F2(
	function (networkName, metrics) {
		return {metrics: metrics, networkName: networkName};
	});
var $author$project$Insights$Overview$Model$MetricDetails = F2(
	function (key, value) {
		return {key: key, value: value};
	});
var $author$project$Insights$Overview$Decoders$metricDetailsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Overview$Model$MetricDetails)));
var $author$project$Insights$Overview$Decoders$networkMetricsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metrics',
	$elm$json$Json$Decode$list($author$project$Insights$Overview$Decoders$metricDetailsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'network',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Overview$Model$NetworkMetrics)));
var $author$project$Insights$Overview$Decoders$networkMetricsListDecoder = $elm$json$Json$Decode$list($author$project$Insights$Overview$Decoders$networkMetricsDecoder);
var $author$project$Insights$Overview$Commands$getActionMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (locationId_) {
					return locationId_ + '/';
				},
				model.locationId));
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			$author$project$Insights$Overview$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'metrics/actions/',
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					locationId,
					A2(
						$author$project$Insights$Overview$Commands$urlAppend,
						'/overview/locations/',
						A2(
							$author$project$Insights$Overview$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Overview$Decoders$networkMetricsListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Model$TopListLocation = function (name) {
	return function (storeId) {
		return function (locationDescriptor) {
			return function (locationId) {
				return function (address) {
					return function (visibility) {
						return function (actions) {
							return function (answeredCount) {
								return function (unAnsweredCount) {
									return function (reviewCount) {
										return function (pageLikes) {
											return function (averageRating) {
												return {name: name, actions: actions, address: address, storeId: storeId, pageLikes: pageLikes, locationId: locationId, visibility: visibility, reviewCount: reviewCount, answeredCount: answeredCount, averageRating: averageRating, unAnsweredCount: unAnsweredCount, locationDescriptor: locationDescriptor};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Overview$Decoders$topListLocationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'averageRating',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pageLikes',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'reviewCount',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'unAnsweredReviews',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'answeredReviews',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'actions',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'visibility',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['location', 'address']),
								$author$project$Data$Address$addressDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['location', '_id']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['location', 'locationDescriptor']),
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['location', 'storeId']),
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
												_List_fromArray(
													['location', 'name']),
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Insights$Overview$Model$TopListLocation)))))))))))));
var $author$project$Insights$Overview$Commands$getTopListMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			$author$project$Insights$Overview$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'/overview/metrics/topList',
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					siteName,
					$elm$url$Url$toString(model.insightsUrl))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Insights$Overview$Decoders$topListLocationDecoder),
					$elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Decoders$facebookPageLikesDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'facebookPageLikes',
	$elm$json$Json$Decode$nullable($author$project$Insights$Overview$Decoders$metricDetailsDecoder),
	$elm$core$Maybe$Nothing,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Insights$Overview$Commands$getPageLikesMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (locationId_) {
					return locationId_ + '/';
				},
				model.locationId));
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			$author$project$Insights$Overview$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'metrics/localPageLikes/',
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					locationId,
					A2(
						$author$project$Insights$Overview$Commands$urlAppend,
						'/overview/locations/',
						A2(
							$author$project$Insights$Overview$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Overview$Decoders$facebookPageLikesDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Commands$getVisibilityMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (locationId_) {
					return locationId_ + '/';
				},
				model.locationId));
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			$author$project$Insights$Overview$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'metrics/visibility/',
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					locationId,
					A2(
						$author$project$Insights$Overview$Commands$urlAppend,
						'/overview/locations/',
						A2(
							$author$project$Insights$Overview$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Overview$Decoders$networkMetricsListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Model$OnRatingStatsResponse = function (a) {
	return {$: 'OnRatingStatsResponse', a: a};
};
var $author$project$Insights$Overview$Model$OnActionMetricsResponse = function (a) {
	return {$: 'OnActionMetricsResponse', a: a};
};
var $author$project$Insights$Overview$Commands$getComparativePageLikes = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (locationId_) {
					return locationId_ + '/';
				},
				model.locationId));
		var dateRange = model.range;
		var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			'&to=' + from,
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'?from=' + from,
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					'metrics/localPageLikes/',
					A2(
						$author$project$Insights$Overview$Commands$urlAppend,
						locationId,
						A2(
							$author$project$Insights$Overview$Commands$urlAppend,
							'/overview/locations/',
							A2(
								$author$project$Insights$Overview$Commands$urlAppend,
								siteName,
								$elm$url$Url$toString(model.insightsUrl)))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Overview$Decoders$facebookPageLikesDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Model$OnTopListMetricsResponse = function (a) {
	return {$: 'OnTopListMetricsResponse', a: a};
};
var $author$project$Insights$Overview$Commands$getComparativeRatingStats = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var dateRange = model.range;
		var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
		var url = A2(
			$author$project$Insights$Overview$Commands$urlAppend,
			'?to=' + from,
			A2(
				$author$project$Insights$Overview$Commands$urlAppend,
				'/rating',
				A2(
					$author$project$Insights$Overview$Commands$urlAppend,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (locationId) {
							return '/' + locationId;
						},
						model.locationId),
					A2(
						$author$project$Insights$Overview$Commands$urlAppend,
						'/overview',
						A2(
							$author$project$Insights$Overview$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Overview$Decoders$ratingStatsDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Overview$Model$OnPageLikesMetricsResponse = function (a) {
	return {$: 'OnPageLikesMetricsResponse', a: a};
};
var $author$project$Insights$Overview$Model$OnVisibilityMetricsResponse = function (a) {
	return {$: 'OnVisibilityMetricsResponse', a: a};
};
var $author$project$Insights$Overview$Model$OnComparativeRatingsStatsResponse = function (a) {
	return {$: 'OnComparativeRatingsStatsResponse', a: a};
};
var $author$project$Insights$Overview$Model$OnComparativePageLikesMetricsResponse = function (a) {
	return {$: 'OnComparativePageLikesMetricsResponse', a: a};
};
var $author$project$Insights$Overview$Main$fetchAllLocationInsights = F2(
	function (model, siteName) {
		return _List_fromArray(
			[
				A3($author$project$Insights$Overview$Commands$getRatingStats, model, siteName, $author$project$Insights$Overview$Model$OnRatingStatsResponse),
				A3($author$project$Insights$Overview$Commands$getVisibilityMetrics, model, siteName, $author$project$Insights$Overview$Model$OnVisibilityMetricsResponse),
				A3($author$project$Insights$Overview$Commands$getActionMetrics, model, siteName, $author$project$Insights$Overview$Model$OnActionMetricsResponse),
				A3($author$project$Insights$Overview$Commands$getPageLikesMetrics, model, siteName, $author$project$Insights$Overview$Model$OnPageLikesMetricsResponse),
				A3($author$project$Insights$Overview$Commands$getTopListMetrics, model, siteName, $author$project$Insights$Overview$Model$OnTopListMetricsResponse),
				A3($author$project$Insights$Overview$Commands$getComparativePageLikes, model, siteName, $author$project$Insights$Overview$Model$OnComparativePageLikesMetricsResponse),
				A3($author$project$Insights$Overview$Commands$getComparativeRatingStats, model, siteName, $author$project$Insights$Overview$Model$OnComparativeRatingsStatsResponse)
			]);
	});
var $author$project$Insights$Overview$Main$out_Insights_Overview_Main_onFilter = _Platform_outgoingPort('out_Insights_Overview_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Overview$Main$out_Insights_Overview_Main_onRangeChange = _Platform_outgoingPort('out_Insights_Overview_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$Overview$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'DateRangePickerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{presetDatePickerState: x});
					},
					A3(
						$author$project$Listings$Ui$PresetDateRangePicker$update,
						{
							tagger: $author$project$Insights$Overview$Model$DateRangePickerMsg,
							onChange: $author$project$Insights$Overview$Model$OnDateRangeChange,
							metricsPrefix: $author$project$Common$Metrics$prefix('Insights Overview')
						},
						msg_,
						model.presetDatePickerState));
			case 'OnDateRangeChange':
				var range = msg.a;
				var onRangeChange = $author$project$Insights$Overview$Main$out_Insights_Overview_Main_onRangeChange(
					$author$project$Insights$Utils$encodeDateRange(range));
				var newModel_ = _Utils_update(
					model,
					{range: range, topList: $author$project$RemoteData$Loading, ratingStats: $author$project$RemoteData$Loading, actionMetrics: $author$project$RemoteData$Loading, totalPageLikes: $author$project$RemoteData$Loading, visibilityMetrics: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel_,
					$elm$core$Platform$Cmd$batch(
						_Utils_ap(
							A2($author$project$Insights$Overview$Main$fetchAllLocationInsights, newModel_, session.siteName),
							_List_fromArray(
								[onRangeChange]))));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Overview$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'OnDownloadLabelClicked':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (model_) {
						var _v1 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Overview$Model$FilterControllerMsg, msg_, model_, $author$project$Insights$Overview$Model$OnFilter, $author$project$Insights$Overview$Model$OnSearch);
						var filterControllerModel_ = _v1.a;
						var filterControllerCmd_ = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									filterController: $elm$core$Maybe$Just(filterControllerModel_)
								}),
							filterControllerCmd_);
					},
					model.filterController);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						topList: $author$project$RemoteData$Loading,
						ratingStats: $author$project$RemoteData$Loading,
						actionMetrics: $author$project$RemoteData$Loading,
						totalPageLikes: $author$project$RemoteData$Loading,
						filterDefinition: $elm$core$Maybe$Just(filterDefinition),
						visibilityMetrics: $author$project$RemoteData$Loading
					});
				var newBatch = $elm$core$Platform$Cmd$batch(
					_Utils_ap(
						A2($author$project$Insights$Overview$Main$fetchAllLocationInsights, newModel, session.siteName),
						_List_fromArray(
							[
								$author$project$Insights$Overview$Main$out_Insights_Overview_Main_onFilter(filterDefinition)
							])));
				return _Utils_Tuple2(newModel, newBatch);
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnUrlChange':
				var value = msg.a;
				var _v2 = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, value);
				if (_v2.$ === 'Ok') {
					var url = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								baseUrl: $elm$core$Maybe$Just(url)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = _v2.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'Insights.Overview.Main.OnUrlChange',
								message: 'Failed to decode url'
							}));
				}
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnPopOver':
				var popOverConfigType = msg.a;
				var msg_ = msg.b;
				var planhatTrack = function () {
					if (msg_.$ === 'Open') {
						switch (popOverConfigType.$) {
							case 'Visibility':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.visibilityPopoverClicked;
							case 'Actions':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.actionsPopoverClicked;
							case 'RatingTrend':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.ratingTrendPopoverClicked;
							case 'ResponseRate':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.responseRatePopoverClicked;
							case 'LocalPageLikes':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.localPageLikesPopoverClicked;
							case 'TopList':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.topListPopoverClicked;
							default:
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.overview.datePickerPopoverClicked;
						}
					} else {
						return '';
					}
				}();
				var planhatTrackCmd = (planhatTrack !== '') ? $author$project$PlanHat$PlanHat$track(
					{info: '', action: planhatTrack}) : $elm$core$Platform$Cmd$none;
				var _v3 = A3(
					$author$project$PinMeTo$Ui$PopOver$update,
					$author$project$Insights$Overview$Model$OnPopOver(popOverConfigType),
					msg_,
					model.popOverState);
				var newState = _v3.a;
				var cmd_ = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd_, planhatTrackCmd])));
			case 'UiFeedbackMsg':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnRatingStatsResponse':
				if (msg.a.$ === 'Ok') {
					var stats = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ratingStats: $author$project$RemoteData$Loaded(stats)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ratingStats: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnComparativeRatingsStatsResponse':
				if (msg.a.$ === 'Ok') {
					var stats = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								comparativeRatingStats: $author$project$RemoteData$Loaded(stats)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								comparativeRatingStats: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnVisibilityMetricsResponse':
				if (msg.a.$ === 'Ok') {
					var metrics = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								visibilityMetrics: $author$project$RemoteData$Loaded(metrics)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								visibilityMetrics: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnActionMetricsResponse':
				if (msg.a.$ === 'Ok') {
					var metrics = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								actionMetrics: $author$project$RemoteData$Loaded(metrics)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								actionMetrics: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnComparativePageLikesMetricsResponse':
				if (msg.a.$ === 'Ok') {
					var likes = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								comparativePageLikes: $author$project$RemoteData$Loaded(likes)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								comparativePageLikes: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPageLikesMetricsResponse':
				if (msg.a.$ === 'Ok') {
					var likes = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								totalPageLikes: $author$project$RemoteData$Loaded(likes)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								totalPageLikes: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.a.$ === 'Ok') {
					var topList = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topList: $author$project$RemoteData$Loaded(topList)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topList: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Insights$Overview$Model$Flags = function (siteName) {
	return function (today) {
		return function (dateRange) {
			return function (insightsUrl) {
				return function (baseUrl) {
					return function (locale) {
						return function (translations) {
							return function (language) {
								return function (initialFilter) {
									return function (locationId) {
										return function (url) {
											return function (timezoneOffset) {
												return {url: url, today: today, locale: locale, baseUrl: baseUrl, language: language, siteName: siteName, dateRange: dateRange, locationId: locationId, insightsUrl: insightsUrl, translations: translations, initialFilter: initialFilter, timezoneOffset: timezoneOffset};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Listings$Ui$PresetDateRangePicker$Range = F2(
	function (from, to) {
		return {to: to, from: from};
	});
var $author$project$Common$Date$stringToDateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(x);
		if (_v0.$ === 'Ok') {
			var date_ = _v0.a;
			return $elm$json$Json$Decode$succeed(date_);
		} else {
			return $elm$json$Json$Decode$fail('Invalid date');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Insights$Overview$Decoders$dateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$Listings$Ui$PresetDateRangePicker$Range)));
var $author$project$Insights$Overview$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timezoneOffset',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'url',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'placeId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'initialFilter',
				$elm$json$Json$Decode$nullable(
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'language',
					$author$project$PinMeTo$Ui$I18n$Language$decoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'translations',
						$author$project$Common$Language$translationsDecoder,
						$author$project$Common$Language$initialTranslationsFallback,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['user', 'settings', 'locale']),
							$author$project$PinMeTo$Ui$I18n$Locale$decoder,
							$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'baseUrl',
								$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'insightsUrl',
									$elm_community$json_extra$Json$Decode$Extra$url,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'dateRange',
										$elm$json$Json$Decode$nullable($author$project$Insights$Overview$Decoders$dateRangeDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'today',
											$elm_community$json_extra$Json$Decode$Extra$datetime,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'siteName',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Insights$Overview$Model$Flags)))))))))))));
var $author$project$Insights$Overview$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$Overview$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$Overview$Model$OnUrlChange)
			]));
};
var $author$project$Insights$Overview$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$Overview$Main$init, view: $author$project$Insights$Overview$View$view, update: $author$project$Insights$Overview$Main$update, flagsDecoder: $author$project$Insights$Overview$Main$flagsDecoder, subscriptions: $author$project$Insights$Overview$Main$subscriptions});
var $author$project$Insights$Keywords$Commands$getDateRange = F4(
	function (_v0, model, msg, decoder) {
		var siteName = _v0.a;
		var _v1 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2('', $lukewestby$elm_http_builder$HttpBuilder$post),
			function (id) {
				return _Utils_Tuple2('/' + id, $lukewestby$elm_http_builder$HttpBuilder$get);
			},
			model.placeId);
		var locationParam = _v1.a;
		var httpRequest = _v1.b;
		var url = function (u) {
			return u + (siteName + ('/google/locations' + (locationParam + '/businessProfilePerformance/keywords/dateRange')));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, decoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						httpRequest(url)))));
	});
var $author$project$Insights$Keywords$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Insights$Keywords$Model$KeywordsDateRangeResponse = function (a) {
	return {$: 'KeywordsDateRangeResponse', a: a};
};
var $author$project$Insights$Keywords$Model$DateRange = F2(
	function (minDate, maxDate) {
		return {maxDate: maxDate, minDate: minDate};
	});
var $author$project$Insights$Keywords$Commands$googleKeywordsRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'latest',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'first',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$Insights$Keywords$Model$DateRange)));
var $author$project$Insights$Keywords$Main$init = F2(
	function (session, flags) {
		var firstOfLastMonthInPosix = A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Months, -1, flags.startOfMonth);
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var model = {
			placeId: flags.placeId,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			insightsUrl: flags.insightsUrl,
			keywordsData: $author$project$RemoteData$Loading,
			selectedRange: {to: firstOfLastMonthInPosix, from: firstOfLastMonthInPosix},
			filterController: $elm$core$Maybe$Just(filterControllerModel_),
			filterDefinition: $elm$core$Maybe$Nothing,
			supportedDateRange: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Insights$Keywords$Commands$getDateRange, session.siteName, model, $author$project$Insights$Keywords$Model$KeywordsDateRangeResponse, $author$project$Insights$Keywords$Commands$googleKeywordsRangeDecoder),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Keywords$Model$FilterControllerMsg, filterControllerCmd_)
					])));
	});
var $author$project$PinMeTo$Ui$DatePickerV2$withMax = F2(
	function (max_, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$DatePickerV2$View(
			_Utils_update(
				config,
				{
					max: $elm$core$Maybe$Just(max_)
				}));
	});
var $author$project$PinMeTo$Ui$DatePickerV2$withMin = F2(
	function (min_, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$DatePickerV2$View(
			_Utils_update(
				config,
				{
					min: $elm$core$Maybe$Just(min_)
				}));
	});
var $author$project$Translations$Listings$Insights$position = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.position');
};
var $author$project$Insights$Keywords$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$Insights$searchesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.searches_title');
};
var $author$project$Translations$Listings$Insights$keywordsTitleKeywords = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.keywords_title_keywords');
};
var $author$project$Translations$Listings$Insights$keywordsTitleLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.keywords_title_locations');
};
var $author$project$Insights$Keywords$View$listView = F3(
	function (model, keywordsData, translations) {
		var numberFormatHandler = function (number) {
			return (number < 15) ? '<15' : $author$project$Common$Math$formatNumber(number);
		};
		var keywordsToShow = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, item) {
					return {
						space: '    ',
						keyword: item.keyword,
						position: index + 1,
						searches: item.value,
						numberOfLocations: $elm$core$List$length(item.locationIds)
					};
				}),
			$elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.value;
					},
					keywordsData)));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body-1')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$PinMeTo$Ui$Table$render,
							model.uiTable,
							$author$project$PinMeTo$Ui$Table$withFullWidth(
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									'',
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.space;
										},
										$elm$html$Html$text),
									$author$project$PinMeTo$Ui$Table$comparing(
										function ($) {
											return $.space;
										}),
									A3(
										$author$project$PinMeTo$Ui$Table$when,
										_Utils_eq(model.placeId, $elm$core$Maybe$Nothing),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
											$author$project$Translations$Listings$Insights$keywordsTitleLocations(translations),
											_List_fromArray(
												[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact, $author$project$PinMeTo$Ui$Table$MaxWidth]),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.numberOfLocations;
												},
												A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.numberOfLocations;
												})),
										A5(
											$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
											$author$project$Translations$Listings$Insights$searchesTitle(translations),
											_List_fromArray(
												[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact, $author$project$PinMeTo$Ui$Table$MaxWidth]),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.searches;
												},
												A2($elm$core$Basics$composeR, numberFormatHandler, $elm$html$Html$text)),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.searches;
												}),
											A5(
												$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
												$author$project$Translations$Listings$Insights$keywordsTitleKeywords(translations),
												_List_fromArray(
													[$author$project$PinMeTo$Ui$Table$Compact, $author$project$PinMeTo$Ui$Table$MaxWidth]),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.keyword;
													},
													$elm$html$Html$text),
												$author$project$PinMeTo$Ui$Table$comparing(
													function ($) {
														return $.keyword;
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addCompactColumn,
													'',
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.space;
														},
														$elm$html$Html$text),
													$author$project$PinMeTo$Ui$Table$comparing(
														function ($) {
															return $.space;
														}),
													A5(
														$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
														$author$project$Translations$Listings$Insights$position(translations),
														_List_fromArray(
															[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact, $author$project$PinMeTo$Ui$Table$MaxWidth]),
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.position;
															},
															A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.position;
															}),
														A2(
															$author$project$PinMeTo$Ui$Table$withLimit,
															{
																limit: 50,
																viewMoreLabel: $author$project$Labels$viewMore(translations)
															},
															A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Keywords$Model$UiTableMsg, keywordsToShow))))))))))
						]))
				]));
	});
var $author$project$PinMeTo$Ui$DatePickerV2$MonthRange = {$: 'MonthRange'};
var $author$project$Insights$Keywords$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Insights$Keywords$Model$OnChangeRange = function (a) {
	return {$: 'OnChangeRange', a: a};
};
var $author$project$Translations$Listings$Insights$keywordsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.keywords_title');
};
var $author$project$Insights$Keywords$View$totalKeywords = function (keywordsData) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (item, acc) {
				return acc + item.value;
			}),
		0,
		keywordsData);
};
var $author$project$Translations$Listings$Insights$keywordsHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.keywords_header');
};
var $author$project$Translations$General$Insights$noDataCollected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.no_data_collected');
};
var $author$project$Insights$Keywords$Commands$filterQueryString = F4(
	function (_v0, model, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (id) {
				return '/' + id;
			},
			model.placeId);
		var filterQuery = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (filterController) {
				return '&' + A2(
					$elm$core$String$dropLeft,
					1,
					$author$project$Filter$FilterController$getCurrentFilterAsQueryString(filterController));
			},
			model.filterController);
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var from = $justinmimbs$date$Date$toIsoString(model.selectedRange.from);
		var to = $justinmimbs$date$Date$toIsoString(model.selectedRange.to);
		var query = '?from=' + (from + ('&to=' + (to + filterQuery)));
		var request = requestUrl + (siteName + ('/google/locations' + (locationParam + (endpoint + (fileTypeStr + query)))));
		return request;
	});
var $author$project$Translations$Listings$Insights$keywordsDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.keywords_description');
};
var $author$project$Translations$General$Insights$noDataCollectedNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.no_data_collected_note');
};
var $author$project$Translations$Listings$Insights$downloadKeywordsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_keywords_title');
};
var $author$project$PinMeTo$Ui$DatePickerV2$PlainLight = {$: 'PlainLight'};
var $author$project$PinMeTo$Ui$DatePickerV2$withPlainButtonToggle = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$DatePickerV2$View(
		_Utils_update(
			config,
			{toggleStyle: $author$project$PinMeTo$Ui$DatePickerV2$PlainLight}));
};
var $author$project$Insights$Keywords$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Insights$Keywords$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$html$Html$text(''),
				function (controller) {
					return A2(
						$elm$html$Html$map,
						$author$project$Insights$Keywords$Model$FilterControllerMsg,
						A4($author$project$Filter$FilterController$viewInsights, controller, session.locale, session.translations, session.language));
				},
				model.filterController),
			function (_v1) {
				return $elm$html$Html$text('');
			},
			model.placeId);
		var downloadConf = {
			uid: 'ui-select-download-keywords-google',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Keywords$Commands$filterQueryString, session.siteName, model, 'csv', '/businessProfilePerformance/keywords/download/'),
					label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
				},
					{
					url: A4($author$project$Insights$Keywords$Commands$filterQueryString, session.siteName, model, 'xlsx', '/businessProfilePerformance/keywords/download/'),
					label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadKeywordsTitle(session.translations),
			tagger: $author$project$Insights$Keywords$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Google-Keywords_' + ($justinmimbs$date$Date$toIsoString(model.selectedRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(model.selectedRange.to))))),
			onChange: $author$project$Insights$Keywords$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A2(
					$author$project$RemoteData$map,
					function (data) {
						return $elm$core$List$isEmpty(data);
					},
					model.keywordsData),
				$author$project$RemoteData$Loaded(false))
		};
		var asides = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (supportedDateRange) {
				return _List_fromArray(
					[
						$author$project$PinMeTo$Ui$DatePickerV2$render(
						A2(
							$author$project$PinMeTo$Ui$DatePickerV2$withMin,
							supportedDateRange.minDate,
							A2(
								$author$project$PinMeTo$Ui$DatePickerV2$withMax,
								supportedDateRange.maxDate,
								$author$project$PinMeTo$Ui$DatePickerV2$withPlainButtonToggle(
									A2(
										$author$project$PinMeTo$Ui$DatePickerV2$withType,
										$author$project$PinMeTo$Ui$DatePickerV2$MonthRange,
										$author$project$PinMeTo$Ui$DatePickerV2$view(
											{
												label: 'Select date',
												value: $elm$core$Maybe$Just(
													$author$project$PinMeTo$Ui$DatePickerV2$MonthRangeChanged(model.selectedRange)),
												locale: session.locale,
												language: session.language,
												onChange: $author$project$Insights$Keywords$Model$OnChangeRange
											})))))),
						A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadConf, model.uiSelect)
					]);
			},
			model.supportedDateRange);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					filterControllerHandler,
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
								$author$project$Translations$Listings$Insights$keywordsHeader(session.translations))))),
					function () {
					var _v0 = model.keywordsData;
					switch (_v0.$) {
						case 'Loaded':
							var keywordsData = _v0.a;
							return (!$elm$core$List$length(keywordsData)) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-empty-state__icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/static/pmt-ui/svg/empty-states/Empty_states_Insights.svg')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-empty-state__message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$General$Insights$noDataCollected(session.translations)),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												$author$project$Translations$General$Insights$noDataCollectedNote(session.translations))
											]))
									])) : A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('util__inset util__background--white insights-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-google-business-title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Insights$keywordsTitle(session.translations))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-google-business-keywords-description')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Insights$keywordsDescription(session.translations))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-google-business-total')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Common$Math$formatNumber(
													$author$project$Insights$Keywords$View$totalKeywords(keywordsData)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-insights__margin-top')
											]),
										_List_fromArray(
											[
												A3($author$project$Insights$Keywords$View$listView, model, keywordsData, session.translations)
											]))
									]));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						default:
							var errorKeywords = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(errorKeywords)
									]));
					}
				}()
				]));
	});
var $author$project$Insights$Keywords$Commands$getData = F4(
	function (_v0, model, msg, decoder) {
		var siteName = _v0.a;
		var _v1 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2('', $lukewestby$elm_http_builder$HttpBuilder$post),
			function (id) {
				return _Utils_Tuple2('/' + id, $lukewestby$elm_http_builder$HttpBuilder$get);
			},
			model.placeId);
		var locationParam = _v1.a;
		var httpRequest = _v1.b;
		var from = $justinmimbs$date$Date$toIsoString(model.selectedRange.from);
		var to = $justinmimbs$date$Date$toIsoString(model.selectedRange.to);
		var url = function (u) {
			return u + (siteName + ('/google/locations' + (locationParam + ('/businessProfilePerformance/keywords' + ('?from=' + (from + ('&to=' + to)))))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, decoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						httpRequest(url)))));
	});
var $author$project$Insights$Keywords$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Keywords$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Keywords$Model$KeywordsDataResponse = function (a) {
	return {$: 'KeywordsDataResponse', a: a};
};
var $author$project$Insights$Keywords$Model$GoogleKeyword = F3(
	function (keyword, value, locationIds) {
		return {value: value, keyword: keyword, locationIds: locationIds};
	});
var $author$project$Insights$Keywords$Commands$googleKeywordsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'locationIds',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'keyword',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Insights$Keywords$Model$GoogleKeyword))));
var $author$project$Insights$Keywords$Commands$googleKeywordsListDecoder = $elm$json$Json$Decode$list($author$project$Insights$Keywords$Commands$googleKeywordsDecoder);
var $author$project$Insights$Keywords$Main$out_Insights_Keywords_Main_onFilter = _Platform_outgoingPort('out_Insights_Keywords_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Keywords$Main$getKeywordsWhenDateRangeAndFilterDefinitionAreSet = F2(
	function (session, model) {
		return ((!_Utils_eq(model.filterDefinition, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.supportedDateRange, $elm$core$Maybe$Nothing))) ? A4($author$project$Insights$Keywords$Commands$getData, session.siteName, model, $author$project$Insights$Keywords$Model$KeywordsDataResponse, $author$project$Insights$Keywords$Commands$googleKeywordsListDecoder) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Insights$Keywords$Main$update = F3(
	function (pinmetoSession, msg, model) {
		switch (msg.$) {
			case 'KeywordsDataResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								keywordsData: $author$project$RemoteData$Loaded(x)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								keywordsData: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Google.Main.KeywordsDataResponse'),
							e));
				}
			case 'KeywordsDateRangeResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							keywordsData: $author$project$RemoteData$Loading,
							selectedRange: {to: x.maxDate, from: x.maxDate},
							supportedDateRange: $elm$core$Maybe$Just(
								{maxDate: x.maxDate, minDate: x.minDate})
						});
					return _Utils_Tuple2(
						newModel,
						A2($author$project$Insights$Keywords$Main$getKeywordsWhenDateRangeAndFilterDefinitionAreSet, pinmetoSession, newModel));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								keywordsData: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Google.Main.KeywordsDateRangeResponse'),
							e));
				}
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (model_) {
						var _v1 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Keywords$Model$FilterControllerMsg, msg_, model_, $author$project$Insights$Keywords$Model$OnFilter, $author$project$Insights$Keywords$Model$OnSearch);
						var filterControllerModel_ = _v1.a;
						var filterControllerCmd_ = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									filterController: $elm$core$Maybe$Just(filterControllerModel_)
								}),
							filterControllerCmd_);
					},
					model.filterController);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						filterDefinition: $elm$core$Maybe$Just(filterDefinition)
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Insights$Keywords$Main$getKeywordsWhenDateRangeAndFilterDefinitionAreSet, pinmetoSession, newModel),
								$author$project$Insights$Keywords$Main$out_Insights_Keywords_Main_onFilter(filterDefinition)
							])));
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnDownloadLabelClicked':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Keywords$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'OnChangeRange':
				var datePickerChangeType = msg.a;
				if (datePickerChangeType.$ === 'MonthRangeChanged') {
					var range = datePickerChangeType.a;
					var newModel = _Utils_update(
						model,
						{keywordsData: $author$project$RemoteData$Loading, selectedRange: range});
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4($author$project$Insights$Keywords$Commands$getData, pinmetoSession.siteName, newModel, $author$project$Insights$Keywords$Model$KeywordsDataResponse, $author$project$Insights$Keywords$Commands$googleKeywordsListDecoder)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Insights$Keywords$Model$Flags = F6(
	function (today, insightsUrl, baseUrl, initialFilter, placeId, startOfMonth) {
		return {today: today, baseUrl: baseUrl, placeId: placeId, insightsUrl: insightsUrl, startOfMonth: startOfMonth, initialFilter: initialFilter};
	});
var $author$project$Insights$Keywords$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'startOfMonth',
	$author$project$Common$Date$stringToDateDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'placeId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'initialFilter',
			$elm$json$Json$Decode$nullable(
				$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'baseUrl',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'insightsUrl',
					$elm_community$json_extra$Json$Decode$Extra$url,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'today',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						$elm$json$Json$Decode$succeed($author$project$Insights$Keywords$Model$Flags)))))));
var $author$project$Insights$Keywords$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Insights$Keywords$Main$init,
		view: $author$project$Insights$Keywords$View$view,
		update: $author$project$Insights$Keywords$Main$update,
		flagsDecoder: $author$project$Insights$Keywords$Main$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$PinMeTo$Ui$DateRangePicker$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$OnTime = function (a) {
	return {$: 'OnTime', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$init = _Utils_Tuple2(
	$author$project$PinMeTo$Ui$DateRangePicker$State(
		{
			time: $elm$time$Time$millisToPosix(0),
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			selectedPreset: $elm$core$Maybe$Nothing
		}),
	A2($elm$core$Task$perform, $author$project$PinMeTo$Ui$DateRangePicker$OnTime, $elm$time$Time$now));
var $author$project$Insights$Facebook$Model$Collapsed = {$: 'Collapsed'};
var $author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack = F2(
	function (time, days) {
		var rangeTo = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, time);
		return {
			to: rangeTo,
			from: A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Days, -(days - 1), rangeTo)
		};
	});
var $author$project$Insights$Facebook$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Insights$Facebook$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$Range = F2(
	function (from, to) {
		return {to: to, from: from};
	});
var $author$project$Insights$Facebook$Decoders$supportedDateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxDate',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minDate',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$Facebook$Commands$getFacebookSupportedDateRange = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var httpRequest = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$lukewestby$elm_http_builder$HttpBuilder$get,
			function (_v1) {
				return $lukewestby$elm_http_builder$HttpBuilder$get;
			},
			model.locationId);
		var url = function (u) {
			return u + (siteName + '/facebook/locations/metrics/supportedDateRange');
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Facebook$Decoders$supportedDateRangeDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					httpRequest(url))));
	});
var $author$project$Insights$Facebook$Model$FacebookSupportedDateRangeResponse = function (a) {
	return {$: 'FacebookSupportedDateRangeResponse', a: a};
};
var $author$project$Insights$Facebook$Main$out_Insights_Facebook_Main_onRangeChange = _Platform_outgoingPort('out_Insights_Facebook_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$Facebook$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var uiDateRangePicker = $author$project$PinMeTo$Ui$DateRangePicker$init;
		var timezone = A2($elm$time$Time$customZone, flags.timezoneOffset, _List_Nil);
		var model = {
			range: A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 28),
				flags.dateRange),
			today: flags.today,
			baseUrl: flags.url,
			topList: $author$project$RemoteData$Loading,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			lifetime: $elm$core$Maybe$Nothing,
			timezone: timezone,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			locationId: flags.locationId,
			uiFeedback: $author$project$Listings$Ui$Feedback$init,
			insightsUrl: flags.insightsUrl,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			initialFilter: flags.initialFilter,
			showLocations: true,
			mergedInsights: $author$project$RemoteData$Loading,
			showBrandPages: _Utils_eq(flags.locationId, $elm$core$Maybe$Nothing),
			filterController: filterControllerModel_,
			filterDefinition: $elm$core$Maybe$Nothing,
			locationInsights: $author$project$RemoteData$Loading,
			brandPageInsights: $author$project$RemoteData$Loading,
			uiDateRangePicker: uiDateRangePicker.a,
			legacyInsightsState: $author$project$Insights$Facebook$Model$Collapsed,
			topListAmountToShow: 5
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Insights$Facebook$Commands$getFacebookSupportedDateRange, model, session.siteName, $author$project$Insights$Facebook$Model$FacebookSupportedDateRangeResponse),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Facebook$Model$DateRangePickerMsg, uiDateRangePicker.b),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Facebook$Model$FilterControllerMsg, filterControllerCmd_),
						$author$project$Insights$Facebook$Main$out_Insights_Facebook_Main_onRangeChange(
						$author$project$Insights$Utils$encodeDateRange(model.range))
					])));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$DaysBack = function (a) {
	return {$: 'DaysBack', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$defaultRanges = _List_fromArray(
	[
		$author$project$PinMeTo$Ui$DateRangePicker$DaysBack(7),
		$author$project$PinMeTo$Ui$DateRangePicker$DaysBack(14),
		$author$project$PinMeTo$Ui$DateRangePicker$DaysBack(28)
	]);
var $author$project$PinMeTo$Ui$DateRangePicker$view = function (config) {
	return $author$project$PinMeTo$Ui$DateRangePicker$View(
		{uid: config.uid, range: config.range, labels: config.labels, locale: config.locale, ranges: _List_Nil, tagger: config.tagger, language: config.language, defaultRanges: $author$project$PinMeTo$Ui$DateRangePicker$defaultRanges});
};
var $author$project$FontAwesome$Regular$Icon$faChevronUp = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-chevron-up');
var $author$project$FontAwesome$Regular$faChevronUp = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faChevronUp);
var $author$project$Insights$Facebook$Model$getDateLabel = function (model) {
	var toString = function (date) {
		return $justinmimbs$date$Date$toIsoString(date);
	};
	var from = toString(model.range.from);
	var to = toString(model.range.to);
	return from + (' - ' + to);
};
var $author$project$Insights$Facebook$Model$ToggleLegacyInsights = {$: 'ToggleLegacyInsights'};
var $author$project$Insights$Facebook$Model$Impressions = {$: 'Impressions'};
var $author$project$Translations$General$Insights$impressions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.impressions');
};
var $author$project$Insights$Facebook$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Translations$Listings$Insights$feedbackLabel = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.feedback_label');
};
var $author$project$Insights$Facebook$View$Charts$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: $author$project$Translations$Listings$Insights$feedbackLabel(translations),
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Facebook$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Insights$Facebook$View$Charts$renderAsides = F3(
	function (session, model, uid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
						]),
					_List_fromArray(
						[
							A3($author$project$Insights$Facebook$View$Charts$uiFeedback, session.translations, uid, model.uiFeedback)
						]))
				]));
	});
var $author$project$Insights$Facebook$Model$OnPopOver = F2(
	function (a, b) {
		return {$: 'OnPopOver', a: a, b: b};
	});
var $author$project$Translations$Listings$Insights$facebookLikesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.facebook_likes_popover');
};
var $author$project$Translations$Listings$Insights$facebookReachPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.facebook_reach_popover');
};
var $author$project$Translations$Listings$Insights$facebookImpressionsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.facebook_impressions_popover');
};
var $author$project$Translations$Listings$Insights$facebookTopListingsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.facebook_top_listings_popover');
};
var $author$project$Insights$Facebook$View$Charts$popOverConfig = F2(
	function (popOverConfigType, translations) {
		var _v0 = function () {
			switch (popOverConfigType.$) {
				case 'Impressions':
					return _Utils_Tuple2(
						'facebook-metrics-impressions-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$facebookImpressionsPopover(translations))
							]));
				case 'Reach':
					return _Utils_Tuple2(
						'facebook-metrics-reach-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$facebookReachPopover(translations))
							]));
				case 'Likes':
					return _Utils_Tuple2(
						'facebook-metrics-likes-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$facebookLikesPopover(translations))
							]));
				default:
					return _Utils_Tuple2(
						'facebook-metrics-top-list-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$facebookTopListingsPopover(translations))
							]));
			}
		}();
		var uid = _v0.a;
		var content = _v0.b;
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: uid,
				tagger: $author$project$Insights$Facebook$Model$OnPopOver(popOverConfigType),
				content: content,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Translations$General$Insights$paid = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.paid');
};
var $author$project$Translations$General$Insights$likes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.likes');
};
var $author$project$Translations$General$Insights$actions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.actions');
};
var $author$project$Translations$General$Insights$organic = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.organic');
};
var $author$project$Insights$Facebook$View$Charts$areaChartTitleAndColor = F2(
	function (translations, metricData) {
		var _v0 = metricData.metricName;
		switch (_v0) {
			case 'page_impressions_paid':
				return {
					data: metricData.metrics,
					color: '#61D173',
					title: $author$project$Translations$General$Insights$paid(translations)
				};
			case 'page_impressions_organic':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$General$Insights$organic(translations)
				};
			case 'page_impressions_organic_unique':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$General$Insights$organic(translations)
				};
			case 'page_impressions_paid_unique':
				return {
					data: metricData.metrics,
					color: '#61D173',
					title: $author$project$Translations$General$Insights$paid(translations)
				};
			case 'page_fans':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$General$Insights$likes(translations)
				};
			case 'page_total_actions':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$General$Insights$actions(translations)
				};
			case 'page_fan_adds':
				return {data: metricData.metrics, color: '#61D173', title: 'Likes added'};
			case 'page_fan_removes':
				return {
					data: A2(
						$elm$core$List$map,
						function (metric) {
							return _Utils_update(
								metric,
								{value: -metric.value});
						},
						metricData.metrics),
					color: '#E96687',
					title: 'Likes removed'
				};
			default:
				return {data: _List_Nil, color: '#FFC107', title: ''};
		}
	});
var $author$project$Insights$Facebook$View$Charts$sortAndFilterByDataKeys = F3(
	function (session, dataKeys, metricData) {
		var getMetricIndex = F2(
			function (metricName, metricKeys) {
				var _v0 = A2($elm_community$list_extra$List$Extra$elemIndex, metricName, metricKeys);
				if (_v0.$ === 'Just') {
					var index = _v0.a;
					return index;
				} else {
					return -1;
				}
			});
		return A2(
			$elm$core$List$filterMap,
			function (metric) {
				return A2($elm$core$List$member, metric.metricName, dataKeys) ? $elm$core$Maybe$Just(
					A2($author$project$Insights$Facebook$View$Charts$areaChartTitleAndColor, session.translations, metric)) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$sortBy,
				function (metric) {
					return A2(getMetricIndex, metric.metricName, dataKeys);
				},
				metricData));
	});
var $author$project$Translations$General$Insights$facebookImpressionsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.insights.facebook_impressions_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Facebook$View$Charts$renderImpressionsChart = F4(
	function (session, model, locationInsights, dateLabel) {
		var impressionsKeys = _List_fromArray(
			['page_impressions_organic', 'page_impressions_paid']);
		var impressionsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A3($author$project$Insights$Facebook$View$Charts$sortAndFilterByDataKeys, session, impressionsKeys, locationInsights));
		var impressionsChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, impressionsData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(impressionsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Facebook$View$Charts$renderAsides, session, model, 'facebook-insights-impresssions'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Facebook$View$Charts$popOverConfig, $author$project$Insights$Facebook$Model$Impressions, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$General$Insights$facebookImpressionsDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$General$Insights$impressions(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[impressionsChart])))));
	});
var $author$project$PinMeTo$Ui$Chart$Bar = function (a) {
	return {$: 'Bar', a: a};
};
var $author$project$Insights$Facebook$Model$Likes = {$: 'Likes'};
var $author$project$PinMeTo$Ui$Chart$withStackingX = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$View(
		_Utils_update(
			config,
			{withStackingX: true}));
};
var $author$project$Translations$General$Insights$facebookLikesDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.insights.facebook_likes_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange', dateRange)
				]));
	});
var $author$project$Insights$Facebook$View$Charts$renderLikesChart = F4(
	function (session, model, locationInsights, dateLabel) {
		var likesKeys = _List_fromArray(
			['page_fan_adds', 'page_fan_removes']);
		var likesData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A3($author$project$Insights$Facebook$View$Charts$sortAndFilterByDataKeys, session, likesKeys, locationInsights));
		var metricChart = $author$project$PinMeTo$Ui$Chart$render(
			A2(
				$author$project$PinMeTo$Ui$Chart$withLocale,
				session.locale,
				$author$project$PinMeTo$Ui$Chart$withStackingX(
					A2(
						$author$project$PinMeTo$Ui$Chart$withLegendConfig,
						$author$project$PinMeTo$Ui$Chart$Legend$withTotal,
						$author$project$PinMeTo$Ui$Chart$view(
							{
								chart: $author$project$PinMeTo$Ui$Chart$Bar(likesData)
							})))));
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withAsides,
						A3($author$project$Insights$Facebook$View$Charts$renderAsides, session, model, 'facebook-insights-likes'),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withPopOver,
							_Utils_Tuple2(
								A2($author$project$Insights$Facebook$View$Charts$popOverConfig, $author$project$Insights$Facebook$Model$Likes, session.translations),
								model.popOverState),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withNote,
								$elm$html$Html$text(
									A2($author$project$Translations$General$Insights$facebookLikesDescription, session.translations, dateLabel)),
								$author$project$Listings$Ui$InsightsHeader$view(
									{
										title: $author$project$Translations$General$Insights$likes(session.translations)
									}))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[metricChart])))));
	});
var $author$project$Insights$Facebook$Model$Reach = {$: 'Reach'};
var $author$project$Translations$General$Insights$reach = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.reach');
};
var $author$project$Translations$General$Insights$facebookReachDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.insights.facebook_reach_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Facebook$View$Charts$renderReachChart = F4(
	function (session, model, locationInsights, dateLabel) {
		var reachKeys = _List_fromArray(
			['page_impressions_organic_unique', 'page_impressions_paid_unique']);
		var reachData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A3($author$project$Insights$Facebook$View$Charts$sortAndFilterByDataKeys, session, reachKeys, locationInsights));
		var reachChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, reachData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(reachData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Facebook$View$Charts$renderAsides, session, model, 'facebook-insights-reach'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Facebook$View$Charts$popOverConfig, $author$project$Insights$Facebook$Model$Reach, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$General$Insights$facebookReachDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$General$Insights$reach(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[reachChart])))));
	});
var $author$project$Translations$Listings$Insights$facebookDiscontinuedReachLikes = F2(
	function (translations, date) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.facebook_discontinued_reach_likes',
			_List_fromArray(
				[
					_Utils_Tuple2(' date ', date)
				]));
	});
var $author$project$Insights$Facebook$Model$facebookMetricsDeprecationDate = '2025-10-27';
var $author$project$Insights$Facebook$View$MetricSection$facebookDiscontinuationBanner = F4(
	function (session, model, locationInsights, dateLabel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '1rem')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Note,
						$author$project$PinMeTo$Ui$Alert$plain(
							A2($author$project$Translations$Listings$Insights$facebookDiscontinuedReachLikes, session.translations, $author$project$Insights$Facebook$Model$facebookMetricsDeprecationDate)))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A4($author$project$Insights$Facebook$View$Charts$renderReachChart, session, model, locationInsights, dateLabel),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A4($author$project$Insights$Facebook$View$Charts$renderLikesChart, session, model, locationInsights, dateLabel)
				]));
	});
var $author$project$Insights$Facebook$View$MetricSection$view = F3(
	function (session, model, insightsToDisplay) {
		var dateLabel = $author$project$Insights$Facebook$Model$getDateLabel(model);
		switch (insightsToDisplay.$) {
			case 'Suspended':
				return $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations));
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Loaded':
				var locationInsights = insightsToDisplay.a;
				if ($elm$core$List$isEmpty(locationInsights)) {
					return $author$project$PinMeTo$Ui$EmptyState$insights(
						$author$project$Translations$General$Insights$noData(session.translations));
				} else {
					var legacyInsightsSection = A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-top', '2rem'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '2rem')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'display', 'flex'),
										A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
										A2($elm$html$Html$Attributes$style, 'padding', '1rem'),
										A2($elm$html$Html$Attributes$style, 'background-color', '#f3f4f6'),
										A2($elm$html$Html$Attributes$style, 'border-radius', '0.5rem'),
										A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
										$elm$html$Html$Events$onClick($author$project$Insights$Facebook$Model$ToggleLegacyInsights)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'font-weight', '600'),
												A2($elm$html$Html$Attributes$style, 'flex-grow', '1')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Legacy Insights')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'color', '#6b7280'),
												A2($elm$html$Html$Attributes$style, 'display', 'flex'),
												A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
												A2($elm$html$Html$Attributes$style, 'gap', '0.5rem')
											]),
										function () {
											var _v1 = model.legacyInsightsState;
											if (_v1.$ === 'Expanded') {
												return _List_fromArray(
													[
														$elm$html$Html$text('Hide'),
														$author$project$FontAwesome$Regular$faChevronUp
													]);
											} else {
												return _List_fromArray(
													[
														$elm$html$Html$text('Show'),
														$author$project$FontAwesome$Regular$faChevronDown
													]);
											}
										}())
									])),
								function () {
								var _v2 = model.legacyInsightsState;
								if (_v2.$ === 'Expanded') {
									return A4($author$project$Insights$Facebook$View$MetricSection$facebookDiscontinuationBanner, session, model, locationInsights, dateLabel);
								} else {
									return $elm$html$Html$text('');
								}
							}()
							]));
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A4($author$project$Insights$Facebook$View$Charts$renderImpressionsChart, session, model, locationInsights, dateLabel),
								legacyInsightsSection
							]));
				}
			default:
				var e = insightsToDisplay.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Insights$Facebook$Model$TopList = {$: 'TopList'};
var $author$project$Insights$Facebook$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Translations$General$topListings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_listings');
};
var $author$project$Insights$Facebook$Model$filterQueryString = F5(
	function (model, _v0, fileTypeStr, endpoint, isTopList) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (id) {
				return '/' + id;
			},
			model.locationId);
		var filterQuery = '&' + A2(
			$elm$core$String$dropLeft,
			1,
			$author$project$Filter$FilterController$getCurrentFilterAsQueryString(model.filterController));
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var dateRange = model.range;
		var query = '?from=' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('&to=' + ($justinmimbs$date$Date$toIsoString(dateRange.to) + filterQuery)));
		return _Utils_ap(
			requestUrl,
			_Utils_ap(
				siteName,
				_Utils_ap(
					function () {
						if (isTopList) {
							return '/facebook/locations';
						} else {
							var _v1 = _Utils_Tuple2(model.showLocations, model.showBrandPages);
							if (_v1.b) {
								if (_v1.a) {
									return '/facebook/locations-and-brand-pages';
								} else {
									return '/facebook/brandpages';
								}
							} else {
								return '/facebook/locations';
							}
						}
					}(),
					_Utils_ap(
						locationParam,
						_Utils_ap(
							endpoint,
							_Utils_ap(fileTypeStr, query))))));
	});
var $author$project$Insights$Facebook$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$Insights$facebookTopListAddedLikes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.facebook_top_list_added_likes');
};
var $author$project$Translations$Listings$Insights$facebookTopListRemovedLikes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.facebook_top_list_removed_likes');
};
var $author$project$Insights$Facebook$View$TopListSection$renderTopList = F4(
	function (session, model, topList, sortedBy) {
		var compactRightContent = _List_fromArray(
			[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]);
		var site = $author$project$Data$SiteName$toString(session.siteName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-apple-insights-top-list')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						$author$project$Translations$General$locationCountry(session.translations),
						A2(
							$elm$core$Basics$composeR,
							function (item) {
								return item.address.country;
							},
							$elm$html$Html$text),
						$author$project$PinMeTo$Ui$Table$comparing(
							function (item) {
								return item.address.country;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							$author$project$Translations$General$locationCity(session.translations),
							A2(
								$elm$core$Basics$composeR,
								function (item) {
									return item.address.city;
								},
								$elm$html$Html$text),
							$author$project$PinMeTo$Ui$Table$comparing(
								function (item) {
									return item.address.city;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$General$locationZip(session.translations),
								A2(
									$elm$core$Basics$composeR,
									function (item) {
										return item.address.zip;
									},
									$elm$html$Html$text),
								$author$project$PinMeTo$Ui$Table$comparing(
									function (item) {
										return item.address.zip;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addCompactColumn,
									$author$project$Translations$General$locationStreet(session.translations),
									A2(
										$elm$core$Basics$composeR,
										function (item) {
											return item.address.street;
										},
										$elm$html$Html$text),
									$author$project$PinMeTo$Ui$Table$comparing(
										function (item) {
											return item.address.street;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addCompactColumn,
										$author$project$Translations$General$locationDescriptor(session.translations),
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.locationDescriptor;
											},
											$elm$html$Html$text),
										$author$project$PinMeTo$Ui$Table$comparing(
											function ($) {
												return $.locationDescriptor;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$name(session.translations),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.name;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.name;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationStoreId(session.translations),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.storeId;
													},
													$elm$html$Html$text),
												A2(
													$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
													30,
													function ($) {
														return $.storeId;
													}),
												A5(
													$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
													$author$project$Translations$Listings$Insights$facebookTopListRemovedLikes(session.translations),
													compactRightContent,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.removedLikes;
														},
														A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
													$author$project$PinMeTo$Ui$Table$comparing(
														function ($) {
															return $.removedLikes;
														}),
													A5(
														$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
														$author$project$Translations$Listings$Insights$facebookTopListAddedLikes(session.translations),
														compactRightContent,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.addedLikesUnique;
															},
															A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.addedLikesUnique;
															}),
														A5(
															$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
															$author$project$Translations$General$Insights$reach(session.translations),
															compactRightContent,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.reach;
																},
																A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
															$author$project$PinMeTo$Ui$Table$comparing(
																function ($) {
																	return $.reach;
																}),
															A5(
																$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
																$author$project$Translations$General$Insights$impressions(session.translations),
																compactRightContent,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.impressions;
																	},
																	A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
																$author$project$PinMeTo$Ui$Table$comparing(
																	function ($) {
																		return $.impressions;
																	}),
																A2(
																	$author$project$PinMeTo$Ui$Table$withRowLink,
																	function (location) {
																		return '/listings/' + (site + ('/locations/' + (location.locationId + '/details')));
																	},
																	A2(
																		$author$project$PinMeTo$Ui$Table$withLimit,
																		{
																			limit: model.topListAmountToShow,
																			viewMoreLabel: F2(
																				function (_v0, _v1) {
																					return 'Show more';
																				})
																		},
																		$author$project$PinMeTo$Ui$Table$withScrollableTable(
																			$author$project$PinMeTo$Ui$Table$withStickyHeader(
																				A2(
																					$author$project$PinMeTo$Ui$Table$withSort,
																					sortedBy,
																					A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Facebook$Model$UiTableMsg, topList))))))))))))))))))
				]));
	});
var $author$project$Insights$Facebook$View$TopListSection$renderViewSelector = F2(
	function (session, model) {
		var topListMetricsData = function () {
			var _v0 = model.topList;
			if (_v0.$ === 'Loaded') {
				var topListData = _v0.a;
				return topListData;
			} else {
				return _List_Nil;
			}
		}();
		var sortedBy = A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$Table$Desc(0),
			$author$project$PinMeTo$Ui$Table$getSort(model.uiTable));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Insights$Facebook$View$TopListSection$renderTopList, session, model, topListMetricsData, sortedBy)
				]));
	});
var $author$project$Translations$Listings$Insights$downloadToplistTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_toplist_title');
};
var $author$project$Insights$Facebook$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Translations$General$topListingsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.top_listings_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Translations$Listings$Insights$facebookDiscontinuedMetrics = F2(
	function (translations, date) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.facebook_discontinued_metrics',
			_List_fromArray(
				[
					_Utils_Tuple2(' date ', date)
				]));
	});
var $author$project$Insights$Facebook$View$TopListSection$view = F2(
	function (session, model) {
		var titleWithPopOver = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$topListings(session.translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.popOverState,
							A2($author$project$Insights$Facebook$View$Charts$popOverConfig, $author$project$Insights$Facebook$Model$TopList, session.translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$General$topListingsDescription,
								session.translations,
								$author$project$Insights$Facebook$Model$getDateLabel(model)))
						]))
				]));
		var deprecationAlert = $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Note,
				$author$project$PinMeTo$Ui$Alert$plain(
					A2($author$project$Translations$Listings$Insights$facebookDiscontinuedMetrics, session.translations, $author$project$Insights$Facebook$Model$facebookMetricsDeprecationDate))));
		var dateRange = model.range;
		var downloadConf = {
			uid: 'ui-select-download-toplist-facebook',
			items: _List_fromArray(
				[
					{
					url: A5($author$project$Insights$Facebook$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/topList/download/', true),
					label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
				},
					{
					url: A5($author$project$Insights$Facebook$Model$filterQueryString, model, session.siteName, 'xlsx', '/metrics/topList/download/', true),
					label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadToplistTitle(session.translations),
			tagger: $author$project$Insights$Facebook$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Facebook-top-list_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Facebook$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A2(
					$author$project$RemoteData$map,
					function (data) {
						return $elm$core$List$isEmpty(data);
					},
					model.topList),
				$author$project$RemoteData$Loaded(false))
		};
		var asides = _List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
				$author$project$Translations$Listings$Insights$downloadDetailedDataTooltip(session.translations),
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadConf, model.uiSelect)
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(titleWithPopOver)))),
					deprecationAlert,
					function () {
					var _v0 = model.topList;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Loaded':
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Insights$Facebook$View$TopListSection$renderViewSelector, session, model)
									]));
						default:
							var e = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$presetToRange = F2(
	function (time, preset) {
		var today = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, time);
		switch (preset.$) {
			case 'DaysBack':
				var days = preset.a;
				return {
					to: today,
					from: A3($justinmimbs$date$Date$add, $justinmimbs$date$Date$Days, -(days - 1), today)
				};
			case 'Labeled':
				var range = preset.c;
				return range;
			default:
				var range = preset.a;
				return range;
		}
	});
var $author$project$PinMeTo$Ui$DateRangePicker$presetToString = F2(
	function (labels, preset) {
		switch (preset.$) {
			case 'DaysBack':
				var days = preset.a;
				return labels.daysBack(days);
			case 'Labeled':
				var label = preset.a.a;
				return label;
			default:
				var range = preset.a;
				return labels.days(
					A3($justinmimbs$date$Date$diff, $justinmimbs$date$Date$Days, range.from, range.to) + 1);
		}
	});
var $author$project$PinMeTo$Ui$DateRangePicker$OnPresetSelected = function (a) {
	return {$: 'OnPresetSelected', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$renderPresets = F3(
	function (config, model, presets) {
		var isCurrent = function (preset) {
			return _Utils_eq(
				A2($author$project$PinMeTo$Ui$DateRangePicker$presetToRange, model.time, preset),
				config.range);
		};
		return A2(
			$elm$core$List$map,
			function (preset) {
				return $author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$PinMeTo$Ui$DateRangePicker$OnPresetSelected(preset),
						A2(
							$author$project$PinMeTo$Ui$Button$withGhostStyle,
							$author$project$PinMeTo$Ui$Button$GhostNeutral,
							A2(
								$author$project$PinMeTo$Ui$Button$disabledIfTrue,
								isCurrent(preset),
								A2(
									$author$project$PinMeTo$Ui$Button$withSize,
									$author$project$PinMeTo$Ui$Button$Small,
									$author$project$PinMeTo$Ui$Button$buttonGhost(
										A2($author$project$PinMeTo$Ui$DateRangePicker$presetToString, config.labels, preset)))))));
			},
			presets);
	});
var $author$project$PinMeTo$Ui$DatePickerV2$DateRange = {$: 'DateRange'};
var $author$project$PinMeTo$Ui$DatePickerV2$withRenderInline = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$DatePickerV2$View(
		_Utils_update(
			config,
			{inline: true}));
};
var $author$project$PinMeTo$Ui$DateRangePicker$OnDateRangeChanged = F2(
	function (a, b) {
		return {$: 'OnDateRangeChanged', a: a, b: b};
	});
var $author$project$PinMeTo$Ui$DateRangePicker$renderDatePicker = F2(
	function (_v0, model) {
		var config = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$DatePickerV2$render(
					$author$project$PinMeTo$Ui$DatePickerV2$withRenderInline(
						A2(
							$author$project$PinMeTo$Ui$DatePickerV2$withType,
							$author$project$PinMeTo$Ui$DatePickerV2$DateRange,
							A2(
								$author$project$PinMeTo$Ui$DatePickerV2$withMax,
								A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.time),
								$author$project$PinMeTo$Ui$DatePickerV2$view(
									{
										label: '',
										value: $elm$core$Maybe$Just(
											$author$project$PinMeTo$Ui$DatePickerV2$MonthRangeChanged(config.range)),
										locale: config.locale,
										language: config.language,
										onChange: $author$project$PinMeTo$Ui$DateRangePicker$OnDateRangeChanged(config.range)
									})))))
				]));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$renderDropdown = F2(
	function (_v0, model) {
		var config = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-date-range-picker__dropdown')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-date-range-picker__presets')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (x) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[x]));
								},
								A3($author$project$PinMeTo$Ui$DateRangePicker$renderPresets, config, model, config.defaultRanges))),
							function () {
							var _v1 = config.ranges;
							if (!_v1.b) {
								return $elm$html$Html$text('');
							} else {
								var ranges = _v1;
								return A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (x) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[x]));
										},
										A3($author$project$PinMeTo$Ui$DateRangePicker$renderPresets, config, model, ranges)));
							}
						}()
						])),
					A2(
					$author$project$PinMeTo$Ui$DateRangePicker$renderDatePicker,
					$author$project$PinMeTo$Ui$DateRangePicker$View(config),
					model)
				]));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$rangeToPreset = F3(
	function (config, time, dateRange) {
		var presetIsEqualToRange = F2(
			function (range, preset) {
				switch (preset.$) {
					case 'Labeled':
						var range_ = preset.c;
						return _Utils_eq(range_, range);
					case 'Custom':
						var range_ = preset.a;
						return _Utils_eq(range_, range);
					default:
						var days = preset.a;
						return _Utils_eq(
							range,
							A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, time, days));
				}
			});
		var allRanges = _Utils_ap(config.defaultRanges, config.ranges);
		var today = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, time);
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$find,
			presetIsEqualToRange(dateRange),
			allRanges);
		if (_v0.$ === 'Just') {
			var preset = _v0.a;
			return preset;
		} else {
			return _Utils_eq(dateRange.to, today) ? $author$project$PinMeTo$Ui$DateRangePicker$DaysBack(
				A3($justinmimbs$date$Date$diff, $justinmimbs$date$Date$Days, dateRange.from, today) + 1) : $author$project$PinMeTo$Ui$DateRangePicker$Custom(dateRange);
		}
	});
var $author$project$PinMeTo$Ui$DateRangePicker$renderDateRangeToggle = F2(
	function (config, model) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-date-range-picker-toggle')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-date-range-picker-toggle__part pmt-ui-date-range-picker-toggle__preset')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$PinMeTo$Ui$DateRangePicker$presetToString,
								config.labels,
								A3($author$project$PinMeTo$Ui$DateRangePicker$rangeToPreset, config, model.time, config.range))),
							$author$project$FontAwesome$Regular$faChevronDown
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-date-range-picker-toggle__part pmt-ui-date-range-picker-toggle__dates')
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$Light$faCalendar,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-date-range-picker-toggle__date-range')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Date$render(
									A2(
										$author$project$PinMeTo$Ui$Date$withFormat,
										$author$project$PinMeTo$Ui$Date$FormatDate,
										A2(
											$author$project$PinMeTo$Ui$Date$string,
											config.locale,
											$justinmimbs$date$Date$toIsoString(config.range.from)))),
									$elm$html$Html$text('–'),
									$author$project$PinMeTo$Ui$Date$render(
									A2(
										$author$project$PinMeTo$Ui$Date$withFormat,
										$author$project$PinMeTo$Ui$Date$FormatDate,
										A2(
											$author$project$PinMeTo$Ui$Date$string,
											config.locale,
											$justinmimbs$date$Date$toIsoString(config.range.to))))
								]))
						]))
				]));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-date-range-picker')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					config.tagger,
					A2(
						$author$project$PinMeTo$Ui$Select$render,
						model.uiSelect,
						$author$project$PinMeTo$Ui$Select$withWrapperToggle(
							$author$project$PinMeTo$Ui$Select$raw(
								{
									uid: 'date-range-picker-' + config.uid,
									items: _List_fromArray(
										[_Utils_Tuple0]),
									label: A2($author$project$PinMeTo$Ui$DateRangePicker$renderDateRangeToggle, config, model),
									tagger: $author$project$PinMeTo$Ui$DateRangePicker$UiSelectMsg,
									itemRender: function (_v2) {
										return A2(
											$author$project$PinMeTo$Ui$DateRangePicker$renderDropdown,
											$author$project$PinMeTo$Ui$DateRangePicker$View(config),
											model);
									}
								}))))
				]));
	});
var $author$project$Translations$General$Insights$lifetime = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.lifetime');
};
var $author$project$PinMeTo$Ui$DateRangePicker$withRanges = F2(
	function (ranges, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$DateRangePicker$View(
			_Utils_update(
				config,
				{ranges: ranges}));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$Labeled = F3(
	function (a, b, c) {
		return {$: 'Labeled', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Ui$DateRangePicker$MetricsEvent = function (a) {
	return {$: 'MetricsEvent', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$DateRangeLabel = function (a) {
	return {$: 'DateRangeLabel', a: a};
};
var $author$project$PinMeTo$Ui$DateRangePicker$presetCustom = F3(
	function (label, metricsEvent, range) {
		return A3(
			$author$project$PinMeTo$Ui$DateRangePicker$Labeled,
			$author$project$PinMeTo$Ui$DateRangePicker$DateRangeLabel(label),
			$author$project$PinMeTo$Ui$DateRangePicker$MetricsEvent(metricsEvent),
			range);
	});
var $author$project$Insights$Facebook$Model$ToggleLocations = {$: 'ToggleLocations'};
var $author$project$Insights$Facebook$Model$ToggleBrandPages = {$: 'ToggleBrandPages'};
var $author$project$Translations$General$today = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.today');
};
var $author$project$Translations$General$numberOfDaysBack = F2(
	function (translations, daysNumber) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.number_of_days_back',
			_List_fromArray(
				[
					_Utils_Tuple2('daysNumber', daysNumber)
				]));
	});
var $author$project$Labels$uiDateRangePicker = F2(
	function (translations, language) {
		return {
			days: A3($author$project$Common$Language$i18n, translations, language, 'general.number_of_days_count'),
			daysBack: function (days) {
				if (days === 1) {
					return $author$project$Translations$General$today(translations);
				} else {
					var multipleDays = days;
					return A2(
						$author$project$Translations$General$numberOfDaysBack,
						translations,
						$elm$core$String$fromInt(multipleDays));
				}
			}
		};
	});
var $author$project$Insights$Facebook$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2(
				$elm$html$Html$map,
				$author$project$Insights$Facebook$Model$FilterControllerMsg,
				A4($author$project$Filter$FilterController$viewInsights, model.filterController, session.locale, session.translations, session.language)),
			function (_v7) {
				return $elm$html$Html$text('');
			},
			model.locationId);
		var shouldShowTopList = function () {
			var _v5 = model.locationId;
			if (_v5.$ === 'Just') {
				return false;
			} else {
				var _v6 = model.locationInsights;
				if (_v6.$ === 'Loaded') {
					var locationInsights = _v6.a;
					return $elm$core$List$length(locationInsights) > 0;
				} else {
					return false;
				}
			}
		}();
		var insightsToDisplay = function () {
			var _v4 = _Utils_Tuple2(model.showLocations, model.showBrandPages);
			if (_v4.a) {
				if (_v4.b) {
					return model.mergedInsights;
				} else {
					return model.locationInsights;
				}
			} else {
				if (_v4.b) {
					return model.brandPageInsights;
				} else {
					return $author$project$RemoteData$Suspended;
				}
			}
		}();
		var checkboxes = function () {
			var _v1 = model.locationId;
			if (_v1.$ === 'Just') {
				return _List_fromArray(
					[
						$elm$html$Html$text('')
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$PinMeTo$Ui$Form$Checkbox$render(
						$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
							{
								label: 'Locations',
								checked: model.showLocations,
								onChange: function (_v2) {
									return $author$project$Insights$Facebook$Model$ToggleLocations;
								}
							})),
						$author$project$PinMeTo$Ui$Form$Checkbox$render(
						$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
							{
								label: 'Brand Pages',
								checked: model.showBrandPages,
								onChange: function (_v3) {
									return $author$project$Insights$Facebook$Model$ToggleBrandPages;
								}
							}))
					]);
			}
		}();
		var dateRange = model.range;
		var downloadConf = {
			uid: 'ui-select-download-facebook-metric',
			items: _List_fromArray(
				[
					{
					url: A5($author$project$Insights$Facebook$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/download/', false),
					label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
				},
					{
					url: A5($author$project$Insights$Facebook$Model$filterQueryString, model, session.siteName, 'xlsx', '/metrics/download/', false),
					label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
			tagger: $author$project$Insights$Facebook$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Facebook-Insights_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Facebook$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A2(
					$author$project$RemoteData$map,
					function (insights) {
						return A2(
							$elm$core$List$all,
							function (data) {
								return $elm$core$List$isEmpty(data.metrics);
							},
							insights);
					},
					insightsToDisplay),
				$author$project$RemoteData$Loaded(false))
		};
		var downloadMetricsDropdown = A4(
			$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
			$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
			$elm$html$Html$b,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadConf, model.uiSelect)
				]));
		var asides = checkboxes;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					filterControllerHandler,
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
								$author$project$Translations$General$Insights$insightsTitle(session.translations))))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$DateRangePicker$render,
									model.uiDateRangePicker,
									function () {
										var _v0 = model.lifetime;
										if (_v0.$ === 'Just') {
											var lifetime = _v0.a;
											return $author$project$PinMeTo$Ui$DateRangePicker$withRanges(
												_List_fromArray(
													[
														A3(
														$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
														$author$project$Translations$General$Insights$lifetime(session.translations),
														'Lifetime',
														lifetime)
													]));
										} else {
											return $elm$core$Basics$identity;
										}
									}()(
										$author$project$PinMeTo$Ui$DateRangePicker$view(
											{
												uid: 'facebook-insights-date-range-picker',
												range: model.range,
												labels: A2($author$project$Labels$uiDateRangePicker, session.translations, session.language),
												locale: session.locale,
												tagger: $author$project$Insights$Facebook$Model$DateRangePickerMsg,
												language: session.language
											})))
								])),
							downloadMetricsDropdown
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A3($author$project$Insights$Facebook$View$MetricSection$view, session, model, insightsToDisplay),
					shouldShowTopList ? A2($author$project$Insights$Facebook$View$TopListSection$view, session, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$update_ = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					$elm$core$Platform$Cmd$map(config.tagger),
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$PinMeTo$Ui$DateRangePicker$UiSelectMsg, msg_, model.uiSelect));
			case 'OnTime':
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{time: time}),
					$elm$core$Platform$Cmd$none);
			case 'OnSelectorOpened':
				return _Utils_Tuple2(
					model,
					$author$project$PinMeTo$Ui$Metrics$sendEvent(
						config.metricsPrefix('Range Selector Opened')));
			case 'OnPresetSelected':
				var preset = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiSelect: $author$project$PinMeTo$Ui$Select$close(model.uiSelect),
							selectedPreset: $elm$core$Maybe$Just(preset)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								config.onChange,
								$elm$core$Task$succeed(
									A2($author$project$PinMeTo$Ui$DateRangePicker$presetToRange, model.time, preset))),
								$author$project$PinMeTo$Ui$Metrics$sendEvent(
								_Utils_ap(
									config.metricsPrefix('Selected Date Range '),
									function () {
										switch (preset.$) {
											case 'DaysBack':
												var days = preset.a;
												return 'Last ' + ($elm$core$String$fromInt(days) + ' days');
											case 'Labeled':
												var metricsEvent = preset.b.a;
												return metricsEvent;
											default:
												return 'Custom';
										}
									}()))
							])));
			default:
				switch (msg.b.$) {
					case 'DateRangeChanged':
						var current = msg.a;
						var range = msg.b.a;
						return (!_Utils_eq(range, current)) ? _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$perform,
										config.onChange,
										$elm$core$Task$succeed(range)),
										$author$project$PinMeTo$Ui$Metrics$sendEvent(
										config.metricsPrefix('Selected Custom Date Range'))
									]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'DateChanged':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$PinMeTo$Ui$DateRangePicker$update = F3(
	function (config, msg, _v0) {
		var model = _v0.a;
		return A3(
			$elm$core$Tuple$mapBoth,
			$author$project$PinMeTo$Ui$DateRangePicker$State,
			function (cmd) {
				if (msg.$ === 'OnTime') {
					return cmd;
				} else {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2(
								$elm$core$Platform$Cmd$map,
								config.tagger,
								A2($elm$core$Task$perform, $author$project$PinMeTo$Ui$DateRangePicker$OnTime, $elm$time$Time$now))
							]));
				}
			},
			A3($author$project$PinMeTo$Ui$DateRangePicker$update_, config, msg, model));
	});
var $author$project$Insights$Facebook$Model$Expanded = {$: 'Expanded'};
var $author$project$Insights$Facebook$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Facebook$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Facebook$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$Facebook$Commands$mergeMetricDetails = F2(
	function (locationMetricDetails, brandPageMetricDetails) {
		var locationDetailsDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (d) {
					return _Utils_Tuple2(d.key, d);
				},
				locationMetricDetails));
		var metricDetailsDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (d) {
					return _Utils_Tuple2(d.key, d);
				},
				brandPageMetricDetails));
		var mergedDict = A6(
			$elm$core$Dict$merge,
			F3(
				function (date, value, mergedValue) {
					return A3($elm$core$Dict$insert, date, value, mergedValue);
				}),
			F3(
				function (date, locationMetricValue, brandPageMetricValue) {
					return A2(
						$elm$core$Dict$insert,
						date,
						{key: locationMetricValue.key, value: locationMetricValue.value + brandPageMetricValue.value});
				}),
			F3(
				function (date, value, mergedValue) {
					return A3($elm$core$Dict$insert, date, value, mergedValue);
				}),
			locationDetailsDict,
			metricDetailsDict,
			$elm$core$Dict$empty);
		return $elm$core$Dict$values(mergedDict);
	});
var $author$project$Insights$Facebook$Commands$mergeMetrics = F2(
	function (locationMetrics, brandPageMetrics) {
		var brandPageMetricsDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (m) {
					return _Utils_Tuple2(m.metricName, m);
				},
				brandPageMetrics));
		var locationMetricsDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (m) {
					return _Utils_Tuple2(m.metricName, m);
				},
				locationMetrics));
		var mergedDict = A6(
			$elm$core$Dict$merge,
			F3(
				function (metricName, locationMetrics_, mergedMetrics) {
					return A3($elm$core$Dict$insert, metricName, locationMetrics_, mergedMetrics);
				}),
			F3(
				function (metricName, locationMetricDetails, brandPageMetricDetails) {
					return A2(
						$elm$core$Dict$insert,
						metricName,
						{
							metrics: A2($author$project$Insights$Facebook$Commands$mergeMetricDetails, locationMetricDetails.metrics, brandPageMetricDetails.metrics),
							metricName: locationMetricDetails.metricName
						});
				}),
			F3(
				function (metricName, brandPageMetrics_, mergedMetrics) {
					return A3($elm$core$Dict$insert, metricName, brandPageMetrics_, mergedMetrics);
				}),
			locationMetricsDict,
			brandPageMetricsDict,
			$elm$core$Dict$empty);
		return $elm$core$Dict$values(mergedDict);
	});
var $author$project$Insights$Facebook$Commands$mergeFacebookInsights = function (model) {
	var _v0 = _Utils_Tuple2(model.locationInsights, model.brandPageInsights);
	if ((_v0.a.$ === 'Loaded') && (_v0.b.$ === 'Loaded')) {
		var locationMetrics = _v0.a.a;
		var brandMetrics = _v0.b.a;
		return $author$project$RemoteData$Loaded(
			A2($author$project$Insights$Facebook$Commands$mergeMetrics, locationMetrics, brandMetrics));
	} else {
		return $author$project$RemoteData$Loading;
	}
};
var $author$project$Insights$Facebook$Commands$getQueryParams = function (model) {
	var dateRange = model.range;
	var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
	var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
	return '?from=' + (from + ('&to=' + to));
};
var $author$project$Insights$Facebook$Model$TopListLocation = function (name) {
	return function (storeId) {
		return function (locationDescriptor) {
			return function (locationId) {
				return function (address) {
					return function (impressions) {
						return function (reach) {
							return function (addedLikesUnique) {
								return function (removedLikes) {
									return function (actions) {
										return {name: name, reach: reach, actions: actions, address: address, storeId: storeId, locationId: locationId, impressions: impressions, removedLikes: removedLikes, addedLikesUnique: addedLikesUnique, locationDescriptor: locationDescriptor};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Facebook$Decoders$facebookTopListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'removed_likes',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'added_likes_unique',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'reach',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'impressions',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['location', 'address']),
						$author$project$Data$Address$addressDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['location', '_id']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['location', 'locationDescriptor']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['location', 'storeId']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['location', 'name']),
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Insights$Facebook$Model$TopListLocation)))))))))));
var $author$project$Insights$Facebook$Decoders$facebookTopListsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['metrics']),
	$elm$json$Json$Decode$list($author$project$Insights$Facebook$Decoders$facebookTopListDecoder));
var $author$project$Insights$Facebook$Commands$getFacebookLocationsTopList = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = function (u) {
			return u + (siteName + ('/facebook/locations/metrics/toplist' + $author$project$Insights$Facebook$Commands$getQueryParams(model)));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Facebook$Decoders$facebookTopListsDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Facebook$Model$FacebookLocationsMetricsDataResponse = function (a) {
	return {$: 'FacebookLocationsMetricsDataResponse', a: a};
};
var $author$project$Insights$Facebook$Model$FacebookLocationsTopListDataResponse = function (a) {
	return {$: 'FacebookLocationsTopListDataResponse', a: a};
};
var $author$project$Insights$Facebook$Model$FacebookMetrics = F2(
	function (metricName, metrics) {
		return {metrics: metrics, metricName: metricName};
	});
var $author$project$Insights$Facebook$Model$MetricDetails = F2(
	function (key, value) {
		return {key: key, value: value};
	});
var $author$project$Insights$Facebook$Decoders$metricDetailsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Facebook$Model$MetricDetails)));
var $author$project$Insights$Facebook$Decoders$facebookInsightMetricDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metrics',
	$elm$json$Json$Decode$list($author$project$Insights$Facebook$Decoders$metricDetailsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Facebook$Model$FacebookMetrics)));
var $author$project$Insights$Facebook$Decoders$facebookInsightMetricsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['metrics']),
	$elm$json$Json$Decode$list($author$project$Insights$Facebook$Decoders$facebookInsightMetricDecoder));
var $author$project$Insights$Facebook$Commands$getFacebookInsightsAllLocationsPerDay = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (locationId_) {
				return locationId_ + '/';
			},
			model.locationId);
		var url = function (u) {
			return u + (siteName + ('/facebook/locations/' + (locationId + ('metrics' + $author$project$Insights$Facebook$Commands$getQueryParams(model)))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Facebook$Decoders$facebookInsightMetricsDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Facebook$Main$fetchAllLocationInsights = F2(
	function (model, siteName) {
		return A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A3($author$project$Insights$Facebook$Commands$getFacebookInsightsAllLocationsPerDay, model, siteName, $author$project$Insights$Facebook$Model$FacebookLocationsMetricsDataResponse)
				]),
			_Utils_eq(model.locationId, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					A3($author$project$Insights$Facebook$Commands$getFacebookLocationsTopList, model, siteName, $author$project$Insights$Facebook$Model$FacebookLocationsTopListDataResponse)
				]) : _List_Nil);
	});
var $author$project$Insights$Facebook$Main$out_Insights_Facebook_Main_onFilter = _Platform_outgoingPort('out_Insights_Facebook_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Facebook$Model$FacebookBrandPagesMetricsDataResponse = function (a) {
	return {$: 'FacebookBrandPagesMetricsDataResponse', a: a};
};
var $author$project$Insights$Facebook$Commands$getFacebookInsightsAllBrandpagesPerDay = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = function (u) {
			return u + (siteName + ('/facebook/brandpages/metrics' + $author$project$Insights$Facebook$Commands$getQueryParams(model)));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Facebook$Decoders$facebookInsightMetricsDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Insights$Facebook$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'FacebookLocationsMetricsDataResponse':
				if (msg.a.$ === 'Ok') {
					var metrics = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationInsights: $author$project$RemoteData$Loaded(metrics)
							}),
						A3($author$project$Insights$Facebook$Commands$getFacebookInsightsAllBrandpagesPerDay, model, session.siteName, $author$project$Insights$Facebook$Model$FacebookBrandPagesMetricsDataResponse));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationInsights: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'FacebookBrandPagesMetricsDataResponse':
				if (msg.a.$ === 'Ok') {
					var metrics = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							brandPageInsights: $author$project$RemoteData$Loaded(metrics)
						});
					var mergedMetrics = $author$project$Insights$Facebook$Commands$mergeFacebookInsights(newModel);
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{mergedInsights: mergedMetrics}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								brandPageInsights: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'FacebookLocationsTopListDataResponse':
				if (msg.a.$ === 'Ok') {
					var topList = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topList: $author$project$RemoteData$Loaded(topList)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topList: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'DateRangePickerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiDateRangePicker: x});
					},
					A3(
						$author$project$PinMeTo$Ui$DateRangePicker$update,
						{
							tagger: $author$project$Insights$Facebook$Model$DateRangePickerMsg,
							onChange: $author$project$Insights$Facebook$Model$OnDateRangeChange,
							metricsPrefix: $author$project$Common$Metrics$prefix('Facebook Insights')
						},
						msg_,
						model.uiDateRangePicker));
			case 'OnDateRangeChange':
				var range = msg.a;
				var _v1 = function () {
					var onRangeChange = $author$project$Insights$Facebook$Main$out_Insights_Facebook_Main_onRangeChange(
						$author$project$Insights$Utils$encodeDateRange(range));
					var newModel_ = _Utils_update(
						model,
						{range: range, mergedInsights: $author$project$RemoteData$Loading, locationInsights: $author$project$RemoteData$Loading, brandPageInsights: $author$project$RemoteData$Loading});
					return _Utils_Tuple2(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_Utils_ap(
								A2($author$project$Insights$Facebook$Main$fetchAllLocationInsights, newModel_, session.siteName),
								_List_fromArray(
									[onRangeChange]))));
				}();
				var newModel = _v1.a;
				var newBatch = _v1.b;
				return _Utils_Tuple2(newModel, newBatch);
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Facebook$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'OnDownloadLabelClicked':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				var _v2 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Facebook$Model$FilterControllerMsg, msg_, model.filterController, $author$project$Insights$Facebook$Model$OnFilter, $author$project$Insights$Facebook$Model$OnSearch);
				var filterControllerModel_ = _v2.a;
				var filterControllerCmd_ = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filterController: filterControllerModel_}),
					filterControllerCmd_);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						mergedInsights: $author$project$RemoteData$Loading,
						filterDefinition: $elm$core$Maybe$Just(filterDefinition),
						locationInsights: $author$project$RemoteData$Loading,
						brandPageInsights: $author$project$RemoteData$Loading
					});
				var newBatch = $elm$core$Platform$Cmd$batch(
					_Utils_ap(
						A2($author$project$Insights$Facebook$Main$fetchAllLocationInsights, newModel, session.siteName),
						_List_fromArray(
							[
								$author$project$Insights$Facebook$Main$out_Insights_Facebook_Main_onFilter(filterDefinition)
							])));
				return _Utils_Tuple2(newModel, newBatch);
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnUrlChange':
				var value = msg.a;
				var _v3 = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, value);
				if (_v3.$ === 'Ok') {
					var url = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								baseUrl: $elm$core$Maybe$Just(url)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = _v3.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'Insights.Facebook.Main.OnUrlChange',
								message: 'Failed to decode url'
							}));
				}
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'FacebookSupportedDateRangeResponse':
				if (msg.a.$ === 'Ok') {
					var supportedDateRange = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							lifetime: $elm$core$Maybe$Just(supportedDateRange)
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Error'),
							error));
				}
			case 'ToggleLocations':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showLocations: !model.showLocations}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleBrandPages':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showBrandPages: !model.showBrandPages}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleLegacyInsights':
				var newState = function () {
					var _v4 = model.legacyInsightsState;
					if (_v4.$ === 'Expanded') {
						return $author$project$Insights$Facebook$Model$Collapsed;
					} else {
						return $author$project$Insights$Facebook$Model$Expanded;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{legacyInsightsState: newState}),
					$elm$core$Platform$Cmd$none);
			case 'OnPopOver':
				var popOverConfigType = msg.a;
				var msg_ = msg.b;
				var planhatTrack = function () {
					if (msg_.$ === 'Open') {
						switch (popOverConfigType.$) {
							case 'Impressions':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.facebook.impressionsPopoverClicked;
							case 'Reach':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.facebook.reachPopoverClicked;
							case 'Likes':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.facebook.likesPopoverClicked;
							default:
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.facebook.topListPopoverClicked;
						}
					} else {
						return '';
					}
				}();
				var planhatTrackCmd = (planhatTrack !== '') ? $author$project$PlanHat$PlanHat$track(
					{info: '', action: planhatTrack}) : $elm$core$Platform$Cmd$none;
				var _v5 = A3(
					$author$project$PinMeTo$Ui$PopOver$update,
					$author$project$Insights$Facebook$Model$OnPopOver(popOverConfigType),
					msg_,
					model.popOverState);
				var newState = _v5.a;
				var cmd_ = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd_, planhatTrackCmd])));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Insights$Facebook$Model$Flags = function (siteName) {
	return function (today) {
		return function (dateRange) {
			return function (insightsUrl) {
				return function (baseUrl) {
					return function (locale) {
						return function (translations) {
							return function (language) {
								return function (initialFilter) {
									return function (locationId) {
										return function (url) {
											return function (timezoneOffset) {
												return {url: url, today: today, locale: locale, baseUrl: baseUrl, language: language, siteName: siteName, dateRange: dateRange, locationId: locationId, insightsUrl: insightsUrl, translations: translations, initialFilter: initialFilter, timezoneOffset: timezoneOffset};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PinMeTo$Ui$DatePickerV2$Range = F2(
	function (from, to) {
		return {to: to, from: from};
	});
var $author$project$Insights$Facebook$Decoders$dateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DatePickerV2$Range)));
var $author$project$Insights$Facebook$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timezoneOffset',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'url',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'placeId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'initialFilter',
				$elm$json$Json$Decode$nullable(
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'language',
					$author$project$PinMeTo$Ui$I18n$Language$decoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'translations',
						$author$project$Common$Language$translationsDecoder,
						$author$project$Common$Language$initialTranslationsFallback,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['user', 'settings', 'locale']),
							$author$project$PinMeTo$Ui$I18n$Locale$decoder,
							$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'baseUrl',
								$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'insightsUrl',
									$elm_community$json_extra$Json$Decode$Extra$url,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'dateRange',
										$elm$json$Json$Decode$nullable($author$project$Insights$Facebook$Decoders$dateRangeDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'today',
											$elm_community$json_extra$Json$Decode$Extra$datetime,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'siteName',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Insights$Facebook$Model$Flags)))))))))))));
var $author$project$Insights$Facebook$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$Facebook$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$Facebook$Model$OnUrlChange)
			]));
};
var $author$project$Insights$Facebook$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$Facebook$Main$init, view: $author$project$Insights$Facebook$View$view, update: $author$project$Insights$Facebook$Main$update, flagsDecoder: $author$project$Insights$Facebook$Main$flagsDecoder, subscriptions: $author$project$Insights$Facebook$Main$subscriptions});
var $author$project$Tasks$Trustpilot$Main$UpdateTime = function (a) {
	return {$: 'UpdateTime', a: a};
};
var $author$project$Tasks$Trustpilot$Main$Flags = F5(
	function (claimUrl, uploadChangesUrl, siteName, user, translations) {
		return {user: user, claimUrl: claimUrl, siteName: siteName, translations: translations, uploadChangesUrl: uploadChangesUrl};
	});
var $author$project$Tasks$Trustpilot$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$author$project$Common$Language$translationsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Data$User$userDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'siteName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uploadChangesUrl',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'claimUrl',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$Trustpilot$Main$Flags))))));
var $author$project$Tasks$Trustpilot$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Trustpilot$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Trustpilot$Main$initialModel = {
	user: $author$project$Data$User$emptyUser,
	stats: $author$project$RemoteData$Loading,
	claimUrl: '',
	siteName: '',
	timestamp: $elm$time$Time$millisToPosix(0),
	translations: $author$project$Common$Language$initialTranslationsFallback,
	uploadChangesUrl: ''
};
var $author$project$Tasks$Trustpilot$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Trustpilot$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Tasks$Trustpilot$Main$initialModel,
				{user: decoded.user, claimUrl: decoded.claimUrl, siteName: decoded.siteName, translations: decoded.translations, uploadChangesUrl: decoded.uploadChangesUrl}),
			A2($elm$core$Task$perform, $author$project$Tasks$Trustpilot$Main$UpdateTime, $elm$time$Time$now));
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$author$project$Tasks$Trustpilot$Main$initialModel,
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'Tasks.Trustpilot.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Translations$Listings$Tasks$conflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.conflicts');
};
var $author$project$Translations$Listings$Tasks$noConflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.no_conflicts');
};
var $author$project$Data$User$hasPermission = F2(
	function (user, permission) {
		return A2($elm$core$List$member, permission, user.localAccess.permissions);
	});
var $author$project$Translations$Listings$Tasks$uploadChanges = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.upload_changes');
};
var $author$project$Translations$Listings$Tasks$changesToPublish = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.changes_to_publish');
};
var $author$project$Translations$Listings$Tasks$conflictsTrustpilot = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.conflicts_trustpilot');
};
var $author$project$Tasks$Trustpilot$Main$uploadChanges = function (model) {
	var _v0 = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_Utils_Tuple3(
			$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay,
			$elm$html$Html$text('...'),
			false),
		function (x) {
			return _Utils_Tuple3(
				$elm$html$Html$text(
					$elm$core$String$fromInt(x.uniqueChangesCount)),
				(x.uniqueChangesCount > 0) ? $elm$html$Html$text(
					$author$project$Translations$Listings$Tasks$conflictsTrustpilot(model.translations)) : $elm$html$Html$text(
					$author$project$Translations$Listings$Tasks$noConflicts(model.translations)),
				x.uniqueChangesCount > 0);
		},
		$author$project$RemoteData$currentData(model.stats));
	var count = _v0.a;
	var infoText = _v0.b;
	var linkEnabled = _v0.c;
	var hasManage = A2(
		$author$project$Data$User$hasPermission,
		model.user,
		$author$project$Data$User$Permission('claim.manage'));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__indicator')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-task__icon fa fa-exclamation')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-task__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Trustpilot - ' + $author$project$Translations$Listings$Tasks$conflicts(model.translations))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[infoText]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__asides stats')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Tasks$changesToPublish(model.translations))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats__value')
							]),
						_List_fromArray(
							[count])),
						(hasManage && linkEnabled) ? $author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$withHref,
							model.uploadChangesUrl,
							$author$project$PinMeTo$Ui$Button$buttonPrimary(
								$author$project$Translations$Listings$Tasks$uploadChanges(model.translations)))) : $elm$html$Html$text('')
					]))
			]));
};
var $author$project$FontAwesome$Solid$Icon$faLocationDot = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-location-dot');
var $author$project$Tasks$Trustpilot$Main$claimLocations = function (model) {
	var hasManage = A2(
		$author$project$Data$User$hasPermission,
		model.user,
		$author$project$Data$User$Permission('claim.manage'));
	var hasView = A2(
		$author$project$Data$User$hasPermission,
		model.user,
		$author$project$Data$User$Permission('claim.view'));
	return hasView ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__indicator')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-task__icon')
							]),
						_List_fromArray(
							[
								$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-task__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Trustpilot - Claim Locations')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Claim or create listings for each of your locations on Trustpilot.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-task__asides stats')
					]),
				_List_fromArray(
					[
						hasManage ? $author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$withHref,
							model.claimUrl,
							$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Tasks$Trustpilot$Main$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list-highlighted list--divided')
					]),
				_List_fromArray(
					[
						$author$project$Tasks$Trustpilot$Main$uploadChanges(model),
						$author$project$Tasks$Trustpilot$Main$claimLocations(model)
					]))
			]));
};
var $author$project$Tasks$Trustpilot$Main$Stats = F3(
	function (locationsChangedCount, uniqueChangesCount, totalChangesCount) {
		return {totalChangesCount: totalChangesCount, uniqueChangesCount: uniqueChangesCount, locationsChangedCount: locationsChangedCount};
	});
var $author$project$Tasks$Trustpilot$Main$decodeStats = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalChangesCount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uniqueChangesCount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locationsChangedCount',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Tasks$Trustpilot$Main$Stats))));
var $author$project$Tasks$Trustpilot$Main$GetStatsResponse = function (a) {
	return {$: 'GetStatsResponse', a: a};
};
var $author$project$Tasks$Trustpilot$Main$getChangeStats = F2(
	function (site, timestamp) {
		var ts = $elm$core$String$fromInt(
			$elm$time$Time$posixToMillis(timestamp));
		var url = '/listings/api/' + (site + ('/trustpilot/conflict/solved/' + (ts + '/count')));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, $author$project$Tasks$Trustpilot$Main$GetStatsResponse, $author$project$Tasks$Trustpilot$Main$decodeStats),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Tasks$Trustpilot$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'UpdateTime':
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timestamp: time}),
					A2($author$project$Tasks$Trustpilot$Main$getChangeStats, model.siteName, time));
			case 'Refresh':
				return _Utils_Tuple2(
					model,
					A2($elm$core$Task$perform, $author$project$Tasks$Trustpilot$Main$UpdateTime, $elm$time$Time$now));
			default:
				if (msg.a.$ === 'Ok') {
					var res = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								stats: $author$project$RemoteData$Loaded(res)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								stats: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(err))
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Tasks.Trustpilot.Main', message: 'GetStatsResponse failed'}));
				}
		}
	});
var $author$project$Tasks$Trustpilot$Main$Refresh = function (a) {
	return {$: 'Refresh', a: a};
};
var $author$project$Tasks$Trustpilot$Main$reload_Tasks_Trustpilot_Main = _Platform_incomingPort(
	'reload_Tasks_Trustpilot_Main',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$Tasks$Trustpilot$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Trustpilot$Main$init,
		view: $author$project$Tasks$Trustpilot$Main$view,
		update: $author$project$Tasks$Trustpilot$Main$update,
		subscriptions: function (_v0) {
			return $author$project$Tasks$Trustpilot$Main$reload_Tasks_Trustpilot_Main($author$project$Tasks$Trustpilot$Main$Refresh);
		}
	});
var $author$project$Tasks$Here$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Here$Claim$Commands$getAllHereCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allDataCategoriesDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/here/categories')))));
	});
var $author$project$Tasks$Here$Claim$Main$init = F2(
	function (session, flags) {
		return _Utils_Tuple2(
			{uiTable: $author$project$PinMeTo$Ui$Table$init, uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, allCategories: $author$project$RemoteData$Loading, primaryCategory: flags.categories.primaryCategory, categoriesNotification: $elm$core$Maybe$Nothing, additionalCategoriesList: flags.categories.additionalCategories},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Here$Claim$Commands$getAllHereCategories, session.siteName, $author$project$Tasks$Here$Claim$Model$GotAllCategories)
					])));
	});
var $author$project$Tasks$Here$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Translations$Listings$Claim$claimHereLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_here_locations');
};
var $author$project$Tasks$Here$Claim$View$renderHeader = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorHere)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimHereLocations(translations))
					]))
			]));
};
var $author$project$Tasks$Here$Claim$View$renderInnerContainer = F2(
	function (session, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Tasks$Here$Claim$View$renderHeader(session.translations)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Here$Claim$Sections$Shared$renderAlert = function (notification) {
	if (notification.$ === 'Just') {
		var message = notification.a.message;
		var state = notification.a.state;
		return $author$project$PinMeTo$Ui$Alert$render(
			function () {
				switch (state.$) {
					case 'Success':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
					case 'Failed':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
					default:
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
				}
			}()(
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Tasks$Here$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Here$Claim$Update$areCategoriesSelected = function (model) {
	var areAllAdditionalCategoriesSelected = A2($elm$core$List$all, $elm_community$maybe_extra$Maybe$Extra$isJust, model.additionalCategoriesList);
	var isPrimaryCategorySelected = $elm_community$maybe_extra$Maybe$Extra$isJust(model.primaryCategory);
	return isPrimaryCategorySelected && areAllAdditionalCategoriesSelected;
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Here$Claim$Update$areCategoriesSelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Here$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Tasks$Here$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Here$Claim$Model$SelectedPrimaryCategory = function (a) {
	return {$: 'SelectedPrimaryCategory', a: a};
};
var $author$project$Tasks$Here$Claim$Model$SelectedAdditionalCategory = F2(
	function (a, b) {
		return {$: 'SelectedAdditionalCategory', a: a, b: b};
	});
var $author$project$Tasks$Here$Claim$Model$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderCategorySelector = F6(
	function (uid, translations, model, categories, category, index) {
		var isPrimary = uid === 'ui-select-primary';
		var title = isPrimary ? $author$project$Translations$Listings$LocationDetail$primaryCategory(translations) : A2(
			$author$project$Translations$Listings$LocationDetail$additionalCategory,
			translations,
			$elm$core$String$fromInt(index + 1));
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid + ('-' + $elm$core$String$fromInt(index)),
													items: A2($author$project$Tasks$Here$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Here$Claim$Model$UiSelectMsg,
													onChange: function (category_) {
														return isPrimary ? $author$project$Tasks$Here$Claim$Model$SelectedPrimaryCategory(category_) : A2($author$project$Tasks$Here$Claim$Model$SelectedAdditionalCategory, category_, index);
													},
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								])),
							isPrimary ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__remove-additional'),
									$elm$html$Html$Events$onClick(
									$author$project$Tasks$Here$Claim$Model$RemoveAdditionalCategoryByIndex(index))
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
								]))
						]))
				]));
	});
var $author$project$Tasks$Here$Claim$Model$AddAdditionalCategory = {$: 'AddAdditionalCategory'};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderAddCategoryButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__publish-button')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Tasks$Here$Claim$Model$AddAdditionalCategory)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$addCategory(translations))
					]))
			]));
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderAdditionalCategories = F3(
	function (translations, model, categories) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return A6($author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-additional', translations, model, categories, item, index);
					}),
				model.additionalCategoriesList));
	});
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$getCategoryId = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	function (category_) {
		return $author$project$Data$Location$NetworkCategories$getId(category_);
	});
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$getSelectedCategoryIds = function (model) {
	return A2(
		$elm$core$List$append,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (category) {
				return _List_fromArray(
					[
						$author$project$Data$Location$NetworkCategories$getId(category)
					]);
			},
			model.primaryCategory),
		A2(
			$elm$core$List$filter,
			function (category) {
				return category !== '';
			},
			A2($elm$core$List$map, $author$project$Tasks$Here$Claim$Sections$CategoriesSection$getCategoryId, model.additionalCategoriesList)));
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$getAllNotSelectedCategories = function (model) {
	var _v0 = model.allCategories;
	if (_v0.$ === 'Loaded') {
		var categories = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (category) {
				return !A2(
					$elm$core$List$member,
					$author$project$Data$Location$NetworkCategories$getId(category),
					$author$project$Tasks$Here$Claim$Sections$CategoriesSection$getSelectedCategoryIds(model));
			},
			categories);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = $author$project$Tasks$Here$Claim$Sections$CategoriesSection$sortCategories(
			$author$project$Tasks$Here$Claim$Sections$CategoriesSection$getAllNotSelectedCategories(model));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Tasks$Shared$Components$Header$renderHeader,
							$author$project$Translations$Listings$Claim$categories(translations),
							$elm$core$Maybe$Nothing),
							$author$project$Tasks$Here$Claim$Sections$Shared$renderAlert(model.categoriesNotification),
							A6($author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-primary', translations, model, sortedCategories, model.primaryCategory, 0),
							A3($author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderAdditionalCategories, translations, model, sortedCategories),
							$author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderAddCategoryButton(translations),
							A2($author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
						]))
				]));
	});
var $author$project$Tasks$Here$Claim$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Here$Claim$View$renderInnerContainer, session, model),
						$author$project$Tasks$Here$Claim$View$lineSeparator,
						A2($author$project$Tasks$Here$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model)
					]),
				_List_Nil));
	});
var $author$project$Tasks$Here$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Here$Claim$Model$Success = {$: 'Success'};
var $author$project$Tasks$Here$Claim$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Tasks$Here$Claim$Commands$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getId(x))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getName(x)))
			]));
};
var $author$project$Tasks$Here$Claim$Commands$encodePrimaryCategory = function (primaryCategory) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (p) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'primaryCategory',
						$author$project$Tasks$Here$Claim$Commands$encodeCategory(p))
					]);
			},
			primaryCategory));
};
var $author$project$Tasks$Here$Claim$Commands$encodeAdditionalCategories = function (additionalCategories) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'additionalCategories',
			A2($elm$json$Json$Encode$list, $author$project$Tasks$Here$Claim$Commands$encodeCategory, additionalCategories))
		]);
};
var $author$project$Tasks$Here$Claim$Commands$encodeCategories = function (model) {
	var additionalCategories = A2($elm$core$List$filterMap, $elm$core$Basics$identity, model.additionalCategoriesList);
	var primaryCategory = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just, model.primaryCategory);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				$elm$json$Json$Encode$object(
					_Utils_ap(
						$author$project$Tasks$Here$Claim$Commands$encodeAdditionalCategories(additionalCategories),
						$author$project$Tasks$Here$Claim$Commands$encodePrimaryCategory(primaryCategory))))
			]));
};
var $author$project$Tasks$Here$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var sitename = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Here$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (sitename + '/here/categories')))));
	});
var $author$project$Tasks$Here$Claim$Update$emptyNotification = function (model) {
	return _Utils_update(
		model,
		{categoriesNotification: $elm$core$Maybe$Nothing});
};
var $author$project$Tasks$Here$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				categoriesNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$Here$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Here$Claim$Update$update = F3(
	function (session, msg, model) {
		var modelClearedNotifications = $author$project$Tasks$Here$Claim$Update$emptyNotification(model);
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Here$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Here$Claim$Model$UiPopOverMsg, msg_, model.uiPopover));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							modelClearedNotifications,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var updatedModel = A3(
						$author$project$Tasks$Here$Claim$Update$updateNotification,
						$author$project$Tasks$Here$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(session.translations),
						model);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								allCategories: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Here.Claim.Update.GotAllCategories',
								message: 'Failed to decode response GotAllCategories'
							}));
				}
			case 'SelectedPrimaryCategory':
				var category = msg.a;
				return A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					model.additionalCategoriesList) ? _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{
							primaryCategory: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'AddAdditionalCategory':
				var newSelection = A2(
					$elm$core$List$append,
					model.additionalCategoriesList,
					$elm$core$List$singleton($elm$core$Maybe$Nothing));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newSelection}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedAdditionalCategory':
				var category = msg.a;
				var index = msg.b;
				var primaryCategory = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (cat) {
						return $elm$core$List$singleton(
							$elm$core$Maybe$Just(cat));
					},
					model.primaryCategory);
				var newAdditional = A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					A2($elm$core$List$append, model.additionalCategoriesList, primaryCategory)) ? model.additionalCategoriesList : A2(
					$elm$core$List$append,
					A2(
						$elm$core$List$append,
						A2($elm$core$List$take, index, model.additionalCategoriesList),
						$elm$core$List$singleton(
							$elm$core$Maybe$Just(category))),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				var newAdditional = A2(
					$elm$core$List$append,
					A2($elm$core$List$take, index, model.additionalCategoriesList),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				return _Utils_Tuple2(
					_Utils_update(
						modelClearedNotifications,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'SaveCategories':
				return $author$project$Tasks$Here$Claim$Update$areCategoriesSelected(model) ? _Utils_Tuple2(
					modelClearedNotifications,
					A3($author$project$Tasks$Here$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Here$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(modelClearedNotifications, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					var _v1 = success ? _Utils_Tuple2(
						$author$project$Tasks$Here$Claim$Model$Success,
						$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
						$author$project$Tasks$Here$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
					var notificationState = _v1.a;
					var notificationMessage = _v1.b;
					return _Utils_Tuple2(
						A3($author$project$Tasks$Here$Claim$Update$updateNotification, notificationState, notificationMessage, model),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					return _Utils_Tuple2(
						A3($author$project$Tasks$Here$Claim$Update$updateNotification, $author$project$Tasks$Here$Claim$Model$Failed, message, model),
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Tasks.Here.Claim.Update.SaveCategoriesResult', message: 'Failed to decode response SaveCategoriesResult'}));
				}
			default:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Here$Claim$Model$Flags = function (categories) {
	return {categories: categories};
};
var $author$project$Tasks$Here$Claim$Commands$defaultCategoriesValue = {primaryCategory: $elm$core$Maybe$Nothing, additionalCategories: _List_Nil};
var $author$project$Tasks$Here$Claim$Commands$flagsCategoriesDecoder = function () {
	var decodeAdditional = A2(
		$elm$json$Json$Decode$field,
		'additionalCategories',
		$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodeAdditionalCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodeAdditional);
	var decodePrimary = A2(
		$elm$json$Json$Decode$field,
		'primaryCategory',
		$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder));
	var decodePrimaryCommon = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$map($author$project$Data$Location$NetworkCategories$CommonNetworkCategory),
		decodePrimary);
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (primary, additional) {
				return {
					primaryCategory: primary,
					additionalCategories: A2($elm$core$List$map, $elm$core$Maybe$Just, additional)
				};
			}),
		decodePrimaryCommon,
		decodeAdditionalCommon);
}();
var $author$project$Tasks$Here$Claim$Commands$flagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Tasks$Here$Claim$Model$Flags,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$Tasks$Here$Claim$Commands$defaultCategoriesValue),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'categories', $author$project$Tasks$Here$Claim$Commands$flagsCategoriesDecoder))));
var $author$project$Tasks$Here$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$Here$Claim$Main$init,
		view: $author$project$Tasks$Here$Claim$View$view,
		update: $author$project$Tasks$Here$Claim$Update$update,
		flagsDecoder: $author$project$Tasks$Here$Claim$Commands$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Foursquare$Main$Flags = F6(
	function (claimUrl, siteName, user, translations, language, hasCategory) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, hasCategory: hasCategory, translations: translations};
	});
var $author$project$Tasks$Foursquare$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hasCategory',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$PinMeTo$Ui$I18n$Language$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translations',
			$author$project$Common$Language$translationsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'user',
				$author$project$Data$User$userDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'siteName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'claimUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Tasks$Foursquare$Main$Flags)))))));
var $author$project$Tasks$Foursquare$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Foursquare$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Foursquare$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Foursquare$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Foursquare$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					user: decoded.user,
					claimUrl: decoded.claimUrl,
					language: decoded.language,
					siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
					hasCategory: decoded.hasCategory,
					translations: decoded.translations
				}),
			$elm$core$Platform$Cmd$none);
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Foursquare$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Foursquare.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Foursquare$Main$getText = function (model) {
	return model.hasCategory ? $elm$html$Html$text('All of your locations are claimed!') : $elm$html$Html$text('Claim or create listings for each of your locations on Foursquare.');
};
var $author$project$Tasks$Foursquare$Main$getClassName = function (model) {
	return model.hasCategory ? 'pmt-admin-box__success' : 'pmt-admin-box pmt-task--warning';
};
var $author$project$Tasks$Foursquare$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Foursquare$Main$getClassName(model))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Foursquare - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Foursquare$Main$getText(model)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Foursquare$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Foursquare$Main$init,
		view: $author$project$Tasks$Foursquare$Main$view,
		update: F2(
			function (_v0, model) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}),
		subscriptions: function (_v1) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Bing$Claim$Model$GetChain = function (a) {
	return {$: 'GetChain', a: a};
};
var $author$project$Tasks$Bing$Claim$Model$Chain = F6(
	function (id, enabled, name, contactName, corporateEmail, website) {
		return {id: id, name: name, enabled: enabled, website: website, contactName: contactName, corporateEmail: corporateEmail};
	});
var $author$project$Tasks$Bing$Claim$Commands$chainDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['account', 'WebSite']),
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['account', 'ClientCorporateEmail']),
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['account', 'ClientContactName']),
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['account', 'ChainName']),
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'enabled',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'_id',
						$elm$json$Json$Decode$string,
						'',
						$elm$json$Json$Decode$succeed($author$project$Tasks$Bing$Claim$Model$Chain)))))));
var $author$project$Tasks$Bing$Claim$Commands$getChain = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/bing/claim/chain');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Bing$Claim$Commands$chainDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Bing$Claim$Model$Available = {$: 'Available'};
var $author$project$Tasks$Bing$Claim$Model$GotAllCategories = function (a) {
	return {$: 'GotAllCategories', a: a};
};
var $author$project$Tasks$Bing$Claim$Commands$getAllBingCategories = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/bing/allcategories');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$Location$NetworkCategories$allCategoriesListDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Bing$Claim$Model$GetLocationsToBeCreated = function (a) {
	return {$: 'GetLocationsToBeCreated', a: a};
};
var $author$project$Tasks$Bing$Claim$Model$LocationData = F8(
	function (id, storeId, name, address, location, locationType, isActive, permanentlyClosed) {
		return {id: id, name: name, address: address, storeId: storeId, isActive: isActive, location: location, locationType: locationType, permanentlyClosed: permanentlyClosed};
	});
var $author$project$Tasks$Bing$Claim$Commands$locationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'permanentlyClosed',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isActive',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Data$Location$locationTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$author$project$Data$Coordinates$coordinatesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address',
					$author$project$Data$Address$addressDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'storeId',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'_id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Tasks$Bing$Claim$Model$LocationData)))))))));
var $author$project$Tasks$Bing$Claim$Model$LocationToCreate = F3(
	function (location, errors, lastClaimAttempt) {
		return {errors: errors, location: location, lastClaimAttempt: lastClaimAttempt};
	});
var $author$project$Tasks$Bing$Claim$Commands$locationToCreateDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'lastClaimAttempt',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'errors',
		$elm$json$Json$Decode$nullable(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'location',
			$author$project$Tasks$Bing$Claim$Commands$locationDecoder,
			$elm$json$Json$Decode$succeed($author$project$Tasks$Bing$Claim$Model$LocationToCreate))));
var $author$project$Tasks$Bing$Claim$Commands$getLocationsToBeCreated = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/bing/claim/pendingconfirm');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Bing$Claim$Commands$locationToCreateDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Bing$Claim$Main$init = F2(
	function (session, flags) {
		var getLocationsToCreateCmd = A2($author$project$Tasks$Bing$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Bing$Claim$Model$GetLocationsToBeCreated);
		return _Utils_Tuple2(
			{chain: $author$project$RemoteData$Loading, filter: '', uiTable: $author$project$PinMeTo$Ui$Table$init, uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, allCategories: $author$project$RemoteData$Loading, notifications: _List_Nil, primaryCategory: flags.categories.primaryCategory, createLocationsTab: $author$project$Tasks$Bing$Claim$Model$Available, locationsToBeCreated: $author$project$RemoteData$Loading, syncLocationsLastRun: flags.syncLocationsLastRun, additionalCategoriesList: flags.categories.additionalCategories},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$Bing$Claim$Commands$getAllBingCategories, session.siteName, $author$project$Tasks$Bing$Claim$Model$GotAllCategories),
						A2($author$project$Tasks$Bing$Claim$Commands$getChain, session.siteName, $author$project$Tasks$Bing$Claim$Model$GetChain),
						getLocationsToCreateCmd
					])));
	});
var $author$project$Tasks$Bing$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Tasks$Bing$Claim$Sections$Shared$renderAlert = function (notification) {
	if (notification.$ === 'Just') {
		var message = notification.a.message;
		var state = notification.a.state;
		return $author$project$PinMeTo$Ui$Alert$render(
			function () {
				switch (state.$) {
					case 'Success':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
					case 'Failed':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
					default:
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
				}
			}()(
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Tasks$Bing$Claim$Model$ChainSection = {$: 'ChainSection'};
var $author$project$Tasks$Bing$Claim$Model$ChainName = {$: 'ChainName'};
var $author$project$Translations$Listings$Claim$requiredField = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.required_field');
};
var $author$project$Tasks$Bing$Claim$Sections$ChainSection$withError = F2(
	function (translations, field) {
		return (field === '') ? $elm$core$Maybe$Just(
			$author$project$Translations$Listings$Claim$requiredField(translations)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Tasks$Bing$Claim$Model$ChainWebsite = {$: 'ChainWebsite'};
var $author$project$Tasks$Bing$Claim$Commands$parseChainData = function (chainData) {
	if (chainData.$ === 'Loaded') {
		var chain = chainData.a;
		return chain;
	} else {
		return {id: '', name: '', enabled: false, website: '', contactName: '', corporateEmail: ''};
	}
};
var $author$project$Tasks$Bing$Claim$Model$ChainContactName = {$: 'ChainContactName'};
var $author$project$Tasks$Bing$Claim$Model$ChainInputOnChange = F2(
	function (a, b) {
		return {$: 'ChainInputOnChange', a: a, b: b};
	});
var $author$project$Tasks$Bing$Claim$Model$ChainCorporateEmail = {$: 'ChainCorporateEmail'};
var $author$project$Translations$Listings$Claim$bingChainSectionWebsite = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_website');
};
var $author$project$Translations$Listings$Claim$bingChainSectionChainName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_chain_name');
};
var $author$project$Translations$Listings$Claim$bingChainSectionContactName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_contact_name');
};
var $author$project$Translations$Listings$Claim$bingChainSectionCorporateEmail = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_corporate_email');
};
var $author$project$Translations$Listings$Claim$bingChainSectionWebsitePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_website_placeholder');
};
var $author$project$Translations$Listings$Claim$bingChainSectionChainNamePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_chain_name_placeholder');
};
var $author$project$Translations$Listings$Claim$bingChainSectionContactNamePlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_contact_name_placeholder');
};
var $author$project$Translations$Listings$Claim$bingChainSectionCorporateEmailPlaceholder = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_corporate_email_placeholder');
};
var $author$project$Tasks$Bing$Claim$Sections$ChainSection$renderChainForm = F2(
	function (session, model) {
		var chain = $author$project$Tasks$Bing$Claim$Commands$parseChainData(model.chain);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bing-claim-page--chain-section__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bing-claim-page--chain-section__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bing-claim-page--chain-section__row--child bing-claim-page--chain-section__row--child--left')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Input$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Input$withError,
										A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$withError, session.translations, chain.name),
										A2(
											$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
											$author$project$Translations$Listings$Claim$bingChainSectionChainNamePlaceholder(session.translations),
											A2(
												$author$project$PinMeTo$Ui$Form$Input$withLabel,
												$author$project$Translations$Listings$Claim$bingChainSectionChainName(session.translations),
												$author$project$PinMeTo$Ui$Form$Input$text(
													{
														value: chain.name,
														onChange: $author$project$Tasks$Bing$Claim$Model$ChainInputOnChange($author$project$Tasks$Bing$Claim$Model$ChainName)
													})))))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bing-claim-page--chain-section__row--child')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Input$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Input$withError,
										A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$withError, session.translations, chain.website),
										A2(
											$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
											$author$project$Translations$Listings$Claim$bingChainSectionWebsitePlaceholder(session.translations),
											A2(
												$author$project$PinMeTo$Ui$Form$Input$withLabel,
												$author$project$Translations$Listings$Claim$bingChainSectionWebsite(session.translations),
												$author$project$PinMeTo$Ui$Form$Input$text(
													{
														value: chain.website,
														onChange: $author$project$Tasks$Bing$Claim$Model$ChainInputOnChange($author$project$Tasks$Bing$Claim$Model$ChainWebsite)
													})))))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bing-claim-page--chain-section__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bing-claim-page--chain-section__row--child bing-claim-page--chain-section__row--child--left')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Input$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Input$withError,
										A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$withError, session.translations, chain.contactName),
										A2(
											$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
											$author$project$Translations$Listings$Claim$bingChainSectionContactNamePlaceholder(session.translations),
											A2(
												$author$project$PinMeTo$Ui$Form$Input$withLabel,
												$author$project$Translations$Listings$Claim$bingChainSectionContactName(session.translations),
												$author$project$PinMeTo$Ui$Form$Input$text(
													{
														value: chain.contactName,
														onChange: $author$project$Tasks$Bing$Claim$Model$ChainInputOnChange($author$project$Tasks$Bing$Claim$Model$ChainContactName)
													})))))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bing-claim-page--chain-section__row--child')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Form$Input$render(
									A2(
										$author$project$PinMeTo$Ui$Form$Input$withError,
										A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$withError, session.translations, chain.corporateEmail),
										A2(
											$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
											$author$project$Translations$Listings$Claim$bingChainSectionCorporateEmailPlaceholder(session.translations),
											A2(
												$author$project$PinMeTo$Ui$Form$Input$withLabel,
												$author$project$Translations$Listings$Claim$bingChainSectionCorporateEmail(session.translations),
												$author$project$PinMeTo$Ui$Form$Input$text(
													{
														value: chain.corporateEmail,
														onChange: $author$project$Tasks$Bing$Claim$Model$ChainInputOnChange($author$project$Tasks$Bing$Claim$Model$ChainCorporateEmail)
													})))))
								]))
						]))
				]));
	});
var $author$project$Tasks$Bing$Claim$Model$SaveChain = {$: 'SaveChain'};
var $author$project$Tasks$Bing$Claim$Sections$ChainSection$getPublishButtonLabel = F2(
	function (translations, chain) {
		return (chain.id === '') ? $author$project$Translations$General$create(translations) : $author$project$Translations$General$update(translations);
	});
var $author$project$Tasks$Bing$Claim$Sections$ChainSection$isPublishButtonDisabled = function (chain) {
	return (chain.name === '') || ((chain.website === '') || ((chain.contactName === '') || (chain.corporateEmail === '')));
};
var $author$project$Tasks$Bing$Claim$Sections$ChainSection$renderPublishButton = F2(
	function (translations, model) {
		return $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$disabledIfTrue,
				$author$project$Tasks$Bing$Claim$Sections$ChainSection$isPublishButtonDisabled(
					$author$project$Tasks$Bing$Claim$Commands$parseChainData(model.chain)),
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Tasks$Bing$Claim$Model$SaveChain,
					$author$project$PinMeTo$Ui$Button$buttonPrimary(
						A2(
							$author$project$Tasks$Bing$Claim$Sections$ChainSection$getPublishButtonLabel,
							translations,
							$author$project$Tasks$Bing$Claim$Commands$parseChainData(model.chain))))));
	});
var $author$project$Translations$Listings$Claim$bingChainSectionTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_section_title');
};
var $author$project$Tasks$Bing$Claim$Model$getSectionNotification = F2(
	function (section, notifications) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (notification) {
				return _Utils_eq(notification.section, section);
			},
			notifications);
	});
var $author$project$Tasks$Bing$Claim$Sections$ChainSection$renderChainSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__content-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$author$project$Tasks$Shared$Components$Header$renderHeader,
						$author$project$Translations$Listings$Claim$bingChainSectionTitle(session.translations),
						$elm$core$Maybe$Nothing)
					]),
				function () {
					var _v0 = model.chain;
					if (_v0.$ === 'Loading') {
						return _List_fromArray(
							[$author$project$PinMeTo$Ui$Spinner$spinner]);
					} else {
						return _List_fromArray(
							[
								$author$project$Tasks$Bing$Claim$Sections$Shared$renderAlert(
								A2($author$project$Tasks$Bing$Claim$Model$getSectionNotification, $author$project$Tasks$Bing$Claim$Model$ChainSection, model.notifications)),
								A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$renderChainForm, session, model),
								A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$renderPublishButton, session.translations, model)
							]);
					}
				}()));
	});
var $author$project$Tasks$Bing$Claim$Model$Invalid = {$: 'Invalid'};
var $author$project$Tasks$Bing$Claim$Model$UiPopOverMsg = function (a) {
	return {$: 'UiPopOverMsg', a: a};
};
var $author$project$Translations$Listings$Claim$locationsFailedToCreateOnBingAutomatically = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.locations_failed_to_create_on_bing_automatically');
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderHeader_ = F2(
	function (uiPopoverState, session) {
		var popOverConfig = {
			uid: 'create-locations-popover',
			tagger: $author$project$Tasks$Bing$Claim$Model$UiPopOverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$locationsFailedToCreateOnBingAutomatically(session.translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$createLocations(session.translations),
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$classSelection = F2(
	function (model, tab) {
		return _Utils_eq(tab, model.createLocationsTab) ? 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header pmt-ui-view-selector__item--active pmt-ui-view-selector__item--enabled' : 'pmt-ui-view-selector__item pmt-ui-view-selector__item--label form__selectable-header';
	});
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError = function (location) {
	return !$elm$core$List$isEmpty(
		A2($elm$core$Maybe$withDefault, _List_Nil, location.errors));
};
var $author$project$Tasks$Bing$Claim$Model$filter = F2(
	function (searchQuery, locations) {
		var lowercasedSearchQuery = $elm$core$String$toLower(searchQuery);
		return (searchQuery === '') ? locations : A2(
			$elm$core$List$filter,
			function (locationToCreate) {
				return A2($author$project$Data$Location$Filter$isMatch, lowercasedSearchQuery, locationToCreate.location);
			},
			locations);
	});
var $author$project$Tasks$Bing$Claim$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderErrorMessage = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__error-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getLastClaimAttempt = function (lastClaimAttempt) {
	if (lastClaimAttempt.$ === 'Just') {
		var lastClaimAttempt_ = lastClaimAttempt.a;
		return lastClaimAttempt_;
	} else {
		return '';
	}
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getFirstErrorMessage = function (errors) {
	if (errors.$ === 'Just') {
		if (errors.a.b) {
			var _v1 = errors.a;
			var error = _v1.a;
			return error;
		} else {
			return '';
		}
	} else {
		return '';
	}
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationTypeToPlainString = function (locationTypeToTurn) {
	switch (locationTypeToTurn.$) {
		case 'Storefront':
			return 'Storefront';
		case 'StorefrontAndServiceArea':
			return 'Storefront and Service Area';
		default:
			return 'Service Area';
	}
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationListTable = F4(
	function (translations, site, model, filteredLocations) {
		var createLocationTabAddColumn = function () {
			var _v0 = model.createLocationsTab;
			if (_v0.$ === 'Available') {
				return $elm$core$Basics$identity;
			} else {
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					'Error',
					function (location) {
						return $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderErrorMessage(
							$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getFirstErrorMessage(location.errors));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (l) {
							return $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getFirstErrorMessage(l.errors);
						}));
			}
		}();
		var locationsMatchingFilter = A2($author$project$Tasks$Bing$Claim$Model$filter, model.filter, filteredLocations);
		var anyLocationHasNetworkClaimError = A2($elm$core$List$any, $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError, locationsMatchingFilter);
		var locationStatusText = function (location) {
			return location.isActive ? (location.permanentlyClosed ? $author$project$Translations$General$closed(translations) : $author$project$Translations$General$open(translations)) : $author$project$Translations$General$disabled(translations);
		};
		var showLocationStatus = function (location) {
			return location.isActive ? (location.permanentlyClosed ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__error-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						locationStatusText(location))
					])) : A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						locationStatusText(location))
					]))) : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__error-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						locationStatusText(location))
					]));
		};
		var siteName_ = $author$project$Data$SiteName$toString(site);
		return A2(
			$author$project$PinMeTo$Ui$Table$render,
			model.uiTable,
			A3(
				$author$project$PinMeTo$Ui$Table$withColumnSelectionAndLink,
				function (x) {
					return x.location.id;
				},
				function (location) {
					return '/listings/' + (siteName_ + ('/locations/' + location.location.id));
				},
				A4(
					$author$project$PinMeTo$Ui$Table$addColumn,
					'Type',
					function (location) {
						return $elm$html$Html$text(
							$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationTypeToPlainString(location.location.locationType));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (l) {
							return $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationTypeToPlainString(l.location.locationType);
						}),
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						'City',
						function (location) {
							return $elm$html$Html$text(location.location.address.city);
						},
						$author$project$PinMeTo$Ui$Table$comparing(
							function (l) {
								return l.location.address.city;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							'Zip',
							function (location) {
								return $elm$html$Html$text(location.location.address.zip);
							},
							$author$project$PinMeTo$Ui$Table$comparing(
								function (l) {
									return l.location.address.zip;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								'Street',
								function (location) {
									return $elm$html$Html$text(location.location.address.street);
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (l) {
										return l.location.address.street;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									'Name',
									function (location) {
										return $elm$html$Html$text(location.location.name);
									},
									$author$project$PinMeTo$Ui$Table$comparing(
										function (l) {
											return l.location.name;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addColumn,
										'Status',
										function (location) {
											return showLocationStatus(location.location);
										},
										$author$project$PinMeTo$Ui$Table$comparing(
											function (l) {
												return locationStatusText(l.location);
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											'Last claim attempt',
											function (location) {
												return $elm$html$Html$text(
													$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getLastClaimAttempt(location.lastClaimAttempt));
											},
											$author$project$PinMeTo$Ui$Table$comparing(
												function (l) {
													return $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getLastClaimAttempt(l.lastClaimAttempt);
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												'Country',
												function (location) {
													return $elm$html$Html$text(location.location.address.country);
												},
												$author$project$PinMeTo$Ui$Table$comparing(
													function (l) {
														return l.location.address.country;
													}),
												(anyLocationHasNetworkClaimError ? A3(
													$author$project$PinMeTo$Ui$Table$addColumn,
													'Error',
													function (location) {
														return $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderErrorMessage(
															$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getFirstErrorMessage(location.errors));
													},
													$author$project$PinMeTo$Ui$Table$comparing(
														function (l) {
															return $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$getFirstErrorMessage(l.errors);
														})) : $elm$core$Basics$identity)(
													createLocationTabAddColumn(
														A4(
															$author$project$PinMeTo$Ui$Table$addColumn,
															'StoreId',
															function (location) {
																return $elm$html$Html$text(location.location.storeId);
															},
															$author$project$PinMeTo$Ui$Table$comparing(
																function (l) {
																	return l.location.storeId;
																}),
															A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$Bing$Claim$Model$UiTableMsg, locationsMatchingFilter))))))))))))));
	});
var $author$project$Tasks$Bing$Claim$Model$FilterLocationsToCreate = function (a) {
	return {$: 'FilterLocationsToCreate', a: a};
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsList = F5(
	function (translations, siteName, model, filteredLocations, button) {
		var renderLocationListTable = $elm$core$List$isEmpty(filteredLocations) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$Claim$noAvailableLocationsToCreate(translations)))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__list-container')
				]),
			_List_fromArray(
				[
					A4($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationListTable, translations, siteName, model, filteredLocations)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__business-selection-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__business-selection-filter-row')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								'Search Locations',
								$author$project$PinMeTo$Ui$Form$Input$search(
									{value: model.filter, onChange: $author$project$Tasks$Bing$Claim$Model$FilterLocationsToCreate}))),
							button
						])),
					renderLocationListTable
				]));
	});
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderInvalidTab = F4(
	function (translations, siteName, model, filteredLocations) {
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Bing$Claim$Model$Invalid) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A5(
					$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsList,
					translations,
					siteName,
					model,
					filteredLocations,
					A2($elm$html$Html$span, _List_Nil, _List_Nil))
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Bing$Claim$Model$CreateLocationsSection = {$: 'CreateLocationsSection'};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderAlertSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__render-distance')
			]),
		_List_fromArray(
			[
				$author$project$Tasks$Bing$Claim$Sections$Shared$renderAlert(
				A2($author$project$Tasks$Bing$Claim$Model$getSectionNotification, $author$project$Tasks$Bing$Claim$Model$CreateLocationsSection, model.notifications))
			]));
};
var $author$project$Tasks$Bing$Claim$Model$CreateLocations = {$: 'CreateLocations'};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsCount = function (list) {
	return '(' + ($elm$core$String$fromInt(
		$elm$core$List$length(list)) + ')');
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList = function (locations) {
	if (locations.$ === 'Loaded') {
		var locations_ = locations.a;
		return locations_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderAvailableTab = F4(
	function (translations, siteName, model, filteredLocations) {
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
			},
			$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
		var isCreateButtonDisabled = $elm$core$List$isEmpty(selectedLocations);
		var createButton = A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(isCreateButtonDisabled),
					$elm$html$Html$Events$onClick($author$project$Tasks$Bing$Claim$Model$CreateLocations)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$create(translations) + (' ' + $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsCount(selectedLocations)))
				]));
		return _Utils_eq(model.createLocationsTab, $author$project$Tasks$Bing$Claim$Model$Available) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsList, translations, siteName, model, filteredLocations, createButton),
					createButton
				])) : $elm$html$Html$text('');
	});
var $author$project$Tasks$Bing$Claim$Model$SwitchCreateLocationsTab = function (a) {
	return {$: 'SwitchCreateLocationsTab', a: a};
};
var $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderCreateLocationsSection = F2(
	function (session, model) {
		var shouldDisableCreateSection = function () {
			var _v1 = model.chain;
			if (_v1.$ === 'Loaded') {
				var chain = _v1.a;
				return chain.id === '';
			} else {
				return true;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__content-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderHeader_, model.uiPopover, session),
						$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderAlertSection(model)
					]),
				function () {
					var _v0 = model.locationsToBeCreated;
					switch (_v0.$) {
						case 'Loading':
							return _List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]);
						case 'Loaded':
							var allLocations = _v0.a;
							var filterLocationsWithoutErrors = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeR, $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError, $elm$core$Basics$not),
								allLocations);
							var filterLocationsWithErrors = A2($elm$core$List$filter, $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError, allLocations);
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('network-claim-page__create-location-tabs'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bing-claim-page--create-section__disabled', shouldDisableCreateSection)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-ui-view-selector')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(
															A2($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$classSelection, model, $author$project$Tasks$Bing$Claim$Model$Available)),
															$elm$html$Html$Events$onClick(
															$author$project$Tasks$Bing$Claim$Model$SwitchCreateLocationsTab($author$project$Tasks$Bing$Claim$Model$Available))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Claim$available(session.translations) + (' ' + $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsCount(filterLocationsWithoutErrors)))
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(
															A2($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$classSelection, model, $author$project$Tasks$Bing$Claim$Model$Invalid)),
															$elm$html$Html$Events$onClick(
															$author$project$Tasks$Bing$Claim$Model$SwitchCreateLocationsTab($author$project$Tasks$Bing$Claim$Model$Invalid))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Claim$invalid(session.translations) + (' ' + $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderLocationsCount(filterLocationsWithErrors)))
														]))
												])),
											A4($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderAvailableTab, session.translations, session.siteName, model, filterLocationsWithoutErrors),
											A4($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderInvalidTab, session.translations, session.siteName, model, filterLocationsWithErrors)
										]))
								]);
						case 'Error':
							var error = _v0.a;
							return _List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Error,
										$author$project$PinMeTo$Ui$Alert$plain(error)))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
					}
				}()));
	});
var $author$project$Tasks$Bing$Claim$View$renderClaimSections = F2(
	function (session, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__section-break')
					]),
				_List_fromArray(
					[$author$project$Tasks$Bing$Claim$View$lineSeparator])),
				A2($author$project$Tasks$Bing$Claim$Sections$ChainSection$renderChainSection, session, model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__section-break')
					]),
				_List_fromArray(
					[$author$project$Tasks$Bing$Claim$View$lineSeparator])),
				A2($author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$renderCreateLocationsSection, session, model),
				A2($elm$html$Html$br, _List_Nil, _List_Nil)
			]);
	});
var $author$project$Translations$Listings$Claim$claimBingLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_bing_locations');
};
var $author$project$Tasks$Bing$Claim$View$renderHeader = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorBing)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimBingLocations(translations))
					]))
			]));
};
var $author$project$Tasks$Bing$Claim$Model$SyncLocations = {$: 'SyncLocations'};
var $author$project$Tasks$Bing$Claim$Sections$SyncLocationsSection$renderLastDate = F2(
	function (translations, lastRun) {
		var dateAndTime = function () {
			if (lastRun.$ === 'Nothing') {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$syncLocationsNeverRun(translations))
							]))
					]);
			} else {
				var lastRun_ = lastRun.a;
				var time = A3($elm$core$String$slice, 11, 16, lastRun_);
				var date = A2($elm$core$String$left, 10, lastRun_);
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(date)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' ' + ($author$project$Translations$Listings$Claim$syncLocationsAt(translations) + ' '))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(time)
									]))
							]))
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations__container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-claim-page__sync-locations__last-sync'),
								$elm$html$Html$Attributes$class('pmt-ui-font-caption')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Claim$syncLocationsLastRun(translations))
							]))
					]),
				dateAndTime));
	});
var $author$project$Tasks$Bing$Claim$Sections$SyncLocationsSection$isButtonDisabled = function (model) {
	return (_Utils_eq(model.locationsToBeCreated, $author$project$RemoteData$Loading) || _Utils_eq(model.chain, $author$project$RemoteData$Loading)) ? true : false;
};
var $author$project$Tasks$Bing$Claim$Sections$SyncLocationsSection$renderSyncLocationsSection = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations_section')
				]),
			_List_fromArray(
				[
					A2($author$project$Tasks$Bing$Claim$Sections$SyncLocationsSection$renderLastDate, translations, model.syncLocationsLastRun),
					A4(
					$author$project$PinMeTo$Ui$Btn$pmtBtnCta,
					$author$project$PinMeTo$Ui$Btn$FASolid($author$project$FontAwesome$Solid$Icon$faArrowsRotate),
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Tasks$Bing$Claim$Model$SyncLocations),
							$elm$html$Html$Attributes$disabled(
							$author$project$Tasks$Bing$Claim$Sections$SyncLocationsSection$isButtonDisabled(model))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Claim$syncLocations(translations))
						]))
				]));
	});
var $author$project$Tasks$Bing$Claim$View$renderInnerContainer = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Tasks$Bing$Claim$View$renderHeader(session.translations)
					]),
				_List_fromArray(
					[
						A2($author$project$Tasks$Bing$Claim$Sections$SyncLocationsSection$renderSyncLocationsSection, session.translations, model)
					])));
	});
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$sortCategories = $elm$core$List$sortBy($author$project$Data$Location$NetworkCategories$getName);
var $author$project$Tasks$Bing$Claim$Model$CategoriesSection = {$: 'CategoriesSection'};
var $author$project$Tasks$Bing$Claim$Model$SaveCategories = {$: 'SaveCategories'};
var $author$project$Tasks$Bing$Claim$Update$areCategoriesSelected = function (model) {
	var areAllAdditionalCategoriesSelected = A2($elm$core$List$all, $elm_community$maybe_extra$Maybe$Extra$isJust, model.additionalCategoriesList);
	var isPrimaryCategorySelected = $elm_community$maybe_extra$Maybe$Extra$isJust(model.primaryCategory);
	return isPrimaryCategorySelected && areAllAdditionalCategoriesSelected;
};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderPublishButton = F2(
	function (translations, model) {
		return A3(
			$author$project$PinMeTo$Ui$Btn$pmtBtn,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					!$author$project$Tasks$Bing$Claim$Update$areCategoriesSelected(model)),
					$elm$html$Html$Events$onClick($author$project$Tasks$Bing$Claim$Model$SaveCategories)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$publish(translations))
				]));
	});
var $author$project$Tasks$Bing$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$selectableCategories = F2(
	function (categories, category) {
		if (category.$ === 'Just') {
			var category_ = category.a;
			return A2($elm$core$List$cons, category_, categories);
		} else {
			return categories;
		}
	});
var $author$project$Tasks$Bing$Claim$Model$SelectedPrimaryCategory = function (a) {
	return {$: 'SelectedPrimaryCategory', a: a};
};
var $author$project$Tasks$Bing$Claim$Model$SelectedAdditionalCategory = F2(
	function (a, b) {
		return {$: 'SelectedAdditionalCategory', a: a, b: b};
	});
var $author$project$Tasks$Bing$Claim$Model$RemoveAdditionalCategoryByIndex = function (a) {
	return {$: 'RemoveAdditionalCategoryByIndex', a: a};
};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderCategorySelector = F6(
	function (uid, translations, model, categories, category, index) {
		var isPrimary = uid === 'ui-select-primary';
		var title = isPrimary ? $author$project$Translations$Listings$LocationDetail$primaryCategory(translations) : A2(
			$author$project$Translations$Listings$LocationDetail$additionalCategory,
			translations,
			$elm$core$String$fromInt(index + 1));
		var label = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Translations$Listings$LocationDetail$helpTextCategoriesSelectAction(translations),
			function (category_) {
				return $author$project$Data$Location$NetworkCategories$getName(category_);
			},
			category);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__select-container network-claim-page__categories-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-ui-font-body network-claim-page__categories-component-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('lightbox__select-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__dropdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$withFullWidthInputToggle(
										A2(
											$author$project$PinMeTo$Ui$Select$withSearch,
											{
												searchMap: $author$project$Data$Location$NetworkCategories$getName,
												placeholder: $author$project$Translations$General$searchItemsPlaceholder(translations),
												noResultsLabel: $author$project$Translations$General$searchNoResults(translations)
											},
											$author$project$PinMeTo$Ui$Select$view(
												{
													uid: uid + ('-' + $elm$core$String$fromInt(index)),
													items: A2($author$project$Tasks$Bing$Claim$Sections$CategoriesSection$selectableCategories, categories, category),
													label: $elm$html$Html$text(label),
													tagger: $author$project$Tasks$Bing$Claim$Model$UiSelectMsg,
													onChange: function (category_) {
														return isPrimary ? $author$project$Tasks$Bing$Claim$Model$SelectedPrimaryCategory(category_) : A2($author$project$Tasks$Bing$Claim$Model$SelectedAdditionalCategory, category_, index);
													},
													itemRender: A2($elm$core$Basics$composeR, $author$project$Data$Location$NetworkCategories$getName, $elm$html$Html$text)
												}))))
								])),
							isPrimary ? $elm$html$Html$text('') : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lightbox__remove-additional'),
									$elm$html$Html$Events$onClick(
									$author$project$Tasks$Bing$Claim$Model$RemoveAdditionalCategoryByIndex(index))
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$Delete)
								]))
						]))
				]));
	});
var $author$project$Tasks$Bing$Claim$Model$AddAdditionalCategory = {$: 'AddAdditionalCategory'};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderAddCategoryButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__publish-button')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
				$author$project$PinMeTo$Ui$Btn$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Tasks$Bing$Claim$Model$AddAdditionalCategory)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$addCategory(translations))
					]))
			]));
};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderAdditionalCategories = F3(
	function (translations, model, categories) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return A6($author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-additional', translations, model, categories, item, index);
					}),
				model.additionalCategoriesList));
	});
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$getCategoryId = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	'',
	function (category_) {
		return $author$project$Data$Location$NetworkCategories$getId(category_);
	});
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$getSelectedCategoryIds = function (model) {
	return A2(
		$elm$core$List$append,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function (category) {
				return _List_fromArray(
					[
						$author$project$Data$Location$NetworkCategories$getId(category)
					]);
			},
			model.primaryCategory),
		A2(
			$elm$core$List$filter,
			function (category) {
				return category !== '';
			},
			A2($elm$core$List$map, $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$getCategoryId, model.additionalCategoriesList)));
};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$getAllNotSelectedCategories = function (model) {
	var _v0 = model.allCategories;
	if (_v0.$ === 'Loaded') {
		var categories = _v0.a;
		return A2(
			$elm$core$List$filter,
			function (category) {
				return !A2(
					$elm$core$List$member,
					$author$project$Data$Location$NetworkCategories$getId(category),
					$author$project$Tasks$Bing$Claim$Sections$CategoriesSection$getSelectedCategoryIds(model));
			},
			categories);
	} else {
		return _List_Nil;
	}
};
var $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderCategorySection = F2(
	function (translations, model) {
		var sortedCategories = $author$project$Tasks$Bing$Claim$Sections$CategoriesSection$sortCategories(
			$author$project$Tasks$Bing$Claim$Sections$CategoriesSection$getAllNotSelectedCategories(model));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Tasks$Shared$Components$Header$renderHeader,
							$author$project$Translations$Listings$Claim$categories(translations),
							$elm$core$Maybe$Nothing),
							$author$project$Tasks$Bing$Claim$Sections$Shared$renderAlert(
							A2($author$project$Tasks$Bing$Claim$Model$getSectionNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model.notifications)),
							A6($author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderCategorySelector, 'ui-select-primary', translations, model, sortedCategories, model.primaryCategory, 0),
							A3($author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderAdditionalCategories, translations, model, sortedCategories),
							$author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderAddCategoryButton(translations),
							A2($author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderPublishButton, translations, model)
						]))
				]));
	});
var $author$project$Tasks$Bing$Claim$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$Bing$Claim$View$renderInnerContainer, session, model),
						$author$project$Tasks$Bing$Claim$View$lineSeparator,
						A2($author$project$Tasks$Bing$Claim$Sections$CategoriesSection$renderCategorySection, session.translations, model)
					]),
				A2($author$project$Tasks$Bing$Claim$View$renderClaimSections, session, model)));
	});
var $author$project$Tasks$Bing$Claim$Model$Info = {$: 'Info'};
var $author$project$Tasks$Bing$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$Bing$Claim$Model$Success = {$: 'Success'};
var $author$project$Tasks$Bing$Claim$Commands$updateChainEncoder = function (chain) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(chain.name)),
				_Utils_Tuple2(
				'contactName',
				$elm$json$Json$Encode$string(chain.contactName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(chain.corporateEmail)),
				_Utils_Tuple2(
				'website',
				$elm$json$Json$Encode$string(chain.website))
			]));
};
var $author$project$Tasks$Bing$Claim$Commands$updateChain = F3(
	function (_v0, chain, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/bing/claim/chain');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Bing$Claim$Commands$chainDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Bing$Claim$Commands$updateChainEncoder(
						$author$project$Tasks$Bing$Claim$Commands$parseChainData(chain)),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Bing$Claim$Commands$syncLocations = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/bing/locationsfind');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed('Syncing locations'),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get(url)));
	});
var $author$project$Tasks$Bing$Claim$Commands$encodeCategory = function (x) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getId(x))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Data$Location$NetworkCategories$getName(x)))
			]));
};
var $author$project$Tasks$Bing$Claim$Commands$encodeCategories = function (model) {
	var primaryCategoryId = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (category) {
			return $author$project$Data$Location$NetworkCategories$getId(category);
		},
		model.primaryCategory);
	var categories = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$append,
			_List_fromArray(
				[model.primaryCategory]),
			model.additionalCategoriesList));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'categories',
				A2($elm$json$Json$Encode$list, $author$project$Tasks$Bing$Claim$Commands$encodeCategory, categories)),
				_Utils_Tuple2(
				'primaryCategoryId',
				$elm$json$Json$Encode$string(primaryCategoryId))
			]));
};
var $author$project$Tasks$Bing$Claim$Commands$saveCategories = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var url = 'api/' + (accountName + '/bing/categories');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$succeed(
						{success: true}),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Bing$Claim$Commands$encodeCategories(model),
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Tasks$Bing$Claim$Update$emptyNotification = F2(
	function (section, model) {
		return _Utils_update(
			model,
			{
				notifications: A2(
					$elm$core$List$filter,
					function (notification) {
						return !_Utils_eq(notification.section, section);
					},
					model.notifications)
			});
	});
var $author$project$Tasks$Bing$Claim$Update$addNotification = F4(
	function (section, state, message, model) {
		var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, section, model);
		return _Utils_update(
			newModel,
			{
				notifications: _Utils_ap(
					model.notifications,
					_List_fromArray(
						[
							{state: state, message: message, section: section}
						]))
			});
	});
var $author$project$Tasks$Bing$Claim$Commands$createLocationsEncoder = function (locations) {
	return A2(
		$elm$json$Json$Encode$list,
		function (location) {
			return $elm$json$Json$Encode$string(location.location.id);
		},
		locations);
};
var $author$project$Tasks$Bing$Claim$Commands$createLocations = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
			},
			$author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationsToBeCreatedList(model.locationsToBeCreated));
		var allHaveNoErrors = A2(
			$elm$core$List$all,
			A2($elm$core$Basics$composeR, $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError, $elm$core$Basics$not),
			selectedLocations);
		var url = 'api/' + (accountName + '/place/bing');
		return allHaveNoErrors ? $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Tasks$Bing$Claim$Commands$locationToCreateDecoder),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$Tasks$Bing$Claim$Commands$createLocationsEncoder(selectedLocations),
					$lukewestby$elm_http_builder$HttpBuilder$post(url)))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Translations$Listings$Claim$bingChainSuccess = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_chain_success');
};
var $author$project$Translations$Listings$Claim$bingSetChainInfo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.bing_set_chain_info');
};
var $author$project$Tasks$Bing$Claim$Model$SaveChainResponse = function (a) {
	return {$: 'SaveChainResponse', a: a};
};
var $author$project$Tasks$Bing$Claim$Model$SendSyncLocations = function (a) {
	return {$: 'SendSyncLocations', a: a};
};
var $author$project$Tasks$Bing$Claim$Model$SaveCategoriesResult = function (a) {
	return {$: 'SaveCategoriesResult', a: a};
};
var $author$project$Tasks$Bing$Claim$Model$CreateLocationsResponse = function (a) {
	return {$: 'CreateLocationsResponse', a: a};
};
var $author$project$Translations$Listings$Claim$locationsFailedToCreate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.locations_failed_to_create');
};
var $author$project$Tasks$Bing$Claim$Update$updateLocationWithError = F2(
	function (locationsWithError, location) {
		var locationWithError = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (x) {
					return _Utils_eq(x.location.id, location.location.id);
				},
				locationsWithError));
		if (locationWithError.$ === 'Just') {
			var errors = locationWithError.a.errors;
			return _Utils_update(
				location,
				{errors: errors});
		} else {
			return location;
		}
	});
var $author$project$Tasks$Bing$Claim$Update$updateLocationsToBeCreated = F2(
	function (locationsToBeCreated, locationsWithoutError) {
		if (locationsToBeCreated.$ === 'Loaded') {
			var locationsData = locationsToBeCreated.a;
			return $author$project$RemoteData$Loaded(
				A2(
					$elm$core$List$filter,
					function (location) {
						return !A2($elm$core$List$member, location.location.id, locationsWithoutError);
					},
					locationsData));
		} else {
			return locationsToBeCreated;
		}
	});
var $author$project$Translations$Listings$Claim$locationsCreatedSuccessfully = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.locations_created_successfully');
};
var $author$project$Tasks$Bing$Claim$Update$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$Bing$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopOverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$Bing$Claim$Model$UiPopOverMsg, msg_, model.uiPopover));
			case 'GotAllCategories':
				if (msg.a.$ === 'Ok') {
					var categories = msg.a.a;
					var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model);
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								allCategories: $author$project$RemoteData$Loaded(categories)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var updatedModel = A4(
						$author$project$Tasks$Bing$Claim$Update$addNotification,
						$author$project$Tasks$Bing$Claim$Model$CategoriesSection,
						$author$project$Tasks$Bing$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$PopUpContent$categoriesErrorSuspended(session.translations),
						model);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								allCategories: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Bing.Claim.Update.GotAllCategories',
								message: 'Failed to decode response GotAllCategories'
							}));
				}
			case 'SelectedPrimaryCategory':
				var category = msg.a;
				var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model);
				return A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					model.additionalCategoriesList) ? _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						newModel,
						{
							primaryCategory: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none);
			case 'AddAdditionalCategory':
				var newSelection = A2(
					$elm$core$List$append,
					model.additionalCategoriesList,
					$elm$core$List$singleton($elm$core$Maybe$Nothing));
				var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model);
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{additionalCategoriesList: newSelection}),
					$elm$core$Platform$Cmd$none);
			case 'SelectedAdditionalCategory':
				var category = msg.a;
				var index = msg.b;
				var primaryCategory = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (cat) {
						return $elm$core$List$singleton(
							$elm$core$Maybe$Just(cat));
					},
					model.primaryCategory);
				var newAdditional = A2(
					$elm$core$List$member,
					$elm$core$Maybe$Just(category),
					A2($elm$core$List$append, model.additionalCategoriesList, primaryCategory)) ? model.additionalCategoriesList : A2(
					$elm$core$List$append,
					A2(
						$elm$core$List$append,
						A2($elm$core$List$take, index, model.additionalCategoriesList),
						$elm$core$List$singleton(
							$elm$core$Maybe$Just(category))),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model);
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'RemoveAdditionalCategoryByIndex':
				var index = msg.a;
				var newAdditional = A2(
					$elm$core$List$append,
					A2($elm$core$List$take, index, model.additionalCategoriesList),
					A2($elm$core$List$drop, index + 1, model.additionalCategoriesList));
				var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model);
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{additionalCategoriesList: newAdditional}),
					$elm$core$Platform$Cmd$none);
			case 'SaveCategories':
				var newModel = A2($author$project$Tasks$Bing$Claim$Update$emptyNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, model);
				return $author$project$Tasks$Bing$Claim$Update$areCategoriesSelected(model) ? _Utils_Tuple2(
					newModel,
					A3($author$project$Tasks$Bing$Claim$Commands$saveCategories, session.siteName, model, $author$project$Tasks$Bing$Claim$Model$SaveCategoriesResult)) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'SaveCategoriesResult':
				if (msg.a.$ === 'Ok') {
					var success = msg.a.a.success;
					var _v1 = success ? _Utils_Tuple2(
						$author$project$Tasks$Bing$Claim$Model$Success,
						$author$project$Translations$Listings$LocationDetail$saveCategories(session.translations)) : _Utils_Tuple2(
						$author$project$Tasks$Bing$Claim$Model$Failed,
						$author$project$Translations$Listings$LocationDetail$saveCategoriesFailed(session.translations));
					var notificationState = _v1.a;
					var notificationMessage = _v1.b;
					return _Utils_Tuple2(
						A4($author$project$Tasks$Bing$Claim$Update$addNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, notificationState, notificationMessage, model),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					return _Utils_Tuple2(
						A4($author$project$Tasks$Bing$Claim$Update$addNotification, $author$project$Tasks$Bing$Claim$Model$CategoriesSection, $author$project$Tasks$Bing$Claim$Model$Failed, message, model),
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Tasks.Bing.Claim.Update.SaveCategoriesResult', message: 'Failed to decode response SaveCategoriesResult'}));
				}
			case 'GetLocationsToBeCreated':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationsToBeCreated: $author$project$RemoteData$Loaded(locations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationsToBeCreated: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Bing.Claim.Update.GetLocationsToBeCreated',
								message: 'Failed to decode response GetLocationsToBeCreated'
							}));
				}
			case 'FilterLocationsToCreate':
				var locationFilter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: locationFilter}),
					$elm$core$Platform$Cmd$none);
			case 'CreateLocations':
				return _Utils_Tuple2(
					model,
					A3($author$project$Tasks$Bing$Claim$Commands$createLocations, session.siteName, model, $author$project$Tasks$Bing$Claim$Model$CreateLocationsResponse));
			case 'CreateLocationsResponse':
				if (msg.a.$ === 'Ok') {
					var locations = msg.a.a;
					var locationsWithoutError = A2(
						$elm$core$List$map,
						function (location) {
							return location.location.id;
						},
						A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeR, $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError, $elm$core$Basics$not),
							locations));
					var locationsToBeCreated = A2($author$project$Tasks$Bing$Claim$Update$updateLocationsToBeCreated, model.locationsToBeCreated, locationsWithoutError);
					var locationsWithError = A2($elm$core$List$filter, $author$project$Tasks$Bing$Claim$Sections$CreateLocationsSection$locationHasError, locations);
					var updatedLocationsData = function () {
						if (locationsToBeCreated.$ === 'Loaded') {
							var locationsData = locationsToBeCreated.a;
							return $author$project$RemoteData$Loaded(
								A2(
									$elm$core$List$map,
									$author$project$Tasks$Bing$Claim$Update$updateLocationWithError(locationsWithError),
									locationsData));
						} else {
							return locationsToBeCreated;
						}
					}();
					var newModelWithNotification = function () {
						var allSucceeded = _Utils_eq(
							$elm$core$List$length(locationsWithoutError),
							$elm$core$List$length(locations));
						return allSucceeded ? A4(
							$author$project$Tasks$Bing$Claim$Update$addNotification,
							$author$project$Tasks$Bing$Claim$Model$CreateLocationsSection,
							$author$project$Tasks$Bing$Claim$Model$Success,
							$author$project$Translations$Listings$Claim$locationsCreatedSuccessfully(session.translations),
							model) : (($elm$core$List$length(locationsWithError) > 0) ? A4(
							$author$project$Tasks$Bing$Claim$Update$addNotification,
							$author$project$Tasks$Bing$Claim$Model$CreateLocationsSection,
							$author$project$Tasks$Bing$Claim$Model$Failed,
							$author$project$Translations$Listings$Claim$locationsFailedToCreate(session.translations),
							model) : model);
					}();
					return _Utils_Tuple2(
						_Utils_update(
							newModelWithNotification,
							{locationsToBeCreated: updatedLocationsData}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var newModel = A4(
						$author$project$Tasks$Bing$Claim$Update$addNotification,
						$author$project$Tasks$Bing$Claim$Model$CreateLocationsSection,
						$author$project$Tasks$Bing$Claim$Model$Failed,
						$author$project$PinMeTo$ExpectJson$getErrorMessage(err),
						model);
					return _Utils_Tuple2(
						newModel,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Bing.Claim.Update.CreateLocationsResponse',
								message: 'Failed to decode response CreateLocationsResponse'
							}));
				}
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SwitchCreateLocationsTab':
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: '', createLocationsTab: tab}),
					$elm$core$Platform$Cmd$none);
			case 'SyncLocations':
				var newModel = _Utils_update(
					model,
					{chain: $author$project$RemoteData$Loading, locationsToBeCreated: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$Bing$Claim$Commands$syncLocations, session.siteName, $author$project$Tasks$Bing$Claim$Model$SendSyncLocations)
							])));
			case 'SendSyncLocations':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'SocketSyncLocations':
				var lastRun = msg.a;
				var newModel = _Utils_update(
					model,
					{
						chain: $author$project$RemoteData$Loading,
						locationsToBeCreated: $author$project$RemoteData$Loading,
						syncLocationsLastRun: $elm$core$Maybe$Just(lastRun)
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$Bing$Claim$Commands$getLocationsToBeCreated, session.siteName, $author$project$Tasks$Bing$Claim$Model$GetLocationsToBeCreated),
								A2($author$project$Tasks$Bing$Claim$Commands$getChain, session.siteName, $author$project$Tasks$Bing$Claim$Model$GetChain)
							])));
			case 'GetChain':
				if (msg.a.$ === 'Ok') {
					var chain = msg.a.a;
					var newModel = (chain.id === '') ? A4(
						$author$project$Tasks$Bing$Claim$Update$addNotification,
						$author$project$Tasks$Bing$Claim$Model$CreateLocationsSection,
						$author$project$Tasks$Bing$Claim$Model$Info,
						$author$project$Translations$Listings$Claim$bingSetChainInfo(session.translations),
						model) : model;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								chain: $author$project$RemoteData$Loaded(chain)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								chain: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.Bing.Claim.Update.GetChain',
								message: 'Failed to decode response GetChain'
							}));
				}
			case 'ChainInputOnChange':
				var field = msg.a;
				var value = msg.b;
				var _v3 = model.chain;
				if (_v3.$ === 'Loaded') {
					var chain = _v3.a;
					var updatedChain = function () {
						switch (field.$) {
							case 'ChainName':
								return _Utils_update(
									chain,
									{name: value});
							case 'ChainContactName':
								return _Utils_update(
									chain,
									{contactName: value});
							case 'ChainCorporateEmail':
								return _Utils_update(
									chain,
									{corporateEmail: value});
							default:
								return _Utils_update(
									chain,
									{website: value});
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								chain: $author$project$RemoteData$Loaded(updatedChain)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'SaveChain':
				return _Utils_Tuple2(
					model,
					A3($author$project$Tasks$Bing$Claim$Commands$updateChain, session.siteName, model.chain, $author$project$Tasks$Bing$Claim$Model$SaveChainResponse));
			default:
				if (msg.a.$ === 'Ok') {
					var chain = msg.a.a;
					var newModel = A2(
						$author$project$Tasks$Bing$Claim$Update$emptyNotification,
						$author$project$Tasks$Bing$Claim$Model$CreateLocationsSection,
						A4(
							$author$project$Tasks$Bing$Claim$Update$addNotification,
							$author$project$Tasks$Bing$Claim$Model$ChainSection,
							$author$project$Tasks$Bing$Claim$Model$Success,
							$author$project$Translations$Listings$Claim$bingChainSuccess(session.translations),
							model));
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								chain: $author$project$RemoteData$Loaded(chain)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var message = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					return _Utils_Tuple2(
						A4($author$project$Tasks$Bing$Claim$Update$addNotification, $author$project$Tasks$Bing$Claim$Model$ChainSection, $author$project$Tasks$Bing$Claim$Model$Failed, message, model),
						$author$project$PinMeTo$Logger$log(
							{data: message, context: 'Tasks.Bing.Claim.Update.SaveChainResponse', message: 'Failed to decode response SaveChainResponse'}));
				}
		}
	});
var $author$project$Tasks$Bing$Claim$Commands$flagsCategoriesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (maybeId) {
		if (maybeId.$ === 'Just') {
			var primaryCategoryId = maybeId.a;
			return A2(
				$elm$json$Json$Decode$map,
				function (categories) {
					var common = function (cat) {
						return $author$project$Data$Location$NetworkCategories$CommonNetworkCategory(cat);
					};
					var primaryCategory = A2(
						$elm$core$Maybe$map,
						common,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (cat) {
									return _Utils_eq(cat.id, primaryCategoryId);
								},
								categories)));
					var additionalCategories = A2(
						$elm$core$List$map,
						A2($elm$core$Basics$composeR, common, $elm$core$Maybe$Just),
						A2(
							$elm$core$List$filter,
							function (cat) {
								return !_Utils_eq(cat.id, primaryCategoryId);
							},
							categories));
					return {primaryCategory: primaryCategory, additionalCategories: additionalCategories};
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['categories']),
					$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder)));
		} else {
			return $elm$json$Json$Decode$succeed(
				{primaryCategory: $elm$core$Maybe$Nothing, additionalCategories: _List_Nil});
		}
	},
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'primaryCategoryId', $elm$json$Json$Decode$string)));
var $author$project$Tasks$Bing$Claim$Commands$flagsDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (categories, lastRun) {
			return {categories: categories, syncLocationsLastRun: lastRun};
		}),
	$author$project$Tasks$Bing$Claim$Commands$flagsCategoriesDecoder,
	A2(
		$elm$json$Json$Decode$field,
		'lastRun',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Tasks$Bing$Claim$Model$SocketSyncLocations = function (a) {
	return {$: 'SocketSyncLocations', a: a};
};
var $author$project$Tasks$Bing$Claim$Main$in_Tasks_Bing_Claim_Main_syncLocations = _Platform_incomingPort('in_Tasks_Bing_Claim_Main_syncLocations', $elm$json$Json$Decode$string);
var $author$project$Tasks$Bing$Claim$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Tasks$Bing$Claim$Main$in_Tasks_Bing_Claim_Main_syncLocations($author$project$Tasks$Bing$Claim$Model$SocketSyncLocations)
			]));
};
var $author$project$Tasks$Bing$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$Bing$Claim$Main$init,
		view: function (session) {
			return $author$project$Tasks$Bing$Claim$View$view(session);
		},
		update: $author$project$Tasks$Bing$Claim$Update$update,
		flagsDecoder: $author$project$Tasks$Bing$Claim$Commands$flagsDecoder,
		subscriptions: $author$project$Tasks$Bing$Claim$Main$subscriptions
	});
var $author$project$Locations$Labels$Model$GotLibrary = function (a) {
	return {$: 'GotLibrary', a: a};
};
var $author$project$Locations$Labels$Model$NoDialog = {$: 'NoDialog'};
var $author$project$Locations$Labels$Model$emptyModel = function (isLabelsFeatureFlaggedUser) {
	return {dialog: $author$project$Locations$Labels$Model$NoDialog, saving: false, library: $author$project$RemoteData$Loading, searchQuery: '', errorMessage: $elm$core$Maybe$Nothing, popOverState: $author$project$PinMeTo$Ui$PopOver$init, displayFolders: _List_Nil, collapsedFolderIds: $elm$core$Set$empty, isLabelsFeatureFlaggedUser: isLabelsFeatureFlaggedUser};
};
var $author$project$Locations$Labels$Commands$apiBase = function (siteName) {
	return '/api/' + $author$project$Data$SiteName$toString(siteName);
};
var $author$project$Locations$Labels$Decoders$Library = function (folders) {
	return {folders: folders};
};
var $author$project$Locations$Labels$Decoders$Folder = F3(
	function (id, name, labels) {
		return {id: id, name: name, labels: labels};
	});
var $author$project$Locations$Labels$FolderId$FolderId = function (a) {
	return {$: 'FolderId', a: a};
};
var $author$project$Locations$Labels$FolderId$decode = $author$project$PinMeTo$Common$Util$idDecoder($author$project$Locations$Labels$FolderId$FolderId);
var $author$project$Locations$Labels$Decoders$Label = F4(
	function (id, name, folderId, color) {
		return {id: id, name: name, color: color, folderId: folderId};
	});
var $author$project$Locations$Labels$Color$Hex = function (a) {
	return {$: 'Hex', a: a};
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $author$project$Locations$Labels$Color$isValidHex = function (value) {
	return ($elm$core$String$length(value) === 7) && (A2($elm$core$String$startsWith, '#', value) && A2(
		$elm$core$String$all,
		$elm$core$Char$isHexDigit,
		A2($elm$core$String$dropLeft, 1, value)));
};
var $author$project$Locations$Labels$Color$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (raw) {
		var trimmed = $elm$core$String$toUpper(
			$elm$core$String$trim(raw));
		return $author$project$Locations$Labels$Color$isValidHex(trimmed) ? $elm$json$Json$Decode$succeed(
			$author$project$Locations$Labels$Color$Hex(trimmed)) : $elm$json$Json$Decode$fail('invalid hex color');
	},
	$elm$json$Json$Decode$string);
var $author$project$Locations$Labels$LabelId$LabelId = function (a) {
	return {$: 'LabelId', a: a};
};
var $author$project$Locations$Labels$LabelId$decode = $author$project$PinMeTo$Common$Util$idDecoder($author$project$Locations$Labels$LabelId$LabelId);
var $author$project$Locations$Labels$Decoders$labelDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'color',
	$elm$json$Json$Decode$nullable($author$project$Locations$Labels$Color$decode),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'folderId',
		$author$project$Locations$Labels$FolderId$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$author$project$Locations$Labels$LabelId$decode,
				$elm$json$Json$Decode$succeed($author$project$Locations$Labels$Decoders$Label)))));
var $author$project$Locations$Labels$Decoders$folderDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'labels',
	$elm$json$Json$Decode$list($author$project$Locations$Labels$Decoders$labelDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Locations$Labels$FolderId$decode,
			$elm$json$Json$Decode$succeed($author$project$Locations$Labels$Decoders$Folder))));
var $author$project$Locations$Labels$Decoders$libraryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'folders',
	$elm$json$Json$Decode$list($author$project$Locations$Labels$Decoders$folderDecoder),
	$elm$json$Json$Decode$succeed($author$project$Locations$Labels$Decoders$Library));
var $author$project$Locations$Labels$Commands$getLibrary = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$Labels$Decoders$libraryDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					$author$project$Locations$Labels$Commands$apiBase(siteName) + '/labels')));
	});
var $author$project$Locations$Labels$Model$init = F2(
	function (session, isLabelsFeatureFlaggedUser) {
		return _Utils_Tuple2(
			$author$project$Locations$Labels$Model$emptyModel(isLabelsFeatureFlaggedUser),
			isLabelsFeatureFlaggedUser ? A2($author$project$Locations$Labels$Commands$getLibrary, session.siteName, $author$project$Locations$Labels$Model$GotLibrary) : $elm$core$Platform$Cmd$none);
	});
var $author$project$Locations$Labels$Main$init = F2(
	function (session, flags) {
		return A2($author$project$Locations$Labels$Model$init, session, flags.isLabelsFeatureFlaggedUser);
	});
var $author$project$Locations$Labels$Model$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Locations$Labels$View$labelsInfoPopOver = $author$project$PinMeTo$Ui$PopOver$view(
	{
		uid: 'labels-page-info',
		tagger: $author$project$Locations$Labels$Model$PopOverMsg,
		content: _List_fromArray(
			[
				$elm$html$Html$text('Labels are shared across your account. Assign them to locations in Listings to filter and report on groups of locations.')
			]),
		preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
	});
var $author$project$Locations$Labels$View$header = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labels-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-page__title-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-headline')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Labels')
							])),
						A2($author$project$PinMeTo$Ui$PopOver$renderPlain, model.popOverState, $author$project$Locations$Labels$View$labelsInfoPopOver)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-page__subtitle pmt-ui-font-note')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create location labels to organize, filter and create reports. Visible to all users in the account.')
					]))
			]));
};
var $author$project$FontAwesome$Regular$Icon$faFolderPlus = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-folder-plus');
var $author$project$Locations$Labels$Model$SearchChanged = function (a) {
	return {$: 'SearchChanged', a: a};
};
var $author$project$Locations$Labels$Model$OpenCreateFolder = {$: 'OpenCreateFolder'};
var $author$project$Locations$Labels$View$toolbar = function (searchQuery) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labels-page__toolbar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-page__toolbar-left')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('labels-page__search')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Form$Input$render(
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
									'Search labels',
									$author$project$PinMeTo$Ui$Form$Input$search(
										{value: searchQuery, onChange: $author$project$Locations$Labels$Model$SearchChanged})))
							]))
					])),
				$author$project$PinMeTo$Ui$Button$render(
				A2(
					$author$project$PinMeTo$Ui$Button$withOnClick,
					$author$project$Locations$Labels$Model$OpenCreateFolder,
					A2(
						$author$project$PinMeTo$Ui$Button$withIconBefore,
						$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faFolderPlus),
						$author$project$PinMeTo$Ui$Button$buttonOutlined('New folder'))))
			]));
};
var $author$project$Locations$Labels$View$foldersFrom = function (model) {
	var _v0 = model.library;
	if (_v0.$ === 'Loaded') {
		var library = _v0.a;
		return library.folders;
	} else {
		return _List_Nil;
	}
};
var $author$project$Locations$Labels$View$labelForm = F6(
	function (model, title, primaryLabel, showDelete, onDelete, state) {
		return {
			name: state.name,
			color: $elm$core$Maybe$Just(state.color),
			title: title,
			saving: model.saving,
			folders: $author$project$Locations$Labels$View$foldersFrom(model),
			folderId: state.folderId,
			onDelete: onDelete,
			showDelete: showDelete,
			errorMessage: model.errorMessage,
			primaryLabel: primaryLabel,
			showFolderSelect: true
		};
	});
var $author$project$Locations$Labels$FolderId$fromString = $author$project$Locations$Labels$FolderId$FolderId;
var $author$project$Locations$Labels$View$folderForm = F6(
	function (model, title, primaryLabel, showDelete, onDelete, name) {
		return {
			name: name,
			color: $elm$core$Maybe$Nothing,
			title: title,
			saving: model.saving,
			folders: _List_Nil,
			folderId: $author$project$Locations$Labels$FolderId$fromString(''),
			onDelete: onDelete,
			showDelete: showDelete,
			errorMessage: model.errorMessage,
			primaryLabel: primaryLabel,
			showFolderSelect: false
		};
	});
var $author$project$Locations$Labels$Model$CloseDialog = {$: 'CloseDialog'};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Locations$Labels$FolderId$toString = function (_v0) {
	var id = _v0.a;
	return id;
};
var $author$project$Locations$Labels$Color$preset = F3(
	function (id, label, hexValue) {
		return {
			id: id,
			hex: $author$project$Locations$Labels$Color$Hex(
				$elm$core$String$toUpper(hexValue)),
			label: label
		};
	});
var $author$project$Locations$Labels$Color$presets = _List_fromArray(
	[
		A3($author$project$Locations$Labels$Color$preset, 'positive', 'Positive', '#3FA650'),
		A3($author$project$Locations$Labels$Color$preset, 'negative', 'Negative', '#DB0037'),
		A3($author$project$Locations$Labels$Color$preset, 'neutral', 'Neutral', '#107DCF'),
		A3($author$project$Locations$Labels$Color$preset, 'mixed', 'Mixed', '#424242'),
		A3($author$project$Locations$Labels$Color$preset, 'new', 'New', '#FF5900')
	]);
var $author$project$Locations$Labels$Color$toString = function (_v0) {
	var value = _v0.a;
	return value;
};
var $author$project$Locations$Labels$View$labelChip = F2(
	function (name, maybeHex) {
		if (maybeHex.$ === 'Just') {
			var hex = maybeHex.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-chip labels-chip--custom'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'style',
						'--label-color: ' + $author$project$Locations$Labels$Color$toString(hex))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-chip__label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]));
		} else {
			return $author$project$PinMeTo$Ui$Chip$render(
				$author$project$PinMeTo$Ui$Chip$view(name));
		}
	});
var $author$project$Locations$Labels$Model$DialogPresetColorSelected = function (a) {
	return {$: 'DialogPresetColorSelected', a: a};
};
var $author$project$Locations$Labels$View$colorSwatch = F2(
	function (selectedHex, preset) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('labels-dialog__swatch'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'labels-dialog__swatch--selected',
							_Utils_eq(
								selectedHex,
								$elm$core$Maybe$Just(preset.hex)))
						])),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					$author$project$Locations$Labels$Color$toString(preset.hex)),
					$elm$html$Html$Attributes$title(
					preset.label + (' (' + ($author$project$Locations$Labels$Color$toString(preset.hex) + ')'))),
					$elm$html$Html$Events$onClick(
					$author$project$Locations$Labels$Model$DialogPresetColorSelected(preset.hex))
				]),
			_List_Nil);
	});
var $author$project$Locations$Labels$Color$parseHex = function (input) {
	var trimmed = $elm$core$String$trim(input);
	return $author$project$Locations$Labels$Color$isValidHex(trimmed) ? $elm$core$Result$Ok(
		$author$project$Locations$Labels$Color$Hex(
			$elm$core$String$toUpper(trimmed))) : $elm$core$Result$Err('Use a hex color like #3FA650, or leave blank.');
};
var $author$project$Locations$Labels$Color$maybeFromInput = function (input) {
	var trimmed = $elm$core$String$trim(input);
	if ($elm$core$String$isEmpty(trimmed)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = $author$project$Locations$Labels$Color$parseHex(trimmed);
		if (_v0.$ === 'Ok') {
			var hex = _v0.a;
			return $elm$core$Maybe$Just(hex);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Locations$Labels$Model$DialogColorChanged = function (a) {
	return {$: 'DialogColorChanged', a: a};
};
var $author$project$Locations$Labels$View$colorField = F2(
	function (name, colorValue) {
		var selectedHex = $author$project$Locations$Labels$Color$maybeFromInput(colorValue);
		var previewName = function () {
			var trimmed = $elm$core$String$trim(name);
			return $elm$core$String$isEmpty(trimmed) ? 'Label' : trimmed;
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('labels-dialog__color')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Color')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('labels-dialog__color-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('labels-dialog__swatches')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Locations$Labels$View$colorSwatch(selectedHex),
								$author$project$Locations$Labels$Color$presets)),
							$author$project$PinMeTo$Ui$Form$Input$render(
							A2(
								$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
								'#3FA650',
								$author$project$PinMeTo$Ui$Form$Input$text(
									{value: colorValue, onChange: $author$project$Locations$Labels$Model$DialogColorChanged}))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('labels-dialog__color-preview')
								]),
							_List_fromArray(
								[
									A2($author$project$Locations$Labels$View$labelChip, previewName, selectedHex),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('labels-dialog__color-hex pmt-ui-font-note')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'No color',
												A2($elm$core$Maybe$map, $author$project$Locations$Labels$Color$toString, selectedHex)))
										]))
								]))
						]))
				]));
	});
var $author$project$Locations$Labels$Model$SubmitDialog = {$: 'SubmitDialog'};
var $author$project$Locations$Labels$View$dialogFooter = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labels-dialog__footer')
			]),
		_List_fromArray(
			[
				config.showDelete ? $author$project$PinMeTo$Ui$Button$render(
				A2(
					$author$project$PinMeTo$Ui$Button$disabledIfTrue,
					config.saving,
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						config.onDelete,
						A2(
							$author$project$PinMeTo$Ui$Button$withGhostStyle,
							$author$project$PinMeTo$Ui$Button$GhostDanger,
							$author$project$PinMeTo$Ui$Button$buttonGhost('Delete'))))) : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-dialog__footer-right')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$disabledIfTrue,
							config.saving,
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								$author$project$Locations$Labels$Model$CloseDialog,
								$author$project$PinMeTo$Ui$Button$buttonGhost('Cancel')))),
						$author$project$PinMeTo$Ui$Button$render(
						A2(
							$author$project$PinMeTo$Ui$Button$disabledIfTrue,
							config.saving,
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								$author$project$Locations$Labels$Model$SubmitDialog,
								$author$project$PinMeTo$Ui$Button$buttonPrimary(config.primaryLabel))))
					]))
			]));
};
var $author$project$Locations$Labels$View$dialogErrorAlert = function (maybeMessage) {
	if (maybeMessage.$ === 'Just') {
		var message = maybeMessage.a;
		return $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Warning,
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Locations$Labels$Model$DialogNameChanged = function (a) {
	return {$: 'DialogNameChanged', a: a};
};
var $author$project$Locations$Labels$Model$DialogFolderChanged = function (a) {
	return {$: 'DialogFolderChanged', a: a};
};
var $author$project$Locations$Labels$View$formLightbox = function (config) {
	return $author$project$PinMeTo$Ui$Lightbox$render(
		$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$Medium,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					$author$project$Locations$Labels$View$dialogFooter(
						{saving: config.saving, onDelete: config.onDelete, showDelete: config.showDelete, primaryLabel: config.primaryLabel}),
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withClose,
						$author$project$Locations$Labels$Model$CloseDialog,
						$author$project$PinMeTo$Ui$Lightbox$view(
							{
								title: config.title,
								content: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('labels-dialog__content')
										]),
									_List_fromArray(
										[
											$author$project$Locations$Labels$View$dialogErrorAlert(config.errorMessage),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('labels-dialog__form')
												]),
											_List_fromArray(
												[
													$author$project$PinMeTo$Ui$Form$Input$render(
													A2(
														$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
														'Name',
														A2(
															$author$project$PinMeTo$Ui$Form$Input$withLabel,
															'Name',
															$author$project$PinMeTo$Ui$Form$Input$text(
																{value: config.name, onChange: $author$project$Locations$Labels$Model$DialogNameChanged})))),
													function () {
													var _v0 = config.color;
													if (_v0.$ === 'Just') {
														var colorValue = _v0.a;
														return A2($author$project$Locations$Labels$View$colorField, config.name, colorValue);
													} else {
														return $elm$html$Html$text('');
													}
												}(),
													config.showFolderSelect ? A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('labels-dialog__folder')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Folder')
																])),
															A2(
															$elm$html$Html$select,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('labels-dialog__select'),
																	$elm$html$Html$Events$onInput(
																	A2($elm$core$Basics$composeR, $author$project$Locations$Labels$FolderId$fromString, $author$project$Locations$Labels$Model$DialogFolderChanged))
																]),
															A2(
																$elm$core$List$map,
																function (folder) {
																	return A2(
																		$elm$html$Html$option,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$value(
																				$author$project$Locations$Labels$FolderId$toString(folder.id)),
																				$elm$html$Html$Attributes$selected(
																				_Utils_eq(config.folderId, folder.id))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(folder.name)
																			]));
																},
																config.folders))
														])) : $elm$html$Html$text('')
												]))
										]))
							}))))));
};
var $author$project$Locations$Labels$Model$OpenDeleteLabel = function (a) {
	return {$: 'OpenDeleteLabel', a: a};
};
var $author$project$Locations$Labels$View$confirmLightbox = function (config) {
	return $author$project$PinMeTo$Ui$Lightbox$render(
		$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					$author$project$Locations$Labels$View$dialogFooter(
						{saving: config.saving, onDelete: $author$project$Locations$Labels$Model$CloseDialog, showDelete: false, primaryLabel: 'Delete'}),
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withClose,
						$author$project$Locations$Labels$Model$CloseDialog,
						$author$project$PinMeTo$Ui$Lightbox$view(
							{
								title: config.title,
								content: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('labels-dialog__content')
										]),
									_List_fromArray(
										[
											$author$project$Locations$Labels$View$dialogErrorAlert(config.errorMessage),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(config.body)
												]))
										]))
							}))))));
};
var $author$project$Locations$Labels$Model$OpenDeleteFolder = function (a) {
	return {$: 'OpenDeleteFolder', a: a};
};
var $author$project$Locations$Labels$View$dialogView = function (model) {
	var _v0 = model.dialog;
	switch (_v0.$) {
		case 'NoDialog':
			return $elm$html$Html$text('');
		case 'DeleteLabel':
			var name = _v0.a.name;
			return $author$project$Locations$Labels$View$confirmLightbox(
				{body: 'Delete \u0022' + (name + '\u0022? It will be removed from all locations.'), title: 'Delete label', saving: model.saving, errorMessage: model.errorMessage});
		case 'DeleteFolder':
			var name = _v0.a.name;
			return $author$project$Locations$Labels$View$confirmLightbox(
				{body: 'Delete folder \u0022' + (name + '\u0022? It must be empty first.'), title: 'Delete folder', saving: model.saving, errorMessage: model.errorMessage});
		case 'CreateLabel':
			var state = _v0.a;
			return $author$project$Locations$Labels$View$formLightbox(
				A6($author$project$Locations$Labels$View$labelForm, model, 'New label', 'Create', false, $author$project$Locations$Labels$Model$CloseDialog, state));
		case 'EditLabel':
			var state = _v0.a;
			return $author$project$Locations$Labels$View$formLightbox(
				A6(
					$author$project$Locations$Labels$View$labelForm,
					model,
					'Edit label',
					'Save',
					true,
					$author$project$Locations$Labels$Model$OpenDeleteLabel(
						{id: state.id, name: state.name}),
					state));
		case 'CreateFolder':
			var name = _v0.a.name;
			return $author$project$Locations$Labels$View$formLightbox(
				A6($author$project$Locations$Labels$View$folderForm, model, 'New folder', 'Create', false, $author$project$Locations$Labels$Model$CloseDialog, name));
		default:
			var state = _v0.a;
			return $author$project$Locations$Labels$View$formLightbox(
				A6(
					$author$project$Locations$Labels$View$folderForm,
					model,
					'Edit folder',
					'Save',
					true,
					$author$project$Locations$Labels$Model$OpenDeleteFolder(
						{id: state.id, name: state.name}),
					state.name));
	}
};
var $author$project$Locations$Labels$Model$NoOp = {$: 'NoOp'};
var $author$project$Locations$Labels$View$editButton = function (onClickMsg) {
	return $author$project$PinMeTo$Ui$Button$render(
		A2(
			$author$project$PinMeTo$Ui$Button$withOnClick,
			onClickMsg,
			A2(
				$author$project$PinMeTo$Ui$Button$withSize,
				$author$project$PinMeTo$Ui$Button$Small,
				A2(
					$author$project$PinMeTo$Ui$Button$withGhostStyle,
					$author$project$PinMeTo$Ui$Button$GhostNeutral,
					$author$project$PinMeTo$Ui$Button$buttonGhost('Edit')))));
};
var $author$project$Locations$Labels$Model$OpenEditLabel = function (a) {
	return {$: 'OpenEditLabel', a: a};
};
var $author$project$Locations$Labels$View$labelRowContent = function (label_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labels-row__inner')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-row__name')
					]),
				_List_fromArray(
					[
						A2($author$project$Locations$Labels$View$labelChip, label_.name, label_.color)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-row__edit'),
						A2(
						$elm$html$Html$Events$stopPropagationOn,
						'click',
						$elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$Locations$Labels$Model$NoOp, true)))
					]),
				_List_fromArray(
					[
						$author$project$Locations$Labels$View$editButton(
						$author$project$Locations$Labels$Model$OpenEditLabel(label_))
					]))
			]));
};
var $author$project$Locations$Labels$View$labelRow = function (label_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labels-row')
			]),
		_List_fromArray(
			[
				$author$project$Locations$Labels$View$labelRowContent(label_)
			]));
};
var $author$project$Locations$Labels$View$sectionBody = F2(
	function (isCollapsed, labels) {
		return isCollapsed ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('labels-section__body')
				]),
			A2($elm$core$List$map, $author$project$Locations$Labels$View$labelRow, labels));
	});
var $author$project$FontAwesome$Light$Icon$faFolder = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-folder');
var $author$project$Locations$Labels$Model$ToggleFolder = function (a) {
	return {$: 'ToggleFolder', a: a};
};
var $author$project$Locations$Labels$View$labelCountText = function (count) {
	return _Utils_ap(
		$elm$core$String$fromInt(count),
		(count === 1) ? ' label' : ' labels');
};
var $author$project$Locations$Labels$View$sectionHeader = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labels-section__header'),
				$elm$html$Html$Events$onClick(
				$author$project$Locations$Labels$Model$ToggleFolder(config.groupId))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-section__chevron'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('labels-section__chevron--collapsed', config.isCollapsed)
							]))
					]),
				_List_fromArray(
					[
						$author$project$FontAwesome$render(
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faChevronDown))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-section__folder-icon')
					]),
				_List_fromArray(
					[
						$author$project$FontAwesome$render(
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faFolder))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-section__title-group')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('labels-section__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.title)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('labels-section__count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Locations$Labels$View$labelCountText(config.labelCount))
							]))
					])),
				config.actions
			]));
};
var $author$project$Locations$Labels$Model$OpenCreateLabel = function (a) {
	return {$: 'OpenCreateLabel', a: a};
};
var $author$project$FontAwesome$Regular$Icon$faTag = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-tag');
var $author$project$Locations$Labels$Model$OpenEditFolder = function (a) {
	return {$: 'OpenEditFolder', a: a};
};
var $author$project$Locations$Labels$View$folderHeaderActions = F2(
	function (folder, onNewLabel) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('labels-section__actions'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'click',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$Locations$Labels$Model$NoOp, true)))
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						onNewLabel,
						A2(
							$author$project$PinMeTo$Ui$Button$withIconBefore,
							$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faTag),
							A2(
								$author$project$PinMeTo$Ui$Button$withSize,
								$author$project$PinMeTo$Ui$Button$Small,
								$author$project$PinMeTo$Ui$Button$buttonGhost('New label'))))),
					$author$project$Locations$Labels$View$editButton(
					$author$project$Locations$Labels$Model$OpenEditFolder(folder))
				]));
	});
var $author$project$Locations$Labels$View$folderSection = F2(
	function (collapsed, folder) {
		var isCollapsed = A2(
			$elm$core$Set$member,
			$author$project$Locations$Labels$FolderId$toString(folder.id),
			collapsed);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('labels-section')
				]),
			_List_fromArray(
				[
					$author$project$Locations$Labels$View$sectionHeader(
					{
						title: folder.name,
						actions: A2(
							$author$project$Locations$Labels$View$folderHeaderActions,
							folder,
							$author$project$Locations$Labels$Model$OpenCreateLabel(folder.id)),
						groupId: folder.id,
						labelCount: $elm$core$List$length(folder.labels),
						isCollapsed: isCollapsed
					}),
					A2($author$project$Locations$Labels$View$sectionBody, isCollapsed, folder.labels)
				]));
	});
var $author$project$Locations$Labels$View$emptySearchHint = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('labels-page__empty')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-font-note')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No labels match your search.')
				]))
		]));
var $author$project$Locations$Labels$View$emptyLibraryHint = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('labels-page__empty')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-font-note')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Create a folder, then add labels inside it.')
				]))
		]));
var $author$project$Locations$Labels$View$libraryView = function (model) {
	var _v0 = model.library;
	switch (_v0.$) {
		case 'Loading':
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-page__loading')
					]),
				_List_fromArray(
					[$author$project$PinMeTo$Ui$Spinner$spinner]));
		case 'Error':
			var message = _v0.a;
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]));
		case 'Loaded':
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labels-page__library')
					]),
				$elm$core$List$isEmpty(model.displayFolders) ? ($elm$core$String$isEmpty(
					$elm$core$String$trim(model.searchQuery)) ? _List_fromArray(
					[$author$project$Locations$Labels$View$emptyLibraryHint]) : _List_fromArray(
					[$author$project$Locations$Labels$View$emptySearchHint])) : A2(
					$elm$core$List$map,
					$author$project$Locations$Labels$View$folderSection(model.collapsedFolderIds),
					model.displayFolders));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Locations$Labels$View$view = F2(
	function (_v0, model) {
		return model.isLabelsFeatureFlaggedUser ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page pmt-page--labels labels-page')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Note,
						$author$project$PinMeTo$Ui$Alert$plain('Internal preview for pilot users. This page is not ready for customers.'))),
					$author$project$Locations$Labels$View$header(model),
					function () {
					var _v1 = _Utils_Tuple2(model.dialog, model.errorMessage);
					if ((_v1.a.$ === 'NoDialog') && (_v1.b.$ === 'Just')) {
						var _v2 = _v1.a;
						var message = _v1.b.a;
						return $author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Warning,
								$author$project$PinMeTo$Ui$Alert$plain(message)));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					$author$project$Locations$Labels$View$toolbar(model.searchQuery),
					$author$project$Locations$Labels$View$libraryView(model),
					$author$project$Locations$Labels$View$dialogView(model)
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page pmt-page--labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Not found')
						]))
				]));
	});
var $author$project$Locations$Labels$Main$view = F2(
	function (session, model) {
		return A2($author$project$Locations$Labels$View$view, session.user, model);
	});
var $author$project$Locations$Labels$Model$EditLabel = function (a) {
	return {$: 'EditLabel', a: a};
};
var $author$project$Locations$Labels$Model$EditFolder = function (a) {
	return {$: 'EditFolder', a: a};
};
var $author$project$Locations$Labels$Update$openDialog = F2(
	function (model, dialog) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dialog: dialog, errorMessage: $elm$core$Maybe$Nothing}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Locations$Labels$Model$CreateLabel = function (a) {
	return {$: 'CreateLabel', a: a};
};
var $author$project$Locations$Labels$Model$DeleteLabel = function (a) {
	return {$: 'DeleteLabel', a: a};
};
var $author$project$Locations$Labels$Model$CreateFolder = function (a) {
	return {$: 'CreateFolder', a: a};
};
var $author$project$Locations$Labels$Model$DeleteFolder = function (a) {
	return {$: 'DeleteFolder', a: a};
};
var $author$project$Locations$Labels$Commands$encodeNullableHex = function (maybeHex) {
	if (maybeHex.$ === 'Just') {
		var hex = maybeHex.a;
		return $elm$json$Json$Encode$string(
			$author$project$Locations$Labels$Color$toString(hex));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Locations$Labels$Commands$createLabel = F3(
	function (siteName, _v0, msg) {
		var color = _v0.color;
		var folderId = _v0.folderId;
		var name = _v0.name;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'folderId',
					$elm$json$Json$Encode$string(
						$author$project$Locations$Labels$FolderId$toString(folderId))),
					_Utils_Tuple2(
					'color',
					$author$project$Locations$Labels$Commands$encodeNullableHex(color))
				]));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$Labels$Decoders$labelDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$post(
						$author$project$Locations$Labels$Commands$apiBase(siteName) + '/labels'))));
	});
var $author$project$Locations$Labels$LabelId$toString = function (_v0) {
	var id = _v0.a;
	return id;
};
var $author$project$Locations$Labels$Commands$deleteLabel = F3(
	function (siteName, labelId, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectWhatever(msg),
				$lukewestby$elm_http_builder$HttpBuilder$delete(
					$author$project$Locations$Labels$Commands$apiBase(siteName) + ('/labels/' + $author$project$Locations$Labels$LabelId$toString(labelId)))));
	});
var $author$project$Locations$Labels$Update$requireName = function (name) {
	var trimmed = $elm$core$String$trim(name);
	return $elm$core$String$isEmpty(trimmed) ? $elm$core$Result$Err('Name is required.') : $elm$core$Result$Ok(trimmed);
};
var $author$project$Locations$Labels$Update$startSaving = F2(
	function (model, cmd) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{saving: true, errorMessage: $elm$core$Maybe$Nothing}),
			cmd);
	});
var $author$project$Locations$Labels$Commands$updateLabel = F4(
	function (siteName, labelId, _v0, msg) {
		var color = _v0.color;
		var folderId = _v0.folderId;
		var name = _v0.name;
		var body = $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (n) {
							return _Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(n));
						},
						name),
						A2(
						$elm$core$Maybe$map,
						function (id) {
							return _Utils_Tuple2(
								'folderId',
								$elm$json$Json$Encode$string(
									$author$project$Locations$Labels$FolderId$toString(id)));
						},
						folderId),
						A2(
						$elm$core$Maybe$map,
						function (maybeHex) {
							return _Utils_Tuple2(
								'color',
								$author$project$Locations$Labels$Commands$encodeNullableHex(maybeHex));
						},
						color)
					])));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$Labels$Decoders$labelDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					body,
					$lukewestby$elm_http_builder$HttpBuilder$patch(
						$author$project$Locations$Labels$Commands$apiBase(siteName) + ('/labels/' + $author$project$Locations$Labels$LabelId$toString(labelId))))));
	});
var $author$project$Locations$Labels$Model$MutationDone = function (a) {
	return {$: 'MutationDone', a: a};
};
var $author$project$Locations$Labels$Commands$createFolder = F3(
	function (siteName, name, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$Labels$Decoders$folderDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post(
						$author$project$Locations$Labels$Commands$apiBase(siteName) + '/label-folders'))));
	});
var $author$project$Locations$Labels$Commands$deleteFolder = F3(
	function (siteName, folderId, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				$elm$http$Http$expectWhatever(msg),
				$lukewestby$elm_http_builder$HttpBuilder$delete(
					$author$project$Locations$Labels$Commands$apiBase(siteName) + ('/label-folders/' + $author$project$Locations$Labels$FolderId$toString(folderId)))));
	});
var $author$project$Locations$Labels$Commands$renameFolder = F4(
	function (siteName, folderId, name, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Locations$Labels$Decoders$folderDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$patch(
						$author$project$Locations$Labels$Commands$apiBase(siteName) + ('/label-folders/' + $author$project$Locations$Labels$FolderId$toString(folderId))))));
	});
var $author$project$Locations$Labels$Update$mutationFailed = F2(
	function (model, message) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					saving: false,
					errorMessage: $elm$core$Maybe$Just(message)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Locations$Labels$Model$FolderDeleteDone = function (a) {
	return {$: 'FolderDeleteDone', a: a};
};
var $author$project$Locations$Labels$Model$LabelMutationDone = function (a) {
	return {$: 'LabelMutationDone', a: a};
};
var $author$project$Locations$Labels$Model$FolderMutationDone = function (a) {
	return {$: 'FolderMutationDone', a: a};
};
var $author$project$Locations$Labels$Update$validateLabelFields = function (_v0) {
	var color = _v0.color;
	var name = _v0.name;
	var trimmedColor = $elm$core$String$trim(color);
	var trimmed = $elm$core$String$trim(name);
	return $elm$core$String$isEmpty(trimmed) ? $elm$core$Result$Err('Name is required.') : ($elm$core$String$isEmpty(trimmedColor) ? $elm$core$Result$Ok(
		{name: trimmed, maybeColor: $elm$core$Maybe$Nothing}) : A2(
		$elm$core$Result$map,
		function (hex) {
			return {
				name: trimmed,
				maybeColor: $elm$core$Maybe$Just(hex)
			};
		},
		$author$project$Locations$Labels$Color$parseHex(trimmedColor)));
};
var $author$project$Locations$Labels$Update$submitDialog = F2(
	function (session, model) {
		var _v0 = model.dialog;
		switch (_v0.$) {
			case 'CreateLabel':
				var color = _v0.a.color;
				var folderId = _v0.a.folderId;
				var name = _v0.a.name;
				var _v1 = $author$project$Locations$Labels$Update$validateLabelFields(
					{name: name, color: color});
				if (_v1.$ === 'Err') {
					var message = _v1.a;
					return A2($author$project$Locations$Labels$Update$mutationFailed, model, message);
				} else {
					var fields = _v1.a;
					return A2(
						$author$project$Locations$Labels$Update$startSaving,
						model,
						A3(
							$author$project$Locations$Labels$Commands$createLabel,
							session.siteName,
							{name: fields.name, color: fields.maybeColor, folderId: folderId},
							$author$project$Locations$Labels$Model$LabelMutationDone));
				}
			case 'EditLabel':
				var color = _v0.a.color;
				var folderId = _v0.a.folderId;
				var name = _v0.a.name;
				var id = _v0.a.id;
				var _v2 = $author$project$Locations$Labels$Update$validateLabelFields(
					{name: name, color: color});
				if (_v2.$ === 'Err') {
					var message = _v2.a;
					return A2($author$project$Locations$Labels$Update$mutationFailed, model, message);
				} else {
					var fields = _v2.a;
					return A2(
						$author$project$Locations$Labels$Update$startSaving,
						model,
						A4(
							$author$project$Locations$Labels$Commands$updateLabel,
							session.siteName,
							id,
							{
								name: $elm$core$Maybe$Just(fields.name),
								color: $elm$core$Maybe$Just(fields.maybeColor),
								folderId: $elm$core$Maybe$Just(folderId)
							},
							$author$project$Locations$Labels$Model$LabelMutationDone));
				}
			case 'DeleteLabel':
				var id = _v0.a.id;
				return A2(
					$author$project$Locations$Labels$Update$startSaving,
					model,
					A3($author$project$Locations$Labels$Commands$deleteLabel, session.siteName, id, $author$project$Locations$Labels$Model$MutationDone));
			case 'CreateFolder':
				var name = _v0.a.name;
				var _v3 = $author$project$Locations$Labels$Update$requireName(name);
				if (_v3.$ === 'Err') {
					var message = _v3.a;
					return A2($author$project$Locations$Labels$Update$mutationFailed, model, message);
				} else {
					var trimmed = _v3.a;
					return A2(
						$author$project$Locations$Labels$Update$startSaving,
						model,
						A3($author$project$Locations$Labels$Commands$createFolder, session.siteName, trimmed, $author$project$Locations$Labels$Model$FolderMutationDone));
				}
			case 'EditFolder':
				var name = _v0.a.name;
				var id = _v0.a.id;
				var _v4 = $author$project$Locations$Labels$Update$requireName(name);
				if (_v4.$ === 'Err') {
					var message = _v4.a;
					return A2($author$project$Locations$Labels$Update$mutationFailed, model, message);
				} else {
					var trimmed = _v4.a;
					return A2(
						$author$project$Locations$Labels$Update$startSaving,
						model,
						A4($author$project$Locations$Labels$Commands$renameFolder, session.siteName, id, trimmed, $author$project$Locations$Labels$Model$FolderMutationDone));
				}
			case 'DeleteFolder':
				var id = _v0.a.id;
				return A2(
					$author$project$Locations$Labels$Update$startSaving,
					model,
					A3($author$project$Locations$Labels$Commands$deleteFolder, session.siteName, id, $author$project$Locations$Labels$Model$FolderDeleteDone));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Locations$Labels$Update$filterLibrary = F2(
	function (query, library) {
		var q = $elm$core$String$toLower(
			$elm$core$String$trim(query));
		var matchesLabel = function (label) {
			return (q === '') || A2(
				$elm$core$String$contains,
				q,
				$elm$core$String$toLower(label.name));
		};
		var filterFolder = function (folder) {
			if (q === '') {
				return $elm$core$Maybe$Just(folder);
			} else {
				if (A2(
					$elm$core$String$contains,
					q,
					$elm$core$String$toLower(folder.name))) {
					return $elm$core$Maybe$Just(folder);
				} else {
					var labels = A2($elm$core$List$filter, matchesLabel, folder.labels);
					return $elm$core$List$isEmpty(labels) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						_Utils_update(
							folder,
							{labels: labels}));
				}
			}
		};
		return {
			folders: A2($elm$core$List$filterMap, filterFolder, library.folders)
		};
	});
var $author$project$Locations$Labels$Update$displayFolders = F2(
	function (query, library) {
		if (library.$ === 'Loaded') {
			var loadedLibrary = library.a;
			return A2($author$project$Locations$Labels$Update$filterLibrary, query, loadedLibrary).folders;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Locations$Labels$Update$mutationResult = F4(
	function (session, model, result, errorMessage) {
		if (result.$ === 'Ok') {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{dialog: $author$project$Locations$Labels$Model$NoDialog, saving: false, library: $author$project$RemoteData$Loading, displayFolders: _List_Nil}),
				A2($author$project$Locations$Labels$Commands$getLibrary, session.siteName, $author$project$Locations$Labels$Model$GotLibrary));
		} else {
			return A2($author$project$Locations$Labels$Update$mutationFailed, model, errorMessage);
		}
	});
var $author$project$Locations$Labels$Update$updateDialogName = F2(
	function (name, dialog) {
		switch (dialog.$) {
			case 'CreateLabel':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$CreateLabel(
					_Utils_update(
						state,
						{name: name}));
			case 'EditLabel':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$EditLabel(
					_Utils_update(
						state,
						{name: name}));
			case 'CreateFolder':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$CreateFolder(
					_Utils_update(
						state,
						{name: name}));
			case 'EditFolder':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$EditFolder(
					_Utils_update(
						state,
						{name: name}));
			default:
				return dialog;
		}
	});
var $author$project$Locations$Labels$Update$updateDialogColor = F2(
	function (color, dialog) {
		switch (dialog.$) {
			case 'CreateLabel':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$CreateLabel(
					_Utils_update(
						state,
						{color: color}));
			case 'EditLabel':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$EditLabel(
					_Utils_update(
						state,
						{color: color}));
			default:
				return dialog;
		}
	});
var $author$project$Locations$Labels$Update$updateDialogFolderId = F2(
	function (folderId, dialog) {
		switch (dialog.$) {
			case 'CreateLabel':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$CreateLabel(
					_Utils_update(
						state,
						{folderId: folderId}));
			case 'EditLabel':
				var state = dialog.a;
				return $author$project$Locations$Labels$Model$EditLabel(
					_Utils_update(
						state,
						{folderId: folderId}));
			default:
				return dialog;
		}
	});
var $author$project$Locations$Labels$Update$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'PopOverMsg':
				var subMsg = msg.a;
				var _v1 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Locations$Labels$Model$PopOverMsg, subMsg, model.popOverState);
				var popOverState = _v1.a;
				var popOverCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: popOverState}),
					popOverCmd);
			case 'GotLibrary':
				if (msg.a.$ === 'Ok') {
					var library = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								saving: false,
								library: $author$project$RemoteData$Loaded(library),
								errorMessage: $elm$core$Maybe$Nothing,
								displayFolders: A2(
									$author$project$Locations$Labels$Update$displayFolders,
									model.searchQuery,
									$author$project$RemoteData$Loaded(library))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								library: $author$project$RemoteData$Error('Could not load labels.'),
								errorMessage: $elm$core$Maybe$Just('Could not load labels.'),
								displayFolders: _List_Nil
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'SearchChanged':
				var query = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							searchQuery: query,
							displayFolders: A2($author$project$Locations$Labels$Update$displayFolders, query, model.library)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleFolder':
				var folderId = msg.a;
				var folderIdString = $author$project$Locations$Labels$FolderId$toString(folderId);
				var collapsedFolderIds = A2($elm$core$Set$member, folderIdString, model.collapsedFolderIds) ? A2($elm$core$Set$remove, folderIdString, model.collapsedFolderIds) : A2($elm$core$Set$insert, folderIdString, model.collapsedFolderIds);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{collapsedFolderIds: collapsedFolderIds}),
					$elm$core$Platform$Cmd$none);
			case 'OpenCreateLabel':
				var folderId = msg.a;
				return A2(
					$author$project$Locations$Labels$Update$openDialog,
					model,
					$author$project$Locations$Labels$Model$CreateLabel(
						{name: '', color: '', folderId: folderId}));
			case 'OpenCreateFolder':
				return A2(
					$author$project$Locations$Labels$Update$openDialog,
					model,
					$author$project$Locations$Labels$Model$CreateFolder(
						{name: ''}));
			case 'OpenEditLabel':
				var label = msg.a;
				return A2(
					$author$project$Locations$Labels$Update$openDialog,
					model,
					$author$project$Locations$Labels$Model$EditLabel(
						{
							id: label.id,
							name: label.name,
							color: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Locations$Labels$Color$toString, label.color)),
							folderId: label.folderId
						}));
			case 'OpenEditFolder':
				var folder = msg.a;
				return A2(
					$author$project$Locations$Labels$Update$openDialog,
					model,
					$author$project$Locations$Labels$Model$EditFolder(
						{id: folder.id, name: folder.name}));
			case 'OpenDeleteLabel':
				var name = msg.a.name;
				var id = msg.a.id;
				return A2(
					$author$project$Locations$Labels$Update$openDialog,
					model,
					$author$project$Locations$Labels$Model$DeleteLabel(
						{id: id, name: name}));
			case 'OpenDeleteFolder':
				var name = msg.a.name;
				var id = msg.a.id;
				return A2(
					$author$project$Locations$Labels$Update$openDialog,
					model,
					$author$project$Locations$Labels$Model$DeleteFolder(
						{id: id, name: name}));
			case 'CloseDialog':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dialog: $author$project$Locations$Labels$Model$NoDialog, saving: false}),
					$elm$core$Platform$Cmd$none);
			case 'DialogNameChanged':
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dialog: A2($author$project$Locations$Labels$Update$updateDialogName, name, model.dialog)
						}),
					$elm$core$Platform$Cmd$none);
			case 'DialogFolderChanged':
				var folderId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dialog: A2($author$project$Locations$Labels$Update$updateDialogFolderId, folderId, model.dialog)
						}),
					$elm$core$Platform$Cmd$none);
			case 'DialogColorChanged':
				var color = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dialog: A2($author$project$Locations$Labels$Update$updateDialogColor, color, model.dialog)
						}),
					$elm$core$Platform$Cmd$none);
			case 'DialogPresetColorSelected':
				var hex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dialog: A2(
								$author$project$Locations$Labels$Update$updateDialogColor,
								$author$project$Locations$Labels$Color$toString(hex),
								model.dialog),
							errorMessage: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 'SubmitDialog':
				return A2($author$project$Locations$Labels$Update$submitDialog, session, model);
			case 'MutationDone':
				var result = msg.a;
				return A4($author$project$Locations$Labels$Update$mutationResult, session, model, result, 'Something went wrong. Please try again.');
			case 'FolderDeleteDone':
				var result = msg.a;
				return A4($author$project$Locations$Labels$Update$mutationResult, session, model, result, 'Could not delete folder. It must be empty first.');
			case 'LabelMutationDone':
				var result = msg.a;
				return A4($author$project$Locations$Labels$Update$mutationResult, session, model, result, 'Could not save label. Name may already exist.');
			default:
				var result = msg.a;
				return A4($author$project$Locations$Labels$Update$mutationResult, session, model, result, 'Could not save folder. Name may already exist or the folder still contains labels.');
		}
	});
var $author$project$Locations$Labels$Main$Flags = function (isLabelsFeatureFlaggedUser) {
	return {isLabelsFeatureFlaggedUser: isLabelsFeatureFlaggedUser};
};
var $author$project$Locations$Labels$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isLabelsFeatureFlaggedUser',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Locations$Labels$Main$Flags));
var $author$project$Locations$Labels$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Locations$Labels$Main$init,
		view: $author$project$Locations$Labels$Main$view,
		update: $author$project$Locations$Labels$Update$update,
		flagsDecoder: $author$project$Locations$Labels$Main$flagsDecoder,
		subscriptions: function (model) {
			return A2($author$project$PinMeTo$Ui$PopOver$subscriptions, model.popOverState, $author$project$Locations$Labels$Model$PopOverMsg);
		}
	});
var $author$project$BrandPageSelectorPort$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$BrandPageSelectorPort$Running = function (a) {
	return {$: 'Running', a: a};
};
var $author$project$BrandPageSelectorPort$Flags = F6(
	function (siteName, realm, network, selected, translations, language) {
		return {realm: realm, network: network, language: language, selected: selected, siteName: siteName, translations: translations};
	});
var $author$project$PinMeTo$Api$SelectorApi$Listen = {$: 'Listen'};
var $author$project$PinMeTo$Api$SelectorApi$SocialMedia = {$: 'SocialMedia'};
var $author$project$PinMeTo$Api$SelectorApi$AccessManager = {$: 'AccessManager'};
var $author$project$PinMeTo$Api$SelectorApi$realmFromString = function (x) {
	var _v0 = $elm$core$String$toLower(x);
	switch (_v0) {
		case 'places':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Api$SelectorApi$Places);
		case 'socialmedia':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Api$SelectorApi$SocialMedia);
		case 'listenrespond':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Api$SelectorApi$Listen);
		case 'accessmanager':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Api$SelectorApi$AccessManager);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Api$SelectorApi$realmDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		var _v0 = $author$project$PinMeTo$Api$SelectorApi$realmFromString(x);
		if (_v0.$ === 'Just') {
			var realm = _v0.a;
			return $elm$json$Json$Decode$succeed(realm);
		} else {
			return $elm$json$Json$Decode$fail('Invalid realm: ' + x);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Api$SelectorApi$Google = {$: 'Google'};
var $author$project$PinMeTo$Api$SelectorApi$Facebook = {$: 'Facebook'};
var $author$project$PinMeTo$Api$SelectorApi$LinkedIn = {$: 'LinkedIn'};
var $author$project$PinMeTo$Api$SelectorApi$Instagram = {$: 'Instagram'};
var $author$project$PinMeTo$Api$SelectorApi$networkFromString = function (x) {
	switch (x) {
		case 'google':
			return $author$project$PinMeTo$Api$SelectorApi$Google;
		case 'facebook':
			return $author$project$PinMeTo$Api$SelectorApi$Facebook;
		case 'instagram':
			return $author$project$PinMeTo$Api$SelectorApi$Instagram;
		case 'linkedin':
			return $author$project$PinMeTo$Api$SelectorApi$LinkedIn;
		default:
			return $author$project$PinMeTo$Api$SelectorApi$All;
	}
};
var $author$project$PinMeTo$Api$SelectorApi$networkDecoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Api$SelectorApi$networkFromString, $elm$json$Json$Decode$string);
var $author$project$BrandPageSelectorPort$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'selected',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'network',
				$author$project$PinMeTo$Api$SelectorApi$networkDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'realm',
					$author$project$PinMeTo$Api$SelectorApi$realmDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'siteName',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$BrandPageSelectorPort$Flags)))))));
var $author$project$BrandPageSelectorPort$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$BrandPageSelectorPort$flagsDecoder, flagsValue);
};
var $author$project$BrandPageSelectorPort$init = function (flagsValue) {
	var _v0 = $author$project$BrandPageSelectorPort$decodeFlags(flagsValue);
	if (_v0.$ === 'Ok') {
		var flags = _v0.a;
		return _Utils_Tuple2(
			$author$project$BrandPageSelectorPort$Running(
				{realm: flags.realm, network: flags.network, language: flags.language, selected: flags.selected, selector: $author$project$PinMeTo$Ui$SelectorBrandPage$init, siteName: flags.siteName, translations: flags.translations}),
			$elm$core$Platform$Cmd$none);
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$author$project$BrandPageSelectorPort$Error('Brand Page selector failed. Error has been logged.'),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'BrandPageSelectorPort',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$BrandPageSelectorPort$RunningMsg = function (a) {
	return {$: 'RunningMsg', a: a};
};
var $author$project$BrandPageSelectorPort$UiSelectorMsg = function (a) {
	return {$: 'UiSelectorMsg', a: a};
};
var $author$project$BrandPageSelectorPort$view = function (state) {
	if (state.$ === 'Running') {
		var model = state.a;
		return A2(
			$author$project$PinMeTo$Ui$SelectorBrandPage$render,
			model.selector,
			A2(
				$author$project$PinMeTo$Ui$SelectorBrandPage$withSelected,
				model.selected,
				$author$project$PinMeTo$Ui$SelectorBrandPage$view(
					{
						labels: A2($author$project$Filter$FilterLabels$selectorBrandPageLabels, model.translations, model.language),
						locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
						tagger: A2($elm$core$Basics$composeR, $author$project$BrandPageSelectorPort$UiSelectorMsg, $author$project$BrandPageSelectorPort$RunningMsg)
					})));
	} else {
		var error = state.a;
		return $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Error,
				$author$project$PinMeTo$Ui$Alert$plain(error)));
	}
};
var $author$project$BrandPageSelectorPort$OnSelect = function (a) {
	return {$: 'OnSelect', a: a};
};
var $author$project$BrandPageSelectorPort$out_BrandPageSelectorPort_BrandPagesSelected = _Platform_outgoingPort(
	'out_BrandPageSelectorPort_BrandPagesSelected',
	$elm$json$Json$Encode$list($elm$json$Json$Encode$string));
var $author$project$BrandPageSelectorPort$updateModel = F2(
	function (msg, model) {
		if (msg.$ === 'UiSelectorMsg') {
			var msg_ = msg.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$BrandPageSelectorPort$RunningMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					function (selector) {
						return _Utils_update(
							model,
							{selector: selector});
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorBrandPage$update,
						{
							tagger: $author$project$BrandPageSelectorPort$UiSelectorMsg,
							onChange: $author$project$BrandPageSelectorPort$OnSelect,
							getAllItems: $author$project$PinMeTo$Api$SelectorApi$getBrandPages(
								{realm: model.realm, network: model.network, siteName: model.siteName})
						},
						msg_,
						model.selector)));
		} else {
			var selected = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{selected: selected}),
				$author$project$BrandPageSelectorPort$out_BrandPageSelectorPort_BrandPagesSelected(selected));
		}
	});
var $author$project$BrandPageSelectorPort$update = F2(
	function (msg, model) {
		if (msg.$ === 'HandleFlags') {
			var flagsValue = msg.a;
			return $author$project$BrandPageSelectorPort$init(flagsValue);
		} else {
			var msg_ = msg.a;
			if (model.$ === 'Running') {
				var model_ = model.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$BrandPageSelectorPort$Running,
					A2($author$project$BrandPageSelectorPort$updateModel, msg_, model_));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$BrandPageSelectorPort$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$BrandPageSelectorPort$passArgs_BrandPageSelectorPort = _Platform_incomingPort('passArgs_BrandPageSelectorPort', $elm$json$Json$Decode$value);
var $author$project$BrandPageSelectorPort$main = $elm$browser$Browser$element(
	{
		init: $author$project$BrandPageSelectorPort$init,
		view: $author$project$BrandPageSelectorPort$view,
		update: $author$project$BrandPageSelectorPort$update,
		subscriptions: $elm$core$Basics$always(
			$author$project$BrandPageSelectorPort$passArgs_BrandPageSelectorPort($author$project$BrandPageSelectorPort$HandleFlags))
	});
var $author$project$Tasks$PTV$Claim$Commands$posixDecoder = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		return $elm$time$Time$millisToPosix(x);
	},
	$elm$json$Json$Decode$int);
var $author$project$Tasks$PTV$Claim$Model$ListingLocation = function (id) {
	return function (storeId) {
		return function (name) {
			return function (address) {
				return function (location) {
					return function (locationDescriptor) {
						return function (locationType) {
							return function (isActive) {
								return function (permanentlyClosed) {
									return function (ptvCustomName) {
										return {id: id, name: name, address: address, storeId: storeId, isActive: isActive, location: location, locationType: locationType, ptvCustomName: ptvCustomName, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Tasks$PTV$Claim$Commands$locationDataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'networkCustomName',
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['ptv']),
			$elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'permanentlyClosed',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'isActive',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$author$project$Data$Location$locationTypeDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationDescriptor',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'location',
						$author$project$Data$Coordinates$coordinatesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'address',
							$author$project$Data$Address$addressDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'storeId',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'_id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$ListingLocation)))))))))));
var $author$project$Tasks$PTV$Claim$Model$Done = {$: 'Done'};
var $author$project$Tasks$PTV$Claim$Model$ClaimError = {$: 'ClaimError'};
var $author$project$Tasks$PTV$Claim$Model$InProgress = {$: 'InProgress'};
var $author$project$Tasks$PTV$Claim$Model$ReadyToCreate = {$: 'ReadyToCreate'};
var $author$project$Tasks$PTV$Claim$Commands$locationStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'readyToCreate':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$ReadyToCreate);
			case 'inProgress':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$InProgress);
			case 'done':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$Done);
			case 'error':
				return $elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$ClaimError);
			default:
				return $elm$json$Json$Decode$fail('Unknown LocationState: ' + state);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Tasks$PTV$Claim$Model$LocationToCreateOnPtv = F4(
	function (errors, lastClaimAttempt, location, state) {
		return {state: state, errors: errors, location: location, lastClaimAttempt: lastClaimAttempt};
	});
var $author$project$Tasks$PTV$Claim$Commands$locationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'state',
	$author$project$Tasks$PTV$Claim$Commands$locationStateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'location',
		$author$project$Tasks$PTV$Claim$Commands$locationDataDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'lastClaimAttempt',
			$elm$json$Json$Decode$maybe($author$project$Tasks$PTV$Claim$Commands$posixDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'errors',
				$elm$json$Json$Decode$maybe(
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
				$elm$core$Maybe$Just(_List_Nil),
				$elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$LocationToCreateOnPtv)))));
var $author$project$Tasks$PTV$Claim$Model$LocationResponse = F2(
	function (unmatchedListings, unmatchedPTV) {
		return {unmatchedPTV: unmatchedPTV, unmatchedListings: unmatchedListings};
	});
var $author$project$Tasks$PTV$Claim$Model$LocationToCreateInPinmeto = F4(
	function (id, name, address, location) {
		return {id: id, name: name, address: address, location: location};
	});
var $author$project$Tasks$PTV$Claim$Commands$ptvLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$author$project$Data$Coordinates$coordinatesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'address',
		$author$project$Data$Address$addressDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$LocationToCreateInPinmeto)))));
var $author$project$Tasks$PTV$Claim$Commands$createLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unmatchedPTV',
	$elm$json$Json$Decode$list($author$project$Tasks$PTV$Claim$Commands$ptvLocationDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'unmatchedListings',
		$elm$json$Json$Decode$list($author$project$Tasks$PTV$Claim$Commands$locationDecoder),
		$elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$LocationResponse)));
var $author$project$Tasks$PTV$Claim$Commands$getNotMatched = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Tasks$PTV$Claim$Commands$createLocationDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/ptv/claim/unmatched')))));
	});
var $author$project$Tasks$PTV$Claim$Model$GetLastFetchedAt = function (a) {
	return {$: 'GetLastFetchedAt', a: a};
};
var $author$project$Tasks$PTV$Claim$Commands$getLastFetchedAt = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$maybe($author$project$Tasks$PTV$Claim$Commands$posixDecoder),
					$elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/ptv/claim/lastFetchedAt')))));
	});
var $author$project$Tasks$PTV$Claim$Model$LocationsResponse = function (a) {
	return {$: 'LocationsResponse', a: a};
};
var $author$project$Tasks$PTV$Claim$Model$OneWay = {$: 'OneWay'};
var $author$project$Tasks$PTV$Claim$Model$TwoWay = {$: 'TwoWay'};
var $author$project$Tasks$PTV$Claim$Commands$connectionTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (isTwoWay) {
		return isTwoWay ? $elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$TwoWay) : $elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Claim$Model$OneWay);
	},
	A2($elm$json$Json$Decode$field, 'isTwoWay', $elm$json$Json$Decode$bool));
var $author$project$Tasks$PTV$Claim$Commands$getConnectionType = F2(
	function (_v0, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$PTV$Claim$Commands$connectionTypeDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (accountName + '/ptv/claim/getConnectionType')))));
	});
var $author$project$Tasks$PTV$Claim$Model$GetConnectionTypeResponse = function (a) {
	return {$: 'GetConnectionTypeResponse', a: a};
};
var $author$project$Tasks$PTV$Claim$Main$init = F2(
	function (session, _v0) {
		return _Utils_Tuple2(
			{filter: '', uiSelect: $author$project$PinMeTo$Ui$Select$init, uiPopover: $author$project$PinMeTo$Ui$PopOver$init, canProceed: false, lastFetchedAt: $author$project$RemoteData$Loading, connectionType: $author$project$RemoteData$Loading, lightboxVisible: false, selectedPMTLocation: $elm$core$Maybe$Nothing, syncLightboxVisible: false, createLoadingVisible: false, matchLocationPMTTable: $author$project$PinMeTo$Ui$Table$init, unmatchedPTVLocations: $author$project$RemoteData$Loading, createLocationPMTTable: $author$project$PinMeTo$Ui$Table$init, selectedNetworkLocation: $elm$core$Maybe$Nothing, matchLocationNetworkTable: $author$project$PinMeTo$Ui$Table$init, createLocationNetworkTable: $author$project$PinMeTo$Ui$Table$init, matchLocationsNotification: $elm$core$Maybe$Nothing, unmatchedListingsLocations: $author$project$RemoteData$Loading, createLocationsNotification: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tasks$PTV$Claim$Commands$getNotMatched, session.siteName, $author$project$Tasks$PTV$Claim$Model$LocationsResponse),
						A2($author$project$Tasks$PTV$Claim$Commands$getLastFetchedAt, session.siteName, $author$project$Tasks$PTV$Claim$Model$GetLastFetchedAt),
						A2($author$project$Tasks$PTV$Claim$Commands$getConnectionType, session.siteName, $author$project$Tasks$PTV$Claim$Model$GetConnectionTypeResponse)
					])));
	});
var $author$project$Translations$Listings$Claim$claimPtvLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_ptv_locations');
};
var $author$project$Tasks$PTV$Claim$View$renderClaimTitle = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-claim-page__icon')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTV)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-ui-font-headline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$Claim$claimPtvLocations(translations))
					]))
			]));
};
var $author$project$Tasks$PTV$Claim$Model$SyncLocations = {$: 'SyncLocations'};
var $author$project$FontAwesome$Regular$Icon$faArrowsRotate = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-arrows-rotate');
var $author$project$Tasks$PTV$Claim$Components$SyncButton$renderSyncButton = function (translations) {
	return $author$project$PinMeTo$Ui$Button$render(
		A2(
			$author$project$PinMeTo$Ui$Button$withOnClick,
			$author$project$Tasks$PTV$Claim$Model$SyncLocations,
			A2(
				$author$project$PinMeTo$Ui$Button$withIconBefore,
				$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faArrowsRotate),
				$author$project$PinMeTo$Ui$Button$buttonPrimary(
					$author$project$Translations$Listings$Claim$syncLocations(translations)))));
};
var $author$project$Tasks$PTV$Claim$Model$ExportDescriptions = {$: 'ExportDescriptions'};
var $author$project$Tasks$PTV$Claim$View$renderExportButton = $author$project$PinMeTo$Ui$Button$render(
	A2(
		$author$project$PinMeTo$Ui$Button$withOnClick,
		$author$project$Tasks$PTV$Claim$Model$ExportDescriptions,
		$author$project$PinMeTo$Ui$Button$buttonSecondary('Export Descriptions')));
var $author$project$Tasks$PTV$Claim$Components$LastSyncDate$renderLastSyncDate = F2(
	function (session, model) {
		var dateAndTime = function () {
			var _v0 = model.lastFetchedAt;
			switch (_v0.$) {
				case 'Loaded':
					if (_v0.a.$ === 'Just') {
						var posix = _v0.a.a;
						return $author$project$PinMeTo$Ui$Date$render(
							A2($author$project$PinMeTo$Ui$Date$posix, session.locale, posix));
					} else {
						var _v1 = _v0.a;
						return $elm$html$Html$text(
							$author$project$Translations$Listings$Claim$syncLocationsNeverRun(session.translations));
					}
				case 'Loading':
					return $elm$html$Html$text('loading...');
				default:
					return $elm$html$Html$text(
						$author$project$Translations$Listings$Claim$syncLocationsNeverRun(session.translations));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__sync-locations_section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__sync-locations__container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('network-claim-page__sync-locations__last-sync'),
									$elm$html$Html$Attributes$class('pmt-ui-font-caption')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Last fetched:')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-note-1')
								]),
							_List_fromArray(
								[dateAndTime]))
						]))
				]));
	});
var $author$project$Tasks$PTV$Claim$View$renderHeader = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__inner-container')
				]),
			_List_fromArray(
				[
					$author$project$Tasks$PTV$Claim$View$renderClaimTitle(session.translations),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__sync-locations_section')
						]),
					_List_fromArray(
						[
							A2($author$project$Tasks$PTV$Claim$Components$LastSyncDate$renderLastSyncDate, session, model),
							$author$project$Tasks$PTV$Claim$Components$SyncButton$renderSyncButton(session.translations),
							$author$project$Tasks$PTV$Claim$View$renderExportButton
						]))
				]));
	});
var $author$project$Tasks$PTV$Claim$Model$ToggleLightbox = {$: 'ToggleLightbox'};
var $author$project$Tasks$PTV$Claim$Model$GoToNextSection = {$: 'GoToNextSection'};
var $author$project$Tasks$PTV$Claim$Components$ConfirmLighbox$renderLightbox = function (shouldRender) {
	return shouldRender ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Lightbox$render(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withStyle,
					$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withFooter,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-btn-group'),
									A2($elm$html$Html$Attributes$style, 'margin-bottom', '0em'),
									A2($elm$html$Html$Attributes$style, 'margin-right', '0em')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										$author$project$Tasks$PTV$Claim$Model$ToggleLightbox,
										A2(
											$author$project$PinMeTo$Ui$Button$withGhostStyle,
											$author$project$PinMeTo$Ui$Button$GhostDanger,
											$author$project$PinMeTo$Ui$Button$buttonGhost('Cancel')))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'width', '1em')
										]),
									_List_Nil),
									$author$project$PinMeTo$Ui$Button$render(
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										$author$project$Tasks$PTV$Claim$Model$GoToNextSection,
										$author$project$PinMeTo$Ui$Button$buttonPrimary('Proceed')))
								])),
						$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
							$author$project$PinMeTo$Ui$Lightbox$view(
								{
									title: 'Confirm',
									content: A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'text-align', 'center')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Make sure you have connected all possible matches before creating locations!')
											]))
								})))))
			])) : $elm$html$Html$text('');
};
var $author$project$Tasks$PTV$Claim$Model$ToggleSyncLightbox = {$: 'ToggleSyncLightbox'};
var $author$project$Tasks$PTV$Claim$Components$SyncLocationsInfoLightbox$renderSyncLightbox = function (shouldRender) {
	return shouldRender ? $author$project$PinMeTo$Ui$Lightbox$render(
		A2(
			$author$project$PinMeTo$Ui$Lightbox$withStyle,
			$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
			$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withFooter,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-btn-group'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '0em'),
								A2($elm$html$Html$Attributes$style, 'margin-right', '0em')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$Tasks$PTV$Claim$Model$ToggleSyncLightbox,
									A2(
										$author$project$PinMeTo$Ui$Button$withPrimaryStyle,
										$author$project$PinMeTo$Ui$Button$PrimaryDefault,
										$author$project$PinMeTo$Ui$Button$buttonPrimary('Ok'))))
							])),
					$author$project$PinMeTo$Ui$Lightbox$view(
						{
							title: 'Location synchronization queued',
							content: A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'text-align', 'center')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Location synchronization has been queued. Please allow a few minutes for the process to complete.')
									]))
						}))))) : $elm$html$Html$text('');
};
var $author$project$Tasks$PTV$Claim$Components$CreateLightbox$renderCreateLoading = function (shouldRender) {
	return shouldRender ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Lightbox$render(
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withStyle,
					$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
					$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
						$author$project$PinMeTo$Ui$Lightbox$view(
							{
								title: 'Locations are being created...',
								content: A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'text-align', 'center')
										]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Spinner$spinner,
											$elm$html$Html$text('Your location(s) are being created...')
										]))
							}))))
			])) : $elm$html$Html$text('');
};
var $author$project$Tasks$PTV$Claim$View$lineSeparator = A2(
	$elm$html$Html$hr,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__line-separator')
		]),
	_List_Nil);
var $author$project$Tasks$PTV$Claim$View$sectionBreak = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('network-claim-page__section-break')
		]),
	_List_fromArray(
		[$author$project$Tasks$PTV$Claim$View$lineSeparator]));
var $author$project$Translations$Listings$Claim$claimPtvNotAvailable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.claim_ptv_not_available');
};
var $author$project$Tasks$PTV$Claim$View$renderOneWaySection = F2(
	function (session, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('network-claim-page__disabled', false)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Tasks$PTV$Claim$View$sectionBreak,
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$claimPtvNotAvailable(session.translations))
				]));
	});
var $author$project$Tasks$PTV$Claim$Sections$Shared$renderAlert = function (notification) {
	if (notification.$ === 'Just') {
		var message = notification.a.message;
		var state = notification.a.state;
		return $author$project$PinMeTo$Ui$Alert$render(
			function () {
				switch (state.$) {
					case 'Success':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Success);
					case 'Failed':
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Error);
					default:
						return $author$project$PinMeTo$Ui$Alert$withStatus($author$project$PinMeTo$Ui$Alert$Warning);
				}
			}()(
				$author$project$PinMeTo$Ui$Alert$plain(message)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Translations$Listings$Claim$ptvLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.ptv_locations');
};
var $author$project$Tasks$PTV$Claim$Model$UiPopoverMsg = function (a) {
	return {$: 'UiPopoverMsg', a: a};
};
var $author$project$Translations$Listings$Claim$PTV$connectLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.PTV.connectLocations');
};
var $author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderHeader_ = F2(
	function (uiPopoverState, translations) {
		var popOverConfig = {
			uid: 'match-locations-popover',
			tagger: $author$project$Tasks$PTV$Claim$Model$UiPopoverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$PTV$connectLocations(translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$connectLocations(translations),
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Tasks$PTV$Claim$Model$ConnectLocations = F2(
	function (a, b) {
		return {$: 'ConnectLocations', a: a, b: b};
	});
var $author$project$Tasks$PTV$Claim$Model$MatchLocationPMTTable = function (a) {
	return {$: 'MatchLocationPMTTable', a: a};
};
var $author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderPMTTable = F5(
	function (translations, model, pmtLocations, selectedLocationstoreId, selectedLocationCoordinates) {
		var pmtLocationsSortedByDistance = A2(
			$elm$core$List$take,
			10,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.distance;
				},
				A2(
					$elm$core$List$map,
					function (l) {
						var parseDistance = function (str) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								0,
								$elm$core$Basics$identity,
								$elm$core$String$toInt(str));
						};
						var distance = parseDistance(
							A4($author$project$Common$Math$calculateDistance, selectedLocationCoordinates.lat, selectedLocationCoordinates.lon, l.location.location.lat, l.location.location.lon));
						return {distance: distance, location: l.location};
					},
					pmtLocations)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__match_location_container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.matchLocationPMTTable,
					$author$project$PinMeTo$Ui$Table$withFullWidth(
						A2(
							$author$project$PinMeTo$Ui$Table$withColumn,
							A3(
								$author$project$PinMeTo$Ui$Table$createColumn,
								function (rowData) {
									return $author$project$PinMeTo$Ui$Button$render(
										A2(
											$author$project$PinMeTo$Ui$Button$withOnClick,
											A2($author$project$Tasks$PTV$Claim$Model$ConnectLocations, rowData.location.id, selectedLocationstoreId),
											A2(
												$author$project$PinMeTo$Ui$Button$withSize,
												$author$project$PinMeTo$Ui$Button$Small,
												$author$project$PinMeTo$Ui$Button$buttonSecondary(
													$author$project$Translations$Listings$Claim$connect(translations)))));
								},
								$author$project$PinMeTo$Ui$Table$comparing(
									function (_v0) {
										return 1;
									}),
								''),
							A2(
								$author$project$PinMeTo$Ui$Table$withColumn,
								A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.location;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.city;
												},
												$elm$html$Html$text))),
									$author$project$PinMeTo$Ui$Table$comparing(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.location;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.address;
												},
												function ($) {
													return $.city;
												}))),
									$author$project$Translations$General$locationCity(translations)),
								A2(
									$author$project$PinMeTo$Ui$Table$withColumn,
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.location;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.address;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.zip;
													},
													$elm$html$Html$text))),
										$author$project$PinMeTo$Ui$Table$comparing(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.location;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.address;
													},
													function ($) {
														return $.zip;
													}))),
										$author$project$Translations$General$locationZip(translations)),
									A2(
										$author$project$PinMeTo$Ui$Table$withColumn,
										A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.location;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.address;
													},
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.street;
														},
														$elm$html$Html$text))),
											$author$project$PinMeTo$Ui$Table$comparing(
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.location;
													},
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.address;
														},
														function ($) {
															return $.street;
														}))),
											$author$project$Translations$General$locationStreet(translations)),
										A2(
											$author$project$PinMeTo$Ui$Table$withColumn,
											A3(
												$author$project$PinMeTo$Ui$Table$createColumn,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.location;
													},
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.locationDescriptor;
														},
														$elm$html$Html$text)),
												$author$project$PinMeTo$Ui$Table$comparing(
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.location;
														},
														function ($) {
															return $.locationDescriptor;
														})),
												$author$project$Translations$General$locationDescriptor(translations)),
											A2(
												$author$project$PinMeTo$Ui$Table$withColumn,
												A3(
													$author$project$PinMeTo$Ui$Table$createColumn,
													function (item) {
														return $elm$html$Html$text(
															A2($elm$core$Maybe$withDefault, item.location.name, item.location.ptvCustomName));
													},
													$author$project$PinMeTo$Ui$Table$comparing(
														function (item) {
															return A2($elm$core$Maybe$withDefault, item.location.name, item.location.ptvCustomName);
														}),
													$author$project$Translations$General$locationName(translations)),
												A2(
													$author$project$PinMeTo$Ui$Table$withColumn,
													A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.distance;
															},
															A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.distance;
															}),
														$author$project$Translations$Listings$Claim$distance(translations)),
													A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$PTV$Claim$Model$MatchLocationPMTTable, pmtLocationsSortedByDistance))))))))))
				]));
	});
var $author$project$Tasks$PTV$Claim$Model$MatchLocationNetworkTable = function (a) {
	return {$: 'MatchLocationNetworkTable', a: a};
};
var $author$project$Tasks$PTV$Claim$Model$OnMatchLocationNetworkDataSelect = function (a) {
	return {$: 'OnMatchLocationNetworkDataSelect', a: a};
};
var $author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderNetworkTable = F3(
	function (translations, model, ptvUnmatchedLocations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__match_location_container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.matchLocationNetworkTable,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowMore,
						function (location) {
							if (_Utils_eq(
								model.selectedNetworkLocation,
								$elm$core$Maybe$Just(location.id))) {
								var locationsToBeCreated = function () {
									var _v0 = model.unmatchedListingsLocations;
									if (_v0.$ === 'Loaded') {
										var locations = _v0.a;
										return locations;
									} else {
										return _List_Nil;
									}
								}();
								var subheading = A2(
									$author$project$Translations$Listings$Claim$remaining,
									translations,
									$elm$core$String$fromInt(
										$elm$core$List$length(locationsToBeCreated)));
								var heading = $author$project$Translations$Listings$Claim$pinmetoLocations(translations);
								return $elm$core$Maybe$Just(
									A3(
										$author$project$NetworkLogs$CardView$renderGeneralPmtCard,
										heading,
										subheading,
										A5($author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderPMTTable, translations, model, locationsToBeCreated, location.id, location.location)));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withRowAction,
							function (location) {
								return $author$project$Tasks$PTV$Claim$Model$OnMatchLocationNetworkDataSelect(location.id);
							},
							A2(
								$author$project$PinMeTo$Ui$Table$withColumn,
								A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.address;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.city;
											},
											$elm$html$Html$text)),
									$author$project$PinMeTo$Ui$Table$comparing(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.city;
											})),
									$author$project$Translations$General$locationCity(translations)),
								A2(
									$author$project$PinMeTo$Ui$Table$withColumn,
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.zip;
												},
												$elm$html$Html$text)),
										$author$project$PinMeTo$Ui$Table$comparing(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.address;
												},
												function ($) {
													return $.zip;
												})),
										$author$project$Translations$General$locationZip(translations)),
									A2(
										$author$project$PinMeTo$Ui$Table$withColumn,
										A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.address;
												},
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.street;
													},
													$elm$html$Html$text)),
											$author$project$PinMeTo$Ui$Table$comparing(
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.address;
													},
													function ($) {
														return $.street;
													})),
											$author$project$Translations$General$locationStreet(translations)),
										A2(
											$author$project$PinMeTo$Ui$Table$withColumn,
											A3(
												$author$project$PinMeTo$Ui$Table$createColumn,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.name;
													},
													$elm$html$Html$text),
												$author$project$PinMeTo$Ui$Table$comparing(
													function ($) {
														return $.name;
													}),
												$author$project$Translations$General$locationName(translations)),
											$author$project$PinMeTo$Ui$Table$withFullWidth(
												A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$PTV$Claim$Model$MatchLocationNetworkTable, ptvUnmatchedLocations)))))))))
				]));
	});
var $author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderMatchTables = F3(
	function (translations, model, ptvUnmatchedLocations) {
		return $elm$core$List$isEmpty(ptvUnmatchedLocations) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$Claim$noAvailableLocationsToConnect(translations)))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__match_location_table_container')
				]),
			_List_fromArray(
				[
					A3($author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderNetworkTable, translations, model, ptvUnmatchedLocations)
				]));
	});
var $author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderMatchLocationsSection = F2(
	function (translations, model) {
		var notMatchedLocations = function () {
			var _v0 = model.unmatchedPTVLocations;
			if (_v0.$ === 'Loaded') {
				var locations = _v0.a;
				return locations;
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__render-distance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__content-margin')
						]),
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								A2($author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderHeader_, model.uiPopover, translations)
							]),
						_Utils_eq(model.unmatchedPTVLocations, $author$project$RemoteData$Loading) ? _List_fromArray(
							[$author$project$PinMeTo$Ui$Spinner$spinner]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('network-claim-page__sub_content-margin')
									]),
								_List_fromArray(
									[
										$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTV),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-font-note network-claim-page__sub_content-note')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$Listings$Claim$ptvLocations(translations))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-ui-font-caption network-claim-page__sub_content-caption')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Translations$Listings$Claim$remaining,
													translations,
													$elm$core$String$fromInt(
														$elm$core$List$length(notMatchedLocations))))
											]))
									])),
								$author$project$Tasks$PTV$Claim$Sections$Shared$renderAlert(model.matchLocationsNotification),
								A3($author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderMatchTables, translations, model, notMatchedLocations),
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$disabledIfTrue,
									model.canProceed,
									A2(
										$author$project$PinMeTo$Ui$Button$withOnClick,
										$author$project$Tasks$PTV$Claim$Model$ToggleLightbox,
										$author$project$PinMeTo$Ui$Button$buttonPrimary('Continue to Create Locations'))))
							])))
				]));
	});
var $author$project$Translations$Listings$Claim$PTV$createPinmetoLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.claim.PTV.createPinmetoLocations');
};
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderHeader_ = F2(
	function (uiPopoverState, session) {
		var popOverConfig = {
			uid: 'create-pinmeto-locations-popover',
			tagger: $author$project$Tasks$PTV$Claim$Model$UiPopoverMsg,
			content: _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Claim$PTV$createPinmetoLocations(session.translations))
				]),
			preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
		};
		return A2(
			$author$project$Tasks$Shared$Components$Header$renderHeader,
			$author$project$Translations$Listings$Claim$createLocations(session.translations) + ' (→PinMeTo)',
			$elm$core$Maybe$Just(
				A2(
					$author$project$PinMeTo$Ui$PopOver$renderPlain,
					uiPopoverState,
					$author$project$PinMeTo$Ui$PopOver$view(popOverConfig))));
	});
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderAlertSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('network-claim-page__render-distance')
			]),
		_List_fromArray(
			[
				$author$project$Tasks$PTV$Claim$Sections$Shared$renderAlert(model.createLocationsNotification)
			]));
};
var $author$project$Tasks$PTV$Claim$Model$CreateLocationPMTTable = function (a) {
	return {$: 'CreateLocationPMTTable', a: a};
};
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$locationListTable = F3(
	function (translations, model, locations) {
		return A2(
			$author$project$PinMeTo$Ui$Table$render,
			model.createLocationPMTTable,
			A2(
				$author$project$PinMeTo$Ui$Table$withRowSelection,
				function (x) {
					return x.id;
				},
				A2(
					$author$project$PinMeTo$Ui$Table$withColumn,
					A3(
						$author$project$PinMeTo$Ui$Table$createColumn,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.address;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.city;
								},
								$elm$html$Html$text)),
						$author$project$PinMeTo$Ui$Table$comparing(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.city;
								})),
						$author$project$Translations$General$locationCity(translations)),
					A2(
						$author$project$PinMeTo$Ui$Table$withColumn,
						A3(
							$author$project$PinMeTo$Ui$Table$createColumn,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.zip;
									},
									$elm$html$Html$text)),
							$author$project$PinMeTo$Ui$Table$comparing(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.zip;
									})),
							$author$project$Translations$General$locationZip(translations)),
						A2(
							$author$project$PinMeTo$Ui$Table$withColumn,
							A3(
								$author$project$PinMeTo$Ui$Table$createColumn,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.street;
										},
										$elm$html$Html$text)),
								$author$project$PinMeTo$Ui$Table$comparing(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.address;
										},
										function ($) {
											return $.street;
										})),
								$author$project$Translations$General$locationStreet(translations)),
							A2(
								$author$project$PinMeTo$Ui$Table$withColumn,
								A3(
									$author$project$PinMeTo$Ui$Table$createColumn,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.name;
										},
										$elm$html$Html$text),
									$author$project$PinMeTo$Ui$Table$comparing(
										function ($) {
											return $.name;
										}),
									$author$project$Translations$General$locationName(translations)),
								A2(
									$author$project$PinMeTo$Ui$Table$withColumn,
									A3(
										$author$project$PinMeTo$Ui$Table$createColumn,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.country;
												},
												$elm$html$Html$text)),
										$author$project$PinMeTo$Ui$Table$comparing(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.address;
												},
												function ($) {
													return $.country;
												})),
										$author$project$Translations$General$locationCountry(translations)),
									A2(
										$author$project$PinMeTo$Ui$Table$withColumn,
										A3(
											$author$project$PinMeTo$Ui$Table$createColumn,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.id;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.id;
												}),
											$author$project$Translations$General$locationStoreId(translations)),
										$author$project$PinMeTo$Ui$Table$withFullWidth(
											A2($author$project$PinMeTo$Ui$Table$view, $author$project$Tasks$PTV$Claim$Model$CreateLocationPMTTable, locations))))))))));
	});
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderLocationsList = F3(
	function (translations, model, filteredLocations) {
		var renderLocationListTable = $elm$core$List$isEmpty(filteredLocations) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Success,
				$author$project$PinMeTo$Ui$Alert$plain(
					$author$project$Translations$Listings$Claim$noAvailableLocationsToCreate(translations)))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__list-container')
				]),
			_List_fromArray(
				[
					A3($author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$locationListTable, translations, model, filteredLocations)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__list-container')
				]),
			_List_fromArray(
				[renderLocationListTable]));
	});
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderLocationsCount = function (list) {
	return '(' + ($elm$core$String$fromInt(
		$elm$core$List$length(list)) + ')');
};
var $author$project$Tasks$PTV$Claim$Model$CreatePinmetoLocations = {$: 'CreatePinmetoLocations'};
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderAvailableTab = F3(
	function (translations, model, filteredLocations) {
		var selectedLocations = A2(
			$elm$core$List$filter,
			function (location) {
				return A2(
					$elm$core$List$member,
					location.id,
					$author$project$PinMeTo$Ui$Table$selectedItems(model.createLocationPMTTable));
			},
			filteredLocations);
		var isCreateButtonDisabled = $elm$core$List$isEmpty(selectedLocations);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-claim-page__business-selection-container__button')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withOnClick,
								$author$project$Tasks$PTV$Claim$Model$CreatePinmetoLocations,
								A2(
									$author$project$PinMeTo$Ui$Button$disabledIfTrue,
									isCreateButtonDisabled,
									A2(
										$author$project$PinMeTo$Ui$Button$withIconBefore,
										$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
										$author$project$PinMeTo$Ui$Button$buttonPrimary(
											$author$project$Translations$General$create(translations) + (' ' + $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderLocationsCount(selectedLocations)))))))
						])),
					A3($author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderLocationsList, translations, model, filteredLocations),
					$author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Tasks$PTV$Claim$Model$CreatePinmetoLocations,
						A2(
							$author$project$PinMeTo$Ui$Button$disabledIfTrue,
							isCreateButtonDisabled,
							A2(
								$author$project$PinMeTo$Ui$Button$withIconBefore,
								$author$project$PinMeTo$Ui$Button$FARegular($author$project$FontAwesome$Regular$Icon$faPlus),
								$author$project$PinMeTo$Ui$Button$buttonPrimary(
									$author$project$Translations$General$create(translations) + (' ' + $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderLocationsCount(selectedLocations)))))))
				]));
	});
var $author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderCreatePinMeToLocationsSection = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-claim-page__content-margin')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2($author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderHeader_, model.uiPopover, session),
						$author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderAlertSection(model)
					]),
				function () {
					var _v0 = model.unmatchedPTVLocations;
					switch (_v0.$) {
						case 'Loading':
							return _List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinner]);
						case 'Loaded':
							var availableLocations = _v0.a;
							return _List_fromArray(
								[
									A3($author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderAvailableTab, session.translations, model, availableLocations)
								]);
						case 'Error':
							var error = _v0.a;
							return _List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Error,
										$author$project$PinMeTo$Ui$Alert$plain(error)))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
					}
				}()));
	});
var $author$project$Tasks$PTV$Claim$View$renderTwoWaySections = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('network-claim-page__disabled', false)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Tasks$PTV$Claim$View$sectionBreak,
					A2($author$project$Tasks$PTV$Claim$Sections$MatchLocationsSection$renderMatchLocationsSection, session.translations, model),
					$author$project$Tasks$PTV$Claim$View$sectionBreak,
					model.canProceed ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Tasks$PTV$Claim$Sections$CreatePinMeToLocationsSection$renderCreatePinMeToLocationsSection, session, model),
							$author$project$Tasks$PTV$Claim$View$sectionBreak
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Tasks$PTV$Claim$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container network-claim-page__page-margin')
				]),
			_List_fromArray(
				[
					A2($author$project$Tasks$PTV$Claim$View$renderHeader, session, model),
					function () {
					var _v0 = model.connectionType;
					if (_v0.$ === 'Loaded') {
						var conn = _v0.a;
						return _Utils_eq(conn, $author$project$Tasks$PTV$Claim$Model$TwoWay) ? A2($author$project$Tasks$PTV$Claim$View$renderTwoWaySections, session, model) : A2($author$project$Tasks$PTV$Claim$View$renderOneWaySection, session, model);
					} else {
						return $author$project$PinMeTo$Ui$Spinner$spinner;
					}
				}(),
					$author$project$Tasks$PTV$Claim$Components$ConfirmLighbox$renderLightbox(model.lightboxVisible),
					$author$project$Tasks$PTV$Claim$Components$SyncLocationsInfoLightbox$renderSyncLightbox(model.syncLightboxVisible),
					$author$project$Tasks$PTV$Claim$Components$CreateLightbox$renderCreateLoading(model.createLoadingVisible)
				]));
	});
var $author$project$Tasks$PTV$Claim$Model$Failed = {$: 'Failed'};
var $author$project$Tasks$PTV$Claim$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$PinMeTo$ExpectJson$expectString = F3(
	function (toMsg, map, jsonDecodeError) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			A2(
				$author$project$PinMeTo$ExpectJson$handleResponse,
				A2($elm$core$Basics$composeR, map, $elm$core$Result$Ok),
				jsonDecodeError));
	});
var $author$project$Tasks$PTV$Claim$Commands$syncLocations = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectString, msg, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/ptv/claim/sync'))));
	});
var $author$project$Tasks$PTV$Claim$Model$OnSyncLocations = function (a) {
	return {$: 'OnSyncLocations', a: a};
};
var $author$project$Tasks$PTV$Claim$Commands$encodeConnectLocation = function (_v0) {
	var ptvId = _v0.ptvId;
	var pmtId = _v0.pmtId;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pmtId',
				$elm$json$Json$Encode$string(pmtId)),
				_Utils_Tuple2(
				'ptvId',
				$elm$json$Json$Encode$string(ptvId))
			]));
};
var $author$project$Tasks$PTV$Claim$Commands$connectLocations = F3(
	function (_v0, matches, msg) {
		var accountName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectString, msg, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'data',
								$author$project$Tasks$PTV$Claim$Commands$encodeConnectLocation(matches))
							])),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (accountName + '/ptv/claim/connectLocations')))));
	});
var $author$project$Tasks$PTV$Claim$Model$OnConnectLocations = function (a) {
	return {$: 'OnConnectLocations', a: a};
};
var $author$project$Tasks$PTV$Claim$Update$updateNotification = F3(
	function (state, message, model) {
		return _Utils_update(
			model,
			{
				matchLocationsNotification: $elm$core$Maybe$Just(
					{state: state, message: message}),
				createLocationsNotification: $elm$core$Maybe$Just(
					{state: state, message: message})
			});
	});
var $author$project$Tasks$PTV$Claim$Model$GotExportDescriptions = function (a) {
	return {$: 'GotExportDescriptions', a: a};
};
var $author$project$Tasks$PTV$Claim$Commands$getDescriptionsExport = function (_v0) {
	var siteName = _v0.a;
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A3($author$project$PinMeTo$ExpectJson$expectString, $author$project$Tasks$PTV$Claim$Model$GotExportDescriptions, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
			$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/ptv/claim/download-descriptions'))));
};
var $author$project$Tasks$PTV$Claim$Commands$encodeLocationForPinmeto = function (location) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ptvId',
				$elm$json$Json$Encode$string(location.id))
			]));
};
var $author$project$Tasks$PTV$Claim$Commands$createPinMeToLocations = F3(
	function (_v0, model, msg) {
		var accountName = _v0.a;
		var selectedLocations = function () {
			var _v1 = model.unmatchedPTVLocations;
			if (_v1.$ === 'Loaded') {
				var locations = _v1.a;
				return A2(
					$elm$core$List$filter,
					function (location) {
						return A2(
							$elm$core$List$member,
							location.id,
							$author$project$PinMeTo$Ui$Table$selectedItems(model.createLocationPMTTable));
					},
					locations);
			} else {
				return _List_Nil;
			}
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$PTV$Claim$Commands$createLocationDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					A2($elm$json$Json$Encode$list, $author$project$Tasks$PTV$Claim$Commands$encodeLocationForPinmeto, selectedLocations),
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (accountName + '/ptv/claim/createListingsLocations')))));
	});
var $author$project$Tasks$PTV$Claim$Update$filterUnmatchedLocations = F2(
	function (unmatchedLocations, predicate) {
		if (unmatchedLocations.$ === 'Loaded') {
			var locationsData = unmatchedLocations.a;
			return $author$project$RemoteData$Loaded(
				A2($elm$core$List$filter, predicate, locationsData));
		} else {
			return unmatchedLocations;
		}
	});
var $author$project$Tasks$PTV$Claim$Update$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiSelect) {
						return _Utils_update(
							model,
							{uiSelect: updatedUiSelect});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Tasks$PTV$Claim$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'UiPopoverMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updatedUiPopover) {
						return _Utils_update(
							model,
							{uiPopover: updatedUiPopover});
					},
					A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Tasks$PTV$Claim$Model$UiPopoverMsg, msg_, model.uiPopover));
			case 'FilterLocationsToCreate':
				var locationFilter = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filter: locationFilter}),
					$elm$core$Platform$Cmd$none);
			case 'CreateLocationNetworkTable':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							createLocationNetworkTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.createLocationNetworkTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'CreateLocationPMTTable':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							createLocationPMTTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.createLocationPMTTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'MatchLocationNetworkTable':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							matchLocationNetworkTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.matchLocationNetworkTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'MatchLocationPMTTable':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							matchLocationPMTTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.matchLocationPMTTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnMatchLocationNetworkDataSelect':
				var id = msg.a;
				var newSelectedNetworkLocation = _Utils_eq(
					model.selectedNetworkLocation,
					$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectedNetworkLocation: newSelectedNetworkLocation}),
					$elm$core$Platform$Cmd$none);
			case 'ConnectLocations':
				var pmtId = msg.a;
				var ptvId = msg.b;
				var newModel = _Utils_update(
					model,
					{
						unmatchedPTVLocations: A2(
							$author$project$Tasks$PTV$Claim$Update$filterUnmatchedLocations,
							model.unmatchedPTVLocations,
							function (ptvLocation) {
								return !_Utils_eq(ptvLocation.id, ptvId);
							}),
						unmatchedListingsLocations: A2(
							$author$project$Tasks$PTV$Claim$Update$filterUnmatchedLocations,
							model.unmatchedListingsLocations,
							function (listingData) {
								return !_Utils_eq(listingData.location.id, ptvId);
							})
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Tasks$PTV$Claim$Commands$connectLocations,
								session.siteName,
								{pmtId: pmtId, ptvId: ptvId},
								$author$project$Tasks$PTV$Claim$Model$OnConnectLocations)
							])));
			case 'CreatePinmetoLocations':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{createLoadingVisible: !model.createLoadingVisible}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Tasks$PTV$Claim$Commands$createPinMeToLocations, session.siteName, model, $author$project$Tasks$PTV$Claim$Model$LocationsResponse)
							])));
			case 'LocationsResponse':
				if (msg.a.$ === 'Ok') {
					var locationsResponse = msg.a.a;
					var listings = locationsResponse.unmatchedListings;
					var ptv = locationsResponse.unmatchedPTV;
					var canProceed = $elm$core$List$isEmpty(listings) || $elm$core$List$isEmpty(ptv);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								canProceed: model.canProceed || canProceed,
								createLoadingVisible: false,
								unmatchedPTVLocations: $author$project$RemoteData$Loaded(ptv),
								unmatchedListingsLocations: $author$project$RemoteData$Loaded(listings)
							}),
						A2($author$project$Tasks$PTV$Claim$Commands$getLastFetchedAt, session.siteName, $author$project$Tasks$PTV$Claim$Model$GetLastFetchedAt));
				} else {
					var err = msg.a.a;
					var errorMessage = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					var updatedModel = A3($author$project$Tasks$PTV$Claim$Update$updateNotification, $author$project$Tasks$PTV$Claim$Model$Failed, errorMessage, model);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{createLoadingVisible: false}),
						$author$project$PinMeTo$Logger$log(
							{data: errorMessage, context: 'Tasks.PTV.Claim.Update.LocationsResponse', message: 'Failed to decode response LocationsResponse'}));
				}
			case 'GoToNextSection':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{canProceed: true, lightboxVisible: false}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleLightbox':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lightboxVisible: !model.lightboxVisible}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleCreateLightbox':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{createLoadingVisible: !model.createLoadingVisible}),
					$elm$core$Platform$Cmd$none);
			case 'OnConnectLocations':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Tasks$PTV$Claim$Commands$getNotMatched, session.siteName, $author$project$Tasks$PTV$Claim$Model$LocationsResponse),
									A2($author$project$Tasks$PTV$Claim$Commands$getLastFetchedAt, session.siteName, $author$project$Tasks$PTV$Claim$Model$GetLastFetchedAt)
								])));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.PTV.Claim.Update.OnConnectLocations',
								message: 'Failed to decode response OnConnectLocations'
							}));
				}
			case 'GetLastFetchedAt':
				if (msg.a.$ === 'Ok') {
					var timestamp = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lastFetchedAt: $author$project$RemoteData$Loaded(timestamp)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var updatedModel = A3(
						$author$project$Tasks$PTV$Claim$Update$updateNotification,
						$author$project$Tasks$PTV$Claim$Model$Failed,
						$author$project$PinMeTo$ExpectJson$getErrorMessage(err),
						model);
					return _Utils_Tuple2(
						_Utils_update(
							updatedModel,
							{
								lastFetchedAt: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.PTV.Claim.Update.GetLastFetchedAt',
								message: 'Failed to decode response GetLastFetchedAt'
							}));
				}
			case 'SyncLocations':
				return _Utils_Tuple2(
					model,
					A2($author$project$Tasks$PTV$Claim$Commands$syncLocations, session.siteName, $author$project$Tasks$PTV$Claim$Model$OnSyncLocations));
			case 'OnSyncLocations':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{syncLightboxVisible: true}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var errorMessage = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					var updatedModel = A3($author$project$Tasks$PTV$Claim$Update$updateNotification, $author$project$Tasks$PTV$Claim$Model$Failed, errorMessage, model);
					return _Utils_Tuple2(
						updatedModel,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.PTV.Claim.Update.OnSyncLocations',
								message: 'Failed to decode response OnSyncLocations'
							}));
				}
			case 'ToggleSyncLightbox':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{syncLightboxVisible: !model.syncLightboxVisible}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tasks$PTV$Claim$Commands$getNotMatched, session.siteName, $author$project$Tasks$PTV$Claim$Model$LocationsResponse),
								A2($author$project$Tasks$PTV$Claim$Commands$getLastFetchedAt, session.siteName, $author$project$Tasks$PTV$Claim$Model$GetLastFetchedAt)
							])));
			case 'ExportDescriptions':
				return _Utils_Tuple2(
					model,
					$author$project$Tasks$PTV$Claim$Commands$getDescriptionsExport(session.siteName));
			case 'GotExportDescriptions':
				if (msg.a.$ === 'Ok') {
					var csvContent = msg.a.a;
					return _Utils_Tuple2(
						model,
						A3(
							$elm$file$File$Download$string,
							'PTV_Descriptions_' + ($author$project$Data$SiteName$toString(session.siteName) + '.csv'),
							'text/csv',
							csvContent));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.PTV.Claim.Update.GotExportDescriptions',
								message: 'Failed to export descriptions'
							}));
				}
			default:
				if (msg.a.$ === 'Ok') {
					var connectionType = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								connectionType: $author$project$RemoteData$Loaded(connectionType)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								connectionType: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(err),
								context: 'Tasks.PTV.Claim.Update.GetConnectionTypeResponse',
								message: 'Failed to decode response GetConnectionTypeResponse'
							}));
				}
		}
	});
var $author$project$Tasks$PTV$Claim$Main$subscriptions = function (model) {
	return A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Tasks$PTV$Claim$Model$CreateLocationPMTTable, model.createLocationPMTTable);
};
var $author$project$Tasks$PTV$Claim$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$Tasks$PTV$Claim$Main$init,
		view: function (session) {
			return $author$project$Tasks$PTV$Claim$View$view(session);
		},
		update: $author$project$Tasks$PTV$Claim$Update$update,
		flagsDecoder: $elm$json$Json$Decode$succeed(_Utils_Tuple0),
		subscriptions: $author$project$Tasks$PTV$Claim$Main$subscriptions
	});
var $author$project$FontAwesome$Regular$Icon$faBan = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-ban');
var $author$project$FontAwesome$Regular$faBan = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faBan);
var $author$project$PinMeTo$Ui$Alert$withIcon = F2(
	function (icon, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Alert$Alert(
			_Utils_update(
				config,
				{icon: icon, withoutIcon: false}));
	});
var $author$project$Translations$General$learnMore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.learn_more');
};
var $author$project$PlatformBanners$Main$ReconnectBtnClicked = {$: 'ReconnectBtnClicked'};
var $author$project$PlatformBanners$Main$disconnectedNetworks = function (connections) {
	var isDisconnected = function (connection) {
		return connection.enabled && (!connection.connected);
	};
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var disconnected = _v0.b;
				return _Utils_eq(
					disconnected,
					$elm$core$Maybe$Just(true));
			},
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Facebook',
					A2($elm$core$Maybe$map, isDisconnected, connections.facebook)),
					_Utils_Tuple2(
					'Google',
					A2($elm$core$Maybe$map, isDisconnected, connections.google)),
					_Utils_Tuple2(
					'Trustpilot',
					A2($elm$core$Maybe$map, isDisconnected, connections.trustpilot)),
					_Utils_Tuple2(
					'Apple',
					A2($elm$core$Maybe$map, isDisconnected, connections.apple)),
					_Utils_Tuple2(
					'PTV',
					A2($elm$core$Maybe$map, isDisconnected, connections.ptv))
				])));
};
var $author$project$FontAwesome$Regular$Icon$faTriangleExclamation = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-triangle-exclamation');
var $author$project$FontAwesome$Regular$faTriangleExclamation = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faTriangleExclamation);
var $author$project$Translations$General$networkConnectionIsLost = F2(
	function (translations, networkName) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.network_connection_is_lost',
			_List_fromArray(
				[
					_Utils_Tuple2('networkName', networkName)
				]));
	});
var $author$project$PlatformBanners$Main$trustpilotLacksSubscription = function (connections) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (trustpilot) {
				return trustpilot.enabled && (trustpilot.connected && (!trustpilot.isSubscriber));
			},
			connections.trustpilot));
};
var $author$project$Translations$General$trustpilotNotSubscribedCustom = F3(
	function (translations, nonPlaceholderLift, learnMoreLink) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'general.trustpilot_not_subscribed',
			_List_fromArray(
				[
					_Utils_Tuple2('- learn_more_link ', learnMoreLink)
				]));
	});
var $author$project$Translations$General$networkConnectionIsLostPleaseContactOwner = F2(
	function (translations, networkName) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.network_connection_is_lost_please_contact_owner',
			_List_fromArray(
				[
					_Utils_Tuple2('networkName', networkName)
				]));
	});
var $author$project$PlatformBanners$Main$view = function (model) {
	var trustpilotSubscriptionBanner = $author$project$PlatformBanners$Main$trustpilotLacksSubscription(model.networkConnections) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('reconnect-network-banner')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Alert$render(
				A2(
					$author$project$PinMeTo$Ui$Alert$withIcon,
					$author$project$FontAwesome$Regular$faTriangleExclamation,
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Warning,
						$author$project$PinMeTo$Ui$Alert$rich(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									A3(
										$author$project$Translations$General$trustpilotNotSubscribedCustom,
										model.translations,
										$elm$html$Html$text,
										A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/trustpilot-1mneqdg'),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$General$learnMore(model.translations))
												]))))
								])))))
			])) : $elm$html$Html$text('');
	var reconnectLink = '/account-settings/' + (model.siteName + '/connections');
	var reconnectBtn = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(reconnectLink),
				$elm$html$Html$Attributes$class('pmt-ui-font-note-1'),
				$elm$html$Html$Events$onClick($author$project$PlatformBanners$Main$ReconnectBtnClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Reconnect')
			]));
	var disconnected = $author$project$PlatformBanners$Main$disconnectedNetworks(model.networkConnections);
	var networkNames = A2($elm$core$String$join, ', ', disconnected);
	var warningText = model.userIsOwner ? A2($author$project$Translations$General$networkConnectionIsLost, model.translations, networkNames) : A2($author$project$Translations$General$networkConnectionIsLostPleaseContactOwner, model.translations, networkNames);
	var textElement = function (isOwner) {
		return A2(
			$elm$core$List$cons,
			$elm$html$Html$text(warningText),
			isOwner ? _List_fromArray(
				[
					$elm$html$Html$text(' '),
					reconnectBtn
				]) : _List_Nil);
	};
	var disconnectedBanner = $elm$core$List$isEmpty(disconnected) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('reconnect-network-banner')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Alert$render(
				A2(
					$author$project$PinMeTo$Ui$Alert$withIcon,
					$author$project$FontAwesome$Regular$faBan,
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Error,
						$author$project$PinMeTo$Ui$Alert$rich(
							textElement(model.userIsOwner)))))
			]));
	var elements = _List_fromArray(
		[disconnectedBanner, trustpilotSubscriptionBanner]);
	return A2($elm$html$Html$span, _List_Nil, elements);
};
var $author$project$PlatformBanners$Main$update = F2(
	function (msg, model) {
		var cmd = $author$project$PlanHat$PlanHat$track(
			{
				info: A2(
					$elm$core$String$join,
					', ',
					$author$project$PlatformBanners$Main$disconnectedNetworks(model.networkConnections)),
				action: 'Click on reconnect button'
			});
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$PlatformBanners$Main$Flags = F7(
	function (siteName, networkConnections, userIsOwner, translations, productName, appleEnabled, appleOAuth) {
		return {siteName: siteName, appleOAuth: appleOAuth, productName: productName, userIsOwner: userIsOwner, appleEnabled: appleEnabled, translations: translations, networkConnections: networkConnections};
	});
var $author$project$PlatformBanners$Main$Connection = F2(
	function (enabled, connected) {
		return {enabled: enabled, connected: connected};
	});
var $author$project$PlatformBanners$Main$NetworkConnections = F5(
	function (facebook, google, trustpilot, apple, ptv) {
		return {ptv: ptv, apple: apple, google: google, facebook: facebook, trustpilot: trustpilot};
	});
var $author$project$PlatformBanners$Main$TrustpilotConnection = F3(
	function (enabled, connected, isSubscriber) {
		return {enabled: enabled, connected: connected, isSubscriber: isSubscriber};
	});
var $author$project$PlatformBanners$Main$networkConnectionsDecoder = function () {
	var trustpilotConnectionDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isSubscriber',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'connected',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enabled',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$PlatformBanners$Main$TrustpilotConnection))));
	var optionalConnection = F2(
		function (field, decoder) {
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				field,
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$core$Maybe$Nothing);
		});
	var connectionDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'connected',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enabled',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$PlatformBanners$Main$Connection)));
	return A3(
		optionalConnection,
		'ptv',
		connectionDecoder,
		A3(
			optionalConnection,
			'apple',
			connectionDecoder,
			A3(
				optionalConnection,
				'trustpilot',
				trustpilotConnectionDecoder,
				A3(
					optionalConnection,
					'google',
					connectionDecoder,
					A3(
						optionalConnection,
						'facebook',
						connectionDecoder,
						$elm$json$Json$Decode$succeed($author$project$PlatformBanners$Main$NetworkConnections))))));
}();
var $author$project$PlatformBanners$Main$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'appleOAuth',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'appleEnabled',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'productName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'translations',
				$author$project$Common$Language$translationsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userIsOwner',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['user', 'selectedSite', 'networkConnections']),
						$author$project$PlatformBanners$Main$networkConnectionsDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'siteName',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$PlatformBanners$Main$Flags))))))));
var $author$project$PlatformBanners$Main$handleFlags = function (data) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlatformBanners$Main$flagsDecoder, data);
	if (_v0.$ === 'Ok') {
		var flags = _v0.a;
		return _Utils_Tuple2(flags, $elm$core$Platform$Cmd$none);
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			{
				siteName: '',
				appleOAuth: false,
				productName: '',
				userIsOwner: false,
				appleEnabled: false,
				translations: $author$project$Common$Language$initialTranslationsFallback,
				networkConnections: {ptv: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, trustpilot: $elm$core$Maybe$Nothing}
			},
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'PlatformBanners.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$PlatformBanners$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$PlatformBanners$Main$handleFlags,
		view: $author$project$PlatformBanners$Main$view,
		update: $author$project$PlatformBanners$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$LocationSelectorPort$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$LocationSelectorPort$Running = function (a) {
	return {$: 'Running', a: a};
};
var $author$project$LocationSelectorPort$Flags = F6(
	function (siteName, realm, network, selected, translations, language) {
		return {realm: realm, network: network, language: language, selected: selected, siteName: siteName, translations: translations};
	});
var $author$project$LocationSelectorPort$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'selected',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'network',
				$author$project$PinMeTo$Api$SelectorApi$networkDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'realm',
					$author$project$PinMeTo$Api$SelectorApi$realmDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'siteName',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$LocationSelectorPort$Flags)))))));
var $author$project$LocationSelectorPort$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$LocationSelectorPort$flagsDecoder, flagsValue);
};
var $author$project$LocationSelectorPort$init = function (flagsValue) {
	var _v0 = $author$project$LocationSelectorPort$decodeFlags(flagsValue);
	if (_v0.$ === 'Ok') {
		var flags = _v0.a;
		return _Utils_Tuple2(
			$author$project$LocationSelectorPort$Running(
				{realm: flags.realm, network: flags.network, language: flags.language, selected: flags.selected, selector: $author$project$PinMeTo$Ui$SelectorLocationWithFilters$init, siteName: flags.siteName, translations: flags.translations}),
			$elm$core$Platform$Cmd$none);
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$author$project$LocationSelectorPort$Error('Location selector failed. Error has been logged.'),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'LocationSelectorPort',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$LocationSelectorPort$RunningMsg = function (a) {
	return {$: 'RunningMsg', a: a};
};
var $author$project$LocationSelectorPort$UiSelectorMsg = function (a) {
	return {$: 'UiSelectorMsg', a: a};
};
var $author$project$LocationSelectorPort$view = function (state) {
	if (state.$ === 'Running') {
		var model = state.a;
		return A2(
			$author$project$PinMeTo$Ui$SelectorLocationWithFilters$render,
			model.selector,
			A2(
				$author$project$PinMeTo$Ui$SelectorLocationWithFilters$withSelected,
				model.selected,
				$author$project$PinMeTo$Ui$SelectorLocationWithFilters$view(
					{
						labels: A3(
							$author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels,
							model.translations,
							model.language,
							A2($author$project$Filter$FilterLabels$locationsFilterControllerLabels, model.translations, model.language)),
						locale: $author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
						tagger: A2($elm$core$Basics$composeR, $author$project$LocationSelectorPort$UiSelectorMsg, $author$project$LocationSelectorPort$RunningMsg)
					})));
	} else {
		var error = state.a;
		return $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Error,
				$author$project$PinMeTo$Ui$Alert$plain(error)));
	}
};
var $author$project$LocationSelectorPort$OnSelect = function (a) {
	return {$: 'OnSelect', a: a};
};
var $author$project$LocationSelectorPort$out_LocationSelectorPort_LocationsSelected = _Platform_outgoingPort(
	'out_LocationSelectorPort_LocationsSelected',
	$elm$json$Json$Encode$list($elm$json$Json$Encode$string));
var $author$project$LocationSelectorPort$updateModel = F2(
	function (msg, model) {
		if (msg.$ === 'UiSelectorMsg') {
			var msg_ = msg.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$LocationSelectorPort$RunningMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					function (selector) {
						return _Utils_update(
							model,
							{selector: selector});
					},
					A3(
						$author$project$PinMeTo$Ui$SelectorLocationWithFilters$update,
						{
							api: $author$project$PinMeTo$Api$SelectorApi$filteredLocationApi(
								{realm: model.realm, network: model.network, siteName: model.siteName}),
							tagger: $author$project$LocationSelectorPort$UiSelectorMsg,
							onChange: $author$project$LocationSelectorPort$OnSelect
						},
						msg_,
						model.selector)));
		} else {
			var selected = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{selected: selected}),
				$author$project$LocationSelectorPort$out_LocationSelectorPort_LocationsSelected(selected));
		}
	});
var $author$project$LocationSelectorPort$update = F2(
	function (msg, model) {
		if (msg.$ === 'HandleFlags') {
			var flagsValue = msg.a;
			return $author$project$LocationSelectorPort$init(flagsValue);
		} else {
			var msg_ = msg.a;
			if (model.$ === 'Running') {
				var model_ = model.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$LocationSelectorPort$Running,
					A2($author$project$LocationSelectorPort$updateModel, msg_, model_));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$LocationSelectorPort$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$LocationSelectorPort$passArgs_LocationSelectorPort = _Platform_incomingPort('passArgs_LocationSelectorPort', $elm$json$Json$Decode$value);
var $author$project$LocationSelectorPort$main = $elm$browser$Browser$element(
	{
		init: $author$project$LocationSelectorPort$init,
		view: $author$project$LocationSelectorPort$view,
		update: $author$project$LocationSelectorPort$update,
		subscriptions: $elm$core$Basics$always(
			$author$project$LocationSelectorPort$passArgs_LocationSelectorPort($author$project$LocationSelectorPort$HandleFlags))
	});
var $author$project$Listings$Ui$Examples$init = function (_v0) {
	return _Utils_Tuple2(
		{},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Listings$Ui$Header$City = function (a) {
	return {$: 'City', a: a};
};
var $author$project$Listings$Ui$Header$Header = function (a) {
	return {$: 'Header', a: a};
};
var $author$project$Listings$Ui$Header$Street = function (a) {
	return {$: 'Street', a: a};
};
var $author$project$Listings$Ui$Header$StoreId = function (a) {
	return {$: 'StoreId', a: a};
};
var $author$project$Listings$Ui$Header$OpenStatus = function (a) {
	return {$: 'OpenStatus', a: a};
};
var $author$project$Listings$Ui$Header$CountryCode = function (a) {
	return {$: 'CountryCode', a: a};
};
var $author$project$Listings$Ui$Header$Description = function (a) {
	return {$: 'Description', a: a};
};
var $author$project$Listings$Ui$Header$header = function (config) {
	return $author$project$Listings$Ui$Header$Header(
		{
			city: $author$project$Listings$Ui$Header$City(config.city),
			street: $author$project$Listings$Ui$Header$Street(config.street),
			storeId: $author$project$Listings$Ui$Header$StoreId(config.storeId),
			openStatus: $author$project$Listings$Ui$Header$OpenStatus(config.openStatus),
			countryCode: $author$project$Listings$Ui$Header$CountryCode(config.countryCode),
			description: $author$project$Listings$Ui$Header$Description(config.description)
		});
};
var $author$project$Listings$Ui$Header$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('location-details-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function (_v1) {
							var string = _v1.a;
							return string;
						}(config.storeId))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function (_v2) {
							var string = _v2.a;
							return string;
						}(config.openStatus))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function (_v3) {
							var string = _v3.a;
							return string;
						}(config.description))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function (_v4) {
							var string = _v4.a;
							return string;
						}(config.city))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function (_v5) {
							var string = _v5.a;
							return string;
						}(config.street))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function (_v6) {
							var string = _v6.a;
							return string;
						}(config.countryCode))
					]))
			]));
};
var $author$project$Listings$Ui$Examples$view = function (_v0) {
	var specialOpenHours = {
		label: $elm$core$Maybe$Just(''),
		state: $author$project$Data$Location$SpecialOpenHours$Open(
			{open: '0800', close: '1400'}),
		endDate: $elm$time$Time$millisToPosix(1671753600000),
		startDate: $elm$time$Time$millisToPosix(1671753600000)
	};
	var openHours = $author$project$Data$Location$OpenHours$During(
		{
			fri: $author$project$Data$Location$OpenHours$Closed,
			mon: $author$project$Data$Location$OpenHours$Open(
				_List_fromArray(
					[
						{open: '0800', close: '1700'}
					])),
			sat: $author$project$Data$Location$OpenHours$Closed,
			sun: $author$project$Data$Location$OpenHours$Open(
				_List_fromArray(
					[
						{open: '1400', close: '1600'},
						{open: '2100', close: '2200'}
					])),
			thu: $author$project$Data$Location$OpenHours$Open(
				_List_fromArray(
					[
						{open: '0800', close: '1700'}
					])),
			tue: $author$project$Data$Location$OpenHours$Open(
				_List_fromArray(
					[
						{open: '0800', close: '1700'}
					])),
			wed: $author$project$Data$Location$OpenHours$Open(
				_List_fromArray(
					[
						{open: '0800', close: '1700'}
					]))
		});
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('UI HEADER')
					])),
				$author$project$Listings$Ui$Header$render(
				$author$project$Listings$Ui$Header$header(
					{city: 'Lund', street: '123 Main Street', storeId: '1335', openStatus: 'Open', countryCode: 'SE', description: 'PinMeTo'})),
				A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('UI GROUP')
					])),
				A2(
				$author$project$Listings$Ui$Group$render(
					$author$project$Listings$Ui$Group$group(
						{
							rows: _List_fromArray(
								[
									A2(
									$author$project$Listings$Ui$Row$withStatus,
									$author$project$Listings$Ui$Row$NoConflict,
									$author$project$Listings$Ui$Row$row(
										{
											label: $author$project$Listings$Ui$Label$label(
												{title: 'Store Id', description: 'Unique identifier of the location'}),
											fieldType: $author$project$Listings$Ui$Row$Paragraph('1389')
										})),
									A2(
									$author$project$Listings$Ui$Row$withStatus,
									$author$project$Listings$Ui$Row$NoConflict,
									$author$project$Listings$Ui$Row$row(
										{
											label: $author$project$Listings$Ui$Label$label(
												{title: 'Store Phone Number', description: 'Main phone number of the location'}),
											fieldType: $author$project$Listings$Ui$Row$Paragraph('+46 789 8764')
										}))
								]),
							title: 'Listings Ui Group 1'
						})),
				$author$project$Common$Language$initialTranslationsFallback,
				$elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale)),
				A2(
				$author$project$Listings$Ui$Group$render(
					$author$project$Listings$Ui$Group$group(
						{
							rows: _List_fromArray(
								[
									A2(
									$author$project$Listings$Ui$Row$withStatus,
									$author$project$Listings$Ui$Row$Conflict,
									$author$project$Listings$Ui$Row$row(
										{
											label: $author$project$Listings$Ui$Label$label(
												{title: 'Homepage', description: 'Website of the location'}),
											fieldType: $author$project$Listings$Ui$Row$Paragraph('www.pinmeto.com')
										})),
									A2(
									$author$project$Listings$Ui$Row$withStatus,
									$author$project$Listings$Ui$Row$NoConflict,
									$author$project$Listings$Ui$Row$row(
										{
											label: $author$project$Listings$Ui$Label$label(
												{title: 'Email', description: 'Main email of the location'}),
											fieldType: $author$project$Listings$Ui$Row$Paragraph('test@pinmeto.com')
										})),
									A2(
									$author$project$Listings$Ui$Row$withStatus,
									$author$project$Listings$Ui$Row$Work,
									$author$project$Listings$Ui$Row$row(
										{
											label: $author$project$Listings$Ui$Label$label(
												{title: 'Description', description: 'Description of the location'}),
											fieldType: $author$project$Listings$Ui$Row$Paragraph('This is the best location')
										}))
								]),
							title: 'Listings Ui Group 2'
						})),
				$author$project$Common$Language$initialTranslationsFallback,
				$elm$core$Maybe$Just($author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale)),
				A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('UI ROW')
					])),
				A3(
				$author$project$Listings$Ui$Row$render,
				A2(
					$author$project$Listings$Ui$Row$withStatus,
					$author$project$Listings$Ui$Row$NoConflict,
					$author$project$Listings$Ui$Row$row(
						{
							label: $author$project$Listings$Ui$Label$label(
								{title: 'UI Row Text', description: 'Text'}),
							fieldType: $author$project$Listings$Ui$Row$Paragraph('Text is rendering by the Paragraph type')
						})),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Profile Image', description: 'Profile image is rendered by the ProfileImage type'}),
								fieldType: $author$project$Listings$Ui$Row$ProfileImage('https://pinmeto.s3.eu-west-1.amazonaws.com/pinmeto/thumbnail_2022-08-30_d1cc0242-4450-45db-8a48-4c69f3363e3b.png')
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Cover Image', description: 'Cover image is rendered by the CoverImage type'}),
								fieldType: $author$project$Listings$Ui$Row$CoverImage('https://pinmeto.s3.eu-west-1.amazonaws.com/pinmeto/thumbnail_beb66308-cb1b-4917-9248-17db41b9d2ce_cropped-cropped-google_location_coverImage_20200601_082530_485')
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Coordinates', description: 'Coordinates are rendered by the Coordinates type'}),
								fieldType: $author$project$Listings$Ui$Row$Coordinates(
									{lat: 78.4944, lon: 23423})
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Special Open Hours', description: 'Special open hours are rendered by the SpecialOpenHours type'}),
								fieldType: A2(
									$author$project$Listings$Ui$Row$SpecialOpenHours,
									_List_fromArray(
										[specialOpenHours]),
									$elm$time$Time$millisToPosix(1))
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Open Hours', description: 'Open hours are rendered by the OpenHours type'}),
								fieldType: $author$project$Listings$Ui$Row$OpenHours(openHours)
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Review Link', description: 'New google review link is rendered by the ReviewLink type'}),
								fieldType: $author$project$Listings$Ui$Row$NewReviewLink(
									$author$project$Data$Location$NewReviewUrl('https://google.com'))
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$author$project$Listings$Ui$Row$render(
					A2(
						$author$project$Listings$Ui$Row$withStatus,
						$author$project$Listings$Ui$Row$NoConflict,
						$author$project$Listings$Ui$Row$row(
							{
								label: $author$project$Listings$Ui$Label$label(
									{title: 'UI Row Google Attributes', description: 'Google attributes are rendered by the GoogleAttributesType'}),
								fieldType: $author$project$Listings$Ui$Row$GoogleAttributes(
									_List_fromArray(
										[
											{
											name: 'Business Name',
											type_: 'BOOL',
											values: _List_fromArray(
												['true']),
											unsetValue: _List_Nil
										},
											{
											name: 'Business Description',
											type_: 'BOOL',
											values: _List_fromArray(
												['false']),
											unsetValue: _List_Nil
										},
											{
											name: 'Business Address',
											type_: 'URL',
											values: _List_fromArray(
												['https://google.com']),
											unsetValue: _List_Nil
										}
										]))
							}))),
				$author$project$Common$Language$initialTranslationsFallback,
				$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
				A2(
				$elm$html$Html$h6,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('UI LABEL')
					])),
				$author$project$Listings$Ui$Label$render(
				$author$project$Listings$Ui$Label$label(
					{title: 'UI Label Title', description: 'UI Label Description'}))
			]));
};
var $author$project$Listings$Ui$Examples$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Listings$Ui$Examples$main = $elm$browser$Browser$element(
	{
		init: $author$project$Listings$Ui$Examples$init,
		view: $author$project$Listings$Ui$Examples$view,
		update: $author$project$Listings$Ui$Examples$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Insights$System$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Insights$System$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Insights$System$Model$GotSupportedDateRange = function (a) {
	return {$: 'GotSupportedDateRange', a: a};
};
var $author$project$Insights$System$Decoders$supportedDateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxDate',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minDate',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$System$Commands$getSupportedDateRange = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = function (urlString) {
			return urlString + (siteName + '/system/locations/updated/supportedDateRange');
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$System$Decoders$supportedDateRangeDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Insights$System$Main$out_Insights_System_Main_onRangeChange = _Platform_outgoingPort('out_Insights_System_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$System$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var uiDateRangePicker = $author$project$PinMeTo$Ui$DateRangePicker$init;
		var timezone = A2($elm$time$Time$customZone, flags.timezoneOffset, _List_Nil);
		var model = {
			range: A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 28),
				flags.dateRange),
			today: flags.today,
			baseUrl: flags.url,
			placeId: $elm$core$Maybe$Nothing,
			lifetime: $elm$core$Maybe$Nothing,
			timezone: timezone,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			uiFeedback: $author$project$Listings$Ui$Feedback$init,
			insightsUrl: flags.insightsUrl,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			initialFilter: flags.initialFilter,
			filterController: filterControllerModel_,
			filterDefinition: $elm$core$Maybe$Nothing,
			uiDateRangePicker: uiDateRangePicker.a,
			accountNetworkUpdates: $author$project$RemoteData$Loading,
			accountLocationUpdates: $author$project$RemoteData$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Insights$System$Commands$getSupportedDateRange, model, session.siteName, $author$project$Insights$System$Model$GotSupportedDateRange),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$System$Model$DateRangePickerMsg, uiDateRangePicker.b),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$System$Model$FilterControllerMsg, filterControllerCmd_),
						$author$project$Insights$System$Main$out_Insights_System_Main_onRangeChange(
						$author$project$Insights$Utils$encodeDateRange(model.range))
					])));
	});
var $author$project$Insights$System$Model$getDateLabel = function (model) {
	var toString = function (date) {
		return $justinmimbs$date$Date$toIsoString(date);
	};
	var from = toString(model.range.from);
	var to = toString(model.range.to);
	return from + (' - ' + to);
};
var $author$project$Insights$System$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Insights$System$View$Charts$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: $author$project$Translations$Listings$Insights$feedbackLabel(translations),
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$System$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Insights$System$View$Charts$renderAsides = F3(
	function (session, model, uid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
						]),
					_List_fromArray(
						[
							A3($author$project$Insights$System$View$Charts$uiFeedback, session.translations, uid, model.uiFeedback)
						]))
				]));
	});
var $author$project$Insights$System$Model$OnPopOver = F2(
	function (a, b) {
		return {$: 'OnPopOver', a: a, b: b};
	});
var $author$project$Translations$Listings$Insights$systemNetworkUpdatesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.system_network_updates_popover');
};
var $author$project$Translations$Listings$Insights$systemLocationUpdatesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.system_location_updates_popover');
};
var $author$project$Insights$System$View$Charts$popOverConfig = F2(
	function (popOverConfigType, translations) {
		var _v0 = function () {
			if (popOverConfigType.$ === 'AccountLocationUpdates') {
				return _Utils_Tuple2(
					'apple-metrics-views-popover',
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Insights$systemLocationUpdatesPopover(translations))
						]));
			} else {
				return _Utils_Tuple2(
					'apple-metrics-actions-popover',
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Insights$systemNetworkUpdatesPopover(translations))
						]));
			}
		}();
		var uid = _v0.a;
		var content = _v0.b;
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: uid,
				tagger: $author$project$Insights$System$Model$OnPopOver(popOverConfigType),
				content: content,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $author$project$Insights$System$Model$AccountNetworkUpdates = {$: 'AccountNetworkUpdates'};
var $author$project$Insights$System$View$Charts$capitalize = function (str) {
	var _v0 = $elm$core$String$uncons(str);
	if (_v0.$ === 'Nothing') {
		return '';
	} else {
		var _v1 = _v0.a;
		var head = _v1.a;
		var tail = _v1.b;
		return A2(
			$elm$core$String$append,
			$elm$core$String$fromChar(
				$elm$core$Char$toUpper(head)),
			tail);
	}
};
var $author$project$Insights$System$View$Charts$orderedNetworks = _List_fromArray(
	[$author$project$Data$Network$Google, $author$project$Data$Network$Facebook, $author$project$Data$Network$Apple, $author$project$Data$Network$Bing]);
var $author$project$Insights$System$View$Charts$getNetworkChartColor = function (network) {
	switch (network.$) {
		case 'Google':
			return '#3399FF';
		case 'Facebook':
			return '#61D173';
		case 'Apple':
			return '#9933FF';
		case 'Bing':
			return '#FDB268';
		default:
			return '#000000';
	}
};
var $author$project$Insights$System$View$Charts$getNetworkUpdatesData = function (accountNetworkUpdates) {
	var networkUpdates = A2(
		$elm$core$List$concatMap,
		function (accountNetworkUpdate) {
			return A2(
				$elm$core$List$map,
				function (networkUpdate) {
					return {date: accountNetworkUpdate.date, network: networkUpdate.network, numberUpdates: networkUpdate.numberUpdates};
				},
				accountNetworkUpdate.networkUpdates);
		},
		accountNetworkUpdates);
	var networks = $author$project$Insights$System$View$Charts$orderedNetworks;
	var dataItemSeries = A2(
		$elm$core$List$map,
		function (network) {
			var networkData = A2(
				$elm$core$List$map,
				function (networkUpdate) {
					return {key: networkUpdate.date, value: networkUpdate.numberUpdates};
				},
				A2(
					$elm$core$List$filter,
					function (networkUpdate) {
						return _Utils_eq(
							networkUpdate.network,
							$elm$core$Maybe$Just(network));
					},
					networkUpdates));
			return {
				data: networkData,
				color: $author$project$Insights$System$View$Charts$getNetworkChartColor(network),
				title: $author$project$Insights$System$View$Charts$capitalize(
					$author$project$Data$Network$toHumanReadable(network))
			};
		},
		networks);
	return A2(
		$elm$core$List$filter,
		function (dataItem) {
			return $elm$core$List$length(dataItem.data) > 0;
		},
		dataItemSeries);
};
var $author$project$Insights$System$View$Charts$getTotalNetworkUpdates = function (accountNetworkUpdates) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (networkUpdate) {
				return networkUpdate.numberUpdates;
			},
			A2(
				$elm$core$List$concatMap,
				function (networkUpdates) {
					return networkUpdates;
				},
				A2(
					$elm$core$List$map,
					function (accountNetworkUpdate) {
						return accountNetworkUpdate.networkUpdates;
					},
					accountNetworkUpdates))));
};
var $author$project$PinMeTo$Ui$Chart$withStackingY = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$View(
		_Utils_update(
			config,
			{withStackingY: true}));
};
var $author$project$PinMeTo$Ui$Chart$withoutGradient = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$View(
		_Utils_update(
			config,
			{withGradient: false}));
};
var $author$project$Insights$Utils$renderYStackedAreaChart = F3(
	function (session, withLegendTotal, datasets) {
		return $author$project$PinMeTo$Ui$Chart$render(
			$author$project$PinMeTo$Ui$Chart$withoutGradient(
				$author$project$PinMeTo$Ui$Chart$withStackingY(
					A2(
						$author$project$PinMeTo$Ui$Chart$withLocale,
						session.locale,
						(withLegendTotal ? $author$project$PinMeTo$Ui$Chart$withLegendConfig($author$project$PinMeTo$Ui$Chart$Legend$withTotal) : $author$project$PinMeTo$Ui$Chart$withLegend)(
							$author$project$PinMeTo$Ui$Chart$view(
								{
									chart: $author$project$PinMeTo$Ui$Chart$Area(datasets)
								}))))));
	});
var $author$project$Translations$Listings$Insights$systemPinmetoNetworkUpdates = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.system_pinmeto_network_updates');
};
var $author$project$Translations$Listings$Insights$systemPinmetoNetworkUpdatesDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.system_pinmeto_network_updates_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$System$View$Charts$renderAccountNetworkUpdates = F3(
	function (session, model, accountNetworkUpdates) {
		var dataItemSeries = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			$author$project$Insights$System$View$Charts$getNetworkUpdatesData(accountNetworkUpdates));
		var chart = A3($author$project$Insights$Utils$renderYStackedAreaChart, session, true, dataItemSeries);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$System$View$Charts$getTotalNetworkUpdates(accountNetworkUpdates)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$System$View$Charts$renderAsides, session, model, 'system-insights-network-updates'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$System$View$Charts$popOverConfig, $author$project$Insights$System$Model$AccountNetworkUpdates, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2(
											$author$project$Translations$Listings$Insights$systemPinmetoNetworkUpdatesDescription,
											session.translations,
											$author$project$Insights$System$Model$getDateLabel(model))),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$systemPinmetoNetworkUpdates(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[chart])))));
	});
var $author$project$Insights$System$View$MetricSection$renderAccountNetworkUpdatesWrapper = F2(
	function (session, model) {
		var _v0 = model.accountNetworkUpdates;
		switch (_v0.$) {
			case 'Suspended':
				return $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations));
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Loaded':
				var accountNetworkUpdates = _v0.a;
				return $elm$core$List$isEmpty(accountNetworkUpdates) ? $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations)) : A3($author$project$Insights$System$View$Charts$renderAccountNetworkUpdates, session, model, accountNetworkUpdates);
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Translations$General$Insights$locationUpdates = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.location_updates');
};
var $author$project$Insights$System$Model$AccountLocationUpdates = {$: 'AccountLocationUpdates'};
var $author$project$Insights$System$View$Charts$getTotalLocationUpdates = function (accountLocationUpdates) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (accountLocationUpdate) {
				return accountLocationUpdate.numberUpdates;
			},
			accountLocationUpdates));
};
var $author$project$Translations$Listings$Insights$systemPinmetoLocationUpdates = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.system_pinmeto_location_updates');
};
var $author$project$Translations$Listings$Insights$systemPinmetoLocationUpdatesDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.system_pinmeto_location_updates_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$System$View$Charts$renderAccountLocationUpdates = F3(
	function (session, model, accountLocationUpdates) {
		var dataItemSeries = A2(
			$elm$core$List$map,
			function (accountLocationUpdate) {
				return {key: accountLocationUpdate.date, value: accountLocationUpdate.numberUpdates};
			},
			accountLocationUpdates);
		var locationUpdatesData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			_List_fromArray(
				[
					{
					data: dataItemSeries,
					color: '#3399FF',
					title: $author$project$Translations$General$Insights$locationUpdates(session.translations)
				}
				]));
		var chart = A3($author$project$Insights$Utils$renderAreaChart, session, true, locationUpdatesData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$System$View$Charts$getTotalLocationUpdates(accountLocationUpdates)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$System$View$Charts$renderAsides, session, model, 'system-insights-location-updates'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$System$View$Charts$popOverConfig, $author$project$Insights$System$Model$AccountLocationUpdates, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2(
											$author$project$Translations$Listings$Insights$systemPinmetoLocationUpdatesDescription,
											session.translations,
											$author$project$Insights$System$Model$getDateLabel(model))),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$systemPinmetoLocationUpdates(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[chart])))));
	});
var $author$project$Insights$System$View$MetricSection$renderAccountLocationUpdatesWrapper = F2(
	function (session, model) {
		var _v0 = model.accountLocationUpdates;
		switch (_v0.$) {
			case 'Suspended':
				return $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations));
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Loaded':
				var accountLocationUpdates = _v0.a;
				return $elm$core$List$isEmpty(accountLocationUpdates) ? $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations)) : A3($author$project$Insights$System$View$Charts$renderAccountLocationUpdates, session, model, accountLocationUpdates);
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Insights$System$View$MetricSection$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$System$View$MetricSection$renderAccountNetworkUpdatesWrapper, session, model),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($author$project$Insights$System$View$MetricSection$renderAccountLocationUpdatesWrapper, session, model)
				]));
	});
var $author$project$Insights$System$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Insights$System$Model$filterQueryString = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (id) {
				return '/' + id;
			},
			model.placeId);
		var filterQuery = '&' + A2(
			$elm$core$String$dropLeft,
			1,
			$author$project$Filter$FilterController$getCurrentFilterAsQueryString(model.filterController));
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var dateRange = model.range;
		var query = '?from=' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('&to=' + ($justinmimbs$date$Date$toIsoString(dateRange.to) + filterQuery)));
		return requestUrl + (siteName + ('/system/locations' + (locationParam + (endpoint + (fileTypeStr + query)))));
	});
var $author$project$Insights$System$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Translations$Listings$Insights$downloadDataSummaryCsv = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_data_summary_csv');
};
var $author$project$Translations$Listings$Insights$downloadDataSummaryXlsx = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_data_summary_xlsx');
};
var $author$project$Insights$System$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2(
				$elm$html$Html$map,
				$author$project$Insights$System$Model$FilterControllerMsg,
				A4($author$project$Filter$FilterController$viewInsights, model.filterController, session.locale, session.translations, session.language)),
			function (_v1) {
				return $elm$html$Html$text('');
			},
			model.placeId);
		var dateRange = model.range;
		var downloadMetricsConf = {
			uid: 'ui-select-download-system-metric',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$System$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/download/'),
					label: $author$project$Translations$Listings$Insights$downloadDataSummaryCsv(session.translations)
				},
					{
					url: A4($author$project$Insights$System$Model$filterQueryString, model, session.siteName, 'xlsx', '/metrics/download/'),
					label: $author$project$Translations$Listings$Insights$downloadDataSummaryXlsx(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
			tagger: $author$project$Insights$System$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('System-Insights_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$System$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A3(
					$author$project$RemoteData$map2,
					F2(
						function (data1, data2) {
							return $elm$core$List$isEmpty(data1) && $elm$core$List$isEmpty(data2);
						}),
					model.accountLocationUpdates,
					model.accountNetworkUpdates),
				$author$project$RemoteData$Loaded(false))
		};
		var downloadMetricsDropdown = A4(
			$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
			$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
			$elm$html$Html$b,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadMetricsConf, model.uiSelect)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					filterControllerHandler,
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
						true,
						$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
							$author$project$Translations$General$Insights$insightsTitle(session.translations)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$DateRangePicker$render,
									model.uiDateRangePicker,
									function () {
										var _v0 = model.lifetime;
										if (_v0.$ === 'Just') {
											var lifetime = _v0.a;
											return $author$project$PinMeTo$Ui$DateRangePicker$withRanges(
												_List_fromArray(
													[
														A3(
														$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
														$author$project$Translations$General$Insights$lifetime(session.translations),
														'Lifetime',
														lifetime)
													]));
										} else {
											return $elm$core$Basics$identity;
										}
									}()(
										$author$project$PinMeTo$Ui$DateRangePicker$view(
											{
												uid: 'system-insights-date-range-picker',
												range: model.range,
												labels: A2($author$project$Labels$uiDateRangePicker, session.translations, session.language),
												locale: session.locale,
												tagger: $author$project$Insights$System$Model$DateRangePickerMsg,
												language: session.language
											})))
								])),
							downloadMetricsDropdown
						])),
					A2($author$project$Insights$System$View$MetricSection$view, session, model)
				]));
	});
var $author$project$Insights$System$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$System$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$System$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$System$Model$GotAccountNetworkUpdates = function (a) {
	return {$: 'GotAccountNetworkUpdates', a: a};
};
var $author$project$Insights$System$Decoders$networkUpdatesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (dict) {
		return $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var network = _v0.a;
					var value = _v0.b;
					return {
						network: $author$project$Data$Network$fromString(network),
						numberUpdates: value
					};
				},
				$elm$core$Dict$toList(dict)));
	},
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$int));
var $author$project$Insights$System$Decoders$accountNetworkUpdateListDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (pairs) {
		return $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var date = _v0.a;
					var networkUpdates = _v0.b;
					return {date: date, networkUpdates: networkUpdates};
				},
				pairs));
	},
	$elm$json$Json$Decode$keyValuePairs($author$project$Insights$System$Decoders$networkUpdatesDecoder));
var $author$project$Insights$System$Commands$getAccountNetworkUpdates = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var dateRange = model.range;
		var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
		var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
		var url = function (urlString) {
			return urlString + (siteName + ('/system/locations/networkChanges?from=' + (from + ('&to=' + to))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$System$Decoders$accountNetworkUpdateListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$System$Model$GotAccountLocationUpdates = function (a) {
	return {$: 'GotAccountLocationUpdates', a: a};
};
var $author$project$Insights$System$Decoders$accountLocationUpdateListDecoder = A2(
	$elm$json$Json$Decode$field,
	'data',
	A2(
		$elm$json$Json$Decode$andThen,
		function (dict) {
			return $elm$json$Json$Decode$succeed(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var date = _v0.a;
						var value = _v0.b;
						return {date: date, numberUpdates: value};
					},
					$elm$core$Dict$toList(dict)));
		},
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int)));
var $author$project$Insights$System$Commands$getAccountLocationUpdates = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var dateRange = model.range;
		var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
		var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
		var url = function (urlString) {
			return urlString + (siteName + ('/system/locations/updated?from=' + (from + ('&to=' + to))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$System$Decoders$accountLocationUpdateListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$System$Main$out_Insights_System_Main_onFilter = _Platform_outgoingPort('out_Insights_System_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$System$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'GotAccountLocationUpdates':
				if (msg.a.$ === 'Ok') {
					var accountLocationUpdates = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								accountLocationUpdates: $author$project$RemoteData$Loaded(accountLocationUpdates)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								accountLocationUpdates: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.System.Main.GotAccountLocationUpdates'),
							error));
				}
			case 'GotAccountNetworkUpdates':
				if (msg.a.$ === 'Ok') {
					var accountNetworkUpdates = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								accountNetworkUpdates: $author$project$RemoteData$Loaded(accountNetworkUpdates)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								accountNetworkUpdates: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.System.Main.GotAccountNetworkUpdates'),
							error));
				}
			case 'OnUrlChange':
				var value = msg.a;
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, value);
				if (_v1.$ === 'Ok') {
					var url = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								baseUrl: $elm$core$Maybe$Just(url)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = _v1.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(e),
								context: 'Insights.System.Main.OnUrlChange',
								message: 'Failed to decode url'
							}));
				}
			case 'DateRangePickerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiDateRangePicker: x});
					},
					A3(
						$author$project$PinMeTo$Ui$DateRangePicker$update,
						{
							tagger: $author$project$Insights$System$Model$DateRangePickerMsg,
							onChange: $author$project$Insights$System$Model$OnDateRangeChange,
							metricsPrefix: $author$project$Common$Metrics$prefix('System Insights')
						},
						msg_,
						model.uiDateRangePicker));
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				var _v2 = A5($author$project$Filter$FilterController$update, $author$project$Insights$System$Model$FilterControllerMsg, msg_, model.filterController, $author$project$Insights$System$Model$OnFilter, $author$project$Insights$System$Model$OnSearch);
				var filterControllerModel_ = _v2.a;
				var filterControllerCmd_ = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filterController: filterControllerModel_}),
					filterControllerCmd_);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						filterDefinition: $elm$core$Maybe$Just(filterDefinition),
						accountLocationUpdates: $author$project$RemoteData$Loading
					});
				var newBatch = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Insights$System$Main$out_Insights_System_Main_onFilter(filterDefinition),
							A3($author$project$Insights$System$Commands$getAccountLocationUpdates, newModel, session.siteName, $author$project$Insights$System$Model$GotAccountLocationUpdates),
							A3($author$project$Insights$System$Commands$getAccountNetworkUpdates, newModel, session.siteName, $author$project$Insights$System$Model$GotAccountNetworkUpdates)
						]));
				return _Utils_Tuple2(newModel, newBatch);
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnDownloadLabelClicked':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnDateRangeChange':
				var range = msg.a;
				var onRangeChange = $author$project$Insights$System$Main$out_Insights_System_Main_onRangeChange(
					$author$project$Insights$Utils$encodeDateRange(range));
				var newModel_ = _Utils_update(
					model,
					{range: range, accountNetworkUpdates: $author$project$RemoteData$Loading, accountLocationUpdates: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel_,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Insights$System$Commands$getAccountLocationUpdates, newModel_, session.siteName, $author$project$Insights$System$Model$GotAccountLocationUpdates),
								A3($author$project$Insights$System$Commands$getAccountNetworkUpdates, newModel_, session.siteName, $author$project$Insights$System$Model$GotAccountNetworkUpdates),
								onRangeChange
							])));
			case 'OnPopOver':
				var popOverConfigType = msg.a;
				var msg_ = msg.b;
				var _v3 = A3(
					$author$project$PinMeTo$Ui$PopOver$update,
					$author$project$Insights$System$Model$OnPopOver(popOverConfigType),
					msg_,
					model.popOverState);
				var newState = _v3.a;
				var cmd_ = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newState}),
					cmd_);
			case 'UiFeedbackMsg':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$System$Model$UiSelectMsg, msg_, model.uiSelect));
			default:
				if (msg.a.$ === 'Ok') {
					var supportedDateRange = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							lifetime: $elm$core$Maybe$Just(supportedDateRange)
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.System.Main.GotSupportedDateRange'),
							error));
				}
		}
	});
var $author$project$Insights$System$Model$Flags = function (siteName) {
	return function (today) {
		return function (dateRange) {
			return function (insightsUrl) {
				return function (baseUrl) {
					return function (locale) {
						return function (translations) {
							return function (language) {
								return function (initialFilter) {
									return function (url) {
										return function (timezoneOffset) {
											return function (locationId) {
												return {url: url, today: today, locale: locale, baseUrl: baseUrl, language: language, siteName: siteName, dateRange: dateRange, locationId: locationId, insightsUrl: insightsUrl, translations: translations, initialFilter: initialFilter, timezoneOffset: timezoneOffset};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$System$Decoders$dateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$System$Decoders$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'placeId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timezoneOffset',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'url',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'initialFilter',
				$elm$json$Json$Decode$nullable(
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'language',
					$author$project$PinMeTo$Ui$I18n$Language$decoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'translations',
						$author$project$Common$Language$translationsDecoder,
						$author$project$Common$Language$initialTranslationsFallback,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['user', 'settings', 'locale']),
							$author$project$PinMeTo$Ui$I18n$Locale$decoder,
							$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'baseUrl',
								$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'insightsUrl',
									$elm_community$json_extra$Json$Decode$Extra$url,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'dateRange',
										$elm$json$Json$Decode$nullable($author$project$Insights$System$Decoders$dateRangeDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'today',
											$elm_community$json_extra$Json$Decode$Extra$datetime,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'siteName',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Insights$System$Model$Flags)))))))))))));
var $author$project$Insights$System$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$System$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$System$Model$OnUrlChange)
			]));
};
var $author$project$Insights$System$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$System$Main$init, view: $author$project$Insights$System$View$view, update: $author$project$Insights$System$Main$update, flagsDecoder: $author$project$Insights$System$Decoders$flagsDecoder, subscriptions: $author$project$Insights$System$Main$subscriptions});
var $author$project$Insights$Rating$Model$Top = {$: 'Top'};
var $author$project$Insights$Rating$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Insights$Rating$Decoders$supportedDateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxDate',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minDate',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$Rating$Commands$getSupportedDateRange = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = function (u) {
			return u + (siteName + '/rating/metrics/supportedDateRange');
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Rating$Decoders$supportedDateRangeDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$PinMeTo$Common$Tour$Tour$LeftStart = {$: 'LeftStart'};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsConfirm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.ratings_confirm');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsTitleStepOne = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.ratings_title_step_one');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsTitleStepTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.ratings_title_step_two');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsDescriptionStepOne = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.ratings_description_step_one');
};
var $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsDescriptionStepTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.insights_redesign_tour.ratings_description_step_two');
};
var $author$project$Tours$InsightsRedesign$insightsRedesignTourRatings = function (translations) {
	return {
		id: 'insights-redesign-ratings',
		steps: _List_fromArray(
			[
				{
				arrow: true,
				title: $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsTitleStepOne(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$RightStart,
				description: $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsDescriptionStepOne(translations),
				targetElementQuery: '.pmt-ui-navigation__item--current'
			},
				{
				arrow: true,
				title: $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsTitleStepTwo(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$LeftStart,
				description: $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsDescriptionStepTwo(translations),
				targetElementQuery: '.ui-insights-header__header:has(.pmt-insights__ui-performance-asides) > h1'
			}
			]),
		endDate: $author$project$Tours$InsightsRedesign$endDate,
		startDate: $author$project$Tours$InsightsRedesign$startDate,
		useModalOverlay: false,
		confirmButtonUrl: $elm$core$Maybe$Nothing,
		requiresTourSeen: $elm$core$Maybe$Nothing,
		showStepProgress: true,
		confirmButtonLabel: $author$project$Translations$Listings$Tour$InsightsRedesignTour$ratingsConfirm(translations),
		requiresTourNotSeen: $elm$core$Maybe$Nothing
	};
};
var $author$project$Insights$Rating$Model$OnSupportedDateRangeResponse = function (a) {
	return {$: 'OnSupportedDateRangeResponse', a: a};
};
var $author$project$Insights$Rating$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var defaultInitDateRange = A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 30);
		var timezone = A2($elm$time$Time$customZone, flags.timezoneOffset, _List_Nil);
		var tourCmd = (!session.user.isDemo) ? A2(
			$author$project$PinMeTo$Common$Tour$Tour$startTour,
			$author$project$Labels$tourLabels(session.translations),
			$author$project$Tours$InsightsRedesign$insightsRedesignTourRatings(session.translations)) : $elm$core$Platform$Cmd$none;
		var model = {
			range: A2($elm$core$Maybe$withDefault, defaultInitDateRange, flags.dateRange),
			today: flags.today,
			baseUrl: flags.url,
			reviews: $author$project$RemoteData$Loading,
			topList: $author$project$RemoteData$Loading,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			lifetime: $elm$core$Maybe$Nothing,
			timezone: timezone,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			locationId: flags.locationId,
			uiFeedback: $author$project$Listings$Ui$Feedback$init,
			insightsUrl: flags.insightsUrl,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			initialFilter: flags.initialFilter,
			performanceType: $author$project$Insights$Rating$Model$Top,
			filterController: $elm$core$Maybe$Just(filterControllerModel_),
			filterDefinition: $elm$core$Maybe$Nothing,
			performanceLists: $author$project$RemoteData$Loading,
			performanceTable: $author$project$PinMeTo$Ui$Table$init,
			uiDateRangePicker: $elm$core$Maybe$Nothing,
			detailedRatingStats: $author$project$RemoteData$Loading,
			topListAmountToShow: 5,
			performanceSelectState: $author$project$PinMeTo$Ui$Select$init,
			lifetimeDetailedRatingStats: $author$project$RemoteData$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Insights$Rating$Commands$getSupportedDateRange, model, session.siteName, $author$project$Insights$Rating$Model$OnSupportedDateRangeResponse),
						tourCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Rating$Model$FilterControllerMsg, filterControllerCmd_)
					])));
	});
var $author$project$Insights$Rating$Model$Bottom = {$: 'Bottom'};
var $author$project$Insights$Rating$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Insights$Rating$View$UiFeedback$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: '',
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Rating$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$FontAwesome$Light$Icon$faAngleDown = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-angle-down');
var $author$project$Insights$Rating$Model$OnPopOver = F2(
	function (a, b) {
		return {$: 'OnPopOver', a: a, b: b};
	});
var $author$project$Translations$Listings$Insights$ratingTopListPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_top_list_popover');
};
var $author$project$Translations$Listings$Insights$ratingReviewsPopoverEnabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_popover_enabled');
};
var $author$project$Translations$Listings$Insights$ratingReviewsPopoverDisabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_popover_disabled');
};
var $author$project$Translations$Listings$Insights$ratingPerformancePopoverFirst = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_performance_popover_first');
};
var $author$project$Translations$Listings$Insights$ratingDistributionPopoverFirst = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_distribution_popover_first');
};
var $author$project$Translations$Listings$Insights$ratingPerformancePopoverSecond = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_performance_popover_second');
};
var $author$project$Translations$Listings$Insights$ratingResponseRatePopoverFirst = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_response_rate_popover_first');
};
var $author$project$Translations$Listings$Insights$ratingReviewsPopoverCtaEnabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_popover_cta_enabled');
};
var $author$project$Translations$Listings$Insights$ratingDistributionPopoverSecond = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_distribution_popover_second');
};
var $author$project$Translations$Listings$Insights$ratingResponseRatePopoverSecond = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_response_rate_popover_second');
};
var $author$project$Translations$Listings$Insights$ratingReviewsPopoverCtaDisabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_popover_cta_disabled');
};
var $author$project$Translations$Listings$Insights$ratingReviewsPopoverPromoEnabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_popover_promo_enabled');
};
var $author$project$Translations$Listings$Insights$ratingReviewsPopoverPromoDisabled = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_popover_promo_disabled');
};
var $author$project$Insights$Rating$View$PopOverConfig$popOverConfig = F2(
	function (session, popOverConfigType) {
		var getReviewsLink = '/listen-and-respond/' + $author$project$Data$SiteName$toString(session.siteName);
		var translations = session.translations;
		var hasReviews = _Utils_eq(session.products.listenAndRespond.availability, $author$project$PinMeToPage$ProductEnabled);
		var ratingPromo = hasReviews ? $author$project$Translations$Listings$Insights$ratingReviewsPopoverPromoEnabled(translations) : $author$project$Translations$Listings$Insights$ratingReviewsPopoverPromoDisabled(translations);
		var ratingPopover = hasReviews ? $author$project$Translations$Listings$Insights$ratingReviewsPopoverEnabled(translations) : $author$project$Translations$Listings$Insights$ratingReviewsPopoverDisabled(translations);
		var ratingReviewCta = hasReviews ? $author$project$Translations$Listings$Insights$ratingReviewsPopoverCtaEnabled(translations) : $author$project$Translations$Listings$Insights$ratingReviewsPopoverCtaDisabled(translations);
		var _v0 = function () {
			switch (popOverConfigType.$) {
				case 'RatingDistribution':
					return _Utils_Tuple2(
						'rating-metrics-rating-distribution-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingDistributionPopoverFirst(translations)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingDistributionPopoverSecond(translations))
							]));
				case 'ResponseRate':
					return _Utils_Tuple2(
						'rating-metrics-response-rate-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingResponseRatePopoverFirst(translations)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingResponseRatePopoverSecond(translations))
							]));
				case 'Reviews':
					return _Utils_Tuple2(
						'rating-metrics-reviews-popover',
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(ratingPopover),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(ratingPromo),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(getReviewsLink)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(ratingReviewCta)
											]))
									]))
							]));
				case 'PerformanceRanking':
					return _Utils_Tuple2(
						'rating-metrics-performance-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingPerformancePopoverFirst(translations)),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingPerformancePopoverSecond(translations))
							]));
				default:
					return _Utils_Tuple2(
						'rating-metrics-top-locations-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$ratingTopListPopover(translations))
							]));
			}
		}();
		var uid = _v0.a;
		var content = _v0.b;
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: uid,
				tagger: $author$project$Insights$Rating$Model$OnPopOver(popOverConfigType),
				content: content,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $author$project$Insights$Rating$Model$PerformanceRanking = {$: 'PerformanceRanking'};
var $author$project$Translations$Listings$Insights$ratingPerformanceTop = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_performance_top');
};
var $author$project$Translations$Listings$Insights$ratingPerformanceNote = F2(
	function (translations, totalLocations) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.rating_performance_note',
			_List_fromArray(
				[
					_Utils_Tuple2(' totalLocations ', totalLocations)
				]));
	});
var $author$project$Translations$Listings$Insights$ratingPerformanceEmptyStateNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_performance_empty_state_note');
};
var $author$project$Insights$Rating$View$PerformanceTable$renderPerformanceList = F2(
	function (session, model) {
		var getSiteNameString = function (_v2) {
			var name = _v2.a;
			return name;
		};
		var siteName = getSiteNameString(session.siteName);
		var renderList = function (lists) {
			var createRowLink = function (location) {
				return '/listings/' + (siteName + ('/locations/' + (location.locationId + '/details')));
			};
			var renderItem = function (item) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-insights__performance-item')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__performance-item--rank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(item.score))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__performance-item--location')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-insights__performance-item--location__identifier')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(item.displayName)
														])),
													$elm$html$Html$text(' ('),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(
															createRowLink(item)),
															$elm$html$Html$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(item.storeId)
														])),
													$elm$html$Html$text(')')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-insights__performance-item--location__metrics')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-insights__performance-item--location__metrics--rating')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($myrho$elm_round$Round$round, 2, item.rating)),
															A2(
															$author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage,
															function (_v1) {
																return '';
															},
															item.rating)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-insights__performance-item--location__metrics--review')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.insights.rating_performance_reviews_counter', item.reviews))
														]))
												]))
										]))
								]))
						]));
			};
			var items = _Utils_eq(model.performanceType, $author$project$Insights$Rating$Model$Bottom) ? lists.bottom : lists.top;
			var content = A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($elm$core$List$map, renderItem, items));
			return content;
		};
		var _v0 = model.performanceLists;
		switch (_v0.$) {
			case 'Suspended':
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('suspended')
						]));
			case 'Error':
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
			case 'Loading':
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			default:
				var items = _v0.a;
				return $elm$core$List$isEmpty(items.top) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__alert-container')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Alert$render(
							A2(
								$author$project$PinMeTo$Ui$Alert$withStatus,
								$author$project$PinMeTo$Ui$Alert$Note,
								$author$project$PinMeTo$Ui$Alert$rich(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Insights$ratingPerformanceEmptyStateNote(session.translations))
										]))))
						])) : renderList(items);
		}
	});
var $author$project$Insights$Rating$Model$OnPerformanceSelectMsg = function (a) {
	return {$: 'OnPerformanceSelectMsg', a: a};
};
var $author$project$Translations$Listings$Insights$ratingPerformanceTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_performance_title');
};
var $author$project$Translations$Listings$Insights$ratingPerformanceBottom = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_performance_bottom');
};
var $author$project$Insights$Rating$Model$OnPerformanceTypeChanged = function (a) {
	return {$: 'OnPerformanceTypeChanged', a: a};
};
var $author$project$Insights$Rating$View$PerformanceTable$view = F3(
	function (skeletonCard, session, model) {
		var performanceSelect = function () {
			var toText = function (value) {
				if (value.$ === 'Bottom') {
					return $author$project$Translations$Listings$Insights$ratingPerformanceBottom(session.translations);
				} else {
					return $author$project$Translations$Listings$Insights$ratingPerformanceTop(session.translations);
				}
			};
			var config = {
				uid: 'performance-table-uid',
				items: _List_fromArray(
					[$author$project$Insights$Rating$Model$Top, $author$project$Insights$Rating$Model$Bottom]),
				tagger: $author$project$Insights$Rating$Model$OnPerformanceSelectMsg,
				onChange: function (newValue) {
					return $author$project$Insights$Rating$Model$OnPerformanceTypeChanged(newValue);
				},
				itemRender: function (item) {
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-ui-font-body')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								toText(item))
							]));
				}
			};
			var icon = $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faAngleDown);
			return A2(
				$author$project$PinMeTo$Ui$Select$render,
				model.performanceSelectState,
				A2(
					$author$project$PinMeTo$Ui$Select$viewWithToggle,
					config,
					A2(
						$author$project$PinMeTo$Ui$Select$uiButtonToggleWithIconAfter,
						icon,
						A2(
							$author$project$PinMeTo$Ui$Select$uiButtonToggleWithButtonStyle,
							$author$project$PinMeTo$Ui$Button$Outlined($author$project$PinMeTo$Ui$Button$OutlinedNeutral),
							$author$project$PinMeTo$Ui$Select$uiButtonToggle(
								toText(model.performanceType))))));
		}();
		var skellify = function (child) {
			return $author$project$PinMeTo$Ui$Skeleton$view(
				{
					shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
					children: _List_fromArray(
						[child]),
					isLoading: _Utils_eq(model.performanceLists, $author$project$RemoteData$Loading),
					attributes: _List_Nil
				});
		};
		var popOver = A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$PerformanceRanking);
		var asides = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__ui-performance-asides')
				]),
			_List_fromArray(
				[
					performanceSelect,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
						]),
					_List_fromArray(
						[
							A3($author$project$Insights$Rating$View$UiFeedback$uiFeedback, session.translations, 'performance-table-id', model.uiFeedback)
						]))
				]));
		var title = $author$project$Translations$Listings$Insights$ratingPerformanceTitle(session.translations);
		var note = $elm$html$Html$text(
			A2(
				$author$project$Translations$Listings$Insights$ratingPerformanceNote,
				session.translations,
				$elm$core$String$fromInt(
					A2(
						$author$project$RemoteData$withDefault,
						0,
						A2(
							$author$project$RemoteData$map,
							function ($) {
								return $.count;
							},
							model.performanceLists)))));
		var _v0 = model.performanceLists;
		if (_v0.$ === 'Loading') {
			return skeletonCard;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__ui-performance-container')
					]),
				_List_fromArray(
					[
						$author$project$Listings$Ui$InsightsHeader$render(
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							asides,
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(popOver, model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									skellify(note),
									$author$project$Listings$Ui$InsightsHeader$view(
										{title: title}))))),
						A2($author$project$Insights$Rating$View$PerformanceTable$renderPerformanceList, session, model)
					]));
		}
	});
var $author$project$Listings$Ui$InsightsHeader$withIcon = F2(
	function (icon, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					icon: $elm$core$Maybe$Just(icon)
				}));
	});
var $author$project$Insights$Rating$View$MetricSection$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: '',
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Rating$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Insights$Rating$Model$ResponseRate = {$: 'ResponseRate'};
var $author$project$PinMeTo$Ui$Chart$Doughnut = function (a) {
	return {$: 'Doughnut', a: a};
};
var $author$project$PinMeTo$Ui$Chart$Legend$PositionRight = {$: 'PositionRight'};
var $author$project$PinMeTo$Ui$Chart$Legend$withPositionRight = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$Legend$Legend(
		_Utils_update(
			config,
			{position: $author$project$PinMeTo$Ui$Chart$Legend$PositionRight}));
};
var $author$project$Insights$Rating$View$MetricSection$renderDonutChart = F2(
	function (session, datasets) {
		return $author$project$PinMeTo$Ui$Chart$render(
			A2(
				$author$project$PinMeTo$Ui$Chart$withLocale,
				session.locale,
				A2(
					$author$project$PinMeTo$Ui$Chart$withLegendConfig,
					A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Chart$Legend$withTotal, $author$project$PinMeTo$Ui$Chart$Legend$withPositionRight),
					$author$project$PinMeTo$Ui$Chart$view(
						{
							chart: $author$project$PinMeTo$Ui$Chart$Doughnut(datasets)
						}))));
	});
var $author$project$Insights$Rating$View$MetricSection$renderSkeletonCard = F3(
	function (session, isLoading, shimmer) {
		var chart = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__chart'),
					$elm$html$Html$Attributes$class('pmt-insights__chart--doughnut-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Insights$Rating$View$MetricSection$renderDonutChart,
					session,
					_List_fromArray(
						[
							{data: 0, color: '', title: ''}
						]))
				]));
		var config = {
			shimmer: shimmer,
			children: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Card$render(
							A2(
								$author$project$PinMeTo$Ui$Card$withHeader,
								$author$project$Listings$Ui$InsightsHeader$render(
									A2(
										$author$project$Listings$Ui$InsightsHeader$withAsides,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
												]),
											_List_Nil),
										A2(
											$author$project$Listings$Ui$InsightsHeader$withNumber,
											'0',
											$author$project$Listings$Ui$InsightsHeader$view(
												{title: 'title'})))),
								$author$project$PinMeTo$Ui$Card$view(chart)))
						]))
				]),
			isLoading: isLoading,
			attributes: _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'border-radius', 'var(--radius-lg)'),
					A2($elm$html$Html$Attributes$style, 'height', '100%')
				])
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--item__full-height')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Skeleton$view(config)
				]));
	});
var $author$project$Listings$Ui$InsightsHeader$withLifetimeNumber = F3(
	function (number, lifetimeLabel, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					lifetimeNumber: $elm$core$Maybe$Just(
						{value: number, lifetimeLabel: lifetimeLabel})
				}));
	});
var $author$project$Translations$Listings$Insights$ratingReviewsAnswered = F3(
	function (translations, responseCount, reviewCount) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.rating_reviews_answered',
			_List_fromArray(
				[
					_Utils_Tuple2('- responseCount ', responseCount),
					_Utils_Tuple2('- reviewCount ', reviewCount)
				]));
	});
var $author$project$Translations$Listings$Insights$ratingResponseRateAnswered = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_response_rate_answered');
};
var $author$project$Translations$Listings$Insights$ratingResponseRateUnanswered = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_response_rate_unanswered');
};
var $author$project$Insights$Rating$View$MetricSection$renderResponseRate = F2(
	function (session, model) {
		var _v0 = model.detailedRatingStats;
		if (_v0.$ === 'Loaded') {
			var detailedRatingStats = _v0.a;
			var calculateResponseRate = F2(
				function (answered, total) {
					return (answered / ((!total) ? 1 : total)) * 100;
				});
			var notConnectedHeader = function () {
				var siteName = $author$project$Data$SiteName$toString(session.siteName);
				var directoriesLink = '/listings/' + (siteName + '/directories');
				return $author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNote,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Insights$overviewNetworkNotEnabledNote(session.translations)),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(directoriesLink)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' Google ')
												]))
										])),
									$elm$html$Html$text(
									$author$project$Translations$Listings$Insights$or(session.translations)),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(directoriesLink)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' Trustpilot')
												]))
										]))
								])),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withIcon,
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCloudXmark),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
										]),
									_List_fromArray(
										[
											A3($author$project$Insights$Rating$View$MetricSection$uiFeedback, session.translations, 'rating-response-rate', model.uiFeedback)
										])),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(
										A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$ResponseRate),
										model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$responseRate(session.translations)
										}))))));
			}();
			var totalReviews = function (detailedRatingStats_) {
				return detailedRatingStats_.answeredCount + detailedRatingStats_.unAnsweredCount;
			};
			var responseRateStr = function (detailedRatingStats_) {
				return function (x) {
					return x + '%';
				}(
					A2(
						$myrho$elm_round$Round$round,
						1,
						A2(
							calculateResponseRate,
							detailedRatingStats_.answeredCount,
							totalReviews(detailedRatingStats_))));
			};
			var lifetimeResponseRate = A2(
				$elm$core$Maybe$map,
				responseRateStr,
				$author$project$RemoteData$currentData(model.lifetimeDetailedRatingStats));
			var responseRateNote = $elm$html$Html$text(
				A3(
					$author$project$Translations$Listings$Insights$ratingReviewsAnswered,
					session.translations,
					$author$project$Common$Math$formatNumber(detailedRatingStats.answeredCount),
					$author$project$Common$Math$formatNumber(
						totalReviews(detailedRatingStats))));
			var isConnected = _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled) || _Utils_eq(session.analytics.trustpilot, $author$project$PinMeToPage$NetworkEnabled);
			var datasets = _List_fromArray(
				[
					{
					data: detailedRatingStats.answeredCount,
					color: '#33CD32',
					title: $author$project$Translations$Listings$Insights$ratingResponseRateAnswered(session.translations)
				},
					{
					data: detailedRatingStats.unAnsweredCount,
					color: '#C7C7C7',
					title: $author$project$Translations$Listings$Insights$ratingResponseRateUnanswered(session.translations)
				}
				]);
			var header = $author$project$Listings$Ui$InsightsHeader$render(
				A2(
					$author$project$Listings$Ui$InsightsHeader$withNote,
					responseRateNote,
					A3(
						$elm$core$Basics$apR,
						A2(
							$elm$core$Maybe$map,
							function (lifetimeResponseRate_) {
								return A2($author$project$Listings$Ui$InsightsHeader$withLifetimeNumber, lifetimeResponseRate_, 'lifetime');
							},
							lifetimeResponseRate),
						$elm$core$Maybe$withDefault($elm$core$Basics$identity),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withNumber,
							responseRateStr(detailedRatingStats),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
										]),
									_List_fromArray(
										[
											A3($author$project$Insights$Rating$View$MetricSection$uiFeedback, session.translations, 'rating-response-rate', model.uiFeedback)
										])),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(
										A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$ResponseRate),
										model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$responseRate(session.translations)
										})))))));
			var chart = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__chart'),
						$elm$html$Html$Attributes$class('pmt-insights__chart--doughnut-container')
					]),
				_List_fromArray(
					[
						A2($author$project$Insights$Rating$View$MetricSection$renderDonutChart, session, datasets)
					]));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__highlight--item__full-height')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Card$render(
						A2(
							$author$project$PinMeTo$Ui$Card$withHeader,
							isConnected ? header : notConnectedHeader,
							$author$project$PinMeTo$Ui$Card$view(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__chart')
										]),
									_List_fromArray(
										[chart])))))
					]));
		} else {
			return A3($author$project$Insights$Rating$View$MetricSection$renderSkeletonCard, session, true, $author$project$PinMeTo$Ui$Skeleton$Gradient);
		}
	});
var $author$project$Translations$Listings$Insights$reply = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.reply');
};
var $author$project$Insights$Rating$Model$Reviews = {$: 'Reviews'};
var $author$project$Translations$Listings$Insights$googleReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_review');
};
var $author$project$Translations$Listings$Insights$ratingRecentReviewsNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_recent_reviews_note');
};
var $author$project$Translations$Listings$Insights$ratingRecentReviewsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_recent_reviews_title');
};
var $author$project$Translations$Listings$Insights$ratingReviewsEmptyStateNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_reviews_empty_state_note');
};
var $author$project$Insights$Rating$View$MetricSection$renderReviewsSection = F2(
	function (session, model) {
		var _v0 = model.reviews;
		switch (_v0.$) {
			case 'Loaded':
				var reviews = _v0.a;
				var isEmptyState = $elm$core$List$isEmpty(reviews);
				var starRating = function (review) {
					return A2(
						$author$project$PinMeTo$Ui$Insights$Rating$starRatingAverage,
						function (_v2) {
							return '';
						},
						review.rating);
				};
				var reviewDate = function (review) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__review--date-container')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Date$render(
								A2(
									$author$project$PinMeTo$Ui$Date$withFormat,
									$author$project$PinMeTo$Ui$Date$FormatDate,
									A2(
										$author$project$PinMeTo$Ui$Date$string,
										session.locale,
										$justinmimbs$date$Date$toIsoString(review.createTime))))
							]));
				};
				var renderReviewWithDivider = F2(
					function (index, review) {
						var reviewElement = A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-insights__review')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__review--star-rating')
										]),
									_List_fromArray(
										[
											starRating(review),
											reviewDate(review)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__review--comment')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(review.comment)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__review--footer')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-insights__review--network')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$Insights$googleReview(session.translations))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-insights__review--button-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$target('_blank'),
															$elm$html$Html$Attributes$href(
															'/listen-and-respond/' + ($author$project$Data$SiteName$toString(session.siteName) + A3(
																$elm_community$maybe_extra$Maybe$Extra$unpack,
																function (_v1) {
																	return '';
																},
																function (id) {
																	return '/inbox/' + id;
																},
																review.id))),
															$elm$html$Html$Attributes$class('pmt-ui-button pmt-ui-button--small pmt-ui-button--secondary'),
															A2($elm$html$Html$Attributes$attribute, 'data-pmt-event', 'listings-ratings-page-clicked-reply')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Insights$reply(session.translations))
														]))
												]))
										]))
								]));
						return _Utils_eq(
							index,
							$elm$core$List$length(reviews) - 1) ? _List_fromArray(
							[reviewElement]) : _List_fromArray(
							[
								reviewElement,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-insights__divider')
									]),
								_List_Nil)
							]);
					});
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-insights__ui-performance-container')
								]),
							_List_fromArray(
								[
									$author$project$Listings$Ui$InsightsHeader$render(
									A2(
										$author$project$Listings$Ui$InsightsHeader$withAsides,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
												]),
											_List_fromArray(
												[
													A3($author$project$Insights$Rating$View$MetricSection$uiFeedback, session.translations, 'rating-reviews', model.uiFeedback)
												])),
										A2(
											$author$project$Listings$Ui$InsightsHeader$withPopOver,
											_Utils_Tuple2(
												A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$Reviews),
												model.popOverState),
											A2(
												$author$project$Listings$Ui$InsightsHeader$withNote,
												$elm$html$Html$text(
													$author$project$Translations$Listings$Insights$ratingRecentReviewsNote(session.translations)),
												$author$project$Listings$Ui$InsightsHeader$view(
													{
														title: $author$project$Translations$Listings$Insights$ratingRecentReviewsTitle(session.translations)
													}))))),
									isEmptyState ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__alert-container')
										]),
									_List_fromArray(
										[
											$author$project$PinMeTo$Ui$Alert$render(
											A2(
												$author$project$PinMeTo$Ui$Alert$withStatus,
												$author$project$PinMeTo$Ui$Alert$Note,
												$author$project$PinMeTo$Ui$Alert$rich(
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Insights$ratingReviewsEmptyStateNote(session.translations))
														]))))
										])) : A2(
									$elm$html$Html$div,
									_List_Nil,
									$elm$core$List$concat(
										A2($elm$core$List$indexedMap, renderReviewWithDivider, reviews)))
								]))
						]));
			case 'Loading':
				return A3($author$project$Insights$Rating$View$MetricSection$renderSkeletonCard, session, true, $author$project$PinMeTo$Ui$Skeleton$Gradient);
			case 'Suspended':
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('suspended')
						]));
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Translations$Listings$Insights$stars = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.stars');
};
var $author$project$Listings$Ui$InsightsHeader$withStarRating = F3(
	function (toString, rating, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{
					starRating: $elm$core$Maybe$Just(
						{rating: rating, toString: toString})
				}));
	});
var $author$project$Insights$Rating$Model$RatingDistribution = {$: 'RatingDistribution'};
var $author$project$Translations$Listings$Insights$ratingDistributionNote = F2(
	function (translations, totalReviews) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.rating_distribution_note',
			_List_fromArray(
				[
					_Utils_Tuple2('- totalReviews', totalReviews)
				]));
	});
var $author$project$Translations$Listings$Insights$ratingDistributionTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_distribution_title');
};
var $author$project$Insights$Rating$View$MetricSection$renderRatingDistribution = F2(
	function (session, model) {
		var _v0 = model.detailedRatingStats;
		if (_v0.$ === 'Loaded') {
			var detailedRatingStats = _v0.a;
			var notConnectedHeader = function () {
				var siteName = $author$project$Data$SiteName$toString(session.siteName);
				var directoriesLink = '/listings/' + (siteName + '/directories');
				return $author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNote,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Insights$overviewNetworkNotEnabledNote(session.translations)),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(directoriesLink)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' Google ')
												]))
										])),
									$elm$html$Html$text(
									$author$project$Translations$Listings$Insights$or(session.translations)),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(directoriesLink)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' Trustpilot')
												]))
										]))
								])),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withIcon,
							$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCloudXmark),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
										]),
									_List_fromArray(
										[
											A3($author$project$Insights$Rating$View$MetricSection$uiFeedback, session.translations, 'rating-rating-distribution', model.uiFeedback)
										])),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(
										A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$RatingDistribution),
										model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$ratingDistributionTitle(session.translations)
										}))))));
			}();
			var totalRatings = function (detailedRatingStats_) {
				return (((detailedRatingStats_.oneStar + detailedRatingStats_.twoStar) + detailedRatingStats_.threeStar) + detailedRatingStats_.fourStar) + detailedRatingStats_.fiveStar;
			};
			var summedRating = function (detailedRatingStats_) {
				return ((((detailedRatingStats_.oneStar * 1) + (detailedRatingStats_.twoStar * 2)) + (detailedRatingStats_.threeStar * 3)) + (detailedRatingStats_.fourStar * 4)) + (detailedRatingStats_.fiveStar * 5);
			};
			var calculateAverageRating = function (detailedRatingStats_) {
				return summedRating(detailedRatingStats_) / totalRatings(detailedRatingStats_);
			};
			var averageRating = calculateAverageRating(detailedRatingStats);
			var lifetimeAverageRating = A2(
				$elm$core$Maybe$andThen,
				function (lifetimeDetailedRatingStats) {
					var average = calculateAverageRating(lifetimeDetailedRatingStats);
					return $elm$core$Basics$isNaN(average) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2($myrho$elm_round$Round$round, 2, average));
				},
				$author$project$RemoteData$currentData(model.lifetimeDetailedRatingStats));
			var starRatingHeader = $author$project$Listings$Ui$InsightsHeader$render(
				A3(
					$elm$core$Basics$apR,
					$elm$html$Html$text(
						A2(
							$author$project$Translations$Listings$Insights$ratingDistributionNote,
							session.translations,
							$author$project$Common$Math$formatNumber(
								totalRatings(detailedRatingStats)))),
					$author$project$Listings$Ui$InsightsHeader$withNote,
					A3(
						$elm$core$Basics$apR,
						A2(
							$elm$core$Maybe$map,
							function (lifetimeAverageRating_) {
								return A2($author$project$Listings$Ui$InsightsHeader$withLifetimeNumber, lifetimeAverageRating_, 'lifetime');
							},
							lifetimeAverageRating),
						$elm$core$Maybe$withDefault($elm$core$Basics$identity),
						A3(
							$author$project$Listings$Ui$InsightsHeader$withStarRating,
							$elm$core$Basics$isNaN(averageRating) ? function (_v1) {
								return ' - ';
							} : $myrho$elm_round$Round$round(2),
							averageRating,
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
										]),
									_List_fromArray(
										[
											A3($author$project$Insights$Rating$View$MetricSection$uiFeedback, session.translations, 'rating-rating-distribution', model.uiFeedback)
										])),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withPopOver,
									_Utils_Tuple2(
										A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$RatingDistribution),
										model.popOverState),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$ratingDistributionTitle(session.translations)
										})))))));
			var isConnected = _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled) || _Utils_eq(session.analytics.trustpilot, $author$project$PinMeToPage$NetworkEnabled);
			var datasets = _List_fromArray(
				[
					{
					data: detailedRatingStats.fiveStar,
					color: '#33CD32',
					title: '5 ' + $author$project$Translations$Listings$Insights$stars(session.translations)
				},
					{
					data: detailedRatingStats.fourStar,
					color: '#9ACD31',
					title: '4 ' + $author$project$Translations$Listings$Insights$stars(session.translations)
				},
					{
					data: detailedRatingStats.threeStar,
					color: '#FFD800',
					title: '3 ' + $author$project$Translations$Listings$Insights$stars(session.translations)
				},
					{
					data: detailedRatingStats.twoStar,
					color: '#FF8C00',
					title: '2 ' + $author$project$Translations$Listings$Insights$stars(session.translations)
				},
					{
					data: detailedRatingStats.oneStar,
					color: '#DB0037',
					title: '1 ' + $author$project$Translations$Listings$Insights$stars(session.translations)
				}
				]);
			var chart = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__chart'),
						$elm$html$Html$Attributes$class('pmt-insights__chart--doughnut-container')
					]),
				_List_fromArray(
					[
						A2($author$project$Insights$Rating$View$MetricSection$renderDonutChart, session, datasets)
					]));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__highlight--item')
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Card$render(
						A2(
							$author$project$PinMeTo$Ui$Card$withHeader,
							isConnected ? starRatingHeader : notConnectedHeader,
							$author$project$PinMeTo$Ui$Card$view(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-insights__chart')
										]),
									_List_fromArray(
										[chart])))))
					]));
		} else {
			return A3($author$project$Insights$Rating$View$MetricSection$renderSkeletonCard, session, true, $author$project$PinMeTo$Ui$Skeleton$Gradient);
		}
	});
var $author$project$Insights$Rating$View$MetricSection$view = F2(
	function (session, model) {
		var skeletonCard = A3($author$project$Insights$Rating$View$MetricSection$renderSkeletonCard, session, true, $author$project$PinMeTo$Ui$Skeleton$Gradient);
		var items = _List_fromArray(
			[
				A2($author$project$Insights$Rating$View$MetricSection$renderRatingDistribution, session, model),
				A3($author$project$Insights$Rating$View$PerformanceTable$view, skeletonCard, session, model),
				A2($author$project$Insights$Rating$View$MetricSection$renderReviewsSection, session, model),
				A2($author$project$Insights$Rating$View$MetricSection$renderResponseRate, session, model)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__rating-metric-section-container')
				]),
			items);
	});
var $author$project$Insights$Rating$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Insights$Rating$Model$TopLocations = {$: 'TopLocations'};
var $author$project$Translations$Listings$Insights$reviews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.reviews');
};
var $author$project$FontAwesome$Light$Icon$faQrcode = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-qrcode');
var $author$project$Insights$Rating$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$Insights$leaveAReviewGoogle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.leave_a_review_google');
};
var $author$project$PinMeTo$Ui$Table$withRowLinkWithAttributes = F3(
	function (att, x, config) {
		return _Utils_update(
			config,
			{
				rowLink: $elm$core$Maybe$Just(x),
				rowLinkAttributes: $elm$core$Maybe$Just(att)
			});
	});
var $author$project$Insights$Rating$View$TopListSection$renderTopList = F4(
	function (session, model, topList, sortedBy) {
		var missingValuePlaceHolder = '-';
		var calculateResponseRate = F2(
			function (answered, unanswered) {
				var denom = ((unanswered + answered) > 0) ? (unanswered + answered) : 1;
				return answered / denom;
			});
		var compactRightContent = _List_fromArray(
			[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]);
		var formatResponseRate = F2(
			function (a, b) {
				return A3(
					$author$project$Util$flip,
					$elm$core$Basics$append,
					'%',
					A2(
						$myrho$elm_round$Round$round,
						1,
						100 * A2(calculateResponseRate, a, b)));
			});
		var getResponseRate = function (location) {
			return A2(calculateResponseRate, location.answeredCount, location.unAnsweredCount);
		};
		var hasNoReviews = function (location) {
			return !location.reviewCount;
		};
		var reviewLink = function (link) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(link),
						$elm$html$Html$Attributes$class('pmt-insights__top-list-review-link')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(link)
					]));
		};
		var qrCodeLink = function (location) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (link) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(link),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$class('pmt-btn pmt-btn--cta-muted')
								]),
							_List_fromArray(
								[
									$author$project$FontAwesome$Light$Icon$render($author$project$FontAwesome$Light$Icon$faQrcode)
								]));
					},
					location.qrCodeLink));
		};
		var site = $author$project$Data$SiteName$toString(session.siteName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-apple-insights-top-list')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addCompactColumn,
						$author$project$Translations$Listings$Insights$leaveAReviewGoogle(session.translations),
						qrCodeLink,
						$author$project$PinMeTo$Ui$Table$comparing(
							function ($) {
								return $.locationId;
							}),
						A5(
							$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
							$author$project$Translations$Listings$Insights$leaveAReviewGoogle(session.translations),
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Table$MaxWidth]),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.reviewLink;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(''),
									reviewLink)),
							$author$project$PinMeTo$Ui$Table$comparingMaybe(
								function ($) {
									return $.reviewLink;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addCompactColumn,
								$author$project$Translations$General$locationDescriptor(session.translations),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.locationDescriptor;
									},
									$elm$html$Html$text),
								$author$project$PinMeTo$Ui$Table$comparing(
									function ($) {
										return $.locationDescriptor;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addColumn,
									$author$project$Translations$General$name(session.translations),
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.name;
										},
										$elm$html$Html$text),
									$author$project$PinMeTo$Ui$Table$comparing(
										function ($) {
											return $.name;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addColumn,
										$author$project$Translations$General$locationStoreId(session.translations),
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.storeId;
											},
											$elm$html$Html$text),
										A2(
											$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
											30,
											function ($) {
												return $.storeId;
											}),
										A5(
											$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
											$author$project$Translations$Listings$Insights$responseRate(session.translations),
											compactRightContent,
											A2(
												$elm$core$Basics$composeR,
												function (item) {
													return hasNoReviews(item) ? missingValuePlaceHolder : A2(formatResponseRate, item.answeredCount, item.unAnsweredCount);
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(getResponseRate),
											A5(
												$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
												$author$project$Translations$Listings$Insights$reviews(session.translations),
												compactRightContent,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.reviewCount;
													},
													A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
												$author$project$PinMeTo$Ui$Table$comparing(
													function ($) {
														return $.reviewCount;
													}),
												A5(
													$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
													$author$project$Translations$Listings$Insights$rating(session.translations),
													compactRightContent,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.averageRating;
														},
														A2(
															$elm$core$Basics$composeR,
															A2(
																$elm_community$maybe_extra$Maybe$Extra$unpack,
																function (_v2) {
																	return missingValuePlaceHolder;
																},
																$myrho$elm_round$Round$round(1)),
															$elm$html$Html$text)),
													$author$project$PinMeTo$Ui$Table$comparingMaybe(
														function ($) {
															return $.averageRating;
														}),
													A3(
														$author$project$PinMeTo$Ui$Table$withRowLinkWithAttributes,
														$elm$core$Basics$always(
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$target('_blank')
																])),
														function (location) {
															return '/listings/' + (site + ('/locations/' + (location.locationId + '/details')));
														},
														A2(
															$author$project$PinMeTo$Ui$Table$withLimit,
															{
																limit: model.topListAmountToShow,
																viewMoreLabel: F2(
																	function (_v0, _v1) {
																		return 'Show more';
																	})
															},
															$author$project$PinMeTo$Ui$Table$withScrollableTable(
																$author$project$PinMeTo$Ui$Table$withStickyHeader(
																	A2(
																		$author$project$PinMeTo$Ui$Table$withSort,
																		sortedBy,
																		A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Rating$Model$UiTableMsg, topList)))))))))))))))
				]));
	});
var $author$project$Insights$Rating$Commands$filterQueryString = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var filterQuery = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (filterController) {
				return '&' + A2(
					$elm$core$String$dropLeft,
					1,
					$author$project$Filter$FilterController$getCurrentFilterAsQueryString(filterController));
			},
			model.filterController);
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var query = '?from=' + ($justinmimbs$date$Date$toIsoString(model.range.from) + ('&to=' + ($justinmimbs$date$Date$toIsoString(model.range.to) + filterQuery)));
		return requestUrl + (siteName + ('/rating/metrics' + (endpoint + (fileTypeStr + query))));
	});
var $author$project$Insights$Rating$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Translations$Listings$Insights$ratingTopListDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.rating_top_list_description');
};
var $author$project$Insights$Rating$View$TopListSection$view = F2(
	function (session, model) {
		var downloadButton = _List_fromArray(
			[
				A2(
				$author$project$Insights$Utils$renderInsightsDownloadButton,
				{
					uid: 'ui-select-download-toplist-overview',
					items: _List_fromArray(
						[
							{
							url: A4($author$project$Insights$Rating$Commands$filterQueryString, model, session.siteName, 'csv', '/topList/download/'),
							label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
						},
							{
							url: A4($author$project$Insights$Rating$Commands$filterQueryString, model, session.siteName, 'xlsx', '/topList/download/'),
							label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
						}
						]),
					title: $author$project$Translations$Listings$Insights$downloadTopLocationsTitle(session.translations),
					tagger: $author$project$Insights$Rating$Model$UiSelectMsg,
					fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Rating-top-list_' + (function (range) {
						return $justinmimbs$date$Date$toIsoString(range.from);
					}(model.range) + ('_' + function (range) {
						return $justinmimbs$date$Date$toIsoString(range.to);
					}(model.range))))),
					onChange: $author$project$Insights$Rating$Model$OnDownloadLabelClicked,
					isDisabled: !_Utils_eq(
						A2(
							$author$project$RemoteData$map,
							function (data) {
								return $elm$core$List$isEmpty(data);
							},
							model.topList),
						$author$project$RemoteData$Loaded(false))
				},
				model.uiSelect)
			]);
		var dateRangeHtml = function (range) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-insights__date-container')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('('),
						$author$project$PinMeTo$Ui$Date$render(
						A2(
							$author$project$PinMeTo$Ui$Date$withFormat,
							$author$project$PinMeTo$Ui$Date$FormatDate,
							A2(
								$author$project$PinMeTo$Ui$Date$string,
								session.locale,
								$justinmimbs$date$Date$toIsoString(range.from)))),
						$elm$html$Html$text(' –'),
						$author$project$PinMeTo$Ui$Date$render(
						A2(
							$author$project$PinMeTo$Ui$Date$withFormat,
							$author$project$PinMeTo$Ui$Date$FormatDate,
							A2(
								$author$project$PinMeTo$Ui$Date$string,
								session.locale,
								$justinmimbs$date$Date$toIsoString(range.to)))),
						$elm$html$Html$text(' )')
					]));
		}(model.range);
		var titleWithPopOver = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$topLocations(session.translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.popOverState,
							A2($author$project$Insights$Rating$View$PopOverConfig$popOverConfig, session, $author$project$Insights$Rating$Model$TopLocations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Insights$ratingTopListDescription(session.translations)),
							dateRangeHtml
						]))
				]));
		var asides = _List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
				$author$project$Translations$Listings$Insights$downloadDetailedDataTooltip(session.translations),
				$elm$html$Html$b,
				_List_Nil,
				downloadButton)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__rating-top-list-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(titleWithPopOver)))),
					function () {
					var _v0 = model.topList;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Loaded':
							var topListMetricsData = function () {
								var _v1 = model.topList;
								if (_v1.$ === 'Loaded') {
									var topListData = _v1.a;
									return topListData;
								} else {
									return _List_Nil;
								}
							}();
							var sortedBy = A2(
								$elm$core$Maybe$withDefault,
								$author$project$PinMeTo$Ui$Table$Desc(0),
								$author$project$PinMeTo$Ui$Table$getSort(model.uiTable));
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A4($author$project$Insights$Rating$View$TopListSection$renderTopList, session, model, topListMetricsData, sortedBy)
									]));
						default:
							var e = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
					}
				}()
				]));
	});
var $author$project$Translations$General$Insights$rating = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.rating');
};
var $author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack = function (days) {
	return $author$project$PinMeTo$Ui$DateRangePicker$DaysBack(days);
};
var $author$project$Translations$Listings$Insights$downloadReviews = F2(
	function (translations, fileFormat) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.download_reviews',
			_List_fromArray(
				[
					_Utils_Tuple2(' fileFormat', fileFormat)
				]));
	});
var $author$project$Translations$Listings$Insights$allAvailableData = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.all_available_data');
};
var $author$project$Insights$Rating$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Translations$Listings$Insights$downloadRatingsOld = F2(
	function (translations, fileFormat) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.download_ratings_old',
			_List_fromArray(
				[
					_Utils_Tuple2(' fileFormat', fileFormat)
				]));
	});
var $author$project$PinMeTo$Ui$DateRangePicker$withCustomDefaults = F2(
	function (customDefaults, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$DateRangePicker$View(
			_Utils_update(
				config,
				{defaultRanges: customDefaults}));
	});
var $author$project$Insights$Rating$Commands$getLegacyDownloadUrl = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var filterQuery = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (filterController) {
				return $author$project$Filter$FilterController$getCurrentFilterAsQueryString(filterController);
			},
			model.filterController);
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		return requestUrl + (siteName + (endpoint + (($justinmimbs$date$Date$toIsoString(model.range.from) + ('/' + $justinmimbs$date$Date$toIsoString(model.range.to))) + ('/download/' + (fileTypeStr + filterQuery)))));
	});
var $author$project$Translations$Listings$Insights$downloadRatingsSummary = F2(
	function (translations, fileFormat) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.download_ratings_summary',
			_List_fromArray(
				[
					_Utils_Tuple2(' fileFormat', fileFormat)
				]));
	});
var $author$project$Insights$Rating$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A2(
			$elm$core$Maybe$map,
			function (filterController) {
				return A2(
					$elm$html$Html$map,
					$author$project$Insights$Rating$Model$FilterControllerMsg,
					A4($author$project$Filter$FilterController$viewInsights, filterController, session.locale, session.translations, session.language));
			},
			model.filterController);
		var uiDateRangePickerState = A2($elm$core$Maybe$withDefault, $author$project$PinMeTo$Ui$DateRangePicker$init.a, model.uiDateRangePicker);
		var downloadButtonConfig = function () {
			var conversationsOptions = _Utils_eq(session.products.listenAndRespond.availability, $author$project$PinMeToPage$ProductEnabled) ? _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Rating$Commands$getLegacyDownloadUrl, model, session.siteName, 'csv', '/review/'),
					label: A2($author$project$Translations$Listings$Insights$downloadReviews, session.translations, 'csv')
				},
					{
					url: A4($author$project$Insights$Rating$Commands$getLegacyDownloadUrl, model, session.siteName, 'xlsx', '/review/'),
					label: A2($author$project$Translations$Listings$Insights$downloadReviews, session.translations, 'xlsx')
				}
				]) : _List_Nil;
			return {
				uid: 'ui-select-download-ratings-metric',
				items: A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							{
							url: A4($author$project$Insights$Rating$Commands$filterQueryString, model, session.siteName, 'csv', '/download/'),
							label: A2($author$project$Translations$Listings$Insights$downloadRatingsSummary, session.translations, 'csv')
						},
							{
							url: A4($author$project$Insights$Rating$Commands$filterQueryString, model, session.siteName, 'xlsx', '/download/'),
							label: A2($author$project$Translations$Listings$Insights$downloadRatingsSummary, session.translations, 'xlsx')
						},
							{
							url: A4($author$project$Insights$Rating$Commands$getLegacyDownloadUrl, model, session.siteName, 'csv', '/rating/'),
							label: A2($author$project$Translations$Listings$Insights$downloadRatingsOld, session.translations, 'csv')
						},
							{
							url: A4($author$project$Insights$Rating$Commands$getLegacyDownloadUrl, model, session.siteName, 'xlsx', '/rating/'),
							label: A2($author$project$Translations$Listings$Insights$downloadRatingsOld, session.translations, 'xlsx')
						}
						]),
					conversationsOptions),
				title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
				tagger: $author$project$Insights$Rating$Model$UiSelectMsg,
				fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Ratings_' + ($justinmimbs$date$Date$toIsoString(model.range.from) + ('_' + $justinmimbs$date$Date$toIsoString(model.range.to))))),
				onChange: $author$project$Insights$Rating$Model$OnDownloadLabelClicked,
				isDisabled: false
			};
		}();
		var shouldShowTopList = $elm_community$maybe_extra$Maybe$Extra$isNothing(model.locationId);
		var defaultDateRanges = _List_fromArray(
			[
				$author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack(30),
				$author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack(90),
				$author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack(180),
				$author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack(365)
			]);
		var dateRangePicker = {
			uid: 'rating-insights-date-range-picker',
			range: model.range,
			labels: A2($author$project$Labels$uiDateRangePicker, session.translations, session.language),
			locale: session.locale,
			tagger: $author$project$Insights$Rating$Model$DateRangePickerMsg,
			language: session.language
		};
		var isLoadingRange = $elm_community$maybe_extra$Maybe$Extra$isNothing(model.uiDateRangePicker);
		var downloadButton = A4(
			$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
			$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
			$elm$html$Html$b,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadButtonConfig, model.uiSelect)
				]));
		var skellify = function (child) {
			return $author$project$PinMeTo$Ui$Skeleton$view(
				{
					shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
					children: _List_fromArray(
						[child]),
					isLoading: isLoadingRange,
					attributes: _List_Nil
				});
		};
		var renderFilterController = function () {
			var _v1 = model.locationId;
			if (_v1.$ === 'Just') {
				return $elm$html$Html$text('');
			} else {
				return skellify(
					A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text('placeholder'),
						filterControllerHandler));
			}
		}();
		var today = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, model.today);
		var additionalRanges = A2(
			$elm$core$List$cons,
			A3(
				$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
				$author$project$Translations$Listings$Insights$yearToDate(session.translations),
				'year-to-date',
				{
					to: today,
					from: A3(
						$justinmimbs$date$Date$fromCalendarDate,
						$justinmimbs$date$Date$year(today),
						$elm$time$Time$Jan,
						1)
				}),
			function () {
				var _v0 = model.lifetime;
				if (_v0.$ === 'Just') {
					var lifetime = _v0.a;
					return _List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
							$author$project$Translations$Listings$Insights$allAvailableData(session.translations),
							'lifetime',
							lifetime)
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					renderFilterController,
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
						true,
						$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
							$author$project$Translations$General$Insights$rating(session.translations)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									skellify(
									A2(
										$author$project$PinMeTo$Ui$DateRangePicker$render,
										uiDateRangePickerState,
										A2(
											$author$project$PinMeTo$Ui$DateRangePicker$withRanges,
											additionalRanges,
											A2(
												$author$project$PinMeTo$Ui$DateRangePicker$withCustomDefaults,
												defaultDateRanges,
												$author$project$PinMeTo$Ui$DateRangePicker$view(dateRangePicker)))))
								])),
							downloadButton
						])),
					A2($author$project$Insights$Rating$View$MetricSection$view, session, model),
					shouldShowTopList ? A2($author$project$Insights$Rating$View$TopListSection$view, session, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Insights$Rating$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Rating$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Rating$Commands$urlAppend = $author$project$Util$flip($elm$core$Basics$append);
var $author$project$Insights$Rating$Commands$getQueryParams = function (_v0) {
	var range = _v0.range;
	var from = $justinmimbs$date$Date$toIsoString(range.from);
	var to = $justinmimbs$date$Date$toIsoString(range.to);
	return '?from=' + (from + ('&to=' + to));
};
var $author$project$Insights$Rating$Model$Review = F4(
	function (createTime, rating, comment, id) {
		return {id: id, rating: rating, comment: comment, createTime: createTime};
	});
var $author$project$Insights$Rating$Decoders$reviewDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'comment',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rating',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'createTime',
				$author$project$Common$Date$stringToDateDecoder,
				$elm$json$Json$Decode$succeed($author$project$Insights$Rating$Model$Review)))));
var $author$project$Insights$Rating$Decoders$reviewListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data',
	$elm$json$Json$Decode$list($author$project$Insights$Rating$Decoders$reviewDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Insights$Rating$Commands$getReviewsSample = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = A2(
			$author$project$Insights$Rating$Commands$urlAppend,
			$author$project$Insights$Rating$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Rating$Commands$urlAppend,
				'/metrics/reviews',
				A2(
					$author$project$Insights$Rating$Commands$urlAppend,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (locationId) {
							return '/' + locationId;
						},
						model.locationId),
					A2(
						$author$project$Insights$Rating$Commands$urlAppend,
						'/rating/locations',
						A2(
							$author$project$Insights$Rating$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Rating$Decoders$reviewListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Rating$Model$TopListLocation = function (name) {
	return function (storeId) {
		return function (locationDescriptor) {
			return function (locationId) {
				return function (reviewLink) {
					return function (qrCodeLink) {
						return function (answeredCount) {
							return function (unAnsweredCount) {
								return function (reviewCount) {
									return function (averageRating) {
										return {name: name, storeId: storeId, locationId: locationId, qrCodeLink: qrCodeLink, reviewLink: reviewLink, reviewCount: reviewCount, answeredCount: answeredCount, averageRating: averageRating, unAnsweredCount: unAnsweredCount, locationDescriptor: locationDescriptor};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Rating$Decoders$topListLocationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'averageRating',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'reviewCount',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'unAnsweredReviews',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'answeredReviews',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['location', 'qrReviewLink']),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['location', 'reviewLink']),
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['location', '_id']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['location', 'locationDescriptor']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['location', 'storeId']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['location', 'name']),
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Insights$Rating$Model$TopListLocation)))))))))));
var $author$project$Insights$Rating$Commands$getTopListMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = A2(
			$author$project$Insights$Rating$Commands$urlAppend,
			$author$project$Insights$Rating$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Rating$Commands$urlAppend,
				'/rating/metrics/topList',
				A2(
					$author$project$Insights$Rating$Commands$urlAppend,
					siteName,
					$elm$url$Url$toString(model.insightsUrl))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$Insights$Rating$Decoders$topListLocationDecoder),
					$elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Rating$Model$PerformanceLists = F3(
	function (top, bottom, count) {
		return {top: top, count: count, bottom: bottom};
	});
var $author$project$Insights$Rating$Model$PerformanceItem = F6(
	function (locationId, score, rating, reviews, storeId, displayName) {
		return {score: score, rating: rating, reviews: reviews, storeId: storeId, locationId: locationId, displayName: displayName};
	});
var $author$project$Insights$Rating$Decoders$performanceItemDecoder = function () {
	var displayNameDecoder = function () {
		var nonEmptyLocationDescriptor = A2(
			$elm$json$Json$Decode$andThen,
			function (locationDescriptor) {
				return (!$elm$core$String$isEmpty(locationDescriptor)) ? $elm$json$Json$Decode$succeed(locationDescriptor) : $elm$json$Json$Decode$fail('locationDescriptor is empty');
			},
			A2($elm$json$Json$Decode$field, 'locationDescriptor', $elm$json$Json$Decode$string));
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					nonEmptyLocationDescriptor,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)
				]));
	}();
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		displayNameDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'storeId',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'reviews',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rating',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'score',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Insights$Rating$Model$PerformanceItem)))))));
}();
var $author$project$Insights$Rating$Decoders$performanceListsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bottom',
		$elm$json$Json$Decode$list($author$project$Insights$Rating$Decoders$performanceItemDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'top',
			$elm$json$Json$Decode$list($author$project$Insights$Rating$Decoders$performanceItemDecoder),
			$elm$json$Json$Decode$succeed($author$project$Insights$Rating$Model$PerformanceLists))));
var $author$project$Insights$Rating$Decoders$performanceResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data',
	$author$project$Insights$Rating$Decoders$performanceListsDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Insights$Rating$Commands$getPerformanceItems = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = A2(
			$author$project$Insights$Rating$Commands$urlAppend,
			$author$project$Insights$Rating$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Rating$Commands$urlAppend,
				'metrics/performance/',
				A2(
					$author$project$Insights$Rating$Commands$urlAppend,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (id) {
								return id + '/';
							},
							model.locationId)),
					A2(
						$author$project$Insights$Rating$Commands$urlAppend,
						'/rating/locations/',
						A2(
							$author$project$Insights$Rating$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Rating$Decoders$performanceResponseDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Rating$Commands$getDetailedRatingStats = F4(
	function (model, _v0, lifetime, msg) {
		var siteName = _v0.a;
		var url = ((!lifetime) ? $author$project$Insights$Rating$Commands$urlAppend(
			$author$project$Insights$Rating$Commands$getQueryParams(model)) : $elm$core$Basics$identity)(
			A2(
				$author$project$Insights$Rating$Commands$urlAppend,
				'/metrics/detailedRatings',
				A2(
					$author$project$Insights$Rating$Commands$urlAppend,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (locationId) {
							return '/' + locationId;
						},
						model.locationId),
					A2(
						$author$project$Insights$Rating$Commands$urlAppend,
						'/locations',
						A2(
							$author$project$Insights$Rating$Commands$urlAppend,
							'/rating',
							A2(
								$author$project$Insights$Rating$Commands$urlAppend,
								siteName,
								$elm$url$Url$toString(model.insightsUrl)))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Rating$Decoders$detailedRatingStatsDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Rating$Model$OnReviewMetricsResponse = function (a) {
	return {$: 'OnReviewMetricsResponse', a: a};
};
var $author$project$Insights$Rating$Model$OnTopListMetricsResponse = function (a) {
	return {$: 'OnTopListMetricsResponse', a: a};
};
var $author$project$Insights$Rating$Model$OnPerformanceItemsResponse = function (a) {
	return {$: 'OnPerformanceItemsResponse', a: a};
};
var $author$project$Insights$Rating$Model$OnDetailedRatingStatsResponse = function (a) {
	return {$: 'OnDetailedRatingStatsResponse', a: a};
};
var $author$project$Insights$Rating$Commands$fetchAllData = F2(
	function (model, siteName) {
		return $elm$core$Platform$Cmd$batch(
			_Utils_ap(
				_List_fromArray(
					[
						A4($author$project$Insights$Rating$Commands$getDetailedRatingStats, model, siteName, false, $author$project$Insights$Rating$Model$OnDetailedRatingStatsResponse),
						A3($author$project$Insights$Rating$Commands$getReviewsSample, model, siteName, $author$project$Insights$Rating$Model$OnReviewMetricsResponse),
						A3($author$project$Insights$Rating$Commands$getPerformanceItems, model, siteName, $author$project$Insights$Rating$Model$OnPerformanceItemsResponse)
					]),
				function () {
					var _v0 = model.locationId;
					if (_v0.$ === 'Just') {
						return _List_Nil;
					} else {
						return _List_fromArray(
							[
								A3($author$project$Insights$Rating$Commands$getTopListMetrics, model, siteName, $author$project$Insights$Rating$Model$OnTopListMetricsResponse)
							]);
					}
				}()));
	});
var $author$project$Insights$Rating$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$Rating$Main$out_Insights_Rating_Main_onFilter = _Platform_outgoingPort('out_Insights_Rating_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Rating$Model$OnLifetimeDetailedRatingStatsResponse = function (a) {
	return {$: 'OnLifetimeDetailedRatingStatsResponse', a: a};
};
var $author$project$Insights$Rating$Main$out_Insights_Rating_Main_onRangeChange = _Platform_outgoingPort('out_Insights_Rating_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$Rating$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'DateRangePickerMsg':
				var msg_ = msg.a;
				var _v1 = model.uiDateRangePicker;
				if (_v1.$ === 'Just') {
					var uiDateRangePicker = _v1.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									uiDateRangePicker: $elm$core$Maybe$Just(x)
								});
						},
						A3(
							$author$project$PinMeTo$Ui$DateRangePicker$update,
							{
								tagger: $author$project$Insights$Rating$Model$DateRangePickerMsg,
								onChange: $author$project$Insights$Rating$Model$OnDateRangeChange,
								metricsPrefix: $author$project$Common$Metrics$prefix('Rating Insights')
							},
							msg_,
							uiDateRangePicker));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnDateRangeChange':
				var range = msg.a;
				var onRangeChange = $author$project$Insights$Rating$Main$out_Insights_Rating_Main_onRangeChange(
					$author$project$Insights$Utils$encodeDateRange(range));
				var newModel_ = _Utils_update(
					model,
					{range: range, reviews: $author$project$RemoteData$Loading, topList: $author$project$RemoteData$Loading, performanceLists: $author$project$RemoteData$Loading, detailedRatingStats: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel_,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Insights$Rating$Commands$fetchAllData, newModel_, session.siteName),
								onRangeChange
							])));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Rating$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'OnDownloadLabelClicked':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (model_) {
						var _v2 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Rating$Model$FilterControllerMsg, msg_, model_, $author$project$Insights$Rating$Model$OnFilter, $author$project$Insights$Rating$Model$OnSearch);
						var filterControllerModel_ = _v2.a;
						var filterControllerCmd_ = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									filterController: $elm$core$Maybe$Just(filterControllerModel_)
								}),
							filterControllerCmd_);
					},
					model.filterController);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						reviews: $author$project$RemoteData$Loading,
						topList: $author$project$RemoteData$Loading,
						filterDefinition: $elm$core$Maybe$Just(filterDefinition),
						performanceLists: $author$project$RemoteData$Loading,
						detailedRatingStats: $author$project$RemoteData$Loading
					});
				var newBatch = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Insights$Rating$Commands$fetchAllData, newModel, session.siteName),
							A4($author$project$Insights$Rating$Commands$getDetailedRatingStats, newModel, session.siteName, true, $author$project$Insights$Rating$Model$OnLifetimeDetailedRatingStatsResponse),
							$author$project$Insights$Rating$Main$out_Insights_Rating_Main_onFilter(filterDefinition)
						]));
				return _Utils_Tuple2(newModel, newBatch);
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnUrlChange':
				var value = msg.a;
				var _v3 = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, value);
				if (_v3.$ === 'Ok') {
					var url = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								baseUrl: $elm$core$Maybe$Just(url)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = _v3.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'Insights.Facebook.Main.OnUrlChange',
								message: 'Failed to decode url'
							}));
				}
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnPopOver':
				var popOverConfigType = msg.a;
				var msg_ = msg.b;
				var _v4 = A3(
					$author$project$PinMeTo$Ui$PopOver$update,
					$author$project$Insights$Rating$Model$OnPopOver(popOverConfigType),
					msg_,
					model.popOverState);
				var newState = _v4.a;
				var cmd_ = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd_])));
			case 'UiFeedbackMsg':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnDetailedRatingStatsResponse':
				if (msg.a.$ === 'Ok') {
					var stats = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detailedRatingStats: $author$project$RemoteData$Loaded(stats)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detailedRatingStats: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnLifetimeDetailedRatingStatsResponse':
				if (msg.a.$ === 'Ok') {
					var stats = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lifetimeDetailedRatingStats: $author$project$RemoteData$Loaded(stats)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lifetimeDetailedRatingStats: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'PerformanceTableMsg':
				var tableMsg = msg.a;
				var newTableState = A2($author$project$PinMeTo$Ui$Table$update, tableMsg, model.performanceTable);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{performanceTable: newTableState}),
					$elm$core$Platform$Cmd$none);
			case 'OnPerformanceTypeChanged':
				var newType = msg.a;
				var newModel = _Utils_update(
					model,
					{performanceType: newType});
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'OnPerformanceSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{performanceSelectState: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Rating$Model$OnPerformanceSelectMsg, msg_, model.performanceSelectState));
			case 'OnPerformanceItemsResponse':
				if (msg.a.$ === 'Ok') {
					var items = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								performanceLists: $author$project$RemoteData$Loaded(items)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								performanceLists: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnTopListMetricsResponse':
				if (msg.a.$ === 'Ok') {
					var topList = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topList: $author$project$RemoteData$Loaded(topList)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topList: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSupportedDateRangeResponse':
				if (msg.a.$ === 'Ok') {
					var range = msg.a.a;
					var uiDateRangePicker = $author$project$PinMeTo$Ui$DateRangePicker$init;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lifetime: $elm$core$Maybe$Just(range),
								uiDateRangePicker: $elm$core$Maybe$Just(uiDateRangePicker.a)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Insights$Rating$Model$DateRangePickerMsg, uiDateRangePicker.b)
								])));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Insights.Rating.Main.OnSupportedDateRangeResponse',
								message: 'Failed to get supported date range'
							}));
				}
			default:
				if (msg.a.$ === 'Ok') {
					var reviews = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								reviews: $author$project$RemoteData$Loaded(reviews)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'Insights.Rating.Main.OnReviewMetricsResponse',
								message: 'Failed to get review metrics'
							}));
				}
		}
	});
var $author$project$Insights$Rating$Model$Flags = function (siteName) {
	return function (today) {
		return function (dateRange) {
			return function (insightsUrl) {
				return function (baseUrl) {
					return function (locale) {
						return function (translations) {
							return function (language) {
								return function (initialFilter) {
									return function (locationId) {
										return function (url) {
											return function (timezoneOffset) {
												return {url: url, today: today, locale: locale, baseUrl: baseUrl, language: language, siteName: siteName, dateRange: dateRange, locationId: locationId, insightsUrl: insightsUrl, translations: translations, initialFilter: initialFilter, timezoneOffset: timezoneOffset};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Rating$Decoders$dateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$Listings$Ui$PresetDateRangePicker$Range)));
var $author$project$Insights$Rating$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timezoneOffset',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'url',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'placeId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'initialFilter',
				$elm$json$Json$Decode$nullable(
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'language',
					$author$project$PinMeTo$Ui$I18n$Language$decoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'translations',
						$author$project$Common$Language$translationsDecoder,
						$author$project$Common$Language$initialTranslationsFallback,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['user', 'settings', 'locale']),
							$author$project$PinMeTo$Ui$I18n$Locale$decoder,
							$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'baseUrl',
								$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'insightsUrl',
									$elm_community$json_extra$Json$Decode$Extra$url,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'dateRange',
										$elm$json$Json$Decode$nullable($author$project$Insights$Rating$Decoders$dateRangeDecoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'today',
											$elm_community$json_extra$Json$Decode$Extra$datetime,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'siteName',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Insights$Rating$Model$Flags)))))))))))));
var $author$project$Insights$Rating$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$Rating$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$Rating$Model$OnUrlChange)
			]));
};
var $author$project$Insights$Rating$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$Rating$Main$init, view: $author$project$Insights$Rating$View$view, update: $author$project$Insights$Rating$Main$update, flagsDecoder: $author$project$Insights$Rating$Main$flagsDecoder, subscriptions: $author$project$Insights$Rating$Main$subscriptions});
var $author$project$Insights$Google$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Insights$Google$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Insights$Google$Commands$supportedDateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxDate',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minDate',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$Google$Commands$getGoogleSupportedDateRange = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = function (u) {
			return u + (siteName + ('/google/locations' + ('/businessProfilePerformance' + '/supportedDateRange')));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Google$Commands$supportedDateRangeDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Insights$Google$Model$GoogleSupportedDateRangeResponse = function (a) {
	return {$: 'GoogleSupportedDateRangeResponse', a: a};
};
var $author$project$Insights$Google$Main$out_Insights_Google_Main_onRangeChange = _Platform_outgoingPort('out_Insights_Google_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$Google$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var uiDateRangePicker = $author$project$PinMeTo$Ui$DateRangePicker$init;
		var model = {
			url: flags.url,
			range: A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 28),
				flags.dateRange),
			today: flags.today,
			baseUrl: flags.url,
			placeId: flags.placeId,
			topList: $author$project$RemoteData$Loading,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			lifetime: $elm$core$Maybe$Nothing,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			insightsUrl: flags.insightsUrl,
			metricsData: $author$project$RemoteData$Loading,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			feedbackState: $author$project$Listings$Ui$Feedback$init,
			initialFilter: flags.initialFilter,
			filterController: filterControllerModel_,
			filterDefinition: $elm$core$Maybe$Nothing,
			uiDateRangePicker: uiDateRangePicker.a,
			topListAmountToShow: 5
		};
		return _Utils_Tuple2(
			$elm$core$Result$Ok(model),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Insights$Google$Main$out_Insights_Google_Main_onRangeChange(
						$author$project$Insights$Utils$encodeDateRange(model.range)),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Google$Model$DateRangePickerMsg, uiDateRangePicker.b),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Google$Model$FilterControllerMsg, filterControllerCmd_),
						A3($author$project$Insights$Google$Commands$getGoogleSupportedDateRange, model, session.siteName, $author$project$Insights$Google$Model$GoogleSupportedDateRangeResponse)
					])));
	});
var $author$project$Insights$Google$Model$getDateLabel = function (model) {
	var toString = function (date) {
		return $justinmimbs$date$Date$toIsoString(date);
	};
	var from = toString(model.range.from);
	var to = toString(model.range.to);
	return from + (' - ' + to);
};
var $author$project$Insights$Google$Model$Actions = {$: 'Actions'};
var $author$project$Insights$Google$View$Charts$getData = F2(
	function (f, metrics) {
		return A2(
			$elm$core$List$map,
			function (x) {
				return {
					key: x.date,
					value: f(x)
				};
			},
			metrics);
	});
var $author$project$Insights$Google$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Insights$Google$View$Charts$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: $author$project$Translations$Listings$Insights$feedbackLabel(translations),
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Google$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Insights$Google$View$Charts$renderAsides = F3(
	function (session, model, uid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
						]),
					_List_fromArray(
						[
							A3($author$project$Insights$Google$View$Charts$uiFeedback, session.translations, uid, model.feedbackState)
						]))
				]));
	});
var $author$project$Insights$Google$Model$OnPopOver = function (a) {
	return {$: 'OnPopOver', a: a};
};
var $author$project$Translations$Listings$Insights$googleViewsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_views_popover');
};
var $author$project$Translations$Listings$Insights$googleActionsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_actions_popover');
};
var $author$project$Translations$Listings$Insights$googleTopListingsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_top_listings_popover');
};
var $author$project$Insights$Google$View$Charts$popOverConfig = F2(
	function (popOverType, translations) {
		switch (popOverType.$) {
			case 'TopList':
				return $author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'top-list-popover',
						tagger: $author$project$Insights$Google$Model$OnPopOver,
						content: _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$googleTopListingsPopover(translations))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					});
			case 'Actions':
				return $author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'google-action-popover',
						tagger: $author$project$Insights$Google$Model$OnPopOver,
						content: _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$googleActionsPopover(translations))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					});
			default:
				return $author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'google-view-popover',
						tagger: $author$project$Insights$Google$Model$OnPopOver,
						content: _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$googleViewsPopover(translations))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					});
		}
	});
var $author$project$Translations$Listings$Insights$googleActionsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.google_actions_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Translations$Listings$Insights$googleActionBusinessCallClicks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_action_business_call_clicks');
};
var $author$project$Translations$Listings$Insights$googleActionBusinessWebsiteClicks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_action_business_website_clicks');
};
var $author$project$Translations$Listings$Insights$googleActionBusinessDirectionRequests = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_action_business_direction_requests');
};
var $author$project$Insights$Google$View$Charts$renderActionsChart = F4(
	function (session, model, metrics, dateLabel) {
		var directionRequests = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.businessDirectionRequests;
				},
				metrics),
			color: '#FDB268',
			title: $author$project$Translations$Listings$Insights$googleActionBusinessDirectionRequests(session.translations)
		};
		var websiteClicks = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.websiteClicks;
				},
				metrics),
			color: '#3399FF',
			title: $author$project$Translations$Listings$Insights$googleActionBusinessWebsiteClicks(session.translations)
		};
		var callClicks = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.callClicks;
				},
				metrics),
			color: '#9933FF',
			title: $author$project$Translations$Listings$Insights$googleActionBusinessCallClicks(session.translations)
		};
		var actionsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			_List_fromArray(
				[directionRequests, callClicks, websiteClicks]));
		var actionsChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, actionsData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(actionsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withPopOver,
							_Utils_Tuple2(
								A2($author$project$Insights$Google$View$Charts$popOverConfig, $author$project$Insights$Google$Model$Actions, session.translations),
								model.popOverState),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withAsides,
								A3($author$project$Insights$Google$View$Charts$renderAsides, session, model, 'google-insights-actions'),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$googleActionsDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$actionsTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[actionsChart])))));
	});
var $author$project$Translations$Listings$Insights$googleLegacyLinkCustom = F3(
	function (translations, nonPlaceholderLift, oldGoogleInsightsLink) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'listings.insights.google_legacy_link',
			_List_fromArray(
				[
					_Utils_Tuple2('- oldGoogleInsightsLink', oldGoogleInsightsLink)
				]));
	});
var $author$project$Insights$Google$Model$Views = {$: 'Views'};
var $author$project$Translations$Listings$Insights$viewsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.views_title');
};
var $author$project$Translations$Listings$Insights$googleMapsMobile = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_maps_mobile');
};
var $author$project$Translations$Listings$Insights$googleMapsDesktop = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_maps_desktop');
};
var $author$project$Translations$Listings$Insights$googleSearchesMobile = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_searches_mobile');
};
var $author$project$Translations$Listings$Insights$googleSearchesDesktop = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_searches_desktop');
};
var $author$project$Translations$Listings$Insights$googleViewsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.google_views_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Google$View$Charts$renderImpressionsChart = F4(
	function (session, model, metrics, dateLabel) {
		var googleSearchDesktop = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.businessImpressionsDesktopSearch;
				},
				metrics),
			color: '#9933FF',
			title: $author$project$Translations$Listings$Insights$googleSearchesDesktop(session.translations)
		};
		var googleSearchMobile = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.businessImpressionsMobileSearch;
				},
				metrics),
			color: '#3399FF',
			title: $author$project$Translations$Listings$Insights$googleSearchesMobile(session.translations)
		};
		var googleMapsDesktop = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.businessImpressionsDesktopMaps;
				},
				metrics),
			color: '#FDB268',
			title: $author$project$Translations$Listings$Insights$googleMapsDesktop(session.translations)
		};
		var googleMapsMobile = {
			data: A2(
				$author$project$Insights$Google$View$Charts$getData,
				function ($) {
					return $.businessImpressionsMobileMaps;
				},
				metrics),
			color: '#61D173',
			title: $author$project$Translations$Listings$Insights$googleMapsMobile(session.translations)
		};
		var impressionsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			_List_fromArray(
				[googleSearchDesktop, googleSearchMobile, googleMapsDesktop, googleMapsMobile]));
		var impressionsChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, impressionsData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(impressionsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Google$View$Charts$renderAsides, session, model, 'google-insights-visibility'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Google$View$Charts$popOverConfig, $author$project$Insights$Google$Model$Views, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$googleViewsDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$viewsTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[impressionsChart])))));
	});
var $author$project$Translations$Listings$Insights$googleLegacyLinkNextLine = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.google_legacy_link_next_line');
};
var $author$project$Insights$Google$View$MetricSection$view = F3(
	function (session, model, metrics) {
		var _v0 = session.siteName;
		var siteName = _v0.a;
		var dateLabel = $author$project$Insights$Google$Model$getDateLabel(model);
		var legacyLink = '/account-settings/' + (siteName + '/api/v3/documentation');
		var legacyDiv = A2(
			$elm$html$Html$p,
			_List_Nil,
			A3(
				$author$project$Translations$Listings$Insights$googleLegacyLinkCustom,
				session.translations,
				$elm$html$Html$text,
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(legacyLink),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Insights$googleLegacyLinkNextLine(session.translations))
						]))));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$Insights$Google$View$Charts$renderImpressionsChart, session, model, metrics, dateLabel),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A4($author$project$Insights$Google$View$Charts$renderActionsChart, session, model, metrics, dateLabel)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							legacyDiv,
							A2($elm$html$Html$br, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Insights$Google$Model$TopList = {$: 'TopList'};
var $author$project$Insights$Google$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Insights$Google$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Insights$Google$View$TopListSection$renderTopList = F4(
	function (model, session, topListLocations, sortedBy) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-apple-insights-top-list')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						$author$project$Translations$General$locationCountry(session.translations),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.address;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.country;
								},
								$elm$html$Html$text)),
						$author$project$PinMeTo$Ui$Table$comparing(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								function ($) {
									return $.country;
								})),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							$author$project$Translations$General$locationCity(session.translations),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.address;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.city;
									},
									$elm$html$Html$text)),
							$author$project$PinMeTo$Ui$Table$comparing(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									function ($) {
										return $.city;
									})),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$General$locationZip(session.translations),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.address;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.zip;
										},
										$elm$html$Html$text)),
								$author$project$PinMeTo$Ui$Table$comparing(
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.address;
										},
										function ($) {
											return $.zip;
										})),
								A4(
									$author$project$PinMeTo$Ui$Table$addCompactColumn,
									$author$project$Translations$General$locationStreet(session.translations),
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.address;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.street;
											},
											$elm$html$Html$text)),
									$author$project$PinMeTo$Ui$Table$comparing(
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.address;
											},
											function ($) {
												return $.street;
											})),
									A4(
										$author$project$PinMeTo$Ui$Table$addCompactColumn,
										$author$project$Translations$General$locationDescriptor(session.translations),
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.locationDescriptor;
											},
											$elm$html$Html$text),
										$author$project$PinMeTo$Ui$Table$comparing(
											function ($) {
												return $.locationDescriptor;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$name(session.translations),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.name;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.name;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationStoreId(session.translations),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.storeId;
													},
													$elm$html$Html$text),
												A2(
													$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
													30,
													function ($) {
														return $.storeId;
													}),
												A2(
													$author$project$PinMeTo$Ui$Table$withRowLink,
													function (location) {
														return '/listings/' + ($author$project$Data$SiteName$toString(session.siteName) + ('/locations/' + (location.locationId + '/details')));
													},
													A5(
														$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
														$author$project$Translations$Listings$Insights$actionsTitle(session.translations),
														_List_fromArray(
															[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.totalActions;
															},
															A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.totalActions;
															}),
														A5(
															$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
															$author$project$Translations$Listings$Insights$viewsTitle(session.translations),
															_List_fromArray(
																[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.totalViews;
																},
																A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
															$author$project$PinMeTo$Ui$Table$comparing(
																function ($) {
																	return $.totalViews;
																}),
															A2(
																$author$project$PinMeTo$Ui$Table$withLimit,
																{
																	limit: model.topListAmountToShow,
																	viewMoreLabel: F2(
																		function (_v0, _v1) {
																			return 'Show more';
																		})
																},
																$author$project$PinMeTo$Ui$Table$withScrollableTable(
																	$author$project$PinMeTo$Ui$Table$withStickyHeader(
																		A2(
																			$author$project$PinMeTo$Ui$Table$withSort,
																			sortedBy,
																			A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Google$Model$UiTableMsg, topListLocations))))))))))))))))
				]));
	});
var $author$project$Insights$Google$Model$filterQueryString = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (id) {
				return '/' + id;
			},
			model.placeId);
		var filterQuery = '&' + A2(
			$elm$core$String$dropLeft,
			1,
			$author$project$Filter$FilterController$getCurrentFilterAsQueryString(model.filterController));
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var dateRange = model.range;
		var query = '?from=' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('&to=' + ($justinmimbs$date$Date$toIsoString(dateRange.to) + filterQuery)));
		return requestUrl + (siteName + ('/google/locations' + (locationParam + (endpoint + (fileTypeStr + query)))));
	});
var $author$project$Insights$Google$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Translations$Listings$Insights$downloadListingsMetricsCsv = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_listings_metrics_csv');
};
var $author$project$Translations$Listings$Insights$downloadListingsMetricsXlsx = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.download_listings_metrics_xlsx');
};
var $author$project$Insights$Google$View$TopListSection$view = F2(
	function (session, model) {
		var titleWithPopOver = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$topListings(session.translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.popOverState,
							A2($author$project$Insights$Google$View$Charts$popOverConfig, $author$project$Insights$Google$Model$TopList, session.translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$General$topListingsDescription,
								session.translations,
								$author$project$Insights$Google$Model$getDateLabel(model)))
						]))
				]));
		var topListData = function (model_) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				function () {
					var _v0 = model_.topList;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Loaded':
							var topList = _v0.a;
							var sortedBy = A2(
								$elm$core$Maybe$withDefault,
								$author$project$PinMeTo$Ui$Table$Desc(0),
								$author$project$PinMeTo$Ui$Table$getSort(model_.uiTable));
							return A4($author$project$Insights$Google$View$TopListSection$renderTopList, model_, session, topList, sortedBy);
						default:
							var errorTopList = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(errorTopList)
									]));
					}
				}(),
				function (_v1) {
					return $elm$html$Html$text('');
				},
				model.placeId);
		};
		var dateRange = model.range;
		var dropDownConf = {
			uid: 'ui-select-download-toplist-google',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Google$Model$filterQueryString, model, session.siteName, 'csv', '/businessProfilePerformance/topListFull/download/'),
					label: $author$project$Translations$Listings$Insights$downloadListingsMetricsCsv(session.translations)
				},
					{
					url: A4($author$project$Insights$Google$Model$filterQueryString, model, session.siteName, 'xlsx', '/businessProfilePerformance/topListFull/download/'),
					label: $author$project$Translations$Listings$Insights$downloadListingsMetricsXlsx(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadToplistTitle(session.translations),
			tagger: $author$project$Insights$Google$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Google-top-list_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Google$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A2(
					$author$project$RemoteData$map,
					function (data) {
						return $elm$core$List$isEmpty(data);
					},
					model.topList),
				$author$project$RemoteData$Loaded(false))
		};
		var asides = _List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
				$author$project$Translations$Listings$Insights$downloadDetailedDataTooltip(session.translations),
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Insights$Utils$renderInsightsDownloadButton, dropDownConf, model.uiSelect)
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(titleWithPopOver)))),
					topListData(model)
				]));
	});
var $author$project$Insights$Google$View$view = F2(
	function (session, state) {
		if (state.$ === 'Ok') {
			var model = state.a;
			var filterControllerHandler = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				A2(
					$elm$html$Html$map,
					$author$project$Insights$Google$Model$FilterControllerMsg,
					A4($author$project$Filter$FilterController$viewInsights, model.filterController, session.locale, session.translations, session.language)),
				function (_v5) {
					return $elm$html$Html$text('');
				},
				model.placeId);
			var shouldShowTopList = function () {
				var _v3 = model.placeId;
				if (_v3.$ === 'Just') {
					return false;
				} else {
					var _v4 = model.metricsData;
					if (_v4.$ === 'Loaded') {
						var metricsData = _v4.a;
						return $elm$core$List$length(metricsData) > 0;
					} else {
						return false;
					}
				}
			}();
			var dateRange = model.range;
			var conf = {
				uid: 'ui-select-download-google-metric',
				items: _List_fromArray(
					[
						{
						url: A4($author$project$Insights$Google$Model$filterQueryString, model, session.siteName, 'csv', '/businessProfilePerformance/download/'),
						label: $author$project$Translations$Listings$Insights$downloadDataSummaryCsv(session.translations)
					},
						{
						url: A4($author$project$Insights$Google$Model$filterQueryString, model, session.siteName, 'xlsx', '/businessProfilePerformance/download/'),
						label: $author$project$Translations$Listings$Insights$downloadDataSummaryXlsx(session.translations)
					}
					]),
				title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
				tagger: $author$project$Insights$Google$Model$UiSelectMsg,
				fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Google-Insights_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
				onChange: $author$project$Insights$Google$Model$OnDownloadLabelClicked,
				isDisabled: !_Utils_eq(
					A2(
						$author$project$RemoteData$map,
						function (data) {
							return $elm$core$List$isEmpty(data);
						},
						model.metricsData),
					$author$project$RemoteData$Loaded(false))
			};
			var downloadMetricsDropdown = A4(
				$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
				$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Insights$Utils$renderInsightsDownloadButton, conf, model.uiSelect)
					]));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-page container')
					]),
				_List_fromArray(
					[
						filterControllerHandler,
						$author$project$PinMeTo$Ui$TitleBar$render(
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
								$author$project$Translations$General$Insights$insightsTitle(session.translations)))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$PinMeTo$Ui$DateRangePicker$render,
										model.uiDateRangePicker,
										function () {
											var _v1 = model.lifetime;
											if (_v1.$ === 'Just') {
												var lifetime = _v1.a;
												return $author$project$PinMeTo$Ui$DateRangePicker$withRanges(
													_List_fromArray(
														[
															A3(
															$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
															$author$project$Translations$General$Insights$lifetime(session.translations),
															'Lifetime',
															lifetime)
														]));
											} else {
												return $elm$core$Basics$identity;
											}
										}()(
											A2(
												$author$project$PinMeTo$Ui$DateRangePicker$withCustomDefaults,
												_List_fromArray(
													[
														$author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack(14),
														$author$project$PinMeTo$Ui$DateRangePicker$presetDaysBack(28)
													]),
												$author$project$PinMeTo$Ui$DateRangePicker$view(
													{
														uid: 'google-insights-date-range-picker',
														range: model.range,
														labels: A2($author$project$Labels$uiDateRangePicker, session.translations, session.language),
														locale: session.locale,
														tagger: $author$project$Insights$Google$Model$DateRangePickerMsg,
														language: session.language
													}))))
									])),
								downloadMetricsDropdown
							])),
						function () {
						var _v2 = model.metricsData;
						switch (_v2.$) {
							case 'Suspended':
								return $author$project$PinMeTo$Ui$EmptyState$insights(
									$author$project$Translations$General$Insights$noData(session.translations));
							case 'Loading':
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-empty-state')
										]),
									_List_fromArray(
										[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
							case 'Loaded':
								var metricsData = _v2.a;
								var isEmpty = $elm$core$List$isEmpty(metricsData);
								return isEmpty ? $author$project$PinMeTo$Ui$EmptyState$insights(
									$author$project$Translations$General$Insights$noData(session.translations)) : A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Insights$Google$View$MetricSection$view, session, model, metricsData),
											shouldShowTopList ? A2($author$project$Insights$Google$View$TopListSection$view, session, model) : $elm$html$Html$text('')
										]));
							default:
								var e = _v2.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(e)
										]));
						}
					}()
					]));
		} else {
			if (state.a.$ === 'FailedToDecodeFlags') {
				var _v6 = state.a;
				return $elm$html$Html$text('Failed to decode the flags in view');
			} else {
				var _v7 = state.a;
				return $elm$html$Html$text('Failed to fetch the supported date range in view');
			}
		}
	});
var $author$project$Insights$Google$Commands$getData = F5(
	function (model, _v0, msg, decoder, isTopList) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (id) {
				return '/' + id;
			},
			model.placeId);
		var topListParam = isTopList ? '/topListFull' : '';
		var httpRequest = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$lukewestby$elm_http_builder$HttpBuilder$post,
			function (_v1) {
				return $lukewestby$elm_http_builder$HttpBuilder$get;
			},
			model.placeId);
		var dateRange = model.range;
		var url = function (u) {
			return u + (siteName + ('/google/locations' + (locationParam + ('/businessProfilePerformance' + (topListParam + ('?from=' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('&to=' + $justinmimbs$date$Date$toIsoString(dateRange.to)))))))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, decoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						httpRequest(url)))));
	});
var $author$project$Insights$Google$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Google$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Google$Model$Flags = F8(
	function (today, insightsUrl, baseUrl, dateRange, initialFilter, placeId, url, timezoneOffset) {
		return {url: url, today: today, baseUrl: baseUrl, placeId: placeId, dateRange: dateRange, insightsUrl: insightsUrl, initialFilter: initialFilter, timezoneOffset: timezoneOffset};
	});
var $author$project$Insights$Google$Model$DateRange = F2(
	function (from, to) {
		return {to: to, from: from};
	});
var $author$project$Insights$Google$Model$dateRangeDecoder = function () {
	var dateDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (s) {
			var _v0 = $justinmimbs$date$Date$fromIsoString(s);
			if (_v0.$ === 'Ok') {
				var x = _v0.a;
				return $elm$json$Json$Decode$succeed(x);
			} else {
				var e = _v0.a;
				return $elm$json$Json$Decode$fail(e);
			}
		},
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'to',
		dateDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'from',
			dateDecoder,
			$elm$json$Json$Decode$succeed($author$project$Insights$Google$Model$DateRange)));
}();
var $author$project$Insights$Google$Model$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timezoneOffset',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'url',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'placeId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'initialFilter',
				$elm$json$Json$Decode$nullable(
					$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'dateRange',
					$elm$json$Json$Decode$nullable($author$project$Insights$Google$Model$dateRangeDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'baseUrl',
						$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'insightsUrl',
							$elm_community$json_extra$Json$Decode$Extra$url,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'today',
								$elm_community$json_extra$Json$Decode$Extra$datetime,
								$elm$json$Json$Decode$succeed($author$project$Insights$Google$Model$Flags)))))))));
var $author$project$Insights$Google$Commands$decodeFlags = function (flagsValue) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Insights$Google$Model$flagsDecoder, flagsValue);
};
var $author$project$Insights$Google$Model$FailedToDecodeFlags = {$: 'FailedToDecodeFlags'};
var $author$project$Insights$Google$Main$handleFlags = F2(
	function (flagsValue, model) {
		var _v0 = $author$project$Insights$Google$Commands$decodeFlags(flagsValue);
		if (_v0.$ === 'Ok') {
			var flags = _v0.a;
			var newModel = _Utils_update(
				model,
				{url: flags.url, baseUrl: flags.url, placeId: flags.placeId, topList: $author$project$RemoteData$Loading, insightsUrl: flags.insightsUrl, metricsData: $author$project$RemoteData$Loading});
			return _Utils_Tuple2(
				$elm$core$Result$Ok(newModel),
				$elm$core$Platform$Cmd$batch(_List_Nil));
		} else {
			var err = _v0.a;
			return _Utils_Tuple2(
				$elm$core$Result$Err($author$project$Insights$Google$Model$FailedToDecodeFlags),
				$author$project$PinMeTo$Logger$log(
					{
						data: $elm$json$Json$Decode$errorToString(err),
						context: 'Insights.Google.Main',
						message: 'Failed to decode google metrics'
					}));
		}
	});
var $author$project$Insights$Google$Model$TopListLocation = F7(
	function (name, storeId, locationDescriptor, locationId, address, totalViews, totalActions) {
		return {name: name, address: address, storeId: storeId, locationId: locationId, totalViews: totalViews, totalActions: totalActions, locationDescriptor: locationDescriptor};
	});
var $author$project$Insights$Google$Model$topListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'views',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$author$project$Data$Address$addressDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'locationId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationDescriptor',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'storeId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Insights$Google$Model$TopListLocation))))))));
var $author$project$Insights$Google$Commands$decodeTopList = $elm$json$Json$Decode$list($author$project$Insights$Google$Model$topListDecoder);
var $author$project$Insights$Google$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$Google$Model$MetricsDataResponse = function (a) {
	return {$: 'MetricsDataResponse', a: a};
};
var $author$project$Insights$Google$Model$TopListDataResponse = function (a) {
	return {$: 'TopListDataResponse', a: a};
};
var $author$project$Insights$Google$Model$GoogleMetric = F8(
	function (date, businessImpressionsDesktopMaps, businessImpressionsDesktopSearch, businessImpressionsMobileMaps, businessImpressionsMobileSearch, businessDirectionRequests, callClicks, websiteClicks) {
		return {date: date, callClicks: callClicks, websiteClicks: websiteClicks, businessDirectionRequests: businessDirectionRequests, businessImpressionsMobileMaps: businessImpressionsMobileMaps, businessImpressionsDesktopMaps: businessImpressionsDesktopMaps, businessImpressionsMobileSearch: businessImpressionsMobileSearch, businessImpressionsDesktopSearch: businessImpressionsDesktopSearch};
	});
var $author$project$Insights$Google$Commands$googleMetricDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'WEBSITE_CLICKS',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'CALL_CLICKS',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'BUSINESS_DIRECTION_REQUESTS',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'BUSINESS_IMPRESSIONS_MOBILE_SEARCH',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'BUSINESS_IMPRESSIONS_MOBILE_MAPS',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'BUSINESS_IMPRESSIONS_DESKTOP_MAPS',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'date',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Insights$Google$Model$GoogleMetric)))))))));
var $author$project$Insights$Google$Commands$googleMetricListDecoder = $elm$json$Json$Decode$list($author$project$Insights$Google$Commands$googleMetricDecoder);
var $author$project$Insights$Google$Main$out_Insights_Google_Main_onFilter = _Platform_outgoingPort('out_Insights_Google_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Google$Main$update = F3(
	function (session, msg, state) {
		if (state.$ === 'Ok') {
			var model = state.a;
			switch (msg.$) {
				case 'HandleFlags':
					var flagsValue = msg.a;
					return A2($author$project$Insights$Google$Main$handleFlags, flagsValue, model);
				case 'MetricsDataResponse':
					if (msg.a.$ === 'Ok') {
						var x = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										metricsData: $author$project$RemoteData$Loaded(x)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						var e = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										metricsData: $author$project$RemoteData$Error(
											$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
									})),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Google.Main.MetricsDataResponse'),
								e));
					}
				case 'UiSelectMsg':
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return $elm$core$Result$Ok(
								_Utils_update(
									model,
									{uiSelect: x}));
						},
						A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Google$Model$UiSelectMsg, msg_, model.uiSelect));
				case 'OnDownloadLabelClicked':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(model),
						$elm$core$Platform$Cmd$none);
				case 'TopListDataResponse':
					if (msg.a.$ === 'Ok') {
						var x = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										topList: $author$project$RemoteData$Loaded(x)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						var e = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										topList: $author$project$RemoteData$Error(
											$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
									})),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Google.Main.TopListDataResponse'),
								e));
					}
				case 'FilterControllerMsg':
					var msg_ = msg.a;
					var _v2 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Google$Model$FilterControllerMsg, msg_, model.filterController, $author$project$Insights$Google$Model$OnFilter, $author$project$Insights$Google$Model$OnSearch);
					var filterControllerModel_ = _v2.a;
					var filterControllerCmd_ = _v2.b;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{filterController: filterControllerModel_})),
						filterControllerCmd_);
				case 'OnFilter':
					var filterDefinition = msg.a;
					var newModel = _Utils_update(
						model,
						{
							metricsData: $author$project$RemoteData$Loading,
							filterDefinition: $elm$core$Maybe$Just(filterDefinition)
						});
					return _Utils_Tuple2(
						$elm$core$Result$Ok(newModel),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Insights$Google$Commands$getData, newModel, session.siteName, $author$project$Insights$Google$Model$MetricsDataResponse, $author$project$Insights$Google$Commands$googleMetricListDecoder, false),
									A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									A5($author$project$Insights$Google$Commands$getData, newModel, session.siteName, $author$project$Insights$Google$Model$TopListDataResponse, $author$project$Insights$Google$Commands$decodeTopList, true),
									function (_v3) {
										return $elm$core$Platform$Cmd$none;
									},
									model.placeId),
									$author$project$Insights$Google$Main$out_Insights_Google_Main_onFilter(filterDefinition)
								])));
				case 'OnUrlChange':
					var value = msg.a;
					var _v4 = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, value);
					if (_v4.$ === 'Ok') {
						var url = _v4.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(
								_Utils_update(
									model,
									{
										baseUrl: $elm$core$Maybe$Just(url)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						var e = _v4.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(model),
							$author$project$PinMeTo$Logger$log(
								{
									data: $elm$json$Json$Decode$errorToString(e),
									context: 'Insights.Google.Main.OnUrlChange',
									message: 'Failed to decode url'
								}));
					}
				case 'ShowMore':
					var amountToShow = msg.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{topListAmountToShow: amountToShow + 100})),
						$elm$core$Platform$Cmd$none);
				case 'OnSearch':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(model),
						$elm$core$Platform$Cmd$none);
				case 'OnPopOver':
					var msg_ = msg.a;
					var _v5 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Insights$Google$Model$OnPopOver, msg_, model.popOverState);
					var newState = _v5.a;
					var cmd_ = _v5.b;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{popOverState: newState})),
						cmd_);
				case 'UiTableMsg':
					var msg_ = msg.a;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							_Utils_update(
								model,
								{
									uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
								})),
						$elm$core$Platform$Cmd$none);
				case 'DateRangePickerMsg':
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return $elm$core$Result$Ok(
								_Utils_update(
									model,
									{uiDateRangePicker: x}));
						},
						A3(
							$author$project$PinMeTo$Ui$DateRangePicker$update,
							{
								tagger: $author$project$Insights$Google$Model$DateRangePickerMsg,
								onChange: $author$project$Insights$Google$Model$OnDateRangeChange,
								metricsPrefix: $author$project$Common$Metrics$prefix('Google Insights')
							},
							msg_,
							model.uiDateRangePicker));
				case 'OnDateRangeChange':
					var range = msg.a;
					var _v6 = function () {
						var onRangeChange = $author$project$Insights$Google$Main$out_Insights_Google_Main_onRangeChange(
							$author$project$Insights$Utils$encodeDateRange(range));
						var newModel_ = _Utils_update(
							model,
							{range: range, metricsData: $author$project$RemoteData$Loading});
						return _Utils_Tuple2(
							newModel_,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A5($author$project$Insights$Google$Commands$getData, newModel_, session.siteName, $author$project$Insights$Google$Model$MetricsDataResponse, $author$project$Insights$Google$Commands$googleMetricListDecoder, false),
										A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										A5($author$project$Insights$Google$Commands$getData, newModel_, session.siteName, $author$project$Insights$Google$Model$TopListDataResponse, $author$project$Insights$Google$Commands$decodeTopList, true),
										function (_v7) {
											return $elm$core$Platform$Cmd$none;
										},
										model.placeId),
										onRangeChange
									])));
					}();
					var newModel = _v6.a;
					var newBatch = _v6.b;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(newModel),
						newBatch);
				case 'UiFeedbackMsg':
					return _Utils_Tuple2(
						$elm$core$Result$Ok(model),
						$elm$core$Platform$Cmd$none);
				default:
					if (msg.a.$ === 'Ok') {
						var supportedDateRange = msg.a.a;
						var newModel = _Utils_update(
							model,
							{
								lifetime: $elm$core$Maybe$Just(supportedDateRange)
							});
						return _Utils_Tuple2(
							$elm$core$Result$Ok(newModel),
							$elm$core$Platform$Cmd$none);
					} else {
						var error = msg.a.a;
						return _Utils_Tuple2(
							$elm$core$Result$Ok(model),
							A2(
								$author$project$PinMeTo$ExpectJson$logError,
								$author$project$PinMeTo$ExpectJson$ErrorContext('Error'),
								error));
					}
			}
		} else {
			var err = state.a;
			return _Utils_Tuple2(
				$elm$core$Result$Err(err),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Insights$Google$Model$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$Insights$Google$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$Google$Main$passArgs_Insights_Google_Main = _Platform_incomingPort('passArgs_Insights_Google_Main', $elm$json$Json$Decode$value);
var $author$project$Insights$Google$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Insights$Google$Main$passArgs_Insights_Google_Main($author$project$Insights$Google$Model$HandleFlags),
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$Google$Model$OnUrlChange)
			]));
};
var $author$project$Insights$Google$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$Google$Main$init, view: $author$project$Insights$Google$View$view, update: $author$project$Insights$Google$Main$update, flagsDecoder: $author$project$Insights$Google$Model$flagsDecoder, subscriptions: $author$project$Insights$Google$Main$subscriptions});
var $author$project$Tasks$Overture$Main$Flags = F6(
	function (claimUrl, siteName, user, translations, language, hasCategory) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, hasCategory: hasCategory, translations: translations};
	});
var $author$project$Tasks$Overture$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hasCategory',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$PinMeTo$Ui$I18n$Language$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translations',
			$author$project$Common$Language$translationsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'user',
				$author$project$Data$User$userDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'siteName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'claimUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Tasks$Overture$Main$Flags)))))));
var $author$project$Tasks$Overture$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Overture$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Overture$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Overture$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Overture$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					user: decoded.user,
					claimUrl: decoded.claimUrl,
					language: decoded.language,
					siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
					hasCategory: decoded.hasCategory,
					translations: decoded.translations
				}),
			$elm$core$Platform$Cmd$none);
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Overture$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Overture.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Overture$Main$getText = function (model) {
	return model.hasCategory ? $elm$html$Html$text('All of your locations are claimed!') : $elm$html$Html$text('Claim or create listings for each of your locations on Overture.');
};
var $author$project$Tasks$Overture$Main$getClassName = function (model) {
	return model.hasCategory ? 'pmt-admin-box__success' : 'pmt-admin-box pmt-task--warning';
};
var $author$project$Tasks$Overture$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Overture$Main$getClassName(model))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Overture - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Overture$Main$getText(model)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Overture$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Overture$Main$init,
		view: $author$project$Tasks$Overture$Main$view,
		update: F2(
			function (_v0, model) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}),
		subscriptions: function (_v1) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Facebook$Main$Flags = F5(
	function (claimUrl, siteName, user, translations, language) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, translations: translations};
	});
var $author$project$Tasks$Facebook$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$author$project$Data$User$userDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'claimUrl',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$Facebook$Main$Flags))))));
var $author$project$Tasks$Facebook$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Facebook$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Facebook$Main$GetClaimStatus = function (a) {
	return {$: 'GetClaimStatus', a: a};
};
var $author$project$Tasks$Facebook$Main$ClaimStatus = F4(
	function (doneClaim, numberOfPlacesToClaim, numberOfClaimedPlaces, claimDisabled) {
		return {doneClaim: doneClaim, claimDisabled: claimDisabled, numberOfClaimedPlaces: numberOfClaimedPlaces, numberOfPlacesToClaim: numberOfPlacesToClaim};
	});
var $author$project$Tasks$Facebook$Main$claimStatusDecoder = function () {
	var numberOfPlacesToClaim = A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int);
	var numberOfClaimedPlaces = A2($elm$json$Json$Decode$field, 'claimed', $elm$json$Json$Decode$int);
	var claimDisabled = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (notClaimed, claimed) {
				return (!notClaimed) && (!claimed);
			}),
		A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'claimed', $elm$json$Json$Decode$int));
	var doneClaim = A2(
		$elm$json$Json$Decode$map,
		function (n) {
			return !n;
		},
		A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int));
	return A5($elm$json$Json$Decode$map4, $author$project$Tasks$Facebook$Main$ClaimStatus, doneClaim, numberOfPlacesToClaim, numberOfClaimedPlaces, claimDisabled);
}();
var $author$project$Tasks$Facebook$Main$getClaimStatus = F2(
	function (msg, _v0) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/facebook/claim/status');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Facebook$Main$claimStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Facebook$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Facebook$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Facebook$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		var model = {
			user: decoded.user,
			claimUrl: decoded.claimUrl,
			language: decoded.language,
			siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
			claimStatus: $author$project$RemoteData$Loading,
			translations: decoded.translations
		};
		return _Utils_Tuple2(
			$elm$core$Result$Ok(model),
			A2(
				$author$project$Tasks$Facebook$Main$getClaimStatus,
				$author$project$Tasks$Facebook$Main$GetClaimStatus,
				$author$project$Data$SiteName$SiteName(decoded.siteName)));
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Facebook$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Facebook.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Facebook$Main$getText = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return (x.numberOfPlacesToClaim > 0) ? $elm$html$Html$text('Take ownership of, or create pages, on Facebook for each of your locations.') : $elm$html$Html$text('All of your locations are claimed!');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Facebook$Main$toClaim = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return (x.numberOfPlacesToClaim > 0) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Pages to claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(x.numberOfPlacesToClaim))
									]))
							]))
					])) : $elm$html$Html$text('');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Facebook$Main$getClassName = function (status) {
	if (status.$ === 'Loaded') {
		var x = status.a;
		return (x.numberOfPlacesToClaim > 0) ? 'pmt-admin-box pmt-task--warning' : 'pmt-admin-box__success';
	} else {
		return '';
	}
};
var $author$project$Tasks$Facebook$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Facebook$Main$getClassName(model.claimStatus))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Facebook - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Facebook$Main$getText(model.claimStatus)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												$author$project$Tasks$Facebook$Main$toClaim(model.claimStatus),
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Facebook$Main$update = F2(
	function (msg, state) {
		var _v0 = _Utils_Tuple2(state, msg);
		if (_v0.a.$ === 'Ok') {
			if (_v0.b.a.$ === 'Ok') {
				var model = _v0.a.a;
				var result = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Loaded(result)
							})),
					$elm$core$Platform$Cmd$none);
			} else {
				var model = _v0.a.a;
				var error = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							})),
					A2(
						$author$project$PinMeTo$ExpectJson$logError,
						$author$project$PinMeTo$ExpectJson$ErrorContext('Tasks.Facebook.Main'),
						error));
			}
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Facebook$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Facebook$Main$init,
		view: $author$project$Tasks$Facebook$Main$view,
		update: $author$project$Tasks$Facebook$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$SwitchAccounts$Main$Site = F4(
	function (name, displayName, facebookImage, googleImage) {
		return {name: name, displayName: displayName, googleImage: googleImage, facebookImage: facebookImage};
	});
var $author$project$SwitchAccounts$Main$decodeSite = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['places', 'google', 'media', 'profileImage', 'previewUrl']),
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['places', 'facebook', 'media', 'profileImage', 'previewUrl']),
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'displayName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$SwitchAccounts$Main$Site)))));
var $author$project$SwitchAccounts$Main$decodeSites = $elm$json$Json$Decode$list($author$project$SwitchAccounts$Main$decodeSite);
var $author$project$SwitchAccounts$Main$getSites = function (msg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$SwitchAccounts$Main$decodeSites, $elm$json$Json$Decode$string),
			$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
				$lukewestby$elm_http_builder$HttpBuilder$get('api/user/accounts'))));
};
var $author$project$SwitchAccounts$Main$flagDecoder = function (value) {
	return A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['pmtEnv', 'urls', 'login']),
			$elm$json$Json$Decode$string),
		value);
};
var $author$project$SwitchAccounts$Main$initialModel = {sites: $author$project$RemoteData$Loading, search: '', loginUrl: '', filteredSites: _List_Nil};
var $author$project$SwitchAccounts$Main$SitesResponse = function (a) {
	return {$: 'SitesResponse', a: a};
};
var $author$project$SwitchAccounts$Main$init = function (flags) {
	var _v0 = $author$project$SwitchAccounts$Main$flagDecoder(flags);
	if (_v0.$ === 'Ok') {
		var loginUrl = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$SwitchAccounts$Main$initialModel,
				{loginUrl: loginUrl}),
			$author$project$SwitchAccounts$Main$getSites($author$project$SwitchAccounts$Main$SitesResponse));
	} else {
		var e = _v0.a;
		var errorMessage = $elm$json$Json$Decode$errorToString(e);
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$SwitchAccounts$Main$initialModel,
				{
					sites: $author$project$RemoteData$Error(errorMessage)
				}),
			$author$project$PinMeTo$Logger$log(
				{data: errorMessage, context: 'SwitchAccounts.Main.init', message: 'Failed to decode flags'}));
	}
};
var $author$project$SwitchAccounts$Main$UpdateSearch = function (a) {
	return {$: 'UpdateSearch', a: a};
};
var $author$project$SwitchAccounts$Main$renderSites = F2(
	function (model, sites) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-accounts')
					]),
				_List_fromArray(
					[
						($elm$core$List$length(sites) > 5) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('search-accounts__search')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Form$Input$render(
								A2(
									$author$project$PinMeTo$Ui$Form$Input$withPlaceholder,
									'Search accounts',
									$author$project$PinMeTo$Ui$Form$Input$search(
										{value: model.search, onChange: $author$project$SwitchAccounts$Main$UpdateSearch})))
							])) : $elm$html$Html$text(''),
						$author$project$PinMeTo$Ui$TitleBar$render(
						$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar('Accounts')),
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list list--selector list--highlighted list--divided')
							]),
						A2(
							$elm$core$List$map,
							function (site) {
								var image = (!$elm$core$String$length(site.googleImage)) ? site.facebookImage : site.googleImage;
								return A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list__item')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-account pmt-asides'),
													$elm$html$Html$Attributes$href('./' + site.name),
													$elm$html$Html$Attributes$target('_self')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-account__thumbnail')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('thumbnail thumbnail--small')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src(image)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-account__content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h4,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pmt-account__title')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(site.displayName)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pmt-account__aside asides')
														]),
													_List_Nil)
												]))
										]));
							},
							model.filteredSites))
					]))
			]);
	});
var $author$project$SwitchAccounts$Main$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modern container')
			]),
		function () {
			var _v0 = model.sites;
			switch (_v0.$) {
				case 'Suspended':
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]))
						]);
				case 'Loading':
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]))
						]);
				case 'Loaded':
					var sites = _v0.a;
					return A2($author$project$SwitchAccounts$Main$renderSites, model, sites);
				default:
					var e = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$TitleBar$render(
									$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar('Accounts')),
									$elm$html$Html$text(e)
								]))
						]);
			}
		}());
};
var $author$project$SwitchAccounts$Main$initialSite = {name: '', displayName: '', googleImage: '', facebookImage: ''};
var $author$project$Common$Search$normalize = A2($elm$core$Basics$composeR, $elm$core$String$toLower, $kuon$elm_string_normalize$String$Normalize$removeDiacritics);
var $author$project$Common$Search$textOrder = F3(
	function (toText, item1, item2) {
		return A2(
			$elm$core$Basics$compare,
			$author$project$Common$Search$normalize(
				toText(item1)),
			$author$project$Common$Search$normalize(
				toText(item2)));
	});
var $author$project$Common$Search$foldCompare = F2(
	function (compareField, fields) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (field, order) {
					if (order.$ === 'EQ') {
						return compareField(field);
					} else {
						return order;
					}
				}),
			$elm$core$Basics$EQ,
			fields);
	});
var $author$project$Common$Search$compareBool = F2(
	function (a, b) {
		return _Utils_eq(a, b) ? $elm$core$Basics$EQ : (a ? $elm$core$Basics$LT : $elm$core$Basics$GT);
	});
var $author$project$Common$Search$prefixOrder = F4(
	function (toText, query, item1, item2) {
		return A2(
			$author$project$Common$Search$compareBool,
			A2(
				$elm$core$String$startsWith,
				$author$project$Common$Search$normalize(query),
				$author$project$Common$Search$normalize(
					toText(item1))),
			A2(
				$elm$core$String$startsWith,
				$author$project$Common$Search$normalize(query),
				$author$project$Common$Search$normalize(
					toText(item2))));
	});
var $author$project$Common$Search$sortByQuery = F4(
	function (fields, query, item1, item2) {
		var _v0 = A2(
			$author$project$Common$Search$foldCompare,
			function (field) {
				return A4($author$project$Common$Search$prefixOrder, field, query, item1, item2);
			},
			fields);
		if (_v0.$ === 'EQ') {
			return A2(
				$author$project$Common$Search$foldCompare,
				function (field) {
					return A3($author$project$Common$Search$textOrder, field, item1, item2);
				},
				fields);
		} else {
			var order = _v0;
			return order;
		}
	});
var $author$project$Common$Search$queryMatches = F3(
	function (matcher, query, text) {
		return A2(
			matcher,
			$author$project$Common$Search$normalize(query),
			$author$project$Common$Search$normalize(text));
	});
var $author$project$Common$Search$matchesQuery = F3(
	function (fields, query, item) {
		return A2(
			$elm$core$List$any,
			function (toText) {
				return A3(
					$author$project$Common$Search$queryMatches,
					$elm$core$String$contains,
					query,
					toText(item));
			},
			fields);
	});
var $author$project$Common$Search$filterAndSort = F3(
	function (toText, query, items) {
		var _v0 = $elm$core$String$trim(query);
		if (_v0 === '') {
			return A2(
				$elm$core$List$sortBy,
				A2($elm$core$Basics$composeL, $author$project$Common$Search$normalize, toText),
				items);
		} else {
			var trimmed = _v0;
			return A2(
				$elm$core$List$sortWith,
				A2(
					$author$project$Common$Search$sortByQuery,
					_List_fromArray(
						[toText]),
					trimmed),
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Common$Search$matchesQuery,
						_List_fromArray(
							[toText]),
						trimmed),
					items));
		}
	});
var $author$project$PinMeTo$ExpectJson$getStatusCode = function (_v0) {
	var details = _v0.details;
	switch (details.$) {
		case 'BadUrl':
			return $elm$core$Maybe$Nothing;
		case 'Timeout':
			return $elm$core$Maybe$Nothing;
		case 'NetworkError':
			return $elm$core$Maybe$Nothing;
		case 'BadStatus':
			var x = details.a;
			return $elm$core$Maybe$Just(x);
		default:
			return $elm$core$Maybe$Just(200);
	}
};
var $author$project$SwitchAccounts$Main$loadSingleSite = function (name) {
	return $elm$browser$Browser$Navigation$load('./' + name);
};
var $author$project$SwitchAccounts$Main$update = F2(
	function (msg, model) {
		if (msg.$ === 'SitesResponse') {
			if (msg.a.$ === 'Ok') {
				var response = msg.a.a;
				var cmd = ($elm$core$List$length(response) === 1) ? $author$project$SwitchAccounts$Main$loadSingleSite(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$SwitchAccounts$Main$initialSite,
						$elm$core$List$head(response)).name) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sites: $author$project$RemoteData$Loaded(response),
							filteredSites: A3(
								$author$project$Common$Search$filterAndSort,
								function ($) {
									return $.displayName;
								},
								'',
								response)
						}),
					cmd);
			} else {
				var err = msg.a.a;
				var statusCode = $author$project$PinMeTo$ExpectJson$getStatusCode(err);
				var _v1 = _Utils_eq(
					statusCode,
					$elm$core$Maybe$Just(401)) ? _Utils_Tuple2(
					'You are not logged in, redirecting to login...',
					$elm$browser$Browser$Navigation$load(model.loginUrl)) : _Utils_Tuple2(
					$author$project$PinMeTo$ExpectJson$getErrorMessage(err),
					A2(
						$author$project$PinMeTo$ExpectJson$logError,
						$author$project$PinMeTo$ExpectJson$ErrorContext('SwitchAccounts.Main'),
						err));
				var errorMsg = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sites: $author$project$RemoteData$Error(errorMsg)
						}),
					cmd);
			}
		} else {
			var string = msg.a;
			var filteredSites = A3(
				$author$project$Common$Search$filterAndSort,
				function ($) {
					return $.displayName;
				},
				string,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$RemoteData$currentData(model.sites)));
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{search: string, filteredSites: filteredSites}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$SwitchAccounts$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$SwitchAccounts$Main$init,
		view: $author$project$SwitchAccounts$Main$view,
		update: $author$project$SwitchAccounts$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Locations$List$Model$GetToday = function (a) {
	return {$: 'GetToday', a: a};
};
var $author$project$Locations$List$Model$LocationsLoaded = function (a) {
	return {$: 'LocationsLoaded', a: a};
};
var $author$project$Locations$List$Model$Open = {$: 'Open'};
var $author$project$Locations$List$Model$Closed = {$: 'Closed'};
var $author$project$Locations$List$Model$Disabled = {$: 'Disabled'};
var $author$project$Locations$List$Model$LocationDetails = function (id) {
	return function (name) {
		return function (storeId) {
			return function (address) {
				return function (permanentlyClosed) {
					return function (isActive) {
						return function (locationDescriptor) {
							return function (location) {
								return function (created) {
									return function (status) {
										return function (actionResult) {
											return function (temporarilyClosedUntil) {
												return function (contact) {
													return function (locationType) {
														return function (serviceAreas) {
															return function (shortDescription) {
																return function (longDescription) {
																	return function (networkCategories) {
																		return function (openHours) {
																			return function (networkAttributes) {
																				return function (actionLinks) {
																					return function (networkMedia) {
																						return function (googleAccountId) {
																							return function (facebookParentPageId) {
																								return {id: id, name: name, status: status, address: address, contact: contact, created: created, storeId: storeId, isActive: isActive, location: location, openHours: openHours, actionLinks: actionLinks, actionResult: actionResult, locationType: locationType, networkMedia: networkMedia, serviceAreas: serviceAreas, googleAccountId: googleAccountId, longDescription: longDescription, shortDescription: shortDescription, networkAttributes: networkAttributes, networkCategories: networkCategories, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor, facebookParentPageId: facebookParentPageId, temporarilyClosedUntil: temporarilyClosedUntil};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Locations$List$Model$TemporarilyClosed = function (a) {
	return {$: 'TemporarilyClosed', a: a};
};
var $author$project$Locations$List$Model$defaultCoordinates = {lat: 0, lon: 0};
var $author$project$Locations$List$Model$nullableCoordinatesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault($author$project$Locations$List$Model$defaultCoordinates),
	$elm$json$Json$Decode$nullable($author$project$Data$Coordinates$coordinatesDecoder));
var $author$project$Locations$List$Model$locationDetailsDecoder = function (today) {
	var tempClosedDecoder = A2(
		$elm$json$Json$Decode$map,
		function (x) {
			return _Utils_eq(
				x,
				$elm$core$Maybe$Just('')) ? $elm$core$Maybe$Nothing : x;
		},
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'temporarilyClosedUntil', $elm$json$Json$Decode$string)));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (status) {
			return A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['fb', 'data', 'parent_page']),
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['google', 'accountId']),
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'networkMedia',
						$author$project$Data$Location$networkMediaDecoder,
						{
							google: {coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing},
							facebook: {coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing}
						},
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'actionLinks',
							$author$project$Data$Location$ActionLinks$listDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'networkAttributes',
								$elm$json$Json$Decode$nullable($author$project$Data$Location$NetworkAttributes$decoder),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'openHours',
									$author$project$Data$Location$OpenHours$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'networkCategories',
										$author$project$Data$Location$NetworkCategories$decoder,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'longDescription',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'shortDescription',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'serviceAreas',
													$elm$json$Json$Decode$list(
														A2($elm$json$Json$Decode$field, 'area', $elm$json$Json$Decode$string)),
													_List_Nil,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'type',
														$author$project$Data$Location$locationTypeDecoder,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'contact',
															$author$project$Locations$List$Model$contactDecoder,
															{email: '', phone: '', homepage: ''},
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'temporarilyClosedUntil',
																$elm$json$Json$Decode$string,
																'',
																A2(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																	$author$project$RemoteData$Suspended,
																	A2(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																		status,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'created',
																			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
																			$elm$time$Time$millisToPosix(0),
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'location',
																				$author$project$Locations$List$Model$nullableCoordinatesDecoder,
																				$author$project$Locations$List$Model$defaultCoordinates,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'locationDescriptor',
																					$elm$json$Json$Decode$string,
																					'',
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'isActive',
																						$elm$json$Json$Decode$bool,
																						false,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'permanentlyClosed',
																							$elm$json$Json$Decode$bool,
																							true,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'address',
																								$author$project$Data$Address$addressDecoder,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'storeId',
																									$elm$json$Json$Decode$string,
																									'',
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'name',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'_id',
																											$elm$json$Json$Decode$string,
																											$elm$json$Json$Decode$succeed($author$project$Locations$List$Model$LocationDetails)))))))))))))))))))))))));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (isActive, permanentlyClosed, temporarilyClosedUntil) {
					var _v0 = _Utils_Tuple3(isActive, permanentlyClosed, temporarilyClosedUntil);
					_v0$1:
					while (true) {
						if (!_v0.a) {
							return $author$project$Locations$List$Model$Disabled;
						} else {
							if (_v0.c.$ === 'Nothing') {
								if ((_v0.b.$ === 'Just') && _v0.b.a) {
									break _v0$1;
								} else {
									var _v1 = _v0.c;
									return $author$project$Locations$List$Model$Open;
								}
							} else {
								if ((_v0.b.$ === 'Just') && _v0.b.a) {
									break _v0$1;
								} else {
									if (_v0.c.a === '') {
										return $author$project$Locations$List$Model$Open;
									} else {
										var tempClosed = _v0.c.a;
										return A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$Locations$List$Model$Open,
											function (d) {
												var todayToRataDie = $justinmimbs$date$Date$toRataDie(today);
												var nextDay = $justinmimbs$date$Date$toRataDie(
													A3(
														$justinmimbs$date$Date$add,
														$justinmimbs$date$Date$Days,
														1,
														A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, d)));
												return (_Utils_cmp(nextDay, todayToRataDie) < 1) ? $author$project$Locations$List$Model$Open : $author$project$Locations$List$Model$TemporarilyClosed(d);
											},
											$elm$core$Result$toMaybe(
												$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(
													A3($elm$core$String$replace, ' ', '', tempClosed))));
									}
								}
							}
						}
					}
					return $author$project$Locations$List$Model$Closed;
				}),
			A2($elm$json$Json$Decode$field, 'isActive', $elm$json$Json$Decode$bool),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'permanentlyClosed', $elm$json$Json$Decode$bool)),
			tempClosedDecoder));
};
var $author$project$Locations$List$Model$listLocationDetailsDecoder = function (today) {
	return $elm$json$Json$Decode$list(
		$author$project$Locations$List$Model$locationDetailsDecoder(today));
};
var $author$project$Locations$List$Main$getLocations = F3(
	function (siteName_, today, filter) {
		var url = 'api/' + ($author$project$Data$SiteName$toString(siteName_) + '/places/filter');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					$author$project$Locations$List$Model$LocationsLoaded,
					$author$project$Locations$List$Model$listLocationDetailsDecoder(today)),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					filter,
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$Locations$List$Model$ListView = {$: 'ListView'};
var $author$project$Locations$List$Model$NoAction = {$: 'NoAction'};
var $author$project$Locations$List$Main$initialModel = {
	today: A3($justinmimbs$date$Date$fromCalendarDate, 2019, $elm$time$Time$Jan, 1),
	editor: $elm$core$Maybe$Nothing,
	uiTable: $author$project$PinMeTo$Ui$Table$init,
	allItems: $author$project$RemoteData$Suspended,
	debounce: 0,
	uiSelect: $author$project$PinMeTo$Ui$Select$init,
	viewType: $author$project$Locations$List$Model$ListView,
	uiTooltip: $author$project$PinMeTo$Ui$AdvancedTooltip$init,
	bulkAction: $author$project$Locations$List$Model$NoAction,
	openEditor: false,
	postEnabled: false,
	initialQuery: $elm$core$Maybe$Nothing,
	locationList: {siteCategories: $elm$core$Maybe$Nothing, dataCompleteness: $author$project$RemoteData$Suspended, itemsMatchingFilter: $elm$core$Set$empty},
	latestSearchId: 0,
	normalizedItems: _List_Nil,
	filterController: $elm$core$Maybe$Nothing,
	openFilterOnLoad: false,
	allItemsMatchingFilter: $elm$core$Set$empty,
	hasCreateLocationPermission: false,
	receivedInitialFilterDefinition: false
};
var $author$project$Locations$List$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Locations$List$Model$DataCompletenessLoaded = function (a) {
	return {$: 'DataCompletenessLoaded', a: a};
};
var $author$project$Locations$List$Main$getDataCompleteness = function (siteName_) {
	var dataCompletenessDecoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, '_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'completeness', $elm$json$Json$Decode$float))));
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($elm$http$Http$expectJson, $author$project$Locations$List$Model$DataCompletenessLoaded, dataCompletenessDecoder),
			$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
				$lukewestby$elm_http_builder$HttpBuilder$post(
					'api/' + ($author$project$Data$SiteName$toString(siteName_) + '/dataCompleteness')))));
};
var $author$project$Locations$List$Model$MapView = {$: 'MapView'};
var $author$project$Locations$List$Model$savedViewTypeDecoder = function (str) {
	switch (str) {
		case 'map':
			return $author$project$Locations$List$Model$MapView;
		case 'list':
			return $author$project$Locations$List$Model$ListView;
		default:
			return $author$project$Locations$List$Model$ListView;
	}
};
var $author$project$Locations$List$Main$init = F2(
	function (session, flagsValue) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			flagsValue.query,
			$author$project$PinMeTo$Api$FilterApi$Location,
			flagsValue.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var locationList = $author$project$Locations$List$Main$initialModel.locationList;
		var model = _Utils_update(
			$author$project$Locations$List$Main$initialModel,
			{
				uiTable: $author$project$PinMeTo$Ui$Table$init,
				allItems: $author$project$RemoteData$Loading,
				viewType: $author$project$Locations$List$Model$savedViewTypeDecoder(session.user.settings.locationListView),
				postEnabled: flagsValue.postEnabled,
				initialQuery: flagsValue.query,
				locationList: _Utils_update(
					locationList,
					{siteCategories: flagsValue.siteCategories, itemsMatchingFilter: $elm$core$Set$empty}),
				filterController: $elm$core$Maybe$Just(filterControllerModel_),
				openFilterOnLoad: flagsValue.openFilterOnLoad,
				hasCreateLocationPermission: flagsValue.hasCreateLocationPermission
			});
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Locations$List$Model$GetToday, $justinmimbs$date$Date$today),
						A2($elm$core$Platform$Cmd$map, $author$project$Locations$List$Model$FilterControllerMsg, filterControllerCmd_),
						$author$project$Locations$List$Main$getDataCompleteness(session.siteName),
						A3(
						$author$project$Locations$List$Main$getLocations,
						session.siteName,
						model.today,
						A2($elm$core$Maybe$map, $author$project$PinMeTo$Ui$Filter$DataTypes$encodeFilter, flagsValue.initialFilter))
					])));
	});
var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
var $elm$html$Html$Lazy$lazy6 = $elm$virtual_dom$VirtualDom$lazy6;
var $author$project$Locations$List$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Locations$List$Model$isClosed = function (openStatus) {
	return _Utils_eq(openStatus, $author$project$Locations$List$Model$Closed) || _Utils_eq(openStatus, $author$project$Locations$List$Model$Disabled);
};
var $author$project$Translations$General$errorPlain = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.error_plain');
};
var $author$project$Translations$General$typeHeader = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.type_header');
};
var $author$project$Locations$List$Model$UiTooltipMsg = function (a) {
	return {$: 'UiTooltipMsg', a: a};
};
var $author$project$Translations$Listings$LocationList$closedThrough = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_list.closed_through');
};
var $author$project$Locations$List$Model$openStatusToString = F2(
	function (status, translations) {
		switch (status.$) {
			case 'Disabled':
				return $author$project$Translations$General$disabled(translations);
			case 'Closed':
				return $author$project$Translations$General$closed(translations);
			case 'Open':
				return $author$project$Translations$General$open(translations);
			default:
				return $author$project$Translations$Listings$LocationList$closedThrough(translations);
		}
	});
var $author$project$Locations$List$LocationList$renderStatus = F2(
	function (s, translations) {
		if (s.$ === 'TemporarilyClosed') {
			var p = s.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '0.8em 0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'lineHeight', '1.5')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Locations$List$Model$openStatusToString, s, translations))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'lineHeight', '1.5')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$justinmimbs$date$Date$toIsoString(
									A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, p)))
							]))
					]));
		} else {
			return $elm$html$Html$text(
				A2($author$project$Locations$List$Model$openStatusToString, s, translations));
		}
	});
var $author$project$PinMeTo$Ui$ProgressBar$withIsActive = F2(
	function (isActive, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$ProgressBar$ProgressBar(
			_Utils_update(
				config,
				{isActive: isActive}));
	});
var $author$project$Locations$List$LocationList$wrapInTooltip = F5(
	function (tagger, state, id, content, toolTipContent) {
		return A5(
			$author$project$PinMeTo$Ui$AdvancedTooltip$render,
			state,
			$author$project$PinMeTo$Ui$AdvancedTooltip$view(
				{
					uid: 'table-tooltip' + id,
					tagger: tagger,
					content: _List_fromArray(
						[toolTipContent]),
					preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$TopCenter
				}),
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
				]),
			_List_fromArray(
				[content]));
	});
var $author$project$Locations$List$LocationList$networkEnabled = F2(
	function (network, analytics) {
		var isEnabled = function (networkAnalytics) {
			switch (networkAnalytics.$) {
				case 'NotVisible':
					return false;
				case 'CanEnable':
					return false;
				default:
					return true;
			}
		};
		switch (network.$) {
			case 'Google':
				return isEnabled(analytics.google);
			case 'Facebook':
				return isEnabled(analytics.facebook);
			case 'Apple':
				return isEnabled(analytics.apple);
			case 'Bing':
				return isEnabled(analytics.bing);
			case 'Foursquare':
				return isEnabled(analytics.foursquare);
			case 'Overture':
				return isEnabled(analytics.overture);
			case 'Here':
				return isEnabled(analytics.here);
			case 'Tomtom':
				return isEnabled(analytics.tomtom);
			case 'Ptv':
				return isEnabled(analytics.ptv);
			default:
				return isEnabled(analytics.instagram);
		}
	});
var $author$project$Data$Location$OpenHours$openHoursAreSet = function (openHours) {
	if (openHours.$ === 'During') {
		var days = openHours.a;
		return _Utils_eq(
			$author$project$Data$Location$OpenHours$During(days),
			$author$project$Data$Location$OpenHours$notSpecified) ? false : true;
	} else {
		return true;
	}
};
var $author$project$Translations$Listings$LocationList$completenessScore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_list.completeness_score');
};
var $author$project$Locations$List$LocationList$getBingCategories = F2(
	function (locationCategories, siteCategories) {
		var getSiteCategories = function () {
			if (siteCategories.$ === 'Just') {
				var categories = siteCategories.a;
				var _v2 = categories.bing;
				if (_v2.$ === 'Just') {
					var sc = _v2.a;
					return A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							sc.categories));
				} else {
					return '';
				}
			} else {
				return '';
			}
		}();
		var _v0 = locationCategories.bing;
		if (_v0.$ === 'Just') {
			var locationCategories_ = _v0.a;
			return $elm$core$List$isEmpty(locationCategories_.categories) ? getSiteCategories : A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.name;
					},
					locationCategories_.categories));
		} else {
			return getSiteCategories;
		}
	});
var $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursNotSpecified = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_detail.pop_up_content.open_hours_not_specified');
};
var $author$project$Data$Location$OpenHours$openHoursToString = F2(
	function (openHours, translations) {
		if (openHours.$ === 'Always') {
			return $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAlwaysOpen(translations);
		} else {
			var days = openHours.a;
			if (_Utils_eq(
				$author$project$Data$Location$OpenHours$During(days),
				$author$project$Data$Location$OpenHours$notSpecified)) {
				return $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursNotSpecified(translations);
			} else {
				var dayToString = F2(
					function (day, state) {
						switch (state.$) {
							case 'NotSpecified':
								return '';
							case 'Closed':
								return day + (' ' + $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursDayClosed(translations));
							case 'AlwaysOpen':
								return day + (' ' + $author$project$Translations$Listings$LocationDetail$PopUpContent$openHoursAlwaysOpen(translations));
							default:
								var spans = state.a;
								var spanToString = function (span) {
									return span.open + ('-' + span.close);
								};
								return day + (' ' + A2(
									$elm$core$String$join,
									' ',
									A2($elm$core$List$map, spanToString, spans)));
						}
					});
				return A2(
					dayToString,
					$author$project$Translations$General$abbrMon(translations),
					days.mon) + (' ' + (A2(
					dayToString,
					' | ' + $author$project$Translations$General$abbrTue(translations),
					days.tue) + (' ' + (A2(
					dayToString,
					' | ' + $author$project$Translations$General$abbrWed(translations),
					days.wed) + (' ' + (A2(
					dayToString,
					' | ' + $author$project$Translations$General$abbrThu(translations),
					days.thu) + (' ' + (A2(
					dayToString,
					' | ' + $author$project$Translations$General$abbrFri(translations),
					days.fri) + (' ' + (A2(
					dayToString,
					' | ' + $author$project$Translations$General$abbrSat(translations),
					days.sat) + (' ' + A2(
					dayToString,
					' | ' + $author$project$Translations$General$abbrSun(translations),
					days.sun))))))))))));
			}
		}
	});
var $author$project$Locations$List$LocationList$renderLocationLink = F2(
	function (siteName, location) {
		var locationLink = '/listings/' + (siteName + ('/locations/' + location.id));
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(locationLink),
					$elm$html$Html$Attributes$class('pmt-ui-table__row--link')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(location.storeId)
				]));
	});
var $author$project$Locations$List$LocationList$actionLinksToString = function (actionLinks) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function ($) {
				return $.url;
			},
			actionLinks));
};
var $author$project$Locations$List$LocationList$getFacebookCategories = F2(
	function (locationCategories, siteCategories) {
		var getSiteCategories = function () {
			if (siteCategories.$ === 'Just') {
				var categories = siteCategories.a;
				var _v2 = categories.facebook;
				if (_v2.$ === 'Just') {
					var sc = _v2.a;
					return A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function ($) {
								return $.name;
							},
							sc.subcategories));
				} else {
					return '';
				}
			} else {
				return '';
			}
		}();
		var _v0 = locationCategories.facebook;
		if (_v0.$ === 'Just') {
			var locationCategories_ = _v0.a;
			return $elm$core$List$isEmpty(locationCategories_.subcategories) ? getSiteCategories : A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.name;
					},
					locationCategories_.subcategories));
		} else {
			return getSiteCategories;
		}
	});
var $author$project$Locations$List$TooltipRenderers$renderOpenHoursTooltip = F2(
	function (hour, translations) {
		var hourText = '24' + $author$project$Translations$General$abbrHour(translations);
		var displayDaySpan = function (day) {
			switch (day.$) {
				case 'Open':
					var span = day.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (s) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Listings$Ui$Row$displayTimeSpan(
												{open: s.open, close: s.close}))
										]));
							},
							span));
				case 'Closed':
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$closed(translations))
							]));
				case 'NotSpecified':
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Listings$Ui$Row$emptyValueSpan(translations)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(hourText)
							]));
			}
		};
		if (hour.$ === 'Always') {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$alwaysOpen(translations))
					]));
		} else {
			var sun = hour.a.sun;
			var sat = hour.a.sat;
			var fri = hour.a.fri;
			var thu = hour.a.thu;
			var wed = hour.a.wed;
			var tue = hour.a.tue;
			var mon = hour.a.mon;
			var darkModeClass = 'networks-log__table--dark';
			var weekObjects = _List_fromArray(
				[
					{
					key: $author$project$Translations$General$mon(translations),
					value: displayDaySpan(mon)
				},
					{
					key: $author$project$Translations$General$tue(translations),
					value: displayDaySpan(tue)
				},
					{
					key: $author$project$Translations$General$wed(translations),
					value: displayDaySpan(wed)
				},
					{
					key: $author$project$Translations$General$thu(translations),
					value: displayDaySpan(thu)
				},
					{
					key: $author$project$Translations$General$fri(translations),
					value: displayDaySpan(fri)
				},
					{
					key: $author$project$Translations$General$sat(translations),
					value: displayDaySpan(sat)
				},
					{
					key: $author$project$Translations$General$sun(translations),
					value: displayDaySpan(sun)
				}
				]);
			var cssClass = 'networks-log__table';
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(cssClass),
						$elm$html$Html$Attributes$class(darkModeClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('max-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (day) {
										return A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(cssClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(day.key)
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(cssClass + '--td-center'),
															$elm$html$Html$Attributes$class(cssClass + '__open-hours-value')
														]),
													_List_fromArray(
														[day.value]))
												]));
									},
									weekObjects))
							]))
					]));
		}
	});
var $author$project$PinMeTo$Ui$Table$Custom = function (a) {
	return {$: 'Custom', a: a};
};
var $author$project$PinMeTo$Ui$Table$columnWithCustomSort = F2(
	function (sorter, column) {
		return _Utils_update(
			column,
			{
				sorter: $author$project$PinMeTo$Ui$Table$Custom(sorter)
			});
	});
var $author$project$PinMeTo$Ui$Table$addColumnWithCustomSort = F3(
	function (key, renderer, sorter) {
		return $author$project$PinMeTo$Ui$Table$withColumn(
			A2(
				$author$project$PinMeTo$Ui$Table$columnWithCustomSort,
				sorter,
				A3(
					$author$project$PinMeTo$Ui$Table$createColumn,
					renderer,
					sorter(
						$author$project$PinMeTo$Ui$Table$Asc(0)),
					key)));
	});
var $author$project$Locations$List$TooltipRenderers$renderDescriptionTooltip = function (description) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'white-space', 'normal')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(description)
			]));
};
var $author$project$Locations$List$LocationList$networkAttributesToString = function (networkAttributes) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (x) {
				return x.attributeId + (': ' + A2($elm$core$String$join, ', ', x.values));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.google;
					},
					networkAttributes))));
};
var $author$project$Locations$List$LocationList$getApplePrimaryCategoryName = F2(
	function (locationCategories, siteCategories) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.primary;
			},
			locationCategories.apple);
		if (_v0.$ === 'Just') {
			var category = _v0.a;
			return category.name;
		} else {
			if (siteCategories.$ === 'Just') {
				var categories = siteCategories.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.name;
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.primary;
							},
							categories.apple)));
			} else {
				return '';
			}
		}
	});
var $author$project$Locations$List$LocationList$getGooglePrimaryCategoryName = F2(
	function (locationCategories, siteCategories) {
		var _v0 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.primary;
			},
			locationCategories.google);
		if (_v0.$ === 'Just') {
			var category = _v0.a;
			return category.name;
		} else {
			if (siteCategories.$ === 'Just') {
				var sc = siteCategories.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.name;
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.primary;
							},
							sc.google)));
			} else {
				return '';
			}
		}
	});
var $author$project$Locations$List$LocationList$createColumn = F4(
	function (uiTooltip, columns, session, model) {
		var translations = session.translations;
		var locale = session.locale;
		var _v0 = session.siteName;
		var siteName = _v0.a;
		var analytics = session.analytics;
		var bingEnabled = A2($author$project$Locations$List$LocationList$networkEnabled, $author$project$Data$Network$Bing, analytics);
		var appleEnabled = A2($author$project$Locations$List$LocationList$networkEnabled, $author$project$Data$Network$Apple, analytics);
		var googleEnabled = A2($author$project$Locations$List$LocationList$networkEnabled, $author$project$Data$Network$Google, analytics);
		var facebookEnabled = A2($author$project$Locations$List$LocationList$networkEnabled, $author$project$Data$Network$Facebook, analytics);
		switch (columns.$) {
			case 'RowSelectColumn':
				return $author$project$PinMeTo$Ui$Table$withRowSelection(
					function ($) {
						return $.id;
					});
			case 'RowErrorColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$errorPlain(translations),
					function (x) {
						var _v2 = x.actionResult;
						switch (_v2.$) {
							case 'Suspended':
								return $elm$html$Html$text('');
							case 'Loading':
								return $author$project$PinMeTo$Ui$Spinner$spinner;
							case 'Loaded':
								return A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-table-list__cell fa-solid fa-check success')
										]),
									_List_Nil);
							default:
								var e = _v2.a;
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-table-list__cell-warning')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa-solid fa-triangle-exclamation')
												]),
											_List_Nil),
											$elm$html$Html$text(' '),
											$elm$html$Html$text(e)
										]));
						}
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (x) {
							var _v3 = x.actionResult;
							switch (_v3.$) {
								case 'Suspended':
									return '1';
								case 'Loading':
									return '2';
								case 'Loaded':
									return '3' + x.storeId;
								default:
									var e = _v3.a;
									return '4_' + e;
							}
						}));
			case 'ScoreColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$Listings$LocationList$completenessScore(translations),
					function (x) {
						var score = function () {
							var _v4 = model.dataCompleteness;
							if (_v4.$ === 'Loaded') {
								var completenessDictionary = _v4.a;
								return A2(
									$elm$core$Maybe$withDefault,
									0,
									A2($elm$core$Dict$get, x.id, completenessDictionary));
							} else {
								return 0;
							}
						}();
						return $author$project$PinMeTo$Ui$ProgressBar$render(
							A2(
								$author$project$PinMeTo$Ui$ProgressBar$withIsActive,
								!$author$project$Locations$List$Model$isClosed(x.status),
								$author$project$PinMeTo$Ui$ProgressBar$view(score)));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (x) {
							var _v5 = model.dataCompleteness;
							if (_v5.$ === 'Loaded') {
								var completenessDictionary = _v5.a;
								return A2(
									$elm$core$Maybe$withDefault,
									0,
									A2($elm$core$Dict$get, x.id, completenessDictionary));
							} else {
								return 0;
							}
						}));
			case 'StoreIdColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$locationStoreId(translations),
					function (x) {
						return A2($author$project$Locations$List$LocationList$renderLocationLink, siteName, x);
					},
					A2(
						$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
						30,
						function ($) {
							return $.storeId;
						}));
			case 'StatusColumn':
				var tepmClosedCmp = F3(
					function (_v8, x, y) {
						var cmpStatus = A2(
							$elm$core$Basics$compare,
							A2($author$project$Locations$List$Model$openStatusToString, x.status, translations),
							A2($author$project$Locations$List$Model$openStatusToString, y.status, translations));
						var _v6 = _Utils_Tuple3(cmpStatus, x.status, y.status);
						if (((_v6.a.$ === 'EQ') && (_v6.b.$ === 'TemporarilyClosed')) && (_v6.c.$ === 'TemporarilyClosed')) {
							var _v7 = _v6.a;
							var xStatus = _v6.b.a;
							var yStatus = _v6.c.a;
							return A2(
								$elm$core$Basics$compare,
								A2($elm$time$Time$toMillis, $elm$time$Time$utc, xStatus),
								A2($elm$time$Time$toMillis, $elm$time$Time$utc, yStatus));
						} else {
							return cmpStatus;
						}
					});
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumnWithCustomSort,
					$author$project$Translations$General$status(translations),
					function (x) {
						return A2($author$project$Locations$List$LocationList$renderStatus, x.status, translations);
					},
					tepmClosedCmp);
			case 'NameColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$name(translations),
					function (x) {
						return $elm$html$Html$text(x.name);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function ($) {
							return $.name;
						}));
			case 'LocationDescriptorColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationDescriptor(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(x.locationDescriptor);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function ($) {
							return $.locationDescriptor;
						}));
			case 'StreetColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationStreet(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(x.address.street);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.address.street;
						}));
			case 'ZipColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$locationZip(translations),
					function (x) {
						return $elm$html$Html$text(x.address.zip);
					},
					A2(
						$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
						20,
						function (x) {
							return x.address.zip;
						}));
			case 'CityColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$locationCity(translations),
					function (x) {
						return $elm$html$Html$text(x.address.city);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.address.city;
						}));
			case 'CountryColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$locationCountry(translations),
					function (x) {
						return $elm$html$Html$text(x.address.country);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.address.country;
						}));
			case 'CreatedColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$locationCreated(translations),
					function (x) {
						return $author$project$PinMeTo$Ui$Date$render(
							A2(
								$author$project$PinMeTo$Ui$Date$withFormat,
								$author$project$PinMeTo$Ui$Date$FormatDate,
								A2($author$project$PinMeTo$Ui$Date$posix, locale, x.created)));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (x) {
							return $elm$time$Time$posixToMillis(x.created);
						}));
			case 'TypeColumn':
				return A3(
					$author$project$PinMeTo$Ui$Table$addColumn,
					$author$project$Translations$General$typeHeader(translations),
					function (x) {
						return $elm$html$Html$text(
							A2($author$project$Locations$List$Model$locationTypeToString, x.locationType, translations));
					},
					$author$project$PinMeTo$Ui$Table$comparing(
						function (x) {
							return A2($author$project$Locations$List$Model$locationTypeToString, x.locationType, translations);
						}));
			case 'LongDescriptionColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationLongDescription(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						var tooltip = $author$project$Locations$List$TooltipRenderers$renderDescriptionTooltip(x.longDescription);
						var target = $elm$html$Html$text(x.longDescription);
						return A5($author$project$Locations$List$LocationList$wrapInTooltip, $author$project$Locations$List$Model$UiTooltipMsg, uiTooltip, x.id + '-longDesc', target, tooltip);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.longDescription;
						}));
			case 'ShortDescriptionColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationShortDescription(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						var tooltip = $author$project$Locations$List$TooltipRenderers$renderDescriptionTooltip(x.shortDescription);
						var target = $elm$html$Html$text(x.shortDescription);
						return A5($author$project$Locations$List$LocationList$wrapInTooltip, $author$project$Locations$List$Model$UiTooltipMsg, uiTooltip, x.id + '-shortDesc', target, tooltip);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.shortDescription;
						}));
			case 'GoogleCategoriesColumn':
				return googleEnabled ? A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$Listings$LocationDetail$categoriesGoogle(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(
							A2($author$project$Locations$List$LocationList$getGooglePrimaryCategoryName, x.networkCategories, model.siteCategories));
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return A2($author$project$Locations$List$LocationList$getGooglePrimaryCategoryName, x.networkCategories, model.siteCategories);
						})) : $elm$core$Basics$identity;
			case 'AppleCategoriesColumn':
				return appleEnabled ? A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$Listings$LocationDetail$categoriesApple(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(
							A2($author$project$Locations$List$LocationList$getApplePrimaryCategoryName, x.networkCategories, model.siteCategories));
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return A2($author$project$Locations$List$LocationList$getApplePrimaryCategoryName, x.networkCategories, model.siteCategories);
						})) : $elm$core$Basics$identity;
			case 'FacebookCategoriesColumn':
				return facebookEnabled ? A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$Listings$LocationDetail$categoriesFacebook(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(
							A2($author$project$Locations$List$LocationList$getFacebookCategories, x.networkCategories, model.siteCategories));
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return A2($author$project$Locations$List$LocationList$getFacebookCategories, x.networkCategories, model.siteCategories);
						})) : $elm$core$Basics$identity;
			case 'BingCategoriesColumn':
				return bingEnabled ? A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$Listings$LocationDetail$categoriesBing(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(
							A2($author$project$Locations$List$LocationList$getBingCategories, x.networkCategories, model.siteCategories));
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return A2($author$project$Locations$List$LocationList$getBingCategories, x.networkCategories, model.siteCategories);
						})) : $elm$core$Basics$identity;
			case 'ContactPhoneColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationPhone(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(x.contact.phone);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.contact.phone;
						}));
			case 'ContactEmailColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationEmail(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(x.contact.email);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.contact.email;
						}));
			case 'ContactHomepageColumn':
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationHomepage(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(x.contact.homepage);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return x.contact.homepage;
						}));
			case 'OpenHoursColumn':
				var openHoursString = function (openHours) {
					return $author$project$Data$Location$OpenHours$openHoursAreSet(openHours) ? A2($author$project$Data$Location$OpenHours$openHoursToString, openHours, translations) : '';
				};
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationOpenHours(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						var tooltip = A2($author$project$Locations$List$TooltipRenderers$renderOpenHoursTooltip, x.openHours, translations);
						var target = $elm$html$Html$text(
							openHoursString(x.openHours));
						return A5($author$project$Locations$List$LocationList$wrapInTooltip, $author$project$Locations$List$Model$UiTooltipMsg, uiTooltip, x.id + '-openHours', target, tooltip);
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return openHoursString(x.openHours);
						}));
			case 'GoogleAttributesColumn':
				return googleEnabled ? A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationAttributes(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(
							$author$project$Locations$List$LocationList$networkAttributesToString(x.networkAttributes));
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return $author$project$Locations$List$LocationList$networkAttributesToString(x.networkAttributes);
						})) : $elm$core$Basics$identity;
			default:
				return A4(
					$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
					$author$project$Translations$General$locationActionLinks(translations),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Table$Tooltip, $author$project$PinMeTo$Ui$Table$MaxWidth]),
					function (x) {
						return $elm$html$Html$text(
							$author$project$Locations$List$LocationList$actionLinksToString(x.actionLinks));
					},
					$author$project$PinMeTo$Ui$Table$comparingString(
						function (x) {
							return $author$project$Locations$List$LocationList$actionLinksToString(x.actionLinks);
						}));
		}
	});
var $author$project$PinMeTo$Ui$Table$withSortingVisible = function (config) {
	return _Utils_update(
		config,
		{sortingVisible: true});
};
var $author$project$Locations$List$LocationList$locationListLazy = F6(
	function (session, uiTable, uiTooltip, columnList, locationList, allItems) {
		var translations = session.translations;
		var siteName = session.siteName;
		var items = A2(
			$elm$core$List$filter,
			function (x) {
				return A2($elm$core$Set$member, x.id, locationList.itemsMatchingFilter);
			},
			allItems);
		return A2(
			$author$project$PinMeTo$Ui$Table$render,
			uiTable,
			function (tableConfig) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (col, acc) {
							return A5($author$project$Locations$List$LocationList$createColumn, uiTooltip, col, session, locationList, acc);
						}),
					tableConfig,
					columnList);
			}(
				A2(
					$author$project$PinMeTo$Ui$Table$withStickyRowSelection,
					true,
					$author$project$PinMeTo$Ui$Table$withSortingVisible(
						$author$project$PinMeTo$Ui$Table$withScrollableTable(
							$author$project$PinMeTo$Ui$Table$withStickyHeader(
								A3(
									$author$project$PinMeTo$Ui$Table$withColumnSelectionAndLink,
									function (x) {
										return x.id;
									},
									function (location) {
										return '/listings/' + ($author$project$Data$SiteName$toString(siteName) + ('/locations/' + location.id));
									},
									A2(
										$author$project$PinMeTo$Ui$Table$withSort,
										$author$project$PinMeTo$Ui$Table$Asc(0),
										A2(
											$author$project$PinMeTo$Ui$Table$withLimit,
											{
												limit: 100,
												viewMoreLabel: $author$project$Labels$viewMore(translations)
											},
											A2($author$project$PinMeTo$Ui$Table$view, $author$project$Locations$List$Model$UiTableMsg, items))))))))));
	});
var $author$project$Locations$List$LocationList$view = F3(
	function (session, columnList, model) {
		var _v0 = model.allItems;
		switch (_v0.$) {
			case 'Loading':
				return $author$project$PinMeTo$Ui$Spinner$spinner;
			case 'Loaded':
				var allItems = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-table pmt-ui-font-note')
						]),
					_List_fromArray(
						[
							A7($elm$html$Html$Lazy$lazy6, $author$project$Locations$List$LocationList$locationListLazy, session, model.uiTable, model.uiTooltip, columnList, model.locationList, allItems)
						]));
			case 'Suspended':
				return $elm$html$Html$text('');
			default:
				var err = _v0.a;
				return $elm$html$Html$text(err);
		}
	});
var $author$project$PinMeTo$Ui$DownloadWithFilterButton$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Ui$DownloadWithFilterButton$view = function (config) {
	return $author$project$PinMeTo$Ui$DownloadWithFilterButton$View(
		{uid: config.uid, items: config.items, tagger: config.tagger, fileName: config.fileName, uiSelect: config.uiSelect, withNoHeader: false, withPlainButtonToggle: false});
};
var $author$project$FontAwesome$Solid$Icon$faDownload = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-download');
var $author$project$FontAwesome$Solid$faDownload = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faDownload);
var $author$project$PinMeTo$Ui$Select$withNoHeader = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Select$Config(
		_Utils_update(
			config,
			{withNoHeader: true}));
};
var $author$project$PinMeTo$Ui$Select$PlainLight = {$: 'PlainLight'};
var $author$project$PinMeTo$Ui$Select$withPlainButtonToggle = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Select$Config(
		_Utils_update(
			config,
			{toggleStyle: $author$project$PinMeTo$Ui$Select$PlainLight}));
};
var $author$project$PinMeTo$Ui$DownloadWithFilterButton$render = function (_v0) {
	var config = _v0.a;
	return A2(
		$author$project$PinMeTo$Ui$Select$render,
		config.uiSelect,
		function (view_) {
			var viewToggle = config.withNoHeader ? $author$project$PinMeTo$Ui$Select$withNoHeader(view_) : view_;
			return config.withPlainButtonToggle ? $author$project$PinMeTo$Ui$Select$withPlainButtonToggle(viewToggle) : viewToggle;
		}(
			$author$project$PinMeTo$Ui$Select$raw(
				{
					uid: config.uid,
					items: config.items,
					label: $author$project$FontAwesome$Solid$faDownload,
					tagger: config.tagger,
					itemRender: function (item) {
						return A3(
							$elm$html$Html$node,
							'pmt-download-with-filter-button',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'url', item.url),
									A2($elm$html$Html$Attributes$attribute, 'label', item.label),
									A2($elm$html$Html$Attributes$attribute, 'filename', config.fileName)
								]),
							_List_Nil);
					}
				})));
};
var $author$project$PinMeTo$Ui$Map$DefaultPinPopover = function (a) {
	return {$: 'DefaultPinPopover', a: a};
};
var $author$project$PinMeTo$Ui$Map$withPinPopover = F2(
	function (popover, pin_) {
		if (pin_.$ === 'Pin') {
			var config = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Pin(
				_Utils_update(
					config,
					{
						popover: $elm$core$Maybe$Just(
							$author$project$PinMeTo$Ui$Map$DefaultPinPopover(popover))
					}));
		} else {
			var feature = pin_.a;
			return $author$project$PinMeTo$Ui$Map$Feature(feature);
		}
	});
var $author$project$Locations$List$View$mapItem = F2(
	function (siteName, item) {
		var name_ = item.name + (' - ' + ((item.locationDescriptor !== '') ? item.locationDescriptor : item.storeId));
		return A2(
			$author$project$PinMeTo$Ui$Map$withPinPopover,
			{
				url: $elm$core$String$concat(
					_List_fromArray(
						[
							'/listings/',
							$author$project$Data$SiteName$toString(siteName),
							'/locations/',
							item.id,
							'/details'
						])),
				name: name_
			},
			$author$project$PinMeTo$Ui$Map$pin(item.location));
	});
var $author$project$PinMeTo$Ui$Map$Clustered = {$: 'Clustered'};
var $author$project$PinMeTo$Ui$Map$withMapTypeClustered = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Map$View(
		_Utils_update(
			config,
			{mapType: $author$project$PinMeTo$Ui$Map$Clustered}));
};
var $author$project$Locations$List$View$mapView = F2(
	function (siteName, items) {
		switch (items.$) {
			case 'Loading':
				return $elm$html$Html$text('');
			case 'Loaded':
				var xs = items.a;
				return $author$project$PinMeTo$Ui$Map$render(
					A2(
						$author$project$PinMeTo$Ui$Map$withOnPopulate,
						$author$project$PinMeTo$Ui$Map$FitBoundsOnPopulate,
						$author$project$PinMeTo$Ui$Map$withMapTypeClustered(
							A2(
								$author$project$PinMeTo$Ui$Map$withZoom,
								2,
								$author$project$PinMeTo$Ui$Map$view(
									A2(
										$elm$core$List$map,
										$author$project$Locations$List$View$mapItem(siteName),
										A2(
											$elm$core$List$filter,
											function (location) {
												return !_Utils_eq(location.locationType, $author$project$Data$Location$ServiceArea);
											},
											xs)))))));
			case 'Suspended':
				return $elm$html$Html$text('');
			default:
				var err = items.a;
				return $elm$html$Html$text(err);
		}
	});
var $author$project$Locations$List$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Locations$List$Model$Email = {$: 'Email'};
var $author$project$Locations$List$Model$Phone = {$: 'Phone'};
var $author$project$Locations$List$Model$Active = {$: 'Active'};
var $author$project$Locations$List$Model$Homepage = {$: 'Homepage'};
var $author$project$Locations$List$Model$WiFiName = {$: 'WiFiName'};
var $author$project$Locations$List$Model$OpenHours = {$: 'OpenHours'};
var $author$project$Locations$List$Model$AppleCategories = {$: 'AppleCategories'};
var $author$project$Locations$List$Model$LongDescription = {$: 'LongDescription'};
var $author$project$Locations$List$Model$GoogleAttributes = {$: 'GoogleAttributes'};
var $author$project$Locations$List$Model$GoogleCategories = {$: 'GoogleCategories'};
var $author$project$Locations$List$Model$ShortDescription = {$: 'ShortDescription'};
var $author$project$Locations$List$Model$SpecialOpenHours = {$: 'SpecialOpenHours'};
var $author$project$Locations$List$Model$FacebookCategories = {$: 'FacebookCategories'};
var $author$project$Locations$List$Model$TemporarilyClosedAction = {$: 'TemporarilyClosedAction'};
var $author$project$Locations$List$Model$actions = function (session) {
	var showCSView = A2($elm$core$List$member, $author$project$Data$User$CustomerSuccess, session.user.localAccess.roles) && (!session.user.isDemo);
	return showCSView ? _List_fromArray(
		[$author$project$Locations$List$Model$OpenHours, $author$project$Locations$List$Model$SpecialOpenHours, $author$project$Locations$List$Model$TemporarilyClosedAction, $author$project$Locations$List$Model$Homepage, $author$project$Locations$List$Model$Phone, $author$project$Locations$List$Model$Email, $author$project$Locations$List$Model$LongDescription, $author$project$Locations$List$Model$ShortDescription, $author$project$Locations$List$Model$WiFiName, $author$project$Locations$List$Model$GoogleCategories, $author$project$Locations$List$Model$GoogleAttributes, $author$project$Locations$List$Model$AppleCategories, $author$project$Locations$List$Model$FacebookCategories, $author$project$Locations$List$Model$Active]) : _List_fromArray(
		[$author$project$Locations$List$Model$OpenHours, $author$project$Locations$List$Model$SpecialOpenHours, $author$project$Locations$List$Model$TemporarilyClosedAction, $author$project$Locations$List$Model$Homepage, $author$project$Locations$List$Model$Phone, $author$project$Locations$List$Model$Email, $author$project$Locations$List$Model$LongDescription, $author$project$Locations$List$Model$ShortDescription, $author$project$Locations$List$Model$WiFiName, $author$project$Locations$List$Model$GoogleCategories, $author$project$Locations$List$Model$GoogleAttributes, $author$project$Locations$List$Model$AppleCategories, $author$project$Locations$List$Model$FacebookCategories]);
};
var $author$project$PinMeTo$Ui$Select$withOnOpen = F2(
	function (onOpen, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Select$Config(
			_Utils_update(
				config,
				{
					onOpen: $elm$core$Maybe$Just(onOpen)
				}));
	});
var $author$project$Translations$General$locationBulkActionDefault = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'general.location_bulk_action_default',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $author$project$Translations$General$locationBulkActionNoLocationsSelected = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.location_bulk_action_no_locations_selected');
};
var $author$project$Locations$List$Model$toHumanReadable = F3(
	function (model, translations, action) {
		var locationsQty = $elm$core$List$length(
			$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable));
		var defaultLabel = (!locationsQty) ? $author$project$Translations$General$locationBulkActionNoLocationsSelected(translations) : A2(
			$author$project$Translations$General$locationBulkActionDefault,
			translations,
			$elm$core$String$fromInt(locationsQty));
		switch (action.$) {
			case 'NoAction':
				return defaultLabel;
			case 'OpenHours':
				return $author$project$Translations$General$locationOpenHours(translations);
			case 'SpecialOpenHours':
				return $author$project$Translations$General$locationSpecialHours(translations);
			case 'TemporarilyClosedAction':
				return $author$project$Translations$General$locationTempClosed(translations);
			case 'Homepage':
				return $author$project$Translations$General$locationHomepage(translations);
			case 'Phone':
				return $author$project$Translations$General$locationPhone(translations);
			case 'Email':
				return $author$project$Translations$General$locationEmail(translations);
			case 'LongDescription':
				return $author$project$Translations$General$locationLongDescription(translations);
			case 'ShortDescription':
				return $author$project$Translations$General$locationShortDescription(translations);
			case 'WiFiName':
				return $author$project$Translations$General$locationWifi(translations);
			case 'GoogleCategories':
				return $author$project$Translations$Listings$LocationDetail$categoriesGoogle(translations);
			case 'AppleCategories':
				return $author$project$Translations$Listings$LocationDetail$categoriesApple(translations);
			case 'FacebookCategories':
				return $author$project$Translations$Listings$LocationDetail$categoriesFacebook(translations);
			case 'GoogleAttributes':
				return $author$project$Translations$General$locationAttributes(translations);
			case 'Active':
				return $author$project$Translations$Listings$LocationDetail$active(translations);
			default:
				return '';
		}
	});
var $author$project$PinMeTo$Ui$Select$withDataTestAttribute = F2(
	function (attribute, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Select$Config(
			_Utils_update(
				config,
				{
					dataTestAttribute: $elm$core$Maybe$Just(attribute)
				}));
	});
var $author$project$Locations$List$Model$actionToString = function (action) {
	switch (action.$) {
		case 'NoAction':
			return 'Drop Down opened';
		case 'OpenHours':
			return 'Open Hours';
		case 'SpecialOpenHours':
			return 'Special Open Hours';
		case 'TemporarilyClosedAction':
			return 'Temporarily Closed';
		case 'Homepage':
			return 'Homepage';
		case 'Phone':
			return 'Phone';
		case 'Email':
			return 'Email';
		case 'LongDescription':
			return 'Long Description';
		case 'ShortDescription':
			return 'Short Description';
		case 'WiFiName':
			return 'Wifi Name';
		case 'GoogleCategories':
			return 'Google Categories';
		case 'AppleCategories':
			return 'Apple Categories';
		case 'FacebookCategories':
			return 'Facebook Categories';
		case 'GoogleAttributes':
			return 'Google Attributes';
		default:
			return '';
	}
};
var $author$project$Locations$List$Model$actionToTrackingKey = function (bulkActionPopUp) {
	switch (bulkActionPopUp.$) {
		case 'NoAction':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.dropDownOpened;
		case 'SpecialOpenHours':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.specialOpenHoursUpdated;
		case 'TemporarilyClosedAction':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.temporarilyClosedUpdated;
		case 'Homepage':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.homepageUpdated;
		case 'OpenHours':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.openHoursUpdated;
		case 'Phone':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.phoneNumberUpdated;
		case 'Email':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.emailUpdated;
		case 'LongDescription':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.longDescriptionUpdated;
		case 'ShortDescription':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.shortDescriptionUpdated;
		case 'WiFiName':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.wifiNameUpdated;
		case 'GoogleCategories':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.googleCategoriesUpdated;
		case 'FacebookCategories':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.facebookCategoriesUpdated;
		case 'AppleCategories':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.appleCategoriesUpdated;
		case 'GoogleAttributes':
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.googleAttributesUpdated;
		default:
			return $author$project$PlanHat$TrackingActions$keys.bulkUpdate.temporarilyClosedUpdated;
	}
};
var $author$project$Locations$List$Model$bulkActionToEditorState = F2(
	function (model, action) {
		var locations = $elm$core$Maybe$Just(
			{
				locations: $author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable)
			});
		var tracking = $elm$core$Maybe$Just(
			{
				info: 'Bulk Actions: ' + ($author$project$Locations$List$Model$actionToString(action) + (' changed for ' + ($elm$core$String$fromInt(
					$elm$core$List$length(
						$author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable))) + ' locations'))),
				action: $author$project$Locations$List$Model$actionToTrackingKey(action)
			});
		switch (action.$) {
			case 'SpecialOpenHours':
				return A3($author$project$Location$Details$Editor$SpecialOpenHoursEditor, $author$project$Location$Details$PopupContent$SpecialOpenHours$SideBar, locations, tracking);
			case 'TemporarilyClosedAction':
				return A2($author$project$Location$Details$Editor$TemporarilyClosedEditor, locations, tracking);
			case 'Homepage':
				return A2($author$project$Location$Details$Editor$HomepageEditor, locations, tracking);
			case 'OpenHours':
				return A2($author$project$Location$Details$Editor$OpenHoursEditor, locations, tracking);
			case 'Phone':
				return A2($author$project$Location$Details$Editor$PhoneEditor, locations, tracking);
			case 'Email':
				return A2($author$project$Location$Details$Editor$EmailEditor, locations, tracking);
			case 'LongDescription':
				return A2($author$project$Location$Details$Editor$LongDescriptionEditor, locations, tracking);
			case 'ShortDescription':
				return A2($author$project$Location$Details$Editor$ShortDescriptionEditor, locations, tracking);
			case 'WiFiName':
				return A2($author$project$Location$Details$Editor$WifiEditor, locations, tracking);
			case 'GoogleCategories':
				return A3($author$project$Location$Details$Editor$CategoriesEditor, $author$project$Data$Network$Google, locations, tracking);
			case 'AppleCategories':
				return A3($author$project$Location$Details$Editor$CategoriesEditor, $author$project$Data$Network$Apple, locations, tracking);
			case 'FacebookCategories':
				return A3($author$project$Location$Details$Editor$CategoriesEditor, $author$project$Data$Network$Facebook, locations, tracking);
			case 'GoogleAttributes':
				return A3($author$project$Location$Details$Editor$GoogleAttributesEditor, _List_Nil, locations, tracking);
			case 'Active':
				return A2($author$project$Location$Details$Editor$ActiveEditor, locations, tracking);
			default:
				return A2($author$project$Location$Details$Editor$TemporarilyClosedEditor, locations, tracking);
		}
	});
var $author$project$Locations$List$Model$BulkUpdateDropdownOpened = {$: 'BulkUpdateDropdownOpened'};
var $author$project$Locations$List$Model$LocationDetailsEditorMsg = function (a) {
	return {$: 'LocationDetailsEditorMsg', a: a};
};
var $author$project$PinMeTo$Ui$Select$Positive = {$: 'Positive'};
var $author$project$PinMeTo$Ui$Select$withPositiveButtonToggle = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Select$Config(
		_Utils_update(
			config,
			{toggleStyle: $author$project$PinMeTo$Ui$Select$Positive}));
};
var $author$project$Locations$List$Model$LocationDetailsEditorOpen = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorOpen', a: a, b: b};
	});
var $author$project$Locations$List$Model$LocationDetailsEditorClose = {$: 'LocationDetailsEditorClose'};
var $author$project$Locations$List$View$bulkActions = F2(
	function (session, model) {
		var postNote = $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-view-selector')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Select$render,
					model.uiSelect,
					A2(
						$author$project$PinMeTo$Ui$Select$withDataTestAttribute,
						$author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute('pmt-listings-bulk-actions-drop-down'),
						A2(
							$author$project$PinMeTo$Ui$Select$withOnOpen,
							function (_v0) {
								return $author$project$Locations$List$Model$BulkUpdateDropdownOpened;
							},
							$author$project$PinMeTo$Ui$Select$withPositiveButtonToggle(
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'select-locale',
										items: $author$project$Locations$List$Model$actions(session),
										label: $elm$html$Html$text(
											A3($author$project$Locations$List$Model$toHumanReadable, model, session.translations, model.bulkAction)),
										tagger: $author$project$Locations$List$Model$UiSelectMsg,
										onChange: function (action) {
											return A2(
												$author$project$Locations$List$Model$LocationDetailsEditorOpen,
												action,
												A2($author$project$Locations$List$Model$bulkActionToEditorState, model, action));
										},
										itemRender: A2(
											$elm$core$Basics$composeR,
											A2($author$project$Locations$List$Model$toHumanReadable, model, session.translations),
											$elm$html$Html$text)
									}))))),
					postNote,
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (editor) {
							return A4(
								$author$project$Location$Details$Editor$view,
								{tagger: $author$project$Locations$List$Model$LocationDetailsEditorMsg, onCancel: $author$project$Locations$List$Model$LocationDetailsEditorClose, onSubmit: $author$project$Locations$List$Model$LocationDetailsEditorClose, withScheduling: true},
								{user: session.user, locale: session.locale, language: session.language, translations: session.translations},
								$elm$core$Maybe$Nothing,
								editor);
						},
						model.editor))
				]));
	});
var $author$project$PinMeTo$Ui$DownloadWithFilterButton$withNoHeader = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$DownloadWithFilterButton$View(
		_Utils_update(
			config,
			{withNoHeader: true}));
};
var $author$project$PinMeTo$Ui$FilterController$withRightNode = F2(
	function (x, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$FilterController$View(
			_Utils_update(
				config,
				{
					rightNode: $elm$core$Maybe$Just(x)
				}));
	});
var $author$project$Filter$FilterController$viewLocations = F7(
	function (tagger, filterControls, model, itemCount, locale, translations, language) {
		var filterLabels = A2($author$project$Filter$FilterLabels$locationsFilterControllerLabels, translations, language);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$PinMeTo$Global$FilterController$render,
					A3($author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels, translations, language, filterLabels),
					A2($elm$core$Basics$composeR, $author$project$Filter$FilterController$UiFilteredListMsg, tagger),
					model.uiFilteredList,
					A2(
						$author$project$PinMeTo$Ui$FilterController$withResultsCount,
						itemCount,
						A2(
							$author$project$PinMeTo$Ui$FilterController$withRightNode,
							filterControls,
							$author$project$PinMeTo$Ui$FilterController$view(
								{uid: 'filter-controller-locations', labels: filterLabels, locale: locale}))))
				]));
	});
var $author$project$PinMeTo$Ui$Btn$Create = {$: 'Create'};
var $author$project$Locations$List$Model$SelectView = function (a) {
	return {$: 'SelectView', a: a};
};
var $author$project$Translations$Listings$LocationList$addLocation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_list.add_location');
};
var $author$project$Locations$List$View$renderLocationListControls = F2(
	function (session, model) {
		var mapViewToggleButton = function () {
			var mapIsOn = _Utils_eq(model.viewType, $author$project$Locations$List$Model$ListView);
			var iconClass = mapIsOn ? 'location-details__map-off-svg-icon ' : 'location-details__map-on-svg-icon';
			var newViewType = mapIsOn ? $author$project$Locations$List$Model$MapView : $author$project$Locations$List$Model$ListView;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('location-details__circle-toggle-button', true)
							])),
						$elm$html$Html$Events$onClick(
						$author$project$Locations$List$Model$SelectView(newViewType))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(iconClass)
							]),
						_List_Nil)
					]));
		}();
		var addLocationButton = model.hasCreateLocationPermission ? A4(
			$author$project$PinMeTo$Ui$Btn$pmtBtnCtaMuted,
			$author$project$PinMeTo$Ui$Btn$Create,
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-page-actions__cta'),
					$elm$html$Html$Attributes$href(
					$elm$core$String$concat(
						_List_fromArray(
							[
								'/listings/',
								$author$project$Data$SiteName$toString(session.siteName),
								'/locations/add'
							])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$LocationList$addLocation(session.translations))
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-page-actions')
				]),
			_List_fromArray(
				[addLocationButton, mapViewToggleButton]));
	});
var $author$project$Locations$List$View$renderControls = F2(
	function (session, model) {
		var itemCount = function () {
			var _v0 = model.allItems;
			if (_v0.$ === 'Loaded') {
				return $elm$core$Set$size(model.locationList.itemsMatchingFilter);
			} else {
				return 0;
			}
		}();
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (model_) {
				return A7(
					$author$project$Filter$FilterController$viewLocations,
					$author$project$Locations$List$Model$FilterControllerMsg,
					A2($author$project$Locations$List$View$renderLocationListControls, session, model),
					model_,
					itemCount,
					session.locale,
					session.translations,
					session.language);
			},
			model.filterController);
	});
var $author$project$Translations$Listings$LocationList$downloadAllDataCsv = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_list.download_all_data_csv');
};
var $author$project$Translations$Listings$LocationList$downloadAllDataXlsx = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.location_list.download_all_data_xlsx');
};
var $author$project$PinMeTo$Ui$DownloadWithFilterButton$withPlainButtonToggle = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$DownloadWithFilterButton$View(
		_Utils_update(
			config,
			{withPlainButtonToggle: true}));
};
var $author$project$Data$User$containsCustomerSuccessOrDeveloper = function (list) {
	return A2(
		$elm$core$List$any,
		function (role) {
			return _Utils_eq(
				role,
				$author$project$Data$User$SystemRole('customersuccess')) || _Utils_eq(
				role,
				$author$project$Data$User$SystemRole('pinmetodeveloper'));
		},
		list);
};
var $author$project$Locations$List$View$view = F3(
	function (session, columnList, model) {
		var filterQueryString = F2(
			function (extraParams, fileType) {
				var selectedLocations = $author$project$PinMeTo$Ui$Table$selectedItems(model.uiTable);
				var filterParam = (!$elm$core$List$length(selectedLocations)) ? A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function (x) {
						return A2(
							$elm$core$String$dropLeft,
							1,
							$author$project$Filter$FilterController$getCurrentFilterAsQueryString(x));
					},
					model.filterController) : ('listFilter=locations=[' + (A2($elm$core$String$join, ',', selectedLocations) + ']'));
				var queryParams = A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					A2($elm$core$List$cons, filterParam, extraParams));
				var baseUrl = $elm$core$String$concat(
					_List_fromArray(
						[
							'listings/api/',
							$author$project$Data$SiteName$toString(session.siteName),
							'/export/locations/',
							fileType
						]));
				return $elm$core$List$isEmpty(queryParams) ? baseUrl : (baseUrl + ('?' + A2($elm$core$String$join, '&', queryParams)));
			});
		var fullExportItems = $author$project$Data$User$containsCustomerSuccessOrDeveloper(session.user.systemRoles) ? _List_fromArray(
			[
				{
				url: A2(
					filterQueryString,
					_List_fromArray(
						['fullExport=1']),
					'csv'),
				label: $author$project$Translations$Listings$LocationList$downloadAllDataCsv(session.translations)
			},
				{
				url: A2(
					filterQueryString,
					_List_fromArray(
						['fullExport=1']),
					'xlsx'),
				label: $author$project$Translations$Listings$LocationList$downloadAllDataXlsx(session.translations)
			}
			]) : _List_Nil;
		var downloadButton = $author$project$PinMeTo$Ui$DownloadWithFilterButton$render(
			$author$project$PinMeTo$Ui$DownloadWithFilterButton$withNoHeader(
				$author$project$PinMeTo$Ui$DownloadWithFilterButton$withPlainButtonToggle(
					$author$project$PinMeTo$Ui$DownloadWithFilterButton$view(
						{
							uid: 'ui-select-download-locations',
							items: _Utils_ap(
								_List_fromArray(
									[
										{
										url: A2(filterQueryString, _List_Nil, 'csv'),
										label: $author$project$Translations$General$downloadCsvSpreadsheet(session.translations)
									},
										{
										url: A2(filterQueryString, _List_Nil, 'xlsx'),
										label: $author$project$Translations$General$downloadXlsxSpreadsheet(session.translations)
									}
									]),
								fullExportItems),
							tagger: $author$project$Locations$List$Model$UiSelectMsg,
							fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Locations_' + $justinmimbs$date$Date$toIsoString(model.today))),
							uiSelect: model.uiSelect
						}))));
		var viewList = A3($author$project$Locations$List$LocationList$view, session, columnList, model);
		var items = function () {
			var _v0 = model.allItems;
			switch (_v0.$) {
				case 'Loaded':
					var xs = _v0.a;
					return $author$project$RemoteData$Loaded(
						A2(
							$elm$core$List$filter,
							function (x) {
								return A2($elm$core$Set$member, x.id, model.locationList.itemsMatchingFilter);
							},
							xs));
				case 'Suspended':
					return $author$project$RemoteData$Suspended;
				case 'Loading':
					return $author$project$RemoteData$Loading;
				default:
					var e = _v0.a;
					return $author$project$RemoteData$Error(e);
			}
		}();
		var viewMap = _Utils_eq(model.viewType, $author$project$Locations$List$Model$MapView) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '600px')
				]),
			_List_fromArray(
				[
					A2($author$project$Locations$List$View$mapView, session.siteName, items)
				])) : $elm$html$Html$text('');
		var menu = function () {
			var viewTypeClass = _Utils_eq(model.viewType, $author$project$Locations$List$Model$MapView) ? 'pmt-pagination location-details--location-list-header location-details--location-list-header-with-map' : 'pmt-pagination location-details--location-list-header';
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-page__content')
									]),
								_List_fromArray(
									[
										A2($author$project$Locations$List$View$renderControls, session, model),
										viewMap,
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(viewTypeClass)
											]),
										_List_fromArray(
											[
												A2($author$project$Locations$List$View$bulkActions, session, model),
												downloadButton
											])),
										viewList
									]))
							]))
					]));
		}();
		return menu;
	});
var $author$project$Locations$List$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Locations$List$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Locations$List$Main$matchesFilter = F2(
	function (filter_, details) {
		return A2(
			$elm$core$List$any,
			function (detail) {
				return A2($elm$core$String$contains, filter_, detail);
			},
			details);
	});
var $author$project$Locations$List$Main$filterItems = F2(
	function (filter, locations) {
		return $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				A2(
					$elm$core$List$filter,
					function (x) {
						return A2(
							$author$project$Locations$List$Main$matchesFilter,
							$author$project$PinMeTo$Common$StringNormalize$normalize(
								$elm$core$String$toLower(filter)),
							x.location);
					},
					locations)));
	});
var $author$project$PinMeTo$Ui$FilterController$openSearchOptions = function (_v0) {
	var loading = _v0.a;
	var model = _v0.b;
	return A2(
		$author$project$PinMeTo$Ui$FilterController$State,
		loading,
		_Utils_update(
			model,
			{searchOptionsToggled: true}));
};
var $author$project$PinMeTo$Global$FilterController$openFilters = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Global$FilterController$State(
		_Utils_update(
			model,
			{
				uiFilterController: $author$project$PinMeTo$Ui$FilterController$openSearchOptions(model.uiFilterController)
			}));
};
var $author$project$Filter$FilterController$openFilters = function (model) {
	return _Utils_update(
		model,
		{
			uiFilteredList: $author$project$PinMeTo$Global$FilterController$openFilters(model.uiFilteredList)
		});
};
var $author$project$Locations$List$Model$ViewTypeSent = function (a) {
	return {$: 'ViewTypeSent', a: a};
};
var $author$project$Filter$FilterController$encodeFilter = function (filterDefinitionEncoded) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('filter', filterDefinitionEncoded)
			]));
};
var $author$project$Data$Location$EmptyLocation$emptyLocation = {
	id: '',
	ptv: $elm$core$Maybe$Nothing,
	bing: $elm$core$Maybe$Nothing,
	name: '',
	about: $author$project$Data$Location$ShortDescription(''),
	apple: $elm$core$Maybe$Nothing,
	email: $author$project$Data$Location$Email(''),
	phone: $author$project$Data$Location$Phone(''),
	google: $elm$core$Maybe$Nothing,
	address: {
		zip: '',
		city: '',
		street: '',
		country: '',
		stateOrProvince: $author$project$Data$Address$WithState(''),
		countryAlpha2Code: ''
	},
	storeId: $author$project$Data$Location$StoreId(''),
	facebook: $elm$core$Maybe$Nothing,
	homepage: $author$project$Data$Location$Homepage(''),
	isActive: $author$project$Data$Location$Active,
	location: {lat: 0, lon: 0},
	wifiSsId: $author$project$Data$Location$WifiSsId(''),
	fbStoreId: $author$project$Data$Location$FacebookStoreId($elm$core$Maybe$Nothing),
	openHours: $author$project$Data$Location$OpenHours$Always,
	customData: $elm$core$Maybe$Nothing,
	actionLinks: _List_Nil,
	openingDate: '',
	locationType: $author$project$Data$Location$Storefront,
	networkMedia: {
		google: {coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing},
		facebook: {coverImage: $elm$core$Maybe$Nothing, profileImage: $elm$core$Maybe$Nothing}
	},
	networkNames: {ptv: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing},
	serviceAreas: $author$project$Data$ServiceArea$None,
	verification: $elm$core$Maybe$Nothing,
	storefrontName: $author$project$Data$Location$StorefrontName(''),
	longDescription: $author$project$Data$Location$LongDescription(''),
	specialOpenHours: _List_Nil,
	networkAttributes: {google: _List_Nil},
	networkCategories: {bing: $elm$core$Maybe$Nothing, here: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, tomtom: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, overture: $elm$core$Maybe$Nothing, foursquare: $elm$core$Maybe$Nothing},
	permanentlyClosed: false,
	locationDescriptor: $author$project$Data$Location$LocationDescriptor(''),
	networkServiceItems: {google: _List_Nil},
	newGoogleReviewLink: $author$project$Data$Location$NewReviewUrl(''),
	alternativeSearchNames: $author$project$Data$Location$AlternativeSearchNames(_List_Nil),
	temporarilyClosedUntil: $author$project$Data$NetworkData$TemporarilyClosed$NotTemporarilyClosed,
	temporarilyClosedMessage: $author$project$Data$Location$TemporarilyClosedMessage(''),
	hasTransitionedToNewPageExperience: false
};
var $author$project$Locations$List$Model$SchedulerUpdated = function (a) {
	return {$: 'SchedulerUpdated', a: a};
};
var $author$project$Locations$List$Model$viewTypeToString = function (viewType) {
	if (viewType.$ === 'ListView') {
		return 'list';
	} else {
		return 'map';
	}
};
var $author$project$Locations$List$Main$listToString = $elm$core$String$join(', ');
var $author$project$Locations$List$Main$formatLinks = function (links) {
	return $author$project$Locations$List$Main$listToString(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.url;
			},
			links));
};
var $author$project$Locations$List$Main$formatAttributes = function (maybeAttrs) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (attrs) {
			return $author$project$Locations$List$Main$listToString(
				A2(
					$elm$core$List$map,
					function (value) {
						return value.attributeId;
					},
					attrs.google));
		},
		maybeAttrs);
};
var $author$project$Locations$List$Main$getCategoryNames = function (maybeCategories) {
	if (maybeCategories.$ === 'Just') {
		var categories = maybeCategories.a;
		var additionalCategories = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.name;
				},
				categories.additional));
		var primaryCategory = function () {
			var _v1 = categories.primary;
			if (_v1.$ === 'Just') {
				var category = _v1.a;
				return category.name;
			} else {
				return '';
			}
		}();
		return ((primaryCategory !== '') && (additionalCategories !== '')) ? (primaryCategory + (', ' + additionalCategories)) : _Utils_ap(primaryCategory, additionalCategories);
	} else {
		return '';
	}
};
var $author$project$Locations$List$Main$getBingCategoryNames = function (maybeCategories) {
	if (maybeCategories.$ === 'Just') {
		var categories = maybeCategories.a;
		var additionalCategories = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.name;
				},
				categories.categories));
		var primaryCategory = function () {
			var _v1 = categories.primaryCategoryId;
			if (_v1.$ === 'Just') {
				var categoryId = _v1.a;
				return categoryId;
			} else {
				return '';
			}
		}();
		return ((primaryCategory !== '') && (additionalCategories !== '')) ? (primaryCategory + (', ' + additionalCategories)) : _Utils_ap(primaryCategory, additionalCategories);
	} else {
		return '';
	}
};
var $author$project$Locations$List$Main$getFacebookCategoryNames = function (maybeCategories) {
	if (maybeCategories.$ === 'Just') {
		var categories = maybeCategories.a;
		return A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.name;
				},
				categories.subcategories));
	} else {
		return '';
	}
};
var $author$project$Locations$List$Main$getLocationDetails = F2(
	function (x, translations) {
		var facebookCategories = $author$project$Locations$List$Main$getFacebookCategoryNames(x.networkCategories.facebook);
		var googleCategories = $author$project$Locations$List$Main$getCategoryNames(x.networkCategories.google);
		var appleCategories = $author$project$Locations$List$Main$getCategoryNames(x.networkCategories.apple);
		var bingCategories = $author$project$Locations$List$Main$getBingCategoryNames(x.networkCategories.bing);
		return {
			id: x.id,
			location: A2(
				$elm$core$List$map,
				$author$project$PinMeTo$Common$StringNormalize$normalize,
				A2(
					$elm$core$List$map,
					$elm$core$String$toLower,
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								x.name,
								x.storeId,
								x.address.street,
								x.address.zip,
								x.address.city,
								x.address.country,
								x.contact.phone,
								x.contact.email,
								x.contact.homepage,
								x.longDescription,
								x.shortDescription,
								x.locationDescriptor,
								$author$project$Data$Address$getState(x.address),
								$author$project$Data$Address$getProvince(x.address),
								$author$project$Data$Address$getDistrict(x.address),
								x.locationDescriptor,
								$author$project$Locations$List$Main$formatLinks(x.actionLinks),
								$author$project$Locations$List$Main$formatAttributes(x.networkAttributes),
								googleCategories,
								appleCategories,
								facebookCategories,
								bingCategories,
								A2($author$project$Locations$List$Model$openStatusToString, x.status, translations),
								A2($author$project$Locations$List$Model$locationTypeToString, x.locationType, translations),
								x.temporarilyClosedUntil
							]),
						x.serviceAreas)))
		};
	});
var $author$project$Locations$List$Main$getNormalizedItems = F2(
	function (locations, translations) {
		return A2(
			$elm$core$List$map,
			function (x) {
				return A2($author$project$Locations$List$Main$getLocationDetails, x, translations);
			},
			locations);
	});
var $author$project$Locations$List$Model$FilterBySearchQuery = F2(
	function (a, b) {
		return {$: 'FilterBySearchQuery', a: a, b: b};
	});
var $author$project$Location$Details$Model$SideBarSpecialOpenHoursUpdateResult = function (storeIds) {
	return {storeIds: storeIds};
};
var $author$project$Location$Details$Commands$sideBarSpecialOpenHoursUpdateResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['storeIds']),
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Location$Details$Model$SideBarSpecialOpenHoursUpdateResult));
var $author$project$Location$Details$Commands$sendToAddSpecialOpenHours = F4(
	function (_v0, locationId, msg, json) {
		var siteName = _v0.a;
		var locationIdUrl = (locationId !== '') ? ('?returnPlaceId=' + locationId) : locationId;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Location$Details$Commands$sideBarSpecialOpenHoursUpdateResultDecoder, $elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + ('/places/addSpecialOpenHours/' + locationIdUrl))))));
	});
var $author$project$Locations$List$Model$LdpSpecialOpenHoursUpdated = function (a) {
	return {$: 'LdpSpecialOpenHoursUpdated', a: a};
};
var $author$project$Location$Details$Commands$sendToPartialUpdateMutiple_ = F5(
	function (_v0, features, customDataDefinition, msg, json) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($author$project$Location$Details$Commands$partialUpdateResultDecoder, features, customDataDefinition),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + '/places/partialUpdateMultiple/')))));
	});
var $author$project$Locations$List$Model$LocationDetailsEditorUpdated = F2(
	function (a, b) {
		return {$: 'LocationDetailsEditorUpdated', a: a, b: b};
	});
var $author$project$Location$Details$Commands$deleteScheduleUpdateMultiple = F3(
	function (_v0, scheduleId, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Location$Details$Commands$scheduleUpdatesDecoder($elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$delete('api/' + (siteName + ('/places/schedule/' + scheduleId))))));
	});
var $author$project$Location$Details$Commands$sendToScheduleUpdateMultiple_ = F3(
	function (_v0, msg, json) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$author$project$Location$Details$Commands$scheduleUpdatesDecoder($elm$core$Maybe$Nothing),
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/places/schedule')))));
	});
var $author$project$Locations$List$Model$SideBarSpecialOpenHoursUpdated = function (a) {
	return {$: 'SideBarSpecialOpenHoursUpdated', a: a};
};
var $author$project$Locations$List$Main$out_Locations_List_Main_onFilter = _Platform_outgoingPort('out_Locations_List_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Locations$List$Main$out_Locations_List_Main_onSearchQuery = _Platform_outgoingPort('out_Locations_List_Main_onSearchQuery', $elm$json$Json$Encode$string);
var $author$project$Locations$List$Main$out_Locations_List_Main_ViewTypeChange = _Platform_outgoingPort(
	'out_Locations_List_Main_ViewTypeChange',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'viewType',
					$elm$json$Json$Encode$string($.viewType))
				]));
	});
var $author$project$Data$GoogleAttributes$Api$addChosenAttributesToLocations = F4(
	function (siteName, returnPlaceId, editor, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								$author$project$Data$GoogleAttributes$Api$encodeLocationIds(editor.locationIds),
								$author$project$Data$GoogleAttributes$Api$encodeAttributes(editor.attributes)
							])),
					$lukewestby$elm_http_builder$HttpBuilder$put(
						A2(
							$author$project$Data$GoogleAttributes$Api$withReturnPlaceId,
							returnPlaceId,
							$author$project$Data$GoogleAttributes$Api$siteUrl(siteName) + '/places/google/attributes/addChosen')))));
	});
var $author$project$Location$Details$Commands$addChosenGoogleAttributesFromUpdateMultiple = F4(
	function (siteName, features, editor, msg) {
		return A4(
			$author$project$Data$GoogleAttributes$Api$addChosenAttributesToLocations,
			siteName,
			$elm$core$List$head(editor.locationIds),
			editor,
			A3(
				$author$project$PinMeTo$ExpectJson$expectJson,
				msg,
				A2($author$project$Location$Details$Commands$partialUpdateResultDecoder, features, $elm$core$Maybe$Nothing),
				$elm$json$Json$Decode$string));
	});
var $author$project$Locations$List$Main$update = F3(
	function (session, msg, model) {
		var encoded = function (viewType) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'key',
						$elm$json$Json$Encode$string('locationListView')),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$string(
							$author$project$Locations$List$Model$viewTypeToString(viewType)))
					]));
		};
		var saveViewType = function (viewType) {
			return $lukewestby$elm_http_builder$HttpBuilder$request(
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					$elm$http$Http$expectWhatever($author$project$Locations$List$Model$ViewTypeSent),
					A2(
						$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
						encoded(viewType),
						$lukewestby$elm_http_builder$HttpBuilder$put(
							'api/user/settings/' + $author$project$Data$SiteName$toString(session.siteName)))));
		};
		switch (msg.$) {
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UiTooltipMsg':
				var msg_ = msg.a;
				var _v1 = A3($author$project$PinMeTo$Ui$AdvancedTooltip$update, $author$project$Locations$List$Model$UiTooltipMsg, msg_, model.uiTooltip);
				var uiTooltip = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiTooltip: uiTooltip}),
					cmd);
			case 'GetToday':
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{today: date}),
					$elm$core$Platform$Cmd$none);
			case 'LocationsLoaded':
				if (msg.a.$ === 'Ok') {
					var loadedItems = msg.a.a;
					var xs = session.user.isDemo ? A2(
						$elm$core$List$filter,
						function (x) {
							return !_Utils_eq(x.status, $author$project$Locations$List$Model$Disabled);
						},
						loadedItems) : loadedItems;
					var normalizedItems = A2($author$project$Locations$List$Main$getNormalizedItems, xs, session.translations);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uiTable: $author$project$PinMeTo$Ui$Table$init,
								allItems: $author$project$RemoteData$Loaded(xs),
								locationList: function (locationList) {
									return _Utils_update(
										locationList,
										{
											itemsMatchingFilter: A2(
												$author$project$Locations$List$Main$filterItems,
												A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, model.initialQuery),
												normalizedItems)
										});
								}(model.locationList),
								normalizedItems: normalizedItems,
								allItemsMatchingFilter: $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.id;
										},
										normalizedItems))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								uiTable: $author$project$PinMeTo$Ui$Table$init,
								allItems: $author$project$RemoteData$Error(
									$author$project$PinMeTo$Common$Util$httpErrorToString(err))
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.List.Main', message: 'Failed to handle msg LocationsLoaded'}));
				}
			case 'SelectView':
				var viewType = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{viewType: viewType}),
					saveViewType(viewType));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Locations$List$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (model_) {
						var _v2 = A5($author$project$Filter$FilterController$update, $author$project$Locations$List$Model$FilterControllerMsg, msg_, model_, $author$project$Locations$List$Model$OnFilter, $author$project$Locations$List$Model$OnSearch);
						var filterControllerModel_ = _v2.a;
						var filterControllerCmd_ = _v2.b;
						var filterControllerModelWithOpened = model.openFilterOnLoad ? $elm$core$Maybe$Just(
							$author$project$Filter$FilterController$openFilters(filterControllerModel_)) : $elm$core$Maybe$Just(filterControllerModel_);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{filterController: filterControllerModelWithOpened, openFilterOnLoad: false}),
							filterControllerCmd_);
					},
					model.filterController);
			case 'OnFilter':
				var filterDefinition = msg.a;
				return model.receivedInitialFilterDefinition ? _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Locations$List$Main$getLocations,
								session.siteName,
								model.today,
								$elm$core$Maybe$Just(
									$author$project$Filter$FilterController$encodeFilter(filterDefinition))),
								$author$project$Locations$List$Main$out_Locations_List_Main_onFilter(filterDefinition)
							]))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{receivedInitialFilterDefinition: true}),
					$author$project$Locations$List$Main$out_Locations_List_Main_onFilter(filterDefinition));
			case 'FilterBySearchQuery':
				var searchId = msg.a;
				var query = msg.b;
				var performFilter = function (q) {
					return (q === '') ? model.allItemsMatchingFilter : A2($author$project$Locations$List$Main$filterItems, q, model.normalizedItems);
				};
				return _Utils_eq(searchId, model.latestSearchId) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							locationList: function (locationList) {
								return _Utils_update(
									locationList,
									{
										itemsMatchingFilter: performFilter(query)
									});
							}(model.locationList)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnSearch':
				var query = msg.a;
				var debounceDelay = 250;
				var newSearchId = model.latestSearchId + 1;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{latestSearchId: newSearchId}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								function (_v3) {
									return A2($author$project$Locations$List$Model$FilterBySearchQuery, newSearchId, query);
								},
								$elm$core$Process$sleep(debounceDelay)),
								$author$project$Locations$List$Main$out_Locations_List_Main_onSearchQuery(query)
							])));
			case 'ViewTypeSent':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$author$project$Locations$List$Main$out_Locations_List_Main_ViewTypeChange(
							{
								viewType: $author$project$Locations$List$Model$viewTypeToString(model.viewType)
							}));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'LocationDetailsEditorOpen':
				var action = msg.a;
				var editor = msg.b;
				var editorType = editor;
				var _v4 = A3(
					$elm$core$Tuple$mapBoth,
					function (editorModel) {
						return _Utils_update(
							model,
							{
								editor: $elm$core$Maybe$Just(editorModel),
								bulkAction: action
							});
					},
					$elm$core$Platform$Cmd$map($author$project$Locations$List$Model$LocationDetailsEditorMsg),
					A7(
						$author$project$Location$Details$Editor$init,
						{bing: $elm$core$Maybe$Nothing, here: $elm$core$Maybe$Nothing, apple: $elm$core$Maybe$Nothing, google: $elm$core$Maybe$Nothing, tomtom: $elm$core$Maybe$Nothing, facebook: $elm$core$Maybe$Nothing, overture: $elm$core$Maybe$Nothing, foursquare: $elm$core$Maybe$Nothing},
						$author$project$Location$Details$PopupContent$TemporarilyClosed$dateToPosix(model.today),
						$author$project$Data$Location$EmptyLocation$emptyLocation,
						session,
						true,
						_List_Nil,
						editorType));
				var state = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(state, cmd);
			case 'LocationDetailsEditorMsg':
				var editorMsg = msg.a;
				var _v5 = model.editor;
				if (_v5.$ === 'Just') {
					var editor = _v5.a;
					var _v6 = editor;
					var editor_ = _v6.a;
					var _v7 = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_Utils_Tuple3(
							A3($author$project$Location$Details$Commands$sendToPartialUpdateMutiple_, session.siteName, session.features, $elm$core$Maybe$Nothing),
							$author$project$Location$Details$Commands$sendToScheduleUpdateMultiple_(session.siteName),
							$author$project$Location$Details$Commands$deleteScheduleUpdateMultiple(session.siteName)),
						function (locationId) {
							return _Utils_Tuple3(
								A4($author$project$Location$Details$Commands$sendToPartialUpdate_, session.siteName, locationId, session.features, $elm$core$Maybe$Nothing),
								A3($author$project$Location$Details$Commands$sendToScheduleUpdate_, session.siteName, $elm$core$Maybe$Nothing, locationId),
								A2($author$project$Location$Details$Commands$deleteScheduleUpdate, session.siteName, locationId));
						},
						$elm$core$List$head(editor_.selectedLocations));
					var updateCommand = _v7.a;
					var scheduleCommand = _v7.b;
					var deleteCommand = _v7.c;
					var updateCommandSideBarSpecialOpenHours = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2($author$project$Location$Details$Commands$sendToAddSpecialOpenHours, session.siteName, ''),
						function (locationId) {
							return A2($author$project$Location$Details$Commands$sendToAddSpecialOpenHours, session.siteName, locationId);
						},
						$elm$core$List$head(editor_.selectedLocations));
					var _v8 = A4(
						$author$project$Location$Details$Editor$update,
						{
							tagger: $author$project$Locations$List$Model$LocationDetailsEditorMsg,
							siteName: session.siteName,
							onUpdated: $author$project$Locations$List$Model$LocationDetailsEditorUpdated(editor_.selectedLocations),
							onScheduled: $elm$core$Maybe$Just($author$project$Locations$List$Model$SchedulerUpdated),
							deleteCommand: deleteCommand,
							updateCommand: updateCommand,
							scheduleCommand: scheduleCommand,
							onDeleteSchedule: $elm$core$Maybe$Nothing,
							saveGoogleAttributes: A2($author$project$Location$Details$Commands$addChosenGoogleAttributesFromUpdateMultiple, session.siteName, session.features),
							saveGoogleSocialLinks: A2($author$project$Location$Details$Commands$addChosenGoogleAttributesFromUpdateMultiple, session.siteName, session.features),
							onScheduleUpdatesRefreshed: $elm$core$Maybe$Nothing,
							onUpdatedLdpSpecialOpenHours: $author$project$Locations$List$Model$LdpSpecialOpenHoursUpdated,
							onUpdatedSideBarSpecialOpenHours: $author$project$Locations$List$Model$SideBarSpecialOpenHoursUpdated,
							updateCommandLdpSpecialOpenHours: $elm$core$Maybe$Nothing,
							updateCommandSideBarSpecialOpenHours: $elm$core$Maybe$Just(updateCommandSideBarSpecialOpenHours)
						},
						session,
						editorMsg,
						editor);
					var state = _v8.a;
					var cmd = _v8.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								editor: $elm$core$Maybe$Just(state)
							}),
						cmd);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'LocationDetailsEditorClose':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing, bulkAction: $author$project$Locations$List$Model$NoAction}),
					$elm$core$Platform$Cmd$none);
			case 'SideBarSpecialOpenHoursUpdated':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing, bulkAction: $author$project$Locations$List$Model$NoAction}),
					$elm$core$Platform$Cmd$none);
			case 'LdpSpecialOpenHoursUpdated':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing, bulkAction: $author$project$Locations$List$Model$NoAction}),
					$elm$core$Platform$Cmd$none);
			case 'LocationDetailsEditorUpdated':
				var updatedLocationIds = msg.a;
				var locationData = msg.b;
				var list = function () {
					var _v9 = model.allItems;
					if (_v9.$ === 'Loaded') {
						var items = _v9.a;
						var updatedList = A2(
							$elm$core$List$map,
							function (record) {
								if (A2($elm$core$List$member, record.id, updatedLocationIds)) {
									var getStatusTemporarilyClosed = function (temporarilyClosed) {
										if (temporarilyClosed.$ === 'Until') {
											var posix = temporarilyClosed.a;
											return $author$project$Locations$List$Model$TemporarilyClosed(posix);
										} else {
											return $author$project$Locations$List$Model$Open;
										}
									};
									var newRecord = function () {
										var _v10 = model.bulkAction;
										switch (_v10.$) {
											case 'TemporarilyClosedAction':
												return _Utils_update(
													record,
													{
														status: getStatusTemporarilyClosed(locationData.temporarilyClosedUntil)
													});
											case 'Active':
												var status = function () {
													var _v11 = locationData.isActive;
													if (_v11.$ === 'Active') {
														return getStatusTemporarilyClosed(locationData.temporarilyClosedUntil);
													} else {
														return $author$project$Locations$List$Model$Disabled;
													}
												}();
												return _Utils_update(
													record,
													{status: status});
											default:
												return record;
										}
									}();
									return newRecord;
								} else {
									return record;
								}
							},
							items);
						return updatedList;
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							editor: $elm$core$Maybe$Nothing,
							allItems: $author$project$RemoteData$Loaded(list),
							bulkAction: $author$project$Locations$List$Model$NoAction
						}),
					$elm$core$Platform$Cmd$none);
			case 'SchedulerUpdated':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'BulkUpdateDropdownOpened':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{editor: $elm$core$Maybe$Nothing}),
					$author$project$PlanHat$PlanHat$track(
						{info: 'Bulk update dropdown opened', action: $author$project$PlanHat$TrackingActions$keys.bulkUpdate.dropDownOpened}));
			case 'OnClickPostsLocationList':
				return _Utils_Tuple2(
					model,
					$author$project$PlanHat$PlanHat$track(
						{info: '', action: $author$project$PlanHat$TrackingActions$keys.postsPQL.locationList}));
			default:
				if (msg.a.$ === 'Ok') {
					var dataCompleteness = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationList: function (locationList) {
									return _Utils_update(
										locationList,
										{
											dataCompleteness: $author$project$RemoteData$Loaded(dataCompleteness)
										});
								}(model.locationList)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								locationList: function (locationList) {
									return _Utils_update(
										locationList,
										{
											dataCompleteness: $author$project$RemoteData$Error(
												$author$project$PinMeTo$Common$Util$httpErrorToString(err))
										});
								}(model.locationList)
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Locations.List.Main', message: 'Failed to handle msg DataCompletenessLoaded'}));
				}
		}
	});
var $author$project$Locations$List$Model$ZipColumn = {$: 'ZipColumn'};
var $author$project$Locations$List$Model$CityColumn = {$: 'CityColumn'};
var $author$project$Locations$List$Model$NameColumn = {$: 'NameColumn'};
var $author$project$Locations$List$Model$TypeColumn = {$: 'TypeColumn'};
var $author$project$Locations$List$Model$ScoreColumn = {$: 'ScoreColumn'};
var $author$project$Locations$List$Model$StatusColumn = {$: 'StatusColumn'};
var $author$project$Locations$List$Model$StreetColumn = {$: 'StreetColumn'};
var $author$project$Locations$List$Main$Flags = F7(
	function (initialFilter, query, openFilterOnLoad, viewType, siteCategories, hasCreateLocationPermission, postEnabled) {
		return {query: query, viewType: viewType, postEnabled: postEnabled, initialFilter: initialFilter, siteCategories: siteCategories, openFilterOnLoad: openFilterOnLoad, hasCreateLocationPermission: hasCreateLocationPermission};
	});
var $author$project$Locations$List$Model$viewTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'map':
				return $elm$json$Json$Decode$succeed($author$project$Locations$List$Model$MapView);
			case 'list':
				return $elm$json$Json$Decode$succeed($author$project$Locations$List$Model$ListView);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Locations$List$Model$ListView);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Locations$List$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'postEnabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hasCreateLocationPermission',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'siteCategories',
			$elm$json$Json$Decode$nullable($author$project$Data$Location$NetworkCategories$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'viewType',
				$author$project$Locations$List$Model$viewTypeDecoder,
				$author$project$Locations$List$Model$ListView,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'openFilterOnLoad',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'query',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'initialFilter',
							$elm$json$Json$Decode$nullable(
								$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Locations$List$Main$Flags))))))));
var $author$project$Locations$List$Model$CountryColumn = {$: 'CountryColumn'};
var $author$project$Locations$List$Model$CreatedColumn = {$: 'CreatedColumn'};
var $author$project$Locations$List$Model$StoreIdColumn = {$: 'StoreIdColumn'};
var $author$project$Locations$List$Main$subscriptions = function (model) {
	return A2($author$project$PinMeTo$Ui$Table$subscriptions, $author$project$Locations$List$Model$UiTableMsg, model.uiTable);
};
var $author$project$Locations$List$Model$OpenHoursColumn = {$: 'OpenHoursColumn'};
var $author$project$Locations$List$Model$ActionLinksColumn = {$: 'ActionLinksColumn'};
var $author$project$Locations$List$Model$ContactEmailColumn = {$: 'ContactEmailColumn'};
var $author$project$Locations$List$Model$ContactPhoneColumn = {$: 'ContactPhoneColumn'};
var $author$project$Locations$List$Model$BingCategoriesColumn = {$: 'BingCategoriesColumn'};
var $author$project$Locations$List$Model$AppleCategoriesColumn = {$: 'AppleCategoriesColumn'};
var $author$project$Locations$List$Model$ContactHomepageColumn = {$: 'ContactHomepageColumn'};
var $author$project$Locations$List$Model$LongDescriptionColumn = {$: 'LongDescriptionColumn'};
var $author$project$Locations$List$Model$GoogleAttributesColumn = {$: 'GoogleAttributesColumn'};
var $author$project$Locations$List$Model$GoogleCategoriesColumn = {$: 'GoogleCategoriesColumn'};
var $author$project$Locations$List$Model$ShortDescriptionColumn = {$: 'ShortDescriptionColumn'};
var $author$project$Locations$List$Model$FacebookCategoriesColumn = {$: 'FacebookCategoriesColumn'};
var $author$project$Locations$List$Model$LocationDescriptorColumn = {$: 'LocationDescriptorColumn'};
var $author$project$Locations$List$Main$main = function () {
	var columns = _List_fromArray(
		[$author$project$Locations$List$Model$StoreIdColumn, $author$project$Locations$List$Model$ScoreColumn, $author$project$Locations$List$Model$StatusColumn, $author$project$Locations$List$Model$NameColumn, $author$project$Locations$List$Model$LocationDescriptorColumn, $author$project$Locations$List$Model$StreetColumn, $author$project$Locations$List$Model$ZipColumn, $author$project$Locations$List$Model$CityColumn, $author$project$Locations$List$Model$CountryColumn, $author$project$Locations$List$Model$ContactPhoneColumn, $author$project$Locations$List$Model$OpenHoursColumn, $author$project$Locations$List$Model$ContactEmailColumn, $author$project$Locations$List$Model$ContactHomepageColumn, $author$project$Locations$List$Model$LongDescriptionColumn, $author$project$Locations$List$Model$ShortDescriptionColumn, $author$project$Locations$List$Model$GoogleAttributesColumn, $author$project$Locations$List$Model$ActionLinksColumn, $author$project$Locations$List$Model$GoogleCategoriesColumn, $author$project$Locations$List$Model$AppleCategoriesColumn, $author$project$Locations$List$Model$FacebookCategoriesColumn, $author$project$Locations$List$Model$BingCategoriesColumn, $author$project$Locations$List$Model$TypeColumn, $author$project$Locations$List$Model$CreatedColumn]);
	return $author$project$PinMeToPage$page(
		{
			init: $author$project$Locations$List$Main$init,
			view: function (session) {
				return A2($author$project$Locations$List$View$view, session, columns);
			},
			update: $author$project$Locations$List$Main$update,
			flagsDecoder: $author$project$Locations$List$Main$flagsDecoder,
			subscriptions: $author$project$Locations$List$Main$subscriptions
		});
}();
var $author$project$Insights$Apple$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Insights$Apple$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Insights$Apple$Decoders$supportedDateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxDate',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minDate',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$Apple$Commands$getAppleSupportedDateRange = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var httpRequest = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$lukewestby$elm_http_builder$HttpBuilder$get,
			function (_v1) {
				return $lukewestby$elm_http_builder$HttpBuilder$get;
			},
			model.locationId);
		var url = function (u) {
			return u + (siteName + '/apple/locations/metrics/supportedDateRange');
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Apple$Decoders$supportedDateRangeDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					httpRequest(url))));
	});
var $author$project$Insights$Apple$Model$AppleSupportedDateRangeResponse = function (a) {
	return {$: 'AppleSupportedDateRangeResponse', a: a};
};
var $author$project$Insights$Apple$Main$out_Insights_Apple_Main_onRangeChange = _Platform_outgoingPort('out_Insights_Apple_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$Apple$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var uiDateRangePicker = $author$project$PinMeTo$Ui$DateRangePicker$init;
		var timezone = A2($elm$time$Time$customZone, flags.timezoneOffset, _List_Nil);
		var model = {
			range: A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 28),
				flags.dateRange),
			today: flags.today,
			baseUrl: flags.url,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			lifetime: $elm$core$Maybe$Nothing,
			timezone: timezone,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			locationId: flags.locationId,
			uiFeedback: $author$project$Listings$Ui$Feedback$init,
			insightsUrl: flags.insightsUrl,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			initialFilter: flags.initialFilter,
			filterController: filterControllerModel_,
			filterDefinition: $elm$core$Maybe$Nothing,
			uiDateRangePicker: uiDateRangePicker.a,
			topListMetricsData: $author$project$RemoteData$Loading,
			appleConnectionType: flags.appleConnectionType,
			topListAmountToShow: 5,
			placeCardMetricsData: $author$project$RemoteData$Loading,
			searchLocationMetricsData: $author$project$RemoteData$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Insights$Apple$Main$out_Insights_Apple_Main_onRangeChange(
						$author$project$Insights$Utils$encodeDateRange(model.range)),
						A3($author$project$Insights$Apple$Commands$getAppleSupportedDateRange, model, session.siteName, $author$project$Insights$Apple$Model$AppleSupportedDateRangeResponse),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Apple$Model$DateRangePickerMsg, uiDateRangePicker.b),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Apple$Model$FilterControllerMsg, filterControllerCmd_)
					])));
	});
var $author$project$Insights$Apple$Model$getDateLabel = function (model) {
	var toString = function (date) {
		return $justinmimbs$date$Date$toIsoString(date);
	};
	var from = toString(model.range.from);
	var to = toString(model.range.to);
	return from + (' - ' + to);
};
var $author$project$Insights$Apple$Model$Searches = {$: 'Searches'};
var $author$project$Translations$Listings$Insights$appleSearchesNoDataNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_searches_no_data_note');
};
var $author$project$Insights$Apple$View$Charts$renderAlert = F2(
	function (session, total) {
		return (!total) ? $author$project$PinMeTo$Ui$Alert$render(
			A2(
				$author$project$PinMeTo$Ui$Alert$withStatus,
				$author$project$PinMeTo$Ui$Alert$Note,
				$author$project$PinMeTo$Ui$Alert$rich(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Insights$appleSearchesNoDataNote(session.translations))
						])))) : $elm$html$Html$text('');
	});
var $author$project$Insights$Apple$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Insights$Apple$View$Charts$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: $author$project$Translations$Listings$Insights$feedbackLabel(translations),
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Apple$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Insights$Apple$View$Charts$renderAsides = F3(
	function (session, model, uid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
						]),
					_List_fromArray(
						[
							A3($author$project$Insights$Apple$View$Charts$uiFeedback, session.translations, uid, model.uiFeedback)
						]))
				]));
	});
var $author$project$Insights$Apple$Model$OnPopOver = F2(
	function (a, b) {
		return {$: 'OnPopOver', a: a, b: b};
	});
var $author$project$Translations$Listings$Insights$appleViewsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_views_popover');
};
var $author$project$Translations$Listings$Insights$appleActionsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_actions_popover');
};
var $author$project$Translations$Listings$Insights$appleSearchesPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_searches_popover');
};
var $author$project$Translations$Listings$Insights$appleTopLocationsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_top_locations_popover');
};
var $author$project$Insights$Apple$View$Charts$popOverConfig = F2(
	function (popOverConfigType, translations) {
		var _v0 = function () {
			switch (popOverConfigType.$) {
				case 'Views':
					return _Utils_Tuple2(
						'apple-metrics-views-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$appleViewsPopover(translations))
							]));
				case 'Actions':
					return _Utils_Tuple2(
						'apple-metrics-actions-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$appleActionsPopover(translations))
							]));
				case 'Searches':
					return _Utils_Tuple2(
						'apple-metrics-searches-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$appleSearchesPopover(translations))
							]));
				default:
					return _Utils_Tuple2(
						'apple-metrics-toplist-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$appleTopLocationsPopover(translations))
							]));
			}
		}();
		var uid = _v0.a;
		var content = _v0.b;
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: uid,
				tagger: $author$project$Insights$Apple$Model$OnPopOver(popOverConfigType),
				content: content,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $author$project$Translations$Listings$Insights$appleMetricUnknown = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_metric_unknown');
};
var $author$project$Translations$Listings$Insights$appleSearchesOther = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_searches_other');
};
var $author$project$Translations$Listings$Insights$appleSearchesCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_searches_category');
};
var $author$project$Translations$Listings$Insights$appleSearchesNameOrBrand = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_searches_name_or_brand');
};
var $author$project$Insights$Apple$View$Charts$donutChartTitleAndColor = F2(
	function (translations, metricData) {
		var _v0 = metricData.metricName;
		switch (_v0) {
			case 'SEARCH_LOCATION_TAP_NAME':
				return {
					data: metricData.data,
					color: '#3399FF',
					title: $author$project$Translations$Listings$Insights$appleSearchesNameOrBrand(translations)
				};
			case 'SEARCH_LOCATION_TAP_CATEGORY':
				return {
					data: metricData.data,
					color: '#61D173',
					title: $author$project$Translations$Listings$Insights$appleSearchesCategory(translations)
				};
			case 'SEARCH_LOCATION_TAP_OTHER':
				return {
					data: metricData.data,
					color: '#9933FF',
					title: $author$project$Translations$Listings$Insights$appleSearchesOther(translations)
				};
			default:
				return {
					data: 0,
					color: '#FFC107',
					title: $author$project$Translations$Listings$Insights$appleMetricUnknown(translations)
				};
		}
	});
var $author$project$Translations$Listings$Insights$appleSearchesDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.apple_searches_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Apple$View$Charts$renderDonutChart = F2(
	function (session, datasets) {
		var sortedList = _List_fromArray(
			[
				{
				data: 0,
				color: '',
				title: $author$project$Translations$Listings$Insights$appleSearchesNameOrBrand(session.translations)
			},
				{
				data: 0,
				color: '',
				title: $author$project$Translations$Listings$Insights$appleSearchesCategory(session.translations)
			},
				{
				data: 0,
				color: '',
				title: $author$project$Translations$Listings$Insights$appleSearchesOther(session.translations)
			}
			]);
		var listToRender = A2(
			$elm$core$List$map,
			function (element) {
				var filteredElement = A2(
					$elm$core$List$filter,
					function (filtered) {
						return _Utils_eq(filtered.title, element.title);
					},
					datasets);
				var firstElement = $elm$core$List$head(filteredElement);
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					element,
					function (item) {
						return {data: item.data, color: item.color, title: element.title};
					},
					firstElement);
			},
			sortedList);
		return $author$project$PinMeTo$Ui$Chart$render(
			A2(
				$author$project$PinMeTo$Ui$Chart$withLocale,
				session.locale,
				A2(
					$author$project$PinMeTo$Ui$Chart$withLegendConfig,
					$author$project$PinMeTo$Ui$Chart$Legend$withTotal,
					$author$project$PinMeTo$Ui$Chart$view(
						{
							chart: $author$project$PinMeTo$Ui$Chart$Doughnut(listToRender)
						}))));
	});
var $author$project$Insights$Apple$View$Charts$renderSearchesChartContent = F3(
	function (session, searchData, alert) {
		var searchData_ = A2(
			$elm$core$List$map,
			$author$project$Insights$Apple$View$Charts$donutChartTitleAndColor(session.translations),
			searchData);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					alert,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__chart'),
							$elm$html$Html$Attributes$class('pmt-insights__chart--doughnut-container')
						]),
					_List_fromArray(
						[
							A2($author$project$Insights$Apple$View$Charts$renderDonutChart, session, searchData_)
						]))
				]));
	});
var $author$project$Insights$Apple$View$Charts$renderSearchesChart = F4(
	function (session, model, searchLocationMetricsData, dateLabel) {
		var searchData = A2(
			$elm$core$List$map,
			$author$project$Insights$Apple$View$Charts$donutChartTitleAndColor(session.translations),
			searchLocationMetricsData);
		var total = A3(
			$elm$core$List$foldl,
			F2(
				function (searchDataItem, acc) {
					return acc + searchDataItem.data;
				}),
			0,
			searchData);
		var alert = A2($author$project$Insights$Apple$View$Charts$renderAlert, session, total);
		var searchesChart = A3($author$project$Insights$Apple$View$Charts$renderSearchesChartContent, session, searchLocationMetricsData, alert);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(total),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Apple$View$Charts$renderAsides, session, model, 'apple-insights-searches'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Apple$View$Charts$popOverConfig, $author$project$Insights$Apple$Model$Searches, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$appleSearchesDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$searchesTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(searchesChart)));
	});
var $author$project$Insights$Apple$View$MetricSection$renderSearchesChartWrapper = F3(
	function (session, model, dateLabel) {
		var _v0 = model.searchLocationMetricsData;
		switch (_v0.$) {
			case 'Suspended':
				return $elm$html$Html$text('');
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Loaded':
				var searchLocationMetricsData = _v0.a;
				return $elm$core$List$isEmpty(searchLocationMetricsData) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$Insights$Apple$View$Charts$renderSearchesChart, session, model, searchLocationMetricsData, dateLabel)
						]));
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Insights$Apple$Model$Views = {$: 'Views'};
var $author$project$Translations$Listings$Insights$appleViews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_views');
};
var $author$project$Translations$Listings$Insights$appleActionsCalls = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_actions_calls');
};
var $author$project$Translations$Listings$Insights$appleActionsDirections = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_actions_directions');
};
var $author$project$Translations$Listings$Insights$appleActionsWebsiteClicks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_actions_website_clicks');
};
var $author$project$Insights$Apple$View$Charts$areaChartTitleAndColor = F2(
	function (translations, metricData) {
		var _v0 = metricData.metricName;
		switch (_v0) {
			case 'PLACECARD_VIEW':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$Listings$Insights$appleViews(translations)
				};
			case 'PLACECARD_TAP_DIRECTION':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$Listings$Insights$appleActionsDirections(translations)
				};
			case 'PLACECARD_TAP_WEBSITE':
				return {
					data: metricData.metrics,
					color: '#9933FF',
					title: $author$project$Translations$Listings$Insights$appleActionsWebsiteClicks(translations)
				};
			case 'PLACECARD_TAP_CALL':
				return {
					data: metricData.metrics,
					color: '#61D173',
					title: $author$project$Translations$Listings$Insights$appleActionsCalls(translations)
				};
			default:
				return {
					data: _List_Nil,
					color: '#FFC107',
					title: $author$project$Translations$Listings$Insights$appleMetricUnknown(translations)
				};
		}
	});
var $author$project$Insights$Apple$View$Charts$filterViewsData = F2(
	function (session, metricData) {
		return (metricData.metricName === 'PLACECARD_VIEW') ? $elm$core$Maybe$Just(
			A2($author$project$Insights$Apple$View$Charts$areaChartTitleAndColor, session.translations, metricData)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Translations$Listings$Insights$appleViewsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.apple_views_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Apple$View$Charts$renderViewsChart = F4(
	function (session, model, placeCardMetricsData, dateLabel) {
		var viewsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A2(
				$elm$core$List$filterMap,
				$author$project$Insights$Apple$View$Charts$filterViewsData(session),
				placeCardMetricsData));
		var viewsChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, viewsData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(viewsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Apple$View$Charts$renderAsides, session, model, 'app-insights-views'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Apple$View$Charts$popOverConfig, $author$project$Insights$Apple$Model$Views, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$appleViewsDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$viewsTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[viewsChart])))));
	});
var $author$project$Insights$Apple$Model$Actions = {$: 'Actions'};
var $author$project$Insights$Apple$View$Charts$sortActionsData = F2(
	function (session, actionsData) {
		return A2(
			$elm$core$List$sortBy,
			function (metricData) {
				return _Utils_eq(
					metricData.title,
					$author$project$Translations$Listings$Insights$appleActionsDirections(session.translations)) ? 0 : (_Utils_eq(
					metricData.title,
					$author$project$Translations$Listings$Insights$appleActionsCalls(session.translations)) ? 1 : 2);
			},
			actionsData);
	});
var $author$project$Insights$Apple$View$Charts$filterActionsData = F2(
	function (session, metricData) {
		var actionDataKeys = _List_fromArray(
			['PLACECARD_TAP_DIRECTION', 'PLACECARD_TAP_WEBSITE', 'PLACECARD_TAP_CALL']);
		return A2($elm$core$List$member, metricData.metricName, actionDataKeys) ? $elm$core$Maybe$Just(
			A2($author$project$Insights$Apple$View$Charts$areaChartTitleAndColor, session.translations, metricData)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Translations$Listings$Insights$appleActionsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.apple_actions_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Apple$View$Charts$renderActionsChart = F4(
	function (session, model, placeCardMetricsData, dateLabel) {
		var actionsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A2(
				$elm$core$List$filterMap,
				$author$project$Insights$Apple$View$Charts$filterActionsData(session),
				placeCardMetricsData));
		var sortedActionsData = A2($author$project$Insights$Apple$View$Charts$sortActionsData, session, actionsData);
		var actionsChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, sortedActionsData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(actionsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Apple$View$Charts$renderAsides, session, model, 'apple-insights-actions'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Apple$View$Charts$popOverConfig, $author$project$Insights$Apple$Model$Actions, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$appleActionsDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$actionsTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[actionsChart])))));
	});
var $author$project$Insights$Apple$View$MetricSection$renderViewsAndActionsCharts = F3(
	function (session, model, dateLabel) {
		var _v0 = model.placeCardMetricsData;
		switch (_v0.$) {
			case 'Suspended':
				return $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations));
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Loaded':
				var placeCardMetricsData = _v0.a;
				return $elm$core$List$isEmpty(placeCardMetricsData) ? $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations)) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$Insights$Apple$View$Charts$renderViewsChart, session, model, placeCardMetricsData, dateLabel),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A4($author$project$Insights$Apple$View$Charts$renderActionsChart, session, model, placeCardMetricsData, dateLabel),
							A2($elm$html$Html$br, _List_Nil, _List_Nil)
						]));
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Translations$Listings$Insights$appleOauthDisabledText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_oauth_disabled_text');
};
var $author$project$Translations$Listings$Insights$appleOauthDisabledTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.apple_oauth_disabled_title');
};
var $author$project$Insights$Apple$View$MetricSection$renderEmptyStateForOauthDisabled = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-empty-state')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-empty-state__icon')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('img/insights/promotion-state.svg')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-empty-state__message')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-empty-state__message__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$appleOauthDisabledTitle(translations))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-empty-state__message__content')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$appleOauthDisabledText(translations))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('https://help.pinmeto.com/en/article/setting-up-your-apple-business-connect-account-b1rdhn/'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Directories$appleHelpCenterArticle(translations) + ' '),
								A2(
								$elm$html$Html$a,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$PinMeTo$Deprecated$FontAwesome$render($author$project$PinMeTo$Deprecated$FontAwesome$ExternalLink)
									]))
							]))
					]))
			]));
};
var $author$project$Insights$Apple$View$MetricSection$view = F2(
	function (session, model) {
		var dateLabel = $author$project$Insights$Apple$Model$getDateLabel(model);
		var searchesChart = A3($author$project$Insights$Apple$View$MetricSection$renderSearchesChartWrapper, session, model, dateLabel);
		var viewsAndActionCharts = A3($author$project$Insights$Apple$View$MetricSection$renderViewsAndActionsCharts, session, model, dateLabel);
		return _Utils_eq(model.appleConnectionType, $author$project$Insights$Apple$Model$SYSTEM) ? $author$project$Insights$Apple$View$MetricSection$renderEmptyStateForOauthDisabled(session.translations) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[viewsAndActionCharts, searchesChart]));
	});
var $author$project$Insights$Apple$Model$TopList = {$: 'TopList'};
var $author$project$Insights$Apple$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$Insights$Apple$Model$filterQueryString = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (id) {
				return '/' + id;
			},
			model.locationId);
		var filterQuery = '&' + A2(
			$elm$core$String$dropLeft,
			1,
			$author$project$Filter$FilterController$getCurrentFilterAsQueryString(model.filterController));
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var dateRange = model.range;
		var query = '?from=' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('&to=' + ($justinmimbs$date$Date$toIsoString(dateRange.to) + filterQuery)));
		return requestUrl + (siteName + ('/apple/locations' + (locationParam + (endpoint + (fileTypeStr + query)))));
	});
var $author$project$Insights$Apple$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Insights$Apple$View$TopListSection$renderTopList = F4(
	function (session, model, topListMetricsData, sortedBy) {
		var site = $author$project$Data$SiteName$toString(session.siteName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-apple-insights-top-list')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						$author$project$Translations$General$locationCountry(session.translations),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.country;
							},
							$elm$html$Html$text),
						$author$project$PinMeTo$Ui$Table$comparing(
							function ($) {
								return $.country;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							$author$project$Translations$General$locationCity(session.translations),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.city;
								},
								$elm$html$Html$text),
							$author$project$PinMeTo$Ui$Table$comparing(
								function ($) {
									return $.city;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$General$locationZip(session.translations),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.zip;
									},
									$elm$html$Html$text),
								$author$project$PinMeTo$Ui$Table$comparing(
									function ($) {
										return $.zip;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addCompactColumn,
									$author$project$Translations$General$locationStreet(session.translations),
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.street;
										},
										$elm$html$Html$text),
									$author$project$PinMeTo$Ui$Table$comparing(
										function ($) {
											return $.street;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addCompactColumn,
										$author$project$Translations$General$locationDescriptor(session.translations),
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.locationDescriptor;
											},
											$elm$html$Html$text),
										$author$project$PinMeTo$Ui$Table$comparing(
											function ($) {
												return $.locationDescriptor;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$name(session.translations),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.name;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.name;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationStoreId(session.translations),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.storeId;
													},
													$elm$html$Html$text),
												A2(
													$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
													30,
													function ($) {
														return $.storeId;
													}),
												A2(
													$author$project$PinMeTo$Ui$Table$withRowLink,
													function (location) {
														return '/listings/' + (site + ('/locations/' + (location.locationId + '/details')));
													},
													A5(
														$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
														$author$project$Translations$Listings$Insights$actionsTitle(session.translations),
														_List_fromArray(
															[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.totalActions;
															},
															A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.totalActions;
															}),
														A5(
															$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
															$author$project$Translations$Listings$Insights$viewsTitle(session.translations),
															_List_fromArray(
																[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.totalViews;
																},
																A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
															$author$project$PinMeTo$Ui$Table$comparing(
																function ($) {
																	return $.totalViews;
																}),
															A2(
																$author$project$PinMeTo$Ui$Table$withLimit,
																{
																	limit: model.topListAmountToShow,
																	viewMoreLabel: F2(
																		function (_v0, _v1) {
																			return 'Show more';
																		})
																},
																$author$project$PinMeTo$Ui$Table$withScrollableTable(
																	$author$project$PinMeTo$Ui$Table$withStickyHeader(
																		A2(
																			$author$project$PinMeTo$Ui$Table$withSort,
																			sortedBy,
																			A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Apple$Model$UiTableMsg, topListMetricsData))))))))))))))))
				]));
	});
var $author$project$Insights$Apple$View$TopListSection$renderViewSelector = F2(
	function (session, model) {
		var topListMetricsData = function () {
			var _v0 = model.topListMetricsData;
			if (_v0.$ === 'Loaded') {
				var topListData = _v0.a;
				return topListData;
			} else {
				return _List_Nil;
			}
		}();
		var sortedBy = A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$Table$Desc(0),
			$author$project$PinMeTo$Ui$Table$getSort(model.uiTable));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Insights$Apple$View$TopListSection$renderTopList, session, model, topListMetricsData, sortedBy)
				]));
	});
var $author$project$Insights$Apple$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Insights$Apple$View$TopListSection$view = F2(
	function (session, model) {
		var titleWithPopOver = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$topListings(session.translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.popOverState,
							A2($author$project$Insights$Apple$View$Charts$popOverConfig, $author$project$Insights$Apple$Model$TopList, session.translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$General$topListingsDescription,
								session.translations,
								$author$project$Insights$Apple$Model$getDateLabel(model)))
						]))
				]));
		var dateRange = model.range;
		var downloadTopListConf = {
			uid: 'ui-select-download-toplist-apple',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Apple$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/topList/download/'),
					label: $author$project$Translations$Listings$Insights$downloadListingsMetricsCsv(session.translations)
				},
					{
					url: A4($author$project$Insights$Apple$Model$filterQueryString, model, session.siteName, 'xlsx', '/metrics/topList/download/'),
					label: $author$project$Translations$Listings$Insights$downloadListingsMetricsXlsx(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadToplistTitle(session.translations),
			tagger: $author$project$Insights$Apple$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Apple-top-list_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Apple$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A2(
					$author$project$RemoteData$map,
					function (data) {
						return $elm$core$List$isEmpty(data);
					},
					model.topListMetricsData),
				$author$project$RemoteData$Loaded(false))
		};
		var asides = _List_fromArray(
			[
				A4(
				$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
				$author$project$Translations$Listings$Insights$downloadDetailedDataTooltip(session.translations),
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadTopListConf, model.uiSelect)
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(titleWithPopOver)))),
					function () {
					var _v0 = model.topListMetricsData;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Loaded':
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Insights$Apple$View$TopListSection$renderViewSelector, session, model)
									]));
						default:
							var e = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
					}
				}()
				]));
	});
var $author$project$Insights$Apple$View$promotionStateWrapper = F2(
	function (model, children) {
		var _v0 = model.appleConnectionType;
		if (_v0.$ === 'OAUTH') {
			return A2($elm$html$Html$div, _List_Nil, children);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointerEvents', 'none'),
						A2($elm$html$Html$Attributes$style, 'opacity', '0.5')
					]),
				children);
		}
	});
var $author$project$Insights$Apple$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2(
				$elm$html$Html$map,
				$author$project$Insights$Apple$Model$FilterControllerMsg,
				A4($author$project$Filter$FilterController$viewInsights, model.filterController, session.locale, session.translations, session.language)),
			function (_v3) {
				return $elm$html$Html$text('');
			},
			model.locationId);
		var shouldShowTopList = function () {
			var _v1 = model.locationId;
			if (_v1.$ === 'Just') {
				return false;
			} else {
				var _v2 = model.placeCardMetricsData;
				if (_v2.$ === 'Loaded') {
					var placeCardMetricsData = _v2.a;
					return $elm$core$List$length(placeCardMetricsData) > 0;
				} else {
					return false;
				}
			}
		}();
		var dateRange = model.range;
		var downloadMetricsConf = {
			uid: 'ui-select-download-apple-metric',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Apple$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/download/'),
					label: $author$project$Translations$Listings$Insights$downloadDataSummaryCsv(session.translations)
				},
					{
					url: A4($author$project$Insights$Apple$Model$filterQueryString, model, session.siteName, 'xlsx', '/metrics/download/'),
					label: $author$project$Translations$Listings$Insights$downloadDataSummaryXlsx(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
			tagger: $author$project$Insights$Apple$Model$UiSelectMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Apple-Insights_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Apple$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A3(
					$author$project$RemoteData$map2,
					F2(
						function (placeCardData, searchData) {
							return A2(
								$elm$core$List$all,
								function (data) {
									return $elm$core$List$isEmpty(data.metrics);
								},
								placeCardData) && $elm$core$List$isEmpty(searchData);
						}),
					model.placeCardMetricsData,
					model.searchLocationMetricsData),
				$author$project$RemoteData$Loaded(false))
		};
		var downloadMetricsDropdown = A4(
			$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
			$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
			$elm$html$Html$b,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadMetricsConf, model.uiSelect)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Insights$Apple$View$promotionStateWrapper,
					model,
					_List_fromArray(
						[
							filterControllerHandler,
							$author$project$PinMeTo$Ui$TitleBar$render(
							A2(
								$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
								true,
								$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
									$author$project$Translations$General$Insights$insightsTitle(session.translations)))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$PinMeTo$Ui$DateRangePicker$render,
											model.uiDateRangePicker,
											function () {
												var _v0 = model.lifetime;
												if (_v0.$ === 'Just') {
													var lifetime = _v0.a;
													return $author$project$PinMeTo$Ui$DateRangePicker$withRanges(
														_List_fromArray(
															[
																A3(
																$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
																$author$project$Translations$General$Insights$lifetime(session.translations),
																'Lifetime',
																lifetime)
															]));
												} else {
													return $elm$core$Basics$identity;
												}
											}()(
												$author$project$PinMeTo$Ui$DateRangePicker$view(
													{
														uid: 'apple-insights-date-range-picker',
														range: model.range,
														labels: A2($author$project$Labels$uiDateRangePicker, session.translations, session.language),
														locale: session.locale,
														tagger: $author$project$Insights$Apple$Model$DateRangePickerMsg,
														language: session.language
													})))
										])),
									downloadMetricsDropdown
								]))
						])),
					A2($author$project$Insights$Apple$View$MetricSection$view, session, model),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					shouldShowTopList ? A2($author$project$Insights$Apple$View$TopListSection$view, session, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Insights$Apple$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Apple$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Apple$Model$TopListDataResponse = function (a) {
	return {$: 'TopListDataResponse', a: a};
};
var $author$project$Insights$Apple$Commands$isLifetime = F2(
	function (dateRange, supportedDateRange) {
		if (supportedDateRange.$ === 'Just') {
			var supportedDateRange_ = supportedDateRange.a;
			var supportedDateRangeInDate = {to: supportedDateRange_.to, from: supportedDateRange_.from};
			return _Utils_eq(supportedDateRangeInDate.from, dateRange.from) && _Utils_eq(supportedDateRangeInDate.to, dateRange.to);
		} else {
			return false;
		}
	});
var $author$project$Insights$Apple$Commands$getQueryParams = function (model) {
	var dateRange = model.range;
	var isLifetime_ = A2($author$project$Insights$Apple$Commands$isLifetime, dateRange, model.lifetime);
	var lifetime = isLifetime_ ? '&lifetime=true' : '';
	var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
	var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
	return '?from=' + (from + ('&to=' + (to + lifetime)));
};
var $author$project$Insights$Apple$Model$TopListLocation = function (name) {
	return function (storeId) {
		return function (locationDescriptor) {
			return function (locationId) {
				return function (zip) {
					return function (street) {
						return function (city) {
							return function (country) {
								return function (totalViews) {
									return function (totalActions) {
										return {zip: zip, city: city, name: name, street: street, country: country, storeId: storeId, locationId: locationId, totalViews: totalViews, totalActions: totalActions, locationDescriptor: locationDescriptor};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Apple$Decoders$topListLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'views',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['location', 'address', 'country']),
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['location', 'address', 'city']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['location', 'address', 'street']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['location', 'address', 'zip']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['location', '_id']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['location', 'locationDescriptor']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['location', 'storeId']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['location', 'name']),
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$TopListLocation)))))))))));
var $author$project$Insights$Apple$Decoders$topListDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['metrics']),
	$elm$json$Json$Decode$list($author$project$Insights$Apple$Decoders$topListLocationDecoder));
var $author$project$Insights$Apple$Commands$getAppleTopListMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = function (u) {
			return u + (siteName + ('/apple/locations/metrics/topList' + $author$project$Insights$Apple$Commands$getQueryParams(model)));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Apple$Decoders$topListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Apple$Model$ApplePlaceCardMetric = F2(
	function (metricName, metrics) {
		return {metrics: metrics, metricName: metricName};
	});
var $author$project$Insights$Apple$Model$AppleMetricDetails = F2(
	function (key, value) {
		return {key: key, value: value};
	});
var $author$project$Insights$Apple$Decoders$appleMetricDetailsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$AppleMetricDetails)));
var $author$project$Insights$Apple$Decoders$appleMetricDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metrics',
	$elm$json$Json$Decode$list($author$project$Insights$Apple$Decoders$appleMetricDetailsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$ApplePlaceCardMetric)));
var $author$project$Insights$Apple$Decoders$appleMetricListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metrics',
	$elm$json$Json$Decode$list($author$project$Insights$Apple$Decoders$appleMetricDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Insights$Apple$Commands$getApplePlaceCardMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (locationId_) {
				return locationId_ + '/';
			},
			model.locationId);
		var url = function (u) {
			return u + (siteName + ('/apple/locations/' + (locationId + ('metrics/placeCard' + $author$project$Insights$Apple$Commands$getQueryParams(model)))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Apple$Decoders$appleMetricListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Apple$Model$AppleSearchLocationMetric = F2(
	function (metricName, data) {
		return {data: data, metricName: metricName};
	});
var $author$project$Insights$Apple$Decoders$appleSearchLocationMetricDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$AppleSearchLocationMetric)));
var $author$project$Insights$Apple$Decoders$appleSearchLocationMetricsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['metrics']),
	$elm$json$Json$Decode$list($author$project$Insights$Apple$Decoders$appleSearchLocationMetricDecoder));
var $author$project$Insights$Apple$Commands$getAppleSearchLocationMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (locationId_) {
				return locationId_ + '/';
			},
			model.locationId);
		var url = function (u) {
			return u + (siteName + ('/apple/locations/' + (locationId + ('metrics/searchLocation' + $author$project$Insights$Apple$Commands$getQueryParams(model)))));
		}(
			$elm$url$Url$toString(model.insightsUrl));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Apple$Decoders$appleSearchLocationMetricsDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Apple$Model$ApplePlaceCardMetricsDataResponse = function (a) {
	return {$: 'ApplePlaceCardMetricsDataResponse', a: a};
};
var $author$project$Insights$Apple$Model$SearchLocationMetricsDataResponse = function (a) {
	return {$: 'SearchLocationMetricsDataResponse', a: a};
};
var $author$project$Insights$Apple$Main$fetchAllInsights = F2(
	function (model, siteName) {
		return A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A3($author$project$Insights$Apple$Commands$getApplePlaceCardMetrics, model, siteName, $author$project$Insights$Apple$Model$ApplePlaceCardMetricsDataResponse),
					A3($author$project$Insights$Apple$Commands$getAppleSearchLocationMetrics, model, siteName, $author$project$Insights$Apple$Model$SearchLocationMetricsDataResponse)
				]),
			_Utils_eq(model.locationId, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					A3($author$project$Insights$Apple$Commands$getAppleTopListMetrics, model, siteName, $author$project$Insights$Apple$Model$TopListDataResponse)
				]) : _List_Nil);
	});
var $author$project$Insights$Apple$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$Apple$Main$out_Insights_Apple_Main_onFilter = _Platform_outgoingPort('out_Insights_Apple_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Apple$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'AppleSupportedDateRangeResponse':
				if (msg.a.$ === 'Ok') {
					var supportedDateRange = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							lifetime: $elm$core$Maybe$Just(supportedDateRange)
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Apple.Main.AppleSupportedDateRangeResponse'),
							e));
				}
			case 'SearchLocationMetricsDataResponse':
				if (msg.a.$ === 'Ok') {
					var metrics = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								searchLocationMetricsData: $author$project$RemoteData$Loaded(metrics)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								searchLocationMetricsData: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Apple.Main.SearchLocationMetricsDataResponse'),
							e));
				}
			case 'ApplePlaceCardMetricsDataResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								placeCardMetricsData: $author$project$RemoteData$Loaded(x)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								placeCardMetricsData: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Apple.Main.ApplePlaceCardMetricsDataResponse'),
							e));
				}
			case 'DateRangePickerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiDateRangePicker: x});
					},
					A3(
						$author$project$PinMeTo$Ui$DateRangePicker$update,
						{
							tagger: $author$project$Insights$Apple$Model$DateRangePickerMsg,
							onChange: $author$project$Insights$Apple$Model$OnDateRangeChange,
							metricsPrefix: $author$project$Common$Metrics$prefix('Apple Insights')
						},
						msg_,
						model.uiDateRangePicker));
			case 'OnDateRangeChange':
				var range = msg.a;
				var onRangeChange = $author$project$Insights$Apple$Main$out_Insights_Apple_Main_onRangeChange(
					$author$project$Insights$Utils$encodeDateRange(range));
				var newModel_ = _Utils_update(
					model,
					{range: range, topListMetricsData: $author$project$RemoteData$Loading, placeCardMetricsData: $author$project$RemoteData$Loading, searchLocationMetricsData: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel_,
					$elm$core$Platform$Cmd$batch(
						_Utils_ap(
							A2($author$project$Insights$Apple$Main$fetchAllInsights, newModel_, session.siteName),
							_List_fromArray(
								[onRangeChange]))));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Apple$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'TopListDataResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topListMetricsData: $author$project$RemoteData$Loaded(x)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topListMetricsData: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('Insights.Apple.Main.TopListDataResponse'),
							e));
				}
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				var _v1 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Apple$Model$FilterControllerMsg, msg_, model.filterController, $author$project$Insights$Apple$Model$OnFilter, $author$project$Insights$Apple$Model$OnSearch);
				var filterControllerModel_ = _v1.a;
				var filterControllerCmd_ = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filterController: filterControllerModel_}),
					filterControllerCmd_);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						filterDefinition: $elm$core$Maybe$Just(filterDefinition),
						topListMetricsData: $author$project$RemoteData$Loading,
						placeCardMetricsData: $author$project$RemoteData$Loading,
						searchLocationMetricsData: $author$project$RemoteData$Loading
					});
				var newBatch = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						$author$project$Insights$Apple$Main$out_Insights_Apple_Main_onFilter(filterDefinition),
						A2($author$project$Insights$Apple$Main$fetchAllInsights, newModel, session.siteName)));
				return _Utils_Tuple2(newModel, newBatch);
			case 'OnUrlChange':
				var value = msg.a;
				var _v2 = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, value);
				if (_v2.$ === 'Ok') {
					var url = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								baseUrl: $elm$core$Maybe$Just(url)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = _v2.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(e),
								context: 'Insights.Apple.Main.OnUrlChange',
								message: 'Failed to decode url'
							}));
				}
			case 'ShowMore':
				var amountToShow = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{topListAmountToShow: amountToShow + 100}),
					$elm$core$Platform$Cmd$none);
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnPopOver':
				var popOverConfigType = msg.a;
				var msg_ = msg.b;
				var planhatTrack = function () {
					if (msg_.$ === 'Open') {
						switch (popOverConfigType.$) {
							case 'Views':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.apple.viewsPopoverClicked;
							case 'Actions':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.apple.actionsPopoverClicked;
							case 'Searches':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.apple.searchesPopoverClicked;
							default:
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.apple.topListPopoverClicked;
						}
					} else {
						return '';
					}
				}();
				var planhatTrackCmd = (planhatTrack !== '') ? $author$project$PlanHat$PlanHat$track(
					{info: '', action: planhatTrack}) : $elm$core$Platform$Cmd$none;
				var _v3 = A3(
					$author$project$PinMeTo$Ui$PopOver$update,
					$author$project$Insights$Apple$Model$OnPopOver(popOverConfigType),
					msg_,
					model.popOverState);
				var newState = _v3.a;
				var cmd_ = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd_, planhatTrackCmd])));
			case 'UiFeedbackMsg':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Insights$Apple$Model$Flags = function (siteName) {
	return function (today) {
		return function (dateRange) {
			return function (insightsUrl) {
				return function (baseUrl) {
					return function (locale) {
						return function (translations) {
							return function (language) {
								return function (initialFilter) {
									return function (placeId) {
										return function (url) {
											return function (timezoneOffset) {
												return function (locationId) {
													return function (appleConnectionType) {
														return {url: url, today: today, locale: locale, baseUrl: baseUrl, placeId: placeId, language: language, siteName: siteName, dateRange: dateRange, locationId: locationId, insightsUrl: insightsUrl, translations: translations, initialFilter: initialFilter, timezoneOffset: timezoneOffset, appleConnectionType: appleConnectionType};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Apple$Decoders$dateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DatePickerV2$Range)));
var $author$project$Insights$Apple$Decoders$appleConnectionTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		switch (x) {
			case 'oauth':
				return $elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$OAUTH);
			case 'system':
				return $elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$SYSTEM);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$SYSTEM);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Insights$Apple$Decoders$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'appleConnectionType',
	$author$project$Insights$Apple$Decoders$appleConnectionTypeDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'placeId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timezoneOffset',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'url',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'placeId',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'initialFilter',
						$elm$json$Json$Decode$nullable(
							$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'language',
							$author$project$PinMeTo$Ui$I18n$Language$decoder,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'translations',
								$author$project$Common$Language$translationsDecoder,
								$author$project$Common$Language$initialTranslationsFallback,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['user', 'settings', 'locale']),
									$author$project$PinMeTo$Ui$I18n$Locale$decoder,
									$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'baseUrl',
										$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'insightsUrl',
											$elm_community$json_extra$Json$Decode$Extra$url,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'dateRange',
												$elm$json$Json$Decode$nullable($author$project$Insights$Apple$Decoders$dateRangeDecoder),
												$elm$core$Maybe$Nothing,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'today',
													$elm_community$json_extra$Json$Decode$Extra$datetime,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'siteName',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Insights$Apple$Model$Flags)))))))))))))));
var $author$project$Insights$Apple$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$Apple$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$Apple$Model$OnUrlChange)
			]));
};
var $author$project$Insights$Apple$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$Apple$Main$init, view: $author$project$Insights$Apple$View$view, update: $author$project$Insights$Apple$Main$update, flagsDecoder: $author$project$Insights$Apple$Decoders$flagsDecoder, subscriptions: $author$project$Insights$Apple$Main$subscriptions});
var $author$project$Insights$Bing$Model$DateRangePickerMsg = function (a) {
	return {$: 'DateRangePickerMsg', a: a};
};
var $author$project$Insights$Bing$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$Insights$Bing$Model$urlAppend = $author$project$Util$flip($elm$core$Basics$append);
var $author$project$Insights$Bing$Decoders$supportedDateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxDate',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minDate',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$Bing$Commands$getBingSupportedDateRange = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var httpRequest = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$lukewestby$elm_http_builder$HttpBuilder$get,
			function (_v1) {
				return $lukewestby$elm_http_builder$HttpBuilder$get;
			},
			model.locationId);
		var url = A2(
			$author$project$Insights$Bing$Model$urlAppend,
			'/bing/locations/metrics/supportedDateRange',
			A2(
				$author$project$Insights$Bing$Model$urlAppend,
				siteName,
				$elm$url$Url$toString(model.insightsUrl)));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Bing$Decoders$supportedDateRangeDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					httpRequest(url))));
	});
var $author$project$Insights$Bing$Model$GotBingSupportedDateRangeResponse = function (a) {
	return {$: 'GotBingSupportedDateRangeResponse', a: a};
};
var $author$project$Insights$Bing$Main$out_Insights_Bing_Main_onRangeChange = _Platform_outgoingPort('out_Insights_Bing_Main_onRangeChange', $elm$core$Basics$identity);
var $author$project$Insights$Bing$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$Insights,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var uiDateRangePicker = $author$project$PinMeTo$Ui$DateRangePicker$init;
		var timezone = A2($elm$time$Time$customZone, flags.timezoneOffset, _List_Nil);
		var model = {
			range: A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 28),
				flags.dateRange),
			today: flags.today,
			baseUrl: flags.url,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			lifetime: $elm$core$Maybe$Nothing,
			timezone: timezone,
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			locationId: flags.locationId,
			uiFeedback: $author$project$Listings$Ui$Feedback$init,
			insightsUrl: flags.insightsUrl,
			metricsData: $author$project$RemoteData$Loading,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			initialFilter: flags.initialFilter,
			filterController: filterControllerModel_,
			filterDefinition: $elm$core$Maybe$Nothing,
			uiDateRangePicker: uiDateRangePicker.a,
			topListMetricsData: $author$project$RemoteData$Loading,
			topListAmountToShow: 5,
			downloadMetricsState: $author$project$PinMeTo$Ui$Select$init
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Insights$Bing$Commands$getBingSupportedDateRange, model, session.siteName, $author$project$Insights$Bing$Model$GotBingSupportedDateRangeResponse),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Bing$Model$DateRangePickerMsg, uiDateRangePicker.b),
						A2($elm$core$Platform$Cmd$map, $author$project$Insights$Bing$Model$FilterControllerMsg, filterControllerCmd_),
						$author$project$Insights$Bing$Main$out_Insights_Bing_Main_onRangeChange(
						$author$project$Insights$Utils$encodeDateRange(model.range))
					])));
	});
var $author$project$Insights$Bing$Model$getDateLabel = function (model) {
	var toString = function (date) {
		return $justinmimbs$date$Date$toIsoString(date);
	};
	var from = toString(model.range.from);
	var to = toString(model.range.to);
	return from + (' - ' + to);
};
var $author$project$Insights$Bing$Model$TopList = {$: 'TopList'};
var $author$project$Insights$Bing$Model$OnPopOver = F2(
	function (a, b) {
		return {$: 'OnPopOver', a: a, b: b};
	});
var $author$project$Translations$Listings$Insights$bingActionsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_actions_popover');
};
var $author$project$Translations$Listings$Insights$bingImpressionsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_impressions_popover');
};
var $author$project$Translations$Listings$Insights$bingTopLocationsPopover = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_top_locations_popover');
};
var $author$project$Insights$Bing$View$Charts$popOverConfig = F2(
	function (popOverConfigType, translations) {
		var _v0 = function () {
			switch (popOverConfigType.$) {
				case 'Impressions':
					return _Utils_Tuple2(
						'bing-metrics-views-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$bingImpressionsPopover(translations))
							]));
				case 'Actions':
					return _Utils_Tuple2(
						'bing-metrics-actions-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$bingActionsPopover(translations))
							]));
				default:
					return _Utils_Tuple2(
						'bing-metrics-toplist-popover',
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Insights$bingTopLocationsPopover(translations))
							]));
			}
		}();
		var uid = _v0.a;
		var content = _v0.b;
		return $author$project$PinMeTo$Ui$PopOver$view(
			{
				uid: uid,
				tagger: $author$project$Insights$Bing$Model$OnPopOver(popOverConfigType),
				content: content,
				preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
			});
	});
var $author$project$Insights$Bing$Model$filterQueryString = F4(
	function (model, _v0, fileTypeStr, endpoint) {
		var siteName = _v0.a;
		var locationParam = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			$author$project$Insights$Bing$Model$urlAppend('/'),
			model.locationId);
		var filterQuery = '&' + A2(
			$elm$core$String$dropLeft,
			1,
			$author$project$Filter$FilterController$getCurrentFilterAsQueryString(model.filterController));
		var requestUrl = $elm$url$Url$toString(model.insightsUrl);
		var dateRange = model.range;
		var query = A2(
			$author$project$Insights$Bing$Model$urlAppend,
			filterQuery,
			A2(
				$author$project$Insights$Bing$Model$urlAppend,
				$justinmimbs$date$Date$toIsoString(dateRange.to),
				A2(
					$author$project$Insights$Bing$Model$urlAppend,
					'&to=',
					A2(
						$author$project$Insights$Bing$Model$urlAppend,
						$justinmimbs$date$Date$toIsoString(dateRange.from),
						'?from='))));
		return A2(
			$author$project$Insights$Bing$Model$urlAppend,
			query,
			A2(
				$author$project$Insights$Bing$Model$urlAppend,
				fileTypeStr,
				A2(
					$author$project$Insights$Bing$Model$urlAppend,
					endpoint,
					A2(
						$author$project$Insights$Bing$Model$urlAppend,
						locationParam,
						A2(
							$author$project$Insights$Bing$Model$urlAppend,
							'/bing/locations',
							A2($author$project$Insights$Bing$Model$urlAppend, siteName, requestUrl))))));
	});
var $author$project$Insights$Bing$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$Listings$Insights$impressionsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.impressions_title');
};
var $author$project$Translations$Listings$Insights$bingSimilarBusinessImpressionsTable = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_similar_business_impressions_table');
};
var $author$project$Insights$Bing$View$TopListSection$renderTopList = F4(
	function (session, model, topListMetricsData, sortedBy) {
		var site = $author$project$Data$SiteName$toString(session.siteName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-apple-insights-top-list')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A4(
						$author$project$PinMeTo$Ui$Table$addColumn,
						$author$project$Translations$General$locationCountry(session.translations),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.country;
							},
							$elm$html$Html$text),
						$author$project$PinMeTo$Ui$Table$comparing(
							function ($) {
								return $.country;
							}),
						A4(
							$author$project$PinMeTo$Ui$Table$addColumn,
							$author$project$Translations$General$locationCity(session.translations),
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.city;
								},
								$elm$html$Html$text),
							$author$project$PinMeTo$Ui$Table$comparing(
								function ($) {
									return $.city;
								}),
							A4(
								$author$project$PinMeTo$Ui$Table$addColumn,
								$author$project$Translations$General$locationZip(session.translations),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.zip;
									},
									$elm$html$Html$text),
								$author$project$PinMeTo$Ui$Table$comparing(
									function ($) {
										return $.zip;
									}),
								A4(
									$author$project$PinMeTo$Ui$Table$addCompactColumn,
									$author$project$Translations$General$locationStreet(session.translations),
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.street;
										},
										$elm$html$Html$text),
									$author$project$PinMeTo$Ui$Table$comparing(
										function ($) {
											return $.street;
										}),
									A4(
										$author$project$PinMeTo$Ui$Table$addCompactColumn,
										$author$project$Translations$General$locationDescriptor(session.translations),
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.locationDescriptor;
											},
											$elm$html$Html$text),
										$author$project$PinMeTo$Ui$Table$comparing(
											function ($) {
												return $.locationDescriptor;
											}),
										A4(
											$author$project$PinMeTo$Ui$Table$addColumn,
											$author$project$Translations$General$name(session.translations),
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.name;
												},
												$elm$html$Html$text),
											$author$project$PinMeTo$Ui$Table$comparing(
												function ($) {
													return $.name;
												}),
											A4(
												$author$project$PinMeTo$Ui$Table$addColumn,
												$author$project$Translations$General$locationStoreId(session.translations),
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.storeId;
													},
													$elm$html$Html$text),
												A2(
													$author$project$PinMeTo$Ui$Table$comparingStringAndNumber,
													30,
													function ($) {
														return $.storeId;
													}),
												A2(
													$author$project$PinMeTo$Ui$Table$withRowLink,
													function (location) {
														return '/listings/' + (site + ('/locations/' + (location.locationId + '/details')));
													},
													A5(
														$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
														$author$project$Translations$Listings$Insights$actionsTitle(session.translations),
														_List_fromArray(
															[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.actions;
															},
															A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.actions;
															}),
														A5(
															$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
															$author$project$Translations$Listings$Insights$bingSimilarBusinessImpressionsTable(session.translations),
															_List_fromArray(
																[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.competitorAverage;
																},
																A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
															$author$project$PinMeTo$Ui$Table$comparing(
																function ($) {
																	return $.competitorAverage;
																}),
															A5(
																$author$project$PinMeTo$Ui$Table$addColumnWithOptions,
																$author$project$Translations$Listings$Insights$impressionsTitle(session.translations),
																_List_fromArray(
																	[$author$project$PinMeTo$Ui$Table$Right, $author$project$PinMeTo$Ui$Table$Compact]),
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.impressions;
																	},
																	A2($elm$core$Basics$composeR, $author$project$Common$Math$formatNumber, $elm$html$Html$text)),
																$author$project$PinMeTo$Ui$Table$comparing(
																	function ($) {
																		return $.impressions;
																	}),
																A2(
																	$author$project$PinMeTo$Ui$Table$withLimit,
																	{
																		limit: model.topListAmountToShow,
																		viewMoreLabel: F2(
																			function (_v0, _v1) {
																				return 'Show more';
																			})
																	},
																	$author$project$PinMeTo$Ui$Table$withScrollableTable(
																		$author$project$PinMeTo$Ui$Table$withStickyHeader(
																			A2(
																				$author$project$PinMeTo$Ui$Table$withSort,
																				sortedBy,
																				A2($author$project$PinMeTo$Ui$Table$view, $author$project$Insights$Bing$Model$UiTableMsg, topListMetricsData)))))))))))))))))
				]));
	});
var $author$project$Insights$Bing$View$TopListSection$renderViewSelector = F2(
	function (session, model) {
		var topListMetricsData = function () {
			var _v0 = model.topListMetricsData;
			if (_v0.$ === 'Loaded') {
				var topListData = _v0.a;
				return topListData;
			} else {
				return _List_Nil;
			}
		}();
		var sortedBy = A2(
			$elm$core$Maybe$withDefault,
			$author$project$PinMeTo$Ui$Table$Desc(0),
			$author$project$PinMeTo$Ui$Table$getSort(model.uiTable));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Insights$Bing$View$TopListSection$renderTopList, session, model, topListMetricsData, sortedBy)
				]));
	});
var $author$project$Insights$Bing$Model$OnDownloadLabelClicked = function (a) {
	return {$: 'OnDownloadLabelClicked', a: a};
};
var $author$project$Insights$Bing$Model$OnDownloadMetricsClicked = function (a) {
	return {$: 'OnDownloadMetricsClicked', a: a};
};
var $author$project$Insights$Bing$View$TopListSection$view = F2(
	function (session, model) {
		var titleWithPopOver = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$topListings(session.translations)),
							A2(
							$author$project$PinMeTo$Ui$PopOver$renderPlain,
							model.popOverState,
							A2($author$project$Insights$Bing$View$Charts$popOverConfig, $author$project$Insights$Bing$Model$TopList, session.translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__top-list-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$General$topListingsDescription,
								session.translations,
								$author$project$Insights$Bing$Model$getDateLabel(model)))
						]))
				]));
		var dateRange = model.range;
		var asides = function () {
			var conf = {
				uid: 'ui-select-download-toplist-bing',
				items: _List_fromArray(
					[
						{
						url: A4($author$project$Insights$Bing$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/topList/download/'),
						label: $author$project$Translations$Listings$Insights$downloadListingsMetricsCsv(session.translations)
					},
						{
						url: A4($author$project$Insights$Bing$Model$filterQueryString, model, session.siteName, 'xlsx', '/metrics/topList/download/'),
						label: $author$project$Translations$Listings$Insights$downloadListingsMetricsXlsx(session.translations)
					}
					]),
				title: $author$project$Translations$Listings$Insights$downloadToplistTitle(session.translations),
				tagger: $author$project$Insights$Bing$Model$OnDownloadMetricsClicked,
				fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Bing-top-list_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
				onChange: $author$project$Insights$Bing$Model$OnDownloadLabelClicked,
				isDisabled: !_Utils_eq(
					A2(
						$author$project$RemoteData$map,
						function (data) {
							return $elm$core$List$isEmpty(data);
						},
						model.topListMetricsData),
					$author$project$RemoteData$Loaded(false))
			};
			return _List_fromArray(
				[
					A4(
					$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
					$author$project$Translations$Listings$Insights$downloadDetailedDataTooltip(session.translations),
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Insights$Utils$renderInsightsDownloadButton, conf, model.downloadMetricsState)
						]))
				]);
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withAsides,
						asides,
						A2(
							$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
							true,
							$author$project$PinMeTo$Ui$TitleBar$pmtTitleBarHtml(titleWithPopOver)))),
					function () {
					var _v0 = model.topListMetricsData;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$EmptyState$insights(
								$author$project$Translations$General$Insights$noData(session.translations));
						case 'Loading':
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-empty-state')
									]),
								_List_fromArray(
									[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
						case 'Loaded':
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Insights$Bing$View$TopListSection$renderViewSelector, session, model)
									]));
						default:
							var e = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
					}
				}()
				]));
	});
var $author$project$Insights$Bing$Model$Actions = {$: 'Actions'};
var $author$project$Insights$Bing$Model$UiFeedbackMsg = function (a) {
	return {$: 'UiFeedbackMsg', a: a};
};
var $author$project$Insights$Bing$View$Charts$uiFeedback = F3(
	function (translations, id, feedbackState) {
		return A2(
			$author$project$Listings$Ui$Feedback$render,
			feedbackState,
			$author$project$Listings$Ui$Feedback$view(
				{
					id: id,
					labels: {
						close: '',
						label: $author$project$Translations$Listings$Insights$feedbackLabel(translations),
						cancel: '',
						submit: '',
						submitting: '',
						submitAgain: '',
						generalError: '',
						negativeTooltip: $author$project$Translations$Listings$Insights$feedbackNegativeLabel(translations),
						positiveTooltip: $author$project$Translations$Listings$Insights$feedbackPositiveLabel(translations),
						confirmationTitle: '',
						negativeFeedbackTitle: '',
						negativeFeedbackPlaceholder: ''
					},
					tagger: $author$project$Insights$Bing$Model$UiFeedbackMsg,
					thumbsUpEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Up', id),
					thumbsDownEvent: A2($author$project$Common$Metrics$clickEvent, 'Clicked Thumbs Down', id)
				}));
	});
var $author$project$Insights$Bing$View$Charts$renderAsides = F3(
	function (session, model, uid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-insights__highlight--asides')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__ui-feedback')
						]),
					_List_fromArray(
						[
							A3($author$project$Insights$Bing$View$Charts$uiFeedback, session.translations, uid, model.uiFeedback)
						]))
				]));
	});
var $author$project$Insights$Bing$View$Charts$sortActionsData = F2(
	function (session, actionsData) {
		return A2(
			$elm$core$List$sortBy,
			function (metricData) {
				return _Utils_eq(
					metricData.title,
					$author$project$Translations$Listings$Insights$appleActionsDirections(session.translations)) ? 0 : (_Utils_eq(
					metricData.title,
					$author$project$Translations$Listings$Insights$appleActionsCalls(session.translations)) ? 1 : 2);
			},
			actionsData);
	});
var $author$project$Translations$Listings$Insights$bingImpressions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_impressions');
};
var $author$project$Translations$Listings$Insights$bingPhoneClicks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_phone_clicks');
};
var $author$project$Translations$Listings$Insights$bingMetricUnknown = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_metric_unknown');
};
var $author$project$Translations$Listings$Insights$bingWebsiteClicks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_website_clicks');
};
var $author$project$Translations$Listings$Insights$bingDirectionClicks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_direction_clicks');
};
var $author$project$Translations$Listings$Insights$bingSimilarBusinessImpressionsChart = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_similar_business_impressions_chart');
};
var $author$project$Insights$Bing$View$Charts$areaChartTitleAndColor = F2(
	function (translations, metricData) {
		var _v0 = metricData.metricName;
		switch (_v0) {
			case 'impressions':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$Listings$Insights$bingImpressions(translations)
				};
			case 'similarBusinessImpressions':
				return {
					data: metricData.metrics,
					color: '#F15079',
					title: $author$project$Translations$Listings$Insights$bingSimilarBusinessImpressionsChart(translations)
				};
			case 'websiteClicks':
				return {
					data: metricData.metrics,
					color: '#9933FF',
					title: $author$project$Translations$Listings$Insights$bingWebsiteClicks(translations)
				};
			case 'phoneClicks':
				return {
					data: metricData.metrics,
					color: '#61D173',
					title: $author$project$Translations$Listings$Insights$bingPhoneClicks(translations)
				};
			case 'directionClicks':
				return {
					data: metricData.metrics,
					color: '#3399FF',
					title: $author$project$Translations$Listings$Insights$bingDirectionClicks(translations)
				};
			default:
				return {
					data: _List_Nil,
					color: '#FFC107',
					title: $author$project$Translations$Listings$Insights$bingMetricUnknown(translations)
				};
		}
	});
var $author$project$Insights$Bing$View$Charts$filterMetricData = F3(
	function (session, keys, metricData) {
		var inActionDataKeys = A2($elm$core$List$member, metricData.metricName, keys);
		return inActionDataKeys ? $elm$core$Maybe$Just(
			A2($author$project$Insights$Bing$View$Charts$areaChartTitleAndColor, session.translations, metricData)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Insights$Bing$View$Charts$filterActionsData = function (session) {
	return A2(
		$author$project$Insights$Bing$View$Charts$filterMetricData,
		session,
		_List_fromArray(
			['websiteClicks', 'phoneClicks', 'directionClicks']));
};
var $author$project$Translations$Listings$Insights$bingActionsDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.bing_actions_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Bing$View$Charts$renderActionsChart = F4(
	function (session, model, placeCardMetricsData, dateLabel) {
		var actionsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A2(
				$elm$core$List$filterMap,
				$author$project$Insights$Bing$View$Charts$filterActionsData(session),
				placeCardMetricsData));
		var sortedActionsData = A2($author$project$Insights$Bing$View$Charts$sortActionsData, session, actionsData);
		var actionsChart = A3($author$project$Insights$Utils$renderAreaChart, session, true, sortedActionsData);
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(actionsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Bing$View$Charts$renderAsides, session, model, 'bing-insights-views'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Bing$View$Charts$popOverConfig, $author$project$Insights$Bing$Model$Actions, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$bingActionsDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$actionsTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[actionsChart])))));
	});
var $author$project$PinMeTo$Ui$Chart$MixArea = {$: 'MixArea'};
var $author$project$PinMeTo$Ui$Chart$MixLine = {$: 'MixLine'};
var $author$project$Insights$Bing$Model$Impressions = {$: 'Impressions'};
var $author$project$PinMeTo$Ui$Chart$Mixed = F2(
	function (a, b) {
		return {$: 'Mixed', a: a, b: b};
	});
var $author$project$Insights$Utils$renderMixedChart = F4(
	function (session, withLegendTotal, types, datasets) {
		return $author$project$PinMeTo$Ui$Chart$render(
			A2(
				$author$project$PinMeTo$Ui$Chart$withLocale,
				session.locale,
				(withLegendTotal ? $author$project$PinMeTo$Ui$Chart$withLegendConfig($author$project$PinMeTo$Ui$Chart$Legend$withTotal) : $author$project$PinMeTo$Ui$Chart$withLegend)(
					$author$project$PinMeTo$Ui$Chart$view(
						{
							chart: A2($author$project$PinMeTo$Ui$Chart$Mixed, types, datasets)
						}))));
	});
var $author$project$Translations$Listings$Insights$bingImpressionsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.insights.bing_impressions_title');
};
var $author$project$Insights$Bing$View$Charts$filterCompetitorData = function (session) {
	return A2(
		$author$project$Insights$Bing$View$Charts$filterMetricData,
		session,
		_List_fromArray(
			['similarBusinessImpressions']));
};
var $author$project$Insights$Bing$View$Charts$filterImpressionsData = function (session) {
	return A2(
		$author$project$Insights$Bing$View$Charts$filterMetricData,
		session,
		_List_fromArray(
			['impressions']));
};
var $author$project$Translations$Listings$Insights$bingImpressionDescription = F2(
	function (translations, dateRange) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.insights.bing_impression_description',
			_List_fromArray(
				[
					_Utils_Tuple2(' dateRange ', dateRange)
				]));
	});
var $author$project$Insights$Bing$View$Charts$renderImpressionsChart = F4(
	function (session, model, metricsData, dateLabel) {
		var impressionsData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A2(
				$elm$core$List$filterMap,
				$author$project$Insights$Bing$View$Charts$filterImpressionsData(session),
				metricsData));
		var competitorData = A2(
			$author$project$Insights$Utils$padListOfDataItemSeries,
			model.range,
			A2(
				$elm$core$List$filterMap,
				$author$project$Insights$Bing$View$Charts$filterCompetitorData(session),
				metricsData));
		var impressionsChart = A4(
			$author$project$Insights$Utils$renderMixedChart,
			session,
			true,
			_List_fromArray(
				[$author$project$PinMeTo$Ui$Chart$MixArea, $author$project$PinMeTo$Ui$Chart$MixLine]),
			_List_fromArray(
				[impressionsData, competitorData]));
		return $author$project$PinMeTo$Ui$Card$render(
			A2(
				$author$project$PinMeTo$Ui$Card$withHeader,
				$author$project$Listings$Ui$InsightsHeader$render(
					A2(
						$author$project$Listings$Ui$InsightsHeader$withNumber,
						$author$project$Common$Math$formatNumber(
							$author$project$Insights$Utils$metricTotal(impressionsData)),
						A2(
							$author$project$Listings$Ui$InsightsHeader$withAsides,
							A3($author$project$Insights$Bing$View$Charts$renderAsides, session, model, 'bing-insights-views'),
							A2(
								$author$project$Listings$Ui$InsightsHeader$withPopOver,
								_Utils_Tuple2(
									A2($author$project$Insights$Bing$View$Charts$popOverConfig, $author$project$Insights$Bing$Model$Impressions, session.translations),
									model.popOverState),
								A2(
									$author$project$Listings$Ui$InsightsHeader$withNote,
									$elm$html$Html$text(
										A2($author$project$Translations$Listings$Insights$bingImpressionDescription, session.translations, dateLabel)),
									$author$project$Listings$Ui$InsightsHeader$view(
										{
											title: $author$project$Translations$Listings$Insights$bingImpressionsTitle(session.translations)
										})))))),
				$author$project$PinMeTo$Ui$Card$view(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-insights__chart')
							]),
						_List_fromArray(
							[impressionsChart])))));
	});
var $author$project$Insights$Bing$View$MetricSection$renderCharts = F4(
	function (session, model, dateLabel, includeTopList) {
		var _v0 = model.metricsData;
		switch (_v0.$) {
			case 'Suspended':
				return $author$project$PinMeTo$Ui$EmptyState$insights(
					$author$project$Translations$General$Insights$noData(session.translations));
			case 'Loading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-empty-state')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			case 'Loaded':
				if (!_v0.a.b) {
					return $author$project$PinMeTo$Ui$EmptyState$insights(
						$author$project$Translations$General$Insights$noData(session.translations));
				} else {
					var metricsData = _v0.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A4($author$project$Insights$Bing$View$Charts$renderImpressionsChart, session, model, metricsData, dateLabel),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A4($author$project$Insights$Bing$View$Charts$renderActionsChart, session, model, metricsData, dateLabel),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								includeTopList ? A2($author$project$Insights$Bing$View$TopListSection$view, session, model) : $elm$html$Html$text('')
							]));
				}
			default:
				var e = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger status-bar--margin-top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(e)
						]));
		}
	});
var $author$project$Insights$Bing$View$MetricSection$view = F2(
	function (session, model) {
		var dateLabel = $author$project$Insights$Bing$Model$getDateLabel(model);
		var charts = A4(
			$author$project$Insights$Bing$View$MetricSection$renderCharts,
			session,
			model,
			dateLabel,
			$elm_community$maybe_extra$Maybe$Extra$isNothing(model.locationId));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[charts]));
	});
var $author$project$Translations$General$Insights$bingInsightsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.insights.bing_insights_title');
};
var $author$project$Insights$Bing$Model$DownloadFilterButtonMsg = function (a) {
	return {$: 'DownloadFilterButtonMsg', a: a};
};
var $author$project$Insights$Bing$View$view = F2(
	function (session, model) {
		var initFilterController = function (controller) {
			return A2(
				$elm$html$Html$map,
				$author$project$Insights$Bing$Model$FilterControllerMsg,
				A4($author$project$Filter$FilterController$viewInsights, controller, session.locale, session.translations, session.language));
		};
		var filterControllerHandler = function () {
			var noFilterPlaceHolder = A2($elm$html$Html$div, _List_Nil, _List_Nil);
			var shouldShowFilter = $elm_community$maybe_extra$Maybe$Extra$isNothing;
			return shouldShowFilter(model.locationId) ? initFilterController(model.filterController) : noFilterPlaceHolder;
		}();
		var dateRange = model.range;
		var downloadFilterButtonInit = {
			uid: 'ui-select-download-bing-metric',
			items: _List_fromArray(
				[
					{
					url: A4($author$project$Insights$Bing$Model$filterQueryString, model, session.siteName, 'csv', '/metrics/download/'),
					label: $author$project$Translations$Listings$Insights$downloadDataSummaryCsv(session.translations)
				},
					{
					url: A4($author$project$Insights$Bing$Model$filterQueryString, model, session.siteName, 'xslsx', '/metrics/download/'),
					label: $author$project$Translations$Listings$Insights$downloadDataSummaryXlsx(session.translations)
				}
				]),
			title: $author$project$Translations$Listings$Insights$downloadMetricsTitle(session.translations),
			tagger: $author$project$Insights$Bing$Model$DownloadFilterButtonMsg,
			fileName: $author$project$Data$SiteName$toString(session.siteName) + ('_' + ('Bing-Insights_' + ($justinmimbs$date$Date$toIsoString(dateRange.from) + ('_' + $justinmimbs$date$Date$toIsoString(dateRange.to))))),
			onChange: $author$project$Insights$Bing$Model$OnDownloadLabelClicked,
			isDisabled: !_Utils_eq(
				A2(
					$author$project$RemoteData$map,
					function (insights) {
						return A2(
							$elm$core$List$all,
							function (data) {
								return $elm$core$List$isEmpty(data.metrics);
							},
							insights);
					},
					model.metricsData),
				$author$project$RemoteData$Loaded(false))
		};
		var downloadMetricsDropdown = A4(
			$author$project$PinMeTo$Ui$Tooltip$tooltipLeft,
			$author$project$Translations$Listings$Insights$downloadSummaryTooltip(session.translations),
			$elm$html$Html$b,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Insights$Utils$renderInsightsDownloadButton, downloadFilterButtonInit, model.uiSelect)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-page container')
				]),
			_List_fromArray(
				[
					filterControllerHandler,
					$author$project$PinMeTo$Ui$TitleBar$render(
					A2(
						$author$project$PinMeTo$Ui$TitleBar$withLightStyle,
						true,
						$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
							$author$project$Translations$General$Insights$bingInsightsTitle(session.translations)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__date-picker-and-export-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$PinMeTo$Ui$DateRangePicker$render,
									model.uiDateRangePicker,
									function () {
										var _v0 = model.lifetime;
										if (_v0.$ === 'Just') {
											var lifetime = _v0.a;
											return $author$project$PinMeTo$Ui$DateRangePicker$withRanges(
												_List_fromArray(
													[
														A3(
														$author$project$PinMeTo$Ui$DateRangePicker$presetCustom,
														$author$project$Translations$General$Insights$lifetime(session.translations),
														'Lifetime',
														lifetime)
													]));
										} else {
											return $elm$core$Basics$identity;
										}
									}()(
										$author$project$PinMeTo$Ui$DateRangePicker$view(
											{
												uid: 'bing-insights-date-range-picker',
												range: model.range,
												labels: A2($author$project$Labels$uiDateRangePicker, session.translations, session.language),
												locale: session.locale,
												tagger: $author$project$Insights$Bing$Model$DateRangePickerMsg,
												language: session.language
											})))
								])),
							downloadMetricsDropdown
						])),
					A2($author$project$Insights$Bing$View$MetricSection$view, session, model),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Insights$Bing$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$Insights$Bing$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$Insights$Bing$Commands$isLifetime = F2(
	function (dateRange, supportedDateRange) {
		if (supportedDateRange.$ === 'Just') {
			var supportedDateRange_ = supportedDateRange.a;
			return _Utils_eq(supportedDateRange_.from, dateRange.from) && _Utils_eq(supportedDateRange_.to, dateRange.to);
		} else {
			return false;
		}
	});
var $author$project$Insights$Bing$Commands$getQueryParams = function (model) {
	var dateRange = model.range;
	var isLifetime_ = A2($author$project$Insights$Bing$Commands$isLifetime, dateRange, model.lifetime);
	var lifetime = isLifetime_ ? '&lifetime=true' : '';
	var from = $justinmimbs$date$Date$toIsoString(dateRange.from);
	var to = $justinmimbs$date$Date$toIsoString(dateRange.to);
	return '?from=' + (from + ('&to=' + (to + lifetime)));
};
var $author$project$Insights$Bing$Model$BingMetric = F2(
	function (metricName, metrics) {
		return {metrics: metrics, metricName: metricName};
	});
var $author$project$Insights$Bing$Model$BingMetricDetails = F2(
	function (key, value) {
		return {key: key, value: value};
	});
var $author$project$Insights$Bing$Decoders$bingMetricDetailsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Bing$Model$BingMetricDetails)));
var $author$project$Insights$Bing$Decoders$bingMetricDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metrics',
	$elm$json$Json$Decode$list($author$project$Insights$Bing$Decoders$bingMetricDetailsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Insights$Bing$Model$BingMetric)));
var $author$project$Insights$Bing$Decoders$bingMetricListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metrics',
	$elm$json$Json$Decode$list($author$project$Insights$Bing$Decoders$bingMetricDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Insights$Bing$Commands$getBingMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var locationId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (locationId_) {
					return locationId_ + '/';
				},
				model.locationId));
		var url = A2(
			$author$project$Insights$Bing$Model$urlAppend,
			$author$project$Insights$Bing$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Bing$Model$urlAppend,
				'metrics',
				A2(
					$author$project$Insights$Bing$Model$urlAppend,
					locationId,
					A2(
						$author$project$Insights$Bing$Model$urlAppend,
						'/bing/locations/',
						A2(
							$author$project$Insights$Bing$Model$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Bing$Decoders$bingMetricListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Bing$Model$OnMetricsFetched = function (a) {
	return {$: 'OnMetricsFetched', a: a};
};
var $author$project$Insights$Bing$Model$OnTopListFetched = function (a) {
	return {$: 'OnTopListFetched', a: a};
};
var $author$project$Insights$Bing$Model$TopListLocation = function (name) {
	return function (storeId) {
		return function (locationDescriptor) {
			return function (locationId) {
				return function (zip) {
					return function (street) {
						return function (city) {
							return function (country) {
								return function (actions) {
									return function (competitorAverage) {
										return function (impressions) {
											return {zip: zip, city: city, name: name, street: street, actions: actions, country: country, storeId: storeId, locationId: locationId, impressions: impressions, competitorAverage: competitorAverage, locationDescriptor: locationDescriptor};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Bing$Decoders$topListLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'impressions',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'competitorAverage',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'actions',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['location', 'address', 'country']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['location', 'address', 'city']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['location', 'address', 'street']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['location', 'address', 'zip']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['location', '_id']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['location', 'locationDescriptor']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['location', 'storeId']),
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['location', 'name']),
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Insights$Bing$Model$TopListLocation))))))))))));
var $author$project$Insights$Bing$Decoders$topListDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['metrics']),
	$elm$json$Json$Decode$list($author$project$Insights$Bing$Decoders$topListLocationDecoder));
var $author$project$Insights$Bing$Commands$getBingTopListMetrics = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = A2(
			$author$project$Insights$Bing$Model$urlAppend,
			$author$project$Insights$Bing$Commands$getQueryParams(model),
			A2(
				$author$project$Insights$Bing$Model$urlAppend,
				'/bing/locations/metrics/topList',
				A2(
					$author$project$Insights$Bing$Model$urlAppend,
					siteName,
					$elm$url$Url$toString(model.insightsUrl))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Insights$Bing$Decoders$topListDecoder, $elm$json$Json$Decode$string),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					function (filter) {
						return $lukewestby$elm_http_builder$HttpBuilder$withJsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2('filter', filter)
									])));
					},
					model.filterDefinition,
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post(url)))));
	});
var $author$project$Insights$Bing$Commands$fetchAllMetrics = F2(
	function (model, siteName) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Insights$Bing$Commands$getBingMetrics, model, siteName, $author$project$Insights$Bing$Model$OnMetricsFetched),
					A3($author$project$Insights$Bing$Commands$getBingTopListMetrics, model, siteName, $author$project$Insights$Bing$Model$OnTopListFetched)
				]));
	});
var $author$project$Insights$Bing$Model$OnDateRangeChange = function (a) {
	return {$: 'OnDateRangeChange', a: a};
};
var $author$project$Insights$Bing$Main$out_Insights_Bing_Main_onFilter = _Platform_outgoingPort('out_Insights_Bing_Main_onFilter', $elm$core$Basics$identity);
var $author$project$Insights$Bing$Main$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'GotBingSupportedDateRangeResponse':
				if (msg.a.$ === 'Ok') {
					var supportedDateRange = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							lifetime: $elm$core$Maybe$Just(supportedDateRange)
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				var _v1 = A5($author$project$Filter$FilterController$update, $author$project$Insights$Bing$Model$FilterControllerMsg, msg_, model.filterController, $author$project$Insights$Bing$Model$OnFilter, $author$project$Insights$Bing$Model$OnSearch);
				var filterControllerModel_ = _v1.a;
				var filterControllerCmd_ = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{filterController: filterControllerModel_}),
					filterControllerCmd_);
			case 'OnFilter':
				var newFilterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						metricsData: $author$project$RemoteData$Loading,
						filterDefinition: $elm$core$Maybe$Just(newFilterDefinition),
						topListMetricsData: $author$project$RemoteData$Loading
					});
				var newMsg = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Insights$Bing$Main$out_Insights_Bing_Main_onFilter(newFilterDefinition),
							A2($author$project$Insights$Bing$Commands$fetchAllMetrics, newModel, session.siteName)
						]));
				return _Utils_Tuple2(newModel, newMsg);
			case 'DateRangePickerMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiDateRangePicker: x});
					},
					A3(
						$author$project$PinMeTo$Ui$DateRangePicker$update,
						{
							tagger: $author$project$Insights$Bing$Model$DateRangePickerMsg,
							onChange: $author$project$Insights$Bing$Model$OnDateRangeChange,
							metricsPrefix: $author$project$Common$Metrics$prefix('Bing Insights')
						},
						msg_,
						model.uiDateRangePicker));
			case 'OnDateRangeChange':
				var range = msg.a;
				var encodedDateRange = $author$project$Insights$Utils$encodeDateRange(range);
				var newModel = _Utils_update(
					model,
					{range: range, metricsData: $author$project$RemoteData$Loading, topListMetricsData: $author$project$RemoteData$Loading});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Insights$Bing$Commands$fetchAllMetrics, newModel, session.siteName),
								$author$project$Insights$Bing$Main$out_Insights_Bing_Main_onRangeChange(encodedDateRange)
							])));
			case 'OnMetricsFetched':
				if (msg.a.$ === 'Ok') {
					var newMetrics = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								metricsData: $author$project$RemoteData$Loaded(newMetrics)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnTopListFetched':
				if (msg.a.$ === 'Ok') {
					var newTopList = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								topListMetricsData: $author$project$RemoteData$Loaded(newTopList)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnPopOver':
				var popOverConfigType = msg.a;
				var popOverMsg = msg.b;
				var planhatTrack = function () {
					if (popOverMsg.$ === 'Open') {
						switch (popOverConfigType.$) {
							case 'Impressions':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.bing.impressionsPopoverClicked;
							case 'Actions':
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.bing.actionsPopoverClicked;
							default:
								return $author$project$PlanHat$TrackingActions$keys.insights.listings.bing.topListPopoverClicked;
						}
					} else {
						return '';
					}
				}();
				var planhatTrackCmd = (planhatTrack !== '') ? $author$project$PlanHat$PlanHat$track(
					{info: '', action: planhatTrack}) : $elm$core$Platform$Cmd$none;
				var _v2 = A3(
					$author$project$PinMeTo$Ui$PopOver$update,
					$author$project$Insights$Bing$Model$OnPopOver(popOverConfigType),
					popOverMsg,
					model.popOverState);
				var newState = _v2.a;
				var cmd_ = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newState}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd_, planhatTrackCmd])));
			case 'UiTableMsg':
				var uiTableMsg = msg.a;
				var newTable = A2($author$project$PinMeTo$Ui$Table$update, uiTableMsg, model.uiTable);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiTable: newTable}),
					$elm$core$Platform$Cmd$none);
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'UiFeedbackMsg':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'DownloadFilterButtonMsg':
				var downloadFilterButtonMsg = msg.a;
				var _v5 = A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Bing$Model$DownloadFilterButtonMsg, downloadFilterButtonMsg, model.uiSelect);
				var newState = _v5.a;
				var newMsg = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiSelect: newState}),
					newMsg);
			case 'OnUrlChange':
				var jdValue = msg.a;
				var decodeResult = A2($elm$json$Json$Decode$decodeValue, $elm_community$json_extra$Json$Decode$Extra$url, jdValue);
				var newModel = function () {
					if (decodeResult.$ === 'Ok') {
						var url = decodeResult.a;
						return _Utils_update(
							model,
							{
								baseUrl: $elm$core$Maybe$Just(url)
							});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'OnDownloadLabelClicked':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var uiSelectMsg = msg.a;
				var _v7 = A3($author$project$PinMeTo$Ui$Select$update, $author$project$Insights$Bing$Model$OnDownloadMetricsClicked, uiSelectMsg, model.downloadMetricsState);
				var newState = _v7.a;
				var newMsg = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{downloadMetricsState: newState}),
					newMsg);
		}
	});
var $author$project$Insights$Bing$Model$Flags = function (siteName) {
	return function (today) {
		return function (dateRange) {
			return function (insightsUrl) {
				return function (baseUrl) {
					return function (locale) {
						return function (translations) {
							return function (language) {
								return function (initialFilter) {
									return function (placeId) {
										return function (url) {
											return function (timezoneOffset) {
												return function (locationId) {
													return {url: url, today: today, locale: locale, baseUrl: baseUrl, placeId: placeId, language: language, siteName: siteName, dateRange: dateRange, locationId: locationId, insightsUrl: insightsUrl, translations: translations, initialFilter: initialFilter, timezoneOffset: timezoneOffset};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Insights$Bing$Decoders$dateRangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Common$Date$stringToDateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Common$Date$stringToDateDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Ui$DateRangePicker$Range)));
var $author$project$Insights$Bing$Decoders$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'placeId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timezoneOffset',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'url',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'placeId',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'initialFilter',
					$elm$json$Json$Decode$nullable(
						$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'language',
						$author$project$PinMeTo$Ui$I18n$Language$decoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'translations',
							$author$project$Common$Language$translationsDecoder,
							$author$project$Common$Language$initialTranslationsFallback,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['user', 'settings', 'locale']),
								$author$project$PinMeTo$Ui$I18n$Locale$decoder,
								$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'baseUrl',
									$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$url),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'insightsUrl',
										$elm_community$json_extra$Json$Decode$Extra$url,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'dateRange',
											$elm$json$Json$Decode$nullable($author$project$Insights$Bing$Decoders$dateRangeDecoder),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'today',
												$elm_community$json_extra$Json$Decode$Extra$datetime,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'siteName',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Insights$Bing$Model$Flags))))))))))))));
var $author$project$Insights$Bing$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Insights$Bing$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Common$PollPortModule$urlChange($author$project$Insights$Bing$Model$OnUrlChange)
			]));
};
var $author$project$Insights$Bing$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Insights$Bing$Main$init, view: $author$project$Insights$Bing$View$view, update: $author$project$Insights$Bing$Main$update, flagsDecoder: $author$project$Insights$Bing$Decoders$flagsDecoder, subscriptions: $author$project$Insights$Bing$Main$subscriptions});
var $author$project$UserSettings$Legal$OnTimeZone = function (a) {
	return {$: 'OnTimeZone', a: a};
};
var $author$project$UserSettings$Legal$getTimeZone = function (tagger) {
	var zone = A2(
		$elm$core$Task$onError,
		$elm$core$Basics$always(
			$elm$core$Task$succeed($elm$time$Time$utc)),
		A2($elm$core$Task$map, $elm$core$Tuple$second, $justinmimbs$timezone_data$TimeZone$getZone));
	return A2(
		$elm$core$Task$perform,
		A2($elm$core$Basics$composeR, $author$project$UserSettings$Legal$OnTimeZone, tagger),
		zone);
};
var $author$project$UserSettings$Legal$Document = F4(
	function (displayName, docType, id, when) {
		return {id: id, when: when, docType: docType, displayName: displayName};
	});
var $author$project$UserSettings$Legal$documentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'when',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'displayName',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$UserSettings$Legal$Document)))));
var $author$project$UserSettings$Legal$documentsDecoder = $elm$json$Json$Decode$list($author$project$UserSettings$Legal$documentDecoder);
var $author$project$UserSettings$Legal$GetLegalDocuments = function (a) {
	return {$: 'GetLegalDocuments', a: a};
};
var $author$project$UserSettings$Legal$getLegalDocuments = function (tagger) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $author$project$UserSettings$Legal$GetLegalDocuments, tagger),
				$author$project$UserSettings$Legal$documentsDecoder),
			$lukewestby$elm_http_builder$HttpBuilder$get('api/legal/accepted')));
};
var $author$project$UserSettings$Legal$init = F2(
	function (tagger, translations) {
		return _Utils_Tuple2(
			{timeZone: $elm$time$Time$utc, documents: $author$project$RemoteData$Loading, translations: translations},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$UserSettings$Legal$getLegalDocuments(tagger),
						$author$project$UserSettings$Legal$getTimeZone(tagger)
					])));
	});
var $author$project$UserSettings$Language$Settings = F2(
	function (locale, language) {
		return {locale: locale, language: language};
	});
var $author$project$UserSettings$Language$settingsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$UserSettings$Language$Settings,
	A2($elm$json$Json$Decode$field, 'locale', $author$project$PinMeTo$Ui$I18n$Locale$decoder),
	A2($elm$json$Json$Decode$field, 'language', $author$project$PinMeTo$Ui$I18n$Language$decoder));
var $author$project$UserSettings$Language$GetSettingsResponse = function (a) {
	return {$: 'GetSettingsResponse', a: a};
};
var $author$project$UserSettings$Language$getSettings = function (tagger) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A3(
				$author$project$PinMeTo$ExpectJson$expectJson,
				A2($elm$core$Basics$composeR, $author$project$UserSettings$Language$GetSettingsResponse, tagger),
				$author$project$UserSettings$Language$settingsDecoder,
				$elm$json$Json$Decode$string),
			$lukewestby$elm_http_builder$HttpBuilder$get('api/user/settings')));
};
var $author$project$UserSettings$Language$init = F3(
	function (tagger, user, translations) {
		return _Utils_Tuple2(
			{user: user, settings: $author$project$RemoteData$Loading, uiSelect: $author$project$PinMeTo$Ui$Select$init, saveResult: $author$project$RemoteData$Suspended, translations: translations, currentLocale: $elm$core$Maybe$Nothing, currentLanguage: $elm$core$Maybe$Nothing},
			$author$project$UserSettings$Language$getSettings(tagger));
	});
var $author$project$UserSettings$ChangePassword$init = function (user) {
	return _Utils_Tuple2(user, $elm$core$Platform$Cmd$none);
};
var $author$project$PinMeTo$Global$NewsFeed$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Global$NewsFeed$Loading = {$: 'Loading'};
var $author$project$PinMeTo$Global$NewsFeed$init = $author$project$PinMeTo$Global$NewsFeed$State(
	{articles: $author$project$PinMeTo$Global$NewsFeed$Loading, latestSeen: 0});
var $author$project$PinMeTo$Global$SupportTicket$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Global$SupportTicket$Closed = {$: 'Closed'};
var $author$project$PinMeTo$Global$SupportTicket$Editing = {$: 'Editing'};
var $author$project$PinMeTo$Global$SupportTicket$init = function (siteName) {
	return $author$project$PinMeTo$Global$SupportTicket$State(
		{open: false, error: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing, header: $elm$core$Maybe$Nothing, images: $elm$core$Set$empty, message: $elm$core$Maybe$Nothing, siteName: siteName, imageFiles: $elm$core$Dict$empty, sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing, imagePreview: $author$project$PinMeTo$Global$SupportTicket$Closed, showRequiredMessage: false});
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Collapsed = {$: 'Collapsed'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$init = F2(
	function (_v0, isMobile) {
		var config = _v0.a;
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$State(
			{isMobile: isMobile, rightSideBarState: $author$project$PinMeTo$Global$TopNavigation$Navigation$Collapsed, topNavigationState: config.topNavigation, activeTopNavigationIndex: $elm$core$Maybe$Nothing});
	});
var $author$project$PinMeTo$Global$TopNavigation$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg = function (a) {
	return {$: 'ChatMsg', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$noLauncher = function (_v0) {
	return $elm$html$Html$text('');
};
var $author$project$PinMeTo$Global$TopNavigation$Msg$WindowResize = function (a) {
	return {$: 'WindowResize', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$getViewport = A2(
	$elm$core$Task$perform,
	function (vp) {
		return $author$project$PinMeTo$Global$TopNavigation$Msg$WindowResize(
			$elm$core$Basics$ceiling(vp.viewport.width));
	},
	$elm$browser$Browser$Dom$getViewport);
var $author$project$PinMeTo$Global$TopNavigation$Chat$State = function (a) {
	return {$: 'State', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$GotStatus = function (a) {
	return {$: 'GotStatus', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$InitPending = {$: 'InitPending'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$ChatInfo = F2(
	function (status, user) {
		return {user: user, status: status};
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$ChatEnabled = {$: 'ChatEnabled'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$ChatDisabled = {$: 'ChatDisabled'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$ChatUser = F8(
	function (firstName, lastName, profileImage, email, encryptedEmail, locale, language, siteName) {
		return {email: email, locale: locale, language: language, lastName: lastName, siteName: siteName, firstName: firstName, profileImage: profileImage, encryptedEmail: encryptedEmail};
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$chatUserDecoded = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['selectedSite', 'name']),
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['settings', 'language']),
		$elm$json$Json$Decode$string,
		$author$project$PinMeTo$Ui$I18n$Language$toString($author$project$PinMeTo$Ui$I18n$Language$En),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['settings', 'locale']),
			$elm$json$Json$Decode$string,
			$author$project$PinMeTo$Ui$I18n$Locale$toString($author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'encryptedEmail',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'profileImage',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'firstName',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Chat$ChatUser)))))))));
var $author$project$PinMeTo$Global$TopNavigation$Chat$chatStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$author$project$PinMeTo$Global$TopNavigation$Chat$chatUserDecoded,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'chatEnabled',
		A2(
			$elm$json$Json$Decode$andThen,
			function (enabled) {
				return enabled ? $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Chat$ChatEnabled) : $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Chat$ChatDisabled);
			},
			$elm$json$Json$Decode$bool),
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Chat$ChatInfo)));
var $author$project$PinMeTo$Global$TopNavigation$Chat$getChatStatus = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$PinMeTo$Global$TopNavigation$Chat$chatStatusDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('/api/' + (siteName + '/chat'))));
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$initForSite = function (_v0) {
	var site = _v0.site;
	return _Utils_Tuple2(
		$author$project$PinMeTo$Global$TopNavigation$Chat$State(
			{info: $elm$core$Maybe$Nothing, initState: $author$project$PinMeTo$Global$TopNavigation$Chat$InitPending, companyName: $elm$core$Maybe$Nothing, notEnabledOpen: false}),
		A2($author$project$PinMeTo$Global$TopNavigation$Chat$getChatStatus, site, $author$project$PinMeTo$Global$TopNavigation$Chat$GotStatus));
};
var $author$project$PinMeTo$Global$TopNavigation$Msg$GetProfileImg = function (a) {
	return {$: 'GetProfileImg', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Msg$NavigationMsg = function (a) {
	return {$: 'NavigationMsg', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Config = function (a) {
	return {$: 'Config', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$buildNavigation = F2(
	function (tagger, chatLauncher) {
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$Config(
			{tagger: tagger, chatLauncher: chatLauncher, topNavigation: _List_Nil});
	});
var $author$project$PinMeTo$Global$TopNavigation$topNavigation = $author$project$PinMeTo$Global$TopNavigation$Navigation$buildNavigation($author$project$PinMeTo$Global$TopNavigation$Msg$NavigationMsg);
var $author$project$PinMeTo$Global$NewsFeed$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$PinMeTo$Global$NewsFeed$Link = function (a) {
	return {$: 'Link', a: a};
};
var $author$project$PinMeTo$Global$NewsFeed$Posts = {$: 'Posts'};
var $author$project$PinMeTo$Global$NewsFeed$Places = {$: 'Places'};
var $author$project$PinMeTo$Global$NewsFeed$Article = F8(
	function (id, trackingId, application, applicationCta, applicationUrl, title, content, contentLink) {
		return {id: id, title: title, content: content, trackingId: trackingId, application: application, contentLink: contentLink, applicationCta: applicationCta, applicationUrl: applicationUrl};
	});
var $author$project$PinMeTo$Global$NewsFeed$Listings = {$: 'Listings'};
var $author$project$PinMeTo$Global$NewsFeed$Conversations = {$: 'Conversations'};
var $author$project$PinMeTo$Global$NewsFeed$articleDecoder = function () {
	var contentLinkDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contentLink',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'contentLinkLabel',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed(
				F2(
					function (label, url) {
						return $author$project$PinMeTo$Global$NewsFeed$Link(
							{url: url, label: label});
					}))));
	var applicationDecoder = function () {
		var get = function (id) {
			switch (id) {
				case 'listings':
					return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$NewsFeed$Listings);
				case 'posts':
					return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$NewsFeed$Posts);
				case 'conversations':
					return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$NewsFeed$Conversations);
				case 'places':
					return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$NewsFeed$Places);
				default:
					return $elm$json$Json$Decode$fail('unknown value for Application: ' + id);
			}
		};
		return A2($elm$json$Json$Decode$andThen, get, $elm$json$Json$Decode$string);
	}();
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$maybe(contentLinkDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'applicationUrl',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'applicationCta',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'application',
							applicationDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'trackingId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$NewsFeed$Article)))))))));
}();
var $author$project$PinMeTo$Global$NewsFeed$getNews = function (msg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A3(
				$author$project$PinMeTo$ExpectJson$expectJson,
				msg,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$PinMeTo$Global$NewsFeed$Loaded,
					$elm$json$Json$Decode$list($author$project$PinMeTo$Global$NewsFeed$articleDecoder)),
				$elm$json$Json$Decode$string),
			$lukewestby$elm_http_builder$HttpBuilder$get('/api/news')));
};
var $author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedGetNews = function (a) {
	return {$: 'NewsFeedGetNews', a: a};
};
var $author$project$PinMeTo$Ports$pmtUiNewsFeedGetLatestSeen = _Platform_outgoingPort(
	'pmtUiNewsFeedGetLatestSeen',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PinMeTo$Global$TopNavigation$withNewsFeedCmds = function (cmd) {
	return A2(
		$elm$core$List$cons,
		$author$project$PinMeTo$Global$NewsFeed$getNews($author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedGetNews),
		A2(
			$elm$core$List$cons,
			$author$project$PinMeTo$Ports$pmtUiNewsFeedGetLatestSeen(_Utils_Tuple0),
			cmd));
};
var $author$project$PinMeTo$Global$TopNavigation$Model$coverImgDecoder = A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$getSiteProfileImage = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$PinMeTo$Global$TopNavigation$Model$coverImgDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('/listings/api/' + (siteName + '/network/brandpageImage'))));
	});
var $author$project$PinMeTo$Global$TopNavigation$init = function (config) {
	var _v0 = config.selectedSite;
	var selectedSite = _v0.a;
	var _v1 = $author$project$PinMeTo$Global$TopNavigation$Chat$initForSite(
		{site: selectedSite.name});
	var chat = _v1.a;
	var chatCmd = _v1.b;
	return _Utils_Tuple2(
		$author$project$PinMeTo$Global$TopNavigation$State(
			{
				app: config.app,
				chat: chat,
				config: $elm$core$Maybe$Just(config.config),
				isDemo: config.isDemo,
				mobile: false,
				allSites: A2(
					$elm$core$List$sortBy,
					function (_v2) {
						var site = _v2.a;
						return $elm$core$String$toLower(site.displayName);
					},
					config.sites),
				newsFeed: $author$project$PinMeTo$Global$NewsFeed$init,
				siteAccess: config.siteAccess,
				siteFilter: $elm$core$Maybe$Nothing,
				permissions: config.permissions,
				siteProfile: $elm$core$Maybe$Nothing,
				featureFlags: config.featureFlags,
				selectedSite: $elm$core$Maybe$Just(config.selectedSite),
				sitesFiltered: A2(
					$elm$core$List$sortBy,
					function (_v3) {
						var site = _v3.a;
						return $elm$core$String$toLower(site.displayName);
					},
					config.sites),
				uiSupportModel: $author$project$PinMeTo$Global$SupportTicket$init(selectedSite.name),
				navigationState: A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$init,
					$author$project$PinMeTo$Global$TopNavigation$topNavigation($author$project$PinMeTo$Global$TopNavigation$noLauncher),
					false),
				mobileWindowWidth: config.mobileWindowWidth,
				newsFeedLatestSeen: $elm$core$Maybe$Nothing,
				userProfileImageUrl: config.userProfileImageUrl,
				ignoredProductUpgrades: config.ignoredProductUpgrades,
				showIgnoredProductUpgrades: false
			}),
		$elm$core$Platform$Cmd$batch(
			$author$project$PinMeTo$Global$TopNavigation$withNewsFeedCmds(
				_List_fromArray(
					[
						$author$project$PinMeTo$Global$TopNavigation$getViewport,
						A2($author$project$PinMeTo$Global$TopNavigation$Model$getSiteProfileImage, selectedSite.name, $author$project$PinMeTo$Global$TopNavigation$Msg$GetProfileImg),
						A2($elm$core$Platform$Cmd$map, $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg, chatCmd)
					]))));
};
var $author$project$UserSettings$EmailNotifications$Friday = {$: 'Friday'};
var $author$project$UserSettings$EmailNotifications$Monday = {$: 'Monday'};
var $author$project$UserSettings$EmailNotifications$Sunday = {$: 'Sunday'};
var $author$project$UserSettings$EmailNotifications$Tuesday = {$: 'Tuesday'};
var $author$project$UserSettings$EmailNotifications$Saturday = {$: 'Saturday'};
var $author$project$UserSettings$EmailNotifications$Thursday = {$: 'Thursday'};
var $author$project$UserSettings$EmailNotifications$EmailList = F3(
	function (listId, name, status) {
		return {name: name, listId: listId, status: status};
	});
var $author$project$UserSettings$EmailNotifications$Wednesday = {$: 'Wednesday'};
var $author$project$UserSettings$EmailNotifications$Subscribed = {$: 'Subscribed'};
var $author$project$UserSettings$EmailNotifications$Unsubscribed = {$: 'Unsubscribed'};
var $author$project$UserSettings$EmailNotifications$Subscriptions = F6(
	function (id, days, taskNotificationsEnabled, lists, listenDigestEnabled, listingsManagerDigestEnabled) {
		return {id: id, days: days, lists: lists, listenDigestEnabled: listenDigestEnabled, taskNotificationsEnabled: taskNotificationsEnabled, listingsManagerDigestEnabled: listingsManagerDigestEnabled};
	});
var $author$project$UserSettings$EmailNotifications$subscriptionsDecoder = function () {
	var emailListStateDecoder = A2(
		$elm$json$Json$Decode$map,
		function (x) {
			return (x === 'unsubscribed') ? $author$project$UserSettings$EmailNotifications$Unsubscribed : $author$project$UserSettings$EmailNotifications$Subscribed;
		},
		$elm$json$Json$Decode$string);
	var emailListDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		emailListStateDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'listId',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$EmailList))));
	var validEmailListsDecoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe(emailListDecoder)));
	var dayDecode = A2(
		$elm$json$Json$Decode$andThen,
		function (x) {
			var _v0 = $elm$core$String$toLower(x);
			switch (_v0) {
				case 'monday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Monday);
				case 'tuesday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Tuesday);
				case 'wednesday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Wednesday);
				case 'thursday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Thursday);
				case 'friday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Friday);
				case 'saturday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Saturday);
				case 'sunday':
					return $elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Sunday);
				default:
					return $elm$json$Json$Decode$fail('Unknown day \u0027' + (x + '\u0027'));
			}
		},
		$elm$json$Json$Decode$string);
	var setOf = function (decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$Gizra$elm_all_set$EverySet$fromList,
			$elm$json$Json$Decode$list(decoder));
	};
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['notification', 'listingsManagerDigest', 'enabled']),
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['notification', 'listenDigest', 'enabled']),
			$elm$json$Json$Decode$bool,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'emailLists',
				validEmailListsDecoder,
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['notification', 'taskNotifications', 'enabled']),
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['notification', 'taskNotifications', 'days']),
						setOf(
							A2($elm$json$Json$Decode$field, 'day', dayDecode)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['notification', '_id']),
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$UserSettings$EmailNotifications$Subscriptions)))))));
}();
var $author$project$UserSettings$EmailNotifications$GetSubscriptionsResponse = function (a) {
	return {$: 'GetSubscriptionsResponse', a: a};
};
var $author$project$UserSettings$EmailNotifications$getEmailSubscriptions = F2(
	function (tagger, _v0) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$EmailNotifications$GetSubscriptionsResponse, tagger),
					$author$project$UserSettings$EmailNotifications$subscriptionsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/email-notifications/user'))));
	});
var $author$project$UserSettings$EmailNotifications$init = F3(
	function (tagger, siteName, translations) {
		return _Utils_Tuple2(
			{saving: $author$project$RemoteData$Suspended, siteName: siteName, translations: translations, subscriptions: $author$project$RemoteData$Loading},
			A2($author$project$UserSettings$EmailNotifications$getEmailSubscriptions, tagger, siteName));
	});
var $author$project$UserSettings$Notifications$Model$init = F2(
	function (siteName, productType) {
		return {form: $author$project$RemoteData$Loading, siteName: siteName, productType: productType, pushSubscriptions: $author$project$RemoteData$Loading, currentSubscription: $author$project$RemoteData$Loading, askingForPushWithEvent: $elm$core$Maybe$Nothing};
	});
var $author$project$UserSettings$Notifications$Model$ReceivedPushSubscriptions = function (a) {
	return {$: 'ReceivedPushSubscriptions', a: a};
};
var $author$project$UserSettings$Notifications$Data$PushSubscription$Enabled = {$: 'Enabled'};
var $author$project$UserSettings$Notifications$Data$PushSubscription$NotEnabled = {$: 'NotEnabled'};
var $author$project$UserSettings$Notifications$Data$PushSubscription$decoder = A2(
	$elm$json$Json$Decode$map,
	function (subscriptions) {
		return $elm$core$List$isEmpty(subscriptions) ? $author$project$UserSettings$Notifications$Data$PushSubscription$NotEnabled : $author$project$UserSettings$Notifications$Data$PushSubscription$Enabled;
	},
	$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
var $author$project$UserSettings$Notifications$Commands$getPushNotificationStatus = function (msg) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$Notifications$Data$PushSubscription$decoder),
			$lukewestby$elm_http_builder$HttpBuilder$get('api/user/notifications/webPush')));
};
var $author$project$UserSettings$Notifications$Data$Event$IssueAssigned = {$: 'IssueAssigned'};
var $author$project$UserSettings$Notifications$Data$Event$NewGoogleReview = {$: 'NewGoogleReview'};
var $author$project$UserSettings$Notifications$Data$Event$NewFacebookComment = {$: 'NewFacebookComment'};
var $author$project$UserSettings$Notifications$Data$Event$NewFacebookMention = {$: 'NewFacebookMention'};
var $author$project$UserSettings$Notifications$Data$Event$NewFacebookUserPost = {$: 'NewFacebookUserPost'};
var $author$project$UserSettings$Notifications$Data$Event$NewInstagramComment = {$: 'NewInstagramComment'};
var $author$project$UserSettings$Notifications$Data$Event$NewInstagramMention = {$: 'NewInstagramMention'};
var $author$project$UserSettings$Notifications$Data$Event$NewTrustpilotReview = {$: 'NewTrustpilotReview'};
var $author$project$UserSettings$Notifications$Data$Event$NewFacebookDirectMessage = {$: 'NewFacebookDirectMessage'};
var $author$project$UserSettings$Notifications$Data$Event$NewFacebookRecommendation = {$: 'NewFacebookRecommendation'};
var $author$project$UserSettings$Notifications$Data$Event$NewInstagramDirectMessage = {$: 'NewInstagramDirectMessage'};
var $author$project$UserSettings$Notifications$Data$Event$fromString = function (x) {
	switch (x) {
		case 'NewGoogleReview':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewGoogleReview);
		case 'NewFacebookRecommendation':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewFacebookRecommendation);
		case 'NewFacebookComment':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewFacebookComment);
		case 'NewFacebookUserPost':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewFacebookUserPost);
		case 'NewFacebookMention':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewFacebookMention);
		case 'IssueAssigned':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$IssueAssigned);
		case 'NewInstagramComment':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewInstagramComment);
		case 'NewInstagramMention':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewInstagramMention);
		case 'NewTrustpilotReview':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewTrustpilotReview);
		case 'NewFacebookDirectMessage':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewFacebookDirectMessage);
		case 'NewInstagramDirectMessage':
			return $elm$core$Maybe$Just($author$project$UserSettings$Notifications$Data$Event$NewInstagramDirectMessage);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UserSettings$Notifications$Data$Event$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Failed to decode event from ' + x),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$UserSettings$Notifications$Data$Event$fromString(x)));
	},
	$elm$json$Json$Decode$string);
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$NotificationSubscription = F2(
	function (push, email) {
		return {push: push, email: email};
	});
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$list($author$project$UserSettings$Notifications$Data$Event$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'push',
		$elm$json$Json$Decode$list($author$project$UserSettings$Notifications$Data$Event$decoder),
		$elm$json$Json$Decode$succeed($author$project$UserSettings$Notifications$Data$NotificationSubscription$NotificationSubscription)));
var $author$project$UserSettings$Notifications$Commands$getNotificationSubscription = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$Notifications$Data$NotificationSubscription$decoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/user/' + (siteName + '/notifications'))));
	});
var $author$project$UserSettings$Notifications$Model$ReceivedNotificationSubscription = function (a) {
	return {$: 'ReceivedNotificationSubscription', a: a};
};
var $author$project$UserSettings$Notifications$Main$init = F4(
	function (tagger, getCurrentPushSubscription, siteName, productType) {
		return _Utils_Tuple2(
			A2($author$project$UserSettings$Notifications$Model$init, siteName, productType),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$UserSettings$Notifications$Commands$getNotificationSubscription,
						siteName,
						A2($elm$core$Basics$composeR, $author$project$UserSettings$Notifications$Model$ReceivedNotificationSubscription, tagger)),
						$author$project$UserSettings$Notifications$Commands$getPushNotificationStatus(
						A2($elm$core$Basics$composeR, $author$project$UserSettings$Notifications$Model$ReceivedPushSubscriptions, tagger)),
						getCurrentPushSubscription(_Utils_Tuple0)
					])));
	});
var $author$project$UserSettings$PostsNotifications$Model$init = function (siteName) {
	return {form: $author$project$RemoteData$Loading, siteName: siteName};
};
var $author$project$UserSettings$PostsNotifications$Data$Event$FailedScheduledPosts = {$: 'FailedScheduledPosts'};
var $author$project$UserSettings$PostsNotifications$Data$Event$SuccessfullyScheduledPosts = {$: 'SuccessfullyScheduledPosts'};
var $author$project$UserSettings$PostsNotifications$Data$Event$fromString = function (x) {
	switch (x) {
		case 'FailedScheduledPosts':
			return $elm$core$Maybe$Just($author$project$UserSettings$PostsNotifications$Data$Event$FailedScheduledPosts);
		case 'SuccessfullyScheduledPosts':
			return $elm$core$Maybe$Just($author$project$UserSettings$PostsNotifications$Data$Event$SuccessfullyScheduledPosts);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UserSettings$PostsNotifications$Data$Event$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Failed to decode event from ' + x),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$UserSettings$PostsNotifications$Data$Event$fromString(x)));
	},
	$elm$json$Json$Decode$string);
var $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$NotificationSubscription = F2(
	function (push, email) {
		return {push: push, email: email};
	});
var $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'emailForPosts',
	$elm$json$Json$Decode$list($author$project$UserSettings$PostsNotifications$Data$Event$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pushForPosts',
		$elm$json$Json$Decode$list($author$project$UserSettings$PostsNotifications$Data$Event$decoder),
		$elm$json$Json$Decode$succeed($author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$NotificationSubscription)));
var $author$project$UserSettings$PostsNotifications$Commands$getNotificationSubscription = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$decoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/user/' + (siteName + '/notifications'))));
	});
var $author$project$UserSettings$PostsNotifications$Model$ReceivedNotificationSubscription = function (a) {
	return {$: 'ReceivedNotificationSubscription', a: a};
};
var $author$project$UserSettings$PostsNotifications$Main$init = F2(
	function (tagger, siteName) {
		return _Utils_Tuple2(
			$author$project$UserSettings$PostsNotifications$Model$init(siteName),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$UserSettings$PostsNotifications$Commands$getNotificationSubscription,
						siteName,
						A2($elm$core$Basics$composeR, $author$project$UserSettings$PostsNotifications$Model$ReceivedNotificationSubscription, tagger))
					])));
	});
var $author$project$UserSettings$PlacesAINotifications$Model$init = function (siteName) {
	return {form: $author$project$RemoteData$Loading, siteName: siteName};
};
var $author$project$UserSettings$PlacesAINotifications$Data$Event$ActionAssigned = {$: 'ActionAssigned'};
var $author$project$UserSettings$PlacesAINotifications$Data$Event$fromString = function (x) {
	if (x === 'ActionAssigned') {
		return $elm$core$Maybe$Just($author$project$UserSettings$PlacesAINotifications$Data$Event$ActionAssigned);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UserSettings$PlacesAINotifications$Data$Event$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Failed to decode event from ' + x),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$UserSettings$PlacesAINotifications$Data$Event$fromString(x)));
	},
	$elm$json$Json$Decode$string);
var $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$NotificationSubscription = function (email) {
	return {email: email};
};
var $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'emailForPlacesAI',
	$elm$json$Json$Decode$list($author$project$UserSettings$PlacesAINotifications$Data$Event$decoder),
	$elm$json$Json$Decode$succeed($author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$NotificationSubscription));
var $author$project$UserSettings$PlacesAINotifications$Commands$getNotificationSubscription = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$decoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/user/' + (siteName + '/notifications'))));
	});
var $author$project$UserSettings$PlacesAINotifications$Model$ReceivedNotificationSubscription = function (a) {
	return {$: 'ReceivedNotificationSubscription', a: a};
};
var $author$project$UserSettings$PlacesAINotifications$Main$init = F2(
	function (tagger, siteName) {
		return _Utils_Tuple2(
			$author$project$UserSettings$PlacesAINotifications$Model$init(siteName),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$UserSettings$PlacesAINotifications$Commands$getNotificationSubscription,
						siteName,
						A2($elm$core$Basics$composeR, $author$project$UserSettings$PlacesAINotifications$Model$ReceivedNotificationSubscription, tagger))
					])));
	});
var $author$project$PinMeTo$FeatureFlags$FeatureFlags = function (a) {
	return {$: 'FeatureFlags', a: a};
};
var $author$project$PinMeTo$FeatureFlags$none = $author$project$PinMeTo$FeatureFlags$FeatureFlags(
	{
		places: {api: false},
		locator: false,
		listings: {serviceArea: false, newNavigation: false, allowPtvTwoWay: false, allowAppleOauth: false, specialOpenHours: false, allowCustomStoreNames: false, allowGoogleCustomName: false, allowFacebookCustomName: false},
		networks: {ptv: false, bing: false, here: false, yelp: false, apple: false, baidu: false, google: false, tomtom: false, wechat: false, yandex: false, facebook: false, instagram: false, foursquare: false, trustpilot: false},
		publicApi: false,
		listenRespond: {hasNoFeatureFlagsYetSoThisIsJustADummy: false},
		locationPosts: {api: false, google: false, facebook: false, linkedin: false, instagram: false, locationPost: false, newNavigation: false, instagramReels: false, instagramCarouselPosts: false},
		localCampaigns: false,
		accountSettings: {sso: false, aiIntegration: false, allowMessagingConfiguration: false, ignoreGlobalBrandPageIdOnConnect: false}
	});
var $author$project$UserSettings$Model$Profile = function (a) {
	return {$: 'Profile', a: a};
};
var $author$project$UserSettings$Model$Language = function (a) {
	return {$: 'Language', a: a};
};
var $author$project$UserSettings$Model$LegalMsg = function (a) {
	return {$: 'LegalMsg', a: a};
};
var $author$project$UserSettings$EmailNotifications$SiteName = function (a) {
	return {$: 'SiteName', a: a};
};
var $author$project$UserSettings$Types$CurrentPath = function (a) {
	return {$: 'CurrentPath', a: a};
};
var $author$project$UserSettings$Model$LanguageMsg = function (a) {
	return {$: 'LanguageMsg', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Model$Flags = function (selectedSite) {
	return function (sites) {
		return function (siteAccess) {
			return function (user) {
				return function (collapsed) {
					return function (env) {
						return function (currentRoute) {
							return function (permissions) {
								return function (ignoredProductUpgrades) {
									return function (productUrl) {
										return function (isDemo) {
											return function (currentUrl) {
												return {env: env, user: user, sites: sites, isDemo: isDemo, collapsed: collapsed, currentUrl: currentUrl, productUrl: productUrl, siteAccess: siteAccess, permissions: permissions, currentRoute: currentRoute, selectedSite: selectedSite, ignoredProductUpgrades: ignoredProductUpgrades};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PinMeTo$Global$Model$SiteAccess$SiteAccess = F7(
	function (hasAccountSettings, hasListings, hasSocialMedia, hasListenAndRespond, hasLocator, hasLocalCampaigns, hasAiVisibility) {
		return {hasLocator: hasLocator, hasListings: hasListings, hasSocialMedia: hasSocialMedia, hasAiVisibility: hasAiVisibility, hasLocalCampaigns: hasLocalCampaigns, hasAccountSettings: hasAccountSettings, hasListenAndRespond: hasListenAndRespond};
	});
var $author$project$PinMeTo$Global$Model$SiteAccess$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'hasAiVisibility',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hasLocalCampaigns',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'hasLocator',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'hasListenRespond',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'hasSocialMedia',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'hasPlaces',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'hasLocalAccess',
							$elm$json$Json$Decode$bool,
							false,
							$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$Model$SiteAccess$SiteAccess))))))));
var $author$project$PinMeTo$Global$TopNavigation$Model$urlDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Invalid URL: ' + x),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$elm$url$Url$fromString(x)));
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$Site = function (a) {
	return {$: 'Site', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Model$Site_ = F6(
	function (id, name, displayName, listenRespond, authenticationType, hasAccess) {
		return {id: id, name: name, hasAccess: hasAccess, displayName: displayName, listenRespond: listenRespond, authenticationType: authenticationType};
	});
var $author$project$PinMeTo$Global$TopNavigation$Model$Password = {$: 'Password'};
var $author$project$PinMeTo$Global$TopNavigation$Model$All = {$: 'All'};
var $author$project$PinMeTo$Global$TopNavigation$Model$defaultListenKeys = {product: $author$project$PinMeTo$Global$TopNavigation$Model$All};
var $author$project$PinMeTo$Global$TopNavigation$Model$ListenKeys = function (product) {
	return {product: product};
};
var $author$project$PinMeTo$Global$TopNavigation$Model$ReviewsOnly = {$: 'ReviewsOnly'};
var $author$project$PinMeTo$Global$TopNavigation$Model$productTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (product) {
		switch (product) {
			case 'reviewsOnly':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$ReviewsOnly);
			case 'all':
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$All);
			default:
				return $elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$All);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$listenKeysDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'product',
	$author$project$PinMeTo$Global$TopNavigation$Model$productTypeDecoder,
	$author$project$PinMeTo$Global$TopNavigation$Model$All,
	$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$ListenKeys));
var $author$project$PinMeTo$Global$TopNavigation$Model$SAML = {$: 'SAML'};
var $author$project$PinMeTo$Global$TopNavigation$Model$PasswordAndSAML = {$: 'PasswordAndSAML'};
var $author$project$PinMeTo$Global$TopNavigation$Model$toAuthenticationType = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		switch (x) {
			case 'saml':
				return $author$project$PinMeTo$Global$TopNavigation$Model$SAML;
			case 'password':
				return $author$project$PinMeTo$Global$TopNavigation$Model$Password;
			case 'samlAndPassword':
				return $author$project$PinMeTo$Global$TopNavigation$Model$PasswordAndSAML;
			default:
				return $author$project$PinMeTo$Global$TopNavigation$Model$Password;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$siteDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$PinMeTo$Global$TopNavigation$Model$Site,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hasAccess',
		$elm$json$Json$Decode$bool,
		true,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'authenticationType',
			$author$project$PinMeTo$Global$TopNavigation$Model$toAuthenticationType,
			$author$project$PinMeTo$Global$TopNavigation$Model$Password,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'listenRespond',
				$author$project$PinMeTo$Global$TopNavigation$Model$listenKeysDecoder,
				$author$project$PinMeTo$Global$TopNavigation$Model$defaultListenKeys,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'displayName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'_id',
							$elm$json$Json$Decode$string,
							'',
							$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$Site_))))))));
var $author$project$PinMeTo$Global$TopNavigation$Model$Sms = {$: 'Sms'};
var $author$project$PinMeTo$Global$TopNavigation$Model$User = F9(
	function (id, firstName, lastName, profileImage, otp, otpDelivery, systemRoles, isDemo, ignoredProductUpgrades) {
		return {id: id, otp: otp, isDemo: isDemo, lastName: lastName, firstName: firstName, otpDelivery: otpDelivery, systemRoles: systemRoles, profileImage: profileImage, ignoredProductUpgrades: ignoredProductUpgrades};
	});
var $author$project$PinMeTo$Global$TopNavigation$Model$UserId = function (a) {
	return {$: 'UserId', a: a};
};
var $author$project$PinMeTo$Global$Model$SystemRole$PinMeTo = {$: 'PinMeTo'};
var $author$project$PinMeTo$Global$Model$SystemRole$Upsales = {$: 'Upsales'};
var $author$project$PinMeTo$Global$Model$SystemRole$CustomerSuccess = {$: 'CustomerSuccess'};
var $author$project$PinMeTo$Global$Model$SystemRole$PinMeToDeveloper = {$: 'PinMeToDeveloper'};
var $author$project$PinMeTo$Global$Model$SystemRole$toSystemRole = function (role) {
	switch (role) {
		case 'pinmeto':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$Model$SystemRole$PinMeTo);
		case 'pinmetodeveloper':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$Model$SystemRole$PinMeToDeveloper);
		case 'customersuccess':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$Model$SystemRole$CustomerSuccess);
		case 'upsales':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$Model$SystemRole$Upsales);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Global$Model$SystemRole$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$json$Json$Decode$fail('Unknown case \u0027' + (x + '\u0027')),
			$elm$json$Json$Decode$succeed,
			$author$project$PinMeTo$Global$Model$SystemRole$toSystemRole(x));
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$Enabled = {$: 'Enabled'};
var $author$project$PinMeTo$Global$TopNavigation$Model$NotEnabled = {$: 'NotEnabled'};
var $author$project$PinMeTo$Global$TopNavigation$Model$EnabledNotVerified = {$: 'EnabledNotVerified'};
var $author$project$PinMeTo$Global$TopNavigation$Model$otpDecoder = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		switch (x) {
			case 'ENABLED':
				return $author$project$PinMeTo$Global$TopNavigation$Model$Enabled;
			case 'ENABLED_NOT_VERIFIED':
				return $author$project$PinMeTo$Global$TopNavigation$Model$EnabledNotVerified;
			default:
				return $author$project$PinMeTo$Global$TopNavigation$Model$NotEnabled;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$Authenticator = {$: 'Authenticator'};
var $author$project$PinMeTo$Global$TopNavigation$Model$otpDeliveryDecoder = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		if (x === 'APP') {
			return $author$project$PinMeTo$Global$TopNavigation$Model$Authenticator;
		} else {
			return $author$project$PinMeTo$Global$TopNavigation$Model$Sms;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Model$defaultIgnoredProductUpgrades = $elm$core$Dict$empty;
var $author$project$PinMeTo$Global$TopNavigation$Model$userDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ignoredProductUpgrades',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	$author$project$PinMeTo$Global$TopNavigation$Model$defaultIgnoredProductUpgrades,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'isDemo',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'systemRoles',
			$elm$json$Json$Decode$list($author$project$PinMeTo$Global$Model$SystemRole$decoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'otpDelivery',
				$author$project$PinMeTo$Global$TopNavigation$Model$otpDeliveryDecoder,
				$author$project$PinMeTo$Global$TopNavigation$Model$Sms,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'otpEnabled',
					$author$project$PinMeTo$Global$TopNavigation$Model$otpDecoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'profileImage',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'firstName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'_id',
									A2($elm$json$Json$Decode$map, $author$project$PinMeTo$Global$TopNavigation$Model$UserId, $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$User))))))))));
var $author$project$PinMeTo$Global$TopNavigation$Config$Config = F2(
	function (env, baseUrls) {
		return {env: env, baseUrls: baseUrls};
	});
var $author$project$PinMeTo$Global$TopNavigation$Config$Dev = {$: 'Dev'};
var $author$project$PinMeTo$Global$TopNavigation$Config$Test = {$: 'Test'};
var $author$project$PinMeTo$Global$TopNavigation$Config$Production = {$: 'Production'};
var $author$project$PinMeTo$Global$TopNavigation$Config$fromString = function (x) {
	switch (x) {
		case 'dev':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$TopNavigation$Config$Dev);
		case 'test':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$TopNavigation$Config$Test);
		case 'prod':
			return $elm$core$Maybe$Just($author$project$PinMeTo$Global$TopNavigation$Config$Production);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PinMeTo$Global$TopNavigation$Config$envDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (x) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unpack,
			function (_v0) {
				return $elm$json$Json$Decode$fail('Trying to decode env but \u0027' + (x + '\u0027 is unknown.'));
			},
			$elm$json$Json$Decode$succeed,
			$author$project$PinMeTo$Global$TopNavigation$Config$fromString(x));
	},
	$elm$json$Json$Decode$string);
var $author$project$PinMeTo$Global$TopNavigation$Config$BaseUrl = F9(
	function (listings, locationPosts, accountSettings, listenAndRespond, login, admin, insightsApi, champion, aiVisibility) {
		return {admin: admin, login: login, champion: champion, listings: listings, insightsApi: insightsApi, aiVisibility: aiVisibility, locationPosts: locationPosts, accountSettings: accountSettings, listenAndRespond: listenAndRespond};
	});
var $author$project$PinMeTo$Global$TopNavigation$Config$urlDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'aiVisibility',
	$elm$json$Json$Decode$string,
	'/ai-insights/',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'champion',
		$elm$json$Json$Decode$string,
		'/overview/',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'insightsApi',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'admin',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'login',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'listen',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'accountSettings',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'locationPosts',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'listings',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Config$BaseUrl))))))))));
var $author$project$PinMeTo$Global$TopNavigation$Config$configDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'urls',
	$author$project$PinMeTo$Global$TopNavigation$Config$urlDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'env',
		$author$project$PinMeTo$Global$TopNavigation$Config$envDecoder,
		$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Config$Config)));
var $author$project$PinMeTo$Global$TopNavigation$Model$ignoredProductUpgradesDecoder = $elm$json$Json$Decode$dict(
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$PinMeTo$Global$TopNavigation$Model$flagsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (siteName) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'currentUrl',
			$author$project$PinMeTo$Global$TopNavigation$Model$urlDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'isDemo',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'productUrl',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'ignoredProductUpgrades',
						$author$project$PinMeTo$Global$TopNavigation$Model$ignoredProductUpgradesDecoder,
						$author$project$PinMeTo$Global$TopNavigation$Model$defaultIgnoredProductUpgrades,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'permissions',
							$author$project$PinMeTo$Permissions$permissionsDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'currentRoute',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'env',
									$author$project$PinMeTo$Global$TopNavigation$Config$configDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'collapsed',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'user',
											$author$project$PinMeTo$Global$TopNavigation$Model$userDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
												_List_fromArray(
													['user', 'accountAccess', siteName]),
												$author$project$PinMeTo$Global$Model$SiteAccess$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
													_List_fromArray(
														['user', 'sites']),
													$elm$json$Json$Decode$list($author$project$PinMeTo$Global$TopNavigation$Model$siteDecoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
														_List_fromArray(
															['user', 'selectedSite']),
														$author$project$PinMeTo$Global$TopNavigation$Model$siteDecoder,
														$elm$json$Json$Decode$succeed($author$project$PinMeTo$Global$TopNavigation$Model$Flags)))))))))))));
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['user', 'selectedSite', 'name']),
		$elm$json$Json$Decode$string));
var $author$project$PinMeTo$Global$TopNavigation$Model$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$PinMeTo$Global$TopNavigation$Model$flagsDecoder, flags);
};
var $author$project$PinMeTo$Global$TopNavigation$Model$UserSettings = {$: 'UserSettings'};
var $author$project$UserSettings$Model$Notifications = function (a) {
	return {$: 'Notifications', a: a};
};
var $author$project$UserSettings$Model$OnWindowWidth = function (a) {
	return {$: 'OnWindowWidth', a: a};
};
var $author$project$UserSettings$Model$ChangePassword = function (a) {
	return {$: 'ChangePassword', a: a};
};
var $author$project$UserSettings$Model$LegalDocuments = function (a) {
	return {$: 'LegalDocuments', a: a};
};
var $author$project$UserSettings$Profile$Model$User = F3(
	function (firstName, lastName, profileImage) {
		return {lastName: lastName, firstName: firstName, profileImage: profileImage};
	});
var $author$project$UserSettings$Profile$Model$ProfileImage = function (a) {
	return {$: 'ProfileImage', a: a};
};
var $author$project$UserSettings$Profile$Commands$userDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'profileImage',
	A2(
		$elm$json$Json$Decode$map,
		function (s) {
			return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$UserSettings$Profile$Model$ProfileImage(s));
		},
		$elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lastName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'firstName',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$UserSettings$Profile$Model$User))));
var $author$project$UserSettings$Profile$Model$GetUserProfile = function (a) {
	return {$: 'GetUserProfile', a: a};
};
var $author$project$UserSettings$Profile$Commands$getInformation = function (tagger) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $author$project$UserSettings$Profile$Model$GetUserProfile, tagger),
				$author$project$UserSettings$Profile$Commands$userDecoder),
			$lukewestby$elm_http_builder$HttpBuilder$get('api/user/profile')));
};
var $author$project$UserSettings$Profile$Profile$init = F2(
	function (tagger, translations) {
		return _Utils_Tuple2(
			{user: $author$project$RemoteData$Loading, savingUser: $author$project$RemoteData$Suspended, translations: translations},
			$author$project$UserSettings$Profile$Commands$getInformation(tagger));
	});
var $author$project$UserSettings$Model$ProfileMsg = function (a) {
	return {$: 'ProfileMsg', a: a};
};
var $author$project$UserSettings$Main$userProfileInit = function (translations) {
	return A2($author$project$UserSettings$Profile$Profile$init, $author$project$UserSettings$Model$ProfileMsg, translations);
};
var $author$project$UserSettings$Model$NotificationsMsg = function (a) {
	return {$: 'NotificationsMsg', a: a};
};
var $author$project$UserSettings$Model$TopNavigationMsg = function (a) {
	return {$: 'TopNavigationMsg', a: a};
};
var $author$project$UserSettings$Model$EmailNotifications = function (a) {
	return {$: 'EmailNotifications', a: a};
};
var $author$project$UserSettings$Model$NotificationsPosts = function (a) {
	return {$: 'NotificationsPosts', a: a};
};
var $author$project$UserSettings$Model$translationsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['translations']),
	$author$project$Common$Language$translationsDecoder);
var $author$project$UserSettings$Model$decodeTranslations = function (x) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$UserSettings$Model$translationsDecoder, x);
};
var $author$project$UserSettings$Main$showChangePassword = function (method) {
	return !_Utils_eq(method, $author$project$PinMeTo$Global$TopNavigation$Model$SAML);
};
var $author$project$UserSettings$Model$EmailNotificationsMsg = function (a) {
	return {$: 'EmailNotificationsMsg', a: a};
};
var $author$project$UserSettings$Model$NotificationsPlacesAI = function (a) {
	return {$: 'NotificationsPlacesAI', a: a};
};
var $author$project$UserSettings$Model$PostsNotificationsMsg = function (a) {
	return {$: 'PostsNotificationsMsg', a: a};
};
var $author$project$UserSettings$Model$PlacesAINotificationsMsg = function (a) {
	return {$: 'PlacesAINotificationsMsg', a: a};
};
var $author$project$UserSettings$Main$out_UserSettings_Main_getCurrentPushSubscription = _Platform_outgoingPort(
	'out_UserSettings_Main_getCurrentPushSubscription',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$UserSettings$Main$init = function (flags) {
	var decodeError = F2(
		function (msg, e) {
			return _Utils_Tuple2(
				{
					url: $elm$core$Maybe$Nothing,
					user: $elm$core$Maybe$Nothing,
					view: $author$project$UserSettings$Model$EmailNotifications($elm$core$Maybe$Nothing),
					config: $elm$core$Maybe$Nothing,
					mobile: false,
					collapsed: false,
					productUrl: '',
					currentPath: $author$project$UserSettings$Types$CurrentPath('/'),
					selectedSite: $elm$core$Maybe$Nothing,
					translations: $author$project$Common$Language$initialTranslationsFallback,
					accountAccess: {hasLocator: false, hasListings: false, hasSocialMedia: false, hasAiVisibility: false, hasLocalCampaigns: false, hasAccountSettings: false, hasListenAndRespond: false},
					topNavigation: $elm$core$Maybe$Nothing,
					workInProgress: 0
				},
				$author$project$PinMeTo$Logger$log(
					{
						data: $elm$json$Json$Decode$errorToString(e),
						context: 'UserSettings.Main',
						message: 'Failed to decode flags ' + msg
					}));
		});
	var _v0 = _Utils_Tuple2(
		$author$project$PinMeTo$Global$TopNavigation$Model$decodeFlags(flags),
		$author$project$UserSettings$Model$decodeTranslations(flags));
	if (_v0.a.$ === 'Ok') {
		if (_v0.b.$ === 'Ok') {
			var flags_ = _v0.a.a;
			var translations = _v0.b.a;
			var _v1 = $author$project$PinMeTo$Global$TopNavigation$init(
				{
					app: $author$project$PinMeTo$Global$TopNavigation$Model$UserSettings,
					sites: flags_.sites,
					config: flags_.env,
					isDemo: false,
					siteAccess: flags_.siteAccess,
					permissions: flags_.permissions,
					featureFlags: $author$project$PinMeTo$FeatureFlags$none,
					selectedSite: flags_.selectedSite,
					mobileWindowWidth: 640,
					userProfileImageUrl: $elm$core$Maybe$Just(flags_.user.profileImage),
					ignoredProductUpgrades: flags_.user.ignoredProductUpgrades
				});
			var topNavigationState = _v1.a;
			var topNavigationCmd = _v1.b;
			var currentPath = '/listings' + flags_.currentRoute;
			var _v2 = flags_.selectedSite;
			var listenRespond = _v2.a.listenRespond;
			var authenticationType = _v2.a.authenticationType;
			var name = _v2.a.name;
			var emailNotifications = A2(
				$elm$core$Tuple$mapFirst,
				function (z) {
					return $author$project$UserSettings$Model$EmailNotifications(
						$elm$core$Maybe$Just(z));
				},
				A3(
					$author$project$UserSettings$EmailNotifications$init,
					$author$project$UserSettings$Model$EmailNotificationsMsg,
					$author$project$UserSettings$EmailNotifications$SiteName(name),
					translations));
			var activeNavigation = function (currentRoute) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					emailNotifications,
					function (x) {
						var _v4 = $elm$core$String$toLower(x);
						switch (_v4) {
							case 'profile':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (z) {
										return $author$project$UserSettings$Model$Profile(
											$elm$core$Maybe$Just(z));
									},
									$author$project$UserSettings$Main$userProfileInit(translations));
							case 'email-notifications':
								return emailNotifications;
							case 'notifications':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (z) {
										return $author$project$UserSettings$Model$Notifications(
											$elm$core$Maybe$Just(z));
									},
									A4($author$project$UserSettings$Notifications$Main$init, $author$project$UserSettings$Model$NotificationsMsg, $author$project$UserSettings$Main$out_UserSettings_Main_getCurrentPushSubscription, name, listenRespond.product));
							case 'notifications-posts':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (z) {
										return $author$project$UserSettings$Model$NotificationsPosts(
											$elm$core$Maybe$Just(z));
									},
									A2($author$project$UserSettings$PostsNotifications$Main$init, $author$project$UserSettings$Model$PostsNotificationsMsg, name));
							case 'notifications-places-ai':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (z) {
										return $author$project$UserSettings$Model$NotificationsPlacesAI(
											$elm$core$Maybe$Just(z));
									},
									A2($author$project$UserSettings$PlacesAINotifications$Main$init, $author$project$UserSettings$Model$PlacesAINotificationsMsg, name));
							case 'change-password':
								return $author$project$UserSettings$Main$showChangePassword(authenticationType) ? A2(
									$elm$core$Tuple$mapFirst,
									function (z) {
										return $author$project$UserSettings$Model$ChangePassword(
											$elm$core$Maybe$Just(z));
									},
									$author$project$UserSettings$ChangePassword$init(
										$elm$core$Maybe$Just(flags_.user))) : _Utils_Tuple2(
									emailNotifications.a,
									$elm$browser$Browser$Navigation$load(
										A3($elm$core$String$replace, 'change-password', 'profile', currentPath)));
							case 'legal':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (d) {
										return $author$project$UserSettings$Model$LegalDocuments(
											$elm$core$Maybe$Just(d));
									},
									A2($author$project$UserSettings$Legal$init, $author$project$UserSettings$Model$LegalMsg, translations));
							case 'language':
								return A2(
									$elm$core$Tuple$mapFirst,
									function (z) {
										return $author$project$UserSettings$Model$Language(
											$elm$core$Maybe$Just(z));
									},
									A3(
										$author$project$UserSettings$Language$init,
										$author$project$UserSettings$Model$LanguageMsg,
										$elm$core$Maybe$Just(flags_.user),
										translations));
							default:
								return emailNotifications;
						}
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$drop,
							3,
							A2($elm$core$String$split, '/', currentRoute))));
			};
			var _v3 = activeNavigation(flags_.currentRoute);
			var selectedView = _v3.a;
			var commands = _v3.b;
			return _Utils_Tuple2(
				{
					url: $elm$core$Maybe$Just(flags_.currentUrl),
					user: $elm$core$Maybe$Just(flags_.user),
					view: selectedView,
					config: $elm$core$Maybe$Just(flags_.env),
					mobile: false,
					collapsed: flags_.collapsed,
					productUrl: flags_.productUrl,
					currentPath: $author$project$UserSettings$Types$CurrentPath(currentPath),
					selectedSite: $elm$core$Maybe$Just(flags_.selectedSite),
					translations: translations,
					accountAccess: flags_.siteAccess,
					topNavigation: $elm$core$Maybe$Just(topNavigationState),
					workInProgress: 0
				},
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							commands,
							A2($elm$core$Platform$Cmd$map, $author$project$UserSettings$Model$TopNavigationMsg, topNavigationCmd),
							A2(
							$elm$core$Task$perform,
							function (viewPort) {
								return $author$project$UserSettings$Model$OnWindowWidth(
									$elm$core$Basics$round(viewPort.viewport.width));
							},
							$elm$browser$Browser$Dom$getViewport)
						])));
		} else {
			var err = _v0.b.a;
			return A2(decodeError, 'translations', err);
		}
	} else {
		var err = _v0.a.a;
		return A2(decodeError, '', err);
	}
};
var $author$project$PinMeTo$Global$SupportTicket$Close = {$: 'Close'};
var $author$project$PinMeTo$Global$SupportTicket$Sending = {$: 'Sending'};
var $author$project$PinMeTo$Ui$StatusBar$success = function (message) {
	return $author$project$PinMeTo$Ui$StatusBar$StatusBar(
		{
			status: $elm$core$Maybe$Just($author$project$PinMeTo$Ui$StatusBar$Success),
			content: $author$project$PinMeTo$Ui$StatusBar$Plain(message),
			padding: $author$project$PinMeTo$Ui$StatusBar$DefaultPadding
		});
};
var $author$project$PinMeTo$Global$SupportTicket$baseClass = 'pmt-ui-support-ticket__';
var $author$project$PinMeTo$Global$SupportTicket$CloseImage = {$: 'CloseImage'};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$PinMeTo$Global$SupportTicket$SetTitle = function (a) {
	return {$: 'SetTitle', a: a};
};
var $author$project$PinMeTo$Global$SupportTicket$SelectImg = {$: 'SelectImg'};
var $author$project$PinMeTo$Global$SupportTicket$SetMessage = function (a) {
	return {$: 'SetMessage', a: a};
};
var $author$project$PinMeTo$Global$SupportTicket$OpenImage = function (a) {
	return {$: 'OpenImage', a: a};
};
var $author$project$PinMeTo$Global$SupportTicket$RemoveImage = function (a) {
	return {$: 'RemoveImage', a: a};
};
var $author$project$PinMeTo$Ui$Btn$pmtBtnNegativeSmall = $author$project$PinMeTo$Ui$Btn$pmtBtn_('pmt-btn--link pmt-btn--brand-4');
var $author$project$PinMeTo$Global$SupportTicket$viewPreview = F2(
	function (labels, url) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'imagePreview--card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'imagePreview--img'),
							$elm$html$Html$Attributes$src(url),
							$elm$html$Html$Events$onClick(
							$author$project$PinMeTo$Global$SupportTicket$OpenImage(url))
						]),
					_List_Nil),
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtnNegativeSmall,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$PinMeTo$Global$SupportTicket$RemoveImage(url))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labels.remove)
						]))
				]));
	});
var $author$project$PinMeTo$Global$SupportTicket$ticketBody = F2(
	function (labels, _v0) {
		var model = _v0.a;
		var addAndPreviewImages = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'button-container')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$PinMeTo$Ui$Btn$pmtBtn,
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'select'),
							$elm$html$Html$Events$onClick($author$project$PinMeTo$Global$SupportTicket$SelectImg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labels.attachImages)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labels.maxFileSize)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'imagePreview')
						]),
					A2(
						$elm$core$List$map,
						$author$project$PinMeTo$Global$SupportTicket$viewPreview(labels),
						$elm$core$Set$toList(model.images)))
				]));
		var requiredField = function (field) {
			return _Utils_eq(field, $elm$core$Maybe$Nothing) || _Utils_eq(
				field,
				$elm$core$Maybe$Just(''));
		};
		var message = A2($elm$core$Maybe$withDefault, '', model.message);
		var title = A2($elm$core$Maybe$withDefault, '', model.title);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'note')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labels.detailedMessage)
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('mailto:support@pinmeto.com')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labels.sendUs)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'input-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'label')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(labels.title)
										])),
									(requiredField(model.title) && model.showRequiredMessage) ? A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'require')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(labels.requiredTitle)
										])) : $elm$html$Html$text('')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + ('form-input ' + ($author$project$PinMeTo$Global$SupportTicket$baseClass + 'form-input--title'))),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$PinMeTo$Global$SupportTicket$baseClass + 'bad-input',
											requiredField(model.title) && model.showRequiredMessage)
										])),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Events$onInput($author$project$PinMeTo$Global$SupportTicket$SetTitle),
									$elm$html$Html$Attributes$value(title)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'input-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'label')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('message')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(labels.message)
										])),
									(requiredField(model.message) && model.showRequiredMessage) ? A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'require')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(labels.requiredMessage)
										])) : $elm$html$Html$text('')
								])),
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'form-input'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$PinMeTo$Global$SupportTicket$baseClass + ('bad-input' + ($author$project$PinMeTo$Global$SupportTicket$baseClass + 'bad-input--message')),
											requiredField(model.message) && model.showRequiredMessage)
										])),
									$elm$html$Html$Events$onInput($author$project$PinMeTo$Global$SupportTicket$SetMessage),
									$elm$html$Html$Attributes$value(message)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(labels.encounteredBug)
								]))
						])),
					addAndPreviewImages
				]));
	});
var $author$project$PinMeTo$Global$SupportTicket$ValidateTicket = {$: 'ValidateTicket'};
var $author$project$PinMeTo$Global$SupportTicket$alertBoxBody = F2(
	function (labels, _v0) {
		var model = _v0.a;
		var confirmButton = (!_Utils_eq(model.sendStatus, $author$project$PinMeTo$Global$SupportTicket$Sending)) ? $author$project$PinMeTo$Ui$Lightbox$withFooter(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-btn-group pmt-btn-group--large pmt-btn-group--basis-6')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$PinMeTo$Ui$Btn$pmtBtn,
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$PinMeTo$Global$SupportTicket$ValidateTicket)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labels.send)
							]))
					]))) : $elm$core$Basics$identity;
		var content = (!_Utils_eq(model.sendStatus, $author$project$PinMeTo$Global$SupportTicket$Sending)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-ui-support-ticket')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Global$SupportTicket$ticketBody,
					labels,
					$author$project$PinMeTo$Global$SupportTicket$State(model)),
					function () {
					var _v7 = model.imagePreview;
					if (_v7.$ === 'Open') {
						var url = _v7.a;
						return $author$project$PinMeTo$Ui$Lightbox$render(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withStyle,
								$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$PinMeTo$Global$SupportTicket$CloseImage,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{
											title: '',
											content: A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(url)
													]),
												_List_Nil)
										}))));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				])) : $elm$html$Html$text('');
		var header = function () {
			var errorMessage = function () {
				var _v4 = model.error;
				if (_v4.$ === 'Just') {
					if (_v4.a.$ === 'CouldntSend') {
						var _v5 = _v4.a;
						return $elm$core$Maybe$Just(labels.couldntSend);
					} else {
						var _v6 = _v4.a;
						return $elm$core$Maybe$Just(labels.couldntSend);
					}
				} else {
					return model.showRequiredMessage ? $elm$core$Maybe$Just(labels.requiredFields) : $elm$core$Maybe$Nothing;
				}
			}();
			var _v1 = model.sendStatus;
			switch (_v1.$) {
				case 'Editing':
					if (errorMessage.$ === 'Just') {
						var x = errorMessage.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'status-bar')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$StatusBar$render(
									$author$project$PinMeTo$Ui$StatusBar$error(x))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				case 'Sending':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'sending')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labels.sending),
								$author$project$PinMeTo$Ui$Spinner$spinner
							]));
				default:
					if (errorMessage.$ === 'Just') {
						var x = errorMessage.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'status-bar')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$StatusBar$render(
									$author$project$PinMeTo$Ui$StatusBar$error(x))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class($author$project$PinMeTo$Global$SupportTicket$baseClass + 'status-bar')
								]),
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$StatusBar$render(
									$author$project$PinMeTo$Ui$StatusBar$success(labels.thanks))
								]));
					}
			}
		}();
		return model.open ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('supportTicket')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Lightbox$render(
					confirmButton(
						A2(
							$author$project$PinMeTo$Ui$Lightbox$withHeader,
							header,
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withStyle,
								$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withClose,
									$author$project$PinMeTo$Global$SupportTicket$Close,
									$author$project$PinMeTo$Ui$Lightbox$view(
										{title: labels.header, content: content}))))))
				])) : $elm$html$Html$text('');
	});
var $author$project$PinMeTo$Global$SupportTicket$render = F2(
	function (labels, _v0) {
		var model = _v0.a;
		return A2(
			$author$project$PinMeTo$Global$SupportTicket$alertBoxBody,
			labels,
			$author$project$PinMeTo$Global$SupportTicket$State(model));
	});
var $author$project$PinMeTo$Global$TopNavigation$ChatFailAlert$render = F3(
	function (labels, show, onClose) {
		return show ? $author$project$PinMeTo$Ui$Lightbox$render(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withClose,
					onClose,
					$author$project$PinMeTo$Ui$Lightbox$withLightLightbox(
						$author$project$PinMeTo$Ui$Lightbox$view(
							{
								title: labels.title,
								content: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('chat-fail-alert')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											A2(
												labels.contactSupport,
												$elm$html$Html$text,
												A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href('mailto:support@pinmeto.com'),
															A2($elm$html$Html$Attributes$attribute, 'data-pmt-event', 'Crisp Not Load - Click on Email link')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('support@pinmeto.com')
														]))))
										]))
							}))))) : $elm$html$Html$text('');
	});
var $author$project$FontAwesome$Regular$Icon$faCommentDots = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-comment-dots');
var $author$project$FontAwesome$Regular$faCommentDots = $author$project$FontAwesome$Regular$Icon$render($author$project$FontAwesome$Regular$Icon$faCommentDots);
var $author$project$PinMeTo$Global$TopNavigation$Chat$ToggleRequested = {$: 'ToggleRequested'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$NotEnabledToggled = {$: 'NotEnabledToggled'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$launcher = function (config) {
	return A2(
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('pmt_chat_launcher'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pmt-global-top-navigation__chat-launcher--mobile', config.isMobile)
					])),
				$elm$html$Html$Attributes$class('pmt-global-top-navigation__chat-launcher'),
				$elm$html$Html$Attributes$title(config.title),
				$elm$html$Html$Events$onClick(
				config.enabled ? $author$project$PinMeTo$Global$TopNavigation$Chat$ToggleRequested : $author$project$PinMeTo$Global$TopNavigation$Chat$NotEnabledToggled)
			]),
		_List_fromArray(
			[$author$project$FontAwesome$Regular$faCommentDots]));
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$chatEnabled = function (info) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var status = _v0.status;
				if (status.$ === 'ChatEnabled') {
					return true;
				} else {
					return false;
				}
			},
			info));
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$isEnabled = function (_v0) {
	var s = _v0.a;
	return $author$project$PinMeTo$Global$TopNavigation$Chat$chatEnabled(s.info);
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 'Nothing') {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$New = {$: 'New'};
var $author$project$PinMeTo$Global$NewsFeed$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Global$NewsFeed$SiteName = function (a) {
	return {$: 'SiteName', a: a};
};
var $author$project$PinMeTo$Global$NewsFeed$view = function (config) {
	return $author$project$PinMeTo$Global$NewsFeed$View(
		{
			app: config.app,
			title: config.title,
			siteName: $author$project$PinMeTo$Global$NewsFeed$SiteName(config.siteName),
			onNavigate: config.onNavigate,
			siteAccess: config.siteAccess,
			articlesSeen: config.newsFeedLatestSeen
		});
};
var $author$project$PinMeTo$Ui$Metrics$click = function (x) {
	return A2($elm$html$Html$Attributes$attribute, 'data-pmt-event', x);
};
var $author$project$PinMeTo$Ui$Metrics$weight = function (x) {
	return A2(
		$elm$html$Html$Attributes$attribute,
		'data-pmt-event-weight',
		$elm$core$String$fromInt(x));
};
var $author$project$PinMeTo$Global$TopNavigation$HelpMenu$tracking = function (maybeEvent) {
	if (maybeEvent.$ === 'Just') {
		var event = maybeEvent.a;
		return _List_fromArray(
			[
				$author$project$PinMeTo$Ui$Metrics$click(event),
				$author$project$PinMeTo$Ui$Metrics$weight(5)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$PinMeTo$Global$TopNavigation$HelpMenu$rowContent = F2(
	function (icon, label) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__icon')
					]),
				_List_fromArray(
					[
						$author$project$FontAwesome$render(icon)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]);
	});
var $author$project$FontAwesome$Regular$Icon$faFileLines = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-file-lines');
var $author$project$FontAwesome$Regular$Icon$faPaperPlane = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-paper-plane');
var $author$project$PinMeTo$Global$TopNavigation$HelpMenu$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-global-top-navigation__menu')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_Utils_ap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'link-navigation-documentation'),
							$elm$html$Html$Attributes$href(config.helpCenterUrl),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$rel('noreferrer noopener'),
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__link')
						]),
					$author$project$PinMeTo$Global$TopNavigation$HelpMenu$tracking(config.helpCenterTracking)),
				A2(
					$author$project$PinMeTo$Global$TopNavigation$HelpMenu$rowContent,
					$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faFileLines),
					config.labels.helpCenter)),
				A2(
				$elm$html$Html$button,
				_Utils_ap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'button-navigation-sendFeedback'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(config.onSendFeedback),
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__button')
						]),
					$author$project$PinMeTo$Global$TopNavigation$HelpMenu$tracking(config.sendFeedbackTracking)),
				A2(
					$author$project$PinMeTo$Global$TopNavigation$HelpMenu$rowContent,
					$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faPaperPlane),
					config.labels.sendFeedback))
			]));
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Self = {$: 'Self'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Blank = {$: 'Blank'};
var $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned = {$: 'Owned'};
var $author$project$FontAwesome$Solid$Icon$faGrid = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-grid');
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Title = function (a) {
	return {$: 'Title', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$addNode = function (title) {
	return {
		url: $elm$core$Maybe$Nothing,
		html: $elm$core$Maybe$Nothing,
		icon: $elm$core$Maybe$Nothing,
		badge: $elm$core$Maybe$Nothing,
		_class: '',
		click: $elm$core$Maybe$Nothing,
		title: $author$project$PinMeTo$Global$TopNavigation$Navigation$Title(title),
		trackingEvent: $elm$core$Maybe$Nothing,
		dataTestAttribute: $author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute(
			'navigation-' + A3($elm$core$String$replace, ' ', '_', title))
	};
};
var $author$project$PinMeTo$Global$TopNavigation$Model$Champion = {$: 'Champion'};
var $author$project$PinMeTo$Global$TopNavigation$Model$Listings = {$: 'Listings'};
var $author$project$PinMeTo$Global$TopNavigation$ProductUpgrades$partition = F2(
	function (opts, all) {
		var isIgnored = function (upgrade) {
			return A2($elm$core$List$member, upgrade.name, opts.ignoredNames);
		};
		var visible = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeR, isIgnored, $elm$core$Basics$not),
			all);
		var ignored = A2($elm$core$List$filter, isIgnored, all);
		return {
			shown: opts.showIgnored ? _Utils_ap(visible, ignored) : visible,
			ignored: ignored
		};
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withClass = F2(
	function (_class, x) {
		return _Utils_update(
			x,
			{_class: _class});
	});
var $author$project$PinMeTo$Ui$Icon$AppIconLocatorNoFill = {$: 'AppIconLocatorNoFill'};
var $author$project$PinMeTo$Ui$Icon$AppIconConversationsNoFill = {$: 'AppIconConversationsNoFill'};
var $author$project$PinMeTo$Ui$Icon$AppIconLocationPostsNoFill = {$: 'AppIconLocationPostsNoFill'};
var $author$project$PinMeTo$Ui$Icon$AppIconLocalCampaignsNoFill = {$: 'AppIconLocalCampaignsNoFill'};
var $author$project$PinMeTo$Global$TopNavigation$ProductUpgrades$candidates = function (input) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				(!input.hasLocator) ? $elm$core$Maybe$Just(
				{
					icon: $author$project$PinMeTo$Ui$Icon$AppIconLocatorNoFill,
					name: 'Locator & Local Pages',
					isNew: true,
					promoUrl: input.urls.locator,
					description: input.descriptions.locator,
					trackingEvent: input.trackingEvent('Top Navigation - Upgrade - Locator & Local Pages'),
					dataTestAttribute: 'navigation-upgrade-Locator'
				}) : $elm$core$Maybe$Nothing,
				(!input.hasListenAndRespond) ? $elm$core$Maybe$Just(
				{
					icon: $author$project$PinMeTo$Ui$Icon$AppIconConversationsNoFill,
					name: 'Conversations',
					isNew: false,
					promoUrl: input.urls.conversations,
					description: input.descriptions.conversations,
					trackingEvent: input.trackingEvent('Top Navigation - Upgrade - Conversations'),
					dataTestAttribute: 'navigation-upgrade-Conversations'
				}) : $elm$core$Maybe$Nothing,
				(!input.hasSocialMedia) ? $elm$core$Maybe$Just(
				{
					icon: $author$project$PinMeTo$Ui$Icon$AppIconLocationPostsNoFill,
					name: 'Posts',
					isNew: false,
					promoUrl: input.urls.posts,
					description: input.descriptions.posts,
					trackingEvent: input.trackingEvent('Top Navigation - Upgrade - Posts'),
					dataTestAttribute: 'navigation-upgrade-Posts'
				}) : $elm$core$Maybe$Nothing,
				(!input.hasLocalCampaigns) ? $elm$core$Maybe$Just(
				{
					icon: $author$project$PinMeTo$Ui$Icon$AppIconLocalCampaignsNoFill,
					name: 'Local Campaigns',
					isNew: true,
					promoUrl: input.urls.localCampaigns,
					description: input.descriptions.localCampaigns,
					trackingEvent: input.trackingEvent('Top Navigation - Upgrade - Local Campaigns'),
					dataTestAttribute: 'navigation-upgrade-LocalCampaigns'
				}) : $elm$core$Maybe$Nothing
			]));
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Visible = {$: 'Visible'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$HtmlItem = F3(
	function (a, b, c) {
		return {$: 'HtmlItem', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode = F2(
	function (expanded, collapsed) {
		return A3($author$project$PinMeTo$Global$TopNavigation$Navigation$HtmlItem, $author$project$PinMeTo$Global$TopNavigation$Navigation$Visible, expanded, collapsed);
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withChildren = F2(
	function (xs, x) {
		return {url: x.url, icon: x.icon, badge: x.badge, _class: x._class, click: x.click, title: x.title, children: xs, trackingEvent: x.trackingEvent};
	});
var $author$project$PinMeTo$Ui$Icon$AppIconPlaces = {$: 'AppIconPlaces'};
var $author$project$PinMeTo$Global$TopNavigation$Model$LocationPosts = {$: 'LocationPosts'};
var $author$project$PinMeTo$Ui$Icon$AppIconReviews = {$: 'AppIconReviews'};
var $author$project$PinMeTo$Global$TopNavigation$Model$ListenAndRespond = {$: 'ListenAndRespond'};
var $author$project$PinMeTo$Ui$Icon$AppIconAiInsights = {$: 'AppIconAiInsights'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$TrackingEvent = function (a) {
	return {$: 'TrackingEvent', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent = F2(
	function (trackingEvent, x) {
		return _Utils_update(
			x,
			{
				trackingEvent: $elm$core$Maybe$Just(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$TrackingEvent(trackingEvent))
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withHtml = F2(
	function (html, x) {
		return _Utils_update(
			x,
			{
				html: $elm$core$Maybe$Just(html)
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$productHtml = function (product) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('product-grid-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('product-grid-item__icon'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product-grid-item__icon--places',
								_Utils_eq(product.icon, $author$project$PinMeTo$Ui$Icon$AppIconPlaces))
							]))
					]),
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Icon$render(product.icon)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('product-grid-item__name')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(product.name)
					]))
			]));
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Item = F3(
	function (a, b, c) {
		return {$: 'Item', a: a, b: b, c: c};
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigation = function (x) {
	return A3($author$project$PinMeTo$Global$TopNavigation$Navigation$Item, $author$project$PinMeTo$Global$TopNavigation$Navigation$Visible, x, _List_Nil);
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Url = F2(
	function (a, b) {
		return {$: 'Url', a: a, b: b};
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withUrlTarget = F3(
	function (target, url, x) {
		return _Utils_update(
			x,
			{
				url: $elm$core$Maybe$Just(
					A2($author$project$PinMeTo$Global$TopNavigation$Navigation$Url, target, url))
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$disabledProductHtml = F2(
	function (product, tooltip) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('product-grid-item product-grid-item--disabled'),
					$elm$html$Html$Attributes$title(tooltip)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('product-grid-item__icon product-grid-item__icon--disabled'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product-grid-item__icon--places',
									_Utils_eq(product.icon, $author$project$PinMeTo$Ui$Icon$AppIconPlaces))
								]))
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Icon$render(product.icon)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('product-grid-item__name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(product.name)
						]))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute = F2(
	function (dataTestAttribute, nav) {
		return _Utils_update(
			nav,
			{
				dataTestAttribute: $author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute(dataTestAttribute)
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$productToNavigation = function (product) {
	var _v0 = product.state;
	if (_v0.$ === 'Owned') {
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigation(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
				product.trackingEvent,
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
					product.dataTestAttribute,
					A3(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withUrlTarget,
						product.target,
						product.url,
						A2(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$withHtml,
							$author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$productHtml(product),
							A2(
								$author$project$PinMeTo$Global$TopNavigation$Navigation$withClass,
								'product-grid-item-link',
								$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(product.name)))))));
	} else {
		var tooltip = _v0.a;
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigation(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
				product.dataTestAttribute,
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withHtml,
					A2($author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$disabledProductHtml, product, tooltip),
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withClass,
						'product-grid-item-link product-grid-item-link--disabled',
						$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(product.name)))));
	}
};
var $author$project$PinMeTo$Global$TopNavigation$ProductUpgrades$upgradeHtml = F2(
	function (labels, upgrade) {
		var newChip = upgrade.isNew ? $author$project$PinMeTo$Ui$Chip$render(
			A2(
				$author$project$PinMeTo$Ui$Chip$withColor,
				$author$project$PinMeTo$Ui$Chip$NewColor,
				$author$project$PinMeTo$Ui$Chip$view(labels._new))) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('product-upgrade-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('product-upgrade-item__icon'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product-upgrade-item__icon--places',
									_Utils_eq(upgrade.icon, $author$project$PinMeTo$Ui$Icon$AppIconPlaces))
								]))
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Icon$render(upgrade.icon)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('product-upgrade-item__body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('product-upgrade-item__name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(upgrade.name),
									newChip
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('product-upgrade-item__description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(upgrade.description)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('product-upgrade-item__learn-more')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labels.learnMore)
						]))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$upgradeToNavigation = F2(
	function (labels, upgrade) {
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigation(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
				upgrade.trackingEvent,
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
					upgrade.dataTestAttribute,
					A3(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withUrlTarget,
						$author$project$PinMeTo$Global$TopNavigation$Navigation$Blank,
						upgrade.promoUrl,
						A2(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$withHtml,
							A2(
								$author$project$PinMeTo$Global$TopNavigation$ProductUpgrades$upgradeHtml,
								{_new: labels.productInfo._new, learnMore: labels.productInfo.learnMore},
								upgrade),
							A2(
								$author$project$PinMeTo$Global$TopNavigation$Navigation$withClass,
								'product-upgrade-item-link',
								$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(upgrade.name)))))));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$FontAwesome = function (a) {
	return {$: 'FontAwesome', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withFontAwesomeIcon = F2(
	function (icon, x) {
		return _Utils_update(
			x,
			{
				icon: $elm$core$Maybe$Just(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$FontAwesome(icon))
			});
	});
var $author$project$PinMeTo$Ui$Icon$AppIconConversations = {$: 'AppIconConversations'};
var $author$project$PinMeTo$Ui$Icon$AppIconLocationPosts = {$: 'AppIconLocationPosts'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Hidden = {$: 'Hidden'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden = function (nav) {
	if (nav.$ === 'Item') {
		var navigationItem = nav.b;
		var navigations = nav.c;
		return A3($author$project$PinMeTo$Global$TopNavigation$Navigation$Item, $author$project$PinMeTo$Global$TopNavigation$Navigation$Hidden, navigationItem, navigations);
	} else {
		var html1 = nav.b;
		var html2 = nav.c;
		return A3($author$project$PinMeTo$Global$TopNavigation$Navigation$HtmlItem, $author$project$PinMeTo$Global$TopNavigation$Navigation$Hidden, html1, html2);
	}
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigationWithChildren = function (x) {
	var node = function (n) {
		return _Utils_update(
			n,
			{url: x.url, icon: x.icon, badge: x.badge, _class: x._class, click: x.click, trackingEvent: x.trackingEvent});
	}(
		$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(
			function (_v0) {
				var t = _v0.a;
				return t;
			}(x.title)));
	return A3($author$project$PinMeTo$Global$TopNavigation$Navigation$Item, $author$project$PinMeTo$Global$TopNavigation$Navigation$Visible, node, x.children);
};
var $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$view = function (config) {
	var horizontalLine = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-global-top-navigation__divider product-switcher-full-width')
			]),
		_List_Nil);
	var upgradesTitle = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-global-top-navigation__upgrades-title product-switcher-full-width')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Upgrades')
			]));
	var trackingEvent = function (event) {
		return config.trackingEventPrefix + (' - ' + event);
	};
	var aiVisibilityProduct = (A2($author$project$PinMeTo$Permissions$hasRole, config.permissions, $author$project$PinMeTo$Permissions$PinMeTo) && config.siteAccess.hasAiVisibility) ? $elm$core$Maybe$Just(
		{
			url: config.urls.aiVisibility,
			icon: $author$project$PinMeTo$Ui$Icon$AppIconAiInsights,
			name: 'AI Visibility',
			state: $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned,
			target: $author$project$PinMeTo$Global$TopNavigation$Navigation$Blank,
			description: config.labels.productInfo.aiVisibility,
			trackingEvent: trackingEvent('Top Navigation - Switch Product - AiVisibility'),
			dataTestAttribute: 'navigation-AiVisibility'
		}) : $elm$core$Maybe$Nothing;
	var allUpgrades = $author$project$PinMeTo$Global$TopNavigation$ProductUpgrades$candidates(
		{
			urls: {posts: config.urls.locationPosts, locator: config.urls.locator, conversations: config.urls.listenAndRespond, localCampaigns: config.urls.localCampaigns},
			hasLocator: config.siteAccess.hasLocator,
			descriptions: {posts: config.labels.productInfo.posts, locator: config.labels.productInfo.locator, conversations: config.labels.productInfo.conversations, localCampaigns: config.labels.productInfo.localCampaigns},
			trackingEvent: trackingEvent,
			hasSocialMedia: config.siteAccess.hasSocialMedia,
			hasLocalCampaigns: config.siteAccess.hasLocalCampaigns,
			hasListenAndRespond: config.siteAccess.hasListenAndRespond
		});
	var upgradeParts = A2(
		$author$project$PinMeTo$Global$TopNavigation$ProductUpgrades$partition,
		{
			showIgnored: config.showIgnoredProductUpgrades,
			ignoredNames: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, config.site.name, config.ignoredProductUpgrades))
		},
		allUpgrades);
	var ignoredUpgrades = upgradeParts.ignored;
	var showMoreNode = function () {
		if (!$elm$core$List$isEmpty(ignoredUpgrades)) {
			var count = $elm$core$List$length(ignoredUpgrades);
			var label = config.showIgnoredProductUpgrades ? ('Hide ' + ($elm$core$String$fromInt(count) + ' items')) : ('Show ' + ($elm$core$String$fromInt(count) + ' more'));
			var icon = config.showIgnoredProductUpgrades ? $author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faChevronUp) : $author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faChevronDown);
			var showMoreHtml = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__show-more product-switcher-full-width'),
						$elm$html$Html$Events$onClick(config.onToggleIgnoredUpgrades)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-global-top-navigation__show-more-content')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-global-top-navigation__show-more-icon')
									]),
								_List_fromArray(
									[
										$author$project$FontAwesome$render(icon)
									]))
							]))
					]));
			return _List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
					showMoreHtml,
					$elm$html$Html$text(''))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var upgrades = upgradeParts.shown;
	var upgradeNodes = A2(
		$elm$core$List$map,
		$author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$upgradeToNavigation(config.labels),
		upgrades);
	var upgradesSection = ($elm$core$List$isEmpty(upgradeNodes) && $elm$core$List$isEmpty(showMoreNode)) ? _List_Nil : _Utils_ap(
		_List_fromArray(
			[
				A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
				horizontalLine,
				$elm$html$Html$text('')),
				A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
				upgradesTitle,
				$elm$html$Html$text(''))
			]),
		_Utils_ap(upgradeNodes, showMoreNode));
	var isOwner = A2($author$project$PinMeTo$Permissions$hasRole, config.permissions, $author$project$PinMeTo$Permissions$Owner);
	var isDev = A2($author$project$PinMeTo$Permissions$hasRole, config.permissions, $author$project$PinMeTo$Permissions$PinMeToDeveloper);
	var getTarget = function (app) {
		return (_Utils_eq(config.app, app) || isDev) ? $author$project$PinMeTo$Global$TopNavigation$Navigation$Self : $author$project$PinMeTo$Global$TopNavigation$Navigation$Blank;
	};
	var postsProduct = config.siteAccess.hasSocialMedia ? $elm$core$Maybe$Just(
		{
			url: config.urls.locationPosts,
			icon: $author$project$PinMeTo$Ui$Icon$AppIconLocationPosts,
			name: 'Posts',
			state: $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned,
			target: getTarget($author$project$PinMeTo$Global$TopNavigation$Model$LocationPosts),
			description: config.labels.productInfo.posts,
			trackingEvent: trackingEvent('Top Navigation - Switch Product - Posts'),
			dataTestAttribute: 'navigation-Posts'
		}) : $elm$core$Maybe$Nothing;
	var placesProduct = (config.siteAccess.hasListings || isOwner) ? $elm$core$Maybe$Just(
		{
			url: config.urls.champion,
			icon: $author$project$PinMeTo$Ui$Icon$AppIconPlaces,
			name: 'Places AI',
			state: $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned,
			target: getTarget($author$project$PinMeTo$Global$TopNavigation$Model$Champion),
			description: config.labels.productInfo.places,
			trackingEvent: trackingEvent('Top Navigation - Switch Product - Places'),
			dataTestAttribute: 'navigation-Champion'
		}) : $elm$core$Maybe$Nothing;
	var listingsProduct = $elm$core$Maybe$Just(
		{
			url: config.urls.listings,
			icon: $author$project$PinMeTo$Ui$Icon$AppIconListings,
			name: 'Listings',
			state: $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned,
			target: getTarget($author$project$PinMeTo$Global$TopNavigation$Model$Listings),
			description: config.labels.productInfo.listings,
			trackingEvent: trackingEvent('Top Navigation - Switch Product - Listings'),
			dataTestAttribute: 'navigation-Listings'
		});
	var conversationsProduct = function () {
		if (config.siteAccess.hasListenAndRespond) {
			var _v0 = config.site.listenRespondProduct;
			if (_v0.$ === 'ReviewsOnly') {
				return $elm$core$Maybe$Just(
					{
						url: config.urls.listenAndRespond,
						icon: $author$project$PinMeTo$Ui$Icon$AppIconReviews,
						name: 'Reviews',
						state: $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned,
						target: getTarget($author$project$PinMeTo$Global$TopNavigation$Model$ListenAndRespond),
						description: config.labels.productInfo.reviews,
						trackingEvent: trackingEvent('Top Navigation - Switch Product - Reviews'),
						dataTestAttribute: 'navigation-Conversations'
					});
			} else {
				return $elm$core$Maybe$Just(
					{
						url: config.urls.listenAndRespond,
						icon: $author$project$PinMeTo$Ui$Icon$AppIconConversations,
						name: 'Conversations',
						state: $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$Owned,
						target: getTarget($author$project$PinMeTo$Global$TopNavigation$Model$ListenAndRespond),
						description: config.labels.productInfo.conversations,
						trackingEvent: trackingEvent('Top Navigation - Switch Product - Conversations'),
						dataTestAttribute: 'navigation-Conversations'
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var products = $elm_community$maybe_extra$Maybe$Extra$values(
		_List_fromArray(
			[placesProduct, aiVisibilityProduct, listingsProduct, conversationsProduct, postsProduct]));
	var productNodes = A2($elm$core$List$map, $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$productToNavigation, products);
	var children = $elm$core$List$concat(
		$elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					$elm$core$List$isEmpty(productNodes) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(productNodes),
					$elm$core$List$isEmpty(upgradesSection) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(upgradesSection)
				])));
	return (_Utils_eq(children, _List_Nil) ? $author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden : $elm$core$Basics$identity)(
		$author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigationWithChildren(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withChildren,
				children,
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
					trackingEvent('Top Navigation - Switch Product'),
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
						'navigation-switchProduct',
						A2(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faGrid),
							A2(
								$author$project$PinMeTo$Global$TopNavigation$Navigation$withClass,
								'pmt-global-top-navigation__switch-product',
								$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(config.labels.switchProduct))))))));
};
var $author$project$PinMeTo$Global$NewsFeed$appUrl = F2(
	function (application, _v0) {
		var siteName = _v0.a;
		switch (application.$) {
			case 'Listings':
				return '/listings/' + siteName;
			case 'Posts':
				return '/location-posts/' + siteName;
			case 'Conversations':
				return '/listen-and-respond/' + siteName;
			default:
				return '/overview/portfolio';
		}
	});
var $author$project$PinMeTo$Global$NewsFeed$appChip = function (application) {
	switch (application.$) {
		case 'Listings':
			return $author$project$PinMeTo$Ui$Chip$render(
				A2(
					$author$project$PinMeTo$Ui$Chip$withColor,
					$author$project$PinMeTo$Ui$Chip$AppListingsColor,
					$author$project$PinMeTo$Ui$Chip$view('Listings')));
		case 'Posts':
			return $author$project$PinMeTo$Ui$Chip$render(
				A2(
					$author$project$PinMeTo$Ui$Chip$withColor,
					$author$project$PinMeTo$Ui$Chip$AppPostsColor,
					$author$project$PinMeTo$Ui$Chip$view('Posts')));
		case 'Conversations':
			return $author$project$PinMeTo$Ui$Chip$render(
				A2(
					$author$project$PinMeTo$Ui$Chip$withColor,
					$author$project$PinMeTo$Ui$Chip$AppConversationsColor,
					$author$project$PinMeTo$Ui$Chip$view('Conversations')));
		default:
			return $author$project$PinMeTo$Ui$Chip$render(
				A2(
					$author$project$PinMeTo$Ui$Chip$withColor,
					$author$project$PinMeTo$Ui$Chip$AppPlacesColor,
					$author$project$PinMeTo$Ui$Chip$view('Places AI')));
	}
};
var $author$project$PinMeTo$Ui$Icon$AppIconListingsNoFill = {$: 'AppIconListingsNoFill'};
var $author$project$PinMeTo$Global$NewsFeed$renderArticle = F3(
	function (latestSeen, config, article) {
		var shouldShowCta = function () {
			var _v2 = article.application;
			switch (_v2.$) {
				case 'Listings':
					return true;
				case 'Posts':
					return true;
				case 'Conversations':
					return true;
				default:
					return config.siteAccess.hasListings;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('article')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$aside,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('article__meta')
						]),
					_List_fromArray(
						[
							(_Utils_cmp(article.id, latestSeen) > 0) ? $author$project$PinMeTo$Ui$Chip$render(
							A2(
								$author$project$PinMeTo$Ui$Chip$withColor,
								$author$project$PinMeTo$Ui$Chip$NewColor,
								$author$project$PinMeTo$Ui$Chip$view('New'))) : $elm$html$Html$text(''),
							$author$project$PinMeTo$Global$NewsFeed$appChip(article.application)
						])),
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('article__header')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = article.application;
							switch (_v0.$) {
								case 'Listings':
									return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$AppIconListingsNoFill);
								case 'Posts':
									return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$AppIconLocationPostsNoFill);
								case 'Conversations':
									return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$AppIconConversationsNoFill);
								default:
									return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$AppIconPlaces);
							}
						}(),
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(article.title)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(article.content),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								function (_v1) {
									var link = _v1.a;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(link.url),
												$elm$html$Html$Attributes$target('_blank'),
												$author$project$PinMeTo$Ui$Metrics$click('News feed - Clicked content link - ' + article.trackingId),
												$author$project$PinMeTo$Ui$Metrics$weight(5)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(link.label)
											]));
								},
								article.contentLink))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (ctaText) {
							var addTarget = function (attrs) {
								return _Utils_eq(
									config.app,
									$elm$core$Maybe$Just(article.application)) ? attrs : A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$target('_blank'),
									attrs);
							};
							var toLink = function (attrs) {
								return A2(
									$elm$html$Html$a,
									attrs,
									_List_fromArray(
										[
											$elm$html$Html$text(ctaText)
										]));
							};
							return A2(
								$elm$html$Html$footer,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('article__footer')
									]),
								_List_fromArray(
									[
										toLink(
										addTarget(
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													A2(
														$elm$core$Maybe$withDefault,
														A2($author$project$PinMeTo$Global$NewsFeed$appUrl, article.application, config.siteName),
														article.applicationUrl)),
													$elm$html$Html$Events$onClick(config.onNavigate),
													$author$project$PinMeTo$Ui$Metrics$click('News feed - Clicked navigation CTA - ' + article.trackingId),
													$author$project$PinMeTo$Ui$Metrics$weight(5)
												])))
									]));
						},
						A2(
							$elm$core$Maybe$andThen,
							function (ctaText) {
								return shouldShowCta ? $elm$core$Maybe$Just(ctaText) : $elm$core$Maybe$Nothing;
							},
							article.applicationCta)))
				]));
	});
var $author$project$PinMeTo$Global$NewsFeed$render = F2(
	function (_v0, _v1) {
		var model = _v0.a;
		var config = _v1.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-news-feed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-news-feed__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(config.title)
								]))
						])),
					function () {
					var _v2 = model.articles;
					if (_v2.$ === 'Loading') {
						return A2(
							$elm$html$Html$section,
							_List_Nil,
							_List_fromArray(
								[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
					} else {
						var articles_ = _v2.a;
						return A2(
							$elm$html$Html$section,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-global-news-feed__articles')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$PinMeTo$Global$NewsFeed$renderArticle, model.latestSeen, config),
								$elm$core$List$reverse(
									A2(
										$elm$core$List$sortBy,
										function ($) {
											return $.id;
										},
										articles_))));
					}
				}()
				]));
	});
var $author$project$FontAwesome$Regular$Icon$faHouse = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-house');
var $author$project$PinMeTo$Global$TopNavigation$Top$concatUrl = F2(
	function (base, path) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$endsWith, '/', base),
			A2($elm$core$String$startsWith, '/', path));
		if (!_v0.a) {
			if (!_v0.b) {
				return base + ('/' + path);
			} else {
				return _Utils_ap(base, path);
			}
		} else {
			if (!_v0.b) {
				return _Utils_ap(base, path);
			} else {
				return _Utils_ap(
					base,
					A3(
						$elm$core$String$slice,
						1,
						$elm$core$String$length(path),
						path));
			}
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withBadge = F2(
	function (badge, x) {
		return _Utils_update(
			x,
			{
				badge: $elm$core$Maybe$Just(badge)
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Image = function (a) {
	return {$: 'Image', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withImage = F2(
	function (href, x) {
		return _Utils_update(
			x,
			{
				icon: $elm$core$Maybe$Just(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$Image(href))
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$Msg$ToggleDemo = {$: 'ToggleDemo'};
var $author$project$FontAwesome$Solid$Icon$faToggleOn = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-toggle-on');
var $author$project$PinMeTo$Global$TopNavigation$Top$appToString = function (app) {
	switch (app.$) {
		case 'Listings':
			return 'Listings';
		case 'LocationPosts':
			return 'Posts';
		case 'ListenAndRespond':
			return 'Conversations';
		case 'AccountSettings':
			return 'Account Settings';
		case 'Admin':
			return 'Admin';
		case 'UserSettings':
			return 'User Settings';
		default:
			return 'Overview';
	}
};
var $author$project$FontAwesome$Regular$Icon$faNewspaper = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-newspaper');
var $author$project$FontAwesome$Regular$Icon$faToggleOff = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-toggle-off');
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withOnClick = F2(
	function (msg, x) {
		return _Utils_update(
			x,
			{
				click: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$Msg$SearchFilter = function (a) {
	return {$: 'SearchFilter', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Top$switchAccount = F5(
	function (labels, app, config, siteFilter, sites) {
		var addSitePath = function (siteName) {
			switch (app.$) {
				case 'Listings':
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, 'api/user/accounts/add/' + siteName);
				case 'LocationPosts':
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.locationPosts, 'api/user/accounts/add/' + siteName);
				case 'ListenAndRespond':
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listenAndRespond, 'api/user/accounts/add/' + siteName);
				case 'AccountSettings':
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.accountSettings, 'api/user/accounts/add/' + siteName);
				case 'Admin':
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.admin, 'api/user/accounts/add/' + siteName);
				case 'UserSettings':
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, 'api/user/accounts/add/' + siteName);
				default:
					return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.champion, 'api/user/accounts/add/' + siteName);
			}
		};
		var searchBox = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__switch-account--search-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$id('navigation_switch_account_search'),
							$elm$html$Html$Attributes$placeholder(labels.searchAccounts),
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__switch-account--search'),
							$elm$html$Html$Attributes$value(
							A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, siteFilter)),
							$elm$html$Html$Events$onInput($author$project$PinMeTo$Global$TopNavigation$Msg$SearchFilter),
							$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('navigation-search')
						]),
					_List_Nil)
				]));
		var sitePath = function (siteName) {
			if (app.$ === 'ListenAndRespond') {
				return A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listenAndRespond, siteName);
			} else {
				return siteName;
			}
		};
		var renderSite = function (_v0) {
			var x = _v0.a;
			var toUrl = x.hasAccess ? sitePath : addSitePath;
			var link = A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						toUrl(x.name)),
						$elm$html$Html$Attributes$target('_self'),
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__link pmt-global-top-navigation__link--dropdown-item'),
						$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('navigation-site-' + x.name)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(x.displayName)
					]));
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-global-top-navigation__top--item')
							]),
						_List_fromArray(
							[link]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__switch-account')
				]),
			_List_fromArray(
				[
					searchBox,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__switch-account--account-list')
						]),
					A2($elm$core$List$map, renderSite, sites))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedOnOpen = {$: 'NewsFeedOnOpen'};
var $author$project$PinMeTo$Global$NewsFeed$latestArticleId = function (_v0) {
	var model = _v0.a;
	var _v1 = model.articles;
	if (_v1.$ === 'Loading') {
		return $elm$core$Maybe$Nothing;
	} else {
		var articles_ = _v1.a;
		return $elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.id;
				},
				articles_));
	}
};
var $author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent = F2(
	function (app, event) {
		return $author$project$PinMeTo$Global$TopNavigation$Top$appToString(app) + (' - ' + event);
	});
var $author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Self = {$: 'Self'};
var $author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Blank = {$: 'Blank'};
var $author$project$FontAwesome$Regular$Icon$faUser = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-user');
var $author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$divider = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('pmt-global-top-navigation__divider')
		]),
	_List_Nil);
var $author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$targetAttrs = function (linkTarget) {
	if (linkTarget.$ === 'Blank') {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$rel('noreferrer noopener')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$linkRow = F5(
	function (linkTarget, dataTest, icon, label, url) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'link-' + dataTest),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$href(url),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__link'),
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$targetAttrs(linkTarget)))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__icon')
						]),
					_List_fromArray(
						[
							$author$project$FontAwesome$render(icon)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$FontAwesome$Regular$Icon$faBuilding = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-building');
var $author$project$FontAwesome$Regular$Icon$faMicrochipAi = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-microchip-ai');
var $author$project$FontAwesome$Regular$Icon$faShieldHalved = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-shield-halved');
var $author$project$FontAwesome$Regular$Icon$faRightFromBracket = $author$project$FontAwesome$Regular$Icon$Icon('fa-regular fa-right-from-bracket');
var $author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-global-top-navigation__menu')
			]),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A5(
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$linkRow,
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Blank,
						'navigation-user',
						$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faUser),
						config.labels.user,
						config.userUrl)),
					config.hasAccountSettings ? $elm$core$Maybe$Just(
					A5(
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$linkRow,
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Blank,
						'navigation-account',
						$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faBuilding),
						config.labels.account,
						config.accountUrl)) : $elm$core$Maybe$Nothing,
					config.isPinMeToAdmin ? $elm$core$Maybe$Just(
					A5(
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$linkRow,
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Blank,
						'navigation-admin',
						$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faShieldHalved),
						config.labels.admin,
						config.adminUrl)) : $elm$core$Maybe$Nothing,
					config.showAi ? $elm$core$Maybe$Just(
					A5(
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$linkRow,
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Blank,
						'navigation-ai',
						$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faMicrochipAi),
						config.labels.ai,
						config.aiUrl)) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just($author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$divider),
					$elm$core$Maybe$Just(
					A5(
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$linkRow,
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$Self,
						'navigation-user-logout',
						$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faRightFromBracket),
						config.labels.logout,
						config.logoutUrl))
				])));
};
var $author$project$FontAwesome$Solid$Icon$faGear = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-gear');
var $author$project$PinMeTo$Global$TopNavigation$Top$userSettingsNode = F4(
	function (labels, model, config, _v0) {
		var site = _v0.a;
		var listingsUrl = A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, site.name);
		var isDev = A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$PinMeToDeveloper);
		var isCs = A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$CustomerSuccess);
		var isPinMeToAdmin = (isCs || isDev) && (!model.isDemo);
		var menuConfig = {
			aiUrl: '/ai/' + site.name,
			labels: {ai: 'AI', user: labels.user, admin: labels.admin, logout: labels.logout, account: labels.account},
			showAi: isDev && (!model.isDemo),
			userUrl: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, listingsUrl, '/user'),
			adminUrl: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.admin + 'sites', site.name),
			logoutUrl: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.login, '/logout'),
			accountUrl: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.accountSettings, site.name),
			isPinMeToAdmin: isPinMeToAdmin,
			hasAccountSettings: model.siteAccess.hasAccountSettings
		};
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigationWithChildren(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withChildren,
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
						$author$project$PinMeTo$Global$TopNavigation$UserSettingsMenu$view(menuConfig),
						$elm$html$Html$text(''))
					]),
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
					A2($author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent, model.app, 'Top Navigation - User Settings'),
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
						'navigation-UserSettings',
						A2(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faGear),
							$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(labels.userSettings))))));
	});
var $author$project$PinMeTo$Global$TopNavigation$Msg$OpenSupportTicket = {$: 'OpenSupportTicket'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$notEnabledToggled = $author$project$PinMeTo$Global$TopNavigation$Chat$NotEnabledToggled;
var $author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedOnNavigate = {$: 'NewsFeedOnNavigate'};
var $author$project$PinMeTo$Global$TopNavigation$Msg$ToggleIgnoredProductUpgrades = {$: 'ToggleIgnoredProductUpgrades'};
var $author$project$PinMeTo$Global$TopNavigation$Top$navigation_ = F4(
	function (desktopChatLauncher, labels, model, config) {
		var switchAccountNode = function () {
			var withIconOrImage = function () {
				var _v4 = model.siteProfile;
				if (_v4.$ === 'Just') {
					var href = _v4.a;
					return $author$project$PinMeTo$Global$TopNavigation$Navigation$withImage(href);
				} else {
					return $author$project$PinMeTo$Global$TopNavigation$Navigation$withFontAwesomeIcon(
						$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faHouse));
				}
			}();
			return (($elm$core$List$length(model.allSites) === 1) ? $author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden : $elm$core$Basics$identity)(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigationWithChildren(
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withChildren,
						_List_fromArray(
							[
								A2(
								$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
								A5($author$project$PinMeTo$Global$TopNavigation$Top$switchAccount, labels, model.app, config, model.siteFilter, model.sitesFiltered),
								$elm$html$Html$text(''))
							]),
						A2(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
							A2($author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent, model.app, 'Top Navigation - Switch Account'),
							A2(
								$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
								'navigation-switchAccount',
								withIconOrImage(
									$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(labels.switchAccount)))))));
		}();
		var helpMenuConfig = {
			labels: {helpCenter: labels.helpCenter, sendFeedback: labels.sendFeedBack},
			helpCenterUrl: 'https://pinmeto.crisp.help/',
			onSendFeedback: $author$project$PinMeTo$Global$TopNavigation$Chat$isEnabled(model.chat) ? $author$project$PinMeTo$Global$TopNavigation$Msg$OpenSupportTicket : $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg($author$project$PinMeTo$Global$TopNavigation$Chat$notEnabledToggled),
			helpCenterTracking: $elm$core$Maybe$Just(
				A2($author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent, model.app, 'Top Navigation - Help - Help Center')),
			sendFeedbackTracking: $elm$core$Maybe$Just(
				A2($author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent, model.app, 'Top Navigation - Help - Send Feedback'))
		};
		var maybeSiteName = A2(
			$elm$core$Maybe$map,
			function (_v3) {
				var site = _v3.a;
				return site.name;
			},
			model.selectedSite);
		var demoLauncher = function () {
			var icon = model.isDemo ? $author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faToggleOn) : $author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faToggleOff);
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__demo-launcher'),
						$elm$html$Html$Attributes$title('Demo mode'),
						$author$project$PinMeTo$Ui$DataTestAttribute$dataTestAttribute('navigation-demoToggle'),
						$elm$html$Html$Events$onClick($author$project$PinMeTo$Global$TopNavigation$Msg$ToggleDemo)
					]),
				_List_fromArray(
					[
						$author$project$FontAwesome$render(icon)
					]));
		}();
		var unseenNews = A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (latestArticleId, latestArticleSeen) {
						return _Utils_cmp(latestArticleId, latestArticleSeen) > 0;
					}),
				$author$project$PinMeTo$Global$NewsFeed$latestArticleId(model.newsFeed),
				model.newsFeedLatestSeen));
		var newsFeedNode = $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigationWithChildren(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withChildren,
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
						A2(
							$author$project$PinMeTo$Global$NewsFeed$render,
							model.newsFeed,
							$author$project$PinMeTo$Global$NewsFeed$view(
								{
									app: function () {
										var _v2 = model.app;
										switch (_v2.$) {
											case 'Listings':
												return $elm$core$Maybe$Just($author$project$PinMeTo$Global$NewsFeed$Listings);
											case 'ListenAndRespond':
												return $elm$core$Maybe$Just($author$project$PinMeTo$Global$NewsFeed$Conversations);
											case 'LocationPosts':
												return $elm$core$Maybe$Just($author$project$PinMeTo$Global$NewsFeed$Posts);
											case 'Champion':
												return $elm$core$Maybe$Just($author$project$PinMeTo$Global$NewsFeed$Places);
											default:
												return $elm$core$Maybe$Nothing;
										}
									}(),
									title: labels.news,
									siteName: A2($elm$core$Maybe$withDefault, '', maybeSiteName),
									onNavigate: $author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedOnNavigate,
									siteAccess: model.siteAccess,
									newsFeedLatestSeen: A2($elm$core$Maybe$withDefault, 0, model.newsFeedLatestSeen)
								})),
						$elm$html$Html$text(''))
					]),
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
					A2($author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent, model.app, 'Top Navigation - News Feed'),
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
						'news-page',
						(unseenNews ? $author$project$PinMeTo$Global$TopNavigation$Navigation$withBadge($author$project$PinMeTo$Global$TopNavigation$Navigation$New) : $elm$core$Basics$identity)(
							A2(
								$author$project$PinMeTo$Global$TopNavigation$Navigation$withOnClick,
								$author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedOnOpen,
								A2(
									$author$project$PinMeTo$Global$TopNavigation$Navigation$withFontAwesomeIcon,
									$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faNewspaper),
									A2(
										$author$project$PinMeTo$Global$TopNavigation$Navigation$withClass,
										'pmt-global-top-navigation__news-feed',
										$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(labels.news)))))))));
		var isMobile = function (_v1) {
			var navState = _v1.a;
			return navState.isMobile;
		};
		var helpNode = $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigationWithChildren(
			A2(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withChildren,
				_List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
						$author$project$PinMeTo$Global$TopNavigation$HelpMenu$view(helpMenuConfig),
						$elm$html$Html$text(''))
					]),
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withTrackingEvent,
					A2($author$project$PinMeTo$Global$TopNavigation$Top$appTrackingEvent, model.app, 'Top Navigation - Help'),
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withDataTestAttribute,
						'navigation-support',
						A2(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$withFontAwesomeIcon,
							$author$project$FontAwesome$regular($author$project$FontAwesome$Regular$Icon$faCircleQuestion),
							$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(labels.help))))));
		var isCs = A2($author$project$PinMeTo$Permissions$hasRole, model.permissions, $author$project$PinMeTo$Permissions$CustomerSuccess);
		return _List_fromArray(
			[
				(isMobile(model.navigationState) ? $author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden : $elm$core$Basics$identity)(
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
					desktopChatLauncher,
					$elm$html$Html$text(''))),
				(isMobile(model.navigationState) ? $author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden : $elm$core$Basics$identity)(newsFeedNode),
				helpNode,
				function () {
				var siteName = A2($elm$core$Maybe$withDefault, '', maybeSiteName);
				return $author$project$PinMeTo$Global$TopNavigation$ProductSwitcher$view(
					{
						app: model.app,
						site: {
							name: siteName,
							listenRespondProduct: A2(
								$elm$core$Maybe$withDefault,
								$author$project$PinMeTo$Global$TopNavigation$Model$All,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										var site = _v0.a;
										return site.listenRespond.product;
									},
									model.selectedSite))
						},
						urls: {
							locator: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, siteName + '/locator-intro'),
							champion: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.champion, siteName),
							listings: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, siteName),
							aiVisibility: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.aiVisibility, 'login-link/' + siteName),
							userSettings: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, siteName + '/user'),
							locationPosts: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.locationPosts, siteName),
							localCampaigns: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listings, siteName + '/local-campaigns-intro'),
							listenAndRespond: A2($author$project$PinMeTo$Global$TopNavigation$Top$concatUrl, config.baseUrls.listenAndRespond, siteName)
						},
						isDemo: model.isDemo,
						labels: {productInfo: labels.productInfo, switchProduct: labels.switchProduct},
						siteAccess: model.siteAccess,
						permissions: model.permissions,
						trackingEventPrefix: $author$project$PinMeTo$Global$TopNavigation$Top$appToString(model.app),
						ignoredProductUpgrades: model.ignoredProductUpgrades,
						onToggleIgnoredUpgrades: $author$project$PinMeTo$Global$TopNavigation$Msg$ToggleIgnoredProductUpgrades,
						showIgnoredProductUpgrades: model.showIgnoredProductUpgrades
					});
			}(),
				switchAccountNode,
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigation(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode(''))),
				A2(
					$elm$core$Maybe$map,
					A3($author$project$PinMeTo$Global$TopNavigation$Top$userSettingsNode, labels, model, config),
					A2(
						$elm_community$maybe_extra$Maybe$Extra$or,
						model.selectedSite,
						$elm$core$List$head(model.allSites)))),
				(isCs ? $elm$core$Basics$identity : $author$project$PinMeTo$Global$TopNavigation$Navigation$withVisibilityHidden)(
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$addHtmlNode,
					demoLauncher,
					$elm$html$Html$text('')))
			]);
	});
var $author$project$PinMeTo$Global$TopNavigation$Top$navigation = F3(
	function (desktopChatLauncher, labels, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A3($author$project$PinMeTo$Global$TopNavigation$Top$navigation_, desktopChatLauncher, labels, model),
				model.config));
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailShown = {$: 'InitFailShown'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$isFailShown = function (_v0) {
	var s = _v0.a;
	return _Utils_eq(s.initState, $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailShown);
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withTopNavigation = F2(
	function (xs, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Global$TopNavigation$Navigation$Config(
			_Utils_update(
				config,
				{topNavigation: xs}));
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$notEnabledLightbox = F2(
	function (_v0, labels) {
		var s = _v0.a;
		return s.notEnabledOpen ? $author$project$PinMeTo$Ui$Lightbox$render(
			A2(
				$author$project$PinMeTo$Ui$Lightbox$withStyle,
				$author$project$PinMeTo$Ui$Lightbox$AlertStyle,
				A2(
					$author$project$PinMeTo$Ui$Lightbox$withClose,
					$author$project$PinMeTo$Global$TopNavigation$Chat$NotEnabledToggled,
					$author$project$PinMeTo$Ui$Lightbox$view(
						{
							title: labels.title,
							content: A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('chat-fail-alert')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(labels.body)
											]))
									]))
						})))) : $elm$html$Html$text('');
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$FailLightboxToggled = {$: 'FailLightboxToggled'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$failLightboxToggled = $author$project$PinMeTo$Global$TopNavigation$Chat$FailLightboxToggled;
var $author$project$PinMeTo$Global$TopNavigation$Msg$SupportTicketMessage = function (a) {
	return {$: 'SupportTicketMessage', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$envBanner = F2(
	function (demoMode, maybeEnv) {
		var demoModeText = 'Demo Mode';
		var productionBannerView = demoMode ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__env-banner'),
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__env-banner--demo-mode')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__env-banner-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(demoModeText)
						]))
				])) : $elm$html$Html$text('');
		var bannerView = function (env) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-global-top-navigation__env-banner'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pmt-global-top-navigation__env-banner--dev',
								_Utils_eq(env, $author$project$PinMeTo$Global$TopNavigation$Config$Dev))
							])),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pmt-global-top-navigation__env-banner--test',
								_Utils_eq(env, $author$project$PinMeTo$Global$TopNavigation$Config$Test))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-global-top-navigation__env-banner-label')
							]),
						_List_fromArray(
							[
								_Utils_eq(env, $author$project$PinMeTo$Global$TopNavigation$Config$Test) ? $elm$html$Html$text(
								'PinMeTo Test Environment' + (demoMode ? (' | ' + demoModeText) : '')) : $elm$html$Html$text(
								demoMode ? ('Developers | ' + demoModeText) : 'Developers, developers, developers')
							]))
					]));
		};
		if (maybeEnv.$ === 'Just') {
			switch (maybeEnv.a.$) {
				case 'Dev':
					var _v1 = maybeEnv.a;
					return bannerView($author$project$PinMeTo$Global$TopNavigation$Config$Dev);
				case 'Test':
					var _v2 = maybeEnv.a;
					return bannerView($author$project$PinMeTo$Global$TopNavigation$Config$Test);
				case 'Production':
					var _v3 = maybeEnv.a;
					return productionBannerView;
				default:
					var _v4 = maybeEnv.a;
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Hover = function (a) {
	return {$: 'Hover', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$iconToText = F2(
	function (attrs, icon) {
		if (icon.$ === 'Nothing') {
			return $elm$html$Html$text('');
		} else {
			switch (icon.a.$) {
				case 'Svg':
					var i = icon.a.a;
					return A2(
						$elm$html$Html$span,
						attrs,
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Icon$render(i)
							]));
				case 'FontAwesome':
					var i = icon.a.a;
					return A2(
						$elm$html$Html$span,
						attrs,
						_List_fromArray(
							[
								$author$project$FontAwesome$render(i)
							]));
				default:
					var href = icon.a.a;
					return A2(
						$elm$html$Html$span,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__img-icon'),
							attrs),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(href)
									]),
								_List_Nil)
							]));
			}
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$toIcon = F2(
	function (attrs, navigation) {
		if (navigation.$ === 'HtmlItem') {
			return A2($author$project$PinMeTo$Global$TopNavigation$Navigation$iconToText, attrs, $elm$core$Maybe$Nothing);
		} else {
			var x = navigation.b;
			return A2($author$project$PinMeTo$Global$TopNavigation$Navigation$iconToText, attrs, x.icon);
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withModBEM = F2(
	function (className, modifiersBem) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (mod, acc) {
					return acc + (' ' + (className + ('--' + mod)));
				}),
			className,
			modifiersBem);
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$targetToText = function (t) {
	switch (t.$) {
		case 'Empty':
			return _List_Nil;
		case 'Blank':
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$rel('norefferer noopener')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$target('_self')
				]);
	}
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$toLink = F5(
	function (innerHtml, modifiersBEM, hover, onClickMsg, navigation) {
		var addTracking = F2(
			function (trackingEvent, attribs) {
				if (trackingEvent.$ === 'Just') {
					var event = trackingEvent.a.a;
					return A2(
						$elm$core$List$cons,
						$author$project$PinMeTo$Ui$Metrics$click(event),
						A2(
							$elm$core$List$cons,
							$author$project$PinMeTo$Ui$Metrics$weight(5),
							attribs));
				} else {
					return attribs;
				}
			});
		var toUrl = F2(
			function (_v5, trackingEvent) {
				var dataTestAttribute = _v5.a;
				return F2(
					function (extraClass, _v3) {
						var target = _v3.a;
						var u = _v3.b;
						return A2(
							$elm$html$Html$a,
							A2(
								addTracking,
								trackingEvent,
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'link-' + dataTestAttribute),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$href(u),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class(
												A2($author$project$PinMeTo$Global$TopNavigation$Navigation$withModBEM, 'pmt-global-top-navigation__link', modifiersBEM) + (' ' + extraClass)),
											_Utils_ap(
												$author$project$PinMeTo$Global$TopNavigation$Navigation$targetToText(target),
												A3(
													$elm_community$maybe_extra$Maybe$Extra$unwrap,
													_List_Nil,
													function (_v4) {
														var x = _v4.a;
														return _List_fromArray(
															[
																$elm$html$Html$Attributes$title(x)
															]);
													},
													hover)))))),
							innerHtml);
					});
			});
		var toBtn = F2(
			function (_v2, trackingEvent) {
				var dataTestAttribute = _v2.a;
				return function (extraClass) {
					return A2(
						$elm$html$Html$button,
						A2(
							addTracking,
							trackingEvent,
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'button-' + dataTestAttribute),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onClick(onClickMsg),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class(
											A2($author$project$PinMeTo$Global$TopNavigation$Navigation$withModBEM, 'pmt-global-top-navigation__button', modifiersBEM) + (' ' + extraClass)),
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											_List_Nil,
											function (_v1) {
												var x = _v1.a;
												return _List_fromArray(
													[
														$elm$html$Html$Attributes$title(x)
													]);
											},
											hover))))),
						innerHtml);
				};
			});
		var toElement = function (x) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				A3(toBtn, x.dataTestAttribute, x.trackingEvent, x._class),
				A3(toUrl, x.dataTestAttribute, x.trackingEvent, x._class),
				x.url);
		};
		if (navigation.$ === 'HtmlItem') {
			return A3(
				toBtn,
				$author$project$PinMeTo$Ui$DataTestAttribute$DataTestAttribute('something'),
				$elm$core$Maybe$Nothing,
				'');
		} else {
			var x = navigation.b;
			return toElement(x);
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$toBadge = function (navigation) {
	if (navigation.$ === 'HtmlItem') {
		return $elm$html$Html$text('');
	} else {
		var x = navigation.b;
		var _v1 = x.badge;
		if (_v1.$ === 'Just') {
			var _v2 = _v1.a;
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('badge badge--new')
					]),
				_List_Nil);
		} else {
			return $elm$html$Html$text('');
		}
	}
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$ToggleRoot = F2(
	function (a, b) {
		return {$: 'ToggleRoot', a: a, b: b};
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$titleToString = function (_v0) {
	var s = _v0.a;
	return s;
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$titleToText = F2(
	function (attrs, navigation) {
		var titleWithStatus = function (item) {
			return $elm$html$Html$text(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$titleToString(item.title));
		};
		if (navigation.$ === 'HtmlItem') {
			return $elm$html$Html$text('');
		} else {
			var x = navigation.b;
			var _v1 = x.html;
			if (_v1.$ === 'Just') {
				var html = _v1.a;
				return html;
			} else {
				return A2(
					$elm$html$Html$span,
					attrs,
					_List_fromArray(
						[
							titleWithStatus(x)
						]));
			}
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$OnTopNavigationClick = function (a) {
	return {$: 'OnTopNavigationClick', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$renderTopNavigation = F3(
	function (_v0, tagger, items) {
		var model = _v0.a;
		var render = F3(
			function (depth, extraCss, children) {
				var css_ = _List_fromArray(
					[
						_Utils_Tuple2('pmt-global-top-navigation__top--sub-container', true),
						_Utils_Tuple2(
						' pmt-global-top-navigation__top--LEVEL_' + $elm$core$String$fromInt(depth),
						true),
						A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_Utils_Tuple2('', false),
						function (x) {
							return _Utils_Tuple2(
								x,
								$elm$core$List$length(children) > 0);
						},
						extraCss)
					]);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(css_)
						]),
					A2(
						$elm$core$List$map,
						function (navigation) {
							if (navigation.$ === 'Item') {
								var xs = navigation.c;
								return A3(renderItem, depth + 0, navigation, xs);
							} else {
								var expanded = navigation.b;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[expanded]));
							}
						},
						children));
			});
		var renderItem = F3(
			function (depth, navigation, children) {
				var hasChildren = $elm$core$List$length(children) > 0;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'pmt-global-top-navigation__top--item-wrapper pmt-global-top-navigation__top--LEVEL_' + $elm$core$String$fromInt(depth))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-global-top-navigation__top--item')
								]),
							_List_fromArray(
								[
									A5(
									$author$project$PinMeTo$Global$TopNavigation$Navigation$toLink,
									_List_fromArray(
										[
											A2(
											$author$project$PinMeTo$Global$TopNavigation$Navigation$toIcon,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-global-top-navigation__icon')
												]),
											navigation),
											A2(
											$author$project$PinMeTo$Global$TopNavigation$Navigation$titleToText,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('pmt-global-top-navigation__title', true),
															_Utils_Tuple2('pmt-global-top-navigation__top--title-has-children', hasChildren)
														]))
												]),
											navigation)
										]),
									_List_Nil,
									$elm$core$Maybe$Nothing,
									tagger(
										$author$project$PinMeTo$Global$TopNavigation$Navigation$OnTopNavigationClick(navigation)),
									navigation),
									hasChildren ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-global-top-navigation__top--sub-navigation')
										]),
									_List_fromArray(
										[
											A3(render, depth + 1, $elm$core$Maybe$Nothing, children)
										])) : $elm$html$Html$text('')
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__top--root')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, nav) {
						var classFromItem = function () {
							if (nav.$ === 'HtmlItem') {
								return '';
							} else {
								var x = nav.b;
								return x._class;
							}
						}();
						var isOpen_ = _Utils_eq(
							model.activeTopNavigationIndex,
							$elm$core$Maybe$Just(index));
						var topMenuModifiersBEM = isOpen_ ? _List_fromArray(
							['top-menu', 'selected']) : _List_fromArray(
							['top-menu']);
						var renderTheItem = F2(
							function (navigation, children) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-global-top-navigation__top--navigation'),
											$elm$html$Html$Attributes$class(classFromItem),
											$elm$html$Html$Attributes$id('pmt-global-top-navigation__top--navigation')
										]),
									_List_fromArray(
										[
											A5(
											$author$project$PinMeTo$Global$TopNavigation$Navigation$toLink,
											_List_fromArray(
												[
													A2($author$project$PinMeTo$Global$TopNavigation$Navigation$toIcon, _List_Nil, nav),
													$author$project$PinMeTo$Global$TopNavigation$Navigation$toBadge(nav)
												]),
											topMenuModifiersBEM,
											$elm$core$Maybe$Just(
												$author$project$PinMeTo$Global$TopNavigation$Navigation$Hover(
													$author$project$PinMeTo$Global$TopNavigation$Navigation$titleToString(navigation.title))),
											tagger(
												A2($author$project$PinMeTo$Global$TopNavigation$Navigation$ToggleRoot, index, nav)),
											nav),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('pmt-global-top-navigation__menu', true),
															_Utils_Tuple2('pmt-global-top-navigation__top-dropdown-container', true),
															_Utils_Tuple2('pmt-global-top-navigation__top-dropdown-container--selected', isOpen_)
														]))
												]),
											_List_fromArray(
												[
													A3(
													render,
													1,
													$elm$core$Maybe$Just('pmt-global-top-navigation__top--selected'),
													children)
												]))
										]));
							});
						_v1$2:
						while (true) {
							if (nav.$ === 'Item') {
								if (nav.a.$ === 'Visible') {
									var _v2 = nav.a;
									var n = nav.b;
									var children = nav.c;
									return A2(renderTheItem, n, children);
								} else {
									break _v1$2;
								}
							} else {
								if (nav.a.$ === 'Visible') {
									var _v3 = nav.a;
									var expanded = nav.b;
									return expanded;
								} else {
									break _v1$2;
								}
							}
						}
						return $elm$html$Html$text('');
					}),
				items));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Expanded = {$: 'Expanded'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$ExpandRight = {$: 'ExpandRight'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$CollapseRight = {$: 'CollapseRight'};
var $author$project$FontAwesome$Solid$Icon$faEllipsisVertical = $author$project$FontAwesome$Solid$Icon$Icon('fa-solid fa-ellipsis-vertical');
var $author$project$FontAwesome$Solid$faEllipsisVertical = $author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faEllipsisVertical);
var $author$project$PinMeTo$Global$TopNavigation$Navigation$renderMobileSideToggle = F4(
	function (sideBar, tagger, open, close) {
		var event = function () {
			if (sideBar.$ === 'Collapsed') {
				return open;
			} else {
				return close;
			}
		}();
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__mobile_side_toggle'),
					$elm$html$Html$Events$onClick(
					tagger(event)),
					$elm$html$Html$Attributes$type_('button')
				]),
			_List_fromArray(
				[$author$project$FontAwesome$Solid$faEllipsisVertical]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Empty = {$: 'Empty'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$withUrl = F2(
	function (url, x) {
		return _Utils_update(
			x,
			{
				url: $elm$core$Maybe$Just(
					A2($author$project$PinMeTo$Global$TopNavigation$Navigation$Url, $author$project$PinMeTo$Global$TopNavigation$Navigation$Empty, url))
			});
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$switchAccountNode = F3(
	function (isMobile, tagger, navigation) {
		var verify = function (navItem) {
			return (isMobile && ($author$project$PinMeTo$Global$TopNavigation$Navigation$titleToString(navItem.title) === 'Switch Account')) ? $author$project$PinMeTo$Global$TopNavigation$Navigation$toNavigation(
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withOnClick,
					tagger(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$OnTopNavigationClick(navigation)),
					A2(
						$author$project$PinMeTo$Global$TopNavigation$Navigation$withUrl,
						'/switch-accounts',
						$author$project$PinMeTo$Global$TopNavigation$Navigation$addNode('Switch Account')))) : navigation;
		};
		if (navigation.$ === 'Item') {
			var navItem = navigation.b;
			return verify(navItem);
		} else {
			return navigation;
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$renderRightSideNavigation = F3(
	function (_v0, tagger, items) {
		var model = _v0.a;
		var renderItem = F2(
			function (navigation, children) {
				var childItems = ($elm$core$List$length(children) > 0) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (n) {
							_v6$2:
							while (true) {
								if (n.$ === 'Item') {
									if (n.a.$ === 'Visible') {
										var _v7 = n.a;
										return A5(
											$author$project$PinMeTo$Global$TopNavigation$Navigation$toLink,
											_List_fromArray(
												[
													A2($author$project$PinMeTo$Global$TopNavigation$Navigation$titleToText, _List_Nil, n)
												]),
											_List_fromArray(
												['pmt-global-top-navigation__global_navigation--item']),
											$elm$core$Maybe$Nothing,
											tagger(
												$author$project$PinMeTo$Global$TopNavigation$Navigation$OnTopNavigationClick(n)),
											n);
									} else {
										break _v6$2;
									}
								} else {
									if (n.a.$ === 'Visible') {
										var _v8 = n.a;
										var expanded = n.b;
										return expanded;
									} else {
										break _v6$2;
									}
								}
							}
							return $elm$html$Html$text('');
						},
						children)) : $elm$html$Html$text('');
				var navItem = function () {
					var _v4 = navigation.url;
					if (_v4.$ === 'Just') {
						var _v5 = _v4.a;
						var target = _v5.a;
						var u = _v5.b;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(u)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$PinMeTo$Global$TopNavigation$Navigation$titleToString(navigation.title))
								]));
					} else {
						return $elm$html$Html$text(
							$author$project$PinMeTo$Global$TopNavigation$Navigation$titleToString(navigation.title));
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__global_navigation--item-group')
						]),
					_List_fromArray(
						[navItem, childItems]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pmt-global-top-navigation__global_navigation', true),
							_Utils_Tuple2(
							'pmt-global-top-navigation__global_navigation--expanded',
							_Utils_eq(model.rightSideBarState, $author$project$PinMeTo$Global$TopNavigation$Navigation$Expanded))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-global-top-navigation__global_navigation--items')
						]),
					A2(
						$elm$core$List$map,
						function (nav) {
							_v1$2:
							while (true) {
								if (nav.$ === 'HtmlItem') {
									if (nav.a.$ === 'Visible') {
										var _v2 = nav.a;
										var expanded = nav.b;
										return expanded;
									} else {
										break _v1$2;
									}
								} else {
									if (nav.a.$ === 'Visible') {
										var _v3 = nav.a;
										var n = nav.b;
										var children = nav.c;
										return A2(renderItem, n, children);
									} else {
										break _v1$2;
									}
								}
							}
							return $elm$html$Html$text('');
						},
						A2(
							$elm$core$List$map,
							function (n) {
								return A3($author$project$PinMeTo$Global$TopNavigation$Navigation$switchAccountNode, model.isMobile, tagger, n);
							},
							items)))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$renderTopMobileNavigation = F4(
	function (_v0, tagger, chatLauncher, items) {
		var model = _v0.a;
		var overlay = _Utils_eq(model.rightSideBarState, $author$project$PinMeTo$Global$TopNavigation$Navigation$Expanded) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__overlay')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-global-top-navigation__top-mobile')
				]),
			_List_fromArray(
				[
					chatLauncher(true),
					A4($author$project$PinMeTo$Global$TopNavigation$Navigation$renderMobileSideToggle, model.rightSideBarState, tagger, $author$project$PinMeTo$Global$TopNavigation$Navigation$ExpandRight, $author$project$PinMeTo$Global$TopNavigation$Navigation$CollapseRight),
					A3(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$renderRightSideNavigation,
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(model),
					tagger,
					items),
					overlay
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$viewTopNavigationWithLeading = F7(
	function (demoMode, _v0, maybeEnv, _v1, toMsg, leading, _v2) {
		var model = _v0.a;
		var config = _v2.a;
		var innerContent = model.isMobile ? A4(
			$author$project$PinMeTo$Global$TopNavigation$Navigation$renderTopMobileNavigation,
			$author$project$PinMeTo$Global$TopNavigation$Navigation$State(model),
			config.tagger,
			config.chatLauncher,
			config.topNavigation) : A3(
			$author$project$PinMeTo$Global$TopNavigation$Navigation$renderTopNavigation,
			$author$project$PinMeTo$Global$TopNavigation$Navigation$State(model),
			config.tagger,
			config.topNavigation);
		var barRow = function () {
			if (leading.$ === 'Nothing') {
				return A2($elm$html$Html$map, toMsg, innerContent);
			} else {
				var slot = leading.a;
				var wrapperClass = model.isMobile ? 'pmt-global-top-navigation__top-mobile--with-slot' : 'pmt-global-top-navigation__top--with-slot';
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(wrapperClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-global-top-navigation__slot')
								]),
							_List_fromArray(
								[slot])),
							A2($elm$html$Html$map, toMsg, innerContent)
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('pmt-ui-nav__top'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pmt-global-top-navigation pmt-global-top-navigation__top', true),
									_Utils_Tuple2('pmt-global-top-navigation--mobile', model.isMobile)
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$PinMeTo$Global$TopNavigation$Navigation$envBanner, demoMode, maybeEnv),
							barRow
						]))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$render = function (_v0) {
	var leadingContent = _v0.a.leadingContent;
	var state = _v0.a.state;
	var labels = _v0.a.labels;
	var tagger = _v0.a.tagger;
	var _v1 = state;
	var model = _v1.a;
	var chatLauncher = function (launcherIsMobile) {
		return A2(
			$elm$html$Html$map,
			$author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg,
			$author$project$PinMeTo$Global$TopNavigation$Chat$launcher(
				{
					title: labels.chat,
					enabled: $author$project$PinMeTo$Global$TopNavigation$Chat$isEnabled(model.chat),
					isMobile: launcherIsMobile
				}));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A7(
				$author$project$PinMeTo$Global$TopNavigation$Navigation$viewTopNavigationWithLeading,
				model.isDemo,
				model.navigationState,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.env;
					},
					model.config),
				labels,
				tagger,
				leadingContent,
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$withTopNavigation,
					A3(
						$author$project$PinMeTo$Global$TopNavigation$Top$navigation,
						chatLauncher(false),
						labels,
						model),
					$author$project$PinMeTo$Global$TopNavigation$topNavigation(chatLauncher))),
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Msg$SupportTicketMessage, tagger),
				A2($author$project$PinMeTo$Global$SupportTicket$render, labels.supportTicket, model.uiSupportModel)),
				A2(
				$elm$html$Html$map,
				tagger,
				A3(
					$author$project$PinMeTo$Global$TopNavigation$ChatFailAlert$render,
					labels.chatFailAlert,
					$author$project$PinMeTo$Global$TopNavigation$Chat$isFailShown(model.chat),
					$author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg($author$project$PinMeTo$Global$TopNavigation$Chat$failLightboxToggled))),
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg, tagger),
				A2(
					$author$project$PinMeTo$Global$TopNavigation$Chat$notEnabledLightbox,
					model.chat,
					{body: labels.contactSupportBody, title: labels.contactSupportTitle}))
			]));
};
var $author$project$PinMeTo$Global$TopNavigation$View = function (a) {
	return {$: 'View', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$viewWith = F3(
	function (tagger, labels, state) {
		return $author$project$PinMeTo$Global$TopNavigation$View(
			{state: state, labels: labels, tagger: tagger, leadingContent: $elm$core$Maybe$Nothing});
	});
var $author$project$PinMeTo$Global$TopNavigation$view = F3(
	function (tagger, labels, state) {
		return $author$project$PinMeTo$Global$TopNavigation$render(
			A3($author$project$PinMeTo$Global$TopNavigation$viewWith, tagger, labels, state));
	});
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$FontAwesome$Light$Icon$faUser = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-user');
var $author$project$Translations$UserSettings$Navigation$profile = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.profile');
};
var $author$project$Translations$UserSettings$Navigation$language = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.language');
};
var $author$project$Translations$UserSettings$Navigation$security = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.security');
};
var $author$project$FontAwesome$Light$Icon$faEnvelope = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-envelope');
var $author$project$FontAwesome$Light$Icon$faLanguage = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-language');
var $author$project$FontAwesome$Light$Icon$faFileLines = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-file-lines');
var $author$project$Translations$UserSettings$Navigation$subscriptions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.subscriptions');
};
var $author$project$FontAwesome$Light$Icon$faShieldHalved = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-shield-halved');
var $author$project$Translations$UserSettings$Navigation$legalDocuments = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.legal_documents');
};
var $author$project$FontAwesome$Light$Icon$faBell = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-bell');
var $author$project$PinMeTo$Ui$Icon$PostsGray = {$: 'PostsGray'};
var $author$project$Translations$UserSettings$Navigation$notifications = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.notifications');
};
var $author$project$PinMeTo$Ui$Icon$ConversationsGray = {$: 'ConversationsGray'};
var $author$project$UserSettings$Main$notificationsTab = F2(
	function (model, siteName) {
		var checkIfHasConversations = model.accountAccess.hasListenAndRespond;
		var checkIfHasPosts = model.accountAccess.hasSocialMedia;
		var isTester = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.id;
					},
					model.user)),
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$Just,
				_List_fromArray(
					[
						$author$project$PinMeTo$Global$TopNavigation$Model$UserId('9ce27b94ff2d4b5da5e7d9087624c669'),
						$author$project$PinMeTo$Global$TopNavigation$Model$UserId('8d27cc7610934f89b19b9ed4baf5173e')
					])));
		var checkIfHasPlacesAI = model.accountAccess.hasListings || isTester;
		var products = _List_fromArray(
			[
				{icon: $author$project$PinMeTo$Ui$Icon$ConversationsGray, name: 'Conversations', path: 'notifications', enabled: checkIfHasConversations},
				{icon: $author$project$PinMeTo$Ui$Icon$PostsGray, name: 'Posts', path: 'notifications-posts', enabled: checkIfHasPosts},
				{icon: $author$project$PinMeTo$Ui$Icon$AppIconPlaces, name: 'Places AI', path: 'notifications-places-ai', enabled: checkIfHasPlacesAI}
			]);
		var productsFiltered = A2(
			$elm$core$List$filter,
			function (x) {
				return x.enabled;
			},
			products);
		var path = function (x) {
			return '/listings/' + (siteName + ('/user/' + x));
		};
		var getProductPath = function () {
			var _v1 = $elm$core$List$head(productsFiltered);
			if (_v1.$ === 'Just') {
				var a = _v1.a;
				return path(a.path);
			} else {
				return path('');
			}
		}();
		var link = function (item) {
			return A2(
				$author$project$PinMeTo$Ui$Navigation$activeIf,
				item.enabled,
				A2(
					$author$project$PinMeTo$Ui$Navigation$withIcon,
					item.icon,
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						item.name,
						path(item.path))));
		};
		var productsNavigation = A2($elm$core$List$map, link, productsFiltered);
		var withChild = A2(
			$author$project$PinMeTo$Ui$Navigation$withChildren,
			productsNavigation,
			A2(
				$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
				$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faBell),
				A2(
					$author$project$PinMeTo$Ui$Navigation$link,
					$author$project$Translations$UserSettings$Navigation$notifications(model.translations),
					path('notifications'))));
		var _v0 = $elm$core$List$length(productsFiltered);
		switch (_v0) {
			case 1:
				return _List_fromArray(
					[
						A2(
						$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
						$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faBell),
						A2(
							$author$project$PinMeTo$Ui$Navigation$link,
							$author$project$Translations$UserSettings$Navigation$notifications(model.translations),
							getProductPath))
					]);
			case 0:
				return _List_Nil;
			default:
				return _List_fromArray(
					[withChild]);
		}
	});
var $author$project$UserSettings$Main$navigation = F2(
	function (model, _v0) {
		var site = _v0.a;
		var path = function (x) {
			return '/listings/' + (site.name + ('/user/' + x));
		};
		var link = F3(
			function (label, path_, icon) {
				return A2(
					$author$project$PinMeTo$Ui$Navigation$withFontAwesomeIcon,
					$author$project$FontAwesome$light(icon),
					A2(
						$author$project$PinMeTo$Ui$Navigation$link,
						label,
						path(path_)));
			});
		return _Utils_ap(
			_List_fromArray(
				[
					A3(
					link,
					$author$project$Translations$UserSettings$Navigation$profile(model.translations),
					'profile',
					$author$project$FontAwesome$Light$Icon$faUser),
					A3(
					link,
					$author$project$Translations$UserSettings$Navigation$subscriptions(model.translations),
					'email-notifications',
					$author$project$FontAwesome$Light$Icon$faEnvelope)
				]),
			_Utils_ap(
				A2($author$project$UserSettings$Main$notificationsTab, model, site.name),
				_Utils_ap(
					_List_fromArray(
						[
							A3(
							link,
							$author$project$Translations$UserSettings$Navigation$legalDocuments(model.translations),
							'legal',
							$author$project$FontAwesome$Light$Icon$faFileLines),
							A3(
							link,
							$author$project$Translations$UserSettings$Navigation$language(model.translations),
							'language',
							$author$project$FontAwesome$Light$Icon$faLanguage)
						]),
					$author$project$UserSettings$Main$showChangePassword(site.authenticationType) ? _List_fromArray(
						[
							A3(
							link,
							$author$project$Translations$UserSettings$Navigation$security(model.translations),
							'change-password',
							$author$project$FontAwesome$Light$Icon$faShieldHalved)
						]) : _List_Nil)));
	});
var $author$project$Translations$UserSettings$LegalDocuments$view = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.legal_documents.view');
};
var $author$project$UserSettings$Legal$shortDate = $author$project$Common$Date$dateShort;
var $author$project$Translations$UserSettings$LegalDocuments$acceptedAtCustom = F4(
	function (translations, nonPlaceholderLift, displayName, shortDate) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'user_settings.legal_documents.accepted_at',
			_List_fromArray(
				[
					_Utils_Tuple2(' displayName ', displayName),
					_Utils_Tuple2(' shortDate ', shortDate)
				]));
	});
var $author$project$Translations$UserSettings$LegalDocuments$acceptedLegalDocuments = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.legal_documents.accepted_legal_documents');
};
var $author$project$UserSettings$Legal$viewDocuments = F3(
	function (documents, model, _v0) {
		var url = _v0.a;
		var doc = function (d) {
			var policyText = A4(
				$author$project$Translations$UserSettings$LegalDocuments$acceptedAtCustom,
				model.translations,
				$elm$html$Html$text,
				$elm$html$Html$text(d.displayName),
				$elm$html$Html$text(
					A2($author$project$UserSettings$Legal$shortDate, model.timeZone, d.when)));
			var toList = A2($elm$core$String$split, '/', url);
			var listLength = $elm$core$List$length(toList);
			var myUrl = $elm$core$String$concat(
				A2(
					$elm$core$List$intersperse,
					'/',
					A2($elm$core$List$take, listLength - 2, toList)));
			var viewDocumentUrl = myUrl + ('/listings/public/legal/' + (d.docType + ('/' + d.id)));
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list__item util__inset')
					]),
				_List_fromArray(
					[
						A2($elm$html$Html$span, _List_Nil, policyText),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(viewDocumentUrl),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
								$elm$html$Html$button,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fa-solid fa-eye')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'marginLeft', '0.5rem')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$UserSettings$LegalDocuments$view(model.translations))
											]))
									]))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$LegalDocuments$acceptedLegalDocuments(model.translations))),
					($elm$core$List$length(documents) > 0) ? A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list list--divided list--zebra')
						]),
					A2($elm$core$List$map, doc, documents)) : A2($elm$html$Html$div, _List_Nil, _List_Nil)
				]));
	});
var $author$project$UserSettings$Legal$view = F2(
	function (loginUrl, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.documents;
					switch (_v0.$) {
						case 'Suspended':
							return $elm$html$Html$text('');
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinner;
						case 'Loaded':
							var d = _v0.a;
							return A3($author$project$UserSettings$Legal$viewDocuments, d, model, loginUrl);
						default:
							var e = _v0.a;
							return $elm$html$Html$text(e);
					}
				}()
				]));
	});
var $author$project$PinMeTo$Ui$I18n$Locale$locales = _List_fromArray(
	[$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale, $author$project$PinMeTo$Ui$I18n$Locale$EnUs, $author$project$PinMeTo$Ui$I18n$Locale$EnGb, $author$project$PinMeTo$Ui$I18n$Locale$Fr, $author$project$PinMeTo$Ui$I18n$Locale$De, $author$project$PinMeTo$Ui$I18n$Locale$Es, $author$project$PinMeTo$Ui$I18n$Locale$SvSe, $author$project$PinMeTo$Ui$I18n$Locale$Fi, $author$project$PinMeTo$Ui$I18n$Locale$Pl, $author$project$PinMeTo$Ui$I18n$Locale$Pt]);
var $author$project$UserSettings$Language$Save = function (a) {
	return {$: 'Save', a: a};
};
var $author$project$Translations$General$saved = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.saved');
};
var $author$project$Translations$UserSettings$Language$byDefault = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.language.by_default');
};
var $author$project$UserSettings$Language$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$UserSettings$Language$SelectLocale = function (a) {
	return {$: 'SelectLocale', a: a};
};
var $author$project$Translations$UserSettings$Language$selectLocale = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.language.select_locale');
};
var $author$project$UserSettings$Language$SelectLanguage = function (a) {
	return {$: 'SelectLanguage', a: a};
};
var $author$project$Translations$UserSettings$Language$selectLanguage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.language.select_language');
};
var $author$project$PinMeTo$Ui$I18n$Locale$toHumanReadable = function (locale) {
	switch (locale.$) {
		case 'BrowserLocale':
			return 'Browser Locale';
		case 'EnUs':
			return 'English (USA)';
		case 'EnGb':
			return 'English (GB)';
		case 'Fr':
			return 'Français';
		case 'De':
			return 'Deutsch';
		case 'Es':
			return 'Español';
		case 'SvSe':
			return 'Svenska';
		case 'Fi':
			return 'Suomi';
		case 'Pl':
			return 'Polski';
		default:
			return 'Português';
	}
};
var $author$project$Translations$UserSettings$Language$yourLocaleChanges = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.language.your_locale_changes');
};
var $author$project$UserSettings$Language$viewSettings = F2(
	function (_v0, model) {
		var settings = _v0.settings;
		var locales = _v0.locales;
		var languages = _v0.languages;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section')
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = model.saveResult;
							switch (_v1.$) {
								case 'Loaded':
									return $author$project$PinMeTo$Ui$Alert$render(
										A2(
											$author$project$PinMeTo$Ui$Alert$withStatus,
											$author$project$PinMeTo$Ui$Alert$Success,
											$author$project$PinMeTo$Ui$Alert$plain(
												$author$project$Translations$General$saved(model.translations))));
								case 'Error':
									var e = _v1.a;
									return $author$project$PinMeTo$Ui$Alert$render(
										A2(
											$author$project$PinMeTo$Ui$Alert$withStatus,
											$author$project$PinMeTo$Ui$Alert$Error,
											$author$project$PinMeTo$Ui$Alert$plain(e)));
								case 'Suspended':
									return $elm$html$Html$text('');
								default:
									return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
							}
						}(),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$UserSettings$Language$yourLocaleChanges(model.translations)),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text(
									$author$project$Translations$UserSettings$Language$byDefault(model.translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$UserSettings$Language$selectLocale(model.translations)),
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$view(
										{
											uid: 'select-locale',
											items: locales,
											label: $elm$html$Html$text(
												$author$project$PinMeTo$Ui$I18n$Locale$toHumanReadable(settings.locale)),
											tagger: $author$project$UserSettings$Language$UiSelectMsg,
											onChange: $author$project$UserSettings$Language$SelectLocale,
											itemRender: A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$I18n$Locale$toHumanReadable, $elm$html$Html$text)
										}))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$UserSettings$Language$selectLanguage(model.translations)),
									A2(
									$author$project$PinMeTo$Ui$Select$render,
									model.uiSelect,
									$author$project$PinMeTo$Ui$Select$view(
										{
											uid: 'select-language',
											items: languages,
											label: $elm$html$Html$text(
												$author$project$PinMeTo$Ui$I18n$Language$toHumanReadable(settings.language)),
											tagger: $author$project$UserSettings$Language$UiSelectMsg,
											onChange: $author$project$UserSettings$Language$SelectLanguage,
											itemRender: function (l) {
												var langToString = $author$project$PinMeTo$Ui$I18n$Language$toHumanReadable(l.language);
												return l.internal ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'color', 'gray')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(langToString + ' - internal')
														])) : $elm$html$Html$text(langToString);
											}
										}))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-btn-group pmt-btn-group--basis-6')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$UserSettings$Language$Save(settings)),
									$elm$html$Html$Attributes$disabled(
									_Utils_eq(
										model.currentLocale,
										$elm$core$Maybe$Just(settings.locale)) && _Utils_eq(
										model.currentLanguage,
										$elm$core$Maybe$Just(settings.language)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$save(model.translations))
								]))
						]))
				]));
	});
var $author$project$PinMeTo$Ui$I18n$Language$languages = _List_fromArray(
	[$author$project$PinMeTo$Ui$I18n$Language$En, $author$project$PinMeTo$Ui$I18n$Language$Fr, $author$project$PinMeTo$Ui$I18n$Language$De, $author$project$PinMeTo$Ui$I18n$Language$Es, $author$project$PinMeTo$Ui$I18n$Language$Sv, $author$project$PinMeTo$Ui$I18n$Language$Fi, $author$project$PinMeTo$Ui$I18n$Language$Pl, $author$project$PinMeTo$Ui$I18n$Language$Pt]);
var $author$project$UserSettings$Language$getLanguageOptions = A2(
	$elm$core$List$map,
	function (l) {
		return {
			internal: function () {
				switch (l.$) {
					case 'En':
						return false;
					case 'De':
						return false;
					case 'Es':
						return false;
					case 'Fr':
						return false;
					case 'Pl':
						return false;
					case 'Pt':
						return false;
					default:
						return true;
				}
			}(),
			language: l
		};
	},
	$author$project$PinMeTo$Ui$I18n$Language$languages);
var $author$project$UserSettings$Language$view = F2(
	function (tagger, model) {
		var hasRole_ = function (role) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				false,
				function (x) {
					return A2($elm$core$List$member, role, x.systemRoles);
				},
				model.user);
		};
		var languageFilter = function (l) {
			return l.internal ? hasRole_($author$project$PinMeTo$Global$Model$SystemRole$PinMeTo) : true;
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$Navigation$language(model.translations))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section section--solid util__inset')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.settings;
							switch (_v0.$) {
								case 'Suspended':
									return $author$project$PinMeTo$Ui$Spinner$spinner;
								case 'Loading':
									return $author$project$PinMeTo$Ui$Spinner$spinner;
								case 'Error':
									return $author$project$PinMeTo$Ui$Alert$render(
										A2(
											$author$project$PinMeTo$Ui$Alert$withStatus,
											$author$project$PinMeTo$Ui$Alert$Error,
											$author$project$PinMeTo$Ui$Alert$plain(
												$author$project$Translations$General$updateError(model.translations))));
								default:
									var settings = _v0.a;
									return A2(
										$elm$html$Html$map,
										tagger,
										A2(
											$author$project$UserSettings$Language$viewSettings,
											{
												locales: $author$project$PinMeTo$Ui$I18n$Locale$locales,
												settings: settings,
												languages: A2($elm$core$List$filter, languageFilter, $author$project$UserSettings$Language$getLanguageOptions)
											},
											model));
							}
						}()
						]))
				]));
	});
var $author$project$Translations$UserSettings$Security$usingApp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.security.using_app');
};
var $author$project$Translations$UserSettings$Security$considerIt = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.security.consider_it');
};
var $author$project$Translations$UserSettings$Security$changePhone = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.security.change_phone');
};
var $author$project$Translations$UserSettings$Security$changePassword = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.security.change_password');
};
var $author$project$Translations$UserSettings$Security$twoStepVerification = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.security.two_step_verification');
};
var $author$project$Translations$UserSettings$Security$verificationWarningCustom = F3(
	function (translations, nonPlaceholderLift, considerItStyled) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'user_settings.security.verification_warning',
			_List_fromArray(
				[
					_Utils_Tuple2(' considerItStyled ', considerItStyled)
				]));
	});
var $author$project$UserSettings$ChangePassword$viewLogin = F5(
	function (_v0, config, translations, _v1, user) {
		var currentPath = _v1.a;
		var changePassText = $author$project$Translations$UserSettings$Security$changePassword(translations);
		var returnUrl = _Utils_ap(
			config.baseUrls.listings,
			A2(
				$elm$core$String$join,
				'/',
				A2(
					$elm$core$List$drop,
					2,
					A2($elm$core$String$split, '/', currentPath))));
		var loginUrl = config.baseUrls.login;
		var urlOtpEnable = loginUrl + ('otp/enable?returnUrl=' + returnUrl);
		var warningtext = A3(
			$author$project$Translations$UserSettings$Security$verificationWarningCustom,
			translations,
			$elm$html$Html$text,
			A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(urlOtpEnable),
								A2($elm$html$Html$Attributes$style, 'color', 'inherit')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$UserSettings$Security$considerIt(translations))
							]))
					])));
		var otpBanner = _Utils_eq(user.otp, $author$project$PinMeTo$Global$TopNavigation$Model$Enabled) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('status-bar status-bar--status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fa-solid fa-exclamation-circle')
						]),
					_List_Nil),
					A2($elm$html$Html$span, _List_Nil, warningtext)
				]));
		var changePhoneNumber = _Utils_eq(user.otp, $author$project$PinMeTo$Global$TopNavigation$Model$Enabled) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section section--solid')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$Security$twoStepVerification(translations))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									_Utils_eq(user.otpDelivery, $author$project$PinMeTo$Global$TopNavigation$Model$Sms) ? A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(urlOtpEnable)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$PinMeTo$Ui$Btn$pmtBtn,
											$elm$html$Html$button,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$UserSettings$Security$changePhone(translations))
												]))
										])) : $elm$html$Html$text(
									$author$project$Translations$UserSettings$Security$usingApp(translations))
								]))
						]))
				])) : $elm$html$Html$text('');
		var urlChangePassword = loginUrl + ('password/change?returnUrl=' + returnUrl);
		var changePassword = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section section--solid')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(changePassText)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(urlChangePassword),
											$elm$html$Html$Attributes$target('_self')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$PinMeTo$Ui$Btn$pmtBtn,
											$elm$html$Html$button,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(changePassText)
												]))
										]))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[otpBanner, changePassword, changePhoneNumber]));
	});
var $author$project$UserSettings$ChangePassword$view = F5(
	function (tagger, config, currentPath, model, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container modern')
				]),
			_List_fromArray(
				[
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$PinMeTo$Ui$Spinner$spinner,
					A4($author$project$UserSettings$ChangePassword$viewLogin, tagger, config, translations, currentPath),
					model)
				]));
	});
var $author$project$UserSettings$Profile$Model$Pick = {$: 'Pick'};
var $author$project$Translations$UserSettings$Profile$uploadPhoto = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.upload_photo');
};
var $author$project$UserSettings$Profile$Model$getUrl = function (_v0) {
	var url = _v0.a;
	return url;
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$UserSettings$Profile$Picture$renderImage = function (url) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('profile_image'),
				$elm$html$Html$Attributes$src(url),
				$elm$html$Html$Attributes$alt('')
			]),
		_List_Nil);
};
var $author$project$UserSettings$Profile$Picture$defaultUserImage = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('default-user-icon fa-stack fa-2x')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fa-solid fa-circle fa-stack-2x')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fa-solid fa-user-astronaut fa-stack-2x fa-inverse')
				]),
			_List_Nil)
		]));
var $author$project$UserSettings$Profile$Picture$viewPreview = function (model) {
	var _v0 = model.user;
	if (_v0.$ === 'Loaded') {
		var user = _v0.a;
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$UserSettings$Profile$Picture$defaultUserImage,
			A2($elm$core$Basics$composeR, $author$project$UserSettings$Profile$Model$getUrl, $author$project$UserSettings$Profile$Picture$renderImage),
			user.profileImage);
	} else {
		return $author$project$UserSettings$Profile$Picture$defaultUserImage;
	}
};
var $author$project$Translations$UserSettings$Profile$profileImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.profile_image');
};
var $author$project$UserSettings$Profile$Model$RemoveProfileImage = {$: 'RemoveProfileImage'};
var $author$project$UserSettings$Profile$Picture$view = F2(
	function (tagger, model) {
		var isLoading = _Utils_eq(model.savingUser, $author$project$RemoteData$Loading) || _Utils_eq(model.user, $author$project$RemoteData$Loading);
		var image = $author$project$PinMeTo$Ui$Skeleton$view(
			{
				shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
				children: _List_fromArray(
					[
						A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$UserSettings$Profile$Picture$defaultUserImage,
						function (user) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$UserSettings$Profile$Picture$defaultUserImage,
								function (_v0) {
									return $author$project$UserSettings$Profile$Picture$viewPreview(model);
								},
								user.profileImage);
						},
						$author$project$RemoteData$currentData(model.user))
					]),
				isLoading: isLoading,
				attributes: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('profile_image')
					])
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-settings-profile__picture')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h5,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$UserSettings$Profile$profileImage(model.translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('picture-wrapper')
						]),
					_List_fromArray(
						[
							image,
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									tagger($author$project$UserSettings$Profile$Model$Pick))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$UserSettings$Profile$uploadPhoto(model.translations))
								])),
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnSmall,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									tagger($author$project$UserSettings$Profile$Model$RemoveProfileImage))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$delete(model.translations))
								]))
						]))
				]));
	});
var $author$project$UserSettings$Profile$Model$OnSave = {$: 'OnSave'};
var $author$project$Translations$UserSettings$Profile$lastName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.last_name');
};
var $author$project$UserSettings$Profile$Model$emptyUser = {lastName: '', firstName: '', profileImage: $elm$core$Maybe$Nothing};
var $author$project$Translations$UserSettings$Profile$firstName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.first_name');
};
var $author$project$UserSettings$Profile$Model$OnChange = F2(
	function (a, b) {
		return {$: 'OnChange', a: a, b: b};
	});
var $author$project$UserSettings$Profile$Profile$inputField = F4(
	function (tagger, value_, id, label_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form__label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label_)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('form__field'),
							$elm$html$Html$Attributes$value(value_),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeR,
								$author$project$UserSettings$Profile$Model$OnChange(id),
								tagger))
						]),
					_List_Nil)
				]));
	});
var $author$project$UserSettings$Profile$Model$RemoveResponseBanner = {$: 'RemoveResponseBanner'};
var $author$project$Translations$UserSettings$Profile$saveUserProfileFailure = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.save_user_profile_failure');
};
var $author$project$Translations$UserSettings$Profile$saveUserProfileSuccess = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.save_user_profile_success');
};
var $author$project$UserSettings$Profile$Profile$renderBanner = F2(
	function (tagger, model) {
		var banner = F2(
			function (cls, message) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('status-bar status-bar--symbol', true),
									_Utils_Tuple2(cls, true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar__message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar__dismiss'),
									$elm$html$Html$Events$onClick(
									tagger($author$project$UserSettings$Profile$Model$RemoveResponseBanner))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]));
			});
		var _v0 = model.savingUser;
		switch (_v0.$) {
			case 'Loaded':
				return A2(
					banner,
					'status-bar--success',
					$author$project$Translations$UserSettings$Profile$saveUserProfileSuccess(model.translations));
			case 'Error':
				return A2(
					banner,
					'status-bar--danger',
					$author$project$Translations$UserSettings$Profile$saveUserProfileFailure(model.translations));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Translations$UserSettings$Profile$basicInformation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.profile.basic_information');
};
var $author$project$UserSettings$Profile$Profile$renderBasicInformation = F2(
	function (tagger, model) {
		var user = A2($author$project$RemoteData$withDefault, $author$project$UserSettings$Profile$Model$emptyUser, model.user);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$UserSettings$Profile$Profile$renderBanner, tagger, model),
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$Profile$basicInformation(model.translations))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('user-settings-profile__basic-information')
						]),
					_List_fromArray(
						[
							A2($author$project$UserSettings$Profile$Picture$view, tagger, model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-fields')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$UserSettings$Profile$basicInformation(model.translations))
										])),
									A4(
									$author$project$UserSettings$Profile$Profile$inputField,
									tagger,
									user.firstName,
									'firstName',
									$author$project$Translations$UserSettings$Profile$firstName(model.translations)),
									A4(
									$author$project$UserSettings$Profile$Profile$inputField,
									tagger,
									user.lastName,
									'lastName',
									$author$project$Translations$UserSettings$Profile$lastName(model.translations)),
									A3(
									$author$project$PinMeTo$Ui$Btn$pmtBtn,
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											tagger($author$project$UserSettings$Profile$Model$OnSave)),
											$elm$html$Html$Attributes$disabled(
											_Utils_eq(model.savingUser, $author$project$RemoteData$Loading))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$save(model.translations))
										]))
								]))
						]))
				]));
	});
var $author$project$UserSettings$Profile$Profile$view = F2(
	function (tagger, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container user-settings-profile')
				]),
			_List_fromArray(
				[
					A2($author$project$UserSettings$Profile$Profile$renderBasicInformation, tagger, model)
				]));
	});
var $author$project$UserSettings$EmailNotifications$Save = {$: 'Save'};
var $author$project$Translations$UserSettings$Subscriptions$digestMail = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.digest_mail');
};
var $author$project$UserSettings$EmailNotifications$OnChangeDay = F2(
	function (a, b) {
		return {$: 'OnChangeDay', a: a, b: b};
	});
var $author$project$Translations$UserSettings$Subscriptions$onWhichDays = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.on_which_days');
};
var $author$project$Translations$UserSettings$Subscriptions$chooseEmails = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.choose_emails');
};
var $author$project$Translations$UserSettings$Subscriptions$pendingTasks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.pending_tasks');
};
var $author$project$Translations$UserSettings$Subscriptions$listingsManager = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.listings_manager');
};
var $author$project$UserSettings$EmailNotifications$OnChangeEmailList = F2(
	function (a, b) {
		return {$: 'OnChangeEmailList', a: a, b: b};
	});
var $author$project$Translations$UserSettings$Subscriptions$otherSubscriptions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.other_subscriptions');
};
var $author$project$UserSettings$EmailNotifications$OnChangePendingTasks = function (a) {
	return {$: 'OnChangePendingTasks', a: a};
};
var $author$project$UserSettings$EmailNotifications$RemoveResponseBanner = {$: 'RemoveResponseBanner'};
var $author$project$Translations$UserSettings$Subscriptions$listingsManagerWeekly = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.listings_manager_weekly');
};
var $author$project$Translations$UserSettings$Subscriptions$conversationTaskEmailTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.conversation_task_email_title');
};
var $author$project$Translations$UserSettings$Subscriptions$selectTypesOfNotifications = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.select_types_of_notifications');
};
var $author$project$UserSettings$EmailNotifications$OnChangeListingsManagerDigest = function (a) {
	return {$: 'OnChangeListingsManagerDigest', a: a};
};
var $author$project$Translations$UserSettings$Subscriptions$conversationTaskEmailHelpText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.subscriptions.conversation_task_email_help_text');
};
var $author$project$UserSettings$EmailNotifications$OnChangeListenDigestSubscription = function (a) {
	return {$: 'OnChangeListenDigestSubscription', a: a};
};
var $author$project$UserSettings$EmailNotifications$viewSubscriptions = F4(
	function (tagger, config, n, model) {
		var emailListCheckbox = function (list) {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$PinMeTo$Ui$Form$Checkbox$render(
						$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
							{
								label: list.name,
								checked: _Utils_eq(list.status, $author$project$UserSettings$EmailNotifications$Subscribed),
								onChange: A2(
									$elm$core$Basics$composeR,
									$author$project$UserSettings$EmailNotifications$OnChangeEmailList(list),
									tagger)
							}))
					]));
		};
		var checkbox = F3(
			function (txt, onClickMsg, isChecked) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Form$Checkbox$render(
							$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
								{
									label: txt,
									checked: isChecked,
									onChange: A2($elm$core$Basics$composeR, onClickMsg, tagger)
								}))
						]));
			});
		var checkboxes = function () {
			var chkBox = F2(
				function (s, day) {
					return A3(
						checkbox,
						s,
						$author$project$UserSettings$EmailNotifications$OnChangeDay(day),
						A2($Gizra$elm_all_set$EverySet$member, day, n.days));
				});
			return n.taskNotificationsEnabled ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$UserSettings$Subscriptions$onWhichDays(model.translations))
							])),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$mon(model.translations),
						$author$project$UserSettings$EmailNotifications$Monday),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$tue(model.translations),
						$author$project$UserSettings$EmailNotifications$Tuesday),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$wed(model.translations),
						$author$project$UserSettings$EmailNotifications$Wednesday),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$thu(model.translations),
						$author$project$UserSettings$EmailNotifications$Thursday),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$fri(model.translations),
						$author$project$UserSettings$EmailNotifications$Friday),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$sat(model.translations),
						$author$project$UserSettings$EmailNotifications$Saturday),
						A2(
						chkBox,
						' ' + $author$project$Translations$General$sun(model.translations),
						$author$project$UserSettings$EmailNotifications$Sunday)
					])) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}();
		var viewContent = _List_fromArray(
			[
				$author$project$PinMeTo$Ui$TitleBar$render(
				$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
					$author$project$Translations$UserSettings$Subscriptions$digestMail(model.translations))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('util__inset email-subscription-settings__section'),
						A2($elm$html$Html$Attributes$style, 'backgroundColor', 'white')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$UserSettings$Subscriptions$selectTypesOfNotifications(model.translations))
									])),
								A3(
								checkbox,
								$author$project$Translations$UserSettings$Subscriptions$pendingTasks(model.translations),
								$author$project$UserSettings$EmailNotifications$OnChangePendingTasks,
								n.taskNotificationsEnabled),
								checkboxes
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset-y util__left')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$PinMeTo$Ui$Btn$pmtBtn,
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										tagger($author$project$UserSettings$EmailNotifications$Save))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$update(model.translations))
									]))
							]))
					])),
				$author$project$PinMeTo$Ui$TitleBar$render(
				$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
					$author$project$Translations$UserSettings$Subscriptions$otherSubscriptions(model.translations))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('util__inset email-subscription-settings__section'),
						A2($elm$html$Html$Attributes$style, 'backgroundColor', 'white')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$UserSettings$Subscriptions$chooseEmails(model.translations))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$map, emailListCheckbox, n.lists)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset-y util__left')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$PinMeTo$Ui$Btn$pmtBtn,
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										tagger($author$project$UserSettings$EmailNotifications$Save))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$update(model.translations))
									]))
							]))
					])),
				config.listenEnabled ? $author$project$PinMeTo$Ui$TitleBar$render(
				$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
					$author$project$Translations$UserSettings$Subscriptions$conversationTaskEmailTitle(model.translations))) : $elm$html$Html$text(''),
				config.listenEnabled ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('util__inset email-subscription-settings__section'),
						A2($elm$html$Html$Attributes$style, 'backgroundColor', 'white')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$UserSettings$Subscriptions$chooseEmails(model.translations))
									])),
								A3(
								checkbox,
								$author$project$Translations$UserSettings$Subscriptions$conversationTaskEmailTitle(model.translations),
								$author$project$UserSettings$EmailNotifications$OnChangeListenDigestSubscription,
								n.listenDigestEnabled)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$UserSettings$Subscriptions$conversationTaskEmailHelpText(model.translations))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset-y util__left')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$PinMeTo$Ui$Btn$pmtBtn,
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										tagger($author$project$UserSettings$EmailNotifications$Save))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$update(model.translations))
									]))
							]))
					])) : $elm$html$Html$text(''),
				$author$project$PinMeTo$Ui$TitleBar$render(
				$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
					$author$project$Translations$UserSettings$Subscriptions$listingsManager(model.translations))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('util__inset email-subscription-settings__section'),
						A2($elm$html$Html$Attributes$style, 'backgroundColor', 'white')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$UserSettings$Subscriptions$chooseEmails(model.translations))
									])),
								A3(
								checkbox,
								$author$project$Translations$UserSettings$Subscriptions$listingsManagerWeekly(model.translations),
								$author$project$UserSettings$EmailNotifications$OnChangeListingsManagerDigest,
								n.listingsManagerDigestEnabled)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('util__inset-y util__left')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$PinMeTo$Ui$Btn$pmtBtn,
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										tagger($author$project$UserSettings$EmailNotifications$Save))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$General$update(model.translations))
									]))
							]))
					]))
			]);
		var viewBanner = F2(
			function (cls, message) {
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('status-bar status-bar--symbol', true),
										_Utils_Tuple2(cls, true)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar__message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('status-bar__dismiss'),
										$elm$html$Html$Events$onClick(
										tagger($author$project$UserSettings$EmailNotifications$RemoveResponseBanner))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('')
									]))
							])),
					viewContent);
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('email-subscription-settings')
				]),
			function () {
				var _v0 = model.saving;
				switch (_v0.$) {
					case 'Suspended':
						return viewContent;
					case 'Loading':
						return viewContent;
					case 'Loaded':
						return A2(viewBanner, 'status-bar--success', 'Email notifications saved.');
					default:
						return A2(viewBanner, 'status-bar--danger', 'saving email notifications failed.');
				}
			}());
	});
var $author$project$UserSettings$EmailNotifications$view = F3(
	function (tagger, config, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container modern')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.subscriptions;
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$Spinner$spinner;
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinner;
						case 'Loaded':
							var x = _v0.a;
							return A4($author$project$UserSettings$EmailNotifications$viewSubscriptions, tagger, config, x, model);
						default:
							var e = _v0.a;
							return $elm$html$Html$text(e);
					}
				}()
				]));
	});
var $author$project$UserSettings$Notifications$Model$Save = function (a) {
	return {$: 'Save', a: a};
};
var $author$project$Translations$UserSettings$Notifications$intro = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.intro');
};
var $author$project$UserSettings$Notifications$View$Enabled = {$: 'Enabled'};
var $author$project$UserSettings$Notifications$Model$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$UserSettings$Notifications$View$Disabled = {$: 'Disabled'};
var $author$project$UserSettings$Notifications$Model$AskForPush = function (a) {
	return {$: 'AskForPush', a: a};
};
var $author$project$UserSettings$Notifications$View$FA = function (a) {
	return {$: 'FA', a: a};
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$PinMeTo$Deprecated$FontAwesome$Chat = {$: 'Chat'};
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $author$project$PinMeTo$Deprecated$FontAwesome$Google = {$: 'Google'};
var $author$project$UserSettings$Notifications$View$UiIcon = function (a) {
	return {$: 'UiIcon', a: a};
};
var $author$project$UserSettings$Notifications$Form$unwrap = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return data.changes;
	} else {
		var data = form.a;
		return data;
	}
};
var $author$project$PinMeTo$Deprecated$FontAwesome$Facebook = {$: 'Facebook'};
var $author$project$UserSettings$Notifications$Form$isSaving = function (form) {
	if (form.$ === 'Editing') {
		return false;
	} else {
		return true;
	}
};
var $author$project$PinMeTo$Deprecated$FontAwesome$Instagram = {$: 'Instagram'};
var $author$project$UserSettings$Notifications$Form$canSubmit = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return !_Utils_eq(data.original, data.changes);
	} else {
		return false;
	}
};
var $author$project$UserSettings$Notifications$Data$Event$googleEvents = _List_fromArray(
	[$author$project$UserSettings$Notifications$Data$Event$NewGoogleReview]);
var $author$project$Translations$UserSettings$Notifications$notifications = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.notifications');
};
var $author$project$UserSettings$Notifications$Data$Event$facebookEvents = _List_fromArray(
	[$author$project$UserSettings$Notifications$Data$Event$NewFacebookRecommendation, $author$project$UserSettings$Notifications$Data$Event$NewFacebookComment, $author$project$UserSettings$Notifications$Data$Event$NewFacebookUserPost, $author$project$UserSettings$Notifications$Data$Event$NewFacebookMention, $author$project$UserSettings$Notifications$Data$Event$NewFacebookDirectMessage]);
var $author$project$UserSettings$Notifications$Data$Event$instagramEvents = _List_fromArray(
	[$author$project$UserSettings$Notifications$Data$Event$NewInstagramComment, $author$project$UserSettings$Notifications$Data$Event$NewInstagramMention, $author$project$UserSettings$Notifications$Data$Event$NewInstagramDirectMessage]);
var $author$project$Translations$UserSettings$Notifications$eventConversationNewGoogleReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_google_review');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationAssignedToReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_assigned_to_review');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookComment = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_facebook_comment');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookMention = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_facebook_mention');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookUserPost = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_facebook_user_post');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewInstagramComment = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_instagram_comment');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewInstagramMention = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_instagram_mention');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewTrustpilotReview = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_trustpilot_review');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationAssignedToConversation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_assigned_to_conversation');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookDirectMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_facebook_direct_message');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookRecommendation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_facebook_recommendation');
};
var $author$project$Translations$UserSettings$Notifications$eventConversationNewInstagramDirectMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.event_conversation_new_instagram_direct_message');
};
var $author$project$UserSettings$Notifications$Data$Event$toHumanReadable = F3(
	function (translations, event, isReviewOnly) {
		switch (event.$) {
			case 'NewGoogleReview':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewGoogleReview(translations);
			case 'NewFacebookRecommendation':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookRecommendation(translations);
			case 'NewFacebookComment':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookComment(translations);
			case 'NewFacebookUserPost':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookUserPost(translations);
			case 'NewFacebookMention':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookMention(translations);
			case 'IssueAssigned':
				return isReviewOnly ? $author$project$Translations$UserSettings$Notifications$eventConversationAssignedToReview(translations) : $author$project$Translations$UserSettings$Notifications$eventConversationAssignedToConversation(translations);
			case 'NewInstagramComment':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewInstagramComment(translations);
			case 'NewInstagramMention':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewInstagramMention(translations);
			case 'NewTrustpilotReview':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewTrustpilotReview(translations);
			case 'NewFacebookDirectMessage':
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewFacebookDirectMessage(translations);
			default:
				return $author$project$Translations$UserSettings$Notifications$eventConversationNewInstagramDirectMessage(translations);
		}
	});
var $author$project$UserSettings$Notifications$Data$Event$trustpilotEvents = _List_fromArray(
	[$author$project$UserSettings$Notifications$Data$Event$NewTrustpilotReview]);
var $author$project$UserSettings$Notifications$Model$ToggleEventForPush = F2(
	function (a, b) {
		return {$: 'ToggleEventForPush', a: a, b: b};
	});
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$isSubscribedToPush = F2(
	function (event, subscription) {
		return A2($elm$core$List$member, event, subscription.push);
	});
var $author$project$UserSettings$Notifications$Model$ToggleEventForEmail = F2(
	function (a, b) {
		return {$: 'ToggleEventForEmail', a: a, b: b};
	});
var $author$project$UserSettings$Notifications$Data$Event$conversationsEvents = _List_fromArray(
	[$author$project$UserSettings$Notifications$Data$Event$IssueAssigned]);
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$isSubscribedToEmail = F2(
	function (event, subscription) {
		return A2($elm$core$List$member, event, subscription.email);
	});
var $author$project$Translations$UserSettings$Notifications$notificationTypeEmail = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.notification_type_email');
};
var $author$project$Translations$UserSettings$Notifications$notificationTypeDesktop = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.notification_type_desktop');
};
var $author$project$UserSettings$Notifications$View$eventsView = F2(
	function (translations, _v0) {
		var productType = _v0.productType;
		var nameChangeFeatureEnabled = _v0.nameChangeFeatureEnabled;
		var form = _v0.form;
		var pushSubscriptionCheckboxState = _v0.pushSubscriptionCheckboxState;
		var _v1 = function () {
			switch (pushSubscriptionCheckboxState.$) {
				case 'Enabled':
					return _Utils_Tuple2(
						true,
						function (event) {
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UserSettings$Notifications$Model$ToggleEventForPush(event),
								$author$project$UserSettings$Notifications$Model$FormMsg);
						});
				case 'EnabledAndAsk':
					return _Utils_Tuple2(
						true,
						F2(
							function (event, _v3) {
								return $author$project$UserSettings$Notifications$Model$AskForPush(
									$elm$core$Maybe$Just(event));
							}));
				default:
					return _Utils_Tuple2(
						false,
						function (event) {
							return A2(
								$elm$core$Basics$composeR,
								$author$project$UserSettings$Notifications$Model$ToggleEventForPush(event),
								$author$project$UserSettings$Notifications$Model$FormMsg);
						});
			}
		}();
		var pushEnabled = _v1.a;
		var pushOnChange = _v1.b;
		var isReviewsOnly = _Utils_eq(productType, $author$project$PinMeTo$Global$TopNavigation$Model$ReviewsOnly) && nameChangeFeatureEnabled;
		var conversationsProductName = isReviewsOnly ? 'Reviews' : 'Conversations';
		var subscription = $author$project$UserSettings$Notifications$Form$unwrap(form);
		var renderIcon = function (icon) {
			if (icon.$ === 'FA') {
				var x = icon.a;
				return $author$project$PinMeTo$Deprecated$FontAwesome$render(x);
			} else {
				var x = icon.a;
				return $author$project$PinMeTo$Ui$Icon$render(x);
			}
		};
		var checkbox = F2(
			function (_v4, checked) {
				var enabled = _v4.enabled;
				var onChange = _v4.onChange;
				return $author$project$PinMeTo$Ui$Form$Checkbox$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Checkbox$withEnabled,
						enabled,
						$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
							{label: '', checked: checked, onChange: onChange})));
			});
		var tableRow = function (event) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('event')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('event__name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$UserSettings$Notifications$Data$Event$toHumanReadable, translations, event, isReviewsOnly))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('event__checkbox')
							]),
						_List_fromArray(
							[
								A2(
								checkbox,
								{
									enabled: pushEnabled,
									onChange: pushOnChange(event)
								},
								A2($author$project$UserSettings$Notifications$Data$NotificationSubscription$isSubscribedToPush, event, subscription))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('event__checkbox')
							]),
						_List_fromArray(
							[
								A2(
								checkbox,
								{
									enabled: true,
									onChange: A2(
										$elm$core$Basics$composeR,
										$author$project$UserSettings$Notifications$Model$ToggleEventForEmail(event),
										$author$project$UserSettings$Notifications$Model$FormMsg)
								},
								A2($author$project$UserSettings$Notifications$Data$NotificationSubscription$isSubscribedToEmail, event, subscription))
							]))
					]));
		};
		var tableSection = F3(
			function (title, icon, events) {
				return A2(
					$elm$html$Html$tbody,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$colspan(3),
											$elm$html$Html$Attributes$class('section__title')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('section__icon')
												]),
											_List_fromArray(
												[
													renderIcon(icon)
												])),
											$elm$html$Html$text(title)
										]))
								])),
						A2($elm$core$List$map, tableRow, events)));
			});
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$UserSettings$Notifications$notifications(translations))
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$UserSettings$Notifications$notificationTypeDesktop(translations))
										])),
									A2(
									$elm$html$Html$td,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$UserSettings$Notifications$notificationTypeEmail(translations))
										]))
								]))
						])),
					A3(
					tableSection,
					'Google',
					$author$project$UserSettings$Notifications$View$FA($author$project$PinMeTo$Deprecated$FontAwesome$Google),
					$author$project$UserSettings$Notifications$Data$Event$googleEvents),
					A3(
					tableSection,
					'Facebook',
					$author$project$UserSettings$Notifications$View$FA($author$project$PinMeTo$Deprecated$FontAwesome$Facebook),
					$author$project$UserSettings$Notifications$Data$Event$facebookEvents),
					A3(
					tableSection,
					'Instagram',
					$author$project$UserSettings$Notifications$View$FA($author$project$PinMeTo$Deprecated$FontAwesome$Instagram),
					$author$project$UserSettings$Notifications$Data$Event$instagramEvents),
					A3(
					tableSection,
					'Trustpilot',
					$author$project$UserSettings$Notifications$View$UiIcon($author$project$PinMeTo$Ui$Icon$NetworkTrustPilot),
					$author$project$UserSettings$Notifications$Data$Event$trustpilotEvents),
					A3(
					tableSection,
					conversationsProductName,
					$author$project$UserSettings$Notifications$View$FA($author$project$PinMeTo$Deprecated$FontAwesome$Chat),
					$author$project$UserSettings$Notifications$Data$Event$conversationsEvents),
					A2(
					$elm$html$Html$tfoot,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$td,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$colspan(3)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('user-settings-notifications__actions')
												]),
											_List_fromArray(
												[
													$author$project$UserSettings$Notifications$Form$isSaving(form) ? $author$project$PinMeTo$Ui$Spinner$spinner : A3(
													$author$project$PinMeTo$Ui$Btn$pmtBtn,
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('submit'),
															$elm$html$Html$Attributes$disabled(
															!$author$project$UserSettings$Notifications$Form$canSubmit(form))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$General$save(translations))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$UserSettings$Notifications$View$EnabledAndAsk = {$: 'EnabledAndAsk'};
var $author$project$Translations$UserSettings$Notifications$desktopNotificationsBlockedCustom = F2(
	function (translations, nonPlaceholderLift) {
		return A5($ChristophP$elm_i18next$I18Next$customTr, translations, $ChristophP$elm_i18next$I18Next$Curly, nonPlaceholderLift, 'user_settings.notifications.desktop_notifications_blocked', _List_Nil);
	});
var $author$project$Translations$UserSettings$Notifications$desktopNotificationsOtherBrowserInfo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.desktop_notifications_other_browser_info');
};
var $author$project$Translations$UserSettings$Notifications$desktopNotificationsUnsupportedCustom = F2(
	function (translations, nonPlaceholderLift) {
		return A5($ChristophP$elm_i18next$I18Next$customTr, translations, $ChristophP$elm_i18next$I18Next$Curly, nonPlaceholderLift, 'user_settings.notifications.desktop_notifications_unsupported', _List_Nil);
	});
var $author$project$Translations$UserSettings$Notifications$desktopNotificationsApproveNotificationsAction = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.desktop_notifications_approve_notifications_action');
};
var $author$project$Translations$UserSettings$Notifications$desktopNotificationsApproveCurrentBrowserAlsoCustom = F3(
	function (translations, nonPlaceholderLift, approveNotificationsAction) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'user_settings.notifications.desktop_notifications_approve_current_browser_also',
			_List_fromArray(
				[
					_Utils_Tuple2(' approveNotificationsAction ', approveNotificationsAction)
				]));
	});
var $author$project$UserSettings$Notifications$View$viewLoaded = F5(
	function (translations, form, pushSubscriptionStatus, nameChangeFeatureEnabled, productType) {
		var otherBrowserInfo = A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$UserSettings$Notifications$desktopNotificationsOtherBrowserInfo(translations))
				]));
		var noSupportText = A2(
			$elm$html$Html$p,
			_List_Nil,
			A2($author$project$Translations$UserSettings$Notifications$desktopNotificationsUnsupportedCustom, translations, $elm$html$Html$text));
		var blockedText = A2(
			$elm$html$Html$p,
			_List_Nil,
			A2($author$project$Translations$UserSettings$Notifications$desktopNotificationsBlockedCustom, translations, $elm$html$Html$text));
		var _v0 = function () {
			switch (pushSubscriptionStatus.$) {
				case 'NotEnabled':
					var currentBrowserCapability = pushSubscriptionStatus.a;
					switch (currentBrowserCapability.$) {
						case 'CanAsk':
							return _Utils_Tuple2($author$project$UserSettings$Notifications$View$EnabledAndAsk, $elm$core$Maybe$Nothing);
						case 'Blocked':
							return _Utils_Tuple2(
								$author$project$UserSettings$Notifications$View$Disabled,
								$elm$core$Maybe$Just(
									_List_fromArray(
										[blockedText])));
						default:
							return _Utils_Tuple2(
								$author$project$UserSettings$Notifications$View$Disabled,
								$elm$core$Maybe$Just(
									_List_fromArray(
										[noSupportText])));
					}
				case 'EnabledInOtherBrowser':
					var currentBrowserCapability = pushSubscriptionStatus.a;
					switch (currentBrowserCapability.$) {
						case 'CanAsk':
							return _Utils_Tuple2(
								$author$project$UserSettings$Notifications$View$Enabled,
								$elm$core$Maybe$Just(
									A3(
										$author$project$Translations$UserSettings$Notifications$desktopNotificationsApproveCurrentBrowserAlsoCustom,
										translations,
										$elm$html$Html$text,
										A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$UserSettings$Notifications$Model$AskForPush($elm$core$Maybe$Nothing))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$UserSettings$Notifications$desktopNotificationsApproveNotificationsAction(translations))
												])))));
						case 'Blocked':
							return _Utils_Tuple2(
								$author$project$UserSettings$Notifications$View$Enabled,
								$elm$core$Maybe$Just(
									_List_fromArray(
										[blockedText, otherBrowserInfo])));
						default:
							return _Utils_Tuple2(
								$author$project$UserSettings$Notifications$View$Enabled,
								$elm$core$Maybe$Just(
									_List_fromArray(
										[noSupportText, otherBrowserInfo])));
					}
				default:
					return _Utils_Tuple2($author$project$UserSettings$Notifications$View$Enabled, $elm$core$Maybe$Nothing);
			}
		}();
		var pushSubscriptionCheckboxState = _v0.a;
		var pushInfo = _v0.b;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section section--solid')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' util__inset info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$UserSettings$Notifications$intro(translations))
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Alert$rich, $author$project$PinMeTo$Ui$Alert$render),
								pushInfo))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset user-settings-notifications--form'),
							$elm$html$Html$Events$onSubmit(
							$author$project$UserSettings$Notifications$Model$FormMsg(
								$author$project$UserSettings$Notifications$Model$Save(false)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UserSettings$Notifications$View$eventsView,
							translations,
							{form: form, productType: productType, nameChangeFeatureEnabled: nameChangeFeatureEnabled, pushSubscriptionCheckboxState: pushSubscriptionCheckboxState})
						]))
				]));
	});
var $author$project$Translations$General$unknownError = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.unknown_error');
};
var $author$project$UserSettings$Notifications$View$CanAsk = {$: 'CanAsk'};
var $author$project$UserSettings$Notifications$View$Blocked = {$: 'Blocked'};
var $author$project$UserSettings$Notifications$View$NotEnabled = function (a) {
	return {$: 'NotEnabled', a: a};
};
var $author$project$UserSettings$Notifications$View$NotSupported = {$: 'NotSupported'};
var $author$project$UserSettings$Notifications$View$EnabledInOtherBrowser = function (a) {
	return {$: 'EnabledInOtherBrowser', a: a};
};
var $author$project$UserSettings$Notifications$View$EnabledForCurrentBrowser = {$: 'EnabledForCurrentBrowser'};
var $author$project$UserSettings$Notifications$View$getPushSubscriptionStatus = F2(
	function (status, currentSubscription) {
		var status_ = function (x) {
			if (status.$ === 'Enabled') {
				return $author$project$UserSettings$Notifications$View$EnabledInOtherBrowser(x);
			} else {
				return $author$project$UserSettings$Notifications$View$NotEnabled(x);
			}
		};
		switch (currentSubscription.$) {
			case 'Granted':
				return $author$project$UserSettings$Notifications$View$EnabledForCurrentBrowser;
			case 'Unsupported':
				return status_($author$project$UserSettings$Notifications$View$NotSupported);
			case 'NotAsked':
				return status_($author$project$UserSettings$Notifications$View$CanAsk);
			default:
				return status_($author$project$UserSettings$Notifications$View$Blocked);
		}
	});
var $author$project$Translations$UserSettings$Notifications$notificationsConversations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.notifications_conversations');
};
var $author$project$UserSettings$Notifications$View$view = F3(
	function (tagger, translations, model) {
		var nameChangeFeatureEnabled = A2(
			$elm$core$List$member,
			model.siteName,
			_List_fromArray(
				['pinmeto', 'acme', 'EG_Deutschland']));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-settings-notifications container modern')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$Notifications$notificationsConversations(translations))),
					function () {
					var _v0 = A3(
						$author$project$RemoteData$map2,
						F2(
							function (form, pushSubscriptionStatus) {
								return {form: form, pushSubscriptionStatus: pushSubscriptionStatus};
							}),
						model.form,
						A3($author$project$RemoteData$map2, $author$project$UserSettings$Notifications$View$getPushSubscriptionStatus, model.pushSubscriptions, model.currentSubscription));
					switch (_v0.$) {
						case 'Suspended':
							return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
						case 'Error':
							return $author$project$PinMeTo$Ui$Alert$render(
								A2(
									$author$project$PinMeTo$Ui$Alert$withStatus,
									$author$project$PinMeTo$Ui$Alert$Error,
									$author$project$PinMeTo$Ui$Alert$plain(
										$author$project$Translations$General$unknownError(translations))));
						default:
							var pushSubscriptionStatus = _v0.a.pushSubscriptionStatus;
							var form = _v0.a.form;
							return A2(
								$elm$html$Html$map,
								tagger,
								A5($author$project$UserSettings$Notifications$View$viewLoaded, translations, form, pushSubscriptionStatus, nameChangeFeatureEnabled, model.productType));
					}
				}()
				]));
	});
var $author$project$UserSettings$PostsNotifications$Model$Save = function (a) {
	return {$: 'Save', a: a};
};
var $author$project$UserSettings$PostsNotifications$Model$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$UserSettings$PostsNotifications$Form$unwrap = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return data.changes;
	} else {
		var data = form.a;
		return data;
	}
};
var $author$project$UserSettings$PostsNotifications$Form$isSaving = function (form) {
	if (form.$ === 'Editing') {
		return false;
	} else {
		return true;
	}
};
var $author$project$UserSettings$PostsNotifications$Data$Event$allEvents = _List_fromArray(
	[$author$project$UserSettings$PostsNotifications$Data$Event$SuccessfullyScheduledPosts, $author$project$UserSettings$PostsNotifications$Data$Event$FailedScheduledPosts]);
var $author$project$UserSettings$PostsNotifications$Form$canSubmit = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return !_Utils_eq(data.original, data.changes);
	} else {
		return false;
	}
};
var $author$project$Translations$UserSettings$Notifications$postsNote = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.posts_note');
};
var $author$project$Translations$UserSettings$Notifications$scheduledPostFailed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.scheduled_post_failed');
};
var $author$project$Translations$UserSettings$Notifications$scheduledPostPublished = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.scheduled_post_published');
};
var $author$project$UserSettings$PostsNotifications$Data$Event$toHumanReadable = F2(
	function (translations, event) {
		if (event.$ === 'SuccessfullyScheduledPosts') {
			return $author$project$Translations$UserSettings$Notifications$scheduledPostPublished(translations);
		} else {
			return $author$project$Translations$UserSettings$Notifications$scheduledPostFailed(translations);
		}
	});
var $author$project$UserSettings$PostsNotifications$Model$ToggleEventForEmail = F2(
	function (a, b) {
		return {$: 'ToggleEventForEmail', a: a, b: b};
	});
var $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$isSubscribedToEmail = F2(
	function (event, subscription) {
		return A2($elm$core$List$member, event, subscription.email);
	});
var $author$project$UserSettings$PostsNotifications$View$eventsView = F2(
	function (translations, _v0) {
		var form = _v0.form;
		var subscription = $author$project$UserSettings$PostsNotifications$Form$unwrap(form);
		var checkbox = F2(
			function (_v1, checked) {
				var enabled = _v1.enabled;
				var onChange = _v1.onChange;
				return $author$project$PinMeTo$Ui$Form$Checkbox$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Checkbox$withEnabled,
						enabled,
						$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
							{label: '', checked: checked, onChange: onChange})));
			});
		var tableRow = function (event) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('event')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-settings__notifications--event')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$UserSettings$PostsNotifications$Data$Event$toHumanReadable, translations, event))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('event__checkbox')
							]),
						_List_fromArray(
							[
								A2(
								checkbox,
								{
									enabled: true,
									onChange: A2(
										$elm$core$Basics$composeR,
										$author$project$UserSettings$PostsNotifications$Model$ToggleEventForEmail(event),
										$author$project$UserSettings$PostsNotifications$Model$FormMsg)
								},
								A2($author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$isSubscribedToEmail, event, subscription))
							]))
					]));
		};
		var tableSection = function (events) {
			return A2(
				$elm$html$Html$tbody,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section')
					]),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$tr, _List_Nil, _List_Nil),
					A2($elm$core$List$map, tableRow, events)));
		};
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table')
				]),
			_List_fromArray(
				[
					tableSection($author$project$UserSettings$PostsNotifications$Data$Event$allEvents),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-settings__notifications--note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$UserSettings$Notifications$postsNote(translations))
						])),
					A2(
					$elm$html$Html$tfoot,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-settings__notifications--save-btn')
								]),
							_List_fromArray(
								[
									$author$project$UserSettings$PostsNotifications$Form$isSaving(form) ? $author$project$PinMeTo$Ui$Spinner$spinner : A3(
									$author$project$PinMeTo$Ui$Btn$pmtBtn,
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Attributes$disabled(
											!$author$project$UserSettings$PostsNotifications$Form$canSubmit(form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$save(translations))
										]))
								]))
						]))
				]));
	});
var $author$project$Translations$UserSettings$Notifications$postsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.posts_title');
};
var $author$project$UserSettings$PostsNotifications$View$viewLoaded = F2(
	function (translations, form) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-settings__notifications')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-settings__notifications--title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$UserSettings$Notifications$postsTitle(translations))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-settings__notifications--form'),
							$elm$html$Html$Events$onSubmit(
							$author$project$UserSettings$PostsNotifications$Model$FormMsg(
								$author$project$UserSettings$PostsNotifications$Model$Save(false)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UserSettings$PostsNotifications$View$eventsView,
							translations,
							{form: form})
						]))
				]));
	});
var $author$project$Translations$UserSettings$Notifications$notificationsPosts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.notifications_posts');
};
var $author$project$UserSettings$PostsNotifications$View$view = F3(
	function (tagger, translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-settings-notifications container modern')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$Notifications$notificationsPosts(translations))),
					function () {
					var _v0 = model.form;
					switch (_v0.$) {
						case 'Loaded':
							var x = _v0.a;
							return A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$UserSettings$PostsNotifications$View$viewLoaded, translations, x));
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
						default:
							return $elm$html$Html$text('Something went wrong. Please restart the page.');
					}
				}()
				]));
	});
var $author$project$UserSettings$PlacesAINotifications$Model$Save = function (a) {
	return {$: 'Save', a: a};
};
var $author$project$UserSettings$PlacesAINotifications$Model$FormMsg = function (a) {
	return {$: 'FormMsg', a: a};
};
var $author$project$UserSettings$PlacesAINotifications$Form$unwrap = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return data.changes;
	} else {
		var data = form.a;
		return data;
	}
};
var $author$project$UserSettings$PlacesAINotifications$Form$isSaving = function (form) {
	if (form.$ === 'Editing') {
		return false;
	} else {
		return true;
	}
};
var $author$project$UserSettings$PlacesAINotifications$Data$Event$allEvents = _List_fromArray(
	[$author$project$UserSettings$PlacesAINotifications$Data$Event$ActionAssigned]);
var $author$project$UserSettings$PlacesAINotifications$Form$canSubmit = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return !_Utils_eq(data.original, data.changes);
	} else {
		return false;
	}
};
var $author$project$Translations$UserSettings$Notifications$placesAiActionAssigned = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.places_ai_action_assigned');
};
var $author$project$UserSettings$PlacesAINotifications$Data$Event$toHumanReadable = F2(
	function (translations, event) {
		return $author$project$Translations$UserSettings$Notifications$placesAiActionAssigned(translations);
	});
var $author$project$UserSettings$PlacesAINotifications$Model$ToggleEventForEmail = F2(
	function (a, b) {
		return {$: 'ToggleEventForEmail', a: a, b: b};
	});
var $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$isSubscribedToEmail = F2(
	function (event, subscription) {
		return A2($elm$core$List$member, event, subscription.email);
	});
var $author$project$UserSettings$PlacesAINotifications$View$eventsView = F2(
	function (translations, _v0) {
		var form = _v0.form;
		var subscription = $author$project$UserSettings$PlacesAINotifications$Form$unwrap(form);
		var checkbox = F2(
			function (_v1, checked) {
				var enabled = _v1.enabled;
				var onChange = _v1.onChange;
				return $author$project$PinMeTo$Ui$Form$Checkbox$render(
					A2(
						$author$project$PinMeTo$Ui$Form$Checkbox$withEnabled,
						enabled,
						$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
							{label: '', checked: checked, onChange: onChange})));
			});
		var tableRow = function (event) {
			return A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('event')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-settings__notifications--event')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$UserSettings$PlacesAINotifications$Data$Event$toHumanReadable, translations, event))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('event__checkbox')
							]),
						_List_fromArray(
							[
								A2(
								checkbox,
								{
									enabled: true,
									onChange: A2(
										$elm$core$Basics$composeR,
										$author$project$UserSettings$PlacesAINotifications$Model$ToggleEventForEmail(event),
										$author$project$UserSettings$PlacesAINotifications$Model$FormMsg)
								},
								A2($author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$isSubscribedToEmail, event, subscription))
							]))
					]));
		};
		var tableSection = function (events) {
			return A2(
				$elm$html$Html$tbody,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section')
					]),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$tr, _List_Nil, _List_Nil),
					A2($elm$core$List$map, tableRow, events)));
		};
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table')
				]),
			_List_fromArray(
				[
					tableSection($author$project$UserSettings$PlacesAINotifications$Data$Event$allEvents),
					A2(
					$elm$html$Html$tfoot,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-settings__notifications--save-btn')
								]),
							_List_fromArray(
								[
									$author$project$UserSettings$PlacesAINotifications$Form$isSaving(form) ? $author$project$PinMeTo$Ui$Spinner$spinner : A3(
									$author$project$PinMeTo$Ui$Btn$pmtBtn,
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Attributes$disabled(
											!$author$project$UserSettings$PlacesAINotifications$Form$canSubmit(form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$save(translations))
										]))
								]))
						]))
				]));
	});
var $author$project$Translations$UserSettings$Notifications$placesAiTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.notifications.places_ai_title');
};
var $author$project$UserSettings$PlacesAINotifications$View$viewLoaded = F2(
	function (translations, form) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-settings__notifications')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-settings__notifications--title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$UserSettings$Notifications$placesAiTitle(translations))
						])),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-settings__notifications--form'),
							$elm$html$Html$Events$onSubmit(
							$author$project$UserSettings$PlacesAINotifications$Model$FormMsg(
								$author$project$UserSettings$PlacesAINotifications$Model$Save(false)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UserSettings$PlacesAINotifications$View$eventsView,
							translations,
							{form: form})
						]))
				]));
	});
var $author$project$UserSettings$PlacesAINotifications$View$view = F3(
	function (tagger, translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-settings-notifications container modern')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$TitleBar$render(
					$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(
						$author$project$Translations$UserSettings$Notifications$notifications(translations) + ' - Places AI')),
					function () {
					var _v0 = model.form;
					switch (_v0.$) {
						case 'Loaded':
							var x = _v0.a;
							return A2(
								$elm$html$Html$map,
								tagger,
								A2($author$project$UserSettings$PlacesAINotifications$View$viewLoaded, translations, x));
						case 'Loading':
							return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
						default:
							return $elm$html$Html$text(
								$author$project$Translations$General$errorUnexpected(translations));
					}
				}()
				]));
	});
var $author$project$UserSettings$Legal$LoginUrl = function (a) {
	return {$: 'LoginUrl', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$getSiteAccess = function (_v0) {
	var model = _v0.a;
	return model.siteAccess;
};
var $author$project$UserSettings$Main$listenEnabled = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$andThen,
			function (state) {
				return $elm$core$Maybe$Just(
					$author$project$PinMeTo$Global$TopNavigation$getSiteAccess(state).hasListenAndRespond);
			},
			model.topNavigation));
};
var $author$project$UserSettings$Model$ChangePasswordMsg = function (a) {
	return {$: 'ChangePasswordMsg', a: a};
};
var $author$project$UserSettings$Main$viewSettings = F2(
	function (config, model) {
		var _v0 = model.view;
		switch (_v0.$) {
			case 'Profile':
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A2($author$project$UserSettings$Profile$Profile$view, $author$project$UserSettings$Model$ProfileMsg, subModel);
				} else {
					var _v1 = _v0.a;
					return $elm$html$Html$text('');
				}
			case 'EmailNotifications':
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A3(
						$author$project$UserSettings$EmailNotifications$view,
						$author$project$UserSettings$Model$EmailNotificationsMsg,
						{
							listenEnabled: $author$project$UserSettings$Main$listenEnabled(model)
						},
						subModel);
				} else {
					var _v2 = _v0.a;
					return $elm$html$Html$text('');
				}
			case 'Notifications':
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A3($author$project$UserSettings$Notifications$View$view, $author$project$UserSettings$Model$NotificationsMsg, model.translations, subModel);
				} else {
					var _v3 = _v0.a;
					return $elm$html$Html$text('');
				}
			case 'NotificationsPosts':
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A3($author$project$UserSettings$PostsNotifications$View$view, $author$project$UserSettings$Model$PostsNotificationsMsg, model.translations, subModel);
				} else {
					var _v4 = _v0.a;
					return $elm$html$Html$text('');
				}
			case 'NotificationsPlacesAI':
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A3($author$project$UserSettings$PlacesAINotifications$View$view, $author$project$UserSettings$Model$PlacesAINotificationsMsg, model.translations, subModel);
				} else {
					var _v5 = _v0.a;
					return $elm$html$Html$text('');
				}
			case 'ChangePassword':
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A5($author$project$UserSettings$ChangePassword$view, $author$project$UserSettings$Model$ChangePasswordMsg, config, model.currentPath, subModel, model.translations);
				} else {
					var _v6 = _v0.a;
					return $elm$html$Html$text('');
				}
			case 'LegalDocuments':
				if (_v0.a.$ === 'Just') {
					var legalModel = _v0.a.a;
					return A2(
						$author$project$UserSettings$Legal$view,
						$author$project$UserSettings$Legal$LoginUrl(config.baseUrls.login),
						legalModel);
				} else {
					var _v7 = _v0.a;
					return $elm$html$Html$text('');
				}
			default:
				if (_v0.a.$ === 'Just') {
					var subModel = _v0.a.a;
					return A2($author$project$UserSettings$Language$view, $author$project$UserSettings$Model$LanguageMsg, subModel);
				} else {
					var _v8 = _v0.a;
					return $elm$html$Html$text('');
				}
		}
	});
var $author$project$Translations$General$TopNavigation$ProductInfo$new = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.new');
};
var $author$project$Translations$General$TopNavigation$chat = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.chat');
};
var $author$project$Translations$General$TopNavigation$help = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.help');
};
var $author$project$Translations$General$TopNavigation$news = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.news');
};
var $author$project$Translations$General$TopNavigation$admin = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.admin');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$posts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.posts');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$places = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.places');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$locator = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.locator');
};
var $author$project$Translations$General$TopNavigation$profile = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.profile');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$reviews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.reviews');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$champion = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.champion');
};
var $author$project$Translations$General$TopNavigation$language = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.language');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$listings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.listings');
};
var $author$project$Translations$General$TopNavigation$security = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.security');
};
var $author$project$Translations$General$TopNavigation$helpCenter = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.help_center');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$aiVisibility = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.ai_visibility');
};
var $author$project$Translations$General$TopNavigation$sendFeedBack = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.send_feed_back');
};
var $author$project$Translations$General$TopNavigation$userSettings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.user_settings');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$conversations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.conversations');
};
var $author$project$Translations$General$TopNavigation$notifications = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.notifications');
};
var $author$project$Translations$General$TopNavigation$subscriptions = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.subscriptions');
};
var $author$project$Translations$General$TopNavigation$switchAccount = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.switch_account');
};
var $author$project$Translations$General$TopNavigation$switchProduct = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.switch_product');
};
var $author$project$Translations$General$TopNavigation$legalDocuments = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.legal_documents');
};
var $author$project$Translations$General$TopNavigation$ProductInfo$localCampaigns = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.product_info.local_campaigns');
};
var $author$project$Translations$General$TopNavigation$searchAccounts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.search_accounts');
};
var $author$project$Translations$General$TopNavigation$contactSupportBody = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.contact_support_body');
};
var $author$project$Translations$General$TopNavigation$ChatInitAlert$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.chat_init_alert.title');
};
var $author$project$Translations$General$TopNavigation$ChatInitAlert$contactSupportCustom = F3(
	function (translations, nonPlaceholderLift, linkTag) {
		return A5(
			$ChristophP$elm_i18next$I18Next$customTr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			nonPlaceholderLift,
			'general.top_navigation.chat_init_alert.contact_support',
			_List_fromArray(
				[
					_Utils_Tuple2(' -linkTag ', linkTag)
				]));
	});
var $author$project$Labels$chatInitAlertLabels = function (translations) {
	return {
		title: $author$project$Translations$General$TopNavigation$ChatInitAlert$title(translations),
		contactSupport: $author$project$Translations$General$TopNavigation$ChatInitAlert$contactSupportCustom(translations)
	};
};
var $author$project$Translations$General$TopNavigation$contactSupportTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.contact_support_title');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$send = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.send');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$title = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.title');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$remove = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.remove');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$sendUs = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.send_us');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$thanks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.thanks');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$message = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.message');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$sending = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.sending');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$couldntSend = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.couldnt_send');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$maxFileSize = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.max_file_size');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$attachImages = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.attach_images');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$requiredTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.required_title');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$encounteredBug = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.encountered_bug');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$requiredFields = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.required_fields');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$detailedMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.detailed_message');
};
var $author$project$Translations$General$TopNavigation$SupportTicket$requiredMessage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.top_navigation.support_ticket.required_message');
};
var $author$project$Labels$globalSupportTicketLabels = function (translations) {
	return {
		send: $author$project$Translations$General$TopNavigation$SupportTicket$send(translations),
		title: $author$project$Translations$General$TopNavigation$SupportTicket$title(translations),
		header: $author$project$Translations$General$TopNavigation$sendFeedBack(translations),
		remove: $author$project$Translations$General$TopNavigation$SupportTicket$remove(translations),
		sendUs: $author$project$Translations$General$TopNavigation$SupportTicket$sendUs(translations),
		thanks: $author$project$Translations$General$TopNavigation$SupportTicket$thanks(translations),
		message: $author$project$Translations$General$TopNavigation$SupportTicket$message(translations),
		sending: $author$project$Translations$General$TopNavigation$SupportTicket$sending(translations),
		couldntSend: $author$project$Translations$General$TopNavigation$SupportTicket$couldntSend(translations),
		maxFileSize: $author$project$Translations$General$TopNavigation$SupportTicket$maxFileSize(translations),
		attachImages: $author$project$Translations$General$TopNavigation$SupportTicket$attachImages(translations),
		requiredTitle: $author$project$Translations$General$TopNavigation$SupportTicket$requiredTitle(translations),
		encounteredBug: $author$project$Translations$General$TopNavigation$SupportTicket$encounteredBug(translations),
		requiredFields: $author$project$Translations$General$TopNavigation$SupportTicket$requiredFields(translations),
		detailedMessage: $author$project$Translations$General$TopNavigation$SupportTicket$detailedMessage(translations),
		requiredMessage: $author$project$Translations$General$TopNavigation$SupportTicket$requiredMessage(translations)
	};
};
var $author$project$Labels$topNavigation = function (translations) {
	return {
		chat: $author$project$Translations$General$TopNavigation$chat(translations),
		help: $author$project$Translations$General$TopNavigation$help(translations),
		news: $author$project$Translations$General$TopNavigation$news(translations),
		user: $author$project$Translations$General$TopNavigation$userSettings(translations),
		admin: $author$project$Translations$General$TopNavigation$admin(translations),
		logout: $author$project$Translations$General$TopNavigation$logout(translations),
		account: $author$project$Translations$General$TopNavigation$accountSettings(translations),
		profile: $author$project$Translations$General$TopNavigation$profile(translations),
		language: $author$project$Translations$General$TopNavigation$language(translations),
		security: $author$project$Translations$General$TopNavigation$security(translations),
		helpCenter: $author$project$Translations$General$TopNavigation$helpCenter(translations),
		productInfo: {
			_new: $author$project$Translations$General$TopNavigation$ProductInfo$new(translations),
			posts: $author$project$Translations$General$TopNavigation$ProductInfo$posts(translations),
			places: $author$project$Translations$General$TopNavigation$ProductInfo$places(translations),
			locator: $author$project$Translations$General$TopNavigation$ProductInfo$locator(translations),
			reviews: $author$project$Translations$General$TopNavigation$ProductInfo$reviews(translations),
			champion: $author$project$Translations$General$TopNavigation$ProductInfo$champion(translations),
			listings: $author$project$Translations$General$TopNavigation$ProductInfo$listings(translations),
			learnMore: $author$project$Translations$General$TopNavigation$ProductInfo$learnMore(translations),
			aiVisibility: $author$project$Translations$General$TopNavigation$ProductInfo$aiVisibility(translations),
			conversations: $author$project$Translations$General$TopNavigation$ProductInfo$conversations(translations),
			localCampaigns: $author$project$Translations$General$TopNavigation$ProductInfo$localCampaigns(translations)
		},
		sendFeedBack: $author$project$Translations$General$TopNavigation$sendFeedBack(translations),
		userSettings: $author$project$Translations$General$TopNavigation$userSettings(translations),
		chatFailAlert: $author$project$Labels$chatInitAlertLabels(translations),
		notifications: $author$project$Translations$General$TopNavigation$notifications(translations),
		subscriptions: $author$project$Translations$General$TopNavigation$subscriptions(translations),
		supportTicket: $author$project$Labels$globalSupportTicketLabels(translations),
		switchAccount: $author$project$Translations$General$TopNavigation$switchAccount(translations),
		switchProduct: $author$project$Translations$General$TopNavigation$switchProduct(translations),
		legalDocuments: $author$project$Translations$General$TopNavigation$legalDocuments(translations),
		searchAccounts: $author$project$Translations$General$TopNavigation$searchAccounts(translations),
		accountSettings: $author$project$Translations$General$TopNavigation$accountSettings(translations),
		contactSupportBody: $author$project$Translations$General$TopNavigation$contactSupportBody(translations),
		contactSupportTitle: $author$project$Translations$General$TopNavigation$contactSupportTitle(translations)
	};
};
var $author$project$UserSettings$Model$SidebarSetCompact = function (a) {
	return {$: 'SidebarSetCompact', a: a};
};
var $author$project$Translations$UserSettings$Navigation$userSettingsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'user_settings.navigation.user_settings_title');
};
var $author$project$PinMeTo$Ui$Icon$AppIconUserSettings = {$: 'AppIconUserSettings'};
var $author$project$UserSettings$Main$view = function (model) {
	var _v0 = _Utils_Tuple3(
		_Utils_Tuple2(model.url, model.selectedSite),
		model.topNavigation,
		model.config);
	if ((((_v0.a.a.$ === 'Just') && (_v0.a.b.$ === 'Just')) && (_v0.b.$ === 'Just')) && (_v0.c.$ === 'Just')) {
		var _v1 = _v0.a;
		var currentUrl = _v1.a.a;
		var site = _v1.b.a.a;
		var topNavigation = _v0.b.a;
		var config = _v0.c.a;
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main splitview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('splitview__sidebar')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Global$Sidebar$render(
							$author$project$PinMeTo$Global$Sidebar$view(
								{
									url: currentUrl,
									mobile: model.mobile,
									compact: model.collapsed,
									product: {
										icon: $author$project$PinMeTo$Ui$Icon$AppIconUserSettings,
										path: model.productUrl,
										title: $author$project$Translations$UserSettings$Navigation$userSettingsTitle(model.translations),
										siteName: site.displayName
									},
									basePath: '/listings/',
									onToggle: $author$project$UserSettings$Model$SidebarSetCompact,
									navigation: A2(
										$author$project$UserSettings$Main$navigation,
										model,
										$author$project$PinMeTo$Global$TopNavigation$Model$Site(site)),
									workInProgress: model.workInProgress
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('splitview__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('splitview__top-navigation')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$PinMeTo$Global$TopNavigation$view,
									$author$project$UserSettings$Model$TopNavigationMsg,
									$author$project$Labels$topNavigation(model.translations),
									topNavigation)
								])),
							A2($author$project$UserSettings$Main$viewSettings, config, model)
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$General$errorOccurred(model.translations))
				]));
	}
};
var $author$project$UserSettings$Legal$update = F3(
	function (_v0, msg, model) {
		if (msg.$ === 'GetLegalDocuments') {
			var result = msg.a;
			if (result.$ === 'Ok') {
				var d = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documents: $author$project$RemoteData$Loaded(d)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var e = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							documents: $author$project$RemoteData$Error(
								$author$project$Util$httpErrorToString(e))
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			var zone = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{timeZone: zone}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$UserSettings$Language$encodeSettings = function (settings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'locale',
				$elm$json$Json$Encode$string(
					$author$project$PinMeTo$Ui$I18n$Locale$toString(settings.locale))),
				_Utils_Tuple2(
				'language',
				$elm$json$Json$Encode$string(
					$author$project$PinMeTo$Ui$I18n$Language$toString(settings.language)))
			]));
};
var $author$project$UserSettings$Language$SaveSettingsResponse = function (a) {
	return {$: 'SaveSettingsResponse', a: a};
};
var $author$project$UserSettings$Language$saveSettings = F2(
	function (tagger, settings) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$Language$SaveSettingsResponse, tagger),
					$author$project$UserSettings$Language$settingsDecoder,
					$elm$json$Json$Decode$string),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$UserSettings$Language$encodeSettings(settings),
					$lukewestby$elm_http_builder$HttpBuilder$put('api/user/settings'))));
	});
var $author$project$UserSettings$Language$update = F3(
	function (tagger, msg, model) {
		switch (msg.$) {
			case 'GetSettingsResponse':
				if (msg.a.$ === 'Ok') {
					var settings = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								settings: $author$project$RemoteData$Loaded(settings),
								saveResult: $author$project$RemoteData$Suspended,
								currentLocale: $elm$core$Maybe$Just(settings.locale),
								currentLanguage: $elm$core$Maybe$Just(settings.language)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								settings: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('UserSettings.Language.GetSettingsResponse'),
							e));
				}
			case 'Save':
				var settings = msg.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$UserSettings$Language$saveSettings, tagger, settings));
			case 'SaveSettingsResponse':
				if (msg.a.$ === 'Ok') {
					var settings = msg.a.a;
					var newModel = _Utils_update(
						model,
						{
							saveResult: $author$project$RemoteData$Loaded('Saved'),
							currentLocale: $elm$core$Maybe$Just(settings.locale),
							currentLanguage: $elm$core$Maybe$Just(settings.language)
						});
					return (!_Utils_eq(
						model.currentLanguage,
						$elm$core$Maybe$Just(settings.language))) ? _Utils_Tuple2(newModel, $elm$browser$Browser$Navigation$reload) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var error = $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								saveResult: $author$project$RemoteData$Error(error)
							}),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('UserSettings.Language.SaveSettingsResponse'),
							err));
				}
			case 'SelectLocale':
				var locale = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							settings: A2(
								$author$project$RemoteData$map,
								function (x) {
									return _Utils_update(
										x,
										{locale: locale});
								},
								model.settings)
						}),
					$elm$core$Platform$Cmd$none);
			case 'SelectLanguage':
				var l = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							settings: A2(
								$author$project$RemoteData$map,
								function (x) {
									return _Utils_update(
										x,
										{language: l.language});
								},
								model.settings)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3(
						$author$project$PinMeTo$Ui$Select$update,
						A2($elm$core$Basics$composeR, $author$project$UserSettings$Language$UiSelectMsg, tagger),
						subMsg,
						model.uiSelect));
		}
	});
var $author$project$UserSettings$ChangePassword$update = F3(
	function (_v0, msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$UserSettings$Profile$Model$GotFile = function (a) {
	return {$: 'GotFile', a: a};
};
var $author$project$UserSettings$Profile$Commands$userEncoder = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(user.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(user.lastName))
			]));
};
var $author$project$UserSettings$Profile$Model$SaveUserProfile = function (a) {
	return {$: 'SaveUserProfile', a: a};
};
var $author$project$UserSettings$Profile$Commands$saveInformation = F2(
	function (tagger, user) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$Profile$Model$SaveUserProfile, tagger),
					$author$project$UserSettings$Profile$Commands$userDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$UserSettings$Profile$Commands$userEncoder(user),
					$lukewestby$elm_http_builder$HttpBuilder$put('api/user/profile'))));
	});
var $author$project$UserSettings$Profile$Model$SaveProfileImage = function (a) {
	return {$: 'SaveProfileImage', a: a};
};
var $author$project$UserSettings$Profile$Commands$saveProfileImage = F2(
	function (tagger, file) {
		return $elm$http$Http$request(
			{
				url: 'api/user/profile/image',
				body: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file', file)
						])),
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$Profile$Model$SaveProfileImage, tagger),
					$author$project$UserSettings$Profile$Commands$userDecoder),
				method: 'PUT',
				headers: _List_Nil,
				timeout: $elm$core$Maybe$Nothing,
				tracker: $elm$core$Maybe$Just('upload')
			});
	});
var $author$project$UserSettings$Profile$Commands$removeProfileImage = function (tagger) {
	return $lukewestby$elm_http_builder$HttpBuilder$request(
		A2(
			$lukewestby$elm_http_builder$HttpBuilder$withExpect,
			A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $author$project$UserSettings$Profile$Model$SaveProfileImage, tagger),
				$author$project$UserSettings$Profile$Commands$userDecoder),
			$lukewestby$elm_http_builder$HttpBuilder$delete('api/user/profile/image')));
};
var $author$project$UserSettings$Profile$Update$update = F3(
	function (tagger, msg, model) {
		switch (msg.$) {
			case 'OnSave':
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (user) {
						return _Utils_Tuple2(
							model,
							A2($author$project$UserSettings$Profile$Commands$saveInformation, tagger, user));
					},
					$author$project$RemoteData$currentData(model.user));
			case 'OnChange':
				var id = msg.a;
				var value = msg.b;
				switch (id) {
					case 'firstName':
						return function (user) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{user: user}),
								$elm$core$Platform$Cmd$none);
						}(
							A2(
								$author$project$RemoteData$map,
								function (x) {
									return _Utils_update(
										x,
										{firstName: value});
								},
								model.user));
					case 'lastName':
						return function (user) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{user: user}),
								$elm$core$Platform$Cmd$none);
						}(
							A2(
								$author$project$RemoteData$map,
								function (x) {
									return _Utils_update(
										x,
										{lastName: value});
								},
								model.user));
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'GetUserProfile':
				if (msg.a.$ === 'Ok') {
					var profile = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								user: $author$project$RemoteData$Loaded(profile)
							}),
						A2(
							$author$project$Util$delay,
							3000,
							tagger($author$project$UserSettings$Profile$Model$RemoveResponseBanner)));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								user: $author$project$RemoteData$Error('')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'UserSettings.Profile.Update', message: 'Failed to GetUserProfile'}));
				}
			case 'SaveUserProfile':
				if (msg.a.$ === 'Ok') {
					var profile = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								user: $author$project$RemoteData$Loaded(profile),
								savingUser: $author$project$RemoteData$Loaded(profile)
							}),
						A2(
							$author$project$Util$delay,
							3000,
							tagger($author$project$UserSettings$Profile$Model$RemoveResponseBanner)));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								savingUser: $author$project$RemoteData$Error('')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'UserSettings.Profile.Update', message: 'Failed to SaveUserProfile'}));
				}
			case 'RemoveResponseBanner':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{savingUser: $author$project$RemoteData$Suspended}),
					$elm$core$Platform$Cmd$none);
			case 'Pick':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['image/*']),
						A2($elm$core$Basics$composeR, $author$project$UserSettings$Profile$Model$GotFile, tagger)));
			case 'GotFile':
				var file = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{savingUser: $author$project$RemoteData$Loading}),
					A2($author$project$UserSettings$Profile$Commands$saveProfileImage, tagger, file));
			case 'RemoveProfileImage':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{savingUser: $author$project$RemoteData$Loading}),
					$author$project$UserSettings$Profile$Commands$removeProfileImage(tagger));
			default:
				if (msg.a.$ === 'Ok') {
					var profile = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								user: $author$project$RemoteData$Loaded(profile),
								savingUser: $author$project$RemoteData$Loaded(profile)
							}),
						A2(
							$author$project$Util$delay,
							3000,
							tagger($author$project$UserSettings$Profile$Model$RemoveResponseBanner)));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								savingUser: $author$project$RemoteData$Error('')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'UserSettings.Profile.Update', message: 'Failed to save profile image'}));
				}
		}
	});
var $Gizra$elm_all_set$EverySet$remove = F2(
	function (k, _v0) {
		var d = _v0.a;
		return $Gizra$elm_all_set$EverySet$EverySet(
			A2($pzp1997$assoc_list$AssocList$remove, k, d));
	});
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0.a;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $Gizra$elm_all_set$EverySet$toList = function (_v0) {
	var d = _v0.a;
	return $pzp1997$assoc_list$AssocList$keys(d);
};
var $author$project$UserSettings$EmailNotifications$SaveResponse = function (a) {
	return {$: 'SaveResponse', a: a};
};
var $author$project$UserSettings$EmailNotifications$saveEmailSubscriptions = F3(
	function (tagger, _v0, subscriptions) {
		var siteName = _v0.a;
		var toString = function (day) {
			switch (day.$) {
				case 'Monday':
					return 'monday';
				case 'Tuesday':
					return 'tuesday';
				case 'Wednesday':
					return 'wednesday';
				case 'Thursday':
					return 'thursday';
				case 'Friday':
					return 'friday';
				case 'Saturday':
					return 'saturday';
				default:
					return 'sunday';
			}
		};
		var xs = A2(
			$elm$core$List$map,
			function (x) {
				return {
					day: toString(x),
					time: '10:00',
					zone: 'UTC'
				};
			},
			$Gizra$elm_all_set$EverySet$toList(subscriptions.days));
		var json = function () {
			var tasks = $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'_id',
						$elm$json$Json$Encode$string(subscriptions.id)),
						_Utils_Tuple2(
						'taskNotifications',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'enabled',
									$elm$json$Json$Encode$bool(subscriptions.taskNotificationsEnabled)),
									_Utils_Tuple2(
									'days',
									A2(
										$elm$json$Json$Encode$list,
										function (x) {
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'time',
														$elm$json$Json$Encode$string(x.time)),
														_Utils_Tuple2(
														'zone',
														$elm$json$Json$Encode$string(x.zone)),
														_Utils_Tuple2(
														'day',
														$elm$json$Json$Encode$string(x.day))
													]));
										},
										xs))
								]))),
						_Utils_Tuple2(
						'listenDigest',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'enabled',
									$elm$json$Json$Encode$bool(subscriptions.listenDigestEnabled))
								]))),
						_Utils_Tuple2(
						'listingsManagerDigest',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'enabled',
									$elm$json$Json$Encode$bool(subscriptions.listingsManagerDigestEnabled))
								])))
					]));
			var lists = A2(
				$elm$json$Json$Encode$list,
				function (x) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'listId',
								$elm$json$Json$Encode$int(x.listId)),
								_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string(
									_Utils_eq(x.status, $author$project$UserSettings$EmailNotifications$Subscribed) ? 'subscribed' : 'unsubscribed'))
							]));
				},
				subscriptions.lists);
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('notifications', tasks),
						_Utils_Tuple2('lists', lists)
					]));
		}();
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$EmailNotifications$SaveResponse, tagger),
					$author$project$UserSettings$EmailNotifications$subscriptionsDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					json,
					$lukewestby$elm_http_builder$HttpBuilder$put('api/' + (siteName + '/email-notifications/user')))));
	});
var $author$project$UserSettings$EmailNotifications$update = F3(
	function (tagger, msg, model) {
		switch (msg.$) {
			case 'GetSubscriptionsResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								subscriptions: $author$project$RemoteData$Loaded(x)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								subscriptions: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(e))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'Save':
				var _v1 = model.subscriptions;
				if (_v1.$ === 'Loaded') {
					var subscriptions = _v1.a;
					return _Utils_Tuple2(
						model,
						A3($author$project$UserSettings$EmailNotifications$saveEmailSubscriptions, tagger, model.siteName, subscriptions));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'SaveResponse':
				if (msg.a.$ === 'Ok') {
					var x = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								saving: $author$project$RemoteData$Loaded(x),
								subscriptions: $author$project$RemoteData$Loaded(x)
							}),
						A2(
							$author$project$Util$delay,
							3000,
							tagger($author$project$UserSettings$EmailNotifications$RemoveResponseBanner)));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								saving: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(e))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'RemoveResponseBanner':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{saving: $author$project$RemoteData$Suspended}),
					$elm$core$Platform$Cmd$none);
			case 'OnChangeDay':
				var day = msg.a;
				var value = msg.b;
				var _v2 = model.subscriptions;
				if (_v2.$ === 'Loaded') {
					var subscriptions = _v2.a;
					var days = value ? A2($Gizra$elm_all_set$EverySet$insert, day, subscriptions.days) : A2($Gizra$elm_all_set$EverySet$remove, day, subscriptions.days);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								subscriptions: $author$project$RemoteData$Loaded(
									_Utils_update(
										subscriptions,
										{days: days}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnChangePendingTasks':
				var value = msg.a;
				var _v3 = model.subscriptions;
				if (_v3.$ === 'Loaded') {
					var n = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								subscriptions: $author$project$RemoteData$Loaded(
									_Utils_update(
										n,
										{taskNotificationsEnabled: value}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnChangeListingsManagerDigest':
				var value = msg.a;
				var _v4 = model.subscriptions;
				if (_v4.$ === 'Loaded') {
					var n = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								subscriptions: $author$project$RemoteData$Loaded(
									_Utils_update(
										n,
										{listingsManagerDigestEnabled: value}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnChangeEmailList':
				var list = msg.a;
				var value = msg.b;
				var newLists = function (lists) {
					return A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_eq(x, list) ? _Utils_update(
								x,
								{
									status: value ? $author$project$UserSettings$EmailNotifications$Subscribed : $author$project$UserSettings$EmailNotifications$Unsubscribed
								}) : x;
						},
						lists);
				};
				return function (subs) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{subscriptions: subs}),
						$elm$core$Platform$Cmd$none);
				}(
					A2(
						$author$project$RemoteData$map,
						function (subs) {
							return _Utils_update(
								subs,
								{
									lists: newLists(subs.lists)
								});
						},
						model.subscriptions));
			default:
				var value = msg.a;
				var subscriptions = function () {
					var _v5 = model.subscriptions;
					if (_v5.$ === 'Loaded') {
						var loadedSubscriptions = _v5.a;
						return $author$project$RemoteData$Loaded(
							_Utils_update(
								loadedSubscriptions,
								{listenDigestEnabled: value}));
					} else {
						var other = _v5;
						return other;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{subscriptions: subscriptions}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$UserSettings$Notifications$Form$Editing = function (a) {
	return {$: 'Editing', a: a};
};
var $author$project$UserSettings$Notifications$Form$init = function (a) {
	return $author$project$UserSettings$Notifications$Form$Editing(
		{changes: a, original: a});
};
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$empty = {push: _List_Nil, email: _List_Nil};
var $author$project$UserSettings$Notifications$Form$Saving = function (a) {
	return {$: 'Saving', a: a};
};
var $author$project$UserSettings$Notifications$Form$update = F2(
	function (f, form) {
		if (form.$ === 'Editing') {
			var data = form.a;
			return $author$project$UserSettings$Notifications$Form$Editing(
				_Utils_update(
					data,
					{
						changes: f(data.changes)
					}));
		} else {
			var a = form.a;
			return $author$project$UserSettings$Notifications$Form$Saving(a);
		}
	});
var $author$project$UserSettings$Notifications$Form$toSaving = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return $author$project$UserSettings$Notifications$Form$Saving(data.changes);
	} else {
		var a = form.a;
		return $author$project$UserSettings$Notifications$Form$Saving(a);
	}
};
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$subscribeToPush = F3(
	function (subscribe, event, subscription) {
		return _Utils_update(
			subscription,
			{
				push: subscribe ? A2($elm$core$List$cons, event, subscription.push) : A2(
					$elm$core$List$filter,
					function (x) {
						return !_Utils_eq(x, event);
					},
					subscription.push)
			});
	});
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$subscribeToEmail = F3(
	function (subscribe, event, subscription) {
		return _Utils_update(
			subscription,
			{
				email: subscribe ? A2($elm$core$List$cons, event, subscription.email) : A2(
					$elm$core$List$filter,
					function (x) {
						return !_Utils_eq(x, event);
					},
					subscription.email)
			});
	});
var $author$project$UserSettings$Notifications$Data$Event$encode = function (event) {
	switch (event.$) {
		case 'NewGoogleReview':
			return $elm$json$Json$Encode$string('NewGoogleReview');
		case 'NewFacebookRecommendation':
			return $elm$json$Json$Encode$string('NewFacebookRecommendation');
		case 'NewFacebookComment':
			return $elm$json$Json$Encode$string('NewFacebookComment');
		case 'NewFacebookUserPost':
			return $elm$json$Json$Encode$string('NewFacebookUserPost');
		case 'NewFacebookMention':
			return $elm$json$Json$Encode$string('NewFacebookMention');
		case 'IssueAssigned':
			return $elm$json$Json$Encode$string('IssueAssigned');
		case 'NewInstagramComment':
			return $elm$json$Json$Encode$string('NewInstagramComment');
		case 'NewInstagramMention':
			return $elm$json$Json$Encode$string('NewInstagramMention');
		case 'NewTrustpilotReview':
			return $elm$json$Json$Encode$string('NewTrustpilotReview');
		case 'NewFacebookDirectMessage':
			return $elm$json$Json$Encode$string('NewFacebookDirectMessage');
		default:
			return $elm$json$Json$Encode$string('NewInstagramDirectMessage');
	}
};
var $author$project$UserSettings$Notifications$Data$NotificationSubscription$encode = function (subscription) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'push',
				A2($elm$json$Json$Encode$list, $author$project$UserSettings$Notifications$Data$Event$encode, subscription.push)),
				_Utils_Tuple2(
				'email',
				A2($elm$json$Json$Encode$list, $author$project$UserSettings$Notifications$Data$Event$encode, subscription.email))
			]));
};
var $author$project$UserSettings$Notifications$Commands$saveNotificationSubscription = F3(
	function (siteName, msg, data) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$Notifications$Data$NotificationSubscription$decoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$UserSettings$Notifications$Data$NotificationSubscription$encode(data),
					$lukewestby$elm_http_builder$HttpBuilder$put('api/user/' + (siteName + '/notifications')))));
	});
var $author$project$UserSettings$Notifications$Main$updateForm = F4(
	function (tagger, siteName, msg, form) {
		switch (msg.$) {
			case 'Save':
				var afterDelay = msg.a;
				var subscription = $author$project$UserSettings$Notifications$Form$unwrap(form);
				return _Utils_Tuple2(
					$author$project$UserSettings$Notifications$Form$toSaving(form),
					afterDelay ? A3(
						$author$project$UserSettings$Notifications$Commands$saveNotificationSubscription,
						siteName,
						A2($elm$core$Basics$composeR, $author$project$UserSettings$Notifications$Model$ReceivedNotificationSubscription, tagger),
						subscription) : A2(
						$author$project$Util$delay,
						500,
						tagger(
							$author$project$UserSettings$Notifications$Model$FormMsg(
								$author$project$UserSettings$Notifications$Model$Save(true)))));
			case 'ToggleEventForPush':
				var event = msg.a;
				var checked = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$UserSettings$Notifications$Form$update,
						A2($author$project$UserSettings$Notifications$Data$NotificationSubscription$subscribeToPush, checked, event),
						form),
					$elm$core$Platform$Cmd$none);
			default:
				var event = msg.a;
				var checked = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$UserSettings$Notifications$Form$update,
						A2($author$project$UserSettings$Notifications$Data$NotificationSubscription$subscribeToEmail, checked, event),
						form),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$UserSettings$Notifications$Main$update = F4(
	function (tagger, portOutRegisterPush, msg, model) {
		switch (msg.$) {
			case 'PushSubscriptionChanged':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var currentSubscription = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: A2(
									$author$project$RemoteData$map,
									function (form) {
										return A2(
											$elm$core$Maybe$withDefault,
											form,
											A2(
												$elm$core$Maybe$map,
												function (event) {
													if (currentSubscription.$ === 'Granted') {
														return A2(
															$author$project$UserSettings$Notifications$Form$update,
															A2($author$project$UserSettings$Notifications$Data$NotificationSubscription$subscribeToPush, true, event),
															form);
													} else {
														return form;
													}
												},
												model.askingForPushWithEvent));
									},
									model.form),
								currentSubscription: $author$project$RemoteData$Loaded(currentSubscription),
								askingForPushWithEvent: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								currentSubscription: $author$project$RemoteData$Error('Something went wrong')
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(error),
								context: 'UserSettings.Main',
								message: 'PushSubscriptionChanged failed'
							}));
				}
			case 'ReceivedNotificationSubscription':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var notificationSubscription = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $author$project$RemoteData$Loaded(
									$author$project$UserSettings$Notifications$Form$init(notificationSubscription))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					if ((error.$ === 'BadStatus') && (error.a === 404)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									form: $author$project$RemoteData$Loaded(
										$author$project$UserSettings$Notifications$Form$init($author$project$UserSettings$Notifications$Data$NotificationSubscription$empty))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var unexpectedError = error;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									form: $author$project$RemoteData$Error('Something went wrong')
								}),
							$author$project$PinMeTo$Logger$logHttpError(
								{data: unexpectedError, context: 'UserSettings.Main', message: 'ReceivedNotificationSubscription failed'}));
					}
				}
			case 'ReceivedPushSubscriptions':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var pushSubscriptions = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pushSubscriptions: $author$project$RemoteData$Loaded(pushSubscriptions)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pushSubscriptions: $author$project$RemoteData$Error('error')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: error, context: 'UserSettings.Main', message: 'ReceivedNotificationSubscription failed'}));
				}
			case 'AskForPush':
				var event = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{askingForPushWithEvent: event}),
					portOutRegisterPush(true));
			default:
				var msg_ = msg.a;
				var _v6 = model.form;
				if (_v6.$ === 'Loaded') {
					var form = _v6.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (updated) {
							return _Utils_update(
								model,
								{
									form: $author$project$RemoteData$Loaded(updated)
								});
						},
						A4($author$project$UserSettings$Notifications$Main$updateForm, tagger, model.siteName, msg_, form));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{data: 'Tried to update non loaded form. This should never happen!', context: 'UserSettings.Main', message: 'Form update'}));
				}
		}
	});
var $author$project$UserSettings$PostsNotifications$Form$Editing = function (a) {
	return {$: 'Editing', a: a};
};
var $author$project$UserSettings$PostsNotifications$Form$init = function (a) {
	return $author$project$UserSettings$PostsNotifications$Form$Editing(
		{changes: a, original: a});
};
var $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$empty = {push: _List_Nil, email: _List_Nil};
var $author$project$UserSettings$PostsNotifications$Form$Saving = function (a) {
	return {$: 'Saving', a: a};
};
var $author$project$UserSettings$PostsNotifications$Form$update = F2(
	function (f, form) {
		if (form.$ === 'Editing') {
			var data = form.a;
			return $author$project$UserSettings$PostsNotifications$Form$Editing(
				_Utils_update(
					data,
					{
						changes: f(data.changes)
					}));
		} else {
			var a = form.a;
			return $author$project$UserSettings$PostsNotifications$Form$Saving(a);
		}
	});
var $author$project$UserSettings$PostsNotifications$Form$toSaving = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return $author$project$UserSettings$PostsNotifications$Form$Saving(data.changes);
	} else {
		var a = form.a;
		return $author$project$UserSettings$PostsNotifications$Form$Saving(a);
	}
};
var $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$subscribeToEmail = F3(
	function (subscribe, event, subscription) {
		return _Utils_update(
			subscription,
			{
				email: subscribe ? A2($elm$core$List$cons, event, subscription.email) : A2(
					$elm$core$List$filter,
					function (x) {
						return !_Utils_eq(x, event);
					},
					subscription.email)
			});
	});
var $author$project$UserSettings$PostsNotifications$Data$Event$encode = function (event) {
	if (event.$ === 'SuccessfullyScheduledPosts') {
		return $elm$json$Json$Encode$string('SuccessfullyScheduledPosts');
	} else {
		return $elm$json$Json$Encode$string('FailedScheduledPosts');
	}
};
var $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$encode = function (subscription) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pushForPosts',
				A2($elm$json$Json$Encode$list, $author$project$UserSettings$PostsNotifications$Data$Event$encode, subscription.push)),
				_Utils_Tuple2(
				'emailForPosts',
				A2($elm$json$Json$Encode$list, $author$project$UserSettings$PostsNotifications$Data$Event$encode, subscription.email))
			]));
};
var $author$project$UserSettings$PostsNotifications$Commands$saveNotificationSubscription = F3(
	function (siteName, msg, data) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$decoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$encode(data),
					$lukewestby$elm_http_builder$HttpBuilder$put('api/user/' + (siteName + '/notifications')))));
	});
var $author$project$UserSettings$PostsNotifications$Main$updateForm = F4(
	function (tagger, siteName, msg, form) {
		if (msg.$ === 'Save') {
			var afterDelay = msg.a;
			var subscription = $author$project$UserSettings$PostsNotifications$Form$unwrap(form);
			return _Utils_Tuple2(
				$author$project$UserSettings$PostsNotifications$Form$toSaving(form),
				afterDelay ? A3(
					$author$project$UserSettings$PostsNotifications$Commands$saveNotificationSubscription,
					siteName,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$PostsNotifications$Model$ReceivedNotificationSubscription, tagger),
					subscription) : A2(
					$author$project$Util$delay,
					500,
					tagger(
						$author$project$UserSettings$PostsNotifications$Model$FormMsg(
							$author$project$UserSettings$PostsNotifications$Model$Save(true)))));
		} else {
			var event = msg.a;
			var checked = msg.b;
			return _Utils_Tuple2(
				A2(
					$author$project$UserSettings$PostsNotifications$Form$update,
					A2($author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$subscribeToEmail, checked, event),
					form),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$UserSettings$PostsNotifications$Main$update = F3(
	function (tagger, msg, model) {
		if (msg.$ === 'ReceivedNotificationSubscription') {
			var result = msg.a;
			if (result.$ === 'Ok') {
				var notificationSubscription = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: $author$project$RemoteData$Loaded(
								$author$project$UserSettings$PostsNotifications$Form$init(notificationSubscription))
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var error = result.a;
				if ((error.$ === 'BadStatus') && (error.a === 404)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $author$project$RemoteData$Loaded(
									$author$project$UserSettings$PostsNotifications$Form$init($author$project$UserSettings$PostsNotifications$Data$NotificationSubscription$empty))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var unexpectedError = error;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $author$project$RemoteData$Error('Something went wrong')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: unexpectedError, context: 'UserSettings.Main', message: 'ReceivedNotificationSubscription failed'}));
				}
			}
		} else {
			var msg_ = msg.a;
			var _v3 = model.form;
			if (_v3.$ === 'Loaded') {
				var form = _v3.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updated) {
						return _Utils_update(
							model,
							{
								form: $author$project$RemoteData$Loaded(updated)
							});
					},
					A4($author$project$UserSettings$PostsNotifications$Main$updateForm, tagger, model.siteName, msg_, form));
			} else {
				return _Utils_Tuple2(
					model,
					$author$project$PinMeTo$Logger$log(
						{data: 'Tried to update non loaded form. This should never happen!', context: 'UserSettings.Main', message: 'Form update'}));
			}
		}
	});
var $author$project$UserSettings$PlacesAINotifications$Form$Editing = function (a) {
	return {$: 'Editing', a: a};
};
var $author$project$UserSettings$PlacesAINotifications$Form$init = function (a) {
	return $author$project$UserSettings$PlacesAINotifications$Form$Editing(
		{changes: a, original: a});
};
var $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$empty = {email: _List_Nil};
var $author$project$UserSettings$PlacesAINotifications$Form$Saving = function (a) {
	return {$: 'Saving', a: a};
};
var $author$project$UserSettings$PlacesAINotifications$Form$update = F2(
	function (f, form) {
		if (form.$ === 'Editing') {
			var data = form.a;
			return $author$project$UserSettings$PlacesAINotifications$Form$Editing(
				_Utils_update(
					data,
					{
						changes: f(data.changes)
					}));
		} else {
			var a = form.a;
			return $author$project$UserSettings$PlacesAINotifications$Form$Saving(a);
		}
	});
var $author$project$UserSettings$PlacesAINotifications$Form$toSaving = function (form) {
	if (form.$ === 'Editing') {
		var data = form.a;
		return $author$project$UserSettings$PlacesAINotifications$Form$Saving(data.changes);
	} else {
		var a = form.a;
		return $author$project$UserSettings$PlacesAINotifications$Form$Saving(a);
	}
};
var $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$subscribeToEmail = F3(
	function (subscribe, event, subscription) {
		return _Utils_update(
			subscription,
			{
				email: subscribe ? A2($elm$core$List$cons, event, subscription.email) : A2(
					$elm$core$List$filter,
					function (x) {
						return !_Utils_eq(x, event);
					},
					subscription.email)
			});
	});
var $author$project$UserSettings$PlacesAINotifications$Data$Event$encode = function (event) {
	return $elm$json$Json$Encode$string('ActionAssigned');
};
var $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$encode = function (subscription) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'emailForPlacesAI',
				A2($elm$json$Json$Encode$list, $author$project$UserSettings$PlacesAINotifications$Data$Event$encode, subscription.email))
			]));
};
var $author$project$UserSettings$PlacesAINotifications$Commands$saveNotificationSubscription = F3(
	function (siteName, msg, data) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$decoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withJsonBody,
					$author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$encode(data),
					$lukewestby$elm_http_builder$HttpBuilder$put('api/user/' + (siteName + '/notifications')))));
	});
var $author$project$UserSettings$PlacesAINotifications$Main$updateForm = F4(
	function (tagger, siteName, msg, form) {
		if (msg.$ === 'Save') {
			var afterDelay = msg.a;
			var subscription = $author$project$UserSettings$PlacesAINotifications$Form$unwrap(form);
			return _Utils_Tuple2(
				$author$project$UserSettings$PlacesAINotifications$Form$toSaving(form),
				afterDelay ? A3(
					$author$project$UserSettings$PlacesAINotifications$Commands$saveNotificationSubscription,
					siteName,
					A2($elm$core$Basics$composeR, $author$project$UserSettings$PlacesAINotifications$Model$ReceivedNotificationSubscription, tagger),
					subscription) : A2(
					$author$project$Util$delay,
					500,
					tagger(
						$author$project$UserSettings$PlacesAINotifications$Model$FormMsg(
							$author$project$UserSettings$PlacesAINotifications$Model$Save(true)))));
		} else {
			var event = msg.a;
			var checked = msg.b;
			return _Utils_Tuple2(
				A2(
					$author$project$UserSettings$PlacesAINotifications$Form$update,
					A2($author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$subscribeToEmail, checked, event),
					form),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$UserSettings$PlacesAINotifications$Main$update = F3(
	function (tagger, msg, model) {
		if (msg.$ === 'ReceivedNotificationSubscription') {
			var result = msg.a;
			if (result.$ === 'Ok') {
				var notificationSubscription = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							form: $author$project$RemoteData$Loaded(
								$author$project$UserSettings$PlacesAINotifications$Form$init(notificationSubscription))
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var error = result.a;
				if ((error.$ === 'BadStatus') && (error.a === 404)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $author$project$RemoteData$Loaded(
									$author$project$UserSettings$PlacesAINotifications$Form$init($author$project$UserSettings$PlacesAINotifications$Data$NotificationSubscription$empty))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var unexpectedError = error;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								form: $author$project$RemoteData$Error('Something went wrong')
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: unexpectedError, context: 'UserSettings.Main', message: 'ReceivedNotificationSubscription failed'}));
				}
			}
		} else {
			var msg_ = msg.a;
			var _v3 = model.form;
			if (_v3.$ === 'Loaded') {
				var form = _v3.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (updated) {
						return _Utils_update(
							model,
							{
								form: $author$project$RemoteData$Loaded(updated)
							});
					},
					A4($author$project$UserSettings$PlacesAINotifications$Main$updateForm, tagger, model.siteName, msg_, form));
			} else {
				return _Utils_Tuple2(
					model,
					$author$project$PinMeTo$Logger$log(
						{data: 'Tried to update non loaded form. This should never happen!', context: 'UserSettings.Main', message: 'Form update'}));
			}
		}
	});
var $author$project$UserSettings$Main$urlToView = F2(
	function (_v0, url) {
		var site = _v0.a;
		var path = A3($elm$core$String$replace, '/listings/' + site.name, '', url.path);
		switch (path) {
			case '/user/profile':
				return $author$project$UserSettings$Model$Profile($elm$core$Maybe$Nothing);
			case '/user/email-notifications':
				return $author$project$UserSettings$Model$EmailNotifications($elm$core$Maybe$Nothing);
			case '/user/notifications':
				return $author$project$UserSettings$Model$Notifications($elm$core$Maybe$Nothing);
			case '/user/notifications-posts':
				return $author$project$UserSettings$Model$NotificationsPosts($elm$core$Maybe$Nothing);
			case '/user/notifications-places-ai':
				return $author$project$UserSettings$Model$NotificationsPlacesAI($elm$core$Maybe$Nothing);
			case '/user/change-password':
				return $author$project$UserSettings$Main$showChangePassword(site.authenticationType) ? $author$project$UserSettings$Model$ChangePassword($elm$core$Maybe$Nothing) : $author$project$UserSettings$Model$Profile($elm$core$Maybe$Nothing);
			case '/user/legal':
				return $author$project$UserSettings$Model$LegalDocuments($elm$core$Maybe$Nothing);
			case '/user/language':
				return $author$project$UserSettings$Model$Language($elm$core$Maybe$Nothing);
			default:
				return $author$project$UserSettings$Model$EmailNotifications($elm$core$Maybe$Nothing);
		}
	});
var $author$project$UserSettings$Main$updateNavigateTo = F2(
	function (viewToNavigateTo, model) {
		var _v0 = model.selectedSite;
		if (_v0.$ === 'Just') {
			var site = _v0.a.a;
			switch (viewToNavigateTo.$) {
				case 'EmailNotifications':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$EmailNotifications(
										$elm$core$Maybe$Just(x))
								});
						},
						A3(
							$author$project$UserSettings$EmailNotifications$init,
							$author$project$UserSettings$Model$EmailNotificationsMsg,
							$author$project$UserSettings$EmailNotifications$SiteName(site.name),
							model.translations));
				case 'Notifications':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$Notifications(
										$elm$core$Maybe$Just(x))
								});
						},
						A4($author$project$UserSettings$Notifications$Main$init, $author$project$UserSettings$Model$NotificationsMsg, $author$project$UserSettings$Main$out_UserSettings_Main_getCurrentPushSubscription, site.name, site.listenRespond.product));
				case 'NotificationsPosts':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$NotificationsPosts(
										$elm$core$Maybe$Just(x))
								});
						},
						A2($author$project$UserSettings$PostsNotifications$Main$init, $author$project$UserSettings$Model$PostsNotificationsMsg, site.name));
				case 'NotificationsPlacesAI':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$NotificationsPlacesAI(
										$elm$core$Maybe$Just(x))
								});
						},
						A2($author$project$UserSettings$PlacesAINotifications$Main$init, $author$project$UserSettings$Model$PlacesAINotificationsMsg, site.name));
				case 'ChangePassword':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$ChangePassword(
										$elm$core$Maybe$Just(x))
								});
						},
						$author$project$UserSettings$ChangePassword$init(model.user));
				case 'Profile':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (subModel) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$Profile(
										$elm$core$Maybe$Just(subModel))
								});
						},
						$author$project$UserSettings$Main$userProfileInit(model.translations));
				case 'LegalDocuments':
					return A2(
						$elm$core$Tuple$mapFirst,
						function (subModel) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$LegalDocuments(
										$elm$core$Maybe$Just(subModel))
								});
						},
						A2($author$project$UserSettings$Legal$init, $author$project$UserSettings$Model$LegalMsg, model.translations));
				default:
					return A2(
						$elm$core$Tuple$mapFirst,
						function (subModel) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$Language(
										$elm$core$Maybe$Just(subModel))
								});
						},
						A3($author$project$UserSettings$Language$init, $author$project$UserSettings$Model$LanguageMsg, model.user, model.translations));
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Common$Language$decodeTranslations = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Common$Language$translationsDecoder, flags);
};
var $author$project$PinMeTo$Global$TopNavigation$updateProfileImage = F2(
	function (url, _v0) {
		var model = _v0.a;
		return _Utils_Tuple2(
			$author$project$PinMeTo$Global$TopNavigation$State(
				_Utils_update(
					model,
					{
						userProfileImageUrl: $elm$core$Maybe$Just(url)
					})),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$PinMeTo$Global$TopNavigation$Msg$NoOp = {$: 'NoOp'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$out_Navigation_Main_PinMeToUiInitChat = _Platform_outgoingPort(
	'out_Navigation_Main_PinMeToUiInitChat',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.email)),
					_Utils_Tuple2(
					'locale',
					$elm$json$Json$Encode$string($.locale)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string($.language)),
					_Utils_Tuple2(
					'lastName',
					$elm$json$Json$Encode$string($.lastName)),
					_Utils_Tuple2(
					'siteName',
					$elm$json$Json$Encode$string($.siteName)),
					_Utils_Tuple2(
					'firstName',
					$elm$json$Json$Encode$string($.firstName)),
					_Utils_Tuple2(
					'profileImage',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.profileImage)),
					_Utils_Tuple2(
					'encryptedEmail',
					$elm$json$Json$Encode$string($.encryptedEmail))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$out_UserSettings_Main_PinMeToUiInitChat = _Platform_outgoingPort(
	'out_UserSettings_Main_PinMeToUiInitChat',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.email)),
					_Utils_Tuple2(
					'locale',
					$elm$json$Json$Encode$string($.locale)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string($.language)),
					_Utils_Tuple2(
					'lastName',
					$elm$json$Json$Encode$string($.lastName)),
					_Utils_Tuple2(
					'siteName',
					$elm$json$Json$Encode$string($.siteName)),
					_Utils_Tuple2(
					'firstName',
					$elm$json$Json$Encode$string($.firstName)),
					_Utils_Tuple2(
					'profileImage',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.profileImage)),
					_Utils_Tuple2(
					'encryptedEmail',
					$elm$json$Json$Encode$string($.encryptedEmail))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$initChat = function (user) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$PinMeTo$Global$TopNavigation$Chat$out_Navigation_Main_PinMeToUiInitChat(user),
				$author$project$PinMeTo$Global$TopNavigation$Chat$out_UserSettings_Main_PinMeToUiInitChat(user)
			]));
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$out_Navigation_Main_PinMeToUiToggleChat = _Platform_outgoingPort(
	'out_Navigation_Main_PinMeToUiToggleChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$out_UserSettings_Main_PinMeToUiToggleChat = _Platform_outgoingPort(
	'out_UserSettings_Main_PinMeToUiToggleChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$toggleChat = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[
			$author$project$PinMeTo$Global$TopNavigation$Chat$out_Navigation_Main_PinMeToUiToggleChat(_Utils_Tuple0),
			$author$project$PinMeTo$Global$TopNavigation$Chat$out_UserSettings_Main_PinMeToUiToggleChat(_Utils_Tuple0)
		]));
var $author$project$PinMeTo$Global$TopNavigation$Chat$InitSuccess = {$: 'InitSuccess'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailHidden = {$: 'InitFailHidden'};
var $author$project$PinMeTo$Global$TopNavigation$Chat$toggleFail = function (initState) {
	switch (initState.$) {
		case 'InitFailHidden':
			return $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailShown;
		case 'InitPending':
			return $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailShown;
		case 'InitFailShown':
			return $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailHidden;
		default:
			return $author$project$PinMeTo$Global$TopNavigation$Chat$InitSuccess;
	}
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$update = F2(
	function (msg, _v0) {
		var s = _v0.a;
		switch (msg.$) {
			case 'GotStatus':
				if (msg.a.$ === 'Ok') {
					var info = msg.a.a;
					var rawUser = info.user;
					var user = A2(
						$elm$core$Maybe$withDefault,
						rawUser,
						A2(
							$elm$core$Maybe$map,
							function (name) {
								return _Utils_update(
									rawUser,
									{siteName: name});
							},
							s.companyName));
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$TopNavigation$Chat$State(
							_Utils_update(
								s,
								{
									info: $elm$core$Maybe$Just(
										_Utils_update(
											info,
											{user: user}))
								})),
						$author$project$PinMeTo$Global$TopNavigation$Chat$initChat(user));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$TopNavigation$Chat$State(s),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('PinMeTo.Global.TopNavigation.Chat'),
							err));
				}
			case 'GotInitResponse':
				var success = msg.a.success;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Chat$State(
						_Utils_update(
							s,
							{
								initState: success ? $author$project$PinMeTo$Global$TopNavigation$Chat$InitSuccess : $author$project$PinMeTo$Global$TopNavigation$Chat$InitFailHidden
							})),
					$elm$core$Platform$Cmd$none);
			case 'ToggleRequested':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Chat$State(
						_Utils_update(
							s,
							{
								initState: $author$project$PinMeTo$Global$TopNavigation$Chat$toggleFail(s.initState)
							})),
					$author$project$PinMeTo$Global$TopNavigation$Chat$toggleChat);
			case 'FailLightboxToggled':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Chat$State(
						_Utils_update(
							s,
							{
								initState: $author$project$PinMeTo$Global$TopNavigation$Chat$toggleFail(s.initState)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Chat$State(
						_Utils_update(
							s,
							{notEnabledOpen: !s.notEnabledOpen})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$toggle = function (state) {
	return A2($author$project$PinMeTo$Global$TopNavigation$Chat$update, $author$project$PinMeTo$Global$TopNavigation$Chat$ToggleRequested, state);
};
var $author$project$PinMeTo$Global$SupportTicket$Open = function (a) {
	return {$: 'Open', a: a};
};
var $author$project$PinMeTo$Global$SupportTicket$Sent = {$: 'Sent'};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$PinMeTo$Global$SupportTicket$SetImages = F2(
	function (a, b) {
		return {$: 'SetImages', a: a, b: b};
	});
var $author$project$PinMeTo$Global$SupportTicket$ImgReceived = F2(
	function (a, b) {
		return {$: 'ImgReceived', a: a, b: b};
	});
var $author$project$PinMeTo$Api$SupportTicketApi$AttachedImage = F3(
	function (type_, name, url) {
		return {url: url, name: name, type_: type_};
	});
var $author$project$PinMeTo$Api$SupportTicketApi$attachedImageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PinMeTo$Api$SupportTicketApi$AttachedImage))));
var $author$project$PinMeTo$Api$SupportTicketApi$uploadMedia = F3(
	function (siteName, tickets, msg) {
		var ticketList = A2(
			$elm$core$List$map,
			$elm$http$Http$filePart('files'),
			$elm$core$Dict$values(tickets));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$PinMeTo$Api$SupportTicketApi$attachedImageDecoder)),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withBody,
					$elm$http$Http$multipartBody(ticketList),
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('/api/' + (siteName + '/feedback-media'))))));
	});
var $author$project$PinMeTo$Global$SupportTicket$MediaUploaded = function (a) {
	return {$: 'MediaUploaded', a: a};
};
var $author$project$PinMeTo$Global$SupportTicket$ResponseError = {$: 'ResponseError'};
var $author$project$PinMeTo$Global$SupportTicket$OnSubmitTicket = {$: 'OnSubmitTicket'};
var $author$project$PinMeTo$Global$SupportTicket$update = F3(
	function (_v0, msg, _v1) {
		var sendTicketCmd = _v0.sendTicketCmd;
		var model = _v1.a;
		var nonEmptyString = function (str) {
			return (str !== '') ? $elm$core$Maybe$Just(str) : $elm$core$Maybe$Nothing;
		};
		switch (msg.$) {
			case 'ToggleSupportTicket':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{open: true})),
					$elm$core$Platform$Cmd$none);
			case 'SelectImg':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(model),
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['image/*']),
						$author$project$PinMeTo$Global$SupportTicket$ImgReceived));
			case 'ImgReceived':
				var file = msg.a;
				var files = msg.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(model),
					A2(
						$elm$core$Task$perform,
						$author$project$PinMeTo$Global$SupportTicket$SetImages(
							A2($elm$core$List$cons, file, files)),
						$elm$core$Task$sequence(
							A2(
								$elm$core$List$map,
								$elm$file$File$toUrl,
								A2($elm$core$List$cons, file, files)))));
			case 'SetImages':
				var imageFiles = msg.a;
				var urls = msg.b;
				var imagePairs = A3($elm$core$List$map2, $elm$core$Tuple$pair, urls, imageFiles);
				var newImageFiles = A3(
					$elm$core$List$foldl,
					function (_v3) {
						var url = _v3.a;
						var file = _v3.b;
						return A2($elm$core$Dict$insert, url, file);
					},
					model.imageFiles,
					imagePairs);
				var images = A2(
					$elm$core$Set$union,
					$elm$core$Set$fromList(urls),
					model.images);
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{images: images, imageFiles: newImageFiles, sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing})),
					$elm$core$Platform$Cmd$none);
			case 'RemoveImage':
				var url = msg.a;
				var imageFiles = A2($elm$core$Dict$remove, url, model.imageFiles);
				var images = A2(
					$elm$core$Set$filter,
					function (x) {
						return !_Utils_eq(x, url);
					},
					model.images);
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{images: images, imageFiles: imageFiles, sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing})),
					$elm$core$Platform$Cmd$none);
			case 'SetTitle':
				var title = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{
								title: nonEmptyString(title),
								sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing
							})),
					$elm$core$Platform$Cmd$none);
			case 'SetMessage':
				var message = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{
								message: nonEmptyString(message),
								sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing
							})),
					$elm$core$Platform$Cmd$none);
			case 'ValidateTicket':
				var formInvalid = _Utils_eq(model.title, $elm$core$Maybe$Nothing) || _Utils_eq(model.message, $elm$core$Maybe$Nothing);
				return formInvalid ? _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{showRequiredMessage: true})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{showRequiredMessage: false})),
					A2(
						$elm$core$Task$perform,
						function (_v4) {
							return $author$project$PinMeTo$Global$SupportTicket$OnSubmitTicket;
						},
						$elm$core$Task$succeed(_Utils_Tuple0)));
			case 'OnSubmitTicket':
				var message = A2($elm$core$Maybe$withDefault, '', model.message);
				var title = A2($elm$core$Maybe$withDefault, '', model.title);
				return $elm$core$Set$isEmpty(model.images) ? _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{sendStatus: $author$project$PinMeTo$Global$SupportTicket$Sending})),
					sendTicketCmd(
						{title: title, images: _List_Nil, message: message})) : _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{sendStatus: $author$project$PinMeTo$Global$SupportTicket$Sending})),
					A3($author$project$PinMeTo$Api$SupportTicketApi$uploadMedia, model.siteName, model.imageFiles, $author$project$PinMeTo$Global$SupportTicket$MediaUploaded));
			case 'TicketSubmitted':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$SupportTicket$State(
							_Utils_update(
								model,
								{error: $elm$core$Maybe$Nothing, sendStatus: $author$project$PinMeTo$Global$SupportTicket$Sent})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$SupportTicket$State(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just($author$project$PinMeTo$Global$SupportTicket$ResponseError),
									sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'MediaUploaded':
				if (msg.a.$ === 'Ok') {
					var attachedImages = msg.a.a;
					var ticket = {
						title: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, model.title),
						images: attachedImages,
						message: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, model.message)
					};
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$SupportTicket$State(model),
						sendTicketCmd(ticket));
				} else {
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$SupportTicket$State(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just($author$project$PinMeTo$Global$SupportTicket$ResponseError),
									sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OpenImage':
				var url = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{
								imagePreview: $author$project$PinMeTo$Global$SupportTicket$Open(url)
							})),
					$elm$core$Platform$Cmd$none);
			case 'CloseImage':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{imagePreview: $author$project$PinMeTo$Global$SupportTicket$Closed})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_eq(model.sendStatus, $author$project$PinMeTo$Global$SupportTicket$Sent) ? _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$init(model.siteName),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$PinMeTo$Global$SupportTicket$State(
						_Utils_update(
							model,
							{open: false, sendStatus: $author$project$PinMeTo$Global$SupportTicket$Editing})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$None = {$: 'None'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$Batch = function (a) {
	return {$: 'Batch', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$SetFocus = function (a) {
	return {$: 'SetFocus', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$ExternalMsg = function (a) {
	return {$: 'ExternalMsg', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$update = F2(
	function (msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'ToggleRoot':
				var index = msg.a;
				var n = msg.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(
						_Utils_update(
							model,
							{
								activeTopNavigationIndex: _Utils_eq(
									model.activeTopNavigationIndex,
									$elm$core$Maybe$Just(index)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(index)
							})),
					$author$project$PinMeTo$Global$TopNavigation$Navigation$Batch(
						_List_fromArray(
							[
								$author$project$PinMeTo$Global$TopNavigation$Navigation$SetFocus('navigation_switch_account_search'),
								function () {
								if (n.$ === 'HtmlItem') {
									return $author$project$PinMeTo$Global$TopNavigation$Navigation$None;
								} else {
									var x = n.b;
									return A2(
										$elm$core$Maybe$withDefault,
										$author$project$PinMeTo$Global$TopNavigation$Navigation$None,
										A2($elm$core$Maybe$map, $author$project$PinMeTo$Global$TopNavigation$Navigation$ExternalMsg, x.click));
								}
							}()
							])));
			case 'OnTopNavigationClick':
				var n = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(model),
					function () {
						if (n.$ === 'HtmlItem') {
							return $author$project$PinMeTo$Global$TopNavigation$Navigation$None;
						} else {
							var x = n.b;
							return A2(
								$elm$core$Maybe$withDefault,
								$author$project$PinMeTo$Global$TopNavigation$Navigation$None,
								A2($elm$core$Maybe$map, $author$project$PinMeTo$Global$TopNavigation$Navigation$ExternalMsg, x.click));
						}
					}());
			case 'ClickOutsideNav':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(
						_Utils_update(
							model,
							{rightSideBarState: $author$project$PinMeTo$Global$TopNavigation$Navigation$Collapsed, activeTopNavigationIndex: $elm$core$Maybe$Nothing})),
					$author$project$PinMeTo$Global$TopNavigation$Navigation$None);
			case 'CollapseAll':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(
						_Utils_update(
							model,
							{rightSideBarState: $author$project$PinMeTo$Global$TopNavigation$Navigation$Collapsed})),
					$author$project$PinMeTo$Global$TopNavigation$Navigation$None);
			case 'CollapseRight':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(
						_Utils_update(
							model,
							{rightSideBarState: $author$project$PinMeTo$Global$TopNavigation$Navigation$Collapsed})),
					$author$project$PinMeTo$Global$TopNavigation$Navigation$None);
			default:
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$Navigation$State(
						_Utils_update(
							model,
							{rightSideBarState: $author$project$PinMeTo$Global$TopNavigation$Navigation$Expanded})),
					$author$project$PinMeTo$Global$TopNavigation$Navigation$None);
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$setMobile = F2(
	function (isMobile, _v0) {
		var model = _v0.a;
		return isMobile ? $author$project$PinMeTo$Global$TopNavigation$Navigation$State(
			_Utils_update(
				model,
				{isMobile: isMobile, rightSideBarState: $author$project$PinMeTo$Global$TopNavigation$Navigation$Collapsed})) : $author$project$PinMeTo$Global$TopNavigation$Navigation$State(
			_Utils_update(
				model,
				{isMobile: isMobile}));
	});
var $author$project$PinMeTo$Global$NewsFeed$withArticles = F2(
	function (articles, _v0) {
		var model = _v0.a;
		return $author$project$PinMeTo$Global$NewsFeed$State(
			_Utils_update(
				model,
				{articles: articles}));
	});
var $author$project$PinMeTo$Global$TopNavigation$isMobileWidth = F2(
	function (_v0, width) {
		var mobileWindowWidth = _v0.mobileWindowWidth;
		return _Utils_cmp(width, mobileWindowWidth) < 0;
	});
var $author$project$PinMeTo$Global$TopNavigation$sortSiteQuery = F3(
	function (query, _v0, _v1) {
		var site1 = _v0.a;
		var site2 = _v1.a;
		var bStartWith2 = A2(
			$elm$core$String$startsWith,
			$elm$core$String$toLower(query),
			$kuon$elm_string_normalize$String$Normalize$removeDiacritics(
				$elm$core$String$toLower(site2.displayName)));
		var bStartWith1 = A2(
			$elm$core$String$startsWith,
			$elm$core$String$toLower(query),
			$elm$core$String$toLower(site2.displayName));
		var aStartWith2 = A2(
			$elm$core$String$startsWith,
			$elm$core$String$toLower(query),
			$kuon$elm_string_normalize$String$Normalize$removeDiacritics(
				$elm$core$String$toLower(site1.displayName)));
		var aStartWith1 = A2(
			$elm$core$String$startsWith,
			$elm$core$String$toLower(query),
			$elm$core$String$toLower(site1.displayName));
		var _v2 = _List_fromArray(
			[aStartWith1, bStartWith1, aStartWith2, bStartWith2]);
		_v2$0:
		while (true) {
			_v2$1:
			while (true) {
				_v2$2:
				while (true) {
					_v2$3:
					while (true) {
						_v2$4:
						while (true) {
							if ((((_v2.b && _v2.b.b) && _v2.b.b.b) && _v2.b.b.b.b) && (!_v2.b.b.b.b.b)) {
								if (_v2.a) {
									if (_v2.b.b.a) {
										if (!_v2.b.a) {
											break _v2$0;
										} else {
											if (!_v2.b.b.b.a) {
												break _v2$2;
											} else {
												break _v2$4;
											}
										}
									} else {
										if (!_v2.b.a) {
											break _v2$0;
										} else {
											if (_v2.b.b.b.a) {
												break _v2$3;
											} else {
												break _v2$4;
											}
										}
									}
								} else {
									if (_v2.b.b.a) {
										if (_v2.b.a) {
											break _v2$1;
										} else {
											if (!_v2.b.b.b.a) {
												break _v2$2;
											} else {
												break _v2$4;
											}
										}
									} else {
										if (_v2.b.a) {
											break _v2$1;
										} else {
											if (_v2.b.b.b.a) {
												break _v2$3;
											} else {
												break _v2$4;
											}
										}
									}
								}
							} else {
								break _v2$4;
							}
						}
						return A2(
							$elm$core$Basics$compare,
							$elm$core$String$toLower(site1.displayName),
							$elm$core$String$toLower(site2.displayName));
					}
					var _v12 = _v2.b;
					var _v13 = _v12.b;
					var _v14 = _v13.b;
					return $elm$core$Basics$GT;
				}
				var _v9 = _v2.b;
				var _v10 = _v9.b;
				var _v11 = _v10.b;
				return $elm$core$Basics$LT;
			}
			var _v6 = _v2.b;
			var _v7 = _v6.b;
			var _v8 = _v7.b;
			return $elm$core$Basics$GT;
		}
		var _v3 = _v2.b;
		var _v4 = _v3.b;
		var _v5 = _v4.b;
		return $elm$core$Basics$LT;
	});
var $author$project$PinMeTo$Global$NewsFeed$withLatestSeen = F2(
	function (latestSeen, _v0) {
		var model = _v0.a;
		return $author$project$PinMeTo$Global$NewsFeed$State(
			_Utils_update(
				model,
				{latestSeen: latestSeen}));
	});
var $author$project$PinMeTo$Global$TopNavigation$filterSitesByQuery = F2(
	function (query, sites) {
		var filterFun = F2(
			function (q, _v0) {
				var site = _v0.a;
				return A2(
					$elm$core$String$contains,
					q,
					$elm$core$String$toLower(site.displayName)) || A2(
					$elm$core$String$contains,
					q,
					$kuon$elm_string_normalize$String$Normalize$removeDiacritics(
						$elm$core$String$toLower(site.displayName)));
			});
		return A2(
			$elm$core$List$filter,
			filterFun(
				$elm$core$String$toLower(query)),
			sites);
	});
var $author$project$PinMeTo$Global$SupportTicket$CouldntSend = {$: 'CouldntSend'};
var $author$project$PinMeTo$Global$SupportTicket$onSubmitTicketResult = F2(
	function (_v0, _v1) {
		var success = _v0.success;
		var model = _v1.a;
		return success ? $author$project$PinMeTo$Global$SupportTicket$State(
			_Utils_update(
				model,
				{title: $elm$core$Maybe$Nothing, images: $elm$core$Set$empty, message: $elm$core$Maybe$Nothing, imageFiles: $elm$core$Dict$empty, sendStatus: $author$project$PinMeTo$Global$SupportTicket$Sent})) : $author$project$PinMeTo$Global$SupportTicket$State(
			_Utils_update(
				model,
				{
					error: $elm$core$Maybe$Just($author$project$PinMeTo$Global$SupportTicket$CouldntSend),
					sendStatus: $author$project$PinMeTo$Global$SupportTicket$Sent
				}));
	});
var $author$project$PinMeTo$Global$TopNavigation$Chat$isReady = function (_v0) {
	var s = _v0.a;
	return _Utils_eq(s.initState, $author$project$PinMeTo$Global$TopNavigation$Chat$InitSuccess);
};
var $author$project$PinMeTo$Global$SupportTicket$showSupportTicket = function (_v0) {
	var model = _v0.a;
	return $author$project$PinMeTo$Global$SupportTicket$State(
		_Utils_update(
			model,
			{open: true}));
};
var $author$project$PinMeTo$Global$TopNavigation$handleChatAndTicketUpdate = F2(
	function (tagger, _v0) {
		var model = _v0.a;
		if ($author$project$PinMeTo$Global$TopNavigation$Chat$isReady(model.chat)) {
			return _Utils_Tuple2(
				$author$project$PinMeTo$Global$TopNavigation$State(
					_Utils_update(
						model,
						{
							uiSupportModel: $author$project$PinMeTo$Global$SupportTicket$showSupportTicket(model.uiSupportModel)
						})),
				$elm$core$Platform$Cmd$none);
		} else {
			var _v1 = A2($author$project$PinMeTo$Global$TopNavigation$Chat$update, $author$project$PinMeTo$Global$TopNavigation$Chat$failLightboxToggled, model.chat);
			var chat = _v1.a;
			var chatCmd = _v1.b;
			return _Utils_Tuple2(
				$author$project$PinMeTo$Global$TopNavigation$State(
					_Utils_update(
						model,
						{chat: chat})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg, tagger),
					chatCmd));
		}
	});
var $author$project$PinMeTo$Ports$pmtUiNewsFeedSetLatestSeen = _Platform_outgoingPort('pmtUiNewsFeedSetLatestSeen', $elm$json$Json$Encode$int);
var $author$project$PinMeTo$Global$TopNavigation$out_Navigation_Main_PinMeToUiToggleDemo = _Platform_outgoingPort(
	'out_Navigation_Main_PinMeToUiToggleDemo',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PinMeTo$Global$TopNavigation$out_Navigation_Main_PinMeToUiSupportTicket = _Platform_outgoingPort(
	'out_Navigation_Main_PinMeToUiSupportTicket',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string($.title)),
					_Utils_Tuple2(
					'images',
					$elm$json$Json$Encode$list(
						function ($) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string($.url)),
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string($.name)),
										_Utils_Tuple2(
										'type_',
										$elm$json$Json$Encode$string($.type_))
									]));
						})($.images)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$out_UserSettings_Main_PinMeToUiSupportTicket = _Platform_outgoingPort(
	'out_UserSettings_Main_PinMeToUiSupportTicket',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string($.title)),
					_Utils_Tuple2(
					'images',
					$elm$json$Json$Encode$list(
						function ($) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string($.url)),
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string($.name)),
										_Utils_Tuple2(
										'type_',
										$elm$json$Json$Encode$string($.type_))
									]));
						})($.images)),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string($.message))
				]));
	});
var $author$project$PinMeTo$Global$TopNavigation$handleExternalMsg = F5(
	function (external, tagger, _v8, navigationState, extMsg) {
		var model = _v8.a;
		switch (extMsg.$) {
			case 'None':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{navigationState: navigationState})),
					$elm$core$Platform$Cmd$none);
			case 'ExternalMsg':
				var x = extMsg.a;
				return A4(
					$author$project$PinMeTo$Global$TopNavigation$updateWithExternal,
					external,
					tagger,
					x,
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{navigationState: navigationState})));
			case 'Batch':
				var batchCommands = extMsg.a;
				return function (_v12) {
					var m = _v12.a;
					var commands = _v12.b;
					return _Utils_Tuple2(
						m,
						$elm$core$Platform$Cmd$batch(commands));
				}(
					A3(
						$elm$core$List$foldl,
						F2(
							function (batchCommand, _v10) {
								var m = _v10.a;
								var commands = _v10.b;
								var _v11 = A5($author$project$PinMeTo$Global$TopNavigation$handleExternalMsg, external, tagger, m, navigationState, batchCommand);
								var model2 = _v11.a;
								var cmd = _v11.b;
								return _Utils_Tuple2(
									model2,
									A2($elm$core$List$cons, cmd, commands));
							}),
						_Utils_Tuple2(
							$author$project$PinMeTo$Global$TopNavigation$State(model),
							_List_Nil),
						batchCommands));
			default:
				var id = extMsg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{navigationState: navigationState})),
					A2(
						$elm$core$Task$attempt,
						function (_v13) {
							return tagger($author$project$PinMeTo$Global$TopNavigation$Msg$NoOp);
						},
						$elm$browser$Browser$Dom$focus(id)));
		}
	});
var $author$project$PinMeTo$Global$TopNavigation$updateWithExternal = F4(
	function (external, tagger, msg, _v0) {
		var model = _v0.a;
		switch (msg.$) {
			case 'NoOp':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(model),
					$elm$core$Platform$Cmd$none);
			case 'WindowResize':
				var width = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{
								mobile: A2($author$project$PinMeTo$Global$TopNavigation$isMobileWidth, model, width),
								navigationState: A2(
									$author$project$PinMeTo$Global$TopNavigation$Navigation$setMobile,
									A2($author$project$PinMeTo$Global$TopNavigation$isMobileWidth, model, width),
									model.navigationState)
							})),
					$elm$core$Platform$Cmd$none);
			case 'NavigationMsg':
				var msg_ = msg.a;
				var _v2 = A2($author$project$PinMeTo$Global$TopNavigation$Navigation$update, msg_, model.navigationState);
				var navigationState = _v2.a;
				var extMsg = _v2.b;
				return A5(
					$author$project$PinMeTo$Global$TopNavigation$handleExternalMsg,
					external,
					tagger,
					$author$project$PinMeTo$Global$TopNavigation$State(model),
					navigationState,
					extMsg);
			case 'ChatMsg':
				var subMsg = msg.a;
				var _v3 = A2($author$project$PinMeTo$Global$TopNavigation$Chat$update, subMsg, model.chat);
				var chat = _v3.a;
				var chatCmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{chat: chat})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg, tagger),
						chatCmd));
			case 'HandleFlags':
				var x = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(model),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (handleFlags) {
								return A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										handleFlags(x)),
									$elm$core$Task$succeed(_Utils_Tuple0));
							},
							external.handleFlags)));
			case 'SearchFilter':
				var query = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{
								siteFilter: $elm$core$Maybe$Just(query),
								sitesFiltered: A2(
									$elm$core$List$sortWith,
									$author$project$PinMeTo$Global$TopNavigation$sortSiteQuery(query),
									A2($author$project$PinMeTo$Global$TopNavigation$filterSitesByQuery, query, model.allSites))
							})),
					$elm$core$Platform$Cmd$none);
			case 'Navigate':
				var _v4 = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(model),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (onSupportMail) {
								return A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(onSupportMail),
									$elm$core$Task$succeed(_Utils_Tuple0));
							},
							external.onSupportMail)));
			case 'GetProfileImg':
				var res = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{
								siteProfile: $elm$core$Result$toMaybe(res)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OpenSupportTicket':
				return A2(
					$author$project$PinMeTo$Global$TopNavigation$handleChatAndTicketUpdate,
					tagger,
					$author$project$PinMeTo$Global$TopNavigation$State(model));
			case 'SupportTicketMessage':
				var subMsg = msg.a;
				var _v5 = A3(
					$author$project$PinMeTo$Global$SupportTicket$update,
					{
						sendTicketCmd: function (params) {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$PinMeTo$Global$TopNavigation$out_Navigation_Main_PinMeToUiSupportTicket(params),
										$author$project$PinMeTo$Global$TopNavigation$out_UserSettings_Main_PinMeToUiSupportTicket(params)
									]));
						}
					},
					subMsg,
					model.uiSupportModel);
				var supportTicketModelUpdate = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{uiSupportModel: supportTicketModelUpdate})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Msg$SupportTicketMessage, tagger),
						cmd));
			case 'ToggleChat':
				var _v6 = $author$project$PinMeTo$Global$TopNavigation$Chat$toggle(model.chat);
				var chat = _v6.a;
				var chatCmd = _v6.b;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{chat: chat})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg, tagger),
						chatCmd));
			case 'ToggleDemo':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(model),
					$author$project$PinMeTo$Global$TopNavigation$out_Navigation_Main_PinMeToUiToggleDemo(_Utils_Tuple0));
			case 'ToggleIgnoredProductUpgrades':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{showIgnoredProductUpgrades: !model.showIgnoredProductUpgrades})),
					$elm$core$Platform$Cmd$none);
			case 'SupportTicketResult':
				var result = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{
								uiSupportModel: A2($author$project$PinMeTo$Global$SupportTicket$onSubmitTicketResult, result, model.uiSupportModel)
							})),
					$elm$core$Platform$Cmd$none);
			case 'NewsFeedOnOpen':
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						$author$project$PinMeTo$Global$TopNavigation$State(model),
						$elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (articleId) {
							return _Utils_Tuple2(
								$author$project$PinMeTo$Global$TopNavigation$State(
									_Utils_update(
										model,
										{
											newsFeedLatestSeen: $elm$core$Maybe$Just(articleId)
										})),
								$author$project$PinMeTo$Ports$pmtUiNewsFeedSetLatestSeen(articleId));
						},
						$author$project$PinMeTo$Global$NewsFeed$latestArticleId(model.newsFeed)));
			case 'NewsFeedOnNavigate':
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{
								navigationState: function (_v7) {
									var navigationState = _v7.a;
									return $author$project$PinMeTo$Global$TopNavigation$Navigation$State(
										_Utils_update(
											navigationState,
											{topNavigationState: _List_Nil, activeTopNavigationIndex: $elm$core$Maybe$Nothing}));
								}(model.navigationState)
							})),
					$elm$core$Platform$Cmd$none);
			case 'NewsFeedGetSeen':
				var latestSeen = msg.a;
				return _Utils_Tuple2(
					$author$project$PinMeTo$Global$TopNavigation$State(
						_Utils_update(
							model,
							{
								newsFeed: A2($author$project$PinMeTo$Global$NewsFeed$withLatestSeen, latestSeen, model.newsFeed),
								newsFeedLatestSeen: $elm$core$Maybe$Just(latestSeen)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 'Ok') {
					var articles = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$TopNavigation$State(
							_Utils_update(
								model,
								{
									newsFeed: A2($author$project$PinMeTo$Global$NewsFeed$withArticles, articles, model.newsFeed)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						$author$project$PinMeTo$Global$TopNavigation$State(model),
						A2(
							$author$project$PinMeTo$ExpectJson$logError,
							$author$project$PinMeTo$ExpectJson$ErrorContext('PinMeTo.Global.TopNavigation.NewsFeedGetNews'),
							err));
				}
		}
	});
var $author$project$UserSettings$Main$out_UserSettings_Main_registerPush = _Platform_outgoingPort('out_UserSettings_Main_registerPush', $elm$json$Json$Encode$bool);
var $author$project$UserSettings$Main$out_UserSettings_Main_sidebarCollapsed = _Platform_outgoingPort(
	'out_UserSettings_Main_sidebarCollapsed',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'collapsed',
					$elm$json$Json$Encode$bool($.collapsed))
				]));
	});
var $author$project$UserSettings$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.view);
		switch (_v0.a.$) {
			case 'LanguageMsg':
				if ((_v0.b.$ === 'Language') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var locale = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (l) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$Language(
										$elm$core$Maybe$Just(l))
								});
						},
						A3($author$project$UserSettings$Language$update, $author$project$UserSettings$Model$LanguageMsg, subMsg, locale));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ChangePasswordMsg':
				if ((_v0.b.$ === 'ChangePassword') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var cp = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (x) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$ChangePassword(
										$elm$core$Maybe$Just(x))
								});
						},
						A3($author$project$UserSettings$ChangePassword$update, $author$project$UserSettings$Model$ChangePasswordMsg, subMsg, cp));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'EmailNotificationsMsg':
				if ((_v0.b.$ === 'EmailNotifications') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var x = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (l) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$EmailNotifications(
										$elm$core$Maybe$Just(l))
								});
						},
						A3($author$project$UserSettings$EmailNotifications$update, $author$project$UserSettings$Model$EmailNotificationsMsg, subMsg, x));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ProfileMsg':
				if ((_v0.b.$ === 'Profile') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var profile = _v0.b.a.a;
					var getProfileImgUrl = function (profileImage) {
						return $author$project$UserSettings$Profile$Model$getUrl(profileImage);
					};
					var topNavigationState = function () {
						if ((subMsg.$ === 'SaveProfileImage') && (subMsg.a.$ === 'Ok')) {
							var user = subMsg.a.a;
							return A2(
								$elm$core$Maybe$map,
								function (topNavigation) {
									return A2(
										$author$project$PinMeTo$Global$TopNavigation$updateProfileImage,
										A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', getProfileImgUrl, user.profileImage),
										topNavigation).a;
								},
								model.topNavigation);
						} else {
							return model.topNavigation;
						}
					}();
					return A2(
						$elm$core$Tuple$mapFirst,
						function (d) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$Profile(
										$elm$core$Maybe$Just(d)),
									topNavigation: topNavigationState
								});
						},
						A3($author$project$UserSettings$Profile$Update$update, $author$project$UserSettings$Model$ProfileMsg, subMsg, profile));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'LegalMsg':
				if ((_v0.b.$ === 'LegalDocuments') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var legal = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (d) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$LegalDocuments(
										$elm$core$Maybe$Just(d))
								});
						},
						A3($author$project$UserSettings$Legal$update, $author$project$UserSettings$Model$LegalMsg, subMsg, legal));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'NotificationsMsg':
				if ((_v0.b.$ === 'Notifications') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var x = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (d) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$Notifications(
										$elm$core$Maybe$Just(d))
								});
						},
						A4($author$project$UserSettings$Notifications$Main$update, $author$project$UserSettings$Model$NotificationsMsg, $author$project$UserSettings$Main$out_UserSettings_Main_registerPush, subMsg, x));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'PostsNotificationsMsg':
				if ((_v0.b.$ === 'NotificationsPosts') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var x = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (d) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$NotificationsPosts(
										$elm$core$Maybe$Just(d))
								});
						},
						A3($author$project$UserSettings$PostsNotifications$Main$update, $author$project$UserSettings$Model$PostsNotificationsMsg, subMsg, x));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'PlacesAINotificationsMsg':
				if ((_v0.b.$ === 'NotificationsPlacesAI') && (_v0.b.a.$ === 'Just')) {
					var subMsg = _v0.a.a;
					var x = _v0.b.a.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (d) {
							return _Utils_update(
								model,
								{
									view: $author$project$UserSettings$Model$NotificationsPlacesAI(
										$elm$core$Maybe$Just(d))
								});
						},
						A3($author$project$UserSettings$PlacesAINotifications$Main$update, $author$project$UserSettings$Model$PlacesAINotificationsMsg, subMsg, x));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'TopNavigationMsg':
				var msg_ = _v0.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (topNavigation) {
							return A2(
								$elm$core$Tuple$mapFirst,
								function (x) {
									return _Utils_update(
										model,
										{
											topNavigation: $elm$core$Maybe$Just(x)
										});
								},
								A4(
									$author$project$PinMeTo$Global$TopNavigation$updateWithExternal,
									{handleFlags: $elm$core$Maybe$Nothing, onSupportMail: $elm$core$Maybe$Nothing},
									$author$project$UserSettings$Model$TopNavigationMsg,
									msg_,
									topNavigation));
						},
						model.topNavigation));
			case 'HandleFlags':
				var flags = _v0.a.a;
				return $author$project$UserSettings$Main$init(flags);
			case 'HandleTranslationChange':
				var newTranslationValue = _v0.a.a;
				var _v2 = $author$project$Common$Language$decodeTranslations(newTranslationValue);
				if (_v2.$ === 'Ok') {
					var translations_ = _v2.a;
					var newModel = _Utils_update(
						model,
						{translations: translations_});
					return A2($author$project$UserSettings$Main$updateNavigateTo, newModel.view, newModel);
				} else {
					var err = _v2.a;
					return _Utils_Tuple2(
						model,
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(err),
								context: 'UserSettings.Main',
								message: 'Failed to decode translations '
							}));
				}
			case 'OnUrlChange':
				var x = _v0.a.a;
				var _v3 = _Utils_Tuple2(
					model.selectedSite,
					$elm$url$Url$fromString(x));
				if ((_v3.a.$ === 'Just') && (_v3.b.$ === 'Just')) {
					var site = _v3.a.a;
					var url = _v3.b.a;
					var newView = A2($author$project$UserSettings$Main$urlToView, site, url);
					var _v4 = A2($author$project$UserSettings$Main$updateNavigateTo, newView, model);
					var newModel = _v4.a;
					var command = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								url: $elm$core$Maybe$Just(url),
								currentPath: $author$project$UserSettings$Types$CurrentPath(url.path)
							}),
						command);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'SidebarSetCompact':
				var x = _v0.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{collapsed: x}),
					$author$project$UserSettings$Main$out_UserSettings_Main_sidebarCollapsed(
						{collapsed: x}));
			case 'OnWorkInProgress':
				var count = _v0.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{workInProgress: count}),
					$elm$core$Platform$Cmd$none);
			default:
				var width = _v0.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mobile: width < 640}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$UserSettings$Model$HandleFlags = function (a) {
	return {$: 'HandleFlags', a: a};
};
var $author$project$UserSettings$Model$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, $elm$browser$Browser$Events$Document, 'mousedown');
var $author$project$PinMeTo$Global$TopNavigation$Navigation$outsideTarget = F3(
	function (tagger, targetId, msg) {
		var isOutside = function (navId) {
			var newId = function (myId) {
				var _v1 = $elm$core$List$head(
					A2($elm$core$String$split, '__', myId));
				if (_v1.$ === 'Just') {
					var x = _v1.a;
					return x;
				} else {
					return '';
				}
			};
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$andThen,
						function (id) {
							return _Utils_eq(
								navId,
								newId(id)) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
						},
						A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$lazy(
						function (_v0) {
							return A2(
								$elm$json$Json$Decode$field,
								'parentNode',
								isOutside(navId));
						}),
						$elm$json$Json$Decode$succeed(true)
					]));
		};
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isClickOutside) {
				return isClickOutside ? $elm$json$Json$Decode$succeed(
					tagger(msg)) : $elm$json$Json$Decode$fail('inside');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				isOutside(targetId)));
	});
var $author$project$PinMeTo$Global$TopNavigation$Navigation$ClickOutsideNav = {$: 'ClickOutsideNav'};
var $author$project$PinMeTo$Global$TopNavigation$Navigation$subscriptions = function (tagger) {
	return $elm$browser$Browser$Events$onMouseDown(
		A3($author$project$PinMeTo$Global$TopNavigation$Navigation$outsideTarget, tagger, 'pmt-global-top-navigation', $author$project$PinMeTo$Global$TopNavigation$Navigation$ClickOutsideNav));
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$in_Navigation_Main_PinMeToUiInitChatResponse = _Platform_incomingPort(
	'in_Navigation_Main_PinMeToUiInitChatResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (success) {
			return $elm$json$Json$Decode$succeed(
				{success: success});
		},
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool)));
var $author$project$PinMeTo$Global$TopNavigation$Chat$in_UserSettings_Main_PinMeToUiInitChatResponse = _Platform_incomingPort(
	'in_UserSettings_Main_PinMeToUiInitChatResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (success) {
			return $elm$json$Json$Decode$succeed(
				{success: success});
		},
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool)));
var $author$project$PinMeTo$Global$TopNavigation$Chat$onInitResponse = function (tagger) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PinMeTo$Global$TopNavigation$Chat$in_Navigation_Main_PinMeToUiInitChatResponse(tagger),
				$author$project$PinMeTo$Global$TopNavigation$Chat$in_UserSettings_Main_PinMeToUiInitChatResponse(tagger)
			]));
};
var $author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedGetSeen = function (a) {
	return {$: 'NewsFeedGetSeen', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$GotInitResponse = function (a) {
	return {$: 'GotInitResponse', a: a};
};
var $author$project$PinMeTo$Global$TopNavigation$Chat$gotInitResponse = $author$project$PinMeTo$Global$TopNavigation$Chat$GotInitResponse;
var $author$project$PinMeTo$Global$TopNavigation$Msg$SupportTicketResult = function (a) {
	return {$: 'SupportTicketResult', a: a};
};
var $author$project$PinMeTo$Ports$pmtUiNewsFeedLatestSeenValue = _Platform_incomingPort('pmtUiNewsFeedLatestSeenValue', $elm$json$Json$Decode$int);
var $author$project$PinMeTo$Global$TopNavigation$in_Navigation_Main_PinMeToUiSupportTicketOpen = _Platform_incomingPort(
	'in_Navigation_Main_PinMeToUiSupportTicketOpen',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$PinMeTo$Global$TopNavigation$in_UserSettings_Main_PinMeToUiSupportTicketOpen = _Platform_incomingPort(
	'in_UserSettings_Main_PinMeToUiSupportTicketOpen',
	$elm$json$Json$Decode$null(_Utils_Tuple0));
var $author$project$PinMeTo$Global$TopNavigation$in_Navigation_Main_PinMeToUiSupportTicketResponse = _Platform_incomingPort(
	'in_Navigation_Main_PinMeToUiSupportTicketResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (success) {
			return $elm$json$Json$Decode$succeed(
				{success: success});
		},
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool)));
var $author$project$PinMeTo$Global$TopNavigation$in_UserSettings_Main_PinMeToUiSupportTicketResponse = _Platform_incomingPort(
	'in_UserSettings_Main_PinMeToUiSupportTicketResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (success) {
			return $elm$json$Json$Decode$succeed(
				{success: success});
		},
		A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool)));
var $author$project$PinMeTo$Global$TopNavigation$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$PinMeTo$Global$TopNavigation$Navigation$subscriptions($author$project$PinMeTo$Global$TopNavigation$Msg$NavigationMsg),
			$author$project$PinMeTo$Ports$pmtUiNewsFeedLatestSeenValue($author$project$PinMeTo$Global$TopNavigation$Msg$NewsFeedGetSeen),
			$elm$browser$Browser$Events$onResize(
			F2(
				function (w, _v0) {
					return $author$project$PinMeTo$Global$TopNavigation$Msg$WindowResize(w);
				})),
			$author$project$PinMeTo$Global$TopNavigation$in_Navigation_Main_PinMeToUiSupportTicketResponse($author$project$PinMeTo$Global$TopNavigation$Msg$SupportTicketResult),
			$author$project$PinMeTo$Global$TopNavigation$in_UserSettings_Main_PinMeToUiSupportTicketResponse($author$project$PinMeTo$Global$TopNavigation$Msg$SupportTicketResult),
			$author$project$PinMeTo$Global$TopNavigation$in_Navigation_Main_PinMeToUiSupportTicketOpen(
			function (_v1) {
				return $author$project$PinMeTo$Global$TopNavigation$Msg$OpenSupportTicket;
			}),
			$author$project$PinMeTo$Global$TopNavigation$in_UserSettings_Main_PinMeToUiSupportTicketOpen(
			function (_v2) {
				return $author$project$PinMeTo$Global$TopNavigation$Msg$OpenSupportTicket;
			}),
			$author$project$PinMeTo$Global$TopNavigation$Chat$onInitResponse(
			A2($elm$core$Basics$composeR, $author$project$PinMeTo$Global$TopNavigation$Chat$gotInitResponse, $author$project$PinMeTo$Global$TopNavigation$Msg$ChatMsg))
		]));
var $author$project$UserSettings$Model$OnWorkInProgress = function (a) {
	return {$: 'OnWorkInProgress', a: a};
};
var $author$project$UserSettings$Model$HandleTranslationChange = function (a) {
	return {$: 'HandleTranslationChange', a: a};
};
var $author$project$UserSettings$Notifications$Model$PushSubscriptionChanged = function (a) {
	return {$: 'PushSubscriptionChanged', a: a};
};
var $author$project$UserSettings$Notifications$Model$Denied = {$: 'Denied'};
var $author$project$UserSettings$Notifications$Model$Granted = {$: 'Granted'};
var $author$project$UserSettings$Notifications$Model$NotAsked = {$: 'NotAsked'};
var $author$project$UserSettings$Notifications$Model$Unsupported = {$: 'Unsupported'};
var $author$project$UserSettings$Notifications$Model$currentSubscriptionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		switch (status) {
			case 'Unsupported':
				return $elm$json$Json$Decode$succeed($author$project$UserSettings$Notifications$Model$Unsupported);
			case 'NotAsked':
				return $elm$json$Json$Decode$succeed($author$project$UserSettings$Notifications$Model$NotAsked);
			case 'Denied':
				return $elm$json$Json$Decode$succeed($author$project$UserSettings$Notifications$Model$Denied);
			case 'Granted':
				return $elm$json$Json$Decode$succeed($author$project$UserSettings$Notifications$Model$Granted);
			default:
				var unknown = status;
				return $elm$json$Json$Decode$fail('Unknown status: ' + unknown);
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $author$project$UserSettings$Notifications$Main$onPushSubscriptionChanged = function (data) {
	return $author$project$UserSettings$Notifications$Model$PushSubscriptionChanged(
		A2($elm$json$Json$Decode$decodeValue, $author$project$UserSettings$Notifications$Model$currentSubscriptionDecoder, data));
};
var $author$project$UserSettings$Main$passArgs_UserSettings_Main = _Platform_incomingPort('passArgs_UserSettings_Main', $elm$json$Json$Decode$value);
var $author$project$UserSettings$Main$in_UserSettings_Main_urlChange = _Platform_incomingPort('in_UserSettings_Main_urlChange', $elm$json$Json$Decode$string);
var $author$project$UserSettings$Main$in_UserSettings_Main_languageChanged = _Platform_incomingPort('in_UserSettings_Main_languageChanged', $elm$json$Json$Decode$value);
var $author$project$UserSettings$Main$in_UserSettings_Main_workInProgressCount = _Platform_incomingPort('in_UserSettings_Main_workInProgressCount', $elm$json$Json$Decode$int);
var $author$project$UserSettings$Main$in_UserSettings_Main_pushSubscriptionChanged = _Platform_incomingPort('in_UserSettings_Main_pushSubscriptionChanged', $elm$json$Json$Decode$value);
var $author$project$UserSettings$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$UserSettings$Main$passArgs_UserSettings_Main($author$project$UserSettings$Model$HandleFlags),
				$author$project$UserSettings$Main$in_UserSettings_Main_languageChanged($author$project$UserSettings$Model$HandleTranslationChange),
				A2($elm$core$Platform$Sub$map, $author$project$UserSettings$Model$TopNavigationMsg, $author$project$PinMeTo$Global$TopNavigation$subscriptions),
				$author$project$UserSettings$Main$in_UserSettings_Main_workInProgressCount($author$project$UserSettings$Model$OnWorkInProgress),
				$author$project$UserSettings$Main$in_UserSettings_Main_urlChange($author$project$UserSettings$Model$OnUrlChange),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (w, _v1) {
						return $author$project$UserSettings$Model$OnWindowWidth(w);
					})),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$UserSettings$Model$NotificationsMsg,
				$author$project$UserSettings$Main$in_UserSettings_Main_pushSubscriptionChanged($author$project$UserSettings$Notifications$Main$onPushSubscriptionChanged))
			]));
};
var $author$project$UserSettings$Main$main = $elm$browser$Browser$element(
	{init: $author$project$UserSettings$Main$init, view: $author$project$UserSettings$Main$view, update: $author$project$UserSettings$Main$update, subscriptions: $author$project$UserSettings$Main$subscriptions});
var $author$project$Tasks$Tomtom$Main$Flags = F6(
	function (claimUrl, siteName, user, translations, language, hasCategory) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, hasCategory: hasCategory, translations: translations};
	});
var $author$project$Tasks$Tomtom$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hasCategory',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$PinMeTo$Ui$I18n$Language$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translations',
			$author$project$Common$Language$translationsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'user',
				$author$project$Data$User$userDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'siteName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'claimUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Tasks$Tomtom$Main$Flags)))))));
var $author$project$Tasks$Tomtom$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Tomtom$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Tomtom$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Tomtom$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Tomtom$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					user: decoded.user,
					claimUrl: decoded.claimUrl,
					language: decoded.language,
					siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
					hasCategory: decoded.hasCategory,
					translations: decoded.translations
				}),
			$elm$core$Platform$Cmd$none);
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Tomtom$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Tomtom.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Tomtom$Main$getText = function (model) {
	return model.hasCategory ? $elm$html$Html$text('All of your locations are claimed!') : $elm$html$Html$text('Claim or create listings for each of your locations on TomTom.');
};
var $author$project$Tasks$Tomtom$Main$getClassName = function (model) {
	return model.hasCategory ? 'pmt-admin-box__success' : 'pmt-admin-box pmt-task--warning';
};
var $author$project$Tasks$Tomtom$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Tomtom$Main$getClassName(model))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('TomTom - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Tomtom$Main$getText(model)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Tomtom$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Tomtom$Main$init,
		view: $author$project$Tasks$Tomtom$Main$view,
		update: F2(
			function (_v0, model) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}),
		subscriptions: function (_v1) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Google$Main$Flags = F5(
	function (claimUrl, siteName, user, translations, language) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, translations: translations};
	});
var $author$project$Tasks$Google$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$author$project$Data$User$userDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'claimUrl',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$Google$Main$Flags))))));
var $author$project$Tasks$Google$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Google$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Google$Main$GetClaimStatus = function (a) {
	return {$: 'GetClaimStatus', a: a};
};
var $author$project$Tasks$Google$Main$ClaimStatus = F6(
	function (doneClaim, numberOfUserAction, numberOfPlacesToClaim, numberOfNonSupportedClaim, numberOfClaimedPlaces, claimDisabled) {
		return {doneClaim: doneClaim, claimDisabled: claimDisabled, numberOfUserAction: numberOfUserAction, numberOfClaimedPlaces: numberOfClaimedPlaces, numberOfPlacesToClaim: numberOfPlacesToClaim, numberOfNonSupportedClaim: numberOfNonSupportedClaim};
	});
var $author$project$Tasks$Google$Main$claimStatusDecoder = function () {
	var numberOfNonSupportedClaim = A2($elm$json$Json$Decode$field, 'notSupportedClaim', $elm$json$Json$Decode$int);
	var numberOfPlacesToClaim = A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int);
	var numberOfClaimedPlaces = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (claimed, userAction) {
				return claimed + userAction;
			}),
		A2($elm$json$Json$Decode$field, 'claimed', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'userAction', $elm$json$Json$Decode$int));
	var numberOfUserAction = A2($elm$json$Json$Decode$field, 'userAction', $elm$json$Json$Decode$int);
	var claimDisabled = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (notClaimed, claimed) {
				return (!notClaimed) && (!claimed);
			}),
		A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'claimed', $elm$json$Json$Decode$int));
	var doneClaim = A2(
		$elm$json$Json$Decode$map,
		function (n) {
			return !n;
		},
		A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int));
	return A7($elm$json$Json$Decode$map6, $author$project$Tasks$Google$Main$ClaimStatus, doneClaim, numberOfUserAction, numberOfPlacesToClaim, numberOfNonSupportedClaim, numberOfClaimedPlaces, claimDisabled);
}();
var $author$project$Tasks$Google$Main$getClaimStatus = F2(
	function (msg, _v0) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/Google/claim/status');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Google$Main$claimStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Google$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Google$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Google$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		var model = {
			user: decoded.user,
			claimUrl: decoded.claimUrl,
			language: decoded.language,
			siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
			claimStatus: $author$project$RemoteData$Loading,
			translations: decoded.translations
		};
		return _Utils_Tuple2(
			$elm$core$Result$Ok(model),
			A2(
				$author$project$Tasks$Google$Main$getClaimStatus,
				$author$project$Tasks$Google$Main$GetClaimStatus,
				$author$project$Data$SiteName$SiteName(decoded.siteName)));
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Google$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Google.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Google$Main$getText = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return (x.numberOfPlacesToClaim > 0) ? $elm$html$Html$text('Claim or create listings for each of your locations on Google.') : $elm$html$Html$text('All of your locations are claimed!');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Google$Main$toClaim = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return (x.numberOfPlacesToClaim > 0) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Pages to claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(x.numberOfPlacesToClaim))
									]))
							])),
						(x.numberOfNonSupportedClaim > 0) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Not supported claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(x.numberOfNonSupportedClaim))
									]))
							])) : $elm$html$Html$text('')
					])) : $elm$html$Html$text('');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Google$Main$getClassName = function (status) {
	if (status.$ === 'Loaded') {
		var x = status.a;
		return (x.numberOfPlacesToClaim > 0) ? 'pmt-admin-box pmt-task--warning' : 'pmt-admin-box__success';
	} else {
		return '';
	}
};
var $author$project$Tasks$Google$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Google$Main$getClassName(model.claimStatus))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Google - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Google$Main$getText(model.claimStatus)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												$author$project$Tasks$Google$Main$toClaim(model.claimStatus),
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Google$Main$update = F2(
	function (msg, state) {
		var _v0 = _Utils_Tuple2(state, msg);
		if (_v0.a.$ === 'Ok') {
			if (_v0.b.a.$ === 'Ok') {
				var model = _v0.a.a;
				var result = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Loaded(result)
							})),
					$elm$core$Platform$Cmd$none);
			} else {
				var model = _v0.a.a;
				var error = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							})),
					A2(
						$author$project$PinMeTo$ExpectJson$logError,
						$author$project$PinMeTo$ExpectJson$ErrorContext('Tasks.Google.Main'),
						error));
			}
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Google$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Google$Main$init,
		view: $author$project$Tasks$Google$Main$view,
		update: $author$project$Tasks$Google$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Apple$Main$Flags = F5(
	function (claimUrl, siteName, user, translations, language) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, translations: translations};
	});
var $author$project$Tasks$Apple$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$author$project$Data$User$userDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'claimUrl',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$Apple$Main$Flags))))));
var $author$project$Tasks$Apple$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Apple$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Apple$Main$GetClaimStatus = function (a) {
	return {$: 'GetClaimStatus', a: a};
};
var $author$project$Tasks$Apple$Main$ClaimStatus = F6(
	function (doneClaim, numberOfUserAction, numberOfPlacesToClaim, numberOfNonSupportedClaim, numberOfClaimedPlaces, claimDisabled) {
		return {doneClaim: doneClaim, claimDisabled: claimDisabled, numberOfUserAction: numberOfUserAction, numberOfClaimedPlaces: numberOfClaimedPlaces, numberOfPlacesToClaim: numberOfPlacesToClaim, numberOfNonSupportedClaim: numberOfNonSupportedClaim};
	});
var $author$project$Tasks$Apple$Main$claimStatusDecoder = function () {
	var numberOfNonSupportedClaim = A2($elm$json$Json$Decode$field, 'notSupportedClaim', $elm$json$Json$Decode$int);
	var numberOfPlacesToClaim = A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int);
	var numberOfClaimedPlaces = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (claimed, userAction) {
				return claimed + userAction;
			}),
		A2($elm$json$Json$Decode$field, 'claimed', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'userAction', $elm$json$Json$Decode$int));
	var numberOfUserAction = A2($elm$json$Json$Decode$field, 'userAction', $elm$json$Json$Decode$int);
	var claimDisabled = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (notClaimed, claimed) {
				return (!notClaimed) && (!claimed);
			}),
		A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'claimed', $elm$json$Json$Decode$int));
	var doneClaim = A2(
		$elm$json$Json$Decode$map,
		function (n) {
			return !n;
		},
		A2($elm$json$Json$Decode$field, 'notClaimed', $elm$json$Json$Decode$int));
	return A7($elm$json$Json$Decode$map6, $author$project$Tasks$Apple$Main$ClaimStatus, doneClaim, numberOfUserAction, numberOfPlacesToClaim, numberOfNonSupportedClaim, numberOfClaimedPlaces, claimDisabled);
}();
var $author$project$Tasks$Apple$Main$getClaimStatus = F2(
	function (msg, _v0) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/apple/claim/status');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Apple$Main$claimStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Apple$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Apple$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Apple$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		var model = {
			user: decoded.user,
			claimUrl: decoded.claimUrl,
			language: decoded.language,
			siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
			claimStatus: $author$project$RemoteData$Loading,
			translations: decoded.translations
		};
		return _Utils_Tuple2(
			$elm$core$Result$Ok(model),
			A2(
				$author$project$Tasks$Apple$Main$getClaimStatus,
				$author$project$Tasks$Apple$Main$GetClaimStatus,
				$author$project$Data$SiteName$SiteName(decoded.siteName)));
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Apple$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Apple.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Apple$Main$getText = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return (x.numberOfPlacesToClaim > 0) ? $elm$html$Html$text('Claim or create listings for each of your locations on Apple.') : $elm$html$Html$text('All of your locations are claimed!');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Apple$Main$toClaim = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return (x.numberOfPlacesToClaim > 0) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Pages to claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(x.numberOfPlacesToClaim))
									]))
							])),
						(x.numberOfNonSupportedClaim > 0) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Not supported claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(x.numberOfNonSupportedClaim))
									]))
							])) : $elm$html$Html$text('')
					])) : $elm$html$Html$text('');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Apple$Main$getClassName = function (status) {
	if (status.$ === 'Loaded') {
		var x = status.a;
		return (x.numberOfPlacesToClaim > 0) ? 'pmt-admin-box pmt-task--warning' : 'pmt-admin-box__success';
	} else {
		return '';
	}
};
var $author$project$Tasks$Apple$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Apple$Main$getClassName(model.claimStatus))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Apple - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Apple$Main$getText(model.claimStatus)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												$author$project$Tasks$Apple$Main$toClaim(model.claimStatus),
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Apple$Main$update = F2(
	function (msg, state) {
		var _v0 = _Utils_Tuple2(state, msg);
		if (_v0.a.$ === 'Ok') {
			if (_v0.b.a.$ === 'Ok') {
				var model = _v0.a.a;
				var result = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Loaded(result)
							})),
					$elm$core$Platform$Cmd$none);
			} else {
				var model = _v0.a.a;
				var error = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							})),
					A2(
						$author$project$PinMeTo$ExpectJson$logError,
						$author$project$PinMeTo$ExpectJson$ErrorContext('Tasks.Apple.Main'),
						error));
			}
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Apple$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Apple$Main$init,
		view: $author$project$Tasks$Apple$Main$view,
		update: $author$project$Tasks$Apple$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$PinMeTo$Api$FilterApi$NetworkLog = {$: 'NetworkLog'};
var $author$project$NetworkLogs$Model$PaginationHide = {$: 'PaginationHide'};
var $author$project$NetworkLogs$Model$FilterControllerMsg = function (a) {
	return {$: 'FilterControllerMsg', a: a};
};
var $author$project$NetworkLogs$Model$LocationDescriptorField = {$: 'LocationDescriptorField'};
var $author$project$NetworkLogs$Main$init = F2(
	function (session, flags) {
		var _v0 = A4(
			$author$project$Filter$FilterController$init,
			$author$project$Data$SiteName$toString(session.siteName),
			$elm$core$Maybe$Nothing,
			$author$project$PinMeTo$Api$FilterApi$NetworkLog,
			flags.initialFilter);
		var filterControllerModel_ = _v0.a;
		var filterControllerCmd_ = _v0.b;
		var model = {
			locale: session.locale,
			uiTable: $author$project$PinMeTo$Ui$Table$init,
			language: session.language,
			showMore: $elm$core$Maybe$Nothing,
			siteName: $author$project$Data$SiteName$toString(session.siteName),
			uiSelect: $author$project$PinMeTo$Ui$Select$init,
			pageNumber: 1,
			translations: session.translations,
			locationColumn: $author$project$NetworkLogs$Model$LocationDescriptorField,
			workDataStatus: $author$project$RemoteData$Loading,
			showMoreDetails: $elm$core$Maybe$Nothing,
			showMoreUiTable: $author$project$PinMeTo$Ui$Table$init,
			filterController: $elm$core$Maybe$Just(filterControllerModel_),
			filterDefinition: $elm$core$Maybe$Nothing,
			paginationStatus: $author$project$NetworkLogs$Model$PaginationHide,
			showCreateLocation: true
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$NetworkLogs$Model$FilterControllerMsg, filterControllerCmd_)
					])));
	});
var $author$project$Translations$General$WorkerLog$date = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.date');
};
var $author$project$Translations$General$WorkerLog$user = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.user');
};
var $author$project$Translations$General$WorkerLog$network = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.network');
};
var $author$project$Translations$General$WorkerLog$details = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.details');
};
var $author$project$NetworkLogs$View$wrapper = F2(
	function (html, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$WorkerLog$workerLogTitle(translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$General$WorkerLog$details(translations))
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__background--white')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-table network-log-list-table')
								]),
							html)
						]))
				]));
	});
var $author$project$NetworkLogs$Model$ToggleMore = function (a) {
	return {$: 'ToggleMore', a: a};
};
var $author$project$NetworkLogs$Model$UiTableMsg = function (a) {
	return {$: 'UiTableMsg', a: a};
};
var $author$project$Translations$General$WorkerLog$fieldTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.field_title');
};
var $author$project$NetworkLogs$Model$UiSelectMsg = function (a) {
	return {$: 'UiSelectMsg', a: a};
};
var $author$project$NetworkLogs$View$errorBanner = F2(
	function (userMessage, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('util__inset')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-bar status-bar--symbol status-bar--danger')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-bar__message')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$error(translations) + ': ')
										])),
									$elm$html$Html$text(userMessage)
								]))
						]))
				]));
	});
var $author$project$NetworkLogs$View$getPostLink = F2(
	function (workItem, _v0) {
		var siteName = _v0.a;
		var postBaseUrl = '/location-posts/';
		if (workItem.$ === 'Nothing') {
			return '';
		} else {
			var work = workItem.a;
			return (work.itemType === 'locationPost') ? (_Utils_eq(
				work.data.network,
				$elm$core$Maybe$Just($author$project$Data$Network$Google)) ? (postBaseUrl + (siteName + ('/posts/google/' + (A2($elm$core$Maybe$withDefault, '', work.data.locationPostId) + '/status?postStatusView=published_status')))) : (postBaseUrl + (siteName + ('/posts/status/' + (A2($elm$core$Maybe$withDefault, '', work.data.locationPostId) + '?view=published_status'))))) : '';
		}
	});
var $author$project$NetworkLogs$Model$LocationName = {$: 'LocationName'};
var $author$project$Translations$General$WorkerLog$showMore = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.show_more');
};
var $author$project$NetworkLogs$Model$PaginateNetworkLogs = {$: 'PaginateNetworkLogs'};
var $author$project$NetworkLogs$View$withShowMore = F2(
	function (paginationStatus, translations) {
		switch (paginationStatus.$) {
			case 'PaginationLoaded':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-log-pagination')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtn,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$NetworkLogs$Model$PaginateNetworkLogs)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$WorkerLog$showMore(translations))
								]))
						]));
			case 'PaginationLoading':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-log-pagination')
						]),
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('network-log-pagination')
						]),
					_List_Nil);
		}
	});
var $author$project$Translations$General$WorkerLog$locationTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.location_title');
};
var $author$project$Translations$General$WorkerLog$noEntriesText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.no_entries_text');
};
var $author$project$Translations$General$WorkerLog$noEntriesTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.no_entries_title');
};
var $author$project$PinMeTo$Ui$Table$withoutSorting = function (config) {
	return _Utils_update(
		config,
		{sortableColumns: _List_Nil});
};
var $author$project$NetworkLogs$Model$LocationStoreId = {$: 'LocationStoreId'};
var $author$project$Translations$General$WorkerLog$clickHereSeeLog = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.click_here_see_log');
};
var $author$project$Translations$General$WorkerLog$storeId = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.store_id');
};
var $author$project$Translations$General$WorkerLog$storefrontName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.storefront_name');
};
var $author$project$Translations$General$WorkerLog$locationDescriptor = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.location_descriptor');
};
var $author$project$NetworkLogs$View$idLocationToString = F2(
	function (translations, idLocation) {
		switch (idLocation.$) {
			case 'LocationDescriptorField':
				return $author$project$Translations$General$WorkerLog$locationDescriptor(translations);
			case 'LocationStoreId':
				return $author$project$Translations$General$WorkerLog$storeId(translations);
			default:
				return $author$project$Translations$General$WorkerLog$storefrontName(translations);
		}
	});
var $author$project$Translations$General$WorkerLog$locationColumnText = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.location_column_text');
};
var $author$project$NetworkLogs$View$getStoreId = function (workItemDataLocation) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (location) {
			return location.storeId;
		},
		workItemDataLocation);
};
var $author$project$NetworkLogs$Model$MoreUiTableMsg = function (a) {
	return {$: 'MoreUiTableMsg', a: a};
};
var $author$project$PinMeTo$Ui$Table$withoutHeaders = function (config) {
	return _Utils_update(
		config,
		{displayHeaders: false});
};
var $author$project$NetworkLogs$View$getLocationName = F3(
	function (location, locationColumn, translations) {
		var storeIdTranslationText = $author$project$Translations$General$WorkerLog$storeId(translations) + ': ';
		switch (locationColumn.$) {
			case 'LocationDescriptorField':
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(location.locationDescriptor)) ? _Utils_ap(storeIdTranslationText, location.storeId) : location.locationDescriptor;
			case 'LocationStoreId':
				return _Utils_ap(storeIdTranslationText, location.storeId);
			default:
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(location.name)) ? _Utils_ap(storeIdTranslationText, location.storeId) : location.name;
		}
	});
var $author$project$NetworkLogs$Model$ToggleMoreDetail = function (a) {
	return {$: 'ToggleMoreDetail', a: a};
};
var $author$project$NetworkLogs$Model$supportedNetworks = _List_fromArray(
	[$author$project$Data$Network$Google, $author$project$Data$Network$Facebook, $author$project$Data$Network$Bing, $author$project$Data$Network$Apple, $author$project$Data$Network$Ptv, $author$project$Data$Network$Instagram]);
var $author$project$Data$Network$Off = {$: 'Off'};
var $author$project$Data$Network$Failed = {$: 'Failed'};
var $author$project$Data$Network$Pending = {$: 'Pending'};
var $author$project$Data$Network$Success = {$: 'Success'};
var $author$project$NetworkLogs$View$getNetworkState = function (state) {
	switch (state) {
		case 'done':
			return $author$project$Data$Network$Success;
		case 'error':
			return $author$project$Data$Network$Failed;
		case 'inProgress':
			return $author$project$Data$Network$Pending;
		default:
			return $author$project$Data$Network$Off;
	}
};
var $author$project$PinMeTo$Ui$Icon$BingOff = {$: 'BingOff'};
var $author$project$PinMeTo$Ui$Icon$GoogleOff = {$: 'GoogleOff'};
var $author$project$PinMeTo$Ui$Icon$BingFailed = {$: 'BingFailed'};
var $author$project$PinMeTo$Ui$Icon$BingPending = {$: 'BingPending'};
var $author$project$PinMeTo$Ui$Icon$BingSuccess = {$: 'BingSuccess'};
var $author$project$PinMeTo$Ui$Icon$FacebookOff = {$: 'FacebookOff'};
var $author$project$PinMeTo$Ui$Icon$GoogleFailed = {$: 'GoogleFailed'};
var $author$project$PinMeTo$Ui$Icon$InstagramOff = {$: 'InstagramOff'};
var $author$project$PinMeTo$Ui$Icon$GooglePending = {$: 'GooglePending'};
var $author$project$PinMeTo$Ui$Icon$GoogleSuccess = {$: 'GoogleSuccess'};
var $author$project$PinMeTo$Ui$Icon$FacebookFailed = {$: 'FacebookFailed'};
var $author$project$PinMeTo$Ui$Icon$FacebookPending = {$: 'FacebookPending'};
var $author$project$PinMeTo$Ui$Icon$FacebookSuccess = {$: 'FacebookSuccess'};
var $author$project$PinMeTo$Ui$Icon$InstagramFailed = {$: 'InstagramFailed'};
var $author$project$PinMeTo$Ui$Icon$InstagramPending = {$: 'InstagramPending'};
var $author$project$PinMeTo$Ui$Icon$InstagramSuccess = {$: 'InstagramSuccess'};
var $author$project$PinMeTo$Ui$Icon$RegularColorPTVOff = {$: 'RegularColorPTVOff'};
var $author$project$PinMeTo$Ui$Icon$RegularColorAppleOff = {$: 'RegularColorAppleOff'};
var $author$project$PinMeTo$Ui$Icon$RegularColorPTVFailed = {$: 'RegularColorPTVFailed'};
var $author$project$PinMeTo$Ui$Icon$RegularColorPTVPending = {$: 'RegularColorPTVPending'};
var $author$project$PinMeTo$Ui$Icon$RegularColorPTVSuccess = {$: 'RegularColorPTVSuccess'};
var $author$project$PinMeTo$Ui$Icon$RegularColorAppleFailed = {$: 'RegularColorAppleFailed'};
var $author$project$PinMeTo$Ui$Icon$RegularColorApplePending = {$: 'RegularColorApplePending'};
var $author$project$PinMeTo$Ui$Icon$RegularColorAppleSuccess = {$: 'RegularColorAppleSuccess'};
var $author$project$Data$Network$renderNetworkSvgIconWithStatus = F2(
	function (network, networkStatus) {
		var _v0 = _Utils_Tuple2(network, networkStatus);
		_v0$24:
		while (true) {
			switch (_v0.b.$) {
				case 'Off':
					switch (_v0.a.$) {
						case 'Apple':
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorAppleOff));
						case 'Bing':
							var _v9 = _v0.a;
							var _v10 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$BingOff));
						case 'Facebook':
							var _v17 = _v0.a;
							var _v18 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$FacebookOff));
						case 'Google':
							var _v25 = _v0.a;
							var _v26 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$GoogleOff));
						case 'Ptv':
							var _v33 = _v0.a;
							var _v34 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTVOff));
						case 'Instagram':
							var _v41 = _v0.a;
							var _v42 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$InstagramOff));
						default:
							break _v0$24;
					}
				case 'Success':
					switch (_v0.a.$) {
						case 'Apple':
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorAppleSuccess));
						case 'Bing':
							var _v11 = _v0.a;
							var _v12 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$BingSuccess));
						case 'Facebook':
							var _v19 = _v0.a;
							var _v20 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$FacebookSuccess));
						case 'Google':
							var _v27 = _v0.a;
							var _v28 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$GoogleSuccess));
						case 'Ptv':
							var _v35 = _v0.a;
							var _v36 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTVSuccess));
						case 'Instagram':
							var _v43 = _v0.a;
							var _v44 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$InstagramSuccess));
						default:
							break _v0$24;
					}
				case 'Pending':
					switch (_v0.a.$) {
						case 'Apple':
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorApplePending));
						case 'Bing':
							var _v13 = _v0.a;
							var _v14 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$BingPending));
						case 'Facebook':
							var _v21 = _v0.a;
							var _v22 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$FacebookPending));
						case 'Google':
							var _v29 = _v0.a;
							var _v30 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$GooglePending));
						case 'Ptv':
							var _v37 = _v0.a;
							var _v38 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTVPending));
						case 'Instagram':
							var _v45 = _v0.a;
							var _v46 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$InstagramPending));
						default:
							break _v0$24;
					}
				default:
					switch (_v0.a.$) {
						case 'Apple':
							var _v7 = _v0.a;
							var _v8 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorAppleFailed));
						case 'Bing':
							var _v15 = _v0.a;
							var _v16 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$BingFailed));
						case 'Facebook':
							var _v23 = _v0.a;
							var _v24 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$FacebookFailed));
						case 'Google':
							var _v31 = _v0.a;
							var _v32 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$GoogleFailed));
						case 'Ptv':
							var _v39 = _v0.a;
							var _v40 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTVFailed));
						case 'Instagram':
							var _v47 = _v0.a;
							var _v48 = _v0.b;
							return $elm$core$Maybe$Just(
								$author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$InstagramFailed));
						default:
							break _v0$24;
					}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$NetworkLogs$View$getNetworkItemDetailIcon = F2(
	function (network, networkState) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (n) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('network-log-list-table-more__network-icon'),
								$elm$html$Html$Attributes$id(
								A2(
									$elm$core$Maybe$withDefault,
									'-icon',
									A2($elm$core$Maybe$map, $author$project$Data$Network$toString, network)) + '-icon')
							]),
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$author$project$Data$Network$renderNetworkSvgIconWithStatus,
									n,
									$author$project$NetworkLogs$View$getNetworkState(networkState))
								])));
				},
				network));
	});
var $author$project$NetworkLogs$View$networkEnabled = F2(
	function (network, analytics) {
		var isEnabled = function (networkAnalytics) {
			switch (networkAnalytics.$) {
				case 'NotVisible':
					return false;
				case 'CanEnable':
					return false;
				default:
					return true;
			}
		};
		switch (network.$) {
			case 'Google':
				return isEnabled(analytics.google);
			case 'Facebook':
				return isEnabled(analytics.facebook);
			case 'Apple':
				return isEnabled(analytics.apple);
			case 'Bing':
				return isEnabled(analytics.bing);
			case 'Foursquare':
				return isEnabled(analytics.foursquare);
			case 'Overture':
				return isEnabled(analytics.overture);
			case 'Here':
				return isEnabled(analytics.here);
			case 'Tomtom':
				return isEnabled(analytics.tomtom);
			case 'Ptv':
				return isEnabled(analytics.ptv);
			default:
				return isEnabled(analytics.instagram);
		}
	});
var $author$project$NetworkLogs$View$enabledNetworksList = function (analytics) {
	return A2(
		$elm$core$List$filter,
		function (network) {
			return A2($author$project$NetworkLogs$View$networkEnabled, network, analytics);
		},
		$author$project$Data$Network$allNetworks);
};
var $author$project$Translations$General$WorkerLog$email = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.email');
};
var $author$project$Translations$General$WorkerLog$media = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.media');
};
var $author$project$Translations$General$WorkerLog$address = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.address');
};
var $author$project$Translations$General$WorkerLog$homepage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.homepage');
};
var $author$project$Translations$General$WorkerLog$openHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.open_hours');
};
var $author$project$Translations$General$WorkerLog$coverImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.cover_image');
};
var $author$project$Translations$General$WorkerLog$actionLinks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.action_links');
};
var $author$project$Translations$General$WorkerLog$openingDate = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.opening_date');
};
var $author$project$Translations$General$WorkerLog$phoneNumber = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.phone_number');
};
var $author$project$Translations$General$WorkerLog$serviceArea = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.service_area');
};
var $author$project$Translations$General$WorkerLog$bingCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.bing_category');
};
var $author$project$Translations$General$WorkerLog$locationPost = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.location_post');
};
var $author$project$Translations$General$WorkerLog$profileImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.profile_image');
};
var $author$project$Translations$General$WorkerLog$serviceItems = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.service_items');
};
var $author$project$Translations$General$WorkerLog$appleCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.apple_category');
};
var $author$project$Translations$General$WorkerLog$geoCoordinates = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.geo_coordinates');
};
var $author$project$Translations$General$WorkerLog$googleCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.google_category');
};
var $author$project$Translations$General$WorkerLog$huaweiCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.huawei_category');
};
var $author$project$Translations$General$WorkerLog$longDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.long_description');
};
var $author$project$Translations$General$WorkerLog$googleCustomName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.google_custom_name');
};
var $author$project$Translations$General$WorkerLog$shortDescription = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.short_description');
};
var $author$project$Translations$General$WorkerLog$specialOpenHours = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.special_open_hours');
};
var $author$project$Translations$General$WorkerLog$permanentlyClosed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.permanently_closed');
};
var $author$project$Translations$General$WorkerLog$facebookCustomName = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.facebook_custom_name');
};
var $author$project$Translations$General$WorkerLog$foursquareCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.foursquare_category');
};
var $author$project$Translations$General$WorkerLog$facebookSubCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.facebook_sub_category');
};
var $author$project$Translations$General$WorkerLog$googlePrimaryCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.google_primary_category');
};
var $author$project$Translations$General$WorkerLog$googleNetworkAttribute = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.google_network_attribute');
};
var $author$project$Translations$General$WorkerLog$temporarilyClosedUntil = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.temporarily_closed_until');
};
var $author$project$NetworkLogs$View$getFieldNameConversion = F3(
	function (model, fieldName, workItems) {
		var postTitle = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (work) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function (title) {
						return ': ' + title;
					},
					work.data.locationPostTitle);
			},
			$elm$core$List$head(workItems));
		var fieldKeys = _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$profileImage(model.translations),
				_List_fromArray(
					['networkMedia.google.profileImage', 'media.profileImage', 'networkMedia.facebook.profileImage'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$coverImage(model.translations),
				_List_fromArray(
					['networkMedia.google.coverImage', 'media.coverImage', 'networkMedia.facebook.coverImage'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$media(model.translations),
				_List_fromArray(
					['networkMedia.google.media'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$permanentlyClosed(model.translations),
				_List_fromArray(
					['permanentlyClosed'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$phoneNumber(model.translations),
				_List_fromArray(
					['contact.phone'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$specialOpenHours(model.translations),
				_List_fromArray(
					['specialOpenHours'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$temporarilyClosedUntil(model.translations),
				_List_fromArray(
					['temporarilyClosedUntil'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$openHours(model.translations),
				_List_fromArray(
					['openHours'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$address(model.translations),
				_List_fromArray(
					['address'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$googleNetworkAttribute(model.translations),
				_List_fromArray(
					['networkAttributes.google'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$locationPost(model.translations),
				_List_fromArray(
					['locationPost'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$homepage(model.translations),
				_List_fromArray(
					['contact.homepage'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$email(model.translations),
				_List_fromArray(
					['contact.email'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$facebookSubCategory(model.translations),
				_List_fromArray(
					['networkCategories.facebook.subcategories'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$googlePrimaryCategory(model.translations),
				_List_fromArray(
					['networkCategories.google.primary', 'networkCategories.google.additional', 'networkCategories.google.primary, networkCategories.google.additional'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$googleCategory(model.translations),
				_List_fromArray(
					['networkCategories.google.additional'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$shortDescription(model.translations),
				_List_fromArray(
					['shortDescription'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$longDescription(model.translations),
				_List_fromArray(
					['longDescription'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$geoCoordinates(model.translations),
				_List_fromArray(
					['location'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$facebookCustomName(model.translations),
				_List_fromArray(
					['fb.custom.name'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$googleCustomName(model.translations),
				_List_fromArray(
					['google.custom.name'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$huaweiCategory(model.translations),
				_List_fromArray(
					['networkCategories.huawei.primary, networkCategories.huawei.additional', 'networkCategories.huawei.primary', 'networkCategories.huawei.additional'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$openingDate(model.translations),
				_List_fromArray(
					['openingDate'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$storefrontName(model.translations),
				_List_fromArray(
					['name'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$storeId(model.translations),
				_List_fromArray(
					['storeId'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$media(model.translations),
				_List_fromArray(
					['Media'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$locationDescriptor(model.translations),
				_List_fromArray(
					['locationDescriptor'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$serviceArea(model.translations),
				_List_fromArray(
					['serviceArea'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$serviceArea(model.translations),
				_List_fromArray(
					['serviceAreas'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$foursquareCategory(model.translations),
				_List_fromArray(
					['networkCategories.foursquare.primary', 'networkCategories.foursquare.additional'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$bingCategory(model.translations),
				_List_fromArray(
					['networkCategories.bing.primaryCategoryId', 'networkCategories.bing.categories', 'networkCategories.bing.primaryCategoryId, networkCategories.bing.categories'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$appleCategory(model.translations),
				_List_fromArray(
					['networkCategories.apple.primary, networkCategories.apple.additional', 'networkCategories.apple.primary', 'networkCategories.apple.additional'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$serviceItems(model.translations),
				_List_fromArray(
					['networkServiceItems.google'])),
				_Utils_Tuple2(
				$author$project$Translations$General$WorkerLog$actionLinks(model.translations),
				_List_fromArray(
					['actionLinks', 'networkActionLinks.google']))
			]);
		var translateField = function (rawField) {
			var field = $elm$core$String$trim(rawField);
			var _v0 = A2(
				$elm$core$List$filter,
				function (_v1) {
					var listItem = _v1.b;
					return A2($elm$core$List$member, field, listItem);
				},
				fieldKeys);
			if (_v0.b) {
				var _v2 = _v0.a;
				var name = _v2.a;
				return (field === 'locationPost') ? _Utils_ap(name, postTitle) : name;
			} else {
				return field;
			}
		};
		var fields = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$String$split, ',', fieldName)));
		return A2(
			$elm$core$String$join,
			', ',
			$elm_community$list_extra$List$Extra$unique(
				A2($elm$core$List$map, translateField, fields)));
	});
var $author$project$NetworkLogs$View$getFirstWorkItemPropertiesAsString = function (workItems) {
	var _v0 = $elm$core$List$head(workItems);
	if (_v0.$ === 'Just') {
		var firstWorkItem = _v0.a;
		return $elm$core$List$isEmpty(firstWorkItem.data.properties) ? firstWorkItem.itemType : A2($elm$core$String$join, ', ', firstWorkItem.data.properties);
	} else {
		return '';
	}
};
var $author$project$NetworkLogs$View$groupWorkItemsByLocationId = F3(
	function (model, analytics, workItems) {
		var groupByLocationId = F2(
			function (items, acc) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (item, acc_) {
							var _v1 = item.data.locationId;
							if (_v1.$ === 'Just') {
								var id = _v1.a;
								var _v2 = A2(
									$elm$core$List$partition,
									function (_v3) {
										var maybeId = _v3.a;
										return _Utils_eq(
											maybeId,
											$elm$core$Maybe$Just(id));
									},
									acc_);
								var matched = _v2.a;
								var rest = _v2.b;
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$elm$core$Maybe$Just(id),
										A2(
											$elm$core$List$cons,
											item,
											$elm$core$List$concat(
												A2($elm$core$List$map, $elm$core$Tuple$second, matched)))),
									rest);
							} else {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										_List_fromArray(
											[item])),
									acc_);
							}
						}),
					acc,
					items);
			});
		var groupedWorkItems = A2(groupByLocationId, workItems, _List_Nil);
		var groupedList = function (list) {
			var allNetworks = A2(
				$elm$core$List$map,
				function (n) {
					return {status: '', network: n};
				},
				$author$project$NetworkLogs$View$enabledNetworksList(analytics));
			var locationRows = A2(
				$elm$core$List$map,
				function (workItemsList) {
					var firstElement = $elm$core$List$head(workItemsList);
					var row = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						{
							field: '',
							changes: _List_Nil,
							location: $elm$core$Maybe$Just(
								{name: '', storeId: '', locationDescriptor: ''}),
							networks: _List_Nil
						},
						function (element) {
							var networkStatusList = A2(
								$elm$core$List$map,
								function (y) {
									var filtered = A2(
										$elm$core$List$filter,
										function (x) {
											return _Utils_eq(
												$elm$core$Maybe$Just(y.network),
												x.data.network);
										},
										workItemsList);
									if ($elm$core$List$isEmpty(filtered)) {
										return {
											status: y.status,
											network: $elm$core$Maybe$Just(y.network)
										};
									} else {
										var _v0 = $elm$core$List$head(filtered);
										if (_v0.$ === 'Just') {
											var f = _v0.a;
											return {status: f.state, network: f.data.network};
										} else {
											return {status: '', network: $elm$core$Maybe$Nothing};
										}
									}
								},
								allNetworks);
							var fieldName = A3(
								$author$project$NetworkLogs$View$getFieldNameConversion,
								model,
								$author$project$NetworkLogs$View$getFirstWorkItemPropertiesAsString(workItemsList),
								workItemsList);
							return {field: fieldName, changes: workItemsList, location: element.data.location, networks: networkStatusList};
						},
						firstElement);
					return row;
				},
				list);
			return locationRows;
		};
		var result = A2($elm$core$List$map, $elm$core$Tuple$second, groupedWorkItems);
		return groupedList(result);
	});
var $author$project$Translations$General$WorkerLog$logDetails = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.log_details');
};
var $author$project$Translations$General$WorkerLog$off = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.off');
};
var $author$project$Translations$General$WorkerLog$failed = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.failed');
};
var $author$project$Translations$General$WorkerLog$pending = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.pending');
};
var $author$project$Translations$General$WorkerLog$published = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.published');
};
var $author$project$PinMeTo$Ui$Icon$GoogleColor = {$: 'GoogleColor'};
var $author$project$PinMeTo$Ui$Icon$FacebookColor = {$: 'FacebookColor'};
var $author$project$PinMeTo$Ui$Icon$InstagramColor = {$: 'InstagramColor'};
var $author$project$Data$Network$toSvgIcon = function (network) {
	switch (network.$) {
		case 'Google':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$GoogleColor);
		case 'Facebook':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$FacebookColor);
		case 'Apple':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorApple);
		case 'Bing':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorBing);
		case 'Foursquare':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorFoursquare);
		case 'Overture':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorOverture);
		case 'Here':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorHere);
		case 'Tomtom':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorTomTom);
		case 'Ptv':
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$RegularColorPTV);
		default:
			return $author$project$PinMeTo$Ui$Icon$render($author$project$PinMeTo$Ui$Icon$InstagramColor);
	}
};
var $author$project$NetworkLogs$CardView$renderCard = F7(
	function (translations, network, networkStatus, errorMessage, locationUrl, contentFrom, contentTo) {
		var _v0 = function () {
			switch (networkStatus.$) {
				case 'Success':
					return _Utils_Tuple2(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__icon__success')
								]),
							_List_fromArray(
								[
									$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircleCheck)
								])),
						$author$project$Translations$General$WorkerLog$published(translations));
				case 'Failed':
					return _Utils_Tuple2(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__icon__failed')
								]),
							_List_fromArray(
								[
									$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faCircleXmark)
								])),
						$author$project$Translations$General$WorkerLog$failed(translations));
				case 'Off':
					return _Utils_Tuple2(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__icon__off')
								]),
							_List_fromArray(
								[
									$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faClock)
								])),
						$author$project$Translations$General$WorkerLog$off(translations));
				default:
					return _Utils_Tuple2(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__icon__pending')
								]),
							_List_fromArray(
								[
									$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faClock)
								])),
						$author$project$Translations$General$WorkerLog$pending(translations));
			}
		}();
		var statusHtml = _v0.a;
		var statusText = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-log-card-view__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__logo-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__logo-box__logo-icon')
										]),
									_List_fromArray(
										[
											function () {
											if (network.$ === 'Just') {
												var something = network.a;
												return $author$project$Data$Network$toSvgIcon(something);
											} else {
												return $elm$html$Html$text('');
											}
										}()
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__logo-box__logo-text__network-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											function () {
												if (network.$ === 'Just') {
													var actualNetwork = network.a;
													return $author$project$Data$Network$toHumanReadable(actualNetwork);
												} else {
													return 'Unknown';
												}
											}())
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__icon')
										]),
									_List_fromArray(
										[statusHtml])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__top-inner-container__status-box__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(statusText)
										]))
								]))
						])),
					($elm$core$String$length(errorMessage) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-log-card-view__content-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$PinMeTo$Ui$Alert$render(
									A2(
										$author$project$PinMeTo$Ui$Alert$withStatus,
										$author$project$PinMeTo$Ui$Alert$Error,
										$author$project$PinMeTo$Ui$Alert$rich(
											_List_fromArray(
												[
													A3($author$project$Common$ErrorMessages$getError, errorMessage, locationUrl, translations)
												]))))
								]))
						])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('full-data-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-data-container__from')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__middle-title-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-log-card-view__middle-title-box__text-style')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('From:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__content-box')
										]),
									_List_fromArray(
										[contentFrom]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('arrow-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa-solid fa-arrow-right')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-data-container__to')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__middle-title-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-log-card-view__middle-title-box__text-style')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('To:')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-log-card-view__content-box')
										]),
									_List_fromArray(
										[contentTo]))
								]))
						]))
				]));
	});
var $author$project$NetworkLogs$View$getLocationUrl = function (workItemsList) {
	var _v0 = A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		_Utils_Tuple2('', ''),
		function (workItem) {
			return _Utils_Tuple2(
				workItem.data.siteName,
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, workItem.data.locationId));
		},
		$elm$core$List$head(workItemsList));
	var siteName = _v0.a;
	var locationId = _v0.b;
	return '/listings/' + (siteName + ('/locations/' + locationId));
};
var $author$project$NetworkLogs$View$getLocationLink = F2(
	function (workItemsList, storeId) {
		var _v0 = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2('', ''),
			function (workItem) {
				return _Utils_Tuple2(
					workItem.data.siteName,
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, workItem.data.locationId));
			},
			$elm$core$List$head(workItemsList));
		var siteName = _v0.a;
		var locationId = _v0.b;
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/listings/' + (siteName + ('/locations/' + locationId))),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(storeId)
				]));
	});
var $author$project$NetworkLogs$CardView$renderMedia = function (url) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('networks-log__value ')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(url)
					]),
				_List_Nil)
			]));
};
var $author$project$NetworkLogs$View$getAttributes = function (attributes) {
	var rawAttributes = A2(
		$elm$core$List$map,
		function (attribute) {
			var _v0 = attribute.valueType;
			switch (_v0) {
				case 'ENUM':
					return {name: attribute.attributeId, type_: attribute.valueType, values: attribute.values, unsetValue: _List_Nil};
				case 'REPEATED_ENUM':
					return {
						name: attribute.attributeId,
						type_: attribute.valueType,
						values: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (x) {
								return x.setValues;
							},
							attribute.repeatedEnumValue),
						unsetValue: A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (x) {
								return x.unsetValues;
							},
							attribute.repeatedEnumValue)
					};
				default:
					return {name: attribute.attributeId, type_: attribute.valueType, values: attribute.values, unsetValue: _List_Nil};
			}
		},
		attributes);
	return A2(
		$elm$core$List$filter,
		function (attribute) {
			return !_Utils_eq(attribute.values, _List_Nil);
		},
		rawAttributes);
};
var $author$project$NetworkLogs$CardView$renderAddress = F2(
	function (translations, value) {
		var _v0 = function () {
			var _v1 = value.stateOrProvince;
			if (_v1.$ === 'WithState') {
				var state = _v1.a;
				return _Utils_Tuple2(
					$author$project$Translations$General$locationState(translations),
					state);
			} else {
				var province = _v1.a;
				return _Utils_Tuple2(
					$author$project$Translations$General$locationState(translations),
					province.district + (', ' + province.province));
			}
		}();
		var stateTitle = _v0.a;
		var stateValue = _v0.b;
		var addressRow = F2(
			function (title, text_) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('networks-log__table--td-address-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('networks-log__table--td-address-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(text_)
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									addressRow,
									$author$project$Translations$General$locationStreet(translations),
									value.street),
									A2(
									addressRow,
									$author$project$Translations$General$locationCity(translations),
									value.city),
									A2(
									addressRow,
									$author$project$Translations$General$locationZip(translations),
									value.zip),
									A2(addressRow, stateTitle, stateValue),
									A2(
									addressRow,
									$author$project$Translations$General$locationCountry(translations),
									value.country)
								]))
						]))
				]));
	});
var $author$project$NetworkLogs$CardView$renderOpenHours = F2(
	function (hour, translations) {
		var hourText = '24' + $author$project$Translations$General$abbrHour(translations);
		var displayDaySpan = function (day) {
			switch (day.$) {
				case 'Open':
					var span = day.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (s) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Listings$Ui$Row$displayTimeSpan(
												{open: s.open, close: s.close}))
										]));
							},
							span));
				case 'Closed':
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$closed(translations))
							]));
				case 'NotSpecified':
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Listings$Ui$Row$emptyValueSpan(translations)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(hourText)
							]));
			}
		};
		if (hour.$ === 'Always') {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$Listings$LocationDetail$alwaysOpen(translations))
					]));
		} else {
			var sun = hour.a.sun;
			var sat = hour.a.sat;
			var fri = hour.a.fri;
			var thu = hour.a.thu;
			var wed = hour.a.wed;
			var tue = hour.a.tue;
			var mon = hour.a.mon;
			var weekObjects = _List_fromArray(
				[
					{
					key: $author$project$Translations$General$mon(translations),
					value: displayDaySpan(mon)
				},
					{
					key: $author$project$Translations$General$tue(translations),
					value: displayDaySpan(tue)
				},
					{
					key: $author$project$Translations$General$wed(translations),
					value: displayDaySpan(wed)
				},
					{
					key: $author$project$Translations$General$thu(translations),
					value: displayDaySpan(thu)
				},
					{
					key: $author$project$Translations$General$fri(translations),
					value: displayDaySpan(fri)
				},
					{
					key: $author$project$Translations$General$sat(translations),
					value: displayDaySpan(sat)
				},
					{
					key: $author$project$Translations$General$sun(translations),
					value: displayDaySpan(sun)
				}
				]);
			var cssClass = 'networks-log__table';
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(cssClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('max-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (day) {
										return A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(cssClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(day.key)
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(cssClass + '--td-center'),
															$elm$html$Html$Attributes$class(cssClass + '__open-hours-value')
														]),
													_List_fromArray(
														[day.value]))
												]));
									},
									weekObjects))
							]))
					]));
		}
	});
var $author$project$NetworkLogs$View$fromBoolToString = F2(
	function (translations, boolValue) {
		return boolValue ? $author$project$Translations$General$yes(translations) : $author$project$Translations$General$no(translations);
	});
var $author$project$Translations$General$WorkerLog$bingPrimaryCategory = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.bing_primary_category');
};
var $author$project$NetworkLogs$View$serviceAreaToString = F2(
	function (translations, serviceAreas) {
		var longName = function (area) {
			return area.longName;
		};
		var unwrapServiceArea = F2(
			function (area, str) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					str,
					function (x) {
						return (str === '') ? longName(x) : (str + (', ' + longName(x)));
					},
					area);
			});
		var unwrappedServiceAreas = A2(
			$elm$core$List$map,
			function (area) {
				return A2(
					unwrapServiceArea,
					$elm$core$Maybe$Just(area.country),
					A2(
						unwrapServiceArea,
						area.state,
						A2(
							unwrapServiceArea,
							area.region,
							A2(
								unwrapServiceArea,
								area.city,
								A2(unwrapServiceArea, area.zip, '')))));
			},
			A2($elm$core$List$take, 5, serviceAreas));
		var serviceAreaStringList = ($elm$core$List$length(serviceAreas) > 5) ? A2(
			$elm$core$List$append,
			unwrappedServiceAreas,
			_List_fromArray(
				[
					A2(
					$author$project$Translations$Listings$LocationDetail$plusAmount,
					translations,
					$elm$core$String$fromInt(
						$elm$core$List$length(serviceAreas) - 5))
				])) : unwrappedServiceAreas;
		return serviceAreaStringList;
	});
var $author$project$NetworkLogs$CardView$renderActionLinksTable = function (links) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('networks-log__value networks-log__table')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('special-open-hours-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (link) {
								return A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('networks-log__table--td-special-hour-date')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Data$Location$ActionLinks$actionLinkTypeToString(link.type_))
												])),
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('networks-log__table--td-special-hour-label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(link.url)
												]))
										]));
							},
							links))
					]))
			]));
};
var $author$project$NetworkLogs$CardView$renderGoogleServicesTable = function (services) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('networks-log__value networks-log__table')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('google-services-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$th,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('networks-log__table--td-google-service-id')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Service')
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('networks-log__table--td-google-service-price')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Price')
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('networks-log__table--td-google-service-description')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Description')
											])),
									A2(
										$elm$core$List$map,
										function (service) {
											return A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('networks-log__table--td-google-service-id')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																function () {
																	if (service.$ === 'Structured') {
																		var structured = service.a;
																		return $author$project$Data$Location$NetworkServiceItems$parseStructuredServiceId(structured.id);
																	} else {
																		var freeform = service.a;
																		return freeform.label.displayName;
																	}
																}())
															])),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('networks-log__table--td-google-service-price')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																function () {
																	if (service.$ === 'Structured') {
																		var structured = service.a;
																		return A3(
																			$elm_community$maybe_extra$Maybe$Extra$unwrap,
																			'',
																			$elm$core$Basics$identity,
																			A2(
																				$elm$core$Maybe$map,
																				function (price) {
																					return price.amount + (' ' + price.currency);
																				},
																				structured.price));
																	} else {
																		var freeform = service.a;
																		return A3(
																			$elm_community$maybe_extra$Maybe$Extra$unwrap,
																			'',
																			$elm$core$Basics$identity,
																			A2(
																				$elm$core$Maybe$map,
																				function (price) {
																					return price.amount + (' ' + price.currency);
																				},
																				freeform.price));
																	}
																}())
															])),
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('networks-log__table--td-google-service-description')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																function () {
																	if (service.$ === 'Structured') {
																		var structured = service.a;
																		return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, structured.description);
																	} else {
																		var freeform = service.a;
																		return A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, freeform.label.description);
																	}
																}())
															]))
													]));
										},
										services)))))
					]))
			]));
};
var $author$project$Translations$General$WorkerLog$additionalCategories = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.additional_categories');
};
var $author$project$NetworkLogs$CardView$renderAdditionalCategories = F2(
	function (list, translations) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$List$isEmpty(list) ? '' : ($author$project$Translations$General$WorkerLog$additionalCategories(translations) + ': ')),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									function (category) {
										return category.name;
									},
									list)))
						]))
				]));
	});
var $author$project$NetworkLogs$CardView$renderSpecialOpenHoursTable = F2(
	function (upcomingDatesList, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('networks-log__value networks-log__table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('special-open-hours-table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (hour) {
									return A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('networks-log__table--td-special-hour-date')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(hour.startDate)
													])),
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('networks-log__table--td-special-hour-time')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														function () {
															var _v0 = hour.state;
															if (_v0.$ === 'Open') {
																var span = _v0.a;
																return $author$project$Listings$Ui$Row$displayTimeSpan(
																	{open: span.open, close: span.close});
															} else {
																return $author$project$Translations$General$closed(translations);
															}
														}())
													])),
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('networks-log__table--td-special-hour-label')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, hour.label))
													]))
											]));
								},
								upcomingDatesList))
						]))
				]));
	});
var $author$project$NetworkLogs$View$renderChangeValues = F2(
	function (translations, workItem) {
		var getTextDuple = F2(
			function (value1, value2) {
				return _Utils_Tuple2(
					$elm$html$Html$text(value1),
					$elm$html$Html$text(value2));
			});
		switch (workItem.$) {
			case 'UnknownChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, value.from),
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, value.to));
			case 'StoreIdChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$storeIdToString(value.from),
					$author$project$Data$Location$storeIdToString(value.to));
			case 'GoogleChainIdChange':
				var value = workItem.a;
				return A2(getTextDuple, value.from, value.to);
			case 'OpeningDateChange':
				var value = workItem.a;
				return A2(getTextDuple, value.from, value.to);
			case 'NameChange':
				var value = workItem.a;
				return A2(getTextDuple, value.from, value.to);
			case 'TemporarilyClosedUntilChange':
				var value = workItem.a;
				return A2(getTextDuple, value.from, value.to);
			case 'LocationDescriptorChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$locationDescriptorToString(value.from),
					$author$project$Data$Location$locationDescriptorToString(value.to));
			case 'LongDescriptionChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$longDescriptionToString(value.from),
					$author$project$Data$Location$longDescriptionToString(value.to));
			case 'FbCustomNameChange':
				var value = workItem.a;
				return A2(getTextDuple, value.from, value.to);
			case 'ContactPhoneChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$phoneToString(value.from),
					$author$project$Data$Location$phoneToString(value.to));
			case 'ContactEmailChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$emailToString(value.from),
					$author$project$Data$Location$emailToString(value.to));
			case 'ContactHomepageChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$homepageToString(value.from),
					$author$project$Data$Location$homepageToString(value.to));
			case 'BoolChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A2($author$project$NetworkLogs$View$fromBoolToString, translations, value.from),
					A2($author$project$NetworkLogs$View$fromBoolToString, translations, value.to));
			case 'PermanentlyClosedChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A2($author$project$NetworkLogs$View$fromBoolToString, translations, value.from),
					A2($author$project$NetworkLogs$View$fromBoolToString, translations, value.to));
			case 'ShortDescriptionChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					$author$project$Data$Location$shortDescriptionToString(value.from),
					$author$project$Data$Location$shortDescriptionToString(value.to));
			case 'OpenHoursChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A2($author$project$NetworkLogs$CardView$renderOpenHours, value.from, translations),
					A2($author$project$NetworkLogs$CardView$renderOpenHours, value.to, translations));
			case 'SpecialOpenHoursChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A2($author$project$NetworkLogs$CardView$renderSpecialOpenHoursTable, value.from, translations),
					A2($author$project$NetworkLogs$CardView$renderSpecialOpenHoursTable, value.to, translations));
			case 'CategoryChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (category) {
							return category.name;
						},
						value.from),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (category) {
							return category.name;
						},
						value.to));
			case 'AdditionalCategoryChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A2($author$project$NetworkLogs$CardView$renderAdditionalCategories, value.from, translations),
					A2($author$project$NetworkLogs$CardView$renderAdditionalCategories, value.to, translations));
			case 'BingPrimaryCategoryIdChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (x) {
							return $author$project$Translations$General$WorkerLog$bingPrimaryCategory(translations) + (': ' + x);
						},
						value.from),
					$author$project$Translations$General$WorkerLog$bingPrimaryCategory(translations) + (': ' + value.to));
			case 'ApplePrimaryCategoryIdChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (category) {
							return category.name;
						},
						value.from),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (category) {
							return category.name;
						},
						value.to));
			case 'AddressChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A2($author$project$NetworkLogs$CardView$renderAddress, translations, value.from),
					A2($author$project$NetworkLogs$CardView$renderAddress, translations, value.to));
			case 'LocationCoordinateChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A2(
						$elm$html$Html$span,
						_List_Nil,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]),
							function (latLong) {
								return A2($author$project$Listings$Ui$Row$renderLatitudeAndLongitude, latLong, translations);
							},
							value.from)),
					A2(
						$elm$html$Html$span,
						_List_Nil,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]),
							function (latLong) {
								return A2($author$project$Listings$Ui$Row$renderLatitudeAndLongitude, latLong, translations);
							},
							value.to)));
			case 'MediaChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$html$Html$text(''),
						function (media) {
							return $author$project$NetworkLogs$CardView$renderMedia(media.previewUrl);
						},
						value.from),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$html$Html$text(''),
						function (media) {
							return $author$project$NetworkLogs$CardView$renderMedia(media.previewUrl);
						},
						value.to));
			case 'GoogleNetworkAttributeChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					A2(
						$elm$html$Html$span,
						_List_Nil,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (attr) {
								return A2(
									$author$project$Listings$Ui$Row$renderGoogleAttributesRows,
									$author$project$NetworkLogs$View$getAttributes(attr),
									translations);
							},
							value.from)),
					A2(
						$elm$html$Html$span,
						_List_Nil,
						A2(
							$author$project$Listings$Ui$Row$renderGoogleAttributesRows,
							$author$project$NetworkLogs$View$getAttributes(value.to),
							translations)));
			case 'GoogleServiceChange':
				var value = workItem.a;
				return _Utils_Tuple2(
					$author$project$NetworkLogs$CardView$renderGoogleServicesTable(value.from),
					$author$project$NetworkLogs$CardView$renderGoogleServicesTable(value.to));
			case 'ServiceAreaChange':
				var value = workItem.a;
				return A2(
					getTextDuple,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (sa) {
							return A2(
								$elm$core$String$join,
								', ',
								A2($author$project$NetworkLogs$View$serviceAreaToString, translations, sa));
						},
						value.from),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (sa) {
							return A2(
								$elm$core$String$join,
								', ',
								A2($author$project$NetworkLogs$View$serviceAreaToString, translations, sa));
						},
						value.to));
			default:
				var value = workItem.a;
				return _Utils_Tuple2(
					$author$project$NetworkLogs$CardView$renderActionLinksTable(value.from),
					$author$project$NetworkLogs$CardView$renderActionLinksTable(value.to));
		}
	});
var $author$project$NetworkLogs$View$renderMoreSingleLocationView = F5(
	function (translations, analytics, locationColumn, storeId, workItems) {
		var linkToLocation = A2($author$project$NetworkLogs$View$getLocationLink, workItems, storeId);
		var identifierName = function () {
			switch (locationColumn.$) {
				case 'LocationDescriptorField':
					return $author$project$Translations$General$WorkerLog$locationDescriptor(translations);
				case 'LocationStoreId':
					return $author$project$Translations$General$WorkerLog$storeId(translations);
				default:
					return $author$project$Translations$General$WorkerLog$storefrontName(translations);
			}
		}();
		var locationUrl = $author$project$NetworkLogs$View$getLocationUrl(workItems);
		var allNetworks = A2(
			$elm$core$List$map,
			function (n) {
				return {
					status: $author$project$Data$Network$Off,
					content: $elm$core$Maybe$Nothing,
					network: $elm$core$Maybe$Just(n),
					errorMessage: $elm$core$Maybe$Nothing
				};
			},
			$author$project$NetworkLogs$View$enabledNetworksList(analytics));
		var networksList = A2(
			$elm$core$List$filter,
			function (networkItem) {
				return !_Utils_eq(networkItem.status, $author$project$Data$Network$Off);
			},
			A2(
				$elm$core$List$map,
				function (y) {
					var filtered = A2(
						$elm$core$List$filter,
						function (x) {
							return _Utils_eq(y.network, x.data.network);
						},
						workItems);
					return $elm$core$List$isEmpty(filtered) ? y : A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						{status: $author$project$Data$Network$Off, content: $elm$core$Maybe$Nothing, network: $elm$core$Maybe$Nothing, errorMessage: $elm$core$Maybe$Nothing},
						function (f) {
							var errorMessage = A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Maybe$Nothing,
								function (e) {
									return $elm$core$Maybe$Just(e.message);
								},
								f.error);
							var _v0 = function () {
								if ($elm$core$List$length(f.data.changes) === 1) {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										_Utils_Tuple2(
											$elm$html$Html$text(''),
											$elm$html$Html$text('')),
										function (change) {
											return A2($author$project$NetworkLogs$View$renderChangeValues, translations, change);
										},
										$elm$core$List$head(f.data.changes));
								} else {
									var _v1 = $elm$core$List$unzip(
										A2(
											$elm$core$List$map,
											function (change) {
												return A2($author$project$NetworkLogs$View$renderChangeValues, translations, change);
											},
											f.data.changes));
									var fromList = _v1.a;
									var toList = _v1.b;
									return _Utils_Tuple2(
										A2($elm$html$Html$div, _List_Nil, fromList),
										A2($elm$html$Html$div, _List_Nil, toList));
								}
							}();
							var contentFrom = _v0.a;
							var contentTo = _v0.b;
							var status = $author$project$NetworkLogs$View$getNetworkState(f.state);
							return {
								status: status,
								content: $elm$core$Maybe$Just(
									{to: contentTo, from: contentFrom}),
								network: f.data.network,
								errorMessage: errorMessage
							};
						},
						$elm$core$List$head(filtered));
				},
				allNetworks));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('outer-card-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(identifierName + ': '),
							linkToLocation,
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('details-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$WorkerLog$logDetails(translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inner-card-container')
						]),
					A2(
						$elm$core$List$map,
						function (card) {
							var networkError = A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								'',
								function (message) {
									return message;
								},
								card.errorMessage);
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								A7(
									$author$project$NetworkLogs$CardView$renderCard,
									translations,
									card.network,
									card.status,
									'',
									locationUrl,
									A2($elm$html$Html$div, _List_Nil, _List_Nil),
									A2($elm$html$Html$div, _List_Nil, _List_Nil)),
								function (contentToDisplay) {
									var element = A7($author$project$NetworkLogs$CardView$renderCard, translations, card.network, card.status, networkError, locationUrl, contentToDisplay.from, contentToDisplay.to);
									return element;
								},
								card.content);
						},
						networksList))
				]));
	});
var $author$project$NetworkLogs$View$renderMoreTableView = F3(
	function (workItems, analytics, model) {
		var getLocationData = function (location) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				{name: '', storeId: '', locationDescriptor: ''},
				$elm$core$Basics$identity,
				location);
		};
		var groupedItems = A3($author$project$NetworkLogs$View$groupWorkItemsByLocationId, model, analytics, workItems);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-log-list-table-more')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.showMoreUiTable,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowMore,
						function (x) {
							return _Utils_eq(
								model.showMoreDetails,
								$elm$core$Maybe$Just(
									$author$project$NetworkLogs$View$getStoreId(x.location))) ? $elm$core$Maybe$Just(
								A5(
									$author$project$NetworkLogs$View$renderMoreSingleLocationView,
									model.translations,
									analytics,
									model.locationColumn,
									A3(
										$author$project$NetworkLogs$View$getLocationName,
										getLocationData(x.location),
										model.locationColumn,
										model.translations),
									x.changes)) : $elm$core$Maybe$Nothing;
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withRowAction,
							function (x) {
								return $author$project$NetworkLogs$Model$ToggleMoreDetail(
									$author$project$NetworkLogs$View$getStoreId(x.location));
							},
							$author$project$PinMeTo$Ui$Table$withoutSorting(
								$author$project$PinMeTo$Ui$Table$withoutHeaders(
									A2(
										$author$project$PinMeTo$Ui$Table$withSort,
										$author$project$PinMeTo$Ui$Table$Desc(0),
										A2(
											$author$project$PinMeTo$Ui$Table$withColumn,
											A3(
												$author$project$PinMeTo$Ui$Table$createColumn,
												A2(
													$elm$core$Basics$composeR,
													function (_v6) {
														return ' ';
													},
													$elm$html$Html$text),
												function (_v7) {
													return function (_v8) {
														return $elm$core$Basics$LT;
													};
												},
												'-'),
											A2(
												$author$project$PinMeTo$Ui$Table$withColumn,
												A3(
													$author$project$PinMeTo$Ui$Table$createColumn,
													function (x) {
														return A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('network-log-list-table-more__networks-cell')
																]),
															A2(
																$elm$core$List$map,
																function (y) {
																	return A2($author$project$NetworkLogs$View$getNetworkItemDetailIcon, y.network, y.status);
																},
																A2(
																	$elm$core$List$filter,
																	function (y) {
																		return A3(
																			$elm_community$maybe_extra$Maybe$Extra$unwrap,
																			false,
																			function (n) {
																				return A2($elm$core$List$member, n, $author$project$NetworkLogs$Model$supportedNetworks);
																			},
																			y.network);
																	},
																	x.networks)));
													},
													function (_v4) {
														return function (_v5) {
															return $elm$core$Basics$LT;
														};
													},
													$author$project$Translations$General$WorkerLog$network(model.translations)),
												A2(
													$author$project$PinMeTo$Ui$Table$withColumn,
													A3(
														$author$project$PinMeTo$Ui$Table$createColumn,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.field;
															},
															$elm$html$Html$text),
														function (_v2) {
															return function (_v3) {
																return $elm$core$Basics$LT;
															};
														},
														'Field'),
													A2(
														$author$project$PinMeTo$Ui$Table$withColumn,
														A3(
															$author$project$PinMeTo$Ui$Table$createColumn,
															A2(
																$elm$core$Basics$composeR,
																function (x) {
																	return A3(
																		$author$project$NetworkLogs$View$getLocationName,
																		getLocationData(x.location),
																		model.locationColumn,
																		model.translations);
																},
																$elm$html$Html$text),
															function (_v0) {
																return function (_v1) {
																	return $elm$core$Basics$LT;
																};
															},
															$author$project$Translations$General$WorkerLog$locationTitle(model.translations)),
														A2($author$project$PinMeTo$Ui$Table$view, $author$project$NetworkLogs$Model$MoreUiTableMsg, groupedItems)))))))))))
				]));
	});
var $author$project$NetworkLogs$Model$SelectLocationColumn = function (a) {
	return {$: 'SelectLocationColumn', a: a};
};
var $author$project$NetworkLogs$View$getLocationColumnText = F5(
	function (session, maybeDataLocation, locationsCount, locationColumn, translations) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A3($author$project$PinMeToPage$translatePluralValue, session, 'general.number_of_locations', locationsCount),
			function (location) {
				return A3($author$project$NetworkLogs$View$getLocationName, location, locationColumn, translations);
			},
			maybeDataLocation);
	});
var $author$project$NetworkLogs$View$getLocationFieldStatus = F6(
	function (session, brandPagesList, locationList, workItems, locationColum, translations) {
		var locationsCount = $elm$core$List$length(locationList);
		var locationsCountString = A3($author$project$PinMeToPage$translatePluralValue, session, 'general.number_of_locations', locationsCount);
		var pagesCount = $elm$core$List$length(brandPagesList);
		if ($elm$core$List$isEmpty(brandPagesList)) {
			return (locationsCount > 1) ? locationsCountString : A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				function (work) {
					var locationName = A5($author$project$NetworkLogs$View$getLocationColumnText, session, work.data.location, locationsCount, locationColum, translations);
					return $elm$core$String$isEmpty(locationName) ? A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$Basics$identity, work.data.locationDescriptor) : locationName;
				},
				$elm$core$List$head(workItems));
		} else {
			var additionalText = (locationsCount > 1) ? (' & ' + locationsCountString) : '';
			return _Utils_ap(
				A3($author$project$PinMeToPage$translatePluralValue, session, 'general.number_of_brand_pages', pagesCount),
				additionalText);
		}
	});
var $author$project$Translations$General$WorkerLog$showCreateLocationLogs = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.worker_log.show_create_location_logs');
};
var $author$project$NetworkLogs$Model$OnChangeShowCreateLocation = function (a) {
	return {$: 'OnChangeShowCreateLocation', a: a};
};
var $author$project$NetworkLogs$View$getLocationIdentifierValue = F3(
	function (workItems, idLocation, translations) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'',
			function (work) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function (location) {
						switch (idLocation.$) {
							case 'LocationDescriptorField':
								return $elm$core$String$isEmpty(location.locationDescriptor) ? ($author$project$Translations$General$WorkerLog$storeId(translations) + (': ' + location.storeId)) : location.locationDescriptor;
							case 'LocationStoreId':
								return location.storeId;
							default:
								return location.name;
						}
					},
					work.data.location);
			},
			$elm$core$List$head(workItems));
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$NetworkLogs$View$getNetworksIconFromWorkItemList = F2(
	function (workItems, analytics) {
		var renderNetworkIcon = function (item) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('network-log-list-table__network-icon')
					]),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2($author$project$Data$Network$renderNetworkSvgIconWithStatus, item.network, item.status)
						])));
		};
		var uniqueWorkItems = A2(
			$elm$core$List$filterMap,
			function (f) {
				return f.data.network;
			},
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				function (f) {
					var _v0 = f.data.network;
					if (_v0.$ === 'Just') {
						var network = _v0.a;
						return $author$project$Data$Network$toString(network);
					} else {
						return '';
					}
				},
				A2(
					$elm$core$List$sortBy,
					function (f) {
						return _Utils_eq(f.error, $elm$core$Maybe$Nothing) ? 1 : 0;
					},
					workItems)));
		var getNetworkStateFromWorkItems = function (network) {
			if (A2($elm$core$List$member, network, uniqueWorkItems)) {
				var networksInWorkItems = A2(
					$elm$core$List$filter,
					function (field) {
						return _Utils_eq(
							field.data.network,
							$elm$core$Maybe$Just(network));
					},
					workItems);
				var statesList = A2(
					$elm$core$List$map,
					function (item) {
						return item.state;
					},
					networksInWorkItems);
				var stateToShow = A2($elm$core$List$member, 'error', statesList) ? 'error' : (A2($elm$core$List$member, 'inProgress', statesList) ? 'inProgress' : 'done');
				return $author$project$NetworkLogs$View$getNetworkState(stateToShow);
			} else {
				return $author$project$Data$Network$Off;
			}
		};
		var networksList = A2(
			$elm$core$List$map,
			function (x) {
				return {
					status: getNetworkStateFromWorkItems(x),
					network: x
				};
			},
			$author$project$NetworkLogs$View$enabledNetworksList(analytics));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('network-log-list-table__network-list')
				]),
			A2(
				$elm$core$List$map,
				renderNetworkIcon,
				A2(
					$elm$core$List$filter,
					function (n) {
						return A2($elm$core$List$member, n.network, $author$project$NetworkLogs$Model$supportedNetworks);
					},
					networksList)));
	});
var $author$project$NetworkLogs$View$withTableView = F2(
	function (session, model) {
		var getFirstWorkItemAndCheckIfIsPost = function (workItems) {
			var _v5 = $elm$core$List$head(workItems);
			if (_v5.$ === 'Just') {
				var firstWorkItem = _v5.a;
				return (firstWorkItem.itemType === 'locationPost') ? true : false;
			} else {
				return false;
			}
		};
		var _v0 = model.workDataStatus;
		switch (_v0.$) {
			case 'Loaded':
				var result = _v0.a;
				var locationColumnSelector = function () {
					var locationIdOptions = _List_fromArray(
						[$author$project$NetworkLogs$Model$LocationDescriptorField, $author$project$NetworkLogs$Model$LocationStoreId, $author$project$NetworkLogs$Model$LocationName]);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('networks-log-select-location-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$General$WorkerLog$locationColumnText(model.translations) + ': '),
								A2(
								$author$project$PinMeTo$Ui$Select$render,
								model.uiSelect,
								$author$project$PinMeTo$Ui$Select$view(
									{
										uid: 'ui-select-location-text',
										items: locationIdOptions,
										label: $elm$html$Html$text(
											A2($author$project$NetworkLogs$View$idLocationToString, model.translations, model.locationColumn)),
										tagger: $author$project$NetworkLogs$Model$UiSelectMsg,
										onChange: $author$project$NetworkLogs$Model$SelectLocationColumn,
										itemRender: A2(
											$elm$core$Basics$composeR,
											$author$project$NetworkLogs$View$idLocationToString(model.translations),
											$elm$html$Html$text)
									}))
							]));
				}();
				var createLocationCheckbox = function () {
					var hasRequiredRole = $author$project$Data$User$containsCustomerSuccessOrDeveloper(session.user.systemRoles);
					var showCheckbox = hasRequiredRole && (!session.user.isDemo);
					return showCheckbox ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Form$Checkbox$render(
								$author$project$PinMeTo$Ui$Form$Checkbox$checkbox(
									{
										label: $author$project$Translations$General$WorkerLog$showCreateLocationLogs(model.translations),
										checked: model.showCreateLocation,
										onChange: $author$project$NetworkLogs$Model$OnChangeShowCreateLocation
									})),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
				}();
				var renderPublishingDate = F2(
					function (locale, publishDate) {
						return $author$project$PinMeTo$Ui$Date$render(
							A2($author$project$PinMeTo$Ui$Date$posix, locale, publishDate));
					});
				var tableData = $elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (item) {
							return item.data;
						},
						result));
				var rowsToShow = A2(
					$elm$core$List$filter,
					function (row) {
						var fieldName = $author$project$NetworkLogs$View$getFirstWorkItemPropertiesAsString(row.workItems);
						return (fieldName !== 'create location') || model.showCreateLocation;
					},
					A2(
						$elm$core$List$filter,
						function (row) {
							return (!($elm$core$List$isEmpty(row.locations) && $elm$core$List$isEmpty(row.brandpages))) && ((!$elm$core$List$isEmpty(row.brandpages)) || A2(
								$elm$core$List$any,
								function (loc) {
									return !_Utils_eq(loc, $elm$core$Maybe$Nothing);
								},
								row.locations));
						},
						tableData));
				var emptyBanner = $elm$core$List$isEmpty(tableData) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('networks-log-empty-state-banner')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$WorkerLog$noEntriesTitle(model.translations))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-ui-font-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$General$WorkerLog$noEntriesText(model.translations))
								]))
						])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
				var logsTable = A2(
					$author$project$PinMeTo$Ui$Table$render,
					model.uiTable,
					A2(
						$author$project$PinMeTo$Ui$Table$withRowMore,
						function (x) {
							var identifierValue = A3($author$project$NetworkLogs$View$getLocationIdentifierValue, x.workItems, model.locationColumn, model.translations);
							var workItem = $elm$core$List$head(x.workItems);
							var postLink = A2($author$project$NetworkLogs$View$getPostLink, workItem, session.siteName);
							return _Utils_eq(
								model.showMore,
								$elm$core$Maybe$Just(x.id)) ? ((!getFirstWorkItemAndCheckIfIsPost(x.workItems)) ? (($elm$core$List$length(x.locations) > 1) ? $elm$core$Maybe$Just(
								A3($author$project$NetworkLogs$View$renderMoreTableView, x.workItems, session.analytics, model)) : $elm$core$Maybe$Just(
								A5($author$project$NetworkLogs$View$renderMoreSingleLocationView, model.translations, session.analytics, model.locationColumn, identifierValue, x.workItems))) : $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(postLink),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$General$WorkerLog$clickHereSeeLog(model.translations))
										])))) : $elm$core$Maybe$Nothing;
						},
						A2(
							$author$project$PinMeTo$Ui$Table$withRowAction,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.id;
								},
								$author$project$NetworkLogs$Model$ToggleMore),
							A2(
								$author$project$PinMeTo$Ui$Table$withSort,
								$author$project$PinMeTo$Ui$Table$Desc(0),
								A2(
									$author$project$PinMeTo$Ui$Table$withRowMoreIndent,
									1,
									$author$project$PinMeTo$Ui$Table$withoutSorting(
										$author$project$PinMeTo$Ui$Table$withStickyHeader(
											A4(
												$author$project$PinMeTo$Ui$Table$addCompactColumn,
												$author$project$Translations$General$WorkerLog$user(model.translations),
												A2(
													$elm$core$Basics$composeR,
													function (x) {
														return (x.createdByUser.name === 'places ai') ? 'Listings Manager' : x.createdByUser.name;
													},
													$elm$html$Html$text),
												$author$project$PinMeTo$Ui$Table$comparing(
													function (x) {
														return x.createdByUser.name;
													}),
												A4(
													$author$project$PinMeTo$Ui$Table$addColumn,
													$author$project$Translations$General$WorkerLog$network(model.translations),
													function (x) {
														return A2($author$project$NetworkLogs$View$getNetworksIconFromWorkItemList, x.workItems, session.analytics);
													},
													function (_v3) {
														return function (_v4) {
															return $elm$core$Basics$LT;
														};
													},
													A4(
														$author$project$PinMeTo$Ui$Table$addColumn,
														$author$project$Translations$General$WorkerLog$fieldTitle(model.translations),
														A2(
															$elm$core$Basics$composeR,
															function (x) {
																return A3(
																	$author$project$NetworkLogs$View$getFieldNameConversion,
																	model,
																	$author$project$NetworkLogs$View$getFirstWorkItemPropertiesAsString(x.workItems),
																	x.workItems);
															},
															$elm$html$Html$text),
														$author$project$PinMeTo$Ui$Table$comparing(
															function ($) {
																return $.totalWorkCount;
															}),
														A4(
															$author$project$PinMeTo$Ui$Table$addColumn,
															$author$project$Translations$General$WorkerLog$locationTitle(model.translations),
															A2(
																$elm$core$Basics$composeR,
																function (x) {
																	return A6($author$project$NetworkLogs$View$getLocationFieldStatus, session, x.brandpages, x.locations, x.workItems, model.locationColumn, model.translations);
																},
																$elm$html$Html$text),
															function (_v1) {
																return function (_v2) {
																	return $elm$core$Basics$LT;
																};
															},
															A4(
																$author$project$PinMeTo$Ui$Table$addCompactColumn,
																$author$project$Translations$General$WorkerLog$date(model.translations),
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.createdAt;
																	},
																	renderPublishingDate(model.locale)),
																$author$project$PinMeTo$Ui$Table$comparing(
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.createdAt;
																		},
																		$elm$time$Time$posixToMillis)),
																A2($author$project$PinMeTo$Ui$Table$view, $author$project$NetworkLogs$Model$UiTableMsg, rowsToShow)))))))))))));
				return A2(
					$author$project$NetworkLogs$View$wrapper,
					_List_fromArray(
						[
							emptyBanner,
							createLocationCheckbox,
							locationColumnSelector,
							logsTable,
							A2($author$project$NetworkLogs$View$withShowMore, model.paginationStatus, model.translations)
						]),
					model.translations);
			case 'Loading':
				return A2(
					$author$project$NetworkLogs$View$wrapper,
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]),
					model.translations);
			case 'Suspended':
				return A2(
					$author$project$NetworkLogs$View$wrapper,
					_List_fromArray(
						[$author$project$PinMeTo$Ui$Spinner$spinnerWithDelay]),
					model.translations);
			default:
				var message = _v0.a;
				return A2(
					$author$project$NetworkLogs$View$wrapper,
					_List_fromArray(
						[
							A2($author$project$NetworkLogs$View$errorBanner, message, model.translations)
						]),
					model.translations);
		}
	});
var $author$project$Filter$FilterController$viewNetworkLog = F4(
	function (model, locale, translations, language) {
		var labels = A2($author$project$Filter$FilterLabels$locationsFilterControllerLabels, translations, language);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$PinMeTo$Global$FilterController$render,
					A3($author$project$Filter$FilterLabels$filterControllerWithSelectorsLabels, translations, language, labels),
					$author$project$Filter$FilterController$UiFilteredListMsg,
					model.uiFilteredList,
					A2(
						$author$project$PinMeTo$Ui$FilterController$withSearchOptionsOnly,
						$author$project$Translations$General$filter(translations),
						$author$project$PinMeTo$Ui$FilterController$view(
							{uid: 'filter-controller-network-log', labels: labels, locale: locale})))
				]));
	});
var $author$project$NetworkLogs$View$view = F2(
	function (session, model) {
		var filterControllerHandler = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$html$Html$text(''),
			function (controller) {
				return A2(
					$elm$html$Html$map,
					$author$project$NetworkLogs$Model$FilterControllerMsg,
					A4($author$project$Filter$FilterController$viewNetworkLog, controller, model.locale, model.translations, model.language));
			},
			model.filterController);
		var isLoading = function () {
			var _v0 = model.workDataStatus;
			if (_v0.$ === 'Loading') {
				return true;
			} else {
				return false;
			}
		}();
		var loadingOverlay = isLoading ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('networks-log-filter-overlay')
				]),
			_List_Nil) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('networks-log-filterContainer'),
							$elm$html$Html$Attributes$class(
							isLoading ? 'networks-log-filterContainer__loading' : '')
						]),
					_List_fromArray(
						[filterControllerHandler, loadingOverlay])),
					A2($author$project$NetworkLogs$View$withTableView, session, model)
				]));
	});
var $author$project$NetworkLogs$Model$OnFilter = function (a) {
	return {$: 'OnFilter', a: a};
};
var $author$project$NetworkLogs$Model$OnSearch = function (a) {
	return {$: 'OnSearch', a: a};
};
var $author$project$NetworkLogs$Model$GetNetworkLogs = function (a) {
	return {$: 'GetNetworkLogs', a: a};
};
var $author$project$NetworkLogs$Commands$mergeJsonBodies = F2(
	function (maybeFilterDefinition, pageNumber) {
		if (maybeFilterDefinition.$ === 'Just') {
			var filterJson = maybeFilterDefinition.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('filter', filterJson),
						_Utils_Tuple2(
						'pageNumber',
						$elm$json$Json$Encode$int(pageNumber))
					]));
		} else {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pageNumber',
						$elm$json$Json$Encode$int(pageNumber))
					]));
		}
	});
var $author$project$NetworkLogs$Model$WorkItem = F4(
	function (state, itemType, data, error) {
		return {data: data, error: error, state: state, itemType: itemType};
	});
var $author$project$NetworkLogs$Model$NameChange = function (a) {
	return {$: 'NameChange', a: a};
};
var $author$project$NetworkLogs$Model$Pagination = F3(
	function (total, size, current) {
		return {size: size, total: total, current: current};
	});
var $author$project$NetworkLogs$Model$MediaChange = function (a) {
	return {$: 'MediaChange', a: a};
};
var $author$project$NetworkLogs$Model$WorkItemData = function (changes) {
	return function (location) {
		return function (locationId) {
			return function (network) {
				return function (properties) {
					return function (siteName) {
						return function (name) {
							return function (locationDescriptor) {
								return function (locationPostId) {
									return function (locationPostTitle) {
										return function (brandpageId) {
											return {name: name, changes: changes, network: network, location: location, siteName: siteName, locationId: locationId, properties: properties, brandpageId: brandpageId, locationPostId: locationPostId, locationPostTitle: locationPostTitle, locationDescriptor: locationDescriptor};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$NetworkLogs$Model$AddressChange = function (a) {
	return {$: 'AddressChange', a: a};
};
var $author$project$NetworkLogs$Model$CreatedByUser = F3(
	function (email, name, userId) {
		return {name: name, email: email, userId: userId};
	});
var $author$project$NetworkLogs$Model$StoreIdChange = function (a) {
	return {$: 'StoreIdChange', a: a};
};
var $author$project$NetworkLogs$Model$UnknownChange = function (a) {
	return {$: 'UnknownChange', a: a};
};
var $author$project$NetworkLogs$Model$CategoryChange = function (a) {
	return {$: 'CategoryChange', a: a};
};
var $author$project$NetworkLogs$Model$NetworkLogItem = function (brandpages) {
	return function (businessAccounts) {
		return function (createdAt) {
			return function (updatedAt) {
				return function (createdByUser) {
					return function (locations) {
						return function (restrictedRoles) {
							return function (siteName) {
								return function (totalWorkCount) {
									return function (workFailedCount) {
										return function (workInProgressCount) {
											return function (workSuccessCount) {
												return function (workItems) {
													return function (id) {
														return {id: id, siteName: siteName, createdAt: createdAt, locations: locations, updatedAt: updatedAt, workItems: workItems, brandpages: brandpages, createdByUser: createdByUser, totalWorkCount: totalWorkCount, restrictedRoles: restrictedRoles, workFailedCount: workFailedCount, businessAccounts: businessAccounts, workSuccessCount: workSuccessCount, workInProgressCount: workInProgressCount};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$NetworkLogs$Model$OpenHoursChange = function (a) {
	return {$: 'OpenHoursChange', a: a};
};
var $author$project$NetworkLogs$Model$ActionLinkChange = function (a) {
	return {$: 'ActionLinkChange', a: a};
};
var $author$project$NetworkLogs$Model$WorkItemErrorLog = function (message) {
	return {message: message};
};
var $author$project$NetworkLogs$Model$OpeningDateChange = function (a) {
	return {$: 'OpeningDateChange', a: a};
};
var $author$project$NetworkLogs$Model$ServiceAreaChange = function (a) {
	return {$: 'ServiceAreaChange', a: a};
};
var $author$project$NetworkLogs$Model$ContactEmailChange = function (a) {
	return {$: 'ContactEmailChange', a: a};
};
var $author$project$NetworkLogs$Model$ContactPhoneChange = function (a) {
	return {$: 'ContactPhoneChange', a: a};
};
var $author$project$NetworkLogs$Model$FbCustomNameChange = function (a) {
	return {$: 'FbCustomNameChange', a: a};
};
var $author$project$NetworkLogs$Model$GoogleChainIdChange = function (a) {
	return {$: 'GoogleChainIdChange', a: a};
};
var $author$project$NetworkLogs$Model$GoogleServiceChange = function (a) {
	return {$: 'GoogleServiceChange', a: a};
};
var $author$project$NetworkLogs$Model$NetworkLogsApiResult = F2(
	function (data, pagination) {
		return {data: data, pagination: pagination};
	});
var $author$project$NetworkLogs$Model$WorkItemDataLocation = F3(
	function (locationDescriptor, name, storeId) {
		return {name: name, storeId: storeId, locationDescriptor: locationDescriptor};
	});
var $author$project$NetworkLogs$Model$ContactHomepageChange = function (a) {
	return {$: 'ContactHomepageChange', a: a};
};
var $author$project$NetworkLogs$Model$LongDescriptionChange = function (a) {
	return {$: 'LongDescriptionChange', a: a};
};
var $author$project$Data$Location$ActionLinks$googleToActionLink = F3(
	function (maybeType, maybeUri, primary) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (type_, uri) {
					return A3($author$project$Data$Location$ActionLinks$ActionLink, type_, uri, primary);
				}),
			maybeType,
			maybeUri);
	});
var $author$project$Data$Location$ActionLinks$fromGoogleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'isPreferred',
	$elm$json$Json$Decode$bool,
	false,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'uri', $elm$json$Json$Decode$string)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'placeActionType',
			A2($elm$json$Json$Decode$map, $author$project$Data$Location$ActionLinks$googleStringToActionLinkType, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Data$Location$ActionLinks$googleToActionLink))));
var $author$project$Data$Location$ActionLinks$fromGoogleListDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list($author$project$Data$Location$ActionLinks$fromGoogleDecoder));
var $author$project$NetworkLogs$Model$ShortDescriptionChange = function (a) {
	return {$: 'ShortDescriptionChange', a: a};
};
var $author$project$NetworkLogs$Model$SpecialOpenHoursChange = function (a) {
	return {$: 'SpecialOpenHoursChange', a: a};
};
var $author$project$Data$Media$NetworkLogMedia = F2(
	function (url, previewUrl) {
		return {url: url, previewUrl: previewUrl};
	});
var $author$project$Data$Media$networkLogMediaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'previewUrl',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'url',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$Data$Media$NetworkLogMedia)));
var $author$project$NetworkLogs$Model$PermanentlyClosedChange = function (a) {
	return {$: 'PermanentlyClosedChange', a: a};
};
var $author$project$NetworkLogs$Model$AdditionalCategoryChange = function (a) {
	return {$: 'AdditionalCategoryChange', a: a};
};
var $author$project$NetworkLogs$Model$LocationCoordinateChange = function (a) {
	return {$: 'LocationCoordinateChange', a: a};
};
var $author$project$NetworkLogs$Model$LocationDescriptorChange = function (a) {
	return {$: 'LocationDescriptorChange', a: a};
};
var $author$project$NetworkLogs$Model$BingPrimaryCategoryIdChange = function (a) {
	return {$: 'BingPrimaryCategoryIdChange', a: a};
};
var $author$project$NetworkLogs$Model$NetworkLogsSpecialOpenHours = F4(
	function (startDate, endDate, label, state) {
		return {label: label, state: state, endDate: endDate, startDate: startDate};
	});
var $author$project$NetworkLogs$Model$ApplePrimaryCategoryIdChange = function (a) {
	return {$: 'ApplePrimaryCategoryIdChange', a: a};
};
var $author$project$NetworkLogs$Model$GoogleNetworkAttributeChange = function (a) {
	return {$: 'GoogleNetworkAttributeChange', a: a};
};
var $author$project$NetworkLogs$Model$TemporarilyClosedUntilChange = function (a) {
	return {$: 'TemporarilyClosedUntilChange', a: a};
};
var $author$project$NetworkLogs$Decoders$networkLogsDecoder = function () {
	var networkLogsSpecialOpenHoursDecoder = A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Location$SpecialOpenHours$stateDecoder,
				A2($elm$json$Json$Decode$field, 'isClosed', $elm$json$Json$Decode$bool))),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'label',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'end',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'start',
					$elm$json$Json$Decode$string,
					'',
					$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$NetworkLogsSpecialOpenHours)))));
	var workItemDataLocationDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'storeId',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'locationDescriptor',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$WorkItemDataLocation))));
	var workItemErrorLogDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$WorkItemErrorLog));
	var unknownChangeDecoder = A5(
		$elm$json$Json$Decode$map4,
		F4(
			function (key, network, to, from) {
				return $author$project$NetworkLogs$Model$UnknownChange(
					{to: to, key: key, from: from, network: network});
			}),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(''),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'network', $author$project$Data$Network$networkDecoder))),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'to', $elm$json$Json$Decode$string)),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'from', $elm$json$Json$Decode$string)));
	var createdByUserDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'userId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$CreatedByUser))));
	var knownChangeDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (toKey) {
			var baseDecoder = function (workItemChangesType) {
				return $elm$json$Json$Decode$succeed(
					F4(
						function (key, network, to, from) {
							return workItemChangesType(
								{to: to, key: key, from: from, network: network});
						}));
			};
			switch (toKey) {
				case 'permanentlyClosed':
					return $elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'from',
								$elm$json$Json$Decode$bool,
								false,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'to',
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'network',
										$author$project$Data$Network$networkDecoder,
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'key',
											$elm$json$Json$Decode$string,
											baseDecoder($author$project$NetworkLogs$Model$PermanentlyClosedChange))))),
								A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'from',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'to',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'network',
										$author$project$Data$Network$networkDecoder,
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'key',
											$elm$json$Json$Decode$string,
											baseDecoder($author$project$NetworkLogs$Model$TemporarilyClosedUntilChange)))))
							]));
				case 'fb.custom.name':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$FbCustomNameChange)))));
				case 'locationDescriptor':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$LocationDescriptor),
						$author$project$Data$Location$LocationDescriptor(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$LocationDescriptor),
							$author$project$Data$Location$LocationDescriptor(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$LocationDescriptorChange)))));
				case 'storeId':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$StoreId),
						$author$project$Data$Location$StoreId(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$StoreId),
							$author$project$Data$Location$StoreId(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$StoreIdChange)))));
				case 'openingDate':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$OpeningDateChange)))));
				case 'name':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$NameChange)))));
				case 'google.chainId':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$GoogleChainIdChange)))));
				case 'temporarilyClosedUntil':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$TemporarilyClosedUntilChange)))));
				case 'contact.phone':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$Phone),
						$author$project$Data$Location$Phone(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$Phone),
							$author$project$Data$Location$Phone(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ContactPhoneChange)))));
				case 'contact.email':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$Email),
						$author$project$Data$Location$Email(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$Email),
							$author$project$Data$Location$Email(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ContactEmailChange)))));
				case 'contact.homepage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$Homepage),
						$author$project$Data$Location$Homepage(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$Homepage),
							$author$project$Data$Location$Homepage(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ContactHomepageChange)))));
				case 'longDescription':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$LongDescription),
						$author$project$Data$Location$LongDescription(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$LongDescription),
							$author$project$Data$Location$LongDescription(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$LongDescriptionChange)))));
				case 'shortDescription':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Util$idDecoder($author$project$Data$Location$ShortDescription),
						$author$project$Data$Location$ShortDescription(''),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Util$idDecoder($author$project$Data$Location$ShortDescription),
							$author$project$Data$Location$ShortDescription(''),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ShortDescriptionChange)))));
				case 'openHours':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Data$Location$OpenHours$decoder,
						$author$project$Data$Location$OpenHours$notSpecified,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Data$Location$OpenHours$decoder,
							$author$project$Data$Location$OpenHours$notSpecified,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$OpenHoursChange)))));
				case 'specialOpenHours':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list(networkLogsSpecialOpenHoursDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list(networkLogsSpecialOpenHoursDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$SpecialOpenHoursChange)))));
				case 'networkCategories.facebook.subcategories':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AdditionalCategoryChange)))));
				case 'networkCategories.huawei.primary':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$CategoryChange)))));
				case 'networkCategories.huawei.additional':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AdditionalCategoryChange)))));
				case 'networkCategories.google.primary':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$CategoryChange)))));
				case 'networkCategories.google.additional':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AdditionalCategoryChange)))));
				case 'networkCategories.bing.primaryCategoryId':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$BingPrimaryCategoryIdChange)))));
				case 'networkCategories.bing.categories':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AdditionalCategoryChange)))));
				case 'networkCategories.apple.primary':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkCategories$categoryDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ApplePrimaryCategoryIdChange)))));
				case 'networkCategories.apple.additional':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AdditionalCategoryChange)))));
				case 'networkCategories.foursquare.additional':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkCategories$categoryDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AdditionalCategoryChange)))));
				case 'networkServiceItems.google':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$list($author$project$Data$Location$NetworkServiceItems$googleServiceItemsDecoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$list($author$project$Data$Location$NetworkServiceItems$googleServiceItemsDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$GoogleServiceChange)))));
				case 'address':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Data$Address$addressDecoder,
						$author$project$Data$Address$emptyAddress,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Data$Address$addressDecoder,
							$author$project$Data$Address$emptyAddress,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$AddressChange)))));
				case 'location':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Coordinates$coordinatesDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Coordinates$coordinatesDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$LocationCoordinateChange)))));
				case 'networkMedia.google.profileImage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'networkMedia.google.coverImage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'networkMedia.google.media':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'networkMedia.facebook.profileImage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'media.profileImage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'networkMedia.facebook.coverImage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'media.coverImage':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe($author$project$Data$Media$networkLogMediaDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$MediaChange)))));
				case 'serviceAreas':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe(
							$elm$json$Json$Decode$list($author$project$Data$ServiceArea$serviceAreaDecoder)),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$elm$json$Json$Decode$maybe(
								$elm$json$Json$Decode$list($author$project$Data$ServiceArea$serviceAreaDecoder)),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ServiceAreaChange)))));
				case 'networkAttributes.google':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$elm$json$Json$Decode$maybe($author$project$Data$Location$NetworkAttributes$attributeListDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Data$Location$NetworkAttributes$attributeListDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$GoogleNetworkAttributeChange)))));
				case 'actionLinks':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Data$Location$ActionLinks$listDecoder,
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Data$Location$ActionLinks$listDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ActionLinkChange)))));
				case 'networkActionLinks.google':
					return A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'from',
						$author$project$Data$Location$ActionLinks$fromGoogleListDecoder,
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'to',
							$author$project$Data$Location$ActionLinks$fromGoogleListDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'network',
								$author$project$Data$Network$networkDecoder,
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									baseDecoder($author$project$NetworkLogs$Model$ActionLinkChange)))));
				default:
					return unknownChangeDecoder;
			}
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	var workItemDataChangesDecoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[knownChangeDecoder, unknownChangeDecoder]));
	var workItemDataDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'brandpageId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'locationPostTitle',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'locationPostId',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'locationDescriptor',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'name',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'siteName',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'properties',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
								_List_Nil,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'network',
									$author$project$Data$Network$networkDecoder,
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'locationId',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'location',
											$elm$json$Json$Decode$maybe(workItemDataLocationDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'changes',
												$elm$json$Json$Decode$list(workItemDataChangesDecoder),
												_List_Nil,
												$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$WorkItemData))))))))))));
	var paginationDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$Pagination))));
	var workItemDecoder = A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'error',
		$elm$json$Json$Decode$maybe(workItemErrorLogDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'data',
			workItemDataDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'itemType',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$WorkItem)))));
	var networkLogsItemsDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'workItems',
			$elm$json$Json$Decode$list(workItemDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'workSuccessCount',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'workInProgressCount',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'workFailedCount',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'totalWorkCount',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'siteName',
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'restrictedRoles',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'locations',
										$elm$json$Json$Decode$list(
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
										_List_fromArray(
											[$elm$core$Maybe$Nothing]),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'createdByUser',
											createdByUserDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'updatedAt',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'createdAt',
													$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'businessAccounts',
														$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
														_List_Nil,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'brandpages',
															$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
															_List_Nil,
															$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$NetworkLogItem)))))))))))))));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pagination',
		paginationDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'data',
			$elm$json$Json$Decode$list(networkLogsItemsDecoder),
			$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$NetworkLogsApiResult)));
}();
var $author$project$NetworkLogs$Commands$getNetworkLogs = F3(
	function (_v0, pageNumber, model) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					$author$project$NetworkLogs$Model$GetNetworkLogs,
					$author$project$NetworkLogs$Decoders$networkLogsDecoder,
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
				function (builder) {
					var mergedJson = A2($author$project$NetworkLogs$Commands$mergeJsonBodies, model.filterDefinition, pageNumber);
					return A2($lukewestby$elm_http_builder$HttpBuilder$withJsonBody, mergedJson, builder);
				}(
					$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
						$lukewestby$elm_http_builder$HttpBuilder$post('api/' + (siteName + '/work/networkLog'))))));
	});
var $author$project$NetworkLogs$Model$PaginationLoaded = {$: 'PaginationLoaded'};
var $author$project$NetworkLogs$Model$PaginationLoading = {$: 'PaginationLoading'};
var $author$project$NetworkLogs$Update$out_NetworkLogs_Main_onFilter = _Platform_outgoingPort('out_NetworkLogs_Main_onFilter', $elm$core$Basics$identity);
var $author$project$NetworkLogs$Update$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 'GetNetworkLogs':
				if (msg.a.$ === 'Ok') {
					var newWorkData = msg.a.a;
					var updatedModel = function () {
						var isValidPagination = ((!$elm$core$List$length(newWorkData.data)) || (_Utils_cmp(newWorkData.pagination.total, newWorkData.pagination.size) < 0)) ? $author$project$NetworkLogs$Model$PaginationHide : $author$project$NetworkLogs$Model$PaginationLoaded;
						var _v1 = model.workDataStatus;
						switch (_v1.$) {
							case 'Loading':
								return _Utils_update(
									model,
									{
										workDataStatus: $author$project$RemoteData$Loaded(
											_List_fromArray(
												[newWorkData])),
										paginationStatus: isValidPagination
									});
							case 'Loaded':
								var existingData = _v1.a;
								return _Utils_update(
									model,
									{
										workDataStatus: $author$project$RemoteData$Loaded(
											_Utils_ap(
												existingData,
												_List_fromArray(
													[newWorkData]))),
										paginationStatus: isValidPagination
									});
							default:
								return model;
						}
					}();
					return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					var displayMessage = function () {
						var _v2 = err.details;
						if ((_v2.$ === 'BadStatus') && (_v2.c.$ === 'Ok')) {
							var backendMessage = _v2.c.a;
							return backendMessage;
						} else {
							return $author$project$PinMeTo$ExpectJson$getErrorMessage(err);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								workDataStatus: $author$project$RemoteData$Error(displayMessage),
								paginationStatus: $author$project$NetworkLogs$Model$PaginationHide
							}),
						$author$project$PinMeTo$Logger$log(
							{data: displayMessage, context: 'NetworkLogs.Update', message: 'GetNetworkLogs Failure'}));
				}
			case 'ToggleMore':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							showMore: _Utils_eq(
								model.showMore,
								$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleMoreDetail':
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							showMoreDetails: _Utils_eq(
								model.showMoreDetails,
								$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none);
			case 'UiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.uiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'MoreUiTableMsg':
				var msg_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							showMoreUiTable: A2($author$project$PinMeTo$Ui$Table$update, msg_, model.showMoreUiTable)
						}),
					$elm$core$Platform$Cmd$none);
			case 'PaginateNetworkLogs':
				var nextPageNumber = model.pageNumber + 1;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pageNumber: nextPageNumber, paginationStatus: $author$project$NetworkLogs$Model$PaginationLoading}),
					A3($author$project$NetworkLogs$Commands$getNetworkLogs, session.siteName, nextPageNumber, model));
			case 'UiSelectMsg':
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (x) {
						return _Utils_update(
							model,
							{uiSelect: x});
					},
					A3($author$project$PinMeTo$Ui$Select$update, $author$project$NetworkLogs$Model$UiSelectMsg, msg_, model.uiSelect));
			case 'SelectLocationColumn':
				var newColumn = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationColumn: newColumn}),
					$elm$core$Platform$Cmd$none);
			case 'FilterControllerMsg':
				var msg_ = msg.a;
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (model_) {
						var _v3 = A5($author$project$Filter$FilterController$update, $author$project$NetworkLogs$Model$FilterControllerMsg, msg_, model_, $author$project$NetworkLogs$Model$OnFilter, $author$project$NetworkLogs$Model$OnSearch);
						var filterControllerModel_ = _v3.a;
						var filterControllerCmd_ = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									filterController: $elm$core$Maybe$Just(filterControllerModel_)
								}),
							filterControllerCmd_);
					},
					model.filterController);
			case 'OnFilter':
				var filterDefinition = msg.a;
				var newModel = _Utils_update(
					model,
					{
						pageNumber: 1,
						workDataStatus: $author$project$RemoteData$Loading,
						filterDefinition: $elm$core$Maybe$Just(filterDefinition)
					});
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$NetworkLogs$Commands$getNetworkLogs, session.siteName, 1, newModel),
								$author$project$NetworkLogs$Update$out_NetworkLogs_Main_onFilter(filterDefinition)
							])));
			case 'OnSearch':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var newValue = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{showCreateLocation: newValue}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$NetworkLogs$Model$Flags = F3(
	function (initialFilter, language, locale) {
		return {locale: locale, language: language, initialFilter: initialFilter};
	});
var $author$project$NetworkLogs$Decoders$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'locale',
	$author$project$PinMeTo$Ui$I18n$Locale$decoder,
	$author$project$PinMeTo$Ui$I18n$Locale$BrowserLocale,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$PinMeTo$Ui$I18n$Language$decoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'initialFilter',
			$elm$json$Json$Decode$nullable(
				$author$project$PinMeTo$Ui$Filter$DataTypes$filterDefinitionDecoder($elm$core$Dict$empty)),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$NetworkLogs$Model$Flags))));
var $author$project$NetworkLogs$Main$main = $author$project$PinMeToPage$page(
	{
		init: $author$project$NetworkLogs$Main$init,
		view: $author$project$NetworkLogs$View$view,
		update: $author$project$NetworkLogs$Update$update,
		flagsDecoder: $author$project$NetworkLogs$Decoders$flagsDecoder,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$batch(_List_Nil);
		}
	});
var $author$project$LatestLegal$Main$Flags = F2(
	function (type_, id) {
		return {id: id, type_: type_};
	});
var $author$project$LatestLegal$Main$flagsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'id',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$LatestLegal$Main$Flags)));
var $author$project$LatestLegal$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$LatestLegal$Main$flagsDecoder, flags);
};
var $lukewestby$elm_http_builder$HttpBuilder$withTimeout = F2(
	function (timeout, builder) {
		return _Utils_update(
			builder,
			{
				timeout: $elm$core$Maybe$Just(timeout)
			});
	});
var $author$project$LatestLegal$Main$Model = F4(
	function (type_, displayName, text, published) {
		return {text: text, type_: type_, published: published, displayName: displayName};
	});
var $author$project$LatestLegal$Main$modelDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'updatedAt',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'text',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'displayName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$LatestLegal$Main$Model)))));
var $author$project$LatestLegal$Main$DocumentLoaded = function (a) {
	return {$: 'DocumentLoaded', a: a};
};
var $author$project$LatestLegal$Main$getDocument = F2(
	function (docType, id) {
		var url = (id === '') ? ('api/legal/' + (docType + '/latest')) : ('api/legal/' + (docType + ('/' + id)));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, $author$project$LatestLegal$Main$DocumentLoaded, $author$project$LatestLegal$Main$modelDecoder),
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withTimeout,
					10 * 1000,
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$LatestLegal$Main$init = function (flags) {
	var _v0 = $author$project$LatestLegal$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			{text: '', type_: decoded.type_, published: '', displayName: ''},
			A2($author$project$LatestLegal$Main$getDocument, decoded.type_, decoded.id));
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			{text: '', type_: '', published: '', displayName: ''},
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(err),
					context: 'LatestLegal.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$List = F2(
	function (a, b) {
		return {$: 'List', a: a, b: b};
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C`+)'));
var $pablohirafuji$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 'CodeToken', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				index: regMatch.index + backslashesLength,
				length: $elm$core$String$length(backtick),
				meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeToken(
					!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\u005C\u005C+)|( {2,}))\u005Cn'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 'HardLineBreakToken'};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.a.$ === 'Just') {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{index: (regMatch.index + backslashesLength) - 1, length: 2, meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (_v0.b.a.$ === 'Just')) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							index: regMatch.index,
							length: $elm$core$String$length(regMatch.match),
							meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.a.$ === 'Just') {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{index: regMatch.index + backslashesLength, length: 1, meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{index: (regMatch.index + backslashesLength) - 1, length: 2, meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							index: regMatch.index,
							length: $elm$core$String$length(regMatch.match),
							meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\u005C\u005C+)|( *))\u005Cn'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findHardBreakTokens = F2(
	function (softAsHardLineBreak, str) {
		return softAsHardLineBreak ? A2(
			$elm$core$List$filterMap,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
			A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
			$elm$core$List$filterMap,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
			A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C<)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken = function (a) {
	return {$: 'CharToken', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{
				index: regMatch.index + backslashesLength,
				length: 1,
				meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken(
					_Utils_chr('<'))
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C>)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$RightAngleBracket = function (a) {
	return {$: 'RightAngleBracket', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				index: regMatch.index + backslashesLength,
				length: 1,
				meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$RightAngleBracket(
					!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C!)?(\u005C[)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 'LinkOpenToken', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 'ImageOpenToken'};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (_v0.b.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var delimiter = _v2.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var meaning = isEscaped ? A2(
			$elm$core$Maybe$map,
			function (_v3) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken(true);
			},
			maybeImageOpen) : $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken(true),
				A2(
					$elm$core$Maybe$map,
					function (_v4) {
						return $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageOpenToken;
					},
					maybeImageOpen)));
		var length = _Utils_eq(
			meaning,
			$elm$core$Maybe$Just($pablohirafuji$elm_markdown$Markdown$InlineParser$ImageOpenToken)) ? 2 : 1;
		var index = (regMatch.index + backslashesLength) + ((isEscaped && _Utils_eq(
			maybeImageOpen,
			$elm$core$Maybe$Just('!'))) ? 1 : 0);
		var toModel = function (m) {
			return {index: index, length: length, meaning: m};
		};
		return A2($elm$core$Maybe$map, toModel, meaning);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)(\u005C])'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.submatches;
	if ((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{
				index: regMatch.index + backslashesLength,
				length: 1,
				meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken(
					_Utils_chr(']'))
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 'EmphasisToken', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\u005Cs'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$containSpace = $elm$regex$Regex$contains($pablohirafuji$elm_markdown$Markdown$InlineParser$spaceRegex);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$punctuationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[!-#%-\u005C*,-/:;\u005C?@\u005C[-\u005C]_\u005C{\u005C}]'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$containPunctuation = $elm$regex$Regex$contains($pablohirafuji$elm_markdown$Markdown$InlineParser$punctuationRegex);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$charFringeRank = function (_char) {
	var string = $elm$core$String$fromChar(_char);
	return $pablohirafuji$elm_markdown$Markdown$InlineParser$containSpace(string) ? 0 : ($pablohirafuji$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$maybeCharFringeRank = function (maybeChar) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$core$Maybe$map, $pablohirafuji$elm_markdown$Markdown$InlineParser$charFringeRank, maybeChar));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$getFringeRank = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$uncons,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($elm$core$Tuple$first),
				$pablohirafuji$elm_markdown$Markdown$InlineParser$maybeCharFringeRank))),
	$elm$core$Maybe$withDefault(0));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.submatches;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (_v0.b.b.a.$ === 'Just')) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var backslashesLength = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
			var leftFringeLength = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$core$String$length, maybeLeftFringe));
			var mLeftFringe = ((!(!regMatch.index)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.index - 1, regMatch.index, rawText)) : maybeLeftFringe;
			var isEscaped = ((!$pablohirafuji$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || _Utils_eq(
				mLeftFringe,
				$elm$core$Maybe$Just('\u005C'));
			var fringeRank = _Utils_Tuple2(
				isEscaped ? 1 : $pablohirafuji$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe),
				$pablohirafuji$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe));
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var index = ((regMatch.index + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
			return ((delimiterLength <= 0) || (_Utils_eq(
				_char,
				_Utils_chr('_')) && _Utils_eq(
				fringeRank,
				_Utils_Tuple2(2, 2)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{
					index: index,
					length: delimiterLength,
					meaning: A2($pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisToken, _char, fringeRank)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)([^*])?(\u005C*+)([^*])?'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2(
			$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken,
			_Utils_chr('*'),
			str),
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C*)([^_])?(\u005C_+)([^_])?'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2(
			$pablohirafuji$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken,
			_Utils_chr('_'),
			str),
		A2($elm$regex$Regex$find, $pablohirafuji$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokenize = function (model) {
	return _Utils_update(
		model,
		{
			tokens: A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.index;
				},
				_Utils_ap(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(model.rawText),
					_Utils_ap(
						$pablohirafuji$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(model.rawText),
						_Utils_ap(
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$findHardBreakTokens, model.options.softAsHardLineBreak, model.rawText),
							_Utils_ap(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(model.rawText),
								_Utils_ap(
									$pablohirafuji$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(model.rawText),
									_Utils_ap(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(model.rawText),
										_Utils_ap(
											$pablohirafuji$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(model.rawText),
											$pablohirafuji$elm_markdown$Markdown$InlineParser$findCodeTokens(model.rawText)))))))))
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$Match = function (a) {
	return {$: 'Match', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$NormalType = {$: 'NormalType'};
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $pablohirafuji$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $pablohirafuji$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($pablohirafuji$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$pablohirafuji$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.match,
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Entity$validUnicode,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					$elm$core$List$head(match.submatches)))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $pablohirafuji$elm_markdown$Markdown$Entity$decimalRegex, $pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimal);
var $pablohirafuji$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $pablohirafuji$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.match,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2($elm$core$Dict$get, a, $pablohirafuji$elm_markdown$Markdown$Entity$entities);
				},
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					$elm$core$List$head(match.submatches)))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $pablohirafuji$elm_markdown$Markdown$Entity$entitiesRegex, $pablohirafuji$elm_markdown$Markdown$Entity$replaceEntity);
var $pablohirafuji$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\u005C\u005C+)([!\u0022#$%&\u005C\u0027()*+,./:;<=>?@[\u005C\u005C\u005C]^_`{|}~-])'));
var $pablohirafuji$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$pablohirafuji$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.submatches;
		if (((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) && (_v0.b.a.$ === 'Just')) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\u005C'),
				escapedStr);
		} else {
			return regexMatch.match;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $pablohirafuji$elm_markdown$Markdown$Entity$hexToInt = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toList,
		A2(
			$elm$core$List$foldl,
			F2(
				function (hexDigit, _int) {
					return ((_int * 16) + A2(
						$elm$core$Basics$modBy,
						39,
						$elm$core$Char$toCode(hexDigit))) - 9;
				}),
			0)));
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.match,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $pablohirafuji$elm_markdown$Markdown$Entity$hexToInt, $pablohirafuji$elm_markdown$Markdown$Entity$validUnicode),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				$elm$core$List$head(match.submatches))));
};
var $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $pablohirafuji$elm_markdown$Markdown$Entity$hexadecimalRegex, $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $pablohirafuji$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	return $pablohirafuji$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$pablohirafuji$elm_markdown$Markdown$Entity$replaceDecimals(
			$pablohirafuji$elm_markdown$Markdown$Entity$replaceEntities(
				$pablohirafuji$elm_markdown$Markdown$Helpers$replaceEscapable(str))));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
		{
			end: 0,
			text: $pablohirafuji$elm_markdown$Markdown$Helpers$formatStr(text),
			start: 0,
			type_: $pablohirafuji$elm_markdown$Markdown$InlineParser$NormalType,
			matches: _List_Nil,
			textEnd: 0,
			textStart: 0
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2.a;
		var updtMatch = $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				matchModel,
				{
					matches: A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.text, _List_Nil, matchModel.matches)
				}));
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.end, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a.a;
			var matchesTail = parsedMatches.b;
			return _Utils_eq(matchHead.type_, $pablohirafuji$elm_markdown$Markdown$InlineParser$NormalType) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : (_Utils_eq(matchModel.end, matchHead.start) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.end, matchHead.start) < 0) ? A2(
				$elm$core$List$cons,
				updtMatch,
				A2(
					$elm$core$List$cons,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(
						A3($elm$core$String$slice, matchModel.end, matchHead.start, rawText)),
					parsedMatches)) : parsedMatches));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a.a;
					return (matchModel.start > 0) ? A2(
						$elm$core$List$cons,
						$pablohirafuji$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.start, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parseText = function (model) {
	return _Utils_update(
		model,
		{
			matches: A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parseTextMatches, model.rawText, _List_Nil, model.matches)
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$initParser = F3(
	function (options, refs, rawText) {
		return {refs: refs, tokens: _List_Nil, matches: _List_Nil, options: options, rawText: rawText};
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (result.$ === 'Ok') {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeType = {$: 'CodeType'};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 'HtmlType', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 'LinkType', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch = F2(
	function (model, match) {
		return _Utils_update(
			model,
			{
				matches: A2($elm$core$List$cons, match, model.matches)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$addToken = F2(
	function (model, token) {
		return _Utils_update(
			model,
			{
				tokens: A2($elm$core$List$cons, token, model.tokens)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM = F2(
	function (finderFunction, model) {
		return finderFunction(
			_Utils_Tuple2(
				model.tokens,
				_Utils_update(
					model,
					{tokens: _List_Nil})));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 'ImageType', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		var search = F2(
			function (token, _v2) {
				var maybeToken = _v2.a;
				var innerTokens = _v2.b;
				var remainTokens = _v2.c;
				if (maybeToken.$ === 'Nothing') {
					return isToken(token) ? _Utils_Tuple3(
						$elm$core$Maybe$Just(token),
						innerTokens,
						_List_Nil) : _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, token, innerTokens),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						maybeToken,
						innerTokens,
						A2($elm$core$List$cons, token, remainTokens));
				}
			});
		var _return = function (_v0) {
			var maybeToken = _v0.a;
			var innerTokens = _v0.b;
			var remainTokens = _v0.c;
			return A2(
				$elm$core$Maybe$map,
				function (token) {
					return _Utils_Tuple3(
						token,
						$elm$core$List$reverse(innerTokens),
						$elm$core$List$reverse(remainTokens));
				},
				maybeToken);
		};
		return _return(
			A3(
				$elm$core$List$foldl,
				search,
				_Utils_Tuple3($elm$core$Maybe$Nothing, _List_Nil, _List_Nil),
				tokens));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$voidHtmlTags = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isVoidTag = function (htmlModel) {
	return A2($elm$core$List$member, htmlModel.tag, $pablohirafuji$elm_markdown$Markdown$InlineParser$voidHtmlTags);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(\u005C/)?([a-zA-Z][a-zA-Z0-9\u005C-]*)(?:\u005Cs+([^<>]*?))?(\u005C/)?$'));
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlModel = F2(
	function (tag, attributes) {
		return {tag: tag, attributes: attributes};
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 'HtmlToken', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (maybeFound.$ === 'Just') {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$attributesFromRegex = function (regexMatch) {
	var _v0 = regexMatch.submatches;
	_v0$2:
	while (true) {
		if (_v0.b && (_v0.a.$ === 'Just')) {
			if (_v0.a.a === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				if ((_v0.b.b && _v0.b.b.b) && _v0.b.b.b.b) {
					var name = _v0.a.a;
					var _v1 = _v0.b;
					var maybeDoubleQuotes = _v1.a;
					var _v2 = _v1.b;
					var maybeSingleQuotes = _v2.a;
					var _v3 = _v2.b;
					var maybeUnquoted = _v3.a;
					var maybeValue = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
						_List_fromArray(
							[maybeDoubleQuotes, maybeSingleQuotes, maybeUnquoted]));
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(name, maybeValue));
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlAttributesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('([a-zA-Z:_][a-zA-Z0-9\u005C-_.:]*)(?: ?= ?(?:\u0022([^\u0022]*)\u0022|\u0027([^\u0027]*)\u0027|([^\u005Cs\u0022\u0027=<>`]*)))?'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$applyAttributesRegex = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$find($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlAttributesRegex),
	$elm$core$List$filterMap($pablohirafuji$elm_markdown$Markdown$InlineParser$attributesFromRegex));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlFromRegex = F3(
	function (model, match, regexMatch) {
		var _v0 = regexMatch.submatches;
		if ((((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) && _v0.b.b.b) && _v0.b.b.b.b) {
			var maybeClose = _v0.a;
			var _v1 = _v0.b;
			var tag = _v1.a.a;
			var _v2 = _v1.b;
			var maybeAttributes = _v2.a;
			var _v3 = _v2.b;
			var maybeSelfClosing = _v3.a;
			var filterAttributes = F2(
				function (attrs, allowed) {
					return A2(
						$elm$core$List$filter,
						function (attr) {
							return A2($elm$core$List$member, attr.a, allowed);
						},
						attrs);
				});
			var updateModel = function (attrs) {
				return A2(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$addToken,
					model,
					{
						index: match.start,
						length: match.end - match.start,
						meaning: A2(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlToken,
							_Utils_eq(maybeClose, $elm$core$Maybe$Nothing) && _Utils_eq(maybeSelfClosing, $elm$core$Maybe$Nothing),
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlModel, tag, attrs))
					});
			};
			var attributes = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $pablohirafuji$elm_markdown$Markdown$InlineParser$applyAttributesRegex, maybeAttributes));
			var noAttributesInCloseTag = _Utils_eq(maybeClose, $elm$core$Maybe$Nothing) || ((!_Utils_eq(maybeClose, $elm$core$Maybe$Nothing)) && _Utils_eq(attributes, _List_Nil));
			var _v4 = model.options.rawHtml;
			switch (_v4.$) {
				case 'ParseUnsafe':
					return noAttributesInCloseTag ? $elm$core$Maybe$Just(
						updateModel(attributes)) : $elm$core$Maybe$Nothing;
				case 'Sanitize':
					var allowedHtmlAttributes = _v4.a.allowedHtmlAttributes;
					var allowedHtmlElements = _v4.a.allowedHtmlElements;
					return (A2($elm$core$List$member, tag, allowedHtmlElements) && noAttributesInCloseTag) ? $elm$core$Maybe$Just(
						updateModel(
							A2(filterAttributes, attributes, allowedHtmlAttributes))) : $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (model, _v0) {
		var match = _v0.a;
		var _v1 = model.options.rawHtml;
		if (_v1.$ === 'DontParse') {
			return $elm$core$Maybe$Nothing;
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				A2($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlFromRegex, model, match),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlRegex, match.text)));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 'EmphasisType', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$filterTokens = F2(
	function (filter, model) {
		return _Utils_update(
			model,
			{
				tokens: A2($elm$core$List$filter, filter, model.tokens)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		var _v0 = token.meaning;
		if ((_v0.$ === 'HtmlToken') && (!_v0.a)) {
			var htmlModel_ = _v0.b;
			return _Utils_eq(htmlModel.tag, htmlModel_.tag);
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			{end: token.index + token.length, text: '', start: token.index, type_: type_, matches: _List_Nil, textEnd: 0, textStart: 0});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens = function (model) {
	return _Utils_update(
		model,
		{
			tokens: $elm$core$List$reverse(model.tokens)
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 'HardLineBreakType'};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$SoftLineBreakToken = {$: 'SoftLineBreakToken'};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$lineBreakTTM = function (_v0) {
	lineBreakTTM:
	while (true) {
		var tokens = _v0.a;
		var model = _v0.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			if (_Utils_eq(token.meaning, $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakToken) || (_Utils_eq(token.meaning, $pablohirafuji$elm_markdown$Markdown$InlineParser$SoftLineBreakToken) && model.options.softAsHardLineBreak)) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$lineBreakTTM(
					function (b) {
						return _Utils_Tuple2(tokensTail, b);
					}(
						_Utils_update(
							model,
							{
								matches: A2(
									$elm$core$List$cons,
									A2($pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $pablohirafuji$elm_markdown$Markdown$InlineParser$HardLineBreakType),
									model.matches)
							})));
			} else {
				var $temp$_v0 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v0 = $temp$_v0;
				continue lineBreakTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\u005C-]{1,31}:[^<>\u005Cx00-\u005Cx20]*)$'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.match,
				$elm$url$Url$percentDecode(match.match));
		}));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 'AutolinkType', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0.a;
	return A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$InlineParser$urlRegex, match.text) ? $elm$core$Result$Ok(
		$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				match,
				{
					type_: $pablohirafuji$elm_markdown$Markdown$InlineParser$AutolinkType(
						_Utils_Tuple2(
							match.text,
							$pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl(match.text)))
				}))) : $elm$core$Result$Err(
		$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(match));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.meaning;
		if (_v0.$ === 'CodeToken') {
			var isEscaped = _v0.a;
			return isEscaped ? _Utils_eq(openToken.length - 1, closeToken.length) : _Utils_eq(openToken.length, closeToken.length);
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \u005Ct\u005Cf\u005Cv\u005Cr\u005Cn';
var $pablohirafuji$elm_markdown$Markdown$Helpers$whitespacesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + ']+')));
var $pablohirafuji$elm_markdown$Markdown$Helpers$cleanWhitespaces = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$trim,
	A2(
		$elm$regex$Regex$replace,
		$pablohirafuji$elm_markdown$Markdown$Helpers$whitespacesRegex,
		function (_v0) {
			return ' ';
		}));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				childMatch,
				{end: childMatch.end - parentMatch.textStart, start: childMatch.start - parentMatch.textStart, textEnd: childMatch.textEnd - parentMatch.textStart, textStart: childMatch.textStart - parentMatch.textStart}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.meaning;
		if (_v0.$ === 'EmphasisToken') {
			var openChar = _v0.a;
			var _v1 = _v0.b;
			var openLR = _v1.a;
			var openRR = _v1.b;
			var _v2 = closeToken.meaning;
			if (_v2.$ === 'EmphasisToken') {
				var closeChar = _v2.a;
				var _v3 = _v2.b;
				var closeLR = _v3.a;
				var closeRR = _v3.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(openLR, openRR) || _Utils_eq(closeLR, closeRR)) ? (!(!A2($elm$core$Basics$modBy, 3, closeToken.length + openToken.length))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (tokensTail, parser) {
		var _v0 = parser.matches;
		if (!_v0.b) {
			return _Utils_Tuple2(tokensTail, parser);
		} else {
			var match = _v0.a.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$filter,
					function (token) {
						return _Utils_cmp(token.index, match.end) > -1;
					},
					tokensTail),
				parser);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\u0027*+\u005C/=?^_`{|}~\u005C-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\u005C-]{0,61}[a-zA-Z0-9])?(?:\u005C.[a-zA-Z0-9](?:[a-zA-Z0-9\u005C-]{0,61}[a-zA-Z0-9])?)*)$'));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0.a;
	return A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$InlineParser$emailRegex, match.text) ? $elm$core$Result$Ok(
		$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				match,
				{
					type_: $pablohirafuji$elm_markdown$Markdown$InlineParser$AutolinkType(
						_Utils_Tuple2(
							match.text,
							'mailto:' + $pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl(match.text)))
				}))) : $elm$core$Result$Err(
		$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(match));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.meaning;
	switch (_v0.$) {
		case 'LinkOpenToken':
			return true;
		case 'ImageOpenToken':
			return true;
		default:
			return false;
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = function (parser) {
	var _v0 = parser.matches;
	if (!_v0.b) {
		return $elm$core$Result$Err(_Utils_Tuple0);
	} else {
		var match = _v0.a.a;
		var remainMatches = _v0.b;
		var overlappingMatches = A2(
			$elm$core$List$filter,
			function (_v1) {
				var testMatch = _v1.a;
				return (_Utils_cmp(match.end, testMatch.start) > 0) && (_Utils_cmp(match.end, testMatch.end) < 0);
			},
			remainMatches);
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(overlappingMatches)) ? $elm$core$Result$Ok(parser) : $elm$core$Result$Err(_Utils_Tuple0);
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (maybe.$ === 'Just') {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\u005C[\u005C]\u005C\u005C]*(?:\u005C\u005C.[^\u005C[\u005C]\u005C\u005C]*)*';
var $pablohirafuji$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\u005C[\u005Cs*(' + ($pablohirafuji$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\u005Cs*\u005C]')));
var $pablohirafuji$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $pablohirafuji$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $pablohirafuji$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = function (_v0) {
	var rawUrl = _v0.a;
	var maybeTitle = _v0.b;
	return _Utils_Tuple2(
		$pablohirafuji$elm_markdown$Markdown$InlineParser$encodeUrl(
			$pablohirafuji$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
		A2($elm$core$Maybe$map, $pablohirafuji$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, model, maybeRegexMatch) {
		var regexMatchLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.match;
					},
					$elm$core$String$length),
				maybeRegexMatch));
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.text : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.text,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.submatches;
								},
								$elm$core$List$head),
							maybeRegexMatch)))));
		var maybeRefItem = A2(
			$elm$core$Dict$get,
			$pablohirafuji$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			model.refs);
		var toMatch = function (urlTitle) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
				_Utils_update(
					matchModel,
					{
						end: matchModel.end + regexMatchLength,
						type_: function () {
							var _v0 = matchModel.type_;
							if (_v0.$ === 'ImageType') {
								return $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle(urlTitle))
					}));
		};
		return A2($elm$core$Maybe$map, toMatch, maybeRefItem);
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType = function (_v0) {
	var remainText = _v0.a;
	var tempMatch = _v0.b.a;
	var model = _v0.c;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple3(
			remainText,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(tempMatch),
			model),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch(model),
			A3(
				$pablohirafuji$elm_markdown$Markdown$InlineParser$refRegexToMatch,
				tempMatch,
				model,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText)))));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']*)>|([^' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\u005C(\u005C)\u005C\u005C]*(?:\u005C\u005C.[^' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\u005C(\u005C)\u005C\u005C]*)*))')))));
var $pablohirafuji$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($pablohirafuji$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\u0027([^\u0027\u005C\u005C]*(?:\u005C\u005C.[^\u0027\u005C\u005C]*)*)\u0027|' + ('\u0022([^\u0022\u005C\u005C]*(?:\u005C\u005C.[^\u0022\u005C\u005C]*)*)\u0022|' + '\u005C(([^\u005C)\u005C\u005C]*(?:\u005C\u005C.[^\u005C)\u005C\u005C]*)*)\u005C)))?'))));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\u005C(\u005Cs*' + ($pablohirafuji$elm_markdown$Markdown$InlineParser$hrefRegex + ($pablohirafuji$elm_markdown$Markdown$Helpers$titleRegex + '\u005Cs*\u005C)'))));
var $pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F3(
	function (matchModel, model, regexMatch) {
		var _v0 = regexMatch.submatches;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeRawUrl = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			var maybeTitle = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
					_Utils_update(
						matchModel,
						{
							end: matchModel.end + $elm$core$String$length(regexMatch.match),
							type_: function () {
								var _v5 = matchModel.type_;
								if (_v5.$ === 'ImageType') {
									return $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType;
								} else {
									return $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType;
								}
							}()(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle(
									_Utils_Tuple2(rawUrl, maybeTitle)))
						}));
			};
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = function (_v0) {
	var remainText = _v0.a;
	var tempMatch = _v0.b.a;
	var model = _v0.c;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple3(
			remainText,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(tempMatch),
			model),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch(model),
			A2(
				$elm$core$Maybe$andThen,
				A2($pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, model),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText)))));
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$codeToMatch = F3(
	function (closeToken, model, _v25) {
		var openToken = _v25.a;
		var remainTokens = _v25.c;
		var updtOpenToken = _Utils_eq(
			openToken.meaning,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$CodeToken(true)) ? _Utils_update(
			openToken,
			{index: openToken.index + 1, length: openToken.length - 1}) : openToken;
		return _Utils_update(
			model,
			{
				tokens: remainTokens,
				matches: A2(
					$elm$core$List$cons,
					A6($pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch, model, $pablohirafuji$elm_markdown$Markdown$Helpers$cleanWhitespaces, $pablohirafuji$elm_markdown$Markdown$InlineParser$CodeType, updtOpenToken, closeToken, _List_Nil),
					model.matches)
			});
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM = function (_v21) {
	emphasisTTM:
	while (true) {
		var tokens = _v21.a;
		var model = _v21.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v23 = token.meaning;
			if (_v23.$ === 'EmphasisToken') {
				var _char = _v23.a;
				var _v24 = _v23.b;
				var leftRank = _v24.a;
				var rightRank = _v24.b;
				if (_Utils_eq(leftRank, rightRank)) {
					if ((!(!rightRank)) && ((!_Utils_eq(
						_char,
						_Utils_chr('_'))) || (rightRank === 1))) {
						return $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM(
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(
									tokensTail,
									A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token)),
								A2(
									$elm$core$Maybe$map,
									A3($pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisToMatch, token, tokensTail, model),
									A2(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
										model.tokens))));
					} else {
						var $temp$_v21 = _Utils_Tuple2(tokensTail, model);
						_v21 = $temp$_v21;
						continue emphasisTTM;
					}
				} else {
					if (_Utils_cmp(leftRank, rightRank) < 0) {
						var $temp$_v21 = _Utils_Tuple2(
							tokensTail,
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
						_v21 = $temp$_v21;
						continue emphasisTTM;
					} else {
						return $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM(
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(tokensTail, model),
								A2(
									$elm$core$Maybe$map,
									A3($pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisToMatch, token, tokensTail, model),
									A2(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
										model.tokens))));
					}
				}
			} else {
				var $temp$_v21 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v21 = $temp$_v21;
				continue emphasisTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM = function (_v18) {
	htmlElementTTM:
	while (true) {
		var tokens = _v18.a;
		var model = _v18.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v20 = token.meaning;
			if (_v20.$ === 'HtmlToken') {
				var isOpen = _v20.a;
				var htmlModel = _v20.b;
				return ($pablohirafuji$elm_markdown$Markdown$InlineParser$isVoidTag(htmlModel) || (!isOpen)) ? $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM(
					function (b) {
						return _Utils_Tuple2(tokensTail, b);
					}(
						A2(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch,
							model,
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel))))) : $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM(
					A2(
						$elm$core$Maybe$withDefault,
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$addMatch,
								model,
								A2(
									$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)))),
						A2(
							$elm$core$Maybe$map,
							A3($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementToMatch, token, model, htmlModel),
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
								tokensTail))));
			} else {
				var $temp$_v18 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v18 = $temp$_v18;
				continue htmlElementTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisToMatch = F4(
	function (closeToken, tokensTail, model, _v17) {
		var openToken = _v17.a;
		var innerTokens = _v17.b;
		var remainTokens = _v17.c;
		var remainLength = openToken.length - closeToken.length;
		var updt = (!remainLength) ? {openToken: openToken, closeToken: closeToken, tokensTail: tokensTail, remainTokens: remainTokens} : ((remainLength > 0) ? {
			openToken: _Utils_update(
				openToken,
				{index: openToken.index + remainLength, length: closeToken.length}),
			closeToken: closeToken,
			tokensTail: tokensTail,
			remainTokens: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{length: remainLength}),
				remainTokens)
		} : {
			openToken: openToken,
			closeToken: _Utils_update(
				closeToken,
				{length: openToken.length}),
			tokensTail: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{index: closeToken.index + openToken.length, length: -remainLength}),
				tokensTail),
			remainTokens: remainTokens
		});
		var match = A6(
			$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			model,
			function (s) {
				return s;
			},
			$pablohirafuji$elm_markdown$Markdown$InlineParser$EmphasisType(updt.openToken.length),
			updt.openToken,
			updt.closeToken,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple2(
			updt.tokensTail,
			_Utils_update(
				model,
				{
					tokens: updt.remainTokens,
					matches: A2($elm$core$List$cons, match, model.matches)
				}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = function (_v14) {
	linkImageTypeTTM:
	while (true) {
		var tokens = _v14.a;
		var model = _v14.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v16 = token.meaning;
			if ((_v16.$ === 'CharToken') && (']' === _v16.a.valueOf())) {
				return $pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageTypeTTM(
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(tokensTail, model),
						A2(
							$elm$core$Maybe$andThen,
							A3($pablohirafuji$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, model),
							A2($pablohirafuji$elm_markdown$Markdown$InlineParser$findToken, $pablohirafuji$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, model.tokens))));
			} else {
				var $temp$_v14 = _Utils_Tuple2(
					tokensTail,
					A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v14 = $temp$_v14;
				continue linkImageTypeTTM;
			}
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F6(
	function (model, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.index + openToken.length;
		var textEnd = closeToken.index;
		var start = openToken.index;
		var end = closeToken.index + closeToken.length;
		var match = {
			end: end,
			text: processText(
				A3($elm$core$String$slice, textStart, textEnd, model.rawText)),
			start: start,
			type_: type_,
			matches: _List_Nil,
			textEnd: textEnd,
			textStart: textStart
		};
		var matches = A2(
			$elm$core$List$map,
			function (_v13) {
				var matchModel = _v13.a;
				return A2($pablohirafuji$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			$pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches()(
				_Utils_update(
					model,
					{tokens: innerTokens, matches: _List_Nil})).matches);
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				match,
				{matches: matches}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementToMatch = F4(
	function (openToken, model, htmlModel, _v12) {
		var closeToken = _v12.a;
		var innerTokens = _v12.b;
		var remainTokens = _v12.c;
		return _Utils_Tuple2(
			remainTokens,
			_Utils_update(
				model,
				{
					matches: A2(
						$elm$core$List$cons,
						A6(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
							model,
							function (s) {
								return s;
							},
							$pablohirafuji$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
							openToken,
							closeToken,
							innerTokens),
						model.matches)
				}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F4(
	function (closeToken, isEscaped, model, _v10) {
		var openToken = _v10.a;
		var remainTokens = _v10.c;
		return function (result) {
			if (result.$ === 'Err') {
				var tempMatch = result.a;
				return (!isEscaped) ? A2(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$htmlToToken,
					_Utils_update(
						model,
						{tokens: remainTokens}),
					tempMatch) : $elm$core$Result$toMaybe(result);
			} else {
				return $elm$core$Result$toMaybe(result);
			}
		}(
			A2(
				$elm$core$Result$map,
				function (newMatch) {
					return _Utils_update(
						model,
						{
							tokens: remainTokens,
							matches: A2($elm$core$List$cons, newMatch, model.matches)
						});
				},
				A2(
					$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$autolinkToMatch(
						A6(
							$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
							model,
							function (s) {
								return s;
							},
							$pablohirafuji$elm_markdown$Markdown$InlineParser$CodeType,
							openToken,
							closeToken,
							_List_Nil)))));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F4(
	function (closeToken, tokensTail, model, _v3) {
		var openToken = _v3.a;
		var innerTokens = _v3.b;
		var remainTokens = _v3.c;
		var linkOpenTokenToInactive = function (model_) {
			var process = function (token) {
				var _v9 = token.meaning;
				if (_v9.$ === 'LinkOpenToken') {
					return _Utils_update(
						token,
						{
							meaning: $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkOpenToken(false)
						});
				} else {
					return token;
				}
			};
			return _Utils_update(
				model_,
				{
					tokens: A2($elm$core$List$map, process, model_.tokens)
				});
		};
		var removeOpenToken = _Utils_Tuple2(
			tokensTail,
			_Utils_update(
				model,
				{
					tokens: _Utils_ap(innerTokens, remainTokens)
				}));
		var remainText = A2($elm$core$String$dropLeft, closeToken.index + 1, model.rawText);
		var tempMatch = function (isLinkType) {
			return A6(
				$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				model,
				function (s) {
					return s;
				},
				isLinkType ? $pablohirafuji$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $pablohirafuji$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var args = function (isLinkType) {
			return _Utils_Tuple3(
				remainText,
				tempMatch(isLinkType),
				_Utils_update(
					model,
					{tokens: remainTokens}));
		};
		var _v4 = openToken.meaning;
		switch (_v4.$) {
			case 'ImageOpenToken':
				return $elm$core$Result$toMaybe(
					A2(
						$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
						function (_v6) {
							return $elm$core$Result$Ok(removeOpenToken);
						},
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens(tokensTail),
							A2(
								$elm$core$Result$andThen,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping,
								A2(
									$elm$core$Result$mapError,
									function (_v5) {
										return _Utils_Tuple0;
									},
									A2(
										$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType(
											args(false))))))));
			case 'LinkOpenToken':
				if (_v4.a) {
					return $elm$core$Result$toMaybe(
						A2(
							$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
							function (_v8) {
								return $elm$core$Result$Ok(removeOpenToken);
							},
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens(tokensTail),
								A2(
									$elm$core$Result$map,
									linkOpenTokenToInactive,
									A2(
										$elm$core$Result$andThen,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping,
										A2(
											$elm$core$Result$mapError,
											function (_v7) {
												return _Utils_Tuple0;
											},
											A2(
												$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
												$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType,
												$pablohirafuji$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType(
													args(true)))))))));
				} else {
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = function (_v0) {
	codeAutolinkTypeHtmlTagTTM:
	while (true) {
		var tokens = _v0.a;
		var model = _v0.b;
		if (!tokens.b) {
			return $pablohirafuji$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v2 = token.meaning;
			switch (_v2.$) {
				case 'CodeToken':
					var isEscaped = _v2.a;
					return $pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM(
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$elm$core$Maybe$withDefault,
								A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token),
								A2(
									$elm$core$Maybe$map,
									A2($pablohirafuji$elm_markdown$Markdown$InlineParser$codeToMatch, token, model),
									A2(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
										$pablohirafuji$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
										model.tokens)))));
				case 'RightAngleBracket':
					var isEscaped = _v2.a;
					return $pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM(
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$filterTokens,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.meaning;
									},
									$elm$core$Basics$neq(
										$pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken(
											_Utils_chr('<')))),
								A2(
									$elm$core$Maybe$withDefault,
									model,
									A2(
										$elm$core$Maybe$andThen,
										A3($pablohirafuji$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, model),
										A2(
											$pablohirafuji$elm_markdown$Markdown$InlineParser$findToken,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.meaning;
												},
												$elm$core$Basics$eq(
													$pablohirafuji$elm_markdown$Markdown$InlineParser$CharToken(
														_Utils_chr('<')))),
											model.tokens))))));
				default:
					var $temp$_v0 = _Utils_Tuple2(
						tokensTail,
						A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addToken, model, token));
					_v0 = $temp$_v0;
					continue codeAutolinkTypeHtmlTagTTM;
			}
		}
	}
};
function $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches() {
	return A2(
		$elm$core$Basics$composeR,
		$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM),
		A2(
			$elm$core$Basics$composeR,
			$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$htmlElementTTM),
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$linkImageTypeTTM),
				A2(
					$elm$core$Basics$composeR,
					$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$emphasisTTM),
					$pablohirafuji$elm_markdown$Markdown$InlineParser$applyTTM($pablohirafuji$elm_markdown$Markdown$InlineParser$lineBreakTTM)))));
}
try {
	var $pablohirafuji$elm_markdown$Markdown$InlineParser$tokensToMatches = $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches();
	$pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches = function () {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$tokensToMatches;
	};
} catch ($) {
	throw 'Some top-level definitions from `Markdown.InlineParser` are causing infinite recursion:\n\n  ┌─────┐\n  │    codeToMatch\n  │     ↓\n  │    tokensToMatches\n  │     ↓\n  │    emphasisTTM\n  │     ↓\n  │    htmlElementTTM\n  │     ↓\n  │    emphasisToMatch\n  │     ↓\n  │    linkImageTypeTTM\n  │     ↓\n  │    tokenPairToMatch\n  │     ↓\n  │    htmlElementToMatch\n  │     ↓\n  │    angleBracketsToMatch\n  │     ↓\n  │    linkOrImageTypeToMatch\n  │     ↓\n  │    codeAutolinkTypeHtmlTagTTM\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $pablohirafuji$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 'Link', a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 'Text', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 'Image', a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 'Emphasis', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 'CodeInline', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Inline$HtmlInline = F3(
	function (a, b, c) {
		return {$: 'HtmlInline', a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$HardLineBreak = {$: 'HardLineBreak'};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0.a;
	var _v1 = match.type_;
	switch (_v1.$) {
		case 'NormalType':
			return $pablohirafuji$elm_markdown$Markdown$Inline$Text(match.text);
		case 'HardLineBreakType':
			return $pablohirafuji$elm_markdown$Markdown$Inline$HardLineBreak;
		case 'CodeType':
			return $pablohirafuji$elm_markdown$Markdown$Inline$CodeInline(match.text);
		case 'AutolinkType':
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$pablohirafuji$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 'LinkType':
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
		case 'ImageType':
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
		case 'HtmlType':
			var model = _v1.a;
			return A3(
				$pablohirafuji$elm_markdown$Markdown$Inline$HtmlInline,
				model.tag,
				model.attributes,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
		default:
			var length = _v1.a;
			return A2(
				$pablohirafuji$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(match.matches));
	}
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $pablohirafuji$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
			_Utils_update(
				parentMatch,
				{
					matches: A2(
						$elm$core$List$cons,
						A2($pablohirafuji$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
						parentMatch.matches)
				}));
	});
var $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatch = F2(
	function (_v0, matches) {
		var match = _v0.a;
		if (!matches.b) {
			return _List_fromArray(
				[
					$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(match)
				]);
		} else {
			var prevMatch = matches.a.a;
			var matchesTail = matches.b;
			return (_Utils_cmp(prevMatch.end, match.start) < 1) ? A2(
				$elm$core$List$cons,
				$pablohirafuji$elm_markdown$Markdown$InlineParser$Match(match),
				matches) : (((_Utils_cmp(prevMatch.start, match.start) < 0) && (_Utils_cmp(prevMatch.end, match.end) > 0)) ? A2(
				$elm$core$List$cons,
				A2($pablohirafuji$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
				matchesTail) : matches);
		}
	});
function $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches() {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortBy(
			function (_v0) {
				var match = _v0.a;
				return match.start;
			}),
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$List$foldl, $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatch, _List_Nil),
			$elm$core$List$map(
				function (_v1) {
					var match = _v1.a;
					return $pablohirafuji$elm_markdown$Markdown$InlineParser$Match(
						_Utils_update(
							match,
							{
								matches: $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches()(match.matches)
							}));
				})));
}
try {
	var $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatches = $pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches();
	$pablohirafuji$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches = function () {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatches;
	};
} catch ($) {
	throw 'Some top-level definitions from `Markdown.InlineParser` are causing infinite recursion:\n\n  ┌─────┐\n  │    organizeMatches\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.3/bad-recursion to learn how to fix it!';}
var $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeParserMatches = function (model) {
	return _Utils_update(
		model,
		{
			matches: $pablohirafuji$elm_markdown$Markdown$InlineParser$organizeMatches(model.matches)
		});
};
var $pablohirafuji$elm_markdown$Markdown$InlineParser$parse = F3(
	function (options, refs, rawText) {
		return $pablohirafuji$elm_markdown$Markdown$InlineParser$matchesToInlines(
			$pablohirafuji$elm_markdown$Markdown$InlineParser$parseText(
				$pablohirafuji$elm_markdown$Markdown$InlineParser$organizeParserMatches(
					$pablohirafuji$elm_markdown$Markdown$InlineParser$tokensToMatches(
						$pablohirafuji$elm_markdown$Markdown$InlineParser$tokenize(
							A3(
								$pablohirafuji$elm_markdown$Markdown$InlineParser$initParser,
								options,
								refs,
								$elm$core$String$trim(rawText)))))).matches);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$Custom = F2(
	function (a, b) {
		return {$: 'Custom', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$Heading = F3(
	function (a, b, c) {
		return {$: 'Heading', a: a, b: b, c: c};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$Paragraph = F2(
	function (a, b) {
		return {$: 'Paragraph', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 'BlockQuote', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Block$PlainInlines = function (a) {
	return {$: 'PlainInlines', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Config$Sanitize = function (a) {
	return {$: 'Sanitize', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlElements = _List_fromArray(
	['address', 'article', 'aside', 'b', 'blockquote', 'br', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'dd', 'details', 'div', 'dl', 'dt', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'legend', 'li', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'option', 'p', 'pre', 'section', 'strike', 'summary', 'small', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'ul']);
var $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlAttributes = _List_fromArray(
	['name', 'class']);
var $pablohirafuji$elm_markdown$Markdown$Config$defaultSanitizeOptions = {allowedHtmlElements: $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlElements, allowedHtmlAttributes: $pablohirafuji$elm_markdown$Markdown$Config$defaultAllowedHtmlAttributes};
var $pablohirafuji$elm_markdown$Markdown$Config$defaultOptions = {
	rawHtml: $pablohirafuji$elm_markdown$Markdown$Config$Sanitize($pablohirafuji$elm_markdown$Markdown$Config$defaultSanitizeOptions),
	softAsHardLineBreak: false
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseInline = F4(
	function (maybeOptions, textAsParagraph, refs, block) {
		var options = A2($elm$core$Maybe$withDefault, $pablohirafuji$elm_markdown$Markdown$Config$defaultOptions, maybeOptions);
		switch (block.$) {
			case 'Heading':
				var rawText = block.a;
				var lvl = block.b;
				return A3(
					$pablohirafuji$elm_markdown$Markdown$Block$Heading,
					rawText,
					lvl,
					A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parse, options, refs, rawText));
			case 'Paragraph':
				var rawText = block.a;
				var inlines = A3($pablohirafuji$elm_markdown$Markdown$InlineParser$parse, options, refs, rawText);
				if ((inlines.b && (inlines.a.$ === 'HtmlInline')) && (!inlines.b.b)) {
					var _v3 = inlines.a;
					return $pablohirafuji$elm_markdown$Markdown$Block$PlainInlines(inlines);
				} else {
					return textAsParagraph ? A2($pablohirafuji$elm_markdown$Markdown$Block$Paragraph, rawText, inlines) : $pablohirafuji$elm_markdown$Markdown$Block$PlainInlines(inlines);
				}
			case 'BlockQuote':
				var blocks = block.a;
				return $pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(
					A3(
						$pablohirafuji$elm_markdown$Markdown$Block$parseInlines,
						maybeOptions,
						true,
						_Utils_Tuple2(refs, blocks)));
			case 'List':
				var model = block.a;
				var items = block.b;
				return A2(
					$pablohirafuji$elm_markdown$Markdown$Block$List,
					model,
					function (a) {
						return A2($elm$core$List$map, a, items);
					}(
						A2(
							$elm$core$Basics$composeL,
							A2($pablohirafuji$elm_markdown$Markdown$Block$parseInlines, maybeOptions, model.isLoose),
							function (b) {
								return _Utils_Tuple2(refs, b);
							})));
			case 'Custom':
				var customBlock = block.a;
				var blocks = block.b;
				return A2(
					$pablohirafuji$elm_markdown$Markdown$Block$Custom,
					customBlock,
					A3(
						$pablohirafuji$elm_markdown$Markdown$Block$parseInlines,
						maybeOptions,
						true,
						_Utils_Tuple2(refs, blocks)));
			default:
				return block;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseInlines = F3(
	function (maybeOptions, textAsParagraph, _v0) {
		var refs = _v0.a;
		var blocks = _v0.b;
		return A2(
			$elm$core$List$map,
			A3($pablohirafuji$elm_markdown$Markdown$Block$parseInline, maybeOptions, textAsParagraph, refs),
			blocks);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\u005Cs*$'));
var $pablohirafuji$elm_markdown$Markdown$Block$dropRefString = F2(
	function (rawText, inlineMatch) {
		var strippedText = A2($elm$core$String$dropLeft, inlineMatch.matchLength, rawText);
		return A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex, strippedText) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(strippedText);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$hrefRegex = '\u005Cs*(?:<([^<>\u005Cs]*)>|([^\u005Cs]*))';
var $pablohirafuji$elm_markdown$Markdown$Block$refRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\u005Cs*\u005C[(' + ($pablohirafuji$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + (')\u005C]:' + ($pablohirafuji$elm_markdown$Markdown$Block$hrefRegex + ($pablohirafuji$elm_markdown$Markdown$Helpers$titleRegex + '\u005Cs*(?![^\u005Cn])'))))));
var $pablohirafuji$elm_markdown$Markdown$Block$extractUrlTitleRegex = function (regexMatch) {
	var _v0 = regexMatch.submatches;
	if ((((((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) && _v0.b.b.b.b.b.b) {
		var rawText = _v0.a.a;
		var _v1 = _v0.b;
		var maybeRawUrlAngleBrackets = _v1.a;
		var _v2 = _v1.b;
		var maybeRawUrlWithoutBrackets = _v2.a;
		var _v3 = _v2.b;
		var maybeTitleSingleQuotes = _v3.a;
		var _v4 = _v3.b;
		var maybeTitleDoubleQuotes = _v4.a;
		var _v5 = _v4.b;
		var maybeTitleParenthesis = _v5.a;
		var maybeRawUrl = $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
			_List_fromArray(
				[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
		var toReturn = function (rawUrl) {
			return {
				url: rawUrl,
				inside: rawText,
				maybeTitle: $pablohirafuji$elm_markdown$Markdown$Helpers$returnFirstJust(
					_List_fromArray(
						[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis])),
				matchLength: $elm$core$String$length(regexMatch.match)
			};
		};
		return A2($elm$core$Maybe$map, toReturn, maybeRawUrl);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$maybeLinkMatch = function (rawText) {
	return A2(
		$elm$core$Maybe$andThen,
		function (linkMatch) {
			return ((linkMatch.url === '') || (linkMatch.inside === '')) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(linkMatch);
		},
		A2(
			$elm$core$Maybe$map,
			function (linkMatch) {
				return _Utils_update(
					linkMatch,
					{
						inside: $pablohirafuji$elm_markdown$Markdown$Helpers$prepareRefLabel(linkMatch.inside)
					});
			},
			A2(
				$elm$core$Maybe$andThen,
				$pablohirafuji$elm_markdown$Markdown$Block$extractUrlTitleRegex,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$refRegex, rawText)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$insertLinkMatch = F2(
	function (refs, linkMatch) {
		return A2($elm$core$Dict$member, linkMatch.inside, refs) ? refs : A3(
			$elm$core$Dict$insert,
			linkMatch.inside,
			_Utils_Tuple2(linkMatch.url, linkMatch.maybeTitle),
			refs);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseReference = F2(
	function (refs, rawText) {
		parseReference:
		while (true) {
			var _v0 = $pablohirafuji$elm_markdown$Markdown$Block$maybeLinkMatch(rawText);
			if (_v0.$ === 'Just') {
				var linkMatch = _v0.a;
				var maybeStrippedText = A2($pablohirafuji$elm_markdown$Markdown$Block$dropRefString, rawText, linkMatch);
				var updtRefs = A2($pablohirafuji$elm_markdown$Markdown$Block$insertLinkMatch, refs, linkMatch);
				if (maybeStrippedText.$ === 'Just') {
					var strippedText = maybeStrippedText.a;
					var $temp$refs = updtRefs,
						$temp$rawText = strippedText;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue parseReference;
				} else {
					return _Utils_Tuple2(updtRefs, $elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple2(
					refs,
					$elm$core$Maybe$Just(rawText));
			}
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseReferences = function (refs) {
	return A2(
		$elm$core$List$foldl,
		$pablohirafuji$elm_markdown$Markdown$Block$parseReferencesHelp,
		_Utils_Tuple2(refs, _List_Nil));
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseReferencesHelp = F2(
	function (block, _v0) {
		var refs = _v0.a;
		var parsedAST = _v0.b;
		switch (block.$) {
			case 'Paragraph':
				var rawText = block.a;
				var _v2 = A2($pablohirafuji$elm_markdown$Markdown$Block$parseReference, $elm$core$Dict$empty, rawText);
				var paragraphRefs = _v2.a;
				var maybeUpdtText = _v2.b;
				var updtRefs = A2($elm$core$Dict$union, paragraphRefs, refs);
				if (maybeUpdtText.$ === 'Just') {
					var updtText = maybeUpdtText.a;
					return _Utils_Tuple2(
						updtRefs,
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_markdown$Markdown$Block$Paragraph, updtText, _List_Nil),
							parsedAST));
				} else {
					return _Utils_Tuple2(updtRefs, parsedAST);
				}
			case 'List':
				var model = block.a;
				var items = block.b;
				var _v4 = A3(
					$elm$core$List$foldl,
					F2(
						function (item, _v5) {
							var refs__ = _v5.a;
							var parsedItems = _v5.b;
							return A2(
								$elm$core$Tuple$mapSecond,
								function (a) {
									return A2($elm$core$List$cons, a, parsedItems);
								},
								A2($pablohirafuji$elm_markdown$Markdown$Block$parseReferences, refs__, item));
						}),
					_Utils_Tuple2(refs, _List_Nil),
					items);
				var updtRefs = _v4.a;
				var updtItems = _v4.b;
				return _Utils_Tuple2(
					updtRefs,
					A2(
						$elm$core$List$cons,
						A2($pablohirafuji$elm_markdown$Markdown$Block$List, model, updtItems),
						parsedAST));
			case 'BlockQuote':
				var blocks = block.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (a) {
						return A2($elm$core$List$cons, a, parsedAST);
					},
					A2(
						$elm$core$Tuple$mapSecond,
						$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote,
						A2($pablohirafuji$elm_markdown$Markdown$Block$parseReferences, refs, blocks)));
			case 'Custom':
				var customBlock = block.a;
				var blocks = block.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (a) {
						return A2($elm$core$List$cons, a, parsedAST);
					},
					A2(
						$elm$core$Tuple$mapSecond,
						$pablohirafuji$elm_markdown$Markdown$Block$Custom(customBlock),
						A2($pablohirafuji$elm_markdown$Markdown$Block$parseReferences, refs, blocks)));
			default:
				return _Utils_Tuple2(
					refs,
					A2($elm$core$List$cons, block, parsedAST));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Helpers$tabRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\u005Ct'));
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $pablohirafuji$elm_markdown$Markdown$Helpers$indentLine = function (indentLength_) {
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$regex$Regex$replace,
			$pablohirafuji$elm_markdown$Markdown$Helpers$tabRegex,
			function (_v0) {
				return '    ';
			}),
		A3(
			$elm$regex$Regex$replaceAtMost,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString(
					'^ {0,' + ($elm$core$String$fromInt(indentLength_) + '}'))),
			function (_v1) {
				return '';
			}));
};
var $pablohirafuji$elm_markdown$Markdown$Helpers$initSpacesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ +'));
var $pablohirafuji$elm_markdown$Markdown$Helpers$indentLength = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$regex$Regex$replace,
		$pablohirafuji$elm_markdown$Markdown$Helpers$tabRegex,
		function (_v0) {
			return '    ';
		}),
	A2(
		$elm$core$Basics$composeR,
		A2($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Helpers$initSpacesRegex),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.match;
						},
						$elm$core$String$length)),
				$elm$core$Maybe$withDefault(0)))));
var $pablohirafuji$elm_markdown$Markdown$Block$formatParagraphLine = function (rawParagraph) {
	return (A2($elm$core$String$right, 2, rawParagraph) === '  ') ? ($elm$core$String$trim(rawParagraph) + '  ') : $elm$core$String$trim(rawParagraph);
};
var $pablohirafuji$elm_markdown$Markdown$Block$addToParagraph = F2(
	function (paragraph, rawLine) {
		return A2(
			$pablohirafuji$elm_markdown$Markdown$Block$Paragraph,
			paragraph + ('\u000A' + $pablohirafuji$elm_markdown$Markdown$Block$formatParagraphLine(rawLine)),
			_List_Nil);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph = F2(
	function (rawLine, ast) {
		_v0$3:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 'Paragraph':
						var _v1 = ast.a;
						var paragraph = _v1.a;
						var astTail = ast.b;
						return $elm$core$Maybe$Just(
							A2(
								$elm$core$List$cons,
								A2($pablohirafuji$elm_markdown$Markdown$Block$addToParagraph, paragraph, rawLine),
								astTail));
					case 'BlockQuote':
						var bqAST = ast.a.a;
						var astTail = ast.b;
						return A2(
							$elm$core$Maybe$map,
							function (updtBqAST) {
								return A2(
									$elm$core$List$cons,
									$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(updtBqAST),
									astTail);
							},
							A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, rawLine, bqAST));
					case 'List':
						var _v2 = ast.a;
						var model = _v2.a;
						var items = _v2.b;
						var astTail = ast.b;
						if (items.b) {
							var itemAST = items.a;
							var itemASTTail = items.b;
							return A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function (a) {
										return A2($elm$core$List$cons, a, itemASTTail);
									},
									A2(
										$elm$core$Basics$composeR,
										$pablohirafuji$elm_markdown$Markdown$Block$List(model),
										function (a) {
											return A2($elm$core$List$cons, a, astTail);
										})),
								A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, rawLine, itemAST));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseTextLine = F2(
	function (rawLine, ast) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$List$cons,
				A2(
					$pablohirafuji$elm_markdown$Markdown$Block$Paragraph,
					$pablohirafuji$elm_markdown$Markdown$Block$formatParagraphLine(rawLine),
					_List_Nil),
				ast),
			A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, rawLine, ast));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$Fenced = F2(
	function (a, b) {
		return {$: 'Fenced', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$BlankLine = function (a) {
	return {$: 'BlankLine', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Block$CodeBlock = F2(
	function (a, b) {
		return {$: 'CodeBlock', a: a, b: b};
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseBlankLine = F2(
	function (ast, match) {
		_v1$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 'CodeBlock':
						if ((ast.a.a.$ === 'Fenced') && ast.a.a.a) {
							var _v2 = ast.a;
							var _v3 = _v2.a;
							var fence = _v3.b;
							var code = _v2.b;
							var astTail = ast.b;
							return function (a) {
								return A2($elm$core$List$cons, a, astTail);
							}(
								A2(
									$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
									A2($pablohirafuji$elm_markdown$Markdown$Block$Fenced, true, fence),
									code + '\u000A'));
						} else {
							break _v1$2;
						}
					case 'List':
						var _v4 = ast.a;
						var model = _v4.a;
						var items = _v4.b;
						var astTail = ast.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$pablohirafuji$elm_markdown$Markdown$Block$List,
								model,
								A2($pablohirafuji$elm_markdown$Markdown$Block$addBlankLineToListBlock, match, items)),
							astTail);
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return A2(
			$elm$core$List$cons,
			$pablohirafuji$elm_markdown$Markdown$Block$BlankLine(match.match),
			ast);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$addBlankLineToListBlock = F2(
	function (match, asts) {
		if (!asts.b) {
			return _List_fromArray(
				[
					_List_fromArray(
					[
						$pablohirafuji$elm_markdown$Markdown$Block$BlankLine(match.match)
					])
				]);
		} else {
			var ast = asts.a;
			var astsTail = asts.b;
			return A2(
				$elm$core$List$cons,
				A2($pablohirafuji$elm_markdown$Markdown$Block$parseBlankLine, ast, match),
				astsTail);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkBlankLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Block$parseBlankLine(ast),
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$isBlankLineLast = function (items) {
	isBlankLineLast:
	while (true) {
		if (!items.b) {
			return false;
		} else {
			var item = items.a;
			var itemsTail = items.b;
			_v1$3:
			while (true) {
				if (item.b) {
					switch (item.a.$) {
						case 'BlankLine':
							if (!item.b.b) {
								return false;
							} else {
								return true;
							}
						case 'List':
							var _v2 = item.a;
							var items_ = _v2.b;
							var $temp$items = items_;
							items = $temp$items;
							continue isBlankLineLast;
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return false;
		}
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$indentedCodeLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^(?: {4,4}| {0,3}\u005Ct)(.*)$'));
var $pablohirafuji$elm_markdown$Markdown$Block$Indented = {$: 'Indented'};
var $pablohirafuji$elm_markdown$Markdown$Block$blocksAfterBlankLines = F2(
	function (ast, blankLines) {
		blocksAfterBlankLines:
		while (true) {
			if (ast.b && (ast.a.$ === 'BlankLine')) {
				var blankStr = ast.a.a;
				var astTail = ast.b;
				var $temp$ast = astTail,
					$temp$blankLines = A2($elm$core$List$cons, blankStr, blankLines);
				ast = $temp$ast;
				blankLines = $temp$blankLines;
				continue blocksAfterBlankLines;
			} else {
				return _Utils_Tuple2(ast, blankLines);
			}
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$resumeIndentedCodeBlock = F2(
	function (codeLine, _v0) {
		var remainBlocks = _v0.a;
		var blankLines = _v0.b;
		if ((remainBlocks.b && (remainBlocks.a.$ === 'CodeBlock')) && (remainBlocks.a.a.$ === 'Indented')) {
			var _v2 = remainBlocks.a;
			var _v3 = _v2.a;
			var codeStr = _v2.b;
			var remainBlocksTail = remainBlocks.b;
			return $elm$core$Maybe$Just(
				function (a) {
					return A2($elm$core$List$cons, a, remainBlocksTail);
				}(
					A2(
						$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
						$pablohirafuji$elm_markdown$Markdown$Block$Indented,
						function (a) {
							return a + (codeLine + '\u000A');
						}(
							_Utils_ap(
								codeStr,
								$elm$core$String$concat(
									A2(
										$elm$core$List$map,
										function (bl) {
											return A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, 4, bl) + '\u000A';
										},
										blankLines)))))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseIndentedCodeLine = F2(
	function (ast, codeLine) {
		_v0$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 'CodeBlock':
						if (ast.a.a.$ === 'Indented') {
							var _v1 = ast.a;
							var _v2 = _v1.a;
							var codeStr = _v1.b;
							var astTail = ast.b;
							return function (a) {
								return A2($elm$core$List$cons, a, astTail);
							}(
								A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, $pablohirafuji$elm_markdown$Markdown$Block$Indented, codeStr + (codeLine + '\u000A')));
						} else {
							break _v0$2;
						}
					case 'BlankLine':
						var blankStr = ast.a.a;
						var astTail = ast.b;
						return A2(
							$elm$core$Maybe$withDefault,
							function (a) {
								return A2($elm$core$List$cons, a, ast);
							}(
								A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, $pablohirafuji$elm_markdown$Markdown$Block$Indented, codeLine + '\u000A')),
							A2(
								$pablohirafuji$elm_markdown$Markdown$Block$resumeIndentedCodeBlock,
								codeLine,
								A2(
									$pablohirafuji$elm_markdown$Markdown$Block$blocksAfterBlankLines,
									astTail,
									_List_fromArray(
										[blankStr]))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$elm$core$Maybe$withDefault,
			function (a) {
				return A2($elm$core$List$cons, a, ast);
			}(
				A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, $pablohirafuji$elm_markdown$Markdown$Block$Indented, codeLine + '\u000A')),
			A2($pablohirafuji$elm_markdown$Markdown$Block$maybeContinueParagraph, codeLine, ast));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkIndentedCode = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Block$parseIndentedCodeLine(ast),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.submatches;
							},
							$elm$core$List$head),
						$elm$core$List$head(
							A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$indentedCodeLineRegex, rawLine)))))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$blockQuoteLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(?:>[ ]?)(.*)$'));
var $pablohirafuji$elm_markdown$Markdown$Block$atxHeadingLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(#{1,6})' + ('(?:[ \u005Ct]+[ \u005Ct#]+$|[ \u005Ct]+|$)' + '(.*?)(?:\u005Cs+[ \u005Ct#]*)?$')));
var $pablohirafuji$elm_markdown$Markdown$Block$extractATXHeadingRM = function (match) {
	var _v0 = match.submatches;
	if ((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) {
		var lvl = _v0.a.a;
		var _v1 = _v0.b;
		var maybeHeading = _v1.a;
		return $elm$core$Maybe$Just(
			A3(
				$pablohirafuji$elm_markdown$Markdown$Block$Heading,
				A2($elm$core$Maybe$withDefault, '', maybeHeading),
				$elm$core$String$length(lvl),
				_List_Nil));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$checkATXHeadingLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return A2($elm$core$List$cons, a, ast);
			},
			A2(
				$elm$core$Maybe$andThen,
				$pablohirafuji$elm_markdown$Markdown$Block$extractATXHeadingRM,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$atxHeadingLineRegex, rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$calcListIndentLength = function (_v0) {
	var listBlock = _v0.a;
	var indentSpace = _v0.b;
	var rawLine = _v0.c;
	var indentSpaceLength = $elm$core$String$length(indentSpace);
	var isIndentedCode = indentSpaceLength >= 4;
	var indentLength = (isIndentedCode || A2($elm$regex$Regex$contains, $pablohirafuji$elm_markdown$Markdown$Block$blankLineRegex, rawLine)) ? (listBlock.indentLength - indentSpaceLength) : listBlock.indentLength;
	var updtRawLine = isIndentedCode ? _Utils_ap(indentSpace, rawLine) : rawLine;
	return _Utils_Tuple2(
		_Utils_update(
			listBlock,
			{indentLength: indentLength}),
		updtRawLine);
};
var $pablohirafuji$elm_markdown$Markdown$Block$Ordered = function (a) {
	return {$: 'Ordered', a: a};
};
var $pablohirafuji$elm_markdown$Markdown$Block$Unordered = {$: 'Unordered'};
var $pablohirafuji$elm_markdown$Markdown$Block$extractOrderedListRM = function (match) {
	var _v0 = match.submatches;
	if (((((((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) && (_v0.b.a.$ === 'Just')) && _v0.b.b.b) && (_v0.b.b.a.$ === 'Just')) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
		var indentString = _v0.a.a;
		var _v1 = _v0.b;
		var start = _v1.a.a;
		var _v2 = _v1.b;
		var delimiter = _v2.a.a;
		var _v3 = _v2.b;
		var maybeIndentSpace = _v3.a;
		var _v4 = _v3.b;
		var maybeRawLine = _v4.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(
				{
					type_: A2(
						$elm$core$Maybe$withDefault,
						$pablohirafuji$elm_markdown$Markdown$Block$Unordered,
						A2(
							$elm$core$Maybe$map,
							$pablohirafuji$elm_markdown$Markdown$Block$Ordered,
							$elm$core$String$toInt(start))),
					isLoose: false,
					delimiter: delimiter,
					indentLength: $elm$core$String$length(indentString) + 1
				},
				A2($elm$core$Maybe$withDefault, '', maybeIndentSpace),
				A2($elm$core$Maybe$withDefault, '', maybeRawLine)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$orderedListLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^( *(\u005Cd{1,9})([.)])( {0,4}))(?:[ \u005Ct](.*))?$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkOrderedListLine = function (rawLine) {
	return A2(
		$elm$core$Result$fromMaybe,
		rawLine,
		A2(
			$elm$core$Maybe$andThen,
			$pablohirafuji$elm_markdown$Markdown$Block$extractOrderedListRM,
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$orderedListLineRegex, rawLine))));
};
var $elm$core$String$words = _String_words;
var $pablohirafuji$elm_markdown$Markdown$Block$extractOpenCodeFenceRM = function (match) {
	var _v0 = match.submatches;
	if (((_v0.b && _v0.b.b) && (_v0.b.a.$ === 'Just')) && _v0.b.b.b) {
		var maybeIndent = _v0.a;
		var _v1 = _v0.b;
		var fence = _v1.a.a;
		var _v2 = _v1.b;
		var maybeLanguage = _v2.a;
		return $elm$core$Maybe$Just(
			A2(
				$pablohirafuji$elm_markdown$Markdown$Block$Fenced,
				true,
				{
					language: A2(
						$elm$core$Maybe$map,
						$pablohirafuji$elm_markdown$Markdown$Helpers$formatStr,
						A2(
							$elm$core$Maybe$andThen,
							function (lang) {
								return (lang === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lang);
							},
							$elm$core$List$head(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $elm$core$String$words, maybeLanguage))))),
					fenceChar: A2($elm$core$String$left, 1, fence),
					fenceLength: $elm$core$String$length(fence),
					indentLength: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Maybe$map, $elm$core$String$length, maybeIndent))
				}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$openCodeFenceLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^( {0,3})(`{3,}(?!.*`)|~{3,}(?!.*~))(.*)$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkOpenCodeFenceLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return A2($elm$core$List$cons, a, ast);
			},
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return A2($pablohirafuji$elm_markdown$Markdown$Block$CodeBlock, f, '');
				},
				A2(
					$elm$core$Maybe$andThen,
					$pablohirafuji$elm_markdown$Markdown$Block$extractOpenCodeFenceRM,
					$elm$core$List$head(
						A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$openCodeFenceLineRegex, rawLine))))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$extractSetextHeadingRM = function (match) {
	var _v0 = match.submatches;
	if (_v0.b && (_v0.a.$ === 'Just')) {
		var delimiter = _v0.a.a;
		return A2($elm$core$String$startsWith, '=', delimiter) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(1, delimiter)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(2, delimiter));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseSetextHeadingLine = F3(
	function (rawLine, ast, _v0) {
		var lvl = _v0.a;
		var delimiter = _v0.b;
		if (ast.b && (ast.a.$ === 'Paragraph')) {
			var _v2 = ast.a;
			var rawText = _v2.a;
			var astTail = ast.b;
			return $elm$core$Maybe$Just(
				A2(
					$elm$core$List$cons,
					A3($pablohirafuji$elm_markdown$Markdown$Block$Heading, rawText, lvl, _List_Nil),
					astTail));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$setextHeadingLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(=+|-+)[ \u005Ct]*$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkSetextHeadingLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$andThen,
			A2($pablohirafuji$elm_markdown$Markdown$Block$parseSetextHeadingLine, rawLine, ast),
			A2(
				$elm$core$Maybe$andThen,
				$pablohirafuji$elm_markdown$Markdown$Block$extractSetextHeadingRM,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$setextHeadingLineRegex, rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$ThematicBreak = {$: 'ThematicBreak'};
var $pablohirafuji$elm_markdown$Markdown$Block$thematicBreakLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(?:' + ('(?:\u005C*[ \u005Ct]*){3,}' + ('|(?:_[ \u005Ct]*){3,}' + '|(?:-[ \u005Ct]*){3,})[ \u005Ct]*$'))));
var $pablohirafuji$elm_markdown$Markdown$Block$checkThematicBreakLine = function (_v0) {
	var rawLine = _v0.a;
	var ast = _v0.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			function (_v1) {
				return A2($elm$core$List$cons, $pablohirafuji$elm_markdown$Markdown$Block$ThematicBreak, ast);
			},
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$thematicBreakLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$extractUnorderedListRM = function (match) {
	var _v0 = match.submatches;
	if ((((((_v0.b && (_v0.a.$ === 'Just')) && _v0.b.b) && (_v0.b.a.$ === 'Just')) && _v0.b.b.b) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
		var indentString = _v0.a.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var _v2 = _v1.b;
		var maybeIndentSpace = _v2.a;
		var _v3 = _v2.b;
		var maybeRawLine = _v3.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(
				{
					type_: $pablohirafuji$elm_markdown$Markdown$Block$Unordered,
					isLoose: false,
					delimiter: delimiter,
					indentLength: $elm$core$String$length(indentString) + 1
				},
				A2($elm$core$Maybe$withDefault, '', maybeIndentSpace),
				A2($elm$core$Maybe$withDefault, '', maybeRawLine)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $pablohirafuji$elm_markdown$Markdown$Block$unorderedListLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^( *([\u005C*\u005C-\u005C+])( {0,4}))(?:[ \u005Ct](.*))?$'));
var $pablohirafuji$elm_markdown$Markdown$Block$checkUnorderedListLine = function (rawLine) {
	return A2(
		$elm$core$Result$fromMaybe,
		rawLine,
		A2(
			$elm$core$Maybe$andThen,
			$pablohirafuji$elm_markdown$Markdown$Block$extractUnorderedListRM,
			$elm$core$List$head(
				A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$unorderedListLineRegex, rawLine))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLineHelp = F2(
	function (fence, match) {
		var _v0 = match.submatches;
		if (_v0.b && (_v0.a.$ === 'Just')) {
			var fenceStr = _v0.a.a;
			return (_Utils_cmp(
				$elm$core$String$length(fenceStr),
				fence.fenceLength) > -1) && _Utils_eq(
				A2($elm$core$String$left, 1, fenceStr),
				fence.fenceChar);
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$closeCodeFenceLineRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^ {0,3}(`{3,}|~{3,})\u005Cs*$'));
var $pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLine = function (fence) {
	return A2(
		$elm$core$Basics$composeR,
		A2($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$closeCodeFenceLineRegex),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLineHelp(fence)),
				$elm$core$Maybe$withDefault(false))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$continueOrCloseCodeFence = F3(
	function (fence, previousCode, rawLine) {
		return A2($pablohirafuji$elm_markdown$Markdown$Block$isCloseFenceLine, fence, rawLine) ? A2(
			$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
			A2($pablohirafuji$elm_markdown$Markdown$Block$Fenced, false, fence),
			previousCode) : A2(
			$pablohirafuji$elm_markdown$Markdown$Block$CodeBlock,
			A2($pablohirafuji$elm_markdown$Markdown$Block$Fenced, true, fence),
			previousCode + (A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, fence.indentLength, rawLine) + '\u000A'));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseRawLine = F2(
	function (rawLine, ast) {
		return A2(
			$elm$core$Result$withDefault,
			A2($pablohirafuji$elm_markdown$Markdown$Block$parseTextLine, rawLine, ast),
			A2(
				$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
				$pablohirafuji$elm_markdown$Markdown$Block$checkListLine,
				A2(
					$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
					$pablohirafuji$elm_markdown$Markdown$Block$checkThematicBreakLine,
					A2(
						$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
						$pablohirafuji$elm_markdown$Markdown$Block$checkBlockQuote,
						A2(
							$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
							$pablohirafuji$elm_markdown$Markdown$Block$checkATXHeadingLine,
							A2(
								$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
								$pablohirafuji$elm_markdown$Markdown$Block$checkSetextHeadingLine,
								A2(
									$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
									$pablohirafuji$elm_markdown$Markdown$Block$checkOpenCodeFenceLine,
									A2(
										$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
										$pablohirafuji$elm_markdown$Markdown$Block$checkIndentedCode,
										$pablohirafuji$elm_markdown$Markdown$Block$checkBlankLine(
											_Utils_Tuple2(rawLine, ast))))))))));
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkListLine = function (_v16) {
	var rawLine = _v16.a;
	var ast = _v16.b;
	return A2(
		$elm$core$Result$mapError,
		function (e) {
			return _Utils_Tuple2(e, ast);
		},
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_markdown$Markdown$Block$parseListLine, rawLine, ast),
			A2(
				$elm$core$Result$map,
				$pablohirafuji$elm_markdown$Markdown$Block$calcListIndentLength,
				A2(
					$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
					$pablohirafuji$elm_markdown$Markdown$Block$checkUnorderedListLine,
					$pablohirafuji$elm_markdown$Markdown$Block$checkOrderedListLine(rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$parseListLine = F3(
	function (rawLine, ast, _v10) {
		var listBlock = _v10.a;
		var listRawLine = _v10.b;
		var parsedRawLine = A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, listRawLine, _List_Nil);
		var newList = A2(
			$elm$core$List$cons,
			A2(
				$pablohirafuji$elm_markdown$Markdown$Block$List,
				listBlock,
				_List_fromArray(
					[parsedRawLine])),
			ast);
		_v11$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 'List':
						var _v12 = ast.a;
						var model = _v12.a;
						var items = _v12.b;
						var astTail = ast.b;
						return _Utils_eq(listBlock.delimiter, model.delimiter) ? function (a) {
							return A2($elm$core$List$cons, a, astTail);
						}(
							A2(
								$pablohirafuji$elm_markdown$Markdown$Block$List,
								_Utils_update(
									model,
									{
										isLoose: model.isLoose || $pablohirafuji$elm_markdown$Markdown$Block$isBlankLineLast(items),
										indentLength: listBlock.indentLength
									}),
								A2($elm$core$List$cons, parsedRawLine, items))) : newList;
					case 'Paragraph':
						var _v13 = ast.a;
						var rawText = _v13.a;
						var inlines = _v13.b;
						var astTail = ast.b;
						if ((parsedRawLine.b && (parsedRawLine.a.$ === 'BlankLine')) && (!parsedRawLine.b.b)) {
							return A2(
								$elm$core$List$cons,
								A2($pablohirafuji$elm_markdown$Markdown$Block$addToParagraph, rawText, rawLine),
								astTail);
						} else {
							var _v15 = listBlock.type_;
							if (_v15.$ === 'Ordered') {
								if (_v15.a === 1) {
									return newList;
								} else {
									var _int = _v15.a;
									return A2(
										$elm$core$List$cons,
										A2($pablohirafuji$elm_markdown$Markdown$Block$addToParagraph, rawText, rawLine),
										astTail);
								}
							} else {
								return newList;
							}
						}
					default:
						break _v11$2;
				}
			} else {
				break _v11$2;
			}
		}
		return newList;
	});
var $pablohirafuji$elm_markdown$Markdown$Block$checkBlockQuote = function (_v9) {
	var rawLine = _v9.a;
	var ast = _v9.b;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple2(rawLine, ast),
		A2(
			$elm$core$Maybe$map,
			$pablohirafuji$elm_markdown$Markdown$Block$parseBlockQuoteLine(ast),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.submatches;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($elm$core$Maybe$Nothing),
							$elm$core$Maybe$withDefault('')))),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $pablohirafuji$elm_markdown$Markdown$Block$blockQuoteLineRegex, rawLine)))));
};
var $pablohirafuji$elm_markdown$Markdown$Block$incorporateLine = F2(
	function (rawLine, ast) {
		_v5$2:
		while (true) {
			if (ast.b) {
				switch (ast.a.$) {
					case 'CodeBlock':
						if ((ast.a.a.$ === 'Fenced') && ast.a.a.a) {
							var _v6 = ast.a;
							var _v7 = _v6.a;
							var fence = _v7.b;
							var code = _v6.b;
							var astTail = ast.b;
							return function (a) {
								return A2($elm$core$List$cons, a, astTail);
							}(
								A3($pablohirafuji$elm_markdown$Markdown$Block$continueOrCloseCodeFence, fence, code, rawLine));
						} else {
							break _v5$2;
						}
					case 'List':
						var _v8 = ast.a;
						var model = _v8.a;
						var items = _v8.b;
						var astTail = ast.b;
						return (_Utils_cmp(
							$pablohirafuji$elm_markdown$Markdown$Helpers$indentLength(rawLine),
							model.indentLength) > -1) ? A5($pablohirafuji$elm_markdown$Markdown$Block$parseIndentedListLine, rawLine, model, items, ast, astTail) : A2(
							$elm$core$Result$withDefault,
							A2($pablohirafuji$elm_markdown$Markdown$Block$parseTextLine, rawLine, ast),
							A2(
								$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
								$pablohirafuji$elm_markdown$Markdown$Block$checkBlockQuote,
								A2(
									$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
									$pablohirafuji$elm_markdown$Markdown$Block$checkATXHeadingLine,
									A2(
										$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
										$pablohirafuji$elm_markdown$Markdown$Block$checkSetextHeadingLine,
										A2(
											$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
											$pablohirafuji$elm_markdown$Markdown$Block$checkOpenCodeFenceLine,
											A2(
												$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
												$pablohirafuji$elm_markdown$Markdown$Block$checkIndentedCode,
												A2(
													$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
													$pablohirafuji$elm_markdown$Markdown$Block$checkBlankLine,
													A2(
														$pablohirafuji$elm_markdown$Markdown$Helpers$ifError,
														$pablohirafuji$elm_markdown$Markdown$Block$checkListLine,
														$pablohirafuji$elm_markdown$Markdown$Block$checkThematicBreakLine(
															_Utils_Tuple2(rawLine, ast))))))))));
					default:
						break _v5$2;
				}
			} else {
				break _v5$2;
			}
		}
		return A2($pablohirafuji$elm_markdown$Markdown$Block$parseRawLine, rawLine, ast);
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseBlockQuoteLine = F2(
	function (ast, rawLine) {
		if (ast.b && (ast.a.$ === 'BlockQuote')) {
			var bqAST = ast.a.a;
			var astTail = ast.b;
			return function (a) {
				return A2($elm$core$List$cons, a, astTail);
			}(
				$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(
					A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, rawLine, bqAST)));
		} else {
			return function (a) {
				return A2($elm$core$List$cons, a, ast);
			}(
				$pablohirafuji$elm_markdown$Markdown$Block$BlockQuote(
					A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, rawLine, _List_Nil)));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parseIndentedListLine = F5(
	function (rawLine, model, items, ast, astTail) {
		if (!items.b) {
			return function (a) {
				return A2($elm$core$List$cons, a, astTail);
			}(
				A2(
					$pablohirafuji$elm_markdown$Markdown$Block$List,
					model,
					function (a) {
						return A2($elm$core$List$cons, a, _List_Nil);
					}(
						function (a) {
							return A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, a, _List_Nil);
						}(
							A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, model.indentLength, rawLine)))));
		} else {
			var item = items.a;
			var itemsTail = items.b;
			var indentedRawLine = A2($pablohirafuji$elm_markdown$Markdown$Helpers$indentLine, model.indentLength, rawLine);
			var updateList = function (model_) {
				return function (a) {
					return A2($elm$core$List$cons, a, astTail);
				}(
					A2(
						$pablohirafuji$elm_markdown$Markdown$Block$List,
						model_,
						function (a) {
							return A2($elm$core$List$cons, a, itemsTail);
						}(
							A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, indentedRawLine, item))));
			};
			_v1$3:
			while (true) {
				if (item.b) {
					switch (item.a.$) {
						case 'BlankLine':
							if (!item.b.b) {
								return updateList(model);
							} else {
								var itemTail = item.b;
								return A2(
									$elm$core$List$all,
									function (block) {
										if (block.$ === 'BlankLine') {
											return true;
										} else {
											return false;
										}
									},
									itemTail) ? A2($pablohirafuji$elm_markdown$Markdown$Block$parseRawLine, rawLine, ast) : updateList(
									_Utils_update(
										model,
										{isLoose: true}));
							}
						case 'List':
							var _v3 = item.a;
							var model_ = _v3.a;
							var items_ = _v3.b;
							var itemTail = item.b;
							return (_Utils_cmp(
								$pablohirafuji$elm_markdown$Markdown$Helpers$indentLength(indentedRawLine),
								model_.indentLength) > -1) ? updateList(model) : ($pablohirafuji$elm_markdown$Markdown$Block$isBlankLineLast(items_) ? updateList(
								_Utils_update(
									model,
									{isLoose: true})) : updateList(model));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return updateList(model);
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$incorporateLines = F2(
	function (rawLines, ast) {
		if (!rawLines.b) {
			return ast;
		} else {
			var rawLine = rawLines.a;
			var rawLinesTail = rawLines.b;
			return A2(
				$pablohirafuji$elm_markdown$Markdown$Block$incorporateLines,
				rawLinesTail,
				A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLine, rawLine, ast));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$parse = function (maybeOptions) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$lines,
		A2(
			$elm$core$Basics$composeR,
			function (a) {
				return A2($pablohirafuji$elm_markdown$Markdown$Block$incorporateLines, a, _List_Nil);
			},
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_markdown$Markdown$Block$parseReferences($elm$core$Dict$empty),
				A2($pablohirafuji$elm_markdown$Markdown$Block$parseInlines, maybeOptions, true))));
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$em = _VirtualDom_node('em');
var $pablohirafuji$elm_markdown$Markdown$Inline$extractText = function (inlines) {
	return A3($elm$core$List$foldl, $pablohirafuji$elm_markdown$Markdown$Inline$extractTextHelp, '', inlines);
};
var $pablohirafuji$elm_markdown$Markdown$Inline$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 'Text':
				var str = inline.a;
				return _Utils_ap(text, str);
			case 'HardLineBreak':
				return text + ' ';
			case 'CodeInline':
				var str = inline.a;
				return _Utils_ap(text, str);
			case 'Link':
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			case 'Image':
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			case 'HtmlInline':
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			case 'Emphasis':
				var inlines = inline.b;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
			default:
				var inlines = inline.b;
				return _Utils_ap(
					text,
					$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$attributeToAttribute = function (_v0) {
	var name = _v0.a;
	var maybeValue = _v0.b;
	return A2(
		$elm$html$Html$Attributes$attribute,
		name,
		A2($elm$core$Maybe$withDefault, name, maybeValue));
};
var $pablohirafuji$elm_markdown$Markdown$Inline$attributesToHtmlAttributes = $elm$core$List$map($pablohirafuji$elm_markdown$Markdown$Inline$attributeToAttribute);
var $pablohirafuji$elm_markdown$Markdown$Inline$defaultHtml = F2(
	function (customTransformer, inline) {
		var transformer = A2(
			$elm$core$Maybe$withDefault,
			$pablohirafuji$elm_markdown$Markdown$Inline$defaultHtml($elm$core$Maybe$Nothing),
			customTransformer);
		switch (inline.$) {
			case 'Text':
				var str = inline.a;
				return $elm$html$Html$text(str);
			case 'HardLineBreak':
				return A2($elm$html$Html$br, _List_Nil, _List_Nil);
			case 'CodeInline':
				var codeStr = inline.a;
				return A2(
					$elm$html$Html$code,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(codeStr)
						]));
			case 'Link':
				var url = inline.a;
				var maybeTitle = inline.b;
				var inlines = inline.c;
				if (maybeTitle.$ === 'Just') {
					var title_ = maybeTitle.a;
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$title(title_)
							]),
						A2($elm$core$List$map, transformer, inlines));
				} else {
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url)
							]),
						A2($elm$core$List$map, transformer, inlines));
				}
			case 'Image':
				var url = inline.a;
				var maybeTitle = inline.b;
				var inlines = inline.c;
				if (maybeTitle.$ === 'Just') {
					var title_ = maybeTitle.a;
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$alt(
								$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines)),
								$elm$html$Html$Attributes$src(url),
								$elm$html$Html$Attributes$title(title_)
							]),
						_List_Nil);
				} else {
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$alt(
								$pablohirafuji$elm_markdown$Markdown$Inline$extractText(inlines)),
								$elm$html$Html$Attributes$src(url)
							]),
						_List_Nil);
				}
			case 'HtmlInline':
				var tag = inline.a;
				var attrs = inline.b;
				var inlines = inline.c;
				return A3(
					$elm$html$Html$node,
					tag,
					$pablohirafuji$elm_markdown$Markdown$Inline$attributesToHtmlAttributes(attrs),
					A2($elm$core$List$map, transformer, inlines));
			case 'Emphasis':
				var length = inline.a;
				var inlines = inline.b;
				switch (length) {
					case 1:
						return A2(
							$elm$html$Html$em,
							_List_Nil,
							A2($elm$core$List$map, transformer, inlines));
					case 2:
						return A2(
							$elm$html$Html$strong,
							_List_Nil,
							A2($elm$core$List$map, transformer, inlines));
					default:
						return ((length - 2) > 0) ? A2(
							$elm$html$Html$strong,
							_List_Nil,
							function (a) {
								return A2($elm$core$List$cons, a, _List_Nil);
							}(
								transformer(
									A2($pablohirafuji$elm_markdown$Markdown$Inline$Emphasis, length - 2, inlines)))) : A2(
							$elm$html$Html$em,
							_List_Nil,
							A2($elm$core$List$map, transformer, inlines));
				}
			default:
				var inlines = inline.b;
				return $elm$html$Html$text('');
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Inline$toHtml = $pablohirafuji$elm_markdown$Markdown$Inline$defaultHtml($elm$core$Maybe$Nothing);
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $pablohirafuji$elm_markdown$Markdown$Block$defaultHtml = F3(
	function (customHtml, customInlineHtml, block) {
		var inlineToHtml = A2($elm$core$Maybe$withDefault, $pablohirafuji$elm_markdown$Markdown$Inline$toHtml, customInlineHtml);
		var blockToHtml = A2(
			$elm$core$Maybe$withDefault,
			A2($pablohirafuji$elm_markdown$Markdown$Block$defaultHtml, $elm$core$Maybe$Nothing, customInlineHtml),
			customHtml);
		switch (block.$) {
			case 'BlankLine':
				return _List_Nil;
			case 'Heading':
				var level = block.b;
				var inlines = block.c;
				var hElement = function () {
					switch (level) {
						case 1:
							return $elm$html$Html$h1(_List_Nil);
						case 2:
							return $elm$html$Html$h2(_List_Nil);
						case 3:
							return $elm$html$Html$h3(_List_Nil);
						case 4:
							return $elm$html$Html$h4(_List_Nil);
						case 5:
							return $elm$html$Html$h5(_List_Nil);
						default:
							return $elm$html$Html$h6(_List_Nil);
					}
				}();
				return _List_fromArray(
					[
						hElement(
						A2($elm$core$List$map, inlineToHtml, inlines))
					]);
			case 'ThematicBreak':
				return _List_fromArray(
					[
						A2($elm$html$Html$hr, _List_Nil, _List_Nil)
					]);
			case 'Paragraph':
				var inlines = block.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						A2($elm$core$List$map, inlineToHtml, inlines))
					]);
			case 'CodeBlock':
				if (block.a.$ === 'Fenced') {
					var _v2 = block.a;
					var model = _v2.b;
					var codeStr = block.b;
					var basicView = function (attrs) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$pre,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$code,
										attrs,
										_List_fromArray(
											[
												$elm$html$Html$text(codeStr)
											]))
									]))
							]);
					};
					var _v3 = model.language;
					if (_v3.$ === 'Just') {
						var language = _v3.a;
						return basicView(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-' + language)
								]));
					} else {
						return basicView(_List_Nil);
					}
				} else {
					var _v4 = block.a;
					var codeStr = block.b;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$pre,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$code,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(codeStr)
										]))
								]))
						]);
				}
			case 'BlockQuote':
				var blocks = block.a;
				return function (a) {
					return A2($elm$core$List$cons, a, _List_Nil);
				}(
					A2(
						$elm$html$Html$blockquote,
						_List_Nil,
						$elm$core$List$concat(
							A2($elm$core$List$map, blockToHtml, blocks))));
			case 'List':
				var model = block.a;
				var items = block.b;
				return function (a) {
					return A2($elm$core$List$cons, a, _List_Nil);
				}(
					function () {
						var _v5 = model.type_;
						if (_v5.$ === 'Ordered') {
							var startInt = _v5.a;
							return (startInt === 1) ? $elm$html$Html$ol(_List_Nil) : $elm$html$Html$ol(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$start(startInt)
									]));
						} else {
							return $elm$html$Html$ul(_List_Nil);
						}
					}()(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(blockToHtml),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$concat,
									$elm$html$Html$li(_List_Nil))),
							items)));
			case 'PlainInlines':
				var inlines = block.a;
				return A2($elm$core$List$map, inlineToHtml, inlines);
			default:
				var customBlock = block.a;
				var blocks = block.b;
				return function (a) {
					return A2($elm$core$List$cons, a, _List_Nil);
				}(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$text('Unhandled custom block.'),
							$elm$core$List$concat(
								A2($elm$core$List$map, blockToHtml, blocks)))));
		}
	});
var $pablohirafuji$elm_markdown$Markdown$Block$toHtml = A2($pablohirafuji$elm_markdown$Markdown$Block$defaultHtml, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $pablohirafuji$elm_markdown$Markdown$toHtml = F2(
	function (maybeOptions, rawText) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$pablohirafuji$elm_markdown$Markdown$Block$toHtml,
				A2($pablohirafuji$elm_markdown$Markdown$Block$parse, maybeOptions, rawText)));
	});
var $author$project$LatestLegal$Main$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('main'),
				A2($elm$html$Html$Attributes$style, 'padding', '0')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-legal')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$TitleBar$render(
								$author$project$PinMeTo$Ui$TitleBar$pmtTitleBar(model.displayName)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-legal__content')
									]),
								A2($pablohirafuji$elm_markdown$Markdown$toHtml, $elm$core$Maybe$Nothing, model.text))
							]))
					]))
			]));
};
var $author$project$LatestLegal$Main$update = F2(
	function (msg, model) {
		if (msg.a.$ === 'Ok') {
			var newModel = msg.a.a;
			return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{text: '__Something went wrong fetching the document__'}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$LatestLegal$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$LatestLegal$Main$init,
		view: $author$project$LatestLegal$Main$view,
		update: $author$project$LatestLegal$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$DashboardV2$Model$NetworkConnection = F6(
	function (connected, customerCanEnable, enabled, needsAction, networkKey, filterKey) {
		return {enabled: enabled, connected: connected, filterKey: filterKey, networkKey: networkKey, needsAction: needsAction, customerCanEnable: customerCanEnable};
	});
var $author$project$DashboardV2$Model$LocationId = function (a) {
	return {$: 'LocationId', a: a};
};
var $author$project$DashboardV2$Decoders$locationIdDecoder = A2($elm$json$Json$Decode$map, $author$project$DashboardV2$Model$LocationId, $elm$json$Json$Decode$string);
var $author$project$DashboardV2$Decoders$decodeConnection = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['networkDetails', 'filterKey']),
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'networkKey',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['networkDetails', 'needsActionLocationList']),
			$elm$json$Json$Decode$list($author$project$DashboardV2$Decoders$locationIdDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enabled',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'customerCanEnable',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'isConnected',
						$elm$json$Json$Decode$bool,
						false,
						$elm$json$Json$Decode$succeed($author$project$DashboardV2$Model$NetworkConnection)))))));
var $author$project$DashboardV2$Commands$getNetworkData = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					$elm$json$Json$Decode$list($author$project$DashboardV2$Decoders$decodeConnection),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/network/networkConnections'))));
	});
var $author$project$PinMeTo$Common$Tour$Tour$Top = {$: 'Top'};
var $author$project$PinMeTo$Common$Tour$Tour$Left = {$: 'Left'};
var $author$project$Tours$DashboardV2Tour$endDate = '2025-09-01';
var $author$project$Tours$DashboardV2Tour$startDate = '2025-07-06';
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardTourConfirm = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_tour_confirm');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepOne = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_title_step_one');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_title_step_two');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepFive = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_title_step_five');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepFour = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_title_step_four');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepThree = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_title_step_three');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepOne = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_description_step_one');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepTwo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_description_step_two');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepFive = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_description_step_five');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepFour = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_description_step_four');
};
var $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepThree = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tour.dashboard_tour.dashboard_description_step_three');
};
var $author$project$Tours$DashboardV2Tour$dashboardV2Tour = function (translations) {
	return {
		id: 'dashboard-overview-detail',
		steps: _List_fromArray(
			[
				{
				arrow: false,
				title: $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepOne(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Just('img/tour/dashboard_hero.png'),
				placement: $author$project$PinMeTo$Common$Tour$Tour$LeftStart,
				description: $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepOne(translations),
				targetElementQuery: 'body > ui-view > pmt-site-dir > div > pmt-elm > div > div.pmt-global-sidebar > div > div > ul > li:nth-child(1)'
			},
				{
				arrow: false,
				title: $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepTwo(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$Top,
				description: $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepTwo(translations),
				targetElementQuery: 'body > ui-view > pmt-site-dir > div > main > div:nth-child(2) > ui-view > pmt-elm > div > div.pmt-dashboard > div.pmt-dashboard__highlight__container'
			},
				{
				arrow: false,
				title: $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepThree(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$Left,
				description: $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepThree(translations),
				targetElementQuery: 'body > ui-view > pmt-site-dir > div > main > div:nth-child(2) > ui-view > pmt-elm > div > div.pmt-dashboard > div.pmt-dashboard__insights__container > div:nth-child(3)'
			},
				{
				arrow: false,
				title: $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepFour(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$Left,
				description: $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepFour(translations),
				targetElementQuery: 'body > ui-view > pmt-site-dir > div > main > div:nth-child(2) > ui-view > pmt-elm > div > div.pmt-dashboard > div.pmt-dashboard__insights__container > div:nth-child(2)'
			},
				{
				arrow: false,
				title: $author$project$Translations$Listings$Tour$DashboardTour$dashboardTitleStepFive(translations),
				classes: _List_fromArray(
					['']),
				mediaUrl: $elm$core$Maybe$Nothing,
				placement: $author$project$PinMeTo$Common$Tour$Tour$Right,
				description: $author$project$Translations$Listings$Tour$DashboardTour$dashboardDescriptionStepFive(translations),
				targetElementQuery: 'body > ui-view > pmt-site-dir > div > main > div:nth-child(2) > ui-view > pmt-elm > div > div.pmt-dashboard > div.pmt-dashboard__insights__container > div:nth-child(1)'
			}
			]),
		endDate: $author$project$Tours$DashboardV2Tour$endDate,
		startDate: $author$project$Tours$DashboardV2Tour$startDate,
		useModalOverlay: true,
		confirmButtonUrl: $elm$core$Maybe$Nothing,
		requiresTourSeen: $elm$core$Maybe$Nothing,
		showStepProgress: true,
		confirmButtonLabel: $author$project$Translations$Listings$Tour$DashboardTour$dashboardTourConfirm(translations),
		requiresTourNotSeen: $elm$core$Maybe$Nothing
	};
};
var $author$project$DashboardV2$Model$DataCompletenessMsg = function (a) {
	return {$: 'DataCompletenessMsg', a: a};
};
var $author$project$DashboardV2$Commands$getNumberOfConflicts = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$DashboardV2$Decoders$decodeNumberOfConflicts, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/conflicts/total'))));
	});
var $author$project$DashboardV2$Decoders$decodeNumberOfLocations = A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$int);
var $author$project$DashboardV2$Commands$getNumberOfLocations = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$DashboardV2$Decoders$decodeNumberOfLocations, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/count'))));
	});
var $author$project$DashboardV2$Model$OnNetworkDataResponse = function (a) {
	return {$: 'OnNetworkDataResponse', a: a};
};
var $author$project$DashboardV2$Commands$urlAppend = $author$project$Util$flip($elm$core$Basics$append);
var $author$project$DashboardV2$Commands$getQueryParams = function (range) {
	var from = $justinmimbs$date$Date$toIsoString(range.from);
	var to = $justinmimbs$date$Date$toIsoString(range.to);
	return '?from=' + (from + ('&to=' + to));
};
var $author$project$DashboardV2$Model$DetailedRatingStats = F7(
	function (answered, unanswered, oneStar, twoStar, threeStar, fourStar, fiveStar) {
		return {oneStar: oneStar, twoStar: twoStar, answered: answered, fiveStar: fiveStar, fourStar: fourStar, threeStar: threeStar, unanswered: unanswered};
	});
var $author$project$DashboardV2$Decoders$detailedRatingStatsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fiveStar',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fourStar',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'threeStar',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'twoStar',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'oneStar',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'unAnswered',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'answered',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$DashboardV2$Model$DetailedRatingStats))))))));
var $author$project$DashboardV2$Commands$getDetailedRatingStats = F3(
	function (model, _v0, msg) {
		var siteName = _v0.a;
		var url = A2(
			$author$project$DashboardV2$Commands$urlAppend,
			$author$project$DashboardV2$Commands$getQueryParams(model.insightsDateRange),
			A2(
				$author$project$DashboardV2$Commands$urlAppend,
				'/metrics/detailedRatings',
				A2(
					$author$project$DashboardV2$Commands$urlAppend,
					'/locations',
					A2(
						$author$project$DashboardV2$Commands$urlAppend,
						'/rating',
						A2(
							$author$project$DashboardV2$Commands$urlAppend,
							siteName,
							$elm$url$Url$toString(model.insightsUrl))))));
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$DashboardV2$Decoders$detailedRatingStatsDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$post(url))));
	});
var $author$project$DashboardV2$Commands$getUnreviewedMediaCount = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'unreviewedMediaCount', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/network-media-assets/unreviewed-count'))));
	});
var $author$project$DashboardV2$Model$OnNumberOfConflictsResponse = function (a) {
	return {$: 'OnNumberOfConflictsResponse', a: a};
};
var $author$project$DashboardV2$Model$OnNumberOfLocationsResponse = function (a) {
	return {$: 'OnNumberOfLocationsResponse', a: a};
};
var $author$project$DashboardV2$Commands$getNumberOfLocationsToVerify = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/unverified/count')))));
	});
var $author$project$DashboardV2$Model$OnDetailedRatingStatsResponse = function (a) {
	return {$: 'OnDetailedRatingStatsResponse', a: a};
};
var $author$project$DashboardV2$Commands$getFacebookBrandPageConflicts = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/facebook/conflict/brandpage/status'))));
	});
var $author$project$DashboardV2$Model$OnUnreviewedMediaCountResponse = function (a) {
	return {$: 'OnUnreviewedMediaCountResponse', a: a};
};
var $author$project$DashboardV2$Model$OnListingsManagerPoliciesEnabled = function (a) {
	return {$: 'OnListingsManagerPoliciesEnabled', a: a};
};
var $author$project$DashboardV2$Commands$getTotalPendingImageAssociations = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/media/approval/count'))));
	});
var $author$project$DashboardV2$Model$OnNumberOfLocationsToVerifyResponse = function (a) {
	return {$: 'OnNumberOfLocationsToVerifyResponse', a: a};
};
var $author$project$DashboardV2$Model$OnFacebookBrandPageConflictsResponse = function (a) {
	return {$: 'OnFacebookBrandPageConflictsResponse', a: a};
};
var $author$project$DashboardV2$Commands$getNumberOfLocationsWithPendingChanges = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3(
					$author$project$PinMeTo$ExpectJson$expectJson,
					msg,
					A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$withCredentials(
					$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/places/apipendingchanges/count')))));
	});
var $author$project$DashboardV2$Model$OnTotalPendingImageAssociationsResponse = function (a) {
	return {$: 'OnTotalPendingImageAssociationsResponse', a: a};
};
var $author$project$DashboardV2$Model$OnNumberOfLocationsWithPendingChangesResponse = function (a) {
	return {$: 'OnNumberOfLocationsWithPendingChangesResponse', a: a};
};
var $author$project$DashboardV2$Main$init = F2(
	function (session, flags) {
		var _v0 = $author$project$DataCompletenessV2$Dashboard$init(flags.account);
		var dataCompletenessModel = _v0.a;
		var dataCompletenessCmd = _v0.b;
		var _v1 = A2($author$project$Data$User$hasRole, session.user, $author$project$Data$User$Owner) ? _Utils_Tuple2(
			$author$project$RemoteData$Loading,
			A2($author$project$DashboardV2$Commands$getFacebookBrandPageConflicts, session.siteName, $author$project$DashboardV2$Model$OnFacebookBrandPageConflictsResponse)) : _Utils_Tuple2(
			$author$project$RemoteData$Loaded(0),
			$elm$core$Platform$Cmd$none);
		var brandPageConflicts = _v1.a;
		var brandPageCommand = _v1.b;
		var dashboardTourCmd = A2(
			$author$project$PinMeTo$Common$Tour$Tour$startTour,
			$author$project$Labels$tourLabels(session.translations),
			$author$project$Tours$DashboardV2Tour$dashboardV2Tour(session.translations));
		var model = {
			today: flags.today,
			account: flags.account,
			uiTooltip: $author$project$PinMeTo$Ui$AdvancedTooltip$init,
			apiEnabled: flags.apiEnabled,
			insightsUrl: flags.insightsUrl,
			popOverState: $author$project$PinMeTo$Ui$PopOver$init,
			dataCompleteness: dataCompletenessModel,
			insightsDateRange: A2($author$project$PinMeTo$Ui$DateRangePicker$rangeFromDaysBack, flags.today, 30),
			numberOfConflicts: $author$project$RemoteData$Loading,
			numberOfLocations: $author$project$RemoteData$Loading,
			mediaReviewEnabled: flags.mediaReviewEnabled,
			detailedRatingStats: $author$project$RemoteData$Loading,
			networksConnections: $author$project$RemoteData$Loading,
			unreviewedMediaCount: $author$project$RemoteData$Loading,
			numberOfLocationsToVerify: $author$project$RemoteData$Loading,
			facebookBrandPageConflicts: brandPageConflicts,
			totalPendingImageAssociations: $author$project$RemoteData$Loading,
			listingsManagerPoliciesEnabled: $author$project$RemoteData$Loading,
			numberOfLocationsWithPendingChanges: $author$project$RemoteData$Loading
		};
		var initialCommands = _List_fromArray(
			[
				A3($author$project$DashboardV2$Commands$getDetailedRatingStats, model, session.siteName, $author$project$DashboardV2$Model$OnDetailedRatingStatsResponse),
				A2($author$project$DashboardV2$Commands$getNumberOfLocations, session.siteName, $author$project$DashboardV2$Model$OnNumberOfLocationsResponse),
				A2($author$project$DashboardV2$Commands$getNetworkData, session.siteName, $author$project$DashboardV2$Model$OnNetworkDataResponse),
				A2($author$project$DashboardV2$Commands$getNumberOfConflicts, session.siteName, $author$project$DashboardV2$Model$OnNumberOfConflictsResponse),
				brandPageCommand,
				A2($author$project$DashboardV2$Commands$getTotalPendingImageAssociations, session.siteName, $author$project$DashboardV2$Model$OnTotalPendingImageAssociationsResponse),
				A2($author$project$DashboardV2$Commands$getNumberOfLocationsWithPendingChanges, session.siteName, $author$project$DashboardV2$Model$OnNumberOfLocationsWithPendingChangesResponse),
				A2($author$project$DashboardV2$Commands$getNumberOfLocationsToVerify, session.siteName, $author$project$DashboardV2$Model$OnNumberOfLocationsToVerifyResponse),
				A2($author$project$DashboardV2$Commands$getUnreviewedMediaCount, session.siteName, $author$project$DashboardV2$Model$OnUnreviewedMediaCountResponse),
				A2($author$project$Conflicts$Commands$getListingsManagerPoliciesEnabled, session.siteName, $author$project$DashboardV2$Model$OnListingsManagerPoliciesEnabled),
				A2($elm$core$Platform$Cmd$map, $author$project$DashboardV2$Model$DataCompletenessMsg, dataCompletenessCmd),
				dashboardTourCmd
			]);
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(initialCommands));
	});
var $author$project$Translations$Listings$Dashboard$goToDataCompleteness = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.go_to_data_completeness');
};
var $author$project$DataCompletenessV2$Dashboard$View$view = F3(
	function (account, model, translations) {
		var trackingDetails = {info: '', action: $author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToDataCompleteness};
		var siteName_ = $author$project$Data$SiteName$toString(account.name);
		var linkElement = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/listings/' + (siteName_ + '/dataCompleteness')),
					$elm$html$Html$Attributes$class('pmt-dashboard__card__link'),
					$elm$html$Html$Events$onClick(
					$author$project$DataCompletenessV2$Dashboard$Update$LinkClicked(trackingDetails))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$Listings$Dashboard$goToDataCompleteness(translations))
				]));
		return A5(
			$author$project$DataCompletenessV2$Dashboard$View$renderCard,
			model,
			translations,
			$author$project$Translations$Listings$DataCompleteness$title(translations),
			true,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-dashboard__card-with-link-content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-dashboard__gauge')
							]),
						_List_fromArray(
							[
								$author$project$DataCompletenessV2$Dashboard$View$renderDonutChart(model)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-summary pmt-conflict-dashboard__fields'),
								A2($elm$html$Html$Attributes$style, 'grid-gap', '0.8rem 1rem')
							]),
						A4(
							$author$project$DataCompletenessV2$Dashboard$View$renderFieldsList,
							$elm$core$Maybe$Just(4),
							model,
							account,
							translations)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-dashboard__gauge__link-container')
							]),
						_List_fromArray(
							[linkElement]))
					])));
	});
var $author$project$DashboardV2$Model$Low = {$: 'Low'};
var $author$project$DashboardV2$Model$High = {$: 'High'};
var $author$project$DashboardV2$Model$Medium = {$: 'Medium'};
var $author$project$DashboardV2$Model$Urgent = {$: 'Urgent'};
var $author$project$DashboardV2$Model$Blocker = {$: 'Blocker'};
var $author$project$DashboardV2$Model$Critical = {$: 'Critical'};
var $author$project$DashboardV2$Utils$todoOrder = F2(
	function (a, b) {
		var priorityRank = function (prio) {
			switch (prio.$) {
				case 'Blocker':
					return -1;
				case 'Critical':
					return 0;
				case 'Urgent':
					return 1;
				case 'High':
					return 2;
				case 'Medium':
					return 3;
				case 'Low':
					return 4;
				default:
					return 5;
			}
		};
		return A2(
			$elm$core$Basics$compare,
			priorityRank(a.prio),
			priorityRank(b.prio));
	});
var $author$project$Translations$Listings$Dashboard$reviewUnreviewedMedia = F2(
	function (translations, count) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.dashboard.review_unreviewed_media',
			_List_fromArray(
				[
					_Utils_Tuple2('count', count)
				]));
	});
var $author$project$DashboardV2$View$getLocationListFilterUrl = F3(
	function (_v0, needsActionList, filterKey) {
		var siteName = _v0.a;
		var getLocationIds = A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$map,
				function (_v1) {
					var x = _v1.a;
					return '\u0022' + (x + '\u0022');
				},
				needsActionList));
		var unshortenedFilter = '%7B\u0022filterDefinition\u0022:%5B%7B\u0022property\u0022:\u0022locations\u0022,\u0022value\u0022:%5B' + (getLocationIds + ('%5D%7D%5D%7D' + '&openFilterOnLoad=true'));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					'/listings/',
					siteName,
					'/locations',
					'?filter=',
					A2($elm$core$Maybe$withDefault, unshortenedFilter, filterKey)
				]));
	});
var $author$project$DashboardV2$View$getAllTodos = F2(
	function (session, model) {
		var networkNeedsAction = function (networkKey) {
			return A2(
				$elm$core$Maybe$andThen,
				function (networksConnections) {
					return A2(
						$elm$core$Maybe$andThen,
						function (network) {
							if (($elm$core$List$length(network.needsAction) > 0) && network.enabled) {
								var uppercaseNetworkKey = $author$project$Util$capitalize(networkKey);
								var _v1 = function () {
									switch (networkKey) {
										case 'google':
											return _Utils_Tuple2($author$project$DashboardV2$Model$Critical, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksGoogleListingsWithIssues);
										case 'apple':
											return _Utils_Tuple2($author$project$DashboardV2$Model$Urgent, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksAppleListingsWithIssues);
										case 'ptv':
											return _Utils_Tuple2($author$project$DashboardV2$Model$High, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksPtvListingsWithIssues);
										default:
											return _Utils_Tuple2($author$project$DashboardV2$Model$High, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksFacebookListingsWithIssues);
									}
								}();
								var priority = _v1.a;
								var trackingKey = _v1.b;
								var number = $elm$core$List$length(network.needsAction);
								return $elm$core$Maybe$Just(
									{
										desc: uppercaseNetworkKey + (': ' + A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.dashboard.network_issues_todo', number)),
										href: A3($author$project$DashboardV2$View$getLocationListFilterUrl, session.siteName, network.needsAction, network.filterKey),
										prio: priority,
										tracking: trackingKey
									});
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (network) {
								return _Utils_eq(network.networkKey, networkKey);
							},
							networksConnections));
				},
				$author$project$RemoteData$currentData(model.networksConnections));
		};
		var _v0 = session.siteName;
		var siteName = _v0.a;
		var unreviewedMedia = A2(
			$elm$core$Maybe$andThen,
			function (unreviewedMediaCount) {
				return (model.mediaReviewEnabled && (unreviewedMediaCount > 0)) ? $elm$core$Maybe$Just(
					{
						desc: function (count) {
							return A2($author$project$Translations$Listings$Dashboard$reviewUnreviewedMedia, session.translations, count);
						}(
							$author$project$Common$Math$formatNumber(unreviewedMediaCount)),
						href: '/listings/' + (siteName + '/mediareview'),
						prio: $author$project$DashboardV2$Model$Low,
						tracking: $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksNewMedia
					}) : $elm$core$Maybe$Nothing;
			},
			$author$project$RemoteData$currentData(model.unreviewedMediaCount));
		var locationsToVerify = A2(
			$elm$core$Maybe$andThen,
			function (numberOfLocationsToVerify) {
				return (numberOfLocationsToVerify > 0) ? $elm$core$Maybe$Just(
					{
						desc: A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.dashboard.verify_locations', numberOfLocationsToVerify),
						href: '/listings/' + (siteName + '/locations/verify'),
						prio: $author$project$DashboardV2$Model$Blocker,
						tracking: $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksVerifyAddresses
					}) : $elm$core$Maybe$Nothing;
			},
			$author$project$RemoteData$currentData(model.numberOfLocationsToVerify));
		var pendingApiChanges = A2(
			$elm$core$Maybe$andThen,
			function (numberOfLocationsWithPendingChanges) {
				return (model.apiEnabled && (numberOfLocationsWithPendingChanges > 0)) ? $elm$core$Maybe$Just(
					{
						desc: A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.dashboard.review_pending_api_change', numberOfLocationsWithPendingChanges),
						href: '/listings/' + (siteName + '/apisettings/pendingchanges'),
						prio: $author$project$DashboardV2$Model$Medium,
						tracking: $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksAPIAddressDifferences
					}) : $elm$core$Maybe$Nothing;
			},
			$author$project$RemoteData$currentData(model.numberOfLocationsWithPendingChanges));
		var pendingImageAssociations = A2(
			$elm$core$Maybe$andThen,
			function (totalPendingImageAssociations) {
				return (model.apiEnabled && (totalPendingImageAssociations > 0)) ? $elm$core$Maybe$Just(
					{
						desc: A3($author$project$PinMeToPage$translatePluralValue, session, 'listings.dashboard.review_pending_image_association', totalPendingImageAssociations),
						href: '/listings/' + (siteName + '/media/approval'),
						prio: $author$project$DashboardV2$Model$Medium,
						tracking: $author$project$PlanHat$TrackingActions$keys.listingsDashboard.tasksAPIMedia
					}) : $elm$core$Maybe$Nothing;
			},
			$author$project$RemoteData$currentData(model.totalPendingImageAssociations));
		var todos = A2(
			$elm$core$List$sortWith,
			$author$project$DashboardV2$Utils$todoOrder,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						pendingImageAssociations,
						pendingApiChanges,
						unreviewedMedia,
						networkNeedsAction('google'),
						networkNeedsAction('apple'),
						networkNeedsAction('facebook'),
						networkNeedsAction('ptv'),
						locationsToVerify
					])));
		return todos;
	});
var $author$project$Translations$Listings$Dashboard$toDo = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.to_do');
};
var $author$project$DashboardV2$View$skellify = F3(
	function (isLoading, attributes, child) {
		return $author$project$PinMeTo$Ui$Skeleton$view(
			{
				shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
				children: _List_fromArray(
					[child]),
				isLoading: isLoading,
				attributes: attributes
			});
	});
var $author$project$DashboardV2$Model$UiTooltipMsg = function (a) {
	return {$: 'UiTooltipMsg', a: a};
};
var $author$project$DashboardV2$Model$OnLinkClicked = function (a) {
	return {$: 'OnLinkClicked', a: a};
};
var $author$project$FontAwesome$Light$Icon$faClipboardList = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-clipboard-list');
var $author$project$Translations$Listings$Dashboard$noTasksRightNow = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.no_tasks_right_now');
};
var $author$project$Translations$Listings$Dashboard$youAreAllCaughtUp = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.you_are_all_caught_up');
};
var $author$project$DashboardV2$View$renderToDoList = F4(
	function (session, isLoading, tooltipState, todos) {
		var renderTodo = function (todo) {
			var conditionalClassList = $elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'pmt-dashboard__red-border',
						_Utils_eq(todo.prio, $author$project$DashboardV2$Model$Blocker)),
						_Utils_Tuple2('pmt-dashboard__todo', true)
					]));
			var className = function () {
				var _v0 = todo.prio;
				switch (_v0.$) {
					case 'Blocker':
						return 'pmt-dashboard__todo--high';
					case 'Critical':
						return 'pmt-dashboard__todo--high';
					case 'Urgent':
						return 'pmt-dashboard__todo--high';
					case 'High':
						return 'pmt-dashboard__todo--high';
					case 'Medium':
						return 'pmt-dashboard__todo--medium';
					case 'Low':
						return 'pmt-dashboard__todo--low';
					default:
						return 'pmt-dashboard__todo--info';
				}
			}();
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(todo.href),
						$elm$html$Html$Events$onClick(
						$author$project$DashboardV2$Model$OnLinkClicked(todo.tracking))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$DashboardV2$View$skellify,
						isLoading,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-dashboard__rounded-border')
							]),
						A5(
							$author$project$PinMeTo$Ui$AdvancedTooltip$render,
							tooltipState,
							$author$project$PinMeTo$Ui$AdvancedTooltip$view(
								{
									uid: 'todo-tooltip-' + todo.href,
									tagger: $author$project$DashboardV2$Model$UiTooltipMsg,
									content: _List_fromArray(
										[
											$elm$html$Html$text(todo.desc)
										]),
									preferredDirection: $author$project$PinMeTo$Ui$AdvancedTooltip$LeftCenter
								}),
							$elm$html$Html$li,
							_List_fromArray(
								[conditionalClassList]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(className),
											$elm$html$Html$Attributes$class('pmt-dashboard__todo__icon')
										]),
									_List_fromArray(
										[
											$author$project$FontAwesome$render(
											$author$project$FontAwesome$solid($author$project$FontAwesome$Solid$Icon$faCircle))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-dashboard__todo__desc')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(todo.desc)
										]))
								])))
					]));
		};
		var emptyState = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__todo'),
					$elm$html$Html$Attributes$class('pmt-dashboard__todo__empty-state')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__todo__empty-state--header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Dashboard$youAreAllCaughtUp(session.translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__todo__empty-state--content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Dashboard$noTasksRightNow(session.translations))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__todos-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-dashboard__todos-title')
								]),
							_List_fromArray(
								[
									$author$project$FontAwesome$render(
									$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faClipboardList)),
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Translations$Listings$Dashboard$toDo(session.translations))
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-dashboard__todos-tasks')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$DashboardV2$View$skellify,
									isLoading,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-dashboard__rounded-border')
										]),
									$elm$html$Html$text(
										A3(
											$author$project$PinMeToPage$translatePluralValue,
											session,
											'listings.dashboard.count_tasks',
											$elm$core$List$length(todos))))
								]))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__todos')
						]),
					$elm$core$List$isEmpty(todos) ? _List_fromArray(
						[emptyState]) : A2($elm$core$List$map, renderTodo, todos))
				]));
	});
var $author$project$DashboardV2$Utils$isRemoteDataLoading = function (remoteData) {
	if (remoteData.$ === 'Loading') {
		return true;
	} else {
		return false;
	}
};
var $author$project$PinMeTo$Ui$Card$withBackgroundColor = F2(
	function (color, _v0) {
		var config = _v0.a;
		return $author$project$PinMeTo$Ui$Card$View(
			_Utils_update(
				config,
				{
					backgroundColor: $elm$core$Maybe$Just(color)
				}));
	});
var $author$project$DashboardV2$View$renderTodosSkeleton = function (session) {
	var dummyTodo = {desc: '', href: '#', prio: $author$project$DashboardV2$Model$Medium, tracking: ''};
	var dummyTodos = A2($elm$core$List$repeat, 5, dummyTodo);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pmt-dashboard__todos-card-container')
			]),
		_List_fromArray(
			[
				$author$project$PinMeTo$Ui$Card$render(
				A2(
					$author$project$PinMeTo$Ui$Card$withSeparator,
					false,
					A2(
						$author$project$PinMeTo$Ui$Card$withBackgroundColor,
						'#F2F2F2',
						$author$project$PinMeTo$Ui$Card$view(
							A4($author$project$DashboardV2$View$renderToDoList, session, true, $author$project$PinMeTo$Ui$AdvancedTooltip$init, dummyTodos)))))
			]));
};
var $author$project$DashboardV2$View$renderTodoCard = F2(
	function (session, model) {
		var anyTodoLoading = $author$project$DashboardV2$Utils$isRemoteDataLoading(model.totalPendingImageAssociations) || ($author$project$DashboardV2$Utils$isRemoteDataLoading(model.numberOfLocationsWithPendingChanges) || ($author$project$DashboardV2$Utils$isRemoteDataLoading(model.numberOfConflicts) || ($author$project$DashboardV2$Utils$isRemoteDataLoading(model.numberOfLocationsToVerify) || $author$project$DashboardV2$Utils$isRemoteDataLoading(model.networksConnections))));
		return anyTodoLoading ? $author$project$DashboardV2$View$renderTodosSkeleton(session) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__todos-card-container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Card$render(
					A2(
						$author$project$PinMeTo$Ui$Card$withSeparator,
						false,
						A2(
							$author$project$PinMeTo$Ui$Card$withBackgroundColor,
							'#F2F2F2',
							$author$project$PinMeTo$Ui$Card$view(
								A4(
									$author$project$DashboardV2$View$renderToDoList,
									session,
									false,
									model.uiTooltip,
									A2($author$project$DashboardV2$View$getAllTodos, session, model))))))
				]));
	});
var $author$project$Translations$Listings$Dashboard$noReviews = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.no_reviews');
};
var $author$project$Translations$Listings$Dashboard$goToRatings = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.go_to_ratings');
};
var $author$project$Translations$Listings$Dashboard$ratingsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.ratings_title');
};
var $author$project$PinMeTo$Ui$Chart$Legend$PositionBottom = {$: 'PositionBottom'};
var $author$project$PinMeTo$Ui$Chart$Legend$withPositionBottom = function (_v0) {
	var config = _v0.a;
	return $author$project$PinMeTo$Ui$Chart$Legend$Legend(
		_Utils_update(
			config,
			{position: $author$project$PinMeTo$Ui$Chart$Legend$PositionBottom}));
};
var $author$project$DashboardV2$View$renderDonutChart = F2(
	function (session, datasets) {
		return $author$project$PinMeTo$Ui$Chart$render(
			A2(
				$author$project$PinMeTo$Ui$Chart$withLocale,
				session.locale,
				A2(
					$author$project$PinMeTo$Ui$Chart$withLegendConfig,
					A2($elm$core$Basics$composeR, $author$project$PinMeTo$Ui$Chart$Legend$withTotal, $author$project$PinMeTo$Ui$Chart$Legend$withPositionBottom),
					$author$project$PinMeTo$Ui$Chart$view(
						{
							chart: $author$project$PinMeTo$Ui$Chart$Doughnut(datasets)
						}))));
	});
var $author$project$Translations$Listings$Dashboard$ratingAverageNote = F2(
	function (translations, totalReviews) {
		return A4(
			$ChristophP$elm_i18next$I18Next$tr,
			translations,
			$ChristophP$elm_i18next$I18Next$Curly,
			'listings.dashboard.rating_average_note',
			_List_fromArray(
				[
					_Utils_Tuple2('- totalReviews', totalReviews)
				]));
	});
var $author$project$Listings$Ui$InsightsHeader$withLoadingStatus = F2(
	function (isLoading, _v0) {
		var config = _v0.a;
		return $author$project$Listings$Ui$InsightsHeader$View(
			_Utils_update(
				config,
				{isLoading: isLoading}));
	});
var $author$project$DashboardV2$View$renderResponseRate = F2(
	function (session, model) {
		var isConnected = _Utils_eq(session.analytics.google, $author$project$PinMeToPage$NetworkEnabled) || _Utils_eq(session.analytics.trustpilot, $author$project$PinMeToPage$NetworkEnabled);
		var _v0 = session.siteName;
		var siteName = _v0.a;
		var notConnectedHeader = $author$project$Listings$Ui$InsightsHeader$render(
			A2(
				$author$project$Listings$Ui$InsightsHeader$withNote,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-insights__highlight--note')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Dashboard$noReviews(session.translations)),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/listings/' + (siteName + '/directories'))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(' Google & Trustpilot')
										]))
								]))
						])),
				A2(
					$author$project$Listings$Ui$InsightsHeader$withIcon,
					$author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faCloudXmark),
					$author$project$Listings$Ui$InsightsHeader$view(
						{
							title: $author$project$Translations$Listings$Insights$responseRate(session.translations)
						}))));
		var _v1 = model.detailedRatingStats;
		if (_v1.$ === 'Loaded') {
			var detailedRatingStats = _v1.a;
			var totalReviews = function (detailedRatingStats_) {
				return detailedRatingStats_.answered + detailedRatingStats_.unanswered;
			};
			var responseRateNote = $elm$html$Html$text(
				A2(
					$author$project$Translations$Listings$Dashboard$ratingAverageNote,
					session.translations,
					$author$project$Common$Math$formatNumber(
						totalReviews(detailedRatingStats))));
			var totalRatings = function (detailedRatingStats_) {
				return (((detailedRatingStats_.oneStar + detailedRatingStats_.twoStar) + detailedRatingStats_.threeStar) + detailedRatingStats_.fourStar) + detailedRatingStats_.fiveStar;
			};
			var summedRating = function (detailedRatingStats_) {
				return ((((detailedRatingStats_.oneStar * 1) + (detailedRatingStats_.twoStar * 2)) + (detailedRatingStats_.threeStar * 3)) + (detailedRatingStats_.fourStar * 4)) + (detailedRatingStats_.fiveStar * 5);
			};
			var calculateAverageRating = function (detailedRatingStats_) {
				return summedRating(detailedRatingStats_) / totalRatings(detailedRatingStats_);
			};
			var averageRating = calculateAverageRating(detailedRatingStats);
			var starRatingHeader = $author$project$Listings$Ui$InsightsHeader$render(
				A2(
					$author$project$Listings$Ui$InsightsHeader$withNote,
					responseRateNote,
					A3(
						$author$project$Listings$Ui$InsightsHeader$withStarRating,
						$elm$core$Basics$isNaN(averageRating) ? function (_v2) {
							return ' - ';
						} : $myrho$elm_round$Round$round(2),
						averageRating,
						$author$project$Listings$Ui$InsightsHeader$view(
							{
								title: $author$project$Translations$Listings$Dashboard$ratingsTitle(session.translations)
							}))));
			var datasets = _List_fromArray(
				[
					{
					data: detailedRatingStats.answered,
					color: '#9933FF',
					title: $author$project$Translations$Listings$Insights$ratingResponseRateAnswered(session.translations)
				},
					{
					data: detailedRatingStats.unanswered,
					color: '#C7C7C7',
					title: $author$project$Translations$Listings$Insights$ratingResponseRateUnanswered(session.translations)
				}
				]);
			var content = function () {
				var linkElement = A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/listings/' + (siteName + '/insights/rating')),
							$elm$html$Html$Attributes$class('pmt-dashboard__card__link'),
							$elm$html$Html$Events$onClick(
							$author$project$DashboardV2$Model$OnLinkClicked($author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToRatings))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Dashboard$goToRatings(session.translations))
						]));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__chart-and-link-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-dashboard__chart-container')
								]),
							_List_fromArray(
								[
									A2($author$project$DashboardV2$View$renderDonutChart, session, datasets)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-dashboard__gauge__link-container')
								]),
							_List_fromArray(
								[linkElement]))
						]));
			}();
			return $author$project$PinMeTo$Ui$Card$render(
				A2(
					$author$project$PinMeTo$Ui$Card$withSeparator,
					false,
					A2(
						$author$project$PinMeTo$Ui$Card$withHeader,
						isConnected ? starRatingHeader : notConnectedHeader,
						$author$project$PinMeTo$Ui$Card$view(content))));
		} else {
			var skeletonHeader = $author$project$Listings$Ui$InsightsHeader$render(
				A3(
					$author$project$Listings$Ui$InsightsHeader$withStarRating,
					$myrho$elm_round$Round$round(2),
					5,
					A2(
						$author$project$Listings$Ui$InsightsHeader$withLoadingStatus,
						true,
						$author$project$Listings$Ui$InsightsHeader$view(
							{
								title: $author$project$Translations$Listings$Dashboard$ratingsTitle(session.translations)
							}))));
			var chart = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-dashboard__chart-container')
					]),
				_List_fromArray(
					[
						A2($author$project$DashboardV2$View$renderDonutChart, session, _List_Nil)
					]));
			return $author$project$PinMeTo$Ui$Card$render(
				A2(
					$author$project$PinMeTo$Ui$Card$withSeparator,
					false,
					A2(
						$author$project$PinMeTo$Ui$Card$withHeader,
						isConnected ? skeletonHeader : notConnectedHeader,
						$author$project$PinMeTo$Ui$Card$view(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[chart]))))));
		}
	});
var $author$project$DashboardV2$View$renderInsights = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__insights__container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__insights__item'),
							$elm$html$Html$Attributes$class('pmt-dashboard__insights-card')
						]),
					_List_fromArray(
						[
							A2($author$project$DashboardV2$View$renderResponseRate, session, model)
						])),
					A2(
					$elm$html$Html$map,
					$author$project$DashboardV2$Model$DataCompletenessMsg,
					A3($author$project$DataCompletenessV2$Dashboard$View$view, model.account, model.dataCompleteness, session.translations)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__insights__item'),
							$elm$html$Html$Attributes$class('pmt-dashboard__insights-card')
						]),
					_List_fromArray(
						[
							A2($author$project$DashboardV2$View$renderTodoCard, session, model)
						]))
				]));
	});
var $author$project$Translations$Listings$Navigation$locations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.locations');
};
var $author$project$DashboardV2$Model$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Translations$Listings$Navigation$Dashboard$errorTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.navigation.dashboard.error_title');
};
var $author$project$FontAwesome$Light$Icon$faQuestion = $author$project$FontAwesome$Light$Icon$Icon('fa-light fa-question');
var $author$project$DashboardV2$View$renderCardWithAside = F4(
	function (title, content, popOver, aside) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__highlight__item'),
					$elm$html$Html$Attributes$class('pmt-dashboard__card__container')
				]),
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Card$render(
					A2(
						$author$project$PinMeTo$Ui$Card$withSeparator,
						false,
						A2(
							$author$project$PinMeTo$Ui$Card$withHeader,
							$author$project$Listings$Ui$InsightsHeader$render(
								A4(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Basics$identity,
									function (aside_) {
										return $author$project$Listings$Ui$InsightsHeader$withAsides(
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-dashboard__card__header-aside')
													]),
												_List_fromArray(
													[aside_])));
									},
									aside,
									A4(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$elm$core$Basics$identity,
										function (_v0) {
											var config = _v0.a;
											var state = _v0.b;
											return $author$project$Listings$Ui$InsightsHeader$withPopOver(
												_Utils_Tuple2(config, state));
										},
										popOver,
										$author$project$Listings$Ui$InsightsHeader$view(
											{title: title})))),
							$author$project$PinMeTo$Ui$Card$view(content))))
				]));
	});
var $author$project$DashboardV2$View$renderCard = F3(
	function (title, content, popOver) {
		return A4($author$project$DashboardV2$View$renderCardWithAside, title, content, popOver, $elm$core$Maybe$Nothing);
	});
var $author$project$Translations$Listings$Dashboard$goToNetworks = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.go_to_networks');
};
var $author$project$Translations$Listings$Dashboard$goToConflicts = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.go_to_conflicts');
};
var $author$project$Translations$Listings$Dashboard$goToLocations = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.go_to_locations');
};
var $author$project$DashboardV2$View$renderCardContent = F8(
	function (number, totalNumber, linkText, linkHref, highlightedNumber, isLoading, trackingEvent, numberTrackingEvent) {
		var totalElement = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			function (totalValue) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__card__total')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'/ ' + $elm$core$String$fromInt(totalValue))
						]));
			},
			totalNumber);
		var linkElement = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(linkHref),
					$elm$html$Html$Attributes$class('pmt-dashboard__card__link'),
					$elm$html$Html$Events$onClick(
					$author$project$DashboardV2$Model$OnLinkClicked(trackingEvent))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(linkText)
				]));
		var classes = $elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('pmt-dashboard__card__red-text', highlightedNumber)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__card')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$DashboardV2$View$skellify,
					isLoading,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-dashboard__rounded-border')
						]),
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(linkHref),
								$elm$html$Html$Events$onClick(
								$author$project$DashboardV2$Model$OnLinkClicked(numberTrackingEvent)),
								$elm$html$Html$Attributes$class('ui-insights-header__number ui-insights-header__number-dashboard')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[classes]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(number))
									])),
								totalElement
							]))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[linkElement]))
				]));
	});
var $author$project$Translations$Listings$Dashboard$conflictsPopoverHref = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.conflicts_popover_href');
};
var $author$project$Conflicts$ListingsManagerSetup$Dashboard = {$: 'Dashboard'};
var $author$project$Conflicts$ListingsManagerSetup$listingsManagerButton = F3(
	function (siteName, policiesEnabled, translations) {
		return $author$project$Conflicts$ListingsManagerSetup$isHidden(policiesEnabled) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3($author$project$Conflicts$ListingsManagerSetup$setupCta, $author$project$Conflicts$ListingsManagerSetup$Dashboard, siteName, translations));
	});
var $author$project$Translations$Listings$Dashboard$conflictsPopoverContent = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.dashboard.conflicts_popover_content');
};
var $author$project$DashboardV2$View$renderHighlights = F2(
	function (session, model) {
		var siteName_ = $author$project$Data$SiteName$toString(session.siteName);
		var getCardDetails = function (title) {
			switch (title) {
				case 'Locations':
					return {
						icon: $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faLocationDot),
						title: $author$project$Translations$Listings$Navigation$locations(session.translations),
						linkRef: '/listings/' + (siteName_ + '/locations'),
						linkText: $author$project$Translations$Listings$Dashboard$goToLocations(session.translations)
					};
				case 'Networks':
					return {
						icon: $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faLocationDot),
						title: $author$project$Translations$Listings$Navigation$directories(session.translations),
						linkRef: '/listings/' + (siteName_ + '/directories'),
						linkText: $author$project$Translations$Listings$Dashboard$goToNetworks(session.translations)
					};
				case 'Conflicts':
					return {
						icon: $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faLocationDot),
						title: $author$project$Translations$Listings$Tasks$conflicts(session.translations),
						linkRef: '/listings/' + (siteName_ + '/conflicts'),
						linkText: $author$project$Translations$Listings$Dashboard$goToConflicts(session.translations)
					};
				default:
					return {
						icon: $author$project$FontAwesome$light($author$project$FontAwesome$Light$Icon$faQuestion),
						title: title,
						linkRef: '#',
						linkText: ''
					};
			}
		};
		var errorCard = F2(
			function (cardTitle, error) {
				return A3(
					$author$project$DashboardV2$View$renderCard,
					cardTitle,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Navigation$Dashboard$errorTitle(session.translations) + (': ' + error))
							])),
					$elm$core$Maybe$Nothing);
			});
		var networksCard = function () {
			var details = getCardDetails('Networks');
			var _v2 = model.networksConnections;
			switch (_v2.$) {
				case 'Loaded':
					var networksConnections = _v2.a;
					var numberConnectedNetworks = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							function (connection) {
								return connection.connected ? $elm$core$Maybe$Just(connection.connected) : $elm$core$Maybe$Nothing;
							},
							networksConnections));
					var totalNetworksCount = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							function (connection) {
								return (connection.customerCanEnable || connection.connected) ? $elm$core$Maybe$Just(connection.customerCanEnable) : $elm$core$Maybe$Nothing;
							},
							networksConnections));
					return A3(
						$author$project$DashboardV2$View$renderCard,
						details.title,
						A8(
							$author$project$DashboardV2$View$renderCardContent,
							numberConnectedNetworks,
							$elm$core$Maybe$Just(totalNetworksCount),
							details.linkText,
							details.linkRef,
							false,
							false,
							$author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToNetworks,
							$author$project$PlanHat$TrackingActions$keys.listingsDashboard.linkInNetworksNumber),
						$elm$core$Maybe$Nothing);
				case 'Error':
					var error = _v2.a;
					return A2(errorCard, details.title, error);
				default:
					return A3(
						$author$project$DashboardV2$View$renderCard,
						details.title,
						A8($author$project$DashboardV2$View$renderCardContent, 10, $elm$core$Maybe$Nothing, details.linkText, details.linkRef, false, true, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToNetworks, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.linkInNetworksNumber),
						$elm$core$Maybe$Nothing);
			}
		}();
		var conflictsCard = function () {
			var popOverConfig = A2(
				$author$project$PinMeTo$Ui$PopOver$withLink,
				{
					href: 'https://help.pinmeto.com/en/article/listings-what-are-conflicts-and-how-to-handle-them-suhf32/',
					text: $author$project$Translations$Listings$Dashboard$conflictsPopoverHref(session.translations)
				},
				$author$project$PinMeTo$Ui$PopOver$view(
					{
						uid: 'conflicts-popover',
						tagger: $author$project$DashboardV2$Model$PopOverMsg,
						content: _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$Listings$Dashboard$conflictsPopoverContent(session.translations))
							]),
						preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
					}));
			var setupAside = A3($author$project$Conflicts$ListingsManagerSetup$listingsManagerButton, session.siteName, model.listingsManagerPoliciesEnabled, session.translations);
			var details = getCardDetails('Conflicts');
			var _v1 = _Utils_Tuple2(model.numberOfConflicts, model.facebookBrandPageConflicts);
			_v1$2:
			while (true) {
				_v1$3:
				while (true) {
					switch (_v1.a.$) {
						case 'Loaded':
							switch (_v1.b.$) {
								case 'Loaded':
									var numberOfConflicts = _v1.a.a;
									var numberOfFacebookBrandPageConflicts = _v1.b.a;
									var totalConflicts = numberOfConflicts + numberOfFacebookBrandPageConflicts;
									var highlightedNumber = totalConflicts > 0;
									return A4(
										$author$project$DashboardV2$View$renderCardWithAside,
										details.title,
										A8($author$project$DashboardV2$View$renderCardContent, totalConflicts, $elm$core$Maybe$Nothing, details.linkText, details.linkRef, highlightedNumber, false, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToConflicts, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.linkInConflictsNumber),
										$elm$core$Maybe$Just(
											_Utils_Tuple2(popOverConfig, model.popOverState)),
										setupAside);
								case 'Error':
									break _v1$2;
								default:
									break _v1$3;
							}
						case 'Error':
							var error = _v1.a.a;
							return A2(errorCard, details.title, error);
						default:
							if (_v1.b.$ === 'Error') {
								break _v1$2;
							} else {
								break _v1$3;
							}
					}
				}
				return A4(
					$author$project$DashboardV2$View$renderCardWithAside,
					details.title,
					A8($author$project$DashboardV2$View$renderCardContent, 70, $elm$core$Maybe$Nothing, details.linkText, details.linkRef, true, true, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToConflicts, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.linkInConflictsNumber),
					$elm$core$Maybe$Just(
						_Utils_Tuple2(popOverConfig, model.popOverState)),
					setupAside);
			}
			var error = _v1.b.a;
			return A2(errorCard, details.title, error);
		}();
		var locationsCard = function () {
			var details = getCardDetails('Locations');
			var _v0 = model.numberOfLocations;
			switch (_v0.$) {
				case 'Loaded':
					var numberOfLocations = _v0.a;
					return A3(
						$author$project$DashboardV2$View$renderCard,
						details.title,
						A8($author$project$DashboardV2$View$renderCardContent, numberOfLocations, $elm$core$Maybe$Nothing, details.linkText, details.linkRef, false, false, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToLocations, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.linkInLocationsNumber),
						$elm$core$Maybe$Nothing);
				case 'Error':
					var error = _v0.a;
					return A2(errorCard, details.title, error);
				default:
					return A3(
						$author$project$DashboardV2$View$renderCard,
						details.title,
						A8($author$project$DashboardV2$View$renderCardContent, 100, $elm$core$Maybe$Nothing, details.linkText, details.linkRef, false, true, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.goToLocations, $author$project$PlanHat$TrackingActions$keys.listingsDashboard.linkInLocationsNumber),
						$elm$core$Maybe$Nothing);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard__highlight__container')
				]),
			_List_fromArray(
				[locationsCard, networksCard, conflictsCard]));
	});
var $author$project$DashboardV2$View$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard')
				]),
			_List_fromArray(
				[
					A2($author$project$DashboardV2$View$renderHighlights, session, model),
					A2($author$project$DashboardV2$View$renderInsights, session, model)
				]));
	});
var $author$project$DashboardV2$Main$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 'OnDetailedRatingStatsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var detailedRatingStats = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detailedRatingStats: $author$project$RemoteData$Loaded(detailedRatingStats)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								detailedRatingStats: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get detailed rating stats'
							}));
				}
			case 'OnNumberOfLocationsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var numberOfLocations = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocations: $author$project$RemoteData$Loaded(numberOfLocations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocations: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get number of locations'
							}));
				}
			case 'OnNetworkDataResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var networksConnections = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								networksConnections: $author$project$RemoteData$Loaded(networksConnections)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								networksConnections: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get network data'
							}));
				}
			case 'OnNumberOfConflictsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var numberOfConflicts = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfConflicts: $author$project$RemoteData$Loaded(numberOfConflicts)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfConflicts: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get number of conflicts'
							}));
				}
			case 'OnFacebookBrandPageConflictsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var facebookBrandPageConflicts = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								facebookBrandPageConflicts: $author$project$RemoteData$Loaded(facebookBrandPageConflicts)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								facebookBrandPageConflicts: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get facebook brand page conflicts'
							}));
				}
			case 'DataCompletenessMsg':
				var dataCompletenessMsg = msg.a;
				var _v7 = A2($author$project$DataCompletenessV2$Dashboard$Update$update, dataCompletenessMsg, model.dataCompleteness);
				var updatedDataCompleteness = _v7.a;
				var dataCompletenessCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dataCompleteness: updatedDataCompleteness}),
					A2($elm$core$Platform$Cmd$map, $author$project$DashboardV2$Model$DataCompletenessMsg, dataCompletenessCmd));
			case 'OnTotalPendingImageAssociationsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var totalPendingImageAssociations = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								totalPendingImageAssociations: $author$project$RemoteData$Loaded(totalPendingImageAssociations)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								totalPendingImageAssociations: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get total pending image associations'
							}));
				}
			case 'OnNumberOfLocationsWithPendingChangesResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var numberOfLocationsWithPendingChanges = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocationsWithPendingChanges: $author$project$RemoteData$Loaded(numberOfLocationsWithPendingChanges)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocationsWithPendingChanges: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get number of locations with pending changes'
							}));
				}
			case 'OnNumberOfLocationsToVerifyResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var numberOfLocationsToVerify = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocationsToVerify: $author$project$RemoteData$Loaded(numberOfLocationsToVerify)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								numberOfLocationsToVerify: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get number of locations to verify'
							}));
				}
			case 'OnUnreviewedMediaCountResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var unreviewedMediaCount = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								unreviewedMediaCount: $author$project$RemoteData$Loaded(unreviewedMediaCount)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								unreviewedMediaCount: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							}),
						$author$project$PinMeTo$Logger$log(
							{
								data: $author$project$PinMeTo$ExpectJson$getErrorMessage(error),
								context: 'DashboardV2.Main.Update',
								message: 'Failed to get unreviewed media count'
							}));
				}
			case 'PopOverMsg':
				var popOverMsg = msg.a;
				var _v12 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$DashboardV2$Model$PopOverMsg, popOverMsg, model.popOverState);
				var newPopOverState = _v12.a;
				var popOverCmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: newPopOverState}),
					popOverCmd);
			case 'UiTooltipMsg':
				var tooltipMsg = msg.a;
				var _v13 = A3($author$project$PinMeTo$Ui$AdvancedTooltip$update, $author$project$DashboardV2$Model$UiTooltipMsg, tooltipMsg, model.uiTooltip);
				var newTooltipState = _v13.a;
				var tooltipCmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{uiTooltip: newTooltipState}),
					tooltipCmd);
			case 'OnLinkClicked':
				var trackingEvent = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$PlanHat$PlanHat$track(
						{info: '', action: trackingEvent}));
			default:
				if (msg.a.$ === 'Ok') {
					var hasEnabledPolicy = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								listingsManagerPoliciesEnabled: $author$project$RemoteData$Loaded(hasEnabledPolicy)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								listingsManagerPoliciesEnabled: $author$project$RemoteData$Error(
									$author$project$Common$HandleResult$httpErrorUserMessage(error))
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: error, context: 'DashboardV2.Main.Update', message: 'Failed to get listings manager policies'}));
				}
		}
	});
var $author$project$DashboardV2$Model$Flags = F6(
	function (siteName, account, today, insightsUrl, apiEnabled, mediaReviewEnabled) {
		return {today: today, account: account, siteName: siteName, apiEnabled: apiEnabled, insightsUrl: insightsUrl, mediaReviewEnabled: mediaReviewEnabled};
	});
var $author$project$DashboardV2$Decoders$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mediaReviewEnabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apiEnabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'insightsUrl',
			$elm_community$json_extra$Json$Decode$Extra$url,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'today',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'account',
					$author$project$Data$Account$accountDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'siteName',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$DashboardV2$Model$Flags)))))));
var $author$project$DashboardV2$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$DashboardV2$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$DashboardV2$Main$init, view: $author$project$DashboardV2$View$view, update: $author$project$DashboardV2$Main$update, flagsDecoder: $author$project$DashboardV2$Decoders$flagsDecoder, subscriptions: $author$project$DashboardV2$Main$subscriptions});
var $author$project$Tasks$Here$Main$Flags = F6(
	function (claimUrl, siteName, user, translations, language, hasCategory) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, hasCategory: hasCategory, translations: translations};
	});
var $author$project$Tasks$Here$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hasCategory',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$PinMeTo$Ui$I18n$Language$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translations',
			$author$project$Common$Language$translationsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'user',
				$author$project$Data$User$userDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'siteName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'claimUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Tasks$Here$Main$Flags)))))));
var $author$project$Tasks$Here$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Here$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Here$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Here$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Here$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					user: decoded.user,
					claimUrl: decoded.claimUrl,
					language: decoded.language,
					siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
					hasCategory: decoded.hasCategory,
					translations: decoded.translations
				}),
			$elm$core$Platform$Cmd$none);
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Here$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Here.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Here$Main$getText = function (model) {
	return model.hasCategory ? $elm$html$Html$text('All of your locations are claimed!') : $elm$html$Html$text('Claim or create listings for each of your locations on HERE.');
};
var $author$project$Tasks$Here$Main$getClassName = function (model) {
	return model.hasCategory ? 'pmt-admin-box__success' : 'pmt-admin-box pmt-task--warning';
};
var $author$project$Tasks$Here$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Here$Main$getClassName(model))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('HERE - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Here$Main$getText(model)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Here$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Here$Main$init,
		view: $author$project$Tasks$Here$Main$view,
		update: F2(
			function (_v0, model) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}),
		subscriptions: function (_v1) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Tasks$Bing$Main$Flags = F5(
	function (claimUrl, siteName, user, translations, language) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, translations: translations};
	});
var $author$project$Tasks$Bing$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$author$project$Data$User$userDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'claimUrl',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$Bing$Main$Flags))))));
var $author$project$Tasks$Bing$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$Bing$Main$flagsDecoder, flags);
};
var $author$project$Tasks$Bing$Main$GetClaimStatus = function (a) {
	return {$: 'GetClaimStatus', a: a};
};
var $author$project$Tasks$Bing$Claim$Data$ClaimStatus$ClaimStatus = F4(
	function (claimed, notClaimed, notSupportedClaim, leftToVerify) {
		return {claimed: claimed, notClaimed: notClaimed, leftToVerify: leftToVerify, notSupportedClaim: notSupportedClaim};
	});
var $author$project$Tasks$Bing$Claim$Data$ClaimStatus$claimStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'leftToVerify',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'notSupportedClaim',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'notClaimed',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'claimed',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Tasks$Bing$Claim$Data$ClaimStatus$ClaimStatus)))));
var $author$project$Tasks$Bing$Claim$Data$ClaimStatus$getClaimStatus = F2(
	function (msg, _v0) {
		var siteName = _v0.a;
		var url = 'api/' + (siteName + '/bing/claim/status');
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Tasks$Bing$Claim$Data$ClaimStatus$claimStatusDecoder, $elm$json$Json$Decode$string),
				A3(
					$lukewestby$elm_http_builder$HttpBuilder$withHeader,
					'Content-Type',
					'application/json',
					$lukewestby$elm_http_builder$HttpBuilder$get(url))));
	});
var $author$project$Tasks$Bing$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$Bing$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$Bing$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					user: decoded.user,
					claimUrl: decoded.claimUrl,
					language: decoded.language,
					siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
					claimStatus: $author$project$RemoteData$Loading,
					translations: decoded.translations
				}),
			A2(
				$author$project$Tasks$Bing$Claim$Data$ClaimStatus$getClaimStatus,
				$author$project$Tasks$Bing$Main$GetClaimStatus,
				$author$project$Data$SiteName$SiteName(decoded.siteName)));
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$Bing$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.Bing.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$Bing$Main$getText = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return ((x.notClaimed > 0) || (x.leftToVerify > 0)) ? $elm$html$Html$text('Claim or create listings for each of your locations on Bing.') : $elm$html$Html$text('All of your locations are claimed!');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Bing$Main$toClaim = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			var _v1 = _Utils_Tuple2(
				$elm$core$String$fromInt(x.notClaimed),
				$elm$core$String$fromInt(x.notSupportedClaim));
			var notClaimed = _v1.a;
			var notSupportedClaim = _v1.b;
			return (x.notClaimed > 0) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Pages to claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(notClaimed)
									]))
							])),
						(x.notSupportedClaim > 0) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Not supported claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(notSupportedClaim)
									]))
							])) : $elm$html$Html$text('')
					])) : $elm$html$Html$text('');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$Bing$Main$getClassName = function (status) {
	if (status.$ === 'Loaded') {
		var x = status.a;
		return ((x.notClaimed > 0) || (x.leftToVerify > 0)) ? 'pmt-admin-box pmt-task--warning' : 'pmt-admin-box__success';
	} else {
		return '';
	}
};
var $author$project$Tasks$Bing$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$Bing$Main$getClassName(model.claimStatus))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Bing - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$Bing$Main$getText(model.claimStatus)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												$author$project$Tasks$Bing$Main$toClaim(model.claimStatus),
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$Bing$Main$update = F2(
	function (msg, state) {
		var _v0 = _Utils_Tuple2(state, msg);
		if (_v0.a.$ === 'Ok') {
			if (_v0.b.a.$ === 'Ok') {
				var model = _v0.a.a;
				var result = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Loaded(result)
							})),
					$elm$core$Platform$Cmd$none);
			} else {
				var model = _v0.a.a;
				var error = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								claimStatus: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							})),
					A2(
						$author$project$PinMeTo$ExpectJson$logError,
						$author$project$PinMeTo$ExpectJson$ErrorContext('Tasks.Bing.Main'),
						error));
			}
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$Bing$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$Bing$Main$init,
		view: $author$project$Tasks$Bing$Main$view,
		update: $author$project$Tasks$Bing$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Navigation$Navigation$TopNavigationMsg = function (a) {
	return {$: 'TopNavigationMsg', a: a};
};
var $author$project$Navigation$Navigation$decodeTranslations = function (flags) {
	var decoder = A2($elm$json$Json$Decode$field, 'translations', $author$project$Common$Language$translationsDecoder);
	return A2($elm$json$Json$Decode$decodeValue, decoder, flags);
};
var $author$project$Navigation$Navigation$init = F2(
	function (app, flags) {
		var _v0 = _Utils_Tuple2(
			$author$project$PinMeTo$Global$TopNavigation$Model$decodeFlags(flags),
			$author$project$Navigation$Navigation$decodeTranslations(flags));
		_v0$1:
		while (true) {
			if (_v0.a.$ === 'Ok') {
				if (_v0.b.$ === 'Ok') {
					var topNavFlags = _v0.a.a;
					var translations = _v0.b.a;
					var _v1 = $author$project$PinMeTo$Global$TopNavigation$init(
						{
							app: app,
							sites: topNavFlags.sites,
							config: topNavFlags.env,
							isDemo: topNavFlags.user.isDemo,
							siteAccess: topNavFlags.siteAccess,
							permissions: topNavFlags.permissions,
							featureFlags: $author$project$PinMeTo$FeatureFlags$none,
							selectedSite: topNavFlags.selectedSite,
							mobileWindowWidth: 640,
							userProfileImageUrl: $elm$core$Maybe$Just(topNavFlags.user.profileImage),
							ignoredProductUpgrades: topNavFlags.user.ignoredProductUpgrades
						});
					var topNavigation = _v1.a;
					var cmd = _v1.b;
					return _Utils_Tuple2(
						$elm$core$Result$Ok(
							{translations: translations, topNavigation: topNavigation}),
						A2($elm$core$Platform$Cmd$map, $author$project$Navigation$Navigation$TopNavigationMsg, cmd));
				} else {
					break _v0$1;
				}
			} else {
				if (_v0.b.$ === 'Err') {
					break _v0$1;
				} else {
					var e = _v0.a.a;
					return _Utils_Tuple2(
						$elm$core$Result$Err('Could not initialize navigation. Error has been logged.'),
						$author$project$PinMeTo$Logger$log(
							{
								data: $elm$json$Json$Decode$errorToString(e),
								context: 'Navigation.Navigation',
								message: 'Failed to decode flags'
							}));
				}
			}
		}
		var e = _v0.b.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err('Could not decode translations. Error has been logged.'),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Navigation.Navigation',
					message: 'Failed to decode translations'
				}));
	});
var $author$project$Navigation$Main$init = function (flags) {
	return A2($author$project$Navigation$Navigation$init, $author$project$PinMeTo$Global$TopNavigation$Model$Listings, flags);
};
var $author$project$Navigation$Navigation$view = function (result) {
	if (result.$ === 'Ok') {
		var topNavigation = result.a.topNavigation;
		var translations = result.a.translations;
		return A3(
			$author$project$PinMeTo$Global$TopNavigation$view,
			$author$project$Navigation$Navigation$TopNavigationMsg,
			$author$project$Labels$topNavigation(translations),
			topNavigation);
	} else {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('An error occurred')
				]));
	}
};
var $author$project$Navigation$Main$view = function (model) {
	return $author$project$Navigation$Navigation$view(model);
};
var $author$project$Navigation$Navigation$OnSupportMail = {$: 'OnSupportMail'};
var $author$project$Navigation$Navigation$update = F3(
	function (_v0, msg, result) {
		if (msg.$ === 'TopNavigationMsg') {
			var msg_ = msg.a;
			return A2(
				$elm$core$Result$withDefault,
				_Utils_Tuple2(result, $elm$core$Platform$Cmd$none),
				A2(
					$elm$core$Result$map,
					function (model) {
						return A2(
							$elm$core$Tuple$mapFirst,
							function (topNavigation) {
								return $elm$core$Result$Ok(
									_Utils_update(
										model,
										{topNavigation: topNavigation}));
							},
							A4(
								$author$project$PinMeTo$Global$TopNavigation$updateWithExternal,
								{
									handleFlags: $elm$core$Maybe$Nothing,
									onSupportMail: $elm$core$Maybe$Just($author$project$Navigation$Navigation$OnSupportMail)
								},
								$author$project$Navigation$Navigation$TopNavigationMsg,
								msg_,
								model.topNavigation));
					},
					result));
		} else {
			return _Utils_Tuple2(result, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Navigation$Main$out_Navigation_Main_angularService = _Platform_outgoingPort(
	'out_Navigation_Main_angularService',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string($.action)),
					_Utils_Tuple2(
					'service',
					$elm$json$Json$Encode$string($.service))
				]));
	});
var $author$project$Navigation$Main$update = F2(
	function (msg, model) {
		return A3($author$project$Navigation$Navigation$update, $author$project$Navigation$Main$out_Navigation_Main_angularService, msg, model);
	});
var $author$project$Navigation$Navigation$subscriptions = function (_v0) {
	return A2($elm$core$Platform$Sub$map, $author$project$Navigation$Navigation$TopNavigationMsg, $author$project$PinMeTo$Global$TopNavigation$subscriptions);
};
var $author$project$Navigation$Main$main = $elm$browser$Browser$element(
	{init: $author$project$Navigation$Main$init, view: $author$project$Navigation$Main$view, update: $author$project$Navigation$Main$update, subscriptions: $author$project$Navigation$Navigation$subscriptions});
var $author$project$Tasks$PTV$Main$Flags = F5(
	function (claimUrl, siteName, user, translations, language) {
		return {user: user, claimUrl: claimUrl, language: language, siteName: siteName, translations: translations};
	});
var $author$project$Tasks$PTV$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$PinMeTo$Ui$I18n$Language$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translations',
		$author$project$Common$Language$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$author$project$Data$User$userDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'siteName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'claimUrl',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Tasks$PTV$Main$Flags))))));
var $author$project$Tasks$PTV$Main$decodeFlags = function (flags) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Tasks$PTV$Main$flagsDecoder, flags);
};
var $author$project$Tasks$PTV$Main$LocationsResponse = function (a) {
	return {$: 'LocationsResponse', a: a};
};
var $author$project$Tasks$PTV$Main$FailedToDecodeFlags = function (a) {
	return {$: 'FailedToDecodeFlags', a: a};
};
var $author$project$Tasks$PTV$Main$init = function (flags) {
	var _v0 = $author$project$Tasks$PTV$Main$decodeFlags(flags);
	if (_v0.$ === 'Ok') {
		var decoded = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				{
					user: decoded.user,
					claimUrl: decoded.claimUrl,
					language: decoded.language,
					siteName: $author$project$Data$SiteName$SiteName(decoded.siteName),
					translations: decoded.translations,
					locationsResponse: $author$project$RemoteData$Loading
				}),
			A2(
				$author$project$Tasks$PTV$Claim$Commands$getNotMatched,
				$author$project$Data$SiteName$SiteName(decoded.siteName),
				$author$project$Tasks$PTV$Main$LocationsResponse));
	} else {
		var e = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Tasks$PTV$Main$FailedToDecodeFlags(
					$elm$json$Json$Decode$errorToString(e))),
			$author$project$PinMeTo$Logger$log(
				{
					data: $elm$json$Json$Decode$errorToString(e),
					context: 'Tasks.PTV.Main',
					message: 'Failed to decode flags'
				}));
	}
};
var $author$project$Tasks$PTV$Main$getText = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			return ($elm$core$List$length(x.unmatchedPTV) > 0) ? $elm$html$Html$text('Claim or create listings for each of your locations on PTV.') : $elm$html$Html$text('All of your locations are claimed!');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$PTV$Main$toClaim = function (status) {
	switch (status.$) {
		case 'Suspended':
			return $elm$html$Html$text('');
		case 'Loading':
			return $author$project$PinMeTo$Ui$Spinner$spinnerWithDelay;
		case 'Loaded':
			var x = status.a;
			var unmatchedPtv = x.unmatchedPTV;
			return ($elm$core$List$length(unmatchedPtv) > 0) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stats')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Locations to claim')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stats__value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$elm$core$List$length(unmatchedPtv)))
									]))
							]))
					])) : $elm$html$Html$text('');
		default:
			var e = status.a;
			return $elm$html$Html$text(e);
	}
};
var $author$project$Tasks$PTV$Main$getClassName = function (status) {
	if (status.$ === 'Loaded') {
		var x = status.a;
		return ($elm$core$List$length(x.unmatchedPTV) > 0) ? 'pmt-admin-box pmt-task--warning' : 'pmt-admin-box__success';
	} else {
		return '';
	}
};
var $author$project$Tasks$PTV$Main$view = function (state) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list list--rounded list--divided')
					]),
				_List_fromArray(
					[
						function () {
						if (state.$ === 'Ok') {
							var model = state.a;
							var hasManage = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.manage'));
							var hasView = A2(
								$author$project$Data$User$hasPermission,
								model.user,
								$author$project$Data$User$Permission('claim.view'));
							return hasView ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										'list__item pmt-task ' + $author$project$Tasks$PTV$Main$getClassName(model.locationsResponse))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__indicator')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$i,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__icon')
													]),
												_List_fromArray(
													[
														$author$project$FontAwesome$Solid$Icon$render($author$project$FontAwesome$Solid$Icon$faLocationDot)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('pmt-task__title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('PTV - Claim Locations')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Tasks$PTV$Main$getText(model.locationsResponse)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-task__asides stats')
											]),
										_List_fromArray(
											[
												$author$project$Tasks$PTV$Main$toClaim(model.locationsResponse),
												hasManage ? $author$project$PinMeTo$Ui$Button$render(
												A2(
													$author$project$PinMeTo$Ui$Button$withHref,
													model.claimUrl,
													$author$project$PinMeTo$Ui$Button$buttonPrimary('Claim Locations'))) : $elm$html$Html$text('')
											]))
									])) : $elm$html$Html$text('');
						} else {
							var e = state.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list__item pmt-task pmt-admin-box')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (_v1) {
											var s = _v1.a;
											return s;
										}(e))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Tasks$PTV$Main$update = F2(
	function (msg, state) {
		var _v0 = _Utils_Tuple2(state, msg);
		if (_v0.a.$ === 'Ok') {
			if (_v0.b.a.$ === 'Ok') {
				var model = _v0.a.a;
				var result = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								locationsResponse: $author$project$RemoteData$Loaded(result)
							})),
					$elm$core$Platform$Cmd$none);
			} else {
				var model = _v0.a.a;
				var error = _v0.b.a.a;
				return _Utils_Tuple2(
					$elm$core$Result$Ok(
						_Utils_update(
							model,
							{
								locationsResponse: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(error))
							})),
					A2(
						$author$project$PinMeTo$ExpectJson$logError,
						$author$project$PinMeTo$ExpectJson$ErrorContext('Tasks.PTV.Main'),
						error));
			}
		} else {
			return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Tasks$PTV$Main$main = $elm$browser$Browser$element(
	{
		init: $author$project$Tasks$PTV$Main$init,
		view: $author$project$Tasks$PTV$Main$view,
		update: $author$project$Tasks$PTV$Main$update,
		subscriptions: function (_v0) {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Conflicts$Dashboard$Model$FirstPage = {$: 'FirstPage'};
var $author$project$Conflicts$Dashboard$Model$init = {popOverState: $author$project$PinMeTo$Ui$PopOver$init, conflictStatus: $author$project$RemoteData$Suspended, googleSuggestionsCount: $author$project$RemoteData$Suspended, deprecatedAttributesCount: $author$project$RemoteData$Suspended, googleAttributesSuggestions: $author$project$RemoteData$Suspended, isResolvingGoogleAttributes: false, googleSuggestionsLightboxPage: $author$project$Conflicts$Dashboard$Model$FirstPage, showGoogleSuggestionsLightbox: false, listingsManagerPoliciesEnabled: $author$project$RemoteData$Loading};
var $author$project$Conflicts$Dashboard$Update$OnConflictStatus = function (a) {
	return {$: 'OnConflictStatus', a: a};
};
var $author$project$Data$ConflictStatus$FieldData$FieldData = function (name) {
	return function (storeId) {
		return function (locationDescriptor) {
			return function (email) {
				return function (homepage) {
					return function (phone) {
						return function (about) {
							return function (longDescription) {
								return function (location) {
									return function (hours) {
										return function (openingDate) {
											return function (specialOpenHours) {
												return function (permanentlyClosed) {
													return function (temporarilyClosedUntil) {
														return function (address) {
															return function (images) {
																return function (networkCategories) {
																	return function (networkAttributes) {
																		return function (networkActionLinks) {
																			return function (networkServiceItems) {
																				return function (serviceAreas) {
																					return {name: name, about: about, email: email, hours: hours, phone: phone, images: images, address: address, storeId: storeId, homepage: homepage, location: location, openingDate: openingDate, serviceAreas: serviceAreas, longDescription: longDescription, specialOpenHours: specialOpenHours, networkAttributes: networkAttributes, networkCategories: networkCategories, permanentlyClosed: permanentlyClosed, locationDescriptor: locationDescriptor, networkActionLinks: networkActionLinks, networkServiceItems: networkServiceItems, temporarilyClosedUntil: temporarilyClosedUntil};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$ConflictStatus$FieldConflict = F3(
	function (count, work, isPublishing) {
		return {work: work, count: count, isPublishing: isPublishing};
	});
var $author$project$Data$ConflictStatus$fieldConflictEmpty = A3($author$project$Data$ConflictStatus$FieldConflict, 0, _List_Nil, false);
var $author$project$Data$ConflictStatus$fieldConflictDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'work',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Data$ConflictStatus$FieldConflict))));
var $author$project$Data$ConflictStatus$fieldsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'serviceAreas',
	$author$project$Data$ConflictStatus$fieldConflictDecoder,
	$author$project$Data$ConflictStatus$fieldConflictEmpty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'networkServiceItems',
		$author$project$Data$ConflictStatus$fieldConflictDecoder,
		$author$project$Data$ConflictStatus$fieldConflictEmpty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'networkActionLinks',
			$author$project$Data$ConflictStatus$fieldConflictDecoder,
			$author$project$Data$ConflictStatus$fieldConflictEmpty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'networkAttributes',
				$author$project$Data$ConflictStatus$fieldConflictDecoder,
				$author$project$Data$ConflictStatus$fieldConflictEmpty,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'networkCategories',
					$author$project$Data$ConflictStatus$fieldConflictDecoder,
					$author$project$Data$ConflictStatus$fieldConflictEmpty,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'images',
						$author$project$Data$ConflictStatus$fieldConflictDecoder,
						$author$project$Data$ConflictStatus$fieldConflictEmpty,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'address',
							$author$project$Data$ConflictStatus$fieldConflictDecoder,
							$author$project$Data$ConflictStatus$fieldConflictEmpty,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'temporarilyClosedUntil',
								$author$project$Data$ConflictStatus$fieldConflictDecoder,
								$author$project$Data$ConflictStatus$fieldConflictEmpty,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'permanentlyClosed',
									$author$project$Data$ConflictStatus$fieldConflictDecoder,
									$author$project$Data$ConflictStatus$fieldConflictEmpty,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'specialOpenHours',
										$author$project$Data$ConflictStatus$fieldConflictDecoder,
										$author$project$Data$ConflictStatus$fieldConflictEmpty,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'openingDate',
											$author$project$Data$ConflictStatus$fieldConflictDecoder,
											$author$project$Data$ConflictStatus$fieldConflictEmpty,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'hours',
												$author$project$Data$ConflictStatus$fieldConflictDecoder,
												$author$project$Data$ConflictStatus$fieldConflictEmpty,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'location',
													$author$project$Data$ConflictStatus$fieldConflictDecoder,
													$author$project$Data$ConflictStatus$fieldConflictEmpty,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'longDescription',
														$author$project$Data$ConflictStatus$fieldConflictDecoder,
														$author$project$Data$ConflictStatus$fieldConflictEmpty,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'about',
															$author$project$Data$ConflictStatus$fieldConflictDecoder,
															$author$project$Data$ConflictStatus$fieldConflictEmpty,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'phoneNumber',
																$author$project$Data$ConflictStatus$fieldConflictDecoder,
																$author$project$Data$ConflictStatus$fieldConflictEmpty,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'homepage',
																	$author$project$Data$ConflictStatus$fieldConflictDecoder,
																	$author$project$Data$ConflictStatus$fieldConflictEmpty,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'email',
																		$author$project$Data$ConflictStatus$fieldConflictDecoder,
																		$author$project$Data$ConflictStatus$fieldConflictEmpty,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'locationDescriptor',
																			$author$project$Data$ConflictStatus$fieldConflictDecoder,
																			$author$project$Data$ConflictStatus$fieldConflictEmpty,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'storeId',
																				$author$project$Data$ConflictStatus$fieldConflictDecoder,
																				$author$project$Data$ConflictStatus$fieldConflictEmpty,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'name',
																					$author$project$Data$ConflictStatus$fieldConflictDecoder,
																					$author$project$Data$ConflictStatus$fieldConflictEmpty,
																					$elm$json$Json$Decode$succeed($author$project$Data$ConflictStatus$FieldData$FieldData))))))))))))))))))))));
var $author$project$Data$ConflictStatus$ConflictStatus = F3(
	function (total, fields, featureFlags) {
		return {total: total, fields: fields, featureFlags: featureFlags};
	});
var $author$project$Data$ConflictStatus$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$author$project$RemoteData$Loading,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fields',
		$author$project$Data$ConflictStatus$fieldsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Data$ConflictStatus$ConflictStatus))));
var $author$project$Conflicts$Commands$getConflictStatus = F2(
	function (account, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Data$ConflictStatus$decoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					'api/' + ($author$project$Data$SiteName$toString(account.name) + '/conflicts/status'))));
	});
var $author$project$Conflicts$Dashboard$Update$OnDeprecatedAttributesCount = function (a) {
	return {$: 'OnDeprecatedAttributesCount', a: a};
};
var $author$project$Data$ConflictStatus$deprecatedAttributesCountDecoder = A2($elm$json$Json$Decode$field, 'deprecatedCount', $elm$json$Json$Decode$int);
var $author$project$Conflicts$Commands$getDeprecatedAttributesCount = F2(
	function (account, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$Data$ConflictStatus$deprecatedAttributesCountDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get(
					'api/' + ($author$project$Data$SiteName$toString(account.name) + '/conflicts/deprecatedAttributesCount'))));
	});
var $author$project$Conflicts$Dashboard$Update$OnGoogleAttributesSuggestions = function (a) {
	return {$: 'OnGoogleAttributesSuggestions', a: a};
};
var $author$project$Conflicts$Dashboard$Commands$getGoogleAttributesSuggestions = F2(
	function (_v0, msg) {
		var siteName = _v0.a;
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A3($author$project$PinMeTo$ExpectJson$expectJson, msg, $author$project$Data$NetworkData$GoogleAttributes$googleAttributesDecoder, $elm$json$Json$Decode$string),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/google/suggestions/attributes'))));
	});
var $author$project$Conflicts$Dashboard$Update$OnListingsManagerPoliciesEnabled = function (a) {
	return {$: 'OnListingsManagerPoliciesEnabled', a: a};
};
var $author$project$Conflicts$Dashboard$init = function (account) {
	return _Utils_Tuple2(
		$author$project$Conflicts$Dashboard$Model$init,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Conflicts$Commands$getConflictStatus, account, $author$project$Conflicts$Dashboard$Update$OnConflictStatus),
					A2($author$project$Conflicts$Commands$getDeprecatedAttributesCount, account, $author$project$Conflicts$Dashboard$Update$OnDeprecatedAttributesCount),
					A2($author$project$Conflicts$Dashboard$Commands$getGoogleAttributesSuggestions, account.name, $author$project$Conflicts$Dashboard$Update$OnGoogleAttributesSuggestions),
					A2($author$project$Conflicts$Commands$getListingsManagerPoliciesEnabled, account.name, $author$project$Conflicts$Dashboard$Update$OnListingsManagerPoliciesEnabled)
				])));
};
var $author$project$Conflicts$Main$ConflictsMsg = function (a) {
	return {$: 'ConflictsMsg', a: a};
};
var $author$project$Conflicts$Main$OnFacebookBrandPageConflicts = function (a) {
	return {$: 'OnFacebookBrandPageConflicts', a: a};
};
var $author$project$Conflicts$Main$init = F2(
	function (session, flags) {
		var _v0 = A2($author$project$Data$User$hasRole, session.user, $author$project$Data$User$Owner) ? _Utils_Tuple2(
			$author$project$RemoteData$Loading,
			A2($author$project$DashboardV2$Commands$getFacebookBrandPageConflicts, session.siteName, $author$project$Conflicts$Main$OnFacebookBrandPageConflicts)) : _Utils_Tuple2(
			$author$project$RemoteData$Loaded(-1),
			$elm$core$Platform$Cmd$none);
		var brandPageCounter = _v0.a;
		var brandPageCommand = _v0.b;
		var _v1 = $author$project$Conflicts$Dashboard$init(flags.account);
		var conflictsModel = _v1.a;
		var conflictsCmd = _v1.b;
		return _Utils_Tuple2(
			{account: flags.account, conflicts: conflictsModel, facebookBrandPageConflicts: brandPageCounter},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Conflicts$Main$ConflictsMsg, conflictsCmd),
						brandPageCommand
					])));
	});
var $author$project$Conflicts$ListingsManagerSetup$Conflicts = {$: 'Conflicts'};
var $author$project$Conflicts$ListingsManagerSetup$view = F3(
	function (siteName, policiesEnabled, translations) {
		return $author$project$Conflicts$ListingsManagerSetup$isHidden(policiesEnabled) ? $elm$html$Html$text('') : A4($author$project$Conflicts$ListingsManagerSetup$setup, $author$project$Conflicts$ListingsManagerSetup$Conflicts, false, siteName, translations);
	});
var $author$project$Conflicts$Dashboard$View$skellify = F2(
	function (child, isLoaded) {
		return $author$project$PinMeTo$Ui$Skeleton$view(
			{
				shimmer: $author$project$PinMeTo$Ui$Skeleton$Gradient,
				children: _List_fromArray(
					[child]),
				isLoading: !isLoaded,
				attributes: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-dashboard__rounded-border')
					])
			});
	});
var $author$project$Conflicts$Dashboard$Update$PopOverMsg = function (a) {
	return {$: 'PopOverMsg', a: a};
};
var $author$project$Data$User$UserIsCustomerSuccess = {$: 'UserIsCustomerSuccess'};
var $author$project$Data$Location$Field$requiresCustomerSuccessRole = _List_Nil;
var $author$project$Conflicts$Dashboard$View$fieldVisible = F2(
	function (user, field) {
		return A2(
			$elm$core$List$any,
			function (x) {
				return _Utils_eq(x, field);
			},
			$author$project$Data$Location$Field$requiresCustomerSuccessRole) ? _Utils_eq(user, $author$project$Data$User$UserIsCustomerSuccess) : true;
	});
var $author$project$Conflicts$Dashboard$View$visibleFields = function (user) {
	return A2(
		$elm$core$List$filter,
		function (field) {
			return A2($author$project$Conflicts$Dashboard$View$fieldVisible, user, field);
		},
		$author$project$Data$Location$Field$allFields);
};
var $author$project$Translations$Listings$Tasks$conflictsOccur = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.conflicts_occur');
};
var $author$project$Translations$Listings$Tasks$solveByLocation = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.solve_by_location');
};
var $author$project$Translations$Listings$Tasks$profileCoverImage = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.profile_cover_image');
};
var $author$project$Translations$Listings$Tasks$conflictsOccurLink = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.conflicts_occur_link');
};
var $author$project$Translations$Listings$Tasks$cleanupDeprecated = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.tasks.cleanup_deprecated');
};
var $author$project$Conflicts$Dashboard$View$replaceSpecialCharacters = function (originalValue) {
	var regex = $elm$regex$Regex$fromString('[^a-zA-Z0-9]');
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		originalValue,
		function (reg) {
			return A3(
				$elm$regex$Regex$replace,
				reg,
				function (_v0) {
					return '_';
				},
				A3(
					$elm$core$String$replace,
					' ',
					'_',
					$elm$core$String$toLower(originalValue)));
		},
		regex);
};
var $author$project$Conflicts$Dashboard$View$nameToTasksDataTestId = function (name) {
	return 'tasks.conflictName.' + $author$project$Conflicts$Dashboard$View$replaceSpecialCharacters(name);
};
var $author$project$Conflicts$Dashboard$View$countToTasksDataTestId = function (name) {
	return 'tasks.conflictCount.' + $author$project$Conflicts$Dashboard$View$replaceSpecialCharacters(name);
};
var $author$project$Conflicts$Dashboard$Update$BulkPublishFieldConfirmAlert = F3(
	function (a, b, c) {
		return {$: 'BulkPublishFieldConfirmAlert', a: a, b: b, c: c};
	});
var $author$project$Conflicts$Dashboard$View$conflictSummaryItem = F7(
	function (_v0, isLoaded, canBulkPublish, fields, title, fieldConflict, countersList) {
		var siteName = _v0.a;
		var counterToShow = $elm$core$List$isEmpty(countersList) ? ((fieldConflict.count > 0) ? $elm$core$String$fromInt(fieldConflict.count) : '') : A2(
			$elm$core$String$join,
			' & ',
			A2(
				$elm$core$List$map,
				function (element) {
					return $elm$core$String$fromInt(element);
				},
				A2(
					$elm$core$List$filter,
					function (number) {
						return number > 0;
					},
					countersList)));
		return (!isLoaded) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-summary__item pmt-conflict-status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__title'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-test',
							$author$project$Conflicts$Dashboard$View$nameToTasksDataTestId(title))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A3(
					$author$project$Util$flip,
					$author$project$Conflicts$Dashboard$View$skellify,
					isLoaded,
					A2(
						$elm$html$Html$dd,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-status__aside')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-conflict-status__info fa fa-fw fa-ellipsis-h')
									]),
								_List_Nil)
							])))
				])) : ((fieldConflict.count > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-summary__item pmt-conflict-status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__link'),
							$elm$html$Html$Attributes$href(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									[
										'/listings/',
										siteName,
										'/conflicts/resolve?fields=',
										A2(
										$elm$core$String$join,
										',',
										A2($elm$core$List$map, $author$project$Data$Location$Field$toString, fields))
									])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dt,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__title'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-test',
									$author$project$Conflicts$Dashboard$View$nameToTasksDataTestId(title))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$dd,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__count'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-test',
									$author$project$Conflicts$Dashboard$View$countToTasksDataTestId(title))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(counterToShow)
								]))
						])),
					function () {
					var _v1 = _Utils_Tuple2(
						$elm$core$List$head(fields),
						canBulkPublish);
					if ((_v1.a.$ === 'Just') && _v1.b) {
						var field = _v1.a.a;
						return (($elm$core$List$length(fieldConflict.work) > 0) || fieldConflict.isPublishing) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__aside')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-status__info fa fa-fw fa-gear fa-spin')
										]),
									_List_Nil)
								])) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__aside'),
									$elm$html$Html$Events$onClick(
									A3(
										$author$project$Conflicts$Dashboard$Update$BulkPublishFieldConfirmAlert,
										$author$project$Data$SiteName$SiteName(siteName),
										field,
										fieldConflict.count))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-status__action fa-regular fa-wand-magic-sparkles')
										]),
									_List_Nil)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-summary__item pmt-conflict-status pmt-conflict-status--clean')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__title'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-test',
							$author$project$Conflicts$Dashboard$View$nameToTasksDataTestId(title))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$dd,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__aside')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__info fa fa-fw fa-check')
								]),
							_List_Nil)
						]))
				])));
	});
var $author$project$Conflicts$Dashboard$Update$CleanupDeprecatedAttributes = F2(
	function (a, b) {
		return {$: 'CleanupDeprecatedAttributes', a: a, b: b};
	});
var $author$project$Conflicts$Dashboard$View$conflictSummaryView = F9(
	function (_v0, isLoaded, canBulkPublish, fields, title, fieldConflict, deprecatedCount, translations, countersList) {
		var siteName = _v0.a;
		return (_Utils_eq(
			title,
			$author$project$Translations$General$locationAttributes(translations)) && (deprecatedCount > 0)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-status-container pmt-conflict-summary pmt-conflict-status')
				]),
			_List_fromArray(
				[
					A7(
					$author$project$Conflicts$Dashboard$View$conflictSummaryItem,
					$author$project$Data$SiteName$SiteName(siteName),
					isLoaded,
					canBulkPublish,
					fields,
					title,
					fieldConflict,
					countersList),
					function () {
					var _v1 = _Utils_Tuple2(
						$elm$core$List$head(fields),
						canBulkPublish);
					if ((_v1.a.$ === 'Just') && _v1.b) {
						var field = _v1.a.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status-container__cleanup')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$PinMeTo$Ui$Btn$pmtBtn,
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-status-container__cleanup--button'),
											$elm$html$Html$Events$onClick(
											A2($author$project$Conflicts$Dashboard$Update$CleanupDeprecatedAttributes, siteName, field))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pmt-conflict-status-container__cleanup--button--aside')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fa fa-wand-magic-sparkles')
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cleanup-deprecated-button-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Translations$Listings$Tasks$cleanupDeprecated(translations) + (' (' + ($elm$core$String$fromInt(deprecatedCount) + ')')))
												]))
										]))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				])) : A7(
			$author$project$Conflicts$Dashboard$View$conflictSummaryItem,
			$author$project$Data$SiteName$SiteName(siteName),
			isLoaded,
			canBulkPublish,
			fields,
			title,
			fieldConflict,
			countersList);
	});
var $author$project$Conflicts$Dashboard$View$barndPageConflictItem = F4(
	function (_v0, isLoaded, title, conflictsCount) {
		var siteName = _v0.a;
		return (!isLoaded) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-summary__item pmt-conflict-status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__title'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-test',
							$author$project$Conflicts$Dashboard$View$nameToTasksDataTestId(title))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A3(
					$author$project$Util$flip,
					$author$project$Conflicts$Dashboard$View$skellify,
					isLoaded,
					A2(
						$elm$html$Html$dd,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-conflict-status__aside')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-conflict-status__info fa fa-fw fa-ellipsis-h')
									]),
								_List_Nil)
							])))
				])) : ((!conflictsCount) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-summary__item pmt-conflict-status pmt-conflict-status--clean')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__title'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-test',
							$author$project$Conflicts$Dashboard$View$nameToTasksDataTestId(title))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$dd,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__aside')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__info fa fa-fw fa-check')
								]),
							_List_Nil)
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-conflict-summary__item pmt-conflict-status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-status__link'),
							$elm$html$Html$Attributes$href(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									['/listings/', siteName, '/conflicts/facebook/brandpage'])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dt,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__title'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-test',
									$author$project$Conflicts$Dashboard$View$nameToTasksDataTestId(title))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$dd,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-status__count'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-test',
									$author$project$Conflicts$Dashboard$View$countToTasksDataTestId(title))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(conflictsCount))
								]))
						]))
				])));
	});
var $author$project$Conflicts$Dashboard$View$barndPageConflictsView = F5(
	function (_v0, isFacebookEnabled, title, isLoaded, conflictsCount) {
		var siteName = _v0.a;
		return (!isFacebookEnabled) ? $elm$html$Html$text('') : (_Utils_eq(conflictsCount, -1) ? $elm$html$Html$text('') : A4(
			$author$project$Conflicts$Dashboard$View$barndPageConflictItem,
			$author$project$Data$SiteName$SiteName(siteName),
			isLoaded,
			title,
			conflictsCount));
	});
var $author$project$Translations$General$review = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'general.review');
};
var $author$project$Conflicts$Dashboard$Model$SecondPage = {$: 'SecondPage'};
var $author$project$Translations$Listings$Conflicts$syncAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.sync_attributes');
};
var $author$project$Translations$Listings$Conflicts$syncingAttributes = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.syncing_attributes');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesBanner = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_banner');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesBannerCta = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_banner_cta');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesBannerTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_banner_title');
};
var $author$project$Conflicts$Dashboard$View$groupByGroupDisplayName = function (attributes) {
	return $elm$core$Dict$toList(
		A3(
			$elm$core$List$foldl,
			F2(
				function (attr, acc) {
					var existing = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, attr.groupDisplayName, acc));
					return A3(
						$elm$core$Dict$insert,
						attr.groupDisplayName,
						_Utils_ap(
							existing,
							_List_fromArray(
								[attr])),
						acc);
				}),
			$elm$core$Dict$empty,
			attributes.attributes));
};
var $author$project$Conflicts$Dashboard$View$googleAttributesGroupedView = function (remoteAttributes) {
	if (remoteAttributes.$ === 'Loaded') {
		var attributes = remoteAttributes.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var groupName = _v1.a;
					var attrs = _v1.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__attribute-group')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__attribute-group__title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(groupName)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$String$join,
											',  ',
											A2(
												$elm$core$List$map,
												function ($) {
													return $.displayName;
												},
												attrs)))
									]))
							]));
				},
				$author$project$Conflicts$Dashboard$View$groupByGroupDisplayName(attributes)));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Conflicts$Dashboard$Update$GoogleSuggestionsLightboxPage = function (a) {
	return {$: 'GoogleSuggestionsLightboxPage', a: a};
};
var $author$project$Conflicts$Dashboard$Update$ToggleGoogleSuggestionsLightbox = {$: 'ToggleGoogleSuggestionsLightbox'};
var $author$project$Conflicts$Dashboard$Update$ResolveGoogleAttributesConflicts = {$: 'ResolveGoogleAttributesConflicts'};
var $author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsTitle = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_suggestions_title');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsDetails = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_suggestions_details');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsWarning = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_suggestions_warning');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsIntroFirstLine = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_suggestions_intro_first_line');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsIntroThirdLine = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_suggestions_intro_third_line');
};
var $author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsIntroSecondLine = function (translations) {
	return A2($ChristophP$elm_i18next$I18Next$t, translations, 'listings.conflicts.google_attributes_suggestions_intro_second_line');
};
var $author$project$Conflicts$Dashboard$View$googleSuggestionsConflictView = F2(
	function (model, translations) {
		var googleAttributesConflictBanner = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__banner')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$Listings$Conflicts$googleAttributesBannerTitle(translations))
									])),
								$elm$html$Html$text(
								$author$project$Translations$Listings$Conflicts$googleAttributesBanner(translations))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__banner-button')
							]),
						_List_fromArray(
							[
								$author$project$PinMeTo$Ui$Button$render(
								A2(
									$author$project$PinMeTo$Ui$Button$withOnClick,
									$author$project$Conflicts$Dashboard$Update$ToggleGoogleSuggestionsLightbox,
									A2(
										$author$project$PinMeTo$Ui$Button$withSize,
										$author$project$PinMeTo$Ui$Button$Small,
										$author$project$PinMeTo$Ui$Button$buttonPrimary(
											$author$project$Translations$Listings$Conflicts$googleAttributesBannerCta(translations)))))
							]))
					]))
			]);
		var pageTwoContent = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__content'),
					$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__page-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsDetails(translations))
						])),
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Warning,
						$author$project$PinMeTo$Ui$Alert$plain(
							$author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsWarning(translations)))),
					$author$project$Conflicts$Dashboard$View$googleAttributesGroupedView(model.googleAttributesSuggestions)
				]));
		var pageOneContent = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('lightbox__content'),
					$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__page-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsIntroFirstLine(translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsIntroSecondLine(translations))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsIntroThirdLine(translations))
						]))
				]));
		var lightBoxPage = function () {
			var _v1 = model.googleSuggestionsLightboxPage;
			if (_v1.$ === 'FirstPage') {
				return pageOneContent;
			} else {
				return pageTwoContent;
			}
		}();
		var cancelButton = $author$project$PinMeTo$Ui$Button$render(
			A2(
				$author$project$PinMeTo$Ui$Button$withOnClick,
				$author$project$Conflicts$Dashboard$Update$ToggleGoogleSuggestionsLightbox,
				A2(
					$author$project$PinMeTo$Ui$Button$withGhostStyle,
					$author$project$PinMeTo$Ui$Button$GhostNeutral,
					$author$project$PinMeTo$Ui$Button$buttonGhost(
						$author$project$Translations$General$cancel(translations)))));
		var ctaButton = function () {
			var _v0 = model.googleSuggestionsLightboxPage;
			if (_v0.$ === 'FirstPage') {
				return $author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Conflicts$Dashboard$Update$GoogleSuggestionsLightboxPage($author$project$Conflicts$Dashboard$Model$SecondPage),
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$General$review(translations))));
			} else {
				return model.isResolvingGoogleAttributes ? $author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$disabledIfTrue,
						true,
						A2(
							$author$project$PinMeTo$Ui$Button$withOnClick,
							$author$project$Conflicts$Dashboard$Update$ResolveGoogleAttributesConflicts,
							$author$project$PinMeTo$Ui$Button$buttonPrimary(
								$author$project$Translations$Listings$Conflicts$syncingAttributes(translations))))) : $author$project$PinMeTo$Ui$Button$render(
					A2(
						$author$project$PinMeTo$Ui$Button$withOnClick,
						$author$project$Conflicts$Dashboard$Update$ResolveGoogleAttributesConflicts,
						$author$project$PinMeTo$Ui$Button$buttonPrimary(
							$author$project$Translations$Listings$Conflicts$syncAttributes(translations))));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$PinMeTo$Ui$Alert$render(
					A2(
						$author$project$PinMeTo$Ui$Alert$withStatus,
						$author$project$PinMeTo$Ui$Alert$Warning,
						$author$project$PinMeTo$Ui$Alert$rich(googleAttributesConflictBanner))),
					model.showGoogleSuggestionsLightbox ? $author$project$PinMeTo$Ui$Lightbox$render(
					A2(
						$author$project$PinMeTo$Ui$Lightbox$withStyle,
						$author$project$PinMeTo$Ui$Lightbox$Medium,
						$author$project$PinMeTo$Ui$Lightbox$withoutTitleBar(
							A2(
								$author$project$PinMeTo$Ui$Lightbox$withClose,
								$author$project$Conflicts$Dashboard$Update$ToggleGoogleSuggestionsLightbox,
								A2(
									$author$project$PinMeTo$Ui$Lightbox$withFooter,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pmt-google-attributes-suggestions__footer')
											]),
										_List_fromArray(
											[cancelButton, ctaButton])),
									A2(
										$author$project$PinMeTo$Ui$Lightbox$withHeader,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('lightbox__header ')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('lightbox__headline')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Translations$Listings$Conflicts$googleAttributesSuggestionsTitle(translations))
														]))
												])),
										$author$project$PinMeTo$Ui$Lightbox$view(
											{title: '', content: lightBoxPage}))))))) : $elm$html$Html$text('')
				]));
	});
var $author$project$Conflicts$Dashboard$View$view = F5(
	function (user, account, model, facebookBrandPageConflicts, translations) {
		var _v0 = function () {
			if (facebookBrandPageConflicts.$ === 'Loaded') {
				var count = facebookBrandPageConflicts.a;
				return _Utils_Tuple2(true, count);
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var isFacebookBrandPageConflictsCountLoaded = _v0.a;
		var facebookBrandPageConflictsCount = _v0.b;
		var resolveConflictsButton = function () {
			var _v3 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.total;
				},
				$author$project$RemoteData$currentData(model.conflictStatus));
			if (_v3.$ === 'Just') {
				var conflictCount = _v3.a;
				return (conflictCount > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-dashboard__justify-center')
						]),
					_List_fromArray(
						[
							$author$project$PinMeTo$Ui$Button$render(
							A2(
								$author$project$PinMeTo$Ui$Button$withHref,
								A2(
									$elm$core$String$join,
									'',
									_List_fromArray(
										[
											'/listings/',
											$author$project$Data$SiteName$toString(account.name),
											'/conflicts/resolve?fields=',
											A2(
											$elm$core$String$join,
											',',
											A2(
												$elm$core$List$map,
												$author$project$Data$Location$Field$toString,
												$author$project$Conflicts$Dashboard$View$visibleFields(user)))
										])),
								$author$project$PinMeTo$Ui$Button$buttonSecondary(
									$author$project$Translations$Listings$Tasks$solveByLocation(translations) + (' (' + ($elm$core$String$fromInt(conflictCount) + ')')))))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-dashboard__justify-center')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$PinMeTo$Ui$Btn$pmtBtnPlain,
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$disabled(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Tasks$solveByLocation(translations) + (' (' + ($elm$core$String$fromInt(conflictCount) + ')')))
								]))
						]));
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pmt-conflict-dashboard__justify-center')
						]),
					_List_Nil);
			}
		}();
		var fieldConflictForField = function (f) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Data$ConflictStatus$fieldConflictEmpty,
				A2(
					$elm$core$Maybe$map,
					f,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fields;
						},
						$author$project$RemoteData$currentData(model.conflictStatus))));
		};
		var hasGoogleSuggestions = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (count) {
					return count > 0;
				},
				$author$project$RemoteData$currentData(model.googleSuggestionsCount)));
		var deprecatedCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$RemoteData$currentData(model.deprecatedAttributesCount));
		var conflictInfoBox = A2(
			$author$project$PinMeTo$Ui$PopOver$withLink,
			{
				href: 'https://help.pinmeto.com/en/article/listings-what-are-conflicts-and-how-to-handle-them-suhf32/',
				text: $author$project$Translations$Listings$Tasks$conflictsOccurLink(translations)
			},
			$author$project$PinMeTo$Ui$PopOver$view(
				{
					uid: 'conflict-info-box',
					tagger: $author$project$Conflicts$Dashboard$Update$PopOverMsg,
					content: _List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$Listings$Tasks$conflictsOccur(translations))
						]),
					preferredDirection: $author$project$PinMeTo$Ui$PopOver$BottomRight
				}));
		var isLoaded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					return true;
				},
				$author$project$RemoteData$currentData(model.conflictStatus)));
		var fieldView = F4(
			function (fields, canBulkPublish, fieldName, fieldConflict) {
				var fields_ = A2(
					$elm$core$List$filter,
					$author$project$Conflicts$Dashboard$View$fieldVisible(user),
					fields);
				return ($elm$core$List$length(fields_) > 0) ? A9($author$project$Conflicts$Dashboard$View$conflictSummaryView, account.name, isLoaded, canBulkPublish, fields_, fieldName, fieldConflict, deprecatedCount, translations, _List_Nil) : $elm$html$Html$text('');
			});
		var multiFieldsView = F4(
			function (fields, canBulkPublish, fieldName, fieldConflictList) {
				var combinedFields = A3(
					$elm$core$List$foldl,
					F2(
						function (value, acc) {
							return _Utils_update(
								acc,
								{
									work: A2($elm$core$List$append, acc.work, value.work),
									count: acc.count + value.count,
									isPublishing: acc.isPublishing || value.isPublishing
								});
						}),
					{work: _List_Nil, count: 0, isPublishing: false},
					fieldConflictList);
				var countersList = A2(
					$elm$core$List$map,
					function ($) {
						return $.count;
					},
					fieldConflictList);
				var fields_ = A2(
					$elm$core$List$filter,
					$author$project$Conflicts$Dashboard$View$fieldVisible(user),
					fields);
				return ($elm$core$List$length(fields_) > 0) ? A9($author$project$Conflicts$Dashboard$View$conflictSummaryView, account.name, isLoaded, canBulkPublish, fields_, fieldName, combinedFields, deprecatedCount, translations, countersList) : $elm$html$Html$text('');
			});
		var conflictsCard = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('util__inset')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pmt-conflict-dashboard__header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$Listings$Tasks$conflicts(translations)),
									A2($author$project$PinMeTo$Ui$PopOver$renderPlain, model.popOverState, conflictInfoBox)
								])),
							A3($author$project$Conflicts$ListingsManagerSetup$view, account.name, model.listingsManagerPoliciesEnabled, translations),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('grid__item pmt-conflict-dashboard__fields')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$dl,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pmt-conflict-summary ')
										]),
									_List_fromArray(
										[
											A4(
											fieldView,
											_List_fromArray(
												[
													$author$project$Data$Location$Field$Name,
													$author$project$Data$Location$Field$CustomName($author$project$Data$Network$Facebook),
													$author$project$Data$Location$Field$CustomName($author$project$Data$Network$Google)
												]),
											true,
											$author$project$Translations$General$name(translations),
											fieldConflictForField(
												function ($) {
													return $.name;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$StoreId]),
											true,
											$author$project$Translations$General$locationStoreId(translations),
											fieldConflictForField(
												function ($) {
													return $.storeId;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$LocationDescriptor]),
											true,
											$author$project$Translations$General$locationDescriptor(translations),
											fieldConflictForField(
												function ($) {
													return $.locationDescriptor;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[
													$author$project$Data$Location$Field$ProfileImage($author$project$Data$Network$Facebook),
													$author$project$Data$Location$Field$CoverImage($author$project$Data$Network$Facebook),
													$author$project$Data$Location$Field$ProfileImage($author$project$Data$Network$Google),
													$author$project$Data$Location$Field$CoverImage($author$project$Data$Network$Google)
												]),
											false,
											$author$project$Translations$Listings$Tasks$profileCoverImage(translations),
											fieldConflictForField(
												function ($) {
													return $.images;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$Email]),
											true,
											$author$project$Translations$General$locationEmail(translations),
											fieldConflictForField(
												function ($) {
													return $.email;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$Homepage]),
											true,
											$author$project$Translations$General$locationHomepage(translations),
											fieldConflictForField(
												function ($) {
													return $.homepage;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$Phone]),
											true,
											$author$project$Translations$General$locationPhone(translations),
											fieldConflictForField(
												function ($) {
													return $.phone;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$About]),
											true,
											$author$project$Translations$General$locationShortDescription(translations),
											fieldConflictForField(
												function ($) {
													return $.about;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$LongDescription]),
											true,
											$author$project$Translations$General$locationLongDescription(translations),
											fieldConflictForField(
												function ($) {
													return $.longDescription;
												})),
											A4(
											multiFieldsView,
											_List_fromArray(
												[$author$project$Data$Location$Field$Address, $author$project$Data$Location$Field$ServiceAreas]),
											true,
											$author$project$Translations$General$locationAddress(translations) + (' & ' + $author$project$Translations$General$serviceAreas(translations)),
											_List_fromArray(
												[
													fieldConflictForField(
													function ($) {
														return $.address;
													}),
													fieldConflictForField(
													function ($) {
														return $.serviceAreas;
													})
												])),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$Location]),
											true,
											$author$project$Translations$Listings$Tasks$locationLatLong(translations),
											fieldConflictForField(
												function ($) {
													return $.location;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$Hours]),
											true,
											$author$project$Translations$General$locationOpenHours(translations),
											fieldConflictForField(
												function ($) {
													return $.hours;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$OpeningDate]),
											true,
											$author$project$Translations$General$locationOpeningDate(translations),
											fieldConflictForField(
												function ($) {
													return $.openingDate;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$SpecialHours]),
											true,
											$author$project$Translations$General$locationSpecialHours(translations),
											fieldConflictForField(
												function ($) {
													return $.specialOpenHours;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$PermanentlyClosed]),
											true,
											$author$project$Translations$General$locationPermanentlyClosed(translations),
											fieldConflictForField(
												function ($) {
													return $.permanentlyClosed;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$TemporarilyClosedUntil]),
											true,
											$author$project$Translations$General$locationTempClosed(translations),
											fieldConflictForField(
												function ($) {
													return $.temporarilyClosedUntil;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[
													$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Facebook),
													$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Google),
													$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Bing),
													$author$project$Data$Location$Field$NetworkCategories($author$project$Data$Network$Apple)
												]),
											true,
											$author$project$Translations$General$locationNetworkCategories(translations),
											fieldConflictForField(
												function ($) {
													return $.networkCategories;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[$author$project$Data$Location$Field$ActionLinks]),
											true,
											$author$project$Translations$General$locationActionLinks(translations),
											fieldConflictForField(
												function ($) {
													return $.networkActionLinks;
												})),
											A5(
											$author$project$Conflicts$Dashboard$View$barndPageConflictsView,
											account.name,
											A2($elm$core$List$member, $author$project$Data$Network$Facebook, account.networks),
											$author$project$Translations$Listings$Tasks$brandPageConflicts(translations),
											isFacebookBrandPageConflictsCountLoaded,
											facebookBrandPageConflictsCount),
											A4(
											fieldView,
											_List_fromArray(
												[
													$author$project$Data$Location$Field$NetworkServiceItems($author$project$Data$Network$Google)
												]),
											true,
											$author$project$Translations$General$locationServiceItems(translations),
											fieldConflictForField(
												function ($) {
													return $.networkServiceItems;
												})),
											A4(
											fieldView,
											_List_fromArray(
												[
													$author$project$Data$Location$Field$NetworkAttributes($author$project$Data$Network$Google)
												]),
											true,
											$author$project$Translations$General$locationAttributes(translations),
											fieldConflictForField(
												function ($) {
													return $.networkAttributes;
												}))
										]))
								])),
							A3($author$project$Util$flip, $author$project$Conflicts$Dashboard$View$skellify, isLoaded, resolveConflictsButton)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					hasGoogleSuggestions ? A2($author$project$Conflicts$Dashboard$View$googleSuggestionsConflictView, model, translations) : $elm$html$Html$text(''),
					conflictsCard
				]));
	});
var $author$project$Data$User$UserIsNotCustomerSuccess = {$: 'UserIsNotCustomerSuccess'};
var $author$project$Conflicts$Main$view = F2(
	function (session, model) {
		var userIsCustomerSuccess = (A2($elm$core$List$member, $author$project$Data$User$CustomerSuccess, session.user.localAccess.roles) && (!session.user.isDemo)) ? $author$project$Data$User$UserIsCustomerSuccess : $author$project$Data$User$UserIsNotCustomerSuccess;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pmt-dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Conflicts$Main$ConflictsMsg,
					A5($author$project$Conflicts$Dashboard$View$view, userIsCustomerSuccess, model.account, model.conflicts, model.facebookBrandPageConflicts, session.translations))
				]));
	});
var $author$project$Data$ConflictStatus$FieldData$map = F2(
	function (f, x) {
		return _Utils_update(
			x,
			{
				name: f(x.name),
				about: f(x.about),
				email: f(x.email),
				hours: f(x.hours),
				phone: f(x.phone),
				images: f(x.images),
				address: f(x.address),
				storeId: f(x.storeId),
				homepage: f(x.homepage),
				location: f(x.location),
				openingDate: f(x.openingDate),
				longDescription: f(x.longDescription),
				specialOpenHours: f(x.specialOpenHours),
				networkAttributes: f(x.networkAttributes),
				networkCategories: f(x.networkCategories),
				permanentlyClosed: f(x.permanentlyClosed),
				locationDescriptor: f(x.locationDescriptor),
				networkActionLinks: f(x.networkActionLinks),
				temporarilyClosedUntil: f(x.temporarilyClosedUntil)
			});
	});
var $author$project$Data$ConflictStatus$updateInField = F3(
	function (field, f, x) {
		switch (field.$) {
			case 'Name':
				return _Utils_update(
					x,
					{
						name: f(x.name)
					});
			case 'CustomName':
				return _Utils_update(
					x,
					{
						name: f(x.name)
					});
			case 'StoreId':
				return _Utils_update(
					x,
					{
						storeId: f(x.storeId)
					});
			case 'LocationDescriptor':
				return _Utils_update(
					x,
					{
						locationDescriptor: f(x.locationDescriptor)
					});
			case 'Location':
				return _Utils_update(
					x,
					{
						location: f(x.location)
					});
			case 'About':
				return _Utils_update(
					x,
					{
						about: f(x.about)
					});
			case 'LongDescription':
				return _Utils_update(
					x,
					{
						longDescription: f(x.longDescription)
					});
			case 'Hours':
				return _Utils_update(
					x,
					{
						hours: f(x.hours)
					});
			case 'OpeningDate':
				return _Utils_update(
					x,
					{
						openingDate: f(x.openingDate)
					});
			case 'SpecialHours':
				return _Utils_update(
					x,
					{
						specialOpenHours: f(x.specialOpenHours)
					});
			case 'PermanentlyClosed':
				return _Utils_update(
					x,
					{
						permanentlyClosed: f(x.permanentlyClosed)
					});
			case 'TemporarilyClosedUntil':
				return _Utils_update(
					x,
					{
						temporarilyClosedUntil: f(x.temporarilyClosedUntil)
					});
			case 'Email':
				return _Utils_update(
					x,
					{
						email: f(x.email)
					});
			case 'Homepage':
				return _Utils_update(
					x,
					{
						homepage: f(x.homepage)
					});
			case 'Phone':
				return _Utils_update(
					x,
					{
						phone: f(x.phone)
					});
			case 'Address':
				return _Utils_update(
					x,
					{
						address: f(x.address)
					});
			case 'CoverImage':
				return _Utils_update(
					x,
					{
						images: f(x.images)
					});
			case 'ProfileImage':
				return _Utils_update(
					x,
					{
						images: f(x.images)
					});
			case 'NetworkCategories':
				return _Utils_update(
					x,
					{
						networkCategories: f(x.networkCategories)
					});
			case 'NetworkAttributes':
				return _Utils_update(
					x,
					{
						networkAttributes: f(x.networkAttributes)
					});
			case 'ActionLinks':
				return _Utils_update(
					x,
					{
						networkActionLinks: f(x.networkActionLinks)
					});
			case 'NetworkServiceItems':
				return _Utils_update(
					x,
					{
						networkServiceItems: f(x.networkServiceItems)
					});
			case 'ServiceAreas':
				return _Utils_update(
					x,
					{
						serviceAreas: f(x.serviceAreas)
					});
			case 'Wifi':
				return x;
			default:
				return x;
		}
	});
var $author$project$Conflicts$Dashboard$Update$OnFeatureFlags = function (a) {
	return {$: 'OnFeatureFlags', a: a};
};
var $author$project$PinMeTo$FeatureFlags$flag = function (key) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			[key, 'enabled']),
		$elm$json$Json$Decode$bool,
		false);
};
var $author$project$PinMeTo$FeatureFlags$Model = F9(
	function (publicApi, networks, listings, places, locationPosts, accountSettings, listenRespond, locator, localCampaigns) {
		return {places: places, locator: locator, listings: listings, networks: networks, publicApi: publicApi, listenRespond: listenRespond, locationPosts: locationPosts, localCampaigns: localCampaigns, accountSettings: accountSettings};
	});
var $author$project$PinMeTo$FeatureFlags$Places = function (api) {
	return {api: api};
};
var $author$project$PinMeTo$FeatureFlags$placesDecoder = A2(
	$author$project$PinMeTo$FeatureFlags$flag,
	'api',
	$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$Places));
var $author$project$PinMeTo$FeatureFlags$Listings = F8(
	function (specialOpenHours, allowCustomStoreNames, allowGoogleCustomName, allowFacebookCustomName, newNavigation, serviceArea, allowAppleOauth, allowPtvTwoWay) {
		return {serviceArea: serviceArea, newNavigation: newNavigation, allowPtvTwoWay: allowPtvTwoWay, allowAppleOauth: allowAppleOauth, specialOpenHours: specialOpenHours, allowCustomStoreNames: allowCustomStoreNames, allowGoogleCustomName: allowGoogleCustomName, allowFacebookCustomName: allowFacebookCustomName};
	});
var $author$project$PinMeTo$FeatureFlags$listingsDecoder = A2(
	$author$project$PinMeTo$FeatureFlags$flag,
	'allowPtvTwoWay',
	A2(
		$author$project$PinMeTo$FeatureFlags$flag,
		'allowAppleOauth',
		A2(
			$author$project$PinMeTo$FeatureFlags$flag,
			'serviceArea',
			A2(
				$author$project$PinMeTo$FeatureFlags$flag,
				'newNavigation',
				A2(
					$author$project$PinMeTo$FeatureFlags$flag,
					'allowFacebookCustomName',
					A2(
						$author$project$PinMeTo$FeatureFlags$flag,
						'allowGoogleCustomName',
						A2(
							$author$project$PinMeTo$FeatureFlags$flag,
							'allowCustomStoreNames',
							A2(
								$author$project$PinMeTo$FeatureFlags$flag,
								'specialOpenHours',
								$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$Listings)))))))));
var $author$project$PinMeTo$FeatureFlags$Networks = function (yelp) {
	return function (instagram) {
		return function (google) {
			return function (foursquare) {
				return function (facebook) {
					return function (apple) {
						return function (yandex) {
							return function (baidu) {
								return function (wechat) {
									return function (here) {
										return function (bing) {
											return function (tomtom) {
												return function (trustpilot) {
													return function (ptv) {
														return {ptv: ptv, bing: bing, here: here, yelp: yelp, apple: apple, baidu: baidu, google: google, tomtom: tomtom, wechat: wechat, yandex: yandex, facebook: facebook, instagram: instagram, foursquare: foursquare, trustpilot: trustpilot};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PinMeTo$FeatureFlags$networksDecoder = A2(
	$author$project$PinMeTo$FeatureFlags$flag,
	'ptv',
	A2(
		$author$project$PinMeTo$FeatureFlags$flag,
		'trustpilot',
		A2(
			$author$project$PinMeTo$FeatureFlags$flag,
			'tomtom',
			A2(
				$author$project$PinMeTo$FeatureFlags$flag,
				'bing',
				A2(
					$author$project$PinMeTo$FeatureFlags$flag,
					'here',
					A2(
						$author$project$PinMeTo$FeatureFlags$flag,
						'wechat',
						A2(
							$author$project$PinMeTo$FeatureFlags$flag,
							'baidu',
							A2(
								$author$project$PinMeTo$FeatureFlags$flag,
								'yandex',
								A2(
									$author$project$PinMeTo$FeatureFlags$flag,
									'apple',
									A2(
										$author$project$PinMeTo$FeatureFlags$flag,
										'facebook',
										A2(
											$author$project$PinMeTo$FeatureFlags$flag,
											'foursquare',
											A2(
												$author$project$PinMeTo$FeatureFlags$flag,
												'google',
												A2(
													$author$project$PinMeTo$FeatureFlags$flag,
													'instagram',
													A2(
														$author$project$PinMeTo$FeatureFlags$flag,
														'yelp',
														$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$Networks)))))))))))))));
var $author$project$PinMeTo$FeatureFlags$ListenRespond = function (hasNoFeatureFlagsYetSoThisIsJustADummy) {
	return {hasNoFeatureFlagsYetSoThisIsJustADummy: hasNoFeatureFlagsYetSoThisIsJustADummy};
};
var $author$project$PinMeTo$FeatureFlags$listenRespondDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$ListenRespond));
var $author$project$PinMeTo$FeatureFlags$LocationPosts = F9(
	function (locationPost, newNavigation, instagramCarouselPosts, instagramReels, api, linkedin, google, instagram, facebook) {
		return {api: api, google: google, facebook: facebook, linkedin: linkedin, instagram: instagram, locationPost: locationPost, newNavigation: newNavigation, instagramReels: instagramReels, instagramCarouselPosts: instagramCarouselPosts};
	});
var $author$project$PinMeTo$FeatureFlags$locationPostsDecoder = A2(
	$author$project$PinMeTo$FeatureFlags$flag,
	'facebookPost',
	A2(
		$author$project$PinMeTo$FeatureFlags$flag,
		'instagramPost',
		A2(
			$author$project$PinMeTo$FeatureFlags$flag,
			'googlePost',
			A2(
				$author$project$PinMeTo$FeatureFlags$flag,
				'linkedinPost',
				A2(
					$author$project$PinMeTo$FeatureFlags$flag,
					'api',
					A2(
						$author$project$PinMeTo$FeatureFlags$flag,
						'instagramReels',
						A2(
							$author$project$PinMeTo$FeatureFlags$flag,
							'instagramCarouselPosts',
							A2(
								$author$project$PinMeTo$FeatureFlags$flag,
								'newNavigation',
								A2(
									$author$project$PinMeTo$FeatureFlags$flag,
									'locationPost',
									$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$LocationPosts))))))))));
var $author$project$PinMeTo$FeatureFlags$AccountSettings = F4(
	function (sso, ignoreGlobalBrandPageIdOnConnect, aiIntegration, allowMessagingConfiguration) {
		return {sso: sso, aiIntegration: aiIntegration, allowMessagingConfiguration: allowMessagingConfiguration, ignoreGlobalBrandPageIdOnConnect: ignoreGlobalBrandPageIdOnConnect};
	});
var $author$project$PinMeTo$FeatureFlags$accountSettingsDecoder = A2(
	$author$project$PinMeTo$FeatureFlags$flag,
	'allowMessagingConfiguration',
	A2(
		$author$project$PinMeTo$FeatureFlags$flag,
		'aiIntegration',
		A2(
			$author$project$PinMeTo$FeatureFlags$flag,
			'ignoreGlobalBrandPageIdOnConnect',
			A2(
				$author$project$PinMeTo$FeatureFlags$flag,
				'sso',
				$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$AccountSettings)))));
var $author$project$PinMeTo$FeatureFlags$modelDecoder = A2(
	$author$project$PinMeTo$FeatureFlags$flag,
	'localCampaigns',
	A2(
		$author$project$PinMeTo$FeatureFlags$flag,
		'locator',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'listenRespond',
			$author$project$PinMeTo$FeatureFlags$listenRespondDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'accountSettings',
				$author$project$PinMeTo$FeatureFlags$accountSettingsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'socialMedia',
					$author$project$PinMeTo$FeatureFlags$locationPostsDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'places',
						$author$project$PinMeTo$FeatureFlags$placesDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'listings',
							$author$project$PinMeTo$FeatureFlags$listingsDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'networks',
								$author$project$PinMeTo$FeatureFlags$networksDecoder,
								A2(
									$author$project$PinMeTo$FeatureFlags$flag,
									'publicApi',
									$elm$json$Json$Decode$succeed($author$project$PinMeTo$FeatureFlags$Model))))))))));
var $author$project$PinMeTo$FeatureFlags$featureFlagsDecoder = A2($elm$json$Json$Decode$map, $author$project$PinMeTo$FeatureFlags$FeatureFlags, $author$project$PinMeTo$FeatureFlags$modelDecoder);
var $author$project$PinMeTo$FeatureFlags$getFeatureFlags = F2(
	function (siteName, msg) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				A2($elm$http$Http$expectJson, msg, $author$project$PinMeTo$FeatureFlags$featureFlagsDecoder),
				$lukewestby$elm_http_builder$HttpBuilder$get('api/' + (siteName + '/featureflags'))));
	});
var $author$project$Data$ConflictStatus$FieldData$toList = function (x) {
	return _List_fromArray(
		[x.name, x.storeId, x.locationDescriptor, x.location, x.about, x.longDescription, x.hours, x.openingDate, x.specialOpenHours, x.permanentlyClosed, x.temporarilyClosedUntil, x.email, x.homepage, x.phone, x.address, x.images, x.networkCategories, x.networkAttributes, x.networkActionLinks]);
};
var $author$project$Data$ConflictStatus$conflictsWithoutWork = function (x) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$elm$core$List$isEmpty,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.work;
				},
				$author$project$Data$ConflictStatus$FieldData$toList(x))));
};
var $author$project$Conflicts$Dashboard$Update$OnBulkPublishFieldResult = F2(
	function (a, b) {
		return {$: 'OnBulkPublishFieldResult', a: a, b: b};
	});
var $author$project$Conflicts$Commands$PublishFieldResult = F3(
	function (success, work, field) {
		return {work: work, field: field, success: success};
	});
var $author$project$Conflicts$Commands$PartialUpdate = F2(
	function (locationId, workId) {
		return {workId: workId, locationId: locationId};
	});
var $author$project$Conflicts$Commands$partialUpdateDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'workId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['place', '_id']),
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Conflicts$Commands$PartialUpdate)));
var $author$project$Conflicts$Commands$publishFieldResultDecoder = function (field) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		field,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'data',
			$elm$json$Json$Decode$nullable($author$project$Conflicts$Commands$partialUpdateDecoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'success',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Conflicts$Commands$PublishFieldResult))));
};
var $author$project$Data$GoogleAttributes$Api$keepOurAttributesAsTheTruthOnConflictingLocations = F2(
	function (siteName, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				$lukewestby$elm_http_builder$HttpBuilder$post(
					$author$project$Data$GoogleAttributes$Api$siteUrl(siteName) + '/places/google/attributes/keepOurs')));
	});
var $author$project$Conflicts$Commands$publishFieldForLocations = F3(
	function (account, field, msg) {
		if (field.$ === 'NetworkAttributes') {
			return A2(
				$author$project$Data$GoogleAttributes$Api$keepOurAttributesAsTheTruthOnConflictingLocations,
				account.name,
				A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$Conflicts$Commands$publishFieldResultDecoder(field)));
		} else {
			return $lukewestby$elm_http_builder$HttpBuilder$request(
				A2(
					$lukewestby$elm_http_builder$HttpBuilder$withExpect,
					A2(
						$elm$http$Http$expectJson,
						msg,
						$author$project$Conflicts$Commands$publishFieldResultDecoder(field)),
					$lukewestby$elm_http_builder$HttpBuilder$post(
						'api/' + ($author$project$Data$SiteName$toString(account.name) + ('/conflicts/fieldpublish/' + $author$project$Data$Location$Field$toString(field))))));
		}
	});
var $author$project$Data$GoogleAttributes$Api$addSuggestedAttributesFromGoogle = F2(
	function (siteName, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				$lukewestby$elm_http_builder$HttpBuilder$post(
					$author$project$Data$GoogleAttributes$Api$siteUrl(siteName) + '/google/attributes/addSuggestedFromGoogle')));
	});
var $author$project$Conflicts$Dashboard$Commands$solveGoogleAttributesConflicts = F2(
	function (siteName, msg) {
		return A2(
			$author$project$Data$GoogleAttributes$Api$addSuggestedAttributesFromGoogle,
			siteName,
			$elm$http$Http$expectWhatever(msg));
	});
var $author$project$Conflicts$Dashboard$Update$OnResolveGoogleAttributesConflicts = function (a) {
	return {$: 'OnResolveGoogleAttributesConflicts', a: a};
};
var $author$project$Data$GoogleAttributes$Api$removeAttributesGoogleNoLongerSupports = F2(
	function (siteName, expect) {
		return $lukewestby$elm_http_builder$HttpBuilder$request(
			A2(
				$lukewestby$elm_http_builder$HttpBuilder$withExpect,
				expect,
				$lukewestby$elm_http_builder$HttpBuilder$put(
					$author$project$Data$GoogleAttributes$Api$siteUrl(siteName) + '/google/attributes/removeUnsupported')));
	});
var $author$project$Conflicts$Commands$cleanupDeprecatedAttributesConflicts = F3(
	function (siteName, field, msg) {
		return A2(
			$author$project$Data$GoogleAttributes$Api$removeAttributesGoogleNoLongerSupports,
			$author$project$Data$SiteName$SiteName(siteName),
			A2(
				$elm$http$Http$expectJson,
				msg,
				$author$project$Conflicts$Commands$publishFieldResultDecoder(field)));
	});
var $author$project$Conflicts$Dashboard$Update$out_Conflicts_Main_bulkPublishFieldConfirmAlert = _Platform_outgoingPort(
	'out_Conflicts_Main_bulkPublishFieldConfirmAlert',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'count',
					$elm$json$Json$Encode$int($.count)),
					_Utils_Tuple2(
					'field',
					$elm$json$Json$Encode$string($.field)),
					_Utils_Tuple2(
					'accountName',
					$elm$json$Json$Encode$string($.accountName)),
					_Utils_Tuple2(
					'fieldDisplayName',
					$elm$json$Json$Encode$string($.fieldDisplayName))
				]));
	});
var $author$project$Conflicts$Dashboard$Update$update = F4(
	function (translations, account, msg, model) {
		switch (msg.$) {
			case 'OnConflictStatus':
				if (msg.a.$ === 'Ok') {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								conflictStatus: $author$project$RemoteData$Loaded(data)
							}),
						A2(
							$author$project$PinMeTo$FeatureFlags$getFeatureFlags,
							$author$project$Data$SiteName$toString(account.name),
							$author$project$Conflicts$Dashboard$Update$OnFeatureFlags));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								conflictStatus: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(e))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDeprecatedAttributesCount':
				if (msg.a.$ === 'Ok') {
					var count = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								deprecatedAttributesCount: $author$project$RemoteData$Loaded(count)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								deprecatedAttributesCount: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(e))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'BulkPublishFieldConfirmAlert':
				var siteName = msg.a;
				var field = msg.b;
				var conflictCount = msg.c;
				return _Utils_Tuple2(
					model,
					$author$project$Conflicts$Dashboard$Update$out_Conflicts_Main_bulkPublishFieldConfirmAlert(
						{
							count: conflictCount,
							field: $author$project$Data$Location$Field$toString(field),
							accountName: $author$project$Data$SiteName$toString(siteName),
							fieldDisplayName: A2($author$project$Data$Location$Field$toHumanReadable, field, translations)
						}));
			case 'BulkPublishField':
				var field = msg.a.field;
				var _v1 = _Utils_Tuple2(
					$author$project$RemoteData$currentData(model.conflictStatus),
					$author$project$Data$Location$Field$fromString(field));
				if ((_v1.a.$ === 'Just') && (_v1.b.$ === 'Just')) {
					var data = _v1.a.a;
					var field_ = _v1.b.a;
					return function (x) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStatus: $author$project$RemoteData$Loaded(x)
								}),
							A3(
								$author$project$Conflicts$Commands$publishFieldForLocations,
								account,
								field_,
								$author$project$Conflicts$Dashboard$Update$OnBulkPublishFieldResult(field_)));
					}(
						_Utils_update(
							data,
							{
								fields: A3(
									$author$project$Data$ConflictStatus$updateInField,
									field_,
									function (x) {
										return _Utils_update(
											x,
											{isPublishing: true});
									},
									data.fields)
							}));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'CleanupDeprecatedAttributes':
				var siteName = msg.a;
				var field = msg.b;
				var _v2 = $author$project$RemoteData$currentData(model.conflictStatus);
				if (_v2.$ === 'Just') {
					var data = _v2.a;
					return function (x) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStatus: $author$project$RemoteData$Loaded(x)
								}),
							A3(
								$author$project$Conflicts$Commands$cleanupDeprecatedAttributesConflicts,
								siteName,
								field,
								$author$project$Conflicts$Dashboard$Update$OnBulkPublishFieldResult(field)));
					}(
						_Utils_update(
							data,
							{
								fields: A3(
									$author$project$Data$ConflictStatus$updateInField,
									field,
									function (x) {
										return _Utils_update(
											x,
											{isPublishing: true});
									},
									data.fields)
							}));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnBulkPublishFieldResult':
				if (msg.b.$ === 'Ok') {
					var data = msg.b.a;
					var addWork = function (fieldConflict) {
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							fieldConflict,
							function (work) {
								return _Utils_update(
									fieldConflict,
									{
										work: A2($elm$core$List$cons, work.workId, fieldConflict.work)
									});
							},
							data.work);
					};
					var newModel = A2(
						$elm$core$Maybe$withDefault,
						model,
						A2(
							$elm$core$Maybe$map,
							function (x) {
								return _Utils_update(
									model,
									{
										conflictStatus: $author$project$RemoteData$Loaded(
											_Utils_update(
												x,
												{
													fields: A3($author$project$Data$ConflictStatus$updateInField, data.field, addWork, x.fields)
												}))
									});
							},
							$author$project$RemoteData$currentData(model.conflictStatus)));
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var field = msg.a;
					var err = msg.b.a;
					var newModel = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						model,
						function (data_) {
							return _Utils_update(
								model,
								{
									conflictStatus: $author$project$RemoteData$Loaded(
										_Utils_update(
											data_,
											{
												fields: A3(
													$author$project$Data$ConflictStatus$updateInField,
													field,
													function (x) {
														return _Utils_update(
															x,
															{isPublishing: false});
													},
													data_.fields)
											}))
								});
						},
						$author$project$RemoteData$currentData(model.conflictStatus));
					return _Utils_Tuple2(
						newModel,
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Conflicts.Dashboard.Update', message: 'Failed to handle result for msg OnBulkPublishFieldResult'}));
				}
			case 'WorkCompleted':
				var workId = msg.a;
				var removeWork = function (fieldConflict) {
					return _Utils_update(
						fieldConflict,
						{
							work: A2(
								$elm$core$List$filter,
								function (x) {
									return !_Utils_eq(x, workId);
								},
								fieldConflict.work)
						});
				};
				var newConflictStatus = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					model.conflictStatus,
					function (x) {
						return $author$project$RemoteData$Loaded(
							_Utils_update(
								x,
								{
									fields: A2($author$project$Data$ConflictStatus$FieldData$map, removeWork, x.fields)
								}));
					},
					$author$project$RemoteData$currentData(model.conflictStatus));
				var before = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					0,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fields;
						},
						$author$project$Data$ConflictStatus$conflictsWithoutWork),
					$author$project$RemoteData$currentData(model.conflictStatus));
				var after = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					0,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fields;
						},
						$author$project$Data$ConflictStatus$conflictsWithoutWork),
					$author$project$RemoteData$currentData(newConflictStatus));
				var conflictsWasCompleted = !_Utils_eq(before, after);
				var cmd = conflictsWasCompleted ? A2($author$project$Conflicts$Commands$getConflictStatus, account, $author$project$Conflicts$Dashboard$Update$OnConflictStatus) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{conflictStatus: newConflictStatus}),
					cmd);
			case 'OnFeatureFlags':
				if (msg.a.$ === 'Ok') {
					var flags = msg.a.a;
					var _v3 = $author$project$RemoteData$currentData(model.conflictStatus);
					if (_v3.$ === 'Just') {
						var model_ = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStatus: $author$project$RemoteData$Loaded(
										_Utils_update(
											model_,
											{
												featureFlags: $author$project$RemoteData$Loaded(flags)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$logHttpError(
						{data: err, context: 'Conflicts.Dashboard.Update', message: 'Failed to handle result for msg OnFeatureFlags'});
					var _v4 = $author$project$RemoteData$currentData(model.conflictStatus);
					if (_v4.$ === 'Just') {
						var model_ = _v4.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									conflictStatus: $author$project$RemoteData$Loaded(
										_Utils_update(
											model_,
											{
												featureFlags: $author$project$RemoteData$Error(
													$author$project$Util$httpErrorToString(err))
											}))
								}),
							cmd);
					} else {
						return _Utils_Tuple2(model, cmd);
					}
				}
			case 'PopOverMsg':
				var subMsg = msg.a;
				var _v5 = A3($author$project$PinMeTo$Ui$PopOver$update, $author$project$Conflicts$Dashboard$Update$PopOverMsg, subMsg, model.popOverState);
				var popOverState = _v5.a;
				var popOverCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{popOverState: popOverState}),
					popOverCmd);
			case 'OnGoogleAttributesSuggestions':
				if (msg.a.$ === 'Ok') {
					var data = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								googleSuggestionsCount: $author$project$RemoteData$Loaded(
									$elm$core$List$length(data.attributes)),
								googleAttributesSuggestions: $author$project$RemoteData$Loaded(data)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								googleAttributesSuggestions: $author$project$RemoteData$Error(
									$author$project$PinMeTo$ExpectJson$getErrorMessage(e))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'ResolveGoogleAttributesConflicts':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{isResolvingGoogleAttributes: true}),
					A2($author$project$Conflicts$Dashboard$Commands$solveGoogleAttributesConflicts, account.name, $author$project$Conflicts$Dashboard$Update$OnResolveGoogleAttributesConflicts));
			case 'OnResolveGoogleAttributesConflicts':
				if (msg.a.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								googleSuggestionsCount: $author$project$RemoteData$Loaded(0),
								isResolvingGoogleAttributes: false,
								googleSuggestionsLightboxPage: $author$project$Conflicts$Dashboard$Model$FirstPage,
								showGoogleSuggestionsLightbox: false
							}),
						A2($author$project$Conflicts$Commands$getConflictStatus, account, $author$project$Conflicts$Dashboard$Update$OnConflictStatus));
				} else {
					var err = msg.a.a;
					var cmd = $author$project$PinMeTo$Logger$logHttpError(
						{data: err, context: 'Conflicts.Dashboard.Update', message: 'Failed to handle result for msg OnResoleveGoogleAttributesConflicts'});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{isResolvingGoogleAttributes: false}),
						cmd);
				}
			case 'ToggleGoogleSuggestionsLightbox':
				var lightboxToBeOpened = !model.showGoogleSuggestionsLightbox;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{googleSuggestionsLightboxPage: $author$project$Conflicts$Dashboard$Model$FirstPage, showGoogleSuggestionsLightbox: lightboxToBeOpened}),
					$elm$core$Platform$Cmd$none);
			case 'GoogleSuggestionsLightboxPage':
				var page = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{googleSuggestionsLightboxPage: page}),
					$elm$core$Platform$Cmd$none);
			default:
				if (msg.a.$ === 'Ok') {
					var hasEnabledPolicy = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								listingsManagerPoliciesEnabled: $author$project$RemoteData$Loaded(hasEnabledPolicy)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								listingsManagerPoliciesEnabled: $author$project$RemoteData$Error(
									$author$project$Util$httpErrorToString(err))
							}),
						$author$project$PinMeTo$Logger$logHttpError(
							{data: err, context: 'Conflicts.Dashboard.Update', message: 'Failed to handle result for msg OnListingsManagerPoliciesEnabled'}));
				}
		}
	});
var $author$project$Conflicts$Main$update = F3(
	function (session, msg, model) {
		if (msg.$ === 'ConflictsMsg') {
			var conflictsMsg = msg.a;
			var _v1 = A4($author$project$Conflicts$Dashboard$Update$update, session.translations, model.account, conflictsMsg, model.conflicts);
			var conflicts = _v1.a;
			var conflictsCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{conflicts: conflicts}),
				A2($elm$core$Platform$Cmd$map, $author$project$Conflicts$Main$ConflictsMsg, conflictsCmd));
		} else {
			var result = msg.a;
			if (result.$ === 'Ok') {
				var count = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							facebookBrandPageConflicts: $author$project$RemoteData$Loaded(count)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var err = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							facebookBrandPageConflicts: $author$project$RemoteData$Error(
								$author$project$PinMeTo$ExpectJson$getErrorMessage(err))
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Conflicts$Main$Flags = F2(
	function (siteName, account) {
		return {account: account, siteName: siteName};
	});
var $author$project$Conflicts$Main$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account',
	$author$project$Data$Account$accountDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'siteName',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Conflicts$Main$Flags)));
var $author$project$Conflicts$Dashboard$Update$WorkCompleted = function (a) {
	return {$: 'WorkCompleted', a: a};
};
var $author$project$Conflicts$Dashboard$Update$BulkPublishField = function (a) {
	return {$: 'BulkPublishField', a: a};
};
var $author$project$Conflicts$Main$in_Conflicts_Main_workFailed = _Platform_incomingPort('in_Conflicts_Main_workFailed', $elm$json$Json$Decode$string);
var $author$project$Conflicts$Main$in_Conflicts_Main_workSucceeded = _Platform_incomingPort('in_Conflicts_Main_workSucceeded', $elm$json$Json$Decode$string);
var $author$project$Conflicts$Main$in_Conflicts_Main_confirmConflictsBulkPublishField = _Platform_incomingPort(
	'in_Conflicts_Main_confirmConflictsBulkPublishField',
	A2(
		$elm$json$Json$Decode$andThen,
		function (accountName) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (field) {
					return $elm$json$Json$Decode$succeed(
						{field: field, accountName: accountName});
				},
				A2($elm$json$Json$Decode$field, 'field', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'accountName', $elm$json$Json$Decode$string)));
var $author$project$Conflicts$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Conflicts$Main$in_Conflicts_Main_confirmConflictsBulkPublishField(
				function (x) {
					return $author$project$Conflicts$Main$ConflictsMsg(
						$author$project$Conflicts$Dashboard$Update$BulkPublishField(
							{
								field: x.field,
								accountName: $author$project$Data$SiteName$SiteName(x.accountName)
							}));
				}),
				$author$project$Conflicts$Main$in_Conflicts_Main_workSucceeded(
				A2($elm$core$Basics$composeL, $author$project$Conflicts$Main$ConflictsMsg, $author$project$Conflicts$Dashboard$Update$WorkCompleted)),
				$author$project$Conflicts$Main$in_Conflicts_Main_workFailed(
				A2($elm$core$Basics$composeL, $author$project$Conflicts$Main$ConflictsMsg, $author$project$Conflicts$Dashboard$Update$WorkCompleted))
			]));
};
var $author$project$Conflicts$Main$main = $author$project$PinMeToPage$page(
	{init: $author$project$Conflicts$Main$init, view: $author$project$Conflicts$Main$view, update: $author$project$Conflicts$Main$update, flagsDecoder: $author$project$Conflicts$Main$flagsDecoder, subscriptions: $author$project$Conflicts$Main$subscriptions});
_Platform_export({'Tasks':{'PTV':{'Main':{'init':$author$project$Tasks$PTV$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$PTV$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Trustpilot':{'Main':{'init':$author$project$Tasks$Trustpilot$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Trustpilot$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Foursquare':{'Main':{'init':$author$project$Tasks$Foursquare$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Foursquare$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Overture':{'Main':{'init':$author$project$Tasks$Overture$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Overture$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Facebook':{'Main':{'init':$author$project$Tasks$Facebook$Main$main($elm$json$Json$Decode$value)(0)},'ReviewAndCreate':{'Main':{'init':$author$project$Tasks$Facebook$ReviewAndCreate$Main$main($elm$json$Json$Decode$value)(0)}}},'Tomtom':{'Main':{'init':$author$project$Tasks$Tomtom$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Tomtom$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Google':{'Main':{'init':$author$project$Tasks$Google$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Google$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Apple':{'Main':{'init':$author$project$Tasks$Apple$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Apple$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Here':{'Main':{'init':$author$project$Tasks$Here$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Here$Claim$Main$main($elm$json$Json$Decode$value)(0)}}},'Bing':{'Main':{'init':$author$project$Tasks$Bing$Main$main($elm$json$Json$Decode$value)(0)},'Claim':{'Main':{'init':$author$project$Tasks$Bing$Claim$Main$main($elm$json$Json$Decode$value)(0)}}}},'LocalCampaignLandingPage':{'Main':{'init':$author$project$LocalCampaignLandingPage$Main$main($elm$json$Json$Decode$value)(0)}},'BrandPageSelectorPort':{'init':$author$project$BrandPageSelectorPort$main($elm$json$Json$Decode$value)(0)},'LocationSelectorPort':{'init':$author$project$LocationSelectorPort$main($elm$json$Json$Decode$value)(0)},'LocatorLandingPage':{'Main':{'init':$author$project$LocatorLandingPage$Main$main($elm$json$Json$Decode$value)(0)}},'DataCompletenessV2':{'Main':{'init':$author$project$DataCompletenessV2$Main$main($elm$json$Json$Decode$value)(0)}},'ApiPendingChanges':{'Log':{'Main':{'init':$author$project$ApiPendingChanges$Log$Main$main($elm$json$Json$Decode$value)(0)}},'Dashboard':{'Main':{'init':$author$project$ApiPendingChanges$Dashboard$Main$main($elm$json$Json$Decode$value)(0)}},'Resolver':{'Main':{'init':$author$project$ApiPendingChanges$Resolver$Main$main($elm$json$Json$Decode$value)(0)}}},'ApiDocumentation':{'ApiDocumentation':{'init':$author$project$ApiDocumentation$ApiDocumentation$main($elm$json$Json$Decode$value)(0)}},'VerifyLocations':{'Resolver':{'Main':{'init':$author$project$VerifyLocations$Resolver$Main$main($elm$json$Json$Decode$value)(0)}},'Dashboard':{'Main':{'init':$author$project$VerifyLocations$Dashboard$Main$main($elm$json$Json$Decode$value)(0)}}},'PlatformBanners':{'Main':{'init':$author$project$PlatformBanners$Main$main($elm$json$Json$Decode$value)(0)}},'BrandManagement':{'Google':{'Main':{'init':$author$project$BrandManagement$Google$Main$main($elm$json$Json$Decode$value)(0)}},'Facebook':{'Main':{'init':$author$project$BrandManagement$Facebook$Main$main($elm$json$Json$Decode$value)(0)}}},'SwitchAccounts':{'Main':{'init':$author$project$SwitchAccounts$Main$main($elm$json$Json$Decode$value)(0)}},'UserSettings':{'Main':{'init':$author$project$UserSettings$Main$main($elm$json$Json$Decode$value)(0)}},'NetworkLogs':{'Main':{'init':$author$project$NetworkLogs$Main$main($elm$json$Json$Decode$value)(0)}},'LatestLegal':{'Main':{'init':$author$project$LatestLegal$Main$main($elm$json$Json$Decode$value)(0)}},'Directories':{'NetworkList':{'Main':{'init':$author$project$Directories$NetworkList$Main$main($elm$json$Json$Decode$value)(0)}},'NetworkListDetail':{'Main':{'init':$author$project$Directories$NetworkListDetail$Main$main($elm$json$Json$Decode$value)(0)}}},'DashboardV2':{'Main':{'init':$author$project$DashboardV2$Main$main($elm$json$Json$Decode$value)(0)}},'Navigation':{'Main':{'init':$author$project$Navigation$Main$main($elm$json$Json$Decode$value)(0)},'Sidebar':{'Main':{'init':$author$project$Navigation$Sidebar$Main$main($elm$json$Json$Decode$value)(0)}}},'Locations':{'List':{'Main':{'init':$author$project$Locations$List$Main$main($elm$json$Json$Decode$value)(0)}},'MediaApproval':{'Main':{'init':$author$project$Locations$MediaApproval$Main$main($elm$json$Json$Decode$value)(0)}},'BookingLinks':{'Main':{'init':$author$project$Locations$BookingLinks$Main$main($elm$json$Json$Decode$value)(0)}},'Spreadsheet':{'Main':{'init':$author$project$Locations$Spreadsheet$Main$main($elm$json$Json$Decode$value)(0)}},'MediaReview':{'Main':{'init':$author$project$Locations$MediaReview$Main$main($elm$json$Json$Decode$value)(0)}},'AddLocation':{'Main':{'init':$author$project$Locations$AddLocation$Main$main($elm$json$Json$Decode$value)(0)}},'Labels':{'Main':{'init':$author$project$Locations$Labels$Main$main($elm$json$Json$Decode$value)(0)}}},'Conflicts':{'Main':{'init':$author$project$Conflicts$Main$main($elm$json$Json$Decode$value)(0)},'Resolver':{'Main':{'init':$author$project$Conflicts$Resolver$Main$main($elm$json$Json$Decode$value)(0)}}},'Location':{'Bing':{'Categories':{'Main':{'init':$author$project$Location$Bing$Categories$Main$main($elm$json$Json$Decode$value)(0)}}},'DisplayLocationInfoTitleBar':{'init':$author$project$Location$DisplayLocationInfoTitleBar$main($elm$json$Json$Decode$value)(0)},'LocationInfoPane':{'Main':{'init':$author$project$Location$LocationInfoPane$Main$main($elm$json$Json$Decode$value)(0)}},'DetailsPage':{'Main':{'init':$author$project$Location$DetailsPage$Main$main($elm$json$Json$Decode$value)(0)}},'Edit':{'OpeningDate':{'Main':{'init':$author$project$Location$Edit$OpeningDate$Main$main($elm$json$Json$Decode$value)(0)}}}},'Listings':{'Ui':{'Examples':{'init':$author$project$Listings$Ui$Examples$main(
	$elm$json$Json$Decode$succeed(_Utils_Tuple0))(0)}}},'Insights':{'Bing':{'Main':{'init':$author$project$Insights$Bing$Main$main($elm$json$Json$Decode$value)(0)}},'Overview':{'Main':{'init':$author$project$Insights$Overview$Main$main($elm$json$Json$Decode$value)(0)}},'Keywords':{'Main':{'init':$author$project$Insights$Keywords$Main$main($elm$json$Json$Decode$value)(0)}},'Facebook':{'Main':{'init':$author$project$Insights$Facebook$Main$main($elm$json$Json$Decode$value)(0)}},'System':{'Main':{'init':$author$project$Insights$System$Main$main($elm$json$Json$Decode$value)(0)}},'Rating':{'Main':{'init':$author$project$Insights$Rating$Main$main($elm$json$Json$Decode$value)(0)}},'Google':{'Main':{'init':$author$project$Insights$Google$Main$main($elm$json$Json$Decode$value)(0)}},'Apple':{'Main':{'init':$author$project$Insights$Apple$Main$main($elm$json$Json$Decode$value)(0)}}},'Network':{'Conflicts':{'Trustpilot':{'Upload':{'Main':{'init':$author$project$Network$Conflicts$Trustpilot$Upload$Main$main($elm$json$Json$Decode$value)(0)}}}}},'Common':{'Filter':{'FilterControllerPort':{'init':$author$project$Common$Filter$FilterControllerPort$main($elm$json$Json$Decode$value)(0)}},'NoPermissionLightbox':{'init':$author$project$Common$NoPermissionLightbox$main($elm$json$Json$Decode$value)(0)}}});}(this));}).call(output); window.Elm = output.Elm;